
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire688c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire688c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8HV7i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $656ea513998a70a9$var$_typeof = $41YNz.default;
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $656ea513998a70a9$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($656ea513998a70a9$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("23fob", function(module, exports) {

$parcel$export(module.exports, "mediaTypeClass", () => mediaTypeClass, (v) => mediaTypeClass = v);
$parcel$export(module.exports, "callbackify", () => callbackify, (v) => callbackify = v);
$parcel$export(module.exports, "domToString", () => domToString, (v) => domToString = v);
$parcel$export(module.exports, "heavyCompareSPO", () => heavyCompareSPO, (v) => heavyCompareSPO = v);
$parcel$export(module.exports, "parseXML", () => parseXML, (v) => parseXML = v);
$parcel$export(module.exports, "RDFArrayRemove", () => RDFArrayRemove, (v) => RDFArrayRemove = v);
$parcel$export(module.exports, "string_startswith", () => string_startswith, (v) => string_startswith = v);
$parcel$export(module.exports, "stackString", () => stackString, (v) => stackString = v);
/**
 * Utility functions for $rdf
 * @module util
 */ 
var $4Q80K = parcelRequire("4Q80K");


var $99pVg = parcelRequire("99pVg");

var $6YUDA = parcelRequire("6YUDA");
var string = {
    template: stringTemplate
};
function mediaTypeClass(mediaType) {
    mediaType = mediaType.split(";")[0].trim(); // remove media type parameters
    return new (0, $99pVg.default)("http://www.w3.org/ns/iana/media-types/" + mediaType + "#Resource");
}
function linkRelationProperty(relation) {
    return new (0, $99pVg.default)("http://www.w3.org/ns/iana/link-relations/relation#" + relation.trim());
}
function callbackify(obj, callbacks) {
    obj.callbacks = {};
    for(var x = callbacks.length - 1; x >= 0; x--)obj.callbacks[callbacks[x]] = [];
    obj.addHook = function(hook) {
        if (!obj.callbacks[hook]) obj.callbacks[hook] = [];
    };
    obj.addCallback = function(hook, func) {
        obj.callbacks[hook].push(func);
    };
    obj.removeCallback = function(hook, funcName) {
        for(var i = 0; i < obj.callbacks[hook].length; i++)if (obj.callbacks[hook][i].name === funcName) {
            obj.callbacks[hook].splice(i, 1);
            return true;
        }
        return false;
    };
    obj.insertCallback = function(hook, func) {
        obj.callbacks[hook].unshift(func);
    };
    obj.fireCallbacks = function fireCallbacks(hook, args) {
        var newCallbacks = [];
        var replaceCallbacks = [];
        var len = obj.callbacks[hook].length;
        var x;
        var callback;
        // log.info('!@$ Firing '+hook+' call back with length'+len)
        for(x = len - 1; x >= 0; x--){
            // log.info('@@ Firing '+hook+' callback '+ obj.callbacks[hook][x])
            callback = obj.callbacks[hook][x];
            if (callback && callback.apply(obj, args)) newCallbacks.push(callback);
        }
        for(x = newCallbacks.length - 1; x >= 0; x--)replaceCallbacks.push(newCallbacks[x]);
        for(x = len; x < obj.callbacks[hook].length; x++)replaceCallbacks.push(obj.callbacks[hook][x]);
        obj.callbacks[hook] = replaceCallbacks;
    };
}
function DOMParserFactory() {
    if (window.DOMParser) return new (0, $6YUDA.DOMParser)();
    else if (window.ActiveXObject) return new ActiveXObject("Microsoft.XMLDOM");
    else return false;
}
function domToString(node, options) {
    options = options || {};
    var selfClosing = [];
    if (options && options.selfClosing) options.selfClosing.split(" ").forEach(function(n) {
        selfClosing[n] = true;
    });
    var skipAttributes = [];
    if (options && options.skipAttributes) options.skipAttributes.split(" ").forEach(function(n) {
        skipAttributes[n] = true;
    });
    return dumpNode(node, options, selfClosing, skipAttributes);
}
function dumpNode(node, options, selfClosing, skipAttributes) {
    var i;
    var out = "";
    var noEsc = [
        false
    ];
    if (typeof node.nodeType === "undefined") return out;
    if (node.nodeType === 1) {
        if (node.hasAttribute("class") && options && options.classWithChildText && node.matches(options.classWithChildText.class)) out += node.querySelector(options.classWithChildText.element).textContent;
        else if (!(options && options.skipNodeWithClass && node.matches("." + options.skipNodeWithClass))) {
            var ename = node.nodeName.toLowerCase();
            out += "<" + ename;
            var attrList = [];
            for(i = node.attributes.length - 1; i >= 0; i--){
                var atn = node.attributes[i];
                if (skipAttributes && skipAttributes.length > 0 && skipAttributes[atn.name]) continue;
                if (/^\d+$/.test(atn.name)) continue;
                if (atn.name === "class" && options && options.replaceClassItemWith && atn.value.split(" ").indexOf(options.replaceClassItemWith.source) > -1) {
                    var re = new RegExp(options.replaceClassItemWith.source, "g");
                    atn.value = atn.value.replace(re, options.replaceClassItemWith.target).trim();
                }
                if (!(atn.name === "class" && options && options.skipClassWithValue && options.skipClassWithValue === atn.value)) attrList.push(atn.name + "='" + atn.value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&quot;") + "'");
            }
            if (attrList.length > 0) {
                if (options && options.sortAttributes) attrList.sort(function(a, b) {
                    return a.toLowerCase().localeCompare(b.toLowerCase());
                });
                out += " " + attrList.join(" ");
            }
            if (selfClosing && selfClosing.ename) out += " />";
            else {
                out += ">";
                out += ename === "html" ? "\n  " : "";
                noEsc.push(ename === "style" || ename === "script");
                for(i = 0; i < node.childNodes.length; i++)out += dumpNode(node.childNodes[i]);
                noEsc.pop();
                out += ename === "body" ? "</" + ename + ">" + "\n" : "</" + ename + ">";
            }
        }
    } else if (node.nodeType === 8) // FIXME: If comments are not tabbed in source, a new line is not prepended
    out += "<!--" + node.nodeValue + "-->";
    else if (node.nodeType === 3 || node.nodeType === 4) {
        // XXX: Remove new lines which were added after DOM ready
        var nl = node.nodeValue.replace(/\n+$/, "");
        out += noEsc[noEsc.length - 1] ? nl : nl.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    } else {
        console.log("Warning; Cannot handle serialising nodes of type: " + node.nodeType);
        console.log(node);
    }
    return out;
}
function dtstamp() {
    var now = new Date();
    var year = now.getYear() + 1900;
    var month = now.getMonth() + 1;
    var day = now.getDate();
    var hour = now.getUTCHours();
    var minute = now.getUTCMinutes();
    var second = now.getSeconds();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    if (hour < 10) hour = "0" + hour;
    if (minute < 10) minute = "0" + minute;
    if (second < 10) second = "0" + second;
    return year + "-" + month + "-" + day + "T" + hour + ":" + minute + ":" + second + "Z";
}
function heavyCompare(x, y, g, uriMap) {
    var nonBlank = function nonBlank(x) {
        return x.termType === "BlankNode" ? null : x;
    };
    var signature = function signature(x) {
        var lis = g.statementsMatching(x).map(function(st) {
            return "" + nonBlank(st.subject) + " " + nonBlank(st.predicate) + " " + nonBlank(st.object);
        }).concat(g.statementsMatching(undefined, undefined, x).map(function(st) {
            return "" + nonBlank(st.subject) + " " + nonBlank(st.predicate) + " " + nonBlank(st.object);
        }));
        lis.sort();
        return lis.join("\n");
    };
    var comparison = Object.prototype.hasOwnProperty.call(g, "compareTerms") ? g.compareTerms(x, y) : x.compareTerm(y);
    if (x.termType === "BlankNode" && y.termType === "BlankNode") {
        if (comparison === 0) return 0; // Same
        if (signature(x) > signature(y)) return 1;
        if (signature(x) < signature(y)) return -1;
        return comparison; // Too bad -- this order not canonical.
    // throw "different bnodes indistinquishable for sorting"
    } else {
        if (uriMap && x.uri && y.uri) return (uriMap[x.uri] || x.uri).localeCompare(uriMap[y.uri] || y.uri);
        return comparison;
    }
}
function heavyCompareSPO(x, y, g, uriMap) {
    return heavyCompare(x.subject, y.subject, g, uriMap) || heavyCompare(x.predicate, y.predicate, g, uriMap) || heavyCompare(x.object, y.object, g, uriMap);
}
function output(o) {
    var k = document.createElement("div");
    k.textContent = o;
    document.body.appendChild(k);
}
function parseXML(str, options) {
    var dparser;
    options = options || {};
    if (module && module.exports) {
        // Node.js
        var dom = new (0, $6YUDA.DOMParser)().parseFromString(str, options.contentType || "application/xhtml+xml");
        return dom;
    } else if (typeof window !== "undefined" && window.DOMParser) dparser = new window.DOMParser(); // seems to actually work
    else dparser = new (0, $6YUDA.DOMParser)(); // Doc says this works
    return dparser.parseFromString(str, "application/xml");
}
function RDFArrayRemove(a, x) {
    for(var i = 0; i < a.length; i++)// TODO: This used to be the following, which didnt always work..why
    // if(a[i] === x)
    if (a[i].subject.equals(x.subject) && a[i].predicate.equals(x.predicate) && a[i].object.equals(x.object) && a[i].why.equals(x.why)) {
        a.splice(i, 1);
        return;
    }
    throw new Error("RDFArrayRemove: Array did not contain " + x + " " + x.why);
}
function string_startswith(str, pref) {
    // missing library routines
    return str.slice(0, pref.length) === pref;
}
/**
 * C++, python style %s -> subs
 */ function stringTemplate(base, subs) {
    var baseA = base.split("%s");
    var result = "";
    for(var i = 0; i < subs.length; i++){
        subs[i] += "";
        result += baseA[i] + subs[i];
    }
    return result + baseA.slice(subs.length).join();
}
function stackString(e) {
    var str = "" + e + "\n";
    if (!e.stack) return str + "No stack available.\n";
    var lines = e.stack.toString().split("\n");
    var toprint = [];
    for(var i = 0; i < lines.length; i++){
        var line = lines[i];
        if (line.indexOf("ecmaunit.js") > -1) break;
        if (line.charAt(0) == "(") line = "function" + line;
        var chunks = line.split("@");
        toprint.push(chunks);
    }
    // toprint.reverse();  No - I prefer the latest at the top by the error message -tbl
    for(var i = 0; i < toprint.length; i++)str += "  " + toprint[i][1] + "\n    " + toprint[i][0];
    return str;
}

});
parcelRegister("4Q80K", function(module, exports) {

$parcel$export(module.exports, "docpart", () => $38623b99b5ce9da3$export$80bf8edc91783541);
$parcel$export(module.exports, "document", () => $38623b99b5ce9da3$export$5a7bfc01df82fcd1);
$parcel$export(module.exports, "hostpart", () => $38623b99b5ce9da3$export$ca102a2135b45508);
$parcel$export(module.exports, "join", () => $38623b99b5ce9da3$export$f7e2c8231c57a8bd);
$parcel$export(module.exports, "protocol", () => $38623b99b5ce9da3$export$a51d6b395ff4c65a);
$parcel$export(module.exports, "refTo", () => $38623b99b5ce9da3$export$53a1c54169f784af);
/*
 * Implements URI-specific functions
 *
 * See RFC 2386
 *
 * See also:
 *   http://www.w3.org/2005/10/ajaw/uri.js
 *   http://www.w3.org/2000/10/swap/uripath.py
 *
 */ 
var $99pVg = parcelRequire("99pVg");
var $38623b99b5ce9da3$var$alert = $38623b99b5ce9da3$var$alert || console.log;
function $38623b99b5ce9da3$export$80bf8edc91783541(uri) {
    var i;
    i = uri.indexOf("#");
    if (i < 0) return uri;
    else return uri.slice(0, i);
}
function $38623b99b5ce9da3$export$5a7bfc01df82fcd1(x) {
    return new (0, $99pVg.default)($38623b99b5ce9da3$export$80bf8edc91783541(x));
}
function $38623b99b5ce9da3$export$ca102a2135b45508(u) {
    var m = /[^\/]*\/\/([^\/]*)\//.exec(u);
    if (m) return m[1];
    else return "";
}
function $38623b99b5ce9da3$export$f7e2c8231c57a8bd(given, base) {
    var baseColon, baseScheme, baseSingle;
    var colon, lastSlash, path;
    var baseHash = base.indexOf("#");
    if (baseHash > 0) base = base.slice(0, baseHash);
    if (given.length === 0) return base;
    if (given.indexOf("#") === 0) return base + given;
    colon = given.indexOf(":");
    if (colon >= 0) return given;
    baseColon = base.indexOf(":");
    if (base.length === 0) return given;
    if (baseColon < 0) {
        $38623b99b5ce9da3$var$alert("Invalid base: " + base + " in join with given: " + given);
        return given;
    }
    baseScheme = base.slice(0, +baseColon + 1 || 9e9);
    if (given.indexOf("//") === 0) return baseScheme + given;
    if (base.indexOf("//", baseColon) === baseColon + 1) {
        baseSingle = base.indexOf("/", baseColon + 3);
        if (baseSingle < 0) {
            if (base.length - baseColon - 3 > 0) return base + "/" + given;
            else return baseScheme + given;
        }
    } else {
        baseSingle = base.indexOf("/", baseColon + 1);
        if (baseSingle < 0) {
            if (base.length - baseColon - 1 > 0) return base + "/" + given;
            else return baseScheme + given;
        }
    }
    if (given.indexOf("/") === 0) return base.slice(0, baseSingle) + given;
    path = base.slice(baseSingle);
    lastSlash = path.lastIndexOf("/");
    if (lastSlash < 0) return baseScheme + given;
    if (lastSlash >= 0 && lastSlash < path.length - 1) path = path.slice(0, +lastSlash + 1 || 9e9);
    path += given;
    while(path.match(/[^\/]*\/\.\.\//))path = path.replace(/[^\/]*\/\.\.\//, "");
    path = path.replace(/\.\//g, "");
    path = path.replace(/\/\.$/, "/");
    return base.slice(0, baseSingle) + path;
}
function $38623b99b5ce9da3$export$a51d6b395ff4c65a(uri) {
    var i = uri.indexOf(":");
    if (i < 0) return null;
    else return uri.slice(0, i);
}
function $38623b99b5ce9da3$export$53a1c54169f784af(base, uri) {
    var c, i, k, l, len, len1, n, o, p, q, ref, ref1, s;
    var commonHost = new RegExp("^[-_a-zA-Z0-9.]+:(//[^/]*)?/[^/]*$");
    if (!base) return uri;
    if (base === uri) return "";
    for(i = o = 0, len = uri.length; o < len; i = ++o){
        var _c = uri[i];
        if (_c !== base[i]) break;
    }
    if (base.slice(0, i).match(commonHost)) {
        k = uri.indexOf("//");
        if (k < 0) k = -2;
        l = uri.indexOf("/", k + 2);
        if (uri[l + 1] !== "/" && base[l + 1] !== "/" && uri.slice(0, l) === base.slice(0, l)) return uri.slice(l);
    }
    if (uri[i] === "#" && base.length === i) return uri.slice(i);
    while(i > 0 && uri[i - 1] !== "/")i--;
    if (i < 3) return uri;
    if (base.indexOf("//", i - 2) > 0 || uri.indexOf("//", i - 2) > 0) return uri;
    if (base.indexOf(":", i) > 0) return uri;
    n = 0;
    ref = base.slice(i);
    for(p = 0, len1 = ref.length; p < len1; p++){
        c = ref[p];
        if (c === "/") n++;
    }
    if (n === 0 && i < uri.length && uri[i] === "#") return "./" + uri.slice(i);
    if (n === 0 && i === uri.length) return "./";
    s = "";
    if (n > 0) for(q = 1, ref1 = n; ref1 >= 1 ? q <= ref1 : q >= ref1; ref1 >= 1 ? ++q : --q)s += "../";
    return s + uri.slice(i);
}

});
parcelRegister("99pVg", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a99100006cc9c4d$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $avzMW = parcelRequire("avzMW");

var $gCJkd = parcelRequire("gCJkd");
function $6a99100006cc9c4d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6a99100006cc9c4d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $6a99100006cc9c4d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A named (IRI) RDF node
 */ var $6a99100006cc9c4d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(NamedNode, _Node);
    var _super = $6a99100006cc9c4d$var$_createSuper(NamedNode);
    /**
   * Create a named (IRI) RDF Node
   * @constructor
   * @param iri - The IRI for this node
   */ function NamedNode(iri) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, NamedNode);
        _this = _super.call(this, (0, $avzMW.termValue)(iri));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.NamedNodeTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).NamedNode);
        if (!_this.value) throw new Error("Missing IRI for NamedNode");
        if (!_this.value.includes(":")) throw new Error('NamedNode IRI "' + iri + '" must be absolute.');
        if (_this.value.includes(" ")) {
            var message = 'Error: NamedNode IRI "' + iri + '" must not contain unencoded spaces.';
            throw new Error(message);
        }
        return _this;
    }
    /**
   * Returns an $rdf node for the containing directory, ending in slash.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(NamedNode, [
        {
            key: "dir",
            value: function dir() {
                var str = this.value.split("#")[0];
                var p = str.slice(0, -1).lastIndexOf("/");
                var q = str.indexOf("//");
                if (q >= 0 && p < q + 2 || p < 0) return null;
                return new NamedNode(str.slice(0, p + 1));
            }
        },
        {
            key: "site",
            value: function site() {
                var str = this.value.split("#")[0];
                var p = str.indexOf("//");
                if (p < 0) throw new Error("This URI does not have a web site part (origin)");
                var q = str.indexOf("/", p + 2);
                if (q < 0) return new NamedNode(str.slice(0) + "/"); // Add slash to a bare origin
                else return new NamedNode(str.slice(0, q + 1));
            }
        },
        {
            key: "doc",
            value: function doc() {
                if (this.value.indexOf("#") < 0) return this;
                else return new NamedNode(this.value.split("#")[0]);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "<" + this.value + ">";
            }
        },
        {
            key: "id",
            value: function id() {
                return this.value.split("#")[1];
            }
        },
        {
            key: "uri",
            get: function get() {
                return this.value;
            },
            set: function set(uri) {
                this.value = uri;
            }
        }
    ], [
        {
            key: "fromValue",
            value: function fromValue(value) {
                if (typeof value === "undefined" || value === null) return value;
                if ((0, $gCJkd.isTerm)(value)) return value;
                return new NamedNode(value);
            }
        }
    ]);
    return NamedNode;
}((0, $cdU35.default));

});
parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5DKOa(descriptor.key), descriptor);
    }
}
function $fe9438347a673ba6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fe9438347a673ba6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fe9438347a673ba6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : String(i);
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $aAhot(subClass, superClass);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p) {
    module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $7b4ac2338b8e8f97$var$_setPrototypeOf(o, p);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(self, call) {
    if (call && ($ac4cd79166dac6e4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(self);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(o) {
    module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $93d4339c80153a6a$var$_getPrototypeOf(o);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(obj, key, value) {
    key = $5DKOa(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aZYlt", function(module, exports) {

$parcel$export(module.exports, "default", () => $801e6932b6e9b45f$export$2e2bcd8739ae039);
/**
* Class orders
*/ var $801e6932b6e9b45f$var$ClassOrder = {
    "Literal": 1,
    "Collection": 3,
    "Graph": 4,
    "NamedNode": 5,
    "BlankNode": 6,
    "Variable": 7
};
var $801e6932b6e9b45f$export$2e2bcd8739ae039 = $801e6932b6e9b45f$var$ClassOrder;

});

parcelRegister("cdU35", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e622d13d12c0a4c$export$2e2bcd8739ae039);

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");
/**
 * The superclass of all RDF Statement objects, that is
 * NamedNode, Literal, BlankNode, etc.
 * Should not be instantiated directly.
 * Also called Term.
 * @link https://rdf.js.org/data-model-spec/#term-interface
 * @class Node
 */ var $8e622d13d12c0a4c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Node(value) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Node);
        /** The type of node */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "termType", void 0);
        /** The class order for this node */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "classOrder", void 0);
        /** The node's value */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "value", void 0);
        this.value = value;
    }
    /**
   * Creates the substituted node for this one, according to the specified bindings
   * @param bindings - Bindings of identifiers to nodes
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Node, [
        {
            key: "substitute",
            value: function substitute(bindings) {
                return this;
            }
        },
        {
            key: "compareTerm",
            value: function compareTerm(other) {
                if (this.classOrder < other.classOrder) return -1;
                if (this.classOrder > other.classOrder) return 1;
                if (this.value < other.value) return -1;
                if (this.value > other.value) return 1;
                return 0;
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                return this.termType === other.termType && this.value === other.value;
            }
        },
        {
            key: "hashString",
            value: function hashString() {
                return this.toCanonical();
            }
        },
        {
            key: "sameTerm",
            value: function sameTerm(other) {
                return this.equals(other);
            }
        },
        {
            key: "toCanonical",
            value: function toCanonical() {
                return this.toNT();
            }
        },
        {
            key: "toNT",
            value: function toNT() {
                return this.toString();
            }
        },
        {
            key: "toNQ",
            value: function toNQ() {
                return this.toNT();
            }
        },
        {
            key: "toString",
            value: function toString() {
                throw new Error("Node.toString() is abstract - see the subclasses instead");
            }
        }
    ]);
    return Node;
}();
// Specified in './node.ts' to prevent circular dependency
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($8e622d13d12c0a4c$export$2e2bcd8739ae039, "fromValue", void 0);
// Specified in './node.ts' to prevent circular dependency
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($8e622d13d12c0a4c$export$2e2bcd8739ae039, "toJS", void 0);

});

parcelRegister("8RKL2", function(module, exports) {

$parcel$export(module.exports, "NamedNodeTermType", () => $67478b0b307aeabd$export$ab86c9774e900759);
$parcel$export(module.exports, "BlankNodeTermType", () => $67478b0b307aeabd$export$f1b84dadeebce3ec);
$parcel$export(module.exports, "LiteralTermType", () => $67478b0b307aeabd$export$6ec19b5755c118bb);
$parcel$export(module.exports, "VariableTermType", () => $67478b0b307aeabd$export$76b848e67ab7df67);
$parcel$export(module.exports, "DefaultGraphTermType", () => $67478b0b307aeabd$export$66e3691befce521);
$parcel$export(module.exports, "CollectionTermType", () => $67478b0b307aeabd$export$1cc319ce4cc6c07);
$parcel$export(module.exports, "EmptyTermType", () => $67478b0b307aeabd$export$5e07dee03d88fd9b);
$parcel$export(module.exports, "GraphTermType", () => $67478b0b307aeabd$export$8b0a5b7a9bab7f5f);
$parcel$export(module.exports, "HTMLContentType", () => $67478b0b307aeabd$export$4e97c6324b0fc563);
$parcel$export(module.exports, "JSONLDContentType", () => $67478b0b307aeabd$export$c0caf88d9bfc4151);
$parcel$export(module.exports, "N3ContentType", () => $67478b0b307aeabd$export$7c2abebedede4666);
$parcel$export(module.exports, "N3LegacyContentType", () => $67478b0b307aeabd$export$71a86f1571e0f9e3);
$parcel$export(module.exports, "NQuadsAltContentType", () => $67478b0b307aeabd$export$e1378d8473a1b8b);
$parcel$export(module.exports, "NQuadsContentType", () => $67478b0b307aeabd$export$72c700663a6da118);
$parcel$export(module.exports, "NTriplesContentType", () => $67478b0b307aeabd$export$1c7d73fda2689091);
$parcel$export(module.exports, "RDFXMLContentType", () => $67478b0b307aeabd$export$ee6f8f5f19deb6c0);
$parcel$export(module.exports, "SPARQLUpdateContentType", () => $67478b0b307aeabd$export$fad3d759a39fa06b);
$parcel$export(module.exports, "SPARQLUpdateSingleMatchContentType", () => $67478b0b307aeabd$export$d7cdba5560258a1);
$parcel$export(module.exports, "TurtleContentType", () => $67478b0b307aeabd$export$9be2284ddc122481);
$parcel$export(module.exports, "TurtleLegacyContentType", () => $67478b0b307aeabd$export$55356beaf2f33538);
$parcel$export(module.exports, "XHTMLContentType", () => $67478b0b307aeabd$export$b5947d5930ff0842);
var $67478b0b307aeabd$export$ab86c9774e900759 = "NamedNode";
var $67478b0b307aeabd$export$f1b84dadeebce3ec = "BlankNode";
var $67478b0b307aeabd$export$6ec19b5755c118bb = "Literal";
var $67478b0b307aeabd$export$76b848e67ab7df67 = "Variable";
var $67478b0b307aeabd$export$66e3691befce521 = "DefaultGraph";
var $67478b0b307aeabd$export$1cc319ce4cc6c07 = "Collection";
var $67478b0b307aeabd$export$5e07dee03d88fd9b = "Empty";
var $67478b0b307aeabd$export$8b0a5b7a9bab7f5f = "Graph";
var $67478b0b307aeabd$export$4e97c6324b0fc563 = "text/html";
var $67478b0b307aeabd$export$c0caf88d9bfc4151 = "application/ld+json";
var $67478b0b307aeabd$export$7c2abebedede4666 = "text/n3";
var $67478b0b307aeabd$export$71a86f1571e0f9e3 = "application/n3";
var $67478b0b307aeabd$export$e1378d8473a1b8b = "application/nquads";
var $67478b0b307aeabd$export$72c700663a6da118 = "application/n-quads";
var $67478b0b307aeabd$export$1c7d73fda2689091 = "application/n-triples";
var $67478b0b307aeabd$export$ee6f8f5f19deb6c0 = "application/rdf+xml";
var $67478b0b307aeabd$export$fad3d759a39fa06b = "application/sparql-update";
var $67478b0b307aeabd$export$d7cdba5560258a1 = "application/sparql-update-single-match";
var $67478b0b307aeabd$export$9be2284ddc122481 = "text/turtle";
var $67478b0b307aeabd$export$55356beaf2f33538 = "application/x-turtle";
var $67478b0b307aeabd$export$b5947d5930ff0842 = "application/xhtml+xml"; /**
 * A valid mime type header
 */  /** A type for values that serves as inputs */  /**
 * In this project, there exist two types for the same kind of RDF concept.
 * We have RDF/JS spec types (standardized, generic), and RDFlib types (internal, specific).
 * When deciding which type to use in a function, it is preferable to accept generic inputs,
 * whenever possible, and provide strict outputs.
 * In some ways, the TF types in here are a bit more strict.
 * Variables are missing, and the statement requires specific types of terms (e.g. NamedNode instead of Term).
 */  /** An RDF/JS Subject */  /** An RDF/JS Predicate */  /** An RDF/JS Object */  /** An RDF/JS Graph */  // | Formula
 /** All the types that a .fromValue() method might return */ 

});

parcelRegister("avzMW", function(module, exports) {

$parcel$export(module.exports, "termValue", () => $7a688f78df8e5efd$export$deab0da43b28364e);
/** Retrieve the value of a term, or self if already a string. */ function $7a688f78df8e5efd$export$deab0da43b28364e(node) {
    if (typeof node === "string") return node;
    return node.value;
}

});

parcelRegister("gCJkd", function(module, exports) {

$parcel$export(module.exports, "isStatement", () => $c1a35a9520365540$export$78a28e85343c8674);
$parcel$export(module.exports, "isStore", () => $c1a35a9520365540$export$9abf972af34a1547);
$parcel$export(module.exports, "isCollection", () => $c1a35a9520365540$export$cea7aa84e978eba5);
$parcel$export(module.exports, "isTerm", () => $c1a35a9520365540$export$9d67e281257ee71);
$parcel$export(module.exports, "isRDFlibObject", () => $c1a35a9520365540$export$ee15a308c4424939);
$parcel$export(module.exports, "isRDFlibSubject", () => $c1a35a9520365540$export$aa61d0c644b154b4);
$parcel$export(module.exports, "isRDFlibPredicate", () => $c1a35a9520365540$export$1b8f3715c19ad752);
$parcel$export(module.exports, "isVariable", () => $c1a35a9520365540$export$670a0c046e2ed227);
$parcel$export(module.exports, "isLiteral", () => $c1a35a9520365540$export$899158ea22bb4609);
$parcel$export(module.exports, "isQuad", () => $c1a35a9520365540$export$631d618571b0cb5d);
$parcel$export(module.exports, "isNamedNode", () => $c1a35a9520365540$export$10490ce738f72284);
$parcel$export(module.exports, "isBlankNode", () => $c1a35a9520365540$export$7b5b4967656acaac);
$parcel$export(module.exports, "isGraph", () => $c1a35a9520365540$export$ac5b344562d20e4e);

var $41YNz = parcelRequire("41YNz");

var $8RKL2 = parcelRequire("8RKL2");
function $c1a35a9520365540$export$78a28e85343c8674(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "subject" in obj;
}
function $c1a35a9520365540$export$9abf972af34a1547(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "statements" in obj;
}
function $c1a35a9520365540$export$cea7aa84e978eba5(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && obj.termType === (0, $8RKL2.CollectionTermType);
}
function $c1a35a9520365540$export$ee15a308c4424939(obj) {
    return obj && Object.prototype.hasOwnProperty.call(obj, "termType") && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.CollectionTermType) || obj.termType === (0, $8RKL2.LiteralTermType) || obj.termType === (0, $8RKL2.GraphTermType));
}
function $c1a35a9520365540$export$aa61d0c644b154b4(obj) {
    return obj && Object.prototype.hasOwnProperty.call(obj, "termType") && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.CollectionTermType) || obj.termType === (0, $8RKL2.LiteralTermType) || obj.termType === (0, $8RKL2.GraphTermType));
}
function $c1a35a9520365540$export$1b8f3715c19ad752(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType));
}
function $c1a35a9520365540$export$670a0c046e2ed227(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && obj.termType === (0, $8RKL2.VariableTermType);
}
function $c1a35a9520365540$export$9d67e281257ee71(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "termType" in obj;
}
function $c1a35a9520365540$export$899158ea22bb4609(value) {
    return value.termType === (0, $8RKL2.LiteralTermType);
}
function $c1a35a9520365540$export$631d618571b0cb5d(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(obj) === "object" && obj !== null && "subject" in obj && "predicate" in obj && "object" in obj;
}
function $c1a35a9520365540$export$10490ce738f72284(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && obj.termType === "NamedNode";
}
function $c1a35a9520365540$export$7b5b4967656acaac(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && "termType" in obj && obj.termType === "BlankNode";
}
function $c1a35a9520365540$export$3abc00c648b4208e(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType));
}
function $c1a35a9520365540$export$693d5ce24db4cd2a(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType));
}
function $c1a35a9520365540$export$597628373f7ff1c6(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.LiteralTermType));
}
function $c1a35a9520365540$export$ac5b344562d20e4e(obj) {
    return $c1a35a9520365540$export$9d67e281257ee71(obj) && (obj.termType === (0, $8RKL2.NamedNodeTermType) || obj.termType === (0, $8RKL2.VariableTermType) || obj.termType === (0, $8RKL2.BlankNodeTermType) || obj.termType === (0, $8RKL2.DefaultGraphTermType));
}

});



parcelRegister("6YUDA", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $515447b9158f86cb$export$1059c6e7d2ce5669, (v) => $515447b9158f86cb$export$1059c6e7d2ce5669 = v);
var $515447b9158f86cb$export$455426655eab1d48;
var $515447b9158f86cb$export$64f0bed4ae6f0f24;
var $515447b9158f86cb$export$1059c6e7d2ce5669;

var $2YubT = parcelRequire("2YubT");
$515447b9158f86cb$export$455426655eab1d48 = $2YubT.DOMImplementation;
$515447b9158f86cb$export$64f0bed4ae6f0f24 = $2YubT.XMLSerializer;

$515447b9158f86cb$export$1059c6e7d2ce5669 = (parcelRequire("c1Wy2")).DOMParser;

});
parcelRegister("2YubT", function(module, exports) {

$parcel$export(module.exports, "DOMImplementation", () => $22a89a9d1d5ce29e$export$455426655eab1d48, (v) => $22a89a9d1d5ce29e$export$455426655eab1d48 = v);
$parcel$export(module.exports, "XMLSerializer", () => $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24, (v) => $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24 = v);
//if(typeof require == 'function'){
var $22a89a9d1d5ce29e$export$d1d99cf900472499;
var $22a89a9d1d5ce29e$export$fe58bcf938607f6a;
var $22a89a9d1d5ce29e$export$455426655eab1d48;
var $22a89a9d1d5ce29e$export$db77ccec0bb4ccac;
var $22a89a9d1d5ce29e$export$85c928794f8d04d4;
var $22a89a9d1d5ce29e$export$79b41aa5d56abdff;
var $22a89a9d1d5ce29e$export$64f0bed4ae6f0f24;

var $hkG9E = parcelRequire("hkG9E");
var $22a89a9d1d5ce29e$var$find = $hkG9E.find;
var $22a89a9d1d5ce29e$var$NAMESPACE = $hkG9E.NAMESPACE;
/**
 * A prerequisite for `[].filter`, to drop elements that are empty
 * @param {string} input
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$notEmptyString(input) {
    return input !== "";
}
/**
 * @see https://infra.spec.whatwg.org/#split-on-ascii-whitespace
 * @see https://infra.spec.whatwg.org/#ascii-whitespace
 *
 * @param {string} input
 * @returns {string[]} (can be empty)
 */ function $22a89a9d1d5ce29e$var$splitOnASCIIWhitespace(input) {
    // U+0009 TAB, U+000A LF, U+000C FF, U+000D CR, U+0020 SPACE
    return input ? input.split(/[\t\n\f\r ]+/).filter($22a89a9d1d5ce29e$var$notEmptyString) : [];
}
/**
 * Adds element as a key to current if it is not already present.
 *
 * @param {Record<string, boolean | undefined>} current
 * @param {string} element
 * @returns {Record<string, boolean | undefined>}
 */ function $22a89a9d1d5ce29e$var$orderedSetReducer(current, element) {
    if (!current.hasOwnProperty(element)) current[element] = true;
    return current;
}
/**
 * @see https://infra.spec.whatwg.org/#ordered-set
 * @param {string} input
 * @returns {string[]}
 */ function $22a89a9d1d5ce29e$var$toOrderedSet(input) {
    if (!input) return [];
    var list = $22a89a9d1d5ce29e$var$splitOnASCIIWhitespace(input);
    return Object.keys(list.reduce($22a89a9d1d5ce29e$var$orderedSetReducer, {}));
}
/**
 * Uses `list.indexOf` to implement something like `Array.prototype.includes`,
 * which we can not rely on being available.
 *
 * @param {any[]} list
 * @returns {function(any): boolean}
 */ function $22a89a9d1d5ce29e$var$arrayIncludes(list) {
    return function(element) {
        return list && list.indexOf(element) !== -1;
    };
}
function $22a89a9d1d5ce29e$var$copy(src, dest) {
    for(var p in src)if (Object.prototype.hasOwnProperty.call(src, p)) dest[p] = src[p];
}
/**
^\w+\.prototype\.([_\w]+)\s*=\s*((?:.*\{\s*?[\r\n][\s\S]*?^})|\S.*?(?=[;\r\n]));?
^\w+\.prototype\.([_\w]+)\s*=\s*(\S.*?(?=[;\r\n]));?
 */ function $22a89a9d1d5ce29e$var$_extends(Class, Super) {
    var pt = Class.prototype;
    if (!(pt instanceof Super)) {
        function t() {}
        t.prototype = Super.prototype;
        t = new t();
        $22a89a9d1d5ce29e$var$copy(pt, t);
        Class.prototype = pt = t;
    }
    if (pt.constructor != Class) {
        if (typeof Class != "function") console.error("unknown Class:" + Class);
        pt.constructor = Class;
    }
}
// Node Types
var $22a89a9d1d5ce29e$var$NodeType = {};
var $22a89a9d1d5ce29e$var$ELEMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.ELEMENT_NODE = 1;
var $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE = $22a89a9d1d5ce29e$var$NodeType.ATTRIBUTE_NODE = 2;
var $22a89a9d1d5ce29e$var$TEXT_NODE = $22a89a9d1d5ce29e$var$NodeType.TEXT_NODE = 3;
var $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE = $22a89a9d1d5ce29e$var$NodeType.CDATA_SECTION_NODE = 4;
var $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE = $22a89a9d1d5ce29e$var$NodeType.ENTITY_REFERENCE_NODE = 5;
var $22a89a9d1d5ce29e$var$ENTITY_NODE = $22a89a9d1d5ce29e$var$NodeType.ENTITY_NODE = 6;
var $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE = $22a89a9d1d5ce29e$var$NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var $22a89a9d1d5ce29e$var$COMMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.COMMENT_NODE = 8;
var $22a89a9d1d5ce29e$var$DOCUMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_NODE = 9;
var $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_TYPE_NODE = 10;
var $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE = $22a89a9d1d5ce29e$var$NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var $22a89a9d1d5ce29e$var$NOTATION_NODE = $22a89a9d1d5ce29e$var$NodeType.NOTATION_NODE = 12;
// ExceptionCode
var $22a89a9d1d5ce29e$var$ExceptionCode = {};
var $22a89a9d1d5ce29e$var$ExceptionMessage = {};
var $22a89a9d1d5ce29e$var$INDEX_SIZE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INDEX_SIZE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[1] = "Index size error", 1);
var $22a89a9d1d5ce29e$var$DOMSTRING_SIZE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.DOMSTRING_SIZE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[2] = "DOMString size error", 2);
var $22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.HIERARCHY_REQUEST_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[3] = "Hierarchy request error", 3);
var $22a89a9d1d5ce29e$var$WRONG_DOCUMENT_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.WRONG_DOCUMENT_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[4] = "Wrong document", 4);
var $22a89a9d1d5ce29e$var$INVALID_CHARACTER_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_CHARACTER_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[5] = "Invalid character", 5);
var $22a89a9d1d5ce29e$var$NO_DATA_ALLOWED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NO_DATA_ALLOWED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[6] = "No data allowed", 6);
var $22a89a9d1d5ce29e$var$NO_MODIFICATION_ALLOWED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[7] = "No modification allowed", 7);
var $22a89a9d1d5ce29e$var$NOT_FOUND_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NOT_FOUND_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[8] = "Not found", 8);
var $22a89a9d1d5ce29e$var$NOT_SUPPORTED_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NOT_SUPPORTED_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[9] = "Not supported", 9);
var $22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INUSE_ATTRIBUTE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[10] = "Attribute in use", 10);
//level2
var $22a89a9d1d5ce29e$var$INVALID_STATE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_STATE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[11] = "Invalid state", 11);
var $22a89a9d1d5ce29e$var$SYNTAX_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.SYNTAX_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[12] = "Syntax error", 12);
var $22a89a9d1d5ce29e$var$INVALID_MODIFICATION_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_MODIFICATION_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[13] = "Invalid modification", 13);
var $22a89a9d1d5ce29e$var$NAMESPACE_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.NAMESPACE_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[14] = "Invalid namespace", 14);
var $22a89a9d1d5ce29e$var$INVALID_ACCESS_ERR = $22a89a9d1d5ce29e$var$ExceptionCode.INVALID_ACCESS_ERR = ($22a89a9d1d5ce29e$var$ExceptionMessage[15] = "Invalid access", 15);
/**
 * DOM Level 2
 * Object DOMException
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/ecma-script-binding.html
 * @see http://www.w3.org/TR/REC-DOM-Level-1/ecma-script-language-binding.html
 */ function $22a89a9d1d5ce29e$var$DOMException(code, message) {
    if (message instanceof Error) var error = message;
    else {
        error = this;
        Error.call(this, $22a89a9d1d5ce29e$var$ExceptionMessage[code]);
        this.message = $22a89a9d1d5ce29e$var$ExceptionMessage[code];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $22a89a9d1d5ce29e$var$DOMException);
    }
    error.code = code;
    if (message) this.message = this.message + ": " + message;
    return error;
}
$22a89a9d1d5ce29e$var$DOMException.prototype = Error.prototype;
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$ExceptionCode, $22a89a9d1d5ce29e$var$DOMException);
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-536297177
 * The NodeList interface provides the abstraction of an ordered collection of nodes, without defining or constraining how this collection is implemented. NodeList objects in the DOM are live.
 * The items in the NodeList are accessible via an integral index, starting from 0.
 */ function $22a89a9d1d5ce29e$var$NodeList() {}
$22a89a9d1d5ce29e$var$NodeList.prototype = {
    /**
	 * The number of nodes in the list. The range of valid child node indices is 0 to length-1 inclusive.
	 * @standard level1
	 */ length: 0,
    /**
	 * Returns the indexth item in the collection. If index is greater than or equal to the number of nodes in the list, this returns null.
	 * @standard level1
	 * @param index  unsigned long
	 *   Index into the collection.
	 * @return Node
	 * 	The node at the indexth position in the NodeList, or null if that is not a valid index.
	 */ item: function(index) {
        return index >= 0 && index < this.length ? this[index] : null;
    },
    toString: function(isHTML, nodeFilter) {
        for(var buf = [], i = 0; i < this.length; i++)$22a89a9d1d5ce29e$var$serializeToString(this[i], buf, isHTML, nodeFilter);
        return buf.join("");
    },
    /**
	 * @private
	 * @param {function (Node):boolean} predicate
	 * @returns {Node[]}
	 */ filter: function(predicate) {
        return Array.prototype.filter.call(this, predicate);
    },
    /**
	 * @private
	 * @param {Node} item
	 * @returns {number}
	 */ indexOf: function(item) {
        return Array.prototype.indexOf.call(this, item);
    }
};
function $22a89a9d1d5ce29e$var$LiveNodeList(node, refresh) {
    this._node = node;
    this._refresh = refresh;
    $22a89a9d1d5ce29e$var$_updateLiveList(this);
}
function $22a89a9d1d5ce29e$var$_updateLiveList(list) {
    var inc = list._node._inc || list._node.ownerDocument._inc;
    if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        $22a89a9d1d5ce29e$var$__set__(list, "length", ls.length);
        if (!list.$$length || ls.length < list.$$length) {
            for(var i = ls.length; (i in list); i++)if (Object.prototype.hasOwnProperty.call(list, i)) delete list[i];
        }
        $22a89a9d1d5ce29e$var$copy(ls, list);
        list._inc = inc;
    }
}
$22a89a9d1d5ce29e$var$LiveNodeList.prototype.item = function(i) {
    $22a89a9d1d5ce29e$var$_updateLiveList(this);
    return this[i] || null;
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$LiveNodeList, $22a89a9d1d5ce29e$var$NodeList);
/**
 * Objects implementing the NamedNodeMap interface are used
 * to represent collections of nodes that can be accessed by name.
 * Note that NamedNodeMap does not inherit from NodeList;
 * NamedNodeMaps are not maintained in any particular order.
 * Objects contained in an object implementing NamedNodeMap may also be accessed by an ordinal index,
 * but this is simply to allow convenient enumeration of the contents of a NamedNodeMap,
 * and does not imply that the DOM specifies an order to these Nodes.
 * NamedNodeMap objects in the DOM are live.
 * used for attributes or DocumentType entities
 */ function $22a89a9d1d5ce29e$var$NamedNodeMap() {}
function $22a89a9d1d5ce29e$var$_findNodeIndex(list, node) {
    var i = list.length;
    while(i--){
        if (list[i] === node) return i;
    }
}
function $22a89a9d1d5ce29e$var$_addNamedNode(el, list, newAttr, oldAttr) {
    if (oldAttr) list[$22a89a9d1d5ce29e$var$_findNodeIndex(list, oldAttr)] = newAttr;
    else list[list.length++] = newAttr;
    if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
            oldAttr && $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, oldAttr);
            $22a89a9d1d5ce29e$var$_onAddAttribute(doc, el, newAttr);
        }
    }
}
function $22a89a9d1d5ce29e$var$_removeNamedNode(el, list, attr) {
    //console.log('remove attr:'+attr)
    var i = $22a89a9d1d5ce29e$var$_findNodeIndex(list, attr);
    if (i >= 0) {
        var lastIndex = list.length - 1;
        while(i < lastIndex)list[i] = list[++i];
        list.length = lastIndex;
        if (el) {
            var doc = el.ownerDocument;
            if (doc) {
                $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, attr);
                attr.ownerElement = null;
            }
        }
    } else throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$NOT_FOUND_ERR, new Error(el.tagName + "@" + attr));
}
$22a89a9d1d5ce29e$var$NamedNodeMap.prototype = {
    length: 0,
    item: $22a89a9d1d5ce29e$var$NodeList.prototype.item,
    getNamedItem: function(key) {
        //		if(key.indexOf(':')>0 || key == 'xmlns'){
        //			return null;
        //		}
        //console.log()
        var i = this.length;
        while(i--){
            var attr = this[i];
            //console.log(attr.nodeName,key)
            if (attr.nodeName == key) return attr;
        }
    },
    setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el != this._ownerElement) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR);
        var oldAttr = this.getNamedItem(attr.nodeName);
        $22a89a9d1d5ce29e$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ setNamedItemNS: function(attr) {
        var el = attr.ownerElement, oldAttr;
        if (el && el != this._ownerElement) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$INUSE_ATTRIBUTE_ERR);
        oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        $22a89a9d1d5ce29e$var$_addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
    },
    /* returns Node */ removeNamedItem: function(key) {
        var attr = this.getNamedItem(key);
        $22a89a9d1d5ce29e$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    //for level2
    removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        $22a89a9d1d5ce29e$var$_removeNamedNode(this._ownerElement, this, attr);
        return attr;
    },
    getNamedItemNS: function(namespaceURI, localName) {
        var i = this.length;
        while(i--){
            var node = this[i];
            if (node.localName == localName && node.namespaceURI == namespaceURI) return node;
        }
        return null;
    }
};
/**
 * The DOMImplementation interface represents an object providing methods
 * which are not dependent on any particular document.
 * Such an object is returned by the `Document.implementation` property.
 *
 * __The individual methods describe the differences compared to the specs.__
 *
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation MDN
 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-102161490 DOM Level 1 Core (Initial)
 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#ID-102161490 DOM Level 2 Core
 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-102161490 DOM Level 3 Core
 * @see https://dom.spec.whatwg.org/#domimplementation DOM Living Standard
 */ function $22a89a9d1d5ce29e$var$DOMImplementation() {}
$22a89a9d1d5ce29e$var$DOMImplementation.prototype = {
    /**
	 * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given feature is supported.
	 * The different implementations fairly diverged in what kind of features were reported.
	 * The latest version of the spec settled to force this method to always return true, where the functionality was accurate and in use.
	 *
	 * @deprecated It is deprecated and modern browsers return true in all cases.
	 *
	 * @param {string} feature
	 * @param {string} [version]
	 * @returns {boolean} always true
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
	 * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
	 */ hasFeature: function(feature, version) {
        return true;
    },
    /**
	 * Creates an XML Document object of the specified type with its document element.
	 *
	 * __It behaves slightly different from the description in the living standard__:
	 * - There is no interface/class `XMLDocument`, it returns a `Document` instance.
	 * - `contentType`, `encoding`, `mode`, `origin`, `url` fields are currently not declared.
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string|null} namespaceURI
	 * @param {string} qualifiedName
	 * @param {DocumentType=null} doctype
	 * @returns {Document}
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM Level 2 Core (initial)
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument  DOM Level 2 Core
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocument: function(namespaceURI, qualifiedName, doctype) {
        var doc = new $22a89a9d1d5ce29e$var$Document();
        doc.implementation = this;
        doc.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        doc.doctype = doctype || null;
        if (doctype) doc.appendChild(doctype);
        if (qualifiedName) {
            var root = doc.createElementNS(namespaceURI, qualifiedName);
            doc.appendChild(root);
        }
        return doc;
    },
    /**
	 * Returns a doctype, with the given `qualifiedName`, `publicId`, and `systemId`.
	 *
	 * __This behavior is slightly different from the in the specs__:
	 * - this implementation is not validating names or qualified names
	 *   (when parsing XML strings, the SAX parser takes care of that)
	 *
	 * @param {string} qualifiedName
	 * @param {string} [publicId]
	 * @param {string} [systemId]
	 * @returns {DocumentType} which can either be used with `DOMImplementation.createDocument` upon document creation
	 * 				  or can be put into the document via methods like `Node.insertBefore()` or `Node.replaceChild()`
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType MDN
	 * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM Level 2 Core
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living Standard
	 *
	 * @see https://dom.spec.whatwg.org/#validate-and-extract DOM: Validate and extract
	 * @see https://www.w3.org/TR/xml/#NT-NameStartChar XML Spec: Names
	 * @see https://www.w3.org/TR/xml-names/#ns-qualnames XML Namespaces: Qualified names
	 */ createDocumentType: function(qualifiedName, publicId, systemId) {
        var node = new $22a89a9d1d5ce29e$var$DocumentType();
        node.name = qualifiedName;
        node.nodeName = qualifiedName;
        node.publicId = publicId || "";
        node.systemId = systemId || "";
        return node;
    }
};
/**
 * @see http://www.w3.org/TR/2000/REC-DOM-Level-2-Core-20001113/core.html#ID-1950641247
 */ function $22a89a9d1d5ce29e$var$Node() {}
$22a89a9d1d5ce29e$var$Node.prototype = {
    firstChild: null,
    lastChild: null,
    previousSibling: null,
    nextSibling: null,
    attributes: null,
    parentNode: null,
    childNodes: null,
    ownerDocument: null,
    nodeValue: null,
    namespaceURI: null,
    prefix: null,
    localName: null,
    // Modified in DOM Level 2:
    insertBefore: function(newChild, refChild) {
        return $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, refChild);
    },
    replaceChild: function(newChild, oldChild) {
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, oldChild, $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument);
        if (oldChild) this.removeChild(oldChild);
    },
    removeChild: function(oldChild) {
        return $22a89a9d1d5ce29e$var$_removeChild(this, oldChild);
    },
    appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
    },
    hasChildNodes: function() {
        return this.firstChild != null;
    },
    cloneNode: function(deep) {
        return $22a89a9d1d5ce29e$var$cloneNode(this.ownerDocument || this, this, deep);
    },
    // Modified in DOM Level 2:
    normalize: function() {
        var child = this.firstChild;
        while(child){
            var next = child.nextSibling;
            if (next && next.nodeType == $22a89a9d1d5ce29e$var$TEXT_NODE && child.nodeType == $22a89a9d1d5ce29e$var$TEXT_NODE) {
                this.removeChild(next);
                child.appendData(next.data);
            } else {
                child.normalize();
                child = next;
            }
        }
    },
    // Introduced in DOM Level 2:
    isSupported: function(feature, version) {
        return this.ownerDocument.implementation.hasFeature(feature, version);
    },
    // Introduced in DOM Level 2:
    hasAttributes: function() {
        return this.attributes.length > 0;
    },
    /**
	 * Look up the prefix associated to the given namespace URI, starting from this node.
	 * **The default namespace declarations are ignored by this method.**
	 * See Namespace Prefix Lookup for details on the algorithm used by this method.
	 *
	 * _Note: The implementation seems to be incomplete when compared to the algorithm described in the specs._
	 *
	 * @param {string | null} namespaceURI
	 * @returns {string | null}
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
	 * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
	 * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
	 * @see https://github.com/xmldom/xmldom/issues/322
	 */ lookupPrefix: function(namespaceURI) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) for(var n in map){
                if (Object.prototype.hasOwnProperty.call(map, n) && map[n] === namespaceURI) return n;
            }
            el = el.nodeType == $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    lookupNamespaceURI: function(prefix) {
        var el = this;
        while(el){
            var map = el._nsMap;
            //console.dir(map)
            if (map) {
                if (Object.prototype.hasOwnProperty.call(map, prefix)) return map[prefix];
            }
            el = el.nodeType == $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
    },
    // Introduced in DOM Level 3:
    isDefaultNamespace: function(namespaceURI) {
        var prefix = this.lookupPrefix(namespaceURI);
        return prefix == null;
    }
};
function $22a89a9d1d5ce29e$var$_xmlEncoder(c) {
    return c == "<" && "&lt;" || c == ">" && "&gt;" || c == "&" && "&amp;" || c == '"' && "&quot;" || "&#" + c.charCodeAt() + ";";
}
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$NodeType, $22a89a9d1d5ce29e$var$Node);
$22a89a9d1d5ce29e$var$copy($22a89a9d1d5ce29e$var$NodeType, $22a89a9d1d5ce29e$var$Node.prototype);
/**
 * @param callback return true for continue,false for break
 * @return boolean true: break visit;
 */ function $22a89a9d1d5ce29e$var$_visitNode(node, callback) {
    if (callback(node)) return true;
    if (node = node.firstChild) do {
        if ($22a89a9d1d5ce29e$var$_visitNode(node, callback)) return true;
    }while (node = node.nextSibling);
}
function $22a89a9d1d5ce29e$var$Document() {
    this.ownerDocument = this;
}
function $22a89a9d1d5ce29e$var$_onAddAttribute(doc, el, newAttr) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) //update namespace
    el._nsMap[newAttr.prefix ? newAttr.localName : ""] = newAttr.value;
}
function $22a89a9d1d5ce29e$var$_onRemoveAttribute(doc, el, newAttr, remove) {
    doc && doc._inc++;
    var ns = newAttr.namespaceURI;
    if (ns === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) //update namespace
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ""];
}
/**
 * Updates `el.childNodes`, updating the indexed items and it's `length`.
 * Passing `newChild` means it will be appended.
 * Otherwise it's assumed that an item has been removed,
 * and `el.firstNode` and it's `.nextSibling` are used
 * to walk the current list of child nodes.
 *
 * @param {Document} doc
 * @param {Node} el
 * @param {Node} [newChild]
 * @private
 */ function $22a89a9d1d5ce29e$var$_onUpdateChild(doc, el, newChild) {
    if (doc && doc._inc) {
        doc._inc++;
        //update childNodes
        var cs = el.childNodes;
        if (newChild) cs[cs.length++] = newChild;
        else {
            var child = el.firstChild;
            var i = 0;
            while(child){
                cs[i++] = child;
                child = child.nextSibling;
            }
            cs.length = i;
            delete cs[cs.length];
        }
    }
}
/**
 * Removes the connections between `parentNode` and `child`
 * and any existing `child.previousSibling` or `child.nextSibling`.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 *
 * @param {Node} parentNode
 * @param {Node} child
 * @returns {Node} the child that was removed.
 * @private
 */ function $22a89a9d1d5ce29e$var$_removeChild(parentNode, child) {
    var previous = child.previousSibling;
    var next = child.nextSibling;
    if (previous) previous.nextSibling = next;
    else parentNode.firstChild = next;
    if (next) next.previousSibling = previous;
    else parentNode.lastChild = previous;
    child.parentNode = null;
    child.previousSibling = null;
    child.nextSibling = null;
    $22a89a9d1d5ce29e$var$_onUpdateChild(parentNode.ownerDocument, parentNode);
    return child;
}
/**
 * Returns `true` if `node` can be a parent for insertion.
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$hasValidParentNodeType(node) {
    return node && (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.ELEMENT_NODE);
}
/**
 * Returns `true` if `node` can be inserted according to it's `nodeType`.
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$hasInsertableNodeType(node) {
    return node && ($22a89a9d1d5ce29e$var$isElementNode(node) || $22a89a9d1d5ce29e$var$isTextNode(node) || $22a89a9d1d5ce29e$var$isDocTypeNode(node) || node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.COMMENT_NODE || node.nodeType === $22a89a9d1d5ce29e$var$Node.PROCESSING_INSTRUCTION_NODE);
}
/**
 * Returns true if `node` is a DOCTYPE node
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isDocTypeNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_TYPE_NODE;
}
/**
 * Returns true if the node is an element
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isElementNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.ELEMENT_NODE;
}
/**
 * Returns true if `node` is a text node
 * @param {Node} node
 * @returns {boolean}
 */ function $22a89a9d1d5ce29e$var$isTextNode(node) {
    return node && node.nodeType === $22a89a9d1d5ce29e$var$Node.TEXT_NODE;
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Document} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$isElementInsertionPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    if ($22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode) || $22a89a9d1d5ce29e$var$isDocTypeNode(child)) return false;
    var docTypeNode = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * Check if en element node can be inserted before `child`, or at the end if child is falsy,
 * according to the presence and position of a doctype node on the same level.
 *
 * @param {Node} doc The document node
 * @param {Node} child the node that would become the nextSibling if the element would be inserted
 * @returns {boolean} `true` if an element can be inserted before child
 * @private
 * https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$isElementReplacementPossible(doc, child) {
    var parentChildNodes = doc.childNodes || [];
    function hasElementChildThatIsNotChild(node) {
        return $22a89a9d1d5ce29e$var$isElementNode(node) && node !== child;
    }
    if ($22a89a9d1d5ce29e$var$find(parentChildNodes, hasElementChildThatIsNotChild)) return false;
    var docTypeNode = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode);
    return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
/**
 * @private
 * Steps 1-5 of the checks before inserting and before replacing a child are the same.
 *
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreInsertionValidity1to5(parent, node, child) {
    // 1. If `parent` is not a Document, DocumentFragment, or Element node, then throw a "HierarchyRequestError" DOMException.
    if (!$22a89a9d1d5ce29e$var$hasValidParentNodeType(parent)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Unexpected parent node type " + parent.nodeType);
    // 2. If `node` is a host-including inclusive ancestor of `parent`, then throw a "HierarchyRequestError" DOMException.
    // not implemented!
    // 3. If `child` is non-null and its parent is not `parent`, then throw a "NotFoundError" DOMException.
    if (child && child.parentNode !== parent) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$NOT_FOUND_ERR, "child not in parent");
    if (// 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
    !$22a89a9d1d5ce29e$var$hasInsertableNodeType(node) || // 5. If either `node` is a Text node and `parent` is a document,
    // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
    // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
    // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
    $22a89a9d1d5ce29e$var$isDocTypeNode(node) && parent.nodeType !== $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Unexpected node type " + node.nodeType + " for parent node type " + parent.nodeType);
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreInsertionValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($22a89a9d1d5ce29e$var$isElementNode);
        // If node has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $22a89a9d1d5ce29e$var$find(nodeChildNodes, $22a89a9d1d5ce29e$var$isTextNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        // Otherwise, if `node` has one element child and either `parent` has an element child,
        // `child` is a doctype, or `child` is non-null and a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$22a89a9d1d5ce29e$var$isElementInsertionPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
    }
    // Element
    if ($22a89a9d1d5ce29e$var$isElementNode(node)) {
        // `parent` has an element child, `child` is a doctype,
        // or `child` is non-null and a doctype is following `child`.
        if (!$22a89a9d1d5ce29e$var$isElementInsertionPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
    }
    // DocumentType
    if ($22a89a9d1d5ce29e$var$isDocTypeNode(node)) {
        // `parent` has a doctype child,
        if ($22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isDocTypeNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        var parentElementChild = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode);
        // `child` is non-null and an element is preceding `child`,
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
        // or `child` is null and `parent` has an element child.
        if (!child && parentElementChild) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can not be appended since element is present");
    }
}
/**
 * @private
 * Step 6 of the checks before inserting and before replacing a child are different.
 *
 * @param {Document} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node | undefined} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 * @see https://dom.spec.whatwg.org/#concept-node-replace
 */ function $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument(parent, node, child) {
    var parentChildNodes = parent.childNodes || [];
    var nodeChildNodes = node.childNodes || [];
    // DocumentFragment
    if (node.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter($22a89a9d1d5ce29e$var$isElementNode);
        // If `node` has more than one element child or has a Text node child.
        if (nodeChildElements.length > 1 || $22a89a9d1d5ce29e$var$find(nodeChildNodes, $22a89a9d1d5ce29e$var$isTextNode)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        // Otherwise, if `node` has one element child and either `parent` has an element child that is not `child` or a doctype is following `child`.
        if (nodeChildElements.length === 1 && !$22a89a9d1d5ce29e$var$isElementReplacementPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
    }
    // Element
    if ($22a89a9d1d5ce29e$var$isElementNode(node)) {
        // `parent` has an element child that is not `child` or a doctype is following `child`.
        if (!$22a89a9d1d5ce29e$var$isElementReplacementPossible(parent, child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
    }
    // DocumentType
    if ($22a89a9d1d5ce29e$var$isDocTypeNode(node)) {
        function hasDoctypeChildThatIsNotChild(node) {
            return $22a89a9d1d5ce29e$var$isDocTypeNode(node) && node !== child;
        }
        // `parent` has a doctype child that is not `child`,
        if ($22a89a9d1d5ce29e$var$find(parentChildNodes, hasDoctypeChildThatIsNotChild)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        var parentElementChild = $22a89a9d1d5ce29e$var$find(parentChildNodes, $22a89a9d1d5ce29e$var$isElementNode);
        // or an element is preceding `child`.
        if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) throw new $22a89a9d1d5ce29e$var$DOMException($22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
    }
}
/**
 * @private
 * @param {Node} parent the parent node to insert `node` into
 * @param {Node} node the node to insert
 * @param {Node=} child the node that should become the `nextSibling` of `node`
 * @returns {Node}
 * @throws DOMException for several node combinations that would create a DOM that is not well-formed.
 * @throws DOMException if `child` is provided but is not a child of `parent`.
 * @see https://dom.spec.whatwg.org/#concept-node-ensure-pre-insertion-validity
 */ function $22a89a9d1d5ce29e$var$_insertBefore(parent, node, child, _inDocumentAssertion) {
    // To ensure pre-insertion validity of a node into a parent before a child, run these steps:
    $22a89a9d1d5ce29e$var$assertPreInsertionValidity1to5(parent, node, child);
    // If parent is a document, and any of the statements below, switched on the interface node implements,
    // are true, then throw a "HierarchyRequestError" DOMException.
    if (parent.nodeType === $22a89a9d1d5ce29e$var$Node.DOCUMENT_NODE) (_inDocumentAssertion || $22a89a9d1d5ce29e$var$assertPreInsertionValidityInDocument)(parent, node, child);
    var cp = node.parentNode;
    if (cp) cp.removeChild(node); //remove and update
    if (node.nodeType === $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node.firstChild;
        if (newFirst == null) return node;
        var newLast = node.lastChild;
    } else newFirst = newLast = node;
    var pre = child ? child.previousSibling : parent.lastChild;
    newFirst.previousSibling = pre;
    newLast.nextSibling = child;
    if (pre) pre.nextSibling = newFirst;
    else parent.firstChild = newFirst;
    if (child == null) parent.lastChild = newLast;
    else child.previousSibling = newLast;
    do newFirst.parentNode = parent;
    while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
    $22a89a9d1d5ce29e$var$_onUpdateChild(parent.ownerDocument || parent, parent);
    //console.log(parent.lastChild.nextSibling == null)
    if (node.nodeType == $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) node.firstChild = node.lastChild = null;
    return node;
}
/**
 * Appends `newChild` to `parentNode`.
 * If `newChild` is already connected to a `parentNode` it is first removed from it.
 *
 * @see https://github.com/xmldom/xmldom/issues/135
 * @see https://github.com/xmldom/xmldom/issues/145
 * @param {Node} parentNode
 * @param {Node} newChild
 * @returns {Node}
 * @private
 */ function $22a89a9d1d5ce29e$var$_appendSingleChild(parentNode, newChild) {
    if (newChild.parentNode) newChild.parentNode.removeChild(newChild);
    newChild.parentNode = parentNode;
    newChild.previousSibling = parentNode.lastChild;
    newChild.nextSibling = null;
    if (newChild.previousSibling) newChild.previousSibling.nextSibling = newChild;
    else parentNode.firstChild = newChild;
    parentNode.lastChild = newChild;
    $22a89a9d1d5ce29e$var$_onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
    return newChild;
}
$22a89a9d1d5ce29e$var$Document.prototype = {
    //implementation : null,
    nodeName: "#document",
    nodeType: $22a89a9d1d5ce29e$var$DOCUMENT_NODE,
    /**
	 * The DocumentType node of the document.
	 *
	 * @readonly
	 * @type DocumentType
	 */ doctype: null,
    documentElement: null,
    _inc: 1,
    insertBefore: function(newChild, refChild) {
        if (newChild.nodeType == $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) {
            var child = newChild.firstChild;
            while(child){
                var next = child.nextSibling;
                this.insertBefore(child, refChild);
                child = next;
            }
            return newChild;
        }
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, refChild);
        newChild.ownerDocument = this;
        if (this.documentElement === null && newChild.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE) this.documentElement = newChild;
        return newChild;
    },
    removeChild: function(oldChild) {
        if (this.documentElement == oldChild) this.documentElement = null;
        return $22a89a9d1d5ce29e$var$_removeChild(this, oldChild);
    },
    replaceChild: function(newChild, oldChild) {
        //raises
        $22a89a9d1d5ce29e$var$_insertBefore(this, newChild, oldChild, $22a89a9d1d5ce29e$var$assertPreReplacementValidityInDocument);
        newChild.ownerDocument = this;
        if (oldChild) this.removeChild(oldChild);
        if ($22a89a9d1d5ce29e$var$isElementNode(newChild)) this.documentElement = newChild;
    },
    // Introduced in DOM Level 2:
    importNode: function(importedNode, deep) {
        return $22a89a9d1d5ce29e$var$importNode(this, importedNode, deep);
    },
    // Introduced in DOM Level 2:
    getElementById: function(id) {
        var rtv = null;
        $22a89a9d1d5ce29e$var$_visitNode(this.documentElement, function(node) {
            if (node.nodeType == $22a89a9d1d5ce29e$var$ELEMENT_NODE) {
                if (node.getAttribute("id") == id) {
                    rtv = node;
                    return true;
                }
            }
        });
        return rtv;
    },
    /**
	 * The `getElementsByClassName` method of `Document` interface returns an array-like object
	 * of all child elements which have **all** of the given class name(s).
	 *
	 * Returns an empty list if `classeNames` is an empty string or only contains HTML white space characters.
	 *
	 *
	 * Warning: This is a live LiveNodeList.
	 * Changes in the DOM will reflect in the array as the changes occur.
	 * If an element selected by this array no longer qualifies for the selector,
	 * it will automatically be removed. Be aware of this for iteration purposes.
	 *
	 * @param {string} classNames is a string representing the class name(s) to match; multiple class names are separated by (ASCII-)whitespace
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
	 * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
	 */ getElementsByClassName: function(classNames) {
        var classNamesSet = $22a89a9d1d5ce29e$var$toOrderedSet(classNames);
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            if (classNamesSet.length > 0) $22a89a9d1d5ce29e$var$_visitNode(base.documentElement, function(node) {
                if (node !== base && node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE) {
                    var nodeClassNames = node.getAttribute("class");
                    // can be null if the attribute does not exist
                    if (nodeClassNames) {
                        // before splitting and iterating just compare them for the most common case
                        var matches = classNames === nodeClassNames;
                        if (!matches) {
                            var nodeClassNamesSet = $22a89a9d1d5ce29e$var$toOrderedSet(nodeClassNames);
                            matches = classNamesSet.every($22a89a9d1d5ce29e$var$arrayIncludes(nodeClassNamesSet));
                        }
                        if (matches) ls.push(node);
                    }
                }
            });
            return ls;
        });
    },
    //document factory method:
    createElement: function(tagName) {
        var node = new $22a89a9d1d5ce29e$var$Element();
        node.ownerDocument = this;
        node.nodeName = tagName;
        node.tagName = tagName;
        node.localName = tagName;
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        var attrs = node.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
        attrs._ownerElement = node;
        return node;
    },
    createDocumentFragment: function() {
        var node = new $22a89a9d1d5ce29e$var$DocumentFragment();
        node.ownerDocument = this;
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        return node;
    },
    createTextNode: function(data) {
        var node = new $22a89a9d1d5ce29e$var$Text();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createComment: function(data) {
        var node = new $22a89a9d1d5ce29e$var$Comment();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createCDATASection: function(data) {
        var node = new $22a89a9d1d5ce29e$var$CDATASection();
        node.ownerDocument = this;
        node.appendData(data);
        return node;
    },
    createProcessingInstruction: function(target, data) {
        var node = new $22a89a9d1d5ce29e$var$ProcessingInstruction();
        node.ownerDocument = this;
        node.tagName = node.nodeName = node.target = target;
        node.nodeValue = node.data = data;
        return node;
    },
    createAttribute: function(name) {
        var node = new $22a89a9d1d5ce29e$var$Attr();
        node.ownerDocument = this;
        node.name = name;
        node.nodeName = name;
        node.localName = name;
        node.specified = true;
        return node;
    },
    createEntityReference: function(name) {
        var node = new $22a89a9d1d5ce29e$var$EntityReference();
        node.ownerDocument = this;
        node.nodeName = name;
        return node;
    },
    // Introduced in DOM Level 2:
    createElementNS: function(namespaceURI, qualifiedName) {
        var node = new $22a89a9d1d5ce29e$var$Element();
        var pl = qualifiedName.split(":");
        var attrs = node.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
        node.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.tagName = qualifiedName;
        node.namespaceURI = namespaceURI;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        attrs._ownerElement = node;
        return node;
    },
    // Introduced in DOM Level 2:
    createAttributeNS: function(namespaceURI, qualifiedName) {
        var node = new $22a89a9d1d5ce29e$var$Attr();
        var pl = qualifiedName.split(":");
        node.ownerDocument = this;
        node.nodeName = qualifiedName;
        node.name = qualifiedName;
        node.namespaceURI = namespaceURI;
        node.specified = true;
        if (pl.length == 2) {
            node.prefix = pl[0];
            node.localName = pl[1];
        } else //el.prefix = null;
        node.localName = qualifiedName;
        return node;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Document, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Element() {
    this._nsMap = {};
}
$22a89a9d1d5ce29e$var$Element.prototype = {
    nodeType: $22a89a9d1d5ce29e$var$ELEMENT_NODE,
    hasAttribute: function(name) {
        return this.getAttributeNode(name) != null;
    },
    getAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        return attr && attr.value || "";
    },
    getAttributeNode: function(name) {
        return this.attributes.getNamedItem(name);
    },
    setAttribute: function(name, value) {
        var attr = this.ownerDocument.createAttribute(name);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    removeAttribute: function(name) {
        var attr = this.getAttributeNode(name);
        attr && this.removeAttributeNode(attr);
    },
    //four real opeartion method
    appendChild: function(newChild) {
        if (newChild.nodeType === $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE) return this.insertBefore(newChild, null);
        else return $22a89a9d1d5ce29e$var$_appendSingleChild(this, newChild);
    },
    setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
    },
    setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
    },
    removeAttributeNode: function(oldAttr) {
        //console.log(this == oldAttr.ownerElement)
        return this.attributes.removeNamedItem(oldAttr.nodeName);
    },
    //get real attribute name,and remove it by removeAttributeNode
    removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
    },
    hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
    },
    getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr && attr.value || "";
    },
    setAttributeNS: function(namespaceURI, qualifiedName, value) {
        var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
        attr.value = attr.nodeValue = "" + value;
        this.setAttributeNode(attr);
    },
    getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
    },
    getElementsByTagName: function(tagName) {
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            $22a89a9d1d5ce29e$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType == $22a89a9d1d5ce29e$var$ELEMENT_NODE && (tagName === "*" || node.tagName == tagName)) ls.push(node);
            });
            return ls;
        });
    },
    getElementsByTagNameNS: function(namespaceURI, localName) {
        return new $22a89a9d1d5ce29e$var$LiveNodeList(this, function(base) {
            var ls = [];
            $22a89a9d1d5ce29e$var$_visitNode(base, function(node) {
                if (node !== base && node.nodeType === $22a89a9d1d5ce29e$var$ELEMENT_NODE && (namespaceURI === "*" || node.namespaceURI === namespaceURI) && (localName === "*" || node.localName == localName)) ls.push(node);
            });
            return ls;
        });
    }
};
$22a89a9d1d5ce29e$var$Document.prototype.getElementsByTagName = $22a89a9d1d5ce29e$var$Element.prototype.getElementsByTagName;
$22a89a9d1d5ce29e$var$Document.prototype.getElementsByTagNameNS = $22a89a9d1d5ce29e$var$Element.prototype.getElementsByTagNameNS;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Element, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Attr() {}
$22a89a9d1d5ce29e$var$Attr.prototype.nodeType = $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Attr, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$CharacterData() {}
$22a89a9d1d5ce29e$var$CharacterData.prototype = {
    data: "",
    substringData: function(offset, count) {
        return this.data.substring(offset, offset + count);
    },
    appendData: function(text) {
        text = this.data + text;
        this.nodeValue = this.data = text;
        this.length = text.length;
    },
    insertData: function(offset, text) {
        this.replaceData(offset, 0, text);
    },
    appendChild: function(newChild) {
        throw new Error($22a89a9d1d5ce29e$var$ExceptionMessage[$22a89a9d1d5ce29e$var$HIERARCHY_REQUEST_ERR]);
    },
    deleteData: function(offset, count) {
        this.replaceData(offset, count, "");
    },
    replaceData: function(offset, count, text) {
        var start = this.data.substring(0, offset);
        var end = this.data.substring(offset + count);
        text = start + text + end;
        this.nodeValue = this.data = text;
        this.length = text.length;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$CharacterData, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Text() {}
$22a89a9d1d5ce29e$var$Text.prototype = {
    nodeName: "#text",
    nodeType: $22a89a9d1d5ce29e$var$TEXT_NODE,
    splitText: function(offset) {
        var text = this.data;
        var newText = text.substring(offset);
        text = text.substring(0, offset);
        this.data = this.nodeValue = text;
        this.length = text.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) this.parentNode.insertBefore(newNode, this.nextSibling);
        return newNode;
    }
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Text, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$Comment() {}
$22a89a9d1d5ce29e$var$Comment.prototype = {
    nodeName: "#comment",
    nodeType: $22a89a9d1d5ce29e$var$COMMENT_NODE
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Comment, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$CDATASection() {}
$22a89a9d1d5ce29e$var$CDATASection.prototype = {
    nodeName: "#cdata-section",
    nodeType: $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE
};
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$CDATASection, $22a89a9d1d5ce29e$var$CharacterData);
function $22a89a9d1d5ce29e$var$DocumentType() {}
$22a89a9d1d5ce29e$var$DocumentType.prototype.nodeType = $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$DocumentType, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Notation() {}
$22a89a9d1d5ce29e$var$Notation.prototype.nodeType = $22a89a9d1d5ce29e$var$NOTATION_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Notation, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$Entity() {}
$22a89a9d1d5ce29e$var$Entity.prototype.nodeType = $22a89a9d1d5ce29e$var$ENTITY_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$Entity, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$EntityReference() {}
$22a89a9d1d5ce29e$var$EntityReference.prototype.nodeType = $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$EntityReference, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$DocumentFragment() {}
$22a89a9d1d5ce29e$var$DocumentFragment.prototype.nodeName = "#document-fragment";
$22a89a9d1d5ce29e$var$DocumentFragment.prototype.nodeType = $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$DocumentFragment, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$ProcessingInstruction() {}
$22a89a9d1d5ce29e$var$ProcessingInstruction.prototype.nodeType = $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE;
$22a89a9d1d5ce29e$var$_extends($22a89a9d1d5ce29e$var$ProcessingInstruction, $22a89a9d1d5ce29e$var$Node);
function $22a89a9d1d5ce29e$var$XMLSerializer() {}
$22a89a9d1d5ce29e$var$XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter) {
    return $22a89a9d1d5ce29e$var$nodeSerializeToString.call(node, isHtml, nodeFilter);
};
$22a89a9d1d5ce29e$var$Node.prototype.toString = $22a89a9d1d5ce29e$var$nodeSerializeToString;
function $22a89a9d1d5ce29e$var$nodeSerializeToString(isHtml, nodeFilter) {
    var buf = [];
    var refNode = this.nodeType == 9 && this.documentElement || this;
    var prefix = refNode.prefix;
    var uri = refNode.namespaceURI;
    if (uri && prefix == null) {
        //console.log(prefix)
        var prefix = refNode.lookupPrefix(uri);
        if (prefix == null) //isHTML = true;
        var visibleNamespaces = [
            {
                namespace: uri,
                prefix: null
            }
        ];
    }
    $22a89a9d1d5ce29e$var$serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
    //console.log('###',this.nodeType,uri,prefix,buf.join(''))
    return buf.join("");
}
function $22a89a9d1d5ce29e$var$needNamespaceDefine(node, isHTML, visibleNamespaces) {
    var prefix = node.prefix || "";
    var uri = node.namespaceURI;
    // According to [Namespaces in XML 1.0](https://www.w3.org/TR/REC-xml-names/#ns-using) ,
    // and more specifically https://www.w3.org/TR/REC-xml-names/#nsc-NoPrefixUndecl :
    // > In a namespace declaration for a prefix [...], the attribute value MUST NOT be empty.
    // in a similar manner [Namespaces in XML 1.1](https://www.w3.org/TR/xml-names11/#ns-using)
    // and more specifically https://www.w3.org/TR/xml-names11/#nsc-NSDeclared :
    // > [...] Furthermore, the attribute value [...] must not be an empty string.
    // so serializing empty namespace value like xmlns:ds="" would produce an invalid XML document.
    if (!uri) return false;
    if (prefix === "xml" && uri === $22a89a9d1d5ce29e$var$NAMESPACE.XML || uri === $22a89a9d1d5ce29e$var$NAMESPACE.XMLNS) return false;
    var i = visibleNamespaces.length;
    while(i--){
        var ns = visibleNamespaces[i];
        // get namespace prefix
        if (ns.prefix === prefix) return ns.namespace !== uri;
    }
    return true;
}
/**
 * Well-formed constraint: No < in Attribute Values
 * > The replacement text of any entity referred to directly or indirectly
 * > in an attribute value must not contain a <.
 * @see https://www.w3.org/TR/xml11/#CleanAttrVals
 * @see https://www.w3.org/TR/xml11/#NT-AttValue
 *
 * Literal whitespace other than space that appear in attribute values
 * are serialized as their entity references, so they will be preserved.
 * (In contrast to whitespace literals in the input which are normalized to spaces)
 * @see https://www.w3.org/TR/xml11/#AVNormalize
 * @see https://w3c.github.io/DOM-Parsing/#serializing-an-element-s-attributes
 */ function $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, qualifiedName, value) {
    buf.push(" ", qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, $22a89a9d1d5ce29e$var$_xmlEncoder), '"');
}
function $22a89a9d1d5ce29e$var$serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
    if (!visibleNamespaces) visibleNamespaces = [];
    if (nodeFilter) {
        node = nodeFilter(node);
        if (node) {
            if (typeof node == "string") {
                buf.push(node);
                return;
            }
        } else return;
    //buf.sort.apply(attrs, attributeSorter);
    }
    switch(node.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var len = attrs.length;
            var child = node.firstChild;
            var nodeName = node.tagName;
            isHTML = $22a89a9d1d5ce29e$var$NAMESPACE.isHTML(node.namespaceURI) || isHTML;
            var prefixedNodeName = nodeName;
            if (!isHTML && !node.prefix && node.namespaceURI) {
                var defaultNS;
                // lookup current default ns from `xmlns` attribute
                for(var ai = 0; ai < attrs.length; ai++)if (attrs.item(ai).name === "xmlns") {
                    defaultNS = attrs.item(ai).value;
                    break;
                }
                if (!defaultNS) // lookup current default ns in visibleNamespaces
                for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.prefix === "" && namespace.namespace === node.namespaceURI) {
                        defaultNS = namespace.namespace;
                        break;
                    }
                }
                if (defaultNS !== node.namespaceURI) for(var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--){
                    var namespace = visibleNamespaces[nsi];
                    if (namespace.namespace === node.namespaceURI) {
                        if (namespace.prefix) prefixedNodeName = namespace.prefix + ":" + nodeName;
                        break;
                    }
                }
            }
            buf.push("<", prefixedNodeName);
            for(var i = 0; i < len; i++){
                // add namespaces for attributes
                var attr = attrs.item(i);
                if (attr.prefix == "xmlns") visibleNamespaces.push({
                    prefix: attr.localName,
                    namespace: attr.value
                });
                else if (attr.nodeName == "xmlns") visibleNamespaces.push({
                    prefix: "",
                    namespace: attr.value
                });
            }
            for(var i = 0; i < len; i++){
                var attr = attrs.item(i);
                if ($22a89a9d1d5ce29e$var$needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
                    var prefix = attr.prefix || "";
                    var uri = attr.namespaceURI;
                    $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
                    visibleNamespaces.push({
                        prefix: prefix,
                        namespace: uri
                    });
                }
                $22a89a9d1d5ce29e$var$serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
            }
            // add namespace for current node
            if (nodeName === prefixedNodeName && $22a89a9d1d5ce29e$var$needNamespaceDefine(node, isHTML, visibleNamespaces)) {
                var prefix = node.prefix || "";
                var uri = node.namespaceURI;
                $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
                visibleNamespaces.push({
                    prefix: prefix,
                    namespace: uri
                });
            }
            if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
                buf.push(">");
                //if is cdata child node
                if (isHTML && /^script$/i.test(nodeName)) while(child){
                    if (child.data) buf.push(child.data);
                    else $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                else while(child){
                    $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                    child = child.nextSibling;
                }
                buf.push("</", prefixedNodeName, ">");
            } else buf.push("/>");
            // remove added visible namespaces
            //visibleNamespaces.length = startVisibleNamespaces;
            return;
        case $22a89a9d1d5ce29e$var$DOCUMENT_NODE:
        case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
            var child = node.firstChild;
            while(child){
                $22a89a9d1d5ce29e$var$serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
                child = child.nextSibling;
            }
            return;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            return $22a89a9d1d5ce29e$var$addSerializedAttribute(buf, node.name, node.value);
        case $22a89a9d1d5ce29e$var$TEXT_NODE:
            /**
		 * The ampersand character (&) and the left angle bracket (<) must not appear in their literal form,
		 * except when used as markup delimiters, or within a comment, a processing instruction, or a CDATA section.
		 * If they are needed elsewhere, they must be escaped using either numeric character references or the strings
		 * `&amp;` and `&lt;` respectively.
		 * The right angle bracket (>) may be represented using the string " &gt; ", and must, for compatibility,
		 * be escaped using either `&gt;` or a character reference when it appears in the string `]]>` in content,
		 * when that string is not marking the end of a CDATA section.
		 *
		 * In the content of elements, character data is any string of characters
		 * which does not contain the start-delimiter of any markup
		 * and does not include the CDATA-section-close delimiter, `]]>`.
		 *
		 * @see https://www.w3.org/TR/xml/#NT-CharData
		 * @see https://w3c.github.io/DOM-Parsing/#xml-serializing-a-text-node
		 */ return buf.push(node.data.replace(/[<&>]/g, $22a89a9d1d5ce29e$var$_xmlEncoder));
        case $22a89a9d1d5ce29e$var$CDATA_SECTION_NODE:
            return buf.push("<![CDATA[", node.data, "]]>");
        case $22a89a9d1d5ce29e$var$COMMENT_NODE:
            return buf.push("<!--", node.data, "-->");
        case $22a89a9d1d5ce29e$var$DOCUMENT_TYPE_NODE:
            var pubid = node.publicId;
            var sysid = node.systemId;
            buf.push("<!DOCTYPE ", node.name);
            if (pubid) {
                buf.push(" PUBLIC ", pubid);
                if (sysid && sysid != ".") buf.push(" ", sysid);
                buf.push(">");
            } else if (sysid && sysid != ".") buf.push(" SYSTEM ", sysid, ">");
            else {
                var sub = node.internalSubset;
                if (sub) buf.push(" [", sub, "]");
                buf.push(">");
            }
            return;
        case $22a89a9d1d5ce29e$var$PROCESSING_INSTRUCTION_NODE:
            return buf.push("<?", node.target, " ", node.data, "?>");
        case $22a89a9d1d5ce29e$var$ENTITY_REFERENCE_NODE:
            return buf.push("&", node.nodeName, ";");
        //case ENTITY_NODE:
        //case NOTATION_NODE:
        default:
            buf.push("??", node.nodeName);
    }
}
function $22a89a9d1d5ce29e$var$importNode(doc, node, deep) {
    var node2;
    switch(node.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            node2 = node.cloneNode(false);
            node2.ownerDocument = doc;
        //var attrs = node2.attributes;
        //var len = attrs.length;
        //for(var i=0;i<len;i++){
        //node2.setAttributeNodeNS(importNode(doc,attrs.item(i),deep));
        //}
        case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
            break;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            deep = true;
            break;
    }
    if (!node2) node2 = node.cloneNode(false); //false
    node2.ownerDocument = doc;
    node2.parentNode = null;
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($22a89a9d1d5ce29e$var$importNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
//
//var _relationMap = {firstChild:1,lastChild:1,previousSibling:1,nextSibling:1,
//					attributes:1,childNodes:1,parentNode:1,documentElement:1,doctype,};
function $22a89a9d1d5ce29e$var$cloneNode(doc, node, deep) {
    var node2 = new node.constructor();
    for(var n in node)if (Object.prototype.hasOwnProperty.call(node, n)) {
        var v = node[n];
        if (typeof v != "object") {
            if (v != node2[n]) node2[n] = v;
        }
    }
    if (node.childNodes) node2.childNodes = new $22a89a9d1d5ce29e$var$NodeList();
    node2.ownerDocument = doc;
    switch(node2.nodeType){
        case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
            var attrs = node.attributes;
            var attrs2 = node2.attributes = new $22a89a9d1d5ce29e$var$NamedNodeMap();
            var len = attrs.length;
            attrs2._ownerElement = node2;
            for(var i = 0; i < len; i++)node2.setAttributeNode($22a89a9d1d5ce29e$var$cloneNode(doc, attrs.item(i), true));
            break;
        case $22a89a9d1d5ce29e$var$ATTRIBUTE_NODE:
            deep = true;
    }
    if (deep) {
        var child = node.firstChild;
        while(child){
            node2.appendChild($22a89a9d1d5ce29e$var$cloneNode(doc, child, deep));
            child = child.nextSibling;
        }
    }
    return node2;
}
function $22a89a9d1d5ce29e$var$__set__(object, key, value) {
    object[key] = value;
}
//do dynamic
try {
    if (Object.defineProperty) {
        Object.defineProperty($22a89a9d1d5ce29e$var$LiveNodeList.prototype, "length", {
            get: function() {
                $22a89a9d1d5ce29e$var$_updateLiveList(this);
                return this.$$length;
            }
        });
        Object.defineProperty($22a89a9d1d5ce29e$var$Node.prototype, "textContent", {
            get: function() {
                return getTextContent(this);
            },
            set: function(data) {
                switch(this.nodeType){
                    case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
                    case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
                        while(this.firstChild)this.removeChild(this.firstChild);
                        if (data || String(data)) this.appendChild(this.ownerDocument.createTextNode(data));
                        break;
                    default:
                        this.data = data;
                        this.value = data;
                        this.nodeValue = data;
                }
            }
        });
        function getTextContent(node) {
            switch(node.nodeType){
                case $22a89a9d1d5ce29e$var$ELEMENT_NODE:
                case $22a89a9d1d5ce29e$var$DOCUMENT_FRAGMENT_NODE:
                    var buf = [];
                    node = node.firstChild;
                    while(node){
                        if (node.nodeType !== 7 && node.nodeType !== 8) buf.push(getTextContent(node));
                        node = node.nextSibling;
                    }
                    return buf.join("");
                default:
                    return node.nodeValue;
            }
        }
        $22a89a9d1d5ce29e$var$__set__ = function(object, key, value) {
            //console.log(value)
            object["$$" + key] = value;
        };
    }
} catch (e) {}
$22a89a9d1d5ce29e$export$d1d99cf900472499 = $22a89a9d1d5ce29e$var$DocumentType;
$22a89a9d1d5ce29e$export$fe58bcf938607f6a = $22a89a9d1d5ce29e$var$DOMException;
$22a89a9d1d5ce29e$export$455426655eab1d48 = $22a89a9d1d5ce29e$var$DOMImplementation;
$22a89a9d1d5ce29e$export$db77ccec0bb4ccac = $22a89a9d1d5ce29e$var$Element;
$22a89a9d1d5ce29e$export$85c928794f8d04d4 = $22a89a9d1d5ce29e$var$Node;
$22a89a9d1d5ce29e$export$79b41aa5d56abdff = $22a89a9d1d5ce29e$var$NodeList;
$22a89a9d1d5ce29e$export$64f0bed4ae6f0f24 = $22a89a9d1d5ce29e$var$XMLSerializer; //}

});
parcelRegister("hkG9E", function(module, exports) {

$parcel$export(module.exports, "find", () => $c9e500f3e8ddaab6$export$71aa6c912b956294, (v) => $c9e500f3e8ddaab6$export$71aa6c912b956294 = v);
$parcel$export(module.exports, "freeze", () => $c9e500f3e8ddaab6$export$792f3d81ea979f55, (v) => $c9e500f3e8ddaab6$export$792f3d81ea979f55 = v);
$parcel$export(module.exports, "NAMESPACE", () => $c9e500f3e8ddaab6$export$6aad947bda0f3f46, (v) => $c9e500f3e8ddaab6$export$6aad947bda0f3f46 = v);
var $c9e500f3e8ddaab6$export$e6e34fd1f2686227;
var $c9e500f3e8ddaab6$export$71aa6c912b956294;
var $c9e500f3e8ddaab6$export$792f3d81ea979f55;
var $c9e500f3e8ddaab6$export$c6cb9dd1e3ada1aa;
var $c9e500f3e8ddaab6$export$6aad947bda0f3f46;
"use strict";
/**
 * Ponyfill for `Array.prototype.find` which is only available in ES6 runtimes.
 *
 * Works with anything that has a `length` property and index access properties, including NodeList.
 *
 * @template {unknown} T
 * @param {Array<T> | ({length:number, [number]: T})} list
 * @param {function (item: T, index: number, list:Array<T> | ({length:number, [number]: T})):boolean} predicate
 * @param {Partial<Pick<ArrayConstructor['prototype'], 'find'>>?} ac `Array.prototype` by default,
 * 				allows injecting a custom implementation in tests
 * @returns {T | undefined}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * @see https://tc39.es/ecma262/multipage/indexed-collections.html#sec-array.prototype.find
 */ function $c9e500f3e8ddaab6$var$find(list, predicate, ac) {
    if (ac === undefined) ac = Array.prototype;
    if (list && typeof ac.find === "function") return ac.find.call(list, predicate);
    for(var i = 0; i < list.length; i++)if (Object.prototype.hasOwnProperty.call(list, i)) {
        var item = list[i];
        if (predicate.call(undefined, item, i, list)) return item;
    }
}
/**
 * "Shallow freezes" an object to render it immutable.
 * Uses `Object.freeze` if available,
 * otherwise the immutability is only in the type.
 *
 * Is used to create "enum like" objects.
 *
 * @template T
 * @param {T} object the object to freeze
 * @param {Pick<ObjectConstructor, 'freeze'> = Object} oc `Object` by default,
 * 				allows to inject custom object constructor for tests
 * @returns {Readonly<T>}
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
 */ function $c9e500f3e8ddaab6$var$freeze(object, oc) {
    if (oc === undefined) oc = Object;
    return oc && typeof oc.freeze === "function" ? oc.freeze(object) : object;
}
/**
 * Since we can not rely on `Object.assign` we provide a simplified version
 * that is sufficient for our needs.
 *
 * @param {Object} target
 * @param {Object | null | undefined} source
 *
 * @returns {Object} target
 * @throws TypeError if target is not an object
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 * @see https://tc39.es/ecma262/multipage/fundamental-objects.html#sec-object.assign
 */ function $c9e500f3e8ddaab6$var$assign(target, source) {
    if (target === null || typeof target !== "object") throw new TypeError("target is not an object");
    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    return target;
}
/**
 * All mime types that are allowed as input to `DOMParser.parseFromString`
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#Argument02 MDN
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#domparsersupportedtype WHATWG HTML Spec
 * @see DOMParser.prototype.parseFromString
 */ var $c9e500f3e8ddaab6$var$MIME_TYPE = $c9e500f3e8ddaab6$var$freeze({
    /**
	 * `text/html`, the only mime type that triggers treating an XML document as HTML.
	 *
	 * @see DOMParser.SupportedType.isHTML
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring WHATWG HTML Spec
	 */ HTML: "text/html",
    /**
	 * Helper method to check a mime type if it indicates an HTML document
	 *
	 * @param {string} [value]
	 * @returns {boolean}
	 *
	 * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/HTML Wikipedia
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
	 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring 	 */ isHTML: function(value) {
        return value === $c9e500f3e8ddaab6$var$MIME_TYPE.HTML;
    },
    /**
	 * `application/xml`, the standard mime type for XML documents.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType registration
	 * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_APPLICATION: "application/xml",
    /**
	 * `text/html`, an alias for `application/xml`.
	 *
	 * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
	 * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
	 * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
	 */ XML_TEXT: "text/xml",
    /**
	 * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
	 * but is parsed as an XML document.
	 *
	 * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType registration
	 * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
	 * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
	 */ XML_XHTML_APPLICATION: "application/xhtml+xml",
    /**
	 * `image/svg+xml`,
	 *
	 * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
	 * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
	 * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
	 */ XML_SVG_IMAGE: "image/svg+xml"
});
/**
 * Namespaces that are used in this code base.
 *
 * @see http://www.w3.org/TR/REC-xml-names
 */ var $c9e500f3e8ddaab6$var$NAMESPACE = $c9e500f3e8ddaab6$var$freeze({
    /**
	 * The XHTML namespace.
	 *
	 * @see http://www.w3.org/1999/xhtml
	 */ HTML: "http://www.w3.org/1999/xhtml",
    /**
	 * Checks if `uri` equals `NAMESPACE.HTML`.
	 *
	 * @param {string} [uri]
	 *
	 * @see NAMESPACE.HTML
	 */ isHTML: function(uri) {
        return uri === $c9e500f3e8ddaab6$var$NAMESPACE.HTML;
    },
    /**
	 * The SVG namespace.
	 *
	 * @see http://www.w3.org/2000/svg
	 */ SVG: "http://www.w3.org/2000/svg",
    /**
	 * The `xml:` namespace.
	 *
	 * @see http://www.w3.org/XML/1998/namespace
	 */ XML: "http://www.w3.org/XML/1998/namespace",
    /**
	 * The `xmlns:` namespace
	 *
	 * @see https://www.w3.org/2000/xmlns/
	 */ XMLNS: "http://www.w3.org/2000/xmlns/"
});
$c9e500f3e8ddaab6$export$e6e34fd1f2686227 = $c9e500f3e8ddaab6$var$assign;
$c9e500f3e8ddaab6$export$71aa6c912b956294 = $c9e500f3e8ddaab6$var$find;
$c9e500f3e8ddaab6$export$792f3d81ea979f55 = $c9e500f3e8ddaab6$var$freeze;
$c9e500f3e8ddaab6$export$c6cb9dd1e3ada1aa = $c9e500f3e8ddaab6$var$MIME_TYPE;
$c9e500f3e8ddaab6$export$6aad947bda0f3f46 = $c9e500f3e8ddaab6$var$NAMESPACE;

});


parcelRegister("c1Wy2", function(module, exports) {

$parcel$export(module.exports, "DOMParser", () => $8c22fe72d8589809$export$1059c6e7d2ce5669, (v) => $8c22fe72d8589809$export$1059c6e7d2ce5669 = v);
var $8c22fe72d8589809$export$181392475aa39887;
var $8c22fe72d8589809$export$ba13e0e2f19e61a1;
var $8c22fe72d8589809$export$1059c6e7d2ce5669;

var $hkG9E = parcelRequire("hkG9E");

var $2YubT = parcelRequire("2YubT");

var $2NAtx = parcelRequire("2NAtx");

var $1fO4L = parcelRequire("1fO4L");
var $8c22fe72d8589809$var$DOMImplementation = $2YubT.DOMImplementation;
var $8c22fe72d8589809$var$NAMESPACE = $hkG9E.NAMESPACE;
var $8c22fe72d8589809$var$ParseError = $1fO4L.ParseError;
var $8c22fe72d8589809$var$XMLReader = $1fO4L.XMLReader;
/**
 * Normalizes line ending according to https://www.w3.org/TR/xml11/#sec-line-ends:
 *
 * > XML parsed entities are often stored in computer files which,
 * > for editing convenience, are organized into lines.
 * > These lines are typically separated by some combination
 * > of the characters CARRIAGE RETURN (#xD) and LINE FEED (#xA).
 * >
 * > To simplify the tasks of applications, the XML processor must behave
 * > as if it normalized all line breaks in external parsed entities (including the document entity)
 * > on input, before parsing, by translating all of the following to a single #xA character:
 * >
 * > 1. the two-character sequence #xD #xA
 * > 2. the two-character sequence #xD #x85
 * > 3. the single character #x85
 * > 4. the single character #x2028
 * > 5. any #xD character that is not immediately followed by #xA or #x85.
 *
 * @param {string} input
 * @returns {string}
 */ function $8c22fe72d8589809$var$normalizeLineEndings(input) {
    return input.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028]/g, "\n");
}
/**
 * @typedef Locator
 * @property {number} [columnNumber]
 * @property {number} [lineNumber]
 */ /**
 * @typedef DOMParserOptions
 * @property {DOMHandler} [domBuilder]
 * @property {Function} [errorHandler]
 * @property {(string) => string} [normalizeLineEndings] used to replace line endings before parsing
 * 						defaults to `normalizeLineEndings`
 * @property {Locator} [locator]
 * @property {Record<string, string>} [xmlns]
 *
 * @see normalizeLineEndings
 */ /**
 * The DOMParser interface provides the ability to parse XML or HTML source code
 * from a string into a DOM `Document`.
 *
 * _xmldom is different from the spec in that it allows an `options` parameter,
 * to override the default behavior._
 *
 * @param {DOMParserOptions} [options]
 * @constructor
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
 * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-parsing-and-serialization
 */ function $8c22fe72d8589809$var$DOMParser(options) {
    this.options = options || {
        locator: {}
    };
}
$8c22fe72d8589809$var$DOMParser.prototype.parseFromString = function(source, mimeType) {
    var options = this.options;
    var sax = new $8c22fe72d8589809$var$XMLReader();
    var domBuilder = options.domBuilder || new $8c22fe72d8589809$var$DOMHandler(); //contentHandler and LexicalHandler
    var errorHandler = options.errorHandler;
    var locator = options.locator;
    var defaultNSMap = options.xmlns || {};
    var isHTML = /\/x?html?$/.test(mimeType); //mimeType.toLowerCase().indexOf('html') > -1;
    var entityMap = isHTML ? $2NAtx.HTML_ENTITIES : $2NAtx.XML_ENTITIES;
    if (locator) domBuilder.setDocumentLocator(locator);
    sax.errorHandler = $8c22fe72d8589809$var$buildErrorHandler(errorHandler, domBuilder, locator);
    sax.domBuilder = options.domBuilder || domBuilder;
    if (isHTML) defaultNSMap[""] = $8c22fe72d8589809$var$NAMESPACE.HTML;
    defaultNSMap.xml = defaultNSMap.xml || $8c22fe72d8589809$var$NAMESPACE.XML;
    var normalize = options.normalizeLineEndings || $8c22fe72d8589809$var$normalizeLineEndings;
    if (source && typeof source === "string") sax.parse(normalize(source), defaultNSMap, entityMap);
    else sax.errorHandler.error("invalid doc source");
    return domBuilder.doc;
};
function $8c22fe72d8589809$var$buildErrorHandler(errorImpl, domBuilder, locator) {
    if (!errorImpl) {
        if (domBuilder instanceof $8c22fe72d8589809$var$DOMHandler) return domBuilder;
        errorImpl = domBuilder;
    }
    var errorHandler = {};
    var isCallback = errorImpl instanceof Function;
    locator = locator || {};
    function build(key) {
        var fn = errorImpl[key];
        if (!fn && isCallback) fn = errorImpl.length == 2 ? function(msg) {
            errorImpl(key, msg);
        } : errorImpl;
        errorHandler[key] = fn && function(msg) {
            fn("[xmldom " + key + "]	" + msg + $8c22fe72d8589809$var$_locator(locator));
        } || function() {};
    }
    build("warning");
    build("error");
    build("fatalError");
    return errorHandler;
}
//console.log('#\n\n\n\n\n\n\n####')
/**
 * +ContentHandler+ErrorHandler
 * +LexicalHandler+EntityResolver2
 * -DeclHandler-DTDHandler
 *
 * DefaultHandler:EntityResolver, DTDHandler, ContentHandler, ErrorHandler
 * DefaultHandler2:DefaultHandler,LexicalHandler, DeclHandler, EntityResolver2
 * @link http://www.saxproject.org/apidoc/org/xml/sax/helpers/DefaultHandler.html
 */ function $8c22fe72d8589809$var$DOMHandler() {
    this.cdata = false;
}
function $8c22fe72d8589809$var$position(locator, node) {
    node.lineNumber = locator.lineNumber;
    node.columnNumber = locator.columnNumber;
}
/**
 * @see org.xml.sax.ContentHandler#startDocument
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
 */ $8c22fe72d8589809$var$DOMHandler.prototype = {
    startDocument: function() {
        this.doc = new $8c22fe72d8589809$var$DOMImplementation().createDocument(null, null, null);
        if (this.locator) this.doc.documentURI = this.locator.systemId;
    },
    startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        $8c22fe72d8589809$var$appendElement(this, el);
        this.currentElement = el;
        this.locator && $8c22fe72d8589809$var$position(this.locator, el);
        for(var i = 0; i < len; i++){
            var namespaceURI = attrs.getURI(i);
            var value = attrs.getValue(i);
            var qName = attrs.getQName(i);
            var attr = doc.createAttributeNS(namespaceURI, qName);
            this.locator && $8c22fe72d8589809$var$position(attrs.getLocator(i), attr);
            attr.value = attr.nodeValue = value;
            el.setAttributeNode(attr);
        }
    },
    endElement: function(namespaceURI, localName, qName) {
        var current = this.currentElement;
        var tagName = current.tagName;
        this.currentElement = current.parentNode;
    },
    startPrefixMapping: function(prefix, uri) {},
    endPrefixMapping: function(prefix) {},
    processingInstruction: function(target, data) {
        var ins = this.doc.createProcessingInstruction(target, data);
        this.locator && $8c22fe72d8589809$var$position(this.locator, ins);
        $8c22fe72d8589809$var$appendElement(this, ins);
    },
    ignorableWhitespace: function(ch, start, length) {},
    characters: function(chars, start, length) {
        chars = $8c22fe72d8589809$var$_toString.apply(this, arguments);
        //console.log(chars)
        if (chars) {
            if (this.cdata) var charNode = this.doc.createCDATASection(chars);
            else var charNode = this.doc.createTextNode(chars);
            if (this.currentElement) this.currentElement.appendChild(charNode);
            else if (/^\s*$/.test(chars)) this.doc.appendChild(charNode);
            this.locator && $8c22fe72d8589809$var$position(this.locator, charNode);
        }
    },
    skippedEntity: function(name) {},
    endDocument: function() {
        this.doc.normalize();
    },
    setDocumentLocator: function(locator) {
        if (this.locator = locator) locator.lineNumber = 0;
    },
    //LexicalHandler
    comment: function(chars, start, length) {
        chars = $8c22fe72d8589809$var$_toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && $8c22fe72d8589809$var$position(this.locator, comm);
        $8c22fe72d8589809$var$appendElement(this, comm);
    },
    startCDATA: function() {
        //used in characters() methods
        this.cdata = true;
    },
    endCDATA: function() {
        this.cdata = false;
    },
    startDTD: function(name, publicId, systemId) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
            var dt = impl.createDocumentType(name, publicId, systemId);
            this.locator && $8c22fe72d8589809$var$position(this.locator, dt);
            $8c22fe72d8589809$var$appendElement(this, dt);
            this.doc.doctype = dt;
        }
    },
    /**
	 * @see org.xml.sax.ErrorHandler
	 * @link http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
	 */ warning: function(error) {
        console.warn("[xmldom warning]	" + error, $8c22fe72d8589809$var$_locator(this.locator));
    },
    error: function(error) {
        console.error("[xmldom error]	" + error, $8c22fe72d8589809$var$_locator(this.locator));
    },
    fatalError: function(error) {
        throw new $8c22fe72d8589809$var$ParseError(error, this.locator);
    }
};
function $8c22fe72d8589809$var$_locator(l) {
    if (l) return "\n@" + (l.systemId || "") + "#[line:" + l.lineNumber + ",col:" + l.columnNumber + "]";
}
function $8c22fe72d8589809$var$_toString(chars, start, length) {
    if (typeof chars == "string") return chars.substr(start, length);
    else {
        if (chars.length >= start + length || start) return new java.lang.String(chars, start, length) + "";
        return chars;
    }
}
/*
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/LexicalHandler.html
 * used method of org.xml.sax.ext.LexicalHandler:
 *  #comment(chars, start, length)
 *  #startCDATA()
 *  #endCDATA()
 *  #startDTD(name, publicId, systemId)
 *
 *
 * IGNORED method of org.xml.sax.ext.LexicalHandler:
 *  #endDTD()
 *  #startEntity(name)
 *  #endEntity(name)
 *
 *
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/DeclHandler.html
 * IGNORED method of org.xml.sax.ext.DeclHandler
 * 	#attributeDecl(eName, aName, type, mode, value)
 *  #elementDecl(name, model)
 *  #externalEntityDecl(name, publicId, systemId)
 *  #internalEntityDecl(name, value)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/ext/EntityResolver2.html
 * IGNORED method of org.xml.sax.EntityResolver2
 *  #resolveEntity(String name,String publicId,String baseURI,String systemId)
 *  #resolveEntity(publicId, systemId)
 *  #getExternalSubset(name, baseURI)
 * @link http://www.saxproject.org/apidoc/org/xml/sax/DTDHandler.html
 * IGNORED method of org.xml.sax.DTDHandler
 *  #notationDecl(name, publicId, systemId) {};
 *  #unparsedEntityDecl(name, publicId, systemId, notationName) {};
 */ "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
    $8c22fe72d8589809$var$DOMHandler.prototype[key] = function() {
        return null;
    };
});
/* Private static helpers treated below as private instance methods, so don't need to add these to the public API; we might use a Relator to also get rid of non-standard public properties */ function $8c22fe72d8589809$var$appendElement(hander, node) {
    if (!hander.currentElement) hander.doc.appendChild(node);
    else hander.currentElement.appendChild(node);
} //appendChild and setAttributeNS are preformance key
$8c22fe72d8589809$export$181392475aa39887 = $8c22fe72d8589809$var$DOMHandler;
$8c22fe72d8589809$export$ba13e0e2f19e61a1 = $8c22fe72d8589809$var$normalizeLineEndings;
$8c22fe72d8589809$export$1059c6e7d2ce5669 = $8c22fe72d8589809$var$DOMParser;

});
parcelRegister("2NAtx", function(module, exports) {

$parcel$export(module.exports, "XML_ENTITIES", () => $209c739ee170ce7f$export$91f0e5ff03dc84f, (v) => $209c739ee170ce7f$export$91f0e5ff03dc84f = v);
$parcel$export(module.exports, "HTML_ENTITIES", () => $209c739ee170ce7f$export$b7e4d4631df36afa, (v) => $209c739ee170ce7f$export$b7e4d4631df36afa = v);
/**
 * The entities that are predefined in every XML document.
 *
 * @see https://www.w3.org/TR/2006/REC-xml11-20060816/#sec-predefined-ent W3C XML 1.1
 * @see https://www.w3.org/TR/2008/REC-xml-20081126/#sec-predefined-ent W3C XML 1.0
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Predefined_entities_in_XML Wikipedia
 */ var $209c739ee170ce7f$export$91f0e5ff03dc84f;
/**
 * A map of all entities that are detected in an HTML document.
 * They contain all entries from `XML_ENTITIES`.
 *
 * @see XML_ENTITIES
 * @see DOMParser.parseFromString
 * @see DOMImplementation.prototype.createHTMLDocument
 * @see https://html.spec.whatwg.org/#named-character-references WHATWG HTML(5) Spec
 * @see https://html.spec.whatwg.org/entities.json JSON
 * @see https://www.w3.org/TR/xml-entity-names/ W3C XML Entity Names
 * @see https://www.w3.org/TR/html4/sgml/entities.html W3C HTML4/SGML
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Character_entity_references_in_HTML Wikipedia (HTML)
 * @see https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references#Entities_representing_special_characters_in_XHTML Wikpedia (XHTML)
 */ var $209c739ee170ce7f$export$b7e4d4631df36afa;
/**
 * @deprecated use `HTML_ENTITIES` instead
 * @see HTML_ENTITIES
 */ var $209c739ee170ce7f$export$79451380caed3f98;
"use strict";

var $hkG9E = parcelRequire("hkG9E");
var $209c739ee170ce7f$require$freeze = $hkG9E.freeze;
$209c739ee170ce7f$export$91f0e5ff03dc84f = $209c739ee170ce7f$require$freeze({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
});
$209c739ee170ce7f$export$b7e4d4631df36afa = $209c739ee170ce7f$require$freeze({
    Aacute: "\xc1",
    aacute: "\xe1",
    Abreve: "\u0102",
    abreve: "\u0103",
    ac: "\u223E",
    acd: "\u223F",
    acE: "\u223E\u0333",
    Acirc: "\xc2",
    acirc: "\xe2",
    acute: "\xb4",
    Acy: "\u0410",
    acy: "\u0430",
    AElig: "\xc6",
    aelig: "\xe6",
    af: "\u2061",
    Afr: "\uD835\uDD04",
    afr: "\uD835\uDD1E",
    Agrave: "\xc0",
    agrave: "\xe0",
    alefsym: "\u2135",
    aleph: "\u2135",
    Alpha: "\u0391",
    alpha: "\u03B1",
    Amacr: "\u0100",
    amacr: "\u0101",
    amalg: "\u2A3F",
    AMP: "&",
    amp: "&",
    And: "\u2A53",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xc5",
    angzarr: "\u237C",
    Aogon: "\u0104",
    aogon: "\u0105",
    Aopf: "\uD835\uDD38",
    aopf: "\uD835\uDD52",
    ap: "\u2248",
    apacir: "\u2A6F",
    apE: "\u2A70",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    ApplyFunction: "\u2061",
    approx: "\u2248",
    approxeq: "\u224A",
    Aring: "\xc5",
    aring: "\xe5",
    Ascr: "\uD835\uDC9C",
    ascr: "\uD835\uDCB6",
    Assign: "\u2254",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    Atilde: "\xc3",
    atilde: "\xe3",
    Auml: "\xc4",
    auml: "\xe4",
    awconint: "\u2233",
    awint: "\u2A11",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    barvee: "\u22BD",
    Barwed: "\u2306",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    Bcy: "\u0411",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    Because: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    Bfr: "\uD835\uDD05",
    bfr: "\uD835\uDD1F",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bNot: "\u2AED",
    bnot: "\u2310",
    Bopf: "\uD835\uDD39",
    bopf: "\uD835\uDD53",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxbox: "\u29C9",
    boxDL: "\u2557",
    boxDl: "\u2556",
    boxdL: "\u2555",
    boxdl: "\u2510",
    boxDR: "\u2554",
    boxDr: "\u2553",
    boxdR: "\u2552",
    boxdr: "\u250C",
    boxH: "\u2550",
    boxh: "\u2500",
    boxHD: "\u2566",
    boxHd: "\u2564",
    boxhD: "\u2565",
    boxhd: "\u252C",
    boxHU: "\u2569",
    boxHu: "\u2567",
    boxhU: "\u2568",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxUL: "\u255D",
    boxUl: "\u255C",
    boxuL: "\u255B",
    boxul: "\u2518",
    boxUR: "\u255A",
    boxUr: "\u2559",
    boxuR: "\u2558",
    boxur: "\u2514",
    boxV: "\u2551",
    boxv: "\u2502",
    boxVH: "\u256C",
    boxVh: "\u256B",
    boxvH: "\u256A",
    boxvh: "\u253C",
    boxVL: "\u2563",
    boxVl: "\u2562",
    boxvL: "\u2561",
    boxvl: "\u2524",
    boxVR: "\u2560",
    boxVr: "\u255F",
    boxvR: "\u255E",
    boxvr: "\u251C",
    bprime: "\u2035",
    Breve: "\u02D8",
    breve: "\u02D8",
    brvbar: "\xa6",
    Bscr: "\u212C",
    bscr: "\uD835\uDCB7",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    Bumpeq: "\u224E",
    bumpeq: "\u224F",
    Cacute: "\u0106",
    cacute: "\u0107",
    Cap: "\u22D2",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    CapitalDifferentialD: "\u2145",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    Cayleys: "\u212D",
    ccaps: "\u2A4D",
    Ccaron: "\u010C",
    ccaron: "\u010D",
    Ccedil: "\xc7",
    ccedil: "\xe7",
    Ccirc: "\u0108",
    ccirc: "\u0109",
    Cconint: "\u2230",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    Cdot: "\u010A",
    cdot: "\u010B",
    cedil: "\xb8",
    Cedilla: "\xb8",
    cemptyv: "\u29B2",
    cent: "\xa2",
    CenterDot: "\xb7",
    centerdot: "\xb7",
    Cfr: "\u212D",
    cfr: "\uD835\uDD20",
    CHcy: "\u0427",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    Chi: "\u03A7",
    chi: "\u03C7",
    cir: "\u25CB",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    CircleDot: "\u2299",
    circledR: "\xae",
    circledS: "\u24C8",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    cirE: "\u29C3",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    clubs: "\u2663",
    clubsuit: "\u2663",
    Colon: "\u2237",
    colon: ":",
    Colone: "\u2A74",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    Congruent: "\u2261",
    Conint: "\u222F",
    conint: "\u222E",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    copf: "\uD835\uDD54",
    coprod: "\u2210",
    Coproduct: "\u2210",
    COPY: "\xa9",
    copy: "\xa9",
    copysr: "\u2117",
    CounterClockwiseContourIntegral: "\u2233",
    crarr: "\u21B5",
    Cross: "\u2A2F",
    cross: "\u2717",
    Cscr: "\uD835\uDC9E",
    cscr: "\uD835\uDCB8",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    Cup: "\u22D3",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    CupCap: "\u224D",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xa4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    Dagger: "\u2021",
    dagger: "\u2020",
    daleth: "\u2138",
    Darr: "\u21A1",
    dArr: "\u21D3",
    darr: "\u2193",
    dash: "\u2010",
    Dashv: "\u2AE4",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    Dcaron: "\u010E",
    dcaron: "\u010F",
    Dcy: "\u0414",
    dcy: "\u0434",
    DD: "\u2145",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    DDotrahd: "\u2911",
    ddotseq: "\u2A77",
    deg: "\xb0",
    Del: "\u2207",
    Delta: "\u0394",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    Dfr: "\uD835\uDD07",
    dfr: "\uD835\uDD21",
    dHar: "\u2965",
    dharl: "\u21C3",
    dharr: "\u21C2",
    DiacriticalAcute: "\xb4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    diam: "\u22C4",
    Diamond: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xa8",
    DifferentialD: "\u2146",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xf7",
    divide: "\xf7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    DJcy: "\u0402",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    Dopf: "\uD835\uDD3B",
    dopf: "\uD835\uDD55",
    Dot: "\xa8",
    dot: "\u02D9",
    DotDot: "\u20DC",
    doteq: "\u2250",
    doteqdot: "\u2251",
    DotEqual: "\u2250",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xa8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    Downarrow: "\u21D3",
    downarrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    Dscr: "\uD835\uDC9F",
    dscr: "\uD835\uDCB9",
    DScy: "\u0405",
    dscy: "\u0455",
    dsol: "\u29F6",
    Dstrok: "\u0110",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    DZcy: "\u040F",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    Eacute: "\xc9",
    eacute: "\xe9",
    easter: "\u2A6E",
    Ecaron: "\u011A",
    ecaron: "\u011B",
    ecir: "\u2256",
    Ecirc: "\xca",
    ecirc: "\xea",
    ecolon: "\u2255",
    Ecy: "\u042D",
    ecy: "\u044D",
    eDDot: "\u2A77",
    Edot: "\u0116",
    eDot: "\u2251",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    Efr: "\uD835\uDD08",
    efr: "\uD835\uDD22",
    eg: "\u2A9A",
    Egrave: "\xc8",
    egrave: "\xe8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    Element: "\u2208",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    Emacr: "\u0112",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    EmptySmallSquare: "\u25FB",
    emptyv: "\u2205",
    EmptyVerySmallSquare: "\u25AB",
    emsp: "\u2003",
    emsp13: "\u2004",
    emsp14: "\u2005",
    ENG: "\u014A",
    eng: "\u014B",
    ensp: "\u2002",
    Eogon: "\u0118",
    eogon: "\u0119",
    Eopf: "\uD835\uDD3C",
    eopf: "\uD835\uDD56",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    Epsilon: "\u0395",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    Equal: "\u2A75",
    equals: "=",
    EqualTilde: "\u2242",
    equest: "\u225F",
    Equilibrium: "\u21CC",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erarr: "\u2971",
    erDot: "\u2253",
    Escr: "\u2130",
    escr: "\u212F",
    esdot: "\u2250",
    Esim: "\u2A73",
    esim: "\u2242",
    Eta: "\u0397",
    eta: "\u03B7",
    ETH: "\xd0",
    eth: "\xf0",
    Euml: "\xcb",
    euml: "\xeb",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    Exists: "\u2203",
    expectation: "\u2130",
    ExponentialE: "\u2147",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    Fcy: "\u0424",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    Ffr: "\uD835\uDD09",
    ffr: "\uD835\uDD23",
    filig: "\uFB01",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    Fopf: "\uD835\uDD3D",
    fopf: "\uD835\uDD57",
    ForAll: "\u2200",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    Fouriertrf: "\u2131",
    fpartint: "\u2A0D",
    frac12: "\xbd",
    frac13: "\u2153",
    frac14: "\xbc",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xbe",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    Fscr: "\u2131",
    fscr: "\uD835\uDCBB",
    gacute: "\u01F5",
    Gamma: "\u0393",
    gamma: "\u03B3",
    Gammad: "\u03DC",
    gammad: "\u03DD",
    gap: "\u2A86",
    Gbreve: "\u011E",
    gbreve: "\u011F",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    gcirc: "\u011D",
    Gcy: "\u0413",
    gcy: "\u0433",
    Gdot: "\u0120",
    gdot: "\u0121",
    gE: "\u2267",
    ge: "\u2265",
    gEl: "\u2A8C",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    Gfr: "\uD835\uDD0A",
    gfr: "\uD835\uDD24",
    Gg: "\u22D9",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    GJcy: "\u0403",
    gjcy: "\u0453",
    gl: "\u2277",
    gla: "\u2AA5",
    glE: "\u2A92",
    glj: "\u2AA4",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gnE: "\u2269",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    Gopf: "\uD835\uDD3E",
    gopf: "\uD835\uDD58",
    grave: "`",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\uD835\uDCA2",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    Gt: "\u226B",
    GT: ">",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    Hacek: "\u02C7",
    hairsp: "\u200A",
    half: "\xbd",
    hamilt: "\u210B",
    HARDcy: "\u042A",
    hardcy: "\u044A",
    hArr: "\u21D4",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    Hat: "^",
    hbar: "\u210F",
    Hcirc: "\u0124",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    Hfr: "\u210C",
    hfr: "\uD835\uDD25",
    HilbertSpace: "\u210B",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    Hopf: "\u210D",
    hopf: "\uD835\uDD59",
    horbar: "\u2015",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    hscr: "\uD835\uDCBD",
    hslash: "\u210F",
    Hstrok: "\u0126",
    hstrok: "\u0127",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    hybull: "\u2043",
    hyphen: "\u2010",
    Iacute: "\xcd",
    iacute: "\xed",
    ic: "\u2063",
    Icirc: "\xce",
    icirc: "\xee",
    Icy: "\u0418",
    icy: "\u0438",
    Idot: "\u0130",
    IEcy: "\u0415",
    iecy: "\u0435",
    iexcl: "\xa1",
    iff: "\u21D4",
    Ifr: "\u2111",
    ifr: "\uD835\uDD26",
    Igrave: "\xcc",
    igrave: "\xec",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    IJlig: "\u0132",
    ijlig: "\u0133",
    Im: "\u2111",
    Imacr: "\u012A",
    imacr: "\u012B",
    image: "\u2111",
    ImaginaryI: "\u2148",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    Implies: "\u21D2",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    Int: "\u222C",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    Integral: "\u222B",
    intercal: "\u22BA",
    Intersection: "\u22C2",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    IOcy: "\u0401",
    iocy: "\u0451",
    Iogon: "\u012E",
    iogon: "\u012F",
    Iopf: "\uD835\uDD40",
    iopf: "\uD835\uDD5A",
    Iota: "\u0399",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xbf",
    Iscr: "\u2110",
    iscr: "\uD835\uDCBE",
    isin: "\u2208",
    isindot: "\u22F5",
    isinE: "\u22F9",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    Itilde: "\u0128",
    itilde: "\u0129",
    Iukcy: "\u0406",
    iukcy: "\u0456",
    Iuml: "\xcf",
    iuml: "\xef",
    Jcirc: "\u0134",
    jcirc: "\u0135",
    Jcy: "\u0419",
    jcy: "\u0439",
    Jfr: "\uD835\uDD0D",
    jfr: "\uD835\uDD27",
    jmath: "\u0237",
    Jopf: "\uD835\uDD41",
    jopf: "\uD835\uDD5B",
    Jscr: "\uD835\uDCA5",
    jscr: "\uD835\uDCBF",
    Jsercy: "\u0408",
    jsercy: "\u0458",
    Jukcy: "\u0404",
    jukcy: "\u0454",
    Kappa: "\u039A",
    kappa: "\u03BA",
    kappav: "\u03F0",
    Kcedil: "\u0136",
    kcedil: "\u0137",
    Kcy: "\u041A",
    kcy: "\u043A",
    Kfr: "\uD835\uDD0E",
    kfr: "\uD835\uDD28",
    kgreen: "\u0138",
    KHcy: "\u0425",
    khcy: "\u0445",
    KJcy: "\u040C",
    kjcy: "\u045C",
    Kopf: "\uD835\uDD42",
    kopf: "\uD835\uDD5C",
    Kscr: "\uD835\uDCA6",
    kscr: "\uD835\uDCC0",
    lAarr: "\u21DA",
    Lacute: "\u0139",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    Lambda: "\u039B",
    lambda: "\u03BB",
    Lang: "\u27EA",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    Laplacetrf: "\u2112",
    laquo: "\xab",
    Larr: "\u219E",
    lArr: "\u21D0",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    lAtail: "\u291B",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lBarr: "\u290E",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    Lcaron: "\u013D",
    lcaron: "\u013E",
    Lcedil: "\u013B",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    Lcy: "\u041B",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    lE: "\u2266",
    le: "\u2264",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    Leftarrow: "\u21D0",
    leftarrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    leftarrowtail: "\u21A2",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    LeftRightArrow: "\u2194",
    Leftrightarrow: "\u21D4",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    leftthreetimes: "\u22CB",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    lEg: "\u2A8B",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    lessgtr: "\u2276",
    LessLess: "\u2AA1",
    lesssim: "\u2272",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    Lfr: "\uD835\uDD0F",
    lfr: "\uD835\uDD29",
    lg: "\u2276",
    lgE: "\u2A91",
    lHar: "\u2962",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    LJcy: "\u0409",
    ljcy: "\u0459",
    Ll: "\u22D8",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    Lleftarrow: "\u21DA",
    llhard: "\u296B",
    lltri: "\u25FA",
    Lmidot: "\u013F",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lnE: "\u2268",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    LongLeftArrow: "\u27F5",
    Longleftarrow: "\u27F8",
    longleftarrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    Longleftrightarrow: "\u27FA",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    LongRightArrow: "\u27F6",
    Longrightarrow: "\u27F9",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    Lopf: "\uD835\uDD43",
    lopf: "\uD835\uDD5D",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    Lscr: "\u2112",
    lscr: "\uD835\uDCC1",
    Lsh: "\u21B0",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    Lstrok: "\u0141",
    lstrok: "\u0142",
    Lt: "\u226A",
    LT: "<",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    ltrPar: "\u2996",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    macr: "\xaf",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    Map: "\u2905",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    Mcy: "\u041C",
    mcy: "\u043C",
    mdash: "\u2014",
    mDDot: "\u223A",
    measuredangle: "\u2221",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\uD835\uDD10",
    mfr: "\uD835\uDD2A",
    mho: "\u2127",
    micro: "\xb5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xb7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    MinusPlus: "\u2213",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    Mopf: "\uD835\uDD44",
    mopf: "\uD835\uDD5E",
    mp: "\u2213",
    Mscr: "\u2133",
    mscr: "\uD835\uDCC2",
    mstpos: "\u223E",
    Mu: "\u039C",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nabla: "\u2207",
    Nacute: "\u0143",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xa0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    Ncaron: "\u0147",
    ncaron: "\u0148",
    Ncedil: "\u0145",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    Ncy: "\u041D",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    nearhk: "\u2924",
    neArr: "\u21D7",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    nexist: "\u2204",
    nexists: "\u2204",
    Nfr: "\uD835\uDD11",
    nfr: "\uD835\uDD2B",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    nGg: "\u22D9\u0338",
    ngsim: "\u2275",
    nGt: "\u226B\u20D2",
    ngt: "\u226F",
    ngtr: "\u226F",
    nGtv: "\u226B\u0338",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    NJcy: "\u040A",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlarr: "\u219A",
    nldr: "\u2025",
    nlE: "\u2266\u0338",
    nle: "\u2270",
    nLeftarrow: "\u21CD",
    nleftarrow: "\u219A",
    nLeftrightarrow: "\u21CE",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nLl: "\u22D8\u0338",
    nlsim: "\u2274",
    nLt: "\u226A\u20D2",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nLtv: "\u226A\u0338",
    nmid: "\u2224",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xa0",
    Nopf: "\u2115",
    nopf: "\uD835\uDD5F",
    Not: "\u2AEC",
    not: "\xac",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    notin: "\u2209",
    notindot: "\u22F5\u0338",
    notinE: "\u22F9\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nRightarrow: "\u21CF",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    Nscr: "\uD835\uDCA9",
    nscr: "\uD835\uDCC3",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    Ntilde: "\xd1",
    ntilde: "\xf1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    Nu: "\u039D",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvap: "\u224D\u20D2",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nvDash: "\u22AD",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvHarr: "\u2904",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwarhk: "\u2923",
    nwArr: "\u21D6",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    Oacute: "\xd3",
    oacute: "\xf3",
    oast: "\u229B",
    ocir: "\u229A",
    Ocirc: "\xd4",
    ocirc: "\xf4",
    Ocy: "\u041E",
    ocy: "\u043E",
    odash: "\u229D",
    Odblac: "\u0150",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    OElig: "\u0152",
    oelig: "\u0153",
    ofcir: "\u29BF",
    Ofr: "\uD835\uDD12",
    ofr: "\uD835\uDD2C",
    ogon: "\u02DB",
    Ograve: "\xd2",
    ograve: "\xf2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    Omacr: "\u014C",
    omacr: "\u014D",
    Omega: "\u03A9",
    omega: "\u03C9",
    Omicron: "\u039F",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    Oopf: "\uD835\uDD46",
    oopf: "\uD835\uDD60",
    opar: "\u29B7",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    operp: "\u29B9",
    oplus: "\u2295",
    Or: "\u2A54",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xaa",
    ordm: "\xba",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oS: "\u24C8",
    Oscr: "\uD835\uDCAA",
    oscr: "\u2134",
    Oslash: "\xd8",
    oslash: "\xf8",
    osol: "\u2298",
    Otilde: "\xd5",
    otilde: "\xf5",
    Otimes: "\u2A37",
    otimes: "\u2297",
    otimesas: "\u2A36",
    Ouml: "\xd6",
    ouml: "\xf6",
    ovbar: "\u233D",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    par: "\u2225",
    para: "\xb6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    PartialD: "\u2202",
    Pcy: "\u041F",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    Pfr: "\uD835\uDD13",
    pfr: "\uD835\uDD2D",
    Phi: "\u03A6",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    Pi: "\u03A0",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    PlusMinus: "\xb1",
    plusmn: "\xb1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xb1",
    Poincareplane: "\u210C",
    pointint: "\u2A15",
    Popf: "\u2119",
    popf: "\uD835\uDD61",
    pound: "\xa3",
    Pr: "\u2ABB",
    pr: "\u227A",
    prap: "\u2AB7",
    prcue: "\u227C",
    prE: "\u2AB3",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    Prime: "\u2033",
    prime: "\u2032",
    primes: "\u2119",
    prnap: "\u2AB9",
    prnE: "\u2AB5",
    prnsim: "\u22E8",
    prod: "\u220F",
    Product: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    Proportion: "\u2237",
    Proportional: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    Pscr: "\uD835\uDCAB",
    pscr: "\uD835\uDCC5",
    Psi: "\u03A8",
    psi: "\u03C8",
    puncsp: "\u2008",
    Qfr: "\uD835\uDD14",
    qfr: "\uD835\uDD2E",
    qint: "\u2A0C",
    Qopf: "\u211A",
    qopf: "\uD835\uDD62",
    qprime: "\u2057",
    Qscr: "\uD835\uDCAC",
    qscr: "\uD835\uDCC6",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    QUOT: '"',
    quot: '"',
    rAarr: "\u21DB",
    race: "\u223D\u0331",
    Racute: "\u0154",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    Rang: "\u27EB",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xbb",
    Rarr: "\u21A0",
    rArr: "\u21D2",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    Rarrtl: "\u2916",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    rAtail: "\u291C",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    RBarr: "\u2910",
    rBarr: "\u290F",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    Rcaron: "\u0158",
    rcaron: "\u0159",
    Rcedil: "\u0156",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    Rcy: "\u0420",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    Re: "\u211C",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    REG: "\xae",
    reg: "\xae",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    rfisht: "\u297D",
    rfloor: "\u230B",
    Rfr: "\u211C",
    rfr: "\uD835\uDD2F",
    rHar: "\u2964",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    Rho: "\u03A1",
    rho: "\u03C1",
    rhov: "\u03F1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    Rightarrow: "\u21D2",
    rightarrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    rightarrowtail: "\u21A3",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    rightthreetimes: "\u22CC",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    Ropf: "\u211D",
    ropf: "\uD835\uDD63",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    RoundImplies: "\u2970",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    Rrightarrow: "\u21DB",
    rsaquo: "\u203A",
    Rscr: "\u211B",
    rscr: "\uD835\uDCC7",
    Rsh: "\u21B1",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    RuleDelayed: "\u29F4",
    ruluhar: "\u2968",
    rx: "\u211E",
    Sacute: "\u015A",
    sacute: "\u015B",
    sbquo: "\u201A",
    Sc: "\u2ABC",
    sc: "\u227B",
    scap: "\u2AB8",
    Scaron: "\u0160",
    scaron: "\u0161",
    sccue: "\u227D",
    scE: "\u2AB4",
    sce: "\u2AB0",
    Scedil: "\u015E",
    scedil: "\u015F",
    Scirc: "\u015C",
    scirc: "\u015D",
    scnap: "\u2ABA",
    scnE: "\u2AB6",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    Scy: "\u0421",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    searhk: "\u2925",
    seArr: "\u21D8",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xa7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    Sfr: "\uD835\uDD16",
    sfr: "\uD835\uDD30",
    sfrown: "\u2322",
    sharp: "\u266F",
    SHCHcy: "\u0429",
    shchcy: "\u0449",
    SHcy: "\u0428",
    shcy: "\u0448",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    shy: "\xad",
    Sigma: "\u03A3",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    SmallCircle: "\u2218",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    SOFTcy: "\u042C",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    Sopf: "\uD835\uDD4A",
    sopf: "\uD835\uDD64",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    Sqrt: "\u221A",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    Square: "\u25A1",
    square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    Sscr: "\uD835\uDCAE",
    sscr: "\uD835\uDCC8",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    Star: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xaf",
    Sub: "\u22D0",
    sub: "\u2282",
    subdot: "\u2ABD",
    subE: "\u2AC5",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    Subset: "\u22D0",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    SubsetEqual: "\u2286",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    sum: "\u2211",
    sung: "\u266A",
    Sup: "\u22D1",
    sup: "\u2283",
    sup1: "\xb9",
    sup2: "\xb2",
    sup3: "\xb3",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supE: "\u2AC6",
    supe: "\u2287",
    supedot: "\u2AC4",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    Supset: "\u22D1",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swarhk: "\u2926",
    swArr: "\u21D9",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xdf",
    Tab: "	",
    target: "\u2316",
    Tau: "\u03A4",
    tau: "\u03C4",
    tbrk: "\u23B4",
    Tcaron: "\u0164",
    tcaron: "\u0165",
    Tcedil: "\u0162",
    tcedil: "\u0163",
    Tcy: "\u0422",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    Tfr: "\uD835\uDD17",
    tfr: "\uD835\uDD31",
    there4: "\u2234",
    Therefore: "\u2234",
    therefore: "\u2234",
    Theta: "\u0398",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    ThickSpace: "\u205F\u200A",
    thinsp: "\u2009",
    ThinSpace: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    THORN: "\xde",
    thorn: "\xfe",
    Tilde: "\u223C",
    tilde: "\u02DC",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    times: "\xd7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    Topf: "\uD835\uDD4B",
    topf: "\uD835\uDD65",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    TRADE: "\u2122",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    TripleDot: "\u20DB",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    Tscr: "\uD835\uDCAF",
    tscr: "\uD835\uDCC9",
    TScy: "\u0426",
    tscy: "\u0446",
    TSHcy: "\u040B",
    tshcy: "\u045B",
    Tstrok: "\u0166",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    Uacute: "\xda",
    uacute: "\xfa",
    Uarr: "\u219F",
    uArr: "\u21D1",
    uarr: "\u2191",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    ubrcy: "\u045E",
    Ubreve: "\u016C",
    ubreve: "\u016D",
    Ucirc: "\xdb",
    ucirc: "\xfb",
    Ucy: "\u0423",
    ucy: "\u0443",
    udarr: "\u21C5",
    Udblac: "\u0170",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    Ufr: "\uD835\uDD18",
    ufr: "\uD835\uDD32",
    Ugrave: "\xd9",
    ugrave: "\xf9",
    uHar: "\u2963",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    Umacr: "\u016A",
    umacr: "\u016B",
    uml: "\xa8",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    uogon: "\u0173",
    Uopf: "\uD835\uDD4C",
    uopf: "\uD835\uDD66",
    UpArrow: "\u2191",
    Uparrow: "\u21D1",
    uparrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    Updownarrow: "\u21D5",
    updownarrow: "\u2195",
    UpEquilibrium: "\u296E",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    upsi: "\u03C5",
    upsih: "\u03D2",
    Upsilon: "\u03A5",
    upsilon: "\u03C5",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    Uring: "\u016E",
    uring: "\u016F",
    urtri: "\u25F9",
    Uscr: "\uD835\uDCB0",
    uscr: "\uD835\uDCCA",
    utdot: "\u22F0",
    Utilde: "\u0168",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    Uuml: "\xdc",
    uuml: "\xfc",
    uwangle: "\u29A7",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    vArr: "\u21D5",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    Vbar: "\u2AEB",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    Vcy: "\u0412",
    vcy: "\u0432",
    VDash: "\u22AB",
    Vdash: "\u22A9",
    vDash: "\u22A8",
    vdash: "\u22A2",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    Verbar: "\u2016",
    verbar: "|",
    Vert: "\u2016",
    vert: "|",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\uD835\uDD19",
    vfr: "\uD835\uDD33",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    Vopf: "\uD835\uDD4D",
    vopf: "\uD835\uDD67",
    vprop: "\u221D",
    vrtri: "\u22B3",
    Vscr: "\uD835\uDCB1",
    vscr: "\uD835\uDCCB",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    Vvdash: "\u22AA",
    vzigzag: "\u299A",
    Wcirc: "\u0174",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    Wedge: "\u22C0",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    Wfr: "\uD835\uDD1A",
    wfr: "\uD835\uDD34",
    Wopf: "\uD835\uDD4E",
    wopf: "\uD835\uDD68",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    Wscr: "\uD835\uDCB2",
    wscr: "\uD835\uDCCC",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    Xfr: "\uD835\uDD1B",
    xfr: "\uD835\uDD35",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    Xi: "\u039E",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    Xopf: "\uD835\uDD4F",
    xopf: "\uD835\uDD69",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    Xscr: "\uD835\uDCB3",
    xscr: "\uD835\uDCCD",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    Yacute: "\xdd",
    yacute: "\xfd",
    YAcy: "\u042F",
    yacy: "\u044F",
    Ycirc: "\u0176",
    ycirc: "\u0177",
    Ycy: "\u042B",
    ycy: "\u044B",
    yen: "\xa5",
    Yfr: "\uD835\uDD1C",
    yfr: "\uD835\uDD36",
    YIcy: "\u0407",
    yicy: "\u0457",
    Yopf: "\uD835\uDD50",
    yopf: "\uD835\uDD6A",
    Yscr: "\uD835\uDCB4",
    yscr: "\uD835\uDCCE",
    YUcy: "\u042E",
    yucy: "\u044E",
    Yuml: "\u0178",
    yuml: "\xff",
    Zacute: "\u0179",
    zacute: "\u017A",
    Zcaron: "\u017D",
    zcaron: "\u017E",
    Zcy: "\u0417",
    zcy: "\u0437",
    Zdot: "\u017B",
    zdot: "\u017C",
    zeetrf: "\u2128",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    zeta: "\u03B6",
    Zfr: "\u2128",
    zfr: "\uD835\uDD37",
    ZHcy: "\u0416",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    Zopf: "\u2124",
    zopf: "\uD835\uDD6B",
    Zscr: "\uD835\uDCB5",
    zscr: "\uD835\uDCCF",
    zwj: "\u200D",
    zwnj: "\u200C"
});
$209c739ee170ce7f$export$79451380caed3f98 = $209c739ee170ce7f$export$b7e4d4631df36afa;

});

parcelRegister("1fO4L", function(module, exports) {

$parcel$export(module.exports, "XMLReader", () => $0e9e0929092947dd$export$ccbc9f9f018333e9, (v) => $0e9e0929092947dd$export$ccbc9f9f018333e9 = v);
$parcel$export(module.exports, "ParseError", () => $0e9e0929092947dd$export$f9c837a54db411d, (v) => $0e9e0929092947dd$export$f9c837a54db411d = v);
var $0e9e0929092947dd$export$ccbc9f9f018333e9;
var $0e9e0929092947dd$export$f9c837a54db411d;

var $hkG9E = parcelRequire("hkG9E");
var $0e9e0929092947dd$require$NAMESPACE = $hkG9E.NAMESPACE;
//[4]   	NameStartChar	   ::=   	":" | [A-Z] | "_" | [a-z] | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x2FF] | [#x370-#x37D] | [#x37F-#x1FFF] | [#x200C-#x200D] | [#x2070-#x218F] | [#x2C00-#x2FEF] | [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
//[4a]   	NameChar	   ::=   	NameStartChar | "-" | "." | [0-9] | #xB7 | [#x0300-#x036F] | [#x203F-#x2040]
//[5]   	Name	   ::=   	NameStartChar (NameChar)*
var $0e9e0929092947dd$var$nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/ //\u10000-\uEFFFF
;
var $0e9e0929092947dd$var$nameChar = new RegExp("[\\-\\.0-9" + $0e9e0929092947dd$var$nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var $0e9e0929092947dd$var$tagNamePattern = new RegExp("^" + $0e9e0929092947dd$var$nameStartChar.source + $0e9e0929092947dd$var$nameChar.source + "*(?::" + $0e9e0929092947dd$var$nameStartChar.source + $0e9e0929092947dd$var$nameChar.source + "*)?$");
//var tagNamePattern = /^[a-zA-Z_][\w\-\.]*(?:\:[a-zA-Z_][\w\-\.]*)?$/
//var handlers = 'resolveEntity,getExternalSubset,characters,endDocument,endElement,endPrefixMapping,ignorableWhitespace,processingInstruction,setDocumentLocator,skippedEntity,startDocument,startElement,startPrefixMapping,notationDecl,unparsedEntityDecl,error,fatalError,warning,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,comment,endCDATA,endDTD,endEntity,startCDATA,startDTD,startEntity'.split(',')
//S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
//S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
var $0e9e0929092947dd$var$S_TAG = 0; //tag name offerring
var $0e9e0929092947dd$var$S_ATTR = 1; //attr name offerring
var $0e9e0929092947dd$var$S_ATTR_SPACE = 2; //attr name end and space offer
var $0e9e0929092947dd$var$S_EQ = 3; //=space?
var $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE = 4; //attr value(no quot value only)
var $0e9e0929092947dd$var$S_ATTR_END = 5; //attr value end and no space(quot end)
var $0e9e0929092947dd$var$S_TAG_SPACE = 6; //(attr value end || tag end ) && (space offer)
var $0e9e0929092947dd$var$S_TAG_CLOSE = 7; //closed el<el />
/**
 * Creates an error that will not be caught by XMLReader aka the SAX parser.
 *
 * @param {string} message
 * @param {any?} locator Optional, can provide details about the location in the source
 * @constructor
 */ function $0e9e0929092947dd$var$ParseError(message, locator) {
    this.message = message;
    this.locator = locator;
    if (Error.captureStackTrace) Error.captureStackTrace(this, $0e9e0929092947dd$var$ParseError);
}
$0e9e0929092947dd$var$ParseError.prototype = new Error();
$0e9e0929092947dd$var$ParseError.prototype.name = $0e9e0929092947dd$var$ParseError.name;
function $0e9e0929092947dd$var$XMLReader() {}
$0e9e0929092947dd$var$XMLReader.prototype = {
    parse: function(source, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        $0e9e0929092947dd$var$_copy(defaultNSMap, defaultNSMap = {});
        $0e9e0929092947dd$var$parse(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
    }
};
function $0e9e0929092947dd$var$parse(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
    function fixedFromCharCode(code) {
        // String.prototype.fromCharCode does not supports
        // > 2 bytes unicode chars directly
        if (code > 0xffff) {
            code -= 0x10000;
            var surrogate1 = 0xd800 + (code >> 10), surrogate2 = 0xdc00 + (code & 0x3ff);
            return String.fromCharCode(surrogate1, surrogate2);
        } else return String.fromCharCode(code);
    }
    function entityReplacer(a) {
        var k = a.slice(1, -1);
        if (Object.hasOwnProperty.call(entityMap, k)) return entityMap[k];
        else if (k.charAt(0) === "#") return fixedFromCharCode(parseInt(k.substr(1).replace("x", "0x")));
        else {
            errorHandler.error("entity not found:" + a);
            return a;
        }
    }
    function appendText(end) {
        if (end > start) {
            var xt = source.substring(start, end).replace(/&#?\w+;/g, entityReplacer);
            locator && position(start);
            domBuilder.characters(xt, 0, end - start);
            start = end;
        }
    }
    function position(p, m) {
        while(p >= lineEnd && (m = linePattern.exec(source))){
            lineStart = m.index;
            lineEnd = lineStart + m[0].length;
            locator.lineNumber++;
        //console.log('line++:',locator,startPos,endPos)
        }
        locator.columnNumber = p - lineStart + 1;
    }
    var lineStart = 0;
    var lineEnd = 0;
    var linePattern = /.*(?:\r\n?|\n)|.*$/g;
    var locator = domBuilder.locator;
    var parseStack = [
        {
            currentNSMap: defaultNSMapCopy
        }
    ];
    var closeMap = {};
    var start = 0;
    while(true){
        try {
            var tagStart = source.indexOf("<", start);
            if (tagStart < 0) {
                if (!source.substr(start).match(/^\s*$/)) {
                    var doc = domBuilder.doc;
                    var text = doc.createTextNode(source.substr(start));
                    doc.appendChild(text);
                    domBuilder.currentElement = text;
                }
                return;
            }
            if (tagStart > start) appendText(tagStart);
            switch(source.charAt(tagStart + 1)){
                case "/":
                    var end = source.indexOf(">", tagStart + 3);
                    var tagName = source.substring(tagStart + 2, end).replace(/[ \t\n\r]+$/g, "");
                    var config = parseStack.pop();
                    if (end < 0) {
                        tagName = source.substring(tagStart + 2).replace(/[\s<].*/, "");
                        errorHandler.error("end tag name: " + tagName + " is not complete:" + config.tagName);
                        end = tagStart + 1 + tagName.length;
                    } else if (tagName.match(/\s</)) {
                        tagName = tagName.replace(/[\s<].*/, "");
                        errorHandler.error("end tag name: " + tagName + " maybe not complete");
                        end = tagStart + 1 + tagName.length;
                    }
                    var localNSMap = config.localNSMap;
                    var endMatch = config.tagName == tagName;
                    var endIgnoreCaseMach = endMatch || config.tagName && config.tagName.toLowerCase() == tagName.toLowerCase();
                    if (endIgnoreCaseMach) {
                        domBuilder.endElement(config.uri, config.localName, tagName);
                        if (localNSMap) {
                            for(var prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
                        }
                        if (!endMatch) errorHandler.fatalError("end tag name: " + tagName + " is not match the current start tagName:" + config.tagName); // No known test case
                    } else parseStack.push(config);
                    end++;
                    break;
                // end elment
                case "?":
                    locator && position(tagStart);
                    end = $0e9e0929092947dd$var$parseInstruction(source, tagStart, domBuilder);
                    break;
                case "!":
                    locator && position(tagStart);
                    end = $0e9e0929092947dd$var$parseDCC(source, tagStart, domBuilder, errorHandler);
                    break;
                default:
                    locator && position(tagStart);
                    var el = new $0e9e0929092947dd$var$ElementAttributes();
                    var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
                    //elStartEnd
                    var end = $0e9e0929092947dd$var$parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
                    var len = el.length;
                    if (!el.closed && $0e9e0929092947dd$var$fixSelfClosed(source, end, el.tagName, closeMap)) {
                        el.closed = true;
                        if (!entityMap.nbsp) errorHandler.warning("unclosed xml attribute");
                    }
                    if (locator && len) {
                        var locator2 = $0e9e0929092947dd$var$copyLocator(locator, {});
                        //try{//attribute position fixed
                        for(var i = 0; i < len; i++){
                            var a = el[i];
                            position(a.offset);
                            a.locator = $0e9e0929092947dd$var$copyLocator(locator, {});
                        }
                        domBuilder.locator = locator2;
                        if ($0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                        domBuilder.locator = locator;
                    } else if ($0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap)) parseStack.push(el);
                    if ($0e9e0929092947dd$require$NAMESPACE.isHTML(el.uri) && !el.closed) end = $0e9e0929092947dd$var$parseHtmlSpecialContent(source, end, el.tagName, entityReplacer, domBuilder);
                    else end++;
            }
        } catch (e) {
            if (e instanceof $0e9e0929092947dd$var$ParseError) throw e;
            errorHandler.error("element parse error: " + e);
            end = -1;
        }
        if (end > start) start = end;
        else //TODO: 这里有可能sax回退，有位置错误风险
        appendText(Math.max(tagStart, start) + 1);
    }
}
function $0e9e0929092947dd$var$copyLocator(f, t) {
    t.lineNumber = f.lineNumber;
    t.columnNumber = f.columnNumber;
    return t;
}
/**
 * @see #appendElement(source,elStartEnd,el,selfClosed,entityReplacer,domBuilder,parseStack);
 * @return end of the elementStartPart(end of elementEndPart for selfClosed el)
 */ function $0e9e0929092947dd$var$parseElementStartPart(source, start, el, currentNSMap, entityReplacer, errorHandler) {
    /**
	 * @param {string} qname
	 * @param {string} value
	 * @param {number} startIndex
	 */ function addAttribute(qname, value, startIndex) {
        if (el.attributeNames.hasOwnProperty(qname)) errorHandler.fatalError("Attribute " + qname + " redefined");
        el.addValue(qname, // @see https://www.w3.org/TR/xml/#AVNormalize
        // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
        // - recursive replacement of (DTD) entity references
        // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
        value.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, entityReplacer), startIndex);
    }
    var attrName;
    var value;
    var p = ++start;
    var s = $0e9e0929092947dd$var$S_TAG; //status
    while(true){
        var c = source.charAt(p);
        switch(c){
            case "=":
                if (s === $0e9e0929092947dd$var$S_ATTR) {
                    attrName = source.slice(start, p);
                    s = $0e9e0929092947dd$var$S_EQ;
                } else if (s === $0e9e0929092947dd$var$S_ATTR_SPACE) s = $0e9e0929092947dd$var$S_EQ;
                else //fatalError: equal must after attrName or space after attrName
                throw new Error("attribute equal must after attrName"); // No known test case
                break;
            case "'":
            case '"':
                if (s === $0e9e0929092947dd$var$S_EQ || s === $0e9e0929092947dd$var$S_ATTR //|| s == S_ATTR_SPACE
                ) {
                    if (s === $0e9e0929092947dd$var$S_ATTR) {
                        errorHandler.warning('attribute value must after "="');
                        attrName = source.slice(start, p);
                    }
                    start = p + 1;
                    p = source.indexOf(c, start);
                    if (p > 0) {
                        value = source.slice(start, p);
                        addAttribute(attrName, value, start - 1);
                        s = $0e9e0929092947dd$var$S_ATTR_END;
                    } else //fatalError: no end quot match
                    throw new Error("attribute value no end '" + c + "' match");
                } else if (s == $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE) {
                    value = source.slice(start, p);
                    addAttribute(attrName, value, start);
                    errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ")!!");
                    start = p + 1;
                    s = $0e9e0929092947dd$var$S_ATTR_END;
                } else //fatalError: no equal before
                throw new Error('attribute value must after "="'); // No known test case
                break;
            case "/":
                switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $0e9e0929092947dd$var$S_ATTR_END:
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        s = $0e9e0929092947dd$var$S_TAG_CLOSE;
                        el.closed = true;
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                    case $0e9e0929092947dd$var$S_ATTR:
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        el.closed = true;
                        break;
                    //case S_EQ:
                    default:
                        throw new Error("attribute invalid close char('/')") // No known test case
                        ;
                }
                break;
            case "":
                errorHandler.error("unexpected end of input");
                if (s == $0e9e0929092947dd$var$S_TAG) el.setTagName(source.slice(start, p));
                return p;
            case ">":
                switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p));
                    case $0e9e0929092947dd$var$S_ATTR_END:
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        break; //normal
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                    case $0e9e0929092947dd$var$S_ATTR:
                        value = source.slice(start, p);
                        if (value.slice(-1) === "/") {
                            el.closed = true;
                            value = value.slice(0, -1);
                        }
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        if (s === $0e9e0929092947dd$var$S_ATTR_SPACE) value = attrName;
                        if (s == $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE) {
                            errorHandler.warning('attribute "' + value + '" missed quot(")!');
                            addAttribute(attrName, value, start);
                        } else {
                            if (!$0e9e0929092947dd$require$NAMESPACE.isHTML(currentNSMap[""]) || !value.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
                            addAttribute(value, value, start);
                        }
                        break;
                    case $0e9e0929092947dd$var$S_EQ:
                        throw new Error("attribute value missed!!");
                }
                //			console.log(tagName,tagNamePattern,tagNamePattern.test(tagName))
                return p;
            /*xml space '\x20' | #x9 | #xD | #xA; */ case "\x80":
                c = " ";
            default:
                if (c <= " ") switch(s){
                    case $0e9e0929092947dd$var$S_TAG:
                        el.setTagName(source.slice(start, p)); //tagName
                        s = $0e9e0929092947dd$var$S_TAG_SPACE;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR:
                        attrName = source.slice(start, p);
                        s = $0e9e0929092947dd$var$S_ATTR_SPACE;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE:
                        var value = source.slice(start, p);
                        errorHandler.warning('attribute "' + value + '" missed quot(")!!');
                        addAttribute(attrName, value, start);
                    case $0e9e0929092947dd$var$S_ATTR_END:
                        s = $0e9e0929092947dd$var$S_TAG_SPACE;
                        break;
                }
                else //S_TAG,	S_ATTR,	S_EQ,	S_ATTR_NOQUOT_VALUE
                //S_ATTR_SPACE,	S_ATTR_END,	S_TAG_SPACE, S_TAG_CLOSE
                switch(s){
                    //case S_TAG:void();break;
                    //case S_ATTR:void();break;
                    //case S_ATTR_NOQUOT_VALUE:void();break;
                    case $0e9e0929092947dd$var$S_ATTR_SPACE:
                        var tagName = el.tagName;
                        if (!$0e9e0929092947dd$require$NAMESPACE.isHTML(currentNSMap[""]) || !attrName.match(/^(?:disabled|checked|selected)$/i)) errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                        addAttribute(attrName, attrName, start);
                        start = p;
                        s = $0e9e0929092947dd$var$S_ATTR;
                        break;
                    case $0e9e0929092947dd$var$S_ATTR_END:
                        errorHandler.warning('attribute space is required"' + attrName + '"!!');
                    case $0e9e0929092947dd$var$S_TAG_SPACE:
                        s = $0e9e0929092947dd$var$S_ATTR;
                        start = p;
                        break;
                    case $0e9e0929092947dd$var$S_EQ:
                        s = $0e9e0929092947dd$var$S_ATTR_NOQUOT_VALUE;
                        start = p;
                        break;
                    case $0e9e0929092947dd$var$S_TAG_CLOSE:
                        throw new Error("elements closed character '/' and '>' must be connected to");
                }
        } //end outer switch
        //console.log('p++',p)
        p++;
    }
}
/**
 * @return true if has new namespace define
 */ function $0e9e0929092947dd$var$appendElement(el, domBuilder, currentNSMap) {
    var tagName = el.tagName;
    var localNSMap = null;
    //var currentNSMap = parseStack[parseStack.length-1].currentNSMap;
    var i = el.length;
    while(i--){
        var a = el[i];
        var qName = a.qName;
        var value = a.value;
        var nsp = qName.indexOf(":");
        if (nsp > 0) {
            var prefix = a.prefix = qName.slice(0, nsp);
            var localName = qName.slice(nsp + 1);
            var nsPrefix = prefix === "xmlns" && localName;
        } else {
            localName = qName;
            prefix = null;
            nsPrefix = qName === "xmlns" && "";
        }
        //can not set prefix,because prefix !== ''
        a.localName = localName;
        //prefix == null for no ns prefix attribute
        if (nsPrefix !== false) {
            if (localNSMap == null) {
                localNSMap = {};
                //console.log(currentNSMap,0)
                $0e9e0929092947dd$var$_copy(currentNSMap, currentNSMap = {});
            //console.log(currentNSMap,1)
            }
            currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
            a.uri = $0e9e0929092947dd$require$NAMESPACE.XMLNS;
            domBuilder.startPrefixMapping(nsPrefix, value);
        }
    }
    var i = el.length;
    while(i--){
        a = el[i];
        var prefix = a.prefix;
        if (prefix) {
            if (prefix === "xml") a.uri = $0e9e0929092947dd$require$NAMESPACE.XML;
            if (prefix !== "xmlns") a.uri = currentNSMap[prefix || ""];
        }
    }
    var nsp = tagName.indexOf(":");
    if (nsp > 0) {
        prefix = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
    } else {
        prefix = null; //important!!
        localName = el.localName = tagName;
    }
    //no prefix element has default namespace
    var ns = el.uri = currentNSMap[prefix || ""];
    domBuilder.startElement(ns, localName, tagName, el);
    //endPrefixMapping and startPrefixMapping have not any help for dom builder
    //localNSMap = null
    if (el.closed) {
        domBuilder.endElement(ns, localName, tagName);
        if (localNSMap) {
            for(prefix in localNSMap)if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) domBuilder.endPrefixMapping(prefix);
        }
    } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        //parseStack.push(el);
        return true;
    }
}
function $0e9e0929092947dd$var$parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
    if (/^(?:script|textarea)$/i.test(tagName)) {
        var elEndStart = source.indexOf("</" + tagName + ">", elStartEnd);
        var text = source.substring(elStartEnd + 1, elEndStart);
        if (/[&<]/.test(text)) {
            if (/^script$/i.test(tagName)) {
                //if(!/\]\]>/.test(text)){
                //lexHandler.startCDATA();
                domBuilder.characters(text, 0, text.length);
                //lexHandler.endCDATA();
                return elEndStart;
            //}
            } //}else{//text area
            text = text.replace(/&#?\w+;/g, entityReplacer);
            domBuilder.characters(text, 0, text.length);
            return elEndStart;
        //}
        }
    }
    return elStartEnd + 1;
}
function $0e9e0929092947dd$var$fixSelfClosed(source, elStartEnd, tagName, closeMap) {
    //if(tagName in closeMap){
    var pos = closeMap[tagName];
    if (pos == null) {
        //console.log(tagName)
        pos = source.lastIndexOf("</" + tagName + ">");
        if (pos < elStartEnd) pos = source.lastIndexOf("</" + tagName);
        closeMap[tagName] = pos;
    }
    return pos < elStartEnd;
//}
}
function $0e9e0929092947dd$var$_copy(source, target) {
    for(var n in source)if (Object.prototype.hasOwnProperty.call(source, n)) target[n] = source[n];
}
function $0e9e0929092947dd$var$parseDCC(source, start, domBuilder, errorHandler) {
    var next = source.charAt(start + 2);
    switch(next){
        case "-":
            if (source.charAt(start + 3) === "-") {
                var end = source.indexOf("-->", start + 4);
                //append comment source.substring(4,end)//<!--
                if (end > start) {
                    domBuilder.comment(source, start + 4, end - start - 4);
                    return end + 3;
                } else {
                    errorHandler.error("Unclosed comment");
                    return -1;
                }
            } else //error
            return -1;
        default:
            if (source.substr(start + 3, 6) == "CDATA[") {
                var end = source.indexOf("]]>", start + 9);
                domBuilder.startCDATA();
                domBuilder.characters(source, start + 9, end - start - 9);
                domBuilder.endCDATA();
                return end + 3;
            }
            //<!DOCTYPE
            //startDTD(java.lang.String name, java.lang.String publicId, java.lang.String systemId)
            var matchs = $0e9e0929092947dd$var$split(source, start);
            var len = matchs.length;
            if (len > 1 && /!doctype/i.test(matchs[0][0])) {
                var name = matchs[1][0];
                var pubid = false;
                var sysid = false;
                if (len > 3) {
                    if (/^public$/i.test(matchs[2][0])) {
                        pubid = matchs[3][0];
                        sysid = len > 4 && matchs[4][0];
                    } else if (/^system$/i.test(matchs[2][0])) sysid = matchs[3][0];
                }
                var lastMatch = matchs[len - 1];
                domBuilder.startDTD(name, pubid, sysid);
                domBuilder.endDTD();
                return lastMatch.index + lastMatch[0].length;
            }
    }
    return -1;
}
function $0e9e0929092947dd$var$parseInstruction(source, start, domBuilder) {
    var end = source.indexOf("?>", start);
    if (end) {
        var match = source.substring(start, end).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
        if (match) {
            var len = match[0].length;
            domBuilder.processingInstruction(match[1], match[2]);
            return end + 2;
        } else return -1;
    }
    return -1;
}
function $0e9e0929092947dd$var$ElementAttributes() {
    this.attributeNames = {};
}
$0e9e0929092947dd$var$ElementAttributes.prototype = {
    setTagName: function(tagName) {
        if (!$0e9e0929092947dd$var$tagNamePattern.test(tagName)) throw new Error("invalid tagName:" + tagName);
        this.tagName = tagName;
    },
    addValue: function(qName, value, offset) {
        if (!$0e9e0929092947dd$var$tagNamePattern.test(qName)) throw new Error("invalid attribute:" + qName);
        this.attributeNames[qName] = this.length;
        this[this.length++] = {
            qName: qName,
            value: value,
            offset: offset
        };
    },
    length: 0,
    getLocalName: function(i) {
        return this[i].localName;
    },
    getLocator: function(i) {
        return this[i].locator;
    },
    getQName: function(i) {
        return this[i].qName;
    },
    getURI: function(i) {
        return this[i].uri;
    },
    getValue: function(i) {
        return this[i].value;
    }
};
function $0e9e0929092947dd$var$split(source, start) {
    var match;
    var buf = [];
    var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
    reg.lastIndex = start;
    reg.exec(source); //skip <
    while(match = reg.exec(source)){
        buf.push(match);
        if (match[1]) return buf;
    }
}
$0e9e0929092947dd$export$ccbc9f9f018333e9 = $0e9e0929092947dd$var$XMLReader;
$0e9e0929092947dd$export$f9c837a54db411d = $0e9e0929092947dd$var$ParseError;

});




parcelRegister("biuEp", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $dBHwk = parcelRequire("dBHwk");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $2rasJ = parcelRequire("2rasJ");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $2rasJ.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $dBHwk.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $2rasJ.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $2rasJ.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("dBHwk", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
"use strict";

var $LlIML = parcelRequire("LlIML");

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$sentinel = {};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($e5dd19a945a45bbb$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($e5dd19a945a45bbb$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $iBfJ5.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $e5dd19a945a45bbb$var$isArray(obj) && obj.length === 1 ? prefix + "[]" : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + key : "[" + key + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $LlIML();
        valueSideChannel.set($e5dd19a945a45bbb$var$sentinel, sideChannel);
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === "comma" && encodeValuesOnly && $e5dd19a945a45bbb$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[arrayFormat];
    if (opts && "commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var commaRoundTrip = generateArrayPrefix === "comma" && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $LlIML();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("LlIML", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $hXu6F = parcelRequire("hXu6F");

var $e7DLx = parcelRequire("e7DLx");

var $eEkyn = parcelRequire("eEkyn");
var $08e53d4ef2e1f8ef$var$$WeakMap = $1zENl("%WeakMap%", true);
var $08e53d4ef2e1f8ef$var$$Map = $1zENl("%Map%", true);
var $08e53d4ef2e1f8ef$var$$weakMapGet = $hXu6F("WeakMap.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$weakMapSet = $hXu6F("WeakMap.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$weakMapHas = $hXu6F("WeakMap.prototype.has", true);
var $08e53d4ef2e1f8ef$var$$mapGet = $hXu6F("Map.prototype.get", true);
var $08e53d4ef2e1f8ef$var$$mapSet = $hXu6F("Map.prototype.set", true);
var $08e53d4ef2e1f8ef$var$$mapHas = $hXu6F("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ var $08e53d4ef2e1f8ef$var$listGetNode = function(list, key) {
    for(var prev = list, curr; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
var $08e53d4ef2e1f8ef$var$listGet = function(objects, key) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    return node && node.value;
};
var $08e53d4ef2e1f8ef$var$listSet = function(objects, key, value) {
    var node = $08e53d4ef2e1f8ef$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = {
        key: key,
        next: objects.next,
        value: value
    };
};
var $08e53d4ef2e1f8ef$var$listHas = function(objects, key) {
    return !!$08e53d4ef2e1f8ef$var$listGetNode(objects, key);
};
module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $eEkyn("Side channel does not contain " + $e7DLx(key));
        },
        get: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapGet($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapGet($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $08e53d4ef2e1f8ef$var$$weakMapHas($wm, key);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if ($m) return $08e53d4ef2e1f8ef$var$$mapHas($m, key);
            } else {
                if ($o) return $08e53d4ef2e1f8ef$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($08e53d4ef2e1f8ef$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $08e53d4ef2e1f8ef$var$$WeakMap();
                $08e53d4ef2e1f8ef$var$$weakMapSet($wm, key, value);
            } else if ($08e53d4ef2e1f8ef$var$$Map) {
                if (!$m) $m = new $08e53d4ef2e1f8ef$var$$Map();
                $08e53d4ef2e1f8ef$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $08e53d4ef2e1f8ef$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    __proto__: null,
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !($a1b9a4c94d7d9147$var$test instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @typedef {(...args: unknown[]) => unknown} Func */ /** @type {<T extends Func = Func>(fn: T, length: number, loose?: boolean) => T} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});




parcelRegister("e7DLx", function(module, exports) {
var $a48090c7c3dfd2b6$var$hasMap = typeof Map === "function" && Map.prototype;
var $a48090c7c3dfd2b6$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$mapSize = $a48090c7c3dfd2b6$var$hasMap && $a48090c7c3dfd2b6$var$mapSizeDescriptor && typeof $a48090c7c3dfd2b6$var$mapSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$mapSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$mapForEach = $a48090c7c3dfd2b6$var$hasMap && Map.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasSet = typeof Set === "function" && Set.prototype;
var $a48090c7c3dfd2b6$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $a48090c7c3dfd2b6$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $a48090c7c3dfd2b6$var$setSize = $a48090c7c3dfd2b6$var$hasSet && $a48090c7c3dfd2b6$var$setSizeDescriptor && typeof $a48090c7c3dfd2b6$var$setSizeDescriptor.get === "function" ? $a48090c7c3dfd2b6$var$setSizeDescriptor.get : null;
var $a48090c7c3dfd2b6$var$setForEach = $a48090c7c3dfd2b6$var$hasSet && Set.prototype.forEach;
var $a48090c7c3dfd2b6$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $a48090c7c3dfd2b6$var$weakMapHas = $a48090c7c3dfd2b6$var$hasWeakMap ? WeakMap.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $a48090c7c3dfd2b6$var$weakSetHas = $a48090c7c3dfd2b6$var$hasWeakSet ? WeakSet.prototype.has : null;
var $a48090c7c3dfd2b6$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $a48090c7c3dfd2b6$var$weakRefDeref = $a48090c7c3dfd2b6$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $a48090c7c3dfd2b6$var$booleanValueOf = Boolean.prototype.valueOf;
var $a48090c7c3dfd2b6$var$objectToString = Object.prototype.toString;
var $a48090c7c3dfd2b6$var$functionToString = Function.prototype.toString;
var $a48090c7c3dfd2b6$var$$match = String.prototype.match;
var $a48090c7c3dfd2b6$var$$slice = String.prototype.slice;
var $a48090c7c3dfd2b6$var$$replace = String.prototype.replace;
var $a48090c7c3dfd2b6$var$$toUpperCase = String.prototype.toUpperCase;
var $a48090c7c3dfd2b6$var$$toLowerCase = String.prototype.toLowerCase;
var $a48090c7c3dfd2b6$var$$test = RegExp.prototype.test;
var $a48090c7c3dfd2b6$var$$concat = Array.prototype.concat;
var $a48090c7c3dfd2b6$var$$join = Array.prototype.join;
var $a48090c7c3dfd2b6$var$$arrSlice = Array.prototype.slice;
var $a48090c7c3dfd2b6$var$$floor = Math.floor;
var $a48090c7c3dfd2b6$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $a48090c7c3dfd2b6$var$gOPS = Object.getOwnPropertySymbols;
var $a48090c7c3dfd2b6$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $a48090c7c3dfd2b6$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $a48090c7c3dfd2b6$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $a48090c7c3dfd2b6$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $a48090c7c3dfd2b6$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $a48090c7c3dfd2b6$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $a48090c7c3dfd2b6$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $a48090c7c3dfd2b6$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$a48090c7c3dfd2b6$var$$floor(-num) : $a48090c7c3dfd2b6$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $a48090c7c3dfd2b6$var$$slice.call(str, intStr.length + 1);
            return $a48090c7c3dfd2b6$var$$replace.call(intStr, sepRegex, "$&_") + "." + $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $a48090c7c3dfd2b6$var$$replace.call(str, sepRegex, "$&_");
}

var $kjyEk = parcelRequire("kjyEk");
var $a48090c7c3dfd2b6$var$inspectCustom = $kjyEk.custom;
var $a48090c7c3dfd2b6$var$inspectSymbol = $a48090c7c3dfd2b6$var$isSymbol($a48090c7c3dfd2b6$var$inspectCustom) ? $a48090c7c3dfd2b6$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($a48090c7c3dfd2b6$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $a48090c7c3dfd2b6$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($a48090c7c3dfd2b6$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($a48090c7c3dfd2b6$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $a48090c7c3dfd2b6$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $a48090c7c3dfd2b6$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $a48090c7c3dfd2b6$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $a48090c7c3dfd2b6$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($a48090c7c3dfd2b6$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $a48090c7c3dfd2b6$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($a48090c7c3dfd2b6$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var name = $a48090c7c3dfd2b6$var$nameOf(obj);
        var keys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $a48090c7c3dfd2b6$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($a48090c7c3dfd2b6$var$isSymbol(obj)) {
        var symString = $a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $a48090c7c3dfd2b6$var$symToString.call(obj);
        return typeof obj === "object" && !$a48090c7c3dfd2b6$var$hasShammedSymbols ? $a48090c7c3dfd2b6$var$markBoxed(symString) : symString;
    }
    if ($a48090c7c3dfd2b6$var$isElement(obj)) {
        var s = "<" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $a48090c7c3dfd2b6$var$wrapQuotes($a48090c7c3dfd2b6$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $a48090c7c3dfd2b6$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($a48090c7c3dfd2b6$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (indent && !$a48090c7c3dfd2b6$var$singleLineValues(xs)) return "[" + $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) + "]";
        return "[ " + $a48090c7c3dfd2b6$var$$join.call(xs, ", ") + " ]";
    }
    if ($a48090c7c3dfd2b6$var$isError(obj)) {
        var parts = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$a48090c7c3dfd2b6$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $a48090c7c3dfd2b6$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($a48090c7c3dfd2b6$var$inspectSymbol && typeof obj[$a48090c7c3dfd2b6$var$inspectSymbol] === "function" && $kjyEk) return $kjyEk(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($a48090c7c3dfd2b6$var$isMap(obj)) {
        var mapParts = [];
        if ($a48090c7c3dfd2b6$var$mapForEach) $a48090c7c3dfd2b6$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Map", $a48090c7c3dfd2b6$var$mapSize.call(obj), mapParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isSet(obj)) {
        var setParts = [];
        if ($a48090c7c3dfd2b6$var$setForEach) $a48090c7c3dfd2b6$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $a48090c7c3dfd2b6$var$collectionOf("Set", $a48090c7c3dfd2b6$var$setSize.call(obj), setParts, indent);
    }
    if ($a48090c7c3dfd2b6$var$isWeakMap(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakMap");
    if ($a48090c7c3dfd2b6$var$isWeakSet(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakSet");
    if ($a48090c7c3dfd2b6$var$isWeakRef(obj)) return $a48090c7c3dfd2b6$var$weakCollectionOf("WeakRef");
    if ($a48090c7c3dfd2b6$var$isNumber(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(Number(obj)));
    if ($a48090c7c3dfd2b6$var$isBigInt(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect($a48090c7c3dfd2b6$var$bigIntValueOf.call(obj)));
    if ($a48090c7c3dfd2b6$var$isBoolean(obj)) return $a48090c7c3dfd2b6$var$markBoxed($a48090c7c3dfd2b6$var$booleanValueOf.call(obj));
    if ($a48090c7c3dfd2b6$var$isString(obj)) return $a48090c7c3dfd2b6$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$a48090c7c3dfd2b6$var$isDate(obj) && !$a48090c7c3dfd2b6$var$isRegExp(obj)) {
        var ys = $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect);
        var isPlainObject = $a48090c7c3dfd2b6$var$gPO ? $a48090c7c3dfd2b6$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $a48090c7c3dfd2b6$var$toStringTag && Object(obj) === obj && $a48090c7c3dfd2b6$var$toStringTag in obj ? $a48090c7c3dfd2b6$var$$slice.call($a48090c7c3dfd2b6$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $a48090c7c3dfd2b6$var$$join.call($a48090c7c3dfd2b6$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $a48090c7c3dfd2b6$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $a48090c7c3dfd2b6$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $a48090c7c3dfd2b6$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $a48090c7c3dfd2b6$var$quote(s) {
    return $a48090c7c3dfd2b6$var$$replace.call(String(s), /"/g, "&quot;");
}
function $a48090c7c3dfd2b6$var$isArray(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Array]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isDate(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Date]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isRegExp(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object RegExp]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isError(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Error]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isString(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object String]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isNumber(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Number]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
function $a48090c7c3dfd2b6$var$isBoolean(obj) {
    return $a48090c7c3dfd2b6$var$toStr(obj) === "[object Boolean]" && (!$a48090c7c3dfd2b6$var$toStringTag || !(typeof obj === "object" && $a48090c7c3dfd2b6$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $a48090c7c3dfd2b6$var$isSymbol(obj) {
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$symToString) return false;
    try {
        $a48090c7c3dfd2b6$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$a48090c7c3dfd2b6$var$bigIntValueOf) return false;
    try {
        $a48090c7c3dfd2b6$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $a48090c7c3dfd2b6$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $a48090c7c3dfd2b6$var$has(obj, key) {
    return $a48090c7c3dfd2b6$var$hasOwn.call(obj, key);
}
function $a48090c7c3dfd2b6$var$toStr(obj) {
    return $a48090c7c3dfd2b6$var$objectToString.call(obj);
}
function $a48090c7c3dfd2b6$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $a48090c7c3dfd2b6$var$$match.call($a48090c7c3dfd2b6$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $a48090c7c3dfd2b6$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $a48090c7c3dfd2b6$var$isMap(x) {
    if (!$a48090c7c3dfd2b6$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$mapSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakMap(x) {
    if (!$a48090c7c3dfd2b6$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        try {
            $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakRef(x) {
    if (!$a48090c7c3dfd2b6$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isSet(x) {
    if (!$a48090c7c3dfd2b6$var$setSize || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$setSize.call(x);
        try {
            $a48090c7c3dfd2b6$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isWeakSet(x) {
    if (!$a48090c7c3dfd2b6$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $a48090c7c3dfd2b6$var$weakSetHas.call(x, $a48090c7c3dfd2b6$var$weakSetHas);
        try {
            $a48090c7c3dfd2b6$var$weakMapHas.call(x, $a48090c7c3dfd2b6$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $a48090c7c3dfd2b6$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $a48090c7c3dfd2b6$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $a48090c7c3dfd2b6$var$inspectString($a48090c7c3dfd2b6$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $a48090c7c3dfd2b6$var$$replace.call($a48090c7c3dfd2b6$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $a48090c7c3dfd2b6$var$lowbyte);
    return $a48090c7c3dfd2b6$var$wrapQuotes(s, "single", opts);
}
function $a48090c7c3dfd2b6$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $a48090c7c3dfd2b6$var$$toUpperCase.call(n.toString(16));
}
function $a48090c7c3dfd2b6$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $a48090c7c3dfd2b6$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $a48090c7c3dfd2b6$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $a48090c7c3dfd2b6$var$indentedJoin(entries, indent) : $a48090c7c3dfd2b6$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $a48090c7c3dfd2b6$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($a48090c7c3dfd2b6$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $a48090c7c3dfd2b6$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $a48090c7c3dfd2b6$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $a48090c7c3dfd2b6$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $a48090c7c3dfd2b6$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $a48090c7c3dfd2b6$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $a48090c7c3dfd2b6$var$arrObjKeys(obj, inspect) {
    var isArr = $a48090c7c3dfd2b6$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $a48090c7c3dfd2b6$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $a48090c7c3dfd2b6$var$gOPS === "function" ? $a48090c7c3dfd2b6$var$gOPS(obj) : [];
    var symMap;
    if ($a48090c7c3dfd2b6$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$a48090c7c3dfd2b6$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($a48090c7c3dfd2b6$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($a48090c7c3dfd2b6$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $a48090c7c3dfd2b6$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($a48090c7c3dfd2b6$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $d8a7e190fdc9c6e7$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRegister("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        if ($8ec5fc0fdc198ba4$var$has.call(obj, key)) obj[key] = $iBfJ5.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $8ec5fc0fdc198ba4$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $iBfJ5.compact(obj);
};

});



parcelRegister("v6ngW", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("2brbW").then(()=>parcelRequire("5MOo6"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});


parcelRegister("6qlDJ", function(module, exports) {
"use strict";
/*
  This file is a reduced and adapted version of the main lib/internal/per_context/primordials.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/per_context/primordials.js

  Don't try to replace with the original file and keep it up to date with the upstream file.
*/ module.exports = {
    ArrayIsArray (self) {
        return Array.isArray(self);
    },
    ArrayPrototypeIncludes (self, el) {
        return self.includes(el);
    },
    ArrayPrototypeIndexOf (self, el) {
        return self.indexOf(el);
    },
    ArrayPrototypeJoin (self, sep) {
        return self.join(sep);
    },
    ArrayPrototypeMap (self, fn) {
        return self.map(fn);
    },
    ArrayPrototypePop (self, el) {
        return self.pop(el);
    },
    ArrayPrototypePush (self, el) {
        return self.push(el);
    },
    ArrayPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    Error: Error,
    FunctionPrototypeCall (fn, thisArgs, ...args) {
        return fn.call(thisArgs, ...args);
    },
    FunctionPrototypeSymbolHasInstance (self, instance) {
        return Function.prototype[Symbol.hasInstance].call(self, instance);
    },
    MathFloor: Math.floor,
    Number: Number,
    NumberIsInteger: Number.isInteger,
    NumberIsNaN: Number.isNaN,
    NumberMAX_SAFE_INTEGER: Number.MAX_SAFE_INTEGER,
    NumberMIN_SAFE_INTEGER: Number.MIN_SAFE_INTEGER,
    NumberParseInt: Number.parseInt,
    ObjectDefineProperties (self, props) {
        return Object.defineProperties(self, props);
    },
    ObjectDefineProperty (self, name, prop) {
        return Object.defineProperty(self, name, prop);
    },
    ObjectGetOwnPropertyDescriptor (self, name) {
        return Object.getOwnPropertyDescriptor(self, name);
    },
    ObjectKeys (obj) {
        return Object.keys(obj);
    },
    ObjectSetPrototypeOf (target, proto) {
        return Object.setPrototypeOf(target, proto);
    },
    Promise: Promise,
    PromisePrototypeCatch (self, fn) {
        return self.catch(fn);
    },
    PromisePrototypeThen (self, thenFn, catchFn) {
        return self.then(thenFn, catchFn);
    },
    PromiseReject (err) {
        return Promise.reject(err);
    },
    PromiseResolve (val) {
        return Promise.resolve(val);
    },
    ReflectApply: Reflect.apply,
    RegExpPrototypeTest (self, value) {
        return self.test(value);
    },
    SafeSet: Set,
    String: String,
    StringPrototypeSlice (self, start, end) {
        return self.slice(start, end);
    },
    StringPrototypeToLowerCase (self) {
        return self.toLowerCase();
    },
    StringPrototypeToUpperCase (self) {
        return self.toUpperCase();
    },
    StringPrototypeTrim (self) {
        return self.trim();
    },
    Symbol: Symbol,
    SymbolFor: Symbol.for,
    SymbolAsyncIterator: Symbol.asyncIterator,
    SymbolHasInstance: Symbol.hasInstance,
    SymbolIterator: Symbol.iterator,
    SymbolDispose: Symbol.dispose || Symbol("Symbol.dispose"),
    SymbolAsyncDispose: Symbol.asyncDispose || Symbol("Symbol.asyncDispose"),
    TypedArrayPrototypeSet (self, buf, len) {
        return self.set(buf, len);
    },
    Boolean: Boolean,
    Uint8Array: Uint8Array
};

});

parcelRegister("cSbri", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");

var $6qlDJ = parcelRequire("6qlDJ");
var $95f366cd9222c75c$require$kResistStopPropagation = $6qlDJ.kResistStopPropagation;
var $95f366cd9222c75c$require$SymbolDispose = $6qlDJ.SymbolDispose;

const $95f366cd9222c75c$var$AbortSignal = globalThis.AbortSignal || (parcelRequire("bHKGd")).AbortSignal;

const $95f366cd9222c75c$var$AbortController = globalThis.AbortController || (parcelRequire("bHKGd")).AbortController;
const $95f366cd9222c75c$var$AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
const $95f366cd9222c75c$var$Blob = globalThis.Blob || $6ZWSX.Blob;
/* eslint-disable indent */ const $95f366cd9222c75c$var$isBlob = typeof $95f366cd9222c75c$var$Blob !== "undefined" ? function isBlob(b) {
    // eslint-disable-next-line indent
    return b instanceof $95f366cd9222c75c$var$Blob;
} : function isBlob(b) {
    return false;
};
/* eslint-enable indent */ const $95f366cd9222c75c$var$validateAbortSignal = (signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== "object" || !("aborted" in signal))) throw new ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
};
const $95f366cd9222c75c$var$validateFunction = (value, name)=>{
    if (typeof value !== "function") throw new ERR_INVALID_ARG_TYPE(name, "Function", value);
};
// This is a simplified version of AggregateError
class $95f366cd9222c75c$var$AggregateError extends Error {
    constructor(errors){
        if (!Array.isArray(errors)) throw new TypeError(`Expected input to be an Array, got ${typeof errors}`);
        let message = "";
        for(let i = 0; i < errors.length; i++)message += `    ${errors[i].stack}\n`;
        super(message);
        this.name = "AggregateError";
        this.errors = errors;
    }
}

module.exports = {
    AggregateError: $95f366cd9222c75c$var$AggregateError,
    kEmptyObject: Object.freeze({}),
    once (callback) {
        let called = false;
        return function(...args) {
            if (called) return;
            called = true;
            callback.apply(this, args);
        };
    },
    createDeferredPromise: function() {
        let resolve;
        let reject;
        // eslint-disable-next-line promise/param-names
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        return {
            promise: promise,
            resolve: resolve,
            reject: reject
        };
    },
    promisify (fn) {
        return new Promise((resolve, reject)=>{
            fn((err, ...args)=>{
                if (err) return reject(err);
                return resolve(...args);
            });
        });
    },
    debuglog () {
        return function() {};
    },
    format (format, ...args) {
        // Simplified version of https://nodejs.org/api/util.html#utilformatformat-args
        return format.replace(/%([sdifj])/g, function(...[_unused, type]) {
            const replacement = args.shift();
            if (type === "f") return replacement.toFixed(6);
            else if (type === "j") return JSON.stringify(replacement);
            else if (type === "s" && typeof replacement === "object") {
                const ctor = replacement.constructor !== Object ? replacement.constructor.name : "";
                return `${ctor} {}`.trim();
            } else return replacement.toString();
        });
    },
    inspect (value) {
        // Vastly simplified version of https://nodejs.org/api/util.html#utilinspectobject-options
        switch(typeof value){
            case "string":
                if (value.includes("'")) {
                    if (!value.includes('"')) return `"${value}"`;
                    else if (!value.includes("`") && !value.includes("${")) return `\`${value}\``;
                }
                return `'${value}'`;
            case "number":
                if (isNaN(value)) return "NaN";
                else if (Object.is(value, -0)) return String(value);
                return value;
            case "bigint":
                return `${String(value)}n`;
            case "boolean":
            case "undefined":
                return String(value);
            case "object":
                return "{}";
        }
    },
    types: {
        isAsyncFunction (fn) {
            return fn instanceof $95f366cd9222c75c$var$AsyncFunction;
        },
        isArrayBufferView (arr) {
            return ArrayBuffer.isView(arr);
        }
    },
    isBlob: $95f366cd9222c75c$var$isBlob,
    deprecate (fn, message) {
        return fn;
    },
    addAbortListener: (parcelRequire("7etJZ")).addAbortListener || function addAbortListener(signal, listener) {
        if (signal === undefined) throw new ERR_INVALID_ARG_TYPE("signal", "AbortSignal", signal);
        $95f366cd9222c75c$var$validateAbortSignal(signal, "signal");
        $95f366cd9222c75c$var$validateFunction(listener, "listener");
        let removeEventListener;
        if (signal.aborted) queueMicrotask(()=>listener());
        else {
            signal.addEventListener("abort", listener, {
                __proto__: null,
                once: true,
                [$95f366cd9222c75c$require$kResistStopPropagation]: true
            });
            removeEventListener = ()=>{
                signal.removeEventListener("abort", listener);
            };
        }
        return {
            __proto__: null,
            [$95f366cd9222c75c$require$SymbolDispose] () {
                var _removeEventListener;
                (_removeEventListener = removeEventListener) === null || _removeEventListener === undefined ? undefined : _removeEventListener();
            }
        };
    },
    AbortSignalAny: $95f366cd9222c75c$var$AbortSignal.any || function AbortSignalAny(signals) {
        // Fast path if there is only one signal.
        if (signals.length === 1) return signals[0];
        const ac = new $95f366cd9222c75c$var$AbortController();
        const abort = ()=>ac.abort();
        signals.forEach((signal)=>{
            $95f366cd9222c75c$var$validateAbortSignal(signal, "signals");
            signal.addEventListener("abort", abort, {
                once: true
            });
        });
        ac.signal.addEventListener("abort", ()=>{
            signals.forEach((signal)=>signal.removeEventListener("abort", abort));
        }, {
            once: true
        });
        return ac.signal;
    }
};
module.exports.promisify.custom = Symbol.for("nodejs.util.promisify.custom");

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("bHKGd", function(module, exports) {
/*globals self, window */ "use strict";
/*eslint-disable @mysticatea/prettier */ const { AbortController: $8857eb8900fe3da6$var$AbortController, AbortSignal: $8857eb8900fe3da6$var$AbortSignal } = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : /* otherwise */ undefined;
/*eslint-enable @mysticatea/prettier */ module.exports = $8857eb8900fe3da6$var$AbortController;
module.exports.AbortSignal = $8857eb8900fe3da6$var$AbortSignal;
module.exports.default = $8857eb8900fe3da6$var$AbortController;

});

parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3ujhf", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototype inheritance, this class
// prototypically inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $28a3207d54bb93f3$require$ObjectDefineProperties = $6qlDJ.ObjectDefineProperties;
var $28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor = $6qlDJ.ObjectGetOwnPropertyDescriptor;
var $28a3207d54bb93f3$require$ObjectKeys = $6qlDJ.ObjectKeys;
var $28a3207d54bb93f3$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
module.exports = $28a3207d54bb93f3$var$Duplex;

var $6BZaW = parcelRequire("6BZaW");

var $4uosb = parcelRequire("4uosb");
$28a3207d54bb93f3$require$ObjectSetPrototypeOf($28a3207d54bb93f3$var$Duplex.prototype, $6BZaW.prototype);
$28a3207d54bb93f3$require$ObjectSetPrototypeOf($28a3207d54bb93f3$var$Duplex, $6BZaW);
{
    const keys = $28a3207d54bb93f3$require$ObjectKeys($4uosb.prototype);
    // Allow the keys array to be GC'ed.
    for(let i = 0; i < keys.length; i++){
        const method = keys[i];
        if (!$28a3207d54bb93f3$var$Duplex.prototype[method]) $28a3207d54bb93f3$var$Duplex.prototype[method] = $4uosb.prototype[method];
    }
}function $28a3207d54bb93f3$var$Duplex(options) {
    if (!(this instanceof $28a3207d54bb93f3$var$Duplex)) return new $28a3207d54bb93f3$var$Duplex(options);
    $6BZaW.call(this, options);
    $4uosb.call(this, options);
    if (options) {
        this.allowHalfOpen = options.allowHalfOpen !== false;
        if (options.readable === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if (options.writable === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    } else this.allowHalfOpen = true;
}
$28a3207d54bb93f3$require$ObjectDefineProperties($28a3207d54bb93f3$var$Duplex.prototype, {
    writable: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writable")
    },
    writableHighWaterMark: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableHighWaterMark")
    },
    writableObjectMode: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableObjectMode")
    },
    writableBuffer: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableBuffer")
    },
    writableLength: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableLength")
    },
    writableFinished: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableFinished")
    },
    writableCorked: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableCorked")
    },
    writableEnded: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableEnded")
    },
    writableNeedDrain: {
        __proto__: null,
        ...$28a3207d54bb93f3$require$ObjectGetOwnPropertyDescriptor($4uosb.prototype, "writableNeedDrain")
    },
    destroyed: {
        __proto__: null,
        get () {
            if (this._readableState === undefined || this._writableState === undefined) return false;
            return this._readableState.destroyed && this._writableState.destroyed;
        },
        set (value) {
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            if (this._readableState && this._writableState) {
                this._readableState.destroyed = value;
                this._writableState.destroyed = value;
            }
        }
    }
});
let $28a3207d54bb93f3$var$webStreamsAdapters;
// Lazy to avoid circular references
function $28a3207d54bb93f3$var$lazyWebStreams() {
    if ($28a3207d54bb93f3$var$webStreamsAdapters === undefined) $28a3207d54bb93f3$var$webStreamsAdapters = {};
    return $28a3207d54bb93f3$var$webStreamsAdapters;
}
$28a3207d54bb93f3$var$Duplex.fromWeb = function(pair, options) {
    return $28a3207d54bb93f3$var$lazyWebStreams().newStreamDuplexFromReadableWritablePair(pair, options);
};
$28a3207d54bb93f3$var$Duplex.toWeb = function(duplex) {
    return $28a3207d54bb93f3$var$lazyWebStreams().newReadableWritablePairFromDuplex(duplex);
};
let $28a3207d54bb93f3$var$duplexify;

$28a3207d54bb93f3$var$Duplex.from = function(body) {
    if (!$28a3207d54bb93f3$var$duplexify) $28a3207d54bb93f3$var$duplexify = (parcelRequire("dq9MZ"));
    return $28a3207d54bb93f3$var$duplexify(body, "body");
};

});
parcelRegister("6BZaW", function(module, exports) {
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $4d05a6f3c4a3c493$require$ArrayPrototypeIndexOf = $6qlDJ.ArrayPrototypeIndexOf;
var $4d05a6f3c4a3c493$require$NumberIsInteger = $6qlDJ.NumberIsInteger;
var $4d05a6f3c4a3c493$require$NumberIsNaN = $6qlDJ.NumberIsNaN;
var $4d05a6f3c4a3c493$require$NumberParseInt = $6qlDJ.NumberParseInt;
var $4d05a6f3c4a3c493$require$ObjectDefineProperties = $6qlDJ.ObjectDefineProperties;
var $4d05a6f3c4a3c493$require$ObjectKeys = $6qlDJ.ObjectKeys;
var $4d05a6f3c4a3c493$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
var $4d05a6f3c4a3c493$require$Promise = $6qlDJ.Promise;
var $4d05a6f3c4a3c493$require$SafeSet = $6qlDJ.SafeSet;
var $4d05a6f3c4a3c493$require$SymbolAsyncDispose = $6qlDJ.SymbolAsyncDispose;
var $4d05a6f3c4a3c493$require$SymbolAsyncIterator = $6qlDJ.SymbolAsyncIterator;
var $4d05a6f3c4a3c493$require$Symbol = $6qlDJ.Symbol;
module.exports = $4d05a6f3c4a3c493$var$Readable;
$4d05a6f3c4a3c493$var$Readable.ReadableState = $4d05a6f3c4a3c493$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $4d05a6f3c4a3c493$require$EE = $7etJZ.EventEmitter;

var $8uq7s = parcelRequire("8uq7s");
var $4d05a6f3c4a3c493$require$Stream = $8uq7s.Stream;
var $4d05a6f3c4a3c493$require$prependListener = $8uq7s.prependListener;

var $6ZWSX = parcelRequire("6ZWSX");
var $4d05a6f3c4a3c493$require$Buffer = $6ZWSX.Buffer;

var $khx7T = parcelRequire("khx7T");
var $4d05a6f3c4a3c493$require$addAbortSignal = $khx7T.addAbortSignal;

var $52Cjj = parcelRequire("52Cjj");

let $4d05a6f3c4a3c493$var$debug = (parcelRequire("cSbri")).debuglog("stream", (fn)=>{
    $4d05a6f3c4a3c493$var$debug = fn;
});

var $insGM = parcelRequire("insGM");

var $8Pe5V = parcelRequire("8Pe5V");

var $5ZWSH = parcelRequire("5ZWSH");
var $4d05a6f3c4a3c493$require$getHighWaterMark = $5ZWSH.getHighWaterMark;
var $4d05a6f3c4a3c493$require$getDefaultHighWaterMark = $5ZWSH.getDefaultHighWaterMark;

var $PWkkZ = parcelRequire("PWkkZ");
const { aggregateTwoErrors: $4d05a6f3c4a3c493$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $4d05a6f3c4a3c493$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $4d05a6f3c4a3c493$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_OUT_OF_RANGE: $4d05a6f3c4a3c493$var$ERR_OUT_OF_RANGE, ERR_STREAM_PUSH_AFTER_EOF: $4d05a6f3c4a3c493$var$ERR_STREAM_PUSH_AFTER_EOF, ERR_STREAM_UNSHIFT_AFTER_END_EVENT: $4d05a6f3c4a3c493$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT }, AbortError: $4d05a6f3c4a3c493$var$AbortError } = $PWkkZ;

var $6q8Dc = parcelRequire("6q8Dc");
var $4d05a6f3c4a3c493$require$validateObject = $6q8Dc.validateObject;
const $4d05a6f3c4a3c493$var$kPaused = $4d05a6f3c4a3c493$require$Symbol("kPaused");

var $eNRCS = parcelRequire("eNRCS");
var $4d05a6f3c4a3c493$require$StringDecoder = $eNRCS.StringDecoder;

var $9gNIm = parcelRequire("9gNIm");
$4d05a6f3c4a3c493$require$ObjectSetPrototypeOf($4d05a6f3c4a3c493$var$Readable.prototype, $4d05a6f3c4a3c493$require$Stream.prototype);
$4d05a6f3c4a3c493$require$ObjectSetPrototypeOf($4d05a6f3c4a3c493$var$Readable, $4d05a6f3c4a3c493$require$Stream);
const $4d05a6f3c4a3c493$var$nop = ()=>{};
const { errorOrDestroy: $4d05a6f3c4a3c493$var$errorOrDestroy } = $8Pe5V;
const $4d05a6f3c4a3c493$var$kObjectMode = 1;
const $4d05a6f3c4a3c493$var$kEnded = 2;
const $4d05a6f3c4a3c493$var$kEndEmitted = 4;
const $4d05a6f3c4a3c493$var$kReading = 8;
const $4d05a6f3c4a3c493$var$kConstructed = 16;
const $4d05a6f3c4a3c493$var$kSync = 32;
const $4d05a6f3c4a3c493$var$kNeedReadable = 64;
const $4d05a6f3c4a3c493$var$kEmittedReadable = 128;
const $4d05a6f3c4a3c493$var$kReadableListening = 256;
const $4d05a6f3c4a3c493$var$kResumeScheduled = 512;
const $4d05a6f3c4a3c493$var$kErrorEmitted = 1024;
const $4d05a6f3c4a3c493$var$kEmitClose = 2048;
const $4d05a6f3c4a3c493$var$kAutoDestroy = 4096;
const $4d05a6f3c4a3c493$var$kDestroyed = 8192;
const $4d05a6f3c4a3c493$var$kClosed = 16384;
const $4d05a6f3c4a3c493$var$kCloseEmitted = 32768;
const $4d05a6f3c4a3c493$var$kMultiAwaitDrain = 65536;
const $4d05a6f3c4a3c493$var$kReadingMore = 131072;
const $4d05a6f3c4a3c493$var$kDataEmitted = 262144;
// TODO(benjamingr) it is likely slower to do it this way than with free functions
function $4d05a6f3c4a3c493$var$makeBitMapDescriptor(bit) {
    return {
        enumerable: false,
        get () {
            return (this.state & bit) !== 0;
        },
        set (value) {
            if (value) this.state |= bit;
            else this.state &= ~bit;
        }
    };
}
$4d05a6f3c4a3c493$require$ObjectDefineProperties($4d05a6f3c4a3c493$var$ReadableState.prototype, {
    objectMode: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kObjectMode),
    ended: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kEnded),
    endEmitted: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kEndEmitted),
    reading: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kReading),
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    constructed: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kConstructed),
    // A flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    sync: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kSync),
    // Whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    needReadable: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kNeedReadable),
    emittedReadable: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kEmittedReadable),
    readableListening: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kReadableListening),
    resumeScheduled: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kResumeScheduled),
    // True if the error was already emitted and should not be thrown again.
    errorEmitted: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kErrorEmitted),
    emitClose: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kEmitClose),
    autoDestroy: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kAutoDestroy),
    // Has it been destroyed.
    destroyed: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kDestroyed),
    // Indicates whether the stream has finished destroying.
    closed: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kClosed),
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    closeEmitted: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kCloseEmitted),
    multiAwaitDrain: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kMultiAwaitDrain),
    // If true, a maybeReadMore has been scheduled.
    readingMore: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kReadingMore),
    dataEmitted: $4d05a6f3c4a3c493$var$makeBitMapDescriptor($4d05a6f3c4a3c493$var$kDataEmitted)
});

function $4d05a6f3c4a3c493$var$ReadableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof (parcelRequire("3ujhf"));
    // Bit map field to store ReadableState more effciently with 1 bit per field
    // instead of a V8 slot per field.
    this.state = $4d05a6f3c4a3c493$var$kEmitClose | $4d05a6f3c4a3c493$var$kAutoDestroy | $4d05a6f3c4a3c493$var$kConstructed | $4d05a6f3c4a3c493$var$kSync;
    // Object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away.
    if (options && options.objectMode) this.state |= $4d05a6f3c4a3c493$var$kObjectMode;
    if (isDuplex && options && options.readableObjectMode) this.state |= $4d05a6f3c4a3c493$var$kObjectMode;
    // The point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = options ? $4d05a6f3c4a3c493$require$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex) : $4d05a6f3c4a3c493$require$getDefaultHighWaterMark(false);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift().
    this.buffer = new $insGM();
    this.length = 0;
    this.pipes = [];
    this.flowing = null;
    this[$4d05a6f3c4a3c493$var$kPaused] = null;
    // Should close be emitted on destroy. Defaults to true.
    if (options && options.emitClose === false) this.state &= ~$4d05a6f3c4a3c493$var$kEmitClose;
    // Should .destroy() be called after 'end' (and potentially 'finish').
    if (options && options.autoDestroy === false) this.state &= ~$4d05a6f3c4a3c493$var$kAutoDestroy;
    // Indicates whether the stream has errored. When true no further
    // _read calls, 'data' or 'readable' events should occur. This is needed
    // since when autoDestroy is disabled we need a way to tell whether the
    // stream has failed.
    this.errored = null;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || "utf8";
    // Ref the piped dest which we need a drain event on it
    // type: null | Writable | Set<Writable>.
    this.awaitDrainWriters = null;
    this.decoder = null;
    this.encoding = null;
    if (options && options.encoding) {
        this.decoder = new $4d05a6f3c4a3c493$require$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $4d05a6f3c4a3c493$var$Readable(options) {
    if (!(this instanceof $4d05a6f3c4a3c493$var$Readable)) return new $4d05a6f3c4a3c493$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("3ujhf"));
    this._readableState = new $4d05a6f3c4a3c493$var$ReadableState(options, this, isDuplex);
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.construct === "function") this._construct = options.construct;
        if (options.signal && !isDuplex) $4d05a6f3c4a3c493$require$addAbortSignal(options.signal, this);
    }
    $4d05a6f3c4a3c493$require$Stream.call(this, options);
    $8Pe5V.construct(this, ()=>{
        if (this._readableState.needReadable) $4d05a6f3c4a3c493$var$maybeReadMore(this, this._readableState);
    });
}
$4d05a6f3c4a3c493$var$Readable.prototype.destroy = $8Pe5V.destroy;
$4d05a6f3c4a3c493$var$Readable.prototype._undestroy = $8Pe5V.undestroy;
$4d05a6f3c4a3c493$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
$4d05a6f3c4a3c493$var$Readable.prototype[$4d05a6f3c4a3c493$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
$4d05a6f3c4a3c493$var$Readable.prototype[$4d05a6f3c4a3c493$require$SymbolAsyncDispose] = function() {
    let error;
    if (!this.destroyed) {
        error = this.readableEnded ? null : new $4d05a6f3c4a3c493$var$AbortError();
        this.destroy(error);
    }
    return new $4d05a6f3c4a3c493$require$Promise((resolve, reject)=>$52Cjj(this, (err)=>err && err !== error ? reject(err) : resolve(null)));
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$4d05a6f3c4a3c493$var$Readable.prototype.push = function(chunk, encoding) {
    return $4d05a6f3c4a3c493$var$readableAddChunk(this, chunk, encoding, false);
};
// Unshift should *always* be something directly out of read().
$4d05a6f3c4a3c493$var$Readable.prototype.unshift = function(chunk, encoding) {
    return $4d05a6f3c4a3c493$var$readableAddChunk(this, chunk, encoding, true);
};
function $4d05a6f3c4a3c493$var$readableAddChunk(stream, chunk, encoding, addToFront) {
    $4d05a6f3c4a3c493$var$debug("readableAddChunk", chunk);
    const state = stream._readableState;
    let err;
    if ((state.state & $4d05a6f3c4a3c493$var$kObjectMode) === 0) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (state.encoding !== encoding) {
                if (addToFront && state.encoding) // When unshifting, if state.encoding is set, we have to save
                // the string in the BufferList with the state encoding.
                chunk = $4d05a6f3c4a3c493$require$Buffer.from(chunk, encoding).toString(state.encoding);
                else {
                    chunk = $4d05a6f3c4a3c493$require$Buffer.from(chunk, encoding);
                    encoding = "";
                }
            }
        } else if (chunk instanceof $4d05a6f3c4a3c493$require$Buffer) encoding = "";
        else if ($4d05a6f3c4a3c493$require$Stream._isUint8Array(chunk)) {
            chunk = $4d05a6f3c4a3c493$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = "";
        } else if (chunk != null) err = new $4d05a6f3c4a3c493$var$ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], chunk);
    }
    if (err) $4d05a6f3c4a3c493$var$errorOrDestroy(stream, err);
    else if (chunk === null) {
        state.state &= ~$4d05a6f3c4a3c493$var$kReading;
        $4d05a6f3c4a3c493$var$onEofChunk(stream, state);
    } else if ((state.state & $4d05a6f3c4a3c493$var$kObjectMode) !== 0 || chunk && chunk.length > 0) {
        if (addToFront) {
            if ((state.state & $4d05a6f3c4a3c493$var$kEndEmitted) !== 0) $4d05a6f3c4a3c493$var$errorOrDestroy(stream, new $4d05a6f3c4a3c493$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
            else if (state.destroyed || state.errored) return false;
            else $4d05a6f3c4a3c493$var$addChunk(stream, state, chunk, true);
        } else if (state.ended) $4d05a6f3c4a3c493$var$errorOrDestroy(stream, new $4d05a6f3c4a3c493$var$ERR_STREAM_PUSH_AFTER_EOF());
        else if (state.destroyed || state.errored) return false;
        else {
            state.state &= ~$4d05a6f3c4a3c493$var$kReading;
            if (state.decoder && !encoding) {
                chunk = state.decoder.write(chunk);
                if (state.objectMode || chunk.length !== 0) $4d05a6f3c4a3c493$var$addChunk(stream, state, chunk, false);
                else $4d05a6f3c4a3c493$var$maybeReadMore(stream, state);
            } else $4d05a6f3c4a3c493$var$addChunk(stream, state, chunk, false);
        }
    } else if (!addToFront) {
        state.state &= ~$4d05a6f3c4a3c493$var$kReading;
        $4d05a6f3c4a3c493$var$maybeReadMore(stream, state);
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $4d05a6f3c4a3c493$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync && stream.listenerCount("data") > 0) {
        // Use the guard to avoid creating `Set()` repeatedly
        // when we have multiple pipes.
        if ((state.state & $4d05a6f3c4a3c493$var$kMultiAwaitDrain) !== 0) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
        state.dataEmitted = true;
        stream.emit("data", chunk);
    } else {
        // Update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if ((state.state & $4d05a6f3c4a3c493$var$kNeedReadable) !== 0) $4d05a6f3c4a3c493$var$emitReadable(stream);
    }
    $4d05a6f3c4a3c493$var$maybeReadMore(stream, state);
}
$4d05a6f3c4a3c493$var$Readable.prototype.isPaused = function() {
    const state = this._readableState;
    return state[$4d05a6f3c4a3c493$var$kPaused] === true || state.flowing === false;
};
// Backwards compatibility.
$4d05a6f3c4a3c493$var$Readable.prototype.setEncoding = function(enc) {
    const decoder = new $4d05a6f3c4a3c493$require$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8.
    this._readableState.encoding = this._readableState.decoder.encoding;
    const buffer = this._readableState.buffer;
    // Iterate over current buffer to convert already stored Buffers:
    let content = "";
    for (const data of buffer)content += decoder.write(data);
    buffer.clear();
    if (content !== "") buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB.
const $4d05a6f3c4a3c493$var$MAX_HWM = 0x40000000;
function $4d05a6f3c4a3c493$var$computeNewHighWaterMark(n) {
    if (n > $4d05a6f3c4a3c493$var$MAX_HWM) throw new $4d05a6f3c4a3c493$var$ERR_OUT_OF_RANGE("size", "<= 1GiB", n);
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts.
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4d05a6f3c4a3c493$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if ((state.state & $4d05a6f3c4a3c493$var$kObjectMode) !== 0) return 1;
    if ($4d05a6f3c4a3c493$require$NumberIsNaN(n)) {
        // Only flow one buffer at a time.
        if (state.flowing && state.length) return state.buffer.first().length;
        return state.length;
    }
    if (n <= state.length) return n;
    return state.ended ? state.length : 0;
}
// You can override either this method, or the async _read(n) below.
$4d05a6f3c4a3c493$var$Readable.prototype.read = function(n) {
    $4d05a6f3c4a3c493$var$debug("read", n);
    // Same as parseInt(undefined, 10), however V8 7.3 performance regressed
    // in this scenario, so we are doing it manually.
    if (n === undefined) n = NaN;
    else if (!$4d05a6f3c4a3c493$require$NumberIsInteger(n)) n = $4d05a6f3c4a3c493$require$NumberParseInt(n, 10);
    const state = this._readableState;
    const nOrig = n;
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $4d05a6f3c4a3c493$var$computeNewHighWaterMark(n);
    if (n !== 0) state.state &= ~$4d05a6f3c4a3c493$var$kEmittedReadable;
    // If we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $4d05a6f3c4a3c493$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $4d05a6f3c4a3c493$var$endReadable(this);
        else $4d05a6f3c4a3c493$var$emitReadable(this);
        return null;
    }
    n = $4d05a6f3c4a3c493$var$howMuchToRead(n, state);
    // If we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $4d05a6f3c4a3c493$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    let doRead = (state.state & $4d05a6f3c4a3c493$var$kNeedReadable) !== 0;
    $4d05a6f3c4a3c493$var$debug("need readable", doRead);
    // If we currently have less than the highWaterMark, then also read some.
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $4d05a6f3c4a3c493$var$debug("length less than watermark", doRead);
    }
    // However, if we've ended, then there's no point, if we're already
    // reading, then it's unnecessary, if we're constructing we have to wait,
    // and if we're destroyed or errored, then it's not allowed,
    if (state.ended || state.reading || state.destroyed || state.errored || !state.constructed) {
        doRead = false;
        $4d05a6f3c4a3c493$var$debug("reading, ended or constructing", doRead);
    } else if (doRead) {
        $4d05a6f3c4a3c493$var$debug("do read");
        state.state |= $4d05a6f3c4a3c493$var$kReading | $4d05a6f3c4a3c493$var$kSync;
        // If the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.state |= $4d05a6f3c4a3c493$var$kNeedReadable;
        // Call internal read method
        try {
            this._read(state.highWaterMark);
        } catch (err) {
            $4d05a6f3c4a3c493$var$errorOrDestroy(this, err);
        }
        state.state &= ~$4d05a6f3c4a3c493$var$kSync;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $4d05a6f3c4a3c493$var$howMuchToRead(nOrig, state);
    }
    let ret;
    if (n > 0) ret = $4d05a6f3c4a3c493$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        if (state.multiAwaitDrain) state.awaitDrainWriters.clear();
        else state.awaitDrainWriters = null;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $4d05a6f3c4a3c493$var$endReadable(this);
    }
    if (ret !== null && !state.errorEmitted && !state.closeEmitted) {
        state.dataEmitted = true;
        this.emit("data", ret);
    }
    return ret;
};
function $4d05a6f3c4a3c493$var$onEofChunk(stream, state) {
    $4d05a6f3c4a3c493$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        const chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // If we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call.
    $4d05a6f3c4a3c493$var$emitReadable(stream);
    else {
        // Emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        state.emittedReadable = true;
        // We have to emit readable now that we are EOF. Modules
        // in the ecosystem (e.g. dicer) rely on this event being sync.
        $4d05a6f3c4a3c493$var$emitReadable_(stream);
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $4d05a6f3c4a3c493$var$emitReadable(stream) {
    const state = stream._readableState;
    $4d05a6f3c4a3c493$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $4d05a6f3c4a3c493$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($4d05a6f3c4a3c493$var$emitReadable_, stream);
    }
}
function $4d05a6f3c4a3c493$var$emitReadable_(stream) {
    const state = stream._readableState;
    $4d05a6f3c4a3c493$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && !state.errored && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if:
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $4d05a6f3c4a3c493$var$flow(stream);
}
// At this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $4d05a6f3c4a3c493$var$maybeReadMore(stream, state) {
    if (!state.readingMore && state.constructed) {
        state.readingMore = true;
        $hPtJY.nextTick($4d05a6f3c4a3c493$var$maybeReadMore_, stream, state);
    }
}
function $4d05a6f3c4a3c493$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        const len = state.length;
        $4d05a6f3c4a3c493$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// Abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$4d05a6f3c4a3c493$var$Readable.prototype._read = function(n) {
    throw new $4d05a6f3c4a3c493$var$ERR_METHOD_NOT_IMPLEMENTED("_read()");
};
$4d05a6f3c4a3c493$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    const src = this;
    const state = this._readableState;
    if (state.pipes.length === 1) {
        if (!state.multiAwaitDrain) {
            state.multiAwaitDrain = true;
            state.awaitDrainWriters = new $4d05a6f3c4a3c493$require$SafeSet(state.awaitDrainWriters ? [
                state.awaitDrainWriters
            ] : []);
        }
    }
    state.pipes.push(dest);
    $4d05a6f3c4a3c493$var$debug("pipe count=%d opts=%j", state.pipes.length, pipeOpts);
    const doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    const endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $4d05a6f3c4a3c493$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $4d05a6f3c4a3c493$var$debug("onend");
        dest.end();
    }
    let ondrain;
    let cleanedUp = false;
    function cleanup() {
        $4d05a6f3c4a3c493$var$debug("cleanup");
        // Cleanup event handlers once the pipe is broken.
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        if (ondrain) dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // If the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (ondrain && state.awaitDrainWriters && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    function pause() {
        // If the user unpiped during `dest.write()`, it is possible
        // to get stuck in a permanently paused state if that write
        // also returned false.
        // => Check whether `dest` is still a piping destination.
        if (!cleanedUp) {
            if (state.pipes.length === 1 && state.pipes[0] === dest) {
                $4d05a6f3c4a3c493$var$debug("false write response, pause", 0);
                state.awaitDrainWriters = dest;
                state.multiAwaitDrain = false;
            } else if (state.pipes.length > 1 && state.pipes.includes(dest)) {
                $4d05a6f3c4a3c493$var$debug("false write response, pause", state.awaitDrainWriters.size);
                state.awaitDrainWriters.add(dest);
            }
            src.pause();
        }
        if (!ondrain) {
            // When the dest drains, it reduces the awaitDrain counter
            // on the source.  This would be more elegant with a .once()
            // handler in flow(), but adding and removing repeatedly is
            // too slow.
            ondrain = $4d05a6f3c4a3c493$var$pipeOnDrain(src, dest);
            dest.on("drain", ondrain);
        }
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $4d05a6f3c4a3c493$var$debug("ondata");
        const ret = dest.write(chunk);
        $4d05a6f3c4a3c493$var$debug("dest.write", ret);
        if (ret === false) pause();
    }
    // If the dest has an error, then stop piping into it.
    // However, don't suppress the throwing behavior for this.
    function onerror(er) {
        $4d05a6f3c4a3c493$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if (dest.listenerCount("error") === 0) {
            const s = dest._writableState || dest._readableState;
            if (s && !s.errorEmitted) // User incorrectly emitted 'error' directly on the stream.
            $4d05a6f3c4a3c493$var$errorOrDestroy(dest, er);
            else dest.emit("error", er);
        }
    }
    // Make sure our error handler is attached before userland ones.
    $4d05a6f3c4a3c493$require$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $4d05a6f3c4a3c493$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $4d05a6f3c4a3c493$var$debug("unpipe");
        src.unpipe(dest);
    }
    // Tell the dest that it's being piped to.
    dest.emit("pipe", src);
    // Start the flow if it hasn't been started already.
    if (dest.writableNeedDrain === true) pause();
    else if (!state.flowing) {
        $4d05a6f3c4a3c493$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $4d05a6f3c4a3c493$var$pipeOnDrain(src, dest) {
    return function pipeOnDrainFunctionResult() {
        const state = src._readableState;
        // `ondrain` will call directly,
        // `this` maybe not a reference to dest,
        // so we use the real dest here.
        if (state.awaitDrainWriters === dest) {
            $4d05a6f3c4a3c493$var$debug("pipeOnDrain", 1);
            state.awaitDrainWriters = null;
        } else if (state.multiAwaitDrain) {
            $4d05a6f3c4a3c493$var$debug("pipeOnDrain", state.awaitDrainWriters.size);
            state.awaitDrainWriters.delete(dest);
        }
        if ((!state.awaitDrainWriters || state.awaitDrainWriters.size === 0) && src.listenerCount("data")) src.resume();
    };
}
$4d05a6f3c4a3c493$var$Readable.prototype.unpipe = function(dest) {
    const state = this._readableState;
    const unpipeInfo = {
        hasUnpiped: false
    };
    // If we're not piping anywhere, then do nothing.
    if (state.pipes.length === 0) return this;
    if (!dest) {
        // remove all.
        const dests = state.pipes;
        state.pipes = [];
        this.pause();
        for(let i = 0; i < dests.length; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // Try to find the right one.
    const index = $4d05a6f3c4a3c493$require$ArrayPrototypeIndexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    if (state.pipes.length === 0) this.pause();
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// Set up data events if they are asked for
// Ensure readable listeners eventually get something.
$4d05a6f3c4a3c493$var$Readable.prototype.on = function(ev, fn) {
    const res = $4d05a6f3c4a3c493$require$Stream.prototype.on.call(this, ev, fn);
    const state = this._readableState;
    if (ev === "data") {
        // Update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused.
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $4d05a6f3c4a3c493$var$debug("on readable", state.length, state.reading);
            if (state.length) $4d05a6f3c4a3c493$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($4d05a6f3c4a3c493$var$nReadingNextTick, this);
        }
    }
    return res;
};
$4d05a6f3c4a3c493$var$Readable.prototype.addListener = $4d05a6f3c4a3c493$var$Readable.prototype.on;
$4d05a6f3c4a3c493$var$Readable.prototype.removeListener = function(ev, fn) {
    const res = $4d05a6f3c4a3c493$require$Stream.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($4d05a6f3c4a3c493$var$updateReadableListening, this);
    return res;
};
$4d05a6f3c4a3c493$var$Readable.prototype.off = $4d05a6f3c4a3c493$var$Readable.prototype.removeListener;
$4d05a6f3c4a3c493$var$Readable.prototype.removeAllListeners = function(ev) {
    const res = $4d05a6f3c4a3c493$require$Stream.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($4d05a6f3c4a3c493$var$updateReadableListening, this);
    return res;
};
function $4d05a6f3c4a3c493$var$updateReadableListening(self) {
    const state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && state[$4d05a6f3c4a3c493$var$kPaused] === false) // Flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self.listenerCount("data") > 0) self.resume();
    else if (!state.readableListening) state.flowing = null;
}
function $4d05a6f3c4a3c493$var$nReadingNextTick(self) {
    $4d05a6f3c4a3c493$var$debug("readable nexttick read 0");
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$4d05a6f3c4a3c493$var$Readable.prototype.resume = function() {
    const state = this._readableState;
    if (!state.flowing) {
        $4d05a6f3c4a3c493$var$debug("resume");
        // We flow only if there is no one listening
        // for readable, but we still have to call
        // resume().
        state.flowing = !state.readableListening;
        $4d05a6f3c4a3c493$var$resume(this, state);
    }
    state[$4d05a6f3c4a3c493$var$kPaused] = false;
    return this;
};
function $4d05a6f3c4a3c493$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($4d05a6f3c4a3c493$var$resume_, stream, state);
    }
}
function $4d05a6f3c4a3c493$var$resume_(stream, state) {
    $4d05a6f3c4a3c493$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $4d05a6f3c4a3c493$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$4d05a6f3c4a3c493$var$Readable.prototype.pause = function() {
    $4d05a6f3c4a3c493$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $4d05a6f3c4a3c493$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState[$4d05a6f3c4a3c493$var$kPaused] = true;
    return this;
};
function $4d05a6f3c4a3c493$var$flow(stream) {
    const state = stream._readableState;
    $4d05a6f3c4a3c493$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// Wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$4d05a6f3c4a3c493$var$Readable.prototype.wrap = function(stream) {
    let paused = false;
    // TODO (ronag): Should this.destroy(err) emit
    // 'error' on the wrapped stream? Would require
    // a static factory method, e.g. Readable.wrap(stream).
    stream.on("data", (chunk)=>{
        if (!this.push(chunk) && stream.pause) {
            paused = true;
            stream.pause();
        }
    });
    stream.on("end", ()=>{
        this.push(null);
    });
    stream.on("error", (err)=>{
        $4d05a6f3c4a3c493$var$errorOrDestroy(this, err);
    });
    stream.on("close", ()=>{
        this.destroy();
    });
    stream.on("destroy", ()=>{
        this.destroy();
    });
    this._read = ()=>{
        if (paused && stream.resume) {
            paused = false;
            stream.resume();
        }
    };
    // Proxy all the other methods. Important when wrapping filters and duplexes.
    const streamKeys = $4d05a6f3c4a3c493$require$ObjectKeys(stream);
    for(let j = 1; j < streamKeys.length; j++){
        const i = streamKeys[j];
        if (this[i] === undefined && typeof stream[i] === "function") this[i] = stream[i].bind(stream);
    }
    return this;
};
$4d05a6f3c4a3c493$var$Readable.prototype[$4d05a6f3c4a3c493$require$SymbolAsyncIterator] = function() {
    return $4d05a6f3c4a3c493$var$streamToAsyncIterator(this);
};
$4d05a6f3c4a3c493$var$Readable.prototype.iterator = function(options) {
    if (options !== undefined) $4d05a6f3c4a3c493$require$validateObject(options, "options");
    return $4d05a6f3c4a3c493$var$streamToAsyncIterator(this, options);
};
function $4d05a6f3c4a3c493$var$streamToAsyncIterator(stream, options) {
    if (typeof stream.read !== "function") stream = $4d05a6f3c4a3c493$var$Readable.wrap(stream, {
        objectMode: true
    });
    const iter = $4d05a6f3c4a3c493$var$createAsyncIterator(stream, options);
    iter.stream = stream;
    return iter;
}
async function* $4d05a6f3c4a3c493$var$createAsyncIterator(stream, options) {
    let callback = $4d05a6f3c4a3c493$var$nop;
    function next(resolve) {
        if (this === stream) {
            callback();
            callback = $4d05a6f3c4a3c493$var$nop;
        } else callback = resolve;
    }
    stream.on("readable", next);
    let error;
    const cleanup = $52Cjj(stream, {
        writable: false
    }, (err)=>{
        error = err ? $4d05a6f3c4a3c493$var$aggregateTwoErrors(error, err) : null;
        callback();
        callback = $4d05a6f3c4a3c493$var$nop;
    });
    try {
        while(true){
            const chunk = stream.destroyed ? null : stream.read();
            if (chunk !== null) yield chunk;
            else if (error) throw error;
            else if (error === null) return;
            else await new $4d05a6f3c4a3c493$require$Promise(next);
        }
    } catch (err) {
        error = $4d05a6f3c4a3c493$var$aggregateTwoErrors(error, err);
        throw error;
    } finally{
        if ((error || (options === null || options === undefined ? undefined : options.destroyOnReturn) !== false) && (error === undefined || stream._readableState.autoDestroy)) $8Pe5V.destroyer(stream, null);
        else {
            stream.off("readable", next);
            cleanup();
        }
    }
}
// Making it explicit these properties are not enumerable
// because otherwise some prototype manipulation in
// userland will fail.
$4d05a6f3c4a3c493$require$ObjectDefineProperties($4d05a6f3c4a3c493$var$Readable.prototype, {
    readable: {
        __proto__: null,
        get () {
            const r = this._readableState;
            // r.readable === false means that this is part of a Duplex stream
            // where the readable side was disabled upon construction.
            // Compat. The user might manually disable readable side through
            // deprecated setter.
            return !!r && r.readable !== false && !r.destroyed && !r.errorEmitted && !r.endEmitted;
        },
        set (val) {
            // Backwards compat.
            if (this._readableState) this._readableState.readable = !!val;
        }
    },
    readableDidRead: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.dataEmitted;
        }
    },
    readableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._readableState.readable !== false && (this._readableState.destroyed || this._readableState.errored) && !this._readableState.endEmitted);
        }
    },
    readableHighWaterMark: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.highWaterMark;
        }
    },
    readableBuffer: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState && this._readableState.buffer;
        }
    },
    readableFlowing: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return this._readableState.flowing;
        },
        set: function(state) {
            if (this._readableState) this._readableState.flowing = state;
        }
    },
    readableLength: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState.length;
        }
    },
    readableObjectMode: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.objectMode : false;
        }
    },
    readableEncoding: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.encoding : null;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.errored : null;
        }
    },
    closed: {
        __proto__: null,
        get () {
            return this._readableState ? this._readableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.destroyed : false;
        },
        set (value) {
            // We ignore the value if the stream
            // has not been initialized yet.
            if (!this._readableState) return;
            // Backward compatibility, the user is explicitly
            // managing destroyed.
            this._readableState.destroyed = value;
        }
    },
    readableEnded: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._readableState ? this._readableState.endEmitted : false;
        }
    }
});
$4d05a6f3c4a3c493$require$ObjectDefineProperties($4d05a6f3c4a3c493$var$ReadableState.prototype, {
    // Legacy getter for `pipesCount`.
    pipesCount: {
        __proto__: null,
        get () {
            return this.pipes.length;
        }
    },
    // Legacy property for `paused`.
    paused: {
        __proto__: null,
        get () {
            return this[$4d05a6f3c4a3c493$var$kPaused] !== false;
        },
        set (value) {
            this[$4d05a6f3c4a3c493$var$kPaused] = !!value;
        }
    }
});
// Exposed for testing purposes only.
$4d05a6f3c4a3c493$var$Readable._fromList = $4d05a6f3c4a3c493$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $4d05a6f3c4a3c493$var$fromList(n, state) {
    // nothing buffered.
    if (state.length === 0) return null;
    let ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // Read it all, truncate the list.
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list.
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $4d05a6f3c4a3c493$var$endReadable(stream) {
    const state = stream._readableState;
    $4d05a6f3c4a3c493$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($4d05a6f3c4a3c493$var$endReadableNT, state, stream);
    }
}
function $4d05a6f3c4a3c493$var$endReadableNT(state, stream) {
    $4d05a6f3c4a3c493$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.errored && !state.closeEmitted && !state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.emit("end");
        if (stream.writable && stream.allowHalfOpen === false) $hPtJY.nextTick($4d05a6f3c4a3c493$var$endWritableNT, stream);
        else if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well.
            const wState = stream._writableState;
            const autoDestroy = !wState || wState.autoDestroy && // We don't expect the writable to ever 'finish'
            // if writable is explicitly set to false.
            (wState.finished || wState.writable === false);
            if (autoDestroy) stream.destroy();
        }
    }
}
function $4d05a6f3c4a3c493$var$endWritableNT(stream) {
    const writable = stream.writable && !stream.writableEnded && !stream.destroyed;
    if (writable) stream.end();
}
$4d05a6f3c4a3c493$var$Readable.from = function(iterable, opts) {
    return $9gNIm($4d05a6f3c4a3c493$var$Readable, iterable, opts);
};
let $4d05a6f3c4a3c493$var$webStreamsAdapters;
// Lazy to avoid circular references
function $4d05a6f3c4a3c493$var$lazyWebStreams() {
    if ($4d05a6f3c4a3c493$var$webStreamsAdapters === undefined) $4d05a6f3c4a3c493$var$webStreamsAdapters = {};
    return $4d05a6f3c4a3c493$var$webStreamsAdapters;
}
$4d05a6f3c4a3c493$var$Readable.fromWeb = function(readableStream, options) {
    return $4d05a6f3c4a3c493$var$lazyWebStreams().newStreamReadableFromReadableStream(readableStream, options);
};
$4d05a6f3c4a3c493$var$Readable.toWeb = function(streamReadable, options) {
    return $4d05a6f3c4a3c493$var$lazyWebStreams().newReadableStreamFromStreamReadable(streamReadable, options);
};
$4d05a6f3c4a3c493$var$Readable.wrap = function(src, options) {
    var _ref, _src$readableObjectMo;
    return new $4d05a6f3c4a3c493$var$Readable({
        objectMode: (_ref = (_src$readableObjectMo = src.readableObjectMode) !== null && _src$readableObjectMo !== undefined ? _src$readableObjectMo : src.objectMode) !== null && _ref !== undefined ? _ref : true,
        ...options,
        destroy (err, callback) {
            $8Pe5V.destroyer(src, err);
            callback(err);
        }
    }).wrap(src);
};

});
parcelRegister("8uq7s", function(module, exports) {
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $62e562ccc894494e$require$ArrayIsArray = $6qlDJ.ArrayIsArray;
var $62e562ccc894494e$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;

var $7etJZ = parcelRequire("7etJZ");
var $62e562ccc894494e$require$EE = $7etJZ.EventEmitter;
function $62e562ccc894494e$var$Stream(opts) {
    $62e562ccc894494e$require$EE.call(this, opts);
}
$62e562ccc894494e$require$ObjectSetPrototypeOf($62e562ccc894494e$var$Stream.prototype, $62e562ccc894494e$require$EE.prototype);
$62e562ccc894494e$require$ObjectSetPrototypeOf($62e562ccc894494e$var$Stream, $62e562ccc894494e$require$EE);
$62e562ccc894494e$var$Stream.prototype.pipe = function(dest, options) {
    const source = this;
    function ondata(chunk) {
        if (dest.writable && dest.write(chunk) === false && source.pause) source.pause();
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    let didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // Don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($62e562ccc894494e$require$EE.listenerCount(this, "error") === 0) this.emit("error", er);
    }
    $62e562ccc894494e$var$prependListener(source, "error", onerror);
    $62e562ccc894494e$var$prependListener(dest, "error", onerror);
    // Remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
function $62e562ccc894494e$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($62e562ccc894494e$require$ArrayIsArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}
module.exports = {
    Stream: $62e562ccc894494e$var$Stream,
    prependListener: $62e562ccc894494e$var$prependListener
};

});

parcelRegister("khx7T", function(module, exports) {

$parcel$export(module.exports, "addAbortSignal", () => $03cf781e6c37f723$export$e2db56ee53255a0, (v) => $03cf781e6c37f723$export$e2db56ee53255a0 = v);
$parcel$export(module.exports, "addAbortSignalNoValidate", () => $03cf781e6c37f723$export$11956e9313f43de0, (v) => $03cf781e6c37f723$export$11956e9313f43de0 = v);
var $03cf781e6c37f723$export$e2db56ee53255a0;
var $03cf781e6c37f723$export$11956e9313f43de0;
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $03cf781e6c37f723$require$SymbolDispose = $6qlDJ.SymbolDispose;

var $PWkkZ = parcelRequire("PWkkZ");
var $03cf781e6c37f723$require$AbortError = $PWkkZ.AbortError;
var $03cf781e6c37f723$require$codes = $PWkkZ.codes;

var $dEd8A = parcelRequire("dEd8A");
var $03cf781e6c37f723$require$isNodeStream = $dEd8A.isNodeStream;
var $03cf781e6c37f723$require$isWebStream = $dEd8A.isWebStream;
var $03cf781e6c37f723$require$kControllerErrorFunction = $dEd8A.kControllerErrorFunction;

var $52Cjj = parcelRequire("52Cjj");
const { ERR_INVALID_ARG_TYPE: $03cf781e6c37f723$var$ERR_INVALID_ARG_TYPE } = $03cf781e6c37f723$require$codes;
let $03cf781e6c37f723$var$addAbortListener;
// This method is inlined here for readable-stream
// It also does not allow for signal to not exist on the stream
// https://github.com/nodejs/node/pull/36061#discussion_r533718029
const $03cf781e6c37f723$var$validateAbortSignal = (signal, name)=>{
    if (typeof signal !== "object" || !("aborted" in signal)) throw new $03cf781e6c37f723$var$ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
};
$03cf781e6c37f723$export$e2db56ee53255a0 = function addAbortSignal(signal, stream) {
    $03cf781e6c37f723$var$validateAbortSignal(signal, "signal");
    if (!$03cf781e6c37f723$require$isNodeStream(stream) && !$03cf781e6c37f723$require$isWebStream(stream)) throw new $03cf781e6c37f723$var$ERR_INVALID_ARG_TYPE("stream", [
        "ReadableStream",
        "WritableStream",
        "Stream"
    ], stream);
    return $03cf781e6c37f723$export$11956e9313f43de0(signal, stream);
};

$03cf781e6c37f723$export$11956e9313f43de0 = function(signal, stream) {
    if (typeof signal !== "object" || !("aborted" in signal)) return stream;
    const onAbort = $03cf781e6c37f723$require$isNodeStream(stream) ? ()=>{
        stream.destroy(new $03cf781e6c37f723$require$AbortError(undefined, {
            cause: signal.reason
        }));
    } : ()=>{
        stream[$03cf781e6c37f723$require$kControllerErrorFunction](new $03cf781e6c37f723$require$AbortError(undefined, {
            cause: signal.reason
        }));
    };
    if (signal.aborted) onAbort();
    else {
        $03cf781e6c37f723$var$addAbortListener = $03cf781e6c37f723$var$addAbortListener || (parcelRequire("cSbri")).addAbortListener;
        const disposable = $03cf781e6c37f723$var$addAbortListener(signal, onAbort);
        $52Cjj(stream, disposable[$03cf781e6c37f723$require$SymbolDispose]);
    }
    return stream;
};

});
parcelRegister("PWkkZ", function(module, exports) {
"use strict";

var $cSbri = parcelRequire("cSbri");
var $09c2021114adf118$require$format = $cSbri.format;
var $09c2021114adf118$require$inspect = $cSbri.inspect;
var $09c2021114adf118$require$CustomAggregateError = $cSbri.AggregateError;
/*
  This file is a reduced and adapted version of the main lib/internal/errors.js file defined at

  https://github.com/nodejs/node/blob/master/lib/internal/errors.js

  Don't try to replace with the original file and keep it up to date (starting from E(...) definitions)
  with the upstream file.
*/ const $09c2021114adf118$var$AggregateError = globalThis.AggregateError || $09c2021114adf118$require$CustomAggregateError;
const $09c2021114adf118$var$kIsNodeError = Symbol("kIsNodeError");
const $09c2021114adf118$var$kTypes = [
    "string",
    "function",
    "number",
    "object",
    // Accept 'Function' and 'Object' as alternative to the lower cased version.
    "Function",
    "Object",
    "boolean",
    "bigint",
    "symbol"
];
const $09c2021114adf118$var$classRegExp = /^([A-Z][a-z0-9]*)+$/;
const $09c2021114adf118$var$nodeInternalPrefix = "__node_internal_";
const $09c2021114adf118$var$codes = {};
function $09c2021114adf118$var$assert(value, message) {
    if (!value) throw new $09c2021114adf118$var$codes.ERR_INTERNAL_ASSERTION(message);
}
// Only use this for integers! Decimal numbers do not work with this function.
function $09c2021114adf118$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
function $09c2021114adf118$var$getMessage(key, msg, args) {
    if (typeof msg === "function") {
        $09c2021114adf118$var$assert(msg.length <= args.length, // Default options do not count.
        `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${msg.length}).`);
        return msg(...args);
    }
    const expectedLength = (msg.match(/%[dfijoOs]/g) || []).length;
    $09c2021114adf118$var$assert(expectedLength === args.length, `Code: ${key}; The provided arguments length (${args.length}) does not match the required ones (${expectedLength}).`);
    if (args.length === 0) return msg;
    return $09c2021114adf118$require$format(msg, ...args);
}
function $09c2021114adf118$var$E(code, message, Base) {
    if (!Base) Base = Error;
    class NodeError extends Base {
        constructor(...args){
            super($09c2021114adf118$var$getMessage(code, message, args));
        }
        toString() {
            return `${this.name} [${code}]: ${this.message}`;
        }
    }
    Object.defineProperties(NodeError.prototype, {
        name: {
            value: Base.name,
            writable: true,
            enumerable: false,
            configurable: true
        },
        toString: {
            value () {
                return `${this.name} [${code}]: ${this.message}`;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    NodeError.prototype.code = code;
    NodeError.prototype[$09c2021114adf118$var$kIsNodeError] = true;
    $09c2021114adf118$var$codes[code] = NodeError;
}
function $09c2021114adf118$var$hideStackFrames(fn) {
    // We rename the functions that will be hidden to cut off the stacktrace
    // at the outermost one
    const hidden = $09c2021114adf118$var$nodeInternalPrefix + fn.name;
    Object.defineProperty(fn, "name", {
        value: hidden
    });
    return fn;
}
function $09c2021114adf118$var$aggregateTwoErrors(innerError, outerError) {
    if (innerError && outerError && innerError !== outerError) {
        if (Array.isArray(outerError.errors)) {
            // If `outerError` is already an `AggregateError`.
            outerError.errors.push(innerError);
            return outerError;
        }
        const err = new $09c2021114adf118$var$AggregateError([
            outerError,
            innerError
        ], outerError.message);
        err.code = outerError.code;
        return err;
    }
    return innerError || outerError;
}
class $09c2021114adf118$var$AbortError extends Error {
    constructor(message = "The operation was aborted", options){
        if (options !== undefined && typeof options !== "object") throw new $09c2021114adf118$var$codes.ERR_INVALID_ARG_TYPE("options", "Object", options);
        super(message, options);
        this.code = "ABORT_ERR";
        this.name = "AbortError";
    }
}
$09c2021114adf118$var$E("ERR_ASSERTION", "%s", Error);
$09c2021114adf118$var$E("ERR_INVALID_ARG_TYPE", (name, expected, actual)=>{
    $09c2021114adf118$var$assert(typeof name === "string", "'name' must be a string");
    if (!Array.isArray(expected)) expected = [
        expected
    ];
    let msg = "The ";
    if (name.endsWith(" argument")) // For cases like 'first argument'
    msg += `${name} `;
    else msg += `"${name}" ${name.includes(".") ? "property" : "argument"} `;
    msg += "must be ";
    const types = [];
    const instances = [];
    const other = [];
    for (const value of expected){
        $09c2021114adf118$var$assert(typeof value === "string", "All expected entries have to be of type string");
        if ($09c2021114adf118$var$kTypes.includes(value)) types.push(value.toLowerCase());
        else if ($09c2021114adf118$var$classRegExp.test(value)) instances.push(value);
        else {
            $09c2021114adf118$var$assert(value !== "object", 'The value "object" should be written as "Object"');
            other.push(value);
        }
    }
    // Special handle `object` in case other instances are allowed to outline
    // the differences between each other.
    if (instances.length > 0) {
        const pos = types.indexOf("object");
        if (pos !== -1) {
            types.splice(types, pos, 1);
            instances.push("Object");
        }
    }
    if (types.length > 0) {
        switch(types.length){
            case 1:
                msg += `of type ${types[0]}`;
                break;
            case 2:
                msg += `one of type ${types[0]} or ${types[1]}`;
                break;
            default:
                {
                    const last = types.pop();
                    msg += `one of type ${types.join(", ")}, or ${last}`;
                }
        }
        if (instances.length > 0 || other.length > 0) msg += " or ";
    }
    if (instances.length > 0) {
        switch(instances.length){
            case 1:
                msg += `an instance of ${instances[0]}`;
                break;
            case 2:
                msg += `an instance of ${instances[0]} or ${instances[1]}`;
                break;
            default:
                {
                    const last = instances.pop();
                    msg += `an instance of ${instances.join(", ")}, or ${last}`;
                }
        }
        if (other.length > 0) msg += " or ";
    }
    switch(other.length){
        case 0:
            break;
        case 1:
            if (other[0].toLowerCase() !== other[0]) msg += "an ";
            msg += `${other[0]}`;
            break;
        case 2:
            msg += `one of ${other[0]} or ${other[1]}`;
            break;
        default:
            {
                const last = other.pop();
                msg += `one of ${other.join(", ")}, or ${last}`;
            }
    }
    if (actual == null) msg += `. Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += `. Received function ${actual.name}`;
    else if (typeof actual === "object") {
        var _actual$constructor;
        if ((_actual$constructor = actual.constructor) !== null && _actual$constructor !== undefined && _actual$constructor.name) msg += `. Received an instance of ${actual.constructor.name}`;
        else {
            const inspected = $09c2021114adf118$require$inspect(actual, {
                depth: -1
            });
            msg += `. Received ${inspected}`;
        }
    } else {
        let inspected = $09c2021114adf118$require$inspect(actual, {
            colors: false
        });
        if (inspected.length > 25) inspected = `${inspected.slice(0, 25)}...`;
        msg += `. Received type ${typeof actual} (${inspected})`;
    }
    return msg;
}, TypeError);
$09c2021114adf118$var$E("ERR_INVALID_ARG_VALUE", (name, value, reason = "is invalid")=>{
    let inspected = $09c2021114adf118$require$inspect(value);
    if (inspected.length > 128) inspected = inspected.slice(0, 128) + "...";
    const type = name.includes(".") ? "property" : "argument";
    return `The ${type} '${name}' ${reason}. Received ${inspected}`;
}, TypeError);
$09c2021114adf118$var$E("ERR_INVALID_RETURN_VALUE", (input, name, value)=>{
    var _value$constructor;
    const type = value !== null && value !== undefined && (_value$constructor = value.constructor) !== null && _value$constructor !== undefined && _value$constructor.name ? `instance of ${value.constructor.name}` : `type ${typeof value}`;
    return `Expected ${input} to be returned from the "${name}"` + ` function but got ${type}.`;
}, TypeError);
$09c2021114adf118$var$E("ERR_MISSING_ARGS", (...args)=>{
    $09c2021114adf118$var$assert(args.length > 0, "At least one arg needs to be specified");
    let msg;
    const len = args.length;
    args = (Array.isArray(args) ? args : [
        args
    ]).map((a)=>`"${a}"`).join(" or ");
    switch(len){
        case 1:
            msg += `The ${args[0]} argument`;
            break;
        case 2:
            msg += `The ${args[0]} and ${args[1]} arguments`;
            break;
        default:
            {
                const last = args.pop();
                msg += `The ${args.join(", ")}, and ${last} arguments`;
            }
            break;
    }
    return `${msg} must be specified`;
}, TypeError);
$09c2021114adf118$var$E("ERR_OUT_OF_RANGE", (str, range, input)=>{
    $09c2021114adf118$var$assert(range, 'Missing "range" argument');
    let received;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $09c2021114adf118$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > 2n ** 32n || input < -(2n ** 32n)) received = $09c2021114adf118$var$addNumericalSeparator(received);
        received += "n";
    } else received = $09c2021114adf118$require$inspect(input);
    return `The value of "${str}" is out of range. It must be ${range}. Received ${received}`;
}, RangeError);
$09c2021114adf118$var$E("ERR_MULTIPLE_CALLBACK", "Callback called multiple times", Error);
$09c2021114adf118$var$E("ERR_METHOD_NOT_IMPLEMENTED", "The %s method is not implemented", Error);
$09c2021114adf118$var$E("ERR_STREAM_ALREADY_FINISHED", "Cannot call %s after a stream was finished", Error);
$09c2021114adf118$var$E("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable", Error);
$09c2021114adf118$var$E("ERR_STREAM_DESTROYED", "Cannot call %s after a stream was destroyed", Error);
$09c2021114adf118$var$E("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$09c2021114adf118$var$E("ERR_STREAM_PREMATURE_CLOSE", "Premature close", Error);
$09c2021114adf118$var$E("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF", Error);
$09c2021114adf118$var$E("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event", Error);
$09c2021114adf118$var$E("ERR_STREAM_WRITE_AFTER_END", "write after end", Error);
$09c2021114adf118$var$E("ERR_UNKNOWN_ENCODING", "Unknown encoding: %s", TypeError);
module.exports = {
    AbortError: $09c2021114adf118$var$AbortError,
    aggregateTwoErrors: $09c2021114adf118$var$hideStackFrames($09c2021114adf118$var$aggregateTwoErrors),
    hideStackFrames: $09c2021114adf118$var$hideStackFrames,
    codes: $09c2021114adf118$var$codes
};

});

parcelRegister("dEd8A", function(module, exports) {
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $9ef933a2f63b7ec6$require$SymbolAsyncIterator = $6qlDJ.SymbolAsyncIterator;
var $9ef933a2f63b7ec6$require$SymbolIterator = $6qlDJ.SymbolIterator;
var $9ef933a2f63b7ec6$require$SymbolFor = $6qlDJ.SymbolFor;
// We need to use SymbolFor to make these globally available
// for interopt with readable-stream, i.e. readable-stream
// and node core needs to be able to read/write private state
// from each other for proper interoperability.
const $9ef933a2f63b7ec6$var$kIsDestroyed = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.destroyed");
const $9ef933a2f63b7ec6$var$kIsErrored = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.errored");
const $9ef933a2f63b7ec6$var$kIsReadable = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.readable");
const $9ef933a2f63b7ec6$var$kIsWritable = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.writable");
const $9ef933a2f63b7ec6$var$kIsDisturbed = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.stream.disturbed");
const $9ef933a2f63b7ec6$var$kIsClosedPromise = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.webstream.isClosedPromise");
const $9ef933a2f63b7ec6$var$kControllerErrorFunction = $9ef933a2f63b7ec6$require$SymbolFor("nodejs.webstream.controllerErrorFunction");
function $9ef933a2f63b7ec6$var$isReadableNodeStream(obj, strict = false) {
    var _obj$_readableState;
    return !!(obj && typeof obj.pipe === "function" && typeof obj.on === "function" && (!strict || typeof obj.pause === "function" && typeof obj.resume === "function") && (!obj._writableState || ((_obj$_readableState = obj._readableState) === null || _obj$_readableState === undefined ? undefined : _obj$_readableState.readable) !== false) && // Duplex
    (!obj._writableState || obj._readableState) // Writable has .pipe.
    );
}
function $9ef933a2f63b7ec6$var$isWritableNodeStream(obj) {
    var _obj$_writableState;
    return !!(obj && typeof obj.write === "function" && typeof obj.on === "function" && (!obj._readableState || ((_obj$_writableState = obj._writableState) === null || _obj$_writableState === undefined ? undefined : _obj$_writableState.writable) !== false) // Duplex
    );
}
function $9ef933a2f63b7ec6$var$isDuplexNodeStream(obj) {
    return !!(obj && typeof obj.pipe === "function" && obj._readableState && typeof obj.on === "function" && typeof obj.write === "function");
}
function $9ef933a2f63b7ec6$var$isNodeStream(obj) {
    return obj && (obj._readableState || obj._writableState || typeof obj.write === "function" && typeof obj.on === "function" || typeof obj.pipe === "function" && typeof obj.on === "function");
}
function $9ef933a2f63b7ec6$var$isReadableStream(obj) {
    return !!(obj && !$9ef933a2f63b7ec6$var$isNodeStream(obj) && typeof obj.pipeThrough === "function" && typeof obj.getReader === "function" && typeof obj.cancel === "function");
}
function $9ef933a2f63b7ec6$var$isWritableStream(obj) {
    return !!(obj && !$9ef933a2f63b7ec6$var$isNodeStream(obj) && typeof obj.getWriter === "function" && typeof obj.abort === "function");
}
function $9ef933a2f63b7ec6$var$isTransformStream(obj) {
    return !!(obj && !$9ef933a2f63b7ec6$var$isNodeStream(obj) && typeof obj.readable === "object" && typeof obj.writable === "object");
}
function $9ef933a2f63b7ec6$var$isWebStream(obj) {
    return $9ef933a2f63b7ec6$var$isReadableStream(obj) || $9ef933a2f63b7ec6$var$isWritableStream(obj) || $9ef933a2f63b7ec6$var$isTransformStream(obj);
}
function $9ef933a2f63b7ec6$var$isIterable(obj, isAsync) {
    if (obj == null) return false;
    if (isAsync === true) return typeof obj[$9ef933a2f63b7ec6$require$SymbolAsyncIterator] === "function";
    if (isAsync === false) return typeof obj[$9ef933a2f63b7ec6$require$SymbolIterator] === "function";
    return typeof obj[$9ef933a2f63b7ec6$require$SymbolAsyncIterator] === "function" || typeof obj[$9ef933a2f63b7ec6$require$SymbolIterator] === "function";
}
function $9ef933a2f63b7ec6$var$isDestroyed(stream) {
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !!(stream.destroyed || stream[$9ef933a2f63b7ec6$var$kIsDestroyed] || state !== null && state !== undefined && state.destroyed);
}
// Have been end():d.
function $9ef933a2f63b7ec6$var$isWritableEnded(stream) {
    if (!$9ef933a2f63b7ec6$var$isWritableNodeStream(stream)) return null;
    if (stream.writableEnded === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.ended) !== "boolean") return null;
    return wState.ended;
}
// Have emitted 'finish'.
function $9ef933a2f63b7ec6$var$isWritableFinished(stream, strict) {
    if (!$9ef933a2f63b7ec6$var$isWritableNodeStream(stream)) return null;
    if (stream.writableFinished === true) return true;
    const wState = stream._writableState;
    if (wState !== null && wState !== undefined && wState.errored) return false;
    if (typeof (wState === null || wState === undefined ? undefined : wState.finished) !== "boolean") return null;
    return !!(wState.finished || strict === false && wState.ended === true && wState.length === 0);
}
// Have been push(null):d.
function $9ef933a2f63b7ec6$var$isReadableEnded(stream) {
    if (!$9ef933a2f63b7ec6$var$isReadableNodeStream(stream)) return null;
    if (stream.readableEnded === true) return true;
    const rState = stream._readableState;
    if (!rState || rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.ended) !== "boolean") return null;
    return rState.ended;
}
// Have emitted 'end'.
function $9ef933a2f63b7ec6$var$isReadableFinished(stream, strict) {
    if (!$9ef933a2f63b7ec6$var$isReadableNodeStream(stream)) return null;
    const rState = stream._readableState;
    if (rState !== null && rState !== undefined && rState.errored) return false;
    if (typeof (rState === null || rState === undefined ? undefined : rState.endEmitted) !== "boolean") return null;
    return !!(rState.endEmitted || strict === false && rState.ended === true && rState.length === 0);
}
function $9ef933a2f63b7ec6$var$isReadable(stream) {
    if (stream && stream[$9ef933a2f63b7ec6$var$kIsReadable] != null) return stream[$9ef933a2f63b7ec6$var$kIsReadable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.readable) !== "boolean") return null;
    if ($9ef933a2f63b7ec6$var$isDestroyed(stream)) return false;
    return $9ef933a2f63b7ec6$var$isReadableNodeStream(stream) && stream.readable && !$9ef933a2f63b7ec6$var$isReadableFinished(stream);
}
function $9ef933a2f63b7ec6$var$isWritable(stream) {
    if (stream && stream[$9ef933a2f63b7ec6$var$kIsWritable] != null) return stream[$9ef933a2f63b7ec6$var$kIsWritable];
    if (typeof (stream === null || stream === undefined ? undefined : stream.writable) !== "boolean") return null;
    if ($9ef933a2f63b7ec6$var$isDestroyed(stream)) return false;
    return $9ef933a2f63b7ec6$var$isWritableNodeStream(stream) && stream.writable && !$9ef933a2f63b7ec6$var$isWritableEnded(stream);
}
function $9ef933a2f63b7ec6$var$isFinished(stream, opts) {
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    if ($9ef933a2f63b7ec6$var$isDestroyed(stream)) return true;
    if ((opts === null || opts === undefined ? undefined : opts.readable) !== false && $9ef933a2f63b7ec6$var$isReadable(stream)) return false;
    if ((opts === null || opts === undefined ? undefined : opts.writable) !== false && $9ef933a2f63b7ec6$var$isWritable(stream)) return false;
    return true;
}
function $9ef933a2f63b7ec6$var$isWritableErrored(stream) {
    var _stream$_writableStat, _stream$_writableStat2;
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    if (stream.writableErrored) return stream.writableErrored;
    return (_stream$_writableStat = (_stream$_writableStat2 = stream._writableState) === null || _stream$_writableStat2 === undefined ? undefined : _stream$_writableStat2.errored) !== null && _stream$_writableStat !== undefined ? _stream$_writableStat : null;
}
function $9ef933a2f63b7ec6$var$isReadableErrored(stream) {
    var _stream$_readableStat, _stream$_readableStat2;
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    if (stream.readableErrored) return stream.readableErrored;
    return (_stream$_readableStat = (_stream$_readableStat2 = stream._readableState) === null || _stream$_readableStat2 === undefined ? undefined : _stream$_readableStat2.errored) !== null && _stream$_readableStat !== undefined ? _stream$_readableStat : null;
}
function $9ef933a2f63b7ec6$var$isClosed(stream) {
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    if (typeof stream.closed === "boolean") return stream.closed;
    const wState = stream._writableState;
    const rState = stream._readableState;
    if (typeof (wState === null || wState === undefined ? undefined : wState.closed) === "boolean" || typeof (rState === null || rState === undefined ? undefined : rState.closed) === "boolean") return (wState === null || wState === undefined ? undefined : wState.closed) || (rState === null || rState === undefined ? undefined : rState.closed);
    if (typeof stream._closed === "boolean" && $9ef933a2f63b7ec6$var$isOutgoingMessage(stream)) return stream._closed;
    return null;
}
function $9ef933a2f63b7ec6$var$isOutgoingMessage(stream) {
    return typeof stream._closed === "boolean" && typeof stream._defaultKeepAlive === "boolean" && typeof stream._removedConnection === "boolean" && typeof stream._removedContLen === "boolean";
}
function $9ef933a2f63b7ec6$var$isServerResponse(stream) {
    return typeof stream._sent100 === "boolean" && $9ef933a2f63b7ec6$var$isOutgoingMessage(stream);
}
function $9ef933a2f63b7ec6$var$isServerRequest(stream) {
    var _stream$req;
    return typeof stream._consuming === "boolean" && typeof stream._dumped === "boolean" && ((_stream$req = stream.req) === null || _stream$req === undefined ? undefined : _stream$req.upgradeOrConnect) === undefined;
}
function $9ef933a2f63b7ec6$var$willEmitClose(stream) {
    if (!$9ef933a2f63b7ec6$var$isNodeStream(stream)) return null;
    const wState = stream._writableState;
    const rState = stream._readableState;
    const state = wState || rState;
    return !state && $9ef933a2f63b7ec6$var$isServerResponse(stream) || !!(state && state.autoDestroy && state.emitClose && state.closed === false);
}
function $9ef933a2f63b7ec6$var$isDisturbed(stream) {
    var _stream$kIsDisturbed;
    return !!(stream && ((_stream$kIsDisturbed = stream[$9ef933a2f63b7ec6$var$kIsDisturbed]) !== null && _stream$kIsDisturbed !== undefined ? _stream$kIsDisturbed : stream.readableDidRead || stream.readableAborted));
}
function $9ef933a2f63b7ec6$var$isErrored(stream) {
    var _ref, _ref2, _ref3, _ref4, _ref5, _stream$kIsErrored, _stream$_readableStat3, _stream$_writableStat3, _stream$_readableStat4, _stream$_writableStat4;
    return !!(stream && ((_ref = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_stream$kIsErrored = stream[$9ef933a2f63b7ec6$var$kIsErrored]) !== null && _stream$kIsErrored !== undefined ? _stream$kIsErrored : stream.readableErrored) !== null && _ref5 !== undefined ? _ref5 : stream.writableErrored) !== null && _ref4 !== undefined ? _ref4 : (_stream$_readableStat3 = stream._readableState) === null || _stream$_readableStat3 === undefined ? undefined : _stream$_readableStat3.errorEmitted) !== null && _ref3 !== undefined ? _ref3 : (_stream$_writableStat3 = stream._writableState) === null || _stream$_writableStat3 === undefined ? undefined : _stream$_writableStat3.errorEmitted) !== null && _ref2 !== undefined ? _ref2 : (_stream$_readableStat4 = stream._readableState) === null || _stream$_readableStat4 === undefined ? undefined : _stream$_readableStat4.errored) !== null && _ref !== undefined ? _ref : (_stream$_writableStat4 = stream._writableState) === null || _stream$_writableStat4 === undefined ? undefined : _stream$_writableStat4.errored));
}
module.exports = {
    isDestroyed: $9ef933a2f63b7ec6$var$isDestroyed,
    kIsDestroyed: $9ef933a2f63b7ec6$var$kIsDestroyed,
    isDisturbed: $9ef933a2f63b7ec6$var$isDisturbed,
    kIsDisturbed: $9ef933a2f63b7ec6$var$kIsDisturbed,
    isErrored: $9ef933a2f63b7ec6$var$isErrored,
    kIsErrored: $9ef933a2f63b7ec6$var$kIsErrored,
    isReadable: $9ef933a2f63b7ec6$var$isReadable,
    kIsReadable: $9ef933a2f63b7ec6$var$kIsReadable,
    kIsClosedPromise: $9ef933a2f63b7ec6$var$kIsClosedPromise,
    kControllerErrorFunction: $9ef933a2f63b7ec6$var$kControllerErrorFunction,
    kIsWritable: $9ef933a2f63b7ec6$var$kIsWritable,
    isClosed: $9ef933a2f63b7ec6$var$isClosed,
    isDuplexNodeStream: $9ef933a2f63b7ec6$var$isDuplexNodeStream,
    isFinished: $9ef933a2f63b7ec6$var$isFinished,
    isIterable: $9ef933a2f63b7ec6$var$isIterable,
    isReadableNodeStream: $9ef933a2f63b7ec6$var$isReadableNodeStream,
    isReadableStream: $9ef933a2f63b7ec6$var$isReadableStream,
    isReadableEnded: $9ef933a2f63b7ec6$var$isReadableEnded,
    isReadableFinished: $9ef933a2f63b7ec6$var$isReadableFinished,
    isReadableErrored: $9ef933a2f63b7ec6$var$isReadableErrored,
    isNodeStream: $9ef933a2f63b7ec6$var$isNodeStream,
    isWebStream: $9ef933a2f63b7ec6$var$isWebStream,
    isWritable: $9ef933a2f63b7ec6$var$isWritable,
    isWritableNodeStream: $9ef933a2f63b7ec6$var$isWritableNodeStream,
    isWritableStream: $9ef933a2f63b7ec6$var$isWritableStream,
    isWritableEnded: $9ef933a2f63b7ec6$var$isWritableEnded,
    isWritableFinished: $9ef933a2f63b7ec6$var$isWritableFinished,
    isWritableErrored: $9ef933a2f63b7ec6$var$isWritableErrored,
    isServerRequest: $9ef933a2f63b7ec6$var$isServerRequest,
    isServerResponse: $9ef933a2f63b7ec6$var$isServerResponse,
    willEmitClose: $9ef933a2f63b7ec6$var$willEmitClose,
    isTransformStream: $9ef933a2f63b7ec6$var$isTransformStream
};

});

parcelRegister("52Cjj", function(module, exports) {
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $PWkkZ = parcelRequire("PWkkZ");
var $3abadb51ef1f2b7d$require$AbortError = $PWkkZ.AbortError;
var $3abadb51ef1f2b7d$require$codes = $PWkkZ.codes;
const { ERR_INVALID_ARG_TYPE: $3abadb51ef1f2b7d$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_PREMATURE_CLOSE: $3abadb51ef1f2b7d$var$ERR_STREAM_PREMATURE_CLOSE } = $3abadb51ef1f2b7d$require$codes;

var $3abadb51ef1f2b7d$require$kEmptyObject = (parcelRequire("cSbri")).kEmptyObject;
var $3abadb51ef1f2b7d$require$once = (parcelRequire("cSbri")).once;

var $6q8Dc = parcelRequire("6q8Dc");
var $3abadb51ef1f2b7d$require$validateAbortSignal = $6q8Dc.validateAbortSignal;
var $3abadb51ef1f2b7d$require$validateFunction = $6q8Dc.validateFunction;
var $3abadb51ef1f2b7d$require$validateObject = $6q8Dc.validateObject;
var $3abadb51ef1f2b7d$require$validateBoolean = $6q8Dc.validateBoolean;

var $6qlDJ = parcelRequire("6qlDJ");
var $3abadb51ef1f2b7d$require$Promise = $6qlDJ.Promise;
var $3abadb51ef1f2b7d$require$PromisePrototypeThen = $6qlDJ.PromisePrototypeThen;
var $3abadb51ef1f2b7d$require$SymbolDispose = $6qlDJ.SymbolDispose;

var $dEd8A = parcelRequire("dEd8A");
var $3abadb51ef1f2b7d$require$isClosed = $dEd8A.isClosed;
var $3abadb51ef1f2b7d$require$isReadable = $dEd8A.isReadable;
var $3abadb51ef1f2b7d$require$isReadableNodeStream = $dEd8A.isReadableNodeStream;
var $3abadb51ef1f2b7d$require$isReadableStream = $dEd8A.isReadableStream;
var $3abadb51ef1f2b7d$require$isReadableFinished = $dEd8A.isReadableFinished;
var $3abadb51ef1f2b7d$require$isReadableErrored = $dEd8A.isReadableErrored;
var $3abadb51ef1f2b7d$require$isWritable = $dEd8A.isWritable;
var $3abadb51ef1f2b7d$require$isWritableNodeStream = $dEd8A.isWritableNodeStream;
var $3abadb51ef1f2b7d$require$isWritableStream = $dEd8A.isWritableStream;
var $3abadb51ef1f2b7d$require$isWritableFinished = $dEd8A.isWritableFinished;
var $3abadb51ef1f2b7d$require$isWritableErrored = $dEd8A.isWritableErrored;
var $3abadb51ef1f2b7d$require$isNodeStream = $dEd8A.isNodeStream;
var $3abadb51ef1f2b7d$require$_willEmitClose = $dEd8A.willEmitClose;
var $3abadb51ef1f2b7d$require$kIsClosedPromise = $dEd8A.kIsClosedPromise;
let $3abadb51ef1f2b7d$var$addAbortListener;
function $3abadb51ef1f2b7d$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
const $3abadb51ef1f2b7d$var$nop = ()=>{};

function $3abadb51ef1f2b7d$var$eos(stream, options, callback) {
    var _options$readable, _options$writable;
    if (arguments.length === 2) {
        callback = options;
        options = $3abadb51ef1f2b7d$require$kEmptyObject;
    } else if (options == null) options = $3abadb51ef1f2b7d$require$kEmptyObject;
    else $3abadb51ef1f2b7d$require$validateObject(options, "options");
    $3abadb51ef1f2b7d$require$validateFunction(callback, "callback");
    $3abadb51ef1f2b7d$require$validateAbortSignal(options.signal, "options.signal");
    callback = $3abadb51ef1f2b7d$require$once(callback);
    if ($3abadb51ef1f2b7d$require$isReadableStream(stream) || $3abadb51ef1f2b7d$require$isWritableStream(stream)) return $3abadb51ef1f2b7d$var$eosWeb(stream, options, callback);
    if (!$3abadb51ef1f2b7d$require$isNodeStream(stream)) throw new $3abadb51ef1f2b7d$var$ERR_INVALID_ARG_TYPE("stream", [
        "ReadableStream",
        "WritableStream",
        "Stream"
    ], stream);
    const readable = (_options$readable = options.readable) !== null && _options$readable !== undefined ? _options$readable : $3abadb51ef1f2b7d$require$isReadableNodeStream(stream);
    const writable = (_options$writable = options.writable) !== null && _options$writable !== undefined ? _options$writable : $3abadb51ef1f2b7d$require$isWritableNodeStream(stream);
    const wState = stream._writableState;
    const rState = stream._readableState;
    const onlegacyfinish = ()=>{
        if (!stream.writable) onfinish();
    };
    // TODO (ronag): Improve soft detection to include core modules and
    // common ecosystem modules that do properly emit 'close' but fail
    // this generic check.
    let willEmitClose = $3abadb51ef1f2b7d$require$_willEmitClose(stream) && $3abadb51ef1f2b7d$require$isReadableNodeStream(stream) === readable && $3abadb51ef1f2b7d$require$isWritableNodeStream(stream) === writable;
    let writableFinished = $3abadb51ef1f2b7d$require$isWritableFinished(stream, false);
    const onfinish = ()=>{
        writableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.readable || readable)) return;
        if (!readable || readableFinished) callback.call(stream);
    };
    let readableFinished = $3abadb51ef1f2b7d$require$isReadableFinished(stream, false);
    const onend = ()=>{
        readableFinished = true;
        // Stream should not be destroyed here. If it is that
        // means that user space is doing something differently and
        // we cannot trust willEmitClose.
        if (stream.destroyed) willEmitClose = false;
        if (willEmitClose && (!stream.writable || writable)) return;
        if (!writable || writableFinished) callback.call(stream);
    };
    const onerror = (err)=>{
        callback.call(stream, err);
    };
    let closed = $3abadb51ef1f2b7d$require$isClosed(stream);
    const onclose = ()=>{
        closed = true;
        const errored = $3abadb51ef1f2b7d$require$isWritableErrored(stream) || $3abadb51ef1f2b7d$require$isReadableErrored(stream);
        if (errored && typeof errored !== "boolean") return callback.call(stream, errored);
        if (readable && !readableFinished && $3abadb51ef1f2b7d$require$isReadableNodeStream(stream, true)) {
            if (!$3abadb51ef1f2b7d$require$isReadableFinished(stream, false)) return callback.call(stream, new $3abadb51ef1f2b7d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        if (writable && !writableFinished) {
            if (!$3abadb51ef1f2b7d$require$isWritableFinished(stream, false)) return callback.call(stream, new $3abadb51ef1f2b7d$var$ERR_STREAM_PREMATURE_CLOSE());
        }
        callback.call(stream);
    };
    const onclosed = ()=>{
        closed = true;
        const errored = $3abadb51ef1f2b7d$require$isWritableErrored(stream) || $3abadb51ef1f2b7d$require$isReadableErrored(stream);
        if (errored && typeof errored !== "boolean") return callback.call(stream, errored);
        callback.call(stream);
    };
    const onrequest = ()=>{
        stream.req.on("finish", onfinish);
    };
    if ($3abadb51ef1f2b7d$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        if (!willEmitClose) stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !wState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    // Not all streams will emit 'close' after 'aborted'.
    if (!willEmitClose && typeof stream.aborted === "boolean") stream.on("aborted", onclose);
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (options.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    if (closed) $hPtJY.nextTick(onclose);
    else if (wState !== null && wState !== undefined && wState.errorEmitted || rState !== null && rState !== undefined && rState.errorEmitted) {
        if (!willEmitClose) $hPtJY.nextTick(onclosed);
    } else if (!readable && (!willEmitClose || $3abadb51ef1f2b7d$require$isReadable(stream)) && (writableFinished || $3abadb51ef1f2b7d$require$isWritable(stream) === false)) $hPtJY.nextTick(onclosed);
    else if (!writable && (!willEmitClose || $3abadb51ef1f2b7d$require$isWritable(stream)) && (readableFinished || $3abadb51ef1f2b7d$require$isReadable(stream) === false)) $hPtJY.nextTick(onclosed);
    else if (rState && stream.req && stream.aborted) $hPtJY.nextTick(onclosed);
    const cleanup = ()=>{
        callback = $3abadb51ef1f2b7d$var$nop;
        stream.removeListener("aborted", onclose);
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
    if (options.signal && !closed) {
        const abort = ()=>{
            // Keep it because cleanup removes it.
            const endCallback = callback;
            cleanup();
            endCallback.call(stream, new $3abadb51ef1f2b7d$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $hPtJY.nextTick(abort);
        else {
            $3abadb51ef1f2b7d$var$addAbortListener = $3abadb51ef1f2b7d$var$addAbortListener || (parcelRequire("cSbri")).addAbortListener;
            const disposable = $3abadb51ef1f2b7d$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $3abadb51ef1f2b7d$require$once((...args)=>{
                disposable[$3abadb51ef1f2b7d$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    return cleanup;
}

function $3abadb51ef1f2b7d$var$eosWeb(stream, options, callback) {
    let isAborted = false;
    let abort = $3abadb51ef1f2b7d$var$nop;
    if (options.signal) {
        abort = ()=>{
            isAborted = true;
            callback.call(stream, new $3abadb51ef1f2b7d$require$AbortError(undefined, {
                cause: options.signal.reason
            }));
        };
        if (options.signal.aborted) $hPtJY.nextTick(abort);
        else {
            $3abadb51ef1f2b7d$var$addAbortListener = $3abadb51ef1f2b7d$var$addAbortListener || (parcelRequire("cSbri")).addAbortListener;
            const disposable = $3abadb51ef1f2b7d$var$addAbortListener(options.signal, abort);
            const originalCallback = callback;
            callback = $3abadb51ef1f2b7d$require$once((...args)=>{
                disposable[$3abadb51ef1f2b7d$require$SymbolDispose]();
                originalCallback.apply(stream, args);
            });
        }
    }
    const resolverFn = (...args)=>{
        if (!isAborted) $hPtJY.nextTick(()=>callback.apply(stream, args));
    };
    $3abadb51ef1f2b7d$require$PromisePrototypeThen(stream[$3abadb51ef1f2b7d$require$kIsClosedPromise].promise, resolverFn, resolverFn);
    return $3abadb51ef1f2b7d$var$nop;
}
function $3abadb51ef1f2b7d$var$finished(stream, opts) {
    var _opts;
    let autoCleanup = false;
    if (opts === null) opts = $3abadb51ef1f2b7d$require$kEmptyObject;
    if ((_opts = opts) !== null && _opts !== undefined && _opts.cleanup) {
        $3abadb51ef1f2b7d$require$validateBoolean(opts.cleanup, "cleanup");
        autoCleanup = opts.cleanup;
    }
    return new $3abadb51ef1f2b7d$require$Promise((resolve, reject)=>{
        const cleanup = $3abadb51ef1f2b7d$var$eos(stream, opts, (err)=>{
            if (autoCleanup) cleanup();
            if (err) reject(err);
            else resolve();
        });
    });
}
module.exports = $3abadb51ef1f2b7d$var$eos;
module.exports.finished = $3abadb51ef1f2b7d$var$finished;

});
parcelRegister("6q8Dc", function(module, exports) {
/* eslint jsdoc/require-jsdoc: "error" */ "use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $4acbddc77dc5371b$require$ArrayIsArray = $6qlDJ.ArrayIsArray;
var $4acbddc77dc5371b$require$ArrayPrototypeIncludes = $6qlDJ.ArrayPrototypeIncludes;
var $4acbddc77dc5371b$require$ArrayPrototypeJoin = $6qlDJ.ArrayPrototypeJoin;
var $4acbddc77dc5371b$require$ArrayPrototypeMap = $6qlDJ.ArrayPrototypeMap;
var $4acbddc77dc5371b$require$NumberIsInteger = $6qlDJ.NumberIsInteger;
var $4acbddc77dc5371b$require$NumberIsNaN = $6qlDJ.NumberIsNaN;
var $4acbddc77dc5371b$require$NumberMAX_SAFE_INTEGER = $6qlDJ.NumberMAX_SAFE_INTEGER;
var $4acbddc77dc5371b$require$NumberMIN_SAFE_INTEGER = $6qlDJ.NumberMIN_SAFE_INTEGER;
var $4acbddc77dc5371b$require$NumberParseInt = $6qlDJ.NumberParseInt;
var $4acbddc77dc5371b$require$ObjectPrototypeHasOwnProperty = $6qlDJ.ObjectPrototypeHasOwnProperty;
var $4acbddc77dc5371b$require$RegExpPrototypeExec = $6qlDJ.RegExpPrototypeExec;
var $4acbddc77dc5371b$require$String = $6qlDJ.String;
var $4acbddc77dc5371b$require$StringPrototypeToUpperCase = $6qlDJ.StringPrototypeToUpperCase;
var $4acbddc77dc5371b$require$StringPrototypeTrim = $6qlDJ.StringPrototypeTrim;

var $PWkkZ = parcelRequire("PWkkZ");
const { hideStackFrames: $4acbddc77dc5371b$var$hideStackFrames, codes: { ERR_SOCKET_BAD_PORT: $4acbddc77dc5371b$var$ERR_SOCKET_BAD_PORT, ERR_INVALID_ARG_TYPE: $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_ARG_VALUE: $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE, ERR_OUT_OF_RANGE: $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE, ERR_UNKNOWN_SIGNAL: $4acbddc77dc5371b$var$ERR_UNKNOWN_SIGNAL } } = $PWkkZ;

var $cSbri = parcelRequire("cSbri");
const { normalizeEncoding: $4acbddc77dc5371b$var$normalizeEncoding } = $cSbri;

var $cSbri = parcelRequire("cSbri");
const { isAsyncFunction: $4acbddc77dc5371b$var$isAsyncFunction, isArrayBufferView: $4acbddc77dc5371b$var$isArrayBufferView } = $cSbri.types;
const $4acbddc77dc5371b$var$signals = {};
/**
 * @param {*} value
 * @returns {boolean}
 */ function $4acbddc77dc5371b$var$isInt32(value) {
    return value === (value | 0);
}
/**
 * @param {*} value
 * @returns {boolean}
 */ function $4acbddc77dc5371b$var$isUint32(value) {
    return value === value >>> 0;
}
const $4acbddc77dc5371b$var$octalReg = /^[0-7]+$/;
const $4acbddc77dc5371b$var$modeDesc = "must be a 32-bit unsigned integer or an octal string";
/**
 * Parse and validate values that will be converted into mode_t (the S_*
 * constants). Only valid numbers and octal strings are allowed. They could be
 * converted to 32-bit unsigned integers or non-negative signed integers in the
 * C++ land, but any value higher than 0o777 will result in platform-specific
 * behaviors.
 * @param {*} value Values to be validated
 * @param {string} name Name of the argument
 * @param {number} [def] If specified, will be returned for invalid values
 * @returns {number}
 */ function $4acbddc77dc5371b$var$parseFileMode(value, name, def) {
    if (typeof value === "undefined") value = def;
    if (typeof value === "string") {
        if ($4acbddc77dc5371b$require$RegExpPrototypeExec($4acbddc77dc5371b$var$octalReg, value) === null) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE(name, value, $4acbddc77dc5371b$var$modeDesc);
        value = $4acbddc77dc5371b$require$NumberParseInt(value, 8);
    }
    $4acbddc77dc5371b$var$validateUint32(value, name);
    return value;
}
/**
 * @callback validateInteger
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInteger} */ const $4acbddc77dc5371b$var$validateInteger = $4acbddc77dc5371b$var$hideStackFrames((value, name, min = $4acbddc77dc5371b$require$NumberMIN_SAFE_INTEGER, max = $4acbddc77dc5371b$require$NumberMAX_SAFE_INTEGER)=>{
    if (typeof value !== "number") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$4acbddc77dc5371b$require$NumberIsInteger(value)) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    if (value < min || value > max) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateInt32
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateInt32} */ const $4acbddc77dc5371b$var$validateInt32 = $4acbddc77dc5371b$var$hideStackFrames((value, name, min = -2147483648, max = 2147483647)=>{
    // The defaults for min and max correspond to the limits of 32-bit integers.
    if (typeof value !== "number") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$4acbddc77dc5371b$require$NumberIsInteger(value)) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    if (value < min || value > max) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateUint32
 * @param {*} value
 * @param {string} name
 * @param {number|boolean} [positive=false]
 * @returns {asserts value is number}
 */ /** @type {validateUint32} */ const $4acbddc77dc5371b$var$validateUint32 = $4acbddc77dc5371b$var$hideStackFrames((value, name, positive = false)=>{
    if (typeof value !== "number") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (!$4acbddc77dc5371b$require$NumberIsInteger(value)) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, "an integer", value);
    const min = positive ? 1 : 0;
    // 2 ** 32 === 4294967296
    const max = 4294967295;
    if (value < min || value > max) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, `>= ${min} && <= ${max}`, value);
});
/**
 * @callback validateString
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string}
 */ /** @type {validateString} */ function $4acbddc77dc5371b$var$validateString(value, name) {
    if (typeof value !== "string") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "string", value);
}
/**
 * @callback validateNumber
 * @param {*} value
 * @param {string} name
 * @param {number} [min]
 * @param {number} [max]
 * @returns {asserts value is number}
 */ /** @type {validateNumber} */ function $4acbddc77dc5371b$var$validateNumber(value, name, min, max) {
    if (typeof value !== "number") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "number", value);
    if (min != null && value < min || max != null && value > max || (min != null || max != null) && $4acbddc77dc5371b$require$NumberIsNaN(value)) throw new $4acbddc77dc5371b$var$ERR_OUT_OF_RANGE(name, `${min != null ? `>= ${min}` : ""}${min != null && max != null ? " && " : ""}${max != null ? `<= ${max}` : ""}`, value);
}
/**
 * @callback validateOneOf
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} oneOf
 */ /** @type {validateOneOf} */ const $4acbddc77dc5371b$var$validateOneOf = $4acbddc77dc5371b$var$hideStackFrames((value, name, oneOf)=>{
    if (!$4acbddc77dc5371b$require$ArrayPrototypeIncludes(oneOf, value)) {
        const allowed = $4acbddc77dc5371b$require$ArrayPrototypeJoin($4acbddc77dc5371b$require$ArrayPrototypeMap(oneOf, (v)=>typeof v === "string" ? `'${v}'` : $4acbddc77dc5371b$require$String(v)), ", ");
        const reason = "must be one of: " + allowed;
        throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateBoolean
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean}
 */ /** @type {validateBoolean} */ function $4acbddc77dc5371b$var$validateBoolean(value, name) {
    if (typeof value !== "boolean") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "boolean", value);
}
/**
 * @param {any} options
 * @param {string} key
 * @param {boolean} defaultValue
 * @returns {boolean}
 */ function $4acbddc77dc5371b$var$getOwnPropertyValueOrDefault(options, key, defaultValue) {
    return options == null || !$4acbddc77dc5371b$require$ObjectPrototypeHasOwnProperty(options, key) ? defaultValue : options[key];
}
/**
 * @callback validateObject
 * @param {*} value
 * @param {string} name
 * @param {{
 *   allowArray?: boolean,
 *   allowFunction?: boolean,
 *   nullable?: boolean
 * }} [options]
 */ /** @type {validateObject} */ const $4acbddc77dc5371b$var$validateObject = $4acbddc77dc5371b$var$hideStackFrames((value, name, options = null)=>{
    const allowArray = $4acbddc77dc5371b$var$getOwnPropertyValueOrDefault(options, "allowArray", false);
    const allowFunction = $4acbddc77dc5371b$var$getOwnPropertyValueOrDefault(options, "allowFunction", false);
    const nullable = $4acbddc77dc5371b$var$getOwnPropertyValueOrDefault(options, "nullable", false);
    if (!nullable && value === null || !allowArray && $4acbddc77dc5371b$require$ArrayIsArray(value) || typeof value !== "object" && (!allowFunction || typeof value !== "function")) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "Object", value);
});
/**
 * @callback validateDictionary - We are using the Web IDL Standard definition
 *                                of "dictionary" here, which means any value
 *                                whose Type is either Undefined, Null, or
 *                                Object (which includes functions).
 * @param {*} value
 * @param {string} name
 * @see https://webidl.spec.whatwg.org/#es-dictionary
 * @see https://tc39.es/ecma262/#table-typeof-operator-results
 */ /** @type {validateDictionary} */ const $4acbddc77dc5371b$var$validateDictionary = $4acbddc77dc5371b$var$hideStackFrames((value, name)=>{
    if (value != null && typeof value !== "object" && typeof value !== "function") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "a dictionary", value);
});
/**
 * @callback validateArray
 * @param {*} value
 * @param {string} name
 * @param {number} [minLength]
 * @returns {asserts value is any[]}
 */ /** @type {validateArray} */ const $4acbddc77dc5371b$var$validateArray = $4acbddc77dc5371b$var$hideStackFrames((value, name, minLength = 0)=>{
    if (!$4acbddc77dc5371b$require$ArrayIsArray(value)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "Array", value);
    if (value.length < minLength) {
        const reason = `must be longer than ${minLength}`;
        throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE(name, value, reason);
    }
});
/**
 * @callback validateStringArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is string[]}
 */ /** @type {validateStringArray} */ function $4acbddc77dc5371b$var$validateStringArray(value, name) {
    $4acbddc77dc5371b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$4acbddc77dc5371b$var$validateString(value[i], `${name}[${i}]`);
}
/**
 * @callback validateBooleanArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is boolean[]}
 */ /** @type {validateBooleanArray} */ function $4acbddc77dc5371b$var$validateBooleanArray(value, name) {
    $4acbddc77dc5371b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++)$4acbddc77dc5371b$var$validateBoolean(value[i], `${name}[${i}]`);
}
/**
 * @callback validateAbortSignalArray
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is AbortSignal[]}
 */ /** @type {validateAbortSignalArray} */ function $4acbddc77dc5371b$var$validateAbortSignalArray(value, name) {
    $4acbddc77dc5371b$var$validateArray(value, name);
    for(let i = 0; i < value.length; i++){
        const signal = value[i];
        const indexedName = `${name}[${i}]`;
        if (signal == null) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(indexedName, "AbortSignal", signal);
        $4acbddc77dc5371b$var$validateAbortSignal(signal, indexedName);
    }
}
/**
 * @param {*} signal
 * @param {string} [name='signal']
 * @returns {asserts signal is keyof signals}
 */ function $4acbddc77dc5371b$var$validateSignalName(signal, name = "signal") {
    $4acbddc77dc5371b$var$validateString(signal, name);
    if ($4acbddc77dc5371b$var$signals[signal] === undefined) {
        if ($4acbddc77dc5371b$var$signals[$4acbddc77dc5371b$require$StringPrototypeToUpperCase(signal)] !== undefined) throw new $4acbddc77dc5371b$var$ERR_UNKNOWN_SIGNAL(signal + " (signals must use all capital letters)");
        throw new $4acbddc77dc5371b$var$ERR_UNKNOWN_SIGNAL(signal);
    }
}
/**
 * @callback validateBuffer
 * @param {*} buffer
 * @param {string} [name='buffer']
 * @returns {asserts buffer is ArrayBufferView}
 */ /** @type {validateBuffer} */ const $4acbddc77dc5371b$var$validateBuffer = $4acbddc77dc5371b$var$hideStackFrames((buffer, name = "buffer")=>{
    if (!$4acbddc77dc5371b$var$isArrayBufferView(buffer)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, [
        "Buffer",
        "TypedArray",
        "DataView"
    ], buffer);
});
/**
 * @param {string} data
 * @param {string} encoding
 */ function $4acbddc77dc5371b$var$validateEncoding(data, encoding) {
    const normalizedEncoding = $4acbddc77dc5371b$var$normalizeEncoding(encoding);
    const length = data.length;
    if (normalizedEncoding === "hex" && length % 2 !== 0) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE("encoding", encoding, `is invalid for data of length ${length}`);
}
/**
 * Check that the port number is not NaN when coerced to a number,
 * is an integer and that it falls within the legal range of port numbers.
 * @param {*} port
 * @param {string} [name='Port']
 * @param {boolean} [allowZero=true]
 * @returns {number}
 */ function $4acbddc77dc5371b$var$validatePort(port, name = "Port", allowZero = true) {
    if (typeof port !== "number" && typeof port !== "string" || typeof port === "string" && $4acbddc77dc5371b$require$StringPrototypeTrim(port).length === 0 || +port !== +port >>> 0 || port > 0xffff || port === 0 && !allowZero) throw new $4acbddc77dc5371b$var$ERR_SOCKET_BAD_PORT(name, port, allowZero);
    return port | 0;
}
/**
 * @callback validateAbortSignal
 * @param {*} signal
 * @param {string} name
 */ /** @type {validateAbortSignal} */ const $4acbddc77dc5371b$var$validateAbortSignal = $4acbddc77dc5371b$var$hideStackFrames((signal, name)=>{
    if (signal !== undefined && (signal === null || typeof signal !== "object" || !("aborted" in signal))) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "AbortSignal", signal);
});
/**
 * @callback validateFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validateFunction} */ const $4acbddc77dc5371b$var$validateFunction = $4acbddc77dc5371b$var$hideStackFrames((value, name)=>{
    if (typeof value !== "function") throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "Function", value);
});
/**
 * @callback validatePlainFunction
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is Function}
 */ /** @type {validatePlainFunction} */ const $4acbddc77dc5371b$var$validatePlainFunction = $4acbddc77dc5371b$var$hideStackFrames((value, name)=>{
    if (typeof value !== "function" || $4acbddc77dc5371b$var$isAsyncFunction(value)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "Function", value);
});
/**
 * @callback validateUndefined
 * @param {*} value
 * @param {string} name
 * @returns {asserts value is undefined}
 */ /** @type {validateUndefined} */ const $4acbddc77dc5371b$var$validateUndefined = $4acbddc77dc5371b$var$hideStackFrames((value, name)=>{
    if (value !== undefined) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, "undefined", value);
});
/**
 * @template T
 * @param {T} value
 * @param {string} name
 * @param {T[]} union
 */ function $4acbddc77dc5371b$var$validateUnion(value, name, union) {
    if (!$4acbddc77dc5371b$require$ArrayPrototypeIncludes(union, value)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_TYPE(name, `('${$4acbddc77dc5371b$require$ArrayPrototypeJoin(union, "|")}')`, value);
}
/*
  The rules for the Link header field are described here:
  https://www.rfc-editor.org/rfc/rfc8288.html#section-3

  This regex validates any string surrounded by angle brackets
  (not necessarily a valid URI reference) followed by zero or more
  link-params separated by semicolons.
*/ const $4acbddc77dc5371b$var$linkValueRegExp = /^(?:<[^>]*>)(?:\s*;\s*[^;"\s]+(?:=(")?[^;"\s]*\1)?)*$/;
/**
 * @param {any} value
 * @param {string} name
 */ function $4acbddc77dc5371b$var$validateLinkHeaderFormat(value, name) {
    if (typeof value === "undefined" || !$4acbddc77dc5371b$require$RegExpPrototypeExec($4acbddc77dc5371b$var$linkValueRegExp, value)) throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE(name, value, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
/**
 * @param {any} hints
 * @return {string}
 */ function $4acbddc77dc5371b$var$validateLinkHeaderValue(hints) {
    if (typeof hints === "string") {
        $4acbddc77dc5371b$var$validateLinkHeaderFormat(hints, "hints");
        return hints;
    } else if ($4acbddc77dc5371b$require$ArrayIsArray(hints)) {
        const hintsLength = hints.length;
        let result = "";
        if (hintsLength === 0) return result;
        for(let i = 0; i < hintsLength; i++){
            const link = hints[i];
            $4acbddc77dc5371b$var$validateLinkHeaderFormat(link, "hints");
            result += link;
            if (i !== hintsLength - 1) result += ", ";
        }
        return result;
    }
    throw new $4acbddc77dc5371b$var$ERR_INVALID_ARG_VALUE("hints", hints, 'must be an array or string of format "</styles.css>; rel=preload; as=style"');
}
module.exports = {
    isInt32: $4acbddc77dc5371b$var$isInt32,
    isUint32: $4acbddc77dc5371b$var$isUint32,
    parseFileMode: $4acbddc77dc5371b$var$parseFileMode,
    validateArray: $4acbddc77dc5371b$var$validateArray,
    validateStringArray: $4acbddc77dc5371b$var$validateStringArray,
    validateBooleanArray: $4acbddc77dc5371b$var$validateBooleanArray,
    validateAbortSignalArray: $4acbddc77dc5371b$var$validateAbortSignalArray,
    validateBoolean: $4acbddc77dc5371b$var$validateBoolean,
    validateBuffer: $4acbddc77dc5371b$var$validateBuffer,
    validateDictionary: $4acbddc77dc5371b$var$validateDictionary,
    validateEncoding: $4acbddc77dc5371b$var$validateEncoding,
    validateFunction: $4acbddc77dc5371b$var$validateFunction,
    validateInt32: $4acbddc77dc5371b$var$validateInt32,
    validateInteger: $4acbddc77dc5371b$var$validateInteger,
    validateNumber: $4acbddc77dc5371b$var$validateNumber,
    validateObject: $4acbddc77dc5371b$var$validateObject,
    validateOneOf: $4acbddc77dc5371b$var$validateOneOf,
    validatePlainFunction: $4acbddc77dc5371b$var$validatePlainFunction,
    validatePort: $4acbddc77dc5371b$var$validatePort,
    validateSignalName: $4acbddc77dc5371b$var$validateSignalName,
    validateString: $4acbddc77dc5371b$var$validateString,
    validateUint32: $4acbddc77dc5371b$var$validateUint32,
    validateUndefined: $4acbddc77dc5371b$var$validateUndefined,
    validateUnion: $4acbddc77dc5371b$var$validateUnion,
    validateAbortSignal: $4acbddc77dc5371b$var$validateAbortSignal,
    validateLinkHeaderValue: $4acbddc77dc5371b$var$validateLinkHeaderValue
};

});



parcelRegister("insGM", function(module, exports) {
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $d610a10829238ace$require$StringPrototypeSlice = $6qlDJ.StringPrototypeSlice;
var $d610a10829238ace$require$SymbolIterator = $6qlDJ.SymbolIterator;
var $d610a10829238ace$require$TypedArrayPrototypeSet = $6qlDJ.TypedArrayPrototypeSet;
var $d610a10829238ace$require$Uint8Array = $6qlDJ.Uint8Array;

var $6ZWSX = parcelRequire("6ZWSX");
var $d610a10829238ace$require$Buffer = $6ZWSX.Buffer;

var $cSbri = parcelRequire("cSbri");
var $d610a10829238ace$require$inspect = $cSbri.inspect;
module.exports = class BufferList {
    constructor(){
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    push(v) {
        const entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    }
    unshift(v) {
        const entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    }
    shift() {
        if (this.length === 0) return;
        const ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    }
    clear() {
        this.head = this.tail = null;
        this.length = 0;
    }
    join(s) {
        if (this.length === 0) return "";
        let p = this.head;
        let ret = "" + p.data;
        while((p = p.next) !== null)ret += s + p.data;
        return ret;
    }
    concat(n) {
        if (this.length === 0) return $d610a10829238ace$require$Buffer.alloc(0);
        const ret = $d610a10829238ace$require$Buffer.allocUnsafe(n >>> 0);
        let p = this.head;
        let i = 0;
        while(p){
            $d610a10829238ace$require$TypedArrayPrototypeSet(ret, p.data, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    }
    // Consumes a specified amount of bytes or characters from the buffered data.
    consume(n, hasStrings) {
        const data = this.head.data;
        if (n < data.length) {
            // `slice` is the same for buffers and strings.
            const slice = data.slice(0, n);
            this.head.data = data.slice(n);
            return slice;
        }
        if (n === data.length) // First chunk is a perfect match.
        return this.shift();
        // Result spans more than one buffer.
        return hasStrings ? this._getString(n) : this._getBuffer(n);
    }
    first() {
        return this.head.data;
    }
    *[$d610a10829238ace$require$SymbolIterator]() {
        for(let p = this.head; p; p = p.next)yield p.data;
    }
    // Consumes a specified amount of characters from the buffered data.
    _getString(n) {
        let ret = "";
        let p = this.head;
        let c = 0;
        do {
            const str = p.data;
            if (n > str.length) {
                ret += str;
                n -= str.length;
            } else {
                if (n === str.length) {
                    ret += str;
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    ret += $d610a10829238ace$require$StringPrototypeSlice(str, 0, n);
                    this.head = p;
                    p.data = $d610a10829238ace$require$StringPrototypeSlice(str, n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Consumes a specified amount of bytes from the buffered data.
    _getBuffer(n) {
        const ret = $d610a10829238ace$require$Buffer.allocUnsafe(n);
        const retLen = n;
        let p = this.head;
        let c = 0;
        do {
            const buf = p.data;
            if (n > buf.length) {
                $d610a10829238ace$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                n -= buf.length;
            } else {
                if (n === buf.length) {
                    $d610a10829238ace$require$TypedArrayPrototypeSet(ret, buf, retLen - n);
                    ++c;
                    if (p.next) this.head = p.next;
                    else this.head = this.tail = null;
                } else {
                    $d610a10829238ace$require$TypedArrayPrototypeSet(ret, new $d610a10829238ace$require$Uint8Array(buf.buffer, buf.byteOffset, n), retLen - n);
                    this.head = p;
                    p.data = buf.slice(n);
                }
                break;
            }
            ++c;
        }while ((p = p.next) !== null);
        this.length -= c;
        return ret;
    }
    // Make sure the linked list only shows the minimal necessary information.
    [Symbol.for("nodejs.util.inspect.custom")](_, options) {
        return $d610a10829238ace$require$inspect(this, {
            ...options,
            // Only inspect one level.
            depth: 0,
            // It should not recurse.
            customInspect: false
        });
    }
};

});

parcelRegister("8Pe5V", function(module, exports) {
"use strict";

var $hPtJY = parcelRequire("hPtJY");

var $PWkkZ = parcelRequire("PWkkZ");
/* replacement end */ const { aggregateTwoErrors: $66ce05103b2a1e15$var$aggregateTwoErrors, codes: { ERR_MULTIPLE_CALLBACK: $66ce05103b2a1e15$var$ERR_MULTIPLE_CALLBACK }, AbortError: $66ce05103b2a1e15$var$AbortError } = $PWkkZ;

var $6qlDJ = parcelRequire("6qlDJ");
var $66ce05103b2a1e15$require$Symbol = $6qlDJ.Symbol;

var $dEd8A = parcelRequire("dEd8A");
var $66ce05103b2a1e15$require$kIsDestroyed = $dEd8A.kIsDestroyed;
var $66ce05103b2a1e15$require$isDestroyed = $dEd8A.isDestroyed;
var $66ce05103b2a1e15$require$isFinished = $dEd8A.isFinished;
var $66ce05103b2a1e15$require$isServerRequest = $dEd8A.isServerRequest;
const $66ce05103b2a1e15$var$kDestroy = $66ce05103b2a1e15$require$Symbol("kDestroy");
const $66ce05103b2a1e15$var$kConstruct = $66ce05103b2a1e15$require$Symbol("kConstruct");
function $66ce05103b2a1e15$var$checkError(err, w, r) {
    if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
    }
}
// Backwards compat. cb() is undocumented and unused in core but
// unfortunately might be used by modules.
function $66ce05103b2a1e15$var$destroy(err, cb) {
    const r = this._readableState;
    const w = this._writableState;
    // With duplex streams we use the writable side for state.
    const s = w || r;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) {
        if (typeof cb === "function") cb();
        return this;
    }
    // We set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    $66ce05103b2a1e15$var$checkError(err, w, r);
    if (w) w.destroyed = true;
    if (r) r.destroyed = true;
    // If still constructing then defer calling _destroy.
    if (!s.constructed) this.once($66ce05103b2a1e15$var$kDestroy, function(er) {
        $66ce05103b2a1e15$var$_destroy(this, $66ce05103b2a1e15$var$aggregateTwoErrors(er, err), cb);
    });
    else $66ce05103b2a1e15$var$_destroy(this, err, cb);
    return this;
}
function $66ce05103b2a1e15$var$_destroy(self, err, cb) {
    let called = false;
    function onDestroy(err) {
        if (called) return;
        called = true;
        const r = self._readableState;
        const w = self._writableState;
        $66ce05103b2a1e15$var$checkError(err, w, r);
        if (w) w.closed = true;
        if (r) r.closed = true;
        if (typeof cb === "function") cb(err);
        if (err) $hPtJY.nextTick($66ce05103b2a1e15$var$emitErrorCloseNT, self, err);
        else $hPtJY.nextTick($66ce05103b2a1e15$var$emitCloseNT, self);
    }
    try {
        self._destroy(err || null, onDestroy);
    } catch (err) {
        onDestroy(err);
    }
}
function $66ce05103b2a1e15$var$emitErrorCloseNT(self, err) {
    $66ce05103b2a1e15$var$emitErrorNT(self, err);
    $66ce05103b2a1e15$var$emitCloseNT(self);
}
function $66ce05103b2a1e15$var$emitCloseNT(self) {
    const r = self._readableState;
    const w = self._writableState;
    if (w) w.closeEmitted = true;
    if (r) r.closeEmitted = true;
    if (w !== null && w !== undefined && w.emitClose || r !== null && r !== undefined && r.emitClose) self.emit("close");
}
function $66ce05103b2a1e15$var$emitErrorNT(self, err) {
    const r = self._readableState;
    const w = self._writableState;
    if (w !== null && w !== undefined && w.errorEmitted || r !== null && r !== undefined && r.errorEmitted) return;
    if (w) w.errorEmitted = true;
    if (r) r.errorEmitted = true;
    self.emit("error", err);
}
function $66ce05103b2a1e15$var$undestroy() {
    const r = this._readableState;
    const w = this._writableState;
    if (r) {
        r.constructed = true;
        r.closed = false;
        r.closeEmitted = false;
        r.destroyed = false;
        r.errored = null;
        r.errorEmitted = false;
        r.reading = false;
        r.ended = r.readable === false;
        r.endEmitted = r.readable === false;
    }
    if (w) {
        w.constructed = true;
        w.destroyed = false;
        w.closed = false;
        w.closeEmitted = false;
        w.errored = null;
        w.errorEmitted = false;
        w.finalCalled = false;
        w.prefinished = false;
        w.ended = w.writable === false;
        w.ending = w.writable === false;
        w.finished = w.writable === false;
    }
}
function $66ce05103b2a1e15$var$errorOrDestroy(stream, err, sync) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    const r = stream._readableState;
    const w = stream._writableState;
    if (w !== null && w !== undefined && w.destroyed || r !== null && r !== undefined && r.destroyed) return this;
    if (r !== null && r !== undefined && r.autoDestroy || w !== null && w !== undefined && w.autoDestroy) stream.destroy(err);
    else if (err) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        err.stack // eslint-disable-line no-unused-expressions
        ;
        if (w && !w.errored) w.errored = err;
        if (r && !r.errored) r.errored = err;
        if (sync) $hPtJY.nextTick($66ce05103b2a1e15$var$emitErrorNT, stream, err);
        else $66ce05103b2a1e15$var$emitErrorNT(stream, err);
    }
}
function $66ce05103b2a1e15$var$construct(stream, cb) {
    if (typeof stream._construct !== "function") return;
    const r = stream._readableState;
    const w = stream._writableState;
    if (r) r.constructed = false;
    if (w) w.constructed = false;
    stream.once($66ce05103b2a1e15$var$kConstruct, cb);
    if (stream.listenerCount($66ce05103b2a1e15$var$kConstruct) > 1) // Duplex
    return;
    $hPtJY.nextTick($66ce05103b2a1e15$var$constructNT, stream);
}
function $66ce05103b2a1e15$var$constructNT(stream) {
    let called = false;
    function onConstruct(err) {
        if (called) {
            $66ce05103b2a1e15$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : new $66ce05103b2a1e15$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        const r = stream._readableState;
        const w = stream._writableState;
        const s = w || r;
        if (r) r.constructed = true;
        if (w) w.constructed = true;
        if (s.destroyed) stream.emit($66ce05103b2a1e15$var$kDestroy, err);
        else if (err) $66ce05103b2a1e15$var$errorOrDestroy(stream, err, true);
        else $hPtJY.nextTick($66ce05103b2a1e15$var$emitConstructNT, stream);
    }
    try {
        stream._construct((err)=>{
            $hPtJY.nextTick(onConstruct, err);
        });
    } catch (err) {
        $hPtJY.nextTick(onConstruct, err);
    }
}
function $66ce05103b2a1e15$var$emitConstructNT(stream) {
    stream.emit($66ce05103b2a1e15$var$kConstruct);
}
function $66ce05103b2a1e15$var$isRequest(stream) {
    return (stream === null || stream === undefined ? undefined : stream.setHeader) && typeof stream.abort === "function";
}
function $66ce05103b2a1e15$var$emitCloseLegacy(stream) {
    stream.emit("close");
}
function $66ce05103b2a1e15$var$emitErrorCloseLegacy(stream, err) {
    stream.emit("error", err);
    $hPtJY.nextTick($66ce05103b2a1e15$var$emitCloseLegacy, stream);
}
// Normalize destroy for legacy.
function $66ce05103b2a1e15$var$destroyer(stream, err) {
    if (!stream || $66ce05103b2a1e15$require$isDestroyed(stream)) return;
    if (!err && !$66ce05103b2a1e15$require$isFinished(stream)) err = new $66ce05103b2a1e15$var$AbortError();
    // TODO: Remove isRequest branches.
    if ($66ce05103b2a1e15$require$isServerRequest(stream)) {
        stream.socket = null;
        stream.destroy(err);
    } else if ($66ce05103b2a1e15$var$isRequest(stream)) stream.abort();
    else if ($66ce05103b2a1e15$var$isRequest(stream.req)) stream.req.abort();
    else if (typeof stream.destroy === "function") stream.destroy(err);
    else if (typeof stream.close === "function") // TODO: Don't lose err?
    stream.close();
    else if (err) $hPtJY.nextTick($66ce05103b2a1e15$var$emitErrorCloseLegacy, stream, err);
    else $hPtJY.nextTick($66ce05103b2a1e15$var$emitCloseLegacy, stream);
    if (!stream.destroyed) stream[$66ce05103b2a1e15$require$kIsDestroyed] = true;
}
module.exports = {
    construct: $66ce05103b2a1e15$var$construct,
    destroyer: $66ce05103b2a1e15$var$destroyer,
    destroy: $66ce05103b2a1e15$var$destroy,
    undestroy: $66ce05103b2a1e15$var$undestroy,
    errorOrDestroy: $66ce05103b2a1e15$var$errorOrDestroy
};

});

parcelRegister("5ZWSH", function(module, exports) {
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $45e052d35abe52fb$require$MathFloor = $6qlDJ.MathFloor;
var $45e052d35abe52fb$require$NumberIsInteger = $6qlDJ.NumberIsInteger;

var $6q8Dc = parcelRequire("6q8Dc");
var $45e052d35abe52fb$require$validateInteger = $6q8Dc.validateInteger;

var $PWkkZ = parcelRequire("PWkkZ");
const { ERR_INVALID_ARG_VALUE: $45e052d35abe52fb$var$ERR_INVALID_ARG_VALUE } = $PWkkZ.codes;
let $45e052d35abe52fb$var$defaultHighWaterMarkBytes = 16384;
let $45e052d35abe52fb$var$defaultHighWaterMarkObjectMode = 16;
function $45e052d35abe52fb$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $45e052d35abe52fb$var$getDefaultHighWaterMark(objectMode) {
    return objectMode ? $45e052d35abe52fb$var$defaultHighWaterMarkObjectMode : $45e052d35abe52fb$var$defaultHighWaterMarkBytes;
}
function $45e052d35abe52fb$var$setDefaultHighWaterMark(objectMode, value) {
    $45e052d35abe52fb$require$validateInteger(value, "value", 0);
    if (objectMode) $45e052d35abe52fb$var$defaultHighWaterMarkObjectMode = value;
    else $45e052d35abe52fb$var$defaultHighWaterMarkBytes = value;
}
function $45e052d35abe52fb$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    const hwm = $45e052d35abe52fb$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!$45e052d35abe52fb$require$NumberIsInteger(hwm) || hwm < 0) {
            const name = isDuplex ? `options.${duplexKey}` : "options.highWaterMark";
            throw new $45e052d35abe52fb$var$ERR_INVALID_ARG_VALUE(name, hwm);
        }
        return $45e052d35abe52fb$require$MathFloor(hwm);
    }
    // Default value
    return $45e052d35abe52fb$var$getDefaultHighWaterMark(state.objectMode);
}
module.exports = {
    getHighWaterMark: $45e052d35abe52fb$var$getHighWaterMark,
    getDefaultHighWaterMark: $45e052d35abe52fb$var$getDefaultHighWaterMark,
    setDefaultHighWaterMark: $45e052d35abe52fb$var$setDefaultHighWaterMark
};

});

parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});


parcelRegister("9gNIm", function(module, exports) {
"use strict";

var $hPtJY = parcelRequire("hPtJY");

var $6qlDJ = parcelRequire("6qlDJ");
var $6bfc2beb4df1a713$require$PromisePrototypeThen = $6qlDJ.PromisePrototypeThen;
var $6bfc2beb4df1a713$require$SymbolAsyncIterator = $6qlDJ.SymbolAsyncIterator;
var $6bfc2beb4df1a713$require$SymbolIterator = $6qlDJ.SymbolIterator;

var $6ZWSX = parcelRequire("6ZWSX");
var $6bfc2beb4df1a713$require$Buffer = $6ZWSX.Buffer;

var $PWkkZ = parcelRequire("PWkkZ");
const { ERR_INVALID_ARG_TYPE: $6bfc2beb4df1a713$var$ERR_INVALID_ARG_TYPE, ERR_STREAM_NULL_VALUES: $6bfc2beb4df1a713$var$ERR_STREAM_NULL_VALUES } = $PWkkZ.codes;
function $6bfc2beb4df1a713$var$from(Readable, iterable, opts) {
    let iterator;
    if (typeof iterable === "string" || iterable instanceof $6bfc2beb4df1a713$require$Buffer) return new Readable({
        objectMode: true,
        ...opts,
        read () {
            this.push(iterable);
            this.push(null);
        }
    });
    let isAsync;
    if (iterable && iterable[$6bfc2beb4df1a713$require$SymbolAsyncIterator]) {
        isAsync = true;
        iterator = iterable[$6bfc2beb4df1a713$require$SymbolAsyncIterator]();
    } else if (iterable && iterable[$6bfc2beb4df1a713$require$SymbolIterator]) {
        isAsync = false;
        iterator = iterable[$6bfc2beb4df1a713$require$SymbolIterator]();
    } else throw new $6bfc2beb4df1a713$var$ERR_INVALID_ARG_TYPE("iterable", [
        "Iterable"
    ], iterable);
    const readable = new Readable({
        objectMode: true,
        highWaterMark: 1,
        // TODO(ronag): What options should be allowed?
        ...opts
    });
    // Flag to protect against _read
    // being called before last iteration completion.
    let reading = false;
    readable._read = function() {
        if (!reading) {
            reading = true;
            next();
        }
    };
    readable._destroy = function(error, cb) {
        $6bfc2beb4df1a713$require$PromisePrototypeThen(close(error), ()=>$hPtJY.nextTick(cb, error), // nextTick is here in case cb throws
        (e)=>$hPtJY.nextTick(cb, e || error));
    };
    async function close(error) {
        const hadError = error !== undefined && error !== null;
        const hasThrow = typeof iterator.throw === "function";
        if (hadError && hasThrow) {
            const { value: value, done: done } = await iterator.throw(error);
            await value;
            if (done) return;
        }
        if (typeof iterator.return === "function") {
            const { value: value } = await iterator.return();
            await value;
        }
    }
    async function next() {
        for(;;){
            try {
                const { value: value, done: done } = isAsync ? await iterator.next() : iterator.next();
                if (done) readable.push(null);
                else {
                    const res = value && typeof value.then === "function" ? await value : value;
                    if (res === null) {
                        reading = false;
                        throw new $6bfc2beb4df1a713$var$ERR_STREAM_NULL_VALUES();
                    } else if (readable.push(res)) continue;
                    else reading = false;
                }
            } catch (err) {
                readable.destroy(err);
            }
            break;
        }
    }
    return readable;
}
module.exports = $6bfc2beb4df1a713$var$from;

});


parcelRegister("4uosb", function(module, exports) {
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $344ceeb902e9f356$require$ArrayPrototypeSlice = $6qlDJ.ArrayPrototypeSlice;
var $344ceeb902e9f356$require$Error = $6qlDJ.Error;
var $344ceeb902e9f356$require$FunctionPrototypeSymbolHasInstance = $6qlDJ.FunctionPrototypeSymbolHasInstance;
var $344ceeb902e9f356$require$ObjectDefineProperty = $6qlDJ.ObjectDefineProperty;
var $344ceeb902e9f356$require$ObjectDefineProperties = $6qlDJ.ObjectDefineProperties;
var $344ceeb902e9f356$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
var $344ceeb902e9f356$require$StringPrototypeToLowerCase = $6qlDJ.StringPrototypeToLowerCase;
var $344ceeb902e9f356$require$Symbol = $6qlDJ.Symbol;
var $344ceeb902e9f356$require$SymbolHasInstance = $6qlDJ.SymbolHasInstance;
module.exports = $344ceeb902e9f356$var$Writable;
$344ceeb902e9f356$var$Writable.WritableState = $344ceeb902e9f356$var$WritableState;

var $7etJZ = parcelRequire("7etJZ");
var $344ceeb902e9f356$require$EE = $7etJZ.EventEmitter;

var $8uq7s = parcelRequire("8uq7s");
var $344ceeb902e9f356$require$Stream = $8uq7s.Stream;

var $6ZWSX = parcelRequire("6ZWSX");
var $344ceeb902e9f356$require$Buffer = $6ZWSX.Buffer;

var $8Pe5V = parcelRequire("8Pe5V");

var $khx7T = parcelRequire("khx7T");
var $344ceeb902e9f356$require$addAbortSignal = $khx7T.addAbortSignal;

var $5ZWSH = parcelRequire("5ZWSH");
var $344ceeb902e9f356$require$getHighWaterMark = $5ZWSH.getHighWaterMark;
var $344ceeb902e9f356$require$getDefaultHighWaterMark = $5ZWSH.getDefaultHighWaterMark;

var $PWkkZ = parcelRequire("PWkkZ");
const { ERR_INVALID_ARG_TYPE: $344ceeb902e9f356$var$ERR_INVALID_ARG_TYPE, ERR_METHOD_NOT_IMPLEMENTED: $344ceeb902e9f356$var$ERR_METHOD_NOT_IMPLEMENTED, ERR_MULTIPLE_CALLBACK: $344ceeb902e9f356$var$ERR_MULTIPLE_CALLBACK, ERR_STREAM_CANNOT_PIPE: $344ceeb902e9f356$var$ERR_STREAM_CANNOT_PIPE, ERR_STREAM_DESTROYED: $344ceeb902e9f356$var$ERR_STREAM_DESTROYED, ERR_STREAM_ALREADY_FINISHED: $344ceeb902e9f356$var$ERR_STREAM_ALREADY_FINISHED, ERR_STREAM_NULL_VALUES: $344ceeb902e9f356$var$ERR_STREAM_NULL_VALUES, ERR_STREAM_WRITE_AFTER_END: $344ceeb902e9f356$var$ERR_STREAM_WRITE_AFTER_END, ERR_UNKNOWN_ENCODING: $344ceeb902e9f356$var$ERR_UNKNOWN_ENCODING } = $PWkkZ.codes;
const { errorOrDestroy: $344ceeb902e9f356$var$errorOrDestroy } = $8Pe5V;
$344ceeb902e9f356$require$ObjectSetPrototypeOf($344ceeb902e9f356$var$Writable.prototype, $344ceeb902e9f356$require$Stream.prototype);
$344ceeb902e9f356$require$ObjectSetPrototypeOf($344ceeb902e9f356$var$Writable, $344ceeb902e9f356$require$Stream);
function $344ceeb902e9f356$var$nop() {}
const $344ceeb902e9f356$var$kOnFinished = $344ceeb902e9f356$require$Symbol("kOnFinished");

function $344ceeb902e9f356$var$WritableState(options, stream, isDuplex) {
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof (parcelRequire("3ujhf"));
    // Object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!(options && options.objectMode);
    if (isDuplex) this.objectMode = this.objectMode || !!(options && options.writableObjectMode);
    // The point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write().
    this.highWaterMark = options ? $344ceeb902e9f356$require$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex) : $344ceeb902e9f356$require$getDefaultHighWaterMark(false);
    // if _final has been called.
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // At the start of calling end()
    this.ending = false;
    // When end() has been called, and returned.
    this.ended = false;
    // When 'finish' is emitted.
    this.finished = false;
    // Has it been destroyed
    this.destroyed = false;
    // Should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    const noDecode = !!(options && options.decodeStrings === false);
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options && options.defaultEncoding || "utf8";
    // Not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // A flag to see when we're in the middle of a write.
    this.writing = false;
    // When true all writes will be buffered until .uncork() call.
    this.corked = 0;
    // A flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // A flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // The callback that's passed to _write(chunk, cb).
    this.onwrite = $344ceeb902e9f356$var$onwrite.bind(undefined, stream);
    // The callback that the user supplies to write(chunk, encoding, cb).
    this.writecb = null;
    // The amount that is being written when _write is called.
    this.writelen = 0;
    // Storage for data passed to the afterWrite() callback in case of
    // synchronous _write() completion.
    this.afterWriteTickInfo = null;
    $344ceeb902e9f356$var$resetBuffer(this);
    // Number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted.
    this.pendingcb = 0;
    // Stream is still being constructed and cannot be
    // destroyed until construction finished or failed.
    // Async construction is opt in, therefore we start as
    // constructed.
    this.constructed = true;
    // Emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams.
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again.
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = !options || options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end').
    this.autoDestroy = !options || options.autoDestroy !== false;
    // Indicates whether the stream has errored. When true all write() calls
    // should return false. This is needed since when autoDestroy
    // is disabled we need a way to tell whether the stream has failed.
    this.errored = null;
    // Indicates whether the stream has finished destroying.
    this.closed = false;
    // True if close has been emitted or would have been emitted
    // depending on emitClose.
    this.closeEmitted = false;
    this[$344ceeb902e9f356$var$kOnFinished] = [];
}
function $344ceeb902e9f356$var$resetBuffer(state) {
    state.buffered = [];
    state.bufferedIndex = 0;
    state.allBuffers = true;
    state.allNoop = true;
}
$344ceeb902e9f356$var$WritableState.prototype.getBuffer = function getBuffer() {
    return $344ceeb902e9f356$require$ArrayPrototypeSlice(this.buffered, this.bufferedIndex);
};
$344ceeb902e9f356$require$ObjectDefineProperty($344ceeb902e9f356$var$WritableState.prototype, "bufferedRequestCount", {
    __proto__: null,
    get () {
        return this.buffered.length - this.bufferedIndex;
    }
});

function $344ceeb902e9f356$var$Writable(options) {
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5.
    const isDuplex = this instanceof (parcelRequire("3ujhf"));
    if (!isDuplex && !$344ceeb902e9f356$require$FunctionPrototypeSymbolHasInstance($344ceeb902e9f356$var$Writable, this)) return new $344ceeb902e9f356$var$Writable(options);
    this._writableState = new $344ceeb902e9f356$var$WritableState(options, this, isDuplex);
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
        if (typeof options.construct === "function") this._construct = options.construct;
        if (options.signal) $344ceeb902e9f356$require$addAbortSignal(options.signal, this);
    }
    $344ceeb902e9f356$require$Stream.call(this, options);
    $8Pe5V.construct(this, ()=>{
        const state = this._writableState;
        if (!state.writing) $344ceeb902e9f356$var$clearBuffer(this, state);
        $344ceeb902e9f356$var$finishMaybe(this, state);
    });
}
$344ceeb902e9f356$require$ObjectDefineProperty($344ceeb902e9f356$var$Writable, $344ceeb902e9f356$require$SymbolHasInstance, {
    __proto__: null,
    value: function(object) {
        if ($344ceeb902e9f356$require$FunctionPrototypeSymbolHasInstance(this, object)) return true;
        if (this !== $344ceeb902e9f356$var$Writable) return false;
        return object && object._writableState instanceof $344ceeb902e9f356$var$WritableState;
    }
});
// Otherwise people can pipe Writable streams, which is just wrong.
$344ceeb902e9f356$var$Writable.prototype.pipe = function() {
    $344ceeb902e9f356$var$errorOrDestroy(this, new $344ceeb902e9f356$var$ERR_STREAM_CANNOT_PIPE());
};
function $344ceeb902e9f356$var$_write(stream, chunk, encoding, cb) {
    const state = stream._writableState;
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = state.defaultEncoding;
    } else {
        if (!encoding) encoding = state.defaultEncoding;
        else if (encoding !== "buffer" && !$344ceeb902e9f356$require$Buffer.isEncoding(encoding)) throw new $344ceeb902e9f356$var$ERR_UNKNOWN_ENCODING(encoding);
        if (typeof cb !== "function") cb = $344ceeb902e9f356$var$nop;
    }
    if (chunk === null) throw new $344ceeb902e9f356$var$ERR_STREAM_NULL_VALUES();
    else if (!state.objectMode) {
        if (typeof chunk === "string") {
            if (state.decodeStrings !== false) {
                chunk = $344ceeb902e9f356$require$Buffer.from(chunk, encoding);
                encoding = "buffer";
            }
        } else if (chunk instanceof $344ceeb902e9f356$require$Buffer) encoding = "buffer";
        else if ($344ceeb902e9f356$require$Stream._isUint8Array(chunk)) {
            chunk = $344ceeb902e9f356$require$Stream._uint8ArrayToBuffer(chunk);
            encoding = "buffer";
        } else throw new $344ceeb902e9f356$var$ERR_INVALID_ARG_TYPE("chunk", [
            "string",
            "Buffer",
            "Uint8Array"
        ], chunk);
    }
    let err;
    if (state.ending) err = new $344ceeb902e9f356$var$ERR_STREAM_WRITE_AFTER_END();
    else if (state.destroyed) err = new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("write");
    if (err) {
        $hPtJY.nextTick(cb, err);
        $344ceeb902e9f356$var$errorOrDestroy(stream, err, true);
        return err;
    }
    state.pendingcb++;
    return $344ceeb902e9f356$var$writeOrBuffer(stream, state, chunk, encoding, cb);
}
$344ceeb902e9f356$var$Writable.prototype.write = function(chunk, encoding, cb) {
    return $344ceeb902e9f356$var$_write(this, chunk, encoding, cb) === true;
};
$344ceeb902e9f356$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$344ceeb902e9f356$var$Writable.prototype.uncork = function() {
    const state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing) $344ceeb902e9f356$var$clearBuffer(this, state);
    }
};
$344ceeb902e9f356$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = $344ceeb902e9f356$require$StringPrototypeToLowerCase(encoding);
    if (!$344ceeb902e9f356$require$Buffer.isEncoding(encoding)) throw new $344ceeb902e9f356$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
// If we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $344ceeb902e9f356$var$writeOrBuffer(stream, state, chunk, encoding, callback) {
    const len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    // stream._write resets state.length
    const ret = state.length < state.highWaterMark;
    // We must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked || state.errored || !state.constructed) {
        state.buffered.push({
            chunk: chunk,
            encoding: encoding,
            callback: callback
        });
        if (state.allBuffers && encoding !== "buffer") state.allBuffers = false;
        if (state.allNoop && callback !== $344ceeb902e9f356$var$nop) state.allNoop = false;
    } else {
        state.writelen = len;
        state.writecb = callback;
        state.writing = true;
        state.sync = true;
        stream._write(chunk, encoding, state.onwrite);
        state.sync = false;
    }
    // Return false if errored or destroyed in order to break
    // any synchronous while(stream.write(data)) loops.
    return ret && !state.errored && !state.destroyed;
}
function $344ceeb902e9f356$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $344ceeb902e9f356$var$onwriteError(stream, state, er, cb) {
    --state.pendingcb;
    cb(er);
    // Ensure callbacks are invoked even when autoDestroy is
    // not enabled. Passing `er` here doesn't make sense since
    // it's related to one specific write, not to the buffered
    // writes.
    $344ceeb902e9f356$var$errorBuffer(state);
    // This can emit error, but error must always follow cb.
    $344ceeb902e9f356$var$errorOrDestroy(stream, er);
}
function $344ceeb902e9f356$var$onwrite(stream, er) {
    const state = stream._writableState;
    const sync = state.sync;
    const cb = state.writecb;
    if (typeof cb !== "function") {
        $344ceeb902e9f356$var$errorOrDestroy(stream, new $344ceeb902e9f356$var$ERR_MULTIPLE_CALLBACK());
        return;
    }
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
    if (er) {
        // Avoid V8 leak, https://github.com/nodejs/node/pull/34103#issuecomment-652002364
        er.stack // eslint-disable-line no-unused-expressions
        ;
        if (!state.errored) state.errored = er;
        // In case of duplex streams we need to notify the readable side of the
        // error.
        if (stream._readableState && !stream._readableState.errored) stream._readableState.errored = er;
        if (sync) $hPtJY.nextTick($344ceeb902e9f356$var$onwriteError, stream, state, er, cb);
        else $344ceeb902e9f356$var$onwriteError(stream, state, er, cb);
    } else {
        if (state.buffered.length > state.bufferedIndex) $344ceeb902e9f356$var$clearBuffer(stream, state);
        if (sync) {
            // It is a common case that the callback passed to .write() is always
            // the same. In that case, we do not schedule a new nextTick(), but
            // rather just increase a counter, to improve performance and avoid
            // memory allocations.
            if (state.afterWriteTickInfo !== null && state.afterWriteTickInfo.cb === cb) state.afterWriteTickInfo.count++;
            else {
                state.afterWriteTickInfo = {
                    count: 1,
                    cb: cb,
                    stream: stream,
                    state: state
                };
                $hPtJY.nextTick($344ceeb902e9f356$var$afterWriteTick, state.afterWriteTickInfo);
            }
        } else $344ceeb902e9f356$var$afterWrite(stream, state, 1, cb);
    }
}
function $344ceeb902e9f356$var$afterWriteTick({ stream: stream, state: state, count: count, cb: cb }) {
    state.afterWriteTickInfo = null;
    return $344ceeb902e9f356$var$afterWrite(stream, state, count, cb);
}
function $344ceeb902e9f356$var$afterWrite(stream, state, count, cb) {
    const needDrain = !state.ending && !stream.destroyed && state.length === 0 && state.needDrain;
    if (needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
    while(count-- > 0){
        state.pendingcb--;
        cb();
    }
    if (state.destroyed) $344ceeb902e9f356$var$errorBuffer(state);
    $344ceeb902e9f356$var$finishMaybe(stream, state);
}
// If there's something in the buffer waiting, then invoke callbacks.
function $344ceeb902e9f356$var$errorBuffer(state) {
    if (state.writing) return;
    for(let n = state.bufferedIndex; n < state.buffered.length; ++n){
        var _state$errored;
        const { chunk: chunk, callback: callback } = state.buffered[n];
        const len = state.objectMode ? 1 : chunk.length;
        state.length -= len;
        callback((_state$errored = state.errored) !== null && _state$errored !== undefined ? _state$errored : new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("write"));
    }
    const onfinishCallbacks = state[$344ceeb902e9f356$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++){
        var _state$errored2;
        onfinishCallbacks[i]((_state$errored2 = state.errored) !== null && _state$errored2 !== undefined ? _state$errored2 : new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("end"));
    }
    $344ceeb902e9f356$var$resetBuffer(state);
}
// If there's something in the buffer waiting, then process it.
function $344ceeb902e9f356$var$clearBuffer(stream, state) {
    if (state.corked || state.bufferProcessing || state.destroyed || !state.constructed) return;
    const { buffered: buffered, bufferedIndex: bufferedIndex, objectMode: objectMode } = state;
    const bufferedLength = buffered.length - bufferedIndex;
    if (!bufferedLength) return;
    let i = bufferedIndex;
    state.bufferProcessing = true;
    if (bufferedLength > 1 && stream._writev) {
        state.pendingcb -= bufferedLength - 1;
        const callback = state.allNoop ? $344ceeb902e9f356$var$nop : (err)=>{
            for(let n = i; n < buffered.length; ++n)buffered[n].callback(err);
        };
        // Make a copy of `buffered` if it's going to be used by `callback` above,
        // since `doWrite` will mutate the array.
        const chunks = state.allNoop && i === 0 ? buffered : $344ceeb902e9f356$require$ArrayPrototypeSlice(buffered, i);
        chunks.allBuffers = state.allBuffers;
        $344ceeb902e9f356$var$doWrite(stream, state, true, state.length, chunks, "", callback);
        $344ceeb902e9f356$var$resetBuffer(state);
    } else {
        do {
            const { chunk: chunk, encoding: encoding, callback: callback } = buffered[i];
            buffered[i++] = null;
            const len = objectMode ? 1 : chunk.length;
            $344ceeb902e9f356$var$doWrite(stream, state, false, len, chunk, encoding, callback);
        }while (i < buffered.length && !state.writing);
        if (i === buffered.length) $344ceeb902e9f356$var$resetBuffer(state);
        else if (i > 256) {
            buffered.splice(0, i);
            state.bufferedIndex = 0;
        } else state.bufferedIndex = i;
    }
    state.bufferProcessing = false;
}
$344ceeb902e9f356$var$Writable.prototype._write = function(chunk, encoding, cb) {
    if (this._writev) this._writev([
        {
            chunk: chunk,
            encoding: encoding
        }
    ], cb);
    else throw new $344ceeb902e9f356$var$ERR_METHOD_NOT_IMPLEMENTED("_write()");
};
$344ceeb902e9f356$var$Writable.prototype._writev = null;
$344ceeb902e9f356$var$Writable.prototype.end = function(chunk, encoding, cb) {
    const state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    let err;
    if (chunk !== null && chunk !== undefined) {
        const ret = $344ceeb902e9f356$var$_write(this, chunk, encoding);
        if (ret instanceof $344ceeb902e9f356$require$Error) err = ret;
    }
    // .end() fully uncorks.
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    if (err) ;
    else if (!state.errored && !state.ending) {
        // This is forgiving in terms of unnecessary calls to end() and can hide
        // logic errors. However, usually such errors are harmless and causing a
        // hard error can be disproportionately destructive. It is not always
        // trivial for the user to determine whether end() needs to be called
        // or not.
        state.ending = true;
        $344ceeb902e9f356$var$finishMaybe(this, state, true);
        state.ended = true;
    } else if (state.finished) err = new $344ceeb902e9f356$var$ERR_STREAM_ALREADY_FINISHED("end");
    else if (state.destroyed) err = new $344ceeb902e9f356$var$ERR_STREAM_DESTROYED("end");
    if (typeof cb === "function") {
        if (err || state.finished) $hPtJY.nextTick(cb, err);
        else state[$344ceeb902e9f356$var$kOnFinished].push(cb);
    }
    return this;
};
function $344ceeb902e9f356$var$needFinish(state) {
    return state.ending && !state.destroyed && state.constructed && state.length === 0 && !state.errored && state.buffered.length === 0 && !state.finished && !state.writing && !state.errorEmitted && !state.closeEmitted;
}
function $344ceeb902e9f356$var$callFinal(stream, state) {
    let called = false;
    function onFinish(err) {
        if (called) {
            $344ceeb902e9f356$var$errorOrDestroy(stream, err !== null && err !== undefined ? err : $344ceeb902e9f356$var$ERR_MULTIPLE_CALLBACK());
            return;
        }
        called = true;
        state.pendingcb--;
        if (err) {
            const onfinishCallbacks = state[$344ceeb902e9f356$var$kOnFinished].splice(0);
            for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i](err);
            $344ceeb902e9f356$var$errorOrDestroy(stream, err, state.sync);
        } else if ($344ceeb902e9f356$var$needFinish(state)) {
            state.prefinished = true;
            stream.emit("prefinish");
            // Backwards compat. Don't check state.sync here.
            // Some streams assume 'finish' will be emitted
            // asynchronously relative to _final callback.
            state.pendingcb++;
            $hPtJY.nextTick($344ceeb902e9f356$var$finish, stream, state);
        }
    }
    state.sync = true;
    state.pendingcb++;
    try {
        stream._final(onFinish);
    } catch (err) {
        onFinish(err);
    }
    state.sync = false;
}
function $344ceeb902e9f356$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.finalCalled = true;
            $344ceeb902e9f356$var$callFinal(stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $344ceeb902e9f356$var$finishMaybe(stream, state, sync) {
    if ($344ceeb902e9f356$var$needFinish(state)) {
        $344ceeb902e9f356$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            if (sync) {
                state.pendingcb++;
                $hPtJY.nextTick((stream, state)=>{
                    if ($344ceeb902e9f356$var$needFinish(state)) $344ceeb902e9f356$var$finish(stream, state);
                    else state.pendingcb--;
                }, stream, state);
            } else if ($344ceeb902e9f356$var$needFinish(state)) {
                state.pendingcb++;
                $344ceeb902e9f356$var$finish(stream, state);
            }
        }
    }
}
function $344ceeb902e9f356$var$finish(stream, state) {
    state.pendingcb--;
    state.finished = true;
    const onfinishCallbacks = state[$344ceeb902e9f356$var$kOnFinished].splice(0);
    for(let i = 0; i < onfinishCallbacks.length; i++)onfinishCallbacks[i]();
    stream.emit("finish");
    if (state.autoDestroy) {
        // In case of duplex streams we need a way to detect
        // if the readable side is ready for autoDestroy as well.
        const rState = stream._readableState;
        const autoDestroy = !rState || rState.autoDestroy && // We don't expect the readable to ever 'end'
        // if readable is explicitly set to false.
        (rState.endEmitted || rState.readable === false);
        if (autoDestroy) stream.destroy();
    }
}
$344ceeb902e9f356$require$ObjectDefineProperties($344ceeb902e9f356$var$Writable.prototype, {
    closed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.closed : false;
        }
    },
    destroyed: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.destroyed : false;
        },
        set (value) {
            // Backward compatibility, the user is explicitly managing destroyed.
            if (this._writableState) this._writableState.destroyed = value;
        }
    },
    writable: {
        __proto__: null,
        get () {
            const w = this._writableState;
            // w.writable === false means that this is part of a Duplex stream
            // where the writable side was disabled upon construction.
            // Compat. The user might manually disable writable side through
            // deprecated setter.
            return !!w && w.writable !== false && !w.destroyed && !w.errored && !w.ending && !w.ended;
        },
        set (val) {
            // Backwards compatible.
            if (this._writableState) this._writableState.writable = !!val;
        }
    },
    writableFinished: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.finished : false;
        }
    },
    writableObjectMode: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.objectMode : false;
        }
    },
    writableBuffer: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.getBuffer();
        }
    },
    writableEnded: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.ending : false;
        }
    },
    writableNeedDrain: {
        __proto__: null,
        get () {
            const wState = this._writableState;
            if (!wState) return false;
            return !wState.destroyed && !wState.ending && wState.needDrain;
        }
    },
    writableHighWaterMark: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.highWaterMark;
        }
    },
    writableCorked: {
        __proto__: null,
        get () {
            return this._writableState ? this._writableState.corked : 0;
        }
    },
    writableLength: {
        __proto__: null,
        get () {
            return this._writableState && this._writableState.length;
        }
    },
    errored: {
        __proto__: null,
        enumerable: false,
        get () {
            return this._writableState ? this._writableState.errored : null;
        }
    },
    writableAborted: {
        __proto__: null,
        enumerable: false,
        get: function() {
            return !!(this._writableState.writable !== false && (this._writableState.destroyed || this._writableState.errored) && !this._writableState.finished);
        }
    }
});
const $344ceeb902e9f356$var$destroy = $8Pe5V.destroy;
$344ceeb902e9f356$var$Writable.prototype.destroy = function(err, cb) {
    const state = this._writableState;
    // Invoke pending callbacks.
    if (!state.destroyed && (state.bufferedIndex < state.buffered.length || state[$344ceeb902e9f356$var$kOnFinished].length)) $hPtJY.nextTick($344ceeb902e9f356$var$errorBuffer, state);
    $344ceeb902e9f356$var$destroy.call(this, err, cb);
    return this;
};
$344ceeb902e9f356$var$Writable.prototype._undestroy = $8Pe5V.undestroy;
$344ceeb902e9f356$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};
$344ceeb902e9f356$var$Writable.prototype[$344ceeb902e9f356$require$EE.captureRejectionSymbol] = function(err) {
    this.destroy(err);
};
let $344ceeb902e9f356$var$webStreamsAdapters;
// Lazy to avoid circular references
function $344ceeb902e9f356$var$lazyWebStreams() {
    if ($344ceeb902e9f356$var$webStreamsAdapters === undefined) $344ceeb902e9f356$var$webStreamsAdapters = {};
    return $344ceeb902e9f356$var$webStreamsAdapters;
}
$344ceeb902e9f356$var$Writable.fromWeb = function(writableStream, options) {
    return $344ceeb902e9f356$var$lazyWebStreams().newStreamWritableFromWritableStream(writableStream, options);
};
$344ceeb902e9f356$var$Writable.toWeb = function(streamWritable) {
    return $344ceeb902e9f356$var$lazyWebStreams().newWritableStreamFromStreamWritable(streamWritable);
};

});

parcelRegister("dq9MZ", function(module, exports) {
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");

var $dEd8A = parcelRequire("dEd8A");
var $9c554bfbf13c0cee$require$isReadable = $dEd8A.isReadable;
var $9c554bfbf13c0cee$require$isWritable = $dEd8A.isWritable;
var $9c554bfbf13c0cee$require$isIterable = $dEd8A.isIterable;
var $9c554bfbf13c0cee$require$isNodeStream = $dEd8A.isNodeStream;
var $9c554bfbf13c0cee$require$isReadableNodeStream = $dEd8A.isReadableNodeStream;
var $9c554bfbf13c0cee$require$isWritableNodeStream = $dEd8A.isWritableNodeStream;
var $9c554bfbf13c0cee$require$isDuplexNodeStream = $dEd8A.isDuplexNodeStream;
var $9c554bfbf13c0cee$require$isReadableStream = $dEd8A.isReadableStream;
var $9c554bfbf13c0cee$require$isWritableStream = $dEd8A.isWritableStream;

var $52Cjj = parcelRequire("52Cjj");

var $PWkkZ = parcelRequire("PWkkZ");
const { AbortError: $9c554bfbf13c0cee$var$AbortError, codes: { ERR_INVALID_ARG_TYPE: $9c554bfbf13c0cee$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $9c554bfbf13c0cee$var$ERR_INVALID_RETURN_VALUE } } = $PWkkZ;

var $8Pe5V = parcelRequire("8Pe5V");
var $9c554bfbf13c0cee$require$destroyer = $8Pe5V.destroyer;

var $3ujhf = parcelRequire("3ujhf");

var $6BZaW = parcelRequire("6BZaW");

var $4uosb = parcelRequire("4uosb");

var $cSbri = parcelRequire("cSbri");
var $9c554bfbf13c0cee$require$createDeferredPromise = $cSbri.createDeferredPromise;

var $9gNIm = parcelRequire("9gNIm");
const $9c554bfbf13c0cee$var$Blob = globalThis.Blob || $6ZWSX.Blob;
const $9c554bfbf13c0cee$var$isBlob = typeof $9c554bfbf13c0cee$var$Blob !== "undefined" ? function isBlob(b) {
    return b instanceof $9c554bfbf13c0cee$var$Blob;
} : function isBlob(b) {
    return false;
};

const $9c554bfbf13c0cee$var$AbortController = globalThis.AbortController || (parcelRequire("bHKGd")).AbortController;

var $6qlDJ = parcelRequire("6qlDJ");
var $9c554bfbf13c0cee$require$FunctionPrototypeCall = $6qlDJ.FunctionPrototypeCall;
// This is needed for pre node 17.
class $9c554bfbf13c0cee$var$Duplexify extends $3ujhf {
    constructor(options){
        super(options);
        // https://github.com/nodejs/node/pull/34385
        if ((options === null || options === undefined ? undefined : options.readable) === false) {
            this._readableState.readable = false;
            this._readableState.ended = true;
            this._readableState.endEmitted = true;
        }
        if ((options === null || options === undefined ? undefined : options.writable) === false) {
            this._writableState.writable = false;
            this._writableState.ending = true;
            this._writableState.ended = true;
            this._writableState.finished = true;
        }
    }
}
module.exports = function duplexify(body, name) {
    if ($9c554bfbf13c0cee$require$isDuplexNodeStream(body)) return body;
    if ($9c554bfbf13c0cee$require$isReadableNodeStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        readable: body
    });
    if ($9c554bfbf13c0cee$require$isWritableNodeStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        writable: body
    });
    if ($9c554bfbf13c0cee$require$isNodeStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        writable: false,
        readable: false
    });
    if ($9c554bfbf13c0cee$require$isReadableStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        readable: $6BZaW.fromWeb(body)
    });
    if ($9c554bfbf13c0cee$require$isWritableStream(body)) return $9c554bfbf13c0cee$var$_duplexify({
        writable: $4uosb.fromWeb(body)
    });
    if (typeof body === "function") {
        const { value: value, write: write, final: final, destroy: destroy } = $9c554bfbf13c0cee$var$fromAsyncGen(body);
        if ($9c554bfbf13c0cee$require$isIterable(value)) return $9gNIm($9c554bfbf13c0cee$var$Duplexify, value, {
            // TODO (ronag): highWaterMark?
            objectMode: true,
            write: write,
            final: final,
            destroy: destroy
        });
        const then = value === null || value === undefined ? undefined : value.then;
        if (typeof then === "function") {
            let d;
            const promise = $9c554bfbf13c0cee$require$FunctionPrototypeCall(then, value, (val)=>{
                if (val != null) throw new $9c554bfbf13c0cee$var$ERR_INVALID_RETURN_VALUE("nully", "body", val);
            }, (err)=>{
                $9c554bfbf13c0cee$require$destroyer(d, err);
            });
            return d = new $9c554bfbf13c0cee$var$Duplexify({
                // TODO (ronag): highWaterMark?
                objectMode: true,
                readable: false,
                write: write,
                final (cb) {
                    final(async ()=>{
                        try {
                            await promise;
                            $hPtJY.nextTick(cb, null);
                        } catch (err) {
                            $hPtJY.nextTick(cb, err);
                        }
                    });
                },
                destroy: destroy
            });
        }
        throw new $9c554bfbf13c0cee$var$ERR_INVALID_RETURN_VALUE("Iterable, AsyncIterable or AsyncFunction", name, value);
    }
    if ($9c554bfbf13c0cee$var$isBlob(body)) return duplexify(body.arrayBuffer());
    if ($9c554bfbf13c0cee$require$isIterable(body)) return $9gNIm($9c554bfbf13c0cee$var$Duplexify, body, {
        // TODO (ronag): highWaterMark?
        objectMode: true,
        writable: false
    });
    if ($9c554bfbf13c0cee$require$isReadableStream(body === null || body === undefined ? undefined : body.readable) && $9c554bfbf13c0cee$require$isWritableStream(body === null || body === undefined ? undefined : body.writable)) return $9c554bfbf13c0cee$var$Duplexify.fromWeb(body);
    if (typeof (body === null || body === undefined ? undefined : body.writable) === "object" || typeof (body === null || body === undefined ? undefined : body.readable) === "object") {
        const readable = body !== null && body !== undefined && body.readable ? $9c554bfbf13c0cee$require$isReadableNodeStream(body === null || body === undefined ? undefined : body.readable) ? body === null || body === undefined ? undefined : body.readable : duplexify(body.readable) : undefined;
        const writable = body !== null && body !== undefined && body.writable ? $9c554bfbf13c0cee$require$isWritableNodeStream(body === null || body === undefined ? undefined : body.writable) ? body === null || body === undefined ? undefined : body.writable : duplexify(body.writable) : undefined;
        return $9c554bfbf13c0cee$var$_duplexify({
            readable: readable,
            writable: writable
        });
    }
    const then = body === null || body === undefined ? undefined : body.then;
    if (typeof then === "function") {
        let d;
        $9c554bfbf13c0cee$require$FunctionPrototypeCall(then, body, (val)=>{
            if (val != null) d.push(val);
            d.push(null);
        }, (err)=>{
            $9c554bfbf13c0cee$require$destroyer(d, err);
        });
        return d = new $9c554bfbf13c0cee$var$Duplexify({
            objectMode: true,
            writable: false,
            read () {}
        });
    }
    throw new $9c554bfbf13c0cee$var$ERR_INVALID_ARG_TYPE(name, [
        "Blob",
        "ReadableStream",
        "WritableStream",
        "Stream",
        "Iterable",
        "AsyncIterable",
        "Function",
        "{ readable, writable } pair",
        "Promise"
    ], body);
};
function $9c554bfbf13c0cee$var$fromAsyncGen(fn) {
    let { promise: promise, resolve: resolve } = $9c554bfbf13c0cee$require$createDeferredPromise();
    const ac = new $9c554bfbf13c0cee$var$AbortController();
    const signal = ac.signal;
    const value = fn(async function*() {
        while(true){
            const _promise = promise;
            promise = null;
            const { chunk: chunk, done: done, cb: cb } = await _promise;
            $hPtJY.nextTick(cb);
            if (done) return;
            if (signal.aborted) throw new $9c554bfbf13c0cee$var$AbortError(undefined, {
                cause: signal.reason
            });
            ({ promise: promise, resolve: resolve } = $9c554bfbf13c0cee$require$createDeferredPromise());
            yield chunk;
        }
    }(), {
        signal: signal
    });
    return {
        value: value,
        write (chunk, encoding, cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                chunk: chunk,
                done: false,
                cb: cb
            });
        },
        final (cb) {
            const _resolve = resolve;
            resolve = null;
            _resolve({
                done: true,
                cb: cb
            });
        },
        destroy (err, cb) {
            ac.abort();
            cb(err);
        }
    };
}
function $9c554bfbf13c0cee$var$_duplexify(pair) {
    const r = pair.readable && typeof pair.readable.read !== "function" ? $6BZaW.wrap(pair.readable) : pair.readable;
    const w = pair.writable;
    let readable = !!$9c554bfbf13c0cee$require$isReadable(r);
    let writable = !!$9c554bfbf13c0cee$require$isWritable(w);
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
    }
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $9c554bfbf13c0cee$var$Duplexify({
        // TODO (ronag): highWaterMark?
        readableObjectMode: !!(r !== null && r !== undefined && r.readableObjectMode),
        writableObjectMode: !!(w !== null && w !== undefined && w.writableObjectMode),
        readable: readable,
        writable: writable
    });
    if (writable) {
        $52Cjj(w, (err)=>{
            writable = false;
            if (err) $9c554bfbf13c0cee$require$destroyer(r, err);
            onfinished(err);
        });
        d._write = function(chunk, encoding, callback) {
            if (w.write(chunk, encoding)) callback();
            else ondrain = callback;
        };
        d._final = function(callback) {
            w.end();
            onfinish = callback;
        };
        w.on("drain", function() {
            if (ondrain) {
                const cb = ondrain;
                ondrain = null;
                cb();
            }
        });
        w.on("finish", function() {
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        $52Cjj(r, (err)=>{
            readable = false;
            if (err) $9c554bfbf13c0cee$require$destroyer(r, err);
            onfinished(err);
        });
        r.on("readable", function() {
            if (onreadable) {
                const cb = onreadable;
                onreadable = null;
                cb();
            }
        });
        r.on("end", function() {
            d.push(null);
        });
        d._read = function() {
            while(true){
                const buf = r.read();
                if (buf === null) {
                    onreadable = d._read;
                    return;
                }
                if (!d.push(buf)) return;
            }
        };
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $9c554bfbf13c0cee$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            $9c554bfbf13c0cee$require$destroyer(w, err);
            $9c554bfbf13c0cee$require$destroyer(r, err);
        }
    };
    return d;
}

});


parcelRegister("iXAaU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $dcd9cc4274c6eced$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
module.exports = $dcd9cc4274c6eced$var$PassThrough;

var $3LvcR = parcelRequire("3LvcR");
$dcd9cc4274c6eced$require$ObjectSetPrototypeOf($dcd9cc4274c6eced$var$PassThrough.prototype, $3LvcR.prototype);
$dcd9cc4274c6eced$require$ObjectSetPrototypeOf($dcd9cc4274c6eced$var$PassThrough, $3LvcR);
function $dcd9cc4274c6eced$var$PassThrough(options) {
    if (!(this instanceof $dcd9cc4274c6eced$var$PassThrough)) return new $dcd9cc4274c6eced$var$PassThrough(options);
    $3LvcR.call(this, options);
}
$dcd9cc4274c6eced$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});
parcelRegister("3LvcR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $2bddf7d853db3b47$require$ObjectSetPrototypeOf = $6qlDJ.ObjectSetPrototypeOf;
var $2bddf7d853db3b47$require$Symbol = $6qlDJ.Symbol;
module.exports = $2bddf7d853db3b47$var$Transform;

var $PWkkZ = parcelRequire("PWkkZ");
const { ERR_METHOD_NOT_IMPLEMENTED: $2bddf7d853db3b47$var$ERR_METHOD_NOT_IMPLEMENTED } = $PWkkZ.codes;

var $3ujhf = parcelRequire("3ujhf");

var $5ZWSH = parcelRequire("5ZWSH");
var $2bddf7d853db3b47$require$getHighWaterMark = $5ZWSH.getHighWaterMark;
$2bddf7d853db3b47$require$ObjectSetPrototypeOf($2bddf7d853db3b47$var$Transform.prototype, $3ujhf.prototype);
$2bddf7d853db3b47$require$ObjectSetPrototypeOf($2bddf7d853db3b47$var$Transform, $3ujhf);
const $2bddf7d853db3b47$var$kCallback = $2bddf7d853db3b47$require$Symbol("kCallback");
function $2bddf7d853db3b47$var$Transform(options) {
    if (!(this instanceof $2bddf7d853db3b47$var$Transform)) return new $2bddf7d853db3b47$var$Transform(options);
    // TODO (ronag): This should preferably always be
    // applied but would be semver-major. Or even better;
    // make Transform a Readable with the Writable interface.
    const readableHighWaterMark = options ? $2bddf7d853db3b47$require$getHighWaterMark(this, options, "readableHighWaterMark", true) : null;
    if (readableHighWaterMark === 0) // A Duplex will buffer both on the writable and readable side while
    // a Transform just wants to buffer hwm number of elements. To avoid
    // buffering twice we disable buffering on the writable side.
    options = {
        ...options,
        highWaterMark: null,
        readableHighWaterMark: readableHighWaterMark,
        // TODO (ronag): 0 is not optimal since we have
        // a "bug" where we check needDrain before calling _write and not after.
        // Refs: https://github.com/nodejs/node/pull/32887
        // Refs: https://github.com/nodejs/node/pull/35941
        writableHighWaterMark: options.writableHighWaterMark || 0
    };
    $3ujhf.call(this, options);
    // We have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    this[$2bddf7d853db3b47$var$kCallback] = null;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    // Backwards compat. Some Transform streams incorrectly implement _final
    // instead of or in addition to _flush. By using 'prefinish' instead of
    // implementing _final we continue supporting this unfortunate use case.
    this.on("prefinish", $2bddf7d853db3b47$var$prefinish);
}
function $2bddf7d853db3b47$var$final(cb) {
    if (typeof this._flush === "function" && !this.destroyed) this._flush((er, data)=>{
        if (er) {
            if (cb) cb(er);
            else this.destroy(er);
            return;
        }
        if (data != null) this.push(data);
        this.push(null);
        if (cb) cb();
    });
    else {
        this.push(null);
        if (cb) cb();
    }
}
function $2bddf7d853db3b47$var$prefinish() {
    if (this._final !== $2bddf7d853db3b47$var$final) $2bddf7d853db3b47$var$final.call(this);
}
$2bddf7d853db3b47$var$Transform.prototype._final = $2bddf7d853db3b47$var$final;
$2bddf7d853db3b47$var$Transform.prototype._transform = function(chunk, encoding, callback) {
    throw new $2bddf7d853db3b47$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()");
};
$2bddf7d853db3b47$var$Transform.prototype._write = function(chunk, encoding, callback) {
    const rState = this._readableState;
    const wState = this._writableState;
    const length = rState.length;
    this._transform(chunk, encoding, (err, val)=>{
        if (err) {
            callback(err);
            return;
        }
        if (val != null) this.push(val);
        if (wState.ended || // Backwards compat.
        length === rState.length || // Backwards compat.
        rState.length < rState.highWaterMark) callback();
        else this[$2bddf7d853db3b47$var$kCallback] = callback;
    });
};
$2bddf7d853db3b47$var$Transform.prototype._read = function() {
    if (this[$2bddf7d853db3b47$var$kCallback]) {
        const callback = this[$2bddf7d853db3b47$var$kCallback];
        this[$2bddf7d853db3b47$var$kCallback] = null;
        callback();
    }
};

});


parcelRegister("R5nvG", function(module, exports) {
var global = typeof self !== "undefined" ? self : this;
var __self__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = global.DOMException;
    }
    F.prototype = global;
    return new F();
}();
(function(self1) {
    var irrelevant = function(exports1) {
        var support = {
            searchParams: "URLSearchParams" in self1,
            iterable: "Symbol" in self1 && "iterator" in Symbol,
            blob: "FileReader" in self1 && "Blob" in self1 && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in self1,
            arrayBuffer: "ArrayBuffer" in self1
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) throw new TypeError("Invalid character in header field name");
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsText(blob);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                this._bodyInit = body;
                if (!body) this._bodyText = "";
                else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) {
                this.blob = function() {
                    var rejected = consumed(this);
                    if (rejected) return rejected;
                    if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                    else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                        this._bodyArrayBuffer
                    ]));
                    else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                    else return Promise.resolve(new Blob([
                        this._bodyText
                    ]));
                };
                this.arrayBuffer = function() {
                    if (this._bodyArrayBuffer) return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
                    else return this.blob().then(readBlobAsArrayBuffer);
                };
            }
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "POST",
            "PUT"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal;
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    headers.append(key, value);
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = "statusText" in options ? options.statusText : "OK";
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 0,
                statusText: ""
            });
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = self1.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        status: xhr.status,
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    resolve(new Response(body, options));
                };
                xhr.onerror = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.ontimeout = function() {
                    reject(new TypeError("Network request failed"));
                };
                xhr.onabort = function() {
                    reject(new exports1.DOMException("Aborted", "AbortError"));
                };
                xhr.open(request.method, request.url, true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr && support.blob) xhr.responseType = "blob";
                request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!self1.fetch) {
            self1.fetch = fetch;
            self1.Headers = Headers;
            self1.Request = Request;
            self1.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

exports.finished = (parcelRequire("fiCvv"));

exports.pipeline = (parcelRequire("aGSwO"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
"use strict";

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});


parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $abf00c68ae11d39d$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});


parcelRegister("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});

parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});



parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});

parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $jX0xT(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $jX0xT(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("i46nc", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});


parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {
"use strict";

var $ljw8S = parcelRequire("ljw8S");

var $89TTw = parcelRequire("89TTw");

var $dlqwk = parcelRequire("dlqwk");
const $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $dlqwk(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($89TTw[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($ljw8S[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("ljw8S", function(module, exports) {
"use strict";
const $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $1ae2666fc718ae87$require$Buffer = $5ZrzL.Buffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $h4y6g);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $1ae2666fc718ae87$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $1ae2666fc718ae87$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $1ae2666fc718ae87$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $1ae2666fc718ae87$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getUTCFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $1ae2666fc718ae87$require$Buffer.from(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $1ae2666fc718ae87$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($1ae2666fc718ae87$require$Buffer.from(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1G1m0.tagByName.hasOwnProperty(tag)) res = $1G1m0.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1G1m0.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("5ZrzL", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $45c80a3e8b7e5b65$var$Buffer = $6ZWSX.Buffer;
var $45c80a3e8b7e5b65$var$safer = {};
var $45c80a3e8b7e5b65$var$key;
for($45c80a3e8b7e5b65$var$key in $6ZWSX){
    if (!$6ZWSX.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "SlowBuffer" || $45c80a3e8b7e5b65$var$key === "Buffer") continue;
    $45c80a3e8b7e5b65$var$safer[$45c80a3e8b7e5b65$var$key] = $6ZWSX[$45c80a3e8b7e5b65$var$key];
}
var $45c80a3e8b7e5b65$var$Safer = $45c80a3e8b7e5b65$var$safer.Buffer = {};
for($45c80a3e8b7e5b65$var$key in $45c80a3e8b7e5b65$var$Buffer){
    if (!$45c80a3e8b7e5b65$var$Buffer.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === "allocUnsafe" || $45c80a3e8b7e5b65$var$key === "allocUnsafeSlow") continue;
    $45c80a3e8b7e5b65$var$Safer[$45c80a3e8b7e5b65$var$key] = $45c80a3e8b7e5b65$var$Buffer[$45c80a3e8b7e5b65$var$key];
}
$45c80a3e8b7e5b65$var$safer.Buffer.prototype = $45c80a3e8b7e5b65$var$Buffer.prototype;
if (!$45c80a3e8b7e5b65$var$Safer.from || $45c80a3e8b7e5b65$var$Safer.from === Uint8Array.from) $45c80a3e8b7e5b65$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $45c80a3e8b7e5b65$var$Buffer(value, encodingOrOffset, length);
};
if (!$45c80a3e8b7e5b65$var$Safer.alloc) $45c80a3e8b7e5b65$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $45c80a3e8b7e5b65$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$45c80a3e8b7e5b65$var$safer.kStringMaxLength) try {
    $45c80a3e8b7e5b65$var$safer.kStringMaxLength = $hPtJY.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$45c80a3e8b7e5b65$var$safer.constants) {
    $45c80a3e8b7e5b65$var$safer.constants = {
        MAX_LENGTH: $45c80a3e8b7e5b65$var$safer.kMaxLength
    };
    if ($45c80a3e8b7e5b65$var$safer.kStringMaxLength) $45c80a3e8b7e5b65$var$safer.constants.MAX_STRING_LENGTH = $45c80a3e8b7e5b65$var$safer.kStringMaxLength;
}
module.exports = $45c80a3e8b7e5b65$var$safer;

});

parcelRegister("h4y6g", function(module, exports) {
"use strict";

var $k2jVB = parcelRequire("k2jVB");
var $c6dd42f3395d566f$require$Reporter = $k2jVB.Reporter;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$EncoderBuffer = $33sbF.EncoderBuffer;

var $33sbF = parcelRequire("33sbF");
var $c6dd42f3395d566f$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
const $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
const $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
const $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    const state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;
"use strict";

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $k2jVB = parcelRequire("k2jVB");
var $2397844df508f52e$require$Reporter = $k2jVB.Reporter;

var $5ZrzL = parcelRequire("5ZrzL");
var $2397844df508f52e$require$Buffer = $5ZrzL.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $2397844df508f52e$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer(item)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $2397844df508f52e$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $2397844df508f52e$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;
"use strict";
// Helper
function $138ac3909863432c$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $138ac3909863432c$var$reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $138ac3909863432c$var$reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("bPffB", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $2j6ve.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("89TTw", function(module, exports) {
"use strict";
const $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $9qVGS = parcelRequire("9qVGS");

var $33sbF = parcelRequire("33sbF");
var $b28be291c8d179e1$require$DecoderBuffer = $33sbF.DecoderBuffer;

var $h4y6g = parcelRequire("h4y6g");

var $1G1m0 = parcelRequire("1G1m0");
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$b28be291c8d179e1$require$DecoderBuffer.isDecoderBuffer(data)) data = new $b28be291c8d179e1$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $h4y6g.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $h4y6g);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $9qVGS(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $1G1m0.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $1G1m0.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $5ZrzL = parcelRequire("5ZrzL");
var $6ef8062b6cdbe0f4$require$Buffer = $5ZrzL.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $6ef8062b6cdbe0f4$require$Buffer.from(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});



parcelRegister("5JhaY", function(module, exports) {
"use strict";
const $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});

parcelRegister("3TcQc", function(module, exports) {
"use strict";
const $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});

parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});
parcelRegister("10gXo", function(module, exports) {
"use strict";
const $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});


parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});

parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("aNeDF", function(module, exports) {

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
module.exports = $7db9d5f82e4113aa$var$parseKeys;
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this.int();
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});

parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("3ILSx", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});

parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});



parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});


parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});

parcelRegister("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("jUw11", function(module, exports) {

$parcel$export(module.exports, "Wildcard", () => $e7ec14ea02a2a4bf$export$10fd9b2de72cfe8c, (v) => $e7ec14ea02a2a4bf$export$10fd9b2de72cfe8c = v);
// Wildcard constructor
var $e7ec14ea02a2a4bf$export$10fd9b2de72cfe8c;
class $e7ec14ea02a2a4bf$var$Wildcard {
    constructor(){
        return $e7ec14ea02a2a4bf$var$WILDCARD || this;
    }
    equals(other) {
        return other && this.termType === other.termType;
    }
}
Object.defineProperty($e7ec14ea02a2a4bf$var$Wildcard.prototype, "value", {
    enumerable: true,
    value: "*"
});
Object.defineProperty($e7ec14ea02a2a4bf$var$Wildcard.prototype, "termType", {
    enumerable: true,
    value: "Wildcard"
});
// Wildcard singleton
var $e7ec14ea02a2a4bf$var$WILDCARD = new $e7ec14ea02a2a4bf$var$Wildcard();
$e7ec14ea02a2a4bf$export$10fd9b2de72cfe8c = $e7ec14ea02a2a4bf$var$Wildcard;

});

parcelRegister("dUwlf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlankNode = void 0;
/**
 * A term that represents an RDF blank node with a label.
 */ class $a20997b43a187c27$var$BlankNode {
    constructor(value){
        this.termType = "BlankNode";
        this.value = value;
    }
    equals(other) {
        return !!other && other.termType === "BlankNode" && other.value === this.value;
    }
}
module.exports.BlankNode = $a20997b43a187c27$var$BlankNode;

});

parcelRegister("3wL3n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataFactory = void 0;

var $dUwlf = parcelRequire("dUwlf");

var $0UUif = parcelRequire("0UUif");

var $8RsDA = parcelRequire("8RsDA");

var $7KJsK = parcelRequire("7KJsK");

var $1k2AX = parcelRequire("1k2AX");

var $kNA9K = parcelRequire("kNA9K");
let $2918dc15ed9a49cb$var$dataFactoryCounter = 0;
/**
 * A factory for instantiating RDF terms and quads.
 */ class $2918dc15ed9a49cb$var$DataFactory {
    constructor(options){
        this.blankNodeCounter = 0;
        options = options || {};
        this.blankNodePrefix = options.blankNodePrefix || `df_${$2918dc15ed9a49cb$var$dataFactoryCounter++}_`;
    }
    /**
     * @param value The IRI for the named node.
     * @return A new instance of NamedNode.
     * @see NamedNode
     */ namedNode(value) {
        return new $7KJsK.NamedNode(value);
    }
    /**
     * @param value The optional blank node identifier.
     * @return A new instance of BlankNode.
     *         If the `value` parameter is undefined a new identifier
     *         for the blank node is generated for each call.
     * @see BlankNode
     */ blankNode(value) {
        return new $dUwlf.BlankNode(value || `${this.blankNodePrefix}${this.blankNodeCounter++}`);
    }
    /**
     * @param value              The literal value.
     * @param languageOrDatatype The optional language or datatype.
     *                           If `languageOrDatatype` is a NamedNode,
     *                           then it is used for the value of `NamedNode.datatype`.
     *                           Otherwise `languageOrDatatype` is used for the value
     *                           of `NamedNode.language`.
     * @return A new instance of Literal.
     * @see Literal
     */ literal(value, languageOrDatatype) {
        return new $8RsDA.Literal(value, languageOrDatatype);
    }
    /**
     * This method is optional.
     * @param value The variable name
     * @return A new instance of Variable.
     * @see Variable
     */ variable(value) {
        return new $kNA9K.Variable(value);
    }
    /**
     * @return An instance of DefaultGraph.
     */ defaultGraph() {
        return $0UUif.DefaultGraph.INSTANCE;
    }
    /**
     * @param subject   The quad subject term.
     * @param predicate The quad predicate term.
     * @param object    The quad object term.
     * @param graph     The quad graph term.
     * @return A new instance of Quad.
     * @see Quad
     */ quad(subject, predicate, object, graph) {
        return new $1k2AX.Quad(subject, predicate, object, graph || this.defaultGraph());
    }
    /**
     * Create a deep copy of the given term using this data factory.
     * @param original An RDF term.
     * @return A deep copy of the given term.
     */ fromTerm(original) {
        // TODO: remove nasty any casts when this TS bug has been fixed:
        //  https://github.com/microsoft/TypeScript/issues/26933
        switch(original.termType){
            case "NamedNode":
                return this.namedNode(original.value);
            case "BlankNode":
                return this.blankNode(original.value);
            case "Literal":
                if (original.language) return this.literal(original.value, original.language);
                if (!original.datatype.equals($8RsDA.Literal.XSD_STRING)) return this.literal(original.value, this.fromTerm(original.datatype));
                return this.literal(original.value);
            case "Variable":
                return this.variable(original.value);
            case "DefaultGraph":
                return this.defaultGraph();
            case "Quad":
                return this.quad(this.fromTerm(original.subject), this.fromTerm(original.predicate), this.fromTerm(original.object), this.fromTerm(original.graph));
        }
    }
    /**
     * Create a deep copy of the given quad using this data factory.
     * @param original An RDF quad.
     * @return A deep copy of the given quad.
     */ fromQuad(original) {
        return this.fromTerm(original);
    }
    /**
     * Reset the internal blank node counter.
     */ resetBlankNodeCounter() {
        this.blankNodeCounter = 0;
    }
}
module.exports.DataFactory = $2918dc15ed9a49cb$var$DataFactory;

});
parcelRegister("0UUif", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultGraph = void 0;
/**
 * A singleton term instance that represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $002c24bd07a7ffa2$var$DefaultGraph {
    constructor(){
        this.termType = "DefaultGraph";
        this.value = "";
    // Private constructor
    }
    equals(other) {
        return !!other && other.termType === "DefaultGraph";
    }
}
module.exports.DefaultGraph = $002c24bd07a7ffa2$var$DefaultGraph;
$002c24bd07a7ffa2$var$DefaultGraph.INSTANCE = new $002c24bd07a7ffa2$var$DefaultGraph();

});

parcelRegister("8RsDA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Literal = void 0;

var $7KJsK = parcelRequire("7KJsK");
/**
 * A term that represents an RDF literal, containing a string with an optional language tag or datatype.
 */ class $67397ccc34a6e6fe$var$Literal {
    constructor(value, languageOrDatatype){
        this.termType = "Literal";
        this.value = value;
        if (typeof languageOrDatatype === "string") {
            this.language = languageOrDatatype;
            this.datatype = $67397ccc34a6e6fe$var$Literal.RDF_LANGUAGE_STRING;
        } else if (languageOrDatatype) {
            this.language = "";
            this.datatype = languageOrDatatype;
        } else {
            this.language = "";
            this.datatype = $67397ccc34a6e6fe$var$Literal.XSD_STRING;
        }
    }
    equals(other) {
        return !!other && other.termType === "Literal" && other.value === this.value && other.language === this.language && this.datatype.equals(other.datatype);
    }
}
module.exports.Literal = $67397ccc34a6e6fe$var$Literal;
$67397ccc34a6e6fe$var$Literal.RDF_LANGUAGE_STRING = new $7KJsK.NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
$67397ccc34a6e6fe$var$Literal.XSD_STRING = new $7KJsK.NamedNode("http://www.w3.org/2001/XMLSchema#string");

});
parcelRegister("7KJsK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NamedNode = void 0;
/**
 * A term that contains an IRI.
 */ class $5a501833e31d245e$var$NamedNode {
    constructor(value){
        this.termType = "NamedNode";
        this.value = value;
    }
    equals(other) {
        return !!other && other.termType === "NamedNode" && other.value === this.value;
    }
}
module.exports.NamedNode = $5a501833e31d245e$var$NamedNode;

});


parcelRegister("1k2AX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Quad = void 0;
/**
 * An instance of DefaultGraph represents the default graph.
 * It's only allowed to assign a DefaultGraph to the .graph property of a Quad.
 */ class $0f69ac096a83e0ca$var$Quad {
    constructor(subject, predicate, object, graph){
        this.termType = "Quad";
        this.value = "";
        this.subject = subject;
        this.predicate = predicate;
        this.object = object;
        this.graph = graph;
    }
    equals(other) {
        // `|| !other.termType` is for backwards-compatibility with old factories without RDF* support.
        return !!other && (other.termType === "Quad" || !other.termType) && this.subject.equals(other.subject) && this.predicate.equals(other.predicate) && this.object.equals(other.object) && this.graph.equals(other.graph);
    }
}
module.exports.Quad = $0f69ac096a83e0ca$var$Quad;

});

parcelRegister("kNA9K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Variable = void 0;
/**
 * A term that represents a variable.
 */ class $f2446e1c920a3cc9$var$Variable {
    constructor(value){
        this.termType = "Variable";
        this.value = value;
    }
    equals(other) {
        return !!other && other.termType === "Variable" && other.value === this.value;
    }
}
module.exports.Variable = $f2446e1c920a3cc9$var$Variable;

});


parcelRegister("kAE07", function(module, exports) {

$parcel$export(module.exports, "default", () => $efd632c6048e8a66$export$2e2bcd8739ae039);
/**
 * A Dummy log
 * @module log
 */ var $efd632c6048e8a66$var$log = {
    debug: function debug(x) {},
    warn: function warn(x) {},
    info: function info(x) {},
    error: function error(x) {},
    success: function success(x) {},
    msg: function msg(x) {}
};
var $efd632c6048e8a66$export$2e2bcd8739ae039 = $efd632c6048e8a66$var$log;

});

var $4eae0a726ab50395$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $4eae0a726ab50395$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $4eae0a726ab50395$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $4eae0a726ab50395$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});



var $99pVg = parcelRequire("99pVg");
function $5b5611d501681341$export$2e2bcd8739ae039(nsuri, factory) {
    var dataFactory = factory || {
        namedNode: function namedNode(value) {
            return new (0, $99pVg.default)(value);
        }
    };
    return function(ln) {
        return dataFactory.namedNode(nsuri + (ln || ""));
    };
}


var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");
function $d0a63e5194c4f691$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d0a63e5194c4f691$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $d0a63e5194c4f691$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * An RDF blank node is a Node without a URI
 * @link https://rdf.js.org/data-model-spec/#blanknode-interface
 */ var $d0a63e5194c4f691$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(BlankNode, _Node);
    var _super = $d0a63e5194c4f691$var$_createSuper(BlankNode);
    /**
   * Initializes this node
   * @param [id] The identifier for the blank node
   */ function BlankNode(id) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, BlankNode);
        _this = _super.call(this, BlankNode.getId(id));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.BlankNodeTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).BlankNode);
        /** Whether this is a blank node */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isBlank", 1);
        /**
     * This type of node is a variable.
     *
     * Note that the existence of this property already indicates that it is a variable.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 1);
        return _this;
    }
    /**
   * The identifier for the blank node
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(BlankNode, [
        {
            key: "id",
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.value = value;
            }
        },
        {
            key: "compareTerm",
            value: function compareTerm(other) {
                if (this.classOrder < other.classOrder) return -1;
                if (this.classOrder > other.classOrder) return 1;
                if (this.id < other.id) return -1;
                if (this.id > other.id) return 1;
                return 0;
            }
        },
        {
            key: "copy",
            value: function copy(formula) {
                // depends on the formula
                var bnodeNew = new BlankNode();
                formula.copyTo(this, bnodeNew);
                return bnodeNew;
            }
        },
        {
            key: "toCanonical",
            value: function toCanonical() {
                return BlankNode.NTAnonymousNodePrefix + this.value;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return BlankNode.NTAnonymousNodePrefix + this.id;
            }
        }
    ], [
        {
            key: "getId",
            value: function getId(id) {
                if (id) {
                    if (typeof id !== "string") throw new Error("Bad id argument to new blank node: " + id);
                    if (id.includes("#")) {
                        // Is a URI with hash fragment
                        var fragments = id.split("#");
                        return fragments[fragments.length - 1];
                    }
                    return id;
                }
                return "n" + BlankNode.nextId++;
            }
        }
    ]);
    return BlankNode;
}((0, $cdU35.default));
/**
 * The next unique identifier for blank nodes
 */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($d0a63e5194c4f691$export$2e2bcd8739ae039, "nextId", 0);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($d0a63e5194c4f691$export$2e2bcd8739ae039, "NTAnonymousNodePrefix", "_:");




var $b8259e79f5c77a6f$exports = {};
function $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
$b8259e79f5c77a6f$exports = $b8259e79f5c77a6f$var$_asyncToGenerator, $b8259e79f5c77a6f$exports.__esModule = true, $b8259e79f5c77a6f$exports["default"] = $b8259e79f5c77a6f$exports;



var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $g5Zhu = parcelRequire("g5Zhu");
var $c6598bdb60f83fe0$exports = {};
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
$c6598bdb60f83fe0$exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");
// Prevents circular dependencies between data-factory-internal and statement

var $99pVg = parcelRequire("99pVg");
var $471ea8b4e912e4b1$export$fb7535ed90405da0 = "chrome:theSession";
var $471ea8b4e912e4b1$export$cbca1d642dcb0c4c = new (0, $99pVg.default)($471ea8b4e912e4b1$export$fb7535ed90405da0);



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");


var $aZYlt = parcelRequire("aZYlt");

var $41YNz = parcelRequire("41YNz");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $99pVg = parcelRequire("99pVg");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $gCJkd = parcelRequire("gCJkd");

var $99pVg = parcelRequire("99pVg");
var $f42e02919a7ca0a9$export$2e2bcd8739ae039 = {
    boolean: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#boolean"),
    dateTime: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#dateTime"),
    decimal: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#decimal"),
    double: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#double"),
    integer: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#integer"),
    langString: new (0, $99pVg.default)("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString"),
    string: new (0, $99pVg.default)("http://www.w3.org/2001/XMLSchema#string")
};


function $68c7b1d3a79e3436$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $68c7b1d3a79e3436$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $68c7b1d3a79e3436$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * An RDF literal, containing some value which isn't expressed as an IRI.
 * @link https://rdf.js.org/data-model-spec/#literal-interface
 */ var $68c7b1d3a79e3436$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Literal, _Node);
    var _super = $68c7b1d3a79e3436$var$_createSuper(Literal);
    /**
   * Initializes a literal
   * @param value - The literal's lexical value
   * @param language - The language for the literal. Defaults to ''.
   * @param datatype - The literal's datatype as a named node. Defaults to xsd:string.
   */ function Literal(value, language, datatype) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Literal);
        _this = _super.call(this, value);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.LiteralTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).Literal);
        /**
     * The literal's datatype as a named node
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "datatype", (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).string);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 0);
        /**
     * The language for the literal
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "language", "");
        if (language) {
            _this.language = language;
            _this.datatype = (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).langString;
        } else if (datatype) _this.datatype = (0, $99pVg.default).fromValue(datatype);
        else _this.datatype = (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).string;
        return _this;
    }
    /**
   * Gets a copy of this literal
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Literal, [
        {
            key: "copy",
            value: function copy() {
                return new Literal(this.value, this.lang, this.datatype);
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                return this.termType === other.termType && this.value === other.value && this.language === other.language && (!this.datatype && !other.datatype || this.datatype && this.datatype.equals(other.datatype));
            }
        },
        {
            key: "lang",
            get: function get() {
                return this.language;
            },
            set: function set(language) {
                this.language = language || "";
            }
        },
        {
            key: "toNT",
            value: function toNT() {
                return Literal.toNT(this);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "" + this.value;
            }
        }
    ], [
        {
            key: "toNT",
            value: function toNT(literal) {
                if (typeof literal.value === "number") return "" + literal.value;
                else if (typeof literal.value !== "string") throw new Error("Value of RDF literal is not string or number: " + literal.value);
                var str = literal.value;
                // #x22 ("), #x5C (\), #x0A (\n) and #xD (\r) are disallowed and need to be replaced
                // see https://www.w3.org/TR/n-triples/#grammar-production-STRING_LITERAL_QUOTE
                str = str.replace(/\\/g, "\\\\");
                str = str.replace(/\"/g, '\\"');
                str = str.replace(/\n/g, "\\n");
                str = str.replace(/\r/g, "\\r");
                str = '"' + str + '"';
                if (literal.language) str += "@" + literal.language;
                else if (!literal.datatype.equals((0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).string)) // Only add datatype if it's not a string
                str += "^^" + literal.datatype.toCanonical();
                return str;
            }
        },
        {
            key: "fromBoolean",
            value: function fromBoolean(value) {
                var strValue = value ? "1" : "0";
                return new Literal(strValue, null, (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).boolean);
            }
        },
        {
            key: "fromDate",
            value: function fromDate(value) {
                if (!(value instanceof Date)) throw new TypeError("Invalid argument to Literal.fromDate()");
                var d2 = function d2(x) {
                    return ("" + (100 + x)).slice(1, 3);
                };
                var date = "" + value.getUTCFullYear() + "-" + d2(value.getUTCMonth() + 1) + "-" + d2(value.getUTCDate()) + "T" + d2(value.getUTCHours()) + ":" + d2(value.getUTCMinutes()) + ":" + d2(value.getUTCSeconds()) + "Z";
                return new Literal(date, null, (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).dateTime);
            }
        },
        {
            key: "fromNumber",
            value: function fromNumber(value) {
                if (typeof value !== "number") throw new TypeError("Invalid argument to Literal.fromNumber()");
                var datatype;
                var strValue = value.toString();
                if (strValue.indexOf("e") < 0 && Math.abs(value) <= Number.MAX_SAFE_INTEGER) datatype = Number.isInteger(value) ? (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).integer : (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).decimal;
                else datatype = (0, $f42e02919a7ca0a9$export$2e2bcd8739ae039).double;
                return new Literal(strValue, null, datatype);
            }
        },
        {
            key: "fromValue",
            value: function fromValue(value) {
                if ((0, $gCJkd.isLiteral)(value)) return value;
                switch((0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value)){
                    case "object":
                        if (value instanceof Date) return Literal.fromDate(value);
                    case "boolean":
                        return Literal.fromBoolean(value);
                    case "number":
                        return Literal.fromNumber(value);
                    case "string":
                        return new Literal(value);
                }
                throw new Error("Can't make literal from " + value + " of type " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(value));
            }
        }
    ]);
    return Literal;
}((0, $cdU35.default));



var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $gCJkd = parcelRequire("gCJkd");
function $619d91631affbf30$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $619d91631affbf30$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $619d91631affbf30$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $619d91631affbf30$export$5f36b26c3833b3ba(value) {
    if (typeof value === "undefined" || value === null) return value;
    if ((0, $gCJkd.isTerm)(value)) // a Node subclass or a Collection
    return value;
    if (Array.isArray(value)) return new $619d91631affbf30$export$2e2bcd8739ae039(value);
    return (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039).fromValue(value);
}
/**
 * A collection of other RDF nodes
 *
 * Use generic T to control the contents of the array.
 */ var $619d91631affbf30$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Collection, _Node);
    var _super = $619d91631affbf30$var$_createSuper(Collection);
    function Collection(initial) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Collection);
        _this = _super.call(this, ((0, $d0a63e5194c4f691$export$2e2bcd8739ae039).nextId++).toString());
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.CollectionTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).Collection);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "closed", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "compareTerm", (0, $d0a63e5194c4f691$export$2e2bcd8739ae039).prototype.compareTerm);
        /**
     * The nodes in this collection
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "elements", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 0);
        if (initial && initial.length > 0) initial.forEach(function(element) {
            _this.elements.push($619d91631affbf30$export$5f36b26c3833b3ba(element));
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Collection, [
        {
            key: "id",
            get: function get() {
                return this.value;
            },
            set: function set(value) {
                this.value = value;
            }
        },
        {
            key: "append",
            value: function append(element) {
                return this.elements.push(element);
            }
        },
        {
            key: "close",
            value: function close() {
                this.closed = true;
                return this.closed;
            }
        },
        {
            key: "shift",
            value: function shift() {
                return this.elements.shift();
            }
        },
        {
            key: "substitute",
            value: function substitute(bindings) {
                var elementsCopy = this.elements.map(function(ea) {
                    return ea.substitute(bindings);
                });
                return new Collection(elementsCopy);
            }
        },
        {
            key: "toNT",
            value: function toNT() {
                return Collection.toNT(this);
            }
        },
        {
            key: "toString",
            value: /**
     * Serializes the collection to a string.
     * Surrounded by (parentheses) and separated by spaces.
     */ function toString() {
                return "(" + this.elements.join(" ") + ")";
            }
        },
        {
            key: "unshift",
            value: function unshift(element) {
                return this.elements.unshift(element);
            }
        }
    ], [
        {
            key: "toNT",
            value: function toNT(collection) {
                // return '(' + collection.elements.map(x => x.toNT()).join(' ') + ')'
                // As lists are not in NT and toNT() must be a reversible function, we kludge it for a list
                return (0, $d0a63e5194c4f691$export$2e2bcd8739ae039).NTAnonymousNodePrefix + collection.id;
            }
        }
    ]);
    return Collection;
}((0, $cdU35.default));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($619d91631affbf30$export$2e2bcd8739ae039, "termType", (0, $8RKL2.CollectionTermType));



var $g5Zhu = parcelRequire("g5Zhu");



var $99pVg = parcelRequire("99pVg");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

function $cdeb561dfecfaa8a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cdeb561dfecfaa8a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $cdeb561dfecfaa8a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/** The RDF default graph */ var $cdeb561dfecfaa8a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(DefaultGraph, _Node);
    var _super = $cdeb561dfecfaa8a$var$_createSuper(DefaultGraph);
    function DefaultGraph() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DefaultGraph);
        _this = _super.call(this, "");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "value", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.DefaultGraphTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "uri", (0, $471ea8b4e912e4b1$export$fb7535ed90405da0));
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DefaultGraph, [
        {
            key: "toCanonical",
            value: function toCanonical() {
                return this.value;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "DefaultGraph";
            }
        }
    ]);
    return DefaultGraph;
}((0, $cdU35.default));
function $cdeb561dfecfaa8a$export$1a29e0fa6b36b0c8(object) {
    return !!object && object.termType === (0, $8RKL2.DefaultGraphTermType);
}


var $00d766c69dbb3a6e$var$defaultGraph = new (0, $cdeb561dfecfaa8a$export$2e2bcd8739ae039)();
/** A Statement represents an RDF Triple or Quad. */ var $00d766c69dbb3a6e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * Construct a new statement
   *
   * @param subject - The subject of the triple.  What the fact is about
   * @param predicate - The relationship which is asserted between the subject and object
   * @param object - The thing or data value which is asserted to be related to the subject
   * @param {NamedNode} graph - The document where the triple is or was or will be stored on the web.
   *
   * The graph param is a named node of the document in which the triple when it is stored
   *  on the web. It exists because when you have read data from various places in the web,
   *  the “graph” tells you _why_ you have the triple. (At the moment, it is just the
   *  document, in future it could be an inference step)
   *
   * When you do UpdateManager.update() then the graph’s of all the statements must be the same,
   *  and give the document you are patching. In future, we may have a more
   *  powerful update() which can update more than one document.
   */ function Statement(subject, predicate, object, graph) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Statement);
        /** The subject of the triple.  What the Statement is about. */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "subject", void 0);
        /** The relationship which is asserted between the subject and object */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "predicate", void 0);
        /** The thing or data value which is asserted to be related to the subject */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "object", void 0);
        /**
     * The graph param is a named node of the document in which the triple when
     *  it is stored on the web.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "graph", void 0);
        this.subject = (0, $cdU35.default).fromValue(subject);
        this.predicate = (0, $cdU35.default).fromValue(predicate);
        this.object = (0, $cdU35.default).fromValue(object);
        this.graph = graph == undefined ? $00d766c69dbb3a6e$var$defaultGraph : (0, $cdU35.default).fromValue(graph); // property currently used by rdflib
    }
    /** Alias for graph, favored by Tim */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Statement, [
        {
            key: "why",
            get: function get() {
                return this.graph;
            },
            set: function set(g) {
                this.graph = g;
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                return other.subject.equals(this.subject) && other.predicate.equals(this.predicate) && other.object.equals(this.object) && other.graph.equals(this.graph);
            }
        },
        {
            key: "substitute",
            value: function substitute(bindings) {
                var y = new Statement(this.subject.substitute(bindings), this.predicate.substitute(bindings), this.object.substitute(bindings), (0, $cdeb561dfecfaa8a$export$1a29e0fa6b36b0c8)(this.graph) ? this.graph : this.graph.substitute(bindings)); // 2016
                // console.log('@@@ statement substitute:' + y)
                return y;
            }
        },
        {
            key: "toCanonical",
            value: function toCanonical() {
                var terms = [
                    this.subject.toCanonical(),
                    this.predicate.toCanonical(),
                    this.object.toCanonical()
                ];
                if (this.graph && this.graph.termType !== (0, $8RKL2.DefaultGraphTermType)) terms.push(this.graph.toCanonical());
                return terms.join(" ") + " .";
            }
        },
        {
            key: "toNT",
            value: function toNT() {
                return [
                    this.subject.toNT(),
                    this.predicate.toNT(),
                    this.object.toNT()
                ].join(" ") + " .";
            }
        },
        {
            key: "toNQ",
            value: function toNQ() {
                return [
                    this.subject.toNT(),
                    this.predicate.toNT(),
                    this.object.toNT(),
                    (0, $cdeb561dfecfaa8a$export$1a29e0fa6b36b0c8)(this.graph) ? "" : this.graph.toNT()
                ].join(" ") + " .";
            }
        },
        {
            key: "toString",
            value: function toString() {
                /*
      return [
        this.subject.toString(),
        this.predicate.toString(),
        this.object.toString(),
      ].join(' ') + ' .'
      */ return this.toNT();
            }
        }
    ]);
    return Statement;
}();



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $6zC7B = parcelRequire("6zC7B");

var $f8wIT = parcelRequire("f8wIT");

var $eN9hz = parcelRequire("eN9hz");

var $cGTaw = parcelRequire("cGTaw");

var $g5Zhu = parcelRequire("g5Zhu");

var $aZYlt = parcelRequire("aZYlt");

var $cdU35 = parcelRequire("cdU35");

var $8RKL2 = parcelRequire("8RKL2");

var $4Q80K = parcelRequire("4Q80K");
function $b7a48305c1700eec$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b7a48305c1700eec$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $b7a48305c1700eec$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
* Variables are placeholders used in patterns to be matched.
* In cwm they are symbols which are the formula's list of quantified variables.
* In sparql they are not visibly URIs.  Here we compromise, by having
* a common special base URI for variables. Their names are uris,
* but the ? notation has an implicit base uri of 'varid:'
*/ var $b7a48305c1700eec$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Variable, _Node);
    var _super = $b7a48305c1700eec$var$_createSuper(Variable);
    /**
   * Initializes this variable
   * @param name The variable's name
   */ function Variable() {
        var _this;
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Variable);
        _this = _super.call(this, name);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.VariableTermType));
        /** The base string for a variable's name */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "base", "varid:");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).Variable);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 1);
        /** The unique identifier of this variable */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "uri", void 0);
        _this.base = "varid:";
        _this.uri = $4Q80K.join(name, _this.base);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Variable, [
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                return this.termType === other.termType && this.value === other.value;
            }
        },
        {
            key: "hashString",
            value: function hashString() {
                return this.toString();
            }
        },
        {
            key: "substitute",
            value: function substitute(bindings) {
                var ref;
                return (ref = bindings[this.toNT()]) != null ? ref : this;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return Variable.toString(this);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString(variable) {
                if (variable.uri.slice(0, variable.base.length) === variable.base) return "?".concat(variable.uri.slice(variable.base.length));
                return "?".concat(variable.uri);
            }
        }
    ]);
    return Variable;
}((0, $cdU35.default));



var $8RKL2 = parcelRequire("8RKL2");

/** A set of features that may be supported by a Data Factory */ var $03d9b46807fe65b2$export$6e91cf7616333d5 = /*#__PURE__*/ function(Feature) {
    Feature["collections"] = "COLLECTIONS";
    Feature["defaultGraphType"] = "DEFAULT_GRAPH_TYPE";
    Feature["equalsMethod"] = "EQUALS_METHOD";
    Feature["id"] = "ID";
    Feature["identity"] = "IDENTITY";
    Feature["reversibleId"] = "REVERSIBLE_ID";
    Feature["variableType"] = "VARIABLE_TYPE";
    return Feature;
}({}); /**
 * Defines a DataFactory as used in rdflib, based on the RDF/JS: Data model specification,
 * but with additional extensions
 *
 * bnIndex is optional but useful.
 */ 



var $gCJkd = parcelRequire("gCJkd");

var $158d84b4866fe33e$var$_supports;
/**
 * Gets the default graph
 */ var $158d84b4866fe33e$var$_defaultGraph = new (0, $cdeb561dfecfaa8a$export$2e2bcd8739ae039)();
/** A basic internal RDFlib datafactory, which does not support Collections  */ var $158d84b4866fe33e$var$CanonicalDataFactory = {
    supports: ($158d84b4866fe33e$var$_supports = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).collections, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).defaultGraphType, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).equalsMethod, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).identity, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).id, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).reversibleId, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($158d84b4866fe33e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).variableType, true), $158d84b4866fe33e$var$_supports),
    /**
   * Creates a new blank node
   * @param value - The blank node's identifier
   */ blankNode: function blankNode(value) {
        return new (0, $d0a63e5194c4f691$export$2e2bcd8739ae039)(value);
    },
    defaultGraph: function defaultGraph() {
        return $158d84b4866fe33e$var$_defaultGraph;
    },
    /**
   * Compares to (rdf) objects for equality.
   */ equals: function equals(a, b) {
        if (a === b || !a || !b) return true;
        if ((0, $gCJkd.isQuad)(a) || (0, $gCJkd.isQuad)(b)) {
            if ((0, $gCJkd.isQuad)(a) && (0, $gCJkd.isQuad)(b)) return this.equals(a.subject, b.subject) && this.equals(a.predicate, b.predicate) && this.equals(a.object, b.object) && this.equals(a.graph, b.graph);
            return false;
        }
        if ((0, $gCJkd.isTerm)(a) && (0, $gCJkd.isTerm)(b)) return this.id(a) === this.id(b);
        return false;
    },
    /**
   * Generates a uniquely identifiably *idempotent* string for the given {term}.
   *
   * Equivalent to [[Term.hashString]]
   *
   * @example Use this to associate data with a term in an object
   *   { obj[id(term)] = "myData" }
   */ id: function id(term) {
        if (!term) return "undefined";
        if ((0, $gCJkd.isQuad)(term)) return this.quadToNQ(term);
        switch(term.termType){
            case 0, $8RKL2.DefaultGraphTermType:
                return "defaultGraph";
            case 0, $8RKL2.VariableTermType:
                return (0, $b7a48305c1700eec$export$2e2bcd8739ae039).toString(term);
            default:
                var nq = this.termToNQ(term);
                if (nq) return nq;
                throw new Error("Can't id term with type '".concat(term.termType, "'"));
        }
    },
    isQuad: function isQuad(obj) {
        return obj instanceof (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039);
    },
    /**
   * Creates a new literal node. Does some JS literal parsing for ease of use.
   * @param value - The lexical value
   * @param languageOrDatatype - Either the language or the datatype
   */ literal: function literal(value, languageOrDatatype) {
        if (typeof value !== "string" && !languageOrDatatype) return (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039).fromValue(value);
        var strValue = typeof value === "string" ? value : "" + value;
        if (typeof languageOrDatatype === "string") {
            if (languageOrDatatype.indexOf(":") === -1) return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(strValue, languageOrDatatype);
            else return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(strValue, null, this.namedNode(languageOrDatatype));
        } else return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(strValue, null, languageOrDatatype);
    },
    /**
   * Creates a new named node
   * @param value - The new named node
   */ namedNode: function namedNode(value) {
        return new (0, $99pVg.default)(value);
    },
    /**
   * Creates a new statement
   * @param subject - The subject
   * @param predicate - The predicate
   * @param object - The object
   * @param graph - The containing graph
   */ quad: function quad(subject, predicate, object, graph) {
        return new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(subject, predicate, object, graph || $158d84b4866fe33e$var$_defaultGraph);
    },
    /**
   * Creates a new statement
   * @param subject - The subject
   * @param predicate - The predicate
   * @param object - The object
   * @param graph - The containing graph
   */ triple: function triple(subject, predicate, object, graph) {
        return this.quad(subject, predicate, object, graph);
    },
    quadToNQ: function quadToNQ(q) {
        return "".concat(this.termToNQ(q.subject), " ").concat(this.termToNQ(q.predicate), " ").concat(this.termToNQ(q.object), " ").concat(this.termToNQ(q.graph), " .");
    },
    /** Stringify a {term} to n-quads serialization. */ termToNQ: function termToNQ(term) {
        var _this = this;
        switch(term.termType){
            case 0, $8RKL2.BlankNodeTermType:
                return "_:" + term.value;
            case 0, $8RKL2.DefaultGraphTermType:
                return "";
            case 0, $8RKL2.EmptyTermType:
                return "<http://www.w3.org/1999/02/22-rdf-syntax-ns#nil>";
            case 0, $8RKL2.LiteralTermType:
                return (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039).toNT(term);
            case 0, $8RKL2.GraphTermType:
            case 0, $8RKL2.NamedNodeTermType:
                return "<" + term.value + ">";
            case 0, $8RKL2.CollectionTermType:
                return "(" + term.elements.map(function(t) {
                    return _this.termToNQ(t);
                }).join(" ") + ")";
            default:
                throw new Error("Can't serialize nonstandard term type (was '".concat(term.termType, "')"));
        }
    },
    /** Convert an rdf object (term or quad) to n-quads serialization. */ toNQ: function toNQ(term) {
        if (this.isQuad(term)) return this.quadToNQ(term);
        return this.termToNQ(term);
    },
    /**
   * Creates a new variable
   * @param name - The name for the variable
   */ variable: function variable(name) {
        return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(name);
    }
};
var /** Contains the factory methods as defined in the spec, plus id */ $158d84b4866fe33e$export$2e2bcd8739ae039 = $158d84b4866fe33e$var$CanonicalDataFactory;



var $kAE07 = parcelRequire("kAE07");


var $cdU35 = parcelRequire("cdU35");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");



var $4Q80K = parcelRequire("4Q80K");

var $23fob = parcelRequire("23fob");
var $4Q80K = parcelRequire("4Q80K");


function $c58a780548822e73$export$abafb17d1d8eb7fd() {
    var localFactory = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $158d84b4866fe33e$export$2e2bcd8739ae039);
    return {
        boolean: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#boolean"),
        dateTime: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#dateTime"),
        decimal: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#decimal"),
        double: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#double"),
        integer: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#integer"),
        langString: localFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString"),
        string: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#string")
    };
}
var $c58a780548822e73$var$defaultXSD = $c58a780548822e73$export$abafb17d1d8eb7fd((0, $158d84b4866fe33e$export$2e2bcd8739ae039));
var $c58a780548822e73$export$2e2bcd8739ae039 = $c58a780548822e73$var$defaultXSD;


var $3f9355bcac0943b6$exports = {};
/**
 * Provides a way to access commonly used namespaces
 *
 * Usage:
 *
 *   ```
 *   const $rdf = require('rdflib'); //or any other RDF/JS-compatible library
 *   const ns = require('solid-namespace')($rdf);
 *   const store = $rdf.graph();
 *
 *   let me = ...;
 *   let name = store.any(me, ns.vcard(‘fn’)) || store.any(me, ns.foaf(‘name’));
 *   ```
 * @module vocab
 */ const $3f9355bcac0943b6$var$aliases = {
    acl: "http://www.w3.org/ns/auth/acl#",
    arg: "http://www.w3.org/ns/pim/arg#",
    as: "https://www.w3.org/ns/activitystreams#",
    cal: "http://www.w3.org/2002/12/cal/ical#",
    cert: "http://www.w3.org/ns/auth/cert#",
    contact: "http://www.w3.org/2000/10/swap/pim/contact#",
    dc: "http://purl.org/dc/elements/1.1/",
    dct: "http://purl.org/dc/terms/",
    doap: "http://usefulinc.com/ns/doap#",
    foaf: "http://xmlns.com/foaf/0.1/",
    geo: "http://www.w3.org/2003/01/geo/wgs84_pos#",
    gpx: "http://www.w3.org/ns/pim/gpx#",
    http: "http://www.w3.org/2007/ont/http#",
    httph: "http://www.w3.org/2007/ont/httph#",
    icalTZ: "http://www.w3.org/2002/12/cal/icaltzd#",
    ldp: "http://www.w3.org/ns/ldp#",
    link: "http://www.w3.org/2007/ont/link#",
    log: "http://www.w3.org/2000/10/swap/log#",
    meeting: "http://www.w3.org/ns/pim/meeting#",
    mo: "http://purl.org/ontology/mo/",
    org: "http://www.w3.org/ns/org#",
    owl: "http://www.w3.org/2002/07/owl#",
    pad: "http://www.w3.org/ns/pim/pad#",
    patch: "http://www.w3.org/ns/pim/patch#",
    prov: "http://www.w3.org/ns/prov#",
    qu: "http://www.w3.org/2000/10/swap/pim/qif#",
    trip: "http://www.w3.org/ns/pim/trip#",
    rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    rdfs: "http://www.w3.org/2000/01/rdf-schema#",
    rss: "http://purl.org/rss/1.0/",
    sched: "http://www.w3.org/ns/pim/schedule#",
    schema: "http://schema.org/",
    sioc: "http://rdfs.org/sioc/ns#",
    solid: "http://www.w3.org/ns/solid/terms#",
    space: "http://www.w3.org/ns/pim/space#",
    stat: "http://www.w3.org/ns/posix/stat#",
    tab: "http://www.w3.org/2007/ont/link#",
    tabont: "http://www.w3.org/2007/ont/link#",
    ui: "http://www.w3.org/ns/ui#",
    vcard: "http://www.w3.org/2006/vcard/ns#",
    wf: "http://www.w3.org/2005/01/wf/flow#",
    xsd: "http://www.w3.org/2001/XMLSchema#",
    cco: "http://www.ontologyrepository.com/CommonCoreOntologies/",
    skos: "http://www.w3.org/2004/02/skos/core#",
    bookmark: "http://www.w3.org/2002/01/bookmark#",
    vann: "http://purl.org/vocab/vann/"
};
/**
 * @param [rdflib] {RDF} Optional RDF Library (such as rdflib.js or rdf-ext) to inject
 */ function $3f9355bcac0943b6$var$vocab(rdf = {
    namedNode: (u)=>u
}) {
    const namespaces = {};
    for(const alias in $3f9355bcac0943b6$var$aliases){
        const expansion = $3f9355bcac0943b6$var$aliases[alias];
        namespaces[alias] = function(localName = "") {
            return rdf.namedNode(expansion + localName);
        };
    }
    return namespaces;
}
$3f9355bcac0943b6$exports = $3f9355bcac0943b6$var$vocab;


var $4637181ac5e22c58$exports = {};

/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if (0, $4637181ac5e22c58$exports) $4637181ac5e22c58$exports = factory();
    else root.ttl2jsonld = factory();
})($4637181ac5e22c58$exports, function() {
    "use strict";
    function peg$subclass(child, parent) {
        function ctor() {
            this.constructor = child;
        }
        ctor.prototype = parent.prototype;
        child.prototype = new ctor();
    }
    function peg$SyntaxError(message, expected, found, location) {
        this.message = message;
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, peg$SyntaxError);
    }
    peg$subclass(peg$SyntaxError, Error);
    peg$SyntaxError.buildMessage = function(expected, found) {
        var DESCRIBE_EXPECTATION_FNS = {
            literal: function(expectation) {
                return '"' + literalEscape(expectation.text) + '"';
            },
            "class": function(expectation) {
                var escapedParts = "", i;
                for(i = 0; i < expectation.parts.length; i++)escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
                return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
            },
            any: function(expectation) {
                return "any character";
            },
            end: function(expectation) {
                return "end of input";
            },
            other: function(expectation) {
                return expectation.description;
            }
        };
        function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
            return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                return "\\x0" + hex(ch);
            }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                return "\\x" + hex(ch);
            });
        }
        function classEscape(s) {
            return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                return "\\x0" + hex(ch);
            }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                return "\\x" + hex(ch);
            });
        }
        function describeExpectation(expectation) {
            return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected) {
            var descriptions = new Array(expected.length), i, j;
            for(i = 0; i < expected.length; i++)descriptions[i] = describeExpectation(expected[i]);
            descriptions.sort();
            if (descriptions.length > 0) {
                for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                    descriptions[j] = descriptions[i];
                    j++;
                }
                descriptions.length = j;
            }
            switch(descriptions.length){
                case 1:
                    return descriptions[0];
                case 2:
                    return descriptions[0] + " or " + descriptions[1];
                default:
                    return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
            }
        }
        function describeFound(found) {
            return found ? '"' + literalEscape(found) + '"' : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
    };
    function peg$parse(input, options) {
        options = options !== void 0 ? options : {};
        var peg$FAILED = {}, peg$startRuleFunctions = {
            turtleDoc: peg$parseturtleDoc
        }, peg$startRuleFunction = peg$parseturtleDoc, peg$c0 = function(statements) {
            var jsonld = context.toJSON();
            jsonld["@graph"] = [];
            statements.filter((a)=>Array.isArray(a)).forEach((a)=>{
                a.forEach((b)=>{
                    jsonld["@graph"].push(b);
                });
            });
            if (jsonld["@graph"].length === 1) {
                Object.assign(jsonld, jsonld["@graph"][0]);
                delete jsonld["@graph"];
            }
            return jsonld;
        }, peg$c1 = ".", peg$c2 = peg$literalExpectation(".", false), peg$c3 = function(a) {
            return a;
        }, peg$c4 = "#", peg$c5 = peg$literalExpectation("#", false), peg$c6 = /^[^\n]/, peg$c7 = peg$classExpectation([
            "\n"
        ], true, false), peg$c8 = "\n", peg$c9 = peg$literalExpectation("\n", false), peg$c10 = function(a) {
            return a.join("");
        }, peg$c11 = "@prefix", peg$c12 = peg$literalExpectation("@prefix", false), peg$c13 = function(a, b) {
            context.addPrefix(a === "" ? "0" : a, b);
            return {};
        }, peg$c14 = "@base", peg$c15 = peg$literalExpectation("@base", false), peg$c16 = function(a) {
            context.addBase(a);
            return {};
        }, peg$c17 = /^[Bb]/, peg$c18 = peg$classExpectation([
            "B",
            "b"
        ], false, false), peg$c19 = /^[Aa]/, peg$c20 = peg$classExpectation([
            "A",
            "a"
        ], false, false), peg$c21 = /^[Ss]/, peg$c22 = peg$classExpectation([
            "S",
            "s"
        ], false, false), peg$c23 = /^[Ee]/, peg$c24 = peg$classExpectation([
            "E",
            "e"
        ], false, false), peg$c25 = /^[Pp]/, peg$c26 = peg$classExpectation([
            "P",
            "p"
        ], false, false), peg$c27 = /^[Rr]/, peg$c28 = peg$classExpectation([
            "R",
            "r"
        ], false, false), peg$c29 = /^[Ff]/, peg$c30 = peg$classExpectation([
            "F",
            "f"
        ], false, false), peg$c31 = /^[Ii]/, peg$c32 = peg$classExpectation([
            "I",
            "i"
        ], false, false), peg$c33 = /^[Xx]/, peg$c34 = peg$classExpectation([
            "X",
            "x"
        ], false, false), peg$c35 = function(s, p) {
            var x = {};
            if (typeof s === "string" && s !== "[]") x["@id"] = s;
            else if (typeof s === "object") Object.assign(x, s);
            if (p) Object.assign(x, p);
            return [
                x
            ];
        }, peg$c36 = function(s, p) {
            var x = {};
            if (s) Object.assign(x, s);
            if (p) Object.assign(x, p);
            return [
                x
            ];
        }, peg$c37 = ";", peg$c38 = peg$literalExpectation(";", false), peg$c39 = function(a, b, e, f) {
            var x = {};
            x[e] = f;
            return x;
        }, peg$c40 = function(a, b, d) {
            return d;
        }, peg$c41 = function(a, b, c) {
            var x = {};
            c.unshift(createObject(a, b));
            c.forEach((t)=>{
                if (!t) return;
                Object.keys(t).forEach((key)=>{
                    t[key].forEach((val)=>{
                        if (key === "@type" && val["@id"] !== undefined) val = val["@id"];
                        if (x[key] === undefined) x[key] = val;
                        else if (Array.isArray(x[key])) x[key].push(val);
                        else x[key] = [
                            x[key],
                            val
                        ];
                    });
                });
            });
            return x;
        }, peg$c42 = ",", peg$c43 = peg$literalExpectation(",", false), peg$c44 = function(a, c) {
            return c;
        }, peg$c45 = function(a, b) {
            b.unshift(a);
            return b;
        }, peg$c46 = "a", peg$c47 = peg$literalExpectation("a", false), peg$c48 = function() {
            return "@type";
        }, peg$c49 = function(a) {
            return expandList(a, true);
        }, peg$c50 = function(a) {
            return expandList(a, false);
        }, peg$c51 = function(a) {
            return a === "[]" ? {} : {
                "@id": a
            };
        }, peg$c52 = function(a) {
            return {
                "@id": a
            };
        }, peg$c53 = "[", peg$c54 = peg$literalExpectation("[", false), peg$c55 = "]", peg$c56 = peg$literalExpectation("]", false), peg$c57 = "(", peg$c58 = peg$literalExpectation("(", false), peg$c59 = ")", peg$c60 = peg$literalExpectation(")", false), peg$c61 = function(a) {
            return {
                "@list": a
            };
        }, peg$c62 = function(a, b) {
            return {
                "@value": a,
                "@language": b
            };
        }, peg$c63 = "^^", peg$c64 = peg$literalExpectation("^^", false), peg$c65 = function(a, b) {
            if (b === "http://www.w3.org/2001/XMLSchema#boolean" && a === "true") return true;
            if (b === "http://www.w3.org/2001/XMLSchema#boolean" && a === "false") return false;
            if (b === "http://www.w3.org/2001/XMLSchema#integer") return parseInt(a);
            if (b === "http://www.w3.org/2001/XMLSchema#double") return parseFloat(a);
            const uri = context.resolve(b, true);
            if (uri) {
                const prefix = b.split(":")[0];
                if (uri === "http://www.w3.org/2001/XMLSchema#boolean" && a === "true") {
                    context.decrement(prefix);
                    return true;
                }
                if (uri === "http://www.w3.org/2001/XMLSchema#boolean" && a === "false") {
                    context.decrement(prefix);
                    return false;
                }
                if (uri === "http://www.w3.org/2001/XMLSchema#integer") {
                    context.decrement(prefix);
                    return parseInt(a);
                }
                if (uri === "http://www.w3.org/2001/XMLSchema#double") {
                    context.decrement(prefix);
                    return parseFloat(a);
                }
            }
            return {
                "@value": a,
                "@type": b
            };
        }, peg$c66 = "true", peg$c67 = peg$literalExpectation("true", false), peg$c68 = function() {
            return true;
        }, peg$c69 = "false", peg$c70 = peg$literalExpectation("false", false), peg$c71 = function() {
            return false;
        }, peg$c72 = function(a) {
            return a + ":";
        }, peg$c73 = "<", peg$c74 = peg$literalExpectation("<", false), peg$c75 = /^[^\0- <>"{}|\^`\\]/, peg$c76 = peg$classExpectation([
            [
                "\x00",
                " "
            ],
            "<",
            ">",
            '"',
            "{",
            "}",
            "|",
            "^",
            "`",
            "\\"
        ], true, false), peg$c77 = ">", peg$c78 = peg$literalExpectation(">", false), peg$c79 = function(a) {
            const decoded = a.map((s)=>{
                if (0x10000 <= s.codePointAt(0) && s.codePointAt(0) <= 0xeffff) return "a";
                if (s.length === 1) return s;
                if (s.length === 6) return String.fromCharCode("0x" + s.substring(2));
                if (s.length === 10) return String.fromCodePoint("0x" + s.substring(2));
                return s;
            }).join("");
            if (decoded.match(/^[^\u0000-\u0020<>"{}|^`\\]*$/)) {
                var join = a.join("");
                try {
                    return context.resolve(join);
                } catch (e) {
                    error("Invalid IRIREF " + join);
                }
            } else error("Invalid IRIREF " + a.join("") + " / " + decoded);
        }, peg$c80 = ":", peg$c81 = peg$literalExpectation(":", false), peg$c82 = function(a) {
            a = a || "0";
            if (context.hasPrefix(a) === false) error("undefined prefix " + a);
            return a;
        }, peg$c83 = function(a) {
            return a || "";
        }, peg$c84 = function(a, b) {
            context.increment(a);
            return context.resolve(a + ":" + b);
        }, peg$c85 = "_:", peg$c86 = peg$literalExpectation("_:", false), peg$c87 = /^[0-9]/, peg$c88 = peg$classExpectation([
            [
                "0",
                "9"
            ]
        ], false, false), peg$c89 = "@", peg$c90 = peg$literalExpectation("@", false), peg$c91 = /^[a-zA-Z]/, peg$c92 = peg$classExpectation([
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ]
        ], false, false), peg$c93 = "-", peg$c94 = peg$literalExpectation("-", false), peg$c95 = /^[a-zA-Z0-9]/, peg$c96 = peg$classExpectation([
            [
                "a",
                "z"
            ],
            [
                "A",
                "Z"
            ],
            [
                "0",
                "9"
            ]
        ], false, false), peg$c97 = function(a, s) {
            return "-" + s.join("");
        }, peg$c98 = function(a, b) {
            return a.join("") + b.join("");
        }, peg$c99 = /^[+\-]/, peg$c100 = peg$classExpectation([
            "+",
            "-"
        ], false, false), peg$c101 = function(a) {
            if (a.match(/^[0+][0-9]+$/)) return {
                "@value": a,
                "@type": "http://www.w3.org/2001/XMLSchema#integer"
            };
            return parseInt(a);
        }, peg$c102 = function(a) {
            return {
                "@value": a,
                "@type": "http://www.w3.org/2001/XMLSchema#decimal"
            };
        }, peg$c103 = function(a) {
            return {
                "@value": a,
                "@type": "http://www.w3.org/2001/XMLSchema#double"
            };
        }, peg$c104 = /^[eE]/, peg$c105 = peg$classExpectation([
            "e",
            "E"
        ], false, false), peg$c106 = '"', peg$c107 = peg$literalExpectation('"', false), peg$c108 = /^[^"\\\n\r]/, peg$c109 = peg$classExpectation([
            '"',
            "\\",
            "\n",
            "\r"
        ], true, false), peg$c110 = "'", peg$c111 = peg$literalExpectation("'", false), peg$c112 = /^[^'\\\n\r]/, peg$c113 = peg$classExpectation([
            "'",
            "\\",
            "\n",
            "\r"
        ], true, false), peg$c114 = "'''", peg$c115 = peg$literalExpectation("'''", false), peg$c116 = /^[^'\\]/, peg$c117 = peg$classExpectation([
            "'",
            "\\"
        ], true, false), peg$c118 = "''", peg$c119 = peg$literalExpectation("''", false), peg$c120 = function(head, a) {
            return "''" + a.join("");
        }, peg$c121 = function(head, a) {
            return "'" + a.join("");
        }, peg$c122 = function(head, body) {
            return head.join("") + body.join("");
        }, peg$c123 = '"""', peg$c124 = peg$literalExpectation('"""', false), peg$c125 = /^[^"\\]/, peg$c126 = peg$classExpectation([
            '"',
            "\\"
        ], true, false), peg$c127 = '""', peg$c128 = peg$literalExpectation('""', false), peg$c129 = function(head, a) {
            return '""' + a.join("");
        }, peg$c130 = function(head, a) {
            return '"' + a.join("");
        }, peg$c131 = "\\U", peg$c132 = peg$literalExpectation("\\U", false), peg$c133 = function(hex) {
            return String.fromCodePoint(parseInt(hex.join(""), 16));
        }, peg$c134 = "\\u", peg$c135 = peg$literalExpectation("\\u", false), peg$c136 = function(hex) {
            return String.fromCharCode(parseInt(hex.join(""), 16));
        }, peg$c137 = "\\t", peg$c138 = peg$literalExpectation("\\t", false), peg$c139 = function() {
            return "	";
        }, peg$c140 = "\\b", peg$c141 = peg$literalExpectation("\\b", false), peg$c142 = function() {
            return "\b";
        }, peg$c143 = "\\n", peg$c144 = peg$literalExpectation("\\n", false), peg$c145 = function() {
            return "\n";
        }, peg$c146 = "\\r", peg$c147 = peg$literalExpectation("\\r", false), peg$c148 = function() {
            return "\r";
        }, peg$c149 = "\\f", peg$c150 = peg$literalExpectation("\\f", false), peg$c151 = function() {
            return "\f";
        }, peg$c152 = '\\"', peg$c153 = peg$literalExpectation('\\"', false), peg$c154 = function() {
            return '"';
        }, peg$c155 = "\\'", peg$c156 = peg$literalExpectation("\\'", false), peg$c157 = function() {
            return "'";
        }, peg$c158 = "\\\\", peg$c159 = peg$literalExpectation("\\\\", false), peg$c160 = function() {
            return "\\";
        }, peg$c161 = /^[ \t\r\n]/, peg$c162 = peg$classExpectation([
            " ",
            "	",
            "\r",
            "\n"
        ], false, false), peg$c163 = function() {
            return "[]";
        }, peg$c164 = /^[\uD800-\uDBFF]/, peg$c165 = peg$classExpectation([
            [
                "\uD800",
                "\uDBFF"
            ]
        ], false, false), peg$c166 = /^[\uDC00-\uDFFF]/, peg$c167 = peg$classExpectation([
            [
                "\uDC00",
                "\uDFFF"
            ]
        ], false, false), peg$c168 = function(a, b) {
            return a + b;
        }, peg$c169 = /^[A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, peg$c170 = peg$classExpectation([
            [
                "A",
                "Z"
            ],
            [
                "a",
                "z"
            ],
            [
                "\xc0",
                "\xd6"
            ],
            [
                "\xd8",
                "\xf6"
            ],
            [
                "\xf8",
                "\u02FF"
            ],
            [
                "\u0370",
                "\u037D"
            ],
            [
                "\u037F",
                "\u1FFF"
            ],
            [
                "\u200C",
                "\u200D"
            ],
            [
                "\u2070",
                "\u218F"
            ],
            [
                "\u2C00",
                "\u2FEF"
            ],
            [
                "\u3001",
                "\uD7FF"
            ],
            [
                "\uF900",
                "\uFDCF"
            ],
            [
                "\uFDF0",
                "\uFFFD"
            ]
        ], false, false), peg$c171 = "_", peg$c172 = peg$literalExpectation("_", false), peg$c173 = "\xb7", peg$c174 = peg$literalExpectation("\xb7", false), peg$c175 = /^[\u0300-\u036F]/, peg$c176 = peg$classExpectation([
            [
                "\u0300",
                "\u036F"
            ]
        ], false, false), peg$c177 = /^[\u203F-\u2040]/, peg$c178 = peg$classExpectation([
            [
                "\u203F",
                "\u2040"
            ]
        ], false, false), peg$c179 = function(head, body, a, b) {
            return a.join("") + b.join("");
        }, peg$c180 = function(head, body, tail) {
            return head + body.join("") + tail.join("");
        }, peg$c181 = "%", peg$c182 = peg$literalExpectation("%", false), peg$c183 = /^[0-9A-Fa-f]/, peg$c184 = peg$classExpectation([
            [
                "0",
                "9"
            ],
            [
                "A",
                "F"
            ],
            [
                "a",
                "f"
            ]
        ], false, false), peg$c185 = "\\", peg$c186 = peg$literalExpectation("\\", false), peg$c187 = /^[_~.!$&'()*+,;=\/?#@%\-]/, peg$c188 = peg$classExpectation([
            "_",
            "~",
            ".",
            "!",
            "$",
            "&",
            "'",
            "(",
            ")",
            "*",
            "+",
            ",",
            ";",
            "=",
            "/",
            "?",
            "#",
            "@",
            "%",
            "-"
        ], false, false), peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [
            {
                line: 1,
                column: 1
            }
        ], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ("startRule" in options) {
            if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
            peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text() {
            return input.substring(peg$savedPos, peg$currPos);
        }
        function location() {
            return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description, location) {
            location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildStructuredError([
                peg$otherExpectation(description)
            ], input.substring(peg$savedPos, peg$currPos), location);
        }
        function error(message, location) {
            location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos);
            throw peg$buildSimpleError(message, location);
        }
        function peg$literalExpectation(text, ignoreCase) {
            return {
                type: "literal",
                text: text,
                ignoreCase: ignoreCase
            };
        }
        function peg$classExpectation(parts, inverted, ignoreCase) {
            return {
                type: "class",
                parts: parts,
                inverted: inverted,
                ignoreCase: ignoreCase
            };
        }
        function peg$anyExpectation() {
            return {
                type: "any"
            };
        }
        function peg$endExpectation() {
            return {
                type: "end"
            };
        }
        function peg$otherExpectation(description) {
            return {
                type: "other",
                description: description
            };
        }
        function peg$computePosDetails(pos) {
            var details = peg$posDetailsCache[pos], p;
            if (details) return details;
            else {
                p = pos - 1;
                while(!peg$posDetailsCache[p])p--;
                details = peg$posDetailsCache[p];
                details = {
                    line: details.line,
                    column: details.column
                };
                while(p < pos){
                    if (input.charCodeAt(p) === 10) {
                        details.line++;
                        details.column = 1;
                    } else details.column++;
                    p++;
                }
                peg$posDetailsCache[pos] = details;
                return details;
            }
        }
        function peg$computeLocation(startPos, endPos) {
            var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
            return {
                start: {
                    offset: startPos,
                    line: startPosDetails.line,
                    column: startPosDetails.column
                },
                end: {
                    offset: endPos,
                    line: endPosDetails.line,
                    column: endPosDetails.column
                }
            };
        }
        function peg$fail(expected) {
            if (peg$currPos < peg$maxFailPos) return;
            if (peg$currPos > peg$maxFailPos) {
                peg$maxFailPos = peg$currPos;
                peg$maxFailExpected = [];
            }
            peg$maxFailExpected.push(expected);
        }
        function peg$buildSimpleError(message, location) {
            return new peg$SyntaxError(message, null, null, location);
        }
        function peg$buildStructuredError(expected, found, location) {
            return new peg$SyntaxError(peg$SyntaxError.buildMessage(expected, found), expected, found, location);
        }
        function peg$parseturtleDoc() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parsestatement();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parsestatement();
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseIGNORE();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parseIGNORE();
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c0(s1);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsestatement() {
            var s0, s1, s2, s3;
            s0 = peg$parsedirective();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsetriples();
                if (s1 !== peg$FAILED) {
                    s2 = [];
                    s3 = peg$parseIGNORE();
                    while(s3 !== peg$FAILED){
                        s2.push(s3);
                        s3 = peg$parseIGNORE();
                    }
                    if (s2 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s3 = peg$c1;
                            peg$currPos++;
                        } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                        if (s3 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c3(s1);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseCOMMENT() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 35) {
                s1 = peg$c4;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c5);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c6.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c7);
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c6.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c7);
                    }
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 10) {
                        s3 = peg$c8;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c9);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c10(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseIGNORE() {
            var s0;
            s0 = peg$parseWS();
            if (s0 === peg$FAILED) s0 = peg$parseCOMMENT();
            return s0;
        }
        function peg$parsedirective() {
            var s0;
            s0 = peg$parseprefixID();
            if (s0 === peg$FAILED) {
                s0 = peg$parsebase();
                if (s0 === peg$FAILED) {
                    s0 = peg$parsesparqlPrefix();
                    if (s0 === peg$FAILED) s0 = peg$parsesparqlBase();
                }
            }
            return s0;
        }
        function peg$parseprefixID() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 7) === peg$c11) {
                    s2 = peg$c11;
                    peg$currPos += 7;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c12);
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseIGNORE();
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseIGNORE();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parsePNAME_NS_NO_CHECK();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseIGNORE();
                            while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseIGNORE();
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parseIRIREF();
                                if (s6 !== peg$FAILED) {
                                    s7 = [];
                                    s8 = peg$parseIGNORE();
                                    while(s8 !== peg$FAILED){
                                        s7.push(s8);
                                        s8 = peg$parseIGNORE();
                                    }
                                    if (s7 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 46) {
                                            s8 = peg$c1;
                                            peg$currPos++;
                                        } else {
                                            s8 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c2);
                                        }
                                        if (s8 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c13(s4, s6);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsebase() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 5) === peg$c14) {
                    s2 = peg$c14;
                    peg$currPos += 5;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c15);
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseIGNORE();
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseIGNORE();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseIRIREF();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseIGNORE();
                            while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseIGNORE();
                            }
                            if (s5 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 46) {
                                    s6 = peg$c1;
                                    peg$currPos++;
                                } else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c2);
                                }
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c16(s4);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsesparqlBase() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (peg$c17.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c18);
                }
                if (s2 !== peg$FAILED) {
                    if (peg$c19.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c20);
                    }
                    if (s3 !== peg$FAILED) {
                        if (peg$c21.test(input.charAt(peg$currPos))) {
                            s4 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c22);
                        }
                        if (s4 !== peg$FAILED) {
                            if (peg$c23.test(input.charAt(peg$currPos))) {
                                s5 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c24);
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = [];
                                s7 = peg$parseIGNORE();
                                while(s7 !== peg$FAILED){
                                    s6.push(s7);
                                    s7 = peg$parseIGNORE();
                                }
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseIRIREF();
                                    if (s7 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c16(s7);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsesparqlPrefix() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (peg$c25.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c26);
                }
                if (s2 !== peg$FAILED) {
                    if (peg$c27.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c28);
                    }
                    if (s3 !== peg$FAILED) {
                        if (peg$c23.test(input.charAt(peg$currPos))) {
                            s4 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c24);
                        }
                        if (s4 !== peg$FAILED) {
                            if (peg$c29.test(input.charAt(peg$currPos))) {
                                s5 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c30);
                            }
                            if (s5 !== peg$FAILED) {
                                if (peg$c31.test(input.charAt(peg$currPos))) {
                                    s6 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s6 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c32);
                                }
                                if (s6 !== peg$FAILED) {
                                    if (peg$c33.test(input.charAt(peg$currPos))) {
                                        s7 = input.charAt(peg$currPos);
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c34);
                                    }
                                    if (s7 !== peg$FAILED) {
                                        s8 = [];
                                        s9 = peg$parseIGNORE();
                                        while(s9 !== peg$FAILED){
                                            s8.push(s9);
                                            s9 = peg$parseIGNORE();
                                        }
                                        if (s8 !== peg$FAILED) {
                                            s9 = peg$parsePNAME_NS_NO_CHECK();
                                            if (s9 !== peg$FAILED) {
                                                s10 = [];
                                                s11 = peg$parseIGNORE();
                                                while(s11 !== peg$FAILED){
                                                    s10.push(s11);
                                                    s11 = peg$parseIGNORE();
                                                }
                                                if (s10 !== peg$FAILED) {
                                                    s11 = peg$parseIRIREF();
                                                    if (s11 !== peg$FAILED) {
                                                        peg$savedPos = s0;
                                                        s1 = peg$c13(s9, s11);
                                                        s0 = s1;
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsetriples() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsesubject();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsepredicateObjectList();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c35(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseblankNodePropertyList();
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsepredicateObjectList();
                    if (s2 === peg$FAILED) s2 = null;
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c36(s1, s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parsepredicateObjectList() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
            s0 = peg$currPos;
            s1 = peg$parseverb();
            if (s1 !== peg$FAILED) {
                s2 = peg$parseobjectList();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    s5 = [];
                    s6 = peg$parseIGNORE();
                    while(s6 !== peg$FAILED){
                        s5.push(s6);
                        s6 = peg$parseIGNORE();
                    }
                    if (s5 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 59) {
                            s6 = peg$c37;
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c38);
                        }
                        if (s6 !== peg$FAILED) {
                            s7 = peg$currPos;
                            s8 = peg$parseverb();
                            if (s8 !== peg$FAILED) {
                                s9 = peg$parseobjectList();
                                if (s9 !== peg$FAILED) {
                                    peg$savedPos = s7;
                                    s8 = peg$c39(s1, s2, s8, s9);
                                    s7 = s8;
                                } else {
                                    peg$currPos = s7;
                                    s7 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s7;
                                s7 = peg$FAILED;
                            }
                            if (s7 === peg$FAILED) s7 = null;
                            if (s7 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c40(s1, s2, s7);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        s5 = [];
                        s6 = peg$parseIGNORE();
                        while(s6 !== peg$FAILED){
                            s5.push(s6);
                            s6 = peg$parseIGNORE();
                        }
                        if (s5 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 59) {
                                s6 = peg$c37;
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c38);
                            }
                            if (s6 !== peg$FAILED) {
                                s7 = peg$currPos;
                                s8 = peg$parseverb();
                                if (s8 !== peg$FAILED) {
                                    s9 = peg$parseobjectList();
                                    if (s9 !== peg$FAILED) {
                                        peg$savedPos = s7;
                                        s8 = peg$c39(s1, s2, s8, s9);
                                        s7 = s8;
                                    } else {
                                        peg$currPos = s7;
                                        s7 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s7;
                                    s7 = peg$FAILED;
                                }
                                if (s7 === peg$FAILED) s7 = null;
                                if (s7 !== peg$FAILED) {
                                    peg$savedPos = s4;
                                    s5 = peg$c40(s1, s2, s7);
                                    s4 = s5;
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c41(s1, s2, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseobjectList() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            s1 = peg$parseobject();
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$currPos;
                s4 = [];
                s5 = peg$parseIGNORE();
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    s5 = peg$parseIGNORE();
                }
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                        s5 = peg$c42;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c43);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = peg$parseobject();
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s3;
                            s4 = peg$c44(s1, s6);
                            s3 = s4;
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$currPos;
                    s4 = [];
                    s5 = peg$parseIGNORE();
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$parseIGNORE();
                    }
                    if (s4 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 44) {
                            s5 = peg$c42;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c43);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseobject();
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s3;
                                s4 = peg$c44(s1, s6);
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c45(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseverb() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsepredicate();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c3(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 97) {
                        s2 = peg$c46;
                        peg$currPos++;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c47);
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c48();
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parsesubject() {
            var s0, s1;
            s0 = peg$currPos;
            s1 = peg$parsecollection();
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c49(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$parseBlankNode();
                if (s0 === peg$FAILED) s0 = peg$parseiri();
            }
            return s0;
        }
        function peg$parsepredicate() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseiri();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseobject() {
            var s0, s1;
            s0 = peg$parseliteral();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsecollection();
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c50(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parseBlankNode();
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c51(s1);
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseblankNodePropertyList();
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c3(s1);
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parseiri();
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c52(s1);
                            }
                            s0 = s1;
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parseliteral() {
            var s0;
            s0 = peg$parseRDFLiteral();
            if (s0 === peg$FAILED) {
                s0 = peg$parseNumericLiteral();
                if (s0 === peg$FAILED) s0 = peg$parseBooleanLiteral();
            }
            return s0;
        }
        function peg$parseblankNodePropertyList() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 91) {
                    s2 = peg$c53;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c54);
                }
                if (s2 !== peg$FAILED) {
                    s3 = peg$parsepredicateObjectList();
                    if (s3 !== peg$FAILED) {
                        s4 = [];
                        s5 = peg$parseIGNORE();
                        while(s5 !== peg$FAILED){
                            s4.push(s5);
                            s5 = peg$parseIGNORE();
                        }
                        if (s4 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 93) {
                                s5 = peg$c55;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c56);
                            }
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c3(s3);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsecollection() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 40) {
                    s2 = peg$c57;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c58);
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseobject();
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseobject();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = [];
                        s5 = peg$parseIGNORE();
                        while(s5 !== peg$FAILED){
                            s4.push(s5);
                            s5 = peg$parseIGNORE();
                        }
                        if (s4 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 41) {
                                s5 = peg$c59;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c60);
                            }
                            if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c61(s3);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseNumericLiteral() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseDOUBLE();
                if (s2 === peg$FAILED) {
                    s2 = peg$parseDECIMAL();
                    if (s2 === peg$FAILED) s2 = peg$parseINTEGER();
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseRDFLiteral() {
            var s0, s1, s2, s3, s4, s5, s6;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseString();
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$parseIGNORE();
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$parseIGNORE();
                    }
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseLANGTAG();
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c62(s2, s4);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseString();
                    if (s2 !== peg$FAILED) {
                        s3 = [];
                        s4 = peg$parseIGNORE();
                        while(s4 !== peg$FAILED){
                            s3.push(s4);
                            s4 = peg$parseIGNORE();
                        }
                        if (s3 !== peg$FAILED) {
                            if (input.substr(peg$currPos, 2) === peg$c63) {
                                s4 = peg$c63;
                                peg$currPos += 2;
                            } else {
                                s4 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c64);
                            }
                            if (s4 !== peg$FAILED) {
                                s5 = [];
                                s6 = peg$parseIGNORE();
                                while(s6 !== peg$FAILED){
                                    s5.push(s6);
                                    s6 = peg$parseIGNORE();
                                }
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parseiri();
                                    if (s6 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c65(s2, s6);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = [];
                    s2 = peg$parseIGNORE();
                    while(s2 !== peg$FAILED){
                        s1.push(s2);
                        s2 = peg$parseIGNORE();
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseString();
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c3(s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                }
            }
            return s0;
        }
        function peg$parseBooleanLiteral() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                if (input.substr(peg$currPos, 4) === peg$c66) {
                    s2 = peg$c66;
                    peg$currPos += 4;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c67);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c68();
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    if (input.substr(peg$currPos, 5) === peg$c69) {
                        s2 = peg$c69;
                        peg$currPos += 5;
                    } else {
                        s2 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c70);
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c71();
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseString() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseSTRING_LITERAL_LONG_SINGLE_QUOTE();
                if (s2 === peg$FAILED) {
                    s2 = peg$parseSTRING_LITERAL_LONG_QUOTE();
                    if (s2 === peg$FAILED) {
                        s2 = peg$parseSTRING_LITERAL_SINGLE_QUOTE();
                        if (s2 === peg$FAILED) s2 = peg$parseSTRING_LITERAL_QUOTE();
                    }
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseiri() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseIRIREF();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parsePrefixedName();
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c3(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parsePrefixedName() {
            var s0, s1;
            s0 = peg$parsePNAME_LN();
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsePNAME_NS();
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c72(s1);
                }
                s0 = s1;
            }
            return s0;
        }
        function peg$parseBlankNode() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while(s2 !== peg$FAILED){
                s1.push(s2);
                s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$parseBLANK_NODE_LABEL();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = [];
                s2 = peg$parseIGNORE();
                while(s2 !== peg$FAILED){
                    s1.push(s2);
                    s2 = peg$parseIGNORE();
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$parseANON();
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c3(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseIRIREF() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 60) {
                s1 = peg$c73;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c74);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c75.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c76);
                }
                if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c75.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c76);
                    }
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 62) {
                        s3 = peg$c77;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c78);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c79(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePNAME_NS() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsePN_PREFIX();
            if (s1 === peg$FAILED) s1 = null;
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                    s2 = peg$c80;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c81);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c82(s1);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePNAME_NS_NO_CHECK() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsePN_PREFIX();
            if (s1 === peg$FAILED) s1 = null;
            if (s1 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                    s2 = peg$c80;
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c81);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c83(s1);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePNAME_LN() {
            var s0, s1, s2;
            s0 = peg$currPos;
            s1 = peg$parsePNAME_NS();
            if (s1 !== peg$FAILED) {
                s2 = peg$parsePN_LOCAL();
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c84(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseBLANK_NODE_LABEL() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c85) {
                s2 = peg$c85;
                peg$currPos += 2;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c86);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parsePN_CHARS_U();
                if (s3 === peg$FAILED) {
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                }
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    s5 = peg$parsePN_CHARS();
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$parsePN_CHARS();
                    }
                    if (s4 !== peg$FAILED) {
                        s5 = [];
                        s6 = peg$currPos;
                        s7 = [];
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s8 = peg$c1;
                            peg$currPos++;
                        } else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                        if (s8 !== peg$FAILED) while(s8 !== peg$FAILED){
                            s7.push(s8);
                            if (input.charCodeAt(peg$currPos) === 46) {
                                s8 = peg$c1;
                                peg$currPos++;
                            } else {
                                s8 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c2);
                            }
                        }
                        else s7 = peg$FAILED;
                        if (s7 !== peg$FAILED) {
                            s8 = [];
                            s9 = peg$parsePN_CHARS();
                            if (s9 !== peg$FAILED) while(s9 !== peg$FAILED){
                                s8.push(s9);
                                s9 = peg$parsePN_CHARS();
                            }
                            else s8 = peg$FAILED;
                            if (s8 !== peg$FAILED) {
                                s7 = [
                                    s7,
                                    s8
                                ];
                                s6 = s7;
                            } else {
                                peg$currPos = s6;
                                s6 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s6;
                            s6 = peg$FAILED;
                        }
                        while(s6 !== peg$FAILED){
                            s5.push(s6);
                            s6 = peg$currPos;
                            s7 = [];
                            if (input.charCodeAt(peg$currPos) === 46) {
                                s8 = peg$c1;
                                peg$currPos++;
                            } else {
                                s8 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c2);
                            }
                            if (s8 !== peg$FAILED) while(s8 !== peg$FAILED){
                                s7.push(s8);
                                if (input.charCodeAt(peg$currPos) === 46) {
                                    s8 = peg$c1;
                                    peg$currPos++;
                                } else {
                                    s8 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c2);
                                }
                            }
                            else s7 = peg$FAILED;
                            if (s7 !== peg$FAILED) {
                                s8 = [];
                                s9 = peg$parsePN_CHARS();
                                if (s9 !== peg$FAILED) while(s9 !== peg$FAILED){
                                    s8.push(s9);
                                    s9 = peg$parsePN_CHARS();
                                }
                                else s8 = peg$FAILED;
                                if (s8 !== peg$FAILED) {
                                    s7 = [
                                        s7,
                                        s8
                                    ];
                                    s6 = s7;
                                } else {
                                    peg$currPos = s6;
                                    s6 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s6;
                                s6 = peg$FAILED;
                            }
                        }
                        if (s5 !== peg$FAILED) {
                            s2 = [
                                s2,
                                s3,
                                s4,
                                s5
                            ];
                            s1 = s2;
                        } else {
                            peg$currPos = s1;
                            s1 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            return s0;
        }
        function peg$parseLANGTAG() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 64) {
                s1 = peg$c89;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c90);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c91.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c92);
                }
                if (s3 !== peg$FAILED) while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c91.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c92);
                    }
                }
                else s2 = peg$FAILED;
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 45) {
                        s5 = peg$c93;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c94);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c95.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c96);
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c95.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c96);
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s4;
                            s5 = peg$c97(s2, s6);
                            s4 = s5;
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 45) {
                            s5 = peg$c93;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c94);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c95.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c96);
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c95.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c96);
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c97(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c98(s2, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseINTEGER() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$currPos;
            if (peg$c99.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c100);
            }
            if (s3 === peg$FAILED) s3 = null;
            if (s3 !== peg$FAILED) {
                s4 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                    s5 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c88);
                }
                if (s5 !== peg$FAILED) while(s5 !== peg$FAILED){
                    s4.push(s5);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                }
                else s4 = peg$FAILED;
                if (s4 !== peg$FAILED) {
                    s3 = [
                        s3,
                        s4
                    ];
                    s2 = s3;
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
            else s1 = s2;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c101(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseDECIMAL() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$currPos;
            if (peg$c99.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c100);
            }
            if (s3 === peg$FAILED) s3 = null;
            if (s3 !== peg$FAILED) {
                s4 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                    s5 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c88);
                }
                while(s5 !== peg$FAILED){
                    s4.push(s5);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                }
                if (s4 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s5 = peg$c1;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c87.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c88);
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            s3 = [
                                s3,
                                s4,
                                s5,
                                s6
                            ];
                            s2 = s3;
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
            else s1 = s2;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c102(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseDOUBLE() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$currPos;
            if (peg$c99.test(input.charAt(peg$currPos))) {
                s3 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c100);
            }
            if (s3 === peg$FAILED) s3 = null;
            if (s3 !== peg$FAILED) {
                s4 = peg$currPos;
                s5 = [];
                if (peg$c87.test(input.charAt(peg$currPos))) {
                    s6 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c88);
                }
                if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                    s5.push(s6);
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s6 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                }
                else s5 = peg$FAILED;
                if (s5 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s6 = peg$c1;
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s6 !== peg$FAILED) {
                        s7 = [];
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s8 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s8 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                        while(s8 !== peg$FAILED){
                            s7.push(s8);
                            if (peg$c87.test(input.charAt(peg$currPos))) {
                                s8 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s8 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c88);
                            }
                        }
                        if (s7 !== peg$FAILED) {
                            s8 = peg$parseEXPONENT();
                            if (s8 !== peg$FAILED) {
                                s5 = [
                                    s5,
                                    s6,
                                    s7,
                                    s8
                                ];
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                }
                if (s4 === peg$FAILED) {
                    s4 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s5 = peg$c1;
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c87.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c88);
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            s7 = peg$parseEXPONENT();
                            if (s7 !== peg$FAILED) {
                                s5 = [
                                    s5,
                                    s6,
                                    s7
                                ];
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    if (s4 === peg$FAILED) {
                        s4 = peg$currPos;
                        s5 = [];
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s6 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                        if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                            s5.push(s6);
                            if (peg$c87.test(input.charAt(peg$currPos))) {
                                s6 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c88);
                            }
                        }
                        else s5 = peg$FAILED;
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseEXPONENT();
                            if (s6 !== peg$FAILED) {
                                s5 = [
                                    s5,
                                    s6
                                ];
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                }
                if (s4 !== peg$FAILED) {
                    s3 = [
                        s3,
                        s4
                    ];
                    s2 = s3;
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
            } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) s1 = input.substring(s1, peg$currPos);
            else s1 = s2;
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c103(s1);
            }
            s0 = s1;
            return s0;
        }
        function peg$parseEXPONENT() {
            var s0, s1, s2, s3, s4, s5;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (peg$c104.test(input.charAt(peg$currPos))) {
                s2 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c105);
            }
            if (s2 !== peg$FAILED) {
                if (peg$c99.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c100);
                }
                if (s3 === peg$FAILED) s3 = null;
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s5 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                    if (s5 !== peg$FAILED) while(s5 !== peg$FAILED){
                        s4.push(s5);
                        if (peg$c87.test(input.charAt(peg$currPos))) {
                            s5 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c88);
                        }
                    }
                    else s4 = peg$FAILED;
                    if (s4 !== peg$FAILED) {
                        s2 = [
                            s2,
                            s3,
                            s4
                        ];
                        s1 = s2;
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            return s0;
        }
        function peg$parseSTRING_LITERAL_QUOTE() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 34) {
                s1 = peg$c106;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c107);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c108.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c109);
                }
                if (s3 === peg$FAILED) {
                    s3 = peg$parseECHAR();
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c108.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c109);
                    }
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseECHAR();
                        if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                    }
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 34) {
                        s3 = peg$c106;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c107);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c10(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSTRING_LITERAL_SINGLE_QUOTE() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 39) {
                s1 = peg$c110;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c111);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c112.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c113);
                }
                if (s3 === peg$FAILED) {
                    s3 = peg$parseECHAR();
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c112.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c113);
                    }
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseECHAR();
                        if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                    }
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 39) {
                        s3 = peg$c110;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c111);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c10(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSTRING_LITERAL_LONG_SINGLE_QUOTE() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3) === peg$c114) {
                s1 = peg$c114;
                peg$currPos += 3;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c115);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c116.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c117);
                }
                if (s3 === peg$FAILED) {
                    s3 = peg$parseECHAR();
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c116.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c117);
                    }
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseECHAR();
                        if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c118) {
                        s5 = peg$c118;
                        peg$currPos += 2;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c119);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c116.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c117);
                        }
                        if (s7 === peg$FAILED) {
                            s7 = peg$parseECHAR();
                            if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c116.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c117);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s4;
                            s5 = peg$c120(s2, s6);
                            s4 = s5;
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    if (s4 === peg$FAILED) {
                        s4 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 39) {
                            s5 = peg$c110;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c111);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c116.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c117);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c116.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c117);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c121(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c118) {
                            s5 = peg$c118;
                            peg$currPos += 2;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c119);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c116.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c117);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c116.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c117);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c120(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                        if (s4 === peg$FAILED) {
                            s4 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 39) {
                                s5 = peg$c110;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c111);
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = [];
                                if (peg$c116.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c117);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                                if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                    s6.push(s7);
                                    if (peg$c116.test(input.charAt(peg$currPos))) {
                                        s7 = input.charAt(peg$currPos);
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c117);
                                    }
                                    if (s7 === peg$FAILED) {
                                        s7 = peg$parseECHAR();
                                        if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                    }
                                }
                                else s6 = peg$FAILED;
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s4;
                                    s5 = peg$c121(s2, s6);
                                    s4 = s5;
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 3) === peg$c114) {
                            s4 = peg$c114;
                            peg$currPos += 3;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c115);
                        }
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c122(s2, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseSTRING_LITERAL_LONG_QUOTE() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 3) === peg$c123) {
                s1 = peg$c123;
                peg$currPos += 3;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c124);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                if (peg$c125.test(input.charAt(peg$currPos))) {
                    s3 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c126);
                }
                if (s3 === peg$FAILED) {
                    s3 = peg$parseECHAR();
                    if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    if (peg$c125.test(input.charAt(peg$currPos))) {
                        s3 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c126);
                    }
                    if (s3 === peg$FAILED) {
                        s3 = peg$parseECHAR();
                        if (s3 === peg$FAILED) s3 = peg$parseUCHAR();
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c127) {
                        s5 = peg$c127;
                        peg$currPos += 2;
                    } else {
                        s5 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c128);
                    }
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        if (peg$c125.test(input.charAt(peg$currPos))) {
                            s7 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c126);
                        }
                        if (s7 === peg$FAILED) {
                            s7 = peg$parseECHAR();
                            if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (peg$c125.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c126);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s4;
                            s5 = peg$c129(s2, s6);
                            s4 = s5;
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    if (s4 === peg$FAILED) {
                        s4 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 34) {
                            s5 = peg$c106;
                            peg$currPos++;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c107);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c125.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c126);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c125.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c126);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c130(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c127) {
                            s5 = peg$c127;
                            peg$currPos += 2;
                        } else {
                            s5 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c128);
                        }
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            if (peg$c125.test(input.charAt(peg$currPos))) {
                                s7 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c126);
                            }
                            if (s7 === peg$FAILED) {
                                s7 = peg$parseECHAR();
                                if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                if (peg$c125.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c126);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c129(s2, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                        if (s4 === peg$FAILED) {
                            s4 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 34) {
                                s5 = peg$c106;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c107);
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = [];
                                if (peg$c125.test(input.charAt(peg$currPos))) {
                                    s7 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c126);
                                }
                                if (s7 === peg$FAILED) {
                                    s7 = peg$parseECHAR();
                                    if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                }
                                if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                    s6.push(s7);
                                    if (peg$c125.test(input.charAt(peg$currPos))) {
                                        s7 = input.charAt(peg$currPos);
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c126);
                                    }
                                    if (s7 === peg$FAILED) {
                                        s7 = peg$parseECHAR();
                                        if (s7 === peg$FAILED) s7 = peg$parseUCHAR();
                                    }
                                }
                                else s6 = peg$FAILED;
                                if (s6 !== peg$FAILED) {
                                    peg$savedPos = s4;
                                    s5 = peg$c130(s2, s6);
                                    s4 = s5;
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 3) === peg$c123) {
                            s4 = peg$c123;
                            peg$currPos += 3;
                        } else {
                            s4 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c124);
                        }
                        if (s4 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c122(s2, s3);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parseUCHAR() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c131) {
                s1 = peg$c131;
                peg$currPos += 2;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c132);
            }
            if (s1 !== peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseHEX();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseHEX();
                    if (s4 !== peg$FAILED) {
                        s5 = peg$parseHEX();
                        if (s5 !== peg$FAILED) {
                            s6 = peg$parseHEX();
                            if (s6 !== peg$FAILED) {
                                s7 = peg$parseHEX();
                                if (s7 !== peg$FAILED) {
                                    s8 = peg$parseHEX();
                                    if (s8 !== peg$FAILED) {
                                        s9 = peg$parseHEX();
                                        if (s9 !== peg$FAILED) {
                                            s10 = peg$parseHEX();
                                            if (s10 !== peg$FAILED) {
                                                s3 = [
                                                    s3,
                                                    s4,
                                                    s5,
                                                    s6,
                                                    s7,
                                                    s8,
                                                    s9,
                                                    s10
                                                ];
                                                s2 = s3;
                                            } else {
                                                peg$currPos = s2;
                                                s2 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s2;
                                            s2 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s2;
                                        s2 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s2;
                                    s2 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s2;
                                s2 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c133(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c134) {
                    s1 = peg$c134;
                    peg$currPos += 2;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c135);
                }
                if (s1 !== peg$FAILED) {
                    s2 = peg$currPos;
                    s3 = peg$parseHEX();
                    if (s3 !== peg$FAILED) {
                        s4 = peg$parseHEX();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseHEX();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parseHEX();
                                if (s6 !== peg$FAILED) {
                                    s3 = [
                                        s3,
                                        s4,
                                        s5,
                                        s6
                                    ];
                                    s2 = s3;
                                } else {
                                    peg$currPos = s2;
                                    s2 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s2;
                                s2 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                    }
                    if (s2 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c136(s2);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            }
            return s0;
        }
        function peg$parseECHAR() {
            var s0, s1;
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c137) {
                s1 = peg$c137;
                peg$currPos += 2;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c138);
            }
            if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c139();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c140) {
                    s1 = peg$c140;
                    peg$currPos += 2;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c141);
                }
                if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c142();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c143) {
                        s1 = peg$c143;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c144);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c145();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c146) {
                            s1 = peg$c146;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c147);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c148();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 2) === peg$c149) {
                                s1 = peg$c149;
                                peg$currPos += 2;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c150);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c151();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 2) === peg$c152) {
                                    s1 = peg$c152;
                                    peg$currPos += 2;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c153);
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c154();
                                }
                                s0 = s1;
                                if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    if (input.substr(peg$currPos, 2) === peg$c155) {
                                        s1 = peg$c155;
                                        peg$currPos += 2;
                                    } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c156);
                                    }
                                    if (s1 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c157();
                                    }
                                    s0 = s1;
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        if (input.substr(peg$currPos, 2) === peg$c158) {
                                            s1 = peg$c158;
                                            peg$currPos += 2;
                                        } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c159);
                                        }
                                        if (s1 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c160();
                                        }
                                        s0 = s1;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parseWS() {
            var s0;
            if (peg$c161.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c162);
            }
            return s0;
        }
        function peg$parseANON() {
            var s0, s1, s2, s3;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 91) {
                s1 = peg$c53;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c54);
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parseIGNORE();
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parseIGNORE();
                }
                if (s2 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 93) {
                        s3 = peg$c55;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c56);
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c163();
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePN_CHARS_BASE() {
            var s0, s1, s2;
            s0 = peg$currPos;
            if (peg$c164.test(input.charAt(peg$currPos))) {
                s1 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c165);
            }
            if (s1 !== peg$FAILED) {
                if (peg$c166.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c167);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c168(s1, s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
                if (peg$c169.test(input.charAt(peg$currPos))) {
                    s0 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c170);
                }
            }
            return s0;
        }
        function peg$parsePN_CHARS_U() {
            var s0;
            s0 = peg$parsePN_CHARS_BASE();
            if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 95) {
                    s0 = peg$c171;
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c172);
                }
            }
            return s0;
        }
        function peg$parsePN_CHARS() {
            var s0;
            s0 = peg$parsePN_CHARS_U();
            if (s0 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 45) {
                    s0 = peg$c93;
                    peg$currPos++;
                } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c94);
                }
                if (s0 === peg$FAILED) {
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s0 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s0 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                    if (s0 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 183) {
                            s0 = peg$c173;
                            peg$currPos++;
                        } else {
                            s0 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c174);
                        }
                        if (s0 === peg$FAILED) {
                            if (peg$c175.test(input.charAt(peg$currPos))) {
                                s0 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s0 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c176);
                            }
                            if (s0 === peg$FAILED) {
                                if (peg$c177.test(input.charAt(peg$currPos))) {
                                    s0 = input.charAt(peg$currPos);
                                    peg$currPos++;
                                } else {
                                    s0 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c178);
                                }
                            }
                        }
                    }
                }
            }
            return s0;
        }
        function peg$parsePN_PREFIX() {
            var s0, s1, s2, s3, s4, s5, s6, s7, s8;
            s0 = peg$currPos;
            s1 = peg$currPos;
            s2 = peg$parsePN_CHARS_BASE();
            if (s2 !== peg$FAILED) {
                s3 = [];
                s4 = peg$parsePN_CHARS();
                while(s4 !== peg$FAILED){
                    s3.push(s4);
                    s4 = peg$parsePN_CHARS();
                }
                if (s3 !== peg$FAILED) {
                    s4 = [];
                    s5 = peg$currPos;
                    s6 = [];
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s7 = peg$c1;
                        peg$currPos++;
                    } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                        s6.push(s7);
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s7 = peg$c1;
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                    }
                    else s6 = peg$FAILED;
                    if (s6 !== peg$FAILED) {
                        s7 = [];
                        s8 = peg$parsePN_CHARS();
                        if (s8 !== peg$FAILED) while(s8 !== peg$FAILED){
                            s7.push(s8);
                            s8 = peg$parsePN_CHARS();
                        }
                        else s7 = peg$FAILED;
                        if (s7 !== peg$FAILED) {
                            s6 = [
                                s6,
                                s7
                            ];
                            s5 = s6;
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s5;
                        s5 = peg$FAILED;
                    }
                    while(s5 !== peg$FAILED){
                        s4.push(s5);
                        s5 = peg$currPos;
                        s6 = [];
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s7 = peg$c1;
                            peg$currPos++;
                        } else {
                            s7 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            if (input.charCodeAt(peg$currPos) === 46) {
                                s7 = peg$c1;
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c2);
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            s7 = [];
                            s8 = peg$parsePN_CHARS();
                            if (s8 !== peg$FAILED) while(s8 !== peg$FAILED){
                                s7.push(s8);
                                s8 = peg$parsePN_CHARS();
                            }
                            else s7 = peg$FAILED;
                            if (s7 !== peg$FAILED) {
                                s6 = [
                                    s6,
                                    s7
                                ];
                                s5 = s6;
                            } else {
                                peg$currPos = s5;
                                s5 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s5;
                            s5 = peg$FAILED;
                        }
                    }
                    if (s4 !== peg$FAILED) {
                        s2 = [
                            s2,
                            s3,
                            s4
                        ];
                        s1 = s2;
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            return s0;
        }
        function peg$parsePN_LOCAL() {
            var s0, s1, s2, s3, s4, s5, s6, s7;
            s0 = peg$currPos;
            s1 = peg$parsePN_CHARS_U();
            if (s1 === peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 58) {
                    s1 = peg$c80;
                    peg$currPos++;
                } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c81);
                }
                if (s1 === peg$FAILED) {
                    if (peg$c87.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c88);
                    }
                    if (s1 === peg$FAILED) s1 = peg$parsePLX();
                }
            }
            if (s1 !== peg$FAILED) {
                s2 = [];
                s3 = peg$parsePN_CHARS();
                if (s3 === peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 58) {
                        s3 = peg$c80;
                        peg$currPos++;
                    } else {
                        s3 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c81);
                    }
                    if (s3 === peg$FAILED) s3 = peg$parsePLX();
                }
                while(s3 !== peg$FAILED){
                    s2.push(s3);
                    s3 = peg$parsePN_CHARS();
                    if (s3 === peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 58) {
                            s3 = peg$c80;
                            peg$currPos++;
                        } else {
                            s3 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c81);
                        }
                        if (s3 === peg$FAILED) s3 = peg$parsePLX();
                    }
                }
                if (s2 !== peg$FAILED) {
                    s3 = [];
                    s4 = peg$currPos;
                    s5 = [];
                    if (input.charCodeAt(peg$currPos) === 46) {
                        s6 = peg$c1;
                        peg$currPos++;
                    } else {
                        s6 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                        s5.push(s6);
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s6 = peg$c1;
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                    }
                    else s5 = peg$FAILED;
                    if (s5 !== peg$FAILED) {
                        s6 = [];
                        s7 = peg$parsePN_CHARS();
                        if (s7 === peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 58) {
                                s7 = peg$c80;
                                peg$currPos++;
                            } else {
                                s7 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c81);
                            }
                            if (s7 === peg$FAILED) s7 = peg$parsePLX();
                        }
                        if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                            s6.push(s7);
                            s7 = peg$parsePN_CHARS();
                            if (s7 === peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 58) {
                                    s7 = peg$c80;
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c81);
                                }
                                if (s7 === peg$FAILED) s7 = peg$parsePLX();
                            }
                        }
                        else s6 = peg$FAILED;
                        if (s6 !== peg$FAILED) {
                            peg$savedPos = s4;
                            s5 = peg$c179(s1, s2, s5, s6);
                            s4 = s5;
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s4;
                        s4 = peg$FAILED;
                    }
                    while(s4 !== peg$FAILED){
                        s3.push(s4);
                        s4 = peg$currPos;
                        s5 = [];
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s6 = peg$c1;
                            peg$currPos++;
                        } else {
                            s6 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c2);
                        }
                        if (s6 !== peg$FAILED) while(s6 !== peg$FAILED){
                            s5.push(s6);
                            if (input.charCodeAt(peg$currPos) === 46) {
                                s6 = peg$c1;
                                peg$currPos++;
                            } else {
                                s6 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c2);
                            }
                        }
                        else s5 = peg$FAILED;
                        if (s5 !== peg$FAILED) {
                            s6 = [];
                            s7 = peg$parsePN_CHARS();
                            if (s7 === peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 58) {
                                    s7 = peg$c80;
                                    peg$currPos++;
                                } else {
                                    s7 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c81);
                                }
                                if (s7 === peg$FAILED) s7 = peg$parsePLX();
                            }
                            if (s7 !== peg$FAILED) while(s7 !== peg$FAILED){
                                s6.push(s7);
                                s7 = peg$parsePN_CHARS();
                                if (s7 === peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 58) {
                                        s7 = peg$c80;
                                        peg$currPos++;
                                    } else {
                                        s7 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c81);
                                    }
                                    if (s7 === peg$FAILED) s7 = peg$parsePLX();
                                }
                            }
                            else s6 = peg$FAILED;
                            if (s6 !== peg$FAILED) {
                                peg$savedPos = s4;
                                s5 = peg$c179(s1, s2, s5, s6);
                                s4 = s5;
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s4;
                            s4 = peg$FAILED;
                        }
                    }
                    if (s3 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c180(s1, s2, s3);
                        s0 = s1;
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        function peg$parsePLX() {
            var s0;
            s0 = peg$parsePERCENT();
            if (s0 === peg$FAILED) s0 = peg$parsePN_LOCAL_ESC();
            return s0;
        }
        function peg$parsePERCENT() {
            var s0, s1, s2, s3, s4;
            s0 = peg$currPos;
            s1 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 37) {
                s2 = peg$c181;
                peg$currPos++;
            } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c182);
            }
            if (s2 !== peg$FAILED) {
                s3 = peg$parseHEX();
                if (s3 !== peg$FAILED) {
                    s4 = peg$parseHEX();
                    if (s4 !== peg$FAILED) {
                        s2 = [
                            s2,
                            s3,
                            s4
                        ];
                        s1 = s2;
                    } else {
                        peg$currPos = s1;
                        s1 = peg$FAILED;
                    }
                } else {
                    peg$currPos = s1;
                    s1 = peg$FAILED;
                }
            } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
            }
            if (s1 !== peg$FAILED) s0 = input.substring(s0, peg$currPos);
            else s0 = s1;
            return s0;
        }
        function peg$parseHEX() {
            var s0;
            if (peg$c183.test(input.charAt(peg$currPos))) {
                s0 = input.charAt(peg$currPos);
                peg$currPos++;
            } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c184);
            }
            return s0;
        }
        function peg$parsePN_LOCAL_ESC() {
            var s0, s1, s2;
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 92) {
                s1 = peg$c185;
                peg$currPos++;
            } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) peg$fail(peg$c186);
            }
            if (s1 !== peg$FAILED) {
                if (peg$c187.test(input.charAt(peg$currPos))) {
                    s2 = input.charAt(peg$currPos);
                    peg$currPos++;
                } else {
                    s2 = peg$FAILED;
                    if (peg$silentFails === 0) peg$fail(peg$c188);
                }
                if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c3(s2);
                    s0 = s1;
                } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                }
            } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
            }
            return s0;
        }
        var isBrowser = new Function("try {return this===window;}catch(e){ return false;}");
        var URL = isBrowser() ? window.URL : (parcelRequire("biuEp")).URL;
        var isIRI = function(a) {
            return a.match(/^[a-z](.*?):(.+?)/g);
        };
        function createObject(property, value) {
            var a = {};
            a[property] = value;
            return a;
        }
        var context = {
            base: [],
            data: {},
            addBase: function(uri) {
                if (context.base.length === 0) {
                    context.base.push(uri);
                    return;
                }
                const last = context.base[context.base.length - 1];
                if (last !== uri) context.base.push(new URL(uri, last).toString());
            },
            addPrefix: function(prefix, uri) {
                const list = context.data[prefix];
                if (list === undefined) context.data[prefix] = [
                    {
                        uri: uri,
                        count: 0
                    }
                ];
                else if (list[list.length - 1].uri !== uri) list.push({
                    uri: uri,
                    count: 0
                });
            },
            hasPrefix: function(prefix) {
                return this.data[prefix] !== undefined;
            },
            resolve: function(pname, force) {
                const prefix = Object.keys(context.data).find((key)=>pname.indexOf(key + ":") === 0);
                if (prefix !== undefined) {
                    const list = context.data[prefix];
                    if (list.length === 1 && force !== true && isIRI(list[0].uri)) return pname;
                    const uri = list[list.length - 1].uri;
                    return pname.replace(prefix + ":", uri);
                } else {
                    var base = context.base.length === 0 ? options.baseIRI : context.base[context.base.length - 1];
                    if (!base || pname.match(/^(http:|https:|urn:|file:)/)) return pname;
                    if (pname.indexOf("//") === 0 && base) return base.split("//")[0] + pname;
                    return new URL(pname, base).toString();
                }
            },
            increment: function(prefix) {
                const list = context.data[prefix];
                if (list !== undefined) list[list.length - 1].count++;
            },
            decrement: function(prefix) {
                const list = context.data[prefix];
                if (list !== undefined) list[list.length - 1].count--;
            },
            toJSON: function() {
                const root = {};
                if (context.base.length > 0) {
                    if (root["@context"] === undefined) root["@context"] = {};
                    root["@context"]["@base"] = context.base[0];
                }
                Object.keys(context.data).forEach((key)=>{
                    const head = context.data[key][0];
                    if (head.uri === "http://www.w3.org/2001/XMLSchema#" && head.count < 1) return;
                    if (!isIRI(head.uri)) return;
                    if (root["@context"] === undefined) root["@context"] = {};
                    root["@context"][key] = head.uri;
                });
                return root;
            }
        };
        function expandList(container, force) {
            if (container["@list"] === undefined) return container;
            if (!force && !container["@list"].find((x)=>x["@list"] !== undefined)) return container;
            if (container["@list"].length === 0) return {
                "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
            };
            var root = {};
            var focus = null;
            container["@list"].forEach((b)=>{
                if (focus === null) focus = root;
                else {
                    focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"] = {};
                    focus = focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"];
                }
                focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#first"] = expandList(b, true);
                focus["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"] = {
                    "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
                };
            });
            return root;
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
        else {
            if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
            throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
        }
    }
    return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse
    };
});


function $f832e5387e149401$export$2e2bcd8739ae039(store) {
    return new $f832e5387e149401$export$ef852775387a0be7(store);
}
var $f832e5387e149401$export$ef852775387a0be7 = /*#__PURE__*/ function() {
    function Serializer(store) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Serializer);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_notQNameChars", "	\r\n !\"#$%&'()*.,+/;<=>?@[\\]^`{|}~");
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_notNameChars", this._notQNameChars + ":");
        //  stringToN3:  String escaping for N3
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "validPrefix", new RegExp(/^[a-zA-Z][a-zA-Z0-9]*$/));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "forbidden1", new RegExp(/[\\"\b\f\r\v\t\n\u0080-\uffff]/gm));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "forbidden3", new RegExp(/[\\"\b\f\r\v\u0080-\uffff]/gm));
        this.flags = "";
        this.base = null;
        this.prefixes = []; // suggested prefixes
        this.namespaces = []; // complementary
        var nsKeys = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($3f9355bcac0943b6$exports)))());
        for(var i in nsKeys){
            var uri = (0, (/*@__PURE__*/$parcel$interopDefault($3f9355bcac0943b6$exports)))()[nsKeys[i]]("");
            var prefix = nsKeys[i];
            this.prefixes[uri] = prefix;
            this.namespaces[prefix] = uri;
        }
        this.suggestPrefix("rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#"); // XML code assumes this!
        this.suggestPrefix("xml", "reserved:reservedForFutureUse"); // XML reserves xml: in the spec.
        this.namespacesUsed = []; // Count actually used and so needed in @prefixes
        this.keywords = [
            "a"
        ]; // The only one we generate at the moment
        this.prefixchars = "abcdefghijklmnopqustuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        this.incoming = null; // Array not calculated yet
        this.formulas = []; // remembering original formulae from hashes
        this.store = store;
        this.rdfFactory = store.rdfFactory || (0, $158d84b4866fe33e$export$2e2bcd8739ae039);
        this.xsd = (0, $c58a780548822e73$export$abafb17d1d8eb7fd)(this.rdfFactory);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Serializer, [
        {
            key: "setBase",
            value: function setBase(base) {
                this.base = base;
                return this;
            }
        },
        {
            key: "setFlags",
            value: function setFlags(flags) {
                this.flags = flags || "";
                return this;
            }
        },
        {
            key: "toStr",
            value: function toStr(x) {
                var s = x.toNT();
                if (x.termType === "Graph") this.formulas[s] = x; // remember as reverse does not work
                return s;
            }
        },
        {
            key: "fromStr",
            value: function fromStr(s) {
                if (s[0] === "{") {
                    var x = this.formulas[s];
                    if (!x) console.log("No formula object for " + s);
                    return x;
                }
                return this.store.fromNT(s);
            }
        },
        {
            key: "setNamespaces",
            value: function setNamespaces(namespaces) {
                for(var px in namespaces)this.setPrefix(px, namespaces[px]);
                return this;
            }
        },
        {
            key: "setPrefix",
            value: function setPrefix(prefix, uri) {
                if (prefix.slice(0, 7) === "default") return; // Try to weed these out
                if (prefix.slice(0, 2) === "ns") return; //  From others inferior algos
                if (!prefix || !uri) return; // empty strings not suitable
                // remove any existing prefix targeting this uri
                // for (let existingPrefix in this.namespaces) {
                //   if (this.namespaces[existingPrefix] == uri)
                //     delete this.namespaces[existingPrefix];
                // }
                // remove any existing mapping for this prefix
                for(var existingNs in this.prefixes)if (this.prefixes[existingNs] == prefix) delete this.prefixes[existingNs];
                this.prefixes[uri] = prefix;
                this.namespaces[prefix] = uri;
            }
        },
        {
            key: "suggestPrefix",
            value: function suggestPrefix(prefix, uri) {
                if (prefix.slice(0, 7) === "default") return; // Try to weed these out
                if (prefix.slice(0, 2) === "ns") return; //  From others inferior algos
                if (!prefix || !uri) return; // empty strings not suitable
                if (prefix in this.namespaces || uri in this.prefixes) return; // already used
                this.prefixes[uri] = prefix;
                this.namespaces[prefix] = uri;
            }
        },
        {
            key: "suggestNamespaces",
            value: function suggestNamespaces(namespaces) {
                for(var px in namespaces)this.suggestPrefix(px, namespaces[px]);
                return this;
            }
        },
        {
            key: "checkIntegrity",
            value: function checkIntegrity() {
                var p, ns;
                for(p in this.namespaces){
                    if (this.prefixes[this.namespaces[p]] !== p) throw new Error("Serializer integity error 1: " + p + ", " + this.namespaces[p] + ", " + this.prefixes[this.namespaces[p]] + "!");
                }
                for(ns in this.prefixes){
                    if (this.namespaces[this.prefixes[ns]] !== ns) throw new Error("Serializer integity error 2: " + ns + ", " + this.prefixs[ns] + ", " + this.namespaces[this.prefixes[ns]] + "!");
                }
            }
        },
        {
            key: "makeUpPrefix",
            value: function makeUpPrefix(uri) {
                var p = uri;
                function canUseMethod(pp) {
                    if (!this.validPrefix.test(pp)) return false; // bad format
                    if (pp === "ns") return false; // boring
                    if (pp in this.namespaces) return false; // already used
                    this.prefixes[uri] = pp;
                    this.namespaces[pp] = uri;
                    return pp;
                }
                var canUse = canUseMethod.bind(this);
                if ("#/".indexOf(p[p.length - 1]) >= 0) p = p.slice(0, -1);
                var slash = p.lastIndexOf("/");
                if (slash >= 0) p = p.slice(slash + 1);
                var i = 0;
                while(i < p.length){
                    if (this.prefixchars.indexOf(p[i])) i++;
                    else break;
                }
                p = p.slice(0, i);
                if (p.length < 6 && canUse(p)) return p; // exact is best
                if (canUse(p.slice(0, 3))) return p.slice(0, 3);
                if (canUse(p.slice(0, 2))) return p.slice(0, 2);
                if (canUse(p.slice(0, 4))) return p.slice(0, 4);
                if (canUse(p.slice(0, 1))) return p.slice(0, 1);
                if (canUse(p.slice(0, 5))) return p.slice(0, 5);
                if (!this.validPrefix.test(p)) p = "n"; // Otherwise the loop below may never termimnate
                for(var j = 0;; j++)if (canUse(p.slice(0, 3) + j)) return p.slice(0, 3) + j;
            }
        },
        {
            key: "rootSubjects",
            value: function rootSubjects(sts) {
                var incoming = {};
                var subjects = {};
                var allBnodes = {};
                /* This scan is to find out which nodes will have to be the roots of trees
      ** in the serialized form. This will be any symbols, and any bnodes
      ** which hve more or less than one incoming arc, and any bnodes which have
      ** one incoming arc but it is an uninterrupted loop of such nodes back to itself.
      ** This should be kept linear time with repect to the number of statements.
      ** Note it does not use any indexing of the store.
      */ for(var i = 0; i < sts.length; i++){
                    var st = sts[i];
                    var checkMentions = function checkMentions(x) {
                        if (!incoming.hasOwnProperty(x)) incoming[x] = [];
                        incoming[x].push(st.subject); // List of things which will cause this to be printed
                    };
                    var st2 = [
                        st.subject,
                        st.predicate,
                        st.object
                    ];
                    st2.map(function(y) {
                        if (y.termType === "BlankNode") allBnodes[y.toNT()] = true;
                        else if (y.termType === "Collection") y.elements.forEach(function(z) {
                            checkMentions(z); // bnodes in collections important
                        });
                    });
                    checkMentions(sts[i].object);
                    var ss = subjects[this.toStr(st.subject)]; // Statements with this as subject
                    if (!ss) ss = [];
                    ss.push(st);
                    subjects[this.toStr(st.subject)] = ss; // Make hash. @@ too slow for formula?
                }
                var roots = [];
                for(var xNT in subjects){
                    if (!subjects.hasOwnProperty(xNT)) continue;
                    var y = this.fromStr(xNT);
                    if (y.termType !== "BlankNode" || !incoming[y] || incoming[y].length !== 1) {
                        roots.push(y);
                        continue;
                    }
                }
                this.incoming = incoming; // Keep for serializing @@ Bug for nested formulas
                // Now do the scan using existing roots
                var rootsHash = {};
                for(var k = 0; k < roots.length; k++)rootsHash[roots[k].toNT()] = true;
                return {
                    "roots": roots,
                    "subjects": subjects,
                    "rootsHash": rootsHash,
                    "incoming": incoming
                };
            }
        },
        {
            key: "toN3",
            value: function toN3(f) {
                return this.statementsToN3(f.statements);
            }
        },
        {
            key: "explicitURI",
            value: function explicitURI(uri) {
                if (this.flags.indexOf("r") < 0 && this.base) uri = $4Q80K.refTo(this.base, uri);
                else if (this.flags.indexOf("u") >= 0) // Unicode encoding NTriples style
                uri = $f832e5387e149401$var$backslashUify(uri);
                else uri = $f832e5387e149401$var$hexify(decodeURI(uri));
                return "<" + uri + ">";
            }
        },
        {
            key: "statementsToNTriples",
            value: function statementsToNTriples(sts) {
                var sorted = sts.slice();
                sorted.sort();
                var str = "";
                var rdfns = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
                var self = this;
                var kb = this.store;
                var factory = this.rdfFactory;
                var termToNT = function termToNT(x) {
                    if (x.termType !== "Collection") return self.atomicTermToN3(x);
                    var list = x.elements;
                    var rest = kb.sym(rdfns + "nill");
                    for(var i = list.length - 1; i >= 0; i--){
                        var bnode = factory.blankNode();
                        str += termToNT(bnode) + " " + termToNT(kb.sym(rdfns + "first")) + " " + termToNT(list[i]) + ".\n";
                        str += termToNT(bnode) + " " + termToNT(kb.sym(rdfns + "rest")) + " " + termToNT(rest) + ".\n";
                        rest = bnode;
                    }
                    return self.atomicTermToN3(rest);
                };
                for(var i = 0; i < sorted.length; i++){
                    var st = sorted[i];
                    var s = "";
                    s += termToNT(st.subject) + " ";
                    s += termToNT(st.predicate) + " ";
                    s += termToNT(st.object) + " ";
                    if (this.flags.indexOf("q") >= 0) // Do quads not nrtiples
                    s += termToNT(st.why) + " ";
                    s += ".\n";
                    str += s;
                }
                return str;
            }
        },
        {
            key: "statementsToN3",
            value: function statementsToN3(sts) {
                var indent = 4;
                var width = 80;
                var kb = this.store;
                // A URI Map alows us to put the type statemnts at the top.
                var uriMap = {
                    "http://www.w3.org/1999/02/22-rdf-syntax-ns#type": "aaa:00"
                };
                var SPO = function SPO(x, y) {
                    // Do limited canonicalization of bnodes
                    return $23fob.heavyCompareSPO(x, y, kb, uriMap);
                };
                sts.sort(SPO);
                if (this.base && !this.defaultNamespace) this.defaultNamespace = this.base + "#";
                var predMap = {};
                if (this.flags.indexOf("s") < 0) predMap["http://www.w3.org/2002/07/owl#sameAs"] = "=";
                if (this.flags.indexOf("t") < 0) predMap["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"] = "a";
                if (this.flags.indexOf("i") < 0) predMap["http://www.w3.org/2000/10/swap/log#implies"] = "=>";
                // //////////////////////// Arrange the bits of text
                var spaces = function spaces(n) {
                    var s = "";
                    for(var i = 0; i < n; i++)s += " ";
                    return s;
                };
                var treeToLine = function treeToLine(tree) {
                    var str = "";
                    for(var i = 0; i < tree.length; i++){
                        var branch = tree[i];
                        var s2 = typeof branch === "string" ? branch : treeToLine(branch);
                        // Note the space before the dot in case statement ends with 123 or colon. which is in fact allowed but be conservative.
                        if (i !== 0) {
                            var ch = str.slice(-1) || " ";
                            if (s2 === "," || s2 === ";") ;
                            else if (s2 === "." && !"0123456789.:".includes(ch)) ;
                            else str += " "; // separate from previous token
                        }
                        str += s2;
                    }
                    return str;
                };
                // Convert a nested tree of lists and strings to a string
                var treeToString = function treeToString(tree, level) {
                    var str = "";
                    var lastLength = 100000;
                    if (level === undefined) level = -1;
                    for(var i = 0; i < tree.length; i++){
                        var branch = tree[i];
                        if (typeof branch !== "string") {
                            var substr = treeToString(branch, level + 1);
                            if (substr.length < 10 * (width - indent * level) && substr.indexOf('"""') < 0) {
                                // Don't mess up multiline strings
                                var line = treeToLine(branch);
                                if (line.length < width - indent * level) {
                                    branch = line; //   Note! treat as string below
                                    substr = "";
                                }
                            }
                            if (substr) lastLength = 10000;
                            str += substr;
                        }
                        if (typeof branch === "string") {
                            if (branch.length === 1 && str.slice(-1) === "\n") {
                                if (",.;".indexOf(branch) >= 0) {
                                    str = str.slice(0, -1);
                                    // be conservative and ensure a whitespace between some chars and a final dot, as in treeToLine above
                                    if (branch == "." && "0123456789.:".includes(str.charAt(str.length - 1))) {
                                        str += " ";
                                        lastLength += 1;
                                    }
                                    str += branch + "\n"; //  slip punct'n on end
                                    lastLength += 1;
                                    continue;
                                }
                            }
                            if (lastLength < indent * level + 4 || // if new line not necessary
                            lastLength + branch.length + 1 < width && ";.".indexOf(str[str.length - 2]) < 0) {
                                // or the string fits on last line
                                str = str.slice(0, -1) + " " + branch + "\n"; // then continue on this line
                                lastLength += branch.length + 1;
                            } else {
                                var _line = spaces(indent * level) + branch;
                                str += _line + "\n";
                                lastLength = _line.length;
                                if (level < 0) {
                                    str += "\n"; // extra blank line
                                    lastLength = 100000; // don't touch
                                }
                            }
                        }
                    }
                    return str;
                };
                // //////////////////////////////////////////// Structure for N3
                // Convert a set of statements into a nested tree of lists and strings
                function statementListToTreeMethod(statements) {
                    var stats = this.rootSubjects(statements);
                    var roots = stats.roots;
                    var results = [];
                    for(var i = 0; i < roots.length; i++){
                        var root = roots[i];
                        results.push(subjectTree(root, stats));
                    }
                    return results;
                }
                var statementListToTree = statementListToTreeMethod.bind(this);
                // The tree for a subject
                function subjectTree(subject, stats) {
                    if (subject.termType === "BlankNode" && !stats.incoming[subject]) return objectTree(subject, stats, true).concat([
                        "."
                    ]); // Anonymous bnode subject
                    return [
                        termToN3(subject, stats)
                    ].concat([
                        propertyTree(subject, stats)
                    ]).concat([
                        "."
                    ]);
                }
                // The property tree for a single subject or anonymous node
                function propertyTreeMethod(subject, stats) {
                    var results = [];
                    var lastPred = null;
                    var sts = stats.subjects[this.toStr(subject)] || []; // relevant statements
                    if (typeof sts === "undefined") throw new Error("Cant find statements for " + subject);
                    var objects = [];
                    for(var i = 0; i < sts.length; i++){
                        var st = sts[i];
                        if (st.predicate.uri === lastPred) objects.push(",");
                        else {
                            if (lastPred) {
                                results = results.concat([
                                    objects
                                ]).concat([
                                    ";"
                                ]);
                                objects = [];
                            }
                            results.push(predMap[st.predicate.uri] ? predMap[st.predicate.uri] : termToN3(st.predicate, stats));
                        }
                        lastPred = st.predicate.uri;
                        objects.push(objectTree(st.object, stats));
                    }
                    results = results.concat([
                        objects
                    ]);
                    return results;
                }
                var propertyTree = propertyTreeMethod.bind(this);
                function objectTreeMethod(obj, stats, force) {
                    if (obj.termType === "BlankNode" && (force || stats.rootsHash[obj.toNT()] === undefined)) {
                        // if not a root
                        if (stats.subjects[this.toStr(obj)]) return [
                            "[",
                            propertyTree(obj, stats),
                            "]"
                        ];
                        else return "[]";
                    }
                    return termToN3(obj, stats);
                }
                var objectTree = objectTreeMethod.bind(this);
                function termToN3Method(expr, stats) {
                    //
                    var i, res;
                    switch(expr.termType){
                        case "Graph":
                            res = [
                                "{"
                            ];
                            res = res.concat(statementListToTree(expr.statements));
                            return res.concat([
                                "}"
                            ]);
                        case "Collection":
                            res = [
                                "("
                            ];
                            for(i = 0; i < expr.elements.length; i++)res.push([
                                objectTree(expr.elements[i], stats)
                            ]);
                            res.push(")");
                            return res;
                        default:
                            return this.atomicTermToN3(expr);
                    }
                }
                Serializer.prototype.termToN3 = termToN3;
                var termToN3 = termToN3Method.bind(this);
                function prefixDirectivesMethod() {
                    var str = "";
                    if (this.flags.indexOf("d") < 0 && this.defaultNamespace) str += "@prefix : " + this.explicitURI(this.defaultNamespace) + ".\n";
                    for(var ns in this.prefixes){
                        if (!this.prefixes.hasOwnProperty(ns)) continue;
                        if (!this.namespacesUsed[ns]) continue;
                        str += "@prefix " + this.prefixes[ns] + ": " + this.explicitURI(ns) + ".\n";
                    }
                    return str + "\n";
                }
                var prefixDirectives = prefixDirectivesMethod.bind(this);
                // Body of statementsToN3:
                var tree = statementListToTree(sts);
                return prefixDirectives() + treeToString(tree);
            }
        },
        {
            key: "atomicTermToN3",
            value: function atomicTermToN3(expr, stats) {
                switch(expr.termType){
                    case "BlankNode":
                    case "Variable":
                        return expr.toNT();
                    case "Literal":
                        var val = expr.value;
                        if (typeof val !== "string") throw new TypeError("Value of RDF literal node must be a string");
                        // var val = expr.value.toString() // should be a string already
                        if (expr.datatype && this.flags.indexOf("x") < 0) // Supress native numbers
                        switch(expr.datatype.uri){
                            case "http://www.w3.org/2001/XMLSchema#integer":
                                return val;
                            case "http://www.w3.org/2001/XMLSchema#decimal":
                                // In Turtle, must have dot
                                if (val.indexOf(".") < 0) val += ".0";
                                return val;
                            case "http://www.w3.org/2001/XMLSchema#double":
                                // Must force use of 'e'
                                var eNotation = val.toLowerCase().indexOf("e") > 0;
                                if (val.indexOf(".") < 0 && !eNotation) val += ".0";
                                if (!eNotation) val += "e0";
                                return val;
                            case "http://www.w3.org/2001/XMLSchema#boolean":
                                return expr.value === "1" ? "true" : "false";
                        }
                        var str = this.stringToN3(expr.value);
                        if (expr.language) str += "@" + expr.language;
                        else if (!expr.datatype.equals(this.xsd.string)) str += "^^" + this.atomicTermToN3(expr.datatype, stats);
                        return str;
                    case "NamedNode":
                        return this.symbolToN3(expr);
                    case "DefaultGraph":
                        return "";
                    default:
                        throw new Error("Internal: atomicTermToN3 cannot handle " + expr + " of termType: " + expr.termType);
                }
            }
        },
        {
            key: "stringToN3",
            value: function stringToN3(str, flags) {
                if (!flags) flags = "e";
                var res = "";
                var i, j, k;
                var delim;
                var forbidden;
                if (str.length > 20 && // Long enough to make sense
                str.slice(-1) !== '"' && // corner case'
                flags.indexOf("n") < 0 && // Force single line
                (str.indexOf("\n") > 0 || str.indexOf('"') > 0)) {
                    delim = '"""';
                    forbidden = this.forbidden3;
                } else {
                    delim = '"';
                    forbidden = this.forbidden1;
                }
                for(i = 0; i < str.length;){
                    forbidden.lastIndex = 0;
                    var m = forbidden.exec(str.slice(i));
                    if (m == null) break;
                    j = i + forbidden.lastIndex - 1;
                    res += str.slice(i, j);
                    var ch = str[j];
                    if (ch === '"' && delim === '"""' && str.slice(j, j + 3) !== '"""') res += ch;
                    else {
                        k = '\b\f\r	\v\n\\"'.indexOf(ch); // No escaping of bell (7)?
                        if (k >= 0) res += "\\" + 'bfrtvn\\"'[k];
                        else if (flags.indexOf("e") >= 0) // Unicode escaping in strings not unix style
                        res += "\\u" + ("000" + ch.charCodeAt(0).toString(16).toLowerCase()).slice(-4);
                        else // no 'e' flag
                        res += ch;
                    }
                    i = j + 1;
                }
                return delim + res + str.slice(i) + delim;
            }
        },
        {
            key: "symbolToN3",
            value: function symbolToN3(x) {
                // c.f. symbolString() in notation3.py
                var uri = x.uri;
                var j = uri.indexOf("#");
                if (j < 0 && this.flags.indexOf("/") < 0) j = uri.lastIndexOf("/");
                if (j >= 0 && this.flags.indexOf("p") < 0 && // Can split at namespace but only if http[s]: URI or file: or ws[s] (why not others?)
                (uri.indexOf("http") === 0 || uri.indexOf("ws") === 0 || uri.indexOf("file") === 0)) {
                    var canSplit = true;
                    for(var k = j + 1; k < uri.length; k++)if (this._notNameChars.indexOf(uri[k]) >= 0) {
                        canSplit = false;
                        break;
                    }
                    /*
              if (uri.slice(0, j + 1) === this.base + '#') { // base-relative
                if (canSplit) {
                  return ':' + uri.slice(j + 1) // assume deafult ns is local
                } else {
                  return '<#' + uri.slice(j + 1) + '>'
                }
              }
        */ if (canSplit) {
                        var localid = uri.slice(j + 1);
                        var namesp = uri.slice(0, j + 1);
                        if (this.defaultNamespace && this.defaultNamespace === namesp && this.flags.indexOf("d") < 0) {
                            // d -> suppress default
                            if (this.flags.indexOf("k") >= 0 && this.keyords.indexOf(localid) < 0) return localid;
                            return ":" + localid;
                        }
                        // this.checkIntegrity() //  @@@ Remove when not testing
                        var prefix = this.prefixes[namesp];
                        if (!prefix) prefix = this.makeUpPrefix(namesp);
                        if (prefix) {
                            this.namespacesUsed[namesp] = true;
                            return prefix + ":" + localid;
                        }
                    // Fall though if can't do qname
                    }
                }
                return this.explicitURI(uri);
            }
        },
        {
            key: "writeStore",
            value: function writeStore(write) {
                var kb = this.store;
                var fetcher = kb.fetcher;
                var session = fetcher && fetcher.appNode;
                // The core data
                var sources = this.store.index[3];
                for(var s in sources){
                    // -> assume we can use -> as short for log:semantics
                    var source = kb.fromNT(s);
                    if (session && source.equals(session)) continue;
                    write("\n" + this.atomicTermToN3(source) + " " + this.atomicTermToN3(kb.sym("http://www.w3.org/2000/10/swap/log#semantics")) + " { " + this.statementsToN3(kb.statementsMatching(undefined, undefined, undefined, source)) + " }.\n");
                }
                // The metadata from HTTP interactions:
                kb.statementsMatching(undefined, kb.sym("http://www.w3.org/2007/ont/link#requestedURI")).map(function(st) {
                    write("\n<" + st.object.value + "> log:metadata {\n");
                    var sts = kb.statementsMatching(undefined, undefined, undefined, st.subject);
                    write(this.statementsToN3(this.statementsToN3(sts)));
                    write("}.\n");
                });
                // Inferences we have made ourselves not attributable to anyone else
                var metaSources = [];
                if (session) metaSources.push(session);
                var metadata = [];
                metaSources.map(function(source) {
                    metadata = metadata.concat(kb.statementsMatching(undefined, undefined, undefined, source));
                });
                write(this.statementsToN3(metadata));
            }
        },
        {
            key: "statementsToXML",
            value: function statementsToXML(sts) {
                var indent = 4;
                var width = 80;
                var namespaceCounts = []; // which have been used
                namespaceCounts["http://www.w3.org/1999/02/22-rdf-syntax-ns#"] = true;
                var liPrefix = "http://www.w3.org/1999/02/22-rdf-syntax-ns#_"; // prefix for ordered list items
                // //////////////////////// Arrange the bits of XML text
                var spaces = function spaces(n) {
                    var s = "";
                    for(var i = 0; i < n; i++)s += " ";
                    return s;
                };
                var XMLtreeToLine = function XMLtreeToLine(tree) {
                    var str = "";
                    for(var i = 0; i < tree.length; i++){
                        var branch = tree[i];
                        var s2 = typeof branch === "string" ? branch : XMLtreeToLine(branch);
                        str += s2;
                    }
                    return str;
                };
                // Convert a nested tree of lists and strings to a string
                var XMLtreeToString = function XMLtreeToString(tree, level) {
                    var str = "";
                    var line;
                    var lastLength = 100000;
                    if (!level) level = 0;
                    for(var i = 0; i < tree.length; i++){
                        var branch = tree[i];
                        if (typeof branch !== "string") {
                            var substr = XMLtreeToString(branch, level + 1);
                            if (substr.length < 10 * (width - indent * level) && substr.indexOf('"""') < 0) {
                                // Don't mess up multiline strings
                                line = XMLtreeToLine(branch);
                                if (line.length < width - indent * level) {
                                    branch = "   " + line; //   @@ Hack: treat as string below
                                    substr = "";
                                }
                            }
                            if (substr) lastLength = 10000;
                            str += substr;
                        }
                        if (typeof branch === "string") {
                            if (lastLength < indent * level + 4) {
                                // continue
                                str = str.slice(0, -1) + " " + branch + "\n";
                                lastLength += branch.length + 1;
                            } else {
                                line = spaces(indent * level) + branch;
                                str += line + "\n";
                                lastLength = line.length;
                            }
                        } else ;
                    }
                    return str;
                };
                function statementListToXMLTreeMethod(statements) {
                    this.suggestPrefix("rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#");
                    var stats = this.rootSubjects(statements);
                    var roots = stats.roots;
                    var results = [];
                    for(var i = 0; i < roots.length; i++){
                        var root = roots[i];
                        results.push(subjectXMLTree(root, stats));
                    }
                    return results;
                }
                var statementListToXMLTree = statementListToXMLTreeMethod.bind(this);
                function escapeForXML(str) {
                    if (typeof str === "undefined") return "@@@undefined@@@@";
                    return str.replace(/[&<"]/g, function(m) {
                        switch(m[0]){
                            case "&":
                                return "&amp;";
                            case "<":
                                return "&lt;";
                            case '"':
                                return "&quot;";
                        }
                    });
                }
                function relURIMethod(term) {
                    return escapeForXML(this.base ? $4Q80K.refTo(this.base, term.uri) : term.uri);
                }
                var relURI = relURIMethod.bind(this);
                // The tree for a subject
                function subjectXMLTreeMethod(subject, stats) {
                    var results = [];
                    var type, t, st, pred;
                    var sts = stats.subjects[this.toStr(subject)]; // relevant statements
                    if (typeof sts === "undefined") // empty bnode
                    return propertyXMLTree(subject, stats);
                    // Sort only on the predicate, leave the order at object
                    // level undisturbed.  This leaves multilingual content in
                    // the order of entry (for partner literals), which helps
                    // readability.
                    //
                    // For the predicate sort, we attempt to split the uri
                    // as a hint to the sequence
                    sts.sort(function(a, b) {
                        var ap = a.predicate.uri;
                        var bp = b.predicate.uri;
                        if (ap.substring(0, liPrefix.length) === liPrefix || bp.substring(0, liPrefix.length) === liPrefix) // we're only interested in sorting list items
                        return ap.localeCompare(bp);
                        var as = ap.substring(liPrefix.length);
                        var bs = bp.substring(liPrefix.length);
                        var an = parseInt(as, 10);
                        var bn = parseInt(bs, 10);
                        if (isNaN(an) || isNaN(bn) || an !== as || bn !== bs) // we only care about integers
                        return ap.localeCompare(bp);
                        return an - bn;
                    });
                    for(var i = 0; i < sts.length; i++){
                        st = sts[i];
                        // look for a type
                        if (st.predicate.uri === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" && !type && st.object.termType === "NamedNode") {
                            type = st.object;
                            continue; // don't include it as a child element
                        }
                        // see whether predicate can be replaced with "li"
                        pred = st.predicate;
                        if (pred.uri.substr(0, liPrefix.length) === liPrefix) {
                            var number = pred.uri.substr(liPrefix.length);
                            // make sure these are actually numeric list items
                            var intNumber = parseInt(number, 10);
                            if (number === intNumber.toString()) // was numeric; don't need to worry about ordering since we've already
                            // sorted the statements
                            pred = this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#li");
                        }
                        t = qname(pred);
                        switch(st.object.termType){
                            case "BlankNode":
                                if (stats.incoming[st.object].length === 1) // there should always be something in the incoming array for a bnode
                                results = results.concat([
                                    "<" + t + ' rdf:parseType="Resource">',
                                    subjectXMLTree(st.object, stats),
                                    "</" + t + ">"
                                ]);
                                else results = results.concat([
                                    "<" + t + ' rdf:nodeID="' + st.object.toNT().slice(2) + '"/>'
                                ]);
                                break;
                            case "NamedNode":
                                results = results.concat([
                                    "<" + t + ' rdf:resource="' + relURI(st.object) + '"/>'
                                ]);
                                break;
                            case "Literal":
                                results = results.concat([
                                    "<" + t + (st.object.datatype.equals(this.xsd.string) ? "" : ' rdf:datatype="' + escapeForXML(st.object.datatype.uri) + '"') + (st.object.language ? ' xml:lang="' + st.object.language + '"' : "") + ">" + escapeForXML(st.object.value) + "</" + t + ">"
                                ]);
                                break;
                            case "Collection":
                                results = results.concat([
                                    "<" + t + ' rdf:parseType="Collection">',
                                    collectionXMLTree(st.object, stats),
                                    "</" + t + ">"
                                ]);
                                break;
                            default:
                                throw new Error("Can't serialize object of type " + st.object.termType + " into XML");
                        } // switch
                    }
                    var tag = type ? qname(type) : "rdf:Description";
                    var attrs = "";
                    if (subject.termType === "BlankNode") {
                        if (!stats.incoming[subject] || stats.incoming[subject].length !== 1) // not an anonymous bnode
                        attrs = ' rdf:nodeID="' + subject.toNT().slice(2) + '"';
                    } else attrs = ' rdf:about="' + relURI(subject) + '"';
                    return [
                        "<" + tag + attrs + ">"
                    ].concat([
                        results
                    ]).concat([
                        "</" + tag + ">"
                    ]);
                }
                var subjectXMLTree = subjectXMLTreeMethod.bind(this);
                function collectionXMLTree(subject, stats) {
                    var res = [];
                    for(var i = 0; i < subject.elements.length; i++)res.push(subjectXMLTree(subject.elements[i], stats));
                    return res;
                }
                // The property tree for a single subject or anonymos node
                function propertyXMLTreeMethod(subject, stats) {
                    var results = [];
                    var sts = stats.subjects[this.toStr(subject)]; // relevant statements
                    if (!sts) return results; // No relevant statements
                    sts.sort();
                    for(var i = 0; i < sts.length; i++){
                        var st = sts[i];
                        switch(st.object.termType){
                            case "BlankNode":
                                if (stats.rootsHash[st.object.toNT()]) // This bnode has been done as a root -- no content here @@ what bout first time
                                results = results.concat([
                                    "<" + qname(st.predicate) + ' rdf:nodeID="' + st.object.toNT().slice(2) + '">',
                                    "</" + qname(st.predicate) + ">"
                                ]);
                                else results = results.concat([
                                    "<" + qname(st.predicate) + ' rdf:parseType="Resource">',
                                    propertyXMLTree(st.object, stats),
                                    "</" + qname(st.predicate) + ">"
                                ]);
                                break;
                            case "NamedNode":
                                results = results.concat([
                                    "<" + qname(st.predicate) + ' rdf:resource="' + relURI(st.object) + '"/>'
                                ]);
                                break;
                            case "Literal":
                                results = results.concat([
                                    "<" + qname(st.predicate) + (st.object.datatype.equals(this.xsd.string) ? "" : ' rdf:datatype="' + escapeForXML(st.object.datatype.value) + '"') + (st.object.language ? ' xml:lang="' + st.object.language + '"' : "") + ">" + escapeForXML(st.object.value) + "</" + qname(st.predicate) + ">"
                                ]);
                                break;
                            case "Collection":
                                results = results.concat([
                                    "<" + qname(st.predicate) + ' rdf:parseType="Collection">',
                                    collectionXMLTree(st.object, stats),
                                    "</" + qname(st.predicate) + ">"
                                ]);
                                break;
                            default:
                                throw new Error("Can't serialize object of type " + st.object.termType + " into XML");
                        } // switch
                    }
                    return results;
                }
                var propertyXMLTree = propertyXMLTreeMethod.bind(this);
                function qnameMethod(term) {
                    var uri = term.uri;
                    var j = uri.indexOf("#");
                    if (j < 0 && this.flags.indexOf("/") < 0) j = uri.lastIndexOf("/");
                    if (j < 0) throw new Error("Cannot make qname out of <" + uri + ">");
                    for(var k = j + 1; k < uri.length; k++){
                        if (this._notNameChars.indexOf(uri[k]) >= 0) throw new Error('Invalid character "' + uri[k] + '" cannot be in XML qname for URI: ' + uri);
                    }
                    var localid = uri.slice(j + 1);
                    var namesp = uri.slice(0, j + 1);
                    if (this.defaultNamespace && this.defaultNamespace === namesp && this.flags.indexOf("d") < 0) // d -> suppress default
                    return localid;
                    var prefix = this.prefixes[namesp];
                    if (!prefix) prefix = this.makeUpPrefix(namesp);
                    namespaceCounts[namesp] = true;
                    return prefix + ":" + localid;
                }
                var qname = qnameMethod.bind(this);
                // Body of toXML:
                var tree = statementListToXMLTree(sts);
                var str = "<rdf:RDF";
                if (this.defaultNamespace) str += ' xmlns="' + escapeForXML(this.defaultNamespace) + '"';
                for(var ns in namespaceCounts){
                    if (!namespaceCounts.hasOwnProperty(ns)) continue;
                    // Rel uris in xml ns is not strictly allowed in the XMLNS spec but needed in practice often
                    var ns2 = this.base && this.flags.includes("z") ? $4Q80K.refTo(this.base, ns) : ns;
                    str += "\n xmlns:" + this.prefixes[ns] + '="' + escapeForXML(ns2) + '"';
                }
                str += ">";
                var tree2 = [
                    str,
                    tree,
                    "</rdf:RDF>"
                ]; // @@ namespace declrations
                return XMLtreeToString(tree2, -1);
            } // End @@ body
        },
        {
            key: "statementsToJsonld",
            value: function statementsToJsonld(sts) {
                // ttl2jsonld creates context keys for all ttl prefix
                // context keys must be absolute IRI ttl2jsonld@0.0.8
                /* function findId (itemObj) {
        if (itemObj['@id']) {
          const item = itemObj['@id'].split(':')
          if (keys[item[0]]) itemObj['@id'] = jsonldObj['@context'][item[0]] + item[1]
        }
        const itemValues = Object.values(itemObj)
        for (const i in itemValues) {
          if (typeof itemValues[i] !== 'string') { // @list contains array
            findId(itemValues[i])
          }
        }
      } */ var turtleDoc = this.statementsToN3(sts);
                var jsonldObj = $4637181ac5e22c58$exports.parse(turtleDoc);
                return JSON.stringify(jsonldObj, null, 2);
            }
        }
    ]);
    return Serializer;
}();
// String escaping utilities
function $f832e5387e149401$var$hexify(str) {
    // also used in parser
    return encodeURI(str);
}
function $f832e5387e149401$var$backslashUify(str) {
    var res = "";
    var k;
    for(var i = 0; i < str.length; i++){
        k = str.charCodeAt(i);
        if (k > 65535) res += "\\U" + ("00000000" + k.toString(16)).slice(-8); // convert to upper?
        else if (k > 126) res += "\\u" + ("0000" + k.toString(16)).slice(-4);
        else res += str[i];
    }
    return res;
}



var $8RKL2 = parcelRequire("8RKL2");
function $957a454a8ab6ebde$export$2e2bcd8739ae039(/** The graph or nodes that should be serialized */ target, /** The store */ kb, base, /**
 * The mime type.
 * Defaults to Turtle.
 */ contentType, callback, options) {
    base = base || (target === null || target === void 0 ? void 0 : target.value);
    var opts = options || {};
    contentType = contentType || (0, $8RKL2.TurtleContentType); // text/n3 if complex?
    var documentString = undefined;
    try {
        var sz = (0, $f832e5387e149401$export$2e2bcd8739ae039)(kb);
        if (opts.flags) sz.setFlags(opts.flags);
        var newSts = kb.statementsMatching(undefined, undefined, undefined, target);
        // If an IndexedFormula, use the namespaces from the given graph as suggestions
        if ("namespaces" in kb) sz.suggestNamespaces(kb.namespaces);
        // use the provided options.namespaces are mandatory prefixes
        if (opts.namespaces) sz.setNamespaces(opts.namespaces);
        sz.setBase(base);
        switch(contentType){
            case 0, $8RKL2.RDFXMLContentType:
                documentString = sz.statementsToXML(newSts);
                return executeCallback(null, documentString);
            case 0, $8RKL2.N3ContentType:
            case 0, $8RKL2.N3LegacyContentType:
                documentString = sz.statementsToN3(newSts);
                return executeCallback(null, documentString);
            case 0, $8RKL2.TurtleContentType:
            case 0, $8RKL2.TurtleLegacyContentType:
                sz.setFlags("si"); // Suppress = for sameAs and => for implies
                documentString = sz.statementsToN3(newSts);
                return executeCallback(null, documentString);
            case 0, $8RKL2.NTriplesContentType:
                sz.setFlags("deinprstux"); // Suppress nice parts of N3 to make ntriples
                documentString = sz.statementsToNTriples(newSts);
                return executeCallback(null, documentString);
            case 0, $8RKL2.JSONLDContentType:
                sz.setFlags("si dr"); // turtle + dr (means no default, no relative prefix)
                documentString = sz.statementsToJsonld(newSts); // convert via turtle
                return executeCallback(null, documentString);
            case 0, $8RKL2.NQuadsContentType:
            case 0, $8RKL2.NQuadsAltContentType:
                // @@@ just outpout the quads? Does not work for collections
                sz.setFlags("deinprstux q"); // Suppress nice parts of N3 to make ntriples
                documentString = sz.statementsToNTriples(newSts); // q in flag means actually quads
                return executeCallback(null, documentString);
            default:
                throw new Error("Serialize: Content-type " + contentType + " not supported for data write.");
        }
    } catch (err) {
        if (callback) // @ts-ignore
        return callback(err, undefined);
        throw err; // Don't hide problems from caller in sync mode
    }
    function executeCallback(err, result) {
        if (callback) {
            callback(err, result);
            return;
        } else return result;
    }
}



var $8RKL2 = parcelRequire("8RKL2");

var $gCJkd = parcelRequire("gCJkd");


var $kAE07 = parcelRequire("kAE07");

var $4Q80K = parcelRequire("4Q80K");

var $23fob = parcelRequire("23fob");
function $c584fbcedb5512e3$export$cc2475d73d6ab0ad(kb, p, requestedBy) {
    var sf = null;
    if (typeof kb.fetcher !== "undefined") sf = kb.fetcher;
    else return;
    if (p.termType !== "NamedNode") return;
    var docuri = (0, $4Q80K.docpart)(p.uri);
    var fixuri;
    if (p.uri.indexOf("#") < 0) {
        // No hash
        // @@ major hack for dbpedia Categories, which spread indefinitely
        if ((0, $23fob.string_startswith)(p.uri, "http://dbpedia.org/resource/Category:")) return;
        /*
      if (string_startswith(p.uri, 'http://xmlns.com/foaf/0.1/')) {
      fixuri = "http://dig.csail.mit.edu/2005/ajar/ajaw/test/foaf"
      // should give HTTP 303 to ontology -- now is :-)
      } else
    */ if ((0, $23fob.string_startswith)(p.uri, "http://purl.org/dc/elements/1.1/") || (0, $23fob.string_startswith)(p.uri, "http://purl.org/dc/terms/")) fixuri = "http://dublincore.org/2005/06/13/dcq";
        else if ((0, $23fob.string_startswith)(p.uri, "http://xmlns.com/wot/0.1/")) fixuri = "http://xmlns.com/wot/0.1/index.rdf";
        else if ((0, $23fob.string_startswith)(p.uri, "http://web.resource.org/cc/")) //            log.warn("creative commons links to html instead of rdf. doesn't seem to content-negotiate.")
        fixuri = "http://web.resource.org/cc/schema.rdf";
    }
    if (fixuri) docuri = fixuri;
    if (sf && sf.getState(docuri) !== "unrequested") return;
    if (fixuri) // only give warning once: else happens too often
    (0, $kAE07.default).warn("Assuming server still broken, faking redirect of <" + p.uri + "> to <" + docuri + ">");
    return sf.fetch(docuri, {
        referringTerm: requestedBy
    });
}
var $c584fbcedb5512e3$export$d04247d66bc672f = [
    "blankNode",
    "defaultGraph",
    "literal",
    "namedNode",
    "quad",
    "variable",
    "supports"
];
var $c584fbcedb5512e3$var$rdf = {
    first: "http://www.w3.org/1999/02/22-rdf-syntax-ns#first",
    rest: "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest",
    nil: "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
};
function $c584fbcedb5512e3$export$b0f02731210f3037(rdfFactory, subject, data) {
    var statements = [];
    data.reduce(function(id, _listObj, i, listData) {
        statements.push(rdfFactory.quad(id, rdfFactory.namedNode($c584fbcedb5512e3$var$rdf.first), listData[i]));
        var nextNode;
        if (i < listData.length - 1) {
            nextNode = rdfFactory.blankNode();
            statements.push(rdfFactory.quad(id, rdfFactory.namedNode($c584fbcedb5512e3$var$rdf.rest), nextNode));
        } else statements.push(rdfFactory.quad(id, rdfFactory.namedNode($c584fbcedb5512e3$var$rdf.rest), rdfFactory.namedNode($c584fbcedb5512e3$var$rdf.nil)));
        return nextNode;
    }, subject);
    return statements;
}
function $c584fbcedb5512e3$export$37abcb37ee31055e(arr, item) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var length = arr.length;
    if (i < 0) i = length + i;
    for(; i < length; i++){
        if (arr[i] === item) return i;
    }
    return -1;
}



var $99pVg = parcelRequire("99pVg");
function $31157af6e1e82257$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $31157af6e1e82257$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $31157af6e1e82257$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $31157af6e1e82257$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $31157af6e1e82257$var$_arrayLikeToArray(o, minLen);
}
function $31157af6e1e82257$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $31157af6e1e82257$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $31157af6e1e82257$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $31157af6e1e82257$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * A formula, or store of RDF statements
 */ var $31157af6e1e82257$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Node) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Formula, _Node);
    var _super = $31157af6e1e82257$var$_createSuper(Formula);
    /**
   * Initializes this formula
   * @constructor
   * @param statements - Initial array of statements
   * @param constraints - initial array of constraints
   * @param initBindings - initial bindings used in Query
   * @param optional - optional
   * @param opts
   * @param opts.rdfFactory - The rdf factory that should be used by the store
  */ function Formula() {
        var _this;
        var statements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var constraints = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var initBindings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        var optional = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
        var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Formula);
        _this = _super.call(this, "");
        _this.statements = statements;
        _this.constraints = constraints;
        _this.initBindings = initBindings;
        _this.optional = optional;
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "termType", (0, $8RKL2.GraphTermType));
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classOrder", (0, $aZYlt.default).Graph);
        /**
     * The accompanying fetcher instance.
     *
     * Is set by the fetcher when initialized.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "fetcher", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "isVar", 0);
        /**
     * A namespace for the specified namespace's URI
     * @param nsuri The URI for the namespace
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "ns", (0, $5b5611d501681341$export$2e2bcd8739ae039));
        /** The factory used to generate statements and terms */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "rdfFactory", void 0);
        _this.rdfFactory = opts && opts.rdfFactory || (0, $158d84b4866fe33e$export$2e2bcd8739ae039);
        // Enable default factory methods on this while preserving factory context.
        var _iterator = $31157af6e1e82257$var$_createForOfIteratorHelper((0, $c584fbcedb5512e3$export$d04247d66bc672f)), _step;
        try {
            var _loop = function _loop() {
                var factoryMethod = _step.value;
                _this[factoryMethod] = function() {
                    var _this$rdfFactory;
                    return (_this$rdfFactory = _this.rdfFactory)[factoryMethod].apply(_this$rdfFactory, arguments);
                };
            };
            for(_iterator.s(); !(_step = _iterator.n()).done;)_loop();
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return _this;
    }
    /** Add a statement from its parts
   * @param subject - the first part of the statement
   * @param predicate - the second part of the statement
   * @param object - the third part of the statement
   * @param graph - the last part of the statement
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Formula, [
        {
            key: "add",
            value: function add(subject, predicate, object, graph) {
                var _this2 = this;
                if (arguments.length === 1) subject.forEach(function(st) {
                    return _this2.add(st.subject, st.predicate, st.object, st.graph);
                });
                return this.statements.push(this.rdfFactory.quad(subject, predicate, object, graph));
            }
        },
        {
            key: "addStatement",
            value: function addStatement(statement) {
                return this.add(statement);
            }
        },
        {
            key: "bnode",
            value: function bnode(id) {
                return this.rdfFactory.blankNode(id);
            }
        },
        {
            key: "addAll",
            value: function addAll(statements) {
                var _this3 = this;
                statements.forEach(function(quad) {
                    _this3.add(quad.subject, quad.predicate, quad.object, quad.graph);
                });
            }
        },
        {
            key: "any",
            value: function any(s, p, o, g) {
                var st = this.anyStatementMatching(s, p, o, g);
                if (st == null) return null;
                else if (s == null) return st.subject;
                else if (p == null) return st.predicate;
                else if (o == null) return st.object;
                return null;
            }
        },
        {
            key: "anyValue",
            value: function anyValue(s, p, o, g) {
                var y = this.any(s, p, o, g);
                return y ? y.value : void 0;
            }
        },
        {
            key: "anyJS",
            value: function anyJS(s, p, o, g) {
                var y = this.any(s, p, o, g);
                return y ? (0, $cdU35.default).toJS(y) : void 0;
            }
        },
        {
            key: "anyStatementMatching",
            value: function anyStatementMatching(s, p, o, g) {
                var x = this.statementsMatching(s, p, o, g, true);
                if (!x || x.length === 0) return undefined;
                return x[0];
            }
        },
        {
            key: "id",
            value: function id(term) {
                return this.rdfFactory.id(term);
            }
        },
        {
            key: "statementsMatching",
            value: function statementsMatching(s, p, o, g, justOne) {
                var sts = this.statements.filter(function(st) {
                    return (!s || s.equals(st.subject)) && (!p || p.equals(st.predicate)) && (!o || o.equals(st.object)) && (!g || g.equals(st.graph));
                });
                if (justOne) return sts.length === 0 ? [] : [
                    sts[0]
                ];
                return sts;
            }
        },
        {
            key: "bottomTypeURIs",
            value: function bottomTypeURIs(types) {
                var bots;
                var bottom;
                var elt;
                var i;
                var len;
                var ref;
                var subs;
                var v;
                bots = [];
                for(var _k in types){
                    if (!types.hasOwnProperty(_k)) continue;
                    v = types[_k];
                    subs = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), this.rdfFactory.namedNode(_k));
                    bottom = true;
                    i = 0;
                    for(len = subs.length; i < len; i++){
                        elt = subs[i];
                        ref = elt.uri;
                        if (ref in types) {
                            // the subclass is one we know
                            bottom = false;
                            break;
                        }
                    }
                    if (bottom) bots[_k] = v;
                }
                return bots;
            }
        },
        {
            key: "collection",
            value: function collection() {
                return new (0, $619d91631affbf30$export$2e2bcd8739ae039)();
            }
        },
        {
            key: "each",
            value: function each(s, p, o, g) {
                var results = [];
                var sts = this.statementsMatching(s, p, o, g, false);
                if (s == null) for(var i = 0, len = sts.length; i < len; i++)results.push(sts[i].subject);
                else if (p == null) for(var l = 0, len1 = sts.length; l < len1; l++)results.push(sts[l].predicate);
                else if (o == null) for(var m = 0, len2 = sts.length; m < len2; m++)results.push(sts[m].object);
                else if (g == null) for(var _q = 0, len3 = sts.length; _q < len3; _q++)results.push(new (0, $99pVg.default)(sts[_q].graph.value));
                return results;
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                if (!other) return false;
                return this.hashString() === other.hashString();
            }
        },
        {
            key: "findMembersNT",
            value: function findMembersNT(thisClass) {
                var len2;
                var len4;
                var m;
                var members;
                var pred;
                var ref;
                var ref1;
                var ref2;
                var ref3;
                var ref4;
                var ref5;
                var seeds;
                var st;
                var u;
                seeds = {};
                seeds[thisClass.toNT()] = true;
                members = {};
                ref = this.transitiveClosure(seeds, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), true);
                for(var t in ref){
                    if (!ref.hasOwnProperty(t)) continue;
                    ref1 = this.statementsMatching(void 0, this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"), this.fromNT(t));
                    for(var i = 0, len = ref1.length; i < len; i++){
                        st = ref1[i];
                        members[st.subject.toNT()] = st;
                    }
                    ref2 = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#domain"), this.fromNT(t));
                    for(var l = 0, len1 = ref2.length; l < len1; l++){
                        pred = ref2[l];
                        ref3 = this.statementsMatching(void 0, pred);
                        for(m = 0, len2 = ref3.length; m < len2; m++){
                            st = ref3[m];
                            members[st.subject.toNT()] = st;
                        }
                    }
                    ref4 = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#range"), this.fromNT(t));
                    for(var _q2 = 0, len3 = ref4.length; _q2 < len3; _q2++){
                        pred = ref4[_q2];
                        ref5 = this.statementsMatching(void 0, pred);
                        for(u = 0, len4 = ref5.length; u < len4; u++){
                            st = ref5[u];
                            members[st.object.toNT()] = st;
                        }
                    }
                }
                return members;
            }
        },
        {
            key: "findMemberURIs",
            value: function findMemberURIs(subject) {
                return this.NTtoURI(this.findMembersNT(subject));
            }
        },
        {
            key: "findSubClassesNT",
            value: function findSubClassesNT(subject) {
                var types = {};
                types[subject.toNT()] = true;
                return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), true);
            }
        },
        {
            key: "findSuperClassesNT",
            value: function findSuperClassesNT(subject) {
                var types = {};
                types[subject.toNT()] = true;
                return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), false);
            }
        },
        {
            key: "findTypesNT",
            value: function findTypesNT(subject) {
                var domain;
                var range;
                var rdftype;
                var ref;
                var ref1;
                var ref2;
                var ref3;
                var st;
                var types;
                rdftype = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
                types = [];
                ref = this.statementsMatching(subject, void 0, void 0);
                for(var i = 0, len = ref.length; i < len; i++){
                    st = ref[i];
                    if (st.predicate.uri === rdftype) types[st.object.toNT()] = st;
                    else {
                        ref1 = this.each(st.predicate, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#domain"));
                        for(var l = 0, len1 = ref1.length; l < len1; l++){
                            range = ref1[l];
                            types[range.toNT()] = st;
                        }
                    }
                }
                ref2 = this.statementsMatching(void 0, void 0, subject);
                for(var m = 0, len2 = ref2.length; m < len2; m++){
                    st = ref2[m];
                    ref3 = this.each(st.predicate, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#range"));
                    for(var _q3 = 0, len3 = ref3.length; _q3 < len3; _q3++){
                        domain = ref3[_q3];
                        types[domain.toNT()] = st;
                    }
                }
                return this.transitiveClosure(types, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), false);
            }
        },
        {
            key: "findTypeURIs",
            value: function findTypeURIs(subject) {
                return this.NTtoURI(this.findTypesNT(subject));
            }
        },
        {
            key: "connectedStatements",
            value: function connectedStatements(subject, doc, excludePredicateURIs) {
                excludePredicateURIs = excludePredicateURIs || [];
                var todo = [
                    subject
                ];
                var done = {};
                var doneArcs = {};
                var result = [];
                var self = this;
                var follow = function follow(x) {
                    var queue = function queue(x) {
                        if (x.termType === "BlankNode" && !done[x.value]) {
                            done[x.value] = true;
                            todo.push(x);
                        }
                    };
                    var sts = self.statementsMatching(null, null, x, doc).concat(self.statementsMatching(x, null, null, doc));
                    sts = sts.filter(function(st) {
                        if (excludePredicateURIs[st.predicate.value]) return false;
                        var hash = st.toNT();
                        if (doneArcs[hash]) return false;
                        doneArcs[hash] = true;
                        return true;
                    });
                    sts.forEach(function(st) {
                        queue(st.subject);
                        queue(st.object);
                    });
                    result = result.concat(sts);
                };
                while(todo.length)follow(todo.shift());
                return result;
            }
        },
        {
            key: "formula",
            value: function formula(_features) {
                return new Formula();
            }
        },
        {
            key: "fromNT",
            value: function fromNT(str) {
                var dt, k, lang;
                switch(str[0]){
                    case "<":
                        return this.sym(str.slice(1, -1));
                    case '"':
                        lang = void 0;
                        dt = void 0;
                        k = str.lastIndexOf('"');
                        if (k < str.length - 1) {
                            if (str[k + 1] === "@") lang = str.slice(k + 2);
                            else if (str.slice(k + 1, k + 3) === "^^") dt = this.fromNT(str.slice(k + 3));
                            else throw new Error("Can't convert string from NT: " + str);
                        }
                        str = str.slice(1, k);
                        str = str.replace(/\\"/g, '"');
                        str = str.replace(/\\n/g, "\n");
                        str = str.replace(/\\\\/g, "\\");
                        return this.rdfFactory.literal(str, lang || dt);
                    case "_":
                        return this.rdfFactory.blankNode(str.slice(2));
                    case "?":
                        return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(str.slice(1));
                }
                throw new Error("Can't convert from NT: " + str);
            }
        },
        {
            key: "holds",
            value: function holds(s, p, o, g) {
                var i;
                if (arguments.length === 1) {
                    if (!s) return true;
                    if (s instanceof Array) {
                        for(i = 0; i < s.length; i++){
                            if (!this.holds(s[i])) return false;
                        }
                        return true;
                    } else if ((0, $gCJkd.isStatement)(s)) return this.holds(s.subject, s.predicate, s.object, s.graph);
                    else if (s.statements) return this.holds(s.statements);
                }
                var st = this.anyStatementMatching(s, p, o, g);
                return st != null;
            }
        },
        {
            key: "holdsStatement",
            value: function holdsStatement(statement) {
                return this.holds(statement.subject, statement.predicate, statement.object, statement.graph);
            }
        },
        {
            key: "list",
            value: function list(values, context) {
                if (context.rdfFactory.supports["COLLECTIONS"]) {
                    var collection = context.rdfFactory.collection();
                    values.forEach(function(val) {
                        collection.append(val);
                    });
                    return collection;
                } else {
                    var node = context.rdfFactory.blankNode();
                    var statements = (0, $c584fbcedb5512e3$export$b0f02731210f3037)(context.rdfFactory, node, values);
                    context.addAll(statements);
                    return node;
                }
            }
        },
        {
            key: "NTtoURI",
            value: function NTtoURI(t) {
                var k, v;
                var uris = {};
                for(k in t){
                    if (!t.hasOwnProperty(k)) continue;
                    v = t[k];
                    if (k[0] === "<") uris[k.slice(1, -1)] = v;
                }
                return uris;
            }
        },
        {
            key: "serialize",
            value: function serialize(base, contentType, provenance, options) {
                // delegate the graph serialization to the implementation in ./serialize
                return (0, $957a454a8ab6ebde$export$2e2bcd8739ae039)(provenance, this, base, contentType, undefined, options);
            }
        },
        {
            key: "substitute",
            value: function substitute(bindings) {
                var statementsCopy = this.statements.map(function(ea) {
                    return ea.substitute(bindings);
                });
                // console.log('Formula subs statmnts:' + statementsCopy)
                var y = new Formula();
                y.addAll(statementsCopy);
                // console.log('indexed-form subs formula:' + y)
                return y;
            }
        },
        {
            key: "sym",
            value: function sym(uri, name) {
                if (name) throw new Error("This feature (kb.sym with 2 args) is removed. Do not assume prefix mappings.");
                return this.rdfFactory.namedNode(uri);
            }
        },
        {
            key: "the",
            value: function the(s, p, o, g) {
                var x = this.any(s, p, o, g);
                if (x == null) (0, $kAE07.default).error("No value found for the() {" + s + " " + p + " " + o + "}.");
                return x;
            }
        },
        {
            key: "transitiveClosure",
            value: function transitiveClosure(seeds, predicate, inverse) {
                var elt, i, len, s, sups, t;
                var agenda = {};
                Object.assign(agenda, seeds); // make a copy
                var done = {}; // classes we have looked up
                while(true){
                    t = function() {
                        for(var p in agenda){
                            if (!agenda.hasOwnProperty(p)) continue;
                            return p;
                        }
                    }();
                    if (t == null) return done;
                    sups = inverse ? this.each(void 0, predicate, this.fromNT(t)) : this.each(this.fromNT(t), predicate);
                    for(i = 0, len = sups.length; i < len; i++){
                        elt = sups[i];
                        s = elt.toNT();
                        if (s in done) continue;
                        if (s in agenda) continue;
                        agenda[s] = agenda[t];
                    }
                    done[t] = agenda[t];
                    delete agenda[t];
                }
            }
        },
        {
            key: "topTypeURIs",
            value: function topTypeURIs(types) {
                var i;
                var j;
                var k;
                var len;
                var n;
                var ref;
                var tops;
                var v;
                tops = [];
                for(k in types){
                    if (!types.hasOwnProperty(k)) continue;
                    v = types[k];
                    n = 0;
                    ref = this.each(this.rdfFactory.namedNode(k), this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"));
                    for(i = 0, len = ref.length; i < len; i++){
                        j = ref[i];
                        if (j.uri !== "http://www.w3.org/2000/01/rdf-schema#Resource") {
                            n++;
                            break;
                        }
                    }
                    if (!n) tops[k] = v;
                }
                if (tops["http://www.w3.org/2000/01/rdf-schema#Resource"]) delete tops["http://www.w3.org/2000/01/rdf-schema#Resource"];
                if (tops["http://www.w3.org/2002/07/owl#Thing"]) delete tops["http://www.w3.org/2002/07/owl#Thing"];
                return tops;
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "{" + this.statements.join("\n") + "}";
            }
        },
        {
            key: "variable",
            value: function variable(name) {
                return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(name);
            }
        },
        {
            key: "whether",
            value: function whether(s, p, o, g) {
                return this.statementsMatching(s, p, o, g, false).length;
            }
        }
    ]);
    return Formula;
}((0, $cdU35.default));




var $23fob = parcelRequire("23fob");

var $gCJkd = parcelRequire("gCJkd");
// This file attaches all functionality to Node
// that would otherwise require circular dependencies.


var $cdU35 = parcelRequire("cdU35");


var $gCJkd = parcelRequire("gCJkd");
/**
 * Creates an RDF Node from a native javascript value.
 * RDF Nodes are returned unchanged, undefined returned as itself.
 * @method fromValue
 * @static
 * @param value {Node|Date|String|Number|Boolean|Undefined}
 * @return {Node|Collection}
 */ (0, $cdU35.default).fromValue = (0, $619d91631affbf30$export$5f36b26c3833b3ba);
var $e01338ed2499626a$export$2e2bcd8739ae039 = (0, $cdU35.default);
var $e01338ed2499626a$var$ns = {
    xsd: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2001/XMLSchema#")
};
/**
 * Gets the javascript object equivalent to a node
 * @param term The RDF node
 */ (0, $cdU35.default).toJS = function(term) {
    if ((0, $gCJkd.isCollection)(term)) return term.elements.map((0, $cdU35.default).toJS); // Array node (not standard RDFJS)
    if (!(0, $gCJkd.isLiteral)(term)) return term;
    if (term.datatype.equals($e01338ed2499626a$var$ns.xsd("boolean"))) return term.value === "1" || term.value === "true";
    if (term.datatype.equals($e01338ed2499626a$var$ns.xsd("dateTime")) || term.datatype.equals($e01338ed2499626a$var$ns.xsd("date"))) return new Date(term.value);
    if (term.datatype.equals($e01338ed2499626a$var$ns.xsd("integer")) || term.datatype.equals($e01338ed2499626a$var$ns.xsd("float")) || term.datatype.equals($e01338ed2499626a$var$ns.xsd("decimal"))) return Number(term.value);
    return term.value;
};




var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");



var $kAE07 = parcelRequire("kAE07");

var $4Q80K = parcelRequire("4Q80K");
var $06f9ff3d33460d2e$export$62297b13309008b2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(function Query(name, id) {
    (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Query);
    this.pat = new (0, $6f5c135260474402$export$2e2bcd8739ae039)(); // The pattern to search for
    this.vars = []; // Used by UI code but not in query.js
    //    this.orderBy = [] // Not used yet
    this.name = name;
    this.id = id;
});
function $06f9ff3d33460d2e$export$b935ec197a103b45(myQuery, callback, fetcher, onDone) {
    /** Debug strings
  */ function bindingDebug(b) {
        var str = "";
        var v;
        for(v in b)if (b.hasOwnProperty(v)) str += "    " + v + " -> " + b[v];
        return str;
    }
    function bindingsDebug(nbs) {
        var str = "Bindings: ";
        var i;
        var n = nbs.length;
        for(i = 0; i < n; i++)str += bindingDebug(nbs[i][0]) + ";\n	";
        return str;
    } // bindingsDebug
    /** Unification
   *
   * Unification finds all bindings such that when the binding is applied
   * to one term it is equal to the other.
   * @returns {Arrray}-  a list of bindings, where a binding is an associative array
   *  mapping variuable to value.
   */ function unifyTerm(self, other, bindings, formula) {
        var actual = bindings[self];
        if (actual === undefined) {
            // Not mapped
            if (self.isVar) {
                var b = [];
                b[self] = other;
                return [
                    [
                        b,
                        null
                    ]
                ]; // Match
            }
            actual = self;
        }
        if (!actual.complexType) {
            if (formula.redirections[actual]) actual = formula.redirections[actual];
            if (formula.redirections[other]) other = formula.redirections[other];
            if (actual.equals(other) || actual.uri && actual.uri === (0, $471ea8b4e912e4b1$export$fb7535ed90405da0)) // Used to mean 'any graph' in a query
            return [
                [
                    [],
                    null
                ]
            ];
            return [];
        }
        if (self instanceof Array) {
            if (!(other instanceof Array)) return [];
            return unifyContents(self, other, bindings);
        }
        throw new Error("query.js: oops - code not written yet");
    // return undefined;  // for lint - no jslint objects to unreachables
    //    return actual.unifyContents(other, bindings)
    } // unifyTerm
    function unifyContents(self, other, bindings, formula) {
        var nbs2;
        if (self.length !== other.length) return []; // no way
        if (!self.length) return [
            [
                [],
                null
            ]
        ]; // Success
        var nbs = unifyTerm(self[0], other[0], bindings, formula);
        if (nbs.length === 0) return nbs;
        var res = [];
        var i;
        var n = nbs.length;
        var nb;
        var j;
        var m;
        var v;
        var nb2;
        var bindings2;
        for(i = 0; i < n; i++){
            // for each possibility from the first term
            nb = nbs[i][0]; // new bindings
            bindings2 = [];
            for(v in nb)if (nb.hasOwnProperty(v)) bindings2[v] = nb[v]; // copy
            for(v in bindings)if (bindings.hasOwnProperty(v)) bindings2[v] = bindings[v]; // copy
            nbs2 = unifyContents(self.slice(1), other.slice(1), bindings2, formula);
            m = nbs2.length;
            for(j = 0; j < m; j++){
                nb2 = nbs2[j][0]; // @@@@ no idea whether this is used or right
                for(v in nb)if (nb.hasOwnProperty(v)) nb2[v] = nb[v];
                res.push([
                    nb2,
                    null
                ]);
            }
        }
        return res;
    } // unifyContents
    //  Matching
    //
    // Matching finds all bindings such that when the binding is applied
    // to one term it is equal to the other term.  We only match formulae.
    /** if x is not in the bindings array, return the var; otherwise, return the bindings **/ function bind(x, binding) {
        var y = binding[x];
        if (y === undefined) return x;
        return y;
    }
    // When there are OPTIONAL clauses, we must return bindings without them if none of them
    // succeed. However, if any of them do succeed, we should not.  (This is what branchCount()
    // tracked. The problem currently is (2011/7) that when several optionals exist, and they
    // all match, multiple sets of bindings are returned, each with one optional filled in.)
    function union(a, b) {
        var c = {};
        var x;
        for(x in a)if (a.hasOwnProperty(x)) c[x] = a[x];
        for(x in b)if (b.hasOwnProperty(x)) c[x] = b[x];
        return c;
    }
    function OptionalBranchJunction(originalCallback, trunkBindings) {
        this.trunkBindings = trunkBindings;
        this.originalCallback = originalCallback;
        this.branches = [];
        // this.results = []; // result[i] is an array of bindings for branch i
        // this.done = {};  // done[i] means all/any results are in for branch i
        // this.count = {}
        return this;
    }
    OptionalBranchJunction.prototype.checkAllDone = function() {
        var i;
        for(i = 0; i < this.branches.length; i++){
            if (!this.branches[i].done) return;
        }
        (0, $kAE07.default).debug("OPTIONAL BIDNINGS ALL DONE:");
        this.doCallBacks(this.branches.length - 1, this.trunkBindings);
    };
    // Recrursively generate the cross product of the bindings
    OptionalBranchJunction.prototype.doCallBacks = function(b, bindings) {
        var j;
        if (b < 0) return this.originalCallback(bindings);
        for(j = 0; j < this.branches[b].results.length; j++)this.doCallBacks(b - 1, union(bindings, this.branches[b].results[j]));
    };
    // A mandatory branch is the normal one, where callbacks
    // are made immediately and no junction is needed.
    // Might be useful for onFinsihed callback for query API.
    function MandatoryBranch(callback, onDone) {
        this.count = 0;
        this.success = false;
        this.done = false;
        // this.results = []
        this.callback = callback;
        this.onDone = onDone;
        // this.junction = junction
        // junction.branches.push(this)
        return this;
    }
    MandatoryBranch.prototype.reportMatch = function(bindings) {
        // log.error("@@@@ query.js 1"); // @@
        this.callback(bindings);
        this.success = true;
    };
    MandatoryBranch.prototype.reportDone = function() {
        this.done = true;
        (0, $kAE07.default).info("Mandatory query branch finished.***");
        if (this.onDone !== undefined) this.onDone();
    };
    // An optional branch hoards its results.
    var OptionalBranch = function OptionalBranch(junction) {
        this.count = 0;
        this.done = false;
        this.results = [];
        this.junction = junction;
        junction.branches.push(this);
        return this;
    };
    OptionalBranch.prototype.reportMatch = function(bindings) {
        this.results.push(bindings);
    };
    OptionalBranch.prototype.reportDone = function() {
        (0, $kAE07.default).debug("Optional branch finished - results.length = " + this.results.length);
        if (this.results.length === 0) {
            // This is what optional means: if no hits,
            this.results.push({}); // mimic success, but with no bindings
            (0, $kAE07.default).debug("Optional branch FAILED - that's OK.");
        }
        this.done = true;
        this.junction.checkAllDone();
    };
    /** prepare -- sets the index of the item to the possible matches
   * @param f - formula
   * @param item - an Statement, possibly w/ vars in it
   * @param bindings - Bindings so far
   * @returns false if the query fails -- there are no items that match
  */ function prepare(f, item, bindings) {
        var terms, termIndex, i, ind;
        item.nvars = 0;
        item.index = null;
        // if (!f.statements) log.warn("@@@ prepare: f is "+f)
        //    log.debug("Prepare: f has "+ f.statements.length)
        // log.debug("Prepare: Kb size "+f.statements.length+" Preparing "+item)
        terms = [
            item.subject,
            item.predicate,
            item.object,
            item.why
        ];
        ind = [
            f.subjectIndex,
            f.predicateIndex,
            f.objectIndex,
            f.whyIndex
        ];
        for(i = 0; i < 4; i++){
            var t = terms[i];
            // console.log("  Prepare (" + t + ") "+(t in bindings))
            if (t.uri && t.uri === (0, $471ea8b4e912e4b1$export$fb7535ed90405da0)) ;
            else if (t.isVar && !(bindings[t] !== undefined)) item.nvars++;
            else {
                t = bind(terms[i], bindings); // returns the RDF binding if bound, otherwise itself
                // if (terms[i]!=bind(terms[i],bindings) alert("Term: "+terms[i]+"Binding: "+bind(terms[i], bindings))
                if (f.redirections[f.id(t)]) t = f.redirections[f.id(t)]; // redirect
                termIndex = ind[i][f.id(t)];
                if (!termIndex) {
                    item.index = [];
                    return false; // Query line cannot match
                }
                if (item.index === null || item.index.length > termIndex.length) // Find smallest index
                item.index = termIndex;
            }
        }
        if (item.index === null) // All 4 are variables?
        item.index = f.statements;
        return true;
    } // prepare
    /** sorting function -- negative if self is easier **/ // We always prefer to start with a URI to be able to browse a graph
    // this is why we put off items with more variables till later.
    function easiestQuery(self, other) {
        if (self.nvars !== other.nvars) return self.nvars - other.nvars;
        return self.index.length - other.index.length;
    }
    var matchIndex = 0; // index
    /** matches a pattern formula against the knowledge base, e.g. to find matches for table-view
  *
  * @param f - knowledge base formula
  * @param g - pattern formula (may have vars)
  * @param bindingsSoFar  - bindings accumulated in matching to date
  * @param level - spaces to indent stuff also lets you know what level of recursion you're at
  * @param fetcher - function (term, requestedBy) If you want link following
  * @param localCallback - function(bindings, pattern, branch) called on sucess
  * @returns nothing
  *
  * Will fetch linked data from the web iff the knowledge base an associated source fetcher (f.fetcher)
  ***/ var match = function match(f, g, bindingsSoFar, level, fetcher, localCallback, branch) {
        (0, $kAE07.default).debug("Match begins, Branch count now: " + branch.count + " for " + branch.pattern_debug);
        // log.debug("match: f has "+f.statements.length+", g has "+g.statements.length)
        var pattern = g.statements;
        if (pattern.length === 0) {
            // when it's satisfied all the pattern triples
            (0, $kAE07.default).debug("FOUND MATCH WITH BINDINGS:" + bindingDebug(bindingsSoFar));
            if (g.optional.length === 0) branch.reportMatch(bindingsSoFar);
            else {
                (0, $kAE07.default).debug("OPTIONAL: " + g.optional);
                var junction = new OptionalBranchJunction(callback, bindingsSoFar); // @@ won't work with nested optionals? nest callbacks
                var br = [];
                var b;
                for(b = 0; b < g.optional.length; b++){
                    br[b] = new OptionalBranch(junction); // Allocate branches to prevent premature ending
                    br[b].pattern_debug = g.optional[b]; // for diagnotics only
                }
                for(b = 0; b < g.optional.length; b++){
                    br[b].count = br[b].count + 1; // Count how many matches we have yet to complete
                    match(f, g.optional[b], bindingsSoFar, "", fetcher, callback, br[b]);
                }
            }
            branch.count--;
            (0, $kAE07.default).debug("Match ends -- success , Branch count now: " + branch.count + " for " + branch.pattern_debug);
            return; // Success
        }
        var item;
        var i;
        var n = pattern.length;
        // log.debug(level + "Match "+n+" left, bs so far:"+bindingDebug(bindingsSoFar))
        // Follow links from variables in query
        if (fetcher) {
            // Fetcher is used to fetch URIs, function first term is a URI term, second is the requester
            var id = "match" + matchIndex++;
            var fetchResource = function fetchResource(requestedTerm, id) {
                var docuri = requestedTerm.uri.split("#")[0];
                fetcher.nowOrWhenFetched(docuri, undefined, function(ok, body, xhr) {
                    if (!ok) console.log("Error following link to <" + requestedTerm.uri + "> in query: " + body);
                    match(f, g, bindingsSoFar, level, fetcher, // match not match2 to look up any others necessary.
                    localCallback, branch);
                });
            };
            for(i = 0; i < n; i++){
                item = pattern[i]; // for each of the triples in the query
                if (bindingsSoFar[item.subject] !== undefined && bindingsSoFar[item.subject].uri && fetcher && fetcher.getState((0, $4Q80K.docpart)(bindingsSoFar[item.subject].uri)) === "unrequested") {
                    // fetch the subject info and return to id
                    fetchResource(bindingsSoFar[item.subject], id);
                    return; // only look up one per line this time, but we will come back again though match
                }
                if (bindingsSoFar[item.object] !== undefined && bindingsSoFar[item.object].uri && fetcher && fetcher.getState((0, $4Q80K.docpart)(bindingsSoFar[item.object].uri)) === "unrequested") {
                    fetchResource(bindingsSoFar[item.object], id);
                    return;
                }
            }
        } // if fetcher
        match2(f, g, bindingsSoFar, level, fetcher, localCallback, branch);
    }; // match
    var constraintsSatisfied = function constraintsSatisfied(bindings, constraints) {
        var res = true;
        var x;
        var test;
        for(x in bindings){
            if (bindings.hasOwnProperty(x)) {
                if (constraints[x]) {
                    test = constraints[x].test;
                    if (test && !test(bindings[x])) res = false;
                }
            }
        }
        return res;
    };
    /** match2 -- stuff after the fetch **/ var match2 = function match2(f, g, bindingsSoFar, level, fetcher, callback, branch) {
        // post fetch
        var pattern = g.statements;
        var n = pattern.length;
        var i;
        var k;
        var nk;
        var v;
        var bindings2;
        var newBindings1;
        var item;
        for(i = 0; i < n; i++){
            // For each statement left in the query, run prepare
            item = pattern[i];
            // log.info('match2: item=' + item + ', bindingsSoFar=' + bindingDebug(bindingsSoFar))
            prepare(f, item, bindingsSoFar);
        // if (item.index) console.log('     item.index.length ' + item.index.length)
        }
        pattern.sort(easiestQuery);
        item = pattern[0];
        // log.debug("Sorted pattern:\n"+pattern)
        var rest = f.formula();
        rest.optional = g.optional;
        rest.constraints = g.constraints;
        rest.statements = pattern.slice(1); // No indexes: we will not query g.
        (0, $kAE07.default).debug(level + "match2 searching " + item.index.length + " for " + item + "; bindings so far=" + bindingDebug(bindingsSoFar));
        // var results = []
        var c;
        var nc = item.index.length;
        var nbs1;
        var st;
        var onward = 0;
        // var x
        for(c = 0; c < nc; c++){
            // For each candidate statement
            st = item.index[c]; // for each statement in the item's index, spawn a new match with that binding
            nbs1 = unifyContents([
                item.subject,
                item.predicate,
                item.object,
                item.why
            ], [
                st.subject,
                st.predicate,
                st.object,
                st.why
            ], bindingsSoFar, f);
            (0, $kAE07.default).info(level + " From first: " + nbs1.length + ": " + bindingsDebug(nbs1));
            nk = nbs1.length;
            // branch.count += nk
            // log.debug("Branch count bumped "+nk+" to: "+branch.count)
            for(k = 0; k < nk; k++){
                // For each way that statement binds
                bindings2 = [];
                newBindings1 = nbs1[k][0];
                if (!constraintsSatisfied(newBindings1, g.constraints)) // branch.count--
                (0, $kAE07.default).debug("Branch count CS: " + branch.count);
                else {
                    for(v in newBindings1)if (newBindings1.hasOwnProperty(v)) bindings2[v] = newBindings1[v]; // copy
                    for(v in bindingsSoFar)if (bindingsSoFar.hasOwnProperty(v)) bindings2[v] = bindingsSoFar[v]; // copy
                    branch.count++; // Count how many matches we have yet to complete
                    onward++;
                    match(f, rest, bindings2, level + "  ", fetcher, callback, branch); // call match
                }
            }
        }
        branch.count--;
        if (onward === 0) (0, $kAE07.default).debug("Match2 fails completely on " + item);
        (0, $kAE07.default).debug("Match2 ends, Branch count: " + branch.count + " for " + branch.pattern_debug);
        if (branch.count === 0) {
            (0, $kAE07.default).debug("Branch finished.");
            branch.reportDone();
        }
    }; // match2
    // ////////////////////////// Body of query()  ///////////////////////
    var f = this;
    (0, $kAE07.default).debug("Query on " + this.statements.length);
    var trunck = new MandatoryBranch(callback, onDone);
    trunck.count++; // count one branch to complete at the moment
    if (myQuery.sync) match(f, myQuery.pat, myQuery.pat.initBindings, "", fetcher, callback, trunck);
    else // Give up thread: Allow other activities to run
    setTimeout(function() {
        match(f, myQuery.pat, myQuery.pat.initBindings, "", fetcher, callback, trunck);
    }, 0);
// returns nothing; callback does the work
} // query



var $8RKL2 = parcelRequire("8RKL2");

var $99pVg = parcelRequire("99pVg");





function $6f5c135260474402$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6f5c135260474402$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6f5c135260474402$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6f5c135260474402$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6f5c135260474402$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $6f5c135260474402$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $6f5c135260474402$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6f5c135260474402$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6f5c135260474402$var$_arrayLikeToArray(o, minLen);
}
function $6f5c135260474402$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6f5c135260474402$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6f5c135260474402$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $6f5c135260474402$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6f5c135260474402$var$owlNamespaceURI = "http://www.w3.org/2002/07/owl#";
// var link_ns = 'http://www.w3.org/2007/ont/link#'
// Handle Functional Property
function $6f5c135260474402$var$handleFP(formula, subj, pred, obj) {
    var o1 = formula.any(subj, pred, undefined);
    if (!o1) return false; // First time with this value
    // log.warn("Equating "+o1.uri+" and "+obj.uri + " because FP "+pred.uri);  //@@
    formula.equate(o1, obj);
    return true;
} // handleFP
// Handle Inverse Functional Property
function $6f5c135260474402$var$handleIFP(formula, subj, pred, obj) {
    var s1 = formula.any(undefined, pred, obj);
    if (!s1) return false; // First time with this value
    // log.warn("Equating "+s1.uri+" and "+subj.uri + " because IFP "+pred.uri);  //@@
    formula.equate(s1, subj);
    return true;
} // handleIFP
function $6f5c135260474402$var$handleRDFType(formula, subj, pred, obj, why) {
    //@ts-ignore this method does not seem to exist in this library
    if (formula.typeCallback) formula.typeCallback(formula, obj, why);
    var x = formula.classActions[formula.id(obj)];
    var done = false;
    if (x) for(var i = 0; i < x.length; i++)done = done || x[i](formula, subj, pred, obj, why);
    return done; // statement given is not needed if true
}
/**
 * Indexed Formula aka Store
 */ var $6f5c135260474402$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Formula) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(IndexedFormula, _Formula);
    var _super = $6f5c135260474402$var$_createSuper(IndexedFormula);
    /**
   * Creates a new formula
   * @param features - What sort of automatic processing to do? Array of string
   * @param features.sameAs - Smush together A and B nodes whenever { A sameAs B }
   * @param opts
   * @param [opts.rdfFactory] - The data factory that should be used by the store
   * @param [opts.rdfArrayRemove] - Function which removes statements from the store
   * @param [opts.dataCallback] - Callback when a statement is added to the store, will not trigger when adding duplicates
   */ function IndexedFormula(features) {
        var _this;
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, IndexedFormula);
        _this = _super.call(this, undefined, undefined, undefined, undefined, opts);
        // IN future - allow pass array of statements to constructor
        /**
     * An UpdateManager initialised to this store
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "updater", void 0);
        /**
     * Dictionary of namespace prefixes
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "namespaces", void 0);
        /** Map of iri predicates to functions to call when adding { s type X } */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "classActions", void 0);
        /** Map of iri predicates to functions to call when getting statement with {s X o} */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "propertyActions", void 0);
        /** Redirect to lexically smaller equivalent symbol */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "redirections", void 0);
        /** Reverse mapping to redirection: aliases for this */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "aliases", void 0);
        /** Redirections we got from HTTP */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "HTTPRedirects", void 0);
        /** Array of statements with this X as subject */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "subjectIndex", void 0);
        /** Array of statements with this X as predicate */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "predicateIndex", void 0);
        /** Array of statements with this X as object */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "objectIndex", void 0);
        /** Array of statements with X as provenance */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "whyIndex", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "index", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "features", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_universalVariables", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "_existentialVariables", void 0);
        /** Function to remove quads from the store arrays with */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "rdfArrayRemove", void 0);
        /** Callbacks which are triggered after a statement has been added to the store */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "dataCallbacks", void 0);
        _this.propertyActions = {};
        _this.classActions = {};
        _this.redirections = [];
        _this.aliases = [];
        _this.HTTPRedirects = [];
        _this.subjectIndex = [];
        _this.predicateIndex = [];
        _this.objectIndex = [];
        _this.whyIndex = [];
        _this.index = [
            _this.subjectIndex,
            _this.predicateIndex,
            _this.objectIndex,
            _this.whyIndex
        ];
        _this.namespaces = {}; // Dictionary of namespace prefixes
        _this.features = features || [];
        _this.rdfArrayRemove = opts.rdfArrayRemove || (0, $23fob.RDFArrayRemove);
        if (opts.dataCallback) _this.dataCallbacks = [
            opts.dataCallback
        ];
        _this.initPropertyActions(_this.features);
        return _this;
    }
    /**
   * Gets the URI of the default graph
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(IndexedFormula, [
        {
            key: "substitute",
            value: /**
     * Gets this graph with the bindings substituted
     * @param bindings The bindings
     */ function substitute(bindings) {
                var statementsCopy = this.statements.map(function(ea) {
                    return ea.substitute(bindings);
                });
                var y = new IndexedFormula();
                y.add(statementsCopy);
                return y;
            }
        },
        {
            key: "addDataCallback",
            value: function addDataCallback(cb) {
                if (!this.dataCallbacks) this.dataCallbacks = [];
                this.dataCallbacks.push(cb);
            }
        },
        {
            key: "applyPatch",
            value: function applyPatch(patch, target, patchCallback) {
                var targetKB = this;
                var ds;
                var binding = null;
                function doPatch(onDonePatch) {
                    if (patch["delete"]) {
                        ds = patch["delete"];
                        // console.log(bindingDebug(binding))
                        // console.log('ds before substitute: ' + ds)
                        if (binding) ds = ds.substitute(binding);
                        // console.log('applyPatch: delete: ' + ds)
                        ds = ds.statements;
                        var bad = [];
                        var ds2 = ds.map(function(st) {
                            // Find the actual statements in the store
                            var sts = targetKB.statementsMatching(st.subject, st.predicate, st.object, target);
                            if (sts.length === 0) {
                                // log.info("NOT FOUND deletable " + st)
                                bad.push(st);
                                return null;
                            } else // log.info("Found deletable " + st)
                            return sts[0];
                        });
                        if (bad.length) // console.log('Could not find to delete ' + bad.length + 'statements')
                        // console.log('despite ' + targetKB.statementsMatching(bad[0].subject, bad[0].predicate)[0])
                        return patchCallback("Could not find to delete: " + bad.join("\n or "));
                        ds2.map(function(st) {
                            targetKB.remove(st);
                        });
                    }
                    if (patch["insert"]) {
                        // log.info("doPatch insert "+patch['insert'])
                        ds = patch["insert"];
                        if (binding) ds = ds.substitute(binding);
                        ds = ds.statements;
                        ds.map(function(st) {
                            st.graph = target;
                            targetKB.add(st.subject, st.predicate, st.object, st.graph);
                        });
                    }
                    onDonePatch();
                }
                if (patch.where) {
                    // log.info("Processing WHERE: " + patch.where + '\n')
                    var query = new (0, $06f9ff3d33460d2e$export$62297b13309008b2)("patch");
                    query.pat = patch.where;
                    query.pat.statements.map(function(st) {
                        st.graph = (0, $6f0137736d5eb798$export$fe4bf738d66b6b12)(target.value);
                    });
                    //@ts-ignore TODO: add sync property to Query when converting Query to typescript
                    query.sync = true;
                    var bindingsFound = [];
                    targetKB.query(query, function onBinding(binding) {
                        bindingsFound.push(binding);
                    // console.log('   got a binding: ' + bindingDebug(binding))
                    }, targetKB.fetcher, function onDone() {
                        if (bindingsFound.length === 0) return patchCallback("No match found to be patched:" + patch.where);
                        if (bindingsFound.length > 1) return patchCallback("Patch ambiguous. No patch done.");
                        binding = bindingsFound[0];
                        doPatch(patchCallback);
                    });
                } else doPatch(patchCallback);
            }
        },
        {
            key: "declareExistential",
            value: function declareExistential(x) {
                if (!this._existentialVariables) this._existentialVariables = [];
                this._existentialVariables.push(x);
                return x;
            }
        },
        {
            key: "initPropertyActions",
            value: function initPropertyActions(features) {
                // If the predicate is #type, use handleRDFType to create a typeCallback on the object
                this.propertyActions[this.rdfFactory.id(this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"))] = [
                    $6f5c135260474402$var$handleRDFType
                ];
                // Assumption: these terms are not redirected @@fixme
                if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(features, "sameAs") >= 0) this.propertyActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat($6f5c135260474402$var$owlNamespaceURI, "sameAs")))] = [
                    function(formula, subj, pred, obj, why) {
                        // log.warn("Equating "+subj.uri+" sameAs "+obj.uri);  //@@
                        formula.equate(subj, obj);
                        return true; // true if statement given is NOT needed in the store
                    }
                ]; // sameAs -> equate & don't add to index
                if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(features, "InverseFunctionalProperty") >= 0) this.classActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat($6f5c135260474402$var$owlNamespaceURI, "InverseFunctionalProperty")))] = [
                    function(formula, subj, pred, obj, addFn) {
                        // yes subj not pred!
                        return formula.newPropertyAction(subj, $6f5c135260474402$var$handleIFP);
                    }
                ]; // IFP -> handleIFP, do add to index
                if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(features, "FunctionalProperty") >= 0) this.classActions[this.rdfFactory.id(this.rdfFactory.namedNode("".concat($6f5c135260474402$var$owlNamespaceURI, "FunctionalProperty")))] = [
                    function(formula, subj, proj, obj, addFn) {
                        return formula.newPropertyAction(subj, $6f5c135260474402$var$handleFP);
                    }
                ]; // FP => handleFP, do add to index
            }
        },
        {
            key: "addStatement",
            value: function addStatement(st) {
                this.add(st.subject, st.predicate, st.object, st.graph);
                return this.statements.length;
            }
        },
        {
            key: "add",
            value: function add(subj, pred, obj, why) {
                var i;
                if (arguments.length === 1) {
                    if (subj instanceof Array) for(i = 0; i < subj.length; i++)this.add(subj[i]);
                    else if ((0, $gCJkd.isQuad)(subj)) this.add(subj.subject, subj.predicate, subj.object, subj.graph);
                    else if ((0, $gCJkd.isStore)(subj)) this.add(subj.statements);
                    return this;
                }
                var actions;
                var st;
                if (!why) // system generated
                why = this.fetcher ? this.fetcher.appNode : this.rdfFactory.defaultGraph();
                if (typeof subj == "string") subj = this.rdfFactory.namedNode(subj);
                pred = (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(pred);
                var objNode = (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(obj);
                why = (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(why);
                if (!(0, $gCJkd.isRDFlibSubject)(subj)) throw new Error("Subject is not a subject type");
                if (!(0, $gCJkd.isRDFlibPredicate)(pred)) throw new Error("Predicate ".concat(pred, " is not a predicate type"));
                if (!(0, $gCJkd.isRDFlibObject)(objNode)) throw new Error("Object ".concat(objNode, " is not an object type"));
                if (!(0, $gCJkd.isGraph)(why)) throw new Error("Why is not a graph type");
                //@ts-ignore This is not used internally
                if (this.predicateCallback) //@ts-ignore This is not used internally
                this.predicateCallback(this, pred, why);
                // Action return true if the statement does not need to be added
                var predHash = this.id(this.canon(pred));
                actions = this.propertyActions[predHash]; // Predicate hash
                var done = false;
                if (actions) // alert('type: '+typeof actions +' @@ actions='+actions)
                for(i = 0; i < actions.length; i++)done = done || actions[i](this, subj, pred, objNode, why);
                if (this.holds(subj, pred, objNode, why)) // Takes time but saves duplicates
                // console.log('rdflib: Ignoring dup! {' + subj + ' ' + pred + ' ' + obj + ' ' + why + '}')
                return null; // @@better to return self in all cases?
                // If we are tracking provenance, every thing should be loaded into the store
                // if (done) return this.rdfFactory.quad(subj, pred, obj, why)
                // Don't put it in the store
                // still return this statement for owl:sameAs input
                var hash = [
                    this.id(this.canon(subj)),
                    predHash,
                    this.id(this.canon(objNode)),
                    this.id(this.canon(why))
                ];
                // @ts-ignore this will fail if you pass a collection and the factory does not allow Collections
                st = this.rdfFactory.quad(subj, pred, objNode, why);
                for(i = 0; i < 4; i++){
                    var ix = this.index[i];
                    var h = hash[i];
                    if (!ix[h]) ix[h] = [];
                    ix[h].push(st); // Set of things with this as subject, etc
                }
                // log.debug("ADDING    {"+subj+" "+pred+" "+objNode+"} "+why)
                this.statements.push(st);
                if (this.dataCallbacks) {
                    var _iterator = $6f5c135260474402$var$_createForOfIteratorHelper(this.dataCallbacks), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var callback = _step.value;
                            callback(st);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                return st;
            }
        },
        {
            key: "canon",
            value: function canon(term) {
                if (!term) // @@ TODO Should improve this to return proper value - doing this to keep it backward compatible
                return term;
                var y = this.redirections[this.id(term)];
                if (y) return y;
                switch(term.termType){
                    case 0, $8RKL2.BlankNodeTermType:
                        return new (0, $d0a63e5194c4f691$export$2e2bcd8739ae039)(term.value);
                    case 0, $8RKL2.CollectionTermType:
                        return term;
                    // non-RDF/JS type, should just need to cast
                    case 0, $8RKL2.DefaultGraphTermType:
                        return new (0, $cdeb561dfecfaa8a$export$2e2bcd8739ae039)();
                    case 0, $8RKL2.EmptyTermType:
                        // non-RDF/JS type, should just need to cast
                        return term;
                    case 0, $8RKL2.GraphTermType:
                        // non-RDF/JS type, should just need to cast
                        return term;
                    case 0, $8RKL2.LiteralTermType:
                        return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(term.value, term.language, term.datatype);
                    case 0, $8RKL2.NamedNodeTermType:
                        return new (0, $99pVg.default)(term.value);
                    case 0, $8RKL2.VariableTermType:
                        return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(term.value);
                    default:
                        throw new Error("Term Type not recognized for canonization: ".concat(term.termType));
                }
            }
        },
        {
            key: "check",
            value: function check() {
                this.checkStatementList(this.statements);
                for(var p = 0; p < 4; p++){
                    var ix = this.index[p];
                    for(var key in ix)if (ix.hasOwnProperty(key)) // @ts-ignore should this pass an array or a single statement? checkStateMentsList expects an array.
                    this.checkStatementList(ix[key], p);
                }
            }
        },
        {
            key: "checkStatementList",
            value: function checkStatementList(sts, from) {
                if (from === undefined) from = 0;
                var names = [
                    "subject",
                    "predicate",
                    "object",
                    "why"
                ];
                var origin = " found in " + names[from] + " index.";
                var st;
                for(var j = 0; j < sts.length; j++){
                    st = sts[j];
                    var term = [
                        st.subject,
                        st.predicate,
                        st.object,
                        st.graph
                    ];
                    var arrayContains = function arrayContains(a, x) {
                        for(var i = 0; i < a.length; i++){
                            if (a[i].subject.equals(x.subject) && a[i].predicate.equals(x.predicate) && a[i].object.equals(x.object) && a[i].why.equals(x.graph)) return true;
                        }
                    };
                    for(var p = 0; p < 4; p++){
                        var c = this.canon(term[p]);
                        var h = this.id(c);
                        if (!this.index[p][h]) ;
                        else arrayContains(this.index[p][h], st);
                    }
                    if (!arrayContains(this.statements, st)) throw new Error("Statement list does not statement " + st + "@" + st.graph + origin);
                }
            }
        },
        {
            key: "close",
            value: function close() {
                return this;
            }
        },
        {
            key: "compareTerms",
            value: function compareTerms(u1, u2) {
                // Keep compatibility with downstream classOrder changes
                if (Object.prototype.hasOwnProperty.call(u1, "compareTerm")) return u1.compareTerm(u2);
                if ((0, $aZYlt.default)[u1.termType] < (0, $aZYlt.default)[u2.termType]) return -1;
                if ((0, $aZYlt.default)[u1.termType] > (0, $aZYlt.default)[u2.termType]) return 1;
                if (u1.value < u2.value) return -1;
                if (u1.value > u2.value) return 1;
                return 0;
            }
        },
        {
            key: "copyTo",
            value: function copyTo(template, target, flags) {
                if (!flags) flags = [];
                var statList = this.statementsMatching(template);
                if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(flags, "two-direction") !== -1) statList.concat(this.statementsMatching(undefined, undefined, template));
                for(var i = 0; i < statList.length; i++){
                    var st = statList[i];
                    switch(st.object.termType){
                        case "NamedNode":
                            this.add(target, st.predicate, st.object);
                            break;
                        case "Literal":
                        case "BlankNode":
                        // @ts-ignore Collections can appear here
                        case "Collection":
                            // @ts-ignore Possible bug: copy is not available on Collections
                            this.add(target, st.predicate, st.object.copy(this));
                    }
                    if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(flags, "delete") !== -1) this.remove(st);
                }
            }
        },
        {
            key: "equate",
            value: function equate(u1in, u2in) {
                // log.warn("Equating "+u1+" and "+u2); // @@
                // @@JAMBO Must canonicalize the uris to prevent errors from a=b=c
                // 03-21-2010
                var u1 = this.canon(u1in);
                var u2 = this.canon(u2in);
                var d = this.compareTerms(u1, u2);
                if (!d) return true; // No information in {a = a}
                // var big
                // var small
                if (d < 0) // u1 less than u2
                return this.replaceWith(u2, u1);
                else return this.replaceWith(u1, u2);
            }
        },
        {
            key: "formula",
            value: function formula(features) {
                return new IndexedFormula(features);
            }
        },
        {
            key: "length",
            get: function get() {
                return this.statements.length;
            }
        },
        {
            key: "match",
            value: function match(subject, predicate, object, graph) {
                return this.statementsMatching((0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(subject), (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(predicate), (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(object), (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(graph));
            }
        },
        {
            key: "mentionsURI",
            value: function mentionsURI(uri) {
                var hash = "<" + uri + ">";
                return !!this.subjectIndex[hash] || !!this.objectIndex[hash] || !!this.predicateIndex[hash];
            }
        },
        {
            key: "newExistential",
            value: function newExistential(uri) {
                if (!uri) return this.bnode();
                var x = this.sym(uri);
                // @ts-ignore x should be blanknode, but is namedNode.
                return this.declareExistential(x);
            }
        },
        {
            key: "newPropertyAction",
            value: function newPropertyAction(pred, action) {
                // log.debug("newPropertyAction:  "+pred)
                var hash = this.id(pred);
                if (!this.propertyActions[hash]) this.propertyActions[hash] = [];
                this.propertyActions[hash].push(action);
                // Now apply the function to to statements already in the store
                var toBeFixed = this.statementsMatching(undefined, pred, undefined);
                var done = false;
                for(var i = 0; i < toBeFixed.length; i++)// NOT optimized - sort toBeFixed etc
                done = done || action(this, toBeFixed[i].subject, pred, toBeFixed[i].object);
                return done;
            }
        },
        {
            key: "newUniversal",
            value: function newUniversal(uri) {
                var x = this.sym(uri);
                if (!this._universalVariables) this._universalVariables = [];
                this._universalVariables.push(x);
                return x;
            }
        },
        {
            key: "variable",
            value: function variable(name) {
                return new (0, $b7a48305c1700eec$export$2e2bcd8739ae039)(name);
            }
        },
        {
            key: "nextSymbol",
            value: function nextSymbol(doc) {
                for(var i = 0;; i++){
                    var uri = doc.value + "#n" + i;
                    if (!this.mentionsURI(uri)) return this.sym(uri);
                }
            }
        },
        {
            key: "query",
            value: function query(myQuery, callback, fetcher, onDone) {
                return (0, $06f9ff3d33460d2e$export$b935ec197a103b45).call(this, myQuery, callback, fetcher, onDone);
            }
        },
        {
            key: "querySync",
            value: function querySync(myQuery) {
                var results = [];
                function saveBinginds(bindings) {
                    results.push(bindings);
                }
                function onDone() {
                    done = true;
                }
                var done = false;
                // @ts-ignore TODO: Add .sync to Query
                myQuery.sync = true;
                (0, $06f9ff3d33460d2e$export$b935ec197a103b45).call(this, myQuery, saveBinginds, null, onDone);
                if (!done) throw new Error("Sync query should have called done function");
                return results;
            }
        },
        {
            key: "remove",
            value: function remove(st) {
                if (st instanceof Array) {
                    for(var i = 0; i < st.length; i++)this.remove(st[i]);
                    return this;
                }
                if ((0, $gCJkd.isStore)(st)) return this.remove(st.statements);
                var sts = this.statementsMatching(st.subject, st.predicate, st.object, st.graph);
                if (!sts.length) throw new Error("Statement to be removed is not on store: " + st);
                this.removeStatement(sts[0]);
                return this;
            }
        },
        {
            key: "removeDocument",
            value: function removeDocument(doc) {
                var meta = this.sym("chrome://TheCurrentSession"); // or this.rdfFactory.namedNode('chrome://TheCurrentSession')
                var linkNamespaceURI = "http://www.w3.org/2007/ont/link#"; // alain
                // remove request/response and metadata
                var requests = this.statementsMatching(undefined, this.sym("".concat(linkNamespaceURI, "requestedURI")), this.rdfFactory.literal(doc.value), meta).map(function(st) {
                    return st.subject;
                });
                for(var r = 0; r < requests.length; r++){
                    var request = requests[r];
                    if (request !== undefined) {
                        this.removeMatches(request, null, null, meta);
                        var response = this.any(request, this.sym("".concat(linkNamespaceURI, "response")), null, meta);
                        if (response !== undefined) // ts
                        this.removeMatches(response, null, null, meta);
                    }
                }
                this.removeMatches(this.sym(doc.value), null, null, meta); // content-type
                // remove document
                var sts = this.statementsMatching(undefined, undefined, undefined, doc).slice(); // Take a copy as this is the actual index
                for(var i = 0; i < sts.length; i++)this.removeStatement(sts[i]);
                return this;
            }
        },
        {
            key: "removeMany",
            value: function removeMany(subj, pred, obj, why, limit) {
                // log.debug("entering removeMany w/ subj,pred,obj,why,limit = " + subj +", "+ pred+", " + obj+", " + why+", " + limit)
                var sts = this.statementsMatching(subj, pred, obj, why, false);
                // This is a subtle bug that occurred in updateCenter.js too.
                // The fact is, this.statementsMatching returns this.whyIndex instead of a copy of it
                // but for perfromance consideration, it's better to just do that
                // so make a copy here.
                var statements = [];
                for(var i = 0; i < sts.length; i++)statements.push(sts[i]);
                if (limit) statements = statements.slice(0, limit);
                for(i = 0; i < statements.length; i++)this.remove(statements[i]);
            }
        },
        {
            key: "removeMatches",
            value: function removeMatches(subject, predicate, object, graph) {
                this.removeMany(subject, predicate, object, graph);
                return this;
            }
        },
        {
            key: "removeStatement",
            value: function removeStatement(st) {
                // log.debug("entering remove w/ st=" + st)
                var term = [
                    st.subject,
                    st.predicate,
                    st.object,
                    st.graph
                ];
                for(var p = 0; p < 4; p++){
                    var c = this.canon(term[p]);
                    var h = this.id(c);
                    if (!this.index[p][h]) ;
                    else this.rdfArrayRemove(this.index[p][h], st);
                }
                this.rdfArrayRemove(this.statements, st);
                return this;
            }
        },
        {
            key: "removeStatements",
            value: function removeStatements(sts) {
                for(var i = 0; i < sts.length; i++)this.remove(sts[i]);
                return this;
            }
        },
        {
            key: "replaceWith",
            value: function replaceWith(big, small) {
                // log.debug("Replacing "+big+" with "+small) // this.id(@@
                var oldhash = this.id(big);
                var newhash = this.id(small);
                var moveIndex = function moveIndex(ix) {
                    var oldlist = ix[oldhash];
                    if (!oldlist) return; // none to move
                    var newlist = ix[newhash];
                    if (!newlist) ix[newhash] = oldlist;
                    else ix[newhash] = oldlist.concat(newlist);
                    delete ix[oldhash];
                };
                // the canonical one carries all the indexes
                for(var i = 0; i < 4; i++)moveIndex(this.index[i]);
                this.redirections[oldhash] = small;
                if (big.value) {
                    // @@JAMBO: must update redirections,aliases from sub-items, too.
                    if (!this.aliases[newhash]) this.aliases[newhash] = [];
                    this.aliases[newhash].push(big); // Back link
                    if (this.aliases[oldhash]) for(i = 0; i < this.aliases[oldhash].length; i++){
                        this.redirections[this.id(this.aliases[oldhash][i])] = small;
                        this.aliases[newhash].push(this.aliases[oldhash][i]);
                    }
                    this.add(small, this.sym("http://www.w3.org/2007/ont/link#uri"), big);
                    // If two things are equal, and one is requested, we should request the other.
                    if (this.fetcher) this.fetcher.nowKnownAs(big, small);
                }
                moveIndex(this.classActions);
                moveIndex(this.propertyActions);
                // log.debug("Equate done. "+big+" to be known as "+small)
                return true; // true means the statement does not need to be put in
            }
        },
        {
            key: "allAliases",
            value: function allAliases(x) {
                var a = this.aliases[this.id(this.canon(x))] || [];
                a.push(this.canon(x));
                return a;
            }
        },
        {
            key: "sameThings",
            value: function sameThings(x, y) {
                if (x.equals(y)) return true;
                var x1 = this.canon(x);
                //    alert('x1='+x1)
                if (!x1) return false;
                var y1 = this.canon(y);
                //    alert('y1='+y1); //@@
                if (!y1) return false;
                return x1.value === y1.value;
            }
        },
        {
            key: "setPrefixForURI",
            value: function setPrefixForURI(prefix, nsuri) {
                // TODO: This is a hack for our own issues, which ought to be fixed
                // post-release
                // See http://dig.csail.mit.edu/cgi-bin/roundup.cgi/$rdf/issue227
                if (prefix === "tab" && this.namespaces["tab"]) return;
                 // There are files around with long badly generated prefixes like this
                if (prefix.slice(0, 2) === "ns" || prefix.slice(0, 7) === "default") return;
                // remove any prefix that currently targets nsuri
                for(var existingPrefix in this.namespaces)if (this.namespaces[existingPrefix] == nsuri) delete this.namespaces[existingPrefix];
                this.namespaces[prefix] = nsuri;
            }
        },
        {
            key: "statementsMatching",
            value: function statementsMatching(subj, pred, obj, why, justOne) {
                // log.debug("Matching {"+subj+" "+pred+" "+obj+"}")
                var pat = [
                    subj,
                    pred,
                    obj,
                    why
                ];
                var pattern = [];
                var hash = [];
                var wild = []; // wildcards
                var given = []; // Not wild
                var p;
                var list;
                for(p = 0; p < 4; p++){
                    pattern[p] = this.canon((0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue(pat[p]));
                    if (!pattern[p]) wild.push(p);
                    else {
                        given.push(p);
                        hash[p] = this.id(pattern[p]);
                    }
                }
                if (given.length === 0) return this.statements;
                if (given.length === 1) {
                    // Easy too, we have an index for that
                    p = given[0];
                    list = this.index[p][hash[p]];
                    if (list && justOne) {
                        if (list.length > 1) list = list.slice(0, 1);
                    }
                    list = list || [];
                    return list;
                }
                // Now given.length is 2, 3 or 4.
                // We hope that the scale-free nature of the data will mean we tend to get
                // a short index in there somewhere!
                var best = 1e10; // really bad
                var iBest;
                var i;
                for(i = 0; i < given.length; i++){
                    p = given[i]; // Which part we are dealing with
                    list = this.index[p][hash[p]];
                    if (!list) return []; // No occurrences
                    if (list.length < best) {
                        best = list.length;
                        iBest = i; // (not p!)
                    }
                }
                // Ok, we have picked the shortest index but now we have to filter it
                var pBest = given[iBest];
                var possibles = this.index[pBest][hash[pBest]];
                var check = given.slice(0, iBest).concat(given.slice(iBest + 1)); // remove iBest
                var results = [];
                var parts = [
                    "subject",
                    "predicate",
                    "object",
                    "why"
                ];
                for(var j = 0; j < possibles.length; j++){
                    var st = possibles[j];
                    for(i = 0; i < check.length; i++){
                        // for each position to be checked
                        p = check[i];
                        if (!this.canon(st[parts[p]]).equals(pattern[p])) {
                            st = null;
                            break;
                        }
                    }
                    if (st != null) {
                        results.push(st);
                        if (justOne) break;
                    }
                }
                return results;
            }
        },
        {
            key: "uris",
            value: function uris(term) {
                var cterm = this.canon(term);
                var terms = this.aliases[this.id(cterm)];
                if (!cterm.value) return [];
                var res = [
                    cterm.value
                ];
                if (terms) for(var i = 0; i < terms.length; i++)res.push(terms[i].uri);
                return res;
            }
        },
        {
            key: "serialize",
            value: function serialize(base, contentType, provenance, options) {
                var _options;
                // override Formula.serialize to force the serializer namespace prefixes
                // to those of this IndexedFormula
                // if namespaces are explicitly passed in options, let them override the existing namespaces in this formula
                var namespaces = (_options = options) !== null && _options !== void 0 && _options.namespaces ? $6f5c135260474402$var$_objectSpread($6f5c135260474402$var$_objectSpread({}, this.namespaces), options.namespaces) : $6f5c135260474402$var$_objectSpread({}, this.namespaces);
                options = $6f5c135260474402$var$_objectSpread($6f5c135260474402$var$_objectSpread({}, options || {}), {}, {
                    namespaces: namespaces
                });
                return (0, $957a454a8ab6ebde$export$2e2bcd8739ae039)(provenance, this, base, contentType, undefined, options);
            }
        }
    ], [
        {
            key: "defaultGraphURI",
            get: function get() {
                return 0, $471ea8b4e912e4b1$export$fb7535ed90405da0;
            }
        }
    ]);
    return IndexedFormula;
}((0, $31157af6e1e82257$export$2e2bcd8739ae039));
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($6f5c135260474402$export$2e2bcd8739ae039, "handleRDFType", void 0);
$6f5c135260474402$export$2e2bcd8739ae039.handleRDFType = $6f5c135260474402$var$handleRDFType;



var $kAE07 = parcelRequire("kAE07");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $41YNz = parcelRequire("41YNz");

var $4Q80K = parcelRequire("4Q80K");




function $d44594c351a1dfa1$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $d44594c351a1dfa1$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $d44594c351a1dfa1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d44594c351a1dfa1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d44594c351a1dfa1$var$_arrayLikeToArray(o, minLen);
}
function $d44594c351a1dfa1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $d44594c351a1dfa1$var$RDF = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
function $d44594c351a1dfa1$export$6468f4bab59ad3f(store, x, y, doc) {
    // console.log(`substituteInDoc put ${x} for ${y} in ${doc}}`)
    var _iterator = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(y, null, null, doc)), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var quad = _step.value;
            var newStatement = new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(x, quad.predicate, quad.object, doc);
            store.remove(quad);
            store.add(newStatement);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(null, y, null, doc)), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _quad = _step2.value;
            store.remove(_quad);
            // console.log(`  substituteInDoc predicate ${x} in ${quad}}`)
            store.add(new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(_quad.subject, x, _quad.object, doc));
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var _iterator3 = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(null, null, y, doc)), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _quad2 = _step3.value;
            store.remove(_quad2);
            store.add(new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(_quad2.subject, _quad2.predicate, x, doc));
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $d44594c351a1dfa1$export$db0e3a58b44fdcbc(store, doc) {
    var x = $d44594c351a1dfa1$var$RDF("nil");
    var _iterator4 = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(x, null, null, doc)), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var quad = _step4.value;
            store.remove(quad);
            var y = new (0, $619d91631affbf30$export$2e2bcd8739ae039)();
            store.add(new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(y, quad.predicate, quad.object, doc));
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
    var _iterator5 = $d44594c351a1dfa1$var$_createForOfIteratorHelper(store.statementsMatching(null, null, x, doc)), _step5;
    try {
        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
            var _quad3 = _step5.value;
            if (!_quad3.predicate.sameTerm($d44594c351a1dfa1$var$RDF("rest"))) {
                // If not a tail
                store.remove(_quad3);
                var _y = new (0, $619d91631affbf30$export$2e2bcd8739ae039)();
                store.add(new (0, $00d766c69dbb3a6e$export$2e2bcd8739ae039)(_quad3.subject, _quad3.predicate, _y, doc));
            }
        }
    } catch (err) {
        _iterator5.e(err);
    } finally{
        _iterator5.f();
    }
}
function $d44594c351a1dfa1$export$c264eb27c0279bcd(store, doc // Do whole store?
) {
    function preceding(ele, listSoFar, trash) {
        var rests = store.statementsMatching(ele, $d44594c351a1dfa1$var$RDF("rest"), null, doc);
        if (rests.length !== 1) throw new Error("Bad list structure: no rest at ".concat(ele));
        var firsts = store.statementsMatching(ele, $d44594c351a1dfa1$var$RDF("first"), null, doc);
        if (firsts.length !== 1) throw new Error("Bad list structure: rest but ".concat(firsts.length, " firsts at ").concat(ele));
        var value = firsts[0].object;
        var total = [
            value
        ].concat(listSoFar);
        // console.log('  List now is: ', total)
        var totalTrash = trash.concat(rests).concat(firsts);
        var pres = store.statementsMatching(null, $d44594c351a1dfa1$var$RDF("rest"), ele, doc);
        if (pres.length === 0) {
            // Head of the list
            var newList = new (0, $619d91631affbf30$export$2e2bcd8739ae039)(total);
            store.remove(totalTrash);
            // Replace old list with new list:
            $d44594c351a1dfa1$export$6468f4bab59ad3f(store, newList, ele, doc);
            return;
        }
        if (pres.length !== 1) throw new Error("Bad list structure: ".concat(pres.length, " pres at ").concat(ele));
        var pre = pres[0].subject;
        if (pre.termType !== "BlankNode") throw new Error("Bad list element node ".concat(pre, " type: ").concat(pre.termType, " "));
        preceding(pre, total, totalTrash);
        return;
    }
    $d44594c351a1dfa1$export$db0e3a58b44fdcbc(store, doc); // lone ones only
    var tails = store.statementsMatching(null, $d44594c351a1dfa1$var$RDF("rest"), $d44594c351a1dfa1$var$RDF("nil"), doc);
    tails.forEach(function(tail) {
        if (tail.subject.termType !== "BlankNode") throw new Error("Bad list element node ".concat(tail.subject, " type: ").concat(tail.subject.termType, " "));
        preceding(tail.subject, [], []);
    });
}


function $220f89846e1c7272$var$hexify(str) {
    // also used in parser
    return encodeURI(str);
}
var $220f89846e1c7272$var$Utf8 = {
    // public method for url encoding
    encode: function encode(string) {
        string = string.replace(/\r\n/g, "\n");
        var utftext = "";
        for(var n = 0; n < string.length; n++){
            var c = string.charCodeAt(n);
            if (c < 128) utftext += String.fromCharCode(c);
            else if (c > 127 && c < 2048) {
                utftext += String.fromCharCode(c >> 6 | 192);
                utftext += String.fromCharCode(c & 63 | 128);
            } else {
                utftext += String.fromCharCode(c >> 12 | 224);
                utftext += String.fromCharCode(c >> 6 & 63 | 128);
                utftext += String.fromCharCode(c & 63 | 128);
            }
        }
        return utftext;
    },
    // public method for url decoding
    decode: function decode(utftext) {
        var string = "";
        var i = 0;
        while(i < utftext.length){
            var c = utftext.charCodeAt(i);
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if (c > 191 && c < 224) {
                string += String.fromCharCode((c & 31) << 6 | utftext.charCodeAt(i + 1) & 63);
                i += 2;
            } else {
                string += String.fromCharCode((c & 15) << 12 | (utftext.charCodeAt(i + 1) & 63) << 6 | utftext.charCodeAt(i + 2) & 63);
                i += 3;
            }
        }
        return string;
    }
}; // Things we need to define to make converted pythn code work in js
// environment of $rdf
var $220f89846e1c7272$var$RDFSink_forSomeSym = "http://www.w3.org/2000/10/swap/log#forSome";
var $220f89846e1c7272$var$RDFSink_forAllSym = "http://www.w3.org/2000/10/swap/log#forAll";
var $220f89846e1c7272$var$Logic_NS = "http://www.w3.org/2000/10/swap/log#";
//  pyjs seems to reference runtime library which I didn't find
var $220f89846e1c7272$var$pyjslib_Tuple = function pyjslib_Tuple(theList) {
    return theList;
};
var $220f89846e1c7272$var$pyjslib_List = function pyjslib_List(theList) {
    return theList;
};
var $220f89846e1c7272$var$pyjslib_Dict = function pyjslib_Dict(listOfPairs) {
    if (listOfPairs.length > 0) throw "missing.js: oops nnonempty dict not imp";
    return [];
};
var $220f89846e1c7272$var$pyjslib_len = function pyjslib_len(s) {
    return s.length;
};
var $220f89846e1c7272$var$pyjslib_slice = function pyjslib_slice(str, i, j) {
    if (typeof str.slice == "undefined") throw "@@ mising.js: No .slice function for " + str + " of type " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(str);
    if (typeof j == "undefined" || j == null) return str.slice(i);
    return str.slice(i, j); // @ exactly the same spec?
};
var $220f89846e1c7272$var$StopIteration = Error("dummy error stop iteration");
var $220f89846e1c7272$var$pyjslib_Iterator = function pyjslib_Iterator(theList) {
    this.last = 0;
    this.li = theList;
    this.next = function() {
        if (this.last == this.li.length) throw $220f89846e1c7272$var$StopIteration;
        return this.li[this.last++];
    };
    return this;
};
var $220f89846e1c7272$var$ord = function ord(str) {
    return str.charCodeAt(0);
};
var $220f89846e1c7272$var$string_find = function string_find(str, s) {
    return str.indexOf(s);
};
var $220f89846e1c7272$var$assertFudge = function assertFudge(condition, desc) {
    if (condition) return;
    if (desc) throw "python Assertion failed: " + desc;
    throw "(python) Assertion failed.";
};
var $220f89846e1c7272$var$stringFromCharCode = function stringFromCharCode(uesc) {
    return String.fromCharCode(uesc);
};
String.prototype.encode = function(encoding) {
    if (encoding != "utf-8") throw "UTF8_converter: can only do utf-8";
    return $220f89846e1c7272$var$Utf8.encode(this);
};
String.prototype.decode = function(encoding) {
    if (encoding != "utf-8") throw "UTF8_converter: can only do utf-8";
    //return Utf8.decode(this);
    return this;
};
var $220f89846e1c7272$var$uripath_join = function uripath_join(base, given) {
    return $4Q80K.join(given, base); // sad but true
};
var $220f89846e1c7272$var$becauseSubexpression = null; // No reason needed
var $220f89846e1c7272$var$diag_tracking = 0;
var $220f89846e1c7272$var$diag_chatty_flag = 0;
var $220f89846e1c7272$var$diag_progress = function diag_progress(str) {};
// why_BecauseOfData = function(doc, reason) { return doc };
var $220f89846e1c7272$var$RDF_type_URI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
var $220f89846e1c7272$var$RDF_nil_URI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil";
var $220f89846e1c7272$var$DAML_sameAs_URI = "http://www.w3.org/2002/07/owl#sameAs";
/*
function SyntaxError(details) {
    return new __SyntaxError(details);
}
*/ function $220f89846e1c7272$var$__SyntaxError(details) {
    this.details = details;
}
/*

$Id: n3parser.js 14561 2008-02-23 06:37:26Z kennyluck $

HAND EDITED FOR CONVERSION TO JAVASCRIPT

This module implements a Nptation3 parser, and the final
part of a notation3 serializer.

See also:

Notation 3
http://www.w3.org/DesignIssues/Notation3

Closed World Machine - and RDF Processor
http://www.w3.org/2000/10/swap/cwm

To DO: See also "@@" in comments

- Clean up interfaces
______________________________________________

Module originally by Dan Connolly, includeing notation3
parser and RDF generator. TimBL added RDF stream model
and N3 generation, replaced stream model with use
of common store/formula API.  Yosi Scharf developped
the module, including tests and test harness.

*/ var $220f89846e1c7272$var$ADDED_HASH = "#";
var $220f89846e1c7272$var$LOG_implies_URI = "http://www.w3.org/2000/10/swap/log#implies";
var $220f89846e1c7272$var$INTEGER_DATATYPE = "http://www.w3.org/2001/XMLSchema#integer";
var $220f89846e1c7272$var$FLOAT_DATATYPE = "http://www.w3.org/2001/XMLSchema#double";
var $220f89846e1c7272$var$DECIMAL_DATATYPE = "http://www.w3.org/2001/XMLSchema#decimal";
var $220f89846e1c7272$var$DATE_DATATYPE = "http://www.w3.org/2001/XMLSchema#date";
var $220f89846e1c7272$var$DATETIME_DATATYPE = "http://www.w3.org/2001/XMLSchema#dateTime";
var $220f89846e1c7272$var$BOOLEAN_DATATYPE = "http://www.w3.org/2001/XMLSchema#boolean";
var $220f89846e1c7272$var$option_noregen = 0;
var $220f89846e1c7272$var$_notQNameChars = "	\r\n !\"#$%&'()*.,+/;<=>?@[\\]^`{|}~";
var $220f89846e1c7272$var$_notNameChars = $220f89846e1c7272$var$_notQNameChars + ":";
var $220f89846e1c7272$var$_rdfns = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
var $220f89846e1c7272$var$N3CommentCharacter = "#";
var $220f89846e1c7272$var$eol = new RegExp("^[ \\t]*(#[^\\n]*)?\\r?\\n", "g");
var $220f89846e1c7272$var$eof = new RegExp("^[ \\t]*(#[^\\n]*)?$", "g");
var $220f89846e1c7272$var$ws = new RegExp("^[ \\t]*", "g");
var $220f89846e1c7272$var$signed_integer = new RegExp("^[-+]?[0-9]+", "g");
var $220f89846e1c7272$var$number_syntax = new RegExp("^([-+]?[0-9]+)(\\.[0-9]+)?(e[-+]?[0-9]+)?", "g");
var $220f89846e1c7272$var$datetime_syntax = new RegExp("^[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9](T[0-9][0-9]:[0-9][0-9](:[0-9][0-9](\\.[0-9]*)?)?)?Z?");
var $220f89846e1c7272$var$digitstring = new RegExp("^[0-9]+", "g");
var $220f89846e1c7272$var$interesting = new RegExp('[\\\\\\r\\n\\"]', "g");
var $220f89846e1c7272$var$langcode = new RegExp("^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*", "g");
function $220f89846e1c7272$var$createSinkParser(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why) {
    return new $220f89846e1c7272$export$17576c3d9720d783(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why);
}
var $220f89846e1c7272$export$2e2bcd8739ae039 = $220f89846e1c7272$var$createSinkParser;
var $220f89846e1c7272$export$17576c3d9720d783 = /*#__PURE__*/ function() {
    function SinkParser(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags, why) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, SinkParser);
        if (typeof openFormula == "undefined") openFormula = null;
        if (typeof thisDoc == "undefined") thisDoc = "";
        if (typeof baseURI == "undefined") baseURI = null;
        if (typeof genPrefix == "undefined") genPrefix = "";
        if (typeof metaURI == "undefined") metaURI = null;
        if (typeof flags == "undefined") flags = "";
        if (typeof why == "undefined") why = null;
        /*
    note: namespace names should *not* end in #;
    the # will get added during qname processing */ this._bindings = new $220f89846e1c7272$var$pyjslib_Dict([]);
        this._flags = flags;
        if (thisDoc != "") {
            $220f89846e1c7272$var$assertFudge(thisDoc.indexOf(":") >= 0, "Document URI not absolute: " + thisDoc);
            this._bindings[""] = thisDoc + "#";
        }
        this._store = store;
        if (genPrefix) store.setGenPrefix(genPrefix);
        this._thisDoc = thisDoc;
        this.source = store.sym(thisDoc);
        this.lines = 0;
        this.statementCount = 0;
        this.hasNil = false;
        this.startOfLine = 0;
        this.previousLine = 0;
        this._genPrefix = genPrefix;
        this.keywords = new $220f89846e1c7272$var$pyjslib_List([
            "a",
            "this",
            "bind",
            "has",
            "is",
            "of",
            "true",
            "false"
        ]);
        this.keywordsSet = 0;
        this._anonymousNodes = new $220f89846e1c7272$var$pyjslib_Dict([]);
        this._variables = new $220f89846e1c7272$var$pyjslib_Dict([]);
        this._parentVariables = new $220f89846e1c7272$var$pyjslib_Dict([]);
        this._reason = why;
        this._reason2 = null;
        if ($220f89846e1c7272$var$diag_tracking) this._reason2 = why_BecauseOfData(store.sym(thisDoc), this._reason);
        if (baseURI) this._baseURI = baseURI;
        else if (thisDoc) this._baseURI = thisDoc;
        else this._baseURI = null;
        $220f89846e1c7272$var$assertFudge(!this._baseURI || this._baseURI.indexOf(":") >= 0);
        if (!this._genPrefix) {
            if (this._thisDoc) this._genPrefix = this._thisDoc + "#_g";
            else this._genPrefix = RDFSink_uniqueURI();
        }
        if (openFormula == null) {
            if (this._thisDoc) this._formula = store.formula(thisDoc + "#_formula");
            else this._formula = store.formula();
        } else this._formula = openFormula;
        this._context = this._formula;
        this._parentContext = null;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(SinkParser, [
        {
            key: "here",
            value: function here(i) {
                return this._genPrefix + "_L" + this.lines + "C" + (i - this.startOfLine + 1);
            }
        },
        {
            key: "formula",
            value: function formula() {
                return this._formula;
            }
        },
        {
            key: "loadStream",
            value: function loadStream(stream) {
                return this.loadBuf(stream.read());
            }
        },
        {
            key: "loadBuf",
            value: function loadBuf(buf) {
                /*
      Parses a buffer and returns its top level formula*/ this.startDoc();
                this.feed(buf);
                return this.endDoc();
            }
        },
        {
            key: "feed",
            value: function feed(octets) {
                /*
      Feed an octet stream tothe parser
       if BadSyntax is raised, the string
      passed in the exception object is the
      remainder after any statements have been parsed.
      So if there is more data to feed to the
      parser, it should be straightforward to recover.*/ var str = octets.decode("utf-8");
                var i = 0;
                while(i >= 0){
                    var j = this.skipSpace(str, i);
                    if (j < 0) return;
                    var i = this.directiveOrStatement(str, j);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected directive or statement");
                }
            }
        },
        {
            key: "directiveOrStatement",
            value: function directiveOrStatement(str, h) {
                var i = this.skipSpace(str, h);
                if (i < 0) return i;
                var j = this.directive(str, i);
                if (j >= 0) return this.checkDot(str, j);
                var j = this.statement(str, i);
                if (j >= 0) return this.checkDot(str, j);
                return j;
            }
        },
        {
            key: "tok",
            value: function tok(_tok, str, i) {
                /*
      Check for keyword.  Space must have been stripped on entry and
      we must not be at end of file.*/ var whitespace = "	\n\v\f\r ";
                if (str.slice(i, i + 1) == "@") var i = i + 1;
                else {
                    if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this.keywords, _tok) < 0) return -1;
                }
                var k = i + $220f89846e1c7272$var$pyjslib_len(_tok);
                if (str.slice(i, k) == _tok && $220f89846e1c7272$var$_notQNameChars.indexOf(str.charAt(k)) >= 0) return k;
                else return -1;
            }
        },
        {
            key: "directive",
            value: function directive(str, i) {
                var j = this.skipSpace(str, i);
                if (j < 0) return j;
                var res = new $220f89846e1c7272$var$pyjslib_List([]);
                var j = this.tok("bind", str, i);
                if (j > 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "keyword bind is obsolete: use @prefix");
                var j = this.tok("keywords", str, i);
                if (j > 0) {
                    var i = this.commaSeparatedList(str, j, res, false);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "'@keywords' needs comma separated list of words");
                    this.setKeywords($220f89846e1c7272$var$pyjslib_slice(res, null, null));
                    if ($220f89846e1c7272$var$diag_chatty_flag > 80) $220f89846e1c7272$var$diag_progress("Keywords ", this.keywords);
                    return i;
                }
                var j = this.tok("forAll", str, i);
                if (j > 0) {
                    var i = this.commaSeparatedList(str, j, res, true);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Bad variable list after @forAll");
                    var __x = new $220f89846e1c7272$var$pyjslib_Iterator(res);
                    try {
                        while(true){
                            var x = __x.next();
                            if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this._variables, x) < 0 || (0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this._parentVariables, x) >= 0) this._variables[x] = this._context.newUniversal(x);
                        }
                    } catch (e) {
                        if (e != $220f89846e1c7272$var$StopIteration) throw e;
                    }
                    return i;
                }
                var j = this.tok("forSome", str, i);
                if (j > 0) {
                    var i = this.commaSeparatedList(str, j, res, this.uri_ref2);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Bad variable list after @forSome");
                    var __x = new $220f89846e1c7272$var$pyjslib_Iterator(res);
                    try {
                        while(true){
                            var x = __x.next();
                            this._context.declareExistential(x);
                        }
                    } catch (e) {
                        if (e != $220f89846e1c7272$var$StopIteration) throw e;
                    }
                    return i;
                }
                var j = this.tok("prefix", str, i);
                if (j >= 0) {
                    var t = new $220f89846e1c7272$var$pyjslib_List([]);
                    var i = this.qname(str, j, t);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected qname after @prefix");
                    var j = this.uri_ref2(str, i, t);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected <uriref> after @prefix _qname_");
                    var ns = t[1].uri;
                    if (this._baseURI) var ns = $220f89846e1c7272$var$uripath_join(this._baseURI, ns);
                    else $220f89846e1c7272$var$assertFudge(ns.indexOf(":") >= 0, "With no base URI, cannot handle relative URI for NS");
                    $220f89846e1c7272$var$assertFudge(ns.indexOf(":") >= 0);
                    this._bindings[t[0][0]] = ns;
                    this.bind(t[0][0], $220f89846e1c7272$var$hexify(ns));
                    return j;
                }
                var j = this.tok("base", str, i);
                if (j >= 0) {
                    var t = new $220f89846e1c7272$var$pyjslib_List([]);
                    var i = this.uri_ref2(str, j, t);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected <uri> after @base ");
                    var ns = t[0].uri;
                    if (this._baseURI) var ns = $220f89846e1c7272$var$uripath_join(this._baseURI, ns);
                    else throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "With no previous base URI, cannot use relative URI in @base  <" + ns + ">");
                    $220f89846e1c7272$var$assertFudge(ns.indexOf(":") >= 0);
                    this._baseURI = ns;
                    return i;
                }
                return -1;
            }
        },
        {
            key: "bind",
            value: function bind(qn, uri) {
                if (qn == "") ;
                else this._store.setPrefixForURI(qn, uri);
            }
        },
        {
            key: "setKeywords",
            value: function setKeywords(k) {
                /*
      Takes a list of strings*/ if (k == null) this.keywordsSet = 0;
                else {
                    this.keywords = k;
                    this.keywordsSet = 1;
                }
            }
        },
        {
            key: "startDoc",
            value: function startDoc() {}
        },
        {
            key: "endDoc",
            value: /* Signal end of document and stop parsing. returns formula */ function endDoc() {
                if (this.hasNil && this._store.rdfFactory.supports["COLLECTIONS"]) (0, $d44594c351a1dfa1$export$c264eb27c0279bcd)(this._store, this.source);
                return this._formula;
            }
        },
        {
            key: "makeStatement",
            value: function makeStatement(quad) {
                quad[0].add(quad[2], quad[1], quad[3], this.source);
                if (quad[2].uri && quad[2].uri === $220f89846e1c7272$var$RDF_nil_URI || quad[3].uri && quad[3].uri === $220f89846e1c7272$var$RDF_nil_URI) this.hasNil = true;
                this.statementCount += 1;
            }
        },
        {
            key: "statement",
            value: function statement(str, i) {
                var r = new $220f89846e1c7272$var$pyjslib_List([]);
                var i = this.object(str, i, r);
                if (i < 0) return i;
                var j = this.property_list(str, i, r[0]);
                if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected propertylist");
                return j;
            }
        },
        {
            key: "subject",
            value: function subject(str, i, res) {
                return this.item(str, i, res);
            }
        },
        {
            key: "verb",
            value: function verb(str, i, res) {
                /*
      has _prop_
      is _prop_ of
      a
      =
      _prop_
      >- prop ->
      <- prop -<
      _operator_*/ var j = this.skipSpace(str, i);
                if (j < 0) return j;
                var r = new $220f89846e1c7272$var$pyjslib_List([]);
                var j = this.tok("has", str, i);
                if (j >= 0) {
                    var i = this.prop(str, j, r);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected property after 'has'");
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        r[0]
                    ]));
                    return i;
                }
                var j = this.tok("is", str, i);
                if (j >= 0) {
                    var i = this.prop(str, j, r);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected <property> after 'is'");
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "End of file found, expected property after 'is'");
                    var i = j;
                    var j = this.tok("of", str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected 'of' after 'is' <prop>");
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "<-",
                        r[0]
                    ]));
                    return j;
                }
                var j = this.tok("a", str, i);
                if (j >= 0) {
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        this._store.sym($220f89846e1c7272$var$RDF_type_URI)
                    ]));
                    return j;
                }
                if (str.slice(i, i + 2) == "<=") {
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "<-",
                        this._store.sym($220f89846e1c7272$var$Logic_NS + "implies")
                    ]));
                    return i + 2;
                }
                if (str.slice(i, i + 1) == "=") {
                    if (str.slice(i + 1, i + 2) == ">") {
                        res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                            "->",
                            this._store.sym($220f89846e1c7272$var$Logic_NS + "implies")
                        ]));
                        return i + 2;
                    }
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        this._store.sym($220f89846e1c7272$var$DAML_sameAs_URI)
                    ]));
                    return i + 1;
                }
                if (str.slice(i, i + 2) == ":=") {
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        $220f89846e1c7272$var$Logic_NS + "becomes"
                    ]));
                    return i + 2;
                }
                var j = this.prop(str, i, r);
                if (j >= 0) {
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        "->",
                        r[0]
                    ]));
                    return j;
                }
                if (str.slice(i, i + 2) == ">-" || str.slice(i, i + 2) == "<-") throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, ">- ... -> syntax is obsolete.");
                return -1;
            }
        },
        {
            key: "prop",
            value: function prop(str, i, res) {
                return this.item(str, i, res);
            }
        },
        {
            key: "item",
            value: function item(str, i, res) {
                return this.path(str, i, res);
            }
        },
        {
            key: "blankNode",
            value: function blankNode(uri) {
                return this._context.bnode(uri, this._reason2);
            }
        },
        {
            key: "path",
            value: function path(str, i, res) {
                /*
      Parse the path production.
      */ var j = this.nodeOrLiteral(str, i, res);
                if (j < 0) return j;
                while("!^.".indexOf(str.slice(j, j + 1)) >= 0){
                    var ch = str.slice(j, j + 1);
                    if (ch == ".") {
                        var ahead = str.slice(j + 1, j + 2);
                        if (!ahead || $220f89846e1c7272$var$_notNameChars.indexOf(ahead) >= 0 && ":?<[{(".indexOf(ahead) < 0) break;
                    }
                    var subj = res.pop();
                    var obj = this.blankNode(this.here(j));
                    var j = this.node(str, j + 1, res);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "EOF found in middle of path syntax");
                    var pred = res.pop();
                    if (ch == "^") this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                        this._context,
                        pred,
                        obj,
                        subj
                    ]));
                    else this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                        this._context,
                        pred,
                        subj,
                        obj
                    ]));
                    res.push(obj);
                }
                return j;
            }
        },
        {
            key: "anonymousNode",
            value: function anonymousNode(ln) {
                /*
      Remember or generate a term for one of these _: anonymous nodes*/ var term = this._anonymousNodes[ln];
                if (term) return term;
                var term = this._store.bnode(ln);
                // var term = this._store.bnode(this._context, this._reason2); eh?
                this._anonymousNodes[ln] = term;
                return term;
            }
        },
        {
            key: "node",
            value: function node(str, i, res, subjectAlready) {
                if (typeof subjectAlready == "undefined") subjectAlready = null;
                /*
      Parse the <node> production.
      Space is now skipped once at the beginning
      instead of in multipe calls to self.skipSpace().
      */ var subj = subjectAlready;
                var j = this.skipSpace(str, i);
                if (j < 0) return j;
                var i = j;
                var ch = str.slice(i, i + 1);
                if (ch == "[") {
                    var bnodeID = this.here(i);
                    var j = this.skipSpace(str, i + 1);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF after '['");
                    if (str.slice(j, j + 1) == "=") {
                        var i = j + 1;
                        var objs = new $220f89846e1c7272$var$pyjslib_List([]);
                        var j = this.objectList(str, i, objs);
                        if (j >= 0) {
                            var subj = objs[0];
                            if ($220f89846e1c7272$var$pyjslib_len(objs) > 1) {
                                var __obj = new $220f89846e1c7272$var$pyjslib_Iterator(objs);
                                try {
                                    while(true){
                                        var obj = __obj.next();
                                        this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                                            this._context,
                                            this._store.sym($220f89846e1c7272$var$DAML_sameAs_URI),
                                            subj,
                                            obj
                                        ]));
                                    }
                                } catch (e) {
                                    if (e != $220f89846e1c7272$var$StopIteration) throw e;
                                }
                            }
                            var j = this.skipSpace(str, j);
                            if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF when objectList expected after [ = ");
                            if (str.slice(j, j + 1) == ";") var j = j + 1;
                        } else throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "objectList expected after [= ");
                    }
                    if (subj == null) var subj = this.blankNode(bnodeID);
                    var i = this.property_list(str, j, subj);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "property_list expected");
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF when ']' expected after [ <propertyList>");
                    if (str.slice(j, j + 1) != "]") throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "']' expected");
                    res.push(subj);
                    return j + 1;
                }
                if (ch == "{") {
                    var ch2 = str.slice(i + 1, i + 2);
                    if (ch2 == "$") {
                        i += 1;
                        var j = i + 1;
                        var mylist = new $220f89846e1c7272$var$pyjslib_List([]);
                        var first_run = true;
                        while(true){
                            var i = this.skipSpace(str, j);
                            if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "needed '$}', found end.");
                            if (str.slice(i, i + 2) == "$}") {
                                var j = i + 2;
                                break;
                            }
                            if (!first_run) {
                                if (str.slice(i, i + 1) == ",") i += 1;
                                else throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected: ','");
                            } else var first_run = false;
                            var item = new $220f89846e1c7272$var$pyjslib_List([]);
                            var j = this.item(str, i, item);
                            if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected item in set or '$}'");
                            mylist.push(item[0]);
                        }
                        res.push(this._store.newSet(mylist, this._context));
                        return j;
                    } else {
                        var j = i + 1;
                        var oldParentContext = this._parentContext;
                        this._parentContext = this._context;
                        var parentAnonymousNodes = this._anonymousNodes;
                        var grandParentVariables = this._parentVariables;
                        this._parentVariables = this._variables;
                        this._anonymousNodes = new $220f89846e1c7272$var$pyjslib_Dict([]);
                        this._variables = this._variables.slice();
                        var reason2 = this._reason2;
                        this._reason2 = $220f89846e1c7272$var$becauseSubexpression;
                        if (subj == null) var subj = this._store.formula();
                        this._context = subj;
                        while(true){
                            var i = this.skipSpace(str, j);
                            if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "needed '}', found end.");
                            if (str.slice(i, i + 1) == "}") {
                                var j = i + 1;
                                break;
                            }
                            var j = this.directiveOrStatement(str, i);
                            if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected statement or '}'");
                        }
                        this._anonymousNodes = parentAnonymousNodes;
                        this._variables = this._parentVariables;
                        this._parentVariables = grandParentVariables;
                        this._context = this._parentContext;
                        this._reason2 = reason2;
                        this._parentContext = oldParentContext;
                        res.push(subj.close());
                        return j;
                    }
                }
                if (ch == "(") {
                    var thing_type = this._store.list;
                    var ch2 = str.slice(i + 1, i + 2);
                    if (ch2 == "$") {
                        var thing_type = this._store.newSet;
                        i += 1;
                    }
                    var j = i + 1;
                    var mylist = new $220f89846e1c7272$var$pyjslib_List([]);
                    while(true){
                        var i = this.skipSpace(str, j);
                        if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "needed ')', found end.");
                        if (str.slice(i, i + 1) == ")") {
                            var j = i + 1;
                            break;
                        }
                        var item = new $220f89846e1c7272$var$pyjslib_List([]);
                        var j = this.item(str, i, item);
                        if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "expected item in list or ')'");
                        mylist.push(item[0]);
                    }
                    res.push(thing_type(mylist, this._context));
                    return j;
                }
                var j = this.tok("this", str, i);
                if (j >= 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Keyword 'this' was ancient N3. Now use @forSome and @forAll keywords.");
                var j = this.tok("true", str, i);
                if (j >= 0) {
                    res.push(true);
                    return j;
                }
                var j = this.tok("false", str, i);
                if (j >= 0) {
                    res.push(false);
                    return j;
                }
                if (subj == null) {
                    var j = this.uri_ref2(str, i, res);
                    if (j >= 0) return j;
                }
                return -1;
            }
        },
        {
            key: "property_list",
            value: function property_list(str, i, subj) {
                /*
      Parse property list
      Leaves the terminating punctuation in the buffer
      */ while(true){
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF found when expected verb in property list");
                    if (str.slice(j, j + 2) == ":-") {
                        var i = j + 2;
                        var res = new $220f89846e1c7272$var$pyjslib_List([]);
                        var j = this.node(str, i, res, subj);
                        if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "bad {} or () or [] node after :- ");
                        var i = j;
                        continue;
                    }
                    var i = j;
                    var v = new $220f89846e1c7272$var$pyjslib_List([]);
                    var j = this.verb(str, i, v);
                    if (j <= 0) return i;
                    var objs = new $220f89846e1c7272$var$pyjslib_List([]);
                    var i = this.objectList(str, j, objs);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "objectList expected");
                    var __obj = new $220f89846e1c7272$var$pyjslib_Iterator(objs);
                    try {
                        while(true){
                            var obj = __obj.next();
                            var pairFudge = v[0];
                            var dir = pairFudge[0];
                            var sym = pairFudge[1];
                            if (dir == "->") this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                                this._context,
                                sym,
                                subj,
                                obj
                            ]));
                            else this.makeStatement(new $220f89846e1c7272$var$pyjslib_Tuple([
                                this._context,
                                sym,
                                obj,
                                subj
                            ]));
                        }
                    } catch (e) {
                        if (e != $220f89846e1c7272$var$StopIteration) throw e;
                    }
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "EOF found in list of objects");
                    if (str.slice(i, i + 1) != ";") return i;
                    var i = i + 1;
                }
            }
        },
        {
            key: "commaSeparatedList",
            value: function commaSeparatedList(str, j, res, ofUris) {
                /*
      return value: -1 bad syntax; >1 new position in str
      res has things found appended
       Used to use a final value of the function to be called, e.g. this.bareWord
      but passing the function didn't work fo js converion pyjs
      */ var i = this.skipSpace(str, j);
                if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "EOF found expecting comma sep list");
                if (str.charAt(i) == ".") return j;
                if (ofUris) var i = this.uri_ref2(str, i, res);
                else var i = this.bareWord(str, i, res);
                if (i < 0) return -1;
                while(true){
                    var j = this.skipSpace(str, i);
                    if (j < 0) return j;
                    var ch = str.slice(j, j + 1);
                    if (ch != ",") {
                        if (ch != ".") return -1;
                        return j;
                    }
                    if (ofUris) var i = this.uri_ref2(str, j + 1, res);
                    else var i = this.bareWord(str, j + 1, res);
                    if (i < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "bad list content");
                }
            }
        },
        {
            key: "objectList",
            value: function objectList(str, i, res) {
                var i = this.object(str, i, res);
                if (i < 0) return -1;
                while(true){
                    var j = this.skipSpace(str, i);
                    if (j < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "EOF found after object");
                    if (str.slice(j, j + 1) != ",") return j;
                    var i = this.object(str, j + 1, res);
                    if (i < 0) return i;
                }
            }
        },
        {
            key: "checkDot",
            value: function checkDot(str, i) {
                var j = this.skipSpace(str, i);
                if (j < 0) return j;
                if (str.slice(j, j + 1) == ".") return j + 1;
                if (str.slice(j, j + 1) == "}") return j;
                if (str.slice(j, j + 1) == "]") return j;
                throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "expected '.' or '}' or ']' at end of statement");
            }
        },
        {
            key: "uri_ref2",
            value: function uri_ref2(str, i, res) {
                /*
      Generate uri from n3 representation.
       Note that the RDF convention of directly concatenating
      NS and local name is now used though I prefer inserting a '#'
      to make the namesapces look more like what XML folks expect.
      */ var qn = new $220f89846e1c7272$var$pyjslib_List([]);
                var j = this.qname(str, i, qn);
                if (j >= 0) {
                    var pairFudge = qn[0];
                    var pfx = pairFudge[0];
                    var ln = pairFudge[1];
                    if (pfx == null) {
                        $220f89846e1c7272$var$assertFudge(0, "not used?");
                        var ns = this._baseURI + $220f89846e1c7272$var$ADDED_HASH;
                    } else {
                        var ns = this._bindings[pfx];
                        if (!ns) {
                            if (pfx == "_") {
                                res.push(this.anonymousNode(ln));
                                return j;
                            }
                            throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Prefix " + pfx + " not bound.");
                        }
                    }
                    var symb = this._store.sym(ns + ln);
                    if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this._variables, symb) >= 0) res.push(this._variables[symb]);
                    else res.push(symb);
                    return j;
                }
                var i = this.skipSpace(str, i);
                if (i < 0) return -1;
                if (str.charAt(i) == "?") {
                    var v = new $220f89846e1c7272$var$pyjslib_List([]);
                    var j = this.variable(str, i, v);
                    if (j > 0) {
                        res.push(v[0]);
                        return j;
                    }
                    return -1;
                } else if (str.charAt(i) == "<") {
                    var i = i + 1;
                    var st = i;
                    while(i < $220f89846e1c7272$var$pyjslib_len(str)){
                        if (str.charAt(i) == ">") {
                            var uref = str.slice(st, i);
                            if (this._baseURI) var uref = $220f89846e1c7272$var$uripath_join(this._baseURI, uref);
                            else $220f89846e1c7272$var$assertFudge(uref.indexOf(":") >= 0, "With no base URI, cannot deal with relative URIs");
                            if (str.slice(i - 1, i) == "#" && !($220f89846e1c7272$var$pyjslib_slice(uref, -1, null) == "#")) var uref = uref + "#";
                            var symb = this._store.sym(uref);
                            if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this._variables, symb) >= 0) res.push(this._variables[symb]);
                            else res.push(symb);
                            return i + 1;
                        }
                        var i = i + 1;
                    }
                    throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "unterminated URI reference");
                } else if (this.keywordsSet) {
                    var v = new $220f89846e1c7272$var$pyjslib_List([]);
                    var j = this.bareWord(str, i, v);
                    if (j < 0) return -1;
                    if ((0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this.keywords, v[0]) >= 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, 'Keyword "' + v[0] + '" not allowed here.');
                    res.push(this._store.sym(this._bindings[""] + v[0]));
                    return j;
                } else return -1;
            }
        },
        {
            key: "skipSpace",
            value: function skipSpace(str, i) {
                /*
      Skip white space, newlines and comments.
      return -1 if EOF, else position of first non-ws character*/ var whitespace = " \n\r	\f\v\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u2028\u2029\u3000";
                for(var j = i ? i : 0; j < str.length; j++){
                    var ch = str.charAt(j);
                    // console.log("    skipspace j= "+j + " i= " + i + " n= " + str.length);
                    // console.log(" skipspace ch <" + ch + ">");
                    if (whitespace.indexOf(ch) < 0) {
                        //not ws
                        // console.log(" skipspace 2 ch <" + ch + ">");
                        if (str.charAt(j) === "#") for(;; j++){
                            // console.log("    skipspace2 j= "+j + " i= " + i + " n= " + str.length);
                            if (j === str.length) return -1; // EOF
                            if (str.charAt(j) === "\n") {
                                this.lines = this.lines + 1;
                                break;
                            }
                        }
                        else // Not hash - something interesting
                        // console.log(" skipspace 3 ch <" + ch + ">");
                        return j;
                    } else // Whitespace
                    // console.log(" skipspace 5 ch <" + ch + ">");
                    if (str.charAt(j) === "\n") this.lines = this.lines + 1;
                } // next j
                return -1; // EOF
            }
        },
        {
            key: "variable",
            value: function variable(str, i, res) {
                /*
      ?abc -> variable(:abc)
      */ var j = this.skipSpace(str, i);
                if (j < 0) return -1;
                if (str.slice(j, j + 1) != "?") return -1;
                var j = j + 1;
                var i = j;
                if ("0123456789-".indexOf(str.charAt(j)) >= 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "Varible name can't start with '" + str.charAt(j) + "s'");
                while(i < $220f89846e1c7272$var$pyjslib_len(str) && $220f89846e1c7272$var$_notNameChars.indexOf(str.charAt(i)) < 0)var i = i + 1;
                if (this._parentContext == null) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, j, "Can't use ?xxx syntax for variable in outermost level: " + str.slice(j - 1, i));
                res.push(this._store.variable(str.slice(j, i)));
                return i;
            }
        },
        {
            key: "bareWord",
            value: function bareWord(str, i, res) {
                /*
      abc -> :abc
      */ var j = this.skipSpace(str, i);
                if (j < 0) return -1;
                var ch = str.charAt(j);
                if ("0123456789-".indexOf(ch) >= 0) return -1;
                if ($220f89846e1c7272$var$_notNameChars.indexOf(ch) >= 0) return -1;
                var i = j;
                while(i < $220f89846e1c7272$var$pyjslib_len(str) && $220f89846e1c7272$var$_notNameChars.indexOf(str.charAt(i)) < 0)var i = i + 1;
                res.push(str.slice(j, i));
                return i;
            }
        },
        {
            key: "qname",
            value: function qname(str, i, res) {
                /*
       xyz:def -> ('xyz', 'def')
      If not in keywords and keywordsSet: def -> ('', 'def')
      :def -> ('', 'def')
      */ var i = this.skipSpace(str, i);
                if (i < 0) return -1;
                var c = str.charAt(i);
                if ("0123456789-+".indexOf(c) >= 0) return -1;
                if ($220f89846e1c7272$var$_notNameChars.indexOf(c) < 0) {
                    var ln = c;
                    var i = i + 1;
                    while(i < $220f89846e1c7272$var$pyjslib_len(str)){
                        var c = str.charAt(i);
                        if ($220f89846e1c7272$var$_notNameChars.indexOf(c) < 0) {
                            var ln = ln + c;
                            var i = i + 1;
                        } else break;
                    }
                } else var ln = "";
                if (i < $220f89846e1c7272$var$pyjslib_len(str) && str.charAt(i) == ":") {
                    var pfx = ln;
                    var i = i + 1;
                    var ln = "";
                    while(i < $220f89846e1c7272$var$pyjslib_len(str)){
                        var c = str.charAt(i);
                        if ($220f89846e1c7272$var$_notNameChars.indexOf(c) < 0) {
                            var ln = ln + c;
                            var i = i + 1;
                        } else break;
                    }
                    res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                        pfx,
                        ln
                    ]));
                    return i;
                } else {
                    if (ln && this.keywordsSet && (0, $c584fbcedb5512e3$export$37abcb37ee31055e)(this.keywords, ln) < 0) {
                        res.push(new $220f89846e1c7272$var$pyjslib_Tuple([
                            "",
                            ln
                        ]));
                        return i;
                    }
                    return -1;
                }
            }
        },
        {
            key: "object",
            value: function object(str, i, res) {
                var j = this.subject(str, i, res);
                if (j >= 0) return j;
                else {
                    var j = this.skipSpace(str, i);
                    if (j < 0) return -1;
                    else var i = j;
                    var delim = null;
                    var ch = str.charAt(i);
                    if (ch == '"' || ch == "'") {
                        if (str.slice(i, i + 3 == ch + ch)) delim = ch + ch + ch;
                        else delim = ch;
                        var i = i + $220f89846e1c7272$var$pyjslib_len(delim);
                        var pairFudge = this.strconst(str, i, delim);
                        var j = pairFudge[0];
                        var s = pairFudge[1];
                        res.push(this._store.literal(s));
                        $220f89846e1c7272$var$diag_progress("New string const ", s, j);
                        return j;
                    } else return -1;
                }
            }
        },
        {
            key: "nodeOrLiteral",
            value: function nodeOrLiteral(str, i, res) {
                var j = this.node(str, i, res);
                if (j >= 0) return j;
                else {
                    var j = this.skipSpace(str, i);
                    if (j < 0) return -1;
                    else var i = j;
                    var ch = str.charAt(i);
                    if ("-+0987654321".indexOf(ch) >= 0) {
                        $220f89846e1c7272$var$datetime_syntax.lastIndex = 0;
                        var m = $220f89846e1c7272$var$datetime_syntax.exec(str.slice(i));
                        if (m != null) {
                            // j =  ( i + datetime_syntax.lastIndex ) ;
                            var val = m[0];
                            j = i + val.length;
                            if (val.indexOf("T") >= 0) res.push(this._store.literal(val, this._store.sym($220f89846e1c7272$var$DATETIME_DATATYPE)));
                            else res.push(this._store.literal(val, this._store.sym($220f89846e1c7272$var$DATE_DATATYPE)));
                        } else {
                            $220f89846e1c7272$var$number_syntax.lastIndex = 0;
                            var m = $220f89846e1c7272$var$number_syntax.exec(str.slice(i));
                            if (m == null) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "Bad number or date syntax");
                            j = i + $220f89846e1c7272$var$number_syntax.lastIndex;
                            var val = str.slice(i, j);
                            if (val.indexOf("e") >= 0) res.push(this._store.literal(parseFloat(val), this._store.sym($220f89846e1c7272$var$FLOAT_DATATYPE)));
                            else if (str.slice(i, j).indexOf(".") >= 0) res.push(this._store.literal(parseFloat(val), this._store.sym($220f89846e1c7272$var$DECIMAL_DATATYPE)));
                            else res.push(this._store.literal(parseInt(val), this._store.sym($220f89846e1c7272$var$INTEGER_DATATYPE)));
                        }
                        return j; // Where we have got up to
                    }
                    if (str.charAt(i) == '"') {
                        if (str.slice(i, i + 3) == '"""') var delim = '"""';
                        else var delim = '"';
                        var i = i + $220f89846e1c7272$var$pyjslib_len(delim);
                        var dt = null;
                        var pairFudge = this.strconst(str, i, delim);
                        var j = pairFudge[0];
                        var s = pairFudge[1];
                        var lang = null;
                        if (str.slice(j, j + 1) == "@") {
                            $220f89846e1c7272$var$langcode.lastIndex = 0;
                            var m = $220f89846e1c7272$var$langcode.exec(str.slice(j + 1));
                            if (m == null) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline, str, i, "Bad language code syntax on string literal, after @");
                            var i = $220f89846e1c7272$var$langcode.lastIndex + j + 1;
                            var lang = str.slice(j + 1, i);
                            var j = i;
                        }
                        if (str.slice(j, j + 2) == "^^") {
                            var res2 = new $220f89846e1c7272$var$pyjslib_List([]);
                            var j = this.uri_ref2(str, j + 2, res2);
                            var dt = res2[0];
                        }
                        res.push(this._store.literal(s, lang || dt));
                        return j;
                    } else return -1;
                }
            }
        },
        {
            key: "strconst",
            value: function strconst(str, i, delim) {
                /*
      parse an N3 string constant delimited by delim.
      return index, val
      */ var j = i;
                var ustr = "";
                var startline1 = this.lines;
                while(j < $220f89846e1c7272$var$pyjslib_len(str)){
                    var i = j + $220f89846e1c7272$var$pyjslib_len(delim);
                    if (str.slice(j, i) == delim) return new $220f89846e1c7272$var$pyjslib_Tuple([
                        i,
                        ustr
                    ]);
                    if (str.charAt(j) == '"') {
                        var ustr = ustr + '"';
                        var j = j + 1;
                        continue;
                    }
                    $220f89846e1c7272$var$interesting.lastIndex = 0;
                    var m = $220f89846e1c7272$var$interesting.exec(str.slice(j));
                    if (!m) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, j, "Closing quote missing in string at ^ in " + str.slice(j - 20, j) + "^" + str.slice(j, j + 20));
                    var i = j + $220f89846e1c7272$var$interesting.lastIndex - 1;
                    var ustr = ustr + str.slice(j, i);
                    var ch = str.charAt(i);
                    if (ch == '"') {
                        var j = i;
                        continue;
                    } else if (ch == "\r") {
                        var j = i + 1;
                        continue;
                    } else if (ch == "\n") {
                        if (delim == '"') throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "newline found in string literal");
                        this.lines = this.lines + 1;
                        var ustr = ustr + ch;
                        var j = i + 1;
                        this.previousLine = this.startOfLine;
                        this.startOfLine = j;
                    } else if (ch == "\\") {
                        var j = i + 1;
                        var ch = str.slice(j, j + 1);
                        if (!ch) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "unterminated string literal (2)");
                        var k = $220f89846e1c7272$var$string_find('abfrtvn\\"', ch);
                        if (k >= 0) {
                            var uch = 'a\b\f\r	\v\n\\"'.charAt(k);
                            var ustr = ustr + uch;
                            var j = j + 1;
                        } else if (ch == "u") {
                            var pairFudge = this.uEscape(str, j + 1, startline1);
                            var j = pairFudge[0];
                            var ch = pairFudge[1];
                            var ustr = ustr + ch;
                        } else if (ch == "U") {
                            var pairFudge = this.UEscape(str, j + 1, startline1);
                            var j = pairFudge[0];
                            var ch = pairFudge[1];
                            var ustr = ustr + ch;
                        } else throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "bad escape");
                    }
                }
                throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, this.lines, str, i, "unterminated string literal");
            }
        },
        {
            key: "uEscape",
            value: function uEscape(str, i, startline1) {
                var j = i;
                var count = 0;
                var value = 0;
                while(count < 4){
                    var chFudge = str.slice(j, j + 1);
                    var ch = chFudge.toLowerCase();
                    var j = j + 1;
                    if (ch == "") throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "unterminated string literal(3)");
                    var k = $220f89846e1c7272$var$string_find("0123456789abcdef", ch);
                    if (k < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "bad string literal hex escape");
                    var value = value * 16 + k;
                    var count = count + 1;
                }
                var uch = String.fromCharCode(value);
                return new $220f89846e1c7272$var$pyjslib_Tuple([
                    j,
                    uch
                ]);
            }
        },
        {
            key: "UEscape",
            value: function UEscape(str, i, startline1) {
                var j = i;
                var count = 0;
                var value = "\\U";
                while(count < 8){
                    var chFudge = str.slice(j, j + 1);
                    var ch = chFudge.toLowerCase();
                    var j = j + 1;
                    if (ch == "") throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "unterminated string literal(3)");
                    var k = $220f89846e1c7272$var$string_find("0123456789abcdef", ch);
                    if (k < 0) throw $220f89846e1c7272$var$BadSyntax(this._thisDoc, startline1, str, i, "bad string literal hex escape");
                    var value = value + ch;
                    var count = count + 1;
                }
                var uch = $220f89846e1c7272$var$stringFromCharCode("0x" + $220f89846e1c7272$var$pyjslib_slice(value, 2, 10) - 0);
                return new $220f89846e1c7272$var$pyjslib_Tuple([
                    j,
                    uch
                ]);
            }
        }
    ]);
    return SinkParser;
}();
function $220f89846e1c7272$var$OLD_BadSyntax(uri, lines, str, i, why) {
    return new $220f89846e1c7272$var$__OLD_BadSyntax(uri, lines, str, i, why);
}
function $220f89846e1c7272$var$__OLD_BadSyntax(uri, lines, str, i, why) {
    this._str = str.encode("utf-8");
    this._str = str;
    this._i = i;
    this._why = why;
    this.lines = lines;
    this._uri = uri;
}
$220f89846e1c7272$var$__OLD_BadSyntax.prototype.toString = function() {
    var str = this._str;
    var i = this._i;
    var st = 0;
    if (i > 60) {
        var pre = "...";
        var st = i - 60;
    } else var pre = "";
    if ($220f89846e1c7272$var$pyjslib_len(str) - i > 60) var post = "...";
    else var post = "";
    return 'Line %i of <%s>: Bad syntax (%s) at ^ in:\n"%s%s^%s%s"' % new $220f89846e1c7272$var$pyjslib_Tuple([
        this.lines + 1,
        this._uri,
        this._why,
        pre,
        str.slice(st, i),
        str.slice(i, i + 60),
        post
    ]);
};
function $220f89846e1c7272$var$BadSyntax(uri, lines, str, i, why) {
    var lineNo = lines + 1;
    var msg = "Line " + lineNo + " of <" + uri + ">: Bad syntax: " + why + '\nat: "' + str.slice(i, i + 30) + '"';
    var e = new SyntaxError(msg, uri, lineNo);
    e.lineNo = lineNo;
    e.characterInFile = i;
    e.syntaxProblem = why;
    return e;
}
function $220f89846e1c7272$var$stripCR(str) {
    var res = "";
    var __ch = new $220f89846e1c7272$var$pyjslib_Iterator(str);
    try {
        while(true){
            var ch = __ch.next();
            if (ch != "\r") var res = res + ch;
        }
    } catch (e) {
        if (e != $220f89846e1c7272$var$StopIteration) throw e;
    }
    return res;
}
function $220f89846e1c7272$var$dummyWrite(x) {}



var $99pVg = parcelRequire("99pVg");


var $g5Zhu = parcelRequire("g5Zhu");



var $8RKL2 = parcelRequire("8RKL2");


var $gCJkd = parcelRequire("gCJkd");

var $2b3711697846728e$var$_supports;
function $2b3711697846728e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2b3711697846728e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2b3711697846728e$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2b3711697846728e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Data factory which also supports Collections
 *
 * Necessary for preventing circular dependencies.
 */ var $2b3711697846728e$var$ExtendedTermFactory = $2b3711697846728e$var$_objectSpread($2b3711697846728e$var$_objectSpread({}, (0, $158d84b4866fe33e$export$2e2bcd8739ae039)), {}, {
    supports: ($2b3711697846728e$var$_supports = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).collections, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).defaultGraphType, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).equalsMethod, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).identity, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).id, true), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).reversibleId, false), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($2b3711697846728e$var$_supports, (0, $03d9b46807fe65b2$export$6e91cf7616333d5).variableType, true), $2b3711697846728e$var$_supports),
    /**
   * Creates a new collection
   * @param elements - The initial element
   */ collection: function collection(elements) {
        return new (0, $619d91631affbf30$export$2e2bcd8739ae039)(elements);
    },
    id: function id(term) {
        var _this = this;
        if ((0, $gCJkd.isCollection)(term)) return "( ".concat(term.elements.map(function(e) {
            return _this.id(e);
        }).join(", "), " )");
        if ((0, $gCJkd.isVariable)(term)) return (0, $b7a48305c1700eec$export$2e2bcd8739ae039).toString(term);
        return (0, $158d84b4866fe33e$export$2e2bcd8739ae039).id(term);
    },
    termToNQ: function termToNQ(term) {
        if (term.termType === (0, $8RKL2.CollectionTermType)) return (0, $619d91631affbf30$export$2e2bcd8739ae039).toNT(term);
        return (0, $158d84b4866fe33e$export$2e2bcd8739ae039).termToNQ(term);
    }
});
var $2b3711697846728e$export$2e2bcd8739ae039 = $2b3711697846728e$var$ExtendedTermFactory;



function $93c26633f06ced7c$export$a8378f59d30ae4c0(kb, obj) {
    if (typeof obj === "string") return kb.rdfFactory.literal(obj);
    if (Object.prototype.hasOwnProperty.call(obj, "@list")) {
        if (kb.rdfFactory.supports["COLLECTIONS"] === true) return $93c26633f06ced7c$var$listToCollection(kb, obj["@list"]);
        return $93c26633f06ced7c$var$listToStatements(kb, obj);
    }
    if (Object.prototype.hasOwnProperty.call(obj, "@id")) return $93c26633f06ced7c$var$nodeType(kb, obj);
    if (Object.prototype.hasOwnProperty.call(obj, "@language")) return kb.rdfFactory.literal(obj["@value"], obj["@language"]);
    if (Object.prototype.hasOwnProperty.call(obj, "@type")) return kb.rdfFactory.literal(obj["@value"], kb.rdfFactory.namedNode(obj["@type"]));
    if (Object.prototype.hasOwnProperty.call(obj, "@value")) return kb.rdfFactory.literal(obj["@value"]);
    return kb.rdfFactory.literal(obj);
}
/**
 * Adds the statements in a json-ld list object to {kb}.
 */ function $93c26633f06ced7c$var$listToStatements(kb, obj) {
    var listId = obj["@id"] ? $93c26633f06ced7c$var$nodeType(kb, obj) : kb.rdfFactory.blankNode();
    var items = obj["@list"].map(function(listItem) {
        return $93c26633f06ced7c$export$a8378f59d30ae4c0(kb, listItem);
    });
    var statements = (0, $c584fbcedb5512e3$export$b0f02731210f3037)(kb.rdfFactory, listId, items);
    kb.addAll(statements);
    return listId;
}
function $93c26633f06ced7c$var$listToCollection(kb, obj) {
    if (!Array.isArray(obj)) throw new TypeError("Object must be an array");
    return kb.rdfFactory.collection(obj.map(function(o) {
        return $93c26633f06ced7c$export$a8378f59d30ae4c0(kb, o);
    }));
}

function $93c26633f06ced7c$export$2e2bcd8739ae039(str, kb, base, callback) {
    var baseString = base && Object.prototype.hasOwnProperty.call(base, "termType") ? base.value : base;
    return (parcelRequire("v6ngW")).then(function(jsonld) {
        return jsonld.flatten(JSON.parse(str), null, {
            base: baseString
        });
    }).then(function(flattened) {
        return flattened.reduce(function(store, flatResource) {
            kb = $93c26633f06ced7c$var$processResource(kb, base, flatResource);
            return kb;
        }, kb);
    }).then(callback).catch(callback);
}
function $93c26633f06ced7c$var$nodeType(kb, obj) {
    if (obj["@id"].startsWith("_:")) // This object is a Blank Node. Pass the id without the `_:` prefix
    return kb.rdfFactory.blankNode(obj["@id"].substring(2));
    else // This object is a Named Node
    return kb.rdfFactory.namedNode(obj["@id"]);
}
function $93c26633f06ced7c$var$processResource(kb, base, flatResource) {
    var id = flatResource["@id"] ? $93c26633f06ced7c$var$nodeType(kb, flatResource) : kb.rdfFactory.blankNode();
    for(var _i = 0, _Object$keys = Object.keys(flatResource); _i < _Object$keys.length; _i++){
        var property = _Object$keys[_i];
        if (property === "@id") continue;
        else if (property == "@graph") {
            // the JSON-LD flattened structure may contain nested graphs
            // the id value for this object is the new base (named graph id) for all nested flat resources
            var graphId = id;
            // this is an array of resources
            var nestedFlatResources = flatResource[property];
            // recursively process all flat resources in the array, but with the graphId as base.
            for(var i = 0; i < nestedFlatResources.length; i++)kb = $93c26633f06ced7c$var$processResource(kb, graphId, nestedFlatResources[i]);
        }
        var value = flatResource[property];
        if (Array.isArray(value)) for(var _i2 = 0; _i2 < value.length; _i2++)kb.addStatement($93c26633f06ced7c$var$createStatement(kb, id, property, value[_i2], base));
        else kb.addStatement($93c26633f06ced7c$var$createStatement(kb, id, property, value, base));
    }
    return kb;
}
/**
 * Create statement quad depending on @type being a type node
 * @param kb
 * @param subject id
 * @param property
 * @param value
 * @return quad statement
 */ function $93c26633f06ced7c$var$createStatement(kb, id, property, value, base) {
    var predicate, object;
    if (property === "@type") {
        predicate = kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
        object = kb.rdfFactory.namedNode(value);
    } else {
        predicate = kb.rdfFactory.namedNode(property);
        object = $93c26633f06ced7c$export$a8378f59d30ae4c0(kb, value);
    }
    return kb.rdfFactory.quad(id, predicate, object, kb.rdfFactory.namedNode(base));
}


// **N3Lexer** tokenizes N3 documents.
const $b50e49a75dcd9196$var$RDF = "http://www.w3.org/1999/02/22-rdf-syntax-ns#", $b50e49a75dcd9196$var$XSD = "http://www.w3.org/2001/XMLSchema#", $b50e49a75dcd9196$var$SWAP = "http://www.w3.org/2000/10/swap/";
var $b50e49a75dcd9196$export$2e2bcd8739ae039 = {
    xsd: {
        decimal: `${$b50e49a75dcd9196$var$XSD}decimal`,
        boolean: `${$b50e49a75dcd9196$var$XSD}boolean`,
        double: `${$b50e49a75dcd9196$var$XSD}double`,
        integer: `${$b50e49a75dcd9196$var$XSD}integer`,
        string: `${$b50e49a75dcd9196$var$XSD}string`
    },
    rdf: {
        type: `${$b50e49a75dcd9196$var$RDF}type`,
        nil: `${$b50e49a75dcd9196$var$RDF}nil`,
        first: `${$b50e49a75dcd9196$var$RDF}first`,
        rest: `${$b50e49a75dcd9196$var$RDF}rest`,
        langString: `${$b50e49a75dcd9196$var$RDF}langString`
    },
    owl: {
        sameAs: "http://www.w3.org/2002/07/owl#sameAs"
    },
    r: {
        forSome: `${$b50e49a75dcd9196$var$SWAP}reify#forSome`,
        forAll: `${$b50e49a75dcd9196$var$SWAP}reify#forAll`
    },
    log: {
        implies: `${$b50e49a75dcd9196$var$SWAP}log#implies`
    }
};


var $6210dce35be42a6b$exports = {};
/*! queue-microtask. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ let $6210dce35be42a6b$var$promise;
$6210dce35be42a6b$exports = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : $parcel$global) : (cb)=>($6210dce35be42a6b$var$promise || ($6210dce35be42a6b$var$promise = Promise.resolve())).then(cb).catch((err)=>setTimeout(()=>{
            throw err;
        }, 0));



var $6ZWSX = parcelRequire("6ZWSX");
var $c66a9a29d2de1131$require$Buffer = $6ZWSX.Buffer;
const { xsd: $c66a9a29d2de1131$var$xsd } = (0, $b50e49a75dcd9196$export$2e2bcd8739ae039);
// Regular expression and replacement string to escape N3 strings
const $c66a9a29d2de1131$var$escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\([^])/g;
const $c66a9a29d2de1131$var$escapeReplacements = {
    "\\": "\\",
    "'": "'",
    '"': '"',
    "n": "\n",
    "r": "\r",
    "t": "	",
    "f": "\f",
    "b": "\b",
    "_": "_",
    "~": "~",
    ".": ".",
    "-": "-",
    "!": "!",
    "$": "$",
    "&": "&",
    "(": "(",
    ")": ")",
    "*": "*",
    "+": "+",
    ",": ",",
    ";": ";",
    "=": "=",
    "/": "/",
    "?": "?",
    "#": "#",
    "@": "@",
    "%": "%"
};
const $c66a9a29d2de1131$var$illegalIriChars = /[\x00-\x20<>\\"\{\}\|\^\`]/;
const $c66a9a29d2de1131$var$lineModeRegExps = {
    _iri: true,
    _unescapedIri: true,
    _simpleQuotedString: true,
    _langcode: true,
    _blank: true,
    _newline: true,
    _comment: true,
    _whitespace: true,
    _endOfFile: true
};
const $c66a9a29d2de1131$var$invalidRegExp = /$0^/;
class $c66a9a29d2de1131$export$2e2bcd8739ae039 {
    constructor(options){
        // ## Regular expressions
        // It's slightly faster to have these as properties than as in-scope variables
        this._iri = /^<((?:[^ <>{}\\]|\\[uU])+)>[ \t]*/; // IRI with escape sequences; needs sanity check after unescaping
        this._unescapedIri = /^<([^\x00-\x20<>\\"\{\}\|\^\`]*)>[ \t]*/; // IRI without escape sequences; no unescaping
        this._simpleQuotedString = /^"([^"\\\r\n]*)"(?=[^"])/; // string without escape sequences
        this._simpleApostropheString = /^'([^'\\\r\n]*)'(?=[^'])/;
        this._langcode = /^@([a-z]+(?:-[a-z0-9]+)*)(?=[^a-z0-9\-])/i;
        this._prefix = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:(?=[#\s<])/;
        this._prefixed = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:((?:(?:[0-:A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])(?:(?:[\.\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])*(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~]))?)?)(?:[ \t]+|(?=\.?[,;!\^\s#()\[\]\{\}"'<>]))/;
        this._variable = /^\?(?:(?:[A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?=[.,;!\^\s#()\[\]\{\}"'<>])/;
        this._blank = /^_:((?:[0-9A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?:[ \t]+|(?=\.?[,;:\s#()\[\]\{\}"'<>]))/;
        this._number = /^[\-+]?(?:(\d+\.\d*|\.?\d+)[eE][\-+]?|\d*(\.)?)\d+(?=\.?[,;:\s#()\[\]\{\}"'<>])/;
        this._boolean = /^(?:true|false)(?=[.,;\s#()\[\]\{\}"'<>])/;
        this._keyword = /^@[a-z]+(?=[\s#<:])/i;
        this._sparqlKeyword = /^(?:PREFIX|BASE|GRAPH)(?=[\s#<])/i;
        this._shortPredicates = /^a(?=[\s#()\[\]\{\}"'<>])/;
        this._newline = /^[ \t]*(?:#[^\n\r]*)?(?:\r\n|\n|\r)[ \t]*/;
        this._comment = /#([^\n\r]*)/;
        this._whitespace = /^[ \t]+/;
        this._endOfFile = /^(?:#[^\n\r]*)?$/;
        options = options || {};
        // In line mode (N-Triples or N-Quads), only simple features may be parsed
        if (this._lineMode = !!options.lineMode) {
            this._n3Mode = false;
            // Don't tokenize special literals
            for(const key in this)if (!(key in $c66a9a29d2de1131$var$lineModeRegExps) && this[key] instanceof RegExp) this[key] = $c66a9a29d2de1131$var$invalidRegExp;
        } else this._n3Mode = options.n3 !== false;
        // Don't output comment tokens by default
        this._comments = !!options.comments;
        // Cache the last tested closing position of long literals
        this._literalClosingPos = 0;
    }
    // ## Private methods
    // ### `_tokenizeToEnd` tokenizes as for as possible, emitting tokens through the callback
    _tokenizeToEnd(callback, inputFinished) {
        // Continue parsing as far as possible; the loop will return eventually
        let input = this._input;
        let currentLineLength = input.length;
        while(true){
            // Count and skip whitespace lines
            let whiteSpaceMatch, comment;
            while(whiteSpaceMatch = this._newline.exec(input)){
                // Try to find a comment
                if (this._comments && (comment = this._comment.exec(whiteSpaceMatch[0]))) emitToken("comment", comment[1], "", this._line, whiteSpaceMatch[0].length);
                // Advance the input
                input = input.substr(whiteSpaceMatch[0].length, input.length);
                currentLineLength = input.length;
                this._line++;
            }
            // Skip whitespace on current line
            if (!whiteSpaceMatch && (whiteSpaceMatch = this._whitespace.exec(input))) input = input.substr(whiteSpaceMatch[0].length, input.length);
            // Stop for now if we're at the end
            if (this._endOfFile.test(input)) {
                // If the input is finished, emit EOF
                if (inputFinished) {
                    // Try to find a final comment
                    if (this._comments && (comment = this._comment.exec(input))) emitToken("comment", comment[1], "", this._line, input.length);
                    input = null;
                    emitToken("eof", "", "", this._line, 0);
                }
                return this._input = input;
            }
            // Look for specific token types based on the first character
            const line = this._line, firstChar = input[0];
            let type = "", value = "", prefix = "", match = null, matchLength = 0, inconclusive = false;
            switch(firstChar){
                case "^":
                    // We need at least 3 tokens lookahead to distinguish ^^<IRI> and ^^pre:fixed
                    if (input.length < 3) break;
                    else if (input[1] === "^") {
                        this._previousMarker = "^^";
                        // Move to type IRI or prefixed name
                        input = input.substr(2);
                        if (input[0] !== "<") {
                            inconclusive = true;
                            break;
                        }
                    } else {
                        if (this._n3Mode) {
                            matchLength = 1;
                            type = "^";
                        }
                        break;
                    }
                // Fall through in case the type is an IRI
                case "<":
                    // Try to find a full IRI without escape sequences
                    if (match = this._unescapedIri.exec(input)) type = "IRI", value = match[1];
                    else if (match = this._iri.exec(input)) {
                        value = this._unescape(match[1]);
                        if (value === null || $c66a9a29d2de1131$var$illegalIriChars.test(value)) return reportSyntaxError(this);
                        type = "IRI";
                    } else if (input.length > 1 && input[1] === "<") type = "<<", matchLength = 2;
                    else if (this._n3Mode && input.length > 1 && input[1] === "=") type = "inverse", matchLength = 2, value = ">";
                    break;
                case ">":
                    if (input.length > 1 && input[1] === ">") type = ">>", matchLength = 2;
                    break;
                case "_":
                    // Try to find a blank node. Since it can contain (but not end with) a dot,
                    // we always need a non-dot character before deciding it is a blank node.
                    // Therefore, try inserting a space if we're at the end of the input.
                    if ((match = this._blank.exec(input)) || inputFinished && (match = this._blank.exec(`${input} `))) type = "blank", prefix = "_", value = match[1];
                    break;
                case '"':
                    // Try to find a literal without escape sequences
                    if (match = this._simpleQuotedString.exec(input)) value = match[1];
                    else {
                        ({ value: value, matchLength: matchLength } = this._parseLiteral(input));
                        if (value === null) return reportSyntaxError(this);
                    }
                    if (match !== null || matchLength !== 0) {
                        type = "literal";
                        this._literalClosingPos = 0;
                    }
                    break;
                case "'":
                    if (!this._lineMode) {
                        // Try to find a literal without escape sequences
                        if (match = this._simpleApostropheString.exec(input)) value = match[1];
                        else {
                            ({ value: value, matchLength: matchLength } = this._parseLiteral(input));
                            if (value === null) return reportSyntaxError(this);
                        }
                        if (match !== null || matchLength !== 0) {
                            type = "literal";
                            this._literalClosingPos = 0;
                        }
                    }
                    break;
                case "?":
                    // Try to find a variable
                    if (this._n3Mode && (match = this._variable.exec(input))) type = "var", value = match[0];
                    break;
                case "@":
                    // Try to find a language code
                    if (this._previousMarker === "literal" && (match = this._langcode.exec(input))) type = "langcode", value = match[1];
                    else if (match = this._keyword.exec(input)) type = match[0];
                    break;
                case ".":
                    // Try to find a dot as punctuation
                    if (input.length === 1 ? inputFinished : input[1] < "0" || input[1] > "9") {
                        type = ".";
                        matchLength = 1;
                        break;
                    }
                // Fall through to numerical case (could be a decimal dot)
                case "0":
                case "1":
                case "2":
                case "3":
                case "4":
                case "5":
                case "6":
                case "7":
                case "8":
                case "9":
                case "+":
                case "-":
                    // Try to find a number. Since it can contain (but not end with) a dot,
                    // we always need a non-dot character before deciding it is a number.
                    // Therefore, try inserting a space if we're at the end of the input.
                    if (match = this._number.exec(input) || inputFinished && (match = this._number.exec(`${input} `))) {
                        type = "literal", value = match[0];
                        prefix = typeof match[1] === "string" ? $c66a9a29d2de1131$var$xsd.double : typeof match[2] === "string" ? $c66a9a29d2de1131$var$xsd.decimal : $c66a9a29d2de1131$var$xsd.integer;
                    }
                    break;
                case "B":
                case "b":
                case "p":
                case "P":
                case "G":
                case "g":
                    // Try to find a SPARQL-style keyword
                    if (match = this._sparqlKeyword.exec(input)) type = match[0].toUpperCase();
                    else inconclusive = true;
                    break;
                case "f":
                case "t":
                    // Try to match a boolean
                    if (match = this._boolean.exec(input)) type = "literal", value = match[0], prefix = $c66a9a29d2de1131$var$xsd.boolean;
                    else inconclusive = true;
                    break;
                case "a":
                    // Try to find an abbreviated predicate
                    if (match = this._shortPredicates.exec(input)) type = "abbreviation", value = "a";
                    else inconclusive = true;
                    break;
                case "=":
                    // Try to find an implication arrow or equals sign
                    if (this._n3Mode && input.length > 1) {
                        type = "abbreviation";
                        if (input[1] !== ">") matchLength = 1, value = "=";
                        else matchLength = 2, value = ">";
                    }
                    break;
                case "!":
                    if (!this._n3Mode) break;
                case ",":
                case ";":
                case "[":
                case "]":
                case "(":
                case ")":
                case "}":
                    if (!this._lineMode) {
                        matchLength = 1;
                        type = firstChar;
                    }
                    break;
                case "{":
                    // We need at least 2 tokens lookahead to distinguish "{|" and "{ "
                    if (!this._lineMode && input.length >= 2) {
                        // Try to find a quoted triple annotation start
                        if (input[1] === "|") type = "{|", matchLength = 2;
                        else type = firstChar, matchLength = 1;
                    }
                    break;
                case "|":
                    // We need 2 tokens lookahead to parse "|}"
                    // Try to find a quoted triple annotation end
                    if (input.length >= 2 && input[1] === "}") type = "|}", matchLength = 2;
                    break;
                default:
                    inconclusive = true;
            }
            // Some first characters do not allow an immediate decision, so inspect more
            if (inconclusive) {
                // Try to find a prefix
                if ((this._previousMarker === "@prefix" || this._previousMarker === "PREFIX") && (match = this._prefix.exec(input))) type = "prefix", value = match[1] || "";
                else if ((match = this._prefixed.exec(input)) || inputFinished && (match = this._prefixed.exec(`${input} `))) type = "prefixed", prefix = match[1] || "", value = this._unescape(match[2]);
            }
            // A type token is special: it can only be emitted after an IRI or prefixed name is read
            if (this._previousMarker === "^^") switch(type){
                case "prefixed":
                    type = "type";
                    break;
                case "IRI":
                    type = "typeIRI";
                    break;
                default:
                    type = "";
            }
            // What if nothing of the above was found?
            if (!type) {
                // We could be in streaming mode, and then we just wait for more input to arrive.
                // Otherwise, a syntax error has occurred in the input.
                // One exception: error on an unaccounted linebreak (= not inside a triple-quoted literal).
                if (inputFinished || !/^'''|^"""/.test(input) && /\n|\r/.test(input)) return reportSyntaxError(this);
                else return this._input = input;
            }
            // Emit the parsed token
            const length = matchLength || match[0].length;
            const token = emitToken(type, value, prefix, line, length);
            this.previousToken = token;
            this._previousMarker = type;
            // Advance to next part to tokenize
            input = input.substr(length, input.length);
        }
        // Emits the token through the callback
        function emitToken(type, value, prefix, line, length) {
            const start = input ? currentLineLength - input.length : currentLineLength;
            const end = start + length;
            const token = {
                type: type,
                value: value,
                prefix: prefix,
                line: line,
                start: start,
                end: end
            };
            callback(null, token);
            return token;
        }
        // Signals the syntax error through the callback
        function reportSyntaxError(self) {
            callback(self._syntaxError(/^\S*/.exec(input)[0]));
        }
    }
    // ### `_unescape` replaces N3 escape codes by their corresponding characters
    _unescape(item) {
        let invalid = false;
        const replaced = item.replace($c66a9a29d2de1131$var$escapeSequence, (sequence, unicode4, unicode8, escapedChar)=>{
            // 4-digit unicode character
            if (typeof unicode4 === "string") return String.fromCharCode(Number.parseInt(unicode4, 16));
            // 8-digit unicode character
            if (typeof unicode8 === "string") {
                let charCode = Number.parseInt(unicode8, 16);
                return charCode <= 0xFFFF ? String.fromCharCode(Number.parseInt(unicode8, 16)) : String.fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
            }
            // fixed escape sequence
            if (escapedChar in $c66a9a29d2de1131$var$escapeReplacements) return $c66a9a29d2de1131$var$escapeReplacements[escapedChar];
            // invalid escape sequence
            invalid = true;
            return "";
        });
        return invalid ? null : replaced;
    }
    // ### `_parseLiteral` parses a literal into an unescaped value
    _parseLiteral(input) {
        // Ensure we have enough lookahead to identify triple-quoted strings
        if (input.length >= 3) {
            // Identify the opening quote(s)
            const opening = input.match(/^(?:"""|"|'''|'|)/)[0];
            const openingLength = opening.length;
            // Find the next candidate closing quotes
            let closingPos = Math.max(this._literalClosingPos, openingLength);
            while((closingPos = input.indexOf(opening, closingPos)) > 0){
                // Count backslashes right before the closing quotes
                let backslashCount = 0;
                while(input[closingPos - backslashCount - 1] === "\\")backslashCount++;
                // An even number of backslashes (in particular 0)
                // means these are actual, non-escaped closing quotes
                if (backslashCount % 2 === 0) {
                    // Extract and unescape the value
                    const raw = input.substring(openingLength, closingPos);
                    const lines = raw.split(/\r\n|\r|\n/).length - 1;
                    const matchLength = closingPos + openingLength;
                    // Only triple-quoted strings can be multi-line
                    if (openingLength === 1 && lines !== 0 || openingLength === 3 && this._lineMode) break;
                    this._line += lines;
                    return {
                        value: this._unescape(raw),
                        matchLength: matchLength
                    };
                }
                closingPos++;
            }
            this._literalClosingPos = input.length - openingLength + 1;
        }
        return {
            value: "",
            matchLength: 0
        };
    }
    // ### `_syntaxError` creates a syntax error for the given issue
    _syntaxError(issue) {
        this._input = null;
        const err = new Error(`Unexpected "${issue}" on line ${this._line}.`);
        err.context = {
            token: undefined,
            line: this._line,
            previousToken: this.previousToken
        };
        return err;
    }
    // ### Strips off any starting UTF BOM mark.
    _readStartingBom(input) {
        return input.startsWith("\uFEFF") ? input.substr(1) : input;
    }
    // ## Public methods
    // ### `tokenize` starts the transformation of an N3 document into an array of tokens.
    // The input can be a string or a stream.
    tokenize(input, callback) {
        this._line = 1;
        // If the input is a string, continuously emit tokens through the callback until the end
        if (typeof input === "string") {
            this._input = this._readStartingBom(input);
            // If a callback was passed, asynchronously call it
            if (typeof callback === "function") (0, (/*@__PURE__*/$parcel$interopDefault($6210dce35be42a6b$exports)))(()=>this._tokenizeToEnd(callback, true));
            else {
                const tokens = [];
                let error;
                this._tokenizeToEnd((e, t)=>e ? error = e : tokens.push(t), true);
                if (error) throw error;
                return tokens;
            }
        } else {
            this._pendingBuffer = null;
            if (typeof input.setEncoding === "function") input.setEncoding("utf8");
            // Adds the data chunk to the buffer and parses as far as possible
            input.on("data", (data)=>{
                if (this._input !== null && data.length !== 0) {
                    // Prepend any previous pending writes
                    if (this._pendingBuffer) {
                        data = $c66a9a29d2de1131$require$Buffer.concat([
                            this._pendingBuffer,
                            data
                        ]);
                        this._pendingBuffer = null;
                    }
                    // Hold if the buffer ends in an incomplete unicode sequence
                    if (data[data.length - 1] & 0x80) this._pendingBuffer = data;
                    else {
                        // Only read a BOM at the start
                        if (typeof this._input === "undefined") this._input = this._readStartingBom(typeof data === "string" ? data : data.toString());
                        else this._input += data;
                        this._tokenizeToEnd(callback, false);
                    }
                }
            });
            // Parses until the end
            input.on("end", ()=>{
                if (typeof this._input === "string") this._tokenizeToEnd(callback, true);
            });
            input.on("error", callback);
        }
    }
}


// **N3Parser** parses N3 documents.

// N3.js implementations of the RDF/JS core data types
// See https://github.com/rdfjs/representation-task-force/blob/master/interface-spec.md

var $d33ba30d5e9a7819$exports = {};

$parcel$export($d33ba30d5e9a7819$exports, "isNamedNode", () => $d33ba30d5e9a7819$export$10490ce738f72284);
$parcel$export($d33ba30d5e9a7819$exports, "isBlankNode", () => $d33ba30d5e9a7819$export$7b5b4967656acaac);
$parcel$export($d33ba30d5e9a7819$exports, "isLiteral", () => $d33ba30d5e9a7819$export$899158ea22bb4609);
$parcel$export($d33ba30d5e9a7819$exports, "isVariable", () => $d33ba30d5e9a7819$export$670a0c046e2ed227);
$parcel$export($d33ba30d5e9a7819$exports, "isDefaultGraph", () => $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8);
$parcel$export($d33ba30d5e9a7819$exports, "inDefaultGraph", () => $d33ba30d5e9a7819$export$be8c4434e9c7c90b);
$parcel$export($d33ba30d5e9a7819$exports, "prefix", () => $d33ba30d5e9a7819$export$82e9f45cca5ba907);
$parcel$export($d33ba30d5e9a7819$exports, "prefixes", () => $d33ba30d5e9a7819$export$5d3c3f85c29a375);
// **N3Util** provides N3 utility functions.

function $d33ba30d5e9a7819$export$10490ce738f72284(term) {
    return !!term && term.termType === "NamedNode";
}
function $d33ba30d5e9a7819$export$7b5b4967656acaac(term) {
    return !!term && term.termType === "BlankNode";
}
function $d33ba30d5e9a7819$export$899158ea22bb4609(term) {
    return !!term && term.termType === "Literal";
}
function $d33ba30d5e9a7819$export$670a0c046e2ed227(term) {
    return !!term && term.termType === "Variable";
}
function $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8(term) {
    return !!term && term.termType === "DefaultGraph";
}
function $d33ba30d5e9a7819$export$be8c4434e9c7c90b(quad) {
    return $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8(quad.graph);
}
function $d33ba30d5e9a7819$export$82e9f45cca5ba907(iri, factory) {
    return $d33ba30d5e9a7819$export$5d3c3f85c29a375({
        "": iri.value || iri
    }, factory)("");
}
function $d33ba30d5e9a7819$export$5d3c3f85c29a375(defaultPrefixes, factory) {
    // Add all of the default prefixes
    const prefixes = Object.create(null);
    for(const prefix in defaultPrefixes)processPrefix(prefix, defaultPrefixes[prefix]);
    // Set the default factory if none was specified
    factory = factory || (0, $712f170b9f5279d6$export$2e2bcd8739ae039);
    // Registers a new prefix (if an IRI was specified)
    // or retrieves a function that expands an existing prefix (if no IRI was specified)
    function processPrefix(prefix, iri) {
        // Create a new prefix if an IRI is specified or the prefix doesn't exist
        if (typeof iri === "string") {
            // Create a function that expands the prefix
            const cache = Object.create(null);
            prefixes[prefix] = (local)=>{
                return cache[local] || (cache[local] = factory.namedNode(iri + local));
            };
        } else if (!(prefix in prefixes)) throw new Error(`Unknown prefix: ${prefix}`);
        return prefixes[prefix];
    }
    return processPrefix;
}


const { rdf: $712f170b9f5279d6$var$rdf, xsd: $712f170b9f5279d6$var$xsd } = (0, $b50e49a75dcd9196$export$2e2bcd8739ae039);
// eslint-disable-next-line prefer-const
let $712f170b9f5279d6$var$DEFAULTGRAPH;
let $712f170b9f5279d6$var$_blankNodeCounter = 0;
const $712f170b9f5279d6$var$escapedLiteral = /^"(.*".*)(?="[^"]*$)/;
// ## DataFactory singleton
const $712f170b9f5279d6$var$DataFactory = {
    namedNode: $712f170b9f5279d6$var$namedNode,
    blankNode: $712f170b9f5279d6$var$blankNode,
    variable: $712f170b9f5279d6$var$variable,
    literal: $712f170b9f5279d6$var$literal,
    defaultGraph: $712f170b9f5279d6$var$defaultGraph,
    quad: $712f170b9f5279d6$var$quad,
    triple: $712f170b9f5279d6$var$quad
};
var $712f170b9f5279d6$export$2e2bcd8739ae039 = $712f170b9f5279d6$var$DataFactory;
class $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(id){
        this.id = id;
    }
    // ### The value of this term
    get value() {
        return this.id;
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both terms were created by this library,
        // equality can be computed through ids
        if (other instanceof $712f170b9f5279d6$export$656c1e606ad06131) return this.id === other.id;
        // Otherwise, compare term type and value
        return !!other && this.termType === other.termType && this.value === other.value;
    }
    // ### Implement hashCode for Immutable.js, since we implement `equals`
    // https://immutable-js.com/docs/v4.0.0/ValueObject/#hashCode()
    hashCode() {
        return 0;
    }
    // ### Returns a plain object representation of this term
    toJSON() {
        return {
            termType: this.termType,
            value: this.value
        };
    }
}
class $712f170b9f5279d6$export$e55689a56c4c92c2 extends $712f170b9f5279d6$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return "NamedNode";
    }
}
class $712f170b9f5279d6$export$e175ae9e414693bc extends $712f170b9f5279d6$export$656c1e606ad06131 {
    // ### The term type of this term
    get termType() {
        return "Literal";
    }
    // ### The text value of this literal
    get value() {
        return this.id.substring(1, this.id.lastIndexOf('"'));
    }
    // ### The language of this literal
    get language() {
        // Find the last quotation mark (e.g., '"abc"@en-us')
        const id = this.id;
        let atPos = id.lastIndexOf('"') + 1;
        // If "@" it follows, return the remaining substring; empty otherwise
        return atPos < id.length && id[atPos++] === "@" ? id.substr(atPos).toLowerCase() : "";
    }
    // ### The datatype IRI of this literal
    get datatype() {
        return new $712f170b9f5279d6$export$e55689a56c4c92c2(this.datatypeString);
    }
    // ### The datatype string of this literal
    get datatypeString() {
        // Find the last quotation mark (e.g., '"abc"^^http://ex.org/types#t')
        const id = this.id, dtPos = id.lastIndexOf('"') + 1;
        const char = dtPos < id.length ? id[dtPos] : "";
        // If "^" it follows, return the remaining substring
        return char === "^" ? id.substr(dtPos + 2) : // If "@" follows, return rdf:langString; xsd:string otherwise
        char !== "@" ? $712f170b9f5279d6$var$xsd.string : $712f170b9f5279d6$var$rdf.langString;
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both literals were created by this library,
        // equality can be computed through ids
        if (other instanceof $712f170b9f5279d6$export$e175ae9e414693bc) return this.id === other.id;
        // Otherwise, compare term type, value, language, and datatype
        return !!other && !!other.datatype && this.termType === other.termType && this.value === other.value && this.language === other.language && this.datatype.value === other.datatype.value;
    }
    toJSON() {
        return {
            termType: this.termType,
            value: this.value,
            language: this.language,
            datatype: {
                termType: "NamedNode",
                value: this.datatypeString
            }
        };
    }
}
class $712f170b9f5279d6$export$1a8019c085269883 extends $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(name){
        super(`_:${name}`);
    }
    // ### The term type of this term
    get termType() {
        return "BlankNode";
    }
    // ### The name of this blank node
    get value() {
        return this.id.substr(2);
    }
}
class $712f170b9f5279d6$export$c867a5c9595a1350 extends $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(name){
        super(`?${name}`);
    }
    // ### The term type of this term
    get termType() {
        return "Variable";
    }
    // ### The name of this variable
    get value() {
        return this.id.substr(1);
    }
}
class $712f170b9f5279d6$export$4383f89a7161b240 extends $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(){
        super("");
        return $712f170b9f5279d6$var$DEFAULTGRAPH || this;
    }
    // ### The term type of this term
    get termType() {
        return "DefaultGraph";
    }
    // ### Returns whether this object represents the same term as the other
    equals(other) {
        // If both terms were created by this library,
        // equality can be computed through strict equality;
        // otherwise, compare term types.
        return this === other || !!other && this.termType === other.termType;
    }
}
// ## DefaultGraph singleton
$712f170b9f5279d6$var$DEFAULTGRAPH = new $712f170b9f5279d6$export$4383f89a7161b240();
function $712f170b9f5279d6$export$85285e91bbd99cf(id, factory, nested) {
    factory = factory || $712f170b9f5279d6$var$DataFactory;
    // Falsy value or empty string indicate the default graph
    if (!id) return factory.defaultGraph();
    // Identify the term type based on the first character
    switch(id[0]){
        case "?":
            return factory.variable(id.substr(1));
        case "_":
            return factory.blankNode(id.substr(2));
        case '"':
            // Shortcut for internal literals
            if (factory === $712f170b9f5279d6$var$DataFactory) return new $712f170b9f5279d6$export$e175ae9e414693bc(id);
            // Literal without datatype or language
            if (id[id.length - 1] === '"') return factory.literal(id.substr(1, id.length - 2));
            // Literal with datatype or language
            const endPos = id.lastIndexOf('"', id.length - 1);
            return factory.literal(id.substr(1, endPos - 1), id[endPos + 1] === "@" ? id.substr(endPos + 2) : factory.namedNode(id.substr(endPos + 3)));
        case "[":
            id = JSON.parse(id);
            break;
        default:
            if (!nested || !Array.isArray(id)) return factory.namedNode(id);
    }
    return factory.quad($712f170b9f5279d6$export$85285e91bbd99cf(id[0], factory, true), $712f170b9f5279d6$export$85285e91bbd99cf(id[1], factory, true), $712f170b9f5279d6$export$85285e91bbd99cf(id[2], factory, true), id[3] && $712f170b9f5279d6$export$85285e91bbd99cf(id[3], factory, true));
}
function $712f170b9f5279d6$export$fbf03d1179c9227e(term, nested) {
    if (typeof term === "string") return term;
    if (term instanceof $712f170b9f5279d6$export$656c1e606ad06131 && term.termType !== "Quad") return term.id;
    if (!term) return $712f170b9f5279d6$var$DEFAULTGRAPH.id;
    // Term instantiated with another library
    switch(term.termType){
        case "NamedNode":
            return term.value;
        case "BlankNode":
            return `_:${term.value}`;
        case "Variable":
            return `?${term.value}`;
        case "DefaultGraph":
            return "";
        case "Literal":
            return `"${term.value}"${term.language ? `@${term.language}` : term.datatype && term.datatype.value !== $712f170b9f5279d6$var$xsd.string ? `^^${term.datatype.value}` : ""}`;
        case "Quad":
            const res = [
                $712f170b9f5279d6$export$fbf03d1179c9227e(term.subject, true),
                $712f170b9f5279d6$export$fbf03d1179c9227e(term.predicate, true),
                $712f170b9f5279d6$export$fbf03d1179c9227e(term.object, true)
            ];
            if (!(0, $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8)(term.graph)) res.push($712f170b9f5279d6$export$fbf03d1179c9227e(term.graph, true));
            return nested ? res : JSON.stringify(res);
        default:
            throw new Error(`Unexpected termType: ${term.termType}`);
    }
}
class $712f170b9f5279d6$export$7005c9eb6671414d extends $712f170b9f5279d6$export$656c1e606ad06131 {
    constructor(subject, predicate, object, graph){
        super("");
        this._subject = subject;
        this._predicate = predicate;
        this._object = object;
        this._graph = graph || $712f170b9f5279d6$var$DEFAULTGRAPH;
    }
    // ### The term type of this term
    get termType() {
        return "Quad";
    }
    get subject() {
        return this._subject;
    }
    get predicate() {
        return this._predicate;
    }
    get object() {
        return this._object;
    }
    get graph() {
        return this._graph;
    }
    // ### Returns a plain object representation of this quad
    toJSON() {
        return {
            termType: this.termType,
            subject: this._subject.toJSON(),
            predicate: this._predicate.toJSON(),
            object: this._object.toJSON(),
            graph: this._graph.toJSON()
        };
    }
    // ### Returns whether this object represents the same quad as the other
    equals(other) {
        return !!other && this._subject.equals(other.subject) && this._predicate.equals(other.predicate) && this._object.equals(other.object) && this._graph.equals(other.graph);
    }
}
function $712f170b9f5279d6$export$3ff8cecf0aa87c28(id) {
    return id.replace($712f170b9f5279d6$var$escapedLiteral, (_, quoted)=>`"${quoted.replace(/"/g, '""')}`);
}
function $712f170b9f5279d6$export$7cedbcd33d1bf915(id) {
    return id.replace($712f170b9f5279d6$var$escapedLiteral, (_, quoted)=>`"${quoted.replace(/""/g, '"')}`);
}
// ### Creates an IRI
function $712f170b9f5279d6$var$namedNode(iri) {
    return new $712f170b9f5279d6$export$e55689a56c4c92c2(iri);
}
// ### Creates a blank node
function $712f170b9f5279d6$var$blankNode(name) {
    return new $712f170b9f5279d6$export$1a8019c085269883(name || `n3-${$712f170b9f5279d6$var$_blankNodeCounter++}`);
}
// ### Creates a literal
function $712f170b9f5279d6$var$literal(value, languageOrDataType) {
    // Create a language-tagged string
    if (typeof languageOrDataType === "string") return new $712f170b9f5279d6$export$e175ae9e414693bc(`"${value}"@${languageOrDataType.toLowerCase()}`);
    // Automatically determine datatype for booleans and numbers
    let datatype = languageOrDataType ? languageOrDataType.value : "";
    if (datatype === "") {
        // Convert a boolean
        if (typeof value === "boolean") datatype = $712f170b9f5279d6$var$xsd.boolean;
        else if (typeof value === "number") {
            if (Number.isFinite(value)) datatype = Number.isInteger(value) ? $712f170b9f5279d6$var$xsd.integer : $712f170b9f5279d6$var$xsd.double;
            else {
                datatype = $712f170b9f5279d6$var$xsd.double;
                if (!Number.isNaN(value)) value = value > 0 ? "INF" : "-INF";
            }
        }
    }
    // Create a datatyped literal
    return datatype === "" || datatype === $712f170b9f5279d6$var$xsd.string ? new $712f170b9f5279d6$export$e175ae9e414693bc(`"${value}"`) : new $712f170b9f5279d6$export$e175ae9e414693bc(`"${value}"^^${datatype}`);
}
// ### Creates a variable
function $712f170b9f5279d6$var$variable(name) {
    return new $712f170b9f5279d6$export$c867a5c9595a1350(name);
}
// ### Returns the default graph
function $712f170b9f5279d6$var$defaultGraph() {
    return $712f170b9f5279d6$var$DEFAULTGRAPH;
}
// ### Creates a quad
function $712f170b9f5279d6$var$quad(subject, predicate, object, graph) {
    return new $712f170b9f5279d6$export$7005c9eb6671414d(subject, predicate, object, graph);
}



let $c0715e6442e25456$var$blankNodePrefix = 0;
class $c0715e6442e25456$export$2e2bcd8739ae039 {
    constructor(options){
        this._contextStack = [];
        this._graph = null;
        // Set the document IRI
        options = options || {};
        this._setBase(options.baseIRI);
        options.factory && $c0715e6442e25456$var$initDataFactory(this, options.factory);
        // Set supported features depending on the format
        const format = typeof options.format === "string" ? options.format.match(/\w*$/)[0].toLowerCase() : "", isTurtle = /turtle/.test(format), isTriG = /trig/.test(format), isNTriples = /triple/.test(format), isNQuads = /quad/.test(format), isN3 = this._n3Mode = /n3/.test(format), isLineMode = isNTriples || isNQuads;
        if (!(this._supportsNamedGraphs = !(isTurtle || isN3))) this._readPredicateOrNamedGraph = this._readPredicate;
        // Support triples in other graphs
        this._supportsQuads = !(isTurtle || isTriG || isNTriples || isN3);
        // Support nesting of triples
        this._supportsRDFStar = format === "" || /star|\*$/.test(format);
        // Disable relative IRIs in N-Triples or N-Quads mode
        if (isLineMode) this._resolveRelativeIRI = (iri)=>{
            return null;
        };
        this._blankNodePrefix = typeof options.blankNodePrefix !== "string" ? "" : options.blankNodePrefix.replace(/^(?!_:)/, "_:");
        this._lexer = options.lexer || new (0, $c66a9a29d2de1131$export$2e2bcd8739ae039)({
            lineMode: isLineMode,
            n3: isN3
        });
        // Disable explicit quantifiers by default
        this._explicitQuantifiers = !!options.explicitQuantifiers;
    }
    // ## Static class methods
    // ### `_resetBlankNodePrefix` restarts blank node prefix identification
    static _resetBlankNodePrefix() {
        $c0715e6442e25456$var$blankNodePrefix = 0;
    }
    // ## Private methods
    // ### `_setBase` sets the base IRI to resolve relative IRIs
    _setBase(baseIRI) {
        if (!baseIRI) {
            this._base = "";
            this._basePath = "";
        } else {
            // Remove fragment if present
            const fragmentPos = baseIRI.indexOf("#");
            if (fragmentPos >= 0) baseIRI = baseIRI.substr(0, fragmentPos);
            // Set base IRI and its components
            this._base = baseIRI;
            this._basePath = baseIRI.indexOf("/") < 0 ? baseIRI : baseIRI.replace(/[^\/?]*(?:\?.*)?$/, "");
            baseIRI = baseIRI.match(/^(?:([a-z][a-z0-9+.-]*:))?(?:\/\/[^\/]*)?/i);
            this._baseRoot = baseIRI[0];
            this._baseScheme = baseIRI[1];
        }
    }
    // ### `_saveContext` stores the current parsing context
    // when entering a new scope (list, blank node, formula)
    _saveContext(type, graph, subject, predicate, object) {
        const n3Mode = this._n3Mode;
        this._contextStack.push({
            type: type,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph,
            inverse: n3Mode ? this._inversePredicate : false,
            blankPrefix: n3Mode ? this._prefixes._ : "",
            quantified: n3Mode ? this._quantified : null
        });
        // The settings below only apply to N3 streams
        if (n3Mode) {
            // Every new scope resets the predicate direction
            this._inversePredicate = false;
            // In N3, blank nodes are scoped to a formula
            // (using a dot as separator, as a blank node label cannot start with it)
            this._prefixes._ = this._graph ? `${this._graph.value}.` : ".";
            // Quantifiers are scoped to a formula
            this._quantified = Object.create(this._quantified);
        }
    }
    // ### `_restoreContext` restores the parent context
    // when leaving a scope (list, blank node, formula)
    _restoreContext(type, token) {
        // Obtain the previous context
        const context = this._contextStack.pop();
        if (!context || context.type !== type) return this._error(`Unexpected ${token.type}`, token);
        // Restore the quad of the previous context
        this._subject = context.subject;
        this._predicate = context.predicate;
        this._object = context.object;
        this._graph = context.graph;
        // Restore N3 context settings
        if (this._n3Mode) {
            this._inversePredicate = context.inverse;
            this._prefixes._ = context.blankPrefix;
            this._quantified = context.quantified;
        }
    }
    // ### `_readInTopContext` reads a token when in the top context
    _readInTopContext(token) {
        switch(token.type){
            // If an EOF token arrives in the top context, signal that we're done
            case "eof":
                if (this._graph !== null) return this._error("Unclosed graph", token);
                delete this._prefixes._;
                return this._callback(null, null, this._prefixes);
            // It could be a prefix declaration
            case "PREFIX":
                this._sparqlStyle = true;
            case "@prefix":
                return this._readPrefix;
            // It could be a base declaration
            case "BASE":
                this._sparqlStyle = true;
            case "@base":
                return this._readBaseIRI;
            // It could be a graph
            case "{":
                if (this._supportsNamedGraphs) {
                    this._graph = "";
                    this._subject = null;
                    return this._readSubject;
                }
            case "GRAPH":
                if (this._supportsNamedGraphs) return this._readNamedGraphLabel;
            // Otherwise, the next token must be a subject
            default:
                return this._readSubject(token);
        }
    }
    // ### `_readEntity` reads an IRI, prefixed name, blank node, or variable
    _readEntity(token, quantifier) {
        let value;
        switch(token.type){
            // Read a relative or absolute IRI
            case "IRI":
            case "typeIRI":
                const iri = this._resolveIRI(token.value);
                if (iri === null) return this._error("Invalid IRI", token);
                value = this._namedNode(iri);
                break;
            // Read a prefixed name
            case "type":
            case "prefixed":
                const prefix = this._prefixes[token.prefix];
                if (prefix === undefined) return this._error(`Undefined prefix "${token.prefix}:"`, token);
                value = this._namedNode(prefix + token.value);
                break;
            // Read a blank node
            case "blank":
                value = this._blankNode(this._prefixes[token.prefix] + token.value);
                break;
            // Read a variable
            case "var":
                value = this._variable(token.value.substr(1));
                break;
            // Everything else is not an entity
            default:
                return this._error(`Expected entity but got ${token.type}`, token);
        }
        // In N3 mode, replace the entity if it is quantified
        if (!quantifier && this._n3Mode && value.id in this._quantified) value = this._quantified[value.id];
        return value;
    }
    // ### `_readSubject` reads a quad's subject
    _readSubject(token) {
        this._predicate = null;
        switch(token.type){
            case "[":
                // Start a new quad with a new blank node as subject
                this._saveContext("blank", this._graph, this._subject = this._blankNode(), null, null);
                return this._readBlankNodeHead;
            case "(":
                // Start a new list
                this._saveContext("list", this._graph, this.RDF_NIL, null, null);
                this._subject = null;
                return this._readListItem;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._graph = this._blankNode(), null, null);
                return this._readSubject;
            case "}":
                // No subject; the graph in which we are reading is closed instead
                return this._readPunctuation(token);
            case "@forSome":
                if (!this._n3Mode) return this._error('Unexpected "@forSome"', token);
                this._subject = null;
                this._predicate = this.N3_FORSOME;
                this._quantifier = this._blankNode;
                return this._readQuantifierList;
            case "@forAll":
                if (!this._n3Mode) return this._error('Unexpected "@forAll"', token);
                this._subject = null;
                this._predicate = this.N3_FORALL;
                this._quantifier = this._variable;
                return this._readQuantifierList;
            case "literal":
                if (!this._n3Mode) return this._error("Unexpected literal", token);
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    return this._completeSubjectLiteral;
                } else this._subject = this._literal(token.value, this._namedNode(token.prefix));
                break;
            case "<<":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                this._saveContext("<<", this._graph, null, null, null);
                this._graph = null;
                return this._readSubject;
            default:
                // Read the subject entity
                if ((this._subject = this._readEntity(token)) === undefined) return;
                // In N3 mode, the subject might be a path
                if (this._n3Mode) return this._getPathReader(this._readPredicateOrNamedGraph);
        }
        // The next token must be a predicate,
        // or, if the subject was actually a graph IRI, a named graph
        return this._readPredicateOrNamedGraph;
    }
    // ### `_readPredicate` reads a quad's predicate
    _readPredicate(token) {
        const type = token.type;
        switch(type){
            case "inverse":
                this._inversePredicate = true;
            case "abbreviation":
                this._predicate = this.ABBREVIATIONS[token.value];
                break;
            case ".":
            case "]":
            case "}":
                // Expected predicate didn't come, must have been trailing semicolon
                if (this._predicate === null) return this._error(`Unexpected ${type}`, token);
                this._subject = null;
                return type === "]" ? this._readBlankNodeTail(token) : this._readPunctuation(token);
            case ";":
                // Additional semicolons can be safely ignored
                return this._predicate !== null ? this._readPredicate : this._error("Expected predicate but got ;", token);
            case "[":
                if (this._n3Mode) {
                    // Start a new quad with a new blank node as subject
                    this._saveContext("blank", this._graph, this._subject, this._subject = this._blankNode(), null);
                    return this._readBlankNodeHead;
                }
            case "blank":
                if (!this._n3Mode) return this._error("Disallowed blank node as predicate", token);
            default:
                if ((this._predicate = this._readEntity(token)) === undefined) return;
        }
        // The next token must be an object
        return this._readObject;
    }
    // ### `_readObject` reads a quad's object
    _readObject(token) {
        switch(token.type){
            case "literal":
                // Regular literal, can still get a datatype or language
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    return this._readDataTypeOrLang;
                } else this._object = this._literal(token.value, this._namedNode(token.prefix));
                break;
            case "[":
                // Start a new quad with a new blank node as subject
                this._saveContext("blank", this._graph, this._subject, this._predicate, this._subject = this._blankNode());
                return this._readBlankNodeHead;
            case "(":
                // Start a new list
                this._saveContext("list", this._graph, this._subject, this._predicate, this.RDF_NIL);
                this._subject = null;
                return this._readListItem;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._subject, this._predicate, this._graph = this._blankNode());
                return this._readSubject;
            case "<<":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                this._saveContext("<<", this._graph, this._subject, this._predicate, null);
                this._graph = null;
                return this._readSubject;
            default:
                // Read the object entity
                if ((this._object = this._readEntity(token)) === undefined) return;
                // In N3 mode, the object might be a path
                if (this._n3Mode) return this._getPathReader(this._getContextEndReader());
        }
        return this._getContextEndReader();
    }
    // ### `_readPredicateOrNamedGraph` reads a quad's predicate, or a named graph
    _readPredicateOrNamedGraph(token) {
        return token.type === "{" ? this._readGraph(token) : this._readPredicate(token);
    }
    // ### `_readGraph` reads a graph
    _readGraph(token) {
        if (token.type !== "{") return this._error(`Expected graph but got ${token.type}`, token);
        // The "subject" we read is actually the GRAPH's label
        this._graph = this._subject, this._subject = null;
        return this._readSubject;
    }
    // ### `_readBlankNodeHead` reads the head of a blank node
    _readBlankNodeHead(token) {
        if (token.type === "]") {
            this._subject = null;
            return this._readBlankNodeTail(token);
        } else {
            this._predicate = null;
            return this._readPredicate(token);
        }
    }
    // ### `_readBlankNodeTail` reads the end of a blank node
    _readBlankNodeTail(token) {
        if (token.type !== "]") return this._readBlankNodePunctuation(token);
        // Store blank node quad
        if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
        // Restore the parent context containing this blank node
        const empty = this._predicate === null;
        this._restoreContext("blank", token);
        // If the blank node was the object, restore previous context and read punctuation
        if (this._object !== null) return this._getContextEndReader();
        else if (this._predicate !== null) return this._readObject;
        else // If the blank node was empty, it could be a named graph label
        return empty ? this._readPredicateOrNamedGraph : this._readPredicateAfterBlank;
    }
    // ### `_readPredicateAfterBlank` reads a predicate after an anonymous blank node
    _readPredicateAfterBlank(token) {
        switch(token.type){
            case ".":
            case "}":
                // No predicate is coming if the triple is terminated here
                this._subject = null;
                return this._readPunctuation(token);
            default:
                return this._readPredicate(token);
        }
    }
    // ### `_readListItem` reads items from a list
    _readListItem(token) {
        let item = null, list = null, next = this._readListItem; // The next function to execute
        const previousList = this._subject, stack = this._contextStack, parent = stack[stack.length - 1]; // The parent containing the current list
        switch(token.type){
            case "[":
                // Stack the current list quad and start a new quad with a blank node as subject
                this._saveContext("blank", this._graph, list = this._blankNode(), this.RDF_FIRST, this._subject = item = this._blankNode());
                next = this._readBlankNodeHead;
                break;
            case "(":
                // Stack the current list quad and start a new list
                this._saveContext("list", this._graph, list = this._blankNode(), this.RDF_FIRST, this.RDF_NIL);
                this._subject = null;
                break;
            case ")":
                // Closing the list; restore the parent context
                this._restoreContext("list", token);
                // If this list is contained within a parent list, return the membership quad here.
                // This will be `<parent list element> rdf:first <this list>.`.
                if (stack.length !== 0 && stack[stack.length - 1].type === "list") this._emit(this._subject, this._predicate, this._object, this._graph);
                // Was this list the parent's subject?
                if (this._predicate === null) {
                    // The next token is the predicate
                    next = this._readPredicate;
                    // No list tail if this was an empty list
                    if (this._subject === this.RDF_NIL) return next;
                } else {
                    next = this._getContextEndReader();
                    // No list tail if this was an empty list
                    if (this._object === this.RDF_NIL) return next;
                }
                // Close the list by making the head nil
                list = this.RDF_NIL;
                break;
            case "literal":
                // Regular literal, can still get a datatype or language
                if (token.prefix.length === 0) {
                    this._literalValue = token.value;
                    next = this._readListItemDataTypeOrLang;
                } else {
                    item = this._literal(token.value, this._namedNode(token.prefix));
                    next = this._getContextEndReader();
                }
                break;
            case "{":
                // Start a new formula
                if (!this._n3Mode) return this._error("Unexpected graph", token);
                this._saveContext("formula", this._graph, this._subject, this._predicate, this._graph = this._blankNode());
                return this._readSubject;
            default:
                if ((item = this._readEntity(token)) === undefined) return;
        }
        // Create a new blank node if no item head was assigned yet
        if (list === null) this._subject = list = this._blankNode();
        // Is this the first element of the list?
        if (previousList === null) {
            // This list is either the subject or the object of its parent
            if (parent.predicate === null) parent.subject = list;
            else parent.object = list;
        } else // Continue the previous list with the current list
        this._emit(previousList, this.RDF_REST, list, this._graph);
        // If an item was read, add it to the list
        if (item !== null) {
            // In N3 mode, the item might be a path
            if (this._n3Mode && (token.type === "IRI" || token.type === "prefixed")) {
                // Create a new context to add the item's path
                this._saveContext("item", this._graph, list, this.RDF_FIRST, item);
                this._subject = item, this._predicate = null;
                // _readPath will restore the context and output the item
                return this._getPathReader(this._readListItem);
            }
            // Output the item
            this._emit(list, this.RDF_FIRST, item, this._graph);
        }
        return next;
    }
    // ### `_readDataTypeOrLang` reads an _optional_ datatype or language
    _readDataTypeOrLang(token) {
        return this._completeObjectLiteral(token, false);
    }
    // ### `_readListItemDataTypeOrLang` reads an _optional_ datatype or language in a list
    _readListItemDataTypeOrLang(token) {
        return this._completeObjectLiteral(token, true);
    }
    // ### `_completeLiteral` completes a literal with an optional datatype or language
    _completeLiteral(token) {
        // Create a simple string literal by default
        let literal = this._literal(this._literalValue);
        switch(token.type){
            // Create a datatyped literal
            case "type":
            case "typeIRI":
                const datatype = this._readEntity(token);
                if (datatype === undefined) return; // No datatype means an error occurred
                literal = this._literal(this._literalValue, datatype);
                token = null;
                break;
            // Create a language-tagged string
            case "langcode":
                literal = this._literal(this._literalValue, token.value);
                token = null;
                break;
        }
        return {
            token: token,
            literal: literal
        };
    }
    // Completes a literal in subject position
    _completeSubjectLiteral(token) {
        this._subject = this._completeLiteral(token).literal;
        return this._readPredicateOrNamedGraph;
    }
    // Completes a literal in object position
    _completeObjectLiteral(token, listItem) {
        const completed = this._completeLiteral(token);
        if (!completed) return;
        this._object = completed.literal;
        // If this literal was part of a list, write the item
        // (we could also check the context stack, but passing in a flag is faster)
        if (listItem) this._emit(this._subject, this.RDF_FIRST, this._object, this._graph);
        // If the token was consumed, continue with the rest of the input
        if (completed.token === null) return this._getContextEndReader();
        else {
            this._readCallback = this._getContextEndReader();
            return this._readCallback(completed.token);
        }
    }
    // ### `_readFormulaTail` reads the end of a formula
    _readFormulaTail(token) {
        if (token.type !== "}") return this._readPunctuation(token);
        // Store the last quad of the formula
        if (this._subject !== null) this._emit(this._subject, this._predicate, this._object, this._graph);
        // Restore the parent context containing this formula
        this._restoreContext("formula", token);
        // If the formula was the subject, continue reading the predicate.
        // If the formula was the object, read punctuation.
        return this._object === null ? this._readPredicate : this._getContextEndReader();
    }
    // ### `_readPunctuation` reads punctuation between quads or quad parts
    _readPunctuation(token) {
        let next, graph = this._graph;
        const subject = this._subject, inversePredicate = this._inversePredicate;
        switch(token.type){
            // A closing brace ends a graph
            case "}":
                if (this._graph === null) return this._error("Unexpected graph closing", token);
                if (this._n3Mode) return this._readFormulaTail(token);
                this._graph = null;
            // A dot just ends the statement, without sharing anything with the next
            case ".":
                this._subject = null;
                next = this._contextStack.length ? this._readSubject : this._readInTopContext;
                if (inversePredicate) this._inversePredicate = false;
                break;
            // Semicolon means the subject is shared; predicate and object are different
            case ";":
                next = this._readPredicate;
                break;
            // Comma means both the subject and predicate are shared; the object is different
            case ",":
                next = this._readObject;
                break;
            // {| means that the current triple is annotated with predicate-object pairs.
            case "{|":
                if (!this._supportsRDFStar) return this._error("Unexpected RDF* syntax", token);
                // Continue using the last triple as quoted triple subject for the predicate-object pairs.
                const predicate = this._predicate, object = this._object;
                this._subject = this._quad(subject, predicate, object, this.DEFAULTGRAPH);
                next = this._readPredicate;
                break;
            // |} means that the current quoted triple in annotation syntax is finalized.
            case "|}":
                if (this._subject.termType !== "Quad") return this._error("Unexpected asserted triple closing", token);
                this._subject = null;
                next = this._readPunctuation;
                break;
            default:
                // An entity means this is a quad (only allowed if not already inside a graph)
                if (this._supportsQuads && this._graph === null && (graph = this._readEntity(token)) !== undefined) {
                    next = this._readQuadPunctuation;
                    break;
                }
                return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
        }
        // A quad has been completed now, so return it
        if (subject !== null) {
            const predicate = this._predicate, object = this._object;
            if (!inversePredicate) this._emit(subject, predicate, object, graph);
            else this._emit(object, predicate, subject, graph);
        }
        return next;
    }
    // ### `_readBlankNodePunctuation` reads punctuation in a blank node
    _readBlankNodePunctuation(token) {
        let next;
        switch(token.type){
            // Semicolon means the subject is shared; predicate and object are different
            case ";":
                next = this._readPredicate;
                break;
            // Comma means both the subject and predicate are shared; the object is different
            case ",":
                next = this._readObject;
                break;
            default:
                return this._error(`Expected punctuation to follow "${this._object.id}"`, token);
        }
        // A quad has been completed now, so return it
        this._emit(this._subject, this._predicate, this._object, this._graph);
        return next;
    }
    // ### `_readQuadPunctuation` reads punctuation after a quad
    _readQuadPunctuation(token) {
        if (token.type !== ".") return this._error("Expected dot to follow quad", token);
        return this._readInTopContext;
    }
    // ### `_readPrefix` reads the prefix of a prefix declaration
    _readPrefix(token) {
        if (token.type !== "prefix") return this._error("Expected prefix to follow @prefix", token);
        this._prefix = token.value;
        return this._readPrefixIRI;
    }
    // ### `_readPrefixIRI` reads the IRI of a prefix declaration
    _readPrefixIRI(token) {
        if (token.type !== "IRI") return this._error(`Expected IRI to follow prefix "${this._prefix}:"`, token);
        const prefixNode = this._readEntity(token);
        this._prefixes[this._prefix] = prefixNode.value;
        this._prefixCallback(this._prefix, prefixNode);
        return this._readDeclarationPunctuation;
    }
    // ### `_readBaseIRI` reads the IRI of a base declaration
    _readBaseIRI(token) {
        const iri = token.type === "IRI" && this._resolveIRI(token.value);
        if (!iri) return this._error("Expected valid IRI to follow base declaration", token);
        this._setBase(iri);
        return this._readDeclarationPunctuation;
    }
    // ### `_readNamedGraphLabel` reads the label of a named graph
    _readNamedGraphLabel(token) {
        switch(token.type){
            case "IRI":
            case "blank":
            case "prefixed":
                return this._readSubject(token), this._readGraph;
            case "[":
                return this._readNamedGraphBlankLabel;
            default:
                return this._error("Invalid graph label", token);
        }
    }
    // ### `_readNamedGraphLabel` reads a blank node label of a named graph
    _readNamedGraphBlankLabel(token) {
        if (token.type !== "]") return this._error("Invalid graph label", token);
        this._subject = this._blankNode();
        return this._readGraph;
    }
    // ### `_readDeclarationPunctuation` reads the punctuation of a declaration
    _readDeclarationPunctuation(token) {
        // SPARQL-style declarations don't have punctuation
        if (this._sparqlStyle) {
            this._sparqlStyle = false;
            return this._readInTopContext(token);
        }
        if (token.type !== ".") return this._error("Expected declaration to end with a dot", token);
        return this._readInTopContext;
    }
    // Reads a list of quantified symbols from a @forSome or @forAll statement
    _readQuantifierList(token) {
        let entity;
        switch(token.type){
            case "IRI":
            case "prefixed":
                if ((entity = this._readEntity(token, true)) !== undefined) break;
            default:
                return this._error(`Unexpected ${token.type}`, token);
        }
        // Without explicit quantifiers, map entities to a quantified entity
        if (!this._explicitQuantifiers) this._quantified[entity.id] = this._quantifier(this._blankNode().value);
        else {
            // If this is the first item, start a new quantifier list
            if (this._subject === null) this._emit(this._graph || this.DEFAULTGRAPH, this._predicate, this._subject = this._blankNode(), this.QUANTIFIERS_GRAPH);
            else this._emit(this._subject, this.RDF_REST, this._subject = this._blankNode(), this.QUANTIFIERS_GRAPH);
            // Output the list item
            this._emit(this._subject, this.RDF_FIRST, entity, this.QUANTIFIERS_GRAPH);
        }
        return this._readQuantifierPunctuation;
    }
    // Reads punctuation from a @forSome or @forAll statement
    _readQuantifierPunctuation(token) {
        // Read more quantifiers
        if (token.type === ",") return this._readQuantifierList;
        else {
            // With explicit quantifiers, close the quantifier list
            if (this._explicitQuantifiers) {
                this._emit(this._subject, this.RDF_REST, this.RDF_NIL, this.QUANTIFIERS_GRAPH);
                this._subject = null;
            }
            // Read a dot
            this._readCallback = this._getContextEndReader();
            return this._readCallback(token);
        }
    }
    // ### `_getPathReader` reads a potential path and then resumes with the given function
    _getPathReader(afterPath) {
        this._afterPath = afterPath;
        return this._readPath;
    }
    // ### `_readPath` reads a potential path
    _readPath(token) {
        switch(token.type){
            // Forward path
            case "!":
                return this._readForwardPath;
            // Backward path
            case "^":
                return this._readBackwardPath;
            // Not a path; resume reading where we left off
            default:
                const stack = this._contextStack, parent = stack.length && stack[stack.length - 1];
                // If we were reading a list item, we still need to output it
                if (parent && parent.type === "item") {
                    // The list item is the remaining subejct after reading the path
                    const item = this._subject;
                    // Switch back to the context of the list
                    this._restoreContext("item", token);
                    // Output the list item
                    this._emit(this._subject, this.RDF_FIRST, item, this._graph);
                }
                return this._afterPath(token);
        }
    }
    // ### `_readForwardPath` reads a '!' path
    _readForwardPath(token) {
        let subject, predicate;
        const object = this._blankNode();
        // The next token is the predicate
        if ((predicate = this._readEntity(token)) === undefined) return;
        // If we were reading a subject, replace the subject by the path's object
        if (this._predicate === null) subject = this._subject, this._subject = object;
        else subject = this._object, this._object = object;
        // Emit the path's current quad and read its next section
        this._emit(subject, predicate, object, this._graph);
        return this._readPath;
    }
    // ### `_readBackwardPath` reads a '^' path
    _readBackwardPath(token) {
        const subject = this._blankNode();
        let predicate, object;
        // The next token is the predicate
        if ((predicate = this._readEntity(token)) === undefined) return;
        // If we were reading a subject, replace the subject by the path's subject
        if (this._predicate === null) object = this._subject, this._subject = subject;
        else object = this._object, this._object = subject;
        // Emit the path's current quad and read its next section
        this._emit(subject, predicate, object, this._graph);
        return this._readPath;
    }
    // ### `_readRDFStarTailOrGraph` reads the graph of a nested RDF* quad or the end of a nested RDF* triple
    _readRDFStarTailOrGraph(token) {
        if (token.type !== ">>") {
            // An entity means this is a quad (only allowed if not already inside a graph)
            if (this._supportsQuads && this._graph === null && (this._graph = this._readEntity(token)) !== undefined) return this._readRDFStarTail;
            return this._error(`Expected >> to follow "${this._object.id}"`, token);
        }
        return this._readRDFStarTail(token);
    }
    // ### `_readRDFStarTail` reads the end of a nested RDF* triple
    _readRDFStarTail(token) {
        if (token.type !== ">>") return this._error(`Expected >> but got ${token.type}`, token);
        // Read the quad and restore the previous context
        const quad = this._quad(this._subject, this._predicate, this._object, this._graph || this.DEFAULTGRAPH);
        this._restoreContext("<<", token);
        // If the triple was the subject, continue by reading the predicate.
        if (this._subject === null) {
            this._subject = quad;
            return this._readPredicate;
        } else {
            this._object = quad;
            return this._getContextEndReader();
        }
    }
    // ### `_getContextEndReader` gets the next reader function at the end of a context
    _getContextEndReader() {
        const contextStack = this._contextStack;
        if (!contextStack.length) return this._readPunctuation;
        switch(contextStack[contextStack.length - 1].type){
            case "blank":
                return this._readBlankNodeTail;
            case "list":
                return this._readListItem;
            case "formula":
                return this._readFormulaTail;
            case "<<":
                return this._readRDFStarTailOrGraph;
        }
    }
    // ### `_emit` sends a quad through the callback
    _emit(subject, predicate, object, graph) {
        this._callback(null, this._quad(subject, predicate, object, graph || this.DEFAULTGRAPH));
    }
    // ### `_error` emits an error message through the callback
    _error(message, token) {
        const err = new Error(`${message} on line ${token.line}.`);
        err.context = {
            token: token,
            line: token.line,
            previousToken: this._lexer.previousToken
        };
        this._callback(err);
        this._callback = $c0715e6442e25456$var$noop;
    }
    // ### `_resolveIRI` resolves an IRI against the base path
    _resolveIRI(iri) {
        return /^[a-z][a-z0-9+.-]*:/i.test(iri) ? iri : this._resolveRelativeIRI(iri);
    }
    // ### `_resolveRelativeIRI` resolves an IRI against the base path,
    // assuming that a base path has been set and that the IRI is indeed relative
    _resolveRelativeIRI(iri) {
        // An empty relative IRI indicates the base IRI
        if (!iri.length) return this._base;
        // Decide resolving strategy based in the first character
        switch(iri[0]){
            // Resolve relative fragment IRIs against the base IRI
            case "#":
                return this._base + iri;
            // Resolve relative query string IRIs by replacing the query string
            case "?":
                return this._base.replace(/(?:\?.*)?$/, iri);
            // Resolve root-relative IRIs at the root of the base IRI
            case "/":
                // Resolve scheme-relative IRIs to the scheme
                return (iri[1] === "/" ? this._baseScheme : this._baseRoot) + this._removeDotSegments(iri);
            // Resolve all other IRIs at the base IRI's path
            default:
                // Relative IRIs cannot contain a colon in the first path segment
                return /^[^/:]*:/.test(iri) ? null : this._removeDotSegments(this._basePath + iri);
        }
    }
    // ### `_removeDotSegments` resolves './' and '../' path segments in an IRI as per RFC3986
    _removeDotSegments(iri) {
        // Don't modify the IRI if it does not contain any dot segments
        if (!/(^|\/)\.\.?($|[/#?])/.test(iri)) return iri;
        // Start with an imaginary slash before the IRI in order to resolve trailing './' and '../'
        const length = iri.length;
        let result = "", i = -1, pathStart = -1, segmentStart = 0, next = "/";
        while(i < length){
            switch(next){
                // The path starts with the first slash after the authority
                case ":":
                    if (pathStart < 0) {
                        // Skip two slashes before the authority
                        if (iri[++i] === "/" && iri[++i] === "/") // Skip to slash after the authority
                        while((pathStart = i + 1) < length && iri[pathStart] !== "/")i = pathStart;
                    }
                    break;
                // Don't modify a query string or fragment
                case "?":
                case "#":
                    i = length;
                    break;
                // Handle '/.' or '/..' path segments
                case "/":
                    if (iri[i + 1] === ".") {
                        next = iri[++i + 1];
                        switch(next){
                            // Remove a '/.' segment
                            case "/":
                                result += iri.substring(segmentStart, i - 1);
                                segmentStart = i + 1;
                                break;
                            // Remove a trailing '/.' segment
                            case undefined:
                            case "?":
                            case "#":
                                return result + iri.substring(segmentStart, i) + iri.substr(i + 1);
                            // Remove a '/..' segment
                            case ".":
                                next = iri[++i + 1];
                                if (next === undefined || next === "/" || next === "?" || next === "#") {
                                    result += iri.substring(segmentStart, i - 2);
                                    // Try to remove the parent path from result
                                    if ((segmentStart = result.lastIndexOf("/")) >= pathStart) result = result.substr(0, segmentStart);
                                    // Remove a trailing '/..' segment
                                    if (next !== "/") return `${result}/${iri.substr(i + 1)}`;
                                    segmentStart = i + 1;
                                }
                        }
                    }
            }
            next = iri[++i];
        }
        return result + iri.substring(segmentStart);
    }
    // ## Public methods
    // ### `parse` parses the N3 input and emits each parsed quad through the callback
    parse(input, quadCallback, prefixCallback) {
        // The read callback is the next function to be executed when a token arrives.
        // We start reading in the top context.
        this._readCallback = this._readInTopContext;
        this._sparqlStyle = false;
        this._prefixes = Object.create(null);
        this._prefixes._ = this._blankNodePrefix ? this._blankNodePrefix.substr(2) : `b${$c0715e6442e25456$var$blankNodePrefix++}_`;
        this._prefixCallback = prefixCallback || $c0715e6442e25456$var$noop;
        this._inversePredicate = false;
        this._quantified = Object.create(null);
        // Parse synchronously if no quad callback is given
        if (!quadCallback) {
            const quads = [];
            let error;
            this._callback = (e, t)=>{
                e ? error = e : t && quads.push(t);
            };
            this._lexer.tokenize(input).every((token)=>{
                return this._readCallback = this._readCallback(token);
            });
            if (error) throw error;
            return quads;
        }
        // Parse asynchronously otherwise, executing the read callback when a token arrives
        this._callback = quadCallback;
        this._lexer.tokenize(input, (error, token)=>{
            if (error !== null) this._callback(error), this._callback = $c0715e6442e25456$var$noop;
            else if (this._readCallback) this._readCallback = this._readCallback(token);
        });
    }
}
// The empty function
function $c0715e6442e25456$var$noop() {}
// Initializes the parser with the given data factory
function $c0715e6442e25456$var$initDataFactory(parser, factory) {
    // Set factory methods
    const namedNode = factory.namedNode;
    parser._namedNode = namedNode;
    parser._blankNode = factory.blankNode;
    parser._literal = factory.literal;
    parser._variable = factory.variable;
    parser._quad = factory.quad;
    parser.DEFAULTGRAPH = factory.defaultGraph();
    // Set common named nodes
    parser.RDF_FIRST = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.first);
    parser.RDF_REST = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.rest);
    parser.RDF_NIL = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.nil);
    parser.N3_FORALL = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).r.forAll);
    parser.N3_FORSOME = namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).r.forSome);
    parser.ABBREVIATIONS = {
        "a": namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.type),
        "=": namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).owl.sameAs),
        ">": namedNode((0, $b50e49a75dcd9196$export$2e2bcd8739ae039).log.implies)
    };
    parser.QUANTIFIERS_GRAPH = namedNode("urn:n3:quantifiers");
}
$c0715e6442e25456$var$initDataFactory($c0715e6442e25456$export$2e2bcd8739ae039.prototype, (0, $712f170b9f5279d6$export$2e2bcd8739ae039));


// **N3Writer** writes N3 documents.



const $bab8cb0a961d0e7d$var$DEFAULTGRAPH = (0, $712f170b9f5279d6$export$2e2bcd8739ae039).defaultGraph();
const { rdf: $bab8cb0a961d0e7d$var$rdf, xsd: $bab8cb0a961d0e7d$var$xsd } = (0, $b50e49a75dcd9196$export$2e2bcd8739ae039);
// Characters in literals that require escaping
const $bab8cb0a961d0e7d$var$escape = /["\\\t\n\r\b\f\u0000-\u0019\ud800-\udbff]/, $bab8cb0a961d0e7d$var$escapeAll = /["\\\t\n\r\b\f\u0000-\u0019]|[\ud800-\udbff][\udc00-\udfff]/g, $bab8cb0a961d0e7d$var$escapedCharacters = {
    "\\": "\\\\",
    '"': '\\"',
    "	": "\\t",
    "\n": "\\n",
    "\r": "\\r",
    "\b": "\\b",
    "\f": "\\f"
};
// ## Placeholder class to represent already pretty-printed terms
class $bab8cb0a961d0e7d$var$SerializedTerm extends (0, $712f170b9f5279d6$export$656c1e606ad06131) {
    // Pretty-printed nodes are not equal to any other node
    // (e.g., [] does not equal [])
    equals(other) {
        return other === this;
    }
}
class $bab8cb0a961d0e7d$export$2e2bcd8739ae039 {
    constructor(outputStream, options){
        // ### `_prefixRegex` matches a prefixed name or IRI that begins with one of the added prefixes
        this._prefixRegex = /$0^/;
        // Shift arguments if the first argument is not a stream
        if (outputStream && typeof outputStream.write !== "function") options = outputStream, outputStream = null;
        options = options || {};
        this._lists = options.lists;
        // If no output stream given, send the output as string through the end callback
        if (!outputStream) {
            let output = "";
            this._outputStream = {
                write (chunk, encoding, done) {
                    output += chunk;
                    done && done();
                },
                end: (done)=>{
                    done && done(null, output);
                }
            };
            this._endStream = true;
        } else {
            this._outputStream = outputStream;
            this._endStream = options.end === undefined ? true : !!options.end;
        }
        // Initialize writer, depending on the format
        this._subject = null;
        if (!/triple|quad/i.test(options.format)) {
            this._lineMode = false;
            this._graph = $bab8cb0a961d0e7d$var$DEFAULTGRAPH;
            this._prefixIRIs = Object.create(null);
            options.prefixes && this.addPrefixes(options.prefixes);
            if (options.baseIRI) {
                this._baseMatcher = new RegExp(`^${$bab8cb0a961d0e7d$var$escapeRegex(options.baseIRI)}${options.baseIRI.endsWith("/") ? "" : "[#?]"}`);
                this._baseLength = options.baseIRI.length;
            }
        } else {
            this._lineMode = true;
            this._writeQuad = this._writeQuadLine;
        }
    }
    // ## Private methods
    // ### Whether the current graph is the default graph
    get _inDefaultGraph() {
        return $bab8cb0a961d0e7d$var$DEFAULTGRAPH.equals(this._graph);
    }
    // ### `_write` writes the argument to the output stream
    _write(string, callback) {
        this._outputStream.write(string, "utf8", callback);
    }
    // ### `_writeQuad` writes the quad to the output stream
    _writeQuad(subject, predicate, object, graph, done) {
        try {
            // Write the graph's label if it has changed
            if (!graph.equals(this._graph)) {
                // Close the previous graph and start the new one
                this._write((this._subject === null ? "" : this._inDefaultGraph ? ".\n" : "\n}\n") + ($bab8cb0a961d0e7d$var$DEFAULTGRAPH.equals(graph) ? "" : `${this._encodeIriOrBlank(graph)} {\n`));
                this._graph = graph;
                this._subject = null;
            }
            // Don't repeat the subject if it's the same
            if (subject.equals(this._subject)) {
                // Don't repeat the predicate if it's the same
                if (predicate.equals(this._predicate)) this._write(`, ${this._encodeObject(object)}`, done);
                else this._write(`;\n    ${this._encodePredicate(this._predicate = predicate)} ${this._encodeObject(object)}`, done);
            } else this._write(`${(this._subject === null ? "" : ".\n") + this._encodeSubject(this._subject = subject)} ${this._encodePredicate(this._predicate = predicate)} ${this._encodeObject(object)}`, done);
        } catch (error) {
            done && done(error);
        }
    }
    // ### `_writeQuadLine` writes the quad to the output stream as a single line
    _writeQuadLine(subject, predicate, object, graph, done) {
        // Write the quad without prefixes
        delete this._prefixMatch;
        this._write(this.quadToString(subject, predicate, object, graph), done);
    }
    // ### `quadToString` serializes a quad as a string
    quadToString(subject, predicate, object, graph) {
        return `${this._encodeSubject(subject)} ${this._encodeIriOrBlank(predicate)} ${this._encodeObject(object)}${graph && graph.value ? ` ${this._encodeIriOrBlank(graph)} .\n` : " .\n"}`;
    }
    // ### `quadsToString` serializes an array of quads as a string
    quadsToString(quads) {
        return quads.map((t)=>{
            return this.quadToString(t.subject, t.predicate, t.object, t.graph);
        }).join("");
    }
    // ### `_encodeSubject` represents a subject
    _encodeSubject(entity) {
        return entity.termType === "Quad" ? this._encodeQuad(entity) : this._encodeIriOrBlank(entity);
    }
    // ### `_encodeIriOrBlank` represents an IRI or blank node
    _encodeIriOrBlank(entity) {
        // A blank node or list is represented as-is
        if (entity.termType !== "NamedNode") {
            // If it is a list head, pretty-print it
            if (this._lists && entity.value in this._lists) entity = this.list(this._lists[entity.value]);
            return "id" in entity ? entity.id : `_:${entity.value}`;
        }
        let iri = entity.value;
        // Use relative IRIs if requested and possible
        if (this._baseMatcher && this._baseMatcher.test(iri)) iri = iri.substr(this._baseLength);
        // Escape special characters
        if ($bab8cb0a961d0e7d$var$escape.test(iri)) iri = iri.replace($bab8cb0a961d0e7d$var$escapeAll, $bab8cb0a961d0e7d$var$characterReplacer);
        // Try to represent the IRI as prefixed name
        const prefixMatch = this._prefixRegex.exec(iri);
        return !prefixMatch ? `<${iri}>` : !prefixMatch[1] ? iri : this._prefixIRIs[prefixMatch[1]] + prefixMatch[2];
    }
    // ### `_encodeLiteral` represents a literal
    _encodeLiteral(literal) {
        // Escape special characters
        let value = literal.value;
        if ($bab8cb0a961d0e7d$var$escape.test(value)) value = value.replace($bab8cb0a961d0e7d$var$escapeAll, $bab8cb0a961d0e7d$var$characterReplacer);
        // Write a language-tagged literal
        if (literal.language) return `"${value}"@${literal.language}`;
        // Write dedicated literals per data type
        if (this._lineMode) {
            // Only abbreviate strings in N-Triples or N-Quads
            if (literal.datatype.value === $bab8cb0a961d0e7d$var$xsd.string) return `"${value}"`;
        } else // Use common datatype abbreviations in Turtle or TriG
        switch(literal.datatype.value){
            case $bab8cb0a961d0e7d$var$xsd.string:
                return `"${value}"`;
            case $bab8cb0a961d0e7d$var$xsd.boolean:
                if (value === "true" || value === "false") return value;
                break;
            case $bab8cb0a961d0e7d$var$xsd.integer:
                if (/^[+-]?\d+$/.test(value)) return value;
                break;
            case $bab8cb0a961d0e7d$var$xsd.decimal:
                if (/^[+-]?\d*\.\d+$/.test(value)) return value;
                break;
            case $bab8cb0a961d0e7d$var$xsd.double:
                if (/^[+-]?(?:\d+\.\d*|\.?\d+)[eE][+-]?\d+$/.test(value)) return value;
                break;
        }
        // Write a regular datatyped literal
        return `"${value}"^^${this._encodeIriOrBlank(literal.datatype)}`;
    }
    // ### `_encodePredicate` represents a predicate
    _encodePredicate(predicate) {
        return predicate.value === $bab8cb0a961d0e7d$var$rdf.type ? "a" : this._encodeIriOrBlank(predicate);
    }
    // ### `_encodeObject` represents an object
    _encodeObject(object) {
        switch(object.termType){
            case "Quad":
                return this._encodeQuad(object);
            case "Literal":
                return this._encodeLiteral(object);
            default:
                return this._encodeIriOrBlank(object);
        }
    }
    // ### `_encodeQuad` encodes an RDF* quad
    _encodeQuad({ subject: subject, predicate: predicate, object: object, graph: graph }) {
        return `<<${this._encodeSubject(subject)} ${this._encodePredicate(predicate)} ${this._encodeObject(object)}${(0, $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8)(graph) ? "" : ` ${this._encodeIriOrBlank(graph)}`}>>`;
    }
    // ### `_blockedWrite` replaces `_write` after the writer has been closed
    _blockedWrite() {
        throw new Error("Cannot write because the writer has been closed.");
    }
    // ### `addQuad` adds the quad to the output stream
    addQuad(subject, predicate, object, graph, done) {
        // The quad was given as an object, so shift parameters
        if (object === undefined) this._writeQuad(subject.subject, subject.predicate, subject.object, subject.graph, predicate);
        else if (typeof graph === "function") this._writeQuad(subject, predicate, object, $bab8cb0a961d0e7d$var$DEFAULTGRAPH, graph);
        else this._writeQuad(subject, predicate, object, graph || $bab8cb0a961d0e7d$var$DEFAULTGRAPH, done);
    }
    // ### `addQuads` adds the quads to the output stream
    addQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.addQuad(quads[i]);
    }
    // ### `addPrefix` adds the prefix to the output stream
    addPrefix(prefix, iri, done) {
        const prefixes = {};
        prefixes[prefix] = iri;
        this.addPrefixes(prefixes, done);
    }
    // ### `addPrefixes` adds the prefixes to the output stream
    addPrefixes(prefixes, done) {
        // Ignore prefixes if not supported by the serialization
        if (!this._prefixIRIs) return done && done();
        // Write all new prefixes
        let hasPrefixes = false;
        for(let prefix in prefixes){
            let iri = prefixes[prefix];
            if (typeof iri !== "string") iri = iri.value;
            hasPrefixes = true;
            // Finish a possible pending quad
            if (this._subject !== null) {
                this._write(this._inDefaultGraph ? ".\n" : "\n}\n");
                this._subject = null, this._graph = "";
            }
            // Store and write the prefix
            this._prefixIRIs[iri] = prefix += ":";
            this._write(`@prefix ${prefix} <${iri}>.\n`);
        }
        // Recreate the prefix matcher
        if (hasPrefixes) {
            let IRIlist = "", prefixList = "";
            for(const prefixIRI in this._prefixIRIs){
                IRIlist += IRIlist ? `|${prefixIRI}` : prefixIRI;
                prefixList += (prefixList ? "|" : "") + this._prefixIRIs[prefixIRI];
            }
            IRIlist = $bab8cb0a961d0e7d$var$escapeRegex(IRIlist, /[\]\/\(\)\*\+\?\.\\\$]/g, "\\$&");
            this._prefixRegex = new RegExp(`^(?:${prefixList})[^\/]*$|` + `^(${IRIlist})([_a-zA-Z][\\-_a-zA-Z0-9]*)$`);
        }
        // End a prefix block with a newline
        this._write(hasPrefixes ? "\n" : "", done);
    }
    // ### `blank` creates a blank node with the given content
    blank(predicate, object) {
        let children = predicate, child, length;
        // Empty blank node
        if (predicate === undefined) children = [];
        else if (predicate.termType) children = [
            {
                predicate: predicate,
                object: object
            }
        ];
        else if (!("length" in predicate)) children = [
            predicate
        ];
        switch(length = children.length){
            // Generate an empty blank node
            case 0:
                return new $bab8cb0a961d0e7d$var$SerializedTerm("[]");
            // Generate a non-nested one-triple blank node
            case 1:
                child = children[0];
                if (!(child.object instanceof $bab8cb0a961d0e7d$var$SerializedTerm)) return new $bab8cb0a961d0e7d$var$SerializedTerm(`[ ${this._encodePredicate(child.predicate)} ${this._encodeObject(child.object)} ]`);
            // Generate a multi-triple or nested blank node
            default:
                let contents = "[";
                // Write all triples in order
                for(let i = 0; i < length; i++){
                    child = children[i];
                    // Write only the object is the predicate is the same as the previous
                    if (child.predicate.equals(predicate)) contents += `, ${this._encodeObject(child.object)}`;
                    else {
                        contents += `${(i ? ";\n  " : "\n  ") + this._encodePredicate(child.predicate)} ${this._encodeObject(child.object)}`;
                        predicate = child.predicate;
                    }
                }
                return new $bab8cb0a961d0e7d$var$SerializedTerm(`${contents}\n]`);
        }
    }
    // ### `list` creates a list node with the given content
    list(elements) {
        const length = elements && elements.length || 0, contents = new Array(length);
        for(let i = 0; i < length; i++)contents[i] = this._encodeObject(elements[i]);
        return new $bab8cb0a961d0e7d$var$SerializedTerm(`(${contents.join(" ")})`);
    }
    // ### `end` signals the end of the output stream
    end(done) {
        // Finish a possible pending quad
        if (this._subject !== null) {
            this._write(this._inDefaultGraph ? ".\n" : "\n}\n");
            this._subject = null;
        }
        // Disallow further writing
        this._write = this._blockedWrite;
        // Try to end the underlying stream, ensuring done is called exactly one time
        let singleDone = done && ((error, result)=>{
            singleDone = null, done(error, result);
        });
        if (this._endStream) try {
            return this._outputStream.end(singleDone);
        } catch (error) {}
        singleDone && singleDone();
    }
}
// Replaces a character by its escaped version
function $bab8cb0a961d0e7d$var$characterReplacer(character) {
    // Replace a single character by its escaped version
    let result = $bab8cb0a961d0e7d$var$escapedCharacters[character];
    if (result === undefined) {
        // Replace a single character with its 4-bit unicode escape sequence
        if (character.length === 1) {
            result = character.charCodeAt(0).toString(16);
            result = "\\u0000".substr(0, 6 - result.length) + result;
        } else {
            result = ((character.charCodeAt(0) - 0xD800) * 0x400 + character.charCodeAt(1) + 0x2400).toString(16);
            result = "\\U00000000".substr(0, 10 - result.length) + result;
        }
    }
    return result;
}
function $bab8cb0a961d0e7d$var$escapeRegex(regex) {
    return regex.replace(/[\]\/\(\)\*\+\?\.\\\$]/g, "\\$&");
}


// **N3Store** objects store N3 quads by graph in memory.

var $28176da182b29f80$exports = {};
"use strict";
var $511554dafd610175$exports = {};
/* replacement start */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $511554dafd610175$require$Buffer = $6ZWSX.Buffer;
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $511554dafd610175$require$ObjectDefineProperty = $6qlDJ.ObjectDefineProperty;
var $511554dafd610175$require$ObjectKeys = $6qlDJ.ObjectKeys;
var $511554dafd610175$require$ReflectApply = $6qlDJ.ReflectApply;

var $cSbri = parcelRequire("cSbri");
const { promisify: { custom: $511554dafd610175$var$customPromisify } } = $cSbri;
var $b0731249a151e5da$export$42af8c323be37587;
var $b0731249a151e5da$export$f405f72c701dad87;
"use strict";

const $b0731249a151e5da$var$AbortController = globalThis.AbortController || (parcelRequire("bHKGd")).AbortController;

var $PWkkZ = parcelRequire("PWkkZ");
const { codes: { ERR_INVALID_ARG_VALUE: $b0731249a151e5da$var$ERR_INVALID_ARG_VALUE, ERR_INVALID_ARG_TYPE: $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE, ERR_MISSING_ARGS: $b0731249a151e5da$var$ERR_MISSING_ARGS, ERR_OUT_OF_RANGE: $b0731249a151e5da$var$ERR_OUT_OF_RANGE }, AbortError: $b0731249a151e5da$var$AbortError } = $PWkkZ;

var $6q8Dc = parcelRequire("6q8Dc");
var $b0731249a151e5da$require$validateAbortSignal = $6q8Dc.validateAbortSignal;
var $b0731249a151e5da$require$validateInteger = $6q8Dc.validateInteger;
var $b0731249a151e5da$require$validateObject = $6q8Dc.validateObject;

const $b0731249a151e5da$var$kWeakHandler = (parcelRequire("6qlDJ")).Symbol("kWeak");

const $b0731249a151e5da$var$kResistStopPropagation = (parcelRequire("6qlDJ")).Symbol("kResistStopPropagation");

var $52Cjj = parcelRequire("52Cjj");
var $b0731249a151e5da$require$finished = $52Cjj.finished;
var $45fc09d411d5afbf$exports = {};
"use strict";
var $e0a640136e444712$exports = {};
/* replacement start */ 
var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $e0a640136e444712$require$ArrayIsArray = $6qlDJ.ArrayIsArray;
var $e0a640136e444712$require$Promise = $6qlDJ.Promise;
var $e0a640136e444712$require$SymbolAsyncIterator = $6qlDJ.SymbolAsyncIterator;
var $e0a640136e444712$require$SymbolDispose = $6qlDJ.SymbolDispose;

var $52Cjj = parcelRequire("52Cjj");

var $e0a640136e444712$require$once = (parcelRequire("cSbri")).once;

var $8Pe5V = parcelRequire("8Pe5V");

var $3ujhf = parcelRequire("3ujhf");

var $PWkkZ = parcelRequire("PWkkZ");
const { aggregateTwoErrors: $e0a640136e444712$var$aggregateTwoErrors, codes: { ERR_INVALID_ARG_TYPE: $e0a640136e444712$var$ERR_INVALID_ARG_TYPE, ERR_INVALID_RETURN_VALUE: $e0a640136e444712$var$ERR_INVALID_RETURN_VALUE, ERR_MISSING_ARGS: $e0a640136e444712$var$ERR_MISSING_ARGS, ERR_STREAM_DESTROYED: $e0a640136e444712$var$ERR_STREAM_DESTROYED, ERR_STREAM_PREMATURE_CLOSE: $e0a640136e444712$var$ERR_STREAM_PREMATURE_CLOSE }, AbortError: $e0a640136e444712$var$AbortError } = $PWkkZ;

var $6q8Dc = parcelRequire("6q8Dc");
var $e0a640136e444712$require$validateFunction = $6q8Dc.validateFunction;
var $e0a640136e444712$require$validateAbortSignal = $6q8Dc.validateAbortSignal;

var $dEd8A = parcelRequire("dEd8A");
var $e0a640136e444712$require$isIterable = $dEd8A.isIterable;
var $e0a640136e444712$require$isReadable = $dEd8A.isReadable;
var $e0a640136e444712$require$isReadableNodeStream = $dEd8A.isReadableNodeStream;
var $e0a640136e444712$require$isNodeStream = $dEd8A.isNodeStream;
var $e0a640136e444712$require$isTransformStream = $dEd8A.isTransformStream;
var $e0a640136e444712$require$isWebStream = $dEd8A.isWebStream;
var $e0a640136e444712$require$isReadableStream = $dEd8A.isReadableStream;
var $e0a640136e444712$require$isReadableFinished = $dEd8A.isReadableFinished;

const $e0a640136e444712$var$AbortController = globalThis.AbortController || (parcelRequire("bHKGd")).AbortController;
let $e0a640136e444712$var$PassThrough;
let $e0a640136e444712$var$Readable;
let $e0a640136e444712$var$addAbortListener;
function $e0a640136e444712$var$destroyer(stream, reading, writing) {
    let finished = false;
    stream.on("close", ()=>{
        finished = true;
    });
    const cleanup = $52Cjj(stream, {
        readable: reading,
        writable: writing
    }, (err)=>{
        finished = !err;
    });
    return {
        destroy: (err)=>{
            if (finished) return;
            finished = true;
            $8Pe5V.destroyer(stream, err || new $e0a640136e444712$var$ERR_STREAM_DESTROYED("pipe"));
        },
        cleanup: cleanup
    };
}
function $e0a640136e444712$var$popCallback(streams) {
    // Streams should never be an empty array. It should always contain at least
    // a single stream. Therefore optimize for the average case instead of
    // checking for length === 0 as well.
    $e0a640136e444712$require$validateFunction(streams[streams.length - 1], "streams[stream.length - 1]");
    return streams.pop();
}
function $e0a640136e444712$var$makeAsyncIterable(val) {
    if ($e0a640136e444712$require$isIterable(val)) return val;
    else if ($e0a640136e444712$require$isReadableNodeStream(val)) // Legacy streams are not Iterable.
    return $e0a640136e444712$var$fromReadable(val);
    throw new $e0a640136e444712$var$ERR_INVALID_ARG_TYPE("val", [
        "Readable",
        "Iterable",
        "AsyncIterable"
    ], val);
}

async function* $e0a640136e444712$var$fromReadable(val) {
    if (!$e0a640136e444712$var$Readable) $e0a640136e444712$var$Readable = (parcelRequire("6BZaW"));
    yield* $e0a640136e444712$var$Readable.prototype[$e0a640136e444712$require$SymbolAsyncIterator].call(val);
}
async function $e0a640136e444712$var$pumpToNode(iterable, writable, finish, { end: end }) {
    let error;
    let onresolve = null;
    const resume = (err)=>{
        if (err) error = err;
        if (onresolve) {
            const callback = onresolve;
            onresolve = null;
            callback();
        }
    };
    const wait = ()=>new $e0a640136e444712$require$Promise((resolve, reject)=>{
            if (error) reject(error);
            else onresolve = ()=>{
                if (error) reject(error);
                else resolve();
            };
        });
    writable.on("drain", resume);
    const cleanup = $52Cjj(writable, {
        readable: false
    }, resume);
    try {
        if (writable.writableNeedDrain) await wait();
        for await (const chunk of iterable)if (!writable.write(chunk)) await wait();
        if (end) {
            writable.end();
            await wait();
        }
        finish();
    } catch (err) {
        finish(error !== err ? $e0a640136e444712$var$aggregateTwoErrors(error, err) : err);
    } finally{
        cleanup();
        writable.off("drain", resume);
    }
}
async function $e0a640136e444712$var$pumpToWeb(readable, writable, finish, { end: end }) {
    if ($e0a640136e444712$require$isTransformStream(writable)) writable = writable.writable;
    // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure
    const writer = writable.getWriter();
    try {
        for await (const chunk of readable){
            await writer.ready;
            writer.write(chunk).catch(()=>{});
        }
        await writer.ready;
        if (end) await writer.close();
        finish();
    } catch (err) {
        try {
            await writer.abort(err);
            finish(err);
        } catch (err) {
            finish(err);
        }
    }
}
function $e0a640136e444712$var$pipeline(...streams) {
    return $e0a640136e444712$var$pipelineImpl(streams, $e0a640136e444712$require$once($e0a640136e444712$var$popCallback(streams)));
}


function $e0a640136e444712$var$pipelineImpl(streams, callback, opts) {
    if (streams.length === 1 && $e0a640136e444712$require$ArrayIsArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $e0a640136e444712$var$ERR_MISSING_ARGS("streams");
    const ac = new $e0a640136e444712$var$AbortController();
    const signal = ac.signal;
    const outerSignal = opts === null || opts === undefined ? undefined : opts.signal;
    // Need to cleanup event listeners if last stream is readable
    // https://github.com/nodejs/node/issues/35452
    const lastStreamCleanup = [];
    $e0a640136e444712$require$validateAbortSignal(outerSignal, "options.signal");
    function abort() {
        finishImpl(new $e0a640136e444712$var$AbortError());
    }
    $e0a640136e444712$var$addAbortListener = $e0a640136e444712$var$addAbortListener || (parcelRequire("cSbri")).addAbortListener;
    let disposable;
    if (outerSignal) disposable = $e0a640136e444712$var$addAbortListener(outerSignal, abort);
    let error;
    let value;
    const destroys = [];
    let finishCount = 0;
    function finish(err) {
        finishImpl(err, --finishCount === 0);
    }
    function finishImpl(err, final) {
        var _disposable;
        if (err && (!error || error.code === "ERR_STREAM_PREMATURE_CLOSE")) error = err;
        if (!error && !final) return;
        while(destroys.length)destroys.shift()(error);
        (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[$e0a640136e444712$require$SymbolDispose]();
        ac.abort();
        if (final) {
            if (!error) lastStreamCleanup.forEach((fn)=>fn());
            $hPtJY.nextTick(callback, error, value);
        }
    }
    let ret;
    for(let i = 0; i < streams.length; i++){
        const stream = streams[i];
        const reading = i < streams.length - 1;
        const writing = i > 0;
        const end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
        const isLastStream = i === streams.length - 1;
        if ($e0a640136e444712$require$isNodeStream(stream)) {
            if (end) {
                const { destroy: destroy, cleanup: cleanup } = $e0a640136e444712$var$destroyer(stream, reading, writing);
                destroys.push(destroy);
                if ($e0a640136e444712$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            }
            // Catch stream errors that occur after pipe/pump has completed.
            function onError(err) {
                if (err && err.name !== "AbortError" && err.code !== "ERR_STREAM_PREMATURE_CLOSE") finish(err);
            }
            stream.on("error", onError);
            if ($e0a640136e444712$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(()=>{
                stream.removeListener("error", onError);
            });
        }
        if (i === 0) {
            if (typeof stream === "function") {
                ret = stream({
                    signal: signal
                });
                if (!$e0a640136e444712$require$isIterable(ret)) throw new $e0a640136e444712$var$ERR_INVALID_RETURN_VALUE("Iterable, AsyncIterable or Stream", "source", ret);
            } else if ($e0a640136e444712$require$isIterable(stream) || $e0a640136e444712$require$isReadableNodeStream(stream) || $e0a640136e444712$require$isTransformStream(stream)) ret = stream;
            else ret = $3ujhf.from(stream);
        } else if (typeof stream === "function") {
            if ($e0a640136e444712$require$isTransformStream(ret)) {
                var _ret;
                ret = $e0a640136e444712$var$makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
            } else ret = $e0a640136e444712$var$makeAsyncIterable(ret);
            ret = stream(ret, {
                signal: signal
            });
            if (reading) {
                if (!$e0a640136e444712$require$isIterable(ret, true)) throw new $e0a640136e444712$var$ERR_INVALID_RETURN_VALUE("AsyncIterable", `transform[${i - 1}]`, ret);
            } else {
                var _ret2;
                if (!$e0a640136e444712$var$PassThrough) $e0a640136e444712$var$PassThrough = (parcelRequire("iXAaU"));
                // If the last argument to pipeline is not a stream
                // we must create a proxy stream so that pipeline(...)
                // always returns a stream which can be further
                // composed through `.pipe(stream)`.
                const pt = new $e0a640136e444712$var$PassThrough({
                    objectMode: true
                });
                // Handle Promises/A+ spec, `then` could be a getter that throws on
                // second use.
                const then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;
                if (typeof then === "function") {
                    finishCount++;
                    then.call(ret, (val)=>{
                        value = val;
                        if (val != null) pt.write(val);
                        if (end) pt.end();
                        $hPtJY.nextTick(finish);
                    }, (err)=>{
                        pt.destroy(err);
                        $hPtJY.nextTick(finish, err);
                    });
                } else if ($e0a640136e444712$require$isIterable(ret, true)) {
                    finishCount++;
                    $e0a640136e444712$var$pumpToNode(ret, pt, finish, {
                        end: end
                    });
                } else if ($e0a640136e444712$require$isReadableStream(ret) || $e0a640136e444712$require$isTransformStream(ret)) {
                    const toRead = ret.readable || ret;
                    finishCount++;
                    $e0a640136e444712$var$pumpToNode(toRead, pt, finish, {
                        end: end
                    });
                } else throw new $e0a640136e444712$var$ERR_INVALID_RETURN_VALUE("AsyncIterable or Promise", "destination", ret);
                ret = pt;
                const { destroy: destroy, cleanup: cleanup } = $e0a640136e444712$var$destroyer(ret, false, true);
                destroys.push(destroy);
                if (isLastStream) lastStreamCleanup.push(cleanup);
            }
        } else if ($e0a640136e444712$require$isNodeStream(stream)) {
            if ($e0a640136e444712$require$isReadableNodeStream(ret)) {
                finishCount += 2;
                const cleanup = $e0a640136e444712$var$pipe(ret, stream, finish, {
                    end: end
                });
                if ($e0a640136e444712$require$isReadable(stream) && isLastStream) lastStreamCleanup.push(cleanup);
            } else if ($e0a640136e444712$require$isTransformStream(ret) || $e0a640136e444712$require$isReadableStream(ret)) {
                const toRead = ret.readable || ret;
                finishCount++;
                $e0a640136e444712$var$pumpToNode(toRead, stream, finish, {
                    end: end
                });
            } else if ($e0a640136e444712$require$isIterable(ret)) {
                finishCount++;
                $e0a640136e444712$var$pumpToNode(ret, stream, finish, {
                    end: end
                });
            } else throw new $e0a640136e444712$var$ERR_INVALID_ARG_TYPE("val", [
                "Readable",
                "Iterable",
                "AsyncIterable",
                "ReadableStream",
                "TransformStream"
            ], ret);
            ret = stream;
        } else if ($e0a640136e444712$require$isWebStream(stream)) {
            if ($e0a640136e444712$require$isReadableNodeStream(ret)) {
                finishCount++;
                $e0a640136e444712$var$pumpToWeb($e0a640136e444712$var$makeAsyncIterable(ret), stream, finish, {
                    end: end
                });
            } else if ($e0a640136e444712$require$isReadableStream(ret) || $e0a640136e444712$require$isIterable(ret)) {
                finishCount++;
                $e0a640136e444712$var$pumpToWeb(ret, stream, finish, {
                    end: end
                });
            } else if ($e0a640136e444712$require$isTransformStream(ret)) {
                finishCount++;
                $e0a640136e444712$var$pumpToWeb(ret.readable, stream, finish, {
                    end: end
                });
            } else throw new $e0a640136e444712$var$ERR_INVALID_ARG_TYPE("val", [
                "Readable",
                "Iterable",
                "AsyncIterable",
                "ReadableStream",
                "TransformStream"
            ], ret);
            ret = stream;
        } else ret = $3ujhf.from(stream);
    }
    if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) $hPtJY.nextTick(abort);
    return ret;
}
function $e0a640136e444712$var$pipe(src, dst, finish, { end: end }) {
    let ended = false;
    dst.on("close", ()=>{
        if (!ended) // Finish if the destination closes before the source has completed.
        finish(new $e0a640136e444712$var$ERR_STREAM_PREMATURE_CLOSE());
    });
    src.pipe(dst, {
        end: false
    }) // If end is true we already will have a listener to end dst.
    ;
    if (end) {
        // Compat. Before node v10.12.0 stdio used to throw an error so
        // pipe() did/does not end() stdio destinations.
        // Now they allow it but "secretly" don't close the underlying fd.
        function endFn() {
            ended = true;
            dst.end();
        }
        if ($e0a640136e444712$require$isReadableFinished(src)) // End the destination if the source has already ended.
        $hPtJY.nextTick(endFn);
        else src.once("end", endFn);
    } else finish();
    $52Cjj(src, {
        readable: true,
        writable: false
    }, (err)=>{
        const rState = src._readableState;
        if (err && err.code === "ERR_STREAM_PREMATURE_CLOSE" && rState && rState.ended && !rState.errored && !rState.errorEmitted) // Some readable streams will emit 'close' before 'end'. However, since
        // this is on the readable side 'end' should still be emitted if the
        // stream has been ended and no error emitted. This should be allowed in
        // favor of backwards compatibility. Since the stream is piped to a
        // destination this should not result in any observable difference.
        // We don't need to check if this is a writable premature close since
        // eos will only fail with premature close on the reading side for
        // duplex streams.
        src.once("end", finish).once("error", finish);
        else finish(err);
    });
    return $52Cjj(dst, {
        readable: false,
        writable: true
    }, finish);
}
$e0a640136e444712$exports = {
    pipelineImpl: $e0a640136e444712$var$pipelineImpl,
    pipeline: $e0a640136e444712$var$pipeline
};


var $45fc09d411d5afbf$require$pipeline = $e0a640136e444712$exports.pipeline;

var $3ujhf = parcelRequire("3ujhf");

var $8Pe5V = parcelRequire("8Pe5V");
var $45fc09d411d5afbf$require$destroyer = $8Pe5V.destroyer;

var $dEd8A = parcelRequire("dEd8A");
var $45fc09d411d5afbf$require$isNodeStream = $dEd8A.isNodeStream;
var $45fc09d411d5afbf$require$isReadable = $dEd8A.isReadable;
var $45fc09d411d5afbf$require$isWritable = $dEd8A.isWritable;
var $45fc09d411d5afbf$require$isWebStream = $dEd8A.isWebStream;
var $45fc09d411d5afbf$require$isTransformStream = $dEd8A.isTransformStream;
var $45fc09d411d5afbf$require$isWritableStream = $dEd8A.isWritableStream;
var $45fc09d411d5afbf$require$isReadableStream = $dEd8A.isReadableStream;

var $PWkkZ = parcelRequire("PWkkZ");
const { AbortError: $45fc09d411d5afbf$var$AbortError, codes: { ERR_INVALID_ARG_VALUE: $45fc09d411d5afbf$var$ERR_INVALID_ARG_VALUE, ERR_MISSING_ARGS: $45fc09d411d5afbf$var$ERR_MISSING_ARGS } } = $PWkkZ;

var $52Cjj = parcelRequire("52Cjj");
$45fc09d411d5afbf$exports = function compose(...streams) {
    if (streams.length === 0) throw new $45fc09d411d5afbf$var$ERR_MISSING_ARGS("streams");
    if (streams.length === 1) return $3ujhf.from(streams[0]);
    const orgStreams = [
        ...streams
    ];
    if (typeof streams[0] === "function") streams[0] = $3ujhf.from(streams[0]);
    if (typeof streams[streams.length - 1] === "function") {
        const idx = streams.length - 1;
        streams[idx] = $3ujhf.from(streams[idx]);
    }
    for(let n = 0; n < streams.length; ++n){
        if (!$45fc09d411d5afbf$require$isNodeStream(streams[n]) && !$45fc09d411d5afbf$require$isWebStream(streams[n])) continue;
        if (n < streams.length - 1 && !($45fc09d411d5afbf$require$isReadable(streams[n]) || $45fc09d411d5afbf$require$isReadableStream(streams[n]) || $45fc09d411d5afbf$require$isTransformStream(streams[n]))) throw new $45fc09d411d5afbf$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], "must be readable");
        if (n > 0 && !($45fc09d411d5afbf$require$isWritable(streams[n]) || $45fc09d411d5afbf$require$isWritableStream(streams[n]) || $45fc09d411d5afbf$require$isTransformStream(streams[n]))) throw new $45fc09d411d5afbf$var$ERR_INVALID_ARG_VALUE(`streams[${n}]`, orgStreams[n], "must be writable");
    }
    let ondrain;
    let onfinish;
    let onreadable;
    let onclose;
    let d;
    function onfinished(err) {
        const cb = onclose;
        onclose = null;
        if (cb) cb(err);
        else if (err) d.destroy(err);
        else if (!readable && !writable) d.destroy();
    }
    const head = streams[0];
    const tail = $45fc09d411d5afbf$require$pipeline(streams, onfinished);
    const writable = !!($45fc09d411d5afbf$require$isWritable(head) || $45fc09d411d5afbf$require$isWritableStream(head) || $45fc09d411d5afbf$require$isTransformStream(head));
    const readable = !!($45fc09d411d5afbf$require$isReadable(tail) || $45fc09d411d5afbf$require$isReadableStream(tail) || $45fc09d411d5afbf$require$isTransformStream(tail));
    // TODO(ronag): Avoid double buffering.
    // Implement Writable/Readable/Duplex traits.
    // See, https://github.com/nodejs/node/pull/33515.
    d = new $3ujhf({
        // TODO (ronag): highWaterMark?
        writableObjectMode: !!(head !== null && head !== undefined && head.writableObjectMode),
        readableObjectMode: !!(tail !== null && tail !== undefined && tail.readableObjectMode),
        writable: writable,
        readable: readable
    });
    if (writable) {
        if ($45fc09d411d5afbf$require$isNodeStream(head)) {
            d._write = function(chunk, encoding, callback) {
                if (head.write(chunk, encoding)) callback();
                else ondrain = callback;
            };
            d._final = function(callback) {
                head.end();
                onfinish = callback;
            };
            head.on("drain", function() {
                if (ondrain) {
                    const cb = ondrain;
                    ondrain = null;
                    cb();
                }
            });
        } else if ($45fc09d411d5afbf$require$isWebStream(head)) {
            const writable = $45fc09d411d5afbf$require$isTransformStream(head) ? head.writable : head;
            const writer = writable.getWriter();
            d._write = async function(chunk, encoding, callback) {
                try {
                    await writer.ready;
                    writer.write(chunk).catch(()=>{});
                    callback();
                } catch (err) {
                    callback(err);
                }
            };
            d._final = async function(callback) {
                try {
                    await writer.ready;
                    writer.close().catch(()=>{});
                    onfinish = callback;
                } catch (err) {
                    callback(err);
                }
            };
        }
        const toRead = $45fc09d411d5afbf$require$isTransformStream(tail) ? tail.readable : tail;
        $52Cjj(toRead, ()=>{
            if (onfinish) {
                const cb = onfinish;
                onfinish = null;
                cb();
            }
        });
    }
    if (readable) {
        if ($45fc09d411d5afbf$require$isNodeStream(tail)) {
            tail.on("readable", function() {
                if (onreadable) {
                    const cb = onreadable;
                    onreadable = null;
                    cb();
                }
            });
            tail.on("end", function() {
                d.push(null);
            });
            d._read = function() {
                while(true){
                    const buf = tail.read();
                    if (buf === null) {
                        onreadable = d._read;
                        return;
                    }
                    if (!d.push(buf)) return;
                }
            };
        } else if ($45fc09d411d5afbf$require$isWebStream(tail)) {
            const readable = $45fc09d411d5afbf$require$isTransformStream(tail) ? tail.readable : tail;
            const reader = readable.getReader();
            d._read = async function() {
                while(true)try {
                    const { value: value, done: done } = await reader.read();
                    if (!d.push(value)) return;
                    if (done) {
                        d.push(null);
                        return;
                    }
                } catch  {
                    return;
                }
            };
        }
    }
    d._destroy = function(err, callback) {
        if (!err && onclose !== null) err = new $45fc09d411d5afbf$var$AbortError();
        onreadable = null;
        ondrain = null;
        onfinish = null;
        if (onclose === null) callback(err);
        else {
            onclose = callback;
            if ($45fc09d411d5afbf$require$isNodeStream(tail)) $45fc09d411d5afbf$require$destroyer(tail, err);
        }
    };
    return d;
};



var $khx7T = parcelRequire("khx7T");
var $b0731249a151e5da$require$addAbortSignalNoValidate = $khx7T.addAbortSignalNoValidate;

var $dEd8A = parcelRequire("dEd8A");
var $b0731249a151e5da$require$isWritable = $dEd8A.isWritable;
var $b0731249a151e5da$require$isNodeStream = $dEd8A.isNodeStream;

var $b0731249a151e5da$require$deprecate = (parcelRequire("cSbri")).deprecate;

var $b0731249a151e5da$require$ArrayPrototypePush = (parcelRequire("6qlDJ")).ArrayPrototypePush;
var $b0731249a151e5da$require$Boolean = (parcelRequire("6qlDJ")).Boolean;
var $b0731249a151e5da$require$MathFloor = (parcelRequire("6qlDJ")).MathFloor;
var $b0731249a151e5da$require$Number = (parcelRequire("6qlDJ")).Number;
var $b0731249a151e5da$require$NumberIsNaN = (parcelRequire("6qlDJ")).NumberIsNaN;
var $b0731249a151e5da$require$Promise = (parcelRequire("6qlDJ")).Promise;
var $b0731249a151e5da$require$PromiseReject = (parcelRequire("6qlDJ")).PromiseReject;
var $b0731249a151e5da$require$PromiseResolve = (parcelRequire("6qlDJ")).PromiseResolve;
var $b0731249a151e5da$require$PromisePrototypeThen = (parcelRequire("6qlDJ")).PromisePrototypeThen;
var $b0731249a151e5da$require$Symbol = (parcelRequire("6qlDJ")).Symbol;
const $b0731249a151e5da$var$kEmpty = $b0731249a151e5da$require$Symbol("kEmpty");
const $b0731249a151e5da$var$kEof = $b0731249a151e5da$require$Symbol("kEof");
function $b0731249a151e5da$var$compose(stream, options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    if ($b0731249a151e5da$require$isNodeStream(stream) && !$b0731249a151e5da$require$isWritable(stream)) throw new $b0731249a151e5da$var$ERR_INVALID_ARG_VALUE("stream", stream, "must be writable");
    const composedStream = $45fc09d411d5afbf$exports(this, stream);
    if (options !== null && options !== undefined && options.signal) // Not validating as we already validated before
    $b0731249a151e5da$require$addAbortSignalNoValidate(options.signal, composedStream);
    return composedStream;
}

function $b0731249a151e5da$var$map(fn, options) {
    if (typeof fn !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    let concurrency = 1;
    if ((options === null || options === undefined ? undefined : options.concurrency) != null) concurrency = $b0731249a151e5da$require$MathFloor(options.concurrency);
    let highWaterMark = concurrency - 1;
    if ((options === null || options === undefined ? undefined : options.highWaterMark) != null) highWaterMark = $b0731249a151e5da$require$MathFloor(options.highWaterMark);
    $b0731249a151e5da$require$validateInteger(concurrency, "options.concurrency", 1);
    $b0731249a151e5da$require$validateInteger(highWaterMark, "options.highWaterMark", 0);
    highWaterMark += concurrency;
    return (async function* map() {
        const signal = (parcelRequire("cSbri")).AbortSignalAny([
            options === null || options === undefined ? undefined : options.signal
        ].filter($b0731249a151e5da$require$Boolean));
        const stream = this;
        const queue = [];
        const signalOpt = {
            signal: signal
        };
        let next;
        let resume;
        let done = false;
        let cnt = 0;
        function onCatch() {
            done = true;
            afterItemProcessed();
        }
        function afterItemProcessed() {
            cnt -= 1;
            maybeResume();
        }
        function maybeResume() {
            if (resume && !done && cnt < concurrency && queue.length < highWaterMark) {
                resume();
                resume = null;
            }
        }
        async function pump() {
            try {
                for await (let val of stream){
                    if (done) return;
                    if (signal.aborted) throw new $b0731249a151e5da$var$AbortError();
                    try {
                        val = fn(val, signalOpt);
                        if (val === $b0731249a151e5da$var$kEmpty) continue;
                        val = $b0731249a151e5da$require$PromiseResolve(val);
                    } catch (err) {
                        val = $b0731249a151e5da$require$PromiseReject(err);
                    }
                    cnt += 1;
                    $b0731249a151e5da$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                    queue.push(val);
                    if (next) {
                        next();
                        next = null;
                    }
                    if (!done && (queue.length >= highWaterMark || cnt >= concurrency)) await new $b0731249a151e5da$require$Promise((resolve)=>{
                        resume = resolve;
                    });
                }
                queue.push($b0731249a151e5da$var$kEof);
            } catch (err) {
                const val = $b0731249a151e5da$require$PromiseReject(err);
                $b0731249a151e5da$require$PromisePrototypeThen(val, afterItemProcessed, onCatch);
                queue.push(val);
            } finally{
                done = true;
                if (next) {
                    next();
                    next = null;
                }
            }
        }
        pump();
        try {
            while(true){
                while(queue.length > 0){
                    const val = await queue[0];
                    if (val === $b0731249a151e5da$var$kEof) return;
                    if (signal.aborted) throw new $b0731249a151e5da$var$AbortError();
                    if (val !== $b0731249a151e5da$var$kEmpty) yield val;
                    queue.shift();
                    maybeResume();
                }
                await new $b0731249a151e5da$require$Promise((resolve)=>{
                    next = resolve;
                });
            }
        } finally{
            done = true;
            if (resume) {
                resume();
                resume = null;
            }
        }
    }).call(this);
}
function $b0731249a151e5da$var$asIndexedPairs(options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    return (async function* asIndexedPairs() {
        let index = 0;
        for await (const val of this){
            var _options$signal;
            if (options !== null && options !== undefined && (_options$signal = options.signal) !== null && _options$signal !== undefined && _options$signal.aborted) throw new $b0731249a151e5da$var$AbortError({
                cause: options.signal.reason
            });
            yield [
                index++,
                val
            ];
        }
    }).call(this);
}
async function $b0731249a151e5da$var$some(fn, options) {
    for await (const unused of $b0731249a151e5da$var$filter.call(this, fn, options))return true;
    return false;
}
async function $b0731249a151e5da$var$every(fn, options) {
    if (typeof fn !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    // https://en.wikipedia.org/wiki/De_Morgan%27s_laws
    return !await $b0731249a151e5da$var$some.call(this, async (...args)=>{
        return !await fn(...args);
    }, options);
}
async function $b0731249a151e5da$var$find(fn, options) {
    for await (const result of $b0731249a151e5da$var$filter.call(this, fn, options))return result;
    return undefined;
}
async function $b0731249a151e5da$var$forEach(fn, options) {
    if (typeof fn !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    async function forEachFn(value, options) {
        await fn(value, options);
        return $b0731249a151e5da$var$kEmpty;
    }
    // eslint-disable-next-line no-unused-vars
    for await (const unused of $b0731249a151e5da$var$map.call(this, forEachFn, options));
}
function $b0731249a151e5da$var$filter(fn, options) {
    if (typeof fn !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("fn", [
        "Function",
        "AsyncFunction"
    ], fn);
    async function filterFn(value, options) {
        if (await fn(value, options)) return value;
        return $b0731249a151e5da$var$kEmpty;
    }
    return $b0731249a151e5da$var$map.call(this, filterFn, options);
}
// Specific to provide better error to reduce since the argument is only
// missing if the stream has no items in it - but the code is still appropriate
class $b0731249a151e5da$var$ReduceAwareErrMissingArgs extends $b0731249a151e5da$var$ERR_MISSING_ARGS {
    constructor(){
        super("reduce");
        this.message = "Reduce of an empty stream requires an initial value";
    }
}
async function $b0731249a151e5da$var$reduce(reducer, initialValue, options) {
    var _options$signal2;
    if (typeof reducer !== "function") throw new $b0731249a151e5da$var$ERR_INVALID_ARG_TYPE("reducer", [
        "Function",
        "AsyncFunction"
    ], reducer);
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    let hasInitialValue = arguments.length > 1;
    if (options !== null && options !== undefined && (_options$signal2 = options.signal) !== null && _options$signal2 !== undefined && _options$signal2.aborted) {
        const err = new $b0731249a151e5da$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        this.once("error", ()=>{}) // The error is already propagated
        ;
        await $b0731249a151e5da$require$finished(this.destroy(err));
        throw err;
    }
    const ac = new $b0731249a151e5da$var$AbortController();
    const signal = ac.signal;
    if (options !== null && options !== undefined && options.signal) {
        const opts = {
            once: true,
            [$b0731249a151e5da$var$kWeakHandler]: this,
            [$b0731249a151e5da$var$kResistStopPropagation]: true
        };
        options.signal.addEventListener("abort", ()=>ac.abort(), opts);
    }
    let gotAnyItemFromStream = false;
    try {
        for await (const value of this){
            var _options$signal3;
            gotAnyItemFromStream = true;
            if (options !== null && options !== undefined && (_options$signal3 = options.signal) !== null && _options$signal3 !== undefined && _options$signal3.aborted) throw new $b0731249a151e5da$var$AbortError();
            if (!hasInitialValue) {
                initialValue = value;
                hasInitialValue = true;
            } else initialValue = await reducer(initialValue, value, {
                signal: signal
            });
        }
        if (!gotAnyItemFromStream && !hasInitialValue) throw new $b0731249a151e5da$var$ReduceAwareErrMissingArgs();
    } finally{
        ac.abort();
    }
    return initialValue;
}
async function $b0731249a151e5da$var$toArray(options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    const result = [];
    for await (const val of this){
        var _options$signal4;
        if (options !== null && options !== undefined && (_options$signal4 = options.signal) !== null && _options$signal4 !== undefined && _options$signal4.aborted) throw new $b0731249a151e5da$var$AbortError(undefined, {
            cause: options.signal.reason
        });
        $b0731249a151e5da$require$ArrayPrototypePush(result, val);
    }
    return result;
}
function $b0731249a151e5da$var$flatMap(fn, options) {
    const values = $b0731249a151e5da$var$map.call(this, fn, options);
    return (async function* flatMap() {
        for await (const val of values)yield* val;
    }).call(this);
}
function $b0731249a151e5da$var$toIntegerOrInfinity(number) {
    // We coerce here to align with the spec
    // https://github.com/tc39/proposal-iterator-helpers/issues/169
    number = $b0731249a151e5da$require$Number(number);
    if ($b0731249a151e5da$require$NumberIsNaN(number)) return 0;
    if (number < 0) throw new $b0731249a151e5da$var$ERR_OUT_OF_RANGE("number", ">= 0", number);
    return number;
}
function $b0731249a151e5da$var$drop(number, options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    number = $b0731249a151e5da$var$toIntegerOrInfinity(number);
    return (async function* drop() {
        var _options$signal5;
        if (options !== null && options !== undefined && (_options$signal5 = options.signal) !== null && _options$signal5 !== undefined && _options$signal5.aborted) throw new $b0731249a151e5da$var$AbortError();
        for await (const val of this){
            var _options$signal6;
            if (options !== null && options !== undefined && (_options$signal6 = options.signal) !== null && _options$signal6 !== undefined && _options$signal6.aborted) throw new $b0731249a151e5da$var$AbortError();
            if (number-- <= 0) yield val;
        }
    }).call(this);
}
function $b0731249a151e5da$var$take(number, options) {
    if (options != null) $b0731249a151e5da$require$validateObject(options, "options");
    if ((options === null || options === undefined ? undefined : options.signal) != null) $b0731249a151e5da$require$validateAbortSignal(options.signal, "options.signal");
    number = $b0731249a151e5da$var$toIntegerOrInfinity(number);
    return (async function* take() {
        var _options$signal7;
        if (options !== null && options !== undefined && (_options$signal7 = options.signal) !== null && _options$signal7 !== undefined && _options$signal7.aborted) throw new $b0731249a151e5da$var$AbortError();
        for await (const val of this){
            var _options$signal8;
            if (options !== null && options !== undefined && (_options$signal8 = options.signal) !== null && _options$signal8 !== undefined && _options$signal8.aborted) throw new $b0731249a151e5da$var$AbortError();
            if (number-- > 0) yield val;
            // Don't get another item from iterator in case we reached the end
            if (number <= 0) return;
        }
    }).call(this);
}
$b0731249a151e5da$export$42af8c323be37587 = {
    asIndexedPairs: $b0731249a151e5da$require$deprecate($b0731249a151e5da$var$asIndexedPairs, "readable.asIndexedPairs will be removed in a future version."),
    drop: $b0731249a151e5da$var$drop,
    filter: $b0731249a151e5da$var$filter,
    flatMap: $b0731249a151e5da$var$flatMap,
    map: $b0731249a151e5da$var$map,
    take: $b0731249a151e5da$var$take,
    compose: $b0731249a151e5da$var$compose
};
$b0731249a151e5da$export$f405f72c701dad87 = {
    every: $b0731249a151e5da$var$every,
    forEach: $b0731249a151e5da$var$forEach,
    reduce: $b0731249a151e5da$var$reduce,
    toArray: $b0731249a151e5da$var$toArray,
    some: $b0731249a151e5da$var$some,
    find: $b0731249a151e5da$var$find
};


var $511554dafd610175$require$streamReturningOperators = $b0731249a151e5da$export$42af8c323be37587;
var $511554dafd610175$require$promiseReturningOperators = $b0731249a151e5da$export$f405f72c701dad87;

var $PWkkZ = parcelRequire("PWkkZ");
const { codes: { ERR_ILLEGAL_CONSTRUCTOR: $511554dafd610175$var$ERR_ILLEGAL_CONSTRUCTOR } } = $PWkkZ;


var $5ZWSH = parcelRequire("5ZWSH");
var $511554dafd610175$require$setDefaultHighWaterMark = $5ZWSH.setDefaultHighWaterMark;
var $511554dafd610175$require$getDefaultHighWaterMark = $5ZWSH.getDefaultHighWaterMark;

var $511554dafd610175$require$pipeline = $e0a640136e444712$exports.pipeline;

var $8Pe5V = parcelRequire("8Pe5V");
var $511554dafd610175$require$destroyer = $8Pe5V.destroyer;

var $52Cjj = parcelRequire("52Cjj");
const $511554dafd610175$var$internalBuffer = {};
var $eada4a54cfd36b5a$exports = {};
"use strict";

var $6qlDJ = parcelRequire("6qlDJ");
var $eada4a54cfd36b5a$require$ArrayPrototypePop = $6qlDJ.ArrayPrototypePop;
var $eada4a54cfd36b5a$require$Promise = $6qlDJ.Promise;

var $dEd8A = parcelRequire("dEd8A");
var $eada4a54cfd36b5a$require$isIterable = $dEd8A.isIterable;
var $eada4a54cfd36b5a$require$isNodeStream = $dEd8A.isNodeStream;
var $eada4a54cfd36b5a$require$isWebStream = $dEd8A.isWebStream;

var $eada4a54cfd36b5a$require$pl = $e0a640136e444712$exports.pipelineImpl;

var $52Cjj = parcelRequire("52Cjj");
var $eada4a54cfd36b5a$require$finished = $52Cjj.finished;

function $eada4a54cfd36b5a$var$pipeline(...streams) {
    return new $eada4a54cfd36b5a$require$Promise((resolve, reject)=>{
        let signal;
        let end;
        const lastArg = streams[streams.length - 1];
        if (lastArg && typeof lastArg === "object" && !$eada4a54cfd36b5a$require$isNodeStream(lastArg) && !$eada4a54cfd36b5a$require$isIterable(lastArg) && !$eada4a54cfd36b5a$require$isWebStream(lastArg)) {
            const options = $eada4a54cfd36b5a$require$ArrayPrototypePop(streams);
            signal = options.signal;
            end = options.end;
        }
        $eada4a54cfd36b5a$require$pl(streams, (err, value)=>{
            if (err) reject(err);
            else resolve(value);
        }, {
            signal: signal,
            end: end
        });
    });
}
$eada4a54cfd36b5a$exports = {
    finished: $eada4a54cfd36b5a$require$finished,
    pipeline: $eada4a54cfd36b5a$var$pipeline
};



var $dEd8A = parcelRequire("dEd8A");

const $511554dafd610175$var$Stream = $511554dafd610175$exports = (parcelRequire("8uq7s")).Stream;
$511554dafd610175$var$Stream.isDestroyed = $dEd8A.isDestroyed;
$511554dafd610175$var$Stream.isDisturbed = $dEd8A.isDisturbed;
$511554dafd610175$var$Stream.isErrored = $dEd8A.isErrored;
$511554dafd610175$var$Stream.isReadable = $dEd8A.isReadable;
$511554dafd610175$var$Stream.isWritable = $dEd8A.isWritable;

$511554dafd610175$var$Stream.Readable = (parcelRequire("6BZaW"));
for (const key of $511554dafd610175$require$ObjectKeys($511554dafd610175$require$streamReturningOperators)){
    const op = $511554dafd610175$require$streamReturningOperators[key];
    function fn(...args) {
        if (new.target) throw $511554dafd610175$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $511554dafd610175$var$Stream.Readable.from($511554dafd610175$require$ReflectApply(op, this, args));
    }
    $511554dafd610175$require$ObjectDefineProperty(fn, "name", {
        __proto__: null,
        value: op.name
    });
    $511554dafd610175$require$ObjectDefineProperty(fn, "length", {
        __proto__: null,
        value: op.length
    });
    $511554dafd610175$require$ObjectDefineProperty($511554dafd610175$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn,
        enumerable: false,
        configurable: true,
        writable: true
    });
}
for (const key of $511554dafd610175$require$ObjectKeys($511554dafd610175$require$promiseReturningOperators)){
    const op = $511554dafd610175$require$promiseReturningOperators[key];
    function fn1(...args) {
        if (new.target) throw $511554dafd610175$var$ERR_ILLEGAL_CONSTRUCTOR();
        return $511554dafd610175$require$ReflectApply(op, this, args);
    }
    $511554dafd610175$require$ObjectDefineProperty(fn1, "name", {
        __proto__: null,
        value: op.name
    });
    $511554dafd610175$require$ObjectDefineProperty(fn1, "length", {
        __proto__: null,
        value: op.length
    });
    $511554dafd610175$require$ObjectDefineProperty($511554dafd610175$var$Stream.Readable.prototype, key, {
        __proto__: null,
        value: fn1,
        enumerable: false,
        configurable: true,
        writable: true
    });
}

$511554dafd610175$var$Stream.Writable = (parcelRequire("4uosb"));

$511554dafd610175$var$Stream.Duplex = (parcelRequire("3ujhf"));

$511554dafd610175$var$Stream.Transform = (parcelRequire("3LvcR"));

$511554dafd610175$var$Stream.PassThrough = (parcelRequire("iXAaU"));
$511554dafd610175$var$Stream.pipeline = $511554dafd610175$require$pipeline;

var $khx7T = parcelRequire("khx7T");
var $511554dafd610175$require$addAbortSignal = $khx7T.addAbortSignal;
$511554dafd610175$var$Stream.addAbortSignal = $511554dafd610175$require$addAbortSignal;
$511554dafd610175$var$Stream.finished = $52Cjj;
$511554dafd610175$var$Stream.destroy = $511554dafd610175$require$destroyer;
$511554dafd610175$var$Stream.compose = $45fc09d411d5afbf$exports;
$511554dafd610175$var$Stream.setDefaultHighWaterMark = $511554dafd610175$require$setDefaultHighWaterMark;
$511554dafd610175$var$Stream.getDefaultHighWaterMark = $511554dafd610175$require$getDefaultHighWaterMark;
$511554dafd610175$require$ObjectDefineProperty($511554dafd610175$var$Stream, "promises", {
    __proto__: null,
    configurable: true,
    enumerable: true,
    get () {
        return $eada4a54cfd36b5a$exports;
    }
});
$511554dafd610175$require$ObjectDefineProperty($511554dafd610175$require$pipeline, $511554dafd610175$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $eada4a54cfd36b5a$exports.pipeline;
    }
});
$511554dafd610175$require$ObjectDefineProperty($52Cjj, $511554dafd610175$var$customPromisify, {
    __proto__: null,
    enumerable: true,
    get () {
        return $eada4a54cfd36b5a$exports.finished;
    }
});
// Backwards-compat with node 0.4.x
$511554dafd610175$var$Stream.Stream = $511554dafd610175$var$Stream;
$511554dafd610175$var$Stream._isUint8Array = function isUint8Array(value) {
    return value instanceof Uint8Array;
};
$511554dafd610175$var$Stream._uint8ArrayToBuffer = function _uint8ArrayToBuffer(chunk) {
    return $511554dafd610175$require$Buffer.from(chunk.buffer, chunk.byteOffset, chunk.byteLength);
};



const $28176da182b29f80$var$originalDestroy = $511554dafd610175$exports.Readable.destroy;
$28176da182b29f80$exports = $511554dafd610175$exports.Readable;
// Explicit export naming is needed for ESM
$28176da182b29f80$exports._uint8ArrayToBuffer = $511554dafd610175$exports._uint8ArrayToBuffer;
$28176da182b29f80$exports._isUint8Array = $511554dafd610175$exports._isUint8Array;
$28176da182b29f80$exports.isDisturbed = $511554dafd610175$exports.isDisturbed;
$28176da182b29f80$exports.isErrored = $511554dafd610175$exports.isErrored;
$28176da182b29f80$exports.isReadable = $511554dafd610175$exports.isReadable;
$28176da182b29f80$exports.Readable = $511554dafd610175$exports.Readable;
$28176da182b29f80$exports.Writable = $511554dafd610175$exports.Writable;
$28176da182b29f80$exports.Duplex = $511554dafd610175$exports.Duplex;
$28176da182b29f80$exports.Transform = $511554dafd610175$exports.Transform;
$28176da182b29f80$exports.PassThrough = $511554dafd610175$exports.PassThrough;
$28176da182b29f80$exports.addAbortSignal = $511554dafd610175$exports.addAbortSignal;
$28176da182b29f80$exports.finished = $511554dafd610175$exports.finished;
$28176da182b29f80$exports.destroy = $511554dafd610175$exports.destroy;
$28176da182b29f80$exports.destroy = $28176da182b29f80$var$originalDestroy;
$28176da182b29f80$exports.pipeline = $511554dafd610175$exports.pipeline;
$28176da182b29f80$exports.compose = $511554dafd610175$exports.compose;
Object.defineProperty($511554dafd610175$exports, "promises", {
    configurable: true,
    enumerable: true,
    get () {
        return $eada4a54cfd36b5a$exports;
    }
});
$28176da182b29f80$exports.Stream = $511554dafd610175$exports.Stream;
// Allow default importing
$28176da182b29f80$exports.default = $28176da182b29f80$exports;




class $b0dfd6227adaa9e6$export$2e2bcd8739ae039 {
    constructor(quads, options){
        // The number of quads is initially zero
        this._size = 0;
        // `_graphs` contains subject, predicate, and object indexes per graph
        this._graphs = Object.create(null);
        // `_ids` maps entities such as `http://xmlns.com/foaf/0.1/name` to numbers,
        // saving memory by using only numbers as keys in `_graphs`
        this._id = 0;
        this._ids = Object.create(null);
        this._entities = Object.create(null); // inverse of `_ids`
        // `_blankNodeIndex` is the index of the last automatically named blank node
        this._blankNodeIndex = 0;
        // Shift parameters if `quads` is not given
        if (!options && quads && !quads[0]) options = quads, quads = null;
        options = options || {};
        this._factory = options.factory || (0, $712f170b9f5279d6$export$2e2bcd8739ae039);
        // Add quads if passed
        if (quads) this.addQuads(quads);
    }
    _termFromId(id, factory) {
        if (id[0] === ".") {
            const entities = this._entities;
            const terms = id.split(".");
            const q = this._factory.quad(this._termFromId(entities[terms[1]]), this._termFromId(entities[terms[2]]), this._termFromId(entities[terms[3]]), terms[4] && this._termFromId(entities[terms[4]]));
            return q;
        }
        return (0, $712f170b9f5279d6$export$85285e91bbd99cf)(id, factory);
    }
    _termToNumericId(term) {
        if (term.termType === "Quad") {
            const s = this._termToNumericId(term.subject), p = this._termToNumericId(term.predicate), o = this._termToNumericId(term.object);
            let g;
            return s && p && o && ((0, $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8)(term.graph) || (g = this._termToNumericId(term.graph))) && this._ids[g ? `.${s}.${p}.${o}.${g}` : `.${s}.${p}.${o}`];
        }
        return this._ids[(0, $712f170b9f5279d6$export$fbf03d1179c9227e)(term)];
    }
    _termToNewNumericId(term) {
        // This assumes that no graph term is present - we may wish to error if there is one
        const str = term && term.termType === "Quad" ? `.${this._termToNewNumericId(term.subject)}.${this._termToNewNumericId(term.predicate)}.${this._termToNewNumericId(term.object)}${(0, $d33ba30d5e9a7819$export$1a29e0fa6b36b0c8)(term.graph) ? "" : `.${this._termToNewNumericId(term.graph)}`}` : (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(term);
        return this._ids[str] || (this._ids[this._entities[++this._id] = str] = this._id);
    }
    // ## Public properties
    // ### `size` returns the number of quads in the store
    get size() {
        // Return the quad count if if was cached
        let size = this._size;
        if (size !== null) return size;
        // Calculate the number of quads by counting to the deepest level
        size = 0;
        const graphs = this._graphs;
        let subjects, subject;
        for(const graphKey in graphs)for(const subjectKey in subjects = graphs[graphKey].subjects)for(const predicateKey in subject = subjects[subjectKey])size += Object.keys(subject[predicateKey]).length;
        return this._size = size;
    }
    // ## Private methods
    // ### `_addToIndex` adds a quad to a three-layered index.
    // Returns if the index has changed, if the entry did not already exist.
    _addToIndex(index0, key0, key1, key2) {
        // Create layers as necessary
        const index1 = index0[key0] || (index0[key0] = {});
        const index2 = index1[key1] || (index1[key1] = {});
        // Setting the key to _any_ value signals the presence of the quad
        const existed = key2 in index2;
        if (!existed) index2[key2] = null;
        return !existed;
    }
    // ### `_removeFromIndex` removes a quad from a three-layered index
    _removeFromIndex(index0, key0, key1, key2) {
        // Remove the quad from the index
        const index1 = index0[key0], index2 = index1[key1];
        delete index2[key2];
        // Remove intermediary index layers if they are empty
        for(const key in index2)return;
        delete index1[key1];
        for(const key in index1)return;
        delete index0[key0];
    }
    // ### `_findInIndex` finds a set of quads in a three-layered index.
    // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
    // Any of these keys can be undefined, which is interpreted as a wildcard.
    // `name0`, `name1`, and `name2` are the names of the keys at each level,
    // used when reconstructing the resulting quad
    // (for instance: _subject_, _predicate_, and _object_).
    // Finally, `graphId` will be the graph of the created quads.
    *_findInIndex(index0, key0, key1, key2, name0, name1, name2, graphId) {
        let tmp, index1, index2;
        const entityKeys = this._entities;
        const graph = this._termFromId(graphId, this._factory);
        const parts = {
            subject: null,
            predicate: null,
            object: null
        };
        // If a key is specified, use only that part of index 0.
        if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
        for(const value0 in index0)if (index1 = index0[value0]) {
            parts[name0] = this._termFromId(entityKeys[value0], this._factory);
            // If a key is specified, use only that part of index 1.
            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
            for(const value1 in index1)if (index2 = index1[value1]) {
                parts[name1] = this._termFromId(entityKeys[value1], this._factory);
                // If a key is specified, use only that part of index 2, if it exists.
                const values = key2 ? key2 in index2 ? [
                    key2
                ] : [] : Object.keys(index2);
                // Create quads for all items found in index 2.
                for(let l = 0; l < values.length; l++){
                    parts[name2] = this._termFromId(entityKeys[values[l]], this._factory);
                    yield this._factory.quad(parts.subject, parts.predicate, parts.object, graph);
                }
            }
        }
    }
    // ### `_loop` executes the callback on all keys of index 0
    _loop(index0, callback) {
        for(const key0 in index0)callback(key0);
    }
    // ### `_loopByKey0` executes the callback on all keys of a certain entry in index 0
    _loopByKey0(index0, key0, callback) {
        let index1, key1;
        if (index1 = index0[key0]) for(key1 in index1)callback(key1);
    }
    // ### `_loopByKey1` executes the callback on given keys of all entries in index 0
    _loopByKey1(index0, key1, callback) {
        let key0, index1;
        for(key0 in index0){
            index1 = index0[key0];
            if (index1[key1]) callback(key0);
        }
    }
    // ### `_loopBy2Keys` executes the callback on given keys of certain entries in index 2
    _loopBy2Keys(index0, key0, key1, callback) {
        let index1, index2, key2;
        if ((index1 = index0[key0]) && (index2 = index1[key1])) for(key2 in index2)callback(key2);
    }
    // ### `_countInIndex` counts matching quads in a three-layered index.
    // The index base is `index0` and the keys at each level are `key0`, `key1`, and `key2`.
    // Any of these keys can be undefined, which is interpreted as a wildcard.
    _countInIndex(index0, key0, key1, key2) {
        let count = 0, tmp, index1, index2;
        // If a key is specified, count only that part of index 0
        if (key0) (tmp = index0, index0 = {})[key0] = tmp[key0];
        for(const value0 in index0)if (index1 = index0[value0]) {
            // If a key is specified, count only that part of index 1
            if (key1) (tmp = index1, index1 = {})[key1] = tmp[key1];
            for(const value1 in index1)if (index2 = index1[value1]) {
                // If a key is specified, count the quad if it exists
                if (key2) key2 in index2 && count++;
                else count += Object.keys(index2).length;
            }
        }
        return count;
    }
    // ### `_getGraphs` returns an array with the given graph,
    // or all graphs if the argument is null or undefined.
    _getGraphs(graph) {
        if (!$b0dfd6227adaa9e6$var$isString(graph)) return this._graphs;
        const graphs = {};
        graphs[graph] = this._graphs[graph];
        return graphs;
    }
    // ### `_uniqueEntities` returns a function that accepts an entity ID
    // and passes the corresponding entity to callback if it hasn't occurred before.
    _uniqueEntities(callback) {
        const uniqueIds = Object.create(null);
        return (id)=>{
            if (!(id in uniqueIds)) {
                uniqueIds[id] = true;
                callback(this._termFromId(this._entities[id], this._factory));
            }
        };
    }
    // ## Public methods
    // ### `add` adds the specified quad to the dataset.
    // Returns the dataset instance it was called on.
    // Existing quads, as defined in Quad.equals, will be ignored.
    add(quad) {
        this.addQuad(quad);
        return this;
    }
    // ### `addQuad` adds a new quad to the store.
    // Returns if the quad index has changed, if the quad did not already exist.
    addQuad(subject, predicate, object, graph) {
        // Shift arguments if a quad object is given instead of components
        if (!predicate) graph = subject.graph, object = subject.object, predicate = subject.predicate, subject = subject.subject;
        // Convert terms to internal string representation
        graph = (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        // Find the graph that will contain the triple
        let graphItem = this._graphs[graph];
        // Create the graph if it doesn't exist yet
        if (!graphItem) {
            graphItem = this._graphs[graph] = {
                subjects: {},
                predicates: {},
                objects: {}
            };
            // Freezing a graph helps subsequent `add` performance,
            // and properties will never be modified anyway
            Object.freeze(graphItem);
        }
        // Since entities can often be long IRIs, we avoid storing them in every index.
        // Instead, we have a separate index that maps entities to numbers,
        // which are then used as keys in the other indexes.
        subject = this._termToNewNumericId(subject);
        predicate = this._termToNewNumericId(predicate);
        object = this._termToNewNumericId(object);
        const changed = this._addToIndex(graphItem.subjects, subject, predicate, object);
        this._addToIndex(graphItem.predicates, predicate, object, subject);
        this._addToIndex(graphItem.objects, object, subject, predicate);
        // The cached quad count is now invalid
        this._size = null;
        return changed;
    }
    // ### `addQuads` adds multiple quads to the store
    addQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.addQuad(quads[i]);
    }
    // ### `delete` removes the specified quad from the dataset.
    // Returns the dataset instance it was called on.
    delete(quad) {
        this.removeQuad(quad);
        return this;
    }
    // ### `has` determines whether a dataset includes a certain quad or quad pattern.
    has(subjectOrQuad, predicate, object, graph) {
        if (subjectOrQuad && subjectOrQuad.subject) ({ subject: subjectOrQuad, predicate: predicate, object: object, graph: graph } = subjectOrQuad);
        return !this.readQuads(subjectOrQuad, predicate, object, graph).next().done;
    }
    // ### `import` adds a stream of quads to the store
    import(stream) {
        stream.on("data", (quad)=>{
            this.addQuad(quad);
        });
        return stream;
    }
    // ### `removeQuad` removes a quad from the store if it exists
    removeQuad(subject, predicate, object, graph) {
        // Shift arguments if a quad object is given instead of components
        if (!predicate) graph = subject.graph, object = subject.object, predicate = subject.predicate, subject = subject.subject;
        // Convert terms to internal string representation
        graph = (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        // Find internal identifiers for all components
        // and verify the quad exists.
        const graphs = this._graphs;
        let graphItem, subjects, predicates;
        if (!(subject = subject && this._termToNumericId(subject)) || !(predicate = predicate && this._termToNumericId(predicate)) || !(object = object && this._termToNumericId(object)) || !(graphItem = graphs[graph]) || !(subjects = graphItem.subjects[subject]) || !(predicates = subjects[predicate]) || !(object in predicates)) return false;
        // Remove it from all indexes
        this._removeFromIndex(graphItem.subjects, subject, predicate, object);
        this._removeFromIndex(graphItem.predicates, predicate, object, subject);
        this._removeFromIndex(graphItem.objects, object, subject, predicate);
        if (this._size !== null) this._size--;
        // Remove the graph if it is empty
        for(subject in graphItem.subjects)return true;
        delete graphs[graph];
        return true;
    }
    // ### `removeQuads` removes multiple quads from the store
    removeQuads(quads) {
        for(let i = 0; i < quads.length; i++)this.removeQuad(quads[i]);
    }
    // ### `remove` removes a stream of quads from the store
    remove(stream) {
        stream.on("data", (quad)=>{
            this.removeQuad(quad);
        });
        return stream;
    }
    // ### `removeMatches` removes all matching quads from the store
    // Setting any field to `undefined` or `null` indicates a wildcard.
    removeMatches(subject, predicate, object, graph) {
        const stream = new (0, $28176da182b29f80$exports.Readable)({
            objectMode: true
        });
        stream._read = ()=>{
            for (const quad of this.readQuads(subject, predicate, object, graph))stream.push(quad);
            stream.push(null);
        };
        return this.remove(stream);
    }
    // ### `deleteGraph` removes all triples with the given graph from the store
    deleteGraph(graph) {
        return this.removeMatches(null, null, null, graph);
    }
    // ### `getQuads` returns an array of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getQuads(subject, predicate, object, graph) {
        return [
            ...this.readQuads(subject, predicate, object, graph)
        ];
    }
    // ### `readQuads` returns an generator of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    *readQuads(subject, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, predicateId, objectId;
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
        for(const graphId in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graphId]) {
            // Choose the optimal index, based on what fields are present
            if (subjectId) {
                if (objectId) // If subject and object are given, the object index will be the fastest
                yield* this._findInIndex(content.objects, objectId, subjectId, predicateId, "object", "subject", "predicate", graphId);
                else // If only subject and possibly predicate are given, the subject index will be the fastest
                yield* this._findInIndex(content.subjects, subjectId, predicateId, null, "subject", "predicate", "object", graphId);
            } else if (predicateId) // If only predicate and possibly object are given, the predicate index will be the fastest
            yield* this._findInIndex(content.predicates, predicateId, objectId, null, "predicate", "object", "subject", graphId);
            else if (objectId) // If only object is given, the object index will be the fastest
            yield* this._findInIndex(content.objects, objectId, null, null, "object", "subject", "predicate", graphId);
            else // If nothing is given, iterate subjects and predicates first
            yield* this._findInIndex(content.subjects, null, null, null, "subject", "predicate", "object", graphId);
        }
    }
    // ### `match` returns a new dataset that is comprised of all quads in the current instance matching the given arguments.
    // The logic described in Quad Matching is applied for each quad in this dataset to check if it should be included in the output dataset.
    // Note: This method always returns a new DatasetCore, even if that dataset contains no quads.
    // Note: Since a DatasetCore is an unordered set, the order of the quads within the returned sequence is arbitrary.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    // For backwards compatibility, the object return also implements the Readable stream interface.
    match(subject, predicate, object, graph) {
        return new $b0dfd6227adaa9e6$var$DatasetCoreAndReadableStream(this, subject, predicate, object, graph);
    }
    // ### `countQuads` returns the number of quads matching a pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    countQuads(subject, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let count = 0, content, subjectId, predicateId, objectId;
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return 0;
        for(const graphId in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graphId]) {
            // Choose the optimal index, based on what fields are present
            if (subject) {
                if (object) // If subject and object are given, the object index will be the fastest
                count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
                else // If only subject and possibly predicate are given, the subject index will be the fastest
                count += this._countInIndex(content.subjects, subjectId, predicateId, objectId);
            } else if (predicate) // If only predicate and possibly object are given, the predicate index will be the fastest
            count += this._countInIndex(content.predicates, predicateId, objectId, subjectId);
            else // If only object is possibly given, the object index will be the fastest
            count += this._countInIndex(content.objects, objectId, subjectId, predicateId);
        }
        return count;
    }
    // ### `forEach` executes the callback on all quads.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forEach(callback, subject, predicate, object, graph) {
        this.some((quad)=>{
            callback(quad);
            return false;
        }, subject, predicate, object, graph);
    }
    // ### `every` executes the callback on all quads,
    // and returns `true` if it returns truthy for all them.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    every(callback, subject, predicate, object, graph) {
        let some = false;
        const every = !this.some((quad)=>{
            some = true;
            return !callback(quad);
        }, subject, predicate, object, graph);
        return some && every;
    }
    // ### `some` executes the callback on all quads,
    // and returns `true` if it returns truthy for any of them.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    some(callback, subject, predicate, object, graph) {
        for (const quad of this.readQuads(subject, predicate, object, graph))if (callback(quad)) return true;
        return false;
    }
    // ### `getSubjects` returns all subjects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getSubjects(predicate, object, graph) {
        const results = [];
        this.forSubjects((s)=>{
            results.push(s);
        }, predicate, object, graph);
        return results;
    }
    // ### `forSubjects` executes the callback on all subjects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forSubjects(callback, predicate, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, predicateId, objectId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (predicate && !(predicateId = this._termToNumericId(predicate)) || object && !(objectId = this._termToNumericId(object))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (predicateId) {
                if (objectId) // If predicate and object are given, the POS index is best.
                this._loopBy2Keys(content.predicates, predicateId, objectId, callback);
                else // If only predicate is given, the SPO index is best.
                this._loopByKey1(content.subjects, predicateId, callback);
            } else if (objectId) // If only object is given, the OSP index is best.
            this._loopByKey0(content.objects, objectId, callback);
            else // If no params given, iterate all the subjects
            this._loop(content.subjects, callback);
        }
    }
    // ### `getPredicates` returns all predicates that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getPredicates(subject, object, graph) {
        const results = [];
        this.forPredicates((p)=>{
            results.push(p);
        }, subject, object, graph);
        return results;
    }
    // ### `forPredicates` executes the callback on all predicates that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forPredicates(callback, subject, object, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, objectId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || object && !(objectId = this._termToNumericId(object))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (subjectId) {
                if (objectId) // If subject and object are given, the OSP index is best.
                this._loopBy2Keys(content.objects, objectId, subjectId, callback);
                else // If only subject is given, the SPO index is best.
                this._loopByKey0(content.subjects, subjectId, callback);
            } else if (objectId) // If only object is given, the POS index is best.
            this._loopByKey1(content.predicates, objectId, callback);
            else // If no params given, iterate all the predicates.
            this._loop(content.predicates, callback);
        }
    }
    // ### `getObjects` returns all objects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getObjects(subject, predicate, graph) {
        const results = [];
        this.forObjects((o)=>{
            results.push(o);
        }, subject, predicate, graph);
        return results;
    }
    // ### `forObjects` executes the callback on all objects that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forObjects(callback, subject, predicate, graph) {
        // Convert terms to internal string representation
        graph = graph && (0, $712f170b9f5279d6$export$fbf03d1179c9227e)(graph);
        const graphs = this._getGraphs(graph);
        let content, subjectId, predicateId;
        callback = this._uniqueEntities(callback);
        // Translate IRIs to internal index keys.
        if (subject && !(subjectId = this._termToNumericId(subject)) || predicate && !(predicateId = this._termToNumericId(predicate))) return;
        for(graph in graphs)// Only if the specified graph contains triples, there can be results
        if (content = graphs[graph]) {
            // Choose optimal index based on which fields are wildcards
            if (subjectId) {
                if (predicateId) // If subject and predicate are given, the SPO index is best.
                this._loopBy2Keys(content.subjects, subjectId, predicateId, callback);
                else // If only subject is given, the OSP index is best.
                this._loopByKey1(content.objects, subjectId, callback);
            } else if (predicateId) // If only predicate is given, the POS index is best.
            this._loopByKey0(content.predicates, predicateId, callback);
            else // If no params given, iterate all the objects.
            this._loop(content.objects, callback);
        }
    }
    // ### `getGraphs` returns all graphs that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    getGraphs(subject, predicate, object) {
        const results = [];
        this.forGraphs((g)=>{
            results.push(g);
        }, subject, predicate, object);
        return results;
    }
    // ### `forGraphs` executes the callback on all graphs that match the pattern.
    // Setting any field to `undefined` or `null` indicates a wildcard.
    forGraphs(callback, subject, predicate, object) {
        for(const graph in this._graphs)this.some((quad)=>{
            callback(quad.graph);
            return true; // Halt iteration of some()
        }, subject, predicate, object, graph);
    }
    // ### `createBlankNode` creates a new blank node, returning its name
    createBlankNode(suggestedName) {
        let name, index;
        // Generate a name based on the suggested name
        if (suggestedName) {
            name = suggestedName = `_:${suggestedName}`, index = 1;
            while(this._ids[name])name = suggestedName + index++;
        } else do name = `_:b${this._blankNodeIndex++}`;
        while (this._ids[name]);
        // Add the blank node to the entities, avoiding the generation of duplicates
        this._ids[name] = ++this._id;
        this._entities[this._id] = name;
        return this._factory.blankNode(name.substr(2));
    }
    // ### `extractLists` finds and removes all list triples
    // and returns the items per list.
    extractLists({ remove: remove = false, ignoreErrors: ignoreErrors = false } = {}) {
        const lists = {}; // has scalar keys so could be a simple Object
        const onError = ignoreErrors ? ()=>true : (node, message)=>{
            throw new Error(`${node.value} ${message}`);
        };
        // Traverse each list from its tail
        const tails = this.getQuads(null, (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.rest, (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.nil, null);
        const toRemove = remove ? [
            ...tails
        ] : [];
        tails.forEach((tailQuad)=>{
            const items = []; // the members found as objects of rdf:first quads
            let malformed = false; // signals whether the current list is malformed
            let head; // the head of the list (_:b1 in above example)
            let headPos; // set to subject or object when head is set
            const graph = tailQuad.graph; // make sure list is in exactly one graph
            // Traverse the list from tail to end
            let current = tailQuad.subject;
            while(current && !malformed){
                const objectQuads = this.getQuads(null, null, current, null);
                const subjectQuads = this.getQuads(current, null, null, null);
                let quad, first = null, rest = null, parent = null;
                // Find the first and rest of this list node
                for(let i = 0; i < subjectQuads.length && !malformed; i++){
                    quad = subjectQuads[i];
                    if (!quad.graph.equals(graph)) malformed = onError(current, "not confined to single graph");
                    else if (head) malformed = onError(current, "has non-list arcs out");
                    else if (quad.predicate.value === (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.first) {
                        if (first) malformed = onError(current, "has multiple rdf:first arcs");
                        else toRemove.push(first = quad);
                    } else if (quad.predicate.value === (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.rest) {
                        if (rest) malformed = onError(current, "has multiple rdf:rest arcs");
                        else toRemove.push(rest = quad);
                    } else if (objectQuads.length) malformed = onError(current, "can't be subject and object");
                    else {
                        head = quad; // e.g. { (1 2 3) :p :o }
                        headPos = "subject";
                    }
                }
                // { :s :p (1 2) } arrives here with no head
                // { (1 2) :p :o } arrives here with head set to the list.
                for(let i = 0; i < objectQuads.length && !malformed; ++i){
                    quad = objectQuads[i];
                    if (head) malformed = onError(current, "can't have coreferences");
                    else if (quad.predicate.value === (0, $b50e49a75dcd9196$export$2e2bcd8739ae039).rdf.rest) {
                        if (parent) malformed = onError(current, "has incoming rdf:rest arcs");
                        else parent = quad;
                    } else {
                        head = quad; // e.g. { :s :p (1 2) }
                        headPos = "object";
                    }
                }
                // Store the list item and continue with parent
                if (!first) malformed = onError(current, "has no list head");
                else items.unshift(first.object);
                current = parent && parent.subject;
            }
            // Don't remove any quads if the list is malformed
            if (malformed) remove = false;
            else if (head) lists[head[headPos].value] = items;
        });
        // Remove list quads if requested
        if (remove) this.removeQuads(toRemove);
        return lists;
    }
    // ### Store is an iterable.
    // Can be used where iterables are expected: for...of loops, array spread operator,
    // `yield*`, and destructuring assignment (order is not guaranteed).
    *[Symbol.iterator]() {
        yield* this.readQuads();
    }
}
// Determines whether the argument is a string
function $b0dfd6227adaa9e6$var$isString(s) {
    return typeof s === "string" || s instanceof String;
}
/**
 * A class that implements both DatasetCore and Readable.
 */ class $b0dfd6227adaa9e6$var$DatasetCoreAndReadableStream extends (0, $28176da182b29f80$exports.Readable) {
    constructor(n3Store, subject, predicate, object, graph){
        super({
            objectMode: true
        });
        Object.assign(this, {
            n3Store: n3Store,
            subject: subject,
            predicate: predicate,
            object: object,
            graph: graph
        });
    }
    get filtered() {
        if (!this._filtered) {
            const { n3Store: n3Store, graph: graph, object: object, predicate: predicate, subject: subject } = this;
            const newStore = this._filtered = new $b0dfd6227adaa9e6$export$2e2bcd8739ae039({
                factory: n3Store._factory
            });
            for (const quad of n3Store.readQuads(subject, predicate, object, graph))newStore.addQuad(quad);
        }
        return this._filtered;
    }
    get size() {
        return this.filtered.size;
    }
    _read() {
        for (const quad of this)this.push(quad);
        this.push(null);
    }
    add(quad) {
        return this.filtered.add(quad);
    }
    delete(quad) {
        return this.filtered.delete(quad);
    }
    has(quad) {
        return this.filtered.has(quad);
    }
    match(subject, predicate, object, graph) {
        return new $b0dfd6227adaa9e6$var$DatasetCoreAndReadableStream(this.filtered, subject, predicate, object, graph);
    }
    *[Symbol.iterator]() {
        yield* this._filtered || this.n3Store.readQuads(this.subject, this.predicate, this.object, this.graph);
    }
}


// **N3StreamParser** parses a text stream into a quad stream.


class $6bcaa36986f53a11$export$2e2bcd8739ae039 extends (0, $28176da182b29f80$exports.Transform) {
    constructor(options){
        super({
            decodeStrings: true
        });
        this._readableState.objectMode = true;
        // Set up parser with dummy stream to obtain `data` and `end` callbacks
        const parser = new (0, $c0715e6442e25456$export$2e2bcd8739ae039)(options);
        let onData, onEnd;
        parser.parse({
            on: (event, callback)=>{
                switch(event){
                    case "data":
                        onData = callback;
                        break;
                    case "end":
                        onEnd = callback;
                        break;
                }
            }
        }, // Handle quads by pushing them down the pipeline
        (error, quad)=>{
            error && this.emit("error", error) || quad && this.push(quad);
        }, // Emit prefixes through the `prefix` event
        (prefix, uri)=>{
            this.emit("prefix", prefix, uri);
        });
        // Implement Transform methods through parser callbacks
        this._transform = (chunk, encoding, done)=>{
            onData(chunk);
            done();
        };
        this._flush = (done)=>{
            onEnd();
            done();
        };
    }
    // ### Parses a stream of strings
    import(stream) {
        stream.on("data", (chunk)=>{
            this.write(chunk);
        });
        stream.on("end", ()=>{
            this.end();
        });
        stream.on("error", (error)=>{
            this.emit("error", error);
        });
        return this;
    }
}


// **N3StreamWriter** serializes a quad stream into a text stream.


class $5cb440355f51fa91$export$2e2bcd8739ae039 extends (0, $28176da182b29f80$exports.Transform) {
    constructor(options){
        super({
            encoding: "utf8",
            writableObjectMode: true
        });
        // Set up writer with a dummy stream object
        const writer = this._writer = new (0, $bab8cb0a961d0e7d$export$2e2bcd8739ae039)({
            write: (quad, encoding, callback)=>{
                this.push(quad);
                callback && callback();
            },
            end: (callback)=>{
                this.push(null);
                callback && callback();
            }
        }, options);
        // Implement Transform methods on top of writer
        this._transform = (quad, encoding, done)=>{
            writer.addQuad(quad, done);
        };
        this._flush = (done)=>{
            writer.end(done);
        };
    }
    // ### Serializes a stream of quads
    import(stream) {
        stream.on("data", (quad)=>{
            this.write(quad);
        });
        stream.on("end", ()=>{
            this.end();
        });
        stream.on("error", (error)=>{
            this.emit("error", error);
        });
        stream.on("prefix", (prefix, iri)=>{
            this._writer.addPrefix(prefix, iri);
        });
        return this;
    }
}




var // Export all named exports as a default object for backward compatibility
$4c2b561ec056addb$export$2e2bcd8739ae039 = {
    Lexer: $c66a9a29d2de1131$export$2e2bcd8739ae039,
    Parser: $c0715e6442e25456$export$2e2bcd8739ae039,
    Writer: $bab8cb0a961d0e7d$export$2e2bcd8739ae039,
    Store: $b0dfd6227adaa9e6$export$2e2bcd8739ae039,
    StreamParser: $6bcaa36986f53a11$export$2e2bcd8739ae039,
    StreamWriter: $5cb440355f51fa91$export$2e2bcd8739ae039,
    Util: $d33ba30d5e9a7819$exports,
    DataFactory: $712f170b9f5279d6$export$2e2bcd8739ae039,
    Term: $712f170b9f5279d6$export$656c1e606ad06131,
    NamedNode: $712f170b9f5279d6$export$e55689a56c4c92c2,
    Literal: $712f170b9f5279d6$export$e175ae9e414693bc,
    BlankNode: $712f170b9f5279d6$export$1a8019c085269883,
    Variable: $712f170b9f5279d6$export$c867a5c9595a1350,
    DefaultGraph: $712f170b9f5279d6$export$4383f89a7161b240,
    Quad: $712f170b9f5279d6$export$7005c9eb6671414d,
    Triple: $712f170b9f5279d6$export$7005c9eb6671414d,
    termFromId: $712f170b9f5279d6$export$85285e91bbd99cf,
    termToId: $712f170b9f5279d6$export$fbf03d1179c9227e
};




var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");



var $99pVg = parcelRequire("99pVg");

var $4Q80K = parcelRequire("4Q80K");

var $23fob = parcelRequire("23fob");

if (typeof $fec45f84912c236b$var$Node === "undefined") //  @@@@@@ Global. Interface to xmldom.
var $fec45f84912c236b$var$Node = {
    ELEMENT_NODE: 1,
    ATTRIBUTE_NODE: 2,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    ENTITY_REFERENCE_NODE: 5,
    ENTITY_NODE: 6,
    PROCESSING_INSTRUCTION_NODE: 7,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9,
    DOCUMENT_TYPE_NODE: 10,
    DOCUMENT_FRAGMENT_NODE: 11,
    NOTATION_NODE: 12
};
var $fec45f84912c236b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RDFaProcessor(kb, options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RDFaProcessor);
        this.options = options || {};
        this.kb = kb;
        this.target = options.target || {
            graph: {
                subjects: {},
                prefixes: {},
                terms: {}
            }
        };
        // XXX: Added to track bnodes
        this.blankNodes = [];
        // XXX: Added for normalisation
        this.htmlOptions = {
            "selfClosing": "br img input area base basefont col colgroup source wbr isindex link meta param hr"
        };
        this.theOne = "_:" + new Date().getTime();
        this.language = null;
        this.vocabulary = null;
        this.blankCounter = 0;
        this.langAttributes = [
            {
                namespaceURI: "http://www.w3.org/XML/1998/namespace",
                localName: "lang"
            }
        ];
        this.inXHTMLMode = false;
        this.absURIRE = /[\w\_\-]+:\S+/;
        this.finishedHandlers = [];
        this.init();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RDFaProcessor, [
        {
            key: "addTriple",
            value: function addTriple(origin, subject, predicate, object) {
                var su, ob, pr, or;
                if (typeof subject === "undefined") su = (0, $158d84b4866fe33e$export$2e2bcd8739ae039).namedNode(this.options.base);
                else su = this.toRDFNodeObject(subject);
                pr = this.toRDFNodeObject(predicate);
                ob = this.toRDFNodeObject(object);
                or = (0, $158d84b4866fe33e$export$2e2bcd8739ae039).namedNode(this.options.base);
                // console.log('Adding { ' + su + ' ' + pr + ' ' + ob + ' ' + or + ' }')
                this.kb.add(su, pr, ob, or);
            }
        },
        {
            key: "ancestorPath",
            value: function ancestorPath(node) {
                var path = "";
                while(node && node.nodeType !== $fec45f84912c236b$var$Node.DOCUMENT_NODE){
                    path = "/" + node.localName + path;
                    node = node.parentNode;
                }
                return path;
            }
        },
        {
            key: "copyMappings",
            value: function copyMappings(mappings) {
                var newMappings = {};
                for(var k in mappings)newMappings[k] = mappings[k];
                return newMappings;
            }
        },
        {
            key: "copyProperties",
            value: function copyProperties() {}
        },
        {
            key: "deriveDateTimeType",
            value: function deriveDateTimeType(value) {
                for(var i = 0; i < RDFaProcessor.dateTimeTypes.length; i++){
                    // console.log("Checking "+value+" against "+RDFaProcessor.dateTimeTypes[i].type)
                    var matched = RDFaProcessor.dateTimeTypes[i].pattern.exec(value);
                    if (matched && matched[0].length === value.length) // console.log("Matched!")
                    return RDFaProcessor.dateTimeTypes[i].type;
                }
                return null;
            }
        },
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "newBlankNode",
            value: function newBlankNode() {
                this.blankCounter++;
                return "_:" + this.blankCounter;
            }
        },
        {
            key: "newSubjectOrigin",
            value: function newSubjectOrigin(origin, subject) {}
        },
        {
            key: "parseCURIE",
            value: function parseCURIE(value, prefixes, base) {
                var colon = value.indexOf(":");
                var uri;
                if (colon >= 0) {
                    var prefix = value.substring(0, colon);
                    if (prefix === "") {
                        // default prefix
                        uri = prefixes[""];
                        return uri ? uri + value.substring(colon + 1) : null;
                    } else if (prefix === "_") // blank node
                    return "_:" + value.substring(colon + 1);
                    else if (RDFaProcessor.NCNAME.test(prefix)) {
                        uri = prefixes[prefix];
                        if (uri) return uri + value.substring(colon + 1);
                    }
                }
                return null;
            }
        },
        {
            key: "parseCURIEOrURI",
            value: function parseCURIEOrURI(value, prefixes, base) {
                var curie = this.parseCURIE(value, prefixes, base);
                if (curie) return curie;
                return this.resolveAndNormalize(base, value);
            }
        },
        {
            key: "parsePredicate",
            value: function parsePredicate(value, defaultVocabulary, terms, prefixes, base, ignoreTerms) {
                if (value === "") return null;
                var predicate = this.parseTermOrCURIEOrAbsURI(value, defaultVocabulary, ignoreTerms ? null : terms, prefixes, base);
                if (predicate && predicate.indexOf("_:") === 0) return null;
                return predicate;
            }
        },
        {
            key: "parsePrefixMappings",
            value: function parsePrefixMappings(str, target) {
                var values = this.tokenize(str);
                var prefix = null;
                // var uri = null
                for(var i = 0; i < values.length; i++){
                    if (values[i][values[i].length - 1] === ":") prefix = values[i].substring(0, values[i].length - 1);
                    else if (prefix) {
                        target[prefix] = this.options.base ? $4Q80K.join(values[i], this.options.base) : values[i];
                        prefix = null;
                    }
                }
            }
        },
        {
            key: "parseSafeCURIEOrCURIEOrURI",
            value: function parseSafeCURIEOrCURIEOrURI(value, prefixes, base) {
                value = this.trim(value);
                if (value.charAt(0) === "[" && value.charAt(value.length - 1) === "]") {
                    value = value.substring(1, value.length - 1);
                    value = value.trim(value);
                    if (value.length === 0) return null;
                    if (value === "_:") // the one node
                    return this.theOne;
                    return this.parseCURIE(value, prefixes, base);
                } else return this.parseCURIEOrURI(value, prefixes, base);
            }
        },
        {
            key: "parseTermOrCURIEOrAbsURI",
            value: function parseTermOrCURIEOrAbsURI(value, defaultVocabulary, terms, prefixes, base) {
                // alert("Parsing "+value+" with default vocab "+defaultVocabulary)
                value = this.trim(value);
                var curie = this.parseCURIE(value, prefixes, base);
                if (curie) return curie;
                else if (terms) {
                    if (defaultVocabulary && !this.absURIRE.exec(value)) return defaultVocabulary + value;
                    var term = terms[value];
                    if (term) return term;
                    var lcvalue = value.toLowerCase();
                    term = terms[lcvalue];
                    if (term) return term;
                }
                if (this.absURIRE.exec(value)) return this.resolveAndNormalize(base, value);
                return null;
            }
        },
        {
            key: "parseTermOrCURIEOrURI",
            value: function parseTermOrCURIEOrURI(value, defaultVocabulary, terms, prefixes, base) {
                // alert("Parsing "+value+" with default vocab "+defaultVocabulary)
                value = this.trim(value);
                var curie = this.parseCURIE(value, prefixes, base);
                if (curie) return curie;
                else {
                    var term = terms[value];
                    if (term) return term;
                    var lcvalue = value.toLowerCase();
                    term = terms[lcvalue];
                    if (term) return term;
                    if (defaultVocabulary && !this.absURIRE.exec(value)) return defaultVocabulary + value;
                }
                return this.resolveAndNormalize(base, value);
            }
        },
        {
            key: "parseURI",
            value: function parseURI(uri) {
                return uri; // We just use strings as URIs, not objects now.
            }
        },
        {
            key: "process",
            value: function process(node, options) {
                /*
      if (!window.console) {
         window.console = { log: function() {} }
      } */ options = options || {};
                var base;
                if (node.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) {
                    if (node.baseURI && !options.baseURI) options.baseURI = node.baseURI; // be defensive as DOM implementations vary
                    base = node.baseURI;
                    node = node.documentElement;
                    if (!node.baseURI) node.baseURI = base;
                    this.setContext(node);
                } else if (node.parentNode.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) this.setContext(node);
                var queue = [];
                // Fix for Firefox that includes the hash in the base URI
                var removeHash = function removeHash(baseURI) {
                    // Fix for undefined baseURI property
                    if (!baseURI && options && options.baseURI) return options.baseURI;
                    var hash = baseURI.indexOf("#");
                    if (hash >= 0) baseURI = baseURI.substring(0, hash);
                    if (options && options.baseURIMap) baseURI = options.baseURIMap(baseURI);
                    return baseURI;
                };
                queue.push({
                    current: node,
                    context: this.push(null, removeHash(node.baseURI))
                });
                while(queue.length > 0){
                    var item = queue.shift();
                    if (item.parent) {
                        // Sequence Step 14: list triple generation
                        if (item.context.parent && item.context.parent.listMapping === item.listMapping) continue;
                        // console.log("Generating lists for "+item.subject+", tag "+item.parent.localName)
                        for(var _predicate in item.listMapping){
                            var list = item.listMapping[_predicate];
                            if (list.length === 0) {
                                this.addTriple(item.parent, item.subject, _predicate, {
                                    type: RDFaProcessor.objectURI,
                                    value: "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
                                });
                                continue;
                            }
                            var bnodes = [];
                            for(var _i = 0; _i < list.length; _i++)bnodes.push(this.newBlankNode());
                            for(var _i2 = 0; _i2 < bnodes.length; _i2++){
                                this.addTriple(item.parent, bnodes[_i2], "http://www.w3.org/1999/02/22-rdf-syntax-ns#first", list[_i2]);
                                this.addTriple(item.parent, bnodes[_i2], "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest", {
                                    type: RDFaProcessor.objectURI,
                                    value: _i2 + 1 < bnodes.length ? bnodes[_i2 + 1] : "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
                                });
                            }
                            this.addTriple(item.parent, item.subject, _predicate, {
                                type: RDFaProcessor.objectURI,
                                value: bnodes[0]
                            });
                        }
                        continue;
                    }
                    var current = item.current;
                    var context = item.context;
                    // console.log("Tag: "+current.localName+", listMapping="+JSON.stringify(context.listMapping))
                    // Sequence Step 1
                    var skip = false;
                    var newSubject = null;
                    var currentObjectResource = null;
                    var typedResource = null;
                    var prefixes = context.prefixes;
                    var prefixesCopied = false;
                    var incomplete = [];
                    var listMapping = context.listMapping;
                    var listMappingDifferent = !context.parent;
                    var language = context.language;
                    var vocabulary = context.vocabulary;
                    // TODO: the "base" element may be used for HTML+RDFa 1.1
                    base = this.parseURI(removeHash(current.baseURI));
                    current.item = null;
                    // Sequence Step 2: set the default vocabulary
                    var vocabAtt = current.getAttributeNode("vocab");
                    if (vocabAtt) {
                        var value = this.trim(vocabAtt.value);
                        if (value.length > 0) {
                            vocabulary = value;
                            var baseSubject = base.spec;
                            // this.newSubject(current,baseSubject)
                            this.addTriple(current, baseSubject, "http://www.w3.org/ns/rdfa#usesVocabulary", {
                                type: RDFaProcessor.objectURI,
                                value: vocabulary
                            });
                        } else vocabulary = this.vocabulary;
                    }
                    // Sequence Step 3: IRI mappings
                    // handle xmlns attributes
                    for(var i = 0; i < current.attributes.length; i++){
                        var att = current.attributes[i];
                        // if (att.namespaceURI=="http://www.w3.org/2000/xmlns/") {
                        if (att.nodeName.charAt(0) === "x" && att.nodeName.indexOf("xmlns:") === 0) {
                            if (!prefixesCopied) {
                                prefixes = this.copyMappings(prefixes);
                                prefixesCopied = true;
                            }
                            var prefix = att.nodeName.substring(6);
                            // TODO: resolve relative?
                            var ref = RDFaProcessor.trim(att.value);
                            prefixes[prefix] = this.options.base ? $4Q80K.join(ref, this.options.base) : ref;
                        }
                    }
                    // Handle prefix mappings (@prefix)
                    var prefixAtt = current.getAttributeNode("prefix");
                    if (prefixAtt) {
                        if (!prefixesCopied) {
                            prefixes = this.copyMappings(prefixes);
                            prefixesCopied = true;
                        }
                        this.parsePrefixMappings(prefixAtt.value, prefixes);
                    }
                    // Sequence Step 4: language
                    var xmlLangAtt = null;
                    for(var _i3 = 0; !xmlLangAtt && _i3 < this.langAttributes.length; _i3++)xmlLangAtt = current.getAttributeNodeNS(this.langAttributes[_i3].namespaceURI, this.langAttributes[_i3].localName);
                    if (xmlLangAtt) {
                        var _value = RDFaProcessor.trim(xmlLangAtt.value);
                        if (_value.length > 0) language = _value;
                        else language = null;
                    }
                    var relAtt = current.getAttributeNode("rel");
                    var revAtt = current.getAttributeNode("rev");
                    var typeofAtt = current.getAttributeNode("typeof");
                    var propertyAtt = current.getAttributeNode("property");
                    var datatypeAtt = current.getAttributeNode("datatype");
                    var datetimeAtt = this.inHTMLMode ? current.getAttributeNode("datetime") : null;
                    var contentAtt = current.getAttributeNode("content");
                    var aboutAtt = current.getAttributeNode("about");
                    var srcAtt = current.getAttributeNode("src");
                    var resourceAtt = current.getAttributeNode("resource");
                    var hrefAtt = current.getAttributeNode("href");
                    var inlistAtt = current.getAttributeNode("inlist");
                    var relAttPredicates = [];
                    var predicate, values;
                    if (relAtt) {
                        values = this.tokenize(relAtt.value);
                        for(var _i4 = 0; _i4 < values.length; _i4++){
                            predicate = this.parsePredicate(values[_i4], vocabulary, context.terms, prefixes, base, this.inHTMLMode && propertyAtt !== null);
                            if (predicate) relAttPredicates.push(predicate);
                        }
                    }
                    var revAttPredicates = [];
                    if (revAtt) {
                        values = this.tokenize(revAtt.value);
                        for(var _i5 = 0; _i5 < values.length; _i5++){
                            predicate = this.parsePredicate(values[_i5], vocabulary, context.terms, prefixes, base, this.inHTMLMode && propertyAtt);
                            if (predicate) revAttPredicates.push(predicate);
                        }
                    }
                    // Section 3.1, bullet 7
                    if (this.inHTMLMode && (relAtt || revAtt) && propertyAtt) {
                        if (relAttPredicates.length === 0) relAtt = null;
                        if (revAttPredicates.length === 0) revAtt = null;
                    }
                    if (relAtt || revAtt) {
                        // Sequence Step 6: establish new subject and value
                        if (aboutAtt) newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
                        if (typeofAtt) typedResource = newSubject;
                        if (!newSubject) {
                            if (current.parentNode.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) newSubject = removeHash(current.baseURI);
                            else if (context.parentObject) // TODO: Verify: If the xml:base has been set and the parentObject is the baseURI of the parent, then the subject needs to be the new base URI
                            newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                        }
                        if (resourceAtt) currentObjectResource = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
                        if (!currentObjectResource) {
                            if (hrefAtt) currentObjectResource = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
                            else if (srcAtt) currentObjectResource = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
                            else if (typeofAtt && !aboutAtt && !(this.inXHTMLMode && (current.localName === "head" || current.localName === "body"))) currentObjectResource = this.newBlankNode();
                        }
                        if (typeofAtt && !aboutAtt && this.inXHTMLMode && (current.localName === "head" || current.localName === "body")) typedResource = newSubject;
                        else if (typeofAtt && !aboutAtt) typedResource = currentObjectResource;
                    } else if (propertyAtt && !contentAtt && !datatypeAtt) {
                        // Sequence Step 5.1: establish a new subject
                        if (aboutAtt) {
                            newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
                            if (typeofAtt) typedResource = newSubject;
                        }
                        if (!newSubject && current.parentNode.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) {
                            newSubject = removeHash(current.baseURI);
                            if (typeofAtt) typedResource = newSubject;
                        } else if (!newSubject && context.parentObject) // TODO: Verify: If the xml:base has been set and the parentObject is the baseURI of the parent, then the subject needs to be the new base URI
                        newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                        if (typeofAtt && !typedResource) {
                            if (resourceAtt) typedResource = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
                            if (!typedResource && hrefAtt) typedResource = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
                            if (!typedResource && srcAtt) typedResource = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
                            if (!typedResource && (this.inXHTMLMode || this.inHTMLMode) && (current.localName === "head" || current.localName === "body")) typedResource = newSubject;
                            if (!typedResource) typedResource = this.newBlankNode();
                            currentObjectResource = typedResource;
                        }
                    // console.log(current.localName+", newSubject="+newSubject+", typedResource="+typedResource+", currentObjectResource="+currentObjectResource)
                    } else {
                        // Sequence Step 5.2: establish a new subject
                        if (aboutAtt) newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes, base);
                        if (!newSubject && resourceAtt) newSubject = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
                        if (!newSubject && hrefAtt) newSubject = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
                        if (!newSubject && srcAtt) newSubject = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
                        if (!newSubject) {
                            if (current.parentNode.nodeType === $fec45f84912c236b$var$Node.DOCUMENT_NODE) newSubject = removeHash(current.baseURI);
                            else if ((this.inXHTMLMode || this.inHTMLMode) && (current.localName === "head" || current.localName === "body")) newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                            else if (typeofAtt) newSubject = this.newBlankNode();
                            else if (context.parentObject) {
                                // TODO: Verify: If the xml:base has been set and the parentObject is the baseURI of the parent, then the subject needs to be the new base URI
                                newSubject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                                if (!propertyAtt) skip = true;
                            }
                        }
                        if (typeofAtt) typedResource = newSubject;
                    }
                    // console.log(current.tagName+": newSubject="+newSubject+", currentObjectResource="+currentObjectResource+", typedResource="+typedResource+", skip="+skip)
                    // var rdfaData = null
                    if (newSubject) // this.newSubject(current,newSubject)
                    {
                        if (aboutAtt || resourceAtt || typedResource) {
                            var id = newSubject;
                            if (typeofAtt && !aboutAtt && !resourceAtt && currentObjectResource) id = currentObjectResource;
                            // console.log("Setting data attribute for "+current.localName+" for subject "+id)
                            this.newSubjectOrigin(current, id);
                        }
                    }
                    // Sequence Step 7: generate type triple
                    if (typedResource) {
                        values = this.tokenize(typeofAtt.value);
                        for(var _i6 = 0; _i6 < values.length; _i6++){
                            var object = this.parseTermOrCURIEOrAbsURI(values[_i6], vocabulary, context.terms, prefixes, base);
                            if (object) this.addTriple(current, typedResource, RDFaProcessor.typeURI, {
                                type: RDFaProcessor.objectURI,
                                value: object
                            });
                        }
                    }
                    // Sequence Step 8: new list mappings if there is a new subject
                    // console.log("Step 8: newSubject="+newSubject+", context.parentObject="+context.parentObject)
                    if (newSubject && newSubject !== context.parentObject) {
                        // console.log("Generating new list mapping for "+newSubject)
                        listMapping = {};
                        listMappingDifferent = true;
                    }
                    // Sequence Step 9: generate object triple
                    if (currentObjectResource) {
                        if (relAtt && inlistAtt) for(var _i7 = 0; _i7 < relAttPredicates.length; _i7++){
                            var _list = listMapping[relAttPredicates[_i7]];
                            if (!_list) {
                                _list = [];
                                listMapping[relAttPredicates[_i7]] = _list;
                            }
                            _list.push({
                                type: RDFaProcessor.objectURI,
                                value: currentObjectResource
                            });
                        }
                        else if (relAtt) for(var _i8 = 0; _i8 < relAttPredicates.length; _i8++)this.addTriple(current, newSubject, relAttPredicates[_i8], {
                            type: RDFaProcessor.objectURI,
                            value: currentObjectResource
                        });
                        if (revAtt) for(var _i9 = 0; _i9 < revAttPredicates.length; _i9++)this.addTriple(current, currentObjectResource, revAttPredicates[_i9], {
                            type: RDFaProcessor.objectURI,
                            value: newSubject
                        });
                    } else {
                        // Sequence Step 10: incomplete triples
                        if (newSubject && !currentObjectResource && (relAtt || revAtt)) currentObjectResource = this.newBlankNode();
                        if (relAtt && inlistAtt) for(var _i10 = 0; _i10 < relAttPredicates.length; _i10++){
                            var _list2 = listMapping[relAttPredicates[_i10]];
                            if (!_list2) {
                                _list2 = [];
                                listMapping[predicate] = _list2;
                            }
                            // console.log("Adding incomplete list for "+predicate)
                            incomplete.push({
                                predicate: relAttPredicates[_i10],
                                list: _list2
                            });
                        }
                        else if (relAtt) for(var _i11 = 0; _i11 < relAttPredicates.length; _i11++)incomplete.push({
                            predicate: relAttPredicates[_i11],
                            forward: true
                        });
                        if (revAtt) for(var _i12 = 0; _i12 < revAttPredicates.length; _i12++)incomplete.push({
                            predicate: revAttPredicates[_i12],
                            forward: false
                        });
                    }
                    // Step 11: Current property values
                    if (propertyAtt) {
                        var datatype = null;
                        var content = null;
                        if (datatypeAtt) {
                            datatype = datatypeAtt.value === "" ? RDFaProcessor.PlainLiteralURI : this.parseTermOrCURIEOrAbsURI(datatypeAtt.value, vocabulary, context.terms, prefixes, base);
                            if (datetimeAtt && !contentAtt) content = datetimeAtt.value;
                            else content = datatype === RDFaProcessor.XMLLiteralURI || datatype === RDFaProcessor.HTMLLiteralURI ? null : contentAtt ? contentAtt.value : current.textContent;
                        } else if (contentAtt) {
                            datatype = RDFaProcessor.PlainLiteralURI;
                            content = contentAtt.value;
                        } else if (datetimeAtt) {
                            content = datetimeAtt.value;
                            datatype = RDFaProcessor.deriveDateTimeType(content);
                            if (!datatype) datatype = RDFaProcessor.PlainLiteralURI;
                        } else if (!relAtt && !revAtt) {
                            if (resourceAtt) content = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes, base);
                            if (!content && hrefAtt) content = this.resolveAndNormalize(base, encodeURI(hrefAtt.value));
                            else if (!content && srcAtt) content = this.resolveAndNormalize(base, encodeURI(srcAtt.value));
                            if (content) datatype = RDFaProcessor.objectURI;
                        }
                        if (!datatype) {
                            if (typeofAtt && !aboutAtt) {
                                datatype = RDFaProcessor.objectURI;
                                content = typedResource;
                            } else {
                                content = current.textContent;
                                if (this.inHTMLMode && current.localName === "time") datatype = RDFaProcessor.deriveDateTimeType(content);
                                if (!datatype) datatype = RDFaProcessor.PlainLiteralURI;
                            }
                        }
                        values = this.tokenize(propertyAtt.value);
                        for(var _i13 = 0; _i13 < values.length; _i13++){
                            var _predicate2 = this.parsePredicate(values[_i13], vocabulary, context.terms, prefixes, base);
                            if (_predicate2) {
                                if (inlistAtt) {
                                    var _list3 = listMapping[_predicate2];
                                    if (!_list3) {
                                        _list3 = [];
                                        listMapping[_predicate2] = _list3;
                                    }
                                    _list3.push(datatype === RDFaProcessor.XMLLiteralURI || datatype === RDFaProcessor.HTMLLiteralURI ? {
                                        type: datatype,
                                        value: current.childNodes
                                    } : {
                                        type: datatype || RDFaProcessor.PlainLiteralURI,
                                        value: content,
                                        language: language
                                    });
                                } else if (datatype === RDFaProcessor.XMLLiteralURI || datatype === RDFaProcessor.HTMLLiteralURI) this.addTriple(current, newSubject, _predicate2, {
                                    type: datatype,
                                    value: current.childNodes
                                });
                                else this.addTriple(current, newSubject, _predicate2, {
                                    type: datatype || RDFaProcessor.PlainLiteralURI,
                                    value: content,
                                    language: language
                                });
                            }
                        }
                    }
                    // Sequence Step 12: complete incomplete triples with new subject
                    if (newSubject && !skip) for(var _i14 = 0; _i14 < context.incomplete.length; _i14++){
                        if (context.incomplete[_i14].list) // console.log("Adding subject "+newSubject+" to list for "+context.incomplete[i].predicate)
                        // TODO: it is unclear what to do here
                        context.incomplete[_i14].list.push({
                            type: RDFaProcessor.objectURI,
                            value: newSubject
                        });
                        else if (context.incomplete[_i14].forward) // console.log(current.tagName+": completing forward triple "+context.incomplete[i].predicate+" with object="+newSubject)
                        this.addTriple(current, context.subject, context.incomplete[_i14].predicate, {
                            type: RDFaProcessor.objectURI,
                            value: newSubject
                        });
                        else // console.log(current.tagName+": completing reverse triple with object="+context.subject)
                        this.addTriple(current, newSubject, context.incomplete[_i14].predicate, {
                            type: RDFaProcessor.objectURI,
                            value: context.subject
                        });
                    }
                    var childContext = null;
                    var listSubject = newSubject;
                    if (skip) {
                        // TODO: should subject be null?
                        childContext = this.push(context, context.subject);
                        // TODO: should the entObject be passed along?  If not, then intermediary children will keep properties from being associated with incomplete triples.
                        // TODO: Verify: if the current baseURI has changed and the parentObject is the parent's base URI, then the baseURI should change
                        childContext.parentObject = removeHash(current.parentNode.baseURI) === context.parentObject ? removeHash(current.baseURI) : context.parentObject;
                        childContext.incomplete = context.incomplete;
                        childContext.language = language;
                        childContext.prefixes = prefixes;
                        childContext.vocabulary = vocabulary;
                    } else {
                        childContext = this.push(context, newSubject);
                        childContext.parentObject = currentObjectResource || newSubject || context.subject;
                        childContext.prefixes = prefixes;
                        childContext.incomplete = incomplete;
                        if (currentObjectResource) {
                            // console.log("Generating new list mapping for "+currentObjectResource)
                            listSubject = currentObjectResource;
                            listMapping = {};
                            listMappingDifferent = true;
                        }
                        childContext.listMapping = listMapping;
                        childContext.language = language;
                        childContext.vocabulary = vocabulary;
                    }
                    if (listMappingDifferent) // console.log("Pushing list parent "+current.localName)
                    queue.unshift({
                        parent: current,
                        context: context,
                        subject: listSubject,
                        listMapping: listMapping
                    });
                    for(var child = current.lastChild; child; child = child.previousSibling)if (child.nodeType === $fec45f84912c236b$var$Node.ELEMENT_NODE) // console.log("Pushing child "+child.localName)
                    // child.baseURI = current.baseURI
                    queue.unshift({
                        current: child,
                        context: childContext
                    });
                }
                if (this.inHTMLMode) this.copyProperties();
                for(var _i15 = 0; _i15 < this.finishedHandlers.length; _i15++)this.finishedHandlers[_i15](node);
            }
        },
        {
            key: "push",
            value: function push(parent, subject) {
                return {
                    parent: parent,
                    subject: subject || (parent ? parent.subject : null),
                    parentObject: null,
                    incomplete: [],
                    listMapping: parent ? parent.listMapping : {},
                    language: parent ? parent.language : this.language,
                    prefixes: parent ? parent.prefixes : this.target.graph.prefixes,
                    terms: parent ? parent.terms : this.target.graph.terms,
                    vocabulary: parent ? parent.vocabulary : this.vocabulary
                };
            }
        },
        {
            key: "resolveAndNormalize",
            value: function resolveAndNormalize(base, uri) {
                // console.log("Joining " + uri + " to " + base + " making " +  Uri.join(uri, base))
                return $4Q80K.join(uri, base); // @@ normalize?
            }
        },
        {
            key: "setContext",
            value: function setContext(node) {
                // We only recognized XHTML+RDFa 1.1 if the version is set propertyly
                if (node.localName === "html" && node.getAttribute("version") === "XHTML+RDFa 1.1") this.setXHTMLContext();
                else if (node.localName === "html" || node.namespaceURI === "http://www.w3.org/1999/xhtml") {
                    if (typeof document !== "undefined" && document.doctype) {
                        if (document.doctype.publicId === "-//W3C//DTD XHTML+RDFa 1.0//EN" && document.doctype.systemId === "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-1.dtd") {
                            console.log("WARNING: RDF 1.0 is not supported.  Defaulting to HTML5 mode.");
                            this.setHTMLContext();
                        } else if (document.doctype.publicId === "-//W3C//DTD XHTML+RDFa 1.1//EN" && document.doctype.systemId === "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-2.dtd") this.setXHTMLContext();
                        else this.setHTMLContext();
                    } else this.setHTMLContext();
                } else this.setXMLContext();
            }
        },
        {
            key: "setHTMLContext",
            value: function setHTMLContext() {
                this.setInitialContext();
                this.langAttributes = [
                    {
                        namespaceURI: "http://www.w3.org/XML/1998/namespace",
                        localName: "lang"
                    },
                    {
                        namespaceURI: null,
                        localName: "lang"
                    }
                ];
                this.inXHTMLMode = false;
                this.inHTMLMode = true;
            }
        },
        {
            key: "setInitialContext",
            value: function setInitialContext() {
                this.vocabulary = null;
                // By default, the prefixes are terms are loaded to the RDFa 1.1. standard within the graph constructor
                this.langAttributes = [
                    {
                        namespaceURI: "http://www.w3.org/XML/1998/namespace",
                        localName: "lang"
                    }
                ];
            }
        },
        {
            key: "setXHTMLContext",
            value: function setXHTMLContext() {
                this.setInitialContext();
                this.inXHTMLMode = true;
                this.inHTMLMode = false;
                this.langAttributes = [
                    {
                        namespaceURI: "http://www.w3.org/XML/1998/namespace",
                        localName: "lang"
                    },
                    {
                        namespaceURI: null,
                        localName: "lang"
                    }
                ];
                // From http://www.w3.org/2011/rdfa-context/xhtml-rdfa-1.1
                this.target.graph.terms["alternate"] = "http://www.w3.org/1999/xhtml/vocab#alternate";
                this.target.graph.terms["appendix"] = "http://www.w3.org/1999/xhtml/vocab#appendix";
                this.target.graph.terms["bookmark"] = "http://www.w3.org/1999/xhtml/vocab#bookmark";
                this.target.graph.terms["cite"] = "http://www.w3.org/1999/xhtml/vocab#cite";
                this.target.graph.terms["chapter"] = "http://www.w3.org/1999/xhtml/vocab#chapter";
                this.target.graph.terms["contents"] = "http://www.w3.org/1999/xhtml/vocab#contents";
                this.target.graph.terms["copyright"] = "http://www.w3.org/1999/xhtml/vocab#copyright";
                this.target.graph.terms["first"] = "http://www.w3.org/1999/xhtml/vocab#first";
                this.target.graph.terms["glossary"] = "http://www.w3.org/1999/xhtml/vocab#glossary";
                this.target.graph.terms["help"] = "http://www.w3.org/1999/xhtml/vocab#help";
                this.target.graph.terms["icon"] = "http://www.w3.org/1999/xhtml/vocab#icon";
                this.target.graph.terms["index"] = "http://www.w3.org/1999/xhtml/vocab#index";
                this.target.graph.terms["last"] = "http://www.w3.org/1999/xhtml/vocab#last";
                this.target.graph.terms["license"] = "http://www.w3.org/1999/xhtml/vocab#license";
                this.target.graph.terms["meta"] = "http://www.w3.org/1999/xhtml/vocab#meta";
                this.target.graph.terms["next"] = "http://www.w3.org/1999/xhtml/vocab#next";
                this.target.graph.terms["prev"] = "http://www.w3.org/1999/xhtml/vocab#prev";
                this.target.graph.terms["previous"] = "http://www.w3.org/1999/xhtml/vocab#previous";
                this.target.graph.terms["section"] = "http://www.w3.org/1999/xhtml/vocab#section";
                this.target.graph.terms["stylesheet"] = "http://www.w3.org/1999/xhtml/vocab#stylesheet";
                this.target.graph.terms["subsection"] = "http://www.w3.org/1999/xhtml/vocab#subsection";
                this.target.graph.terms["start"] = "http://www.w3.org/1999/xhtml/vocab#start";
                this.target.graph.terms["top"] = "http://www.w3.org/1999/xhtml/vocab#top";
                this.target.graph.terms["up"] = "http://www.w3.org/1999/xhtml/vocab#up";
                this.target.graph.terms["p3pv1"] = "http://www.w3.org/1999/xhtml/vocab#p3pv1";
                // other
                this.target.graph.terms["related"] = "http://www.w3.org/1999/xhtml/vocab#related";
                this.target.graph.terms["role"] = "http://www.w3.org/1999/xhtml/vocab#role";
                this.target.graph.terms["transformation"] = "http://www.w3.org/1999/xhtml/vocab#transformation";
            }
        },
        {
            key: "setXMLContext",
            value: function setXMLContext() {
                this.setInitialContext();
                this.inXHTMLMode = false;
                this.inHTMLMode = false;
            }
        },
        {
            key: "tokenize",
            value: function tokenize(str) {
                return this.trim(str).split(/\s+/);
            }
        },
        {
            key: "toRDFNodeObject",
            value: function toRDFNodeObject(x) {
                var _this = this;
                if (typeof x === "undefined") return undefined;
                if (typeof x === "string") {
                    if (x.substring(0, 2) === "_:") {
                        if (typeof this.blankNodes[x.substring(2)] === "undefined") this.blankNodes[x.substring(2)] = new (0, $d0a63e5194c4f691$export$2e2bcd8739ae039)(x.substring(2));
                        return this.blankNodes[x.substring(2)];
                    }
                    return (0, $158d84b4866fe33e$export$2e2bcd8739ae039).namedNode(x);
                }
                switch(x.type){
                    case RDFaProcessor.objectURI:
                        if (x.value.substring(0, 2) === "_:") {
                            if (typeof this.blankNodes[x.value.substring(2)] === "undefined") this.blankNodes[x.value.substring(2)] = new (0, $d0a63e5194c4f691$export$2e2bcd8739ae039)(x.value.substring(2));
                            return this.blankNodes[x.value.substring(2)];
                        }
                        return (0, $158d84b4866fe33e$export$2e2bcd8739ae039).namedNode(x.value);
                    case RDFaProcessor.PlainLiteralURI:
                        return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(x.value, x.language || "");
                    case RDFaProcessor.XMLLiteralURI:
                    case RDFaProcessor.HTMLLiteralURI:
                        var string = "";
                        Object.keys(x.value).forEach(function(i) {
                            string += $23fob.domToString(x.value[i], _this.htmlOptions);
                        });
                        return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(string, "", new (0, $99pVg.default)(x.type));
                    default:
                        return new (0, $68c7b1d3a79e3436$export$2e2bcd8739ae039)(x.value, "", new (0, $99pVg.default)(x.type));
                }
            }
        },
        {
            key: "trim",
            value: function trim(str) {
                return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
            }
        }
    ], [
        {
            key: "parseRDFaDOM",
            value: function parseRDFaDOM(dom, kb, base) {
                var p = new RDFaProcessor(kb, {
                    "base": base
                });
                //  Cannot assign to read only property 'baseURI' of object '#<XMLDocument>':
                if (!dom.baseURI) // Note this became a read-only attribute some time before 2018
                dom.baseURI = base; // oinly set if not already set
                p.process(dom, {
                    baseURI: base
                });
            }
        },
        {
            key: "tokenize",
            value: function tokenize(str) {
                return this.trim(str).split(/\s+/);
            }
        },
        {
            key: "trim",
            value: function trim(str) {
                return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
            }
        }
    ]);
    return RDFaProcessor;
}();
$fec45f84912c236b$export$2e2bcd8739ae039.XMLLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#XMLLiteral";
$fec45f84912c236b$export$2e2bcd8739ae039.HTMLLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML";
$fec45f84912c236b$export$2e2bcd8739ae039.PlainLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#PlainLiteral";
$fec45f84912c236b$export$2e2bcd8739ae039.objectURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#object";
$fec45f84912c236b$export$2e2bcd8739ae039.typeURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
$fec45f84912c236b$export$2e2bcd8739ae039.nameChar = "[-A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u10000-\uEFFFF.0-9\xb7\u0300-\u036F\u203F-\u2040]";
$fec45f84912c236b$export$2e2bcd8739ae039.nameStartChar = "[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u0131\u0134-\u013E\u0141-\u0148\u014A-\u017E\u0180-\u01C3\u01CD-\u01F0\u01F4-\u01F5\u01FA-\u0217\u0250-\u02A8\u02BB-\u02C1\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03CE\u03D0-\u03D6\u03DA\u03DC\u03DE\u03E0\u03E2-\u03F3\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E-\u0481\u0490-\u04C4\u04C7-\u04C8\u04CB-\u04CC\u04D0-\u04EB\u04EE-\u04F5\u04F8-\u04F9\u0531-\u0556\u0559\u0561-\u0586\u05D0-\u05EA\u05F0-\u05F2\u0621-\u063A\u0641-\u064A\u0671-\u06B7\u06BA-\u06BE\u06C0-\u06CE\u06D0-\u06D3\u06D5\u06E5-\u06E6\u0905-\u0939\u093D\u0958-\u0961\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8B\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AE0\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B36-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB5\u0BB7-\u0BB9\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CDE\u0CE0-\u0CE1\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D28\u0D2A-\u0D39\u0D60-\u0D61\u0E01-\u0E2E\u0E30\u0E32-\u0E33\u0E40-\u0E45\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EAE\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0F40-\u0F47\u0F49-\u0F69\u10A0-\u10C5\u10D0-\u10F6\u1100\u1102-\u1103\u1105-\u1107\u1109\u110B-\u110C\u110E-\u1112\u113C\u113E\u1140\u114C\u114E\u1150\u1154-\u1155\u1159\u115F-\u1161\u1163\u1165\u1167\u1169\u116D-\u116E\u1172-\u1173\u1175\u119E\u11A8\u11AB\u11AE-\u11AF\u11B7-\u11B8\u11BA\u11BC-\u11C2\u11EB\u11F0\u11F9\u1E00-\u1E9B\u1EA0-\u1EF9\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2126\u212A-\u212B\u212E\u2180-\u2182\u3041-\u3094\u30A1-\u30FA\u3105-\u312C\uAC00-\uD7A3\u4E00-\u9FA5\u3007\u3021-\u3029_]";
$fec45f84912c236b$export$2e2bcd8739ae039.NCNAME = new RegExp("^" + $fec45f84912c236b$export$2e2bcd8739ae039.nameStartChar + $fec45f84912c236b$export$2e2bcd8739ae039.nameChar + "*$");
/*
RDFaProcessor.prototype.resolveAndNormalize = function(base,href) {
   var u = base.resolve(href)
   var parsed = this.parseURI(u)
   parsed.normalize()
   return parsed.spec
}
*/ $fec45f84912c236b$export$2e2bcd8739ae039.dateTimeTypes = [
    {
        pattern: /-?P(?:[0-9]+Y)?(?:[0-9]+M)?(?:[0-9]+D)?(?:T(?:[0-9]+H)?(?:[0-9]+M)?(?:[0-9]+(?:\.[0-9]+)?S)?)?/,
        type: "http://www.w3.org/2001/XMLSchema#duration"
    },
    {
        pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]-[0-9][0-9]T(?:[0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9](?:\.[0-9]+)?(?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
        type: "http://www.w3.org/2001/XMLSchema#dateTime"
    },
    {
        pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]-[0-9][0-9](?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
        type: "http://www.w3.org/2001/XMLSchema#date"
    },
    {
        pattern: /(?:[0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9](?:\.[0-9]+)?(?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
        type: "http://www.w3.org/2001/XMLSchema#time"
    },
    {
        pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]/,
        type: "http://www.w3.org/2001/XMLSchema#gYearMonth"
    },
    {
        pattern: /-?[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9]/,
        type: "http://www.w3.org/2001/XMLSchema#gYear"
    }
];
var $fec45f84912c236b$export$912cd33c0e79bc14 = $fec45f84912c236b$export$2e2bcd8739ae039.parseRDFaDOM;



var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");

var $4Q80K = parcelRequire("4Q80K");
var $4fc73169c933142c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /*
   * @constructor
   * @param {RDFStore} store An RDFStore object
   */ function RDFParser(store) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RDFParser);
        /** Our triple store reference @private */ this.store = store; /** Our identified blank nodes @private */ 
        this.bnodes = {}; /** A context for context-aware stores @private */ 
        this.why = null; /** Reification flag */ 
        this.reify = false;
    }
    /** Standard namespaces that we know how to handle @final
   *  @member RDFParser
   */ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RDFParser, [
        {
            key: "frameFactory",
            value: /**
     * Frame class for namespace and base URI lookups
     * Base lookups will always resolve because the parser knows
     * the default base.
     *
     * @private
     */ function frameFactory(parser, parent, element) {
                return {
                    "NODE": 1,
                    "ARC": 2,
                    "parent": parent,
                    "parser": parser,
                    "store": parser.store,
                    "element": element,
                    "lastChild": 0,
                    "base": null,
                    "lang": null,
                    "node": null,
                    "nodeType": null,
                    "listIndex": 1,
                    "rdfid": null,
                    "datatype": null,
                    "collection": false,
                    /** Terminate the frame and notify the store that we're done */ "terminateFrame": function terminateFrame() {
                        if (this.collection) this.node.close();
                    },
                    /** Add a symbol of a certain type to the this frame */ "addSymbol": function addSymbol(type, uri) {
                        uri = $4Q80K.join(uri, this.base);
                        this.node = this.store.sym(uri);
                        this.nodeType = type;
                    },
                    /** Load any constructed triples into the store */ "loadTriple": function loadTriple() {
                        if (this.parent.parent.collection) this.parent.parent.node.append(this.node);
                        else this.store.add(this.parent.parent.node, this.parent.node, this.node, this.parser.why);
                        if (this.parent.rdfid != null) {
                            // reify
                            var triple = this.store.sym($4Q80K.join("#" + this.parent.rdfid, this.base));
                            this.store.add(triple, this.store.sym(RDFParser.ns.RDF + "type"), this.store.sym(RDFParser.ns.RDF + "Statement"), this.parser.why);
                            this.store.add(triple, this.store.sym(RDFParser.ns.RDF + "subject"), this.parent.parent.node, this.parser.why);
                            this.store.add(triple, this.store.sym(RDFParser.ns.RDF + "predicate"), this.parent.node, this.parser.why);
                            this.store.add(triple, this.store.sym(RDFParser.ns.RDF + "object"), this.node, this.parser.why);
                        }
                    },
                    /** Check if it's OK to load a triple */ "isTripleToLoad": function isTripleToLoad() {
                        return this.parent != null && this.parent.parent != null && this.nodeType === this.NODE && this.parent.nodeType === this.ARC && this.parent.parent.nodeType === this.NODE;
                    },
                    /** Add a symbolic node to this frame */ "addNode": function addNode(uri) {
                        this.addSymbol(this.NODE, uri);
                        if (this.isTripleToLoad()) this.loadTriple();
                    },
                    /** Add a collection node to this frame */ "addCollection": function addCollection() {
                        this.nodeType = this.NODE;
                        this.node = this.store.collection();
                        this.collection = true;
                        if (this.isTripleToLoad()) this.loadTriple();
                    },
                    /** Add a collection arc to this frame */ "addCollectionArc": function addCollectionArc() {
                        this.nodeType = this.ARC;
                    },
                    /** Add a bnode to this frame */ "addBNode": function addBNode(id) {
                        if (id != null) {
                            if (this.parser.bnodes[id] != null) this.node = this.parser.bnodes[id];
                            else this.node = this.parser.bnodes[id] = this.store.bnode();
                        } else this.node = this.store.bnode();
                        this.nodeType = this.NODE;
                        if (this.isTripleToLoad()) this.loadTriple();
                    },
                    /** Add an arc or property to this frame */ "addArc": function addArc(uri) {
                        if (uri === RDFParser.ns.RDF + "li") {
                            uri = RDFParser.ns.RDF + "_" + this.parent.listIndex;
                            this.parent.listIndex++;
                        }
                        this.addSymbol(this.ARC, uri);
                    },
                    /** Add a literal to this frame */ "addLiteral": function addLiteral(value) {
                        if (this.parent.datatype && this.parent.datatype !== RDFParser.ns.RDF + "langString") this.node = this.store.literal(value, this.store.sym(this.parent.datatype));
                        else this.node = this.store.literal(value, this.lang);
                        this.nodeType = this.NODE;
                        if (this.isTripleToLoad()) this.loadTriple();
                    }
                };
            }
        },
        {
            key: "getAttributeNodeNS",
            value: function getAttributeNodeNS(node, uri, name) {
                var attributeNode = null;
                if (node.getAttributeNodeNS) attributeNode = node.getAttributeNodeNS(uri, name);
                else {
                    var attributes = node.attributes;
                    var potentialNode, fullName;
                    for(var i = 0; i < attributes.length; ++i){
                        potentialNode = attributes[i];
                        if (potentialNode.namespaceURI === uri) {
                            fullName = potentialNode.prefix ? potentialNode.prefix + ":" + name : name;
                            if (fullName === potentialNode.nodeName) {
                                attributeNode = potentialNode;
                                break;
                            }
                        }
                    }
                }
                return attributeNode;
            }
        },
        {
            key: "parse",
            value: function parse(document, base, why) {
                var children = document.childNodes; // clean up for the next run
                this.cleanParser(); // figure out the root element
                var root;
                if (document.nodeType === RDFParser.nodeType.DOCUMENT) {
                    for(var c = 0; c < children.length; c++)if (children[c].nodeType === RDFParser.nodeType.ELEMENT) {
                        root = children[c];
                        break;
                    }
                } else if (document.nodeType === RDFParser.nodeType.ELEMENT) root = document;
                else throw new Error("RDFParser: can't find root in " + base + ". Halting. ");
                this.why = why; // our topmost frame
                var f = this.frameFactory(this);
                this.base = base;
                f.base = base;
                f.lang = null; // was '' but can't have langs like that 2015 (!)
                this.parseDOM(this.buildFrame(f, root));
                return true;
            }
        },
        {
            key: "parseDOM",
            value: function parseDOM(frame) {
                // a DOM utility function used in parsing
                var rdfid;
                var elementURI = (function(el) {
                    var result = "";
                    if (el.namespaceURI == null) throw new Error("RDF/XML syntax error: No namespace for " + el.localName + " in " + this.base);
                    if (el.namespaceURI) result = result + el.namespaceURI;
                    if (el.localName) result = result + el.localName;
                    else if (el.nodeName) {
                        if (el.nodeName.indexOf(":") >= 0) result = result + el.nodeName.split(":")[1];
                        else result = result + el.nodeName;
                    }
                    return result;
                }).bind(this);
                var dig = true; // if we'll dig down in the tree on the next iter
                while(frame.parent){
                    var dom = frame.element;
                    var attrs = dom.attributes;
                    if (dom.nodeType === RDFParser.nodeType.TEXT || dom.nodeType === RDFParser.nodeType.CDATA_SECTION) {
                        // we have a literal
                        if (frame.parent.nodeType === frame.NODE) {
                            // must have had attributes, store as rdf:value
                            frame.addArc(RDFParser.ns.RDF + "value");
                            frame = this.buildFrame(frame);
                        }
                        frame.addLiteral(dom.nodeValue);
                    } else if (elementURI(dom) !== RDFParser.ns.RDF + "RDF") {
                        // not root
                        if (frame.parent && frame.parent.collection) {
                            // we're a collection element
                            frame.addCollectionArc();
                            frame = this.buildFrame(frame, frame.element);
                            frame.parent.element = null;
                        }
                        if (!frame.parent || !frame.parent.nodeType || frame.parent.nodeType === frame.ARC) {
                            // we need a node
                            var about = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "about");
                            rdfid = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "ID");
                            if (about && rdfid) throw new Error("RDFParser: " + dom.nodeName + " has both rdf:id and rdf:about." + " Halting. Only one of these" + " properties may be specified on a" + " node.");
                            if (!about && rdfid) {
                                frame.addNode("#" + rdfid.nodeValue);
                                dom.removeAttributeNode(rdfid);
                            } else if (about == null && rdfid == null) {
                                var bnid = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "nodeID");
                                if (bnid) {
                                    frame.addBNode(bnid.nodeValue);
                                    dom.removeAttributeNode(bnid);
                                } else frame.addBNode();
                            } else {
                                frame.addNode(about.nodeValue);
                                dom.removeAttributeNode(about);
                            }
                            // Typed nodes
                            var rdftype = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "type");
                            if (RDFParser.ns.RDF + "Description" !== elementURI(dom)) rdftype = {
                                "nodeValue": elementURI(dom)
                            };
                            if (rdftype != null) {
                                this.store.add(frame.node, this.store.sym(RDFParser.ns.RDF + "type"), this.store.sym($4Q80K.join(rdftype.nodeValue, frame.base)), this.why);
                                if (rdftype.nodeName) dom.removeAttributeNode(rdftype);
                            }
                            // Property Attributes
                            for(var x = attrs.length - 1; x >= 0; x--)this.store.add(frame.node, this.store.sym(elementURI(attrs[x])), this.store.literal(attrs[x].nodeValue, frame.lang), this.why);
                        } else {
                            // we should add an arc (or implicit bnode+arc)
                            frame.addArc(elementURI(dom)); // save the arc's rdf:ID if it has one
                            if (this.reify) {
                                rdfid = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "ID");
                                if (rdfid) {
                                    frame.rdfid = rdfid.nodeValue;
                                    dom.removeAttributeNode(rdfid);
                                }
                            }
                            var parsetype = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "parseType");
                            var datatype = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "datatype");
                            if (datatype) {
                                frame.datatype = datatype.nodeValue;
                                dom.removeAttributeNode(datatype);
                            }
                            if (parsetype) {
                                var nv = parsetype.nodeValue;
                                if (nv === "Literal") {
                                    frame.datatype = RDFParser.ns.RDF + "XMLLiteral";
                                    frame = this.buildFrame(frame);
                                    // Don't include the literal node, only its children
                                    frame.addLiteral(dom.childNodes);
                                    dig = false;
                                } else if (nv === "Resource") {
                                    frame = this.buildFrame(frame, frame.element);
                                    frame.parent.element = null;
                                    frame.addBNode();
                                } else if (nv === "Collection") {
                                    frame = this.buildFrame(frame, frame.element);
                                    frame.parent.element = null;
                                    frame.addCollection();
                                }
                                dom.removeAttributeNode(parsetype);
                            }
                            if (attrs.length !== 0) {
                                var resource = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "resource");
                                var bnid2 = this.getAttributeNodeNS(dom, RDFParser.ns.RDF, "nodeID");
                                frame = this.buildFrame(frame);
                                if (resource) {
                                    frame.addNode(resource.nodeValue);
                                    dom.removeAttributeNode(resource);
                                } else if (bnid2) {
                                    frame.addBNode(bnid2.nodeValue);
                                    dom.removeAttributeNode(bnid2);
                                } else frame.addBNode();
                                for(var x1 = attrs.length - 1; x1 >= 0; x1--){
                                    var f = this.buildFrame(frame);
                                    f.addArc(elementURI(attrs[x1]));
                                    if (elementURI(attrs[x1]) === RDFParser.ns.RDF + "type") this.buildFrame(f).addNode(attrs[x1].nodeValue);
                                    else this.buildFrame(f).addLiteral(attrs[x1].nodeValue);
                                }
                            } else if (dom.childNodes.length === 0) this.buildFrame(frame).addLiteral("");
                        }
                    } // rdf:RDF
                    // dig dug
                    dom = frame.element;
                    while(frame.parent){
                        var pframe = frame;
                        while(dom == null){
                            frame = frame.parent;
                            dom = frame.element;
                        }
                        var candidate = dom.childNodes && dom.childNodes[frame.lastChild];
                        if (!candidate || !dig) {
                            frame.terminateFrame();
                            if (!(frame = frame.parent)) break;
                             // done
                            dom = frame.element;
                            dig = true;
                        } else if (candidate.nodeType !== RDFParser.nodeType.ELEMENT && candidate.nodeType !== RDFParser.nodeType.TEXT && candidate.nodeType !== RDFParser.nodeType.CDATA_SECTION || (candidate.nodeType === RDFParser.nodeType.TEXT || candidate.nodeType === RDFParser.nodeType.CDATA_SECTION) && dom.childNodes.length !== 1) frame.lastChild++;
                        else {
                            // not a leaf
                            frame.lastChild++;
                            frame = this.buildFrame(pframe, dom.childNodes[frame.lastChild - 1]);
                            break;
                        }
                    }
                } // while
            }
        },
        {
            key: "cleanParser",
            value: function cleanParser() {
                this.bnodes = {};
                this.why = null;
            }
        },
        {
            key: "buildFrame",
            value: function buildFrame(parent, element) {
                var frame = this.frameFactory(this, parent, element);
                if (parent) {
                    frame.base = parent.base;
                    frame.lang = parent.lang;
                }
                if (!element || element.nodeType === RDFParser.nodeType.TEXT || element.nodeType === RDFParser.nodeType.CDATA_SECTION) return frame;
                var attrs = element.attributes;
                var base = element.getAttributeNode("xml:base");
                if (base != null) {
                    frame.base = base.nodeValue;
                    element.removeAttribute("xml:base");
                }
                var lang = element.getAttributeNode("xml:lang");
                if (lang != null) {
                    frame.lang = lang.nodeValue;
                    element.removeAttribute("xml:lang");
                }
                // remove all extraneous xml and xmlns attributes
                for(var x = attrs.length - 1; x >= 0; x--)if (attrs[x].nodeName.substr(0, 3) === "xml") {
                    if (attrs[x].name.slice(0, 6) === "xmlns:") {
                        var uri = attrs[x].nodeValue; // alert('base for namespac attr:'+this.base)
                        if (this.base) uri = $4Q80K.join(uri, this.base);
                        this.store.setPrefixForURI(attrs[x].name.slice(6), uri);
                    }
                    //		alert('rdfparser: xml atribute: '+attrs[x].name) //@@
                    element.removeAttributeNode(attrs[x]);
                }
                return frame;
            }
        }
    ]);
    return RDFParser;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4fc73169c933142c$export$2e2bcd8739ae039, "ns", {
    "RDF": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "RDFS": "http://www.w3.org/2000/01/rdf-schema#"
});
/** DOM Level 2 node type magic numbers @final
 *  @member RDFParser
 */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($4fc73169c933142c$export$2e2bcd8739ae039, "nodeType", {
    "ELEMENT": 1,
    "ATTRIBUTE": 2,
    "TEXT": 3,
    "CDATA_SECTION": 4,
    "ENTITY_REFERENCE": 5,
    "ENTITY": 6,
    "PROCESSING_INSTRUCTION": 7,
    "COMMENT": 8,
    "DOCUMENT": 9,
    "DOCUMENT_TYPE": 10,
    "DOCUMENT_FRAGMENT": 11,
    "NOTATION": 12
});


// Parse a simple SPARL-Update subset syntax for patches.
//
//  This parses
//   WHERE {xxx} DELETE {yyy} INSERT DATA {zzz}
// (not necessarily in that order)
// as though it were the n3
//   <#query> patch:where {xxx}; patch:delete {yyy}; patch:insert {zzz}.


function $f5662a1810b2d5d2$export$2e2bcd8739ae039(str, kb, base) {
    var i, j, k;
    var keywords = [
        "INSERT",
        "DELETE",
        "WHERE"
    ];
    var SQNS = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/ns/pim/patch#");
    var p = (0, $220f89846e1c7272$export$2e2bcd8739ae039)(kb, kb, base, base, null, null, "", null);
    var clauses = {};
    var badSyntax = function badSyntax(uri, lines, str, i, why) {
        return "Line " + (lines + 1) + " of <" + uri + ">: Bad syntax:\n   " + why + '\n   at: "' + str.slice(i, i + 30) + '"';
    };
    // var check = function (next, last, message) {
    //   if (next < 0) {
    //     throw badSyntax(p._thisDoc, p.lines, str, j, last, message)
    //   }
    //   return next
    // }
    i = 0;
    var query = kb.sym(base + "#query"); // Invent a URI for the query
    clauses["query"] = query; // A way of accessing it in its N3 model.
    while(true){
        // console.log("A Now at i = " + i)
        j = p.skipSpace(str, i);
        if (j < 0) return clauses;
        // console.log("B After space at j= " + j)
        if (str[j] === ";") {
            i = p.skipSpace(str, j + 1);
            if (i < 0) return clauses; // Allow end in a
            j = i;
        }
        var found = false;
        for(k = 0; k < keywords.length; k++){
            var key = keywords[k];
            if (str.slice(j, j + key.length) === key) {
                i = p.skipSpace(str, j + key.length);
                if (i < 0) throw badSyntax(p._thisDoc, p.lines, str, j + key.length, "found EOF, needed {...} after " + key);
                if ((key === "INSERT" || key === "DELETE") && str.slice(i, i + 4) === "DATA") {
                    // Some wanted 'DATA'. Whatever
                    j = p.skipSpace(str, i + 4);
                    if (j < 0) throw badSyntax(p._thisDoc, p.lines, str, i + 4, "needed {...} after INSERT DATA " + key);
                    i = j;
                }
                var res2 = [];
                j = p.node(str, i, res2); // Parse all the complexity of the clause
                if (j < 0) throw badSyntax(p._thisDoc, p.lines, str, i, "bad syntax or EOF in {...} after " + key);
                clauses[key.toLowerCase()] = res2[0];
                kb.add(query, SQNS(key.toLowerCase()), res2[0]); // , kb.sym(base)
                // key is the keyword and res2 has the contents
                found = true;
                i = j;
            }
        }
        if (!found && str.slice(j, j + 7) === "@prefix") {
            i = p.directive(str, j);
            if (i < 0) throw badSyntax(p._thisDoc, p.lines, str, i, "bad syntax or EOF after @prefix ");
            // console.log("P before dot i= " + i)
            i = p.checkDot(str, i);
            // console.log("Q after dot i= " + i)
            found = true;
        }
        if (!found) // console.log("Bad syntax " + j)
        throw badSyntax(p._thisDoc, p.lines, str, j, "Unknown syntax at start of statememt: '" + str.slice(j).slice(0, 20) + "'");
    } // while
// return clauses
}



var $23fob = parcelRequire("23fob");

var $8RKL2 = parcelRequire("8RKL2");
function $3e841386a4d5e0bd$export$2e2bcd8739ae039(str, kb, base) {
    var contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "text/turtle";
    var callback = arguments.length > 4 ? arguments[4] : undefined;
    contentType = contentType || (0, $8RKL2.TurtleContentType);
    contentType = contentType.split(";")[0];
    try {
        if (contentType === (0, $8RKL2.N3ContentType) || contentType === (0, $8RKL2.TurtleContentType)) {
            var p = (0, $220f89846e1c7272$export$2e2bcd8739ae039)(kb, kb, base, base, null, null, "", null);
            p.loadBuf(str);
            executeCallback();
        } else if (contentType === (0, $8RKL2.RDFXMLContentType)) {
            var parser = new (0, $4fc73169c933142c$export$2e2bcd8739ae039)(kb);
            parser.parse($23fob.parseXML(str), base, kb.sym(base));
            executeCallback();
        } else if (contentType === (0, $8RKL2.XHTMLContentType)) {
            (0, $fec45f84912c236b$export$912cd33c0e79bc14)($23fob.parseXML(str, {
                contentType: (0, $8RKL2.XHTMLContentType)
            }), kb, base);
            executeCallback();
        } else if (contentType === (0, $8RKL2.HTMLContentType)) {
            (0, $fec45f84912c236b$export$912cd33c0e79bc14)($23fob.parseXML(str, {
                contentType: (0, $8RKL2.HTMLContentType)
            }), kb, base);
            executeCallback();
        } else if (contentType === (0, $8RKL2.SPARQLUpdateContentType) || contentType === (0, $8RKL2.SPARQLUpdateSingleMatchContentType)) {
            // @@ we handle a subset
            (0, $f5662a1810b2d5d2$export$2e2bcd8739ae039)(str, kb, base);
            executeCallback();
        } else if (contentType === (0, $8RKL2.JSONLDContentType)) (0, $93c26633f06ced7c$export$2e2bcd8739ae039)(str, kb, base, executeCallback);
        else if (contentType === (0, $8RKL2.NQuadsContentType) || contentType === (0, $8RKL2.NQuadsAltContentType)) {
            var n3Parser = new (0, $c0715e6442e25456$export$2e2bcd8739ae039)({
                factory: (0, $2b3711697846728e$export$2e2bcd8739ae039)
            });
            nquadCallback(null, str);
        } else if (contentType === undefined) throw new Error("contentType is undefined");
        else throw new Error("Don't know how to parse " + contentType + " yet");
    } catch (e) {
        // @ts-ignore
        executeErrorCallback(e);
    }
    $3e841386a4d5e0bd$export$2e2bcd8739ae039.handled = {
        "text/n3": true,
        "text/turtle": true,
        "application/rdf+xml": true,
        "application/xhtml+xml": true,
        "text/html": true,
        "application/sparql-update": true,
        "application/sparql-update-single-match": true,
        "application/ld+json": true,
        "application/nquads": true,
        "application/n-quads": true
    };
    function executeCallback() {
        if (callback) callback(null, kb);
        else return;
    }
    function executeErrorCallback(e) {
        if (// TODO: Always true, what is the right behavior
        contentType !== (0, $8RKL2.JSONLDContentType) || // @ts-ignore always true?
        contentType !== (0, $8RKL2.NQuadsContentType) || // @ts-ignore always true?
        contentType !== (0, $8RKL2.NQuadsAltContentType)) {
            if (callback) callback(e, kb);
            else {
                var e2 = new Error("" + e + " while trying to parse <" + base + "> as " + contentType);
                //@ts-ignore .cause is not a default error property
                e2.cause = e;
                throw e2;
            }
        }
    }
    /*
    function setJsonLdBase (doc, base) {
      if (doc instanceof Array) {
        return
      }
      if (!('@context' in doc)) {
        doc['@context'] = {}
      }
      doc['@context']['@base'] = base
    }
  */ function nquadCallback(err, nquads) {
        if (err) callback(err, kb);
        try {
            n3Parser.parse(nquads, tripleCallback);
        } catch (err) {
            callback(err, kb);
        }
    }
    function tripleCallback(err, triple) {
        if (triple) kb.add(triple.subject, triple.predicate, triple.object, triple.graph);
        else callback(err, kb);
    }
}





var $4Q80K = parcelRequire("4Q80K");

var $gCJkd = parcelRequire("gCJkd");

var $23fob = parcelRequire("23fob");


var $R5nvG = parcelRequire("R5nvG");

var $8RKL2 = parcelRequire("8RKL2");

var $avzMW = parcelRequire("avzMW");

function $1d9128915acc42fc$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $1d9128915acc42fc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $1d9128915acc42fc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1d9128915acc42fc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1d9128915acc42fc$var$_arrayLikeToArray(o, minLen);
}
function $1d9128915acc42fc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1d9128915acc42fc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1d9128915acc42fc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $1d9128915acc42fc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $1d9128915acc42fc$var$Parsable = {
    "text/n3": true,
    "text/turtle": true,
    "application/rdf+xml": true,
    "application/xhtml+xml": true,
    "text/html": true,
    "application/ld+json": true
};
// This is a minimal set to allow the use of damaged servers if necessary
var $1d9128915acc42fc$var$CONTENT_TYPE_BY_EXT = {
    "rdf": (0, $8RKL2.RDFXMLContentType),
    "owl": (0, $8RKL2.RDFXMLContentType),
    "n3": "text/n3",
    "ttl": "text/turtle",
    "nt": "text/n3",
    "acl": "text/n3",
    "html": "text/html",
    "xml": "text/xml"
};
// Convenience namespaces needed in this module.
// These are deliberately not exported as the user application should
// make its own list and not rely on the prefixes used here,
// and not be tempted to add to them, and them clash with those of another
// application.
var $1d9128915acc42fc$var$getNS = function getNS(factory) {
    return {
        link: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/link#", factory),
        http: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/http#", factory),
        httph: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/httph#", factory),
        // headers
        rdf: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/1999/02/22-rdf-syntax-ns#", factory),
        rdfs: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2000/01/rdf-schema#", factory),
        dc: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://purl.org/dc/elements/1.1/", factory),
        ldp: (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/ns/ldp#", factory)
    };
};
var $1d9128915acc42fc$var$ns = $1d9128915acc42fc$var$getNS();
/** An extended interface of Response, since RDFlib.js adds some properties. */ /** tell typescript that a 'panes' child may exist on Window */ /** All valid inputs for initFetchOptions */ /** Initiated by initFetchOptions, which runs on load */ var $1d9128915acc42fc$var$Handler = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(function Handler(response, dom) {
    (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Handler);
    // TODO: Document, type
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "response", void 0);
    // TODO: Document, type
    (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "dom", void 0);
    this.response = response;
    // The type assertion operator here might need to be removed.
    this.dom = dom;
});
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1d9128915acc42fc$var$Handler, "pattern", void 0);
var $1d9128915acc42fc$var$RDFXMLHandler = /*#__PURE__*/ function(_Handler) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(RDFXMLHandler, _Handler);
    var _super = $1d9128915acc42fc$var$_createSuper(RDFXMLHandler);
    function RDFXMLHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RDFXMLHandler);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RDFXMLHandler, [
        {
            key: "parse",
            value: function parse(fetcher, /** An XML String */ responseText, /** Requires .original */ options) {
                var kb = fetcher.store;
                if (!this.dom) this.dom = $23fob.parseXML(responseText);
                var root = this.dom.documentElement;
                if (root.nodeName === "parsererror") // Mozilla only See issue/issue110
                // have to fail the request
                return fetcher.failFetch(options, "Badly formed XML in " + options.resource.value, "parse_error");
                var parser = new (0, $4fc73169c933142c$export$2e2bcd8739ae039)(kb);
                try {
                    parser.parse(this.dom, options.original.value, options.original);
                } catch (err) {
                    return fetcher.failFetch(options, "Syntax error parsing RDF/XML! " + err, "parse_error");
                }
                if (!options.noMeta) kb.add(options.original, $1d9128915acc42fc$var$ns.rdf("type"), $1d9128915acc42fc$var$ns.link("RDFDocument"), fetcher.appNode);
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "RDFXMLHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes[0, $8RKL2.RDFXMLContentType] = {
                    "q": 0.9
                };
            }
        }
    ]);
    return RDFXMLHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$RDFXMLHandler.pattern = new RegExp("application/rdf\\+xml");
var $1d9128915acc42fc$var$XHTMLHandler = /*#__PURE__*/ function(_Handler2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(XHTMLHandler, _Handler2);
    var _super2 = $1d9128915acc42fc$var$_createSuper(XHTMLHandler);
    function XHTMLHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, XHTMLHandler);
        return _super2.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(XHTMLHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options) {
                var relation, reverse;
                if (!this.dom) this.dom = $23fob.parseXML(responseText);
                var kb = fetcher.store;
                // dc:title
                var title = this.dom.getElementsByTagName("title");
                if (title.length > 0) kb.add(options.resource, $1d9128915acc42fc$var$ns.dc("title"), kb.rdfFactory.literal(title[0].textContent), options.resource);
                // link rel
                var links = this.dom.getElementsByTagName("link");
                for(var x = links.length - 1; x >= 0; x--){
                    // @@ rev
                    relation = links[x].getAttribute("rel");
                    reverse = false;
                    if (!relation) {
                        relation = links[x].getAttribute("rev");
                        reverse = true;
                    }
                    if (relation) fetcher.linkData(options.original, relation, links[x].getAttribute("href"), options.resource, reverse);
                }
                // Data Islands
                var scripts = this.dom.getElementsByTagName("script");
                for(var i = 0; i < scripts.length; i++){
                    var contentType = scripts[i].getAttribute("type");
                    if ($1d9128915acc42fc$var$Parsable[contentType]) {
                        // @ts-ignore incompatibility between Store.add and Formula.add
                        (0, $3e841386a4d5e0bd$export$2e2bcd8739ae039)(scripts[i].textContent, kb, options.original.value, contentType);
                        // @ts-ignore incompatibility between Store.add and Formula.add
                        (0, $3e841386a4d5e0bd$export$2e2bcd8739ae039)(scripts[i].textContent, kb, options.original.value, contentType);
                    }
                }
                if (!options.noMeta) kb.add(options.resource, $1d9128915acc42fc$var$ns.rdf("type"), $1d9128915acc42fc$var$ns.link("WebPage"), fetcher.appNode);
                if (!options.noRDFa && (0, $fec45f84912c236b$export$912cd33c0e79bc14)) // enable by default
                try {
                    (0, $fec45f84912c236b$export$912cd33c0e79bc14)(this.dom, kb, options.original.value);
                } catch (err) {
                    // @ts-ignore
                    var msg = "Error trying to parse " + options.resource + " as RDFa:\n" + err + ":\n" + err.stack;
                    return fetcher.failFetch(options, msg, "parse_error");
                }
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "XHTMLHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes[0, $8RKL2.XHTMLContentType] = {};
            }
        }
    ]);
    return XHTMLHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$XHTMLHandler.pattern = new RegExp("application/xhtml");
var $1d9128915acc42fc$var$XMLHandler = /*#__PURE__*/ function(_Handler3) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(XMLHandler, _Handler3);
    var _super3 = $1d9128915acc42fc$var$_createSuper(XMLHandler);
    function XMLHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, XMLHandler);
        return _super3.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(XMLHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options) {
                var dom = $23fob.parseXML(responseText);
                // XML Semantics defined by root element namespace
                // figure out the root element
                for(var c = 0; c < dom.childNodes.length; c++){
                    var node = dom.childNodes[c];
                    // is this node an element?
                    if (XMLHandler.isElement(node)) {
                        // We've found the first element, it's the root
                        var _ns = node.namespaceURI;
                        // Is it RDF/XML?
                        if (_ns && _ns === _ns["rdf"]) {
                            fetcher.addStatus(options.req, "Has XML root element in the RDF namespace, so assume RDF/XML.");
                            var rdfHandler = new $1d9128915acc42fc$var$RDFXMLHandler(this.response, dom);
                            return rdfHandler.parse(fetcher, responseText, options);
                        }
                        break;
                    }
                }
                // Or it could be XHTML?
                // Maybe it has an XHTML DOCTYPE?
                if (dom.doctype) // log.info("We found a DOCTYPE in " + xhr.resource)
                {
                    if (dom.doctype.name === "html" && dom.doctype.publicId.match(/^-\/\/W3C\/\/DTD XHTML/) && dom.doctype.systemId.match(/http:\/\/www.w3.org\/TR\/xhtml/)) {
                        fetcher.addStatus(options.req, "Has XHTML DOCTYPE. Switching to XHTML Handler.\n");
                        var xhtmlHandler = new $1d9128915acc42fc$var$XHTMLHandler(this.response, dom);
                        return xhtmlHandler.parse(fetcher, responseText, options);
                    }
                }
                // Or what about an XHTML namespace?
                var html = dom.getElementsByTagName("html")[0];
                if (html) {
                    var xmlns = html.getAttribute("xmlns");
                    if (xmlns && xmlns.match(/^http:\/\/www.w3.org\/1999\/xhtml/)) {
                        fetcher.addStatus(options.req, "Has a default namespace for XHTML. Switching to XHTMLHandler.\n");
                        var _xhtmlHandler = new $1d9128915acc42fc$var$XHTMLHandler(this.response, dom);
                        return _xhtmlHandler.parse(fetcher, responseText, options);
                    }
                }
                // At this point we should check the namespace document (cache it!) and
                // look for a GRDDL transform
                // @@  Get namespace document <n>, parse it, look for  <n> grddl:namespaceTransform ?y
                // Apply ?y to   dom
                // We give up. What dialect is this?
                return fetcher.failFetch(options, "Unsupported dialect of XML: not RDF or XHTML namespace, etc.\n" + responseText.slice(0, 80), 901);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "XMLHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["text/xml"] = {
                    "q": 0.5
                };
                fetcher.mediatypes["application/xml"] = {
                    "q": 0.5
                };
            }
        },
        {
            key: "isElement",
            value: function isElement(node) {
                return node.nodeType === Node.ELEMENT_NODE;
            }
        }
    ]);
    return XMLHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$XMLHandler.pattern = new RegExp("(text|application)/(.*)xml");
var $1d9128915acc42fc$var$HTMLHandler = /*#__PURE__*/ function(_Handler4) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(HTMLHandler, _Handler4);
    var _super4 = $1d9128915acc42fc$var$_createSuper(HTMLHandler);
    function HTMLHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, HTMLHandler);
        return _super4.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(HTMLHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options) {
                var kb = fetcher.store;
                // We only handle XHTML so we have to figure out if this is XML
                // log.info("Sniffing HTML " + xhr.resource + " for XHTML.")
                if ($1d9128915acc42fc$var$isXML(responseText)) {
                    fetcher.addStatus(options.req, "Has an XML declaration. We'll assume it's XHTML as the content-type was text/html.\n");
                    var xhtmlHandler = new $1d9128915acc42fc$var$XHTMLHandler(this.response);
                    return xhtmlHandler.parse(fetcher, responseText, options);
                }
                // DOCTYPE html
                if ($1d9128915acc42fc$var$isXHTML(responseText)) {
                    fetcher.addStatus(options.req, "Has XHTML DOCTYPE. Switching to XHTMLHandler.\n");
                    var _xhtmlHandler2 = new $1d9128915acc42fc$var$XHTMLHandler(this.response);
                    return _xhtmlHandler2.parse(fetcher, responseText, options);
                }
                // xmlns
                if ($1d9128915acc42fc$var$isXMLNS(responseText)) {
                    fetcher.addStatus(options.req, "Has default namespace for XHTML, so switching to XHTMLHandler.\n");
                    var _xhtmlHandler3 = new $1d9128915acc42fc$var$XHTMLHandler(this.response);
                    return _xhtmlHandler3.parse(fetcher, responseText, options);
                }
                // dc:title
                // no need to escape '/' here
                var titleMatch = new RegExp("<title>([\\s\\S]+?)</title>", "im").exec(responseText);
                if (titleMatch) kb.add(options.resource, $1d9128915acc42fc$var$ns.dc("title"), kb.rdfFactory.literal(titleMatch[1]), options.resource); // think about xml:lang later
                kb.add(options.resource, $1d9128915acc42fc$var$ns.rdf("type"), $1d9128915acc42fc$var$ns.link("WebPage"), fetcher.appNode);
                fetcher.addStatus(options.req, "non-XML HTML document, not parsed for data.");
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "HTMLHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["text/html"] = {
                    "q": 0.9
                };
            }
        }
    ]);
    return HTMLHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$HTMLHandler.pattern = new RegExp("text/html");
var $1d9128915acc42fc$var$JsonLdHandler = /*#__PURE__*/ function(_Handler5) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(JsonLdHandler, _Handler5);
    var _super5 = $1d9128915acc42fc$var$_createSuper(JsonLdHandler);
    function JsonLdHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, JsonLdHandler);
        return _super5.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(JsonLdHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options, response) {
                var kb = fetcher.store;
                return new Promise(function(resolve, reject) {
                    try {
                        (0, $93c26633f06ced7c$export$2e2bcd8739ae039)(responseText, kb, options.original.value, function() {
                            resolve(fetcher.doneFetch(options, response));
                        });
                    } catch (err) {
                        var msg = "Error trying to parse " + options.resource + " as JSON-LD:\n" + err; // not err.stack -- irrelevant
                        resolve(fetcher.failFetch(options, msg, "parse_error", response));
                    }
                });
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "JsonLdHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["application/ld+json"] = {
                    "q": 0.9
                };
            }
        }
    ]);
    return JsonLdHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$JsonLdHandler.pattern = /application\/ld\+json/;
var $1d9128915acc42fc$var$TextHandler = /*#__PURE__*/ function(_Handler6) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(TextHandler, _Handler6);
    var _super6 = $1d9128915acc42fc$var$_createSuper(TextHandler);
    function TextHandler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, TextHandler);
        return _super6.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(TextHandler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options) {
                // We only speak dialects of XML right now. Is this XML?
                // Look for an XML declaration
                if ($1d9128915acc42fc$var$isXML(responseText)) {
                    fetcher.addStatus(options.req, "Warning: " + options.resource + " has an XML declaration. We'll assume " + "it's XML but its content-type wasn't XML.\n");
                    var xmlHandler = new $1d9128915acc42fc$var$XMLHandler(this.response);
                    return xmlHandler.parse(fetcher, responseText, options);
                }
                // Look for an XML declaration
                if (responseText.slice(0, 500).match(/xmlns:/)) {
                    fetcher.addStatus(options.req, "May have an XML namespace. We'll assume it's XML but its content-type wasn't XML.\n");
                    var _xmlHandler = new $1d9128915acc42fc$var$XMLHandler(this.response);
                    return _xmlHandler.parse(fetcher, responseText, options);
                }
                // We give up finding semantics - this is not an error, just no data
                fetcher.addStatus(options.req, "Plain text document, no known RDF semantics.");
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "TextHandler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["text/plain"] = {
                    "q": 0.5
                };
            }
        }
    ]);
    return TextHandler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$TextHandler.pattern = new RegExp("text/plain");
var $1d9128915acc42fc$var$N3Handler = /*#__PURE__*/ function(_Handler7) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(N3Handler, _Handler7);
    var _super7 = $1d9128915acc42fc$var$_createSuper(N3Handler);
    function N3Handler() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, N3Handler);
        return _super7.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(N3Handler, [
        {
            key: "parse",
            value: function parse(fetcher, responseText, options, response) {
                // Parse the text of this N3 file
                var kb = fetcher.store;
                var p = (0, $220f89846e1c7272$export$2e2bcd8739ae039)(kb, kb, options.original.value, options.original.value, null, null, "", null);
                //                p.loadBuf(xhr.responseText)
                try {
                    p.loadBuf(responseText);
                } catch (err) {
                    var msg = "Error trying to parse " + options.resource + " as Notation3:\n" + err; // not err.stack -- irrelevant
                    return fetcher.failFetch(options, msg, "parse_error", response);
                }
                fetcher.addStatus(options.req, "N3 parsed: " + p.statementCount + " triples in " + p.lines + " lines.");
                fetcher.store.add(options.original, $1d9128915acc42fc$var$ns.rdf("type"), $1d9128915acc42fc$var$ns.link("RDFDocument"), fetcher.appNode);
                return fetcher.doneFetch(options, this.response);
            }
        }
    ], [
        {
            key: "toString",
            value: function toString() {
                return "N3Handler";
            }
        },
        {
            key: "register",
            value: function register(fetcher) {
                fetcher.mediatypes["text/n3"] = {
                    "q": "1.0"
                }; // as per 2008 spec
                /*
       fetcher.mediatypes['application/x-turtle'] = {
       'q': 1.0
       } // pre 2008
       */ fetcher.mediatypes["text/turtle"] = {
                    "q": 1.0
                }; // post 2008
            }
        }
    ]);
    return N3Handler;
}($1d9128915acc42fc$var$Handler);
$1d9128915acc42fc$var$N3Handler.pattern = new RegExp("(application|text)/(x-)?(rdf\\+)?(n3|turtle)");
var $1d9128915acc42fc$var$defaultHandlers = {
    RDFXMLHandler: $1d9128915acc42fc$var$RDFXMLHandler,
    XHTMLHandler: $1d9128915acc42fc$var$XHTMLHandler,
    XMLHandler: $1d9128915acc42fc$var$XMLHandler,
    HTMLHandler: $1d9128915acc42fc$var$HTMLHandler,
    TextHandler: $1d9128915acc42fc$var$TextHandler,
    N3Handler: $1d9128915acc42fc$var$N3Handler,
    JsonLdHandler: $1d9128915acc42fc$var$JsonLdHandler
};
function $1d9128915acc42fc$var$isXHTML(responseText) {
    var docTypeStart = responseText.indexOf("<!DOCTYPE html");
    var docTypeEnd = responseText.indexOf(">");
    if (docTypeStart === -1 || docTypeEnd === -1 || docTypeStart > docTypeEnd) return false;
    return responseText.substr(docTypeStart, docTypeEnd - docTypeStart).indexOf("XHTML") !== -1;
}
function $1d9128915acc42fc$var$isXML(responseText) {
    var match = responseText.match(/\s*<\?xml\s+version\s*=[^<>]+\?>/);
    return !!match;
}
function $1d9128915acc42fc$var$isXMLNS(responseText) {
    var match = responseText.match(/[^(<html)]*<html\s+[^<]*xmlns=['"]http:\/\/www.w3.org\/1999\/xhtml["'][^<]*>/);
    return !!match;
}
// Not sure about the shapes of this. Response? FetchError?
/** Differs from normal Fetch, has an extended Response type */ /** Fetcher
 *
 * The Fetcher object is a helper object for a quadstore
 * which turns it from an offline store to an online store.
 * The fetcher deals with loading data files rom the web,
  * figuring how to parse them.  It will also refresh, remove, the data
  * and put back the data to the web.
 */ var $1d9128915acc42fc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher(store) {
        var _this = this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fetcher);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "store", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "timeout", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "_fetch", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "mediatypes", void 0);
        /** Denoting this session */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "appNode", void 0);
        /**
     * this.requested[uri] states:
     * undefined     no record of web access or records reset
     * true          has been requested, fetch in progress
     * 'done'        received, Ok
     * 401           Not logged in
     * 403           HTTP status unauthorized
     * 404           Resource does not exist. Can be created etc.
     * 'redirected'  In attempt to counter CORS problems retried.
     * 'parse_error' Parse error
     * 'unsupported_protocol'  URI is not a protocol Fetcher can deal with
     * other strings mean various other errors.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "requested", void 0);
        /** List of timeouts associated with a requested URL */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "timeouts", void 0);
        /** Redirected from *key uri* to *value uri* */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "redirectedTo", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "fetchQueue", void 0);
        /** fetchCallbacks[uri].push(callback) */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "fetchCallbacks", void 0);
        /** Keep track of explicit 404s -> we can overwrite etc */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "nonexistent", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "lookedUp", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "handlers", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "ns", void 0);
        /** Methods added by calling Util.callbackify in the constructor*/ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "fireCallbacks", void 0);
        this.store = store || new (0, $6f5c135260474402$export$2e2bcd8739ae039)();
        this.ns = $1d9128915acc42fc$var$getNS(this.store.rdfFactory);
        this.timeout = options.timeout || 30000;
        // solidFetcher is deprecated
        this._fetch = options.fetch || typeof $parcel$global !== "undefined" && ($parcel$global.solidFetcher || $parcel$global.solidFetch) || typeof window !== "undefined" && (window.solidFetcher || window.solidFetch) || (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)));
        if (!this._fetch) throw new Error("No _fetch function available for Fetcher");
        // This is the name of the graph we store all the HTTP metadata in
        this.appNode = this.store.sym("chrome://TheCurrentSession");
        // this.appNode = this.store.rdfFactory.blankNode() // Needs to have a URI in tests
        this.store.fetcher = this; // Bi-linked
        this.requested = {};
        this.timeouts = {};
        this.redirectedTo = {};
        this.fetchQueue = {};
        this.fetchCallbacks = {};
        this.nonexistent = {};
        this.lookedUp = {};
        this.handlers = [];
        this.mediatypes = {
            "image/*": {
                "q": 0.9
            },
            "*/*": {
                "q": 0.1
            } // Must allow access to random content
        };
        // Util.callbackify(this, ['request', 'recv', 'headers', 'load', 'fail',
        //   'refresh', 'retract', 'done'])
        // In switching to fetch(), 'recv', 'headers' and 'load' do not make sense
        $23fob.callbackify(this, [
            "request",
            "fail",
            "refresh",
            "retract",
            "done"
        ]);
        Object.keys(options.handlers || $1d9128915acc42fc$var$defaultHandlers).map(function(key) {
            return _this.addHandler($1d9128915acc42fc$var$defaultHandlers[key]);
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fetcher, [
        {
            key: "load",
            value: /**
     * Promise-based load function
     *
     * Loads a web resource or resources into the store.
     *
     * A resource may be given as NamedNode object, or as a plain URI.
     * an array of resources will be given, in which they will be fetched in parallel.
     * By default, the HTTP headers are recorded also, in the same store, in a separate graph.
     * This allows code like editable() for example to test things about the resource.
     *
     * @param uri {Array<RDFlibNamedNode>|Array<string>|RDFlibNamedNode|string}
     *
     * @param [options={}] {Object}
     *
     * @param [options.fetch] {Function}
     *
     * @param [options.referringTerm] {RDFlibNamedNode} Referring term, the resource which
     *   referred to this (for tracking bad links)
     *
     * @param [options.contentType] {string} Provided content type (for writes)
     *
     * @param [options.forceContentType] {string} Override the incoming header to
     *   force the data to be treated as this content-type (for reads)
     *
     * @param [options.force] {boolean} Load the data even if loaded before.
     *   Also sets the `Cache-Control:` header to `no-cache`
     *
     * @param [options.baseURI=docuri] {Node|string} Original uri to preserve
     *   through proxying etc (`xhr.original`).
     *
     * @param [options.proxyUsed] {boolean} Whether this request is a retry via
     *   a proxy (generally done from an error handler)
     *
     * @param [options.withCredentials] {boolean} flag for XHR/CORS etc
     *
     * @param [options.clearPreviousData] {boolean} Before we parse new data,
     *   clear old, but only on status 200 responses
     *
     * @param [options.noMeta] {boolean} Prevents the addition of various metadata
     *   triples (about the fetch request) to the store
     *
     * @param [options.noRDFa] {boolean}
     *
     * @returns {Promise<Result>}
     */ function load(uri) {
                var _this2 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                options = Object.assign({}, options); // Take a copy as we add stuff to the options!!
                if (uri instanceof Array) return Promise.all(uri.map(function(x) {
                    return _this2.load(x, Object.assign({}, options));
                }));
                var uriIn = uri;
                var docuri = (0, $avzMW.termValue)(uriIn);
                docuri = docuri.split("#")[0];
                options = this.initFetchOptions(docuri, options);
                // if metadata flaged clear cache and removeDocument
                var meta = this.appNode;
                var kb = this.store;
                var requests = kb.statementsMatching(undefined, this.ns.link("requestedURI"), kb.sym(docuri), meta).map(function(st) {
                    return st.subject;
                });
                var _iterator = $1d9128915acc42fc$var$_createForOfIteratorHelper(requests), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var request = _step.value;
                        var _response = kb.any(request, this.ns.link("response"), null, meta);
                        if (_response !== undefined) {
                            // ts
                            var quad = kb.statementsMatching(_response, this.ns.link("outOfDate"), true, meta);
                            kb.remove(quad);
                            options.force = true;
                            options.clearPreviousData = true;
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var initialisedOptions = this.initFetchOptions(docuri, options);
                return this.pendingFetchPromise(docuri, initialisedOptions.baseURI, initialisedOptions);
            }
        },
        {
            key: "pendingFetchPromise",
            value: function() {
                var _pendingFetchPromise = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(uri, originalUri, options) {
                    var _this3 = this;
                    var pendingPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.t0 = !options.force;
                                if (!_context.t0) {
                                    _context.next = 5;
                                    break;
                                }
                                _context.next = 4;
                                return this.fetchQueue[originalUri];
                            case 4:
                                _context.t0 = _context.sent;
                            case 5:
                                if (!_context.t0) {
                                    _context.next = 9;
                                    break;
                                }
                                pendingPromise = this.fetchQueue[originalUri];
                                _context.next = 12;
                                break;
                            case 9:
                                pendingPromise = Promise.race([
                                    this.setRequestTimeout(uri, options),
                                    this.fetchUri(uri, options)
                                ]);
                                this.fetchQueue[originalUri] = pendingPromise;
                                // Clean up the queued promise after a time, if it's resolved
                                this.cleanupFetchRequest(originalUri, undefined, this.timeout);
                            case 12:
                                return _context.abrupt("return", pendingPromise.then(function(x) {
                                    if (uri in _this3.timeouts) {
                                        _this3.timeouts[uri].forEach(clearTimeout);
                                        delete _this3.timeouts[uri];
                                    }
                                    return x;
                                }));
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function pendingFetchPromise(_x, _x2, _x3) {
                    return _pendingFetchPromise.apply(this, arguments);
                }
                return pendingFetchPromise;
            }()
        },
        {
            key: "cleanupFetchRequest",
            value: function cleanupFetchRequest(originalUri, _options, timeout) {
                var _this4 = this;
                if (_options !== undefined) console.warn("_options is deprecated");
                this.timeouts[originalUri] = (this.timeouts[originalUri] || []).concat(setTimeout(function() {
                    if (!_this4.isPending(originalUri)) delete _this4.fetchQueue[originalUri];
                }, timeout));
            }
        },
        {
            key: "initFetchOptions",
            value: function initFetchOptions(uri, options) {
                var kb = this.store;
                var isGet = !options.method || options.method.toUpperCase() === "GET";
                if (!isGet) options.force = true;
                options.resource = kb.rdfFactory.namedNode(uri); // This might be proxified
                options.baseURI = options.baseURI || uri; // Preserve though proxying etc
                options.original = kb.rdfFactory.namedNode(options.baseURI);
                options.req = kb.bnode();
                options.headers = options.headers || new (0, $R5nvG.Headers)();
                if (options.contentType) // @ts-ignore
                options.headers["content-type"] = options.contentType;
                if (options.force) options.cache = "no-cache";
                var acceptString = this.acceptString();
                // @ts-ignore
                options.headers["accept"] = acceptString;
                var requestedURI = Fetcher.offlineOverride(uri);
                options.requestedURI = requestedURI;
                Fetcher.setCredentials(requestedURI, options);
                var actualProxyURI = Fetcher.proxyIfNecessary(requestedURI);
                if (requestedURI !== actualProxyURI) options.proxyUsed = true;
                options.actualProxyURI = actualProxyURI;
                return options;
            }
        },
        {
            key: "fetchUri",
            value: function fetchUri(docuri, options) {
                var _this5 = this;
                if (!docuri) return Promise.reject(new Error("Cannot fetch an empty uri"));
                if (Fetcher.unsupportedProtocol(docuri)) return this.failFetch(options, "fetcher: Unsupported protocol", "unsupported_protocol");
                var state = this.getState(docuri);
                if (!options.force) {
                    if (state === "fetched") // URI already fetched and added to store
                    return Promise.resolve(// @ts-ignore This is not a valid response object
                    this.doneFetch(options, {
                        status: 200,
                        ok: true,
                        statusText: "Already loaded into quadstore."
                    }));
                    if (state === "failed" && this.requested[docuri] === 404) {
                        // Remember nonexistence
                        var _message = "Previously failed: " + this.requested[docuri];
                        // @ts-ignore This is not a valid response object
                        var dummyResponse = {
                            url: docuri,
                            // This does not comply to Fetch spec, it can be a string value in rdflib
                            status: this.requested[docuri],
                            statusText: _message,
                            responseText: _message,
                            headers: new (0, $R5nvG.Headers)(),
                            // Headers() ???
                            ok: false,
                            body: null,
                            bodyUsed: false,
                            size: 0,
                            timeout: 0
                        };
                        return this.failFetch(options, _message, this.requested[docuri], dummyResponse);
                    }
                } else // options.force == true
                delete this.nonexistent[docuri];
                this.fireCallbacks("request", [
                    docuri
                ]);
                this.requested[docuri] = true; // mark this uri as 'requested'
                if (!options.noMeta) this.saveRequestMetadata(docuri, options);
                var actualProxyURI = options.actualProxyURI;
                // Map might get mistakenly added into headers
                // error TS2339: Property 'map' does not exist on type 'Headers'.
                /* let map
      if (options.headers && map in options.headers) {
        delete options.headers.map
      } */ return this._fetch(actualProxyURI, options).then(function(response) {
                    return _this5.handleResponse(response, docuri, options);
                }, function(error) {
                    // @@ handleError?
                    // @ts-ignore Invalid response object
                    var dummyResponse = {
                        url: actualProxyURI,
                        status: 999,
                        // @@ what number/string should fetch failures report?
                        statusText: (error.name || "network failure") + ": " + (error.errno || error.code || error.type),
                        responseText: error.message,
                        headers: new (0, $R5nvG.Headers)(),
                        // Headers() ???
                        ok: false,
                        body: null,
                        bodyUsed: false,
                        size: 0,
                        timeout: 0
                    };
                    // console.log('Fetcher: <' + actualProxyURI + '> Non-HTTP fetch exception: ' + error)
                    return _this5.handleError(dummyResponse, docuri, options); // possible credentials retry
                // return this.failFetch(options, 'fetch failed: ' + error, 999, dummyResponse) // Fake status code: fetch exception
                // handleError expects a response so we fake some important bits.
                /*
        this.handleError(, docuri, options)
        */ });
            }
        },
        {
            key: "nowOrWhenFetched",
            value: function nowOrWhenFetched(uriIn, p2, userCallback) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var uri = (0, $avzMW.termValue)(uriIn);
                if (typeof p2 === "function") // nowOrWhenFetched (uri, userCallback)
                userCallback = p2;
                else if (typeof p2 === "undefined") ;
                else if ((0, $gCJkd.isNamedNode)(p2)) // referringTerm = p2
                options.referringTerm = p2;
                else // nowOrWhenFetched (uri, options, userCallback)
                options = p2;
                this.load(uri, options).then(function(fetchResponse) {
                    if (userCallback) {
                        if (fetchResponse) {
                            if (fetchResponse.ok) userCallback(true, "OK", fetchResponse);
                            else {
                                var oops = "HTTP error: Status " + fetchResponse.status + " (" + fetchResponse.statusText + ")";
                                if (fetchResponse.responseText) oops += " " + fetchResponse.responseText; // not in 404, dns error, nock failure
                                userCallback(false, oops, fetchResponse);
                            }
                        } else {
                            var _oops = "@@ nowOrWhenFetched:  no response object!";
                            userCallback(false, _oops);
                        }
                    }
                }, function(err) {
                    var message = err.message || err.statusText;
                    message = "Failed to load  <" + uri + "> " + message;
                    if (err.response && err.response.status) message += " status: " + err.response.status;
                    userCallback(false, message, err.response);
                });
            }
        },
        {
            key: "addStatus",
            value: function addStatus(req, statusMessage) {
                // <Debug about="parsePerformance">
                var now = new Date();
                statusMessage = "[" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + "." + now.getMilliseconds() + "] " + statusMessage;
                // </Debug>
                var kb = this.store;
                var statusNode = kb.the(req, this.ns.link("status"));
                if ((0, $gCJkd.isCollection)(statusNode)) statusNode.append(kb.rdfFactory.literal(statusMessage));
                else (0, $kAE07.default).warn("web.js: No list to add to: " + statusNode + "," + statusMessage);
            }
        },
        {
            key: "failFetch",
            value: function failFetch(options, errorMessage, statusCode, response) {
                this.addStatus(options.req, errorMessage);
                if (!options.noMeta) this.store.add(options.original, this.ns.link("error"), this.store.rdfFactory.literal(errorMessage));
                var meth = (options.method || "GET").toUpperCase();
                var isGet = meth === "GET" || meth === "HEAD";
                if (isGet) {
                    // only cache the status code on GET or HEAD
                    options.resource.equals(options.original);
                    this.requested[$4Q80K.docpart(options.original.value)] = statusCode;
                    this.fireCallbacks("fail", [
                        options.original.value,
                        errorMessage
                    ]);
                }
                var err = new Error("Fetcher: " + errorMessage);
                // err.ok = false // Is taken as a response, will work too @@ phase out?
                err.status = statusCode;
                err.statusText = errorMessage;
                err.response = response;
                return Promise.reject(err);
            }
        },
        {
            key: "linkData",
            value: function linkData(originalUri, rel, uri, why, reverse) {
                if (!uri) return;
                var kb = this.store;
                var predicate;
                // See http://www.w3.org/TR/powder-dr/#httplink for describedby 2008-12-10
                var obj = kb.rdfFactory.namedNode($4Q80K.join(uri, originalUri.value));
                if (rel === "alternate" || rel === "seeAlso" || rel === "meta" || rel === "describedby") {
                    if (obj.value === originalUri.value) return;
                    predicate = this.ns.rdfs("seeAlso");
                } else if (rel === "type") predicate = kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
                else // See https://www.iana.org/assignments/link-relations/link-relations.xml
                // Alas not yet in RDF yet for each predicate
                // encode space in e.g. rel="shortcut icon"
                predicate = kb.rdfFactory.namedNode($4Q80K.join(encodeURIComponent(rel), "http://www.iana.org/assignments/link-relations/"));
                if (reverse) kb.add(obj, predicate, originalUri, why);
                else kb.add(originalUri, predicate, obj, why);
            }
        },
        {
            key: "parseLinkHeader",
            value: function parseLinkHeader(linkHeader, originalUri, reqNode) {
                if (!linkHeader) return;
                // const linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^()<>@,;:"/[]?={} \t]+)|("[^"]*")))*(,|$)/g
                // const paramexp = /[^()<>@,;:"/[]?={} \t]+=(([^()<>@,;:"/[]?={} \t]+)|("[^"]*"))/g
                // From https://www.dcode.fr/regular-expression-simplificator:
                // const linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} t]+=["]))*[,$]/g
                // const paramexp = /[^\\<>@,;:"\/\[\]?={} \t]+=["])/g
                // Original:
                var linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*")))*(,|$)/g;
                var paramexp = /[^\(\)<>@,;:"\/\[\]\?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*"))/g;
                var matches = linkHeader.match(linkexp);
                if (matches == null) return;
                for(var i = 0; i < matches.length; i++){
                    var split = matches[i].split(">");
                    var href = split[0].substring(1);
                    var ps = split[1];
                    var s = ps.match(paramexp);
                    if (s == null) return;
                    for(var j = 0; j < s.length; j++){
                        var p = s[j];
                        var paramsplit = p.split("=");
                        // var name = paramsplit[0]
                        var rel = paramsplit[1].replace(/["']/g, ""); // '"
                        this.linkData(originalUri, rel, href, reqNode);
                    }
                }
            }
        },
        {
            key: "doneFetch",
            value: function doneFetch(options, response) {
                this.addStatus(options.req, "Done.");
                this.requested[options.original.value] = "done";
                this.fireCallbacks("done", [
                    options.original.value
                ]);
                response.req = options.req; // Set the request meta blank node
                return response;
            }
        },
        {
            key: "nowKnownAs",
            value: function nowKnownAs(was, now) {
                if (this.lookedUp[was.value]) // Transfer userCallback
                {
                    if (!this.lookedUp[now.value]) this.lookUpThing(now, was);
                } else if (this.lookedUp[now.value]) {
                    if (!this.lookedUp[was.value]) this.lookUpThing(was, now);
                }
            }
        },
        {
            key: "putBack",
            value: function putBack(uri) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var uriSting = (0, $avzMW.termValue)(uri);
                var doc = new (0, $99pVg.default)(uriSting).doc(); // strip off #
                options.contentType = options["content-type"] || options["Content-Type"] || options.contentType || (0, $8RKL2.TurtleContentType);
                if (options.contentType === "application/ld+json") return new Promise(function(resolve, reject) {
                    (0, $957a454a8ab6ebde$export$2e2bcd8739ae039)(doc, _this6.store, doc.uri, options.contentType, function(err, jsonString) {
                        if (err) reject(err);
                        else {
                            // @ts-ignore
                            options.data = jsonString;
                            _this6.webOperation("PUT", uri, options).then(function(res) {
                                return resolve(res);
                            }).catch(function(error) {
                                return reject(error);
                            });
                        }
                    });
                });
                options.data = (0, $957a454a8ab6ebde$export$2e2bcd8739ae039)(doc, this.store, doc.value, options.contentType);
                return this.webOperation("PUT", uriSting, options);
            }
        },
        {
            key: "webCopy",
            value: function webCopy(here, there, contentType) {
                var _this7 = this;
                return this.webOperation("GET", here).then(function(result) {
                    return _this7.webOperation("PUT", // change to binary from text
                    there, {
                        data: result.responseText,
                        contentType: contentType
                    });
                });
            }
        },
        {
            key: "delete",
            value: function _delete(uri, options) {
                var _this8 = this;
                return this.webOperation("DELETE", uri, options).then(function(response) {
                    _this8.requested[uri] = 404;
                    _this8.nonexistent[uri] = true;
                    _this8.unload(_this8.store.rdfFactory.namedNode(uri));
                    return response;
                });
            }
        },
        {
            key: "createIfNotExists",
            value: function() {
                var _createIfNotExists = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee2(doc) {
                    var contentType, data, fetcher, response, _args2 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                contentType = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : (0, $8RKL2.TurtleContentType);
                                data = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : "";
                                fetcher = this;
                                _context2.prev = 3;
                                _context2.next = 6;
                                return fetcher.load(doc);
                            case 6:
                                response = _context2.sent;
                                _context2.next = 26;
                                break;
                            case 9:
                                _context2.prev = 9;
                                _context2.t0 = _context2["catch"](3);
                                if (!(_context2.t0.response.status === 404)) {
                                    _context2.next = 25;
                                    break;
                                }
                                _context2.prev = 12;
                                _context2.next = 15;
                                return fetcher.webOperation("PUT", doc.value, {
                                    data: data,
                                    contentType: contentType
                                });
                            case 15:
                                response = _context2.sent;
                                _context2.next = 21;
                                break;
                            case 18:
                                _context2.prev = 18;
                                _context2.t1 = _context2["catch"](12);
                                throw _context2.t1;
                            case 21:
                                delete fetcher.requested[doc.value]; // delete cached 404 error
                                // console.log('createIfNotExists doc created ok ' + doc)
                                return _context2.abrupt("return", response);
                            case 25:
                                throw _context2.t0;
                            case 26:
                                return _context2.abrupt("return", response);
                            case 27:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            3,
                            9
                        ],
                        [
                            12,
                            18
                        ]
                    ]);
                }));
                function createIfNotExists(_x4) {
                    return _createIfNotExists.apply(this, arguments);
                }
                return createIfNotExists;
            }()
        },
        {
            key: "createContainer",
            value: function createContainer(parentURI, folderName, data) {
                var headers = {
                    // Force the right mime type for containers
                    "content-type": (0, $8RKL2.TurtleContentType),
                    "link": this.ns.ldp("BasicContainer") + '; rel="type"'
                };
                if (folderName) headers["slug"] = folderName;
                // @ts-ignore These headers lack some of the required operators.
                var options = {
                    headers: headers
                };
                if (data) options.body = data;
                return this.webOperation("POST", parentURI, options);
            }
        },
        {
            key: "invalidateCache",
            value: function invalidateCache(iri) {
                var uri = (0, $avzMW.termValue)(iri);
                var fetcher = this;
                // @ts-ignore
                if (fetcher.fetchQueue && fetcher.fetchQueue[uri]) {
                    // console.log('Internal error - fetchQueue exists ' + uri)
                    var promise = fetcher.fetchQueue[uri];
                    if (promise["PromiseStatus"] === "resolved") delete fetcher.fetchQueue[uri];
                    else // pending
                    delete fetcher.fetchQueue[uri];
                }
                if (fetcher.requested[uri] && fetcher.requested[uri] !== "done" && fetcher.requested[uri] !== "failed" && fetcher.requested[uri] !== 404) {
                    var msg = "Rdflib: fetcher: Destructive operation on <".concat(fetcher.requested[uri], "> file being fetched! ") + uri;
                    console.error(msg);
                // alert(msg)
                } else {
                    delete fetcher.requested[uri]; // invalidate read cache -- @@ messes up logic if request in progress ??
                    delete fetcher.nonexistent[uri];
                }
            }
        },
        {
            key: "webOperation",
            value: function webOperation(method, uriIn) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var uri = (0, $avzMW.termValue)(uriIn);
                options.method = method;
                options.body = options.data || options.body;
                options.force = true;
                var fetcher = this;
                if (options.body && !options.contentType) throw new Error("Web operation sending data must have a defined contentType.");
                if (options.contentType) {
                    options.headers = options.headers || {};
                    options.headers["content-type"] = options.contentType;
                }
                Fetcher.setCredentials(uri, options);
                return new Promise(function(resolve, reject) {
                    fetcher._fetch(uri, options).then(function(response) {
                        if (response.ok) {
                            if (method === "PUT" || method === "PATCH" || method === "POST" || method === "DELETE") fetcher.invalidateCache(uri);
                             // response.body with Chrome can't be relied on
                            if (response.text) // Was: response.body https://github.com/linkeddata/rdflib.js/issues/506
                            response.text().then(function(data) {
                                response.responseText = data;
                                resolve(response);
                            });
                            else resolve(response);
                        } else {
                            var msg = "Web error: " + response.status;
                            if (response.statusText) msg += " (" + response.statusText + ")";
                            msg += " on " + method + " of <" + uri + ">";
                            if (response.responseText) msg += ": " + response.responseText;
                            var e2 = new Error(msg);
                            e2.response = response;
                            reject(e2);
                        }
                    }, function(err) {
                        var msg = "Fetch error for " + method + " of <" + uri + ">:" + err;
                        reject(new Error(msg));
                    });
                });
            }
        },
        {
            key: "lookUpThing",
            value: function lookUpThing(term, rterm) {
                var _this9 = this;
                var uris = this.store.uris(term); // Get all URIs
                uris = uris.map(function(u) {
                    return $4Q80K.docpart(u);
                }); // Drop hash fragments
                uris.forEach(function(u) {
                    _this9.lookedUp[u] = true;
                });
                // @ts-ignore Recursive type
                return this.load(uris, {
                    referringTerm: rterm
                });
            }
        },
        {
            key: "getHeader",
            value: function getHeader(doc, header) {
                var kb = this.store; // look for the URI (AS A STRING NOT A NODE) for a stored request
                var docuri = doc.value;
                var requests = kb.each(undefined, this.ns.link("requestedURI"), kb.rdfFactory.literal(docuri));
                for(var r = 0; r < requests.length; r++){
                    var request = requests[r];
                    if (request !== undefined) {
                        var _response2 = kb.any(request, this.ns.link("response"));
                        if (_response2 !== undefined && kb.anyValue(_response2, this.ns.http("status")) && kb.anyValue(_response2, this.ns.http("status")).startsWith("2")) {
                            // Only look at success returns - not 401 error messagess etc
                            var results = kb.each(_response2, this.ns.httph(header.toLowerCase()));
                            if (results.length) return results.map(function(v) {
                                return v.value;
                            });
                            return [];
                        }
                    }
                }
                return undefined;
            }
        },
        {
            key: "saveRequestMetadata",
            value: function saveRequestMetadata(docuri, options) {
                var req = options.req;
                var kb = this.store;
                var rterm = options.referringTerm;
                this.addStatus(options.req, "Accept: " + options.headers["accept"]);
                if ((0, $gCJkd.isNamedNode)(rterm)) kb.add(kb.rdfFactory.namedNode(docuri), this.ns.link("requestedBy"), rterm, this.appNode);
                if (options.original && options.original.value !== docuri) kb.add(req, this.ns.link("orginalURI"), kb.rdfFactory.literal(options.original.value), this.appNode);
                var now = new Date();
                var timeNow = "[" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + "] ";
                kb.add(req, this.ns.rdfs("label"), kb.rdfFactory.literal(timeNow + " Request for " + docuri), this.appNode);
                // We store the docuri as a string, not as a node,
                // see https://github.com/linkeddata/rdflib.js/pull/427#pullrequestreview-447910061
                kb.add(req, this.ns.link("requestedURI"), kb.rdfFactory.literal(docuri), this.appNode);
                kb.add(req, this.ns.link("status"), kb.collection(), this.appNode);
            }
        },
        {
            key: "saveResponseMetadata",
            value: function saveResponseMetadata(response, options) {
                var _this10 = this;
                var kb = this.store;
                var responseNode = kb.bnode();
                kb.add(options.req, this.ns.link("response"), responseNode, this.appNode);
                kb.add(responseNode, this.ns.http("status"), kb.rdfFactory.literal(response.status), this.appNode);
                kb.add(responseNode, this.ns.http("statusText"), kb.rdfFactory.literal(response.statusText), this.appNode);
                // Save the response headers
                response.headers.forEach(function(value, header) {
                    kb.add(responseNode, _this10.ns.httph(header), _this10.store.rdfFactory.literal(value), _this10.appNode);
                    if (header === "content-type") kb.add(options.resource, _this10.ns.rdf("type"), kb.rdfFactory.namedNode($23fob.mediaTypeClass(value).value), _this10.appNode // responseNode
                    );
                });
                return responseNode;
            }
        },
        {
            key: "objectRefresh",
            value: function objectRefresh(term) {
                var uris = this.store.uris(term); // Get all URIs
                if (typeof uris !== "undefined") for(var i = 0; i < uris.length; i++)this.refresh(this.store.rdfFactory.namedNode($4Q80K.docpart(uris[i])));
            }
        },
        {
            key: "refresh",
            value: function refresh(term, userCallback) {
                // sources_refresh
                this.fireCallbacks("refresh", arguments);
                this.nowOrWhenFetched(term, {
                    force: true,
                    clearPreviousData: true
                }, userCallback);
            }
        },
        {
            key: "refreshIfExpired",
            value: function refreshIfExpired(term, userCallback) {
                var exp = this.getHeader(term, "Expires");
                if (!exp || new Date(exp[0]).getTime() <= new Date().getTime()) this.refresh(term, userCallback);
                else userCallback(true, "Not expired", {});
            }
        },
        {
            key: "retract",
            value: function retract(term) {
                // sources_retract
                this.store.removeMany(undefined, undefined, undefined, term);
                if (term.value) delete this.requested[$4Q80K.docpart(term.value)];
                this.fireCallbacks("retract", arguments);
            }
        },
        {
            key: "getState",
            value: function getState(docuri) {
                if (typeof this.requested[docuri] === "undefined") return "unrequested";
                else if (this.requested[docuri] === true) return "requested";
                else if (this.requested[docuri] === "done") return "fetched";
                else if (this.requested[docuri] === "redirected") return this.getState(this.redirectedTo[docuri]);
                else // An non-200 HTTP error status
                return "failed";
            }
        },
        {
            key: "isPending",
            value: function isPending(docuri) {
                // sources_pending
                // doing anyStatementMatching is wasting time
                // if it's not pending: false -> flailed
                //   'done' -> done 'redirected' -> redirected
                return this.requested[docuri] === true;
            }
        },
        {
            key: "unload",
            value: function unload(term) {
                this.store.removeDocument(term);
                delete this.requested[term.value]; // So it can be load2ed again
            }
        },
        {
            key: "addHandler",
            value: function addHandler(handler) {
                this.handlers.push(handler);
                handler.register(this);
            }
        },
        {
            key: "retryNoCredentials",
            value: function retryNoCredentials(docuri, options) {
                // console.log('Fetcher: CORS: RETRYING with NO CREDENTIALS for ' + options.resource)
                options.retriedWithNoCredentials = true; // protect against being called twice
                delete this.requested[docuri]; // forget the original request happened
                delete this.fetchQueue[docuri];
                // Note: XHR property was withCredentials, but fetch property is just credentials
                var newOptions = Object.assign({}, options, {
                    credentials: "omit"
                });
                this.addStatus(options.req, "Abort: Will retry with credentials SUPPRESSED to see if that helps");
                return this.load(docuri, newOptions);
            }
        },
        {
            key: "isCrossSite",
            value: function isCrossSite(uri) {
                // Mashup situation, not node etc
                if (typeof document === "undefined" || !document.location) return false;
                var hostpart = $4Q80K.hostpart;
                var here = "" + document.location;
                return (hostpart(here) && hostpart(uri) && hostpart(here)) !== hostpart(uri);
            }
        },
        {
            key: "handleError",
            value: function handleError(response, docuri, options) {
                if (this.isCrossSite(docuri)) {
                    // Make sure we haven't retried already
                    if (options.credentials && options.credentials === "include" && !options.retriedWithNoCredentials) return this.retryNoCredentials(docuri, options);
                    // Now attempt retry via proxy
                    var proxyUri = Fetcher.crossSiteProxy(docuri);
                    if (proxyUri && !options.proxyUsed) // console.log('web: Direct failed so trying proxy ' + proxyUri)
                    return this.redirectToProxy(proxyUri, options);
                }
                var message;
                if (response instanceof Error) message = "Fetch error: " + response.message;
                else {
                    message = response.statusText;
                    if (response.responseText) message += " ".concat(response.responseText);
                }
                // This is either not a CORS error, or retries have been made
                return this.failFetch(options, message, response.status || 998, response);
            }
        },
        {
            key: "addType",
            value: function addType(rdfType, req, kb, locURI) {
                // add type to all redirected resources too
                var prev = req;
                if (locURI) {
                    var reqURI = kb.any(prev, this.ns.link("requestedURI"));
                    if (reqURI && reqURI.value !== locURI) kb.add(kb.rdfFactory.namedNode(locURI), this.ns.rdf("type"), rdfType, this.appNode);
                }
                for(;;){
                    var doc = kb.any(prev, this.ns.link("requestedURI"));
                    if (doc && doc.value) kb.add(kb.rdfFactory.namedNode(doc.value), this.ns.rdf("type"), rdfType, this.appNode);
                     // convert Literal
                    prev = kb.any(undefined, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#redirectedRequest"), prev);
                    if (!prev) break;
                    var response = kb.any(prev, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#response"));
                    if (!response) break;
                    var redirection = kb.any(response, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/http#status"));
                    if (!redirection) break;
                    // @ts-ignore always true?
                    if (redirection !== "301" && redirection !== "302") break;
                }
            }
        },
        {
            key: "handleResponse",
            value: function handleResponse(response, docuri, options) {
                var _this11 = this;
                var kb = this.store;
                var headers = response.headers;
                var reqNode = options.req;
                var responseNode = this.saveResponseMetadata(response, options);
                var contentType = this.normalizedContentType(options, headers) || "";
                var contentLocation = headers.get("content-location");
                // this.fireCallbacks('recv', xhr.args)
                // this.fireCallbacks('headers', [{uri: docuri, headers: xhr.headers}])
                // Check for masked errors (CORS, etc)
                if (response.status === 0) // console.log('Masked error - status 0 for ' + docuri)
                return this.handleError(response, docuri, options);
                if (response.status >= 400) {
                    if (response.status === 404) {
                        this.nonexistent[options.original.value] = true;
                        this.nonexistent[docuri] = true;
                    }
                    return this.saveErrorResponse(response, responseNode).then(function() {
                        var errorMessage = options.resource + " " + response.statusText;
                        return _this11.failFetch(options, errorMessage, response.status, response);
                    });
                }
                var diffLocation = null;
                var absContentLocation = null;
                if (contentLocation) {
                    absContentLocation = $4Q80K.join(contentLocation, docuri);
                    if (absContentLocation !== docuri) diffLocation = absContentLocation;
                }
                if (response.status === 200) {
                    this.addType(this.ns.link("Document"), reqNode, kb, docuri);
                    if (diffLocation) this.addType(this.ns.link("Document"), reqNode, kb, diffLocation);
                    // Before we parse new data clear old but only on 200
                    if (options.clearPreviousData) kb.removeDocument(options.resource);
                    var isImage = contentType.includes("image/") || contentType.includes("application/pdf");
                    if (contentType && isImage) {
                        this.addType(kb.rdfFactory.namedNode("http://purl.org/dc/terms/Image"), reqNode, kb, docuri);
                        if (diffLocation) this.addType(kb.rdfFactory.namedNode("http://purl.org/dc/terms/Image"), reqNode, kb, diffLocation);
                    }
                }
                // If we have already got the thing at this location, abort
                if (contentLocation) {
                    if (!options.force && diffLocation && this.requested[absContentLocation] === "done") // we have already fetched this
                    // should we smush too?
                    // log.info("HTTP headers indicate we have already" + " retrieved " +
                    // xhr.resource + " as " + absContentLocation + ". Aborting.")
                    return this.doneFetch(options, response);
                    this.requested[absContentLocation] = true;
                }
                this.parseLinkHeader(headers.get("link"), options.original, reqNode);
                var handler = this.handlerForContentType(contentType, response);
                if (!handler) {
                    //  Not a problem, we just don't extract data
                    this.addStatus(reqNode, "Fetch over. No data handled.");
                    return this.doneFetch(options, response);
                }
                return response.text()// @ts-ignore Types seem right
                .then(function(responseText) {
                    response.responseText = responseText;
                    return handler.parse(_this11, responseText, options, response);
                });
            }
        },
        {
            key: "saveErrorResponse",
            value: function saveErrorResponse(response, responseNode) {
                var _this12 = this;
                var kb = this.store;
                return response.text().then(function(content) {
                    if (content.length > 10) kb.add(responseNode, _this12.ns.http("content"), kb.rdfFactory.literal(content), responseNode);
                });
            }
        },
        {
            key: "handlerForContentType",
            value: function handlerForContentType(contentType, response) {
                if (!contentType) return null;
                var Handler = this.handlers.find(function(handler) {
                    return contentType.match(handler.pattern);
                });
                // @ts-ignore in practice all Handlers have constructors.
                return Handler ? new Handler(response) : null;
            }
        },
        {
            key: "guessContentType",
            value: function guessContentType(uri) {
                return $1d9128915acc42fc$var$CONTENT_TYPE_BY_EXT[uri.split(".").pop()];
            }
        },
        {
            key: "normalizedContentType",
            value: function normalizedContentType(options, headers) {
                if (options.forceContentType) return options.forceContentType;
                var contentType = headers.get("content-type");
                if (!contentType || contentType.includes("application/octet-stream")) {
                    var guess = this.guessContentType(options.resource.value);
                    if (guess) return guess;
                }
                var protocol = $4Q80K.protocol(options.resource.value);
                if (!contentType && [
                    "file",
                    "chrome"
                ].includes(protocol)) return "text/xml";
                return contentType;
            }
        },
        {
            key: "redirectToProxy",
            value: function redirectToProxy(newURI, options) {
                var _this13 = this;
                this.addStatus(options.req, "BLOCKED -> Cross-site Proxy to <" + newURI + ">");
                options.proxyUsed = true;
                var kb = this.store;
                var oldReq = options.req; // request metadata blank node
                if (!options.noMeta) {
                    kb.add(oldReq, this.ns.link("redirectedTo"), kb.rdfFactory.namedNode(newURI), oldReq);
                    this.addStatus(oldReq, "redirected to new request"); // why
                }
                this.requested[options.resource.value] = "redirected";
                this.redirectedTo[options.resource.value] = newURI;
                var newOptions = Object.assign({}, options);
                newOptions.baseURI = options.resource.value;
                return this.fetchUri(newURI, newOptions).then(function(response) {
                    if (!newOptions.noMeta) kb.add(oldReq, _this13.ns.link("redirectedRequest"), newOptions.req, _this13.appNode);
                    return response;
                });
            }
        },
        {
            key: "setRequestTimeout",
            value: function setRequestTimeout(uri, options) {
                var _this14 = this;
                return new Promise(function(resolve) {
                    _this14.timeouts[uri] = (_this14.timeouts[uri] || []).concat(setTimeout(function() {
                        if (_this14.isPending(uri) && !options.retriedWithNoCredentials && !options.proxyUsed) resolve(_this14.failFetch(options, "Request to ".concat(uri, " timed out"), "timeout"));
                    }, _this14.timeout));
                });
            }
        },
        {
            key: "addFetchCallback",
            value: function addFetchCallback(uri, callback) {
                if (!this.fetchCallbacks[uri]) this.fetchCallbacks[uri] = [
                    callback
                ];
                else this.fetchCallbacks[uri].push(callback);
            }
        },
        {
            key: "acceptString",
            value: function acceptString() {
                var acceptstring = "";
                for(var mediaType in this.mediatypes){
                    if (acceptstring !== "") acceptstring += ", ";
                    acceptstring += mediaType;
                    for(var property in this.mediatypes[mediaType])acceptstring += ";" + property + "=" + this.mediatypes[mediaType][property];
                }
                return acceptstring;
            }
        }
    ], [
        {
            key: "crossSiteProxy",
            value: function crossSiteProxy(uri) {
                if (Fetcher.crossSiteProxyTemplate) return Fetcher.crossSiteProxyTemplate.replace("{uri}", encodeURIComponent(uri));
                else return undefined;
            }
        },
        {
            key: "offlineOverride",
            value: function offlineOverride(uri) {
                // Map the URI to a localhost proxy if we are running on localhost
                // This is used for working offline, e.g. on planes.
                // Is the script itself is running in localhost, then access all
                //   data in a localhost mirror.
                // Do not remove without checking with TimBL
                var requestedURI = uri;
                var UI;
                if (typeof window !== "undefined" && window.panes && (UI = window.panes.UI) && UI.preferences && UI.preferences.get("offlineModeUsingLocalhost")) {
                    if (requestedURI.slice(0, 7) === "http://" && requestedURI.slice(7, 17) !== "localhost/") {
                        requestedURI = "http://localhost/" + requestedURI.slice(7);
                        (0, $kAE07.default).warn("Localhost kludge for offline use: actually getting <" + requestedURI + ">");
                    }
                // log.warn("Localhost kludge NOT USED <" + requestedURI + ">")
                }
                return requestedURI;
            }
        },
        {
            key: "proxyIfNecessary",
            value: function proxyIfNecessary(uri) {
                var UI;
                if (typeof window !== "undefined" && window.panes && (UI = window.panes.UI) && UI.isExtension) return uri;
                 // Extension does not need proxy
                if (typeof $SolidTestEnvironment !== "undefined" && $SolidTestEnvironment.localSiteMap) {
                    // nested dictionaries of URI parts from origin down
                    var hostpath = uri.split("/").slice(2); // the bit after the //
                    var lookup = function lookup(parts, index) {
                        var z = index[parts.shift()];
                        if (!z) return null;
                        if (typeof z === "string") return z + parts.join("/");
                        if (!parts) return null;
                        return lookup(parts, z);
                    };
                    var y = lookup(hostpath, $SolidTestEnvironment.localSiteMap);
                    if (y) return y;
                }
                // browser does 2014 on as https browser script not trusted
                // If the web app origin is https: then the mixed content rules
                // prevent it loading insecure http: stuff so we need proxy.
                if (Fetcher.crossSiteProxyTemplate && typeof document !== "undefined" && document.location && ("" + document.location).slice(0, 6) === "https:" && // origin is secure
                uri.slice(0, 5) === "http:") // requested data is not
                return Fetcher.crossSiteProxyTemplate.replace("{uri}", encodeURIComponent(uri));
                return uri;
            }
        },
        {
            key: "unsupportedProtocol",
            value: function unsupportedProtocol(uri) {
                var pcol = $4Q80K.protocol(uri);
                return pcol === "tel" || pcol === "mailto" || pcol === "urn";
            }
        },
        {
            key: "setCredentials",
            value: function setCredentials(requestedURI) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                // 2014 CORS problem:
                // XMLHttpRequest cannot load http://www.w3.org/People/Berners-Lee/card.
                // A wildcard '*' cannot be used in the 'Access-Control-Allow-Origin'
                //   header when the credentials flag is true.
                // @ Many ontology files under http: and need CORS wildcard ->
                //   can't have credentials
                if (options.credentials === undefined) {
                    // Caller using new fetch convention
                    if (options.withCredentials !== undefined) // XHR style is what Fetcher specified before
                    options.credentials = options.withCredentials ? "include" : "omit";
                    else options.credentials = "include"; // default is to be logged on
                }
            }
        }
    ]);
    return Fetcher;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1d9128915acc42fc$export$2e2bcd8739ae039, "HANDLERS", void 0);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1d9128915acc42fc$export$2e2bcd8739ae039, "CONTENT_TYPE_BY_EXT", void 0);
// TODO: Document this
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($1d9128915acc42fc$export$2e2bcd8739ae039, "crossSiteProxyTemplate", void 0);
$1d9128915acc42fc$export$2e2bcd8739ae039.HANDLERS = $1d9128915acc42fc$var$defaultHandlers;
$1d9128915acc42fc$export$2e2bcd8739ae039.CONTENT_TYPE_BY_EXT = $1d9128915acc42fc$var$CONTENT_TYPE_BY_EXT;






















var $41YNz = parcelRequire("41YNz");


var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $g5Zhu = parcelRequire("g5Zhu");



var $4Q80K = parcelRequire("4Q80K");




var $gCJkd = parcelRequire("gCJkd");

var $23fob = parcelRequire("23fob");

var $avzMW = parcelRequire("avzMW");
function $f8539385ca2d21cc$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $f8539385ca2d21cc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $f8539385ca2d21cc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f8539385ca2d21cc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f8539385ca2d21cc$var$_arrayLikeToArray(o, minLen);
}
function $f8539385ca2d21cc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
* The UpdateManager is a helper object for a store.
* Just as a Fetcher provides the store with the ability to read and write,
* the Update Manager provides functionality for making small patches in real time,
* and also looking out for concurrent updates from other agents
*/ var $f8539385ca2d21cc$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  store - The quadstore to store data and metadata. Created if not passed.
  */ function UpdateManager(store) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, UpdateManager);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "store", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "ifps", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "fps", void 0);
        /** Index of objects for coordinating incoming and outgoing patches */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "patchControl", void 0);
        /** Object of namespaces */ (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(this, "ns", void 0);
        store = store || new (0, $6f5c135260474402$export$2e2bcd8739ae039)();
        if (store.updater) throw new Error("You can't have two UpdateManagers for the same store");
        if (!store.fetcher) store.fetcher = new (0, $1d9128915acc42fc$export$2e2bcd8739ae039)(store);
        this.store = store;
        store.updater = this;
        this.ifps = {};
        this.fps = {};
        this.ns = {};
        this.ns.link = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/link#");
        this.ns.http = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/http#");
        this.ns.httph = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2007/ont/httph#");
        this.ns.ldp = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/ns/ldp#");
        this.ns.rdf = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
        this.ns.rdfs = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2000/01/rdf-schema#");
        this.ns.rdf = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
        this.ns.owl = (0, $5b5611d501681341$export$2e2bcd8739ae039)("http://www.w3.org/2002/07/owl#");
        this.patchControl = [];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(UpdateManager, [
        {
            key: "patchControlFor",
            value: function patchControlFor(doc) {
                if (!this.patchControl[doc.value]) this.patchControl[doc.value] = [];
                return this.patchControl[doc.value];
            }
        },
        {
            key: "isHttpUri",
            value: function isHttpUri(uri) {
                return uri.slice(0, 4) === "http";
            }
        },
        {
            key: "flagAuthorizationMetadata",
            value: function flagAuthorizationMetadata(kb) {
                var _kb$fetcher;
                if (!kb) kb = this.store;
                var meta = (_kb$fetcher = kb.fetcher) === null || _kb$fetcher === void 0 ? void 0 : _kb$fetcher.appNode;
                var requests = kb.statementsMatching(undefined, this.ns.link("requestedURI"), undefined, meta).map(function(st) {
                    return st.subject;
                });
                var _iterator = $f8539385ca2d21cc$var$_createForOfIteratorHelper(requests), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var request = _step.value;
                        var _response = kb.any(request, this.ns.link("response"), null, meta);
                        if (_response !== undefined) // ts
                        kb.add(_response, this.ns.link("outOfDate"), true, meta); // @@ Boolean is fine - fix types
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        },
        {
            key: "checkEditable",
            value: function() {
                var _checkEditable = (0, (/*@__PURE__*/$parcel$interopDefault($b8259e79f5c77a6f$exports)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(uri, kb) {
                    var _kb$fetcher2;
                    var initial, final;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (uri) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                if (!kb) kb = this.store;
                                initial = this.editable(uri, kb);
                                if (!(initial !== undefined)) {
                                    _context.next = 6;
                                    break;
                                }
                                return _context.abrupt("return", initial);
                            case 6:
                                _context.next = 8;
                                return (_kb$fetcher2 = kb.fetcher) === null || _kb$fetcher2 === void 0 ? void 0 : _kb$fetcher2.load(uri);
                            case 8:
                                final = this.editable(uri, kb); // console.log(`Loaded ${uri} just to check editable, result: ${final}.`)
                                return _context.abrupt("return", final);
                            case 10:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function checkEditable(_x, _x2) {
                    return _checkEditable.apply(this, arguments);
                }
                return checkEditable;
            }()
        },
        {
            key: "editable",
            value: function editable(uri, kb) {
                var _kb$fetcher3;
                if (!uri) return false; // Eg subject is bnode, no known doc to write to
                if (!kb) kb = this.store;
                uri = (0, $avzMW.termValue)(uri);
                if (!this.isHttpUri(uri)) {
                    if (kb.holds(kb.rdfFactory.namedNode(uri), kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"), kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#MachineEditableDocument"))) return "LOCALFILE";
                }
                var request;
                var definitive = false;
                var meta = (_kb$fetcher3 = kb.fetcher) === null || _kb$fetcher3 === void 0 ? void 0 : _kb$fetcher3.appNode;
                // const kb = s
                // @ts-ignore passes a string to kb.each, which expects a term. Should this work?
                var requests = kb.each(undefined, this.ns.link("requestedURI"), (0, $4Q80K.docpart)(uri), meta);
                var method;
                for(var r = 0; r < requests.length; r++){
                    request = requests[r];
                    if (request !== undefined) {
                        var _response2 = kb.any(request, this.ns.link("response"), null, meta);
                        if (_response2 !== undefined) {
                            // ts
                            var outOfDate = kb.anyJS(_response2, this.ns.link("outOfDate"), null, meta);
                            if (outOfDate) continue;
                            var wacAllow = kb.anyValue(_response2, this.ns.httph("wac-allow"));
                            if (wacAllow) {
                                var _iterator2 = $f8539385ca2d21cc$var$_createForOfIteratorHelper(wacAllow.split(",")), _step2;
                                try {
                                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                        var bit = _step2.value;
                                        var lr = bit.split("=");
                                        if (lr[0].includes("user") && !lr[1].includes("write") && !lr[1].includes("append")) // console.log('    editable? excluded by WAC-Allow: ', wacAllow)
                                        return false;
                                    }
                                } catch (err) {
                                    _iterator2.e(err);
                                } finally{
                                    _iterator2.f();
                                }
                            }
                            var acceptPatch = kb.each(_response2, this.ns.httph("accept-patch"));
                            if (acceptPatch.length) for(var i = 0; i < acceptPatch.length; i++){
                                method = acceptPatch[i].value.trim();
                                if (method.indexOf("text/n3") >= 0) return "N3PATCH";
                                if (method.indexOf("application/sparql-update") >= 0) return "SPARQL";
                                if (method.indexOf("application/sparql-update-single-match") >= 0) return "SPARQL";
                            }
                            var authorVia = kb.each(_response2, this.ns.httph("ms-author-via"));
                            if (authorVia.length) for(var _i = 0; _i < authorVia.length; _i++){
                                method = authorVia[_i].value.trim();
                                if (method.indexOf("SPARQL") >= 0) return "SPARQL";
                                if (method.indexOf("DAV") >= 0) return "DAV";
                            }
                            if (!this.isHttpUri(uri)) {
                                if (!wacAllow) return false;
                                else return "LOCALFILE";
                            }
                            var status = kb.each(_response2, this.ns.http("status"));
                            if (status.length) {
                                for(var _i2 = 0; _i2 < status.length; _i2++)// @ts-ignore since statuses should be TFTerms, this should always be false
                                if (status[_i2] === 200 || status[_i2] === 404) definitive = true;
                            }
                        }
                    }
                }
                if (requests.length === 0) ;
                else {
                    if (definitive) return false; // We have got a request and it did NOT say editable => not editable
                }
                // console.log('UpdateManager.editable: inconclusive for ' + uri + '\n')
                return undefined; // We don't know (yet) as we haven't had a response (yet)
            }
        },
        {
            key: "anonymize",
            value: function anonymize(obj) {
                var anonymized = obj.toNT().substr(0, 2) === "_:" && this.mentioned(obj) ? "?" + obj.toNT().substr(2) : obj.toNT();
                return anonymized;
            }
        },
        {
            key: "anonymizeNT",
            value: function anonymizeNT(stmt) {
                return this.anonymize(stmt.subject) + " " + this.anonymize(stmt.predicate) + " " + this.anonymize(stmt.object) + " .";
            }
        },
        {
            key: "nTriples",
            value: function nTriples(stmt) {
                return "".concat(stmt.subject.toNT(), " ").concat(stmt.predicate.toNT(), " ").concat(stmt.object.toNT(), " .");
            }
        },
        {
            key: "statementBnodes",
            value: function statementBnodes(st) {
                return [
                    st.subject,
                    st.predicate,
                    st.object
                ].filter(function(x) {
                    return (0, $gCJkd.isBlankNode)(x);
                });
            }
        },
        {
            key: "statementArrayBnodes",
            value: function statementArrayBnodes(sts) {
                var bnodes = [];
                for(var i = 0; i < sts.length; i++)bnodes = bnodes.concat(this.statementBnodes(sts[i]));
                bnodes.sort(); // in place sort - result may have duplicates
                var bnodes2 = [];
                for(var j = 0; j < bnodes.length; j++)if (j === 0 || !bnodes[j].equals(bnodes[j - 1])) bnodes2.push(bnodes[j]);
                return bnodes2;
            }
        },
        {
            key: "cacheIfps",
            value: function cacheIfps() {
                this.ifps = {};
                var a = this.store.each(undefined, this.ns.rdf("type"), this.ns.owl("InverseFunctionalProperty"));
                for(var i = 0; i < a.length; i++)this.ifps[a[i].value] = true;
                this.fps = {};
                a = this.store.each(undefined, this.ns.rdf("type"), this.ns.owl("FunctionalProperty"));
                for(var _i3 = 0; _i3 < a.length; _i3++)this.fps[a[_i3].value] = true;
            }
        },
        {
            key: "bnodeContext2",
            value: function bnodeContext2(x, source, depth) {
                // Return a list of statements which indirectly identify a node
                //  Depth > 1 if try further indirection.
                //  Return array of statements (possibly empty), or null if failure
                var sts = this.store.statementsMatching(undefined, undefined, x, source); // incoming links
                var y;
                var res;
                for(var i = 0; i < sts.length; i++)if (this.fps[sts[i].predicate.value]) {
                    y = sts[i].subject;
                    if (!y.isBlank) return [
                        sts[i]
                    ];
                    if (depth) {
                        res = this.bnodeContext2(y, source, depth - 1);
                        if (res) return res.concat([
                            sts[i]
                        ]);
                    }
                }
                // outgoing links
                sts = this.store.statementsMatching(x, undefined, undefined, source);
                for(var _i4 = 0; _i4 < sts.length; _i4++)if (this.ifps[sts[_i4].predicate.value]) {
                    y = sts[_i4].object;
                    if (!y.isBlank) return [
                        sts[_i4]
                    ];
                    if (depth) {
                        res = this.bnodeContext2(y, source, depth - 1);
                        if (res) return res.concat([
                            sts[_i4]
                        ]);
                    }
                }
                return null; // Failure
            }
        },
        {
            key: "bnodeContext1",
            value: function bnodeContext1(x, source) {
                // Return a list of statements which indirectly identify a node
                //   Breadth-first
                for(var depth = 0; depth < 3; depth++){
                    // Try simple first
                    var con = this.bnodeContext2(x, source, depth);
                    if (con !== null) return con;
                }
                // If we can't guarantee unique with logic just send all info about node
                return this.store.connectedStatements(x, source); // was:
            // throw new Error('Unable to uniquely identify bnode: ' + x.toNT())
            }
        },
        {
            key: "mentioned",
            value: function mentioned(x) {
                return this.store.statementsMatching(x, null, null, null).length !== 0 || // Don't pin fresh bnodes
                this.store.statementsMatching(null, x).length !== 0 || this.store.statementsMatching(null, null, x).length !== 0;
            }
        },
        {
            key: "bnodeContext",
            value: function bnodeContext(bnodes, doc) {
                var context = [];
                if (bnodes.length) {
                    this.cacheIfps();
                    for(var i = 0; i < bnodes.length; i++){
                        // Does this occur in old graph?
                        var bnode = bnodes[i];
                        if (!this.mentioned(bnode)) continue;
                        context = context.concat(this.bnodeContext1(bnode, doc));
                    }
                }
                return context;
            }
        },
        {
            key: "statementContext",
            value: function statementContext(st) {
                var bnodes = this.statementBnodes(st);
                return this.bnodeContext(bnodes, st.graph);
            }
        },
        {
            key: "contextWhere",
            value: function contextWhere(context) {
                var updater = this;
                return !context || context.length === 0 ? "" : "WHERE { " + context.map(function(x) {
                    return updater.anonymizeNT(x);
                }).join("\n") + " }\n";
            }
        },
        {
            key: "fire",
            value: function fire(uri, query, callbackFunction) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                return Promise.resolve().then(function() {
                    if (!uri) throw new Error("No URI given for remote editing operation: " + query);
                    // console.log('UpdateManager: sending update to <' + uri + '>')
                    options.noMeta = true;
                    options.contentType = options.contentType || "application/sparql-update";
                    options.body = query;
                    return _this.store.fetcher.webOperation("PATCH", uri, options);
                }).then(function(response) {
                    if (!response.ok) {
                        var _message = "UpdateManager: update failed for <" + uri + "> status=" + response.status + ", " + response.statusText + "\n   for query: " + query;
                        // console.log(message)
                        throw new Error(_message);
                    }
                    // console.log('UpdateManager: update Ok for <' + uri + '>')
                    callbackFunction(uri, response.ok, response.responseText, response);
                }).catch(function(err) {
                    callbackFunction(uri, false, err.message, err);
                });
            }
        },
        {
            key: "update_statement",
            value: function update_statement(statement) {
                if (statement && !statement.graph) return;
                var updater = this;
                var context = this.statementContext(statement);
                return {
                    statement: statement ? [
                        statement.subject,
                        statement.predicate,
                        statement.object,
                        statement.graph
                    ] : undefined,
                    statementNT: statement ? this.anonymizeNT(statement) : undefined,
                    where: updater.contextWhere(context),
                    set_object: function set_object(obj, callbackFunction) {
                        var query = this.where;
                        query += "DELETE DATA { " + this.statementNT + " } ;\n";
                        query += "INSERT DATA { " + // @ts-ignore `this` might refer to the wrong scope. Does this work?
                        this.anonymize(this.statement[0]) + " " + // @ts-ignore
                        this.anonymize(this.statement[1]) + " " + // @ts-ignore
                        this.anonymize(obj) + " " + " . }\n";
                        updater.fire(this.statement[3].value, query, callbackFunction);
                    }
                };
            }
        },
        {
            key: "insert_statement",
            value: function insert_statement(st, callbackFunction) {
                var st0 = st instanceof Array ? st[0] : st;
                var query = this.contextWhere(this.statementContext(st0));
                if (st instanceof Array) {
                    var stText = "";
                    for(var i = 0; i < st.length; i++)stText += st[i] + "\n";
                    query += "INSERT DATA { " + stText + " }\n";
                } else query += "INSERT DATA { " + this.anonymize(st.subject) + " " + this.anonymize(st.predicate) + " " + this.anonymize(st.object) + " " + " . }\n";
                this.fire(st0.graph.value, query, callbackFunction);
            }
        },
        {
            key: "delete_statement",
            value: function delete_statement(st, callbackFunction) {
                var st0 = st instanceof Array ? st[0] : st;
                var query = this.contextWhere(this.statementContext(st0));
                if (st instanceof Array) {
                    var stText = "";
                    for(var i = 0; i < st.length; i++)stText += st[i] + "\n";
                    query += "DELETE DATA { " + stText + " }\n";
                } else query += "DELETE DATA { " + this.anonymize(st.subject) + " " + this.anonymize(st.predicate) + " " + this.anonymize(st.object) + " " + " . }\n";
                this.fire(st0.graph.value, query, callbackFunction);
            }
        },
        {
            key: "requestDownstreamAction",
            value: function requestDownstreamAction(doc, action) {
                var control = this.patchControlFor(doc);
                if (!control.pendingUpstream) action(doc);
                else if (control.downstreamAction) {
                    if ("" + control.downstreamAction !== "" + action) // Kludge compare
                    throw new Error("Can't wait for > 1 different downstream actions");
                } else control.downstreamAction = action;
            }
        },
        {
            key: "clearUpstreamCount",
            value: function clearUpstreamCount(doc) {
                var control = this.patchControlFor(doc);
                control.upstreamCount = 0;
            }
        },
        {
            key: "getUpdatesVia",
            value: function getUpdatesVia(doc) {
                var linkHeaders = this.store.fetcher.getHeader(doc, "updates-via");
                if (!linkHeaders || !linkHeaders.length) return null;
                return linkHeaders[0].trim();
            }
        },
        {
            key: "addDownstreamChangeListener",
            value: function addDownstreamChangeListener(doc, listener) {
                var _this2 = this;
                var control = this.patchControlFor(doc);
                if (!control.downstreamChangeListeners) control.downstreamChangeListeners = [];
                control.downstreamChangeListeners.push(listener);
                this.setRefreshHandler(doc, function(doc) {
                    _this2.reloadAndSync(doc);
                });
            }
        },
        {
            key: "reloadAndSync",
            value: function reloadAndSync(doc) {
                var control = this.patchControlFor(doc);
                var updater = this;
                if (control.reloading) {
                    // console.log('   Already reloading - note this load may be out of date')
                    control.outOfDate = true;
                    return; // once only needed @@ Not true, has changed again
                }
                control.reloading = true;
                var retryTimeout = 1000; // ms
                var tryReload = function tryReload() {
                    // console.log('try reload - timeout = ' + retryTimeout)
                    updater.reload(updater.store, doc, function(ok, message, response) {
                        if (ok) {
                            if (control.downstreamChangeListeners) for(var i = 0; i < control.downstreamChangeListeners.length; i++)// console.log('        Calling downstream listener ' + i)
                            control.downstreamChangeListeners[i]();
                            control.reloading = false;
                            if (control.outOfDate) {
                                // console.log('   Extra reload because of extra update.')
                                control.outOfDate = false;
                                tryReload();
                            }
                        } else {
                            control.reloading = false;
                            if (response.status === 0) {
                                // console.log('Network error refreshing the data. Retrying in ' +
                                // retryTimeout / 1000)
                                control.reloading = true;
                                retryTimeout = retryTimeout * 2;
                                setTimeout(tryReload, retryTimeout);
                            }
                        }
                    });
                };
                tryReload();
            }
        },
        {
            key: "setRefreshHandler",
            value: function setRefreshHandler(doc, handler) {
                var wssURI = this.getUpdatesVia(doc); // relative
                // var kb = this.store
                var theHandler = handler;
                var self = this;
                var updater = this;
                var retryTimeout = 1500; // *2 will be 3 Seconds, 6, 12, etc
                var retries = 0;
                if (!wssURI) // console.log('Server does not support live updates through Updates-Via :-(')
                return false;
                wssURI = (0, $4Q80K.join)(wssURI, doc.value);
                var validWssURI = wssURI.replace(/^http:/, "ws:").replace(/^https:/, "wss:");
                // console.log('Web socket URI ' + wssURI)
                var openWebsocket = function openWebsocket() {
                    // From https://github.com/solid/solid-spec#live-updates
                    var socket;
                    if (typeof WebSocket !== "undefined") socket = new WebSocket(validWssURI);
                    else if (typeof window !== "undefined" && window.WebSocket) socket = window.WebSocket(validWssURI);
                    else // console.log('Live update disabled, as WebSocket not supported by platform :-(')
                    return;
                    socket.onopen = function() {
                        // console.log('    websocket open')
                        retryTimeout = 1500; // reset timeout to fast on success
                        this.send("sub " + doc.value);
                        if (retries) // console.log('Web socket has been down, better check for any news.')
                        updater.requestDownstreamAction(doc, theHandler);
                    };
                    var control = self.patchControlFor(doc);
                    control.upstreamCount = 0;
                    socket.onerror = function onerror(err) {
                    // console.log('Error on Websocket:', err)
                    };
                    // https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent
                    //
                    // 1000  CLOSE_NORMAL  Normal closure; the connection successfully completed whatever purpose for which it was created.
                    // 1001  CLOSE_GOING_AWAY  The endpoint is going away, either
                    //                                  because of a server failure or because the browser is navigating away from the page that opened the connection.
                    // 1002  CLOSE_PROTOCOL_ERROR  The endpoint is terminating the connection due to a protocol error.
                    // 1003  CLOSE_UNSUPPORTED  The connection is being terminated because the endpoint
                    //                                  received data of a type it cannot accept (for example, a text-only endpoint received binary data).
                    // 1004                             Reserved. A meaning might be defined in the future.
                    // 1005  CLOSE_NO_STATUS  Reserved.  Indicates that no status code was provided even though one was expected.
                    // 1006  CLOSE_ABNORMAL  Reserved. Used to indicate that a connection was closed abnormally (
                    //
                    //
                    socket.onclose = function(event) {
                        // console.log('*** Websocket closed with code ' + event.code +
                        //   ", reason '" + event.reason + "' clean = " + event.wasClean)
                        retryTimeout *= 2;
                        retries += 1;
                        // console.log('Retrying in ' + retryTimeout + 'ms') // (ask user?)
                        setTimeout(function() {
                            // console.log('Trying websocket again')
                            openWebsocket();
                        }, retryTimeout);
                    };
                    socket.onmessage = function(msg) {
                        if (msg.data && msg.data.slice(0, 3) === "pub") {
                            if ("upstreamCount" in control) {
                                control.upstreamCount -= 1;
                                if (control.upstreamCount >= 0) // console.log('just an echo: ' + control.upstreamCount)
                                return; // Just an echo
                            }
                            // console.log('Assume a real downstream change: ' + control.upstreamCount + ' -> 0')
                            control.upstreamCount = 0;
                            self.requestDownstreamAction(doc, theHandler);
                        }
                    };
                }; // openWebsocket
                openWebsocket();
                return true;
            }
        },
        {
            key: "updateMany",
            value: function updateMany(deletions) {
                var insertions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var docs = deletions.concat(insertions).map(function(st) {
                    return st.why;
                });
                var thisUpdater = this;
                var uniqueDocs = [];
                docs.forEach(function(doc) {
                    if (!uniqueDocs.find(function(uniqueDoc) {
                        return uniqueDoc.equals(doc);
                    })) uniqueDocs.push(doc);
                });
                var updates = uniqueDocs.map(function(doc) {
                    return thisUpdater.update(deletions.filter(function(st) {
                        return st.why.equals(doc);
                    }), insertions.filter(function(st) {
                        return st.why.equals(doc);
                    }));
                });
                updates.length;
                return Promise.all(updates);
            }
        },
        {
            key: "constructSparqlUpdateQuery",
            value: function constructSparqlUpdateQuery(ds, is, bnodes_context) {
                var whereClause = this.contextWhere(bnodes_context);
                var query = "";
                if (whereClause.length) {
                    // Is there a WHERE clause?
                    if (ds.length) {
                        query += "DELETE { ";
                        for(var i = 0; i < ds.length; i++)query += this.anonymizeNT(ds[i]) + "\n";
                        query += " }\n";
                    }
                    if (is.length) {
                        query += "INSERT { ";
                        for(var _i5 = 0; _i5 < is.length; _i5++)query += this.anonymizeNT(is[_i5]) + "\n";
                        query += " }\n";
                    }
                    query += whereClause;
                } else {
                    // no where clause
                    if (ds.length) {
                        query += "DELETE DATA { ";
                        for(var _i6 = 0; _i6 < ds.length; _i6++)query += this.anonymizeNT(ds[_i6]) + "\n";
                        query += " } \n";
                    }
                    if (is.length) {
                        if (ds.length) query += " ; ";
                        query += "INSERT DATA { ";
                        for(var _i7 = 0; _i7 < is.length; _i7++)query += this.nTriples(is[_i7]) + "\n";
                        query += " }\n";
                    }
                }
                return query;
            }
        },
        {
            key: "constructN3PatchQuery",
            value: function constructN3PatchQuery(ds, is, bnodes_context) {
                var _this3 = this;
                var query = "\n@prefix solid: <http://www.w3.org/ns/solid/terms#>.\n@prefix ex: <http://www.example.org/terms#>.\n\n_:patch\n";
                // If bnode context is non trivial, express it as ?conditions formula.
                if (bnodes_context && bnodes_context.length > 0) query += "\n      solid:where {\n        ".concat(bnodes_context.map(function(x) {
                    return _this3.anonymizeNT(x);
                }).join("\n        "), "\n      };");
                if (ds.length > 0) query += "\n      solid:deletes {\n        ".concat(ds.map(function(x) {
                    return _this3.anonymizeNT(x);
                }).join("\n        "), "\n      };");
                if (is.length > 0) query += "\n      solid:inserts {\n        ".concat(is.map(function(x) {
                    return _this3.anonymizeNT(x);
                }).join("\n        "), "\n      };");
                query += "   a solid:InsertDeletePatch .\n";
                return query;
            }
        },
        {
            key: "update",
            value: function update(deletions, insertions, callback, secondTry) {
                var _this4 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                if (!callback) {
                    var thisUpdater = this;
                    return new Promise(function(resolve, reject) {
                        // Promise version
                        thisUpdater.update(deletions, insertions, function(uri, ok, errorBody) {
                            if (!ok) reject(new Error(errorBody));
                            else resolve();
                        }, secondTry, options); // callbackFunction
                    }); // promise
                } // if
                try {
                    var kb = this.store;
                    var ds = !deletions ? [] : (0, $gCJkd.isStore)(deletions) ? deletions.statements : deletions instanceof Array ? deletions : [
                        deletions
                    ];
                    var is = !insertions ? [] : (0, $gCJkd.isStore)(insertions) ? insertions.statements : insertions instanceof Array ? insertions : [
                        insertions
                    ];
                    if (!(ds instanceof Array)) throw new Error("Type Error " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(ds) + ": " + ds);
                    if (!(is instanceof Array)) throw new Error("Type Error " + (0, (/*@__PURE__*/$parcel$interopDefault($41YNz)))(is) + ": " + is);
                    if (ds.length === 0 && is.length === 0) return callback(null, true); // success -- nothing needed to be done.
                    var doc = ds.length ? ds[0].graph : is[0].graph;
                    if (!doc) {
                        var _message2 = "Error patching: statement does not specify which document to patch:" + ds[0] + ", " + is[0];
                        // console.log(message)
                        throw new Error(_message2);
                    }
                    if (doc.termType !== "NamedNode") {
                        var _message3 = "Error patching: document not a NamedNode:" + ds[0] + ", " + is[0];
                        // console.log(message)
                        throw new Error(_message3);
                    }
                    var control = this.patchControlFor(doc);
                    var startTime = Date.now();
                    var props = [
                        "subject",
                        "predicate",
                        "object",
                        "why"
                    ];
                    var verbs = [
                        "insert",
                        "delete"
                    ];
                    var clauses = {
                        "delete": ds,
                        "insert": is
                    };
                    verbs.map(function(verb) {
                        clauses[verb].map(function(st) {
                            if (!doc.equals(st.graph)) throw new Error("update: destination " + doc + " inconsistent with delete quad " + st.graph);
                            props.map(function(prop) {
                                if (typeof st[prop] === "undefined") throw new Error("update: undefined " + prop + " of statement.");
                            });
                        });
                    });
                    var protocol = this.editable(doc.value, kb);
                    if (protocol === false) throw new Error("Update: Can't make changes in uneditable " + doc);
                    if (protocol === undefined) {
                        // Not enough metadata
                        if (secondTry) throw new Error("Update: Loaded " + doc + "but still can't figure out what editing protocol it supports.");
                        // console.log(`Update: have not loaded ${doc} before: loading now...`);
                        this.store.fetcher.load(doc).then(function(response) {
                            _this4.update(deletions, insertions, callback, true, options);
                        }, function(err) {
                            if (err.response.status === 404) // nonexistent files are fine
                            _this4.update(deletions, insertions, callback, true, options);
                            else throw new Error("Update: Can't get updatability status ".concat(doc, " before patching: ").concat(err));
                        });
                        return;
                    } else if (protocol.indexOf("SPARQL") >= 0 || protocol.indexOf("N3PATCH") >= 0) {
                        var isSparql = protocol.indexOf("SPARQL") >= 0;
                        var bnodes = [];
                        // change ReadOnly type to Mutable type
                        if (ds.length) bnodes = this.statementArrayBnodes(ds);
                        if (is.length) bnodes = bnodes.concat(this.statementArrayBnodes(is));
                        var context = this.bnodeContext(bnodes, doc);
                        var query = isSparql ? this.constructSparqlUpdateQuery(ds, is, context) : this.constructN3PatchQuery(ds, is, context);
                        options.contentType = isSparql ? "application/sparql-update" : "text/n3";
                        // Track pending upstream patches until they have finished their callbackFunction
                        control.pendingUpstream = control.pendingUpstream ? control.pendingUpstream + 1 : 1;
                        if ("upstreamCount" in control) control.upstreamCount += 1; // count changes we originated ourselves
                        this.fire(doc.value, query, function(uri, success, body, response) {
                            response.elapsedTimeMs = Date.now() - startTime;
                            /* console.log('    UpdateManager: Return ' +
              (success ? 'success ' : 'FAILURE ') + (response as Response).status +
              ' elapsed ' + (response as any).elapsedTimeMs + 'ms')
              */ if (success) {
                                try {
                                    kb.remove(ds);
                                } catch (e) {
                                    success = false;
                                    body = "Remote Ok BUT error deleting " + ds.length + " from store!!! " + e;
                                } // Add in any case -- help recover from weirdness??
                                for(var i = 0; i < is.length; i++)kb.add(is[i].subject, is[i].predicate, is[i].object, doc);
                            }
                            callback(uri, success, body, response);
                            control.pendingUpstream -= 1;
                            // When upstream patches have been sent, reload state if downstream waiting
                            if (control.pendingUpstream === 0 && control.downstreamAction) {
                                var downstreamAction = control.downstreamAction;
                                delete control.downstreamAction;
                                // console.log('delayed downstream action:')
                                downstreamAction(doc);
                            }
                        }, options);
                    } else if (protocol.indexOf("DAV") >= 0) this.updateDav(doc, ds, is, callback, options);
                    else {
                        if (protocol.indexOf("LOCALFILE") >= 0) try {
                            this.updateLocalFile(doc, ds, is, callback, options);
                        } catch (e) {
                            callback(doc.value, false, "Exception trying to write back file <" + doc.value + ">\n");
                        }
                        else throw new Error("Unhandled edit method: '" + protocol + "' for " + doc);
                    }
                } catch (e) {
                    callback(undefined, false, "Exception in update: " + e + "\n" + $23fob.stackString(e));
                }
            }
        },
        {
            key: "updateDav",
            value: function updateDav(doc, ds, is, callbackFunction) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var kb = this.store;
                // The code below is derived from Kenny's UpdateCenter.js
                var request = kb.any(doc, this.ns.link("request"));
                if (!request) throw new Error("No record of our HTTP GET request for document: " + doc);
                 // should not happen
                var response = kb.any(request, this.ns.link("response"));
                if (!response) return null; // throw "No record HTTP GET response for document: "+doc
                var contentType = kb.the(response, this.ns.httph("content-type")).value;
                // prepare contents of revised document
                var newSts = kb.statementsMatching(undefined, undefined, undefined, doc).slice(); // copy!
                for(var i = 0; i < ds.length; i++)$23fob.RDFArrayRemove(newSts, ds[i]);
                for(var _i8 = 0; _i8 < is.length; _i8++)newSts.push(is[_i8]);
                var documentString = this.serialize(doc.value, newSts, contentType);
                // Write the new version back
                var candidateTarget = kb.the(response, this.ns.httph("content-location"));
                var targetURI;
                if (candidateTarget) targetURI = (0, $4Q80K.join)(candidateTarget.value, targetURI);
                options.contentType = contentType;
                options.noMeta = true;
                options.body = documentString;
                return kb.fetcher.webOperation("PUT", targetURI, options).then(function(response) {
                    if (!response.ok) throw new Error(response.error);
                    for(var _i9 = 0; _i9 < ds.length; _i9++)kb.remove(ds[_i9]);
                    for(var _i10 = 0; _i10 < is.length; _i10++)kb.add(is[_i10].subject, is[_i10].predicate, is[_i10].object, doc);
                    callbackFunction(doc.value, response.ok, response.responseText, response);
                }).catch(function(err) {
                    callbackFunction(doc.value, false, err.message, err);
                });
            }
        },
        {
            key: "updateLocalFile",
            value: function updateLocalFile(doc, ds, is, callbackFunction) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var kb = this.store;
                // console.log('Writing back to local file\n')
                // prepare contents of revised document
                var newSts = kb.statementsMatching(undefined, undefined, undefined, doc).slice(); // copy!
                for(var i = 0; i < ds.length; i++)$23fob.RDFArrayRemove(newSts, ds[i]);
                for(var _i11 = 0; _i11 < is.length; _i11++)newSts.push(is[_i11]);
                // serialize to the appropriate format
                var dot = doc.value.lastIndexOf(".");
                if (dot < 1) throw new Error("Rewriting file: No filename extension: " + doc.value);
                var ext = doc.value.slice(dot + 1);
                var contentType = (0, $1d9128915acc42fc$export$2e2bcd8739ae039).CONTENT_TYPE_BY_EXT[ext];
                if (!contentType) throw new Error("File extension ." + ext + " not supported for data write");
                options.body = this.serialize(doc.value, newSts, contentType);
                options.contentType = contentType;
                kb.fetcher.webOperation("PUT", doc.value, options).then(function(response) {
                    if (!response.ok) return callbackFunction(doc.value, false, response.error);
                    for(var _i12 = 0; _i12 < ds.length; _i12++)kb.remove(ds[_i12]);
                    for(var _i13 = 0; _i13 < is.length; _i13++)kb.add(is[_i13].subject, is[_i13].predicate, is[_i13].object, doc);
                    callbackFunction(doc.value, true, ""); // success!
                });
            }
        },
        {
            key: "serialize",
            value: function serialize(uri, data, contentType) {
                var kb = this.store;
                var documentString;
                if (typeof data === "string") return data;
                // serialize to the appropriate format
                var sz = (0, $f832e5387e149401$export$2e2bcd8739ae039)(kb);
                sz.suggestNamespaces(kb.namespaces);
                sz.setBase(uri);
                switch(contentType){
                    case "text/xml":
                    case "application/rdf+xml":
                        documentString = sz.statementsToXML(data);
                        break;
                    case "text/n3":
                    case "text/turtle":
                    case "application/x-turtle":
                    case "application/n3":
                        // Legacy
                        documentString = sz.statementsToN3(data);
                        break;
                    default:
                        throw new Error("Content-type " + contentType + " not supported for data serialization");
                }
                return documentString;
            }
        },
        {
            key: "put",
            value: function put(doc, data, contentType, callback) {
                var _this5 = this;
                var kb = this.store;
                var documentString;
                return Promise.resolve().then(function() {
                    documentString = _this5.serialize(doc.value, data, contentType);
                    return kb.fetcher.webOperation("PUT", doc.value, {
                        contentType: contentType,
                        body: documentString
                    });
                }).then(function(response) {
                    if (!response.ok) return callback(doc.value, response.ok, response.error, response);
                    delete kb.fetcher.nonexistent[doc.value];
                    delete kb.fetcher.requested[doc.value]; // @@ could this mess with the requested state machine? if a fetch is in progress
                    if (typeof data !== "string") data.map(function(st) {
                        kb.addStatement(st);
                    });
                    callback(doc.value, response.ok, "", response);
                }).catch(function(err) {
                    callback(doc.value, false, err.message);
                });
            }
        },
        {
            key: "reload",
            value: function reload(kb, doc, callbackFunction) {
                var startTime = Date.now();
                // force sets no-cache and
                var options = {
                    force: true,
                    noMeta: true,
                    clearPreviousData: true
                };
                kb.fetcher.nowOrWhenFetched(doc.value, options, function(ok, body, response) {
                    if (!ok) // console.log('    ERROR reloading data: ' + body)
                    callbackFunction(false, "Error reloading data: " + body, response);
                    else if (response.onErrorWasCalled || response.status !== 200) // console.log('    Non-HTTP error reloading data! onErrorWasCalled=' +
                    //@ts-ignore Where does onErrorWasCalled come from?
                    // response.onErrorWasCalled + ' status: ' + response.status)
                    callbackFunction(false, "Non-HTTP error reloading data: " + body, response);
                    else {
                        var elapsedTimeMs = Date.now() - startTime;
                        if (!doc.reloadTimeTotal) doc.reloadTimeTotal = 0;
                        if (!doc.reloadTimeCount) doc.reloadTimeCount = 0;
                        doc.reloadTimeTotal += elapsedTimeMs;
                        doc.reloadTimeCount += 1;
                        // console.log('    Fetch took ' + elapsedTimeMs + 'ms, av. of ' +
                        // doc.reloadTimeCount + ' = ' +
                        // (doc.reloadTimeTotal / doc.reloadTimeCount) + 'ms.')
                        callbackFunction(true);
                    }
                });
            }
        }
    ]);
    return UpdateManager;
}();







var $g5Zhu = parcelRequire("g5Zhu");



function $eb05007f91aa13a9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $eb05007f91aa13a9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $eb05007f91aa13a9$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $eb05007f91aa13a9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/** Full RDFLib.js Data Factory */ var $eb05007f91aa13a9$var$RDFlibDataFactory = $eb05007f91aa13a9$var$_objectSpread($eb05007f91aa13a9$var$_objectSpread({}, (0, $2b3711697846728e$export$2e2bcd8739ae039)), {}, {
    /**
   * Creates a new fetcher
   * @param store - The store to use
   * @param options - The options
   */ fetcher: function fetcher(store, options) {
        return new (0, $1d9128915acc42fc$export$2e2bcd8739ae039)(store, options);
    },
    /**
   * Creates a new graph (store)
   */ graph: function graph() {
        var features = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
        return new (0, $6f5c135260474402$export$2e2bcd8739ae039)(features, opts || {
            rdfFactory: (0, $2b3711697846728e$export$2e2bcd8739ae039)
        });
    },
    /**
   * Creates a new literal node
   * @param val The lexical value
   * @param lang The language
   * @param dt The datatype
   */ lit: function lit(val, lang, dt) {
        return this.literal("" + val, lang || dt);
    },
    /**
   * Creates a new statement
   * @param subject The subject
   * @param predicate The predicate
   * @param object The object
   * @param graph The containing graph
   */ st: function st(subject, predicate, object, graph) {
        return this.quad(subject, predicate, object, graph);
    }
});
var $eb05007f91aa13a9$export$2e2bcd8739ae039 = $eb05007f91aa13a9$var$RDFlibDataFactory;


parcelRequire("gCJkd");

function $6f0137736d5eb798$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6f0137736d5eb798$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($cGTaw)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eN9hz)))(this, result);
    };
}
function $6f0137736d5eb798$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
// Prepare bound versions of data factory methods for export
var $6f0137736d5eb798$var$boundDataFactory = {};
for(var $6f0137736d5eb798$var$name in 0, $eb05007f91aa13a9$export$2e2bcd8739ae039)if (typeof (0, $eb05007f91aa13a9$export$2e2bcd8739ae039)[$6f0137736d5eb798$var$name] === "function") $6f0137736d5eb798$var$boundDataFactory[$6f0137736d5eb798$var$name] = (0, $eb05007f91aa13a9$export$2e2bcd8739ae039)[$6f0137736d5eb798$var$name].bind((0, $eb05007f91aa13a9$export$2e2bcd8739ae039));
var $6f0137736d5eb798$export$47fdd40111eda34c = $6f0137736d5eb798$var$boundDataFactory.fetcher, $6f0137736d5eb798$export$3d344a3806285c2 = $6f0137736d5eb798$var$boundDataFactory.graph, $6f0137736d5eb798$export$f9c0624c04b6af9f = $6f0137736d5eb798$var$boundDataFactory.lit, $6f0137736d5eb798$export$8692ddd9f3fb5f5d = $6f0137736d5eb798$var$boundDataFactory.st, $6f0137736d5eb798$export$fe4bf738d66b6b12 = $6f0137736d5eb798$var$boundDataFactory.namedNode, $6f0137736d5eb798$export$3a9d57cefcd2c285 = $6f0137736d5eb798$var$boundDataFactory.variable, $6f0137736d5eb798$export$54639f27c75f330c = $6f0137736d5eb798$var$boundDataFactory.blankNode, $6f0137736d5eb798$export$d3dde9fdaf372e40 = $6f0137736d5eb798$var$boundDataFactory.defaultGraph, $6f0137736d5eb798$export$c8ec6e1ec9fefcb0 = $6f0137736d5eb798$var$boundDataFactory.literal, $6f0137736d5eb798$export$9fc5786234c4f1e = $6f0137736d5eb798$var$boundDataFactory.quad, $6f0137736d5eb798$export$515818ff8d37c07d = $6f0137736d5eb798$var$boundDataFactory.triple;
var $6f0137736d5eb798$var$formula = new (0, $31157af6e1e82257$export$2e2bcd8739ae039)();
var $6f0137736d5eb798$export$b66615c92119fc20 = function fromNT(str) {
    return $6f0137736d5eb798$var$formula.fromNT(str);
};
var $6f0137736d5eb798$export$be3eabeed0f5400e = (0, $e01338ed2499626a$export$2e2bcd8739ae039).fromValue;
// TODO: this export is broken;
// it exports the _current_ value of nextId, which is always 0
var $6f0137736d5eb798$export$ad5ce394e01d3081 = (0, $d0a63e5194c4f691$export$2e2bcd8739ae039).nextId;
var $6f0137736d5eb798$export$d778a5b158cf3099 = /*#__PURE__*/ function(_Store) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ConnectedStore, _Store);
    var _super = $6f0137736d5eb798$var$_createSuper(ConnectedStore);
    function ConnectedStore(features) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ConnectedStore);
        _this = _super.call(this, features);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), "fetcher", void 0);
        _this.fetcher = new (0, $1d9128915acc42fc$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this), {});
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ConnectedStore);
}((0, $6f5c135260474402$export$2e2bcd8739ae039));
var $6f0137736d5eb798$export$385ff6920702c0f2 = /*#__PURE__*/ function(_ConnectedStore) {
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(LiveStore, _ConnectedStore);
    var _super2 = $6f0137736d5eb798$var$_createSuper(LiveStore);
    function LiveStore(features) {
        var _this2;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, LiveStore);
        _this2 = _super2.call(this, features);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this2), "updater", void 0);
        _this2.updater = new (0, $f8539385ca2d21cc$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this2));
        return _this2;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(LiveStore);
}($6f0137736d5eb798$export$d778a5b158cf3099);


var $gCJkd = parcelRequire("gCJkd");
var $9043c565d33eb642$exports = {};
// queueMicrotask shim

var $6ZWSX = parcelRequire("6ZWSX");
var $9043c565d33eb642$require$Buffer = $6ZWSX.Buffer;
// not defined or not a function
if ("function" !== typeof queueMicrotask) {
    // create resolved promise
    let dp_resolve = Promise.resolve();
    // try to redefine
    try {
        // eslint-disable-next-line no-global-assign
        queueMicrotask = (fk)=>dp_resolve.then(fk).catch((e_callback)=>setTimeout(()=>{
                    throw e_callback;
                }, 0));
    } // oh well, at least we tried
    catch (e_define) {}
}
var $1a8051d506d618be$exports = {};
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory($1a8051d506d618be$exports);
})($1a8051d506d618be$exports, function(exports1) {
    "use strict";
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join("");
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = "-"; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1("invalid-input");
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1("overflow");
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1("overflow");
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1("overflow");
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ "version": "2.1.0",
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: "null"
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === "boolean") {
                wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== "/" ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



var $eNRCS = parcelRequire("eNRCS");
var $141f1697ab3cba12$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $141f1697ab3cba12$require$Buffer = $6ZWSX.Buffer;

var $hPtJY = parcelRequire("hPtJY");

var $b6RFW = parcelRequire("b6RFW");
class $141f1697ab3cba12$var$Readable extends $b6RFW.Readable {
    constructor(gc_readable = {}){
        super(gc_readable);
        // use iterator
        if (gc_readable.iterator) throw new Error("readable stream iterator shortcut not yet implemented");
    }
    until(s_event, b_return_stream) {
        return new Promise((fk_until, fe_until)=>{
            // convert error to rejected promise
            this.on("error", (e_stream)=>{
                fe_until(e_stream);
            });
            // special cases returns `this`
            if (b_return_stream) this.once(s_event, (...a_args)=>{
                fk_until(this, ...a_args);
            });
            else this.once(s_event, fk_until);
        });
    }
    bucket(s_encoding = "utf8") {
        let g_readable = this._readableState;
        // object mode
        if (g_readable.objectMode) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let a_data = [];
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                write (w_event, s_write_encoding, fk_write) {
                    a_data.push(w_event);
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    a_data.push(...a_chunks);
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(a_data);
            });
        });
        else if ("utf8" === s_encoding || "utf-8" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let s_data = "";
            // set encoding
            this.setEncoding(s_encoding);
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                decodeStrings: false,
                write (s_chunk, s_write_encoding, fk_write) {
                    s_data += s_chunk;
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    s_data += a_chunks.join("");
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(s_data);
            });
        });
        else if ("buffer" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let ab_data = $141f1697ab3cba12$require$Buffer.from([]);
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                decodeStrings: true,
                write (ab_chunk, s_write_encoding, fk_write) {
                    ab_data = $141f1697ab3cba12$require$Buffer.concat([
                        ab_data,
                        ab_chunk
                    ], ab_data.length + ab_chunk.length);
                    fk_write();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(ab_data);
            });
        });
    }
}
class $141f1697ab3cba12$var$Writable extends $b6RFW.Writable {
    until(s_event, b_return_stream) {
        return new Promise((fk_until, fe_until)=>{
            // convert error to rejected promise
            this.on("error", (e_stream)=>{
                fe_until(e_stream);
            });
            // special cases returns `this`
            if (b_return_stream) this.once(s_event, (...a_args)=>{
                fk_until(this, ...a_args);
            });
            else this.once(s_event, fk_until);
        });
    }
    // rdfjs impl
    import(ds_source) {
        ds_source.on("data", (w_chunk)=>this.write(w_chunk)).on("end", ()=>this.end()).on("error", (e_read)=>this.emit("error", e_read));
        return this;
    }
}
class $141f1697ab3cba12$var$Duplex extends $b6RFW.Duplex {
    until(s_event, b_return_stream) {
        return new Promise((fk_until, fe_until)=>{
            // convert error to rejected promise
            this.on("error", (e_stream)=>{
                fe_until(e_stream);
            });
            // special cases returns `this`
            if (b_return_stream) this.once(s_event, (...a_args)=>{
                fk_until(this, ...a_args);
            });
            else this.once(s_event, fk_until);
        });
    }
    bucket(s_encoding = "utf8") {
        let g_readable = this._readableState;
        // object mode
        if (g_readable.objectMode) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let a_data = [];
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                write (w_event, s_write_encoding, fk_write) {
                    a_data.push(w_event);
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    a_data.push(...a_chunks);
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(a_data);
            });
        });
        else if ("utf8" === s_encoding || "utf-8" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let s_data = "";
            // set encoding
            this.setEncoding(s_encoding);
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                decodeStrings: false,
                write (s_chunk, s_write_encoding, fk_write) {
                    s_data += s_chunk;
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    s_data += a_chunks.join("");
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(s_data);
            });
        });
        else if ("buffer" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let ab_data = $141f1697ab3cba12$require$Buffer.from([]);
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                decodeStrings: true,
                write (ab_chunk, s_write_encoding, fk_write) {
                    ab_data = $141f1697ab3cba12$require$Buffer.concat([
                        ab_data,
                        ab_chunk
                    ], ab_data.length + ab_chunk.length);
                    fk_write();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(ab_data);
            });
        });
    }
}
class $141f1697ab3cba12$var$Transform extends $b6RFW.Transform {
    until(s_event, b_return_stream) {
        return new Promise((fk_until, fe_until)=>{
            // convert error to rejected promise
            this.on("error", (e_stream)=>{
                fe_until(e_stream);
            });
            // special cases returns `this`
            if (b_return_stream) this.once(s_event, (...a_args)=>{
                fk_until(this, ...a_args);
            });
            else this.once(s_event, fk_until);
        });
    }
    bucket(s_encoding = "utf8") {
        let g_readable = this._readableState;
        // object mode
        if (g_readable.objectMode) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let a_data = [];
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                write (w_event, s_write_encoding, fk_write) {
                    a_data.push(w_event);
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    a_data.push(...a_chunks);
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(a_data);
            });
        });
        else if ("utf8" === s_encoding || "utf-8" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let s_data = "";
            // set encoding
            this.setEncoding(s_encoding);
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                decodeStrings: false,
                write (s_chunk, s_write_encoding, fk_write) {
                    s_data += s_chunk;
                    fk_write();
                },
                writev (a_chunks, fk_writev) {
                    s_data += a_chunks.join("");
                    fk_writev();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(s_data);
            });
        });
        else if ("buffer" === s_encoding) // async operation
        return new Promise((fk_bucket, fe_bucket)=>{
            let ab_data = $141f1697ab3cba12$require$Buffer.from([]);
            // pipe to writable
            this.pipe(new $b6RFW.Writable({
                decodeStrings: true,
                write (ab_chunk, s_write_encoding, fk_write) {
                    ab_data = $141f1697ab3cba12$require$Buffer.concat([
                        ab_data,
                        ab_chunk
                    ], ab_data.length + ab_chunk.length);
                    fk_write();
                }
            }))// error
            .on("error", (e_stream)=>{
                fe_bucket(e_stream);
            })// wait for it to finish
            .on("finish", ()=>{
                fk_bucket(ab_data);
            });
        });
    }
    // rdfjs impl
    import(ds_source) {
        ds_source.on("data", (w_chunk)=>this.write(w_chunk)).on("end", ()=>this.end()).on("error", (e_read)=>this.emit("error", e_read));
        return this;
    }
    demolish(e_destroy) {
        // do not allow to push
        this.push = (z_chunk)=>{
            // ignore eof signals from node core
            if (null === z_chunk) return;
            // anything else is bad
            throw new Error(`[ERR_STREAM_DESTROYED]: Cannot push after stream was destroyed`);
        };
        // do not allow to emit 'end'
        this.emit = function(s_event, ...a_args) {
            if ("end" === s_event) return;
            Object.getPrototypeOf(this).emit.apply(this, [
                s_event,
                ...a_args
            ]);
        };
        // an error was given, destroy the stream as well
        if (e_destroy) return $b6RFW.Transform.prototype.destroy.call(this, e_destroy);
    }
}
// eslint-disable-next-line no-new-func
const $141f1697ab3cba12$var$b_is_node = new Function(/* syntax: js */ `try {return this===global;}catch(e){return false;}`)();
// deduce the runtime environment
const [$141f1697ab3cba12$var$B_BROWSER, $141f1697ab3cba12$var$B_BROWSERIFY] = (()=>"undefined" === typeof $hPtJY ? [
        true,
        false
    ] : [
        true,
        true
    ])();
// node.js or browserify; patch for node < v10
if ($141f1697ab3cba12$var$B_BROWSERIFY || $141f1697ab3cba12$var$b_is_node && +/^v(\d+)/.exec($hPtJY.version)[1] < 10) {
    // override destroy methods
    $141f1697ab3cba12$var$Transform.prototype.destroy = $141f1697ab3cba12$var$Duplex.prototype.destroy = function(e_destroy, fke_destroy) {
        this._readableState.destroyed = true;
        this._writableState.destroyed = true;
        let f_emit_close = ()=>{
            if (!this._writableState.emitClose) return;
            if (!this._readableState.emitClose) return;
            this.emit("close");
        };
        this._destroy(e_destroy || null, (e_destroy_re)=>{
            if (!fke_destroy && e_destroy_re) {
                $hPtJY.nextTick(()=>{
                    this.emit("error", e_destroy_re);
                    f_emit_close();
                });
                this._writableState.errorEmitted = true;
            } else {
                $hPtJY.nextTick(f_emit_close);
                if (fke_destroy) fke_destroy(e_destroy_re);
            }
        });
        return this;
    };
    // override default _destroy implementations
    $141f1697ab3cba12$var$Transform.prototype._destroy = $141f1697ab3cba12$var$Duplex.prototype._destroy = (e_destroy, fke_destroy)=>fke_destroy(e_destroy);
}
class $141f1697ab3cba12$var$QuadsToOther extends $141f1697ab3cba12$var$Transform {
    constructor(gc_transform = {}){
        super({
            ...gc_transform,
            writableObjectMode: true,
            readableObjectMode: true
        });
        this._as_inputs = new Set();
        // forward prefix and comment events
        this.on("pipe", (ds_src)=>{
            this._as_inputs.add(ds_src);
            ds_src.on("prefix", (...a_args)=>{
                this.emit("prefix", ...a_args);
            }).on("comment", (...a_args)=>{
                this.emit("comment", ...a_args);
            });
        });
        this.on("unpipe", (ds_src)=>{
            this._as_inputs.delete(ds_src);
        });
    }
    _destroy() {
        for (let ds_input of this._as_inputs)ds_input.destroy();
    }
}
class $141f1697ab3cba12$var$Quads_To_JSON_Transform extends $141f1697ab3cba12$var$QuadsToOther {
    // serializse json
    _transform(g_quad, s_encoding, fk_transform) {
        fk_transform(null, JSON.stringify(g_quad.isolate()) + "\n");
    }
}
class $141f1697ab3cba12$var$Quads_To_Writable extends $141f1697ab3cba12$var$QuadsToOther {
    _transform(g_quad, s_encoding, fk_transform) {
        fk_transform(null, {
            type: "quad",
            value: g_quad
        });
    }
}
$141f1697ab3cba12$var$Transform.QuadsToOther = $141f1697ab3cba12$var$QuadsToOther;
$141f1697ab3cba12$exports = {
    ...$b6RFW,
    Readable: $141f1697ab3cba12$var$Readable,
    Writable: $141f1697ab3cba12$var$Writable,
    Duplex: $141f1697ab3cba12$var$Duplex,
    Transform: $141f1697ab3cba12$var$Transform,
    QuadsToOther: $141f1697ab3cba12$var$QuadsToOther,
    // create a transform from quad objects into JSON strings for trivial serialization
    quads_to_json () {
        return new $141f1697ab3cba12$var$Quads_To_JSON_Transform();
    },
    // create a transform from quad objects into writable data events
    quads_to_writable () {
        return new $141f1697ab3cba12$var$Quads_To_Writable();
    },
    // create a simple, single-event readable stream
    source (w_push, s_encoding = null) {
        // encoding not explicit, string given; assume utf8
        if (!s_encoding && "string" === typeof w_push) s_encoding = "utf8";
        // readable
        return new $141f1697ab3cba12$var$Readable({
            objectMode: !s_encoding && "string" !== typeof w_push && !$141f1697ab3cba12$require$Buffer.isBuffer(w_push),
            read () {
                this.push(w_push, s_encoding);
                this.push(null);
            }
        });
    }
};


var $266825253b7f24dc$exports = {};
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));
var $aaef572789dc684d$exports = {};
"use strict";

$aaef572789dc684d$exports = (parcelRequire("6swAi"));


var $44edd02a6be448cd$var$algoKeys = Object.keys($aaef572789dc684d$exports);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;
var $f85287bc79724838$exports = {};

var $26nOC = parcelRequire("26nOC");
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));



var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede3": $675eb908dbde2e68$export$947646e34766044f,
    "des-ede-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede": $675eb908dbde2e68$export$947646e34766044f,
    "des-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$cc8859615686b300),
    "des-ecb": $675eb908dbde2e68$export$cc8859615686b300
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
$f85287bc79724838$exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};



var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");
var $0649907c0434f982$exports = {};

$parcel$export($0649907c0434f982$exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export($0649907c0434f982$exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export($0649907c0434f982$exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export($0649907c0434f982$exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export($0649907c0434f982$exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export($0649907c0434f982$exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export($0649907c0434f982$exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export($0649907c0434f982$exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($0649907c0434f982$exports).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;


$44edd02a6be448cd$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$export$26e5786e8ac8e530;
$44edd02a6be448cd$export$bdd223f16383713e = $a97f913e2ff95e3b$export$bdd223f16383713e;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$export$20533d26f07f1ee0;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
$44edd02a6be448cd$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$12ada9414fbc594c;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$36b6d6ef312eab39;
$44edd02a6be448cd$export$58a258485f1e49f6 = $a97f913e2ff95e3b$export$58a258485f1e49f6;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;
var $7f34ba2fa9025258$exports = {};

var $hkN9y = parcelRequire("hkN9y");
$7f34ba2fa9025258$exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);
var $bac5f004a90de4c6$exports = {};

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
$bac5f004a90de4c6$exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $7f34ba2fa9025258$var$millerRabin = new $bac5f004a90de4c6$exports();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}


var $f0f71b0d846b32d7$exports = {};
$f0f71b0d846b32d7$exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');


var $8911d62d5514749e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $8911d62d5514749e$var$millerRabin = new $bac5f004a90de4c6$exports();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);


var $hkN9y = parcelRequire("hkN9y");
$8911d62d5514749e$exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$7f34ba2fa9025258$exports.simpleSieve || !$7f34ba2fa9025258$exports.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].gen, "hex");
    return new $8911d62d5514749e$exports(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $8911d62d5514749e$exports($7f34ba2fa9025258$exports(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $8911d62d5514749e$exports(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;


$44edd02a6be448cd$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$971862a2fcb1bb40;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
$44edd02a6be448cd$export$fdc27893e98845cc = $4387b1fafb8a1868$export$fdc27893e98845cc;
$44edd02a6be448cd$export$6671fb9a1323bed = $4387b1fafb8a1868$export$6671fb9a1323bed;
$44edd02a6be448cd$export$d74daf141a551db = $4387b1fafb8a1868$export$d74daf141a551db;
var $3550302076d9e62e$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");
var $4d6db7c28d99f640$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");
var $7fcf61ce5a538063$exports = {};
$7fcf61ce5a538063$exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');


var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $7fcf61ce5a538063$exports[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
$4d6db7c28d99f640$exports = $4d6db7c28d99f640$var$sign;
$4d6db7c28d99f640$exports.getKey = $4d6db7c28d99f640$var$getKey;
$4d6db7c28d99f640$exports.makeKey = $4d6db7c28d99f640$var$makeKey;


var $b885ed4272d45f84$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $7fcf61ce5a538063$exports[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
$b885ed4272d45f84$exports = $b885ed4272d45f84$var$verify;



var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $4d6db7c28d99f640$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $b885ed4272d45f84$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
$3550302076d9e62e$exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};


$44edd02a6be448cd$export$45df7cae684751af = $3550302076d9e62e$exports.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $3550302076d9e62e$exports.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $3550302076d9e62e$exports.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $3550302076d9e62e$exports.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};


$44edd02a6be448cd$export$512823e338ddb1b7 = $b7e0a6843ffae451$export$512823e338ddb1b7;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
$44edd02a6be448cd$export$b9d55ff329113abd = $b7e0a6843ffae451$export$b9d55ff329113abd;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}


$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
$44edd02a6be448cd$export$2f7171e78e524d5e = $8c5943302864e9a5$export$2f7171e78e524d5e;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};


const $266825253b7f24dc$var$R_INVALID_IRIREF = /([\x00-\x20<>"{}|^`\\]|%(?![0-9A-F][0-9A-F]))/g;
const $266825253b7f24dc$var$F_REPLACE_INVALID_IRIREF = (s_, s_v)=>{
    let s_code = s_v.codePointAt(0).toString(16) + "";
    return s_code.length > 4 ? "\\U" + s_code.padStart(8, "0") : "\\u" + s_code.padStart(4, "0");
};
const $266825253b7f24dc$var$clean_iri = (p_iri_dirty)=>p_iri_dirty.replace($266825253b7f24dc$var$R_INVALID_IRIREF, $266825253b7f24dc$var$F_REPLACE_INVALID_IRIREF);
// eslint-disable-next-line no-misleading-character-class
const $266825253b7f24dc$var$RT_AVOID_PNAME_NS = /^(?:[\u0000-@[-`{-\u00bf\u00d7\u00f7\u0300-\u306f\u037e\u2000-\u200b\u200e-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff].+|(?:.+?[\u0000-,\/:-@[-^`{-\u00b6\u00b8-\u00bf\u00d7\u00f7\u037e\u2000-\u200b\u200e-\u203e\u2041-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff].*)|.+\.)$/;
// eslint-disable-next-line no-misleading-character-class
const $266825253b7f24dc$var$RT_AVOID_PNAME_LOCAL = /^(?:\\|[\u0000-\/;-@[-^`{-\u00bf\u00d7\u00f7\u0300-\u306f\u037e\u2000-\u200b\u200e-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff].+|(?:.+?(?:\\|[\u0000-,\/;-@[-^`{-\u00b6\u00b8-\u00bf\u00d7\u00f7\u037e\u2000-\u200b\u200e-\u203e\u2041-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff]).+)|(?:.+?(?:\\|[\u0000-,.\/;-@[-^`{-\u00b6\u00b8-\u00bf\u00d7\u00f7\u037e\u2000-\u200b\u200e-\u203e\u2041-\u206f\u2190-\u2bff\u2ff0-\u3000\ud800-\uf8ff\ufdd0-\ufddf\ufffe\uffff])))$/;
const $266825253b7f24dc$var$RT_BOOLEAN_TRUE = /^([Tt](rue)?|TRUE)$/;
const $266825253b7f24dc$var$RT_BOOLEAN_FALSE = /^([Ff](alse)?|FALSE)$/;
const $266825253b7f24dc$var$S_UUID_V4 = "xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx";
const $266825253b7f24dc$var$R_UUID_V4 = /[xy]/g;
const $266825253b7f24dc$var$uuid_v4 = ()=>{
    let dt_now = Date.now();
    if ("undefined" !== typeof performance) dt_now += performance.now();
    return $266825253b7f24dc$var$S_UUID_V4.replace($266825253b7f24dc$var$R_UUID_V4, (s)=>{
        let x_r = (dt_now + Math.random() * 16) % 16 | 0;
        dt_now = Math.floor(dt_now / 16);
        return ("x" === s ? x_r : x_r & 0x3 | 0x8).toString(16);
    });
};
// symbol to access cache on a prefix mapping
const $266825253b7f24dc$var$$_PREFIX_CACHE = Symbol("prefix-cache");
// escape characters for compiling regexes
const $266825253b7f24dc$var$R_REGEX_ESCAPE = /[$^*()+[\\{}|.?]/g;
// valid locals of prefixed names
const $266825253b7f24dc$var$SR_PN_LOCAL = "((?:[A-Za-z\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u{02ff}\\u{0370}-\\u{037d}\\u{037f}-\\u{1fff}\\u{200c}-\\u{200d}\\u{2070}-\\u{218f}\\u{2c00}-\\u{2fef}\\u{3001}-\\u{d7ff}\\u{f900}-\\u{fdcf}\\u{fdf0}-\\u{fffd}\\u{10000}-\\u{effff}_:0-9]|%[A-Fa-f0-9]{2}|\\\\[_~.\\-!$&'()*+,;=/?#@%])(?:(?:[A-Za-z\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u{02ff}\\u{0370}-\\u{037d}\\u{037f}-\\u{1fff}\\u{200c}-\\u{200d}\\u{2070}-\\u{218f}\\u{2c00}-\\u{2fef}\\u{3001}-\\u{d7ff}\\u{f900}-\\u{fdcf}\\u{fdf0}-\\u{fffd}\\u{10000}-\\u{effff}_\\-0-9\\xb7\\u{0300}-\\u{036f}\\u{203f}-\\u{2040}.:]|%[A-Fa-f0-9]{2}|\\\\[_~.\\-!$&'()*+,;=/?#@%])*(?:[A-Za-z\\xc0-\\xd6\\xd8-\\xf6\\xf8-\\u{02ff}\\u{0370}-\\u{037d}\\u{037f}-\\u{1fff}\\u{200c}-\\u{200d}\\u{2070}-\\u{218f}\\u{2c00}-\\u{2fef}\\u{3001}-\\u{d7ff}\\u{f900}-\\u{fdcf}\\u{fdf0}-\\u{fffd}\\u{10000}-\\u{effff}_\\-0-9\\xb7\\u{0300}-\\u{036f}\\u{203f}-\\u{2040}:]|%[A-Fa-f0-9]{2}|\\\\[_~.\\-!$&'()*+,;=/?#@%]))?)$";
// create a cache on a prefix mapping
function $266825253b7f24dc$var$cache_prefixes(h_prefixes, b_terse = false) {
    // regex cache string building
    let a_cache = [];
    // inverse mappings
    let h_inverse = {};
    // each prefix/iri pair
    for(let si_prefix in h_prefixes){
        let p_iri = h_prefixes[si_prefix];
        // prefix would make an invalid namespace; skip
        if (b_terse && $266825253b7f24dc$var$RT_AVOID_PNAME_NS.test(si_prefix)) continue;
        // save inverse mapping
        h_inverse[p_iri] = si_prefix;
        // push iri
        a_cache.push(p_iri.replace($266825253b7f24dc$var$R_REGEX_ESCAPE, "\\$&"));
    }
    // no prefixes; forgo cache
    if (!a_cache.length) return h_prefixes;
    // save cache object
    h_prefixes[$266825253b7f24dc$var$$_PREFIX_CACHE] = {
        _r_iris: new RegExp(`^(${a_cache.join("|")})${$266825253b7f24dc$var$SR_PN_LOCAL}`, "u"),
        _h_inverse: h_inverse
    };
    // freeze object
    return Object.freeze(h_prefixes);
}
// attempt to turn an iri into a terse prefixed name
const $266825253b7f24dc$var$terse = (p_iri, h_prefixes)=>{
    // ref cache
    let g_cache = h_prefixes[$266825253b7f24dc$var$$_PREFIX_CACHE];
    // cache exists
    if (g_cache) {
        // iri matching
        let m_iri = g_cache._r_iris.exec(p_iri);
        // prefix mapped; compress
        if (m_iri) return g_cache._h_inverse[m_iri[1]] + ":" + m_iri[2];
    } else {
        // best prefix id
        let si_best_prefix = "";
        let s_best_suffix = "";
        // length of longest matching iri
        let nl_best_prefix_iri = -1;
        // each prefix in hash
        for(let si_prefix in h_prefixes){
            let p_prefix_iri = h_prefixes[si_prefix];
            // target iri starts with prefix iri and its longer than the current best
            if (0 === p_iri.indexOf(p_prefix_iri) && p_prefix_iri.length > nl_best_prefix_iri && !$266825253b7f24dc$var$RT_AVOID_PNAME_NS.test(si_prefix)) {
                // compute suffix
                let s_suffix = p_iri.slice(p_prefix_iri.length);
                // suffix is okay to use
                if (!$266825253b7f24dc$var$RT_AVOID_PNAME_LOCAL.test(s_suffix)) {
                    s_best_suffix = s_suffix;
                    // save prefix id as best
                    si_best_prefix = si_prefix;
                    // update best iri length
                    nl_best_prefix_iri = p_prefix_iri.length;
                }
            }
        }
        // found a prefix
        if (-1 !== nl_best_prefix_iri) // use terse prefixed name
        return si_best_prefix + ":" + s_best_suffix;
    }
    // fallback
    return "<" + p_iri + ">";
};
// attempt to turn an iri into a concise prefixed name
const $266825253b7f24dc$var$concise = (p_iri, h_prefixes = {})=>{
    // ref cache
    let g_cache = h_prefixes[$266825253b7f24dc$var$$_PREFIX_CACHE];
    // cache exists
    if (g_cache) {
        // iri matching
        let m_iri = g_cache._r_iris.exec(p_iri);
        // prefix mapped; compress
        if (m_iri) return g_cache._h_inverse[m_iri[1]] + ":" + m_iri[2];
    } else {
        // best prefix id
        let s_best_prefix_id = "";
        // length of longest matching iri
        let nl_best_prefix_iri = -1;
        // each prefix in hash
        for(let s_prefix_id in h_prefixes){
            let p_prefix_iri = h_prefixes[s_prefix_id];
            // target iri starts with prefix iri and its longer than the current best
            if (p_iri.startsWith(p_prefix_iri) && p_prefix_iri.length > nl_best_prefix_iri) {
                // save prefix id as best
                s_best_prefix_id = s_prefix_id;
                // update best iri length
                nl_best_prefix_iri = p_prefix_iri.length;
            }
        }
        // found a prefix
        if (-1 !== nl_best_prefix_iri) return s_best_prefix_id + ":" + p_iri.slice(nl_best_prefix_iri);
    }
    // no prefix found; default to full iri
    return ">" + p_iri;
};
const $266825253b7f24dc$var$R_C1N_DECONSTRUCT = /^([^:]*):(.*)$/;
function $266825253b7f24dc$var$c1_to_nt(sc1_in, h_prefixes = {}, b_verbose = false) {
    switch(sc1_in[0]){
        // absolute iri
        case ">":
            return "<" + sc1_in.slice(1) + ">";
        // blank node
        case "_":
            // ephemeral hint
            if (sc1_in.length <= 2 || "#" === sc1_in[2]) return new $266825253b7f24dc$var$EphemeralBlankNode()[b_verbose ? "verbose" : "terse"]();
            else return sc1_in;
        // simple literal
        case '"':
            return JSON.stringify(sc1_in.slice(1));
        // languaged literal
        case "@":
            {
                let i_contents = sc1_in.indexOf('"');
                return JSON.stringify(sc1_in.slice(i_contents + 1)) + sc1_in.slice(0, i_contents);
            }
        // datatyped literal
        case "^":
            {
                let i_contents = sc1_in.indexOf('"');
                return JSON.stringify(sc1_in.slice(i_contents + 1)) + "^^" + $266825253b7f24dc$var$c1_to_nt(sc1_in.slice(1, i_contents), h_prefixes, b_verbose);
            }
        // default graph
        case "*":
            return "";
        // directive / node explicit
        case "<":
        case "`":
            return $266825253b7f24dc$var$factory.c1(sc1_in).terse(h_prefixes);
        // otherwise
        default:
            {
                // rdf:type alis
                if ("a" === sc1_in) return b_verbose ? "<http://www.w3.org/1999/02/22-rdf-syntax-ns#type>" : "a";
                // deconstruct prefixed name
                let [, si_prefix, s_suffix] = $266825253b7f24dc$var$R_C1N_DECONSTRUCT.exec(sc1_in);
                // avoid illegal prefixed name parts
                if (b_verbose || $266825253b7f24dc$var$RT_AVOID_PNAME_LOCAL.test(s_suffix) || $266825253b7f24dc$var$RT_AVOID_PNAME_NS.test(si_prefix)) return "<" + h_prefixes[si_prefix] + s_suffix + ">";
                // good as-is
                return sc1_in;
            }
    }
}
class $266825253b7f24dc$var$GenericTerm {
    valueOf() {
        return this.concise();
    }
    toString() {
        return this.concise();
    }
    equals(z_other) {
        return z_other ? this === z_other || z_other.termType === this.termType && z_other.value === this.value : false;
    }
}
Object.assign($266825253b7f24dc$var$GenericTerm.prototype, {
    isGraphyTerm: true
});
class $266825253b7f24dc$var$NamedNode extends $266825253b7f24dc$var$GenericTerm {
    constructor(s_iri){
        super();
        this.value = s_iri;
    }
    concise(h_prefixes = {}) {
        return $266825253b7f24dc$var$concise(this.value, h_prefixes);
    }
    terse(h_prefixes = {}, b_opt = false) {
        return $266825253b7f24dc$var$terse($266825253b7f24dc$var$clean_iri(this.value), h_prefixes, b_opt);
    }
    verbose() {
        return "<" + $266825253b7f24dc$var$clean_iri(this.value) + ">";
    }
    isolate() {
        return {
            termType: "NamedNode",
            value: this.value
        };
    }
}
Object.assign($266825253b7f24dc$var$NamedNode.prototype, {
    termType: "NamedNode",
    isNamedNode: true
});
const $266825253b7f24dc$var$KT_RDF_TYPE = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
$266825253b7f24dc$var$KT_RDF_TYPE.isRdfTypeAlias = true; // for serialization
const $266825253b7f24dc$var$KT_RDF_LANG_STRING = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
const $266825253b7f24dc$var$G_ISOLATE_RDF_LANG_STRING = $266825253b7f24dc$var$KT_RDF_LANG_STRING.isolate();
const $266825253b7f24dc$var$KT_RDF_FIRST = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#first");
const $266825253b7f24dc$var$KT_RDF_REST = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#rest");
const $266825253b7f24dc$var$KT_RDF_NIL = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#nil");
const $266825253b7f24dc$var$KT_XSD_DATE = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#date");
const $266825253b7f24dc$var$KT_XSD_DATETIME = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#dateTime");
const $266825253b7f24dc$var$KT_XSD_STRING = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#string");
class $266825253b7f24dc$var$GenericLiteral extends $266825253b7f24dc$var$GenericTerm {
    equals(z_other) {
        return z_other ? this === z_other || "Literal" === z_other.termType && z_other.value === this.value && this.datatype.equals(z_other.datatype) && z_other.language === this.language : false;
    }
    verbose() {
        return JSON.stringify(this.value) + (this.language ? "@" + this.language : "^^" + this.datatype.verbose());
    }
    concise(h_prefixes) {
        if (this.language) return "@" + this.language + '"' + this.value;
        else return "^" + $266825253b7f24dc$var$concise(this.datatype.value, h_prefixes) + '"' + this.value;
    }
    terse(h_prefixes = {}) {
        // turn into terse
        let st_datatype = this.datatype.terse(h_prefixes);
        // stringify literal
        return JSON.stringify(this.value) + (this.language ? "@" + this.language : "^^" + st_datatype);
    }
    isolate() {
        return {
            termType: "Literal",
            value: this.value,
            language: this.language,
            datatype: this.datatype.isolate()
        };
    }
}
Object.assign($266825253b7f24dc$var$GenericLiteral.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_STRING,
    language: "",
    termType: "Literal",
    isLiteral: true,
    isSimple: false
});
class $266825253b7f24dc$var$LanguagedLiteral extends $266825253b7f24dc$var$GenericLiteral {
    constructor(s_value, s_lang){
        super();
        this.value = s_value;
        // remove optional '@' character from beginning
        this.language = ("@" === s_lang[0] ? s_lang.slice(1) : s_lang).toLowerCase();
    }
    verbose() {
        return JSON.stringify(this.value) + "@" + this.language;
    }
    concise() {
        return "@" + this.language + '"' + this.value;
    }
    terse() {
        // stringify literal
        return JSON.stringify(this.value) + "@" + this.language;
    }
    isolate() {
        return {
            termType: "Literal",
            value: this.value,
            language: this.language,
            datatype: $266825253b7f24dc$var$G_ISOLATE_RDF_LANG_STRING
        };
    }
}
Object.assign($266825253b7f24dc$var$LanguagedLiteral.prototype, {
    datatype: $266825253b7f24dc$var$KT_RDF_LANG_STRING,
    isLanguaged: true
});
class $266825253b7f24dc$var$DatatypedLiteral extends $266825253b7f24dc$var$GenericLiteral {
    verbose() {
        return JSON.stringify(this.value) + "^^" + this.datatype.verbose();
    }
    concise(h_prefixes) {
        return "^" + $266825253b7f24dc$var$concise(this.datatype.value, h_prefixes) + '"' + this.value;
    }
    terse(h_prefixes = {}) {
        // turn into terse
        let st_datatype = this.datatype.terse(h_prefixes);
        // stringify literal
        return JSON.stringify(this.value) + "^^" + st_datatype;
    }
    isolate() {
        return {
            termType: "Literal",
            value: this.value,
            language: this.language,
            datatype: this.datatype.isolate()
        };
    }
}
Object.assign($266825253b7f24dc$var$DatatypedLiteral.prototype, {
    isDatatyped: true
});
class $266825253b7f24dc$var$ExplicitlyDatatypedLiteral extends $266825253b7f24dc$var$DatatypedLiteral {
    constructor(s_value, kt_datatype){
        super();
        this.value = s_value;
        this.datatype = kt_datatype;
    }
}
class $266825253b7f24dc$var$RawLiteral extends $266825253b7f24dc$var$GenericTerm {
    constructor(s_value){
        super();
        this.value = s_value;
    }
    get isSimple() {
        return !this.language && !this.datatype.equals($266825253b7f24dc$var$KT_XSD_STRING);
    }
    get isLanguaged() {
        return !!this.language;
    }
    get isDatatyped() {
        return $266825253b7f24dc$var$KT_XSD_STRING.equals(this.datatype);
    }
    equals(z_other) {
        return z_other ? this === z_other || "Literal" === z_other.termType && z_other.value === this.value && this.datatype.equals(z_other.datatype) && z_other.language === this.language : false;
    }
    verbose() {
        return JSON.stringify(this.value) + (this.language ? "@" + this.language : "^^" + this.datatype.verbose());
    }
    concise(h_prefixes) {
        if (this.language) return "@" + this.language + '"' + this.value;
        else return "^" + $266825253b7f24dc$var$concise(this.datatype.value, h_prefixes) + '"' + this.value;
    }
    terse(h_prefixes = {}) {
        // turn into terse
        let st_datatype = this.datatype.terse(h_prefixes);
        // stringify literal
        return JSON.stringify(this.value) + (this.language ? "@" + this.language : "^^" + st_datatype);
    }
    isolate() {
        return {
            termType: "Literal",
            value: this.value,
            language: this.language,
            datatype: this.datatype.isolate()
        };
    }
}
Object.assign($266825253b7f24dc$var$RawLiteral.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_STRING,
    language: "",
    termType: "Literal",
    isLiteral: true
});
class $266825253b7f24dc$var$SimpleLiteral extends $266825253b7f24dc$var$GenericLiteral {
    constructor(s_value){
        super();
        this.value = s_value;
    }
    verbose() {
        return JSON.stringify(this.value);
    }
    concise() {
        return '"' + this.value;
    }
    terse() {
        return JSON.stringify(this.value);
    }
}
Object.assign($266825253b7f24dc$var$SimpleLiteral.prototype, {
    isSimple: true
});
const $266825253b7f24dc$var$KT_XSD_INTEGER = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#integer");
class $266825253b7f24dc$var$Literal_Integer extends $266825253b7f24dc$var$DatatypedLiteral {
    static from(s_literal) {
        let kt = new $266825253b7f24dc$var$Literal_Integer(+s_literal);
        kt.value = s_literal;
        return kt;
    }
    constructor(x_value){
        super();
        this.value = x_value + "";
        this.number = x_value;
    }
    concise(h_prefixes = {}) {
        return "^" + $266825253b7f24dc$var$KT_XSD_INTEGER.concise(h_prefixes) + '"' + this.value;
    }
    terse() {
        return this.value.includes("e") ? `"${this.value}"^^<http://www.w3.org/2001/XMLSchema#integer>` : this.value;
    }
}
Object.assign($266825253b7f24dc$var$Literal_Integer.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_INTEGER,
    isNumeric: true,
    isInteger: true
});
const $266825253b7f24dc$var$KT_XSD_DOUBLE = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#double");
class $266825253b7f24dc$var$Literal_Double extends $266825253b7f24dc$var$DatatypedLiteral {
    static from(s_literal) {
        let kt = new $266825253b7f24dc$var$Literal_Double(+s_literal);
        kt.value = s_literal;
        return kt;
    }
    constructor(x_value){
        super();
        this.value = x_value + "";
        this.number = x_value;
    }
    concise(h_prefixes = {}) {
        return "^" + $266825253b7f24dc$var$KT_XSD_DOUBLE.concise(h_prefixes) + '"' + this.value;
    }
    terse() {
        return this.number.toExponential();
    }
}
Object.assign($266825253b7f24dc$var$Literal_Double.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_DOUBLE,
    isNumeric: true,
    isDouble: true
});
const $266825253b7f24dc$var$KT_XSD_DECIMAL = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#decimal");
class $266825253b7f24dc$var$Literal_Decimal extends $266825253b7f24dc$var$DatatypedLiteral {
    static from(s_literal) {
        let kt = new $266825253b7f24dc$var$Literal_Decimal(+s_literal);
        kt.value = s_literal;
        return kt;
    }
    constructor(x_value){
        super();
        this.value = x_value + "";
        this.number = x_value;
    }
    concise(h_prefixes = {}) {
        return "^" + $266825253b7f24dc$var$KT_XSD_DECIMAL.concise(h_prefixes) + '"' + this.value;
    }
    terse() {
        return this.value.includes("e") ? `"${this.value}"^^<http://www.w3.org/2001/XMLSchema#decimal>` : this.value + (this.value.includes(".") ? "" : ".0");
    }
}
Object.assign($266825253b7f24dc$var$Literal_Decimal.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_DECIMAL,
    isNumeric: true,
    isDecimal: true
});
const $266825253b7f24dc$var$KT_XSD_BOOLEAN = new $266825253b7f24dc$var$NamedNode("http://www.w3.org/2001/XMLSchema#boolean");
class $266825253b7f24dc$var$Literal_Boolean extends $266825253b7f24dc$var$DatatypedLiteral {
    static from(s_literal) {
        let kt = new $266825253b7f24dc$var$Literal_Boolean(+s_literal);
        kt.value = s_literal;
        return kt;
    }
    constructor(b_value){
        super();
        this.value = b_value + "";
        this.boolean = b_value;
    }
    concise(h_prefixes = {}) {
        return "^" + $266825253b7f24dc$var$KT_XSD_BOOLEAN.concise(h_prefixes) + '"' + this.value;
    }
    terse() {
        return this.value + "";
    }
}
Object.assign($266825253b7f24dc$var$Literal_Boolean.prototype, {
    datatype: $266825253b7f24dc$var$KT_XSD_BOOLEAN,
    isBoolean: true
});
class $266825253b7f24dc$var$Literal_PositiveInfinity extends $266825253b7f24dc$var$Literal_Double {
    constructor(){
        super(Infinity);
        this.value = "INF";
    }
    terse(h_prefixes) {
        return '"INF"^^' + $266825253b7f24dc$var$KT_XSD_DOUBLE.terse(h_prefixes);
    }
}
Object.assign($266825253b7f24dc$var$Literal_PositiveInfinity.prototype, {
    isInfinite: true
});
class $266825253b7f24dc$var$Literal_NegativeInfinity extends $266825253b7f24dc$var$Literal_Double {
    constructor(){
        super(-Infinity);
        this.value = "-INF";
    }
    terse(h_prefixes) {
        return '"-INF"^^' + $266825253b7f24dc$var$KT_XSD_DOUBLE.terse(h_prefixes);
    }
}
Object.assign($266825253b7f24dc$var$Literal_NegativeInfinity.prototype, {
    isInfinite: true
});
class $266825253b7f24dc$var$Literal_NaN extends $266825253b7f24dc$var$Literal_Double {
    constructor(){
        super(NaN);
        this.value = "NaN";
    }
    terse(h_prefixes) {
        return '"NaN"^^' + $266825253b7f24dc$var$KT_XSD_DOUBLE.terse(h_prefixes);
    }
}
Object.assign($266825253b7f24dc$var$Literal_NaN.prototype, {
    isNaN: true
});
function $266825253b7f24dc$var$BlankNode(s_value, b_anonymous = false) {
    this.value = s_value;
    this.isAnonymous = b_anonymous;
}
$266825253b7f24dc$var$BlankNode.prototype = Object.assign(Object.create($266825253b7f24dc$var$GenericTerm.prototype), {
    termType: "BlankNode",
    isBlankNode: true,
    concise () {
        return "_:" + this.value;
    },
    terse () {
        return "_:" + this.value;
    },
    verbose () {
        return "_:" + this.value;
    },
    isolate () {
        return {
            termType: "BlankNode",
            value: this.value
        };
    }
});
function $266825253b7f24dc$var$EphemeralBlankNode() {}
$266825253b7f24dc$var$EphemeralBlankNode.prototype = Object.assign(Object.create($266825253b7f24dc$var$BlankNode.prototype), {
    isAnonymous: true,
    isEphemeral: true,
    concise () {
        return "_:#" + this.value;
    },
    terse () {
        return "[]";
    },
    verbose () {
        return "_:" + this.value;
    },
    isolate () {
        return {
            termType: "BlankNode",
            value: this.value
        };
    },
    equals () {
        return false;
    }
});
Object.defineProperty($266825253b7f24dc$var$EphemeralBlankNode.prototype, "value", {
    get () {
        return "_" + $266825253b7f24dc$var$uuid_v4();
    }
});
class $266825253b7f24dc$var$Variable extends $266825253b7f24dc$var$GenericTerm {
    constructor(s_label){
        super();
        this.value = s_label;
    }
    concise() {
        return "?" + this.value;
    }
    terse() {
        throw new Error(`Cannot call .terse() on 'Variable' term type`);
    }
    verbose() {
        throw new Error(`Cannot call .verbose() on 'Variable' term type`);
    }
    isolate() {
        return {
            termType: "Variable",
            value: this.value
        };
    }
}
Object.assign($266825253b7f24dc$var$Variable.prototype, {
    termType: "Variable",
    isVariable: true
});
function $266825253b7f24dc$var$DefaultGraph() {}
$266825253b7f24dc$var$DefaultGraph.prototype = Object.assign(Object.create($266825253b7f24dc$var$GenericTerm.prototype), {
    value: "",
    termType: "DefaultGraph",
    isDefaultGraph: true,
    concise () {
        return "*";
    },
    terse () {
        return "";
    },
    verbose () {
        return "";
    },
    isolate () {
        return {
            termType: "DefaultGraph",
            value: ""
        };
    }
});
function $266825253b7f24dc$var$NoGraph() {}
$266825253b7f24dc$var$NoGraph.prototype = Object.assign(Object.create($266825253b7f24dc$var$GenericTerm.prototype), {
    value: "",
    termType: "NoGraph",
    concise () {
        return "";
    },
    terse () {
        return "";
    },
    verbose () {
        return "";
    },
    isolate () {
        return {
            termType: "NoGraph",
            value: ""
        };
    }
});
const $266825253b7f24dc$var$KT_DEFAULT_GRAPH = new $266825253b7f24dc$var$DefaultGraph();
function $266825253b7f24dc$var$Quad(h_subject, h_predicate, h_object, h_graph = $266825253b7f24dc$var$KT_DEFAULT_GRAPH) {
    this.subject = h_subject;
    this.predicate = h_predicate;
    this.object = h_object;
    this.graph = h_graph;
}
Object.assign($266825253b7f24dc$var$Quad.prototype, {
    isGraphyQuad: true,
    equals (z_other) {
        return z_other ? this === z_other || this.object.equals(z_other.object) && this.subject.equals(z_other.subject) && this.predicate.equals(z_other.predicate) && this.graph.equals(z_other.graph) : false;
    },
    valueOf () {
        return this.verbose();
    },
    concise (h_prefixes = {}) {
        return [
            this.subject.concise(h_prefixes),
            this.predicate.concise(h_prefixes),
            this.object.concise(h_prefixes),
            this.graph.concise(h_prefixes)
        ];
    },
    terse (h_prefixes) {
        let b_default_graph = this.graph.isDefaultGraph;
        return (b_default_graph ? "" : this.graph.terse(h_prefixes) + " { ") + this.subject.terse(h_prefixes) + " " + this.predicate.terse(h_prefixes) + " " + this.object.terse(h_prefixes) + " ." + (b_default_graph ? "" : " }");
    },
    verbose () {
        return this.subject.verbose() + " " + this.predicate.verbose() + " " + this.object.verbose() + " " + (this.graph.isDefaultGraph ? "" : this.graph.verbose() + " ") + ".";
    },
    isolate () {
        return {
            subject: this.subject.isolate(),
            predicate: this.predicate.isolate(),
            object: this.object.isolate(),
            graph: this.graph.isolate()
        };
    }
});
let $266825253b7f24dc$var$g_raw = {
    namedNode (p_iri) {
        return new $266825253b7f24dc$var$NamedNode(p_iri);
    },
    blankNode (s_label, b_anonymous) {
        return new $266825253b7f24dc$var$BlankNode(s_label, b_anonymous);
    },
    literal (s_value) {
        return new $266825253b7f24dc$var$RawLiteral(s_value);
    },
    defaultGraph () {
        return new $266825253b7f24dc$var$DefaultGraph();
    },
    quad (kt_subject, kt_predicate, kt_object, kt_graph) {
        return new $266825253b7f24dc$var$Quad(kt_subject, kt_predicate, kt_object, kt_graph || $266825253b7f24dc$var$KT_DEFAULT_GRAPH);
    },
    integer (w) {
        return $266825253b7f24dc$var$Literal_Integer.from(w);
    },
    double (w) {
        return $266825253b7f24dc$var$Literal_Double.from(w);
    },
    decimal (w) {
        return $266825253b7f24dc$var$Literal_Decimal.from(w);
    },
    boolean (w) {
        return new $266825253b7f24dc$var$Literal_Boolean(w);
    }
};
const $266825253b7f24dc$var$factory = $266825253b7f24dc$exports = {
    concise: $266825253b7f24dc$var$concise,
    adopt (dc_factory) {
        let dc_extend = Object.create(dc_factory);
        let b_use_extend = false;
        if ("function" !== typeof dc_factory.boolean) {
            let kt_xsd_boolean = dc_factory.namedNode("http://www.w3.org/2001/XMLSchema#boolean");
            dc_extend.boolean = (b_value)=>dc_factory.literal(b_value + "", kt_xsd_boolean);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.double) {
            let kt_xsd_double = dc_factory.namedNode("http://www.w3.org/2001/XMLSchema#double");
            dc_extend.double = (s_value)=>dc_factory.literal(s_value + "", kt_xsd_double);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.decimal) {
            let kt_xsd_decimal = dc_factory.namedNode("http://www.w3.org/2001/XMLSchema#decimal");
            dc_extend.decimal = (s_value)=>dc_factory.literal(s_value + "", kt_xsd_decimal);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.integer) {
            let kt_xsd_integer = dc_factory.namedNode("http://www.w3.org/2001/XMLSchema#integer");
            dc_extend.integer = (s_value)=>dc_factory.literal(s_value + "", kt_xsd_integer);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.simpleLiteral) {
            dc_extend.simpleLiteral = (s_value)=>dc_factory.literal(s_value);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.languagedLiteral) {
            dc_extend.languagedLiteral = (s_value, s_lang)=>dc_factory.literal(s_value, s_lang);
            b_use_extend = true;
        }
        if ("function" !== typeof dc_factory.datatypedLiteral) {
            dc_extend.datatypedLiteral = (s_value, kt_datatype)=>dc_factory.literal(s_value, kt_datatype);
            b_use_extend = true;
        }
        if (b_use_extend) return dc_extend;
        else return dc_factory;
    },
    raw: $266825253b7f24dc$var$g_raw,
    unfiltered: {
        ...$266825253b7f24dc$var$g_raw,
        literal (s_value, z_datatype_or_lang) {
            if (!z_datatype_or_lang || $266825253b7f24dc$var$KT_XSD_STRING.equals(z_datatype_or_lang)) return new $266825253b7f24dc$var$SimpleLiteral(s_value);
            else if ("string" === typeof z_datatype_or_lang) return new $266825253b7f24dc$var$LanguagedLiteral(s_value, z_datatype_or_lang);
            else if ($266825253b7f24dc$var$KT_XSD_STRING.equals(z_datatype_or_lang)) return new $266825253b7f24dc$var$SimpleLiteral(s_value);
            else return new $266825253b7f24dc$var$ExplicitlyDatatypedLiteral(s_value, z_datatype_or_lang);
        },
        simpleLiteral (s_value) {
            return new $266825253b7f24dc$var$SimpleLiteral(s_value);
        },
        languagedLiteral (s_value, s_language) {
            return new $266825253b7f24dc$var$LanguagedLiteral(s_value, s_language);
        },
        datatypedLiteral (s_value, kt_datatype) {
            if ($266825253b7f24dc$var$KT_XSD_STRING.equals(kt_datatype)) return new $266825253b7f24dc$var$SimpleLiteral(s_value);
            else return new $266825253b7f24dc$var$ExplicitlyDatatypedLiteral(s_value, kt_datatype);
        }
    },
    number (x) {
        // not finite or not a number
        if ("number" === typeof x && (!Number.isFinite(x) || Number.isNaN(x))) return $266825253b7f24dc$var$factory.double(x);
        else if (Number.isInteger(x) || "bigint" === typeof x) return $266825253b7f24dc$var$factory.integer(x);
        else return $266825253b7f24dc$var$factory.decimal(x);
    },
    date (dt) {
        return $266825253b7f24dc$var$factory.literal(dt.toISOString().replace(/T.+$/, "Z"), $266825253b7f24dc$var$KT_XSD_DATE);
    },
    dateTime (dt) {
        return $266825253b7f24dc$var$factory.literal(dt.toISOString(), $266825253b7f24dc$var$KT_XSD_DATETIME);
    },
    namedNode (p_iri) {
        return new $266825253b7f24dc$var$NamedNode(p_iri);
    },
    ephemeral () {
        return new $266825253b7f24dc$var$EphemeralBlankNode();
    },
    // @deprecated
    anonymous () {
        return new $266825253b7f24dc$var$EphemeralBlankNode();
    },
    blankNode (z_label) {
        // no label given, generate a UUID
        if (!z_label) // eslint-disable-next-line no-undef
        return new $266825253b7f24dc$var$BlankNode("_" + $266825253b7f24dc$var$uuid_v4(), true);
        else if ("string" === typeof z_label) return new $266825253b7f24dc$var$BlankNode(z_label);
        throw new TypeError(`factory.blankNode(label) expects 'label' parameter to be falsy or a string; instead found: ${z_label}`);
    },
    literal (s_value, z_datatype_or_lang) {
        if (!z_datatype_or_lang || $266825253b7f24dc$var$KT_XSD_STRING.equals(z_datatype_or_lang)) return new $266825253b7f24dc$var$SimpleLiteral(s_value);
        else if ("string" === typeof z_datatype_or_lang) return new $266825253b7f24dc$var$LanguagedLiteral(s_value, z_datatype_or_lang);
        else return new $266825253b7f24dc$var$ExplicitlyDatatypedLiteral(s_value, z_datatype_or_lang);
    },
    integer (w_value) {
        let s_type = typeof w_value;
        // a number was given
        if ("number" === s_type) {
            // not a finite number
            if (!Number.isFinite(w_value)) {
                // NaN
                if (Number.isNaN(w_value)) throw new Error("XSD integer cannot encode NaN. Try using double");
                throw new Error("XSD integer cannot encode +/-infinity. Try using double");
            } else if (!Number.isInteger(w_value)) throw new Error("Number is not an integer: " + w_value);
            return new $266825253b7f24dc$var$Literal_Integer(w_value);
        } else if ("string" === s_type) {
            // empty string
            if ("" === w_value) throw new Error("Refusing to serialize empty string as xsd:integer");
            // parse to number
            let x_value = +w_value;
            // failed to parse or not an integer
            if (Number.isNaN(x_value) || !Number.isInteger(x_value)) throw new Error("Invalid integer string: " + w_value);
            return new $266825253b7f24dc$var$Literal_Integer(x_value);
        } else if ("undefined" === s_type) throw new Error("Refusing to serialize undefined value as xsd:integer");
        else {
            // null
            if (null === w_value) throw new Error("Refusing to serialize null value as xsd:integer");
            // invalid
            throw new Error("XSD integer expects a number type or integer string");
        }
    },
    double (w_value) {
        let s_type = typeof w_value;
        // a number was given
        if ("number" === s_type) {
            // not a finite number
            if (!Number.isFinite(w_value)) {
                // NaN
                if (Number.isNaN(w_value)) return new $266825253b7f24dc$var$Literal_NaN();
                return w_value > 0 ? new $266825253b7f24dc$var$Literal_PositiveInfinity() : new $266825253b7f24dc$var$Literal_NegativeInfinity();
            }
            return new $266825253b7f24dc$var$Literal_Double(w_value);
        } else if ("string" === s_type) {
            // empty string
            if ("" === w_value) throw new Error("Refusing to serialize empty string as xsd:double");
            // parse to number
            let x_value = +w_value;
            // failed to parse
            if (Number.isNaN(x_value)) throw new Error("Invalid decimal string: " + w_value);
            return new $266825253b7f24dc$var$Literal_Double(x_value);
        } else if ("undefined" === s_type) throw new Error("Refusing to serialize undefined value as xsd:double");
        else {
            // null
            if (null === w_value) throw new Error("Refusing to serialize null value as xsd:double");
            // invalid
            throw new Error("XSD double expects a number type or double string");
        }
    },
    decimal (w_value) {
        let s_type = typeof w_value;
        // a number was given
        if ("number" === s_type) {
            // not a finite number
            if (!Number.isFinite(w_value)) {
                // NaN
                if (Number.isNaN(w_value)) throw new Error("XSD decimal cannot encode NaN. Try using double");
                throw new Error("XSD decimal cannot encode +/-infinity. Try using double");
            }
            return new $266825253b7f24dc$var$Literal_Decimal(w_value);
        } else if ("string" === s_type) {
            // empty string
            if ("" === w_value) throw new Error("Refusing to serialize empty string as xsd:decimal");
            // parse to number
            let x_value = +w_value;
            // failed to parse
            if (Number.isNaN(x_value)) throw new Error("Invalid decimal string: " + w_value);
            return new $266825253b7f24dc$var$Literal_Decimal(x_value);
        } else if ("undefined" === s_type) throw new Error("Refusing to serialize undefined value as xsd:decimal");
        else {
            // null
            if (null === w_value) throw new Error("Refusing to serialize null value as xsd:decimal");
            // invalid
            throw new Error("XSD decimal expects a number type or decimal string");
        }
    },
    boolean (w_value) {
        let s_type = typeof w_value;
        // boolean
        if ("boolean" === s_type) return new $266825253b7f24dc$var$Literal_Boolean(w_value);
        else if ("number" === s_type) {
            // 1
            if (1 === w_value) return new $266825253b7f24dc$var$Literal_Boolean(true);
            else if (0 === w_value) return new $266825253b7f24dc$var$Literal_Boolean(false);
            // invalid
            throw new Error(`Boolean value 'w_value' must be either a '1' or '0' if using numbers`);
        } else if ("string" === s_type) {
            // truthy value
            if ($266825253b7f24dc$var$RT_BOOLEAN_TRUE.test(w_value)) return new $266825253b7f24dc$var$Literal_Boolean(true);
            else if ($266825253b7f24dc$var$RT_BOOLEAN_FALSE.test(w_value)) return new $266825253b7f24dc$var$Literal_Boolean(false);
            // empty string
            if ("" === w_value) throw new Error("Refusing to serialize empty string as xsd:boolean");
            // failed to parse
            throw new Error("Invalid boolean string: " + w_value);
        } else if ("undefined" === s_type) throw new Error("Refusing to serialize undefined value as xsd:boolean");
        else {
            // null
            if (null === w_value) throw new Error("Refusing to serialize null value as xsd:boolean");
            // invalid
            throw new Error("XSD boolean expects a boolean type or boolean string");
        }
    },
    defaultGraph () {
        return new $266825253b7f24dc$var$DefaultGraph();
    },
    variable (s_label) {
        return new $266825253b7f24dc$var$Variable(s_label);
    },
    // warn
    triple (h_subject, h_predicate, h_object) {
        let e_stack = new Error("It is strongly encouraged to use .quad() instead of .triple()");
        console.warn(e_stack.stack.replace(/^(\s*)Error:/, "$1Warning:"));
        return new $266825253b7f24dc$var$Quad(h_subject, h_predicate, h_object);
    },
    quad (h_subject, h_predicate, h_object, h_graph) {
        return new $266825253b7f24dc$var$Quad(h_subject, h_predicate, h_object, h_graph || $266825253b7f24dc$var$KT_DEFAULT_GRAPH);
    },
    term (z_term, w_prefixes) {
        // concise term
        if ("string" === typeof z_term) return $266825253b7f24dc$var$factory.c1(z_term, w_prefixes);
        else return $266825253b7f24dc$var$factory.from.rdfjs_term(z_term);
    },
    /**
	 * construct a term object from a concise term string
	 * @param  {c1_string} sc1_term - a representation of the term object to create
	 * @param  {Object} h_prefixes - mappings for prefixes
	 * @return {Term} - an RDFJS-compatible term object
	 */ c1 (sc1_term, h_prefixes = {}) {
        // deduce term type
        switch(sc1_term[0]){
            // datatyped literal
            case "^":
                {
                    // find literal's contents delimiter
                    let i_contents = sc1_term.indexOf('"');
                    // no delimiter
                    if (-1 === i_contents) throw new Error(`Invalid concise-term string, no content literal delimiter found: '${sc1_term}'`);
                    // extract datatype
                    let s_datatype = sc1_term.slice(1, i_contents);
                    // make term
                    return $266825253b7f24dc$var$factory.literal(sc1_term.slice(i_contents + 1), $266825253b7f24dc$var$factory.c1_node_explicit(s_datatype, h_prefixes));
                }
            // languaged literal
            case "@":
                {
                    // find literal's contents delimiter
                    let i_contents = sc1_term.indexOf('"');
                    // no delimiter
                    if (-1 === i_contents) throw new Error(`Invalid concise-term string, no content literal delimiter found: '${sc1_term}'`);
                    // extract language
                    let s_language = sc1_term.slice(1, i_contents);
                    // make term
                    return $266825253b7f24dc$var$factory.literal(sc1_term.slice(i_contents + 1), s_language);
                }
            // simple literal
            case '"':
                // make term
                return $266825253b7f24dc$var$factory.literal(sc1_term.slice(1));
            // prefixed name
            default:
                return $266825253b7f24dc$var$factory.c1_node(sc1_term, h_prefixes);
        }
    },
    // construct a term object from a concise term string for nodes
    c1_node (sc1_node, h_prefixes = {}) {
        // rdf:type shortcut
        if ("a" === sc1_node) return $266825253b7f24dc$var$KT_RDF_TYPE;
        // default graph
        if ("*" === sc1_node) return $266825253b7f24dc$var$factory.defaultGraph();
        // blank node
        if ("_" === sc1_node[0]) {
            if (":" !== sc1_node[1]) throw new Error(`Invliad concise-term string, prefixes are not allowed to start with an underscore: '${sc1_node}'`);
            // interpret ephemeral hint
            if ("#" === sc1_node[2] || 2 === sc1_node.length) return $266825253b7f24dc$var$factory.ephemeral();
            // create blank node
            return $266825253b7f24dc$var$factory.blankNode(sc1_node.slice(2));
        }
        // other
        return $266825253b7f24dc$var$factory.c1_node_explicit(sc1_node, h_prefixes);
    },
    // construct a named node
    c1_named_node (sc1_node, h_prefixes = {}) {
        // rdf:type shortcut
        if ("a" === sc1_node) return $266825253b7f24dc$var$KT_RDF_TYPE;
        // other
        return $266825253b7f24dc$var$factory.c1_node_explicit(sc1_node, h_prefixes);
    },
    // construct a term object from a concise term string for nodes (no shortcuts)
    c1_node_explicit (sc1_node, h_prefixes = {}) {
        // deduce term type
        switch(sc1_node[0]){
            // iri
            case ">":
                return $266825253b7f24dc$var$factory.namedNode(sc1_node.slice(1));
            // invalid concise-term string
            case "<":
                throw new Error(`Whoops! It looks like this concise-term string starts with a '<' character. Remember to use '>' if you are trying to make an absolute IRI reference.\nInvalid concise-term string '${sc1_node}'`);
            case "`":
                throw new Error(`The backtick character '\`' is reserved for concise-struct key directives and should not be used in the object position.\nInvalid concise-term string '${sc1_node}'`);
            // prefixed name
            default:
                return this.c1_prefixed_node(sc1_node, h_prefixes);
        }
    },
    // construct a term object from a concise term string for prefixed nodes
    c1_prefixed_node (sc1_node, h_prefixes = {}) {
        // find prefix delimiter
        let i_colon = sc1_node.indexOf(":");
        // no delimter; invalid concise-term string for node
        if (-1 === i_colon) throw new Error(`A relative or prefixed node must include a ':' character. \nInvalid concise-term string for node: '${sc1_node}'`);
        // prefix id
        let s_prefix_id = sc1_node.slice(0, i_colon);
        // suffix
        let s_suffix = sc1_node.slice(i_colon + 1);
        // find prefix in hash
        if (s_prefix_id in h_prefixes) return $266825253b7f24dc$var$factory.namedNode(h_prefixes[s_prefix_id] + s_suffix);
        else throw new Error(`Prefix not defined: '${s_prefix_id}'`);
    },
    c1_to_nt: $266825253b7f24dc$var$c1_to_nt,
    *quads (hc4_quads, h_prefixes = {}) {
        for(let sc1_graph in hc4_quads)yield* $266825253b7f24dc$var$factory.triples(hc4_quads[sc1_graph], h_prefixes, sc1_graph);
    },
    *triples (hc3_triples, h_prefixes = {}, sc1_graph = "*") {
        let k_graph = $266825253b7f24dc$var$factory.c1(sc1_graph, h_prefixes);
        for(let sc1_subject in hc3_triples){
            let k_subject = $266825253b7f24dc$var$factory.c1(sc1_subject, h_prefixes);
            let hc2_pairs = hc3_triples[sc1_subject];
            yield* $266825253b7f24dc$var$factory.pairs(k_graph, k_subject, hc2_pairs, h_prefixes);
        }
    },
    *pairs (k_graph, k_subject, hc2_pairs, h_prefixes = {}) {
        for(let sc1_predicate in hc2_pairs){
            let k_predicate = $266825253b7f24dc$var$factory.c1(sc1_predicate, h_prefixes);
            let z_objects = hc2_pairs[sc1_predicate];
            yield* $266825253b7f24dc$var$factory.objects(k_graph, k_subject, k_predicate, z_objects, h_prefixes);
        }
    },
    *collection (k_graph, k_subject, a_objects, h_prefixes = {}) {
        // first item
        yield* $266825253b7f24dc$var$factory.objects(k_graph, k_subject, $266825253b7f24dc$var$KT_RDF_FIRST, a_objects[0], h_prefixes);
        // rest of items
        let a_rest = a_objects.slice(1);
        // no more
        if (!a_rest.length) yield new $266825253b7f24dc$var$Quad(k_subject, $266825253b7f24dc$var$KT_RDF_REST, $266825253b7f24dc$var$KT_RDF_NIL, k_graph);
        else {
            // auto blank node
            let k_hop = $266825253b7f24dc$var$factory.blankNode();
            // incoming triple
            yield new $266825253b7f24dc$var$Quad(k_subject, $266825253b7f24dc$var$KT_RDF_REST, k_hop, k_graph);
            // outgoing triples
            yield* $266825253b7f24dc$var$factory.collection(k_graph, k_hop, a_rest, h_prefixes);
        }
    },
    *objects (k_graph, k_subject, k_predicate, z_objects, h_prefixes, b_nested = false) {
        // value type
        let s_type = typeof z_objects;
        switch(s_type){
            // c1-string
            case "string":
                yield new $266825253b7f24dc$var$Quad(k_subject, k_predicate, $266825253b7f24dc$var$factory.c1(z_objects, h_prefixes), k_graph);
                break;
            // number
            case "number":
                yield new $266825253b7f24dc$var$Quad(k_subject, k_predicate, $266825253b7f24dc$var$factory.number(z_objects), k_graph);
                break;
            // object
            case "object":
                // array
                if (Array.isArray(z_objects)) {
                    // RDF collection
                    if (b_nested) {
                        // auto blank node
                        let k_hop = $266825253b7f24dc$var$factory.blankNode();
                        // incoming triple
                        yield new $266825253b7f24dc$var$Quad(k_subject, k_predicate, k_hop, k_graph);
                        // outgoing triple
                        yield* $266825253b7f24dc$var$factory.collection(k_graph, k_hop, z_objects, h_prefixes);
                    } else for (let z_item of z_objects)yield* $266825253b7f24dc$var$factory.objects(k_graph, k_subject, k_predicate, z_item, h_prefixes, true);
                } else {
                    // auto blank node
                    let k_hop = $266825253b7f24dc$var$factory.blankNode();
                    // incoming triple
                    yield new $266825253b7f24dc$var$Quad(k_subject, k_predicate, k_hop, k_graph);
                    // outgoing triples
                    yield* $266825253b7f24dc$var$factory.pairs(k_graph, k_hop, z_objects, h_prefixes);
                }
                break;
            // other
            default:
                throw new Error(`invalid object type: ${typeof z_objects}`);
        }
    },
    from: {
        term (z_term) {
            if (null === z_term) return z_term;
            if (z_term.isGraphyTerm) return z_term;
            return $266825253b7f24dc$var$factory.from.rdfjs_term(z_term);
        },
        quad (g_quad) {
            if (null === g_quad) return g_quad;
            if (g_quad.isGraphyQuad) return g_quad;
            let g_from = $266825253b7f24dc$var$factory.from;
            return new $266825253b7f24dc$var$Quad(g_from.rdfjs_term(g_quad.subject), g_from.rdfjs_term(g_quad.predicate), g_from.rdfjs_term(g_quad.object), g_quad.graph ? g_from.rdfjs_term(g_quad.graph) : $266825253b7f24dc$var$KT_DEFAULT_GRAPH);
        },
        rdfjs_term (g_term) {
            switch(g_term.termType){
                case "NamedNode":
                    return new $266825253b7f24dc$var$NamedNode(g_term.value);
                case "BlankNode":
                    return new $266825253b7f24dc$var$BlankNode(g_term.value);
                case "Literal":
                    return $266825253b7f24dc$var$factory.literal(g_term.value, g_term.language ? g_term.language : g_term.datatype ? new $266825253b7f24dc$var$NamedNode(g_term.datatype.value) : null);
                case "DefaultGraph":
                    return new $266825253b7f24dc$var$DefaultGraph();
                default:
                    throw new TypeError(`invalid termType: ${g_term.termType}`);
            }
        },
        sparql_result (g_term) {
            switch(g_term.type){
                case "uri":
                    return new $266825253b7f24dc$var$NamedNode(g_term.value);
                case "literal":
                case "typed-literal":
                    if ("xml:lang" in g_term) return new $266825253b7f24dc$var$LanguagedLiteral(g_term.value, g_term["xml:lang"]);
                    else if ("datatype" in g_term && "http://www.w3.org/2001/XMLSchema#string" !== g_term.datatype) return new $266825253b7f24dc$var$ExplicitlyDatatypedLiteral(g_term.value, new $266825253b7f24dc$var$NamedNode(g_term.datatype));
                    else return new $266825253b7f24dc$var$SimpleLiteral(g_term.value);
                case "bnode":
                    return new $266825253b7f24dc$var$BlankNode(g_term.value);
                default:
                    throw new Error(`unexpected SPARQL Result JSON Format Term type: ${g_term.type}`);
            }
        }
    },
    to: {
        boolean: (s_boolean)=>$266825253b7f24dc$var$Literal_Boolean.from(s_boolean),
        integer: (s_integer)=>$266825253b7f24dc$var$Literal_Integer.from(s_integer),
        decimal: (s_decimal)=>$266825253b7f24dc$var$Literal_Decimal.from(s_decimal),
        double: (s_double)=>$266825253b7f24dc$var$Literal_Double.from(s_double)
    },
    /**
	 * @param  {Object} gc_comment -
	 * @return {string} a `concise-term string` directive to be used as a key in `concise-term structs`
	 * 	in order to write a comment to the document (only works with supporting serializers)
	 */ comment (gc_comment = {}) {
        return `\`[${$266825253b7f24dc$var$uuid_v4()}]${JSON.stringify({
            ...gc_comment,
            type: "comment"
        })}`;
    },
    /**
	 * @param  {integer} [line_count=1] - number of newlines to insert
	 * @return {string} a `concise-term string` directive to be used as a key in `concise-term structs`
	 * 	in order to write the given number of newlines to the document (only works with supporting serializers)
	 */ newlines () {
        // if(!Number.isInteger(n_line_count)) throw new TypeError('graphy/core.data.factory#newlines() expects `line_count` argument to be an integer');
        return `\`[${$266825253b7f24dc$var$uuid_v4()}]{"type":"newlines"}`;
    },
    /**
	 * @param {string} s_key - key that identifies which aspect to configure. e.g., 'lists'
	 * @return {string} a `concise-term string` directive to be used as a key in `concise-term structs`
	 * 	in order to write the given number of newlines to the document (only works with supporting serializers)
	 */ config (s_key) {
        if ("string" !== typeof s_key) throw new TypeError(`Expected 'key' argument to be a string, instead found ${typeof s_key}`);
        return `\`[${$266825253b7f24dc$var$uuid_v4()}]{"type":"config","value":${JSON.stringify(s_key)}}`;
    },
    /**
	 * @param {AnyQuad} g_quad - quad to hash
	 * @return {string} a sha256 hash of the quad
	 */ hash (g_quad) {
        // normalize quad
        let k_quad = $266825253b7f24dc$var$factory.from.quad(g_quad);
        // create hash
        let d_hash = $44edd02a6be448cd$export$2fb37efbf6ae0c0e("sha256");
        // verbose quad
        d_hash.update(k_quad.verbose());
        // return hash string
        return d_hash.digest("hex");
    },
    cache_prefixes: $266825253b7f24dc$var$cache_prefixes,
    cachePrefixes: $266825253b7f24dc$var$cache_prefixes,
    terse: $266825253b7f24dc$var$terse,
    clean_iri: $266825253b7f24dc$var$clean_iri,
    cleanIri: $266825253b7f24dc$var$clean_iri,
    $_PREFIX_CACHE: $266825253b7f24dc$var$$_PREFIX_CACHE
};
Object.assign($266825253b7f24dc$var$factory, {
    c3: $266825253b7f24dc$var$factory.triples,
    c4: $266825253b7f24dc$var$factory.quads,
    fromTerm: $266825253b7f24dc$var$factory.from.term,
    fromQuad: $266825253b7f24dc$var$factory.from.quad
});


const $9043c565d33eb642$var$quad = (k)=>$266825253b7f24dc$exports.quad(k._kt_subject, k._kt_predicate, k._kt_object, k._kt_graph);
// eslint-disable-next-line no-misleading-character-class
const $9043c565d33eb642$var$RT_PREFIXED_NAME_NAMESPACE_VALID = /^([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}]([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.]*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?)?$/u;
// eslint-disable-next-line no-misleading-character-class
const $9043c565d33eb642$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID = /^([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_:0-9]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%])(([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.:]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%])*([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}:]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%]))?$/u;
// eslint-disable-next-line no-misleading-character-class
const $9043c565d33eb642$var$RT_BLANK_NODE_VALID = /^[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_0-9]([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.]*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?$/u;
const $9043c565d33eb642$var$RT_NAMED_NODE_VALID = /^([^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $9043c565d33eb642$var$RT_NAMED_NODE_ESCAPELESS_VALID = /^([^\0-\x20<>"{}|^`])*$/;
const $9043c565d33eb642$var$RT_LITERAL_CONTENTS_VALID = /^(?:[^\\]|\\[tbnrf"'\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $9043c565d33eb642$var$R_UNICODE_ANY = /\\u([0-9A-Fa-f]{4})|\\U([0-9A-Fa-f]{8})/g;
const $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY = (s_, s_4, s_8)=>String.fromCodePoint(parseInt(s_4 || s_8, 16));
const $9043c565d33eb642$var$OPHOP = Object.prototype.hasOwnProperty;
const $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK = /([A-Za-z][A-Za-z0-9_-]*)?:([A-Za-z_0-9:][A-Za-z0-9_:-]*)(?:\s+|(?=\.?[<[("';,)\]#]|\.[\s\0]))/y;
const $9043c565d33eb642$var$R_PREFIXED_NAME_ESCAPELESS = /([^\s#@<[("':_][^\s#@<[("':]*)?:((?:[^\s#@<[("'.;,)\]\\](?:[^\s#@<[("';,)\]\\]*[^\s#@<[("'.;,)\]\\])?)?)(?:\s+|(?=\.?[<[("';,)\]#]|\.[\s\0]))/y;
const $9043c565d33eb642$var$R_PREFIXED_NAME = /([^\s#@<[("':_][^\s#@<[("':]*)?:((?:(?:[^\s#@<[("'.;,)\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))(?:(?:[^\s#@<[("';,)\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))*(?:[^\s#@<[("'.;,)\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"])))?)?)(?:\s+|(?=\.?[<[("';,)\]#]|\.[\s\0]))/y;
const $9043c565d33eb642$var$R_PN_LOCAL_ESCAPES = /\\(.)/g;
const $9043c565d33eb642$var$R_BLANK_NODE_LABEL = /_:(.(?:[^\s:<;,)\]#]*[^\s:<.;,)\]#])?)(?:\s+|(?=[<:,;\])#]))/y;
const $9043c565d33eb642$var$R_BLANK_NODE_LABEL_TERMINAL = /_:(.(?:[^\s:<;,)\]#]*[^\s:<.;,)\]#])?)(?:\s+|(?=\.?[<:,;\])#])|(?=\.[\s@#<({[}]))/y;
const $9043c565d33eb642$var$R_IRIREF_ESCAPELESS = /<([^\\>]*)>\s*/y;
const $9043c565d33eb642$var$R_IRIREF = /<([^>]*)>\s*/y;
const $9043c565d33eb642$var$R_NUMERIC_LITERAL = /([+-]?(?:[0-9]+(\.[0-9]+)?|(\.[0-9]+))(\.?[eE][+-]?[0-9]+)?)(?:\s+|(?=\.[^eE0-9]|[;,)\]]))/y;
const $9043c565d33eb642$var$R_BOOLEAN_LITERAL = /(?:(true|TRUE)|false|FALSE)\s*/y;
const $9043c565d33eb642$var$R_A = /a(?:\s+|(?=[[("'<#]))/y;
const $9043c565d33eb642$var$R_DOUBLE_CARET = /\^\^/y;
const $9043c565d33eb642$var$R_WS = /\s*/y;
const $9043c565d33eb642$var$R_LANGTAG = /@([A-Za-z]+(?:-[A-Za-z0-9-]+)*)(?:\s+|(?=[.,;\])#]))/y;
const $9043c565d33eb642$var$R_PREFIX_KEYWORD = /(?:(@prefix)|[pP][rR][eE][fF][iI][xX])\s*/y;
const $9043c565d33eb642$var$R_PREFIX_ID = /([^#:]*):\s*/iy;
const $9043c565d33eb642$var$R_BASE_KEYWORD = /(?:(@base)|[bB][aA][sS][eE])\s*/y;
const $9043c565d33eb642$var$R_COMMENT = /(#[^\n]*\n\s*)+/y;
const $9043c565d33eb642$var$RT_IRI_ABSOLUTE = /^[A-Za-z][A-Za-z0-9.\-+]*:/;
const $9043c565d33eb642$var$R_RELATIVE_URI = /^(\/[^?#]+)([?#].*)?$/;
const $9043c565d33eb642$var$R_BASE_IRI = /^((([A-Za-z0-9.\-+]*:\/)?\/[^/>]*)?(\/(?:[^/>]*\/)*)?[^>]*)$/;
const $9043c565d33eb642$var$R_ANONYMOUS_BLANK_NODE = /\[\s*\]\s*/y;
const $9043c565d33eb642$var$R_CHAR_BLANK_NODE = /\[(?:\s+|(?=[^\]]))/y;
const $9043c565d33eb642$var$R_CHAR_COLLECTION = /\(\s*/y;
const $9043c565d33eb642$var$R_CHAR_KET = /\]\s*/y;
const $9043c565d33eb642$var$R_CHAR_STOP = /\.\s*/y;
const $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_BREAK = /[\\"\r\n]/g;
const $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_BREAK = /[\\'\r\n]/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM = /"{1,2}$/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM = /'{1,2}$/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_BREAK = /(\\|""")/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_BREAK = /(\\|''')/g;
const $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS = (s_, s_whitespace, s_auto, s_4, s_8, s_invalid)=>{
    if (s_whitespace) switch(s_whitespace){
        case "t":
            return "	";
        case "n":
            return "\n";
        case "r":
            return "\r";
        case "f":
            return "\f";
        case "b":
            return "\b";
        default:
            console.assert(`bad regex escape char mapping: '${s_whitespace}'`);
    }
    else if (s_auto) return s_auto;
    else if (s_4) return String.fromCodePoint(parseInt(s_4, 16));
    else if (s_8) return String.fromCodePoint(parseInt(s_8, 16));
    else if (s_invalid) {
        // pointless escape
        if ("\\" === s_invalid[0]) // // relaxed
        // return s_invalid[1];
        // if relaxed then return s_invalid, otherwise throw:
        throw new Error(`expected string_literal but invalid escape sequence within contents: '${s_invalid}'. failed to parse a valid token`);
        else throw new Error(`expected string_literal but invalid whitespace character within contents: ${JSON.stringify(s_invalid)}. failed to parse a valid token`);
    } else console.assert(`unexpected no match branch in escape sequence replace callback`);
};
const $9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\.))/g;
const $9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $9043c565d33eb642$var$unescape_literal_short_hard = (s_literal)=>s_literal.replace($9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS);
const $9043c565d33eb642$var$unescape_literal_short_soft = (s_literal)=>{
    let m_incomplete = $9043c565d33eb642$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($9043c565d33eb642$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
const $9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|(\\.))/g;
const $9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|(\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $9043c565d33eb642$var$unescape_literal_long_hard = (s_literal)=>s_literal.replace($9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_HARD, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS);
const $9043c565d33eb642$var$unescape_literal_long_soft = (s_literal)=>{
    let m_incomplete = $9043c565d33eb642$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($9043c565d33eb642$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT, $9043c565d33eb642$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
// lookbehind regexes
const [$9043c565d33eb642$var$R_STRLIT_ESCAPE_INCOMPLETE, $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_TERM, $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_TERM, $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_TERM, $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_TERM] = (()=>{
    function RegExp_$lookbehind_polyfill(s_input) {
        let m_match = RegExp.prototype.exec.call(this, s_input);
        if (m_match) {
            let i_start = m_match[0].length - m_match[1].length;
            m_match.index += i_start;
            m_match[0] = m_match[0].slice(i_start);
        }
        return m_match;
    }
    let mk_lookbehind_regex = (()=>{
        try {
            new RegExp("(?<!h)i"); // eslint-disable-line no-new
        } catch (e_compile) {
            return (f_lookbehind, r_polyfill, f_polyfill)=>{
                r_polyfill.exec = f_polyfill;
                return r_polyfill;
            };
        }
        return (f_lookbehind)=>f_lookbehind();
    })();
    return [
        // R_STRLIT_ESCAPE_INCOMPLETE
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)\\\\(|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7})$"), /^(?:(?:[^\\]|\\.)*)(\\(?:|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7}))$/, function RegExp_$lookbehind_polyfill_n(s_input) {
            let m_match = RegExp.prototype.exec.call(this, s_input);
            if (m_match) m_match.index += m_match[0].length - m_match[1].length;
            return m_match;
        }),
        // R_STRLIT_SHORT_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"\\s*', "g"), /(?:[^\\"]|\\.)*("\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_SHORT_SINGLE_TERM
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)'\\s*", "g"), /(?:[^\\']|\\.)*('\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_LONG_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"""\\s*', "g"), /(?:[^\\"]|\\.|""?(?!"))*("""\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_LONG_SINGLE_TERM
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)'''\\s*", "g"), /(?:[^\\']|\\.|''?(?!'))*('''\s*)/y, RegExp_$lookbehind_polyfill)
    ];
})();
const $9043c565d33eb642$var$match_prefixed_name_quick = (s, i)=>{
    $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
    return [
        $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s),
        $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex
    ];
};
const $9043c565d33eb642$var$match_prefixed_name_escapeless = (s, i)=>{
    $9043c565d33eb642$var$R_PREFIXED_NAME_ESCAPELESS.lastIndex = i;
    return [
        $9043c565d33eb642$var$R_PREFIXED_NAME_ESCAPELESS.exec(s),
        $9043c565d33eb642$var$R_PREFIXED_NAME_ESCAPELESS.lastIndex
    ];
};
const $9043c565d33eb642$var$match_prefixed_name = (s, i)=>{
    $9043c565d33eb642$var$R_PREFIXED_NAME.lastIndex = i;
    return [
        $9043c565d33eb642$var$R_PREFIXED_NAME.exec(s),
        $9043c565d33eb642$var$R_PREFIXED_NAME.lastIndex
    ];
};
function $9043c565d33eb642$var$Reader$syntax_error(k_self, i, si_state, s_info) {
    let i_off = Math.min(i, Math.abs(i - 15));
    let s = k_self.s;
    return k_self.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + `expected ${si_state} ${s_info || ""}.  failed to parse a valid token starting at ${s[i] ? '"' + s[i] + '"' : "<<EOF>>"}`);
}
class $9043c565d33eb642$var$Turtle_Reader extends $141f1697ab3cba12$exports.Transform {
    constructor(g_impls){
        super({
            // do not decode strings into buffers
            decodeStrings: false,
            // accept strings as input on writable side
            writableObjectMode: false,
            // output quad objects on readable side
            readableObjectMode: true,
            // implementations
            flush: g_impls.flush,
            transform: g_impls.transform
        });
    }
    // intercept pipe
    pipe(ds_out) {
        let ds_dst = ds_out;
        // non-object mode
        if (!ds_dst._writableState.objectMode) // transform to JSON
        ds_out = $141f1697ab3cba12$exports.quads_to_json();
        else if (ds_out.isGraphyWritable) // transform to writable data events
        ds_out = $141f1697ab3cba12$exports.quads_to_writable();
        // interim stream created
        if (ds_out !== ds_dst) {
            // forward output to super
            super.pipe(ds_out);
            // pipe outpu to destination
            return ds_out.pipe(ds_dst);
        } else return super.pipe(ds_dst);
    }
}
class $9043c565d33eb642$var$Reader {
    constructor(g_config = {}){
        // impl-specific configs
        let { // input medium
        input: g_input = null, // a state to inherit
        state: g_state = {} } = g_config;
        // inherit state from creator
        let { // index for anonymous blank node labels
        blank_node_index: i_anon = 0, // prefix map
        prefixes: h_prefixes = {}, // blank node label map
        labels: h_labels = {} } = g_state;
        let dc_factory = $266825253b7f24dc$exports.adopt(g_config.dataFactory || g_config.data_factory || $266825253b7f24dc$exports.unfiltered);
        let kt_default_graph = dc_factory.defaultGraph();
        // if data factory is not graphy, it might be returning the same object on each call to .defaultGraph()
        if (dc_factory !== $266825253b7f24dc$exports.unfiltered) // do not trust it, create a new object
        kt_default_graph = Object.create(kt_default_graph);
        let kt_rdf_first = dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#first");
        let blankNode = dc_factory.blankNode;
        let namedNode = dc_factory.namedNode;
        this.emit_data = $266825253b7f24dc$exports.unfiltered === dc_factory ? function() {
            ds_transform.push($9043c565d33eb642$var$quad(this));
        } : function() {
            let g_quad = dc_factory.quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_graph);
            ds_transform.push(g_quad);
        };
        // fields
        Object.assign(this, {
            // read index
            i: 0,
            // string buffer
            s: "",
            // string buffer length
            n: 0,
            // left-over string from previous data chunk
            pre: g_config.prepend || "",
            // debug state
            _b_debug: g_config.debug || false,
            // relax
            _b_relax: g_config.relax || false,
            // factory
            _dc_factory: dc_factory,
            // current reader state
            _f_state: this.statement,
            // map of current prefix ids => iris
            _h_prefixes: h_prefixes,
            // reader was destroyed by an error
            _b_destroyed: false,
            // current @base url
            _s_base_url: "",
            _s_base_url_scheme: "",
            _s_base_url_root: "",
            _s_base_url_path: "",
            // current data
            _kt_subject: null,
            _kt_predicate: kt_rdf_first,
            _kt_object: null,
            _kt_graph: kt_default_graph,
            _s_literal: "",
            // static terms
            _kt_rdf_type: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
            _kt_rdf_first: kt_rdf_first,
            _kt_rdf_rest: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"),
            _kt_rdf_nil: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"),
            _kt_default_graph: kt_default_graph,
            // queue of nested subject, predicate, state for blanknodes and collections
            _a_nested: [],
            // hash to keep track of all blank node labels in use
            _h_labels: h_labels,
            // event routing
            event: this.emit,
            data: this.emit_data,
            // for restoring the original event callback when resuming paused stream
            restore_data: this.emit_data,
            // keep a queue of data events to hold onto until stream resumes (only happens in rare conditions)
            _a_queue_event: [],
            // helper states
            _b_expecting_full_stop: false,
            _s_temp_prefix_id: null,
            _b_trim_start: true,
            anonymous_blank_node: (s_label)=>blankNode(s_label, true),
            // finds the next non-conflicting blank node label
            next_label () {
                let s_label = "";
                do s_label = "g" + i_anon++;
                while (this._h_labels[s_label]);
                // claim this label, and remember that we invented it
                this._h_labels[s_label] = 2;
                // return the label
                return s_label;
            },
            // what to do when reach eos
            eos: null,
            // which state to go to after end of statement
            after_end_of_statement: this.post_object,
            // maximum length of a token: defaults to 2048 => http://stackoverflow.com/a/417184/1641160
            _n_max_token_length: g_config.max_token_length || g_config.maxTokenLength || 2048,
            // maximum length of a string (overrides max_token_length): defaults to Infinity
            _n_max_string_length: g_config.max_string_length || g_config.maxStringLength || Infinity,
            // byte tracking
            _b_byte_tracking: g_config.byte_tracking || g_config.byteTracking || false,
            _nb_seen: 0,
            _nb_last: 0,
            _nb_curr: 0
        });
        if (g_config.relaxed) console.warn(new Error(`no such option 'relaxed'; did you mean 'relax' ?`).stack.replace(/^Error:/, "Warning:"));
        if ("validate" in g_config) console.warn(new Error(`option 'validate' has been deprecated. Validation is now enabled by default. Use the 'relax' option if you wish to disable validation.`).stack.replace(/^Error:/, "Warning:"));
        // term constructors
        Object.assign(this, !g_config.relax ? {
            blank_node (s_label) {
                // test valid blank node label
                if (!$9043c565d33eb642$var$RT_BLANK_NODE_VALID.test(s_label)) return this.error(`invalid blank node label: "${s_label}"`);
                // not first time use of label
                let z_label_state = this._h_labels[s_label];
                if (z_label_state) {
                    // label was used previously by document and has no conflict
                    if (1 === z_label_state) ; // eslint-disable-line no-empty
                    else if (2 === z_label_state) // so create a redirect mapping for this actual label & use it instead
                    s_label = this._h_labels[s_label] = this.next_label();
                    else // use redirected label
                    s_label = this._h_labels[s_label];
                } else // store label in hash so we avoid future collisions
                this._h_labels[s_label] = 1;
                // make term
                return blankNode(s_label);
            },
            check_named_node (p_iri) {
                if (!$9043c565d33eb642$var$RT_NAMED_NODE_VALID.test(p_iri)) return this.error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            check_named_node_escapeless (p_iri) {
                if (!$9043c565d33eb642$var$RT_NAMED_NODE_ESCAPELESS_VALID.test(p_iri)) return this.error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            match_prefixed_name_quick (s, i) {
                $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
                return [
                    $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s),
                    $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex
                ];
            },
            match_prefixed_name_escapeless (s, i) {
                let [m_prefixed_name_e, im_prefixed_name_e] = $9043c565d33eb642$var$match_prefixed_name_escapeless(s, i);
                if (m_prefixed_name_e) // invalid local name
                {
                    if (!$9043c565d33eb642$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID.test(m_prefixed_name_e[2]) && m_prefixed_name_e[2]) {
                        this.error(`invalid prefixed name local name: "${m_prefixed_name_e[2]}:"`);
                        return;
                    }
                }
                return [
                    m_prefixed_name_e,
                    im_prefixed_name_e
                ];
            },
            match_prefixed_name (s, i) {
                let [m_prefixed_name, im_prefixed_name] = $9043c565d33eb642$var$match_prefixed_name(s, i);
                if (m_prefixed_name) // invalid local name
                {
                    if (!$9043c565d33eb642$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID.test(m_prefixed_name[2])) {
                        this.error(`invalid prefixed name local name: "${m_prefixed_name[2]}:"`);
                        return;
                    }
                }
                return [
                    m_prefixed_name,
                    im_prefixed_name
                ];
            }
        } : {
            // term constructors
            blank_node (s_label) {
                // not first time use of label
                let z_label_state = this._h_labels[s_label];
                if (z_label_state) {
                    // label was used previously by document and has no conflict
                    if (1 === z_label_state) ; // eslint-disable-line no-empty
                    else if (2 === z_label_state) // so create a redirect mapping for this actual label & use it instead
                    s_label = this._h_labels[s_label] = this.next_label();
                    else // use redirected label
                    s_label = this._h_labels[s_label];
                } else // store label in hash so we avoid future collisions
                this._h_labels[s_label] = 1;
                // make term
                return blankNode(s_label);
            },
            check_named_node: namedNode,
            check_named_node_escapeless: namedNode,
            match_prefixed_name_escapeless: $9043c565d33eb642$var$match_prefixed_name_escapeless,
            match_prefixed_name: $9043c565d33eb642$var$match_prefixed_name
        });
        this.named_node = namedNode;
        this.prefixed_name = function(si_prefix, s_suffix) {
            return namedNode(h_prefixes[si_prefix] + s_suffix);
        };
        // oops -- user passed string into `base`
        if ("string" === typeof g_config.base) throw new TypeError(`invalid type 'string' was given for 'base' event listener: '${g_config.base}'\n` + `did you mean to use the 'base_uri' key instead?`);
        // base uri
        let p_set_base_uri = g_config.base_uri || g_config.baseUri || g_config.baseURI || g_config.base_iri || g_config.baseIri || g_config.baseIRI;
        if (p_set_base_uri) {
            let m_base_iri = $9043c565d33eb642$var$R_BASE_IRI.exec(p_set_base_uri);
            this._s_base_url = m_base_iri[1];
            this._s_base_url_root = m_base_iri[2] || "";
            this._s_base_url_scheme = m_base_iri[3] || "";
            this._s_base_url_path = m_base_iri[4] || "";
        } else if (g_config.base_url || g_config.baseUrl || g_config.baseURL) throw new Error(`invalid option: .base${g_config.base_url ? "_url" : g_config.baseUrl ? "Url" : g_config.baseURL ? "URL" : ""}; use the '.base_uri' key instead`);
        // transform stream
        let ds_transform = this.transform = new $9043c565d33eb642$var$Turtle_Reader({
            // on data event
            transform: (s_chunk, s_encoding, fke_chunk)=>{
                // concatenate current chunk to previous chunk
                let s = this.s = this.pre + s_chunk;
                // cache chunk length
                this.n = s.length;
                // eat whitespace before token and reset index
                if (this._b_trim_start) {
                    // consume whitespace (and incidentally reset index)
                    $9043c565d33eb642$var$R_WS.lastIndex = 0;
                    $9043c565d33eb642$var$R_WS.exec(s);
                    this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                } else this.i = 0;
                // resume parsing; no errors
                if (this.safe_parse(true)) {
                    // emit progress event updates
                    ds_transform.emit("progress", s_chunk.length);
                    // done transforming this chunk
                    fke_chunk();
                }
            },
            // once there's no more data to consume, invoke eof
            flush: (fke_flush)=>{
                // now that input stream has ended, clean up remainder
                try {
                    this.eof(1);
                } // read error occurred
                catch (e_eof) {
                    // destroy self and stream
                    this.destroy(e_eof);
                    // exit gracefully
                    return;
                }
                // no errors. done flushing, close read stream
                fke_flush();
            }
        });
        // when the writable side is piped into
        ds_transform.on("pipe", (ds_input)=>{
            this._ds_input = ds_input;
            let b_byte_tracking = this._b_byte_tracking;
            // byte-tracking is disable & input stream has encoding option; ensure stream encoding is utf8
            if (!b_byte_tracking && "function" === typeof ds_input.setEncoding) ds_input.setEncoding("utf8");
            else {
                let f_write = ds_transform.write;
                let d_decoder = new $eNRCS.StringDecoder("utf8");
                let f_write_track = (s_chunk, s_encoding, fk_write)=>{
                    // TODO: optimize by testing for multibyte chars and using string length instead?
                    let nb_chunk = $9043c565d33eb642$require$Buffer.from(s_chunk, "utf8").length;
                    this._nb_seen += nb_chunk;
                    this._nb_last = nb_chunk;
                    return f_write.call(ds_transform, s_chunk, s_encoding, fk_write);
                };
                let f_decode_write_track = (ab_chunk, s_encoding, fk_write)=>{
                    let nb_chunk = this._nb_last = ab_chunk.length;
                    this._nb_seen += nb_chunk;
                    return f_write.call(ds_transform, d_decoder.write(ab_chunk), s_encoding, fk_write);
                };
                let f_decode_write = (ab_chunk, s_encoding, fk_write)=>f_write.call(ds_transform, d_decoder.write(ab_chunk), s_encoding, fk_write);
                ds_transform.write = function(z_chunk, s_encoding, fk_write) {
                    // not null
                    if (null !== z_chunk) {
                        // chunk is string; adapt by resetting method to original
                        if ("string" === typeof z_chunk) ds_transform.write = b_byte_tracking ? f_write_track : f_write;
                        else ds_transform.write = b_byte_tracking ? f_decode_write_track : f_decode_write;
                        // use set method
                        return ds_transform.write(z_chunk, s_encoding, fk_write);
                    }
                    // null, use parent
                    return f_write.call(ds_transform, z_chunk, s_encoding, fk_write);
                };
                // byte tracking is enabled
                if (b_byte_tracking) // overwrite emit_data method
                this.emit_data = this.data = this.restore_data = function() {
                    let g_quad = this._dc_factory.quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_graph);
                    let nb_post = $9043c565d33eb642$require$Buffer.from(this.s.slice(this.i)).length;
                    let ib_post = this._nb_seen - nb_post;
                    g_quad.byteRange = [
                        this._nb_curr,
                        ib_post
                    ];
                    this._nb_curr = ib_post;
                    this.transform.push(g_quad);
                };
            }
        });
        // new listener added
        ds_transform.on("newListener", (s_event)=>{
            // comment
            if ("comment" === s_event) this.emit_comments = (s_captured)=>{
                let a_comments = s_captured.slice(1).replace(/\n\s+$/, "").split(/\n+\s*#/g);
                for (let s_comment of a_comments)ds_transform.emit("comment", s_comment);
            };
        });
        // destroy
        ds_transform._destroy = (...a_args)=>{
            this.destroy(...a_args);
        };
        // bind events to transform stream
        this.bind(g_config);
        // input given
        if (g_input) {
            // input is stream
            if (g_input.stream) {
                let ds_input = g_input.stream;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_input.pipe(ds_transform);
                });
            } else if ("string" === typeof g_input.string) {
                let s_input = g_input.string;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_transform.end(s_input, "utf8");
                });
            } else throw new TypeError(`Invalid argument for input parameter: ${"object" === typeof g_input ? JSON.stringify(g_input) : g_input}`);
        }
    }
    // begin parsing, keep applying until no more stack bail-outs
    safe_parse() {
        try {
            let f_sync = this._f_state();
            while("function" === typeof f_sync)f_sync = f_sync.apply(this);
        } // read error occurred
        catch (e_read) {
            // destroy self and stream
            this.destroy(e_read);
            // failure
            return false;
        }
        // okay
        return true;
    }
    emit(s_event, ...a_args) {
        this.transform.emit(s_event, ...a_args);
    }
    queue(s_event, ...a_args) {
        this._a_queue_event.push({
            event: s_event,
            args: a_args
        });
    }
    error(s_message) {
        // bail out
        throw new Error(s_message);
    }
    // parse_error (not meant to be an event callback)
    parse_error(s_expected, b_eof = false) {
        let i = this.i;
        let i_off = Math.min(i, Math.abs(i - 15));
        let s = this.s;
        return this.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + `expected ${s_expected} ${b_eof ? "but encountered <<EOF>>" : ""}.  failed to parse a valid token starting at ${s[i] ? '"' + s[i] + '"' : "<<EOF>>"}`);
    }
    info_error(s_message) {
        let i = this.i;
        let i_off = Math.min(i, Math.abs(i - 15));
        let s = this.s;
        this.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + s_message);
    }
    // end of file
    eof() {
        // there are events queued
        if (this._a_queue_event.length) {
            let a_queue = this._a_queue_event;
            // drain event queue
            while(a_queue.length){
                // remove event from front of queue
                let h_event = a_queue.shift();
                // make event callback
                this[h_event.event](h_event.data);
            }
        }
        // invalid parsing state
        if (this.statement !== this._f_state) {
            // append EOF char
            this.s += "\x00";
            // exit "flowing" mode
            this.n = this.s.length;
            // resume parsing; no errors
            if (this.safe_parse()) {
                // eof has occurred under safe parse
                if (null === this.s) return;
                // still invalid parsing state
                if (this.statement !== this._f_state) return this.parse_error(this._f_state.name, true);
            }
        }
        // there are still unparsed characters
        if (this.i < this.n) {
            // consume whitespace and comments
            let s = this.s;
            let i = this.i;
            // consume whitespace (and incidentally reset index)
            $9043c565d33eb642$var$R_WS.lastIndex = i;
            $9043c565d33eb642$var$R_WS.exec(s);
            i = $9043c565d33eb642$var$R_WS.lastIndex;
            $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
            let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
            // advance beyond comment
            if ($9043c565d33eb642$var$R_COMMENT.lastIndex > i) {
                this.i = i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                if (this.emit_comments) this.emit_comments(m_comment[0]);
            }
            // still unparsed characters
            if (i < this.n) {
                // not EOF
                if (!(i === this.n - 1 && "\x00" === s[i])) // bad input; parse error
                return this.parse_error(this._f_state.name);
            }
        }
        // make buffer's alloc eligible for gc
        this.s = null;
        // transform stream
        let ds_transform = this.transform;
        // final progress update: no additional bytes were read
        ds_transform.emit("progress", 0);
        // call end event listener
        ds_transform.emit("eof", this._h_prefixes);
        // close write stream (EOF-signaling)
        ds_transform.push(null);
    }
    // bind event listeners to transform stream
    bind(g_config) {
        let ds_transform = this.transform;
        if (g_config.base) ds_transform.on("base", g_config.base);
        if (g_config.prefix) ds_transform.on("prefix", g_config.prefix);
        if (g_config.comment) ds_transform.on("comment", g_config.comment);
        if (g_config.error) ds_transform.on("error", g_config.error);
        if (g_config.read) ds_transform.once("read", g_config.read);
        if (g_config.progress) ds_transform.on("progress", g_config.progress);
        if (g_config.eof) ds_transform.once("eof", g_config.eof);
        if (g_config.end) ds_transform.once("end", g_config.end);
        if (g_config.finish) ds_transform.once("finish", g_config.finish);
        if (g_config.data) ds_transform.on("data", g_config.data);
    }
    // after a blank node subject (either property-list or colleciton)
    post_blank_subject() {
        let { s: s, i: i } = this;
        if ("." === s[i]) {
            // consume whitespace (and incidentally reset index)
            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
            $9043c565d33eb642$var$R_WS.exec(s);
            this.i = $9043c565d33eb642$var$R_WS.lastIndex;
            return this.statement();
        }
        return this.pairs();
    }
    // parse state for statement
    statement() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefixed name quick
            // prepare sticky regex index
            $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
            // execute regex
            let m_pnq_subject = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s);
            // regex was a match
            if (m_pnq_subject) {
                // advance index
                this.i = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex;
                // check valid prefix
                let s_prefix_id = m_pnq_subject[1] || "";
                // invalid prefix
                if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // commit subject iri from resolve prefixed name
                this._kt_subject = this.prefixed_name(s_prefix_id, m_pnq_subject[2]);
                // predicate-object pairs state
                return this.pairs();
            // iriref
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_subject = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_subject) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_e_subject[1];
                    // absolute iri
                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                    this._kt_subject = this.check_named_node_escapeless(s_iri);
                    else this._kt_subject = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // predicate-object pairs state
                    return this.pairs();
                // prefixed name
                } else {
                    // try match
                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                    // stack bail out
                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                    let [m_prefixed_named_e_subject, im_prefixed_named_e_subject] = aw_valid_this_match_prefixed_name_escapeless;
                    if (m_prefixed_named_e_subject) {
                        // advance index
                        this.i = im_prefixed_named_e_subject;
                        // check valid prefix
                        let s_prefix_id = m_prefixed_named_e_subject[1] || "";
                        // invalid prefix
                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                        // make subject key
                        this._kt_subject = this.prefixed_name(s_prefix_id, m_prefixed_named_e_subject[2]);
                        // predicate-object pairs state
                        return this.pairs();
                    // blank node label
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex = i;
                        // execute regex
                        let m_blank_node_label_subject = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.exec(s);
                        // regex was a match
                        if (m_blank_node_label_subject) {
                            // advance index
                            this.i = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex;
                            // extract label
                            let s_label = m_blank_node_label_subject[1];
                            // make subject key
                            this._kt_subject = this.blank_node(s_label);
                            // predicate-object pairs state
                            return this.pairs();
                        // anonymous blank node subject
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_ANONYMOUS_BLANK_NODE.lastIndex = i;
                            if ($9043c565d33eb642$var$R_ANONYMOUS_BLANK_NODE.exec(s)) {
                                // advance index
                                this.i = $9043c565d33eb642$var$R_ANONYMOUS_BLANK_NODE.lastIndex;
                                // set new blank node as subject
                                this._kt_subject = this.anonymous_blank_node(this.next_label());
                                // goto pairs state for inside property list
                                return this.pairs();
                            // anonymous blank node property list subject
                            } else {
                                // prepare sticky regex index
                                $9043c565d33eb642$var$R_CHAR_BLANK_NODE.lastIndex = i;
                                if ($9043c565d33eb642$var$R_CHAR_BLANK_NODE.exec(s)) {
                                    // advance index
                                    this.i = $9043c565d33eb642$var$R_CHAR_BLANK_NODE.lastIndex;
                                    // enter blank node
                                    this._kt_subject = this.anonymous_blank_node(this.next_label());
                                    // how to resume when we pop state
                                    this._a_nested.push([
                                        this._kt_subject,
                                        this._kt_predicate,
                                        "post_blank_subject"
                                    ]);
                                    // goto pairs state for inside property list
                                    return this.pairs();
                                // rdf collection
                                } else {
                                    // prepare sticky regex index
                                    $9043c565d33eb642$var$R_CHAR_COLLECTION.lastIndex = i;
                                    if ($9043c565d33eb642$var$R_CHAR_COLLECTION.exec(s)) {
                                        // advance index
                                        this.i = $9043c565d33eb642$var$R_CHAR_COLLECTION.lastIndex;
                                        // indicate that collection subject should emit an initial statement
                                        this._kt_subject = null;
                                        // (don't push state, we don't have a subject yet)
                                        // goto collection-subject state
                                        return this.collection_subject();
                                    // prefix with interupt (e.g., a comment)
                                    } else {
                                        // prepare sticky regex index
                                        $9043c565d33eb642$var$R_PREFIX_KEYWORD.lastIndex = i;
                                        // execute regex
                                        let m_prefix_keyword = $9043c565d33eb642$var$R_PREFIX_KEYWORD.exec(s);
                                        // regex was a match
                                        if (m_prefix_keyword) {
                                            // advance index
                                            this.i = $9043c565d33eb642$var$R_PREFIX_KEYWORD.lastIndex;
                                            // save whether or not to expect a full stop
                                            this._b_expecting_full_stop = !!m_prefix_keyword[1];
                                            // goto prefix state
                                            return this.prefix_id();
                                        // base with interupt (e.g., a comment)
                                        } else {
                                            // prepare sticky regex index
                                            $9043c565d33eb642$var$R_BASE_KEYWORD.lastIndex = i;
                                            // execute regex
                                            let m_base_keyword = $9043c565d33eb642$var$R_BASE_KEYWORD.exec(s);
                                            // regex was a match
                                            if (m_base_keyword) {
                                                // advance index
                                                this.i = $9043c565d33eb642$var$R_BASE_KEYWORD.lastIndex;
                                                // save whether or not to expect a full stop
                                                this._b_expecting_full_stop = !!m_base_keyword[1];
                                                // goto base state
                                                return this.base_iri();
                                            // iriref
                                            } else {
                                                // prepare sticky regex index
                                                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                                                // execute regex
                                                let m_iriref_subject = $9043c565d33eb642$var$R_IRIREF.exec(s);
                                                // regex was a match
                                                if (m_iriref_subject) {
                                                    // advance index
                                                    this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                                    // ref iri
                                                    let s_iri = m_iriref_subject[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                                    // absolute iri
                                                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                                                    this._kt_subject = this.check_named_node(s_iri);
                                                    else this._kt_subject = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                                    // predicate-object pairs state
                                                    return this.pairs();
                                                // prefixed name
                                                } else {
                                                    // try match
                                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                                    // stack bail out
                                                    if (!aw_valid_this_match_prefixed_name) return true;
                                                    let [m_prefixed_named_subject, im_prefixed_named_subject] = aw_valid_this_match_prefixed_name;
                                                    if (m_prefixed_named_subject) {
                                                        // advance index
                                                        this.i = im_prefixed_named_subject;
                                                        // check valid prefix
                                                        let s_prefix_id = m_prefixed_named_subject[1] || "";
                                                        // invalid prefix
                                                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                        // escape local escapes
                                                        let s_suffix = m_prefixed_named_subject[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                                        // make subject key
                                                        this._kt_subject = this.prefixed_name(s_prefix_id, s_suffix);
                                                        // predicate-object pairs state
                                                        return this.pairs();
                                                    // comment
                                                    } else {
                                                        // prepare sticky regex index
                                                        $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                                        // execute regex
                                                        let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                                        // regex was a match
                                                        if (m_comment) {
                                                            // advance index
                                                            i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                            continue;
                                                        // not iriref, not prefixed name, not blank node label, not prefix id, not base
                                                        // match counter: 11
                                                        } else break;
                                                    } // brace #11
                                                } // brace #10
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("statement");
            }
        }
        // save state before pausing
        this._f_state = this.statement;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for pairs
    pairs() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // benchmarks indicate: regex for end of blank node property list faster than ch
            // iriref
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_predicate = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_predicate) {
                // advance index
                this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_predicate[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set predicate
                this._kt_predicate = this.check_named_node_escapeless(s_iri);
                else this._kt_predicate = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                // object-list state
                return this.object_list();
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_predicate, im_prefixed_named_e_predicate] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_predicate) {
                    // advance index
                    this.i = im_prefixed_named_e_predicate;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_predicate[1] || "";
                    // invalid prefix
                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // make predicate key
                    this._kt_predicate = this.prefixed_name(s_prefix_id, m_prefixed_named_e_predicate[2]);
                    // object-list state
                    return this.object_list();
                // 'a'
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_A.lastIndex = i;
                    if ($9043c565d33eb642$var$R_A.exec(s)) {
                        // advance index
                        this.i = $9043c565d33eb642$var$R_A.lastIndex;
                        // make predicate key
                        this._kt_predicate = this._kt_rdf_type;
                        // object-list state
                        return this.object_list();
                    // ']' end of blank node property list
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_CHAR_KET.lastIndex = i;
                        if ($9043c565d33eb642$var$R_CHAR_KET.exec(s)) {
                            // advance index
                            this.i = $9043c565d33eb642$var$R_CHAR_KET.lastIndex;
                            let s_resume_state;
                            [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                            return this[s_resume_state]();
                        // iriref
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                            // execute regex
                            let m_iriref_predicate = $9043c565d33eb642$var$R_IRIREF.exec(s);
                            // regex was a match
                            if (m_iriref_predicate) {
                                // advance index
                                this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                // ref iri
                                let s_iri = m_iriref_predicate[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                // absolute iri
                                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set predicate
                                this._kt_predicate = this.check_named_node(s_iri);
                                else this._kt_predicate = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // object-list state
                                return this.object_list();
                            // prefixed name
                            } else {
                                // try match
                                let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                // stack bail out
                                if (!aw_valid_this_match_prefixed_name) return true;
                                let [m_prefixed_named_predicate, im_prefixed_named_predicate] = aw_valid_this_match_prefixed_name;
                                if (m_prefixed_named_predicate) {
                                    // advance index
                                    this.i = im_prefixed_named_predicate;
                                    // check valid prefix
                                    let s_prefix_id = m_prefixed_named_predicate[1] || "";
                                    // invalid prefix
                                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                    // escape local escapes
                                    let s_suffix = m_prefixed_named_predicate[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                    // make predicate key
                                    this._kt_predicate = this.prefixed_name(s_prefix_id, s_suffix);
                                    // object-list state
                                    return this.object_list();
                                } else {
                                    // prepare sticky regex index
                                    $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                    // execute regex
                                    let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                    // regex was a match
                                    if (m_comment) {
                                        // advance index
                                        i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                                        continue;
                                    // not iriref, not prefixed name, not 'a'
                                    // match counter: 6
                                    } else break;
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("pairs");
            }
        }
        // save state before pausing
        this._f_state = this.pairs;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for object_list
    object_list() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // string literal * double
            if ('"' === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ('"' === s[i + 1] && '"' === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_double();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_double();
                    }
                } else if (i + 1 < n && '"' !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_double();
                } else break;
            // prefixed name quick
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
                // execute regex
                let m_pnq_object = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s);
                // regex was a match
                if (m_pnq_object) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex;
                    // check valid prefix
                    let s_prefix_id = m_pnq_object[1] || "";
                    // invalid prefix
                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_pnq_object[2]);
                // iriref
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                    // execute regex
                    let m_iriref_e_object = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
                    // regex was a match
                    if (m_iriref_e_object) {
                        // advance index
                        this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                        // ref iri
                        let s_iri = m_iriref_e_object[1];
                        // absolute iri
                        if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                        this._kt_object = this.check_named_node_escapeless(s_iri);
                        else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // prefixed name
                    } else {
                        // try match
                        let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                        // stack bail out
                        if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                        let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                        if (m_prefixed_named_e_object) {
                            // advance index
                            this.i = im_prefixed_named_e_object;
                            // check valid prefix
                            let s_prefix_id = m_prefixed_named_e_object[1] || "";
                            // invalid prefix
                            if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                            // commit object iri from resolve prefixed name
                            this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                        // string literal * single
                        } else if ("'" === x) {
                            // enough chars to deduce type
                            if (i + 2 < n) {
                                // long type
                                if ("'" === s[i + 1] && "'" === s[i + 2]) {
                                    // advance index beyond token
                                    this.i = i + 3;
                                    // read contents
                                    return this.string_literal_long_single();
                                } else {
                                    // advance index beyond token
                                    this.i = i + 1;
                                    // read contents
                                    return this.string_literal_short_single();
                                }
                            } else if (i + 1 < n && "'" !== s[i + 1]) {
                                // advance index beyond token
                                this.i = i + 1;
                                // read contents
                                return this.string_literal_short_single();
                            } else break;
                        // numeric literal
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex = i;
                            // execute regex
                            let m_numeric_literal = $9043c565d33eb642$var$R_NUMERIC_LITERAL.exec(s);
                            // regex was a match
                            if (m_numeric_literal) {
                                // advance index
                                this.i = $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex;
                                // it has exponent term, xsd:double
                                if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                                else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                                else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                            // boolean literal
                            } else {
                                // prepare sticky regex index
                                $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex = i;
                                // execute regex
                                let m_boolean_literal = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.exec(s);
                                // regex was a match
                                if (m_boolean_literal) {
                                    // advance index
                                    this.i = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex;
                                    // make literal
                                    this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                                // blank node property list
                                } else if ("[" === x) {
                                    // advance index to next token
                                    // consume whitespace (and incidentally reset index)
                                    $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                                    $9043c565d33eb642$var$R_WS.exec(s);
                                    this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                                    // make object
                                    let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                                    // emit statement event
                                    this.data();
                                    // push state to stack
                                    this._a_nested.push([
                                        this._kt_subject,
                                        this._kt_predicate,
                                        "post_object"
                                    ]);
                                    // set new subject
                                    this._kt_subject = kt_blank_node;
                                    // goto parsing pairs state
                                    return this.pairs();
                                // labeled blank node
                                } else {
                                    // prepare sticky regex index
                                    $9043c565d33eb642$var$R_BLANK_NODE_LABEL_TERMINAL.lastIndex = i;
                                    // execute regex
                                    let m_blank_node_label_object = $9043c565d33eb642$var$R_BLANK_NODE_LABEL_TERMINAL.exec(s);
                                    // regex was a match
                                    if (m_blank_node_label_object) {
                                        // advance index
                                        this.i = $9043c565d33eb642$var$R_BLANK_NODE_LABEL_TERMINAL.lastIndex;
                                        // ref blank node label
                                        let s_label = m_blank_node_label_object[1];
                                        // make object
                                        this._kt_object = this.blank_node(s_label);
                                    // collection
                                    } else if ("(" === x) {
                                        // advance index to next token
                                        // consume whitespace (and incidentally reset index)
                                        $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                                        $9043c565d33eb642$var$R_WS.exec(s);
                                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                                        // state to resume after collection ends
                                        this._a_nested.push([
                                            this._kt_subject,
                                            this._kt_predicate,
                                            "post_object"
                                        ]);
                                        // goto collection-object state
                                        return this.collection_object();
                                    // iriref
                                    } else {
                                        // prepare sticky regex index
                                        $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                                        // execute regex
                                        let m_iriref_object = $9043c565d33eb642$var$R_IRIREF.exec(s);
                                        // regex was a match
                                        if (m_iriref_object) {
                                            // advance index
                                            this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                            // ref iri
                                            let s_iri = m_iriref_object[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                            // absolute iri
                                            if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                            this._kt_object = this.check_named_node(s_iri);
                                            else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                        // prefixed name
                                        } else {
                                            // try match
                                            let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                            // stack bail out
                                            if (!aw_valid_this_match_prefixed_name) return true;
                                            let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                            if (m_prefixed_named_object) {
                                                // advance index
                                                this.i = im_prefixed_named_object;
                                                // check valid prefix
                                                let s_prefix_id = m_prefixed_named_object[1] || "";
                                                // invalid prefix
                                                if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                // escape local escapes
                                                let s_suffix = m_prefixed_named_object[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                                // commit object iri from resolve prefixed name
                                                this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                            } else {
                                                // prepare sticky regex index
                                                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                                // execute regex
                                                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                                // regex was a match
                                                if (m_comment) {
                                                    // advance index
                                                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                    continue;
                                                // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                                // match counter: 9
                                                } else break;
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            // fall through for cases that did not change state on their own
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("object_list");
            }
        }
        // save state before pausing
        this._f_state = this.object_list;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_short_double
    string_literal_short_double() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_short_double: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case '"':
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $9043c565d33eb642$var$R_WS.lastIndex = i_break + 1;
                        $9043c565d33eb642$var$R_WS.exec(s);
                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_TERM.lastIndex = i_break;
                            let m_term = $9043c565d33eb642$var$R_STRLIT_SHORT_DOUBLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $9043c565d33eb642$var$unescape_literal_short_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $9043c565d33eb642$var$unescape_literal_short_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_short_double;
                            }
                        }
                    // invalid '\n'
                    case "\n":
                        return this.info_error(`expected string_literal_short_double but invalid line feed character '\\n' (newline) within contents. failed to parse a valid token`);
                    // invalid '\r'
                    case "\r":
                        return this.info_error(`expected string_literal_short_double but invalid form feed character '\\r' (carriage return) within contents. failed to parse a valid token`);
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_short_double`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // save
                this._s_literal += i ? s.slice(i) : s;
                // set unparsed index
                i = n;
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_short_double");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_short_double;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_short_single
    string_literal_short_single() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_short_single: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case "'":
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $9043c565d33eb642$var$R_WS.lastIndex = i_break + 1;
                        $9043c565d33eb642$var$R_WS.exec(s);
                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_TERM.lastIndex = i_break;
                            let m_term = $9043c565d33eb642$var$R_STRLIT_SHORT_SINGLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $9043c565d33eb642$var$unescape_literal_short_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $9043c565d33eb642$var$unescape_literal_short_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_short_single;
                            }
                        }
                    // invalid '\n'
                    case "\n":
                        return this.info_error(`expected string_literal_short_single but invalid line feed character '\\n' (newline) within contents. failed to parse a valid token`);
                    // invalid '\r'
                    case "\r":
                        return this.info_error(`expected string_literal_short_single but invalid form feed character '\\r' (carriage return) within contents. failed to parse a valid token`);
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_short_single`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // save
                this._s_literal += i ? s.slice(i) : s;
                // set unparsed index
                i = n;
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_short_single");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_short_single;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_long_double
    string_literal_long_double() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_long_double: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case '"':
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $9043c565d33eb642$var$R_WS.lastIndex = i_break + 3;
                        $9043c565d33eb642$var$R_WS.exec(s);
                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_TERM.lastIndex = i_break;
                            let m_term = $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $9043c565d33eb642$var$unescape_literal_long_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $9043c565d33eb642$var$unescape_literal_long_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_long_double;
                            }
                        }
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_long_double`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // could be unfinished terminator
                $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM.lastIndex = i;
                let m_unfinished = $9043c565d33eb642$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM.exec(s);
                // unfinished terminator
                if (m_unfinished) {
                    // save valid portion
                    this._s_literal += s.slice(i, m_unfinished.index);
                    // set unparsed index
                    i = m_unfinished.index;
                } else {
                    // save
                    this._s_literal += i ? s.slice(i) : s;
                    // set unparsed index
                    i = n;
                }
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_long_double");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_long_double;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_long_single
    string_literal_long_single() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_long_single: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case "'":
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $9043c565d33eb642$var$R_WS.lastIndex = i_break + 3;
                        $9043c565d33eb642$var$R_WS.exec(s);
                        this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_TERM.lastIndex = i_break;
                            let m_term = $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $9043c565d33eb642$var$unescape_literal_long_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $9043c565d33eb642$var$unescape_literal_long_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_long_single;
                            }
                        }
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_long_single`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // could be unfinished terminator
                $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM.lastIndex = i;
                let m_unfinished = $9043c565d33eb642$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM.exec(s);
                // unfinished terminator
                if (m_unfinished) {
                    // save valid portion
                    this._s_literal += s.slice(i, m_unfinished.index);
                    // set unparsed index
                    i = m_unfinished.index;
                } else {
                    // save
                    this._s_literal += i ? s.slice(i) : s;
                    // set unparsed index
                    i = n;
                }
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_long_single");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_long_single;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal
    string_literal() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref character
            let x = s[i];
            // string literal * double
            if ('"' === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ('"' === s[i + 1] && '"' === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_double();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_double();
                    }
                } else if (i + 1 < n && '"' !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_double();
                } else break;
            // string literal * single
            } else if ("'" === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ("'" === s[i + 1] && "'" === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_single();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_single();
                    }
                } else if (i + 1 < n && "'" !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_single();
                } else break;
            // not string literal long single quote, not string literal single quote
            // match counter: 0
            } else break;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_string_length) return this.parse_error("string_literal");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for datatype_or_langtag
    datatype_or_langtag() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref character
            let x = s[i];
            // next token indicates datatype or langtag
            if ("^" === x || "@" === x) {
                // '^^' datatype
                // prepare sticky regex index
                $9043c565d33eb642$var$R_DOUBLE_CARET.lastIndex = i;
                if ($9043c565d33eb642$var$R_DOUBLE_CARET.exec(s)) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_DOUBLE_CARET.lastIndex;
                    return this.datatype();
                // '@' language tag
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_LANGTAG.lastIndex = i;
                    // execute regex
                    let m_langtag = $9043c565d33eb642$var$R_LANGTAG.exec(s);
                    // regex was a match
                    if (m_langtag) {
                        // advance index
                        this.i = $9043c565d33eb642$var$R_LANGTAG.lastIndex;
                        this._kt_object = this._dc_factory.languagedLiteral(this._s_literal, m_langtag[1]);
                        // reset literal
                        this._s_literal = "";
                    // next token definitely datatype or langtag, we are just being interrupted by eos
                    // match counter: 1
                    } else break;
                } // brace #1
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else {
                    this._kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                    // reset literal
                    this._s_literal = "";
                // not datatype, not language tag => that's okay! those are optional
                }
            } // brace #1
            // goto end of statement state
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype_or_langtag");
            }
        }
        // save state before pausing
        this._f_state = this.datatype_or_langtag;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for datatype
    datatype() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let kt_datatype = null;
            // prefixed name quick
            // prepare sticky regex index
            $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
            // execute regex
            let m_pnq_datatype = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.exec(s);
            // regex was a match
            if (m_pnq_datatype) {
                // advance index
                this.i = $9043c565d33eb642$var$R_PREFIXED_NAME_QUICK.lastIndex;
                // check valid prefix
                let s_prefix_id = m_pnq_datatype[1] || "";
                // invalid prefix
                if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // commit object iri from resolve prefixed name
                kt_datatype = this.prefixed_name(s_prefix_id, m_pnq_datatype[2]);
            // iriref
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_datatype = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_datatype) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                    let p_datatype;
                    // ref iri
                    let s_iri = m_iriref_e_datatype[1];
                    // absolute iri
                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_datatype
                    p_datatype = s_iri;
                    else p_datatype = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    kt_datatype = this.check_named_node_escapeless(p_datatype);
                // prefixed name
                } else {
                    // try match
                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                    // stack bail out
                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                    let [m_prefixed_named_e_datatype, im_prefixed_named_e_datatype] = aw_valid_this_match_prefixed_name_escapeless;
                    if (m_prefixed_named_e_datatype) {
                        // advance index
                        this.i = im_prefixed_named_e_datatype;
                        // check valid prefix
                        let s_prefix_id = m_prefixed_named_e_datatype[1] || "";
                        // invalid prefix
                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                        kt_datatype = this.prefixed_name(s_prefix_id, m_prefixed_named_e_datatype[2]);
                    // iriref
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                        // execute regex
                        let m_iriref_datatype = $9043c565d33eb642$var$R_IRIREF.exec(s);
                        // regex was a match
                        if (m_iriref_datatype) {
                            // advance index
                            this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                            let p_datatype;
                            // ref iri
                            let s_iri = m_iriref_e_datatype[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                            // absolute iri
                            if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_datatype
                            p_datatype = s_iri;
                            else p_datatype = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                            kt_datatype = this.check_named_node(p_datatype);
                        // prefixed name
                        } else {
                            // try match
                            let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                            // stack bail out
                            if (!aw_valid_this_match_prefixed_name) return true;
                            let [m_prefixed_named_datatype, im_prefixed_named_datatype] = aw_valid_this_match_prefixed_name;
                            if (m_prefixed_named_datatype) {
                                // advance index
                                this.i = im_prefixed_named_datatype;
                                // check valid prefix
                                let s_prefix_id = m_prefixed_named_datatype[1] || "";
                                // invalid prefix
                                if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                // escape local escapes
                                let s_suffix = m_prefixed_named_datatype[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                // set literal datatype
                                kt_datatype = this.prefixed_name(s_prefix_id, s_suffix);
                            // not iriref, not prefixed name
                            // match counter: 4
                            } else break;
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            this._kt_object = this._dc_factory.datatypedLiteral(this._s_literal, kt_datatype);
            // reset literal
            this._s_literal = "";
            // goto end of statement state
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype");
            }
        }
        // save state before pausing
        this._f_state = this.datatype;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for post_object
    post_object() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let i_reset = i;
            // benchmarks confirm: character ref faster than regexes in this context
            let x = s[i];
            // advance index to next token beyond delimiter
            // consume whitespace (and incidentally reset index)
            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
            $9043c565d33eb642$var$R_WS.exec(s);
            this.i = $9043c565d33eb642$var$R_WS.lastIndex;
            // ',' more objects
            if ("," === x) return this.object_list();
            else if (";" === x) {
                for(;;){
                    // next token is end of outer section
                    let s_peek = s[this.i];
                    if ("." === s_peek || "]" === s_peek || ";" === s_peek) // goto post_object state
                    return this.post_object();
                    else if ("#" === s_peek) {
                        // comment
                        i = this.i;
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                        // execute regex
                        let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                        // regex was a match
                        if (m_comment) {
                            // advance index
                            this.i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                            continue;
                        } else break;
                    } else if (this.i === n) break;
                    else return this.pairs();
                }
                // rather than pushing a dedicated state, just try again next chunk
                i = i_reset;
                break;
            // '.' end of statement
            } else if ("." === x) {
                // assert not nested
                if (this._a_nested.length) {
                    // reset index to that character
                    this.i = i;
                    // emit parse error
                    return this.parse_error("end_of_property_list");
                }
                return this.statement();
            // ']' end of property-object pairs
            } else if ("]" === x) {
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            // ')' end of collection
            } else if (")" === x) // should not be here
            return $9043c565d33eb642$var$Reader$syntax_error(this, i, "post_object", "but encountered end of collection");
            else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // comment interrupted by eos?
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("post_object");
            }
        }
        // save state before pausing
        this._f_state = this.post_object;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for base_iri
    base_iri() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefix id
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_base = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_base) {
                // advance index
                this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_base[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set base_url
                this._s_base_url = s_iri;
                else this._s_base_url = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                let m_base_iri = $9043c565d33eb642$var$R_BASE_IRI.exec(this._s_base_url);
                this._s_base_url = m_base_iri[1];
                this._s_base_url_root = m_base_iri[2] || "";
                this._s_base_url_scheme = m_base_iri[3] || "";
                this._s_base_url_path = m_base_iri[4] || "";
                // emit base event
                this.emit("base", this._s_base_url);
                if (this._b_expecting_full_stop) // change state
                return this.full_stop();
                // goto prefix iri state
                return this.statement();
            // prefix id
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                // execute regex
                let m_iriref_base = $9043c565d33eb642$var$R_IRIREF.exec(s);
                // regex was a match
                if (m_iriref_base) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_base[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                    // absolute iri
                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set base_url
                    this._s_base_url = s_iri;
                    else this._s_base_url = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    let m_base_iri = $9043c565d33eb642$var$R_BASE_IRI.exec(this._s_base_url);
                    this._s_base_url = m_base_iri[1];
                    this._s_base_url_root = m_base_iri[2] || "";
                    this._s_base_url_scheme = m_base_iri[3] || "";
                    this._s_base_url_path = m_base_iri[4] || "";
                    // emit base event
                    this.emit("base", this._s_base_url);
                    if (this._b_expecting_full_stop) // change state
                    return this.full_stop();
                    // goto prefix iri state
                    return this.statement();
                // for poorly-placed comments
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("base_iri");
            }
        }
        // save state before pausing
        this._f_state = this.base_iri;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for prefix_id
    prefix_id() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefix id
            // prepare sticky regex index
            $9043c565d33eb642$var$R_PREFIX_ID.lastIndex = i;
            // execute regex
            let m_prefix_id = $9043c565d33eb642$var$R_PREFIX_ID.exec(s);
            // regex was a match
            if (m_prefix_id) {
                // advance index
                this.i = $9043c565d33eb642$var$R_PREFIX_ID.lastIndex;
                // set temp prefix id
                this._s_temp_prefix_id = m_prefix_id[1];
                // goto prefix iri state
                return this.prefix_iri();
            // for poorly-placed comments
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("prefix_id");
            }
        }
        // save state before pausing
        this._f_state = this.prefix_id;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for prefix_iri
    prefix_iri() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let h_prefixes = this._h_prefixes;
            let s_prefix_id = this._s_temp_prefix_id;
            let p_prefix_iri;
            // prefix iri
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_prefix = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_prefix) {
                // advance index
                this.i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_prefix[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_prefix_iri
                p_prefix_iri = s_iri;
                else p_prefix_iri = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                let b_relax = this._b_relax;
                // existing mapping
                if (s_prefix_id in h_prefixes) // doesn't match existing
                {
                    if (p_prefix_iri !== h_prefixes[s_prefix_id]) {
                        // emit change event
                        if (this.prefix_change) this.prefix_change(s_prefix_id, h_prefixes[s_prefix_id], p_prefix_iri);
                        // update prefix
                        h_prefixes[s_prefix_id] = p_prefix_iri;
                    }
                } else {
                    // check namespace, invalid
                    if (!b_relax && !$9043c565d33eb642$var$RT_PREFIXED_NAME_NAMESPACE_VALID.test(s_prefix_id)) return this.error(`Invalid namespace for prefixed name: "${s_prefix_id}:"`);
                    // set prefix
                    h_prefixes[s_prefix_id] = p_prefix_iri;
                }
                // check iri, invalid
                if (!b_relax && !$9043c565d33eb642$var$RT_NAMED_NODE_VALID.test(p_prefix_iri)) return this.error(`Invalid IRI found in prefix delcaration: "${s_iri}"`);
                // emit prefix event
                this.event("prefix", s_prefix_id, p_prefix_iri);
                if (this._b_expecting_full_stop) // change state
                return this.full_stop();
                // goto statement state
                return this.statement();
            // prefix iri
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                // execute regex
                let m_iriref_prefix = $9043c565d33eb642$var$R_IRIREF.exec(s);
                // regex was a match
                if (m_iriref_prefix) {
                    // advance index
                    this.i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_prefix[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                    // absolute iri
                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_prefix_iri
                    p_prefix_iri = s_iri;
                    else p_prefix_iri = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    let b_relax = this._b_relax;
                    // existing mapping
                    if (s_prefix_id in h_prefixes) // doesn't match existing
                    {
                        if (p_prefix_iri !== h_prefixes[s_prefix_id]) {
                            // emit change event
                            if (this.prefix_change) this.prefix_change(s_prefix_id, h_prefixes[s_prefix_id], p_prefix_iri);
                            // update prefix
                            h_prefixes[s_prefix_id] = p_prefix_iri;
                        }
                    } else {
                        // check namespace, invalid
                        if (!b_relax && !$9043c565d33eb642$var$RT_PREFIXED_NAME_NAMESPACE_VALID.test(s_prefix_id)) return this.error(`Invalid namespace for prefixed name: "${s_prefix_id}:"`);
                        // set prefix
                        h_prefixes[s_prefix_id] = p_prefix_iri;
                    }
                    // check iri, invalid
                    if (!b_relax && !$9043c565d33eb642$var$RT_NAMED_NODE_VALID.test(p_prefix_iri)) return this.error(`Invalid IRI found in prefix delcaration: "${s_iri}"`);
                    // emit prefix event
                    this.event("prefix", s_prefix_id, p_prefix_iri);
                    if (this._b_expecting_full_stop) // change state
                    return this.full_stop();
                    // goto statement state
                    return this.statement();
                // for poorly-placed comments
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("prefix_iri");
            }
        }
        // save state before pausing
        this._f_state = this.prefix_iri;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // in case eos happens twice during prefix / base (extremely unlikely)
    // parse state for full_stop
    full_stop() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prepare sticky regex index
            $9043c565d33eb642$var$R_CHAR_STOP.lastIndex = i;
            if ($9043c565d33eb642$var$R_CHAR_STOP.exec(s)) {
                // advance index
                this.i = $9043c565d33eb642$var$R_CHAR_STOP.lastIndex;
                // resume statement
                return this.statement();
            // poorly-placed comment
            } else {
                // prepare sticky regex index
                $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // possibly interrupted by eos
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("full_stop");
            }
        }
        // save state before pausing
        this._f_state = this.full_stop;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for collection_subject
    collection_subject() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // end of collection
            if (")" === x) {
                // consume whitespace (and incidentally reset index)
                $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                $9043c565d33eb642$var$R_WS.exec(s);
                this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                // no items in collection subject
                if (null === this._kt_subject) {
                    // prepare subject
                    this._kt_subject = this._kt_rdf_nil;
                    // state was never pushed to stack, jump to post_subject state
                    return this.post_blank_subject();
                }
                // otherwise, there must be items in collection
                // commit collection end
                this._kt_object = this._kt_rdf_nil;
                this.data();
                // restore state from stack
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            }
            // otherwise, pre-emptively secure the next blank node label
            let s_pointer_label;
            // very first collection object
            let b_pushed = false;
            if (null === this._kt_subject) {
                // set quasi subject (really for resume state)
                s_pointer_label = this.next_label();
                this._kt_subject = this.anonymous_blank_node(s_pointer_label);
                this._a_nested.push([
                    this._kt_subject,
                    this._kt_predicate,
                    "pairs"
                ]);
                // reset subject for later conditional branch
                this._kt_subject = null;
                b_pushed = true;
            }
            // iriref
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_object = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_object) {
                // advance index
                i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_object[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                this._kt_object = this.check_named_node_escapeless(s_iri);
                else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_object) {
                    // advance index
                    i = im_prefixed_named_e_object;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_object[1] || "";
                    // invalid prefix
                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                // string literal
                } else if ('"' === x || "'" === x) {
                    // first item in list
                    if (null === this._kt_subject) {
                        s_pointer_label = this.next_label();
                        this._kt_subject = this.anonymous_blank_node(s_pointer_label);
                        this._kt_predicate = this._kt_rdf_first;
                    } else {
                        // make nest list item
                        s_pointer_label = this.next_label();
                        let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                        this.data();
                        // setup for object literal
                        this._kt_subject = kt_blank_node;
                        this._kt_predicate = this._kt_rdf_first;
                    }
                    // how to resume collection subject state after object literal
                    this.after_end_of_statement = function() {
                        this._kt_predicate = this._kt_rdf_rest;
                        this.after_end_of_statement = this.post_object;
                        return this.collection_subject();
                    };
                    return this.string_literal();
                // numeric literal
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex = i;
                    // execute regex
                    let m_numeric_literal = $9043c565d33eb642$var$R_NUMERIC_LITERAL.exec(s);
                    // regex was a match
                    if (m_numeric_literal) {
                        // advance index
                        i = $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex;
                        // it has exponent term, xsd:double
                        if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                        else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                        else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                    // boolean literal
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex = i;
                        // execute regex
                        let m_boolean_literal = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.exec(s);
                        // regex was a match
                        if (m_boolean_literal) {
                            // advance index
                            i = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex;
                            // make literal
                            this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                        // blank node property list
                        } else if ("[" === x) {
                            // advance index to next token
                            // consume whitespace (and incidentally reset index)
                            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                            $9043c565d33eb642$var$R_WS.exec(s);
                            this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                            // this blank node is just the next item in the list
                            s_pointer_label = this.next_label();
                            let kt_blank_node;
                            if (null !== this._kt_subject) {
                                kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                                this.data();
                            }
                            // subject needs to be set
                            this._kt_subject = kt_blank_node || this.anonymous_blank_node(s_pointer_label);
                            this._kt_predicate = this._kt_rdf_first;
                            let s_label = this.next_label();
                            kt_blank_node = this._kt_object = this.anonymous_blank_node(s_label);
                            this.data();
                            // when resume
                            this._kt_predicate = this._kt_rdf_rest;
                            // push state
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_subject"
                            ]);
                            // prepare next triple
                            this._kt_subject = kt_blank_node;
                            // goto parsing pairs state
                            return this.pairs();
                        // new collection
                        } else if ("(" === x) {
                            // consume whitespace (and incidentally reset index)
                            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                            $9043c565d33eb642$var$R_WS.exec(s);
                            i = $9043c565d33eb642$var$R_WS.lastIndex;
                            // empty collection
                            if (")" === s[i]) {
                                this.i = i;
                                this._kt_subject = this._a_nested[this._a_nested.length - 1][0];
                                this._kt_predicate = this._kt_rdf_first;
                                this._a_nested.push([
                                    this._kt_subject,
                                    this._kt_rdf_rest,
                                    "collection_subject"
                                ]);
                                return this.collection_object();
                            }
                            // commit list item pointer
                            s_pointer_label = this.next_label();
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                            this.data();
                            // add this list as an item to the outer list
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // prepare next triple
                            this._kt_predicate = this._kt_rdf_first;
                            continue;
                        // labeled blank node
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex = i;
                            // execute regex
                            let m_blank_node_label_object = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.exec(s);
                            // regex was a match
                            if (m_blank_node_label_object) {
                                // advance index
                                i = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex;
                                // ref blank node label
                                let s_label = m_blank_node_label_object[1];
                                // make object
                                this._kt_object = this.blank_node(s_label);
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                                // execute regex
                                let m_iriref_object = $9043c565d33eb642$var$R_IRIREF.exec(s);
                                // regex was a match
                                if (m_iriref_object) {
                                    // advance index
                                    i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                    // ref iri
                                    let s_iri = m_iriref_object[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                    // absolute iri
                                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                    this._kt_object = this.check_named_node(s_iri);
                                    else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name) return true;
                                    let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                    if (m_prefixed_named_object) {
                                        // advance index
                                        i = im_prefixed_named_object;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_object[1] || "";
                                        // invalid prefix
                                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // escape local escapes
                                        let s_suffix = m_prefixed_named_object[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                        // commit object iri from resolve prefixed name
                                        this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                    } else {
                                        // prepare sticky regex index
                                        $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                        // execute regex
                                        let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                        // regex was a match
                                        if (m_comment) {
                                            // advance index
                                            i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                            continue;
                                        // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                        // match counter: 7
                                        } else {
                                            // ran out of characters after pushing state, pop it
                                            if (b_pushed) this._a_nested.pop();
                                            break;
                                        }
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            let kt_blank_node_outer;
            if (!s_pointer_label) s_pointer_label = this.next_label();
            // not the very first item of collection subject
            if (this._kt_subject !== null) {
                // ref object
                let w_object = this._kt_object;
                // create blanknode to embed list
                kt_blank_node_outer = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                // emit statement that functions as collection's head "pointer"
                this.data();
                // swap back object
                this._kt_object = w_object;
            }
            // emit statement that is item
            this._kt_subject = kt_blank_node_outer || this.anonymous_blank_node(s_pointer_label);
            this._kt_predicate = this._kt_rdf_first;
            this.data();
            // prepare next predicate
            this._kt_predicate = this._kt_rdf_rest;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("collection_subject");
            }
        }
        // save state before pausing
        this._f_state = this.collection_subject;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for collection_object
    collection_object() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // end of collection
            if (")" === x) {
                // consume whitespace (and incidentally reset index)
                $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                $9043c565d33eb642$var$R_WS.exec(s);
                this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                // make & emit collection's tail "pointer"
                this._kt_object = this._kt_rdf_nil;
                this.data();
                // restore previous state
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            }
            // otherwise, pre-emptively secure the next blank node label
            let s_pointer_label;
            // iriref
            // prepare sticky regex index
            $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_object = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_object) {
                // advance index
                i = $9043c565d33eb642$var$R_IRIREF_ESCAPELESS.lastIndex;
                // commit object iri as is
                // ref iri
                let s_iri = m_iriref_e_object[1];
                // absolute iri
                if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                this._kt_object = this.check_named_node_escapeless(s_iri);
                else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_object) {
                    // advance index
                    i = im_prefixed_named_e_object;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_object[1] || "";
                    // invalid prefix
                    if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                // string literal
                } else if ('"' === x || "'" === x) {
                    // update index before changing states
                    this.i = i;
                    // create blanknode to embed list
                    let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                    // emit statement that functions as collection's head "pointer"
                    this.data();
                    // prepare statement that is item
                    this._kt_subject = kt_blank_node;
                    this._kt_predicate = this._kt_rdf_first;
                    this.after_end_of_statement = function() {
                        this._kt_predicate = this._kt_rdf_rest;
                        this.after_end_of_statement = this.post_object;
                        return this.collection_object();
                    };
                    return this.string_literal();
                // numeric literal
                } else {
                    // prepare sticky regex index
                    $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex = i;
                    // execute regex
                    let m_numeric_literal = $9043c565d33eb642$var$R_NUMERIC_LITERAL.exec(s);
                    // regex was a match
                    if (m_numeric_literal) {
                        // advance index
                        i = $9043c565d33eb642$var$R_NUMERIC_LITERAL.lastIndex;
                        // it has exponent term, xsd:double
                        if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                        else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                        else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                    // boolean literal
                    } else {
                        // prepare sticky regex index
                        $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex = i;
                        // execute regex
                        let m_boolean_literal = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.exec(s);
                        // regex was a match
                        if (m_boolean_literal) {
                            // advance index
                            i = $9043c565d33eb642$var$R_BOOLEAN_LITERAL.lastIndex;
                            // make literal
                            this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                        // blank node property list
                        } else if ("[" === x) {
                            // advance index to next token
                            // consume whitespace (and incidentally reset index)
                            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                            $9043c565d33eb642$var$R_WS.exec(s);
                            this.i = $9043c565d33eb642$var$R_WS.lastIndex;
                            // commit head of list pointer
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                            this.data();
                            // setup state to resume and push
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // enter blank node
                            this._kt_predicate = this._kt_rdf_first;
                            kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                            this.data();
                            // prepare next triple
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_first;
                            // goto parsing pairs state
                            return this.pairs();
                        // new collection
                        } else if ("(" === x) {
                            // consume whitespace (and incidentally reset index)
                            $9043c565d33eb642$var$R_WS.lastIndex = i + 1;
                            $9043c565d33eb642$var$R_WS.exec(s);
                            i = $9043c565d33eb642$var$R_WS.lastIndex;
                            // commit list item pointer
                            s_pointer_label = this.next_label();
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                            if (null === this._kt_subject) {
                                let a_recent = this._a_nested[this._a_nested.length - 1];
                                this._kt_subject = a_recent[0];
                                this._kt_predicate = a_recent[1];
                            }
                            this.data();
                            // add this list as an item to the outer list
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // prepare next triple
                            this._kt_predicate = this._kt_rdf_first;
                            continue;
                        // labeled blank node
                        } else {
                            // prepare sticky regex index
                            $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex = i;
                            // execute regex
                            let m_blank_node_label_object = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.exec(s);
                            // regex was a match
                            if (m_blank_node_label_object) {
                                // advance index
                                i = $9043c565d33eb642$var$R_BLANK_NODE_LABEL.lastIndex;
                                // ref blank node label
                                let s_label = m_blank_node_label_object[1];
                                // make collection pointer label first
                                s_pointer_label = this.next_label();
                                // make object
                                this._kt_object = this.blank_node(s_label);
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $9043c565d33eb642$var$R_IRIREF.lastIndex = i;
                                // execute regex
                                let m_iriref_object = $9043c565d33eb642$var$R_IRIREF.exec(s);
                                // regex was a match
                                if (m_iriref_object) {
                                    // advance index
                                    i = $9043c565d33eb642$var$R_IRIREF.lastIndex;
                                    // commit object iri as is
                                    // ref iri
                                    let s_iri = m_iriref_object[1].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY);
                                    // absolute iri
                                    if (!this._s_base_url || $9043c565d33eb642$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                    this._kt_object = this.check_named_node(s_iri);
                                    else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name) return true;
                                    let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                    if (m_prefixed_named_object) {
                                        // advance index
                                        i = im_prefixed_named_object;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_object[1] || "";
                                        // invalid prefix
                                        if (!$9043c565d33eb642$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // escape local escapes
                                        let s_suffix = m_prefixed_named_object[2].replace($9043c565d33eb642$var$R_UNICODE_ANY, $9043c565d33eb642$var$F_REPLACE_UNICODE_ANY).replace($9043c565d33eb642$var$R_PN_LOCAL_ESCAPES, "$1");
                                        // commit object iri from resolve prefixed name
                                        this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                    } else {
                                        // prepare sticky regex index
                                        $9043c565d33eb642$var$R_COMMENT.lastIndex = i;
                                        // execute regex
                                        let m_comment = $9043c565d33eb642$var$R_COMMENT.exec(s);
                                        // regex was a match
                                        if (m_comment) {
                                            // advance index
                                            i = $9043c565d33eb642$var$R_COMMENT.lastIndex;
                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                            continue;
                                        // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                        // match counter: 7
                                        } else break;
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            // ref object
            let w_object = this._kt_object;
            // create blanknode to embed list
            if (!s_pointer_label) s_pointer_label = this.next_label();
            let kt_blank_node_outer = this._kt_object = this.anonymous_blank_node(s_pointer_label);
            // emit statement that functions as collection's head "pointer"
            this.data();
            // emit statement that is item
            this._kt_subject = kt_blank_node_outer;
            this._kt_predicate = this._kt_rdf_first;
            this._kt_object = w_object;
            this.data();
            // prepare next predicate
            this._kt_predicate = this._kt_rdf_rest;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("collection_object");
            }
        }
        // save state before pausing
        this._f_state = this.collection_object;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    destroy(e_destroy) {
        this.post_blank_subject = ()=>{};
        this.statement = ()=>{};
        this.pairs = ()=>{};
        this.object_list = ()=>{};
        this.string_literal_short_double = ()=>{};
        this.string_literal_short_single = ()=>{};
        this.string_literal_long_double = ()=>{};
        this.string_literal_long_single = ()=>{};
        this.string_literal = ()=>{};
        this.datatype_or_langtag = ()=>{};
        this.datatype = ()=>{};
        this.post_object = ()=>{};
        this.base_iri = ()=>{};
        this.prefix_id = ()=>{};
        this.prefix_iri = ()=>{};
        this.full_stop = ()=>{};
        this.collection_subject = ()=>{};
        this.collection_object = ()=>{};
        this.eof = ()=>{
            this.s = null;
        };
        this._b_destroyed = true;
        // propagate input destroy
        if (!e_destroy && this._ds_input) this._ds_input.destroy(e_destroy);
        this.transform.demolish(e_destroy);
    }
}
$9043c565d33eb642$exports = function(...a_args) {
    let g_config = {};
    // at least one argument
    if (a_args.length) {
        let z_arg_0 = a_args[0];
        // input given unspecified
        if (z_arg_0 && z_arg_0.input && "undefined" === typeof z_arg_0.input.string && !z_arg_0.input.stream) z_arg_0 = z_arg_0.input;
        // string
        if ("string" === typeof z_arg_0) g_config.input = {
            string: z_arg_0
        };
        else if (null === z_arg_0) g_config.input = null;
        else if ("function" === typeof z_arg_0.setEncoding) g_config.input = {
            stream: z_arg_0
        };
        else if ("function" === typeof z_arg_0.pipeTo) throw new TypeError(`Sorry, WHATWG streams are currently not supported :(`);
        else if (z_arg_0 && "object" === typeof z_arg_0 && "[object Object]" === Object.prototype.toString.call(z_arg_0)) {
            g_config = z_arg_0;
            // more args; invalid
            if (a_args.length > 1) throw new TypeError(`unexpected argument(s) after config struct: ${a_args.slice(1)}`);
        } else throw new TypeError(`unexpected input type: ${z_arg_0}`);
        // more args
        if (a_args.length > 1) {
            // copy onto struct
            Object.assign(g_config, a_args[1]);
            // more args
            if (a_args.length > 2) throw new TypeError(`unexpected argument(s) after input and config struct: ${a_args.slice(2)}`);
        }
    }
    // create reader, return transform stream
    return new $9043c565d33eb642$var$Reader(g_config).transform;
};


var $7d44226cc0f38078$exports = {};
// queueMicrotask shim
// not defined or not a function
if ("function" !== typeof queueMicrotask) {
    // create resolved promise
    let dp_resolve = Promise.resolve();
    // try to redefine
    try {
        // eslint-disable-next-line no-global-assign
        queueMicrotask = (fk)=>dp_resolve.then(fk).catch((e_callback)=>setTimeout(()=>{
                    throw e_callback;
                }, 0));
    } // oh well, at least we tried
    catch (e_define) {}
}


const $7d44226cc0f38078$var$RT_ABSOLUTE_IRI_VALID = /^[a-z][a-z0-9+\-.]*:(?:[^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $7d44226cc0f38078$var$RT_ABSOLUTE_IRI_ESCAPELESS_VALID = /^[a-z][a-z0-9+\-.]*:[^\0-\x20<>"{}|^`]*$/;
const $7d44226cc0f38078$var$RT_NAMED_NODE_VALID = /^([^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $7d44226cc0f38078$var$RT_NAMED_NODE_ESCAPELESS_VALID = /^([^\0-\x20<>"{}|^`])*$/;
const $7d44226cc0f38078$var$R_UNICODE_ANY = /\\u([0-9A-Fa-f]{4})|\\U([0-9A-Fa-f]{8})/g;
const $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY = (s_, s_4, s_8)=>String.fromCodePoint(parseInt(s_4 || s_8, 16));
const $7d44226cc0f38078$var$R_CLEAN = /\s*(?:#[^\n]*\n\s*)*\s*/y;
const $7d44226cc0f38078$var$R_CLEAN_COMMENTS = /\s*(#[^\n]*\n\s*)*\s*/y;
const $7d44226cc0f38078$var$RT_HAS_ESCAPES = /[\\]/;
const $7d44226cc0f38078$var$R_EOL = /[^\n]+\n/y;
// eslint-disable-next-line no-misleading-character-class
const $7d44226cc0f38078$var$RT_BLANK_NODE_LABEL_VALID = /^(?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_0-9])(?:(?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.])*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?$/u;
const $7d44226cc0f38078$var$RT_LANGUAGE_VALID = /^[a-z]+(-[a-z0-9]+)*$/;
const $7d44226cc0f38078$var$R_WS = /\s*/y;
const $7d44226cc0f38078$var$R_HWS = /[ \t]*/y;
const $7d44226cc0f38078$var$R_LANGTAG = /@([A-Za-z]+(?:-[A-Za-z0-9-]+)*)(?:\s+|(?=[.,;\])#]))/y;
const $7d44226cc0f38078$var$R_IRIREF = /<([^>]*)>\s*/y;
const $7d44226cc0f38078$var$F_REPLACE_STRLIT_CONTENTS = (s_, s_whitespace, s_auto, s_4, s_8, s_invalid)=>{
    if (s_whitespace) switch(s_whitespace){
        case "t":
            return "	";
        case "n":
            return "\n";
        case "r":
            return "\r";
        case "f":
            return "\f";
        case "b":
            return "\b";
        default:
            console.assert(`bad regex escape char mapping: '${s_whitespace}'`);
    }
    else if (s_auto) return s_auto;
    else if (s_4) return String.fromCodePoint(parseInt(s_4, 16));
    else if (s_8) return String.fromCodePoint(parseInt(s_8, 16));
    else if (s_invalid) {
        // pointless escape
        if ("\\" === s_invalid[0]) // // relaxed
        // return s_invalid[1];
        // if relaxed then return s_invalid, otherwise throw:
        throw new Error(`expected string_literal but invalid escape sequence within contents: '${s_invalid}'. failed to parse a valid token`);
        else throw new Error(`expected string_literal but invalid whitespace character within contents: ${JSON.stringify(s_invalid)}. failed to parse a valid token`);
    } else console.assert(`unexpected no match branch in escape sequence replace callback`);
};
const $7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\.))/g;
const $7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $7d44226cc0f38078$var$unescape_literal_short_hard = (s_literal)=>s_literal.replace($7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD, $7d44226cc0f38078$var$F_REPLACE_STRLIT_CONTENTS);
const $7d44226cc0f38078$var$unescape_literal_short_soft = (s_literal)=>{
    let m_incomplete = $7d44226cc0f38078$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $7d44226cc0f38078$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($7d44226cc0f38078$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $7d44226cc0f38078$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
// lookbehind regexes
const [$7d44226cc0f38078$var$R_STRLIT_ESCAPE_INCOMPLETE, $7d44226cc0f38078$var$R_STRLIT_SHORT_DOUBLE_TERM] = (()=>{
    function RegExp_$lookbehind_polyfill(s_input) {
        let m_match = RegExp.prototype.exec.call(this, s_input);
        if (m_match) {
            let i_start = m_match[0].length - m_match[1].length;
            m_match.index += i_start;
            m_match[0] = m_match[0].slice(i_start);
        }
        return m_match;
    }
    let mk_lookbehind_regex = (()=>{
        try {
            new RegExp("(?<!h)i"); // eslint-disable-line no-new
        } catch (e_compile) {
            return (f_lookbehind, r_polyfill, f_polyfill)=>{
                r_polyfill.exec = f_polyfill;
                return r_polyfill;
            };
        }
        return (f_lookbehind)=>f_lookbehind();
    })();
    return [
        // R_STRLIT_ESCAPE_INCOMPLETE
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)\\\\(|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7})$"), /^(?:(?:[^\\]|\\.)*)(\\(?:|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7}))$/, function RegExp_$lookbehind_polyfill_n(s_input) {
            let m_match = RegExp.prototype.exec.call(this, s_input);
            if (m_match) m_match.index += m_match[0].length - m_match[1].length;
            return m_match;
        }),
        // R_STRLIT_SHORT_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"\\s*', "g"), /(?:[^\\"]|\\.)*("\s*)/y, RegExp_$lookbehind_polyfill)
    ];
})();
const $7d44226cc0f38078$var$R_TRIPLE_ESCAPELESS_SP = /(?:<([^\\>]*)>|_:([^\x20\t<]+))[\x20\t]*<([^\\>]*)>[\x20\t]*(?:(?:(<[^\\>]*)>|_:([^\x20\t<]+))[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+|"([^"\\]*)(?:(")(?:\^\^<([^\\>]*)>|@([^\x20\t.]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+)?)/y;
const $7d44226cc0f38078$var$R_TRIPLE = /(?:<([^>]*)>|_:([^\x20\t<]+))[\x20\t]*<([^>]*)>[\x20\t]*(?:(?:(<[^>]*)>|_:([^\x20\t<]+))[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+|"((?:[^"\\]|\\.)*)(?:(")(?:\^\^<([^>]*)>|@([^\x20\t.]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+)?)/y;
class $7d44226cc0f38078$var$NTriples_Reader extends $141f1697ab3cba12$exports.Transform {
    constructor(g_impls){
        super({
            // do not decode strings into buffers
            decodeStrings: false,
            // accept strings as input on writable side
            writableObjectMode: false,
            // output quad objects on readable side
            readableObjectMode: true,
            // implementations
            flush: g_impls.flush,
            transform: g_impls.transform
        });
        // when the writable side is piped into
        this.on("pipe", (ds_input)=>{
            this._ds_input = ds_input;
            // input stream has encoding option; ensure stream encoding is utf8
            if ("function" === typeof ds_input.setEncoding) ds_input.setEncoding("utf8");
        });
    }
    // intercept pipe
    pipe(ds_out) {
        let ds_dst = ds_out;
        // non-object mode
        if (!ds_dst._writableState.objectMode) // transform to JSON
        ds_out = $141f1697ab3cba12$exports.quads_to_json();
        else if (ds_out.isGraphyWritable) // transform to quad-stream
        ds_out = $141f1697ab3cba12$exports.quads_to_writable();
        // interim stream created
        if (ds_out !== ds_dst) {
            // forward output to super
            super.pipe(ds_out);
            // pipe outpu to destination
            return ds_out.pipe(ds_dst);
        } else return super.pipe(ds_dst);
    }
}
class $7d44226cc0f38078$var$Reader {
    constructor(g_config){
        let { // input medium
        input: g_input = null, // relax validation
        relax: b_relax = false, // debug
        debug: b_debug = false } = g_config;
        // allow relative iris flag
        let b_allow_relative_iris = g_config.allow_relative_iris || g_config.allowRelativeIRIs || g_config.allowRelativeIris || false;
        // adopt factory
        let dc_factory = this._dc_factory = $266825253b7f24dc$exports.adopt(g_config.dataFactory || g_config.data_factory || $266825253b7f24dc$exports.unfiltered);
        let f_quad = this._f_quad = dc_factory.quad;
        // fields
        Object.assign(this, {
            // string buffer, accept left-over string from previous data chunk
            s: g_config.prepend || "",
            // string buffer length
            n: 0,
            _b_debug: b_debug,
            _b_relax: b_relax,
            _b_destroyed: false,
            _b_trim_start: true,
            _f_state: this.statement,
            _kt_subject: null,
            _kt_predicate: null,
            _s_literal: ""
        });
        this._kt_default_graph = dc_factory.defaultGraph();
        this._kt_rdfs_lang_string = dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
        // clean regex
        let r_clean = this._r_clean = $7d44226cc0f38078$var$R_CLEAN;
        if (g_config.relaxed) console.warn(new Error(`no such option 'relaxed'; did you mean 'relax' ?`).stack.replace(/^Error:/, "Warning:"));
        if ("validate" in g_config) console.warn(new Error(`option 'validate' has been removed and validation is now on by default. Use 'relax' option if you wish to disable validation.`).stack.replace(/^Error:/, "Warning:"));
        let namedNode = dc_factory.namedNode;
        let blankNode = dc_factory.blankNode;
        let languagedLiteral = dc_factory.languagedLiteral;
        // test for valid named node
        let rt_named_node_valid = b_allow_relative_iris ? $7d44226cc0f38078$var$RT_NAMED_NODE_VALID : $7d44226cc0f38078$var$RT_ABSOLUTE_IRI_VALID;
        // test for valid named node escapeless
        let rt_named_node_valid_escapeless = b_allow_relative_iris ? $7d44226cc0f38078$var$RT_NAMED_NODE_ESCAPELESS_VALID : $7d44226cc0f38078$var$RT_ABSOLUTE_IRI_ESCAPELESS_VALID;
        // validation
        let k_self = this;
        Object.assign(this, !b_relax ? {
            create_named_node (p_iri) {
                if (!rt_named_node_valid.test(p_iri)) return k_self._error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            create_named_node_escapeless (p_iri) {
                if (!rt_named_node_valid_escapeless.test(p_iri)) return k_self._error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            create_blank_node (s_label) {
                if (!$7d44226cc0f38078$var$RT_BLANK_NODE_LABEL_VALID.test(s_label)) return k_self._error(`Invalid blank node label: "${s_label}"`);
                return blankNode(s_label);
            },
            create_languaged_literal (s_contents, s_language) {
                if (!$7d44226cc0f38078$var$RT_LANGUAGE_VALID.test(s_language)) return k_self._error(`Invalid literal language tag: ${s_language}`);
                return languagedLiteral(s_contents, s_language);
            }
        } : {
            create_named_node: namedNode,
            create_named_node_escapeless: namedNode,
            create_blank_node: blankNode,
            create_languaged_literal: languagedLiteral
        });
        // transform stream
        let ds_transform;
        // whether or not data has been received before
        let b_init = false;
        // create transform
        ds_transform = this.transform = new $7d44226cc0f38078$var$NTriples_Reader({
            // on data event
            transform: (s_chunk, s_encoding, fk_chunk)=>{
                // first transform
                if (!b_init) {
                    // notify that data will begin
                    ds_transform.emit("ready");
                    // do not emit 'ready' event again
                    b_init = false;
                }
                // concatenate current chunk to previous chunk
                let s = this.s += s_chunk;
                // remove whitespace & comments from beginning
                if (this._b_trim_start) {
                    r_clean.lastIndex = 0;
                    let m_clean = r_clean.exec(s);
                    if (this.emit_comments) this.emit_comments(m_clean[1]);
                    // update index and prepare to match statement
                    this.i = r_clean.lastIndex;
                } else this.i = 0;
                // cache chunk length
                this.n = s.length;
                // resume parsing
                try {
                    this.parse(true);
                } // read error occurred; emit and destroy stream
                catch (e_read) {
                    return ds_transform.destroy(e_read);
                }
                // emit progress event updates
                ds_transform.emit("progress", s_chunk.length);
                // done transforming this chunk
                fk_chunk();
            },
            // once there's no more data to consume, invoke eof
            flush: (fk_flush)=>{
                // there is still unparsed data
                if (this.s.length) {
                    // append newline to end so we can match token
                    this.s += "\n";
                    // remove whitespace & comments from beginning
                    if (this._b_trim_start) {
                        r_clean.lastIndex = 0;
                        let m_clean = r_clean.exec(this.s);
                        if (this.emit_comments) this.emit_comments(m_clean[1]);
                        // update index and prepare to match statement
                        this.i = r_clean.lastIndex;
                    } else this.i = 0;
                    // parse
                    try {
                        this.parse();
                    } // read error occurred; pass to flush errback and exit method
                    catch (e_read) {
                        // destroying during flush means overriding push
                        return ds_transform.demolish(e_read);
                    }
                    // still unparsed characters; pass to flush errback and exit method
                    if (this.s.length) return ds_transform.demolish(new Error(`parsing error occurred in state: statement\n  ${this.s.substr(0, 50)}\n  ^ starting here`));
                }
                // invalid state
                if (this._f_state !== this.statement) return ds_transform.demolish(new Error(`parsing error occurred in state: ${this._f_state.name}\n  ${this.s.substr(0, 50)}\n  ^ starting here`));
                // make buffer's alloc eligible for gc
                this.s = null;
                // final progress update: no additional bytes were read
                ds_transform.emit("progress", 0);
                // call end event listener
                ds_transform.emit("eof");
                // done flushing, close read stream
                fk_flush();
            }
        });
        // destroy
        ds_transform._destroy = (...a_args)=>{
            this.destroy(...a_args);
        };
        // data quad
        this._f_data_quad = (kt_subject, kt_predicate, kt_object, kt_graph)=>ds_transform.push(f_quad(kt_subject, kt_predicate, kt_object, kt_graph));
        // new listener added
        ds_transform.on("newListener", (s_event)=>{
            // comment
            if ("comment" === s_event) {
                r_clean = $7d44226cc0f38078$var$R_CLEAN_COMMENTS;
                this.emit_comments = (s_captured)=>{
                    if (!s_captured) return;
                    let a_comments = s_captured.slice(1).replace(/\n\s+$/, "").split(/\n+\s*#/g);
                    for (let s_comment of a_comments)ds_transform.emit("comment", s_comment);
                };
            }
        });
        // bind events to transform stream
        this.bind(g_config);
        // input given
        if (g_input) {
            // input is stream
            if (g_input.stream) {
                let ds_input = g_input.stream;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_input.pipe(ds_transform);
                });
            } else if ("string" === typeof g_input.string) {
                let s_input = g_input.string;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_transform.end(s_input, "utf8");
                });
            } else throw new TypeError(`Invalid argument for input parameter: ${"object" === typeof g_input ? JSON.stringify(g_input) : g_input}`);
        }
        ds_transform._graphy_reader = this;
    }
    _error(s_message) {
        this._b_destroyed = true;
        throw new Error(s_message);
    }
    bind(g_config) {
        let ds_transform = this.transform;
        if (g_config.error) ds_transform.on("error", g_config.error);
        if (g_config.comment) ds_transform.on("comment", g_config.comment);
        if (g_config.read) ds_transform.once("read", g_config.read);
        if (g_config.progress) ds_transform.on("progress", g_config.progress);
        if (g_config.eof) ds_transform.once("eof", g_config.eof);
        if (g_config.end) ds_transform.once("end", g_config.end);
        if (g_config.finish) ds_transform.once("finish", g_config.finish);
        if (g_config.data) ds_transform.on("data", g_config.data);
    }
    // begin parsing, keep applying until no more stack bail-outs
    parse() {
        let f_sync = this._f_state();
        while("function" === typeof f_sync)f_sync = f_sync.apply(this);
    }
    statement() {
        let s = this.s;
        let n = this.n;
        let i = this.i;
        let f_data_quad = this._f_data_quad;
        let create_named_node = this.create_named_node;
        let create_named_node_escapeless = this.create_named_node_escapeless;
        let create_languaged_literal = this.create_languaged_literal;
        let create_blank_node = this.create_blank_node;
        let simpleLiteral = this._dc_factory.simpleLiteral;
        let datatypedLiteral = this._dc_factory.datatypedLiteral;
        let kt_default_graph = this._kt_default_graph;
        // match triples/quads
        for(;;){
            // prepare sticky regex index
            $7d44226cc0f38078$var$R_TRIPLE_ESCAPELESS_SP.lastIndex = i;
            // execute regex
            let m_statement_e_sp = $7d44226cc0f38078$var$R_TRIPLE_ESCAPELESS_SP.exec(s);
            // regex was a match
            if (m_statement_e_sp) {
                // advance index
                i = $7d44226cc0f38078$var$R_TRIPLE_ESCAPELESS_SP.lastIndex;
                // prep object term
                let kt_object;
                // object term type is named node
                if (m_statement_e_sp[4]) {
                    let p_object = m_statement_e_sp[4].slice(1);
                    kt_object = create_named_node_escapeless(p_object);
                } else if (m_statement_e_sp[5]) kt_object = create_blank_node(m_statement_e_sp[5]);
                else {
                    // contents
                    let s_contents = m_statement_e_sp[7];
                    // string terminator
                    if (m_statement_e_sp[8]) {
                        // datatype is present
                        if (m_statement_e_sp[9]) {
                            // create datatype term
                            let kt_datatype = this.create_named_node_escapeless(m_statement_e_sp[9]);
                            // create object term
                            kt_object = datatypedLiteral(s_contents, kt_datatype);
                        } else if (m_statement_e_sp[10]) {
                            // normalize language
                            let s_language = m_statement_e_sp[10].toLowerCase();
                            // create object term
                            kt_object = create_languaged_literal(s_contents, s_language);
                        } else kt_object = simpleLiteral(s_contents);
                    } else {
                        // save contents
                        this._s_literal = s_contents;
                        // update index
                        this.i = i;
                        // save subject
                        {
                            let s_subject = m_statement_e_sp[1];
                            // named node
                            if (s_subject || "string" === typeof s_subject) this._kt_subject = create_named_node_escapeless(s_subject);
                            else this._kt_subject = create_blank_node(m_statement_e_sp[2]);
                        }
                        // save predicate
                        this._kt_predicate = create_named_node_escapeless(m_statement_e_sp[3]);
                        // parse contents
                        let z_bail = this.strlit_contents();
                        // bail out of stack
                        if (z_bail && this.statement !== z_bail) return z_bail;
                        else {
                            // clean
                            let r_clean = this._r_clean;
                            r_clean.lastIndex = this.i;
                            let m_clean = r_clean.exec(s);
                            if (this.emit_comments) this.emit_comments(m_clean[1]);
                            // update local index and prepare to match next statement
                            i = r_clean.lastIndex;
                            continue;
                        }
                    }
                }
                let kt_subject;
                {
                    let s_subject = m_statement_e_sp[1];
                    // named node
                    if (s_subject || "string" === typeof s_subject) kt_subject = create_named_node_escapeless(s_subject);
                    else kt_subject = create_blank_node(m_statement_e_sp[2]);
                }
                let s_predicate = m_statement_e_sp[3];
                // emit data event
                f_data_quad(kt_subject, create_named_node_escapeless(s_predicate), kt_object, kt_default_graph);
                // comments
                if (this.emit_comments) this.emit_comments(m_statement_e_sp[6] || m_statement_e_sp[11]);
            } else {
                // prepare sticky regex index
                $7d44226cc0f38078$var$R_TRIPLE.lastIndex = i;
                // execute regex
                let m_statement = $7d44226cc0f38078$var$R_TRIPLE.exec(s);
                // regex was a match
                if (m_statement) {
                    // advance index
                    i = $7d44226cc0f38078$var$R_TRIPLE.lastIndex;
                    // prep object term
                    let kt_object;
                    // object term type is named node
                    if (m_statement[4]) {
                        let p_object = m_statement[4].slice(1);
                        kt_object = create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(p_object) ? p_object.replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : p_object);
                    } else if (m_statement[5]) kt_object = create_blank_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(m_statement[5]) ? m_statement[5].replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : m_statement[5]);
                    else {
                        // contents
                        let s_contents = m_statement[7];
                        // string terminator
                        if (m_statement[8]) {
                            // unescape contents
                            s_contents = $7d44226cc0f38078$var$unescape_literal_short_hard(s_contents);
                            // datatype is present
                            if (m_statement[9]) {
                                // create datatype term
                                let kt_datatype = this.create_named_node(m_statement[9]);
                                // create object term
                                kt_object = datatypedLiteral(s_contents, kt_datatype);
                            } else if (m_statement[10]) {
                                // normalize language
                                let s_language = m_statement[10].toLowerCase();
                                // create object term
                                kt_object = create_languaged_literal(s_contents, s_language);
                            } else kt_object = simpleLiteral(s_contents);
                        } else {
                            // save contents
                            this._s_literal = s_contents;
                            // update index
                            this.i = i;
                            // save subject
                            {
                                let s_subject = m_statement[1];
                                // named node
                                if (s_subject || "string" === typeof s_subject) this._kt_subject = create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(s_subject) ? s_subject.replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : s_subject);
                                else this._kt_subject = create_blank_node(m_statement[2]);
                            }
                            // save predicate
                            this._kt_predicate = create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(m_statement[3]) ? m_statement[3].replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : m_statement[3]);
                            // parse contents
                            let z_bail = this.strlit_contents();
                            // bail out of stack
                            if (z_bail && this.statement !== z_bail) return z_bail;
                            else {
                                // clean
                                let r_clean = this._r_clean;
                                r_clean.lastIndex = this.i;
                                let m_clean = r_clean.exec(s);
                                if (this.emit_comments) this.emit_comments(m_clean[1]);
                                // update local index and prepare to match next statement
                                i = r_clean.lastIndex;
                                continue;
                            }
                        }
                    }
                    let kt_subject;
                    {
                        let s_subject = m_statement[1];
                        // named node
                        if (s_subject || "string" === typeof s_subject) kt_subject = create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(s_subject) ? s_subject.replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : s_subject);
                        else kt_subject = create_blank_node(m_statement[2]);
                    }
                    let s_predicate = m_statement[3];
                    // emit data event
                    f_data_quad(kt_subject, create_named_node($7d44226cc0f38078$var$RT_HAS_ESCAPES.test(s_predicate) ? s_predicate.replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY) : s_predicate), kt_object, kt_default_graph);
                    // comments
                    if (this.emit_comments) this.emit_comments(m_statement[6] || m_statement[11]);
                } else {
                    // prepare sticky regex index
                    $7d44226cc0f38078$var$R_EOL.lastIndex = i;
                    if ($7d44226cc0f38078$var$R_EOL.exec(s)) {
                        // advance index
                        i = $7d44226cc0f38078$var$R_EOL.lastIndex;
                        this._error(`Failed to read statement:\n\`${s.substr(i, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        } // end of while
        // update unparsed data string
        this.s = s.substr(i);
        // resume here
        this._f_state = this.statement;
        // exit
        return 1;
    }
    strlit_contents() {
        let { s: s, n: n, i: i } = this;
        // try to find end
        $7d44226cc0f38078$var$R_STRLIT_SHORT_DOUBLE_TERM.lastIndex = i;
        let m_term = $7d44226cc0f38078$var$R_STRLIT_SHORT_DOUBLE_TERM.exec(s);
        // end is in this chunk
        if (m_term) {
            // index of terminator
            let i_term = m_term.index;
            // extract dirty potion
            let s_dirty = s.slice(i, i_term);
            // clean and save
            this._s_literal += $7d44226cc0f38078$var$unescape_literal_short_hard(s_dirty);
            // advance index beyond terminator
            this.i = i_term + m_term[0].length;
            // resume eating whitespace at start of next chunk
            this._b_trim_start = true;
            // proceed with datatype_or_lang, then bail out of stack or resume parsing
            return this.datatype_or_langtag() || this.statement;
        } else {
            // extract whole portion
            let s_dirty = s.slice(i);
            // unescape to clean part
            let [s_clean, s_incomplete] = $7d44226cc0f38078$var$unescape_literal_short_soft(s_dirty);
            // save
            this._s_literal += s_clean;
            // set unparsed index
            this.i = i = n - s_incomplete.length;
            // do not eat whitespace at start of next chunk
            this._b_trim_start = false;
        }
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("strlit_contents");
            }
        }
        // resume here
        this._f_state = this.strlit_contents;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    // parse state for datatype_or_langtag
    datatype_or_langtag() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // ref character
        let x = s[i];
        while(i < n){
            // datatype
            if ("^" === x) {
                // enough to speculate datatype
                if (i + 2 < n) {
                    // correct token
                    if ("^" === s[i + 1]) {
                        // advance index beyond token
                        $7d44226cc0f38078$var$R_IRIREF.lastIndex = i + 2;
                        // execute regex
                        let m_iriref = $7d44226cc0f38078$var$R_IRIREF.exec(s);
                        // regex was a match
                        if (m_iriref) {
                            // advance index
                            this.i = $7d44226cc0f38078$var$R_IRIREF.lastIndex;
                            // prepare iri
                            let p_datatype = m_iriref[1].replace($7d44226cc0f38078$var$R_UNICODE_ANY, $7d44226cc0f38078$var$F_REPLACE_UNICODE_ANY);
                            // create datatype term
                            let kt_datatype = this.create_named_node(p_datatype);
                            // create object term
                            let kt_object = this._dc_factory.datatypedLiteral(this._s_literal, kt_datatype);
                            // free literal string
                            this._s_literal = "";
                            // emit data event
                            this._f_data_quad(this._kt_subject, this._kt_predicate, kt_object, this._kt_default_graph);
                            // complete with statement_term
                            return this.statement_term();
                        } else break;
                    } else this._error(`Failed to read token after literal:\n\`${s.substr(i + 1, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
                } else break;
            } else if ("@" === x) {
                // prepare sticky regex index
                $7d44226cc0f38078$var$R_LANGTAG.lastIndex = i;
                // execute regex
                let m_langtag = $7d44226cc0f38078$var$R_LANGTAG.exec(s);
                // regex was a match
                if (m_langtag) {
                    // advance index
                    this.i = $7d44226cc0f38078$var$R_LANGTAG.lastIndex;
                    // use direct factory method since regex is validation
                    let kt_object = this._dc_factory.languagedLiteral(this._s_literal, m_langtag[1]);
                    // free literal string
                    this._s_literal = "";
                    // emit data event
                    this._f_data_quad(this._kt_subject, this._kt_predicate, kt_object, this._kt_default_graph);
                    // complete with statement_term
                    return this.statement_term();
                } else break;
            } else if ("." === x) {
                // save simple literal
                let kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                // free literal string
                this._s_literal = "";
                // advance index beyond terminator
                this.i = i + 1;
                // emit data event
                this._f_data_quad(this._kt_subject, this._kt_predicate, kt_object, this._kt_default_graph);
                // reset state
                return this.statement;
            // // consume whitespace (and incidentally reset index)
            // R_WS.lastIndex = i + 1;
            // R_WS.exec(s);
            // this.i = R_WS.lastIndex;
            // // done
            // return;
            } else break;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype_or_langtag");
            }
        }
        // resume here
        this._f_state = this.datatype_or_langtag;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    statement_term() {
        let { s: s, n: n, i: i } = this;
        // find full stop
        let i_stop = s.indexOf(".", i);
        // found
        if (i_stop > -1) {
            // consume whitespace again
            this._b_trim_start = true;
            // advance beyond token
            this.i = i_stop + 1;
            // reset state
            return this.statement;
        } else if (!/^\s*$/.test(s.slice(i))) this.parse_error("statement_term");
        // do not consume whitespace
        this._b_trim_start = false;
        // resume here
        this._f_state = this.statement_term;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    parse_error(s_state) {
        return this._error(`Failed to read ${s_state}:\n\`${this.s.substr(this.i, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
    }
    destroy(e_destroy) {
        this._f_data_quad = ()=>{};
        if (!e_destroy && this._ds_input) this._ds_input.destroy(e_destroy);
        this.transform.demolish(e_destroy);
    }
}
$7d44226cc0f38078$exports = function(...a_args) {
    let g_config = {};
    // at least one argument
    if (a_args.length) {
        let z_arg_0 = a_args[0];
        // input given unspecified
        if (z_arg_0 && z_arg_0.input && "undefined" === typeof z_arg_0.input.string && !z_arg_0.input.stream) z_arg_0 = z_arg_0.input;
        // string
        if ("string" === typeof z_arg_0) g_config.input = {
            string: z_arg_0
        };
        else if (null === z_arg_0) g_config.input = null;
        else if ("function" === typeof z_arg_0.setEncoding) g_config.input = {
            stream: z_arg_0
        };
        else if ("function" === typeof z_arg_0.pipeTo) throw new TypeError(`Sorry, WHATWG streams are currently not supported :(`);
        else if (z_arg_0 && "object" === typeof z_arg_0 && "[object Object]" === Object.prototype.toString.call(z_arg_0)) {
            g_config = z_arg_0;
            // more args; invalid
            if (a_args.length > 1) throw new TypeError(`unexpected argument(s) after config struct: ${a_args.slice(1)}`);
        } else throw new TypeError(`unexpected input type: ${z_arg_0}`);
        // more args
        if (a_args.length > 1) {
            // copy onto struct
            Object.assign(g_config, a_args[1]);
            // more args
            if (a_args.length > 2) throw new TypeError(`unexpected argument(s) after input and config struct: ${a_args.slice(2)}`);
        }
    }
    // create reader, return transform stream
    return new $7d44226cc0f38078$var$Reader(g_config).transform;
};


var $0a4e3e68448dada6$exports = {};
// queueMicrotask shim
// not defined or not a function
if ("function" !== typeof queueMicrotask) {
    // create resolved promise
    let dp_resolve = Promise.resolve();
    // try to redefine
    try {
        // eslint-disable-next-line no-global-assign
        queueMicrotask = (fk)=>dp_resolve.then(fk).catch((e_callback)=>setTimeout(()=>{
                    throw e_callback;
                }, 0));
    } // oh well, at least we tried
    catch (e_define) {}
}


const $0a4e3e68448dada6$var$RT_ABSOLUTE_IRI_VALID = /^[a-z][a-z0-9+\-.]*:(?:[^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $0a4e3e68448dada6$var$RT_ABSOLUTE_IRI_ESCAPELESS_VALID = /^[a-z][a-z0-9+\-.]*:[^\0-\x20<>"{}|^`]*$/;
const $0a4e3e68448dada6$var$RT_NAMED_NODE_VALID = /^([^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $0a4e3e68448dada6$var$RT_NAMED_NODE_ESCAPELESS_VALID = /^([^\0-\x20<>"{}|^`])*$/;
const $0a4e3e68448dada6$var$R_UNICODE_ANY = /\\u([0-9A-Fa-f]{4})|\\U([0-9A-Fa-f]{8})/g;
const $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY = (s_, s_4, s_8)=>String.fromCodePoint(parseInt(s_4 || s_8, 16));
const $0a4e3e68448dada6$var$R_CLEAN = /\s*(?:#[^\n]*\n\s*)*\s*/y;
const $0a4e3e68448dada6$var$R_CLEAN_COMMENTS = /\s*(#[^\n]*\n\s*)*\s*/y;
const $0a4e3e68448dada6$var$RT_HAS_ESCAPES = /[\\]/;
const $0a4e3e68448dada6$var$R_EOL = /[^\n]+\n/y;
// eslint-disable-next-line no-misleading-character-class
const $0a4e3e68448dada6$var$RT_BLANK_NODE_LABEL_VALID = /^(?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_0-9])(?:(?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.])*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?$/u;
const $0a4e3e68448dada6$var$RT_LANGUAGE_VALID = /^[a-z]+(-[a-z0-9]+)*$/;
const $0a4e3e68448dada6$var$R_WS = /\s*/y;
const $0a4e3e68448dada6$var$R_HWS = /[ \t]*/y;
const $0a4e3e68448dada6$var$R_LANGTAG = /@([A-Za-z]+(?:-[A-Za-z0-9-]+)*)(?:\s+|(?=[.,;\])#]))/y;
const $0a4e3e68448dada6$var$R_IRIREF = /<([^>]*)>\s*/y;
const $0a4e3e68448dada6$var$F_REPLACE_STRLIT_CONTENTS = (s_, s_whitespace, s_auto, s_4, s_8, s_invalid)=>{
    if (s_whitespace) switch(s_whitespace){
        case "t":
            return "	";
        case "n":
            return "\n";
        case "r":
            return "\r";
        case "f":
            return "\f";
        case "b":
            return "\b";
        default:
            console.assert(`bad regex escape char mapping: '${s_whitespace}'`);
    }
    else if (s_auto) return s_auto;
    else if (s_4) return String.fromCodePoint(parseInt(s_4, 16));
    else if (s_8) return String.fromCodePoint(parseInt(s_8, 16));
    else if (s_invalid) {
        // pointless escape
        if ("\\" === s_invalid[0]) // // relaxed
        // return s_invalid[1];
        // if relaxed then return s_invalid, otherwise throw:
        throw new Error(`expected string_literal but invalid escape sequence within contents: '${s_invalid}'. failed to parse a valid token`);
        else throw new Error(`expected string_literal but invalid whitespace character within contents: ${JSON.stringify(s_invalid)}. failed to parse a valid token`);
    } else console.assert(`unexpected no match branch in escape sequence replace callback`);
};
const $0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\.))/g;
const $0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $0a4e3e68448dada6$var$unescape_literal_short_hard = (s_literal)=>s_literal.replace($0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD, $0a4e3e68448dada6$var$F_REPLACE_STRLIT_CONTENTS);
const $0a4e3e68448dada6$var$unescape_literal_short_soft = (s_literal)=>{
    let m_incomplete = $0a4e3e68448dada6$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $0a4e3e68448dada6$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($0a4e3e68448dada6$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $0a4e3e68448dada6$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
// lookbehind regexes
const [$0a4e3e68448dada6$var$R_STRLIT_ESCAPE_INCOMPLETE, $0a4e3e68448dada6$var$R_STRLIT_SHORT_DOUBLE_TERM] = (()=>{
    function RegExp_$lookbehind_polyfill(s_input) {
        let m_match = RegExp.prototype.exec.call(this, s_input);
        if (m_match) {
            let i_start = m_match[0].length - m_match[1].length;
            m_match.index += i_start;
            m_match[0] = m_match[0].slice(i_start);
        }
        return m_match;
    }
    let mk_lookbehind_regex = (()=>{
        try {
            new RegExp("(?<!h)i"); // eslint-disable-line no-new
        } catch (e_compile) {
            return (f_lookbehind, r_polyfill, f_polyfill)=>{
                r_polyfill.exec = f_polyfill;
                return r_polyfill;
            };
        }
        return (f_lookbehind)=>f_lookbehind();
    })();
    return [
        // R_STRLIT_ESCAPE_INCOMPLETE
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)\\\\(|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7})$"), /^(?:(?:[^\\]|\\.)*)(\\(?:|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7}))$/, function RegExp_$lookbehind_polyfill_n(s_input) {
            let m_match = RegExp.prototype.exec.call(this, s_input);
            if (m_match) m_match.index += m_match[0].length - m_match[1].length;
            return m_match;
        }),
        // R_STRLIT_SHORT_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"\\s*', "g"), /(?:[^\\"]|\\.)*("\s*)/y, RegExp_$lookbehind_polyfill)
    ];
})();
const $0a4e3e68448dada6$var$R_QUAD_ESCAPELESS_SP = /(?:<([^\\>]*)>|_:([^\x20\t<]+))[\x20\t]*<([^\\>]*)>[\x20\t]*(?:(?:(<[^\\>]*)>|_:([^\x20\t<]+))[\x20\t]*(?:<([^\\>]*)>|_:([^\x20\t<]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+|"([^"\\]*)(?:(")(?:\^\^<([^\\>]*)>|@([^\x20\t.]+)|)[\x20\t]*(?:<([^\\>]*)>|_:([^\x20\t<]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+)?)/y;
const $0a4e3e68448dada6$var$R_QUAD = /(?:<([^>]*)>|_:([^\x20\t<]+))[\x20\t]*<([^>]*)>[\x20\t]*(?:(?:(<[^>]*)>|_:([^\x20\t<]+))[\x20\t]*(?:<([^>]*)>|_:([^\x20\t<]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+|"((?:[^"\\]|\\.)*)(?:(")(?:\^\^<([^>]*)>|@([^\x20\t.]+)|)[\x20\t]*(?:<([^>]*)>|_:([^\x20\t<]+)|)[\x20\t]*\.\s*(#[^\n]*\n\s*|\n\s*)+)?)/y;
const $0a4e3e68448dada6$var$R_BLANK_NODE = /_:([^\x20\t<]+)/y;
class $0a4e3e68448dada6$var$NQuads_Reader extends $141f1697ab3cba12$exports.Transform {
    constructor(g_impls){
        super({
            // do not decode strings into buffers
            decodeStrings: false,
            // accept strings as input on writable side
            writableObjectMode: false,
            // output quad objects on readable side
            readableObjectMode: true,
            // implementations
            flush: g_impls.flush,
            transform: g_impls.transform
        });
        // when the writable side is piped into
        this.on("pipe", (ds_input)=>{
            this._ds_input = ds_input;
            // input stream has encoding option; ensure stream encoding is utf8
            if ("function" === typeof ds_input.setEncoding) ds_input.setEncoding("utf8");
        });
    }
    // intercept pipe
    pipe(ds_out) {
        let ds_dst = ds_out;
        // non-object mode
        if (!ds_dst._writableState.objectMode) // transform to JSON
        ds_out = $141f1697ab3cba12$exports.quads_to_json();
        else if (ds_out.isGraphyWritable) // transform to quad-stream
        ds_out = $141f1697ab3cba12$exports.quads_to_writable();
        // interim stream created
        if (ds_out !== ds_dst) {
            // forward output to super
            super.pipe(ds_out);
            // pipe outpu to destination
            return ds_out.pipe(ds_dst);
        } else return super.pipe(ds_dst);
    }
}
class $0a4e3e68448dada6$var$Reader {
    constructor(g_config){
        let { // input medium
        input: g_input = null, // relax validation
        relax: b_relax = false, // debug
        debug: b_debug = false } = g_config;
        // allow relative iris flag
        let b_allow_relative_iris = g_config.allow_relative_iris || g_config.allowRelativeIRIs || g_config.allowRelativeIris || false;
        // adopt factory
        let dc_factory = this._dc_factory = $266825253b7f24dc$exports.adopt(g_config.dataFactory || g_config.data_factory || $266825253b7f24dc$exports.unfiltered);
        let f_quad = this._f_quad = dc_factory.quad;
        // fields
        Object.assign(this, {
            // string buffer, accept left-over string from previous data chunk
            s: g_config.prepend || "",
            // string buffer length
            n: 0,
            _b_debug: b_debug,
            _b_relax: b_relax,
            _b_destroyed: false,
            _b_trim_start: true,
            _f_state: this.statement,
            _kt_subject: null,
            _kt_predicate: null,
            _kt_object: null,
            _s_literal: ""
        });
        this._kt_default_graph = dc_factory.defaultGraph();
        this._kt_rdfs_lang_string = dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
        // clean regex
        let r_clean = this._r_clean = $0a4e3e68448dada6$var$R_CLEAN;
        if (g_config.relaxed) console.warn(new Error(`no such option 'relaxed'; did you mean 'relax' ?`).stack.replace(/^Error:/, "Warning:"));
        if ("validate" in g_config) console.warn(new Error(`option 'validate' has been removed and validation is now on by default. Use 'relax' option if you wish to disable validation.`).stack.replace(/^Error:/, "Warning:"));
        let namedNode = dc_factory.namedNode;
        let blankNode = dc_factory.blankNode;
        let languagedLiteral = dc_factory.languagedLiteral;
        // test for valid named node
        let rt_named_node_valid = b_allow_relative_iris ? $0a4e3e68448dada6$var$RT_NAMED_NODE_VALID : $0a4e3e68448dada6$var$RT_ABSOLUTE_IRI_VALID;
        // test for valid named node escapeless
        let rt_named_node_valid_escapeless = b_allow_relative_iris ? $0a4e3e68448dada6$var$RT_NAMED_NODE_ESCAPELESS_VALID : $0a4e3e68448dada6$var$RT_ABSOLUTE_IRI_ESCAPELESS_VALID;
        // validation
        let k_self = this;
        Object.assign(this, !b_relax ? {
            create_named_node (p_iri) {
                if (!rt_named_node_valid.test(p_iri)) return k_self._error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            create_named_node_escapeless (p_iri) {
                if (!rt_named_node_valid_escapeless.test(p_iri)) return k_self._error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            create_blank_node (s_label) {
                if (!$0a4e3e68448dada6$var$RT_BLANK_NODE_LABEL_VALID.test(s_label)) return k_self._error(`Invalid blank node label: "${s_label}"`);
                return blankNode(s_label);
            },
            create_languaged_literal (s_contents, s_language) {
                if (!$0a4e3e68448dada6$var$RT_LANGUAGE_VALID.test(s_language)) return k_self._error(`Invalid literal language tag: ${s_language}`);
                return languagedLiteral(s_contents, s_language);
            }
        } : {
            create_named_node: namedNode,
            create_named_node_escapeless: namedNode,
            create_blank_node: blankNode,
            create_languaged_literal: languagedLiteral
        });
        // transform stream
        let ds_transform;
        // whether or not data has been received before
        let b_init = false;
        // create transform
        ds_transform = this.transform = new $0a4e3e68448dada6$var$NQuads_Reader({
            // on data event
            transform: (s_chunk, s_encoding, fk_chunk)=>{
                // first transform
                if (!b_init) {
                    // notify that data will begin
                    ds_transform.emit("ready");
                    // do not emit 'ready' event again
                    b_init = false;
                }
                // concatenate current chunk to previous chunk
                let s = this.s += s_chunk;
                // remove whitespace & comments from beginning
                if (this._b_trim_start) {
                    r_clean.lastIndex = 0;
                    let m_clean = r_clean.exec(s);
                    if (this.emit_comments) this.emit_comments(m_clean[1]);
                    // update index and prepare to match statement
                    this.i = r_clean.lastIndex;
                } else this.i = 0;
                // cache chunk length
                this.n = s.length;
                // resume parsing
                try {
                    this.parse(true);
                } // read error occurred; emit and destroy stream
                catch (e_read) {
                    return ds_transform.destroy(e_read);
                }
                // emit progress event updates
                ds_transform.emit("progress", s_chunk.length);
                // done transforming this chunk
                fk_chunk();
            },
            // once there's no more data to consume, invoke eof
            flush: (fk_flush)=>{
                // there is still unparsed data
                if (this.s.length) {
                    // append newline to end so we can match token
                    this.s += "\n";
                    // remove whitespace & comments from beginning
                    if (this._b_trim_start) {
                        r_clean.lastIndex = 0;
                        let m_clean = r_clean.exec(this.s);
                        if (this.emit_comments) this.emit_comments(m_clean[1]);
                        // update index and prepare to match statement
                        this.i = r_clean.lastIndex;
                    } else this.i = 0;
                    // parse
                    try {
                        this.parse();
                    } // read error occurred; pass to flush errback and exit method
                    catch (e_read) {
                        // destroying during flush means overriding push
                        return ds_transform.demolish(e_read);
                    }
                    // still unparsed characters; pass to flush errback and exit method
                    if (this.s.length) return ds_transform.demolish(new Error(`parsing error occurred in state: statement\n  ${this.s.substr(0, 50)}\n  ^ starting here`));
                }
                // invalid state
                if (this._f_state !== this.statement) return ds_transform.demolish(new Error(`parsing error occurred in state: ${this._f_state.name}\n  ${this.s.substr(0, 50)}\n  ^ starting here`));
                // make buffer's alloc eligible for gc
                this.s = null;
                // final progress update: no additional bytes were read
                ds_transform.emit("progress", 0);
                // call end event listener
                ds_transform.emit("eof");
                // done flushing, close read stream
                fk_flush();
            }
        });
        // destroy
        ds_transform._destroy = (...a_args)=>{
            this.destroy(...a_args);
        };
        // data quad
        this._f_data_quad = (kt_subject, kt_predicate, kt_object, kt_graph)=>ds_transform.push(f_quad(kt_subject, kt_predicate, kt_object, kt_graph));
        // new listener added
        ds_transform.on("newListener", (s_event)=>{
            // comment
            if ("comment" === s_event) {
                r_clean = $0a4e3e68448dada6$var$R_CLEAN_COMMENTS;
                this.emit_comments = (s_captured)=>{
                    if (!s_captured) return;
                    let a_comments = s_captured.slice(1).replace(/\n\s+$/, "").split(/\n+\s*#/g);
                    for (let s_comment of a_comments)ds_transform.emit("comment", s_comment);
                };
            }
        });
        // bind events to transform stream
        this.bind(g_config);
        // input given
        if (g_input) {
            // input is stream
            if (g_input.stream) {
                let ds_input = g_input.stream;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_input.pipe(ds_transform);
                });
            } else if ("string" === typeof g_input.string) {
                let s_input = g_input.string;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_transform.end(s_input, "utf8");
                });
            } else throw new TypeError(`Invalid argument for input parameter: ${"object" === typeof g_input ? JSON.stringify(g_input) : g_input}`);
        }
        ds_transform._graphy_reader = this;
    }
    _error(s_message) {
        this._b_destroyed = true;
        throw new Error(s_message);
    }
    bind(g_config) {
        let ds_transform = this.transform;
        if (g_config.error) ds_transform.on("error", g_config.error);
        if (g_config.comment) ds_transform.on("comment", g_config.comment);
        if (g_config.read) ds_transform.once("read", g_config.read);
        if (g_config.progress) ds_transform.on("progress", g_config.progress);
        if (g_config.eof) ds_transform.once("eof", g_config.eof);
        if (g_config.end) ds_transform.once("end", g_config.end);
        if (g_config.finish) ds_transform.once("finish", g_config.finish);
        if (g_config.data) ds_transform.on("data", g_config.data);
    }
    // begin parsing, keep applying until no more stack bail-outs
    parse() {
        let f_sync = this._f_state();
        while("function" === typeof f_sync)f_sync = f_sync.apply(this);
    }
    statement() {
        let s = this.s;
        let n = this.n;
        let i = this.i;
        let f_data_quad = this._f_data_quad;
        let create_named_node = this.create_named_node;
        let create_named_node_escapeless = this.create_named_node_escapeless;
        let create_languaged_literal = this.create_languaged_literal;
        let create_blank_node = this.create_blank_node;
        let simpleLiteral = this._dc_factory.simpleLiteral;
        let datatypedLiteral = this._dc_factory.datatypedLiteral;
        let kt_default_graph = this._kt_default_graph;
        // match triples/quads
        for(;;){
            // prepare sticky regex index
            $0a4e3e68448dada6$var$R_QUAD_ESCAPELESS_SP.lastIndex = i;
            // execute regex
            let m_statement_e_sp = $0a4e3e68448dada6$var$R_QUAD_ESCAPELESS_SP.exec(s);
            // regex was a match
            if (m_statement_e_sp) {
                // advance index
                i = $0a4e3e68448dada6$var$R_QUAD_ESCAPELESS_SP.lastIndex;
                // prep object term
                let kt_object;
                // where to find the graph component
                let b_graph_late = false;
                // object term type is named node
                if (m_statement_e_sp[4]) {
                    let p_object = m_statement_e_sp[4].slice(1);
                    kt_object = create_named_node_escapeless(p_object);
                } else if (m_statement_e_sp[5]) kt_object = create_blank_node(m_statement_e_sp[5]);
                else {
                    // graph is in late capture group
                    b_graph_late = true;
                    // contents
                    let s_contents = m_statement_e_sp[9];
                    // string terminator
                    if (m_statement_e_sp[10]) {
                        // datatype is present
                        if (m_statement_e_sp[11]) {
                            // create datatype term
                            let kt_datatype = this.create_named_node_escapeless(m_statement_e_sp[11]);
                            // create object term
                            kt_object = datatypedLiteral(s_contents, kt_datatype);
                        } else if (m_statement_e_sp[12]) {
                            // normalize language
                            let s_language = m_statement_e_sp[12].toLowerCase();
                            // create object term
                            kt_object = create_languaged_literal(s_contents, s_language);
                        } else kt_object = simpleLiteral(s_contents);
                    } else {
                        // save contents
                        this._s_literal = s_contents;
                        // update index
                        this.i = i;
                        // save subject
                        {
                            let s_subject = m_statement_e_sp[1];
                            // named node
                            if (s_subject || "string" === typeof s_subject) this._kt_subject = create_named_node_escapeless(s_subject);
                            else this._kt_subject = create_blank_node(m_statement_e_sp[2]);
                        }
                        // save predicate
                        this._kt_predicate = create_named_node_escapeless(m_statement_e_sp[3]);
                        // parse contents
                        let z_bail = this.strlit_contents();
                        // bail out of stack
                        if (z_bail && this.statement !== z_bail) return z_bail;
                        else {
                            // clean
                            let r_clean = this._r_clean;
                            r_clean.lastIndex = this.i;
                            let m_clean = r_clean.exec(s);
                            if (this.emit_comments) this.emit_comments(m_clean[1]);
                            // update local index and prepare to match next statement
                            i = r_clean.lastIndex;
                            continue;
                        }
                    }
                }
                let kt_graph = kt_default_graph;
                // graph after literal
                if (b_graph_late) {
                    // ref capture group
                    let s_graph = m_statement_e_sp[13];
                    // named node
                    if (s_graph || "string" === typeof s_graph) kt_graph = create_named_node_escapeless(s_graph);
                    else if (m_statement_e_sp[14]) kt_graph = create_blank_node(m_statement_e_sp[14]);
                } else {
                    // ref capture group
                    let s_graph = m_statement_e_sp[6];
                    // named node
                    if (s_graph || "string" === typeof s_graph) kt_graph = create_named_node_escapeless(s_graph);
                    else if (m_statement_e_sp[7]) kt_graph = create_blank_node(m_statement_e_sp[7]);
                }
                let kt_subject;
                {
                    let s_subject = m_statement_e_sp[1];
                    // named node
                    if (s_subject || "string" === typeof s_subject) kt_subject = create_named_node_escapeless(s_subject);
                    else kt_subject = create_blank_node(m_statement_e_sp[2]);
                }
                let s_predicate = m_statement_e_sp[3];
                // emit data event
                f_data_quad(kt_subject, create_named_node_escapeless(s_predicate), kt_object, kt_graph);
                // comments
                if (this.emit_comments) this.emit_comments(m_statement_e_sp[8] || m_statement_e_sp[15]);
            } else {
                // prepare sticky regex index
                $0a4e3e68448dada6$var$R_QUAD.lastIndex = i;
                // execute regex
                let m_statement = $0a4e3e68448dada6$var$R_QUAD.exec(s);
                // regex was a match
                if (m_statement) {
                    // advance index
                    i = $0a4e3e68448dada6$var$R_QUAD.lastIndex;
                    // prep object term
                    let kt_object;
                    // where to find the graph component
                    let b_graph_late = false;
                    // object term type is named node
                    if (m_statement[4]) {
                        let p_object = m_statement[4].slice(1);
                        kt_object = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(p_object) ? p_object.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : p_object);
                    } else if (m_statement[5]) kt_object = create_blank_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(m_statement[5]) ? m_statement[5].replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : m_statement[5]);
                    else {
                        // graph is in late capture group
                        b_graph_late = true;
                        // contents
                        let s_contents = m_statement[9];
                        // string terminator
                        if (m_statement[10]) {
                            // unescape contents
                            s_contents = $0a4e3e68448dada6$var$unescape_literal_short_hard(s_contents);
                            // datatype is present
                            if (m_statement[11]) {
                                // create datatype term
                                let kt_datatype = this.create_named_node(m_statement[11]);
                                // create object term
                                kt_object = datatypedLiteral(s_contents, kt_datatype);
                            } else if (m_statement[12]) {
                                // normalize language
                                let s_language = m_statement[12].toLowerCase();
                                // create object term
                                kt_object = create_languaged_literal(s_contents, s_language);
                            } else kt_object = simpleLiteral(s_contents);
                        } else {
                            // save contents
                            this._s_literal = s_contents;
                            // update index
                            this.i = i;
                            // save subject
                            {
                                let s_subject = m_statement[1];
                                // named node
                                if (s_subject || "string" === typeof s_subject) this._kt_subject = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_subject) ? s_subject.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_subject);
                                else this._kt_subject = create_blank_node(m_statement[2]);
                            }
                            // save predicate
                            this._kt_predicate = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(m_statement[3]) ? m_statement[3].replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : m_statement[3]);
                            // parse contents
                            let z_bail = this.strlit_contents();
                            // bail out of stack
                            if (z_bail && this.statement !== z_bail) return z_bail;
                            else {
                                // clean
                                let r_clean = this._r_clean;
                                r_clean.lastIndex = this.i;
                                let m_clean = r_clean.exec(s);
                                if (this.emit_comments) this.emit_comments(m_clean[1]);
                                // update local index and prepare to match next statement
                                i = r_clean.lastIndex;
                                continue;
                            }
                        }
                    }
                    let kt_graph = kt_default_graph;
                    // graph after literal
                    if (b_graph_late) {
                        // ref capture group
                        let s_graph = m_statement[13];
                        // named node
                        if (s_graph || "string" === typeof s_graph) kt_graph = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_graph) ? s_graph.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_graph);
                        else if (m_statement[14]) kt_graph = create_blank_node(m_statement[14]);
                    } else {
                        // ref capture group
                        let s_graph = m_statement[6];
                        // named node
                        if (s_graph || "string" === typeof s_graph) kt_graph = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_graph) ? s_graph.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_graph);
                        else if (m_statement[7]) kt_graph = create_blank_node(m_statement[7]);
                    }
                    let kt_subject;
                    {
                        let s_subject = m_statement[1];
                        // named node
                        if (s_subject || "string" === typeof s_subject) kt_subject = create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_subject) ? s_subject.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_subject);
                        else kt_subject = create_blank_node(m_statement[2]);
                    }
                    let s_predicate = m_statement[3];
                    // emit data event
                    f_data_quad(kt_subject, create_named_node($0a4e3e68448dada6$var$RT_HAS_ESCAPES.test(s_predicate) ? s_predicate.replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY) : s_predicate), kt_object, kt_graph);
                    // comments
                    if (this.emit_comments) this.emit_comments(m_statement[8] || m_statement[15]);
                } else {
                    // prepare sticky regex index
                    $0a4e3e68448dada6$var$R_EOL.lastIndex = i;
                    if ($0a4e3e68448dada6$var$R_EOL.exec(s)) {
                        // advance index
                        i = $0a4e3e68448dada6$var$R_EOL.lastIndex;
                        this._error(`Failed to read statement:\n\`${s.substr(i, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        } // end of while
        // update unparsed data string
        this.s = s.substr(i);
        // resume here
        this._f_state = this.statement;
        // exit
        return 1;
    }
    strlit_contents() {
        let { s: s, n: n, i: i } = this;
        // try to find end
        $0a4e3e68448dada6$var$R_STRLIT_SHORT_DOUBLE_TERM.lastIndex = i;
        let m_term = $0a4e3e68448dada6$var$R_STRLIT_SHORT_DOUBLE_TERM.exec(s);
        // end is in this chunk
        if (m_term) {
            // index of terminator
            let i_term = m_term.index;
            // extract dirty potion
            let s_dirty = s.slice(i, i_term);
            // clean and save
            this._s_literal += $0a4e3e68448dada6$var$unescape_literal_short_hard(s_dirty);
            // advance index beyond terminator
            this.i = i_term + m_term[0].length;
            // resume eating whitespace at start of next chunk
            this._b_trim_start = true;
            // proceed with datatype_or_lang, then bail out of stack or resume parsing
            return this.datatype_or_langtag() || this.statement;
        } else {
            // extract whole portion
            let s_dirty = s.slice(i);
            // unescape to clean part
            let [s_clean, s_incomplete] = $0a4e3e68448dada6$var$unescape_literal_short_soft(s_dirty);
            // save
            this._s_literal += s_clean;
            // set unparsed index
            this.i = i = n - s_incomplete.length;
            // do not eat whitespace at start of next chunk
            this._b_trim_start = false;
        }
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("strlit_contents");
            }
        }
        // resume here
        this._f_state = this.strlit_contents;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    // parse state for datatype_or_langtag
    datatype_or_langtag() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // ref character
        let x = s[i];
        while(i < n){
            // datatype
            if ("^" === x) {
                // enough to speculate datatype
                if (i + 2 < n) {
                    // correct token
                    if ("^" === s[i + 1]) {
                        // advance index beyond token
                        $0a4e3e68448dada6$var$R_IRIREF.lastIndex = i + 2;
                        // execute regex
                        let m_iriref = $0a4e3e68448dada6$var$R_IRIREF.exec(s);
                        // regex was a match
                        if (m_iriref) {
                            // advance index
                            this.i = $0a4e3e68448dada6$var$R_IRIREF.lastIndex;
                            // prepare iri
                            let p_datatype = m_iriref[1].replace($0a4e3e68448dada6$var$R_UNICODE_ANY, $0a4e3e68448dada6$var$F_REPLACE_UNICODE_ANY);
                            // create datatype term
                            let kt_datatype = this.create_named_node(p_datatype);
                            // create object term
                            this._kt_object = this._dc_factory.datatypedLiteral(this._s_literal, kt_datatype);
                            // free literal string
                            this._s_literal = "";
                            // graph state
                            return this.post_object();
                        } else break;
                    } else this._error(`Failed to read token after literal:\n\`${s.substr(i + 1, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
                } else break;
            } else if ("@" === x) {
                // prepare sticky regex index
                $0a4e3e68448dada6$var$R_LANGTAG.lastIndex = i;
                // execute regex
                let m_langtag = $0a4e3e68448dada6$var$R_LANGTAG.exec(s);
                // regex was a match
                if (m_langtag) {
                    // advance index
                    this.i = $0a4e3e68448dada6$var$R_LANGTAG.lastIndex;
                    // use direct factory method since regex is validation
                    this._kt_object = this._dc_factory.languagedLiteral(this._s_literal, m_langtag[1]);
                    // free literal string
                    this._s_literal = "";
                    // graph state
                    return this.post_object();
                } else break;
            } else if ("<" === x || "_" === x) {
                // save simple literal
                this._kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                // free literal string
                this._s_literal = "";
                // continue parsing graph component
                return this.graph();
            } else if ("." === x) {
                // save simple literal
                let kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                // free literal string
                this._s_literal = "";
                // advance index beyond terminator
                this.i = i + 1;
                // emit data event
                this._f_data_quad(this._kt_subject, this._kt_predicate, kt_object, this._kt_default_graph);
                // reset state
                return this.statement;
            // // consume whitespace (and incidentally reset index)
            // R_WS.lastIndex = i + 1;
            // R_WS.exec(s);
            // this.i = R_WS.lastIndex;
            // // done
            // return;
            } else break;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype_or_langtag");
            }
        }
        // resume here
        this._f_state = this.datatype_or_langtag;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    statement_term() {
        let { s: s, n: n, i: i } = this;
        // find full stop
        let i_stop = s.indexOf(".", i);
        // found
        if (i_stop > -1) {
            // consume whitespace again
            this._b_trim_start = true;
            // advance beyond token
            this.i = i_stop + 1;
            // reset state
            return this.statement;
        } else if (!/^\s*$/.test(s.slice(i))) this.parse_error("statement_term");
        // do not consume whitespace
        this._b_trim_start = false;
        // resume here
        this._f_state = this.statement_term;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    post_object() {
        let { s: s, n: n, i: i } = this;
        // eat horizontal whitespace
        $0a4e3e68448dada6$var$R_HWS.lastIndex = i;
        $0a4e3e68448dada6$var$R_HWS.exec(s);
        i = $0a4e3e68448dada6$var$R_HWS.lastIndex;
        // ran out of characters
        if (i >= n) {
            // resume here
            this._f_state = this.post_object;
            // store what is unparsed
            this.s = s.slice(i);
            // if we're not parsing a stream, then this is an error
            if (this.eos) this.eos();
            return 1;
        }
        // depending on char
        switch(s[i]){
            // statement term
            case ".":
                // advance index beyond terminator
                this.i = i + 1;
                // emit data event
                this._f_data_quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_default_graph);
                // reset state
                return this.statement;
            // graph
            case "<":
            case "_":
                // save index
                this.i = i;
                // consume graph component
                return this.graph();
            // invalid
            default:
                // save index
                this.i = i;
                // emit parsing error
                this.parse_error("post_object");
        }
    }
    graph() {
        let { s: s, n: n, i: i } = this;
        // prepare sticky regex index
        $0a4e3e68448dada6$var$R_IRIREF.lastIndex = i;
        // execute regex
        let m_iriref = $0a4e3e68448dada6$var$R_IRIREF.exec(s);
        // regex was a match
        if (m_iriref) {
            // advance index
            this.i = $0a4e3e68448dada6$var$R_IRIREF.lastIndex;
            // create graph term
            let kt_graph = this.create_named_node(m_iriref[1]);
            // emit data event
            this._f_data_quad(this._kt_subject, this._kt_predicate, this._kt_object, kt_graph);
            // complete with statement_term
            return this.statement_term();
        } else {
            // prepare sticky regex index
            $0a4e3e68448dada6$var$R_BLANK_NODE.lastIndex = i;
            // execute regex
            let m_blank = $0a4e3e68448dada6$var$R_BLANK_NODE.exec(s);
            // regex was a match
            if (m_blank) {
                // advance index
                this.i = $0a4e3e68448dada6$var$R_BLANK_NODE.lastIndex;
                // create graph term
                let kt_graph = this._dc_factory.blankNode(m_blank[1]);
                // emit data event
                this._f_data_quad(this._kt_subject, this._kt_predicate, this._kt_object, kt_graph);
                // complete with statement_term
                return this.statement_term();
            }
        } // brace #1
        // resume here
        this._f_state = this.graph;
        // store what is unparsed
        this.s = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return 1;
    }
    parse_error(s_state) {
        return this._error(`Failed to read ${s_state}:\n\`${this.s.substr(this.i, 80).replace(/\n/g, "\u23CE")} [...]\`\n ^ starting here`);
    }
    destroy(e_destroy) {
        this._f_data_quad = ()=>{};
        if (!e_destroy && this._ds_input) this._ds_input.destroy(e_destroy);
        this.transform.demolish(e_destroy);
    }
}
$0a4e3e68448dada6$exports = function(...a_args) {
    let g_config = {};
    // at least one argument
    if (a_args.length) {
        let z_arg_0 = a_args[0];
        // input given unspecified
        if (z_arg_0 && z_arg_0.input && "undefined" === typeof z_arg_0.input.string && !z_arg_0.input.stream) z_arg_0 = z_arg_0.input;
        // string
        if ("string" === typeof z_arg_0) g_config.input = {
            string: z_arg_0
        };
        else if (null === z_arg_0) g_config.input = null;
        else if ("function" === typeof z_arg_0.setEncoding) g_config.input = {
            stream: z_arg_0
        };
        else if ("function" === typeof z_arg_0.pipeTo) throw new TypeError(`Sorry, WHATWG streams are currently not supported :(`);
        else if (z_arg_0 && "object" === typeof z_arg_0 && "[object Object]" === Object.prototype.toString.call(z_arg_0)) {
            g_config = z_arg_0;
            // more args; invalid
            if (a_args.length > 1) throw new TypeError(`unexpected argument(s) after config struct: ${a_args.slice(1)}`);
        } else throw new TypeError(`unexpected input type: ${z_arg_0}`);
        // more args
        if (a_args.length > 1) {
            // copy onto struct
            Object.assign(g_config, a_args[1]);
            // more args
            if (a_args.length > 2) throw new TypeError(`unexpected argument(s) after input and config struct: ${a_args.slice(2)}`);
        }
    }
    // create reader, return transform stream
    return new $0a4e3e68448dada6$var$Reader(g_config).transform;
};


var $50d4a76629506683$exports = {};
// queueMicrotask shim

var $6ZWSX = parcelRequire("6ZWSX");
var $50d4a76629506683$require$Buffer = $6ZWSX.Buffer;
// not defined or not a function
if ("function" !== typeof queueMicrotask) {
    // create resolved promise
    let dp_resolve = Promise.resolve();
    // try to redefine
    try {
        // eslint-disable-next-line no-global-assign
        queueMicrotask = (fk)=>dp_resolve.then(fk).catch((e_callback)=>setTimeout(()=>{
                    throw e_callback;
                }, 0));
    } // oh well, at least we tried
    catch (e_define) {}
}


var $eNRCS = parcelRequire("eNRCS");


const $50d4a76629506683$var$quad = (k)=>$266825253b7f24dc$exports.quad(k._kt_subject, k._kt_predicate, k._kt_object, k._kt_graph);
// eslint-disable-next-line no-misleading-character-class
const $50d4a76629506683$var$RT_PREFIXED_NAME_NAMESPACE_VALID = /^([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}]([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.]*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?)?$/u;
// eslint-disable-next-line no-misleading-character-class
const $50d4a76629506683$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID = /^([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_:0-9]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%])(([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.:]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%])*([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}:]|%[A-Fa-f0-9]{2}|\\[_~.\-!$&'()*+,;=/?#@%]))?$/u;
// eslint-disable-next-line no-misleading-character-class
const $50d4a76629506683$var$RT_BLANK_NODE_VALID = /^[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_0-9]([A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}.]*[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u{02ff}\u{0370}-\u{037d}\u{037f}-\u{1fff}\u{200c}-\u{200d}\u{2070}-\u{218f}\u{2c00}-\u{2fef}\u{3001}-\u{d7ff}\u{f900}-\u{fdcf}\u{fdf0}-\u{fffd}\u{10000}-\u{effff}_\-0-9\xb7\u{0300}-\u{036f}\u{203f}-\u{2040}])?$/u;
const $50d4a76629506683$var$RT_NAMED_NODE_VALID = /^([^\0-\x20<>"{}|^`\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $50d4a76629506683$var$RT_NAMED_NODE_ESCAPELESS_VALID = /^([^\0-\x20<>"{}|^`])*$/;
const $50d4a76629506683$var$RT_LITERAL_CONTENTS_VALID = /^(?:[^\\]|\\[tbnrf"'\\]|\\u[A-Fa-f0-9]{4}|\\U[A-Fa-f0-9]{8})*$/;
const $50d4a76629506683$var$R_UNICODE_ANY = /\\u([0-9A-Fa-f]{4})|\\U([0-9A-Fa-f]{8})/g;
const $50d4a76629506683$var$F_REPLACE_UNICODE_ANY = (s_, s_4, s_8)=>String.fromCodePoint(parseInt(s_4 || s_8, 16));
const $50d4a76629506683$var$OPHOP = Object.prototype.hasOwnProperty;
const $50d4a76629506683$var$R_PREFIXED_NAME_QUICK = /([A-Za-z][A-Za-z0-9_-]*)?:([A-Za-z_0-9:][A-Za-z0-9_:-]*)(?:\s+|(?=\.?[<[("';,)\]#{}]|\.[\s\0]))/y;
const $50d4a76629506683$var$R_PREFIXED_NAME_ESCAPELESS = /([^\s#@<[("':_{}][^\s#@<[("':{}]*)?:((?:[^\s#@<[("'.;,{})\]\\](?:[^\s#@<[("';,{})\]\\]*[^\s#@<[("'.;,{})\]\\])?)?)(?:\s+|(?=\.?[<[("';,)\]#{}]|\.[\s\0]))/y;
const $50d4a76629506683$var$R_PREFIXED_NAME = /([^\s#@<[("':_{}][^\s#@<[("':{}]*)?:((?:(?:[^\s#@<[("'.;,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))(?:(?:[^\s#@<[("';,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))*(?:[^\s#@<[("'.;,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"])))?)?)(?:\s+|(?=\.?[<[("';,)\]#{}]|\.[\s\0]))/y;
const $50d4a76629506683$var$R_PN_LOCAL_ESCAPES = /\\(.)/g;
const $50d4a76629506683$var$R_BLANK_NODE_LABEL = /_:(.(?:[^\s:<;,)\]#}]*[^\s:<.;,)\]#}])?)(?:\s+|(?=[<:{,;\])#]))/y;
const $50d4a76629506683$var$R_BLANK_NODE_LABEL_TERMINAL = /_:(.(?:[^\s:<;,)\]#}]*[^\s:<.;,)\]#}])?)(?:\s+|(?=\.?[<:{,;\])#])|(?=\.[\s@#<({[}]))/y;
const $50d4a76629506683$var$R_IRIREF_ESCAPELESS = /<([^\\>]*)>\s*/y;
const $50d4a76629506683$var$R_IRIREF = /<([^>]*)>\s*/y;
const $50d4a76629506683$var$R_NUMERIC_LITERAL = /([+-]?(?:[0-9]+(\.[0-9]+)?|(\.[0-9]+))(\.?[eE][+-]?[0-9]+)?)(?:\s+|(?=\.[^eE0-9]|[;,)\]]))/y;
const $50d4a76629506683$var$R_BOOLEAN_LITERAL = /(?:(true|TRUE)|false|FALSE)\s*/y;
const $50d4a76629506683$var$R_A = /a(?:\s+|(?=[[("'<#]))/y;
const $50d4a76629506683$var$R_DOUBLE_CARET = /\^\^/y;
const $50d4a76629506683$var$R_WS = /\s*/y;
const $50d4a76629506683$var$R_LANGTAG = /@([A-Za-z]+(?:-[A-Za-z0-9-]+)*)(?:\s+|(?=[.},;\])#]))/y;
const $50d4a76629506683$var$R_PREFIX_KEYWORD = /(?:(@prefix)|[pP][rR][eE][fF][iI][xX])\s*/y;
const $50d4a76629506683$var$R_PREFIX_ID = /([^#:]*):\s*/iy;
const $50d4a76629506683$var$R_BASE_KEYWORD = /(?:(@base)|[bB][aA][sS][eE])\s*/y;
const $50d4a76629506683$var$R_GRAPH_IRI_ESCAPELESS = /(?:graph)?\s*<([^\\>]*)>\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH_PREFIXED_NAME = /(?:graph)?\s*([^\s#@<[("':_{}][^\s#@<[("':{}]*)?:((?:(?:[^\s#@<[("'.;,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))(?:(?:[^\s#@<[("';,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"]))*(?:[^\s#@<[("'.;,{})\]\\]|\\(?:%[0-9A-Fa-f][0-9A-Fa-f]|[^\s"])))?)?)\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH_LABELED_BLANK_NODE = /(?:graph)?\s*_:(.(?:[^\s:<;,)\]#}]*[^\s:<.;,)\]#}])?)\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH_ANONYMOUS_BLANK_NODE = /(?:graph)?\s*\[\s*\]\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH_IRI = /(?:graph)?\s*<([^>]*)>\s*\{\s*/iy;
const $50d4a76629506683$var$R_GRAPH = /graph(?:\s+|(?=[#<[{]))/iy;
const $50d4a76629506683$var$R_COMMENT = /(#[^\n]*\n\s*)+/y;
const $50d4a76629506683$var$RT_IRI_ABSOLUTE = /^[A-Za-z][A-Za-z0-9.\-+]*:/;
const $50d4a76629506683$var$R_RELATIVE_URI = /^(\/[^?#]+)([?#].*)?$/;
const $50d4a76629506683$var$R_BASE_IRI = /^((([A-Za-z0-9.\-+]*:\/)?\/[^/>]*)?(\/(?:[^/>]*\/)*)?[^>]*)$/;
const $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE = /\[\s*\]\s*/y;
const $50d4a76629506683$var$R_CHAR_BLANK_NODE = /\[(?:\s+|(?=[^\]]))/y;
const $50d4a76629506683$var$R_CHAR_COLLECTION = /\(\s*/y;
const $50d4a76629506683$var$R_CHAR_KET = /\]\s*/y;
const $50d4a76629506683$var$R_CHAR_OPEN = /\{\s*/y;
const $50d4a76629506683$var$R_CHAR_CLOSE = /\}\s*/y;
const $50d4a76629506683$var$R_CHAR_STOP = /\.\s*/y;
const $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_BREAK = /[\\"\r\n]/g;
const $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_BREAK = /[\\'\r\n]/g;
const $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM = /"{1,2}$/g;
const $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM = /'{1,2}$/g;
const $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_BREAK = /(\\|""")/g;
const $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_BREAK = /(\\|''')/g;
const $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS = (s_, s_whitespace, s_auto, s_4, s_8, s_invalid)=>{
    if (s_whitespace) switch(s_whitespace){
        case "t":
            return "	";
        case "n":
            return "\n";
        case "r":
            return "\r";
        case "f":
            return "\f";
        case "b":
            return "\b";
        default:
            console.assert(`bad regex escape char mapping: '${s_whitespace}'`);
    }
    else if (s_auto) return s_auto;
    else if (s_4) return String.fromCodePoint(parseInt(s_4, 16));
    else if (s_8) return String.fromCodePoint(parseInt(s_8, 16));
    else if (s_invalid) {
        // pointless escape
        if ("\\" === s_invalid[0]) // // relaxed
        // return s_invalid[1];
        // if relaxed then return s_invalid, otherwise throw:
        throw new Error(`expected string_literal but invalid escape sequence within contents: '${s_invalid}'. failed to parse a valid token`);
        else throw new Error(`expected string_literal but invalid whitespace character within contents: ${JSON.stringify(s_invalid)}. failed to parse a valid token`);
    } else console.assert(`unexpected no match branch in escape sequence replace callback`);
};
const $50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\.))/g;
const $50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|([\r\n]|\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $50d4a76629506683$var$unescape_literal_short_hard = (s_literal)=>s_literal.replace($50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_HARD, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS);
const $50d4a76629506683$var$unescape_literal_short_soft = (s_literal)=>{
    let m_incomplete = $50d4a76629506683$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($50d4a76629506683$var$R_STRLIT_SHORT_CONTENTS_ESCAPES_SOFT, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
const $50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_HARD = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|(\\.))/g;
const $50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT = /(?:\\(?:([tnrfb])|([\\"'])|u([0-9A-Fa-f]{4})|U([0-9A-Fa-f]{8}))|(\\[^uU]|\\u[^]{4}|\\U[^]{8}))/g;
const $50d4a76629506683$var$unescape_literal_long_hard = (s_literal)=>s_literal.replace($50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_HARD, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS);
const $50d4a76629506683$var$unescape_literal_long_soft = (s_literal)=>{
    let m_incomplete = $50d4a76629506683$var$R_STRLIT_ESCAPE_INCOMPLETE.exec(s_literal);
    // incomplete escape
    if (m_incomplete) {
        let i_safe = m_incomplete.index;
        // rewind
        return [
            s_literal.slice(0, i_safe).replace($50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS),
            s_literal.slice(i_safe)
        ];
    } else return [
        s_literal.replace($50d4a76629506683$var$R_STRLIT_LONG_CONTENTS_ESCAPES_SOFT, $50d4a76629506683$var$F_REPLACE_STRLIT_CONTENTS),
        ""
    ];
};
// lookbehind regexes
const [$50d4a76629506683$var$R_STRLIT_ESCAPE_INCOMPLETE, $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_TERM, $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_TERM, $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_TERM, $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_TERM] = (()=>{
    function RegExp_$lookbehind_polyfill(s_input) {
        let m_match = RegExp.prototype.exec.call(this, s_input);
        if (m_match) {
            let i_start = m_match[0].length - m_match[1].length;
            m_match.index += i_start;
            m_match[0] = m_match[0].slice(i_start);
        }
        return m_match;
    }
    let mk_lookbehind_regex = (()=>{
        try {
            new RegExp("(?<!h)i"); // eslint-disable-line no-new
        } catch (e_compile) {
            return (f_lookbehind, r_polyfill, f_polyfill)=>{
                r_polyfill.exec = f_polyfill;
                return r_polyfill;
            };
        }
        return (f_lookbehind)=>f_lookbehind();
    })();
    return [
        // R_STRLIT_ESCAPE_INCOMPLETE
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)\\\\(|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7})$"), /^(?:(?:[^\\]|\\.)*)(\\(?:|u[0-9A-Fa-f]{0,3}|U[0-9A-Fa-f]{0,7}))$/, function RegExp_$lookbehind_polyfill_n(s_input) {
            let m_match = RegExp.prototype.exec.call(this, s_input);
            if (m_match) m_match.index += m_match[0].length - m_match[1].length;
            return m_match;
        }),
        // R_STRLIT_SHORT_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"\\s*', "g"), /(?:[^\\"]|\\.)*("\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_SHORT_SINGLE_TERM
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)'\\s*", "g"), /(?:[^\\']|\\.)*('\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_LONG_DOUBLE_TERM
        mk_lookbehind_regex(()=>new RegExp('(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)"""\\s*', "g"), /(?:[^\\"]|\\.|""?(?!"))*("""\s*)/y, RegExp_$lookbehind_polyfill),
        // R_STRLIT_LONG_SINGLE_TERM
        mk_lookbehind_regex(()=>new RegExp("(?<!(?:[^\\\\]|^)(?:\\\\\\\\)*\\\\)'''\\s*", "g"), /(?:[^\\']|\\.|''?(?!'))*('''\s*)/y, RegExp_$lookbehind_polyfill)
    ];
})();
const $50d4a76629506683$var$match_prefixed_name_quick = (s, i)=>{
    $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
    return [
        $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s),
        $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex
    ];
};
const $50d4a76629506683$var$match_prefixed_name_escapeless = (s, i)=>{
    $50d4a76629506683$var$R_PREFIXED_NAME_ESCAPELESS.lastIndex = i;
    return [
        $50d4a76629506683$var$R_PREFIXED_NAME_ESCAPELESS.exec(s),
        $50d4a76629506683$var$R_PREFIXED_NAME_ESCAPELESS.lastIndex
    ];
};
const $50d4a76629506683$var$match_prefixed_name = (s, i)=>{
    $50d4a76629506683$var$R_PREFIXED_NAME.lastIndex = i;
    return [
        $50d4a76629506683$var$R_PREFIXED_NAME.exec(s),
        $50d4a76629506683$var$R_PREFIXED_NAME.lastIndex
    ];
};
function $50d4a76629506683$var$Reader$syntax_error(k_self, i, si_state, s_info) {
    let i_off = Math.min(i, Math.abs(i - 15));
    let s = k_self.s;
    return k_self.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + `expected ${si_state} ${s_info || ""}.  failed to parse a valid token starting at ${s[i] ? '"' + s[i] + '"' : "<<EOF>>"}`);
}
class $50d4a76629506683$var$TriG_Reader extends $141f1697ab3cba12$exports.Transform {
    constructor(g_impls){
        super({
            // do not decode strings into buffers
            decodeStrings: false,
            // accept strings as input on writable side
            writableObjectMode: false,
            // output quad objects on readable side
            readableObjectMode: true,
            // implementations
            flush: g_impls.flush,
            transform: g_impls.transform
        });
    }
    // intercept pipe
    pipe(ds_out) {
        let ds_dst = ds_out;
        // non-object mode
        if (!ds_dst._writableState.objectMode) // transform to JSON
        ds_out = $141f1697ab3cba12$exports.quads_to_json();
        else if (ds_out.isGraphyWritable) // transform to writable data events
        ds_out = $141f1697ab3cba12$exports.quads_to_writable();
        // interim stream created
        if (ds_out !== ds_dst) {
            // forward output to super
            super.pipe(ds_out);
            // pipe outpu to destination
            return ds_out.pipe(ds_dst);
        } else return super.pipe(ds_dst);
    }
}
class $50d4a76629506683$var$Reader {
    constructor(g_config = {}){
        // impl-specific configs
        let { // input medium
        input: g_input = null, // a state to inherit
        state: g_state = {} } = g_config;
        // inherit state from creator
        let { // index for anonymous blank node labels
        blank_node_index: i_anon = 0, // prefix map
        prefixes: h_prefixes = {}, // blank node label map
        labels: h_labels = {} } = g_state;
        let dc_factory = $266825253b7f24dc$exports.adopt(g_config.dataFactory || g_config.data_factory || $266825253b7f24dc$exports.unfiltered);
        let kt_default_graph = dc_factory.defaultGraph();
        // if data factory is not graphy, it might be returning the same object on each call to .defaultGraph()
        if (dc_factory !== $266825253b7f24dc$exports.unfiltered) // do not trust it, create a new object
        kt_default_graph = Object.create(kt_default_graph);
        let kt_rdf_first = dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#first");
        let blankNode = dc_factory.blankNode;
        let namedNode = dc_factory.namedNode;
        this.emit_data = $266825253b7f24dc$exports.unfiltered === dc_factory ? function() {
            ds_transform.push($50d4a76629506683$var$quad(this));
        } : function() {
            let g_quad = dc_factory.quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_graph);
            ds_transform.push(g_quad);
        };
        // fields
        Object.assign(this, {
            // read index
            i: 0,
            // string buffer
            s: "",
            // string buffer length
            n: 0,
            // left-over string from previous data chunk
            pre: g_config.prepend || "",
            // debug state
            _b_debug: g_config.debug || false,
            // relax
            _b_relax: g_config.relax || false,
            // factory
            _dc_factory: dc_factory,
            // current reader state
            _f_state: this.block,
            // map of current prefix ids => iris
            _h_prefixes: h_prefixes,
            // reader was destroyed by an error
            _b_destroyed: false,
            // current @base url
            _s_base_url: "",
            _s_base_url_scheme: "",
            _s_base_url_root: "",
            _s_base_url_path: "",
            // current data
            _kt_subject: null,
            _kt_predicate: kt_rdf_first,
            _kt_object: null,
            _kt_graph: kt_default_graph,
            _s_literal: "",
            // static terms
            _kt_rdf_type: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
            _kt_rdf_first: kt_rdf_first,
            _kt_rdf_rest: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"),
            _kt_rdf_nil: dc_factory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"),
            _kt_default_graph: kt_default_graph,
            // queue of nested subject, predicate, state for blanknodes and collections
            _a_nested: [],
            // hash to keep track of all blank node labels in use
            _h_labels: h_labels,
            // event routing
            event: this.emit,
            data: this.emit_data,
            // for restoring the original event callback when resuming paused stream
            restore_data: this.emit_data,
            // keep a queue of data events to hold onto until stream resumes (only happens in rare conditions)
            _a_queue_event: [],
            // helper states
            _b_expecting_full_stop: false,
            _s_temp_prefix_id: null,
            _b_trim_start: true,
            anonymous_blank_node: (s_label)=>blankNode(s_label, true),
            // finds the next non-conflicting blank node label
            next_label () {
                let s_label = "";
                do s_label = "g" + i_anon++;
                while (this._h_labels[s_label]);
                // claim this label, and remember that we invented it
                this._h_labels[s_label] = 2;
                // return the label
                return s_label;
            },
            // what to do when reach eos
            eos: null,
            // which state to go to after end of statement
            after_end_of_statement: this.post_object,
            // maximum length of a token: defaults to 2048 => http://stackoverflow.com/a/417184/1641160
            _n_max_token_length: g_config.max_token_length || g_config.maxTokenLength || 2048,
            // maximum length of a string (overrides max_token_length): defaults to Infinity
            _n_max_string_length: g_config.max_string_length || g_config.maxStringLength || Infinity,
            // byte tracking
            _b_byte_tracking: g_config.byte_tracking || g_config.byteTracking || false,
            _nb_seen: 0,
            _nb_last: 0,
            _nb_curr: 0
        });
        if (g_config.relaxed) console.warn(new Error(`no such option 'relaxed'; did you mean 'relax' ?`).stack.replace(/^Error:/, "Warning:"));
        if ("validate" in g_config) console.warn(new Error(`option 'validate' has been deprecated. Validation is now enabled by default. Use the 'relax' option if you wish to disable validation.`).stack.replace(/^Error:/, "Warning:"));
        // term constructors
        Object.assign(this, !g_config.relax ? {
            blank_node (s_label) {
                // test valid blank node label
                if (!$50d4a76629506683$var$RT_BLANK_NODE_VALID.test(s_label)) return this.error(`invalid blank node label: "${s_label}"`);
                // not first time use of label
                let z_label_state = this._h_labels[s_label];
                if (z_label_state) {
                    // label was used previously by document and has no conflict
                    if (1 === z_label_state) ; // eslint-disable-line no-empty
                    else if (2 === z_label_state) // so create a redirect mapping for this actual label & use it instead
                    s_label = this._h_labels[s_label] = this.next_label();
                    else // use redirected label
                    s_label = this._h_labels[s_label];
                } else // store label in hash so we avoid future collisions
                this._h_labels[s_label] = 1;
                // make term
                return blankNode(s_label);
            },
            check_named_node (p_iri) {
                if (!$50d4a76629506683$var$RT_NAMED_NODE_VALID.test(p_iri)) return this.error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            check_named_node_escapeless (p_iri) {
                if (!$50d4a76629506683$var$RT_NAMED_NODE_ESCAPELESS_VALID.test(p_iri)) return this.error(`invalid IRI: "${p_iri}"`);
                return namedNode(p_iri);
            },
            match_prefixed_name_quick (s, i) {
                $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
                return [
                    $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s),
                    $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex
                ];
            },
            match_prefixed_name_escapeless (s, i) {
                let [m_prefixed_name_e, im_prefixed_name_e] = $50d4a76629506683$var$match_prefixed_name_escapeless(s, i);
                if (m_prefixed_name_e) // invalid local name
                {
                    if (!$50d4a76629506683$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID.test(m_prefixed_name_e[2]) && m_prefixed_name_e[2]) {
                        this.error(`invalid prefixed name local name: "${m_prefixed_name_e[2]}:"`);
                        return;
                    }
                }
                return [
                    m_prefixed_name_e,
                    im_prefixed_name_e
                ];
            },
            match_prefixed_name (s, i) {
                let [m_prefixed_name, im_prefixed_name] = $50d4a76629506683$var$match_prefixed_name(s, i);
                if (m_prefixed_name) // invalid local name
                {
                    if (!$50d4a76629506683$var$RT_PREFIXED_NAME_LOCAL_NAME_VALID.test(m_prefixed_name[2])) {
                        this.error(`invalid prefixed name local name: "${m_prefixed_name[2]}:"`);
                        return;
                    }
                }
                return [
                    m_prefixed_name,
                    im_prefixed_name
                ];
            }
        } : {
            // term constructors
            blank_node (s_label) {
                // not first time use of label
                let z_label_state = this._h_labels[s_label];
                if (z_label_state) {
                    // label was used previously by document and has no conflict
                    if (1 === z_label_state) ; // eslint-disable-line no-empty
                    else if (2 === z_label_state) // so create a redirect mapping for this actual label & use it instead
                    s_label = this._h_labels[s_label] = this.next_label();
                    else // use redirected label
                    s_label = this._h_labels[s_label];
                } else // store label in hash so we avoid future collisions
                this._h_labels[s_label] = 1;
                // make term
                return blankNode(s_label);
            },
            check_named_node: namedNode,
            check_named_node_escapeless: namedNode,
            match_prefixed_name_escapeless: $50d4a76629506683$var$match_prefixed_name_escapeless,
            match_prefixed_name: $50d4a76629506683$var$match_prefixed_name
        });
        this.named_node = namedNode;
        this.prefixed_name = function(si_prefix, s_suffix) {
            return namedNode(h_prefixes[si_prefix] + s_suffix);
        };
        // oops -- user passed string into `base`
        if ("string" === typeof g_config.base) throw new TypeError(`invalid type 'string' was given for 'base' event listener: '${g_config.base}'\n` + `did you mean to use the 'base_uri' key instead?`);
        // base uri
        let p_set_base_uri = g_config.base_uri || g_config.baseUri || g_config.baseURI || g_config.base_iri || g_config.baseIri || g_config.baseIRI;
        if (p_set_base_uri) {
            let m_base_iri = $50d4a76629506683$var$R_BASE_IRI.exec(p_set_base_uri);
            this._s_base_url = m_base_iri[1];
            this._s_base_url_root = m_base_iri[2] || "";
            this._s_base_url_scheme = m_base_iri[3] || "";
            this._s_base_url_path = m_base_iri[4] || "";
        } else if (g_config.base_url || g_config.baseUrl || g_config.baseURL) throw new Error(`invalid option: .base${g_config.base_url ? "_url" : g_config.baseUrl ? "Url" : g_config.baseURL ? "URL" : ""}; use the '.base_uri' key instead`);
        // transform stream
        let ds_transform = this.transform = new $50d4a76629506683$var$TriG_Reader({
            // on data event
            transform: (s_chunk, s_encoding, fke_chunk)=>{
                // concatenate current chunk to previous chunk
                let s = this.s = this.pre + s_chunk;
                // cache chunk length
                this.n = s.length;
                // eat whitespace before token and reset index
                if (this._b_trim_start) {
                    // consume whitespace (and incidentally reset index)
                    $50d4a76629506683$var$R_WS.lastIndex = 0;
                    $50d4a76629506683$var$R_WS.exec(s);
                    this.i = $50d4a76629506683$var$R_WS.lastIndex;
                } else this.i = 0;
                // resume parsing; no errors
                if (this.safe_parse(true)) {
                    // emit progress event updates
                    ds_transform.emit("progress", s_chunk.length);
                    // done transforming this chunk
                    fke_chunk();
                }
            },
            // once there's no more data to consume, invoke eof
            flush: (fke_flush)=>{
                // now that input stream has ended, clean up remainder
                try {
                    this.eof(1);
                } // read error occurred
                catch (e_eof) {
                    // destroy self and stream
                    this.destroy(e_eof);
                    // exit gracefully
                    return;
                }
                // no errors. done flushing, close read stream
                fke_flush();
            }
        });
        // when the writable side is piped into
        ds_transform.on("pipe", (ds_input)=>{
            this._ds_input = ds_input;
            let b_byte_tracking = this._b_byte_tracking;
            // byte-tracking is disable & input stream has encoding option; ensure stream encoding is utf8
            if (!b_byte_tracking && "function" === typeof ds_input.setEncoding) ds_input.setEncoding("utf8");
            else {
                let f_write = ds_transform.write;
                let d_decoder = new $eNRCS.StringDecoder("utf8");
                let f_write_track = (s_chunk, s_encoding, fk_write)=>{
                    // TODO: optimize by testing for multibyte chars and using string length instead?
                    let nb_chunk = $50d4a76629506683$require$Buffer.from(s_chunk, "utf8").length;
                    this._nb_seen += nb_chunk;
                    this._nb_last = nb_chunk;
                    return f_write.call(ds_transform, s_chunk, s_encoding, fk_write);
                };
                let f_decode_write_track = (ab_chunk, s_encoding, fk_write)=>{
                    let nb_chunk = this._nb_last = ab_chunk.length;
                    this._nb_seen += nb_chunk;
                    return f_write.call(ds_transform, d_decoder.write(ab_chunk), s_encoding, fk_write);
                };
                let f_decode_write = (ab_chunk, s_encoding, fk_write)=>f_write.call(ds_transform, d_decoder.write(ab_chunk), s_encoding, fk_write);
                ds_transform.write = function(z_chunk, s_encoding, fk_write) {
                    // not null
                    if (null !== z_chunk) {
                        // chunk is string; adapt by resetting method to original
                        if ("string" === typeof z_chunk) ds_transform.write = b_byte_tracking ? f_write_track : f_write;
                        else ds_transform.write = b_byte_tracking ? f_decode_write_track : f_decode_write;
                        // use set method
                        return ds_transform.write(z_chunk, s_encoding, fk_write);
                    }
                    // null, use parent
                    return f_write.call(ds_transform, z_chunk, s_encoding, fk_write);
                };
                // byte tracking is enabled
                if (b_byte_tracking) // overwrite emit_data method
                this.emit_data = this.data = this.restore_data = function() {
                    let g_quad = this._dc_factory.quad(this._kt_subject, this._kt_predicate, this._kt_object, this._kt_graph);
                    let nb_post = $50d4a76629506683$require$Buffer.from(this.s.slice(this.i)).length;
                    let ib_post = this._nb_seen - nb_post;
                    g_quad.byteRange = [
                        this._nb_curr,
                        ib_post
                    ];
                    this._nb_curr = ib_post;
                    this.transform.push(g_quad);
                };
            }
        });
        // new listener added
        ds_transform.on("newListener", (s_event)=>{
            // comment
            if ("comment" === s_event) this.emit_comments = (s_captured)=>{
                let a_comments = s_captured.slice(1).replace(/\n\s+$/, "").split(/\n+\s*#/g);
                for (let s_comment of a_comments)ds_transform.emit("comment", s_comment);
            };
        });
        // destroy
        ds_transform._destroy = (...a_args)=>{
            this.destroy(...a_args);
        };
        // bind events to transform stream
        this.bind(g_config);
        // input given
        if (g_input) {
            // input is stream
            if (g_input.stream) {
                let ds_input = g_input.stream;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_input.pipe(ds_transform);
                });
            } else if ("string" === typeof g_input.string) {
                let s_input = g_input.string;
                // go async so caller has chance to bind event listeners
                queueMicrotask(()=>{
                    ds_transform.end(s_input, "utf8");
                });
            } else throw new TypeError(`Invalid argument for input parameter: ${"object" === typeof g_input ? JSON.stringify(g_input) : g_input}`);
        }
    }
    // begin parsing, keep applying until no more stack bail-outs
    safe_parse() {
        try {
            let f_sync = this._f_state();
            while("function" === typeof f_sync)f_sync = f_sync.apply(this);
        } // read error occurred
        catch (e_read) {
            // destroy self and stream
            this.destroy(e_read);
            // failure
            return false;
        }
        // okay
        return true;
    }
    emit(s_event, ...a_args) {
        this.transform.emit(s_event, ...a_args);
    }
    queue(s_event, ...a_args) {
        this._a_queue_event.push({
            event: s_event,
            args: a_args
        });
    }
    error(s_message) {
        // bail out
        throw new Error(s_message);
    }
    // parse_error (not meant to be an event callback)
    parse_error(s_expected, b_eof = false) {
        let i = this.i;
        let i_off = Math.min(i, Math.abs(i - 15));
        let s = this.s;
        return this.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + `expected ${s_expected} ${b_eof ? "but encountered <<EOF>>" : ""}.  failed to parse a valid token starting at ${s[i] ? '"' + s[i] + '"' : "<<EOF>>"}`);
    }
    info_error(s_message) {
        let i = this.i;
        let i_off = Math.min(i, Math.abs(i - 15));
        let s = this.s;
        this.error(`\n\`${s.substr(i_off, i_off + 90).replace(/[\n\t]/g, " ")}\`\n` + ` ${" ".repeat(i - i_off)}^\n` + s_message);
    }
    // end of file
    eof() {
        // there are events queued
        if (this._a_queue_event.length) {
            let a_queue = this._a_queue_event;
            // drain event queue
            while(a_queue.length){
                // remove event from front of queue
                let h_event = a_queue.shift();
                // make event callback
                this[h_event.event](h_event.data);
            }
        }
        // invalid parsing state
        if (this.block !== this._f_state) {
            // append EOF char
            this.s += "\x00";
            // exit "flowing" mode
            this.n = this.s.length;
            // resume parsing; no errors
            if (this.safe_parse()) {
                // eof has occurred under safe parse
                if (null === this.s) return;
                // still invalid parsing state
                if (this.block !== this._f_state) return this.parse_error(this._f_state.name, true);
            }
        }
        // there are still unparsed characters
        if (this.i < this.n) {
            // consume whitespace and comments
            let s = this.s;
            let i = this.i;
            // consume whitespace (and incidentally reset index)
            $50d4a76629506683$var$R_WS.lastIndex = i;
            $50d4a76629506683$var$R_WS.exec(s);
            i = $50d4a76629506683$var$R_WS.lastIndex;
            $50d4a76629506683$var$R_COMMENT.lastIndex = i;
            let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
            // advance beyond comment
            if ($50d4a76629506683$var$R_COMMENT.lastIndex > i) {
                this.i = i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                if (this.emit_comments) this.emit_comments(m_comment[0]);
            }
            // still unparsed characters
            if (i < this.n) {
                // not EOF
                if (!(i === this.n - 1 && "\x00" === s[i])) // bad input; parse error
                return this.parse_error(this._f_state.name);
            }
        }
        // make buffer's alloc eligible for gc
        this.s = null;
        // transform stream
        let ds_transform = this.transform;
        // final progress update: no additional bytes were read
        ds_transform.emit("progress", 0);
        // call end event listener
        ds_transform.emit("eof", this._h_prefixes);
        // close write stream (EOF-signaling)
        ds_transform.push(null);
    }
    // bind event listeners to transform stream
    bind(g_config) {
        let ds_transform = this.transform;
        if (g_config.base) ds_transform.on("base", g_config.base);
        if (g_config.prefix) ds_transform.on("prefix", g_config.prefix);
        if (g_config.enter) ds_transform.on("enter", g_config.enter);
        if (g_config.exit) ds_transform.on("exit", g_config.exit);
        if (g_config.comment) ds_transform.on("comment", g_config.comment);
        if (g_config.error) ds_transform.on("error", g_config.error);
        if (g_config.read) ds_transform.once("read", g_config.read);
        if (g_config.progress) ds_transform.on("progress", g_config.progress);
        if (g_config.eof) ds_transform.once("eof", g_config.eof);
        if (g_config.end) ds_transform.once("end", g_config.end);
        if (g_config.finish) ds_transform.once("finish", g_config.finish);
        if (g_config.data) ds_transform.on("data", g_config.data);
    }
    // after a blank node subject (either property-list or colleciton)
    post_blank_subject() {
        let { s: s, i: i } = this;
        if ("." === s[i]) {
            // consume whitespace (and incidentally reset index)
            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
            $50d4a76629506683$var$R_WS.exec(s);
            this.i = $50d4a76629506683$var$R_WS.lastIndex;
            // not inside block
            if (this._kt_default_graph === this._kt_graph) return this.block();
            else return this.statement();
        } else {
            // prepare sticky regex index
            $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex = i;
            if ($50d4a76629506683$var$R_CHAR_CLOSE.exec(s)) {
                // advance index
                this.i = $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex;
                // empty collection
                if (this._kt_rdf_nil.equals(this._kt_subject)) return this.error("empty collection");
                // emit graph_close event
                this.emit("exit", this._kt_graph);
                // reset graph
                this._kt_graph = this._kt_default_graph;
                // goto block state
                return this.block();
            }
        } // brace #1
        return this.pairs();
    }
    // parse state for statement
    statement() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefixed name quick
            // prepare sticky regex index
            $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
            // execute regex
            let m_pnq_subject = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s);
            // regex was a match
            if (m_pnq_subject) {
                // advance index
                this.i = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex;
                // check valid prefix
                let s_prefix_id = m_pnq_subject[1] || "";
                // invalid prefix
                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // commit subject iri from resolve prefixed name
                this._kt_subject = this.prefixed_name(s_prefix_id, m_pnq_subject[2]);
                // predicate-object pairs state
                return this.pairs();
            // iriref
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_subject = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_subject) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_e_subject[1];
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                    this._kt_subject = this.check_named_node_escapeless(s_iri);
                    else this._kt_subject = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // predicate-object pairs state
                    return this.pairs();
                // prefixed name
                } else {
                    // try match
                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                    // stack bail out
                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                    let [m_prefixed_named_e_subject, im_prefixed_named_e_subject] = aw_valid_this_match_prefixed_name_escapeless;
                    if (m_prefixed_named_e_subject) {
                        // advance index
                        this.i = im_prefixed_named_e_subject;
                        // check valid prefix
                        let s_prefix_id = m_prefixed_named_e_subject[1] || "";
                        // invalid prefix
                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                        // make subject key
                        this._kt_subject = this.prefixed_name(s_prefix_id, m_prefixed_named_e_subject[2]);
                        // predicate-object pairs state
                        return this.pairs();
                    // blank node label
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                        // execute regex
                        let m_blank_node_label_subject = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                        // regex was a match
                        if (m_blank_node_label_subject) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                            // extract label
                            let s_label = m_blank_node_label_subject[1];
                            // make subject key
                            this._kt_subject = this.blank_node(s_label);
                            // predicate-object pairs state
                            return this.pairs();
                        // anonymous blank node subject
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex = i;
                            if ($50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.exec(s)) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex;
                                // set new blank node as subject
                                this._kt_subject = this.anonymous_blank_node(this.next_label());
                                // goto pairs state for inside property list
                                return this.pairs();
                            // anonymous blank node property list subject
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_CHAR_BLANK_NODE.lastIndex = i;
                                if ($50d4a76629506683$var$R_CHAR_BLANK_NODE.exec(s)) {
                                    // advance index
                                    this.i = $50d4a76629506683$var$R_CHAR_BLANK_NODE.lastIndex;
                                    // enter blank node
                                    this._kt_subject = this.anonymous_blank_node(this.next_label());
                                    // how to resume when we pop state
                                    this._a_nested.push([
                                        this._kt_subject,
                                        this._kt_predicate,
                                        "post_blank_subject"
                                    ]);
                                    // goto pairs state for inside property list
                                    return this.pairs();
                                // rdf collection
                                } else {
                                    // prepare sticky regex index
                                    $50d4a76629506683$var$R_CHAR_COLLECTION.lastIndex = i;
                                    if ($50d4a76629506683$var$R_CHAR_COLLECTION.exec(s)) {
                                        // advance index
                                        this.i = $50d4a76629506683$var$R_CHAR_COLLECTION.lastIndex;
                                        // indicate that collection subject should emit an initial statement
                                        this._kt_subject = null;
                                        // (don't push state, we don't have a subject yet)
                                        // goto collection-subject state
                                        return this.collection_subject();
                                    // closing graph '}'
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex = i;
                                        if ($50d4a76629506683$var$R_CHAR_CLOSE.exec(s)) {
                                            // advance index
                                            this.i = $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex;
                                            // emit graph_close event
                                            this.emit("exit", this._kt_graph);
                                            // reset graph
                                            this._kt_graph = this._kt_default_graph;
                                            // goto block state
                                            return this.block();
                                        // iriref
                                        } else {
                                            // prepare sticky regex index
                                            $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                            // execute regex
                                            let m_iriref_subject = $50d4a76629506683$var$R_IRIREF.exec(s);
                                            // regex was a match
                                            if (m_iriref_subject) {
                                                // advance index
                                                this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                                // ref iri
                                                let s_iri = m_iriref_subject[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                                // absolute iri
                                                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                                                this._kt_subject = this.check_named_node(s_iri);
                                                else this._kt_subject = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                                // predicate-object pairs state
                                                return this.pairs();
                                            // prefixed name
                                            } else {
                                                // try match
                                                let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                                // stack bail out
                                                if (!aw_valid_this_match_prefixed_name) return true;
                                                let [m_prefixed_named_subject, im_prefixed_named_subject] = aw_valid_this_match_prefixed_name;
                                                if (m_prefixed_named_subject) {
                                                    // advance index
                                                    this.i = im_prefixed_named_subject;
                                                    // check valid prefix
                                                    let s_prefix_id = m_prefixed_named_subject[1] || "";
                                                    // invalid prefix
                                                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                    // escape local escapes
                                                    let s_suffix = m_prefixed_named_subject[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                                    // make subject key
                                                    this._kt_subject = this.prefixed_name(s_prefix_id, s_suffix);
                                                    // predicate-object pairs state
                                                    return this.pairs();
                                                // comment
                                                } else {
                                                    // prepare sticky regex index
                                                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                                    // execute regex
                                                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                                    // regex was a match
                                                    if (m_comment) {
                                                        // advance index
                                                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                        continue;
                                                    // not iriref, not prefixed name, not blank node label, not prefix id, not base
                                                    // match counter: 10
                                                    } else break;
                                                } // brace #10
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("statement");
            }
        }
        // save state before pausing
        this._f_state = this.statement;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for block
    block() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prepare sticky regex index
            $50d4a76629506683$var$R_GRAPH_IRI_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_graph_iriref_e_graph = $50d4a76629506683$var$R_GRAPH_IRI_ESCAPELESS.exec(s);
            // regex was a match
            if (m_graph_iriref_e_graph) {
                // advance index
                this.i = $50d4a76629506683$var$R_GRAPH_IRI_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_graph_iriref_e_graph[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set graph
                this._kt_graph = this.check_named_node_escapeless(s_iri);
                else this._kt_graph = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                this.emit("enter", this._kt_graph);
                // statement state
                return this.statement();
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_GRAPH_PREFIXED_NAME.lastIndex = i;
                // execute regex
                let m_graph_prefixed_name = $50d4a76629506683$var$R_GRAPH_PREFIXED_NAME.exec(s);
                // regex was a match
                if (m_graph_prefixed_name) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_GRAPH_PREFIXED_NAME.lastIndex;
                    // check valid prefix
                    let s_prefix_id = m_graph_prefixed_name[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // make subject key
                    this._kt_graph = this.prefixed_name(s_prefix_id, m_graph_prefixed_name[2]);
                    this.emit("enter", this._kt_graph);
                    // statement state
                    return this.statement();
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_CHAR_OPEN.lastIndex = i;
                    if ($50d4a76629506683$var$R_CHAR_OPEN.exec(s)) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_CHAR_OPEN.lastIndex;
                        // make new default graph
                        this._kt_graph = this._dc_factory.defaultGraph();
                        this.emit("enter", this._kt_graph);
                        // goto statement state
                        return this.statement();
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_GRAPH_ANONYMOUS_BLANK_NODE.lastIndex = i;
                        // execute regex
                        let m_graph_anonymous_blank_node = $50d4a76629506683$var$R_GRAPH_ANONYMOUS_BLANK_NODE.exec(s);
                        // regex was a match
                        if (m_graph_anonymous_blank_node) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_GRAPH_ANONYMOUS_BLANK_NODE.lastIndex;
                            // make new label & set graph to blank node
                            this._kt_graph = this.anonymous_blank_node(this.next_label());
                            this.emit("enter", this._kt_graph);
                            // statement state
                            return this.statement();
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_GRAPH_LABELED_BLANK_NODE.lastIndex = i;
                            // execute regex
                            let m_graph_labeled_blank_node = $50d4a76629506683$var$R_GRAPH_LABELED_BLANK_NODE.exec(s);
                            // regex was a match
                            if (m_graph_labeled_blank_node) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_GRAPH_LABELED_BLANK_NODE.lastIndex;
                                let s_label = m_graph_labeled_blank_node[1];
                                this._kt_graph = this.blank_node(s_label);
                                this.emit("enter", this._kt_graph);
                                // statement state
                                return this.statement();
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                                // execute regex
                                let m_iriref_e_graph_subject = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                                // regex was a match
                                if (m_iriref_e_graph_subject) {
                                    // advance index
                                    this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                                    // ref iri
                                    let s_iri = m_iriref_e_graph_subject[1];
                                    // absolute iri
                                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                                    this._kt_subject = this.check_named_node_escapeless(s_iri);
                                    else this._kt_subject = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                    // graph or subject
                                    return this.graph_or_subject();
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                                    let [m_prefixed_named_e_subject, im_prefixed_named_e_subject] = aw_valid_this_match_prefixed_name_escapeless;
                                    if (m_prefixed_named_e_subject) {
                                        // advance index
                                        this.i = im_prefixed_named_e_subject;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_e_subject[1] || "";
                                        // invalid prefix
                                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // make subject key
                                        this._kt_subject = this.prefixed_name(s_prefix_id, m_prefixed_named_e_subject[2]);
                                        // predicate-object pairs state
                                        return this.graph_or_subject();
                                    // blank node label
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                                        // execute regex
                                        let m_blank_node_label_subject = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                                        // regex was a match
                                        if (m_blank_node_label_subject) {
                                            // advance index
                                            this.i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                                            // extract label
                                            let s_label = m_blank_node_label_subject[1];
                                            // make subject key
                                            this._kt_subject = this.blank_node(s_label);
                                            // predicate-object pairs state
                                            return this.graph_or_subject();
                                        // anonymous blank node subject
                                        } else {
                                            // prepare sticky regex index
                                            $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex = i;
                                            if ($50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.exec(s)) {
                                                // advance index
                                                this.i = $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex;
                                                // set new blank node as subject
                                                this._kt_subject = this.anonymous_blank_node(this.next_label());
                                                // goto pairs state for inside property list
                                                return this.graph_or_subject();
                                            // anonymous blank node property list subject
                                            } else {
                                                // prepare sticky regex index
                                                $50d4a76629506683$var$R_CHAR_BLANK_NODE.lastIndex = i;
                                                if ($50d4a76629506683$var$R_CHAR_BLANK_NODE.exec(s)) {
                                                    // advance index
                                                    this.i = $50d4a76629506683$var$R_CHAR_BLANK_NODE.lastIndex;
                                                    // enter blank node
                                                    this._kt_subject = this.anonymous_blank_node(this.next_label());
                                                    // how to resume when we pop state
                                                    this._a_nested.push([
                                                        this._kt_subject,
                                                        this._kt_predicate,
                                                        "post_blank_subject"
                                                    ]);
                                                    // goto pairs state for inside property list
                                                    return this.graph_or_subject_property_list();
                                                // rdf collection
                                                } else {
                                                    // prepare sticky regex index
                                                    $50d4a76629506683$var$R_CHAR_COLLECTION.lastIndex = i;
                                                    if ($50d4a76629506683$var$R_CHAR_COLLECTION.exec(s)) {
                                                        // advance index
                                                        this.i = $50d4a76629506683$var$R_CHAR_COLLECTION.lastIndex;
                                                        // indicate that collection subject should emit an initial statement
                                                        this._kt_subject = null;
                                                        // (don't push state, we don't have a subject yet)
                                                        // goto collection-subject state
                                                        return this.collection_subject();
                                                    // prefix with interupt (e.g., a comment)
                                                    } else {
                                                        // prepare sticky regex index
                                                        $50d4a76629506683$var$R_PREFIX_KEYWORD.lastIndex = i;
                                                        // execute regex
                                                        let m_prefix_keyword = $50d4a76629506683$var$R_PREFIX_KEYWORD.exec(s);
                                                        // regex was a match
                                                        if (m_prefix_keyword) {
                                                            // advance index
                                                            this.i = $50d4a76629506683$var$R_PREFIX_KEYWORD.lastIndex;
                                                            // save whether or not to expect a full stop
                                                            this._b_expecting_full_stop = !!m_prefix_keyword[1];
                                                            // goto prefix state
                                                            return this.prefix_id();
                                                        // base with interupt (e.g., a comment)
                                                        } else {
                                                            // prepare sticky regex index
                                                            $50d4a76629506683$var$R_BASE_KEYWORD.lastIndex = i;
                                                            // execute regex
                                                            let m_base_keyword = $50d4a76629506683$var$R_BASE_KEYWORD.exec(s);
                                                            // regex was a match
                                                            if (m_base_keyword) {
                                                                // advance index
                                                                this.i = $50d4a76629506683$var$R_BASE_KEYWORD.lastIndex;
                                                                // save whether or not to expect a full stop
                                                                this._b_expecting_full_stop = !!m_base_keyword[1];
                                                                // goto base state
                                                                return this.base_iri();
                                                            // iriref
                                                            } else {
                                                                // prepare sticky regex index
                                                                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                                                // execute regex
                                                                let m_iriref_subject = $50d4a76629506683$var$R_IRIREF.exec(s);
                                                                // regex was a match
                                                                if (m_iriref_subject) {
                                                                    // advance index
                                                                    this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                                                    // ref iri
                                                                    let s_iri = m_iriref_subject[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                                                    // absolute iri
                                                                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set subject
                                                                    this._kt_subject = this.check_named_node(s_iri);
                                                                    else this._kt_subject = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                                                    // predicate-object pairs state
                                                                    return this.graph_or_subject();
                                                                // prefixed name
                                                                } else {
                                                                    // try match
                                                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                                                    // stack bail out
                                                                    if (!aw_valid_this_match_prefixed_name) return true;
                                                                    let [m_prefixed_named_subject, im_prefixed_named_subject] = aw_valid_this_match_prefixed_name;
                                                                    if (m_prefixed_named_subject) {
                                                                        // advance index
                                                                        this.i = im_prefixed_named_subject;
                                                                        // check valid prefix
                                                                        let s_prefix_id = m_prefixed_named_subject[1] || "";
                                                                        // invalid prefix
                                                                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                                        // escape local escapes
                                                                        let s_suffix = m_prefixed_named_subject[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                                                        // make subject key
                                                                        this._kt_subject = this.prefixed_name(s_prefix_id, s_suffix);
                                                                        // predicate-object pairs state
                                                                        return this.graph_or_subject();
                                                                    } else {
                                                                        // prepare sticky regex index
                                                                        $50d4a76629506683$var$R_GRAPH_IRI.lastIndex = i;
                                                                        // execute regex
                                                                        let m_graph_iriref_graph = $50d4a76629506683$var$R_GRAPH_IRI.exec(s);
                                                                        // regex was a match
                                                                        if (m_graph_iriref_graph) {
                                                                            // advance index
                                                                            this.i = $50d4a76629506683$var$R_GRAPH_IRI.lastIndex;
                                                                            // ref iri
                                                                            let s_iri = m_graph_iriref_graph[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                                                            // absolute iri
                                                                            if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set graph
                                                                            this._kt_graph = this.check_named_node(s_iri);
                                                                            else this._kt_graph = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                                                            this.emit("enter", this._kt_graph);
                                                                            // statement state
                                                                            return this.statement();
                                                                        // comment
                                                                        } else {
                                                                            // prepare sticky regex index
                                                                            $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                                                            // execute regex
                                                                            let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                                                            // regex was a match
                                                                            if (m_comment) {
                                                                                // advance index
                                                                                i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                                                                if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                                                continue;
                                                                            } else {
                                                                                // prepare sticky regex index
                                                                                $50d4a76629506683$var$R_GRAPH.lastIndex = i;
                                                                                if ($50d4a76629506683$var$R_GRAPH.exec(s)) {
                                                                                    // advance index
                                                                                    this.i = $50d4a76629506683$var$R_GRAPH.lastIndex;
                                                                                    return this.graph_keyword();
                                                                                // not iriref, not prefixed name, not blank node label, not prefix id, not base
                                                                                // match counter: 17
                                                                                } else break;
                                                                            } // brace #17
                                                                        } // brace #16
                                                                    } // brace #15
                                                                } // brace #14
                                                            } // brace #13
                                                        } // brace #12
                                                    } // brace #11
                                                } // brace #10
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("block");
            }
        }
        // save state before pausing
        this._f_state = this.block;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_or_subject
    graph_or_subject() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let x = s[i];
            if ("{" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // shift placeholder subject
                this._kt_graph = this._kt_subject;
                this.emit("enter", this._kt_graph);
                // reset subject in case of collections
                this._kt_subject = null;
                // statement state
                return this.statement();
            // non-comment
            } else if ("#" !== x) return this.pairs();
            else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_or_subject");
            }
        }
        // save state before pausing
        this._f_state = this.graph_or_subject;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_or_subject_property_list
    graph_or_subject_property_list() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let x = s[i];
            if ("]" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // next state
                return this.graph_or_subject_anon();
            // non-comment
            } else if ("#" !== x) return this.pairs();
            else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_or_subject_property_list");
            }
        }
        // save state before pausing
        this._f_state = this.graph_or_subject_property_list;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_or_subject_anon
    graph_or_subject_anon() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let x = s[i];
            if ("{" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // shift placeholder subject
                this._kt_graph = this._kt_subject;
                this.emit("enter", this._kt_graph);
                // reset subject in case of collections
                this._kt_subject = null;
                // pop dummy state
                this._a_nested.pop();
                // statement state
                return this.statement();
            // non-comment
            } else if ("#" !== x) return this.pairs();
            else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_or_subject_anon");
            }
        }
        // save state before pausing
        this._f_state = this.graph_or_subject_anon;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_keyword
    graph_keyword() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefixed name
            // try match
            let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
            // stack bail out
            if (!aw_valid_this_match_prefixed_name_escapeless) return true;
            let [m_prefixed_named_e_graph, im_prefixed_named_e_graph] = aw_valid_this_match_prefixed_name_escapeless;
            if (m_prefixed_named_e_graph) {
                // advance index
                this.i = im_prefixed_named_e_graph;
                // check valid prefix
                let s_prefix_id = m_prefixed_named_e_graph[1] || "";
                // invalid prefix
                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // make subject key
                this._kt_graph = this.prefixed_name(s_prefix_id, m_prefixed_named_e_graph[2]);
                // predicate-object pairs state
                return this.graph_post_name();
            // iriref
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_graph = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_graph) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_e_graph[1];
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set graph
                    this._kt_graph = this.check_named_node_escapeless(s_iri);
                    else this._kt_graph = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // graph
                    return this.graph_post_name();
                // blank node label
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                    // execute regex
                    let m_blank_node_label_graph = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                    // regex was a match
                    if (m_blank_node_label_graph) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                        // extract label
                        let s_label = m_blank_node_label_graph[1];
                        // make graph key
                        this._kt_graph = this.blank_node(s_label);
                        // predicate-object pairs state
                        return this.graph_post_name();
                    // anonymous blank node graph
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex = i;
                        if ($50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.exec(s)) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_ANONYMOUS_BLANK_NODE.lastIndex;
                            // set new blank node as graph
                            this._kt_graph = this.anonymous_blank_node(this.next_label());
                            // goto pairs state for inside property list
                            return this.graph_post_name();
                        // iriref
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                            // execute regex
                            let m_iriref_graph = $50d4a76629506683$var$R_IRIREF.exec(s);
                            // regex was a match
                            if (m_iriref_graph) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                // ref iri
                                let s_iri = m_iriref_graph[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                // absolute iri
                                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set graph
                                this._kt_graph = this.check_named_node(s_iri);
                                else this._kt_graph = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // predicate-object pairs state
                                return this.graph_post_name();
                            // prefixed name
                            } else {
                                // try match
                                let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                // stack bail out
                                if (!aw_valid_this_match_prefixed_name) return true;
                                let [m_prefixed_named_graph, im_prefixed_named_graph] = aw_valid_this_match_prefixed_name;
                                if (m_prefixed_named_graph) {
                                    // advance index
                                    this.i = im_prefixed_named_graph;
                                    // check valid prefix
                                    let s_prefix_id = m_prefixed_named_graph[1] || "";
                                    // invalid prefix
                                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                    // escape local escapes
                                    let s_suffix = m_prefixed_named_graph[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                    // make subject key
                                    this._kt_graph = this.prefixed_name(s_prefix_id, s_suffix);
                                    // predicate-object pairs state
                                    return this.graph_post_name();
                                // comment
                                } else {
                                    // prepare sticky regex index
                                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                    // execute regex
                                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                    // regex was a match
                                    if (m_comment) {
                                        // advance index
                                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                                        continue;
                                    // not iriref, not prefixed name, not blank node label, not prefix id, not base
                                    // match counter: 6
                                    } else break;
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_keyword");
            }
        }
        // save state before pausing
        this._f_state = this.graph_keyword;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for graph_post_name
    graph_post_name() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let x = s[i];
            if ("{" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                this.emit("enter", this._kt_graph);
                // statement state
                return this.statement();
            // comment
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("graph_post_name");
            }
        }
        // save state before pausing
        this._f_state = this.graph_post_name;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for pairs
    pairs() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // benchmarks indicate: regex for end of blank node property list faster than ch
            // iriref
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_predicate = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_predicate) {
                // advance index
                this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_predicate[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set predicate
                this._kt_predicate = this.check_named_node_escapeless(s_iri);
                else this._kt_predicate = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                // object-list state
                return this.object_list();
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_predicate, im_prefixed_named_e_predicate] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_predicate) {
                    // advance index
                    this.i = im_prefixed_named_e_predicate;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_predicate[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // make predicate key
                    this._kt_predicate = this.prefixed_name(s_prefix_id, m_prefixed_named_e_predicate[2]);
                    // object-list state
                    return this.object_list();
                // 'a'
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_A.lastIndex = i;
                    if ($50d4a76629506683$var$R_A.exec(s)) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_A.lastIndex;
                        // make predicate key
                        this._kt_predicate = this._kt_rdf_type;
                        // object-list state
                        return this.object_list();
                    // ']' end of blank node property list
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_CHAR_KET.lastIndex = i;
                        if ($50d4a76629506683$var$R_CHAR_KET.exec(s)) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_CHAR_KET.lastIndex;
                            let s_resume_state;
                            [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                            return this[s_resume_state]();
                        // iriref
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                            // execute regex
                            let m_iriref_predicate = $50d4a76629506683$var$R_IRIREF.exec(s);
                            // regex was a match
                            if (m_iriref_predicate) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                // ref iri
                                let s_iri = m_iriref_predicate[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                // absolute iri
                                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set predicate
                                this._kt_predicate = this.check_named_node(s_iri);
                                else this._kt_predicate = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // object-list state
                                return this.object_list();
                            // prefixed name
                            } else {
                                // try match
                                let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                // stack bail out
                                if (!aw_valid_this_match_prefixed_name) return true;
                                let [m_prefixed_named_predicate, im_prefixed_named_predicate] = aw_valid_this_match_prefixed_name;
                                if (m_prefixed_named_predicate) {
                                    // advance index
                                    this.i = im_prefixed_named_predicate;
                                    // check valid prefix
                                    let s_prefix_id = m_prefixed_named_predicate[1] || "";
                                    // invalid prefix
                                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                    // escape local escapes
                                    let s_suffix = m_prefixed_named_predicate[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                    // make predicate key
                                    this._kt_predicate = this.prefixed_name(s_prefix_id, s_suffix);
                                    // object-list state
                                    return this.object_list();
                                } else {
                                    // prepare sticky regex index
                                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                    // execute regex
                                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                    // regex was a match
                                    if (m_comment) {
                                        // advance index
                                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                                        continue;
                                    // not iriref, not prefixed name, not 'a'
                                    // match counter: 6
                                    } else break;
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("pairs");
            }
        }
        // save state before pausing
        this._f_state = this.pairs;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for object_list
    object_list() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // string literal * double
            if ('"' === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ('"' === s[i + 1] && '"' === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_double();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_double();
                    }
                } else if (i + 1 < n && '"' !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_double();
                } else break;
            // prefixed name quick
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
                // execute regex
                let m_pnq_object = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s);
                // regex was a match
                if (m_pnq_object) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex;
                    // check valid prefix
                    let s_prefix_id = m_pnq_object[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_pnq_object[2]);
                // iriref
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                    // execute regex
                    let m_iriref_e_object = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                    // regex was a match
                    if (m_iriref_e_object) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                        // ref iri
                        let s_iri = m_iriref_e_object[1];
                        // absolute iri
                        if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                        this._kt_object = this.check_named_node_escapeless(s_iri);
                        else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                    // prefixed name
                    } else {
                        // try match
                        let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                        // stack bail out
                        if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                        let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                        if (m_prefixed_named_e_object) {
                            // advance index
                            this.i = im_prefixed_named_e_object;
                            // check valid prefix
                            let s_prefix_id = m_prefixed_named_e_object[1] || "";
                            // invalid prefix
                            if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                            // commit object iri from resolve prefixed name
                            this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                        // string literal * single
                        } else if ("'" === x) {
                            // enough chars to deduce type
                            if (i + 2 < n) {
                                // long type
                                if ("'" === s[i + 1] && "'" === s[i + 2]) {
                                    // advance index beyond token
                                    this.i = i + 3;
                                    // read contents
                                    return this.string_literal_long_single();
                                } else {
                                    // advance index beyond token
                                    this.i = i + 1;
                                    // read contents
                                    return this.string_literal_short_single();
                                }
                            } else if (i + 1 < n && "'" !== s[i + 1]) {
                                // advance index beyond token
                                this.i = i + 1;
                                // read contents
                                return this.string_literal_short_single();
                            } else break;
                        // numeric literal
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex = i;
                            // execute regex
                            let m_numeric_literal = $50d4a76629506683$var$R_NUMERIC_LITERAL.exec(s);
                            // regex was a match
                            if (m_numeric_literal) {
                                // advance index
                                this.i = $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex;
                                // it has exponent term, xsd:double
                                if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                                else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                                else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                            // boolean literal
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex = i;
                                // execute regex
                                let m_boolean_literal = $50d4a76629506683$var$R_BOOLEAN_LITERAL.exec(s);
                                // regex was a match
                                if (m_boolean_literal) {
                                    // advance index
                                    this.i = $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex;
                                    // make literal
                                    this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                                // blank node property list
                                } else if ("[" === x) {
                                    // advance index to next token
                                    // consume whitespace (and incidentally reset index)
                                    $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                                    $50d4a76629506683$var$R_WS.exec(s);
                                    this.i = $50d4a76629506683$var$R_WS.lastIndex;
                                    // make object
                                    let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                                    // emit statement event
                                    this.data();
                                    // push state to stack
                                    this._a_nested.push([
                                        this._kt_subject,
                                        this._kt_predicate,
                                        "post_object"
                                    ]);
                                    // set new subject
                                    this._kt_subject = kt_blank_node;
                                    // goto parsing pairs state
                                    return this.pairs();
                                // labeled blank node
                                } else {
                                    // prepare sticky regex index
                                    $50d4a76629506683$var$R_BLANK_NODE_LABEL_TERMINAL.lastIndex = i;
                                    // execute regex
                                    let m_blank_node_label_object = $50d4a76629506683$var$R_BLANK_NODE_LABEL_TERMINAL.exec(s);
                                    // regex was a match
                                    if (m_blank_node_label_object) {
                                        // advance index
                                        this.i = $50d4a76629506683$var$R_BLANK_NODE_LABEL_TERMINAL.lastIndex;
                                        // ref blank node label
                                        let s_label = m_blank_node_label_object[1];
                                        // make object
                                        this._kt_object = this.blank_node(s_label);
                                    // collection
                                    } else if ("(" === x) {
                                        // advance index to next token
                                        // consume whitespace (and incidentally reset index)
                                        $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                                        $50d4a76629506683$var$R_WS.exec(s);
                                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                                        // state to resume after collection ends
                                        this._a_nested.push([
                                            this._kt_subject,
                                            this._kt_predicate,
                                            "post_object"
                                        ]);
                                        // goto collection-object state
                                        return this.collection_object();
                                    // iriref
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                        // execute regex
                                        let m_iriref_object = $50d4a76629506683$var$R_IRIREF.exec(s);
                                        // regex was a match
                                        if (m_iriref_object) {
                                            // advance index
                                            this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                            // ref iri
                                            let s_iri = m_iriref_object[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                            // absolute iri
                                            if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                            this._kt_object = this.check_named_node(s_iri);
                                            else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                        // prefixed name
                                        } else {
                                            // try match
                                            let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                            // stack bail out
                                            if (!aw_valid_this_match_prefixed_name) return true;
                                            let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                            if (m_prefixed_named_object) {
                                                // advance index
                                                this.i = im_prefixed_named_object;
                                                // check valid prefix
                                                let s_prefix_id = m_prefixed_named_object[1] || "";
                                                // invalid prefix
                                                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                                // escape local escapes
                                                let s_suffix = m_prefixed_named_object[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                                // commit object iri from resolve prefixed name
                                                this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                            } else {
                                                // prepare sticky regex index
                                                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                                // execute regex
                                                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                                // regex was a match
                                                if (m_comment) {
                                                    // advance index
                                                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                                                    continue;
                                                // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                                // match counter: 9
                                                } else break;
                                            } // brace #9
                                        } // brace #8
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            // fall through for cases that did not change state on their own
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("object_list");
            }
        }
        // save state before pausing
        this._f_state = this.object_list;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_short_double
    string_literal_short_double() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_short_double: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case '"':
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $50d4a76629506683$var$R_WS.lastIndex = i_break + 1;
                        $50d4a76629506683$var$R_WS.exec(s);
                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_TERM.lastIndex = i_break;
                            let m_term = $50d4a76629506683$var$R_STRLIT_SHORT_DOUBLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $50d4a76629506683$var$unescape_literal_short_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $50d4a76629506683$var$unescape_literal_short_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_short_double;
                            }
                        }
                    // invalid '\n'
                    case "\n":
                        return this.info_error(`expected string_literal_short_double but invalid line feed character '\\n' (newline) within contents. failed to parse a valid token`);
                    // invalid '\r'
                    case "\r":
                        return this.info_error(`expected string_literal_short_double but invalid form feed character '\\r' (carriage return) within contents. failed to parse a valid token`);
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_short_double`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // save
                this._s_literal += i ? s.slice(i) : s;
                // set unparsed index
                i = n;
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_short_double");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_short_double;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_short_single
    string_literal_short_single() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_short_single: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case "'":
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $50d4a76629506683$var$R_WS.lastIndex = i_break + 1;
                        $50d4a76629506683$var$R_WS.exec(s);
                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_TERM.lastIndex = i_break;
                            let m_term = $50d4a76629506683$var$R_STRLIT_SHORT_SINGLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $50d4a76629506683$var$unescape_literal_short_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $50d4a76629506683$var$unescape_literal_short_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_short_single;
                            }
                        }
                    // invalid '\n'
                    case "\n":
                        return this.info_error(`expected string_literal_short_single but invalid line feed character '\\n' (newline) within contents. failed to parse a valid token`);
                    // invalid '\r'
                    case "\r":
                        return this.info_error(`expected string_literal_short_single but invalid form feed character '\\r' (carriage return) within contents. failed to parse a valid token`);
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_short_single`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // save
                this._s_literal += i ? s.slice(i) : s;
                // set unparsed index
                i = n;
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_short_single");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_short_single;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_long_double
    string_literal_long_double() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_long_double: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case '"':
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $50d4a76629506683$var$R_WS.lastIndex = i_break + 3;
                        $50d4a76629506683$var$R_WS.exec(s);
                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_TERM.lastIndex = i_break;
                            let m_term = $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $50d4a76629506683$var$unescape_literal_long_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $50d4a76629506683$var$unescape_literal_long_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_long_double;
                            }
                        }
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_long_double`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // could be unfinished terminator
                $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM.lastIndex = i;
                let m_unfinished = $50d4a76629506683$var$R_STRLIT_LONG_DOUBLE_UNFINISHED_TERM.exec(s);
                // unfinished terminator
                if (m_unfinished) {
                    // save valid portion
                    this._s_literal += s.slice(i, m_unfinished.index);
                    // set unparsed index
                    i = m_unfinished.index;
                } else {
                    // save
                    this._s_literal += i ? s.slice(i) : s;
                    // set unparsed index
                    i = n;
                }
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_long_double");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_long_double;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal_long_single
    string_literal_long_single() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        string_literal_long_single: while(i < n){
            // something breaks string in this chunk
            // prepare sticky regex index
            $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_BREAK.lastIndex = i;
            // execute regex
            let m_break = $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_BREAK.exec(s);
            // regex was a match
            if (m_break) {
                // advance index
                this.i = $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_BREAK.lastIndex;
                // index of break
                let i_break = m_break.index;
                // add to contents
                this._s_literal += s.slice(i, i_break);
                // depending on char
                switch(s[i_break]){
                    // terminator
                    case "'":
                        // advance index to next token beyond delimiter
                        // consume whitespace (and incidentally reset index)
                        $50d4a76629506683$var$R_WS.lastIndex = i_break + 3;
                        $50d4a76629506683$var$R_WS.exec(s);
                        this.i = $50d4a76629506683$var$R_WS.lastIndex;
                        // resume eating whitespace at start of next chunk
                        this._b_trim_start = true;
                        // consume rest
                        return this.datatype_or_langtag();
                    // escape
                    case "\\":
                        {
                            // try to find end
                            $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_TERM.lastIndex = i_break;
                            let m_term = $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_TERM.exec(s);
                            // end is in this chunk
                            if (m_term) {
                                // index of terminator
                                let i_term = m_term.index;
                                // extract dirty potion
                                let s_dirty = s.slice(i_break, i_term);
                                // clean and save
                                this._s_literal += $50d4a76629506683$var$unescape_literal_long_hard(s_dirty);
                                // advance index beyond terminator
                                this.i = i_term + m_term[0].length;
                                // resume eating whitespace at start of next chunk
                                this._b_trim_start = true;
                                // consume rest
                                return this.datatype_or_langtag();
                            } else {
                                // extract whole portion
                                let s_dirty = s.slice(i_break);
                                // unescape to clean part
                                let [s_clean, s_incomplete] = $50d4a76629506683$var$unescape_literal_long_soft(s_dirty);
                                // save
                                this._s_literal += s_clean;
                                // set unparsed index
                                i = n - s_incomplete.length;
                                break string_literal_long_single;
                            }
                        }
                    // invalid
                    default:
                        console.assert(`Unhandle invalid character ${JSON.stringify(s[i_break])} case for string_literal_long_single`);
                }
            // no terminator and nothing to escape
            // match counter: 0
            } else {
                // could be unfinished terminator
                $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM.lastIndex = i;
                let m_unfinished = $50d4a76629506683$var$R_STRLIT_LONG_SINGLE_UNFINISHED_TERM.exec(s);
                // unfinished terminator
                if (m_unfinished) {
                    // save valid portion
                    this._s_literal += s.slice(i, m_unfinished.index);
                    // set unparsed index
                    i = m_unfinished.index;
                } else {
                    // save
                    this._s_literal += i ? s.slice(i) : s;
                    // set unparsed index
                    i = n;
                }
                break;
            }
        }
        // do not eat whitespace at start of next chunk
        this._b_trim_start = false;
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("string_literal_long_single");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal_long_single;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for string_literal
    string_literal() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref character
            let x = s[i];
            // string literal * double
            if ('"' === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ('"' === s[i + 1] && '"' === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_double();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_double();
                    }
                } else if (i + 1 < n && '"' !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_double();
                } else break;
            // string literal * single
            } else if ("'" === x) {
                // enough chars to deduce type
                if (i + 2 < n) {
                    // long type
                    if ("'" === s[i + 1] && "'" === s[i + 2]) {
                        // advance index beyond token
                        this.i = i + 3;
                        // read contents
                        return this.string_literal_long_single();
                    } else {
                        // advance index beyond token
                        this.i = i + 1;
                        // read contents
                        return this.string_literal_short_single();
                    }
                } else if (i + 1 < n && "'" !== s[i + 1]) {
                    // advance index beyond token
                    this.i = i + 1;
                    // read contents
                    return this.string_literal_short_single();
                } else break;
            // not string literal long single quote, not string literal single quote
            // match counter: 0
            } else break;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_string_length) return this.parse_error("string_literal");
            }
        }
        // save state before pausing
        this._f_state = this.string_literal;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for datatype_or_langtag
    datatype_or_langtag() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref character
            let x = s[i];
            // next token indicates datatype or langtag
            if ("^" === x || "@" === x) {
                // '^^' datatype
                // prepare sticky regex index
                $50d4a76629506683$var$R_DOUBLE_CARET.lastIndex = i;
                if ($50d4a76629506683$var$R_DOUBLE_CARET.exec(s)) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_DOUBLE_CARET.lastIndex;
                    return this.datatype();
                // '@' language tag
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_LANGTAG.lastIndex = i;
                    // execute regex
                    let m_langtag = $50d4a76629506683$var$R_LANGTAG.exec(s);
                    // regex was a match
                    if (m_langtag) {
                        // advance index
                        this.i = $50d4a76629506683$var$R_LANGTAG.lastIndex;
                        this._kt_object = this._dc_factory.languagedLiteral(this._s_literal, m_langtag[1]);
                        // reset literal
                        this._s_literal = "";
                    // next token definitely datatype or langtag, we are just being interrupted by eos
                    // match counter: 1
                    } else break;
                } // brace #1
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else {
                    this._kt_object = this._dc_factory.simpleLiteral(this._s_literal);
                    // reset literal
                    this._s_literal = "";
                // not datatype, not language tag => that's okay! those are optional
                }
            } // brace #1
            // goto end of statement state
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype_or_langtag");
            }
        }
        // save state before pausing
        this._f_state = this.datatype_or_langtag;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for datatype
    datatype() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let kt_datatype = null;
            // prefixed name quick
            // prepare sticky regex index
            $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex = i;
            // execute regex
            let m_pnq_datatype = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.exec(s);
            // regex was a match
            if (m_pnq_datatype) {
                // advance index
                this.i = $50d4a76629506683$var$R_PREFIXED_NAME_QUICK.lastIndex;
                // check valid prefix
                let s_prefix_id = m_pnq_datatype[1] || "";
                // invalid prefix
                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                // commit object iri from resolve prefixed name
                kt_datatype = this.prefixed_name(s_prefix_id, m_pnq_datatype[2]);
            // iriref
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
                // execute regex
                let m_iriref_e_datatype = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
                // regex was a match
                if (m_iriref_e_datatype) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                    let p_datatype;
                    // ref iri
                    let s_iri = m_iriref_e_datatype[1];
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_datatype
                    p_datatype = s_iri;
                    else p_datatype = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    kt_datatype = this.check_named_node_escapeless(p_datatype);
                // prefixed name
                } else {
                    // try match
                    let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                    // stack bail out
                    if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                    let [m_prefixed_named_e_datatype, im_prefixed_named_e_datatype] = aw_valid_this_match_prefixed_name_escapeless;
                    if (m_prefixed_named_e_datatype) {
                        // advance index
                        this.i = im_prefixed_named_e_datatype;
                        // check valid prefix
                        let s_prefix_id = m_prefixed_named_e_datatype[1] || "";
                        // invalid prefix
                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                        kt_datatype = this.prefixed_name(s_prefix_id, m_prefixed_named_e_datatype[2]);
                    // iriref
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                        // execute regex
                        let m_iriref_datatype = $50d4a76629506683$var$R_IRIREF.exec(s);
                        // regex was a match
                        if (m_iriref_datatype) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                            let p_datatype;
                            // ref iri
                            let s_iri = m_iriref_e_datatype[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                            // absolute iri
                            if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_datatype
                            p_datatype = s_iri;
                            else p_datatype = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                            kt_datatype = this.check_named_node(p_datatype);
                        // prefixed name
                        } else {
                            // try match
                            let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                            // stack bail out
                            if (!aw_valid_this_match_prefixed_name) return true;
                            let [m_prefixed_named_datatype, im_prefixed_named_datatype] = aw_valid_this_match_prefixed_name;
                            if (m_prefixed_named_datatype) {
                                // advance index
                                this.i = im_prefixed_named_datatype;
                                // check valid prefix
                                let s_prefix_id = m_prefixed_named_datatype[1] || "";
                                // invalid prefix
                                if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                // escape local escapes
                                let s_suffix = m_prefixed_named_datatype[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                // set literal datatype
                                kt_datatype = this.prefixed_name(s_prefix_id, s_suffix);
                            // not iriref, not prefixed name
                            // match counter: 4
                            } else break;
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            this._kt_object = this._dc_factory.datatypedLiteral(this._s_literal, kt_datatype);
            // reset literal
            this._s_literal = "";
            // goto end of statement state
            // at this point, a new statement has been parsed
            this.data();
            // goto next parsing state; bail out of stack
            return this.after_end_of_statement;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("datatype");
            }
        }
        // save state before pausing
        this._f_state = this.datatype;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for post_object
    post_object() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let i_reset = i;
            // benchmarks confirm: character ref faster than regexes in this context
            let x = s[i];
            // advance index to next token beyond delimiter
            // consume whitespace (and incidentally reset index)
            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
            $50d4a76629506683$var$R_WS.exec(s);
            this.i = $50d4a76629506683$var$R_WS.lastIndex;
            // ',' more objects
            if ("," === x) return this.object_list();
            else if (";" === x) {
                for(;;){
                    // next token is end of outer section
                    let s_peek = s[this.i];
                    if ("." === s_peek || "]" === s_peek || ";" === s_peek || "}" === s_peek) // goto post_object state
                    return this.post_object();
                    else if ("#" === s_peek) {
                        // comment
                        i = this.i;
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                        // execute regex
                        let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                        // regex was a match
                        if (m_comment) {
                            // advance index
                            this.i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                            continue;
                        } else break;
                    } else if (this.i === n) break;
                    else return this.pairs();
                }
                // rather than pushing a dedicated state, just try again next chunk
                i = i_reset;
                break;
            // '.' end of statement
            } else if ("." === x) {
                // assert not nested
                if (this._a_nested.length) {
                    // reset index to that character
                    this.i = i;
                    // emit parse error
                    return this.parse_error("end_of_property_list");
                }
                return this._kt_default_graph === this._kt_graph ? this.block() : this.statement();
            // ']' end of property-object pairs
            } else if ("]" === x) {
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            // ')' end of collection
            } else if (")" === x) // should not be here
            return $50d4a76629506683$var$Reader$syntax_error(this, i, "post_object", "but encountered end of collection");
            else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex = i;
                if ($50d4a76629506683$var$R_CHAR_CLOSE.exec(s)) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_CHAR_CLOSE.lastIndex;
                    // emit graph_close event
                    this.emit("exit", this._kt_graph);
                    // reset graph
                    this._kt_graph = this._kt_default_graph;
                    return this.block();
                // comment
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // comment interrupted by eos?
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("post_object");
            }
        }
        // save state before pausing
        this._f_state = this.post_object;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for base_iri
    base_iri() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefix id
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_base = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_base) {
                // advance index
                this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_base[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set base_url
                this._s_base_url = s_iri;
                else this._s_base_url = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                let m_base_iri = $50d4a76629506683$var$R_BASE_IRI.exec(this._s_base_url);
                this._s_base_url = m_base_iri[1];
                this._s_base_url_root = m_base_iri[2] || "";
                this._s_base_url_scheme = m_base_iri[3] || "";
                this._s_base_url_path = m_base_iri[4] || "";
                // emit base event
                this.emit("base", this._s_base_url);
                if (this._b_expecting_full_stop) // change state
                return this.full_stop();
                // goto prefix iri state
                return this.block();
            // prefix id
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                // execute regex
                let m_iriref_base = $50d4a76629506683$var$R_IRIREF.exec(s);
                // regex was a match
                if (m_iriref_base) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_base[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set base_url
                    this._s_base_url = s_iri;
                    else this._s_base_url = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    let m_base_iri = $50d4a76629506683$var$R_BASE_IRI.exec(this._s_base_url);
                    this._s_base_url = m_base_iri[1];
                    this._s_base_url_root = m_base_iri[2] || "";
                    this._s_base_url_scheme = m_base_iri[3] || "";
                    this._s_base_url_path = m_base_iri[4] || "";
                    // emit base event
                    this.emit("base", this._s_base_url);
                    if (this._b_expecting_full_stop) // change state
                    return this.full_stop();
                    // goto prefix iri state
                    return this.block();
                // for poorly-placed comments
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("base_iri");
            }
        }
        // save state before pausing
        this._f_state = this.base_iri;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for prefix_id
    prefix_id() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prefix id
            // prepare sticky regex index
            $50d4a76629506683$var$R_PREFIX_ID.lastIndex = i;
            // execute regex
            let m_prefix_id = $50d4a76629506683$var$R_PREFIX_ID.exec(s);
            // regex was a match
            if (m_prefix_id) {
                // advance index
                this.i = $50d4a76629506683$var$R_PREFIX_ID.lastIndex;
                // set temp prefix id
                this._s_temp_prefix_id = m_prefix_id[1];
                // goto prefix iri state
                return this.prefix_iri();
            // for poorly-placed comments
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("prefix_id");
            }
        }
        // save state before pausing
        this._f_state = this.prefix_id;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for prefix_iri
    prefix_iri() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            let h_prefixes = this._h_prefixes;
            let s_prefix_id = this._s_temp_prefix_id;
            let p_prefix_iri;
            // prefix iri
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_prefix = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_prefix) {
                // advance index
                this.i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_prefix[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_prefix_iri
                p_prefix_iri = s_iri;
                else p_prefix_iri = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                let b_relax = this._b_relax;
                // existing mapping
                if (s_prefix_id in h_prefixes) // doesn't match existing
                {
                    if (p_prefix_iri !== h_prefixes[s_prefix_id]) {
                        // emit change event
                        if (this.prefix_change) this.prefix_change(s_prefix_id, h_prefixes[s_prefix_id], p_prefix_iri);
                        // update prefix
                        h_prefixes[s_prefix_id] = p_prefix_iri;
                    }
                } else {
                    // check namespace, invalid
                    if (!b_relax && !$50d4a76629506683$var$RT_PREFIXED_NAME_NAMESPACE_VALID.test(s_prefix_id)) return this.error(`Invalid namespace for prefixed name: "${s_prefix_id}:"`);
                    // set prefix
                    h_prefixes[s_prefix_id] = p_prefix_iri;
                }
                // check iri, invalid
                if (!b_relax && !$50d4a76629506683$var$RT_NAMED_NODE_VALID.test(p_prefix_iri)) return this.error(`Invalid IRI found in prefix delcaration: "${s_iri}"`);
                // emit prefix event
                this.event("prefix", s_prefix_id, p_prefix_iri);
                if (this._b_expecting_full_stop) // change state
                return this.full_stop();
                // goto statement state
                return this.block();
            // prefix iri
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                // execute regex
                let m_iriref_prefix = $50d4a76629506683$var$R_IRIREF.exec(s);
                // regex was a match
                if (m_iriref_prefix) {
                    // advance index
                    this.i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                    // ref iri
                    let s_iri = m_iriref_prefix[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                    // absolute iri
                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set p_prefix_iri
                    p_prefix_iri = s_iri;
                    else p_prefix_iri = $1a8051d506d618be$exports.resolve(this._s_base_url, s_iri);
                    let b_relax = this._b_relax;
                    // existing mapping
                    if (s_prefix_id in h_prefixes) // doesn't match existing
                    {
                        if (p_prefix_iri !== h_prefixes[s_prefix_id]) {
                            // emit change event
                            if (this.prefix_change) this.prefix_change(s_prefix_id, h_prefixes[s_prefix_id], p_prefix_iri);
                            // update prefix
                            h_prefixes[s_prefix_id] = p_prefix_iri;
                        }
                    } else {
                        // check namespace, invalid
                        if (!b_relax && !$50d4a76629506683$var$RT_PREFIXED_NAME_NAMESPACE_VALID.test(s_prefix_id)) return this.error(`Invalid namespace for prefixed name: "${s_prefix_id}:"`);
                        // set prefix
                        h_prefixes[s_prefix_id] = p_prefix_iri;
                    }
                    // check iri, invalid
                    if (!b_relax && !$50d4a76629506683$var$RT_NAMED_NODE_VALID.test(p_prefix_iri)) return this.error(`Invalid IRI found in prefix delcaration: "${s_iri}"`);
                    // emit prefix event
                    this.event("prefix", s_prefix_id, p_prefix_iri);
                    if (this._b_expecting_full_stop) // change state
                    return this.full_stop();
                    // goto statement state
                    return this.block();
                // for poorly-placed comments
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                    // execute regex
                    let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                    // regex was a match
                    if (m_comment) {
                        // advance index
                        i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                        if (this.emit_comments) this.emit_comments(m_comment[0]);
                        continue;
                    // match counter: 2
                    } else break;
                } // brace #2
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("prefix_iri");
            }
        }
        // save state before pausing
        this._f_state = this.prefix_iri;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // in case eos happens twice during prefix / base (extremely unlikely)
    // parse state for full_stop
    full_stop() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // prepare sticky regex index
            $50d4a76629506683$var$R_CHAR_STOP.lastIndex = i;
            if ($50d4a76629506683$var$R_CHAR_STOP.exec(s)) {
                // advance index
                this.i = $50d4a76629506683$var$R_CHAR_STOP.lastIndex;
                // resume statement
                return this.block();
            // poorly-placed comment
            } else {
                // prepare sticky regex index
                $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                // execute regex
                let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                // regex was a match
                if (m_comment) {
                    // advance index
                    i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                    if (this.emit_comments) this.emit_comments(m_comment[0]);
                    continue;
                // possibly interrupted by eos
                // match counter: 1
                } else break;
            } // brace #1
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("full_stop");
            }
        }
        // save state before pausing
        this._f_state = this.full_stop;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for collection_subject
    collection_subject() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // end of collection
            if (")" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // no items in collection subject
                if (null === this._kt_subject) {
                    // prepare subject
                    this._kt_subject = this._kt_rdf_nil;
                    // state was never pushed to stack, jump to post_subject state
                    return this.post_blank_subject();
                }
                // otherwise, there must be items in collection
                // commit collection end
                this._kt_object = this._kt_rdf_nil;
                this.data();
                // restore state from stack
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            }
            // otherwise, pre-emptively secure the next blank node label
            let s_pointer_label;
            // very first collection object
            let b_pushed = false;
            if (null === this._kt_subject) {
                // set quasi subject (really for resume state)
                s_pointer_label = this.next_label();
                this._kt_subject = this.anonymous_blank_node(s_pointer_label);
                this._a_nested.push([
                    this._kt_subject,
                    this._kt_predicate,
                    "pairs"
                ]);
                // reset subject for later conditional branch
                this._kt_subject = null;
                b_pushed = true;
            }
            // iriref
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_object = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_object) {
                // advance index
                i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // ref iri
                let s_iri = m_iriref_e_object[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                this._kt_object = this.check_named_node_escapeless(s_iri);
                else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_object) {
                    // advance index
                    i = im_prefixed_named_e_object;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_object[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                // string literal
                } else if ('"' === x || "'" === x) {
                    // first item in list
                    if (null === this._kt_subject) {
                        s_pointer_label = this.next_label();
                        this._kt_subject = this.anonymous_blank_node(s_pointer_label);
                        this._kt_predicate = this._kt_rdf_first;
                    } else {
                        // make nest list item
                        s_pointer_label = this.next_label();
                        let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                        this.data();
                        // setup for object literal
                        this._kt_subject = kt_blank_node;
                        this._kt_predicate = this._kt_rdf_first;
                    }
                    // how to resume collection subject state after object literal
                    this.after_end_of_statement = function() {
                        this._kt_predicate = this._kt_rdf_rest;
                        this.after_end_of_statement = this.post_object;
                        return this.collection_subject();
                    };
                    return this.string_literal();
                // numeric literal
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex = i;
                    // execute regex
                    let m_numeric_literal = $50d4a76629506683$var$R_NUMERIC_LITERAL.exec(s);
                    // regex was a match
                    if (m_numeric_literal) {
                        // advance index
                        i = $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex;
                        // it has exponent term, xsd:double
                        if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                        else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                        else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                    // boolean literal
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex = i;
                        // execute regex
                        let m_boolean_literal = $50d4a76629506683$var$R_BOOLEAN_LITERAL.exec(s);
                        // regex was a match
                        if (m_boolean_literal) {
                            // advance index
                            i = $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex;
                            // make literal
                            this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                        // blank node property list
                        } else if ("[" === x) {
                            // advance index to next token
                            // consume whitespace (and incidentally reset index)
                            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                            $50d4a76629506683$var$R_WS.exec(s);
                            this.i = $50d4a76629506683$var$R_WS.lastIndex;
                            // this blank node is just the next item in the list
                            s_pointer_label = this.next_label();
                            let kt_blank_node;
                            if (null !== this._kt_subject) {
                                kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                                this.data();
                            }
                            // subject needs to be set
                            this._kt_subject = kt_blank_node || this.anonymous_blank_node(s_pointer_label);
                            this._kt_predicate = this._kt_rdf_first;
                            let s_label = this.next_label();
                            kt_blank_node = this._kt_object = this.anonymous_blank_node(s_label);
                            this.data();
                            // when resume
                            this._kt_predicate = this._kt_rdf_rest;
                            // push state
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_subject"
                            ]);
                            // prepare next triple
                            this._kt_subject = kt_blank_node;
                            // goto parsing pairs state
                            return this.pairs();
                        // new collection
                        } else if ("(" === x) {
                            // consume whitespace (and incidentally reset index)
                            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                            $50d4a76629506683$var$R_WS.exec(s);
                            i = $50d4a76629506683$var$R_WS.lastIndex;
                            // empty collection
                            if (")" === s[i]) {
                                this.i = i;
                                this._kt_subject = this._a_nested[this._a_nested.length - 1][0];
                                this._kt_predicate = this._kt_rdf_first;
                                this._a_nested.push([
                                    this._kt_subject,
                                    this._kt_rdf_rest,
                                    "collection_subject"
                                ]);
                                return this.collection_object();
                            }
                            // commit list item pointer
                            s_pointer_label = this.next_label();
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                            this.data();
                            // add this list as an item to the outer list
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // prepare next triple
                            this._kt_predicate = this._kt_rdf_first;
                            continue;
                        // labeled blank node
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                            // execute regex
                            let m_blank_node_label_object = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                            // regex was a match
                            if (m_blank_node_label_object) {
                                // advance index
                                i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                                // ref blank node label
                                let s_label = m_blank_node_label_object[1];
                                // make object
                                this._kt_object = this.blank_node(s_label);
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                // execute regex
                                let m_iriref_object = $50d4a76629506683$var$R_IRIREF.exec(s);
                                // regex was a match
                                if (m_iriref_object) {
                                    // advance index
                                    i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                    // ref iri
                                    let s_iri = m_iriref_object[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                    // absolute iri
                                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                    this._kt_object = this.check_named_node(s_iri);
                                    else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name) return true;
                                    let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                    if (m_prefixed_named_object) {
                                        // advance index
                                        i = im_prefixed_named_object;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_object[1] || "";
                                        // invalid prefix
                                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // escape local escapes
                                        let s_suffix = m_prefixed_named_object[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                        // commit object iri from resolve prefixed name
                                        this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                        // execute regex
                                        let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                        // regex was a match
                                        if (m_comment) {
                                            // advance index
                                            i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                            continue;
                                        // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                        // match counter: 7
                                        } else {
                                            // ran out of characters after pushing state, pop it
                                            if (b_pushed) this._a_nested.pop();
                                            break;
                                        }
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            let kt_blank_node_outer;
            if (!s_pointer_label) s_pointer_label = this.next_label();
            // not the very first item of collection subject
            if (this._kt_subject !== null) {
                // ref object
                let w_object = this._kt_object;
                // create blanknode to embed list
                kt_blank_node_outer = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                // emit statement that functions as collection's head "pointer"
                this.data();
                // swap back object
                this._kt_object = w_object;
            }
            // emit statement that is item
            this._kt_subject = kt_blank_node_outer || this.anonymous_blank_node(s_pointer_label);
            this._kt_predicate = this._kt_rdf_first;
            this.data();
            // prepare next predicate
            this._kt_predicate = this._kt_rdf_rest;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("collection_subject");
            }
        }
        // save state before pausing
        this._f_state = this.collection_subject;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    // parse state for collection_object
    collection_object() {
        // destruct chunk, length, and index
        let { s: s, n: n, i: i } = this;
        // start labeled loop, run while there are characters
        while(i < n){
            // ref char
            let x = s[i];
            // end of collection
            if (")" === x) {
                // consume whitespace (and incidentally reset index)
                $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                $50d4a76629506683$var$R_WS.exec(s);
                this.i = $50d4a76629506683$var$R_WS.lastIndex;
                // make & emit collection's tail "pointer"
                this._kt_object = this._kt_rdf_nil;
                this.data();
                // restore previous state
                let s_resume_state;
                [this._kt_subject, this._kt_predicate, s_resume_state] = this._a_nested.pop();
                return this[s_resume_state]();
            }
            // otherwise, pre-emptively secure the next blank node label
            let s_pointer_label;
            // iriref
            // prepare sticky regex index
            $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex = i;
            // execute regex
            let m_iriref_e_object = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.exec(s);
            // regex was a match
            if (m_iriref_e_object) {
                // advance index
                i = $50d4a76629506683$var$R_IRIREF_ESCAPELESS.lastIndex;
                // commit object iri as is
                // ref iri
                let s_iri = m_iriref_e_object[1];
                // absolute iri
                if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                this._kt_object = this.check_named_node_escapeless(s_iri);
                else this._kt_object = this.check_named_node_escapeless($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
            // prefixed name
            } else {
                // try match
                let aw_valid_this_match_prefixed_name_escapeless = this.match_prefixed_name_escapeless(s, i);
                // stack bail out
                if (!aw_valid_this_match_prefixed_name_escapeless) return true;
                let [m_prefixed_named_e_object, im_prefixed_named_e_object] = aw_valid_this_match_prefixed_name_escapeless;
                if (m_prefixed_named_e_object) {
                    // advance index
                    i = im_prefixed_named_e_object;
                    // check valid prefix
                    let s_prefix_id = m_prefixed_named_e_object[1] || "";
                    // invalid prefix
                    if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                    // commit object iri from resolve prefixed name
                    this._kt_object = this.prefixed_name(s_prefix_id, m_prefixed_named_e_object[2]);
                // string literal
                } else if ('"' === x || "'" === x) {
                    // update index before changing states
                    this.i = i;
                    // create blanknode to embed list
                    let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                    // emit statement that functions as collection's head "pointer"
                    this.data();
                    // prepare statement that is item
                    this._kt_subject = kt_blank_node;
                    this._kt_predicate = this._kt_rdf_first;
                    this.after_end_of_statement = function() {
                        this._kt_predicate = this._kt_rdf_rest;
                        this.after_end_of_statement = this.post_object;
                        return this.collection_object();
                    };
                    return this.string_literal();
                // numeric literal
                } else {
                    // prepare sticky regex index
                    $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex = i;
                    // execute regex
                    let m_numeric_literal = $50d4a76629506683$var$R_NUMERIC_LITERAL.exec(s);
                    // regex was a match
                    if (m_numeric_literal) {
                        // advance index
                        i = $50d4a76629506683$var$R_NUMERIC_LITERAL.lastIndex;
                        // it has exponent term, xsd:double
                        if (m_numeric_literal[4]) this._kt_object = this._dc_factory.double(m_numeric_literal[1]);
                        else if (m_numeric_literal[2] || m_numeric_literal[3]) this._kt_object = this._dc_factory.decimal(m_numeric_literal[1]);
                        else this._kt_object = this._dc_factory.integer(m_numeric_literal[1]);
                    // boolean literal
                    } else {
                        // prepare sticky regex index
                        $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex = i;
                        // execute regex
                        let m_boolean_literal = $50d4a76629506683$var$R_BOOLEAN_LITERAL.exec(s);
                        // regex was a match
                        if (m_boolean_literal) {
                            // advance index
                            i = $50d4a76629506683$var$R_BOOLEAN_LITERAL.lastIndex;
                            // make literal
                            this._kt_object = this._dc_factory.boolean(!!m_boolean_literal[1]);
                        // blank node property list
                        } else if ("[" === x) {
                            // advance index to next token
                            // consume whitespace (and incidentally reset index)
                            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                            $50d4a76629506683$var$R_WS.exec(s);
                            this.i = $50d4a76629506683$var$R_WS.lastIndex;
                            // commit head of list pointer
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                            this.data();
                            // setup state to resume and push
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // enter blank node
                            this._kt_predicate = this._kt_rdf_first;
                            kt_blank_node = this._kt_object = this.anonymous_blank_node(this.next_label());
                            this.data();
                            // prepare next triple
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_first;
                            // goto parsing pairs state
                            return this.pairs();
                        // new collection
                        } else if ("(" === x) {
                            // consume whitespace (and incidentally reset index)
                            $50d4a76629506683$var$R_WS.lastIndex = i + 1;
                            $50d4a76629506683$var$R_WS.exec(s);
                            i = $50d4a76629506683$var$R_WS.lastIndex;
                            // commit list item pointer
                            s_pointer_label = this.next_label();
                            let kt_blank_node = this._kt_object = this.anonymous_blank_node(s_pointer_label);
                            if (null === this._kt_subject) {
                                let a_recent = this._a_nested[this._a_nested.length - 1];
                                this._kt_subject = a_recent[0];
                                this._kt_predicate = a_recent[1];
                            }
                            this.data();
                            // add this list as an item to the outer list
                            this._kt_subject = kt_blank_node;
                            this._kt_predicate = this._kt_rdf_rest;
                            this._a_nested.push([
                                this._kt_subject,
                                this._kt_predicate,
                                "collection_object"
                            ]);
                            // prepare next triple
                            this._kt_predicate = this._kt_rdf_first;
                            continue;
                        // labeled blank node
                        } else {
                            // prepare sticky regex index
                            $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex = i;
                            // execute regex
                            let m_blank_node_label_object = $50d4a76629506683$var$R_BLANK_NODE_LABEL.exec(s);
                            // regex was a match
                            if (m_blank_node_label_object) {
                                // advance index
                                i = $50d4a76629506683$var$R_BLANK_NODE_LABEL.lastIndex;
                                // ref blank node label
                                let s_label = m_blank_node_label_object[1];
                                // make collection pointer label first
                                s_pointer_label = this.next_label();
                                // make object
                                this._kt_object = this.blank_node(s_label);
                            // iriref
                            } else {
                                // prepare sticky regex index
                                $50d4a76629506683$var$R_IRIREF.lastIndex = i;
                                // execute regex
                                let m_iriref_object = $50d4a76629506683$var$R_IRIREF.exec(s);
                                // regex was a match
                                if (m_iriref_object) {
                                    // advance index
                                    i = $50d4a76629506683$var$R_IRIREF.lastIndex;
                                    // commit object iri as is
                                    // ref iri
                                    let s_iri = m_iriref_object[1].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY);
                                    // absolute iri
                                    if (!this._s_base_url || $50d4a76629506683$var$RT_IRI_ABSOLUTE.test(s_iri)) // set object
                                    this._kt_object = this.check_named_node(s_iri);
                                    else this._kt_object = this.check_named_node($1a8051d506d618be$exports.resolve(this._s_base_url, s_iri));
                                // prefixed name
                                } else {
                                    // try match
                                    let aw_valid_this_match_prefixed_name = this.match_prefixed_name(s, i);
                                    // stack bail out
                                    if (!aw_valid_this_match_prefixed_name) return true;
                                    let [m_prefixed_named_object, im_prefixed_named_object] = aw_valid_this_match_prefixed_name;
                                    if (m_prefixed_named_object) {
                                        // advance index
                                        i = im_prefixed_named_object;
                                        // check valid prefix
                                        let s_prefix_id = m_prefixed_named_object[1] || "";
                                        // invalid prefix
                                        if (!$50d4a76629506683$var$OPHOP.call(this._h_prefixes, s_prefix_id)) return this.error(`no such prefix "${s_prefix_id}"`);
                                        // escape local escapes
                                        let s_suffix = m_prefixed_named_object[2].replace($50d4a76629506683$var$R_UNICODE_ANY, $50d4a76629506683$var$F_REPLACE_UNICODE_ANY).replace($50d4a76629506683$var$R_PN_LOCAL_ESCAPES, "$1");
                                        // commit object iri from resolve prefixed name
                                        this._kt_object = this.prefixed_name(s_prefix_id, s_suffix);
                                    } else {
                                        // prepare sticky regex index
                                        $50d4a76629506683$var$R_COMMENT.lastIndex = i;
                                        // execute regex
                                        let m_comment = $50d4a76629506683$var$R_COMMENT.exec(s);
                                        // regex was a match
                                        if (m_comment) {
                                            // advance index
                                            i = $50d4a76629506683$var$R_COMMENT.lastIndex;
                                            if (this.emit_comments) this.emit_comments(m_comment[0]);
                                            continue;
                                        // not iriref, not prefixed name, not string literal, not numeric literal, not boolean literal, not blank node property list, not collection
                                        // match counter: 7
                                        } else break;
                                    } // brace #7
                                } // brace #6
                            } // brace #5
                        } // brace #4
                    } // brace #3
                } // brace #2
            } // brace #1
            // ref object
            let w_object = this._kt_object;
            // create blanknode to embed list
            if (!s_pointer_label) s_pointer_label = this.next_label();
            let kt_blank_node_outer = this._kt_object = this.anonymous_blank_node(s_pointer_label);
            // emit statement that functions as collection's head "pointer"
            this.data();
            // emit statement that is item
            this._kt_subject = kt_blank_node_outer;
            this._kt_predicate = this._kt_rdf_first;
            this._kt_object = w_object;
            this.data();
            // prepare next predicate
            this._kt_predicate = this._kt_rdf_rest;
        }
        // ran out of characters
        // update index value
        this.i = i;
        // not yet eos
        if (i < this.n) // expected token was not found
        {
            if (0 === i) {
                // we've exceeded the maximum token length
                if (this.n > this.max_token_length) return this.parse_error("collection_object");
            }
        }
        // save state before pausing
        this._f_state = this.collection_object;
        // store what is unparsed
        this.pre = s.slice(i);
        // if we're not parsing a stream, then this is an error
        if (this.eos) this.eos();
        return;
    }
    destroy(e_destroy) {
        this.post_blank_subject = ()=>{};
        this.statement = ()=>{};
        this.block = ()=>{};
        this.graph_or_subject = ()=>{};
        this.graph_or_subject_property_list = ()=>{};
        this.graph_or_subject_anon = ()=>{};
        this.graph_keyword = ()=>{};
        this.graph_post_name = ()=>{};
        this.pairs = ()=>{};
        this.object_list = ()=>{};
        this.string_literal_short_double = ()=>{};
        this.string_literal_short_single = ()=>{};
        this.string_literal_long_double = ()=>{};
        this.string_literal_long_single = ()=>{};
        this.string_literal = ()=>{};
        this.datatype_or_langtag = ()=>{};
        this.datatype = ()=>{};
        this.post_object = ()=>{};
        this.base_iri = ()=>{};
        this.prefix_id = ()=>{};
        this.prefix_iri = ()=>{};
        this.full_stop = ()=>{};
        this.collection_subject = ()=>{};
        this.collection_object = ()=>{};
        this.eof = ()=>{
            this.s = null;
        };
        this._b_destroyed = true;
        // propagate input destroy
        if (!e_destroy && this._ds_input) this._ds_input.destroy(e_destroy);
        this.transform.demolish(e_destroy);
    }
}
$50d4a76629506683$exports = function(...a_args) {
    let g_config = {};
    // at least one argument
    if (a_args.length) {
        let z_arg_0 = a_args[0];
        // input given unspecified
        if (z_arg_0 && z_arg_0.input && "undefined" === typeof z_arg_0.input.string && !z_arg_0.input.stream) z_arg_0 = z_arg_0.input;
        // string
        if ("string" === typeof z_arg_0) g_config.input = {
            string: z_arg_0
        };
        else if (null === z_arg_0) g_config.input = null;
        else if ("function" === typeof z_arg_0.setEncoding) g_config.input = {
            stream: z_arg_0
        };
        else if ("function" === typeof z_arg_0.pipeTo) throw new TypeError(`Sorry, WHATWG streams are currently not supported :(`);
        else if (z_arg_0 && "object" === typeof z_arg_0 && "[object Object]" === Object.prototype.toString.call(z_arg_0)) {
            g_config = z_arg_0;
            // more args; invalid
            if (a_args.length > 1) throw new TypeError(`unexpected argument(s) after config struct: ${a_args.slice(1)}`);
        } else throw new TypeError(`unexpected input type: ${z_arg_0}`);
        // more args
        if (a_args.length > 1) {
            // copy onto struct
            Object.assign(g_config, a_args[1]);
            // more args
            if (a_args.length > 2) throw new TypeError(`unexpected argument(s) after input and config struct: ${a_args.slice(2)}`);
        }
    }
    // create reader, return transform stream
    return new $50d4a76629506683$var$Reader(g_config).transform;
};



var $biuEp = parcelRequire("biuEp");
var $5605c1058d66d37f$export$fd985e82eeb3038 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
var $5605c1058d66d37f$export$ed40fb79445e6c3f = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2000/01/rdf-schema#");
var $5605c1058d66d37f$export$f4d442bee9f13350 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2002/07/owl#");
var $5605c1058d66d37f$export$65dca9476b1ea120 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2001/XMLSchema#");
var $5605c1058d66d37f$export$7be7716cc4115fc5 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/ns/dcat#");
var $5605c1058d66d37f$export$2399ee13db66b01b = $5b5611d501681341$export$2e2bcd8739ae039("http://xmlns.com/foaf/0.1/");
var $5605c1058d66d37f$export$afb74c410165642c = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/ns/prov#");
var $5605c1058d66d37f$export$166a3e0dcf6b0f25 = $5b5611d501681341$export$2e2bcd8739ae039("http://schema.org/");
var $5605c1058d66d37f$export$1cd1943b3a73bbe8 = $5b5611d501681341$export$2e2bcd8739ae039("http://rdfs.org/ns/void#");
var $5605c1058d66d37f$export$5b088def975a652b = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/ns/sparql-service-description#");
var $5605c1058d66d37f$export$31263f9522fbe61c = $5b5611d501681341$export$2e2bcd8739ae039("http://purl.org/dc/elements/1.1/");
var $5605c1058d66d37f$export$969f4e5258613036 = $5b5611d501681341$export$2e2bcd8739ae039("http://purl.org/dc/terms/");
var $5605c1058d66d37f$export$b613353551a25804 = $5b5611d501681341$export$2e2bcd8739ae039("http://www.w3.org/2004/02/skos/core#");
var $5605c1058d66d37f$export$65000094e116eac3 = $5b5611d501681341$export$2e2bcd8739ae039("http://purl.org/pav/");
var $5605c1058d66d37f$export$4c64c06afd02bfd3 = $5b5611d501681341$export$2e2bcd8739ae039("https://w3id.org/mod#");
var $5605c1058d66d37f$export$d709348e62ac869e = $5b5611d501681341$export$2e2bcd8739ae039("http://purl.org/dc/dcmitype/");
var $5605c1058d66d37f$export$486b38f1ab67447b = $5b5611d501681341$export$2e2bcd8739ae039("http://purl.org/vocab/vann/");
var $5605c1058d66d37f$export$463bd1ce0149c55e = $5b5611d501681341$export$2e2bcd8739ae039("https://e.g/#");
const $5605c1058d66d37f$export$19285ac0211cbcbc = $5605c1058d66d37f$export$463bd1ce0149c55e("dataset");
const $5605c1058d66d37f$export$2e35bef72d35ec05 = $5605c1058d66d37f$export$463bd1ce0149c55e("dataset-service");
function $5605c1058d66d37f$var$unicodeToUrlendcode(text) {
    return text.replace(/\\u[\dA-F]{4}/gi, function(match) {
        let unicodeMatch = String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
        let urlEncodedMatch = encodeURIComponent(unicodeMatch);
        return urlEncodedMatch;
    });
}
function $5605c1058d66d37f$export$666a71f41531be3f(url) {
    var regex = new RegExp("^(?:[a-z+]+:)?//", "i");
    return regex.test(url);
}
function $5605c1058d66d37f$export$300bd6d67c49dbfc(url, baseURI, filename) {
    let result = url;
    if (url.localeCompare("") == 0) result = filename;
    if (!$5605c1058d66d37f$export$666a71f41531be3f(result)) {
        if (filename != null && filename != undefined && filename != "") result = (0, $biuEp.resolve)(filename, result);
        else result = (0, $biuEp.resolve)(baseURI, result);
    }
    if (!(result.startsWith("http://") || result.startsWith("https://") || result.startsWith("file://"))) result = "file://" + result;
    return result;
}
function $5605c1058d66d37f$export$f51a9068ac82ea43() {
    var store = $6f0137736d5eb798$export$3d344a3806285c2();
    store.setPrefixForURI("dcat", "http://www.w3.org/ns/dcat#");
    store.setPrefixForURI("ex", "https://e.g/#");
    store.setPrefixForURI("kgi", "https://ns.inria.fr/kg/index#");
    store.setPrefixForURI("sd", "http://www.w3.org/ns/sparql-service-description#");
    store.setPrefixForURI("wimmics", "https://team.inria.fr/wimmics/");
    store.setPrefixForURI("culturefr", "https://www.culture.gouv.fr/");
    store.setPrefixForURI("inria", "https://www.inria.fr/");
    store.setPrefixForURI("dbfr", "http://fr.dbpedia.org/");
    store.setPrefixForURI("cc", "http://creativecommons.org/ns#");
    store.setPrefixForURI("dbo", "http://dbpedia.org/ontology/");
    store.setPrefixForURI("dbfrp", "http://fr.dbpedia.org/property/");
    store.setPrefixForURI("openvoc", "http://open.vocab.org/terms/");
    store.setPrefixForURI("goodrel", "http://purl.org/goodrelations/v1#");
    store.setPrefixForURI("vann", "http://purl.org/vocab/vann/");
    store.setPrefixForURI("voaf", "http://purl.org/vocommons/voaf#");
    store.setPrefixForURI("eclass", "http://www.ebusiness-unibw.org/ontologies/eclass/5.1.4/#");
    store.setPrefixForURI("georss", "http://www.georss.org/georss/");
    store.setPrefixForURI("skos", "http://www.w3.org/2004/02/skos/core#");
    store.setPrefixForURI("powders", "http://www.w3.org/2007/05/powder-s#");
    store.setPrefixForURI("oa", "http://www.w3.org/ns/oa#");
    store.setPrefixForURI("wdentity", "http://www.wikidata.org/entity/");
    store.setPrefixForURI("dbfrg", "http://fr.dbpedia.org/graph/");
    store.setPrefixForURI("localdav", "http://localhost:8890/DAV/");
    store.setPrefixForURI("dbspr", "http://dbpedia.org/schema/property_rules#");
    store.setPrefixForURI("pav", "http://purl.org/pav/");
    store.setPrefixForURI("dce", "http://purl.org/dc/elements/1.1/");
    store.setPrefixForURI("mod", "https://w3id.org/mod#");
    store.setPrefixForURI("dcmitype", "http://purl.org/dc/dcmitype/");
    store.setPrefixForURI("schema", "http://schema.org/");
    store.setPrefixForURI("accessRight", "http://publications.europa.eu/resource/authority/access-right/");
    return store;
}
function $5605c1058d66d37f$export$e42ce4998cf68d98(ttlString) {
    const regexBnB = /([ \n])(b[0-9]+) /g;
    const regexNodeB = /([ \n])(node[0-9]+) /g;
    let result = ttlString;
    result = result.replaceAll("nodeID://", "_:"); // Dirty hack to fix nodeID:// from Virtuoso servers for turtle
    result = result.replaceAll("genid-", "_:"); // Dirty hack to fix blank nodes with genid- prefix
    result = result.replaceAll(regexBnB, "$1_:$2 "); // Dirty hack to fix blank nodes with b prefix
    result = result.replaceAll(regexNodeB, "$1_:$2 "); // Dirty hack to fix blank nodes with node prefix
    result = $5605c1058d66d37f$export$f41cc328a6c393c3(result);
    return result;
}
function $5605c1058d66d37f$export$f41cc328a6c393c3(text) {
    return text.replace(/\\u[\dA-F]{4}/gi, function(match) {
        let unicodeMatch = String.fromCharCode(parseInt(match.replace(/\\u/g, ""), 16));
        let urlEncodedMatch = encodeURIComponent(unicodeMatch);
        return urlEncodedMatch;
    });
}
function $5605c1058d66d37f$export$93c0abeba0b5b50d(store) {
    return new Promise((accept, reject)=>{
        $957a454a8ab6ebde$export$2e2bcd8739ae039(null, store, undefined, "application/ld+json", function(err, str) {
            if (err != null) reject(err);
            accept(str);
        }, {
            namespaces: store.namespaces
        });
    });
}
function $5605c1058d66d37f$export$147c92fc1e54141d(store) {
    return new Promise((accept, reject)=>{
        $957a454a8ab6ebde$export$2e2bcd8739ae039(null, store, undefined, "text/turtle", function(err, str) {
            if (err != null) reject(err);
            accept(str);
        }, {
            namespaces: store.namespaces
        });
    });
}
function $5605c1058d66d37f$export$4128d08d4610f65f(store) {
    return new Promise((accept, reject)=>{
        $957a454a8ab6ebde$export$2e2bcd8739ae039(null, store, undefined, "application/n-triples", function(err, str) {
            if (err != null) reject(err);
            accept(str);
        }, {
            namespaces: store.namespaces
        });
    });
}
function $5605c1058d66d37f$export$3f751611e1c07e11(content, store) {
    return new Promise((accept, reject)=>{
        try {
            content = $5605c1058d66d37f$var$unicodeToUrlendcode(content);
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, $5605c1058d66d37f$export$463bd1ce0149c55e("").value, "application/n-triples", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$c5a866906ae935ba(content, store) {
    return new Promise((accept, reject)=>{
        try {
            content = $5605c1058d66d37f$var$unicodeToUrlendcode(content);
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, $5605c1058d66d37f$export$463bd1ce0149c55e("").value, "text/n3", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$968deea481412d5d(content, store, base = $5605c1058d66d37f$export$463bd1ce0149c55e("").value) {
    return new Promise((accept, reject)=>{
        try {
            content = $5605c1058d66d37f$export$e42ce4998cf68d98(content);
            (0, (/*@__PURE__*/$parcel$interopDefault($9043c565d33eb642$exports)))(content, {
                baseIRI: base,
                data (y_quad) {
                    $5605c1058d66d37f$var$graphyQuadLoadingToStore(store, y_quad, base, "");
                },
                eof (h_prefixes) {
                    accept(store);
                },
                error (error) {
                    console.error("Error while reading RDF Turtle content using graphy reading function, error", error);
                    reject(error);
                }
            });
        } catch (error) {
            console.error("Error while parsing turtle content", content, "error", error);
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$6725074973fc00d(content, store) {
    return new Promise((accept, reject)=>{
        try {
            content = $5605c1058d66d37f$var$unicodeToUrlendcode(content);
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, $5605c1058d66d37f$export$463bd1ce0149c55e("").value, "application/ld+json", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$1843c9c1bbbb33a(content, store) {
    return new Promise((accept, reject)=>{
        try {
            content = $5605c1058d66d37f$var$unicodeToUrlendcode(content);
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, $5605c1058d66d37f$export$463bd1ce0149c55e("").value, "application/nquads", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$export$4e369e5d821beb3f(content, store) {
    return new Promise((accept, reject)=>{
        try {
            content = $5605c1058d66d37f$var$unicodeToUrlendcode(content);
            $3e841386a4d5e0bd$export$2e2bcd8739ae039(content, store, $5605c1058d66d37f$export$463bd1ce0149c55e("").value, "application/rdf+xml", (err, kb)=>{
                if (err != null) reject(err);
                accept(kb);
            });
        } catch (error) {
            reject(error);
        }
    });
}
function $5605c1058d66d37f$var$graphyQuadLoadingToStore(store, y_quad, baseURI = $5605c1058d66d37f$export$463bd1ce0149c55e("").value, filename = $5605c1058d66d37f$export$463bd1ce0149c55e("").value) {
    function createValidBlankNode(node, baseURI) {
        if (node.termType === "BlankNode") return $6f0137736d5eb798$export$fe4bf738d66b6b12(baseURI + "#" + node.value);
        else throw new Error("Invalid node" + node + " expecting blank node");
    }
    try {
        let s = undefined;
        if (y_quad.subject.termType === "NamedNode") s = $6f0137736d5eb798$export$fe4bf738d66b6b12($5605c1058d66d37f$export$300bd6d67c49dbfc(y_quad.subject.value, baseURI, filename));
        else if (y_quad.subject.termType === "Literal") {
            if (y_quad.subject.language != null && y_quad.subject.language != undefined && y_quad.subject.language != "") s = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.subject.value, y_quad.subject.language);
            else if (y_quad.subject.datatype != null && y_quad.subject.datatype != undefined && y_quad.subject.datatype != "") s = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.subject.value, undefined, $6f0137736d5eb798$export$fe4bf738d66b6b12(y_quad.subject.datatype));
            else s = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.subject.value);
        } else s = createValidBlankNode(y_quad.subject, baseURI);
        const p = $6f0137736d5eb798$export$fe4bf738d66b6b12(y_quad.predicate.value);
        let o = undefined;
        if (y_quad.object.termType === "NamedNode") o = $6f0137736d5eb798$export$fe4bf738d66b6b12($5605c1058d66d37f$export$300bd6d67c49dbfc(y_quad.object.value, baseURI, filename));
        else if (y_quad.object.termType === "Literal") {
            if (y_quad.object.language != null && y_quad.object.language != undefined && y_quad.object.language != "") o = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.object.value, y_quad.object.language);
            else if (y_quad.object.datatype != null && y_quad.object.datatype != undefined && y_quad.object.datatype != "") o = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.object.value, undefined, $6f0137736d5eb798$export$fe4bf738d66b6b12(y_quad.object.datatype));
            else o = $6f0137736d5eb798$export$f9c0624c04b6af9f(y_quad.object.value);
        } else o = createValidBlankNode(y_quad.object, baseURI);
        if (!$gCJkd.isLiteral(s)) {
            if (y_quad.graph.value === "") store.add(s, p, o);
            else {
                const g = $6f0137736d5eb798$export$fe4bf738d66b6b12(y_quad.graph);
                store.add(s, p, o, g);
            }
        }
    } catch (error) {
        console.error("Error while loading quad", y_quad, "error", error);
    }
}
const $5605c1058d66d37f$export$1c7d73fda2689091 = "application/n-triples";
const $5605c1058d66d37f$export$72c700663a6da118 = "application/nquads";
const $5605c1058d66d37f$export$9be2284ddc122481 = "text/turtle";
const $5605c1058d66d37f$export$b0cb396944dacc84 = "application/trig";
function $5605c1058d66d37f$var$getGraphyReadingFunction(contentType) {
    switch(contentType){
        case $5605c1058d66d37f$export$72c700663a6da118:
            return 0, (/*@__PURE__*/$parcel$interopDefault($0a4e3e68448dada6$exports));
        case $5605c1058d66d37f$export$1c7d73fda2689091:
            return 0, (/*@__PURE__*/$parcel$interopDefault($7d44226cc0f38078$exports));
        case $5605c1058d66d37f$export$b0cb396944dacc84:
            return 0, (/*@__PURE__*/$parcel$interopDefault($50d4a76629506683$exports));
        default:
        case $5605c1058d66d37f$export$9be2284ddc122481:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9043c565d33eb642$exports));
    }
}
function $5605c1058d66d37f$export$177a7908c10ca9b0(collection, store) {
    let result = [];
    store.statementsMatching(collection, $5605c1058d66d37f$export$fd985e82eeb3038("first")).forEach((statement)=>{
        if (!statement.object.equals($5605c1058d66d37f$export$fd985e82eeb3038("nil"))) result.push(statement.object);
    });
    store.statementsMatching(collection, $5605c1058d66d37f$export$fd985e82eeb3038("rest")).forEach((statement)=>{
        if (!statement.object.equals($5605c1058d66d37f$export$fd985e82eeb3038("nil"))) {
            if ($gCJkd.isNamedNode(statement.object)) result = result.concat($5605c1058d66d37f$export$177a7908c10ca9b0(statement.object, store));
            else if ($gCJkd.isBlankNode(statement.object)) result = result.concat($5605c1058d66d37f$export$177a7908c10ca9b0(statement.object, store));
        }
    });
    return [
        ...new Set(result)
    ];
}


var $03b19053b9503b86$exports = {};
var $26e61ff341e03f4b$exports = {};
/* parser generated by jison 0.4.18 */ /*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/ 
var $26e61ff341e03f4b$var$SparqlParser = function() {
    var o = function(k, v, o, l) {
        for(o = o || {}, l = k.length; l--; o[k[l]] = v);
        return o;
    }, $V0 = [
        6,
        12,
        13,
        15,
        16,
        24,
        32,
        36,
        41,
        45,
        100,
        110,
        113,
        115,
        116,
        123,
        126,
        131,
        197,
        224,
        229,
        308,
        329,
        330,
        331,
        332,
        333
    ], $V1 = [
        2,
        247
    ], $V2 = [
        100,
        110,
        113,
        115,
        116,
        123,
        126,
        131,
        329,
        330,
        331,
        332,
        333
    ], $V3 = [
        2,
        409
    ], $V4 = [
        1,
        18
    ], $V5 = [
        1,
        27
    ], $V6 = [
        13,
        16,
        45,
        197,
        224,
        229,
        308
    ], $V7 = [
        28,
        29,
        53
    ], $V8 = [
        28,
        53
    ], $V9 = [
        1,
        42
    ], $Va = [
        1,
        45
    ], $Vb = [
        1,
        41
    ], $Vc = [
        1,
        44
    ], $Vd = [
        123,
        126
    ], $Ve = [
        1,
        67
    ], $Vf = [
        39,
        45,
        87
    ], $Vg = [
        13,
        16,
        45,
        197,
        224,
        308
    ], $Vh = [
        1,
        87
    ], $Vi = [
        2,
        281
    ], $Vj = [
        1,
        86
    ], $Vk = [
        13,
        16,
        45,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vl = [
        6,
        28,
        29,
        53,
        63,
        70,
        73,
        81,
        83,
        85
    ], $Vm = [
        6,
        13,
        16,
        28,
        29,
        53,
        63,
        70,
        73,
        81,
        83,
        85,
        87,
        308
    ], $Vn = [
        6,
        13,
        16,
        28,
        29,
        45,
        53,
        63,
        70,
        73,
        81,
        82,
        83,
        85,
        87,
        89,
        197,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314
    ], $Vo = [
        6,
        13,
        16,
        28,
        29,
        31,
        39,
        45,
        47,
        48,
        53,
        63,
        70,
        73,
        81,
        82,
        83,
        85,
        87,
        89,
        109,
        112,
        121,
        123,
        126,
        128,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        337,
        338,
        340,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vp = [
        13,
        16,
        308
    ], $Vq = [
        112,
        132,
        327,
        334
    ], $Vr = [
        13,
        16,
        112,
        132,
        308
    ], $Vs = [
        1,
        111
    ], $Vt = [
        1,
        117
    ], $Vu = [
        112,
        132,
        327,
        328,
        334
    ], $Vv = [
        13,
        16,
        112,
        132,
        308,
        328
    ], $Vw = [
        28,
        29,
        45,
        53,
        87
    ], $Vx = [
        1,
        138
    ], $Vy = [
        1,
        151
    ], $Vz = [
        1,
        128
    ], $VA = [
        1,
        127
    ], $VB = [
        1,
        129
    ], $VC = [
        1,
        140
    ], $VD = [
        1,
        141
    ], $VE = [
        1,
        142
    ], $VF = [
        1,
        143
    ], $VG = [
        1,
        144
    ], $VH = [
        1,
        145
    ], $VI = [
        1,
        147
    ], $VJ = [
        1,
        148
    ], $VK = [
        2,
        457
    ], $VL = [
        1,
        158
    ], $VM = [
        1,
        159
    ], $VN = [
        1,
        160
    ], $VO = [
        1,
        152
    ], $VP = [
        1,
        153
    ], $VQ = [
        1,
        156
    ], $VR = [
        1,
        171
    ], $VS = [
        1,
        172
    ], $VT = [
        1,
        173
    ], $VU = [
        1,
        174
    ], $VV = [
        1,
        175
    ], $VW = [
        1,
        176
    ], $VX = [
        1,
        167
    ], $VY = [
        1,
        168
    ], $VZ = [
        1,
        169
    ], $V_ = [
        1,
        170
    ], $V$ = [
        1,
        157
    ], $V01 = [
        1,
        166
    ], $V11 = [
        1,
        161
    ], $V21 = [
        1,
        162
    ], $V31 = [
        1,
        163
    ], $V41 = [
        1,
        164
    ], $V51 = [
        1,
        165
    ], $V61 = [
        6,
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335
    ], $V71 = [
        1,
        195
    ], $V81 = [
        6,
        31,
        73,
        81,
        83,
        85
    ], $V91 = [
        2,
        285
    ], $Va1 = [
        1,
        199
    ], $Vb1 = [
        1,
        201
    ], $Vc1 = [
        6,
        31,
        70,
        73,
        81,
        83,
        85
    ], $Vd1 = [
        2,
        283
    ], $Ve1 = [
        1,
        207
    ], $Vf1 = [
        1,
        218
    ], $Vg1 = [
        1,
        223
    ], $Vh1 = [
        1,
        219
    ], $Vi1 = [
        1,
        225
    ], $Vj1 = [
        1,
        226
    ], $Vk1 = [
        1,
        224
    ], $Vl1 = [
        6,
        63,
        70,
        73,
        81,
        83,
        85
    ], $Vm1 = [
        1,
        236
    ], $Vn1 = [
        2,
        334
    ], $Vo1 = [
        1,
        243
    ], $Vp1 = [
        1,
        241
    ], $Vq1 = [
        6,
        193
    ], $Vr1 = [
        2,
        349
    ], $Vs1 = [
        2,
        339
    ], $Vt1 = [
        28,
        128
    ], $Vu1 = [
        47,
        48,
        193,
        272
    ], $Vv1 = [
        47,
        48,
        193,
        242,
        272
    ], $Vw1 = [
        47,
        48,
        193,
        242,
        246,
        272
    ], $Vx1 = [
        47,
        48,
        193,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        297,
        298,
        299,
        300,
        301,
        302,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vy1 = [
        39,
        47,
        48,
        193,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        297,
        298,
        299,
        300,
        301,
        302,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $Vz1 = [
        1,
        271
    ], $VA1 = [
        1,
        270
    ], $VB1 = [
        6,
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        70,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        242,
        246,
        250,
        263,
        265,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351
    ], $VC1 = [
        1,
        281
    ], $VD1 = [
        1,
        280
    ], $VE1 = [
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $VF1 = [
        45,
        89
    ], $VG1 = [
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        174,
        193,
        197,
        224,
        229,
        231,
        232,
        242,
        246,
        250,
        263,
        265,
        272,
        290,
        292,
        293,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335,
        338,
        341,
        342,
        343,
        344,
        345,
        346
    ], $VH1 = [
        13,
        16,
        31,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $VI1 = [
        31,
        89
    ], $VJ1 = [
        48,
        87
    ], $VK1 = [
        6,
        13,
        16,
        45,
        48,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        337,
        338
    ], $VL1 = [
        6,
        13,
        16,
        39,
        45,
        48,
        82,
        87,
        89,
        231,
        263,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        337,
        338,
        340
    ], $VM1 = [
        1,
        313
    ], $VN1 = [
        6,
        85
    ], $VO1 = [
        6,
        31,
        81,
        83,
        85
    ], $VP1 = [
        2,
        361
    ], $VQ1 = [
        2,
        353
    ], $VR1 = [
        1,
        343
    ], $VS1 = [
        31,
        112,
        335
    ], $VT1 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        197,
        224,
        229,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $VU1 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        197,
        224,
        229,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        314,
        317,
        318,
        335
    ], $VV1 = [
        6,
        109,
        193
    ], $VW1 = [
        31,
        112
    ], $VX1 = [
        13,
        16,
        45,
        82,
        87,
        224,
        263,
        265,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312,
        346,
        347,
        348,
        349,
        350,
        351
    ], $VY1 = [
        1,
        390
    ], $VZ1 = [
        1,
        391
    ], $V_1 = [
        13,
        16,
        87,
        197,
        308,
        314
    ], $V$1 = [
        13,
        16,
        39,
        45,
        82,
        87,
        224,
        263,
        265,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V02 = [
        1,
        417
    ], $V12 = [
        1,
        418
    ], $V22 = [
        13,
        16,
        48,
        197,
        229,
        308
    ], $V32 = [
        6,
        31,
        85
    ], $V42 = [
        6,
        13,
        16,
        31,
        45,
        73,
        81,
        83,
        85,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V52 = [
        6,
        13,
        16,
        29,
        31,
        45,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        346,
        347,
        348,
        349,
        350,
        351
    ], $V62 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164
    ], $V72 = [
        1,
        443
    ], $V82 = [
        1,
        444
    ], $V92 = [
        1,
        449
    ], $Va2 = [
        31,
        112,
        193,
        232,
        318,
        335
    ], $Vb2 = [
        13,
        16,
        45,
        48,
        82,
        87,
        89,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vc2 = [
        13,
        16,
        31,
        45,
        48,
        82,
        87,
        89,
        112,
        193,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Vd2 = [
        13,
        16,
        29,
        31,
        45,
        48,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Ve2 = [
        13,
        16,
        31,
        48,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $Vf2 = [
        31,
        45
    ], $Vg2 = [
        1,
        507
    ], $Vh2 = [
        1,
        508
    ], $Vi2 = [
        6,
        13,
        16,
        29,
        31,
        39,
        45,
        47,
        48,
        63,
        70,
        73,
        76,
        78,
        81,
        82,
        83,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        231,
        242,
        246,
        250,
        263,
        265,
        268,
        269,
        270,
        271,
        272,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        290,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335,
        336,
        338,
        341,
        342,
        343,
        344,
        345,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vj2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        335
    ], $Vk2 = [
        6,
        13,
        16,
        31,
        45,
        70,
        73,
        81,
        83,
        85,
        87,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vl2 = [
        13,
        16,
        31,
        45,
        48,
        82,
        87,
        89,
        112,
        193,
        197,
        231,
        232,
        272,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        317,
        318,
        335
    ], $Vm2 = [
        2,
        352
    ], $Vn2 = [
        13,
        16,
        197,
        308,
        314
    ], $Vo2 = [
        1,
        565
    ], $Vp2 = [
        6,
        13,
        16,
        31,
        45,
        76,
        78,
        81,
        83,
        85,
        87,
        268,
        269,
        270,
        271,
        273,
        274,
        276,
        277,
        279,
        280,
        283,
        285,
        308,
        346,
        347,
        348,
        349,
        350,
        351
    ], $Vq2 = [
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $Vr2 = [
        13,
        16,
        29,
        31,
        45,
        82,
        85,
        87,
        89,
        112,
        159,
        160,
        161,
        163,
        164,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312,
        335
    ], $Vs2 = [
        13,
        16,
        87,
        308
    ], $Vt2 = [
        2,
        364
    ], $Vu2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        232,
        318,
        335
    ], $Vv2 = [
        31,
        112,
        193,
        232,
        272,
        318,
        335
    ], $Vw2 = [
        2,
        359
    ], $Vx2 = [
        13,
        16,
        48,
        82,
        174,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        312
    ], $Vy2 = [
        29,
        31,
        85,
        112,
        159,
        160,
        161,
        163,
        164,
        193,
        232,
        272,
        318,
        335
    ], $Vz2 = [
        13,
        16,
        31,
        45,
        82,
        87,
        89,
        112,
        231,
        294,
        295,
        296,
        297,
        298,
        299,
        300,
        301,
        302,
        303,
        304,
        305,
        306,
        308,
        309,
        310,
        312
    ], $VA2 = [
        2,
        347
    ];
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            "error": 2,
            "QueryOrUpdate": 3,
            "Prologue": 4,
            "QueryOrUpdate_group0": 5,
            "EOF": 6,
            "Query": 7,
            "Qry": 8,
            "Query_option0": 9,
            "Prologue_repetition0": 10,
            "BaseDecl": 11,
            "BASE": 12,
            "IRIREF": 13,
            "PrefixDecl": 14,
            "PREFIX": 15,
            "PNAME_NS": 16,
            "SelectClauseWildcard": 17,
            "Qry_repetition0": 18,
            "WhereClause": 19,
            "SolutionModifierNoGroup": 20,
            "SelectClauseVars": 21,
            "Qry_repetition1": 22,
            "SolutionModifier": 23,
            "CONSTRUCT": 24,
            "ConstructTemplate": 25,
            "Qry_repetition2": 26,
            "Qry_repetition3": 27,
            "WHERE": 28,
            "{": 29,
            "Qry_option0": 30,
            "}": 31,
            "DESCRIBE": 32,
            "Qry_group0": 33,
            "Qry_repetition4": 34,
            "Qry_option1": 35,
            "ASK": 36,
            "Qry_repetition5": 37,
            "SelectClauseBase": 38,
            "*": 39,
            "SelectClauseVars_repetition_plus0": 40,
            "SELECT": 41,
            "SelectClauseBase_option0": 42,
            "SelectClauseItem": 43,
            "Var": 44,
            "(": 45,
            "Expression": 46,
            "AS": 47,
            ")": 48,
            "SubSelect": 49,
            "SubSelect_option0": 50,
            "SubSelect_option1": 51,
            "DatasetClause": 52,
            "FROM": 53,
            "DatasetClause_option0": 54,
            "iri": 55,
            "WhereClause_option0": 56,
            "GroupGraphPattern": 57,
            "SolutionModifier_option0": 58,
            "SolutionModifierNoGroup_option0": 59,
            "SolutionModifierNoGroup_option1": 60,
            "SolutionModifierNoGroup_option2": 61,
            "GroupClause": 62,
            "GROUP": 63,
            "BY": 64,
            "GroupClause_repetition_plus0": 65,
            "GroupCondition": 66,
            "BuiltInCall": 67,
            "FunctionCall": 68,
            "HavingClause": 69,
            "HAVING": 70,
            "HavingClause_repetition_plus0": 71,
            "OrderClause": 72,
            "ORDER": 73,
            "OrderClause_repetition_plus0": 74,
            "OrderCondition": 75,
            "ASC": 76,
            "BrackettedExpression": 77,
            "DESC": 78,
            "Constraint": 79,
            "LimitOffsetClauses": 80,
            "LIMIT": 81,
            "INTEGER": 82,
            "OFFSET": 83,
            "ValuesClause": 84,
            "VALUES": 85,
            "InlineData": 86,
            "VAR": 87,
            "InlineData_repetition0": 88,
            "NIL": 89,
            "InlineData_repetition1": 90,
            "InlineData_repetition_plus2": 91,
            "InlineData_repetition3": 92,
            "DataBlock": 93,
            "DataBlockValueList": 94,
            "DataBlockValueList_repetition_plus0": 95,
            "Update": 96,
            "Update_repetition0": 97,
            "Update1": 98,
            "Update_option0": 99,
            "LOAD": 100,
            "Update1_option0": 101,
            "Update1_option1": 102,
            "Update1_group0": 103,
            "Update1_option2": 104,
            "GraphRefAll": 105,
            "Update1_group1": 106,
            "Update1_option3": 107,
            "GraphOrDefault": 108,
            "TO": 109,
            "CREATE": 110,
            "Update1_option4": 111,
            "GRAPH": 112,
            "INSERTDATA": 113,
            "QuadPattern": 114,
            "DELETEDATA": 115,
            "DELETEWHERE": 116,
            "Update1_option5": 117,
            "InsertDeleteClause": 118,
            "Update1_repetition0": 119,
            "IntoGraphClause": 120,
            "INTO": 121,
            "GraphRef": 122,
            "DELETE": 123,
            "InsertDeleteClause_option0": 124,
            "InsertClause": 125,
            "INSERT": 126,
            "UsingClause": 127,
            "USING": 128,
            "UsingClause_option0": 129,
            "WithClause": 130,
            "WITH": 131,
            "DEFAULT": 132,
            "GraphOrDefault_option0": 133,
            "GraphRefAll_group0": 134,
            "Quads": 135,
            "Quads_option0": 136,
            "Quads_repetition0": 137,
            "QuadsNotTriples": 138,
            "VarOrIri": 139,
            "QuadsNotTriples_option0": 140,
            "QuadsNotTriples_option1": 141,
            "QuadsNotTriples_option2": 142,
            "TriplesTemplate": 143,
            "TriplesTemplate_repetition0": 144,
            "TriplesSameSubject": 145,
            "TriplesTemplate_option0": 146,
            "GroupGraphPatternSub": 147,
            "GroupGraphPatternSub_option0": 148,
            "GroupGraphPatternSub_repetition0": 149,
            "GroupGraphPatternSubTail": 150,
            "GraphPatternNotTriples": 151,
            "GroupGraphPatternSubTail_option0": 152,
            "GroupGraphPatternSubTail_option1": 153,
            "TriplesBlock": 154,
            "TriplesBlock_repetition0": 155,
            "TriplesSameSubjectPath": 156,
            "TriplesBlock_option0": 157,
            "GroupOrUnionGraphPattern": 158,
            "OPTIONAL": 159,
            "MINUS": 160,
            "SERVICE": 161,
            "GraphPatternNotTriples_option0": 162,
            "FILTER": 163,
            "BIND": 164,
            "InlineDataOneVar": 165,
            "InlineDataFull": 166,
            "InlineDataOneVar_repetition0": 167,
            "InlineDataFull_repetition0": 168,
            "InlineDataFull_repetition_plus1": 169,
            "InlineDataFull_repetition2": 170,
            "DataBlockValue": 171,
            "Literal": 172,
            "QuotedTriple": 173,
            "UNDEF": 174,
            "GroupOrUnionGraphPattern_repetition0": 175,
            "ArgList": 176,
            "ArgList_option0": 177,
            "ArgList_repetition0": 178,
            "ExpressionList": 179,
            "ExpressionList_repetition0": 180,
            "ConstructTemplate_option0": 181,
            "ConstructTriples": 182,
            "ConstructTriples_repetition0": 183,
            "ConstructTriples_option0": 184,
            "VarOrTermOrQuotedTP": 185,
            "PropertyListNotEmpty": 186,
            "TriplesNode": 187,
            "PropertyList": 188,
            "PropertyList_option0": 189,
            "VerbObjectList": 190,
            "PropertyListNotEmpty_repetition0": 191,
            "SemiOptionalVerbObjectList": 192,
            ";": 193,
            "SemiOptionalVerbObjectList_option0": 194,
            "Verb": 195,
            "ObjectList": 196,
            "a": 197,
            "ObjectList_repetition0": 198,
            "Object": 199,
            "GraphNode": 200,
            "Object_option0": 201,
            "PropertyListPathNotEmpty": 202,
            "TriplesNodePath": 203,
            "TriplesSameSubjectPath_option0": 204,
            "O": 205,
            "PropertyListPathNotEmpty_repetition0": 206,
            "PropertyListPathNotEmptyTail": 207,
            "O_group0": 208,
            "ObjectListPath": 209,
            "ObjectListPath_repetition0": 210,
            "ObjectPath": 211,
            "GraphNodePath": 212,
            "ObjectPath_option0": 213,
            "Path": 214,
            "Path_repetition0": 215,
            "PathSequence": 216,
            "PathSequence_repetition0": 217,
            "PathEltOrInverse": 218,
            "PathElt": 219,
            "PathPrimary": 220,
            "PathElt_option0": 221,
            "PathEltOrInverse_option0": 222,
            "IriOrA": 223,
            "!": 224,
            "PathNegatedPropertySet": 225,
            "PathOneInPropertySet": 226,
            "PathNegatedPropertySet_repetition0": 227,
            "PathNegatedPropertySet_option0": 228,
            "^": 229,
            "TriplesNode_repetition_plus0": 230,
            "[": 231,
            "]": 232,
            "TriplesNodePath_repetition_plus0": 233,
            "VarOrTermOrQuotedTPExpr": 234,
            "VarOrTerm": 235,
            "GraphTerm": 236,
            "BlankNode": 237,
            "ConditionalOrExpression": 238,
            "ConditionalAndExpression": 239,
            "ConditionalOrExpression_repetition0": 240,
            "ConditionalOrExpressionTail": 241,
            "||": 242,
            "RelationalExpression": 243,
            "ConditionalAndExpression_repetition0": 244,
            "ConditionalAndExpressionTail": 245,
            "&&": 246,
            "NumericExpression": 247,
            "RelationalExpression_group0": 248,
            "RelationalExpression_option0": 249,
            "IN": 250,
            "MultiplicativeExpression": 251,
            "NumericExpression_repetition0": 252,
            "AdditiveExpressionTail": 253,
            "AdditiveExpressionTail_group0": 254,
            "NumericLiteralPositive": 255,
            "AdditiveExpressionTail_repetition0": 256,
            "NumericLiteralNegative": 257,
            "AdditiveExpressionTail_repetition1": 258,
            "UnaryExpression": 259,
            "MultiplicativeExpression_repetition0": 260,
            "MultiplicativeExpressionTail": 261,
            "MultiplicativeExpressionTail_group0": 262,
            "+": 263,
            "PrimaryExpression": 264,
            "-": 265,
            "ExprQuotedTP": 266,
            "Aggregate": 267,
            "FUNC_ARITY0": 268,
            "FUNC_ARITY1": 269,
            "FUNC_ARITY1_SPARQL_STAR": 270,
            "FUNC_ARITY2": 271,
            ",": 272,
            "FUNC_ARITY3": 273,
            "FUNC_ARITY3_SPARQL_STAR": 274,
            "BuiltInCall_group0": 275,
            "BOUND": 276,
            "BNODE": 277,
            "BuiltInCall_option0": 278,
            "EXISTS": 279,
            "COUNT": 280,
            "Aggregate_option0": 281,
            "Aggregate_group0": 282,
            "FUNC_AGGREGATE": 283,
            "Aggregate_option1": 284,
            "GROUP_CONCAT": 285,
            "Aggregate_option2": 286,
            "Aggregate_option3": 287,
            "GroupConcatSeparator": 288,
            "SEPARATOR": 289,
            "=": 290,
            "String": 291,
            "LANGTAG": 292,
            "^^": 293,
            "DECIMAL": 294,
            "DOUBLE": 295,
            "BOOLEAN": 296,
            "INTEGER_POSITIVE": 297,
            "DECIMAL_POSITIVE": 298,
            "DOUBLE_POSITIVE": 299,
            "INTEGER_NEGATIVE": 300,
            "DECIMAL_NEGATIVE": 301,
            "DOUBLE_NEGATIVE": 302,
            "STRING_LITERAL1": 303,
            "STRING_LITERAL2": 304,
            "STRING_LITERAL_LONG1": 305,
            "STRING_LITERAL_LONG2": 306,
            "PrefixedName": 307,
            "PNAME_LN": 308,
            "BLANK_NODE_LABEL": 309,
            "ANON": 310,
            "QuotedTP": 311,
            "<<": 312,
            "qtSubjectOrObject": 313,
            ">>": 314,
            "DataValueTerm": 315,
            "AnnotationPattern": 316,
            "{|": 317,
            "|}": 318,
            "AnnotationPatternPath": 319,
            "ExprVarOrTerm": 320,
            "QueryOrUpdate_group0_option0": 321,
            "Prologue_repetition0_group0": 322,
            "Qry_group0_repetition_plus0": 323,
            "SelectClauseBase_option0_group0": 324,
            "DISTINCT": 325,
            "REDUCED": 326,
            "NAMED": 327,
            "SILENT": 328,
            "CLEAR": 329,
            "DROP": 330,
            "ADD": 331,
            "MOVE": 332,
            "COPY": 333,
            "ALL": 334,
            ".": 335,
            "UNION": 336,
            "|": 337,
            "/": 338,
            "PathElt_option0_group0": 339,
            "?": 340,
            "!=": 341,
            "<": 342,
            ">": 343,
            "<=": 344,
            ">=": 345,
            "NOT": 346,
            "CONCAT": 347,
            "COALESCE": 348,
            "SUBSTR": 349,
            "REGEX": 350,
            "REPLACE": 351,
            "$accept": 0,
            "$end": 1
        },
        terminals_: {
            2: "error",
            6: "EOF",
            12: "BASE",
            13: "IRIREF",
            15: "PREFIX",
            16: "PNAME_NS",
            24: "CONSTRUCT",
            28: "WHERE",
            29: "{",
            31: "}",
            32: "DESCRIBE",
            36: "ASK",
            39: "*",
            41: "SELECT",
            45: "(",
            47: "AS",
            48: ")",
            53: "FROM",
            63: "GROUP",
            64: "BY",
            70: "HAVING",
            73: "ORDER",
            76: "ASC",
            78: "DESC",
            81: "LIMIT",
            82: "INTEGER",
            83: "OFFSET",
            85: "VALUES",
            87: "VAR",
            89: "NIL",
            100: "LOAD",
            109: "TO",
            110: "CREATE",
            112: "GRAPH",
            113: "INSERTDATA",
            115: "DELETEDATA",
            116: "DELETEWHERE",
            121: "INTO",
            123: "DELETE",
            126: "INSERT",
            128: "USING",
            131: "WITH",
            132: "DEFAULT",
            159: "OPTIONAL",
            160: "MINUS",
            161: "SERVICE",
            163: "FILTER",
            164: "BIND",
            174: "UNDEF",
            193: ";",
            197: "a",
            224: "!",
            229: "^",
            231: "[",
            232: "]",
            242: "||",
            246: "&&",
            250: "IN",
            263: "+",
            265: "-",
            268: "FUNC_ARITY0",
            269: "FUNC_ARITY1",
            270: "FUNC_ARITY1_SPARQL_STAR",
            271: "FUNC_ARITY2",
            272: ",",
            273: "FUNC_ARITY3",
            274: "FUNC_ARITY3_SPARQL_STAR",
            276: "BOUND",
            277: "BNODE",
            279: "EXISTS",
            280: "COUNT",
            283: "FUNC_AGGREGATE",
            285: "GROUP_CONCAT",
            289: "SEPARATOR",
            290: "=",
            292: "LANGTAG",
            293: "^^",
            294: "DECIMAL",
            295: "DOUBLE",
            296: "BOOLEAN",
            297: "INTEGER_POSITIVE",
            298: "DECIMAL_POSITIVE",
            299: "DOUBLE_POSITIVE",
            300: "INTEGER_NEGATIVE",
            301: "DECIMAL_NEGATIVE",
            302: "DOUBLE_NEGATIVE",
            303: "STRING_LITERAL1",
            304: "STRING_LITERAL2",
            305: "STRING_LITERAL_LONG1",
            306: "STRING_LITERAL_LONG2",
            308: "PNAME_LN",
            309: "BLANK_NODE_LABEL",
            310: "ANON",
            312: "<<",
            314: ">>",
            317: "{|",
            318: "|}",
            325: "DISTINCT",
            326: "REDUCED",
            327: "NAMED",
            328: "SILENT",
            329: "CLEAR",
            330: "DROP",
            331: "ADD",
            332: "MOVE",
            333: "COPY",
            334: "ALL",
            335: ".",
            336: "UNION",
            337: "|",
            338: "/",
            340: "?",
            341: "!=",
            342: "<",
            343: ">",
            344: "<=",
            345: ">=",
            346: "NOT",
            347: "CONCAT",
            348: "COALESCE",
            349: "SUBSTR",
            350: "REGEX",
            351: "REPLACE"
        },
        productions_: [
            0,
            [
                3,
                3
            ],
            [
                7,
                2
            ],
            [
                4,
                1
            ],
            [
                11,
                2
            ],
            [
                14,
                3
            ],
            [
                8,
                4
            ],
            [
                8,
                4
            ],
            [
                8,
                5
            ],
            [
                8,
                7
            ],
            [
                8,
                5
            ],
            [
                8,
                4
            ],
            [
                17,
                2
            ],
            [
                21,
                2
            ],
            [
                38,
                2
            ],
            [
                43,
                1
            ],
            [
                43,
                5
            ],
            [
                49,
                4
            ],
            [
                49,
                4
            ],
            [
                52,
                3
            ],
            [
                19,
                2
            ],
            [
                23,
                2
            ],
            [
                20,
                3
            ],
            [
                62,
                3
            ],
            [
                66,
                1
            ],
            [
                66,
                1
            ],
            [
                66,
                3
            ],
            [
                66,
                5
            ],
            [
                66,
                1
            ],
            [
                69,
                2
            ],
            [
                72,
                3
            ],
            [
                75,
                2
            ],
            [
                75,
                2
            ],
            [
                75,
                1
            ],
            [
                75,
                1
            ],
            [
                80,
                2
            ],
            [
                80,
                2
            ],
            [
                80,
                4
            ],
            [
                80,
                4
            ],
            [
                84,
                2
            ],
            [
                86,
                4
            ],
            [
                86,
                4
            ],
            [
                86,
                6
            ],
            [
                86,
                2
            ],
            [
                94,
                3
            ],
            [
                96,
                3
            ],
            [
                98,
                4
            ],
            [
                98,
                3
            ],
            [
                98,
                5
            ],
            [
                98,
                4
            ],
            [
                98,
                2
            ],
            [
                98,
                2
            ],
            [
                98,
                2
            ],
            [
                98,
                5
            ],
            [
                120,
                2
            ],
            [
                118,
                3
            ],
            [
                118,
                1
            ],
            [
                125,
                2
            ],
            [
                127,
                3
            ],
            [
                130,
                2
            ],
            [
                108,
                1
            ],
            [
                108,
                2
            ],
            [
                122,
                2
            ],
            [
                105,
                1
            ],
            [
                105,
                1
            ],
            [
                114,
                3
            ],
            [
                135,
                2
            ],
            [
                138,
                7
            ],
            [
                143,
                3
            ],
            [
                57,
                3
            ],
            [
                57,
                3
            ],
            [
                147,
                2
            ],
            [
                150,
                3
            ],
            [
                154,
                3
            ],
            [
                151,
                1
            ],
            [
                151,
                2
            ],
            [
                151,
                2
            ],
            [
                151,
                3
            ],
            [
                151,
                4
            ],
            [
                151,
                2
            ],
            [
                151,
                6
            ],
            [
                151,
                1
            ],
            [
                93,
                1
            ],
            [
                93,
                1
            ],
            [
                165,
                4
            ],
            [
                166,
                4
            ],
            [
                166,
                6
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                171,
                1
            ],
            [
                158,
                2
            ],
            [
                79,
                1
            ],
            [
                79,
                1
            ],
            [
                79,
                1
            ],
            [
                68,
                2
            ],
            [
                176,
                1
            ],
            [
                176,
                5
            ],
            [
                179,
                1
            ],
            [
                179,
                4
            ],
            [
                25,
                3
            ],
            [
                182,
                3
            ],
            [
                145,
                2
            ],
            [
                145,
                2
            ],
            [
                188,
                1
            ],
            [
                186,
                2
            ],
            [
                192,
                2
            ],
            [
                190,
                2
            ],
            [
                195,
                1
            ],
            [
                195,
                1
            ],
            [
                196,
                2
            ],
            [
                199,
                2
            ],
            [
                156,
                2
            ],
            [
                156,
                2
            ],
            [
                202,
                2
            ],
            [
                207,
                1
            ],
            [
                207,
                2
            ],
            [
                205,
                2
            ],
            [
                209,
                2
            ],
            [
                211,
                2
            ],
            [
                214,
                2
            ],
            [
                216,
                2
            ],
            [
                219,
                2
            ],
            [
                218,
                2
            ],
            [
                220,
                1
            ],
            [
                220,
                2
            ],
            [
                220,
                3
            ],
            [
                225,
                1
            ],
            [
                225,
                1
            ],
            [
                225,
                4
            ],
            [
                226,
                1
            ],
            [
                226,
                2
            ],
            [
                187,
                3
            ],
            [
                187,
                3
            ],
            [
                203,
                3
            ],
            [
                203,
                3
            ],
            [
                200,
                1
            ],
            [
                200,
                1
            ],
            [
                212,
                1
            ],
            [
                212,
                1
            ],
            [
                234,
                1
            ],
            [
                235,
                1
            ],
            [
                235,
                1
            ],
            [
                139,
                1
            ],
            [
                139,
                1
            ],
            [
                44,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                236,
                1
            ],
            [
                46,
                1
            ],
            [
                238,
                2
            ],
            [
                241,
                2
            ],
            [
                239,
                2
            ],
            [
                245,
                2
            ],
            [
                243,
                1
            ],
            [
                243,
                3
            ],
            [
                243,
                4
            ],
            [
                247,
                2
            ],
            [
                253,
                2
            ],
            [
                253,
                2
            ],
            [
                253,
                2
            ],
            [
                251,
                2
            ],
            [
                261,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                2
            ],
            [
                259,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                264,
                1
            ],
            [
                77,
                3
            ],
            [
                67,
                1
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                4
            ],
            [
                67,
                6
            ],
            [
                67,
                8
            ],
            [
                67,
                8
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                2
            ],
            [
                67,
                4
            ],
            [
                67,
                3
            ],
            [
                267,
                5
            ],
            [
                267,
                5
            ],
            [
                267,
                6
            ],
            [
                288,
                4
            ],
            [
                172,
                1
            ],
            [
                172,
                2
            ],
            [
                172,
                3
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                172,
                1
            ],
            [
                255,
                1
            ],
            [
                255,
                1
            ],
            [
                255,
                1
            ],
            [
                257,
                1
            ],
            [
                257,
                1
            ],
            [
                257,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                291,
                1
            ],
            [
                55,
                1
            ],
            [
                55,
                1
            ],
            [
                307,
                1
            ],
            [
                307,
                1
            ],
            [
                237,
                1
            ],
            [
                237,
                1
            ],
            [
                311,
                5
            ],
            [
                173,
                5
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                313,
                1
            ],
            [
                315,
                1
            ],
            [
                315,
                1
            ],
            [
                315,
                1
            ],
            [
                185,
                1
            ],
            [
                185,
                1
            ],
            [
                185,
                1
            ],
            [
                316,
                3
            ],
            [
                319,
                3
            ],
            [
                266,
                5
            ],
            [
                320,
                1
            ],
            [
                320,
                1
            ],
            [
                320,
                1
            ],
            [
                223,
                1
            ],
            [
                223,
                1
            ],
            [
                321,
                0
            ],
            [
                321,
                1
            ],
            [
                5,
                1
            ],
            [
                5,
                1
            ],
            [
                5,
                1
            ],
            [
                9,
                0
            ],
            [
                9,
                1
            ],
            [
                322,
                1
            ],
            [
                322,
                1
            ],
            [
                10,
                0
            ],
            [
                10,
                2
            ],
            [
                18,
                0
            ],
            [
                18,
                2
            ],
            [
                22,
                0
            ],
            [
                22,
                2
            ],
            [
                26,
                0
            ],
            [
                26,
                2
            ],
            [
                27,
                0
            ],
            [
                27,
                2
            ],
            [
                30,
                0
            ],
            [
                30,
                1
            ],
            [
                323,
                1
            ],
            [
                323,
                2
            ],
            [
                33,
                1
            ],
            [
                33,
                1
            ],
            [
                34,
                0
            ],
            [
                34,
                2
            ],
            [
                35,
                0
            ],
            [
                35,
                1
            ],
            [
                37,
                0
            ],
            [
                37,
                2
            ],
            [
                40,
                1
            ],
            [
                40,
                2
            ],
            [
                324,
                1
            ],
            [
                324,
                1
            ],
            [
                42,
                0
            ],
            [
                42,
                1
            ],
            [
                50,
                0
            ],
            [
                50,
                1
            ],
            [
                51,
                0
            ],
            [
                51,
                1
            ],
            [
                54,
                0
            ],
            [
                54,
                1
            ],
            [
                56,
                0
            ],
            [
                56,
                1
            ],
            [
                58,
                0
            ],
            [
                58,
                1
            ],
            [
                59,
                0
            ],
            [
                59,
                1
            ],
            [
                60,
                0
            ],
            [
                60,
                1
            ],
            [
                61,
                0
            ],
            [
                61,
                1
            ],
            [
                65,
                1
            ],
            [
                65,
                2
            ],
            [
                71,
                1
            ],
            [
                71,
                2
            ],
            [
                74,
                1
            ],
            [
                74,
                2
            ],
            [
                88,
                0
            ],
            [
                88,
                2
            ],
            [
                90,
                0
            ],
            [
                90,
                2
            ],
            [
                91,
                1
            ],
            [
                91,
                2
            ],
            [
                92,
                0
            ],
            [
                92,
                2
            ],
            [
                95,
                1
            ],
            [
                95,
                2
            ],
            [
                97,
                0
            ],
            [
                97,
                4
            ],
            [
                99,
                0
            ],
            [
                99,
                2
            ],
            [
                101,
                0
            ],
            [
                101,
                1
            ],
            [
                102,
                0
            ],
            [
                102,
                1
            ],
            [
                103,
                1
            ],
            [
                103,
                1
            ],
            [
                104,
                0
            ],
            [
                104,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                1
            ],
            [
                106,
                1
            ],
            [
                107,
                0
            ],
            [
                107,
                1
            ],
            [
                111,
                0
            ],
            [
                111,
                1
            ],
            [
                117,
                0
            ],
            [
                117,
                1
            ],
            [
                119,
                0
            ],
            [
                119,
                2
            ],
            [
                124,
                0
            ],
            [
                124,
                1
            ],
            [
                129,
                0
            ],
            [
                129,
                1
            ],
            [
                133,
                0
            ],
            [
                133,
                1
            ],
            [
                134,
                1
            ],
            [
                134,
                1
            ],
            [
                134,
                1
            ],
            [
                136,
                0
            ],
            [
                136,
                1
            ],
            [
                137,
                0
            ],
            [
                137,
                2
            ],
            [
                140,
                0
            ],
            [
                140,
                1
            ],
            [
                141,
                0
            ],
            [
                141,
                1
            ],
            [
                142,
                0
            ],
            [
                142,
                1
            ],
            [
                144,
                0
            ],
            [
                144,
                3
            ],
            [
                146,
                0
            ],
            [
                146,
                1
            ],
            [
                148,
                0
            ],
            [
                148,
                1
            ],
            [
                149,
                0
            ],
            [
                149,
                2
            ],
            [
                152,
                0
            ],
            [
                152,
                1
            ],
            [
                153,
                0
            ],
            [
                153,
                1
            ],
            [
                155,
                0
            ],
            [
                155,
                3
            ],
            [
                157,
                0
            ],
            [
                157,
                1
            ],
            [
                162,
                0
            ],
            [
                162,
                1
            ],
            [
                167,
                0
            ],
            [
                167,
                2
            ],
            [
                168,
                0
            ],
            [
                168,
                2
            ],
            [
                169,
                1
            ],
            [
                169,
                2
            ],
            [
                170,
                0
            ],
            [
                170,
                2
            ],
            [
                175,
                0
            ],
            [
                175,
                3
            ],
            [
                177,
                0
            ],
            [
                177,
                1
            ],
            [
                178,
                0
            ],
            [
                178,
                3
            ],
            [
                180,
                0
            ],
            [
                180,
                3
            ],
            [
                181,
                0
            ],
            [
                181,
                1
            ],
            [
                183,
                0
            ],
            [
                183,
                3
            ],
            [
                184,
                0
            ],
            [
                184,
                1
            ],
            [
                189,
                0
            ],
            [
                189,
                1
            ],
            [
                191,
                0
            ],
            [
                191,
                2
            ],
            [
                194,
                0
            ],
            [
                194,
                1
            ],
            [
                198,
                0
            ],
            [
                198,
                3
            ],
            [
                201,
                0
            ],
            [
                201,
                1
            ],
            [
                204,
                0
            ],
            [
                204,
                1
            ],
            [
                206,
                0
            ],
            [
                206,
                2
            ],
            [
                208,
                1
            ],
            [
                208,
                1
            ],
            [
                210,
                0
            ],
            [
                210,
                3
            ],
            [
                213,
                0
            ],
            [
                213,
                1
            ],
            [
                215,
                0
            ],
            [
                215,
                3
            ],
            [
                217,
                0
            ],
            [
                217,
                3
            ],
            [
                339,
                1
            ],
            [
                339,
                1
            ],
            [
                339,
                1
            ],
            [
                221,
                0
            ],
            [
                221,
                1
            ],
            [
                222,
                0
            ],
            [
                222,
                1
            ],
            [
                227,
                0
            ],
            [
                227,
                3
            ],
            [
                228,
                0
            ],
            [
                228,
                1
            ],
            [
                230,
                1
            ],
            [
                230,
                2
            ],
            [
                233,
                1
            ],
            [
                233,
                2
            ],
            [
                240,
                0
            ],
            [
                240,
                2
            ],
            [
                244,
                0
            ],
            [
                244,
                2
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                248,
                1
            ],
            [
                249,
                0
            ],
            [
                249,
                1
            ],
            [
                252,
                0
            ],
            [
                252,
                2
            ],
            [
                254,
                1
            ],
            [
                254,
                1
            ],
            [
                256,
                0
            ],
            [
                256,
                2
            ],
            [
                258,
                0
            ],
            [
                258,
                2
            ],
            [
                260,
                0
            ],
            [
                260,
                2
            ],
            [
                262,
                1
            ],
            [
                262,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                275,
                1
            ],
            [
                278,
                0
            ],
            [
                278,
                1
            ],
            [
                281,
                0
            ],
            [
                281,
                1
            ],
            [
                282,
                1
            ],
            [
                282,
                1
            ],
            [
                284,
                0
            ],
            [
                284,
                1
            ],
            [
                286,
                0
            ],
            [
                286,
                1
            ],
            [
                287,
                0
            ],
            [
                287,
                1
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */ , $$ /* vstack */ , _$ /* lstack */ ) {
            /* this == yyval */ var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    // Set parser options
                    $$[$0 - 1] = $$[$0 - 1] || {};
                    if (Parser.base) $$[$0 - 1].base = Parser.base;
                    Parser.base = "";
                    $$[$0 - 1].prefixes = Parser.prefixes;
                    Parser.prefixes = null;
                    if (Parser.pathOnly) {
                        if ($$[$0 - 1].type === "path" || "termType" in $$[$0 - 1]) return $$[$0 - 1];
                        throw new Error("Received full SPARQL query in path only mode");
                    } else if ($$[$0 - 1].type === "path" || "termType" in $$[$0 - 1]) throw new Error("Received only path in full SPARQL mode");
                    // Ensure that blank nodes are not used across INSERT DATA clauses
                    if ($$[$0 - 1].type === "update") {
                        const insertBnodesAll = {};
                        for (const update of $$[$0 - 1].updates)if (update.updateType === "insert") {
                            // Collect bnodes for current insert clause
                            const insertBnodes = {};
                            for (const operation of update.insert){
                                if (operation.type === "bgp" || operation.type === "graph") for (const triple of operation.triples){
                                    if (triple.subject.termType === "BlankNode") insertBnodes[triple.subject.value] = true;
                                    if (triple.predicate.termType === "BlankNode") insertBnodes[triple.predicate.value] = true;
                                    if (triple.object.termType === "BlankNode") insertBnodes[triple.object.value] = true;
                                }
                            }
                            // Check if the inserting bnodes don't clash with bnodes from a previous insert clause
                            for (const bnode of Object.keys(insertBnodes)){
                                if (insertBnodesAll[bnode]) throw new Error("Detected reuse blank node across different INSERT DATA clauses");
                                insertBnodesAll[bnode] = true;
                            }
                        }
                    }
                    return $$[$0 - 1];
                case 2:
                    this.$ = {
                        ...$$[$0 - 1],
                        ...$$[$0],
                        type: "query"
                    };
                    break;
                case 4:
                    Parser.base = resolveIRI($$[$0]);
                    break;
                case 5:
                    if (!Parser.prefixes) Parser.prefixes = {};
                    $$[$0 - 1] = $$[$0 - 1].substr(0, $$[$0 - 1].length - 1);
                    $$[$0] = resolveIRI($$[$0]);
                    Parser.prefixes[$$[$0 - 1]] = $$[$0];
                    break;
                case 6:
                    this.$ = {
                        ...$$[$0 - 3],
                        ...groupDatasets($$[$0 - 2]),
                        ...$$[$0 - 1],
                        ...$$[$0]
                    };
                    break;
                case 7:
                    // Check for projection of ungrouped variable
                    if (!Parser.skipValidation) {
                        const counts = flatten($$[$0 - 3].variables.map((vars)=>getAggregatesOfExpression(vars.expression))).some((agg)=>agg.aggregation === "count" && !(agg.expression instanceof Wildcard));
                        if (counts || $$[$0].group) for (const selectVar of $$[$0 - 3].variables){
                            if (selectVar.termType === "Variable") {
                                if (!$$[$0].group || !$$[$0].group.map((groupVar)=>getExpressionId(groupVar)).includes(getExpressionId(selectVar))) throw Error("Projection of ungrouped variable (?" + getExpressionId(selectVar) + ")");
                            } else if (getAggregatesOfExpression(selectVar.expression).length === 0) {
                                const usedVars = getVariablesFromExpression(selectVar.expression);
                                for (const usedVar of usedVars){
                                    if (!$$[$0].group || !$$[$0].group.map || !$$[$0].group.map((groupVar)=>getExpressionId(groupVar)).includes(getExpressionId(usedVar))) throw Error("Use of ungrouped variable in projection of operation (?" + getExpressionId(usedVar) + ")");
                                }
                            }
                        }
                    }
                    // Check if id of each AS-selected column is not yet bound by subquery
                    const subqueries = $$[$0 - 1].where.filter((w)=>w.type === "query");
                    if (subqueries.length > 0) {
                        const selectedVarIds = $$[$0 - 3].variables.filter((v)=>v.variable && v.variable.value).map((v)=>v.variable.value);
                        const subqueryIds = flatten(subqueries.map((sub)=>sub.variables)).map((v)=>v.value || v.variable.value);
                        for (const selectedVarId of selectedVarIds){
                            if (subqueryIds.indexOf(selectedVarId) >= 0) throw Error("Target id of 'AS' (?" + selectedVarId + ") already used in subquery");
                        }
                    }
                    this.$ = extend($$[$0 - 3], groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 8:
                    this.$ = extend({
                        queryType: "CONSTRUCT",
                        template: $$[$0 - 3]
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 9:
                    this.$ = extend({
                        queryType: "CONSTRUCT",
                        template: $$[$0 - 2] = $$[$0 - 2] ? $$[$0 - 2].triples : []
                    }, groupDatasets($$[$0 - 5]), {
                        where: [
                            {
                                type: "bgp",
                                triples: appendAllTo([], $$[$0 - 2])
                            }
                        ]
                    }, $$[$0]);
                    break;
                case 10:
                    this.$ = extend({
                        queryType: "DESCRIBE",
                        variables: $$[$0 - 3] === "*" ? [
                            new Wildcard()
                        ] : $$[$0 - 3]
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 11:
                    this.$ = extend({
                        queryType: "ASK"
                    }, groupDatasets($$[$0 - 2]), $$[$0 - 1], $$[$0]);
                    break;
                case 12:
                    this.$ = extend($$[$0 - 1], {
                        variables: [
                            new Wildcard()
                        ]
                    });
                    break;
                case 13:
                    // Check if id of each selected column is different
                    const selectedVarIds = $$[$0].map((v)=>v.value || v.variable.value);
                    const duplicates = getDuplicatesInArray(selectedVarIds);
                    if (duplicates.length > 0) throw Error("Two or more of the resulting columns have the same name (?" + duplicates[0] + ")");
                    this.$ = extend($$[$0 - 1], {
                        variables: $$[$0]
                    });
                    break;
                case 14:
                    this.$ = extend({
                        queryType: "SELECT"
                    }, $$[$0] && ($$[$0 - 1] = lowercase($$[$0]), $$[$0] = {}, $$[$0][$$[$0 - 1]] = true, $$[$0]));
                    break;
                case 16:
                case 27:
                    this.$ = expression($$[$0 - 3], {
                        variable: $$[$0 - 1]
                    });
                    break;
                case 17:
                case 18:
                    this.$ = extend($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], {
                        type: "query"
                    });
                    break;
                case 19:
                case 58:
                    this.$ = {
                        iri: $$[$0],
                        named: !!$$[$0 - 1]
                    };
                    break;
                case 20:
                    this.$ = {
                        where: $$[$0].patterns
                    };
                    break;
                case 21:
                    this.$ = extend($$[$0 - 1], $$[$0]);
                    break;
                case 22:
                    this.$ = extend($$[$0 - 2], $$[$0 - 1], $$[$0]);
                    break;
                case 23:
                    this.$ = {
                        group: $$[$0]
                    };
                    break;
                case 24:
                case 25:
                case 28:
                case 31:
                case 33:
                case 34:
                    this.$ = expression($$[$0]);
                    break;
                case 26:
                    this.$ = expression($$[$0 - 1]);
                    break;
                case 29:
                    this.$ = {
                        having: $$[$0]
                    };
                    break;
                case 30:
                    this.$ = {
                        order: $$[$0]
                    };
                    break;
                case 32:
                    this.$ = expression($$[$0], {
                        descending: true
                    });
                    break;
                case 35:
                    this.$ = {
                        limit: toInt($$[$0])
                    };
                    break;
                case 36:
                    this.$ = {
                        offset: toInt($$[$0])
                    };
                    break;
                case 37:
                    this.$ = {
                        limit: toInt($$[$0 - 2]),
                        offset: toInt($$[$0])
                    };
                    break;
                case 38:
                    this.$ = {
                        limit: toInt($$[$0]),
                        offset: toInt($$[$0 - 2])
                    };
                    break;
                case 39:
                case 43:
                    this.$ = {
                        type: "values",
                        values: $$[$0]
                    };
                    break;
                case 40:
                case 84:
                    this.$ = $$[$0 - 1].map((v)=>({
                            [$$[$0 - 3]]: v
                        }));
                    break;
                case 41:
                case 85:
                    this.$ = $$[$0 - 1].map(()=>({}));
                    break;
                case 42:
                case 86:
                    var length = $$[$0 - 4].length;
                    $$[$0 - 4] = $$[$0 - 4].map(toVar);
                    this.$ = $$[$0 - 1].map(function(values) {
                        if (values.length !== length) throw Error("Inconsistent VALUES length");
                        var valuesObject = {};
                        for(var i = 0; i < length; i++)valuesObject["?" + $$[$0 - 4][i].value] = values[i];
                        return valuesObject;
                    });
                    break;
                case 44:
                case 65:
                case 100:
                case 126:
                case 175:
                    this.$ = $$[$0 - 1];
                    break;
                case 45:
                    this.$ = {
                        type: "update",
                        updates: appendTo($$[$0 - 2], $$[$0 - 1])
                    };
                    break;
                case 46:
                    this.$ = extend({
                        type: "load",
                        silent: !!$$[$0 - 2],
                        source: $$[$0 - 1]
                    }, $$[$0] && {
                        destination: $$[$0]
                    });
                    break;
                case 47:
                    this.$ = {
                        type: lowercase($$[$0 - 2]),
                        silent: !!$$[$0 - 1],
                        graph: $$[$0]
                    };
                    break;
                case 48:
                    this.$ = {
                        type: lowercase($$[$0 - 4]),
                        silent: !!$$[$0 - 3],
                        source: $$[$0 - 2],
                        destination: $$[$0]
                    };
                    break;
                case 49:
                    this.$ = {
                        type: "create",
                        silent: !!$$[$0 - 2],
                        graph: {
                            type: "graph",
                            name: $$[$0]
                        }
                    };
                    break;
                case 50:
                    this.$ = {
                        updateType: "insert",
                        insert: ensureNoVariables($$[$0])
                    };
                    break;
                case 51:
                    this.$ = {
                        updateType: "delete",
                        delete: ensureNoBnodes(ensureNoVariables($$[$0]))
                    };
                    break;
                case 52:
                    this.$ = {
                        updateType: "deletewhere",
                        delete: ensureNoBnodes($$[$0])
                    };
                    break;
                case 53:
                    this.$ = {
                        updateType: "insertdelete",
                        ...$$[$0 - 4],
                        ...$$[$0 - 3],
                        ...groupDatasets($$[$0 - 2], "using"),
                        where: $$[$0].patterns
                    };
                    break;
                case 54:
                case 57:
                case 62:
                case 167:
                case 191:
                case 236:
                    this.$ = $$[$0];
                    break;
                case 55:
                    this.$ = {
                        delete: ensureNoBnodes($$[$0 - 1]),
                        insert: $$[$0] || []
                    };
                    break;
                case 56:
                    this.$ = {
                        delete: [],
                        insert: $$[$0]
                    };
                    break;
                case 59:
                    this.$ = {
                        graph: $$[$0]
                    };
                    break;
                case 60:
                    this.$ = {
                        type: "graph",
                        default: true
                    };
                    break;
                case 61:
                case 63:
                    this.$ = {
                        type: "graph",
                        name: $$[$0]
                    };
                    break;
                case 64:
                    this.$ = {
                        [lowercase($$[$0])]: true
                    };
                    break;
                case 66:
                    this.$ = $$[$0 - 1] ? unionAll($$[$0], [
                        $$[$0 - 1]
                    ]) : unionAll($$[$0]);
                    break;
                case 67:
                    var graph = extend($$[$0 - 3] || {
                        triples: []
                    }, {
                        type: "graph",
                        name: $$[$0 - 5]
                    });
                    this.$ = $$[$0] ? [
                        graph,
                        $$[$0]
                    ] : [
                        graph
                    ];
                    break;
                case 68:
                case 73:
                    this.$ = {
                        type: "bgp",
                        triples: unionAll($$[$0 - 2], [
                            $$[$0 - 1]
                        ])
                    };
                    break;
                case 69:
                    this.$ = {
                        type: "group",
                        patterns: [
                            $$[$0 - 1]
                        ]
                    };
                    break;
                case 70:
                    // For every binding
                    for (const binding of $$[$0 - 1].filter((el)=>el.type === "bind")){
                        const index = $$[$0 - 1].indexOf(binding);
                        const boundVars = new Set();
                        //Collect all bounded variables before the binding
                        for (const el of $$[$0 - 1].slice(0, index))if (el.type === "group" || el.type === "bgp") getBoundVarsFromGroupGraphPattern(el).forEach((boundVar)=>boundVars.add(boundVar));
                        // If binding with a non-free variable, throw error
                        if (boundVars.has(binding.variable.value)) throw Error("Variable used to bind is already bound (?" + binding.variable.value + ")");
                    }
                    this.$ = {
                        type: "group",
                        patterns: $$[$0 - 1]
                    };
                    break;
                case 71:
                    this.$ = $$[$0 - 1] ? unionAll([
                        $$[$0 - 1]
                    ], $$[$0]) : unionAll($$[$0]);
                    break;
                case 72:
                    this.$ = $$[$0] ? [
                        $$[$0 - 2],
                        $$[$0]
                    ] : $$[$0 - 2];
                    break;
                case 75:
                    this.$ = extend($$[$0], {
                        type: "optional"
                    });
                    break;
                case 76:
                    this.$ = extend($$[$0], {
                        type: "minus"
                    });
                    break;
                case 77:
                    this.$ = extend($$[$0], {
                        type: "graph",
                        name: $$[$0 - 1]
                    });
                    break;
                case 78:
                    this.$ = extend($$[$0], {
                        type: "service",
                        name: $$[$0 - 1],
                        silent: !!$$[$0 - 2]
                    });
                    break;
                case 79:
                    this.$ = {
                        type: "filter",
                        expression: $$[$0]
                    };
                    break;
                case 80:
                    this.$ = {
                        type: "bind",
                        variable: $$[$0 - 1],
                        expression: $$[$0 - 3]
                    };
                    break;
                case 89:
                    this.$ = ensureSparqlStar($$[$0]);
                    break;
                case 90:
                    this.$ = undefined;
                    break;
                case 91:
                    this.$ = $$[$0 - 1].length ? {
                        type: "union",
                        patterns: unionAll($$[$0 - 1].map(degroupSingle), [
                            degroupSingle($$[$0])
                        ])
                    } : $$[$0];
                    break;
                case 95:
                    this.$ = {
                        ...$$[$0],
                        function: $$[$0 - 1]
                    };
                    break;
                case 96:
                    this.$ = {
                        type: "functionCall",
                        args: []
                    };
                    break;
                case 97:
                    this.$ = {
                        type: "functionCall",
                        args: appendTo($$[$0 - 2], $$[$0 - 1]),
                        distinct: !!$$[$0 - 3]
                    };
                    break;
                case 98:
                case 115:
                case 128:
                case 247:
                case 249:
                case 251:
                case 253:
                case 255:
                case 263:
                case 267:
                case 297:
                case 299:
                case 303:
                case 307:
                case 328:
                case 341:
                case 349:
                case 355:
                case 361:
                case 367:
                case 369:
                case 373:
                case 375:
                case 379:
                case 381:
                case 385:
                case 391:
                case 395:
                case 401:
                case 405:
                case 409:
                case 411:
                case 420:
                case 428:
                case 430:
                case 440:
                case 444:
                case 446:
                case 448:
                    this.$ = [];
                    break;
                case 99:
                    this.$ = appendTo($$[$0 - 2], $$[$0 - 1]);
                    break;
                case 101:
                    this.$ = unionAll($$[$0 - 2], [
                        $$[$0 - 1]
                    ]);
                    break;
                case 102:
                case 112:
                    this.$ = applyAnnotations($$[$0].map((t)=>extend(triple($$[$0 - 1]), t)));
                    break;
                case 103:
                    this.$ = applyAnnotations(appendAllTo($$[$0].map((t)=>extend(triple($$[$0 - 1].entity), t)), $$[$0 - 1].triples)) /* the subject is a blank node, possibly with more triples */ ;
                    break;
                case 105:
                    this.$ = unionAll([
                        $$[$0 - 1]
                    ], $$[$0]);
                    break;
                case 106:
                    this.$ = unionAll($$[$0]);
                    break;
                case 107:
                    this.$ = objectListToTriples($$[$0 - 1], $$[$0]);
                    break;
                case 109:
                case 237:
                    this.$ = Parser.factory.namedNode(RDF_TYPE);
                    break;
                case 110:
                case 118:
                    this.$ = appendTo($$[$0 - 1], $$[$0]);
                    break;
                case 111:
                    this.$ = $$[$0] ? {
                        annotation: $$[$0],
                        object: $$[$0 - 1]
                    } : $$[$0 - 1];
                    break;
                case 113:
                    this.$ = !$$[$0] ? $$[$0 - 1].triples : applyAnnotations(appendAllTo($$[$0].map((t)=>extend(triple($$[$0 - 1].entity), t)), $$[$0 - 1].triples)) /* the subject is a blank node, possibly with more triples */ ;
                    break;
                case 114:
                    this.$ = objectListToTriples(...$$[$0 - 1], $$[$0]);
                    break;
                case 116:
                    this.$ = objectListToTriples(...$$[$0]);
                    break;
                case 117:
                case 159:
                case 163:
                    this.$ = [
                        $$[$0 - 1],
                        $$[$0]
                    ];
                    break;
                case 119:
                    this.$ = $$[$0] ? {
                        object: $$[$0 - 1],
                        annotation: $$[$0]
                    } : $$[$0 - 1];
                    break;
                case 120:
                    this.$ = $$[$0 - 1].length ? path("|", appendTo($$[$0 - 1], $$[$0])) : $$[$0];
                    break;
                case 121:
                    this.$ = $$[$0 - 1].length ? path("/", appendTo($$[$0 - 1], $$[$0])) : $$[$0];
                    break;
                case 122:
                    this.$ = $$[$0] ? path($$[$0], [
                        $$[$0 - 1]
                    ]) : $$[$0 - 1];
                    break;
                case 123:
                    this.$ = $$[$0 - 1] ? path($$[$0 - 1], [
                        $$[$0]
                    ]) : $$[$0];
                    break;
                case 125:
                case 131:
                    this.$ = path($$[$0 - 1], [
                        $$[$0]
                    ]);
                    break;
                case 129:
                    this.$ = path("|", appendTo($$[$0 - 2], $$[$0 - 1]));
                    break;
                case 132:
                case 134:
                    this.$ = createList($$[$0 - 1]);
                    break;
                case 133:
                case 135:
                    this.$ = createAnonymousObject($$[$0 - 1]);
                    break;
                case 140:
                    this.$ = {
                        entity: $$[$0],
                        triples: []
                    };
                    break;
                case 145:
                    this.$ = toVar($$[$0]);
                    break;
                case 149:
                    this.$ = Parser.factory.namedNode(RDF_NIL);
                    break;
                case 151:
                case 153:
                case 158:
                case 162:
                    this.$ = createOperationTree($$[$0 - 1], $$[$0]);
                    break;
                case 152:
                    this.$ = [
                        "||",
                        $$[$0]
                    ];
                    break;
                case 154:
                    this.$ = [
                        "&&",
                        $$[$0]
                    ];
                    break;
                case 156:
                    this.$ = operation($$[$0 - 1], [
                        $$[$0 - 2],
                        $$[$0]
                    ]);
                    break;
                case 157:
                    this.$ = operation($$[$0 - 2] ? "notin" : "in", [
                        $$[$0 - 3],
                        $$[$0]
                    ]);
                    break;
                case 160:
                    this.$ = [
                        "+",
                        createOperationTree($$[$0 - 1], $$[$0])
                    ];
                    break;
                case 161:
                    var negatedLiteral = createTypedLiteral($$[$0 - 1].value.replace("-", ""), $$[$0 - 1].datatype);
                    this.$ = [
                        "-",
                        createOperationTree(negatedLiteral, $$[$0])
                    ];
                    break;
                case 164:
                    this.$ = operation("UPLUS", [
                        $$[$0]
                    ]);
                    break;
                case 165:
                    this.$ = operation($$[$0 - 1], [
                        $$[$0]
                    ]);
                    break;
                case 166:
                    this.$ = operation("UMINUS", [
                        $$[$0]
                    ]);
                    break;
                case 177:
                    this.$ = operation(lowercase($$[$0 - 1]));
                    break;
                case 178:
                    this.$ = operation(lowercase($$[$0 - 3]), [
                        $$[$0 - 1]
                    ]);
                    break;
                case 179:
                    this.$ = ensureSparqlStar(operation(lowercase($$[$0 - 3]), [
                        $$[$0 - 1]
                    ]));
                    break;
                case 180:
                    this.$ = operation(lowercase($$[$0 - 5]), [
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]);
                    break;
                case 181:
                    this.$ = operation(lowercase($$[$0 - 7]), [
                        $$[$0 - 5],
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]);
                    break;
                case 182:
                    this.$ = ensureSparqlStar(operation(lowercase($$[$0 - 7]), [
                        $$[$0 - 5],
                        $$[$0 - 3],
                        $$[$0 - 1]
                    ]));
                    break;
                case 183:
                    this.$ = operation(lowercase($$[$0 - 1]), $$[$0]);
                    break;
                case 184:
                    this.$ = operation("bound", [
                        toVar($$[$0 - 1])
                    ]);
                    break;
                case 185:
                    this.$ = operation($$[$0 - 1], []);
                    break;
                case 186:
                    this.$ = operation($$[$0 - 3], [
                        $$[$0 - 1]
                    ]);
                    break;
                case 187:
                    this.$ = operation($$[$0 - 2] ? "notexists" : "exists", [
                        degroupSingle($$[$0])
                    ]);
                    break;
                case 188:
                case 189:
                    this.$ = expression($$[$0 - 1], {
                        type: "aggregate",
                        aggregation: lowercase($$[$0 - 4]),
                        distinct: !!$$[$0 - 2]
                    });
                    break;
                case 190:
                    this.$ = expression($$[$0 - 2], {
                        type: "aggregate",
                        aggregation: lowercase($$[$0 - 5]),
                        distinct: !!$$[$0 - 3],
                        separator: typeof $$[$0 - 1] === "string" ? $$[$0 - 1] : " "
                    });
                    break;
                case 192:
                    this.$ = createTypedLiteral($$[$0]);
                    break;
                case 193:
                    this.$ = createLangLiteral($$[$0 - 1], lowercase($$[$0].substr(1)));
                    break;
                case 194:
                    this.$ = createTypedLiteral($$[$0 - 2], $$[$0]);
                    break;
                case 195:
                case 204:
                    this.$ = createTypedLiteral($$[$0], XSD_INTEGER);
                    break;
                case 196:
                case 205:
                    this.$ = createTypedLiteral($$[$0], XSD_DECIMAL);
                    break;
                case 197:
                case 206:
                    this.$ = createTypedLiteral(lowercase($$[$0]), XSD_DOUBLE);
                    break;
                case 200:
                    this.$ = createTypedLiteral($$[$0].toLowerCase(), XSD_BOOLEAN);
                    break;
                case 201:
                    this.$ = createTypedLiteral($$[$0].substr(1), XSD_INTEGER);
                    break;
                case 202:
                    this.$ = createTypedLiteral($$[$0].substr(1), XSD_DECIMAL);
                    break;
                case 203:
                    this.$ = createTypedLiteral($$[$0].substr(1).toLowerCase(), XSD_DOUBLE);
                    break;
                case 207:
                case 208:
                    this.$ = unescapeString($$[$0], 1);
                    break;
                case 209:
                case 210:
                    this.$ = unescapeString($$[$0], 3);
                    break;
                case 211:
                    this.$ = Parser.factory.namedNode(resolveIRI($$[$0]));
                    break;
                case 213:
                    var namePos = $$[$0].indexOf(":"), prefix = $$[$0].substr(0, namePos), expansion = Parser.prefixes[prefix];
                    if (!expansion) throw new Error("Unknown prefix: " + prefix);
                    var uriString = resolveIRI(expansion + $$[$0].substr(namePos + 1));
                    this.$ = Parser.factory.namedNode(uriString);
                    break;
                case 214:
                    $$[$0] = $$[$0].substr(0, $$[$0].length - 1);
                    if (!($$[$0] in Parser.prefixes)) throw new Error("Unknown prefix: " + $$[$0]);
                    var uriString = resolveIRI(Parser.prefixes[$$[$0]]);
                    this.$ = Parser.factory.namedNode(uriString);
                    break;
                case 215:
                    this.$ = blank($$[$0].replace(/^(_:)/, ""));
                    break;
                case 216:
                    this.$ = blank();
                    break;
                case 217:
                case 218:
                case 232:
                    this.$ = ensureSparqlStar(nestedTriple($$[$0 - 3], $$[$0 - 2], $$[$0 - 1]));
                    break;
                case 230:
                case 231:
                    this.$ = ensureSparqlStar($$[$0 - 1]);
                    break;
                case 248:
                case 250:
                case 252:
                case 254:
                case 256:
                case 260:
                case 264:
                case 268:
                case 270:
                case 292:
                case 294:
                case 296:
                case 298:
                case 300:
                case 302:
                case 304:
                case 306:
                case 329:
                case 342:
                case 356:
                case 368:
                case 370:
                case 372:
                case 374:
                case 392:
                case 402:
                case 425:
                case 427:
                case 429:
                case 431:
                case 441:
                case 445:
                case 447:
                case 449:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 259:
                case 269:
                case 291:
                case 293:
                case 295:
                case 301:
                case 305:
                case 371:
                case 424:
                case 426:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 308:
                    $$[$0 - 3].push($$[$0 - 2]);
                    break;
                case 350:
                case 362:
                case 376:
                case 380:
                case 382:
                case 386:
                case 396:
                case 406:
                case 410:
                case 412:
                case 421:
                    $$[$0 - 2].push($$[$0 - 1]);
                    break;
            }
        },
        table: [
            o($V0, $V1, {
                3: 1,
                4: 2,
                10: 3
            }),
            {
                1: [
                    3
                ]
            },
            o($V2, [
                2,
                307
            ], {
                5: 4,
                7: 5,
                321: 6,
                214: 7,
                8: 8,
                96: 9,
                215: 10,
                17: 11,
                21: 12,
                97: 16,
                38: 17,
                6: [
                    2,
                    238
                ],
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                24: [
                    1,
                    13
                ],
                32: [
                    1,
                    14
                ],
                36: [
                    1,
                    15
                ],
                41: $V4
            }),
            o([
                6,
                13,
                16,
                24,
                32,
                36,
                41,
                45,
                100,
                110,
                113,
                115,
                116,
                123,
                126,
                131,
                197,
                224,
                229,
                308,
                329,
                330,
                331,
                332,
                333
            ], [
                2,
                3
            ], {
                322: 19,
                11: 20,
                14: 21,
                12: [
                    1,
                    22
                ],
                15: [
                    1,
                    23
                ]
            }),
            {
                6: [
                    1,
                    24
                ]
            },
            {
                6: [
                    2,
                    240
                ]
            },
            {
                6: [
                    2,
                    241
                ]
            },
            {
                6: [
                    2,
                    242
                ]
            },
            {
                6: [
                    2,
                    243
                ],
                9: 25,
                84: 26,
                85: $V5
            },
            {
                6: [
                    2,
                    239
                ]
            },
            o($V6, [
                2,
                411
            ], {
                216: 28,
                217: 29
            }),
            o($V7, [
                2,
                249
            ], {
                18: 30
            }),
            o($V7, [
                2,
                251
            ], {
                22: 31
            }),
            o($V8, [
                2,
                255
            ], {
                25: 32,
                27: 33,
                29: [
                    1,
                    34
                ]
            }),
            {
                13: $V9,
                16: $Va,
                33: 35,
                39: [
                    1,
                    37
                ],
                44: 39,
                55: 40,
                87: $Vb,
                139: 38,
                307: 43,
                308: $Vc,
                323: 36
            },
            o($V7, [
                2,
                267
            ], {
                37: 46
            }),
            o($Vd, [
                2,
                326
            ], {
                98: 47,
                103: 49,
                106: 50,
                117: 55,
                130: 61,
                100: [
                    1,
                    48
                ],
                110: [
                    1,
                    51
                ],
                113: [
                    1,
                    52
                ],
                115: [
                    1,
                    53
                ],
                116: [
                    1,
                    54
                ],
                131: [
                    1,
                    62
                ],
                329: [
                    1,
                    56
                ],
                330: [
                    1,
                    57
                ],
                331: [
                    1,
                    58
                ],
                332: [
                    1,
                    59
                ],
                333: [
                    1,
                    60
                ]
            }),
            {
                39: [
                    1,
                    63
                ],
                40: 64,
                43: 65,
                44: 66,
                45: $Ve,
                87: $Vb
            },
            o($Vf, [
                2,
                273
            ], {
                42: 68,
                324: 69,
                325: [
                    1,
                    70
                ],
                326: [
                    1,
                    71
                ]
            }),
            o($V0, [
                2,
                248
            ]),
            o($V0, [
                2,
                245
            ]),
            o($V0, [
                2,
                246
            ]),
            {
                13: [
                    1,
                    72
                ]
            },
            {
                16: [
                    1,
                    73
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            {
                6: [
                    2,
                    2
                ]
            },
            {
                6: [
                    2,
                    244
                ]
            },
            {
                45: [
                    1,
                    77
                ],
                85: [
                    1,
                    78
                ],
                86: 74,
                87: [
                    1,
                    75
                ],
                89: [
                    1,
                    76
                ]
            },
            o([
                6,
                13,
                16,
                45,
                48,
                82,
                87,
                89,
                231,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312
            ], [
                2,
                120
            ], {
                337: [
                    1,
                    79
                ]
            }),
            o($Vg, [
                2,
                418
            ], {
                218: 80,
                222: 81,
                229: [
                    1,
                    82
                ]
            }),
            {
                19: 83,
                28: $Vh,
                29: $Vi,
                52: 84,
                53: $Vj,
                56: 85
            },
            {
                19: 88,
                28: $Vh,
                29: $Vi,
                52: 89,
                53: $Vj,
                56: 85
            },
            o($V7, [
                2,
                253
            ], {
                26: 90
            }),
            {
                28: [
                    1,
                    91
                ],
                52: 92,
                53: $Vj
            },
            o($Vk, [
                2,
                385
            ], {
                181: 93,
                182: 94,
                183: 95,
                31: [
                    2,
                    383
                ]
            }),
            o($Vl, [
                2,
                263
            ], {
                34: 96
            }),
            o($Vl, [
                2,
                261
            ], {
                44: 39,
                55: 40,
                307: 43,
                139: 97,
                13: $V9,
                16: $Va,
                87: $Vb,
                308: $Vc
            }),
            o($Vl, [
                2,
                262
            ]),
            o($Vm, [
                2,
                259
            ]),
            o($Vn, [
                2,
                143
            ]),
            o($Vn, [
                2,
                144
            ]),
            o([
                6,
                13,
                16,
                28,
                29,
                31,
                39,
                45,
                47,
                48,
                53,
                63,
                70,
                73,
                76,
                78,
                81,
                82,
                83,
                85,
                87,
                89,
                112,
                159,
                160,
                161,
                163,
                164,
                193,
                197,
                224,
                229,
                231,
                232,
                242,
                246,
                250,
                263,
                265,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                276,
                277,
                279,
                280,
                283,
                285,
                290,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                314,
                317,
                318,
                335,
                338,
                341,
                342,
                343,
                344,
                345,
                346,
                347,
                348,
                349,
                350,
                351
            ], [
                2,
                145
            ]),
            o($Vo, [
                2,
                211
            ]),
            o($Vo, [
                2,
                212
            ]),
            o($Vo, [
                2,
                213
            ]),
            o($Vo, [
                2,
                214
            ]),
            {
                19: 98,
                28: $Vh,
                29: $Vi,
                52: 99,
                53: $Vj,
                56: 85
            },
            {
                6: [
                    2,
                    309
                ],
                99: 100,
                193: [
                    1,
                    101
                ]
            },
            o($Vp, [
                2,
                311
            ], {
                101: 102,
                328: [
                    1,
                    103
                ]
            }),
            o($Vq, [
                2,
                317
            ], {
                104: 104,
                328: [
                    1,
                    105
                ]
            }),
            o($Vr, [
                2,
                322
            ], {
                107: 106,
                328: [
                    1,
                    107
                ]
            }),
            {
                111: 108,
                112: [
                    2,
                    324
                ],
                328: [
                    1,
                    109
                ]
            },
            {
                29: $Vs,
                114: 110
            },
            {
                29: $Vs,
                114: 112
            },
            {
                29: $Vs,
                114: 113
            },
            {
                118: 114,
                123: [
                    1,
                    115
                ],
                125: 116,
                126: $Vt
            },
            o($Vu, [
                2,
                315
            ]),
            o($Vu, [
                2,
                316
            ]),
            o($Vv, [
                2,
                319
            ]),
            o($Vv, [
                2,
                320
            ]),
            o($Vv, [
                2,
                321
            ]),
            o($Vd, [
                2,
                327
            ]),
            {
                13: $V9,
                16: $Va,
                55: 118,
                307: 43,
                308: $Vc
            },
            o($V7, [
                2,
                12
            ]),
            o($V7, [
                2,
                13
            ], {
                44: 66,
                43: 119,
                45: $Ve,
                87: $Vb
            }),
            o($Vw, [
                2,
                269
            ]),
            o($Vw, [
                2,
                15
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 120,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vf, [
                2,
                14
            ]),
            o($Vf, [
                2,
                274
            ]),
            o($Vf, [
                2,
                271
            ]),
            o($Vf, [
                2,
                272
            ]),
            o($V0, [
                2,
                4
            ]),
            {
                13: [
                    1,
                    177
                ]
            },
            o($V61, [
                2,
                39
            ]),
            {
                29: [
                    1,
                    178
                ]
            },
            {
                29: [
                    1,
                    179
                ]
            },
            {
                87: [
                    1,
                    181
                ],
                91: 180
            },
            {
                45: [
                    1,
                    187
                ],
                87: [
                    1,
                    185
                ],
                89: [
                    1,
                    186
                ],
                93: 182,
                165: 183,
                166: 184
            },
            o($V6, [
                2,
                410
            ]),
            o([
                6,
                13,
                16,
                45,
                48,
                82,
                87,
                89,
                231,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                337
            ], [
                2,
                121
            ], {
                338: [
                    1,
                    188
                ]
            }),
            {
                13: $V9,
                16: $Va,
                45: [
                    1,
                    193
                ],
                55: 194,
                197: $V71,
                219: 189,
                220: 190,
                223: 191,
                224: [
                    1,
                    192
                ],
                307: 43,
                308: $Vc
            },
            o($Vg, [
                2,
                419
            ]),
            o($V81, $V91, {
                20: 196,
                59: 197,
                69: 198,
                70: $Va1
            }),
            o($V7, [
                2,
                250
            ]),
            {
                29: $Vb1,
                57: 200
            },
            o($Vp, [
                2,
                279
            ], {
                54: 202,
                327: [
                    1,
                    203
                ]
            }),
            {
                29: [
                    2,
                    282
                ]
            },
            o($Vc1, $Vd1, {
                23: 204,
                58: 205,
                62: 206,
                63: $Ve1
            }),
            o($V7, [
                2,
                252
            ]),
            {
                19: 208,
                28: $Vh,
                29: $Vi,
                52: 209,
                53: $Vj,
                56: 85
            },
            {
                29: [
                    1,
                    210
                ]
            },
            o($V8, [
                2,
                256
            ]),
            {
                31: [
                    1,
                    211
                ]
            },
            {
                31: [
                    2,
                    384
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                145: 212,
                172: 221,
                185: 213,
                187: 214,
                231: $Vh1,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl1, [
                2,
                265
            ], {
                56: 85,
                35: 227,
                52: 228,
                19: 229,
                28: $Vh,
                29: $Vi,
                53: $Vj
            }),
            o($Vm, [
                2,
                260
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 230,
                63: $Ve1
            }),
            o($V7, [
                2,
                268
            ]),
            {
                6: [
                    2,
                    45
                ]
            },
            o($V0, $V1, {
                10: 3,
                4: 231
            }),
            {
                13: $V9,
                16: $Va,
                55: 232,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                312
            ]),
            {
                105: 233,
                112: $Vm1,
                122: 234,
                132: [
                    1,
                    237
                ],
                134: 235,
                327: [
                    1,
                    238
                ],
                334: [
                    1,
                    239
                ]
            },
            o($Vq, [
                2,
                318
            ]),
            o($Vp, $Vn1, {
                108: 240,
                133: 242,
                112: $Vo1,
                132: $Vp1
            }),
            o($Vr, [
                2,
                323
            ]),
            {
                112: [
                    1,
                    244
                ]
            },
            {
                112: [
                    2,
                    325
                ]
            },
            o($Vq1, [
                2,
                50
            ]),
            o($Vk, $Vr1, {
                135: 245,
                136: 246,
                143: 247,
                144: 248,
                31: $Vs1,
                112: $Vs1
            }),
            o($Vq1, [
                2,
                51
            ]),
            o($Vq1, [
                2,
                52
            ]),
            o($Vt1, [
                2,
                328
            ], {
                119: 249
            }),
            {
                29: $Vs,
                114: 250
            },
            o($Vt1, [
                2,
                56
            ]),
            {
                29: $Vs,
                114: 251
            },
            o($Vd, [
                2,
                59
            ]),
            o($Vw, [
                2,
                270
            ]),
            {
                47: [
                    1,
                    252
                ]
            },
            o($Vu1, [
                2,
                150
            ]),
            o($Vv1, [
                2,
                428
            ], {
                240: 253
            }),
            o($Vw1, [
                2,
                430
            ], {
                244: 254
            }),
            o($Vw1, [
                2,
                155
            ], {
                248: 255,
                249: 256,
                250: [
                    2,
                    438
                ],
                290: [
                    1,
                    257
                ],
                341: [
                    1,
                    258
                ],
                342: [
                    1,
                    259
                ],
                343: [
                    1,
                    260
                ],
                344: [
                    1,
                    261
                ],
                345: [
                    1,
                    262
                ],
                346: [
                    1,
                    263
                ]
            }),
            o($Vx1, [
                2,
                440
            ], {
                252: 264
            }),
            o($Vy1, [
                2,
                448
            ], {
                260: 265
            }),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 266,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 267,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                255: 154,
                257: 155,
                264: 268,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vy1, [
                2,
                167
            ]),
            o($Vy1, [
                2,
                168
            ]),
            o($Vy1, [
                2,
                169
            ]),
            o($Vy1, [
                2,
                170
            ], {
                176: 269,
                45: $Vz1,
                89: $VA1
            }),
            o($Vy1, [
                2,
                171
            ]),
            o($Vy1, [
                2,
                172
            ]),
            o($Vy1, [
                2,
                173
            ]),
            o($Vy1, [
                2,
                174
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 272,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                176
            ]),
            {
                89: [
                    1,
                    273
                ]
            },
            {
                45: [
                    1,
                    274
                ]
            },
            {
                45: [
                    1,
                    275
                ]
            },
            {
                45: [
                    1,
                    276
                ]
            },
            {
                45: [
                    1,
                    277
                ]
            },
            {
                45: [
                    1,
                    278
                ]
            },
            {
                45: $VC1,
                89: $VD1,
                179: 279
            },
            {
                45: [
                    1,
                    282
                ]
            },
            {
                45: [
                    1,
                    284
                ],
                89: [
                    1,
                    283
                ]
            },
            {
                279: [
                    1,
                    285
                ]
            },
            o($VE1, [
                2,
                192
            ], {
                292: [
                    1,
                    286
                ],
                293: [
                    1,
                    287
                ]
            }),
            o($VE1, [
                2,
                195
            ]),
            o($VE1, [
                2,
                196
            ]),
            o($VE1, [
                2,
                197
            ]),
            o($VE1, [
                2,
                198
            ]),
            o($VE1, [
                2,
                199
            ]),
            o($VE1, [
                2,
                200
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                82: $Vy,
                87: $Vb,
                139: 289,
                172: 291,
                255: 154,
                257: 155,
                266: 290,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                320: 288
            },
            {
                45: [
                    1,
                    292
                ]
            },
            {
                45: [
                    1,
                    293
                ]
            },
            {
                45: [
                    1,
                    294
                ]
            },
            o($VF1, [
                2,
                452
            ]),
            o($VF1, [
                2,
                453
            ]),
            o($VF1, [
                2,
                454
            ]),
            o($VF1, [
                2,
                455
            ]),
            o($VF1, [
                2,
                456
            ]),
            {
                279: [
                    2,
                    458
                ]
            },
            o($VG1, [
                2,
                207
            ]),
            o($VG1, [
                2,
                208
            ]),
            o($VG1, [
                2,
                209
            ]),
            o($VG1, [
                2,
                210
            ]),
            o($VE1, [
                2,
                201
            ]),
            o($VE1, [
                2,
                202
            ]),
            o($VE1, [
                2,
                203
            ]),
            o($VE1, [
                2,
                204
            ]),
            o($VE1, [
                2,
                205
            ]),
            o($VE1, [
                2,
                206
            ]),
            o($V0, [
                2,
                5
            ]),
            o($VH1, [
                2,
                297
            ], {
                88: 295
            }),
            o($VI1, [
                2,
                299
            ], {
                90: 296
            }),
            {
                48: [
                    1,
                    297
                ],
                87: [
                    1,
                    298
                ]
            },
            o($VJ1, [
                2,
                301
            ]),
            o($V61, [
                2,
                43
            ]),
            o($V61, [
                2,
                82
            ]),
            o($V61, [
                2,
                83
            ]),
            {
                29: [
                    1,
                    299
                ]
            },
            {
                29: [
                    1,
                    300
                ]
            },
            {
                87: [
                    1,
                    302
                ],
                169: 301
            },
            o($V6, [
                2,
                412
            ]),
            o($VK1, [
                2,
                123
            ]),
            o($VK1, [
                2,
                416
            ], {
                221: 303,
                339: 304,
                39: [
                    1,
                    306
                ],
                263: [
                    1,
                    307
                ],
                340: [
                    1,
                    305
                ]
            }),
            o($VL1, [
                2,
                124
            ]),
            {
                13: $V9,
                16: $Va,
                45: [
                    1,
                    311
                ],
                55: 194,
                89: [
                    1,
                    310
                ],
                197: $V71,
                223: 312,
                225: 308,
                226: 309,
                229: $VM1,
                307: 43,
                308: $Vc
            },
            o($V6, $V3, {
                215: 10,
                214: 314
            }),
            o($VL1, [
                2,
                236
            ]),
            o($VL1, [
                2,
                237
            ]),
            o($VN1, [
                2,
                6
            ]),
            o($VO1, [
                2,
                287
            ], {
                60: 315,
                72: 316,
                73: [
                    1,
                    317
                ]
            }),
            o($V81, [
                2,
                286
            ]),
            {
                13: $V9,
                16: $Va,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                71: 318,
                77: 320,
                79: 319,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o([
                6,
                31,
                63,
                70,
                73,
                81,
                83,
                85
            ], [
                2,
                20
            ]),
            o($Vk, $VP1, {
                38: 17,
                49: 324,
                147: 325,
                17: 326,
                21: 327,
                148: 328,
                154: 329,
                155: 330,
                29: $VQ1,
                31: $VQ1,
                85: $VQ1,
                112: $VQ1,
                159: $VQ1,
                160: $VQ1,
                161: $VQ1,
                163: $VQ1,
                164: $VQ1,
                41: $V4
            }),
            {
                13: $V9,
                16: $Va,
                55: 331,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                280
            ]),
            o($VN1, [
                2,
                7
            ]),
            o($V81, $V91, {
                59: 197,
                69: 198,
                20: 332,
                70: $Va1
            }),
            o($Vc1, [
                2,
                284
            ]),
            {
                64: [
                    1,
                    333
                ]
            },
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 334,
                63: $Ve1
            }),
            o($V7, [
                2,
                254
            ]),
            o($Vk, $Vr1, {
                144: 248,
                30: 335,
                143: 336,
                31: [
                    2,
                    257
                ]
            }),
            o($V7, [
                2,
                100
            ]),
            {
                31: [
                    2,
                    387
                ],
                184: 337,
                335: [
                    1,
                    338
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 339,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VS1, [
                2,
                389
            ], {
                44: 39,
                55: 40,
                307: 43,
                190: 340,
                195: 341,
                139: 342,
                188: 344,
                189: 345,
                186: 346,
                13: $V9,
                16: $Va,
                87: $Vb,
                197: $VR1,
                308: $Vc
            }),
            o($VT1, [
                2,
                227
            ]),
            o($VT1, [
                2,
                228
            ]),
            o($VT1, [
                2,
                229
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                200: 348,
                230: 347,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 352,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VT1, [
                2,
                146
            ]),
            o($VT1, [
                2,
                147
            ]),
            o($VT1, [
                2,
                148
            ]),
            o($VT1, [
                2,
                149
            ]),
            {
                13: $V9,
                16: $Va,
                44: 354,
                55: 355,
                82: $Vy,
                87: $Vb,
                172: 357,
                237: 356,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 358,
                312: $Vk1,
                313: 353
            },
            o($VU1, [
                2,
                215
            ]),
            o($VU1, [
                2,
                216
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 359,
                63: $Ve1
            }),
            o($Vl, [
                2,
                264
            ]),
            o($Vl1, [
                2,
                266
            ]),
            o($VN1, [
                2,
                11
            ]),
            o($V2, [
                2,
                308
            ], {
                6: [
                    2,
                    310
                ]
            }),
            o($Vq1, [
                2,
                313
            ], {
                102: 360,
                120: 361,
                121: [
                    1,
                    362
                ]
            }),
            o($Vq1, [
                2,
                47
            ]),
            o($Vq1, [
                2,
                63
            ]),
            o($Vq1, [
                2,
                64
            ]),
            {
                13: $V9,
                16: $Va,
                55: 363,
                307: 43,
                308: $Vc
            },
            o($Vq1, [
                2,
                336
            ]),
            o($Vq1, [
                2,
                337
            ]),
            o($Vq1, [
                2,
                338
            ]),
            {
                109: [
                    1,
                    364
                ]
            },
            o($VV1, [
                2,
                60
            ]),
            {
                13: $V9,
                16: $Va,
                55: 365,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                335
            ]),
            {
                13: $V9,
                16: $Va,
                55: 366,
                307: 43,
                308: $Vc
            },
            {
                31: [
                    1,
                    367
                ]
            },
            o($VW1, [
                2,
                341
            ], {
                137: 368
            }),
            o($VW1, [
                2,
                340
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                145: 369,
                172: 221,
                185: 213,
                187: 214,
                231: $Vh1,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            {
                28: [
                    1,
                    370
                ],
                127: 371,
                128: [
                    1,
                    372
                ]
            },
            o($Vt1, [
                2,
                330
            ], {
                124: 373,
                125: 374,
                126: $Vt
            }),
            o($Vt1, [
                2,
                57
            ]),
            {
                44: 375,
                87: $Vb
            },
            o($Vu1, [
                2,
                151
            ], {
                241: 376,
                242: [
                    1,
                    377
                ]
            }),
            o($Vv1, [
                2,
                153
            ], {
                245: 378,
                246: [
                    1,
                    379
                ]
            }),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                247: 380,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                250: [
                    1,
                    381
                ]
            },
            o($VX1, [
                2,
                432
            ]),
            o($VX1, [
                2,
                433
            ]),
            o($VX1, [
                2,
                434
            ]),
            o($VX1, [
                2,
                435
            ]),
            o($VX1, [
                2,
                436
            ]),
            o($VX1, [
                2,
                437
            ]),
            {
                250: [
                    2,
                    439
                ]
            },
            o([
                47,
                48,
                193,
                242,
                246,
                250,
                272,
                290,
                341,
                342,
                343,
                344,
                345,
                346
            ], [
                2,
                158
            ], {
                253: 382,
                254: 383,
                255: 384,
                257: 385,
                263: [
                    1,
                    386
                ],
                265: [
                    1,
                    387
                ],
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW
            }),
            o($Vx1, [
                2,
                162
            ], {
                261: 388,
                262: 389,
                39: $VY1,
                338: $VZ1
            }),
            o($Vy1, [
                2,
                164
            ]),
            o($Vy1, [
                2,
                165
            ]),
            o($Vy1, [
                2,
                166
            ]),
            o($VB1, [
                2,
                95
            ]),
            o($VB1, [
                2,
                96
            ]),
            o($VX1, [
                2,
                377
            ], {
                177: 392,
                325: [
                    1,
                    393
                ]
            }),
            {
                48: [
                    1,
                    394
                ]
            },
            o($VB1, [
                2,
                177
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 395,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 396,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 397,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 398,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 399,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                183
            ]),
            o($VB1, [
                2,
                98
            ]),
            o($VX1, [
                2,
                381
            ], {
                180: 400
            }),
            {
                87: [
                    1,
                    401
                ]
            },
            o($VB1, [
                2,
                185
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 402,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                29: $Vb1,
                57: 403
            },
            o($VE1, [
                2,
                193
            ]),
            {
                13: $V9,
                16: $Va,
                55: 404,
                307: 43,
                308: $Vc
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                195: 405,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($V_1, [
                2,
                233
            ]),
            o($V_1, [
                2,
                234
            ]),
            o($V_1, [
                2,
                235
            ]),
            o($V$1, [
                2,
                459
            ], {
                281: 406,
                325: [
                    1,
                    407
                ]
            }),
            o($VX1, [
                2,
                463
            ], {
                284: 408,
                325: [
                    1,
                    409
                ]
            }),
            o($VX1, [
                2,
                465
            ], {
                286: 410,
                325: [
                    1,
                    411
                ]
            }),
            {
                13: $V9,
                16: $Va,
                31: [
                    1,
                    412
                ],
                55: 414,
                82: $Vy,
                171: 413,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    419
                ],
                89: [
                    1,
                    420
                ]
            },
            {
                29: [
                    1,
                    421
                ]
            },
            o($VJ1, [
                2,
                302
            ]),
            o($VH1, [
                2,
                367
            ], {
                167: 422
            }),
            o($VI1, [
                2,
                369
            ], {
                168: 423
            }),
            {
                48: [
                    1,
                    424
                ],
                87: [
                    1,
                    425
                ]
            },
            o($VJ1, [
                2,
                371
            ]),
            o($VK1, [
                2,
                122
            ]),
            o($VK1, [
                2,
                417
            ]),
            o($VK1, [
                2,
                413
            ]),
            o($VK1, [
                2,
                414
            ]),
            o($VK1, [
                2,
                415
            ]),
            o($VL1, [
                2,
                125
            ]),
            o($VL1, [
                2,
                127
            ]),
            o($VL1, [
                2,
                128
            ]),
            o($V22, [
                2,
                420
            ], {
                227: 426
            }),
            o($VL1, [
                2,
                130
            ]),
            {
                13: $V9,
                16: $Va,
                55: 194,
                197: $V71,
                223: 427,
                307: 43,
                308: $Vc
            },
            {
                48: [
                    1,
                    428
                ]
            },
            o($V32, [
                2,
                289
            ], {
                61: 429,
                80: 430,
                81: [
                    1,
                    431
                ],
                83: [
                    1,
                    432
                ]
            }),
            o($VO1, [
                2,
                288
            ]),
            {
                64: [
                    1,
                    433
                ]
            },
            o($V81, [
                2,
                29
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                77: 320,
                67: 321,
                68: 322,
                55: 323,
                79: 434,
                13: $V9,
                16: $Va,
                45: $Vx,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($V42, [
                2,
                293
            ]),
            o($V52, [
                2,
                92
            ]),
            o($V52, [
                2,
                93
            ]),
            o($V52, [
                2,
                94
            ]),
            {
                45: $Vz1,
                89: $VA1,
                176: 269
            },
            {
                31: [
                    1,
                    435
                ]
            },
            {
                31: [
                    1,
                    436
                ]
            },
            {
                19: 437,
                28: $Vh,
                29: $Vi,
                56: 85
            },
            {
                19: 438,
                28: $Vh,
                29: $Vi,
                56: 85
            },
            o($V62, [
                2,
                355
            ], {
                149: 439
            }),
            o($V62, [
                2,
                354
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                156: 440,
                172: 221,
                185: 441,
                203: 442,
                231: $V82,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl, [
                2,
                19
            ]),
            o($V32, [
                2,
                21
            ]),
            {
                13: $V9,
                16: $Va,
                44: 450,
                45: $V92,
                55: 323,
                65: 445,
                66: 446,
                67: 447,
                68: 448,
                87: $Vb,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VN1, [
                2,
                8
            ]),
            {
                31: [
                    1,
                    451
                ]
            },
            {
                31: [
                    2,
                    258
                ]
            },
            {
                31: [
                    2,
                    101
                ]
            },
            o($Vk, [
                2,
                386
            ], {
                31: [
                    2,
                    388
                ]
            }),
            o($VS1, [
                2,
                102
            ]),
            o($Va2, [
                2,
                391
            ], {
                191: 452
            }),
            o($Vk, [
                2,
                395
            ], {
                196: 453,
                198: 454
            }),
            o($Vk, [
                2,
                108
            ]),
            o($Vk, [
                2,
                109
            ]),
            o($VS1, [
                2,
                103
            ]),
            o($VS1, [
                2,
                104
            ]),
            o($VS1, [
                2,
                390
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                48: [
                    1,
                    455
                ],
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                200: 456,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vb2, [
                2,
                424
            ]),
            o($Vc2, [
                2,
                136
            ]),
            o($Vc2, [
                2,
                137
            ]),
            o($Vd2, [
                2,
                140
            ]),
            {
                232: [
                    1,
                    457
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                195: 458,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($V_1, [
                2,
                219
            ]),
            o($V_1, [
                2,
                220
            ]),
            o($V_1, [
                2,
                221
            ]),
            o($V_1, [
                2,
                222
            ]),
            o($V_1, [
                2,
                223
            ]),
            o($VN1, [
                2,
                10
            ]),
            o($Vq1, [
                2,
                46
            ]),
            o($Vq1, [
                2,
                314
            ]),
            {
                112: $Vm1,
                122: 459
            },
            o($Vq1, [
                2,
                62
            ]),
            o($Vp, $Vn1, {
                133: 242,
                108: 460,
                112: $Vo1,
                132: $Vp1
            }),
            o($VV1, [
                2,
                61
            ]),
            o($Vq1, [
                2,
                49
            ]),
            o([
                6,
                28,
                126,
                128,
                193
            ], [
                2,
                65
            ]),
            {
                31: [
                    2,
                    66
                ],
                112: [
                    1,
                    462
                ],
                138: 461
            },
            o($VW1, [
                2,
                351
            ], {
                146: 463,
                335: [
                    1,
                    464
                ]
            }),
            {
                29: $Vb1,
                57: 465
            },
            o($Vt1, [
                2,
                329
            ]),
            o($Vp, [
                2,
                332
            ], {
                129: 466,
                327: [
                    1,
                    467
                ]
            }),
            o($Vt1, [
                2,
                55
            ]),
            o($Vt1, [
                2,
                331
            ]),
            {
                48: [
                    1,
                    468
                ]
            },
            o($Vv1, [
                2,
                429
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                239: 469,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vw1, [
                2,
                431
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                243: 470,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vw1, [
                2,
                156
            ]),
            {
                45: $VC1,
                89: $VD1,
                179: 471
            },
            o($Vx1, [
                2,
                441
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                251: 472,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vy1, [
                2,
                444
            ], {
                256: 473
            }),
            o($Vy1, [
                2,
                446
            ], {
                258: 474
            }),
            o($VX1, [
                2,
                442
            ]),
            o($VX1, [
                2,
                443
            ]),
            o($Vy1, [
                2,
                449
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                255: 154,
                257: 155,
                259: 475,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                450
            ]),
            o($VX1, [
                2,
                451
            ]),
            o($VX1, [
                2,
                379
            ], {
                178: 476
            }),
            o($VX1, [
                2,
                378
            ]),
            o([
                6,
                13,
                16,
                29,
                31,
                39,
                45,
                47,
                48,
                73,
                76,
                78,
                81,
                82,
                83,
                85,
                87,
                89,
                112,
                159,
                160,
                161,
                163,
                164,
                193,
                231,
                242,
                246,
                250,
                263,
                265,
                268,
                269,
                270,
                271,
                272,
                273,
                274,
                276,
                277,
                279,
                280,
                283,
                285,
                290,
                294,
                295,
                296,
                297,
                298,
                299,
                300,
                301,
                302,
                303,
                304,
                305,
                306,
                308,
                309,
                310,
                312,
                335,
                338,
                341,
                342,
                343,
                344,
                345,
                346,
                347,
                348,
                349,
                350,
                351
            ], [
                2,
                175
            ]),
            {
                48: [
                    1,
                    477
                ]
            },
            {
                48: [
                    1,
                    478
                ]
            },
            {
                272: [
                    1,
                    479
                ]
            },
            {
                272: [
                    1,
                    480
                ]
            },
            {
                272: [
                    1,
                    481
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 482,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                48: [
                    1,
                    483
                ]
            },
            {
                48: [
                    1,
                    484
                ]
            },
            o($VB1, [
                2,
                187
            ]),
            o($VE1, [
                2,
                194
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                82: $Vy,
                87: $Vb,
                139: 289,
                172: 291,
                255: 154,
                257: 155,
                266: 290,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                320: 485
            },
            {
                13: $V9,
                16: $Va,
                39: [
                    1,
                    487
                ],
                44: 136,
                45: $Vx,
                46: 488,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                282: 486,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($V$1, [
                2,
                460
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 489,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                464
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 490,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VX1, [
                2,
                466
            ]),
            o($V61, [
                2,
                40
            ]),
            o($VH1, [
                2,
                298
            ]),
            o($Ve2, [
                2,
                87
            ]),
            o($Ve2, [
                2,
                88
            ]),
            o($Ve2, [
                2,
                89
            ]),
            o($Ve2, [
                2,
                90
            ]),
            {
                13: $V9,
                16: $Va,
                55: 492,
                82: $Vy,
                172: 493,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                311: 494,
                312: $Vk1,
                315: 491
            },
            o($V61, [
                2,
                41
            ]),
            o($VI1, [
                2,
                300
            ]),
            o($Vf2, [
                2,
                303
            ], {
                92: 495
            }),
            {
                13: $V9,
                16: $Va,
                31: [
                    1,
                    496
                ],
                55: 414,
                82: $Vy,
                171: 497,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    498
                ],
                89: [
                    1,
                    499
                ]
            },
            {
                29: [
                    1,
                    500
                ]
            },
            o($VJ1, [
                2,
                372
            ]),
            {
                13: $V9,
                16: $Va,
                48: [
                    2,
                    422
                ],
                55: 194,
                197: $V71,
                223: 312,
                226: 502,
                228: 501,
                229: $VM1,
                307: 43,
                308: $Vc
            },
            o($VL1, [
                2,
                131
            ]),
            o($VL1, [
                2,
                126
            ]),
            o($V32, [
                2,
                22
            ]),
            o($V32, [
                2,
                290
            ]),
            {
                82: [
                    1,
                    503
                ]
            },
            {
                82: [
                    1,
                    504
                ]
            },
            {
                13: $V9,
                16: $Va,
                44: 510,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                74: 505,
                75: 506,
                76: $Vg2,
                77: 320,
                78: $Vh2,
                79: 509,
                87: $Vb,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($V42, [
                2,
                294
            ]),
            o($Vi2, [
                2,
                69
            ]),
            o($Vi2, [
                2,
                70
            ]),
            o($V81, $V91, {
                59: 197,
                69: 198,
                20: 511,
                70: $Va1
            }),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 512,
                63: $Ve1
            }),
            {
                29: [
                    2,
                    375
                ],
                31: [
                    2,
                    71
                ],
                84: 522,
                85: $V5,
                112: [
                    1,
                    518
                ],
                150: 513,
                151: 514,
                158: 515,
                159: [
                    1,
                    516
                ],
                160: [
                    1,
                    517
                ],
                161: [
                    1,
                    519
                ],
                163: [
                    1,
                    520
                ],
                164: [
                    1,
                    521
                ],
                175: 523
            },
            o($V62, [
                2,
                363
            ], {
                157: 524,
                335: [
                    1,
                    525
                ]
            }),
            o($V6, $V3, {
                215: 10,
                202: 526,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                87: $Vb
            }),
            o($Vj2, [
                2,
                399
            ], {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                204: 531,
                202: 532,
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                87: $Vb
            }),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                212: 534,
                231: $V82,
                233: 533,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($V6, $V3, {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                202: 537,
                87: $Vb
            }),
            o($Vc1, [
                2,
                23
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                55: 323,
                67: 447,
                68: 448,
                44: 450,
                66: 538,
                13: $V9,
                16: $Va,
                45: $V92,
                87: $Vb,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($Vk2, [
                2,
                291
            ]),
            o($Vk2, [
                2,
                24
            ]),
            o($Vk2, [
                2,
                25
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 539,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vk2, [
                2,
                28
            ]),
            o($Vc1, $Vd1, {
                58: 205,
                62: 206,
                23: 540,
                63: $Ve1
            }),
            o([
                31,
                112,
                232,
                318,
                335
            ], [
                2,
                105
            ], {
                192: 541,
                193: [
                    1,
                    542
                ]
            }),
            o($Va2, [
                2,
                107
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $Vf1,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                187: 350,
                199: 543,
                200: 544,
                231: $Vh1,
                234: 349,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vl2, [
                2,
                132
            ]),
            o($Vb2, [
                2,
                425
            ]),
            o($Vl2, [
                2,
                133
            ]),
            {
                13: $V9,
                16: $Va,
                44: 354,
                55: 355,
                82: $Vy,
                87: $Vb,
                172: 357,
                237: 356,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 358,
                312: $Vk1,
                313: 545
            },
            o($Vq1, [
                2,
                54
            ]),
            o($Vq1, [
                2,
                48
            ]),
            o($VW1, [
                2,
                342
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 546,
                307: 43,
                308: $Vc
            },
            o($VW1, [
                2,
                68
            ]),
            o($Vk, [
                2,
                350
            ], {
                31: $Vm2,
                112: $Vm2
            }),
            o($Vq1, [
                2,
                53
            ]),
            {
                13: $V9,
                16: $Va,
                55: 547,
                307: 43,
                308: $Vc
            },
            o($Vp, [
                2,
                333
            ]),
            o($Vw, [
                2,
                16
            ]),
            o($Vv1, [
                2,
                152
            ]),
            o($Vw1, [
                2,
                154
            ]),
            o($Vw1, [
                2,
                157
            ]),
            o($Vx1, [
                2,
                159
            ]),
            o($Vx1, [
                2,
                160
            ], {
                262: 389,
                261: 548,
                39: $VY1,
                338: $VZ1
            }),
            o($Vx1, [
                2,
                161
            ], {
                262: 389,
                261: 549,
                39: $VY1,
                338: $VZ1
            }),
            o($Vy1, [
                2,
                163
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 550,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                178
            ]),
            o($VB1, [
                2,
                179
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 551,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 552,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 553,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                48: [
                    1,
                    554
                ],
                272: [
                    1,
                    555
                ]
            },
            o($VB1, [
                2,
                184
            ]),
            o($VB1, [
                2,
                186
            ]),
            {
                314: [
                    1,
                    556
                ]
            },
            {
                48: [
                    1,
                    557
                ]
            },
            {
                48: [
                    2,
                    461
                ]
            },
            {
                48: [
                    2,
                    462
                ]
            },
            {
                48: [
                    1,
                    558
                ]
            },
            {
                48: [
                    2,
                    467
                ],
                193: [
                    1,
                    561
                ],
                287: 559,
                288: 560
            },
            {
                13: $V9,
                16: $Va,
                55: 194,
                197: $V71,
                223: 562,
                307: 43,
                308: $Vc
            },
            o($Vn2, [
                2,
                224
            ]),
            o($Vn2, [
                2,
                225
            ]),
            o($Vn2, [
                2,
                226
            ]),
            {
                31: [
                    1,
                    563
                ],
                45: $Vo2,
                94: 564
            },
            o($V61, [
                2,
                84
            ]),
            o($VH1, [
                2,
                368
            ]),
            o($V61, [
                2,
                85
            ]),
            o($VI1, [
                2,
                370
            ]),
            o($Vf2, [
                2,
                373
            ], {
                170: 566
            }),
            {
                48: [
                    1,
                    567
                ]
            },
            {
                48: [
                    2,
                    423
                ],
                337: [
                    1,
                    568
                ]
            },
            o($V32, [
                2,
                35
            ], {
                83: [
                    1,
                    569
                ]
            }),
            o($V32, [
                2,
                36
            ], {
                81: [
                    1,
                    570
                ]
            }),
            o($VO1, [
                2,
                30
            ], {
                307: 43,
                267: 139,
                275: 146,
                278: 149,
                77: 320,
                67: 321,
                68: 322,
                55: 323,
                79: 509,
                44: 510,
                75: 571,
                13: $V9,
                16: $Va,
                45: $Vx,
                76: $Vg2,
                78: $Vh2,
                87: $Vb,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                276: $VI,
                277: $VJ,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            }),
            o($Vp2, [
                2,
                295
            ]),
            {
                45: $Vx,
                77: 572
            },
            {
                45: $Vx,
                77: 573
            },
            o($Vp2, [
                2,
                33
            ]),
            o($Vp2, [
                2,
                34
            ]),
            {
                31: [
                    2,
                    275
                ],
                50: 574,
                84: 575,
                85: $V5
            },
            {
                31: [
                    2,
                    277
                ],
                51: 576,
                84: 577,
                85: $V5
            },
            o($V62, [
                2,
                356
            ]),
            o($Vq2, [
                2,
                357
            ], {
                152: 578,
                335: [
                    1,
                    579
                ]
            }),
            o($Vr2, [
                2,
                74
            ]),
            {
                29: $Vb1,
                57: 580
            },
            {
                29: $Vb1,
                57: 581
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 582,
                307: 43,
                308: $Vc
            },
            o($Vs2, [
                2,
                365
            ], {
                162: 583,
                328: [
                    1,
                    584
                ]
            }),
            {
                13: $V9,
                16: $Va,
                45: $Vx,
                55: 323,
                67: 321,
                68: 322,
                77: 320,
                79: 585,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                307: 43,
                308: $Vc,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                45: [
                    1,
                    586
                ]
            },
            o($Vr2, [
                2,
                81
            ]),
            {
                29: $Vb1,
                57: 587
            },
            o($V62, [
                2,
                73
            ]),
            o($Vk, [
                2,
                362
            ], {
                29: $Vt2,
                31: $Vt2,
                85: $Vt2,
                112: $Vt2,
                159: $Vt2,
                160: $Vt2,
                161: $Vt2,
                163: $Vt2,
                164: $Vt2
            }),
            o($Vj2, [
                2,
                112
            ]),
            o($Vu2, [
                2,
                401
            ], {
                206: 588
            }),
            o($Vk, [
                2,
                405
            ], {
                209: 589,
                210: 590
            }),
            o($Vk, [
                2,
                403
            ]),
            o($Vk, [
                2,
                404
            ]),
            o($Vj2, [
                2,
                113
            ]),
            o($Vj2, [
                2,
                400
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                48: [
                    1,
                    591
                ],
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                212: 592,
                231: $V82,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($Vb2, [
                2,
                426
            ]),
            o($Vd2, [
                2,
                138
            ]),
            o($Vd2, [
                2,
                139
            ]),
            {
                232: [
                    1,
                    593
                ]
            },
            o($Vk2, [
                2,
                292
            ]),
            {
                47: [
                    1,
                    595
                ],
                48: [
                    1,
                    594
                ]
            },
            o($VN1, [
                2,
                9
            ]),
            o($Va2, [
                2,
                392
            ]),
            o($Va2, [
                2,
                393
            ], {
                44: 39,
                55: 40,
                307: 43,
                195: 341,
                139: 342,
                194: 596,
                190: 597,
                13: $V9,
                16: $Va,
                87: $Vb,
                197: $VR1,
                308: $Vc
            }),
            o($Va2, [
                2,
                110
            ], {
                272: [
                    1,
                    598
                ]
            }),
            o($Vv2, [
                2,
                397
            ], {
                201: 599,
                316: 600,
                317: [
                    1,
                    601
                ]
            }),
            {
                314: [
                    1,
                    602
                ]
            },
            {
                29: [
                    1,
                    603
                ]
            },
            o($Vt1, [
                2,
                58
            ]),
            o($Vy1, [
                2,
                445
            ]),
            o($Vy1, [
                2,
                447
            ]),
            {
                48: [
                    1,
                    604
                ],
                272: [
                    1,
                    605
                ]
            },
            {
                48: [
                    1,
                    606
                ]
            },
            {
                272: [
                    1,
                    607
                ]
            },
            {
                272: [
                    1,
                    608
                ]
            },
            o($VB1, [
                2,
                99
            ]),
            o($VX1, [
                2,
                382
            ]),
            o([
                13,
                16,
                39,
                47,
                48,
                87,
                193,
                197,
                242,
                246,
                250,
                263,
                265,
                272,
                290,
                297,
                298,
                299,
                300,
                301,
                302,
                308,
                314,
                338,
                341,
                342,
                343,
                344,
                345,
                346
            ], [
                2,
                232
            ]),
            o($VB1, [
                2,
                188
            ]),
            o($VB1, [
                2,
                189
            ]),
            {
                48: [
                    1,
                    609
                ]
            },
            {
                48: [
                    2,
                    468
                ]
            },
            {
                289: [
                    1,
                    610
                ]
            },
            {
                13: $V9,
                16: $Va,
                55: 492,
                82: $Vy,
                172: 493,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                311: 494,
                312: $Vk1,
                315: 611
            },
            o($V61, [
                2,
                42
            ]),
            o($Vf2, [
                2,
                304
            ]),
            {
                13: $V9,
                16: $Va,
                55: 414,
                82: $Vy,
                95: 612,
                171: 613,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            {
                31: [
                    1,
                    614
                ],
                45: $Vo2,
                94: 615
            },
            o($VL1, [
                2,
                129
            ]),
            o($V22, [
                2,
                421
            ]),
            {
                82: [
                    1,
                    616
                ]
            },
            {
                82: [
                    1,
                    617
                ]
            },
            o($Vp2, [
                2,
                296
            ]),
            o($Vp2, [
                2,
                31
            ]),
            o($Vp2, [
                2,
                32
            ]),
            {
                31: [
                    2,
                    17
                ]
            },
            {
                31: [
                    2,
                    276
                ]
            },
            {
                31: [
                    2,
                    18
                ]
            },
            {
                31: [
                    2,
                    278
                ]
            },
            o($Vk, $VP1, {
                155: 330,
                153: 618,
                154: 619,
                29: $Vw2,
                31: $Vw2,
                85: $Vw2,
                112: $Vw2,
                159: $Vw2,
                160: $Vw2,
                161: $Vw2,
                163: $Vw2,
                164: $Vw2
            }),
            o($Vq2, [
                2,
                358
            ]),
            o($Vr2, [
                2,
                75
            ]),
            o($Vr2, [
                2,
                76
            ]),
            {
                29: $Vb1,
                57: 620
            },
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 621,
                307: 43,
                308: $Vc
            },
            o($Vs2, [
                2,
                366
            ]),
            o($Vr2, [
                2,
                79
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 622,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($Vr2, [
                2,
                91
            ], {
                336: [
                    1,
                    623
                ]
            }),
            o([
                29,
                31,
                85,
                112,
                159,
                160,
                161,
                163,
                164,
                232,
                318,
                335
            ], [
                2,
                114
            ], {
                207: 624,
                193: [
                    1,
                    625
                ]
            }),
            o($Vu2, [
                2,
                117
            ]),
            {
                13: $V9,
                16: $Va,
                44: 215,
                45: $V72,
                55: 220,
                82: $Vy,
                87: $Vb,
                89: $Vg1,
                172: 221,
                185: 351,
                203: 536,
                211: 626,
                212: 627,
                231: $V82,
                234: 535,
                236: 216,
                237: 222,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                309: $Vi1,
                310: $Vj1,
                311: 217,
                312: $Vk1
            },
            o($VT1, [
                2,
                134
            ]),
            o($Vb2, [
                2,
                427
            ]),
            o($VT1, [
                2,
                135
            ]),
            o($Vk2, [
                2,
                26
            ]),
            {
                44: 628,
                87: $Vb
            },
            o($Va2, [
                2,
                106
            ]),
            o($Va2, [
                2,
                394
            ]),
            o($Vk, [
                2,
                396
            ]),
            o($Vv2, [
                2,
                111
            ]),
            o($Vv2, [
                2,
                398
            ]),
            {
                13: $V9,
                16: $Va,
                44: 39,
                55: 40,
                87: $Vb,
                139: 342,
                186: 629,
                190: 340,
                195: 341,
                197: $VR1,
                307: 43,
                308: $Vc
            },
            o($VU1, [
                2,
                217
            ]),
            o($Vk, $Vr1, {
                144: 248,
                140: 630,
                143: 631,
                31: [
                    2,
                    343
                ]
            }),
            o($VB1, [
                2,
                97
            ]),
            o($VX1, [
                2,
                380
            ]),
            o($VB1, [
                2,
                180
            ]),
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 632,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            {
                13: $V9,
                16: $Va,
                44: 136,
                45: $Vx,
                46: 633,
                55: 133,
                67: 132,
                68: 134,
                77: 131,
                82: $Vy,
                87: $Vb,
                172: 135,
                224: $Vz,
                238: 121,
                239: 122,
                243: 123,
                247: 124,
                251: 125,
                255: 154,
                257: 155,
                259: 126,
                263: $VA,
                264: 130,
                265: $VB,
                266: 137,
                267: 139,
                268: $VC,
                269: $VD,
                270: $VE,
                271: $VF,
                273: $VG,
                274: $VH,
                275: 146,
                276: $VI,
                277: $VJ,
                278: 149,
                279: $VK,
                280: $VL,
                283: $VM,
                285: $VN,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V$,
                346: $V01,
                347: $V11,
                348: $V21,
                349: $V31,
                350: $V41,
                351: $V51
            },
            o($VB1, [
                2,
                190
            ]),
            {
                290: [
                    1,
                    634
                ]
            },
            {
                314: [
                    1,
                    635
                ]
            },
            {
                13: $V9,
                16: $Va,
                48: [
                    1,
                    636
                ],
                55: 414,
                82: $Vy,
                171: 637,
                172: 415,
                173: 416,
                174: $V02,
                255: 154,
                257: 155,
                291: 150,
                294: $VO,
                295: $VP,
                296: $VQ,
                297: $VR,
                298: $VS,
                299: $VT,
                300: $VU,
                301: $VV,
                302: $VW,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_,
                307: 43,
                308: $Vc,
                312: $V12
            },
            o($Vx2, [
                2,
                305
            ]),
            o($V61, [
                2,
                86
            ]),
            o($Vf2, [
                2,
                374
            ]),
            o($V32, [
                2,
                37
            ]),
            o($V32, [
                2,
                38
            ]),
            o($V62, [
                2,
                72
            ]),
            o($V62, [
                2,
                360
            ]),
            o($Vr2, [
                2,
                77
            ]),
            {
                29: $Vb1,
                57: 638
            },
            {
                47: [
                    1,
                    639
                ]
            },
            {
                29: [
                    2,
                    376
                ]
            },
            o($Vu2, [
                2,
                402
            ]),
            o($Vu2, [
                2,
                115
            ], {
                215: 10,
                208: 528,
                214: 529,
                44: 530,
                205: 640,
                13: $V3,
                16: $V3,
                45: $V3,
                197: $V3,
                224: $V3,
                229: $V3,
                308: $V3,
                87: $Vb
            }),
            o($Vu2, [
                2,
                118
            ], {
                272: [
                    1,
                    641
                ]
            }),
            o($Vy2, [
                2,
                407
            ], {
                213: 642,
                319: 643,
                317: [
                    1,
                    644
                ]
            }),
            {
                48: [
                    1,
                    645
                ]
            },
            {
                318: [
                    1,
                    646
                ]
            },
            {
                31: [
                    1,
                    647
                ]
            },
            {
                31: [
                    2,
                    344
                ]
            },
            {
                48: [
                    1,
                    648
                ]
            },
            {
                48: [
                    1,
                    649
                ]
            },
            {
                291: 650,
                303: $VX,
                304: $VY,
                305: $VZ,
                306: $V_
            },
            o($Ve2, [
                2,
                218
            ]),
            o($Vf2, [
                2,
                44
            ]),
            o($Vx2, [
                2,
                306
            ]),
            o($Vr2, [
                2,
                78
            ]),
            {
                44: 651,
                87: $Vb
            },
            o($Vu2, [
                2,
                116
            ]),
            o($Vk, [
                2,
                406
            ]),
            o($Vy2, [
                2,
                119
            ]),
            o($Vy2, [
                2,
                408
            ]),
            o($V6, $V3, {
                215: 10,
                205: 527,
                208: 528,
                214: 529,
                44: 530,
                202: 652,
                87: $Vb
            }),
            o($Vk2, [
                2,
                27
            ]),
            o($Vv2, [
                2,
                230
            ]),
            o($Vz2, [
                2,
                345
            ], {
                141: 653,
                335: [
                    1,
                    654
                ]
            }),
            o($VB1, [
                2,
                181
            ]),
            o($VB1, [
                2,
                182
            ]),
            {
                48: [
                    2,
                    191
                ]
            },
            {
                48: [
                    1,
                    655
                ]
            },
            {
                318: [
                    1,
                    656
                ]
            },
            o($Vk, $Vr1, {
                144: 248,
                142: 657,
                143: 658,
                31: $VA2,
                112: $VA2
            }),
            o($Vz2, [
                2,
                346
            ]),
            o($Vr2, [
                2,
                80
            ]),
            o($Vy2, [
                2,
                231
            ]),
            o($VW1, [
                2,
                67
            ]),
            o($VW1, [
                2,
                348
            ])
        ],
        defaultActions: {
            5: [
                2,
                240
            ],
            6: [
                2,
                241
            ],
            7: [
                2,
                242
            ],
            9: [
                2,
                239
            ],
            24: [
                2,
                1
            ],
            25: [
                2,
                2
            ],
            26: [
                2,
                244
            ],
            87: [
                2,
                282
            ],
            94: [
                2,
                384
            ],
            100: [
                2,
                45
            ],
            109: [
                2,
                325
            ],
            166: [
                2,
                458
            ],
            263: [
                2,
                439
            ],
            336: [
                2,
                258
            ],
            337: [
                2,
                101
            ],
            487: [
                2,
                461
            ],
            488: [
                2,
                462
            ],
            560: [
                2,
                468
            ],
            574: [
                2,
                17
            ],
            575: [
                2,
                276
            ],
            576: [
                2,
                18
            ],
            577: [
                2,
                278
            ],
            623: [
                2,
                376
            ],
            631: [
                2,
                344
            ],
            650: [
                2,
                191
            ]
        },
        parseError: function parseError(str, hash) {
            if (hash.recoverable) this.trace(str);
            else {
                var error = new Error(str);
                error.hash = hash;
                throw error;
            }
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], tstack = [], vstack = [
                null
            ], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            var args = lstack.slice.call(arguments, 1);
            var lexer = Object.create(this.lexer);
            var sharedState = {
                yy: {}
            };
            for(var k in this.yy)if (Object.prototype.hasOwnProperty.call(this.yy, k)) sharedState.yy[k] = this.yy[k];
            lexer.setInput(input, sharedState.yy);
            sharedState.yy.lexer = lexer;
            sharedState.yy.parser = this;
            if (typeof lexer.yylloc == "undefined") lexer.yylloc = {};
            var yyloc = lexer.yylloc;
            lstack.push(yyloc);
            var ranges = lexer.options && lexer.options.ranges;
            if (typeof sharedState.yy.parseError === "function") this.parseError = sharedState.yy.parseError;
            else this.parseError = Object.getPrototypeOf(this).parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            _token_stack: var lex = function() {
                var token;
                token = lexer.lex() || EOF;
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token;
            };
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == "undefined") symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === "undefined" || !action.length || !action[0]) {
                    var errStr = "";
                    expected = [];
                    for(p in table[state])if (this.terminals_[p] && p > TERROR) expected.push("'" + this.terminals_[p] + "'");
                    if (lexer.showPosition) errStr = "Parse error on line " + (yylineno + 1) + ":\n" + lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                    else errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == EOF ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                    this.parseError(errStr, {
                        text: lexer.match,
                        token: this.terminals_[symbol] || symbol,
                        line: lexer.yylineno,
                        loc: yyloc,
                        expected: expected
                    });
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(lexer.yytext);
                        lstack.push(lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = lexer.yyleng;
                            yytext = lexer.yytext;
                            yylineno = lexer.yylineno;
                            yyloc = lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.apply(yyval, [
                            yytext,
                            yyleng,
                            yylineno,
                            sharedState.yy,
                            action[1],
                            vstack,
                            lstack
                        ].concat(args));
                        if (typeof r !== "undefined") return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /*
    SPARQL parser in the Jison parser generator format.
  */ var Wildcard = (parcelRequire("jUw11")).Wildcard;
    // Common namespaces and entities
    var RDF = "http://www.w3.org/1999/02/22-rdf-syntax-ns#", RDF_TYPE = RDF + "type", RDF_FIRST = RDF + "first", RDF_REST = RDF + "rest", RDF_NIL = RDF + "nil", XSD = "http://www.w3.org/2001/XMLSchema#", XSD_INTEGER = XSD + "integer", XSD_DECIMAL = XSD + "decimal", XSD_DOUBLE = XSD + "double", XSD_BOOLEAN = XSD + "boolean";
    var base = "", basePath = "", baseRoot = "";
    // Returns a lowercase version of the given string
    function lowercase(string) {
        return string.toLowerCase();
    }
    // Appends the item to the array and returns the array
    function appendTo(array, item) {
        return array.push(item), array;
    }
    // Appends the items to the array and returns the array
    function appendAllTo(array, items) {
        return array.push.apply(array, items), array;
    }
    // Extends a base object with properties of other objects
    function extend(base) {
        if (!base) base = {};
        for(var i = 1, l = arguments.length, arg; i < l && (arg = arguments[i] || {}); i++)for(var name in arg)base[name] = arg[name];
        return base;
    }
    // Creates an array that contains all items of the given arrays
    function unionAll() {
        var union = [];
        for(var i = 0, l = arguments.length; i < l; i++)union = union.concat.apply(union, arguments[i]);
        return union;
    }
    // Resolves an IRI against a base path
    function resolveIRI(iri) {
        // Strip off possible angular brackets
        if (iri[0] === "<") iri = iri.substring(1, iri.length - 1);
        // Return absolute IRIs unmodified
        if (/^[a-z]+:/i.test(iri)) return iri;
        if (!Parser.base) throw new Error("Cannot resolve relative IRI " + iri + " because no base IRI was set.");
        if (base !== Parser.base) {
            base = Parser.base;
            basePath = base.replace(/[^\/:]*$/, "");
            baseRoot = base.match(/^(?:[a-z]+:\/*)?[^\/]*/)[0];
        }
        switch(iri[0]){
            // An empty relative IRI indicates the base IRI
            case undefined:
                return base;
            // Resolve relative fragment IRIs against the base IRI
            case "#":
                return base + iri;
            // Resolve relative query string IRIs by replacing the query string
            case "?":
                return base.replace(/(?:\?.*)?$/, iri);
            // Resolve root relative IRIs at the root of the base IRI
            case "/":
                return baseRoot + iri;
            // Resolve all other IRIs at the base IRI's path
            default:
                return basePath + iri;
        }
    }
    // If the item is a variable, ensures it starts with a question mark
    function toVar(variable) {
        if (variable) {
            var first = variable[0];
            if (first === "?" || first === "$") return Parser.factory.variable(variable.substr(1));
        }
        return variable;
    }
    // Creates an operation with the given name and arguments
    function operation(operatorName, args) {
        return {
            type: "operation",
            operator: operatorName,
            args: args || []
        };
    }
    // Creates an expression with the given type and attributes
    function expression(expr, attr) {
        var expression = {
            expression: expr === "*" ? new Wildcard() : expr
        };
        if (attr) for(var a in attr)expression[a] = attr[a];
        return expression;
    }
    // Creates a path with the given type and items
    function path(type, items) {
        return {
            type: "path",
            pathType: type,
            items: items
        };
    }
    // Transforms a list of operations types and arguments into a tree of operations
    function createOperationTree(initialExpression, operationList) {
        for(var i = 0, l = operationList.length, item; i < l && (item = operationList[i]); i++)initialExpression = operation(item[0], [
            initialExpression,
            item[1]
        ]);
        return initialExpression;
    }
    // Group datasets by default and named
    function groupDatasets(fromClauses, groupName) {
        var defaults = [], named = [], l = fromClauses.length, fromClause, group = {};
        if (!l) return null;
        for(var i = 0; i < l && (fromClause = fromClauses[i]); i++)(fromClause.named ? named : defaults).push(fromClause.iri);
        group[groupName || "from"] = {
            default: defaults,
            named: named
        };
        return group;
    }
    // Converts the string to a number
    function toInt(string) {
        return parseInt(string, 10);
    }
    // Transforms a possibly single group into its patterns
    function degroupSingle(group) {
        return group.type === "group" && group.patterns.length === 1 ? group.patterns[0] : group;
    }
    // Creates a literal with the given value and type
    function createTypedLiteral(value, type) {
        if (type && type.termType !== "NamedNode") type = Parser.factory.namedNode(type);
        return Parser.factory.literal(value, type);
    }
    // Creates a literal with the given value and language
    function createLangLiteral(value, lang) {
        return Parser.factory.literal(value, lang);
    }
    function nestedTriple(subject, predicate, object) {
        // TODO: Remove this when it is caught by the grammar
        if (!("termType" in predicate)) throw new Error("Nested triples cannot contain paths");
        return Parser.factory.quad(subject, predicate, object);
    }
    // Creates a triple with the given subject, predicate, and object
    function triple(subject, predicate, object, annotations) {
        var triple = {};
        if (subject != null) triple.subject = subject;
        if (predicate != null) triple.predicate = predicate;
        if (object != null) triple.object = object;
        if (annotations != null) triple.annotations = annotations;
        return triple;
    }
    // Creates a new blank node
    function blank(name) {
        if (typeof name === "string") {
            if (name.startsWith("e_")) return Parser.factory.blankNode(name);
            return Parser.factory.blankNode("e_" + name);
        }
        return Parser.factory.blankNode("g_" + blankId++);
    }
    var blankId = 0;
    Parser._resetBlanks = function() {
        blankId = 0;
    };
    // Regular expression and replacement strings to escape strings
    var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\(.)/g, escapeReplacements = {
        "\\": "\\",
        "'": "'",
        '"': '"',
        "t": "	",
        "b": "\b",
        "n": "\n",
        "r": "\r",
        "f": "\f"
    }, partialSurrogatesWithoutEndpoint = /[\uD800-\uDBFF]([^\uDC00-\uDFFF]|$)/, fromCharCode = String.fromCharCode;
    // Translates escape codes in the string into their textual equivalent
    function unescapeString(string, trimLength) {
        string = string.substring(trimLength, string.length - trimLength);
        try {
            string = string.replace(escapeSequence, function(sequence, unicode4, unicode8, escapedChar) {
                var charCode;
                if (unicode4) {
                    charCode = parseInt(unicode4, 16);
                    if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
                    return fromCharCode(charCode);
                } else if (unicode8) {
                    charCode = parseInt(unicode8, 16);
                    if (isNaN(charCode)) throw new Error(); // can never happen (regex), but helps performance
                    if (charCode < 0xFFFF) return fromCharCode(charCode);
                    return fromCharCode(0xD800 + ((charCode -= 0x10000) >> 10), 0xDC00 + (charCode & 0x3FF));
                } else {
                    var replacement = escapeReplacements[escapedChar];
                    if (!replacement) throw new Error();
                    return replacement;
                }
            });
        } catch (error) {
            return "";
        }
        // Test for invalid unicode surrogate pairs
        if (partialSurrogatesWithoutEndpoint.exec(string)) throw new Error("Invalid unicode codepoint of surrogate pair without corresponding codepoint in " + string);
        return string;
    }
    // Creates a list, collecting its (possibly blank) items and triples associated with those items
    function createList(objects) {
        var list = blank(), head = list, listItems = [], listTriples, triples = [];
        objects.forEach(function(o) {
            listItems.push(o.entity);
            appendAllTo(triples, o.triples);
        });
        // Build an RDF list out of the items
        for(var i = 0, j = 0, l = listItems.length, listTriples = Array(l * 2); i < l;)listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_FIRST), listItems[i]), listTriples[j++] = triple(head, Parser.factory.namedNode(RDF_REST), head = ++i < l ? blank() : Parser.factory.namedNode(RDF_NIL));
        // Return the list's identifier, its triples, and the triples associated with its items
        return {
            entity: list,
            triples: appendAllTo(listTriples, triples)
        };
    }
    // Creates a blank node identifier, collecting triples with that blank node as subject
    function createAnonymousObject(propertyList) {
        var entity = blank();
        return {
            entity: entity,
            triples: propertyList.map(function(t) {
                return extend(triple(entity), t);
            })
        };
    }
    // Collects all (possibly blank) objects, and triples that have them as subject
    function objectListToTriples(predicate, objectList, otherTriples) {
        var objects = [], triples = [];
        objectList.forEach(function(l) {
            let annotation = null;
            if (l.annotation) {
                annotation = l.annotation;
                l = l.object;
            }
            objects.push(triple(null, predicate, l.entity, annotation));
            appendAllTo(triples, l.triples);
        });
        return unionAll(objects, otherTriples || [], triples);
    }
    // Simplifies groups by merging adjacent BGPs
    function mergeAdjacentBGPs(groups) {
        var merged = [], currentBgp;
        for(var i = 0, group; group = groups[i]; i++)switch(group.type){
            // Add a BGP's triples to the current BGP
            case "bgp":
                if (group.triples.length) {
                    if (!currentBgp) appendTo(merged, currentBgp = group);
                    else appendAllTo(currentBgp.triples, group.triples);
                }
                break;
            // All other groups break up a BGP
            default:
                // Only add the group if its pattern is non-empty
                if (!group.patterns || group.patterns.length > 0) {
                    appendTo(merged, group);
                    currentBgp = null;
                }
        }
        return merged;
    }
    // Return the id of an expression
    function getExpressionId(expression) {
        return expression.variable ? expression.variable.value : expression.value || expression.expression.value;
    }
    // Get all "aggregate"'s from an expression
    function getAggregatesOfExpression(expression) {
        if (!expression) return [];
        if (expression.type === "aggregate") return [
            expression
        ];
        else if (expression.type === "operation") {
            const aggregates = [];
            for (const arg of expression.args)aggregates.push(...getAggregatesOfExpression(arg));
            return aggregates;
        }
        return [];
    }
    // Get all variables used in an expression
    function getVariablesFromExpression(expression) {
        const variables = new Set();
        const visitExpression = function(expr) {
            if (!expr) return;
            if (expr.termType === "Variable") variables.add(expr);
            else if (expr.type === "operation") expr.args.forEach(visitExpression);
        };
        visitExpression(expression);
        return variables;
    }
    // Helper function to flatten arrays
    function flatten(input, depth = 1, stack = []) {
        for (const item of input)if (depth > 0 && item instanceof Array) flatten(item, depth - 1, stack);
        else stack.push(item);
        return stack;
    }
    function isVariable(term) {
        return term.termType === "Variable";
    }
    function getBoundVarsFromGroupGraphPattern(pattern) {
        if (pattern.triples) {
            const boundVars = [];
            for (const triple of pattern.triples){
                if (isVariable(triple.subject)) boundVars.push(triple.subject.value);
                if (isVariable(triple.predicate)) boundVars.push(triple.predicate.value);
                if (isVariable(triple.object)) boundVars.push(triple.object.value);
            }
            return boundVars;
        } else if (pattern.patterns) {
            const boundVars = [];
            for (const pat of pattern.patterns)boundVars.push(...getBoundVarsFromGroupGraphPattern(pat));
            return boundVars;
        }
        return [];
    }
    // Helper function to find duplicates in array
    function getDuplicatesInArray(array) {
        const sortedArray = array.slice().sort();
        const duplicates = [];
        for(let i = 0; i < sortedArray.length - 1; i++)if (sortedArray[i + 1] == sortedArray[i]) duplicates.push(sortedArray[i]);
        return duplicates;
    }
    function ensureSparqlStar(value) {
        if (!Parser.sparqlStar) throw new Error("SPARQL-star support is not enabled");
        return value;
    }
    function _applyAnnotations(subject, annotations, arr) {
        for (const annotation of annotations){
            const t = triple(// If the annotation already has a subject then just push the
            // annotation to the upper scope as it is a blank node introduced
            // from a pattern like :s :p :o {| :p1 [ :p2 :o2; :p3 :o3 ] |}
            "subject" in annotation ? annotation.subject : subject, annotation.predicate, annotation.object);
            arr.push(t);
            if (annotation.annotations) _applyAnnotations(nestedTriple(subject, annotation.predicate, annotation.object), annotation.annotations, arr);
        }
    }
    function applyAnnotations(triples) {
        if (Parser.sparqlStar) {
            const newTriples = [];
            triples.forEach((t)=>{
                const s = triple(t.subject, t.predicate, t.object);
                newTriples.push(s);
                if (t.annotations) _applyAnnotations(nestedTriple(t.subject, t.predicate, t.object), t.annotations, newTriples);
            });
            return newTriples;
        }
        return triples;
    }
    function ensureSparqlStarNestedQuads(value) {
        if (!Parser.sparqlStarNestedQuads) throw new Error("Lenient SPARQL-star support with nested quads is not enabled");
        return value;
    }
    function ensureNoVariables(operations) {
        for (const operation of operations){
            if (operation.type === "graph" && operation.name.termType === "Variable") throw new Error("Detected illegal variable in GRAPH");
            if (operation.type === "bgp" || operation.type === "graph") for (const triple of operation.triples){
                if (triple.subject.termType === "Variable" || triple.predicate.termType === "Variable" || triple.object.termType === "Variable") throw new Error("Detected illegal variable in BGP");
            }
        }
        return operations;
    }
    function ensureNoBnodes(operations) {
        for (const operation of operations){
            if (operation.type === "bgp") for (const triple of operation.triples){
                if (triple.subject.termType === "BlankNode" || triple.predicate.termType === "BlankNode" || triple.object.termType === "BlankNode") throw new Error("Detected illegal blank node in BGP");
            }
        }
        return operations;
    }
    /* generated by jison-lex 0.3.4 */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            // resets the lexer, sets new input
            setInput: function(input, yy) {
                this.yy = yy || this.yy || {};
                this._input = input;
                this._more = this._backtrack = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = "";
                this.conditionStack = [
                    "INITIAL"
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            // consumes and returns one char from the input
            input: function() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            // unshifts one char (or a string) into the input
            unput: function(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                this.yyleng = this.yytext.length;
                return this;
            },
            // When called from action, caches matched text and appends it on next action
            more: function() {
                this._more = true;
                return this;
            },
            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
            reject: function() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
                return this;
            },
            // retain first n characters of the match
            less: function(n) {
                this.unput(this.match.slice(n));
            },
            // displays already matched input, i.e. for error messages
            pastInput: function() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? "..." : "") + past.substr(-20).replace(/\n/g, "");
            },
            // displays upcoming input, i.e. for error messages
            upcomingInput: function() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? "..." : "")).replace(/\n/g, "");
            },
            // displays the character position where the lexing error occurred, i.e. for error messages
            showPosition: function() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            // test the lexed token: return FALSE when not a match, otherwise return token
            test_match: function(match, indexed_rule) {
                var token, lines, backup;
                if (this.options.backtrack_lexer) {
                    // save context
                    backup = {
                        yylineno: this.yylineno,
                        yylloc: {
                            first_line: this.yylloc.first_line,
                            last_line: this.last_line,
                            first_column: this.yylloc.first_column,
                            last_column: this.yylloc.last_column
                        },
                        yytext: this.yytext,
                        match: this.match,
                        matches: this.matches,
                        matched: this.matched,
                        yyleng: this.yyleng,
                        offset: this.offset,
                        _more: this._more,
                        _input: this._input,
                        yy: this.yy,
                        conditionStack: this.conditionStack.slice(0),
                        done: this.done
                    };
                    if (this.options.ranges) backup.yylloc.range = this.yylloc.range.slice(0);
                }
                lines = match[0].match(/(?:\r\n?|\n).*/g);
                if (lines) this.yylineno += lines.length;
                this.yylloc = {
                    first_line: this.yylloc.last_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.last_column,
                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                };
                this.yytext += match[0];
                this.match += match[0];
                this.matches = match;
                this.yyleng = this.yytext.length;
                if (this.options.ranges) this.yylloc.range = [
                    this.offset,
                    this.offset += this.yyleng
                ];
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match[0].length);
                this.matched += match[0];
                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    return false; // rule action called reject() implying the next rule should be tested instead.
                }
                return false;
            },
            // return next match in input
            next: function() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) {
                    this.yytext = "";
                    this.match = "";
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rules[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = false;
                                continue; // rule action called reject() implying a rule MISmatch.
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rules[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError("Lexical error on line " + (this.yylineno + 1) + ". Unrecognized text.\n" + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            // return next match that has a token
            lex: function lex() {
                var r = this.next();
                if (r) return r;
                else return this.lex();
            },
            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            // pop the previously active lexer condition state off the condition stack
            popState: function popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) return this.conditionStack.pop();
                else return this.conditionStack[0];
            },
            // produce the lexer rule set which is active for the currently active lexer condition state
            _currentRules: function _currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
                else return this.conditions["INITIAL"].rules;
            },
            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
            topState: function topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            // alias for begin(condition)
            pushState: function pushState(condition) {
                this.begin(condition);
            },
            // return the number of states currently on the stack
            stateStackSize: function stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                "flex": true,
                "case-insensitive": true
            },
            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
                var YYSTATE = YY_START;
                switch($avoiding_name_collisions){
                    case 0:
                        break;
                    case 1:
                        return 12;
                    case 2:
                        return 15;
                    case 3:
                        return 41;
                    case 4:
                        return 325;
                    case 5:
                        return 326;
                    case 6:
                        return 45;
                    case 7:
                        return 47;
                    case 8:
                        return 48;
                    case 9:
                        return 39;
                    case 10:
                        return 24;
                    case 11:
                        return 28;
                    case 12:
                        return 29;
                    case 13:
                        return 31;
                    case 14:
                        return 32;
                    case 15:
                        return 36;
                    case 16:
                        return 53;
                    case 17:
                        return 327;
                    case 18:
                        return 63;
                    case 19:
                        return 64;
                    case 20:
                        return 70;
                    case 21:
                        return 73;
                    case 22:
                        return 76;
                    case 23:
                        return 78;
                    case 24:
                        return 81;
                    case 25:
                        return 83;
                    case 26:
                        return 85;
                    case 27:
                        return 193;
                    case 28:
                        return 100;
                    case 29:
                        return 328;
                    case 30:
                        return 121;
                    case 31:
                        return 329;
                    case 32:
                        return 330;
                    case 33:
                        return 110;
                    case 34:
                        return 331;
                    case 35:
                        return 109;
                    case 36:
                        return 332;
                    case 37:
                        return 333;
                    case 38:
                        return 113;
                    case 39:
                        return 115;
                    case 40:
                        return 116;
                    case 41:
                        return 131;
                    case 42:
                        return 123;
                    case 43:
                        return 126;
                    case 44:
                        return 128;
                    case 45:
                        return 132;
                    case 46:
                        return 112;
                    case 47:
                        return 334;
                    case 48:
                        return 335;
                    case 49:
                        return 159;
                    case 50:
                        return 161;
                    case 51:
                        return 164;
                    case 52:
                        return 174;
                    case 53:
                        return 160;
                    case 54:
                        return 336;
                    case 55:
                        return 163;
                    case 56:
                        return 312;
                    case 57:
                        return 314;
                    case 58:
                        return 317;
                    case 59:
                        return 318;
                    case 60:
                        return 272;
                    case 61:
                        return 197;
                    case 62:
                        return 337;
                    case 63:
                        return 338;
                    case 64:
                        return 229;
                    case 65:
                        return 340;
                    case 66:
                        return 263;
                    case 67:
                        return 224;
                    case 68:
                        return 231;
                    case 69:
                        return 232;
                    case 70:
                        return 242;
                    case 71:
                        return 246;
                    case 72:
                        return 290;
                    case 73:
                        return 341;
                    case 74:
                        return 342;
                    case 75:
                        return 343;
                    case 76:
                        return 344;
                    case 77:
                        return 345;
                    case 78:
                        return 250;
                    case 79:
                        return 346;
                    case 80:
                        return 265;
                    case 81:
                        return 276;
                    case 82:
                        return 277;
                    case 83:
                        return 268;
                    case 84:
                        return 269;
                    case 85:
                        return 270;
                    case 86:
                        return 271;
                    case 87:
                        return 347;
                    case 88:
                        return 348;
                    case 89:
                        return 273;
                    case 90:
                        return 274;
                    case 91:
                        return 350;
                    case 92:
                        return 349;
                    case 93:
                        return 351;
                    case 94:
                        return 279;
                    case 95:
                        return 280;
                    case 96:
                        return 283;
                    case 97:
                        return 285;
                    case 98:
                        return 289;
                    case 99:
                        return 293;
                    case 100:
                        return 296;
                    case 101:
                        return 13;
                    case 102:
                        return 16;
                    case 103:
                        return 308;
                    case 104:
                        return 309;
                    case 105:
                        return 87;
                    case 106:
                        return 292;
                    case 107:
                        return 82;
                    case 108:
                        return 294;
                    case 109:
                        return 295;
                    case 110:
                        return 297;
                    case 111:
                        return 298;
                    case 112:
                        return 299;
                    case 113:
                        return 300;
                    case 114:
                        return 301;
                    case 115:
                        return 302;
                    case 116:
                        return "EXPONENT";
                    case 117:
                        return 303;
                    case 118:
                        return 304;
                    case 119:
                        return 305;
                    case 120:
                        return 306;
                    case 121:
                        return 89;
                    case 122:
                        return 310;
                    case 123:
                        return 6;
                    case 124:
                        return "INVALID";
                    case 125:
                        console.log(yy_.yytext);
                        break;
                }
            },
            rules: [
                /^(?:\s+|(#[^\n\r]*))/i,
                /^(?:BASE)/i,
                /^(?:PREFIX)/i,
                /^(?:SELECT)/i,
                /^(?:DISTINCT)/i,
                /^(?:REDUCED)/i,
                /^(?:\()/i,
                /^(?:AS)/i,
                /^(?:\))/i,
                /^(?:\*)/i,
                /^(?:CONSTRUCT)/i,
                /^(?:WHERE)/i,
                /^(?:\{)/i,
                /^(?:\})/i,
                /^(?:DESCRIBE)/i,
                /^(?:ASK)/i,
                /^(?:FROM)/i,
                /^(?:NAMED)/i,
                /^(?:GROUP)/i,
                /^(?:BY)/i,
                /^(?:HAVING)/i,
                /^(?:ORDER)/i,
                /^(?:ASC)/i,
                /^(?:DESC)/i,
                /^(?:LIMIT)/i,
                /^(?:OFFSET)/i,
                /^(?:VALUES)/i,
                /^(?:;)/i,
                /^(?:LOAD)/i,
                /^(?:SILENT)/i,
                /^(?:INTO)/i,
                /^(?:CLEAR)/i,
                /^(?:DROP)/i,
                /^(?:CREATE)/i,
                /^(?:ADD)/i,
                /^(?:TO)/i,
                /^(?:MOVE)/i,
                /^(?:COPY)/i,
                /^(?:INSERT((\s+|(#[^\n\r]*)\n\r?)+)DATA)/i,
                /^(?:DELETE((\s+|(#[^\n\r]*)\n\r?)+)DATA)/i,
                /^(?:DELETE((\s+|(#[^\n\r]*)\n\r?)+)WHERE)/i,
                /^(?:WITH)/i,
                /^(?:DELETE)/i,
                /^(?:INSERT)/i,
                /^(?:USING)/i,
                /^(?:DEFAULT)/i,
                /^(?:GRAPH)/i,
                /^(?:ALL)/i,
                /^(?:\.)/i,
                /^(?:OPTIONAL)/i,
                /^(?:SERVICE)/i,
                /^(?:BIND)/i,
                /^(?:UNDEF)/i,
                /^(?:MINUS)/i,
                /^(?:UNION)/i,
                /^(?:FILTER)/i,
                /^(?:<<)/i,
                /^(?:>>)/i,
                /^(?:\{\|)/i,
                /^(?:\|\})/i,
                /^(?:,)/i,
                /^(?:a)/i,
                /^(?:\|)/i,
                /^(?:\/)/i,
                /^(?:\^)/i,
                /^(?:\?)/i,
                /^(?:\+)/i,
                /^(?:!)/i,
                /^(?:\[)/i,
                /^(?:\])/i,
                /^(?:\|\|)/i,
                /^(?:&&)/i,
                /^(?:=)/i,
                /^(?:!=)/i,
                /^(?:<)/i,
                /^(?:>)/i,
                /^(?:<=)/i,
                /^(?:>=)/i,
                /^(?:IN)/i,
                /^(?:NOT)/i,
                /^(?:-)/i,
                /^(?:BOUND)/i,
                /^(?:BNODE)/i,
                /^(?:(RAND|NOW|UUID|STRUUID))/i,
                /^(?:(LANG|DATATYPE|IRI|URI|ABS|CEIL|FLOOR|ROUND|STRLEN|STR|UCASE|LCASE|ENCODE_FOR_URI|YEAR|MONTH|DAY|HOURS|MINUTES|SECONDS|TIMEZONE|TZ|MD5|SHA1|SHA256|SHA384|SHA512|isIRI|isURI|isBLANK|isLITERAL|isNUMERIC))/i,
                /^(?:(SUBJECT|PREDICATE|OBJECT|isTRIPLE))/i,
                /^(?:(LANGMATCHES|CONTAINS|STRSTARTS|STRENDS|STRBEFORE|STRAFTER|STRLANG|STRDT|sameTerm))/i,
                /^(?:CONCAT)/i,
                /^(?:COALESCE)/i,
                /^(?:IF)/i,
                /^(?:TRIPLE)/i,
                /^(?:REGEX)/i,
                /^(?:SUBSTR)/i,
                /^(?:REPLACE)/i,
                /^(?:EXISTS)/i,
                /^(?:COUNT)/i,
                /^(?:SUM|MIN|MAX|AVG|SAMPLE)/i,
                /^(?:GROUP_CONCAT)/i,
                /^(?:SEPARATOR)/i,
                /^(?:\^\^)/i,
                /^(?:true|false)/i,
                /^(?:(<(?:[^<>\"\{\}\|\^`\\\u0000-\u0020])*>))/i,
                /^(?:((([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?)?:))/i,
                /^(?:(((([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?)?:)((?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|:|[0-9]|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.|:|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%))))*(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|:|((%([0-9A-Fa-f])([0-9A-Fa-f]))|(\\(_|~|\.|-|!|\$|&|'|\(|\)|\*|\+|,|;|=|\/|\?|#|@|%)))))?)))/i,
                /^(?:(_:(?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(?:(?:(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])|\.)*(((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|-|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040]))?))/i,
                /^(?:([\?\$]((?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9])(?:((?:([A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]|[\uD800-\uDB7F][\uDC00-\uDFFF])|_))|[0-9]|\u00B7|[\u0300-\u036F\u203F-\u2040])*)))/i,
                /^(?:(@[a-zA-Z]+(?:-[a-zA-Z0-9]+)*))/i,
                /^(?:([0-9]+))/i,
                /^(?:([0-9]*\.[0-9]+))/i,
                /^(?:([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+)))/i,
                /^(?:(\+([0-9]+)))/i,
                /^(?:(\+([0-9]*\.[0-9]+)))/i,
                /^(?:(\+([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,
                /^(?:(-([0-9]+)))/i,
                /^(?:(-([0-9]*\.[0-9]+)))/i,
                /^(?:(-([0-9]+\.[0-9]*([eE][+-]?[0-9]+)|\.([0-9])+([eE][+-]?[0-9]+)|([0-9])+([eE][+-]?[0-9]+))))/i,
                /^(?:([eE][+-]?[0-9]+))/i,
                /^(?:('(?:(?:[^\u0027\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])))*'))/i,
                /^(?:("(?:(?:[^\u0022\u005C\u000A\u000D])|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])))*"))/i,
                /^(?:('''(?:(?:'|'')?(?:[^'\\]|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f]))))*'''))/i,
                /^(?:("""(?:(?:"|"")?(?:[^\"\\]|(\\[tbnrf\\\"']|\\u([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])|\\U([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f])([0-9A-Fa-f]))))*"""))/i,
                /^(?:(\((\u0020|\u0009|\u000D|\u000A)*\)))/i,
                /^(?:(\[(\u0020|\u0009|\u000D|\u000A)*\]))/i,
                /^(?:$)/i,
                /^(?:.)/i,
                /^(?:.)/i
            ],
            conditions: {
                "INITIAL": {
                    "rules": [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39,
                        40,
                        41,
                        42,
                        43,
                        44,
                        45,
                        46,
                        47,
                        48,
                        49,
                        50,
                        51,
                        52,
                        53,
                        54,
                        55,
                        56,
                        57,
                        58,
                        59,
                        60,
                        61,
                        62,
                        63,
                        64,
                        65,
                        66,
                        67,
                        68,
                        69,
                        70,
                        71,
                        72,
                        73,
                        74,
                        75,
                        76,
                        77,
                        78,
                        79,
                        80,
                        81,
                        82,
                        83,
                        84,
                        85,
                        86,
                        87,
                        88,
                        89,
                        90,
                        91,
                        92,
                        93,
                        94,
                        95,
                        96,
                        97,
                        98,
                        99,
                        100,
                        101,
                        102,
                        103,
                        104,
                        105,
                        106,
                        107,
                        108,
                        109,
                        110,
                        111,
                        112,
                        113,
                        114,
                        115,
                        116,
                        117,
                        118,
                        119,
                        120,
                        121,
                        122,
                        123,
                        124,
                        125
                    ],
                    "inclusive": true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser;
}();
$26e61ff341e03f4b$exports = $26e61ff341e03f4b$var$SparqlParser;


var $03b19053b9503b86$require$Parser = $26e61ff341e03f4b$exports.Parser;
var $af61b920292f76e6$exports = {};
var $af61b920292f76e6$var$XSD_INTEGER = "http://www.w3.org/2001/XMLSchema#integer";
var $af61b920292f76e6$var$XSD_STRING = "http://www.w3.org/2001/XMLSchema#string";
function $af61b920292f76e6$var$Generator(options) {
    this._options = options = options || {};
    var prefixes = options.prefixes || {};
    this._prefixByIri = {};
    var prefixIris = [];
    for(var prefix in prefixes){
        var iri = prefixes[prefix];
        if ($af61b920292f76e6$var$isString(iri)) {
            this._prefixByIri[iri] = prefix;
            prefixIris.push(iri);
        }
    }
    var iriList = prefixIris.join("|").replace(/[\]\/\(\)\*\+\?\.\\\$]/g, "\\$&");
    this._prefixRegex = new RegExp("^(" + iriList + ")([a-zA-Z][\\-_a-zA-Z0-9]*)$");
    this._usedPrefixes = {};
    this._sparqlStar = options.sparqlStar;
    this._indent = $af61b920292f76e6$var$isString(options.indent) ? options.indent : "  ";
    this._newline = $af61b920292f76e6$var$isString(options.newline) ? options.newline : "\n";
    this._explicitDatatype = Boolean(options.explicitDatatype);
}
// Converts the parsed query object into a SPARQL query
$af61b920292f76e6$var$Generator.prototype.toQuery = function(q) {
    var query = "";
    if (q.queryType) query += q.queryType.toUpperCase() + " ";
    if (q.reduced) query += "REDUCED ";
    if (q.distinct) query += "DISTINCT ";
    if (q.variables) query += $af61b920292f76e6$var$mapJoin(q.variables, undefined, function(variable) {
        return $af61b920292f76e6$var$isTerm(variable) ? this.toEntity(variable) : "(" + this.toExpression(variable.expression) + " AS " + $af61b920292f76e6$var$variableToString(variable.variable) + ")";
    }, this) + " ";
    else if (q.template) query += this.group(q.template, true) + this._newline;
    if (q.from) query += this.graphs("FROM ", q.from.default) + this.graphs("FROM NAMED ", q.from.named);
    if (q.where) query += "WHERE " + this.group(q.where, true) + this._newline;
    if (q.updates) query += $af61b920292f76e6$var$mapJoin(q.updates, ";" + this._newline, this.toUpdate, this);
    if (q.group) query += "GROUP BY " + $af61b920292f76e6$var$mapJoin(q.group, undefined, function(it) {
        var result = $af61b920292f76e6$var$isTerm(it.expression) ? this.toEntity(it.expression) : "(" + this.toExpression(it.expression) + ")";
        return it.variable ? "(" + result + " AS " + $af61b920292f76e6$var$variableToString(it.variable) + ")" : result;
    }, this) + this._newline;
    if (q.having) query += "HAVING (" + $af61b920292f76e6$var$mapJoin(q.having, undefined, this.toExpression, this) + ")" + this._newline;
    if (q.order) query += "ORDER BY " + $af61b920292f76e6$var$mapJoin(q.order, undefined, function(it) {
        var expr = "(" + this.toExpression(it.expression) + ")";
        return !it.descending ? expr : "DESC " + expr;
    }, this) + this._newline;
    if (q.offset) query += "OFFSET " + q.offset + this._newline;
    if (q.limit) query += "LIMIT " + q.limit + this._newline;
    if (q.values) query += this.values(q);
    // stringify prefixes at the end to mark used ones
    query = this.baseAndPrefixes(q) + query;
    return query.trim();
};
$af61b920292f76e6$var$Generator.prototype.baseAndPrefixes = function(q) {
    var base = q.base ? "BASE <" + q.base + ">" + this._newline : "";
    var prefixes = "";
    for(var key in q.prefixes)if (this._options.allPrefixes || this._usedPrefixes[key]) prefixes += "PREFIX " + key + ": <" + q.prefixes[key] + ">" + this._newline;
    return base + prefixes;
};
// Converts the parsed SPARQL pattern into a SPARQL pattern
$af61b920292f76e6$var$Generator.prototype.toPattern = function(pattern) {
    var type = pattern.type || pattern instanceof Array && "array" || (pattern.subject && pattern.predicate && pattern.object ? "triple" : "");
    if (!(type in this)) throw new Error("Unknown entry type: " + type);
    return this[type](pattern);
};
$af61b920292f76e6$var$Generator.prototype.triple = function(t) {
    return this.toEntity(t.subject) + " " + this.toEntity(t.predicate) + " " + this.toEntity(t.object) + ".";
};
$af61b920292f76e6$var$Generator.prototype.array = function(items) {
    return $af61b920292f76e6$var$mapJoin(items, this._newline, this.toPattern, this);
};
$af61b920292f76e6$var$Generator.prototype.bgp = function(bgp) {
    return this.encodeTriples(bgp.triples);
};
$af61b920292f76e6$var$Generator.prototype.encodeTriples = function(triples) {
    if (!triples.length) return "";
    var parts = [], subject = undefined, predicate = undefined;
    for(var i = 0; i < triples.length; i++){
        var triple = triples[i];
        // Triple with different subject
        if (!$af61b920292f76e6$var$equalTerms(triple.subject, subject)) {
            // Terminate previous triple
            if (subject) parts.push("." + this._newline);
            subject = triple.subject;
            predicate = triple.predicate;
            parts.push(this.toEntity(subject), " ", this.toEntity(predicate));
        } else if (!$af61b920292f76e6$var$equalTerms(triple.predicate, predicate)) {
            predicate = triple.predicate;
            parts.push(";" + this._newline, this._indent, this.toEntity(predicate));
        } else parts.push(",");
        parts.push(" ", this.toEntity(triple.object));
    }
    parts.push(".");
    return parts.join("");
};
$af61b920292f76e6$var$Generator.prototype.graph = function(graph) {
    return "GRAPH " + this.toEntity(graph.name) + " " + this.group(graph);
};
$af61b920292f76e6$var$Generator.prototype.graphs = function(keyword, graphs) {
    return !graphs || graphs.length === 0 ? "" : $af61b920292f76e6$var$mapJoin(graphs, "", function(g) {
        return keyword + this.toEntity(g) + this._newline;
    }, this);
};
$af61b920292f76e6$var$Generator.prototype.group = function(group, inline) {
    group = inline !== true ? this.array(group.patterns || group.triples) : this.toPattern(group.type !== "group" ? group : group.patterns);
    return group.indexOf(this._newline) === -1 ? "{ " + group + " }" : "{" + this._newline + this.indent(group) + this._newline + "}";
};
$af61b920292f76e6$var$Generator.prototype.query = function(query) {
    return this.toQuery(query);
};
$af61b920292f76e6$var$Generator.prototype.filter = function(filter) {
    return "FILTER(" + this.toExpression(filter.expression) + ")";
};
$af61b920292f76e6$var$Generator.prototype.bind = function(bind) {
    return "BIND(" + this.toExpression(bind.expression) + " AS " + $af61b920292f76e6$var$variableToString(bind.variable) + ")";
};
$af61b920292f76e6$var$Generator.prototype.optional = function(optional) {
    return "OPTIONAL " + this.group(optional);
};
$af61b920292f76e6$var$Generator.prototype.union = function(union) {
    return $af61b920292f76e6$var$mapJoin(union.patterns, this._newline + "UNION" + this._newline, function(p) {
        return this.group(p, true);
    }, this);
};
$af61b920292f76e6$var$Generator.prototype.minus = function(minus) {
    return "MINUS " + this.group(minus);
};
$af61b920292f76e6$var$Generator.prototype.values = function(valuesList) {
    // Gather unique keys
    var keys = Object.keys(valuesList.values.reduce(function(keyHash, values) {
        for(var key in values)keyHash[key] = true;
        return keyHash;
    }, {}));
    // Check whether simple syntax can be used
    var lparen, rparen;
    if (keys.length === 1) lparen = rparen = "";
    else {
        lparen = "(";
        rparen = ")";
    }
    // Create value rows
    return "VALUES " + lparen + keys.join(" ") + rparen + " {" + this._newline + $af61b920292f76e6$var$mapJoin(valuesList.values, this._newline, function(values) {
        return "  " + lparen + $af61b920292f76e6$var$mapJoin(keys, undefined, function(key) {
            return values[key] ? this.toEntity(values[key]) : "UNDEF";
        }, this) + rparen;
    }, this) + this._newline + "}";
};
$af61b920292f76e6$var$Generator.prototype.service = function(service) {
    return "SERVICE " + (service.silent ? "SILENT " : "") + this.toEntity(service.name) + " " + this.group(service);
};
// Converts the parsed expression object into a SPARQL expression
$af61b920292f76e6$var$Generator.prototype.toExpression = function(expr) {
    if ($af61b920292f76e6$var$isTerm(expr)) return this.toEntity(expr);
    switch(expr.type.toLowerCase()){
        case "aggregate":
            return expr.aggregation.toUpperCase() + "(" + (expr.distinct ? "DISTINCT " : "") + this.toExpression(expr.expression) + (typeof expr.separator === "string" ? '; SEPARATOR = "' + expr.separator.replace($af61b920292f76e6$var$escape, $af61b920292f76e6$var$escapeReplacer) + '"' : "") + ")";
        case "functioncall":
            return this.toEntity(expr.function) + "(" + $af61b920292f76e6$var$mapJoin(expr.args, ", ", this.toExpression, this) + ")";
        case "operation":
            var operator = expr.operator.toUpperCase(), args = expr.args || [];
            switch(expr.operator.toLowerCase()){
                // Infix operators
                case "<":
                case ">":
                case ">=":
                case "<=":
                case "&&":
                case "||":
                case "=":
                case "!=":
                case "+":
                case "-":
                case "*":
                case "/":
                    return ($af61b920292f76e6$var$isTerm(args[0]) ? this.toEntity(args[0]) : "(" + this.toExpression(args[0]) + ")") + " " + operator + " " + ($af61b920292f76e6$var$isTerm(args[1]) ? this.toEntity(args[1]) : "(" + this.toExpression(args[1]) + ")");
                // Unary operators
                case "!":
                    return "!(" + this.toExpression(args[0]) + ")";
                case "uplus":
                    return "+(" + this.toExpression(args[0]) + ")";
                case "uminus":
                    return "-(" + this.toExpression(args[0]) + ")";
                // IN and NOT IN
                case "notin":
                    operator = "NOT IN";
                case "in":
                    return this.toExpression(args[0]) + " " + operator + "(" + ($af61b920292f76e6$var$isString(args[1]) ? args[1] : $af61b920292f76e6$var$mapJoin(args[1], ", ", this.toExpression, this)) + ")";
                // EXISTS and NOT EXISTS
                case "notexists":
                    operator = "NOT EXISTS";
                case "exists":
                    return operator + " " + this.group(args[0], true);
                // Other expressions
                default:
                    return operator + "(" + $af61b920292f76e6$var$mapJoin(args, ", ", this.toExpression, this) + ")";
            }
        default:
            throw new Error("Unknown expression type: " + expr.type);
    }
};
// Converts the parsed entity (or property path) into a SPARQL entity
$af61b920292f76e6$var$Generator.prototype.toEntity = function(value) {
    if ($af61b920292f76e6$var$isTerm(value)) switch(value.termType){
        // variable, * selector, or blank node
        case "Wildcard":
            return "*";
        case "Variable":
            return $af61b920292f76e6$var$variableToString(value);
        case "BlankNode":
            return "_:" + value.value;
        // literal
        case "Literal":
            var lexical = value.value || "", language = value.language || "", datatype = value.datatype;
            value = '"' + lexical.replace($af61b920292f76e6$var$escape, $af61b920292f76e6$var$escapeReplacer) + '"';
            if (language) value += "@" + language;
            else if (datatype) {
                // Abbreviate literals when possible
                if (!this._explicitDatatype) switch(datatype.value){
                    case $af61b920292f76e6$var$XSD_STRING:
                        return value;
                    case $af61b920292f76e6$var$XSD_INTEGER:
                        if (/^\d+$/.test(lexical)) // Add space to avoid confusion with decimals in broken parsers
                        return lexical + " ";
                }
                value += "^^" + this.encodeIRI(datatype.value);
            }
            return value;
        case "Quad":
            if (!this._sparqlStar) throw new Error("SPARQL* support is not enabled");
            if (value.graph && value.graph.termType !== "DefaultGraph") return "<< GRAPH " + this.toEntity(value.graph) + " { " + this.toEntity(value.subject) + " " + this.toEntity(value.predicate) + " " + this.toEntity(value.object) + " } " + " >>";
            else return "<< " + this.toEntity(value.subject) + " " + this.toEntity(value.predicate) + " " + this.toEntity(value.object) + " >>";
        // IRI
        default:
            return this.encodeIRI(value.value);
    }
    else {
        var items = value.items.map(this.toEntity, this), path = value.pathType;
        switch(path){
            // prefix operator
            case "^":
            case "!":
                return path + items[0];
            // postfix operator
            case "*":
            case "+":
            case "?":
                return "(" + items[0] + path + ")";
            // infix operator
            default:
                return "(" + items.join(path) + ")";
        }
    }
};
var $af61b920292f76e6$var$escape = /["\\\t\n\r\b\f]/g, $af61b920292f76e6$var$escapeReplacer = function(c) {
    return $af61b920292f76e6$var$escapeReplacements[c];
}, $af61b920292f76e6$var$escapeReplacements = {
    "\\": "\\\\",
    '"': '\\"',
    "	": "\\t",
    "\n": "\\n",
    "\r": "\\r",
    "\b": "\\b",
    "\f": "\\f"
};
// Represent the IRI, as a prefixed name when possible
$af61b920292f76e6$var$Generator.prototype.encodeIRI = function(iri) {
    var prefixMatch = this._prefixRegex.exec(iri);
    if (prefixMatch) {
        var prefix = this._prefixByIri[prefixMatch[1]];
        this._usedPrefixes[prefix] = true;
        return prefix + ":" + prefixMatch[2];
    }
    return "<" + iri + ">";
};
// Converts the parsed update object into a SPARQL update clause
$af61b920292f76e6$var$Generator.prototype.toUpdate = function(update) {
    switch(update.type || update.updateType){
        case "load":
            return "LOAD" + (update.source ? " " + this.toEntity(update.source) : "") + (update.destination ? " INTO GRAPH " + this.toEntity(update.destination) : "");
        case "insert":
            return "INSERT DATA " + this.group(update.insert, true);
        case "delete":
            return "DELETE DATA " + this.group(update.delete, true);
        case "deletewhere":
            return "DELETE WHERE " + this.group(update.delete, true);
        case "insertdelete":
            return (update.graph ? "WITH " + this.toEntity(update.graph) + this._newline : "") + (update.delete.length ? "DELETE " + this.group(update.delete, true) + this._newline : "") + (update.insert.length ? "INSERT " + this.group(update.insert, true) + this._newline : "") + (update.using ? this.graphs("USING ", update.using.default) : "") + (update.using ? this.graphs("USING NAMED ", update.using.named) : "") + "WHERE " + this.group(update.where, true);
        case "add":
        case "copy":
        case "move":
            return update.type.toUpperCase() + " " + (update.silent ? "SILENT " : "") + (update.source.default ? "DEFAULT" : this.toEntity(update.source.name)) + " TO " + this.toEntity(update.destination.name);
        case "create":
        case "clear":
        case "drop":
            return update.type.toUpperCase() + (update.silent ? " SILENT " : " ") + (update.graph.default ? "DEFAULT" : update.graph.named ? "NAMED" : update.graph.all ? "ALL" : "GRAPH " + this.toEntity(update.graph.name));
        default:
            throw new Error("Unknown update query type: " + update.type);
    }
};
// Indents each line of the string
$af61b920292f76e6$var$Generator.prototype.indent = function(text) {
    return text.replace(/^/gm, this._indent);
};
function $af61b920292f76e6$var$variableToString(variable) {
    return "?" + variable.value;
}
// Checks whether the object is a string
function $af61b920292f76e6$var$isString(object) {
    return typeof object === "string";
}
// Checks whether the object is a Term
function $af61b920292f76e6$var$isTerm(object) {
    return typeof object.termType === "string";
}
// Checks whether term1 and term2 are equivalent without `.equals()` prototype method
function $af61b920292f76e6$var$equalTerms(term1, term2) {
    if (!term1 || !$af61b920292f76e6$var$isTerm(term1)) return false;
    if (!term2 || !$af61b920292f76e6$var$isTerm(term2)) return false;
    if (term1.termType !== term2.termType) return false;
    switch(term1.termType){
        case "Literal":
            return term1.value === term2.value && term1.language === term2.language && $af61b920292f76e6$var$equalTerms(term1.datatype, term2.datatype);
        case "Quad":
            return $af61b920292f76e6$var$equalTerms(term1.subject, term2.subject) && $af61b920292f76e6$var$equalTerms(term1.predicate, term2.predicate) && $af61b920292f76e6$var$equalTerms(term1.object, term2.object) && $af61b920292f76e6$var$equalTerms(term1.graph, term2.graph);
        default:
            return term1.value === term2.value;
    }
}
// Maps the array with the given function, and joins the results using the separator
function $af61b920292f76e6$var$mapJoin(array, sep, func, self) {
    return array.map(func, self).join($af61b920292f76e6$var$isString(sep) ? sep : " ");
}
/**
 * @param options {
 *   allPrefixes: boolean,
 *   indentation: string,
 *   newline: string
 * }
 */ $af61b920292f76e6$exports = function SparqlGenerator(options = {}) {
    return {
        stringify: function(query) {
            var currentOptions = Object.create(options);
            currentOptions.prefixes = query.prefixes;
            return new $af61b920292f76e6$var$Generator(currentOptions).toQuery(query);
        },
        createGenerator: function() {
            return new $af61b920292f76e6$var$Generator(options);
        }
    };
};



var $jUw11 = parcelRequire("jUw11");
var $03b19053b9503b86$require$Wildcard = $jUw11.Wildcard;
var $fbdcb90cff43807c$exports = {};
"use strict";
var $fbdcb90cff43807c$var$__createBinding = $fbdcb90cff43807c$exports && $fbdcb90cff43807c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fbdcb90cff43807c$var$__exportStar = $fbdcb90cff43807c$exports && $fbdcb90cff43807c$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fbdcb90cff43807c$var$__createBinding(exports1, m, p);
};
Object.defineProperty($fbdcb90cff43807c$exports, "__esModule", {
    value: true
});

$fbdcb90cff43807c$var$__exportStar((parcelRequire("dUwlf")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("3wL3n")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("0UUif")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("8RsDA")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("7KJsK")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("1k2AX")), $fbdcb90cff43807c$exports);

$fbdcb90cff43807c$var$__exportStar((parcelRequire("kNA9K")), $fbdcb90cff43807c$exports);


var $03b19053b9503b86$require$DataFactory = $fbdcb90cff43807c$exports.DataFactory;
$03b19053b9503b86$exports = {
    /**
   * Creates a SPARQL parser with the given pre-defined prefixes and base IRI
   * @param options {
   *   prefixes?: { [prefix: string]: string },
   *   baseIRI?: string,
   *   factory?: import('rdf-js').DataFactory,
   *   sparqlStar?: boolean,
   *   skipValidation?: boolean,
   *   skipUngroupedVariableCheck?: boolean
   * }
   */ Parser: function({ prefixes: prefixes, baseIRI: baseIRI, factory: factory, sparqlStar: sparqlStar, skipValidation: skipValidation, skipUngroupedVariableCheck: skipUngroupedVariableCheck, pathOnly: pathOnly } = {}) {
        // Create a copy of the prefixes
        var prefixesCopy = {};
        for(var prefix in prefixes || {})prefixesCopy[prefix] = prefixes[prefix];
        // Create a new parser with the given prefixes
        // (Workaround for https://github.com/zaach/jison/issues/241)
        var parser = new $03b19053b9503b86$require$Parser();
        parser.parse = function() {
            $03b19053b9503b86$require$Parser.base = baseIRI || "";
            $03b19053b9503b86$require$Parser.prefixes = Object.create(prefixesCopy);
            $03b19053b9503b86$require$Parser.factory = factory || new $03b19053b9503b86$require$DataFactory();
            $03b19053b9503b86$require$Parser.sparqlStar = Boolean(sparqlStar);
            $03b19053b9503b86$require$Parser.pathOnly = Boolean(pathOnly);
            // We keep skipUngroupedVariableCheck for compatibility reasons.
            $03b19053b9503b86$require$Parser.skipValidation = Boolean(skipValidation) || Boolean(skipUngroupedVariableCheck);
            return $03b19053b9503b86$require$Parser.prototype.parse.apply(parser, arguments);
        };
        parser._resetBlanks = $03b19053b9503b86$require$Parser._resetBlanks;
        return parser;
    },
    Generator: $af61b920292f76e6$exports,
    Wildcard: $03b19053b9503b86$require$Wildcard
};



const $35459c07cd7570af$var$defaultQueryPaginationSize = 250;
let $35459c07cd7570af$export$91240bce4e364bef = 60000;
function $35459c07cd7570af$export$7fc4ea9a72a632dc(url, header = {}, method = "GET", query = "", numTry = 0) {
    let myHeaders = {};
    myHeaders["pragma"] = "no-cache";
    myHeaders["cache-control"] = "no-cache";
    Object.keys(header).forEach((key)=>{
        myHeaders[key] = header[key];
    });
    let myInit = {
        method: method,
        headers: myHeaders,
        redirect: "follow"
    };
    if (method.localeCompare("POST") == 0) myInit.body = query;
    return fetch(url, myInit).then((response)=>{
        if (response.ok) return response.blob().then((blob)=>blob.text());
        else throw response;
    }).catch((error)=>{
        console.error("Error during fetch", error);
    });
}
function $35459c07cd7570af$export$a6e59c03a779ef88(url, header = {}) {
    return new Promise((resolve, reject)=>{
        let request = new XMLHttpRequest();
        request.open("GET", url);
        let myHeaders = {};
        // myHeaders["pragma"] = "no-cache";
        // myHeaders["cache-control"] = "no-cache";
        Object.keys(header).forEach((key)=>{
            myHeaders[key] = header[key];
        });
        Object.keys(myHeaders).forEach((key)=>{
            request.setRequestHeader(key, myHeaders[key]);
        });
        request.onreadystatechange = ()=>{
            if (request.readyState == 4) {
                if (request.status == 200) resolve(request.responseText);
                else reject(request.status);
            }
        };
        request.send();
    });
}
function $35459c07cd7570af$export$3233bfa38a51357e(url, query = "", header = {}) {
    return $35459c07cd7570af$export$7fc4ea9a72a632dc(url, header, "POST", query);
}
function $35459c07cd7570af$export$230442c21b56ff1e(url, otherHeaders = {}) {
    let header = {};
    header["accept"] = "application/json";
    Object.keys(otherHeaders).forEach((key)=>{
        header[key] = otherHeaders[key];
    });
    return $35459c07cd7570af$export$a6e59c03a779ef88(url, header).then((response)=>{
        if (response == null || response == undefined || response == "") return {};
        else try {
            return JSON.parse(response);
        } catch (error) {
            console.error(url, error, response);
            throw error;
        }
    });
}
function $35459c07cd7570af$export$d37bf5547347f960(endpoint, query, timeout = $35459c07cd7570af$export$91240bce4e364bef) {
    let jsonHeaders = {};
    jsonHeaders["Accept"] = "application/sparql-results+json";
    if ($35459c07cd7570af$export$3cdb12c099e58bd1(query)) return $35459c07cd7570af$export$230442c21b56ff1e(endpoint + "?query=" + encodeURIComponent(query) + "&format=json&timeout=" + timeout, jsonHeaders).catch((error)=>{
        console.error(endpoint, query, error);
        throw error;
    });
    else if ($35459c07cd7570af$export$6fc7ccfd73d62d6(query)) return $35459c07cd7570af$export$230442c21b56ff1e(endpoint + "?query=" + encodeURIComponent(query) + "&format=json&timeout=" + timeout, jsonHeaders).catch(()=>{
        return {
            boolean: false
        };
    });
    else if ($35459c07cd7570af$export$8b54a6cc6363eda0(query) || $35459c07cd7570af$export$e96226776349d85c(query)) return $35459c07cd7570af$export$a6e59c03a779ef88(endpoint + "?query=" + encodeURIComponent(query) + "&format=turtle&timeout=" + timeout).then((result)=>{
        let resultStore = $5605c1058d66d37f$export$f51a9068ac82ea43();
        result = $5605c1058d66d37f$export$e42ce4998cf68d98(result);
        return $5605c1058d66d37f$export$968deea481412d5d(result, resultStore).catch((error)=>{
            console.error(endpoint, query, error, result);
            return;
        });
    }).catch((error)=>{
        console.error(endpoint, query, error);
        throw error;
    });
    else console.error(new Error("Unexpected query type"));
}
function $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, queryType) {
    let parser = new (0, (/*@__PURE__*/$parcel$interopDefault($03b19053b9503b86$exports))).Parser();
    try {
        const parsedQuery = parser.parse(queryString);
        if (parsedQuery.queryType != undefined) return parsedQuery.queryType.localeCompare(queryType) == 0;
        else if (parsedQuery.type != undefined) return parsedQuery.type.localeCompare(queryType) == 0;
        else throw new Error("No expected query type property : " + JSON.stringify(parsedQuery));
    } catch (error) {
        console.error(queryString, error);
    }
}
function $35459c07cd7570af$export$8b54a6cc6363eda0(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "CONSTRUCT");
}
function $35459c07cd7570af$export$3cdb12c099e58bd1(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "SELECT");
}
function $35459c07cd7570af$export$6fc7ccfd73d62d6(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "ASK");
}
function $35459c07cd7570af$export$e96226776349d85c(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "DESCRIBE");
}
function $35459c07cd7570af$export$25d0fe831c5dfff3(queryString) {
    return $35459c07cd7570af$export$2ffe62e6fe70d843(queryString, "update");
}
function $35459c07cd7570af$export$47ed34a15a70bfcf(query) {
    return query.queryType !== undefined && query.queryType === "SELECT";
}
function $35459c07cd7570af$export$b8aa98064b7724c5(query) {
    return query.queryType !== undefined && query.queryType === "ASK";
}
function $35459c07cd7570af$export$f9883ba9a52b1c20(query) {
    return query.queryType !== undefined && query.queryType === "CONSTRUCT";
}
function $35459c07cd7570af$export$d8400edf95116ba7(query) {
    return query.queryType !== undefined && query.queryType === "DESCRIBE";
}
function $35459c07cd7570af$export$90b40f9476038ea6(query) {
    return query.type !== undefined && query.type === "update";
}
function $35459c07cd7570af$export$39dfa61b343cea87(endpointUrl, query, pageSize = $35459c07cd7570af$var$defaultQueryPaginationSize, iteration, timeout, finalResult) {
    let generator = new (0, (/*@__PURE__*/$parcel$interopDefault($03b19053b9503b86$exports))).Generator();
    let parser = new (0, (/*@__PURE__*/$parcel$interopDefault($03b19053b9503b86$exports))).Parser();
    if (iteration == undefined) iteration = 0;
    if (timeout == undefined) timeout = $35459c07cd7570af$export$91240bce4e364bef;
    let queryObject = parser.parse(query);
    if ($35459c07cd7570af$export$3cdb12c099e58bd1(query)) {
        if (finalResult == undefined) finalResult = [];
    } else if ($35459c07cd7570af$export$8b54a6cc6363eda0(query)) {
        if (finalResult == undefined) finalResult = $5605c1058d66d37f$export$f51a9068ac82ea43();
    }
    if ($35459c07cd7570af$export$47ed34a15a70bfcf(queryObject)) {
        // We add the OFFSET and LIMIT to the query
        queryObject.offset = iteration * pageSize;
        queryObject.limit = pageSize;
    }
    let generatedQuery = generator.stringify(queryObject);
    // We send the paginated CONSTRUCT query
    return $35459c07cd7570af$export$d37bf5547347f960(endpointUrl, generatedQuery, timeout).then((generatedQueryResult)=>{
        if (generatedQueryResult !== undefined) {
            if ($35459c07cd7570af$export$3cdb12c099e58bd1(query)) try {
                let parsedSelectQueryResult = generatedQueryResult;
                finalResult = finalResult.concat(parsedSelectQueryResult["results"].bindings);
                if (parsedSelectQueryResult["results"].bindings.length > 0) return $35459c07cd7570af$export$39dfa61b343cea87(endpointUrl, query, pageSize, iteration + 1, timeout, finalResult);
                else return finalResult;
            } catch (error) {
                console.error("Error while parsing the query result as SELECT result: ", error, generatedQueryResult);
                throw error;
            }
            else if ($35459c07cd7570af$export$8b54a6cc6363eda0(query)) {
                finalResult.addAll(generatedQueryResult.statements);
                if (generatedQueryResult.statements.length > 0) return $35459c07cd7570af$export$39dfa61b343cea87(endpointUrl, query, pageSize, iteration + 1, timeout, finalResult);
                else return finalResult;
            } else return finalResult;
        } else return finalResult;
    }).catch((error)=>{
        console.error("Error while paginating the query: ", error);
        throw error;
    }).finally(()=>{
        return finalResult;
    });
}
function $35459c07cd7570af$export$4282b215e95fd9cb(settledPromisesResult) {
    return settledPromisesResult.map((promiseResult)=>{
        if (promiseResult.status === "fulfilled") return promiseResult.value;
        else return undefined;
    });
}



var $gCJkd = parcelRequire("gCJkd");
var $161b08292747466e$exports = {};
$161b08292747466e$exports = JSON.parse('{"lang":[{"label":"English","value":"en"},{"label":"Chinese","value":"zh"},{"label":"Hindi","value":"hi"},{"label":"Spanish","value":"es"},{"label":"French","value":"fr"},{"label":"Arabic","value":"ar"},{"label":"Bengali (Bangla)","value":"bn"},{"label":"Portuguese","value":"pt"},{"label":"Russian","value":"ru"},{"label":"Japanese","value":"ja"},{"label":"Indonesian","value":"id, in"},{"label":"Abkhazian","value":"ab"},{"label":"Afar","value":"aa"},{"label":"Afrikaans","value":"af"},{"label":"Akan","value":"ak"},{"label":"Albanian","value":"sq"},{"label":"Amharic","value":"am"},{"label":"Aragonese","value":"an"},{"label":"Armenian","value":"hy"},{"label":"Assamese","value":"as"},{"label":"Avaric","value":"av"},{"label":"Avestan","value":"ae"},{"label":"Aymara","value":"ay"},{"label":"Azerbaijani","value":"az"},{"label":"Bambara","value":"bm"},{"label":"Bashkir","value":"ba"},{"label":"Basque","value":"eu"},{"label":"Belarusian","value":"be"},{"label":"Bihari","value":"bh"},{"label":"Bislama","value":"bi"},{"label":"Bosnian","value":"bs"},{"label":"Breton","value":"br"},{"label":"Bulgarian","value":"bg"},{"label":"Burmese","value":"my"},{"label":"Catalan","value":"ca"},{"label":"Chamorro","value":"ch"},{"label":"Chechen","value":"ce"},{"label":"Chichewa, Chewa, Nyanja","value":"ny"},{"label":"Chinese (Simplified)","value":"zh-Hans"},{"label":"Chinese (Traditional)","value":"zh-Hant"},{"label":"Chuvash","value":"cv"},{"label":"Cornish","value":"kw"},{"label":"Corsican","value":"co"},{"label":"Cree","value":"cr"},{"label":"Croatian","value":"hr"},{"label":"Czech","value":"cs"},{"label":"Danish","value":"da"},{"label":"Divehi, Dhivehi, Maldivian","value":"dv"},{"label":"Dutch","value":"nl"},{"label":"Dzongkha","value":"dz"},{"label":"Esperanto","value":"eo"},{"label":"Estonian","value":"et"},{"label":"Ewe","value":"ee"},{"label":"Faroese","value":"fo"},{"label":"Fijian","value":"fj"},{"label":"Finnish","value":"fi"},{"label":"Fula, Fulah, Pulaar, Pular","value":"ff"},{"label":"Galician","value":"gl"},{"label":"Gaelic (Scottish)","value":"gd"},{"label":"Gaelic (Manx)","value":"gv"},{"label":"Georgian","value":"ka"},{"label":"German","value":"de"},{"label":"Greek","value":"el"},{"label":"Greenlandic","value":"kl"},{"label":"Guarani","value":"gn"},{"label":"Gujarati","value":"gu"},{"label":"Haitian Creole","value":"ht"},{"label":"Hausa","value":"ha"},{"label":"Hebrew","value":"he"},{"label":"Herero","value":"hz"},{"label":"Hiri Motu","value":"ho"},{"label":"Hungarian","value":"hu"},{"label":"Icelandic","value":"is"},{"label":"Ido","value":"io"},{"label":"Igbo","value":"ig"},{"label":"Interlingua","value":"ia"},{"label":"Interlingue","value":"ie"},{"label":"Inuktitut","value":"iu"},{"label":"Inupiak","value":"ik"},{"label":"Irish","value":"ga"},{"label":"Italian","value":"it"},{"label":"Javanese","value":"jv"},{"label":"Kalaallisut, Greenlandic","value":"kl"},{"label":"Kannada","value":"kn"},{"label":"Kanuri","value":"kr"},{"label":"Kashmiri","value":"ks"},{"label":"Kazakh","value":"kk"},{"label":"Khmer","value":"km"},{"label":"Kikuyu","value":"ki"},{"label":"Kinyarwanda (Rwanda)","value":"rw"},{"label":"Kirundi","value":"rn"},{"label":"Kyrgyz","value":"ky"},{"label":"Komi","value":"kv"},{"label":"Kongo","value":"kg"},{"label":"Korean","value":"ko"},{"label":"Kurdish","value":"ku"},{"label":"Kwanyama","value":"kj"},{"label":"Lao","value":"lo"},{"label":"Latin","value":"la"},{"label":"Latvian (Lettish)","value":"lv"},{"label":"Limburgish ( Limburger)","value":"li"},{"label":"Lingala","value":"ln"},{"label":"Lithuanian","value":"lt"},{"label":"Luga-Katanga","value":"lu"},{"label":"Luganda, Ganda","value":"lg"},{"label":"Luxembourgish","value":"lb"},{"label":"Manx","value":"gv"},{"label":"Macedonian","value":"mk"},{"label":"Malagasy","value":"mg"},{"label":"Malay","value":"ms"},{"label":"Malayalam","value":"ml"},{"label":"Maltese","value":"mt"},{"label":"Maori","value":"mi"},{"label":"Marathi","value":"mr"},{"label":"Marshallese","value":"mh"},{"label":"Moldavian","value":"mo"},{"label":"Mongolian","value":"mn"},{"label":"Nauru","value":"na"},{"label":"Navajo","value":"nv"},{"label":"Ndonga","value":"ng"},{"label":"Northern Ndebele","value":"nd"},{"label":"Nepali","value":"ne"},{"label":"Norwegian","value":"no"},{"label":"Norwegian bokm\xe5l","value":"nb"},{"label":"Norwegian nynorsk","value":"nn"},{"label":"Nuosu","value":"ii"},{"label":"Occitan","value":"oc"},{"label":"Ojibwe","value":"oj"},{"label":"Old Church Slavonic, Old Bulgarian","value":"cu"},{"label":"Oriya","value":"or"},{"label":"Oromo (Afaan Oromo)","value":"om"},{"label":"Ossetian","value":"os"},{"label":"P\u0101li","value":"pi"},{"label":"Pashto, Pushto","value":"ps"},{"label":"Persian (Farsi)","value":"fa"},{"label":"Polish","value":"pl"},{"label":"Punjabi (Eastern)","value":"pa"},{"label":"Quechua","value":"qu"},{"label":"Romansh","value":"rm"},{"label":"Romanian","value":"ro"},{"label":"Sami","value":"se"},{"label":"Samoan","value":"sm"},{"label":"Sango","value":"sg"},{"label":"Sanskrit","value":"sa"},{"label":"Serbian","value":"sr"},{"label":"Serbo-Croatian","value":"sh"},{"label":"Sesotho","value":"st"},{"label":"Setswana","value":"tn"},{"label":"Shona","value":"sn"},{"label":"Sichuan Yi","value":"ii"},{"label":"Sindhi","value":"sd"},{"label":"Sinhalese","value":"si"},{"label":"Siswati","value":"ss"},{"label":"Slovak","value":"sk"},{"label":"Slovenian","value":"sl"},{"label":"Somali","value":"so"},{"label":"Southern Ndebele","value":"nr"},{"label":"Sundanese","value":"su"},{"label":"Swahili (Kiswahili)","value":"sw"},{"label":"Swati","value":"ss"},{"label":"Swedish","value":"sv"},{"label":"Tagalog","value":"tl"},{"label":"Tahitian","value":"ty"},{"label":"Tajik","value":"tg"},{"label":"Tamil","value":"ta"},{"label":"Tatar","value":"tt"},{"label":"Telugu","value":"te"},{"label":"Thai","value":"th"},{"label":"Tibetan","value":"bo"},{"label":"Tigrinya","value":"ti"},{"label":"Tonga","value":"to"},{"label":"Tsonga","value":"ts"},{"label":"Turkish","value":"tr"},{"label":"Turkmen","value":"tk"},{"label":"Twi","value":"tw"},{"label":"Uyghur","value":"ug"},{"label":"Ukrainian","value":"uk"},{"label":"Urdu","value":"ur"},{"label":"Uzbek","value":"uz"},{"label":"Venda","value":"ve"},{"label":"Vietnamese","value":"vi"},{"label":"Volap\xfck","value":"vo"},{"label":"Wallon","value":"wa"},{"label":"Welsh","value":"cy"},{"label":"Wolof","value":"wo"},{"label":"Western Frisian","value":"fy"},{"label":"Xhosa","value":"xh"},{"label":"Yiddish","value":"yi, ji"},{"label":"Yoruba","value":"yo"},{"label":"Zhuang, Chuang","value":"za"},{"label":"Zulu","value":"zu"}],"license":[{"value":"https://www.mozilla.org/MPL/2.0/","label":"MPL V2.0"},{"value":"http://www.meta-net.eu/meta-share/meta-share-licenses/META-SHARE%20Commercial%20%20NoRedistribution_v0%207.pdf","label":"META-SHARE Commercial NoRedistribution For-A-Fee V1.0"},{"value":"http://www.meta-net.eu/meta-share/meta-share-licenses/META-SHARE%20Commercial%20%20NoRedistribution_v0%207.pdf","label":"META-SHARE Commercial NoRedistribution V1.0"},{"value":"http://wiki.data.gouv.fr/images/0/05/Open_Licence.pdf","label":"OL V1.0"},{"value":"https://gnu.org/licenses/fdl.html","label":"GFDL V1.3"},{"value":"https://gnu.org/licenses/fdl.html","label":"GFDL V1.1"},{"value":"http://artlibre.org/licence/lal/en/","label":"GFDL V1.3"},{"value":"https://www.gnu.org/licenses/lgpl.html","label":"LGPL V2.0"},{"value":"https://www.gnu.org/licenses/lgpl.html","label":"LGPL V3.0"},{"value":"https://www.gnu.org/licenses/lgpl.html","label":"LGPL V2.1"},{"value":"http://www.gnu.org/licenses/agpl-3.0.html","label":"GNU Affero General Public License 3.0"},{"value":"http://creativecommons.org/publicdomain/zero/1.0/","label":"CC0 1.0 Universal (CC0 1.0) Public Domain Dedication"},{"value":"http://creativecommons.org/licenses/by-sa/4.0/","label":"Creative Commons - Attribution-ShareAlike 4.0 International - CC BY-SA 4.0"},{"value":"http://creativecommons.org/licenses/by-nd/4.0/","label":"Creative Commons - Attribution-NoDerivatives 4.0 International - CC BY-ND 4.0"},{"value":"http://creativecommons.org/licenses/by-nc-sa/4.0/","label":"Creative Commons - Attribution-NonCommercial-ShareAlike 4.0 International - CC BY-NC-SA 4.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/4.0/","label":"Creative Commons - Attribution-NonCommercial-NoDerivatives 4.0 International - CC BY-NC-ND 4.0"},{"value":"http://creativecommons.org/licenses/by-nc/4.0/","label":"Creative Commons - Attribution-NonCommercial 4.0 International - CC BY-NC 4.0"},{"value":"http://creativecommons.org/licenses/by/3.0/fr","label":"CC-BY 3.0 France"},{"value":"http://creativecommons.org/licenses/by/4.0/","label":"Creative Commons - Attribution 4.0 International - CC BY 4.0"},{"value":"http://openvalue.org/licenses/academic.php","label":"Academic Free License 3.0"},{"value":"http://iss.ndl.go.jp/ndla/use/","label":"Web NDL Authority License"},{"value":"http://www.w3.org/Consortium/Legal/2002/copyright-software-20021231","label":"W3C Software Notice and License V1.0"},{"value":"http://www.nationalarchives.gov.uk/doc/non-commercial-government-licence/non-commercial-government-licence.htm","label":"UK NonCommercial Government License V1.0"},{"value":"http://openvalue.org/licenses/SimPL-2.0","label":"Simple Public License V2.0"},{"value":"http://en.wikipedia.org/wiki/Public_domain","label":"Public domain"},{"value":"http://creativecommons.org/publicdomain/mark/1.0/","label":"Public Domain Mark V1.0"},{"value":"http://www.oracle.com/technetwork/database/database-technologies/berkeleydb/downloads/oslicense-093458.html","label":"Oracle Berkely DB License V1.0"},{"value":"http://www.nationalarchives.gov.uk/doc/open-government-licence/version/2/","label":"Open Government Licence Non-Commercial V2.0"},{"value":"http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/","label":"Open Government Licence V3.0"},{"value":"http://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/re-use-and-licensing/ukglf/","label":"Open Government Licence V1.0"},{"value":"http://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/re-use-and-licensing/ukglf/","label":"Open Government Licence V2.0"},{"value":"http://www.opengeospatial.org/ogc/document","label":"Open Geospatial Consortium Document V1.0"},{"value":"http://www.opengeospatial.org/ogc/software","label":"Open Geospatial Consortium Software V1.0"},{"value":"http://opendatacommons.org/licenses/pddl/","label":"Open Data Commons Public Domain Dedication and License V1.0"},{"value":"http://opendatacommons.org/licenses/odbl/","label":"Open Data Commons Open Database License V1.0"},{"value":"http://opendatacommons.org/licenses/odc-by/","label":"Open Data Commons Attribution License V1.0"},{"value":"http://www.ordnancesurvey.co.uk/business-and-government/licensing/using-creating-data-with-os-products/os-opendata.html","label":"OS Open Data License V3.0"},{"value":"https://www.mozilla.org/MPL/2.0/","label":"Mozilla Public License V2.0"},{"value":"http://openvalue.org/licenses/MIT","label":"MIT License V1.0"},{"value":"http://referencevalue.microsoft.com/referencevaluelicensing.aspx","label":"Microsoft Reference value License"},{"value":"http://wiki.data.gouv.fr/images/0/05/Open_Licence.pdf","label":"License Ouverte V1.0"},{"value":"http://www.formez.it/iodl/","label":"Italian Open Data License v1.0 V1.0"},{"value":"https://www.govtrack.us/developers/license","label":"Govtrack License"},{"value":"http://www.elda.org/media/filer_public/2014/08/01/var_140312.pdf","label":"LANGUAGE REvalueS VALUE-ADDED-RESELLER AGREEMENT"},{"value":"http://openvalue.org/licenses/IPL-1.0","label":"IBM Public License V1.0"},{"value":"https://gnu.org/licenses/fdl.html","label":"GNU Free Documentation License V1.3"},{"value":"https://gnu.org/licenses/fdl.html","label":"GNU Free Documentation License V1.1"},{"value":"https://www.gnu.org/licenses/lgpl.html","label":"GNU Library General Public License V2.0"},{"value":"http://gnu.org/licenses/gpl-3.0.html","label":"GNU General Public License V3.0"},{"value":"http://gnu.org/licenses/gpl-2.0.html","label":"GNU General Public License V2.0"},{"value":"http://gnu.org/licenses/gpl-1.0.html","label":"GNU General Public License V1.0"},{"value":"https://www.gnu.org/licenses/lgpl.html","label":"GNU Lesser General Public License V3.0"},{"value":"https://www.gnu.org/licenses/lgpl.html","label":"GNU Lesser General Public License V2.1"},{"value":"http://www.gnu.org/licenses/agpl-3.0.html","label":"GNU Affero General Public License V3.0"},{"value":"https://joinup.ec.europa.eu/software/page/eupl/licence-eupl","label":"European Union Public License V1.1"},{"value":"http://www.freebsd.org/copyright/freebsd-doc-license.html","label":"Free BSD Documentation License"},{"value":"http://artlibre.org/licence/lal/en/","label":"Free Art License V1.3"},{"value":"http://cryptix.org/LICENSE.TXT","label":"Cryptix General License"},{"value":"https://www.eclipse.org/legal/epl-v10.html","label":"Eclipse Public License V1.0"},{"value":"http://creativecommons.org/publicdomain/zero/1.0/","label":"Creative Commons CC0 V1.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/ro","label":"Creative Commons CC-BY-SA Romania V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/pt","label":"Creative Commons CC-BY-SA Portugal V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/nl","label":"Creative Commons CC-BY-SA Netherlands V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/ie","label":"Creative Commons CC-BY-SA Ireland V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/4.0/","label":"Creative Commons CC-BY-SA V4.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/","label":"Creative Commons CC-BY-SA V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/2.0/","label":"Creative Commons CC-BY-SA V2.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/ch","label":"Creative Commons CC-BY-SA 3.0 Switzerland V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/ve","label":"Creative Commons CC-BY-SA Venezuela V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/es","label":"Creative Commons CC-BY-SA 3.0 Spain V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/it","label":"Creative Commons CC-BY-SA 3.0 Italy V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/gr","label":"Creative Commons CC-BY-SA 3.0 Greece V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/cl","label":"Creative Commons CC-BY-SA 3.0 Chile V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/at","label":"Creative Commons CC-BY-SA 3.0 Austria V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/de","label":"Creative Commons CC-BY-SA 3.0 Germany V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/fr","label":"Creative Commons CC-BY-SA 3.0 France V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/ec","label":"Creative Commons CC-BY-SA 3.0 Ecuador V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/cn","label":"Creative Commons CC-BY-SA 3.0 China V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/br","label":"Creative Commons CC-BY-SA 3.0 Brazil V3.0"},{"value":"http://creativecommons.org/licenses/by-sa/3.0/au","label":"Creative Commons CC-BY-SA 3.0 Australia V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/ch","label":"Creative Commons CC-BY-ND Switzerland V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/ie","label":"Creative Commons CC-BY-ND Ireland V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/2.5/dk","label":"Creative Commons CC-BY-ND Denmark V2.5"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/cn","label":"Creative Commons CC-BY-ND China V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/de","label":"Creative Commons CC-BY-ND Germany V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/cl","label":"Creative Commons CC-BY-ND Chile V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/ec","label":"Creative Commons CC-BY-ND Ecuador V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/br","label":"Creative Commons CC-BY-ND Brazil V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/at","label":"Creative Commons CC-BY-ND Austria V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/2.0/be","label":"Creative Commons CC-BY-ND Belgium V2.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/au","label":"Creative Commons CC-BY-ND Australia V3.0"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/ve","label":"Creative Commons CC-BY-ND 3.0 Venezuela"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/ro","label":"Creative Commons CC-BY-ND 3.0 Romania"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/es","label":"Creative Commons CC-BY-ND 3.0 Spain"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/gr","label":"Creative Commons CC-BY-ND 3.0 Greece"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/pt","label":"Creative Commons CC-BY-ND 3.0 Portugal"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/it","label":"Creative Commons CC-BY-ND 3.0 Italy"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/nl","label":"Creative Commons CC-BY-ND 3.0 Netherlands"},{"value":"http://creativecommons.org/licenses/by-nd/3.0/fr","label":"Creative Commons CC-BY-ND 3.0 France"},{"value":"http://creativecommons.org/licenses/by-nd/4.0/","label":"Creative Commons CC-BY-ND V4.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/","label":"Creative Commons CC-BY-ND V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/2.0/","label":"Creative Commons CC-BY-ND V2.0"},{"value":"http://creativecommons.org/licenses/by-nc-sa/3.0/","label":"Creative Commons CC-BY-NC-SA V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-sa/4.0/","label":"Creative Commons CC-BY-NC-SA V4.0"},{"value":"http://creativecommons.org/licenses/by-nc-sa/2.0/","label":"Creative Commons CC-BY-NC-SA V2.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/ve","label":"Creative Commons CC-BY-NC-ND Venezuela V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/ch","label":"Creative Commons CC-BY-NC-ND Switzerland V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/es","label":"Creative Commons CC-BY-NC-ND Spain V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/ro","label":"Creative Commons CC-BY-NC-ND Romania V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/gr","label":"Creative Commons CC-BY-NC-ND Greece V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/fr","label":"Creative Commons CC-BY-NC-ND France V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/cn","label":"Creative Commons CC-BY-NC-ND China V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/ec","label":"Creative Commons CC-BY-NC-ND Ecuador V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/cl","label":"Creative Commons CC-BY-NC-ND Chile V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/pt","label":"Creative Commons CC-BY-NC-ND Portugal V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/at","label":"Creative Commons CC-BY-NC-ND Austria V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/au","label":"Creative Commons CC-BY-NC-ND Australia V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/nl","label":"Creative Commons CC-BY-NC-ND Netherlands V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/ie","label":"Creative Commons CC-BY-NC-ND Ireland V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/it","label":"Creative Commons CC-BY-NC-ND Italy V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/3.0/","label":"Creative Commons CC-BY-NC-ND V3.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/4.0/","label":"Creative Commons CC-BY-NC-ND V4.0"},{"value":"http://creativecommons.org/licenses/by-nc-nd/2.0/","label":"Creative Commons CC-BY-NC-ND V2.0"},{"value":"http://creativecommons.org/licenses/by-nc/3.0/","label":"Creative Commons CC-BY-NC V3.0"},{"value":"http://creativecommons.org/licenses/by-nc/2.0/","label":"Creative Commons CC-BY-NC V2.0"},{"value":"http://creativecommons.org/licenses/by-nc/4.0/","label":"Creative Commons CC-BY-NC V4.0"},{"value":"http://creativecommons.org/licenses/by/3.0/ve","label":"Creative Commons CC-BY Venezuela V3.0"},{"value":"http://creativecommons.org/licenses/by/3.0/us","label":"Creative Commons CC-BY United States V3.0"},{"value":"http://creativecommons.org/licenses/by/2.5/ch","label":"Creative Commons CC-BY Switzerland V2.5"},{"value":"http://creativecommons.org/licenses/by/2.0/es","label":"Creative Commons CC-BY Spain V2.0"},{"value":"http://creativecommons.org/licenses/by/3.0/th","label":"Creative Commons CC-BY Thailand V3.0"},{"value":"http://creativecommons.org/licenses/by/2.0/za","label":"Creative Commons CC-BY South Africa V2.0"},{"value":"http://creativecommons.org/licenses/by/2.5/scotland","label":"Creative Commons CC-BY Scotland V2.5"},{"value":"http://creativecommons.org/licenses/by/3.0/lu","label":"Creative Commons CC-BY Luxemburg V3.0"},{"value":"http://creativecommons.org/licenses/by/3.0/pt","label":"Creative Commons CC-BY Portugal V3.0"},{"value":"http://creativecommons.org/licenses/by/3.0/nz","label":"Creative Commons CC-BY New Zealand V3.0"},{"value":"http://creativecommons.org/licenses/by/2.0/nl","label":"Creative Commons CC-BY Netherlands V2.0"},{"value":"http://creativecommons.org/licenses/by/2.5/mx","label":"Creative Commons CC-BY Mexico V2.5"},{"value":"http://creativecommons.org/licenses/by/2.0/jp","label":"Creative Commons CC-BY Japan V2.0"},{"value":"http://creativecommons.org/licenses/by/2.0/kr","label":"Creative Commons CC-BY Korea V2.0"},{"value":"http://creativecommons.org/licenses/by/2.0/it","label":"Creative Commons CC-BY Italy V2.0"},{"value":"http://creativecommons.org/licenses/by/2.5/il","label":"Creative Commons CC-BY Israel V2.5"},{"value":"http://creativecommons.org/licenses/by/2.5/in","label":"Creative Commons CC-BY India V2.5"},{"value":"http://creativecommons.org/licenses/by/3.0/ie","label":"Creative Commons CC-BY Ireland V3.0"},{"value":"http://creativecommons.org/licenses/by/2.5/hu","label":"Creative Commons CC-BY Hungary V2.5"},{"value":"http://creativecommons.org/licenses/by/3.0/gr","label":"Creative Commons CC-BY Greece V3.0"},{"value":"http://creativecommons.org/licenses/by/2.0/uk","label":"Creative Commons CC-BY England & Wales V2.0"},{"value":"http://creativecommons.org/licenses/by/3.0/eg","label":"Creative Commons CC-BY Egypt V3.0"},{"value":"http://creativecommons.org/licenses/by/2.0/fr","label":"Creative Commons CC-BY France V2.0"},{"value":"http://creativecommons.org/licenses/by/2.0/de","label":"Creative Commons CC-BY Germany V2.0"},{"value":"http://creativecommons.org/licenses/by/2.5/dk","label":"Creative Commons CC-BY Denmark V2.5"},{"value":"http://creativecommons.org/licenses/by/2.5/dz","label":"Creative Commons CC-BY Czech Republic V2.5"},{"value":"http://creativecommons.org/licenses/by/2.5/dz","label":"Uve\u010Fte p\u016Fvod \u010Cesk\xe1 republika V2.5"},{"value":"http://creativecommons.org/licenses/by/2.5/bg","label":"Creative Commons CC-BY Bulgaria V2.5"},{"value":"http://creativecommons.org/licenses/by/2.0/cl","label":"Creative Commons CC-BY Chile V2.0"},{"value":"http://creativecommons.org/licenses/by/2.0/ca","label":"Creative Commons CC-BY Canada V2.0"},{"value":"http://creativecommons.org/licenses/by/2.0/be","label":"Creative Commons CC-BY Belgium V2.0"},{"value":"http://creativecommons.org/licenses/by/2.5/mx","label":"Creative Commons CC-BY Argentina V2.5"},{"value":"http://creativecommons.org/licenses/by/3.0/ch","label":"Creative Commons CC-BY 3.0 Switzerland"},{"value":"http://creativecommons.org/licenses/by/3.0/es","label":"Creative Commons CC-BY 3.0 Spain"},{"value":"http://creativecommons.org/licenses/by/3.0/nl","label":"Creative Commons CC-BY 3.0 Netherlands"},{"value":"http://creativecommons.org/licenses/by/3.0/ro","label":"Creative Commons CC-BY 3.0 Romania"},{"value":"http://creativecommons.org/licenses/by/3.0/pl","label":"Creative Commons CC-BY 3.0 Poland"},{"value":"http://creativecommons.org/licenses/by/3.0/fr","label":"Creative Commons CC-BY 3.0 France"},{"value":"http://creativecommons.org/licenses/by/3.0/it","label":"Creative Commons CC-BY 3.0 Italy"},{"value":"http://creativecommons.org/licenses/by/3.0/ec","label":"Creative Commons CC-BY 3.0 Ecuador"},{"value":"http://creativecommons.org/licenses/by/3.0/de","label":"Creative Commons CC-BY 3.0 Germany"},{"value":"http://creativecommons.org/licenses/by/3.0/cn","label":"Creative Commons CC-BY 3.0 China"},{"value":"http://creativecommons.org/licenses/by/3.0/cl","label":"Creative Commons CC-BY 3.0 Chile"},{"value":"http://creativecommons.org/licenses/by/2.0/pt","label":"Creative Commons CC-BY 2.5 Portugal"},{"value":"http://creativecommons.org/licenses/by/3.0/br","label":"Creative Commons CC-BY 3.0 Brazil"},{"value":"http://creativecommons.org/licenses/by/3.0/at","label":"Creative Commons CC-BY 3.0 Austria"},{"value":"http://creativecommons.org/licenses/by/2.5/se","label":"Creative Commons CC-BY 2.5 Sweden"},{"value":"http://creativecommons.org/licenses/by/3.0/au","label":"Creative Commons CC-BY 3.0 Australia"},{"value":"http://creativecommons.org/licenses/by/2.5/pe","label":"Creative Commons CC-BY 2.5 Peru"},{"value":"http://creativecommons.org/licenses/by/2.0/br","label":"Creative Commons CC-BY 2.0 Brazil"},{"value":"http://creativecommons.org/licenses/by/2.0/at","label":"Creative Commons CC-BY 2.0 Austria"},{"value":"http://creativecommons.org/licenses/by/2.0/au","label":"Creative Commons CC-BY 2.0 Australia"},{"value":"http://creativecommons.org/licenses/by/2.0/","label":"Creative Commons CC-BY V2.0"},{"value":"http://creativecommons.org/licenses/by/1.0/","label":"Creative Commons CC-BY V1.0"},{"value":"http://creativecommons.org/licenses/by/4.0/","label":"Creative Commons CC-BY V4.0"},{"value":"http://creativecommons.org/licenses/by/3.0/","label":"Creative Commons CC-BY V3.0"},{"value":"http://openvalue.org/licenses/cpl1.0.php","label":"Common Public License V1.0"},{"value":"http://openvalue.org/licenses/CDDL-1.0","label":"Common Development and Distribution License V1.0"},{"value":"http://www.coloriuris.net/en:avisos_legales#copyright_and_industrial_property","label":"ColorIURIS Copyright"},{"value":"http://www.linfo.org/bsdlicense.html","label":"BSD License 4-clause V4.0"},{"value":"http://openvalue.org/licenses/BSL-1.0","label":"BOOST Software License V1.0"},{"value":"http://www.linfo.org/bsdlicense.html","label":"BSD License 3-clause V4.0"},{"value":"http://www.apache.org/licenses/LICENSE-1.0","label":"Apache License V1.0"},{"value":"http://www.apache.org/licenses/LICENSE-2.0","label":"Apache License V2.0"},{"value":"http://openvalue.org/licenses/Artistic-2.0","label":"Artistic License V2.0"},{"value":"http://www.linfo.org/bsdlicense.html","label":"2-clause BSD License V2.0"},{"value":"http://openvalue.org/licenses/academic.php","label":"Academic Free License V3.0"}],"vocabulary":[{"nsp":"http://www.irit.fr/recherches/MELODI/ontologies/SAN#","prefix":"SAN","uri":"http://www.irit.fr/recherches/MELODI/ontologies/SAN","titles":[{"value":"SAN (Semantic Actuator Network)","lang":"en","_id":"632487f6f0004aba7af3f86e"}]},{"uri":"https://w3id.org/arco/ontology/location","nsp":"https://w3id.org/arco/ontology/location/","prefix":"a-loc","titles":[{"value":"Location Ontology (ArCo network)","lang":"en","_id":"63248ca8121504032603bd80"}]},{"nsp":"http://purl.org/acco/ns#","prefix":"acco","uri":"http://purl.org/acco/ns","titles":[{"value":"Accomodation Ontology","lang":"en","_id":"60f45cf6f15c60e61cf5bb21"}]},{"nsp":"http://www.w3.org/ns/auth/acl#","prefix":"acl","uri":"http://www.w3.org/ns/auth/acl","titles":[{"value":"Basic Access Control ontology","lang":"en","_id":"63248405f0004aba7af3f823"}]},{"nsp":"http://acm.rkbexplorer.com/ontologies/acm#","prefix":"acm","uri":"http://www.rkbexplorer.com/ontologies/acm","titles":[{"value":"ACM Classification Ontology","lang":"en","_id":"5aba12a00d8ceb4e0147e17b"}]},{"nsp":"http://privatealpha.com/ontology/certification/1#","prefix":"acrt","uri":"http://privatealpha.com/ontology/certification/1#","titles":[{"value":"Agent Certification Ontology","lang":"en","_id":"632484dbf0004aba7af3f840"}]},{"nsp":"http://www.w3.org/ns/adms#","prefix":"adms","uri":"http://www.w3.org/ns/adms","titles":[{"value":"Asset Description Metadata Schema","lang":"en","_id":"56916f91b7cea413588f954b"}]},{"nsp":"http://purl.org/ontology/af/","prefix":"af","uri":"http://purl.org/ontology/af/","titles":[{"value":"Audio Features Ontology","lang":"en","_id":"586a4a897e341093492b8b59"}]},{"nsp":"http://www.agls.gov.au/agls/terms/","prefix":"agls","uri":"http://www.agls.gov.au/agls/terms","titles":[{"value":"AGLS Metadata Terms","lang":"en","_id":"586a46447e341093492b8583"}]},{"nsp":"http://promsns.org/def/agr#","prefix":"agr","uri":"http://promsns.org/def/agr","titles":[{"value":"Agreements ontology","lang":"en","_id":"5a4141b8b201efd03d3af351"}]},{"nsp":"http://d-nb.info/standards/elementset/agrelon#","prefix":"agrelon","uri":"http://d-nb.info/standards/elementset/agrelon","titles":[{"value":"Agent Relationship Ontology","lang":"en","_id":"632489c6f0004aba7af3f88e"}]},{"nsp":"http://purl.org/vocab/aiiso/schema#","prefix":"aiiso","uri":"http://purl.org/vocab/aiiso/schema","titles":[{"value":"Academic Institution Internal Structure Ontology","lang":"en","_id":"5696a5b6ff8848f96bd11d80"}]},{"uri":"https://w3id.org/AIRO","nsp":"https://w3id.org/AIRO#","prefix":"airo","titles":[{"value":"AI Risk Ontology","lang":"en","_id":"63248867f0004aba7af3f883"}]},{"nsp":"https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#","prefix":"airs","uri":"https://raw.githubusercontent.com/airs-linked-data/lov/latest/src/airs_vocabulary.ttl#","titles":[{"value":"Alliance of Information and Referral Services (AIRS) Vocabulary","lang":"en","_id":"57f6086b812207ab0361cd14"}]},{"nsp":"http://www.aktors.org/ontology/portal#","prefix":"akt","uri":"http://www.aktors.org/ontology/portal","titles":[{"value":"AKT Reference Ontology","lang":"en","_id":"57f60938812207ab0361cdcc"}]},{"nsp":"http://www.aktors.org/ontology/support#","prefix":"akts","uri":"http://www.aktors.org/ontology/support","titles":[{"value":"AKT Support Ontology","lang":"en","_id":"57f60961812207ab0361cdfa"}]},{"nsp":"http://securitytoolbox.appspot.com/securityAlgorithms#","prefix":"algo","uri":"http://securitytoolbox.appspot.com/securityAlgorithms#","titles":[{"value":"Algorithms Ontology","lang":"en","_id":"569170d2b7cea413588f95ea"}]},{"nsp":"http://open-services.net/ns/asset#","prefix":"am","uri":"http://open-services.net/ns/asset#","titles":[{"value":"OSLC Asset Management Vocabulary","lang":"en","_id":"6324850bf0004aba7af3f846"}]},{"nsp":"https://w3id.org/i40/aml#","prefix":"aml","uri":"https://w3id.org/i40/aml","titles":[{"value":"AutomationML Ontology","lang":"en","_id":"588a2c0967d4e8e0568bcc4a"}]},{"uri":"http://w3id.org/amlo/core","nsp":"http://w3id.org/amlo/core#","prefix":"amlo-core","titles":[{"value":"AMLO-core vocabulary","lang":"en","_id":"5ec7f4bb218a9eab39bb02c4"}]},{"nsp":"http://purl.org/ontology/ao/core#","prefix":"ao","uri":"http://purl.org/ontology/ao/core#","titles":[{"value":"Association Ontology","lang":"en","_id":"63248d50121504032603bd8a"}]},{"nsp":"http://rdf.muninn-project.org/ontologies/appearances#","prefix":"aos","uri":"http://rdf.muninn-project.org/ontologies/appearances","titles":[{"value":"Appearances Ontology Specification","lang":"en","_id":"5731d1d7b5cce30e4a3b54ff"}]},{"nsp":"http://purl.org/linked-data/api/vocab#","prefix":"api","uri":"http://purl.org/linked-data/api/vocab#","titles":[{"value":"Linked Data API Vocabulary","lang":"en","_id":"586ba5297e341093492c4762"}]},{"nsp":"http://semweb.mmlab.be/ns/apps4X#","prefix":"apps4X","uri":"http://semweb.mmlab.be/ns/apps4X","titles":[{"value":"The vocabulary for Co-creation Events based on Open Data","lang":"en","_id":"5f1ace5e388540d23b85cf33"}]},{"nsp":"http://purl.org/archival/vocab/arch#","prefix":"arch","uri":"http://purl.org/archival/vocab/arch","titles":[{"value":"Archival collections ontology","lang":"en","_id":"583a047acd0ed0472763e107"}]},{"uri":"https://w3id.org/arco/ontology/core","nsp":"https://w3id.org/arco/ontology/core/","prefix":"arco","titles":[{"value":"Core Ontology (ArCo network)","lang":"en","_id":"5cf3c5e4022005fa5d1ac292"}]},{"nsp":"http://www.arpenteur.org/ontology/Arpenteur.owl#","prefix":"arp","uri":"http://www.arpenteur.org/ontology/Arpenteur.owl","titles":[{"value":"Arpenteur Ontology","lang":"en","_id":"5a5d1f7d209e748d429f9e37"}]},{"nsp":"https://data.nasa.gov/ontologies/atmonto/data#","prefix":"atd","uri":"https://data.nasa.gov/ontologies/atmonto/data#","titles":[{"value":"Air Traffic Data","lang":"en","_id":"5ad894ad1d2f4eee4d656fcf"}]},{"nsp":"https://data.nasa.gov/ontologies/atmonto/ATM#","prefix":"atm","uri":"https://data.nasa.gov/ontologies/atmonto/ATM#","titles":[{"value":"Air Traffic Management (ATM) Vocabulary","lang":"en","_id":"5ad8922b61786a9648240d21"}]},{"nsp":"https://data.nasa.gov/ontologies/atmonto/general#","prefix":"atts","uri":"https://data.nasa.gov/ontologies/atmonto/general#","titles":[{"value":"Air Traffic Temporal and Spacial Vocabulary","lang":"en","_id":"5ad895c40946b4a14e455be7"}]},{"nsp":"http://bblfish.net/work/atom-owl/2006-06-06/#","prefix":"awol","uri":"http://bblfish.net/work/atom-owl/2006-06-06/","titles":[{"value":"Atom Syndication Ontology","lang":"en","_id":"57f68820812207ab03623950"}]},{"nsp":"http://purl.oclc.org/NET/ssnx/meteo/aws#","prefix":"aws","uri":"http://purl.oclc.org/NET/ssnx/meteo/aws","titles":[{"value":"Ontology for Meteorological sensors","lang":"en","_id":"583a04b0cd0ed0472763e10d"}]},{"nsp":"http://bag.basisregistraties.overheid.nl/def/bag#","prefix":"bag","uri":"http://bag.basisregistraties.overheid.nl/def/bag","titles":[{"value":"Vocabulary for the Dutch base registration of buildings and addresses (BAG)","lang":"en","_id":"5abcb8dfc7ef5ec931501221"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic#","prefix":"basic","uri":"http://def.seegrid.csiro.au/isotc211/iso19103/2005/basic","titles":[{"value":"OWL representation of ISO 19103 (Basic types package)","lang":"en","_id":"57f68251812207ab0362348e"}]},{"nsp":"http://www.bbc.co.uk/ontologies/bbc/","prefix":"bbc","uri":"http://www.bbc.co.uk/ontologies/bbc","titles":[{"value":"BBC Ontology","lang":"en","_id":"5731b734b5cce30e4a3b52ab"}]},{"nsp":"http://www.bbc.co.uk/ontologies/cms/","prefix":"bbccms","uri":"http://www.bbc.co.uk/ontologies/cms","titles":[{"value":"BBC CMS Ontology","lang":"en","_id":"5731b9a0b5cce30e4a3b52fe"}]},{"nsp":"http://www.bbc.co.uk/ontologies/coreconcepts/","prefix":"bbccore","uri":"http://www.bbc.co.uk/ontologies/coreconcepts","titles":[{"value":"BBC Core Concepts","lang":"en","_id":"5731bb32b5cce30e4a3b5311"}]},{"nsp":"http://www.bbc.co.uk/ontologies/provenance/","prefix":"bbcprov","uri":"http://www.bbc.co.uk/ontologies/provenance","titles":[{"value":"BBC Provenance Ontology","lang":"en","_id":"578370c60183b1e80fc877ff"}]},{"nsp":"https://w3id.org/BCI-ontology#","prefix":"bci","uri":"https://w3id.org/BCI-ontology","titles":[{"value":"Brain Computing Interface (BCI) Ontology","lang":"en","_id":"58219de637e8a6d933be9d04"}]},{"uri":"https://w3id.org/bcom","nsp":"https://w3id.org/bcom#","prefix":"bcom","titles":[{"value":"Building Concrete Monitoring Ontology (BCOM)","lang":"en","_id":"60fec67c640de9b115d1653e"}]},{"nsp":"http://contextus.net/ontology/ontomedia/ext/common/being#","prefix":"being","uri":"http://contextus.net/ontology/ontomedia/ext/common/being#","titles":[{"value":"OntoMedia Being Representation","lang":"en","_id":"57f6082e812207ab0361ccdf"}]},{"nsp":"http://rdfs.co/bevon/","prefix":"bevon","uri":"http://rdfs.co/bevon/","titles":[{"value":"BEVON: Beverage Ontology","lang":"en","_id":"63248cf5121504032603bd84"}]},{"nsp":"http://id.loc.gov/ontologies/bibframe/","prefix":"bf","uri":"http://id.loc.gov/ontologies/bibframe/","titles":[{"value":"BIBFRAME Vocabulary","lang":"en","_id":"5c9894025ba958e17a8636e0"}]},{"nsp":"http://purl.org/ontology/bibo/","prefix":"bibo","uri":"http://purl.org/ontology/bibo/","titles":[{"value":"The Bibliographic Ontology","lang":"en","_id":"5dacded48b936c5b59e22a73"}]},{"nsp":"http://purl.org/net/nknouf/ns/bibtex#","prefix":"bibtex","uri":"http://purl.org/net/nknouf/ns/bibtex","titles":[{"value":"BibTeX ontology","lang":"en","_id":"578365250183b1e80fc87401"}]},{"uri":"http://bimerr.iot.linkeddata.es/def/occupancy-profile#","nsp":"http://bimerr.iot.linkeddata.es/def/occupancy-profile#","prefix":"bimerr-op","titles":[{"value":"Occupancy Profile ontology","lang":"en","_id":"5eb4402ff298949e0c2d3e1c"}]},{"nsp":"http://purl.org/vocab/bio/0.1/","prefix":"bio","uri":"http://purl.org/vocab/bio/0.1/","titles":[{"value":"BIO: A vocabulary for biographical information","lang":"en","_id":"586a4a1a7e341093492b8af4"}]},{"nsp":"http://purl.org/NET/biol/ns#","prefix":"biol","uri":"http://purl.org/NET/biol/ns#","titles":[{"value":"Biological Taxonomy Vocabulary 0.2 (Core)","lang":"en","_id":"5adda40767b67f5811d01cac"}]},{"nsp":"http://www.biopax.org/release/biopax-level3.owl#","prefix":"biopax","uri":"http://www.biopax.org/release/biopax-level3.owl","titles":[{"value":"BioPAX Level 3 ontology","lang":"en","_id":"56a6abfb37d8a8044b2670ed"}]},{"nsp":"http://purl.org/biotop/biotop.owl#","prefix":"biotop","uri":"http://purl.org/biotop/biotop.owl","titles":[{"value":"BioTop","lang":"en","_id":"59ca791929685e28746bbf9a"}]},{"nsp":"http://purl.org/spar/biro/","prefix":"biro","uri":"http://purl.org/spar/biro","titles":[{"value":"The Bibliographic Reference Ontology","lang":"en","_id":"569cca73ff8848f96bd16c98"}]},{"nsp":"http://www.bl.uk/schemas/bibliographic/blterms#","prefix":"blt","uri":"http://www.bl.uk/schemas/bibliographic/blterms","titles":[{"value":"British Library Terms RDF schema","lang":"en","_id":"569f7714ff8848f96bd20405"}]},{"nsp":"http://swa.cefriel.it/ontologies/botdcat-ap#","prefix":"bot","uri":"http://swa.cefriel.it/ontologies/botdcat-ap","titles":[{"value":"BotDCAT-AP - Data Catalogue vocabulary Application Profile for chatbots","lang":"en","_id":"5947897b8f40482b5d8dff03"}]},{"nsp":"http://purl.org/NET/biol/botany#","prefix":"botany","uri":"http://purl.org/NET/biol/botany#","titles":[{"value":"Biological Taxonomy Vocabulary 0.2 (Botany)","lang":"en","_id":"56a6998b37d8a8044b26678a"}]},{"nsp":"http://data.vlaanderen.be/ns/persoon#","prefix":"bperson","uri":"http://data.vlaanderen.be/ns/persoon","titles":[{"value":"Person","lang":"en","_id":"5a32c6fdece6c50213e99ec7"},{"value":"Persoon","lang":"nl","_id":"5a32c6fdece6c50213e99ec6"}]},{"nsp":"http://vocab.deri.ie/br#","prefix":"br","uri":"http://vocab.deri.ie/br","titles":[{"value":"Brainstorm Ontology","lang":"en","_id":"569f766fff8848f96bd20377"}]},{"nsp":"http://brk.basisregistraties.overheid.nl/def/brk#","prefix":"brk","uri":"http://brk.basisregistraties.overheid.nl/def/brk","titles":[{"value":"Key Register Cadastre (BRK) vocabulary","lang":"en","_id":"5abcc633c7ef5ec93150270e"}]},{"nsp":"http://brt.basisregistraties.overheid.nl/def/top10nl#","prefix":"brt","uri":"http://brt.basisregistraties.overheid.nl/def/top10nl","titles":[{"value":"Key Register Topography (BRT) vocabulary","lang":"en","_id":"5abcc60ac7ef5ec9315026db"}]},{"nsp":"https://w3id.org/bot#","prefix":"bto","uri":"https://w3id.org/bot","titles":[{"value":"BOT: Building Topology Ontology","lang":"en","_id":"601c4192c01d47585511d794"}]},{"nsp":"http://vocab.deri.ie/c4n#","prefix":"c4n","uri":"http://vocab.deri.ie/c4n","titles":[{"value":"Call for Anything vocabulary","lang":"en","_id":"5df2c0bd642496d2717d1a37"}]},{"nsp":"http://purl.org/spar/c4o/","prefix":"c4o","uri":"http://purl.org/spar/c4o","titles":[{"value":"C4O, the Citation Counting and Context Characterization Ontology","lang":"en","_id":"569cc7ccff8848f96bd16c4a"}]},{"nsp":"http://www.w3.org/2002/12/cal/ical#","prefix":"cal","uri":"http://www.w3.org/2002/12/cal/ical","titles":[{"value":"Internet Calendaring and Scheduling Core Object Specification","lang":"en","_id":"569f96b5ff8848f96bd21335"}]},{"uri":"http://caressesrobot.org/ontology","nsp":"http://caressesrobot.org/ontology#","prefix":"caresses","titles":[{"value":"CARESSES Ontology","lang":"en","_id":"5d3ea9f18b4d0a137781129c"}]},{"nsp":"http://purl.org/net/cartCoord#","prefix":"cart","uri":"http://purl.org/net/cartCoord#","titles":[{"value":"cartCoordOnt","lang":"en","_id":"6326e8d0121504032603c3ec"}]},{"uri":"http://www.w3id.org/def/caso#","nsp":"http://www.w3id.org/def/caso#","prefix":"caso","titles":[{"value":"Context Aware System Observation Ontology","lang":"en","_id":"6034ea855520e9076d89fd4e"}]},{"uri":"http://w3id.org/um/cbcm/eu-cm-ontology","nsp":"http://w3id.org/um/cbcm/eu-cm-ontology#","prefix":"cbcm","titles":[{"value":"The European Union Company Mobility Ontology (EUCM ontology)","lang":"en","_id":"61b324916858fed439e7c4c6"}]},{"nsp":"http://comicmeta.org/cbo/","prefix":"cbo","uri":"http://comicmeta.org/cbo/","titles":[{"value":"Comic Book Ontology","lang":"en","_id":"57ad87cfb00b4b1452a888b7"}]},{"nsp":"http://betalinkeddata.cbs.nl/def/cbs#","prefix":"cbs","uri":"http://betalinkeddata.cbs.nl/def/cbs","titles":[{"value":"De Centraal Bureau voor de Statistiek (CBS) ontologie","lang":"nl","_id":"5b34dc5ccd8de63f0afaa608"},{"value":"Netherlands\' National Statistics Office (CBS) ontology","lang":"en","_id":"5b34dc5ccd8de63f0afaa607"}]},{"nsp":"http://creativecommons.org/ns#","prefix":"cc","uri":"http://creativecommons.org/ns","titles":[{"value":"Creative Commons Rights Expression Language","lang":"en","_id":"569171f5b7cea413588f9682"}]},{"nsp":"http://cookingbigdata.com/linkeddata/ccinstances#","prefix":"cci","uri":"http://cookingbigdata.com/linkeddata/ccinstances","titles":[{"value":"Ontology for Cloud Computing instances","lang":"en","_id":"5b0594ea453b589b0c9f98db"}]},{"nsp":"http://purl.org/ontology/cco/core#","prefix":"cco","uri":"http://purl.org/ontology/cco/core#","titles":[{"value":"Cognitive Characteristics Ontology","lang":"en","_id":"5dacdf978b936c5b59e22a8e"}]},{"nsp":"http://cookingbigdata.com/linkeddata/ccpricing#","prefix":"ccp","uri":"http://cookingbigdata.com/linkeddata/ccpricing","titles":[{"value":"Vocabulary for prices options in Cloud Computing Services","lang":"en","_id":"5b05922d453b589b0c9f9874"}]},{"nsp":"http://cookingbigdata.com/linkeddata/ccregions#","prefix":"ccr","uri":"http://cookingbigdata.com/linkeddata/ccregions","titles":[{"value":"Vocabulary for Regions and Zones on Cloud Computing","lang":"en","_id":"5b0595be453b589b0c9f98fa"}]},{"nsp":"http://cookingbigdata.com/linkeddata/ccsla#","prefix":"ccsla","uri":"http://cookingbigdata.com/linkeddata/ccsla","titles":[{"value":"Service Level Agreement for Cloud Computing","lang":"en","_id":"5b058fb3453b589b0c9f9816"}]},{"uri":"https://w3id.org/cdc","nsp":"https://w3id.org/cdc#","prefix":"cdc","titles":[{"value":"CDC: Construction Dataset Context ontology","lang":"en","_id":"6038cad813698c270be20d8f"}]},{"uri":"https://w3id.org/arco/ontology/context-description","nsp":"https://w3id.org/arco/ontology/context-description/","prefix":"cdesc","titles":[{"value":"Context Description Ontology (ArCo network)","lang":"en","_id":"5db03884581233d82940d27c"},{"value":"Ontologia della Descrizione di Contesto (ArCo network)","lang":"it","_id":"5db03884581233d82940d27b"}]},{"nsp":"http://purl.org/twc/ontology/cdm.owl#","prefix":"cdm","uri":"http://purl.org/twc/ontology/cdm.owl#","titles":[{"value":"Conceptual Depth and Momentum","lang":"en","_id":"59a69b227845e44d19bfa2d0"}]},{"nsp":"http://purl.org/cld/cdtype/","prefix":"cdtype","uri":"http://purl.org/cld/cdtype/","titles":[{"value":"The Collection Description Type Namespace","lang":"en","_id":"56950413ff8848f96bd1006d"}]},{"uri":"https://w3id.org/CEMontology","nsp":"https://w3id.org/CEMontology/","prefix":"cem","titles":[{"value":"Crime Event Model (CEM)","lang":"en","_id":"638bc07ce8d209386de14911"}]},{"nsp":"http://www.ebusiness-unibw.org/ontologies/consumerelectronics/v1#","prefix":"ceo","uri":"http://www.ebusiness-unibw.org/ontologies/consumerelectronics/v1","titles":[{"value":"Consumer Electronics Ontology","lang":"en","_id":"577e0e430183b1e80fc6ac2a"}]},{"nsp":"http://www.eurocris.org/ontologies/cerif/1.3#","prefix":"cerif","uri":"http://www.eurocris.org/ontologies/cerif/1.3","titles":[{"value":"CERIF Ontology 1.3","lang":"en","_id":"582ae92ccd0ed04727598a3e"}]},{"nsp":"http://www.w3.org/ns/auth/cert#","prefix":"cert","uri":"http://www.w3.org/ns/auth/cert#","titles":[{"value":"The Cert Ontology","lang":"en","_id":"586a4c467e341093492b8ce4"}]},{"uri":"https://w3id.org/arco/ontology/cultural-event","nsp":"https://w3id.org/arco/ontology/cultural-event/","prefix":"cevent","titles":[{"value":"Cultural Event Ontology (ArCo network)","lang":"en","_id":"5db055a0581233d82940d2d8"}]},{"nsp":"http://purl.oclc.org/NET/ssnx/cf/cf-feature#","prefix":"cff","uri":"http://purl.oclc.org/NET/ssnx/cf/cf-feature","titles":[{"value":"Climate and Forecast (CF) features","lang":"en","_id":"583a0a86cd0ed0472763e156"}]},{"nsp":"http://purl.oclc.org/NET/ssnx/cf/cf-property#","prefix":"cfp","uri":"http://purl.oclc.org/NET/ssnx/cf/cf-property","titles":[{"value":"Climate and Forecast (CF) standard names parameter vocabulary","lang":"en","_id":"586a49437e341093492b89e8"}]},{"nsp":"http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#","prefix":"cfrl","uri":"http://linkeddata.finki.ukim.mk/lod/ontology/cfrl#","titles":[{"value":"Corporate Financial Reports and Loans Ontology","lang":"en","_id":"57d28910a3a9d3a63d7e6b3b"}]},{"nsp":"http://reference.data.gov.uk/def/central-government/","prefix":"cgov","uri":"http://reference.data.gov.uk/def/central-government","titles":[{"value":"Central Government Ontology","lang":"en","_id":"5c49902a9e5c7dfa7bfd1e9b"}]},{"nsp":"http://purl.org/ontology/chord/","prefix":"chord","uri":"http://purl.org/ontology/chord/","titles":[{"value":"The OMRAS2 Chord Ontology","lang":"en","_id":"586b9f0f7e341093492c4719"}]},{"uri":"https://privatealpha.com/ontology/content-inventory/1#","nsp":"https://privatealpha.com/ontology/content-inventory/1#","prefix":"ci","titles":[{"value":"A Content Inventory Vocabulary","lang":"en","_id":"5c628d4c72ab374754392202"}]},{"nsp":"http://dati.beniculturali.it/cis/","prefix":"cis","uri":"http://dati.beniculturali.it/cultural-ON/cultural-ON.owl","titles":[{"value":"Cultural-ON (Cultural ONtology): Cultural Institute/Site and Cultural Event Ontology","lang":"en","_id":"597f0dc9780cc2987e56fe0d"},{"value":"Cultural-ON (Cultural ONtology): Ontologia dei Luoghi della Cultura e degli Eventi Culturali","lang":"it","_id":"597f0dc9780cc2987e56fe0c"}]},{"nsp":"http://purl.org/spar/cito/","prefix":"cito","uri":"http://purl.org/spar/cito","titles":[{"value":"CiTO, the Citation Typing Ontology","lang":"en","_id":"5ace37a53aba5caf50dde017"}]},{"nsp":"http://www.essepuntato.it/2013/03/cito-functions/","prefix":"citof","uri":"http://www.essepuntato.it/2013/03/cito-functions","titles":[{"value":"Functions of Citations","lang":"en","_id":"586a4db87e341093492b8e18"}]},{"nsp":"http://advene.org/ns/cinelab/ld#","prefix":"cl","uri":"http://advene.org/ns/cinelab/ld","titles":[{"value":"Cinelab ontology","lang":"en","_id":"5784e0f20183b1e80fc90523"}]},{"nsp":"http://purl.org/cld/terms/","prefix":"cld","uri":"http://purl.org/cld/terms/","titles":[{"value":"The Collection Description Terms","lang":"en","_id":"56a698cf37d8a8044b26673e"}]},{"nsp":"http://purl.org/twc/ontologies/cmo.owl#","prefix":"cmo","uri":"http://purl.org/twc/ontologies/cmo.owl","titles":[{"value":"Conceptual Model Ontology","lang":"en","_id":"5783694e0183b1e80fc8758e"}]},{"nsp":"http://www.w3.org/2011/content#","prefix":"cnt","uri":"http://www.w3.org/2011/content","titles":[{"value":"Representing Content in RDF","lang":"en","_id":"632caea0c4f7e5f619d44f01"}]},{"nsp":"http://purl.org/ontology/co/core#","prefix":"co","uri":"http://purl.org/ontology/co/core#","titles":[{"value":"Counter Ontology","lang":"en","_id":"632caf16c4f7e5f619d44f0f"}]},{"uri":"http://data.cochrane.org/ontologies/core/","nsp":"http://data.cochrane.org/ontologies/core/","prefix":"cochrane","titles":[{"value":"Cochrane Core Vocabulary Ontology","lang":"en","_id":"5e905a10714818e448ba0a65"}]},{"uri":"https://w3id.org/cocoon/v1.0","nsp":"https://w3id.org/cocoon/v1.0#","prefix":"cocoon","titles":[{"value":"Cloud Computing Services Ontology","lang":"en","_id":"5cf4d54edf5b20456acd6571"}]},{"nsp":"http://vocab.deri.ie/cogs#","prefix":"cogs","uri":"http://vocab.deri.ie/cogs","titles":[{"value":"COGS Vocabulary","lang":"en","_id":"621caca8eb61c60043989113"}]},{"nsp":"http://purl.org/configurationontology#","prefix":"cold","uri":"http://purl.org/configurationontology","titles":[{"value":"\'Configuration as Linked Data\' ontology","lang":"en","_id":"568bec904ee7f7176ff12591"}]},{"nsp":"http://purl.org/co/","prefix":"coll","uri":"http://purl.org/co","titles":[{"value":"Collections Ontology","lang":"en","_id":"55d7292de4ac2b1c4c5a5072"}]},{"nsp":"http://vocab.resc.info/communication#","prefix":"comm","uri":"http://vocab.resc.info/communication","titles":[{"value":"Vocabulary related to incident communication","lang":"en","_id":"5783b7420183b1e80fc87d22"}]},{"uri":"http://www.w3.org/2007/uwa/context/deliverycontext.owl","nsp":"http://www.w3.org/2007/uwa/context/common.owl#","prefix":"common","titles":[{"value":"The Delivery Context Ontology","lang":"en","_id":"5db03395581233d82940d25c"}]},{"nsp":"http://www.w3.org/2000/10/swap/pim/contact#","prefix":"con","uri":"http://www.w3.org/2000/10/swap/pim/contact","titles":[{"value":"Contact","lang":"en","_id":"632cac56c4f7e5f619d44ef3"}]},{"uri":"https://w3id.org/con-tax","nsp":"https://w3id.org/con-tax#","prefix":"contax","titles":[{"value":"ConTax ontology","lang":"en","_id":"6038c99613698c270be20d72"}]},{"nsp":"http://purl.org/twc/vocab/conversion/","prefix":"conversion","uri":"http://purl.org/twc/vocab/conversion/","titles":[{"value":"Conversion Ontology","lang":"en","_id":"5dace3818b936c5b59e22ac3"}]},{"nsp":"http://purl.org/coo/ns#","prefix":"coo","uri":"http://purl.org/coo/ns#","titles":[{"value":"Car Options Ontology","lang":"en","_id":"6326ebfe121504032603c43b"}]},{"uri":"https://w3id.org/mdo/core/","nsp":"https://w3id.org/mdo/core/","prefix":"core","titles":[{"value":"Materials Design Ontology - Core Module","lang":"en","_id":"5fb399314234ac0847e4c4d6"}]},{"nsp":"http://www.daml.org/2001/09/countries/iso-3166-ont#","prefix":"coun","uri":"http://www.daml.org/2001/09/countries/iso-3166-ont","titles":[{"value":"ISO 3166 Country Codes","lang":"en","_id":"5783b7a50183b1e80fc87d34"}]},{"nsp":"http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl#","prefix":"cpa","uri":"http://www.ontologydesignpatterns.org/schemas/cpannotationschema.owl","titles":[{"value":"Content Pattern Annotations","lang":"en","_id":"568beccf4ee7f7176ff12595"}]},{"nsp":"http://www.cidoc-crm.org/cidoc-crm/","prefix":"crm","uri":"http://www.cidoc-crm.org/cidoc-crm/","titles":[{"value":"CIDOC Conceptual Reference Model","lang":"en","_id":"56a69a0a37d8a8044b2667ca"}]},{"nsp":"http://rhizomik.net/ontologies/copyrightonto.owl#","prefix":"cro","uri":"http://rhizomik.net/ontologies/copyrightonto.owl","titles":[{"value":"Copyright Ontology","lang":"en","_id":"632cad7bc4f7e5f619d44efb"}]},{"nsp":"http://courseware.rkbexplorer.com/ontologies/courseware#","prefix":"crsw","uri":"http://courseware.rkbexplorer.com/ontologies/courseware","titles":[{"value":"ReSIST Courseware Ontology","lang":"en","_id":"586b9f837e341093492c4726"}]},{"nsp":"http://purl.org/vocab/changeset/schema#","prefix":"cs","uri":"http://purl.org/vocab/changeset/schema","titles":[{"value":"Changeset","lang":"en","_id":"586a4ca57e341093492b8d3a"}]},{"nsp":"http://vocab.deri.ie/csp#","prefix":"csp","uri":"http://vocab.deri.ie/csp","titles":[{"value":"Constraint Satisfaction Problems Vocabulary","lang":"en","_id":"56a51ae637d8a8044b25db71"}]},{"nsp":"http://www.w3.org/ns/csvw#","prefix":"csvw","uri":"http://www.w3.org/ns/csvw#","titles":[{"value":"CSV on the Web Vocabulary","lang":"en","_id":"61e18ae7ad0aa62c05f2469d"}]},{"nsp":"http://www.tele.pw.edu.pl/~sims-onto/ConnectivityType.owl#","prefix":"ct","uri":"http://www.tele.pw.edu.pl/~sims-onto/ConnectivityType.owl","titles":[{"value":"Connectivity types","lang":"en","_id":"55bb59c67459b3975b63c028"}]},{"nsp":"http://commontag.org/ns#","prefix":"ctag","uri":"http://commontag.org/ns#","titles":[{"value":"Common Tag Vocabulary","lang":"en","_id":"55a0d19257613119099c0fff"}]},{"uri":"https://w3id.org/arco/ontology/catalogue","nsp":"https://w3id.org/arco/ontology/catalogue/","prefix":"ctlog","titles":[{"value":"Catalogue Ontology (ArCo network)","lang":"en","_id":"5db0548b581233d82940d2c8"}]},{"uri":"https://w3id.org/cto","nsp":"https://w3id.org/cto#","prefix":"cto","titles":[{"value":"CTO: Construction Tasks Ontology","lang":"en","_id":"6038cb4113698c270be20d95"}]},{"nsp":"http://purl.org/ctic/infraestructuras/organizacion#","prefix":"ctorg","uri":"http://purl.org/ctic/infraestructuras/organizacion","titles":[{"value":"Vocabulario de la estructura de organismos p\xfablicos","lang":"es","_id":"6326e9c2121504032603c3f2"},{"value":"Vocabulary for the structure of the public organizations","lang":"en","_id":"6326e9c2121504032603c3f1"}]},{"uri":"https://w3id.org/ibp/CTRLont","nsp":"https://w3id.org/ibp/CTRLont#","prefix":"ctrl","titles":[{"value":"CTRLont - An ontology to formally specify the control domain","lang":"en","_id":"5cc863223c9ea81c2a69ab68"}]},{"nsp":"http://www.demcare.eu/ontologies/contextdescriptor.owl#","prefix":"ctxdesc","uri":"http://www.demcare.eu/ontologies/contextdescriptor.owl","titles":[{"value":"Context Descriptor Pattern","lang":"en","_id":"5624b6a942fc695f7e69522c"}]},{"nsp":"http://purl.org/cwmo/#","prefix":"cwmo","uri":"http://purl.org/cwmo/#","titles":[{"value":"Creative Workshop Management Ontology (CWMO)","lang":"en","_id":"58e3c9c4f6baaa6b1ab1eb0f"}]},{"nsp":"http://www.bbc.co.uk/ontologies/creativework/","prefix":"cwork","uri":"http://www.bbc.co.uk/ontologies/creativework","titles":[{"value":"Creative Work Ontology","lang":"en","_id":"578369050183b1e80fc8755a"}]},{"nsp":"http://sparql.cwrc.ca/ontologies/cwrc#","prefix":"cwrc","uri":"http://sparql.cwrc.ca/ontologies/cwrc","titles":[{"value":"L\'Ontologie CWRC","lang":"fr","_id":"594a863d91b367211b350e1e"},{"value":"The CWRC Ontology","lang":"en","_id":"594a863d91b367211b350e1d"}]},{"nsp":"http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1#","prefix":"d2rq","uri":"http://www.wiwiss.fu-berlin.de/suhl/bizer/D2RQ/0.1","titles":[{"value":"D2RQ - Language Specification","lang":"en","_id":"56719ed04ee7f7176fe64bfd"}]},{"nsp":"http://purl.org/NET/dady#","prefix":"dady","uri":"http://vocab.deri.ie/dady","titles":[{"value":"Dataset Dynamics (dady) vocabulary","lang":"en","_id":"55d72b39e4ac2b1c4c5a50d7"}]},{"nsp":"http://purl.org/ontology/daia/","prefix":"daia","uri":"http://purl.org/ontology/daia","titles":[{"value":"Document Availability Information Ontology","lang":"en","_id":"569f9677ff8848f96bd21304"}]},{"nsp":"http://purl.org/eis/vocab/daq#","prefix":"daq","uri":"http://purl.org/eis/vocab/daq#","titles":[{"value":"Dataset Quality Vocabulary","lang":"en","_id":"559aaf5e1928827f4b0133ff"}]},{"nsp":"http://dataid.dbpedia.org/ns/core#","prefix":"dataid","uri":"http://dataid.dbpedia.org/ns/core#","titles":[{"value":"DataID","lang":"en","_id":"57d906bb812207ab034e4c18"}]},{"nsp":"http://contextus.net/ontology/ontomedia/misc/date#","prefix":"date","uri":"http://contextus.net/ontology/ontomedia/misc/date#","titles":[{"value":"OntoMedia Date Part Representation","lang":"en","_id":"58eb8132abe2639e2c3ac8c1"}]},{"nsp":"http://vocab.datex.org/terms#","prefix":"datex","uri":"http://vocab.datex.org/terms#","titles":[{"value":"Linked Datex II","lang":"en","_id":"575e6f74a7910dac495e4e28"}]},{"nsp":"http://theme-e.adaptcentre.ie/dave#","prefix":"dave","uri":"http://theme-e.adaptcentre.ie/dave/dave.ttl","titles":[{"value":"Data Value Vocabulary (DaVe)","lang":"en","_id":"5a254c923d405e60384f2d29"}]},{"uri":"https://w3id.org/dba/ontology/","nsp":"https://w3id.org/dba/ontology/","prefix":"dba","titles":[{"value":"Description Banking Archives Ontology","lang":"en","_id":"61d583fdb7d3952f63200247"}]},{"nsp":"http://purl.org/net/dbm/ontology#","prefix":"dbm","uri":"http://purl.org/net/dbm/ontology#","titles":[{"value":"DBM Ontology","lang":"en","_id":"57d27628a3a9d3a63d7e6270"}]},{"nsp":"http://ontology.cybershare.utep.edu/dbowl/relational-to-ontology-mapping-primitive.owl#","prefix":"dbowl","uri":"http://ontology.cybershare.utep.edu/dbowl","titles":[{"value":"Relational to Ontology Mapping Primitive","lang":"en","_id":"576968874a73263716312e2d"}]},{"nsp":"http://dbpedia.org/ontology/","prefix":"dbpedia-owl","uri":"http://dbpedia.org/ontology/","titles":[{"value":"The DBpedia Ontology","lang":"en","_id":"57d2ae3fa3a9d3a63d7e7c4a"}]},{"nsp":"http://ontologi.es/doap-bugs#","prefix":"dbug","uri":"http://ontologi.es/doap-bugs#","titles":[{"value":"DOAP Bugs","lang":"en","_id":"5788bca38c6f955d29bf1fc5"}]},{"nsp":"http://purl.org/dc/dcam/","prefix":"dcam","uri":"http://purl.org/dc/dcam/","titles":[{"value":"DCMI Abstract Model","lang":"en","_id":"5dacdfd58b936c5b59e22a94"}]},{"nsp":"http://www.w3.org/ns/dcat#","prefix":"dcat","uri":"http://www.w3.org/ns/dcat","titles":[{"value":"Data Catalog Vocabulary","lang":"en","_id":"5f9efd5dfdbf2d3c39c0071f"}]},{"nsp":"http://purl.org/dc/elements/1.1/","prefix":"dce","uri":"http://purl.org/dc/elements/1.1/","titles":[{"value":"Dublin Core Metadata Element Set","lang":"en","_id":"5dace1d28b936c5b59e22aa6"}]},{"nsp":"http://purl.org/spar/datacite/","prefix":"dcite","uri":"http://purl.org/spar/datacite","titles":[{"value":"The DataCite Ontology","lang":"en","_id":"55bb5f927459b3975b63c064"}]},{"nsp":"http://ndl.go.jp/dcndl/terms/","prefix":"dcndl","uri":"http://ndl.go.jp/dcndl/terms/","titles":[{"value":"NDL Metadata Terms","lang":"en","_id":"5cfa12bda83ab4061e10b66d"}]},{"uri":"https://w3id.org/dco","nsp":"https://w3id.org/dco#","prefix":"dco","titles":[{"value":"domOS Common Ontology","lang":"en","_id":"61a769dfbf34bcf5590f0ab5"}]},{"nsp":"http://purl.org/dc/terms/","prefix":"dcterms","uri":"http://purl.org/dc/terms/","titles":[{"value":"DCMI Metadata Terms","lang":"en","_id":"5b633475fe90868e587d2001"}]},{"nsp":"http://purl.org/dc/dcmitype/","prefix":"dctype","uri":"http://purl.org/dc/dcmitype/","titles":[{"value":"DCMI Type Vocabulary","lang":"en","_id":"5697b75eff8848f96bd12b10"}]},{"uri":"https://w3id.org/arco/ontology/denotative-description","nsp":"https://w3id.org/arco/ontology/denotative-description/","prefix":"ddesc","titles":[{"value":"Denotative Description Ontology (ArCo network)","lang":"en","_id":"5db03af5581233d82940d288"}]},{"nsp":"https://decision-ontology.googlecode.com/svn/trunk/decision.owl#","prefix":"decision","uri":"https://decision-ontology.googlecode.com/svn/trunk/decision.owl","titles":[{"value":"Decision ontology","lang":"en","_id":"584840948a0d14e34d5eb88a"}]},{"nsp":"http://www.demcare.eu/ontologies/demlab.owl#","prefix":"demlab","uri":"http://www.demcare.eu/ontologies/demlab.owl","titles":[{"value":"Dem@Care Lab Ontology for Dementia Assessment","lang":"en","_id":"56ae4d4f98f0192c57ea0261"}]},{"nsp":"http://purl.org/spar/deo/","prefix":"deo","uri":"http://purl.org/spar/deo","titles":[{"value":"The Discourse Elements Ontology","lang":"en","_id":"55d72e72e4ac2b1c4c5a5158"}]},{"nsp":"http://ontologi.es/doap-deps#","prefix":"deps","uri":"http://ontologi.es/doap-deps#","titles":[{"value":"DOAP Dependencies","lang":"en","_id":"5784e1270183b1e80fc90546"}]},{"uri":"http://static.datafoodconsortium.org/ontologies/DFC_FullModel.owl","nsp":"http://static.datafoodconsortium.org/ontologies/DFC_FullModel.owl#","prefix":"dfc","titles":[{"value":"Data Food Consortium Ontology","lang":"en","_id":"60115d948d57f51b29adfe81"}]},{"uri":"http://static.datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl","nsp":"http://static.datafoodconsortium.org/ontologies/DFC_BusinessOntology.owl#","prefix":"dfc-b","titles":[{"value":"DFC Business Ontology","lang":"en","_id":"60115eeb8d57f51b29adfe9f"}]},{"uri":"http://static.datafoodconsortium.org/ontologies/DFC_ProductGlossary.owl","nsp":"http://static.datafoodconsortium.org/ontologies/DFC_ProductGlossary.owl#","prefix":"dfc-p","titles":[{"value":"A common vocabulary for digital food platforms (Product Glossary Part)","lang":"en","_id":"601162cdc6bbc8992d5655d3"}]},{"uri":"http://static.datafoodconsortium.org/ontologies/DFC_TechnicalOntology.owl","nsp":"http://static.datafoodconsortium.org/ontologies/DFC_TechnicalOntology.owl#","prefix":"dfc-t","titles":[{"value":"A common vocabulary for digital food platforms (Technical Part)","lang":"en","_id":"601160d18d57f51b29adfebf"}]},{"uri":"https://w3id.org/dingo/","nsp":"https://w3id.org/dingo#","prefix":"dg","titles":[{"value":"DINGO Ontology","lang":"en","_id":"5f1aed9b388540d23b85cf6b"}]},{"nsp":"http://purl.org/healthcarevocab/v1#","prefix":"dicom","uri":"http://purl.org/healthcarevocab/v1","titles":[{"value":"Healthcare metadata - DICOM ontology","lang":"en","_id":"567e6cb64ee7f7176fea7b5f"}]},{"nsp":"https://w3id.org/dio#","prefix":"dio","uri":"https://w3id.org/dio","titles":[{"value":"The Design Intent Ontology","lang":"en","_id":"569fcc8fff8848f96bd2385a"}]},{"nsp":"http://rdf-vocabulary.ddialliance.org/discovery#","prefix":"disco","uri":"http://rdf-vocabulary.ddialliance.org/discovery","titles":[{"value":"DDI-RDF Discovery Vocabulary","lang":"en","_id":"586ba6417e341093492c476c"}]},{"nsp":"http://purl.org/dita/ns#","prefix":"dita","uri":"http://purl.org/dita/ns#","titles":[{"value":"DITA RDF ontology","lang":"en","_id":"5788be8f8c6f955d29bf207c"}]},{"nsp":"http://www.data-knowledge.org/dk/","prefix":"dk","uri":"http://www.data-knowledge.org/dk/","titles":[{"value":"The Data Knowledge Vocabulary","lang":"en","_id":"5abb62460d8ceb4e01493ec2"},{"value":"Das Data-Knowledge-Vokabular","lang":"de","_id":"5abb62460d8ceb4e01493ec1"}]},{"nsp":"http://onto.dm2e.eu/schemas/dm2e/","prefix":"dm2e","uri":"http://onto.dm2e.eu/schemas/dm2e","titles":[{"value":"DM2E model","lang":"en","_id":"578d036d8c6f955d29c02b9f"}]},{"nsp":"http://d-nb.info/standards/elementset/dnb#","prefix":"dnbt","uri":"http://d-nb.info/standards/elementset/dnb","titles":[{"value":"DNB Metadata Terms","lang":"en","_id":"5c486f14d7048abc5cc35ee2"}]},{"nsp":"http://usefulinc.com/ns/doap#","prefix":"doap","uri":"http://usefulinc.com/ns/doap#","titles":[{"value":"Description of a Project vocabulary","lang":"en","_id":"57d2ceb7a3a9d3a63d7e8b48"}]},{"nsp":"http://www.w3.org/2000/10/swap/pim/doc#","prefix":"doc","uri":"http://www.w3.org/2000/10/swap/pim/doc","titles":[{"value":"Works, licences, derivatives and dependencies","lang":"en","_id":"586baa787e341093492c4882"}]},{"nsp":"http://purl.org/spar/doco/","prefix":"doco","uri":"http://purl.org/spar/doco","titles":[{"value":"DoCO, the Document Components Ontology","lang":"en","_id":"5bf281e02a4bb83670a7ba12"}]},{"nsp":"http://purl.org/ontology/dso#","prefix":"docso","uri":"http://purl.org/ontology/dso","titles":[{"value":"Document Service Ontology","lang":"en","_id":"63248a03f0004aba7af3f893"}]},{"nsp":"http://elite.polito.it/ontologies/dogont","prefix":"dogont","uri":"http://elite.polito.it/ontologies/dogont.owl","titles":[{"value":"Ontology Modeling for Intelligent Domotic Environments","lang":"en","_id":"5cdd0e17624369723924cb70"}]},{"nsp":"http://reference.data.gov.au/def/ont/dataset#","prefix":"donto","uri":"http://reference.data.gov.au/def/ont/dataset","titles":[{"value":"Dataset Ontology","lang":"en","_id":"5ad8adf22e909b214fc2d206"}]},{"uri":"https://w3id.org/dot#","nsp":"https://w3id.org/dot#","prefix":"dot","titles":[{"value":"Damage Topology Ontology","lang":"en","_id":"5fae670ab5c44be746694897"}]},{"nsp":"http://purl.org/dpn#","prefix":"dpn","uri":"http://purl.org/dpn","titles":[{"value":"Data Provider Node ontology","lang":"en","_id":"57223579b5cce30e4a33f4cd"}]},{"nsp":"http://promsns.org/def/do#","prefix":"dprov","uri":"http://promsns.org/def/decprov","titles":[{"value":"Decision Provenance ontology (DecPROV)","lang":"en","_id":"5a4145efb201efd03d3afa2a"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality#","prefix":"dq","uri":"http://def.seegrid.csiro.au/isotc211/iso19115/2003/dataquality","titles":[{"value":"OWL representation of ISO 19115 (Geographic Information - Metadata - Data quality package)","lang":"en","_id":"568a55274ee7f7176ff10eb6"}]},{"nsp":"http://semwebquality.org/ontologies/dq-constraints#","prefix":"dqc","uri":"http://semwebquality.org/ontologies/dq-constraints","titles":[{"value":"The Data Quality Constraints Library","lang":"en","_id":"586ba7e87e341093492c477b"}]},{"nsp":"http://purl.org/dqm-vocabulary/v1/dqm#","prefix":"dqm","uri":"http://purl.org/dqm-vocabulary/v1/dqm","titles":[{"value":"The Data Quality Management Vocabulary","lang":"en","_id":"55a6349e57613119099c3516"}]},{"nsp":"http://www.w3.org/ns/dqv#","prefix":"dqv","uri":"http://www.w3.org/ns/dqv","titles":[{"value":"Data Quality Vocabulary","lang":"en","_id":"587e4f137e341093493c3b8e"}]},{"nsp":"http://purl.org/swan/2.0/discourse-relationships/","prefix":"dr","uri":"http://purl.org/swan/2.0/discourse-relationships/","titles":[{"value":"Discourse relationships vocabulary","lang":"en","_id":"55d7310de4ac2b1c4c5a51b8"}]},{"uri":"http://www.purl.org/drammar","nsp":"http://www.purl.org/drammar#","prefix":"drama","titles":[{"value":"Drammar: a comprehensive ontology of drama","lang":"en","_id":"5dce66f4372cf4662a0554f8"}]},{"nsp":"http://vocab.data.gov/def/drm#","prefix":"drm","uri":"http://vocab.data.gov/def/drm","titles":[{"value":"Data Reference Model","lang":"en","_id":"567e6bd24ee7f7176fea7b57"}]},{"nsp":"http://purl.org/ctic/dcat#","prefix":"ds","uri":"http://purl.org/ctic/dcat#","titles":[{"value":"Dataset Catalog Vocabulary","lang":"en","_id":"560655948f7ad2ce3438d4ca"}]},{"uri":"http://dqm.faw.jku.at/ontologies/dsd","nsp":"http://dqm.faw.jku.at/ontologies/dsd#","prefix":"dsd","titles":[{"value":"Description of a Data Source","lang":"en","_id":"62b9a9bc749168e60eb2312b"}]},{"nsp":"http://purl.org/dsnotify/vocab/eventset/","prefix":"dsn","uri":"http://purl.org/dsnotify/vocab/eventset/","titles":[{"value":"DSNotify Eventsets: A vocabulary for change events in linked data sources","lang":"en","_id":"55d731d7e4ac2b1c4c5a51dc"}]},{"nsp":"http://inference-web.org/2.0/ds.owl#","prefix":"dso","uri":"http://inference-web.org/2.0/ds.owl","titles":[{"value":"Data Structure Ontology","lang":"en","_id":"578d04fc8c6f955d29c02c3c"}]},{"uri":"http://cef.uv.es/lodroadtran18/def/transporte/dtx_srti","nsp":"http://cef.uv.es/lodroadtran18/def/transporte/dtx_srti#","prefix":"dtx_srti","titles":[{"value":"LOD SRTI DATEX II","lang":"en","_id":"63480071d5c74e27718ddda2"}]},{"nsp":"http://www.linkedmodel.org/schema/dtype#","prefix":"dtype","uri":"http://www.linkedmodel.org/schema/dtype","titles":[{"value":"Datatype Ontology","lang":"en","_id":"55ae826dcff711cc3f2b1898"}]},{"nsp":"http://www.ontologydesignpatterns.org/ont/dul/DUL.owl#","prefix":"dul","uri":"http://www.ontologydesignpatterns.org/ont/dul/DUL.owl","titles":[{"value":"DOLCE+DnS Ultralite","lang":"en","_id":"58eb972dabe2639e2c3ae112"}]},{"nsp":"http://www.w3.org/ns/duv#","prefix":"duv","uri":"http://www.w3.org/ns/duv","titles":[{"value":"Dataset Usage Vocabulary","lang":"en","_id":"5dad706d98c7a8076a14d5e9"}]},{"nsp":"http://purl.org/ontology/dvia#","prefix":"dvia","uri":"http://purl.org/ontology/dvia","titles":[{"value":"The visualization vocabulary for LOD applications","lang":"en","_id":"576a8e7e4a73263716317b8d"}]},{"nsp":"http://archivi.ibc.regione.emilia-romagna.it/ontology/eac-cpf/","prefix":"eac-cpf","uri":"http://archivi.ibc.regione.emilia-romagna.it/ontology/eac-cpf/","titles":[{"value":"EAC-CPF Descriptions Ontology for Linked Archival Data:","lang":"en","_id":"57d2ceeda3a9d3a63d7e8b6b"}]},{"nsp":"http://www.w3.org/ns/earl#","prefix":"earl","uri":"http://www.w3.org/ns/earl","titles":[{"value":"Evaluation and Report Language","lang":"en","_id":"568be9814ee7f7176ff12517"}]},{"nsp":"http://linked.earth/ontology#","prefix":"earth","uri":"http://linked.earth/ontology#","titles":[{"value":"The Linked Earth Ontology","lang":"en","_id":"57692ff64a73263716311e06"}]},{"uri":"http://data.businessgraph.io/ontology#","nsp":"http://data.businessgraph.io/ontology#","prefix":"ebg","titles":[{"value":"euBusinessGraph ontology","lang":"en","_id":"60141943a63b96c815bc4dc2"}]},{"nsp":"http://www.ebu.ch/metadata/ontologies/ebucore/ebucore#","prefix":"ebucore","uri":"http://www.ebu.ch/metadata/ontologies/ebucore/ebucore","titles":[{"value":"EBU Ontology","lang":"en","_id":"56ae523698f0192c57ea02a4"}]},{"nsp":"https://vocab.eccenca.com/revision/","prefix":"eccrev","uri":"https://vocab.eccenca.com/revision/","titles":[{"value":"RDF changes and revisions vocabulary","lang":"en","_id":"56e69473aacd7f0864390f9a"}]},{"nsp":"http://www.eclap.eu/schema/eclap/","prefix":"eclap","uri":"http://www.eclap.eu/schema/eclap/","titles":[{"value":"ECLAP, Performing Arts Vocabulary","lang":"en","_id":"55cde768e4ac2b1c4c59a51b"}]},{"nsp":"http://purl.org/ontology/ecpo#","prefix":"ecpo","uri":"http://purl.org/ontology/ecpo","titles":[{"value":"Enumeration and Chronology of Periodicals Ontology","lang":"en","_id":"586bacd87e341093492c48b3"}]},{"nsp":"http://erlangen-crm.org/current/","prefix":"ecrm","uri":"http://erlangen-crm.org/current/","titles":[{"value":"Erlangen CRM / OWL","lang":"en","_id":"586bd89e7e341093492c5123"}]},{"nsp":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl#","prefix":"edac","uri":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-edac.owl","titles":[{"value":"ELSEWeb EDAC Ontology","lang":"en","_id":"56af776998f0192c57ea9391"}]},{"nsp":"http://www.europeana.eu/schemas/edm/","prefix":"edm","uri":"http://www.europeana.eu/schemas/edm/","titles":[{"value":"Europeana Data Model vocabulary","lang":"en","_id":"55d732bde4ac2b1c4c5a5211"}]},{"uri":"https://schema.edu.ee/","nsp":"https://schema.edu.ee/","prefix":"edu","titles":[{"value":"Education Ontology","lang":"en","_id":"5ec64d33a4efa76e1c8bb146"},{"value":"Hariduse ontoloogia","lang":"et","_id":"5ec64d33a4efa76e1c8bb145"}]},{"uri":"http://ns.inria.fr/semed/eduprogression/","nsp":"http://ns.inria.fr/semed/eduprogression#","prefix":"edupro","titles":[{"value":"EduProgression Ontology","lang":"en","_id":"5c669c0a6c1cff773137ac17"}]},{"nsp":"http://purl.org/eem#","prefix":"eem","uri":"http://purl.org/eem","titles":[{"value":"The EPCIS Event Model","lang":"en","_id":"553e9cf1581958526a68e5d8"}]},{"uri":"https://w3id.org/eeo","nsp":"https://w3id.org/eeo#","prefix":"eeo","titles":[{"value":"Experimental Evaluation Ontology","lang":"en","_id":"5fc66d2784c552d10a3f32d1"}]},{"nsp":"https://w3id.org/eepsa#","prefix":"eepsa","uri":"https://w3id.org/eepsa","titles":[{"value":"EEPSA (Energy Efficiency Prediction Semantic Assistant) Ontology","lang":"en","_id":"5a92c32167d9427a394ca305"}]},{"uri":"https://opendata.aragon.es/def/ei2a/ei2a.owl","nsp":"http://opendata.aragon.es/def/ei2a#","prefix":"ei2a","titles":[{"value":"Aragon Interoperable Information Structure Ontology\\nEI2A","lang":"en","_id":"5c498db59e5c7dfa7bfd1e93"}]},{"nsp":"http://purl.org/ctic/sector-publico/elecciones#","prefix":"elec","uri":"http://purl.org/ctic/sector-publico/elecciones","titles":[{"value":"Vocabulario de Resultados Electorales","lang":"es","_id":"578d05298c6f955d29c02c43"},{"value":"Vocabulary for Vote Results","lang":"en","_id":"578d05298c6f955d29c02c42"}]},{"nsp":"http://data.europa.eu/eli/ontology#","prefix":"eli","uri":"http://data.europa.eu/eli/ontology","titles":[{"value":"The European Legislation Identifier","lang":"en","_id":"5b0fcb39f79aa03849eabe1c"}]},{"nsp":"http://ns.inria.fr/emoca#","prefix":"emotion","uri":"http://ns.inria.fr/emoca","titles":[{"value":"Emotion Ontology for Context Awareness","lang":"en","_id":"5691702fb7cea413588f958c"}]},{"nsp":"http://purl.org/ctic/empleo/oferta#","prefix":"emp","uri":"http://purl.org/ctic/empleo/oferta","titles":[{"value":"Vocabulario de Ofertas de Empleo","lang":"es","_id":"56a6abce37d8a8044b2670cc"},{"value":"A vocabulary for jobs","lang":"en","_id":"56a6abce37d8a8044b2670cb"}]},{"nsp":"http://labs.mondeca.com/vocab/endpointStatus#","prefix":"ends","uri":"http://labs.mondeca.com/vocab/endpointStatus","titles":[{"value":"Vocabulary of endpoint status (availability, responseTime)","lang":"en","_id":"55d73331e4ac2b1c4c5a522d"}]},{"nsp":"http://eprints.org/ontology/","prefix":"ep","uri":"http://eprints.org/ontology/","titles":[{"value":"EPrints Ontology","lang":"en","_id":"55d735d6e4ac2b1c4c5a52a8"}]},{"uri":"https://w3id.org/ep-plan","nsp":"https://w3id.org/ep-plan#","prefix":"eppl","titles":[{"value":"The EP-Plan ontology","lang":"en","_id":"5cb30645470a172015caa334"}]},{"nsp":"https://data.nasa.gov/ontologies/atmonto/equipment#","prefix":"eqp","uri":"https://data.nasa.gov/ontologies/atmonto/equipment#","titles":[{"value":"Aircraft Equipment Vocabulary","lang":"en","_id":"5ad89378a236156c49539cfa"}]},{"uri":"http://data.europa.eu/esco/model","nsp":"http://data.europa.eu/esco/model#","prefix":"esco","titles":[{"value":"The ESCO ontology","lang":"en","_id":"5da74883db65682853c6e1d0"}]},{"nsp":"http://purl.org/essglobal/vocab/","prefix":"essglobal","uri":"http://purl.org/essglobal/vocab/","titles":[{"value":"ESSGlobal Vocabulary","lang":"en","_id":"5549338bb6189eea2262b0c8"}]},{"uri":"http://elite.polito.it/ontologies/eupont.owl","nsp":"http://elite.polito.it/ontologies/eupont.owl#","prefix":"eupont","titles":[{"value":"EUPont: an ontology for End User Programming of the IoT","lang":"en","_id":"5bc4a88a3bf18c902a0fe53f"}]},{"nsp":"http://purl.org/NET/c4dm/event.owl#","prefix":"event","uri":"http://purl.org/NET/c4dm/event.owl","titles":[{"value":"The Event Ontology","lang":"en","_id":"5a36c89aece6c50213eee4b3"}]},{"nsp":"http://purl.org/net/ns/ex#","prefix":"ex","uri":"http://purl.org/net/ns/ex","titles":[{"value":"Example vocabulary","lang":"en","_id":"5cfa1260a83ab4061e10b660"}]},{"nsp":"http://www.w3.org/2003/12/exif/ns#","prefix":"exif","uri":"http://www.w3.org/2003/12/exif/ns","titles":[{"value":"Exif data description vocabulary","lang":"en","_id":"57d2d0d7a3a9d3a63d7e8c51"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19115/2003/extent#","prefix":"ext","uri":"http://def.seegrid.csiro.au/isotc211/iso19115/2003/extent","titles":[{"value":"OWL representation of ISO 19115 (Geographic Information - Metadata - Extent package)","lang":"en","_id":"55bca7e37459b3975b63ca9a"}]},{"nsp":"http://purl.org/spar/fabio/","prefix":"fabio","uri":"http://purl.org/spar/fabio","titles":[{"value":"FRBR-aligned Bibliographic Ontology","lang":"en","_id":"5ca1c571aa7b2a694adc746c"}]},{"nsp":"http://biohackathon.org/resource/faldo#","prefix":"faldo","uri":"http://biohackathon.org/resource/faldo","titles":[{"value":"Feature Annotation Location Description Ontology","lang":"en","_id":"5a251b4e3d405e60384ebde6"}]},{"nsp":"http://vocab.data.gov/def/fea#","prefix":"fea","uri":"http://vocab.data.gov/def/fea","titles":[{"value":"Federal Enterprise Architecture Vocabulary","lang":"en","_id":"55abcb9c57613119099d7ba1"}]},{"uri":"http://w3id.org/vcb/fel#","nsp":"http://w3id.org/vcb/fel#","prefix":"fel","titles":[{"value":"A Fine-grained Entity Linking vocabulary","lang":"en","_id":"5db17ad35433bbf424c65993"}]},{"nsp":"http://purl.org/iot/ontology/fiesta-iot#","prefix":"fiesta-iot","uri":"http://purl.org/iot/ontology/fiesta-iot","titles":[{"value":"FIESTA-IoT Ontology","lang":"en","_id":"58e49ea8f6baaa6b1ab291bf"}]},{"uri":"http://purl.org/iot/ontology/fiesta-priv#","nsp":"http://purl.org/iot/ontology/fiesta-iot#","prefix":"fiesta-priv","titles":[{"value":"FIESTA-Priv Ontology","lang":"en","_id":"5f2d3298f1a48001181ada3f"}]},{"nsp":"http://xmlns.com/foaf/0.1/","prefix":"foaf","uri":"http://xmlns.com/foaf/0.1/","titles":[{"value":"Friend of a Friend vocabulary","lang":"en","_id":"5da81d9589eb3bf7665c24f3"}]},{"uri":"https://w3id.org/fog","nsp":"https://w3id.org/fog#","prefix":"fog","titles":[{"value":"FOG: File Ontology for Geometry formats","lang":"en","_id":"5d1c6a2eb97ed46e3dc5e191"}]},{"nsp":"https://w3id.org/seas/FeatureOfInterestOntology/","prefix":"foio","uri":"https://w3id.org/seas/FeatureOfInterestOntology","titles":[{"value":"The SEAS Feature of Interest ontology.","lang":"en","_id":"5841771b6002ada739d039d9"}]},{"nsp":"http://data.lirmm.fr/ontologies/food#","prefix":"food","uri":"http://data.lirmm.fr/ontologies/food","titles":[{"value":"Food Ontology","lang":"en","_id":"5dc00b8ab22aa88127c1ae0c"}]},{"nsp":"http://www.w3.org/TR/2003/PR-owl-guide-20031209/food#","prefix":"fowl","uri":"http://www.w3.org/TR/2003/PR-owl-guide-20031215/food","titles":[{"value":"Food Ontology in OWL","lang":"en","_id":"56c595b82ba77c902f47551e"}]},{"nsp":"http://iflastandards.info/ns/fr/frad/","prefix":"frad","uri":"http://iflastandards.info/ns/fr/frad/","titles":[{"value":"FRAD model","lang":"en","_id":"55bcb4317459b3975b63cb10"}]},{"nsp":"http://purl.org/cerif/frapo/","prefix":"frapo","uri":"http://purl.org/cerif/frapo/","titles":[{"value":"Funding, Research Administration and Projects Ontology","lang":"en","_id":"586bad0d7e341093492c48ba"}]},{"nsp":"http://streamreasoning.org/ontologies/frappe#","prefix":"frappe","uri":"http://streamreasoning.org/ontologies/frappe#","titles":[{"value":"FraPPE: Frame, Pixel, Place, Event vocabulary","lang":"en","_id":"55258c6800191ee77225badd"}]},{"nsp":"http://purl.org/vocab/frbr/core#","prefix":"frbr","uri":"http://purl.org/vocab/frbr/core","titles":[{"value":"Expression of Core FRBR Concepts in RDF","lang":"en","_id":"55a9000a57613119099c4b61"}]},{"nsp":"http://purl.org/vocab/frbr/extended#","prefix":"frbre","uri":"http://purl.org/vocab/frbr/extended","titles":[{"value":"Extended FRBR","lang":"en","_id":"554740c3924aca1164f28a75"}]},{"nsp":"http://iflastandards.info/ns/fr/frbr/frbrer/","prefix":"frbrer","uri":"http://iflastandards.info/ns/fr/frbr/frbrer/","titles":[{"value":"FRBRer model","lang":"en","_id":"55bb69c17459b3975b63c0d5"}]},{"nsp":"http://www.w3.org/2004/09/fresnel#","prefix":"fresnel","uri":"http://www.w3.org/2004/09/fresnel","titles":[{"value":"Fresnel Lens and Format Core Vocabulary","lang":"en","_id":"561c02da42fc695f7e67253d"}]},{"nsp":"http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/","prefix":"g50k","uri":"http://data.ordnancesurvey.co.uk/ontology/50kGazetteer/","titles":[{"value":"50K Gazetteer Vocabulary","lang":"en","_id":"55bb5c687459b3975b63c03f"}]},{"nsp":"http://data.totl.net/game/","prefix":"game","uri":"http://data.totl.net/game/","titles":[{"value":"TotL Game Ontology","lang":"en","_id":"5784e0820183b1e80fc904e0"}]},{"nsp":"http://www.oegov.org/core/owl/gc#","prefix":"gc","uri":"http://www.oegov.org/core/owl/gc","titles":[{"value":"oeGOV Government Core Ontology","lang":"en","_id":"55d733fbe4ac2b1c4c5a5250"}]},{"nsp":"http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl#","prefix":"gci","uri":"http://ontology.eil.utoronto.ca/GCI/Foundation/GCI-Foundation.owl","titles":[{"value":"Global City Indicator Foundation Ontology","lang":"en","_id":"552fa52bd945656b497885fc"}]},{"uri":"https://w3id.org/GConsent","nsp":"https://w3id.org/GConsent#","prefix":"gcon","titles":[{"value":"GConsent - a consent ontology based on the GDPR","lang":"en","_id":"5c62adf8a43464be5563cb3d"}]},{"nsp":"http://reference.data.gov/def/govdata/","prefix":"gd","uri":"http://vocab.data.gov/gd","titles":[{"value":"Government Data Vocabulary","lang":"en","_id":"55abd15a57613119099d7fb1"}]},{"uri":"https://w3id.org/GDPRov","nsp":"https://w3id.org/GDPRov#","prefix":"gdprov","titles":[{"value":"The GDPR Provenance ontology","lang":"en","_id":"5c62d070eff3ff9e5c8bc1de"}]},{"uri":"https://w3id.org/GDPRtEXT","nsp":"https://w3id.org/GDPRtEXT#","prefix":"gdprt","titles":[{"value":"GDPR text EXTensions","lang":"en","_id":"5c62cee4a43464be5563cbb9"}]},{"nsp":"http://purl.org/gen/0.1#","prefix":"gen","uri":"http://purl.org/gen/0.1#","titles":[{"value":"Vocabulary for Linked Genealogical Data","lang":"en","_id":"55d73681e4ac2b1c4c5a52c2"}]},{"nsp":"http://www.w3.org/2003/01/geo/wgs84_pos#","prefix":"geo","uri":"http://www.w3.org/2003/01/geo/wgs84_pos","titles":[{"value":"WGS84 Geo Positioning","lang":"en","_id":"57696ba14a73263716312e53"}]},{"nsp":"http://vocab.lenka.no/geo-deling#","prefix":"geod","uri":"http://vocab.lenka.no/geo-deling","titles":[{"value":"Landinndelingen i Norge","lang":"no","_id":"568a5b4d4ee7f7176ff10efa"},{"value":"Administrative vocabulary for Norway","lang":"en","_id":"568a5b4d4ee7f7176ff10ef9"}]},{"nsp":"http://www.mindswap.org/2003/owl/geo/geoFeatures20040307.owl#","prefix":"geof","uri":"http://www.mindswap.org/2003/owl/geo/geoFeatures20040307.owl","titles":[{"value":"Geo Features","lang":"en","_id":"573347bab5cce30e4a3b7229"}]},{"nsp":"http://data.ign.fr/def/geofla#","prefix":"geofla","uri":"http://data.ign.fr/def/geofla","titles":[{"value":"Ontologie des unit\xe9s administratives de l\'IGN","lang":"fr","_id":"60b6037695b778e06b9a58d0"},{"value":"Ontology of administrative units at IGN-France","lang":"en","_id":"60b6037695b778e06b9a58cf"}]},{"nsp":"http://data.ign.fr/def/geometrie#","prefix":"geom","uri":"http://data.ign.fr/def/geometrie","titles":[{"value":"Ontologie des primitives g\xe9om\xe9triques","lang":"fr","_id":"568a54734ee7f7176ff10eac"},{"value":"Ontology for geometry","lang":"en","_id":"568a54734ee7f7176ff10eab"}]},{"nsp":"http://aims.fao.org/aos/geopolitical.owl#","prefix":"geop","uri":"http://aims.fao.org/aos/geopolitical.owl","titles":[{"value":"FAO Geopolitical Ontology","lang":"en","_id":"55bb5efa7459b3975b63c05b"}]},{"nsp":"http://rdf.geospecies.org/ont/geospecies#","prefix":"geosp","uri":"http://rdf.geospecies.org/ont/geospecies","titles":[{"value":"GeoSpecies Ontology","lang":"en","_id":"55ae8357cff711cc3f2b1949"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature#","prefix":"gf","uri":"http://def.seegrid.csiro.au/isotc211/iso19109/2005/feature","titles":[{"value":"OWL representation of ISO 19109 (General Feature Model)","lang":"en","_id":"55a0fc2157613119099c1156"}]},{"uri":"https://www.gleif.org/ontology/L1/","nsp":"https://www.gleif.org/ontology/L1/","prefix":"gleif-L1","titles":[{"value":"Global Legal Entity Identifier Foundation Level 1 Ontology - Who Is Who","lang":"en","_id":"5d26300be239944f0e0582e1"}]},{"uri":"https://www.gleif.org/ontology/L2/","nsp":"https://www.gleif.org/ontology/L2/","prefix":"gleif-L2","titles":[{"value":"Global Legal Entity Identifier Foundation Level 2 Ontology - Who Owns Whom","lang":"en","_id":"5d2610eaa038485a10d98c53"}]},{"uri":"https://www.gleif.org/ontology/Base/","nsp":"https://www.gleif.org/ontology/Base/","prefix":"gleif-base","titles":[{"value":"Global Legal Entity Identifier Foundation Base Ontology","lang":"en","_id":"5d270fae7905867e22b4587d"}]},{"uri":"https://www.gleif.org/ontology/EntityLegalForm/","nsp":"https://www.gleif.org/ontology/EntityLegalForm/","prefix":"gleif-elf","titles":[{"value":"Entity Legal Form Ontology","lang":"en","_id":"5d2623eacfa360250be1fed3"}]},{"uri":"https://www.gleif.org/ontology/Geocoding/","nsp":"https://www.gleif.org/ontology/Geocoding/","prefix":"gleif-geo","titles":[{"value":"Global Legal Entity Identifier Foundation Geocoding Ontology","lang":"en","_id":"5d2610f4492085c310684b5e"}]},{"uri":"https://www.gleif.org/ontology/RegistrationAuthority/","nsp":"https://www.gleif.org/ontology/RegistrationAuthority/","prefix":"gleif-ra","titles":[{"value":"Global Legal Entity Identifier Foundation Registration Authority Ontology","lang":"en","_id":"5d2613419f33896f11e5b42a"}]},{"uri":"https://www.gleif.org/ontology/ReportingException/","nsp":"https://www.gleif.org/ontology/ReportingException/","prefix":"gleif-repex","titles":[{"value":"Global Legal Entity Identifier Foundation Reporting Exception Ontology","lang":"en","_id":"5d261b590189b6ed059c49e8"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry#","prefix":"gm","uri":"http://def.seegrid.csiro.au/isotc211/iso19107/2003/geometry","titles":[{"value":"OWL representation of ISO 19107 (Geographic Information)","lang":"en","_id":"55bcb0f07459b3975b63caf0"}]},{"nsp":"http://www.opengis.net/ont/gml#","prefix":"gml","uri":"http://www.opengis.net/ont/gml","titles":[{"value":"OGC Geometry","lang":"en","_id":"561e50dd42fc695f7e6770f9"}]},{"nsp":"http://www.geonames.org/ontology#","prefix":"gn","uri":"http://www.geonames.org/ontology","titles":[{"value":"The Geonames ontology","lang":"en","_id":"5f64bbffe19cb3b3685f7f9e"}]},{"nsp":"http://d-nb.info/standards/elementset/gnd#","prefix":"gndo","uri":"http://d-nb.info/standards/elementset/gnd#","titles":[{"value":"GND Ontology","lang":"en","_id":"552f7ca7d945656b497884b1"},{"value":"GND-Ontologie","lang":"de","_id":"552f7ca7d945656b497884b0"}]},{"nsp":"http://purl.org/linguistics/gold/","prefix":"gold","uri":"http://purl.org/linguistics/gold","titles":[{"value":"General Ontology for Linguistic Description","lang":"en","_id":"55d736c5e4ac2b1c4c5a52ce"}]},{"uri":"https://w3id.org/gom","nsp":"https://w3id.org/gom#","prefix":"gom","titles":[{"value":"GOM: Geometry Metadata Ontology","lang":"en","_id":"5db178e05433bbf424c6592b"}]},{"nsp":"http://gov.genealogy.net/ontology.owl#","prefix":"gov","uri":"http://gov.genealogy.net/ontology.owl","titles":[{"value":"Ontology for modelling historic administrative information.","lang":"en","_id":"55ba5d037459b3975b63b9cc"},{"value":"Ontologie zur Modellierung historischer Verwaltungsinformationen.","lang":"de","_id":"55ba5d037459b3975b63b9cb"}]},{"nsp":"http://purl.org/goodrelations/v1#","prefix":"gr","uri":"http://purl.org/goodrelations/v1","titles":[{"value":"The GoodRelations Ontology for Semantic Web-based E-Commerce","lang":"en","_id":"56c5972c2ba77c902f47557d"}]},{"nsp":"http://www.w3.org/2003/g/data-view#","prefix":"grddl","uri":"http://www.w3.org/2003/g/data-view","titles":[{"value":"Gleaning Resource Descriptions from Dialects of Languages Vocabulary","lang":"en","_id":"555d0aaf30f688c94e823643"}]},{"nsp":"http://www.w3.org/2006/gen/ont#","prefix":"gso","uri":"http://www.w3.org/2006/gen/ont","titles":[{"value":"Generic Specific Ontology","lang":"en","_id":"557f47351d5237e823d24eba"}]},{"nsp":"http://www.opengis.net/ont/geosparql#","prefix":"gsp","uri":"http://www.opengis.net/ont/geosparql","titles":[{"value":"OGC GeoSPARQL","lang":"en","_id":"5695030bff8848f96bd10004"}]},{"nsp":"http://vocab.gtfs.org/terms#","prefix":"gtfs","uri":"http://vocab.gtfs.org/terms#","titles":[{"value":"General Transit Feed Specification","lang":"en","_id":"569173f2b7cea413588f9751"}]},{"nsp":"http://resource.geosciml.org/ontology/timescale/gts#","prefix":"gts","uri":"http://resource.geosciml.org/ontology/timescale/gts","titles":[{"value":"Geologic Timescale model","lang":"en","_id":"598ade0488adb933350f5c0c"}]},{"uri":"http://purl.org/nemo/gufo#","nsp":"http://purl.org/nemo/gufo#","prefix":"gufo","titles":[{"value":"gUFO: A Lightweight Implementation of the Unified Foundational Ontology (UFO)","lang":"en","_id":"61a2b023599f8bcd3af0c255"}]},{"nsp":"http://vocab.getty.edu/ontology#","prefix":"gvp","uri":"http://vocab.getty.edu/ontology","titles":[{"value":"Getty Vocabulary Program ontology","lang":"en","_id":"554791ee13b634da681d20ff"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic#","prefix":"h2o","uri":"http://def.seegrid.csiro.au/isotc211/iso19150/-2/2012/basic","titles":[{"value":"Ontology for conversion of ISO/TC 211","lang":"en","_id":"55de157754ef107a63464ae9"}]},{"nsp":"http://sensormeasurement.appspot.com/ont/home/homeActivity#","prefix":"ha","uri":"http://sensormeasurement.appspot.com/ont/home/homeActivity#","titles":[{"value":"Home Activity","lang":"en","_id":"552b9a4b039260ce46e256fc"}]},{"uri":"https://www.w3.org/2019/wot/hypermedia#","nsp":"https://www.w3.org/2019/wot/hypermedia#","prefix":"hctl","titles":[{"value":"Hypermedia Controls Ontology","lang":"en","_id":"5ed4d6b5c7d84a2a049e424b"}]},{"nsp":"http://www.samos.gr/ontologies/helpdeskOnto.owl#","prefix":"hdo","uri":"http://www.samos.gr/ontologies/helpdeskOnto.owl","titles":[{"value":"HelpDesk support Ontology","lang":"en","_id":"569cc974ff8848f96bd16c87"}]},{"nsp":"http://purl.org/net/hifm/ontology#","prefix":"hifm","uri":"http://purl.org/net/hifm/ontology#","titles":[{"value":"HIFM Ontology","lang":"en","_id":"57c3f854a3a9d3a63d7aa354"}]},{"nsp":"http://purl.org/ontology/holding#","prefix":"holding","uri":"http://purl.org/ontology/holding","titles":[{"value":"Holding Ontology","lang":"en"}]},{"nsp":"http://health.data.gov/def/hospital/","prefix":"hosp","uri":"http://vocab.data.gov/hosp","titles":[{"value":"Hospital Vocabulary","lang":"en","_id":"57d2795ca3a9d3a63d7e63e8"}]},{"uri":"https://w3id.org/hpont","nsp":"https://w3id.org/hpont#","prefix":"hpont","titles":[{"value":"The Heat Pump Ontology (HPOnt).","lang":"en","_id":"632477a4f0004aba7af3f7a9"}]},{"nsp":"http://iserve.kmi.open.ac.uk/ns/hrests#","prefix":"hr","uri":"http://iserve.kmi.open.ac.uk/ns/hrests","titles":[{"value":"hRESTS Ontology","lang":"en","_id":"569cc917ff8848f96bd16c76"}]},{"nsp":"http://vcharpenay.github.io/hto/hto.xml#","prefix":"hto","uri":"http://vcharpenay.github.io/hto/hto.xml","titles":[{"value":"Haystack Tagging Ontology","lang":"en","_id":"58099f8b3e5586c53d896497"}]},{"nsp":"http://www.w3.org/2011/http#","prefix":"http","uri":"http://www.w3.org/2011/http","titles":[{"value":"HTTP in RDF","lang":"en","_id":"5691717db7cea413588f9641"}]},{"nsp":"https://www.auto.tuwien.ac.at/downloads/thinkhome/ontology/WeatherOntology.owl","prefix":"hw","uri":"https://www.auto.tuwien.ac.at/downloads/thinkhome/ontology/WeatherOntology.owl","titles":[{"value":"Home Weather","lang":"en","_id":"5809c7653e5586c53d897055"}]},{"nsp":"http://www.w3.org/ns/hydra/core#","prefix":"hydra","uri":"http://www.w3.org/ns/hydra/core","titles":[{"value":"The Hydra Core Vocabulary","lang":"en","_id":"5acccfa03aba5caf50dbec41"}]},{"uri":"https://w3id.org/iadopt/ont","nsp":"https://w3id.org/iadopt/ont/","prefix":"iadopt","titles":[{"value":"I-ADOPT Framework ontology","lang":"en","_id":"638bc6a8e8d209386de14932"}]},{"uri":"https://privatealpha.com/ontology/ibis/1#","nsp":"https://privatealpha.com/ontology/ibis/1#","prefix":"ibis","titles":[{"value":"IBIS Vocabulary","lang":"en","_id":"5c628a18f5c09b905305f954"}]},{"nsp":"http://ontology.eil.utoronto.ca/icontact.owl#","prefix":"ic","uri":"http://ontology.eil.utoronto.ca/icontact.owl","titles":[{"value":"International Contact Ontology: Addresses, phone numbers and emails.","lang":"en","_id":"553602163cc9f6585db5255c"}]},{"uri":"https://w3id.org/iddo","nsp":"https://w3id.org/iddo#","prefix":"iddo","titles":[{"value":"The Interconnected Data Dictionary Ontology (IDDO)","lang":"en","_id":"638bca31e8d209386de14951"}]},{"nsp":"http://rdf.insee.fr/def/demo#","prefix":"idemo","uri":"http://rdf.insee.fr/def/demo","titles":[{"value":"Ontologie d\xe9mographique de l\'INSEE","lang":"fr","_id":"56916cc1b7cea413588f93c1"},{"value":"Demographic ontology from the French Statistics Institute","lang":"en","_id":"56916cc1b7cea413588f93c0"}]},{"nsp":"http://www.identity.org/ontologies/identity.owl#","prefix":"identity","uri":"http://www.identity.org/ontologies/identity.owl","titles":[{"value":"Ontology of digital identity.","lang":"en","_id":"56d2d48c85099278261131de"}]},{"uri":"https://w3id.org/idsa/core","nsp":"https://w3id.org/idsa/core/","prefix":"ids","titles":[{"value":"IDS Information Model","lang":"en","_id":"6001d546bdeefbd86ab78376"}]},{"uri":"https://w3id.org/ifc/IFC4_ADD1","nsp":"https://w3id.org/ifc/IFC4_ADD1#","prefix":"ifc","titles":[{"value":"IFC4_ADD1","lang":"en","_id":"5ecba7ee8217e3242789eb08"}]},{"nsp":"http://rdf.insee.fr/def/geo#","prefix":"igeo","uri":"http://rdf.insee.fr/def/geo","titles":[{"value":"Ontologie g\xe9ographique de l\'INSEE","lang":"fr","_id":"63761f7537bc29b307642007"},{"value":"French Statistical ontology for geolocation","lang":"en","_id":"63761f7537bc29b307642006"}]},{"nsp":"http://data.ign.fr/def/ignf#","prefix":"ignf","uri":"http://data.ign.fr/def/ignf","titles":[{"value":"Ontologie des syst\xe8mes de coordonn\xe9es de r\xe9f\xe9rence","lang":"fr","_id":"5783c1bd0183b1e80fc88032"},{"value":"Ontology of coordinates reference systems","lang":"en","_id":"5783c1bd0183b1e80fc88031"}]},{"nsp":"http://imgpedia.dcc.uchile.cl/ontology#","prefix":"imo","uri":"http://imgpedia.dcc.uchile.cl/ontology","titles":[{"value":"The IMGpedia Ontology","lang":"en","_id":"5aa783bd5177bf47192c0714"},{"value":"La Ontolog\xeda de IMGpedia","lang":"es","_id":"5aa783bd5177bf47192c0713"}]},{"nsp":"http://vocab.resc.info/incident#","prefix":"incident","uri":"http://vocab.resc.info/incident","titles":[{"value":"Vocabulary to describe incident response by emergency services","lang":"en","_id":"55da25a88b5f9f281f4c453b"}]},{"nsp":"http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl#","prefix":"infor","uri":"http://www.ontologydesignpatterns.org/cp/owl/informationrealization.owl","titles":[{"value":"Information Realization","lang":"en","_id":"56a3c65937d8a8044b254263"}]},{"nsp":"http://purl.org/innovation/ns#","prefix":"inno","uri":"http://purl.org/innovation/ns","titles":[{"value":"Ontology for Innovation","lang":"en","_id":"55de165654ef107a63464afd"}]},{"nsp":"http://reference.data.gov.uk/def/intervals/","prefix":"interval","uri":"http://reference.data.gov.uk/def/intervals","titles":[{"value":"Intervals Ontology","lang":"en","_id":"5dace34e8b936c5b59e22abc"}]},{"nsp":"http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl#","prefix":"iol","uri":"http://www.ontologydesignpatterns.org/ont/dul/IOLite.owl","titles":[{"value":"Information Objects ontology","lang":"en","_id":"569cc936ff8848f96bd16c7c"}]},{"nsp":"http://purl.oclc.org/NET/UNIS/fiware/iot-lite#","prefix":"iot-lite","uri":"http://purl.oclc.org/NET/UNIS/fiware/iot-lite#","titles":[{"value":"Iot-lite ontology","lang":"en","_id":"5809c5053e5586c53d896de3"}]},{"uri":"https://w3id.org/iot-tta/","nsp":"https://w3id.org/iot-tta/#","prefix":"iot-tta","titles":[{"value":"Ontology for Internet of Things Technologies, Tools, and Applications","lang":"en","_id":"632b41fac4f7e5f619d4447d"}]},{"nsp":"http://www.irit.fr/recherches/MELODI/ontologies/IoT-O#","prefix":"ioto","uri":"http://www.irit.fr/recherches/MELODI/ontologies/IoT-O","titles":[{"value":"IoT-O","lang":"en","_id":"5809c4e03e5586c53d896dba"}]},{"uri":"http://purl.org/iot/vocab/iot-taxonomy-lite#","nsp":"http://purl.org/iot/vocab/iot-taxonomy-lite#","prefix":"iottaxolite","titles":[{"value":"The IoTTaxonomy-lite Taxonomy","lang":"en","_id":"602287f265d8a4db28f18488"}]},{"nsp":"http://purl.org/ipo/core#","prefix":"ipo","uri":"http://purl.org/ipo/core","titles":[{"value":"IPO - Issue Procedure Ontology","lang":"en","_id":"55e412bca71142386b779a15"}]},{"uri":"http://ontology.ethereal.cz/irao","nsp":"http://ontology.ethereal.cz/irao/","prefix":"irao","titles":[{"value":"Informatics Research Artifacts Ontology","lang":"en","_id":"60afcbe8c3818f4546035954"}]},{"nsp":"http://www.ontologydesignpatterns.org/ont/web/irw.owl#","prefix":"irw","uri":"http://www.ontologydesignpatterns.org/ont/web/irw.owl","titles":[{"value":"The Identity of Resources on the Web ontology","lang":"en","_id":"55de1a0754ef107a63464b2b"}]},{"nsp":"http://purl.org/ontology/is/core#","prefix":"is","uri":"http://purl.org/ontology/is/core#","titles":[{"value":"Info Service Ontology","lang":"en","_id":"55e0591c419d00687563ad6d"}]},{"nsp":"http://iflastandards.info/ns/isbd/elements/","prefix":"isbd","uri":"http://iflastandards.info/ns/isbd/elements/","titles":[{"value":"ISBD elements","lang":"en"}]},{"nsp":"http://purl.org/iso25964/skos-thes#","prefix":"iso-thes","uri":"http://purl.org/iso25964/skos-thes","titles":[{"value":"ISO 25964 SKOS extension","lang":"en","_id":"56a63acf37d8a8044b263a2b"}]},{"nsp":"http://ontology.eil.utoronto.ca/ISO37120.owl#","prefix":"iso37120","uri":"http://ontology.eil.utoronto.ca/ISO37120.owl","titles":[{"value":"ISO 37120 indicator URIs","lang":"en","_id":"5817292fc1b1a26b516f855f"}]},{"nsp":"http://reference.data.gov.au/def/ont/iso19160-1-address#","prefix":"isoadr","uri":"http://reference.data.gov.au/def/ont/iso19160-1-address","titles":[{"value":"ISO19160-1:2015 Address ontology","lang":"en","_id":"5a414a9fb201efd03d3b0079"}]},{"nsp":"http://dati.isprambiente.it/ontology/core#","prefix":"ispra","uri":"http://dati.isprambiente.it/ontology/core#","titles":[{"value":"Ispra Ontology","lang":"en","_id":"572ddb95b5cce30e4a39ab28"}]},{"uri":"https://data.istex.fr/ontology/istex#","nsp":"https://data.istex.fr/ontology/istex#","prefix":"istex","titles":[{"value":"Ontologie du projet Istex pour la diffusion de la litt\xe9rature scientifique","lang":"fr","_id":"5cc83e583c9ea81c2a69aa8f"},{"value":"Istex ontology for scholarly documents and extracted entities","lang":"en","_id":"5cc83e583c9ea81c2a69aa8e"}]},{"nsp":"http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0#","prefix":"itm","uri":"http://spi-fm.uca.es/spdef/models/genericTools/itm/1.0","titles":[{"value":"Issue Tracking tool Model","lang":"en","_id":"55abd6f157613119099d83cd"}]},{"nsp":"http://ontology.it/itsmo/v1#","prefix":"itsmo","uri":"http://ontology.it/itsmo/v1","titles":[{"value":"IT Service Management Ontology","lang":"en","_id":"567e6e9d4ee7f7176fea7b75"}]},{"uri":"https://www.w3.org/2019/wot/json-schema#","nsp":"https://www.w3.org/2019/wot/json-schema#","prefix":"jsonsc","titles":[{"value":"JSON Schema in RDF","lang":"en","_id":"5ed4d78ec7d84a2a049e4251"}]},{"nsp":"http://w3id.org/charta77/jup/","prefix":"jup","uri":"http://w3id.org/charta77/jup","titles":[{"value":"Ontology of Building Accessibility","lang":"en","_id":"57d2a8f2a3a9d3a63d7e79fc"},{"value":"Slovnik pristupnosti budov","lang":"cs","_id":"57d2a8f2a3a9d3a63d7e79fb"}]},{"nsp":"http://rdfs.co/juso/","prefix":"juso","uri":"http://rdfs.co/juso/","titles":[{"value":"Juso Ontology","lang":"en","_id":"5613a12442fc695f7e64c70e"}]},{"nsp":"http://rdfs.co/juso/kr/","prefix":"juso.kr","uri":"http://rdfs.co/juso/kr/","titles":[{"value":"South Korea Extension to Juso Ontology","lang":"en","_id":"5614e3a342fc695f7e657bd0"},{"value":"\uB300\uD55C\uBBFC\uAD6D \uC8FC\uC18C \uC628\uD1A8\uB85C\uC9C0","lang":"ko","_id":"5614e3a342fc695f7e657bcf"}]},{"nsp":"http://kdo.render-project.eu/kdo#","prefix":"kdo","uri":"http://kdo.render-project.eu/kdo#","titles":[{"value":"The Knowledge Diversity Ontology","lang":"en","_id":"55e05790419d00687563ad4f"}]},{"nsp":"http://linkeddata.center/kees/v1#","prefix":"kees","uri":"http://linkeddata.center/kees/v1","titles":[{"value":"KEES Ontology","lang":"en","_id":"5710e08a31bafaef0e789576"}]},{"nsp":"http://purl.org/NET/c4dm/keys.owl#","prefix":"keys","uri":"http://purl.org/NET/c4dm/keys.owl","titles":[{"value":"Keys Ontology","lang":"en","_id":"555d070c30f688c94e823631"}]},{"nsp":"http://www.disit.org/km4city/schema#","prefix":"km4c","uri":"http://www.disit.org/km4city/schema","titles":[{"value":"km4city, the DISIT Knowledge Model for City and Mobility","lang":"en","_id":"58171988c1b1a26b516f78f9"}]},{"nsp":"http://purl.org/net/vocab/2004/03/label#","prefix":"label","uri":"http://purl.org/net/vocab/2004/03/label","titles":[{"value":"label","lang":"en","_id":"55a8dfaa57613119099c4a7b"}]},{"nsp":"http://lawd.info/ontology/","prefix":"lawd","uri":"http://lawd.info/ontology/","titles":[{"value":"Linking Ancient World Data Ontology","lang":"en","_id":"56a6015237d8a8044b262bda"}]},{"uri":"http://semweb.mmlab.be/ns/linkedconnections#Ontology","nsp":"http://semweb.mmlab.be/ns/linkedconnections#","prefix":"lc","titles":[{"value":"The Linked Connections ontology","lang":"en","_id":"61a4ab96bf34bcf5590f0330"}]},{"nsp":"http://purl.org/vocab/lifecycle/schema#","prefix":"lcy","uri":"http://purl.org/vocab/lifecycle/schema","titles":[{"value":"Lifecycle Schema","lang":"en","_id":"55620c7bfcb9d2f34824a7f4"}]},{"uri":"https://w3id.org/ldes","nsp":"https://w3id.org/ldes#","prefix":"ldes","titles":[{"value":"The Linked Data Event Streams specification","lang":"en","_id":"63173f41b813c51c1e077290"}]},{"nsp":"http://www.w3.org/ns/ldp#","prefix":"ldp","uri":"http://www.w3.org/ns/ldp#","titles":[{"value":"Linked Data Platform","lang":"en","_id":"5733444fb5cce30e4a3b71fd"}]},{"nsp":"http://purl.oclc.org/NET/ldr/ns#","prefix":"ldr","uri":"http://purl.oclc.org/NET/ldr/ns#","titles":[{"value":"Linked Data Rights (LDR)","lang":"en","_id":"55bcb39f7459b3975b63cb0a"}]},{"nsp":"http://linked.opendata.cz/ontology/ldvm/","prefix":"ldvm","uri":"http://linked.opendata.cz/ontology/ldvm/","titles":[{"value":"Vocabulary for Linked Data Visualization Model","lang":"en"}]},{"nsp":"http://lemon-model.net/lemon#","prefix":"lemon","uri":"http://lemon-model.net/lemon","titles":[{"value":"LExicon Model for ONtologies","lang":"en","_id":"578635a28c6f955d29be1bc4"}]},{"uri":"http://www.w3.org/ns/lemon/decomp","nsp":"http://www.w3.org/ns/lemon/decomp#","prefix":"lexdcp","titles":[{"value":"Lexicon Model for Ontologies - Decomp","lang":"en","_id":"60d077156eec354e1dfe3dec"}]},{"nsp":"http://www.lexinfo.net/ontology/2.0/lexinfo#","prefix":"lexinfo","uri":"http://www.lexinfo.net/ontology/2.0/lexinfo","titles":[{"value":"LexInfo Ontology","lang":"en","_id":"57861e058c6f955d29be10ab"}]},{"nsp":"http://linkedgeodata.org/ontology/","prefix":"lgdo","uri":"http://linkedgeodata.org/ontology","titles":[{"value":"LinkedGeoData ontology","lang":"en","_id":"622b5375eb61c6004398e0a0"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage#","prefix":"li","uri":"http://def.seegrid.csiro.au/isotc211/iso19115/2003/lineage","titles":[{"value":"OWL representation of ISO 19115 (Geographic Information - Metadata - Lineage package)","lang":"en","_id":"56a3c54c37d8a8044b2541c3"}]},{"nsp":"http://purl.org/library/","prefix":"lib","uri":"http://purl.org/library/","titles":[{"value":"Library extension of schema.org","lang":"en","_id":"569cc766ff8848f96bd16c3f"}]},{"nsp":"http://purl.org/vocab/lifecycle/schema#","prefix":"lifecycle","uri":"http://www.irit.fr/recherches/MELODI/ontologies/IoT-Lifecycle","titles":[{"value":"IoT-Lifecycle","lang":"en","_id":"57111d1931bafaef0e78a6c0"}]},{"uri":"http://www.w3.org/ns/lemon/lime","nsp":"http://www.w3.org/ns/lemon/lime#","prefix":"lime","titles":[{"value":"Lexicon Model for Ontologies - LIngusitic MEtadata (LIME)","lang":"en","_id":"60d0a175ea2950ca21ba47cc"}]},{"nsp":"http://purl.org/limo-ontology/limo#","prefix":"limo","uri":"http://purl.org/limo-ontology/limo/","titles":[{"value":"Linked Statistical Models Vocabulary","lang":"en","_id":"55bb656f7459b3975b63c09f"}]},{"nsp":"http://purl.org/LiMo/0.1#","prefix":"limoo","uri":"http://purl.org/LiMo/0.1#","titles":[{"value":"License Model Ontology","lang":"en","_id":"55e01bf654ef107a63465d23"}]},{"nsp":"https://w3id.org/vocab/lingvoj#","prefix":"lingvo","uri":"https://w3id.org/vocab/lingvoj","titles":[{"value":"The Lingvoj Ontology","lang":"en","_id":"5ee35dd341346a864572f1a6"}]},{"nsp":"http://purl.org/net/lio#","prefix":"lio","uri":"http://purl.org/net/lio","titles":[{"value":"Lightweight Image Ontology","lang":"en","_id":"59a69ac37845e44d19bfa1b4"}]},{"nsp":"http://www.linklion.org/ontology#","prefix":"llont","uri":"http://www.linklion.org/ontology","titles":[{"value":"LinkLion - the Link Discovery Portal","lang":"en","_id":"57d2cfa9a3a9d3a63d7e8bc2"}]},{"nsp":"http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl#","prefix":"lmm1","uri":"http://www.ontologydesignpatterns.org/ont/lmm/LMM_L1.owl","titles":[{"value":"Lexical MetaModel Level 1","lang":"en","_id":"56a3c5e537d8a8044b25421b"}]},{"nsp":"http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl#","prefix":"lmm2","uri":"http://www.ontologydesignpatterns.org/ont/lmm/LMM_L2.owl","titles":[{"value":"Lexical MetaModel Level 2","lang":"en","_id":"56a3c60f37d8a8044b254234"}]},{"nsp":"http://purl.org/ctic/infraestructuras/localizacion#","prefix":"loc","uri":"http://purl.org/ctic/infraestructuras/localizacion","titles":[{"value":"Vocabulario de Localizaciones","lang":"es","_id":"555a773e30f688c94e8201e6"},{"value":"Location Vocabulary","lang":"en","_id":"555a773e30f688c94e8201e5"}]},{"nsp":"http://data.archiveshub.ac.uk/def/","prefix":"locah","uri":"http://data.archiveshub.ac.uk/def/","titles":[{"value":"The LOCAH RDF Vocabulary","lang":"en","_id":"5697b6b0ff8848f96bd12afc"}]},{"nsp":"http://www.w3.org/ns/locn#","prefix":"locn","uri":"http://www.w3.org/ns/locn","titles":[{"value":"ISA Programme Location Core Vocabulary","lang":"en","_id":"571f36f1b5cce30e4a2f1a9f"}]},{"nsp":"http://linkedevents.org/ontology/","prefix":"lode","uri":"http://linkedevents.org/ontology/","titles":[{"value":"Linking Open Descriptions of Events","lang":"en","_id":"5a36c915ece6c50213eee55b"}]},{"nsp":"http://www.w3.org/2000/10/swap/log#","prefix":"log","uri":"http://www.w3.org/2000/10/swap/log","titles":[{"value":"SWAP Logic Ontology","lang":"en","_id":"61ae2ca65b2c78953fa51b94"}]},{"nsp":"http://data.opendiscoveryspace.eu/lom_ontology_ods.owl#","prefix":"lom","uri":"http://data.opendiscoveryspace.eu/lom_ontology_ods.owl","titles":[{"value":"Learning Object Metadata Ontology","lang":"en"}]},{"nsp":"http://sparql.sstu.ru:3030/speciality/","prefix":"losp","uri":"http://sparql.sstu.ru:3030/speciality/","titles":[{"value":"Linked open specialities RF","lang":"en","_id":"5ab1346e5177bf47193949fe"},{"value":"\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0435 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0420\u0424","lang":"ru","_id":"5ab1346e5177bf47193949fd"}]},{"nsp":"http://loted.eu/ontology#","prefix":"loted","uri":"http://loted.eu/ontology","titles":[{"value":"LOTED ontology","lang":"en","_id":"552799fb324d21a7430fdcf5"}]},{"nsp":"http://linkedscience.org/lsc/ns#","prefix":"lsc","uri":"http://linkedscience.org/lsc/ns#","titles":[{"value":"Linked Science Core Vocabulary","lang":"en","_id":"55e0609ca71142386b776210"}]},{"nsp":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl#","prefix":"lslife","uri":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper.owl","titles":[{"value":"ELSEWeb Lifemapper Ontology","lang":"en","_id":"56af78b098f0192c57ea948c"}]},{"nsp":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#","prefix":"lsmap","uri":"http://ontology.cybershare.utep.edu/ELSEWeb/mappings/elseweb-mappings.owl","titles":[{"value":"ELSEWeb Mappings Ontology","lang":"en","_id":"56af7a8398f0192c57ea95f3"}]},{"nsp":"http://lsq.aksw.org/vocab#","prefix":"lsq","uri":"http://lsq.aksw.org/vocab","titles":[{"value":"The Linked SPARQL Queries Vocabulary (LSQ(V))","lang":"en","_id":"5735f14fb5cce30e4a3baa61"}]},{"nsp":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl#","prefix":"lsweb","uri":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-data.owl","titles":[{"value":"ELSEWeb Data Ontology","lang":"en","_id":"561b8f5542fc695f7e6722c8"}]},{"nsp":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl#","prefix":"lswmo","uri":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-modelling.owl","titles":[{"value":"ELSEWeb Modelling Ontology","lang":"en","_id":"561e315342fc695f7e6767fd"}]},{"nsp":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl#","prefix":"lswpm","uri":"http://ontology.cybershare.utep.edu/ELSEWeb/elseweb-lifemapper-parameters.owl","titles":[{"value":"ELSEWeb Lifemapper Parameters Ontology","lang":"en","_id":"56af79d398f0192c57ea9561"}]},{"nsp":"http://ns.inria.fr/ludo","prefix":"ludo","uri":"http://ns.inria.fr/ludo","titles":[{"value":"Ludo Ontology","lang":"en","_id":"57349da9b5cce30e4a3b874d"}]},{"nsp":"http://ns.inria.fr/ludo/v1/gamemodel#","prefix":"ludo-gm","uri":"http://ns.inria.fr/ludo/v1/gamemodel#","titles":[{"value":"Ludo Game Model Ontology","lang":"en","_id":"57bfe97aa3a9d3a63d791bf7"}]},{"nsp":"http://ns.inria.fr/ludo/v1/gamepresentation#","prefix":"ludo-gp","uri":"http://ns.inria.fr/ludo/v1/gamepresentation#","titles":[{"value":"Ludo - Game Presentation","lang":"en","_id":"57bfe970a3a9d3a63d791bec"}]},{"nsp":"http://ns.inria.fr/ludo/v1/virtualcontext#","prefix":"ludo-vc","uri":"http://ns.inria.fr/ludo/v1/virtualcontext#","titles":[{"value":"Ludo - Virtual Context","lang":"en","_id":"57bfe6bda3a9d3a63d791ab0"}]},{"nsp":"http://ns.inria.fr/ludo/v1/xapi#","prefix":"ludo-xapi","uri":"http://ns.inria.fr/ludo/v1/xapi","titles":[{"value":"Experience API (xAPI)","lang":"en","_id":"5734a02fb5cce30e4a3b8783"}]},{"nsp":"http://purl.org/lobid/lv#","prefix":"lv","uri":"http://purl.org/lobid/lv","titles":[{"value":"lobid vocab","lang":"en","_id":"55bb5a4b7459b3975b63c02e"}]},{"nsp":"http://lexvo.org/ontology#","prefix":"lvont","uri":"http://lexvo.org/ontology","titles":[{"value":"Lexvo.org Ontology","lang":"en","_id":"555df44ffcb9d2f348248664"}]},{"nsp":"http://purl.org/linkingyou/","prefix":"lyou","uri":"http://purl.org/linkingyou/","titles":[{"value":"Linking-you vocabulary","lang":"en"}]},{"nsp":"http://purl.org/iot/vocab/m3-lite#","prefix":"m3lite","uri":"http://purl.org/iot/vocab/m3-lite#","titles":[{"value":"The Machine-to-Machine Measurement (M3) Lite Ontology","lang":"en","_id":"59b147832ab721804e285a65"}]},{"uri":"http://w3id.org/nfdi4ing/metadata4ing#","nsp":"http://w3id.org/nfdi4ing/metadata4ing#","prefix":"m4i","titles":[{"value":"Metadata4Ing: An ontology for describing the generation of research data within a scientific activity.","lang":"en","_id":"62306164eb61c60043990f31"}]},{"nsp":"http://www.w3.org/ns/ma-ont#","prefix":"ma-ont","uri":"http://www.w3.org/ns/ma-ont","titles":[{"value":"Ontology for Media Resources","lang":"en","_id":"56d067a9ec7d5661016d05fc"}]},{"nsp":"http://www.loc.gov/mads/rdf/v1#","prefix":"mads","uri":"http://www.loc.gov/mads/rdf/v1","titles":[{"value":"Metadata Authority Description Schema","lang":"en","_id":"567e70384ee7f7176fea7b81"}]},{"nsp":"http://www.gsi.dit.upm.es/ontologies/marl/ns#","prefix":"marl","uri":"http://www.gsi.dit.upm.es/ontologies/marl/ns","titles":[{"value":"Marl Ontology Specification","lang":"en","_id":"56a69a7237d8a8044b26685d"}]},{"nsp":"http://securitytoolbox.appspot.com/MASO#","prefix":"maso","uri":"http://securitytoolbox.appspot.com/MASO","titles":[{"value":"S\xe9curit\xe9 Agents Mobiles","lang":"fr","_id":"55489271e83552eb70883987"},{"value":"Mobile Agents Security","lang":"en","_id":"55489271e83552eb70883986"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19115/2003/metadata#","prefix":"md","uri":"http://def.seegrid.csiro.au/isotc211/iso19115/2003/metadata","titles":[{"value":"OWL representation of ISO 19115","lang":"en","_id":"56065adb8f7ad2ce3438d5c4"}]},{"nsp":"https://w3id.org/multidimensional-interface/ontology#","prefix":"mdi","uri":"https://w3id.org/multidimensional-interface/ontology","titles":[{"value":"RDF vocabulary to describe a Multidimensional Interface.","lang":"en","_id":"577d245f0183b1e80fc65e65"}]},{"uri":"https://w3id.org/mdo/full/","nsp":"https://w3id.org/mdo/full/","prefix":"mdo","titles":[{"value":"Materials Design Ontology - Full","lang":"en","_id":"6001d9461d5b17af6c25a04f"}]},{"uri":"https://w3id.org/mdo/calculation/","nsp":"https://w3id.org/mdo/calculation/","prefix":"mdo-calc","titles":[{"value":"Materials Design Ontology - Calculation Module","lang":"en","_id":"6001de85e34ba6a36fadabaa"}]},{"uri":"https://w3id.org/mdo/structure/","nsp":"https://w3id.org/mdo/structure/","prefix":"mdo-struc","titles":[{"value":"Materials Design Ontology - Structure Module","lang":"en","_id":"6001dbda6f98d1eb6e6d705f"}]},{"uri":"https://w3id.org/mdo/provenance/","nsp":"https://w3id.org/mdo/provenance/","prefix":"mdoprov","titles":[{"value":"Materials Design Ontology - Provenance Module","lang":"en","_id":"63248769f0004aba7af3f862"}]},{"uri":"http://semanticturkey.uniroma2.it/ns/mdr","nsp":"http://semanticturkey.uniroma2.it/ns/mdr#","prefix":"mdr","titles":[{"value":"The Semantic Turkey metadata registry ontology","lang":"en","_id":"6324837df0004aba7af3f813"}]},{"nsp":"http://rdf.myexperiment.org/ontologies/base/","prefix":"meb","uri":"http://rdf.myexperiment.org/ontologies/base/","titles":[{"value":"The myExperiment Base Ontology","lang":"en","_id":"63248285f0004aba7af3f802"}]},{"nsp":"http://purl.org/media#","prefix":"media","uri":"http://purl.org/media","titles":[{"value":"The Media RDF Vocabulary","lang":"en","_id":"63248217f0004aba7af3f7f2"}]},{"nsp":"http://w3id.org/medred/medred#","prefix":"medred","uri":"http://w3id.org/medred/medred#","titles":[{"value":"MedRed ontology: clinical data acquisition model","lang":"en","_id":"632480faf0004aba7af3f7e4"},{"value":"MedRed ontologie: mod\xe8le d\'aquisition de donn\xe9es cliniques","lang":"fr","_id":"632480faf0004aba7af3f7e3"},{"value":"Ontolog\xeda MedRed: modelo de adquisici\xf3n de datos cl\xednicos","lang":"es","_id":"632480faf0004aba7af3f7e2"}]},{"nsp":"http://mex.aksw.org/mex-algo#","prefix":"mexalgo","uri":"http://mex.aksw.org/mex-algo","titles":[{"value":"MEX Algorithm Ontology","lang":"en","_id":"63247e50f0004aba7af3f7d3"}]},{"nsp":"http://mex.aksw.org/mex-core#","prefix":"mexcore","uri":"http://mex.aksw.org/mex-core","titles":[{"value":"MEX Core Vocabulary","lang":"en","_id":"632480aff0004aba7af3f7dc"},{"value":"Vocabulario MEX (mex-core)","lang":"pt","_id":"632480aff0004aba7af3f7db"}]},{"nsp":"http://mex.aksw.org/mex-perf#","prefix":"mexperf","uri":"http://mex.aksw.org/mex-perf","titles":[{"value":"MEX Performance Ontology","lang":"en","_id":"63248181f0004aba7af3f7ec"}]},{"nsp":"http://rdf.muninn-project.org/ontologies/military#","prefix":"mil","uri":"http://rdf.muninn-project.org/ontologies/military","titles":[{"value":"Military Ontology Specification","lang":"en","_id":"6324825ef0004aba7af3f7fa"}]},{"nsp":"http://www.w3.org/ns/mls#","prefix":"mls","uri":"http://www.w3.org/ns/mls","titles":[{"value":"Machine Learning Schema","lang":"en","_id":"63248323f0004aba7af3f80d"}]},{"nsp":"http://purl.org/ontology/mo/","prefix":"mo","uri":"http://purl.org/ontology/mo/","titles":[{"value":"Music Ontology","lang":"en","_id":"632487d8f0004aba7af3f866"}]},{"nsp":"http://observedchange.com/moac/ns#","prefix":"moac","uri":"http://www.observedchange.com/moac/ns#","titles":[{"value":"Management of a Crisis Vocabulary","lang":"en","_id":"632488d0f0004aba7af3f886"}]},{"nsp":"http://moat-project.org/ns#","prefix":"moat","uri":"http://moat-project.org/ns#","titles":[{"value":"Meaning of a Tag Ontology","lang":"en","_id":"63248acbf0004aba7af3f89f"}]},{"uri":"http://www.isibang.ac.in/ns/mod","nsp":"http://www.isibang.ac.in/ns/mod#","prefix":"mod","titles":[{"value":"MOD: Metadata for Ontology Description and publication","lang":"en","_id":"63248b3cf0004aba7af3f8a7"}]},{"uri":"https://w3id.org/skgo/modsci#","nsp":"https://w3id.org/skgo/modsci#","prefix":"modsci","titles":[{"value":"ModSci, Modern Science Ontology.","lang":"en","_id":"63a2ecdcd36ad4e74e6fbf1c"}]},{"nsp":"http://id.loc.gov/vocabulary/relators/","prefix":"mrel","uri":"http://id.loc.gov/vocabulary/relators","titles":[{"value":"MARC Code List for Relators","lang":"en","_id":"56a3c44437d8a8044b254130"}]},{"nsp":"http://iserve.kmi.open.ac.uk/ns/msm#","prefix":"msm","uri":"http://iserve.kmi.open.ac.uk/ns/msm","titles":[{"value":"Minimal Service Model","lang":"en","_id":"586ba9fb7e341093492c486d"}]},{"nsp":"http://www.telegraphis.net/ontology/measurement/measurement#","prefix":"msr","uri":"http://www.telegraphis.net/ontology/measurement/measurement#","titles":[{"value":"Measurement Ontology","lang":"en","_id":"632caee0c4f7e5f619d44f09"}]},{"nsp":"http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl#","prefix":"mtlo","uri":"http://www.ics.forth.gr/isl/MarineTLO/v4/marinetlo.owl","titles":[{"value":"MarineTLO Ontology","lang":"en","_id":"568e25144ee7f7176ff21a6f"}]},{"uri":"http://ns.inria.fr/munc/","nsp":"http://ns.inria.fr/munc#","prefix":"munc","titles":[{"value":"Meta-Uncertainty","lang":"en","_id":"5cf3b11c15973e9745ebcaca"}]},{"uri":"http://data.doremus.org/ontology#","nsp":"http://data.doremus.org/ontology#","prefix":"mus","titles":[{"value":"DOREMUS is an extension of the FRBRoo model for describing the music.","lang":"en","_id":"5bf67fa147ae8a96226d6fcd"}]},{"nsp":"http://www.kanzaki.com/ns/music#","prefix":"music","uri":"http://www.kanzaki.com/ns/music","titles":[{"value":"Music Vocabulary","lang":"en","_id":"568beb7f4ee7f7176ff12583"}]},{"nsp":"http://purl.org/muto/core#","prefix":"muto","uri":"http://purl.org/muto/core","titles":[{"value":"Modular Unified Tagging Ontology (MUTO)","lang":"en","_id":"55bb59547459b3975b63c022"}]},{"nsp":"http://schema.mobivoc.org/","prefix":"mv","uri":"http://schema.mobivoc.org/","titles":[{"value":"MobiVoc: Open Mobility Vocabulary","lang":"en","_id":"5a69f44e696bbe7e0f71a8ce"}]},{"nsp":"http://purl.oclc.org/NET/mvco.owl#","prefix":"mvco","uri":"http://purl.oclc.org/NET/mvco.owl","titles":[{"value":"Media Value Chain Ontology","lang":"en","_id":"568e24824ee7f7176ff219ff"}]},{"nsp":"http://www.semanticdesktop.org/ontologies/2007/08/15/nao#","prefix":"nao","uri":"http://www.semanticdesktop.org/ontologies/2007/08/15/nao","titles":[{"value":"NEPOMUK Annotation Ontology","lang":"en","_id":"5bc4a957ae7b898430043b20"}]},{"nsp":"https://data.nasa.gov/ontologies/atmonto/NAS#","prefix":"nas","uri":"https://data.nasa.gov/ontologies/atmonto/NAS#","titles":[{"value":"US National Airspace System (NAS) vocabulary","lang":"en","_id":"5ad89280a236156c49539c9a"}]},{"nsp":"http://www.semanticdesktop.org/ontologies/2007/04/02/ncal#","prefix":"ncal","uri":"http://www.semanticdesktop.org/ontologies/2007/04/02/ncal","titles":[{"value":"NEPOMUK Calendar Ontology","lang":"en","_id":"55473ccb24d03b315d46a46c"}]},{"nsp":"http://www.semanticdesktop.org/ontologies/2007/03/22/nco#","prefix":"nco","uri":"http://www.semanticdesktop.org/ontologies/2007/03/22/nco","titles":[{"value":"NEPOMUK Contact Ontology","lang":"en","_id":"5531354e00421f5f6ed69a51"}]},{"nsp":"http://www.semanticdesktop.org/ontologies/2007/03/22/nfo#","prefix":"nfo","uri":"http://www.semanticdesktop.org/ontologies/2007/03/22/nfo","titles":[{"value":"NEPOMUK File Ontology","lang":"en","_id":"5bd9bfbb30451cea37dc3452"}]},{"nsp":"http://geovocab.org/geometry#","prefix":"ngeo","uri":"http://geovocab.org/geometry","titles":[{"value":"NeoGeo Geometry Ontology","lang":"en","_id":"57696d624a73263716312ebb"}]},{"nsp":"http://www.semanticdesktop.org/ontologies/2007/01/19/nie#","prefix":"nie","uri":"http://www.semanticdesktop.org/ontologies/2007/01/19/nie","titles":[{"value":"NEPOMUK Information Element Core Ontology","lang":"en","_id":"5531359300421f5f6ed69a57"}]},{"nsp":"http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#","prefix":"nif","uri":"http://persistence.uni-leipzig.org/nlp2rdf/ontologies/nif-core#","titles":[{"value":"NLP Interchange Format","lang":"en","_id":"568e23ef4ee7f7176ff219a6"}]},{"nsp":"http://lod.nl.go.kr/ontology/","prefix":"nlon","uri":"http://lod.nl.go.kr/ontology/","titles":[{"value":"National Library of Korea Ontology","lang":"en","_id":"5650e89e591cccea34de068e"}]},{"uri":"https://w3id.org/nno/ontology","nsp":"https://w3id.org/nno/ontology#","prefix":"nno","titles":[{"value":"The Neural Network Ontology","lang":"en","_id":"5ed93c3a04eb75a1282582a7"}]},{"uri":"http://www.nanopub.org/nschema","nsp":"http://www.nanopub.org/nschema#","prefix":"np","titles":[{"value":"Nano publication ontology","lang":"en","_id":"62860a77ae42b28b6180ba9b"}]},{"nsp":"http://ns.nature.com/terms/","prefix":"npg","uri":"http://ns.nature.com/terms/","titles":[{"value":"Nature.com Core Ontology","lang":"en","_id":"5dacdf398b936c5b59e22a85"}]},{"nsp":"http://www.semanticdesktop.org/ontologies/2007/08/15/nrl#","prefix":"nrl","uri":"http://www.semanticdesktop.org/ontologies/2007/08/15/nrl","titles":[{"value":"NEPOMUK Representational Language","lang":"en","_id":"553134b600421f5f6ed69a44"}]},{"nsp":"http://ns.inria.fr/nrv#","prefix":"nrv","uri":"http://ns.inria.fr/nrv","titles":[{"value":"Normative Requirements Vocabulary","lang":"en","_id":"5989902a88adb933350c517b"}]},{"nsp":"http://purl.org/ontology/storyline/","prefix":"nsl","uri":"http://purl.org/ontology/storyline","titles":[{"value":"A News Storyline Ontology","lang":"en","_id":"55366c82a6d4117c3a6b4ffc"}]},{"nsp":"http://ns.inria.fr/nicetag/2010/09/09/voc#","prefix":"ntag","uri":"http://ns.inria.fr/nicetag/2010/09/09/voc","titles":[{"value":"Nice Tag Ontology","lang":"en","_id":"55bcaef77459b3975b63cad4"}]},{"nsp":"http://www.w3.org/ns/oa#","prefix":"oa","uri":"http://www.w3.org/ns/oa#","titles":[{"value":"Open Annotation Data Model","lang":"en","_id":"5788c3738c6f955d29bf2256"}]},{"nsp":"http://culturalis.org/oad#","prefix":"oad","uri":"http://culturalis.org/oad#","titles":[{"value":"Ontology for archival description","lang":"en","_id":"5cdab34faee7bef561bd8f05"}]},{"nsp":"http://www.ics.forth.gr/isl/oae/core#","prefix":"oae","uri":"http://www.ics.forth.gr/isl/oae/core","titles":[{"value":"Open NEE Model","lang":"en","_id":"5731e778b5cce30e4a3b56d3"}]},{"nsp":"http://data.lirmm.fr/ontologies/oan/","prefix":"oan","uri":"http://data.lirmm.fr/ontologies/oan","titles":[{"value":"Ontologie de l\'Assembl\xe9e  Nationale","lang":"fr","_id":"5cd07c75d18d844f5ff6f7ad"},{"value":"Ontology of the French National Assembly","lang":"en","_id":"5cd07c75d18d844f5ff6f7ac"}]},{"nsp":"http://purl.obolibrary.org/obo/","prefix":"obo","uri":"http://purl.obolibrary.org/obo/obi.owl","titles":[{"value":"Ontology for Biomedical Investigation","lang":"en","_id":"5dad697398c7a8076a14d5bd"}]},{"nsp":"http://rdf.geospecies.org/methods/observationMethod#","prefix":"obsm","uri":"http://rdf.geospecies.org/methods/observationMethod.rdf","titles":[{"value":"Observation Method Ontology","lang":"en","_id":"55de198754ef107a63464b23"}]},{"nsp":"http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl#","prefix":"obws","uri":"http://delicias.dia.fi.upm.es/ontologies/ObjectWithStates.owl","titles":[{"value":"Object with states ontology","lang":"en","_id":"57111afb31bafaef0e78a5ce"}]},{"nsp":"http://contextus.net/ontology/ontomedia/core/expression#","prefix":"oc","uri":"http://contextus.net/ontology/ontomedia/core/expression#","titles":[{"value":"OntoMedia Core","lang":"en","_id":"568e243c4ee7f7176ff219dc"}]},{"nsp":"http://dati.camera.it/ocd/","prefix":"ocd","uri":"http://dati.camera.it/ocd/","titles":[{"value":"Ontologia Camera dei Deputati","lang":"it","_id":"55352f246313f1cd32a4b14c"},{"value":"Ontology of Italian Deputy Chamber","lang":"en","_id":"55352f246313f1cd32a4b14b"}]},{"nsp":"http://purl.org/onto-ocds/ocds#","prefix":"ocds","uri":"http://purl.org/onto-ocds/ocds","titles":[{"value":"Schema for an Open Contracting Release (OCDS)","lang":"en","_id":"5b3b9830297c2b02405be2da"}]},{"nsp":"http://vocab.deri.ie/odapp#","prefix":"odapp","uri":"http://vocab.deri.ie/odapp","titles":[{"value":"Open Data Applications Vocabulary","lang":"en","_id":"5dace2008b936c5b59e22aac"}]},{"nsp":"http://semweb.mmlab.be/ns/odapps#","prefix":"odapps","uri":"http://semweb.mmlab.be/ns/odapps","titles":[{"value":"The vocabulary for (L)OD ideas and applications","lang":"en","_id":"5a418dd7b201efd03d3b7839"}]},{"nsp":"http://www.ontologydesignpatterns.org/cp/owl/participation.owl#","prefix":"odpart","uri":"http://www.ontologydesignpatterns.org/cp/owl/participation.owl","titles":[{"value":"Ontology Design Pattern Participation","lang":"en","_id":"55f84aec6185ddbd5f7a02af"}]},{"nsp":"http://www.w3.org/ns/odrl/2/","prefix":"odrl","uri":"http://www.w3.org/ns/odrl/2/","titles":[{"value":"The Open Digital Rights Language (ODRL) Ontology","lang":"en","_id":"5ee0e72219c009bf5b729a44"}]},{"nsp":"http://schema.theodi.org/odrs#","prefix":"odrs","uri":"http://schema.theodi.org/odrs","titles":[{"value":"Open Data Rights Statement Vocabulary","lang":"en","_id":"55dc2f268b5f9f281f4c5a2d"}]},{"nsp":"http://reference.data.gov.uk/def/organogram/","prefix":"odv","uri":"http://reference.data.gov.uk/def/organogram","titles":[{"value":"Organogram Data Vocabulary","lang":"en","_id":"5965f4cf60bd67a35e912a2f"}]},{"nsp":"http://www.oegov.org/core/owl/cc#","prefix":"oecc","uri":"http://www.oegov.org/core/owl/cc","titles":[{"value":"Extended Creative Commons Ontology","lang":"en","_id":"55f848006185ddbd5f7a029e"}]},{"nsp":"http://owlrep.eu01.aws.af.cm/fridge#","prefix":"of","uri":"http://owlrep.eu01.aws.af.cm/fridge","titles":[{"value":"Open Fridge vocabulary","lang":"en","_id":"5809c64b3e5586c53d896f4c"}]},{"uri":"https://w3id.org/ofo#","nsp":"https://w3id.org/ofo#","prefix":"ofo","titles":[{"value":"Occupant Feedback Ontology","lang":"en","_id":"638bd114e8d209386de1497d"}]},{"nsp":"http://purl.org/opdm/refrigerator#","prefix":"ofrd","uri":"http://purl.org/opdm/refrigerator#","titles":[{"value":"Fridge and Freezer Vocabulary","lang":"en","_id":"56a51f8937d8a8044b25de6b"}]},{"nsp":"http://ogp.me/ns#","prefix":"og","uri":"http://ogp.me/ns","titles":[{"value":"Open Graph Protocol Vocabulary","lang":"en","_id":"580e208d7ada884367888d9d"}]},{"nsp":"http://semweb.mmlab.be/ns/oh#","prefix":"oh","uri":"http://semweb.mmlab.be/ns/oh","titles":[{"value":"The Opening Hours vocabulary","lang":"en","_id":"5dace15d8b936c5b59e22aa1"}]},{"nsp":"https://w3id.org/vocab/olca#","prefix":"olca","uri":"https://w3id.org/vocab/olca","titles":[{"value":"Ontology Loose Coupling Annotation","lang":"en","_id":"5ed4c39bc7d84a2a049e41e3"}]},{"nsp":"http://purl.org/ontology/olo/core#","prefix":"olo","uri":"http://purl.org/ontology/olo/core#","titles":[{"value":"Ordered List Ontology","lang":"en","_id":"55e2e8fda71142386b778be3"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19156/2011/observation#","prefix":"om","uri":"http://def.seegrid.csiro.au/isotc211/iso19156/2011/observation","titles":[{"value":"ISO 19156 Observation Model","lang":"en","_id":"55a0f98b57613119099c113f"}]},{"uri":"https://w3id.org/omg","nsp":"https://w3id.org/omg#","prefix":"omg","titles":[{"value":"OMG: Ontology for Managing Geometry","lang":"en","_id":"5da47e6ee8203beb0d42115e"}]},{"nsp":"http://def.seegrid.csiro.au/ontology/om/om-lite#","prefix":"oml","uri":"http://def.seegrid.csiro.au/ontology/om/om-lite","titles":[{"value":"OWL for Observations","lang":"en","_id":"56af7dfd98f0192c57ea989a"}]},{"nsp":"http://open-multinet.info/ontology/omn#","prefix":"omn","uri":"http://open-multinet.info/ontology/omn","titles":[{"value":"Open-Multinet Upper Ontology","lang":"en","_id":"57ad8385b00b4b1452a88643"}]},{"nsp":"http://open-multinet.info/ontology/omn-federation#","prefix":"omnfed","uri":"http://open-multinet.info/ontology/omn-federation","titles":[{"value":"Open-Multinet Upper Federation Ontology","lang":"en","_id":"5527e61e4727af98034d32a1"}]},{"nsp":"http://open-multinet.info/ontology/omn-lifecycle#","prefix":"omnlc","uri":"http://open-multinet.info/ontology/omn-lifecycle","titles":[{"value":"Open-Multinet Upper Lifecycle Ontology","lang":"en","_id":"5527e63b4727af98034d32ad"}]},{"nsp":"http://www.ics.forth.gr/isl/oncm/core#","prefix":"onc","uri":"http://www.ics.forth.gr/isl/oncm/core","titles":[{"value":"Open NEE Configuration Model","lang":"en","_id":"57d2cf72a3a9d3a63d7e8bb2"}]},{"nsp":"http://purl.org/net/ns/ontology-annot#","prefix":"ont","uri":"http://purl.org/net/ns/ontology-annot","titles":[{"value":"Ontology annotation DLiser vocabulary","lang":"en","_id":"5548f6d23d2356850c58948b"}]},{"uri":"http://www.w3.org/ns/lemon/ontolex","nsp":"http://www.w3.org/ns/lemon/ontolex#","prefix":"ontolex","titles":[{"value":"Lexicon Model for Ontologies - Core","lang":"en","_id":"60b7ac9387423a16187e4499"}]},{"nsp":"http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl#","prefix":"ontopic","uri":"http://www.ontologydesignpatterns.org/ont/dul/ontopic.owl","titles":[{"value":"Ontopic Ontology","lang":"en","_id":"55bb60e07459b3975b63c079"}]},{"nsp":"http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl#","prefix":"ontosec","uri":"http://www.semanticweb.org/ontologies/2008/11/OntologySecurity.owl","titles":[{"value":"Ontology Security","lang":"en","_id":"554942850258721029c75c73"}]},{"nsp":"http://www.gsi.dit.upm.es/ontologies/onyx/ns#","prefix":"onyx","uri":"http://www.gsi.dit.upm.es/ontologies/onyx/ns","titles":[{"value":"Onyx Emotion Ontology","lang":"en","_id":"560658768f7ad2ce3438d56c"}]},{"nsp":"http://purl.org/openorg/","prefix":"oo","uri":"http://purl.org/openorg/","titles":[{"value":"Open Organisations","lang":"en","_id":"57d2d10ca3a9d3a63d7e8c71"}]},{"nsp":"http://environment.data.gov.au/def/op#","prefix":"op","uri":"http://environment.data.gov.au/def/op","titles":[{"value":"Observable properties","lang":"en","_id":"57d2d09ea3a9d3a63d7e8c28"}]},{"nsp":"http://ontology.eil.utoronto.ca/open311#","prefix":"open311","uri":"http://ontology.eil.utoronto.ca/open311.owl","titles":[{"value":"Open 311 Ontology: An Ontology for publishing a city\'s non-emergency events.","lang":"en","_id":"5ad0b0803aba5caf50df14a1"}]},{"uri":"https://w3id.org/opm","nsp":"https://w3id.org/opm#","prefix":"opm","titles":[{"value":"OPM: Ontology for Property Management","lang":"en","_id":"5da48640532b78ab0e3bdb2f"}]},{"nsp":"http://openprovenance.org/model/opmo#","prefix":"opmo","uri":"http://openprovenance.org/model/opmo","titles":[{"value":"Open Provenance Model","lang":"en","_id":"5693f592ff8848f96bd09140"}]},{"nsp":"http://purl.org/net/opmv/ns#","prefix":"opmv","uri":"http://purl.org/net/opmv/ns#","titles":[{"value":"Open Provenance Model Vocabulary","lang":"en","_id":"5ad0b0633aba5caf50df148f"}]},{"nsp":"http://www.opmw.org/ontology/","prefix":"opmw","uri":"http://www.opmw.org/ontology/","titles":[{"value":"The OPMW Ontology","lang":"en","_id":"560654898f7ad2ce3438d47f"}]},{"nsp":"http://online-presence.net/opo/ns#","prefix":"opo","uri":"http://online-presence.net/opo/ns#","titles":[{"value":"Online Presence Ontology","lang":"en","_id":"56065a158f7ad2ce3438d5a5"}]},{"nsp":"http://lsdis.cs.uga.edu/projects/semdis/opus#","prefix":"opus","uri":"http://lsdis.cs.uga.edu/projects/semdis/opus#","titles":[{"value":"SwetoDblp Ontology of Computer Science Publications","lang":"en","_id":"555a77a130f688c94e8201ef"}]},{"nsp":"http://vocab.deri.ie/orca#","prefix":"orca","uri":"http://vocab.deri.ie/orca","titles":[{"value":"orca, the Ontology of Reasoning, Certainty and Attribution","lang":"en","_id":"583a03bdcd0ed0472763e103"}]},{"nsp":"http://www.openarchives.org/ore/terms/","prefix":"ore","uri":"http://www.openarchives.org/ore/terms/","titles":[{"value":"The OAI ORE terms vocabulary","lang":"en","_id":"556dc81fa866afd621a1ca6d"}]},{"nsp":"http://www.w3.org/ns/org#","prefix":"org","uri":"http://www.w3.org/ns/org#","titles":[{"value":"Core organization ontology","lang":"en","_id":"5731b553b5cce30e4a3b528d"}]},{"nsp":"http://datos.gob.es/def/sector-publico/organizacion#","prefix":"orges","uri":"http://datos.gob.es/def/sector-publico/organizacion#","titles":[{"value":"Ontology about Spanish public organizations","lang":"en","_id":"55efdde5a71142386b78ff41"},{"value":"Ontolog\xeda sobre organizaciones p\xfablicas en Espa\xf1a","lang":"es","_id":"55efdde5a71142386b78ff40"}]},{"nsp":"http://data.ordnancesurvey.co.uk/ontology/admingeo/","prefix":"osadm","uri":"http://data.ordnancesurvey.co.uk/ontology/admingeo/","titles":[{"value":"The administrative geography and civil voting area ontology","lang":"en","_id":"557f458e1d5237e823d24e1d"}]},{"nsp":"http://data.ordnancesurvey.co.uk/ontology/geometry/","prefix":"osgeom","uri":"http://data.ordnancesurvey.co.uk/ontology/geometry/","titles":[{"value":"Ordnance Survey Geometry Ontology","lang":"en","_id":"599206b4605c58c744d4ff2b"}]},{"nsp":"http://open-services.net/ns/core#","prefix":"oslc","uri":"http://open-services.net/ns/core#","titles":[{"value":"OSLC Core Vocabulary","lang":"en","_id":"55478b5d5cd393446058a75c"}]},{"nsp":"http://purl.org/oslo/ns/localgov#","prefix":"oslo","uri":"http://purl.org/oslo/ns/localgov","titles":[{"value":"OSLO Exchange Standard","lang":"en","_id":"55e062ffa71142386b77622d"}]},{"nsp":"http://data.lirmm.fr/ontologies/osp#","prefix":"osp","uri":"http://data.lirmm.fr/ontologies/osp","titles":[{"value":"Ontologie du Service Public","lang":"fr","_id":"57ad8fd9b00b4b1452a88d20"},{"value":"French Public Services Ontology","lang":"en","_id":"57ad8fd9b00b4b1452a88d1f"}]},{"nsp":"http://contextus.net/ontology/ontomedia/core/space#","prefix":"osr","uri":"http://contextus.net/ontology/ontomedia/core/space#","titles":[{"value":"OntoMedia Space Representation","lang":"en","_id":"55bcb0137459b3975b63cae5"}]},{"nsp":"http://data.ordnancesurvey.co.uk/ontology/spatialrelations/","prefix":"osspr","uri":"http://data.ordnancesurvey.co.uk/ontology/spatialrelations/","titles":[{"value":"Spatial Relations Ontology","lang":"en","_id":"556dc9e8a866afd621a1ca90"}]},{"nsp":"http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl#","prefix":"ostop","uri":"http://www.ordnancesurvey.co.uk/ontology/Topography/v0.1/Topography.owl","titles":[{"value":"Ordnance Survey Topography Ontology","lang":"en","_id":"555e07c0fcb9d2f3482486ec"}]},{"uri":"https://w3id.org/opentrafficlights","nsp":"https://w3id.org/opentrafficlights#","prefix":"otl","titles":[{"value":"The Open Traffic Lights ontology","lang":"en","_id":"5bf68aaa47ae8a96226d7418"}]},{"uri":"http://www.ontology-of-units-of-measure.org/resource/om-2/","nsp":"http://www.ontology-of-units-of-measure.org/resource/om-2/","prefix":"oum","titles":[{"value":"Ontology of units of Measure (OM)","lang":"en","_id":"5f1ac2ed388540d23b85cef5"},{"value":"\u6E2C\u5B9A\u5358\u4F4D\u306E\u30AA\u30F3\u30C8\u30ED\u30B8\u30FC (OM)","lang":"ja","_id":"5f1ac2ed388540d23b85cef4"}]},{"nsp":"http://open.vocab.org/terms/","prefix":"ov","uri":"http://open.vocab.org/terms","titles":[{"value":"OpenVocab","lang":"en","_id":"5534d43792fbe6e5228e6fa3"}]},{"nsp":"http://www.w3.org/2002/07/owl#","prefix":"owl","uri":"http://www.w3.org/2002/07/owl","titles":[{"value":"The OWL 2 Schema vocabulary","lang":"en","_id":"576a57f54a73263716316b54"}]},{"nsp":"http://purl.org/net/p-plan#","prefix":"p-plan","uri":"http://purl.org/net/p-plan#","titles":[{"value":"The P-PLAN Ontology","lang":"en","_id":"58171a2bc1b1a26b516f7977"}]},{"nsp":"http://reference.data.gov.uk/def/parliament/","prefix":"parl","uri":"http://reference.data.gov.uk/def/parliament","titles":[{"value":"Parliament Ontology","lang":"en","_id":"55e01cac54ef107a63465d2d"}]},{"nsp":"http://purl.org/vocab/participation/schema#","prefix":"part","uri":"http://purl.org/vocab/participation/schema","titles":[{"value":"Participation Schema","lang":"en","_id":"556dc894a866afd621a1ca77"}]},{"nsp":"http://data.lirmm.fr/ontologies/passim#","prefix":"passim","uri":"http://data.lirmm.fr/ontologies/passim","titles":[{"value":"PASSIM ontology","lang":"en","_id":"59dce02c2febc4a21c3167c7"}]},{"nsp":"http://purl.org/hpi/patchr#","prefix":"pat","uri":"http://purl.org/hpi/patchr#","titles":[{"value":"Patch Request Ontology","lang":"en"}]},{"nsp":"http://www.essepuntato.it/2008/12/pattern#","prefix":"pattern","uri":"http://www.essepuntato.it/2008/12/pattern","titles":[{"value":"The Pattern Ontology","lang":"en","_id":"55bb58787459b3975b63c013"}]},{"nsp":"http://purl.org/pav/","prefix":"pav","uri":"http://purl.org/pav/","titles":[{"value":"Provenance, Authoring and Versioning","lang":"en","_id":"581718fdc1b1a26b516f787c"}]},{"nsp":"http://reference.data.gov.uk/def/payment#","prefix":"pay","uri":"http://reference.data.gov.uk/def/payment#","titles":[{"value":"Payments ontology","lang":"en","_id":"57ad8f81b00b4b1452a88cb7"}]},{"nsp":"http://purl.org/ontology/pbo/core#","prefix":"pbo","uri":"http://purl.org/ontology/pbo/core#","titles":[{"value":"Play Back Ontology","lang":"en","_id":"55e060c9a71142386b776215"}]},{"nsp":"http://purl.org/procurement/public-contracts#","prefix":"pc","uri":"http://purl.org/procurement/public-contracts","titles":[{"value":"Public Contracts Ontology","lang":"en","_id":"55310643be83f8651477b824"}]},{"nsp":"http://ontologies.smile.deri.ie/pdo#","prefix":"pdo","uri":"http://vocab.deri.ie/pdo","titles":[{"value":"Project Documents Ontology","lang":"en","_id":"55e05ad8419d00687563ad8f"}]},{"nsp":"https://w3id.org/pep/","prefix":"pep","uri":"https://w3id.org/pep/","titles":[{"value":"Process Execution ontology.","lang":"en","_id":"5feb47beba82ec865987976f"}]},{"nsp":"http://www.w3.org/ns/person#","prefix":"person","uri":"http://www.w3.org/ns/person","titles":[{"value":"ISA Programme Person Core Vocabulary","lang":"en","_id":"59dcdeb12febc4a21c31668b"}]},{"nsp":"http://www.ontotext.com/proton/protonext#","prefix":"pext","uri":"http://www.ontotext.com/proton/protonext","titles":[{"value":"PROTON Extent module","lang":"en","_id":"57ad8f47b00b4b1452a88c65"}]},{"uri":"https://w3id.org/pfeepsa#","nsp":"https://w3id.org/pfeepsa#","prefix":"pfeepsa","titles":[{"value":"The PFEEPSA Ontology.","lang":"en","_id":"5eb4077bdff95c0656a7c15a"}]},{"nsp":"http://rdf-vocabulary.ddialliance.org/phdd#","prefix":"phdd","uri":"http://rdf-vocabulary.ddialliance.org/phdd","titles":[{"value":"Physical Data Description","lang":"en","_id":"555df25630f688c94e823b15"}]},{"uri":"http://data.cochrane.org/ontologies/pico/","nsp":"http://data.cochrane.org/ontologies/pico/","prefix":"pico","titles":[{"value":"Cochrane PICO Ontology","lang":"en","_id":"5e905bf32cdad58a4e618c69"}]},{"nsp":"http://purl.org/ontology/places#","prefix":"place","uri":"http://purl.org/ontology/places","titles":[{"value":"The Places Ontology","lang":"en","_id":"5dacde568b936c5b59e22a6b"}]},{"nsp":"http://cedric.cnam.fr/isid/ontologies/PersonLink.owl#","prefix":"plink","uri":"http://cedric.cnam.fr/isid/ontologies/PersonLink.owl","titles":[{"value":"PersonLink Ontology","lang":"en","_id":"5c1a7aa6712ec7a91b1ea13a"}]},{"nsp":"http://purl.org/net/po#","prefix":"plo","uri":"http://purl.org/net/po#","titles":[{"value":"Playlist Ontology","lang":"en","_id":"56950ae3ff8848f96bd10445"}]},{"nsp":"http://inference-web.org/2.0/pml-provenance.owl#","prefix":"pmlp","uri":"http://inference-web.org/2.0/pml-provenance.owl","titles":[{"value":"PML2 provenance ontology","lang":"en","_id":"5693f4f9ff8848f96bd09109"}]},{"nsp":"http://premon.fbk.eu/ontology/fn#","prefix":"pmofn","uri":"http://premon.fbk.eu/ontology/fn","titles":[{"value":"Predicate Model for Ontologies (PreMOn) - FrameNet ontology module","lang":"en","_id":"599d8e19daf8c9570d02b8ec"}]},{"nsp":"http://premon.fbk.eu/ontology/nb#","prefix":"pmonb","uri":"http://premon.fbk.eu/ontology/nb","titles":[{"value":"Predicate Model for Ontologies (PreMOn) - NomBank ontology module","lang":"en","_id":"599d9658daf8c9570d02c2d3"}]},{"nsp":"http://premon.fbk.eu/ontology/pb#","prefix":"pmopb","uri":"http://premon.fbk.eu/ontology/pb","titles":[{"value":"Predicate Model for Ontologies (PreMOn) - PropBank ontology module","lang":"en","_id":"599db279daf8c9570d02fb53"}]},{"nsp":"http://premon.fbk.eu/ontology/vn#","prefix":"pmovn","uri":"http://premon.fbk.eu/ontology/vn","titles":[{"value":"Predicate Model for Ontologies (PreMOn) - VerbNet ontology module","lang":"en","_id":"599d942fdaf8c9570d02bf4a"}]},{"nsp":"http://data.press.net/ontology/asset/","prefix":"pna","uri":"http://data.press.net/ontology/asset/","titles":[{"value":"Press.net Asset Ontology","lang":"en","_id":"55e05a81419d00687563ad87"}]},{"nsp":"http://data.press.net/ontology/classification/","prefix":"pnc","uri":"http://data.press.net/ontology/classification/","titles":[{"value":"Press.net Classification Ontology","lang":"en","_id":"57ad8d0fb00b4b1452a88b4b"}]},{"nsp":"http://data.press.net/ontology/event/","prefix":"pne","uri":"http://data.press.net/ontology/event/","titles":[{"value":"Press.net Event Ontology","lang":"en","_id":"560652478f7ad2ce3438d3fd"}]},{"nsp":"http://data.press.net/ontology/identifier/","prefix":"pni","uri":"http://data.press.net/ontology/identifier/","titles":[{"value":"SNaP Identifier Ontology","lang":"en","_id":"56a3c37037d8a8044b2540cc"}]},{"nsp":"http://data.press.net/ontology/stuff/","prefix":"pns","uri":"http://data.press.net/ontology/stuff/","titles":[{"value":"Press.net Stuff Ontology","lang":"en","_id":"5accd0783aba5caf50dbed6b"}]},{"nsp":"http://data.press.net/ontology/tag/","prefix":"pnt","uri":"http://data.press.net/ontology/tag/","titles":[{"value":"Press.net Tag Ontology","lang":"en","_id":"55d72fbae4ac2b1c4c5a5183"}]},{"nsp":"http://purl.org/ontology/po/","prefix":"po","uri":"http://purl.org/ontology/po/","titles":[{"value":"Programmes ontology","lang":"en","_id":"583a0f5ccd0ed0472763e186"}]},{"nsp":"http://dev.poderopedia.com/vocab/","prefix":"poder","uri":"http://dev.poderopedia.com/vocab/schema","titles":[{"value":"Poder Vocabulary","lang":"en","_id":"5accd0503aba5caf50dbed15"}]},{"uri":"http://purl.org/poso/","nsp":"http://purl.org/poso/","prefix":"poso","titles":[{"value":"Positioning System Ontology","lang":"en","_id":"6326e65c121504032603c39e"}]},{"uri":"http://purl.org/poso/common/","nsp":"http://purl.org/poso/common/","prefix":"posocm","titles":[{"value":"Positioning System Ontology Common Technologies, Algorithms and Systems","lang":"en","_id":"6326e788121504032603c3c7"}]},{"nsp":"http://data.ordnancesurvey.co.uk/ontology/postcode/","prefix":"postcode","uri":"http://data.ordnancesurvey.co.uk/ontology/postcode/","titles":[{"value":"Postcode Ontology","lang":"en","_id":"5a418d96b201efd03d3b77d0"}]},{"nsp":"http://data.lirmm.fr/ontologies/poste#","prefix":"poste","uri":"http://data.lirmm.fr/ontologies/poste","titles":[{"value":"Ontologie de la Poste","lang":"fr","_id":"5783c0c20183b1e80fc87fb7"},{"value":"\\"La Poste\\" Ontology","lang":"en","_id":"5783c0c20183b1e80fc87fb6"}]},{"nsp":"http://vocab.deri.ie/ppo#","prefix":"ppo","uri":"http://vocab.deri.ie/ppo","titles":[{"value":"Privacy Preference Ontology","lang":"en","_id":"55c208da47ebcd4d234436d9"}]},{"nsp":"http://contsem.unizar.es/def/sector-publico/pproc#","prefix":"pproc","uri":"http://contsem.unizar.es/def/sector-publico/pproc","titles":[{"value":"PPROC ontology","lang":"en","_id":"55f847826185ddbd5f7a029a"}]},{"nsp":"http://purl.org/ontology/prv/core#","prefix":"pr","uri":"http://purl.org/ontology/prv/core#","titles":[{"value":"Property Reification Vocabulary","lang":"en","_id":"55e05a0b419d00687563ad7c"}]},{"nsp":"http://www.loc.gov/premis/rdf/v1#","prefix":"premis","uri":"http://www.loc.gov/premis/rdf/v1","titles":[{"value":"PREMIS Ontology","lang":"en","_id":"5dace1028b936c5b59e22a9b"}]},{"nsp":"http://ns.inria.fr/prissma/v2#","prefix":"prissma","uri":"http://ns.inria.fr/prissma/v2#","titles":[{"value":"Presentation of Resources for Interoperable Semantic and Shareable Mobile Adaptability","lang":"en","_id":"5db033dd581233d82940d264"}]},{"nsp":"http://purl.org/spar/pro/","prefix":"pro","uri":"http://purl.org/spar/pro","titles":[{"value":"The Publishing Roles Ontology","lang":"en","_id":"583a0f8dcd0ed0472763e18f"}]},{"uri":"http://www.w3.org/ns/dx/prof","nsp":"http://www.w3.org/ns/dx/prof/","prefix":"prof","titles":[{"value":"Profiles Vocabulary","lang":"en","_id":"5f36d8324dda25af52c6e000"}]},{"nsp":"http://purl.org/prog/","prefix":"prog","uri":"http://purl.org/prog/","titles":[{"value":"The Event Programme Vocabulary","lang":"en","_id":"57ad8cabb00b4b1452a88b2e"}]},{"nsp":"http://www.w3.org/ns/prov#","prefix":"prov","uri":"http://www.w3.org/ns/prov#","titles":[{"value":"W3C PROVenance Interchange","lang":"en","_id":"58f9d4fe6961d74e135adc2d"}]},{"nsp":"http://ns.inria.fr/provoc#","prefix":"provoc","uri":"http://ns.inria.fr/provoc","titles":[{"value":"Product Vocabulary","lang":"en","_id":"56c6e6c1087c0703190899aa"}]},{"nsp":"http://purl.org/net/provenance/ns#","prefix":"prv","uri":"http://purl.org/net/provenance/ns#","titles":[{"value":"Provenance Vocabulary Core Ontology","lang":"en","_id":"5ad0afe43aba5caf50df13f4"}]},{"nsp":"http://purl.org/net/provenance/types#","prefix":"prvt","uri":"http://purl.org/net/provenance/types#","titles":[{"value":"Provenance Vocabulary types","lang":"en","_id":"560653378f7ad2ce3438d435"}]},{"nsp":"http://purl.org/spar/pso/","prefix":"pso","uri":"http://purl.org/spar/pso","titles":[{"value":"The Publishing Status Ontology","lang":"en","_id":"583a0cd2cd0ed0472763e167"}]},{"nsp":"http://www.ontotext.com/proton/protontop#","prefix":"ptop","uri":"http://www.ontotext.com/proton/protontop","titles":[{"value":"PROTON (Proto Ontology), Top Module","lang":"en","_id":"5697bb59ff8848f96bd12b97"}]},{"nsp":"https://vocab.eccenca.com/pubsub/","prefix":"pubsub","uri":"https://vocab.eccenca.com/pubsub/","titles":[{"value":"Eccenca Publish-Subscribe Vocabulary","lang":"en","_id":"606c0c2e599773345e0c5789"}]},{"uri":"https://w3id.org/env/puv","nsp":"https://w3id.org/env/puv#","prefix":"puv","titles":[{"value":"Parameter Usage Vocabulary ontology","lang":"en","_id":"635a895bfd5cc3ee1cd108f5"}]},{"nsp":"http://purl.org/spar/pwo/","prefix":"pwo","uri":"http://purl.org/spar/pwo","titles":[{"value":"The Publishing Workflow Ontology","lang":"en","_id":"55de189754ef107a63464b14"}]},{"nsp":"http://purl.org/linked-data/cube#","prefix":"qb","uri":"http://purl.org/linked-data/cube","titles":[{"value":"The data cube vocabulary","lang":"en","_id":"576a58fa4a73263716316bb2"}]},{"nsp":"http://purl.org/qb4olap/cubes#","prefix":"qb4o","uri":"http://purl.org/qb4olap/cubes","titles":[{"value":"Vocabulary for publishing OLAP data cubes","lang":"en","_id":"57d2cde5a3a9d3a63d7e8add"}]},{"nsp":"http://purl.oclc.org/NET/ssnx/qu/qu#","prefix":"qu","uri":"http://purl.oclc.org/NET/ssnx/qu/qu","titles":[{"value":"Quantity Kinds and Units","lang":"en","_id":"578d05ee8c6f955d29c02c53"}]},{"nsp":"http://qudt.org/schema/qudt/","prefix":"qudt","uri":"http://qudt.org/schema/qudt","titles":[{"value":"Quantities, Units, Dimensions and Types","lang":"en","_id":"5f1b1746b658e6e346838e22"}]},{"uri":"https://w3id.org/arco/ontology/arco","nsp":"https://w3id.org/arco/ontology/arco/","prefix":"r-arco","titles":[{"value":"ArCo Ontology (ArCo network)","lang":"en","_id":"5db15c6f5433bbf424c65658"}]},{"nsp":"http://guava.iis.sinica.edu.tw/r4r/","prefix":"r4r","uri":"http://guava.iis.sinica.edu.tw/r4r","titles":[{"value":"Relations for Reusing (R4R) Ontology","lang":"en","_id":"57ad8c03b00b4b1452a88aee"}]},{"nsp":"http://www.w3.org/ns/radion#","prefix":"radion","uri":"http://www.w3.org/ns/radion#","titles":[{"value":"Repository Asset Distribution","lang":"en","_id":"59dcdf302febc4a21c3166e6"}]},{"uri":"https://w3id.org/rains","nsp":"https://w3id.org/rains#","prefix":"rains","titles":[{"value":"The RAInS Ontology","lang":"en","_id":"62791672476a20423a95d4c9"}]},{"nsp":"http://iais.fraunhofer.de/vocabs/rami#","prefix":"rami","uri":"https://w3id.org/i40/rami/","titles":[{"value":"rami - Reference Architecture Model","lang":"en","_id":"619a27ed964a94327aaf7b57"}]},{"nsp":"http://purl.org/NET/raul#","prefix":"raul","uri":"http://vocab.deri.ie/raul","titles":[{"value":"RAUL Vocabulary","lang":"en","_id":"56950b27ff8848f96bd1046d"}]},{"nsp":"http://rdaregistry.info/Elements/a/","prefix":"rdaa","uri":"http://rdaregistry.info/Elements/a","titles":[{"value":"RDA Agent properties","lang":"en","_id":"56a523a037d8a8044b25e0b7"}]},{"nsp":"http://rdaregistry.info/Elements/c/","prefix":"rdac","uri":"http://rdaregistry.info/Elements/c","titles":[{"value":"RDA Classes","lang":"en","_id":"56a654a737d8a8044b264668"}]},{"nsp":"http://rdaregistry.info/Elements/e/","prefix":"rdae","uri":"http://rdaregistry.info/Elements/e","titles":[{"value":"RDA Expression properties","lang":"en","_id":"5acccf783aba5caf50dbec0d"}]},{"nsp":"http://rdvocab.info/uri/schema/FRBRentitiesRDA/","prefix":"rdafrbr","uri":"http://rdvocab.info/uri/schema/FRBRentitiesRDA","titles":[{"value":"FRBR Entities for RDA","lang":"en","_id":"56a64d6837d8a8044b2642d0"}]},{"nsp":"http://rdvocab.info/Elements/","prefix":"rdag1","uri":"http://rdvocab.info/Elements","titles":[{"value":"RDA Group 1 Elements","lang":"en","_id":"56a6536637d8a8044b264550"}]},{"nsp":"http://rdvocab.info/ElementsGr2/","prefix":"rdag2","uri":"http://rdvocab.info/ElementsGr2","titles":[{"value":"RDA Group 2 Elements","lang":"en","_id":"56a5231537d8a8044b25e063"}]},{"nsp":"http://rdvocab.info/ElementsGr3/","prefix":"rdag3","uri":"http://rdvocab.info/ElementsGr3","titles":[{"value":"RDA Group 3 Elements","lang":"en","_id":"56a64ddc37d8a8044b264306"}]},{"nsp":"http://rdaregistry.info/Elements/i/","prefix":"rdai","uri":"http://rdaregistry.info/Elements/i","titles":[{"value":"RDA Item properties","lang":"en","_id":"56ae4ec798f0192c57ea027c"}]},{"nsp":"http://rdaregistry.info/Elements/m/","prefix":"rdam","uri":"http://rdaregistry.info/Elements/m","titles":[{"value":"RDA Manifestation properties","lang":"en","_id":"56a521c437d8a8044b25dfb8"}]},{"nsp":"http://rdvocab.info/RDARelationshipsWEMI/","prefix":"rdarel","uri":"http://rdvocab.info/RDARelationshipsWEMI","titles":[{"value":"RDA Relationships for Works, Expressions, Manifestations, Items","lang":"en","_id":"56a6992137d8a8044b26676d"}]},{"nsp":"http://metadataregistry.org/uri/schema/RDARelationshipsGR2/","prefix":"rdarel2","uri":"http://metadataregistry.org/uri/schema/RDARelationshipsGR2","titles":[{"value":"RDA Relationships GR2","lang":"en","_id":"57ad8c2bb00b4b1452a88afb"}]},{"nsp":"http://rdvocab.info/roles/","prefix":"rdarole","uri":"http://rdvocab.info/roles","titles":[{"value":"RDA Roles","lang":"en","_id":"56ae4db198f0192c57ea0270"}]},{"nsp":"http://rdaregistry.info/Elements/u/","prefix":"rdau","uri":"http://rdaregistry.info/Elements/u","titles":[{"value":"RDA Unconstrained properties","lang":"en","_id":"568e6d694ee7f7176ff24672"}]},{"nsp":"http://rdaregistry.info/Elements/w/","prefix":"rdaw","uri":"http://rdaregistry.info/Elements/w","titles":[{"value":"RDA Work properties","lang":"en","_id":"56a51c5437d8a8044b25dc2d"}]},{"nsp":"http://www.w3.org/1999/02/22-rdf-syntax-ns#","prefix":"rdf","uri":"http://www.w3.org/1999/02/22-rdf-syntax-ns#","titles":[{"value":"The RDF Concepts Vocabulary","lang":"en","_id":"60449e78f05734d01727282d"}]},{"nsp":"http://www.w3.org/ns/rdfa#","prefix":"rdfa","uri":"http://www.w3.org/ns/rdfa#","titles":[{"value":"RDFa Vocabulary for Term and Prefix Assignment, and for Processor Graph Reporting","lang":"en","_id":"5783c5580183b1e80fc88265"}]},{"nsp":"http://www.w3.org/2004/03/trix/rdfg-1/","prefix":"rdfg","uri":"http://www.w3.org/2004/03/trix/rdfg-1/","titles":[{"value":"Graph","lang":"en","_id":"561e530942fc695f7e67719d"}]},{"nsp":"https://w3id.org/rdfp/","prefix":"rdfp","uri":"https://w3id.org/rdfp/","titles":[{"value":"The RDF Presentation ontology","lang":"en","_id":"580e19837ada88436788895f"}]},{"nsp":"http://www.w3.org/2000/01/rdf-schema#","prefix":"rdfs","uri":"http://www.w3.org/2000/01/rdf-schema#","titles":[{"value":"The RDF Schema vocabulary","lang":"en","_id":"58ec88bbabe2639e2c3bd8d4"}]},{"uri":"http://www.w3.org/ns/rdftest","nsp":"http://www.w3.org/ns/rdftest#","prefix":"rdft","titles":[{"value":"The RDF 1.1 Test Vocabulary","lang":"en","_id":"60f444cb974824e9140ad42f"}]},{"uri":"https://w3id.org/react","nsp":"https://w3id.org/react#","prefix":"react","titles":[{"value":"The REACT Ontology","lang":"en","_id":"63247215f0004aba7af3f788"}]},{"nsp":"http://purl.org/ontology/rec/core#","prefix":"rec","uri":"http://purl.org/ontology/rec/core#","titles":[{"value":"Recommendation Ontology","lang":"en","_id":"55e057ca419d00687563ad55"}]},{"nsp":"http://www.w3.org/2001/02pd/rec54#","prefix":"rec54","uri":"http://www.w3.org/2001/02pd/rec54#","titles":[{"value":"Model of the W3C Process","lang":"en","_id":"55e05b85419d00687563ad9c"}]},{"nsp":"http://purl.org/reco#","prefix":"reco","uri":"http://purl.org/reco#","titles":[{"value":"RECommendations Ontology","lang":"en","_id":"57d2ce7aa3a9d3a63d7e8b24"}]},{"nsp":"http://reegle.info/schema#","prefix":"reegle","uri":"http://reegle.info/schema","titles":[{"value":"Renewable Energy and Energy Efficiency","lang":"en","_id":"5accd09b3aba5caf50dbeda7"}]},{"nsp":"http://purl.org/vocab/relationship/","prefix":"rel","uri":"http://purl.org/vocab/relationship/","titles":[{"value":"Relationship","lang":"en","_id":"583a0a49cd0ed0472763e14f"}]},{"nsp":"http://www.purl.org/net/remetca#","prefix":"remetca","uri":"http://www.purl.org/net/remetca#","titles":[{"value":"ReMetCa Ontology","lang":"en","_id":"56ae4f1698f0192c57ea0281"}]},{"nsp":"http://purl.org/stuff/rev#","prefix":"rev","uri":"http://purl.org/stuff/rev#","titles":[{"value":"Review Vocabulary","lang":"en","_id":"555d0af330f688c94e82364a"}]},{"uri":"https://www.ica.org/standards/RiC/ontology","nsp":"https://www.ica.org/standards/RiC/ontology#","prefix":"rico","titles":[{"value":"International Council on Archives Records in Contexts Ontology (ICA RiC-O)","lang":"en","_id":"6054dfddc98d09ac1b967480"}]},{"nsp":"http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#","prefix":"rlog","uri":"http://persistence.uni-leipzig.org/nlp2rdf/ontologies/rlog#","titles":[{"value":"RDF Logging Ontology","lang":"en","_id":"569f7971ff8848f96bd205ce"}]},{"nsp":"http://purl.org/wf4ever/ro#","prefix":"ro","uri":"http://purl.org/wf4ever/ro","titles":[{"value":"The Research Object Ontology","lang":"en","_id":"57ad8bb4b00b4b1452a88ada"}]},{"uri":"http://w3id.org/roh","nsp":"http://w3id.org/roh#","prefix":"roh","titles":[{"value":"The ASIO ontology","lang":"en","_id":"632483f0f0004aba7af3f821"}]},{"nsp":"http://vocab.deri.ie/rooms#","prefix":"rooms","uri":"http://vocab.deri.ie/rooms","titles":[{"value":"Buildings and Rooms Vocabulary","lang":"en","_id":"5dad880a98c7a8076a14d6bb"}]},{"nsp":"http://www.w3.org/ns/regorg#","prefix":"rov","uri":"http://www.w3.org/ns/regorg","titles":[{"value":"Registered Organization Vocabulary","lang":"en","_id":"569ccfb0ff8848f96bd16d03"}]},{"nsp":"http://www.w3.org/ns/r2rml#","prefix":"rr","uri":"http://www.w3.org/ns/r2rml#","titles":[{"value":"RDB to RDF Mapping Language Schema","lang":"en","_id":"556dc6f9a866afd621a1ca60"}]},{"nsp":"http://softeng.polito.it/rsctx#","prefix":"rsctx","uri":"http://softeng.polito.it/rsctx","titles":[{"value":"Recommender System Context","lang":"en","_id":"58eca6fcabe2639e2c3bf62f"}]},{"nsp":"http://purl.org/rss/1.0/","prefix":"rss","uri":"http://purl.org/rss/1.0","titles":[{"value":"Vocabulary for Rich Site Summary (RSS) 1.0","lang":"en","_id":"57ad8b79b00b4b1452a88ac5"}]},{"uri":"https://w3id.org/rail/topo#","nsp":"https://w3id.org/rail/topo#","prefix":"rto","titles":[{"value":"Rail Topology Ontology","lang":"en","_id":"60ae317ed50a5fc01d00f4ef"}]},{"nsp":"http://purl.org/imbi/ru-meta.owl#","prefix":"ru","uri":"http://purl.org/imbi/ru-meta.owl","titles":[{"value":"Representational Units Metadata Ontology","lang":"en","_id":"59dce1ee2febc4a21c3169a7"}]},{"nsp":"http://rdfunit.aksw.org/ns/core#","prefix":"ruto","uri":"http://rdfunit.aksw.org/ns/core#","titles":[{"value":"Test-Driven Data Debugging Ontology","lang":"en","_id":"56a5176937d8a8044b25d9d9"}]},{"nsp":"http://ns.inria.fr/s4ac/v2#","prefix":"s4ac","uri":"http://ns.inria.fr/s4ac/v2","titles":[{"value":"Social Semantic SPARQL Security For Access Control Ontology","lang":"en","_id":"5cb3149e470a172015caa396"}]},{"uri":"https://saref.etsi.org/saref4agri/","nsp":"https://saref.etsi.org/saref4agri/","prefix":"s4agri","titles":[{"value":"SAREF extension for Agriculture","lang":"en","_id":"6037b2b6354efffb2a8d4f21"}]},{"uri":"https://saref.etsi.org/saref4bldg/","nsp":"https://saref.etsi.org/saref4bldg/","prefix":"s4bldg","titles":[{"value":"SAREF extension for building devices","lang":"en","_id":"6037bc87354efffb2a8d4fb8"}]},{"uri":"https://saref.etsi.org/saref4city/","nsp":"https://saref.etsi.org/saref4city/","prefix":"s4city","titles":[{"value":"SAREF extension for Smart City","lang":"en","_id":"6037c8a9354efffb2a8d5071"}]},{"uri":"https://saref.etsi.org/saref4ehaw/","nsp":"https://saref.etsi.org/saref4ehaw/","prefix":"s4ehaw","titles":[{"value":"SAREF4EHAW: an extension of SAREF for eHealth Ageing Well domain","lang":"en","_id":"6037c30f354efffb2a8d5017"}]},{"nsp":"https://saref.etsi.org/saref4ener/","prefix":"s4ener","uri":"https://saref.etsi.org/saref4ener/","titles":[{"value":"SAREF4EE: the EEbus/Energy@home extension of SAREF","lang":"en","_id":"6037c3fc354efffb2a8d5022"}]},{"uri":"https://saref.etsi.org/saref4envi/","nsp":"https://saref.etsi.org/saref4envi/","prefix":"s4envi","titles":[{"value":"SAREF extension for environment","lang":"en","_id":"6037c8f5354efffb2a8d5077"}]},{"uri":"https://saref.etsi.org/saref4inma/","nsp":"https://saref.etsi.org/saref4inma/","prefix":"s4inma","titles":[{"value":"SAREF4INMA: an extension of SAREF for the industry and manufacturing domain","lang":"en","_id":"6037c01f354efffb2a8d4ff3"}]},{"uri":"https://saref.etsi.org/saref4syst/","nsp":"https://saref.etsi.org/saref4syst/","prefix":"s4syst","titles":[{"value":"SAREF4SYST: an extension of SAREF for typology of systems and their inter-connections","lang":"en","_id":"6037c540354efffb2a8d5030"}]},{"uri":"https://saref.etsi.org/saref4watr/","nsp":"https://saref.etsi.org/saref4watr/","prefix":"s4watr","titles":[{"value":"SAREF extension for water","lang":"en","_id":"6037c87d354efffb2a8d506e"}]},{"uri":"https://saref.etsi.org/saref4wear/","nsp":"https://saref.etsi.org/saref4wear/","prefix":"s4wear","titles":[{"value":"SAREF4WEAR: an extension of SAREF for Wearables","lang":"en","_id":"6037c833354efffb2a8d5066"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling#","prefix":"sam","uri":"http://def.seegrid.csiro.au/isotc211/iso19156/2011/sampling","titles":[{"value":"The Sampling Features Schema Vocabulary","lang":"en","_id":"55d737b0e4ac2b1c4c5a52f6"}]},{"nsp":"http://def.seegrid.csiro.au/ontology/om/sam-lite#","prefix":"samfl","uri":"http://def.seegrid.csiro.au/ontology/om/sam-lite","titles":[{"value":"OWL for Sampling Features","lang":"en","_id":"56af7fdd98f0192c57ea9a30"}]},{"nsp":"http://dati.san.beniculturali.it/SAN/","prefix":"san-lod","uri":"http://dati.san.beniculturali.it/SAN/","titles":[{"value":"SAN Ontologia","lang":"en","_id":"589998c0d9b1a8a8618f704c"}]},{"nsp":"http://salt.semanticauthoring.org/ontologies/sao#","prefix":"sao","uri":"http://salt.semanticauthoring.org/ontologies/sao","titles":[{"value":"SALT Annotation Ontology","lang":"en","_id":"583a0a1acd0ed0472763e146"}]},{"uri":"https://w3id.org/sao","nsp":"https://w3id.org/sao#","prefix":"saont","titles":[{"value":"The System Accountability Ontology","lang":"en","_id":"627915a4476a20423a95d4c0"}]},{"nsp":"https://saref.etsi.org/core/","prefix":"saref","uri":"https://saref.etsi.org/core/","titles":[{"value":"SAREF: the Smart Appliances REFerence ontology","lang":"en","_id":"6037b211354efffb2a8d4f0d"}]},{"nsp":"http://purl.org/saws/ontology#","prefix":"saws","uri":"http://purl.org/saws/ontology","titles":[{"value":"Sharing Ancient Wisdoms Ontology","lang":"en","_id":"556dc75ca866afd621a1ca65"}]},{"uri":"https://w3id.org/sbeo","nsp":"https://w3id.org/sbeo#","prefix":"sbeo","titles":[{"value":"SBEO: Smart Building Evacuation Ontology","lang":"en","_id":"60361a57ecd40f1919dc8689"}]},{"nsp":"http://schema.org/","prefix":"schema","uri":"http://schema.org/","titles":[{"value":"Schema.org vocabulary","lang":"en","_id":"5e7c8e57b27249284e3513c5"}]},{"nsp":"http://lod.taxonconcept.org/ontology/sci_people.owl#","prefix":"scip","uri":"http://lod.taxonconcept.org/ontology/sci_people.owl","titles":[{"value":"Scientific People Ontology","lang":"en","_id":"56a3c47b37d8a8044b254156"}]},{"nsp":"http://purl.org/spar/scoro/","prefix":"scoro","uri":"http://purl.org/spar/scoro/","titles":[{"value":"Scholarly Contributions and Roles Ontology","lang":"en","_id":"586bab2f7e341093492c489f"}]},{"nsp":"http://rdfs.org/scot/ns#","prefix":"scot","uri":"http://rdfs.org/scot/ns#","titles":[{"value":"Social Semantic Cloud of Tags","lang":"en","_id":"586bd6e07e341093492c5100"}]},{"nsp":"http://purl.org/NET/scovo#","prefix":"scovo","uri":"http://vocab.deri.ie/scovo","titles":[{"value":"The Statistical Core Vocabulary","lang":"en","_id":"5783c2460183b1e80fc8807f"}]},{"nsp":"http://purl.org/NET/schema-org-csv#","prefix":"scsv","uri":"http://vocab.deri.ie/scsv","titles":[{"value":"Schema.org CSV","lang":"en","_id":"56a3c4ee37d8a8044b25419c"}]},{"nsp":"http://www.w3.org/ns/sparql-service-description#","prefix":"sd","uri":"http://www.w3.org/ns/sparql-service-description","titles":[{"value":"SPARQL 1.1 Service Description","lang":"en","_id":"5adda46c67b67f5811d01cc6"}]},{"uri":"https://w3id.org/vocab/sdm","nsp":"https://w3id.org/vocab/sdm#","prefix":"sdm","titles":[{"value":"SPARQL endpoint metadata","lang":"en","_id":"5f1ac0f8388540d23b85cee3"}]},{"nsp":"http://purl.org/linked-data/sdmx#","prefix":"sdmx","uri":"http://purl.org/linked-data/sdmx","titles":[{"value":"SDMX-RDF vocabulary","lang":"en","_id":"5c0544ba72ce82f646afa0e5"}]},{"nsp":"http://purl.org/linked-data/sdmx/2009/code#","prefix":"sdmx-code","uri":"http://purl.org/linked-data/sdmx/2009/code","titles":[{"value":"SDMX Code","lang":"en","_id":"57696c4f4a73263716312e6e"}]},{"nsp":"http://purl.org/linked-data/sdmx/2009/dimension#","prefix":"sdmx-dimension","uri":"http://purl.org/linked-data/sdmx/2009/dimension","titles":[{"value":"SDMX Dimension","lang":"en","_id":"5783c1ed0183b1e80fc8804c"}]},{"nsp":"http://salt.semanticauthoring.org/ontologies/sdo#","prefix":"sdo","uri":"http://salt.semanticauthoring.org/ontologies/sdo","titles":[{"value":"SALT Document Ontology","lang":"en","_id":"583a0781cd0ed0472763e12b"}]},{"uri":"http://www.sealitproject.eu/ontology/","nsp":"http://www.sealitproject.eu/ontology/","prefix":"sealit","titles":[{"value":"SeaLiT Ontology","lang":"en","_id":"632b431cc4f7e5f619d44488"}]},{"nsp":"http://sindice.com/vocab/search#","prefix":"search","uri":"http://vocab.deri.ie/search","titles":[{"value":"Sindice Search Vocabulary","lang":"en","_id":"55bb5e507459b3975b63c054"}]},{"nsp":"https://w3id.org/seas/","prefix":"seas","uri":"https://w3id.org/seas/","titles":[{"value":"SEAS ontology","lang":"en","_id":"584ad2bb8a0d14e34d5efc18"}]},{"nsp":"https://w3id.org/seas/","prefix":"seas-eval","uri":"https://w3id.org/seas/EvaluationOntology","titles":[{"value":"The SEAS Evaluation ontology","lang":"en","_id":"585f95207e34109349246cc0"}]},{"nsp":"https://w3id.org/seas/","prefix":"seas-op","uri":"https://w3id.org/seas/OperatingOntology","titles":[{"value":"The SEAS Failable System ontology","lang":"en","_id":"584ad3db8a0d14e34d5efc3b"}]},{"nsp":"https://w3id.org/seas/","prefix":"seas-qudt","uri":"https://w3id.org/seas/QUDTAlignment","titles":[{"value":"QUDT Alignment.","lang":"en","_id":"584ad4f58a0d14e34d5efc77"}]},{"nsp":"https://w3id.org/seas/","prefix":"seas-stats","uri":"https://w3id.org/seas/StatisticsOntology","titles":[{"value":"The SEAS Statistics ontology.","lang":"en","_id":"5873a4437e34109349366a9f"}]},{"nsp":"https://w3id.org/seas/","prefix":"seas-sys","uri":"https://w3id.org/seas/SystemOntology","titles":[{"value":"The SEAS System ontology","lang":"en","_id":"584ad1518a0d14e34d5efbec"}]},{"nsp":"https://w3id.org/seas/","prefix":"seasb","uri":"https://w3id.org/seas/BatteryOntology","titles":[{"value":"The SEAS Battery ontology.","lang":"en","_id":"59a67dff7845e44d19bf8a67"}]},{"nsp":"https://w3id.org/seas/","prefix":"seasbo","uri":"https://w3id.org/seas/BuildingOntology","titles":[{"value":"The SEAS Building Ontology","lang":"en","_id":"59a696887845e44d19bf9b3d"}]},{"nsp":"https://w3id.org/seas/","prefix":"seasd","uri":"https://w3id.org/seas/DeviceOntology","titles":[{"value":"The SEAS Device ontology","lang":"en","_id":"59a5a9377845e44d19beda04"}]},{"nsp":"https://w3id.org/seas/","prefix":"seasfo","uri":"https://w3id.org/seas/ForecastingOntology","titles":[{"value":"The SEAS Forecasting ontology","lang":"en","_id":"59a6814a7845e44d19bf8bb0"}]},{"nsp":"https://w3id.org/seas/","prefix":"seast","uri":"https://w3id.org/seas/TimeOntology","titles":[{"value":"The SEAS Time Ontology.","lang":"en","_id":"59a59ee17845e44d19becf88"}]},{"nsp":"https://w3id.org/seas/","prefix":"seasto","uri":"https://w3id.org/seas/TradingOntology","titles":[{"value":"The SEAS Trading ontology","lang":"en","_id":"59a687c27845e44d19bf910f"}]},{"nsp":"http://securitytoolbox.appspot.com/securityMain#","prefix":"security","uri":"http://securitytoolbox.appspot.com/securityMain","titles":[{"value":"Security Ontology","lang":"en","_id":"57ad8aefb00b4b1452a88a9a"}]},{"nsp":"http://semanticweb.cs.vu.nl/2009/11/sem/","prefix":"sem","uri":"http://semanticweb.cs.vu.nl/2009/11/sem/","titles":[{"value":"The SEM Ontology","lang":"en","_id":"583a0b1ccd0ed0472763e15a"}]},{"nsp":"http://www.lingvoj.org/semio#","prefix":"semio","uri":"http://www.lingvoj.org/semio.rdf","titles":[{"value":"Semio, an ontology of signs","lang":"en","_id":"58f9d5536961d74e135adc87"}]},{"uri":"http://www.ontologydesignpatterns.org/cp/owl/semiotics.owl","nsp":"http://www.ontologydesignpatterns.org/cp/owl/semiotics.owl#","prefix":"semiotics","titles":[{"value":"A content ontology pattern that encodes a basic semiotic theory, by reusing the situation pattern.","lang":"en","_id":"60b7ab1c87423a16187e448d"}]},{"nsp":"http://purl.org/SemSur/","prefix":"semsur","uri":"http://purl.org/SemSur/","titles":[{"value":"The Semantic Survey Ontology (semsur)","lang":"en","_id":"5ad9f3ae2e909b214fc361a1"}]},{"nsp":"https://w3id.org/seo#","prefix":"seo","uri":"https://w3id.org/seo#","titles":[{"value":"The Scientific Events Ontology","lang":"en","_id":"61d5a9d8b7d3952f632002de"}]},{"nsp":"http://www.ontologydesignpatterns.org/cp/owl/sequence.owl#","prefix":"seq","uri":"http://www.ontologydesignpatterns.org/cp/owl/sequence.owl","titles":[{"value":"Sequence Pattern","lang":"en","_id":"5697b7f9ff8848f96bd12b39"}]},{"nsp":"http://purl.org/ontology/service#","prefix":"service","uri":"http://purl.org/ontology/service","titles":[{"value":"The Service Ontology","lang":"en","_id":"560659578f7ad2ce3438d586"}]},{"nsp":"http://www.opengis.net/ont/sf#","prefix":"sf","uri":"http://www.opengis.net/ont/sf","titles":[{"value":"Simplified Features Geometry","lang":"en","_id":"5697b7c3ff8848f96bd12b1a"}]},{"nsp":"http://www.w3.org/ns/shacl#","prefix":"sh","uri":"http://www.w3.org/ns/shacl#","titles":[{"value":"W3C Shapes Constraint Language (SHACL) Vocabulary","lang":"en","_id":"5accce153aba5caf50dbea61"}]},{"nsp":"http://dati.cdec.it/lod/shoah/","prefix":"shoah","uri":"http://dati.cdec.it/lod/shoah/","titles":[{"value":"Shoah Vocabulary Specification","lang":"en","_id":"578d05bb8c6f955d29c02c4e"}]},{"nsp":"http://paul.staroch.name/thesis/SmartHomeWeather.owl#","prefix":"shw","uri":"http://paul.staroch.name/thesis/SmartHomeWeather.owl#","titles":[{"value":"Smart Home Weather","lang":"en","_id":"5809c78f3e5586c53d897083"}]},{"nsp":"http://purl.org/ontology/similarity/","prefix":"sim","uri":"http://purl.org/ontology/similarity/","titles":[{"value":"The Similarity Ontology","lang":"en","_id":"55abbd6857613119099d71aa"}]},{"uri":"https://www.w3id.org/simulation/ontology/","nsp":"https://www.w3id.org/simulation/ontology/","prefix":"simu","titles":[{"value":"Simulation Ontology","lang":"en","_id":"63bd314a231281b8299f9b67"}]},{"nsp":"http://semanticscience.org/resource/","prefix":"sio","uri":"http://semanticscience.org/ontology/sio.owl","titles":[{"value":"Semanticscience Integrated Ontology","lang":"en","_id":"583a0821cd0ed0472763e136"}]},{"nsp":"http://rdfs.org/sioc/ns#","prefix":"sioc","uri":"http://rdfs.org/sioc/ns#","titles":[{"value":"Semantically-Interlinked Online Communities","lang":"en","_id":"5697b70cff8848f96bd12b03"}]},{"nsp":"http://www.ontologydesignpatterns.org/cp/owl/situation.owl#","prefix":"situ","uri":"http://www.ontologydesignpatterns.org/cp/owl/situation.owl","titles":[{"value":"Situation Pattern","lang":"en","_id":"569ccfdaff8848f96bd16d0e"}]},{"nsp":"http://www.w3.org/2004/02/skos/core#","prefix":"skos","uri":"http://www.w3.org/2004/02/skos/core","titles":[{"value":"Simple Knowledge Organization System","lang":"en","_id":"58ec8906abe2639e2c3bd91a"}]},{"nsp":"http://www.w3.org/2008/05/skos-xl#","prefix":"skosxl","uri":"http://www.w3.org/2008/05/skos-xl","titles":[{"value":"SKOS eXtension for Labels","lang":"en","_id":"58ec89a7abe2639e2c3bd9b2"}]},{"nsp":"http://ns.cerise-project.nl/energy/def/cim-smartgrid#","prefix":"smg","uri":"http://ns.cerise-project.nl/energy/def/cim-smartgrid","titles":[{"value":"CERISE CIM Profile for Smart Grids","lang":"en","_id":"569cd063ff8848f96bd16d2a"}]},{"nsp":"http://rdf.myexperiment.org/ontologies/snarm/","prefix":"snarm","uri":"http://rdf.myexperiment.org/ontologies/snarm/","titles":[{"value":"Simple Network Access Rights Management Ontology","lang":"en","_id":"56719d544ee7f7176fe64be0"}]},{"uri":"http://www.w3.org/ns/solid/terms","nsp":"http://www.w3.org/ns/solid/terms#","prefix":"solid","titles":[{"value":"Solid terms","lang":"en","_id":"5cd0359bd18d844f5ff6f650"}]},{"nsp":"http://purl.org/net/soron/","prefix":"sor","uri":"http://purl.org/net/soron","titles":[{"value":"SORON: Social Relationships ONtology","lang":"en","_id":"586ba8e47e341093492c47a8"}]},{"nsp":"http://www.w3.org/ns/sosa/","prefix":"sosa","uri":"http://www.w3.org/ns/sosa/","titles":[{"value":"Sensor, Observation, Sample, and Actuator (SOSA) Ontology","lang":"en","_id":"58f9bf1e6961d74e135ab569"}]},{"nsp":"http://spinrdf.org/sp#","prefix":"sp","uri":"http://spinrdf.org/sp","titles":[{"value":"SPIN SPARQL Syntax","lang":"en","_id":"57696bf54a73263716312e61"}]},{"nsp":"http://geovocab.org/spatial#","prefix":"spatial","uri":"http://geovocab.org/spatial","titles":[{"value":"NeoGeo Spatial Ontology","lang":"en","_id":"57696c824a73263716312e7b"}]},{"nsp":"http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0#","prefix":"spcm","uri":"http://spi-fm.uca.es/spdef/models/deployment/spcm/1.0","titles":[{"value":"Software Process Control Model","lang":"en","_id":"5c4990f39e5c7dfa7bfd1ea7"}]},{"nsp":"http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl#","prefix":"spfood","uri":"http://kmi.open.ac.uk/projects/smartproducts/ontologies/food.owl","titles":[{"value":"SmartProducts Food Domain Model","lang":"en","_id":"59dcdaa72febc4a21c3161e8"}]},{"nsp":"http://spinrdf.org/spin#","prefix":"spin","uri":"http://spinrdf.org/spin","titles":[{"value":"SPIN Inferencing Vocabulary","lang":"en","_id":"568a56af4ee7f7176ff10ec4"}]},{"nsp":"http://www.bbc.co.uk/ontologies/sport/","prefix":"sport","uri":"http://www.bbc.co.uk/ontologies/sport","titles":[{"value":"BBC Sport Ontology","lang":"en","_id":"57e3dbe6812207ab035478ad"}]},{"nsp":"http://spitfire-project.eu/ontology/ns/","prefix":"spt","uri":"http://spitfire-project.eu/ontology/ns","titles":[{"value":"SPITFIRE Ontology","lang":"en","_id":"5809c57c3e5586c53d896e64"}]},{"nsp":"https://bmake.th-brandenburg.de/spv#","prefix":"spvqa","uri":"https://bmake.th-brandenburg.de/spv","titles":[{"value":"Scholarly Papers Vocabulary with Focus on Qualtitative Analysis","lang":"en","_id":"59b80ffb2ab721804e2fcb71"}]},{"nsp":"http://ns.inria.fr/ast/sql#","prefix":"sql","uri":"http://ns.inria.fr/ast/sql#","titles":[{"value":"SQL Abstract Syntax Trees Vocabulary","lang":"en","_id":"58f9d5a66961d74e135adce0"}]},{"nsp":"http://salt.semanticauthoring.org/ontologies/sro#","prefix":"sro","uri":"http://salt.semanticauthoring.org/ontologies/sro","titles":[{"value":"SALT Rhetorical Ontology","lang":"en","_id":"583a04fecd0ed0472763e112"}]},{"uri":"https://purl.org/esric/sronto","nsp":"https://purl.org/esric/sronto/","prefix":"sronto","titles":[{"value":"Space Resources Ontology","lang":"en","_id":"63209843f837e1272cb6ed66"}]},{"nsp":"http://www.w3.org/ns/ssn/","prefix":"ssn","uri":"http://www.w3.org/ns/ssn/","titles":[{"value":"Semantic Sensor Network Ontology","lang":"en","_id":"5fd1d248a1a8e88b452ba6da"}]},{"nsp":"http://www.w3.org/ns/ssn/","prefix":"ssno","uri":"http://www.w3.org/ns/ssn/","titles":[{"value":"Semantic Sensor Network Ontology","lang":"en","_id":"599d826edaf8c9570d02a6a6"}]},{"nsp":"http://purl.org/ontology/ssso#","prefix":"ssso","uri":"http://purl.org/ontology/ssso","titles":[{"value":"Simple Service Status Ontology","lang":"en","_id":"56a5158637d8a8044b25d8dc"}]},{"nsp":"http://semweb.mmlab.be/ns/stoptimes#","prefix":"st","uri":"http://semweb.mmlab.be/ns/stoptimes#Ontology","titles":[{"value":"The Stop Times ontology","lang":"en","_id":"55f5c184a71142386b7a398d"}]},{"nsp":"http://securitytoolbox.appspot.com/stac#","prefix":"stac","uri":"http://securitytoolbox.appspot.com/stac","titles":[{"value":"Security Toolbox : Attacks and Countermeasures","lang":"en","_id":"5cb30433470a172015caa313"}]},{"nsp":"http://purl.org/net/step#","prefix":"step","uri":"http://purl.org/net/step","titles":[{"value":"Semantic Trajectory Episodes","lang":"en","_id":"56938c0261dfb9a05dd2948b"}]},{"nsp":"https://w3id.org/i40/sto#","prefix":"sto","uri":"https://w3id.org/i40/sto#","titles":[{"value":"i40 Standards Lanscape Vocabulary","lang":"en","_id":"59b911622ab721804e310534"}]},{"nsp":"http://purl.org/ontology/stories/","prefix":"stories","uri":"http://purl.org/ontology/stories/","titles":[{"value":"Stories Ontology","lang":"en","_id":"586ba2d17e341093492c474e"}]},{"nsp":"http://purl.org/voc/summa/","prefix":"summa","uri":"http://purl.org/voc/summa/","titles":[{"value":"SUMMA Vocabulary","lang":"en","_id":"57ad84d9b00b4b1452a886be"}]},{"uri":"https://www.w3id.org/survey-ontology","nsp":"https://w3id.org/survey-ontology#","prefix":"sur","titles":[{"value":"The Survey Ontology","lang":"en","_id":"5f1acda1388540d23b85cf30"}]},{"uri":"https://w3id.org/squap/","nsp":"https://w3id.org/squap/SoftwareQuality/","prefix":"sw-quality","titles":[{"value":"SQuAP Ontology","lang":"en","_id":"5d2dcb84cc309974619c5271"}]},{"nsp":"http://data.semanticweb.org/ns/swc/ontology#","prefix":"swc","uri":"http://data.semanticweb.org/ns/swc/ontology","titles":[{"value":"Semantic Web Conference Ontology","lang":"en","_id":"55a0da1b57613119099c1049"}]},{"nsp":"http://www.w3.org/2004/03/trix/swp-1/","prefix":"swp","uri":"http://www.w3.org/2004/03/trix/swp-1","titles":[{"value":"Graph Authority","lang":"en","_id":"569cc838ff8848f96bd16c58"}]},{"nsp":"http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0#","prefix":"swpm","uri":"http://spi-fm.uca.es/spdef/models/deployment/swpm/1.0","titles":[{"value":"Software Work Product Model","lang":"en","_id":"55d733c5e4ac2b1c4c5a5244"}]},{"nsp":"http://sw-portal.deri.org/ontologies/swportal#","prefix":"swpo","uri":"http://sw-portal.deri.org/ontologies/swportal","titles":[{"value":"Semantic Web Portal Ontology","lang":"en","_id":"586ba1657e341093492c4739"}]},{"nsp":"http://swrc.ontoware.org/ontology#","prefix":"swrc","uri":"http://swrc.ontoware.org/ontology-07","titles":[{"value":"Semantic Web for Research Communities","lang":"en","_id":"5ad9dd862e909b214fc3567b"}]},{"nsp":"http://www.w3.org/2003/11/swrl#","prefix":"swrl","uri":"http://www.w3.org/2003/11/swrl","titles":[{"value":"Semantic Web Rule Language","lang":"en","_id":"576a582b4a73263716316b66"}]},{"uri":"http://www.w3.org/ns/lemon/synsem","nsp":"http://www.w3.org/ns/lemon/synsem#","prefix":"synsem","titles":[{"value":"Lexicon Model for Ontologies - Synsem","lang":"en","_id":"60d071196eec354e1dfe3de2"}]},{"nsp":"http://ns.bergnet.org/tac/0.1/triple-access-control#","prefix":"tac","uri":"http://ns.bergnet.org/tac/0.1/triple-access-control","titles":[{"value":"TripleAccessControl Ontology","lang":"en","_id":"59dce0cd2febc4a21c3168dd"}]},{"nsp":"http://www.holygoat.co.uk/owl/redwood/0.1/tags/","prefix":"tag","uri":"http://www.holygoat.co.uk/owl/redwood/0.1/tags/","titles":[{"value":"Tag ontology","lang":"en","_id":"583a0743cd0ed0472763e125"}]},{"nsp":"http://vocab.deri.ie/tao#","prefix":"tao","uri":"http://vocab.deri.ie/tao","titles":[{"value":"Trust Assertion Ontology","lang":"en","_id":"57ad868bb00b4b1452a88830"}]},{"uri":"https://w3id.org/EUTaxO","nsp":"https://w3id.org/EUTaxO#","prefix":"tax","titles":[{"value":"EUTaxO - EUdaphobase Taxonomy Ontology","lang":"en","_id":"638bc8a5e8d209386de14943"}]},{"nsp":"http://purl.org/biodiversity/taxon/","prefix":"taxon","uri":"http://purl.org/biodiversity/taxon/","titles":[{"value":"TaxonMap Ontology","lang":"en","_id":"569172ffb7cea413588f96ef"}]},{"uri":"http://taxref.mnhn.fr/lod/taxref-ld","nsp":"http://taxref.mnhn.fr/lod/","prefix":"taxre-ld","titles":[{"value":"TAXREF-LD Ontology","lang":"en","_id":"63171127b813c51c1e077157"}]},{"uri":"https://w3id.org/timebank","nsp":"https://w3id.org/timebank#","prefix":"tb","titles":[{"value":"Timebank Ontology","lang":"en","_id":"5e988ba37172d55b4fddfe1c"}]},{"uri":"https://www.w3.org/2019/wot/td","nsp":"https://www.w3.org/2019/wot/td#","prefix":"td","titles":[{"value":"Thing Description Ontology","lang":"en","_id":"5ed4d2bec7d84a2a049e4236"}]},{"uri":"https://w3id.org/todo/tododfa","nsp":"https://w3id.org/todo/tododfa#","prefix":"tddfa","titles":[{"value":"TODODFA: Frame-Action Module for Task-Oriented Dialogue management Ontology (TODO)","lang":"en","_id":"61a4d530bf34bcf5590f03d7"}]},{"uri":"https://w3id.org/todo/tododial","nsp":"https://w3id.org/todo/tododial#","prefix":"tddial","titles":[{"value":"TODODial: Dialogue Module for Task-Oriented Dialogue management Ontology (TODO)","lang":"en","_id":"61a3d620bf34bcf5590f011c"}]},{"uri":"https://w3id.org/todo/tododm","nsp":"https://w3id.org/todo/tododm#","prefix":"tddm","titles":[{"value":"TODODM: Dialogue Management Module for Task-Oriented Dialogue management Ontology (TODO)","lang":"en","_id":"61a4d1bebf34bcf5590f039e"}]},{"uri":"https://w3id.org/todo/tododom","nsp":"https://w3id.org/todo/tododom#","prefix":"tddom","titles":[{"value":"TODODom: Domain Module for Task-Oriented Dialogue management Ontology (TODO)","lang":"en","_id":"61a2b4a6dd8a986a3bc45a62"}]},{"uri":"https://w3id.org/todo/tododt","nsp":"https://w3id.org/todo/tododt#","prefix":"tddt","titles":[{"value":"TODODT: Dialogue Tracing Module for Task-Oriented Dialogue management Ontology (TODO)","lang":"en","_id":"61a4d4abbf34bcf5590f03d0"}]},{"uri":"https://w3id.org/todo/tododw","nsp":"https://w3id.org/todo/tododw#","prefix":"tddw","titles":[{"value":"TODODW: World Module for Task-Oriented Dialogue management Ontology (TODO)","lang":"en","_id":"61a4d3c9bf34bcf5590f03c8"}]},{"nsp":"http://www.w3.org/2006/time-entry#","prefix":"te","uri":"http://www.w3.org/2006/time-entry","titles":[{"value":"Time Entry","lang":"en","_id":"5697b642ff8848f96bd12af5"}]},{"nsp":"http://linkedscience.org/teach/ns#","prefix":"teach","uri":"http://linkedscience.org/teach/ns#","titles":[{"value":"Teaching Core Vocabulary Specification","lang":"en","_id":"58f9d4ae6961d74e135adbe2"}]},{"nsp":"http://www.w3.org/2006/03/test-description#","prefix":"test","uri":"http://www.w3.org/2006/03/test-description","titles":[{"value":"Test Metadata","lang":"en","_id":"586ba1cc7e341093492c4741"}]},{"uri":"https://privatealpha.com/ontology/transformation/1#","nsp":"https://privatealpha.com/ontology/transformation/1#","prefix":"tfo","titles":[{"value":"Transformation Functions Ontology","lang":"en","_id":"5eb43ca654a440f80a33027c"}]},{"nsp":"http://purl.org/theatre#","prefix":"theatre","uri":"http://purl.org/theatre#","titles":[{"value":"Theatre Ontology","lang":"en","_id":"57f681fb812207ab03623440"}]},{"nsp":"http://resource.geosciml.org/ontology/timescale/thors#","prefix":"thors","uri":"http://resource.geosciml.org/ontology/timescale/thors","titles":[{"value":"The Temporal Ordinal Reference Systems","lang":"en","_id":"598add7888adb933350f5bc4"}]},{"nsp":"http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl#","prefix":"ti","uri":"http://www.ontologydesignpatterns.org/cp/owl/timeinterval.owl","titles":[{"value":"The Time Interval Pattern","lang":"en","_id":"569ccffeff8848f96bd16d17"}]},{"uri":"https://w3id.org/tree","nsp":"https://w3id.org/tree#","prefix":"tiles","titles":[{"value":"TREE Ontology","lang":"en","_id":"63174cadb813c51c1e07741f"}]},{"nsp":"http://www.w3.org/2006/time#","prefix":"time","uri":"http://www.w3.org/2006/time","titles":[{"value":"Time Ontology","lang":"en","_id":"598c0ea188adb93335127354"}]},{"nsp":"http://purl.org/tio/ns#","prefix":"tio","uri":"http://purl.org/tio/ns#","titles":[{"value":"The Tickets Ontology","lang":"en","_id":"59dcda262febc4a21c31617c"}]},{"nsp":"http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl","prefix":"tis","uri":"http://www.ontologydesignpatterns.org/cp/owl/timeindexedsituation.owl","titles":[{"value":"Time Indexed Situation","lang":"en","_id":"569cd01dff8848f96bd16d21"}]},{"nsp":"http://observedchange.com/tisc/ns#","prefix":"tisc","uri":"http://www.observedchange.com/tisc/ns#","titles":[{"value":"Open Time and Space Core Vocabulary","lang":"en","_id":"55bca8777459b3975b63caa8"}]},{"nsp":"http://purl.org/NET/c4dm/timeline.owl#","prefix":"tl","uri":"http://purl.org/NET/c4dm/timeline.owl","titles":[{"value":"The Timeline Ontology","lang":"en","_id":"586b9f487e341093492c4720"}]},{"nsp":"http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal#","prefix":"tm","uri":"http://def.seegrid.csiro.au/isotc211/iso19108/2002/temporal","titles":[{"value":"A vocabulary for temporal objects in Geographic Information","lang":"en","_id":"59dcdf6f2febc4a21c316714"}]},{"nsp":"http://www.w3.org/2001/sw/hcls/ns/transmed/","prefix":"tmo","uri":"http://www.w3.org/2001/sw/hcls/ns/transmed/","titles":[{"value":"Translational Medicine Ontology","lang":"en","_id":"57f74b8b812207ab0362dd0c"}]},{"uri":"http://purl.org/toco/","nsp":"http://purl.org/toco/","prefix":"toco","titles":[{"value":"Toucan Ontology","lang":"en","_id":"5d11bcf4d3a37d851dfc47f7"}]},{"uri":"https://w3id.org/todo","nsp":"https://w3id.org/todo#","prefix":"todo","titles":[{"value":"TODO: Task-Oriented Dialogue management Ontology","lang":"en","_id":"61a4d015bf34bcf5590f038c"}]},{"nsp":"http://data.ign.fr/def/topo#","prefix":"topo","uri":"http://data.ign.fr/def/topo","titles":[{"value":"Ontologie des \xe9l\xe9ments du territoire et de ses infrastructures de l\'IGN","lang":"fr","_id":"58ec8846abe2639e2c3bd870"},{"value":"An ontology for describing territory elements an infrastructure at French Mapping Agency.","lang":"en","_id":"58ec8846abe2639e2c3bd86f"}]},{"nsp":"http://tour-pedia.org/download/tp.owl#","prefix":"tp","uri":"http://tour-pedia.org/download/tp.owl","titles":[{"value":"Tourpedia Ontology","lang":"en","_id":"5992066e605c58c744d4fea0"}]},{"nsp":"http://www.sensormeasurement.appspot.com/ont/transport/traffic#","prefix":"traffic","uri":"http://www.sensormeasurement.appspot.com/ont/transport/traffic","titles":[{"value":"Road Traffic Management","lang":"en","_id":"5783c5a60183b1e80fc88296"}]},{"nsp":"http://contextus.net/ontology/ontomedia/ext/common/trait#","prefix":"trait","uri":"http://contextus.net/ontology/ontomedia/ext/common/trait#","titles":[{"value":"OntoMedia Trait Representation","lang":"en","_id":"57f609ac812207ab0361ce3a"}]},{"nsp":"http://vocab.org/transit/terms/","prefix":"transit","uri":"http://vocab.org/transit/terms/","titles":[{"value":"TRANSIT","lang":"en","_id":"5b3a04d96c71ef466168a4f8"}]},{"nsp":"http://linkeddata.finki.ukim.mk/lod/ontology/tao#","prefix":"trao","uri":"http://linkeddata.finki.ukim.mk/lod/ontology/tao#","titles":[{"value":"Transport Administration Ontology","lang":"en","_id":"57d27a5da3a9d3a63d7e647f"}]},{"nsp":"http://rdfs.org/sioc/types#","prefix":"tsioc","uri":"http://rdfs.org/sioc/types#","titles":[{"value":"SIOC Types Ontology Module","lang":"en","_id":"578d00ed8c6f955d29c02b7e"}]},{"nsp":"http://purl.org/net/tsn#","prefix":"tsn","uri":"http://purl.org/net/tsn#","titles":[{"value":"Territorial Statistical Nomenclature Ontology","lang":"en","_id":"5a328179ece6c50213e94130"}]},{"nsp":"http://purl.org/net/tsnchange#","prefix":"tsnc","uri":"http://purl.org/net/tsnchange#","titles":[{"value":"Territorial Statistical Nomenclature Change Ontology","lang":"en","_id":"5a3284e9ece6c50213e94506"}]},{"nsp":"http://idi.fundacionctic.org/cruzar/turismo#","prefix":"turismo","uri":"http://idi.fundacionctic.org/cruzar/turismo","titles":[{"value":"Ontolog\xeda de Turismo para el Ayuntamiento de Zaragoza","lang":"es","_id":"568a5da14ee7f7176ff10f1a"},{"value":"Ontology of Tourist for Saragossa town hall.","lang":"en","_id":"568a5da14ee7f7176ff10f19"}]},{"nsp":"http://www.essepuntato.it/2012/04/tvc/","prefix":"tvc","uri":"http://www.essepuntato.it/2012/04/tvc","titles":[{"value":"The Time-indexed Value in Context","lang":"en","_id":"569cc885ff8848f96bd16c61"}]},{"nsp":"http://lod.taxonconcept.org/ontology/txn.owl#","prefix":"txn","uri":"http://lod.taxonconcept.org/ontology/txn.owl","titles":[{"value":"TaxonConcept Ontology","lang":"en","_id":"6317121cb813c51c1e07715d"}]},{"nsp":"http://www.w3.org/2006/timezone#","prefix":"tzont","uri":"http://www.w3.org/2006/timezone","titles":[{"value":"Time Zone Ontology","lang":"en","_id":"578369fc0183b1e80fc875d7"}]},{"nsp":"http://purl.org/olia/ubyCat.owl#","prefix":"uby","uri":"http://purl.org/olia/ubyCat.owl","titles":[{"value":"ubyCat.owl","lang":"en","_id":"5610edb3bbf00b4b0783ceb9"}]},{"nsp":"http://purl.org/uco/ns#","prefix":"uco","uri":"http://purl.org/uco/ns#","titles":[{"value":"Used Cars Ontology","lang":"en","_id":"56ae4d8398f0192c57ea0268"}]},{"nsp":"http://purl.oclc.org/NET/muo/ucum/","prefix":"ucum","uri":"http://purl.oclc.org/NET/muo/ucum/","titles":[{"value":"Units of measurement ontology","lang":"en","_id":"57b7130ea3a9d3a63d7709f2"}]},{"nsp":"http://www.w3.org/ns/ui#","prefix":"ui","uri":"http://www.w3.org/ns/ui","titles":[{"value":"A user interface ontology","lang":"en","_id":"5ff6f98961a499a258e9ac45"}]},{"uri":"http://www.w3id.org/urban-iot/core","nsp":"http://www.w3id.org/urban-iot/core#","prefix":"uiot","titles":[{"value":"Urban IoT Ontologies - Core Module","lang":"en","_id":"5fc762711e22675e2a3b3231"},{"value":"Ontologie per gli Apparati IoT Urbani - Modulo Core","lang":"it","_id":"5fc762711e22675e2a3b3230"}]},{"uri":"http://www.w3id.org/urban-iot/electric","nsp":"http://www.w3id.org/urban-iot/electric#","prefix":"uiote","titles":[{"value":"Ontologie per gli Apparati IoT Urbani - Modulo Electric Mobility","lang":"it","_id":"5fae610e9ba0235c2e0f2192"},{"value":"Urban IoT Ontologies - Electric Mobility Module","lang":"en","_id":"5fae610e9ba0235c2e0f2191"}]},{"uri":"http://www.w3id.org/urban-iot/sharing","nsp":"http://www.w3id.org/urban-iot/sharing#","prefix":"uiots","titles":[{"value":"Ontologie per gli Apparati IoT Urbani - Modulo Sharing Mobility","lang":"it","_id":"5fb39488b79f57e927b87705"},{"value":"Urban IoT Ontologies - Sharing Mobility Module","lang":"en","_id":"5fb39488b79f57e927b87704"}]},{"nsp":"http://umbel.org/umbel#","prefix":"umbel","uri":"http://umbel.org/umbel","titles":[{"value":"Upper Mapping and Binding Exchange Layer","lang":"en","_id":"5f2bcd63f1a48001181ad3e5"}]},{"nsp":"http://purl.org/umu/uneskos#","prefix":"uneskos","uri":"http://purl.org/umu/uneskos","titles":[{"value":"UNESKOS Vocabulary","lang":"en","_id":"5610f0b4bbf00b4b0783cece"}]},{"nsp":"http://purl.uniprot.org/core/","prefix":"uniprot","uri":"http://purl.uniprot.org/core/","titles":[{"value":"Uniprot Core Ontology","lang":"en","_id":"578367430183b1e80fc874bf"}]},{"nsp":"http://uri4uri.net/vocab#","prefix":"uri4uri","uri":"http://uri4uri.net/vocab","titles":[{"value":"URI Vocabulary","lang":"en","_id":"578364fa0183b1e80fc873ec"}]},{"uri":"https://w3id.org/usability","nsp":"https://w3id.org/usability#","prefix":"usability","titles":[{"value":"Usability","lang":"en","_id":"5cee546f29b3ea805fb470fc"},{"value":"\u0423\u0434\u043E\u0431\u0441\u0442\u0432\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F","lang":"ru","_id":"5cee546f29b3ea805fb470fb"}]},{"nsp":"http://code-research.eu/ontology/visual-analytics#","prefix":"va","uri":"http://code-research.eu/ontology/visual-analytics","titles":[{"value":"The Visual Analytics Vocabulary","lang":"en","_id":"578d04a68c6f955d29c02c36"}]},{"nsp":"http://www.linkedmodel.org/schema/vaem#","prefix":"vaem","uri":"http://www.linkedmodel.org/schema/vaem","titles":[{"value":"Vocabulary for Attaching Essential Metadata","lang":"en","_id":"591c84cc6eb19eef1936dbb8"}]},{"nsp":"http://www.essepuntato.it/2013/10/vagueness/","prefix":"vag","uri":"http://www.essepuntato.it/2013/10/vagueness","titles":[{"value":"The Vagueness Ontology","lang":"en","_id":"57f608c4812207ab0361cd6f"}]},{"nsp":"http://purl.org/vocab/vann/","prefix":"vann","uri":"http://purl.org/vocab/vann/","titles":[{"value":"VANN: A vocabulary for annotating vocabulary descriptions","lang":"en","_id":"584fb3598a0d14e34d5f69fb"}]},{"uri":"http://www.w3.org/ns/lemon/vartrans","nsp":"http://www.w3.org/ns/lemon/vartrans#","prefix":"vartrans","titles":[{"value":"Lexicon Model for Ontologies - Vartrans","lang":"en","_id":"60d06e73bbbd68b91c5f024f"}]},{"nsp":"http://www.w3.org/2006/vcard/ns#","prefix":"vcard","uri":"http://www.w3.org/2006/vcard/ns","titles":[{"value":"An Ontology for vCards","lang":"en","_id":"577f5d8e0183b1e80fc720b2"}]},{"nsp":"http://data.lirmm.fr/ontologies/vdpp#","prefix":"vdpp","uri":"http://data.lirmm.fr/ontologies/vdpp","titles":[{"value":"Vocabulary for Dataset Publication Projects","lang":"en","_id":"557f47ef1d5237e823d24ef6"}]},{"nsp":"http://linkeddata.finki.ukim.mk/lod/ontology/veo#","prefix":"veo","uri":"http://linkeddata.finki.ukim.mk/lod/ontology/veo#","titles":[{"value":"Vehicle Emissions Ontology","lang":"en","_id":"57d28866a3a9d3a63d7e6aed"}]},{"nsp":"http://purl.org/net/VideoGameOntology#","prefix":"vgo","uri":"http://purl.org/net/VideoGameOntology","titles":[{"value":"The Video Game Ontology","lang":"en","_id":"586a4b537e341093492b8c01"}]},{"nsp":"http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine#","prefix":"vin","uri":"http://www.w3.org/TR/2003/PR-owl-guide-20031209/wine","titles":[{"value":"Wine Ontology","lang":"en","_id":"568be88c4ee7f7176ff1250f"}]},{"uri":"http://w3id.org/vir#","nsp":"http://w3id.org/vir#","prefix":"vir","titles":[{"value":"VIR - Visual Representation ontology","lang":"en","_id":"5cee5930086e18b660657b58"}]},{"nsp":"http://vivoweb.org/ontology/core#","prefix":"vivo","uri":"http://vivoweb.org/ontology/core","titles":[{"value":"VIVO Core Ontology","lang":"en","_id":"58e63a03f6baaa6b1ab42a4b"}]},{"nsp":"http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0#","prefix":"vmm","uri":"http://spi-fm.uca.es/spdef/models/genericTools/vmm/1.0","titles":[{"value":"Visual Modeling tool Model","lang":"en","_id":"55d73529e4ac2b1c4c5a5281"}]},{"nsp":"http://purl.org/vocommons/voaf#","prefix":"voaf","uri":"http://purl.org/vocommons/voaf","titles":[{"value":"Vocabulary of a Friend","lang":"en","_id":"577f5d160183b1e80fc72088"}]},{"nsp":"http://voag.linkedmodel.org/voag#","prefix":"voag","uri":"http://voag.linkedmodel.org/schema/voag","titles":[{"value":"Vocabulary Of Attribution and Governance","lang":"en","_id":"5feb4051ba82ec865987975e"}]},{"nsp":"http://w3id.org/rsp/vocals#","prefix":"vocals","uri":"http://w3id.org/rsp/vocals#","titles":[{"value":"VoCaLS: A Vocabulary and Catalog for Linked Streams","lang":"en","_id":"5ae77bd03b60c4c82ec0ef08"},{"value":"VoCaLS: ontologie de representation de donn\xe9es et metadonn\xe9es de streams","lang":"fr","_id":"5ae77bd03b60c4c82ec0ef07"}]},{"nsp":"http://rdfs.org/ns/void#","prefix":"void","uri":"http://vocab.deri.ie/void","titles":[{"value":"Vocabulary of Interlinked Datasets","lang":"en","_id":"58e63961f6baaa6b1ab42998"}]},{"uri":"http://purl.org/query/voidext","nsp":"http://purl.org/query/voidext#","prefix":"voidext","titles":[{"value":"Extended Vocabulary of Interlinked Datasets (VoIDext)","lang":"en","_id":"5ddcda497ec5516d2b0ae026"}]},{"nsp":"http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl","prefix":"voidwh","uri":"http://www.ics.forth.gr/isl/VoIDWarehouse/VoID_Extension_Schema.owl","titles":[{"value":"Void Warehouse Ontology","lang":"en","_id":"5696a42dff8848f96bd11d54"}]},{"nsp":"http://simile.mit.edu/2003/10/ontologies/vraCore3#","prefix":"vra","uri":"http://simile.mit.edu/2003/10/ontologies/vraCore3#","titles":[{"value":"RDFS Ontology for VRA","lang":"en","_id":"568a52b14ee7f7176ff10e94"}]},{"nsp":"http://purl.org/voc/vrank#","prefix":"vrank","uri":"http://vocab.sti2.at/vrank","titles":[{"value":"Vocabulary for Ranking","lang":"en","_id":"586a47fc7e341093492b8804"}]},{"nsp":"http://www.w3.org/2003/06/sw-vocab-status/ns#","prefix":"vs","uri":"http://www.w3.org/2003/06/sw-vocab-status/ns","titles":[{"value":"SemWeb Vocab Status ontology","lang":"en","_id":"55d72d4ce4ac2b1c4c5a513c"}]},{"nsp":"http://purl.org/vsearch/","prefix":"vsearch","uri":"http://purl.org/vsearch/","titles":[{"value":"vSearch Vocabulary","lang":"en","_id":"5a2515123d405e60384eb2bc"}]},{"nsp":"http://purl.org/vso/ns#","prefix":"vso","uri":"http://purl.org/vso/ns","titles":[{"value":"Vehicle Sales Ontology","lang":"en","_id":"59dcdf972febc4a21c316731"}]},{"nsp":"http://purl.org/vvo/ns#","prefix":"vvo","uri":"http://purl.org/vvo/ns#","titles":[{"value":"Volkswagen Vehicles Ontology","lang":"en","_id":"59a697e77845e44d19bf9b45"}]},{"nsp":"https://www.w3.org/ns/ssn/","prefix":"w3c-ssn","uri":"https://www.w3.org/ns/ssn","titles":[{"value":"Semantic Sensor Network Ontology","lang":"en","_id":"58481b778a0d14e34d5eb3bd"}]},{"nsp":"http://purl.org/wai#","prefix":"wai","uri":"http://purl.org/wai#","titles":[{"value":"Roles and Profiles Ontology","lang":"en","_id":"568bea2b4ee7f7176ff1253e"}]},{"nsp":"http://www.w3.org/2007/05/powder-s#","prefix":"wdrs","uri":"http://www.w3.org/2007/05/powder-s","titles":[{"value":"Protocol for Web Description Resources","lang":"en","_id":"59dce0912febc4a21c3168b0"}]},{"nsp":"http://purl.org/net/wf-invocation#","prefix":"wf-invoc","uri":"http://purl.org/net/wf-invocation","titles":[{"value":"Workflow Invocation Ontology","lang":"en","_id":"586a48517e341093492b887c"}]},{"nsp":"http://purl.org/wf4ever/wfdesc#","prefix":"wfdesc","uri":"http://purl.org/wf4ever/wfdesc","titles":[{"value":"The Wfdesc ontology","lang":"en","_id":"56c599af2ba77c902f475671"}]},{"nsp":"http://purl.org/net/wf-motifs#","prefix":"wfm","uri":"http://purl.org/net/wf-motifs","titles":[{"value":"The Workflow Motif Ontology","lang":"en","_id":"5696a478ff8848f96bd11d58"}]},{"nsp":"http://purl.org/wf4ever/wfprov#","prefix":"wfprov","uri":"http://purl.org/wf4ever/wfprov","titles":[{"value":"The Wfprov Ontology","lang":"en","_id":"57ad898db00b4b1452a8896f"}]},{"nsp":"http://vocab.org/whisky/terms/","prefix":"whisky","uri":"http://vocab.org/whisky/terms","titles":[{"value":"Whisky Ontology","lang":"en","_id":"576a432e4a732637163164cc"}]},{"nsp":"http://www.kanzaki.com/ns/whois#","prefix":"whois","uri":"http://www.kanzaki.com/ns/whois","titles":[{"value":"Who\'s who description vocabulary","lang":"en","_id":"57ad888bb00b4b1452a888db"}]},{"nsp":"http://purl.org/ontology/wi/core#","prefix":"wi","uri":"http://purl.org/ontology/wi/core#","titles":[{"value":"The Weighted Interests Vocabulary","lang":"en","_id":"599d8f6ddaf8c9570d02ba2f"}]},{"uri":"http://wikiba.se/ontology","nsp":"http://wikiba.se/ontology#","prefix":"wikibase","titles":[{"value":"Wikibase system ontology","lang":"en","_id":"61acb6907fca4e68358b44c6"}]},{"nsp":"http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0#","prefix":"wikim","uri":"http://spi-fm.uca.es/spdef/models/genericTools/wikim/1.0","titles":[{"value":"WIKI tool Model","lang":"en","_id":"586a45de7e341093492b84fc"}]},{"nsp":"http://www.wsmo.org/ns/wsmo-lite#","prefix":"wl","uri":"http://www.wsmo.org/ns/wsmo-lite#","titles":[{"value":"WSMO-Lite Ontology","lang":"en","_id":"586a4be87e341093492b8c8a"}]},{"nsp":"http://purl.org/ontology/wo/","prefix":"wlo","uri":"http://purl.org/ontology/wo/","titles":[{"value":"BBC Wildlife Ontology","lang":"en","_id":"586a489d7e341093492b88e4"}]},{"nsp":"http://purl.org/ontology/wo/core#","prefix":"wo","uri":"http://purl.org/ontology/wo/core#","titles":[{"value":"Weighting Ontology","lang":"en","_id":"59dcdfcc2febc4a21c31675e"}]},{"nsp":"http://xmlns.com/wot/0.1/","prefix":"wot","uri":"http://xmlns.com/wot/0.1/","titles":[{"value":"Web Of Trust","lang":"en","_id":"63248491f0004aba7af3f839"}]},{"uri":"https://www.w3.org/2019/wot/security#","nsp":"https://www.w3.org/2019/wot/security#","prefix":"wotsec","titles":[{"value":"Security mechanisms for the Web of Things","lang":"en","_id":"5ed4d5efc7d84a2a049e4244"}]},{"nsp":"http://purl.org/xapi/ontology#","prefix":"xapi","uri":"http://purl.org/xapi/ontology#","titles":[{"value":"xAPI Controlled Vocabulary Ontology","lang":"en","_id":"6324846bf0004aba7af3f834"}]},{"nsp":"https://w3id.org/vocab/xbrll#","prefix":"xbrll","uri":"https://w3id.org/vocab/xbrll","titles":[{"value":"A lightweight XBRL vocabulary","lang":"en","_id":"63171240b813c51c1e077165"}]},{"nsp":"http://www.w3.org/1999/xhtml/vocab#","prefix":"xhv","uri":"http://www.w3.org/1999/xhtml/vocab","titles":[{"value":"XHTML Vocabulary","lang":"en","_id":"632483b7f0004aba7af3f817"}]},{"nsp":"http://rdf-vocabulary.ddialliance.org/xkos#","prefix":"xkos","uri":"http://rdf-vocabulary.ddialliance.org/xkos","titles":[{"value":"XKOS","lang":"en","_id":"61a3d84ebf34bcf5590f0137"}]},{"nsp":"http://www.w3.org/2001/XMLSchema#","prefix":"xsd","uri":"http://www.w3.org/2001/XMLSchema","titles":[{"value":"XML Schema","lang":"en","_id":"632cac1bc4f7e5f619d44eed"}]},{"uri":"https://yogaontology.org/ontology/","nsp":"https://yogaontology.org/ontology/","prefix":"yoga","titles":[{"value":"Yoga Ontology","lang":"en","_id":"5f1557107d492f6c11bd06a2"}]},{"nsp":"http://zbw.eu/namespaces/zbw-extensions/","prefix":"zbwext","uri":"http://zbw.eu/namespaces/zbw-extensions","titles":[{"value":"ZBW Extensions","lang":"en","_id":"63248698f0004aba7af3f85b"}]}]}');



var $gCJkd = parcelRequire("gCJkd");
var $bebb5f3cb64a9781$exports = {};
!function(t, e) {
    $bebb5f3cb64a9781$exports = e();
}($bebb5f3cb64a9781$exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});


var $216b618b1b33e0d2$exports = {};
!function(t, s) {
    $216b618b1b33e0d2$exports = s();
}($216b618b1b33e0d2$exports, function() {
    "use strict";
    var t, s, n = 1e3, i = 6e4, e = 36e5, r = 864e5, o = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, u = 31536e6, d = 2628e6, a = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, h = {
        years: u,
        months: d,
        days: r,
        hours: e,
        minutes: i,
        seconds: n,
        milliseconds: 1,
        weeks: 6048e5
    }, c = function(t) {
        return t instanceof g;
    }, f = function(t, s, n) {
        return new g(t, n, s.$l);
    }, m = function(t) {
        return s.p(t) + "s";
    }, l = function(t) {
        return t < 0;
    }, $ = function(t) {
        return l(t) ? Math.ceil(t) : Math.floor(t);
    }, y = function(t) {
        return Math.abs(t);
    }, v = function(t, s) {
        return t ? l(t) ? {
            negative: !0,
            format: "" + y(t) + s
        } : {
            negative: !1,
            format: "" + t + s
        } : {
            negative: !1,
            format: ""
        };
    }, g = function() {
        function l(t, s, n) {
            var i = this;
            if (this.$d = {}, this.$l = n, void 0 === t && (this.$ms = 0, this.parseFromMilliseconds()), s) return f(t * h[m(s)], this);
            if ("number" == typeof t) return this.$ms = t, this.parseFromMilliseconds(), this;
            if ("object" == typeof t) return Object.keys(t).forEach(function(s) {
                i.$d[m(s)] = t[s];
            }), this.calMilliseconds(), this;
            if ("string" == typeof t) {
                var e = t.match(a);
                if (e) {
                    var r = e.slice(2).map(function(t) {
                        return null != t ? Number(t) : 0;
                    });
                    return this.$d.years = r[0], this.$d.months = r[1], this.$d.weeks = r[2], this.$d.days = r[3], this.$d.hours = r[4], this.$d.minutes = r[5], this.$d.seconds = r[6], this.calMilliseconds(), this;
                }
            }
            return this;
        }
        var y = l.prototype;
        return y.calMilliseconds = function() {
            var t = this;
            this.$ms = Object.keys(this.$d).reduce(function(s, n) {
                return s + (t.$d[n] || 0) * h[n];
            }, 0);
        }, y.parseFromMilliseconds = function() {
            var t = this.$ms;
            this.$d.years = $(t / u), t %= u, this.$d.months = $(t / d), t %= d, this.$d.days = $(t / r), t %= r, this.$d.hours = $(t / e), t %= e, this.$d.minutes = $(t / i), t %= i, this.$d.seconds = $(t / n), t %= n, this.$d.milliseconds = t;
        }, y.toISOString = function() {
            var t = v(this.$d.years, "Y"), s = v(this.$d.months, "M"), n = +this.$d.days || 0;
            this.$d.weeks && (n += 7 * this.$d.weeks);
            var i = v(n, "D"), e = v(this.$d.hours, "H"), r = v(this.$d.minutes, "M"), o = this.$d.seconds || 0;
            this.$d.milliseconds && (o += this.$d.milliseconds / 1e3, o = Math.round(1e3 * o) / 1e3);
            var u = v(o, "S"), d = t.negative || s.negative || i.negative || e.negative || r.negative || u.negative, a = e.format || r.format || u.format ? "T" : "", h = (d ? "-" : "") + "P" + t.format + s.format + i.format + a + e.format + r.format + u.format;
            return "P" === h || "-P" === h ? "P0D" : h;
        }, y.toJSON = function() {
            return this.toISOString();
        }, y.format = function(t) {
            var n = t || "YYYY-MM-DDTHH:mm:ss", i = {
                Y: this.$d.years,
                YY: s.s(this.$d.years, 2, "0"),
                YYYY: s.s(this.$d.years, 4, "0"),
                M: this.$d.months,
                MM: s.s(this.$d.months, 2, "0"),
                D: this.$d.days,
                DD: s.s(this.$d.days, 2, "0"),
                H: this.$d.hours,
                HH: s.s(this.$d.hours, 2, "0"),
                m: this.$d.minutes,
                mm: s.s(this.$d.minutes, 2, "0"),
                s: this.$d.seconds,
                ss: s.s(this.$d.seconds, 2, "0"),
                SSS: s.s(this.$d.milliseconds, 3, "0")
            };
            return n.replace(o, function(t, s) {
                return s || String(i[t]);
            });
        }, y.as = function(t) {
            return this.$ms / h[m(t)];
        }, y.get = function(t) {
            var s = this.$ms, n = m(t);
            return "milliseconds" === n ? s %= 1e3 : s = "weeks" === n ? $(s / h[n]) : this.$d[n], s || 0;
        }, y.add = function(t, s, n) {
            var i;
            return i = s ? t * h[m(s)] : c(t) ? t.$ms : f(t, this).$ms, f(this.$ms + i * (n ? -1 : 1), this);
        }, y.subtract = function(t, s) {
            return this.add(t, s, !0);
        }, y.locale = function(t) {
            var s = this.clone();
            return s.$l = t, s;
        }, y.clone = function() {
            return f(this.$ms, this);
        }, y.humanize = function(s) {
            return t().add(this.$ms, "ms").locale(this.$l).fromNow(!s);
        }, y.valueOf = function() {
            return this.asMilliseconds();
        }, y.milliseconds = function() {
            return this.get("milliseconds");
        }, y.asMilliseconds = function() {
            return this.as("milliseconds");
        }, y.seconds = function() {
            return this.get("seconds");
        }, y.asSeconds = function() {
            return this.as("seconds");
        }, y.minutes = function() {
            return this.get("minutes");
        }, y.asMinutes = function() {
            return this.as("minutes");
        }, y.hours = function() {
            return this.get("hours");
        }, y.asHours = function() {
            return this.as("hours");
        }, y.days = function() {
            return this.get("days");
        }, y.asDays = function() {
            return this.as("days");
        }, y.weeks = function() {
            return this.get("weeks");
        }, y.asWeeks = function() {
            return this.as("weeks");
        }, y.months = function() {
            return this.get("months");
        }, y.asMonths = function() {
            return this.as("months");
        }, y.years = function() {
            return this.get("years");
        }, y.asYears = function() {
            return this.as("years");
        }, l;
    }(), p = function(t, s, n) {
        return t.add(s.years() * n, "y").add(s.months() * n, "M").add(s.days() * n, "d").add(s.hours() * n, "h").add(s.minutes() * n, "m").add(s.seconds() * n, "s").add(s.milliseconds() * n, "ms");
    };
    return function(n, i, e) {
        t = e, s = e().$utils(), e.duration = function(t, s) {
            var n = e.locale();
            return f(t, {
                $l: n
            }, s);
        }, e.isDuration = c;
        var r = i.prototype.add, o = i.prototype.subtract;
        i.prototype.add = function(t, s) {
            return c(t) ? p(this, t, 1) : r.bind(this)(t, s);
        }, i.prototype.subtract = function(t, s) {
            return c(t) ? p(this, t, -1) : o.bind(this)(t, s);
        };
    };
});


var $fcd8f60277f7fcfe$exports = {};
!function(e, t) {
    $fcd8f60277f7fcfe$exports = t();
}($fcd8f60277f7fcfe$exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, o = {}, s = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var a = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, f = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], h = function(e) {
        var t = o[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, u = function(e, t) {
        var n, r = o.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, d = {
        A: [
            i,
            function(e) {
                this.afternoon = u(e, !1);
            }
        ],
        a: [
            i,
            function(e) {
                this.afternoon = u(e, !0);
            }
        ],
        S: [
            /\d/,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            n,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            r,
            a("seconds")
        ],
        ss: [
            r,
            a("seconds")
        ],
        m: [
            r,
            a("minutes")
        ],
        mm: [
            r,
            a("minutes")
        ],
        H: [
            r,
            a("hours")
        ],
        h: [
            r,
            a("hours")
        ],
        HH: [
            r,
            a("hours")
        ],
        hh: [
            r,
            a("hours")
        ],
        D: [
            r,
            a("day")
        ],
        DD: [
            n,
            a("day")
        ],
        Do: [
            i,
            function(e) {
                var t = o.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        M: [
            r,
            a("month")
        ],
        MM: [
            n,
            a("month")
        ],
        MMM: [
            i,
            function(e) {
                var t = h("months"), n = (h("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            i,
            function(e) {
                var t = h("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            a("year")
        ],
        YY: [
            n,
            function(e) {
                this.year = s(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            a("year")
        ],
        Z: f,
        ZZ: f
    };
    function c(n) {
        var r, i;
        r = n, i = o && o.formats;
        for(var s = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = s.length, f = 0; f < a; f += 1){
            var h = s[f], u = d[h], c = u && u[0], l = u && u[1];
            s[f] = l ? {
                regex: c,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = s[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var o = i.regex, f = i.parser, h = e.slice(r), u = o.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (s = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, s = e.args;
            this.$u = r;
            var a = s[1];
            if ("string" == typeof a) {
                var f = !0 === s[2], h = !0 === s[3], u = f || h, d = s[2];
                h && (d = s[2]), o = this.$locale(), !f && d && (o = n.Ls[d]), this.$d = function(e, t, n) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var r = c(t)(e), i = r.year, o = r.month, s = r.day, a = r.hours, f = r.minutes, h = r.seconds, u = r.milliseconds, d = r.zone, l = new Date, m = s || (i || o ? 1 : l.getDate()), M = i || l.getFullYear(), Y = 0;
                        i && !o || (Y = o > 0 ? o - 1 : l.getMonth());
                        var p = a || 0, v = f || 0, D = h || 0, g = u || 0;
                        return d ? new Date(Date.UTC(M, Y, m, p, v, D, g + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(M, Y, m, p, v, D, g)) : new Date(M, Y, m, p, v, D, g);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), o = {};
            } else if (a instanceof Array) for(var l = a.length, m = 1; m <= l; m += 1){
                s[1] = a[m - 1];
                var M = n.apply(this, s);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === l && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});


var $087cd9ad5d526439$exports = {};
!function(r, e) {
    $087cd9ad5d526439$exports = e();
}($087cd9ad5d526439$exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});


var $beebfe2969c5cd79$exports = {};
!function(t, i) {
    $beebfe2969c5cd79$exports = i();
}($beebfe2969c5cd79$exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($216b618b1b33e0d2$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($087cd9ad5d526439$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($fcd8f60277f7fcfe$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($beebfe2969c5cd79$exports))));
function $bf3112b0c9ec2889$export$899158ea22bb4609(value) {
    try {
        return value != undefined && value.length > 0 && $gCJkd.isLiteral($6f0137736d5eb798$export$f9c0624c04b6af9f(value));
    } catch (e) {
        return false;
    }
}
function $bf3112b0c9ec2889$export$db39d8c4990bbf58(value) {
    try {
        return value != undefined && value.length > 0 && $gCJkd.isNamedNode($6f0137736d5eb798$export$fe4bf738d66b6b12(value));
    } catch (e) {
        return false;
    }
}
function $bf3112b0c9ec2889$export$4d9e7a1c098df5e2(value) {
    try {
        return $bf3112b0c9ec2889$export$db39d8c4990bbf58(value) || $bf3112b0c9ec2889$export$899158ea22bb4609(value);
    } catch (e) {
        return false;
    }
}
function $bf3112b0c9ec2889$export$8b802d7927293173(value) {
    try {
        return $bf3112b0c9ec2889$export$899158ea22bb4609(value) && (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(value).isValid();
    } catch (e) {
        return false;
    }
}
function $bf3112b0c9ec2889$export$757a451204d10ad6(value) {
    try {
        return $bf3112b0c9ec2889$export$899158ea22bb4609(value) && (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(value).isValid() && (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).isDuration((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(value));
    } catch (e) {
        return false;
    }
}
function $bf3112b0c9ec2889$export$a287f47fed4544b8(value) {
    try {
        return $bf3112b0c9ec2889$export$899158ea22bb4609(value) && Number.isInteger(Number.parseInt(value));
    } catch (e) {
        return false;
    }
}
function $bf3112b0c9ec2889$export$1fd13a8724cd7091(value) {
    try {
        return $bf3112b0c9ec2889$export$a287f47fed4544b8(value) && Number.parseInt(value) > 0;
    } catch (e) {
        return false;
    }
}




class $1dd5f29d6665a182$export$f91d67ddd1e8123a {
    constructor(state, message){
        this.state = state;
        this.message = message;
    }
    static valid() {
        return new $1dd5f29d6665a182$export$f91d67ddd1e8123a("Valid", "");
    }
    static invalid(message) {
        return new $1dd5f29d6665a182$export$f91d67ddd1e8123a("Invalid", message);
    }
    static none() {
        return new $1dd5f29d6665a182$export$f91d67ddd1e8123a("None", "");
    }
    static isValid(fieldState) {
        return fieldState.state.localeCompare("Valid") == 0;
    }
    static isInvalid(fieldState) {
        return fieldState.state.localeCompare("Invalid") == 0;
    }
    static isNone(fieldState) {
        return fieldState.state.localeCompare("None") == 0;
    }
}
class $1dd5f29d6665a182$export$dfb94dd8dafa72d2 {
    constructor(config = {
        recommended: false,
        categoryTitle: "",
        legend: "",
        idPrefix: "id",
        minArity: 0,
        maxArity: Infinity,
        computable: false,
        fields: [],
        subCategories: []
    }){
        this.recommended = config.recommended;
        this.categoryTitle = config.categoryTitle;
        this.legend = config.legend;
        this.idPrefix = config.idPrefix;
        this.minArity = config.minArity;
        this.maxArity = config.maxArity;
        this.computable = config.computable;
        this.fields = [];
        config.fields.forEach((fieldConfig)=>{
            this.addNewField(fieldConfig);
        });
        this.subCategories = [];
        if (config.subCategories != undefined) this.subCategories = config.subCategories;
    }
    addNewField(fieldConfig) {
        fieldConfig.parentCategory = this;
        this.fields.push(fieldConfig);
    }
}
class $1dd5f29d6665a182$export$4bcd3e7a61028e57 {
    constructor(config){
        this.placeholder = config.placeholder;
        this.dataValidationFunction = (inputVal)=>{
            var result = $1dd5f29d6665a182$export$f91d67ddd1e8123a.none();
            try {
                result = config.dataValidationFunction(inputVal);
            } catch (e) {
                throw e;
            }
            return result;
        };
        this.dataCreationFunction = (inputVal)=>{
            if (this.dataValidationFunction(inputVal)) return config.dataCreationFunction(inputVal);
        };
        if (config.dataExtractionFunction != undefined) this.dataExtractionFunction = ()=>{
            try {
                return config.dataExtractionFunction();
            } catch (e) {
                throw e;
            }
        };
        if (config.dataSuggestionFunction != undefined) this.dataSuggestionFunction = (inputVal)=>{
            try {
                return config.dataSuggestionFunction(inputVal);
            } catch (e) {
                throw e;
            }
        };
        if (config.dataLoadFunction != undefined) this.dataLoadFunction = (store)=>{
            try {
                return [
                    ...new Set(config.dataLoadFunction(store))
                ];
            } catch (e) {
                throw e;
            }
        };
        this.parentCategory = config.parentCategory;
        this.defaultValue = config.defaultValue;
        this.advice = config.advice;
        if (config.bootstrapFieldColWidth != undefined) this.bootstrapFieldColWidth = config.bootstrapFieldColWidth;
        else config.bootstrapFieldColWidth = [
            12
        ];
        this.fieldPattern = config.fieldPattern;
    }
}








var $a05dabb57d62d821$exports = {};
!function(t, e) {
    $a05dabb57d62d821$exports = e();
}($a05dabb57d62d821$exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n = this.utcOffset(), i = this.toDate(), a = i.toLocaleString("en-US", {
                timeZone: t
            }), u = Math.round((i - new Date(a)) / 1e3 / 60), f = o(a, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(i.getTimezoneOffset() / 15) - u, !0);
            if (e) {
                var s = f.utcOffset();
                f = f.add(n - s, "minute");
            }
            return f.$x.$timezone = t, f;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});


(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($216b618b1b33e0d2$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($087cd9ad5d526439$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($fcd8f60277f7fcfe$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($beebfe2969c5cd79$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports))).extend((0, (/*@__PURE__*/$parcel$interopDefault($a05dabb57d62d821$exports))));
const $1aafcae990228224$var$vocabularySuggestions = $161b08292747466e$exports.vocabulary.map((vocabularyObject)=>{
    let result = {
        value: vocabularyObject.nsp,
        label: ""
    };
    if (vocabularyObject.titles.length > 0) {
        let foundVocabularyTitle = vocabularyObject.titles.find((titleObject)=>titleObject.lang == "en");
        if (foundVocabularyTitle !== undefined) result.label = foundVocabularyTitle.value;
        else result.label = vocabularyObject.titles[0].value;
    }
    result.label += " [" + vocabularyObject.prefix + "]";
    return result;
});
const $1aafcae990228224$var$datePatterns = [
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "YYYY MM DD",
    "DD MM YYYY",
    "YYYY/MM/DD",
    "DD/MM/YYYY"
];
const $1aafcae990228224$var$dateTimePatterns = [
    "YYYY-MM-DD'T'HH:mm:ss",
    "DD-MM-YYYY'T'HH:mm:ss",
    "YYYY-MM-DD HH:mm:ss",
    "DD-MM-YYYY HH:mm:ss",
    "YYYY-MM-DD'T'HH:mm:ssXXX",
    "DD-MM-YYYY'T'HH:mm:ssXXX",
    "YYYY-MM-DD HH:mm:ssXXX",
    "DD-MM-YYYY HH:mm:ssXXX",
    "YYYY-MM-DD'T'HH:mm:ss.SSS'Z'",
    "DD-MM-YYYY'T'HH:mm:ss.SSS'Z'",
    "YYYY-MM-DD HH:mm:ss.SSS'Z'",
    "DD-MM-YYYY HH:mm:ss.SSS'Z'",
    "YYYY-MM-DD'T'HH:mm:ss.SSSXXX",
    "DD-MM-YYYY'T'HH:mm:ss.SSSXXX",
    "YYYY-MM-DD HH:mm:ss.SSSXXX",
    "DD-MM-YYYY HH:mm:ss.SSSXXX"
];
const $1aafcae990228224$var$gYearMonthPatterns = [
    "YYYY-MM",
    "MM-YYYY",
    "YYYY MM",
    "MM YYYY",
    "YYYY/MM",
    "MM/YYYY"
];
const $1aafcae990228224$export$4cacfc59564927f2 = [
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: true,
        categoryTitle: "Title",
        legend: "Short title for the knowledge base and its content.",
        idPrefix: "title",
        minArity: 1,
        maxArity: Infinity,
        computable: false,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Short title for the knowledge base",
                    "Language tag (optional)"
                ],
                defaultValue: [
                    "",
                    "en"
                ],
                bootstrapFieldColWidth: [
                    8,
                    2
                ],
                dataCreationFunction: (valuesArray)=>{
                    let inputVal = valuesArray[0];
                    let inputTag = valuesArray[1];
                    if (inputTag.length > 0) return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("title"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, inputTag))
                    ];
                    else return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("title"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                    ];
                },
                dataValidationFunction: (valuesArray)=>{
                    let inputVal = valuesArray[0];
                    let inputTag = valuesArray[1];
                    let testResult = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) && ($bf3112b0c9ec2889$export$899158ea22bb4609(inputTag) || inputTag.length == 0);
                    if (testResult) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The short title must be non-empty");
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("title"), null).map((statement)=>statement.object).map((object)=>{
                            if ($gCJkd.isLiteral(object)) {
                                if (object.language !== undefined) return [
                                    object.value,
                                    object.language
                                ];
                                else return [
                                    object.value,
                                    ""
                                ];
                            } else return [
                                object.value,
                                ""
                            ]; // Should never happen
                        });
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("title"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: true,
        categoryTitle: "Description",
        legend: "Long description of the knowledge base and its content.",
        idPrefix: "description",
        minArity: 1,
        maxArity: Infinity,
        computable: false,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Long description of the knowledge base",
                    "Language tag (optional)"
                ],
                defaultValue: [
                    "",
                    "en"
                ],
                bootstrapFieldColWidth: [
                    8,
                    2
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    let inputLang = valuesArray[1];
                    if (inputLang.length > 0) return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("description"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, inputLang))
                    ];
                    else return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("description"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                    ];
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    let inputTag = valuesArray[1];
                    let result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) && ($bf3112b0c9ec2889$export$899158ea22bb4609(inputTag) || inputTag.length == 0);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The description must be non-empty");
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("description"), null).map((statement)=>statement.object).map((object)=>{
                            if ($gCJkd.isLiteral(object)) {
                                if (object.language !== undefined) return [
                                    object.value,
                                    object.language
                                ];
                                else return [
                                    object.value,
                                    ""
                                ];
                            } else return [
                                object.value,
                                ""
                            ]; // Should never happen
                        });
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("description"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: false,
        categoryTitle: "Endpoint URL",
        legend: "URL of the SPARQL endpoint.",
        idPrefix: "endpoint",
        minArity: 1,
        maxArity: Infinity,
        computable: false,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Endpoint's URL"
                ],
                defaultValue: [
                    ""
                ],
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    let result = $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The URL must direct to a working SPARQL endpoint for the extraction functions to work.");
                },
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("sparqlEndpoint"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal)),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$2e35bef72d35ec05), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("DataService")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$2e35bef72d35ec05), $5605c1058d66d37f$export$7be7716cc4115fc5("endpointURL"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal)),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$2e35bef72d35ec05), $5605c1058d66d37f$export$7be7716cc4115fc5("servesDataset"), (0, $5605c1058d66d37f$export$19285ac0211cbcbc))
                    ];
                },
                dataLoadFunction (store) {
                    let inputVals = store.statementsMatching(null, $5605c1058d66d37f$export$1cd1943b3a73bbe8("sparqlEndpoint"), null).map((statement)=>[
                            statement.object.value
                        ]);
                    inputVals = inputVals.concat(store.statementsMatching(null, $5605c1058d66d37f$export$7be7716cc4115fc5("endpointURL"), null).map((statement)=>[
                            statement.object.value
                        ]));
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$7be7716cc4115fc5("endpointURL"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: true,
        categoryTitle: "Actors",
        legend: "Represents the different actors involved in the life cycle of the dataset.",
        idPrefix: "actor",
        minArity: 0,
        maxArity: 0,
        computable: false,
        fields: [],
        subCategories: [
            new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
                recommended: true,
                categoryTitle: "Creator",
                legend: "Represents the different actors involved in the creation of the dataset.",
                idPrefix: "creator",
                minArity: 1,
                maxArity: Infinity,
                computable: false,
                fields: [
                    new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                        placeholder: [
                            "Creator's name or URI"
                        ],
                        defaultValue: [
                            ""
                        ],
                        dataValidationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            let result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) || $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal);
                            if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                            else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The creator must be non-empty");
                        },
                        dataCreationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            if ($bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal)) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("creator"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal))
                            ];
                            if ($bf3112b0c9ec2889$export$899158ea22bb4609(inputVal)) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("creator"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                            ];
                            return null;
                        },
                        dataLoadFunction (store) {
                            let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                            let inputVals = [];
                            datasets.forEach((dataset)=>{
                                let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("creator"), null).map((statement)=>[
                                        statement.object.value
                                    ]);
                                inputVals = inputVals.concat(datasetInputVals);
                            });
                            return inputVals;
                        },
                        fieldPattern: [
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("creator"), null)
                            ]
                        ]
                    })
                ]
            }),
            new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
                recommended: true,
                categoryTitle: "Contributor",
                legend: "Represents the different actors involved in the modification of the dataset.",
                idPrefix: "contributor",
                minArity: 1,
                maxArity: Infinity,
                computable: false,
                fields: [
                    new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                        placeholder: [
                            "Contributor's name or URI"
                        ],
                        defaultValue: [
                            ""
                        ],
                        dataValidationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            let result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) || $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal);
                            if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                            else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The contributor must be non-empty");
                        },
                        dataCreationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            if ($bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal)) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("contributor"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal))
                            ];
                            if ($bf3112b0c9ec2889$export$899158ea22bb4609(inputVal)) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("contributor"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                            ];
                            return null;
                        },
                        dataLoadFunction (store) {
                            let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                            let inputVals = [];
                            datasets.forEach((dataset)=>{
                                let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("contributor"), null).map((statement)=>[
                                        statement.object.value
                                    ]);
                                inputVals = inputVals.concat(datasetInputVals);
                            });
                            return inputVals;
                        },
                        fieldPattern: [
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("contributor"), null)
                            ]
                        ]
                    })
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: true,
        categoryTitle: "Dates",
        legend: "Dates relative to the life cycle of the knowledge base. ",
        idPrefix: "date",
        minArity: 0,
        maxArity: 0,
        computable: false,
        fields: [],
        subCategories: [
            new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
                recommended: true,
                categoryTitle: "Publication date",
                legend: "Publication date of the knowledge base. A standard <a href='https://en.wikipedia.org/wiki/ISO_8601'>ISO 8601</a> date is expected, e.g YYYY-MM, YYYY-MM-DD, YYYY-MM-DDThh:mm:ss, etc. ",
                idPrefix: "publication",
                minArity: 1,
                maxArity: 1,
                computable: false,
                fields: [
                    new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                        placeholder: [
                            "Publication date of the knowledge base."
                        ],
                        defaultValue: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))().format("YYYY-MM-DD")
                        ],
                        dataCreationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$datePatterns, true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("issued"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("date")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$dateTimePatterns).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("issued"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("dateTime")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$gYearMonthPatterns, true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("issued"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("gYearMonth")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, "YYYY", true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("issued"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("gYear")))
                            ];
                            else return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("issued"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                            ];
                        },
                        dataValidationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) && $bf3112b0c9ec2889$export$8b802d7927293173(inputVal);
                            if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                            else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The date must be non-empty and in the correct format");
                        },
                        dataLoadFunction (store) {
                            let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                            let inputVals = [];
                            datasets.forEach((dataset)=>{
                                let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("issued"), null).map((statement)=>[
                                        statement.object.value
                                    ]);
                                inputVals = inputVals.concat(datasetInputVals);
                            });
                            return inputVals;
                        },
                        fieldPattern: [
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("issued"), null)
                            ]
                        ]
                    })
                ]
            }),
            new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
                recommended: false,
                categoryTitle: "Modification date",
                legend: "Date of the last modification of the knowledge base. A standard <a href='https://en.wikipedia.org/wiki/ISO_8601'>ISO 8601</a> date is expected, e.g YYYY-MM, YYYY-MM-DD, YYYY-MM-DDThh:mm:ss, etc. ",
                idPrefix: "modification",
                minArity: 1,
                maxArity: 1,
                computable: false,
                fields: [
                    new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                        placeholder: [
                            "Last modification date of the knowledge base."
                        ],
                        defaultValue: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))().format("YYYY-MM-DD")
                        ],
                        dataCreationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$datePatterns, true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("modified"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("date")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$dateTimePatterns).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("modified"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("dateTime")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$gYearMonthPatterns, true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("modified"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("gYearMonth")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, "YYYY", true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("modified"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("gYear")))
                            ];
                            else return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("modified"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                            ];
                        },
                        dataValidationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) && $bf3112b0c9ec2889$export$8b802d7927293173(inputVal);
                            if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                            else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The date must be non-empty and in the correct format");
                        },
                        dataLoadFunction (store) {
                            let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                            let inputVals = [];
                            datasets.forEach((dataset)=>{
                                let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("modified"), null).map((statement)=>[
                                        statement.object.value
                                    ]);
                                inputVals = inputVals.concat(datasetInputVals);
                            });
                            return inputVals;
                        },
                        fieldPattern: [
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("modified"), null)
                            ]
                        ]
                    })
                ]
            }),
            new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
                recommended: false,
                categoryTitle: "Creation date",
                legend: "Date of the creation knowledge base. A standard <a href='https://en.wikipedia.org/wiki/ISO_8601'>ISO 8601</a> date is expected, e.g YYYY-MM, YYYY-MM-DD, YYYY-MM-DDThh:mm:ss, etc. ",
                idPrefix: "creation",
                minArity: 1,
                maxArity: 1,
                computable: false,
                fields: [
                    new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                        placeholder: [
                            "creation date of the knowledge base."
                        ],
                        defaultValue: [
                            (0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))().format("YYYY-MM-DD")
                        ],
                        dataCreationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$datePatterns, true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("created"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("date")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$dateTimePatterns).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("created"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("dateTime")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, $1aafcae990228224$var$gYearMonthPatterns, true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("created"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("gYearMonth")))
                            ];
                            else if ((0, (/*@__PURE__*/$parcel$interopDefault($bebb5f3cb64a9781$exports)))(inputVal, "YYYY", true).isValid()) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("created"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal, undefined, $5605c1058d66d37f$export$65dca9476b1ea120("gYear")))
                            ];
                            else return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("created"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                            ];
                        },
                        dataValidationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) && $bf3112b0c9ec2889$export$8b802d7927293173(inputVal);
                            if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                            else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The date must be non-empty and in the correct format");
                        },
                        dataLoadFunction (store) {
                            let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                            let inputVals = [];
                            datasets.forEach((dataset)=>{
                                let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("created"), null).map((statement)=>[
                                        statement.object.value
                                    ]);
                                inputVals = inputVals.concat(datasetInputVals);
                            });
                            return inputVals;
                        },
                        fieldPattern: [
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("created"), null)
                            ]
                        ]
                    })
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: false,
        categoryTitle: "Keywords",
        legend: "Keywords describing the content of the knowledge base.",
        idPrefix: "keyword",
        minArity: 0,
        maxArity: Infinity,
        computable: false,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Keywords used to describe the knowledge base"
                ],
                defaultValue: [
                    "keyword"
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    if ($bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal)) return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$7be7716cc4115fc5("theme"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal))
                    ];
                    if ($bf3112b0c9ec2889$export$899158ea22bb4609(inputVal)) return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$7be7716cc4115fc5("keyword"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                    ];
                    return null;
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) || $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The keyword must be non empty");
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$7be7716cc4115fc5("keyword"), null).concat(store.statementsMatching(dataset, $5605c1058d66d37f$export$7be7716cc4115fc5("theme"), null)).map((statement)=>[
                                statement.object.value
                            ]);
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$7be7716cc4115fc5("theme"), null)
                    ],
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$7be7716cc4115fc5("keyword"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: true,
        categoryTitle: "Version",
        legend: "Current version number of the knowledge base.",
        idPrefix: "version",
        minArity: 1,
        maxArity: 1,
        computable: false,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Current version of the knowledge base"
                ],
                defaultValue: [
                    "1.0"
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$7be7716cc4115fc5("version"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                    ];
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The version must be non empty");
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$7be7716cc4115fc5("version"), null).map((statement)=>[
                                statement.object.value
                            ]);
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$7be7716cc4115fc5("version"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: true,
        categoryTitle: "License",
        legend: "License of the knowledge base. Use an URI to refer to a license, or a literal to describe the license.",
        idPrefix: "license",
        minArity: 1,
        maxArity: Infinity,
        computable: false,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Reference to the license of the knowledge base"
                ],
                defaultValue: [
                    ""
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    if ($bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal)) return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("license"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal)),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$969f4e5258613036("LicenseDocument"))
                    ];
                    if ($bf3112b0c9ec2889$export$899158ea22bb4609(inputVal)) return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("license"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                    ];
                    return null;
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) || $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The license must be non empty");
                },
                dataSuggestionFunction: (inputVal)=>{
                    return [
                        $161b08292747466e$exports.license
                    ];
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("license"), null).map((statement)=>[
                                statement.object.value
                            ]);
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$7be7716cc4115fc5("license"), $6f0137736d5eb798$export$3a9d57cefcd2c285("license")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("license"), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$969f4e5258613036("LicenseDocument"))
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: false,
        categoryTitle: "Rights",
        legend: "Metadata related to the rights of the dataset",
        idPrefix: "rights",
        minArity: 0,
        maxArity: 0,
        computable: false,
        fields: [],
        subCategories: [
            new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
                recommended: false,
                categoryTitle: "Rights holder",
                legend: "A person or organization owning or managing rights over the dataset",
                idPrefix: "properties",
                minArity: 1,
                maxArity: Infinity,
                computable: true,
                fields: [
                    new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                        placeholder: [
                            "Person or organization"
                        ],
                        defaultValue: [
                            ""
                        ],
                        dataCreationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            if ($bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal)) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("rightsHolder"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal))
                            ];
                            else return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("rightsHolder"), $6f0137736d5eb798$export$c8ec6e1ec9fefcb0(inputVal))
                            ];
                        },
                        dataValidationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            const result = $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal) || $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal);
                            if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                            else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The rights holder must be represented as an URI or a literal.");
                        },
                        dataSuggestionFunction: ()=>{
                            let creatorArray = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).listNodesStore((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("creator"), null);
                            let contributorArray = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).listNodesStore((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("contributor"), null);
                            let result = [
                                creatorArray.map((rightsHolderNode)=>{
                                    return {
                                        value: rightsHolderNode.value,
                                        label: ""
                                    };
                                }).concat(contributorArray.map((rightsHolderNode)=>{
                                    return {
                                        value: rightsHolderNode.value,
                                        label: ""
                                    };
                                }))
                            ];
                            return result;
                        },
                        dataLoadFunction (store) {
                            let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                            let inputVals = [];
                            datasets.forEach((dataset)=>{
                                let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("rightsHolder"), null).map((statement)=>[
                                        statement.object.value
                                    ]);
                                inputVals = inputVals.concat(datasetInputVals);
                            });
                            return inputVals;
                        },
                        fieldPattern: [
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("rightsHolder"), null)
                            ]
                        ]
                    })
                ]
            }),
            new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
                recommended: false,
                categoryTitle: "Access rights",
                legend: "Access rights of the dataset",
                idPrefix: "access_rights",
                minArity: 1,
                maxArity: 1,
                computable: false,
                fields: [
                    new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                        placeholder: [
                            "Access rights"
                        ],
                        defaultValue: [
                            ""
                        ],
                        dataCreationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            if ($bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal)) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("accessRights"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal))
                            ];
                            else return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("accessRights"), $6f0137736d5eb798$export$c8ec6e1ec9fefcb0(inputVal))
                            ];
                        },
                        dataValidationFunction (valuesArray) {
                            let inputVal = valuesArray[0];
                            const result = $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal) || $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal);
                            if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                            else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The access rights must be represented as an URI or a literal.");
                        },
                        dataSuggestionFunction: (inputVal)=>{
                            return [
                                [
                                    {
                                        value: "http://publications.europa.eu/resource/authority/access-right/PUBLIC",
                                        label: "Public"
                                    },
                                    {
                                        value: "http://publications.europa.eu/resource/authority/access-right/RESTRICTED",
                                        label: "Restricted"
                                    },
                                    {
                                        value: "http://publications.europa.eu/resource/authority/access-right/NON_PUBLIC",
                                        label: "Non-public"
                                    }
                                ]
                            ];
                        },
                        dataLoadFunction (store) {
                            let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                            let inputVals = [];
                            datasets.forEach((dataset)=>{
                                let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("accessRights"), null).map((statement)=>[
                                        statement.object.value
                                    ]);
                                inputVals = inputVals.concat(datasetInputVals);
                            });
                            return inputVals;
                        },
                        fieldPattern: [
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("accessRights"), null)
                            ]
                        ]
                    })
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: false,
        categoryTitle: "URIs",
        legend: "Charateristics of the URIs from the dataset",
        idPrefix: "uris",
        minArity: 0,
        maxArity: 0,
        computable: false,
        fields: [],
        subCategories: [
            new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
                recommended: true,
                categoryTitle: "Namespace",
                legend: "Namespace of the URIs created for this dataset.",
                idPrefix: "title",
                minArity: 1,
                maxArity: 1,
                computable: false,
                fields: [
                    new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                        placeholder: [
                            "Namespace of the URIS",
                            "Preferred prefix for this namespace (optional)"
                        ],
                        defaultValue: [
                            "",
                            ""
                        ],
                        bootstrapFieldColWidth: [
                            7,
                            3
                        ],
                        dataCreationFunction: (valuesArray)=>{
                            let inputNs = valuesArray[0];
                            let inputPrefix = valuesArray[1];
                            if (inputPrefix !== undefined && inputPrefix.length > 0) return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("uriSpace"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputNs)),
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$fe4bf738d66b6b12(inputNs), $5605c1058d66d37f$export$486b38f1ab67447b("preferredNamespaceUri"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputNs)),
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$fe4bf738d66b6b12(inputNs), $5605c1058d66d37f$export$486b38f1ab67447b("preferredNamespacePrefix"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputNs))
                            ];
                            else return [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("uriSpace"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputNs)),
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$fe4bf738d66b6b12(inputNs), $5605c1058d66d37f$export$486b38f1ab67447b("preferredNamespaceUri"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputNs))
                            ];
                        },
                        dataValidationFunction: (valuesArray)=>{
                            let inputNs = valuesArray[0];
                            let inputPrefix = valuesArray[1];
                            let testResult = $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputNs) && (inputPrefix === undefined || inputPrefix !== undefined && ($bf3112b0c9ec2889$export$899158ea22bb4609(inputPrefix) || inputPrefix.length == 0));
                            if (testResult) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                            else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The namespace must be a valid URI and the prefix must be a literal. Given: " + inputNs + " and " + inputPrefix);
                        },
                        dataLoadFunction (store) {
                            let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                            let inputVals = [];
                            datasets.forEach((dataset)=>{
                                let inputNs = store.statementsMatching(dataset, $5605c1058d66d37f$export$1cd1943b3a73bbe8("uriSpace"), null).map((statement)=>statement.object.value);
                                inputVals = inputVals.concat(inputNs.map((ns)=>{
                                    let prefixes = store.statementsMatching($6f0137736d5eb798$export$fe4bf738d66b6b12(ns), $5605c1058d66d37f$export$486b38f1ab67447b("preferredNamespacePrefix"), null).map((statement)=>statement.object.value);
                                    if (prefixes.length == 0) return [
                                        ns,
                                        ""
                                    ];
                                    else return [
                                        ns,
                                        prefixes[0]
                                    ];
                                }));
                            });
                            return inputVals;
                        },
                        fieldPattern: [
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$1cd1943b3a73bbe8("uriSpace"), $6f0137736d5eb798$export$3a9d57cefcd2c285("ns")),
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("ns"), $5605c1058d66d37f$export$486b38f1ab67447b("preferredNamespaceUri"), null),
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("ns"), $5605c1058d66d37f$export$486b38f1ab67447b("preferredNamespacePrefix"), null)
                            ],
                            [
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("uriSpace"), $6f0137736d5eb798$export$3a9d57cefcd2c285("ns")),
                                $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("ns"), $5605c1058d66d37f$export$486b38f1ab67447b("preferredNamespaceUri"), null)
                            ]
                        ]
                    })
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: true,
        categoryTitle: "Vocabularies",
        legend: "URIs of the vocabularies used in the knowledge base.",
        idPrefix: "vocabulary",
        minArity: 0,
        maxArity: Infinity,
        computable: true,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Vocabularies used in the knowledge base"
                ],
                defaultValue: [
                    ""
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("vocabulary"), $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal))
                    ];
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The vocabulary must be an URI");
                },
                dataExtractionFunction: ()=>{
                    let endpointArray = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).listNodesStore((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("sparqlEndpoint"), null);
                    if (endpointArray.length == 0) throw new Error("No endpoint found.");
                    let promiseArray = [];
                    endpointArray.forEach((endpointNode)=>{
                        let endpointString = endpointNode.value;
                        endpointString = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).standardizeEndpointURL(endpointString);
                        promiseArray.push($35459c07cd7570af$export$39dfa61b343cea87(endpointString, 'SELECT DISTINCT ?ns WHERE { { SELECT DISTINCT ?elem { ?s ?elem ?o . } } BIND(IRI(REPLACE( str(?elem), "(#|/)[^#/]*$", "$1")) AS ?ns) . }'));
                        promiseArray.push($35459c07cd7570af$export$39dfa61b343cea87(endpointString, 'SELECT DISTINCT ?ns WHERE { { SELECT DISTINCT ?elem { ?s a ?elem . } } BIND(IRI(REPLACE( str(?elem), "(#|/)[^#/]*$", "$1")) AS ?ns) . }'));
                    });
                    return Promise.allSettled(promiseArray).then((rawBindingsArray)=>{
                        let bindingsArray = $35459c07cd7570af$export$4282b215e95fd9cb(rawBindingsArray);
                        let unifiedBindings = [];
                        bindingsArray.forEach((bindings)=>{
                            if (bindings != undefined) unifiedBindings = unifiedBindings.concat(bindings);
                        });
                        unifiedBindings = [
                            ...new Set(unifiedBindings)
                        ];
                        return unifiedBindings.map((binding)=>binding.ns.value);
                    });
                },
                dataSuggestionFunction: ()=>{
                    return [
                        $1aafcae990228224$var$vocabularySuggestions
                    ];
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$1cd1943b3a73bbe8("vocabulary"), null).map((statement)=>[
                                statement.object.value
                            ]);
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$1cd1943b3a73bbe8("vocabulary"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: true,
        categoryTitle: "Languages",
        legend: "Language tags used in the literals of the knowledge base. It is recommended to use the tags used in the language tagged literal, or to follow the <a href='https://www.rfc-editor.org/info/bcp47#section-2.2.9'>RDF1.1 standard</a>.",
        idPrefix: "language",
        minArity: 0,
        maxArity: Infinity,
        computable: true,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Language tags used in the literals of the knowledge base."
                ],
                defaultValue: [
                    ""
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$969f4e5258613036("language"), $6f0137736d5eb798$export$f9c0624c04b6af9f(inputVal))
                    ];
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The language must be non empty");
                },
                dataExtractionFunction: ()=>{
                    let endpointArray = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).listNodesStore((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("sparqlEndpoint"), null);
                    if (endpointArray.length == 0) throw new Error("No endpoint found.");
                    let promiseArray = [];
                    endpointArray.forEach((endpointNode)=>{
                        let endpointString = endpointNode.value;
                        endpointString = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).standardizeEndpointURL(endpointString);
                        promiseArray.push($35459c07cd7570af$export$39dfa61b343cea87(endpointString, 'SELECT DISTINCT (LANG(?o) AS ?tag) WHERE { { SELECT DISTINCT ?o { ?s ?p ?o. FILTER(ISLITERAL(?o)) FILTER((LANG(?o)) != "") } } } LIMIT 50'));
                    });
                    return Promise.allSettled(promiseArray).then((rawBindingsArray)=>{
                        let bindingsArray = $35459c07cd7570af$export$4282b215e95fd9cb(rawBindingsArray);
                        let unifiedBindings = [];
                        bindingsArray.forEach((bindings)=>{
                            if (bindings != undefined) unifiedBindings = unifiedBindings.concat(bindings);
                        });
                        unifiedBindings = [
                            ...new Set(unifiedBindings)
                        ];
                        return unifiedBindings.map((binding)=>binding.tag.value);
                    }).catch((error)=>{
                        console.error(error);
                        return [];
                    });
                },
                dataSuggestionFunction: (inputVal)=>{
                    return [
                        $161b08292747466e$exports.lang
                    ];
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$969f4e5258613036("language"), null).map((statement)=>[
                                statement.object.value
                            ]);
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$969f4e5258613036("language"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: false,
        categoryTitle: "Graph",
        legend: "Graphs present in the dataset",
        idPrefix: "graph",
        minArity: 0,
        maxArity: Infinity,
        computable: true,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Uri of the graph"
                ],
                defaultValue: [
                    ""
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    let graphNode = $6f0137736d5eb798$export$fe4bf738d66b6b12(inputVal);
                    return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$5b088def975a652b("namedGraph"), graphNode),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(graphNode, $5605c1058d66d37f$export$5b088def975a652b("name"), graphNode),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$5b088def975a652b("Dataset")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(graphNode, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$5b088def975a652b("NamedGraph")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$2e35bef72d35ec05), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("DataService")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$2e35bef72d35ec05), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$5b088def975a652b("Service")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$2e35bef72d35ec05), $5605c1058d66d37f$export$7be7716cc4115fc5("servesDataset"), (0, $5605c1058d66d37f$export$19285ac0211cbcbc)),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$2e35bef72d35ec05), $5605c1058d66d37f$export$5b088def975a652b("availableGraphs"), (0, $5605c1058d66d37f$export$19285ac0211cbcbc))
                    ];
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$db39d8c4990bbf58(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The name of the graph must be an URI");
                },
                dataExtractionFunction: ()=>{
                    let endpointArray = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).listNodesStore((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("sparqlEndpoint"), null);
                    if (endpointArray.length == 0) throw new Error("No endpoint found.");
                    let promiseArray = [];
                    endpointArray.forEach((endpointNode)=>{
                        let endpointString = endpointNode.value;
                        endpointString = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).standardizeEndpointURL(endpointString);
                        promiseArray.push($35459c07cd7570af$export$39dfa61b343cea87(endpointString, "SELECT DISTINCT ?graph WHERE { GRAPH ?graph { ?s ?p ?o . } }"));
                    });
                    return Promise.allSettled(promiseArray).then((rawBindingsArray)=>{
                        let bindingsArray = $35459c07cd7570af$export$4282b215e95fd9cb(rawBindingsArray);
                        let unifiedBindings = [];
                        bindingsArray.forEach((bindings)=>{
                            if (bindings != undefined) unifiedBindings = unifiedBindings.concat(bindings);
                        });
                        unifiedBindings = [
                            ...new Set(unifiedBindings)
                        ];
                        return unifiedBindings.map((binding)=>binding.graph.value);
                    }).catch((error)=>{
                        throw error;
                    });
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let graphNodes = store.statementsMatching(dataset, $5605c1058d66d37f$export$5b088def975a652b("namedGraph"), null).map((statement)=>statement.object);
                        let graphBlankNodes = [];
                        graphNodes.forEach((graphNode)=>{
                            if ($gCJkd.isBlankNode(graphNode)) graphBlankNodes.push(graphNode);
                            else if ($gCJkd.isNamedNode(graphNode)) inputVals.push([
                                graphNode.value
                            ]);
                        });
                        graphBlankNodes.forEach((graphBlankNode)=>{
                            let graphName = store.any(graphBlankNode, $5605c1058d66d37f$export$5b088def975a652b("name"), null);
                            if (graphName != undefined) inputVals.push([
                                graphName.value
                            ]);
                        });
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("dataset"), $5605c1058d66d37f$export$5b088def975a652b("namedGraph"), $6f0137736d5eb798$export$3a9d57cefcd2c285("graphNode")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("graphNode"), $5605c1058d66d37f$export$5b088def975a652b("name"), $6f0137736d5eb798$export$3a9d57cefcd2c285("graphNode")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("dataset"), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$5b088def975a652b("Dataset")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("graphNode"), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$5b088def975a652b("NamedGraph")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("service"), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("DataService")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("service"), $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$5b088def975a652b("Service")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("service"), $5605c1058d66d37f$export$7be7716cc4115fc5("servesDataset"), $6f0137736d5eb798$export$3a9d57cefcd2c285("dataset")),
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d($6f0137736d5eb798$export$3a9d57cefcd2c285("service"), $5605c1058d66d37f$export$5b088def975a652b("availableGraphs"), $6f0137736d5eb798$export$3a9d57cefcd2c285("dataset"))
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: false,
        categoryTitle: "Triples",
        legend: "Number of triples present in the dataset",
        idPrefix: "triples",
        minArity: 0,
        maxArity: 1,
        computable: true,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Number of triples"
                ],
                defaultValue: [
                    ""
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("triples"), $6f0137736d5eb798$export$c8ec6e1ec9fefcb0(inputVal, $5605c1058d66d37f$export$65dca9476b1ea120("integer")))
                    ];
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) && $bf3112b0c9ec2889$export$1fd13a8724cd7091(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The number of triples must be a positive integer number.");
                },
                dataExtractionFunction: ()=>{
                    let endpointArray = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).listNodesStore((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("sparqlEndpoint"), null);
                    if (endpointArray.length == 0) throw new Error("No endpoint found.");
                    let promiseArray = [];
                    endpointArray.forEach((endpointNode)=>{
                        let endpointString = endpointNode.value;
                        endpointString = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).standardizeEndpointURL(endpointString);
                        promiseArray.push($35459c07cd7570af$export$d37bf5547347f960(endpointString, "SELECT (count(*) AS ?count) { ?s ?p ?o }"));
                    });
                    return Promise.allSettled(promiseArray).then((rawBindingsArray)=>{
                        let bindingsArray = $35459c07cd7570af$export$4282b215e95fd9cb(rawBindingsArray);
                        let unifiedBindings = [];
                        bindingsArray.forEach((bindings)=>{
                            if (bindings != undefined) unifiedBindings = unifiedBindings.concat(bindings.results.bindings);
                        });
                        unifiedBindings = [
                            ...new Set(unifiedBindings)
                        ];
                        return unifiedBindings.map((binding)=>binding.count.value);
                    }).catch((error)=>{
                        console.error(error);
                        return [];
                    });
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$1cd1943b3a73bbe8("triples"), null).map((statement)=>[
                                statement.object.value
                            ]);
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$1cd1943b3a73bbe8("triples"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: false,
        categoryTitle: "Classes",
        legend: "Number of classes present in the dataset",
        idPrefix: "classes",
        minArity: 0,
        maxArity: 1,
        computable: true,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Number of classes"
                ],
                defaultValue: [
                    ""
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("classes"), $6f0137736d5eb798$export$c8ec6e1ec9fefcb0(inputVal, $5605c1058d66d37f$export$65dca9476b1ea120("integer")))
                    ];
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) && $bf3112b0c9ec2889$export$1fd13a8724cd7091(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The number of classes must be a positive integer number.");
                },
                dataExtractionFunction: ()=>{
                    let endpointArray = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).listNodesStore((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("sparqlEndpoint"), null);
                    if (endpointArray.length == 0) throw new Error("No endpoint found.");
                    let promiseArray = [];
                    endpointArray.forEach((endpointNode)=>{
                        let endpointString = endpointNode.value;
                        endpointString = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).standardizeEndpointURL(endpointString);
                        promiseArray.push($35459c07cd7570af$export$d37bf5547347f960(endpointString, "SELECT (COUNT(DISTINCT ?c) AS ?count) WHERE { { SELECT DISTINCT ?c { ?s a ?c . FILTER(isURI(?c)) } } }"));
                    });
                    return Promise.allSettled(promiseArray).then((rawBindingsArray)=>{
                        let bindingsArray = $35459c07cd7570af$export$4282b215e95fd9cb(rawBindingsArray);
                        let unifiedBindings = [];
                        bindingsArray.forEach((bindings)=>{
                            if (bindings != undefined) unifiedBindings = unifiedBindings.concat(bindings.results.bindings);
                        });
                        unifiedBindings = [
                            ...new Set(unifiedBindings)
                        ];
                        return unifiedBindings.map((binding)=>binding.count.value);
                    }).catch((error)=>{
                        console.error(error);
                        return [];
                    });
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$1cd1943b3a73bbe8("classes"), null).map((statement)=>[
                                statement.object.value
                            ]);
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$1cd1943b3a73bbe8("classes"), null)
                    ]
                ]
            })
        ]
    }),
    new (0, $1dd5f29d6665a182$export$dfb94dd8dafa72d2)({
        recommended: false,
        categoryTitle: "Properties",
        legend: "Number of properties present in the dataset",
        idPrefix: "properties",
        minArity: 0,
        maxArity: 1,
        computable: true,
        fields: [
            new (0, $1dd5f29d6665a182$export$4bcd3e7a61028e57)({
                placeholder: [
                    "Number of properties"
                ],
                defaultValue: [
                    ""
                ],
                dataCreationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    return [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("properties"), $6f0137736d5eb798$export$c8ec6e1ec9fefcb0(inputVal, $5605c1058d66d37f$export$65dca9476b1ea120("integer")))
                    ];
                },
                dataValidationFunction (valuesArray) {
                    let inputVal = valuesArray[0];
                    const result = $bf3112b0c9ec2889$export$899158ea22bb4609(inputVal) && $bf3112b0c9ec2889$export$1fd13a8724cd7091(inputVal);
                    if (result) return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).valid();
                    else return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).invalid("The number of properties must be a positive integer number.");
                },
                dataExtractionFunction: ()=>{
                    let endpointArray = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).listNodesStore((0, $5605c1058d66d37f$export$19285ac0211cbcbc), $5605c1058d66d37f$export$1cd1943b3a73bbe8("sparqlEndpoint"), null);
                    if (endpointArray.length == 0) throw new Error("No endpoint found.");
                    let promiseArray = [];
                    endpointArray.forEach((endpointNode)=>{
                        let endpointString = endpointNode.value;
                        endpointString = (0, $b324e0f8855d37bf$export$ceb8328249fa3d26).standardizeEndpointURL(endpointString);
                        promiseArray.push($35459c07cd7570af$export$d37bf5547347f960(endpointString, "SELECT (COUNT(DISTINCT ?p) AS ?count) WHERE { { SELECT DISTINCT ?p { ?s ?p ?o . FILTER(isURI(?p)) } } }"));
                    });
                    return Promise.allSettled(promiseArray).then((rawBindingsArray)=>{
                        let bindingsArray = $35459c07cd7570af$export$4282b215e95fd9cb(rawBindingsArray);
                        let unifiedBindings = [];
                        bindingsArray.forEach((bindings)=>{
                            if (bindings != undefined) unifiedBindings = unifiedBindings.concat(bindings.results.bindings);
                        });
                        unifiedBindings = [
                            ...new Set(unifiedBindings)
                        ];
                        return unifiedBindings.map((binding)=>binding.count.value);
                    }).catch((error)=>{
                        console.error(error);
                        return [];
                    });
                },
                dataLoadFunction (store) {
                    let datasets = store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).map((statement)=>statement.subject);
                    let inputVals = [];
                    datasets.forEach((dataset)=>{
                        let datasetInputVals = store.statementsMatching(dataset, $5605c1058d66d37f$export$1cd1943b3a73bbe8("properties"), null).map((statement)=>[
                                statement.object.value
                            ]);
                        inputVals = inputVals.concat(datasetInputVals);
                    });
                    return inputVals;
                },
                fieldPattern: [
                    [
                        $6f0137736d5eb798$export$8692ddd9f3fb5f5d(null, $5605c1058d66d37f$export$1cd1943b3a73bbe8("properties"), null)
                    ]
                ]
            })
        ]
    })
];





/**
 * Bootstrap 5 autocomplete
 */ // #region config
/**
 * @callback RenderCallback
 * @param {Object} item
 * @param {String} label
 * @param {Autocomplete} inst
 * @returns {string}
 */ /**
 * @callback ItemCallback
 * @param {Object} item
 * @param {Autocomplete} inst
 * @returns {void}
 */ /**
 * @callback ServerCallback
 * @param {Response} response
 * @param {Autocomplete} inst
 * @returns {Promise}
 */ /**
 * @callback FetchCallback
 * @param {Autocomplete} inst
 * @returns {void}
 */ /**
 * @typedef Config
 * @property {Boolean} showAllSuggestions Show all suggestions even if they don't match
 * @property {Number} suggestionsThreshold Number of chars required to show suggestions
 * @property {Number} maximumItems Maximum number of items to display
 * @property {Boolean} autoselectFirst Always select the first item
 * @property {Boolean} ignoreEnter Ignore enter if no items are selected (play nicely with autoselectFirst=0)
 * @property {Boolean} updateOnSelect Update input value on selection (doesn't play nice with autoselectFirst)
 * @property {Boolean} highlightTyped Highlight matched part of the label
 * @property {String} highlightClass Class added to the mark label
 * @property {Boolean} fullWidth Match the width on the input field
 * @property {Boolean} fixed Use fixed positioning (solve overflow issues)
 * @property {Boolean} fuzzy Fuzzy search
 * @property {Boolean} startsWith Must start with the string. Defaults to false (it matches any position).
 * @property {Boolean} fillIn Show fill in icon.
 * @property {Boolean} preventBrowserAutocomplete Additional measures to prevent browser autocomplete
 * @property {String} itemClass Applied to the dropdown item. Accepts space separated classes.
 * @property {Array} activeClasses By default: ["bg-primary", "text-white"]
 * @property {String} labelField Key for the label
 * @property {String} valueField Key for the value
 * @property {Array} searchFields Key for the search
 * @property {String} queryParam Key for the query parameter for server
 * @property {Array|Object} items An array of label/value objects or an object with key/values
 * @property {Function} source A function that provides the list of items
 * @property {Boolean} hiddenInput Create an hidden input which stores the valueField
 * @property {String} hiddenValue Populate the initial hidden value. Mostly useful with liveServer.
 * @property {String} clearControl Selector that will clear the input on click.
 * @property {String} datalist The id of the source datalist
 * @property {String} server Endpoint for data provider
 * @property {String} serverMethod HTTP request method for data provider, default is GET
 * @property {String|Object} serverParams Parameters to pass along to the server. You can specify a "related" key with the id of a related field.
 * @property {String} serverDataKey By default: data
 * @property {Object} fetchOptions Any other fetch options (https://developer.mozilla.org/en-US/docs/Web/API/fetch#syntax)
 * @property {Boolean} liveServer Should the endpoint be called each time on input
 * @property {Boolean} noCache Prevent caching by appending a timestamp
 * @property {Number} debounceTime Debounce time for live server
 * @property {String} notFoundMessage Display a no suggestions found message. Leave empty to disable
 * @property {RenderCallback} onRenderItem Callback function that returns the label
 * @property {ItemCallback} onSelectItem Callback function to call on selection
 * @property {ServerCallback} onServerResponse Callback function to process server response. Must return a Promise
 * @property {ItemCallback} onChange Callback function to call on change-event. Returns currently selected item if any
 * @property {FetchCallback} onBeforeFetch Callback function before fetch
 * @property {FetchCallback} onAfterFetch Callback function after fetch
 */ /**
 * @type {Config}
 */ const $7d043bb99bff1240$var$DEFAULTS = {
    showAllSuggestions: false,
    suggestionsThreshold: 1,
    maximumItems: 0,
    autoselectFirst: true,
    ignoreEnter: false,
    updateOnSelect: false,
    highlightTyped: false,
    highlightClass: "",
    fullWidth: false,
    fixed: false,
    fuzzy: false,
    startsWith: false,
    fillIn: false,
    preventBrowserAutocomplete: false,
    itemClass: "",
    activeClasses: [
        "bg-primary",
        "text-white"
    ],
    labelField: "label",
    valueField: "value",
    searchFields: [
        "label"
    ],
    queryParam: "query",
    items: [],
    source: null,
    hiddenInput: false,
    hiddenValue: "",
    clearControl: "",
    datalist: "",
    server: "",
    serverMethod: "GET",
    serverParams: {},
    serverDataKey: "data",
    fetchOptions: {},
    liveServer: false,
    noCache: true,
    debounceTime: 300,
    notFoundMessage: "",
    onRenderItem: (item, label, inst)=>{
        return label;
    },
    onSelectItem: (item, inst)=>{},
    onServerResponse: (response, inst)=>{
        return response.json();
    },
    onChange: (item, inst)=>{},
    onBeforeFetch: (inst)=>{},
    onAfterFetch: (inst)=>{}
};
// #endregion
// #region constants
const $7d043bb99bff1240$var$LOADING_CLASS = "is-loading";
const $7d043bb99bff1240$var$ACTIVE_CLASS = "is-active";
const $7d043bb99bff1240$var$SHOW_CLASS = "show";
const $7d043bb99bff1240$var$NEXT = "next";
const $7d043bb99bff1240$var$PREV = "prev";
const $7d043bb99bff1240$var$INSTANCE_MAP = new WeakMap();
let $7d043bb99bff1240$var$counter = 0;
let $7d043bb99bff1240$var$activeCounter = 0;
// #endregion
// #region functions
/**
 * @param {Function} func
 * @param {number} timeout
 * @returns {Function}
 */ function $7d043bb99bff1240$var$debounce(func, timeout = 300) {
    let timer;
    return (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>{
            //@ts-ignore
            func.apply(this, args);
        }, timeout);
    };
}
/**
 * @param {String} str
 * @returns {String}
 */ function $7d043bb99bff1240$var$removeDiacritics(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
/**
 * @param {String|Number} str
 * @returns {String}
 */ function $7d043bb99bff1240$var$normalize(str) {
    if (!str) return "";
    return $7d043bb99bff1240$var$removeDiacritics(str.toString()).toLowerCase();
}
/**
 * A simple fuzzy match algorithm that checks if chars are matched
 * in order in the target string
 *
 * @param {String} str
 * @param {String} lookup
 * @returns {Boolean}
 */ function $7d043bb99bff1240$var$fuzzyMatch(str, lookup) {
    if (str.indexOf(lookup) >= 0) return true;
    let pos = 0;
    for(let i = 0; i < lookup.length; i++){
        const c = lookup[i];
        if (c == " ") continue;
        pos = str.indexOf(c, pos) + 1;
        if (pos <= 0) return false;
    }
    return true;
}
/**
 * @param {HTMLElement} el
 * @param {HTMLElement} newEl
 * @returns {HTMLElement}
 */ function $7d043bb99bff1240$var$insertAfter(el, newEl) {
    return el.parentNode.insertBefore(newEl, el.nextSibling);
}
/**
 * @param {string} html
 * @returns {string}
 */ function $7d043bb99bff1240$var$decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}
/**
 * @param {HTMLElement} el
 * @param {Object} attrs
 */ function $7d043bb99bff1240$var$attrs(el, attrs) {
    for (const [k, v] of Object.entries(attrs))el.setAttribute(k, v);
}
/**
 * Add a zero width join between chars
 * @param {HTMLElement|Element} el
 */ function $7d043bb99bff1240$var$zwijit(el) {
    //@ts-ignore
    el.ariaLabel = el.innerText;
    //@ts-ignore
    el.innerHTML = el.innerText.split("").map((char)=>char + "&zwj;").join("");
}
function $7d043bb99bff1240$var$nested(str, obj = "window") {
    return str.split(".").reduce((r, p)=>r[p], obj);
}
// #endregion
class $7d043bb99bff1240$var$Autocomplete {
    /**
   * @param {HTMLInputElement} el
   * @param {Config|Object} config
   */ constructor(el, config = {}){
        if (!(el instanceof HTMLElement)) {
            console.error("Invalid element", el);
            return;
        }
        $7d043bb99bff1240$var$INSTANCE_MAP.set(el, this);
        $7d043bb99bff1240$var$counter++;
        $7d043bb99bff1240$var$activeCounter++;
        this._searchInput = el;
        this._configure(config);
        // Private vars
        this._preventInput = false;
        this._keyboardNavigation = false;
        this._searchFunc = $7d043bb99bff1240$var$debounce(()=>{
            this._loadFromServer(true);
        }, this._config.debounceTime);
        // Create html
        this._configureSearchInput();
        this._configureDropElement();
        if (this._config.fixed) {
            document.addEventListener("scroll", this, true);
            window.addEventListener("resize", this);
        }
        const clearControl = this._getClearControl();
        if (clearControl) clearControl.addEventListener("click", this);
        // Add listeners (remove then on dispose()). See handleEvent.
        [
            "focus",
            "change",
            "blur",
            "input",
            "keydown"
        ].forEach((type)=>{
            this._searchInput.addEventListener(type, this);
        });
        [
            "mousemove",
            "mouseleave"
        ].forEach((type)=>{
            this._dropElement.addEventListener(type, this);
        });
        this._fetchData();
    }
    // #region Core
    /**
   * Attach to all elements matched by the selector
   * @param {string} selector
   * @param {Config|Object} config
   */ static init(selector = "input.autocomplete", config = {}) {
        /**
     * @type {NodeListOf<HTMLInputElement>}
     */ const nodes = document.querySelectorAll(selector);
        nodes.forEach((el)=>{
            this.getOrCreateInstance(el, config);
        });
    }
    /**
   * @param {HTMLInputElement} el
   */ static getInstance(el) {
        return $7d043bb99bff1240$var$INSTANCE_MAP.has(el) ? $7d043bb99bff1240$var$INSTANCE_MAP.get(el) : null;
    }
    /**
   * @param {HTMLInputElement} el
   * @param {Object} config
   */ static getOrCreateInstance(el, config = {}) {
        return this.getInstance(el) || new this(el, config);
    }
    dispose() {
        $7d043bb99bff1240$var$activeCounter--;
        [
            "focus",
            "change",
            "blur",
            "input",
            "keydown"
        ].forEach((type)=>{
            this._searchInput.removeEventListener(type, this);
        });
        [
            "mousemove",
            "mouseleave"
        ].forEach((type)=>{
            this._dropElement.removeEventListener(type, this);
        });
        const clearControl = this._getClearControl();
        if (clearControl) clearControl.removeEventListener("click", this);
        // only remove if there are no more active elements
        if (this._config.fixed && $7d043bb99bff1240$var$activeCounter <= 0) {
            document.removeEventListener("scroll", this, true);
            window.removeEventListener("resize", this);
        }
        this._dropElement.parentElement.removeChild(this._dropElement);
        $7d043bb99bff1240$var$INSTANCE_MAP.delete(this._searchInput);
    }
    _getClearControl() {
        if (this._config.clearControl) return document.querySelector(this._config.clearControl);
    }
    /**
   * @link https://github.com/lifaon74/events-polyfill/issues/10
   * @link https://gist.github.com/WebReflection/ec9f6687842aa385477c4afca625bbf4#handling-events
   * @param {Event} event
   */ handleEvent = (event)=>{
        // debounce scroll and resize
        const debounced = [
            "scroll",
            "resize"
        ];
        if (debounced.includes(event.type)) {
            if (this._timer) window.cancelAnimationFrame(this._timer);
            this._timer = window.requestAnimationFrame(()=>{
                this[`on${event.type}`](event);
            });
        } else this[`on${event.type}`](event);
    };
    /**
   * @param {Config|Object} config
   */ _configure(config = {}) {
        this._config = Object.assign({}, $7d043bb99bff1240$var$DEFAULTS);
        // Handle options, using arguments first and data attr as override
        const o = {
            ...config,
            ...this._searchInput.dataset
        };
        // Allow 1/0, true/false as strings
        const parseBool = (value)=>[
                "true",
                "false",
                "1",
                "0",
                true,
                false
            ].includes(value) && !!JSON.parse(value);
        // Typecast provided options based on defaults types
        for (const [key, defaultValue] of Object.entries($7d043bb99bff1240$var$DEFAULTS)){
            // Check for undefined keys
            if (o[key] === void 0) continue;
            const value = o[key];
            switch(typeof defaultValue){
                case "number":
                    this._config[key] = parseInt(value);
                    break;
                case "boolean":
                    this._config[key] = parseBool(value);
                    break;
                case "string":
                    this._config[key] = value.toString();
                    break;
                case "object":
                    // Arrays have a type object in js
                    if (Array.isArray(defaultValue)) {
                        if (typeof value === "string") {
                            const separator = value.includes("|") ? "|" : ",";
                            this._config[key] = value.split(separator);
                        } else this._config[key] = value;
                    } else this._config[key] = typeof value === "string" ? JSON.parse(value) : value;
                    break;
                case "function":
                    this._config[key] = typeof value === "string" ? window[value] : value;
                    break;
                default:
                    this._config[key] = value;
                    break;
            }
        }
    }
    // #endregion
    // #region Html
    _configureSearchInput() {
        this._searchInput.autocomplete = "off";
        this._searchInput.spellcheck = false;
        // note: firefox doesn't support the properties so we use attributes
        // @link https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-autocomplete
        // @link https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-expanded
        // use the aria-expanded state on the element with role combobox to communicate that the list is displayed.
        $7d043bb99bff1240$var$attrs(this._searchInput, {
            "aria-autocomplete": "list",
            "aria-haspopup": "menu",
            "aria-expanded": "false",
            role: "combobox"
        });
        // Even with autocomplete "off" we can get suggestion from browser due to label
        if (this._searchInput.id && this._config.preventBrowserAutocomplete) {
            const label = document.querySelector(`[for="${this._searchInput.id}"]`);
            if (label) $7d043bb99bff1240$var$zwijit(label);
        }
        // Hidden input?
        this._hiddenInput = null;
        if (this._config.hiddenInput) {
            this._hiddenInput = document.createElement("input");
            this._hiddenInput.type = "hidden";
            this._hiddenInput.value = this._config.hiddenValue;
            this._hiddenInput.name = this._searchInput.name;
            this._searchInput.name = "_" + this._searchInput.name;
            $7d043bb99bff1240$var$insertAfter(this._searchInput, this._hiddenInput);
        }
    }
    _configureDropElement() {
        this._dropElement = document.createElement("ul");
        this._dropElement.id = "ac-menu-" + $7d043bb99bff1240$var$counter;
        this._dropElement.classList.add(...[
            "dropdown-menu",
            "autocomplete-menu",
            "p-0"
        ]);
        this._dropElement.style.maxHeight = "280px";
        if (!this._config.fullWidth) this._dropElement.style.maxWidth = "360px";
        if (this._config.fixed) this._dropElement.style.position = "fixed";
        this._dropElement.style.overflowY = "auto";
        // Prevent scrolling the menu from scrolling the page
        // @link https://developer.mozilla.org/en-US/docs/Web/CSS/overscroll-behavior
        this._dropElement.style.overscrollBehavior = "contain";
        this._dropElement.style.textAlign = "unset"; // otherwise RTL is not good
        $7d043bb99bff1240$var$insertAfter(this._searchInput, this._dropElement);
        // include aria-controls with the value of the id of the suggested list of values.
        this._searchInput.setAttribute("aria-controls", this._dropElement.id);
    }
    // #endregion
    // #region Events
    onclick(e) {
        if (e.target.matches(this._config.clearControl)) this.clear();
    }
    oninput(e) {
        if (this._preventInput) return;
        // Input has changed, clear value
        if (this._hiddenInput) this._hiddenInput.value = null;
        this.showOrSearch();
    }
    onchange(e) {
        const search = this._searchInput.value;
        const item = Object.values(this._items).find((item)=>item.label === search);
        this._config.onChange(item, this);
    }
    onblur(e) {
        // Clicking on the scrollbar will trigger a blur in modals...
        if (e.relatedTarget && e.relatedTarget.classList.contains("modal")) {
            // Set focus back in
            this._searchInput.focus();
            return;
        }
        setTimeout(()=>{
            this.hideSuggestions();
        }, 100);
    }
    onfocus(e) {
        this.showOrSearch();
    }
    /**
   * keypress doesn't send arrow keys, so we use keydown
   * @param {KeyboardEvent} e
   */ onkeydown(e) {
        const key = e.keyCode || e.key;
        switch(key){
            case 13:
            case "Enter":
                if (this.isDropdownVisible()) {
                    const selection = this.getSelection();
                    if (selection) selection.click();
                    if (selection || !this._config.ignoreEnter) e.preventDefault();
                }
                break;
            case 38:
            case "ArrowUp":
                e.preventDefault();
                this._keyboardNavigation = true;
                this._moveSelection($7d043bb99bff1240$var$PREV);
                break;
            case 40:
            case "ArrowDown":
                e.preventDefault();
                this._keyboardNavigation = true;
                if (this.isDropdownVisible()) this._moveSelection($7d043bb99bff1240$var$NEXT);
                else // show menu regardless of input length
                this.showOrSearch(false);
                break;
            case 27:
            case "Escape":
                if (this.isDropdownVisible()) {
                    this._searchInput.focus();
                    this.hideSuggestions();
                }
                break;
        }
    }
    onmousemove(e) {
        // Moving the mouse means no longer using keyboard
        this._keyboardNavigation = false;
    }
    onmouseleave(e) {
        // Remove selection
        this.removeSelection();
    }
    onscroll(e) {
        this._positionMenu();
    }
    onresize(e) {
        this._positionMenu();
    }
    // #endregion
    // #region Api
    /**
   * @param {String} k
   * @returns {Config}
   */ getConfig(k = null) {
        if (k !== null) return this._config[k];
        return this._config;
    }
    /**
   * @param {String} k
   * @param {*} v
   */ setConfig(k, v) {
        this._config[k] = v;
    }
    setData(src) {
        this._items = {};
        this._addItems(src);
    }
    enable() {
        this._searchInput.setAttribute("disabled", "");
    }
    disable() {
        this._searchInput.removeAttribute("disabled");
    }
    /**
   * @returns {boolean}
   */ isDisabled() {
        return this._searchInput.hasAttribute("disabled") || this._searchInput.disabled || this._searchInput.hasAttribute("readonly");
    }
    /**
   * @returns {boolean}
   */ isDropdownVisible() {
        return this._dropElement.classList.contains($7d043bb99bff1240$var$SHOW_CLASS);
    }
    clear() {
        this._searchInput.value = "";
        if (this._hiddenInput) this._hiddenInput.value = "";
    }
    // #endregion
    // #region Selection management
    /**
   * @returns {HTMLElement}
   */ getSelection() {
        return this._dropElement.querySelector("a." + $7d043bb99bff1240$var$ACTIVE_CLASS);
    }
    removeSelection() {
        const selection = this.getSelection();
        if (selection) selection.classList.remove(...this._activeClasses());
    }
    /**
   * @returns {Array}
   */ _activeClasses() {
        return [
            ...this._config.activeClasses,
            $7d043bb99bff1240$var$ACTIVE_CLASS
        ];
    }
    /**
   * @param {HTMLElement} li
   * @returns {Boolean}
   */ _isItemEnabled(li) {
        if (li.style.display === "none") return false;
        const fc = li.firstElementChild;
        return fc.tagName === "A" && !fc.classList.contains("disabled");
    }
    /**
   * @param {String} dir
   * @param {*|HTMLElement} sel
   * @returns {HTMLElement}
   */ _moveSelection(dir = $7d043bb99bff1240$var$NEXT, sel = null) {
        const active = this.getSelection();
        // select first li
        if (!active) {
            // no active selection, cannot go back
            if (dir === $7d043bb99bff1240$var$PREV) return sel;
            // find first enabled item
            if (!sel) {
                sel = this._dropElement.firstChild;
                while(sel && !this._isItemEnabled(sel))sel = sel["nextSibling"];
            }
        } else {
            const sibling = dir === $7d043bb99bff1240$var$NEXT ? "nextSibling" : "previousSibling";
            // Iterate over enabled li
            sel = active.parentNode;
            do sel = sel[sibling];
            while (sel && !this._isItemEnabled(sel));
            // We have a new selection
            if (sel) {
                // Change classes
                active.classList.remove(...this._activeClasses());
                // Scroll if necessary
                if (dir === $7d043bb99bff1240$var$PREV) // Don't use scrollIntoView as it scrolls the whole window
                sel.parentNode.scrollTop = sel.offsetTop - sel.parentNode.offsetTop;
                else // This is the equivalent of scrollIntoView(false) but only for parent node
                if (sel.offsetTop > sel.parentNode.offsetHeight - sel.offsetHeight) sel.parentNode.scrollTop += sel.offsetHeight;
            } else if (active) sel = active.parentElement;
        }
        if (sel) {
            const a = sel.querySelector("a");
            a.classList.add(...this._activeClasses());
            this._searchInput.setAttribute("aria-activedescendant", a.id);
            if (this._config.updateOnSelect) this._searchInput.value = a.dataset.label;
        } else this._searchInput.setAttribute("aria-activedescendant", "");
        return sel;
    }
    // #endregion
    // #region Implementation
    /**
   * Do we have enough input to show suggestions ?
   * @returns {Boolean}
   */ _shouldShow() {
        if (this.isDisabled()) return false;
        return this._searchInput.value.length >= this._config.suggestionsThreshold;
    }
    /**
   * Show suggestions or load them
   * @param {Boolean} check
   */ showOrSearch(check = true) {
        if (check && !this._shouldShow()) {
            this.hideSuggestions();
            return;
        }
        if (this._config.liveServer) this._searchFunc();
        else if (this._config.source) this._config.source(this._searchInput.value, (items)=>{
            this.setData(items);
            this._showSuggestions();
        });
        else this._showSuggestions();
    }
    /**
   * @param {String} name
   * @returns {HTMLElement}
   */ _createGroup(name) {
        const newChild = this._createLi();
        const newChildSpan = document.createElement("span");
        newChild.append(newChildSpan);
        newChildSpan.classList.add(...[
            "dropdown-header",
            "text-truncate"
        ]);
        newChildSpan.innerHTML = name;
        return newChild;
    }
    /**
   * @param {String} lookup
   * @param {Object} item
   * @returns {HTMLElement}
   */ _createItem(lookup, item) {
        let label = item.label;
        if (this._config.highlightTyped) {
            const idx = $7d043bb99bff1240$var$normalize(label).indexOf(lookup);
            if (idx !== -1) label = label.substring(0, idx) + `<mark class="${this._config.highlightClass}">${label.substring(idx, idx + lookup.length)}</mark>` + label.substring(idx + lookup.length, label.length);
        }
        label = this._config.onRenderItem(item, label, this);
        const newChild = this._createLi();
        const newChildLink = document.createElement("a");
        newChild.append(newChildLink);
        newChildLink.id = this._dropElement.id + "-" + this._dropElement.children.length;
        newChildLink.classList.add(...[
            "dropdown-item",
            "text-truncate"
        ]);
        if (this._config.itemClass) newChildLink.classList.add(...this._config.itemClass.split(" "));
        newChildLink.setAttribute("data-value", item.value);
        newChildLink.setAttribute("data-label", item.label);
        // Behave like a datalist (tab doesn't allow item selection)
        // @link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/datalist
        newChildLink.setAttribute("tabindex", "-1");
        newChildLink.setAttribute("role", "menuitem");
        newChildLink.setAttribute("href", "#");
        newChildLink.innerHTML = label;
        if (item.data) for (const [key, value] of Object.entries(item.data))newChildLink.dataset[key] = value;
        if (this._config.fillIn) {
            const fillIn = document.createElement("button");
            fillIn.type = "button"; // prevent submit
            fillIn.classList.add(...[
                "btn",
                "btn-link",
                "border-0"
            ]);
            fillIn.innerHTML = `<svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M2 2.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H3.707l10.147 10.146a.5.5 0 0 1-.708.708L3 3.707V8.5a.5.5 0 0 1-1 0z"/>
      </svg>`;
            newChild.append(fillIn);
            newChild.classList.add(...[
                "d-flex",
                "justify-content-between"
            ]);
            fillIn.addEventListener("click", (event)=>{
                this._searchInput.value = item.label;
                this._searchInput.focus(); // focus back to keep editing
            });
        }
        // Hover sets active item
        newChildLink.addEventListener("mouseenter", (event)=>{
            // Don't trigger enter if using arrows
            if (this._keyboardNavigation) return;
            this.removeSelection();
            newChild.querySelector("a").classList.add(...this._activeClasses());
        });
        // Prevent searchInput losing focus and close the menu
        newChildLink.addEventListener("mousedown", (event)=>{
            event.preventDefault();
        });
        // Apply value
        newChildLink.addEventListener("click", (event)=>{
            event.preventDefault();
            // Prevent input otherwise it might trigger autocomplete due to value change
            this._preventInput = true;
            this._searchInput.value = $7d043bb99bff1240$var$decodeHtml(item.label);
            // Populate value in hidden input
            if (this._hiddenInput) this._hiddenInput.value = item.value;
            this._config.onSelectItem(item, this);
            this.hideSuggestions();
            this._preventInput = false;
        });
        return newChild;
    }
    /**
   * Show drop menu with suggestions
   */ _showSuggestions() {
        // It's not focused anymore
        if (document.activeElement != this._searchInput) return;
        const lookup = $7d043bb99bff1240$var$normalize(this._searchInput.value);
        this._dropElement.innerHTML = "";
        const keys = Object.keys(this._items);
        let count = 0;
        let firstItem = null;
        const groups = [];
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const entry = this._items[key];
            // Check search length since we can trigger dropdown with arrow
            const showAllSuggestions = this._config.showAllSuggestions || lookup.length === 0;
            // Do we find a matching string or do we display immediately ?
            let isMatched = lookup.length == 0 && this._config.suggestionsThreshold === 0;
            if (!showAllSuggestions && lookup.length > 0) // match on any field
            this._config.searchFields.forEach((sf)=>{
                const text = $7d043bb99bff1240$var$normalize(entry[sf]);
                let found = false;
                if (this._config.fuzzy) found = $7d043bb99bff1240$var$fuzzyMatch(text, lookup);
                else {
                    const idx = text.indexOf(lookup);
                    found = this._config.startsWith ? idx === 0 : idx >= 0;
                }
                if (found) isMatched = true;
            });
            const selectFirst = isMatched || lookup.length === 0;
            if (showAllSuggestions || isMatched) {
                count++;
                // Group
                if (entry.group && !groups.includes(entry.group)) {
                    const newItem = this._createGroup(entry.group);
                    this._dropElement.appendChild(newItem);
                    groups.push(entry.group);
                }
                const newItem = this._createItem(lookup, entry);
                // Only select as first item if its matching or no lookup
                if (!firstItem && selectFirst) firstItem = newItem;
                this._dropElement.appendChild(newItem);
                if (this._config.maximumItems > 0 && count >= this._config.maximumItems) break;
            }
        }
        if (firstItem && this._config.autoselectFirst) {
            this.removeSelection();
            this._moveSelection($7d043bb99bff1240$var$NEXT, firstItem);
        }
        if (count === 0) {
            if (this._config.notFoundMessage) {
                const newChild = this._createLi();
                newChild.innerHTML = `<span class="dropdown-item">${this._config.notFoundMessage}</span>`;
                this._dropElement.appendChild(newChild);
                this._showDropdown();
            } else // Remove dropdown if not found
            this.hideSuggestions();
        } else // Or show it if necessary
        this._showDropdown();
    }
    /**
   * @returns {HTMLLIElement}
   */ _createLi() {
        const newChild = document.createElement("li");
        newChild.setAttribute("role", "presentation");
        return newChild;
    }
    /**
   * Show and position dropdown
   */ _showDropdown() {
        this._dropElement.classList.add($7d043bb99bff1240$var$SHOW_CLASS);
        // Register role when shown to avoid empty children issues
        this._dropElement.setAttribute("role", "menu");
        $7d043bb99bff1240$var$attrs(this._searchInput, {
            "aria-expanded": "true"
        });
        this._positionMenu();
    }
    /**
   * Show or hide suggestions
   * @param {Boolean} check
   */ toggleSuggestions(check = true) {
        if (this._dropElement.classList.contains($7d043bb99bff1240$var$SHOW_CLASS)) this.hideSuggestions();
        else this.showOrSearch(check);
    }
    /**
   * Hide the dropdown menu
   */ hideSuggestions() {
        this._dropElement.classList.remove($7d043bb99bff1240$var$SHOW_CLASS);
        $7d043bb99bff1240$var$attrs(this._searchInput, {
            "aria-expanded": "false"
        });
        this.removeSelection();
    }
    /**
   * @returns {HTMLInputElement}
   */ getInput() {
        return this._searchInput;
    }
    /**
   * @returns {HTMLUListElement}
   */ getDropMenu() {
        return this._dropElement;
    }
    /**
   * Position the dropdown menu
   */ _positionMenu() {
        const styles = window.getComputedStyle(this._searchInput);
        const bounds = this._searchInput.getBoundingClientRect();
        const isRTL = styles.direction === "rtl";
        const fullWidth = this._config.fullWidth;
        const fixed = this._config.fixed;
        // Don't position left if not fixed since it may not work in all situations
        // due to offsetParent margin or in tables
        let left = null;
        let top = null;
        if (fixed) {
            left = bounds.x;
            top = bounds.y + bounds.height;
            // Align end
            if (isRTL && !fullWidth) left -= this._dropElement.offsetWidth - bounds.width;
        }
        // Reset any height overflow adjustement
        this._dropElement.style.transform = "unset";
        // Use full holder width
        if (fullWidth) this._dropElement.style.width = this._searchInput.offsetWidth + "px";
        // Position element
        if (left !== null) this._dropElement.style.left = left + "px";
        if (top !== null) this._dropElement.style.top = top + "px";
        // Overflow height
        const dropBounds = this._dropElement.getBoundingClientRect();
        const h = window.innerHeight;
        // We display above input if it overflows
        if (dropBounds.y + dropBounds.height > h) {
            // We need to add the offset twice
            const topOffset = fullWidth ? bounds.height + 4 : bounds.height;
            // In chrome, we need 100.1% to avoid blurry text
            // @link https://stackoverflow.com/questions/32034574/font-looks-blurry-after-translate-in-chrome
            this._dropElement.style.transform = "translateY(calc(-100.1% - " + topOffset + "px))";
        }
    }
    _fetchData() {
        this._items = {};
        // From an array of items or an object
        this._addItems(this._config.items);
        // From a datalist
        const dl = this._config.datalist;
        if (dl) {
            const datalist = document.querySelector(`#${dl}`);
            if (datalist) {
                const items = Array.from(datalist.children).map((o)=>{
                    const value = o.getAttribute("value") ?? o.innerHTML.toLowerCase();
                    const label = o.innerHTML;
                    return {
                        value: value,
                        label: label
                    };
                });
                this._addItems(items);
            } else console.error(`Datalist not found ${dl}`);
        }
        this._setHiddenVal();
        // From an external source
        if (this._config.server && !this._config.liveServer) this._loadFromServer();
    }
    _setHiddenVal() {
        if (this._config.hiddenInput && !this._config.hiddenValue) {
            for (const [value, entry] of Object.entries(this._items))if (entry.label == this._searchInput.value) this._hiddenInput.value = value;
        }
    }
    /**
   * @param {Array|Object} src An array of items or a value:label object
   */ _addItems(src) {
        const keys = Object.keys(src);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const entry = src[key];
            if (entry.group && entry.items) {
                entry.items.forEach((e)=>e.group = entry.group);
                this._addItems(entry.items);
                continue;
            }
            const label = typeof entry === "string" ? entry : entry.label;
            const item = typeof entry !== "object" ? {} : entry;
            // Normalize entry
            item.label = entry[this._config.labelField] ?? label;
            item.value = entry[this._config.valueField] ?? key;
            // Make sure we have a label
            if (item.label) this._items[item.value] = item;
        }
    }
    /**
   * @param {boolean} show
   */ _loadFromServer(show = false) {
        if (this._abortController) this._abortController.abort();
        this._abortController = new AbortController();
        // Read data params dynamically as well
        let extraParams = this._searchInput.dataset.serverParams || {};
        if (typeof extraParams == "string") extraParams = JSON.parse(extraParams);
        const params = Object.assign({}, this._config.serverParams, extraParams);
        // Pass current value
        params[this._config.queryParam] = this._searchInput.value;
        // Prevent caching
        if (this._config.noCache) params.t = Date.now();
        // We have a related field
        if (params.related) {
            /**
       * @type {HTMLInputElement}
       */ //@ts-ignore
            const input = document.getElementById(params.related);
            if (input) {
                params.related = input.value;
                const inputName = input.getAttribute("name");
                if (inputName) params[inputName] = input.value;
            }
        }
        const urlParams = new URLSearchParams(params);
        let url = this._config.server;
        let fetchOptions = Object.assign(this._config.fetchOptions, {
            method: this._config.serverMethod || "GET",
            signal: this._abortController.signal
        });
        if (fetchOptions.method === "POST") fetchOptions.body = urlParams;
        else url += "?" + urlParams.toString();
        this._searchInput.classList.add($7d043bb99bff1240$var$LOADING_CLASS);
        this._config.onBeforeFetch(this);
        fetch(url, fetchOptions).then((r)=>this._config.onServerResponse(r, this)).then((suggestions)=>{
            const data = $7d043bb99bff1240$var$nested(this._config.serverDataKey, suggestions) || suggestions;
            this.setData(data);
            this._setHiddenVal();
            this._abortController = null;
            if (show) this._showSuggestions();
        }).catch((e)=>{
            // Current version of Firefox rejects the promise with a DOMException
            if (e.name === "AbortError" || this._abortController.signal.aborted) return;
            console.error(e);
        }).finally((e)=>{
            this._searchInput.classList.remove($7d043bb99bff1240$var$LOADING_CLASS);
            this._config.onAfterFetch(this);
        });
    }
}
var $7d043bb99bff1240$export$2e2bcd8739ae039 = $7d043bb99bff1240$var$Autocomplete;


const $7ffc1f94643dc7e4$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $7ffc1f94643dc7e4$export$2e2bcd8739ae039 = {
    randomUUID: $7ffc1f94643dc7e4$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $568f4ee4022ba00e$var$getRandomValues;
const $568f4ee4022ba00e$var$rnds8 = new Uint8Array(16);
function $568f4ee4022ba00e$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$568f4ee4022ba00e$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $568f4ee4022ba00e$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$568f4ee4022ba00e$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $568f4ee4022ba00e$var$getRandomValues($568f4ee4022ba00e$var$rnds8);
}


var $32c496bfb6c27b56$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $46d323206dcbf256$var$validate(uuid) {
    return typeof uuid === "string" && (0, $32c496bfb6c27b56$export$2e2bcd8739ae039).test(uuid);
}
var $46d323206dcbf256$export$2e2bcd8739ae039 = $46d323206dcbf256$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $1d0137947e8554ce$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$1d0137947e8554ce$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $1d0137947e8554ce$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $1d0137947e8554ce$var$byteToHex[arr[offset + 0]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 1]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 2]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 3]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 4]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 5]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 6]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 7]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 8]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 9]] + "-" + $1d0137947e8554ce$var$byteToHex[arr[offset + 10]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 11]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 12]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 13]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 14]] + $1d0137947e8554ce$var$byteToHex[arr[offset + 15]];
}
function $1d0137947e8554ce$var$stringify(arr, offset = 0) {
    const uuid = $1d0137947e8554ce$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $46d323206dcbf256$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $1d0137947e8554ce$export$2e2bcd8739ae039 = $1d0137947e8554ce$var$stringify;


function $3fa3ae484854b431$var$v4(options, buf, offset) {
    if ((0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $7ffc1f94643dc7e4$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $568f4ee4022ba00e$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $1d0137947e8554ce$export$8fb373d660548968)(rnds);
}
var $3fa3ae484854b431$export$2e2bcd8739ae039 = $3fa3ae484854b431$var$v4;




var $7etJZ = parcelRequire("7etJZ");
(0, $7d043bb99bff1240$export$2e2bcd8739ae039).init();
class $0fad04dc9d895ec5$export$6a9b2964be74ea54 extends $7etJZ {
    constructor(){
        super();
        this.JQueryContentContainer = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row"></div>`);
    }
    render() {
        this.JQueryContentContainer.empty();
        var content = this.generateJQueryContent();
        content.forEach((element)=>{
            this.JQueryContentContainer.append(element);
        });
        return this.JQueryContentContainer;
    }
    refresh() {
        this.JQueryContentContainer.empty();
        this.JQueryContentContainer.append(this.generateJQueryContent());
    }
    generateJQueryContent() {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("<div></div>")
        ];
    }
}
class $0fad04dc9d895ec5$export$47ada3610a077e extends $0fad04dc9d895ec5$export$6a9b2964be74ea54 {
    constructor(config = {
        category: null,
        parent: null
    }){
        super();
        this.parent = config.parent;
        this.coreElement = config.category;
        this.lines = new Map();
        this.displayStore = $5605c1058d66d37f$export$f51a9068ac82ea43();
        this.categoryId = this.coreElement.idPrefix + (0, $3fa3ae484854b431$export$2e2bcd8739ae039)() + "Category";
        this.categoryContentId = this.coreElement.idPrefix + (0, $3fa3ae484854b431$export$2e2bcd8739ae039)() + "CategoryContent";
        this.JQueryContentContainer = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="border rounded mb-4 border-secondary col-12"></div>`);
        this.subCategoryViews = [];
        this.collapsed = false;
        if (this.isASubCategory()) this.collapsed = true;
        if (this.coreElement.subCategories !== undefined) this.coreElement.subCategories.forEach((subCategory)=>{
            var subCategoryView = new $0fad04dc9d895ec5$export$47ada3610a077e({
                category: subCategory,
                parent: this
            });
            subCategoryView.on("add", (statements, source)=>{
                this.emit("add", statements, source);
            });
            subCategoryView.on("remove", (statements, source)=>{
                this.emit("remove", statements, source);
            });
            this.subCategoryViews.push(subCategoryView);
        });
        this.coreElement.fields.forEach((field)=>{
            if (this.coreElement.minArity > 0) for(var nbLine = 0; nbLine < this.coreElement.minArity; nbLine++)this.addLine();
        });
    }
    isASubCategory() {
        return this.parent !== undefined && this.parent !== null;
    }
    refreshDisplay() {
        $5605c1058d66d37f$export$147c92fc1e54141d(this.displayStore).then((str)=>{
            this.setDisplay(str);
        });
    }
    setDisplay(content) {
        this.catDisplayContent.text(content);
    }
    clear() {
        this.subCategoryViews.forEach((subCategory)=>{
            subCategory.clear();
        });
        this.lines.forEach((line, lineId)=>{
            this.removeLine(lineId);
        });
        this.refresh();
        this.refreshDisplay();
    }
    addLine(value) {
        function innerAddLine(categoryView, value) {
            categoryView.coreElement.fields.forEach((field)=>{
                var fieldLine = new $0fad04dc9d895ec5$export$535528a1465bbcb0({
                    core: field,
                    parentCategoryView: categoryView
                });
                categoryView.lines.set(fieldLine.inputId, fieldLine);
                fieldLine.on("add", (statements, source)=>{
                    categoryView.emit("add", statements, source);
                });
                fieldLine.on("remove", (statements, source)=>{
                    categoryView.emit("remove", statements, source);
                });
                fieldLine.on("suggestion", (statements, source)=>{
                    categoryView.emit("suggestion", statements, source);
                });
                fieldLine.on("error", (message, source)=>{
                    categoryView.showError(message);
                });
                fieldLine.on("validation", (source)=>{
                    categoryView.hideError();
                });
                if (value !== undefined) fieldLine.updateContent(value);
            });
        }
        // If adding a line put us above the maximum, then we remove the non valid lines
        if (!this.underOrEqualToMaximumNumberOfLine(1)) {
            let lineToBeRemoved = [];
            this.lines.forEach((line, lineId)=>{
                if (!(0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(line.validationState)) lineToBeRemoved.push(lineId);
            });
            lineToBeRemoved.forEach((lineId)=>{
                this.removeLine(lineId);
            });
        }
        if (this.underOrEqualToMaximumNumberOfLine(1)) innerAddLine(this, value);
        this.refresh();
        this.refreshDisplay();
    }
    removeLine(lineId) {
        if (this.aboveOrEqualToMinimumNumberOfLines()) {
            if (this.lines.get(lineId) != undefined && this.lines.get(lineId).getRDFData() != undefined) this.emit("remove", this.lines.get(lineId).getRDFData(), this.lines.get(lineId));
            this.lines.delete(lineId);
        }
    }
    aboveOrEqualToMinimumNumberOfLines(removedLine = 0) {
        return this.coreElement.minArity <= this.lines.size - removedLine;
    }
    underOrEqualToMaximumNumberOfLine(additionnalLine = 0) {
        return this.lines.size + additionnalLine <= this.coreElement.maxArity;
    }
    hasValidLines() {
        var valid = false;
        this.lines.forEach((line)=>{
            if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(line.validationState)) valid = true;
        });
        this.subCategoryViews.forEach((subCategory)=>{
            valid = valid || subCategory.hasValidLines();
        });
        return valid;
    }
    generateNavItem() {
        var navItem = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="navbar-item"><a class="navbar-link btn" href="${"#" + this.categoryId}">${this.coreElement.categoryTitle}</a></div>`);
        return navItem;
    }
    render() {
        var result = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row" id="${this.categoryContentId}"></div>`);
        if (!this.isASubCategory()) {
            // Anchor for the navigation bar
            var catAnchorDiv = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<span class="category-anchor" id="${this.categoryId}"></span>`);
            var navBarHeight = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#title-row").height();
            catAnchorDiv.css("height", navBarHeight + "px");
            catAnchorDiv.css("margin-top", "-" + navBarHeight + "px");
            this.navItem = this.generateNavItem();
            result.append(catAnchorDiv);
        }
        // Removing and re-rendering the category content
        const content = this.generateJQueryContent();
        this.JQueryContentContainer.empty();
        content.forEach((element)=>{
            this.JQueryContentContainer.append(element);
        });
        result.append(this.JQueryContentContainer);
        return result;
    }
    generateJQueryContent() {
        var addButtonId = "add" + this.coreElement.idPrefix + "Button";
        var result = [];
        var catCardHeader = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row"><p class="col-12 text-center gx-0 display-6">${this.coreElement.categoryTitle}</p></div>`);
        if (this.isASubCategory()) catCardHeader = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row"><p class="btn col-12 text-center gx-0 display-7">${this.coreElement.categoryTitle}</p></div>`);
        // Legend and extract button
        var catCardControlOuterRow = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row"></div>`);
        var catCardLegendCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class=".text-wrap"><p>${this.coreElement.legend}</p></div>`);
        var catExtractLineCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div></div>`);
        var catExtractButton = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<a type="button" class="btn btn-dark" id="${this.inputIdButton}" title="Metadatamatic will try to extract the information from the SPARQL endpoint.">Extract</a> `);
        catExtractLineCol.append(catExtractButton);
        catCardControlOuterRow.append(catCardLegendCol);
        if (this.coreElement.computable) {
            catCardLegendCol.addClass("col-10");
            catExtractLineCol.addClass("col-2");
            catCardControlOuterRow.append(catExtractLineCol);
        } else catCardLegendCol.addClass("col-12");
        catExtractButton.on("click", ()=>{
            this.coreElement.fields.forEach((field)=>{
                if (field.dataExtractionFunction != undefined) try {
                    catExtractButton.removeClass("btn-dark");
                    catExtractButton.addClass("btn-warning");
                    catExtractButton.addClass("disabled");
                    field.dataExtractionFunction().then((extractedValues)=>{
                        extractedValues.forEach((value)=>{
                            try {
                                this.addLine([
                                    value
                                ]);
                            } catch (e) {
                                console.error(e);
                                this.showError(new Error("Error during data creation: " + e.message));
                            }
                        });
                        catExtractButton.removeClass("btn-warning");
                        catExtractButton.addClass("btn-success");
                        catExtractButton.removeClass("disabled");
                    });
                } catch (e) {
                    console.error(e);
                    this.showError(new Error("Error during data retrieval: " + e.message));
                }
            });
        });
        // Add button
        var catCardBody = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="col-12 pb-2"></div>`);
        var catLineControlRow = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row"><div class="col-11"></div></div>`);
        var catAddLineButton = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<a type="button" class="btn btn-secondary" id="${addButtonId}" title="Add a new line"><i class="bi bi-file-plus fs-4"></i></a> `);
        var catAddLineButtonCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="col-1"></div>`);
        catAddLineButtonCol.append(catAddLineButton);
        catLineControlRow.append(catAddLineButtonCol);
        catAddLineButton.on("click", ()=>{
            this.addLine();
            this.refresh();
        });
        // Error display
        var catErrorDisplayRow = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row"></div>`);
        var catErrorDisplayCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="col-12"></div>`);
        var catErrorDiplayParagraph = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<p class="text-bg-danger rounded"></p>`);
        catErrorDisplayCol.on("click", ()=>{
            if (catErrorDisplayCol.hasClass("collapse.show")) {
                catErrorDisplayCol.removeClass("collapse.show");
                catErrorDisplayCol.addClass("collapse");
                catErrorDiplayParagraph.text("");
            }
        });
        catErrorDisplayRow.append(catErrorDisplayCol);
        catErrorDisplayCol.append(catErrorDiplayParagraph);
        this.showError = (message)=>{
            console.error(message);
            catErrorDiplayParagraph.text(message.toString());
            catErrorDisplayCol.removeClass("collapse");
            catErrorDisplayCol.addClass("collapse.show");
        };
        this.hideError = ()=>{
            catErrorDiplayParagraph.text("");
            catErrorDisplayCol.removeClass("collapse.show");
            catErrorDisplayCol.addClass("collapse");
        };
        // Display the RDF content of the category
        var catDisplay = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<pre class="language-turtle"></pre>`);
        this.catDisplayContent = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<code class="language-turtle" title="RDF content generated for this category."></code>`);
        $5605c1058d66d37f$export$147c92fc1e54141d(this.displayStore).then((str)=>{
            this.catDisplayContent.text(str);
        });
        catDisplay.append(this.catDisplayContent);
        this.on("add", (statements)=>{
            this.displayStore.addAll(statements);
            this.refreshDisplay();
        });
        this.on("remove", (statements)=>{
            statements.forEach((statement)=>{
                if (this.displayStore.holdsStatement(statement)) this.displayStore.removeStatement(statement);
            });
            this.refreshDisplay();
        });
        catCardBody.append(catLineControlRow);
        catCardBody.append(catErrorDisplayRow);
        // Fields
        this.lines.forEach((field, id)=>{
            const fieldJqueryContent = field.render();
            catCardBody.append(fieldJqueryContent);
        });
        if (this.lines.size >= this.coreElement.maxArity) catAddLineButton.addClass("d-none");
        else catAddLineButton.removeClass("d-none");
        // Subcategories
        if (this.subCategoryViews.length > 0) {
            var catSubCategoryCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row px-3 pt-2"></div>`);
            this.subCategoryViews.forEach((subCategoryView)=>{
                catSubCategoryCol.append(subCategoryView.render());
            });
            catCardBody.append(catSubCategoryCol);
        }
        result.push(catCardHeader);
        result.push(catCardControlOuterRow);
        result.push(catCardBody);
        if (!this.isASubCategory()) result.push(catDisplay);
        else catCardHeader.on("click", ()=>{
            this.collapsed = !this.collapsed;
            applyCollapse(this.collapsed);
        });
        function applyCollapse(collapsed) {
            if (collapsed) {
                catCardBody.removeClass("collapse.show");
                catCardBody.addClass("collapse");
                catCardControlOuterRow.removeClass("collapse.show");
                catCardControlOuterRow.addClass("collapse");
            } else {
                catCardBody.removeClass("collapse");
                catCardBody.addClass("collapse.show");
                catCardControlOuterRow.removeClass("collapse");
                catCardControlOuterRow.addClass("collapse.show");
            }
        }
        if (this.isASubCategory()) applyCollapse(this.collapsed);
        return result;
    }
}
class $0fad04dc9d895ec5$export$535528a1465bbcb0 extends $0fad04dc9d895ec5$export$6a9b2964be74ea54 {
    constructor(config = {
        core: null,
        parentCategoryView: null
    }){
        super();
        this.coreElement = config.core;
        this.parentCategoryView = config.parentCategoryView;
        this.index = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        this.metadataFieldIdPrefix = this.coreElement.parentCategory.idPrefix + "Field";
        this.fieldValue = this.coreElement.defaultValue;
        this.inputId = this.metadataFieldIdPrefix + this.index;
        this.validationState = (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).none();
        if (config.core.bootstrapFieldColWidth != undefined) this.bootstrapFieldColWidth = config.core.bootstrapFieldColWidth;
        else this.bootstrapFieldColWidth = [
            10
        ];
        this.numberOfFields = this.bootstrapFieldColWidth.length;
        this.fieldValue = this.coreElement.defaultValue;
        this.inputIdFields = [];
        for(var i = 0; i < this.numberOfFields; i++)this.inputIdFields.push(this.inputId + "Field" + i);
        this.inputIdButton = this.inputId + "Button";
        this.JQueryContentContainer = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="row pb-2"></div>`);
    }
    getValue() {
        return this.fieldValue;
    }
    hasValidValue() {
        try {
            return (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(this.coreElement.dataValidationFunction(this.getValue()));
        } catch (e) {
            this.emit("error", e, this);
            return false;
        }
    }
    getRDFData() {
        var validated = this.hasValidValue();
        if (validated) {
            var statements = this.coreElement.dataCreationFunction(this.fieldValue);
            return statements;
        } else return [];
    }
    setValidationState(validationState) {
        if (validationState != undefined && validationState.state != undefined && validationState.message != undefined) this.validationState = validationState;
        else this.validationState = (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).none();
    }
    changeViewValidationState(validationState) {
        if (validationState == undefined) validationState = this.validationState;
        var validationButton = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + this.inputIdButton);
        validationButton.attr("title", validationState.message);
        if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(validationState)) {
            validationButton.removeClass("btn-dark");
            validationButton.removeClass("btn-warning");
            validationButton.removeClass("btn-danger");
            validationButton.addClass("btn-success");
            this.inputIdFields.forEach((id)=>{
                var field = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + id);
                field.removeClass("border-dark");
                field.removeClass("border-danger");
                field.addClass("border-success");
            });
            this.emit("validation", this);
        } else if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isInvalid(validationState)) {
            validationButton.removeClass("btn-dark");
            validationButton.removeClass("btn-warning");
            validationButton.removeClass("btn-success");
            validationButton.addClass("btn-danger");
            this.inputIdFields.forEach((id)=>{
                var field = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + id);
                field.addClass("border-danger");
                field.removeClass("border-success");
                field.removeClass("border-dark");
            });
        } else if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isNone(validationState)) {
            validationButton.removeClass("btn-success");
            validationButton.removeClass("btn-warning");
            validationButton.removeClass("btn-danger");
            validationButton.addClass("btn-dark");
            this.inputIdFields.forEach((id)=>{
                var field = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + id);
                field.addClass("border-dark");
                field.removeClass("border-success");
                field.removeClass("border-danger");
            });
        } else throw new Error("Unknown validation state: " + validationState);
    }
    validateContent() {
        const validationState = this.coreElement.dataValidationFunction(this.fieldValue);
        var validated = (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(validationState);
        this.setValidationState(validationState);
        if (validated) {
            var statements = this.coreElement.dataCreationFunction(this.fieldValue);
            this.emit("add", statements, this);
            return statements;
        } else if (this.coreElement.advice != undefined) this.emit("error", this.coreElement.advice, this);
        else this.emit("error", validationState.message, this);
    }
    updateContent(newValue) {
        var oldValueValidated = false;
        if (this.fieldValue !== undefined) try {
            oldValueValidated = (0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(this.coreElement.dataValidationFunction(this.fieldValue));
        } catch (e) {
            this.emit("error", e, this);
        }
        if (oldValueValidated) {
            var statement = this.coreElement.dataCreationFunction(this.fieldValue);
            this.emit("remove", statement, this);
        }
        this.fieldValue = newValue;
        this.validateContent();
        this.changeViewValidationState();
    }
    render() {
        this.changeViewValidationState();
        return super.render();
    }
    refresh() {
        this.setValidationState(this.validationState);
        this.changeViewValidationState();
        super.refresh();
    }
    generateJQueryContent() {
        var result = [];
        var lineRemoveButtonCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="col-1">
            </div>`);
        var lineRemoveButton = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<a id="${this.inputIdRemoveButton}" type="button text-truncate" class="btn btn-secondary" title="Remove this line" tabindex="0">
                <i class="bi bi-file-minus fs-4"></i>
            </a>`);
        lineRemoveButtonCol.append(lineRemoveButton);
        if (this.parentCategoryView.lines.size == this.parentCategoryView.coreElement.minArity) lineRemoveButton.addClass("d-none");
        else lineRemoveButton.removeClass("d-none");
        // Validation button
        var lineValidButton = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<a id="${this.inputIdButton}" type="button" class="btn btn-dark text-truncate" title="Validate this line" tabindex="0">
                Validate
            </a>`);
        lineValidButton.attr("title", this.validationState.message);
        if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(this.validationState)) {
            lineValidButton.removeClass("btn-dark");
            lineValidButton.removeClass("btn-warning");
            lineValidButton.removeClass("btn-danger");
            lineValidButton.addClass("btn-success");
        } else if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isInvalid(this.validationState)) {
            lineValidButton.removeClass("btn-dark");
            lineValidButton.removeClass("btn-warning");
            lineValidButton.removeClass("btn-success");
            lineValidButton.addClass("btn-danger");
        } else if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isNone(this.validationState)) {
            lineValidButton.removeClass("btn-success");
            lineValidButton.removeClass("btn-warning");
            lineValidButton.removeClass("btn-danger");
            lineValidButton.addClass("btn-dark");
        } else throw new Error("Unknown validation state: " + this.validationState);
        var lineValidButtonCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="col-1">
            </div>`);
        lineValidButtonCol.append(lineValidButton);
        var fields = [];
        for(var i = 0; i < this.numberOfFields; i++){
            var lineFieldCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="col-${this.bootstrapFieldColWidth[i]} form-floating"></div>`);
            var lineLabel = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<label for="${this.inputIdFields[i]}" class="form-label">${this.coreElement.placeholder[i]}</label>`);
            var textInput = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<input type="text" class="form-control" autocomplete="off" id="${this.inputIdFields[i]}" value="${this.fieldValue[i]}"></input>`);
            if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(this.validationState)) {
                textInput.removeClass("border-dark");
                textInput.removeClass("border-danger");
                textInput.addClass("border-success");
            } else if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isInvalid(this.validationState)) {
                textInput.addClass("border-danger");
                textInput.removeClass("border-success");
                textInput.removeClass("border-dark");
            } else if ((0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isNone(this.validationState)) {
                textInput.addClass("border-dark");
                textInput.removeClass("border-success");
                textInput.removeClass("border-danger");
            }
            fields.push(textInput);
            lineFieldCol.append(textInput);
            lineFieldCol.append(lineLabel);
            result.push(lineFieldCol);
            if (this.coreElement.dataSuggestionFunction != undefined) {
                var items = this.coreElement.dataSuggestionFunction(this.fieldValue)[i];
                if (items !== undefined && items.length > 0) new (0, $7d043bb99bff1240$export$2e2bcd8739ae039)(textInput.get(0), {
                    items: items,
                    labelField: "label",
                    valueField: "value",
                    fullWidth: true,
                    suggestionsThreshold: 1,
                    onRenderItem: (item, label)=>{
                        if (label === undefined) return item.value;
                        else return label + " (" + item.value + ")";
                    },
                    onSelectItem (item) {
                        textInput.val(item.value);
                    }
                });
                else if (items === undefined) {
                    console.error("Undefined items for dataSuggestionFunction of ", i, "th field");
                    console.error(this.coreElement.dataSuggestionFunction(this.fieldValue));
                }
            }
            textInput.on("change", ()=>{
                this.updateContent(fields.map((field)=>field.val()));
            });
            textInput.on("focusin", (event)=>{
                var targetLabelId = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(event.target).attr("id") + "Label";
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + targetLabelId).addClass("visually-hidden");
            });
            textInput.on("focusout", (event)=>{
                var targetLabelId = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(event.target).attr("id") + "Label";
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#" + targetLabelId).removeClass("visually-hidden");
            });
        }
        result.push(lineValidButtonCol);
        result.push(lineRemoveButtonCol);
        lineValidButton.on("click", ()=>{
            this.updateContent(fields.map((field)=>field.val()));
            this.changeViewValidationState();
        });
        lineRemoveButton.on("click", ()=>{
            this.parentCategoryView.removeLine(this.inputId);
            this.parentCategoryView.refresh();
        });
        return result;
    }
}



var $gCJkd = parcelRequire("gCJkd");


const $0f8b792ecec97e77$var$EQUIV = $5b5611d501681341$export$2e2bcd8739ae039("https://ns.inria.fr/equivalence/#");
const $0f8b792ecec97e77$var$equivEquivalenceClasses = $0f8b792ecec97e77$var$EQUIV("AllEquivalentClasses");
const $0f8b792ecec97e77$var$equivEquivalenceProperties = $0f8b792ecec97e77$var$EQUIV("AllEquivalentProperties");
function $0f8b792ecec97e77$export$f7fc8ccdbb5a3a2c(file) {
    let equivalences = [];
    let fileContent = $35459c07cd7570af$export$a6e59c03a779ef88(file);
    let store = $5605c1058d66d37f$export$f51a9068ac82ea43();
    return fileContent.then((fileContent)=>$5605c1058d66d37f$export$968deea481412d5d(fileContent, store)).then((equivalencesStore)=>{
        let equivalenceClassNodes = new Set();
        let equivalencePropertiesNodes = new Set();
        // Extracting all the nodes representing equivalence sets
        equivalencesStore.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $0f8b792ecec97e77$var$equivEquivalenceClasses).forEach((statement)=>{
            if ($gCJkd.isBlankNode(statement.subject) || $gCJkd.isNamedNode(statement.subject)) equivalenceClassNodes.add(statement.subject);
        });
        equivalencesStore.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $0f8b792ecec97e77$var$equivEquivalenceProperties).forEach((statement)=>{
            if ($gCJkd.isBlankNode(statement.subject) || $gCJkd.isNamedNode(statement.subject)) equivalencePropertiesNodes.add(statement.subject);
        });
        function getMembers(equivalenceNode, equivalencesStore) {
            let members = [];
            equivalencesStore.statementsMatching(equivalenceNode, $5605c1058d66d37f$export$f4d442bee9f13350("members"), null).forEach((statement)=>{
                let memberArray = $5605c1058d66d37f$export$177a7908c10ca9b0(statement.object, equivalencesStore).filter((member)=>$gCJkd.isNamedNode(member)).map((member)=>member);
                members = members.concat(memberArray);
            });
            return members;
        }
        // Creating the object for each equivalence set
        equivalenceClassNodes.forEach((equivalenceNode)=>{
            let equivalence = {};
            equivalence.class = getMembers(equivalenceNode, equivalencesStore);
            equivalences.push(equivalence);
        });
        // Creating the object for each equivalence set
        equivalencePropertiesNodes.forEach((equivalenceNode)=>{
            let equivalence = {};
            equivalence.property = getMembers(equivalenceNode, equivalencesStore);
            equivalences.push(equivalence);
        });
        return equivalences;
    });
}
function $0f8b792ecec97e77$var$applyEquivalence(equivalence, store) {
    let result = [];
    // find dataset instances
    let datasetInstances = new Set();
    store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$1cd1943b3a73bbe8("Dataset")).forEach((statement)=>{
        if ($gCJkd.isNamedNode(statement.subject)) datasetInstances.add(statement.subject);
    });
    store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")).forEach((statement)=>{
        if ($gCJkd.isNamedNode(statement.subject)) datasetInstances.add(statement.subject);
    });
    store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$166a3e0dcf6b0f25("Dataset")).forEach((statement)=>{
        if ($gCJkd.isNamedNode(statement.subject)) datasetInstances.add(statement.subject);
    });
    store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$5b088def975a652b("Dataset")).forEach((statement)=>{
        if ($gCJkd.isNamedNode(statement.subject)) datasetInstances.add(statement.subject);
    });
    store.statementsMatching(null, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$d709348e62ac869e("Dataset")).forEach((statement)=>{
        if ($gCJkd.isNamedNode(statement.subject)) datasetInstances.add(statement.subject);
    });
    datasetInstances.forEach((datasetInstance)=>{
        if (equivalence.class != undefined) {
            let applicableEquivalence = false;
            equivalence.class.forEach((equivalenceClass)=>{
                if (store.holds(datasetInstance, null, equivalenceClass)) applicableEquivalence = true;
            });
            if (applicableEquivalence) equivalence.class.forEach((equivalenceClass)=>{
                store.statementsMatching(datasetInstance, null, equivalenceClass).forEach((statement)=>{
                    let subject = statement.subject;
                    let predicate = statement.predicate;
                    equivalence.class.forEach((otherEquivalenceClass)=>{
                        let newStatement = $6f0137736d5eb798$export$8692ddd9f3fb5f5d(subject, predicate, otherEquivalenceClass);
                        result.push(newStatement);
                    });
                });
            });
        }
        if (equivalence.property != undefined) {
            let applicableEquivalence = false;
            equivalence.property.forEach((equivalenceProperty)=>{
                if (store.holds(datasetInstance, equivalenceProperty, null)) applicableEquivalence = true;
            });
            if (applicableEquivalence) equivalence.property.forEach((equivalenceProperty)=>{
                store.statementsMatching(datasetInstance, equivalenceProperty, null).forEach((statement)=>{
                    let subject = statement.subject;
                    let object = statement.object;
                    equivalence.property.forEach((otherEquivalenceProperty)=>{
                        let newStatement = $6f0137736d5eb798$export$8692ddd9f3fb5f5d(subject, otherEquivalenceProperty, object);
                        result.push(newStatement);
                    });
                });
            });
        }
    });
    return result;
}
function $0f8b792ecec97e77$export$51716a511b9a85d1(equivalences, store) {
    let result = [];
    equivalences.forEach((equivalence)=>{
        result = result.concat($0f8b792ecec97e77$var$applyEquivalence(equivalence, store));
    });
    return result;
}




var $90f256c567e4c320$exports = {};
(function(a, b) {
    if ("function" == typeof define && define.amd) define([], b);
    else b();
})($90f256c567e4c320$exports, function() {
    "use strict";
    function b(a, b) {
        return "undefined" == typeof b ? b = {
            autoBom: !1
        } : "object" != typeof b && (console.warn("Deprecated: Expected third argument to be a object"), b = {
            autoBom: !b
        }), b.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type) ? new Blob([
            "\uFEFF",
            a
        ], {
            type: a.type
        }) : a;
    }
    function c(a, b, c) {
        var d = new XMLHttpRequest;
        d.open("GET", a), d.responseType = "blob", d.onload = function() {
            g(d.response, b, c);
        }, d.onerror = function() {
            console.error("could not download file");
        }, d.send();
    }
    function d(a) {
        var b = new XMLHttpRequest;
        b.open("HEAD", a, !1);
        try {
            b.send();
        } catch (a) {}
        return 200 <= b.status && 299 >= b.status;
    }
    function e(a) {
        try {
            a.dispatchEvent(new MouseEvent("click"));
        } catch (c) {
            var b = document.createEvent("MouseEvents");
            b.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), a.dispatchEvent(b);
        }
    }
    var f = "object" == typeof window && window.window === window ? window : "object" == typeof self && self.self === self ? self : "object" == typeof $parcel$global && $parcel$global.global === $parcel$global ? $parcel$global : void 0, a = f.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), g = f.saveAs || ("object" != typeof window || window !== f ? function() {} : "download" in HTMLAnchorElement.prototype && !a ? function(b, g, h) {
        var i = f.URL || f.webkitURL, j = document.createElement("a");
        g = g || b.name || "download", j.download = g, j.rel = "noopener", "string" == typeof b ? (j.href = b, j.origin === location.origin ? e(j) : d(j.href) ? c(b, g, h) : e(j, j.target = "_blank")) : (j.href = i.createObjectURL(b), setTimeout(function() {
            i.revokeObjectURL(j.href);
        }, 4E4), setTimeout(function() {
            e(j);
        }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(f, g, h) {
        if (g = g || f.name || "download", "string" != typeof f) navigator.msSaveOrOpenBlob(b(f, h), g);
        else if (d(f)) c(f, g, h);
        else {
            var i = document.createElement("a");
            i.href = f, i.target = "_blank", setTimeout(function() {
                e(i);
            });
        }
    } : function(b, d, e, g) {
        if (g = g || open("", "_blank"), g && (g.document.title = g.document.body.innerText = "downloading..."), "string" == typeof b) return c(b, d, e);
        var h = "application/octet-stream" === b.type, i = /constructor/i.test(f.HTMLElement) || f.safari, j = /CriOS\/[\d]+/.test(navigator.userAgent);
        if ((j || h && i || a) && "undefined" != typeof FileReader) {
            var k = new FileReader;
            k.onloadend = function() {
                var a = k.result;
                a = j ? a : a.replace(/^data:[^;]*;/, "data:attachment/file;"), g ? g.location.href = a : location = a, g = null;
            }, k.readAsDataURL(b);
        } else {
            var l = f.URL || f.webkitURL, m = l.createObjectURL(b);
            g ? g.location = m : location.href = m, g = null, setTimeout(function() {
                l.revokeObjectURL(m);
            }, 4E4);
        }
    });
    f.saveAs = g.saveAs = g, $90f256c567e4c320$exports = g;
});



/*!
  * Bootstrap v5.3.3 (https://getbootstrap.com/)
  * Copyright 2011-2024 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $cc4ed71c4f27adbc$exports = {};

$parcel$export($cc4ed71c4f27adbc$exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);
$parcel$export($cc4ed71c4f27adbc$exports, "detectOverflow", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperBase", () => $60bdf67e43f5dfcb$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);
$parcel$export($cc4ed71c4f27adbc$exports, "createPopperLite", () => $ef991c361ca719ad$export$8f7491d57c8f97a9);
var $1472b89a65155de2$exports = {};

$parcel$export($1472b89a65155de2$exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export($1472b89a65155de2$exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export($1472b89a65155de2$exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export($1472b89a65155de2$exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export($1472b89a65155de2$exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export($1472b89a65155de2$exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export($1472b89a65155de2$exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export($1472b89a65155de2$exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export($1472b89a65155de2$exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export($1472b89a65155de2$exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export($1472b89a65155de2$exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export($1472b89a65155de2$exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export($1472b89a65155de2$exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export($1472b89a65155de2$exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export($1472b89a65155de2$exports, "beforeRead", () => $1472b89a65155de2$export$421679a7c3d56e);
$parcel$export($1472b89a65155de2$exports, "read", () => $1472b89a65155de2$export$aafa59e2e03f2942);
$parcel$export($1472b89a65155de2$exports, "afterRead", () => $1472b89a65155de2$export$6964f6c886723980);
$parcel$export($1472b89a65155de2$exports, "beforeMain", () => $1472b89a65155de2$export$c65e99957a05207c);
$parcel$export($1472b89a65155de2$exports, "main", () => $1472b89a65155de2$export$f22da7240b7add18);
$parcel$export($1472b89a65155de2$exports, "afterMain", () => $1472b89a65155de2$export$bab79516f2d662fe);
$parcel$export($1472b89a65155de2$exports, "beforeWrite", () => $1472b89a65155de2$export$8d4d2d70e7d46032);
$parcel$export($1472b89a65155de2$exports, "write", () => $1472b89a65155de2$export$68d8715fc104d294);
$parcel$export($1472b89a65155de2$exports, "afterWrite", () => $1472b89a65155de2$export$70a6e5159acce2e6);
$parcel$export($1472b89a65155de2$exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


var $a3382052de3d061b$exports = {};

$parcel$export($a3382052de3d061b$exports, "applyStyles", () => $7deefb3680d4558f$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "arrow", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "computeStyles", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "eventListeners", () => $e7d7845625089588$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "flip", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "hide", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "offset", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "popperOffsets", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);
$parcel$export($a3382052de3d061b$exports, "preventOverflow", () => $865d356b2ca960a5$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}


function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}



var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "html" || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === "body" && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};








function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}



var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};


var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}








function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === "rtl") x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}










function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== "number" ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};



function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}









function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === "y" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === "x" ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};








function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}








function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === "fixed"),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $ef991c361ca719ad$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039)
];
var $ef991c361ca719ad$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $ef991c361ca719ad$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $1472b89a65155de2$exports);
$parcel$exportWildcard($cc4ed71c4f27adbc$exports, $a3382052de3d061b$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$elementMap = new Map();
const $e9dd36436aec3b21$var$Data = {
    set (element, key, instance) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) $e9dd36436aec3b21$var$elementMap.set(element, new Map());
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($e9dd36436aec3b21$var$elementMap.has(element)) return $e9dd36436aec3b21$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$e9dd36436aec3b21$var$elementMap.has(element)) return;
        const instanceMap = $e9dd36436aec3b21$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $e9dd36436aec3b21$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$MAX_UID = 1000000;
const $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER = 1000;
const $e9dd36436aec3b21$var$TRANSITION_END = "transitionend";
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $e9dd36436aec3b21$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $e9dd36436aec3b21$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $e9dd36436aec3b21$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $e9dd36436aec3b21$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $e9dd36436aec3b21$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(",")[0];
    transitionDelay = transitionDelay.split(",")[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $e9dd36436aec3b21$var$MILLISECONDS_MULTIPLIER;
};
const $e9dd36436aec3b21$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($e9dd36436aec3b21$var$TRANSITION_END));
};
const $e9dd36436aec3b21$var$isElement = (object)=>{
    if (!object || typeof object !== "object") return false;
    if (typeof object.jquery !== "undefined") object = object[0];
    return typeof object.nodeType !== "undefined";
};
const $e9dd36436aec3b21$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($e9dd36436aec3b21$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === "string" && object.length > 0) return document.querySelector($e9dd36436aec3b21$var$parseSelector(object));
    return null;
};
const $e9dd36436aec3b21$var$isVisible = (element)=>{
    if (!$e9dd36436aec3b21$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest("details:not([open])");
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest("summary");
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $e9dd36436aec3b21$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains("disabled")) return true;
    if (typeof element.disabled !== "undefined") return element.disabled;
    return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
};
const $e9dd36436aec3b21$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === "function") {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $e9dd36436aec3b21$var$findShadowRoot(element.parentNode);
};
const $e9dd36436aec3b21$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $e9dd36436aec3b21$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $e9dd36436aec3b21$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
    return null;
};
const $e9dd36436aec3b21$var$DOMContentLoadedCallbacks = [];
const $e9dd36436aec3b21$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === "loading") {
        // add listener on the first call when the document is in loading state
        if (!$e9dd36436aec3b21$var$DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", ()=>{
            for (const callback of $e9dd36436aec3b21$var$DOMContentLoadedCallbacks)callback();
        });
        $e9dd36436aec3b21$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $e9dd36436aec3b21$var$isRTL = ()=>document.documentElement.dir === "rtl";
const $e9dd36436aec3b21$var$defineJQueryPlugin = (plugin)=>{
    $e9dd36436aec3b21$var$onDOMContentLoaded(()=>{
        const $ = $e9dd36436aec3b21$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $e9dd36436aec3b21$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === "function" ? possibleCallback(...args) : defaultValue;
};
const $e9dd36436aec3b21$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $e9dd36436aec3b21$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $e9dd36436aec3b21$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
        $e9dd36436aec3b21$var$execute(callback);
    };
    transitionElement.addEventListener($e9dd36436aec3b21$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $e9dd36436aec3b21$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $e9dd36436aec3b21$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $e9dd36436aec3b21$var$stripNameRegex = /\..*/;
const $e9dd36436aec3b21$var$stripUidRegex = /::\d+$/;
const $e9dd36436aec3b21$var$eventRegistry = {}; // Events storage
let $e9dd36436aec3b21$var$uidEvent = 1;
const $e9dd36436aec3b21$var$customEvents = {
    mouseenter: "mouseover",
    mouseleave: "mouseout"
};
const $e9dd36436aec3b21$var$nativeEvents = new Set([
    "click",
    "dblclick",
    "mouseup",
    "mousedown",
    "contextmenu",
    "mousewheel",
    "DOMMouseScroll",
    "mouseover",
    "mouseout",
    "mousemove",
    "selectstart",
    "selectend",
    "keydown",
    "keypress",
    "keyup",
    "orientationchange",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel",
    "gesturestart",
    "gesturechange",
    "gestureend",
    "focus",
    "blur",
    "change",
    "reset",
    "select",
    "submit",
    "focusin",
    "focusout",
    "load",
    "unload",
    "beforeunload",
    "resize",
    "move",
    "DOMContentLoaded",
    "readystatechange",
    "error",
    "abort",
    "scroll"
]);
/**
 * Private methods
 */ function $e9dd36436aec3b21$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$e9dd36436aec3b21$var$uidEvent++}` || element.uidEvent || $e9dd36436aec3b21$var$uidEvent++;
}
function $e9dd36436aec3b21$var$getElementEvents(element) {
    const uid = $e9dd36436aec3b21$var$makeEventUid(element);
    element.uidEvent = uid;
    $e9dd36436aec3b21$var$eventRegistry[uid] = $e9dd36436aec3b21$var$eventRegistry[uid] || {};
    return $e9dd36436aec3b21$var$eventRegistry[uid];
}
function $e9dd36436aec3b21$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $e9dd36436aec3b21$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $e9dd36436aec3b21$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $e9dd36436aec3b21$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $e9dd36436aec3b21$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === "string";
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $e9dd36436aec3b21$var$getTypeEvent(originalTypeEvent);
    if (!$e9dd36436aec3b21$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $e9dd36436aec3b21$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== "string" || !element) return;
    let [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $e9dd36436aec3b21$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $e9dd36436aec3b21$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $e9dd36436aec3b21$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $e9dd36436aec3b21$var$makeEventUid(callable, originalTypeEvent.replace($e9dd36436aec3b21$var$namespaceRegex, ""));
    const fn = isDelegated ? $e9dd36436aec3b21$var$bootstrapDelegationHandler(element, handler, callable) : $e9dd36436aec3b21$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $e9dd36436aec3b21$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $e9dd36436aec3b21$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($e9dd36436aec3b21$var$stripNameRegex, "");
    return $e9dd36436aec3b21$var$customEvents[event] || event;
}
const $e9dd36436aec3b21$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $e9dd36436aec3b21$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        const [isDelegated, callable, typeEvent] = $e9dd36436aec3b21$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $e9dd36436aec3b21$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith(".");
        if (typeof callable !== "undefined") {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$e9dd36436aec3b21$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($e9dd36436aec3b21$var$stripUidRegex, "");
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $e9dd36436aec3b21$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== "string" || !element) return null;
        const $ = $e9dd36436aec3b21$var$getjQuery();
        const typeEvent = $e9dd36436aec3b21$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $e9dd36436aec3b21$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $e9dd36436aec3b21$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $e9dd36436aec3b21$var$normalizeData(value) {
    if (value === "true") return true;
    if (value === "false") return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === "" || value === "null") return null;
    if (typeof value !== "string") return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $e9dd36436aec3b21$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $e9dd36436aec3b21$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith("bs") && !key.startsWith("bsConfig"));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, "");
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
            attributes[pureKey] = $e9dd36436aec3b21$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $e9dd36436aec3b21$var$normalizeData(element.getAttribute(`data-bs-${$e9dd36436aec3b21$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $e9dd36436aec3b21$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, "config") : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === "object" ? jsonConfig : {},
            ...$e9dd36436aec3b21$var$isElement(element) ? $e9dd36436aec3b21$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === "object" ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $e9dd36436aec3b21$var$isElement(value) ? "element" : $e9dd36436aec3b21$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$VERSION = "5.3.3";
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$BaseComponent extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        element = $e9dd36436aec3b21$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $e9dd36436aec3b21$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $e9dd36436aec3b21$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    _queueCallback(callback, element, isAnimated = true) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $e9dd36436aec3b21$var$Data.get($e9dd36436aec3b21$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
    }
    static get VERSION() {
        return $e9dd36436aec3b21$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$getSelector = (element)=>{
    let selector = element.getAttribute("data-bs-target");
    if (!selector || selector === "#") {
        let hrefAttribute = element.getAttribute("href");
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = `#${hrefAttribute.split("#")[1]}`;
        selector = hrefAttribute && hrefAttribute !== "#" ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(",").map((sel)=>$e9dd36436aec3b21$var$parseSelector(sel)).join(",") : null;
};
const $e9dd36436aec3b21$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            "a",
            "button",
            "input",
            "textarea",
            "select",
            "details",
            "[tabindex]",
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(",");
        return this.find(focusables, element).filter((el)=>!$e9dd36436aec3b21$var$isDisabled(el) && $e9dd36436aec3b21$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        if (selector) return $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $e9dd36436aec3b21$var$getSelector(element);
        return selector ? $e9dd36436aec3b21$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $e9dd36436aec3b21$var$enableDismissTrigger = (component, method = "hide")=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $e9dd36436aec3b21$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if ($e9dd36436aec3b21$var$isDisabled(this)) return;
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$f = "alert";
const $e9dd36436aec3b21$var$DATA_KEY$a = "bs.alert";
const $e9dd36436aec3b21$var$EVENT_KEY$b = `.${$e9dd36436aec3b21$var$DATA_KEY$a}`;
const $e9dd36436aec3b21$var$EVENT_CLOSE = `close${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$EVENT_CLOSED = `closed${$e9dd36436aec3b21$var$EVENT_KEY$b}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$5 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$8 = "show";
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$caec2af78bcc877f extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$caec2af78bcc877f, "close");
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$e = "button";
const $e9dd36436aec3b21$var$DATA_KEY$9 = "bs.button";
const $e9dd36436aec3b21$var$EVENT_KEY$a = `.${$e9dd36436aec3b21$var$DATA_KEY$9}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$6 = ".data-api";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3 = "active";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6 = `click${$e9dd36436aec3b21$var$EVENT_KEY$a}${$e9dd36436aec3b21$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$353f5b6fc5456de1 extends $e9dd36436aec3b21$var$BaseComponent {
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute("aria-pressed", this._element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === "toggle") data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$6, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$5);
    const data = $e9dd36436aec3b21$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$d = "swipe";
const $e9dd36436aec3b21$var$EVENT_KEY$9 = ".bs.swipe";
const $e9dd36436aec3b21$var$EVENT_TOUCHSTART = `touchstart${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHMOVE = `touchmove${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_TOUCHEND = `touchend${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERDOWN = `pointerdown${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$EVENT_POINTERUP = `pointerup${$e9dd36436aec3b21$var$EVENT_KEY$9}`;
const $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH = "touch";
const $e9dd36436aec3b21$var$POINTER_TYPE_PEN = "pen";
const $e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT = "pointer-event";
const $e9dd36436aec3b21$var$SWIPE_THRESHOLD = 40;
const $e9dd36436aec3b21$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $e9dd36436aec3b21$var$DefaultType$c = {
    endCallback: "(function|null)",
    leftCallback: "(function|null)",
    rightCallback: "(function|null)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Swipe extends $e9dd36436aec3b21$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$e9dd36436aec3b21$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$c;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$c;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$d;
    }
    // Public
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $e9dd36436aec3b21$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $e9dd36436aec3b21$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $e9dd36436aec3b21$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_PEN || event.pointerType === $e9dd36436aec3b21$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$c = "carousel";
const $e9dd36436aec3b21$var$DATA_KEY$8 = "bs.carousel";
const $e9dd36436aec3b21$var$EVENT_KEY$8 = `.${$e9dd36436aec3b21$var$DATA_KEY$8}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$5 = ".data-api";
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY$1 = "ArrowLeft";
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1 = "ArrowRight";
const $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $e9dd36436aec3b21$var$ORDER_NEXT = "next";
const $e9dd36436aec3b21$var$ORDER_PREV = "prev";
const $e9dd36436aec3b21$var$DIRECTION_LEFT = "left";
const $e9dd36436aec3b21$var$DIRECTION_RIGHT = "right";
const $e9dd36436aec3b21$var$EVENT_SLIDE = `slide${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_SLID = `slid${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN$1 = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1 = `mouseenter${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1 = `mouseleave${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_DRAG_START = `dragstart${$e9dd36436aec3b21$var$EVENT_KEY$8}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3 = `load${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5 = `click${$e9dd36436aec3b21$var$EVENT_KEY$8}${$e9dd36436aec3b21$var$DATA_API_KEY$5}`;
const $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL = "carousel";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2 = "active";
const $e9dd36436aec3b21$var$CLASS_NAME_SLIDE = "slide";
const $e9dd36436aec3b21$var$CLASS_NAME_END = "carousel-item-end";
const $e9dd36436aec3b21$var$CLASS_NAME_START = "carousel-item-start";
const $e9dd36436aec3b21$var$CLASS_NAME_NEXT = "carousel-item-next";
const $e9dd36436aec3b21$var$CLASS_NAME_PREV = "carousel-item-prev";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE = ".active";
const $e9dd36436aec3b21$var$SELECTOR_ITEM = ".carousel-item";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM = $e9dd36436aec3b21$var$SELECTOR_ACTIVE + $e9dd36436aec3b21$var$SELECTOR_ITEM;
const $e9dd36436aec3b21$var$SELECTOR_ITEM_IMG = ".carousel-item img";
const $e9dd36436aec3b21$var$SELECTOR_INDICATORS = ".carousel-indicators";
const $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE = "[data-bs-slide], [data-bs-slide-to]";
const $e9dd36436aec3b21$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $e9dd36436aec3b21$var$KEY_TO_DIRECTION = {
    [$e9dd36436aec3b21$var$ARROW_LEFT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_RIGHT,
    [$e9dd36436aec3b21$var$ARROW_RIGHT_KEY$1]: $e9dd36436aec3b21$var$DIRECTION_LEFT
};
const $e9dd36436aec3b21$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: "hover",
    ride: false,
    touch: true,
    wrap: true
};
const $e9dd36436aec3b21$var$DefaultType$b = {
    interval: "(number|boolean)",
    // TODO:v6 remove boolean support
    keyboard: "boolean",
    pause: "(string|boolean)",
    ride: "(boolean|string)",
    touch: "boolean",
    wrap: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$144901db2ea8e967 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$b;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$b;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$c;
    }
    // Public
    next() {
        this._slide($e9dd36436aec3b21$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $e9dd36436aec3b21$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($e9dd36436aec3b21$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $e9dd36436aec3b21$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === "hover") {
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $e9dd36436aec3b21$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM_IMG, this._element))$e9dd36436aec3b21$var$EventHandler.on(img, $e9dd36436aec3b21$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== "hover") return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $e9dd36436aec3b21$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($e9dd36436aec3b21$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $e9dd36436aec3b21$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $e9dd36436aec3b21$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute("aria-current");
        const newActiveIndicator = $e9dd36436aec3b21$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute("aria-current", "true");
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute("data-bs-interval"), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $e9dd36436aec3b21$var$ORDER_NEXT;
        const nextElement = element || $e9dd36436aec3b21$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $e9dd36436aec3b21$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($e9dd36436aec3b21$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_START : $e9dd36436aec3b21$var$CLASS_NAME_END;
        const orderClassName = isNext ? $e9dd36436aec3b21$var$CLASS_NAME_NEXT : $e9dd36436aec3b21$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $e9dd36436aec3b21$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($e9dd36436aec3b21$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($e9dd36436aec3b21$var$isRTL()) return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_PREV : $e9dd36436aec3b21$var$ORDER_NEXT;
        return direction === $e9dd36436aec3b21$var$DIRECTION_LEFT ? $e9dd36436aec3b21$var$ORDER_NEXT : $e9dd36436aec3b21$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($e9dd36436aec3b21$var$isRTL()) return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_LEFT : $e9dd36436aec3b21$var$DIRECTION_RIGHT;
        return order === $e9dd36436aec3b21$var$ORDER_PREV ? $e9dd36436aec3b21$var$DIRECTION_RIGHT : $e9dd36436aec3b21$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === "number") {
                data.to(config);
                return;
            }
            if (typeof config === "string") {
                if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$5, $e9dd36436aec3b21$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute("data-bs-slide-to");
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($e9dd36436aec3b21$var$Manipulator.getDataAttribute(this, "slide") === "next") {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$e9dd36436aec3b21$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$b = "collapse";
const $e9dd36436aec3b21$var$DATA_KEY$7 = "bs.collapse";
const $e9dd36436aec3b21$var$EVENT_KEY$7 = `.${$e9dd36436aec3b21$var$DATA_KEY$7}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$4 = ".data-api";
const $e9dd36436aec3b21$var$EVENT_SHOW$6 = `show${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$6 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$6 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$6 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$7}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4 = `click${$e9dd36436aec3b21$var$EVENT_KEY$7}${$e9dd36436aec3b21$var$DATA_API_KEY$4}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE = "collapse";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING = "collapsing";
const $e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED = "collapsed";
const $e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE} .${$e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE}`;
const $e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL = "collapse-horizontal";
const $e9dd36436aec3b21$var$WIDTH = "width";
const $e9dd36436aec3b21$var$HEIGHT = "height";
const $e9dd36436aec3b21$var$SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $e9dd36436aec3b21$var$Default$a = {
    parent: null,
    toggle: true
};
const $e9dd36436aec3b21$var$DefaultType$a = {
    parent: "(null|element)",
    toggle: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$78768a9af065a7b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $e9dd36436aec3b21$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $e9dd36436aec3b21$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$a;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$a;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = "";
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSE);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = "";
        this._queueCallback(complete, this._element, true);
    }
    _isShown(element = this._element) {
        return element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$7);
    }
    // Private
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $e9dd36436aec3b21$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_HORIZONTAL) ? $e9dd36436aec3b21$var$WIDTH : $e9dd36436aec3b21$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($e9dd36436aec3b21$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute("aria-expanded", isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$4, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.getMultipleElementsFromSelector(this))$e9dd36436aec3b21$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$a = "dropdown";
const $e9dd36436aec3b21$var$DATA_KEY$6 = "bs.dropdown";
const $e9dd36436aec3b21$var$EVENT_KEY$6 = `.${$e9dd36436aec3b21$var$DATA_KEY$6}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$3 = ".data-api";
const $e9dd36436aec3b21$var$ESCAPE_KEY$2 = "Escape";
const $e9dd36436aec3b21$var$TAB_KEY$1 = "Tab";
const $e9dd36436aec3b21$var$ARROW_UP_KEY$1 = "ArrowUp";
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1 = "ArrowDown";
const $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $e9dd36436aec3b21$var$EVENT_HIDE$5 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$5 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$5 = `show${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$5 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$6}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3 = `click${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API = `keyup${$e9dd36436aec3b21$var$EVENT_KEY$6}${$e9dd36436aec3b21$var$DATA_API_KEY$3}`;
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$6 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP = "dropup";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPEND = "dropend";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPSTART = "dropstart";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER = "dropup-center";
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3}.${$e9dd36436aec3b21$var$CLASS_NAME_SHOW$6}`;
const $e9dd36436aec3b21$var$SELECTOR_MENU = ".dropdown-menu";
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR = ".navbar";
const $e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV = ".navbar-nav";
const $e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
const $e9dd36436aec3b21$var$PLACEMENT_TOP = $e9dd36436aec3b21$var$isRTL() ? "top-end" : "top-start";
const $e9dd36436aec3b21$var$PLACEMENT_TOPEND = $e9dd36436aec3b21$var$isRTL() ? "top-start" : "top-end";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOM = $e9dd36436aec3b21$var$isRTL() ? "bottom-end" : "bottom-start";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND = $e9dd36436aec3b21$var$isRTL() ? "bottom-start" : "bottom-end";
const $e9dd36436aec3b21$var$PLACEMENT_RIGHT = $e9dd36436aec3b21$var$isRTL() ? "left-start" : "right-start";
const $e9dd36436aec3b21$var$PLACEMENT_LEFT = $e9dd36436aec3b21$var$isRTL() ? "right-start" : "left-start";
const $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER = "top";
const $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER = "bottom";
const $e9dd36436aec3b21$var$Default$9 = {
    autoClose: true,
    boundary: "clippingParents",
    display: "dynamic",
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: "toggle"
};
const $e9dd36436aec3b21$var$DefaultType$9 = {
    autoClose: "(boolean|string)",
    boundary: "(string|element)",
    display: "string",
    offset: "(array|string|function)",
    popperConfig: "(null|object|function)",
    reference: "(string|element|object)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$931cbfb6bfb85fc extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $e9dd36436aec3b21$var$SelectorEngine.next(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.prev(this._element, $e9dd36436aec3b21$var$SELECTOR_MENU)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$9;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$9;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement && !this._parent.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, "mouseover", $e9dd36436aec3b21$var$noop);
        this._element.focus();
        this._element.setAttribute("aria-expanded", true);
        this._menu.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($e9dd36436aec3b21$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, "mouseover", $e9dd36436aec3b21$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute("aria-expanded", "false");
        $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(this._menu, "popper");
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === "object" && !$e9dd36436aec3b21$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$e9dd36436aec3b21$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $cc4ed71c4f27adbc$exports === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
        let referenceElement = this._element;
        if (this._config.reference === "parent") referenceElement = this._parent;
        else if ($e9dd36436aec3b21$var$isElement(this._config.reference)) referenceElement = $e9dd36436aec3b21$var$getElement(this._config.reference);
        else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $cc4ed71c4f27adbc$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPEND)) return $e9dd36436aec3b21$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPSTART)) return $e9dd36436aec3b21$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_CENTER)) return $e9dd36436aec3b21$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
        if (parentDropdown.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPUP)) return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_TOPEND : $e9dd36436aec3b21$var$PLACEMENT_TOP;
        return isEnd ? $e9dd36436aec3b21$var$PLACEMENT_BOTTOMEND : $e9dd36436aec3b21$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($e9dd36436aec3b21$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === "static") {
            $e9dd36436aec3b21$var$Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: "applyStyles",
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$e9dd36436aec3b21$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $e9dd36436aec3b21$var$getNextActiveElement(items, target, key === $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $e9dd36436aec3b21$var$RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== $e9dd36436aec3b21$var$TAB_KEY$1) return;
        const openToggles = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === $e9dd36436aec3b21$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === "click") relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $e9dd36436aec3b21$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $e9dd36436aec3b21$var$ARROW_UP_KEY$1,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3) ? this : $e9dd36436aec3b21$var$SelectorEngine.prev(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.next(this, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3)[0] || $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DATA_API, $e9dd36436aec3b21$var$SELECTOR_MENU, $e9dd36436aec3b21$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYUP_DATA_API, $e9dd36436aec3b21$export$931cbfb6bfb85fc.clearMenus);
$e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$3, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $e9dd36436aec3b21$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$9 = "backdrop";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$4 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$5 = "show";
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN = `mousedown.bs.${$e9dd36436aec3b21$var$NAME$9}`;
const $e9dd36436aec3b21$var$Default$8 = {
    className: "modal-backdrop",
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: "body" // give the choice to place backdrop under different elements
};
const $e9dd36436aec3b21$var$DefaultType$8 = {
    className: "string",
    clickCallback: "(function|null)",
    isAnimated: "boolean",
    isVisible: "boolean",
    rootElement: "(element|string)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$Backdrop extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$8;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$8;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $e9dd36436aec3b21$var$reflow(element);
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $e9dd36436aec3b21$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $e9dd36436aec3b21$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $e9dd36436aec3b21$var$EventHandler.off(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement("div");
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $e9dd36436aec3b21$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $e9dd36436aec3b21$var$EventHandler.on(element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN, ()=>{
            $e9dd36436aec3b21$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $e9dd36436aec3b21$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$8 = "focustrap";
const $e9dd36436aec3b21$var$DATA_KEY$5 = "bs.focustrap";
const $e9dd36436aec3b21$var$EVENT_KEY$5 = `.${$e9dd36436aec3b21$var$DATA_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$2 = `focusin${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB = `keydown.tab${$e9dd36436aec3b21$var$EVENT_KEY$5}`;
const $e9dd36436aec3b21$var$TAB_KEY = "Tab";
const $e9dd36436aec3b21$var$TAB_NAV_FORWARD = "forward";
const $e9dd36436aec3b21$var$TAB_NAV_BACKWARD = "backward";
const $e9dd36436aec3b21$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $e9dd36436aec3b21$var$DefaultType$7 = {
    autofocus: "boolean",
    trapElement: "element"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$FocusTrap extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$7;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$7;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5); // guard against infinite focus loop
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $e9dd36436aec3b21$var$EventHandler.off(document, $e9dd36436aec3b21$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $e9dd36436aec3b21$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $e9dd36436aec3b21$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $e9dd36436aec3b21$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $e9dd36436aec3b21$var$TAB_NAV_BACKWARD : $e9dd36436aec3b21$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
const $e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT = ".sticky-top";
const $e9dd36436aec3b21$var$PROPERTY_PADDING = "padding-right";
const $e9dd36436aec3b21$var$PROPERTY_MARGIN = "margin-right";
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, "overflow");
        this._resetElementAttributes(this._element, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_FIXED_CONTENT, $e9dd36436aec3b21$var$PROPERTY_PADDING);
        this._resetElementAttributes($e9dd36436aec3b21$var$SELECTOR_STICKY_CONTENT, $e9dd36436aec3b21$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, "overflow");
        this._element.style.overflow = "hidden";
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $e9dd36436aec3b21$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $e9dd36436aec3b21$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $e9dd36436aec3b21$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($e9dd36436aec3b21$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $e9dd36436aec3b21$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$7 = "modal";
const $e9dd36436aec3b21$var$DATA_KEY$4 = "bs.modal";
const $e9dd36436aec3b21$var$EVENT_KEY$4 = `.${$e9dd36436aec3b21$var$DATA_KEY$4}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$2 = ".data-api";
const $e9dd36436aec3b21$var$ESCAPE_KEY$1 = "Escape";
const $e9dd36436aec3b21$var$EVENT_HIDE$4 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$4 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$4 = `show${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$4 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE$1 = `resize${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS = `click.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$4}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2 = `click${$e9dd36436aec3b21$var$EVENT_KEY$4}${$e9dd36436aec3b21$var$DATA_API_KEY$2}`;
const $e9dd36436aec3b21$var$CLASS_NAME_OPEN = "modal-open";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$3 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$4 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_STATIC = "modal-static";
const $e9dd36436aec3b21$var$OPEN_SELECTOR$1 = ".modal.show";
const $e9dd36436aec3b21$var$SELECTOR_DIALOG = ".modal-dialog";
const $e9dd36436aec3b21$var$SELECTOR_MODAL_BODY = ".modal-body";
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $e9dd36436aec3b21$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $e9dd36436aec3b21$var$DefaultType$6 = {
    backdrop: "(boolean|string)",
    focus: "boolean",
    keyboard: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$2b77a92f1a5ad772 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $e9dd36436aec3b21$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$6;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$6;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $e9dd36436aec3b21$var$EventHandler.off(window, $e9dd36436aec3b21$var$EVENT_KEY$4);
        $e9dd36436aec3b21$var$EventHandler.off(this._dialog, $e9dd36436aec3b21$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $e9dd36436aec3b21$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = "block";
        this._element.removeAttribute("aria-hidden");
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.scrollTop = 0;
        const modalBody = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $e9dd36436aec3b21$var$EventHandler.one(this._element, $e9dd36436aec3b21$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === "static") {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = "none";
        this._element.setAttribute("aria-hidden", true);
        this._element.removeAttribute("aria-modal");
        this._element.removeAttribute("role");
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === "hidden" || this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = "hidden";
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? "paddingLeft" : "paddingRight";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $e9dd36436aec3b21$var$isRTL() ? "paddingRight" : "paddingLeft";
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = "";
        this._element.style.paddingRight = "";
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$2, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$4, ()=>{
            if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $e9dd36436aec3b21$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$6 = "offcanvas";
const $e9dd36436aec3b21$var$DATA_KEY$3 = "bs.offcanvas";
const $e9dd36436aec3b21$var$EVENT_KEY$3 = `.${$e9dd36436aec3b21$var$DATA_KEY$3}`;
const $e9dd36436aec3b21$var$DATA_API_KEY$1 = ".data-api";
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2 = `load${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$ESCAPE_KEY = "Escape";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$3 = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1 = "showing";
const $e9dd36436aec3b21$var$CLASS_NAME_HIDING = "hiding";
const $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP = "offcanvas-backdrop";
const $e9dd36436aec3b21$var$OPEN_SELECTOR = ".offcanvas.show";
const $e9dd36436aec3b21$var$EVENT_SHOW$3 = `show${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$3 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$3 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED = `hidePrevented${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$3 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_RESIZE = `resize${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1 = `click${$e9dd36436aec3b21$var$EVENT_KEY$3}${$e9dd36436aec3b21$var$DATA_API_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$e9dd36436aec3b21$var$EVENT_KEY$3}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $e9dd36436aec3b21$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $e9dd36436aec3b21$var$DefaultType$5 = {
    backdrop: "(boolean|string)",
    keyboard: "boolean",
    scroll: "boolean"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$591ca0244c9dfcd4 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$5;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$5;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().hide();
        this._element.setAttribute("aria-modal", true);
        this._element.setAttribute("role", "dialog");
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING$1);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$3, $e9dd36436aec3b21$var$CLASS_NAME_HIDING);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            if (!this._config.scroll) new $e9dd36436aec3b21$var$ScrollBarHelper().reset();
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === "static") {
                $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $e9dd36436aec3b21$var$Backdrop({
            className: $e9dd36436aec3b21$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $e9dd36436aec3b21$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $e9dd36436aec3b21$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API$1, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(this);
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$var$EventHandler.one(target, $e9dd36436aec3b21$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($e9dd36436aec3b21$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $e9dd36436aec3b21$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$OPEN_SELECTOR))$e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_RESIZE, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find("[aria-modal][class*=show][class*=offcanvas-]"))if (getComputedStyle(element).position !== "fixed") $e9dd36436aec3b21$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $e9dd36436aec3b21$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    "*": [
        "class",
        "dir",
        "id",
        "lang",
        "role",
        $e9dd36436aec3b21$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        "target",
        "href",
        "title",
        "rel"
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        "src",
        "srcset",
        "alt",
        "title",
        "width",
        "height"
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $e9dd36436aec3b21$var$uriAttributes = new Set([
    "background",
    "cite",
    "href",
    "itemtype",
    "longdesc",
    "poster",
    "src",
    "xlink:href"
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
const $e9dd36436aec3b21$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $e9dd36436aec3b21$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($e9dd36436aec3b21$var$uriAttributes.has(attributeName)) return Boolean($e9dd36436aec3b21$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $e9dd36436aec3b21$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === "function") return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
    const elements = [].concat(...createdDocument.body.querySelectorAll("*"));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList["*"] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$e9dd36436aec3b21$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$5 = "TemplateFactory";
const $e9dd36436aec3b21$var$Default$4 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: "",
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: "<div></div>"
};
const $e9dd36436aec3b21$var$DefaultType$4 = {
    allowList: "object",
    content: "object",
    extraClass: "(string|function)",
    html: "boolean",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    template: "string"
};
const $e9dd36436aec3b21$var$DefaultContentType = {
    entry: "(string|element|function|null)",
    selector: "(string|element)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$var$TemplateFactory extends $e9dd36436aec3b21$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$4;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$4;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement("div");
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(" "));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $e9dd36436aec3b21$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($e9dd36436aec3b21$var$isElement(content)) {
            this._putElementInTemplate($e9dd36436aec3b21$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $e9dd36436aec3b21$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = "";
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$4 = "tooltip";
const $e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES = new Set([
    "sanitize",
    "allowList",
    "sanitizeFn"
]);
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$2 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_MODAL = "modal";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2 = "show";
const $e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
const $e9dd36436aec3b21$var$SELECTOR_MODAL = `.${$e9dd36436aec3b21$var$CLASS_NAME_MODAL}`;
const $e9dd36436aec3b21$var$EVENT_MODAL_HIDE = "hide.bs.modal";
const $e9dd36436aec3b21$var$TRIGGER_HOVER = "hover";
const $e9dd36436aec3b21$var$TRIGGER_FOCUS = "focus";
const $e9dd36436aec3b21$var$TRIGGER_CLICK = "click";
const $e9dd36436aec3b21$var$TRIGGER_MANUAL = "manual";
const $e9dd36436aec3b21$var$EVENT_HIDE$2 = "hide";
const $e9dd36436aec3b21$var$EVENT_HIDDEN$2 = "hidden";
const $e9dd36436aec3b21$var$EVENT_SHOW$2 = "show";
const $e9dd36436aec3b21$var$EVENT_SHOWN$2 = "shown";
const $e9dd36436aec3b21$var$EVENT_INSERTED = "inserted";
const $e9dd36436aec3b21$var$EVENT_CLICK$1 = "click";
const $e9dd36436aec3b21$var$EVENT_FOCUSIN$1 = "focusin";
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT$1 = "focusout";
const $e9dd36436aec3b21$var$EVENT_MOUSEENTER = "mouseenter";
const $e9dd36436aec3b21$var$EVENT_MOUSELEAVE = "mouseleave";
const $e9dd36436aec3b21$var$AttachmentMap = {
    AUTO: "auto",
    TOP: "top",
    RIGHT: $e9dd36436aec3b21$var$isRTL() ? "left" : "right",
    BOTTOM: "bottom",
    LEFT: $e9dd36436aec3b21$var$isRTL() ? "right" : "left"
};
const $e9dd36436aec3b21$var$Default$3 = {
    allowList: $e9dd36436aec3b21$var$DefaultAllowlist,
    animation: true,
    boundary: "clippingParents",
    container: false,
    customClass: "",
    delay: 0,
    fallbackPlacements: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: "top",
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: "",
    trigger: "hover focus"
};
const $e9dd36436aec3b21$var$DefaultType$3 = {
    allowList: "object",
    animation: "boolean",
    boundary: "(string|element)",
    container: "(string|element|boolean)",
    customClass: "(string|function)",
    delay: "(number|object)",
    fallbackPlacements: "array",
    html: "boolean",
    offset: "(array|string|function)",
    placement: "(string|function)",
    popperConfig: "(null|object|function)",
    sanitize: "boolean",
    sanitizeFn: "(null|function)",
    selector: "(string|boolean)",
    template: "string",
    title: "(string|element|function)",
    trigger: "string"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$28c660c63b792dea extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        if (typeof $cc4ed71c4f27adbc$exports === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$3;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$3;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        this._activeTrigger.click = !this._activeTrigger.click;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $e9dd36436aec3b21$var$EventHandler.off(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute("data-bs-original-title")) this._element.setAttribute("title", this._element.getAttribute("data-bs-original-title"));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === "none") throw new Error("Please use show on visible elements");
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOW$2));
        const shadowRoot = $e9dd36436aec3b21$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute("aria-describedby", tip.getAttribute("id"));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.on(element, "mouseover", $e9dd36436aec3b21$var$noop);
        const complete = ()=>{
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ("ontouchstart" in document.documentElement) for (const element of [].concat(...document.body.children))$e9dd36436aec3b21$var$EventHandler.off(element, "mouseover", $e9dd36436aec3b21$var$noop);
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$e9dd36436aec3b21$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute("aria-describedby");
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_FADE$2, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $e9dd36436aec3b21$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute("id", tipId);
        if (this._isAnimated()) tip.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $e9dd36436aec3b21$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute("data-bs-original-title");
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $e9dd36436aec3b21$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $e9dd36436aec3b21$var$AttachmentMap[placement.toUpperCase()];
        return $cc4ed71c4f27adbc$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === "string") return offset.split(",").map((value)=>Number.parseInt(value, 10));
        if (typeof offset === "function") return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $e9dd36436aec3b21$var$execute(arg, [
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: "flip",
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: "offset",
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: "preventOverflow",
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: "arrow",
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: "preSetPlacement",
                    enabled: true,
                    phase: "beforeMain",
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute("data-popper-placement", data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$e9dd36436aec3b21$var$execute(this._config.popperConfig, [
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(" ");
        for (const trigger of triggers){
            if (trigger === "click") $e9dd36436aec3b21$var$EventHandler.on(this._element, this.constructor.eventName($e9dd36436aec3b21$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context.toggle();
            });
            else if (trigger !== $e9dd36436aec3b21$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSEENTER) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $e9dd36436aec3b21$var$TRIGGER_HOVER ? this.constructor.eventName($e9dd36436aec3b21$var$EVENT_MOUSELEAVE) : this.constructor.eventName($e9dd36436aec3b21$var$EVENT_FOCUSOUT$1);
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusin" ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $e9dd36436aec3b21$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === "focusout" ? $e9dd36436aec3b21$var$TRIGGER_FOCUS : $e9dd36436aec3b21$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $e9dd36436aec3b21$var$EventHandler.on(this._element.closest($e9dd36436aec3b21$var$SELECTOR_MODAL), $e9dd36436aec3b21$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute("title");
        if (!title) return;
        if (!this._element.getAttribute("aria-label") && !this._element.textContent.trim()) this._element.setAttribute("aria-label", title);
        this._element.setAttribute("data-bs-original-title", title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute("title");
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $e9dd36436aec3b21$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($e9dd36436aec3b21$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === "object" && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $e9dd36436aec3b21$var$getElement(config.container);
        if (typeof config.delay === "number") config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === "number") config.title = config.title.toString();
        if (typeof config.content === "number") config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = "manual";
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$3 = "popover";
const $e9dd36436aec3b21$var$SELECTOR_TITLE = ".popover-header";
const $e9dd36436aec3b21$var$SELECTOR_CONTENT = ".popover-body";
const $e9dd36436aec3b21$var$Default$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.Default,
    content: "",
    offset: [
        0,
        8
    ],
    placement: "right",
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: "click"
};
const $e9dd36436aec3b21$var$DefaultType$2 = {
    ...$e9dd36436aec3b21$export$28c660c63b792dea.DefaultType,
    content: "(null|string|element|function)"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$5b6b19405a83ff9d extends $e9dd36436aec3b21$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$2;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$2;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$e9dd36436aec3b21$var$SELECTOR_TITLE]: this._getTitle(),
            [$e9dd36436aec3b21$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$2 = "scrollspy";
const $e9dd36436aec3b21$var$DATA_KEY$2 = "bs.scrollspy";
const $e9dd36436aec3b21$var$EVENT_KEY$2 = `.${$e9dd36436aec3b21$var$DATA_KEY$2}`;
const $e9dd36436aec3b21$var$DATA_API_KEY = ".data-api";
const $e9dd36436aec3b21$var$EVENT_ACTIVATE = `activate${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_CLICK = `click${$e9dd36436aec3b21$var$EVENT_KEY$2}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1 = `load${$e9dd36436aec3b21$var$EVENT_KEY$2}${$e9dd36436aec3b21$var$DATA_API_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1 = "active";
const $e9dd36436aec3b21$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS = "[href]";
const $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
const $e9dd36436aec3b21$var$SELECTOR_NAV_LINKS = ".nav-link";
const $e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS = ".nav-item";
const $e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS = ".list-group-item";
const $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS = `${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_NAV_ITEMS} > ${$e9dd36436aec3b21$var$SELECTOR_NAV_LINKS}, ${$e9dd36436aec3b21$var$SELECTOR_LIST_ITEMS}`;
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN = ".dropdown";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
const $e9dd36436aec3b21$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "0px 0px -25%",
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $e9dd36436aec3b21$var$DefaultType$1 = {
    offset: "(number|null)",
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: "string",
    smoothScroll: "boolean",
    target: "element",
    threshold: "array"
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$a6472a5298a374be extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === "visible" ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default$1;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType$1;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $e9dd36436aec3b21$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === "string") config.threshold = config.threshold.split(",").map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $e9dd36436aec3b21$var$EventHandler.off(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK);
        $e9dd36436aec3b21$var$EventHandler.on(this._config.target, $e9dd36436aec3b21$var$EVENT_CLICK, $e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: "smooth"
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $e9dd36436aec3b21$var$isDisabled(anchor)) continue;
            const observableSection = $e9dd36436aec3b21$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($e9dd36436aec3b21$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($e9dd36436aec3b21$var$SELECTOR_DROPDOWN)).classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $e9dd36436aec3b21$var$SelectorEngine.parents(target, $e9dd36436aec3b21$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $e9dd36436aec3b21$var$SelectorEngine.prev(listGroup, $e9dd36436aec3b21$var$SELECTOR_LINK_ITEMS))item.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $e9dd36436aec3b21$var$SelectorEngine.find(`${$e9dd36436aec3b21$var$SELECTOR_TARGET_LINKS}.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_SPY))$e9dd36436aec3b21$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME$1 = "tab";
const $e9dd36436aec3b21$var$DATA_KEY$1 = "bs.tab";
const $e9dd36436aec3b21$var$EVENT_KEY$1 = `.${$e9dd36436aec3b21$var$DATA_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDE$1 = `hide${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN$1 = `hidden${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOW$1 = `show${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN$1 = `shown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API = `click${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_KEYDOWN = `keydown${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API = `load${$e9dd36436aec3b21$var$EVENT_KEY$1}`;
const $e9dd36436aec3b21$var$ARROW_LEFT_KEY = "ArrowLeft";
const $e9dd36436aec3b21$var$ARROW_RIGHT_KEY = "ArrowRight";
const $e9dd36436aec3b21$var$ARROW_UP_KEY = "ArrowUp";
const $e9dd36436aec3b21$var$ARROW_DOWN_KEY = "ArrowDown";
const $e9dd36436aec3b21$var$HOME_KEY = "Home";
const $e9dd36436aec3b21$var$END_KEY = "End";
const $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE = "active";
const $e9dd36436aec3b21$var$CLASS_NAME_FADE$1 = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1 = "show";
const $e9dd36436aec3b21$var$CLASS_DROPDOWN = "dropdown";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
const $e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
const $e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $e9dd36436aec3b21$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $e9dd36436aec3b21$var$SELECTOR_OUTER = ".nav-item, .list-group-item";
const $e9dd36436aec3b21$var$SELECTOR_INNER = `.nav-link${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$e9dd36436aec3b21$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $e9dd36436aec3b21$var$SELECTOR_INNER_ELEM = `${$e9dd36436aec3b21$var$SELECTOR_INNER}, ${$e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE}`;
const $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$e9dd36436aec3b21$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$3e41faf802a29e71 extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($e9dd36436aec3b21$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $e9dd36436aec3b21$var$EventHandler.trigger(active, $e9dd36436aec3b21$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(innerElem, $e9dd36436aec3b21$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        this._activate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute("tabindex");
            element.setAttribute("aria-selected", true);
            this._toggleDropDown(element, true);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute("role") !== "tab") {
                element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute("aria-selected", false);
            element.setAttribute("tabindex", "-1");
            this._toggleDropDown(element, false);
            $e9dd36436aec3b21$var$EventHandler.trigger(element, $e9dd36436aec3b21$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $e9dd36436aec3b21$var$ARROW_LEFT_KEY,
            $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
            $e9dd36436aec3b21$var$ARROW_UP_KEY,
            $e9dd36436aec3b21$var$ARROW_DOWN_KEY,
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$e9dd36436aec3b21$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $e9dd36436aec3b21$var$HOME_KEY,
            $e9dd36436aec3b21$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $e9dd36436aec3b21$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $e9dd36436aec3b21$var$ARROW_RIGHT_KEY,
                $e9dd36436aec3b21$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $e9dd36436aec3b21$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, "role", "tablist");
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute("aria-selected", isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
        if (!isActive) child.setAttribute("tabindex", "-1");
        this._setAttributeIfNotExists(child, "role", "tab");
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $e9dd36436aec3b21$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, "role", "tabpanel");
        if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($e9dd36436aec3b21$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $e9dd36436aec3b21$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_TOGGLE, $e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
        toggle($e9dd36436aec3b21$var$SELECTOR_DROPDOWN_MENU, $e9dd36436aec3b21$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute("aria-expanded", open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM) ? elem : $e9dd36436aec3b21$var$SelectorEngine.findOne($e9dd36436aec3b21$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($e9dd36436aec3b21$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== "string") return;
            if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$EventHandler.on(document, $e9dd36436aec3b21$var$EVENT_CLICK_DATA_API, $e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        "A",
        "AREA"
    ].includes(this.tagName)) event.preventDefault();
    if ($e9dd36436aec3b21$var$isDisabled(this)) return;
    $e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $e9dd36436aec3b21$var$EventHandler.on(window, $e9dd36436aec3b21$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $e9dd36436aec3b21$var$SelectorEngine.find($e9dd36436aec3b21$var$SELECTOR_DATA_TOGGLE_ACTIVE))$e9dd36436aec3b21$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $e9dd36436aec3b21$var$NAME = "toast";
const $e9dd36436aec3b21$var$DATA_KEY = "bs.toast";
const $e9dd36436aec3b21$var$EVENT_KEY = `.${$e9dd36436aec3b21$var$DATA_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOVER = `mouseover${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_MOUSEOUT = `mouseout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSIN = `focusin${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_FOCUSOUT = `focusout${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDE = `hide${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_HIDDEN = `hidden${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOW = `show${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$EVENT_SHOWN = `shown${$e9dd36436aec3b21$var$EVENT_KEY}`;
const $e9dd36436aec3b21$var$CLASS_NAME_FADE = "fade";
const $e9dd36436aec3b21$var$CLASS_NAME_HIDE = "hide"; // @deprecated - kept here only for backwards compatibility
const $e9dd36436aec3b21$var$CLASS_NAME_SHOW = "show";
const $e9dd36436aec3b21$var$CLASS_NAME_SHOWING = "showing";
const $e9dd36436aec3b21$var$DefaultType = {
    animation: "boolean",
    autohide: "boolean",
    delay: "number"
};
const $e9dd36436aec3b21$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $e9dd36436aec3b21$export$8d8dc7d5f743331b extends $e9dd36436aec3b21$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $e9dd36436aec3b21$var$Default;
    }
    static get DefaultType() {
        return $e9dd36436aec3b21$var$DefaultType;
    }
    static get NAME() {
        return $e9dd36436aec3b21$var$NAME;
    }
    // Public
    show() {
        const showEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
        $e9dd36436aec3b21$var$reflow(this._element);
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOW, $e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOWING, $e9dd36436aec3b21$var$CLASS_NAME_SHOW);
            $e9dd36436aec3b21$var$EventHandler.trigger(this._element, $e9dd36436aec3b21$var$EVENT_HIDDEN);
        };
        this._element.classList.add($e9dd36436aec3b21$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($e9dd36436aec3b21$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case "mouseover":
            case "mouseout":
                this._hasMouseInteraction = isInteracting;
                break;
            case "focusin":
            case "focusout":
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $e9dd36436aec3b21$var$EventHandler.on(this._element, $e9dd36436aec3b21$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $e9dd36436aec3b21$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === "string") {
                if (typeof data[config] === "undefined") throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $e9dd36436aec3b21$var$enableDismissTrigger($e9dd36436aec3b21$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $e9dd36436aec3b21$var$defineJQueryPlugin($e9dd36436aec3b21$export$8d8dc7d5f743331b);


/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ // (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
/* eslint-disable space-unary-ops */ /* Public constants ==========================================================*/ /* ===========================================================================*/ //const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const $2dd4f45c8894762f$var$Z_FIXED$1 = 4;
//const Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ const $2dd4f45c8894762f$var$Z_BINARY = 0;
const $2dd4f45c8894762f$var$Z_TEXT = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const $2dd4f45c8894762f$var$Z_UNKNOWN$1 = 2;
/*============================================================================*/ function $2dd4f45c8894762f$var$zero$1(buf) {
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
const $2dd4f45c8894762f$var$STORED_BLOCK = 0;
const $2dd4f45c8894762f$var$STATIC_TREES = 1;
const $2dd4f45c8894762f$var$DYN_TREES = 2;
/* The three kinds of block type */ const $2dd4f45c8894762f$var$MIN_MATCH$1 = 3;
const $2dd4f45c8894762f$var$MAX_MATCH$1 = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ const $2dd4f45c8894762f$var$LENGTH_CODES$1 = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2dd4f45c8894762f$var$LITERALS$1 = 256;
/* number of literal bytes 0..255 */ const $2dd4f45c8894762f$var$L_CODES$1 = $2dd4f45c8894762f$var$LITERALS$1 + 1 + $2dd4f45c8894762f$var$LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2dd4f45c8894762f$var$D_CODES$1 = 30;
/* number of distance codes */ const $2dd4f45c8894762f$var$BL_CODES$1 = 19;
/* number of codes used to transfer the bit lengths */ const $2dd4f45c8894762f$var$HEAP_SIZE$1 = 2 * $2dd4f45c8894762f$var$L_CODES$1 + 1;
/* maximum heap size */ const $2dd4f45c8894762f$var$MAX_BITS$1 = 15;
/* All codes must not exceed MAX_BITS bits */ const $2dd4f45c8894762f$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ const $2dd4f45c8894762f$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ const $2dd4f45c8894762f$var$END_BLOCK = 256;
/* end of block literal code */ const $2dd4f45c8894762f$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ const $2dd4f45c8894762f$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ const $2dd4f45c8894762f$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ const $2dd4f45c8894762f$var$extra_lbits = /* extra bits for each length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
]);
const $2dd4f45c8894762f$var$extra_dbits = /* extra bits for each distance code */ new Uint8Array([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
]);
const $2dd4f45c8894762f$var$extra_blbits = /* extra bits for each bit length code */ new Uint8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
]);
const $2dd4f45c8894762f$var$bl_order = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
const $2dd4f45c8894762f$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const $2dd4f45c8894762f$var$static_ltree = new Array(($2dd4f45c8894762f$var$L_CODES$1 + 2) * 2);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ const $2dd4f45c8894762f$var$static_dtree = new Array($2dd4f45c8894762f$var$D_CODES$1 * 2);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ const $2dd4f45c8894762f$var$_dist_code = new Array($2dd4f45c8894762f$var$DIST_CODE_LEN);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ const $2dd4f45c8894762f$var$_length_code = new Array($2dd4f45c8894762f$var$MAX_MATCH$1 - $2dd4f45c8894762f$var$MIN_MATCH$1 + 1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ const $2dd4f45c8894762f$var$base_length = new Array($2dd4f45c8894762f$var$LENGTH_CODES$1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ const $2dd4f45c8894762f$var$base_dist = new Array($2dd4f45c8894762f$var$D_CODES$1);
$2dd4f45c8894762f$var$zero$1($2dd4f45c8894762f$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $2dd4f45c8894762f$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
let $2dd4f45c8894762f$var$static_l_desc;
let $2dd4f45c8894762f$var$static_d_desc;
let $2dd4f45c8894762f$var$static_bl_desc;
function $2dd4f45c8894762f$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
const $2dd4f45c8894762f$var$d_code = (dist)=>{
    return dist < 256 ? $2dd4f45c8894762f$var$_dist_code[dist] : $2dd4f45c8894762f$var$_dist_code[256 + (dist >>> 7)];
};
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ const $2dd4f45c8894762f$var$put_short = (s, w)=>{
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
};
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ const $2dd4f45c8894762f$var$send_bits = (s, value, length)=>{
    if (s.bi_valid > $2dd4f45c8894762f$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $2dd4f45c8894762f$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $2dd4f45c8894762f$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
};
const $2dd4f45c8894762f$var$send_code = (s, c, tree)=>{
    $2dd4f45c8894762f$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
};
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ const $2dd4f45c8894762f$var$bi_reverse = (code, len)=>{
    let res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
};
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ const $2dd4f45c8894762f$var$bi_flush = (s)=>{
    if (s.bi_valid === 16) {
        $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
};
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ const $2dd4f45c8894762f$var$gen_bitlen = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc;    /* the tree descriptor */
    const tree = desc.dyn_tree;
    const max_code = desc.max_code;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const extra = desc.stat_desc.extra_bits;
    const base = desc.stat_desc.extra_base;
    const max_length = desc.stat_desc.max_length;
    let h; /* heap index */ 
    let n, m; /* iterate over the tree elements */ 
    let bits; /* bit length */ 
    let xbits; /* extra bits */ 
    let f; /* frequency */ 
    let overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $2dd4f45c8894762f$var$HEAP_SIZE$1; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Tracev((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
};
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ const $2dd4f45c8894762f$var$gen_codes = (tree, max_code, bl_count)=>{
    //    ct_data *tree;             /* the tree to decorate */
    //    int max_code;              /* largest code with non zero frequency */
    //    ushf *bl_count;            /* number of codes at each bit length */
    const next_code = new Array($2dd4f45c8894762f$var$MAX_BITS$1 + 1); /* next code value for each bit length */ 
    let code = 0; /* running code value */ 
    let bits; /* bit index */ 
    let n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++){
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
    }
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        let len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $2dd4f45c8894762f$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
};
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ const $2dd4f45c8894762f$var$tr_static_init = ()=>{
    let n; /* iterates over tree elements */ 
    let bits; /* bit counter */ 
    let length; /* length value */ 
    let code; /* code value */ 
    let dist; /* distance index */ 
    const bl_count = new Array($2dd4f45c8894762f$var$MAX_BITS$1 + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $2dd4f45c8894762f$var$LENGTH_CODES$1 - 1; code++){
        $2dd4f45c8894762f$var$base_length[code] = length;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_lbits[code]; n++)$2dd4f45c8894762f$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $2dd4f45c8894762f$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $2dd4f45c8894762f$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_dbits[code]; n++)$2dd4f45c8894762f$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $2dd4f45c8894762f$var$D_CODES$1; code++){
        $2dd4f45c8894762f$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $2dd4f45c8894762f$var$extra_dbits[code] - 7; n++)$2dd4f45c8894762f$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $2dd4f45c8894762f$var$MAX_BITS$1; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $2dd4f45c8894762f$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $2dd4f45c8894762f$var$gen_codes($2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$L_CODES$1 + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $2dd4f45c8894762f$var$D_CODES$1; n++){
        $2dd4f45c8894762f$var$static_dtree[n * 2 + 1] = 5;
        $2dd4f45c8894762f$var$static_dtree[n * 2] = $2dd4f45c8894762f$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $2dd4f45c8894762f$var$static_l_desc = new $2dd4f45c8894762f$var$StaticTreeDesc($2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$extra_lbits, $2dd4f45c8894762f$var$LITERALS$1 + 1, $2dd4f45c8894762f$var$L_CODES$1, $2dd4f45c8894762f$var$MAX_BITS$1);
    $2dd4f45c8894762f$var$static_d_desc = new $2dd4f45c8894762f$var$StaticTreeDesc($2dd4f45c8894762f$var$static_dtree, $2dd4f45c8894762f$var$extra_dbits, 0, $2dd4f45c8894762f$var$D_CODES$1, $2dd4f45c8894762f$var$MAX_BITS$1);
    $2dd4f45c8894762f$var$static_bl_desc = new $2dd4f45c8894762f$var$StaticTreeDesc(new Array(0), $2dd4f45c8894762f$var$extra_blbits, 0, $2dd4f45c8894762f$var$BL_CODES$1, $2dd4f45c8894762f$var$MAX_BL_BITS);
//static_init_done = true;
};
/* ===========================================================================
 * Initialize a new block.
 */ const $2dd4f45c8894762f$var$init_block = (s)=>{
    let n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $2dd4f45c8894762f$var$L_CODES$1; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $2dd4f45c8894762f$var$D_CODES$1; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $2dd4f45c8894762f$var$BL_CODES$1; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$2dd4f45c8894762f$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.sym_next = s.matches = 0;
};
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ const $2dd4f45c8894762f$var$bi_windup = (s)=>{
    if (s.bi_valid > 8) $2dd4f45c8894762f$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
};
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ const $2dd4f45c8894762f$var$smaller = (tree, n, m, depth)=>{
    const _n2 = n * 2;
    const _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
};
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ const $2dd4f45c8894762f$var$pqdownheap = (s, tree, k)=>{
    //    deflate_state *s;
    //    ct_data *tree;  /* the tree to restore */
    //    int k;               /* node to move down */
    const v = s.heap[k];
    let j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $2dd4f45c8894762f$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($2dd4f45c8894762f$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
};
// inlined manually
// const SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ const $2dd4f45c8894762f$var$compress_block = (s, ltree, dtree)=>{
    //    deflate_state *s;
    //    const ct_data *ltree; /* literal tree */
    //    const ct_data *dtree; /* distance tree */
    let dist; /* distance of matched string */ 
    let lc; /* match length or unmatched char (if dist == 0) */ 
    let sx = 0; /* running index in sym_buf */ 
    let code; /* the code to send */ 
    let extra; /* number of extra bits to send */ 
    if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
        dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) $2dd4f45c8894762f$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $2dd4f45c8894762f$var$_length_code[lc];
            $2dd4f45c8894762f$var$send_code(s, code + $2dd4f45c8894762f$var$LITERALS$1 + 1, ltree); /* send the length code */ 
            extra = $2dd4f45c8894762f$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $2dd4f45c8894762f$var$base_length[code];
                $2dd4f45c8894762f$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $2dd4f45c8894762f$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $2dd4f45c8894762f$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $2dd4f45c8894762f$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $2dd4f45c8894762f$var$base_dist[code];
                $2dd4f45c8894762f$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and sym_buf is ok: */ //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");
    }while (sx < s.sym_next);
    $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$END_BLOCK, ltree);
};
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ const $2dd4f45c8894762f$var$build_tree = (s, desc)=>{
    //    deflate_state *s;
    //    tree_desc *desc; /* the tree descriptor */
    const tree = desc.dyn_tree;
    const stree = desc.stat_desc.static_tree;
    const has_stree = desc.stat_desc.has_stree;
    const elems = desc.stat_desc.elems;
    let n, m; /* iterate over heap elements */ 
    let max_code = -1; /* largest code with non zero frequency */ 
    let node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $2dd4f45c8894762f$var$HEAP_SIZE$1;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$2dd4f45c8894762f$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $2dd4f45c8894762f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $2dd4f45c8894762f$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $2dd4f45c8894762f$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $2dd4f45c8894762f$var$gen_codes(tree, max_code, s.bl_count);
};
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ const $2dd4f45c8894762f$var$scan_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree;   /* the tree to be scanned */
    //    int max_code;    /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$2dd4f45c8894762f$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$2dd4f45c8894762f$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$2dd4f45c8894762f$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ const $2dd4f45c8894762f$var$send_tree = (s, tree, max_code)=>{
    //    deflate_state *s;
    //    ct_data *tree; /* the tree to be scanned */
    //    int max_code;       /* and its largest code of non zero frequency */
    let n; /* iterates over all tree elements */ 
    let prevlen = -1; /* last emitted length */ 
    let curlen; /* length of current code */ 
    let nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    let count = 0; /* repeat count of the current code */ 
    let max_count = 7; /* max repeat count */ 
    let min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $2dd4f45c8894762f$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $2dd4f45c8894762f$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REP_3_6, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REPZ_3_10, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 3, 3);
        } else {
            $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$REPZ_11_138, s.bl_tree);
            $2dd4f45c8894762f$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
};
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ const $2dd4f45c8894762f$var$build_bl_tree = (s)=>{
    let max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $2dd4f45c8894762f$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $2dd4f45c8894762f$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $2dd4f45c8894762f$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $2dd4f45c8894762f$var$BL_CODES$1 - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$2dd4f45c8894762f$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
};
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ const $2dd4f45c8894762f$var$send_all_trees = (s, lcodes, dcodes, blcodes)=>{
    //    deflate_state *s;
    //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
    let rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $2dd4f45c8894762f$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $2dd4f45c8894762f$var$send_bits(s, dcodes - 1, 5);
    $2dd4f45c8894762f$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $2dd4f45c8894762f$var$send_bits(s, s.bl_tree[$2dd4f45c8894762f$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $2dd4f45c8894762f$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $2dd4f45c8894762f$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ const $2dd4f45c8894762f$var$detect_data_type = (s)=>{
    /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ let block_mask = 0xf3ffc07f;
    let n;
    /* Check for non-textual ("block-listed") bytes. */ for(n = 0; n <= 31; n++, block_mask >>>= 1){
        if (block_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $2dd4f45c8894762f$var$Z_BINARY;
    }
    /* Check for textual ("allow-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $2dd4f45c8894762f$var$Z_TEXT;
    for(n = 32; n < $2dd4f45c8894762f$var$LITERALS$1; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $2dd4f45c8894762f$var$Z_TEXT;
    }
    /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $2dd4f45c8894762f$var$Z_BINARY;
};
let $2dd4f45c8894762f$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ const $2dd4f45c8894762f$var$_tr_init$1 = (s)=>{
    if (!$2dd4f45c8894762f$var$static_init_done) {
        $2dd4f45c8894762f$var$tr_static_init();
        $2dd4f45c8894762f$var$static_init_done = true;
    }
    s.l_desc = new $2dd4f45c8894762f$var$TreeDesc(s.dyn_ltree, $2dd4f45c8894762f$var$static_l_desc);
    s.d_desc = new $2dd4f45c8894762f$var$TreeDesc(s.dyn_dtree, $2dd4f45c8894762f$var$static_d_desc);
    s.bl_desc = new $2dd4f45c8894762f$var$TreeDesc(s.bl_tree, $2dd4f45c8894762f$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $2dd4f45c8894762f$var$init_block(s);
};
/* ===========================================================================
 * Send a stored block
 */ const $2dd4f45c8894762f$var$_tr_stored_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $2dd4f45c8894762f$var$bi_windup(s); /* align on byte boundary */ 
    $2dd4f45c8894762f$var$put_short(s, stored_len);
    $2dd4f45c8894762f$var$put_short(s, ~stored_len);
    if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
    s.pending += stored_len;
};
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ const $2dd4f45c8894762f$var$_tr_align$1 = (s)=>{
    $2dd4f45c8894762f$var$send_bits(s, $2dd4f45c8894762f$var$STATIC_TREES << 1, 3);
    $2dd4f45c8894762f$var$send_code(s, $2dd4f45c8894762f$var$END_BLOCK, $2dd4f45c8894762f$var$static_ltree);
    $2dd4f45c8894762f$var$bi_flush(s);
};
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */ const $2dd4f45c8894762f$var$_tr_flush_block$1 = (s, buf, stored_len, last)=>{
    //DeflateState *s;
    //charf *buf;       /* input block, or NULL if too old */
    //ulg stored_len;   /* length of input block */
    //int last;         /* one if this is the last block for a file */
    let opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    let max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $2dd4f45c8894762f$var$Z_UNKNOWN$1) s.strm.data_type = $2dd4f45c8894762f$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $2dd4f45c8894762f$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $2dd4f45c8894762f$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $2dd4f45c8894762f$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->sym_next / 3));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $2dd4f45c8894762f$var$_tr_stored_block$1(s, buf, stored_len, last);
    else if (s.strategy === $2dd4f45c8894762f$var$Z_FIXED$1 || static_lenb === opt_lenb) {
        $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $2dd4f45c8894762f$var$compress_block(s, $2dd4f45c8894762f$var$static_ltree, $2dd4f45c8894762f$var$static_dtree);
    } else {
        $2dd4f45c8894762f$var$send_bits(s, ($2dd4f45c8894762f$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $2dd4f45c8894762f$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $2dd4f45c8894762f$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $2dd4f45c8894762f$var$init_block(s);
    if (last) $2dd4f45c8894762f$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
};
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ const $2dd4f45c8894762f$var$_tr_tally$1 = (s, dist, lc)=>{
    //    deflate_state *s;
    //    unsigned dist;  /* distance of matched string */
    //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
    s.pending_buf[s.sym_buf + s.sym_next++] = dist;
    s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
    s.pending_buf[s.sym_buf + s.sym_next++] = lc;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($2dd4f45c8894762f$var$_length_code[lc] + $2dd4f45c8894762f$var$LITERALS$1 + 1) * 2]++;
        s.dyn_dtree[$2dd4f45c8894762f$var$d_code(dist) * 2]++;
    }
    return s.sym_next === s.sym_end;
};
var $2dd4f45c8894762f$var$_tr_init_1 = $2dd4f45c8894762f$var$_tr_init$1;
var $2dd4f45c8894762f$var$_tr_stored_block_1 = $2dd4f45c8894762f$var$_tr_stored_block$1;
var $2dd4f45c8894762f$var$_tr_flush_block_1 = $2dd4f45c8894762f$var$_tr_flush_block$1;
var $2dd4f45c8894762f$var$_tr_tally_1 = $2dd4f45c8894762f$var$_tr_tally$1;
var $2dd4f45c8894762f$var$_tr_align_1 = $2dd4f45c8894762f$var$_tr_align$1;
var $2dd4f45c8894762f$var$trees = {
    _tr_init: $2dd4f45c8894762f$var$_tr_init_1,
    _tr_stored_block: $2dd4f45c8894762f$var$_tr_stored_block_1,
    _tr_flush_block: $2dd4f45c8894762f$var$_tr_flush_block_1,
    _tr_tally: $2dd4f45c8894762f$var$_tr_tally_1,
    _tr_align: $2dd4f45c8894762f$var$_tr_align_1
};
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$adler32 = (adler, buf, len, pos)=>{
    let s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
};
var $2dd4f45c8894762f$var$adler32_1 = $2dd4f45c8894762f$var$adler32;
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
const $2dd4f45c8894762f$var$makeTable = ()=>{
    let c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
};
// Create table on load. Just 255 signed longs. Not a problem.
const $2dd4f45c8894762f$var$crcTable = new Uint32Array($2dd4f45c8894762f$var$makeTable());
const $2dd4f45c8894762f$var$crc32 = (crc, buf, len, pos)=>{
    const t = $2dd4f45c8894762f$var$crcTable;
    const end = pos + len;
    crc ^= -1;
    for(let i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
};
var $2dd4f45c8894762f$var$crc32_1 = $2dd4f45c8894762f$var$crc32;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2dd4f45c8894762f$var$messages = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
var $2dd4f45c8894762f$var$constants$2 = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    Z_MEM_ERROR: -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const { _tr_init: $2dd4f45c8894762f$var$_tr_init, _tr_stored_block: $2dd4f45c8894762f$var$_tr_stored_block, _tr_flush_block: $2dd4f45c8894762f$var$_tr_flush_block, _tr_tally: $2dd4f45c8894762f$var$_tr_tally, _tr_align: $2dd4f45c8894762f$var$_tr_align } = $2dd4f45c8894762f$var$trees;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH$2, Z_PARTIAL_FLUSH: $2dd4f45c8894762f$var$Z_PARTIAL_FLUSH, Z_FULL_FLUSH: $2dd4f45c8894762f$var$Z_FULL_FLUSH$1, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$3, Z_BLOCK: $2dd4f45c8894762f$var$Z_BLOCK$1, Z_OK: $2dd4f45c8894762f$var$Z_OK$3, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$3, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR$2, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR$2, Z_BUF_ERROR: $2dd4f45c8894762f$var$Z_BUF_ERROR$1, Z_DEFAULT_COMPRESSION: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION$1, Z_FILTERED: $2dd4f45c8894762f$var$Z_FILTERED, Z_HUFFMAN_ONLY: $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY, Z_RLE: $2dd4f45c8894762f$var$Z_RLE, Z_FIXED: $2dd4f45c8894762f$var$Z_FIXED, Z_DEFAULT_STRATEGY: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY$1, Z_UNKNOWN: $2dd4f45c8894762f$var$Z_UNKNOWN, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED$2 } = $2dd4f45c8894762f$var$constants$2;
/*============================================================================*/ const $2dd4f45c8894762f$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ const $2dd4f45c8894762f$var$MAX_WBITS$1 = 15;
/* 32K LZ77 window */ const $2dd4f45c8894762f$var$DEF_MEM_LEVEL = 8;
const $2dd4f45c8894762f$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ const $2dd4f45c8894762f$var$LITERALS = 256;
/* number of literal bytes 0..255 */ const $2dd4f45c8894762f$var$L_CODES = $2dd4f45c8894762f$var$LITERALS + 1 + $2dd4f45c8894762f$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ const $2dd4f45c8894762f$var$D_CODES = 30;
/* number of distance codes */ const $2dd4f45c8894762f$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ const $2dd4f45c8894762f$var$HEAP_SIZE = 2 * $2dd4f45c8894762f$var$L_CODES + 1;
/* maximum heap size */ const $2dd4f45c8894762f$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ const $2dd4f45c8894762f$var$MIN_MATCH = 3;
const $2dd4f45c8894762f$var$MAX_MATCH = 258;
const $2dd4f45c8894762f$var$MIN_LOOKAHEAD = $2dd4f45c8894762f$var$MAX_MATCH + $2dd4f45c8894762f$var$MIN_MATCH + 1;
const $2dd4f45c8894762f$var$PRESET_DICT = 0x20;
const $2dd4f45c8894762f$var$INIT_STATE = 42; /* zlib header -> BUSY_STATE */ 
//#ifdef GZIP
const $2dd4f45c8894762f$var$GZIP_STATE = 57; /* gzip header -> BUSY_STATE | EXTRA_STATE */ 
//#endif
const $2dd4f45c8894762f$var$EXTRA_STATE = 69; /* gzip extra block -> NAME_STATE */ 
const $2dd4f45c8894762f$var$NAME_STATE = 73; /* gzip file name -> COMMENT_STATE */ 
const $2dd4f45c8894762f$var$COMMENT_STATE = 91; /* gzip comment -> HCRC_STATE */ 
const $2dd4f45c8894762f$var$HCRC_STATE = 103; /* gzip header CRC -> BUSY_STATE */ 
const $2dd4f45c8894762f$var$BUSY_STATE = 113; /* deflate -> FINISH_STATE */ 
const $2dd4f45c8894762f$var$FINISH_STATE = 666; /* stream complete */ 
const $2dd4f45c8894762f$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
const $2dd4f45c8894762f$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
const $2dd4f45c8894762f$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
const $2dd4f45c8894762f$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
const $2dd4f45c8894762f$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
const $2dd4f45c8894762f$var$err = (strm, errorCode)=>{
    strm.msg = $2dd4f45c8894762f$var$messages[errorCode];
    return errorCode;
};
const $2dd4f45c8894762f$var$rank = (f)=>{
    return f * 2 - (f > 4 ? 9 : 0);
};
const $2dd4f45c8894762f$var$zero = (buf)=>{
    let len = buf.length;
    while(--len >= 0)buf[len] = 0;
};
/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */ const $2dd4f45c8894762f$var$slide_hash = (s)=>{
    let n, m;
    let p;
    let wsize = s.w_size;
    n = s.hash_size;
    p = n;
    do {
        m = s.head[--p];
        s.head[p] = m >= wsize ? m - wsize : 0;
    }while (--n);
    n = wsize;
    //#ifndef FASTEST
    p = n;
    do {
        m = s.prev[--p];
        s.prev[p] = m >= wsize ? m - wsize : 0;
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */ }while (--n);
//#endif
};
/* eslint-disable new-cap */ let $2dd4f45c8894762f$var$HASH_ZLIB = (s, prev, data)=>(prev << s.hash_shift ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let $2dd4f45c8894762f$var$HASH = $2dd4f45c8894762f$var$HASH_ZLIB;
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */ const $2dd4f45c8894762f$var$flush_pending = (strm)=>{
    const s = strm.state;
    //_tr_flush_bits(s);
    let len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
};
const $2dd4f45c8894762f$var$flush_block_only = (s, last)=>{
    $2dd4f45c8894762f$var$_tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $2dd4f45c8894762f$var$flush_pending(s.strm);
};
const $2dd4f45c8894762f$var$put_byte = (s, b)=>{
    s.pending_buf[s.pending++] = b;
};
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ const $2dd4f45c8894762f$var$putShortMSB = (s, b)=>{
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
};
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ const $2dd4f45c8894762f$var$read_buf = (strm, buf, start, size)=>{
    let len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
    if (strm.state.wrap === 1) strm.adler = $2dd4f45c8894762f$var$adler32_1(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
};
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ const $2dd4f45c8894762f$var$longest_match = (s, cur_match)=>{
    let chain_length = s.max_chain_length; /* max hash chain length */ 
    let scan = s.strstart; /* current string */ 
    let match; /* matched string */ 
    let len; /* length of current match */ 
    let best_len = s.prev_length; /* best match length so far */ 
    let nice_match = s.nice_match; /* stop if match long enough */ 
    const limit = s.strstart > s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    const _win = s.window; // shortcut
    const wmask = s.w_mask;
    const prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ const strend = s.strstart + $2dd4f45c8894762f$var$MAX_MATCH;
    let scan_end1 = _win[scan + best_len - 1];
    let scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $2dd4f45c8894762f$var$MAX_MATCH - (strend - scan);
        scan = strend - $2dd4f45c8894762f$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
};
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ const $2dd4f45c8894762f$var$fill_window = (s)=>{
    const _w_size = s.w_size;
    let n, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD)) {
            s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            if (s.insert > s.strstart) s.insert = s.strstart;
            $2dd4f45c8894762f$var$slide_hash(s);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $2dd4f45c8894762f$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $2dd4f45c8894762f$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + 1]);
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $2dd4f45c8894762f$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */ const $2dd4f45c8894762f$var$deflate_stored = (s, flush)=>{
    /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */ let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
    /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */ let len, left, have, last = 0;
    let used = s.strm.avail_in;
    do {
        /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */ len = 65535 /* MAX_STORED */ ; /* maximum deflate stored block length */ 
        have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
        if (s.strm.avail_out < have) break;
        /* maximum stored block length that will fit in avail_out: */ have = s.strm.avail_out - have;
        left = s.strstart - s.block_start; /* bytes left in window */ 
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in; /* limit len to the input */ 
        if (len > have) len = have; /* limit len to the output */ 
        /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */ if (len < min_block && (len === 0 && flush !== $2dd4f45c8894762f$var$Z_FINISH$3 || flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2 || len !== left + s.strm.avail_in)) break;
        /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */ last = flush === $2dd4f45c8894762f$var$Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
        $2dd4f45c8894762f$var$_tr_stored_block(s, 0, 0, last);
        /* Replace the lengths in the dummy stored block with len. */ s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        /* Write the stored block header bytes. */ $2dd4f45c8894762f$var$flush_pending(s.strm);
        //#ifdef ZLIB_DEBUG
        //    /* Update debugging counts for the data about to be copied. */
        //    s->compressed_len += len << 3;
        //    s->bits_sent += len << 3;
        //#endif
        /* Copy uncompressed bytes from the window to next_out. */ if (left) {
            if (left > len) left = len;
            //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
            s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
            s.strm.next_out += left;
            s.strm.avail_out -= left;
            s.strm.total_out += left;
            s.block_start += left;
            len -= left;
        }
        /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */ if (len) {
            $2dd4f45c8894762f$var$read_buf(s.strm, s.strm.output, s.strm.next_out, len);
            s.strm.next_out += len;
            s.strm.avail_out -= len;
            s.strm.total_out += len;
        }
    }while (last === 0);
    /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */ used -= s.strm.avail_in; /* number of input bytes directly copied */ 
    if (used) {
        /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */ if (used >= s.w_size) {
            s.matches = 2; /* clear hash */ 
            //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
            s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
            s.strstart = s.w_size;
            s.insert = s.strstart;
        } else {
            if (s.window_size - s.strstart <= used) {
                /* Slide the window down. */ s.strstart -= s.w_size;
                //zmemcpy(s->window, s->window + s->w_size, s->strstart);
                s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
                if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
                if (s.insert > s.strstart) s.insert = s.strstart;
            }
            //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
            s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
            s.strstart += used;
            s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* If the last block was written to next_out, then done. */ if (last) return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    /* If flushing and all input has been consumed, then done. */ if (flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && flush !== $2dd4f45c8894762f$var$Z_FINISH$3 && s.strm.avail_in === 0 && s.strstart === s.block_start) return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
    /* Fill the window with any remaining input. */ have = s.window_size - s.strstart;
    if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        /* Slide the window down. */ s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++; /* add a pending slide_hash() */ 
        have += s.w_size; /* more space now */ 
        if (s.insert > s.strstart) s.insert = s.strstart;
    }
    if (have > s.strm.avail_in) have = s.strm.avail_in;
    if (have) {
        $2dd4f45c8894762f$var$read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
    }
    if (s.high_water < s.strstart) s.high_water = s.strstart;
    /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */ have = s.bi_valid + 42 >> 3; /* number of header bytes */ 
    /* maximum stored block length that will fit in pending: */ have = s.pending_buf_size - have > 65535 /* MAX_STORED */  ? 65535 /* MAX_STORED */  : s.pending_buf_size - have;
    min_block = have > s.w_size ? s.w_size : have;
    left = s.strstart - s.block_start;
    if (left >= min_block || (left || flush === $2dd4f45c8894762f$var$Z_FINISH$3) && flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === $2dd4f45c8894762f$var$Z_FINISH$3 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        $2dd4f45c8894762f$var$_tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        $2dd4f45c8894762f$var$flush_pending(s.strm);
    }
    /* We've done all we can with the available input and output. */ return last ? $2dd4f45c8894762f$var$BS_FINISH_STARTED : $2dd4f45c8894762f$var$BS_NEED_MORE;
};
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ const $2dd4f45c8894762f$var$deflate_fast = (s, flush)=>{
    let hash_head; /* head of the hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2dd4f45c8894762f$var$longest_match(s, hash_head);
        if (s.match_length >= $2dd4f45c8894762f$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, s.strstart - s.match_start, s.match_length - $2dd4f45c8894762f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + 1]);
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $2dd4f45c8894762f$var$MIN_MATCH - 1 ? s.strstart : $2dd4f45c8894762f$var$MIN_MATCH - 1;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ const $2dd4f45c8894762f$var$deflate_slow = (s, flush)=>{
    let hash_head; /* head of hash chain */ 
    let bflush; /* set if current block must be flushed */ 
    let max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead < $2dd4f45c8894762f$var$MIN_LOOKAHEAD && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $2dd4f45c8894762f$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $2dd4f45c8894762f$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $2dd4f45c8894762f$var$Z_FILTERED || s.match_length === $2dd4f45c8894762f$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $2dd4f45c8894762f$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $2dd4f45c8894762f$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $2dd4f45c8894762f$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[s.strstart + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $2dd4f45c8894762f$var$MIN_MATCH - 1 ? s.strstart : $2dd4f45c8894762f$var$MIN_MATCH - 1;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ const $2dd4f45c8894762f$var$deflate_rle = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    let prev; /* byte at distance one to match */ 
    let scan, strend; /* scan goes up to strend for length of run */ 
    const _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $2dd4f45c8894762f$var$MAX_MATCH) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead <= $2dd4f45c8894762f$var$MAX_MATCH && flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $2dd4f45c8894762f$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $2dd4f45c8894762f$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $2dd4f45c8894762f$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 1, s.match_length - $2dd4f45c8894762f$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ const $2dd4f45c8894762f$var$deflate_huff = (s, flush)=>{
    let bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $2dd4f45c8894762f$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $2dd4f45c8894762f$var$Z_NO_FLUSH$2) return $2dd4f45c8894762f$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $2dd4f45c8894762f$var$_tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $2dd4f45c8894762f$var$Z_FINISH$3) {
        /*** FLUSH_BLOCK(s, 1); ***/ $2dd4f45c8894762f$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_FINISH_STARTED;
        /***/ return $2dd4f45c8894762f$var$BS_FINISH_DONE;
    }
    if (s.sym_next) {
        /*** FLUSH_BLOCK(s, 0); ***/ $2dd4f45c8894762f$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $2dd4f45c8894762f$var$BS_NEED_MORE;
    /***/ }
    return $2dd4f45c8894762f$var$BS_BLOCK_DONE;
};
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $2dd4f45c8894762f$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
const $2dd4f45c8894762f$var$configuration_table = [
    /*      good lazy nice chain */ new $2dd4f45c8894762f$var$Config(0, 0, 0, 0, $2dd4f45c8894762f$var$deflate_stored),
    /* 0 store only */ new $2dd4f45c8894762f$var$Config(4, 4, 8, 4, $2dd4f45c8894762f$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $2dd4f45c8894762f$var$Config(4, 5, 16, 8, $2dd4f45c8894762f$var$deflate_fast),
    /* 2 */ new $2dd4f45c8894762f$var$Config(4, 6, 32, 32, $2dd4f45c8894762f$var$deflate_fast),
    /* 3 */ new $2dd4f45c8894762f$var$Config(4, 4, 16, 16, $2dd4f45c8894762f$var$deflate_slow),
    /* 4 lazy matches */ new $2dd4f45c8894762f$var$Config(8, 16, 32, 32, $2dd4f45c8894762f$var$deflate_slow),
    /* 5 */ new $2dd4f45c8894762f$var$Config(8, 16, 128, 128, $2dd4f45c8894762f$var$deflate_slow),
    /* 6 */ new $2dd4f45c8894762f$var$Config(8, 32, 128, 256, $2dd4f45c8894762f$var$deflate_slow),
    /* 7 */ new $2dd4f45c8894762f$var$Config(32, 128, 258, 1024, $2dd4f45c8894762f$var$deflate_slow),
    /* 8 */ new $2dd4f45c8894762f$var$Config(32, 258, 258, 4096, $2dd4f45c8894762f$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ const $2dd4f45c8894762f$var$lm_init = (s)=>{
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $2dd4f45c8894762f$var$configuration_table[s.level].max_lazy;
    s.good_match = $2dd4f45c8894762f$var$configuration_table[s.level].good_length;
    s.nice_match = $2dd4f45c8894762f$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $2dd4f45c8894762f$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
};
function $2dd4f45c8894762f$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $2dd4f45c8894762f$var$Z_DEFLATED$2; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new Uint16Array($2dd4f45c8894762f$var$HEAP_SIZE * 2);
    this.dyn_dtree = new Uint16Array((2 * $2dd4f45c8894762f$var$D_CODES + 1) * 2);
    this.bl_tree = new Uint16Array((2 * $2dd4f45c8894762f$var$BL_CODES + 1) * 2);
    $2dd4f45c8894762f$var$zero(this.dyn_ltree);
    $2dd4f45c8894762f$var$zero(this.dyn_dtree);
    $2dd4f45c8894762f$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new Uint16Array($2dd4f45c8894762f$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new Uint16Array(2 * $2dd4f45c8894762f$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $2dd4f45c8894762f$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new Uint16Array(2 * $2dd4f45c8894762f$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $2dd4f45c8894762f$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.sym_buf = 0; /* buffer for distances and literals/lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.sym_next = 0; /* running index in sym_buf */ 
    this.sym_end = 0; /* symbol table full when sym_next reaches this */ 
    this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */ const $2dd4f45c8894762f$var$deflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const s = strm.state;
    if (!s || s.strm !== strm || s.status !== $2dd4f45c8894762f$var$INIT_STATE && //#ifdef GZIP
    s.status !== $2dd4f45c8894762f$var$GZIP_STATE && //#endif
    s.status !== $2dd4f45c8894762f$var$EXTRA_STATE && s.status !== $2dd4f45c8894762f$var$NAME_STATE && s.status !== $2dd4f45c8894762f$var$COMMENT_STATE && s.status !== $2dd4f45c8894762f$var$HCRC_STATE && s.status !== $2dd4f45c8894762f$var$BUSY_STATE && s.status !== $2dd4f45c8894762f$var$FINISH_STATE) return 1;
    return 0;
};
const $2dd4f45c8894762f$var$deflateResetKeep = (strm)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $2dd4f45c8894762f$var$Z_UNKNOWN;
    const s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = //#ifdef GZIP
    s.wrap === 2 ? $2dd4f45c8894762f$var$GZIP_STATE : //#endif
    s.wrap ? $2dd4f45c8894762f$var$INIT_STATE : $2dd4f45c8894762f$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = -2;
    $2dd4f45c8894762f$var$_tr_init(s);
    return $2dd4f45c8894762f$var$Z_OK$3;
};
const $2dd4f45c8894762f$var$deflateReset = (strm)=>{
    const ret = $2dd4f45c8894762f$var$deflateResetKeep(strm);
    if (ret === $2dd4f45c8894762f$var$Z_OK$3) $2dd4f45c8894762f$var$lm_init(strm.state);
    return ret;
};
const $2dd4f45c8894762f$var$deflateSetHeader = (strm, head)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm) || strm.state.wrap !== 2) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    strm.state.gzhead = head;
    return $2dd4f45c8894762f$var$Z_OK$3;
};
const $2dd4f45c8894762f$var$deflateInit2 = (strm, level, method, windowBits, memLevel, strategy)=>{
    if (!strm) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    let wrap = 1;
    if (level === $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION$1) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $2dd4f45c8894762f$var$MAX_MEM_LEVEL || method !== $2dd4f45c8894762f$var$Z_DEFLATED$2 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $2dd4f45c8894762f$var$Z_FIXED || windowBits === 8 && wrap !== 1) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ const s = new $2dd4f45c8894762f$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.status = $2dd4f45c8894762f$var$INIT_STATE; /* to pass state test in deflateReset() */ 
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $2dd4f45c8894762f$var$MIN_MATCH - 1) / $2dd4f45c8894762f$var$MIN_MATCH);
    s.window = new Uint8Array(s.w_size * 2);
    s.head = new Uint16Array(s.hash_size);
    s.prev = new Uint16Array(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */ s.pending_buf_size = s.lit_bufsize * 4;
    s.pending_buf = new Uint8Array(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->sym_buf = s->pending_buf + s->lit_bufsize;
    s.sym_buf = s.lit_bufsize;
    //s->sym_end = (s->lit_bufsize - 1) * 3;
    s.sym_end = (s.lit_bufsize - 1) * 3;
    /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $2dd4f45c8894762f$var$deflateReset(strm);
};
const $2dd4f45c8894762f$var$deflateInit = (strm, level)=>{
    return $2dd4f45c8894762f$var$deflateInit2(strm, level, $2dd4f45c8894762f$var$Z_DEFLATED$2, $2dd4f45c8894762f$var$MAX_WBITS$1, $2dd4f45c8894762f$var$DEF_MEM_LEVEL, $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY$1);
};
/* ========================================================================= */ const $2dd4f45c8894762f$var$deflate$2 = (strm, flush)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm) || flush > $2dd4f45c8894762f$var$Z_BLOCK$1 || flush < 0) return strm ? $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_STREAM_ERROR$2) : $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === $2dd4f45c8894762f$var$FINISH_STATE && flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$err(strm, strm.avail_out === 0 ? $2dd4f45c8894762f$var$Z_BUF_ERROR$1 : $2dd4f45c8894762f$var$Z_STREAM_ERROR$2);
    const old_flush = s.last_flush;
    s.last_flush = flush;
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $2dd4f45c8894762f$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $2dd4f45c8894762f$var$rank(flush) <= $2dd4f45c8894762f$var$rank(old_flush) && flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_BUF_ERROR$1);
    /* User must not provide more input after the first FINISH: */ if (s.status === $2dd4f45c8894762f$var$FINISH_STATE && strm.avail_in !== 0) return $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_BUF_ERROR$1);
    /* Write the header */ if (s.status === $2dd4f45c8894762f$var$INIT_STATE && s.wrap === 0) s.status = $2dd4f45c8894762f$var$BUSY_STATE;
    if (s.status === $2dd4f45c8894762f$var$INIT_STATE) {
        /* zlib header */ let header = $2dd4f45c8894762f$var$Z_DEFLATED$2 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header |= level_flags << 6;
        if (s.strstart !== 0) header |= $2dd4f45c8894762f$var$PRESET_DICT;
        header += 31 - header % 31;
        $2dd4f45c8894762f$var$putShortMSB(s, header);
        /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
            $2dd4f45c8894762f$var$putShortMSB(s, strm.adler >>> 16);
            $2dd4f45c8894762f$var$putShortMSB(s, strm.adler & 0xffff);
        }
        strm.adler = 1; // adler32(0L, Z_NULL, 0);
        s.status = $2dd4f45c8894762f$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    }
    //#ifdef GZIP
    if (s.status === $2dd4f45c8894762f$var$GZIP_STATE) {
        /* gzip header */ strm.adler = 0; //crc32(0L, Z_NULL, 0);
        $2dd4f45c8894762f$var$put_byte(s, 31);
        $2dd4f45c8894762f$var$put_byte(s, 139);
        $2dd4f45c8894762f$var$put_byte(s, 8);
        if (!s.gzhead) {
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, 0);
            $2dd4f45c8894762f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2dd4f45c8894762f$var$put_byte(s, $2dd4f45c8894762f$var$OS_CODE);
            s.status = $2dd4f45c8894762f$var$BUSY_STATE;
            /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
            if (s.pending !== 0) {
                s.last_flush = -1;
                return $2dd4f45c8894762f$var$Z_OK$3;
            }
        } else {
            $2dd4f45c8894762f$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
            $2dd4f45c8894762f$var$put_byte(s, s.gzhead.os & 0xff);
            if (s.gzhead.extra && s.gzhead.extra.length) {
                $2dd4f45c8894762f$var$put_byte(s, s.gzhead.extra.length & 0xff);
                $2dd4f45c8894762f$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
            }
            if (s.gzhead.hcrc) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending, 0);
            s.gzindex = 0;
            s.status = $2dd4f45c8894762f$var$EXTRA_STATE;
        }
    }
    if (s.status === $2dd4f45c8894762f$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
            while(s.pending + left > s.pending_buf_size){
                let copy = s.pending_buf_size - s.pending;
                // zmemcpy(s.pending_buf + s.pending,
                //    s.gzhead.extra + s.gzindex, copy);
                s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
                s.pending = s.pending_buf_size;
                //--- HCRC_UPDATE(beg) ---//
                if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                //---//
                s.gzindex += copy;
                $2dd4f45c8894762f$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2dd4f45c8894762f$var$Z_OK$3;
                }
                beg = 0;
                left -= copy;
            }
            // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
            //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
            let gzhead_extra = new Uint8Array(s.gzhead.extra);
            // zmemcpy(s->pending_buf + s->pending,
            //     s->gzhead->extra + s->gzindex, left);
            s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
            s.pending += left;
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2dd4f45c8894762f$var$NAME_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2dd4f45c8894762f$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2dd4f45c8894762f$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2dd4f45c8894762f$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
            //---//
            s.gzindex = 0;
        }
        s.status = $2dd4f45c8894762f$var$COMMENT_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            let beg = s.pending; /* start of bytes to update crc */ 
            let val;
            do {
                if (s.pending === s.pending_buf_size) {
                    //--- HCRC_UPDATE(beg) ---//
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
                    //---//
                    $2dd4f45c8894762f$var$flush_pending(strm);
                    if (s.pending !== 0) {
                        s.last_flush = -1;
                        return $2dd4f45c8894762f$var$Z_OK$3;
                    }
                    beg = 0;
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $2dd4f45c8894762f$var$put_byte(s, val);
            }while (val !== 0);
            //--- HCRC_UPDATE(beg) ---//
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $2dd4f45c8894762f$var$crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        //---//
        }
        s.status = $2dd4f45c8894762f$var$HCRC_STATE;
    }
    if (s.status === $2dd4f45c8894762f$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
                $2dd4f45c8894762f$var$flush_pending(strm);
                if (s.pending !== 0) {
                    s.last_flush = -1;
                    return $2dd4f45c8894762f$var$Z_OK$3;
                }
            }
            $2dd4f45c8894762f$var$put_byte(s, strm.adler & 0xff);
            $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 8 & 0xff);
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
        }
        s.status = $2dd4f45c8894762f$var$BUSY_STATE;
        /* Compression must start with an empty pending buffer */ $2dd4f45c8894762f$var$flush_pending(strm);
        if (s.pending !== 0) {
            s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        }
    }
    //#endif
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $2dd4f45c8894762f$var$Z_NO_FLUSH$2 && s.status !== $2dd4f45c8894762f$var$FINISH_STATE) {
        let bstate = s.level === 0 ? $2dd4f45c8894762f$var$deflate_stored(s, flush) : s.strategy === $2dd4f45c8894762f$var$Z_HUFFMAN_ONLY ? $2dd4f45c8894762f$var$deflate_huff(s, flush) : s.strategy === $2dd4f45c8894762f$var$Z_RLE ? $2dd4f45c8894762f$var$deflate_rle(s, flush) : $2dd4f45c8894762f$var$configuration_table[s.level].func(s, flush);
        if (bstate === $2dd4f45c8894762f$var$BS_FINISH_STARTED || bstate === $2dd4f45c8894762f$var$BS_FINISH_DONE) s.status = $2dd4f45c8894762f$var$FINISH_STATE;
        if (bstate === $2dd4f45c8894762f$var$BS_NEED_MORE || bstate === $2dd4f45c8894762f$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $2dd4f45c8894762f$var$Z_OK$3;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $2dd4f45c8894762f$var$BS_BLOCK_DONE) {
            if (flush === $2dd4f45c8894762f$var$Z_PARTIAL_FLUSH) $2dd4f45c8894762f$var$_tr_align(s);
            else if (flush !== $2dd4f45c8894762f$var$Z_BLOCK$1) {
                $2dd4f45c8894762f$var$_tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $2dd4f45c8894762f$var$Z_FULL_FLUSH$1) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $2dd4f45c8894762f$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $2dd4f45c8894762f$var$Z_OK$3;
            }
        }
    }
    if (flush !== $2dd4f45c8894762f$var$Z_FINISH$3) return $2dd4f45c8894762f$var$Z_OK$3;
    if (s.wrap <= 0) return $2dd4f45c8894762f$var$Z_STREAM_END$3;
    /* Write the trailer */ if (s.wrap === 2) {
        $2dd4f45c8894762f$var$put_byte(s, strm.adler & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 8 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 16 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.adler >> 24 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $2dd4f45c8894762f$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $2dd4f45c8894762f$var$putShortMSB(s, strm.adler >>> 16);
        $2dd4f45c8894762f$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $2dd4f45c8894762f$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $2dd4f45c8894762f$var$Z_OK$3 : $2dd4f45c8894762f$var$Z_STREAM_END$3;
};
const $2dd4f45c8894762f$var$deflateEnd = (strm)=>{
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const status = strm.state.status;
    strm.state = null;
    return status === $2dd4f45c8894762f$var$BUSY_STATE ? $2dd4f45c8894762f$var$err(strm, $2dd4f45c8894762f$var$Z_DATA_ERROR$2) : $2dd4f45c8894762f$var$Z_OK$3;
};
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ const $2dd4f45c8894762f$var$deflateSetDictionary = (strm, dictionary)=>{
    let dictLength = dictionary.length;
    if ($2dd4f45c8894762f$var$deflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    const s = strm.state;
    const wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $2dd4f45c8894762f$var$INIT_STATE || s.lookahead) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$2;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $2dd4f45c8894762f$var$adler32_1(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $2dd4f45c8894762f$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ const avail = strm.avail_in;
    const next = strm.next_in;
    const input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $2dd4f45c8894762f$var$fill_window(s);
    while(s.lookahead >= $2dd4f45c8894762f$var$MIN_MATCH){
        let str = s.strstart;
        let n = s.lookahead - ($2dd4f45c8894762f$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = $2dd4f45c8894762f$var$HASH(s, s.ins_h, s.window[str + $2dd4f45c8894762f$var$MIN_MATCH - 1]);
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $2dd4f45c8894762f$var$MIN_MATCH - 1;
        $2dd4f45c8894762f$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $2dd4f45c8894762f$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $2dd4f45c8894762f$var$Z_OK$3;
};
var $2dd4f45c8894762f$var$deflateInit_1 = $2dd4f45c8894762f$var$deflateInit;
var $2dd4f45c8894762f$var$deflateInit2_1 = $2dd4f45c8894762f$var$deflateInit2;
var $2dd4f45c8894762f$var$deflateReset_1 = $2dd4f45c8894762f$var$deflateReset;
var $2dd4f45c8894762f$var$deflateResetKeep_1 = $2dd4f45c8894762f$var$deflateResetKeep;
var $2dd4f45c8894762f$var$deflateSetHeader_1 = $2dd4f45c8894762f$var$deflateSetHeader;
var $2dd4f45c8894762f$var$deflate_2$1 = $2dd4f45c8894762f$var$deflate$2;
var $2dd4f45c8894762f$var$deflateEnd_1 = $2dd4f45c8894762f$var$deflateEnd;
var $2dd4f45c8894762f$var$deflateSetDictionary_1 = $2dd4f45c8894762f$var$deflateSetDictionary;
var $2dd4f45c8894762f$var$deflateInfo = "pako deflate (from Nodeca project)";
/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/ var $2dd4f45c8894762f$var$deflate_1$2 = {
    deflateInit: $2dd4f45c8894762f$var$deflateInit_1,
    deflateInit2: $2dd4f45c8894762f$var$deflateInit2_1,
    deflateReset: $2dd4f45c8894762f$var$deflateReset_1,
    deflateResetKeep: $2dd4f45c8894762f$var$deflateResetKeep_1,
    deflateSetHeader: $2dd4f45c8894762f$var$deflateSetHeader_1,
    deflate: $2dd4f45c8894762f$var$deflate_2$1,
    deflateEnd: $2dd4f45c8894762f$var$deflateEnd_1,
    deflateSetDictionary: $2dd4f45c8894762f$var$deflateSetDictionary_1,
    deflateInfo: $2dd4f45c8894762f$var$deflateInfo
};
const $2dd4f45c8894762f$var$_has = (obj, key)=>{
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var $2dd4f45c8894762f$var$assign = function(obj /*from1, from2, from3, ...*/ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        const source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(const p in source)if ($2dd4f45c8894762f$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// Join array of chunks to single array.
var $2dd4f45c8894762f$var$flattenChunks = (chunks)=>{
    // calculate data length
    let len = 0;
    for(let i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
    // join chunks
    const result = new Uint8Array(len);
    for(let i = 0, pos = 0, l = chunks.length; i < l; i++){
        let chunk = chunks[i];
        result.set(chunk, pos);
        pos += chunk.length;
    }
    return result;
};
var $2dd4f45c8894762f$var$common = {
    assign: $2dd4f45c8894762f$var$assign,
    flattenChunks: $2dd4f45c8894762f$var$flattenChunks
};
// String encode/decode helpers
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let $2dd4f45c8894762f$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $2dd4f45c8894762f$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const $2dd4f45c8894762f$var$_utf8len = new Uint8Array(256);
for(let q = 0; q < 256; q++)$2dd4f45c8894762f$var$_utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
$2dd4f45c8894762f$var$_utf8len[254] = $2dd4f45c8894762f$var$_utf8len[254] = 1; // Invalid sequence start
// convert string to array (typed, when possible)
var $2dd4f45c8894762f$var$string2buf = (str)=>{
    if (typeof TextEncoder === "function" && TextEncoder.prototype.encode) return new TextEncoder().encode(str);
    let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new Uint8Array(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper
const $2dd4f45c8894762f$var$buf2binstring = (buf, len)=>{
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $2dd4f45c8894762f$var$STR_APPLY_UIA_OK) return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
    let result = "";
    for(let i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
};
// convert array to string
var $2dd4f45c8894762f$var$buf2string = (buf, max)=>{
    const len = max || buf.length;
    if (typeof TextDecoder === "function" && TextDecoder.prototype.decode) return new TextDecoder().decode(buf.subarray(0, max));
    let i, out;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    const utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        let c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        let c_len = $2dd4f45c8894762f$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $2dd4f45c8894762f$var$buf2binstring(utf16buf, out);
};
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $2dd4f45c8894762f$var$utf8border = (buf, max)=>{
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    let pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $2dd4f45c8894762f$var$_utf8len[buf[pos]] > max ? pos : max;
};
var $2dd4f45c8894762f$var$strings = {
    string2buf: $2dd4f45c8894762f$var$string2buf,
    buf2string: $2dd4f45c8894762f$var$buf2string,
    utf8border: $2dd4f45c8894762f$var$utf8border
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2dd4f45c8894762f$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
var $2dd4f45c8894762f$var$zstream = $2dd4f45c8894762f$var$ZStream;
const $2dd4f45c8894762f$var$toString$1 = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH$1, Z_SYNC_FLUSH: $2dd4f45c8894762f$var$Z_SYNC_FLUSH, Z_FULL_FLUSH: $2dd4f45c8894762f$var$Z_FULL_FLUSH, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$2, Z_OK: $2dd4f45c8894762f$var$Z_OK$2, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$2, Z_DEFAULT_COMPRESSION: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION, Z_DEFAULT_STRATEGY: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED$1 } = $2dd4f45c8894762f$var$constants$2;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $2dd4f45c8894762f$var$Deflate$1(options) {
    this.options = $2dd4f45c8894762f$var$common.assign({
        level: $2dd4f45c8894762f$var$Z_DEFAULT_COMPRESSION,
        method: $2dd4f45c8894762f$var$Z_DEFLATED$1,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $2dd4f45c8894762f$var$Z_DEFAULT_STRATEGY
    }, options || {});
    let opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2dd4f45c8894762f$var$zstream();
    this.strm.avail_out = 0;
    let status = $2dd4f45c8894762f$var$deflate_1$2.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $2dd4f45c8894762f$var$Z_OK$2) throw new Error($2dd4f45c8894762f$var$messages[status]);
    if (opt.header) $2dd4f45c8894762f$var$deflate_1$2.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        let dict;
        // Convert data if needed
        if (typeof opt.dictionary === "string") // If we need to compress text, change encoding to utf8.
        dict = $2dd4f45c8894762f$var$strings.string2buf(opt.dictionary);
        else if ($2dd4f45c8894762f$var$toString$1.call(opt.dictionary) === "[object ArrayBuffer]") dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $2dd4f45c8894762f$var$deflate_1$2.deflateSetDictionary(this.strm, dict);
        if (status !== $2dd4f45c8894762f$var$Z_OK$2) throw new Error($2dd4f45c8894762f$var$messages[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    let status, _flush_mode;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2dd4f45c8894762f$var$Z_FINISH$2 : $2dd4f45c8894762f$var$Z_NO_FLUSH$1;
    // Convert data if needed
    if (typeof data === "string") // If we need to compress text, change encoding to utf8.
    strm.input = $2dd4f45c8894762f$var$strings.string2buf(data);
    else if ($2dd4f45c8894762f$var$toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        // Make sure avail_out > 6 to avoid repeating markers
        if ((_flush_mode === $2dd4f45c8894762f$var$Z_SYNC_FLUSH || _flush_mode === $2dd4f45c8894762f$var$Z_FULL_FLUSH) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        status = $2dd4f45c8894762f$var$deflate_1$2.deflate(strm, _flush_mode);
        // Ended => flush and finish
        if (status === $2dd4f45c8894762f$var$Z_STREAM_END$2) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = $2dd4f45c8894762f$var$deflate_1$2.deflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return status === $2dd4f45c8894762f$var$Z_OK$2;
        }
        // Flush if out buffer full
        if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
        }
        // Flush if requested and has data
        if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2dd4f45c8894762f$var$Deflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2dd4f45c8894762f$var$Z_OK$2) this.result = $2dd4f45c8894762f$var$common.flattenChunks(this.chunks);
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $2dd4f45c8894762f$var$deflate$1(input, options) {
    const deflator = new $2dd4f45c8894762f$var$Deflate$1(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $2dd4f45c8894762f$var$messages[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2dd4f45c8894762f$var$deflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2dd4f45c8894762f$var$deflate$1(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $2dd4f45c8894762f$var$gzip$1(input, options) {
    options = options || {};
    options.gzip = true;
    return $2dd4f45c8894762f$var$deflate$1(input, options);
}
var $2dd4f45c8894762f$var$Deflate_1$1 = $2dd4f45c8894762f$var$Deflate$1;
var $2dd4f45c8894762f$var$deflate_2 = $2dd4f45c8894762f$var$deflate$1;
var $2dd4f45c8894762f$var$deflateRaw_1$1 = $2dd4f45c8894762f$var$deflateRaw$1;
var $2dd4f45c8894762f$var$gzip_1$1 = $2dd4f45c8894762f$var$gzip$1;
var $2dd4f45c8894762f$var$constants$1 = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$var$deflate_1$1 = {
    Deflate: $2dd4f45c8894762f$var$Deflate_1$1,
    deflate: $2dd4f45c8894762f$var$deflate_2,
    deflateRaw: $2dd4f45c8894762f$var$deflateRaw_1$1,
    gzip: $2dd4f45c8894762f$var$gzip_1$1,
    constants: $2dd4f45c8894762f$var$constants$1
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
const $2dd4f45c8894762f$var$BAD$1 = 16209; /* got a data error -- remain here until reset */ 
const $2dd4f45c8894762f$var$TYPE$1 = 16191; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ var $2dd4f45c8894762f$var$inffast = function inflate_fast(strm, start) {
    let _in; /* local strm.input */ 
    let last; /* have enough input while in < last */ 
    let _out; /* local strm.output */ 
    let beg; /* inflate()'s initial strm.output */ 
    let end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    let dmax; /* maximum distance from zlib header */ 
    //#endif
    let wsize; /* window size or zero if not using window */ 
    let whave; /* valid bytes in the window */ 
    let wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    let s_window; /* allocated sliding window, if wsize != 0 */ 
    let hold; /* local strm.hold */ 
    let bits; /* local strm.bits */ 
    let lcode; /* local strm.lencode */ 
    let dcode; /* local strm.distcode */ 
    let lmask; /* mask for first level of length codes */ 
    let dmask; /* mask for first level of distance codes */ 
    let here; /* retrieved table entry */ 
    let op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ let len; /* match length, unused bytes */ 
    let dist; /* match distance */ 
    let from; /* where to copy match from */ 
    let from_source;
    let input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ const state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $2dd4f45c8894762f$var$BAD$1;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $2dd4f45c8894762f$var$BAD$1;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $2dd4f45c8894762f$var$BAD$1;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $2dd4f45c8894762f$var$TYPE$1;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $2dd4f45c8894762f$var$BAD$1;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$MAXBITS = 15;
const $2dd4f45c8894762f$var$ENOUGH_LENS$1 = 852;
const $2dd4f45c8894762f$var$ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
const $2dd4f45c8894762f$var$CODES$1 = 0;
const $2dd4f45c8894762f$var$LENS$1 = 1;
const $2dd4f45c8894762f$var$DISTS$1 = 2;
const $2dd4f45c8894762f$var$lbase = new Uint16Array([
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
]);
const $2dd4f45c8894762f$var$lext = new Uint8Array([
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
]);
const $2dd4f45c8894762f$var$dbase = new Uint16Array([
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
]);
const $2dd4f45c8894762f$var$dext = new Uint8Array([
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
]);
const $2dd4f45c8894762f$var$inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts)=>{
    const bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    let len = 0; /* a code's length in bits */ 
    let sym = 0; /* index of code symbols */ 
    let min = 0, max = 0; /* minimum and maximum code lengths */ 
    let root = 0; /* number of index bits for root table */ 
    let curr = 0; /* number of index bits for current table */ 
    let drop = 0; /* code bits to drop for sub-table */ 
    let left = 0; /* number of prefix codes available */ 
    let used = 0; /* code entries in table used */ 
    let huff = 0; /* Huffman code */ 
    let incr; /* for incrementing code, index */ 
    let fill; /* index for replicating entries */ 
    let low; /* low bits for current root entry */ 
    let mask; /* mask for low root bits */ 
    let next; /* next available space in table */ 
    let base = null; /* base value table to use */ 
    //  let shoextra;    /* extra bits table to use */
    let match; /* use base and extra for symbol >= match */ 
    const count = new Uint16Array($2dd4f45c8894762f$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    const offs = new Uint16Array($2dd4f45c8894762f$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    let extra = null;
    let here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $2dd4f45c8894762f$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $2dd4f45c8894762f$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $2dd4f45c8894762f$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $2dd4f45c8894762f$var$CODES$1 || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $2dd4f45c8894762f$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $2dd4f45c8894762f$var$CODES$1) {
        base = extra = work; /* dummy value--not used */ 
        match = 20;
    } else if (type === $2dd4f45c8894762f$var$LENS$1) {
        base = $2dd4f45c8894762f$var$lbase;
        extra = $2dd4f45c8894762f$var$lext;
        match = 257;
    } else {
        base = $2dd4f45c8894762f$var$dbase;
        extra = $2dd4f45c8894762f$var$dext;
        match = 0;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $2dd4f45c8894762f$var$LENS$1 && used > $2dd4f45c8894762f$var$ENOUGH_LENS$1 || type === $2dd4f45c8894762f$var$DISTS$1 && used > $2dd4f45c8894762f$var$ENOUGH_DISTS$1) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] + 1 < match) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] >= match) {
            here_op = extra[work[sym] - match];
            here_val = base[work[sym] - match];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $2dd4f45c8894762f$var$LENS$1 && used > $2dd4f45c8894762f$var$ENOUGH_LENS$1 || type === $2dd4f45c8894762f$var$DISTS$1 && used > $2dd4f45c8894762f$var$ENOUGH_DISTS$1) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};
var $2dd4f45c8894762f$var$inftrees = $2dd4f45c8894762f$var$inflate_table;
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
const $2dd4f45c8894762f$var$CODES = 0;
const $2dd4f45c8894762f$var$LENS = 1;
const $2dd4f45c8894762f$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH$1, Z_BLOCK: $2dd4f45c8894762f$var$Z_BLOCK, Z_TREES: $2dd4f45c8894762f$var$Z_TREES, Z_OK: $2dd4f45c8894762f$var$Z_OK$1, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END$1, Z_NEED_DICT: $2dd4f45c8894762f$var$Z_NEED_DICT$1, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR$1, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR$1, Z_MEM_ERROR: $2dd4f45c8894762f$var$Z_MEM_ERROR$1, Z_BUF_ERROR: $2dd4f45c8894762f$var$Z_BUF_ERROR, Z_DEFLATED: $2dd4f45c8894762f$var$Z_DEFLATED } = $2dd4f45c8894762f$var$constants$2;
/* STATES ====================================================================*/ /* ===========================================================================*/ const $2dd4f45c8894762f$var$HEAD = 16180; /* i: waiting for magic header */ 
const $2dd4f45c8894762f$var$FLAGS = 16181; /* i: waiting for method and flags (gzip) */ 
const $2dd4f45c8894762f$var$TIME = 16182; /* i: waiting for modification time (gzip) */ 
const $2dd4f45c8894762f$var$OS = 16183; /* i: waiting for extra flags and operating system (gzip) */ 
const $2dd4f45c8894762f$var$EXLEN = 16184; /* i: waiting for extra length (gzip) */ 
const $2dd4f45c8894762f$var$EXTRA = 16185; /* i: waiting for extra bytes (gzip) */ 
const $2dd4f45c8894762f$var$NAME = 16186; /* i: waiting for end of file name (gzip) */ 
const $2dd4f45c8894762f$var$COMMENT = 16187; /* i: waiting for end of comment (gzip) */ 
const $2dd4f45c8894762f$var$HCRC = 16188; /* i: waiting for header crc (gzip) */ 
const $2dd4f45c8894762f$var$DICTID = 16189; /* i: waiting for dictionary check value */ 
const $2dd4f45c8894762f$var$DICT = 16190; /* waiting for inflateSetDictionary() call */ 
const $2dd4f45c8894762f$var$TYPE = 16191; /* i: waiting for type bits, including last-flag bit */ 
const $2dd4f45c8894762f$var$TYPEDO = 16192; /* i: same, but skip check to exit inflate on new block */ 
const $2dd4f45c8894762f$var$STORED = 16193; /* i: waiting for stored size (length and complement) */ 
const $2dd4f45c8894762f$var$COPY_ = 16194; /* i/o: same as COPY below, but only first time in */ 
const $2dd4f45c8894762f$var$COPY = 16195; /* i/o: waiting for input or output to copy stored block */ 
const $2dd4f45c8894762f$var$TABLE = 16196; /* i: waiting for dynamic block table lengths */ 
const $2dd4f45c8894762f$var$LENLENS = 16197; /* i: waiting for code length code lengths */ 
const $2dd4f45c8894762f$var$CODELENS = 16198; /* i: waiting for length/lit and distance code lengths */ 
const $2dd4f45c8894762f$var$LEN_ = 16199; /* i: same as LEN below, but only first time in */ 
const $2dd4f45c8894762f$var$LEN = 16200; /* i: waiting for length/lit/eob code */ 
const $2dd4f45c8894762f$var$LENEXT = 16201; /* i: waiting for length extra bits */ 
const $2dd4f45c8894762f$var$DIST = 16202; /* i: waiting for distance code */ 
const $2dd4f45c8894762f$var$DISTEXT = 16203; /* i: waiting for distance extra bits */ 
const $2dd4f45c8894762f$var$MATCH = 16204; /* o: waiting for output space to copy string */ 
const $2dd4f45c8894762f$var$LIT = 16205; /* o: waiting for output space to write literal */ 
const $2dd4f45c8894762f$var$CHECK = 16206; /* i: waiting for 32-bit check value */ 
const $2dd4f45c8894762f$var$LENGTH = 16207; /* i: waiting for 32-bit length (gzip) */ 
const $2dd4f45c8894762f$var$DONE = 16208; /* finished check, done -- remain here until reset */ 
const $2dd4f45c8894762f$var$BAD = 16209; /* got a data error -- remain here until reset */ 
const $2dd4f45c8894762f$var$MEM = 16210; /* got an inflate() memory error -- remain here until reset */ 
const $2dd4f45c8894762f$var$SYNC = 16211; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ const $2dd4f45c8894762f$var$ENOUGH_LENS = 852;
const $2dd4f45c8894762f$var$ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
const $2dd4f45c8894762f$var$MAX_WBITS = 15;
/* 32K LZ77 window */ const $2dd4f45c8894762f$var$DEF_WBITS = $2dd4f45c8894762f$var$MAX_WBITS;
const $2dd4f45c8894762f$var$zswap32 = (q)=>{
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
};
function $2dd4f45c8894762f$var$InflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new Uint16Array(320); /* temporary storage for code lengths */ 
    this.work = new Uint16Array(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
const $2dd4f45c8894762f$var$inflateStateCheck = (strm)=>{
    if (!strm) return 1;
    const state = strm.state;
    if (!state || state.strm !== strm || state.mode < $2dd4f45c8894762f$var$HEAD || state.mode > $2dd4f45c8894762f$var$SYNC) return 1;
    return 0;
};
const $2dd4f45c8894762f$var$inflateResetKeep = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $2dd4f45c8894762f$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.flags = -1;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new Int32Array($2dd4f45c8894762f$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new Int32Array($2dd4f45c8894762f$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateReset = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $2dd4f45c8894762f$var$inflateResetKeep(strm);
};
const $2dd4f45c8894762f$var$inflateReset2 = (strm, windowBits)=>{
    let wrap;
    /* get the state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $2dd4f45c8894762f$var$inflateReset(strm);
};
const $2dd4f45c8894762f$var$inflateInit2 = (strm, windowBits)=>{
    if (!strm) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    const state = new $2dd4f45c8894762f$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.strm = strm;
    state.window = null /*Z_NULL*/ ;
    state.mode = $2dd4f45c8894762f$var$HEAD; /* to pass state test in inflateReset2() */ 
    const ret = $2dd4f45c8894762f$var$inflateReset2(strm, windowBits);
    if (ret !== $2dd4f45c8894762f$var$Z_OK$1) strm.state = null /*Z_NULL*/ ;
    return ret;
};
const $2dd4f45c8894762f$var$inflateInit = (strm)=>{
    return $2dd4f45c8894762f$var$inflateInit2(strm, $2dd4f45c8894762f$var$DEF_WBITS);
};
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ let $2dd4f45c8894762f$var$virgin = true;
let $2dd4f45c8894762f$var$lenfix, $2dd4f45c8894762f$var$distfix; // We have no pointers in JS, so keep tables separate
const $2dd4f45c8894762f$var$fixedtables = (state)=>{
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($2dd4f45c8894762f$var$virgin) {
        $2dd4f45c8894762f$var$lenfix = new Int32Array(512);
        $2dd4f45c8894762f$var$distfix = new Int32Array(32);
        /* literal/length table */ let sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$LENS, state.lens, 0, 288, $2dd4f45c8894762f$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$DISTS, state.lens, 0, 32, $2dd4f45c8894762f$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $2dd4f45c8894762f$var$virgin = false;
    }
    state.lencode = $2dd4f45c8894762f$var$lenfix;
    state.lenbits = 9;
    state.distcode = $2dd4f45c8894762f$var$distfix;
    state.distbits = 5;
};
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ const $2dd4f45c8894762f$var$updatewindow = (strm, src, end, copy)=>{
    let dist;
    const state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new Uint8Array(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            state.window.set(src.subarray(end - copy, end), 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
};
const $2dd4f45c8894762f$var$inflate$2 = (strm, flush)=>{
    let state;
    let input, output; // input/output buffers
    let next; /* next input INDEX */ 
    let put; /* next output INDEX */ 
    let have, left; /* available input and output */ 
    let hold; /* bit buffer */ 
    let bits; /* bits in bit buffer */ 
    let _in, _out; /* save starting available input and output */ 
    let copy; /* number of stored or match bytes to copy */ 
    let from; /* where to copy match bytes from */ 
    let from_source;
    let here = 0; /* current decoding table entry */ 
    let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //let last;                   /* parent table entry */
    let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    let len; /* length to copy for repeats, bits to drop */ 
    let ret; /* return code */ 
    const hbuf = new Uint8Array(4); /* buffer for gzip header crc calculation */ 
    let opts;
    let n; // temporary variable for NEED_BITS
    const order = /* permutation of code lengths */ new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ]);
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.mode === $2dd4f45c8894762f$var$TYPE) state.mode = $2dd4f45c8894762f$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $2dd4f45c8894762f$var$Z_OK$1;
    inf_leave: for(;;)switch(state.mode){
        case $2dd4f45c8894762f$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $2dd4f45c8894762f$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                if (state.wbits === 0) state.wbits = 15;
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $2dd4f45c8894762f$var$FLAGS;
                break;
            }
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $2dd4f45c8894762f$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            if (len > 15 || len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            // !!! pako patch. Force use `options.windowBits` if passed.
            // Required to always use max window size by default.
            state.dmax = 1 << state.wbits;
            //state.dmax = 1 << len;
            state.flags = 0; /* indicate zlib header */ 
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $2dd4f45c8894762f$var$DICTID : $2dd4f45c8894762f$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $2dd4f45c8894762f$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $2dd4f45c8894762f$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$TIME;
        /* falls through */ case $2dd4f45c8894762f$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$OS;
        /* falls through */ case $2dd4f45c8894762f$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200 && state.wrap & 4) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$EXLEN;
        /* falls through */ case $2dd4f45c8894762f$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200 && state.wrap & 4) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $2dd4f45c8894762f$var$crc32_1(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $2dd4f45c8894762f$var$EXTRA;
        /* falls through */ case $2dd4f45c8894762f$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Uint8Array(state.head.extra_len);
                        state.head.extra.set(input.subarray(next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        next + copy), /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $2dd4f45c8894762f$var$NAME;
        /* falls through */ case $2dd4f45c8894762f$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $2dd4f45c8894762f$var$COMMENT;
        /* falls through */ case $2dd4f45c8894762f$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200 && state.wrap & 4) state.check = $2dd4f45c8894762f$var$crc32_1(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $2dd4f45c8894762f$var$HCRC;
        /* falls through */ case $2dd4f45c8894762f$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $2dd4f45c8894762f$var$TYPE;
            break;
        case $2dd4f45c8894762f$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $2dd4f45c8894762f$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$DICT;
        /* falls through */ case $2dd4f45c8894762f$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $2dd4f45c8894762f$var$Z_NEED_DICT$1;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $2dd4f45c8894762f$var$TYPE;
        /* falls through */ case $2dd4f45c8894762f$var$TYPE:
            if (flush === $2dd4f45c8894762f$var$Z_BLOCK || flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $2dd4f45c8894762f$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $2dd4f45c8894762f$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$LEN_; /* decode codes */ 
                    if (flush === $2dd4f45c8894762f$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $2dd4f45c8894762f$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $2dd4f45c8894762f$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $2dd4f45c8894762f$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $2dd4f45c8894762f$var$COPY_;
            if (flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$COPY_:
            state.mode = $2dd4f45c8894762f$var$COPY;
        /* falls through */ case $2dd4f45c8894762f$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                output.set(input.subarray(next, next + copy), put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $2dd4f45c8894762f$var$TYPE;
            break;
        case $2dd4f45c8894762f$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $2dd4f45c8894762f$var$LENLENS;
        /* falls through */ case $2dd4f45c8894762f$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $2dd4f45c8894762f$var$CODELENS;
        /* falls through */ case $2dd4f45c8894762f$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $2dd4f45c8894762f$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $2dd4f45c8894762f$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $2dd4f45c8894762f$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $2dd4f45c8894762f$var$inftrees($2dd4f45c8894762f$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $2dd4f45c8894762f$var$LEN_;
            if (flush === $2dd4f45c8894762f$var$Z_TREES) break inf_leave;
        /* falls through */ case $2dd4f45c8894762f$var$LEN_:
            state.mode = $2dd4f45c8894762f$var$LEN;
        /* falls through */ case $2dd4f45c8894762f$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $2dd4f45c8894762f$var$inffast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $2dd4f45c8894762f$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $2dd4f45c8894762f$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $2dd4f45c8894762f$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $2dd4f45c8894762f$var$LENEXT;
        /* falls through */ case $2dd4f45c8894762f$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $2dd4f45c8894762f$var$DIST;
        /* falls through */ case $2dd4f45c8894762f$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $2dd4f45c8894762f$var$DISTEXT;
        /* falls through */ case $2dd4f45c8894762f$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $2dd4f45c8894762f$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $2dd4f45c8894762f$var$MATCH;
        /* falls through */ case $2dd4f45c8894762f$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $2dd4f45c8894762f$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $2dd4f45c8894762f$var$LEN;
            break;
        case $2dd4f45c8894762f$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $2dd4f45c8894762f$var$LEN;
            break;
        case $2dd4f45c8894762f$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/ state.flags ? $2dd4f45c8894762f$var$crc32_1(state.check, output, _out, put - _out) : $2dd4f45c8894762f$var$adler32_1(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if (state.wrap & 4 && (state.flags ? hold : $2dd4f45c8894762f$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $2dd4f45c8894762f$var$LENGTH;
        /* falls through */ case $2dd4f45c8894762f$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (state.wrap & 4 && hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $2dd4f45c8894762f$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $2dd4f45c8894762f$var$DONE;
        /* falls through */ case $2dd4f45c8894762f$var$DONE:
            ret = $2dd4f45c8894762f$var$Z_STREAM_END$1;
            break inf_leave;
        case $2dd4f45c8894762f$var$BAD:
            ret = $2dd4f45c8894762f$var$Z_DATA_ERROR$1;
            break inf_leave;
        case $2dd4f45c8894762f$var$MEM:
            return $2dd4f45c8894762f$var$Z_MEM_ERROR$1;
        case $2dd4f45c8894762f$var$SYNC:
        /* falls through */ default:
            return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $2dd4f45c8894762f$var$BAD && (state.mode < $2dd4f45c8894762f$var$CHECK || flush !== $2dd4f45c8894762f$var$Z_FINISH$1)) $2dd4f45c8894762f$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out);
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap & 4 && _out) strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/ state.flags ? $2dd4f45c8894762f$var$crc32_1(state.check, output, _out, strm.next_out - _out) : $2dd4f45c8894762f$var$adler32_1(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $2dd4f45c8894762f$var$TYPE ? 128 : 0) + (state.mode === $2dd4f45c8894762f$var$LEN_ || state.mode === $2dd4f45c8894762f$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $2dd4f45c8894762f$var$Z_FINISH$1) && ret === $2dd4f45c8894762f$var$Z_OK$1) ret = $2dd4f45c8894762f$var$Z_BUF_ERROR;
    return ret;
};
const $2dd4f45c8894762f$var$inflateEnd = (strm)=>{
    if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    let state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateGetHeader = (strm, head)=>{
    /* check state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    const state = strm.state;
    if ((state.wrap & 2) === 0) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    /* save header structure */ state.head = head;
    head.done = false;
    return $2dd4f45c8894762f$var$Z_OK$1;
};
const $2dd4f45c8894762f$var$inflateSetDictionary = (strm, dictionary)=>{
    const dictLength = dictionary.length;
    let state;
    let dictid;
    let ret;
    /* check state */ if ($2dd4f45c8894762f$var$inflateStateCheck(strm)) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $2dd4f45c8894762f$var$DICT) return $2dd4f45c8894762f$var$Z_STREAM_ERROR$1;
    /* check for correct dictionary identifier */ if (state.mode === $2dd4f45c8894762f$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $2dd4f45c8894762f$var$adler32_1(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $2dd4f45c8894762f$var$Z_DATA_ERROR$1;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $2dd4f45c8894762f$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $2dd4f45c8894762f$var$MEM;
        return $2dd4f45c8894762f$var$Z_MEM_ERROR$1;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $2dd4f45c8894762f$var$Z_OK$1;
};
var $2dd4f45c8894762f$var$inflateReset_1 = $2dd4f45c8894762f$var$inflateReset;
var $2dd4f45c8894762f$var$inflateReset2_1 = $2dd4f45c8894762f$var$inflateReset2;
var $2dd4f45c8894762f$var$inflateResetKeep_1 = $2dd4f45c8894762f$var$inflateResetKeep;
var $2dd4f45c8894762f$var$inflateInit_1 = $2dd4f45c8894762f$var$inflateInit;
var $2dd4f45c8894762f$var$inflateInit2_1 = $2dd4f45c8894762f$var$inflateInit2;
var $2dd4f45c8894762f$var$inflate_2$1 = $2dd4f45c8894762f$var$inflate$2;
var $2dd4f45c8894762f$var$inflateEnd_1 = $2dd4f45c8894762f$var$inflateEnd;
var $2dd4f45c8894762f$var$inflateGetHeader_1 = $2dd4f45c8894762f$var$inflateGetHeader;
var $2dd4f45c8894762f$var$inflateSetDictionary_1 = $2dd4f45c8894762f$var$inflateSetDictionary;
var $2dd4f45c8894762f$var$inflateInfo = "pako inflate (from Nodeca project)";
/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/ var $2dd4f45c8894762f$var$inflate_1$2 = {
    inflateReset: $2dd4f45c8894762f$var$inflateReset_1,
    inflateReset2: $2dd4f45c8894762f$var$inflateReset2_1,
    inflateResetKeep: $2dd4f45c8894762f$var$inflateResetKeep_1,
    inflateInit: $2dd4f45c8894762f$var$inflateInit_1,
    inflateInit2: $2dd4f45c8894762f$var$inflateInit2_1,
    inflate: $2dd4f45c8894762f$var$inflate_2$1,
    inflateEnd: $2dd4f45c8894762f$var$inflateEnd_1,
    inflateGetHeader: $2dd4f45c8894762f$var$inflateGetHeader_1,
    inflateSetDictionary: $2dd4f45c8894762f$var$inflateSetDictionary_1,
    inflateInfo: $2dd4f45c8894762f$var$inflateInfo
};
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $2dd4f45c8894762f$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = "";
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = "";
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
var $2dd4f45c8894762f$var$gzheader = $2dd4f45c8894762f$var$GZheader;
const $2dd4f45c8894762f$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ const { Z_NO_FLUSH: $2dd4f45c8894762f$var$Z_NO_FLUSH, Z_FINISH: $2dd4f45c8894762f$var$Z_FINISH, Z_OK: $2dd4f45c8894762f$var$Z_OK, Z_STREAM_END: $2dd4f45c8894762f$var$Z_STREAM_END, Z_NEED_DICT: $2dd4f45c8894762f$var$Z_NEED_DICT, Z_STREAM_ERROR: $2dd4f45c8894762f$var$Z_STREAM_ERROR, Z_DATA_ERROR: $2dd4f45c8894762f$var$Z_DATA_ERROR, Z_MEM_ERROR: $2dd4f45c8894762f$var$Z_MEM_ERROR } = $2dd4f45c8894762f$var$constants$2;
/* ===========================================================================*/ /**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2dd4f45c8894762f$var$Inflate$1(options) {
    this.options = $2dd4f45c8894762f$var$common.assign({
        chunkSize: 65536,
        windowBits: 15,
        to: ""
    }, options || {});
    const opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ""; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $2dd4f45c8894762f$var$zstream();
    this.strm.avail_out = 0;
    let status = $2dd4f45c8894762f$var$inflate_1$2.inflateInit2(this.strm, opt.windowBits);
    if (status !== $2dd4f45c8894762f$var$Z_OK) throw new Error($2dd4f45c8894762f$var$messages[status]);
    this.header = new $2dd4f45c8894762f$var$gzheader();
    $2dd4f45c8894762f$var$inflate_1$2.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === "string") opt.dictionary = $2dd4f45c8894762f$var$strings.string2buf(opt.dictionary);
        else if ($2dd4f45c8894762f$var$toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $2dd4f45c8894762f$var$Z_OK) throw new Error($2dd4f45c8894762f$var$messages[status]);
        }
    }
}
/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.push = function(data, flush_mode) {
    const strm = this.strm;
    const chunkSize = this.options.chunkSize;
    const dictionary = this.options.dictionary;
    let status, _flush_mode, last_avail_out;
    if (this.ended) return false;
    if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
    else _flush_mode = flush_mode === true ? $2dd4f45c8894762f$var$Z_FINISH : $2dd4f45c8894762f$var$Z_NO_FLUSH;
    // Convert data if needed
    if ($2dd4f45c8894762f$var$toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    for(;;){
        if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
        if (status === $2dd4f45c8894762f$var$Z_NEED_DICT && dictionary) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateSetDictionary(strm, dictionary);
            if (status === $2dd4f45c8894762f$var$Z_OK) status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
            else if (status === $2dd4f45c8894762f$var$Z_DATA_ERROR) // Replace code with more verbose
            status = $2dd4f45c8894762f$var$Z_NEED_DICT;
        }
        // Skip snyc markers if more data follows and not raw mode
        while(strm.avail_in > 0 && status === $2dd4f45c8894762f$var$Z_STREAM_END && strm.state.wrap > 0 && data[strm.next_in] !== 0){
            $2dd4f45c8894762f$var$inflate_1$2.inflateReset(strm);
            status = $2dd4f45c8894762f$var$inflate_1$2.inflate(strm, _flush_mode);
        }
        switch(status){
            case $2dd4f45c8894762f$var$Z_STREAM_ERROR:
            case $2dd4f45c8894762f$var$Z_DATA_ERROR:
            case $2dd4f45c8894762f$var$Z_NEED_DICT:
            case $2dd4f45c8894762f$var$Z_MEM_ERROR:
                this.onEnd(status);
                this.ended = true;
                return false;
        }
        // Remember real `avail_out` value, because we may patch out buffer content
        // to align utf8 strings boundaries.
        last_avail_out = strm.avail_out;
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $2dd4f45c8894762f$var$Z_STREAM_END) {
                if (this.options.to === "string") {
                    let next_out_utf8 = $2dd4f45c8894762f$var$strings.utf8border(strm.output, strm.next_out);
                    let tail = strm.next_out - next_out_utf8;
                    let utf8str = $2dd4f45c8894762f$var$strings.buf2string(strm.output, next_out_utf8);
                    // move tail & realign counters
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);
                    this.onData(utf8str);
                } else this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
            }
        }
        // Must repeat iteration if out buffer is full
        if (status === $2dd4f45c8894762f$var$Z_OK && last_avail_out === 0) continue;
        // Finalize if end of stream reached.
        if (status === $2dd4f45c8894762f$var$Z_STREAM_END) {
            status = $2dd4f45c8894762f$var$inflate_1$2.inflateEnd(this.strm);
            this.onEnd(status);
            this.ended = true;
            return true;
        }
        if (strm.avail_in === 0) break;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2dd4f45c8894762f$var$Inflate$1.prototype.onEnd = function(status) {
    // On success - join
    if (status === $2dd4f45c8894762f$var$Z_OK) {
        if (this.options.to === "string") this.result = this.chunks.join("");
        else this.result = $2dd4f45c8894762f$var$common.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/ function $2dd4f45c8894762f$var$inflate$1(input, options) {
    const inflator = new $2dd4f45c8894762f$var$Inflate$1(options);
    inflator.push(input);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $2dd4f45c8894762f$var$messages[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2dd4f45c8894762f$var$inflateRaw$1(input, options) {
    options = options || {};
    options.raw = true;
    return $2dd4f45c8894762f$var$inflate$1(input, options);
}
/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2dd4f45c8894762f$var$Inflate_1$1 = $2dd4f45c8894762f$var$Inflate$1;
var $2dd4f45c8894762f$var$inflate_2 = $2dd4f45c8894762f$var$inflate$1;
var $2dd4f45c8894762f$var$inflateRaw_1$1 = $2dd4f45c8894762f$var$inflateRaw$1;
var $2dd4f45c8894762f$var$ungzip$1 = $2dd4f45c8894762f$var$inflate$1;
var $2dd4f45c8894762f$var$constants = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$var$inflate_1$1 = {
    Inflate: $2dd4f45c8894762f$var$Inflate_1$1,
    inflate: $2dd4f45c8894762f$var$inflate_2,
    inflateRaw: $2dd4f45c8894762f$var$inflateRaw_1$1,
    ungzip: $2dd4f45c8894762f$var$ungzip$1,
    constants: $2dd4f45c8894762f$var$constants
};
const { Deflate: $2dd4f45c8894762f$var$Deflate, deflate: $2dd4f45c8894762f$var$deflate, deflateRaw: $2dd4f45c8894762f$var$deflateRaw, gzip: $2dd4f45c8894762f$var$gzip } = $2dd4f45c8894762f$var$deflate_1$1;
const { Inflate: $2dd4f45c8894762f$var$Inflate, inflate: $2dd4f45c8894762f$var$inflate, inflateRaw: $2dd4f45c8894762f$var$inflateRaw, ungzip: $2dd4f45c8894762f$var$ungzip } = $2dd4f45c8894762f$var$inflate_1$1;
var $2dd4f45c8894762f$export$ae157b6234afe138 = $2dd4f45c8894762f$var$Deflate;
var $2dd4f45c8894762f$export$2316623ecd1285ab = $2dd4f45c8894762f$var$deflate;
var $2dd4f45c8894762f$export$e95d6a8f69fb340a = $2dd4f45c8894762f$var$deflateRaw;
var $2dd4f45c8894762f$export$69f0ea7cf3a331a8 = $2dd4f45c8894762f$var$gzip;
var $2dd4f45c8894762f$export$d1de70a877d6e43c = $2dd4f45c8894762f$var$Inflate;
var $2dd4f45c8894762f$export$cae1ce83fe4a1782 = $2dd4f45c8894762f$var$inflate;
var $2dd4f45c8894762f$export$d0f0aa2d05c905c5 = $2dd4f45c8894762f$var$inflateRaw;
var $2dd4f45c8894762f$export$95adf9d270383091 = $2dd4f45c8894762f$var$ungzip;
var $2dd4f45c8894762f$export$1a988e7317c65621 = $2dd4f45c8894762f$var$constants$2;
var $2dd4f45c8894762f$export$2e2bcd8739ae039 = {
    Deflate: $2dd4f45c8894762f$export$ae157b6234afe138,
    deflate: $2dd4f45c8894762f$export$2316623ecd1285ab,
    deflateRaw: $2dd4f45c8894762f$export$e95d6a8f69fb340a,
    gzip: $2dd4f45c8894762f$export$69f0ea7cf3a331a8,
    Inflate: $2dd4f45c8894762f$export$d1de70a877d6e43c,
    inflate: $2dd4f45c8894762f$export$cae1ce83fe4a1782,
    inflateRaw: $2dd4f45c8894762f$export$d0f0aa2d05c905c5,
    ungzip: $2dd4f45c8894762f$export$95adf9d270383091,
    constants: $2dd4f45c8894762f$export$1a988e7317c65621
};


/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $7ca0d9e2d8e201da$require$Buffer = $6ZWSX.Buffer;
const $7ca0d9e2d8e201da$export$83d89fbfd8236492 = "3.7.7";
/**
 * @deprecated use lowercase `version`.
 */ const $7ca0d9e2d8e201da$export$a4ad2735b021c132 = $7ca0d9e2d8e201da$export$83d89fbfd8236492;
const $7ca0d9e2d8e201da$var$_hasBuffer = typeof $7ca0d9e2d8e201da$require$Buffer === "function";
const $7ca0d9e2d8e201da$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $7ca0d9e2d8e201da$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $7ca0d9e2d8e201da$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $7ca0d9e2d8e201da$var$b64chs = Array.prototype.slice.call($7ca0d9e2d8e201da$var$b64ch);
const $7ca0d9e2d8e201da$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($7ca0d9e2d8e201da$var$b64chs);
const $7ca0d9e2d8e201da$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $7ca0d9e2d8e201da$var$_fromCC = String.fromCharCode.bind(String);
const $7ca0d9e2d8e201da$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $7ca0d9e2d8e201da$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $7ca0d9e2d8e201da$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $7ca0d9e2d8e201da$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $7ca0d9e2d8e201da$var$b64chs[u32 >> 18 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 12 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 >> 6 & 63] + $7ca0d9e2d8e201da$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $7ca0d9e2d8e201da$export$a32219e24f8d1e2 = typeof btoa === "function" ? (bin)=>btoa(bin) : $7ca0d9e2d8e201da$var$_hasBuffer ? (bin)=>$7ca0d9e2d8e201da$require$Buffer.from(bin, "binary").toString("base64") : $7ca0d9e2d8e201da$export$ec0fb543302ee251;
const $7ca0d9e2d8e201da$var$_fromUint8Array = $7ca0d9e2d8e201da$var$_hasBuffer ? (u8a)=>$7ca0d9e2d8e201da$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($7ca0d9e2d8e201da$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $7ca0d9e2d8e201da$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_fromUint8Array(u8a)) : $7ca0d9e2d8e201da$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $7ca0d9e2d8e201da$var$_fromCC(0xc0 | cc >>> 6) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f) : $7ca0d9e2d8e201da$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $7ca0d9e2d8e201da$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $7ca0d9e2d8e201da$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $7ca0d9e2d8e201da$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $7ca0d9e2d8e201da$export$10d4b9bd20a66b0 = (u)=>u.replace($7ca0d9e2d8e201da$var$re_utob, $7ca0d9e2d8e201da$var$cb_utob);
//
const $7ca0d9e2d8e201da$var$_encode = $7ca0d9e2d8e201da$var$_hasBuffer ? (s)=>$7ca0d9e2d8e201da$require$Buffer.from(s, "utf8").toString("base64") : $7ca0d9e2d8e201da$var$_TE ? (s)=>$7ca0d9e2d8e201da$var$_fromUint8Array($7ca0d9e2d8e201da$var$_TE.encode(s)) : (s)=>$7ca0d9e2d8e201da$export$a32219e24f8d1e2($7ca0d9e2d8e201da$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $7ca0d9e2d8e201da$var$_mkUriSafe($7ca0d9e2d8e201da$var$_encode(src)) : $7ca0d9e2d8e201da$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $7ca0d9e2d8e201da$export$90c31d5baa78df44 = (src)=>$7ca0d9e2d8e201da$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $7ca0d9e2d8e201da$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $7ca0d9e2d8e201da$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $7ca0d9e2d8e201da$var$_fromCC((offset >>> 10) + 0xD800) + $7ca0d9e2d8e201da$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $7ca0d9e2d8e201da$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $7ca0d9e2d8e201da$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$67e9defdeac3dd95 = (b)=>b.replace($7ca0d9e2d8e201da$var$re_btou, $7ca0d9e2d8e201da$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $7ca0d9e2d8e201da$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$7ca0d9e2d8e201da$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 18 | $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $7ca0d9e2d8e201da$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $7ca0d9e2d8e201da$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a = typeof atob === "function" ? (asc)=>atob($7ca0d9e2d8e201da$var$_tidyB64(asc)) : $7ca0d9e2d8e201da$var$_hasBuffer ? (asc)=>$7ca0d9e2d8e201da$require$Buffer.from(asc, "base64").toString("binary") : $7ca0d9e2d8e201da$export$7f16d8e674ddec24;
//
const $7ca0d9e2d8e201da$var$_toUint8Array = $7ca0d9e2d8e201da$var$_hasBuffer ? (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$require$Buffer.from(a, "base64")) : (a)=>$7ca0d9e2d8e201da$var$_U8Afrom($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a).split("").map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $7ca0d9e2d8e201da$export$73470fd2221e6aef = (a)=>$7ca0d9e2d8e201da$var$_toUint8Array($7ca0d9e2d8e201da$var$_unURI(a));
//
const $7ca0d9e2d8e201da$var$_decode = $7ca0d9e2d8e201da$var$_hasBuffer ? (a)=>$7ca0d9e2d8e201da$require$Buffer.from(a, "base64").toString("utf8") : $7ca0d9e2d8e201da$var$_TD ? (a)=>$7ca0d9e2d8e201da$var$_TD.decode($7ca0d9e2d8e201da$var$_toUint8Array(a)) : (a)=>$7ca0d9e2d8e201da$export$67e9defdeac3dd95($7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a(a));
const $7ca0d9e2d8e201da$var$_unURI = (a)=>$7ca0d9e2d8e201da$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $7ca0d9e2d8e201da$export$c537b38001c583b7 = (src)=>$7ca0d9e2d8e201da$var$_decode($7ca0d9e2d8e201da$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $7ca0d9e2d8e201da$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $7ca0d9e2d8e201da$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add("fromBase64", function() {
        return $7ca0d9e2d8e201da$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $7ca0d9e2d8e201da$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $7ca0d9e2d8e201da$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $7ca0d9e2d8e201da$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $7ca0d9e2d8e201da$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $7ca0d9e2d8e201da$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245 = ()=>{
    $7ca0d9e2d8e201da$export$4678ebf2295c49b();
    $7ca0d9e2d8e201da$export$a105d6a15258bd2();
};
const $7ca0d9e2d8e201da$export$f436b0c2107cbd35 = {
    version: $7ca0d9e2d8e201da$export$83d89fbfd8236492,
    VERSION: $7ca0d9e2d8e201da$export$a4ad2735b021c132,
    atob: $7ca0d9e2d8e201da$export$1406ac7a6dfd7b7a,
    atobPolyfill: $7ca0d9e2d8e201da$export$7f16d8e674ddec24,
    btoa: $7ca0d9e2d8e201da$export$a32219e24f8d1e2,
    btoaPolyfill: $7ca0d9e2d8e201da$export$ec0fb543302ee251,
    fromBase64: $7ca0d9e2d8e201da$export$c537b38001c583b7,
    toBase64: $7ca0d9e2d8e201da$export$37cc283d8fbd3462,
    encode: $7ca0d9e2d8e201da$export$37cc283d8fbd3462,
    encodeURI: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    encodeURL: $7ca0d9e2d8e201da$export$90c31d5baa78df44,
    utob: $7ca0d9e2d8e201da$export$10d4b9bd20a66b0,
    btou: $7ca0d9e2d8e201da$export$67e9defdeac3dd95,
    decode: $7ca0d9e2d8e201da$export$c537b38001c583b7,
    isValid: $7ca0d9e2d8e201da$export$1ea939691cdc45b8,
    fromUint8Array: $7ca0d9e2d8e201da$export$27bbb4e040978768,
    toUint8Array: $7ca0d9e2d8e201da$export$73470fd2221e6aef,
    extendString: $7ca0d9e2d8e201da$export$4678ebf2295c49b,
    extendUint8Array: $7ca0d9e2d8e201da$export$a105d6a15258bd2,
    extendBuiltins: $7ca0d9e2d8e201da$export$1abf1fe5ebfd5245
};


const $ce9a2afe0584bbc0$export$92147089af557b01 = (data)=>(0, $7ca0d9e2d8e201da$export$27bbb4e040978768)((0, $2dd4f45c8894762f$export$69f0ea7cf3a331a8)(data), true);
const $ce9a2afe0584bbc0$export$85af90b470928c35 = (data)=>(0, $2dd4f45c8894762f$export$95adf9d270383091)((0, $7ca0d9e2d8e201da$export$73470fd2221e6aef)(data), {
        to: "string"
    });


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ var $ce6dd58693a21851$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $ce6dd58693a21851$var$Env = function() {
    function Env() {
        this.browser = new $ce6dd58693a21851$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== "undefined";
    }
    return Env;
}();
var $ce6dd58693a21851$var$env = new $ce6dd58693a21851$var$Env();
if (typeof wx === "object" && typeof wx.getSystemInfoSync === "function") {
    $ce6dd58693a21851$var$env.wxa = true;
    $ce6dd58693a21851$var$env.touchEventsSupported = true;
} else if (typeof document === "undefined" && typeof self !== "undefined") $ce6dd58693a21851$var$env.worker = true;
else if (typeof navigator === "undefined" || navigator.userAgent.indexOf("Node.js") === 0) {
    $ce6dd58693a21851$var$env.node = true;
    $ce6dd58693a21851$var$env.svgSupported = true;
} else $ce6dd58693a21851$var$detect(navigator.userAgent, $ce6dd58693a21851$var$env);
function $ce6dd58693a21851$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split(".")[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== "undefined";
    env.touchEventsSupported = "ontouchstart" in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = "onpointerdown" in window && (browser.edge || browser.ie && +browser.version >= 11);
    env.domSupported = typeof document !== "undefined";
    var style = document.documentElement.style;
    env.transform3dSupported = (browser.ie && "transition" in style || browser.edge || "WebKitCSSMatrix" in window && "m11" in new WebKitCSSMatrix() || "MozPerspective" in style) && !("OTransition" in style);
    env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
}
var $ce6dd58693a21851$export$2e2bcd8739ae039 = $ce6dd58693a21851$var$env;


var $c6341dcc9d86826e$export$b1461457ea2c1179 = 12;
var $c6341dcc9d86826e$export$2653e0d5dd45b294 = "sans-serif";
var $c6341dcc9d86826e$export$7d7a232b6d2cc80c = $c6341dcc9d86826e$export$b1461457ea2c1179 + "px " + $c6341dcc9d86826e$export$2653e0d5dd45b294;
var $c6341dcc9d86826e$var$OFFSET = 20;
var $c6341dcc9d86826e$var$SCALE = 100;
var $c6341dcc9d86826e$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $c6341dcc9d86826e$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === "undefined") return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $c6341dcc9d86826e$var$OFFSET) / $c6341dcc9d86826e$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $c6341dcc9d86826e$export$69462fcc6bf851a4 = $c6341dcc9d86826e$var$getTextWidthMap($c6341dcc9d86826e$var$defaultWidthMapStr);
var $c6341dcc9d86826e$export$ef5e599365494451 = {
    createCanvas: function() {
        return typeof document !== "undefined" && document.createElement("canvas");
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $c6341dcc9d86826e$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext("2d");
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $c6341dcc9d86826e$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || "";
                font = font || $c6341dcc9d86826e$export$7d7a232b6d2cc80c;
                var res = /(\d+)px/.exec(font);
                var fontSize = res && +res[1] || $c6341dcc9d86826e$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf("mono") >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $c6341dcc9d86826e$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function $c6341dcc9d86826e$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $c6341dcc9d86826e$export$ef5e599365494451)if (newPlatformApis[key]) $c6341dcc9d86826e$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $7a1bd9c2710fea0d$var$BUILTIN_OBJECT = $7a1bd9c2710fea0d$export$533b26079ad0b4b([
    "Function",
    "RegExp",
    "Date",
    "Error",
    "CanvasGradient",
    "CanvasPattern",
    "Image",
    "Canvas"
], function(obj, val) {
    obj["[object " + val + "]"] = true;
    return obj;
}, {});
var $7a1bd9c2710fea0d$var$TYPED_ARRAY = $7a1bd9c2710fea0d$export$533b26079ad0b4b([
    "Int8",
    "Uint8",
    "Uint8Clamped",
    "Int16",
    "Uint16",
    "Int32",
    "Uint32",
    "Float32",
    "Float64"
], function(obj, val) {
    obj["[object " + val + "Array]"] = true;
    return obj;
}, {});
var $7a1bd9c2710fea0d$var$objToString = Object.prototype.toString;
var $7a1bd9c2710fea0d$var$arrayProto = Array.prototype;
var $7a1bd9c2710fea0d$var$nativeForEach = $7a1bd9c2710fea0d$var$arrayProto.forEach;
var $7a1bd9c2710fea0d$var$nativeFilter = $7a1bd9c2710fea0d$var$arrayProto.filter;
var $7a1bd9c2710fea0d$var$nativeSlice = $7a1bd9c2710fea0d$var$arrayProto.slice;
var $7a1bd9c2710fea0d$var$nativeMap = $7a1bd9c2710fea0d$var$arrayProto.map;
var $7a1bd9c2710fea0d$var$ctorFunction = (function() {}).constructor;
var $7a1bd9c2710fea0d$var$protoFunction = $7a1bd9c2710fea0d$var$ctorFunction ? $7a1bd9c2710fea0d$var$ctorFunction.prototype : null;
var $7a1bd9c2710fea0d$var$protoKey = "__proto__";
var $7a1bd9c2710fea0d$var$idStart = 0x0907;
function $7a1bd9c2710fea0d$export$46e8f25c7328f77e() {
    return $7a1bd9c2710fea0d$var$idStart++;
}
function $7a1bd9c2710fea0d$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== "undefined") console.error.apply(console, args);
}
function $7a1bd9c2710fea0d$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== "object") return source;
    var result = source;
    var typeStr = $7a1bd9c2710fea0d$var$objToString.call(source);
    if (typeStr === "[object Array]") {
        if (!$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[i]);
        }
    } else if ($7a1bd9c2710fea0d$var$TYPED_ARRAY[typeStr]) {
        if (!$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$7a1bd9c2710fea0d$var$BUILTIN_OBJECT[typeStr] && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) result[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $7a1bd9c2710fea0d$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(source) || !$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(target)) return overwrite ? $7a1bd9c2710fea0d$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(sourceProp) && $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(targetProp) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(sourceProp) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(targetProp) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(sourceProp) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(targetProp) && !$7a1bd9c2710fea0d$export$fa523b2c4941fd4f(sourceProp) && !$7a1bd9c2710fea0d$export$fa523b2c4941fd4f(targetProp) && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(sourceProp) && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(targetProp)) $7a1bd9c2710fea0d$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $7a1bd9c2710fea0d$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $7a1bd9c2710fea0d$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $7a1bd9c2710fea0d$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $7a1bd9c2710fea0d$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $7a1bd9c2710fea0d$export$ed97f33186d4b816(source);
    for(var i = 0; i < keysArr.length; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $7a1bd9c2710fea0d$export$cd3d1f114b139967 = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas;
function $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $7a1bd9c2710fea0d$export$e36fc9d62a853069(target, source, override) {
    target = "prototype" in target ? target.prototype : target;
    source = "prototype" in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== "constructor") {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $7a1bd9c2710fea0d$export$ebe90cb607ad99e(target, source, override);
}
function $7a1bd9c2710fea0d$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === "string") return false;
    return typeof data.length === "number";
}
function $7a1bd9c2710fea0d$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $7a1bd9c2710fea0d$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $7a1bd9c2710fea0d$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $7a1bd9c2710fea0d$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $7a1bd9c2710fea0d$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $7a1bd9c2710fea0d$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $7a1bd9c2710fea0d$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $7a1bd9c2710fea0d$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $7a1bd9c2710fea0d$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $7a1bd9c2710fea0d$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($7a1bd9c2710fea0d$var$nativeSlice.call(arguments)));
    };
}
var $7a1bd9c2710fea0d$export$2385a24977818dd0 = $7a1bd9c2710fea0d$var$protoFunction && $7a1bd9c2710fea0d$export$f6e2535fb5126e54($7a1bd9c2710fea0d$var$protoFunction.bind) ? $7a1bd9c2710fea0d$var$protoFunction.call.bind($7a1bd9c2710fea0d$var$protoFunction.bind) : $7a1bd9c2710fea0d$var$bindPolyfill;
function $7a1bd9c2710fea0d$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($7a1bd9c2710fea0d$var$nativeSlice.call(arguments)));
    };
}
function $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object Array]";
}
function $7a1bd9c2710fea0d$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $7a1bd9c2710fea0d$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) {
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object String]";
}
function $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === "function" || !!value && type === "object";
}
function $7a1bd9c2710fea0d$export$fa523b2c4941fd4f(value) {
    return !!$7a1bd9c2710fea0d$var$BUILTIN_OBJECT[$7a1bd9c2710fea0d$var$objToString.call(value)];
}
function $7a1bd9c2710fea0d$export$b119cc7e1840e59c(value) {
    return !!$7a1bd9c2710fea0d$var$TYPED_ARRAY[$7a1bd9c2710fea0d$var$objToString.call(value)];
}
function $7a1bd9c2710fea0d$export$9f57505b7bd8dae(value) {
    return typeof value === "object" && typeof value.nodeType === "number" && typeof value.ownerDocument === "object";
}
function $7a1bd9c2710fea0d$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $7a1bd9c2710fea0d$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $7a1bd9c2710fea0d$export$49841c62b9eff15(value) {
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object RegExp]";
}
function $7a1bd9c2710fea0d$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $7a1bd9c2710fea0d$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $7a1bd9c2710fea0d$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $7a1bd9c2710fea0d$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $7a1bd9c2710fea0d$var$nativeSlice.apply(arr, args);
}
function $7a1bd9c2710fea0d$export$f3a38102c49f4268(val) {
    if (typeof val === "number") return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $7a1bd9c2710fea0d$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $7a1bd9c2710fea0d$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === "function") return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
}
var $7a1bd9c2710fea0d$var$primitiveKey = "__ec_primitive__";
function $7a1bd9c2710fea0d$export$112e66431016387b(obj) {
    obj[$7a1bd9c2710fea0d$var$primitiveKey] = true;
}
function $7a1bd9c2710fea0d$export$c3825b437cbdea5c(obj) {
    return obj[$7a1bd9c2710fea0d$var$primitiveKey];
}
var $7a1bd9c2710fea0d$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $7a1bd9c2710fea0d$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $7a1bd9c2710fea0d$var$isNativeMapSupported = typeof Map === "function";
function $7a1bd9c2710fea0d$var$maybeNativeMap() {
    return $7a1bd9c2710fea0d$var$isNativeMapSupported ? new Map() : new $7a1bd9c2710fea0d$var$MapPolyfill();
}
var $7a1bd9c2710fea0d$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(obj);
        this.data = $7a1bd9c2710fea0d$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $7a1bd9c2710fea0d$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $7a1bd9c2710fea0d$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4(obj) {
    return new $7a1bd9c2710fea0d$export$60ef0b43d585640a(obj);
}
function $7a1bd9c2710fea0d$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $7a1bd9c2710fea0d$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $7a1bd9c2710fea0d$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $7a1bd9c2710fea0d$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = "none";
    domStyle.userSelect = "none";
    domStyle.webkitTapHighlightColor = "rgba(0,0,0,0)";
    domStyle["-webkit-touch-callout"] = "none";
}
function $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $7a1bd9c2710fea0d$export$8793edee2d425525() {}
var $7a1bd9c2710fea0d$export$bce8e055322a0ce6 = 180 / Math.PI;




function $6de594cf8ac295ff$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $6de594cf8ac295ff$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $6de594cf8ac295ff$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $6de594cf8ac295ff$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $6de594cf8ac295ff$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $6de594cf8ac295ff$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $6de594cf8ac295ff$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $6de594cf8ac295ff$export$fc1400facf92c78(v) {
    return Math.sqrt($6de594cf8ac295ff$export$48e33bc611e4c25a(v));
}
var $6de594cf8ac295ff$export$f24224f1c91d8156 = $6de594cf8ac295ff$export$fc1400facf92c78;
function $6de594cf8ac295ff$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $6de594cf8ac295ff$export$2f106540dd9a5136 = $6de594cf8ac295ff$export$48e33bc611e4c25a;
function $6de594cf8ac295ff$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $6de594cf8ac295ff$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $6de594cf8ac295ff$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $6de594cf8ac295ff$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $6de594cf8ac295ff$export$a3295358bff77e(out, v) {
    var d = $6de594cf8ac295ff$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $6de594cf8ac295ff$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $6de594cf8ac295ff$export$6c4a311cc157c764 = $6de594cf8ac295ff$export$9f17032d917177de;
function $6de594cf8ac295ff$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $6de594cf8ac295ff$export$c68db45a034c13b0 = $6de594cf8ac295ff$export$137c0a69d1ff4a79;
function $6de594cf8ac295ff$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $6de594cf8ac295ff$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $6de594cf8ac295ff$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $6de594cf8ac295ff$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $4e8ea7ab4b22b6b2$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $4e8ea7ab4b22b6b2$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on("mousedown", this._dragStart, this);
        handler.on("mousemove", this._drag, this);
        handler.on("mouseup", this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "dragstart", e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "drag", e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(lastDropTarget, e), "dragleave", e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(dropTarget, e), "dragenter", e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "dragend", e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(this._dropTarget, e), "drop", e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $4e8ea7ab4b22b6b2$export$2e2bcd8739ae039 = $4e8ea7ab4b22b6b2$var$Draggable;


var $63441a86293f101f$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === "function") {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $63441a86293f101f$export$2e2bcd8739ae039 = $63441a86293f101f$var$Eventful;





var $a9b673cb651a68dc$var$LN2 = Math.log(2);
function $a9b673cb651a68dc$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + "-" + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $a9b673cb651a68dc$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $a9b673cb651a68dc$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $a9b673cb651a68dc$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $a9b673cb651a68dc$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $a9b673cb651a68dc$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}


var $664e052f390bd76e$var$EVENT_SAVED_PROP = "___zrEVENTSAVED";
var $664e052f390bd76e$var$_calcOut = [];
function $664e052f390bd76e$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $664e052f390bd76e$export$1219648acc517df4($664e052f390bd76e$var$_calcOut, elFrom, inX, inY, true) && $664e052f390bd76e$export$1219648acc517df4(out, elTarget, $664e052f390bd76e$var$_calcOut[0], $664e052f390bd76e$var$_calcOut[1]);
}
function $664e052f390bd76e$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported && !$664e052f390bd76e$export$1b92e4fe606eff6d(el)) {
        var saved = el[$664e052f390bd76e$var$EVENT_SAVED_PROP] || (el[$664e052f390bd76e$var$EVENT_SAVED_PROP] = {});
        var markers = $664e052f390bd76e$var$prepareCoordMarkers(el, saved);
        var transformer = $664e052f390bd76e$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $664e052f390bd76e$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        "left",
        "right"
    ];
    var propTB = [
        "top",
        "bottom"
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement("div");
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            "position: absolute",
            "visibility: hidden",
            "padding: 0",
            "margin: 0",
            "border-width: 0",
            "user-select: none",
            "width:0",
            "height:0",
            propLR[idxLR] + ":0",
            propTB[idxTB] + ":0",
            propLR[1 - idxLR] + ":auto",
            propTB[1 - idxTB] + ":auto",
            ""
        ].join("!important;");
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $664e052f390bd76e$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? "invTrans" : "trans";
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $a9b673cb651a68dc$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $a9b673cb651a68dc$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $664e052f390bd76e$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === "CANVAS";
}
var $664e052f390bd76e$var$replaceReg = /([&<>"'])/g;
var $664e052f390bd76e$var$replaceMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $664e052f390bd76e$export$f9d6449b9af28dc1(source) {
    return source == null ? "" : (source + "").replace($664e052f390bd76e$var$replaceReg, function(str, c) {
        return $664e052f390bd76e$var$replaceMap[c];
    });
}


var $b3864a78637ff9ed$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $b3864a78637ff9ed$var$_calcOut = [];
var $b3864a78637ff9ed$var$firefoxNotSupportOffsetXY = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.firefox && +(0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.version.split(".")[0] < 39;
function $b3864a78637ff9ed$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $b3864a78637ff9ed$var$calculateZrXY(el, e, out);
    else if ($b3864a78637ff9ed$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $b3864a78637ff9ed$var$calculateZrXY(el, e, out);
    return out;
}
function $b3864a78637ff9ed$var$calculateZrXY(el, e, out) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $664e052f390bd76e$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $664e052f390bd76e$export$1219648acc517df4)($b3864a78637ff9ed$var$_calcOut, el, ex, ey)) {
            out.zrX = $b3864a78637ff9ed$var$_calcOut[0];
            out.zrY = $b3864a78637ff9ed$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $b3864a78637ff9ed$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $b3864a78637ff9ed$export$40fadb093aebad71(el, e, calculate) {
    e = $b3864a78637ff9ed$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf("touch") >= 0;
    if (!isTouch) {
        $b3864a78637ff9ed$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $b3864a78637ff9ed$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== "touchend" ? e.targetTouches[0] : e.changedTouches[0];
        touch && $b3864a78637ff9ed$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $b3864a78637ff9ed$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $b3864a78637ff9ed$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $b3864a78637ff9ed$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $b3864a78637ff9ed$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $b3864a78637ff9ed$export$fa6813432f753b0d = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $b3864a78637ff9ed$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $225ab5cf635fc62d$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $b3864a78637ff9ed$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $225ab5cf635fc62d$var$recognizers)if ($225ab5cf635fc62d$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $225ab5cf635fc62d$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $225ab5cf635fc62d$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $225ab5cf635fc62d$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $225ab5cf635fc62d$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $225ab5cf635fc62d$var$dist(pinchEnd) / $225ab5cf635fc62d$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $225ab5cf635fc62d$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: "pinch",
                target: tracks[0].target,
                event: event
            };
        }
    }
};


function $f41ebb9dd60b55b4$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $f41ebb9dd60b55b4$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $f41ebb9dd60b55b4$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $f41ebb9dd60b55b4$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $f41ebb9dd60b55b4$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $f41ebb9dd60b55b4$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $f41ebb9dd60b55b4$export$9cd59f9826255e47(a) {
    var b = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$784d13d8ee351f07(b, a);
    return b;
}


var $b887f038f104fe7e$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $b887f038f104fe7e$export$2e2bcd8739ae039 = $b887f038f104fe7e$var$Point;


var $1bebe7106c895823$var$mathMin = Math.min;
var $1bebe7106c895823$var$mathMax = Math.max;
var $1bebe7106c895823$var$lt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$rb = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$lb = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$rt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$minTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$maxTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function(other) {
        var x = $1bebe7106c895823$var$mathMin(other.x, this.x);
        var y = $1bebe7106c895823$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $1bebe7106c895823$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $1bebe7106c895823$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
            -a.x,
            -a.y
        ]);
        $f41ebb9dd60b55b4$export$dcdf75081b88279d(m, m, [
            sx,
            sy
        ]);
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv) {
        if (!b) return false;
        if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, -d0, 0);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, d1, 0);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d0 < d1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, d0, 0);
                else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, -d1, 0);
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, 0, -d2);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, 0, d3);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d2 < d3) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, 0, d2);
                else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, 0, -d3);
            }
        }
        if (mtv) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy(mtv, overlap ? $1bebe7106c895823$var$minTv : $1bebe7106c895823$var$maxTv);
        return overlap;
    };
    BoundingRect.prototype.contain = function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $1bebe7106c895823$var$lt.x = $1bebe7106c895823$var$lb.x = source.x;
        $1bebe7106c895823$var$lt.y = $1bebe7106c895823$var$rt.y = source.y;
        $1bebe7106c895823$var$rb.x = $1bebe7106c895823$var$rt.x = source.x + source.width;
        $1bebe7106c895823$var$rb.y = $1bebe7106c895823$var$lb.y = source.y + source.height;
        $1bebe7106c895823$var$lt.transform(m);
        $1bebe7106c895823$var$rt.transform(m);
        $1bebe7106c895823$var$rb.transform(m);
        $1bebe7106c895823$var$lb.transform(m);
        target.x = $1bebe7106c895823$var$mathMin($1bebe7106c895823$var$lt.x, $1bebe7106c895823$var$rb.x, $1bebe7106c895823$var$lb.x, $1bebe7106c895823$var$rt.x);
        target.y = $1bebe7106c895823$var$mathMin($1bebe7106c895823$var$lt.y, $1bebe7106c895823$var$rb.y, $1bebe7106c895823$var$lb.y, $1bebe7106c895823$var$rt.y);
        var maxX = $1bebe7106c895823$var$mathMax($1bebe7106c895823$var$lt.x, $1bebe7106c895823$var$rb.x, $1bebe7106c895823$var$lb.x, $1bebe7106c895823$var$rt.x);
        var maxY = $1bebe7106c895823$var$mathMax($1bebe7106c895823$var$lt.y, $1bebe7106c895823$var$rb.y, $1bebe7106c895823$var$lb.y, $1bebe7106c895823$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $1bebe7106c895823$export$2e2bcd8739ae039 = $1bebe7106c895823$var$BoundingRect;


var $b30f5d021af2ec5a$var$SILENT = "silent";
function $b30f5d021af2ec5a$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $b30f5d021af2ec5a$var$stopEvent
    };
}
function $b30f5d021af2ec5a$var$stopEvent() {
    $b3864a78637ff9ed$export$fa6813432f753b0d(this.event);
}
var $b30f5d021af2ec5a$var$EmptyProxy = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $b30f5d021af2ec5a$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $b30f5d021af2ec5a$var$handlerNames = [
    "click",
    "dblclick",
    "mousewheel",
    "mouseout",
    "mouseup",
    "mousedown",
    "mousemove",
    "contextmenu"
];
var $b30f5d021af2ec5a$var$tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $b30f5d021af2ec5a$var$Handler = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $b30f5d021af2ec5a$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $b30f5d021af2ec5a$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $4e8ea7ab4b22b6b2$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($b30f5d021af2ec5a$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b30f5d021af2ec5a$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $b30f5d021af2ec5a$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : "default");
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, "mouseout", event);
        this.dispatchToElement(hovered, "mousemove", event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, "mouseover", event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== "only_globalout") this.dispatchToElement(this._hovered, "mouseout", event);
        if (eventControl !== "no_globalout") this.trigger("globalout", {
            type: "globalout",
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $b30f5d021af2ec5a$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = "on" + eventName;
        var eventPacket = $b30f5d021af2ec5a$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === "function") layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $b30f5d021af2ec5a$var$HoveredResult(x, y);
        $b30f5d021af2ec5a$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $b30f5d021af2ec5a$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $b30f5d021af2ec5a$var$tmpRect.applyTransform(el.transform);
                    if ($b30f5d021af2ec5a$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $b30f5d021af2ec5a$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $225ab5cf635fc62d$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === "start" && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === "end" && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $b30f5d021af2ec5a$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$79b2f7037acddd43([
    "click",
    "mousedown",
    "mouseup",
    "mousewheel",
    "dblclick",
    "contextmenu"
], function(name) {
    $b30f5d021af2ec5a$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b30f5d021af2ec5a$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== "mouseup" || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === "mousedown") {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === "mouseup") this._upEl = hoveredTarget;
        else if (name === "click") {
            if (this._downEl !== this._upEl || !this._downPoint || $6de594cf8ac295ff$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $b30f5d021af2ec5a$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? "rectContain" : "contain"](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? $b30f5d021af2ec5a$var$SILENT : true;
    }
    return false;
}
function $b30f5d021af2ec5a$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $b30f5d021af2ec5a$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $b30f5d021af2ec5a$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $b30f5d021af2ec5a$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $b30f5d021af2ec5a$export$2e2bcd8739ae039 = $b30f5d021af2ec5a$var$Handler;



var $97579a54749e4b24$var$DEFAULT_MIN_MERGE = 32;
var $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING = 7;
function $97579a54749e4b24$var$minRunLength(n) {
    var r = 0;
    while(n >= $97579a54749e4b24$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $97579a54749e4b24$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $97579a54749e4b24$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $97579a54749e4b24$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $97579a54749e4b24$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $97579a54749e4b24$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $97579a54749e4b24$var$TimSort(array, compare) {
    var minGallop = $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $97579a54749e4b24$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $97579a54749e4b24$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $97579a54749e4b24$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $97579a54749e4b24$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING || count2 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $97579a54749e4b24$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $97579a54749e4b24$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING || count2 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $97579a54749e4b24$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $97579a54749e4b24$var$DEFAULT_MIN_MERGE) {
        runLength = $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare);
        $97579a54749e4b24$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $97579a54749e4b24$var$TimSort(array, compare);
    var minRun = $97579a54749e4b24$var$minRunLength(remaining);
    do {
        runLength = $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $97579a54749e4b24$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $ddf76b16f1246ba9$export$a7b6db622c6c7dbd = 1;
var $ddf76b16f1246ba9$export$ada8b2beb3d76671 = 2;
var $ddf76b16f1246ba9$export$f75fe89a33ebe115 = 4;


var $319574df0bc66e80$var$invalidZErrorLogged = false;
function $319574df0bc66e80$var$logInvalidZError() {
    if ($319574df0bc66e80$var$invalidZErrorLogged) return;
    $319574df0bc66e80$var$invalidZErrorLogged = true;
    console.warn("z / z2 / zlevel of displayable is invalid, which may cause unexpected errors");
}
function $319574df0bc66e80$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $319574df0bc66e80$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $319574df0bc66e80$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)(displayList, $319574df0bc66e80$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) clipPaths = null;
        else if (userSetClipPath) {
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
            if (isNaN(disp.z)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $319574df0bc66e80$export$2e2bcd8739ae039 = $319574df0bc66e80$var$Storage;





var $731d42ad1858cd4c$var$requestAnimationFrame;
$731d42ad1858cd4c$var$requestAnimationFrame = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $731d42ad1858cd4c$export$2e2bcd8739ae039 = $731d42ad1858cd4c$var$requestAnimationFrame;


var $9668111025b0b56f$var$easingFuncs = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $9668111025b0b56f$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $9668111025b0b56f$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $9668111025b0b56f$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $9668111025b0b56f$export$2e2bcd8739ae039 = $9668111025b0b56f$var$easingFuncs;




var $747cfc5611b57cea$var$mathPow = Math.pow;
var $747cfc5611b57cea$var$mathSqrt = Math.sqrt;
var $747cfc5611b57cea$var$EPSILON = 1e-8;
var $747cfc5611b57cea$var$EPSILON_NUMERIC = 1e-4;
var $747cfc5611b57cea$var$THREE_SQRT = $747cfc5611b57cea$var$mathSqrt(3);
var $747cfc5611b57cea$var$ONE_THIRD = 1 / 3;
var $747cfc5611b57cea$var$_v0 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
var $747cfc5611b57cea$var$_v1 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
var $747cfc5611b57cea$var$_v2 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
function $747cfc5611b57cea$var$isAroundZero(val) {
    return val > -$747cfc5611b57cea$var$EPSILON && val < $747cfc5611b57cea$var$EPSILON;
}
function $747cfc5611b57cea$var$isNotAroundZero(val) {
    return val > $747cfc5611b57cea$var$EPSILON || val < -$747cfc5611b57cea$var$EPSILON;
}
function $747cfc5611b57cea$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $747cfc5611b57cea$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $747cfc5611b57cea$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(A) && $747cfc5611b57cea$var$isAroundZero(B)) {
        if ($747cfc5611b57cea$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$747cfc5611b57cea$var$mathPow(-Y1, $747cfc5611b57cea$var$ONE_THIRD);
            else Y1 = $747cfc5611b57cea$var$mathPow(Y1, $747cfc5611b57cea$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$747cfc5611b57cea$var$mathPow(-Y2, $747cfc5611b57cea$var$ONE_THIRD);
            else Y2 = $747cfc5611b57cea$var$mathPow(Y2, $747cfc5611b57cea$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $747cfc5611b57cea$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $747cfc5611b57cea$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $747cfc5611b57cea$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $747cfc5611b57cea$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(a)) {
        if ($747cfc5611b57cea$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $747cfc5611b57cea$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $747cfc5611b57cea$var$_v0[0] = x;
    $747cfc5611b57cea$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v0, $747cfc5611b57cea$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $747cfc5611b57cea$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v1, $747cfc5611b57cea$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $747cfc5611b57cea$var$_v2[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $747cfc5611b57cea$var$_v2[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v2, $747cfc5611b57cea$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $747cfc5611b57cea$var$mathSqrt(d);
}
function $747cfc5611b57cea$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $747cfc5611b57cea$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $747cfc5611b57cea$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $747cfc5611b57cea$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(a)) {
        if ($747cfc5611b57cea$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $747cfc5611b57cea$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $747cfc5611b57cea$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $747cfc5611b57cea$var$_v0[0] = x;
    $747cfc5611b57cea$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, _t);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v0, $747cfc5611b57cea$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $747cfc5611b57cea$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, prev);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v1, $747cfc5611b57cea$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $747cfc5611b57cea$var$_v2[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, next);
            $747cfc5611b57cea$var$_v2[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v2, $747cfc5611b57cea$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $747cfc5611b57cea$var$mathSqrt(d);
}
function $747cfc5611b57cea$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, t);
        var y = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $0aea98bda0b4be1f$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $0aea98bda0b4be1f$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $0aea98bda0b4be1f$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(",");
        var a_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $747cfc5611b57cea$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $00f1e1cb3568b9c5$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easing) ? easing : (0, $9668111025b0b56f$export$2e2bcd8739ae039)[easing] || (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $00f1e1cb3568b9c5$export$2e2bcd8739ae039 = $00f1e1cb3568b9c5$var$Clip;


var $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $d91b0b6fc564d9c7$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $d91b0b6fc564d9c7$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $d91b0b6fc564d9c7$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $d91b0b6fc564d9c7$export$2e2bcd8739ae039 = $d91b0b6fc564d9c7$var$LRU;



var $2c037f5bda6341ca$var$kCSSColorTable = {
    "transparent": [
        0,
        0,
        0,
        0
    ],
    "aliceblue": [
        240,
        248,
        255,
        1
    ],
    "antiquewhite": [
        250,
        235,
        215,
        1
    ],
    "aqua": [
        0,
        255,
        255,
        1
    ],
    "aquamarine": [
        127,
        255,
        212,
        1
    ],
    "azure": [
        240,
        255,
        255,
        1
    ],
    "beige": [
        245,
        245,
        220,
        1
    ],
    "bisque": [
        255,
        228,
        196,
        1
    ],
    "black": [
        0,
        0,
        0,
        1
    ],
    "blanchedalmond": [
        255,
        235,
        205,
        1
    ],
    "blue": [
        0,
        0,
        255,
        1
    ],
    "blueviolet": [
        138,
        43,
        226,
        1
    ],
    "brown": [
        165,
        42,
        42,
        1
    ],
    "burlywood": [
        222,
        184,
        135,
        1
    ],
    "cadetblue": [
        95,
        158,
        160,
        1
    ],
    "chartreuse": [
        127,
        255,
        0,
        1
    ],
    "chocolate": [
        210,
        105,
        30,
        1
    ],
    "coral": [
        255,
        127,
        80,
        1
    ],
    "cornflowerblue": [
        100,
        149,
        237,
        1
    ],
    "cornsilk": [
        255,
        248,
        220,
        1
    ],
    "crimson": [
        220,
        20,
        60,
        1
    ],
    "cyan": [
        0,
        255,
        255,
        1
    ],
    "darkblue": [
        0,
        0,
        139,
        1
    ],
    "darkcyan": [
        0,
        139,
        139,
        1
    ],
    "darkgoldenrod": [
        184,
        134,
        11,
        1
    ],
    "darkgray": [
        169,
        169,
        169,
        1
    ],
    "darkgreen": [
        0,
        100,
        0,
        1
    ],
    "darkgrey": [
        169,
        169,
        169,
        1
    ],
    "darkkhaki": [
        189,
        183,
        107,
        1
    ],
    "darkmagenta": [
        139,
        0,
        139,
        1
    ],
    "darkolivegreen": [
        85,
        107,
        47,
        1
    ],
    "darkorange": [
        255,
        140,
        0,
        1
    ],
    "darkorchid": [
        153,
        50,
        204,
        1
    ],
    "darkred": [
        139,
        0,
        0,
        1
    ],
    "darksalmon": [
        233,
        150,
        122,
        1
    ],
    "darkseagreen": [
        143,
        188,
        143,
        1
    ],
    "darkslateblue": [
        72,
        61,
        139,
        1
    ],
    "darkslategray": [
        47,
        79,
        79,
        1
    ],
    "darkslategrey": [
        47,
        79,
        79,
        1
    ],
    "darkturquoise": [
        0,
        206,
        209,
        1
    ],
    "darkviolet": [
        148,
        0,
        211,
        1
    ],
    "deeppink": [
        255,
        20,
        147,
        1
    ],
    "deepskyblue": [
        0,
        191,
        255,
        1
    ],
    "dimgray": [
        105,
        105,
        105,
        1
    ],
    "dimgrey": [
        105,
        105,
        105,
        1
    ],
    "dodgerblue": [
        30,
        144,
        255,
        1
    ],
    "firebrick": [
        178,
        34,
        34,
        1
    ],
    "floralwhite": [
        255,
        250,
        240,
        1
    ],
    "forestgreen": [
        34,
        139,
        34,
        1
    ],
    "fuchsia": [
        255,
        0,
        255,
        1
    ],
    "gainsboro": [
        220,
        220,
        220,
        1
    ],
    "ghostwhite": [
        248,
        248,
        255,
        1
    ],
    "gold": [
        255,
        215,
        0,
        1
    ],
    "goldenrod": [
        218,
        165,
        32,
        1
    ],
    "gray": [
        128,
        128,
        128,
        1
    ],
    "green": [
        0,
        128,
        0,
        1
    ],
    "greenyellow": [
        173,
        255,
        47,
        1
    ],
    "grey": [
        128,
        128,
        128,
        1
    ],
    "honeydew": [
        240,
        255,
        240,
        1
    ],
    "hotpink": [
        255,
        105,
        180,
        1
    ],
    "indianred": [
        205,
        92,
        92,
        1
    ],
    "indigo": [
        75,
        0,
        130,
        1
    ],
    "ivory": [
        255,
        255,
        240,
        1
    ],
    "khaki": [
        240,
        230,
        140,
        1
    ],
    "lavender": [
        230,
        230,
        250,
        1
    ],
    "lavenderblush": [
        255,
        240,
        245,
        1
    ],
    "lawngreen": [
        124,
        252,
        0,
        1
    ],
    "lemonchiffon": [
        255,
        250,
        205,
        1
    ],
    "lightblue": [
        173,
        216,
        230,
        1
    ],
    "lightcoral": [
        240,
        128,
        128,
        1
    ],
    "lightcyan": [
        224,
        255,
        255,
        1
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210,
        1
    ],
    "lightgray": [
        211,
        211,
        211,
        1
    ],
    "lightgreen": [
        144,
        238,
        144,
        1
    ],
    "lightgrey": [
        211,
        211,
        211,
        1
    ],
    "lightpink": [
        255,
        182,
        193,
        1
    ],
    "lightsalmon": [
        255,
        160,
        122,
        1
    ],
    "lightseagreen": [
        32,
        178,
        170,
        1
    ],
    "lightskyblue": [
        135,
        206,
        250,
        1
    ],
    "lightslategray": [
        119,
        136,
        153,
        1
    ],
    "lightslategrey": [
        119,
        136,
        153,
        1
    ],
    "lightsteelblue": [
        176,
        196,
        222,
        1
    ],
    "lightyellow": [
        255,
        255,
        224,
        1
    ],
    "lime": [
        0,
        255,
        0,
        1
    ],
    "limegreen": [
        50,
        205,
        50,
        1
    ],
    "linen": [
        250,
        240,
        230,
        1
    ],
    "magenta": [
        255,
        0,
        255,
        1
    ],
    "maroon": [
        128,
        0,
        0,
        1
    ],
    "mediumaquamarine": [
        102,
        205,
        170,
        1
    ],
    "mediumblue": [
        0,
        0,
        205,
        1
    ],
    "mediumorchid": [
        186,
        85,
        211,
        1
    ],
    "mediumpurple": [
        147,
        112,
        219,
        1
    ],
    "mediumseagreen": [
        60,
        179,
        113,
        1
    ],
    "mediumslateblue": [
        123,
        104,
        238,
        1
    ],
    "mediumspringgreen": [
        0,
        250,
        154,
        1
    ],
    "mediumturquoise": [
        72,
        209,
        204,
        1
    ],
    "mediumvioletred": [
        199,
        21,
        133,
        1
    ],
    "midnightblue": [
        25,
        25,
        112,
        1
    ],
    "mintcream": [
        245,
        255,
        250,
        1
    ],
    "mistyrose": [
        255,
        228,
        225,
        1
    ],
    "moccasin": [
        255,
        228,
        181,
        1
    ],
    "navajowhite": [
        255,
        222,
        173,
        1
    ],
    "navy": [
        0,
        0,
        128,
        1
    ],
    "oldlace": [
        253,
        245,
        230,
        1
    ],
    "olive": [
        128,
        128,
        0,
        1
    ],
    "olivedrab": [
        107,
        142,
        35,
        1
    ],
    "orange": [
        255,
        165,
        0,
        1
    ],
    "orangered": [
        255,
        69,
        0,
        1
    ],
    "orchid": [
        218,
        112,
        214,
        1
    ],
    "palegoldenrod": [
        238,
        232,
        170,
        1
    ],
    "palegreen": [
        152,
        251,
        152,
        1
    ],
    "paleturquoise": [
        175,
        238,
        238,
        1
    ],
    "palevioletred": [
        219,
        112,
        147,
        1
    ],
    "papayawhip": [
        255,
        239,
        213,
        1
    ],
    "peachpuff": [
        255,
        218,
        185,
        1
    ],
    "peru": [
        205,
        133,
        63,
        1
    ],
    "pink": [
        255,
        192,
        203,
        1
    ],
    "plum": [
        221,
        160,
        221,
        1
    ],
    "powderblue": [
        176,
        224,
        230,
        1
    ],
    "purple": [
        128,
        0,
        128,
        1
    ],
    "red": [
        255,
        0,
        0,
        1
    ],
    "rosybrown": [
        188,
        143,
        143,
        1
    ],
    "royalblue": [
        65,
        105,
        225,
        1
    ],
    "saddlebrown": [
        139,
        69,
        19,
        1
    ],
    "salmon": [
        250,
        128,
        114,
        1
    ],
    "sandybrown": [
        244,
        164,
        96,
        1
    ],
    "seagreen": [
        46,
        139,
        87,
        1
    ],
    "seashell": [
        255,
        245,
        238,
        1
    ],
    "sienna": [
        160,
        82,
        45,
        1
    ],
    "silver": [
        192,
        192,
        192,
        1
    ],
    "skyblue": [
        135,
        206,
        235,
        1
    ],
    "slateblue": [
        106,
        90,
        205,
        1
    ],
    "slategray": [
        112,
        128,
        144,
        1
    ],
    "slategrey": [
        112,
        128,
        144,
        1
    ],
    "snow": [
        255,
        250,
        250,
        1
    ],
    "springgreen": [
        0,
        255,
        127,
        1
    ],
    "steelblue": [
        70,
        130,
        180,
        1
    ],
    "tan": [
        210,
        180,
        140,
        1
    ],
    "teal": [
        0,
        128,
        128,
        1
    ],
    "thistle": [
        216,
        191,
        216,
        1
    ],
    "tomato": [
        255,
        99,
        71,
        1
    ],
    "turquoise": [
        64,
        224,
        208,
        1
    ],
    "violet": [
        238,
        130,
        238,
        1
    ],
    "wheat": [
        245,
        222,
        179,
        1
    ],
    "white": [
        255,
        255,
        255,
        1
    ],
    "whitesmoke": [
        245,
        245,
        245,
        1
    ],
    "yellow": [
        255,
        255,
        0,
        1
    ],
    "yellowgreen": [
        154,
        205,
        50,
        1
    ]
};
function $2c037f5bda6341ca$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $2c037f5bda6341ca$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $2c037f5bda6341ca$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $2c037f5bda6341ca$var$parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === "%") return $2c037f5bda6341ca$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $2c037f5bda6341ca$var$clampCssByte(parseInt(str, 10));
}
function $2c037f5bda6341ca$var$parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === "%") return $2c037f5bda6341ca$var$clampCssFloat(parseFloat(str) / 100);
    return $2c037f5bda6341ca$var$clampCssFloat(parseFloat(str));
}
function $2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $2c037f5bda6341ca$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $2c037f5bda6341ca$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $2c037f5bda6341ca$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $2c037f5bda6341ca$var$colorCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(20);
var $2c037f5bda6341ca$var$lastRemovedArr = null;
function $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr) {
    if ($2c037f5bda6341ca$var$lastRemovedArr) $2c037f5bda6341ca$var$copyRgba($2c037f5bda6341ca$var$lastRemovedArr, rgbaArr);
    $2c037f5bda6341ca$var$lastRemovedArr = $2c037f5bda6341ca$var$colorCache.put(colorStr, $2c037f5bda6341ca$var$lastRemovedArr || rgbaArr.slice());
}
function $2c037f5bda6341ca$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $2c037f5bda6341ca$var$colorCache.get(colorStr);
    if (cached) return $2c037f5bda6341ca$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + "";
    var str = colorStr.replace(/ /g, "").toLowerCase();
    if (str in $2c037f5bda6341ca$var$kCSSColorTable) {
        $2c037f5bda6341ca$var$copyRgba(rgbaArr, $2c037f5bda6341ca$var$kCSSColorTable[str]);
        $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === "#") {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2c037f5bda6341ca$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2c037f5bda6341ca$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf("(");
    var ep = str.indexOf(")");
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(",");
        var alpha = 1;
        switch(fname){
            case "rgba":
                if (params.length !== 4) return params.length === 3 ? $2c037f5bda6341ca$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $2c037f5bda6341ca$var$parseCssFloat(params.pop());
            case "rgb":
                if (params.length >= 3) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, $2c037f5bda6341ca$var$parseCssInt(params[0]), $2c037f5bda6341ca$var$parseCssInt(params[1]), $2c037f5bda6341ca$var$parseCssInt(params[2]), params.length === 3 ? alpha : $2c037f5bda6341ca$var$parseCssFloat(params[3]));
                    $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case "hsla":
                if (params.length !== 4) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $2c037f5bda6341ca$var$parseCssFloat(params[3]);
                $2c037f5bda6341ca$var$hsla2rgba(params, rgbaArr);
                $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case "hsl":
                if (params.length !== 3) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $2c037f5bda6341ca$var$hsla2rgba(params, rgbaArr);
                $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $2c037f5bda6341ca$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $2c037f5bda6341ca$var$parseCssFloat(hsla[1]);
    var l = $2c037f5bda6341ca$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $2c037f5bda6341ca$var$setRgba(rgba, $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h) * 255), $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $2c037f5bda6341ca$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $2c037f5bda6341ca$export$590e8b2c435046d9(color, level) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $2c037f5bda6341ca$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? "rgba" : "rgb");
    }
}
function $2c037f5bda6341ca$export$7ea66e3774a60b67(color) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $2c037f5bda6341ca$var$clampCssFloat($2c037f5bda6341ca$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $2c037f5bda6341ca$export$daa5a65daad5df58 = $2c037f5bda6341ca$export$66cb3c0e9efc61c8;
function $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $2c037f5bda6341ca$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $2c037f5bda6341ca$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $2c037f5bda6341ca$export$fac44ee5b035f737([
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $2c037f5bda6341ca$var$clampCssFloat($2c037f5bda6341ca$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], "rgba");
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $2c037f5bda6341ca$export$296e08242b78a3ec = $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f;
function $2c037f5bda6341ca$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $2c037f5bda6341ca$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $2c037f5bda6341ca$var$clampCssAngle(h));
        s != null && (colorArr[1] = $2c037f5bda6341ca$var$parseCssFloat(s));
        l != null && (colorArr[2] = $2c037f5bda6341ca$var$parseCssFloat(l));
        return $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$var$hsla2rgba(colorArr), "rgba");
    }
}
function $2c037f5bda6341ca$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $2c037f5bda6341ca$var$clampCssFloat(alpha);
        return $2c037f5bda6341ca$export$fac44ee5b035f737(colorArr, "rgba");
    }
}
function $2c037f5bda6341ca$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + "," + arrColor[1] + "," + arrColor[2];
    if (type === "rgba" || type === "hsva" || type === "hsla") colorStr += "," + arrColor[3];
    return type + "(" + colorStr + ")";
}
function $2c037f5bda6341ca$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $2c037f5bda6341ca$export$4385e60b38654f68() {
    return $2c037f5bda6341ca$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], "rgb");
}
var $2c037f5bda6341ca$var$liftedColorCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
function $2c037f5bda6341ca$export$2b47e247dfb87a73(color) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(color)) {
        var liftedColor = $2c037f5bda6341ca$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $2c037f5bda6341ca$export$590e8b2c435046d9(color, -0.1);
            $2c037f5bda6341ca$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(color)) {
        var ret = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $2c037f5bda6341ca$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}









var $6ZWSX = parcelRequire("6ZWSX");
var $999d81abec723db8$require$Buffer = $6ZWSX.Buffer;
var $999d81abec723db8$var$mathRound = Math.round;
function $999d81abec723db8$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === "transparent") color = "none";
    else if (typeof color === "string" && color.indexOf("rgba") > -1) {
        var arr = (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(color);
        if (arr) {
            color = "rgb(" + arr[0] + "," + arr[1] + "," + arr[2] + ")";
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $999d81abec723db8$var$EPSILON = 1e-4;
function $999d81abec723db8$export$4701367f5b4de464(transform) {
    return transform < $999d81abec723db8$var$EPSILON && transform > -$999d81abec723db8$var$EPSILON;
}
function $999d81abec723db8$export$4b9074ac37ee5a23(transform) {
    return $999d81abec723db8$var$mathRound(transform * 1e3) / 1e3;
}
function $999d81abec723db8$export$52bfc6d3e2ff0fc2(transform) {
    return $999d81abec723db8$var$mathRound(transform * 1e4) / 1e4;
}
function $999d81abec723db8$export$19676ab5cb1de150(transform) {
    return $999d81abec723db8$var$mathRound(transform * 10) / 10;
}
function $999d81abec723db8$export$f29a4456cf56ff21(m) {
    return "matrix(" + $999d81abec723db8$export$4b9074ac37ee5a23(m[0]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[1]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[2]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[3]) + "," + $999d81abec723db8$export$52bfc6d3e2ff0fc2(m[4]) + "," + $999d81abec723db8$export$52bfc6d3e2ff0fc2(m[5]) + ")";
}
var $999d81abec723db8$export$4062150f0600d971 = {
    left: "start",
    right: "end",
    center: "middle",
    middle: "middle"
};
function $999d81abec723db8$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === "top") y += lineHeight / 2;
    else if (textBaseline === "bottom") y -= lineHeight / 2;
    return y;
}
function $999d81abec723db8$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $999d81abec723db8$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(",");
}
function $999d81abec723db8$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(",");
}
function $999d81abec723db8$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $999d81abec723db8$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $999d81abec723db8$export$41a28f5a000a9d0f(val) {
    return $999d81abec723db8$export$2ade673ac4f85dfe(val) || $999d81abec723db8$export$30352f47600a13cd(val);
}
function $999d81abec723db8$export$7d961bca9d3b47d0(val) {
    return val.type === "linear";
}
function $999d81abec723db8$export$2a9cca6692a0ce3a(val) {
    return val.type === "radial";
}
function $999d81abec723db8$export$545e02bbd5f8fe95(val) {
    return val && (val.type === "linear" || val.type === "radial");
}
function $999d81abec723db8$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $999d81abec723db8$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $999d81abec723db8$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6);
    var scaleX = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $999d81abec723db8$var$mathRound(skewX * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6)) + "deg, " + $999d81abec723db8$var$mathRound(skewY * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6)) + "deg)");
    return res.join(" ");
}
var $999d81abec723db8$export$8fb536984ec8b4d7 = function() {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(window.btoa)) return function(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    if (typeof $999d81abec723db8$require$Buffer !== "undefined") return function(str) {
        return $999d81abec723db8$require$Buffer.from(str).toString("base64");
    };
    return function(str) {
        return null;
    };
}();


var $76d8a142a20276fc$var$arraySlice = Array.prototype.slice;
function $76d8a142a20276fc$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $76d8a142a20276fc$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $76d8a142a20276fc$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $76d8a142a20276fc$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $76d8a142a20276fc$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $76d8a142a20276fc$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $76d8a142a20276fc$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $76d8a142a20276fc$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $76d8a142a20276fc$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $76d8a142a20276fc$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $76d8a142a20276fc$export$c5e92b7f105af84e(value) {
    if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($76d8a142a20276fc$var$arraySlice.call(value[i]));
            return ret;
        }
        return $76d8a142a20276fc$var$arraySlice.call(value);
    }
    return value;
}
function $76d8a142a20276fc$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return "rgba(" + rgba.join(",") + ")";
}
function $76d8a142a20276fc$var$guessArrayDim(value) {
    return (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $76d8a142a20276fc$var$VALUE_TYPE_NUMBER = 0;
var $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY = 1;
var $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY = 2;
var $76d8a142a20276fc$var$VALUE_TYPE_COLOR = 3;
var $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN = 6;
function $76d8a142a20276fc$var$isGradientValueType(valType) {
    return valType === $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $76d8a142a20276fc$var$isArrayValueType(valType) {
    return valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY || valType === $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY;
}
var $76d8a142a20276fc$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $76d8a142a20276fc$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $76d8a142a20276fc$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue) && !(0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_NUMBER;
            else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $2c037f5bda6341ca$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $76d8a142a20276fc$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $2c037f5bda6341ca$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $999d81abec723db8$export$7d961bca9d3b47d0)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $999d81abec723db8$export$2a9cca6692a0ce3a)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easing) ? easing : (0, $9668111025b0b56f$export$2e2bcd8739ae039)[easing] || (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $76d8a142a20276fc$var$isArrayValueType(valType);
        var isGradient = $76d8a142a20276fc$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $76d8a142a20276fc$var$fillArray(value, lastValue, valType);
                else if (isGradient) $76d8a142a20276fc$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $76d8a142a20276fc$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $76d8a142a20276fc$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($76d8a142a20276fc$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY ? $76d8a142a20276fc$var$add1DArray([], kfs[i].value, startValue, -1) : $76d8a142a20276fc$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? "additiveValue" : "value";
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $76d8a142a20276fc$var$tmpRgba : target[propName];
        if (($76d8a142a20276fc$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($76d8a142a20276fc$var$isArrayValueType(valType)) valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY ? $76d8a142a20276fc$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $76d8a142a20276fc$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($76d8a142a20276fc$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? "linear" : "radial",
                x: $76d8a142a20276fc$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $76d8a142a20276fc$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $76d8a142a20276fc$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $76d8a142a20276fc$var$rgba2String($76d8a142a20276fc$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $76d8a142a20276fc$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $76d8a142a20276fc$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $76d8a142a20276fc$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $76d8a142a20276fc$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $76d8a142a20276fc$var$rgba2String(targetArr);
        } else {
            var value = $76d8a142a20276fc$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $76d8a142a20276fc$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR) {
            $2c037f5bda6341ca$export$98e6a39c04603d36(target[propName], $76d8a142a20276fc$var$tmpRgba);
            $76d8a142a20276fc$var$add1DArray($76d8a142a20276fc$var$tmpRgba, $76d8a142a20276fc$var$tmpRgba, additiveValue, 1);
            target[propName] = $76d8a142a20276fc$var$rgba2String($76d8a142a20276fc$var$tmpRgba);
        } else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY) $76d8a142a20276fc$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY) $76d8a142a20276fc$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $76d8a142a20276fc$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $7a1bd9c2710fea0d$export$58da9968c3170cb1)("Can' use additive animation on looped animation.");
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $76d8a142a20276fc$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR && initialValue) initialValue = $76d8a142a20276fc$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $76d8a142a20276fc$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $76d8a142a20276fc$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $00f1e1cb3568b9c5$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $76d8a142a20276fc$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $76d8a142a20276fc$export$2e2bcd8739ae039 = $76d8a142a20276fc$var$Animator;


function $fad434a4044c956a$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $fad434a4044c956a$var$Animation = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $fad434a4044c956a$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger("frame", delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $fad434a4044c956a$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $fad434a4044c956a$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $fad434a4044c956a$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $fad434a4044c956a$export$2e2bcd8739ae039 = $fad434a4044c956a$var$Animation;







var $c0dbbc6989260eee$var$TOUCH_CLICK_DELAY = 300;
var $c0dbbc6989260eee$var$globalEventSupported = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported;
var $c0dbbc6989260eee$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        "click",
        "dblclick",
        "mousewheel",
        "wheel",
        "mouseout",
        "mouseup",
        "mousedown",
        "mousemove",
        "contextmenu"
    ];
    var touchHandlerNames = [
        "touchstart",
        "touchend",
        "touchmove"
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $7a1bd9c2710fea0d$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace("mouse", "pointer");
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $c0dbbc6989260eee$var$globalNativeListenerNames = {
    mouse: [
        "mousemove",
        "mouseup"
    ],
    pointer: [
        "pointermove",
        "pointerup"
    ]
};
var $c0dbbc6989260eee$var$wheelEventSupported = false;
function $c0dbbc6989260eee$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === "pen" || pointerType === "touch";
}
function $c0dbbc6989260eee$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $c0dbbc6989260eee$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $c0dbbc6989260eee$var$normalizeGlobalEvent(instance, event) {
    return (0, $b3864a78637ff9ed$export$40fadb093aebad71)(instance.dom, new $c0dbbc6989260eee$var$FakeGlobalEvent(instance, event), true);
}
function $c0dbbc6989260eee$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $c0dbbc6989260eee$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.stopImmediatePropagation = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.preventDefault = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $c0dbbc6989260eee$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger("mousedown", event);
    },
    mousemove: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger("mouseup", event);
    },
    mouseout: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$c0dbbc6989260eee$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = "no_globalout";
            this.trigger("mouseout", event);
        }
    },
    wheel: function(event) {
        $c0dbbc6989260eee$var$wheelEventSupported = true;
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger("mousewheel", event);
    },
    mousewheel: function(event) {
        if ($c0dbbc6989260eee$var$wheelEventSupported) return;
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger("mousewheel", event);
    },
    touchstart: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, "start");
        $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
        $c0dbbc6989260eee$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.handler.processGesture(event, "change");
        $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.handler.processGesture(event, "end");
        $c0dbbc6989260eee$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $c0dbbc6989260eee$var$TOUCH_CLICK_DELAY) $c0dbbc6989260eee$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $c0dbbc6989260eee$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c0dbbc6989260eee$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$7a1bd9c2710fea0d$export$79b2f7037acddd43([
    "click",
    "dblclick",
    "contextmenu"
], function(name) {
    $c0dbbc6989260eee$var$localDOMHandlers[name] = function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $c0dbbc6989260eee$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c0dbbc6989260eee$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger("mouseup", event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = "only_globalout";
            this.trigger("mouseout", event);
        }
    }
};
function $c0dbbc6989260eee$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).pointerEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.touch, function(nativeEventName) {
            $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $c0dbbc6989260eee$var$setTouchTimer(scope);
            });
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $b3864a78637ff9ed$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $c0dbbc6989260eee$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).pointerEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $b3864a78637ff9ed$export$4abe0e945399ac1d)(event);
            if (!$c0dbbc6989260eee$var$isLocalEl(instance, event.target)) {
                event = $c0dbbc6989260eee$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $c0dbbc6989260eee$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $b3864a78637ff9ed$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $c0dbbc6989260eee$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $c0dbbc6989260eee$var$HandlerDomProxy = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $c0dbbc6989260eee$var$DOMHandlerScope(dom, $c0dbbc6989260eee$var$localDOMHandlers);
        if ($c0dbbc6989260eee$var$globalEventSupported) _this._globalHandlerScope = new $c0dbbc6989260eee$var$DOMHandlerScope(document, $c0dbbc6989260eee$var$globalDOMHandlers);
        $c0dbbc6989260eee$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $c0dbbc6989260eee$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($c0dbbc6989260eee$var$globalEventSupported) $c0dbbc6989260eee$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || "default");
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($c0dbbc6989260eee$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $c0dbbc6989260eee$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $c0dbbc6989260eee$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $c0dbbc6989260eee$export$2e2bcd8739ae039 = $c0dbbc6989260eee$var$HandlerDomProxy;




var $4b0cedd85979c776$var$dpr = 1;
if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow) $4b0cedd85979c776$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $4b0cedd85979c776$export$7cdcde344c85339c = 0;
var $4b0cedd85979c776$export$508f096bfcdaac40 = $4b0cedd85979c776$var$dpr;
var $4b0cedd85979c776$export$fd81e7ebc7dae256 = 0.4;
var $4b0cedd85979c776$export$f8ce94761f39398d = "#333";
var $4b0cedd85979c776$export$3c6e95f318c8369b = "#ccc";
var $4b0cedd85979c776$export$27682248795c3c6b = "#eee";






var $becf2d727f9cf450$var$mIdentity = $f41ebb9dd60b55b4$export$f0954fd7d5368655;
var $becf2d727f9cf450$var$EPSILON = 5e-5;
function $becf2d727f9cf450$var$isNotAroundZero(val) {
    return val > $becf2d727f9cf450$var$EPSILON || val < -$becf2d727f9cf450$var$EPSILON;
}
var $becf2d727f9cf450$var$scaleTmp = [];
var $becf2d727f9cf450$var$tmpTransform = [];
var $becf2d727f9cf450$var$originTransform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
var $becf2d727f9cf450$var$abs = Math.abs;
var $becf2d727f9cf450$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $becf2d727f9cf450$var$isNotAroundZero(this.rotation) || $becf2d727f9cf450$var$isNotAroundZero(this.x) || $becf2d727f9cf450$var$isNotAroundZero(this.y) || $becf2d727f9cf450$var$isNotAroundZero(this.scaleX - 1) || $becf2d727f9cf450$var$isNotAroundZero(this.scaleY - 1) || $becf2d727f9cf450$var$isNotAroundZero(this.skewX) || $becf2d727f9cf450$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $becf2d727f9cf450$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $becf2d727f9cf450$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $f41ebb9dd60b55b4$export$6e3a27864ab166fe(m, parentTransform, m);
            else $f41ebb9dd60b55b4$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($becf2d727f9cf450$var$scaleTmp);
            var relX = $becf2d727f9cf450$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $becf2d727f9cf450$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($becf2d727f9cf450$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $becf2d727f9cf450$var$scaleTmp[0] || 0;
            var sy = (($becf2d727f9cf450$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $becf2d727f9cf450$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe($becf2d727f9cf450$var$tmpTransform, parent.invTransform, m);
            m = $becf2d727f9cf450$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $becf2d727f9cf450$var$originTransform[4] = ox;
            $becf2d727f9cf450$var$originTransform[5] = oy;
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe($becf2d727f9cf450$var$tmpTransform, m, $becf2d727f9cf450$var$originTransform);
            $becf2d727f9cf450$var$tmpTransform[4] -= ox;
            $becf2d727f9cf450$var$tmpTransform[5] -= oy;
            m = $becf2d727f9cf450$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $6de594cf8ac295ff$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $6de594cf8ac295ff$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $becf2d727f9cf450$var$abs(m[0] - 1) > 1e-10 && $becf2d727f9cf450$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($becf2d727f9cf450$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $becf2d727f9cf450$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $f41ebb9dd60b55b4$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $becf2d727f9cf450$export$98ab6203ec3396e2 = [
    "x",
    "y",
    "originX",
    "originY",
    "anchorX",
    "anchorY",
    "rotation",
    "scaleX",
    "scaleY",
    "skewX",
    "skewY"
];
function $becf2d727f9cf450$export$234b1c16dfa57d6a(target, source) {
    for(var i = 0; i < $becf2d727f9cf450$export$98ab6203ec3396e2.length; i++){
        var propName = $becf2d727f9cf450$export$98ab6203ec3396e2[i];
        target[propName] = source[propName];
    }
}
var $becf2d727f9cf450$export$2e2bcd8739ae039 = $becf2d727f9cf450$var$Transformable;








var $6c308355c7107803$var$textWidthCache = {};
function $6c308355c7107803$export$3c49c185de0c2bfc(text, font) {
    font = font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var cacheOfFont = $6c308355c7107803$var$textWidthCache[font];
    if (!cacheOfFont) cacheOfFont = $6c308355c7107803$var$textWidthCache[font] = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(500);
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function $6c308355c7107803$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $6c308355c7107803$export$3c49c185de0c2bfc(text, font);
    var height = $6c308355c7107803$export$56204a27a2958a55(font);
    var x = $6c308355c7107803$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $6c308355c7107803$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $6c308355c7107803$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || "") + "").split("\n");
    var len = textLines.length;
    if (len === 1) return $6c308355c7107803$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $6c308355c7107803$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $6c308355c7107803$export$eb5a525ef00ef9a4(x, width, textAlign) {
    if (textAlign === "right") x -= width;
    else if (textAlign === "center") x -= width / 2;
    return x;
}
function $6c308355c7107803$export$bf7d6802d2badd9(y, height, verticalAlign) {
    if (verticalAlign === "middle") y -= height / 2;
    else if (verticalAlign === "bottom") y -= height;
    return y;
}
function $6c308355c7107803$export$56204a27a2958a55(font) {
    return $6c308355c7107803$export$3c49c185de0c2bfc("\u56FD", font);
}
function $6c308355c7107803$export$866cc30a33805630(text, font) {
    return (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(text, font);
}
function $6c308355c7107803$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === "string") {
        if (value.lastIndexOf("%") >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $6c308355c7107803$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || "inside";
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = "left";
    var textVerticalAlign = "top";
    if (textPosition instanceof Array) {
        x += $6c308355c7107803$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $6c308355c7107803$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case "left":
            x -= distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "right":
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "top":
            x += width / 2;
            y -= distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "bottom":
            x += width / 2;
            y += height + distance;
            textAlign = "center";
            break;
        case "inside":
            x += width / 2;
            y += halfHeight;
            textAlign = "center";
            textVerticalAlign = "middle";
            break;
        case "insideLeft":
            x += distance;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "insideRight":
            x += width - distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "insideTop":
            x += width / 2;
            y += distance;
            textAlign = "center";
            break;
        case "insideBottom":
            x += width / 2;
            y += height - distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "insideTopLeft":
            x += distance;
            y += distance;
            break;
        case "insideTopRight":
            x += width - distance;
            y += distance;
            textAlign = "right";
            break;
        case "insideBottomLeft":
            x += distance;
            y += height - distance;
            textVerticalAlign = "bottom";
            break;
        case "insideBottomRight":
            x += width - distance;
            y += height - distance;
            textAlign = "right";
            textVerticalAlign = "bottom";
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}






var $4bb0f26b847654d5$export$97b5e845c7286801 = "__zr_normal__";
var $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).concat([
    "ignore"
]);
var $4bb0f26b847654d5$var$DEFAULT_ANIMATABLE_MAP = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)((0, $becf2d727f9cf450$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $4bb0f26b847654d5$var$tmpTextPosCalcRes = {};
var $4bb0f26b847654d5$var$tmpBoundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $4bb0f26b847654d5$var$Element = function() {
    function Element(props) {
        this.id = (0, $7a1bd9c2710fea0d$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case "horizontal":
                dy = 0;
                break;
            case "vertical":
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = $4bb0f26b847654d5$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
                if (this.calculateTextPosition) this.calculateTextPosition($4bb0f26b847654d5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $6c308355c7107803$export$eee3603b512feab7)($4bb0f26b847654d5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $4bb0f26b847654d5$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $4bb0f26b847654d5$var$tmpTextPosCalcRes.y;
                textAlign = $4bb0f26b847654d5$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $4bb0f26b847654d5$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === "center") {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null ? typeof textConfig.position === "string" && textConfig.position.indexOf("inside") >= 0 : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === "auto") textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === "auto") {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === "auto") textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === "auto") {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || "#000";
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return "#fff";
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return "#000";
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $4b0cedd85979c776$export$3c6e95f318c8369b) : (0, $4b0cedd85979c776$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === "string" && (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $2c037f5bda6341ca$export$fac44ee5b035f737)(colorArr, "rgba");
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === "textConfig") this.setTextConfig(value);
        else if (key === "textContent") this.setTextContent(value);
        else if (key === "clipPath") this.setClipPath(value);
        else if (key === "extra") {
            this.extra = this.extra || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === "string") this.attrKV(keyOrObj, value);
        else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $4bb0f26b847654d5$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($4bb0f26b847654d5$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $4bb0f26b847654d5$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $7a1bd9c2710fea0d$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(","), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var isSilent = this.silent;
        var ancestor = this.parent;
        while(!isSilent && ancestor){
            if (ancestor.silent) {
                isSilent = true;
                break;
            }
            ancestor = ancestor.parent;
        }
        return isSilent;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $4bb0f26b847654d5$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = "element";
        elProto.name = "";
        elProto.ignore = elProto.silent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = elProto.__inHover = false;
        elProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty("position", "_legacyPos", "x", "y");
            createLegacyProperty("scale", "_legacyScale", "scaleX", "scaleY");
            createLegacyProperty("origin", "_legacyOrigin", "originX", "originY");
        }
    }();
    return Element;
}();
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($4bb0f26b847654d5$var$Element, (0, $63441a86293f101f$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($4bb0f26b847654d5$var$Element, (0, $becf2d727f9cf450$export$2e2bcd8739ae039));
function $4bb0f26b847654d5$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $4bb0f26b847654d5$var$animateToShallow(animatable, "", animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $4bb0f26b847654d5$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $4bb0f26b847654d5$var$is2DArray(value) {
    return (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value[0]);
}
function $4bb0f26b847654d5$var$copyValue(target, source, key) {
    if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(source[key])) {
        if (!(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $4bb0f26b847654d5$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($4bb0f26b847654d5$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $4bb0f26b847654d5$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $4bb0f26b847654d5$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $4bb0f26b847654d5$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val1) && (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val2) && $4bb0f26b847654d5$var$is1DArraySame(val1, val2);
}
function $4bb0f26b847654d5$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $4bb0f26b847654d5$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(targetVal) && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(targetVal) && !(0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $4bb0f26b847654d5$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$4bb0f26b847654d5$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $76d8a142a20276fc$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $4bb0f26b847654d5$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $4bb0f26b847654d5$export$2e2bcd8739ae039 = $4bb0f26b847654d5$var$Element;



var $7ef7583d8302ffce$var$Group = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $4bb0f26b847654d5$export$2e2bcd8739ae039));
$7ef7583d8302ffce$var$Group.prototype.type = "group";
var $7ef7583d8302ffce$export$2e2bcd8739ae039 = $7ef7583d8302ffce$var$Group;


var $6eba88f9eebe6af9$var$painterCtors = {};
var $6eba88f9eebe6af9$var$instances = {};
function $6eba88f9eebe6af9$var$delInstance(id) {
    delete $6eba88f9eebe6af9$var$instances[id];
}
function $6eba88f9eebe6af9$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === "string") return (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
    }
    return false;
}
var $6eba88f9eebe6af9$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $319574df0bc66e80$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || "canvas";
        if (!$6eba88f9eebe6af9$var$painterCtors[rendererType]) rendererType = $7a1bd9c2710fea0d$export$ed97f33186d4b816($6eba88f9eebe6af9$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $6eba88f9eebe6af9$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $c0dbbc6989260eee$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === "auto" ? (0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $b30f5d021af2ec5a$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $fad434a4044c956a$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(true);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $6eba88f9eebe6af9$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (this._disposed) return;
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = (0, $fad434a4044c956a$export$1428f42a7de81803)();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = (0, $fad434a4044c956a$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger("rendered", {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === "canvas") this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $6eba88f9eebe6af9$var$delInstance(this.id);
    };
    return ZRender;
}();
function $6eba88f9eebe6af9$export$2cd8252107eb640b(dom, opts) {
    var zr = new $6eba88f9eebe6af9$var$ZRender($7a1bd9c2710fea0d$export$46e8f25c7328f77e(), dom, opts);
    $6eba88f9eebe6af9$var$instances[zr.id] = zr;
    return zr;
}
function $6eba88f9eebe6af9$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $6eba88f9eebe6af9$export$825f692fb04800ef() {
    for(var key in $6eba88f9eebe6af9$var$instances)if ($6eba88f9eebe6af9$var$instances.hasOwnProperty(key)) $6eba88f9eebe6af9$var$instances[key].dispose();
    $6eba88f9eebe6af9$var$instances = {};
}
function $6eba88f9eebe6af9$export$8bedcca5bbd73999(id) {
    return $6eba88f9eebe6af9$var$instances[id];
}
function $6eba88f9eebe6af9$export$a3e793ccb11823a5(name, Ctor) {
    $6eba88f9eebe6af9$var$painterCtors[name] = Ctor;
}
var $6eba88f9eebe6af9$var$ssrDataGetter;
function $6eba88f9eebe6af9$export$dd7015a5412ca583(el) {
    if (typeof $6eba88f9eebe6af9$var$ssrDataGetter === "function") return $6eba88f9eebe6af9$var$ssrDataGetter(el);
}
function $6eba88f9eebe6af9$export$e7a09d7fe68a4f7(getter) {
    $6eba88f9eebe6af9$var$ssrDataGetter = getter;
}
var $6eba88f9eebe6af9$export$83d89fbfd8236492 = "5.5.0";






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $cfc1f3b422a3185f$var$RADIAN_EPSILON = 1e-4;
// Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $cfc1f3b422a3185f$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
}
function $cfc1f3b422a3185f$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
function $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(percent, all) {
    switch(percent){
        case "center":
        case "middle":
            percent = "50%";
            break;
        case "left":
        case "top":
            percent = "0%";
            break;
        case "right":
        case "bottom":
            percent = "100%";
            break;
    }
    if ($7a1bd9c2710fea0d$export$844ec244b1367d54(percent)) {
        if ($cfc1f3b422a3185f$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
function $cfc1f3b422a3185f$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) precision = 10;
    // Avoid range error
    precision = Math.min(Math.max(0, precision), $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $cfc1f3b422a3185f$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $cfc1f3b422a3185f$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $cfc1f3b422a3185f$export$6d86ba4ca4984d31(val);
}
function $cfc1f3b422a3185f$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf("e");
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf(".");
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $cfc1f3b422a3185f$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10);
    // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $cfc1f3b422a3185f$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $cfc1f3b422a3185f$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $cfc1f3b422a3185f$export$222dabb13d5320df(valueList, precision) {
    var sum = $7a1bd9c2710fea0d$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = Math.pow(10, precision);
    var votesPerQuota = $7a1bd9c2710fea0d$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $7a1bd9c2710fea0d$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $7a1bd9c2710fea0d$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $7a1bd9c2710fea0d$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $cfc1f3b422a3185f$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($cfc1f3b422a3185f$export$e0c74b50bbd10f68(val0), $cfc1f3b422a3185f$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $cfc1f3b422a3185f$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $cfc1f3b422a3185f$export$18510406f204a1b9 = 9007199254740991;
function $cfc1f3b422a3185f$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $cfc1f3b422a3185f$export$d1df570aea2868f(val) {
    return val > -$cfc1f3b422a3185f$var$RADIAN_EPSILON && val < $cfc1f3b422a3185f$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $cfc1f3b422a3185f$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $cfc1f3b422a3185f$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $cfc1f3b422a3185f$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== "Z") hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $cfc1f3b422a3185f$export$82dd68b83a44b253(val) {
    return Math.pow(10, $cfc1f3b422a3185f$export$97256a17b20a0c24(val));
}
function $cfc1f3b422a3185f$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $cfc1f3b422a3185f$export$7a695fe44258210b(val, round) {
    var exponent = $cfc1f3b422a3185f$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $cfc1f3b422a3185f$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $cfc1f3b422a3185f$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $cfc1f3b422a3185f$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$7a1bd9c2710fea0d$export$844ec244b1367d54(val) || val.indexOf("x") <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $cfc1f3b422a3185f$export$e90fb89750dba83f(val) {
    return !isNaN($cfc1f3b422a3185f$export$8b4007b942b45a96(val));
}
function $cfc1f3b422a3185f$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $cfc1f3b422a3185f$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $cfc1f3b422a3185f$export$a368fd580c0d0fe4(b, a % b);
}
function $cfc1f3b422a3185f$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $cfc1f3b422a3185f$export$a368fd580c0d0fe4(a, b);
}



function $76d619f648247e6d$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX = "series\x00";
var $76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX = "\x00_ec_\x00";
function $76d619f648247e6d$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $76d619f648247e6d$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $76d619f648247e6d$export$df45610347a602ad = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "rich",
    "tag",
    "color",
    "textBorderColor",
    "textBorderWidth",
    "width",
    "height",
    "lineHeight",
    "align",
    "verticalAlign",
    "baseline",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY",
    "backgroundColor",
    "borderColor",
    "borderWidth",
    "borderRadius",
    "padding"
];
function $76d619f648247e6d$export$2c944e12edb48d4b(dataItem) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem) && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $76d619f648247e6d$export$3e1a543f33ef6883(dataItem) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $76d619f648247e6d$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === "normalMerge";
    var isReplaceMergeMode = mode === "replaceMerge";
    var isReplaceAllMode = mode === "replaceAll";
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $76d619f648247e6d$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $76d619f648247e6d$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $76d619f648247e6d$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $76d619f648247e6d$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $76d619f648247e6d$var$mappingInReplaceAllMode(result, newCmptOptions);
    $76d619f648247e6d$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $76d619f648247e6d$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === "replaceAll") return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === "replaceMerge" || $76d619f648247e6d$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $76d619f648247e6d$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $76d619f648247e6d$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $76d619f648247e6d$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$76d619f648247e6d$export$feece3e7d52a102b(cmptOption) && !$76d619f648247e6d$export$feece3e7d52a102b(existing) && $76d619f648247e6d$var$keyExistAndEqual("name", existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $76d619f648247e6d$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $76d619f648247e6d$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$76d619f648247e6d$var$keyExistAndEqual("id", cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $76d619f648247e6d$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $76d619f648247e6d$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, "id duplicates: " + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $76d619f648247e6d$var$makeComparableKey(opt.name) : existing ? existing.name : $76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $76d619f648247e6d$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $76d619f648247e6d$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = "\x00" + keyInfo.name + "\x00" + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $76d619f648247e6d$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $76d619f648247e6d$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $76d619f648247e6d$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $76d619f648247e6d$var$makeComparableKey(val) {
    return $76d619f648247e6d$export$fb1a222ba5dd6e51(val, "");
}
function $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(idOrName) || (0, $7a1bd9c2710fea0d$export$29d0bb2a4e07b252)(idOrName) ? idOrName + "" : defaultValue;
}
function $76d619f648247e6d$var$warnInvalidateIdOrName(idOrName) {}
function $76d619f648247e6d$var$isValidIdOrName(idOrName) {
    return (0, $7a1bd9c2710fea0d$export$29d0bb2a4e07b252)(idOrName) || (0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(idOrName);
}
function $76d619f648247e6d$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $76d619f648247e6d$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $76d619f648247e6d$var$makeComparableKey(cmptOption.id).indexOf($76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $76d619f648247e6d$export$1753133c42e665e8(idSuffix) {
    return $76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $76d619f648247e6d$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $76d619f648247e6d$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $76d619f648247e6d$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $76d619f648247e6d$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $76d619f648247e6d$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $76d619f648247e6d$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $76d619f648247e6d$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(payload.name) ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $76d619f648247e6d$export$64df9f8d92ae083f() {
    var key = "__ec_inner_" + $76d619f648247e6d$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $76d619f648247e6d$var$innerUniqueIndex = (0, $cfc1f3b422a3185f$export$474d2ec9aa44a22)();
function $76d619f648247e6d$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $76d619f648247e6d$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $76d619f648247e6d$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + "Models"] = queryResult.models;
        result[mainType + "Model"] = queryResult.models[0];
    });
    return result;
}
function $76d619f648247e6d$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + "Index"] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illgal keys.
        if (key === "dataIndex" || key === "dataIndexInside") {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || "").toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $76d619f648247e6d$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $76d619f648247e6d$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $76d619f648247e6d$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $76d619f648247e6d$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === "none" || indexOption === false) {
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
        result.models = [];
        return result;
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === "all") {
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(opt.enableAll, '`"all"` is not a valid value on index option.');
        indexOption = idOption = nameOption = null;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $76d619f648247e6d$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $76d619f648247e6d$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $76d619f648247e6d$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === "auto") // Using html when `document` exists, use richText otherwise
    return (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported ? "html" : "richText";
    else return renderModeOption || "html";
}
function $76d619f648247e6d$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $76d619f648247e6d$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === "auto";
    if (targetValue == null) return targetValue;
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(targetValue)) {
        var value = $76d619f648247e6d$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === "ordinal") // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $76d619f648247e6d$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(leftVal), (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $cd5f95cf03b4e3e7$var$TYPE_DELIMITER = ".";
var $cd5f95cf03b4e3e7$var$IS_CONTAINER = "___EC__COMPONENT__CONTAINER___";
var $cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS = "___EC__EXTENDED_CLASS___";
function $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: "",
        sub: ""
    };
    if (componentType) {
        var typeArr = componentType.split($cd5f95cf03b4e3e7$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || "";
        ret.sub = typeArr[1] || "";
    }
    return ret;
}
/**
 * @public
 */ function $cd5f95cf03b4e3e7$var$checkClassType(componentType) {
    $7a1bd9c2710fea0d$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $cd5f95cf03b4e3e7$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS]);
}
function $cd5f95cf03b4e3e7$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($cd5f95cf03b4e3e7$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $7a1bd9c2710fea0d$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $cd5f95cf03b4e3e7$var$superCall;
        ExtendedClass.superApply = $cd5f95cf03b4e3e7$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $cd5f95cf03b4e3e7$var$isESClass(fn) {
    return $7a1bd9c2710fea0d$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $cd5f95cf03b4e3e7$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $cd5f95cf03b4e3e7$var$classBase = Math.round(Math.random() * 10);
function $cd5f95cf03b4e3e7$export$e1aac4552ae82081(target) {
    var classAttr = [
        "__\x00is_clz",
        $cd5f95cf03b4e3e7$var$classBase++
    ].join("_");
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $cd5f95cf03b4e3e7$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cd5f95cf03b4e3e7$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cd5f95cf03b4e3e7$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $cd5f95cf03b4e3e7$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $cd5f95cf03b4e3e7$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + "." + "type should be specified." : "Component " + mainType + "." + (subType || "") + " is used but not imported.");
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) $7a1bd9c2710fea0d$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $cd5f95cf03b4e3e7$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$cd5f95cf03b4e3e7$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$cd5f95cf03b4e3e7$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $06542048a26d4d91$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $cb2a96727da5284d$export$52de6e304d934d85 = [
    [
        "fill",
        "color"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "opacity"
    ],
    [
        "shadowColor"
    ]
];
var $cb2a96727da5284d$var$getAreaStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($cb2a96727da5284d$export$52de6e304d934d85);
var $cb2a96727da5284d$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $cb2a96727da5284d$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a53bd598adfb7ebe$var$globalImageCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(50);
function $a53bd598adfb7ebe$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === "string") {
        var cachedImgObj = $a53bd598adfb7ebe$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $a53bd598adfb7ebe$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === "string") {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $a53bd598adfb7ebe$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$a53bd598adfb7ebe$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $c6341dcc9d86826e$export$ef5e599365494451).loadImage(newImageOrSrc, $a53bd598adfb7ebe$var$imageOnLoad, $a53bd598adfb7ebe$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $a53bd598adfb7ebe$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $a53bd598adfb7ebe$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $a53bd598adfb7ebe$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}




var $64fa9b3825ba2dec$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $64fa9b3825ba2dec$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) return "";
    var textLines = (text + "").split("\n");
    options = $64fa9b3825ba2dec$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $64fa9b3825ba2dec$var$truncateSingleLine(textLines[i], options);
    return textLines.join("\n");
}
function $64fa9b3825ba2dec$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, options);
    preparedOpts.font = font;
    ellipsis = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(ellipsis, "...");
    preparedOpts.maxIterations = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.minChar, 0);
    preparedOpts.cnCharWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)("\u56FD", font);
    var ascCharWidth = preparedOpts.ascCharWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)("a", font);
    preparedOpts.placeholder = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.placeholder, "");
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = "";
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $64fa9b3825ba2dec$var$truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) return "";
    var lineWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(textLine, font);
    if (lineWidth <= containerWidth) return textLine;
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $64fa9b3825ba2dec$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(textLine, font);
    }
    if (textLine === "") textLine = options.placeholder;
    return textLine;
}
function $64fa9b3825ba2dec$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function $64fa9b3825ba2dec$export$5772575e34ef80f9(text, style) {
    text != null && (text += "");
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === "truncate";
    var calculatedLineHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
    var lineHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var bgColorDrawn = !!style.backgroundColor;
    var truncateLineOverflow = style.lineOverflow === "truncate";
    var width = style.width;
    var lines;
    if (width != null && (overflow === "break" || overflow === "breakAll")) lines = text ? $64fa9b3825ba2dec$var$wrapText(text, style.font, width, overflow === "breakAll", 0).lines : [];
    else lines = text ? text.split("\n") : [];
    var contentHeight = lines.length * lineHeight;
    var height = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        lines = lines.slice(0, lineCount);
    }
    if (text && truncate && width != null) {
        var options = $64fa9b3825ba2dec$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        for(var i = 0; i < lines.length; i++)lines[i] = $64fa9b3825ba2dec$var$truncateSingleLine(lines[i], options);
    }
    var outerHeight = height;
    var contentWidth = 0;
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $6c308355c7107803$export$3c49c185de0c2bfc)(lines[i], font), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = contentWidth;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        outerWidth += padding[1] + padding[3];
        width += padding[1] + padding[3];
    }
    if (bgColorDrawn) outerWidth = width;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width
    };
}
var $64fa9b3825ba2dec$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $64fa9b3825ba2dec$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $64fa9b3825ba2dec$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
    }
    return RichTextContentBlock;
}();
function $64fa9b3825ba2dec$export$15ec9472ff2d721(text, style) {
    var contentBlock = new $64fa9b3825ba2dec$export$ca607d3c98caaf7e();
    text != null && (text += "");
    if (!text) return contentBlock;
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === "break" || overflow === "breakAll") && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === "breakAll"
    } : null;
    var lastIndex = $64fa9b3825ba2dec$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $64fa9b3825ba2dec$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $64fa9b3825ba2dec$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $64fa9b3825ba2dec$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $64fa9b3825ba2dec$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $64fa9b3825ba2dec$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === "truncate";
    var truncateLine = style.lineOverflow === "truncate";
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || "middle";
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === "auto";
            if (typeof styleTokenWidth === "string" && styleTokenWidth.charAt(styleTokenWidth.length - 1) === "%") {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $a53bd598adfb7ebe$export$1b614f30ac2c8867(bgImg);
                        if ($a53bd598adfb7ebe$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = "";
                        token.width = token.contentWidth = 0;
                    } else {
                        token.text = $64fa9b3825ba2dec$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.width = token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
                    }
                } else token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $64fa9b3825ba2dec$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === "";
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== "auto") {
            var outerWidth_1 = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split("\n");
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $64fa9b3825ba2dec$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    } else strLines = str.split("\n");
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $64fa9b3825ba2dec$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === "number") token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $6c308355c7107803$export$3c49c185de0c2bfc)(text, font);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $64fa9b3825ba2dec$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $64fa9b3825ba2dec$var$RichTextLine([
            token
        ]));
    }
}
function $64fa9b3825ba2dec$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $64fa9b3825ba2dec$var$breakCharMap = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(",&?/;] ".split(""), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $64fa9b3825ba2dec$var$isWordBreakChar(ch) {
    if ($64fa9b3825ba2dec$var$isAlphabeticLetter(ch)) {
        if ($64fa9b3825ba2dec$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $64fa9b3825ba2dec$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = "";
    var currentWord = "";
    var currentWordWidth = 0;
    var accumWidth = 0;
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === "\n") {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = "";
            currentWord = "";
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(ch, font);
        var inWord = isBreakAll ? false : !$64fa9b3825ba2dec$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = "";
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = "";
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = "";
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = "";
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = "";
        currentWordWidth = 0;
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}








var $56206a6cb4666931$var$STYLE_MAGIC_KEY = "__zr_style_" + Math.round(Math.random() * 10);
var $56206a6cb4666931$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: "#000",
    opacity: 1,
    blend: "source-over"
};
var $56206a6cb4666931$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$56206a6cb4666931$export$737672163db00fe3[$56206a6cb4666931$var$STYLE_MAGIC_KEY] = true;
var $56206a6cb4666931$var$PRIMARY_STATES_KEYS = [
    "z",
    "z2",
    "invisible"
];
var $56206a6cb4666931$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    "invisible"
];
var $56206a6cb4666931$var$Displayable = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === "style") this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $56206a6cb4666931$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate("style", loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === "style") this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== "style") _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === "string") this.style[keyOrObj] = value;
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($56206a6cb4666931$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$56206a6cb4666931$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$56206a6cb4666931$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $56206a6cb4666931$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $56206a6cb4666931$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $56206a6cb4666931$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $56206a6cb4666931$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = "displayable";
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = "pointer";
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) | (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $4bb0f26b847654d5$export$2e2bcd8739ae039));
var $56206a6cb4666931$var$tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $56206a6cb4666931$var$viewRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $56206a6cb4666931$var$isDisplayableCulled(el, width, height) {
    $56206a6cb4666931$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $56206a6cb4666931$var$tmpRect.applyTransform(el.transform);
    $56206a6cb4666931$var$viewRect.width = width;
    $56206a6cb4666931$var$viewRect.height = height;
    return !$56206a6cb4666931$var$tmpRect.intersect($56206a6cb4666931$var$viewRect);
}
var $56206a6cb4666931$export$2e2bcd8739ae039 = $56206a6cb4666931$var$Displayable;










var $af3aab2435198f82$var$mathMin = Math.min;
var $af3aab2435198f82$var$mathMax = Math.max;
var $af3aab2435198f82$var$mathSin = Math.sin;
var $af3aab2435198f82$var$mathCos = Math.cos;
var $af3aab2435198f82$var$PI2 = Math.PI * 2;
var $af3aab2435198f82$var$start = $6de594cf8ac295ff$export$185802fd694ee1f5();
var $af3aab2435198f82$var$end = $6de594cf8ac295ff$export$185802fd694ee1f5();
var $af3aab2435198f82$var$extremity = $6de594cf8ac295ff$export$185802fd694ee1f5();
function $af3aab2435198f82$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $af3aab2435198f82$var$mathMin(left, p[0]);
        right = $af3aab2435198f82$var$mathMax(right, p[0]);
        top = $af3aab2435198f82$var$mathMin(top, p[1]);
        bottom = $af3aab2435198f82$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $af3aab2435198f82$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $af3aab2435198f82$var$mathMin(x0, x1);
    min[1] = $af3aab2435198f82$var$mathMin(y0, y1);
    max[0] = $af3aab2435198f82$var$mathMax(x0, x1);
    max[1] = $af3aab2435198f82$var$mathMax(y0, y1);
}
var $af3aab2435198f82$var$xDim = [];
var $af3aab2435198f82$var$yDim = [];
function $af3aab2435198f82$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $747cfc5611b57cea$export$df1a172f100d0457;
    var cubicAt = $747cfc5611b57cea$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $af3aab2435198f82$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $af3aab2435198f82$var$xDim[i]);
        min[0] = $af3aab2435198f82$var$mathMin(x, min[0]);
        max[0] = $af3aab2435198f82$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $af3aab2435198f82$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $af3aab2435198f82$var$yDim[i]);
        min[1] = $af3aab2435198f82$var$mathMin(y, min[1]);
        max[1] = $af3aab2435198f82$var$mathMax(y, max[1]);
    }
    min[0] = $af3aab2435198f82$var$mathMin(x0, min[0]);
    max[0] = $af3aab2435198f82$var$mathMax(x0, max[0]);
    min[0] = $af3aab2435198f82$var$mathMin(x3, min[0]);
    max[0] = $af3aab2435198f82$var$mathMax(x3, max[0]);
    min[1] = $af3aab2435198f82$var$mathMin(y0, min[1]);
    max[1] = $af3aab2435198f82$var$mathMax(y0, max[1]);
    min[1] = $af3aab2435198f82$var$mathMin(y3, min[1]);
    max[1] = $af3aab2435198f82$var$mathMax(y3, max[1]);
}
function $af3aab2435198f82$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $747cfc5611b57cea$export$752e1f8c6e7f7e11;
    var quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
    var tx = $af3aab2435198f82$var$mathMax($af3aab2435198f82$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $af3aab2435198f82$var$mathMax($af3aab2435198f82$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $af3aab2435198f82$var$mathMin(x0, x2, x);
    min[1] = $af3aab2435198f82$var$mathMin(y0, y2, y);
    max[0] = $af3aab2435198f82$var$mathMax(x0, x2, x);
    max[1] = $af3aab2435198f82$var$mathMax(y0, y2, y);
}
function $af3aab2435198f82$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $6de594cf8ac295ff$export$96ec731ed4dcb222;
    var vec2Max = $6de594cf8ac295ff$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $af3aab2435198f82$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $af3aab2435198f82$var$start[0] = $af3aab2435198f82$var$mathCos(startAngle) * rx + x;
    $af3aab2435198f82$var$start[1] = $af3aab2435198f82$var$mathSin(startAngle) * ry + y;
    $af3aab2435198f82$var$end[0] = $af3aab2435198f82$var$mathCos(endAngle) * rx + x;
    $af3aab2435198f82$var$end[1] = $af3aab2435198f82$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $af3aab2435198f82$var$start, $af3aab2435198f82$var$end);
    vec2Max(max, $af3aab2435198f82$var$start, $af3aab2435198f82$var$end);
    startAngle = startAngle % $af3aab2435198f82$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $af3aab2435198f82$var$PI2;
    endAngle = endAngle % $af3aab2435198f82$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $af3aab2435198f82$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $af3aab2435198f82$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $af3aab2435198f82$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $af3aab2435198f82$var$extremity[0] = $af3aab2435198f82$var$mathCos(angle) * rx + x;
        $af3aab2435198f82$var$extremity[1] = $af3aab2435198f82$var$mathSin(angle) * ry + y;
        vec2Min(min, $af3aab2435198f82$var$extremity, min);
        vec2Max(max, $af3aab2435198f82$var$extremity, max);
    }
}



var $20ebe2448f123f2e$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $20ebe2448f123f2e$var$tmpOutX = [];
var $20ebe2448f123f2e$var$tmpOutY = [];
var $20ebe2448f123f2e$var$min = [];
var $20ebe2448f123f2e$var$max = [];
var $20ebe2448f123f2e$var$min2 = [];
var $20ebe2448f123f2e$var$max2 = [];
var $20ebe2448f123f2e$var$mathMin = Math.min;
var $20ebe2448f123f2e$var$mathMax = Math.max;
var $20ebe2448f123f2e$var$mathCos = Math.cos;
var $20ebe2448f123f2e$var$mathSin = Math.sin;
var $20ebe2448f123f2e$var$mathAbs = Math.abs;
var $20ebe2448f123f2e$var$PI = Math.PI;
var $20ebe2448f123f2e$var$PI2 = $20ebe2448f123f2e$var$PI * 2;
var $20ebe2448f123f2e$var$hasTypedArray = typeof Float32Array !== "undefined";
var $20ebe2448f123f2e$var$tmpAngles = [];
function $20ebe2448f123f2e$var$modPI2(radian) {
    var n = Math.round(radian / $20ebe2448f123f2e$var$PI * 1e8) / 1e8;
    return n % 2 * $20ebe2448f123f2e$var$PI;
}
function $20ebe2448f123f2e$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $20ebe2448f123f2e$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $20ebe2448f123f2e$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $20ebe2448f123f2e$var$PI2) newEndAngle = newStartAngle + $20ebe2448f123f2e$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $20ebe2448f123f2e$var$PI2) newEndAngle = newStartAngle - $20ebe2448f123f2e$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($20ebe2448f123f2e$var$PI2 - $20ebe2448f123f2e$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($20ebe2448f123f2e$var$PI2 - $20ebe2448f123f2e$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $20ebe2448f123f2e$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $20ebe2448f123f2e$var$mathAbs(segmentIgnoreThreshold / (0, $4b0cedd85979c776$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $20ebe2448f123f2e$var$mathAbs(segmentIgnoreThreshold / (0, $4b0cedd85979c776$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $20ebe2448f123f2e$var$mathAbs(x - this._xi);
        var dy = $20ebe2448f123f2e$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($20ebe2448f123f2e$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $20ebe2448f123f2e$var$tmpAngles[0] = startAngle;
        $20ebe2448f123f2e$var$tmpAngles[1] = endAngle;
        $20ebe2448f123f2e$export$bc668021e937022a($20ebe2448f123f2e$var$tmpAngles, anticlockwise);
        startAngle = $20ebe2448f123f2e$var$tmpAngles[0];
        endAngle = $20ebe2448f123f2e$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($20ebe2448f123f2e$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $20ebe2448f123f2e$var$mathCos(endAngle) * r + cx;
        this._yi = $20ebe2448f123f2e$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($20ebe2448f123f2e$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $20ebe2448f123f2e$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($20ebe2448f123f2e$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($20ebe2448f123f2e$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $20ebe2448f123f2e$var$min[0] = $20ebe2448f123f2e$var$min[1] = $20ebe2448f123f2e$var$min2[0] = $20ebe2448f123f2e$var$min2[1] = Number.MAX_VALUE;
        $20ebe2448f123f2e$var$max[0] = $20ebe2448f123f2e$var$max[1] = $20ebe2448f123f2e$var$max2[0] = $20ebe2448f123f2e$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $20ebe2448f123f2e$var$min2[0] = x0;
                    $20ebe2448f123f2e$var$min2[1] = y0;
                    $20ebe2448f123f2e$var$max2[0] = x0;
                    $20ebe2448f123f2e$var$max2[1] = y0;
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    (0, $af3aab2435198f82$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    (0, $af3aab2435198f82$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    (0, $af3aab2435198f82$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $af3aab2435198f82$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $af3aab2435198f82$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $6de594cf8ac295ff$export$96ec731ed4dcb222($20ebe2448f123f2e$var$min, $20ebe2448f123f2e$var$min, $20ebe2448f123f2e$var$min2);
            $6de594cf8ac295ff$export$8960430cfd85939f($20ebe2448f123f2e$var$max, $20ebe2448f123f2e$var$max, $20ebe2448f123f2e$var$max2);
        }
        if (i === 0) $20ebe2448f123f2e$var$min[0] = $20ebe2448f123f2e$var$min[1] = $20ebe2448f123f2e$var$max[0] = $20ebe2448f123f2e$var$max[1] = 0;
        return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)($20ebe2448f123f2e$var$min[0], $20ebe2448f123f2e$var$min[1], $20ebe2448f123f2e$var$max[0] - $20ebe2448f123f2e$var$min[0], $20ebe2448f123f2e$var$max[1] - $20ebe2448f123f2e$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($20ebe2448f123f2e$var$mathAbs(dx) > ux || $20ebe2448f123f2e$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $747cfc5611b57cea$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $747cfc5611b57cea$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $20ebe2448f123f2e$var$mathMax(rx, ry) * $20ebe2448f123f2e$var$mathMin($20ebe2448f123f2e$var$PI2, Math.abs(delta));
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $20ebe2448f123f2e$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $20ebe2448f123f2e$var$mathAbs(x - xi);
                    var dy = $20ebe2448f123f2e$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $20ebe2448f123f2e$var$tmpOutX);
                            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $20ebe2448f123f2e$var$tmpOutY);
                            ctx.bezierCurveTo($20ebe2448f123f2e$var$tmpOutX[1], $20ebe2448f123f2e$var$tmpOutY[1], $20ebe2448f123f2e$var$tmpOutX[2], $20ebe2448f123f2e$var$tmpOutY[2], $20ebe2448f123f2e$var$tmpOutX[3], $20ebe2448f123f2e$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $747cfc5611b57cea$export$117c659e21a7a060)(xi, x1, x2, t, $20ebe2448f123f2e$var$tmpOutX);
                            (0, $747cfc5611b57cea$export$117c659e21a7a060)(yi, y1, y2, t, $20ebe2448f123f2e$var$tmpOutY);
                            ctx.quadraticCurveTo($20ebe2448f123f2e$var$tmpOutX[1], $20ebe2448f123f2e$var$tmpOutY[1], $20ebe2448f123f2e$var$tmpOutX[2], $20ebe2448f123f2e$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $20ebe2448f123f2e$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $20ebe2448f123f2e$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $20ebe2448f123f2e$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $20ebe2448f123f2e$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $20ebe2448f123f2e$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = $20ebe2448f123f2e$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $20ebe2448f123f2e$export$2e2bcd8739ae039 = $20ebe2448f123f2e$var$PathProxy;



function $beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $e22e0fd22a005e8a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $747cfc5611b57cea$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $a1d80a5bf05b597b$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $747cfc5611b57cea$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $b44a8536c7214e4f$var$PI2 = Math.PI * 2;
function $b44a8536c7214e4f$export$d44861331f213635(angle) {
    angle %= $b44a8536c7214e4f$var$PI2;
    if (angle < 0) angle += $b44a8536c7214e4f$var$PI2;
    return angle;
}


var $6e9b0f2fe4e39376$var$PI2 = Math.PI * 2;
function $6e9b0f2fe4e39376$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $6e9b0f2fe4e39376$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(startAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $6e9b0f2fe4e39376$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $6e9b0f2fe4e39376$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $6e9b0f2fe4e39376$var$PI2 >= startAngle && angle + $6e9b0f2fe4e39376$var$PI2 <= endAngle;
}



function $e1acc0b10546155f$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $347a114fcc5254ff$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $347a114fcc5254ff$var$PI2 = Math.PI * 2;
var $347a114fcc5254ff$var$EPSILON = 1e-4;
function $347a114fcc5254ff$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $347a114fcc5254ff$var$EPSILON;
}
var $347a114fcc5254ff$var$roots = [
    -1,
    -1,
    -1
];
var $347a114fcc5254ff$var$extrema = [
    -1,
    -1
];
function $347a114fcc5254ff$var$swapExtrema() {
    var tmp = $347a114fcc5254ff$var$extrema[0];
    $347a114fcc5254ff$var$extrema[0] = $347a114fcc5254ff$var$extrema[1];
    $347a114fcc5254ff$var$extrema[1] = tmp;
}
function $347a114fcc5254ff$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $747cfc5611b57cea$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $347a114fcc5254ff$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $347a114fcc5254ff$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $747cfc5611b57cea$export$df1a172f100d0457(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema);
                if ($347a114fcc5254ff$var$extrema[1] < $347a114fcc5254ff$var$extrema[0] && nExtrema > 1) $347a114fcc5254ff$var$swapExtrema();
                y0_ = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema[0]);
                if (nExtrema > 1) y1_ = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $347a114fcc5254ff$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $347a114fcc5254ff$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $347a114fcc5254ff$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $347a114fcc5254ff$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $747cfc5611b57cea$export$fd895ac7ee764967(y0, y1, y2, y, $347a114fcc5254ff$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $747cfc5611b57cea$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $347a114fcc5254ff$var$roots[i] === 0 || $347a114fcc5254ff$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, $347a114fcc5254ff$var$roots[i]);
                if (x_ < x) continue;
                if ($347a114fcc5254ff$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $347a114fcc5254ff$var$roots[0] === 0 || $347a114fcc5254ff$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, $347a114fcc5254ff$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $347a114fcc5254ff$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $347a114fcc5254ff$var$roots[0] = -tmp;
    $347a114fcc5254ff$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $347a114fcc5254ff$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $347a114fcc5254ff$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $347a114fcc5254ff$var$roots[0] + cx && x <= $347a114fcc5254ff$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $347a114fcc5254ff$var$PI2;
        endAngle += $347a114fcc5254ff$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $347a114fcc5254ff$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $347a114fcc5254ff$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $347a114fcc5254ff$var$PI2 >= startAngle && angle + $347a114fcc5254ff$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $347a114fcc5254ff$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $347a114fcc5254ff$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $347a114fcc5254ff$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $347a114fcc5254ff$var$CMD.L:
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.C:
                if (isStroke) {
                    if ($e22e0fd22a005e8a$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.Q:
                if (isStroke) {
                    if ($a1d80a5bf05b597b$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($6e9b0f2fe4e39376$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $347a114fcc5254ff$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $347a114fcc5254ff$var$CMD.Z:
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$347a114fcc5254ff$var$isAroundEqual(yi, y0)) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $347a114fcc5254ff$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $347a114fcc5254ff$var$containPath(pathProxy, 0, false, x, y);
}
function $347a114fcc5254ff$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $347a114fcc5254ff$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $b02ffe7acd508c08$export$deade517576e293a = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    fill: "#000",
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: "butt",
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $56206a6cb4666931$export$737672163db00fe3));
var $b02ffe7acd508c08$export$71bb6c3c6862c6a5 = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
var $b02ffe7acd508c08$var$pathCopyParams = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).concat([
    "invisible",
    "culling",
    "z",
    "z2",
    "zlevel",
    "parent"
]);
var $b02ffe7acd508c08$var$Path = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $b02ffe7acd508c08$var$pathCopyParams.length; ++i)decalEl[$b02ffe7acd508c08$var$pathCopyParams[i]] = this[$b02ffe7acd508c08$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === "style") {
                if (!this.style) this.useStyle(value);
                else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.style, value);
            } else if (key === "shape") (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== "none") {
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $4b0cedd85979c776$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $4b0cedd85979c776$export$27682248795c3c6b;
                return 0, $4b0cedd85979c776$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $4b0cedd85979c776$export$3c6e95f318c8369b;
        }
        return 0, $4b0cedd85979c776$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === "none" || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== "none";
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($347a114fcc5254ff$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $347a114fcc5254ff$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate("shape", loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === "style") this.dirtyStyle();
        else if (targetKey === "shape") this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === "shape") this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === "string") shape[keyOrObj] = value;
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($b02ffe7acd508c08$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === "object") this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $b02ffe7acd508c08$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === "function") Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = "path";
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) | (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671) | (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $b02ffe7acd508c08$export$2e2bcd8739ae039 = $b02ffe7acd508c08$var$Path;




var $c9d5c769fe2f591f$export$5fbb6d98091bcb56 = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: "left",
    textBaseline: "top",
    miterLimit: 2
}, (0, $b02ffe7acd508c08$export$deade517576e293a));
var $c9d5c769fe2f591f$var$TSpan = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== "none" && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== "none";
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($c9d5c769fe2f591f$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? text += "" : text = "";
            var rect = (0, $6c308355c7107803$export$c381147bfed79d9f)(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
$c9d5c769fe2f591f$var$TSpan.prototype.type = "tspan";
var $c9d5c769fe2f591f$export$2e2bcd8739ae039 = $c9d5c769fe2f591f$var$TSpan;








var $86adec94217b86c6$export$8993f922aeeac642 = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $56206a6cb4666931$export$737672163db00fe3));
var $86adec94217b86c6$export$4aba8ad70847a488 = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
function $86adec94217b86c6$var$isImageLike(source) {
    return !!(source && typeof source !== "string" && source.width && source.height);
}
var $86adec94217b86c6$var$ZRImage = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($86adec94217b86c6$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $86adec94217b86c6$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === "width" ? "height" : "width";
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize("width");
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize("height");
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $86adec94217b86c6$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
$86adec94217b86c6$var$ZRImage.prototype.type = "image";
var $86adec94217b86c6$export$2e2bcd8739ae039 = $86adec94217b86c6$var$ZRImage;




function $a351e275fffc3a77$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === "number") r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}


var $4d5544821af8d796$var$round = Math.round;
function $4d5544821af8d796$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($4d5544821af8d796$var$round(x1 * 2) === $4d5544821af8d796$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $4d5544821af8d796$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($4d5544821af8d796$var$round(y1 * 2) === $4d5544821af8d796$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $4d5544821af8d796$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $4d5544821af8d796$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $4d5544821af8d796$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $4d5544821af8d796$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($4d5544821af8d796$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($4d5544821af8d796$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $4d5544821af8d796$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $4d5544821af8d796$var$round(position * 2);
    return (doubledPosition + $4d5544821af8d796$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $419e5ff2f303755e$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $419e5ff2f303755e$var$subPixelOptimizeOutputShape = {};
var $419e5ff2f303755e$var$Rect = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $419e5ff2f303755e$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4d5544821af8d796$export$60e2aa74957d0b9d)($419e5ff2f303755e$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $a351e275fffc3a77$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$419e5ff2f303755e$var$Rect.prototype.type = "rect";
var $419e5ff2f303755e$export$2e2bcd8739ae039 = $419e5ff2f303755e$var$Rect;





var $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: "#000"
};
var $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $fe885cc21795562b$export$21aaaa0607ee0e2b = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
var $fe885cc21795562b$var$ZRText = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = "text";
        _this._children = [];
        _this._defaultStyle = $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $fe885cc21795562b$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $fe885cc21795562b$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var text = $fe885cc21795562b$var$getStyleText(style);
        var contentBlock = (0, $64fa9b3825ba2dec$export$5772575e34ef80f9)(text, style);
        var needDrawBg = $fe885cc21795562b$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var contentWidth = contentBlock.contentWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || "left";
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || "top";
        var textX = baseX;
        var textY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $fe885cc21795562b$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === "top") textY += textPadding[0];
            else if (verticalAlign === "bottom") textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = $fe885cc21795562b$var$getFill("fill" in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $fe885cc21795562b$var$getStroke("stroke" in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null && (style.overflow === "truncate" || style.overflow === "break" || style.overflow === "breakAll");
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $c9d5c769fe2f591f$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = "middle";
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || "transparent";
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $fe885cc21795562b$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            if (fixedBoundingRect) el.setBoundingRect(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)((0, $6c308355c7107803$export$eb5a525ef00ef9a4)(subElStyle.x, style.width, subElStyle.textAlign), (0, $6c308355c7107803$export$bf7d6802d2badd9)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), contentWidth, calculatedLineHeight));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var text = $fe885cc21795562b$var$getStyleText(style);
        var contentBlock = (0, $64fa9b3825ba2dec$export$15ec9472ff2d721)(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var boxX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($fe885cc21795562b$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === "left")){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, "left", bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === "right")){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, "right", bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, "center", bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === "top") y = lineTop + token.height / 2;
        else if (verticalAlign === "bottom") y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $fe885cc21795562b$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === "right" ? x - token.width : textAlign === "center" ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $fe885cc21795562b$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $c9d5c769fe2f591f$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = $fe885cc21795562b$var$getFill("fill" in tokenStyle ? tokenStyle.fill : "fill" in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $fe885cc21795562b$var$getStroke("stroke" in tokenStyle ? tokenStyle.stroke : "stroke" in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || "transparent";
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = "middle";
        subElStyle.font = token.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $fe885cc21795562b$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)((0, $6c308355c7107803$export$eb5a525ef00ef9a4)(subElStyle.x, textWidth, subElStyle.textAlign), (0, $6c308355c7107803$export$bf7d6802d2badd9)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $419e5ff2f303755e$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $86adec94217b86c6$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || "transparent";
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = "";
        if ($fe885cc21795562b$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $fe885cc21795562b$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || "sans-serif"
        ].join(" ");
        return font && (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $fe885cc21795562b$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $fe885cc21795562b$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $fe885cc21795562b$var$FONT_PARTS = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily"
];
function $fe885cc21795562b$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === "string" && (fontSize.indexOf("px") !== -1 || fontSize.indexOf("rem") !== -1 || fontSize.indexOf("em") !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + "px";
    else return (0, $c6341dcc9d86826e$export$b1461457ea2c1179) + "px";
}
function $fe885cc21795562b$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $fe885cc21795562b$var$FONT_PARTS.length; i++){
        var fontProp = $fe885cc21795562b$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $fe885cc21795562b$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $fe885cc21795562b$export$176336068cc5371f(style) {
    $fe885cc21795562b$var$normalizeStyle(style);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(style.rich, $fe885cc21795562b$var$normalizeStyle);
    return style;
}
function $fe885cc21795562b$var$normalizeStyle(style) {
    if (style) {
        style.font = $fe885cc21795562b$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === "middle" && (textAlign = "center");
        style.align = textAlign == null || $fe885cc21795562b$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : "left";
        var verticalAlign = style.verticalAlign;
        verticalAlign === "center" && (verticalAlign = "middle");
        style.verticalAlign = verticalAlign == null || $fe885cc21795562b$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : "top";
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(style.padding);
    }
}
function $fe885cc21795562b$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === "transparent" || stroke === "none" ? null : stroke.image || stroke.colorStops ? "#000" : stroke;
}
function $fe885cc21795562b$var$getFill(fill) {
    return fill == null || fill === "none" ? null : fill.image || fill.colorStops ? "#000" : fill;
}
function $fe885cc21795562b$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === "right" ? x - textPadding[1] : textAlign === "center" ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $fe885cc21795562b$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += "");
    return text;
}
function $fe885cc21795562b$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $fe885cc21795562b$export$2e2bcd8739ae039 = $fe885cc21795562b$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b1983a2fffd47d56$export$b1c39b2bacd1ddc2 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $b1983a2fffd47d56$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $b1983a2fffd47d56$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = "chart";
        // TODO: not store dataIndex on children.
        if (el.type === "group") el.traverse(function(child) {
            var childECData = $b1983a2fffd47d56$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = "chart";
        });
    }
};






// Reserve 0 as default.
var $2bf82c0980125b62$var$_highlightNextDigit = 1;
var $2bf82c0980125b62$var$_highlightKeyMap = {};
var $2bf82c0980125b62$var$getSavedStates = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $2bf82c0980125b62$var$getComponentStates = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $2bf82c0980125b62$export$5542daa30722333e = 0;
var $2bf82c0980125b62$export$1307d6a87d56baa = 1;
var $2bf82c0980125b62$export$f0f2bee145debb31 = 2;
var $2bf82c0980125b62$export$151308dceb52d5b = [
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$export$57ee5306b85ad7d5 = [
    "normal",
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$export$1cb9fc6ed5b9836c = 10;
var $2bf82c0980125b62$export$3a2f97d39514bbc = 9;
var $2bf82c0980125b62$export$df035d873a9de64f = "highlight";
var $2bf82c0980125b62$export$f8a2f7807cc185ea = "downplay";
var $2bf82c0980125b62$export$89616263e7d38fe9 = "select";
var $2bf82c0980125b62$export$7636ad95c0f68a79 = "unselect";
var $2bf82c0980125b62$export$1e90ed8a25542516 = "toggleSelect";
function $2bf82c0980125b62$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== "none";
}
function $2bf82c0980125b62$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $2bf82c0980125b62$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $2bf82c0980125b62$var$doChangeHoverState(el, "emphasis", $2bf82c0980125b62$export$f0f2bee145debb31);
}
function $2bf82c0980125b62$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $2bf82c0980125b62$export$f0f2bee145debb31) $2bf82c0980125b62$var$doChangeHoverState(el, "normal", $2bf82c0980125b62$export$5542daa30722333e);
}
function $2bf82c0980125b62$var$singleEnterBlur(el) {
    $2bf82c0980125b62$var$doChangeHoverState(el, "blur", $2bf82c0980125b62$export$1307d6a87d56baa);
}
function $2bf82c0980125b62$var$singleLeaveBlur(el) {
    if (el.hoverState === $2bf82c0980125b62$export$1307d6a87d56baa) $2bf82c0980125b62$var$doChangeHoverState(el, "normal", $2bf82c0980125b62$export$5542daa30722333e);
}
function $2bf82c0980125b62$var$singleEnterSelect(el) {
    el.selected = true;
}
function $2bf82c0980125b62$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $2bf82c0980125b62$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $2bf82c0980125b62$var$traverseUpdateState(el, updater, commonParam) {
    $2bf82c0980125b62$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $2bf82c0980125b62$var$updateElementState(child, updater, commonParam);
    });
}
function $2bf82c0980125b62$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case "emphasis":
            el.hoverState = $2bf82c0980125b62$export$f0f2bee145debb31;
            break;
        case "normal":
            el.hoverState = $2bf82c0980125b62$export$5542daa30722333e;
            break;
        case "blur":
            el.hoverState = $2bf82c0980125b62$export$1307d6a87d56baa;
            break;
        case "select":
            el.selected = true;
    }
}
function $2bf82c0980125b62$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $2bf82c0980125b62$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === "style") animator.saveTo(fromState, props);
    }
    return fromState;
}
function $2bf82c0980125b62$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(targetStates, "select") >= 0;
    var cloned = false;
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) {
        var store = $2bf82c0980125b62$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($2bf82c0980125b62$var$hasFillOrStroke(fromFill) || $2bf82c0980125b62$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === "inherit") {
                cloned = true;
                state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$2bf82c0980125b62$var$hasFillOrStroke(emphasisStyle.fill) && $2bf82c0980125b62$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromFill);
            } else if (!$2bf82c0980125b62$var$hasFillOrStroke(emphasisStyle.stroke) && $2bf82c0980125b62$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $2bf82c0980125b62$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $2bf82c0980125b62$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $2bf82c0980125b62$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $2bf82c0980125b62$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $2bf82c0980125b62$var$getFromStateStyle(el, [
        "opacity"
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $2bf82c0980125b62$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === "emphasis") return $2bf82c0980125b62$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === "blur") return $2bf82c0980125b62$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === "select") return $2bf82c0980125b62$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $2bf82c0980125b62$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
}
function $2bf82c0980125b62$export$d899507e2598e4ae(el, e) {
    !$2bf82c0980125b62$var$shouldSilent(el, e) && !el.__highByOuter && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterEmphasis);
}
function $2bf82c0980125b62$export$784cba1f7fe58cca(el, e) {
    !$2bf82c0980125b62$var$shouldSilent(el, e) && !el.__highByOuter && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveEmphasis);
}
function $2bf82c0980125b62$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterEmphasis);
}
function $2bf82c0980125b62$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveEmphasis);
}
function $2bf82c0980125b62$export$207f9cb3e1099375(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterBlur);
}
function $2bf82c0980125b62$export$fd4a9ec75456d3c1(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveBlur);
}
function $2bf82c0980125b62$export$252d028dda8ef765(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterSelect);
}
function $2bf82c0980125b62$export$ea9a904bd6e32bd3(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveSelect);
}
function $2bf82c0980125b62$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $2bf82c0980125b62$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $2bf82c0980125b62$var$getComponentStates(componentModel);
        var isSeries = componentType === "series";
        var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $2bf82c0980125b62$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $2bf82c0980125b62$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || "coordinateSystem";
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $2bf82c0980125b62$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === "none") return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === "series" && !sameSeries || blurScope === "coordinateSystem" && !sameCoordSys || focus === "series" && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === "self") return;
                $2bf82c0980125b62$var$singleEnterBlur(child);
            });
            if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $2bf82c0980125b62$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === "series") return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $2bf82c0980125b62$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $2bf82c0980125b62$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $2bf82c0980125b62$var$singleEnterBlur(child);
    });
}
function $2bf82c0980125b62$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        $2bf82c0980125b62$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            "emphasis",
            "focus"
        ]);
        var blurScope = seriesModel.get([
            "emphasis",
            "blurScope"
        ]);
        if (focus_1 != null) $2bf82c0980125b62$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $2bf82c0980125b62$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === "series" || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === "self") {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $2bf82c0980125b62$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $2bf82c0980125b62$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $2bf82c0980125b62$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $2bf82c0980125b62$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $2bf82c0980125b62$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === "self") $2bf82c0980125b62$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $2bf82c0980125b62$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $2bf82c0980125b62$export$bb1c7b62436282a(dispatcher, e, api) {
    $2bf82c0980125b62$export$b2a593c7b5243584(api);
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $2bf82c0980125b62$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $2bf82c0980125b62$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $2bf82c0980125b62$export$784cba1f7fe58cca(dispatcher, e);
}
function $2bf82c0980125b62$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$2bf82c0980125b62$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload);
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $2bf82c0980125b62$export$1e90ed8a25542516 ? "toggleSelect" : payload.type === $2bf82c0980125b62$export$89616263e7d38fe9 ? "select" : "unselect"](dataIndex, dataType);
}
function $2bf82c0980125b62$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $2bf82c0980125b62$export$252d028dda8ef765(el) : $2bf82c0980125b62$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $2bf82c0980125b62$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $2bf82c0980125b62$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $2bf82c0980125b62$export$9ba15aea1e048d48(el, true);
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$export$20f39bbe322fb9ab);
    $2bf82c0980125b62$export$24972466b2b62ac2(el, focus, blurScope);
}
function $2bf82c0980125b62$export$912cae7b47c8e437(el) {
    $2bf82c0980125b62$export$9ba15aea1e048d48(el, false);
}
function $2bf82c0980125b62$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $2bf82c0980125b62$export$912cae7b47c8e437(el) : $2bf82c0980125b62$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $2bf82c0980125b62$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $2bf82c0980125b62$var$OTHER_STATES = [
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$var$defaultStyleGetterMap = {
    itemStyle: "getItemStyle",
    lineStyle: "getLineStyle",
    areaStyle: "getAreaStyle"
};
function $2bf82c0980125b62$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || "itemStyle";
    for(var i = 0; i < $2bf82c0980125b62$var$OTHER_STATES.length; i++){
        var stateName = $2bf82c0980125b62$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$2bf82c0980125b62$var$defaultStyleGetterMap[styleType]]();
    }
}
function $2bf82c0980125b62$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $2bf82c0980125b62$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $2bf82c0980125b62$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $2bf82c0980125b62$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $2bf82c0980125b62$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $2bf82c0980125b62$var$_highlightNextDigit <= 32) highlightDigit = $2bf82c0980125b62$var$_highlightKeyMap[highlightKey] = $2bf82c0980125b62$var$_highlightNextDigit++;
    return highlightDigit;
}
function $2bf82c0980125b62$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $2bf82c0980125b62$export$89616263e7d38fe9 || payloadType === $2bf82c0980125b62$export$7636ad95c0f68a79 || payloadType === $2bf82c0980125b62$export$1e90ed8a25542516;
}
function $2bf82c0980125b62$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $2bf82c0980125b62$export$df035d873a9de64f || payloadType === $2bf82c0980125b62$export$f8a2f7807cc185ea;
}
function $2bf82c0980125b62$export$9fe78019e6f395b6(el) {
    var store = $2bf82c0980125b62$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8b353638fbedfefa$export$ae7433df314f6ec3 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $8b353638fbedfefa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === "update";
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(extraOpts.easing, "cubicOut");
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? "animationDurationUpdate" : "animationDuration");
            easing = animatableModel.getShallow(isUpdate ? "animationEasingUpdate" : "animationEasing");
            delay = animatableModel.getShallow(isUpdate ? "animationDelayUpdate" : "animationDelay");
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $8b353638fbedfefa$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === "leave";
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation("leave");
    var animationConfig = $8b353638fbedfefa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $8b353638fbedfefa$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $8b353638fbedfefa$var$animateOrSetProps("update", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $8b353638fbedfefa$var$animateOrSetProps("enter", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === "leave") return true;
    }
    return false;
}
function $8b353638fbedfefa$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
    $8b353638fbedfefa$var$animateOrSetProps("leave", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $8b353638fbedfefa$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $8b353638fbedfefa$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $8b353638fbedfefa$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $8b353638fbedfefa$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $8b353638fbedfefa$export$bca7290a9faf0ec9(el) {
    $8b353638fbedfefa$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $8b353638fbedfefa$export$ccb1f1e4d2fa86ac(el) {
    return $8b353638fbedfefa$export$ae7433df314f6ec3(el).oldStyle;
}

var $5b455ae6f843ac47$exports = {};

$parcel$export($5b455ae6f843ac47$exports, "extendShape", () => $5b455ae6f843ac47$export$d0d5398c9d612037);
$parcel$export($5b455ae6f843ac47$exports, "extendPath", () => $5b455ae6f843ac47$export$53b54a3137026af0);
$parcel$export($5b455ae6f843ac47$exports, "registerShape", () => $5b455ae6f843ac47$export$2b95b62e3aaf6fdd);
$parcel$export($5b455ae6f843ac47$exports, "getShapeClass", () => $5b455ae6f843ac47$export$51df4b5565a58189);
$parcel$export($5b455ae6f843ac47$exports, "makePath", () => $5b455ae6f843ac47$export$aa9bab72412f5613);
$parcel$export($5b455ae6f843ac47$exports, "resizePath", () => $5b455ae6f843ac47$export$566dbf1c62b04fc7);
$parcel$export($5b455ae6f843ac47$exports, "makeImage", () => $5b455ae6f843ac47$export$7a2bdede98851ac5);
$parcel$export($5b455ae6f843ac47$exports, "mergePath", () => $5b455ae6f843ac47$export$7b1dd269fbc4e903);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimizeLine", () => $5b455ae6f843ac47$export$8b4b620d7f4aad1b);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimizeRect", () => $5b455ae6f843ac47$export$60e2aa74957d0b9d);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimize", () => $5b455ae6f843ac47$export$72c4fd4c1b8fcb10);
$parcel$export($5b455ae6f843ac47$exports, "getTransform", () => $5b455ae6f843ac47$export$fce0c6cfca85ed96);
$parcel$export($5b455ae6f843ac47$exports, "applyTransform", () => $5b455ae6f843ac47$export$9f9dcb98c894b623);
$parcel$export($5b455ae6f843ac47$exports, "transformDirection", () => $5b455ae6f843ac47$export$fff94e9792354cfa);
$parcel$export($5b455ae6f843ac47$exports, "groupTransition", () => $5b455ae6f843ac47$export$64fcab7860c216ae);
$parcel$export($5b455ae6f843ac47$exports, "clipPointsByRect", () => $5b455ae6f843ac47$export$e2f409471bbbc1dc);
$parcel$export($5b455ae6f843ac47$exports, "clipRectByRect", () => $5b455ae6f843ac47$export$d0d3709202b8b2a);
$parcel$export($5b455ae6f843ac47$exports, "createIcon", () => $5b455ae6f843ac47$export$274edc73af1ae9c8);
$parcel$export($5b455ae6f843ac47$exports, "linePolygonIntersect", () => $5b455ae6f843ac47$export$4f47c855a5e9ae9);
$parcel$export($5b455ae6f843ac47$exports, "lineLineIntersect", () => $5b455ae6f843ac47$export$6c0a70ea1d8d158b);
$parcel$export($5b455ae6f843ac47$exports, "setTooltipConfig", () => $5b455ae6f843ac47$export$fc6410d97fab306c);
$parcel$export($5b455ae6f843ac47$exports, "traverseElements", () => $5b455ae6f843ac47$export$3e564442729bf048);
$parcel$export($5b455ae6f843ac47$exports, "updateProps", () => $8b353638fbedfefa$export$c8dce3c08436e91e);
$parcel$export($5b455ae6f843ac47$exports, "initProps", () => $8b353638fbedfefa$export$a121566aadcfe021);
$parcel$export($5b455ae6f843ac47$exports, "removeElement", () => $8b353638fbedfefa$export$f883456a56996078);
$parcel$export($5b455ae6f843ac47$exports, "removeElementWithFadeOut", () => $8b353638fbedfefa$export$6d0fd725cb4aee8a);
$parcel$export($5b455ae6f843ac47$exports, "isElementRemoved", () => $8b353638fbedfefa$export$5b89d4b643713034);
$parcel$export($5b455ae6f843ac47$exports, "Group", () => $7ef7583d8302ffce$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Image", () => $86adec94217b86c6$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Text", () => $fe885cc21795562b$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Circle", () => $1e68d8727773abb7$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Ellipse", () => $4a809f055a7e524c$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Sector", () => $a3e1dec0a3875b49$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Ring", () => $9da0cbfd3f86fdc1$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Polygon", () => $51acf033123e1a30$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Polyline", () => $d28119f30e6bb670$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Rect", () => $419e5ff2f303755e$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Line", () => $7a316ae5ceff7b27$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "BezierCurve", () => $6c7800c49630e431$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Arc", () => $2b5c23eb3597b84a$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "IncrementalDisplayable", () => $ee829f116f003981$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "CompoundPath", () => $e152f3dbf8fba6e2$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "LinearGradient", () => $cf44c01491b58e53$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "RadialGradient", () => $cd2ee2ba32bb26c3$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "BoundingRect", () => $1bebe7106c895823$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "OrientedBoundingRect", () => $f9793b4d8aade116$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Point", () => $b887f038f104fe7e$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Path", () => $b02ffe7acd508c08$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $07911aacc70e67cc$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $07911aacc70e67cc$var$points = [
    [],
    [],
    []
];
var $07911aacc70e67cc$var$mathSqrt = Math.sqrt;
var $07911aacc70e67cc$var$mathAtan2 = Math.atan2;
function $07911aacc70e67cc$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $07911aacc70e67cc$var$CMD.M;
    var C = $07911aacc70e67cc$var$CMD.C;
    var L = $07911aacc70e67cc$var$CMD.L;
    var R = $07911aacc70e67cc$var$CMD.R;
    var A = $07911aacc70e67cc$var$CMD.A;
    var Q = $07911aacc70e67cc$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $07911aacc70e67cc$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $07911aacc70e67cc$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $07911aacc70e67cc$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $07911aacc70e67cc$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $15b38920672b9006$var$mathSqrt = Math.sqrt;
var $15b38920672b9006$var$mathSin = Math.sin;
var $15b38920672b9006$var$mathCos = Math.cos;
var $15b38920672b9006$var$PI = Math.PI;
function $15b38920672b9006$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $15b38920672b9006$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($15b38920672b9006$var$vMag(u) * $15b38920672b9006$var$vMag(v));
}
function $15b38920672b9006$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($15b38920672b9006$var$vRatio(u, v));
}
function $15b38920672b9006$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($15b38920672b9006$var$PI / 180.0);
    var xp = $15b38920672b9006$var$mathCos(psi) * (x1 - x2) / 2.0 + $15b38920672b9006$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $15b38920672b9006$var$mathSin(psi) * (x1 - x2) / 2.0 + $15b38920672b9006$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $15b38920672b9006$var$mathSqrt(lambda);
        ry *= $15b38920672b9006$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $15b38920672b9006$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $15b38920672b9006$var$mathCos(psi) * cxp - $15b38920672b9006$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $15b38920672b9006$var$mathSin(psi) * cxp + $15b38920672b9006$var$mathCos(psi) * cyp;
    var theta = $15b38920672b9006$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $15b38920672b9006$var$vAngle(u, v);
    if ($15b38920672b9006$var$vRatio(u, v) <= -1) dTheta = $15b38920672b9006$var$PI;
    if ($15b38920672b9006$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $15b38920672b9006$var$PI * 1e6) / 1e6;
        dTheta = $15b38920672b9006$var$PI * 2 + n % 2 * $15b38920672b9006$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $15b38920672b9006$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $15b38920672b9006$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $15b38920672b9006$var$createPathProxyFromString(data) {
    var path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($15b38920672b9006$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($15b38920672b9006$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case "l":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "L":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "m":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "l";
                    break;
                case "M":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "L";
                    break;
                case "h":
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "H":
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "v":
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "V":
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "C":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case "c":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case "S":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "s":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "Q":
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "q":
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "T":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "t":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "A":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $15b38920672b9006$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case "a":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $15b38920672b9006$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === "z" || cmdStr === "Z") {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $15b38920672b9006$var$SVGPath = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $15b38920672b9006$var$isPathProxy(path) {
    return path.setData != null;
}
function $15b38920672b9006$var$createPathOptions(str, opts) {
    var pathProxy = $15b38920672b9006$var$createPathProxyFromString(str);
    var innerOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        if ($15b38920672b9006$var$isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $07911aacc70e67cc$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $15b38920672b9006$export$ae5b259626f00aeb(str, opts) {
    return new $15b38920672b9006$var$SVGPath($15b38920672b9006$var$createPathOptions(str, opts));
}
function $15b38920672b9006$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $15b38920672b9006$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($15b38920672b9006$var$SVGPath);
    return Sub;
}
function $15b38920672b9006$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($15b38920672b9006$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $15b38920672b9006$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $07911aacc70e67cc$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $1e68d8727773abb7$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $1e68d8727773abb7$var$Circle = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $1e68d8727773abb7$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$1e68d8727773abb7$var$Circle.prototype.type = "circle";
var $1e68d8727773abb7$export$2e2bcd8739ae039 = $1e68d8727773abb7$var$Circle;




var $4a809f055a7e524c$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $4a809f055a7e524c$var$Ellipse = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $4a809f055a7e524c$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$4a809f055a7e524c$var$Ellipse.prototype.type = "ellipse";
var $4a809f055a7e524c$export$2e2bcd8739ae039 = $4a809f055a7e524c$var$Ellipse;





var $a2aa1e91473aa9ab$var$PI = Math.PI;
var $a2aa1e91473aa9ab$var$PI2 = $a2aa1e91473aa9ab$var$PI * 2;
var $a2aa1e91473aa9ab$var$mathSin = Math.sin;
var $a2aa1e91473aa9ab$var$mathCos = Math.cos;
var $a2aa1e91473aa9ab$var$mathACos = Math.acos;
var $a2aa1e91473aa9ab$var$mathATan2 = Math.atan2;
var $a2aa1e91473aa9ab$var$mathAbs = Math.abs;
var $a2aa1e91473aa9ab$var$mathSqrt = Math.sqrt;
var $a2aa1e91473aa9ab$var$mathMax = Math.max;
var $a2aa1e91473aa9ab$var$mathMin = Math.min;
var $a2aa1e91473aa9ab$var$e = 1e-4;
function $a2aa1e91473aa9ab$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $a2aa1e91473aa9ab$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $a2aa1e91473aa9ab$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $a2aa1e91473aa9ab$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $a2aa1e91473aa9ab$var$mathSqrt($a2aa1e91473aa9ab$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $a2aa1e91473aa9ab$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $a2aa1e91473aa9ab$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $a2aa1e91473aa9ab$var$mathMax(shape.r, 0);
    var innerRadius = $a2aa1e91473aa9ab$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $a2aa1e91473aa9ab$var$mathAbs(endAngle - startAngle);
    var mod = arc > $a2aa1e91473aa9ab$var$PI2 && arc % $a2aa1e91473aa9ab$var$PI2;
    mod > $a2aa1e91473aa9ab$var$e && (arc = mod);
    if (!(radius > $a2aa1e91473aa9ab$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $a2aa1e91473aa9ab$var$PI2 - $a2aa1e91473aa9ab$var$e) {
        ctx.moveTo(cx + radius * $a2aa1e91473aa9ab$var$mathCos(startAngle), cy + radius * $a2aa1e91473aa9ab$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $a2aa1e91473aa9ab$var$e) {
            ctx.moveTo(cx + innerRadius * $a2aa1e91473aa9ab$var$mathCos(endAngle), cy + innerRadius * $a2aa1e91473aa9ab$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $a2aa1e91473aa9ab$var$mathCos(startAngle);
        var yrs = radius * $a2aa1e91473aa9ab$var$mathSin(startAngle);
        var xire = innerRadius * $a2aa1e91473aa9ab$var$mathCos(endAngle);
        var yire = innerRadius * $a2aa1e91473aa9ab$var$mathSin(endAngle);
        var hasArc = arc > $a2aa1e91473aa9ab$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $a2aa1e91473aa9ab$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $a2aa1e91473aa9ab$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $a2aa1e91473aa9ab$var$mathMin(halfRd, ocrStart);
            ocre = $a2aa1e91473aa9ab$var$mathMin(halfRd, ocrEnd);
            icrs = $a2aa1e91473aa9ab$var$mathMin(halfRd, icrStart);
            icre = $a2aa1e91473aa9ab$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $a2aa1e91473aa9ab$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $a2aa1e91473aa9ab$var$mathMax(icrs, icre);
            if (ocrMax > $a2aa1e91473aa9ab$var$e || icrMax > $a2aa1e91473aa9ab$var$e) {
                xre = radius * $a2aa1e91473aa9ab$var$mathCos(endAngle);
                yre = radius * $a2aa1e91473aa9ab$var$mathSin(endAngle);
                xirs = innerRadius * $a2aa1e91473aa9ab$var$mathCos(startAngle);
                yirs = innerRadius * $a2aa1e91473aa9ab$var$mathSin(startAngle);
                if (arc < $a2aa1e91473aa9ab$var$PI) {
                    var it_1 = $a2aa1e91473aa9ab$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $a2aa1e91473aa9ab$var$mathSin($a2aa1e91473aa9ab$var$mathACos((x0 * x1 + y0 * y1) / ($a2aa1e91473aa9ab$var$mathSqrt(x0 * x0 + y0 * y0) * $a2aa1e91473aa9ab$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $a2aa1e91473aa9ab$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $a2aa1e91473aa9ab$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $a2aa1e91473aa9ab$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $a2aa1e91473aa9ab$var$e) {
            var crStart = $a2aa1e91473aa9ab$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $a2aa1e91473aa9ab$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $a2aa1e91473aa9ab$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $a2aa1e91473aa9ab$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $a2aa1e91473aa9ab$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $a2aa1e91473aa9ab$var$mathATan2(ct1.y1, ct1.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $a2aa1e91473aa9ab$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $a2aa1e91473aa9ab$var$e) {
            var crStart = $a2aa1e91473aa9ab$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $a2aa1e91473aa9ab$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $a2aa1e91473aa9ab$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $a2aa1e91473aa9ab$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $a2aa1e91473aa9ab$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $a2aa1e91473aa9ab$var$mathATan2(ct1.y1, ct1.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $a3e1dec0a3875b49$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $a3e1dec0a3875b49$var$Sector = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $a3e1dec0a3875b49$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $a2aa1e91473aa9ab$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$a3e1dec0a3875b49$var$Sector.prototype.type = "sector";
var $a3e1dec0a3875b49$export$2e2bcd8739ae039 = $a3e1dec0a3875b49$var$Sector;




var $9da0cbfd3f86fdc1$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $9da0cbfd3f86fdc1$var$Ring = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $9da0cbfd3f86fdc1$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$9da0cbfd3f86fdc1$var$Ring.prototype.type = "ring";
var $9da0cbfd3f86fdc1$export$2e2bcd8739ae039 = $9da0cbfd3f86fdc1$var$Ring;





function $de6f6db626660fc1$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $6de594cf8ac295ff$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $6de594cf8ac295ff$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $6de594cf8ac295ff$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $6de594cf8ac295ff$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $6de594cf8ac295ff$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $6de594cf8ac295ff$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $6de594cf8ac295ff$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $de6f6db626660fc1$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $51acf033123e1a30$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $51acf033123e1a30$var$Polygon = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $51acf033123e1a30$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$51acf033123e1a30$var$Polygon.prototype.type = "polygon";
var $51acf033123e1a30$export$2e2bcd8739ae039 = $51acf033123e1a30$var$Polygon;





var $d28119f30e6bb670$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $d28119f30e6bb670$var$Polyline = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $d28119f30e6bb670$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$d28119f30e6bb670$var$Polyline.prototype.type = "polyline";
var $d28119f30e6bb670$export$2e2bcd8739ae039 = $d28119f30e6bb670$var$Polyline;






var $7a316ae5ceff7b27$var$subPixelOptimizeOutputShape = {};
var $7a316ae5ceff7b27$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $7a316ae5ceff7b27$var$Line = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $7a316ae5ceff7b27$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4d5544821af8d796$export$8b4b620d7f4aad1b)($7a316ae5ceff7b27$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$7a316ae5ceff7b27$var$Line.prototype.type = "line";
var $7a316ae5ceff7b27$export$2e2bcd8739ae039 = $7a316ae5ceff7b27$var$Line;






var $6c7800c49630e431$var$out = [];
var $6c7800c49630e431$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $6c7800c49630e431$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $747cfc5611b57cea$export$55fce925c60b6271) : (0, $747cfc5611b57cea$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $747cfc5611b57cea$export$55fce925c60b6271) : (0, $747cfc5611b57cea$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $747cfc5611b57cea$export$7e161e77e6fff8cb) : (0, $747cfc5611b57cea$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $747cfc5611b57cea$export$7e161e77e6fff8cb) : (0, $747cfc5611b57cea$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $6c7800c49630e431$var$BezierCurve = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $6c7800c49630e431$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $747cfc5611b57cea$export$117c659e21a7a060)(x1, cpx1, x2, percent, $6c7800c49630e431$var$out);
                cpx1 = $6c7800c49630e431$var$out[1];
                x2 = $6c7800c49630e431$var$out[2];
                (0, $747cfc5611b57cea$export$117c659e21a7a060)(y1, cpy1, y2, percent, $6c7800c49630e431$var$out);
                cpy1 = $6c7800c49630e431$var$out[1];
                y2 = $6c7800c49630e431$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $6c7800c49630e431$var$out);
                cpx1 = $6c7800c49630e431$var$out[1];
                cpx2 = $6c7800c49630e431$var$out[2];
                x2 = $6c7800c49630e431$var$out[3];
                (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $6c7800c49630e431$var$out);
                cpy1 = $6c7800c49630e431$var$out[1];
                cpy2 = $6c7800c49630e431$var$out[2];
                y2 = $6c7800c49630e431$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $6c7800c49630e431$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $6c7800c49630e431$var$someVectorAt(this.shape, t, true);
        return $6de594cf8ac295ff$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$6c7800c49630e431$var$BezierCurve.prototype.type = "bezier-curve";
var $6c7800c49630e431$export$2e2bcd8739ae039 = $6c7800c49630e431$var$BezierCurve;




var $2b5c23eb3597b84a$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $2b5c23eb3597b84a$var$Arc = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $2b5c23eb3597b84a$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$2b5c23eb3597b84a$var$Arc.prototype.type = "arc";
var $2b5c23eb3597b84a$export$2e2bcd8739ae039 = $2b5c23eb3597b84a$var$Arc;




var $e152f3dbf8fba6e2$var$CompoundPath = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "compound";
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $b02ffe7acd508c08$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $e152f3dbf8fba6e2$export$2e2bcd8739ae039 = $e152f3dbf8fba6e2$var$CompoundPath;



var $8273248bf9338d40$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $8273248bf9338d40$export$2e2bcd8739ae039 = $8273248bf9338d40$var$Gradient;


var $cf44c01491b58e53$var$LinearGradient = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = "linear";
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $8273248bf9338d40$export$2e2bcd8739ae039));
var $cf44c01491b58e53$export$2e2bcd8739ae039 = $cf44c01491b58e53$var$LinearGradient;




var $cd2ee2ba32bb26c3$var$RadialGradient = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = "radial";
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $8273248bf9338d40$export$2e2bcd8739ae039));
var $cd2ee2ba32bb26c3$export$2e2bcd8739ae039 = $cd2ee2ba32bb26c3$var$RadialGradient;




var $f9793b4d8aade116$var$extent = [
    0,
    0
];
var $f9793b4d8aade116$var$extent2 = [
    0,
    0
];
var $f9793b4d8aade116$var$minTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f9793b4d8aade116$var$maxTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f9793b4d8aade116$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        $f9793b4d8aade116$var$minTv.set(Infinity, Infinity);
        $f9793b4d8aade116$var$maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, $f9793b4d8aade116$var$minTv, $f9793b4d8aade116$var$maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, $f9793b4d8aade116$var$minTv, $f9793b4d8aade116$var$maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy(mtv, overlapped ? $f9793b4d8aade116$var$minTv : $f9793b4d8aade116$var$maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, $f9793b4d8aade116$var$extent);
            this._getProjMinMaxOnAxis(i, other._corners, $f9793b4d8aade116$var$extent2);
            if ($f9793b4d8aade116$var$extent[1] < $f9793b4d8aade116$var$extent2[0] || $f9793b4d8aade116$var$extent[0] > $f9793b4d8aade116$var$extent2[1]) {
                overlapped = false;
                if (noMtv) return overlapped;
                var dist0 = Math.abs($f9793b4d8aade116$var$extent2[0] - $f9793b4d8aade116$var$extent[1]);
                var dist1 = Math.abs($f9793b4d8aade116$var$extent[0] - $f9793b4d8aade116$var$extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(maxTv, axis, -dist0 * inverse);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(maxTv, axis, dist1 * inverse);
                }
            } else if (minTv) {
                var dist0 = Math.abs($f9793b4d8aade116$var$extent2[0] - $f9793b4d8aade116$var$extent[1]);
                var dist1 = Math.abs($f9793b4d8aade116$var$extent[0] - $f9793b4d8aade116$var$extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(minTv, axis, dist0 * inverse);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(minTv, axis, -dist1 * inverse);
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}();
var $f9793b4d8aade116$export$2e2bcd8739ae039 = $f9793b4d8aade116$var$OrientedBoundingRect;






var $ee829f116f003981$var$m = [];
var $ee829f116f003981$var$IncrementalDisplayable = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($ee829f116f003981$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $ee829f116f003981$export$2e2bcd8739ae039 = $ee829f116f003981$var$IncrementalDisplayable;






var $5b455ae6f843ac47$var$mathMax = Math.max;
var $5b455ae6f843ac47$var$mathMin = Math.min;
var $5b455ae6f843ac47$var$_customShapeMap = {};
function $5b455ae6f843ac47$export$d0d5398c9d612037(opts) {
    return (0, $b02ffe7acd508c08$export$2e2bcd8739ae039).extend(opts);
}
var $5b455ae6f843ac47$var$extendPathFromString = $15b38920672b9006$export$68e3a51ba2ed417c;
function $5b455ae6f843ac47$export$53b54a3137026af0(pathData, opts) {
    return $5b455ae6f843ac47$var$extendPathFromString(pathData, opts);
}
function $5b455ae6f843ac47$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $5b455ae6f843ac47$var$_customShapeMap[name] = ShapeClass;
}
function $5b455ae6f843ac47$export$51df4b5565a58189(name) {
    if ($5b455ae6f843ac47$var$_customShapeMap.hasOwnProperty(name)) return $5b455ae6f843ac47$var$_customShapeMap[name];
}
function $5b455ae6f843ac47$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $15b38920672b9006$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === "center") rect = $5b455ae6f843ac47$var$centerGraphic(rect, path.getBoundingRect());
        $5b455ae6f843ac47$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $5b455ae6f843ac47$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $86adec94217b86c6$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === "center") {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($5b455ae6f843ac47$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $5b455ae6f843ac47$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $5b455ae6f843ac47$export$7b1dd269fbc4e903 = $15b38920672b9006$export$7b1dd269fbc4e903;
function $5b455ae6f843ac47$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $5b455ae6f843ac47$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $4d5544821af8d796$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $5b455ae6f843ac47$export$60e2aa74957d0b9d(param) {
    $4d5544821af8d796$export$60e2aa74957d0b9d(param.shape, param.shape, param.style);
    return param;
}
var $5b455ae6f843ac47$export$72c4fd4c1b8fcb10 = $4d5544821af8d796$export$72c4fd4c1b8fcb10;
function $5b455ae6f843ac47$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $f41ebb9dd60b55b4$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $5b455ae6f843ac47$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(transform)) transform = (0, $becf2d727f9cf450$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $f41ebb9dd60b55b4$export$6897c284b6f9f4dc([], transform);
    return $6de594cf8ac295ff$export$9f9dcb98c894b623([], target, transform);
}
function $5b455ae6f843ac47$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === "left" ? -hBase : direction === "right" ? hBase : 0,
        direction === "top" ? -vBase : direction === "bottom" ? vBase : 0
    ];
    vertex = $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? "right" : "left" : vertex[1] > 0 ? "bottom" : "top";
}
function $5b455ae6f843ac47$var$isNotGroup(el) {
    return !el.isGroup;
}
function $5b455ae6f843ac47$var$isPath(el) {
    return el.shape != null;
}
function $5b455ae6f843ac47$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($5b455ae6f843ac47$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($5b455ae6f843ac47$var$isPath(el)) obj.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($5b455ae6f843ac47$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $5b455ae6f843ac47$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = $5b455ae6f843ac47$var$mathMax(x, rect.x);
        x = $5b455ae6f843ac47$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $5b455ae6f843ac47$var$mathMax(y, rect.y);
        y = $5b455ae6f843ac47$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $5b455ae6f843ac47$export$d0d3709202b8b2a(targetRect, rect) {
    var x = $5b455ae6f843ac47$var$mathMax(targetRect.x, rect.x);
    var x2 = $5b455ae6f843ac47$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $5b455ae6f843ac47$var$mathMax(targetRect.y, rect.y);
    var y2 = $5b455ae6f843ac47$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $5b455ae6f843ac47$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf("image://") === 0 ? (style.image = iconStr.slice(8), (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(style, rect), new (0, $86adec94217b86c6$export$2e2bcd8739ae039)(innerOpts)) : $5b455ae6f843ac47$export$aa9bab72412f5613(iconStr.replace("path://", ""), innerOpts, rect, "center");
}
function $5b455ae6f843ac47$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($5b455ae6f843ac47$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $5b455ae6f843ac47$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $5b455ae6f843ac47$var$crossProduct2d(nx, ny, mx, my);
    if ($5b455ae6f843ac47$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $5b455ae6f843ac47$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $5b455ae6f843ac47$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $5b455ae6f843ac47$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $5b455ae6f843ac47$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $5b455ae6f843ac47$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            "name"
        ]
    };
    formatterParams[mainType + "Index"] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            content: itemName,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $5b455ae6f843ac47$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $5b455ae6f843ac47$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$5b455ae6f843ac47$var$traverseElement(els[i], cb);
        else $5b455ae6f843ac47$var$traverseElement(els, cb);
    }
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("circle", (0, $1e68d8727773abb7$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("ellipse", (0, $4a809f055a7e524c$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("sector", (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("ring", (0, $9da0cbfd3f86fdc1$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("polygon", (0, $51acf033123e1a30$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("polyline", (0, $d28119f30e6bb670$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("rect", (0, $419e5ff2f303755e$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("line", (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("bezierCurve", (0, $6c7800c49630e431$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("arc", (0, $2b5c23eb3597b84a$export$2e2bcd8739ae039));


var $6800dfcb6e1e2a44$var$EMPTY_OBJ = {};
function $6800dfcb6e1e2a44$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $6800dfcb6e1e2a44$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, "normal", null, labelDimIndex, normalModel && normalModel.get("formatter"), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get("formatter")) : null, baseText);
    }
    return statesText;
}
function $6800dfcb6e1e2a44$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $fe885cc21795562b$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $2bf82c0980125b62$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow("show")) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $6800dfcb6e1e2a44$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow("show");
        var normalStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($6800dfcb6e1e2a44$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
            var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(stateModel.getShallow("show"), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow("silent");
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $6800dfcb6e1e2a44$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $6800dfcb6e1e2a44$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $6800dfcb6e1e2a44$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $6800dfcb6e1e2a44$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || "label";
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $6800dfcb6e1e2a44$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $6800dfcb6e1e2a44$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $6800dfcb6e1e2a44$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow("rotate");
    var labelDistance = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("distance"), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow("offset");
    labelPosition = textStyleModel.getShallow("position") || (isNotNormal ? null : "inside");
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.
    labelPosition === "outside" && (labelPosition = opt.defaultOutsidePosition || "top");
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get("color") === "inherit" ? opt.inheritColor || null : "auto";
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $6800dfcb6e1e2a44$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $6800dfcb6e1e2a44$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                "rich",
                name_1
            ]);
            // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $6800dfcb6e1e2a44$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get("overflow");
    if (overflow) textStyle.overflow = overflow;
    var margin = textStyleModel.get("minMargin");
    if (margin != null) textStyle.margin = margin;
    $6800dfcb6e1e2a44$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $6800dfcb6e1e2a44$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $6800dfcb6e1e2a44$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY"
];
var $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF = [
    "align",
    "lineHeight",
    "width",
    "height",
    "tag",
    "verticalAlign",
    "ellipsis"
];
var $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX = [
    "padding",
    "borderWidth",
    "borderRadius",
    "borderDashOffset",
    "backgroundColor",
    "borderColor",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY"
];
function $6800dfcb6e1e2a44$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow("color");
    var strokeColor = textStyleModel.getShallow("textBorderColor");
    var opacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("opacity"), globalTextStyle.opacity);
    if (fillColor === "inherit" || fillColor === "auto") {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === "inherit" || strokeColor === "auto") {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderWidth"), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderType"), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderDashOffset"), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL[i];
        var val = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF.length; i++){
        var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow("baseline");
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX.length; i++){
            var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow("borderType");
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === "auto" || textStyle.backgroundColor === "inherit") && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === "auto" || textStyle.borderColor === "inherit") && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $6800dfcb6e1e2a44$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel("textStyle");
    return (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow("fontStyle") || "",
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow("fontWeight") || "",
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow("fontSize") || 12) + "px",
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow("fontFamily") || "sans-serif"
    ].join(" "));
}
var $6800dfcb6e1e2a44$export$f62786d3261ab0f4 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $6800dfcb6e1e2a44$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get("valueAnimation");
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get("precision");
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $6800dfcb6e1e2a44$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $6800dfcb6e1e2a44$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $76d619f648247e6d$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $6800dfcb6e1e2a44$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ""
        }, labelInnerStore.statesModels, interpolated);
        $6800dfcb6e1e2a44$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $8b353638fbedfefa$export$a121566aadcfe021) : (0, $8b353638fbedfefa$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}



var $a8b74de3c15b55c3$var$PATH_COLOR = [
    "textStyle",
    "color"
];
var $a8b74de3c15b55c3$var$textStyleParams = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "padding",
    "lineHeight",
    "rich",
    "width",
    "height",
    "overflow"
];
// TODO Performance improvement?
var $a8b74de3c15b55c3$var$tmpText = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)();
var $a8b74de3c15b55c3$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow("color") || (!isEmphasis && ecModel ? ecModel.get($a8b74de3c15b55c3$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $6800dfcb6e1e2a44$export$155316a870a9d61e)({
            fontStyle: this.getShallow("fontStyle"),
            fontWeight: this.getShallow("fontWeight"),
            fontSize: this.getShallow("fontSize"),
            fontFamily: this.getShallow("fontFamily")
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow("verticalAlign") || this.getShallow("baseline")
        };
        for(var i = 0; i < $a8b74de3c15b55c3$var$textStyleParams.length; i++)style[$a8b74de3c15b55c3$var$textStyleParams[i]] = this.getShallow($a8b74de3c15b55c3$var$textStyleParams[i]);
        $a8b74de3c15b55c3$var$tmpText.useStyle(style);
        $a8b74de3c15b55c3$var$tmpText.update();
        return $a8b74de3c15b55c3$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $a8b74de3c15b55c3$export$2e2bcd8739ae039 = $a8b74de3c15b55c3$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9c5206e1bd69e88f$export$9f34de5b59222949 = [
    [
        "lineWidth",
        "width"
    ],
    [
        "stroke",
        "color"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "lineDash",
        "type"
    ],
    [
        "lineDashOffset",
        "dashOffset"
    ],
    [
        "lineCap",
        "cap"
    ],
    [
        "lineJoin",
        "join"
    ],
    [
        "miterLimit"
    ]
];
var $9c5206e1bd69e88f$var$getLineStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($9c5206e1bd69e88f$export$9f34de5b59222949);
var $9c5206e1bd69e88f$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $9c5206e1bd69e88f$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c42afdfd2f0ddc96$export$ffb0bba5dde0130b = [
    [
        "fill",
        "color"
    ],
    [
        "stroke",
        "borderColor"
    ],
    [
        "lineWidth",
        "borderWidth"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "lineDash",
        "borderType"
    ],
    [
        "lineDashOffset",
        "borderDashOffset"
    ],
    [
        "lineCap",
        "borderCap"
    ],
    [
        "lineJoin",
        "borderJoin"
    ],
    [
        "miterLimit",
        "borderMiterLimit"
    ]
];
var $c42afdfd2f0ddc96$var$getItemStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($c42afdfd2f0ddc96$export$ffb0bba5dde0130b);
var $c42afdfd2f0ddc96$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $c42afdfd2f0ddc96$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $6818646a97528290$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === "string") return path.split(".");
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && typeof obj === "object" ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $cd5f95cf03b4e3e7$export$cd4c3a4dca301c70)($6818646a97528290$var$Model);
(0, $cd5f95cf03b4e3e7$export$e1aac4552ae82081)($6818646a97528290$var$Model);
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $9c5206e1bd69e88f$export$91eeeeed4a69a7e7));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $c42afdfd2f0ddc96$export$e4f01e48d6fda412));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $cb2a96727da5284d$export$a3a0ed7e2dd84c9e));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $a8b74de3c15b55c3$export$2e2bcd8739ae039));
var $6818646a97528290$export$2e2bcd8739ae039 = $6818646a97528290$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $5370df662b2caf37$var$base = Math.round(Math.random() * 10);
function $5370df662b2caf37$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || "",
        $5370df662b2caf37$var$base++
    ].join("_");
}
function $5370df662b2caf37$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $5370df662b2caf37$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = "";
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(originalDeps, function(dep) {
            $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $5370df662b2caf37$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $7a1bd9c2710fea0d$export$4950aa0f605343fb($7a1bd9c2710fea0d$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $af0c4f5df0270dd8$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        dayOfWeek: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayOfWeekAbbr: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ]
    },
    legend: {
        selector: {
            all: "All",
            inverse: "Inv"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "Box Select",
                polygon: "Lasso Select",
                lineX: "Horizontally Select",
                lineY: "Vertically Select",
                keep: "Keep Selections",
                clear: "Clear Selections"
            }
        },
        dataView: {
            title: "Data View",
            lang: [
                "Data View",
                "Close",
                "Refresh"
            ]
        },
        dataZoom: {
            title: {
                zoom: "Zoom",
                back: "Zoom Reset"
            }
        },
        magicType: {
            title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Stack",
                tiled: "Tile"
            }
        },
        restore: {
            title: "Restore"
        },
        saveAsImage: {
            title: "Save as Image",
            lang: [
                "Right Click to Save Image"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "Pie chart",
            bar: "Bar chart",
            line: "Line chart",
            scatter: "Scatter plot",
            effectScatter: "Ripple scatter plot",
            radar: "Radar chart",
            tree: "Tree",
            treemap: "Treemap",
            boxplot: "Boxplot",
            candlestick: "Candlestick",
            k: "K line chart",
            heatmap: "Heat map",
            map: "Map",
            parallel: "Parallel coordinate map",
            lines: "Line graph",
            graph: "Relationship graph",
            sankey: "Sankey diagram",
            funnel: "Funnel chart",
            gauge: "Gauge",
            pictorialBar: "Pictorial bar",
            themeRiver: "Theme River Map",
            sunburst: "Sunburst",
            custom: "Custom chart",
            chart: "Chart"
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: "This is a chart"
        },
        series: {
            single: {
                prefix: "",
                withName: " with type {seriesType} named {seriesName}.",
                withoutName: " with type {seriesType}."
            },
            multiple: {
                prefix: ". It consists of {seriesCount} series count.",
                withName: " The {seriesId} series is a {seriesType} representing {seriesName}.",
                withoutName: " The {seriesId} series is a {seriesType}.",
                separator: {
                    middle: "",
                    end: ""
                }
            }
        },
        data: {
            allData: "The data is as follows: ",
            partialData: "The first {displayCnt} items are: ",
            withName: "the data for {name} is {value}",
            withoutName: "{value}",
            separator: {
                middle: ", ",
                end: ". "
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $b3a62bfb11b19829$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: "",
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: "{value}",
            separator: {
                middle: "\uFF0C",
                end: ""
            }
        }
    }
};



var $9b0a1ef4bcc91e7d$var$LOCALE_ZH = "ZH";
var $9b0a1ef4bcc91e7d$var$LOCALE_EN = "EN";
var $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE = $9b0a1ef4bcc91e7d$var$LOCALE_EN;
var $9b0a1ef4bcc91e7d$var$localeStorage = {};
var $9b0a1ef4bcc91e7d$var$localeModels = {};
var $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b = !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported ? $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage || $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($9b0a1ef4bcc91e7d$var$LOCALE_ZH) > -1 ? $9b0a1ef4bcc91e7d$var$LOCALE_ZH : $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE;
}();
function $9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $9b0a1ef4bcc91e7d$var$localeModels[locale] = new (0, $6818646a97528290$export$2e2bcd8739ae039)(localeObj);
    $9b0a1ef4bcc91e7d$var$localeStorage[locale] = localeObj;
}
function $9b0a1ef4bcc91e7d$export$ddc371781a6af754(locale) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(locale)) {
        var localeObj = $9b0a1ef4bcc91e7d$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $9b0a1ef4bcc91e7d$var$LOCALE_ZH || locale === $9b0a1ef4bcc91e7d$var$LOCALE_EN) return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(localeObj);
        else return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(localeObj), (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($9b0a1ef4bcc91e7d$var$localeStorage[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE]), false);
    } else return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(locale), (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($9b0a1ef4bcc91e7d$var$localeStorage[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE]), false);
}
function $9b0a1ef4bcc91e7d$export$37cc638e0e11865f(lang) {
    return $9b0a1ef4bcc91e7d$var$localeModels[lang];
}
function $9b0a1ef4bcc91e7d$export$1188f179b2597821() {
    return $9b0a1ef4bcc91e7d$var$localeModels[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE];
}
// Default locale
$9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd($9b0a1ef4bcc91e7d$var$LOCALE_EN, (0, $af0c4f5df0270dd8$export$2e2bcd8739ae039));
$9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd($9b0a1ef4bcc91e7d$var$LOCALE_ZH, (0, $b3a62bfb11b19829$export$2e2bcd8739ae039));



var $0ae0381fb3fd176f$export$32c0454ceff7f92d = 1000;
var $0ae0381fb3fd176f$export$35acaebf644db34e = $0ae0381fb3fd176f$export$32c0454ceff7f92d * 60;
var $0ae0381fb3fd176f$export$82541edf19e5e3b0 = $0ae0381fb3fd176f$export$35acaebf644db34e * 60;
var $0ae0381fb3fd176f$export$a97a1358cbb650ab = $0ae0381fb3fd176f$export$82541edf19e5e3b0 * 24;
var $0ae0381fb3fd176f$export$99cafda57477293d = $0ae0381fb3fd176f$export$a97a1358cbb650ab * 365;
var $0ae0381fb3fd176f$export$f7854271ddbda64e = {
    year: "{yyyy}",
    month: "{MMM}",
    day: "{d}",
    hour: "{HH}:{mm}",
    minute: "{HH}:{mm}",
    second: "{HH}:{mm}:{ss}",
    millisecond: "{HH}:{mm}:{ss} {SSS}",
    none: "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}"
};
var $0ae0381fb3fd176f$var$fullDayFormatter = "{yyyy}-{MM}-{dd}";
var $0ae0381fb3fd176f$export$445bdbd8d2334e40 = {
    year: "{yyyy}",
    month: "{yyyy}-{MM}",
    day: $0ae0381fb3fd176f$var$fullDayFormatter,
    hour: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$export$f7854271ddbda64e.hour,
    minute: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$export$f7854271ddbda64e.minute,
    second: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$export$f7854271ddbda64e.second,
    millisecond: $0ae0381fb3fd176f$export$f7854271ddbda64e.none
};
var $0ae0381fb3fd176f$export$87100da04d711986 = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
var $0ae0381fb3fd176f$export$833c398a55654bb7 = [
    "year",
    "half-year",
    "quarter",
    "month",
    "week",
    "half-week",
    "day",
    "half-day",
    "quarter-day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
function $0ae0381fb3fd176f$export$5d04458e2a6c373e(str, len) {
    str += "";
    return "0000".substr(0, len - str.length) + str;
}
function $0ae0381fb3fd176f$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case "half-year":
        case "quarter":
            return "month";
        case "week":
        case "half-week":
            return "day";
        case "half-day":
        case "quarter-day":
            return "hour";
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $0ae0381fb3fd176f$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $0ae0381fb3fd176f$export$1da4b91a25d7e1c8(timeUnit);
}
function $0ae0381fb3fd176f$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case "year":
        case "month":
            return "day";
        case "millisecond":
            return "millisecond";
        default:
            // Also for day, hour, minute, second
            return "second";
    }
}
function $0ae0381fb3fd176f$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $cfc1f3b422a3185f$export$6b862160d295c8e(time);
    var y = date[$0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC)]();
    var M = date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
    var e = date["get" + (isUTC ? "UTC" : "") + "Day"]();
    var H = date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
    var s = date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    var localeModel = lang instanceof (0, $6818646a97528290$export$2e2bcd8739ae039) ? lang : (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(lang || (0, $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b)) || (0, $9b0a1ef4bcc91e7d$export$1188f179b2597821)();
    var timeModel = localeModel.getModel("time");
    var month = timeModel.get("month");
    var monthAbbr = timeModel.get("monthAbbr");
    var dayOfWeek = timeModel.get("dayOfWeek");
    var dayOfWeekAbbr = timeModel.get("dayOfWeekAbbr");
    return (template || "").replace(/{yyyy}/g, y + "").replace(/{yy}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(y % 100 + "", 2)).replace(/{Q}/g, q + "").replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + "").replace(/{dd}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + "").replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + "").replace(/{HH}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + "").replace(/{hh}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(h + "", 2)).replace(/{h}/g, h + "").replace(/{mm}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + "").replace(/{ss}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + "").replace(/{SSS}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + "");
}
function $0ae0381fb3fd176f$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) // Callback formatter
    template = formatter(tick.value, idx, {
        level: tick.level
    });
    else {
        var defaults = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, $0ae0381fb3fd176f$export$f7854271ddbda64e);
        if (tick.level > 0) for(var i = 0; i < $0ae0381fb3fd176f$export$87100da04d711986.length; ++i)defaults[$0ae0381fb3fd176f$export$87100da04d711986[i]] = "{primary|" + defaults[$0ae0381fb3fd176f$export$87100da04d711986[i]] + "}";
        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
         : $7a1bd9c2710fea0d$export$ebe90cb607ad99e(formatter, defaults) : defaults;
        var unit = $0ae0381fb3fd176f$export$4dfb0417ad6555b7(tick.value, isUTC);
        if (mergedFormatter[unit]) template = mergedFormatter[unit];
        else if (mergedFormatter.inherit) {
            // Unit formatter is not defined and should inherit from bigger units
            var targetId = $0ae0381fb3fd176f$export$833c398a55654bb7.indexOf(unit);
            for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                template = mergedFormatter[unit];
                break;
            }
            template = template || defaults.none;
        }
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(template)) {
            var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
            levelId = Math.min(levelId, template.length - 1);
            template = template[levelId];
        }
    }
    return $0ae0381fb3fd176f$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $0ae0381fb3fd176f$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $cfc1f3b422a3185f$export$6b862160d295c8e(value);
    var M = date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
    var h = date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
    var s = date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return "year";
    else if (isMonth) return "month";
    else if (isDay) return "day";
    else if (isHour) return "hour";
    else if (isMinute) return "minute";
    else if (isSecond) return "second";
    else return "millisecond";
}
function $0ae0381fb3fd176f$export$e04e41a1e24ffd3f(value, unit, isUTC) {
    var date = $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) ? $cfc1f3b422a3185f$export$6b862160d295c8e(value) : value;
    unit = unit || $0ae0381fb3fd176f$export$4dfb0417ad6555b7(value, isUTC);
    switch(unit){
        case "year":
            return date[$0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC)]();
        case "half-year":
            return date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
        case "quarter":
            return Math.floor((date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
        case "month":
            return date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]();
        case "day":
            return date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
        case "half-day":
            return date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]() / 24;
        case "hour":
            return date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
        case "minute":
            return date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
        case "second":
            return date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
        case "millisecond":
            return date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    }
}
function $0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC) {
    return isUTC ? "getUTCFullYear" : "getFullYear";
}
function $0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC) {
    return isUTC ? "getUTCMonth" : "getMonth";
}
function $0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC) {
    return isUTC ? "getUTCDate" : "getDate";
}
function $0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? "getUTCHours" : "getHours";
}
function $0ae0381fb3fd176f$export$8807847c5c71eded(isUTC) {
    return isUTC ? "getUTCMinutes" : "getMinutes";
}
function $0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? "getUTCSeconds" : "getSeconds";
}
function $0ae0381fb3fd176f$export$312207a92d041116(isUTC) {
    return isUTC ? "getUTCMilliseconds" : "getMilliseconds";
}
function $0ae0381fb3fd176f$export$43fbeac90913b151(isUTC) {
    return isUTC ? "setUTCFullYear" : "setFullYear";
}
function $0ae0381fb3fd176f$export$233f59998ed71c09(isUTC) {
    return isUTC ? "setUTCMonth" : "setMonth";
}
function $0ae0381fb3fd176f$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? "setUTCDate" : "setDate";
}
function $0ae0381fb3fd176f$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? "setUTCHours" : "setHours";
}
function $0ae0381fb3fd176f$export$50303078793fc7d(isUTC) {
    return isUTC ? "setUTCMinutes" : "setMinutes";
}
function $0ae0381fb3fd176f$export$a4a908acda9c3118(isUTC) {
    return isUTC ? "setUTCSeconds" : "setSeconds";
}
function $0ae0381fb3fd176f$export$c047afab75f6d84(isUTC) {
    return isUTC ? "setUTCMilliseconds" : "setMilliseconds";
}





function $c84c9521536c601a$export$b6fe44657ce35c42(x) {
    if (!(0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(x)) return $7a1bd9c2710fea0d$export$844ec244b1367d54(x) ? x : "-";
    var parts = (x + "").split(".");
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") + (parts.length > 1 ? "." + parts[1] : "");
}
function $c84c9521536c601a$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || "").toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $c84c9521536c601a$export$f3a38102c49f4268 = $7a1bd9c2710fea0d$export$f3a38102c49f4268;
function $c84c9521536c601a$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}";
    function stringToUserReadable(str) {
        return str && $7a1bd9c2710fea0d$export$87c2784dc9fc4ab(str) ? str : "-";
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === "time";
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $0ae0381fb3fd176f$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return "-";
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === "ordinal") return $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + "" : "-" : "-";
    // By default.
    var numericResult = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $c84c9521536c601a$export$b6fe44657ce35c42(numericResult) : $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === "boolean" ? value + "" : "-";
}
var $c84c9521536c601a$var$TPL_VAR_ALIAS = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g"
];
var $c84c9521536c601a$var$wrapVar = function(varName, seriesIdx) {
    return "{" + varName + (seriesIdx == null ? "" : seriesIdx) + "}";
};
function $c84c9521536c601a$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return "";
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $c84c9521536c601a$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($c84c9521536c601a$var$wrapVar(alias), $c84c9521536c601a$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($c84c9521536c601a$var$wrapVar($c84c9521536c601a$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $c84c9521536c601a$export$2fa08233ee42f8e1(tpl, param, encode) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace("{" + key + "}", encode ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $c84c9521536c601a$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $7a1bd9c2710fea0d$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || "html";
    if (!color) return "";
    if (renderMode === "html") return type === "subItem" ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(color) + ";" + (extraCssText || "") + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(color) + ";" + (extraCssText || "") + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || "markerX";
        return {
            renderMode: renderMode,
            content: "{" + markerId + "|}  ",
            style: type === "subItem" ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $c84c9521536c601a$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === "week" || tpl === "month" || tpl === "quarter" || tpl === "half-year" || tpl === "year") tpl = "MM-dd\nyyyy";
    var date = (0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? "getUTC" : "get";
    var y = date[getUTC + "FullYear"]();
    var M = date[getUTC + "Month"]() + 1;
    var d = date[getUTC + "Date"]();
    var h = date[getUTC + "Hours"]();
    var m = date[getUTC + "Minutes"]();
    var s = date[getUTC + "Seconds"]();
    var S = date[getUTC + "Milliseconds"]();
    tpl = tpl.replace("MM", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(M, 2)).replace("M", M).replace("yyyy", y).replace("yy", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(y % 100 + "", 2)).replace("dd", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(d, 2)).replace("d", d).replace("hh", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(h, 2)).replace("h", h).replace("mm", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(m, 2)).replace("m", m).replace("ss", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(s, 2)).replace("s", s).replace("SSS", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $c84c9521536c601a$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $c84c9521536c601a$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || "transparent";
    return $7a1bd9c2710fea0d$export$844ec244b1367d54(color) ? color : $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $c84c9521536c601a$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === "_blank" || target === "blank") {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}


var $93b9bc7f22ac7369$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $93b9bc7f22ac7369$export$a9aa2cc018afbed = [
    "left",
    "right",
    "top",
    "bottom",
    "width",
    "height"
];
var $93b9bc7f22ac7369$export$d7fd4338c7b20804 = [
    [
        "width",
        "left",
        "right"
    ],
    [
        "height",
        "top",
        "bottom"
    ]
];
function $93b9bc7f22ac7369$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === "horizontal") {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === "horizontal" ? x = nextX + gap : y = nextY + gap;
    });
}
var $93b9bc7f22ac7369$export$827f4ee28efc37 = $93b9bc7f22ac7369$var$boxLayout;
var $93b9bc7f22ac7369$export$be20d9158c17374c = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($93b9bc7f22ac7369$var$boxLayout, "vertical");
var $93b9bc7f22ac7369$export$ae65a483d943e7a7 = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($93b9bc7f22ac7369$var$boxLayout, "horizontal");
function $93b9bc7f22ac7369$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var x2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var y2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
    margin = $c84c9521536c601a$export$f3a38102c49f4268(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
function $93b9bc7f22ac7369$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
    margin = $c84c9521536c601a$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case "center":
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case "right":
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case "middle":
        case "center":
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case "bottom":
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $93b9bc7f22ac7369$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || "all";
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === "raw") rect = el.type === "group" ? new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === "raw") {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $93b9bc7f22ac7369$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $93b9bc7f22ac7369$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $93b9bc7f22ac7369$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$7a1bd9c2710fea0d$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($93b9bc7f22ac7369$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($93b9bc7f22ac7369$export$d7fd4338c7b20804[1], 1);
    copy($93b9bc7f22ac7369$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($93b9bc7f22ac7369$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $93b9bc7f22ac7369$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $93b9bc7f22ac7369$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== "auto";
    }
    function copy(names, target, source) {
        $93b9bc7f22ac7369$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $93b9bc7f22ac7369$export$4b0d20af19c9875e(source) {
    return $93b9bc7f22ac7369$export$7438999faea9b6cc({}, source);
}
function $93b9bc7f22ac7369$export$7438999faea9b6cc(target, source) {
    source && target && $93b9bc7f22ac7369$var$each($93b9bc7f22ac7369$export$a9aa2cc018afbed, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}


var $116d65051f61bdfe$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $116d65051f61bdfe$var$ComponentModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $5370df662b2caf37$export$6d2b3473b0986646("ec_cpt_model");
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $93b9bc7f22ac7369$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $93b9bc7f22ac7369$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $93b9bc7f22ac7369$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $93b9bc7f22ac7369$export$3968a28a7cbd6063(this);
        if (layoutMode) $93b9bc7f22ac7369$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        // If using class declaration, it is different to travel super class
        // in legacy env and auto merge defaultOption. So if using class
        // declaration, defaultOption should be merged manually.
        if (!(0, $cd5f95cf03b4e3e7$export$4f3b818f3dd2d182)(ctor)) // When using ts class, defaultOption must be declared as static.
        return ctor.defaultOption;
        // FIXME: remove this approach?
        var fields = $116d65051f61bdfe$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $7a1bd9c2710fea0d$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + "Index";
        var idKey = mainType + "Id";
        return (0, $76d619f648247e6d$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        var boxLayoutModel = this;
        return {
            left: boxLayoutModel.get("left"),
            top: boxLayoutModel.get("top"),
            right: boxLayoutModel.get("right"),
            bottom: boxLayoutModel.get("bottom"),
            width: boxLayoutModel.get("width"),
            height: boxLayoutModel.get("height")
        };
    };
    /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */ ComponentModel.prototype.getZLevelKey = function() {
        return "";
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = "component";
        proto.id = "";
        proto.name = "";
        proto.mainType = "";
        proto.subType = "";
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
(0, $cd5f95cf03b4e3e7$export$c9c2d87774f1275d)($116d65051f61bdfe$var$ComponentModel, (0, $6818646a97528290$export$2e2bcd8739ae039));
(0, $cd5f95cf03b4e3e7$export$241315e45585454d)($116d65051f61bdfe$var$ComponentModel);
$5370df662b2caf37$export$b9faf30b7d655a6f($116d65051f61bdfe$var$ComponentModel);
$5370df662b2caf37$export$ce592d345a3ec040($116d65051f61bdfe$var$ComponentModel, $116d65051f61bdfe$var$getDependencies);
function $116d65051f61bdfe$var$getDependencies(componentType) {
    var deps = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($116d65051f61bdfe$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $7a1bd9c2710fea0d$export$871de8747c9eaa88(deps, function(type) {
        return (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== "dataset" && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(deps, "dataset") <= 0) deps.unshift("dataset");
    return deps;
}
var $116d65051f61bdfe$export$2e2bcd8739ae039 = $116d65051f61bdfe$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2d7ac35b3b3d57e3$var$platform = "";
// Navigator not exists in node
if (typeof navigator !== "undefined") /* global navigator */ $2d7ac35b3b3d57e3$var$platform = navigator.platform || "";
var $2d7ac35b3b3d57e3$var$decalColor = "rgba(0, 0, 0, 0.2)";
var $2d7ac35b3b3d57e3$export$2e2bcd8739ae039 = {
    darkMode: "auto",
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: "series",
    color: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#9a60b4",
        "#ea7ccc"
    ],
    gradientColor: [
        "#f6efa6",
        "#d88273",
        "#bf444c"
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    symbol: "circle",
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    symbol: "triangle",
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $2d7ac35b3b3d57e3$var$platform.match(/^Win/) ? "Microsoft YaHei" : "sans-serif",
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: "normal"
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: "cubicOut"
    },
    animation: "auto",
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: "cubicInOut",
    animationEasingUpdate: "cubicInOut",
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cab29724515ce2b8$export$cd51b5ca77f6f0e4 = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)([
    "tooltip",
    "label",
    "itemName",
    "itemId",
    "itemGroupId",
    "itemChildGroupId",
    "seriesName"
]);
var $cab29724515ce2b8$export$2823037fb9d8f0c6 = "original";
var $cab29724515ce2b8$export$fcd62ebf51387903 = "arrayRows";
var $cab29724515ce2b8$export$703ae8a2d83f441 = "objectRows";
var $cab29724515ce2b8$export$6a32b42c754a3cb8 = "keyedColumns";
var $cab29724515ce2b8$export$a918cb016a382d45 = "typedArray";
var $cab29724515ce2b8$export$c78f1330778d30d = "unknown";
var $cab29724515ce2b8$export$7b3f3c6551b4949b = "column";
var $cab29724515ce2b8$export$d55da1467cdf7804 = "row";


var $7dc6cdfd7450ef29$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $7dc6cdfd7450ef29$var$innerGlobalModel = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $7dc6cdfd7450ef29$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $7dc6cdfd7450ef29$var$innerGlobalModel(ecModel).datasetMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
}
function $7dc6cdfd7450ef29$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $7dc6cdfd7450ef29$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + "_" + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === "ordinal" && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $7dc6cdfd7450ef29$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441) || sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === "name") potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $7dc6cdfd7450ef29$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $7dc6cdfd7450ef29$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $7dc6cdfd7450ef29$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $7dc6cdfd7450ef29$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get("data", true);
    if (!thisData) return (0, $76d619f648247e6d$export$dc741340f7e5f186)(seriesModel.ecModel, "dataset", {
        index: seriesModel.get("datasetIndex", true),
        id: seriesModel.get("datasetId", true)
    }, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
}
function $7dc6cdfd7450ef29$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get("transform", true) && !datasetModel.get("fromTransformResult", true)) return [];
    return (0, $76d619f648247e6d$export$dc741340f7e5f186)(datasetModel.ecModel, "dataset", {
        index: datasetModel.get("fromDatasetIndex", true),
        id: datasetModel.get("fromDatasetId", true)
    }, (0, $76d619f648247e6d$export$f076738ec84e693c)).models;
}
function $7dc6cdfd7450ef29$export$c51adf1a2be01b9c(source, dimIndex) {
    return $7dc6cdfd7450ef29$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $7dc6cdfd7450ef29$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === "ordinal" ? $7dc6cdfd7450ef29$export$328749e9c5b40760.Must : $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(sample)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(item);
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(val)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `isFinit('')` get `true`.
        if (val != null && isFinite(val) && val !== "") return beStr ? $7dc6cdfd7450ef29$export$328749e9c5b40760.Might : $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        else if (beStr && val !== "-") return $7dc6cdfd7450ef29$export$328749e9c5b40760.Must;
    }
    return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $a625fe571efb4064$var$internalOptionCreatorMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
function $a625fe571efb4064$export$5a90be4668898d38(mainType, creator) {
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)($a625fe571efb4064$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $a625fe571efb4064$var$internalOptionCreatorMap.set(mainType, creator);
}
function $a625fe571efb4064$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $a625fe571efb4064$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e7fbd47751ca3c28$var$innerColor = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e7fbd47751ca3c28$var$innerDecal = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e7fbd47751ca3c28$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $76d619f648247e6d$export$4f07b212a02c8051)(this.get("color", true));
        var layeredPalette = this.get("colorLayer", true);
        return $e7fbd47751ca3c28$var$getFromPalette(this, $e7fbd47751ca3c28$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $e7fbd47751ca3c28$var$clearPalette(this, $e7fbd47751ca3c28$var$innerColor);
    };
    return PaletteMixin;
}();
function $e7fbd47751ca3c28$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get([
        "aria",
        "decal",
        "decals"
    ]));
    return $e7fbd47751ca3c28$var$getFromPalette(ecModel, $e7fbd47751ca3c28$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $e7fbd47751ca3c28$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $e7fbd47751ca3c28$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $e7fbd47751ca3c28$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $e7fbd47751ca3c28$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $84bc7667c27ccedc$var$ECHARTS_PREFIX = "[ECharts] ";
var $84bc7667c27ccedc$var$storedLogs = {};
var $84bc7667c27ccedc$var$hasConsole = typeof console !== "undefined" && console.warn && console.log;
function $84bc7667c27ccedc$var$outputLog(type, str, onlyOnce) {
    if ($84bc7667c27ccedc$var$hasConsole) {
        if (onlyOnce) {
            if ($84bc7667c27ccedc$var$storedLogs[str]) return;
            $84bc7667c27ccedc$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($84bc7667c27ccedc$var$ECHARTS_PREFIX + str);
    }
}
function $84bc7667c27ccedc$export$bef1f36f5486a6a3(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("log", str, onlyOnce);
}
function $84bc7667c27ccedc$export$c106dd0671a0fc2d(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("warn", str, onlyOnce);
}
function $84bc7667c27ccedc$export$a3bc9b8ed74fc(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("error", str, onlyOnce);
}
function $84bc7667c27ccedc$export$4a9c0b74eb885aa1(str) {}
function $84bc7667c27ccedc$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $84bc7667c27ccedc$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = "";
    var makePrintableStringIfPossible_1;
    return msg;
}
function $84bc7667c27ccedc$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $51f6ef0dd9546916$var$reCreateSeriesIndices;
var $51f6ef0dd9546916$var$assertSeriesInitialized;
var $51f6ef0dd9546916$var$initBase;
var $51f6ef0dd9546916$var$OPTION_INNER_KEY = "\x00_ec_inner";
var $51f6ef0dd9546916$var$OPTION_INNER_VALUE = 1;
var $51f6ef0dd9546916$var$BUITIN_COMPONENTS_MAP = {
    grid: "GridComponent",
    polar: "PolarComponent",
    geo: "GeoComponent",
    singleAxis: "SingleAxisComponent",
    parallel: "ParallelComponent",
    calendar: "CalendarComponent",
    graphic: "GraphicComponent",
    toolbox: "ToolboxComponent",
    tooltip: "TooltipComponent",
    axisPointer: "AxisPointerComponent",
    brush: "BrushComponent",
    title: "TitleComponent",
    timeline: "TimelineComponent",
    markPoint: "MarkPointComponent",
    markLine: "MarkLineComponent",
    markArea: "MarkAreaComponent",
    legend: "LegendComponent",
    dataZoom: "DataZoomComponent",
    visualMap: "VisualMapComponent",
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: "GridComponent",
    yAxis: "GridComponent",
    angleAxis: "PolarComponent",
    radiusAxis: "PolarComponent"
};
var $51f6ef0dd9546916$var$BUILTIN_CHARTS_MAP = {
    line: "LineChart",
    bar: "BarChart",
    pie: "PieChart",
    scatter: "ScatterChart",
    radar: "RadarChart",
    map: "MapChart",
    tree: "TreeChart",
    treemap: "TreemapChart",
    graph: "GraphChart",
    gauge: "GaugeChart",
    funnel: "FunnelChart",
    parallel: "ParallelChart",
    sankey: "SankeyChart",
    boxplot: "BoxplotChart",
    candlestick: "CandlestickChart",
    effectScatter: "EffectScatterChart",
    lines: "LinesChart",
    heatmap: "HeatmapChart",
    pictorialBar: "PictorialBarChart",
    themeRiver: "ThemeRiverChart",
    sunburst: "SunburstChart",
    custom: "CustomChart"
};
var $51f6ef0dd9546916$var$componetsMissingLogPrinted = {};
function $51f6ef0dd9546916$var$checkMissingComponents(option) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $51f6ef0dd9546916$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$51f6ef0dd9546916$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $84bc7667c27ccedc$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $51f6ef0dd9546916$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $51f6ef0dd9546916$var$GlobalModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $6818646a97528290$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $6818646a97528290$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $51f6ef0dd9546916$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $51f6ef0dd9546916$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === "recreate") {
            var baseOption = optionManager.mountOption(type === "recreate");
            if (!this.option || type === "recreate") $51f6ef0dd9546916$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === "timeline" || type === "media") this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === "recreate" || type === "timeline") {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === "recreate" || type === "media") {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $7dc6cdfd7450ef29$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(componentOption) : (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $a625fe571efb4064$export$c713a6a3b43f401d)(this, mainType, $76d619f648247e6d$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? "replaceAll" : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? "replaceMerge" : "normalMerge";
            var mappingResult = $76d619f648247e6d$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $76d619f648247e6d$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $116d65051f61bdfe$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === "series";
                    var ComponentModelClass = (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === "tooltip") {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === "series") $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this.option);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $76d619f648247e6d$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$76d619f648247e6d$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$51f6ef0dd9546916$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $51f6ef0dd9546916$var$queryByIdOrName("id", id, cmpts);
        else if (name != null) result = $51f6ef0dd9546916$var$queryByIdOrName("name", name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $51f6ef0dd9546916$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($51f6ef0dd9546916$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + "Index";
            var idAttr = mainType + "Id";
            var nameAttr = mainType + "Name";
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $76d619f648247e6d$export$fb1a222ba5dd6e51(name, null);
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get("series")[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get("series");
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._componentsMap.get("series"), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get("series")[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== "series" || !$51f6ef0dd9546916$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $51f6ef0dd9546916$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecModel._componentsMap.get("series"), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $51f6ef0dd9546916$var$assertSeriesInitialized = function(ecModel) {};
        $51f6ef0dd9546916$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$51f6ef0dd9546916$var$OPTION_INNER_KEY] = $51f6ef0dd9546916$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $51f6ef0dd9546916$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(baseOption, (0, $2d7ac35b3b3d57e3$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
function $51f6ef0dd9546916$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $51f6ef0dd9546916$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === "colorLayer" && notMergeColorLayer) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(name)) {
            if (typeof themeItem === "object") option[name] = !option[name] ? (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(themeItem) : (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $51f6ef0dd9546916$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $51f6ef0dd9546916$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty("subType") ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $51f6ef0dd9546916$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    opts && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($51f6ef0dd9546916$var$GlobalModel, (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4));
var $51f6ef0dd9546916$export$2e2bcd8739ae039 = $51f6ef0dd9546916$var$GlobalModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a6d7e6163195660e$var$availableMethods = [
    "getDom",
    "getZr",
    "getWidth",
    "getHeight",
    "getDevicePixelRatio",
    "dispatchAction",
    "isSSR",
    "isDisposed",
    "on",
    "off",
    "getDataURL",
    "getConnectedDataURL",
    // 'getModel',
    "getOption",
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    "getId",
    "updateLabelLayout"
];
var $a6d7e6163195660e$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($a6d7e6163195660e$var$availableMethods, function(methodName) {
            this[methodName] = $7a1bd9c2710fea0d$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $a6d7e6163195660e$export$2e2bcd8739ae039 = $a6d7e6163195660e$var$ExtensionAPI;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $70c3ede7d3b64757$var$coordinateSystemCreators = {};
var $70c3ede7d3b64757$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._coordinateSystems = [];
    }
    CoordinateSystemManager.prototype.create = function(ecModel, api) {
        var coordinateSystems = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($70c3ede7d3b64757$var$coordinateSystemCreators, function(creator, type) {
            var list = creator.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    };
    CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._coordinateSystems.slice();
    };
    CoordinateSystemManager.register = function(type, creator) {
        $70c3ede7d3b64757$var$coordinateSystemCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $70c3ede7d3b64757$var$coordinateSystemCreators[type];
    };
    return CoordinateSystemManager;
}();
var $70c3ede7d3b64757$export$2e2bcd8739ae039 = $70c3ede7d3b64757$var$CoordinateSystemManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bf4c0a9077b4e970$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $bf4c0a9077b4e970$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(series.data) && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(series.data);
            });
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(dataset.source) && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $bf4c0a9077b4e970$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent("timeline");
            if (timelineModel) option = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($bf4c0a9077b4e970$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$bf4c0a9077b4e970$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $bf4c0a9077b4e970$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(mediaOnRoot)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $bf4c0a9077b4e970$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($bf4c0a9077b4e970$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$bf4c0a9077b4e970$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $bf4c0a9077b4e970$var$compare(real, expect, operator) {
    if (operator === "min") return real >= expect;
    else if (operator === "max") return real <= expect;
    else // Equals
    return real === expect;
}
function $bf4c0a9077b4e970$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(",") === indices2.join(",");
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$bf4c0a9077b4e970$export$2e2bcd8739ae039 = $bf4c0a9077b4e970$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $621cc5e1b758ea39$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $621cc5e1b758ea39$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $621cc5e1b758ea39$var$POSSIBLE_STYLES = [
    "areaStyle",
    "lineStyle",
    "nodeStyle",
    "linkStyle",
    "chordStyle",
    "label",
    "labelLine"
];
function $621cc5e1b758ea39$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $621cc5e1b758ea39$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $621cc5e1b758ea39$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $621cc5e1b758ea39$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $7a1bd9c2710fea0d$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $621cc5e1b758ea39$var$removeEC3NormalStatus(opt) {
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "itemStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "lineStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "areaStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "label");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "labelLine");
    // treemap
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "upperLabel");
    // graph
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "edgeLabel");
}
function $621cc5e1b758ea39$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $621cc5e1b758ea39$var$isObject(opt) && opt[propName];
    var textStyle = $621cc5e1b758ea39$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $76d619f648247e6d$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $76d619f648247e6d$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $621cc5e1b758ea39$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        $621cc5e1b758ea39$var$compatTextStyle(opt, "label");
        opt.emphasis && $621cc5e1b758ea39$var$compatTextStyle(opt.emphasis, "label");
    }
}
function $621cc5e1b758ea39$var$processSeries(seriesOpt) {
    if (!$621cc5e1b758ea39$var$isObject(seriesOpt)) return;
    $621cc5e1b758ea39$var$compatEC2ItemStyle(seriesOpt);
    $621cc5e1b758ea39$var$removeEC3NormalStatus(seriesOpt);
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "label");
    // treemap
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "upperLabel");
    // graph
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "edgeLabel");
    if (seriesOpt.emphasis) {
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "label");
        // treemap
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "upperLabel");
        // graph
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "edgeLabel");
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $621cc5e1b758ea39$var$compatEC2ItemStyle(markPoint);
        $621cc5e1b758ea39$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $621cc5e1b758ea39$var$compatEC2ItemStyle(markLine);
        $621cc5e1b758ea39$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $621cc5e1b758ea39$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === "graph") {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(edgeData[i]);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(mlData[i])) {
            $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i][0]);
            $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i][1]);
        } else $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === "gauge") {
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "axisLabel");
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "title");
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "detail");
    } else if (seriesOpt.type === "treemap") {
        $621cc5e1b758ea39$var$convertNormalEmphasis(seriesOpt.breadcrumb, "itemStyle");
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === "tree") $621cc5e1b758ea39$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $621cc5e1b758ea39$var$toArr(o) {
    return $7a1bd9c2710fea0d$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $621cc5e1b758ea39$var$toObj(o) {
    return ($7a1bd9c2710fea0d$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $621cc5e1b758ea39$export$2e2bcd8739ae039(option, isTheme) {
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.series), function(seriesOpt) {
        $621cc5e1b758ea39$var$isObject(seriesOpt) && $621cc5e1b758ea39$var$processSeries(seriesOpt);
    });
    var axes = [
        "xAxis",
        "yAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "parallelAxis",
        "radar"
    ];
    isTheme && axes.push("valueAxis", "categoryAxis", "logAxis", "timeAxis");
    $621cc5e1b758ea39$var$each(axes, function(axisName) {
        $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $621cc5e1b758ea39$var$compatTextStyle(axisOpt, "axisLabel");
                $621cc5e1b758ea39$var$compatTextStyle(axisOpt.axisPointer, "label");
            }
        });
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $621cc5e1b758ea39$var$compatTextStyle(parallelAxisDefault, "axisLabel");
        $621cc5e1b758ea39$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, "label");
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.calendar), function(calendarOpt) {
        $621cc5e1b758ea39$var$convertNormalEmphasis(calendarOpt, "itemStyle");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "dayLabel");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "monthLabel");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "yearLabel");
    });
    // radar.name.textStyle
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.radar), function(radarOpt) {
        $621cc5e1b758ea39$var$compatTextStyle(radarOpt, "name");
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.geo), function(geoOpt) {
        if ($621cc5e1b758ea39$var$isObject(geoOpt)) {
            $621cc5e1b758ea39$var$compatEC3CommonStyles(geoOpt);
            $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(geoOpt.regions), function(regionObj) {
                $621cc5e1b758ea39$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.timeline), function(timelineOpt) {
        $621cc5e1b758ea39$var$compatEC3CommonStyles(timelineOpt);
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "label");
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "itemStyle");
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "controlStyle", true);
        var data = timelineOpt.data;
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(data) && $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(item) {
            if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(item)) {
                $621cc5e1b758ea39$var$convertNormalEmphasis(item, "label");
                $621cc5e1b758ea39$var$convertNormalEmphasis(item, "itemStyle");
            }
        });
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.toolbox), function(toolboxOpt) {
        $621cc5e1b758ea39$var$convertNormalEmphasis(toolboxOpt, "iconStyle");
        $621cc5e1b758ea39$var$each(toolboxOpt.feature, function(featureOpt) {
            $621cc5e1b758ea39$var$convertNormalEmphasis(featureOpt, "iconStyle");
        });
    });
    $621cc5e1b758ea39$var$compatTextStyle($621cc5e1b758ea39$var$toObj(option.axisPointer), "label");
    $621cc5e1b758ea39$var$compatTextStyle($621cc5e1b758ea39$var$toObj(option.tooltip).axisPointer, "label");
// Clean logs
// storedLogs = {};
}




function $c4489ebdf95633b6$var$get(opt, path) {
    var pathArr = path.split(",");
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $c4489ebdf95633b6$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(",");
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $c4489ebdf95633b6$var$compatLayoutProperties(option) {
    option && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($c4489ebdf95633b6$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $c4489ebdf95633b6$var$LAYOUT_PROPERTIES = [
    [
        "x",
        "left"
    ],
    [
        "y",
        "top"
    ],
    [
        "x2",
        "right"
    ],
    [
        "y2",
        "bottom"
    ]
];
var $c4489ebdf95633b6$var$COMPATITABLE_COMPONENTS = [
    "grid",
    "geo",
    "parallel",
    "legend",
    "toolbox",
    "title",
    "visualMap",
    "dataZoom",
    "timeline"
];
var $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP = [
    [
        "borderRadius",
        "barBorderRadius"
    ],
    [
        "borderColor",
        "barBorderColor"
    ],
    [
        "borderWidth",
        "barBorderWidth"
    ]
];
function $c4489ebdf95633b6$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $c4489ebdf95633b6$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === "edge" && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $c4489ebdf95633b6$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $c4489ebdf95633b6$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = "adjacency";
    }
}
function $c4489ebdf95633b6$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $c4489ebdf95633b6$var$traverseTree(data[i].children, cb);
    }
}
function $c4489ebdf95633b6$export$2e2bcd8739ae039(option, isTheme) {
    (0, $621cc5e1b758ea39$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $76d619f648247e6d$export$4f07b212a02c8051)(option.series);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === "line") {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === "pie" || seriesType === "gauge") {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $c4489ebdf95633b6$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$c4489ebdf95633b6$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === "gauge") {
            var pointerColor = $c4489ebdf95633b6$var$get(seriesOpt, "pointer.color");
            pointerColor != null && $c4489ebdf95633b6$var$set(seriesOpt, "itemStyle.color", pointerColor);
        } else if (seriesType === "bar") {
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt);
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === "object") {
                    $c4489ebdf95633b6$var$compatBarItemStyle(data[i]);
                    $c4489ebdf95633b6$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === "sunburst") {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $c4489ebdf95633b6$var$compatSunburstState(seriesOpt);
            $c4489ebdf95633b6$var$traverseTree(seriesOpt.data, $c4489ebdf95633b6$var$compatSunburstState);
        } else if (seriesType === "graph" || seriesType === "sankey") $c4489ebdf95633b6$var$compatGraphFocus(seriesOpt);
        else if (seriesType === "map") {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $c4489ebdf95633b6$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($c4489ebdf95633b6$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(options, function(option) {
                $c4489ebdf95633b6$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $92eb0b43a1e7607a$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get("stack");
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo("stackResultDimension"),
                stackedOverDimension: data.getCalculationInfo("stackedOverDimension"),
                stackedDimension: data.getCalculationInfo("stackedDimension"),
                stackedByDimension: data.getCalculationInfo("stackedByDimension"),
                isStackedByIndex: data.getCalculationInfo("isStackedByIndex"),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo("stackedOnSeries", stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($92eb0b43a1e7607a$var$calculateStack);
}
function $92eb0b43a1e7607a$var$calculateStack(stackInfoList) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get("stackStrategy") || "samesign";
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === "all" // single stack group
                     || stackStrategy === "positive" && val > 0 || stackStrategy === "negative" && val < 0 || stackStrategy === "samesign" && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === "samesign" && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $cfc1f3b422a3185f$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $99e22f5c2aa5094b$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $cab29724515ce2b8$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $cab29724515ce2b8$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $7dc6cdfd7450ef29$export$c51adf1a2be01b9c)(this, i) === (0, $7dc6cdfd7450ef29$export$328749e9c5b40760).Must) dim.type = "ordinal";
            }
        }
    }
    return SourceImpl;
}();
function $99e22f5c2aa5094b$export$22b808bc02a60488(val) {
    return val instanceof $99e22f5c2aa5094b$var$SourceImpl;
}
function $99e22f5c2aa5094b$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $99e22f5c2aa5094b$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $99e22f5c2aa5094b$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $99e22f5c2aa5094b$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $99e22f5c2aa5094b$export$75aef3f97c0a5edf(data) {
    return new $99e22f5c2aa5094b$var$SourceImpl({
        data: data,
        sourceFormat: (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data) ? (0, $cab29724515ce2b8$export$a918cb016a382d45) : (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)
    });
}
function $99e22f5c2aa5094b$export$e0365e7e3555ddd4(source) {
    return new $99e22f5c2aa5094b$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $99e22f5c2aa5094b$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $cab29724515ce2b8$export$c78f1330778d30d);
    if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $cab29724515ce2b8$export$a918cb016a382d45);
    else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $cab29724515ce2b8$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item) || (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $cab29724515ce2b8$export$fcd62ebf51387903);
                break;
            } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $cab29724515ce2b8$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(data, key) && (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $cab29724515ce2b8$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $99e22f5c2aa5094b$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === "auto" || sourceHeader == null) $99e22f5c2aa5094b$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== "-") {
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $99e22f5c2aa5094b$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + "" : "";
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $99e22f5c2aa5094b$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var value0 = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $99e22f5c2aa5094b$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += "";
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += "-" + exist.count++;
        return item;
    });
}
function $99e22f5c2aa5094b$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $99e22f5c2aa5094b$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441) || sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8);
}



var $8ffb0d67e9446edb$var$_a, $8ffb0d67e9446edb$var$_b, $8ffb0d67e9446edb$var$_c;
var $8ffb0d67e9446edb$var$providerMethods;
var $8ffb0d67e9446edb$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $8ffb0d67e9446edb$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $99e22f5c2aa5094b$export$22b808bc02a60488)(sourceParam) ? (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        // Typed array. TODO IE10+?
        if (source.sourceFormat === (0, $cab29724515ce2b8$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        $8ffb0d67e9446edb$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $8ffb0d67e9446edb$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $8ffb0d67e9446edb$var$providerMethods[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $cab29724515ce2b8$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $8ffb0d67e9446edb$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $8ffb0d67e9446edb$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $8ffb0d67e9446edb$var$providerMethods = (_a = {}, _a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $cab29724515ce2b8$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $cab29724515ce2b8$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $8ffb0d67e9446edb$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $8ffb0d67e9446edb$var$rawSourceItemGetterMap = ($8ffb0d67e9446edb$var$_a = {}, $8ffb0d67e9446edb$var$_a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $8ffb0d67e9446edb$var$_a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$getItemSimply, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = rawData[dimName];
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$getItemSimply, $8ffb0d67e9446edb$var$_a);
function $8ffb0d67e9446edb$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $8ffb0d67e9446edb$var$rawSourceItemGetterMap[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $8ffb0d67e9446edb$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $8ffb0d67e9446edb$var$rawSourceDataCounterMap = ($8ffb0d67e9446edb$var$_b = {}, $8ffb0d67e9446edb$var$_b[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $8ffb0d67e9446edb$var$_b[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$countSimply, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = rawData[dimName];
    return col ? col.length : 0;
}, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$countSimply, $8ffb0d67e9446edb$var$_b);
function $8ffb0d67e9446edb$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $8ffb0d67e9446edb$var$rawSourceDataCounterMap[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $8ffb0d67e9446edb$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $8ffb0d67e9446edb$var$rawSourceValueGetterMap = ($8ffb0d67e9446edb$var$_c = {}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$fcd62ebf51387903] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$703ae8a2d83f441] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$a918cb016a382d45] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c);
function $8ffb0d67e9446edb$export$1752de8084789a14(sourceFormat) {
    var method = $8ffb0d67e9446edb$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903) ? sourceFormat + "_" + seriesLayoutBy : sourceFormat;
}
function $8ffb0d67e9446edb$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $8ffb0d67e9446edb$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) result = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $8ffb0d67e9446edb$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $cab29724515ce2b8$export$2823037fb9d8f0c6) && sourceFormat !== (0, $cab29724515ce2b8$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6) && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $655dd6075cc63601$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $655dd6075cc63601$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, "style");
        var color = style && style[data.getItemVisual(dataIndex, "drawType") || "fill"];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === "series";
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                "seriesName",
                "name",
                "value"
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || "normal";
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $7a1bd9c2710fea0d$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === "normal" ? [
                "label",
                "formatter"
            ] : [
                status,
                "label",
                "formatter"
            ]);
        }
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) {
            var str = (0, $c84c9521536c601a$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($655dd6075cc63601$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === "[" && dimLoose.charAt(len - 1) === "]") dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $7a1bd9c2710fea0d$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + "" : "";
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $655dd6075cc63601$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4d16404c851dcec6$export$f7292ab7796be73c(define) {
    return new $4d16404c851dcec6$export$2dea7024bcdd7731(define);
}
var $4d16404c851dcec6$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = "reset";
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === "reset") {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $4d16404c851dcec6$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $4d16404c851dcec6$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $4d16404c851dcec6$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $40ab59f44b7d2db6$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === "ordinal") // If given value is a category string
    return value;
    if (dimType === "time" && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value) && value != null && value !== "-") value = +(0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === "" ? NaN : +value;
}
var $40ab59f44b7d2db6$var$valueParserMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
    "number": function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    "time": function(val) {
        // return timestamp.
        return +(0, $cfc1f3b422a3185f$export$6b862160d295c8e)(val);
    },
    "trim": function(val) {
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val) ? (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $40ab59f44b7d2db6$export$c88237b7c265b36b(type) {
    return $40ab59f44b7d2db6$var$valueParserMap.get(type);
}
var $40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $40ab59f44b7d2db6$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rval)) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $40ab59f44b7d2db6$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === "desc";
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? "min" : "max";
        this._incomparable = incomparable === "min" ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lval) ? lval : (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rval) ? rval : (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $40ab59f44b7d2db6$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === "number" || this._rvalTypeof === "number")) eqResult = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $40ab59f44b7d2db6$export$f2644c3485f94c4e(op, rval) {
    return op === "eq" || op === "ne" ? new $40ab59f44b7d2db6$var$FilterEqualityComparator(op === "eq", rval) : (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP, op) ? new $40ab59f44b7d2db6$var$FilterOrderComparator(op, rval) : null;
}




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $523dedd0a2328c06$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error("not supported");
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error("not supported");
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $523dedd0a2328c06$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $523dedd0a2328c06$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = "";
    if (internalSource.seriesLayoutBy !== (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = "";
            if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $8ffb0d67e9446edb$export$92c8ea8642b3957d)(sourceFormat, (0, $cab29724515ce2b8$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $8ffb0d67e9446edb$export$803742e832f4b52c)(sourceFormat, (0, $cab29724515ce2b8$export$7b3f3c6551b4949b));
    extSource.count = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $8ffb0d67e9446edb$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $523dedd0a2328c06$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = "";
        (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $523dedd0a2328c06$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = "";
        (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $523dedd0a2328c06$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $523dedd0a2328c06$var$cloneAllDimensionInfo(dimensions) {
    return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(dimensions);
}
var $523dedd0a2328c06$var$externalTransformMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
function $523dedd0a2328c06$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = "";
    if (!type) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(":");
    if (typeParsed.length !== 2) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === "echarts") {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $523dedd0a2328c06$var$externalTransformMap.set(type, externalTransform);
}
function $523dedd0a2328c06$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $76d619f648247e6d$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = "";
    if (!pipeLen) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $523dedd0a2328c06$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $523dedd0a2328c06$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = "";
    if (!upSourceList.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(transOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $523dedd0a2328c06$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $523dedd0a2328c06$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = "";
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(result)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $99e22f5c2aa5094b$export$52a469afa4653e57)(result.data);
        if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903) || sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $370e5aa482d8420b$var$UNDEFINED = "undefined";
var $370e5aa482d8420b$export$859a1fa4f1106aa0 = typeof Uint32Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Uint32Array;
var $370e5aa482d8420b$export$78cf73566f32c185 = typeof Uint16Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Uint16Array;
var $370e5aa482d8420b$export$b60d945128546f53 = typeof Int32Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Int32Array;
var $370e5aa482d8420b$export$365b104db51a490a = typeof Float64Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $370e5aa482d8420b$var$dataCtors = {
    "float": $370e5aa482d8420b$export$365b104db51a490a,
    "int": $370e5aa482d8420b$export$b60d945128546f53,
    // Ordinal data type can be string or int
    "ordinal": Array,
    "number": Array,
    "time": $370e5aa482d8420b$export$365b104db51a490a
};
var $370e5aa482d8420b$var$defaultDimValueGetters;
function $370e5aa482d8420b$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $370e5aa482d8420b$export$859a1fa4f1106aa0 : $370e5aa482d8420b$export$78cf73566f32c185;
}
function $370e5aa482d8420b$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $370e5aa482d8420b$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $370e5aa482d8420b$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $370e5aa482d8420b$var$dataCtors[dimType || "float"];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $370e5aa482d8420b$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $370e5aa482d8420b$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $99e22f5c2aa5094b$export$8911336b527f8517)(source);
        this._dimensions = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $370e5aa482d8420b$var$dataCtors[type || "float"](this._rawCount);
        this._rawExtent[calcDimIdx] = $370e5aa482d8420b$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $370e5aa482d8420b$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = "ordinal"; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $370e5aa482d8420b$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $370e5aa482d8420b$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $370e5aa482d8420b$var$getInitialExtent();
            $370e5aa482d8420b$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    /**
   * Retrieve the index of nearest value.
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices have
   *         the same value, they are put to the result.
   */ DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        var chunks = this._chunks;
        var dimData = chunks[dim];
        var nearestIndices = [];
        if (!dimData) return nearestIndices;
        if (maxDistance == null) maxDistance = Infinity;
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        // Check the test case of `test/ut/spec/data/SeriesData.js`.
        for(var i = 0, len = this.count(); i < len; i++){
            var dataIndex = this.getRawIndex(i);
            var diff = value - dimData[dataIndex];
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $370e5aa482d8420b$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $370e5aa482d8420b$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $370e5aa482d8420b$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $370e5aa482d8420b$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== "object") {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $370e5aa482d8420b$var$getInitialExtent();
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $370e5aa482d8420b$var$getInitialExtent();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $370e5aa482d8420b$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $370e5aa482d8420b$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $370e5aa482d8420b$export$2e2bcd8739ae039 = $370e5aa482d8420b$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $1c87d176de397e7e$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + "_" + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get("data", true);
                sourceFormat = (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data) ? (0, $cab29724515ce2b8$export$a918cb016a382d45) : (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get("source", true);
                resultSourceList = [
                    (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get("transform", true);
        var fromTransformResult = datasetModel.get("fromTransformResult", true);
        if (fromTransformResult != null) {
            var errMsg = "";
            if (upMgrList.length !== 1) $1c87d176de397e7e$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = "";
            if (fromTransformResult != null && !upSource) $1c87d176de397e7e$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $523dedd0a2328c06$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $99e22f5c2aa5094b$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($1c87d176de397e7e$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $370e5aa482d8420b$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $8ffb0d67e9446edb$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            var datasetModel = (0, $7dc6cdfd7450ef29$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7dc6cdfd7450ef29$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get("seriesLayoutBy", true);
            sourceHeader = sourceHost.get("sourceHeader", true);
            dimensions = sourceHost.get("dimensions", true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get("seriesLayoutBy", true);
            sourceHeader = model.get("sourceHeader", true);
            dimensions = model.get("dimensions", true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $1c87d176de397e7e$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(datasetModel.option.transform);
}
function $1c87d176de397e7e$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === "series";
}
function $1c87d176de397e7e$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS = "line-height:1";
// TODO: more textStyle option
function $d5ab84c08d6657ec$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || "#6e7079";
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || "400";
    var valueFontColor = textStyle.color || "#464646";
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || "900";
    if (renderMode === "html") // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontSize + "") + "px;color:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontWeight + ""),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontSize + "") + "px;color:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontWeight + "")
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $d5ab84c08d6657ec$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $d5ab84c08d6657ec$var$RICH_TEXT_GAPS = [
    "",
    "\n",
    "\n\n",
    "\n\n\n"
];
function $d5ab84c08d6657ec$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $d5ab84c08d6657ec$var$isSectionFragment(frag) {
    return frag.type === "section";
}
function $d5ab84c08d6657ec$var$getBuilder(frag) {
    return $d5ab84c08d6657ec$var$isSectionFragment(frag) ? $d5ab84c08d6657ec$var$buildSection : $d5ab84c08d6657ec$var$buildNameValue;
}
function $d5ab84c08d6657ec$var$getBlockGapLevel(frag) {
    if ($d5ab84c08d6657ec$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $d5ab84c08d6657ec$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $d5ab84c08d6657ec$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $d5ab84c08d6657ec$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $d5ab84c08d6657ec$var$getGap($d5ab84c08d6657ec$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!subBlocks || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: "asc",
            valueDesc: "desc"
        };
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $40ab59f44b7d2db6$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === "seriesDesc") subBlocks.reverse();
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $d5ab84c08d6657ec$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === "richText" ? subMarkupTextList.join(gaps.richText) : $d5ab84c08d6657ec$var$wrapBlockHTML(subMarkupTextList.join(""), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $c84c9521536c601a$export$3cd8db88714decfc)(fragment.header, "ordinal", ctx.useUTC);
    var nameStyle = $d5ab84c08d6657ec$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    if (ctx.renderMode === "richText") return $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $d5ab84c08d6657ec$var$wrapBlockHTML('<div style="' + nameStyle + ";" + $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS + ';">' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(displayableHeader) + "</div>" + subMarkupText, topMarginForOuterGap);
}
function $d5ab84c08d6657ec$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $c84c9521536c601a$export$3cd8db88714decfc)(val, (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? "" : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || "#333", renderMode);
    var readableName = noName ? "" : (0, $c84c9521536c601a$export$3cd8db88714decfc)(name, "ordinal", useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.dataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $d5ab84c08d6657ec$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === "richText" ? (noMarker ? "" : markerStr) + (noName ? "" : $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? "" : $d5ab84c08d6657ec$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $d5ab84c08d6657ec$var$wrapBlockHTML((noMarker ? "" : markerStr) + (noName ? "" : $d5ab84c08d6657ec$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? "" : $d5ab84c08d6657ec$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $d5ab84c08d6657ec$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $d5ab84c08d6657ec$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $d5ab84c08d6657ec$var$getGap(gapLevel) {
    return {
        html: $d5ab84c08d6657ec$var$HTML_GAPS[gapLevel],
        richText: $d5ab84c08d6657ec$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $d5ab84c08d6657ec$var$wrapBlockHTML(encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    return '<div style="' + marginCSS + ";" + $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS + ';">' + encodedContent + clearfix + "</div>";
}
function $d5ab84c08d6657ec$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? "margin-left:2px" : "";
    return '<span style="' + style + ";" + marginCss + '">' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(name) + "</span>";
}
function $d5ab84c08d6657ec$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? "10px" : "20px";
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : "";
    valueList = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return '<span style="' + alignCSS + ";" + style + '">' + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(value);
    }).join("&nbsp;&nbsp;") + "</span>";
}
function $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $d5ab84c08d6657ec$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: "right"
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(values) ? values.join("  ") : values, styles);
}
function $d5ab84c08d6657ec$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, "style");
    var color = style[series.visualDrawType];
    return (0, $c84c9521536c601a$export$cda04d03233e5555)(color);
}
function $d5ab84c08d6657ec$export$3048212c802df496(model, renderMode) {
    var padding = model.get("padding");
    return padding != null ? padding : renderMode === "richText" ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $d5ab84c08d6657ec$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $cfc1f3b422a3185f$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return "__EC_aUTo_" + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === "richText" ? this._generateStyleName() : null;
        var marker = (0, $c84c9521536c601a$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(styles)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $b0d4c63a14430ca1$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll("defaultedTooltip");
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value);
    var markerColor = (0, $d5ab84c08d6657ec$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $b0d4c63a14430ca1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $76d619f648247e6d$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || "";
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                markerType: "item",
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                dataIndex: dataIndex
            })
        ].concat(subBlocks || [])
    });
}
function $b0d4c63a14430ca1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            markerType: "subItem",
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $7c10febb2cdef0d8$var$inner = $76d619f648247e6d$export$64df9f8d92ae083f();
function $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $7c10febb2cdef0d8$export$e960441116ae2799 = "__universalTransitionEnabled";
var $7c10febb2cdef0d8$var$SeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            count: $7c10febb2cdef0d8$var$dataTaskCount,
            reset: $7c10febb2cdef0d8$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $7c10febb2cdef0d8$var$inner(this).sourceManager = new (0, $1c87d176de397e7e$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $7c10febb2cdef0d8$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $7c10febb2cdef0d8$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += "Series";
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $7a1bd9c2710fea0d$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $7c10febb2cdef0d8$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $7c10febb2cdef0d8$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed = data;
        $7c10febb2cdef0d8$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(data)) {
            var props = [
                "show"
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $76d619f648247e6d$export$abdcc6a26372f94b(data[i], "label", props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $7c10febb2cdef0d8$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $7c10febb2cdef0d8$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $7c10febb2cdef0d8$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $7c10febb2cdef0d8$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get("encode", true);
        if (encode) return $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $7c10febb2cdef0d8$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get("colorBy");
        return colorBy || "series";
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === "series";
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $b0d4c63a14430ca1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow("animation");
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow("animationThreshold")) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get("progressive");
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get("progressiveThreshold");
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === "series" || selectedMap === "all") {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === "all") return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $7a1bd9c2710fea0d$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === "all" || selectedMap[$7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            "select",
            "disabled"
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$7c10febb2cdef0d8$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === "series") option.selectedMap = "all";
        else if (selectedMode === "multiple") {
            if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === "single" || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = "series.__base__";
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = "circle";
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = "itemStyle";
        proto.visualDrawType = "fill";
    }();
    return SeriesModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7c10febb2cdef0d8$var$SeriesModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7c10febb2cdef0d8$var$SeriesModel, (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4));
(0, $cd5f95cf03b4e3e7$export$c9c2d87774f1275d)($7c10febb2cdef0d8$var$SeriesModel, (0, $116d65051f61bdfe$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $7c10febb2cdef0d8$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$76d619f648247e6d$export$beae19a2652b3368(seriesModel)) seriesModel.name = $7c10febb2cdef0d8$var$getSeriesAutoName(seriesModel) || name;
}
function $7c10febb2cdef0d8$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll("seriesName");
    var nameArr = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(" ");
}
function $7c10febb2cdef0d8$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $7c10febb2cdef0d8$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $7c10febb2cdef0d8$var$dataTaskProgress;
}
function $7c10febb2cdef0d8$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $7c10febb2cdef0d8$var$wrapData(data, seriesModel) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($7a1bd9c2710fea0d$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $7a1bd9c2710fea0d$export$c3095a23b368d1f2($7c10febb2cdef0d8$var$onDataChange, seriesModel));
    });
}
function $7c10febb2cdef0d8$var$onDataChange(seriesModel, newList) {
    var task = $7c10febb2cdef0d8$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $7c10febb2cdef0d8$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $7c10febb2cdef0d8$export$2e2bcd8739ae039 = $7c10febb2cdef0d8$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $737c88aa0711f65a$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this.uid = $5370df662b2caf37$export$6d2b3473b0986646("viewComponent");
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$cd5f95cf03b4e3e7$export$cd4c3a4dca301c70($737c88aa0711f65a$var$ComponentView);
$cd5f95cf03b4e3e7$export$241315e45585454d($737c88aa0711f65a$var$ComponentView);
var $737c88aa0711f65a$export$2e2bcd8739ae039 = $737c88aa0711f65a$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $cd70075c57b35175$export$2e2bcd8739ae039() {
    var inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && "reset";
    };
}




var $0dc5061053e23cd3$var$inner = $76d619f648247e6d$export$64df9f8d92ae083f();
var $0dc5061053e23cd3$var$renderPlanner = (0, $cd70075c57b35175$export$2e2bcd8739ae039)();
var $0dc5061053e23cd3$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this.uid = $5370df662b2caf37$export$6d2b3473b0986646("viewChart");
        this.renderTask = (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            plan: $0dc5061053e23cd3$var$renderTaskPlan,
            reset: $0dc5061053e23cd3$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $0dc5061053e23cd3$var$toggleHighlight(data, payload, "emphasis");
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $0dc5061053e23cd3$var$toggleHighlight(data, payload, "normal");
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $5b455ae6f843ac47$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $0dc5061053e23cd3$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = "chart";
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $0dc5061053e23cd3$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $2bf82c0980125b62$export$77d1445f699c58b5)(el)) (state === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(el, highlightDigit);
}
function $0dc5061053e23cd3$var$toggleHighlight(data, payload, state) {
    var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $2bf82c0980125b62$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $0dc5061053e23cd3$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $0dc5061053e23cd3$var$elSetState(el, state, highlightDigit);
    });
}
$cd5f95cf03b4e3e7$export$cd4c3a4dca301c70($0dc5061053e23cd3$var$ChartView, [
    "dispose"
]);
$cd5f95cf03b4e3e7$export$241315e45585454d($0dc5061053e23cd3$var$ChartView);
function $0dc5061053e23cd3$var$renderTaskPlan(context) {
    return $0dc5061053e23cd3$var$renderPlanner(context.model);
}
function $0dc5061053e23cd3$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $0dc5061053e23cd3$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? "incrementalPrepareRender" : updateMethod && view[updateMethod] ? updateMethod : "render";
    if (methodName !== "render") view[methodName](seriesModel, ecModel, api, payload);
    return $0dc5061053e23cd3$var$progressMethodMap[methodName];
}
var $0dc5061053e23cd3$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $0dc5061053e23cd3$export$2e2bcd8739ae039 = $0dc5061053e23cd3$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c98659a9437a3d2e$var$ORIGIN_METHOD = "\x00__throttleOriginMethod";
var $c98659a9437a3d2e$var$RATE = "\x00__throttleRate";
var $c98659a9437a3d2e$var$THROTTLE_TYPE = "\x00__throttleType";
function $c98659a9437a3d2e$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $c98659a9437a3d2e$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$c98659a9437a3d2e$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$c98659a9437a3d2e$var$THROTTLE_TYPE];
    var lastRate = fn[$c98659a9437a3d2e$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $c98659a9437a3d2e$export$de363e709c412c8a(originFn, rate, throttleType === "debounce");
        fn[$c98659a9437a3d2e$var$ORIGIN_METHOD] = originFn;
        fn[$c98659a9437a3d2e$var$THROTTLE_TYPE] = throttleType;
        fn[$c98659a9437a3d2e$var$RATE] = rate;
    }
    return fn;
}
function $c98659a9437a3d2e$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$c98659a9437a3d2e$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$c98659a9437a3d2e$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a617f62dd17b10f1$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $a617f62dd17b10f1$var$defaultStyleMappers = {
    itemStyle: (0, $06542048a26d4d91$export$2e2bcd8739ae039)((0, $c42afdfd2f0ddc96$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $06542048a26d4d91$export$2e2bcd8739ae039)((0, $9c5206e1bd69e88f$export$9f34de5b59222949), true)
};
var $a617f62dd17b10f1$var$defaultColorKey = {
    lineStyle: "stroke",
    itemStyle: "fill"
};
function $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $a617f62dd17b10f1$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $a617f62dd17b10f1$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $a617f62dd17b10f1$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return "fill";
    }
    return colorKey;
}
var $a617f62dd17b10f1$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow("decal");
        if (decalOption) {
            data.setVisual("decal", decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === "auto" || globalStyle.stroke === "auto";
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual("colorFromPalette", true);
            }
            globalStyle.fill = globalStyle.fill === "auto" || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === "auto" || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual("style", globalStyle);
        data.setVisual("drawType", colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual("colorFromPalette", false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, "style", itemStyle);
                }
            };
        }
    }
};
var $a617f62dd17b10f1$var$sharedModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
var $a617f62dd17b10f1$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
        // Set in itemStyle
        var getStyle = $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual("drawType");
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $a617f62dd17b10f1$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($a617f62dd17b10f1$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, "style");
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
                    if ($a617f62dd17b10f1$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, "decal", $a617f62dd17b10f1$var$sharedModel.option.decal);
                        $a617f62dd17b10f1$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, "colorFromPalette", false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $a617f62dd17b10f1$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + "-" + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $a617f62dd17b10f1$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $a617f62dd17b10f1$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
            var colorKey = $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, "colorFromPalette");
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, "style");
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + "";
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f23f99c31dceac8f$var$PI = Math.PI;
function $f23f99c31dceac8f$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $7a1bd9c2710fea0d$export$ebe90cb607ad99e(opts, {
        text: "loading",
        textColor: "#000",
        fontSize: 12,
        fontWeight: "normal",
        fontStyle: "normal",
        fontFamily: "sans-serif",
        maskColor: "rgba(255, 255, 255, 0.8)",
        showSpinner: true,
        color: "#5470c6",
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    var mask = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $fe885cc21795562b$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        style: {
            fill: "none"
        },
        textContent: textContent,
        textConfig: {
            position: "right",
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $2b5c23eb3597b84a$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$f23f99c31dceac8f$var$PI / 2,
                endAngle: -$f23f99c31dceac8f$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: "round",
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $f23f99c31dceac8f$var$PI * 3 / 2
        }).start("circularInOut");
        arc.animateShape(true).when(1000, {
            startAngle: $f23f99c31dceac8f$var$PI * 3 / 2
        }).delay(300).start("circularInOut");
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $94ae4e8744638a8a$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count();
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get("large") && dataLen >= seriesModel.get("largeThreshold");
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get("progressiveChunkMode") === "mod" ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = "";
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== "remain" && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
                plan: $94ae4e8744638a8a$var$seriesTaskPlan,
                reset: $94ae4e8744638a8a$var$seriesTaskReset,
                count: $94ae4e8744638a8a$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            reset: $94ae4e8744638a8a$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = "";
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
                reset: $94ae4e8744638a8a$var$stubReset,
                onDirty: $94ae4e8744638a8a$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $94ae4e8744638a8a$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("stageHandler");
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $94ae4e8744638a8a$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $94ae4e8744638a8a$var$stubReset(context) {
    return context.overallProgress && $94ae4e8744638a8a$var$stubProgress;
}
function $94ae4e8744638a8a$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $94ae4e8744638a8a$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $94ae4e8744638a8a$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $94ae4e8744638a8a$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $76d619f648247e6d$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $94ae4e8744638a8a$var$makeSeriesTaskProgress(idx);
    }) : $94ae4e8744638a8a$var$singleSeriesTaskProgress;
}
var $94ae4e8744638a8a$var$singleSeriesTaskProgress = $94ae4e8744638a8a$var$makeSeriesTaskProgress(0);
function $94ae4e8744638a8a$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $94ae4e8744638a8a$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $94ae4e8744638a8a$var$detectSeriseType(legacyFunc) {
    $94ae4e8744638a8a$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($94ae4e8744638a8a$var$ecModelMock, $94ae4e8744638a8a$var$apiMock);
    } catch (e) {}
    return $94ae4e8744638a8a$var$seriesType;
}
var $94ae4e8744638a8a$var$ecModelMock = {};
var $94ae4e8744638a8a$var$apiMock = {};
var $94ae4e8744638a8a$var$seriesType;
$94ae4e8744638a8a$var$mockMethods($94ae4e8744638a8a$var$ecModelMock, (0, $51f6ef0dd9546916$export$2e2bcd8739ae039));
$94ae4e8744638a8a$var$mockMethods($94ae4e8744638a8a$var$apiMock, (0, $a6d7e6163195660e$export$2e2bcd8739ae039));
$94ae4e8744638a8a$var$ecModelMock.eachSeriesByType = $94ae4e8744638a8a$var$ecModelMock.eachRawSeriesByType = function(type) {
    $94ae4e8744638a8a$var$seriesType = type;
};
$94ae4e8744638a8a$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === "series" && cond.subType) $94ae4e8744638a8a$var$seriesType = cond.subType;
};
function $94ae4e8744638a8a$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
/* eslint-enable */ }
var $94ae4e8744638a8a$export$2e2bcd8739ae039 = $94ae4e8744638a8a$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0e5dbddd76825050$var$colorAll = [
    "#37A2DA",
    "#32C5E9",
    "#67E0E3",
    "#9FE6B8",
    "#FFDB5C",
    "#ff9f7f",
    "#fb7293",
    "#E062AE",
    "#E690D1",
    "#e7bcf3",
    "#9d96f5",
    "#8378EA",
    "#96BFFF"
];
var $0e5dbddd76825050$export$2e2bcd8739ae039 = {
    color: $0e5dbddd76825050$var$colorAll,
    colorLayer: [
        [
            "#37A2DA",
            "#ffd85c",
            "#fd7b5f"
        ],
        [
            "#37A2DA",
            "#67E0E3",
            "#FFDB5C",
            "#ff9f7f",
            "#E062AE",
            "#9d96f5"
        ],
        [
            "#37A2DA",
            "#32C5E9",
            "#9FE6B8",
            "#FFDB5C",
            "#ff9f7f",
            "#fb7293",
            "#e7bcf3",
            "#8378EA",
            "#96BFFF"
        ],
        $0e5dbddd76825050$var$colorAll
    ]
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $985c98ffd51c6ff6$var$contrastColor = "#B9B8CE";
var $985c98ffd51c6ff6$var$backgroundColor = "#100C2A";
var $985c98ffd51c6ff6$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $985c98ffd51c6ff6$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                color: "#484753"
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    "rgba(255,255,255,0.02)",
                    "rgba(255,255,255,0.05)"
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: "#20203B"
            }
        }
    };
};
var $985c98ffd51c6ff6$var$colorPalette = [
    "#4992ff",
    "#7cffb2",
    "#fddd60",
    "#ff6e76",
    "#58d9f9",
    "#05c091",
    "#ff8a45",
    "#8d48e3",
    "#dd79ff"
];
var $985c98ffd51c6ff6$var$theme = {
    darkMode: true,
    color: $985c98ffd51c6ff6$var$colorPalette,
    backgroundColor: $985c98ffd51c6ff6$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: "#817f91"
        },
        crossStyle: {
            color: "#817f91"
        },
        label: {
            // TODO Contrast of label backgorundColor
            color: "#fff"
        }
    },
    legend: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    textStyle: {
        color: $985c98ffd51c6ff6$var$contrastColor
    },
    title: {
        textStyle: {
            color: "#EEF1FA"
        },
        subtextStyle: {
            color: "#B9B8CE"
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    dataZoom: {
        borderColor: "#71708A",
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        brushStyle: {
            color: "rgba(135,163,206,0.3)"
        },
        handleStyle: {
            color: "#353450",
            borderColor: "#C5CBE3"
        },
        moveHandleStyle: {
            color: "#B0B6C3",
            opacity: 0.3
        },
        fillerColor: "rgba(135,163,206,0.2)",
        emphasis: {
            handleStyle: {
                borderColor: "#91B7F2",
                color: "#4D587D"
            },
            moveHandleStyle: {
                color: "#636D9A",
                opacity: 0.7
            }
        },
        dataBackground: {
            lineStyle: {
                color: "#71708A",
                width: 1
            },
            areaStyle: {
                color: "#71708A"
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: "#87A3CE"
            },
            areaStyle: {
                color: "#87A3CE"
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        label: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        controlStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor,
            borderColor: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    calendar: {
        itemStyle: {
            color: $985c98ffd51c6ff6$var$backgroundColor
        },
        dayLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        monthLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        yearLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    timeAxis: $985c98ffd51c6ff6$var$axisCommon(),
    logAxis: $985c98ffd51c6ff6$var$axisCommon(),
    valueAxis: $985c98ffd51c6ff6$var$axisCommon(),
    categoryAxis: $985c98ffd51c6ff6$var$axisCommon(),
    line: {
        symbol: "circle"
    },
    graph: {
        color: $985c98ffd51c6ff6$var$colorPalette
    },
    gauge: {
        title: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        "rgba(207,212,219,0.2)"
                    ]
                ]
            }
        },
        axisLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        detail: {
            color: "#EEF1FA"
        }
    },
    candlestick: {
        itemStyle: {
            color: "#f64e56",
            color0: "#54ea92",
            borderColor: "#f64e56",
            borderColor0: "#54ea92"
        }
    }
};
$985c98ffd51c6ff6$var$theme.categoryAxis.splitLine.show = false;
var $985c98ffd51c6ff6$export$2e2bcd8739ae039 = $985c98ffd51c6ff6$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $82d62ed69f6abce3$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(query)) {
            var condCptType = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                "Index",
                "Name",
                "Id"
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== "data") {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, "mainType") && check(cptQuery, model, "subType") && check(cptQuery, model, "index", "componentIndex") && check(cptQuery, model, "name") && check(cptQuery, model, "id") && check(dataQuery, packedEvent, "name") && check(dataQuery, packedEvent, "dataIndex") && check(dataQuery, packedEvent, "dataType") && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB = [
    "symbol",
    "symbolSize",
    "symbolRotate",
    "symbolOffset"
];
var $f8e1f1a448782588$var$SYMBOL_PROPS = $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB.concat([
    "symbolKeepAspect"
]);
// Encoding visual for all series include which is filtered for legend drawing
var $f8e1f1a448782588$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual("legendIcon", seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get("symbolKeepAspect")
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $f8e1f1a448782588$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $f8e1f1a448782588$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $f8e1f1a448782588$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ea13f1ab2169d82d$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case "color":
            var style = data.getItemVisual(dataIndex, "style");
            return style[data.getVisual("drawType")];
        case "opacity":
            return data.getItemVisual(dataIndex, "style").opacity;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $ea13f1ab2169d82d$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case "color":
            var style = data.getVisual("style");
            return style[data.getVisual("drawType")];
        case "opacity":
            return data.getVisual("style").opacity;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            return data.getVisual(key);
        default:
    }
}
function $ea13f1ab2169d82d$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case "color":
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, "style");
            style[data.getVisual("drawType")] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, "colorFromPalette", false);
            break;
        case "opacity":
            data.ensureUniqueItemVisual(dataIndex, "style").opacity = value;
            break;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $e855ccf7eff48bce$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: "series",
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        [
            seriesType + "ToggleSelect",
            "toggleSelect"
        ],
        [
            seriesType + "Select",
            "select"
        ],
        [
            seriesType + "UnSelect",
            "unselect"
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: "series",
        subType: "pie"
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $e855ccf7eff48bce$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on("selectchanged", function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "selectchanged", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "selectchanged", ecIns, ecModel, params);
        } else if (params.fromAction === "select") {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "selected", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "selected", ecIns, ecModel, params);
        } else if (params.fromAction === "unselect") {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "unselected", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "unselected", ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $808c5a2823518f68$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $56aadf5b08ec1b47$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $56aadf5b08ec1b47$var$supportDefineProperty = typeof Object.defineProperty === "function";
var $56aadf5b08ec1b47$var$WeakMap = function() {
    function WeakMap() {
        this._id = "__ec_inner_" + $56aadf5b08ec1b47$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($56aadf5b08ec1b47$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError("Value of WeakMap is not a non-null object.");
        return key;
    };
    return WeakMap;
}();
var $56aadf5b08ec1b47$export$2e2bcd8739ae039 = $56aadf5b08ec1b47$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory





/**
 * Triangle shape
 * @inner
 */ var $5370466dadc978d7$var$Triangle = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "triangle",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $5370466dadc978d7$var$Diamond = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "diamond",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $5370466dadc978d7$var$Pin = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "pin",
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $5370466dadc978d7$var$Arrow = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "arrow",
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $5370466dadc978d7$var$symbolCtors = {
    line: $7a316ae5ceff7b27$export$2e2bcd8739ae039,
    rect: $419e5ff2f303755e$export$2e2bcd8739ae039,
    roundRect: $419e5ff2f303755e$export$2e2bcd8739ae039,
    square: $419e5ff2f303755e$export$2e2bcd8739ae039,
    circle: $1e68d8727773abb7$export$2e2bcd8739ae039,
    diamond: $5370466dadc978d7$var$Diamond,
    pin: $5370466dadc978d7$var$Pin,
    arrow: $5370466dadc978d7$var$Arrow,
    triangle: $5370466dadc978d7$var$Triangle
};
var $5370466dadc978d7$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $5370466dadc978d7$export$33fc3b478d332725 = {};
(0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($5370466dadc978d7$var$symbolCtors, function(Ctor, name) {
    $5370466dadc978d7$export$33fc3b478d332725[name] = new Ctor();
});
var $5370466dadc978d7$var$SymbolClz = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "symbol",
    shape: {
        symbolType: "",
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $6c308355c7107803$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === "pin" && config.position === "inside") res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== "none") {
            var proxySymbol = $5370466dadc978d7$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = "rect";
                proxySymbol = $5370466dadc978d7$export$33fc3b478d332725[symbolType];
            }
            $5370466dadc978d7$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $5370466dadc978d7$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== "image") {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || "#fff";
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === "line") symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $5370466dadc978d7$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf("empty") === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf("image://") === 0) symbolPath = $5b455ae6f843ac47$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? "center" : "cover");
    else if (symbolType.indexOf("path://") === 0) symbolPath = $5b455ae6f843ac47$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? "center" : "cover");
    else symbolPath = new $5370466dadc978d7$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $5370466dadc978d7$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $d76b6507633b3c44$var$isSafeNum(num) {
    return isFinite(num);
}
function $d76b6507633b3c44$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $d76b6507633b3c44$var$isSafeNum(x) ? x : 0;
    x2 = $d76b6507633b3c44$var$isSafeNum(x2) ? x2 : 1;
    y = $d76b6507633b3c44$var$isSafeNum(y) ? y : 0;
    y2 = $d76b6507633b3c44$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $d76b6507633b3c44$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $d76b6507633b3c44$var$isSafeNum(x) ? x : 0.5;
    y = $d76b6507633b3c44$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $d76b6507633b3c44$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $d76b6507633b3c44$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === "radial" ? $d76b6507633b3c44$export$57f098206d57a443(ctx, obj, rect) : $d76b6507633b3c44$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $d76b6507633b3c44$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $d76b6507633b3c44$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $d76b6507633b3c44$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        "width",
        "height"
    ][whIdx];
    var cwh = [
        "clientWidth",
        "clientHeight"
    ][whIdx];
    var plt = [
        "paddingLeft",
        "paddingTop"
    ][whIdx];
    var prb = [
        "paddingRight",
        "paddingBottom"
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== "auto") return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $d76b6507633b3c44$var$parseInt10(stl[wh]) || $d76b6507633b3c44$var$parseInt10(root.style[wh])) - ($d76b6507633b3c44$var$parseInt10(stl[plt]) || 0) - ($d76b6507633b3c44$var$parseInt10(stl[prb]) || 0) | 0;
}







function $21ab8baf7c1f083c$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === "solid" || !(lineWidth > 0)) return null;
    return lineType === "dashed" ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === "dotted" ? [
        lineWidth
    ] : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $21ab8baf7c1f083c$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $21ab8baf7c1f083c$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $4f71e35e4552e3dd$var$pathProxyForDraw = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)(true);
function $4f71e35e4552e3dd$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === "none" || !(style.lineWidth > 0));
}
function $4f71e35e4552e3dd$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === "string" && strokeOrFill !== "none";
}
function $4f71e35e4552e3dd$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== "none";
}
function $4f71e35e4552e3dd$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $4f71e35e4552e3dd$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $a53bd598adfb7ebe$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || "repeat");
        if (typeof DOMMatrix === "function" && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $4f71e35e4552e3dd$var$brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = $4f71e35e4552e3dd$var$styleHasStroke(style);
    var hasFill = $4f71e35e4552e3dd$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $4f71e35e4552e3dd$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $4f71e35e4552e3dd$var$doStrokePath(ctx, style);
            if (hasFill) $4f71e35e4552e3dd$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $4f71e35e4552e3dd$var$doFillPath(ctx, style);
            if (hasStroke) $4f71e35e4552e3dd$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash) ctx.setLineDash([]);
}
function $4f71e35e4552e3dd$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $a53bd598adfb7ebe$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $4f71e35e4552e3dd$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += "");
    if (text) {
        ctx.font = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($4f71e35e4552e3dd$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($4f71e35e4552e3dd$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($4f71e35e4552e3dd$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($4f71e35e4552e3dd$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS = [
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY"
];
var $4f71e35e4552e3dd$var$STROKE_PROPS = [
    [
        "lineCap",
        "butt"
    ],
    [
        "lineJoin",
        "miter"
    ],
    [
        "miterLimit",
        10
    ]
];
function $4f71e35e4552e3dd$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $56206a6cb4666931$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $56206a6cb4666931$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $56206a6cb4666931$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $4f71e35e4552e3dd$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $4f71e35e4552e3dd$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $4f71e35e4552e3dd$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $4f71e35e4552e3dd$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $4f71e35e4552e3dd$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $4f71e35e4552e3dd$var$STROKE_PROPS.length; i++){
        var prop = $4f71e35e4552e3dd$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $4f71e35e4552e3dd$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $4f71e35e4552e3dd$var$bindCommonProps(ctx, $4f71e35e4552e3dd$var$getStyle(el, scope.inHover), prevEl && $4f71e35e4552e3dd$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $4f71e35e4552e3dd$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $4f71e35e4552e3dd$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $4f71e35e4552e3dd$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $4f71e35e4552e3dd$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $4f71e35e4552e3dd$var$DRAW_TYPE_PATH = 1;
var $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE = 2;
var $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT = 3;
var $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL = 4;
function $4f71e35e4552e3dd$var$canPathBatch(style) {
    var hasFill = $4f71e35e4552e3dd$var$styleHasFill(style);
    var hasStroke = $4f71e35e4552e3dd$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== "string" || hasStroke && typeof style.stroke !== "string" || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = "";
    scope.batchStroke = "";
}
function $4f71e35e4552e3dd$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $4f71e35e4552e3dd$export$567881adfc3eb7f3(ctx, el) {
    $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $d76b6507633b3c44$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $4f71e35e4552e3dd$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && el.autoBatch && $4f71e35e4552e3dd$var$canPathBatch(el.style);
    if (forceSetTransform || $4f71e35e4552e3dd$var$isTransformChanged(m, prevEl.transform)) {
        $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
        $4f71e35e4552e3dd$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
    var style = $4f71e35e4552e3dd$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_PATH;
        }
        $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $4f71e35e4552e3dd$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || "";
            scope.batchStroke = style.stroke || "";
        }
    } else {
        if (el instanceof (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT;
            }
            $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $4f71e35e4552e3dd$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE;
            }
            $4f71e35e4552e3dd$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $4f71e35e4552e3dd$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL;
            }
            $4f71e35e4552e3dd$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $4f71e35e4552e3dd$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $c6d646aacd243427$var$decalMap = new (0, $56aadf5b08ec1b47$export$2e2bcd8739ae039)();
var $c6d646aacd243427$var$decalCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
var $c6d646aacd243427$var$decalKeys = [
    "symbol",
    "symbolSize",
    "symbolKeepAspect",
    "color",
    "backgroundColor",
    "dashArrayX",
    "dashArrayY",
    "maxTileWidth",
    "maxTileHeight"
];
function $c6d646aacd243427$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === "none") return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === "svg";
    if (decalObject.dirty) $c6d646aacd243427$var$decalMap["delete"](decalObject);
    var oldPattern = $c6d646aacd243427$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(decalObject, {
        symbol: "rect",
        symbolSize: 1,
        symbolKeepAspect: true,
        color: "rgba(0, 0, 0, 0.2)",
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === "none") decalOpt.backgroundColor = null;
    var pattern = {
        repeat: "repeat"
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $c6d646aacd243427$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $c6d646aacd243427$var$decalKeys.length; ++i){
            var value = decalOpt[$c6d646aacd243427$var$decalKeys[i]];
            if (value != null && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value) && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(value) && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value) && typeof value !== "boolean") {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(",") + (isSVG ? "-svg" : "");
            var cache = $c6d646aacd243427$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $c6d646aacd243427$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $c6d646aacd243427$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $c6d646aacd243427$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $c6d646aacd243427$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $c6d646aacd243427$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: "g",
            attrs: {},
            key: "dcl",
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext("2d");
        }
        brushDecal();
        if (isValidKey) $c6d646aacd243427$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $cfc1f3b422a3185f$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $cfc1f3b422a3185f$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $4f71e35e4552e3dd$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $c6d646aacd243427$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            "rect"
        ]
    ];
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $c6d646aacd243427$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $c6d646aacd243427$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $c6d646aacd243427$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $c6d646aacd243427$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === "object" && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $c6d646aacd243427$var$getLineBlockLengthX(dash) {
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash, function(line) {
        return $c6d646aacd243427$var$getLineBlockLengthY(line);
    });
}
function $c6d646aacd243427$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}


function $d82adaf1a5a5cfeb$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, "decal");
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, "style");
                itemStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual("decal");
        if (decal) {
            var style = data.getVisual("style");
            style.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8022924a3c5c0bb5$var$lifecycle = new (0, $63441a86293f101f$export$2e2bcd8739ae039)();
var $8022924a3c5c0bb5$export$2e2bcd8739ae039 = $8022924a3c5c0bb5$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $f773aa0508c1d920$var$implsStore = {};
function $f773aa0508c1d920$export$9b808fd12256ddd3(name, impl) {
    $f773aa0508c1d920$var$implsStore[name] = impl;
}
function $f773aa0508c1d920$export$73333eb8a09d5f61(name) {
    return $f773aa0508c1d920$var$implsStore[name];
}


var $4d59907f44a2d0ad$export$83d89fbfd8236492 = "5.5.0";
var $4d59907f44a2d0ad$export$b74ff737e0e298b5 = {
    zrender: "5.5.0"
};
var $4d59907f44a2d0ad$var$TEST_FRAME_REMAIN_TIME = 1;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// "Data filter" will block the stream, so it should be
// put at the beginning of data processing.
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART = 3000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_BRUSH = 5000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_ARIA = 6000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL = 7000;
var $4d59907f44a2d0ad$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_ARIA,
        DECAL: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL
    }
};
// Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY = "__flagInMainProcess";
var $4d59907f44a2d0ad$var$PENDING_UPDATE = "__pendingUpdate";
var $4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY = "__needsUpdateStatus";
var $4d59907f44a2d0ad$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_KEY = "__connectUpdateStatus";
var $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING = 0;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATING = 1;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATED = 2;
function $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        return $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $63441a86293f101f$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $4d59907f44a2d0ad$var$MessageCenter = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$var$messageCenterProto = $4d59907f44a2d0ad$var$MessageCenter.prototype;
$4d59907f44a2d0ad$var$messageCenterProto.on = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter("on");
$4d59907f44a2d0ad$var$messageCenterProto.off = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter("off");
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $4d59907f44a2d0ad$var$prepare;
var $4d59907f44a2d0ad$var$prepareView;
var $4d59907f44a2d0ad$var$updateDirectly;
var $4d59907f44a2d0ad$var$updateMethods;
var $4d59907f44a2d0ad$var$doConvertPixel;
var $4d59907f44a2d0ad$var$updateStreamModes;
var $4d59907f44a2d0ad$var$doDispatchAction;
var $4d59907f44a2d0ad$var$flushPendingActions;
var $4d59907f44a2d0ad$var$triggerUpdatedEvent;
var $4d59907f44a2d0ad$var$bindRenderedEvent;
var $4d59907f44a2d0ad$var$bindMouseEvent;
var $4d59907f44a2d0ad$var$render;
var $4d59907f44a2d0ad$var$renderComponents;
var $4d59907f44a2d0ad$var$renderSeries;
var $4d59907f44a2d0ad$var$createExtensionAPI;
var $4d59907f44a2d0ad$var$enableConnect;
var $4d59907f44a2d0ad$var$markStatusToUpdate;
var $4d59907f44a2d0ad$var$applyChangedStates;
var $4d59907f44a2d0ad$var$ECharts = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $82d62ed69f6abce3$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        // Get theme by name
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(theme)) theme = $4d59907f44a2d0ad$var$themeStorage[theme];
        _this._dom = dom;
        var defaultRenderer = "canvas";
        var defaultCoarsePointer = "auto";
        var defaultUseDirtyRect = false;
        var root;
        if (opts.ssr) $6eba88f9eebe6af9$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            hashMap.set("series_index", ecData.seriesIndex);
            hashMap.set("data_index", dataIndex);
            ecData.ssrType && hashMap.set("ssr_type", ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $6eba88f9eebe6af9$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $c98659a9437a3d2e$export$de363e709c412c8a)((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(zr.flush, zr), 17);
        theme = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(theme);
        theme && (0, $c4489ebdf95633b6$export$2e2bcd8739ae039)(theme, true);
        _this._theme = theme;
        _this._locale = (0, $9b0a1ef4bcc91e7d$export$ddc371781a6af754)(opts.locale || (0, $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $70c3ede7d3b64757$export$2e2bcd8739ae039)();
        var api = _this._api = $4d59907f44a2d0ad$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)($4d59907f44a2d0ad$var$visualFuncs, prioritySortFunc);
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)($4d59907f44a2d0ad$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $94ae4e8744638a8a$export$2e2bcd8739ae039)(_this, api, $4d59907f44a2d0ad$var$dataProcessorFuncs, $4d59907f44a2d0ad$var$visualFuncs);
        _this._messageCenter = new $4d59907f44a2d0ad$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on("frame", _this._onframe, _this);
        $4d59907f44a2d0ad$var$bindRenderedEvent(zr, _this);
        $4d59907f44a2d0ad$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $7a1bd9c2710fea0d$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $4d59907f44a2d0ad$var$applyChangedStates(this);
        var scheduler = this._scheduler;
        // Lazy update
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            var silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
            try {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, null, this[$4d59907f44a2d0ad$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
            $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
            $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $4d59907f44a2d0ad$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $4d59907f44a2d0ad$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $4d59907f44a2d0ad$var$renderSeries(this, this._model, api, "remain", {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        if (!this._model || notMerge) {
            var optionManager = new (0, $bf4c0a9077b4e970$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $51f6ef0dd9546916$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $4d59907f44a2d0ad$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
            $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * @deprecated
   */ ECharts.prototype.setTheme = function() {
        (0, $84bc7667c27ccedc$export$4a9c0b74eb885aa1)("ECharts#setTheme() is DEPRECATED in ECharts 3.0");
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get("backgroundColor"),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).svgSupported) return;
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === "svg" ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL("image/" + (opts && opts.type || "png"));
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === "svg";
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($4d59907f44a2d0ad$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
            var zr_1 = $6eba88f9eebe6af9$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? "svg" : "canvas"
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = "";
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + "," + y + ')">' + item.dom + "</g>";
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $86adec94217b86c6$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL("image/" + (opts && opts.type || "png"));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, "convertToPixel", finder, value);
    };
    ECharts.prototype.convertFromPixel = function(finder, value) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, "convertFromPixel", finder, value);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $76d619f648247e6d$export$95de80076abac814(ecModel, finder);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf("Models") >= 0 && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === "seriesModels") {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $76d619f648247e6d$export$95de80076abac814(ecModel, finder, {
            defaultMainType: "series"
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty("dataIndexInside") ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty("dataIndex") ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === "globalout";
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === "markLine" || componentType === "markPoint" || componentType === "markArea") {
                        componentType = "series";
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$eventActionMap, function(actionType, eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        // Extra events
        // TODO register?
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "selectchanged"
        ], function(eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        (0, $e855ccf7eff48bce$export$2575c83262e49d0c)(this._messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $76d619f648247e6d$export$9fec4d97f1922e0b(this.getDom(), $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY, "");
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $4d59907f44a2d0ad$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption("media");
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        try {
            needPrepare && $4d59907f44a2d0ad$var$prepare(this);
            $4d59907f44a2d0ad$var$updateMethods.update.call(this, {
                type: "resize",
                animation: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = "";
        }
        name = name || "default";
        this.hideLoading();
        if (!$4d59907f44a2d0ad$var$loadingEffects[name]) return;
        var el = $4d59907f44a2d0ad$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, eventObj);
        payload.type = $4d59907f44a2d0ad$var$eventActionMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$4d59907f44a2d0ad$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $4d59907f44a2d0ad$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:layoutlabels", this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $4d59907f44a2d0ad$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $4d59907f44a2d0ad$var$prepareView(ecIns, true);
            $4d59907f44a2d0ad$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $4d59907f44a2d0ad$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== "series" && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = "_ec_" + model.id + "_" + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $737c88aa0711f65a$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $4d59907f44a2d0ad$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + "Id"] = payload[mainType + "Id"];
            query[mainType + "Index"] = payload[mainType + "Index"];
            query[mainType + "Name"] = payload[mainType + "Name"];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $76d619f648247e6d$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $2bf82c0980125b62$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            "emphasis",
                            "disabled"
                        ])) (0, $2bf82c0980125b62$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $2bf82c0980125b62$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $2bf82c0980125b62$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) ? (0, $2bf82c0980125b62$export$b2d02638cc34c042)(dispatcher) : (0, $2bf82c0980125b62$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $2bf82c0980125b62$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039)) {
                        (0, $2bf82c0980125b62$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $2bf82c0980125b62$export$e4ea08ef52e0a73)(model);
                        $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $4d59907f44a2d0ad$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload, {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $4d59907f44a2d0ad$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                $4d59907f44a2d0ad$var$render(this, ecModel, api, payload, updateParams);
                // Set background
                var backgroundColor = ecModel.get("backgroundColor") || "transparent";
                var darkMode = ecModel.get("darkMode");
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                if (darkMode != null && darkMode !== "auto") zr.setDarkMode(darkMode);
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === "series") return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $4d59907f44a2d0ad$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).markUpdateMethod(payload, "updateView");
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $4d59907f44a2d0ad$var$render(this, ecModel, this._api, payload, {});
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).markUpdateMethod(payload, "updateVisual");
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: "visual",
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== "series") {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, this._api);
            },
            updateLayout: function(payload) {
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload);
            }
        };
        $4d59907f44a2d0ad$var$doConvertPixel = function(ecIns, methodName, finder, value) {
            if (ecIns._disposed) {
                $4d59907f44a2d0ad$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $76d619f648247e6d$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
            }
        };
        $4d59907f44a2d0ad$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $4d59907f44a2d0ad$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionWrap = $4d59907f44a2d0ad$var$actions[payloadType];
            var actionInfo = actionWrap.actionInfo;
            var cptTypeTmp = (actionInfo.update || "update").split(":");
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var isSelectChange = (0, $2bf82c0980125b62$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $2bf82c0980125b62$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $2bf82c0980125b62$export$b2a593c7b5243584)(this._api);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                eventObj = actionWrap.action(batchItem, _this._model, _this._api);
                // Emit event outside
                eventObj = eventObj || (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, batchItem);
                // Convert type to eventType
                eventObj.type = actionInfo.event || eventObj.type;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $76d619f648247e6d$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : "series";
                    $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, "series");
                    $4d59907f44a2d0ad$var$markStatusToUpdate(_this);
                } else if (cptType) $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== "none" && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
                    $4d59907f44a2d0ad$var$prepare(this);
                    $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload);
                    this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                } else $4d59907f44a2d0ad$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: actionInfo.event || payloadType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var messageCenter = this._messageCenter;
                messageCenter.trigger(eventObj.type, eventObj);
                // Extra triggered 'selectchanged' event
                if (isSelectChange) {
                    var newObj = {
                        type: "selectchanged",
                        escapeConnect: escapeConnect,
                        selected: (0, $2bf82c0980125b62$export$c529643b619af6b3)(ecModel),
                        isFromClick: payload.isFromClick || false,
                        fromAction: payload.type,
                        fromActionPayload: payload
                    };
                    messageCenter.trigger(newObj.type, newObj);
                }
            }
        };
        $4d59907f44a2d0ad$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $4d59907f44a2d0ad$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $4d59907f44a2d0ad$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger("updated");
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $4d59907f44a2d0ad$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on("rendered", function(params) {
                ecIns.trigger("rendered", params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$4d59907f44a2d0ad$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger("finished");
            });
        };
        $4d59907f44a2d0ad$var$bindMouseEvent = function(zr, ecIns) {
            zr.on("mouseover", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, (0, $2bf82c0980125b62$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $2bf82c0980125b62$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                }
            }).on("mouseout", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, (0, $2bf82c0980125b62$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $2bf82c0980125b62$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                }
            }).on("click", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? "unselect" : "select";
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get("zlevel") || 0;
                var z = componentModel.get("z") || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === "series" ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $97579a54749e4b24$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = "";
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $4d59907f44a2d0ad$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $4d59907f44a2d0ad$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $4d59907f44a2d0ad$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $4d59907f44a2d0ad$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $4d59907f44a2d0ad$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:beforeupdate", ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get("silent");
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $2bf82c0980125b62$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:layoutlabels", ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:transition", ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:afterupdate", ecModel, api, updateParams);
        };
        $4d59907f44a2d0ad$var$markStatusToUpdate = function(ecIns) {
            ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $4d59907f44a2d0ad$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === "emphasis" || stateName === "blur" || stateName === "select")) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push("select");
            if (el.hoverState === (0, $2bf82c0980125b62$export$f0f2bee145debb31) && el.states.emphasis) newStates.push("emphasis");
            else if (el.hoverState === (0, $2bf82c0980125b62$export$1307d6a87d56baa) && el.states.blur) newStates.push("blur");
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get("hoverLayerThreshold") && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.eachRendered(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get("blendMode") || null;
            chartView.eachRendered(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var z = model.get("z") || 0;
            var zlevel = model.get("zlevel") || 0;
            // Set z and zlevel
            view.eachRendered(function(el) {
                doUpdateZ(el, z, zlevel, -Infinity);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        function doUpdateZ(el, z, zlevel, maxZ2) {
            // Group may also have textContent
            var label = el.getTextContent();
            var labelLine = el.getTextGuideLine();
            var isGroup = el.isGroup;
            if (isGroup) {
                // set z & zlevel of children elements of Group
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++)maxZ2 = Math.max(doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
            } else {
                // not Group
                el.z = z;
                el.zlevel = zlevel;
                maxZ2 = Math.max(el.z2, maxZ2);
            }
            // always set z and zlevel if label/labelLine exists
            if (label) {
                label.z = z;
                label.zlevel = zlevel;
                // lift z2 of text content
                // TODO if el.emphasis.z2 is spcefied, what about textContent.
                isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
            }
            if (labelLine) {
                var textGuideLineConfig = el.textGuideLineConfig;
                labelLine.z = z;
                labelLine.zlevel = zlevel;
                isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
            }
            return maxZ2;
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel("stateAnimation");
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get("duration");
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get("delay"),
                easing: stateAnimationModel.get("easing")
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                    if (el instanceof $b02ffe7acd508c08$export$2e2bcd8739ae039) (0, $2bf82c0980125b62$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $4d59907f44a2d0ad$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $2bf82c0980125b62$export$b2d02638cc34c042)(el, highlightDigit);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $2bf82c0980125b62$export$11be6f716239ac55)(el, highlightDigit);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $2bf82c0980125b62$export$207f9cb3e1099375)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $2bf82c0980125b62$export$fd4a9ec75456d3c1)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $2bf82c0980125b62$export$252d028dda8ef765)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $2bf82c0980125b62$export$ea9a904bd6e32bd3)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                return class_1;
            }((0, $a6d7e6163195660e$export$2e2bcd8739ae039)))(ecIns);
        };
        $4d59907f44a2d0ad$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$eventActionMap, function(actionType, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($4d59907f44a2d0ad$var$connectedGroups[chart.group] && chart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] !== $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING);
                        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] !== $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$var$echartsProto = $4d59907f44a2d0ad$var$ECharts.prototype;
$4d59907f44a2d0ad$var$echartsProto.on = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts("on");
$4d59907f44a2d0ad$var$echartsProto.off = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts("off");
/**
 * @deprecated
 */ // @ts-ignore
$4d59907f44a2d0ad$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $84bc7667c27ccedc$export$4a9c0b74eb885aa1)("ECharts#one is deprecated.");
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $4d59907f44a2d0ad$var$MOUSE_EVENT_NAMES = [
    "click",
    "dblclick",
    "mouseover",
    "mouseout",
    "mousemove",
    "mousedown",
    "mouseup",
    "globalout",
    "contextmenu"
];
function $4d59907f44a2d0ad$var$disposedWarning(id) {}
var $4d59907f44a2d0ad$var$actions = {};
/**
 * Map eventType to actionType
 */ var $4d59907f44a2d0ad$var$eventActionMap = {};
var $4d59907f44a2d0ad$var$dataProcessorFuncs = [];
var $4d59907f44a2d0ad$var$optionPreprocessorFuncs = [];
var $4d59907f44a2d0ad$var$visualFuncs = [];
var $4d59907f44a2d0ad$var$themeStorage = {};
var $4d59907f44a2d0ad$var$loadingEffects = {};
var $4d59907f44a2d0ad$var$instances = {};
var $4d59907f44a2d0ad$var$connectedGroups = {};
var $4d59907f44a2d0ad$var$idBase = +new Date() - 0;
var $4d59907f44a2d0ad$var$groupIdBase = +new Date() - 0;
var $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY = "_echarts_instance_";
function $4d59907f44a2d0ad$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $4d59907f44a2d0ad$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $4d59907f44a2d0ad$var$ECharts(dom, theme, opts);
    chart.id = "ec_" + $4d59907f44a2d0ad$var$idBase++;
    $4d59907f44a2d0ad$var$instances[chart.id] = chart;
    isClient && $76d619f648247e6d$export$9fec4d97f1922e0b(dom, $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY, chart.id);
    $4d59907f44a2d0ad$var$enableConnect(chart);
    (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterinit", chart);
    return chart;
}
function $4d59907f44a2d0ad$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || "g_" + $4d59907f44a2d0ad$var$groupIdBase++;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $4d59907f44a2d0ad$var$connectedGroups[groupId] = true;
    return groupId;
}
function $4d59907f44a2d0ad$export$37dfea93db2e14ed(groupId) {
    $4d59907f44a2d0ad$var$connectedGroups[groupId] = false;
}
var $4d59907f44a2d0ad$export$87cd6834112ecb52 = $4d59907f44a2d0ad$export$37dfea93db2e14ed;
function $4d59907f44a2d0ad$export$fcfbbcec2cb820d5(chart) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(chart)) chart = $4d59907f44a2d0ad$var$instances[chart];
    else if (!(chart instanceof $4d59907f44a2d0ad$var$ECharts)) // Try to treat as dom
    chart = $4d59907f44a2d0ad$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $4d59907f44a2d0ad$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $4d59907f44a2d0ad$export$33b6fbccd4f643f8(dom) {
    return $4d59907f44a2d0ad$var$instances[$76d619f648247e6d$export$735ee1799fd02602(dom, $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY)];
}
function $4d59907f44a2d0ad$export$89b4be35062c4a3f(key) {
    return $4d59907f44a2d0ad$var$instances[key];
}
function $4d59907f44a2d0ad$export$f9c59eed5de5ff80(name, theme) {
    $4d59907f44a2d0ad$var$themeStorage[name] = theme;
}
function $4d59907f44a2d0ad$export$77095792a057b768(preprocessorFunc) {
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($4d59907f44a2d0ad$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $4d59907f44a2d0ad$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $4d59907f44a2d0ad$export$d575e6557ac1729f(priority, processor) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$dataProcessorFuncs, priority, processor, $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $4d59907f44a2d0ad$export$c8c249911ee8c1ed(postInitFunc) {
    $4d59907f44a2d0ad$export$c9ec4b5faef04865("afterinit", postInitFunc);
}
function $4d59907f44a2d0ad$export$99560909c18c76bb(postUpdateFunc) {
    $4d59907f44a2d0ad$export$c9ec4b5faef04865("afterupdate", postUpdateFunc);
}
function $4d59907f44a2d0ad$export$c9ec4b5faef04865(name, cb) {
    (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).on(name, cb);
}
function $4d59907f44a2d0ad$export$408c24786cd729c6(actionInfo, eventName, action) {
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(eventName)) {
        action = eventName;
        eventName = "";
    }
    var actionType = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0];
    // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event;
    if ($4d59907f44a2d0ad$var$eventActionMap[eventName]) // Already registered.
    return;
    // Validate action type and event name.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)($4d59907f44a2d0ad$var$ACTION_REG.test(actionType) && $4d59907f44a2d0ad$var$ACTION_REG.test(eventName));
    if (!$4d59907f44a2d0ad$var$actions[actionType]) $4d59907f44a2d0ad$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $4d59907f44a2d0ad$var$eventActionMap[eventName] = actionType;
}
function $4d59907f44a2d0ad$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $4d59907f44a2d0ad$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $4d59907f44a2d0ad$export$d768f97700ca6bea(priority, layoutTask) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$visualFuncs, priority, layoutTask, $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT, "layout");
}
function $4d59907f44a2d0ad$export$5f32c1eb94c381bb(priority, visualTask) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$visualFuncs, priority, visualTask, $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART, "visual");
}
var $4d59907f44a2d0ad$var$registeredTasks = [];
function $4d59907f44a2d0ad$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(priority) || (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($4d59907f44a2d0ad$var$registeredTasks, fn) >= 0) return;
    $4d59907f44a2d0ad$var$registeredTasks.push(fn);
    var stageHandler = (0, $94ae4e8744638a8a$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $4d59907f44a2d0ad$export$e06b68a82007c015(name, loadingFx) {
    $4d59907f44a2d0ad$var$loadingEffects[name] = loadingFx;
}
function $4d59907f44a2d0ad$export$10425ea7a243b114(creator) {
    (0, $c6341dcc9d86826e$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $4d59907f44a2d0ad$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $f773aa0508c1d920$export$73333eb8a09d5f61)("registerMap");
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $4d59907f44a2d0ad$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $f773aa0508c1d920$export$73333eb8a09d5f61)("getMap");
    return getMap && getMap(mapName);
}
var $4d59907f44a2d0ad$export$f01d71dd0389d7e4 = (0, $523dedd0a2328c06$export$92c96c6d8b255b7d);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL, (0, $a617f62dd17b10f1$export$7ce4d65f9b69240));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $a617f62dd17b10f1$export$f7dcb66a065003d1));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $a617f62dd17b10f1$export$cf9758b0d6dc0aa9));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL, (0, $f8e1f1a448782588$export$144ac3beded415d9));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $f8e1f1a448782588$export$435b956f7f1071fb));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL, (0, $d82adaf1a5a5cfeb$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$77095792a057b768((0, $c4489ebdf95633b6$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$d575e6557ac1729f($4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DATASTACK, (0, $92eb0b43a1e7607a$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$e06b68a82007c015("default", (0, $f23f99c31dceac8f$export$2e2bcd8739ae039));
// Default actions
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$df035d873a9de64f),
    event: (0, $2bf82c0980125b62$export$df035d873a9de64f),
    update: (0, $2bf82c0980125b62$export$df035d873a9de64f)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea),
    event: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea),
    update: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$89616263e7d38fe9),
    event: (0, $2bf82c0980125b62$export$89616263e7d38fe9),
    update: (0, $2bf82c0980125b62$export$89616263e7d38fe9)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$7636ad95c0f68a79),
    event: (0, $2bf82c0980125b62$export$7636ad95c0f68a79),
    update: (0, $2bf82c0980125b62$export$7636ad95c0f68a79)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$1e90ed8a25542516),
    event: (0, $2bf82c0980125b62$export$1e90ed8a25542516),
    update: (0, $2bf82c0980125b62$export$1e90ed8a25542516)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
// Default theme
$4d59907f44a2d0ad$export$f9c59eed5de5ff80("light", (0, $0e5dbddd76825050$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$f9c59eed5de5ff80("dark", (0, $985c98ffd51c6ff6$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$export$73cae5e090579589 = {};









var $d657479d857c7ab3$var$extensions = [];
var $d657479d857c7ab3$var$extensionRegisters = {
    registerPreprocessor: (0, $4d59907f44a2d0ad$export$77095792a057b768),
    registerProcessor: (0, $4d59907f44a2d0ad$export$d575e6557ac1729f),
    registerPostInit: (0, $4d59907f44a2d0ad$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $4d59907f44a2d0ad$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $4d59907f44a2d0ad$export$c9ec4b5faef04865),
    registerAction: (0, $4d59907f44a2d0ad$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $4d59907f44a2d0ad$export$1dd5e025a8a37dd),
    registerLayout: (0, $4d59907f44a2d0ad$export$d768f97700ca6bea),
    registerVisual: (0, $4d59907f44a2d0ad$export$5f32c1eb94c381bb),
    registerTransform: (0, $4d59907f44a2d0ad$export$f01d71dd0389d7e4),
    registerLoading: (0, $4d59907f44a2d0ad$export$e06b68a82007c015),
    registerMap: (0, $4d59907f44a2d0ad$export$d456de060be2dba1),
    registerImpl: (0, $f773aa0508c1d920$export$9b808fd12256ddd3),
    PRIORITY: (0, $4d59907f44a2d0ad$export$bb34f3538ba26c7e),
    ComponentModel: (0, $116d65051f61bdfe$export$2e2bcd8739ae039),
    ComponentView: (0, $737c88aa0711f65a$export$2e2bcd8739ae039),
    SeriesModel: (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039),
    ChartView: (0, $0dc5061053e23cd3$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $737c88aa0711f65a$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $6eba88f9eebe6af9$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $d657479d857c7ab3$export$1f96ae73734a86cc(ext) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ext, function(singleExt) {
            $d657479d857c7ab3$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($d657479d857c7ab3$var$extensions, ext) >= 0) return;
    $d657479d857c7ab3$var$extensions.push(ext);
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($d657479d857c7ab3$var$extensionRegisters);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










function $f88637d76300101e$var$createDom(id, painter, dpr) {
    var newDom = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = "absolute";
        newDomStyle.left = "0";
        newDomStyle.top = "0";
        newDomStyle.width = width + "px";
        newDomStyle.height = height + "px";
        newDom.setAttribute("data-zr-dom-id", id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var $f88637d76300101e$var$Layer = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || (0, $4b0cedd85979c776$export$508f096bfcdaac40);
        if (typeof id === "string") dom = $f88637d76300101e$var$createDom(id, painter, dpr);
        else if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            $7a1bd9c2710fea0d$export$23a5d775868fdd2c(dom);
            dom.onselectstart = function() {
                return false;
            };
            domStyle.padding = "0";
            domStyle.margin = "0";
            domStyle.borderWidth = "0";
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function() {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function() {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext("2d");
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $f88637d76300101e$var$createDom("back-" + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext("2d");
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        for(var i = this.__startIndex; i < this.__endIndex; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
            var el = prevList[i];
            var shouldPaint = el && el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + "px";
            domStyle.height = height + "px";
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = "copy";
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== "transparent") {
                var clearColorGradientOrPattern = void 0;
                if ($7a1bd9c2710fea0d$export$fa2c283003ed971c(clearColor)) {
                    var shouldCache = clearColor.global || clearColor.__width === width && clearColor.__height === height;
                    clearColorGradientOrPattern = shouldCache && clearColor.__canvasGradient || (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                    clearColor.__width = width;
                    clearColor.__height = height;
                } else if ($7a1bd9c2710fea0d$export$a49bbf3a55dcef7b(clearColor)) {
                    clearColor.scaleX = clearColor.scaleX || dpr;
                    clearColor.scaleY = clearColor.scaleY || dpr;
                    clearColorGradientOrPattern = (0, $4f71e35e4552e3dd$export$8eb5db6b7bc27903)(ctx, clearColor, {
                        dirty: function() {
                            self.setUnpainted();
                            self.painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $f88637d76300101e$export$2e2bcd8739ae039 = $f88637d76300101e$var$Layer;







var $19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL = 1e5;
var $19d742a3d88cea2b$var$CANVAS_ZLEVEL = 314159;
var $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $19d742a3d88cea2b$var$INCREMENTAL_INC = 0.001;
function $19d742a3d88cea2b$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== "function" || typeof layer.refresh !== "function") return false;
    return true;
}
function $19d742a3d88cea2b$var$createRoot(width, height) {
    var domRoot = document.createElement("div");
    domRoot.style.cssText = [
        "position:relative",
        "width:" + width + "px",
        "height:" + height + "px",
        "padding:0",
        "margin:0",
        "border-width:0"
    ].join(";") + ";";
    return domRoot;
}
var $19d742a3d88cea2b$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = "canvas";
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = "canvas";
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === "CANVAS";
        this._opts = opts = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $4b0cedd85979c776$export$508f096bfcdaac40);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            $7a1bd9c2710fea0d$export$23a5d775868fdd2c(root);
            root.innerHTML = "";
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            this._height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            var domRoot = this._domRoot = $19d742a3d88cea2b$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[$19d742a3d88cea2b$var$CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = $19d742a3d88cea2b$var$CANVAS_ZLEVEL;
            zlevelList.push($19d742a3d88cea2b$var$CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return "canvas";
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype.refreshHover = function() {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for(var i = 0; i < len; i++){
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL);
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) ctx.restore();
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this.getLayer($19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $4f71e35e4552e3dd$export$567881adfc3eb7f3)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) this._compositeManually();
        if (needsRefreshHover) this._paintHoverList(list);
        if (!finished) {
            var self_1 = this;
            (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(function() {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        } else this.eachLayer(function(layer) {
            layer.afterBrush && layer.afterBrush();
        });
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this.getLayer($19d742a3d88cea2b$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function(k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
            }
            if (start === -1) {
                console.error("For some unknown reason. drawIndex is -1");
                start = layer.__startIndex;
            }
            var i;
            var repaint = function(repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for(i = start; i < layer.__endIndex; i++){
                    var el = list[i];
                    if (el.__inHover) needsRefreshHover = true;
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) break;
                    }
                }
                if (scope.prevElClipPaths) ctx.restore();
            };
            if (repaintRects) {
                if (repaintRects.length === 0) i = layer.__endIndex;
                else {
                    var dpr = this_1.dpr;
                    for(var r = 0; r < repaintRects.length; ++r){
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            } else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
        };
        var this_1 = this;
        for(var k = 0; k < layerList.length; k++)_loop_1(k);
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).wxa) $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        } else (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $19d742a3d88cea2b$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)("zr_" + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC]) $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, this._layerConfig[zlevel - $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) return;
        if (!$19d742a3d88cea2b$var$isLayerValid(layer)) return;
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.painter || (layer.painter = this);
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.getLayers = function() {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
            var el = list[i_1];
            if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for(i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + $19d742a3d88cea2b$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $7a1bd9c2710fea0d$export$58da9968c3170cb1("ZLevel " + zlevel + " has been used by unkown layer " + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    };
    CanvasPainter.prototype.clear = function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function(layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._layers, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($19d742a3d88cea2b$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = "none";
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            domRoot.style.display = "";
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + "px";
                domRoot.style.height = height + "px";
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = "";
        this.root = this.storage = this._domRoot = this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$19d742a3d88cea2b$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)("image", this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    return CanvasPainter;
}();
var $19d742a3d88cea2b$export$2e2bcd8739ae039 = $19d742a3d88cea2b$var$CanvasPainter;


function $e792bf2f67d76098$export$4b3e715f166fdd78(registers) {
    registers.registerPainter("canvas", (0, $19d742a3d88cea2b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c8b2ce72d2349eb5$var$mathSin = Math.sin;
var $c8b2ce72d2349eb5$var$mathCos = Math.cos;
var $c8b2ce72d2349eb5$var$PI = Math.PI;
var $c8b2ce72d2349eb5$var$PI2 = Math.PI * 2;
var $c8b2ce72d2349eb5$var$degree = 180 / $c8b2ce72d2349eb5$var$PI;
var $c8b2ce72d2349eb5$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = "";
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add("M", x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add("L", x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add("C", x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add("Q", x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $999d81abec723db8$export$4701367f5b4de464)(dThetaPositive - $c8b2ce72d2349eb5$var$PI2) || (clockwise ? dTheta >= $c8b2ce72d2349eb5$var$PI2 : -dTheta >= $c8b2ce72d2349eb5$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $c8b2ce72d2349eb5$var$PI2 : dTheta % $c8b2ce72d2349eb5$var$PI2 + $c8b2ce72d2349eb5$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $999d81abec723db8$export$4701367f5b4de464)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $c8b2ce72d2349eb5$var$PI === !!clockwise;
        var x0 = cx + rx * $c8b2ce72d2349eb5$var$mathCos(startAngle);
        var y0 = cy + ry * $c8b2ce72d2349eb5$var$mathSin(startAngle);
        if (this._start) this._add("M", x0, y0);
        var xRot = Math.round(psi * $c8b2ce72d2349eb5$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($c8b2ce72d2349eb5$var$PI2 - p);
            this._add("A", rx, ry, xRot, 1, +clockwise, cx + rx * $c8b2ce72d2349eb5$var$mathCos(startAngle + dTheta_1), cy + ry * $c8b2ce72d2349eb5$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add("A", rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $c8b2ce72d2349eb5$var$mathCos(endAngle);
            var y = cy + ry * $c8b2ce72d2349eb5$var$mathSin(endAngle);
            this._add("A", rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add("M", x, y);
        this._add("l", w, 0);
        this._add("l", 0, h);
        this._add("l", -w, 0);
        this._add("Z");
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add("Z");
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(" "));
        this._start = cmd === "Z";
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? "" : this._d.join("");
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $c8b2ce72d2349eb5$export$2e2bcd8739ae039 = $c8b2ce72d2349eb5$var$SVGPathRebuilder;







var $6f6b3090476bfa7b$var$NONE = "none";
var $6f6b3090476bfa7b$var$mathRound = Math.round;
function $6f6b3090476bfa7b$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $6f6b3090476bfa7b$var$NONE;
}
function $6f6b3090476bfa7b$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $6f6b3090476bfa7b$var$NONE;
}
var $6f6b3090476bfa7b$var$strokeProps = [
    "lineCap",
    "miterLimit",
    "lineJoin"
];
var $6f6b3090476bfa7b$var$svgStrokeProps = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($6f6b3090476bfa7b$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $6f6b3090476bfa7b$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
        updateAttr("opacity", opacity);
        return;
    }
    if ($6f6b3090476bfa7b$var$pathHasFill(style)) {
        var fill = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.fill);
        updateAttr("fill", fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr("fill-opacity", fillOpacity);
    } else updateAttr("fill", $6f6b3090476bfa7b$var$NONE);
    if ($6f6b3090476bfa7b$var$pathHasStroke(style)) {
        var stroke = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.stroke);
        updateAttr("stroke", stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr("stroke-width", strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr("paint-order", strokeFirst ? "stroke" : "fill");
        if (forceUpdate || strokeOpacity < 1) updateAttr("stroke-opacity", strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $6f6b3090476bfa7b$var$mathRound(lineDashOffset || 0);
                updateAttr("stroke-dasharray", lineDash.join(","));
                if (lineDashOffset || forceUpdate) updateAttr("stroke-dashoffset", lineDashOffset);
            }
        } else if (forceUpdate) updateAttr("stroke-dasharray", $6f6b3090476bfa7b$var$NONE);
        for(var i = 0; i < $6f6b3090476bfa7b$var$strokeProps.length; i++){
            var propName = $6f6b3090476bfa7b$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $b02ffe7acd508c08$export$deade517576e293a)[propName]) {
                var val = style[propName] || (0, $b02ffe7acd508c08$export$deade517576e293a)[propName];
                val && updateAttr($6f6b3090476bfa7b$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr("stroke", $6f6b3090476bfa7b$var$NONE);
}




var $f6ad3c9e333d7ffc$export$a690ad4c9a38f86e = "http://www.w3.org/2000/svg";
var $f6ad3c9e333d7ffc$export$b22c6da1792ecec8 = "http://www.w3.org/1999/xlink";
var $f6ad3c9e333d7ffc$export$fac09d762d15fa3b = "http://www.w3.org/2000/xmlns/";
var $f6ad3c9e333d7ffc$export$ad4c4fdecd3b4156 = "http://www.w3.org/XML/1998/namespace";
var $f6ad3c9e333d7ffc$export$d3f79611f155197c = "ecmeta_";
function $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($f6ad3c9e333d7ffc$export$a690ad4c9a38f86e, name);
}
function $f6ad3c9e333d7ffc$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $f6ad3c9e333d7ffc$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += '="' + val + '"';
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(" ") + ">";
}
function $f6ad3c9e333d7ffc$var$createElementClose(name) {
    return "</" + name + ">";
}
function $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? "\n" : "";
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $f6ad3c9e333d7ffc$var$createElementOpen(tag, attrs) + (tag !== "style" ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(text) : text || "") + (children ? "" + S + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : "") + $f6ad3c9e333d7ffc$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $f6ad3c9e333d7ffc$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? "\n" : "";
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === "d") val = 'path("' + val + '")';
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return "";
    return [
        "<![CDATA[",
        selectors,
        animations,
        "]]>"
    ].join(S);
}
function $f6ad3c9e333d7ffc$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $f6ad3c9e333d7ffc$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $f6ad3c9e333d7ffc$export$bf5c4cf060303d58("svg", "root", {
        "width": width,
        "height": height,
        "xmlns": $f6ad3c9e333d7ffc$export$a690ad4c9a38f86e,
        "xmlns:xlink": $f6ad3c9e333d7ffc$export$b22c6da1792ecec8,
        "version": "1.1",
        "baseProfile": "full",
        "viewBox": useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}












var $849cb89161be4359$var$cssClassIdx = 0;
function $849cb89161be4359$export$9c80c36b7367fb56() {
    return $849cb89161be4359$var$cssClassIdx++;
}


var $a85a6a2869494a29$export$54ee1847795bcf37 = {
    cubicIn: "0.32,0,0.67,0",
    cubicOut: "0.33,1,0.68,1",
    cubicInOut: "0.65,0,0.35,1",
    quadraticIn: "0.11,0,0.5,0",
    quadraticOut: "0.5,1,0.89,1",
    quadraticInOut: "0.45,0,0.55,1",
    quarticIn: "0.5,0,0.75,0",
    quarticOut: "0.25,1,0.5,1",
    quarticInOut: "0.76,0,0.24,1",
    quinticIn: "0.64,0,0.78,0",
    quinticOut: "0.22,1,0.36,1",
    quinticInOut: "0.83,0,0.17,1",
    sinusoidalIn: "0.12,0,0.39,0",
    sinusoidalOut: "0.61,1,0.88,1",
    sinusoidalInOut: "0.37,0,0.63,1",
    exponentialIn: "0.7,0,0.84,0",
    exponentialOut: "0.16,1,0.3,1",
    exponentialInOut: "0.87,0,0.13,1",
    circularIn: "0.55,0,1,0.45",
    circularOut: "0,0.55,0.45,1",
    circularInOut: "0.85,0,0.15,1"
};
var $a85a6a2869494a29$var$transformOriginKey = "transform-origin";
function $a85a6a2869494a29$var$buildPathString(el, kfShape, path) {
    var shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $c8b2ce72d2349eb5$export$2e2bcd8739ae039)();
    svgPathBuilder.reset((0, $999d81abec723db8$export$93fa1ae8a509371c)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $a85a6a2869494a29$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$a85a6a2869494a29$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $a85a6a2869494a29$export$f0dede2064ee89d7 = {
    fill: "fill",
    opacity: "opacity",
    lineWidth: "stroke-width",
    lineDashOffset: "stroke-dashoffset"
};
function $a85a6a2869494a29$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + "-ani-" + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $a85a6a2869494a29$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(paths, function(path) {
        var subScope = (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(scope.zrId);
        subScope.animation = true;
        $a85a6a2869494a29$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ""
            };
            composedAnim[percent].d += kf.d || "";
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $a85a6a2869494a29$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $a85a6a2869494a29$var$getEasingFunc(easing) {
    return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(easing) ? $a85a6a2869494a29$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $a85a6a2869494a29$export$54ee1847795bcf37[easing] + ")" : (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing) ? easing : "" : "";
}
function $a85a6a2869494a29$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $e152f3dbf8fba6e2$export$2e2bcd8739ae039)) {
        var animationCfg = $a85a6a2869494a29$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + "s"
        ];
        var easing = $a85a6a2869494a29$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push("linear");
        if (delay) cfgArr.push(delay / 1000 + "s");
        if (animator.getLoop()) cfgArr.push("infinite");
        var cfg = cfgArr.join(" ");
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = "animation-timing-function";
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + "%";
                        var kfEasing = $a85a6a2869494a29$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rawValue) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === "shape") saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $becf2d727f9cf450$export$234b1c16dfa57d6a)(transform, el);
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(transform, transformKfs[percent]);
            var str = (0, $999d81abec723db8$export$3fe07c0888ff6164)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $a85a6a2869494a29$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $a85a6a2869494a29$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === "style") saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $a85a6a2869494a29$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$a85a6a2869494a29$var$transformOriginKey] !== finalKfs[p1][$a85a6a2869494a29$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$a85a6a2869494a29$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$a85a6a2869494a29$var$transformOriginKey]) delete finalKfs[percent][$a85a6a2869494a29$var$transformOriginKey];
            attrs[$a85a6a2869494a29$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(percents, function(percent) {
            return (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $a85a6a2869494a29$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + "-cls-" + (0, $849cb89161be4359$export$9c80c36b7367fb56)();
        scope.cssNodes["." + className] = {
            animation: cssAnimations.join(",")
        };
        attrs["class"] = className;
    }
}






function $05e38a5f94c3c427$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                "pointer-events": "none"
            };
            $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf("select") >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: "pointer"
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style["stroke-width"] = lineWidth;
            $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + "-cls-" + (0, $849cb89161be4359$export$9c80c36b7367fb56)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes["." + className + (withHover ? ":hover" : "")] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + " " + className : className;
}



var $5a7f1b53a6723dcf$var$round = Math.round;
function $5a7f1b53a6723dcf$var$isImageLike(val) {
    return val && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val.src);
}
function $5a7f1b53a6723dcf$var$isCanvasLike(val) {
    return val && (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(val.toDataURL);
}
function $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $6f6b3090476bfa7b$export$2e2bcd8739ae039)(function(key, val) {
        var isFillStroke = key === "fill" || key === "stroke";
        if (isFillStroke && (0, $999d81abec723db8$export$545e02bbd5f8fe95)(val)) $5a7f1b53a6723dcf$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $999d81abec723db8$export$41a28f5a000a9d0f)(val)) $5a7f1b53a6723dcf$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else if (isFillStroke && val === "none") attrs[key] = "transparent";
        else attrs[key] = val;
    }, style, el, false);
    $5a7f1b53a6723dcf$var$setShadow(el, attrs, scope);
}
function $5a7f1b53a6723dcf$var$setMetaData(attrs, el) {
    var metaData = (0, $6eba88f9eebe6af9$export$dd7015a5412ca583)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $f6ad3c9e333d7ffc$export$d3f79611f155197c) + key).toLowerCase()] = val + "");
        });
        if (el.isSilent()) attrs[(0, $f6ad3c9e333d7ffc$export$d3f79611f155197c) + "silent"] = "true";
    }
}
function $5a7f1b53a6723dcf$var$noRotateScale(m) {
    return (0, $999d81abec723db8$export$4701367f5b4de464)(m[0] - 1) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[1]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[2]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[3] - 1);
}
function $5a7f1b53a6723dcf$var$noTranslate(m) {
    return (0, $999d81abec723db8$export$4701367f5b4de464)(m[4]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[5]);
}
function $5a7f1b53a6723dcf$var$setTransform(attrs, m, compress) {
    if (m && !($5a7f1b53a6723dcf$var$noTranslate(m) && $5a7f1b53a6723dcf$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $5a7f1b53a6723dcf$var$noRotateScale(m) ? "translate(" + $5a7f1b53a6723dcf$var$round(m[4] * mul) / mul + " " + $5a7f1b53a6723dcf$var$round(m[5] * mul) / mul + ")" : (0, $999d81abec723db8$export$f29a4456cf56ff21)(m);
    }
}
function $5a7f1b53a6723dcf$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($5a7f1b53a6723dcf$var$round(points[i][0] * mul) / mul);
        strArr.push($5a7f1b53a6723dcf$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(" ");
}
function $5a7f1b53a6723dcf$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $5a7f1b53a6723dcf$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(desc, function(item) {
        return typeof item === "string" ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $5a7f1b53a6723dcf$var$round(val * mul) / mul;
        }
    };
}
var $5a7f1b53a6723dcf$var$builtinShapesDef = {
    circle: [
        $5a7f1b53a6723dcf$var$createAttrsConvert([
            "cx",
            "cy",
            "r"
        ])
    ],
    polyline: [
        $5a7f1b53a6723dcf$var$convertPolyShape,
        $5a7f1b53a6723dcf$var$validatePolyShape
    ],
    polygon: [
        $5a7f1b53a6723dcf$var$convertPolyShape,
        $5a7f1b53a6723dcf$var$validatePolyShape
    ]
};
function $5a7f1b53a6723dcf$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === "shape") return true;
    }
    return false;
}
function $5a7f1b53a6723dcf$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $5a7f1b53a6723dcf$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = "path";
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $999d81abec723db8$export$93fa1ae8a509371c)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $5a7f1b53a6723dcf$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $c8b2ce72d2349eb5$export$2e2bcd8739ae039)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    scope.emphasis && (0, $05e38a5f94c3c427$export$b4c8f742d3cb22ba)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(svgElType, el.id + "", attrs);
}
function $5a7f1b53a6723dcf$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(image)) {
        if ($5a7f1b53a6723dcf$var$isImageLike(image)) image = image.src;
        else if ($5a7f1b53a6723dcf$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("image", el.id + "", attrs);
}
function $5a7f1b53a6723dcf$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += "");
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var x = style.x || 0;
    var y = (0, $999d81abec723db8$export$bf7d6802d2badd9)(style.y || 0, (0, $6c308355c7107803$export$56204a27a2958a55)(font), style.textBaseline);
    var textAlign = (0, $999d81abec723db8$export$4062150f0600d971)[style.textAlign] || style.textAlign;
    var attrs = {
        "dominant-baseline": "central",
        "text-anchor": textAlign
    };
    if ((0, $fe885cc21795562b$export$4685c95d5118e76a)(style)) {
        var separatedFontStr = "";
        var fontStyle = style.fontStyle;
        var fontSize = (0, $fe885cc21795562b$export$51b066d9cfc2578e)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $c6341dcc9d86826e$export$2653e0d5dd45b294);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== "normal") separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== "normal") separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs["xml:space"] = "preserve";
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("text", el.id + "", attrs, undefined, text);
}
function $5a7f1b53a6723dcf$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$d506f5385e62a84a(el, scope);
}
function $5a7f1b53a6723dcf$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $999d81abec723db8$export$c62076b3a966c94b)(style)) {
        var shadowKey = (0, $999d81abec723db8$export$9e4c657be710688a)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + " " + stdDy;
            shadowId = scope.zrId + "-s" + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("filter", shadowId, {
                "id": shadowId,
                "x": "-100%",
                "y": "-100%",
                "width": "300%",
                "height": "300%"
            }, [
                (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("feDropShadow", "", {
                    "dx": offsetX / scaleX,
                    "dy": offsetY / scaleY,
                    "stdDeviation": stdDeviation,
                    "flood-color": color,
                    "flood-opacity": opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $999d81abec723db8$export$bb094196179998a5)(shadowId);
    }
}
function $5a7f1b53a6723dcf$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        "gradientUnits": val.global ? "userSpaceOnUse" : "objectBoundingBox"
    };
    if ((0, $999d81abec723db8$export$7d961bca9d3b47d0)(val)) {
        gradientTag = "linearGradient";
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $999d81abec723db8$export$2a9cca6692a0ce3a)(val)) {
        gradientTag = "radialGradient";
        gradientAttrs.cx = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.x, 0.5);
        gradientAttrs.cy = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.y, 0.5);
        gradientAttrs.r = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $999d81abec723db8$export$52bfc6d3e2ff0fc2)(colors[i].offset) * 100 + "%";
        var stopColor = colors[i].color;
        var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            "offset": offset
        };
        stopsAttrs["stop-color"] = color;
        if (opacity < 1) stopsAttrs["stop-opacity"] = opacity;
        colorStops.push((0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("stop", i + "", stopsAttrs));
    }
    var gradientVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(gradientTag, "", gradientAttrs, colorStops);
    var gradientKey = (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + "-g" + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $999d81abec723db8$export$bb094196179998a5)(gradientId);
}
function $5a7f1b53a6723dcf$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === "no-repeat";
    var repeatX = repeat === "repeat-x";
    var repeatY = repeat === "repeat-y";
    var child;
    if ((0, $999d81abec723db8$export$2ade673ac4f85dfe)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(patternImage)) imageSrc = patternImage;
        else if ($5a7f1b53a6723dcf$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($5a7f1b53a6723dcf$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === "undefined") {
            var errMsg = "Image width/height must been given explictly in svg-ssr renderer.";
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(imageWidth_1, errMsg);
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === "pattern") {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute("width", width);
                        svgEl.setAttribute("height", height);
                    }
                }
            };
            var createdImage = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("image", "img", {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = "userSpaceOnUse";
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $999d81abec723db8$export$3fe07c0888ff6164)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("pattern", "", patternAttrs, [
        child
    ]);
    var patternKey = (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + "-p" + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("pattern", patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $999d81abec723db8$export$bb094196179998a5)(patternId);
}
function $5a7f1b53a6723dcf$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + "-c" + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("clipPath", clipPathId, clipPathAttrs, [
            $5a7f1b53a6723dcf$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs["clip-path"] = (0, $999d81abec723db8$export$bb094196179998a5)(clipPathId);
}







function $a4f5b07c584c2741$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $a4f5b07c584c2741$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $a4f5b07c584c2741$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $a4f5b07c584c2741$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $a4f5b07c584c2741$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $a4f5b07c584c2741$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $a4f5b07c584c2741$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $a4f5b07c584c2741$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $a4f5b07c584c2741$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $a4f5b07c584c2741$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $a4f5b07c584c2741$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}


var $57ac702d7860318b$var$colonChar = 58;
var $57ac702d7860318b$var$xChar = 120;
var $57ac702d7860318b$var$emptyNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("", "");
function $57ac702d7860318b$var$isUndef(s) {
    return s === undefined;
}
function $57ac702d7860318b$var$isDef(s) {
    return s !== undefined;
}
function $57ac702d7860318b$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $57ac702d7860318b$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $57ac702d7860318b$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($57ac702d7860318b$var$isDef(tag)) {
        var elm = vnode.elm = (0, $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d)(tag);
        $57ac702d7860318b$export$277dcc6f06048f24($57ac702d7860318b$var$emptyNode, vnode);
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(elm, $57ac702d7860318b$var$createElm(ch));
        }
        else if ($57ac702d7860318b$var$isDef(vnode.text) && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(vnode.text)) $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(elm, $a4f5b07c584c2741$export$b2ce9ad90858ed7a(vnode.text));
    } else vnode.elm = $a4f5b07c584c2741$export$b2ce9ad90858ed7a(vnode.text);
    return vnode.elm;
}
function $57ac702d7860318b$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(ch), before);
    }
}
function $57ac702d7860318b$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($57ac702d7860318b$var$isDef(ch.tag)) {
                var parent_1 = $a4f5b07c584c2741$export$b54be7ce267a037b(ch.elm);
                $a4f5b07c584c2741$export$7ae609f7af59e4f7(parent_1, ch.elm);
            } else $a4f5b07c584c2741$export$7ae609f7af59e4f7(parentElm, ch.elm);
        }
    }
}
function $57ac702d7860318b$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, "");
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === "style") elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $57ac702d7860318b$var$xChar) elm.setAttribute(key, cur);
                else if (key === "xmlns:xlink" || key === "xmlns") elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$fac09d762d15fa3b), key, cur);
                else if (key.charCodeAt(3) === $57ac702d7860318b$var$colonChar) elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$ad4c4fdecd3b4156), key, cur);
                else if (key.charCodeAt(5) === $57ac702d7860318b$var$colonChar) elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$b22c6da1792ecec8), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $57ac702d7860318b$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($57ac702d7860318b$var$sameVnode(oldStartVnode, newStartVnode)) {
            $57ac702d7860318b$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldEndVnode, newEndVnode)) {
            $57ac702d7860318b$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldStartVnode, newEndVnode)) {
            $57ac702d7860318b$var$patchVnode(oldStartVnode, newEndVnode);
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, oldStartVnode.elm, $a4f5b07c584c2741$export$335219007e689d29(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldEndVnode, newStartVnode)) {
            $57ac702d7860318b$var$patchVnode(oldEndVnode, newStartVnode);
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($57ac702d7860318b$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $57ac702d7860318b$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($57ac702d7860318b$var$isUndef(idxInOld)) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $57ac702d7860318b$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $57ac702d7860318b$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $57ac702d7860318b$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $57ac702d7860318b$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $57ac702d7860318b$export$277dcc6f06048f24(oldVnode, vnode);
    if ($57ac702d7860318b$var$isUndef(vnode.text)) {
        if ($57ac702d7860318b$var$isDef(oldCh) && $57ac702d7860318b$var$isDef(ch)) {
            if (oldCh !== ch) $57ac702d7860318b$var$updateChildren(elm, oldCh, ch);
        } else if ($57ac702d7860318b$var$isDef(ch)) {
            if ($57ac702d7860318b$var$isDef(oldVnode.text)) $a4f5b07c584c2741$export$94b0296cab6203e(elm, "");
            $57ac702d7860318b$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($57ac702d7860318b$var$isDef(oldCh)) $57ac702d7860318b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($57ac702d7860318b$var$isDef(oldVnode.text)) $a4f5b07c584c2741$export$94b0296cab6203e(elm, "");
    } else if (oldVnode.text !== vnode.text) {
        if ($57ac702d7860318b$var$isDef(oldCh)) $57ac702d7860318b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $a4f5b07c584c2741$export$94b0296cab6203e(elm, vnode.text);
    }
}
function $57ac702d7860318b$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($57ac702d7860318b$var$sameVnode(oldVnode, vnode)) $57ac702d7860318b$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $a4f5b07c584c2741$export$b54be7ce267a037b(elm);
        $57ac702d7860318b$var$createElm(vnode);
        if (parent_2 !== null) {
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parent_2, vnode.elm, $a4f5b07c584c2741$export$335219007e689d29(elm));
            $57ac702d7860318b$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}



var $c7b90ea532fd792a$var$svgId = 0;
var $c7b90ea532fd792a$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = "svg";
        this.refreshHover = $c7b90ea532fd792a$var$createMethodNotSupport("refreshHover");
        this.configLayer = $c7b90ea532fd792a$var$createMethodNotSupport("configLayer");
        this.storage = storage;
        this._opts = opts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, opts);
        this.root = root;
        this._id = "zr" + $c7b90ea532fd792a$var$svgId++;
        this._oldVNode = (0, $f6ad3c9e333d7ffc$export$5529a6aad332ee75)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement("div");
            viewport.style.cssText = "position:relative;overflow:hidden";
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d)("svg");
            (0, $57ac702d7860318b$export$277dcc6f06048f24)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = "position:absolute;left:0;top:0;user-select:none";
            (0, $57ac702d7860318b$export$2e2bcd8739ae039)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $5a7f1b53a6723dcf$export$da5d6544e8c27bc1)(el, (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        var children = [];
        var bgVNode = this._bgVNode = $c7b90ea532fd792a$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("g", "main", {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("defs", "defs", {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $f6ad3c9e333d7ffc$export$e2b4f3597c7a7dcb)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("style", "stl", {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $f6ad3c9e333d7ffc$export$5529a6aad332ee75)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(this.renderToVNode({
            animation: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.cssAnimation, true),
            emphasis: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $5a7f1b53a6723dcf$export$8f1d80b445d4fc)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("g", "clip-g-" + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $5a7f1b53a6723dcf$export$da5d6544e8c27bc1)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = "none";
            width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            viewport.style.display = "";
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + "px";
                viewportStyle.height = height + "px";
            }
            if (!(0, $999d81abec723db8$export$41a28f5a000a9d0f)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute("width", width);
                    svgDom.setAttribute("height", height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute("width", width);
                    bgEl.setAttribute("height", height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = "";
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = "data:image/svg+xml;";
        if (base64) {
            str = (0, $999d81abec723db8$export$8fb536984ec8b4d7)(str);
            return str && prefix + "base64," + str;
        }
        return prefix + "charset=UTF-8," + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $c7b90ea532fd792a$var$createMethodNotSupport(method) {
    return function() {};
}
function $c7b90ea532fd792a$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== "none") {
        bgVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("rect", "bg", {
            width: width,
            height: height,
            x: "0",
            y: "0"
        });
        if ((0, $999d81abec723db8$export$545e02bbd5f8fe95)(backgroundColor)) (0, $5a7f1b53a6723dcf$export$afaa8352c6a43a44)({
            fill: backgroundColor
        }, bgVNode.attrs, "fill", scope);
        else if ((0, $999d81abec723db8$export$41a28f5a000a9d0f)(backgroundColor)) (0, $5a7f1b53a6723dcf$export$faed90dbedc3b6d5)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $7a1bd9c2710fea0d$export$8793edee2d425525),
            getBoundingRect: function() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, "fill", scope);
        else {
            var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs["fill-opacity"] = opacity);
        }
    }
    return bgVNode;
}
var $c7b90ea532fd792a$export$2e2bcd8739ae039 = $c7b90ea532fd792a$var$SVGPainter;


function $8d8c6eb926bbdd0e$export$4b3e715f166fdd78(registers) {
    registers.registerPainter("svg", (0, $c7b90ea532fd792a$export$2e2bcd8739ae039));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $306d1c87baff8a10$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $306d1c87baff8a10$var$defaultKeyGetter(item) {
    return item;
}
var $306d1c87baff8a10$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $306d1c87baff8a10$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $306d1c87baff8a10$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === "multiple";
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? "_executeMultiple" : "_executeOneToOne"]();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, "_oldKeyGetter");
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter");
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, "_oldKeyGetter");
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter");
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = "_ec_" + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $306d1c87baff8a10$export$2e2bcd8739ae039 = $306d1c87baff8a10$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $18085de91ae59d03$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $18085de91ae59d03$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $18085de91ae59d03$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($18085de91ae59d03$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $18085de91ae59d03$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $cab29724515ce2b8$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $18085de91ae59d03$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $18085de91ae59d03$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $18085de91ae59d03$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $18085de91ae59d03$export$af1622903e71278e(axisType) {
    return axisType === "category" ? "ordinal" : axisType === "time" ? "time" : "float";
}
function $18085de91ae59d03$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === "ordinal" || dimType === "time");
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5e233867ea3713e7$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $7a1bd9c2710fea0d$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $5e233867ea3713e7$export$2e2bcd8739ae039 = $5e233867ea3713e7$var$SeriesDimensionDefine;







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $85b723b311a86ffc$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $85b723b311a86ffc$var$dimTypeShort = {
    float: "f",
    int: "i",
    ordinal: "o",
    number: "n",
    time: "t"
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $85b723b311a86ffc$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $85b723b311a86ffc$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $99e22f5c2aa5094b$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$85b723b311a86ffc$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = "";
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, "`1").replace(/\$/g, "`2") : property;
            dimHash += "$";
            dimHash += $85b723b311a86ffc$var$dimTypeShort[type] || "f";
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += "$";
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join("$$");
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $85b723b311a86ffc$export$fafbc856132a3a0e(schema) {
    return schema instanceof $85b723b311a86ffc$export$a1ef064685775f3e;
}
function $85b723b311a86ffc$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $85b723b311a86ffc$export$be39ae17310c33f7(source) {
    var innerSource = $85b723b311a86ffc$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $85b723b311a86ffc$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $85b723b311a86ffc$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


var $0ab0556b819346fd$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $0ab0556b819346fd$var$map = $7a1bd9c2710fea0d$export$871de8747c9eaa88;
var $0ab0556b819346fd$var$CtorInt32Array = typeof Int32Array === "undefined" ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $0ab0556b819346fd$var$ID_PREFIX = "e\x00\x00";
var $0ab0556b819346fd$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $0ab0556b819346fd$var$TRANSFERABLE_PROPERTIES = [
    "hasItemOption",
    "_nameList",
    "_idList",
    "_invertedIndicesMap",
    "_dimSummary",
    "userOutput",
    "_rawData",
    "_dimValueGetter",
    "_nameDimIdx",
    "_idDimIdx",
    "_nameRepeatCount"
];
var $0ab0556b819346fd$var$CLONE_PROPERTIES = [
    "_approximateExtent"
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $0ab0556b819346fd$var$prepareInvertedIndex;
var $0ab0556b819346fd$var$getId;
var $0ab0556b819346fd$var$getIdNameFromStore;
var $0ab0556b819346fd$var$normalizeDimensions;
var $0ab0556b819346fd$var$transferProperties;
var $0ab0556b819346fd$var$cloneListForMapAndSample;
var $0ab0556b819346fd$var$makeIdFromName;
var $0ab0556b819346fd$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = "list";
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            "cloneShallow",
            "downSample",
            "lttbDownSample",
            "map"
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            "filterSelf",
            "selectRange"
        ];
        this.DOWNSAMPLE_METHODS = [
            "downSample",
            "lttbDownSample"
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $85b723b311a86ffc$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            "x",
            "y"
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $7a1bd9c2710fea0d$export$844ec244b1367d54(dimInfoInput) ? new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $5e233867ea3713e7$export$2e2bcd8739ae039)) ? new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || "float";
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (otherDims.itemName === 0) this._nameDimIdx = i;
            if (otherDims.itemId === 0) this._idDimIdx = i;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $370e5aa482d8420b$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $99e22f5c2aa5094b$export$22b808bc02a60488)(data) || $7a1bd9c2710fea0d$export$1e2f57719e155213(data) ? new (0, $8ffb0d67e9446edb$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $370e5aa482d8420b$export$2e2bcd8739ae039)();
            var dimensionInfos = $0ab0556b819346fd$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $18085de91ae59d03$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $0ab0556b819346fd$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $cab29724515ce2b8$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $76d619f648247e6d$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$0ab0556b819346fd$var$makeIdFromName(this, idx);
        $0ab0556b819346fd$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $0ab0556b819346fd$var$isObject(key) ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $0ab0556b819346fd$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = "";
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $0ab0556b819346fd$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $7a1bd9c2710fea0d$export$43bee75e5e14138e(dimensions) ? store.getValues($0ab0556b819346fd$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $0ab0556b819346fd$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    /**
   * Retrieve the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        "use strict";
        var _this = this;
        var innerRange = {};
        var dims = $7a1bd9c2710fea0d$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        "use strict";
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $6818646a97528290$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $0ab0556b819346fd$var$getId(otherList, idx);
        }, function(idx) {
            return $0ab0556b819346fd$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($0ab0556b819346fd$var$isObject(kvObj)) $7a1bd9c2710fea0d$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($0ab0556b819346fd$var$isObject(val)) val = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($0ab0556b819346fd$var$isObject(key)) $7a1bd9c2710fea0d$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $0ab0556b819346fd$var$isObject(key) ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $0ab0556b819346fd$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $0ab0556b819346fd$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$7a1bd9c2710fea0d$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($7a1bd9c2710fea0d$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $0ab0556b819346fd$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $0ab0556b819346fd$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $0ab0556b819346fd$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $0ab0556b819346fd$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $0ab0556b819346fd$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $0ab0556b819346fd$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $0ab0556b819346fd$var$ID_PREFIX + rawIndex;
            return id;
        };
        $0ab0556b819346fd$var$normalizeDimensions = function(dimensions) {
            if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $0ab0556b819346fd$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $0ab0556b819346fd$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $0ab0556b819346fd$var$transferProperties(list, original);
            return list;
        };
        $0ab0556b819346fd$var$transferProperties = function(target, source) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ab0556b819346fd$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ab0556b819346fd$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $0ab0556b819346fd$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $0ab0556b819346fd$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $0ab0556b819346fd$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += "__ec__" + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $0ab0556b819346fd$export$2e2bcd8739ae039 = $0ab0556b819346fd$var$SeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $a27631012b7b377c$export$8066c1b52b2e9504(source, opt) {
    return $a27631012b7b377c$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $a27631012b7b377c$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $99e22f5c2aa5094b$export$22b808bc02a60488)(source)) source = (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $a27631012b7b377c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $85b723b311a86ffc$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $85b723b311a86ffc$export$be39ae17310c33f7)(source) : (0, $85b723b311a86ffc$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $370e5aa482d8420b$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $76d619f648247e6d$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $76d619f648247e6d$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $cab29724515ce2b8$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || "value";
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $a27631012b7b377c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $7dc6cdfd7450ef29$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $7dc6cdfd7450ef29$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = "ordinal";
    }
    else {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $a27631012b7b377c$var$removeDuplication(resultList);
    return new (0, $85b723b311a86ffc$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $a27631012b7b377c$var$removeDuplication(result) {
    var duplicationMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $a27631012b7b377c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $a27631012b7b377c$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $a97e3a3e4c0c9c28$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $a97e3a3e4c0c9c28$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var result = new $a97e3a3e4c0c9c28$var$CoordSysInfo(coordSysName);
    var fetch = $a97e3a3e4c0c9c28$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $a97e3a3e4c0c9c28$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents("xAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents("yAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "x",
            "y"
        ];
        axisMap.set("x", xAxisModel);
        axisMap.set("y", yAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(xAxisModel)) {
            categoryAxisMap.set("x", xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($a97e3a3e4c0c9c28$var$isCategory(yAxisModel)) {
            categoryAxisMap.set("y", yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "single"
        ];
        axisMap.set("single", singleAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set("single", singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
        var angleAxisModel = polarModel.findAxisModel("angleAxis");
        result.coordSysDims = [
            "radius",
            "angle"
        ];
        axisMap.set("radius", radiusAxisModel);
        axisMap.set("angle", angleAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set("radius", radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($a97e3a3e4c0c9c28$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set("angle", angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            "lng",
            "lat"
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($a97e3a3e4c0c9c28$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $a97e3a3e4c0c9c28$var$isCategory(axisModel) {
    return axisModel.get("type") === "category";
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $efdd976e4917927c$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($efdd976e4917927c$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get("stack"));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== "ordinal" && dimensionInfo.type !== "time" && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
    // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = "__\x00ecstackresult_" + seriesModel.id;
        stackedOverDimension = "__\x00ecstackedover_" + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $efdd976e4917927c$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $85b723b311a86ffc$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $efdd976e4917927c$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo("stackedDimension");
}
function $efdd976e4917927c$export$909db2be4938fbdf(data, targetDim) {
    return $efdd976e4917927c$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo("stackResultDimension") : targetDim;
}




function $8afdec5f59c90781$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var registeredCoordSys = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get("type");
            dimInfo.type = (0, $18085de91ae59d03$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        "x",
        "y"
    ];
    return coordSysDimDefs;
}
function $8afdec5f59c90781$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $8afdec5f59c90781$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $a97e3a3e4c0c9c28$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $8afdec5f59c90781$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $8afdec5f59c90781$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $efdd976e4917927c$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $8afdec5f59c90781$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $8afdec5f59c90781$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var sampleItem = $8afdec5f59c90781$var$firstDataNotNull(source.data || []);
        return !$7a1bd9c2710fea0d$export$43bee75e5e14138e((0, $76d619f648247e6d$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $8afdec5f59c90781$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $8afdec5f59c90781$export$2e2bcd8739ae039 = $8afdec5f59c90781$var$createSeriesData;





var $04f9db15b0fa1cf8$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        var line = (0, $5370466dadc978d7$export$af050e04da3a02e8)("line", 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual("symbol");
        var visualRotate = this.getData().getVisual("symbolRotate");
        var symbolType = visualType === "none" ? "circle" : visualType;
        // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === "inherit" ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf("empty") > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = "#fff";
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = "series.line";
    LineSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    LineSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 3,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        clip: true,
        label: {
            position: "top"
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: "solid"
        },
        emphasis: {
            scale: true
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: "emptyCircle",
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: "auto",
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: "none",
        animationEasing: "linear",
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: "clone"
        },
        triggerLineEvent: false
    };
    return LineSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $04f9db15b0fa1cf8$export$2e2bcd8739ae039 = $04f9db15b0fa1cf8$var$LineSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b2475f850d3c0bc2$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll("defaultedLabel");
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + "" : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(" ");
    }
}
function $b2475f850d3c0bc2$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll("defaultedLabel");
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + "";
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(" ");
}






var $b1d9c3e17ccace80$var$Symbol = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
        // Remove paths created before
        this.removeAll();
        // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: 100,
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        });
        // Rewrite drift method
        symbolPath.drift = $b1d9c3e17ccace80$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable, hasCursorOption) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = !hasCursorOption && draggable ? "move" : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, "symbol") || "circle";
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, "symbolKeepAspect");
            this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $8b353638fbedfefa$export$c8dce3c08436e91e(symbolPath, target, seriesModel, idx);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $8b353638fbedfefa$export$a121566aadcfe021(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop leave transition manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation("leave");
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var emphasisDisabled;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
            emphasisDisabled = seriesScope.emphasisDisabled;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisItemStyle = emphasisModel.getModel("itemStyle").getItemStyle();
            selectItemStyle = itemModel.getModel([
                "select",
                "itemStyle"
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                "blur",
                "itemStyle"
            ]).getItemStyle();
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
            emphasisDisabled = emphasisModel.get("disabled");
            labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
            hoverScale = emphasisModel.getShallow("scale");
            cursorStyle = itemModel.getShallow("cursor");
        }
        var symbolRotate = data.getItemVisual(idx, "symbolRotate");
        symbolPath.attr("rotation", (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(data.getItemVisual(idx, "symbolOffset"), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr("cursor", cursorStyle);
        var symbolStyle = data.getItemVisual(idx, "style");
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
            // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, "liftZ");
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        });
        // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState("emphasis");
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState("select").style = selectItemStyle;
        symbolPath.ensureState("blur").style = blurItemStyle;
        // null / undefined / true means to use default strategy.
        // 0 / false / negative number / NaN / Infinity means no scale.
        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1;
        // always set scale to allow resetting
        emphasisState.scaleX = this._sizeX * scaleRatio;
        emphasisState.scaleY = this._sizeY * scaleRatio;
        this.setSymbolScale(1);
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, seriesModel, opt) {
        var symbolPath = this.childAt(0);
        var dataIndex = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(this).dataIndex;
        var animationOpt = opt && opt.animation;
        // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true;
        // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $8b353638fbedfefa$export$f883456a56996078(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $8b353638fbedfefa$export$f883456a56996078(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(data.getItemVisual(idx, "symbolSize"));
    };
    return Symbol;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
function $b1d9c3e17ccace80$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $b1d9c3e17ccace80$export$2e2bcd8739ae039 = $b1d9c3e17ccace80$var$Symbol;




function $fedf62268297fcbb$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, "symbol") !== "none";
}
function $fedf62268297fcbb$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $fedf62268297fcbb$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel("emphasis");
    return {
        emphasisItemStyle: emphasisModel.getModel("itemStyle").getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            "blur",
            "itemStyle"
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            "select",
            "itemStyle"
        ]).getItemStyle(),
        focus: emphasisModel.get("focus"),
        blurScope: emphasisModel.get("blurScope"),
        emphasisDisabled: emphasisModel.get("disabled"),
        hoverScale: emphasisModel.get("scale"),
        labelStatesModels: (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel),
        cursorStyle: seriesModel.get("cursor")
    };
}
var $fedf62268297fcbb$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._SymbolCtor = SymbolCtor || (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        // Remove progressive els.
        this._progressiveEls = null;
        opt = $fedf62268297fcbb$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $fedf62268297fcbb$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        };
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($fedf62268297fcbb$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$fedf62268297fcbb$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, "symbol") || "circle";
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $8b353638fbedfefa$export$c8dce3c08436e91e(symbolEl, target, seriesModel);
            }
            // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            }, seriesModel);
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $fedf62268297fcbb$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        // Clear
        this._progressiveEls = [];
        opt = $fedf62268297fcbb$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($fedf62268297fcbb$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    SymbolDraw.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data;
        // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            }, data.hostModel);
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $fedf62268297fcbb$export$2e2bcd8739ae039 = $fedf62268297fcbb$var$SymbolDraw;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $af63fd8cd32fb271$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $af63fd8cd32fb271$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
    var dims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo("stackResultDimension");
    if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo("stackedOverDimension")
    };
}
function $af63fd8cd32fb271$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === "start") valueStart = extent[0];
    else if (valueOrigin === "end") valueStart = extent[1];
    else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(valueOrigin) && !isNaN(valueOrigin)) valueStart = valueOrigin;
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
    // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $af63fd8cd32fb271$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo("stackedOverDimension"), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/* global Float32Array */ var $5cd50afac93e9148$var$supportFloat32Array = typeof Float32Array !== "undefined";
var $5cd50afac93e9148$var$Float32ArrayCtor = !$5cd50afac93e9148$var$supportFloat32Array ? Array : Float32Array;
function $5cd50afac93e9148$export$21d2298f3f56bbaf(arg) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(arg)) // Return self directly if don't support TypedArray.
    return $5cd50afac93e9148$var$supportFloat32Array ? new Float32Array(arg) : arg;
    // Else is number
    return new $5cd50afac93e9148$var$Float32ArrayCtor(arg);
}


function $b022c65e2d67ded9$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: "+",
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: "=",
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: "-",
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $b022c65e2d67ded9$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $b022c65e2d67ded9$var$diffData(oldData, newData);
    // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = [];
    // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $af63fd8cd32fb271$export$b488a529581b37e)(oldCoordSys, newData, oldValueOrigin);
    // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout("points") || [];
    var newPoints = newData.getLayout("points") || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0;
        // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case "=":
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1];
                // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case "+":
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $af63fd8cd32fb271$export$c1601aa630e7b5f8)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case "-":
                pointAdded = false;
        }
        // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    }
    // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedNextPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedCurrStackedPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedNextStackedPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5c417e1ed90142c5$var$mathMin = Math.min;
var $5c417e1ed90142c5$var$mathMax = Math.max;
function $5c417e1ed90142c5$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $5c417e1ed90142c5$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($5c417e1ed90142c5$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? "moveTo" : "lineTo"](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY;
            // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                // Ignore duplicate point
                while(nextX === x && nextY === y && k < segLen){
                    k++;
                    nextIdx += dir;
                    idx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                    x = points[idx * 2];
                    y = points[idx * 2 + 1];
                    dx = x - prevX;
                    dy = y - prevY;
                }
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($5c417e1ed90142c5$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0;
                // Is last point
                if (tmpK >= segLen || $5c417e1ed90142c5$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === "x") {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        var dir_1 = vx > 0 ? 1 : -1;
                        cpx1 = x - dir_1 * lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + dir_1 * lenNextSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === "y") {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        var dir_2 = vy > 0 ? 1 : -1;
                        cpx1 = x;
                        cpy1 = y - dir_2 * lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + dir_2 * lenNextSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                        // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                        // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg;
                        // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $5c417e1ed90142c5$var$mathMin(nextCpx0, $5c417e1ed90142c5$var$mathMax(nextX, x));
                        nextCpy0 = $5c417e1ed90142c5$var$mathMin(nextCpy0, $5c417e1ed90142c5$var$mathMax(nextY, y));
                        nextCpx0 = $5c417e1ed90142c5$var$mathMax(nextCpx0, $5c417e1ed90142c5$var$mathMin(nextX, x));
                        nextCpy0 = $5c417e1ed90142c5$var$mathMax(nextCpy0, $5c417e1ed90142c5$var$mathMin(nextY, y));
                        // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                        // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $5c417e1ed90142c5$var$mathMin(cpx1, $5c417e1ed90142c5$var$mathMax(prevX, x));
                        cpy1 = $5c417e1ed90142c5$var$mathMin(cpy1, $5c417e1ed90142c5$var$mathMax(prevY, y));
                        cpx1 = $5c417e1ed90142c5$var$mathMax(cpx1, $5c417e1ed90142c5$var$mathMin(prevX, x));
                        cpy1 = $5c417e1ed90142c5$var$mathMax(cpy1, $5c417e1ed90142c5$var$mathMin(prevY, y));
                        // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $5c417e1ed90142c5$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $5c417e1ed90142c5$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-polyline";
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $5c417e1ed90142c5$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2;
        // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$5c417e1ed90142c5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$5c417e1ed90142c5$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $5c417e1ed90142c5$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
        var x0;
        var y0;
        var isDimX = dim === "x";
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(x0, x, x2, x3, xOrY, roots) : (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $747cfc5611b57cea$export$547c21de482bbcb2)(y0, y, y2, y3, t_1) : (0, $747cfc5611b57cea$export$547c21de482bbcb2)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $5c417e1ed90142c5$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($5c417e1ed90142c5$var$ECPolylineShape);
var $5c417e1ed90142c5$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-polygon";
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $5c417e1ed90142c5$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$5c417e1ed90142c5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$5c417e1ed90142c5$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $5c417e1ed90142c5$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $5c417e1ed90142c5$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $0e2cc04b3aaad400$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        "lineStyle",
        "width"
    ]) || 2;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(during) ? function(percent) {
            during(percent, clipPath);
        } : null;
        $8b353638fbedfefa$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $0e2cc04b3aaad400$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $a3e1dec0a3875b49$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === "angle";
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $8b353638fbedfefa$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $0e2cc04b3aaad400$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === "polar") return $0e2cc04b3aaad400$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === "cartesian2d") return $0e2cc04b3aaad400$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $3fea949f0512eb55$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}









function $ada57dad04d4bbf5$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $ada57dad04d4bbf5$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $ada57dad04d4bbf5$var$getBoundingDiff(points1, points2) {
    var _a = $ada57dad04d4bbf5$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $ada57dad04d4bbf5$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
    // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $ada57dad04d4bbf5$var$getSmooth(smooth) {
    return $7a1bd9c2710fea0d$export$7e4aa119212bc614(smooth) ? smooth : smooth ? 0.5 : 0;
}
function $ada57dad04d4bbf5$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $af63fd8cd32fb271$export$c1601aa630e7b5f8)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
function $ada57dad04d4bbf5$var$turnPointsIntoStep(points, coordSys, stepTurnAt, connectNulls) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === "x" || baseAxis.dim === "radius" ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    var filteredPoints = [];
    if (connectNulls) {
        for(i = 0; i < points.length; i += 2)if (!isNaN(points[i]) && !isNaN(points[i + 1])) filteredPoints.push(points[i], points[i + 1]);
        points = filteredPoints;
    }
    for(i = 0; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case "end":
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case "middle":
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    }
    // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $ada57dad04d4bbf5$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length;
    // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
            else if (prevOutOfRangeColorStop) // If there are two stops and coord range is between these two stops
            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $ada57dad04d4bbf5$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual("visualMeta");
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== "cartesian2d") return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim;
        // Can only be x or y
        if (coordDim === "x" || coordDim === "y") {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
    // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim);
    // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $ada57dad04d4bbf5$var$clipColorStops(colorStops, coordDim === "x" ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return "transparent";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || "transparent"
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || "transparent"
    });
    var gradient = new $cf44c01491b58e53$export$2e2bcd8739ae039(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + "2"] = maxCoord;
    return gradient;
}
function $ada57dad04d4bbf5$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get("showAllSymbol");
    var isAuto = showAllSymbol === "auto";
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
    if (!categoryAxis) return;
    // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto && $ada57dad04d4bbf5$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
    // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $ada57dad04d4bbf5$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In most cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $b1d9c3e17ccace80$export$2e2bcd8739ae039).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
    }
    return true;
}
function $ada57dad04d4bbf5$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $ada57dad04d4bbf5$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$ada57dad04d4bbf5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $ada57dad04d4bbf5$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $ada57dad04d4bbf5$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === "x" ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        "endLabel",
        "show"
    ])) return true;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        if (seriesModel.get([
            (0, $2bf82c0980125b62$export$151308dceb52d5b)[i],
            "endLabel",
            "show"
        ])) return true;
    }
    return false;
}
function $ada57dad04d4bbf5$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
        var endLabelModel_1 = seriesModel.getModel("endLabel");
        var valueAnimation_1 = endLabelModel_1.get("valueAnimation");
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $0e2cc04b3aaad400$export$83958787eb658d14)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during);
        // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get("clip", true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $0e2cc04b3aaad400$export$13dc2b2230df3cb5)(coordSys, hasAnimation, seriesModel);
}
function $ada57dad04d4bbf5$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? "right" : "left" : "center";
    var verticalAlign = isHorizontal ? "middle" : isBaseInversed ? "top" : "bottom";
    return {
        normal: {
            align: endLabelModel.get("align") || align,
            verticalAlign: endLabelModel.get("verticalAlign") || verticalAlign
        }
    };
}
var $ada57dad04d4bbf5$var$LineView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel("lineStyle");
        var areaStyleModel = seriesModel.getModel("areaStyle");
        var points = data.getLayout("points") || [];
        var isCoordSysPolar = coordSys.type === "polar";
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = !ecModel.ssr && seriesModel.get("animation");
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get("origin");
        var dataCoordInfo = (0, $af63fd8cd32fb271$export$b488a529581b37e)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $ada57dad04d4bbf5$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get("showSymbol");
        var connectNulls = seriesModel.get("connectNulls");
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $ada57dad04d4bbf5$var$getIsIgnoreFunc(seriesModel, data, coordSys);
        // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup);
        // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get("step") : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get("clip", true)) {
            clipShapeForSymbol = coordSys.getArea();
            // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $ada57dad04d4bbf5$var$getVisualGradient(data, coordSys, api) || data.getVisual("style")[data.getVisual("drawType")];
        // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                // TODO If stacked series is not step
                points = $ada57dad04d4bbf5$var$turnPointsIntoStep(points, coordSys, step, connectNulls);
                if (stackedOnPoints) stackedOnPoints = $ada57dad04d4bbf5$var$turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon) {
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $c84c9521536c601a$export$cda04d03233e5555)(visualColor));
            lineGroup.setClipPath($ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $c84c9521536c601a$export$cda04d03233e5555)(visualColor));
            // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, false, seriesModel);
                $8b353638fbedfefa$export$a121566aadcfe021(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, true, seriesModel));
            // Always update, or it is wrong in the case turning on legend
            // because points are not changed.
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            // In the case data zoom triggered refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing.
            if (!$ada57dad04d4bbf5$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$ada57dad04d4bbf5$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
                else {
                    // Not do it in update with animation
                    if (step) {
                        // TODO If stacked series is not step
                        points = $ada57dad04d4bbf5$var$turnPointsIntoStep(points, coordSys, step, connectNulls);
                        if (stackedOnPoints) stackedOnPoints = $ada57dad04d4bbf5$var$turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var emphasisModel = seriesModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var blurScope = emphasisModel.get("blurScope");
        var emphasisDisabled = emphasisModel.get("disabled");
        polyline.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(// Use color in lineStyle first
        lineStyleModel.getLineStyle(), {
            fill: "none",
            stroke: visualColor,
            lineJoin: "bevel"
        }));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polyline, seriesModel, "lineStyle");
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            "emphasis",
            "lineStyle",
            "width"
        ]) === "bolder") {
            var emphasisLineStyle = polyline.getState("emphasis").style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        }
        // Needs seriesIndex for focus
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(polyline, focus, blurScope, emphasisDisabled);
        var smooth = $ada57dad04d4bbf5$var$getSmooth(seriesModel.get("smooth"));
        var smoothMonotone = seriesModel.get("smoothMonotone");
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo("stackedOnSeries");
            var stackedOnSmooth = 0;
            polygon.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: "bevel",
                decal: data.getVisual("style").decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $ada57dad04d4bbf5$var$getSmooth(stackedOnSeries.get("smooth"));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, seriesModel, "areaStyle");
            // Needs seriesIndex for focus
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, focus, blurScope, emphasisDisabled);
        }
        var changePolyState = function(toState) {
            _this._changePolyState(toState);
        };
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data;
        // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
        if (seriesModel.get("triggerLineEvent")) {
            this.packEventData(seriesModel, polyline);
            polygon && this.packEventData(seriesModel, polygon);
        }
    };
    LineView.prototype.packEventData = function(seriesModel, el) {
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
            componentType: "series",
            componentSubType: "line",
            componentIndex: seriesModel.componentIndex,
            seriesIndex: seriesModel.seriesIndex,
            seriesName: seriesModel.name,
            seriesType: "line"
        };
    };
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
        this._changePolyState("emphasis");
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout("points");
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get("zlevel") || 0;
                var z = seriesModel.get("z") || 0;
                symbol = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z);
                // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol);
                // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
        this._changePolyState("normal");
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $2bf82c0980125b62$export$868ba38adffa9e39)(this._polyline, toState);
        polygon && (0, $2bf82c0980125b62$export$868ba38adffa9e39)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline;
        // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $5c417e1ed90142c5$export$bf7c0585b8f7d00f)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon;
        // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $5c417e1ed90142c5$export$6042a400d113f2bd)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === "cartesian2d") {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === "polar") {
            isHorizontalOrRadial = baseAxis.dim === "angle";
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get("animationDuration");
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDuration)) seriesDuration = seriesDuration(null);
        var seriesDelay = seriesModel.get("animationDelay") || 0;
        var seriesDelayValue = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(null) : seriesDelay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel("endLabel");
        if ($ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            // series may be filtered.
            var points = data_2.getLayout("points");
            if (!points) {
                polyline.removeTextContent();
                this._endLabel = null;
                return;
            }
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            }
            // Find last non-NaN data to display data
            var dataIndex = $ada57dad04d4bbf5$var$getLastIndexNotNull(points);
            if (dataIndex >= 0) {
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polyline, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel, "endLabel"), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $b2475f850d3c0bc2$export$5f84815e91ca6775)(data_2, interpolatedValue) : (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $ada57dad04d4bbf5$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout("points");
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get("connectNulls");
            var precision = endLabelModel.get("precision");
            var distance = endLabelModel.get("distance") || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? "x" : "y";
            var dataIndexRange = $ada57dad04d4bbf5$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $ada57dad04d4bbf5$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $76d619f648247e6d$export$bd0439821a1869f3(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $ada57dad04d4bbf5$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) {
                var inner = (0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(endLabel);
                if (typeof inner.setLabelText === "function") inner.setLabelText(value);
            }
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $b022c65e2d67ded9$export$2e2bcd8739ae039)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            current = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.current, coordSys, step, connectNulls);
            stackedOnCurrent = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step, connectNulls);
            next = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.next, coordSys, step, connectNulls);
            stackedOnNext = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.stackedOnNext, coordSys, step, connectNulls);
        }
        // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($ada57dad04d4bbf5$var$getBoundingDiff(current, next) > 3000 || polygon && $ada57dad04d4bbf5$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        };
        // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
        // Stop previous animation.
        polyline.stopAnimation();
        $8b353638fbedfefa$export$c8dce3c08436e91e(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
            // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === "=") {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true);
        // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = "line";
    return LineView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $ada57dad04d4bbf5$export$2e2bcd8739ae039 = $ada57dad04d4bbf5$var$LineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $73b014aa594ea652$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo("stackResultDimension");
            if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i);
                            // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i);
                            // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout("points", points);
                }
            };
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3a37e5b80322a871$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    minmax: function(frame) {
        var turningPointAbsoluteValue = -Infinity;
        var turningPointOriginalValue = -Infinity;
        for(var i = 0; i < frame.length; i++){
            var originalValue = frame[i];
            var absoluteValue = Math.abs(originalValue);
            if (absoluteValue > turningPointAbsoluteValue) {
                turningPointAbsoluteValue = absoluteValue;
                turningPointOriginalValue = originalValue;
            }
        }
        return isFinite(turningPointOriginalValue) ? turningPointOriginalValue : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $3a37e5b80322a871$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $3a37e5b80322a871$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get("sampling");
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === "cartesian2d" && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === "lttb") seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sampling)) sampler = $3a37e5b80322a871$var$samplers[sampling];
                    else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $3a37e5b80322a871$var$indexSampler));
                }
            }
        }
    };
}


function $9c1bfdc9a4f78f2d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $ada57dad04d4bbf5$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $04f9db15b0fa1cf8$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("line", true));
    registers.registerVisual({
        seriesType: "line",
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // Visual coding for legend
            var lineStyle = seriesModel.getModel("lineStyle").getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual("style").fill;
            data.setVisual("legendLineStyle", lineStyle);
        }
    });
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3a37e5b80322a871$export$2e2bcd8739ae039)("line"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $361c48dd900de28f$var$STACK_PREFIX = "__ec_stack_";
function $361c48dd900de28f$var$getSeriesStackId(seriesModel) {
    return seriesModel.get("stack") || $361c48dd900de28f$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $361c48dd900de28f$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $361c48dd900de28f$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = "axis0";
    if (baseAxis.type !== "category") return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $361c48dd900de28f$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $361c48dd900de28f$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$361c48dd900de28f$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $361c48dd900de28f$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($361c48dd900de28f$var$isOnCartesian(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $361c48dd900de28f$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== "time" && baseAxis.type !== "value") return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + "_" + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
        // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            }
            // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $361c48dd900de28f$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $361c48dd900de28f$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === "category") bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === "value" || baseAxis.type === "time") {
            var key = baseAxis.dim + "_" + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barWidth"), bandWidth);
        var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barMaxWidth"), bandWidth);
        var barMinWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
        // the auto-calculated bar width might be less than 0.5 / 1.
        seriesModel.get("barMinWidth") || ($361c48dd900de28f$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
        var barGap = seriesModel.get("barGap");
        var barCategoryGap = seriesModel.get("barCategoryGap");
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $361c48dd900de28f$var$getAxisKey(baseAxis),
            stackId: $361c48dd900de28f$var$getSeriesStackId(seriesModel)
        });
    });
    return $361c48dd900de28f$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $361c48dd900de28f$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: "20%",
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(stacks).length;
            // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + "%";
        }
        var categoryGap = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                // `minWidth` has higher priority. `minWidth` decide that whether the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Because barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $361c48dd900de28f$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$361c48dd900de28f$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$361c48dd900de28f$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $361c48dd900de28f$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $361c48dd900de28f$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $361c48dd900de28f$export$20769dafc84e0299(seriesModels);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $361c48dd900de28f$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$361c48dd900de28f$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
    });
}
function $361c48dd900de28f$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            if (!$361c48dd900de28f$var$isOnCartesian(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get("showBackground", true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo("stackResultDimension");
            var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, valueDim) && !!data.getCalculationInfo("stackedOnSeries");
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $361c48dd900de28f$var$getValueAxisStart(baseAxis, valueAxis);
            var isLarge = $361c48dd900de28f$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get("barMinHeight") || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout("size");
            var columnOffset = data.getLayout("offset");
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count * 3);
                    var largeDataIndices = isLarge && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var startValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) startValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    startValue,
                                    baseValue
                                ]);
                                baseCoord = startCoord[0];
                            }
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    baseValue,
                                    startValue
                                ]);
                                baseCoord = startCoord[1];
                            }
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $361c48dd900de28f$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "cartesian2d";
}
function $361c48dd900de28f$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
// See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $361c48dd900de28f$var$getValueAxisStart(baseAxis, valueAxis) {
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === "log" ? 1 : 0));
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b508252f98157abf$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === "category" && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get("alignWithLabel");
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === "x1" || dims[idx] === "y1";
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout("offset");
                var size = data.getLayout("size");
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = "series.__base_bar__";
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: "mod"
    };
    return BaseBarSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass($b508252f98157abf$var$BaseBarSeriesModel);
var $b508252f98157abf$export$2e2bcd8739ae039 = $b508252f98157abf$var$BaseBarSeriesModel;




var $1db8e2e676cae702$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get("realtimeSort", true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get("large") ? this.get("progressive") : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get("progressiveThreshold");
        var largeThreshold = this.get("largeThreshold");
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = "series.bar";
    BarSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    BarSeriesModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $b508252f98157abf$export$2e2bcd8739ae039).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
            borderColor: null,
            borderWidth: 0,
            borderType: "solid",
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $b508252f98157abf$export$2e2bcd8739ae039));
var $1db8e2e676cae702$export$2e2bcd8739ae039 = $1db8e2e676cae702$var$BarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $9674946a7a7df213$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $9674946a7a7df213$var$SausagePath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "sausage";
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $9674946a7a7df213$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $9674946a7a7df213$export$2e2bcd8739ae039 = $9674946a7a7df213$var$SausagePath;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $5e4aaa173c31cda6$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $6c308355c7107803$export$eee3603b512feab7)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = "left";
        var textVerticalAlign = "top";
        switch(mappedSectorPosition){
            case "startArc":
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "top";
                break;
            case "insideStartArc":
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "bottom";
                break;
            case "startAngle":
                x = cx + middleR * mathCos(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = "right";
                textVerticalAlign = "middle";
                break;
            case "insideStartAngle":
                x = cx + middleR * mathCos(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = "left";
                textVerticalAlign = "middle";
                break;
            case "middle":
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "middle";
                break;
            case "endArc":
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "bottom";
                break;
            case "insideEndArc":
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "top";
                break;
            case "endAngle":
                x = cx + middleR * mathCos(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = "left";
                textVerticalAlign = "middle";
                break;
            case "insideEndAngle":
                x = cx + middleR * mathCos(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = "right";
                textVerticalAlign = "middle";
                break;
            default:
                return (0, $6c308355c7107803$export$eee3603b512feab7)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $5e4aaa173c31cda6$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case "startArc":
        case "insideStartArc":
        case "middle":
        case "insideEndArc":
        case "endArc":
            anchorAngle = middleAngle;
            break;
        case "startAngle":
        case "insideStartAngle":
            anchorAngle = startAngle;
            break;
        case "endAngle":
        case "insideEndAngle":
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === "middle" && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $5e4aaa173c31cda6$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $5e4aaa173c31cda6$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $9491a9b96e203579$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get("borderRadius");
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}


var $0b120d76f26c920d$var$mathMax = Math.max;
var $0b120d76f26c920d$var$mathMin = Math.min;
function $0b120d76f26c920d$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coord, "cartesian2d")) {
        var baseAxis = coord.getBaseAxis();
        // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== "category" || !baseAxis.onBand) {
            var expandWidth = data.getLayout("bandWidth");
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $0b120d76f26c920d$var$BarView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get("coordinateSystem");
        if (coordinateSystemType === "cartesian2d" || coordinateSystemType === "polar") {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $5b455ae6f843ac47$export$3e564442729bf048)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === "cartesian2d") isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === "polar") isHorizontalOrRadial = baseAxis.dim === "angle";
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $0b120d76f26c920d$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get("clip", true) || realtimeSortCfg;
        var coordSysClipArea = $0b120d76f26c920d$var$getClipArea(coord, data);
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get("roundCap", true);
        var drawBackground = seriesModel.get("showBackground", true);
        var backgroundModel = seriesModel.getModel("backgroundStyle");
        var barBorderRadius = backgroundModel.get("borderRadius") || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === "changeAxisOrder";
        function createBackground(dataIndex) {
            var bgLayout = $0b120d76f26c920d$var$getLayout[coord.type](data, dataIndex);
            var bgEl = $0b120d76f26c920d$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === "cartesian2d") bgEl.setShape("r", barBorderRadius);
            else bgEl.setShape("cornerRadius", barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $0b120d76f26c920d$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$0b120d76f26c920d$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $0b120d76f26c920d$var$clip[coord.type](coordSysClipArea, layout);
            var el = $0b120d76f26c920d$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $0b120d76f26c920d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === "polar");
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $8b353638fbedfefa$export$a121566aadcfe021)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $0b120d76f26c920d$var$getLayout[coord.type](data, newIndex, itemModel);
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === "cartesian2d") bgEl.setShape("r", barBorderRadius);
                    else bgEl.setShape("cornerRadius", barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $0b120d76f26c920d$var$getLayout[coord.type](data, newIndex);
                var shape = $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$0b120d76f26c920d$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $0b120d76f26c920d$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            if (!el) el = $0b120d76f26c920d$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
            else (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $0b120d76f26c920d$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === "polar");
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $0b120d76f26c920d$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $0b120d76f26c920d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get("clip", true) && (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on("rendered", this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: "changeAxisOrder",
                componentType: baseAxis.dim + "Axis",
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: "changeAxisOrder",
            componentType: baseAxis.dim + "Axis",
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off("rendered", this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, model, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = "bar";
    return BarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $0b120d76f26c920d$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $0b120d76f26c920d$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $0b120d76f26c920d$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $0b120d76f26c920d$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $0b120d76f26c920d$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $0b120d76f26c920d$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $0b120d76f26c920d$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $0b120d76f26c920d$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = "item";
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? "height" : "width";
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = "item";
        var positionMap = $0b120d76f26c920d$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $5e4aaa173c31cda6$export$359a1e2d210ed734)(positionMap, {
            isRoundCap: ShapeClass === (0, $9674946a7a7df213$export$2e2bcd8739ae039)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? "r" : "endAngle";
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $0b120d76f26c920d$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get("realtimeSort", true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === "category" && coordSys.type === "cartesian2d") return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $0b120d76f26c920d$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $0b120d76f26c920d$var$rectPropties = [
    "x",
    "y",
    "width",
    "height"
];
var $0b120d76f26c920d$var$polarPropties = [
    "cx",
    "cy",
    "r",
    "startAngle",
    "endAngle"
];
var $0b120d76f26c920d$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$0b120d76f26c920d$var$checkPropertiesNotValid(layout, $0b120d76f26c920d$var$rectPropties);
    },
    polar: function(layout) {
        return !$0b120d76f26c920d$var$checkPropertiesNotValid(layout, $0b120d76f26c920d$var$polarPropties);
    }
};
var $0b120d76f26c920d$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        var fixedLineWidth = itemModel ? $0b120d76f26c920d$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $0b120d76f26c920d$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $0b120d76f26c920d$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? "Arc" : "Angle";
        return function(position) {
            switch(position){
                case "start":
                case "insideStart":
                case "end":
                case "insideEnd":
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $0b120d76f26c920d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, "style");
    if (!isPolar) {
        var borderRadius = itemModel.get([
            "itemStyle",
            "borderRadius"
        ]) || 0;
        el.setShape("r", borderRadius);
    } else if (!seriesModel.get("roundCap")) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), sectorShape, true);
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow("cursor");
    cursorStyle && el.attr("cursor", cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? "endArc" : "startArc" : layout.endAngle >= layout.startAngle ? "endAngle" : "startAngle" : isHorizontalOrRadial ? layout.height >= 0 ? "bottom" : "top" : layout.width >= 0 ? "right" : "left";
    var labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
    (0, $6800dfcb6e1e2a44$export$9a13992917966657)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            "label",
            "position"
        ]);
        el.textConfig.inside = position === "middle" ? true : null;
        (0, $5e4aaa173c31cda6$export$672ce504c0db395a)(el, position === "outside" ? labelPositionOutside : position, $0b120d76f26c920d$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            "label",
            "rotate"
        ]));
    }
    (0, $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $b2475f850d3c0bc2$export$5f84815e91ca6775)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        "emphasis"
    ]);
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    if ($0b120d76f26c920d$var$isZeroOnPolar(layout)) {
        el.style.fill = "none";
        el.style.stroke = "none";
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = "none";
        });
    }
}
// In case width or height are too small.
function $0b120d76f26c920d$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        "itemStyle",
        "borderColor"
    ]);
    if (!borderColor || borderColor === "none") return 0;
    var lineWidth = itemModel.get([
        "itemStyle",
        "borderWidth"
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $0b120d76f26c920d$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $0b120d76f26c920d$var$LargePath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "largeBar";
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $0b120d76f26c920d$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $0b120d76f26c920d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout("valueAxisHorizontal") ? 1 : 0;
    var largeDataIndices = data.getLayout("largeDataIndices");
    var barWidth = data.getLayout("size");
    var backgroundModel = seriesModel.getModel("backgroundStyle");
    var bgPoints = data.getLayout("largeBackgroundPoints");
    if (bgPoints) {
        var bgEl = new $0b120d76f26c920d$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $0b120d76f26c920d$var$LargePath({
        shape: {
            points: data.getLayout("largePoints")
        },
        incremental: !!incremental,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual("style"));
    // Enable tooltip and user mouse/touch event handlers.
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get("silent")) {
        el.on("mousedown", $0b120d76f26c920d$var$largePathUpdateDataIndex);
        el.on("mousemove", $0b120d76f26c920d$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $0b120d76f26c920d$var$largePathUpdateDataIndex = (0, $c98659a9437a3d2e$export$de363e709c412c8a)(function(event) {
    var largePath = this;
    var dataIndex = $0b120d76f26c920d$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $0b120d76f26c920d$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coord, "cartesian2d")) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $0b120d76f26c920d$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === "polar" ? (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039) : (0, $419e5ff2f303755e$export$2e2bcd8739ae039);
    return new ElementClz({
        shape: $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $0b120d76f26c920d$export$2e2bcd8739ae039 = $0b120d76f26c920d$var$BarView;


function $4bb56d1f08552ff4$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $0b120d76f26c920d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $1db8e2e676cae702$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $361c48dd900de28f$export$b3219800bda33a1f), "bar"));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $361c48dd900de28f$export$16e8685758531cb6)("bar"));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3a37e5b80322a871$export$2e2bcd8739ae039)("bar"));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: "changeAxisOrder",
        event: "changeAxisOrder",
        update: "update"
    }, function(payload, ecModel) {
        var componentType = payload.componentType || "series";
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $21576fcf4c669316$var$PI2 = Math.PI * 2;
var $21576fcf4c669316$var$RADIAN = Math.PI / 180;
function $21576fcf4c669316$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $21576fcf4c669316$export$2a0d4d5b12383eb9(seriesModel, api) {
    var viewRect = $21576fcf4c669316$var$getViewRect(seriesModel, api);
    // center can be string or number when coordinateSystem is specified
    var center = seriesModel.get("center");
    var radius = seriesModel.get("radius");
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    var cx;
    var cy;
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys) {
        // percentage is not allowed when coordinate system is specified
        var point = coordSys.dataToPoint(center);
        cx = point[0] || 0;
        cy = point[1] || 0;
    } else {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width) + viewRect.x;
        cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height) + viewRect.y;
    }
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r
    };
}
function $21576fcf4c669316$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var viewRect = $21576fcf4c669316$var$getViewRect(seriesModel, api);
        var _a = $21576fcf4c669316$export$2a0d4d5b12383eb9(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0;
        var startAngle = -seriesModel.get("startAngle") * $21576fcf4c669316$var$RADIAN;
        var endAngle = seriesModel.get("endAngle");
        var padAngle = seriesModel.get("padAngle") * $21576fcf4c669316$var$RADIAN;
        endAngle = endAngle === "auto" ? startAngle - $21576fcf4c669316$var$PI2 : -endAngle * $21576fcf4c669316$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $21576fcf4c669316$var$RADIAN;
        var minAndPadAngle = minAngle + padAngle;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim);
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get("clockwise");
        var roseType = seriesModel.get("roseType");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum");
        // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0;
        var dir = clockwise ? 1 : -1;
        var angles = [
            startAngle,
            endAngle
        ];
        var halfPadAngle = dir * padAngle / 2;
        (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0], endAngle = angles[1];
        var angleRange = Math.abs(endAngle - startAngle);
        // In the case some sector angle is smaller than minAngle
        var restAngle = angleRange;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            }
            // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== "area") angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = angleRange / validDataCount;
            if (angle < minAndPadAngle) {
                angle = minAndPadAngle;
                restAngle -= minAndPadAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            // calculate display angle
            var actualStartAngle = 0;
            var actualEndAngle = 0;
            if (padAngle > angle) {
                actualStartAngle = currentAngle + dir * angle / 2;
                actualEndAngle = actualStartAngle;
            } else {
                actualStartAngle = currentAngle + halfPadAngle;
                actualEndAngle = endAngle - halfPadAngle;
            }
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: actualStartAngle,
                endAngle: actualEndAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        });
        // Some sector is constrained by minAngle and padAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $21576fcf4c669316$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle and padAngle
            if (restAngle <= 1e-3) {
                var angle_1 = angleRange / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_1 = data.getItemLayout(idx);
                        layout_1.angle = angle_1;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle_1 < padAngle) {
                            actualStartAngle = startAngle + dir * (idx + 0.5) * angle_1;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = startAngle + dir * idx * angle_1 + halfPadAngle;
                            actualEndAngle = startAngle + dir * (idx + 1) * angle_1 - halfPadAngle;
                        }
                        layout_1.startAngle = actualStartAngle;
                        layout_1.endAngle = actualEndAngle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_2 = data.getItemLayout(idx);
                        var angle = layout_2.angle === minAndPadAngle ? minAndPadAngle : value * unitRadian;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle < padAngle) {
                            actualStartAngle = currentAngle + dir * angle / 2;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = currentAngle + halfPadAngle;
                            actualEndAngle = currentAngle + dir * angle - halfPadAngle;
                        }
                        layout_2.startAngle = actualStartAngle;
                        layout_2.endAngle = actualEndAngle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $e11a533bf70b759c$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: "legend"
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx);
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $f4eb87a228be297f$var$PI2 = Math.PI * 2;
var $f4eb87a228be297f$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $f4eb87a228be297f$var$DEFAULT_SEARCH_SPACE = [
    "top",
    "right",
    "bottom",
    "left"
];
function $f4eb87a228be297f$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case "top":
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case "bottom":
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case "left":
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case "right":
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $f4eb87a228be297f$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d;
    // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $f4eb87a228be297f$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(startAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $f4eb87a228be297f$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $f4eb87a228be297f$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $f4eb87a228be297f$var$PI2 >= startAngle && angle + $f4eb87a228be297f$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $f4eb87a228be297f$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen;
    // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $f4eb87a228be297f$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $f4eb87a228be297f$var$tmpPt = [];
function $f4eb87a228be297f$var$nearestPointOnRect(pt, rect, out) {
    var dist = $f4eb87a228be297f$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $f4eb87a228be297f$var$tmpPt);
    out.set($f4eb87a228be297f$var$tmpPt[0], $f4eb87a228be297f$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $f4eb87a228be297f$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $f4eb87a228be297f$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $f4eb87a228be297f$var$CMD.L:
                d = $f4eb87a228be297f$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.C:
                d = (0, $747cfc5611b57cea$export$dbaa3801d1284367)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.Q:
                d = (0, $747cfc5611b57cea$export$81915a594fe10dee)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                }
                // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $f4eb87a228be297f$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $f4eb87a228be297f$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $f4eb87a228be297f$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $f4eb87a228be297f$var$projectPointToRect(x0, y0, width, height, x, y, $f4eb87a228be297f$var$tmpPt);
                break;
            case $f4eb87a228be297f$var$CMD.Z:
                d = $f4eb87a228be297f$var$projectPointToLine(xi, yi, x0, y0, x, y, $f4eb87a228be297f$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($f4eb87a228be297f$var$tmpPt[0], $f4eb87a228be297f$var$tmpPt[1]);
        }
    }
    return minDist;
}
// Temporal variable for intermediate usage.
var $f4eb87a228be297f$var$pt0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$pt1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$pt2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$dir = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$dir2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
function $f4eb87a228be297f$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent();
    // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $f4eb87a228be297f$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)([], targetTransform);
    var len = labelLineModel.get("length2") || 0;
    if (anchorPoint) $f4eb87a228be297f$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $f4eb87a228be297f$var$getCandidateAnchor(candidate, 0, labelRect, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$dir);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scaleAndAdd($f4eb87a228be297f$var$pt1, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$dir, len);
        // Transform to target coord space.
        $f4eb87a228be297f$var$pt1.transform(targetInversedTransform);
        // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($f4eb87a228be297f$var$pt1) : target instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) ? $f4eb87a228be297f$var$nearestPointOnPath($f4eb87a228be297f$var$pt1, target.path, $f4eb87a228be297f$var$pt2) : $f4eb87a228be297f$var$nearestPointOnRect($f4eb87a228be297f$var$pt1, boundingRect, $f4eb87a228be297f$var$pt2);
        // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist;
            // Transform back to global space.
            $f4eb87a228be297f$var$pt1.transform(targetTransform);
            $f4eb87a228be297f$var$pt2.transform(targetTransform);
            $f4eb87a228be297f$var$pt2.toArray(points[0]);
            $f4eb87a228be297f$var$pt1.toArray(points[1]);
            $f4eb87a228be297f$var$pt0.toArray(points[2]);
        }
    }
    $f4eb87a228be297f$export$ac52062003fbe6a(points, labelLineModel.get("minTurnAngle"));
    labelLine.setShape({
        points: points
    });
}
// Temporal variable for the limitTurnAngle function
var $f4eb87a228be297f$var$tmpArr = [];
var $f4eb87a228be297f$var$tmpProjPoint = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
function $f4eb87a228be297f$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI;
    // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $f4eb87a228be297f$var$pt0.fromArray(linePoints[0]);
    $f4eb87a228be297f$var$pt1.fromArray(linePoints[1]);
    $f4eb87a228be297f$var$pt2.fromArray(linePoints[2]);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$pt1);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir2, $f4eb87a228be297f$var$pt2, $f4eb87a228be297f$var$pt1);
    var len1 = $f4eb87a228be297f$var$dir.len();
    var len2 = $f4eb87a228be297f$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $f4eb87a228be297f$var$dir.scale(1 / len1);
    $f4eb87a228be297f$var$dir2.scale(1 / len2);
    var angleCos = $f4eb87a228be297f$var$dir.dot($f4eb87a228be297f$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $f4eb87a228be297f$var$projectPointToLine($f4eb87a228be297f$var$pt1.x, $f4eb87a228be297f$var$pt1.y, $f4eb87a228be297f$var$pt2.x, $f4eb87a228be297f$var$pt2.y, $f4eb87a228be297f$var$pt0.x, $f4eb87a228be297f$var$pt0.y, $f4eb87a228be297f$var$tmpArr, false);
        $f4eb87a228be297f$var$tmpProjPoint.fromArray($f4eb87a228be297f$var$tmpArr);
        // Calculate new projected length with limited minTurnAngle and get the new connect point
        $f4eb87a228be297f$var$tmpProjPoint.scaleAndAdd($f4eb87a228be297f$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
        // Limit the new calculated connect point between pt1 and pt2.
        var t = $f4eb87a228be297f$var$pt2.x !== $f4eb87a228be297f$var$pt1.x ? ($f4eb87a228be297f$var$tmpProjPoint.x - $f4eb87a228be297f$var$pt1.x) / ($f4eb87a228be297f$var$pt2.x - $f4eb87a228be297f$var$pt1.x) : ($f4eb87a228be297f$var$tmpProjPoint.y - $f4eb87a228be297f$var$pt1.y) / ($f4eb87a228be297f$var$pt2.y - $f4eb87a228be297f$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt1);
        else if (t > 1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        $f4eb87a228be297f$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $f4eb87a228be297f$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $f4eb87a228be297f$var$pt0.fromArray(linePoints[0]);
    $f4eb87a228be297f$var$pt1.fromArray(linePoints[1]);
    $f4eb87a228be297f$var$pt2.fromArray(linePoints[2]);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir, $f4eb87a228be297f$var$pt1, $f4eb87a228be297f$var$pt0);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir2, $f4eb87a228be297f$var$pt2, $f4eb87a228be297f$var$pt1);
    var len1 = $f4eb87a228be297f$var$dir.len();
    var len2 = $f4eb87a228be297f$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $f4eb87a228be297f$var$dir.scale(1 / len1);
    $f4eb87a228be297f$var$dir2.scale(1 / len2);
    var angleCos = $f4eb87a228be297f$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $f4eb87a228be297f$var$projectPointToLine($f4eb87a228be297f$var$pt1.x, $f4eb87a228be297f$var$pt1.y, $f4eb87a228be297f$var$pt2.x, $f4eb87a228be297f$var$pt2.y, $f4eb87a228be297f$var$pt0.x, $f4eb87a228be297f$var$pt0.y, $f4eb87a228be297f$var$tmpArr, false);
        $f4eb87a228be297f$var$tmpProjPoint.fromArray($f4eb87a228be297f$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($f4eb87a228be297f$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $f4eb87a228be297f$var$tmpProjPoint.scaleAndAdd($f4eb87a228be297f$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
            // Limit the new calculated connect point between pt1 and pt2.
            var t = $f4eb87a228be297f$var$pt2.x !== $f4eb87a228be297f$var$pt1.x ? ($f4eb87a228be297f$var$tmpProjPoint.x - $f4eb87a228be297f$var$pt1.x) / ($f4eb87a228be297f$var$pt2.x - $f4eb87a228be297f$var$pt1.x) : ($f4eb87a228be297f$var$tmpProjPoint.y - $f4eb87a228be297f$var$pt1.y) / ($f4eb87a228be297f$var$pt2.y - $f4eb87a228be297f$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt1);
            else if (t > 1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        }
        $f4eb87a228be297f$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $f4eb87a228be297f$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === "normal";
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
    // Make sure display.
    stateObj.ignore = ignore;
    // Set smooth
    var smooth = stateModel.get("smooth");
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel("lineStyle").getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $f4eb87a228be297f$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $6de594cf8ac295ff$export$6c4a311cc157c764(points[0], points[1]);
        var len2 = $6de594cf8ac295ff$export$6c4a311cc157c764(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], points[1], points[0], moveLen / len1);
        var midPoint2 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], points[1], points[2], moveLen / len2);
        var midPoint1 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $f4eb87a228be297f$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get("show");
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$57ee5306b85ad7d5).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$57ee5306b85ad7d5)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === "normal";
        if (stateModel) {
            var stateShow = stateModel.get("show");
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
                if (stateObj) stateObj.ignore = true;
                if (!!labelLine) $f4eb87a228be297f$var$setLabelLineState(labelLine, true, stateName, stateModel);
                continue;
            }
            // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)();
                targetEl.setTextGuideLine(labelLine);
                // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $f4eb87a228be297f$var$setLabelLineState(labelLine, true, "normal", statesModels.normal);
                // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $f4eb87a228be297f$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(labelLine.style, defaultStyle);
        // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get("showAbove");
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false;
        // Custom the buildPath.
        labelLine.buildPath = $f4eb87a228be297f$var$buildLabelLinePath;
    }
}
function $f4eb87a228be297f$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || "labelLine";
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $11dac7a73f36cc2c$export$6c403cad1ae3e239(input) {
    var list = [];
    for(var i = 0; i < input.length; i++){
        var rawItem = input[i];
        if (rawItem.defaultAttr.ignore) continue;
        var label = rawItem.label;
        var transform = label.getComputedTransform();
        // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
        var localRect = label.getBoundingRect();
        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
        var minMargin = label.style.margin || 0;
        var globalRect = localRect.clone();
        globalRect.applyTransform(transform);
        globalRect.x -= minMargin / 2;
        globalRect.y -= minMargin / 2;
        globalRect.width += minMargin;
        globalRect.height += minMargin;
        var obb = isAxisAligned ? new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(localRect, transform) : null;
        list.push({
            label: label,
            labelLine: rawItem.labelLine,
            rect: globalRect,
            localRect: localRect,
            obb: obb,
            priority: rawItem.priority,
            defaultAttr: rawItem.defaultAttr,
            layoutOption: rawItem.computedLayoutOption,
            axisAligned: isAxisAligned,
            transform: transform
        });
    }
    return list;
}
function $11dac7a73f36cc2c$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
    var len = list.length;
    if (len < 2) return;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    var shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $11dac7a73f36cc2c$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, // If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    return $11dac7a73f36cc2c$var$shiftLayout(list, "x", "width", leftBound, rightBound, balanceShift);
}
function $11dac7a73f36cc2c$export$118c25e0932528e4(list, topBound, bottomBound, // If average the shifts on all labels and add them to 0
balanceShift) {
    return $11dac7a73f36cc2c$var$shiftLayout(list, "y", "height", topBound, bottomBound, balanceShift);
}
function $11dac7a73f36cc2c$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return b.priority - a.priority;
    });
    var globalRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState("emphasis");
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var isAxisAligned = labelItem.axisAligned;
        var localRect = labelItem.localRect;
        var transform = labelItem.transform;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        globalRect.copy(labelItem.rect);
        // Add a threshold because layout may be aligned precisely.
        globalRect.width -= 0.1;
        globalRect.height -= 0.1;
        globalRect.x += 0.05;
        globalRect.y += 0.05;
        var obb = labelItem.obb;
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++){
            var existsTextCfg = displayedLabels[j];
            // Fast rejection.
            if (!globalRect.intersect(existsTextCfg.rect)) continue;
            if (isAxisAligned && existsTextCfg.axisAligned) {
                // Is overlapped
                overlapped = true;
                break;
            }
            if (!existsTextCfg.obb) // If self is not axis aligned. But other is.
            existsTextCfg.obb = new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(existsTextCfg.localRect, existsTextCfg.transform);
            if (!obb) // If self is axis aligned. But other is not.
            obb = new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(localRect, transform);
            if (obb.intersect(existsTextCfg.obb)) {
                overlapped = true;
                break;
            }
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else {
            label.attr("ignore", labelItem.defaultAttr.ignore);
            labelLine && labelLine.attr("ignore", labelItem.defaultAttr.labelGuideIgnore);
            displayedLabels.push(labelItem);
        }
    }
}


var $4b109d23b790ee9a$var$RADIAN = Math.PI / 180;
function $4b109d23b790ee9a$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy);
            // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA;
            // Use ellipse implicit function to calculate x
            var dx = Math.sqrt((1 - Math.abs(dy * dy / rB2)) * rA2);
            var newX = cx + (dx + item.len2) * dir;
            var deltaX = newX - item.label.x;
            var newTargetWidth = item.targetTextWidth - deltaX * dir;
            // text x is changed, so need to recalculate width.
            $4b109d23b790ee9a$var$constrainTextWidth(item, newTargetWidth, true);
            item.label.x = newX;
        }
    }
    // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== "none") continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy >= semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir;
                // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len;
                // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === "outer" && list[i].labelAlignTo === "labelLine") {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $11dac7a73f36cc2c$export$118c25e0932528e4)(list, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $4b109d23b790ee9a$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($4b109d23b790ee9a$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$4b109d23b790ee9a$var$isPositionCenter(layout) && layout.linePoints) {
            if (layout.labelStyleWidth != null) continue;
            var label = layout.label;
            var linePoints = layout.linePoints;
            var targetTextWidth = void 0;
            if (layout.labelAlignTo === "edge") {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (layout.labelAlignTo === "labelLine") {
                if (label.x < cx) targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            layout.targetTextWidth = targetTextWidth;
            $4b109d23b790ee9a$var$constrainTextWidth(layout, targetTextWidth);
        }
    }
    $4b109d23b790ee9a$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $4b109d23b790ee9a$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$4b109d23b790ee9a$var$isPositionCenter(layout) && layout.linePoints) {
            var label = layout.label;
            var linePoints = layout.linePoints;
            var isAlignToEdge = layout.labelAlignTo === "edge";
            var padding = label.style.padding;
            var paddingH = padding ? padding[1] + padding[3] : 0;
            // textRect.width already contains paddingH if bgColor is set
            var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
            var realTextWidth = layout.rect.width + extraPaddingH;
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */ function $4b109d23b790ee9a$var$constrainTextWidth(layout, availableWidth, forceRecalculate) {
    if (forceRecalculate === void 0) forceRecalculate = false;
    if (layout.labelStyleWidth != null) // User-defined style.width has the highest priority.
    return;
    var label = layout.label;
    var style = label.style;
    var textRect = layout.rect;
    var bgColor = style.backgroundColor;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var overflow = style.overflow;
    // textRect.width already contains paddingH if bgColor is set
    var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
    if (availableWidth < oldOuterWidth || forceRecalculate) {
        var oldHeight = textRect.height;
        if (overflow && overflow.match("break")) {
            // Temporarily set background to be null to calculate
            // the bounding box without background.
            label.setStyle("backgroundColor", null);
            // Set constraining width
            label.setStyle("width", availableWidth - paddingH);
            // This is the real bounding box of the text without padding.
            var innerRect = label.getBoundingRect();
            label.setStyle("width", Math.ceil(innerRect.width));
            label.setStyle("backgroundColor", bgColor);
        } else {
            var availableInnerWidth = availableWidth - paddingH;
            var newWidth = availableWidth < oldOuterWidth ? availableInnerWidth : // Current available width is enough, but the text may have
            // already been wrapped with a smaller available width.
            forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth ? null : availableInnerWidth : null;
            label.setStyle("width", newWidth);
        }
        var newRect = label.getBoundingRect();
        textRect.width = newRect.width;
        var margin = (label.style.margin || 0) + 2.1;
        textRect.height = newRect.height + margin;
        textRect.y -= (textRect.height - oldHeight) / 2;
    }
}
function $4b109d23b790ee9a$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === "center";
}
function $4b109d23b790ee9a$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get("minShowLabelAngle") || 0) * $4b109d23b790ee9a$var$RADIAN;
    var viewRect = data.getLayout("viewRect");
    var r = data.getLayout("r");
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label");
        // Use position in normal or emphasis
        var labelPosition = labelModel.get("position") || itemModel.get([
            "emphasis",
            "label",
            "position"
        ]);
        var labelDistance = labelModel.get("distanceToLabelLine");
        var labelAlignTo = labelModel.get("alignTo");
        var edgeDistance = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelModel.get("edgeDistance"), viewWidth);
        var bleedMargin = labelModel.get("bleedMargin");
        var labelLineModel = itemModel.getModel("labelLine");
        var labelLineLen = labelLineModel.get("length");
        labelLineLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get("length2");
        labelLineLen2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(label.states, setNotShow);
            label.ignore = true;
            if (labelLine) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            }
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === "inside" || labelPosition === "inner";
        if (labelPosition === "center") {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = "center";
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === "edge") // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? "center" : labelAlignTo === "edge" ? nx > 0 ? "right" : "left" : nx > 0 ? "left" : "right";
        }
        var PI = Math.PI;
        var labelRotate = 0;
        var rotate = labelModel.get("rotate");
        if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotate)) labelRotate = rotate * (PI / 180);
        else if (labelPosition === "center") labelRotate = 0;
        else if (rotate === "radial" || rotate === true) {
            var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
            labelRotate = radialAngle;
        } else if (rotate === "tangential" && labelPosition !== "outside" && labelPosition !== "outer") {
            var rad = Math.atan2(nx, ny);
            if (rad < 0) rad = PI * 2 + rad;
            var isDown = ny > 0;
            if (isDown) rad = PI + rad;
            labelRotate = rad - PI;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: "middle"
        });
        // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = label.getBoundingRect().clone();
            textRect.applyTransform(label.getComputedTransform());
            // Text has a default 1px stroke. Exclude this.
            var margin = (label.style.margin || 0) + 2.1;
            textRect.y -= margin / 2;
            textRect.height += margin;
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get("minTurnAngle"),
                maxSurfaceAngle: labelLineModel.get("maxSurfaceAngle"),
                surfaceNormal: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect,
                unconstrainedWidth: textRect.width,
                labelStyleWidth: label.style.width
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get("avoidLabelOverlap")) $4b109d23b790ee9a$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $f4eb87a228be297f$export$ac52062003fbe6a)(linePoints, layout.minTurnAngle);
                (0, $f4eb87a228be297f$export$973e1fdb2708f71b)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                });
                // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}







/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $773d25f97e67400e$var$PiePiece = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel("emphasis");
        var layout = data.getItemLayout(idx);
        // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), layout, true), layout);
        // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow("animationType");
            if (seriesModel.ecModel.ssr) {
                // Use scale animation in SSR mode(opacity?)
                // Because CSS SVG animation doesn't support very customized shape animation.
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    scaleX: 0,
                    scaleY: 0
                }, seriesModel, {
                    dataIndex: idx,
                    isFrom: true
                });
                sector.originX = sectorShape.cx;
                sector.originY = sectorShape.cy;
            } else if (animationType === "scale") {
                sector.shape.r = layout.r0;
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(sector);
            // Transition animation from the old shape
            $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, "style"));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get("selectedOffset");
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow("cursor");
        cursorStyle && sector.attr("cursor", cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState("emphasis").shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            r: layout.r + (emphasisModel.get("scale") ? emphasisModel.get("scaleSize") || 0 : 0)
        }, (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(emphasisModel.getModel("itemStyle"), layout));
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sector.ensureState("select"), {
            x: dx,
            y: dy,
            shape: (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel([
                "select",
                "itemStyle"
            ]), layout)
        });
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sector.ensureState("blur"), {
            shape: (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel([
                "blur",
                "itemStyle"
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(labelLine.ensureState("select"), {
            x: dx,
            y: dy
        });
        // TODO: needs dx, dy in zrender?
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(labelText.ensureState("select"), {
            x: dx,
            y: dy
        });
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel("labelLine");
        var style = data.getItemVisual(idx, "style");
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(sector, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, "normal") || data.getName(idx)
        });
        var labelText = sector.getTextContent();
        // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        });
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = seriesModel.get([
            "label",
            "position"
        ]);
        if (labelPosition !== "outside" && labelPosition !== "outer") sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $d28119f30e6bb670$export$2e2bcd8739ae039();
                this.setTextGuideLine(polyline);
            }
            // Default use item visual color
            (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(this, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), {
                stroke: visualColor,
                opacity: (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(labelLineModel.get([
                    "lineStyle",
                    "opacity"
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
// Pie view
var $773d25f97e67400e$var$PieView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle;
        // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        }
        // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
        // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get("showEmptyCircle")) {
            var sector = new $a3e1dec0a3875b49$export$2e2bcd8739ae039({
                shape: (0, $21576fcf4c669316$export$2a0d4d5b12383eb9)(seriesModel, api)
            });
            sector.useStyle(seriesModel.getModel("emptyCircleStyle").getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $773d25f97e67400e$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off("click");
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $8b353638fbedfefa$export$6d0fd725cb4aee8a(piePiece, seriesModel, idx);
        }).execute();
        (0, $4b109d23b790ee9a$export$2e2bcd8739ae039)(seriesModel);
        // Always use initial animation.
        if (seriesModel.get("animationTypeUpdate") !== "expansion") this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = "pie";
    return PieView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $773d25f97e67400e$export$2e2bcd8739ae039 = $773d25f97e67400e$var$PieView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $7e5c3511527c9907$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(opt) && {
        coordDimensions: opt
    } || (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(source, opt).dimensions;
    var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $cf24728fc17c4ab6$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(// Function to get data after filtered. It stores all the encoding info
    getDataWithEncodedVisual, // Function to get raw data before filtered.
    getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData();
        // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $cf24728fc17c4ab6$export$2e2bcd8739ae039 = $cf24728fc17c4ab6$var$LegendVisualProvider;



var $9de67b16c98ecc62$var$innerData = $76d619f648247e6d$export$64df9f8d92ae083f();
var $9de67b16c98ecc62$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PieSeriesModel, _super);
    function PieSeriesModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        // update seats when data is changed
        var dataInner = $9de67b16c98ecc62$var$innerData(data);
        var seats = dataInner.seats;
        if (!seats) {
            var valueList_1 = [];
            data.each(data.mapDimension("value"), function(value) {
                valueList_1.push(value);
            });
            seats = dataInner.seats = (0, $cfc1f3b422a3185f$export$222dabb13d5320df)(valueList_1, data.hostModel.get("percentPrecision"));
        }
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        // seats may be empty when sum is 0
        params.percent = seats[dataIndex] || 0;
        params.$vars.push("percent");
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = "series.pie";
    PieSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: "data",
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "75%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        endAngle: "auto",
        padAngle: 0,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: "truncate",
            // 'outer', 'inside', 'center'
            position: "outer",
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: "none",
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: "25%",
            // Works only position is 'outer' and alignTo is not 'edge'.
            bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 15,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: "solid"
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: "round"
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: "lightgray",
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: "expansion",
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: "transition",
        animationEasingUpdate: "cubicInOut",
        animationDurationUpdate: 500,
        animationEasing: "cubicInOut"
    };
    return PieSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $9de67b16c98ecc62$export$2e2bcd8739ae039 = $9de67b16c98ecc62$var$PieSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $10dfc09d63e54240$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension("value");
                var curValue = data.get(valueDim, idx);
                if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(curValue) && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}


function $6b7ead9b40180cba$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $773d25f97e67400e$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $9de67b16c98ecc62$export$2e2bcd8739ae039));
    (0, $e855ccf7eff48bce$export$62942ba95693dbfc)("pie", registers.registerAction);
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $21576fcf4c669316$export$2e2bcd8739ae039), "pie"));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("pie"));
    registers.registerProcessor((0, $10dfc09d63e54240$export$2e2bcd8739ae039)("pie"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $00ab9646b588965f$var$ScatterSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ScatterSeriesModel, _super);
    function ScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    ScatterSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get("progressive");
        return progressive;
    };
    ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get("progressiveThreshold");
        return progressiveThreshold;
    };
    ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    ScatterSeriesModel.prototype.getZLevelKey = function() {
        // Each progressive series has individual key.
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : "";
    };
    ScatterSeriesModel.type = "series.scatter";
    ScatterSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ];
    ScatterSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        symbolSize: 10,
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        itemStyle: {
            opacity: 0.8
        },
        emphasis: {
            scale: true
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true,
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        },
        universalTransition: {
            divideShape: "clone"
        }
    };
    return ScatterSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $00ab9646b588965f$export$2e2bcd8739ae039 = $00ab9646b588965f$var$ScatterSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD = 4;
var $69bbf770a3ca2c75$var$LargeSymbolPathShape = /** @class */ function() {
    function LargeSymbolPathShape() {}
    return LargeSymbolPathShape;
}();
var $69bbf770a3ca2c75$var$LargeSymbolPath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LargeSymbolPath, _super);
    function LargeSymbolPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeSymbolPath.prototype.getDefaultShape = function() {
        return new $69bbf770a3ca2c75$var$LargeSymbolPathShape();
    };
    LargeSymbolPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeSymbolPath.prototype.buildPath = function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD;
        var softClipShape = this.softClipShape;
        var i;
        // Do draw in afterBrush.
        if (canBoost) {
            this._ctx = ctx;
            return;
        }
        this._ctx = null;
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.afterBrush = function() {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var ctx = this._ctx;
        var softClipShape = this.softClipShape;
        var i;
        if (!ctx) return;
        // PENDING If style or other canvas status changed?
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.findDataIndex = function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4);
        // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    };
    LargeSymbolPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeSymbolPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.points;
            var size = shape.size;
            var w = size[0];
            var h = size[1];
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $1bebe7106c895823$export$2e2bcd8739ae039(minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
        }
        return rect;
    };
    return LargeSymbolPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $69bbf770a3ca2c75$var$LargeSymbolDraw = /** @class */ function() {
    function LargeSymbolDraw() {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeSymbolDraw.prototype.updateData = function(data, opt) {
        this._clear();
        var symbolEl = this._create();
        symbolEl.setShape({
            points: data.getLayout("points")
        });
        this._setCommon(symbolEl, data, opt);
    };
    LargeSymbolDraw.prototype.updateLayout = function(data) {
        var points = data.getLayout("points");
        this.group.eachChild(function(child) {
            if (child.startIndex != null) {
                var len = (child.endIndex - child.startIndex) * 2;
                var byteOffset = child.startIndex * 8;
                points = new Float32Array(points.buffer, byteOffset, len);
            }
            child.setShape("points", points);
            // Reset draw cursor.
            child.reset();
        });
    };
    LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._clear();
    };
    LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        var lastAdded = this._newAdded[0];
        var points = data.getLayout("points");
        var oldPoints = lastAdded && lastAdded.shape.points;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldPoints && oldPoints.length < 2e4) {
            var oldLen = oldPoints.length;
            var newPoints = new Float32Array(oldLen + points.length);
            // Concat two array
            newPoints.set(oldPoints);
            newPoints.set(points, oldLen);
            // Update endIndex
            lastAdded.endIndex = taskParams.end;
            lastAdded.setShape({
                points: newPoints
            });
        } else {
            // Clear
            this._newAdded = [];
            var symbolEl = this._create();
            symbolEl.startIndex = taskParams.start;
            symbolEl.endIndex = taskParams.end;
            symbolEl.incremental = true;
            symbolEl.setShape({
                points: points
            });
            this._setCommon(symbolEl, data, opt);
        }
    };
    LargeSymbolDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeSymbolDraw.prototype._create = function() {
        var symbolEl = new $69bbf770a3ca2c75$var$LargeSymbolPath({
            cursor: "default"
        });
        symbolEl.ignoreCoarsePointer = true;
        this.group.add(symbolEl);
        this._newAdded.push(symbolEl);
        return symbolEl;
    };
    LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, opt) {
        var hostModel = data.hostModel;
        opt = opt || {};
        var size = data.getVisual("symbolSize");
        symbolEl.setShape("size", size instanceof Array ? size : [
            size,
            size
        ]);
        symbolEl.softClipShape = opt.clipShape || null;
        // Create symbolProxy to build path for each data
        symbolEl.symbolProxy = (0, $5370466dadc978d7$export$af050e04da3a02e8)(data.getVisual("symbol"), 0, 0, 0, 0);
        // Use symbolProxy setColor method
        symbolEl.setColor = symbolEl.symbolProxy.setColor;
        var extrudeShadow = symbolEl.shape.size[0] < $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD;
        symbolEl.useStyle(// Draw shadow when doing fillRect is extremely slow.
        hostModel.getModel("itemStyle").getItemStyle(extrudeShadow ? [
            "color",
            "shadowBlur",
            "shadowColor"
        ] : [
            "color"
        ]));
        var globalStyle = data.getVisual("style");
        var visualColor = globalStyle && globalStyle.fill;
        if (visualColor) symbolEl.setColor(visualColor);
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(symbolEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        symbolEl.on("mousemove", function(e) {
            ecData.dataIndex = null;
            var dataIndex = symbolEl.hoverDataIdx;
            if (dataIndex >= 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
        });
    };
    LargeSymbolDraw.prototype.remove = function() {
        this._clear();
    };
    LargeSymbolDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeSymbolDraw;
}();
var $69bbf770a3ca2c75$export$2e2bcd8739ae039 = $69bbf770a3ca2c75$var$LargeSymbolDraw;




var $c92a7ada0c69ef68$var$ScatterView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ScatterView, _super);
    function ScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterView.type;
        return _this;
    }
    ScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    };
    ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    };
    ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4) return {
            update: true
        };
        else {
            var res = (0, $73b014aa594ea652$export$2e2bcd8739ae039)("").reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    };
    ScatterView.prototype.eachRendered = function(cb) {
        this._symbolDraw && this._symbolDraw.eachRendered(cb);
    };
    ScatterView.prototype._getClipShape = function(seriesModel) {
        if (!seriesModel.get("clip", true)) return;
        var coordSys = seriesModel.coordinateSystem;
        // PENDING make `0.1` configurable, for example, `clipTolerance`?
        return coordSys && coordSys.getArea && coordSys.getArea(.1);
    };
    ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new (0, $69bbf770a3ca2c75$export$2e2bcd8739ae039)() : new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    };
    ScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    };
    ScatterView.prototype.dispose = function() {};
    ScatterView.type = "scatter";
    return ScatterView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $c92a7ada0c69ef68$export$2e2bcd8739ae039 = $c92a7ada0c69ef68$var$ScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $d67c268180aaad04$var$GridModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.type = "grid";
    GridModel.dependencies = [
        "xAxis",
        "yAxis"
    ];
    GridModel.layoutMode = "box";
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: "10%",
        top: 60,
        right: "10%",
        bottom: 70,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: "rgba(0,0,0,0)",
        borderWidth: 1,
        borderColor: "#ccc"
    };
    return GridModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $d67c268180aaad04$export$2e2bcd8739ae039 = $d67c268180aaad04$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $3449fd4c0590d99e$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();



var $008426c98740266e$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = "cartesian2dAxis";
    return CartesianAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($008426c98740266e$export$483dc37e6ad83a3c, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $008426c98740266e$export$2e2bcd8739ae039 = $008426c98740266e$export$483dc37e6ad83a3c;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ad861b9162f24222$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: "",
    // 'start' | 'middle' | 'end'
    nameLocation: "end",
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: "...",
        placeholder: "."
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: "#6E7079",
            width: 1,
            type: "solid"
        },
        // The arrow at both ends the the axis.
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        lineStyle: {
            color: [
                "#E0E6F1"
            ],
            width: 1,
            type: "solid"
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                "rgba(250,250,250,0.2)",
                "rgba(210,219,238,0.2)"
            ]
        }
    }
};
var $ad861b9162f24222$var$categoryAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: "auto"
    },
    axisLabel: {
        interval: "auto"
    }
}, $ad861b9162f24222$var$defaultOption);
var $ad861b9162f24222$var$valueAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: "auto"
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: "auto"
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: "#F4F7FD",
            width: 1
        }
    }
}, $ad861b9162f24222$var$defaultOption);
var $ad861b9162f24222$var$timeAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: "bold"
            }
        }
    },
    splitLine: {
        show: false
    }
}, $ad861b9162f24222$var$valueAxis);
var $ad861b9162f24222$var$logAxis = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
    logBase: 10
}, $ad861b9162f24222$var$valueAxis);
var $ad861b9162f24222$export$2e2bcd8739ae039 = {
    category: $ad861b9162f24222$var$categoryAxis,
    value: $ad861b9162f24222$var$valueAxis,
    time: $ad861b9162f24222$var$timeAxis,
    log: $ad861b9162f24222$var$logAxis
};



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $57fe7cbbaae9fab0$var$uidBase = 0;
var $57fe7cbbaae9fab0$var$OrdinalMeta = /** @class */ function() {
    function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$57fe7cbbaae9fab0$var$uidBase;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data, $57fe7cbbaae9fab0$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        // @ts-ignore
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            return index;
        }
        var map = this._getOrCreateMap();
        // @ts-ignore
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                // @ts-ignore
                map.set(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $57fe7cbbaae9fab0$var$getName(obj) {
    if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + "";
}
var $57fe7cbbaae9fab0$export$2e2bcd8739ae039 = $57fe7cbbaae9fab0$var$OrdinalMeta;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5dc621cc2f35ccb4$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};



function $c5c4c85259d60abe$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $5dc621cc2f35ccb4$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)({}, (0, $ad861b9162f24222$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + "Axis." + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option, themeModel.get(axisType + "Axis"));
                (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $c5c4c85259d60abe$var$getAxisType(option);
                if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === "category") this.__ordinalMeta = (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === "category") {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.type = axisName + "Axis." + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + "Axis", $c5c4c85259d60abe$var$getAxisType);
}
function $c5c4c85259d60abe$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? "category" : "value");
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1754de95b9b9c398$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]);
    // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get extent
   *
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set extent
   */ Scale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$cd5f95cf03b4e3e7$export$241315e45585454d($1754de95b9b9c398$var$Scale);
var $1754de95b9b9c398$export$2e2bcd8739ae039 = $1754de95b9b9c398$var$Scale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $60f7f1f3e3996637$export$a8a5b03ea14764df(val) {
    var exp10 = Math.pow(10, (0, $cfc1f3b422a3185f$export$97256a17b20a0c24)(Math.abs(val)));
    var f = Math.abs(val / exp10);
    return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function $60f7f1f3e3996637$export$dfc8cd28ed7b22a0(scale) {
    return scale.type === "interval" || scale.type === "log";
}
function $60f7f1f3e3996637$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = (0, $cfc1f3b422a3185f$export$7a695fe44258210b)(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    // Tow more digital for tick.
    var precision = result.intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.ceil(extent[0] / interval) * interval, precision),
        (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $60f7f1f3e3996637$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $60f7f1f3e3996637$export$f39031e8422f329d(interval) {
    var exp10 = Math.pow(10, (0, $cfc1f3b422a3185f$export$97256a17b20a0c24)(interval));
    // Increase interval
    var f = interval / exp10;
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    return (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(f * exp10);
}
function $60f7f1f3e3996637$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(interval) + 2;
}
function $60f7f1f3e3996637$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
}
function $60f7f1f3e3996637$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $60f7f1f3e3996637$var$clamp(niceTickExtent, 0, extent);
    $60f7f1f3e3996637$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $60f7f1f3e3996637$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
function $60f7f1f3e3996637$export$a3295358bff77e(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $60f7f1f3e3996637$export$dcdf75081b88279d(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}



var $6e82606ec775d365$var$OrdinalScale = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = "ordinal";
        var ordinalMeta = _this.getSetting("ordinalMeta");
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({});
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({
            categories: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting("extent") || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) return NaN;
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val) ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(rank) {
        rank = this.parse(rank);
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(this.parse(val));
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round($60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? "" : cateogry + "";
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.calcNiceTicks = function() {};
    OrdinalScale.prototype.calcNiceExtent = function() {};
    OrdinalScale.type = "ordinal";
    return OrdinalScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($6e82606ec775d365$var$OrdinalScale);
var $6e82606ec775d365$export$2e2bcd8739ae039 = $6e82606ec775d365$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $dddb89ade16db3d5$var$roundNumber = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $dddb89ade16db3d5$var$IntervalScale = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "interval";
        // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        return val;
    };
    IntervalScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
    };
    IntervalScale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        // start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    };
    IntervalScale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]);
        // unionExtent may called by it's sub classes
        this.setExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval;
        // Dropped auto calculated niceExtent and use user-set extent.
        // We assume user wants to set both interval, min, max to get a better result.
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(interval);
    };
    /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push({
                value: $dddb89ade16db3d5$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = $dddb89ade16db3d5$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push({
                value: $dddb89ade16db3d5$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $dddb89ade16db3d5$var$roundNumber(prevTick.value + (count + 1) * minorInterval);
                // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return "";
        var precision = opt && opt.precision;
        if (precision == null) precision = $cfc1f3b422a3185f$export$e0c74b50bbd10f68(data.value) || 0;
        else if (precision === "auto") // Should be more precise then tick.
        precision = this._intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $dddb89ade16db3d5$var$roundNumber(data.value, precision, true);
        return $c84c9521536c601a$export$b6fe44657ce35c42(dataNum);
    };
    /**
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.calcNiceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
        // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $60f7f1f3e3996637$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent;
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                // Note that extents can be both negative. See #13154
                var expandSize = Math.abs(extent[0]);
                // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0];
        // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        // let extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $dddb89ade16db3d5$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $dddb89ade16db3d5$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    };
    IntervalScale.prototype.setNiceExtent = function(min, max) {
        this._niceExtent = [
            min,
            max
        ];
    };
    IntervalScale.type = "interval";
    return IntervalScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($dddb89ade16db3d5$var$IntervalScale);
var $dddb89ade16db3d5$export$2e2bcd8739ae039 = $dddb89ade16db3d5$var$IntervalScale;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







// FIXME 公用？
var $7729d7ac367e621c$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $7729d7ac367e621c$var$TimeScale = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = "time";
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting("useUTC");
        return (0, $0ae0381fb3fd176f$export$d9468344d3651243)(tick.value, (0, $0ae0381fb3fd176f$export$445bdbd8d2334e40)[(0, $0ae0381fb3fd176f$export$124c820721c4f66b)((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $0ae0381fb3fd176f$export$445bdbd8d2334e40).second, useUTC, this.getSetting("locale"));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting("useUTC");
        var lang = this.getSetting("locale");
        return (0, $0ae0381fb3fd176f$export$fe777b6293828b5d)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   */ TimeScale.prototype.getTicks = function() {
        var interval = this._interval;
        var extent = this._extent;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        ticks.push({
            value: extent[0],
            level: 0
        });
        var useUTC = this.getSetting("useUTC");
        var innerTicks = $7729d7ac367e621c$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
        ticks = ticks.concat(innerTicks);
        ticks.push({
            value: extent[1],
            level: 0
        });
        return ticks;
    };
    TimeScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent;
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
            extent[1] += (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
        }
        // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
        }
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.calcNiceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $7729d7ac367e621c$var$scaleIntervals.length;
        var idx = Math.min($7729d7ac367e621c$var$bisect($7729d7ac367e621c$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
        // Interval that can be used to calculate ticks
        this._interval = $7729d7ac367e621c$var$scaleIntervals[idx][1];
        // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $7729d7ac367e621c$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(val) ? val : +$cfc1f3b422a3185f$export$6b862160d295c8e(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(this.parse(val), this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return $60f7f1f3e3996637$export$a3295358bff77e(this.parse(val), this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
    };
    TimeScale.type = "time";
    return TimeScale;
}((0, $dddb89ade16db3d5$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $7729d7ac367e621c$var$scaleIntervals = [
    // Format                           interval
    [
        "second",
        (0, $0ae0381fb3fd176f$export$32c0454ceff7f92d)
    ],
    [
        "minute",
        (0, $0ae0381fb3fd176f$export$35acaebf644db34e)
    ],
    [
        "hour",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0)
    ],
    [
        "quarter-day",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0) * 6
    ],
    [
        "half-day",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0) * 12
    ],
    [
        "day",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 1.2
    ],
    [
        "half-week",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 3.5
    ],
    [
        "week",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 7
    ],
    [
        "month",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 31
    ],
    [
        "quarter",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 95
    ],
    [
        "half-year",
        (0, $0ae0381fb3fd176f$export$99cafda57477293d) / 2
    ],
    [
        "year",
        (0, $0ae0381fb3fd176f$export$99cafda57477293d)
    ] // 1Y
];
function $7729d7ac367e621c$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
    var dateA = $cfc1f3b422a3185f$export$6b862160d295c8e(valueA);
    var dateB = $cfc1f3b422a3185f$export$6b862160d295c8e(valueB);
    var isSame = function(unit) {
        return (0, $0ae0381fb3fd176f$export$e04e41a1e24ffd3f)(dateA, unit, isUTC) === (0, $0ae0381fb3fd176f$export$e04e41a1e24ffd3f)(dateB, unit, isUTC);
    };
    var isSameYear = function() {
        return isSame("year");
    };
    // const isSameHalfYear = () => isSameYear() && isSame('half-year');
    // const isSameQuater = () => isSameYear() && isSame('quarter');
    var isSameMonth = function() {
        return isSameYear() && isSame("month");
    };
    var isSameDay = function() {
        return isSameMonth() && isSame("day");
    };
    // const isSameHalfDay = () => isSameDay() && isSame('half-day');
    var isSameHour = function() {
        return isSameDay() && isSame("hour");
    };
    var isSameMinute = function() {
        return isSameHour() && isSame("minute");
    };
    var isSameSecond = function() {
        return isSameMinute() && isSame("second");
    };
    var isSameMilliSecond = function() {
        return isSameSecond() && isSame("millisecond");
    };
    switch(unit){
        case "year":
            return isSameYear();
        case "month":
            return isSameMonth();
        case "day":
            return isSameDay();
        case "hour":
            return isSameHour();
        case "minute":
            return isSameMinute();
        case "second":
            return isSameSecond();
        case "millisecond":
            return isSameMilliSecond();
    }
}
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $7729d7ac367e621c$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $0ae0381fb3fd176f$export$35acaebf644db34e) : (0, $0ae0381fb3fd176f$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMillisecondsInterval(approxInterval) {
    return $cfc1f3b422a3185f$export$7a695fe44258210b(approxInterval, true);
}
function $7729d7ac367e621c$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
    var outDate = new Date(date);
    switch((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitName)){
        case "year":
        case "month":
            outDate[(0, $0ae0381fb3fd176f$export$233f59998ed71c09)(isUTC)](0);
        case "day":
            outDate[(0, $0ae0381fb3fd176f$export$82fd379a67f37fa0)(isUTC)](1);
        case "hour":
            outDate[(0, $0ae0381fb3fd176f$export$b6f943e8d23c15bb)(isUTC)](0);
        case "minute":
            outDate[(0, $0ae0381fb3fd176f$export$50303078793fc7d)(isUTC)](0);
        case "second":
            outDate[(0, $0ae0381fb3fd176f$export$a4a908acda9c3118)(isUTC)](0);
            outDate[(0, $0ae0381fb3fd176f$export$c047afab75f6d84)(isUTC)](0);
    }
    return outDate.getTime();
}
function $7729d7ac367e621c$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
    var safeLimit = 10000;
    var unitNames = (0, $0ae0381fb3fd176f$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var date = new Date(minTimestamp);
        var dateTime = minTimestamp;
        var d = date[getMethodName]();
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            d += interval;
            date[setMethodName](d);
            dateTime = date.getTime();
        }
        // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($7729d7ac367e621c$var$isUnitValueSame((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                // TODO Optimize. Not include so may ticks.
                value: $7729d7ac367e621c$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case "year":
                    interval = Math.max(1, Math.round(approxInterval / (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $0ae0381fb3fd176f$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$43fbeac90913b151)(isUTC);
                    break;
                case "half-year":
                case "quarter":
                case "month":
                    interval = $7729d7ac367e621c$var$getMonthInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$233f59998ed71c09)(isUTC);
                    break;
                case "week":
                case "half-week":
                case "day":
                    interval = $7729d7ac367e621c$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $0ae0381fb3fd176f$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case "half-day":
                case "quarter-day":
                case "hour":
                    interval = $7729d7ac367e621c$var$getHourInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case "minute":
                    interval = $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $0ae0381fb3fd176f$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$50303078793fc7d)(isUTC);
                    break;
                case "second":
                    interval = $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $0ae0381fb3fd176f$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$a4a908acda9c3118)(isUTC);
                    break;
                case "millisecond":
                    interval = $7729d7ac367e621c$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$312207a92d041116)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$c047afab75f6d84)(isUTC);
                    break;
            }
            addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === "year" && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
        // newAddedTicks.length && console.log(unitName, newAddedTicks);
        return newAddedTicks;
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
        var primaryTimeUnit = (0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $0ae0381fb3fd176f$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = (extent[1] - extent[0]) / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k)ticks.push({
            value: levelTicks[k].value,
            level: maxLevel - i
        });
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($7729d7ac367e621c$var$TimeScale);
var $7729d7ac367e621c$export$2e2bcd8739ae039 = $7729d7ac367e621c$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $ae24d1f3a7f905fc$var$scaleProto = (0, $1754de95b9b9c398$export$2e2bcd8739ae039).prototype;
// FIXME:TS refactor: not good to call it directly with `this`?
var $ae24d1f3a7f905fc$var$intervalScaleProto = (0, $dddb89ade16db3d5$export$2e2bcd8739ae039).prototype;
var $ae24d1f3a7f905fc$var$roundingErrorFix = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $ae24d1f3a7f905fc$var$mathFloor = Math.floor;
var $ae24d1f3a7f905fc$var$mathCeil = Math.ceil;
var $ae24d1f3a7f905fc$var$mathPow = Math.pow;
var $ae24d1f3a7f905fc$var$mathLog = Math.log;
var $ae24d1f3a7f905fc$var$LogScale = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "log";
        _this.base = 10;
        _this._originalScale = new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
        // FIXME:TS actually used by `IntervalScale`
        _this._interval = 0;
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        var ticks = $ae24d1f3a7f905fc$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(tick) {
            var val = tick.value;
            var powVal = $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathPow(this.base, val));
            // Fix #4158
            powVal = val === extent[0] && this._fixMin ? $ae24d1f3a7f905fc$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && this._fixMax ? $ae24d1f3a7f905fc$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return {
                value: powVal
            };
        }, this);
    };
    LogScale.prototype.setExtent = function(start, end) {
        var base = $ae24d1f3a7f905fc$var$mathLog(this.base);
        // log(-Infinity) is NaN, so safe guard here
        start = $ae24d1f3a7f905fc$var$mathLog(Math.max(0, start)) / base;
        end = $ae24d1f3a7f905fc$var$mathLog(Math.max(0, end)) / base;
        $ae24d1f3a7f905fc$var$intervalScaleProto.setExtent.call(this, start, end);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = $ae24d1f3a7f905fc$var$scaleProto.getExtent.call(this);
        extent[0] = $ae24d1f3a7f905fc$var$mathPow(base, extent[0]);
        extent[1] = $ae24d1f3a7f905fc$var$mathPow(base, extent[1]);
        // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        this._fixMin && (extent[0] = $ae24d1f3a7f905fc$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $ae24d1f3a7f905fc$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtent = function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $ae24d1f3a7f905fc$var$mathLog(extent[0]) / $ae24d1f3a7f905fc$var$mathLog(base);
        extent[1] = $ae24d1f3a7f905fc$var$mathLog(extent[1]) / $ae24d1f3a7f905fc$var$mathLog(base);
        $ae24d1f3a7f905fc$var$scaleProto.unionExtent.call(this, extent);
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.calcNiceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $cfc1f3b422a3185f$export$82dd68b83a44b253(span);
        var err = approxTickNum / span * interval;
        // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
        // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathCeil(extent[0] / interval) * interval),
            $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.calcNiceExtent = function(opt) {
        $ae24d1f3a7f905fc$var$intervalScaleProto.calcNiceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.parse = function(val) {
        return val;
    };
    LogScale.prototype.contain = function(val) {
        val = $ae24d1f3a7f905fc$var$mathLog(val) / $ae24d1f3a7f905fc$var$mathLog(this.base);
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent);
    };
    LogScale.prototype.normalize = function(val) {
        val = $ae24d1f3a7f905fc$var$mathLog(val) / $ae24d1f3a7f905fc$var$mathLog(this.base);
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    LogScale.prototype.scale = function(val) {
        val = $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
        return $ae24d1f3a7f905fc$var$mathPow(this.base, val);
    };
    LogScale.type = "log";
    return LogScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
var $ae24d1f3a7f905fc$var$proto = $ae24d1f3a7f905fc$var$LogScale.prototype;
$ae24d1f3a7f905fc$var$proto.getMinorTicks = $ae24d1f3a7f905fc$var$intervalScaleProto.getMinorTicks;
$ae24d1f3a7f905fc$var$proto.getLabel = $ae24d1f3a7f905fc$var$intervalScaleProto.getLabel;
function $ae24d1f3a7f905fc$var$fixRoundingError(val, originalVal) {
    return $ae24d1f3a7f905fc$var$roundingErrorFix(val, $cfc1f3b422a3185f$export$e0c74b50bbd10f68(originalVal));
}
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($ae24d1f3a7f905fc$var$LogScale);
var $ae24d1f3a7f905fc$export$2e2bcd8739ae039 = $ae24d1f3a7f905fc$var$LogScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $483be9695e74220c$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
    originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on outside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, // Usually: data extent from all series on this axis.
    dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === "ordinal";
        this._needCrossZero = scale.type === "interval" && model.getNeedCrossZero && model.getNeedCrossZero();
        var modelMinRaw = this._modelMinRaw = model.get("min", true);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(modelMinRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMinNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== "dataMin") this._modelMinNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get("max", true);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(modelMaxRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMaxNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== "dataMax") this._modelMaxNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get("boundaryGap");
            var boundaryGapArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === "boolean" || typeof boundaryGapArr[1] === "boolean") this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(boundaryGapArr[0], 1),
                (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
        // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === "dataMin" ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === "dataMax" ? dataMax : this._modelMaxNum;
        // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        var isBlank = (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(min) || (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(max) || isOrdinal && !axisDataLen;
        // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0;
            // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0;
        // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        }
        // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$483be9695e74220c$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $483be9695e74220c$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $483be9695e74220c$var$DETERMINED_MIN_MAX_ATTR = {
    min: "_determinedMin",
    max: "_determinedMax"
};
var $483be9695e74220c$var$DATA_MIN_MAX_ATTR = {
    min: "_dataMin",
    max: "_dataMax"
};
function $483be9695e74220c$export$5c3dbcbeb9ce7f5a(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $483be9695e74220c$export$c35454f678e99c82(scale, model, originalExtent);
    // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $483be9695e74220c$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(minMax) ? NaN : scale.parse(minMax);
}


function $2d646e51cc34f840$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $483be9695e74220c$export$5c3dbcbeb9ce7f5a)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max;
    // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === "time" /* || scaleType === 'interval' */ ) {
        var barSeriesModels = (0, $361c48dd900de28f$export$efbd0c3f5ab0d5e4)("bar", ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $361c48dd900de28f$export$20769dafc84e0299)(barSeriesModels);
            // Adjust axis min and max to account for overflow
            var adjustedScale = $2d646e51cc34f840$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $2d646e51cc34f840$var$adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = axisExtent[1] - axisExtent[0];
    // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $361c48dd900de28f$export$35920bb6556da1c2)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow;
    // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
}
function $2d646e51cc34f840$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $2d646e51cc34f840$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get("splitNumber");
    if (scale instanceof (0, $ae24d1f3a7f905fc$export$2e2bcd8739ae039)) scale.base = model.get("logBase");
    var scaleType = scale.type;
    var interval = model.get("interval");
    var isIntervalOrTime = scaleType === "interval" || scaleType === "time";
    scale.setExtent(extent[0], extent[1]);
    scale.calcNiceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: isIntervalOrTime ? model.get("minInterval") : null,
        maxInterval: isIntervalOrTime ? model.get("maxInterval") : null
    });
    // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $2d646e51cc34f840$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get("type");
    if (axisType) switch(axisType){
        // Buildin scale
        case "category":
            return new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case "time":
            return new (0, $7729d7ac367e621c$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get("useUTC")
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $1754de95b9b9c398$export$2e2bcd8739ae039).getClass(axisType) || (0, $dddb89ade16db3d5$export$2e2bcd8739ae039))();
    }
}
function $2d646e51cc34f840$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $2d646e51cc34f840$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get("formatter");
    var categoryTickStart = axis.type === "category" ? axis.scale.getExtent()[0] : null;
    if (axis.scale.type === "time") return function(tpl) {
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, tpl);
        };
    }(labelFormatter);
    else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(labelFormatter)) return function(tpl) {
        return function(tick) {
            // For category axis, get raw value; for numeric axis,
            // get formatted label like '1,333,444'.
            var label = axis.scale.getLabel(tick);
            var text = tpl.replace("{value}", label != null ? label : "");
            return text;
        };
    }(labelFormatter);
    else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(labelFormatter)) return function(cb) {
        return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            if (categoryTickStart != null) idx = tick.value - categoryTickStart;
            return cb($2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                level: tick.level
            } : null);
        };
    }(labelFormatter);
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === "category" ? axis.scale.getLabel(tick) : tick.value;
}
function $2d646e51cc34f840$export$fef1c7f0af0b48d(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        "axisLabel",
        "show"
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent();
    // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $6e82606ec775d365$export$2e2bcd8739ae039)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $2d646e51cc34f840$export$742f19a75415b2ae(axis);
    var rect;
    var step = 1;
    // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $2d646e51cc34f840$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get("rotate") || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $2d646e51cc34f840$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var beforeWidth = textRect.width;
    var beforeHeight = textRect.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(textRect.x, textRect.y, afterWidth, afterHeight);
    return rotatedRect;
}
function $2d646e51cc34f840$export$6d0bc2429155c088(model) {
    var interval = model.get("interval");
    return interval == null ? "auto" : interval;
}
function $2d646e51cc34f840$export$c2911c025243d6a6(axis) {
    return axis.type === "category" && $2d646e51cc34f840$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $2d646e51cc34f840$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $efdd976e4917927c$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $7a1bd9c2710fea0d$export$ed97f33186d4b816(dataDimMap);
}
function $2d646e51cc34f840$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $7a1bd9c2710fea0d$export$79b2f7037acddd43($2d646e51cc34f840$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f0775b150bc00f28$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = "cartesian";
        this._dimList = [];
        this._axes = {};
        this.name = name || "";
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $7a1bd9c2710fea0d$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $f0775b150bc00f28$export$2e2bcd8739ae039 = $f0775b150bc00f28$var$Cartesian;




var $6bea838ef63ff2bb$export$988a008d2b9120f4 = [
    "x",
    "y"
];
function $6bea838ef63ff2bb$var$canCalculateAffineTransform(scale) {
    return scale.type === "interval" || scale.type === "time";
}
var $6bea838ef63ff2bb$var$Cartesian2D = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "cartesian2d";
        _this.dimensions = $6bea838ef63ff2bb$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis("x").scale;
        var yAxisScale = this.getAxis("y").scale;
        if (!$6bea838ef63ff2bb$var$canCalculateAffineTransform(xAxisScale) || !$6bea838ef63ff2bb$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAxis("x");
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis("x");
        var axisY = this.getAxis("y");
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis("x").containData(data[0]) && this.getAxis("y").containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // Fast path
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis("x").scale;
        var yScale = this.getAxis("y").scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp) {
        var out = [];
        if (this._invTransform) return (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === "x" ? "y" : "x");
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis("x").getGlobalExtent();
        var yExtent = this.getAxis("y").getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $f0775b150bc00f28$export$2e2bcd8739ae039));
var $6bea838ef63ff2bb$export$2e2bcd8739ae039 = $6bea838ef63ff2bb$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $6a439e51dccdc432$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6a439e51dccdc432$export$10216ebd3e3e485e(axis) {
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $6a439e51dccdc432$var$makeCategoryLabels(axis) : $6a439e51dccdc432$var$makeRealNumberLabels(axis);
}
function $6a439e51dccdc432$export$7cccf6836ae8323c(axis, tickModel) {
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $6a439e51dccdc432$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $7a1bd9c2710fea0d$export$871de8747c9eaa88(axis.scale.getTicks(), function(tick) {
            return tick.value;
        })
    };
}
function $6a439e51dccdc432$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get("show") || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $6a439e51dccdc432$var$getListCache(axis, "labels");
    var optionLabelInterval = (0, $2d646e51cc34f840$export$6d0bc2429155c088)(labelModel);
    var result = $6a439e51dccdc432$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionLabelInterval)) labels = $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === "auto" ? $6a439e51dccdc432$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6a439e51dccdc432$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $6a439e51dccdc432$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $6a439e51dccdc432$var$getListCache(axis, "ticks");
    var optionTickInterval = (0, $2d646e51cc34f840$export$6d0bc2429155c088)(tickModel);
    var result = $6a439e51dccdc432$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get("show") || axis.scale.isBlank()) ticks = [];
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionTickInterval)) ticks = $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === "auto") {
        var labelsResult = $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $7a1bd9c2710fea0d$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6a439e51dccdc432$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $6a439e51dccdc432$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    return {
        labels: $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                level: tick.level,
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value
            };
        })
    };
}
function $6a439e51dccdc432$var$getListCache(axis, prop) {
    // Because key can be a function, and cache size always is small, we use array cache.
    return $6a439e51dccdc432$var$inner(axis)[prop] || ($6a439e51dccdc432$var$inner(axis)[prop] = []);
}
function $6a439e51dccdc432$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $6a439e51dccdc432$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $6a439e51dccdc432$var$makeAutoCategoryInterval(axis) {
    var result = $6a439e51dccdc432$var$inner(axis).autoInterval;
    return result != null ? result : $6a439e51dccdc432$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
function $6a439e51dccdc432$export$9ea1d3f146a5a65f(axis) {
    var params = $6a439e51dccdc432$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $6c308355c7107803$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, "center", "top");
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $6a439e51dccdc432$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
    return interval;
}
function $6a439e51dccdc432$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get("rotate") || 0,
        font: labelModel.getFont()
    };
}
function $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = [];
    // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count();
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $2d646e51cc34f840$export$c2911c025243d6a6)(axis);
    var includeMinLabel = labelModel.get("showMinLabel") || showAllLabel;
    var includeMaxLabel = labelModel.get("showMaxLabel") || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
    // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue
        });
    }
    return result;
}
function $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var result = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}


var $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 */ var $c2b1efffe5ae3f42$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(data);
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $cfc1f3b422a3185f$export$666260d9a2dda8a7)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === "ordinal") {
            extent = extent.slice();
            $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data, $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === "ordinal") {
            extent = extent.slice();
            $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(coord, extent, $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $6a439e51dccdc432$export$7cccf6836ae8323c)(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === "ordinal" ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get("alignWithLabel");
        $c2b1efffe5ae3f42$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === "ordinal") // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel("minorTick");
        var splitNumber = minorTickModel.get("splitNumber");
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function() {
        return (0, $6a439e51dccdc432$export$10216ebd3e3e485e)(this).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel("axisLabel");
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel("axisTick");
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
        // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function() {
        return (0, $6a439e51dccdc432$export$9ea1d3f146a5a65f)(this);
    };
    return Axis;
}();
function $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
}
// If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $c2b1efffe5ae3f42$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[1]
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1];
    // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unnecessary tick added.
        a = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(a);
        b = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(b);
        return inverse ? a > b : a < b;
    }
}
var $c2b1efffe5ae3f42$export$2e2bcd8739ae039 = $c2b1efffe5ae3f42$var$Axis;


var $23369073c2236a8d$var$Axis2D = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || "value";
        _this.position = position || "bottom";
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === "x" ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== "category") return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $23369073c2236a8d$export$2e2bcd8739ae039 = $23369073c2236a8d$var$Axis2D;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $88c937c9bc0ca068$export$b3219800bda33a1f(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? "onZero" : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get("offset") || 0;
    var posBound = axisDim === "x" ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === "y" ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === "x" ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === "x" ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        "axisTick",
        "inside"
    ])) layout.tickDirection = -layout.tickDirection;
    if ($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        "axisLabel",
        "inside"
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        "axisLabel",
        "rotate"
    ]);
    layout.labelRotate = axisPosition === "top" ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $88c937c9bc0ca068$export$c2a0b77974c5e35d(seriesModel) {
    return seriesModel.get("coordinateSystem") === "cartesian2d";
}
function $88c937c9bc0ca068$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, "");
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0591b52263f31374$var$mathLog = Math.log;
function $0591b52263f31374$export$c0b3be0e9eb0c2d9(scale, axisModel, alignToScale) {
    var intervalScaleProto = (0, $dddb89ade16db3d5$export$2e2bcd8739ae039).prototype;
    // NOTE: There is a precondition for log scale  here:
    // In log scale we store _interval and _extent of exponent value.
    // So if we use the method of InternalScale to set/get these data.
    // It process the exponent value, which is linear and what we want here.
    var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
    var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, true);
    var alignToSplitNumber = alignToTicks.length - 1;
    var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
    var scaleExtent = (0, $2d646e51cc34f840$export$9c0ba8df7eb7b328)(scale, axisModel);
    var rawExtent = scaleExtent.extent;
    var isMinFixed = scaleExtent.fixMin;
    var isMaxFixed = scaleExtent.fixMax;
    if (scale.type === "log") {
        var logBase = $0591b52263f31374$var$mathLog(scale.base);
        rawExtent = [
            $0591b52263f31374$var$mathLog(rawExtent[0]) / logBase,
            $0591b52263f31374$var$mathLog(rawExtent[1]) / logBase
        ];
    }
    scale.setExtent(rawExtent[0], rawExtent[1]);
    scale.calcNiceExtent({
        splitNumber: alignToSplitNumber,
        fixMin: isMinFixed,
        fixMax: isMaxFixed
    });
    var extent = intervalScaleProto.getExtent.call(scale);
    // Need to update the rawExtent.
    // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'
    if (isMinFixed) rawExtent[0] = extent[0];
    if (isMaxFixed) rawExtent[1] = extent[1];
    var interval = intervalScaleProto.getInterval.call(scale);
    var min = rawExtent[0];
    var max = rawExtent[1];
    if (isMinFixed && isMaxFixed) // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
    else if (isMinFixed) {
        max = rawExtent[0] + interval * alignToSplitNumber;
        // User set min, expand extent on the other side
        while(max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])){
            interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
            max = rawExtent[0] + interval * alignToSplitNumber;
        }
    } else if (isMaxFixed) {
        // User set max, expand extent on the other side
        min = rawExtent[1] - interval * alignToSplitNumber;
        while(min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])){
            interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
            min = rawExtent[1] - interval * alignToSplitNumber;
        }
    } else {
        var nicedSplitNumber = scale.getTicks().length - 1;
        if (nicedSplitNumber > alignToSplitNumber) interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
        var range = interval * alignToSplitNumber;
        max = Math.ceil(rawExtent[1] / interval) * interval;
        min = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(max - range);
        // Not change the result that crossing zero.
        if (min < 0 && rawExtent[0] >= 0) {
            min = 0;
            max = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(range);
        } else if (max > 0 && rawExtent[1] <= 0) {
            max = 0;
            min = -(0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(range);
        }
    }
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
    var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval;
    // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.
    intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
    intervalScaleProto.setInterval.call(scale, interval);
    if (t0 || t1) intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
    var ticks;
}


var $8e1d1b12d8439742$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = "grid";
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $6bea838ef63ff2bb$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        function updateAxisTicks(axes) {
            var alignTo;
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(axes);
            var len = axesIndices.length;
            if (!len) return;
            var axisNeedsAlign = [];
            // Process once and calculate the ticks for those don't use alignTicks.
            for(var i = len - 1; i >= 0; i--){
                var idx = +axesIndices[i]; // Convert to number.
                var axis = axes[idx];
                var model = axis.model;
                var scale = axis.scale;
                if (// Only value and log axis without interval support alignTicks.
                (0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(scale) && model.get("alignTicks") && model.get("interval") == null) axisNeedsAlign.push(axis);
                else {
                    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(scale, model);
                    if ((0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(scale)) // Can only align to interval or log axis.
                    alignTo = axis;
                }
            }
            // All axes has set alignTicks. Pick the first one.
            // PENDING. Should we find the axis that both set interval, min, max and align to this one?
            if (axisNeedsAlign.length) {
                if (!alignTo) {
                    alignTo = axisNeedsAlign.pop();
                    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(alignTo.scale, alignTo.model);
                }
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                    (0, $0591b52263f31374$export$c0b3be0e9eb0c2d9)(axis.scale, axis.model, alignTo.scale);
                });
            }
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, "y", xAxis, onZeroRecords);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, "x", yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid
   */ Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
        var boxLayoutParams = gridModel.getBoxLayoutParams();
        var isContainLabel = !ignoreContainLabel && gridModel.get("containLabel");
        var gridRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._rect = gridRect;
        var axesList = this._axesList;
        adjustAxes();
        // Minus label size
        if (isContainLabel) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesList, function(axis) {
                if (!axis.model.get([
                    "axisLabel",
                    "inside"
                ])) {
                    var labelUnionRect = (0, $2d646e51cc34f840$export$fef1c7f0af0b48d)(axis);
                    if (labelUnionRect) {
                        var dim = axis.isHorizontal() ? "height" : "width";
                        var margin = axis.model.get([
                            "axisLabel",
                            "margin"
                        ]);
                        gridRect[dim] -= labelUnionRect[dim] + margin;
                        if (axis.position === "top") gridRect.y += labelUnionRect.height + margin;
                        else if (axis.position === "left") gridRect.x += labelUnionRect.width + margin;
                    }
                }
            });
            adjustAxes();
        }
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
        function adjustAxes() {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesList, function(axis) {
                var isHorizontal = axis.isHorizontal();
                var extent = isHorizontal ? [
                    0,
                    gridRect.width
                ] : [
                    0,
                    gridRect.height
                ];
                var idx = axis.inverse ? 1 : 0;
                axis.setExtent(extent[idx], extent[1 - idx]);
                $8e1d1b12d8439742$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
            });
        }
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = "x" + xAxisIndex + "y" + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis("x").index === xAxisIndex || coordList[i].getAxis("y").index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents("xAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents("yAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis("x", xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis("y", yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent("xAxis", createAxisCreator("x"), this);
        ecModel.eachComponent("yAxis", createAxisCreator("y"), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = "x" + xAxisIndex + "y" + yAxisIndex;
                var cartesian = new (0, $6bea838ef63ff2bb$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$8e1d1b12d8439742$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get("position");
                if (dimName === "x") // Fix position
                {
                    if (axisPosition !== "top" && axisPosition !== "bottom") // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? "top" : "bottom";
                } else // Fix position
                if (axisPosition !== "left" && axisPosition !== "right") // Default left of Y
                axisPosition = axisPositionUsed.left ? "right" : "left";
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $23369073c2236a8d$export$2e2bcd8739ae039)(dimName, (0, $2d646e51cc34f840$export$8941c4cacdc8f5a5)(axisModel), [
                    0,
                    0
                ], axisModel.get("type"), axisPosition);
                var isCategory = axis.type === "category";
                axis.onBand = isCategory && axisModel.get("boundaryGap");
                axis.inverse = axisModel.get("inverse");
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === "category") {
                var categorySortInfo = axis.model.get("categorySortInfo");
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if ((0, $88c937c9bc0ca068$export$c2a0b77974c5e35d)(seriesModel)) {
                var axesModelMap = (0, $88c937c9bc0ca068$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$8e1d1b12d8439742$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$8e1d1b12d8439742$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis("x");
                var yAxis = cartesian.getAxis("y");
                unionExtent(data, xAxis);
                unionExtent(data, yAxis);
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== "auto" ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent("grid", function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = "grid_" + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            if (!(0, $88c937c9bc0ca068$export$c2a0b77974c5e35d)(seriesModel)) return;
            var axesModelMap = (0, $88c937c9bc0ca068$export$8220131ac1d61d28)(seriesModel);
            var xAxisModel = axesModelMap.xAxisModel;
            var yAxisModel = axesModelMap.yAxisModel;
            var gridModel = xAxisModel.getCoordSysModel();
            var grid = gridModel.coordinateSystem;
            seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        });
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $6bea838ef63ff2bb$export$988a008d2b9120f4);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $8e1d1b12d8439742$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        "axisLine",
        "onZero"
    ]);
    var onZeroAxisIndex = axisModel.get([
        "axisLine",
        "onZeroAxisIndex"
    ]);
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($8e1d1b12d8439742$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $8e1d1b12d8439742$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + "_" + axis.index;
    }
}
function $8e1d1b12d8439742$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== "category" && axis.type !== "time" && (0, $2d646e51cc34f840$export$3eac36a69f37d52)(axis);
}
function $8e1d1b12d8439742$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === "x" ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === "x" ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $8e1d1b12d8439742$export$2e2bcd8739ae039 = $8e1d1b12d8439742$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $dfe15f745e1c3c2b$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */ var $dfe15f745e1c3c2b$var$AxisBuilder = /** @class */ function() {
    function AxisBuilder(axisModel, opt) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.opt = opt;
        this.axisModel = axisModel;
        // Default value
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(opt, {
            labelOffset: 0,
            nameDirection: 1,
            tickDirection: 1,
            labelDirection: 1,
            silent: true,
            handleAutoShown: function() {
                return true;
            }
        });
        // FIXME Not use a separate text group?
        var transformGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039({
            x: opt.position[0],
            y: opt.position[1],
            rotation: opt.rotation
        });
        // this.group.add(transformGroup);
        // this._transformGroup = transformGroup;
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
    }
    AxisBuilder.prototype.hasBuilder = function(name) {
        return !!$dfe15f745e1c3c2b$var$builders[name];
    };
    AxisBuilder.prototype.add = function(name) {
        $dfe15f745e1c3c2b$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
    };
    AxisBuilder.prototype.getGroup = function() {
        return this.group;
    };
    AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $cfc1f3b422a3185f$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? "top" : "bottom";
            textAlign = "center";
        } else if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? "bottom" : "top";
            textAlign = "center";
        } else {
            textVerticalAlign = "middle";
            if (rotationDiff > 0 && rotationDiff < $dfe15f745e1c3c2b$var$PI) textAlign = direction > 0 ? "right" : "left";
            else textAlign = direction > 0 ? "left" : "right";
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + "Index"] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get("tooltip");
        return axisModel.get("silent") || !(axisModel.get("triggerEvent") || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
var $dfe15f745e1c3c2b$var$builders = {
    axisLine: function(opt, axisModel, group, transformGroup) {
        var shown = axisModel.get([
            "axisLine",
            "show"
        ]);
        if (shown === "auto" && opt.handleAutoShown) shown = opt.handleAutoShown("axisLine");
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            lineCap: "round"
        }, axisModel.getModel([
            "axisLine",
            "lineStyle"
        ]).getLineStyle());
        var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        });
        $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
        line.anid = "line";
        group.add(line);
        var arrows = axisModel.get([
            "axisLine",
            "symbol"
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                "axisLine",
                "symbolSize"
            ]);
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowSize) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(axisModel.get([
                "axisLine",
                "symbolOffset"
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== "none" && arrows[index] != null) {
                    var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(opt.rotation),
                        y: pt[1] - r * Math.sin(opt.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    axisTickLabel: function(opt, axisModel, group, transformGroup) {
        var ticksEls = $dfe15f745e1c3c2b$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
        var labelEls = $dfe15f745e1c3c2b$var$buildAxisLabel(group, transformGroup, axisModel, opt);
        $dfe15f745e1c3c2b$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $dfe15f745e1c3c2b$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection);
        // This bit fixes the label overlap issue for the time chart.
        // See https://github.com/apache/echarts/issues/14266 for more.
        if (axisModel.get([
            "axisLabel",
            "hideOverlap"
        ])) {
            var labelList = (0, $11dac7a73f36cc2c$export$6c403cad1ae3e239)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(labelEls, function(label) {
                return {
                    label: label,
                    priority: label.z2,
                    defaultAttr: {
                        ignore: label.ignore
                    }
                };
            }));
            (0, $11dac7a73f36cc2c$export$8ce774e164a49410)(labelList);
        }
    },
    axisName: function(opt, axisModel, group, transformGroup) {
        var name = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.axisName, axisModel.get("name"));
        if (!name) return;
        var nameLocation = axisModel.get("nameLocation");
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel("nameTextStyle");
        var gap = axisModel.get("nameGap") || 0;
        var extent = axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === "start" ? extent[0] - gapSignal * gap : nameLocation === "end" ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            // Reuse labelOffset.
            $dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get("nameRotate");
        if (nameRotation != null) nameRotation = nameRotation * $dfe15f745e1c3c2b$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation)) labelLayout = $dfe15f745e1c3c2b$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $dfe15f745e1c3c2b$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get("nameTruncate", true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            x: pos[0],
            y: pos[1],
            rotation: labelLayout.rotation,
            silent: $dfe15f745e1c3c2b$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: "truncate",
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ]),
                align: textStyleModel.get("align") || labelLayout.textAlign,
                verticalAlign: textStyleModel.get("verticalAlign") || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = "name";
        if (axisModel.get("triggerEvent")) {
            var eventData = $dfe15f745e1c3c2b$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = "axisName";
            eventData.name = name;
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        group.add(textEl);
        textEl.decomposeTransform();
    }
};
function $dfe15f745e1c3c2b$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $cfc1f3b422a3185f$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === "start" && !inverse || textPosition !== "start" && inverse;
    if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI / 2)) {
        textVerticalAlign = onLeft ? "bottom" : "top";
        textAlign = "center";
    } else if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? "top" : "bottom";
        textAlign = "center";
    } else {
        textVerticalAlign = "middle";
        if (rotationDiff < $dfe15f745e1c3c2b$var$PI * 1.5 && rotationDiff > $dfe15f745e1c3c2b$var$PI / 2) textAlign = onLeft ? "left" : "right";
        else textAlign = onLeft ? "right" : "left";
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
function $dfe15f745e1c3c2b$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ((0, $2d646e51cc34f840$export$c2911c025243d6a6)(axisModel.axis)) return;
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        "axisLabel",
        "showMinLabel"
    ]);
    var showMaxLabel = axisModel.get([
        "axisLabel",
        "showMaxLabel"
    ]);
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $dfe15f745e1c3c2b$var$ignoreEl(firstLabel);
        $dfe15f745e1c3c2b$var$ignoreEl(firstTick);
    } else if ($dfe15f745e1c3c2b$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $dfe15f745e1c3c2b$var$ignoreEl(nextLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(nextTick);
        } else {
            $dfe15f745e1c3c2b$var$ignoreEl(firstLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $dfe15f745e1c3c2b$var$ignoreEl(lastLabel);
        $dfe15f745e1c3c2b$var$ignoreEl(lastTick);
    } else if ($dfe15f745e1c3c2b$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $dfe15f745e1c3c2b$var$ignoreEl(prevLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(prevTick);
        } else {
            $dfe15f745e1c3c2b$var$ignoreEl(lastLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(lastTick);
        }
    }
}
function $dfe15f745e1c3c2b$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $dfe15f745e1c3c2b$var$isTwoLabelOverlapped(current, next) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
    // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $f41ebb9dd60b55b4$export$f0954fd7d5368655([]);
    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($f41ebb9dd60b55b4$export$6e3a27864ab166fe([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($f41ebb9dd60b55b4$export$6e3a27864ab166fe([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation) {
    return nameLocation === "middle" || nameLocation === "center";
}
function $dfe15f745e1c3c2b$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $5b455ae6f843ac47$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + "_" + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $dfe15f745e1c3c2b$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel("axisTick");
    var shown = tickModel.get("show");
    if (shown === "auto" && opt.handleAutoShown) shown = opt.handleAutoShown("axisTick");
    if (!shown || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel("lineStyle");
    var tickEndCoord = opt.tickDirection * tickModel.get("length");
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $dfe15f745e1c3c2b$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ])
    }), "ticks");
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $dfe15f745e1c3c2b$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel("minorTick");
    if (!minorTickModel.get("show") || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel("lineStyle");
    var tickEndCoord = tickDirection * minorTickModel.get("length");
    var minorTickLineStyle = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(axisModel.getModel("axisTick").getLineStyle(), {
        stroke: axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $dfe15f745e1c3c2b$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, "minorticks_" + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
function $dfe15f745e1c3c2b$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var show = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.axisLabelShow, axisModel.get([
        "axisLabel",
        "show"
    ]));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel("axisLabel");
    var labelMargin = labelModel.get("margin");
    var labels = axis.getViewLabels();
    // Special label rotate.
    var labelRotation = ((0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.labelRotate, labelModel.get("rotate")) || 0) * $dfe15f745e1c3c2b$var$PI / 180;
    var labelLayout = $dfe15f745e1c3c2b$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $dfe15f745e1c3c2b$var$AxisBuilder.isLabelSilent(axisModel);
    var triggerEvent = axisModel.get("triggerEvent");
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var tickValue = axis.scale.type === "ordinal" ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ]);
        var tickCoord = axis.dataToCoord(tickValue);
        var align = itemLabelModel.getShallow("align", true) || labelLayout.textAlign;
        var alignMin = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("alignMinLabel", true), align);
        var alignMax = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("alignMaxLabel", true), align);
        var verticalAlign = itemLabelModel.getShallow("verticalAlign", true) || itemLabelModel.getShallow("baseline", true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("verticalAlignMinLabel", true), verticalAlign);
        var verticalAlignMax = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("verticalAlignMaxLabel", true), verticalAlign);
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            x: tickCoord,
            y: opt.labelOffset + opt.labelDirection * labelMargin,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10 + (labelItem.level || 0),
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === "category" ? rawLabel : axis.type === "value" ? tickValue + "" : tickValue, index) : textColor
            })
        });
        textEl.anid = "label_" + tickValue;
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $dfe15f745e1c3c2b$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = "axisLabel";
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            if (axis.type === "category") eventData.dataIndex = tickValue;
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $dfe15f745e1c3c2b$export$2e2bcd8739ae039 = $dfe15f745e1c3c2b$var$AxisBuilder;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $84d826b9ba8bf009$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $84d826b9ba8bf009$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $84d826b9ba8bf009$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $84d826b9ba8bf009$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent("tooltip");
    var globalAxisPointerModel = ecModel.getComponent("axisPointer");
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get("link", true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $84d826b9ba8bf009$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel("tooltip", globalTooltipModel);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get("show")) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get("trigger") === "axis";
            var cross = baseTooltipModel.get([
                "axisPointer",
                "type"
            ]) === "cross";
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                "axisPointer",
                "axis"
            ]));
            if (triggerAxis || cross) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? "cross" : true, triggerAxis));
            if (cross) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, "cross", false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel("axisPointer", globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get("show");
            if (!axisPointerShow || axisPointerShow === "auto" && !fromTooltip && !$84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get("triggerTooltip");
            axisPointerModel = fromTooltip ? $84d826b9ba8bf009$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get("snap");
            var triggerEmphasis = axisPointerModel.get("triggerEmphasis");
            var axisKey = $84d826b9ba8bf009$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === "category";
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $84d826b9ba8bf009$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $84d826b9ba8bf009$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel("axisPointer");
    var fields = [
        "type",
        "snap",
        "lineStyle",
        "shadowStyle",
        "label",
        "animation",
        "animationDurationUpdate",
        "animationEasingUpdate",
        "z"
    ];
    var volatileOption = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== "category" && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get("type") === "cross") volatileOption.type = "line";
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === "cross") {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            "label",
            "show"
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get("crossStyle");
            crossStyle && (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel("axisPointer", new (0, $6818646a97528290$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $84d826b9ba8bf009$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            "tooltip",
            "trigger"
        ], true);
        var seriesTooltipShow = seriesModel.get([
            "tooltip",
            "show"
        ], true);
        if (!coordSys || seriesTooltipTrigger === "none" || seriesTooltipTrigger === false || seriesTooltipTrigger === "item" || seriesTooltipShow === false || seriesModel.get([
            "axisPointer",
            "show"
        ], true) === false) return;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.coordSysAxesInfo[$84d826b9ba8bf009$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $84d826b9ba8bf009$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisId"], axisModel.id) || $84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisIndex"], axisModel.componentIndex) || $84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisName"], axisModel.name)) return i;
    }
}
function $84d826b9ba8bf009$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === "all" || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(linkPropValue) && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $84d826b9ba8bf009$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get("status");
    var value = axisPointerModel.get("value");
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? "show" : "hide";
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? "hide" : "show";
}
function $84d826b9ba8bf009$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent("axisPointer") || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$84d826b9ba8bf009$export$d01b444bafb1a792(axisModel)];
}
function $84d826b9ba8bf009$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        "handle",
        "show"
    ]);
}
function $84d826b9ba8bf009$export$d01b444bafb1a792(model) {
    return model.type + "||" + model.id;
}



var $58c48a3ef1aa0746$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $58c48a3ef1aa0746$var$AxisView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $84d826b9ba8bf009$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $84d826b9ba8bf009$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $58c48a3ef1aa0746$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $58c48a3ef1aa0746$var$axisPointerClazz[type];
    };
    AxisView.type = "axis";
    return AxisView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $58c48a3ef1aa0746$export$2e2bcd8739ae039 = $58c48a3ef1aa0746$var$AxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ff3096b1f24c33b6$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $ff3096b1f24c33b6$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    // TODO: TYPE
    var splitAreaModel = axisModel.getModel("splitArea");
    var areaStyleModel = splitAreaModel.getModel("areaStyle");
    var areaColors = areaStyleModel.get("color");
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $7a1bd9c2710fea0d$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            anid: tickValue != null ? "area_" + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $ff3096b1f24c33b6$export$48ebf2d6ce8ad076(axisView) {
    $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors = null;
}



var $c87c0ba584696283$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $c87c0ba584696283$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine",
    "minorSplitLine"
];
var $c87c0ba584696283$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = "CartesianAxisPointer";
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get("show")) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $88c937c9bc0ca068$export$b3219800bda33a1f(gridModel, axisModel);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, $7a1bd9c2710fea0d$export$8b58be045bf06082({
            handleAutoShown: function(elementType) {
                var cartesians = gridModel.coordinateSystem.getCartesians();
                for(var i = 0; i < cartesians.length; i++){
                    if ((0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) // Still show axis tick or axisLine if other axis is value / log
                    return true;
                }
                // Not show axisTick or axisLine if other axis is category / time
                return false;
            }
        }, layout));
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c87c0ba584696283$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c87c0ba584696283$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                "show"
            ])) $c87c0ba584696283$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === "changeAxisOrder" && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $ff3096b1f24c33b6$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = "cartesianAxis";
    return CartesianAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $c87c0ba584696283$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        lineColors = $7a1bd9c2710fea0d$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var tickValue = ticksCoords[i].tickValue;
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                anid: tickValue != null ? "line_" + ticksCoords[i].tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                anid: "minor_line_" + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel) {
        (0, $ff3096b1f24c33b6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    }
};
var $c87c0ba584696283$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = "xAxis";
    return CartesianXAxisView;
}($c87c0ba584696283$var$CartesianAxisView);
var $c87c0ba584696283$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $c87c0ba584696283$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = "yAxis";
    return CartesianYAxisView;
}($c87c0ba584696283$var$CartesianAxisView);
var $c87c0ba584696283$export$2e2bcd8739ae039 = $c87c0ba584696283$var$CartesianAxisView;


// Grid view
var $1021478d6a16b0aa$var$GridView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "grid";
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get("show")) this.group.add(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                fill: gridModel.get("backgroundColor")
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = "grid";
    return GridView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $1021478d6a16b0aa$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $1021478d6a16b0aa$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($1021478d6a16b0aa$var$GridView);
    registers.registerComponentModel((0, $d67c268180aaad04$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("cartesian2d", (0, $8e1d1b12d8439742$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "x", (0, $008426c98740266e$export$483dc37e6ad83a3c), $1021478d6a16b0aa$var$extraOption);
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "y", (0, $008426c98740266e$export$483dc37e6ad83a3c), $1021478d6a16b0aa$var$extraOption);
    registers.registerComponentView((0, $c87c0ba584696283$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $c87c0ba584696283$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}



function $1214e5d7a4a6f990$export$4b3e715f166fdd78(registers) {
    // In case developer forget to include grid component
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1021478d6a16b0aa$export$4b3e715f166fdd78));
    registers.registerSeriesModel((0, $00ab9646b588965f$export$2e2bcd8739ae039));
    registers.registerChartView((0, $c92a7ada0c69ef68$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("scatter"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $bec68b02ebcf9063$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("radar", function(seriesModel) {
        var data = seriesModel.getData();
        var points = [];
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var axes = coordSys.getIndicatorAxes();
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axes, function(axis, axisIndex) {
            data.each(data.mapDimension(axes[axisIndex].dim), function(val, dataIndex) {
                points[dataIndex] = points[dataIndex] || [];
                var point = coordSys.dataToPoint(val, axisIndex);
                points[dataIndex][axisIndex] = $bec68b02ebcf9063$var$isValidPoint(point) ? point : $bec68b02ebcf9063$var$getValueMissingPoint(coordSys);
            });
        });
        // Close polygon
        data.each(function(idx) {
            // TODO
            // Is it appropriate to connect to the next data when some data is missing?
            // Or, should trade it like `connectNull` in line chart?
            var firstPoint = $7a1bd9c2710fea0d$export$71aa6c912b956294(points[idx], function(point) {
                return $bec68b02ebcf9063$var$isValidPoint(point);
            }) || $bec68b02ebcf9063$var$getValueMissingPoint(coordSys);
            // Copy the first actual point to the end of the array
            points[idx].push(firstPoint.slice());
            data.setItemLayout(idx, points[idx]);
        });
    });
}
function $bec68b02ebcf9063$var$isValidPoint(point) {
    return !isNaN(point[0]) && !isNaN(point[1]);
}
function $bec68b02ebcf9063$var$getValueMissingPoint(coordSys) {
    // It is error-prone to input [NaN, NaN] into polygon, polygon.
    // (probably cause problem when refreshing or animating)
    return [
        coordSys.cx,
        coordSys.cy
    ];
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck
// Backward compat for radar chart in 2

function $506480c8f28f74be$export$2e2bcd8739ae039(option) {
    var polarOptArr = option.polar;
    if (polarOptArr) {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(polarOptArr)) polarOptArr = [
            polarOptArr
        ];
        var polarNotRadar_1 = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(polarOptArr, function(polarOpt, idx) {
            if (polarOpt.indicator) {
                if (polarOpt.type && !polarOpt.shape) polarOpt.shape = polarOpt.type;
                option.radar = option.radar || [];
                if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(option.radar)) option.radar = [
                    option.radar
                ];
                option.radar.push(polarOpt);
            } else polarNotRadar_1.push(polarOpt);
        });
        option.polar = polarNotRadar_1;
    }
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "radar" && seriesOpt.polarIndex) seriesOpt.radarIndex = seriesOpt.polarIndex;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $1fc9e69f4602cced$var$RadarView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(seriesModel, ecModel, api) {
        var polar = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        function createSymbol(data, idx) {
            var symbolType = data.getItemVisual(idx, "symbol") || "circle";
            if (symbolType === "none") return;
            var symbolSize = $5370466dadc978d7$export$a84524f03e8e8dfb(data.getItemVisual(idx, "symbolSize"));
            var symbolPath = $5370466dadc978d7$export$af050e04da3a02e8(symbolType, -1, -1, 2, 2);
            var symbolRotate = data.getItemVisual(idx, "symbolRotate") || 0;
            symbolPath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 100,
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2,
                rotation: symbolRotate * Math.PI / 180 || 0
            });
            return symbolPath;
        }
        function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
            // Simply rerender all
            symbolGroup.removeAll();
            for(var i = 0; i < newPoints.length - 1; i++){
                var symbolPath = createSymbol(data, idx);
                if (symbolPath) {
                    symbolPath.__dimIdx = i;
                    if (oldPoints[i]) {
                        symbolPath.setPosition(oldPoints[i]);
                        $5b455ae6f843ac47$exports[isInit ? "initProps" : "updateProps"](symbolPath, {
                            x: newPoints[i][0],
                            y: newPoints[i][1]
                        }, seriesModel, idx);
                    } else symbolPath.setPosition(newPoints[i]);
                    symbolGroup.add(symbolPath);
                }
            }
        }
        function getInitialPoints(points) {
            return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(pt) {
                return [
                    polar.cx,
                    polar.cy
                ];
            });
        }
        data.diff(oldData).add(function(idx) {
            var points = data.getItemLayout(idx);
            if (!points) return;
            var polygon = new $5b455ae6f843ac47$exports.Polygon();
            var polyline = new $5b455ae6f843ac47$exports.Polyline();
            var target = {
                shape: {
                    points: points
                }
            };
            polygon.shape.points = getInitialPoints(points);
            polyline.shape.points = getInitialPoints(points);
            $5b455ae6f843ac47$exports.initProps(polygon, target, seriesModel, idx);
            $5b455ae6f843ac47$exports.initProps(polyline, target, seriesModel, idx);
            var itemGroup = new $5b455ae6f843ac47$exports.Group();
            var symbolGroup = new $5b455ae6f843ac47$exports.Group();
            itemGroup.add(polyline);
            itemGroup.add(polygon);
            itemGroup.add(symbolGroup);
            updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
            data.setItemGraphicEl(idx, itemGroup);
        }).update(function(newIdx, oldIdx) {
            var itemGroup = oldData.getItemGraphicEl(oldIdx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            var target = {
                shape: {
                    points: data.getItemLayout(newIdx)
                }
            };
            if (!target.shape.points) return;
            updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polyline);
            $5b455ae6f843ac47$exports.updateProps(polyline, target, seriesModel);
            $5b455ae6f843ac47$exports.updateProps(polygon, target, seriesModel);
            data.setItemGraphicEl(newIdx, itemGroup);
        }).remove(function(idx) {
            group.remove(oldData.getItemGraphicEl(idx));
        }).execute();
        data.eachItemGraphicEl(function(itemGroup, idx) {
            var itemModel = data.getItemModel(idx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            // Radar uses the visual encoded from itemStyle.
            var itemStyle = data.getItemVisual(idx, "style");
            var color = itemStyle.fill;
            group.add(itemGroup);
            polyline.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(itemModel.getModel("lineStyle").getLineStyle(), {
                fill: "none",
                stroke: color
            }));
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polyline, itemModel, "lineStyle");
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel, "areaStyle");
            var areaStyleModel = itemModel.getModel("areaStyle");
            var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
            polygon.ignore = polygonIgnore;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43([
                "emphasis",
                "select",
                "blur"
            ], function(stateName) {
                var stateModel = itemModel.getModel([
                    stateName,
                    "areaStyle"
                ]);
                var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty();
                // Won't be ignore if normal state is not ignore.
                polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
            });
            polygon.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: color,
                opacity: 0.7,
                decal: itemStyle.decal
            }));
            var emphasisModel = itemModel.getModel("emphasis");
            var itemHoverStyle = emphasisModel.getModel("itemStyle").getItemStyle();
            symbolGroup.eachChild(function(symbolPath) {
                if (symbolPath instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
                    var pathStyle = symbolPath.style;
                    symbolPath.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                        // TODO other properties like x, y ?
                        image: pathStyle.image,
                        x: pathStyle.x,
                        y: pathStyle.y,
                        width: pathStyle.width,
                        height: pathStyle.height
                    }, itemStyle));
                } else {
                    symbolPath.useStyle(itemStyle);
                    symbolPath.setColor(color);
                    symbolPath.style.strokeNoScale = true;
                }
                var pathEmphasisState = symbolPath.ensureState("emphasis");
                pathEmphasisState.style = $7a1bd9c2710fea0d$export$9cd59f9826255e47(itemHoverStyle);
                var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
                (defaultText == null || isNaN(defaultText)) && (defaultText = "");
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(symbolPath, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                    labelFetcher: data.hostModel,
                    labelDataIndex: idx,
                    labelDimIndex: symbolPath.__dimIdx,
                    defaultText: defaultText,
                    inheritColor: color,
                    defaultOpacity: itemStyle.opacity
                });
            });
            (0, $2bf82c0980125b62$export$e51187539ff11209)(itemGroup, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        this._data = data;
    };
    RadarView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    RadarView.type = "radar";
    return RadarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $1fc9e69f4602cced$export$2e2bcd8739ae039 = $1fc9e69f4602cced$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $3895e6b103877b59$var$RadarSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RadarSeriesModel, _super);
    function RadarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    // Overwrite
    RadarSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    RadarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            generateCoord: "indicator_",
            generateCoordCount: Infinity
        });
    };
    RadarSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var indicatorAxes = coordSys.getIndicatorAxes();
        var name = this.getData().getName(dataIndex);
        var nameToDisplay = name === "" ? this.name : name;
        var markerColor = (0, $d5ab84c08d6657ec$export$ea15628039c0fa93)(this, dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: nameToDisplay,
            sortBlocks: true,
            blocks: $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(axis) {
                var val = data.get(data.mapDimension(axis.dim), dataIndex);
                return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    markerType: "subItem",
                    markerColor: markerColor,
                    name: axis.name,
                    value: val,
                    sortParam: val
                });
            })
        });
    };
    RadarSeriesModel.prototype.getTooltipPosition = function(dataIndex) {
        if (dataIndex != null) {
            var data_1 = this.getData();
            var coordSys = this.coordinateSystem;
            var values = data_1.getValues($7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
                return data_1.mapDimension(dim);
            }), dataIndex);
            for(var i = 0, len = values.length; i < len; i++)if (!isNaN(values[i])) {
                var indicatorAxes = coordSys.getIndicatorAxes();
                return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
            }
        }
    };
    RadarSeriesModel.type = "series.radar";
    RadarSeriesModel.dependencies = [
        "radar"
    ];
    RadarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        coordinateSystem: "radar",
        legendHoverLink: true,
        radarIndex: 0,
        lineStyle: {
            width: 2,
            type: "solid",
            join: "round"
        },
        label: {
            position: "top"
        },
        // areaStyle: {
        // },
        // itemStyle: {}
        symbolSize: 8
    };
    return RadarSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $3895e6b103877b59$export$2e2bcd8739ae039 = $3895e6b103877b59$var$RadarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $19c8b0d3f7411edb$var$valueAxisDefault = (0, $ad861b9162f24222$export$2e2bcd8739ae039).value;
function $19c8b0d3f7411edb$var$defaultsShow(opt, show) {
    return $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        show: show
    }, opt);
}
var $19c8b0d3f7411edb$var$RadarModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RadarModel, _super);
    function RadarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarModel.type;
        return _this;
    }
    RadarModel.prototype.optionUpdated = function() {
        var boundaryGap = this.get("boundaryGap");
        var splitNumber = this.get("splitNumber");
        var scale = this.get("scale");
        var axisLine = this.get("axisLine");
        var axisTick = this.get("axisTick");
        // let axisType = this.get('axisType');
        var axisLabel = this.get("axisLabel");
        var nameTextStyle = this.get("axisName");
        var showName = this.get([
            "axisName",
            "show"
        ]);
        var nameFormatter = this.get([
            "axisName",
            "formatter"
        ]);
        var nameGap = this.get("axisNameGap");
        var triggerEvent = this.get("triggerEvent");
        var indicatorModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this.get("indicator") || [], function(indicatorOpt) {
            // PENDING
            if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) indicatorOpt.min = 0;
            else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) indicatorOpt.max = 0;
            var iNameTextStyle = nameTextStyle;
            if (indicatorOpt.color != null) iNameTextStyle = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                color: indicatorOpt.color
            }, nameTextStyle);
            // Use same configuration
            var innerIndicatorOpt = $7a1bd9c2710fea0d$export$4950aa0f605343fb($7a1bd9c2710fea0d$export$9cd59f9826255e47(indicatorOpt), {
                boundaryGap: boundaryGap,
                splitNumber: splitNumber,
                scale: scale,
                axisLine: axisLine,
                axisTick: axisTick,
                // axisType: axisType,
                axisLabel: axisLabel,
                // Compatible with 2 and use text
                name: indicatorOpt.text,
                showName: showName,
                nameLocation: "end",
                nameGap: nameGap,
                // min: 0,
                nameTextStyle: iNameTextStyle,
                triggerEvent: triggerEvent
            }, false);
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(nameFormatter)) {
                var indName = innerIndicatorOpt.name;
                innerIndicatorOpt.name = nameFormatter.replace("{value}", indName != null ? indName : "");
            } else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(nameFormatter)) innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
            var model = new (0, $6818646a97528290$export$2e2bcd8739ae039)(innerIndicatorOpt, null, this.ecModel);
            $7a1bd9c2710fea0d$export$e36fc9d62a853069(model, (0, $3449fd4c0590d99e$export$5c54b224726edb5a).prototype);
            // For triggerEvent.
            model.mainType = "radar";
            model.componentIndex = this.componentIndex;
            return model;
        }, this);
        this._indicatorModels = indicatorModels;
    };
    RadarModel.prototype.getIndicatorModels = function() {
        return this._indicatorModels;
    };
    RadarModel.type = "radar";
    RadarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            "50%",
            "50%"
        ],
        radius: "75%",
        startAngle: 90,
        axisName: {
            show: true
        },
        boundaryGap: [
            0,
            0
        ],
        splitNumber: 5,
        axisNameGap: 15,
        scale: false,
        // Polygon or circle
        shape: "polygon",
        axisLine: $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            lineStyle: {
                color: "#bbb"
            }
        }, $19c8b0d3f7411edb$var$valueAxisDefault.axisLine),
        axisLabel: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.axisLabel, false),
        axisTick: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.axisTick, false),
        // axisType: 'value',
        splitLine: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.splitLine, true),
        splitArea: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.splitArea, true),
        // {text, min, max}
        indicator: []
    };
    return RadarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $19c8b0d3f7411edb$export$2e2bcd8739ae039 = $19c8b0d3f7411edb$var$RadarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $9604af4c260571a1$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $9604af4c260571a1$var$RadarView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(radarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        this._buildAxes(radarModel);
        this._buildSplitLineAndArea(radarModel);
    };
    RadarView.prototype._buildAxes = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        var axisBuilders = $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis) {
            var axisName = indicatorAxis.model.get("showName") ? indicatorAxis.name : ""; // hide name
            var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(indicatorAxis.model, {
                axisName: axisName,
                position: [
                    radar.cx,
                    radar.cy
                ],
                rotation: indicatorAxis.angle,
                labelDirection: -1,
                tickDirection: -1,
                nameDirection: 1
            });
            return axisBuilder;
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisBuilders, function(axisBuilder) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($9604af4c260571a1$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
            this.group.add(axisBuilder.getGroup());
        }, this);
    };
    RadarView.prototype._buildSplitLineAndArea = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        if (!indicatorAxes.length) return;
        var shape = radarModel.get("shape");
        var splitLineModel = radarModel.getModel("splitLine");
        var splitAreaModel = radarModel.getModel("splitArea");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var showSplitLine = splitLineModel.get("show");
        var showSplitArea = splitAreaModel.get("show");
        var splitLineColors = lineStyleModel.get("color");
        var splitAreaColors = areaStyleModel.get("color");
        var splitLineColorsArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(splitLineColors) ? splitLineColors : [
            splitLineColors
        ];
        var splitAreaColorsArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(splitAreaColors) ? splitAreaColors : [
            splitAreaColors
        ];
        var splitLines = [];
        var splitAreas = [];
        function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
            var colorIndex = idx % areaOrLineColorList.length;
            areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
            return colorIndex;
        }
        if (shape === "circle") {
            var ticksRadius = indicatorAxes[0].getTicksCoords();
            var cx = radar.cx;
            var cy = radar.cy;
            for(var i = 0; i < ticksRadius.length; i++){
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $1e68d8727773abb7$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r: ticksRadius[i].coord
                        }
                    }));
                }
                if (showSplitArea && i < ticksRadius.length - 1) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
                    splitAreas[colorIndex].push(new $9da0cbfd3f86fdc1$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r0: ticksRadius[i].coord,
                            r: ticksRadius[i + 1].coord
                        }
                    }));
                }
            }
        } else {
            var realSplitNumber_1;
            var axesTicksPoints = $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis, idx) {
                var ticksCoords = indicatorAxis.getTicksCoords();
                realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
                return $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticksCoords, function(tickCoord) {
                    return radar.coordToPoint(tickCoord.coord, idx);
                });
            });
            var prevPoints = [];
            for(var i = 0; i <= realSplitNumber_1; i++){
                var points = [];
                for(var j = 0; j < indicatorAxes.length; j++)points.push(axesTicksPoints[j][i]);
                // Close
                if (points[0]) points.push(points[0].slice());
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $d28119f30e6bb670$export$2e2bcd8739ae039({
                        shape: {
                            points: points
                        }
                    }));
                }
                if (showSplitArea && prevPoints) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
                    splitAreas[colorIndex].push(new $51acf033123e1a30$export$2e2bcd8739ae039({
                        shape: {
                            points: points.concat(prevPoints)
                        }
                    }));
                }
                prevPoints = points.slice().reverse();
            }
        }
        var lineStyle = lineStyleModel.getLineStyle();
        var areaStyle = areaStyleModel.getAreaStyle();
        // Add splitArea before splitLine
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(splitAreas, function(splitAreas, idx) {
            this.group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitAreas, {
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    stroke: "none",
                    fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
                }, areaStyle),
                silent: true
            }));
        }, this);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(splitLines, function(splitLines, idx) {
            this.group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitLines, {
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    fill: "none",
                    stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
                }, lineStyle),
                silent: true
            }));
        }, this);
    };
    RadarView.type = "radar";
    return RadarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $9604af4c260571a1$export$2e2bcd8739ae039 = $9604af4c260571a1$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO clockwise
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $5d6acabddf826472$var$IndicatorAxis = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(IndicatorAxis, _super);
    function IndicatorAxis(dim, scale, radiusExtent) {
        var _this = _super.call(this, dim, scale, radiusExtent) || this;
        _this.type = "value";
        _this.angle = 0;
        _this.name = "";
        return _this;
    }
    return IndicatorAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $5d6acabddf826472$export$2e2bcd8739ae039 = $5d6acabddf826472$var$IndicatorAxis;






var $11c0ac35da5ff3e8$var$Radar = /** @class */ function() {
    function Radar(radarModel, ecModel, api) {
        /**
     *
     * Radar dimensions
     */ this.dimensions = [];
        this._model = radarModel;
        this._indicatorAxes = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(radarModel.getIndicatorModels(), function(indicatorModel, idx) {
            var dim = "indicator_" + idx;
            var indicatorAxis = new (0, $5d6acabddf826472$export$2e2bcd8739ae039)(dim, new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)());
            indicatorAxis.name = indicatorModel.get("name");
            // Inject model and axis
            indicatorAxis.model = indicatorModel;
            indicatorModel.axis = indicatorAxis;
            this.dimensions.push(dim);
            return indicatorAxis;
        }, this);
        this.resize(radarModel, api);
    }
    Radar.prototype.getIndicatorAxes = function() {
        return this._indicatorAxes;
    };
    Radar.prototype.dataToPoint = function(value, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
    };
    // TODO: API should be coordToPoint([coord, indicatorIndex])
    Radar.prototype.coordToPoint = function(coord, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        var angle = indicatorAxis.angle;
        var x = this.cx + coord * Math.cos(angle);
        var y = this.cy - coord * Math.sin(angle);
        return [
            x,
            y
        ];
    };
    Radar.prototype.pointToData = function(pt) {
        var dx = pt[0] - this.cx;
        var dy = pt[1] - this.cy;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx);
        // Find the closest angle
        // FIXME index can calculated directly
        var minRadianDiff = Infinity;
        var closestAxis;
        var closestAxisIdx = -1;
        for(var i = 0; i < this._indicatorAxes.length; i++){
            var indicatorAxis = this._indicatorAxes[i];
            var diff = Math.abs(radian - indicatorAxis.angle);
            if (diff < minRadianDiff) {
                closestAxis = indicatorAxis;
                closestAxisIdx = i;
                minRadianDiff = diff;
            }
        }
        return [
            closestAxisIdx,
            +(closestAxis && closestAxis.coordToData(radius))
        ];
    };
    Radar.prototype.resize = function(radarModel, api) {
        var center = radarModel.get("center");
        var viewWidth = api.getWidth();
        var viewHeight = api.getHeight();
        var viewSize = Math.min(viewWidth, viewHeight) / 2;
        this.cx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(center[0], viewWidth);
        this.cy = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(center[1], viewHeight);
        this.startAngle = radarModel.get("startAngle") * Math.PI / 180;
        // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
        var radius = radarModel.get("radius");
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(radius) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(radius)) radius = [
            0,
            radius
        ];
        this.r0 = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(radius[0], viewSize);
        this.r = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(radius[1], viewSize);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._indicatorAxes, function(indicatorAxis, idx) {
            indicatorAxis.setExtent(this.r0, this.r);
            var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length;
            // Normalize to [-PI, PI]
            angle = Math.atan2(Math.sin(angle), Math.cos(angle));
            indicatorAxis.angle = angle;
        }, this);
    };
    Radar.prototype.update = function(ecModel, api) {
        var indicatorAxes = this._indicatorAxes;
        var radarModel = this._model;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
            indicatorAxis.scale.setExtent(Infinity, -Infinity);
        });
        ecModel.eachSeriesByType("radar", function(radarSeries, idx) {
            if (radarSeries.get("coordinateSystem") !== "radar" || ecModel.getComponent("radar", radarSeries.get("radarIndex")) !== radarModel) return;
            var data = radarSeries.getData();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
                indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
            });
        }, this);
        var splitNumber = radarModel.get("splitNumber");
        var dummyScale = new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
        dummyScale.setExtent(0, splitNumber);
        dummyScale.setInterval(1);
        // Force all the axis fixing the maxSplitNumber.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis, idx) {
            (0, $0591b52263f31374$export$c0b3be0e9eb0c2d9)(indicatorAxis.scale, indicatorAxis.model, dummyScale);
        });
    };
    Radar.prototype.convertToPixel = function(ecModel, finder, value) {
        console.warn("Not implemented.");
        return null;
    };
    Radar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        console.warn("Not implemented.");
        return null;
    };
    Radar.prototype.containPoint = function(point) {
        console.warn("Not implemented.");
        return false;
    };
    Radar.create = function(ecModel, api) {
        var radarList = [];
        ecModel.eachComponent("radar", function(radarModel) {
            var radar = new Radar(radarModel, ecModel, api);
            radarList.push(radar);
            radarModel.coordinateSystem = radar;
        });
        ecModel.eachSeriesByType("radar", function(radarSeries) {
            if (radarSeries.get("coordinateSystem") === "radar") // Inject coordinate system
            // @ts-ignore
            radarSeries.coordinateSystem = radarList[radarSeries.get("radarIndex") || 0];
        });
        return radarList;
    };
    /**
   * Radar dimensions is based on the data
   */ Radar.dimensions = [];
    return Radar;
}();
var $11c0ac35da5ff3e8$export$2e2bcd8739ae039 = $11c0ac35da5ff3e8$var$Radar;


function $82e3ee94e7369a99$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem("radar", (0, $11c0ac35da5ff3e8$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $19c8b0d3f7411edb$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $9604af4c260571a1$export$2e2bcd8739ae039));
    registers.registerVisual({
        seriesType: "radar",
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // itemVisual symbol is for selected data
            data.each(function(idx) {
                data.setItemVisual(idx, "legendIcon", "roundRect");
            });
            // visual is for unselected data
            data.setVisual("legendIcon", "roundRect");
        }
    });
}


function $a8120efef8bcaaa0$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $82e3ee94e7369a99$export$4b3e715f166fdd78));
    registers.registerChartView((0, $1fc9e69f4602cced$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3895e6b103877b59$export$2e2bcd8739ae039));
    registers.registerLayout((0, $bec68b02ebcf9063$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("radar"));
    registers.registerPreprocessor((0, $506480c8f28f74be$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck


var $befd6a34b30d3f54$var$ATTR = "\x00_ec_interaction_mutex";
function $befd6a34b30d3f54$export$b7df5d561049483a(zr, resourceKey, userKey) {
    var store = $befd6a34b30d3f54$var$getStore(zr);
    store[resourceKey] = userKey;
}
function $befd6a34b30d3f54$export$23d3fad09dc44362(zr, resourceKey, userKey) {
    var store = $befd6a34b30d3f54$var$getStore(zr);
    var uKey = store[resourceKey];
    if (uKey === userKey) store[resourceKey] = null;
}
function $befd6a34b30d3f54$export$5623cba512bc9470(zr, resourceKey) {
    return !!$befd6a34b30d3f54$var$getStore(zr)[resourceKey];
}
function $befd6a34b30d3f54$var$getStore(zr) {
    return zr[$befd6a34b30d3f54$var$ATTR] || (zr[$befd6a34b30d3f54$var$ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */ // TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "takeGlobalCursor",
    event: "globalCursorTaken",
    update: "update"
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));



var $15927f329deeab51$var$RoamController = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RoamController, _super);
    function RoamController(zr) {
        var _this = _super.call(this) || this;
        _this._zr = zr;
        // Avoid two roamController bind the same handler
        var mousedownHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousedownHandler, _this);
        var mousemoveHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousemoveHandler, _this);
        var mouseupHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mouseupHandler, _this);
        var mousewheelHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousewheelHandler, _this);
        var pinchHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._pinchHandler, _this);
        /**
     * Notice: only enable needed types. For example, if 'zoom'
     * is not needed, 'zoom' should not be enabled, otherwise
     * default mousewheel behaviour (scroll page) will be disabled.
     */ _this.enable = function(controlType, opt) {
            // Disable previous first
            this.disable();
            this._opt = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(opt) || {}, {
                zoomOnMouseWheel: true,
                moveOnMouseMove: true,
                // By default, wheel do not trigger move.
                moveOnMouseWheel: false,
                preventDefaultMouseMove: true
            });
            if (controlType == null) controlType = true;
            if (controlType === true || controlType === "move" || controlType === "pan") {
                zr.on("mousedown", mousedownHandler);
                zr.on("mousemove", mousemoveHandler);
                zr.on("mouseup", mouseupHandler);
            }
            if (controlType === true || controlType === "scale" || controlType === "zoom") {
                zr.on("mousewheel", mousewheelHandler);
                zr.on("pinch", pinchHandler);
            }
        };
        _this.disable = function() {
            zr.off("mousedown", mousedownHandler);
            zr.off("mousemove", mousemoveHandler);
            zr.off("mouseup", mouseupHandler);
            zr.off("mousewheel", mousewheelHandler);
            zr.off("pinch", pinchHandler);
        };
        return _this;
    }
    RoamController.prototype.isDragging = function() {
        return this._dragging;
    };
    RoamController.prototype.isPinching = function() {
        return this._pinching;
    };
    RoamController.prototype.setPointerChecker = function(pointerChecker) {
        this.pointerChecker = pointerChecker;
    };
    RoamController.prototype.dispose = function() {
        this.disable();
    };
    RoamController.prototype._mousedownHandler = function(e) {
        if ($b3864a78637ff9ed$export$b7ae4cded3e71bd2(e)) return;
        var el = e.target;
        while(el){
            if (el.draggable) return;
            // check if host is draggable
            el = el.__hostTarget || el.parent;
        }
        var x = e.offsetX;
        var y = e.offsetY;
        // Only check on mosedown, but not mousemove.
        // Mouse can be out of target when mouse moving.
        if (this.pointerChecker && this.pointerChecker(e, x, y)) {
            this._x = x;
            this._y = y;
            this._dragging = true;
        }
    };
    RoamController.prototype._mousemoveHandler = function(e) {
        if (!this._dragging || !$15927f329deeab51$var$isAvailableBehavior("moveOnMouseMove", e, this._opt) || e.gestureEvent === "pinch" || $befd6a34b30d3f54$export$5623cba512bc9470(this._zr, "globalPan")) return;
        var x = e.offsetX;
        var y = e.offsetY;
        var oldX = this._x;
        var oldY = this._y;
        var dx = x - oldX;
        var dy = y - oldY;
        this._x = x;
        this._y = y;
        this._opt.preventDefaultMouseMove && $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        $15927f329deeab51$var$trigger(this, "pan", "moveOnMouseMove", e, {
            dx: dx,
            dy: dy,
            oldX: oldX,
            oldY: oldY,
            newX: x,
            newY: y,
            isAvailableBehavior: null
        });
    };
    RoamController.prototype._mouseupHandler = function(e) {
        if (!$b3864a78637ff9ed$export$b7ae4cded3e71bd2(e)) this._dragging = false;
    };
    RoamController.prototype._mousewheelHandler = function(e) {
        var shouldZoom = $15927f329deeab51$var$isAvailableBehavior("zoomOnMouseWheel", e, this._opt);
        var shouldMove = $15927f329deeab51$var$isAvailableBehavior("moveOnMouseWheel", e, this._opt);
        var wheelDelta = e.wheelDelta;
        var absWheelDeltaDelta = Math.abs(wheelDelta);
        var originX = e.offsetX;
        var originY = e.offsetY;
        // wheelDelta maybe -0 in chrome mac.
        if (wheelDelta === 0 || !shouldZoom && !shouldMove) return;
        // If both `shouldZoom` and `shouldMove` is true, trigger
        // their event both, and the final behavior is determined
        // by event listener themselves.
        if (shouldZoom) {
            // Convenience:
            // Mac and VM Windows on Mac: scroll up: zoom out.
            // Windows: scroll up: zoom in.
            // FIXME: Should do more test in different environment.
            // wheelDelta is too complicated in difference nvironment
            // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
            // although it has been normallized by zrender.
            // wheelDelta of mouse wheel is bigger than touch pad.
            var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
            var scale = wheelDelta > 0 ? factor : 1 / factor;
            $15927f329deeab51$var$checkPointerAndTrigger(this, "zoom", "zoomOnMouseWheel", e, {
                scale: scale,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
        if (shouldMove) {
            // FIXME: Should do more test in different environment.
            var absDelta = Math.abs(wheelDelta);
            // wheelDelta of mouse wheel is bigger than touch pad.
            var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
            $15927f329deeab51$var$checkPointerAndTrigger(this, "scrollMove", "moveOnMouseWheel", e, {
                scrollDelta: scrollDelta,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
    };
    RoamController.prototype._pinchHandler = function(e) {
        if ($befd6a34b30d3f54$export$5623cba512bc9470(this._zr, "globalPan")) return;
        var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
        $15927f329deeab51$var$checkPointerAndTrigger(this, "zoom", null, e, {
            scale: scale,
            originX: e.pinchX,
            originY: e.pinchY,
            isAvailableBehavior: null
        });
    };
    return RoamController;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
function $15927f329deeab51$var$checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
        // When mouse is out of roamController rect,
        // default befavoius should not be be disabled, otherwise
        // page sliding is disabled, contrary to expectation.
        $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        $15927f329deeab51$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
    }
}
function $15927f329deeab51$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    // Also provide behavior checker for event listener, for some case that
    // multiple components share one listener.
    contollerEvent.isAvailableBehavior = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($15927f329deeab51$var$isAvailableBehavior, null, behaviorToCheck, e);
    // TODO should not have type issue.
    controller.trigger(eventName, contollerEvent);
}
// settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
function $15927f329deeab51$var$isAvailableBehavior(behaviorToCheck, e, settings) {
    var setting = settings[behaviorToCheck];
    return !behaviorToCheck || setting && (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(setting) || e.event[setting + "Key"]);
}
var $15927f329deeab51$export$2e2bcd8739ae039 = $15927f329deeab51$var$RoamController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * For geo and graph.
 */ function $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, dx, dy) {
    var target = controllerHost.target;
    target.x += dx;
    target.y += dy;
    target.dirty();
}
function $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, zoomDelta, zoomX, zoomY) {
    var target = controllerHost.target;
    var zoomLimit = controllerHost.zoomLimit;
    var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
    newZoom *= zoomDelta;
    if (zoomLimit) {
        var zoomMin = zoomLimit.min || 0;
        var zoomMax = zoomLimit.max || Infinity;
        newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
    }
    var zoomScale = newZoom / controllerHost.zoom;
    controllerHost.zoom = newZoom;
    // Keep the mouse center when scaling
    target.x -= (zoomX - target.x) * (zoomScale - 1);
    target.y -= (zoomY - target.y) * (zoomScale - 1);
    target.scaleX *= zoomScale;
    target.scaleY *= zoomScale;
    target.dirty();
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $bee256db41541054$var$IRRELEVANT_EXCLUDES = {
    "axisPointer": 1,
    "tooltip": 1,
    "brush": 1
};
function $bee256db41541054$export$8a33eacb690eac07(e, api, targetCoordSysModel) {
    var model = api.getComponentByElement(e.topTarget);
    // If model is axisModel, it works only if it is injected with coordinateSystem.
    var coordSys = model && model.coordinateSystem;
    return model && model !== targetCoordSysModel && !$bee256db41541054$var$IRRELEVANT_EXCLUDES.hasOwnProperty(model.mainType) && coordSys && coordSys.model !== targetCoordSysModel;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














function $6d3db85dae3a1192$export$eacefc55fad2867e(svg) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, "text/xml");
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== "svg" || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}


var $ccaaa4a85c480645$var$nodeParsers;
var $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    "fill": "fill",
    "stroke": "stroke",
    "stroke-width": "lineWidth",
    "opacity": "opacity",
    "fill-opacity": "fillOpacity",
    "stroke-opacity": "strokeOpacity",
    "stroke-dasharray": "lineDash",
    "stroke-dashoffset": "lineDashOffset",
    "stroke-linecap": "lineCap",
    "stroke-linejoin": "lineJoin",
    "stroke-miterlimit": "miterLimit",
    "font-family": "fontFamily",
    "font-size": "fontSize",
    "font-style": "fontStyle",
    "font-weight": "fontWeight",
    "text-anchor": "textAlign",
    "visibility": "visibility",
    "display": "display"
};
var $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP = {
    "alignment-baseline": "textBaseline",
    "stop-color": "stopColor"
};
var $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP);
var $ccaaa4a85c480645$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $6d3db85dae3a1192$export$eacefc55fad2867e)(xml);
        this._defsUsePending = [];
        var root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute("viewBox") || "";
        var width = parseFloat(svg.getAttribute("width") || opt.width);
        var height = parseFloat(svg.getAttribute("height") || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $ccaaa4a85c480645$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $ccaaa4a85c480645$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $ccaaa4a85c480645$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $ccaaa4a85c480645$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === "defs") isInDefs = true;
        if (nodeName === "text") isInText = true;
        if (nodeName === "defs" || nodeName === "switch") el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $ccaaa4a85c480645$var$nodeParsers[nodeName];
                if (parser_1 && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute("name");
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === "g") namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $ccaaa4a85c480645$var$paintServerParsers[nodeName];
            if (parser && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute("id");
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $ccaaa4a85c480645$var$inheritStyle(parentGroup, text);
        $ccaaa4a85c480645$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $ccaaa4a85c480645$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + "px",
            textStyle.fontFamily || "sans-serif"
        ].join(" ");
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $ccaaa4a85c480645$var$nodeParsers = {
            "g": function(xmlNode, parentGroup) {
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            "rect": function(xmlNode, parentGroup) {
                var rect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, rect);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute("x") || "0"),
                    y: parseFloat(xmlNode.getAttribute("y") || "0"),
                    width: parseFloat(xmlNode.getAttribute("width") || "0"),
                    height: parseFloat(xmlNode.getAttribute("height") || "0")
                });
                rect.silent = true;
                return rect;
            },
            "circle": function(xmlNode, parentGroup) {
                var circle = new (0, $1e68d8727773abb7$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, circle);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute("cx") || "0"),
                    cy: parseFloat(xmlNode.getAttribute("cy") || "0"),
                    r: parseFloat(xmlNode.getAttribute("r") || "0")
                });
                circle.silent = true;
                return circle;
            },
            "line": function(xmlNode, parentGroup) {
                var line = new (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, line);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute("x1") || "0"),
                    y1: parseFloat(xmlNode.getAttribute("y1") || "0"),
                    x2: parseFloat(xmlNode.getAttribute("x2") || "0"),
                    y2: parseFloat(xmlNode.getAttribute("y2") || "0")
                });
                line.silent = true;
                return line;
            },
            "ellipse": function(xmlNode, parentGroup) {
                var ellipse = new (0, $4a809f055a7e524c$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, ellipse);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute("cx") || "0"),
                    cy: parseFloat(xmlNode.getAttribute("cy") || "0"),
                    rx: parseFloat(xmlNode.getAttribute("rx") || "0"),
                    ry: parseFloat(xmlNode.getAttribute("ry") || "0")
                });
                ellipse.silent = true;
                return ellipse;
            },
            "polygon": function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute("points");
                var pointsArr;
                if (pointsStr) pointsArr = $ccaaa4a85c480645$var$parsePoints(pointsStr);
                var polygon = new (0, $51acf033123e1a30$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, polygon);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            "polyline": function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute("points");
                var pointsArr;
                if (pointsStr) pointsArr = $ccaaa4a85c480645$var$parsePoints(pointsStr);
                var polyline = new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, polyline);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            "image": function(xmlNode, parentGroup) {
                var img = new (0, $86adec94217b86c6$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, img);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute("xlink:href") || xmlNode.getAttribute("href"),
                    x: +xmlNode.getAttribute("x"),
                    y: +xmlNode.getAttribute("y"),
                    width: +xmlNode.getAttribute("width"),
                    height: +xmlNode.getAttribute("height")
                });
                img.silent = true;
                return img;
            },
            "text": function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute("x") || "0";
                var y = xmlNode.getAttribute("y") || "0";
                var dx = xmlNode.getAttribute("dx") || "0";
                var dy = xmlNode.getAttribute("dy") || "0";
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            "tspan": function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute("x");
                var y = xmlNode.getAttribute("y");
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute("dx") || "0";
                var dy = xmlNode.getAttribute("dy") || "0";
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            "path": function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute("d") || "";
                var path = (0, $15b38920672b9006$export$ae5b259626f00aeb)(d);
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, path);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $ccaaa4a85c480645$var$paintServerParsers = {
    "lineargradient": function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute("x1") || "0", 10);
        var y1 = parseInt(xmlNode.getAttribute("y1") || "0", 10);
        var x2 = parseInt(xmlNode.getAttribute("x2") || "10", 10);
        var y2 = parseInt(xmlNode.getAttribute("y2") || "0", 10);
        var gradient = new (0, $cf44c01491b58e53$export$2e2bcd8739ae039)(x1, y1, x2, y2);
        $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient);
        $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    "radialgradient": function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute("cx") || "0", 10);
        var cy = parseInt(xmlNode.getAttribute("cy") || "0", 10);
        var r = parseInt(xmlNode.getAttribute("r") || "0", 10);
        var gradient = new (0, $cd2ee2ba32bb26c3$export$2e2bcd8739ae039)(cx, cy, r);
        $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient);
        $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute("gradientUnits");
    if (gradientUnits === "userSpaceOnUse") gradient.global = true;
}
function $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === "stop") {
            var offsetStr = stop.getAttribute("offset");
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf("%") > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $ccaaa4a85c480645$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute("stop-color") || "#000000";
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $ccaaa4a85c480645$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $ccaaa4a85c480645$var$parsePoints(pointsString) {
    var list = $ccaaa4a85c480645$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $ccaaa4a85c480645$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $ccaaa4a85c480645$var$parseTransformAttribute(xmlNode, el);
        $ccaaa4a85c480645$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $ccaaa4a85c480645$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $ccaaa4a85c480645$var$getFillStrokeStyle(disp, "fill", inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $ccaaa4a85c480645$var$getFillStrokeStyle(disp, "stroke", inheritedStyle.stroke, defsUsePending);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "lineWidth",
        "opacity",
        "fillOpacity",
        "strokeOpacity",
        "miterLimit",
        "fontSize"
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "lineDashOffset",
        "lineCap",
        "lineJoin",
        "fontWeight",
        "fontFamily",
        "fontStyle",
        "textAlign"
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($ccaaa4a85c480645$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === "hidden" || inheritedStyle.visibility === "collapse") disp.invisible = true;
    if (inheritedStyle.display === "none") disp.ignore = true;
}
function $ccaaa4a85c480645$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === "auto") zrTextBaseline = "alphabetic";
        else if (textBaseline === "baseline") zrTextBaseline = "alphabetic";
        else if (textBaseline === "before-edge" || textBaseline === "text-before-edge") zrTextBaseline = "top";
        else if (textBaseline === "after-edge" || textBaseline === "text-after-edge") zrTextBaseline = "bottom";
        else if (textBaseline === "central" || textBaseline === "mathematical") zrTextBaseline = "middle";
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === "middle") zrTextAlign = "center";
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $ccaaa4a85c480645$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $ccaaa4a85c480645$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($ccaaa4a85c480645$var$urlRegex);
    if (urlMatch) {
        var url = (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === "none") str = null;
    return str;
}
function $ccaaa4a85c480645$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $ccaaa4a85c480645$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $ccaaa4a85c480645$var$splitNumberSequence(rawStr) {
    return rawStr.match($ccaaa4a85c480645$var$numberReg) || [];
}
var $ccaaa4a85c480645$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $ccaaa4a85c480645$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $ccaaa4a85c480645$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute("transform");
    if (transform) {
        transform = transform.replace(/,/g, " ");
        var transformOps_1 = [];
        var mt = null;
        transform.replace($ccaaa4a85c480645$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return "";
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $ccaaa4a85c480645$var$splitNumberSequence(value);
            mt = mt || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            switch(type){
                case "translate":
                    $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || "0")
                    ]);
                    break;
                case "scale":
                    $f41ebb9dd60b55b4$export$dcdf75081b88279d(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case "rotate":
                    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(mt, mt, -parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE, [
                        parseFloat(valueArr[1] || "0"),
                        parseFloat(valueArr[2] || "0")
                    ]);
                    break;
                case "skewX":
                    var sx = Math.tan(parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE);
                    $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case "skewY":
                    var sy = Math.tan(parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE);
                    $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case "matrix":
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $ccaaa4a85c480645$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $ccaaa4a85c480645$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute("style");
    if (!style) return;
    $ccaaa4a85c480645$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $ccaaa4a85c480645$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $ccaaa4a85c480645$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $ccaaa4a85c480645$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $ccaaa4a85c480645$export$1919f5101c220601(xml, opt) {
    var parser = new $ccaaa4a85c480645$var$SVGParser();
    return parser.parse(xml, opt);
}







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b4726ec5f917394d$var$EPSILON = 1e-8;
function $b4726ec5f917394d$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $b4726ec5f917394d$var$EPSILON;
}
function $b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$b4726ec5f917394d$var$isAroundEqual(p[0], p0[0]) || !$b4726ec5f917394d$var$isAroundEqual(p[1], p0[1])) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}




var $00e94d08c93517b6$var$TMP_TRANSFORM = [];
function $00e94d08c93517b6$var$transformPoints(points, transform) {
    for(var p = 0; p < points.length; p++)$6de594cf8ac295ff$export$9f9dcb98c894b623(points[p], points[p], transform);
}
function $00e94d08c93517b6$var$updateBBoxFromPoints(points, min, max, projection) {
    for(var i = 0; i < points.length; i++){
        var p = points[i];
        if (projection) // projection may return null point.
        p = projection.project(p);
        if (p && isFinite(p[0]) && isFinite(p[1])) {
            $6de594cf8ac295ff$export$96ec731ed4dcb222(min, min, p);
            $6de594cf8ac295ff$export$8960430cfd85939f(max, max, p);
        }
    }
}
function $00e94d08c93517b6$var$centroid(points) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = points.length;
    var x0 = points[len - 1][0];
    var y0 = points[len - 1][1];
    // Polygon should been closed.
    for(var i = 0; i < len; i++){
        var x1 = points[i][0];
        var y1 = points[i][1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
        x0 = x1;
        y0 = y1;
    }
    return signedArea ? [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ] : [
        points[0][0] || 0,
        points[0][1] || 0
    ];
}
var $00e94d08c93517b6$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    Region.prototype.setCenter = function(center) {
        this._center = center;
    };
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this.calcCenter();
        return center;
    };
    return Region;
}();
var $00e94d08c93517b6$export$91e20b0f72443753 = /** @class */ function() {
    function GeoJSONPolygonGeometry(exterior, interiors) {
        this.type = "polygon";
        this.exterior = exterior;
        this.interiors = interiors;
    }
    return GeoJSONPolygonGeometry;
}();
var $00e94d08c93517b6$export$335807c9e785d92c = /** @class */ function() {
    function GeoJSONLineStringGeometry(points) {
        this.type = "linestring";
        this.points = points;
    }
    return GeoJSONLineStringGeometry;
}();
var $00e94d08c93517b6$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = "geoJSON";
        _this.geometries = geometries;
        _this._center = cp && [
            cp[0],
            cp[1]
        ];
        return _this;
    }
    GeoJSONRegion.prototype.calcCenter = function() {
        var geometries = this.geometries;
        var largestGeo;
        var largestGeoSize = 0;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            var exterior = geo.exterior;
            // Simple trick to use points count instead of polygon area as region size.
            // Ignore linestring
            var size = exterior && exterior.length;
            if (size > largestGeoSize) {
                largestGeo = geo;
                largestGeoSize = size;
            }
        }
        if (largestGeo) return $00e94d08c93517b6$var$centroid(largestGeo.exterior);
        // from bounding rect by default.
        var rect = this.getBoundingRect();
        return [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.getBoundingRect = function(projection) {
        var rect = this._rect;
        // Always recalculate if using projection.
        if (rect && !projection) return rect;
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        var geometries = this.geometries;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geometries, function(geo) {
            if (geo.type === "polygon") // Doesn't consider hole
            $00e94d08c93517b6$var$updateBBoxFromPoints(geo.exterior, min, max, projection);
            else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.points, function(points) {
                $00e94d08c93517b6$var$updateBBoxFromPoints(points, min, max, projection);
            });
        });
        // Normalie invalid bounding.
        if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) min[0] = min[1] = max[0] = max[1] = 0;
        rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        if (!projection) this._rect = rect;
        return rect;
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            var geo = geometries[i];
            // Only support polygon.
            if (geo.type !== "polygon") continue;
            var exterior = geo.exterior;
            var interiors = geo.interiors;
            if ($b4726ec5f917394d$export$8893e2b90ba10d92(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($b4726ec5f917394d$export$8893e2b90ba10d92(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */ GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            if (geo.type === "polygon") {
                $00e94d08c93517b6$var$transformPoints(geo.exterior, transform);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.interiors, function(interior) {
                    $00e94d08c93517b6$var$transformPoints(interior, transform);
                });
            } else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.points, function(points) {
                $00e94d08c93517b6$var$transformPoints(points, transform);
            });
        }
        rect = this._rect;
        rect.copy(target);
        // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    return GeoJSONRegion;
}($00e94d08c93517b6$export$b1f97c3099fc6872);
var $00e94d08c93517b6$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = "geoSVG";
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.calcCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $f41ebb9dd60b55b4$export$f0954fd7d5368655($00e94d08c93517b6$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(mat, mat);
        $6de594cf8ac295ff$export$9f9dcb98c894b623(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($00e94d08c93517b6$export$b1f97c3099fc6872);


/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $decc9bf1380d61c0$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)([
    "rect",
    "circle",
    "line",
    "ellipse",
    "polygon",
    "polyline",
    "path",
    // <text> <tspan> are also enabled because some SVG might paint text itself,
    // but still need to trigger events or tooltip.
    "text",
    "tspan",
    // <g> is also enabled because this case: if multiple tags share one name
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    "g"
]);
var $decc9bf1380d61c0$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = "geoSVG";
        // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName;
        // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $6d3db85dae3a1192$export$eacefc55fad2867e)(svg);
    }
    GeoSVGResource.prototype.load = function() {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic;
        // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone();
            // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $decc9bf1380d61c0$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $ccaaa4a85c480645$export$1919f5101c220601)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(rootFromParse != null);
        } catch (e) {
            throw new Error("Invalid svg format\n" + e.message);
        }
        // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true;
        // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only support `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            }
            // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $ccaaa4a85c480645$export$3e2db4420f14f50f)(viewBoxRect, boundingRect);
            // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        }
        // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.named, function(namedItem) {
            if ($decc9bf1380d61c0$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $decc9bf1380d61c0$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey /* , nameMap: NameMap */ ) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic);
        // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $decc9bf1380d61c0$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false;
    // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $decc9bf1380d61c0$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Create resions only for the first graphic.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $00e94d08c93517b6$export$5f3d89e7254f3e69)(namedItem.name, namedItem.el);
        // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region);
        // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 

function $1a1de70a2b6a5dc5$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(features, function(feature) {
        var geometry = feature.geometry;
        var encodeOffsets = geometry.encodeOffsets;
        var coordinates = geometry.coordinates;
        // Geometry may be appeded manually in the script after json loaded.
        // In this case this geometry is usually not encoded.
        if (!encodeOffsets) return;
        switch(geometry.type){
            case "LineString":
                geometry.coordinates = $1a1de70a2b6a5dc5$var$decodeRing(coordinates, encodeOffsets, encodeScale);
                break;
            case "Polygon":
                $1a1de70a2b6a5dc5$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case "MultiLineString":
                $1a1de70a2b6a5dc5$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case "MultiPolygon":
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(coordinates, function(rings, idx) {
                    return $1a1de70a2b6a5dc5$var$decodeRings(rings, encodeOffsets[idx], encodeScale);
                });
        }
    });
    // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $1a1de70a2b6a5dc5$var$decodeRings(rings, encodeOffsets, encodeScale) {
    for(var c = 0; c < rings.length; c++)rings[c] = $1a1de70a2b6a5dc5$var$decodeRing(rings[c], encodeOffsets[c], encodeScale);
}
function $1a1de70a2b6a5dc5$var$decodeRing(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64;
        // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1);
        // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y;
        // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $1a1de70a2b6a5dc5$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $1a1de70a2b6a5dc5$var$decode(geoJson);
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88($7a1bd9c2710fea0d$export$3dea766d36a8935f(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        switch(geo.type){
            case "Polygon":
                var coordinates = geo.coordinates;
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                geometries.push(new (0, $00e94d08c93517b6$export$91e20b0f72443753)(coordinates[0], coordinates.slice(1)));
                break;
            case "MultiPolygon":
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(geo.coordinates, function(item) {
                    if (item[0]) geometries.push(new (0, $00e94d08c93517b6$export$91e20b0f72443753)(item[0], item.slice(1)));
                });
                break;
            case "LineString":
                geometries.push(new (0, $00e94d08c93517b6$export$335807c9e785d92c)([
                    geo.coordinates
                ]));
                break;
            case "MultiLineString":
                geometries.push(new (0, $00e94d08c93517b6$export$335807c9e785d92c)(geo.coordinates));
        }
        var region = new (0, $00e94d08c93517b6$export$ee84fcb463f24b3d)(properties[nameProperty || "name"], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛


var $616ae7a19aad52f4$var$geoCoord = [
    126,
    25
];
var $616ae7a19aad52f4$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $616ae7a19aad52f4$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $616ae7a19aad52f4$var$i = 0; $616ae7a19aad52f4$var$i < $616ae7a19aad52f4$var$points.length; $616ae7a19aad52f4$var$i++)for(var $616ae7a19aad52f4$var$k = 0; $616ae7a19aad52f4$var$k < $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i].length; $616ae7a19aad52f4$var$k++){
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][0] /= 10.5;
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][1] /= -14;
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][0] += $616ae7a19aad52f4$var$geoCoord[0];
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][1] += $616ae7a19aad52f4$var$geoCoord[1];
}
function $616ae7a19aad52f4$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === "china") {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $616ae7a19aad52f4$var$nanhaiName) return;
        }
        regions.push(new (0, $00e94d08c93517b6$export$ee84fcb463f24b3d)($616ae7a19aad52f4$var$nanhaiName, $7a1bd9c2710fea0d$export$871de8747c9eaa88($616ae7a19aad52f4$var$points, function(exterior) {
            return {
                type: "polygon",
                exterior: exterior
            };
        }), $616ae7a19aad52f4$var$geoCoord));
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $280c32529827bd03$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    // '北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $280c32529827bd03$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === "china") {
        var coordFix = $280c32529827bd03$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $5b04f3878acd754e$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $5b04f3878acd754e$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === "china" && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: "polygon",
        exterior: $5b04f3878acd754e$var$points[0]
    });
}



var $ca9a35044b20ba4d$var$DEFAULT_NAME_PROPERTY = "name";
var $ca9a35044b20ba4d$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = "geoJSON";
        this._parsedMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this._mapName = mapName;
        this._specialAreas = specialAreas;
        // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $ca9a35044b20ba4d$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $ca9a35044b20ba4d$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $ca9a35044b20ba4d$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var finalRegions = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parsed.regions, function(region) {
            var regionName = region.name;
            // Try use the alias in geoNameMap
            if (nameMap && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(nameMap, regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions;
        // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $1a1de70a2b6a5dc5$export$2e2bcd8739ae039)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error("Invalid geoJson format\n" + e.message);
        }
        (0, $616ae7a19aad52f4$export$2e2bcd8739ae039)(mapName, rawRegions);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $280c32529827bd03$export$2e2bcd8739ae039)(mapName, region);
            (0, $5b04f3878acd754e$export$2e2bcd8739ae039)(mapName, region);
            // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $ca9a35044b20ba4d$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $ca9a35044b20ba4d$var$parseInput(source) {
    return !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(source) ? source : typeof JSON !== "undefined" && JSON.parse ? JSON.parse(source) : new Function("return (" + source + ");")();
}


var $09550a1229dcb4ad$var$storage = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
var $09550a1229dcb4ad$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $decc9bf1380d61c0$export$be52c950efae1f84)(mapName, rawDef.svg);
            $09550a1229dcb4ad$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $ca9a35044b20ba4d$export$859cf85c67f2df51)(mapName, geoJSON, rawSpecialAreas);
            $09550a1229dcb4ad$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $09550a1229dcb4ad$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $09550a1229dcb4ad$var$storage.get(mapName);
        // Do not support return SVG until some real requirement come.
        return resource && resource.type === "geoJSON" && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $09550a1229dcb4ad$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};








/**
 * Only these tags enable use `itemStyle` if they are named in SVG.
 * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
 * They will not be considered to be styled until some requirements come.
 */ var $ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS = [
    "rect",
    "circle",
    "line",
    "ellipse",
    "polygon",
    "polyline",
    "path"
];
var $ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAG_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS);
var $ad029c27e0f2a7ab$var$STATE_TRIGGER_TAG_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS.concat([
    "g"
]));
var $ad029c27e0f2a7ab$var$LABEL_HOST_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS.concat([
    "g"
]));
var $ad029c27e0f2a7ab$var$mapLabelRaw = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $ad029c27e0f2a7ab$var$getFixedItemStyle(model) {
    var itemStyle = model.getItemStyle();
    var areaColor = model.get("areaColor");
    // If user want the color not to be changed when hover,
    // they should both set areaColor and color to be null.
    if (areaColor != null) itemStyle.fill = areaColor;
    return itemStyle;
}
// Only stroke can be used for line.
// Using fill in style if stroke not exits.
// TODO Not sure yet. Perhaps a separate `lineStyle`?
function $ad029c27e0f2a7ab$var$fixLineStyle(styleHost) {
    var style = styleHost.style;
    if (style) {
        style.stroke = style.stroke || style.fill;
        style.fill = null;
    }
}
var $ad029c27e0f2a7ab$var$MapDraw = /** @class */ function() {
    function MapDraw(api) {
        var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("ec_map_draw");
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: group
        };
        this.group = group;
        group.add(this._regionsGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039());
        group.add(this._svgGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039());
    }
    MapDraw.prototype.draw = function(mapOrGeoModel, ecModel, api, fromView, payload) {
        var isGeo = mapOrGeoModel.mainType === "geo";
        // Map series has data. GEO model that controlled by map series
        // will be assigned with map data. Other GEO model has no data.
        var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
        isGeo && ecModel.eachComponent({
            mainType: "series",
            subType: "map"
        }, function(mapSeries) {
            if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) data = mapSeries.getData();
        });
        var geo = mapOrGeoModel.coordinateSystem;
        var regionsGroup = this._regionsGroup;
        var group = this.group;
        var transformInfo = geo.getTransformInfo();
        var transformInfoRaw = transformInfo.raw;
        var transformInfoRoam = transformInfo.roam;
        // No animation when first draw or in action
        var isFirstDraw = !regionsGroup.childAt(0) || payload;
        if (isFirstDraw) {
            group.x = transformInfoRoam.x;
            group.y = transformInfoRoam.y;
            group.scaleX = transformInfoRoam.scaleX;
            group.scaleY = transformInfoRoam.scaleY;
            group.dirty();
        } else $8b353638fbedfefa$export$c8dce3c08436e91e(group, transformInfoRoam, mapOrGeoModel);
        var isVisualEncodedByVisualMap = data && data.getVisual("visualMeta") && data.getVisual("visualMeta").length > 0;
        var viewBuildCtx = {
            api: api,
            geo: geo,
            mapOrGeoModel: mapOrGeoModel,
            data: data,
            isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
            isGeo: isGeo,
            transformInfoRaw: transformInfoRaw
        };
        if (geo.resourceType === "geoJSON") this._buildGeoJSON(viewBuildCtx);
        else if (geo.resourceType === "geoSVG") this._buildSVG(viewBuildCtx);
        this._updateController(mapOrGeoModel, ecModel, api);
        this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
    };
    MapDraw.prototype._buildGeoJSON = function(viewBuildCtx) {
        var regionsGroupByName = this._regionsGroupByName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var regionsInfoByName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var regionsGroup = this._regionsGroup;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
        var data = viewBuildCtx.data;
        var projection = viewBuildCtx.geo.projection;
        var projectionStream = projection && projection.stream;
        function transformPoint(point, project) {
            if (project) // projection may return null point.
            point = project(point);
            return point && [
                point[0] * transformInfoRaw.scaleX + transformInfoRaw.x,
                point[1] * transformInfoRaw.scaleY + transformInfoRaw.y
            ];
        }
        function transformPolygonPoints(inPoints) {
            var outPoints = [];
            // If projectionStream is provided. Use it instead of single point project.
            var project = !projectionStream && projection && projection.project;
            for(var i = 0; i < inPoints.length; ++i){
                var newPt = transformPoint(inPoints[i], project);
                newPt && outPoints.push(newPt);
            }
            return outPoints;
        }
        function getPolyShape(points) {
            return {
                shape: {
                    points: transformPolygonPoints(points)
                }
            };
        }
        regionsGroup.removeAll();
        // Only when the resource is GeoJSON, there is `geo.regions`.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(viewBuildCtx.geo.regions, function(region) {
            var regionName = region.name;
            // Consider in GeoJson properties.name may be duplicated, for example,
            // there is multiple region named "United Kindom" or "France" (so many
            // colonies). And it is not appropriate to merge them in geo, which
            // will make them share the same label and bring trouble in label
            // location calculation.
            var regionGroup = regionsGroupByName.get(regionName);
            var _a = regionsInfoByName.get(regionName) || {}, dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            if (!regionGroup) {
                regionGroup = regionsGroupByName.set(regionName, new $7ef7583d8302ffce$export$2e2bcd8739ae039());
                regionsGroup.add(regionGroup);
                dataIdx = data ? data.indexOfName(regionName) : null;
                regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
                regionsInfoByName.set(regionName, {
                    dataIdx: dataIdx,
                    regionModel: regionModel
                });
            }
            var polygonSubpaths = [];
            var polylineSubpaths = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(region.geometries, function(geometry) {
                // Polygon and MultiPolygon
                if (geometry.type === "polygon") {
                    var polys = [
                        geometry.exterior
                    ].concat(geometry.interiors || []);
                    if (projectionStream) polys = $ad029c27e0f2a7ab$var$projectPolys(polys, projectionStream);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(polys, function(poly) {
                        polygonSubpaths.push(new $51acf033123e1a30$export$2e2bcd8739ae039(getPolyShape(poly)));
                    });
                } else {
                    var points = geometry.points;
                    if (projectionStream) points = $ad029c27e0f2a7ab$var$projectPolys(points, projectionStream, true);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(points, function(points) {
                        polylineSubpaths.push(new $d28119f30e6bb670$export$2e2bcd8739ae039(getPolyShape(points)));
                    });
                }
            });
            var centerPt = transformPoint(region.getCenter(), projection && projection.project);
            function createCompoundPath(subpaths, isLine) {
                if (!subpaths.length) return;
                var compoundPath = new $e152f3dbf8fba6e2$export$2e2bcd8739ae039({
                    culling: true,
                    segmentIgnoreThreshold: 1,
                    shape: {
                        paths: subpaths
                    }
                });
                regionGroup.add(compoundPath);
                $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
                $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);
                if (isLine) {
                    $ad029c27e0f2a7ab$var$fixLineStyle(compoundPath);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(compoundPath.states, $ad029c27e0f2a7ab$var$fixLineStyle);
                }
            }
            createCompoundPath(polygonSubpaths);
            createCompoundPath(polylineSubpaths, true);
        });
        // Ensure children have been added to `regionGroup` before calling them.
        regionsGroupByName.each(function(regionGroup, regionName) {
            var _a = regionsInfoByName.get(regionName), dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
            $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
            $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
        }, this);
    };
    MapDraw.prototype._buildSVG = function(viewBuildCtx) {
        var mapName = viewBuildCtx.geo.map;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        this._svgGroup.x = transformInfoRaw.x;
        this._svgGroup.y = transformInfoRaw.y;
        this._svgGroup.scaleX = transformInfoRaw.scaleX;
        this._svgGroup.scaleY = transformInfoRaw.scaleY;
        if (this._svgResourceChanged(mapName)) {
            this._freeSVG();
            this._useSVG(mapName);
        }
        var svgDispatcherMap = this._svgDispatcherMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var focusSelf = false;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._svgGraphicRecord.named, function(namedItem) {
            // Note that we also allow different elements have the same name.
            // For example, a glyph of a city and the label of the city have
            // the same name and their tooltip info can be defined in a single
            // region option.
            var regionName = namedItem.name;
            var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
            var data = viewBuildCtx.data;
            var svgNodeTagLower = namedItem.svgNodeTagLower;
            var el = namedItem.el;
            var dataIdx = data ? data.indexOfName(regionName) : null;
            var regionModel = mapOrGeoModel.getRegionModel(regionName);
            if ($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
            if (el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) el.culling = true;
            // We do not know how the SVG like so we'd better not to change z2.
            // Otherwise it might bring some unexpected result. For example,
            // an area hovered that make some inner city can not be clicked.
            el.z2EmphasisLift = 0;
            // If self named:
            if (!namedItem.namedFrom) {
                // label should batter to be displayed based on the center of <g>
                // if it is named rather than displayed on each child.
                if ($ad029c27e0f2a7ab$var$LABEL_HOST_MAP.get(svgNodeTagLower) != null) $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
                $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
                $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                if ($ad029c27e0f2a7ab$var$STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
                    var focus_1 = $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                    if (focus_1 === "self") focusSelf = true;
                    var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
                    els.push(el);
                }
            }
        }, this);
        this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
    };
    MapDraw.prototype._enableBlurEntireSVG = function(focusSelf, viewBuildCtx) {
        // It's a little complicated to support blurring the entire geoSVG in series-map.
        // So do not support it until some requirements come.
        // At present, in series-map, only regions can be blurred.
        if (focusSelf && viewBuildCtx.isGeo) {
            var blurStyle = viewBuildCtx.mapOrGeoModel.getModel([
                "blur",
                "itemStyle"
            ]).getItemStyle();
            // Only support `opacity` here. Because not sure that other props are suitable for
            // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).
            var opacity_1 = blurStyle.opacity;
            this._svgGraphicRecord.root.traverse(function(el) {
                if (!el.isGroup) {
                    // PENDING: clear those settings to SVG elements when `_freeSVG`.
                    // (Currently it happen not to be needed.)
                    (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(el);
                    var style = el.ensureState("blur").style || {};
                    // Do not overwrite the region style that already set from region option.
                    if (style.opacity == null && opacity_1 != null) style.opacity = opacity_1;
                    // If `ensureState('blur').style = {}`, there will be default opacity.
                    // Enable `stateTransition` (animation).
                    el.ensureState("emphasis");
                }
            });
        }
    };
    MapDraw.prototype.remove = function() {
        this._regionsGroup.removeAll();
        this._regionsGroupByName = null;
        this._svgGroup.removeAll();
        this._freeSVG();
        this._controller.dispose();
        this._controllerHost = null;
    };
    MapDraw.prototype.findHighDownDispatchers = function(name, geoModel) {
        if (name == null) return [];
        var geo = geoModel.coordinateSystem;
        if (geo.resourceType === "geoJSON") {
            var regionsGroupByName = this._regionsGroupByName;
            if (regionsGroupByName) {
                var regionGroup = regionsGroupByName.get(name);
                return regionGroup ? [
                    regionGroup
                ] : [];
            }
        } else if (geo.resourceType === "geoSVG") return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
    };
    MapDraw.prototype._svgResourceChanged = function(mapName) {
        return this._svgMapName !== mapName;
    };
    MapDraw.prototype._useSVG = function(mapName) {
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === "geoSVG") {
            var svgGraphic = resource.useGraphic(this.uid);
            this._svgGroup.add(svgGraphic.root);
            this._svgGraphicRecord = svgGraphic;
            this._svgMapName = mapName;
        }
    };
    MapDraw.prototype._freeSVG = function() {
        var mapName = this._svgMapName;
        if (mapName == null) return;
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === "geoSVG") resource.freeGraphic(this.uid);
        this._svgGraphicRecord = null;
        this._svgDispatcherMap = null;
        this._svgGroup.removeAll();
        this._svgMapName = null;
    };
    MapDraw.prototype._updateController = function(mapOrGeoModel, ecModel, api) {
        var geo = mapOrGeoModel.coordinateSystem;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        // @ts-ignore FIXME:TS
        controllerHost.zoomLimit = mapOrGeoModel.get("scaleLimit");
        controllerHost.zoom = geo.getZoom();
        // roamType is will be set default true if it is null
        // @ts-ignore FIXME:TS
        controller.enable(mapOrGeoModel.get("roam") || false);
        var mainType = mapOrGeoModel.mainType;
        function makeActionBase() {
            var action = {
                type: "geoRoam",
                componentType: mainType
            };
            action[mainType + "Id"] = mapOrGeoModel.id;
            return action;
        }
        controller.off("pan").on("pan", function(e) {
            this._mouseDownFlag = false;
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction($7a1bd9c2710fea0d$export$8b58be045bf06082(makeActionBase(), {
                dx: e.dx,
                dy: e.dy,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.off("zoom").on("zoom", function(e) {
            this._mouseDownFlag = false;
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction($7a1bd9c2710fea0d$export$8b58be045bf06082(makeActionBase(), {
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.setPointerChecker(function(e, x, y) {
            return geo.containPoint([
                x,
                y
            ]) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, mapOrGeoModel);
        });
    };
    /**
   * FIXME: this is a temporarily workaround.
   * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
   * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
   * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
   * props will have no chance to be restored.
   * Note: This reset should be after `clearStates` in `renderSeries` because `useStates` in
   * `renderSeries` will cache the modified `ignore` to `el._normalState`.
   * TODO:
   * Use clone/immutable in `LabelManager`?
   */ MapDraw.prototype.resetForLabelLayout = function() {
        this.group.traverse(function(el) {
            var label = el.getTextContent();
            if (label) label.ignore = $ad029c27e0f2a7ab$var$mapLabelRaw(label).ignore;
        });
    };
    MapDraw.prototype._updateMapSelectHandler = function(mapOrGeoModel, regionsGroup, api, fromView) {
        var mapDraw = this;
        regionsGroup.off("mousedown");
        regionsGroup.off("click");
        // @ts-ignore FIXME:TS resolve type conflict
        if (mapOrGeoModel.get("selectedMode")) {
            regionsGroup.on("mousedown", function() {
                mapDraw._mouseDownFlag = true;
            });
            regionsGroup.on("click", function(e) {
                if (!mapDraw._mouseDownFlag) return;
                mapDraw._mouseDownFlag = false;
            });
        }
    };
    return MapDraw;
}();
function $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
    // All of the path are using `itemStyle`, because
    // (1) Some SVG also use fill on polyline (The different between
    // polyline and polygon is "open" or "close" but not fill or not).
    // (2) For the common props like opacity, if some use itemStyle
    // and some use `lineStyle`, it might confuse users.
    // (3) Most SVG use <path>, where can not detect whether to draw a "line"
    // or a filled shape, so use `itemStyle` for <path>.
    var normalStyleModel = regionModel.getModel("itemStyle");
    var emphasisStyleModel = regionModel.getModel([
        "emphasis",
        "itemStyle"
    ]);
    var blurStyleModel = regionModel.getModel([
        "blur",
        "itemStyle"
    ]);
    var selectStyleModel = regionModel.getModel([
        "select",
        "itemStyle"
    ]);
    // NOTE: DON'T use 'style' in visual when drawing map.
    // This component is used for drawing underlying map for both geo component and map series.
    var normalStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(normalStyleModel);
    var emphasisStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(emphasisStyleModel);
    var selectStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(selectStyleModel);
    var blurStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(blurStyleModel);
    // Update the itemStyle if has data visual
    var data = viewBuildCtx.data;
    if (data) {
        // Only visual color of each item will be used. It can be encoded by visualMap
        // But visual color of series is used in symbol drawing
        // Visual color for each series is for the symbol draw
        var style = data.getItemVisual(dataIndex, "style");
        var decal = data.getItemVisual(dataIndex, "decal");
        if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) normalStyle.fill = style.fill;
        if (decal) normalStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, viewBuildCtx.api);
    }
    // SVG text, tspan and image can be named but not supporeted
    // to be styled by region option yet.
    el.setStyle(normalStyle);
    el.style.strokeNoScale = true;
    el.ensureState("emphasis").style = emphasisStyle;
    el.ensureState("select").style = selectStyle;
    el.ensureState("blur").style = blurStyle;
    // Enable blur
    (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(el);
}
function $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
labelXY) {
    var data = viewBuildCtx.data;
    var isGeo = viewBuildCtx.isGeo;
    var isDataNaN = data && isNaN(data.get(data.mapDimension("value"), dataIdx));
    var itemLayout = data && data.getItemLayout(dataIdx);
    // In the following cases label will be drawn
    // 1. In map series and data value is NaN
    // 2. In geo component
    // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout
    if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
        var query = !isGeo ? dataIdx : regionName;
        var labelFetcher = void 0;
        // Consider dataIdx not found.
        if (!data || dataIdx >= 0) labelFetcher = mapOrGeoModel;
        var specifiedTextOpt = labelXY ? {
            normal: {
                align: "center",
                verticalAlign: "middle"
            }
        } : null;
        // Caveat: must be called after `setDefaultStateProxy(el);` called.
        // because textContent will be assign with `el.stateProxy` inside.
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(el, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(regionModel), {
            labelFetcher: labelFetcher,
            labelDataIndex: query,
            defaultText: regionName
        }, specifiedTextOpt);
        var textEl = el.getTextContent();
        if (textEl) {
            $ad029c27e0f2a7ab$var$mapLabelRaw(textEl).ignore = textEl.ignore;
            if (el.textConfig && labelXY) {
                // Compute a relative offset based on the el bounding rect.
                var rect = el.getBoundingRect().clone();
                // Need to make sure the percent position base on the same rect in normal and
                // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
                // has borderWidth (even 0.5px), the text position will be changed obviously
                // if the position is very big like ['1234%', '1345%'].
                el.textConfig.layoutRect = rect;
                el.textConfig.position = [
                    (labelXY[0] - rect.x) / rect.width * 100 + "%",
                    (labelXY[1] - rect.y) / rect.height * 100 + "%"
                ];
            }
        }
        // PENDING:
        // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
        // But el.dataIndex is also used to determine whether user event should be triggered,
        // where el.seriesIndex or el.dataModel must be specified. At present for a single el
        // there is not case that "only label layout enabled but user event disabled", so here
        // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.
        el.disableLabelAnimation = true;
    } else {
        el.removeTextContent();
        el.removeTextConfig();
        el.disableLabelAnimation = null;
    }
}
function $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx) {
    // setItemGraphicEl, setHoverStyle after all polygons and labels
    // are added to the regionGroup
    if (viewBuildCtx.data) // FIXME: when series-map use a SVG map, and there are duplicated name specified
    // on different SVG elements, after `data.setItemGraphicEl(...)`:
    // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
    // can be triggered only mouse hover. That's correct.
    // (2) only the last element will be kept in `data`, so that if trigger tooltip
    // by `dispatchAction`, only the last one can be found and triggered. That might be
    // not correct. We will fix it in future if anyone demanding that.
    viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
    else // Package custom mouse event for geo component
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(eventTrigger).eventData = {
        componentType: "geo",
        componentIndex: mapOrGeoModel.componentIndex,
        geoIndex: mapOrGeoModel.componentIndex,
        name: regionName,
        region: regionModel && regionModel.option || {}
    };
}
function $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    if (!viewBuildCtx.data) $5b455ae6f843ac47$export$fc6410d97fab306c({
        el: el,
        componentModel: mapOrGeoModel,
        itemName: regionName,
        // @ts-ignore FIXME:TS fix the "compatible with each other"?
        itemTooltipOption: regionModel.get("tooltip")
    });
}
function $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    el.highDownSilentOnTouch = !!mapOrGeoModel.get("selectedMode");
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    var emphasisModel = regionModel.getModel("emphasis");
    var focus = emphasisModel.get("focus");
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    if (viewBuildCtx.isGeo) (0, $2bf82c0980125b62$export$4da05a9639f01954)(el, mapOrGeoModel, regionName);
    return focus;
}
function $ad029c27e0f2a7ab$var$projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
createStream, isLine) {
    var polygons = [];
    var curPoly;
    function startPolygon() {
        curPoly = [];
    }
    function endPolygon() {
        if (curPoly.length) {
            polygons.push(curPoly);
            curPoly = [];
        }
    }
    var stream = createStream({
        polygonStart: startPolygon,
        polygonEnd: endPolygon,
        lineStart: startPolygon,
        lineEnd: endPolygon,
        point: function(x, y) {
            // May have NaN values from stream.
            if (isFinite(x) && isFinite(y)) curPoly.push([
                x,
                y
            ]);
        },
        sphere: function() {}
    });
    !isLine && stream.polygonStart();
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(rings, function(ring) {
        stream.lineStart();
        for(var i = 0; i < ring.length; i++)stream.point(ring[i][0], ring[i][1]);
        stream.lineEnd();
    });
    !isLine && stream.polygonEnd();
    return polygons;
}
var $ad029c27e0f2a7ab$export$2e2bcd8739ae039 // @ts-ignore FIXME:TS fix the "compatible with each other"?
 = $ad029c27e0f2a7ab$var$MapDraw;





var $1c3add93106395a4$var$MapView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MapView, _super);
    function MapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapView.type;
        return _this;
    }
    MapView.prototype.render = function(mapModel, ecModel, api, payload) {
        // Not render if it is an toggleSelect action from self
        if (payload && payload.type === "mapToggleSelect" && payload.from === this.uid) return;
        var group = this.group;
        group.removeAll();
        if (mapModel.getHostGeoModel()) return;
        if (this._mapDraw && payload && payload.type === "geoRoam") this._mapDraw.resetForLabelLayout();
        // Not update map if it is an roam action from self
        if (!(payload && payload.type === "geoRoam" && payload.componentType === "series" && payload.seriesId === mapModel.id)) {
            if (mapModel.needsDrawMap) {
                var mapDraw = this._mapDraw || new (0, $ad029c27e0f2a7ab$export$2e2bcd8739ae039)(api);
                group.add(mapDraw.group);
                mapDraw.draw(mapModel, ecModel, api, this, payload);
                this._mapDraw = mapDraw;
            } else {
                // Remove drawn map
                this._mapDraw && this._mapDraw.remove();
                this._mapDraw = null;
            }
        } else {
            var mapDraw = this._mapDraw;
            mapDraw && group.add(mapDraw.group);
        }
        mapModel.get("showLegendSymbol") && ecModel.getComponent("legend") && this._renderSymbols(mapModel, ecModel, api);
    };
    MapView.prototype.remove = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
        this.group.removeAll();
    };
    MapView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
    };
    MapView.prototype._renderSymbols = function(mapModel, ecModel, api) {
        var originalData = mapModel.originalData;
        var group = this.group;
        originalData.each(originalData.mapDimension("value"), function(value, originalDataIndex) {
            if (isNaN(value)) return;
            var layout = originalData.getItemLayout(originalDataIndex);
            if (!layout || !layout.point) // Not exists in map
            return;
            var point = layout.point;
            var offset = layout.offset;
            var circle = new $1e68d8727773abb7$export$2e2bcd8739ae039({
                style: {
                    // Because the special of map draw.
                    // Which needs statistic of multiple series and draw on one map.
                    // And each series also need a symbol with legend color
                    //
                    // Layout and visual are put one the different data
                    // TODO
                    fill: mapModel.getData().getVisual("style").fill
                },
                shape: {
                    cx: point[0] + offset * 9,
                    cy: point[1],
                    r: 3
                },
                silent: true,
                // Do not overlap the first series, on which labels are displayed.
                z2: 8 + (!offset ? (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) + 1 : 0)
            });
            // Only the series that has the first value on the same region is in charge of rendering the label.
            // But consider the case:
            // series: [
            //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
            //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
            // ]
            // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
            // For backward compatibility, we follow the rule that render label `A` by the
            // settings on series `X` but render label `C` by the settings on series `Y`.
            if (!offset) {
                var fullData = mapModel.mainSeries.getData();
                var name_1 = originalData.getName(originalDataIndex);
                var fullIndex_1 = fullData.indexOfName(name_1);
                var itemModel = originalData.getItemModel(originalDataIndex);
                var labelModel = itemModel.getModel("label");
                var regionGroup = fullData.getItemGraphicEl(fullIndex_1);
                // `getFormattedLabel` needs to use `getData` inside. Here
                // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
                // FIXME
                // If this is not the `mainSeries`, the item model (like label formatter)
                // set on original data item will never get. But it has been working
                // like that from the beginning, and this scenario is rarely encountered.
                // So it won't be fixed until we have to.
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(circle, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                    labelFetcher: {
                        getFormattedLabel: function(idx, state) {
                            return mapModel.getFormattedLabel(fullIndex_1, state);
                        }
                    },
                    defaultText: name_1
                });
                circle.disableLabelAnimation = true;
                if (!labelModel.get("position")) circle.setTextConfig({
                    position: "bottom"
                });
                regionGroup.onHoverStateChange = function(toState) {
                    (0, $2bf82c0980125b62$export$868ba38adffa9e39)(circle, toState);
                };
            }
            group.add(circle);
        });
    };
    MapView.type = "map";
    return MapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $1c3add93106395a4$export$2e2bcd8739ae039 = $1c3add93106395a4$var$MapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $f2f4aa5429e1d3d3$var$MapSeries = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MapSeries, _super);
    function MapSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapSeries.type;
        // Only first map series of same mapType will drawMap.
        _this.needsDrawMap = false;
        // Group of all map series with same mapType
        _this.seriesGroup = [];
        _this.getTooltipPosition = function(dataIndex) {
            if (dataIndex != null) {
                var name_1 = this.getData().getName(dataIndex);
                var geo = this.coordinateSystem;
                var region = geo.getRegion(name_1);
                return region && geo.dataToPoint(region.getCenter());
            }
        };
        return _this;
    }
    MapSeries.prototype.getInitialData = function(option) {
        var data = (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
        var dataNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var toAppendNames = [];
        for(var i = 0, len = data.count(); i < len; i++){
            var name_2 = data.getName(i);
            dataNameMap.set(name_2, true);
        }
        var geoSource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(geoSource.regions, function(region) {
            var name = region.name;
            if (!dataNameMap.get(name)) toAppendNames.push(name);
        });
        // Complete data with missing regions. The consequent processes (like visual
        // map and render) can not be performed without a "full data". For example,
        // find `dataIndex` by name.
        data.appendValues([], toAppendNames);
        return data;
    };
    /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */ MapSeries.prototype.getHostGeoModel = function() {
        var geoIndex = this.option.geoIndex;
        return geoIndex != null ? this.ecModel.getComponent("geo", geoIndex) : null;
    };
    MapSeries.prototype.getMapType = function() {
        return (this.getHostGeoModel() || this).option.map;
    };
    // _fillOption(option, mapName) {
    // Shallow clone
    // option = zrUtil.extend({}, option);
    // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
    // return option;
    // }
    MapSeries.prototype.getRawValue = function(dataIndex) {
        // Use value stored in data instead because it is calculated from multiple series
        // FIXME Provide all value of multiple series ?
        var data = this.getData();
        return data.get(data.mapDimension("value"), dataIndex);
    };
    /**
   * Get model of region
   */ MapSeries.prototype.getRegionModel = function(regionName) {
        var data = this.getData();
        return data.getItemModel(data.indexOfName(regionName));
    };
    /**
   * Map tooltip formatter
   */ MapSeries.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // FIXME orignalData and data is a bit confusing
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        var seriesGroup = this.seriesGroup;
        var seriesNames = [];
        for(var i = 0; i < seriesGroup.length; i++){
            var otherIndex = seriesGroup[i].originalData.indexOfName(name);
            var valueDim = data.mapDimension("value");
            if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) seriesNames.push(seriesGroup[i].name);
        }
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: seriesNames.join(", "),
            noHeader: !seriesNames.length,
            blocks: [
                (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    name: name,
                    value: value
                })
            ]
        });
    };
    MapSeries.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    MapSeries.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    MapSeries.prototype.getLegendIcon = function(opt) {
        var iconType = opt.icon || "roundRect";
        var icon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
        icon.setStyle(opt.itemStyle);
        // Map do not use itemStyle.borderWidth as border width
        icon.style.stroke = "none";
        // No rotation because no series visual symbol for map
        if (iconType.indexOf("empty") > -1) {
            icon.style.stroke = icon.style.fill;
            icon.style.fill = "#fff";
            icon.style.lineWidth = 2;
        }
        return icon;
    };
    MapSeries.type = "series.map";
    MapSeries.dependencies = [
        "geo"
    ];
    MapSeries.layoutMode = "box";
    MapSeries.defaultOption = {
        // 一级层叠
        // zlevel: 0,
        // 二级层叠
        z: 2,
        coordinateSystem: "geo",
        // map should be explicitly specified since ec3.
        map: "",
        // If `geoIndex` is not specified, a exclusive geo will be
        // created. Otherwise use the specified geo component, and
        // `map` and `mapType` are ignored.
        // geoIndex: 0,
        // 'center' | 'left' | 'right' | 'x%' | {number}
        left: "center",
        // 'center' | 'top' | 'bottom' | 'x%' | {number}
        top: "center",
        // right
        // bottom
        // width:
        // height
        // Aspect is width / height. Inited to be geoJson bbox aspect
        // This parameter is used for scale this aspect
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient.
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        showLegendSymbol: true,
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ],
        // higher priority than center and zoom
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        selectedMode: true,
        label: {
            show: false,
            color: "#000"
        },
        // scaleLimit: null,
        itemStyle: {
            borderWidth: 0.5,
            borderColor: "#444",
            areaColor: "#eee"
        },
        emphasis: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                areaColor: "rgba(255,215,0,0.8)"
            }
        },
        select: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                color: "rgba(255,215,0,0.8)"
            }
        },
        nameProperty: "name"
    };
    return MapSeries;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $f2f4aa5429e1d3d3$export$2e2bcd8739ae039 = $f2f4aa5429e1d3d3$var$MapSeries;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// FIXME 公用？
function $5e3d42588445ae72$var$dataStatistics(datas, statisticType) {
    var dataNameMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(datas, function(data) {
        data.each(data.mapDimension("value"), function(value, idx) {
            // Add prefix to avoid conflict with Object.prototype.
            var mapKey = "ec-" + data.getName(idx);
            dataNameMap[mapKey] = dataNameMap[mapKey] || [];
            if (!isNaN(value)) dataNameMap[mapKey].push(value);
        });
    });
    return datas[0].map(datas[0].mapDimension("value"), function(value, idx) {
        var mapKey = "ec-" + datas[0].getName(idx);
        var sum = 0;
        var min = Infinity;
        var max = -Infinity;
        var len = dataNameMap[mapKey].length;
        for(var i = 0; i < len; i++){
            min = Math.min(min, dataNameMap[mapKey][i]);
            max = Math.max(max, dataNameMap[mapKey][i]);
            sum += dataNameMap[mapKey][i];
        }
        var result;
        if (statisticType === "min") result = min;
        else if (statisticType === "max") result = max;
        else if (statisticType === "average") result = sum / len;
        else result = sum;
        return len === 0 ? NaN : result;
    });
}
function $5e3d42588445ae72$export$2e2bcd8739ae039(ecModel) {
    var seriesGroups = {};
    ecModel.eachSeriesByType("map", function(seriesModel) {
        var hostGeoModel = seriesModel.getHostGeoModel();
        var key = hostGeoModel ? "o" + hostGeoModel.id : "i" + seriesModel.getMapType();
        (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesGroups, function(seriesList, key) {
        var data = $5e3d42588445ae72$var$dataStatistics($7a1bd9c2710fea0d$export$871de8747c9eaa88(seriesList, function(seriesModel) {
            return seriesModel.getData();
        }), seriesList[0].get("mapValueCalculation"));
        for(var i = 0; i < seriesList.length; i++)seriesList[i].originalData = seriesList[i].getData();
        // FIXME Put where?
        for(var i = 0; i < seriesList.length; i++){
            seriesList[i].seriesGroup = seriesList;
            seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
            seriesList[i].setData(data.cloneShallow());
            seriesList[i].mainSeries = seriesList[0];
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $53e61890435fb2d8$export$2e2bcd8739ae039(ecModel) {
    var processedMapType = {};
    ecModel.eachSeriesByType("map", function(mapSeries) {
        var mapType = mapSeries.getMapType();
        if (mapSeries.getHostGeoModel() || processedMapType[mapType]) return;
        var mapSymbolOffsets = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapSeries.seriesGroup, function(subMapSeries) {
            var geo = subMapSeries.coordinateSystem;
            var data = subMapSeries.originalData;
            if (subMapSeries.get("showLegendSymbol") && ecModel.getComponent("legend")) data.each(data.mapDimension("value"), function(value, idx) {
                var name = data.getName(idx);
                var region = geo.getRegion(name);
                // If input series.data is [11, 22, '-'/null/undefined, 44],
                // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
                // not be drawn. So here must validate if value is NaN.
                if (!region || isNaN(value)) return;
                var offset = mapSymbolOffsets[name] || 0;
                var point = geo.dataToPoint(region.getCenter());
                mapSymbolOffsets[name] = offset + 1;
                data.setItemLayout(idx, {
                    point: point,
                    offset: offset
                });
            });
        });
        // Show label of those region not has legendIcon (which is offset 0)
        var data = mapSeries.getData();
        data.each(function(idx) {
            var name = data.getName(idx);
            var layout = data.getItemLayout(idx) || {};
            layout.showLabel = !mapSymbolOffsets[name];
            data.setItemLayout(idx, layout);
        });
        processedMapType[mapType] = true;
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $4a92e7570d47c1fe$var$v2ApplyTransform = $6de594cf8ac295ff$export$9f9dcb98c894b623;
var $4a92e7570d47c1fe$var$View = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(View, _super);
    function View(name) {
        var _this = _super.call(this) || this;
        _this.type = "view";
        _this.dimensions = [
            "x",
            "y"
        ];
        /**
     * Represents the transform brought by roam/zoom.
     * If `View['_viewRect']` applies roam transform,
     * we can get the final displayed rect.
     */ _this._roamTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        /**
     * Represents the transform from `View['_rect']` to `View['_viewRect']`.
     */ _this._rawTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        _this.name = name;
        return _this;
    }
    View.prototype.setBoundingRect = function(x, y, width, height) {
        this._rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
        return this._rect;
    };
    /**
   * @return {module:zrender/core/BoundingRect}
   */ View.prototype.getBoundingRect = function() {
        return this._rect;
    };
    View.prototype.setViewRect = function(x, y, width, height) {
        this._transformTo(x, y, width, height);
        this._viewRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    };
    /**
   * Transformed to particular position and size
   */ View.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var rawTransform = this._rawTransformable;
        rawTransform.transform = rect.calculateTransform(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransform.parent;
        rawTransform.parent = null;
        rawTransform.decomposeTransform();
        rawTransform.parent = rawParent;
        this._updateTransform();
    };
    /**
   * Set center of view
   */ View.prototype.setCenter = function(centerCoord, api) {
        if (!centerCoord) return;
        this._center = [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerCoord[0], api.getWidth()),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerCoord[1], api.getHeight())
        ];
        this._updateCenterAndZoom();
    };
    View.prototype.setZoom = function(zoom) {
        zoom = zoom || 1;
        var zoomLimit = this.zoomLimit;
        if (zoomLimit) {
            if (zoomLimit.max != null) zoom = Math.min(zoomLimit.max, zoom);
            if (zoomLimit.min != null) zoom = Math.max(zoomLimit.min, zoom);
        }
        this._zoom = zoom;
        this._updateCenterAndZoom();
    };
    /**
   * Get default center without roam
   */ View.prototype.getDefaultCenter = function() {
        // Rect before any transform
        var rawRect = this.getBoundingRect();
        var cx = rawRect.x + rawRect.width / 2;
        var cy = rawRect.y + rawRect.height / 2;
        return [
            cx,
            cy
        ];
    };
    View.prototype.getCenter = function() {
        return this._center || this.getDefaultCenter();
    };
    View.prototype.getZoom = function() {
        return this._zoom || 1;
    };
    View.prototype.getRoamTransform = function() {
        return this._roamTransformable.getLocalTransform();
    };
    /**
   * Remove roam
   */ View.prototype._updateCenterAndZoom = function() {
        // Must update after view transform updated
        var rawTransformMatrix = this._rawTransformable.getLocalTransform();
        var roamTransform = this._roamTransformable;
        var defaultCenter = this.getDefaultCenter();
        var center = this.getCenter();
        var zoom = this.getZoom();
        center = $6de594cf8ac295ff$export$9f9dcb98c894b623([], center, rawTransformMatrix);
        defaultCenter = $6de594cf8ac295ff$export$9f9dcb98c894b623([], defaultCenter, rawTransformMatrix);
        roamTransform.originX = center[0];
        roamTransform.originY = center[1];
        roamTransform.x = defaultCenter[0] - center[0];
        roamTransform.y = defaultCenter[1] - center[1];
        roamTransform.scaleX = roamTransform.scaleY = zoom;
        this._updateTransform();
    };
    /**
   * Update transform props on `this` based on the current
   * `this._roamTransformable` and `this._rawTransformable`.
   */ View.prototype._updateTransform = function() {
        var roamTransformable = this._roamTransformable;
        var rawTransformable = this._rawTransformable;
        rawTransformable.parent = roamTransformable;
        roamTransformable.updateTransform();
        rawTransformable.updateTransform();
        $f41ebb9dd60b55b4$export$784d13d8ee351f07(this.transform || (this.transform = []), rawTransformable.transform || $f41ebb9dd60b55b4$export$185802fd694ee1f5());
        this._rawTransform = rawTransformable.getLocalTransform();
        this.invTransform = this.invTransform || [];
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this.invTransform, this.transform);
        this.decomposeTransform();
    };
    View.prototype.getTransformInfo = function() {
        var rawTransformable = this._rawTransformable;
        var roamTransformable = this._roamTransformable;
        // Because roamTransformabel has `originX/originY` modified,
        // but the caller of `getTransformInfo` can not handle `originX/originY`,
        // so need to recalculate them.
        var dummyTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        dummyTransformable.transform = roamTransformable.transform;
        dummyTransformable.decomposeTransform();
        return {
            roam: {
                x: dummyTransformable.x,
                y: dummyTransformable.y,
                scaleX: dummyTransformable.scaleX,
                scaleY: dummyTransformable.scaleY
            },
            raw: {
                x: rawTransformable.x,
                y: rawTransformable.y,
                scaleX: rawTransformable.scaleX,
                scaleY: rawTransformable.scaleY
            }
        };
    };
    View.prototype.getViewRect = function() {
        return this._viewRect;
    };
    /**
   * Get view rect after roam transform
   */ View.prototype.getViewRectAfterRoam = function() {
        var rect = this.getBoundingRect().clone();
        rect.applyTransform(this.transform);
        return rect;
    };
    /**
   * Convert a single (lon, lat) data item to (x, y) point.
   */ View.prototype.dataToPoint = function(data, noRoam, out) {
        var transform = noRoam ? this._rawTransform : this.transform;
        out = out || [];
        return transform ? $4a92e7570d47c1fe$var$v2ApplyTransform(out, data, transform) : $6de594cf8ac295ff$export$784d13d8ee351f07(out, data);
    };
    /**
   * Convert a (x, y) point to (lon, lat) data
   */ View.prototype.pointToData = function(point) {
        var invTransform = this.invTransform;
        return invTransform ? $4a92e7570d47c1fe$var$v2ApplyTransform([], point, invTransform) : [
            point[0],
            point[1]
        ];
    };
    View.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $4a92e7570d47c1fe$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    View.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $4a92e7570d47c1fe$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    /**
   * @implements
   */ View.prototype.containPoint = function(point) {
        return this.getViewRectAfterRoam().contain(point[0], point[1]);
    };
    View.dimensions = [
        "x",
        "y"
    ];
    return View;
}((0, $becf2d727f9cf450$export$2e2bcd8739ae039));
function $4a92e7570d47c1fe$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
}
var $4a92e7570d47c1fe$export$2e2bcd8739ae039 = $4a92e7570d47c1fe$var$View;





var $e67116e61e57a131$var$GEO_DEFAULT_PARAMS = {
    "geoJSON": {
        aspectScale: 0.75,
        invertLongitute: true
    },
    "geoSVG": {
        aspectScale: 1,
        invertLongitute: false
    }
};
var $e67116e61e57a131$export$10dbc57975912e0f = [
    "lng",
    "lat"
];
var $e67116e61e57a131$var$Geo = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Geo, _super);
    function Geo(name, map, opt) {
        var _this = _super.call(this, name) || this;
        _this.dimensions = $e67116e61e57a131$export$10dbc57975912e0f;
        _this.type = "geo";
        // Only store specified name coord via `addGeoCoord`.
        _this._nameCoordMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        _this.map = map;
        var projection = opt.projection;
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(map, opt.nameMap, opt.nameProperty);
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(map);
        var resourceType = _this.resourceType = resource ? resource.type : null;
        var regions = _this.regions = source.regions;
        var defaultParams = $e67116e61e57a131$var$GEO_DEFAULT_PARAMS[resource.type];
        _this._regionsMap = source.regionsMap;
        _this.regions = source.regions;
        _this.projection = projection;
        var boundingRect;
        if (projection) // Can't reuse the raw bounding rect
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect(projection);
            boundingRect = boundingRect || regionRect.clone();
            boundingRect.union(regionRect);
        }
        else boundingRect = source.boundingRect;
        _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height);
        // aspectScale and invertLongitute actually is the parameters default raw projection.
        // So we ignore them if projection is given.
        // Ignore default aspect scale if projection exits.
        _this.aspectScale = projection ? 1 : $7a1bd9c2710fea0d$export$995e01f2f5c9d030(opt.aspectScale, defaultParams.aspectScale);
        // Not invert longitude if projection exits.
        _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
        return _this;
    }
    Geo.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var invertLongitute = this._invertLongitute;
        rect = rect.clone();
        if (invertLongitute) // Longitude is inverted.
        rect.y = -rect.y - rect.height;
        var rawTransformable = this._rawTransformable;
        rawTransformable.transform = rect.calculateTransform(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransformable.parent;
        rawTransformable.parent = null;
        rawTransformable.decomposeTransform();
        rawTransformable.parent = rawParent;
        if (invertLongitute) rawTransformable.scaleY = -rawTransformable.scaleY;
        this._updateTransform();
    };
    Geo.prototype.getRegion = function(name) {
        return this._regionsMap.get(name);
    };
    Geo.prototype.getRegionByCoord = function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            var region = regions[i];
            if (region.type === "geoJSON" && region.contain(coord)) return regions[i];
        }
    };
    /**
   * Add geoCoord for indexing by name
   */ Geo.prototype.addGeoCoord = function(name, geoCoord) {
        this._nameCoordMap.set(name, geoCoord);
    };
    /**
   * Get geoCoord by name
   */ Geo.prototype.getGeoCoord = function(name) {
        var region = this._regionsMap.get(name);
        // Calculate center only on demand.
        return this._nameCoordMap.get(name) || region && region.getCenter();
    };
    Geo.prototype.dataToPoint = function(data, noRoam, out) {
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(data)) // Map area name to geoCoord
        data = this.getGeoCoord(data);
        if (data) {
            var projection = this.projection;
            if (projection) // projection may return null point.
            data = projection.project(data);
            return data && this.projectedToPoint(data, noRoam, out);
        }
    };
    Geo.prototype.pointToData = function(point) {
        var projection = this.projection;
        if (projection) // projection may return null point.
        point = projection.unproject(point);
        return point && this.pointToProjected(point);
    };
    /**
   * Point to projected data. Same with pointToData when projection is used.
   */ Geo.prototype.pointToProjected = function(point) {
        return _super.prototype.pointToData.call(this, point);
    };
    Geo.prototype.projectedToPoint = function(projected, noRoam, out) {
        return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
    };
    Geo.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $e67116e61e57a131$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Geo.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $e67116e61e57a131$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    return Geo;
}((0, $4a92e7570d47c1fe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($e67116e61e57a131$var$Geo, (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039));
function $e67116e61e57a131$var$getCoordSys(finder) {
    var geoModel = finder.geoModel;
    var seriesModel = finder.seriesModel;
    return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
     || (seriesModel.getReferringComponents("geo", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0] || {}).coordinateSystem : null;
}
var $e67116e61e57a131$export$2e2bcd8739ae039 = $e67116e61e57a131$var$Geo;






/**
 * Resize method bound to the geo
 */ function $303164fe3ecc2dc5$var$resizeGeo(geoModel, api) {
    var boundingCoords = geoModel.get("boundingCoords");
    if (boundingCoords != null) {
        var leftTop_1 = boundingCoords[0];
        var rightBottom_1 = boundingCoords[1];
        if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) ;
        else {
            // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
            var projection_1 = this.projection;
            if (projection_1) {
                var xMin = leftTop_1[0];
                var yMin = leftTop_1[1];
                var xMax = rightBottom_1[0];
                var yMax = rightBottom_1[1];
                leftTop_1 = [
                    Infinity,
                    Infinity
                ];
                rightBottom_1 = [
                    -Infinity,
                    -Infinity
                ];
                // TODO better way?
                var sampleLine = function(x0, y0, x1, y1) {
                    var dx = x1 - x0;
                    var dy = y1 - y0;
                    for(var i = 0; i <= 100; i++){
                        var p = i / 100;
                        var pt = projection_1.project([
                            x0 + dx * p,
                            y0 + dy * p
                        ]);
                        $6de594cf8ac295ff$export$96ec731ed4dcb222(leftTop_1, leftTop_1, pt);
                        $6de594cf8ac295ff$export$8960430cfd85939f(rightBottom_1, rightBottom_1, pt);
                    }
                };
                // Top
                sampleLine(xMin, yMin, xMax, yMin);
                // Right
                sampleLine(xMax, yMin, xMax, yMax);
                // Bottom
                sampleLine(xMax, yMax, xMin, yMax);
                // Left
                sampleLine(xMin, yMax, xMax, yMin);
            }
            this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
        }
    }
    var rect = this.getBoundingRect();
    var centerOption = geoModel.get("layoutCenter");
    var sizeOption = geoModel.get("layoutSize");
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    var aspect = rect.width / rect.height * this.aspectScale;
    var useCenterAndSize = false;
    var center;
    var size;
    if (centerOption && sizeOption) {
        center = [
            $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(centerOption[0], viewWidth),
            $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(centerOption[1], viewHeight)
        ];
        size = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(sizeOption, Math.min(viewWidth, viewHeight));
        if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) useCenterAndSize = true;
    }
    var viewRect;
    if (useCenterAndSize) {
        viewRect = {};
        if (aspect > 1) {
            // Width is same with size
            viewRect.width = size;
            viewRect.height = size / aspect;
        } else {
            viewRect.height = size;
            viewRect.width = size * aspect;
        }
        viewRect.y = center[1] - viewRect.height / 2;
        viewRect.x = center[0] - viewRect.width / 2;
    } else {
        // Use left/top/width/height
        var boxLayoutOption = geoModel.getBoxLayoutParams();
        boxLayoutOption.aspect = aspect;
        viewRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(boxLayoutOption, {
            width: viewWidth,
            height: viewHeight
        });
    }
    this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
    this.setCenter(geoModel.get("center"), api);
    this.setZoom(geoModel.get("zoom"));
}
// Back compat for ECharts2, where the coord map is set on map series:
// {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},
function $303164fe3ecc2dc5$var$setGeoCoords(geo, model) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("geoCoord"), function(geoCoord, name) {
        geo.addGeoCoord(name, geoCoord);
    });
}
var $303164fe3ecc2dc5$var$GeoCreator = /** @class */ function() {
    function GeoCreator() {
        // For deciding which dimensions to use when creating list data
        this.dimensions = (0, $e67116e61e57a131$export$10dbc57975912e0f);
    }
    GeoCreator.prototype.create = function(ecModel, api) {
        var geoList = [];
        function getCommonGeoProperties(model) {
            return {
                nameProperty: model.get("nameProperty"),
                aspectScale: model.get("aspectScale"),
                projection: model.get("projection")
            };
        }
        // FIXME Create each time may be slow
        ecModel.eachComponent("geo", function(geoModel, idx) {
            var mapName = geoModel.get("map");
            var geo = new (0, $e67116e61e57a131$export$2e2bcd8739ae039)(mapName + idx, mapName, $7a1bd9c2710fea0d$export$8b58be045bf06082({
                nameMap: geoModel.get("nameMap")
            }, getCommonGeoProperties(geoModel)));
            geo.zoomLimit = geoModel.get("scaleLimit");
            geoList.push(geo);
            // setGeoCoords(geo, geoModel);
            geoModel.coordinateSystem = geo;
            geo.model = geoModel;
            // Inject resize method
            geo.resize = $303164fe3ecc2dc5$var$resizeGeo;
            geo.resize(geoModel, api);
        });
        ecModel.eachSeries(function(seriesModel) {
            var coordSys = seriesModel.get("coordinateSystem");
            if (coordSys === "geo") {
                var geoIndex = seriesModel.get("geoIndex") || 0;
                seriesModel.coordinateSystem = geoList[geoIndex];
            }
        });
        // If has map series
        var mapModelGroupBySeries = {};
        ecModel.eachSeriesByType("map", function(seriesModel) {
            if (!seriesModel.getHostGeoModel()) {
                var mapType = seriesModel.getMapType();
                mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
                mapModelGroupBySeries[mapType].push(seriesModel);
            }
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapModelGroupBySeries, function(mapSeries, mapType) {
            var nameMapList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get("nameMap");
            });
            var geo = new (0, $e67116e61e57a131$export$2e2bcd8739ae039)(mapType, mapType, $7a1bd9c2710fea0d$export$8b58be045bf06082({
                nameMap: $7a1bd9c2710fea0d$export$18aef43295bbe906(nameMapList)
            }, getCommonGeoProperties(mapSeries[0])));
            geo.zoomLimit = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66.apply(null, $7a1bd9c2710fea0d$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get("scaleLimit");
            }));
            geoList.push(geo);
            // Inject resize method
            geo.resize = $303164fe3ecc2dc5$var$resizeGeo;
            geo.resize(mapSeries[0], api);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapSeries, function(singleMapSeries) {
                singleMapSeries.coordinateSystem = geo;
                $303164fe3ecc2dc5$var$setGeoCoords(geo, singleMapSeries);
            });
        });
        return geoList;
    };
    /**
   * Fill given regions array
   */ GeoCreator.prototype.getFilledRegions = function(originRegionArr, mapName, nameMap, nameProperty) {
        // Not use the original
        var regionsArr = (originRegionArr || []).slice();
        var dataNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        for(var i = 0; i < regionsArr.length; i++)dataNameMap.set(regionsArr[i].name, regionsArr[i]);
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(mapName, nameMap, nameProperty);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(source.regions, function(region) {
            var name = region.name;
            !dataNameMap.get(name) && regionsArr.push({
                name: name
            });
        });
        return regionsArr;
    };
    return GeoCreator;
}();
var $303164fe3ecc2dc5$var$geoCreator = new $303164fe3ecc2dc5$var$GeoCreator();
var $303164fe3ecc2dc5$export$2e2bcd8739ae039 = $303164fe3ecc2dc5$var$geoCreator;



var $4ff027656cc71ef0$var$GeoModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GeoModel, _super);
    function GeoModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoModel.type;
        return _this;
    }
    GeoModel.prototype.init = function(option, parentModel, ecModel) {
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(option.map);
        if (source && source.type === "geoJSON") {
            var itemStyle = option.itemStyle = option.itemStyle || {};
            if (!("color" in itemStyle)) itemStyle.color = "#eee";
        }
        this.mergeDefaultAndTheme(option, ecModel);
        // Default label emphasis `show`
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
    };
    GeoModel.prototype.optionUpdated = function() {
        var _this = this;
        var option = this.option;
        option.regions = (0, $303164fe3ecc2dc5$export$2e2bcd8739ae039).getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
        var selectedMap = {};
        this._optionModelMap = $7a1bd9c2710fea0d$export$533b26079ad0b4b(option.regions || [], function(optionModelMap, regionOpt) {
            var regionName = regionOpt.name;
            if (regionName) {
                optionModelMap.set(regionName, new (0, $6818646a97528290$export$2e2bcd8739ae039)(regionOpt, _this, _this.ecModel));
                if (regionOpt.selected) selectedMap[regionName] = true;
            }
            return optionModelMap;
        }, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4());
        if (!option.selectedMap) option.selectedMap = selectedMap;
    };
    /**
   * Get model of region.
   */ GeoModel.prototype.getRegionModel = function(name) {
        return this._optionModelMap.get(name) || new (0, $6818646a97528290$export$2e2bcd8739ae039)(null, this, this.ecModel);
    };
    /**
   * Format label
   * @param name Region name
   */ GeoModel.prototype.getFormattedLabel = function(name, status) {
        var regionModel = this.getRegionModel(name);
        var formatter = status === "normal" ? regionModel.get([
            "label",
            "formatter"
        ]) : regionModel.get([
            "emphasis",
            "label",
            "formatter"
        ]);
        var params = {
            name: name
        };
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            return formatter(params);
        } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) return formatter.replace("{a}", name != null ? name : "");
    };
    GeoModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GeoModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    // PENGING If selectedMode is null ?
    GeoModel.prototype.select = function(name) {
        var option = this.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        if (selectedMode !== "multiple") option.selectedMap = null;
        var selectedMap = option.selectedMap || (option.selectedMap = {});
        selectedMap[name] = true;
    };
    GeoModel.prototype.unSelect = function(name) {
        var selectedMap = this.option.selectedMap;
        if (selectedMap) selectedMap[name] = false;
    };
    GeoModel.prototype.toggleSelected = function(name) {
        this[this.isSelected(name) ? "unSelect" : "select"](name);
    };
    GeoModel.prototype.isSelected = function(name) {
        var selectedMap = this.option.selectedMap;
        return !!(selectedMap && selectedMap[name]);
    };
    GeoModel.type = "geo";
    GeoModel.layoutMode = "box";
    GeoModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        show: true,
        left: "center",
        top: "center",
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // /// Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        silent: false,
        // Map type
        map: "",
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ]
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        // selectedMode: false
        label: {
            show: false,
            color: "#000"
        },
        itemStyle: {
            borderWidth: 0.5,
            borderColor: "#444"
        },
        emphasis: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                color: "rgba(255,215,0,0.8)"
            }
        },
        select: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                color: "rgba(255,215,0,0.8)"
            }
        },
        regions: []
    };
    return GeoModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $4ff027656cc71ef0$export$2e2bcd8739ae039 = $4ff027656cc71ef0$var$GeoModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $799fe5cfb5042219$var$getCenterCoord(view, point) {
    // Use projected coord as center because it's linear.
    return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
}
function $799fe5cfb5042219$export$797ecc50d262ebd8(view, payload, zoomLimit, api) {
    var previousZoom = view.getZoom();
    var center = view.getCenter();
    var zoom = payload.zoom;
    var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);
    if (payload.dx != null && payload.dy != null) {
        point[0] -= payload.dx;
        point[1] -= payload.dy;
        view.setCenter($799fe5cfb5042219$var$getCenterCoord(view, point), api);
    }
    if (zoom != null) {
        if (zoomLimit) {
            var zoomMin = zoomLimit.min || 0;
            var zoomMax = zoomLimit.max || Infinity;
            zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
        }
        // Zoom on given point(originX, originY)
        view.scaleX *= zoom;
        view.scaleY *= zoom;
        var fixX = (payload.originX - view.x) * (zoom - 1);
        var fixY = (payload.originY - view.y) * (zoom - 1);
        view.x -= fixX;
        view.y -= fixY;
        view.updateTransform();
        // Get the new center
        view.setCenter($799fe5cfb5042219$var$getCenterCoord(view, point), api);
        view.setZoom(zoom * previousZoom);
    }
    return {
        center: view.getCenter(),
        zoom: view.getZoom()
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $26ced9bb0cf549b8$var$GeoView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GeoView, _super);
    function GeoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoView.type;
        _this.focusBlurEnabled = true;
        return _this;
    }
    GeoView.prototype.init = function(ecModel, api) {
        this._api = api;
    };
    GeoView.prototype.render = function(geoModel, ecModel, api, payload) {
        this._model = geoModel;
        if (!geoModel.get("show")) {
            this._mapDraw && this._mapDraw.remove();
            this._mapDraw = null;
            return;
        }
        if (!this._mapDraw) this._mapDraw = new (0, $ad029c27e0f2a7ab$export$2e2bcd8739ae039)(api);
        var mapDraw = this._mapDraw;
        mapDraw.draw(geoModel, ecModel, api, this, payload);
        mapDraw.group.on("click", this._handleRegionClick, this);
        mapDraw.group.silent = geoModel.get("silent");
        this.group.add(mapDraw.group);
        this.updateSelectStatus(geoModel, ecModel, api);
    };
    GeoView.prototype._handleRegionClick = function(e) {
        var eventData;
        (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(e.target, function(current) {
            return (eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(current).eventData) != null;
        }, true);
        if (eventData) this._api.dispatchAction({
            type: "geoToggleSelect",
            geoId: this._model.id,
            name: eventData.name
        });
    };
    GeoView.prototype.updateSelectStatus = function(model, ecModel, api) {
        var _this = this;
        this._mapDraw.group.traverse(function(node) {
            var eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(node).eventData;
            if (eventData) {
                _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node);
                // No need to traverse children.
                return true;
            }
        });
    };
    GeoView.prototype.findHighDownDispatchers = function(name) {
        return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
    };
    GeoView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
    };
    GeoView.type = "geo";
    return GeoView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $26ced9bb0cf549b8$export$2e2bcd8739ae039 = $26ced9bb0cf549b8$var$GeoView;



function $8082b8b129488d44$var$registerMap(mapName, geoJson, specialAreas) {
    (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).registerMap(mapName, geoJson, specialAreas);
}
function $8082b8b129488d44$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem("geo", (0, $303164fe3ecc2dc5$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $4ff027656cc71ef0$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $26ced9bb0cf549b8$export$2e2bcd8739ae039));
    registers.registerImpl("registerMap", $8082b8b129488d44$var$registerMap);
    registers.registerImpl("getMap", function(mapName) {
        return (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getMapForUser(mapName);
    });
    function makeAction(method, actionInfo) {
        actionInfo.update = "geo:updateSelectStatus";
        registers.registerAction(actionInfo, function(payload, ecModel) {
            var selected = {};
            var allSelected = [];
            ecModel.eachComponent({
                mainType: "geo",
                query: payload
            }, function(geoModel) {
                geoModel[method](payload.name);
                var geo = geoModel.coordinateSystem;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.regions, function(region) {
                    selected[region.name] = geoModel.isSelected(region.name) || false;
                });
                // Notice: there might be duplicated name in different regions.
                var names = [];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(selected, function(v, name) {
                    selected[name] && names.push(name);
                });
                allSelected.push({
                    geoIndex: geoModel.componentIndex,
                    // Use singular, the same naming convention as the event `selectchanged`.
                    name: names
                });
            });
            return {
                selected: selected,
                allSelected: allSelected,
                name: payload.name
            };
        });
    }
    makeAction("toggleSelected", {
        type: "geoToggleSelect",
        event: "geoselectchanged"
    });
    makeAction("select", {
        type: "geoSelect",
        event: "geoselected"
    });
    makeAction("unSelect", {
        type: "geoUnSelect",
        event: "geounselected"
    });
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: "geoRoam",
        event: "geoRoam",
        update: "updateTransform"
    }, function(payload, ecModel, api) {
        var componentType = payload.componentType || "series";
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            var geo = componentModel.coordinateSystem;
            if (geo.type !== "geo") return;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(geo, payload, componentModel.get("scaleLimit"), api);
            componentModel.setCenter && componentModel.setCenter(res.center);
            componentModel.setZoom && componentModel.setZoom(res.zoom);
            // All map series with same `map` use the same geo coordinate system
            // So the center and zoom must be in sync. Include the series not selected by legend
            if (componentType === "series") (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(componentModel.seriesGroup, function(seriesModel) {
                seriesModel.setCenter(res.center);
                seriesModel.setZoom(res.zoom);
            });
        });
    });
}


function $6c94070aa7d5e098$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8082b8b129488d44$export$4b3e715f166fdd78));
    registers.registerChartView((0, $1c3add93106395a4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f2f4aa5429e1d3d3$export$2e2bcd8739ae039));
    registers.registerLayout((0, $53e61890435fb2d8$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $5e3d42588445ae72$export$2e2bcd8739ae039));
    (0, $e855ccf7eff48bce$export$62942ba95693dbfc)("map", registers.registerAction);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The tree layoutHelper implementation was originally copied from
* "d3.js"(https://github.com/d3/d3-hierarchy) with
* some modifications made for this project.
* (see more details in the comment of the specific method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the licence of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ /**
 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
 *       the tree.
 */ 
function $172d7581b75555e9$export$2cd8252107eb640b(inRoot) {
    var root = inRoot;
    root.hierNode = {
        defaultAncestor: null,
        ancestor: root,
        prelim: 0,
        modifier: 0,
        change: 0,
        shift: 0,
        i: 0,
        thread: null
    };
    var nodes = [
        root
    ];
    var node;
    var children;
    while(node = nodes.pop()){
        // jshint ignore:line
        children = node.children;
        if (node.isExpand && children.length) {
            var n = children.length;
            for(var i = n - 1; i >= 0; i--){
                var child = children[i];
                child.hierNode = {
                    defaultAncestor: null,
                    ancestor: child,
                    prelim: 0,
                    modifier: 0,
                    change: 0,
                    shift: 0,
                    i: i,
                    thread: null
                };
                nodes.push(child);
            }
        }
    }
}
function $172d7581b75555e9$export$f7eff93d75358a2c(node, separation) {
    var children = node.isExpand ? node.children : [];
    var siblings = node.parentNode.children;
    var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
    if (children.length) {
        $172d7581b75555e9$var$executeShifts(node);
        var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
        if (subtreeW) {
            node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
            node.hierNode.modifier = node.hierNode.prelim - midPoint;
        } else node.hierNode.prelim = midPoint;
    } else if (subtreeW) node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
    node.parentNode.hierNode.defaultAncestor = $172d7581b75555e9$var$apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
function $172d7581b75555e9$export$39e6f19b1ce889be(node) {
    var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
    node.setLayout({
        x: nodeX
    }, true);
    node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function $172d7581b75555e9$export$3bf720ece7bc7b2e(cb) {
    return arguments.length ? cb : $172d7581b75555e9$var$defaultSeparation;
}
function $172d7581b75555e9$export$60198ec123d36099(rad, r) {
    rad -= Math.PI / 2;
    return {
        x: r * Math.cos(rad),
        y: r * Math.sin(rad)
    };
}
function $172d7581b75555e9$export$c02eeb5f98d59b89(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $172d7581b75555e9$var$executeShifts(node) {
    var children = node.children;
    var n = children.length;
    var shift = 0;
    var change = 0;
    while(--n >= 0){
        var child = children[n];
        child.hierNode.prelim += shift;
        child.hierNode.modifier += shift;
        change += child.hierNode.change;
        shift += child.hierNode.shift + change;
    }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 */ function $172d7581b75555e9$var$apportion(subtreeV, subtreeW, ancestor, separation) {
    if (subtreeW) {
        var nodeOutRight = subtreeV;
        var nodeInRight = subtreeV;
        var nodeOutLeft = nodeInRight.parentNode.children[0];
        var nodeInLeft = subtreeW;
        var sumOutRight = nodeOutRight.hierNode.modifier;
        var sumInRight = nodeInRight.hierNode.modifier;
        var sumOutLeft = nodeOutLeft.hierNode.modifier;
        var sumInLeft = nodeInLeft.hierNode.modifier;
        while(nodeInLeft = $172d7581b75555e9$var$nextRight(nodeInLeft), nodeInRight = $172d7581b75555e9$var$nextLeft(nodeInRight), nodeInLeft && nodeInRight){
            nodeOutRight = $172d7581b75555e9$var$nextRight(nodeOutRight);
            nodeOutLeft = $172d7581b75555e9$var$nextLeft(nodeOutLeft);
            nodeOutRight.hierNode.ancestor = subtreeV;
            var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
            if (shift > 0) {
                $172d7581b75555e9$var$moveSubtree($172d7581b75555e9$var$nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
                sumInRight += shift;
                sumOutRight += shift;
            }
            sumInLeft += nodeInLeft.hierNode.modifier;
            sumInRight += nodeInRight.hierNode.modifier;
            sumOutRight += nodeOutRight.hierNode.modifier;
            sumOutLeft += nodeOutLeft.hierNode.modifier;
        }
        if (nodeInLeft && !$172d7581b75555e9$var$nextRight(nodeOutRight)) {
            nodeOutRight.hierNode.thread = nodeInLeft;
            nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
        }
        if (nodeInRight && !$172d7581b75555e9$var$nextLeft(nodeOutLeft)) {
            nodeOutLeft.hierNode.thread = nodeInRight;
            nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
            ancestor = subtreeV;
        }
    }
    return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $172d7581b75555e9$var$nextRight(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $172d7581b75555e9$var$nextLeft(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 */ function $172d7581b75555e9$var$nextAncestor(nodeInLeft, node, ancestor) {
    return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 */ function $172d7581b75555e9$var$moveSubtree(wl, wr, shift) {
    var change = shift / (wr.hierNode.i - wl.hierNode.i);
    wr.hierNode.change -= change;
    wr.hierNode.shift += shift;
    wr.hierNode.modifier += shift;
    wr.hierNode.prelim += shift;
    wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $172d7581b75555e9$var$defaultSeparation(node1, node2) {
    return node1.parentNode === node2.parentNode ? 1 : 2;
}











var $c673dc2ab6ad4136$var$TreeEdgeShape = /** @class */ function() {
    function TreeEdgeShape() {
        this.parentPoint = [];
        this.childPoints = [];
    }
    return TreeEdgeShape;
}();
var $c673dc2ab6ad4136$var$TreePath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TreePath, _super);
    function TreePath(opts) {
        return _super.call(this, opts) || this;
    }
    TreePath.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    TreePath.prototype.getDefaultShape = function() {
        return new $c673dc2ab6ad4136$var$TreeEdgeShape();
    };
    TreePath.prototype.buildPath = function(ctx, shape) {
        var childPoints = shape.childPoints;
        var childLen = childPoints.length;
        var parentPoint = shape.parentPoint;
        var firstChildPos = childPoints[0];
        var lastChildPos = childPoints[childLen - 1];
        if (childLen === 1) {
            ctx.moveTo(parentPoint[0], parentPoint[1]);
            ctx.lineTo(firstChildPos[0], firstChildPos[1]);
            return;
        }
        var orient = shape.orient;
        var forkDim = orient === "TB" || orient === "BT" ? 0 : 1;
        var otherDim = 1 - forkDim;
        var forkPosition = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(shape.forkPosition, 1);
        var tmpPoint = [];
        tmpPoint[forkDim] = parentPoint[forkDim];
        tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
        ctx.moveTo(parentPoint[0], parentPoint[1]);
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.moveTo(firstChildPos[0], firstChildPos[1]);
        tmpPoint[forkDim] = firstChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        tmpPoint[forkDim] = lastChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.lineTo(lastChildPos[0], lastChildPos[1]);
        for(var i = 1; i < childLen - 1; i++){
            var point = childPoints[i];
            ctx.moveTo(point[0], point[1]);
            tmpPoint[forkDim] = point[forkDim];
            ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        }
    };
    return TreePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $c673dc2ab6ad4136$var$TreeView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TreeView, _super);
    function TreeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreeView.type;
        _this._mainGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        return _this;
    }
    TreeView.prototype.init = function(ecModel, api) {
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    };
    TreeView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var layoutInfo = seriesModel.layoutInfo;
        var group = this._mainGroup;
        var layout = seriesModel.get("layout");
        if (layout === "radial") {
            group.x = layoutInfo.x + layoutInfo.width / 2;
            group.y = layoutInfo.y + layoutInfo.height / 2;
        } else {
            group.x = layoutInfo.x;
            group.y = layoutInfo.y;
        }
        this._updateViewCoordSys(seriesModel, api);
        this._updateController(seriesModel, ecModel, api);
        var oldData = this._data;
        data.diff(oldData).add(function(newIdx) {
            if ($c673dc2ab6ad4136$var$symbolNeedsDraw(data, newIdx)) // Create node and edge
            $c673dc2ab6ad4136$var$updateNode(data, newIdx, null, group, seriesModel);
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            if (!$c673dc2ab6ad4136$var$symbolNeedsDraw(data, newIdx)) {
                symbolEl && $c673dc2ab6ad4136$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
                return;
            }
            // Update node and edge
            $c673dc2ab6ad4136$var$updateNode(data, newIdx, symbolEl, group, seriesModel);
        }).remove(function(oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // When remove a collapsed node of subtree, since the collapsed
            // node haven't been initialized with a symbol element,
            // you can't found it's symbol element through index.
            // so if we want to remove the symbol element we should insure
            // that the symbol element is not null.
            if (symbolEl) $c673dc2ab6ad4136$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
        }).execute();
        this._nodeScaleRatio = seriesModel.get("nodeScaleRatio");
        this._updateNodeAndLinkScale(seriesModel);
        if (seriesModel.get("expandAndCollapse") === true) data.eachItemGraphicEl(function(el, dataIndex) {
            el.off("click").on("click", function() {
                api.dispatchAction({
                    type: "treeExpandAndCollapse",
                    seriesId: seriesModel.id,
                    dataIndex: dataIndex
                });
            });
        });
        this._data = data;
    };
    TreeView.prototype._updateViewCoordSys = function(seriesModel, api) {
        var data = seriesModel.getData();
        var points = [];
        data.each(function(idx) {
            var layout = data.getItemLayout(idx);
            if (layout && !isNaN(layout.x) && !isNaN(layout.y)) points.push([
                +layout.x,
                +layout.y
            ]);
        });
        var min = [];
        var max = [];
        $af3aab2435198f82$export$188c3cd07b4129dd(points, min, max);
        // If don't Store min max when collapse the root node after roam,
        // the root node will disappear.
        var oldMin = this._min;
        var oldMax = this._max;
        // If width or height is 0
        if (max[0] - min[0] === 0) {
            min[0] = oldMin ? oldMin[0] : min[0] - 1;
            max[0] = oldMax ? oldMax[0] : max[0] + 1;
        }
        if (max[1] - min[1] === 0) {
            min[1] = oldMin ? oldMin[1] : min[1] - 1;
            max[1] = oldMax ? oldMax[1] : max[1] + 1;
        }
        var viewCoordSys = seriesModel.coordinateSystem = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)();
        viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
        viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        viewCoordSys.setCenter(seriesModel.get("center"), api);
        viewCoordSys.setZoom(seriesModel.get("zoom"));
        // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
        this.group.attr({
            x: viewCoordSys.x,
            y: viewCoordSys.y,
            scaleX: viewCoordSys.scaleX,
            scaleY: viewCoordSys.scaleY
        });
        this._min = min;
        this._max = max;
    };
    TreeView.prototype._updateController = function(seriesModel, ecModel, api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, seriesModel);
        });
        controller.enable(seriesModel.get("roam"));
        controllerHost.zoomLimit = seriesModel.get("scaleLimit");
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off("pan").off("zoom").on("pan", function(e) {
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "treeRoam",
                dx: e.dx,
                dy: e.dy
            });
        }).on("zoom", function(e) {
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "treeRoam",
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            _this._updateNodeAndLinkScale(seriesModel);
            // Only update label layout on zoom
            api.updateLabelLayout();
        });
    };
    TreeView.prototype._updateNodeAndLinkScale = function(seriesModel) {
        var data = seriesModel.getData();
        var nodeScale = this._getNodeGlobalScale(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el.setSymbolScale(nodeScale);
        });
    };
    TreeView.prototype._getNodeGlobalScale = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type !== "view") return 1;
        var nodeScaleRatio = this._nodeScaleRatio;
        var groupZoom = coordSys.scaleX || 1;
        // Scale node when zoom changes
        var roamZoom = coordSys.getZoom();
        var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
        return nodeScale / groupZoom;
    };
    TreeView.prototype.dispose = function() {
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    TreeView.prototype.remove = function() {
        this._mainGroup.removeAll();
        this._data = null;
    };
    TreeView.type = "tree";
    return TreeView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $c673dc2ab6ad4136$var$symbolNeedsDraw(data, dataIndex) {
    var layout = data.getItemLayout(dataIndex);
    return layout && !isNaN(layout.x) && !isNaN(layout.y);
}
function $c673dc2ab6ad4136$var$updateNode(data, dataIndex, symbolEl, group, seriesModel) {
    var isInit = !symbolEl;
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var itemModel = node.getModel();
    var visualColor = node.getVisual("style").fill;
    var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : "#fff";
    var virtualRoot = data.tree.root;
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceLayout = source.getLayout();
    var sourceOldLayout = sourceSymbolEl ? {
        x: sourceSymbolEl.__oldX,
        y: sourceSymbolEl.__oldY,
        rawX: sourceSymbolEl.__radialOldRawX,
        rawY: sourceSymbolEl.__radialOldRawY
    } : sourceLayout;
    var targetLayout = node.getLayout();
    if (isInit) {
        symbolEl = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, dataIndex, null, {
            symbolInnerColor: symbolInnerColor,
            useNameLabel: true
        });
        symbolEl.x = sourceOldLayout.x;
        symbolEl.y = sourceOldLayout.y;
    } else symbolEl.updateData(data, dataIndex, null, {
        symbolInnerColor: symbolInnerColor,
        useNameLabel: true
    });
    symbolEl.__radialOldRawX = symbolEl.__radialRawX;
    symbolEl.__radialOldRawY = symbolEl.__radialRawY;
    symbolEl.__radialRawX = targetLayout.rawX;
    symbolEl.__radialRawY = targetLayout.rawY;
    group.add(symbolEl);
    data.setItemGraphicEl(dataIndex, symbolEl);
    symbolEl.__oldX = symbolEl.x;
    symbolEl.__oldY = symbolEl.y;
    $8b353638fbedfefa$export$c8dce3c08436e91e(symbolEl, {
        x: targetLayout.x,
        y: targetLayout.y
    }, seriesModel);
    var symbolPath = symbolEl.getSymbolPath();
    if (seriesModel.get("layout") === "radial") {
        var realRoot = virtualRoot.children[0];
        var rootLayout = realRoot.getLayout();
        var length_1 = realRoot.children.length;
        var rad = void 0;
        var isLeft = void 0;
        if (targetLayout.x === rootLayout.x && node.isExpand === true && realRoot.children.length) {
            var center = {
                x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
                y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
            };
            rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            isLeft = center.x < rootLayout.x;
            if (isLeft) rad = rad - Math.PI;
        } else {
            rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
                isLeft = targetLayout.x < rootLayout.x;
                if (isLeft) rad = rad - Math.PI;
            } else {
                isLeft = targetLayout.x > rootLayout.x;
                if (!isLeft) rad = rad - Math.PI;
            }
        }
        var textPosition = isLeft ? "left" : "right";
        var normalLabelModel = itemModel.getModel("label");
        var rotate = normalLabelModel.get("rotate");
        var labelRotateRadian = rotate * (Math.PI / 180);
        var textContent = symbolPath.getTextContent();
        if (textContent) {
            symbolPath.setTextConfig({
                position: normalLabelModel.get("position") || textPosition,
                rotation: rotate == null ? -rad : labelRotateRadian,
                origin: "center"
            });
            textContent.setStyle("verticalAlign", "middle");
        }
    }
    // Handle status
    var focus = itemModel.get([
        "emphasis",
        "focus"
    ]);
    var focusDataIndices = focus === "relative" ? $7a1bd9c2710fea0d$export$4fd8af2c48c43416(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === "ancestor" ? node.getAncestorsIndices() : focus === "descendant" ? node.getDescendantIndices() : null;
    if (focusDataIndices) // Modify the focus to data indices.
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(symbolEl).focus = focusDataIndices;
    $c673dc2ab6ad4136$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);
    if (symbolEl.__edge) symbolEl.onHoverStateChange = function(toState) {
        if (toState !== "blur") {
            // NOTE: Ensure the parent elements will been blurred firstly.
            // According to the return of getAncestorsIndices and getDescendantIndices
            // TODO: A bit tricky.
            var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);
            if (!(parentEl && parentEl.hoverState === (0, $2bf82c0980125b62$export$1307d6a87d56baa))) (0, $2bf82c0980125b62$export$868ba38adffa9e39)(symbolEl.__edge, toState);
        }
    };
}
function $c673dc2ab6ad4136$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
    var itemModel = node.getModel();
    var edgeShape = seriesModel.get("edgeShape");
    var layout = seriesModel.get("layout");
    var orient = seriesModel.getOrient();
    var curvature = seriesModel.get([
        "lineStyle",
        "curveness"
    ]);
    var edgeForkPosition = seriesModel.get("edgeForkPosition");
    var lineStyle = itemModel.getModel("lineStyle").getLineStyle();
    var edge = symbolEl.__edge;
    // curve edge from node -> parent
    // polyline edge from node -> children
    if (edgeShape === "curve") {
        if (node.parentNode && node.parentNode !== virtualRoot) {
            if (!edge) edge = symbolEl.__edge = new $6c7800c49630e431$export$2e2bcd8739ae039({
                shape: $c673dc2ab6ad4136$var$getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
            });
            $8b353638fbedfefa$export$c8dce3c08436e91e(edge, {
                shape: $c673dc2ab6ad4136$var$getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
            }, seriesModel);
        }
    } else if (edgeShape === "polyline") {
        if (layout === "orthogonal") {
            if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
                var children = node.children;
                var childPoints = [];
                for(var i = 0; i < children.length; i++){
                    var childLayout = children[i].getLayout();
                    childPoints.push([
                        childLayout.x,
                        childLayout.y
                    ]);
                }
                if (!edge) edge = symbolEl.__edge = new $c673dc2ab6ad4136$var$TreePath({
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: [
                            [
                                targetLayout.x,
                                targetLayout.y
                            ]
                        ],
                        orient: orient,
                        forkPosition: edgeForkPosition
                    }
                });
                $8b353638fbedfefa$export$c8dce3c08436e91e(edge, {
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: childPoints
                    }
                }, seriesModel);
            }
        }
    }
    // show all edge when edgeShape is 'curve', filter node `isExpand` is false when edgeShape is 'polyline'
    if (edge && !(edgeShape === "polyline" && !node.isExpand)) {
        edge.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
            strokeNoScale: true,
            fill: null
        }, lineStyle));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(edge, itemModel, "lineStyle");
        (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(edge);
        group.add(edge);
    }
}
function $c673dc2ab6ad4136$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
    var virtualRoot = data.tree.root;
    var _a = $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node), source = _a.source, sourceLayout = _a.sourceLayout;
    var symbolEl = data.getItemGraphicEl(node.dataIndex);
    if (!symbolEl) return;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceEdge = sourceSymbolEl.__edge;
    // 1. when expand the sub tree, delete the children node should delete the edge of
    // the source at the same time. because the polyline edge shape is only owned by the source.
    // 2.when the node is the only children of the source, delete the node should delete the edge of
    // the source at the same time. the same reason as above.
    var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
    var edgeShape = seriesModel.get("edgeShape");
    var layoutOpt = seriesModel.get("layout");
    var orient = seriesModel.get("orient");
    var curvature = seriesModel.get([
        "lineStyle",
        "curveness"
    ]);
    if (edge) {
        if (edgeShape === "curve") $8b353638fbedfefa$export$f883456a56996078(edge, {
            shape: $c673dc2ab6ad4136$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
        else if (edgeShape === "polyline" && seriesModel.get("layout") === "orthogonal") $8b353638fbedfefa$export$f883456a56996078(edge, {
            shape: {
                parentPoint: [
                    sourceLayout.x,
                    sourceLayout.y
                ],
                childPoints: [
                    [
                        sourceLayout.x,
                        sourceLayout.y
                    ]
                ]
            },
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
    }
}
function $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node) {
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceLayout;
    while(sourceLayout = source.getLayout(), sourceLayout == null)source = source.parentNode === virtualRoot ? source : source.parentNode || source;
    return {
        source: source,
        sourceLayout: sourceLayout
    };
}
function $c673dc2ab6ad4136$var$removeNode(data, dataIndex, symbolEl, group, seriesModel) {
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var virtualRoot = data.tree.root;
    var sourceLayout = $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node).sourceLayout;
    // Use same duration and easing with update to have more consistent animation.
    var removeAnimationOpt = {
        duration: seriesModel.get("animationDurationUpdate"),
        easing: seriesModel.get("animationEasingUpdate")
    };
    $8b353638fbedfefa$export$f883456a56996078(symbolEl, {
        x: sourceLayout.x + 1,
        y: sourceLayout.y + 1
    }, seriesModel, {
        cb: function() {
            group.remove(symbolEl);
            data.setItemGraphicEl(dataIndex, null);
        },
        removeOpt: removeAnimationOpt
    });
    symbolEl.fadeOut(null, data.hostModel, {
        fadeLabel: true,
        animation: removeAnimationOpt
    });
    // remove edge as parent node
    node.children.forEach(function(childNode) {
        $c673dc2ab6ad4136$var$removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
    });
    // remove edge as child node
    $c673dc2ab6ad4136$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
}
function $c673dc2ab6ad4136$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
    var cpx1;
    var cpy1;
    var cpx2;
    var cpy2;
    var x1;
    var x2;
    var y1;
    var y2;
    if (layoutOpt === "radial") {
        x1 = sourceLayout.rawX;
        y1 = sourceLayout.rawY;
        x2 = targetLayout.rawX;
        y2 = targetLayout.rawY;
        var radialCoor1 = (0, $172d7581b75555e9$export$60198ec123d36099)(x1, y1);
        var radialCoor2 = (0, $172d7581b75555e9$export$60198ec123d36099)(x1, y1 + (y2 - y1) * curvature);
        var radialCoor3 = (0, $172d7581b75555e9$export$60198ec123d36099)(x2, y2 + (y1 - y2) * curvature);
        var radialCoor4 = (0, $172d7581b75555e9$export$60198ec123d36099)(x2, y2);
        return {
            x1: radialCoor1.x || 0,
            y1: radialCoor1.y || 0,
            x2: radialCoor4.x || 0,
            y2: radialCoor4.y || 0,
            cpx1: radialCoor2.x || 0,
            cpy1: radialCoor2.y || 0,
            cpx2: radialCoor3.x || 0,
            cpy2: radialCoor3.y || 0
        };
    } else {
        x1 = sourceLayout.x;
        y1 = sourceLayout.y;
        x2 = targetLayout.x;
        y2 = targetLayout.y;
        if (orient === "LR" || orient === "RL") {
            cpx1 = x1 + (x2 - x1) * curvature;
            cpy1 = y1;
            cpx2 = x2 + (x1 - x2) * curvature;
            cpy2 = y2;
        }
        if (orient === "TB" || orient === "BT") {
            cpx1 = x1;
            cpy1 = y1 + (y2 - y1) * curvature;
            cpx2 = x2;
            cpy2 = y2 + (y1 - y2) * curvature;
        }
    }
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
    };
}
var $c673dc2ab6ad4136$export$2e2bcd8739ae039 = $c673dc2ab6ad4136$var$TreeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Tree data structure
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Link lists and struct (graph or tree)
 */ 

var $4a8451eb7786c849$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $4a8451eb7786c849$var$linkSeriesData(opt) {
    var mainData = opt.mainData;
    var datas = opt.datas;
    if (!datas) {
        datas = {
            main: mainData
        };
        opt.datasAttr = {
            main: "data"
        };
    }
    opt.datas = opt.mainData = null;
    $4a8451eb7786c849$var$linkAll(mainData, datas, opt);
    // Porxy data original methods.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(datas, function(data) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mainData.TRANSFERABLE_METHODS, function(methodName) {
            data.wrapMethod(methodName, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$transferInjection, opt));
        });
    });
    // Beyond transfer, additional features should be added to `cloneShallow`.
    mainData.wrapMethod("cloneShallow", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$cloneShallowInjection, opt));
    // Only mainData trigger change, because struct.update may trigger
    // another changable methods, which may bring about dead lock.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mainData.CHANGABLE_METHODS, function(methodName) {
        mainData.wrapMethod(methodName, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$changeInjection, opt));
    });
    // Make sure datas contains mainData.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(datas[mainData.dataType] === mainData);
}
function $4a8451eb7786c849$var$transferInjection(opt, res) {
    if ($4a8451eb7786c849$var$isMainData(this)) {
        // Transfer datas to new main data.
        var datas = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, $4a8451eb7786c849$var$inner(this).datas);
        datas[this.dataType] = res;
        $4a8451eb7786c849$var$linkAll(res, datas, opt);
    } else // Modify the reference in main data to point newData.
    $4a8451eb7786c849$var$linkSingle(res, this.dataType, $4a8451eb7786c849$var$inner(this).mainData, opt);
    return res;
}
function $4a8451eb7786c849$var$changeInjection(opt, res) {
    opt.struct && opt.struct.update();
    return res;
}
function $4a8451eb7786c849$var$cloneShallowInjection(opt, res) {
    // cloneShallow, which brings about some fragilities, may be inappropriate
    // to be exposed as an API. So for implementation simplicity we can make
    // the restriction that cloneShallow of not-mainData should not be invoked
    // outside, but only be invoked here.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4a8451eb7786c849$var$inner(res).datas, function(data, dataType) {
        data !== res && $4a8451eb7786c849$var$linkSingle(data.cloneShallow(), dataType, res, opt);
    });
    return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param [dataType] If not specified, return mainData.
 */ function $4a8451eb7786c849$var$getLinkedData(dataType) {
    var mainData = $4a8451eb7786c849$var$inner(this).mainData;
    return dataType == null || mainData == null ? mainData : $4a8451eb7786c849$var$inner(mainData).datas[dataType];
}
/**
 * Get list of all linked data
 */ function $4a8451eb7786c849$var$getLinkedDataAll() {
    var mainData = $4a8451eb7786c849$var$inner(this).mainData;
    return mainData == null ? [
        {
            data: mainData
        }
    ] : (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($4a8451eb7786c849$var$inner(mainData).datas), function(type) {
        return {
            type: type,
            data: $4a8451eb7786c849$var$inner(mainData).datas[type]
        };
    });
}
function $4a8451eb7786c849$var$isMainData(data) {
    return $4a8451eb7786c849$var$inner(data).mainData === data;
}
function $4a8451eb7786c849$var$linkAll(mainData, datas, opt) {
    $4a8451eb7786c849$var$inner(mainData).datas = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(datas, function(data, dataType) {
        $4a8451eb7786c849$var$linkSingle(data, dataType, mainData, opt);
    });
}
function $4a8451eb7786c849$var$linkSingle(data, dataType, mainData, opt) {
    $4a8451eb7786c849$var$inner(mainData).datas[dataType] = data;
    $4a8451eb7786c849$var$inner(data).mainData = mainData;
    data.dataType = dataType;
    if (opt.struct) {
        data[opt.structAttr] = opt.struct;
        opt.struct[opt.datasAttr[dataType]] = data;
    }
    // Supplement method.
    data.getLinkedData = $4a8451eb7786c849$var$getLinkedData;
    data.getLinkedDataAll = $4a8451eb7786c849$var$getLinkedDataAll;
}
var $4a8451eb7786c849$export$2e2bcd8739ae039 = $4a8451eb7786c849$var$linkSeriesData;





var $116fa5bb9335391f$export$2eba8ec3a333fdbb = /** @class */ function() {
    function TreeNode(name, hostTree) {
        this.depth = 0;
        this.height = 0;
        /**
     * Reference to list item.
     * Do not persistent dataIndex outside,
     * besause it may be changed by list.
     * If dataIndex -1,
     * this node is logical deleted (filtered) in list.
     */ this.dataIndex = -1;
        this.children = [];
        this.viewChildren = [];
        this.isExpand = false;
        this.name = name || "";
        this.hostTree = hostTree;
    }
    /**
   * The node is removed.
   */ TreeNode.prototype.isRemoved = function() {
        return this.dataIndex < 0;
    };
    TreeNode.prototype.eachNode = function(options, cb, context) {
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(options)) {
            context = cb;
            cb = options;
            options = null;
        }
        options = options || {};
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(options)) options = {
            order: options
        };
        var order = options.order || "preorder";
        var children = this[options.attr || "children"];
        var suppressVisitSub;
        order === "preorder" && (suppressVisitSub = cb.call(context, this));
        for(var i = 0; !suppressVisitSub && i < children.length; i++)children[i].eachNode(options, cb, context);
        order === "postorder" && cb.call(context, this);
    };
    /**
   * Update depth and height of this subtree.
   */ TreeNode.prototype.updateDepthAndHeight = function(depth) {
        var height = 0;
        this.depth = depth;
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            child.updateDepthAndHeight(depth + 1);
            if (child.height > height) height = child.height;
        }
        this.height = height + 1;
    };
    TreeNode.prototype.getNodeById = function(id) {
        if (this.getId() === id) return this;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].getNodeById(id);
            if (res) return res;
        }
    };
    TreeNode.prototype.contains = function(node) {
        if (node === this) return true;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].contains(node);
            if (res) return res;
        }
    };
    /**
   * @param includeSelf Default false.
   * @return order: [root, child, grandchild, ...]
   */ TreeNode.prototype.getAncestors = function(includeSelf) {
        var ancestors = [];
        var node = includeSelf ? this : this.parentNode;
        while(node){
            ancestors.push(node);
            node = node.parentNode;
        }
        ancestors.reverse();
        return ancestors;
    };
    TreeNode.prototype.getAncestorsIndices = function() {
        var indices = [];
        var currNode = this;
        while(currNode){
            indices.push(currNode.dataIndex);
            currNode = currNode.parentNode;
        }
        indices.reverse();
        return indices;
    };
    TreeNode.prototype.getDescendantIndices = function() {
        var indices = [];
        this.eachNode(function(childNode) {
            indices.push(childNode.dataIndex);
        });
        return indices;
    };
    TreeNode.prototype.getValue = function(dimension) {
        var data = this.hostTree.data;
        return data.getStore().get(data.getDimensionIndex(dimension || "value"), this.dataIndex);
    };
    TreeNode.prototype.setLayout = function(layout, merge) {
        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
    };
    /**
   * @return {Object} layout
   */ TreeNode.prototype.getLayout = function() {
        return this.hostTree.data.getItemLayout(this.dataIndex);
    };
    // @depcrecated
    // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TreeNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var hostTree = this.hostTree;
        var itemModel = hostTree.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    // TODO: TYPE More specific model
    TreeNode.prototype.getLevelModel = function() {
        return (this.hostTree.levelModels || [])[this.depth];
    };
    TreeNode.prototype.setVisual = function(key, value) {
        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
    };
    /**
   * Get item visual
   * FIXME: make return type better
   */ TreeNode.prototype.getVisual = function(key) {
        return this.hostTree.data.getItemVisual(this.dataIndex, key);
    };
    TreeNode.prototype.getRawIndex = function() {
        return this.hostTree.data.getRawIndex(this.dataIndex);
    };
    TreeNode.prototype.getId = function() {
        return this.hostTree.data.getId(this.dataIndex);
    };
    /**
   * index in parent's children
   */ TreeNode.prototype.getChildIndex = function() {
        if (this.parentNode) {
            var children = this.parentNode.children;
            for(var i = 0; i < children.length; ++i){
                if (children[i] === this) return i;
            }
            return -1;
        }
        return -1;
    };
    /**
   * if this is an ancestor of another node
   *
   * @param node another node
   * @return if is ancestor
   */ TreeNode.prototype.isAncestorOf = function(node) {
        var parent = node.parentNode;
        while(parent){
            if (parent === this) return true;
            parent = parent.parentNode;
        }
        return false;
    };
    /**
   * if this is an descendant of another node
   *
   * @param node another node
   * @return if is descendant
   */ TreeNode.prototype.isDescendantOf = function(node) {
        return node !== this && node.isAncestorOf(this);
    };
    return TreeNode;
}();
var $116fa5bb9335391f$var$Tree = /** @class */ function() {
    function Tree(hostModel) {
        this.type = "tree";
        this._nodes = [];
        this.hostModel = hostModel;
    }
    Tree.prototype.eachNode = function(options, cb, context) {
        this.root.eachNode(options, cb, context);
    };
    Tree.prototype.getNodeByDataIndex = function(dataIndex) {
        var rawIndex = this.data.getRawIndex(dataIndex);
        return this._nodes[rawIndex];
    };
    Tree.prototype.getNodeById = function(name) {
        return this.root.getNodeById(name);
    };
    /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */ Tree.prototype.update = function() {
        var data = this.data;
        var nodes = this._nodes;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
    };
    /**
   * Clear all layouts
   */ Tree.prototype.clearLayouts = function() {
        this.data.clearItemLayouts();
    };
    /**
   * data node format:
   * {
   *     name: ...
   *     value: ...
   *     children: [
   *         {
   *             name: ...
   *             value: ...
   *             children: ...
   *         },
   *         ...
   *     ]
   * }
   */ Tree.createTree = function(dataRoot, hostModel, beforeLink) {
        var tree = new Tree(hostModel);
        var listData = [];
        var dimMax = 1;
        buildHierarchy(dataRoot);
        function buildHierarchy(dataNode, parentNode) {
            var value = dataNode.value;
            dimMax = Math.max(dimMax, $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) ? value.length : 1);
            listData.push(dataNode);
            var node = new $116fa5bb9335391f$export$2eba8ec3a333fdbb((0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(dataNode.name, ""), tree);
            parentNode ? $116fa5bb9335391f$var$addChild(node, parentNode) : tree.root = node;
            tree._nodes.push(node);
            var children = dataNode.children;
            if (children) for(var i = 0; i < children.length; i++)buildHierarchy(children[i], node);
        }
        tree.root.updateDepthAndHeight(0);
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(listData, {
            coordDimensions: [
                "value"
            ],
            dimensionsCount: dimMax
        }).dimensions;
        var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, hostModel);
        list.initData(listData);
        beforeLink && beforeLink(list);
        (0, $4a8451eb7786c849$export$2e2bcd8739ae039)({
            mainData: list,
            struct: tree,
            structAttr: "tree"
        });
        tree.update();
        return tree;
    };
    return Tree;
}();
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 */ function $116fa5bb9335391f$var$addChild(child, node) {
    var children = node.children;
    if (child.parentNode === node) return;
    children.push(child);
    child.parentNode = node;
}
var $116fa5bb9335391f$export$2e2bcd8739ae039 = $116fa5bb9335391f$var$Tree;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $6341f66602946a06$export$c5445fa59c15dec4(payload, validPayloadTypes, seriesModel) {
    if (payload && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(validPayloadTypes, payload.type) >= 0) {
        var root = seriesModel.getData().tree.root;
        var targetNode = payload.targetNode;
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(targetNode)) targetNode = root.getNodeById(targetNode);
        if (targetNode && root.contains(targetNode)) return {
            node: targetNode
        };
        var targetNodeId = payload.targetNodeId;
        if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) return {
            node: targetNode
        };
    }
}
function $6341f66602946a06$export$6be31fe4499506f9(node) {
    var path = [];
    while(node){
        node = node.parentNode;
        node && path.push(node);
    }
    return path.reverse();
}
function $6341f66602946a06$export$df59de26c77b5bea(viewRoot, node) {
    var viewPath = $6341f66602946a06$export$6be31fe4499506f9(viewRoot);
    return $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(viewPath, node) >= 0;
}
function $6341f66602946a06$export$c5baa480d6ceb0a3(node, seriesModel) {
    var treePathInfo = [];
    while(node){
        var nodeDataIndex = node.dataIndex;
        treePathInfo.push({
            name: node.name,
            dataIndex: nodeDataIndex,
            value: seriesModel.getRawValue(nodeDataIndex)
        });
        node = node.parentNode;
    }
    treePathInfo.reverse();
    return treePathInfo;
}


var $908076d89767d409$var$TreeSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TreeSeriesModel, _super);
    function TreeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSymbolVisual = true;
        // Do it self.
        _this.ignoreStyleOnData = true;
        return _this;
    }
    /**
   * Init a tree data structure from data in option series
   */ TreeSeriesModel.prototype.getInitialData = function(option) {
        // create a virtual root
        var root = {
            name: option.name,
            children: option.data
        };
        var leaves = option.leaves || {};
        var leavesModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(leaves, this, this.ecModel);
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                if (!(node && node.children.length && node.isExpand)) model.parentModel = leavesModel;
                return model;
            });
        }
        var treeDepth = 0;
        tree.eachNode("preorder", function(node) {
            if (node.depth > treeDepth) treeDepth = node.depth;
        });
        var expandAndCollapse = option.expandAndCollapse;
        var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
        tree.root.eachNode("preorder", function(node) {
            var item = node.hostTree.data.getRawDataItem(node.dataIndex);
            // Add item.collapsed != null, because users can collapse node original in the series.data.
            node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
        });
        return tree.data;
    };
    /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */ TreeSeriesModel.prototype.getOrient = function() {
        var orient = this.get("orient");
        if (orient === "horizontal") orient = "LR";
        else if (orient === "vertical") orient = "TB";
        return orient;
    };
    TreeSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    TreeSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    TreeSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var tree = this.getData().tree;
        var realRoot = tree.root.children[0];
        var node = tree.getNodeByDataIndex(dataIndex);
        var value = node.getValue();
        var name = node.name;
        while(node && node !== realRoot){
            name = node.parentNode.name + "." + name;
            node = node.parentNode;
        }
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value,
            noValue: isNaN(value) || value == null
        });
    };
    // Add tree path to tooltip param
    TreeSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        params.collapsed = !node.isExpand;
        return params;
    };
    TreeSeriesModel.type = "series.tree";
    // can support the position parameters 'left', 'top','right','bottom', 'width',
    // 'height' in the setOption() with 'merge' mode normal.
    TreeSeriesModel.layoutMode = "box";
    TreeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        // the position of the whole view
        left: "12%",
        top: "12%",
        right: "12%",
        bottom: "12%",
        // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
        layout: "orthogonal",
        // value can be 'polyline'
        edgeShape: "curve",
        edgeForkPosition: "50%",
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.4,
        // Default on center of graph
        center: null,
        zoom: 1,
        orient: "LR",
        symbol: "emptyCircle",
        symbolSize: 7,
        expandAndCollapse: true,
        initialTreeDepth: 2,
        lineStyle: {
            color: "#ccc",
            width: 1.5,
            curveness: 0.5
        },
        itemStyle: {
            color: "lightsteelblue",
            // borderColor: '#c23531',
            borderWidth: 1.5
        },
        label: {
            show: true
        },
        animationEasing: "linear",
        animationDuration: 700,
        animationDurationUpdate: 500
    };
    return TreeSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $908076d89767d409$export$2e2bcd8739ae039 = $908076d89767d409$var$TreeSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Traverse the tree from bottom to top and do something
 */ function $40241c7ef27c3238$export$bd961f70bc91ffb4(root, callback, separation) {
    var nodes = [
        root
    ];
    var next = [];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        next.push(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = 0; i < children.length; i++)nodes.push(children[i]);
        }
    }
    while(node = next.pop())// jshint ignore:line
    callback(node, separation);
}
/**
 * Traverse the tree from top to bottom and do something
 */ function $40241c7ef27c3238$export$32a66ec2b39acdac(root, callback) {
    var nodes = [
        root
    ];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        callback(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = children.length - 1; i >= 0; i--)nodes.push(children[i]);
        }
    }
}



function $121bf97d85edc8b9$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("tree", function(seriesModel) {
        $121bf97d85edc8b9$var$commonLayout(seriesModel, api);
    });
}
function $121bf97d85edc8b9$var$commonLayout(seriesModel, api) {
    var layoutInfo = (0, $172d7581b75555e9$export$c02eeb5f98d59b89)(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var layout = seriesModel.get("layout");
    var width = 0;
    var height = 0;
    var separation = null;
    if (layout === "radial") {
        width = 2 * Math.PI;
        height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
        separation = (0, $172d7581b75555e9$export$3bf720ece7bc7b2e)(function(node1, node2) {
            return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
        });
    } else {
        width = layoutInfo.width;
        height = layoutInfo.height;
        separation = (0, $172d7581b75555e9$export$3bf720ece7bc7b2e)();
    }
    var virtualRoot = seriesModel.getData().tree.root;
    var realRoot = virtualRoot.children[0];
    if (realRoot) {
        (0, $172d7581b75555e9$export$2cd8252107eb640b)(virtualRoot);
        (0, $40241c7ef27c3238$export$bd961f70bc91ffb4)(realRoot, (0, $172d7581b75555e9$export$f7eff93d75358a2c), separation);
        virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
        (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, (0, $172d7581b75555e9$export$39e6f19b1ce889be));
        var left_1 = realRoot;
        var right_1 = realRoot;
        var bottom_1 = realRoot;
        (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
            var x = node.getLayout().x;
            if (x < left_1.getLayout().x) left_1 = node;
            if (x > right_1.getLayout().x) right_1 = node;
            if (node.depth > bottom_1.depth) bottom_1 = node;
        });
        var delta = left_1 === right_1 ? 1 : separation(left_1, right_1) / 2;
        var tx_1 = delta - left_1.getLayout().x;
        var kx_1 = 0;
        var ky_1 = 0;
        var coorX_1 = 0;
        var coorY_1 = 0;
        if (layout === "radial") {
            kx_1 = width / (right_1.getLayout().x + delta + tx_1);
            // here we use (node.depth - 1), bucause the real root's depth is 1
            ky_1 = height / (bottom_1.depth - 1 || 1);
            (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                coorY_1 = (node.depth - 1) * ky_1;
                var finalCoor = (0, $172d7581b75555e9$export$60198ec123d36099)(coorX_1, coorY_1);
                node.setLayout({
                    x: finalCoor.x,
                    y: finalCoor.y,
                    rawX: coorX_1,
                    rawY: coorY_1
                }, true);
            });
        } else {
            var orient_1 = seriesModel.getOrient();
            if (orient_1 === "RL" || orient_1 === "LR") {
                ky_1 = height / (right_1.getLayout().x + delta + tx_1);
                kx_1 = width / (bottom_1.depth - 1 || 1);
                (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorY_1 = (node.getLayout().x + tx_1) * ky_1;
                    coorX_1 = orient_1 === "LR" ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            } else if (orient_1 === "TB" || orient_1 === "BT") {
                kx_1 = width / (right_1.getLayout().x + delta + tx_1);
                ky_1 = height / (bottom_1.depth - 1 || 1);
                (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                    coorY_1 = orient_1 === "TB" ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            }
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $d90852cc2c74d10f$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("tree", function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            // TODO Optimize
            var style = model.getModel("itemStyle").getItemStyle();
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $0f83bac2aba33cc4$export$83b6a0f4104bd4f4(registers) {
    registers.registerAction({
        type: "treeExpandAndCollapse",
        event: "treeExpandAndCollapse",
        update: "update"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "tree",
            query: payload
        }, function(seriesModel) {
            var dataIndex = payload.dataIndex;
            var tree = seriesModel.getData().tree;
            var node = tree.getNodeByDataIndex(dataIndex);
            node.isExpand = !node.isExpand;
        });
    });
    registers.registerAction({
        type: "treeRoam",
        event: "treeRoam",
        // Here we set 'none' instead of 'update', because roam action
        // just need to update the transform matrix without having to recalculate
        // the layout. So don't need to go through the whole update process, such
        // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
        update: "none"
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "tree",
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(coordSys, payload, undefined, api);
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}


function $44a5d4d260c7de78$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $c673dc2ab6ad4136$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $908076d89767d409$export$2e2bcd8739ae039));
    registers.registerLayout((0, $121bf97d85edc8b9$export$2e2bcd8739ae039));
    registers.registerVisual((0, $d90852cc2c74d10f$export$2e2bcd8739ae039));
    (0, $0f83bac2aba33cc4$export$83b6a0f4104bd4f4)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $26d493e9cdfadb01$var$actionTypes = [
    "treemapZoomToNode",
    "treemapRender",
    "treemapMove"
];
function $26d493e9cdfadb01$export$1ad90fc3f3a8bbf9(registers) {
    for(var i = 0; i < $26d493e9cdfadb01$var$actionTypes.length; i++)registers.registerAction({
        type: $26d493e9cdfadb01$var$actionTypes[i],
        update: "updateView"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "treemapRootToNode",
        update: "updateView"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "treemap",
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var types = [
                "treemapZoomToNode",
                "treemapRootToNode"
            ];
            var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = $6341f66602946a06$export$df59de26c77b5bea(originViewRoot, targetInfo.node) ? "rollUp" : "drillDown";
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $a116b59e46d9072c$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    var decalPaletteScope = {};
    tree.eachNode(function(node) {
        // Use decal of level 1 node
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var decal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, current.name || current.dataIndex + "", decalPaletteScope);
        node.setVisual("decal", decal);
    });
}


var $10d079b37d9731a3$var$TreemapSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TreemapSeriesModel, _super);
    function TreemapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapSeriesModel.type;
        _this.preventUsingHoverLayer = true;
        return _this;
    }
    /**
   * @override
   */ TreemapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $10d079b37d9731a3$var$completeTreeValue(root);
        var levels = option.levels || [];
        // Used in "visual priority" in `treemapVisual.js`.
        // This way is a little tricky, must satisfy the precondition:
        //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
        //   2. The `Model.prototype.getModel()` will not use any clone-like way.
        var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
        var designatedVisualModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)({
            itemStyle: designatedVisualItemStyle
        }, this, ecModel);
        levels = option.levels = $10d079b37d9731a3$var$setDefault(levels, ecModel);
        var levelModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(levels || [], function(levelDefine) {
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine, designatedVisualModel, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = node ? levelModels[node.depth] : null;
                // If no levelModel, we also need `designatedVisualModel`.
                model.parentModel = levelModel || designatedVisualModel;
                return model;
            });
        }
        return tree.data;
    };
    TreemapSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */ TreemapSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value
        });
    };
    /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */ TreemapSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        // compatitable the previous code.
        params.treePathInfo = params.treeAncestors;
        return params;
    };
    /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */ TreemapSeriesModel.prototype.setLayoutInfo = function(layoutInfo) {
        /**
     * @readOnly
     * @type {Object}
     */ this.layoutInfo = this.layoutInfo || {};
        $7a1bd9c2710fea0d$export$8b58be045bf06082(this.layoutInfo, layoutInfo);
    };
    /**
   * @param  {string} id
   * @return {number} index
   */ TreemapSeriesModel.prototype.mapIdToIndex = function(id) {
        // A feature is implemented:
        // index is monotone increasing with the sequence of
        // input id at the first time.
        // This feature can make sure that each data item and its
        // mapped color have the same index between data list and
        // color list at the beginning, which is useful for user
        // to adjust data-color mapping.
        /**
     * @private
     * @type {Object}
     */ var idIndexMap = this._idIndexMap;
        if (!idIndexMap) {
            idIndexMap = this._idIndexMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            /**
       * @private
       * @type {number}
       */ this._idIndexMapCount = 0;
        }
        var index = idIndexMap.get(id);
        if (index == null) idIndexMap.set(id, index = this._idIndexMapCount++);
        return index;
    };
    TreemapSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    TreemapSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    TreemapSeriesModel.prototype.enableAriaDecal = function() {
        (0, $a116b59e46d9072c$export$2e2bcd8739ae039)(this);
    };
    TreemapSeriesModel.type = "series.treemap";
    TreemapSeriesModel.layoutMode = "box";
    TreemapSeriesModel.defaultOption = {
        // Disable progressive rendering
        progressive: 0,
        // size: ['80%', '80%'],            // deprecated, compatible with ec2.
        left: "center",
        top: "middle",
        width: "80%",
        height: "80%",
        sort: true,
        clipWindow: "origin",
        squareRatio: 0.5 * (1 + Math.sqrt(5)),
        leafDepth: null,
        drillDownIcon: "\u25B6",
        // to align specialized icon. ▷▶❒❐▼✚
        zoomToNodeRatio: 0.1024,
        roam: true,
        nodeClick: "zoomToNode",
        animation: true,
        animationDurationUpdate: 900,
        animationEasing: "quinticInOut",
        breadcrumb: {
            show: true,
            height: 22,
            left: "center",
            top: "bottom",
            // right
            // bottom
            emptyItemWidth: 25,
            itemStyle: {
                color: "rgba(0,0,0,0.7)",
                textStyle: {
                    color: "#fff"
                }
            },
            emphasis: {
                itemStyle: {
                    color: "rgba(0,0,0,0.9)" // '#5793f3',
                }
            }
        },
        label: {
            show: true,
            // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
            distance: 0,
            padding: 5,
            position: "inside",
            // formatter: null,
            color: "#fff",
            overflow: "truncate"
        },
        upperLabel: {
            show: false,
            position: [
                0,
                "50%"
            ],
            height: 20,
            // formatter: null,
            // color: '#fff',
            overflow: "truncate",
            // align: null,
            verticalAlign: "middle"
        },
        itemStyle: {
            color: null,
            colorAlpha: null,
            colorSaturation: null,
            borderWidth: 0,
            gapWidth: 0,
            borderColor: "#fff",
            borderColorSaturation: null // If specified, borderColor will be ineffective, and the
        },
        emphasis: {
            upperLabel: {
                show: true,
                position: [
                    0,
                    "50%"
                ],
                overflow: "truncate",
                verticalAlign: "middle"
            }
        },
        visualDimension: 0,
        visualMin: null,
        visualMax: null,
        color: [],
        // level[n].color (if necessary).
        // + Specify color list of each level. level[0].color would be global
        // color list if not specified. (see method `setDefault`).
        // + But set as a empty array to forbid fetch color from global palette
        // when using nodeModel.get('color'), otherwise nodes on deep level
        // will always has color palette set and are not able to inherit color
        // from parent node.
        // + TreemapSeries.color can not be set as 'none', otherwise effect
        // legend color fetching (see seriesColor.js).
        colorAlpha: null,
        colorSaturation: null,
        colorMappingBy: "index",
        visibleMin: 10,
        // be rendered. Only works when sort is 'asc' or 'desc'.
        childrenVisibleMin: null,
        // grandchildren will not show.
        // Why grandchildren? If not grandchildren but children,
        // some siblings show children and some not,
        // the appearance may be mess and not consistent,
        levels: [] // Each item: {
    };
    return TreemapSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
/**
 * @param {Object} dataNode
 */ function $10d079b37d9731a3$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataNode.children, function(child) {
        $10d079b37d9731a3$var$completeTreeValue(child);
        var childValue = child.value;
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */ function $10d079b37d9731a3$var$setDefault(levels, ecModel) {
    var globalColorList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get("color"));
    var globalDecalList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get([
        "aria",
        "decal",
        "decals"
    ]));
    if (!globalColorList) return;
    levels = levels || [];
    var hasColorDefine;
    var hasDecalDefine;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(levels, function(levelDefine) {
        var model = new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine);
        var modelColor = model.get("color");
        var modelDecal = model.get("decal");
        if (model.get([
            "itemStyle",
            "color"
        ]) || modelColor && modelColor !== "none") hasColorDefine = true;
        if (model.get([
            "itemStyle",
            "decal"
        ]) || modelDecal && modelDecal !== "none") hasDecalDefine = true;
    });
    var level0 = levels[0] || (levels[0] = {});
    if (!hasColorDefine) level0.color = globalColorList.slice();
    if (!hasDecalDefine && globalDecalList) level0.decal = globalDecalList.slice();
    return levels;
}
var $10d079b37d9731a3$export$2e2bcd8739ae039 = $10d079b37d9731a3$var$TreemapSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $504a89857fe7780b$var$TEXT_PADDING = 8;
var $504a89857fe7780b$var$ITEM_GAP = 8;
var $504a89857fe7780b$var$ARRAY_LENGTH = 5;
var $504a89857fe7780b$var$Breadcrumb = /** @class */ function() {
    function Breadcrumb(containerGroup) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        containerGroup.add(this.group);
    }
    Breadcrumb.prototype.render = function(seriesModel, api, targetNode, onSelect) {
        var model = seriesModel.getModel("breadcrumb");
        var thisGroup = this.group;
        thisGroup.removeAll();
        if (!model.get("show") || !targetNode) return;
        var normalStyleModel = model.getModel("itemStyle");
        var emphasisModel = model.getModel("emphasis");
        var textStyleModel = normalStyleModel.getModel("textStyle");
        var emphasisTextStyleModel = emphasisModel.getModel([
            "itemStyle",
            "textStyle"
        ]);
        var layoutParam = {
            pos: {
                left: model.get("left"),
                right: model.get("right"),
                top: model.get("top"),
                bottom: model.get("bottom")
            },
            box: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            emptyItemWidth: model.get("emptyItemWidth"),
            totalWidth: 0,
            renderList: []
        };
        this._prepare(targetNode, layoutParam, textStyleModel);
        this._renderContent(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect);
        $93b9bc7f22ac7369$export$74054bd96b5eeef1(thisGroup, layoutParam.pos, layoutParam.box);
    };
    /**
   * Prepare render list and total width
   * @private
   */ Breadcrumb.prototype._prepare = function(targetNode, layoutParam, textStyleModel) {
        for(var node = targetNode; node; node = node.parentNode){
            var text = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(node.getModel().get("name"), "");
            var textRect = textStyleModel.getTextRect(text);
            var itemWidth = Math.max(textRect.width + $504a89857fe7780b$var$TEXT_PADDING * 2, layoutParam.emptyItemWidth);
            layoutParam.totalWidth += itemWidth + $504a89857fe7780b$var$ITEM_GAP;
            layoutParam.renderList.push({
                node: node,
                text: text,
                width: itemWidth
            });
        }
    };
    /**
   * @private
   */ Breadcrumb.prototype._renderContent = function(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect) {
        // Start rendering.
        var lastX = 0;
        var emptyItemWidth = layoutParam.emptyItemWidth;
        var height = seriesModel.get([
            "breadcrumb",
            "height"
        ]);
        var availableSize = $93b9bc7f22ac7369$export$145a8938a85a22b1(layoutParam.pos, layoutParam.box);
        var totalWidth = layoutParam.totalWidth;
        var renderList = layoutParam.renderList;
        var emphasisItemStyle = emphasisModel.getModel("itemStyle").getItemStyle();
        for(var i = renderList.length - 1; i >= 0; i--){
            var item = renderList[i];
            var itemNode = item.node;
            var itemWidth = item.width;
            var text = item.text;
            // Hdie text and shorten width if necessary.
            if (totalWidth > availableSize.width) {
                totalWidth -= itemWidth - emptyItemWidth;
                itemWidth = emptyItemWidth;
                text = null;
            }
            var el = new $51acf033123e1a30$export$2e2bcd8739ae039({
                shape: {
                    points: $504a89857fe7780b$var$makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
                },
                style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(normalStyleModel.getItemStyle(), {
                    lineJoin: "bevel"
                }),
                textContent: new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                        text: text
                    })
                }),
                textConfig: {
                    position: "inside"
                },
                z2: (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 1e4,
                onclick: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(onSelect, itemNode)
            });
            el.disableLabelAnimation = true;
            el.getTextContent().ensureState("emphasis").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(emphasisTextStyleModel, {
                text: text
            });
            el.ensureState("emphasis").style = emphasisItemStyle;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
            this.group.add(el);
            $504a89857fe7780b$var$packEventData(el, seriesModel, itemNode);
            lastX += itemWidth + $504a89857fe7780b$var$ITEM_GAP;
        }
    };
    Breadcrumb.prototype.remove = function() {
        this.group.removeAll();
    };
    return Breadcrumb;
}();
function $504a89857fe7780b$var$makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
    var points = [
        [
            head ? x : x - $504a89857fe7780b$var$ARRAY_LENGTH,
            y
        ],
        [
            x + itemWidth,
            y
        ],
        [
            x + itemWidth,
            y + itemHeight
        ],
        [
            head ? x : x - $504a89857fe7780b$var$ARRAY_LENGTH,
            y + itemHeight
        ]
    ];
    !tail && points.splice(2, 0, [
        x + itemWidth + $504a89857fe7780b$var$ARRAY_LENGTH,
        y + itemHeight / 2
    ]);
    !head && points.push([
        x,
        y + itemHeight / 2
    ]);
    return points;
}
// Package custom mouse event.
function $504a89857fe7780b$var$packEventData(el, seriesModel, itemNode) {
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: "series",
        componentSubType: "treemap",
        componentIndex: seriesModel.componentIndex,
        seriesIndex: seriesModel.seriesIndex,
        seriesName: seriesModel.name,
        seriesType: "treemap",
        selfType: "breadcrumb",
        nodeData: {
            dataIndex: itemNode && itemNode.dataIndex,
            name: itemNode && itemNode.name
        },
        treePathInfo: itemNode && (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(itemNode, seriesModel)
    };
}
var $504a89857fe7780b$export$2e2bcd8739ae039 = $504a89857fe7780b$var$Breadcrumb;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Animate multiple elements with a single done-callback.
 *
 * @example
 *  animation
 *      .createWrap()
 *      .add(el1, {x: 10, y: 10})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */ var $d83d3d8d08e5712f$var$AnimationWrap = /** @class */ function() {
    function AnimationWrap() {
        this._storage = [];
        this._elExistsMap = {};
    }
    /**
   * Caution: a el can only be added once, otherwise 'done'
   * might not be called. This method checks this (by el.id),
   * suppresses adding and returns false when existing el found.
   *
   * @return Whether adding succeeded.
   */ AnimationWrap.prototype.add = function(el, target, duration, delay, easing) {
        if (this._elExistsMap[el.id]) return false;
        this._elExistsMap[el.id] = true;
        this._storage.push({
            el: el,
            target: target,
            duration: duration,
            delay: delay,
            easing: easing
        });
        return true;
    };
    /**
   * Only execute when animation done/aborted.
   */ AnimationWrap.prototype.finished = function(callback) {
        this._finishedCallback = callback;
        return this;
    };
    /**
   * Will stop exist animation firstly.
   */ AnimationWrap.prototype.start = function() {
        var _this = this;
        var count = this._storage.length;
        var checkTerminate = function() {
            count--;
            if (count <= 0) {
                // Guard.
                _this._storage.length = 0;
                _this._elExistsMap = {};
                _this._finishedCallback && _this._finishedCallback();
            }
        };
        for(var i = 0, len = this._storage.length; i < len; i++){
            var item = this._storage[i];
            item.el.animateTo(item.target, {
                duration: item.duration,
                delay: item.delay,
                easing: item.easing,
                setToFinal: true,
                done: checkTerminate,
                aborted: checkTerminate
            });
        }
        return this;
    };
    return AnimationWrap;
}();
function $d83d3d8d08e5712f$export$944643101ee10c7() {
    return new $d83d3d8d08e5712f$var$AnimationWrap();
}








var $ca67abe413e4c090$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $ca67abe413e4c090$var$Rect = $419e5ff2f303755e$export$2e2bcd8739ae039;
var $ca67abe413e4c090$var$DRAG_THRESHOLD = 3;
var $ca67abe413e4c090$var$PATH_LABEL_NOAMAL = "label";
var $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL = "upperLabel";
// Should larger than emphasis states lift z
var $ca67abe413e4c090$var$Z2_BASE = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 10; // Should bigger than every z2.
var $ca67abe413e4c090$var$Z2_BG = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 2;
var $ca67abe413e4c090$var$Z2_CONTENT = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 3;
var $ca67abe413e4c090$var$getStateItemStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)([
    [
        "fill",
        "color"
    ],
    // `borderColor` and `borderWidth` has been occupied,
    // so use `stroke` to indicate the stroke of the rect.
    [
        "stroke",
        "strokeColor"
    ],
    [
        "lineWidth",
        "strokeWidth"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ]
]);
var $ca67abe413e4c090$var$getItemStyleNormal = function(model) {
    // Normal style props should include emphasis style props.
    var itemStyle = $ca67abe413e4c090$var$getStateItemStyle(model);
    // Clear styles set by emphasis.
    itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
    return itemStyle;
};
var $ca67abe413e4c090$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ca67abe413e4c090$var$TreemapView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TreemapView, _super);
    function TreemapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapView.type;
        _this._state = "ready";
        _this._storage = $ca67abe413e4c090$var$createStorage();
        return _this;
    }
    /**
   * @override
   */ TreemapView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var models = ecModel.findComponents({
            mainType: "series",
            subType: "treemap",
            query: payload
        });
        if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(models, seriesModel) < 0) return;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, seriesModel);
        var payloadType = payload && payload.type;
        var layoutInfo = seriesModel.layoutInfo;
        var isInit = !this._oldTree;
        var thisStorage = this._storage;
        // Mark new root when action is treemapRootToNode.
        var reRoot = payloadType === "treemapRootToNode" && targetInfo && thisStorage ? {
            rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
            direction: payload.direction
        } : null;
        var containerGroup = this._giveContainerGroup(layoutInfo);
        var hasAnimation = seriesModel.get("animation");
        var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
        hasAnimation && !isInit && (!payloadType || payloadType === "treemapZoomToNode" || payloadType === "treemapRootToNode") ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
        this._resetController(api);
        this._renderBreadcrumb(seriesModel, api, targetInfo);
    };
    TreemapView.prototype._giveContainerGroup = function(layoutInfo) {
        var containerGroup = this._containerGroup;
        if (!containerGroup) {
            // FIXME
            // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
            containerGroup = this._containerGroup = new $ca67abe413e4c090$var$Group();
            this._initEvents(containerGroup);
            this.group.add(containerGroup);
        }
        containerGroup.x = layoutInfo.x;
        containerGroup.y = layoutInfo.y;
        return containerGroup;
    };
    TreemapView.prototype._doRender = function(containerGroup, seriesModel, reRoot) {
        var thisTree = seriesModel.getData().tree;
        var oldTree = this._oldTree;
        // Clear last shape records.
        var lastsForAnimation = $ca67abe413e4c090$var$createStorage();
        var thisStorage = $ca67abe413e4c090$var$createStorage();
        var oldStorage = this._storage;
        var willInvisibleEls = [];
        function doRenderNode(thisNode, oldNode, parentGroup, depth) {
            return $ca67abe413e4c090$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
        }
        // Notice: When thisTree and oldTree are the same tree (see list.cloneShallow),
        // the oldTree is actually losted, so we cannot find all of the old graphic
        // elements from tree. So we use this strategy: make element storage, move
        // from old storage to new storage, clear old storage.
        dualTravel(thisTree.root ? [
            thisTree.root
        ] : [], oldTree && oldTree.root ? [
            oldTree.root
        ] : [], containerGroup, thisTree === oldTree || !oldTree, 0);
        // Process all removing.
        var willDeleteEls = clearStorage(oldStorage);
        this._oldTree = thisTree;
        this._storage = thisStorage;
        return {
            lastsForAnimation: lastsForAnimation,
            willDeleteEls: willDeleteEls,
            renderFinally: renderFinally
        };
        function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
            // When 'render' is triggered by action,
            // 'this' and 'old' may be the same tree,
            // we use rawIndex in that case.
            if (sameTree) {
                oldViewChildren = thisViewChildren;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(thisViewChildren, function(child, index) {
                    !child.isRemoved() && processNode(index, index);
                });
            } else new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(processNode, null)).execute();
            function getKey(node) {
                // Identify by name or raw index.
                return node.getId();
            }
            function processNode(newIndex, oldIndex) {
                var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
                var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
                var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
                group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
            }
        }
        function clearStorage(storage) {
            var willDeleteEls = $ca67abe413e4c090$var$createStorage();
            storage && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(storage, function(store, storageName) {
                var delEls = willDeleteEls[storageName];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el) {
                    el && (delEls.push(el), $ca67abe413e4c090$var$inner(el).willDelete = true);
                });
            });
            return willDeleteEls;
        }
        function renderFinally() {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(willDeleteEls, function(els) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(els, function(el) {
                    el.parent && el.parent.remove(el);
                });
            });
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(willInvisibleEls, function(el) {
                el.invisible = true;
                // Setting invisible is for optimizing, so no need to set dirty,
                // just mark as invisible.
                el.dirty();
            });
        }
    };
    TreemapView.prototype._doAnimation = function(containerGroup, renderResult, seriesModel, reRoot) {
        var durationOption = seriesModel.get("animationDurationUpdate");
        var easingOption = seriesModel.get("animationEasing");
        // TODO: do not support function until necessary.
        var duration = ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(durationOption) ? 0 : durationOption) || 0;
        var easing = ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easingOption) ? null : easingOption) || "cubicOut";
        var animationWrap = $d83d3d8d08e5712f$export$944643101ee10c7();
        // Make delete animations.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(renderResult.willDeleteEls, function(store, storageName) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                if (el.invisible) return;
                var parent = el.parent; // Always has parent, and parent is nodeGroup.
                var target;
                var innerStore = $ca67abe413e4c090$var$inner(parent);
                if (reRoot && reRoot.direction === "drillDown") target = parent === reRoot.rootNodeGroup ? {
                    shape: {
                        x: 0,
                        y: 0,
                        width: innerStore.nodeWidth,
                        height: innerStore.nodeHeight
                    },
                    style: {
                        opacity: 0
                    }
                } : {
                    style: {
                        opacity: 0
                    }
                };
                else {
                    var targetX = 0;
                    var targetY = 0;
                    if (!innerStore.willDelete) {
                        // Let node animate to right-bottom corner, cooperating with fadeout,
                        // which is appropriate for user understanding.
                        // Divided by 2 for reRoot rolling up effect.
                        targetX = innerStore.nodeWidth / 2;
                        targetY = innerStore.nodeHeight / 2;
                    }
                    target = storageName === "nodeGroup" ? {
                        x: targetX,
                        y: targetY,
                        style: {
                            opacity: 0
                        }
                    } : {
                        shape: {
                            x: targetX,
                            y: targetY,
                            width: 0,
                            height: 0
                        },
                        style: {
                            opacity: 0
                        }
                    };
                }
                // TODO: do not support delay until necessary.
                target && animationWrap.add(el, target, duration, 0, easing);
            });
        });
        // Make other animations
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._storage, function(store, storageName) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                var last = renderResult.lastsForAnimation[storageName][rawIndex];
                var target = {};
                if (!last) return;
                if (el instanceof $7ef7583d8302ffce$export$2e2bcd8739ae039) {
                    if (last.oldX != null) {
                        target.x = el.x;
                        target.y = el.y;
                        el.x = last.oldX;
                        el.y = last.oldY;
                    }
                } else {
                    if (last.oldShape) {
                        target.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
                        el.setShape(last.oldShape);
                    }
                    if (last.fadein) {
                        el.setStyle("opacity", 0);
                        target.style = {
                            opacity: 1
                        };
                    } else if (el.style.opacity !== 1) target.style = {
                        opacity: 1
                    };
                }
                animationWrap.add(el, target, duration, 0, easing);
            });
        }, this);
        this._state = "animating";
        animationWrap.finished((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function() {
            this._state = "ready";
            renderResult.renderFinally();
        }, this)).start();
    };
    TreemapView.prototype._resetController = function(api) {
        var controller = this._controller;
        // Init controller.
        if (!controller) {
            controller = this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
            controller.enable(this.seriesModel.get("roam"));
            controller.on("pan", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onPan, this));
            controller.on("zoom", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onZoom, this));
        }
        var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, api.getWidth(), api.getHeight());
        controller.setPointerChecker(function(e, x, y) {
            return rect.contain(x, y);
        });
    };
    TreemapView.prototype._clearController = function() {
        var controller = this._controller;
        if (controller) {
            controller.dispose();
            controller = null;
        }
    };
    TreemapView.prototype._onPan = function(e) {
        if (this._state !== "animating" && (Math.abs(e.dx) > $ca67abe413e4c090$var$DRAG_THRESHOLD || Math.abs(e.dy) > $ca67abe413e4c090$var$DRAG_THRESHOLD)) {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            this.api.dispatchAction({
                type: "treemapMove",
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rootLayout.x + e.dx,
                    y: rootLayout.y + e.dy,
                    width: rootLayout.width,
                    height: rootLayout.height
                }
            });
        }
    };
    TreemapView.prototype._onZoom = function(e) {
        var mouseX = e.originX;
        var mouseY = e.originY;
        if (this._state !== "animating") {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
            var layoutInfo = this.seriesModel.layoutInfo;
            // Transform mouse coord from global to containerGroup.
            mouseX -= layoutInfo.x;
            mouseY -= layoutInfo.y;
            // Scale root bounding rect.
            var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                -mouseX,
                -mouseY
            ]);
            $f41ebb9dd60b55b4$export$dcdf75081b88279d(m, m, [
                e.scale,
                e.scale
            ]);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                mouseX,
                mouseY
            ]);
            rect.applyTransform(m);
            this.api.dispatchAction({
                type: "treemapRender",
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }
            });
        }
    };
    TreemapView.prototype._initEvents = function(containerGroup) {
        var _this = this;
        containerGroup.on("click", function(e) {
            if (_this._state !== "ready") return;
            var nodeClick = _this.seriesModel.get("nodeClick", true);
            if (!nodeClick) return;
            var targetInfo = _this.findTarget(e.offsetX, e.offsetY);
            if (!targetInfo) return;
            var node = targetInfo.node;
            if (node.getLayout().isLeafRoot) _this._rootToNode(targetInfo);
            else {
                if (nodeClick === "zoomToNode") _this._zoomToNode(targetInfo);
                else if (nodeClick === "link") {
                    var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
                    var link = itemModel.get("link", true);
                    var linkTarget = itemModel.get("target", true) || "blank";
                    link && (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, linkTarget);
                }
            }
        }, this);
    };
    TreemapView.prototype._renderBreadcrumb = function(seriesModel, api, targetInfo) {
        var _this = this;
        if (!targetInfo) {
            targetInfo = seriesModel.get("leafDepth", true) != null ? {
                node: seriesModel.getViewRoot()
            } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
            if (!targetInfo) targetInfo = {
                node: seriesModel.getData().tree.root
            };
        }
        (this._breadcrumb || (this._breadcrumb = new (0, $504a89857fe7780b$export$2e2bcd8739ae039)(this.group))).render(seriesModel, api, targetInfo.node, function(node) {
            if (_this._state !== "animating") $6341f66602946a06$export$df59de26c77b5bea(seriesModel.getViewRoot(), node) ? _this._rootToNode({
                node: node
            }) : _this._zoomToNode({
                node: node
            });
        });
    };
    /**
   * @override
   */ TreemapView.prototype.remove = function() {
        this._clearController();
        this._containerGroup && this._containerGroup.removeAll();
        this._storage = $ca67abe413e4c090$var$createStorage();
        this._state = "ready";
        this._breadcrumb && this._breadcrumb.remove();
    };
    TreemapView.prototype.dispose = function() {
        this._clearController();
    };
    TreemapView.prototype._zoomToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: "treemapZoomToNode",
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    TreemapView.prototype._rootToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: "treemapRootToNode",
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */ TreemapView.prototype.findTarget = function(x, y) {
        var targetInfo;
        var viewRoot = this.seriesModel.getViewRoot();
        viewRoot.eachNode({
            attr: "viewChildren",
            order: "preorder"
        }, function(node) {
            var bgEl = this._storage.background[node.getRawIndex()];
            // If invisible, there might be no element.
            if (bgEl) {
                var point = bgEl.transformCoordToLocal(x, y);
                var shape = bgEl.shape;
                // For performance consideration, don't use 'getBoundingRect'.
                if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) targetInfo = {
                    node: node,
                    offsetX: point[0],
                    offsetY: point[1]
                };
                else return false; // Suppress visit subtree.
            }
        }, this);
        return targetInfo;
    };
    TreemapView.type = "treemap";
    return TreemapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
/**
 * @inner
 */ function $ca67abe413e4c090$var$createStorage() {
    return {
        nodeGroup: [],
        background: [],
        content: []
    };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */ function $ca67abe413e4c090$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
    // Whether under viewRoot.
    if (!thisNode) // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
    // -------------------------------------------------------------------
    // Start of closure variables available in "Procedures in renderNode".
    var thisLayout = thisNode.getLayout();
    var data = seriesModel.getData();
    var nodeModel = thisNode.getModel();
    // Only for enabling highlight/downplay. Clear firstly.
    // Because some node will not be rendered.
    data.setItemGraphicEl(thisNode.dataIndex, null);
    if (!thisLayout || !thisLayout.isInView) return;
    var thisWidth = thisLayout.width;
    var thisHeight = thisLayout.height;
    var borderWidth = thisLayout.borderWidth;
    var thisInvisible = thisLayout.invisible;
    var thisRawIndex = thisNode.getRawIndex();
    var oldRawIndex = oldNode && oldNode.getRawIndex();
    var thisViewChildren = thisNode.viewChildren;
    var upperHeight = thisLayout.upperHeight;
    var isParent = thisViewChildren && thisViewChildren.length;
    var itemStyleNormalModel = nodeModel.getModel("itemStyle");
    var itemStyleEmphasisModel = nodeModel.getModel([
        "emphasis",
        "itemStyle"
    ]);
    var itemStyleBlurModel = nodeModel.getModel([
        "blur",
        "itemStyle"
    ]);
    var itemStyleSelectModel = nodeModel.getModel([
        "select",
        "itemStyle"
    ]);
    var borderRadius = itemStyleNormalModel.get("borderRadius") || 0;
    // End of closure ariables available in "Procedures in renderNode".
    // -----------------------------------------------------------------
    // Node group
    var group = giveGraphic("nodeGroup", $ca67abe413e4c090$var$Group);
    if (!group) return;
    parentGroup.add(group);
    // x,y are not set when el is above view root.
    group.x = thisLayout.x || 0;
    group.y = thisLayout.y || 0;
    group.markRedraw();
    $ca67abe413e4c090$var$inner(group).nodeWidth = thisWidth;
    $ca67abe413e4c090$var$inner(group).nodeHeight = thisHeight;
    if (thisLayout.isAboveViewRoot) return group;
    // Background
    var bg = giveGraphic("background", $ca67abe413e4c090$var$Rect, depth, $ca67abe413e4c090$var$Z2_BG);
    bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
    var emphasisModel = nodeModel.getModel("emphasis");
    var focus = emphasisModel.get("focus");
    var blurScope = emphasisModel.get("blurScope");
    var isDisabled = emphasisModel.get("disabled");
    var focusOrIndices = focus === "ancestor" ? thisNode.getAncestorsIndices() : focus === "descendant" ? thisNode.getDescendantIndices() : focus;
    // No children, render content.
    if (isParent) {
        // Because of the implementation about "traverse" in graphic hover style, we
        // can not set hover listener on the "group" of non-leaf node. Otherwise the
        // hover event from the descendents will be listenered.
        if ((0, $2bf82c0980125b62$export$77d1445f699c58b5)(group)) (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(group, false);
        if (bg) {
            (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(bg, !isDisabled);
            // Only for enabling highlight/downplay.
            data.setItemGraphicEl(thisNode.dataIndex, bg);
            (0, $2bf82c0980125b62$export$24972466b2b62ac2)(bg, focusOrIndices, blurScope);
        }
    } else {
        var content = giveGraphic("content", $ca67abe413e4c090$var$Rect, depth, $ca67abe413e4c090$var$Z2_CONTENT);
        content && renderContent(group, content);
        bg.disableMorphing = true;
        if (bg && (0, $2bf82c0980125b62$export$77d1445f699c58b5)(bg)) (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(bg, false);
        (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(group, !isDisabled);
        // Only for enabling highlight/downplay.
        data.setItemGraphicEl(thisNode.dataIndex, group);
        (0, $2bf82c0980125b62$export$24972466b2b62ac2)(group, focusOrIndices, blurScope);
    }
    return group;
    // ----------------------------
    // | Procedures in renderNode |
    // ----------------------------
    function renderBackground(group, bg, useUpperLabel) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(bg);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        bg.setShape({
            x: 0,
            y: 0,
            width: thisWidth,
            height: thisHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(bg);
        else {
            bg.invisible = false;
            var style = thisNode.getVisual("style");
            var visualBorderColor = style.stroke;
            var normalStyle = $ca67abe413e4c090$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualBorderColor;
            var emphasisStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleEmphasisModel);
            emphasisStyle.fill = itemStyleEmphasisModel.get("borderColor");
            var blurStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleBlurModel);
            blurStyle.fill = itemStyleBlurModel.get("borderColor");
            var selectStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleSelectModel);
            selectStyle.fill = itemStyleSelectModel.get("borderColor");
            if (useUpperLabel) {
                var upperLabelWidth = thisWidth - 2 * borderWidth;
                prepareText(// PENDING: convert ZRColor to ColorString for text.
                bg, visualBorderColor, style.opacity, {
                    x: borderWidth,
                    y: 0,
                    width: upperLabelWidth,
                    height: upperHeight
                });
            } else bg.removeTextContent();
            bg.setStyle(normalStyle);
            bg.ensureState("emphasis").style = emphasisStyle;
            bg.ensureState("blur").style = blurStyle;
            bg.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(bg);
        }
        group.add(bg);
    }
    function renderContent(group, content) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(content);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
        var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
        content.culling = true;
        content.setShape({
            x: borderWidth,
            y: borderWidth,
            width: contentWidth,
            height: contentHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(content);
        else {
            content.invisible = false;
            var nodeStyle = thisNode.getVisual("style");
            var visualColor = nodeStyle.fill;
            var normalStyle = $ca67abe413e4c090$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualColor;
            normalStyle.decal = nodeStyle.decal;
            var emphasisStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleEmphasisModel);
            var blurStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleBlurModel);
            var selectStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleSelectModel);
            // PENDING: convert ZRColor to ColorString for text.
            prepareText(content, visualColor, nodeStyle.opacity, null);
            content.setStyle(normalStyle);
            content.ensureState("emphasis").style = emphasisStyle;
            content.ensureState("blur").style = blurStyle;
            content.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(content);
        }
        group.add(content);
    }
    function processInvisible(element) {
        // Delay invisible setting utill animation finished,
        // avoid element vanish suddenly before animation.
        !element.invisible && willInvisibleEls.push(element);
    }
    function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
    upperLabelRect) {
        var normalLabelModel = nodeModel.getModel(upperLabelRect ? $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL : $ca67abe413e4c090$var$PATH_LABEL_NOAMAL);
        var defaultText = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(nodeModel.get("name"), null);
        var isShow = normalLabelModel.getShallow("show");
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rectEl, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(nodeModel, upperLabelRect ? $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL : $ca67abe413e4c090$var$PATH_LABEL_NOAMAL), {
            defaultText: isShow ? defaultText : null,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            labelFetcher: seriesModel,
            labelDataIndex: thisNode.dataIndex
        });
        var textEl = rectEl.getTextContent();
        if (!textEl) return;
        var textStyle = textEl.style;
        var textPadding = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(textStyle.padding || 0);
        if (upperLabelRect) {
            rectEl.setTextConfig({
                layoutRect: upperLabelRect
            });
            textEl.disableLabelLayout = true;
        }
        textEl.beforeUpdate = function() {
            var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
            var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);
            if (textStyle.width !== width || textStyle.height !== height) textEl.setStyle({
                width: width,
                height: height
            });
        };
        textStyle.truncateMinChar = 2;
        textStyle.lineOverflow = "truncate";
        addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
        var textEmphasisState = textEl.getState("emphasis");
        addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
    }
    function addDrillDownIcon(style, upperLabelRect, thisLayout) {
        var text = style ? style.text : null;
        if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
            var iconChar = seriesModel.get("drillDownIcon", true);
            style.text = iconChar ? iconChar + " " + text : text;
        }
    }
    function giveGraphic(storageName, Ctor, depth, z) {
        var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
        var lasts = lastsForAnimation[storageName];
        if (element) {
            // Remove from oldStorage
            oldStorage[storageName][oldRawIndex] = null;
            prepareAnimationWhenHasOld(lasts, element);
        } else if (!thisInvisible) {
            element = new Ctor();
            if (element instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) element.z2 = $ca67abe413e4c090$var$calculateZ2(depth, z);
            prepareAnimationWhenNoOld(lasts, element);
        }
        // Set to thisStorage
        return thisStorage[storageName][thisRawIndex] = element;
    }
    function prepareAnimationWhenHasOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        if (element instanceof $ca67abe413e4c090$var$Group) {
            lastCfg.oldX = element.x;
            lastCfg.oldY = element.y;
        } else lastCfg.oldShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, element.shape);
    }
    // If a element is new, we need to find the animation start point carefully,
    // otherwise it will looks strange when 'zoomToNode'.
    function prepareAnimationWhenNoOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        var parentNode = thisNode.parentNode;
        var isGroup = element instanceof $7ef7583d8302ffce$export$2e2bcd8739ae039;
        if (parentNode && (!reRoot || reRoot.direction === "drillDown")) {
            var parentOldX = 0;
            var parentOldY = 0;
            // New nodes appear from right-bottom corner in 'zoomToNode' animation.
            // For convenience, get old bounding rect from background.
            var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
            if (!reRoot && parentOldBg && parentOldBg.oldShape) {
                parentOldX = parentOldBg.oldShape.width;
                parentOldY = parentOldBg.oldShape.height;
            }
            // When no parent old shape found, its parent is new too,
            // so we can just use {x:0, y:0}.
            if (isGroup) {
                lastCfg.oldX = 0;
                lastCfg.oldY = parentOldY;
            } else lastCfg.oldShape = {
                x: parentOldX,
                y: parentOldY,
                width: 0,
                height: 0
            };
        }
        // Fade in, user can be aware that these nodes are new.
        lastCfg.fadein = !isGroup;
    }
}
// We cannot set all background with the same z, because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause lower background elements to overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.
function $ca67abe413e4c090$var$calculateZ2(depth, z2InLevel) {
    return depth * $ca67abe413e4c090$var$Z2_BASE + z2InLevel;
}
var $ca67abe413e4c090$export$2e2bcd8739ae039 = $ca67abe413e4c090$var$TreemapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $7b50f502cfd189d5$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $7b50f502cfd189d5$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX = -1;
var $7b50f502cfd189d5$var$VisualMapping = /** @class */ function() {
    function VisualMapping(option) {
        var mappingMethod = option.mappingMethod;
        var visualType = option.type;
        var thisOption = this.option = $7a1bd9c2710fea0d$export$9cd59f9826255e47(option);
        this.type = visualType;
        this.mappingMethod = mappingMethod;
        this._normalizeData = $7b50f502cfd189d5$var$normalizers[mappingMethod];
        var visualHandler = VisualMapping.visualHandlers[visualType];
        this.applyVisual = visualHandler.applyVisual;
        this.getColorMapper = visualHandler.getColorMapper;
        this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];
        if (mappingMethod === "piecewise") {
            $7b50f502cfd189d5$var$normalizeVisualRange(thisOption);
            $7b50f502cfd189d5$var$preprocessForPiecewise(thisOption);
        } else if (mappingMethod === "category") thisOption.categories ? $7b50f502cfd189d5$var$preprocessForSpecifiedCategory(thisOption) : $7b50f502cfd189d5$var$normalizeVisualRange(thisOption, true);
        else {
            // mappingMethod === 'linear' or 'fixed'
            $7a1bd9c2710fea0d$export$a7a9523472993e97(mappingMethod !== "linear" || thisOption.dataExtent);
            $7b50f502cfd189d5$var$normalizeVisualRange(thisOption);
        }
    }
    VisualMapping.prototype.mapValueToVisual = function(value) {
        var normalized = this._normalizeData(value);
        return this._normalizedToVisual(normalized, value);
    };
    VisualMapping.prototype.getNormalizer = function() {
        return $7a1bd9c2710fea0d$export$2385a24977818dd0(this._normalizeData, this);
    };
    /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */ VisualMapping.listVisualTypes = function() {
        return $7a1bd9c2710fea0d$export$ed97f33186d4b816(VisualMapping.visualHandlers);
    };
    // /**
    //  * @public
    //  */
    // static addVisualHandler(name, handler) {
    //     visualHandlers[name] = handler;
    // }
    /**
   * @public
   */ VisualMapping.isValidType = function(visualType) {
        return VisualMapping.visualHandlers.hasOwnProperty(visualType);
    };
    /**
   * Convenient method.
   * Visual can be Object or Array or primary type.
   */ VisualMapping.eachVisual = function(visual, callback, context) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7a1bd9c2710fea0d$export$79b2f7037acddd43(visual, callback, context);
        else callback.call(context, visual);
    };
    VisualMapping.mapVisual = function(visual, callback, context) {
        var isPrimary;
        var newVisual = $7a1bd9c2710fea0d$export$43bee75e5e14138e(visual) ? [] : $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual) ? {} : (isPrimary = true, null);
        VisualMapping.eachVisual(visual, function(v, key) {
            var newVal = callback.call(context, v, key);
            isPrimary ? newVisual = newVal : newVisual[key] = newVal;
        });
        return newVisual;
    };
    /**
   * Retrieve visual properties from given object.
   */ VisualMapping.retrieveVisuals = function(obj) {
        var ret = {};
        var hasVisual;
        obj && $7b50f502cfd189d5$var$each(VisualMapping.visualHandlers, function(h, visualType) {
            if (obj.hasOwnProperty(visualType)) {
                ret[visualType] = obj[visualType];
                hasVisual = true;
            }
        });
        return hasVisual ? ret : null;
    };
    /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */ VisualMapping.prepareVisualTypes = function(visualTypes) {
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(visualTypes)) visualTypes = visualTypes.slice();
        else if ($7b50f502cfd189d5$var$isObject(visualTypes)) {
            var types_1 = [];
            $7b50f502cfd189d5$var$each(visualTypes, function(item, type) {
                types_1.push(type);
            });
            visualTypes = types_1;
        } else return [];
        visualTypes.sort(function(type1, type2) {
            // color should be front of colorSaturation, colorAlpha, ...
            // symbol and symbolSize do not matter.
            return type2 === "color" && type1 !== "color" && type1.indexOf("color") === 0 ? 1 : -1;
        });
        return visualTypes;
    };
    /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */ VisualMapping.dependsOn = function(visualType1, visualType2) {
        return visualType2 === "color" ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
    };
    /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */ VisualMapping.findPieceIndex = function(value, pieceList, findClosestWhenOutside) {
        var possibleI;
        var abs = Infinity;
        // value has the higher priority.
        for(var i = 0, len = pieceList.length; i < len; i++){
            var pieceValue = pieceList[i].value;
            if (pieceValue != null) {
                if (pieceValue === value || $7a1bd9c2710fea0d$export$844ec244b1367d54(pieceValue) && pieceValue === value + "") return i;
                findClosestWhenOutside && updatePossible(pieceValue, i);
            }
        }
        for(var i = 0, len = pieceList.length; i < len; i++){
            var piece = pieceList[i];
            var interval = piece.interval;
            var close_1 = piece.close;
            if (interval) {
                if (interval[0] === -Infinity) {
                    if ($7b50f502cfd189d5$var$littleThan(close_1[1], value, interval[1])) return i;
                } else if (interval[1] === Infinity) {
                    if ($7b50f502cfd189d5$var$littleThan(close_1[0], interval[0], value)) return i;
                } else if ($7b50f502cfd189d5$var$littleThan(close_1[0], interval[0], value) && $7b50f502cfd189d5$var$littleThan(close_1[1], value, interval[1])) return i;
                findClosestWhenOutside && updatePossible(interval[0], i);
                findClosestWhenOutside && updatePossible(interval[1], i);
            }
        }
        if (findClosestWhenOutside) return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
        function updatePossible(val, index) {
            var newAbs = Math.abs(val - value);
            if (newAbs < abs) {
                abs = newAbs;
                possibleI = index;
            }
        }
    };
    VisualMapping.visualHandlers = {
        color: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("color"),
            getColorMapper: function() {
                var thisOption = this.option;
                return $7a1bd9c2710fea0d$export$2385a24977818dd0(thisOption.mappingMethod === "category" ? function(value, isNormalized) {
                    !isNormalized && (value = this._normalizeData(value));
                    return $7b50f502cfd189d5$var$doMapCategory.call(this, value);
                } : function(value, isNormalized, out) {
                    // If output rgb array
                    // which will be much faster and useful in pixel manipulation
                    var returnRGBArray = !!out;
                    !isNormalized && (value = this._normalizeData(value));
                    out = $2c037f5bda6341ca$export$66cb3c0e9efc61c8(value, thisOption.parsedVisual, out);
                    return returnRGBArray ? out : $2c037f5bda6341ca$export$fac44ee5b035f737(out, "rgba");
                }, this);
            },
            _normalizedToVisual: {
                linear: function(normalized) {
                    return $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                },
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                    return result;
                },
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        colorHue: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, value);
        }),
        colorSaturation: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, null, value);
        }),
        colorLightness: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, null, null, value);
        }),
        colorAlpha: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$ab4754bf42583a26(color, value);
        }),
        decal: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("decal"),
            _normalizedToVisual: {
                linear: null,
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: null,
                fixed: null
            }
        },
        opacity: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("opacity"),
            _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        },
        liftZ: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("liftZ"),
            _normalizedToVisual: {
                linear: $7b50f502cfd189d5$var$doMapFixed,
                category: $7b50f502cfd189d5$var$doMapFixed,
                piecewise: $7b50f502cfd189d5$var$doMapFixed,
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        symbol: {
            applyVisual: function(value, getter, setter) {
                var symbolCfg = this.mapValueToVisual(value);
                setter("symbol", symbolCfg);
            },
            _normalizedToVisual: {
                linear: $7b50f502cfd189d5$var$doMapToArray,
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $7b50f502cfd189d5$var$doMapToArray.call(this, normalized);
                    return result;
                },
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        symbolSize: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("symbolSize"),
            _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        }
    };
    return VisualMapping;
}();
function $7b50f502cfd189d5$var$preprocessForPiecewise(thisOption) {
    var pieceList = thisOption.pieceList;
    thisOption.hasSpecialVisual = false;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
        piece.originIndex = index;
        // piece.visual is "result visual value" but not
        // a visual range, so it does not need to be normalized.
        if (piece.visual != null) thisOption.hasSpecialVisual = true;
    });
}
function $7b50f502cfd189d5$var$preprocessForSpecifiedCategory(thisOption) {
    // Hash categories.
    var categories = thisOption.categories;
    var categoryMap = thisOption.categoryMap = {};
    var visual = thisOption.visual;
    $7b50f502cfd189d5$var$each(categories, function(cate, index) {
        categoryMap[cate] = index;
    });
    // Process visual map input.
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(visual)) {
        var visualArr_1 = [];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7b50f502cfd189d5$var$each(visual, function(v, cate) {
            var index = categoryMap[cate];
            visualArr_1[index != null ? index : $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX] = v;
        });
        else // Is primary type, represents default visual.
        visualArr_1[$7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
        visual = $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr_1);
    }
    // Remove categories that has no visual,
    // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
    for(var i = categories.length - 1; i >= 0; i--)if (visual[i] == null) {
        delete categoryMap[categories[i]];
        categories.pop();
    }
}
function $7b50f502cfd189d5$var$normalizeVisualRange(thisOption, isCategory) {
    var visual = thisOption.visual;
    var visualArr = [];
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7b50f502cfd189d5$var$each(visual, function(v) {
        visualArr.push(v);
    });
    else if (visual != null) visualArr.push(visual);
    var doNotNeedPair = {
        color: 1,
        symbol: 1
    };
    if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
    $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr);
}
function $7b50f502cfd189d5$var$makePartialColorVisualHandler(applyValue) {
    return {
        applyVisual: function(value, getter, setter) {
            // Only used in HSL
            var colorChannel = this.mapValueToVisual(value);
            // Must not be array value
            setter("color", applyValue(getter("color"), colorChannel));
        },
        _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
            0,
            1
        ])
    };
}
function $7b50f502cfd189d5$var$doMapToArray(normalized) {
    var visual = this.option.visual;
    return visual[Math.round((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, [
        0,
        1
    ], [
        0,
        visual.length - 1
    ], true))] || {}; // TODO {}?
}
function $7b50f502cfd189d5$var$makeApplyVisual(visualType) {
    return function(value, getter, setter) {
        setter(visualType, this.mapValueToVisual(value));
    };
}
function $7b50f502cfd189d5$var$doMapCategory(normalized) {
    var visual = this.option.visual;
    return visual[this.option.loop && normalized !== $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}
function $7b50f502cfd189d5$var$doMapFixed() {
    // visual will be convert to array.
    return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */ function $7b50f502cfd189d5$var$createNormalizedToNumericVisual(sourceExtent) {
    return {
        linear: function(normalized) {
            return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
        },
        category: $7b50f502cfd189d5$var$doMapCategory,
        piecewise: function(normalized, value) {
            var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
            if (result == null) result = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
            return result;
        },
        fixed: $7b50f502cfd189d5$var$doMapFixed
    };
}
function $7b50f502cfd189d5$var$getSpecifiedVisual(value) {
    var thisOption = this.option;
    var pieceList = thisOption.pieceList;
    if (thisOption.hasSpecialVisual) {
        var pieceIndex = $7b50f502cfd189d5$var$VisualMapping.findPieceIndex(value, pieceList);
        var piece = pieceList[pieceIndex];
        if (piece && piece.visual) return piece.visual[this.type];
    }
}
function $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr) {
    thisOption.visual = visualArr;
    if (thisOption.type === "color") thisOption.parsedVisual = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualArr, function(item) {
        var color = $2c037f5bda6341ca$export$98e6a39c04603d36(item);
        return color || [
            0,
            0,
            0,
            1
        ];
    });
    return visualArr;
}
/**
 * Normalizers by mapping methods.
 */ var $7b50f502cfd189d5$var$normalizers = {
    linear: function(value) {
        return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, this.option.dataExtent, [
            0,
            1
        ], true);
    },
    piecewise: function(value) {
        var pieceList = this.option.pieceList;
        var pieceIndex = $7b50f502cfd189d5$var$VisualMapping.findPieceIndex(value, pieceList, true);
        if (pieceIndex != null) return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(pieceIndex, [
            0,
            pieceList.length - 1
        ], [
            0,
            1
        ], true);
    },
    category: function(value) {
        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value
        return index == null ? $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX : index;
    },
    fixed: $7a1bd9c2710fea0d$export$8793edee2d425525
};
function $7b50f502cfd189d5$var$littleThan(close, a, b) {
    return close ? a <= b : a < b;
}
var $7b50f502cfd189d5$export$2e2bcd8739ae039 = $7b50f502cfd189d5$var$VisualMapping;





var $e6cba72659c474bb$var$ITEM_STYLE_NORMAL = "itemStyle";
var $e6cba72659c474bb$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e6cba72659c474bb$export$2e2bcd8739ae039 = {
    seriesType: "treemap",
    reset: function(seriesModel) {
        var tree = seriesModel.getData().tree;
        var root = tree.root;
        if (root.isRemoved()) return;
        $e6cba72659c474bb$var$travelTree(root, // Visual should calculate from tree root but not view root.
        {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
    }
};
function $e6cba72659c474bb$var$travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
    var nodeModel = node.getModel();
    var nodeLayout = node.getLayout();
    var data = node.hostTree.data;
    // Optimize
    if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) return;
    var nodeItemStyleModel = nodeModel.getModel($e6cba72659c474bb$var$ITEM_STYLE_NORMAL);
    var visuals = $e6cba72659c474bb$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
    var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
    // calculate border color
    var borderColor = nodeItemStyleModel.get("borderColor");
    var borderColorSaturation = nodeItemStyleModel.get("borderColorSaturation");
    var thisNodeColor;
    if (borderColorSaturation != null) {
        // For performance, do not always execute 'calculateColor'.
        thisNodeColor = $e6cba72659c474bb$var$calculateColor(visuals);
        borderColor = $e6cba72659c474bb$var$calculateBorderColor(borderColorSaturation, thisNodeColor);
    }
    existsStyle.stroke = borderColor;
    var viewChildren = node.viewChildren;
    if (!viewChildren || !viewChildren.length) {
        thisNodeColor = $e6cba72659c474bb$var$calculateColor(visuals);
        // Apply visual to this node.
        existsStyle.fill = thisNodeColor;
    } else {
        var mapping_1 = $e6cba72659c474bb$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren);
        // Designate visual to children.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(viewChildren, function(child, index) {
            // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
            if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
                var childVisual = $e6cba72659c474bb$var$mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
                $e6cba72659c474bb$var$travelTree(child, childVisual, viewRootAncestors, seriesModel);
            }
        });
    }
}
function $e6cba72659c474bb$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
    var visuals = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, designatedVisual);
    var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "color",
        "colorAlpha",
        "colorSaturation"
    ], function(visualName) {
        // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
        designatedVisualItemStyle[visualName] = designatedVisual[visualName];
        var val = nodeItemStyleModel.get(visualName);
        designatedVisualItemStyle[visualName] = null;
        val != null && (visuals[visualName] = val);
    });
    return visuals;
}
function $e6cba72659c474bb$var$calculateColor(visuals) {
    var color = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "color");
    if (color) {
        var colorAlpha = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "colorAlpha");
        var colorSaturation = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "colorSaturation");
        if (colorSaturation) color = (0, $2c037f5bda6341ca$export$d898ae866e27bf18)(color, null, null, colorSaturation);
        if (colorAlpha) color = (0, $2c037f5bda6341ca$export$ab4754bf42583a26)(color, colorAlpha);
        return color;
    }
}
function $e6cba72659c474bb$var$calculateBorderColor(borderColorSaturation, thisNodeColor) {
    return thisNodeColor != null ? (0, $2c037f5bda6341ca$export$d898ae866e27bf18)(thisNodeColor, null, null, borderColorSaturation) : null;
}
function $e6cba72659c474bb$var$getValueVisualDefine(visuals, name) {
    var value = visuals[name];
    if (value != null && value !== "none") return value;
}
function $e6cba72659c474bb$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
    if (!viewChildren || !viewChildren.length) return;
    var rangeVisual = $e6cba72659c474bb$var$getRangeVisual(nodeModel, "color") || visuals.color != null && visuals.color !== "none" && ($e6cba72659c474bb$var$getRangeVisual(nodeModel, "colorAlpha") || $e6cba72659c474bb$var$getRangeVisual(nodeModel, "colorSaturation"));
    if (!rangeVisual) return;
    var visualMin = nodeModel.get("visualMin");
    var visualMax = nodeModel.get("visualMax");
    var dataExtent = nodeLayout.dataExtent.slice();
    visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
    visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
    var colorMappingBy = nodeModel.get("colorMappingBy");
    var opt = {
        type: rangeVisual.name,
        dataExtent: dataExtent,
        visual: rangeVisual.range
    };
    if (opt.type === "color" && (colorMappingBy === "index" || colorMappingBy === "id")) {
        opt.mappingMethod = "category";
        opt.loop = true;
    // categories is ordinal, so do not set opt.categories.
    } else opt.mappingMethod = "linear";
    var mapping = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(opt);
    $e6cba72659c474bb$var$inner(mapping).drColorMappingBy = colorMappingBy;
    return mapping;
}
// Notice: If we don't have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node doesn't have children, and its siblings have children,
// and colorRange is set on level-1, then the node cannot be colored.
// So we separate 'colorRange' and 'color' to different attributes.
function $e6cba72659c474bb$var$getRangeVisual(nodeModel, name) {
    // 'colorRange', 'colorARange', 'colorSRange'.
    // If not exists on this node, fetch from levels and series.
    var range = nodeModel.get(name);
    return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(range) && range.length ? {
        name: name,
        range: range
    } : null;
}
function $e6cba72659c474bb$var$mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
    var childVisuals = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, visuals);
    if (mapping) {
        // Only support color, colorAlpha, colorSaturation.
        var mappingType = mapping.type;
        var colorMappingBy = mappingType === "color" && $e6cba72659c474bb$var$inner(mapping).drColorMappingBy;
        var value = colorMappingBy === "index" ? index : colorMappingBy === "id" ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get("visualDimension"));
        childVisuals[mappingType] = mapping.mapValueToVisual(value);
    }
    return childVisuals;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 




var $2f13a432668907b0$var$mathMax = Math.max;
var $2f13a432668907b0$var$mathMin = Math.min;
var $2f13a432668907b0$var$retrieveValue = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66;
var $2f13a432668907b0$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $2f13a432668907b0$var$PATH_BORDER_WIDTH = [
    "itemStyle",
    "borderWidth"
];
var $2f13a432668907b0$var$PATH_GAP_WIDTH = [
    "itemStyle",
    "gapWidth"
];
var $2f13a432668907b0$var$PATH_UPPER_LABEL_SHOW = [
    "upperLabel",
    "show"
];
var $2f13a432668907b0$var$PATH_UPPER_LABEL_HEIGHT = [
    "upperLabel",
    "height"
];
var /**
 * @public
 */ $2f13a432668907b0$export$2e2bcd8739ae039 = {
    seriesType: "treemap",
    reset: function(seriesModel, ecModel, api, payload) {
        // Layout result in each node:
        // {x, y, width, height, area, borderWidth}
        var ecWidth = api.getWidth();
        var ecHeight = api.getHeight();
        var seriesOption = seriesModel.option;
        var layoutInfo = $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        var size = seriesOption.size || []; // Compatible with ec2.
        var containerWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)($2f13a432668907b0$var$retrieveValue(layoutInfo.width, size[0]), ecWidth);
        var containerHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)($2f13a432668907b0$var$retrieveValue(layoutInfo.height, size[1]), ecHeight);
        // Fetch payload info.
        var payloadType = payload && payload.type;
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, seriesModel);
        var rootRect = payloadType === "treemapRender" || payloadType === "treemapMove" ? payload.rootRect : null;
        var viewRoot = seriesModel.getViewRoot();
        var viewAbovePath = $6341f66602946a06$export$6be31fe4499506f9(viewRoot);
        if (payloadType !== "treemapMove") {
            var rootSize = payloadType === "treemapZoomToNode" ? $2f13a432668907b0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [
                rootRect.width,
                rootRect.height
            ] : [
                containerWidth,
                containerHeight
            ];
            var sort_1 = seriesOption.sort;
            if (sort_1 && sort_1 !== "asc" && sort_1 !== "desc") // Default to be desc order.
            sort_1 = "desc";
            var options = {
                squareRatio: seriesOption.squareRatio,
                sort: sort_1,
                leafDepth: seriesOption.leafDepth
            };
            // layout should be cleared because using updateView but not update.
            viewRoot.hostTree.clearLayouts();
            // TODO
            // optimize: if out of view clip, do not layout.
            // But take care that if do not render node out of view clip,
            // how to calculate start po
            var viewRootLayout_1 = {
                x: 0,
                y: 0,
                width: rootSize[0],
                height: rootSize[1],
                area: rootSize[0] * rootSize[1]
            };
            viewRoot.setLayout(viewRootLayout_1);
            $2f13a432668907b0$var$squarify(viewRoot, options, false, 0);
            // Supplement layout.
            viewRootLayout_1 = viewRoot.getLayout();
            $2f13a432668907b0$var$each(viewAbovePath, function(node, index) {
                var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
                node.setLayout($7a1bd9c2710fea0d$export$8b58be045bf06082({
                    dataExtent: [
                        childValue,
                        childValue
                    ],
                    borderWidth: 0,
                    upperHeight: 0
                }, viewRootLayout_1));
            });
        }
        var treeRoot = seriesModel.getData().tree.root;
        treeRoot.setLayout($2f13a432668907b0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
        seriesModel.setLayoutInfo(layoutInfo);
        // FIXME
        // 现在没有clip功能，暂时取ec高宽。
        $2f13a432668907b0$var$prunning(treeRoot, // Transform to base element coordinate system.
        new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
    }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */ function $2f13a432668907b0$var$squarify(node, options, hideChildren, depth) {
    var width;
    var height;
    if (node.isRemoved()) return;
    var thisLayout = node.getLayout();
    width = thisLayout.width;
    height = thisLayout.height;
    // Considering border and gap
    var nodeModel = node.getModel();
    var borderWidth = nodeModel.get($2f13a432668907b0$var$PATH_BORDER_WIDTH);
    var halfGapWidth = nodeModel.get($2f13a432668907b0$var$PATH_GAP_WIDTH) / 2;
    var upperLabelHeight = $2f13a432668907b0$var$getUpperLabelHeight(nodeModel);
    var upperHeight = Math.max(borderWidth, upperLabelHeight);
    var layoutOffset = borderWidth - halfGapWidth;
    var layoutOffsetUpper = upperHeight - halfGapWidth;
    node.setLayout({
        borderWidth: borderWidth,
        upperHeight: upperHeight,
        upperLabelHeight: upperLabelHeight
    }, true);
    width = $2f13a432668907b0$var$mathMax(width - 2 * layoutOffset, 0);
    height = $2f13a432668907b0$var$mathMax(height - layoutOffset - layoutOffsetUpper, 0);
    var totalArea = width * height;
    var viewChildren = $2f13a432668907b0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
    if (!viewChildren.length) return;
    var rect = {
        x: layoutOffset,
        y: layoutOffsetUpper,
        width: width,
        height: height
    };
    var rowFixedLength = $2f13a432668907b0$var$mathMin(width, height);
    var best = Infinity; // the best row score so far
    var row = [];
    row.area = 0;
    for(var i = 0, len = viewChildren.length; i < len;){
        var child = viewChildren[i];
        row.push(child);
        row.area += child.getLayout().area;
        var score = $2f13a432668907b0$var$worst(row, rowFixedLength, options.squareRatio);
        // continue with this orientation
        if (score <= best) {
            i++;
            best = score;
        } else {
            row.area -= row.pop().getLayout().area;
            $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, false);
            rowFixedLength = $2f13a432668907b0$var$mathMin(rect.width, rect.height);
            row.length = row.area = 0;
            best = Infinity;
        }
    }
    if (row.length) $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, true);
    if (!hideChildren) {
        var childrenVisibleMin = nodeModel.get("childrenVisibleMin");
        if (childrenVisibleMin != null && totalArea < childrenVisibleMin) hideChildren = true;
    }
    for(var i = 0, len = viewChildren.length; i < len; i++)$2f13a432668907b0$var$squarify(viewChildren[i], options, hideChildren, depth + 1);
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */ function $2f13a432668907b0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
    var viewChildren = node.children || [];
    var orderBy = options.sort;
    orderBy !== "asc" && orderBy !== "desc" && (orderBy = null);
    var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth;
    // leafDepth has higher priority.
    if (hideChildren && !overLeafDepth) return node.viewChildren = [];
    // Sort children, order by desc.
    viewChildren = $7a1bd9c2710fea0d$export$3dea766d36a8935f(viewChildren, function(child) {
        return !child.isRemoved();
    });
    $2f13a432668907b0$var$sort(viewChildren, orderBy);
    var info = $2f13a432668907b0$var$statistic(nodeModel, viewChildren, orderBy);
    if (info.sum === 0) return node.viewChildren = [];
    info.sum = $2f13a432668907b0$var$filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
    if (info.sum === 0) return node.viewChildren = [];
    // Set area to each child.
    for(var i = 0, len = viewChildren.length; i < len; i++){
        var area = viewChildren[i].getValue() / info.sum * totalArea;
        // Do not use setLayout({...}, true), because it is needed to clear last layout.
        viewChildren[i].setLayout({
            area: area
        });
    }
    if (overLeafDepth) {
        viewChildren.length && node.setLayout({
            isLeafRoot: true
        }, true);
        viewChildren.length = 0;
    }
    node.viewChildren = viewChildren;
    node.setLayout({
        dataExtent: info.dataExtent
    }, true);
    return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */ function $2f13a432668907b0$var$filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
    // visibleMin is not supported yet when no option.sort.
    if (!orderBy) return sum;
    var visibleMin = nodeModel.get("visibleMin");
    var len = orderedChildren.length;
    var deletePoint = len;
    // Always travel from little value to big value.
    for(var i = len - 1; i >= 0; i--){
        var value = orderedChildren[orderBy === "asc" ? len - i - 1 : i].getValue();
        if (value / sum * totalArea < visibleMin) {
            deletePoint = i;
            sum -= value;
        }
    }
    orderBy === "asc" ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
    return sum;
}
/**
 * Sort
 */ function $2f13a432668907b0$var$sort(viewChildren, orderBy) {
    if (orderBy) viewChildren.sort(function(a, b) {
        var diff = orderBy === "asc" ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
        return diff === 0 ? orderBy === "asc" ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
    return viewChildren;
}
/**
 * Statistic
 */ function $2f13a432668907b0$var$statistic(nodeModel, children, orderBy) {
    // Calculate sum.
    var sum = 0;
    for(var i = 0, len = children.length; i < len; i++)sum += children[i].getValue();
    // Statistic data extent for latter visual coding.
    // Notice: data extent should be calculate based on raw children
    // but not filtered view children, otherwise visual mapping will not
    // be stable when zoom (where children is filtered by visibleMin).
    var dimension = nodeModel.get("visualDimension");
    var dataExtent;
    // The same as area dimension.
    if (!children || !children.length) dataExtent = [
        NaN,
        NaN
    ];
    else if (dimension === "value" && orderBy) {
        dataExtent = [
            children[children.length - 1].getValue(),
            children[0].getValue()
        ];
        orderBy === "asc" && dataExtent.reverse();
    } else {
        dataExtent = [
            Infinity,
            -Infinity
        ];
        $2f13a432668907b0$var$each(children, function(child) {
            var value = child.getValue(dimension);
            value < dataExtent[0] && (dataExtent[0] = value);
            value > dataExtent[1] && (dataExtent[1] = value);
        });
    }
    return {
        sum: sum,
        dataExtent: dataExtent
    };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */ function $2f13a432668907b0$var$worst(row, rowFixedLength, ratio) {
    var areaMax = 0;
    var areaMin = Infinity;
    for(var i = 0, area = void 0, len = row.length; i < len; i++){
        area = row[i].getLayout().area;
        if (area) {
            area < areaMin && (areaMin = area);
            area > areaMax && (areaMax = area);
        }
    }
    var squareArea = row.area * row.area;
    var f = rowFixedLength * rowFixedLength * ratio;
    return squareArea ? $2f13a432668907b0$var$mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */ function $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, flush) {
    // When rowFixedLength === rect.width,
    // it is horizontal subdivision,
    // rowFixedLength is the width of the subdivision,
    // rowOtherLength is the height of the subdivision,
    // and nodes will be positioned from left to right.
    // wh[idx0WhenH] means: when horizontal,
    //      wh[idx0WhenH] => wh[0] => 'width'.
    //      xy[idx1WhenH] => xy[1] => 'y'.
    var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
    var idx1WhenH = 1 - idx0WhenH;
    var xy = [
        "x",
        "y"
    ];
    var wh = [
        "width",
        "height"
    ];
    var last = rect[xy[idx0WhenH]];
    var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
    if (flush || rowOtherLength > rect[wh[idx1WhenH]]) rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
    for(var i = 0, rowLen = row.length; i < rowLen; i++){
        var node = row[i];
        var nodeLayout = {};
        var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
        var wh1 = nodeLayout[wh[idx1WhenH]] = $2f13a432668907b0$var$mathMax(rowOtherLength - 2 * halfGapWidth, 0);
        // We use Math.max/min to avoid negative width/height when considering gap width.
        var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
        var modWH = i === rowLen - 1 || remain < step ? remain : step;
        var wh0 = nodeLayout[wh[idx0WhenH]] = $2f13a432668907b0$var$mathMax(modWH - 2 * halfGapWidth, 0);
        nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + $2f13a432668907b0$var$mathMin(halfGapWidth, wh1 / 2);
        nodeLayout[xy[idx0WhenH]] = last + $2f13a432668907b0$var$mathMin(halfGapWidth, wh0 / 2);
        last += modWH;
        node.setLayout(nodeLayout, true);
    }
    rect[xy[idx1WhenH]] += rowOtherLength;
    rect[wh[idx1WhenH]] -= rowOtherLength;
}
// Return [containerWidth, containerHeight] as default.
function $2f13a432668907b0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
    // If targetInfo.node exists, we zoom to the node,
    // so estimate whole width and height by target node.
    var currNode = (targetInfo || {}).node;
    var defaultSize = [
        containerWidth,
        containerHeight
    ];
    if (!currNode || currNode === viewRoot) return defaultSize;
    var parent;
    var viewArea = containerWidth * containerHeight;
    var area = viewArea * seriesModel.option.zoomToNodeRatio;
    while(parent = currNode.parentNode){
        // jshint ignore:line
        var sum = 0;
        var siblings = parent.children;
        for(var i = 0, len = siblings.length; i < len; i++)sum += siblings[i].getValue();
        var currNodeValue = currNode.getValue();
        if (currNodeValue === 0) return defaultSize;
        area *= sum / currNodeValue;
        // Considering border, suppose aspect ratio is 1.
        var parentModel = parent.getModel();
        var borderWidth = parentModel.get($2f13a432668907b0$var$PATH_BORDER_WIDTH);
        var upperHeight = Math.max(borderWidth, $2f13a432668907b0$var$getUpperLabelHeight(parentModel));
        area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
        area > (0, $cfc1f3b422a3185f$export$18510406f204a1b9) && (area = (0, $cfc1f3b422a3185f$export$18510406f204a1b9));
        currNode = parent;
    }
    area < viewArea && (area = viewArea);
    var scale = Math.pow(area / viewArea, 0.5);
    return [
        containerWidth * scale,
        containerHeight * scale
    ];
}
// Root position based on coord of containerGroup
function $2f13a432668907b0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo) {
    if (rootRect) return {
        x: rootRect.x,
        y: rootRect.y
    };
    var defaultPosition = {
        x: 0,
        y: 0
    };
    if (!targetInfo) return defaultPosition;
    // If targetInfo is fetched by 'retrieveTargetInfo',
    // old tree and new tree are the same tree,
    // so the node still exists and we can visit it.
    var targetNode = targetInfo.node;
    var layout = targetNode.getLayout();
    if (!layout) return defaultPosition;
    // Transform coord from local to container.
    var targetCenter = [
        layout.width / 2,
        layout.height / 2
    ];
    var node = targetNode;
    while(node){
        var nodeLayout = node.getLayout();
        targetCenter[0] += nodeLayout.x;
        targetCenter[1] += nodeLayout.y;
        node = node.parentNode;
    }
    return {
        x: layoutInfo.width / 2 - targetCenter[0],
        y: layoutInfo.height / 2 - targetCenter[1]
    };
}
// Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.
function $2f13a432668907b0$var$prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
    var nodeLayout = node.getLayout();
    var nodeInViewAbovePath = viewAbovePath[depth];
    var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
    if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) return;
    node.setLayout({
        // isInView means: viewRoot sub tree + viewAbovePath
        isInView: true,
        // invisible only means: outside view clip so that the node can not
        // see but still layout for animation preparation but not render.
        invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
        isAboveViewRoot: isAboveViewRoot
    }, true);
    // Transform to child coordinate.
    var childClipRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
    $2f13a432668907b0$var$each(node.viewChildren || [], function(child) {
        $2f13a432668907b0$var$prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
    });
}
function $2f13a432668907b0$var$getUpperLabelHeight(model) {
    return model.get($2f13a432668907b0$var$PATH_UPPER_LABEL_SHOW) ? model.get($2f13a432668907b0$var$PATH_UPPER_LABEL_HEIGHT) : 0;
}


function $330b7dc841112eff$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $10d079b37d9731a3$export$2e2bcd8739ae039));
    registers.registerChartView((0, $ca67abe413e4c090$export$2e2bcd8739ae039));
    registers.registerVisual((0, $e6cba72659c474bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $2f13a432668907b0$export$2e2bcd8739ae039));
    (0, $26d493e9cdfadb01$export$1ad90fc3f3a8bbf9)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $23b43ea6be789dc3$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (!legendModels || !legendModels.length) return;
    ecModel.eachSeriesByType("graph", function(graphSeries) {
        var categoriesData = graphSeries.getCategoriesData();
        var graph = graphSeries.getGraph();
        var data = graph.data;
        var categoryNames = categoriesData.mapArray(categoriesData.getName);
        data.filterSelf(function(idx) {
            var model = data.getItemModel(idx);
            var category = model.getShallow("category");
            if (category != null) {
                if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(category)) category = categoryNames[category];
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    if (!legendModels[i].isSelected(category)) return false;
                }
            }
            return true;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $2c7d64c9b3613d6b$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var categoriesData = seriesModel.getCategoriesData();
        var data = seriesModel.getData();
        var categoryNameIdxMap = {};
        categoriesData.each(function(idx) {
            var name = categoriesData.getName(idx);
            // Add prefix to avoid conflict with Object.prototype.
            categoryNameIdxMap["ec-" + name] = idx;
            var itemModel = categoriesData.getItemModel(idx);
            var style = itemModel.getModel("itemStyle").getItemStyle();
            if (!style.fill) // Get color from palette.
            style.fill = seriesModel.getColorFromPalette(name, paletteScope);
            categoriesData.setItemVisual(idx, "style", style);
            var symbolVisualList = [
                "symbol",
                "symbolSize",
                "symbolKeepAspect"
            ];
            for(var i = 0; i < symbolVisualList.length; i++){
                var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);
                if (symbolVisual != null) categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
            }
        });
        // Assign category color to visual
        if (categoriesData.count()) data.each(function(idx) {
            var model = data.getItemModel(idx);
            var categoryIdx = model.getShallow("category");
            if (categoryIdx != null) {
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(categoryIdx)) categoryIdx = categoryNameIdxMap["ec-" + categoryIdx];
                var categoryStyle = categoriesData.getItemVisual(categoryIdx, "style");
                var style = data.ensureUniqueItemVisual(idx, "style");
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(style, categoryStyle);
                var visualList = [
                    "symbol",
                    "symbolSize",
                    "symbolKeepAspect"
                ];
                for(var i = 0; i < visualList.length; i++)data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
            }
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $11ee0a103a25747c$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
function $11ee0a103a25747c$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var graph = seriesModel.getGraph();
        var edgeData = seriesModel.getEdgeData();
        var symbolType = $11ee0a103a25747c$var$normalize(seriesModel.get("edgeSymbol"));
        var symbolSize = $11ee0a103a25747c$var$normalize(seriesModel.get("edgeSymbolSize"));
        // const colorQuery = ['lineStyle', 'color'] as const;
        // const opacityQuery = ['lineStyle', 'opacity'] as const;
        edgeData.setVisual("fromSymbol", symbolType && symbolType[0]);
        edgeData.setVisual("toSymbol", symbolType && symbolType[1]);
        edgeData.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
        edgeData.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
        edgeData.setVisual("style", seriesModel.getModel("lineStyle").getLineStyle());
        edgeData.each(function(idx) {
            var itemModel = edgeData.getItemModel(idx);
            var edge = graph.getEdgeByIndex(idx);
            var symbolType = $11ee0a103a25747c$var$normalize(itemModel.getShallow("symbol", true));
            var symbolSize = $11ee0a103a25747c$var$normalize(itemModel.getShallow("symbolSize", true));
            // Edge visual must after node visual
            var style = itemModel.getModel("lineStyle").getLineStyle();
            var existsStyle = edgeData.ensureUniqueItemVisual(idx, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
            switch(existsStyle.stroke){
                case "source":
                    var nodeStyle = edge.node1.getVisual("style");
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
                case "target":
                    var nodeStyle = edge.node2.getVisual("style");
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
            }
            symbolType[0] && edge.setVisual("fromSymbol", symbolType[0]);
            symbolType[1] && edge.setVisual("toSymbol", symbolType[1]);
            symbolSize[0] && edge.setVisual("fromSymbolSize", symbolSize[0]);
            symbolSize[1] && edge.setVisual("toSymbolSize", symbolSize[1]);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $0425a00d02ade69a$var$KEY_DELIMITER = "-->";
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */ var $0425a00d02ade69a$var$getAutoCurvenessParams = function(seriesModel) {
    return seriesModel.get("autoCurveness") || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */ var $0425a00d02ade69a$var$createCurveness = function(seriesModel, appendLength) {
    var autoCurvenessParmas = $0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel);
    var length = 20;
    var curvenessList = [];
    // handler the function set
    if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(autoCurvenessParmas)) length = autoCurvenessParmas;
    else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(autoCurvenessParmas)) {
        seriesModel.__curvenessList = autoCurvenessParmas;
        return;
    }
    // append length
    if (appendLength > length) length = appendLength;
    // make sure the length is even
    var len = length % 2 ? length + 2 : length + 3;
    curvenessList = [];
    for(var i = 0; i < len; i++)curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
    seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */ var $0425a00d02ade69a$var$getKeyOfEdges = function(n1, n2, seriesModel) {
    var source = [
        n1.id,
        n1.dataIndex
    ].join(".");
    var target = [
        n2.id,
        n2.dataIndex
    ].join(".");
    return [
        seriesModel.uid,
        source,
        target
    ].join($0425a00d02ade69a$var$KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */ var $0425a00d02ade69a$var$getOppositeKey = function(key) {
    var keys = key.split($0425a00d02ade69a$var$KEY_DELIMITER);
    return [
        keys[0],
        keys[2],
        keys[1]
    ].join($0425a00d02ade69a$var$KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */ var $0425a00d02ade69a$var$getEdgeFromMap = function(edge, seriesModel) {
    var key = $0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */ var $0425a00d02ade69a$var$getTotalLengthBetweenNodes = function(edge, seriesModel) {
    var len = $0425a00d02ade69a$var$getEdgeMapLengthWithKey($0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
    var lenV = $0425a00d02ade69a$var$getEdgeMapLengthWithKey($0425a00d02ade69a$var$getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
    return len + lenV;
};
/**
 *
 * @param key
 */ var $0425a00d02ade69a$var$getEdgeMapLengthWithKey = function(key, seriesModel) {
    var edgeMap = seriesModel.__edgeMap;
    return edgeMap[key] ? edgeMap[key].length : 0;
};
function $0425a00d02ade69a$export$4f05389c1f2934b8(seriesModel) {
    if (!$0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel)) return;
    seriesModel.__curvenessList = [];
    seriesModel.__edgeMap = {};
    // calc the array of curveness List
    $0425a00d02ade69a$var$createCurveness(seriesModel);
}
function $0425a00d02ade69a$export$c47b549eed9a7311(n1, n2, seriesModel, index) {
    if (!$0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel)) return;
    var key = $0425a00d02ade69a$var$getKeyOfEdges(n1, n2, seriesModel);
    var edgeMap = seriesModel.__edgeMap;
    var oppositeEdges = edgeMap[$0425a00d02ade69a$var$getOppositeKey(key)];
    // set direction
    if (edgeMap[key] && !oppositeEdges) edgeMap[key].isForward = true;
    else if (oppositeEdges && edgeMap[key]) {
        oppositeEdges.isForward = true;
        edgeMap[key].isForward = false;
    }
    edgeMap[key] = edgeMap[key] || [];
    edgeMap[key].push(index);
}
function $0425a00d02ade69a$export$7e88123f7f1f62da(edge, seriesModel, index, needReverse) {
    var autoCurvenessParams = $0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel);
    var isArrayParam = $7a1bd9c2710fea0d$export$43bee75e5e14138e(autoCurvenessParams);
    if (!autoCurvenessParams) return null;
    var edgeArray = $0425a00d02ade69a$var$getEdgeFromMap(edge, seriesModel);
    if (!edgeArray) return null;
    var edgeIndex = -1;
    for(var i = 0; i < edgeArray.length; i++)if (edgeArray[i] === index) {
        edgeIndex = i;
        break;
    }
    // if totalLen is Longer createCurveness
    var totalLen = $0425a00d02ade69a$var$getTotalLengthBetweenNodes(edge, seriesModel);
    $0425a00d02ade69a$var$createCurveness(seriesModel, totalLen);
    edge.lineStyle = edge.lineStyle || {};
    // if is opposite edge, must set curvenss to opposite number
    var curKey = $0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    var curvenessList = seriesModel.__curvenessList;
    // if pass array no need parity
    var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
    if (!edgeArray.isForward) {
        // the opposite edge show outside
        var oppositeKey = $0425a00d02ade69a$var$getOppositeKey(curKey);
        var len = $0425a00d02ade69a$var$getEdgeMapLengthWithKey(oppositeKey, seriesModel);
        var resValue = curvenessList[edgeIndex + len + parityCorrection];
        // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
        if (needReverse) {
            // set as array may make the parity handle with the len of opposite
            if (isArrayParam) {
                if (autoCurvenessParams && autoCurvenessParams[0] === 0) return (len + parityCorrection) % 2 ? resValue : -resValue;
                else return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
            } else return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else return curvenessList[edgeIndex + len + parityCorrection];
    } else return curvenessList[parityCorrection + edgeIndex];
}


function $159cad03c3625d06$export$6d7efb25f4dcb4db(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== "view") return;
    var graph = seriesModel.getGraph();
    graph.eachNode(function(node) {
        var model = node.getModel();
        node.setLayout([
            +model.get("x"),
            +model.get("y")
        ]);
    });
    $159cad03c3625d06$export$a25b52345bee32aa(graph, seriesModel);
}
function $159cad03c3625d06$export$a25b52345bee32aa(graph, seriesModel) {
    graph.eachEdge(function(edge, index) {
        var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
            "lineStyle",
            "curveness"
        ]), -(0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, seriesModel, index, true), 0);
        var p1 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node2.getLayout());
        var points = [
            p1,
            p2
        ];
        if (+curveness) points.push([
            (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness,
            (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness
        ]);
        edge.setLayout(points);
    });
}


function $35717df2daa24f5d$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var layout = seriesModel.get("layout");
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.type !== "view") {
            var data_1 = seriesModel.getData();
            var dimensions_1 = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.dimensions, function(coordDim) {
                dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
            });
            for(var dataIndex = 0; dataIndex < data_1.count(); dataIndex++){
                var value = [];
                var hasValue = false;
                for(var i = 0; i < dimensions_1.length; i++){
                    var val = data_1.get(dimensions_1[i], dataIndex);
                    if (!isNaN(val)) hasValue = true;
                    value.push(val);
                }
                if (hasValue) data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
                else // Also {Array.<number>}, not undefined to avoid if...else... statement
                data_1.setItemLayout(dataIndex, [
                    NaN,
                    NaN
                ]);
            }
            (0, $159cad03c3625d06$export$a25b52345bee32aa)(data_1.graph, seriesModel);
        } else if (!layout || layout === "none") (0, $159cad03c3625d06$export$6d7efb25f4dcb4db)(seriesModel);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys.type !== "view") return 1;
    var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
    var groupZoom = coordSys.scaleX;
    // Scale node when zoom changes
    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
}
function $ad8b4f94f577d55a$export$8d4a06d3facd414b(node) {
    var symbolSize = node.getVisual("symbolSize");
    if (symbolSize instanceof Array) symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
    return +symbolSize;
}




var $484ee97adf82b508$var$PI = Math.PI;
var $484ee97adf82b508$var$_symbolRadiansHalf = [];
function $484ee97adf82b508$export$cbfed6ae5cab3dae(seriesModel, basedOn, draggingNode, pointer) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== "view") return;
    var rect = coordSys.getBoundingRect();
    var nodeData = seriesModel.getData();
    var graph = nodeData.graph;
    var cx = rect.width / 2 + rect.x;
    var cy = rect.height / 2 + rect.y;
    var r = Math.min(rect.width, rect.height) / 2;
    var count = nodeData.count();
    nodeData.setLayout({
        cx: cx,
        cy: cy
    });
    if (!count) return;
    if (draggingNode) {
        var _a = coordSys.pointToData(pointer), tempX = _a[0], tempY = _a[1];
        var v = [
            tempX - cx,
            tempY - cy
        ];
        $6de594cf8ac295ff$export$a3295358bff77e(v, v);
        $6de594cf8ac295ff$export$dcdf75081b88279d(v, v, r);
        draggingNode.setLayout([
            cx + v[0],
            cy + v[1]
        ], true);
        var circularRotateLabel = seriesModel.get([
            "circular",
            "rotateLabel"
        ]);
        $484ee97adf82b508$export$c768377a6a0a9ab8(draggingNode, circularRotateLabel, cx, cy);
    }
    $484ee97adf82b508$var$_layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);
    graph.eachEdge(function(edge, index) {
        var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
            "lineStyle",
            "curveness"
        ]), (0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, seriesModel, index), 0);
        var p1 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node2.getLayout());
        var cp1;
        var x12 = (p1[0] + p2[0]) / 2;
        var y12 = (p1[1] + p2[1]) / 2;
        if (+curveness) {
            curveness *= 3;
            cp1 = [
                cx * curveness + x12 * (1 - curveness),
                cy * curveness + y12 * (1 - curveness)
            ];
        }
        edge.setLayout([
            p1,
            p2,
            cp1
        ]);
    });
}
var $484ee97adf82b508$var$_layoutNodesBasedOn = {
    value: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var angle = 0;
        var sum = nodeData.getSum("value");
        var unitAngle = Math.PI * 2 / (sum || count);
        graph.eachNode(function(node) {
            var value = node.getValue("value");
            var radianHalf = unitAngle * (sum ? value : 1) / 2;
            angle += radianHalf;
            node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    },
    symbolSize: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var sumRadian = 0;
        $484ee97adf82b508$var$_symbolRadiansHalf.length = count;
        var nodeScale = (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel);
        graph.eachNode(function(node) {
            var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(node);
            // Normally this case will not happen, but we still add
            // some the defensive code (2px is an arbitrary value).
            isNaN(symbolSize) && (symbolSize = 2);
            symbolSize < 0 && (symbolSize = 0);
            symbolSize *= nodeScale;
            var symbolRadianHalf = Math.asin(symbolSize / 2 / r);
            // when `symbolSize / 2` is bigger than `r`.
            isNaN(symbolRadianHalf) && (symbolRadianHalf = $484ee97adf82b508$var$PI / 2);
            $484ee97adf82b508$var$_symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
            sumRadian += symbolRadianHalf * 2;
        });
        var halfRemainRadian = (2 * $484ee97adf82b508$var$PI - sumRadian) / count / 2;
        var angle = 0;
        graph.eachNode(function(node) {
            var radianHalf = halfRemainRadian + $484ee97adf82b508$var$_symbolRadiansHalf[node.dataIndex];
            angle += radianHalf;
            // init circular layout for
            // 1. layout undefined node
            // 2. not fixed node
            (!node.getLayout() || !node.getLayout().fixed) && node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    }
};
function $484ee97adf82b508$export$c768377a6a0a9ab8(node, circularRotateLabel, cx, cy) {
    var el = node.getGraphicEl();
    // need to check if el exists. '-' value may not create node element.
    if (!el) return;
    var nodeModel = node.getModel();
    var labelRotate = nodeModel.get([
        "label",
        "rotate"
    ]) || 0;
    var symbolPath = el.getSymbolPath();
    if (circularRotateLabel) {
        var pos = node.getLayout();
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
        if (rad < 0) rad = Math.PI * 2 + rad;
        var isLeft = pos[0] < cx;
        if (isLeft) rad = rad - Math.PI;
        var textPosition = isLeft ? "left" : "right";
        symbolPath.setTextConfig({
            rotation: -rad,
            position: textPosition,
            origin: "center"
        });
        var emphasisState = symbolPath.ensureState("emphasis");
        $7a1bd9c2710fea0d$export$8b58be045bf06082(emphasisState.textConfig || (emphasisState.textConfig = {}), {
            position: textPosition
        });
    } else symbolPath.setTextConfig({
        rotation: labelRotate *= Math.PI / 180
    });
}


function $3c017b875f1b19fb$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        if (seriesModel.get("layout") === "circular") (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(seriesModel, "symbolSize");
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $b2cd6170c8983d43$var$scaleAndAdd = $6de594cf8ac295ff$export$19cedf1da84ba854;
function $b2cd6170c8983d43$export$100e93b4853dcbde(inNodes, inEdges, opts) {
    var nodes = inNodes;
    var edges = inEdges;
    var rect = opts.rect;
    var width = rect.width;
    var height = rect.height;
    var center = [
        rect.x + width / 2,
        rect.y + height / 2
    ];
    // let scale = opts.scale || 1;
    var gravity = opts.gravity == null ? 0.1 : opts.gravity;
    // for (let i = 0; i < edges.length; i++) {
    //     let e = edges[i];
    //     let n1 = e.n1;
    //     let n2 = e.n2;
    //     n1.edges = n1.edges || [];
    //     n2.edges = n2.edges || [];
    //     n1.edges.push(e);
    //     n2.edges.push(e);
    // }
    // Init position
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        if (!n.p) n.p = $6de594cf8ac295ff$export$185802fd694ee1f5(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
        n.pp = $6de594cf8ac295ff$export$9cd59f9826255e47(n.p);
        n.edges = null;
    }
    // Formula in 'Graph Drawing by Force-directed Placement'
    // let k = scale * Math.sqrt(width * height / nodes.length);
    // let k2 = k * k;
    var initialFriction = opts.friction == null ? 0.6 : opts.friction;
    var friction = initialFriction;
    var beforeStepCallback;
    var afterStepCallback;
    return {
        warmUp: function() {
            friction = initialFriction * 0.8;
        },
        setFixed: function(idx) {
            nodes[idx].fixed = true;
        },
        setUnfixed: function(idx) {
            nodes[idx].fixed = false;
        },
        /**
     * Before step hook
     */ beforeStep: function(cb) {
            beforeStepCallback = cb;
        },
        /**
     * After step hook
     */ afterStep: function(cb) {
            afterStepCallback = cb;
        },
        /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */ step: function(cb) {
            beforeStepCallback && beforeStepCallback(nodes, edges);
            var v12 = [];
            var nLen = nodes.length;
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                if (e.ignoreForceLayout) continue;
                var n1 = e.n1;
                var n2 = e.n2;
                $6de594cf8ac295ff$export$f93b5905241a7cca(v12, n2.p, n1.p);
                var d = $6de594cf8ac295ff$export$fc1400facf92c78(v12) - e.d;
                var w = n2.w / (n1.w + n2.w);
                if (isNaN(w)) w = 0;
                $6de594cf8ac295ff$export$a3295358bff77e(v12, v12);
                !n1.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
                !n2.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
            }
            // Gravity
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v12, center, n.p);
                    // let d = vec2.len(v12);
                    // vec2.scale(v12, v12, 1 / d);
                    // let gravityFactor = gravity;
                    $b2cd6170c8983d43$var$scaleAndAdd(n.p, n.p, v12, gravity * friction);
                }
            }
            // Repulsive
            // PENDING
            for(var i = 0; i < nLen; i++){
                var n1 = nodes[i];
                for(var j = i + 1; j < nLen; j++){
                    var n2 = nodes[j];
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v12, n2.p, n1.p);
                    var d = $6de594cf8ac295ff$export$fc1400facf92c78(v12);
                    if (d === 0) {
                        // Random repulse
                        $6de594cf8ac295ff$export$adaa4cf7ef1b65be(v12, Math.random() - 0.5, Math.random() - 0.5);
                        d = 1;
                    }
                    var repFact = (n1.rep + n2.rep) / d / d;
                    !n1.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n1.pp, n1.pp, v12, repFact);
                    !n2.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
                }
            }
            var v = [];
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v, n.p, n.pp);
                    $b2cd6170c8983d43$var$scaleAndAdd(n.p, n.p, v, friction);
                    $6de594cf8ac295ff$export$784d13d8ee351f07(n.pp, n.p);
                }
            }
            friction = friction * 0.992;
            var finished = friction < 0.01;
            afterStepCallback && afterStepCallback(nodes, edges, finished);
            cb && cb(finished);
        }
    };
}








function $cd6209901c0041df$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(graphSeries) {
        var coordSys = graphSeries.coordinateSystem;
        if (coordSys && coordSys.type !== "view") return;
        if (graphSeries.get("layout") === "force") {
            var preservedPoints_1 = graphSeries.preservedPoints || {};
            var graph_1 = graphSeries.getGraph();
            var nodeData_1 = graph_1.data;
            var edgeData = graph_1.edgeData;
            var forceModel = graphSeries.getModel("force");
            var initLayout = forceModel.get("initLayout");
            if (graphSeries.preservedPoints) nodeData_1.each(function(idx) {
                var id = nodeData_1.getId(idx);
                nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [
                    NaN,
                    NaN
                ]);
            });
            else if (!initLayout || initLayout === "none") (0, $159cad03c3625d06$export$6d7efb25f4dcb4db)(graphSeries);
            else if (initLayout === "circular") (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(graphSeries, "value");
            var nodeDataExtent_1 = nodeData_1.getDataExtent("value");
            var edgeDataExtent_1 = edgeData.getDataExtent("value");
            // let edgeDataExtent = edgeData.getDataExtent('value');
            var repulsion = forceModel.get("repulsion");
            var edgeLength = forceModel.get("edgeLength");
            var repulsionArr_1 = $7a1bd9c2710fea0d$export$43bee75e5e14138e(repulsion) ? repulsion : [
                repulsion,
                repulsion
            ];
            var edgeLengthArr_1 = $7a1bd9c2710fea0d$export$43bee75e5e14138e(edgeLength) ? edgeLength : [
                edgeLength,
                edgeLength
            ];
            // Larger value has smaller length
            edgeLengthArr_1 = [
                edgeLengthArr_1[1],
                edgeLengthArr_1[0]
            ];
            var nodes_1 = nodeData_1.mapArray("value", function(value, idx) {
                var point = nodeData_1.getItemLayout(idx);
                var rep = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, nodeDataExtent_1, repulsionArr_1);
                if (isNaN(rep)) rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
                return {
                    w: rep,
                    rep: rep,
                    fixed: nodeData_1.getItemModel(idx).get("fixed"),
                    p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
                };
            });
            var edges = edgeData.mapArray("value", function(value, idx) {
                var edge = graph_1.getEdgeByIndex(idx);
                var d = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, edgeDataExtent_1, edgeLengthArr_1);
                if (isNaN(d)) d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
                var edgeModel = edge.getModel();
                var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
                    "lineStyle",
                    "curveness"
                ]), -(0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, graphSeries, idx, true), 0);
                return {
                    n1: nodes_1[edge.node1.dataIndex],
                    n2: nodes_1[edge.node2.dataIndex],
                    d: d,
                    curveness: curveness,
                    ignoreForceLayout: edgeModel.get("ignoreForceLayout")
                };
            });
            // let coordSys = graphSeries.coordinateSystem;
            var rect = coordSys.getBoundingRect();
            var forceInstance = (0, $b2cd6170c8983d43$export$100e93b4853dcbde)(nodes_1, edges, {
                rect: rect,
                gravity: forceModel.get("gravity"),
                friction: forceModel.get("friction")
            });
            forceInstance.beforeStep(function(nodes, edges) {
                for(var i = 0, l = nodes.length; i < l; i++)if (nodes[i].fixed) // Write back to layout instance
                $6de594cf8ac295ff$export$784d13d8ee351f07(nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
            });
            forceInstance.afterStep(function(nodes, edges, stopped) {
                for(var i = 0, l = nodes.length; i < l; i++){
                    if (!nodes[i].fixed) graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
                    preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
                }
                for(var i = 0, l = edges.length; i < l; i++){
                    var e = edges[i];
                    var edge = graph_1.getEdgeByIndex(i);
                    var p1 = e.n1.p;
                    var p2 = e.n2.p;
                    var points = edge.getLayout();
                    points = points ? points.slice() : [];
                    points[0] = points[0] || [];
                    points[1] = points[1] || [];
                    $6de594cf8ac295ff$export$784d13d8ee351f07(points[0], p1);
                    $6de594cf8ac295ff$export$784d13d8ee351f07(points[1], p2);
                    if (+e.curveness) points[2] = [
                        (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness,
                        (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness
                    ];
                    edge.setLayout(points);
                }
            });
            graphSeries.forceLayout = forceInstance;
            graphSeries.preservedPoints = preservedPoints_1;
            // Step to get the layout
            forceInstance.step();
        } else // Remove prev injected forceLayout instance
        graphSeries.forceLayout = null;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME Where to create the simple view coordinate system




function $8491beaca48712b9$var$getViewRect(seriesModel, api, aspect) {
    var option = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(seriesModel.getBoxLayoutParams(), {
        aspect: aspect
    });
    return (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(option, {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $8491beaca48712b9$export$2e2bcd8739ae039(ecModel, api) {
    var viewList = [];
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var coordSysType = seriesModel.get("coordinateSystem");
        if (!coordSysType || coordSysType === "view") {
            var data_1 = seriesModel.getData();
            var positions = data_1.mapArray(function(idx) {
                var itemModel = data_1.getItemModel(idx);
                return [
                    +itemModel.get("x"),
                    +itemModel.get("y")
                ];
            });
            var min = [];
            var max = [];
            $af3aab2435198f82$export$188c3cd07b4129dd(positions, min, max);
            // If width or height is 0
            if (max[0] - min[0] === 0) {
                max[0] += 1;
                min[0] -= 1;
            }
            if (max[1] - min[1] === 0) {
                max[1] += 1;
                min[1] -= 1;
            }
            var aspect = (max[0] - min[0]) / (max[1] - min[1]);
            // FIXME If get view rect after data processed?
            var viewRect = $8491beaca48712b9$var$getViewRect(seriesModel, api, aspect);
            // Position may be NaN, use view rect instead
            if (isNaN(aspect)) {
                min = [
                    viewRect.x,
                    viewRect.y
                ];
                max = [
                    viewRect.x + viewRect.width,
                    viewRect.y + viewRect.height
                ];
            }
            var bbWidth = max[0] - min[0];
            var bbHeight = max[1] - min[1];
            var viewWidth = viewRect.width;
            var viewHeight = viewRect.height;
            var viewCoordSys = seriesModel.coordinateSystem = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)();
            viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
            viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
            viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight);
            // Update roam info
            viewCoordSys.setCenter(seriesModel.get("center"), api);
            viewCoordSys.setZoom(seriesModel.get("zoom"));
            viewList.push(viewCoordSys);
        }
    });
    return viewList;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ab7bf64951ce094b$var$straightLineProto = $7a316ae5ceff7b27$export$2e2bcd8739ae039.prototype;
var $ab7bf64951ce094b$var$bezierCurveProto = $6c7800c49630e431$export$2e2bcd8739ae039.prototype;
var $ab7bf64951ce094b$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0;
        // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $ab7bf64951ce094b$var$CurveShape = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($ab7bf64951ce094b$var$StraightLineShape);
function $ab7bf64951ce094b$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $ab7bf64951ce094b$var$ECLinePath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-line";
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $ab7bf64951ce094b$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($ab7bf64951ce094b$var$isStraightLine(shape)) $ab7bf64951ce094b$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $ab7bf64951ce094b$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($ab7bf64951ce094b$var$isStraightLine(this.shape)) return $ab7bf64951ce094b$var$straightLineProto.pointAt.call(this, t);
        else return $ab7bf64951ce094b$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $ab7bf64951ce094b$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $ab7bf64951ce094b$var$bezierCurveProto.tangentAt.call(this, t);
        return $6de594cf8ac295ff$export$a3295358bff77e(p, p);
    };
    return ECLinePath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $ab7bf64951ce094b$export$2e2bcd8739ae039 = $ab7bf64951ce094b$var$ECLinePath;






var $9e0b5f801ab5090c$var$SYMBOL_CATEGORIES = [
    "fromSymbol",
    "toSymbol"
];
function $9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory) {
    return "_" + symbolCategory + "Type";
}
function $9e0b5f801ab5090c$var$makeSymbolTypeValue(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === "none") return symbolType;
    var symbolSize = lineData.getItemVisual(idx, name + "Size");
    var symbolRotate = lineData.getItemVisual(idx, name + "Rotate");
    var symbolOffset = lineData.getItemVisual(idx, name + "Offset");
    var symbolKeepAspect = lineData.getItemVisual(idx, name + "KeepAspect");
    var symbolSizeArr = $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    return symbolType + symbolSizeArr + symbolOffsetArr + (symbolRotate || "") + (symbolKeepAspect || "");
}
/**
 * @inner
 */ function $9e0b5f801ab5090c$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === "none") return;
    var symbolSize = lineData.getItemVisual(idx, name + "Size");
    var symbolRotate = lineData.getItemVisual(idx, name + "Rotate");
    var symbolOffset = lineData.getItemVisual(idx, name + "Offset");
    var symbolKeepAspect = lineData.getItemVisual(idx, name + "KeepAspect");
    var symbolSizeArr = $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $5370466dadc978d7$export$af050e04da3a02e8(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $9e0b5f801ab5090c$var$createLine(points) {
    var line = new (0, $ab7bf64951ce094b$export$2e2bcd8739ae039)({
        name: "line",
        subPixelOptimize: true
    });
    $9e0b5f801ab5090c$var$setLinePoints(line.shape, points);
    return line;
}
function $9e0b5f801ab5090c$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $9e0b5f801ab5090c$var$Line = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var line = $9e0b5f801ab5090c$var$createLine(linePoints);
        line.shape.percent = 0;
        $8b353638fbedfefa$export$a121566aadcfe021(line, {
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $9e0b5f801ab5090c$var$createSymbol(symbolCategory, lineData, idx);
            // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory)] = $9e0b5f801ab5090c$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName("line");
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $9e0b5f801ab5090c$var$setLinePoints(target.shape, linePoints);
        $8b353638fbedfefa$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = $9e0b5f801ab5090c$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
            var key = $9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory);
            // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $9e0b5f801ab5090c$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName("line");
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisLineStyle = emphasisModel.getModel("lineStyle").getLineStyle();
            blurLineStyle = itemModel.getModel([
                "blur",
                "lineStyle"
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                "select",
                "lineStyle"
            ]).getLineStyle();
            emphasisDisabled = emphasisModel.get("disabled");
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
            labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, "style");
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState("emphasis").style = emphasisLineStyle;
        line.ensureState("blur").style = blurLineStyle;
        line.ensureState("select").style = selectLineStyle;
        // Update symbol
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
                    var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? "stroke" : "fill"] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || "#000",
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(rawVal) : rawVal) + ""
        });
        var label = this.getTextContent();
        // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign;
            // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get("position") || "middle";
            var distance = labelNormalModel.get("distance");
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Line.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    Line.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName("line");
        $9e0b5f801ab5090c$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName("fromSymbol");
        var symbolTo = lineGroup.childOfName("toSymbol");
        var label = lineGroup.getTextContent();
        // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName("line");
        // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $6de594cf8ac295ff$export$f93b5905241a7cca([], toPos, fromPos);
        $6de594cf8ac295ff$export$a3295358bff77e(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr("rotation", (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr("rotation", specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== "start" && label.__position !== "end") {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case "insideStartTop":
                case "insideMiddleTop":
                case "insideEndTop":
                case "middle":
                    dy = -distanceY;
                    textVerticalAlign = "bottom";
                    break;
                case "insideStartBottom":
                case "insideMiddleBottom":
                case "insideEndBottom":
                    dy = distanceY;
                    textVerticalAlign = "top";
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = "middle";
            }
            switch(label.__position){
                case "end":
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? "left" : d[0] < -0.8 ? "right" : "center";
                    textVerticalAlign = d[1] > 0.8 ? "top" : d[1] < -0.8 ? "bottom" : "middle";
                    break;
                case "start":
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? "right" : d[0] < -0.8 ? "left" : "center";
                    textVerticalAlign = d[1] > 0.8 ? "bottom" : d[1] < -0.8 ? "top" : "middle";
                    break;
                case "insideStartTop":
                case "insideStart":
                case "insideStartBottom":
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? "right" : "left";
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case "insideMiddleTop":
                case "insideMiddle":
                case "insideMiddleBottom":
                case "middle":
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = "center";
                    label.originY = -dy;
                    break;
                case "insideEndTop":
                case "insideEnd":
                case "insideEndBottom":
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? "right" : "left";
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $9e0b5f801ab5090c$export$2e2bcd8739ae039 = $9e0b5f801ab5090c$var$Line;



var $a2fd63a0fc11274a$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._LineCtor = LineCtor || (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039);
    }
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        // Remove progressive els.
        this._progressiveEls = null;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData;
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $a2fd63a0fc11274a$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData;
        // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $a2fd63a0fc11274a$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        this._progressiveEls = [];
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$a2fd63a0fc11274a$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($a2fd63a0fc11274a$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$a2fd63a0fc11274a$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$a2fd63a0fc11274a$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $a2fd63a0fc11274a$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $a2fd63a0fc11274a$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    var emphasisModel = hostModel.getModel("emphasis");
    return {
        lineStyle: hostModel.getModel("lineStyle").getLineStyle(),
        emphasisLineStyle: emphasisModel.getModel([
            "lineStyle"
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            "blur",
            "lineStyle"
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            "select",
            "lineStyle"
        ]).getLineStyle(),
        emphasisDisabled: emphasisModel.get("disabled"),
        blurScope: emphasisModel.get("blurScope"),
        focus: emphasisModel.get("focus"),
        labelStatesModels: (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(hostModel)
    };
}
function $a2fd63a0fc11274a$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $a2fd63a0fc11274a$var$lineNeedsDraw(pts) {
    return pts && !$a2fd63a0fc11274a$var$isPointNaN(pts[0]) && !$a2fd63a0fc11274a$var$isPointNaN(pts[1]);
}
var $a2fd63a0fc11274a$export$2e2bcd8739ae039 = $a2fd63a0fc11274a$var$LineDraw;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $197126bedfb0a68b$var$v1 = [];
var $197126bedfb0a68b$var$v2 = [];
var $197126bedfb0a68b$var$v3 = [];
var $197126bedfb0a68b$var$quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
var $197126bedfb0a68b$var$v2DistSquare = $6de594cf8ac295ff$export$c68db45a034c13b0;
var $197126bedfb0a68b$var$mathAbs = Math.abs;
function $197126bedfb0a68b$var$intersectCurveCircle(curvePoints, center, radius) {
    var p0 = curvePoints[0];
    var p1 = curvePoints[1];
    var p2 = curvePoints[2];
    var d = Infinity;
    var t;
    var radiusSquare = radius * radius;
    var interval = 0.1;
    for(var _t = 0.1; _t <= 0.9; _t += 0.1){
        $197126bedfb0a68b$var$v1[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], _t);
        $197126bedfb0a68b$var$v1[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], _t);
        var diff = $197126bedfb0a68b$var$mathAbs($197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v1, center) - radiusSquare);
        if (diff < d) {
            d = diff;
            t = _t;
        }
    }
    // Assume the segment is monotone，Find root through Bisection method
    // At most 32 iteration
    for(var i = 0; i < 32; i++){
        // let prev = t - interval;
        var next = t + interval;
        // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
        // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
        $197126bedfb0a68b$var$v2[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], t);
        $197126bedfb0a68b$var$v2[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], t);
        $197126bedfb0a68b$var$v3[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], next);
        $197126bedfb0a68b$var$v3[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], next);
        var diff = $197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v2, center) - radiusSquare;
        if ($197126bedfb0a68b$var$mathAbs(diff) < 1e-2) break;
        // let prevDiff = v2DistSquare(v1, center) - radiusSquare;
        var nextDiff = $197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v3, center) - radiusSquare;
        interval /= 2;
        if (diff < 0) {
            if (nextDiff >= 0) t = t + interval;
            else t = t - interval;
        } else if (nextDiff >= 0) t = t - interval;
        else t = t + interval;
    }
    return t;
}
function $197126bedfb0a68b$export$2e2bcd8739ae039(graph, scale) {
    var tmp0 = [];
    var quadraticSubdivide = $747cfc5611b57cea$export$117c659e21a7a060;
    var pts = [
        [],
        [],
        []
    ];
    var pts2 = [
        [],
        []
    ];
    var v = [];
    scale /= 2;
    graph.eachEdge(function(edge, idx) {
        var linePoints = edge.getLayout();
        var fromSymbol = edge.getVisual("fromSymbol");
        var toSymbol = edge.getVisual("toSymbol");
        if (!linePoints.__original) {
            linePoints.__original = [
                $6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[0]),
                $6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[1])
            ];
            if (linePoints[2]) linePoints.__original.push($6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[2]));
        }
        var originalPoints = linePoints.__original;
        // Quadratic curve
        if (linePoints[2] != null) {
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[0], originalPoints[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[1], originalPoints[2]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[2], originalPoints[1]);
            if (fromSymbol && fromSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node1);
                var t = $197126bedfb0a68b$var$intersectCurveCircle(pts, originalPoints[0], symbolSize * scale);
                // Subdivide and get the second
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[0][0] = tmp0[3];
                pts[1][0] = tmp0[4];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[0][1] = tmp0[3];
                pts[1][1] = tmp0[4];
            }
            if (toSymbol && toSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node2);
                var t = $197126bedfb0a68b$var$intersectCurveCircle(pts, originalPoints[1], symbolSize * scale);
                // Subdivide and get the first
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[1][0] = tmp0[1];
                pts[2][0] = tmp0[2];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[1][1] = tmp0[1];
                pts[2][1] = tmp0[2];
            }
            // Copy back to layout
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[0], pts[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[1], pts[2]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[2], pts[1]);
        } else {
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts2[0], originalPoints[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts2[1], originalPoints[1]);
            $6de594cf8ac295ff$export$f93b5905241a7cca(v, pts2[1], pts2[0]);
            $6de594cf8ac295ff$export$a3295358bff77e(v, v);
            if (fromSymbol && fromSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node1);
                $6de594cf8ac295ff$export$19cedf1da84ba854(pts2[0], pts2[0], v, symbolSize * scale);
            }
            if (toSymbol && toSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node2);
                $6de594cf8ac295ff$export$19cedf1da84ba854(pts2[1], pts2[1], v, -symbolSize * scale);
            }
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[0], pts2[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[1], pts2[1]);
        }
    });
}







function $65490d05ca8b2521$var$isViewCoordSys(coordSys) {
    return coordSys.type === "view";
}
var $65490d05ca8b2521$var$GraphView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GraphView, _super);
    function GraphView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphView.type;
        return _this;
    }
    GraphView.prototype.init = function(ecModel, api) {
        var symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
        var lineDraw = new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)();
        var group = this.group;
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: group
        };
        group.add(symbolDraw.group);
        group.add(lineDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineDraw = lineDraw;
        this._firstRender = true;
    };
    GraphView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        this._model = seriesModel;
        var symbolDraw = this._symbolDraw;
        var lineDraw = this._lineDraw;
        var group = this.group;
        if ($65490d05ca8b2521$var$isViewCoordSys(coordSys)) {
            var groupNewProp = {
                x: coordSys.x,
                y: coordSys.y,
                scaleX: coordSys.scaleX,
                scaleY: coordSys.scaleY
            };
            if (this._firstRender) group.attr(groupNewProp);
            else $8b353638fbedfefa$export$c8dce3c08436e91e(group, groupNewProp, seriesModel);
        }
        // Fix edge contact point with node
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        var data = seriesModel.getData();
        symbolDraw.updateData(data);
        var edgeData = seriesModel.getEdgeData();
        // TODO: TYPE
        lineDraw.updateData(edgeData);
        this._updateNodeAndLinkScale();
        this._updateController(seriesModel, ecModel, api);
        clearTimeout(this._layoutTimeout);
        var forceLayout = seriesModel.forceLayout;
        var layoutAnimation = seriesModel.get([
            "force",
            "layoutAnimation"
        ]);
        if (forceLayout) this._startForceLayoutIteration(forceLayout, layoutAnimation);
        var layout = seriesModel.get("layout");
        data.graph.eachNode(function(node) {
            var idx = node.dataIndex;
            var el = node.getGraphicEl();
            var itemModel = node.getModel();
            if (!el) return;
            // Update draggable
            el.off("drag").off("dragend");
            var draggable = itemModel.get("draggable");
            if (draggable) el.on("drag", function(e) {
                switch(layout){
                    case "force":
                        forceLayout.warmUp();
                        !_this._layouting && _this._startForceLayoutIteration(forceLayout, layoutAnimation);
                        forceLayout.setFixed(idx);
                        // Write position back to layout
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        break;
                    case "circular":
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // mark node fixed
                        node.setLayout({
                            fixed: true
                        }, true);
                        // recalculate circular layout
                        (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(seriesModel, "symbolSize", node, [
                            e.offsetX,
                            e.offsetY
                        ]);
                        _this.updateLayout(seriesModel);
                        break;
                    case "none":
                    default:
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // update edge
                        (0, $159cad03c3625d06$export$a25b52345bee32aa)(seriesModel.getGraph(), seriesModel);
                        _this.updateLayout(seriesModel);
                        break;
                }
            }).on("dragend", function() {
                if (forceLayout) forceLayout.setUnfixed(idx);
            });
            el.setDraggable(draggable, !!itemModel.get("cursor"));
            var focus = itemModel.get([
                "emphasis",
                "focus"
            ]);
            if (focus === "adjacency") (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).focus = node.getAdjacentDataIndices();
        });
        data.graph.eachEdge(function(edge) {
            var el = edge.getGraphicEl();
            var focus = edge.getModel().get([
                "emphasis",
                "focus"
            ]);
            if (!el) return;
            if (focus === "adjacency") (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).focus = {
                edge: [
                    edge.dataIndex
                ],
                node: [
                    edge.node1.dataIndex,
                    edge.node2.dataIndex
                ]
            };
        });
        var circularRotateLabel = seriesModel.get("layout") === "circular" && seriesModel.get([
            "circular",
            "rotateLabel"
        ]);
        var cx = data.getLayout("cx");
        var cy = data.getLayout("cy");
        data.graph.eachNode(function(node) {
            (0, $484ee97adf82b508$export$c768377a6a0a9ab8)(node, circularRotateLabel, cx, cy);
        });
        this._firstRender = false;
    };
    GraphView.prototype.dispose = function() {
        this.remove();
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    GraphView.prototype._startForceLayoutIteration = function(forceLayout, layoutAnimation) {
        var self = this;
        (function step() {
            forceLayout.step(function(stopped) {
                self.updateLayout(self._model);
                (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
            });
        })();
    };
    GraphView.prototype._updateController = function(seriesModel, ecModel, api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, seriesModel);
        });
        if (!$65490d05ca8b2521$var$isViewCoordSys(seriesModel.coordinateSystem)) {
            controller.disable();
            return;
        }
        controller.enable(seriesModel.get("roam"));
        controllerHost.zoomLimit = seriesModel.get("scaleLimit");
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off("pan").off("zoom").on("pan", function(e) {
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "graphRoam",
                dx: e.dx,
                dy: e.dy
            });
        }).on("zoom", function(e) {
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "graphRoam",
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            _this._updateNodeAndLinkScale();
            (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
            _this._lineDraw.updateLayout();
            // Only update label layout on zoom
            api.updateLabelLayout();
        });
    };
    GraphView.prototype._updateNodeAndLinkScale = function() {
        var seriesModel = this._model;
        var data = seriesModel.getData();
        var nodeScale = (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el && el.setSymbolScale(nodeScale);
        });
    };
    GraphView.prototype.updateLayout = function(seriesModel) {
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        this._symbolDraw.updateLayout();
        this._lineDraw.updateLayout();
    };
    GraphView.prototype.remove = function() {
        clearTimeout(this._layoutTimeout);
        this._layouting = false;
        this._layoutTimeout = null;
        this._symbolDraw && this._symbolDraw.remove();
        this._lineDraw && this._lineDraw.remove();
    };
    GraphView.type = "graph";
    return GraphView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $65490d05ca8b2521$export$2e2bcd8739ae039 = $65490d05ca8b2521$var$GraphView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// id may be function name of Object, add a prefix to avoid this problem.
function $7e67f74238c90217$var$generateNodeKey(id) {
    return "_EC_" + id;
}
var $7e67f74238c90217$var$Graph = /** @class */ function() {
    function Graph(directed) {
        this.type = "graph";
        this.nodes = [];
        this.edges = [];
        this._nodesMap = {};
        /**
     * @type {Object.<string, module:echarts/data/Graph.Edge>}
     * @private
     */ this._edgesMap = {};
        this._directed = directed || false;
    }
    /**
   * If is directed graph
   */ Graph.prototype.isDirected = function() {
        return this._directed;
    };
    /**
   * Add a new node
   */ Graph.prototype.addNode = function(id, dataIndex) {
        id = id == null ? "" + dataIndex : "" + id;
        var nodesMap = this._nodesMap;
        if (nodesMap[$7e67f74238c90217$var$generateNodeKey(id)]) return;
        var node = new $7e67f74238c90217$export$32866653dfc29d0d(id, dataIndex);
        node.hostGraph = this;
        this.nodes.push(node);
        nodesMap[$7e67f74238c90217$var$generateNodeKey(id)] = node;
        return node;
    };
    /**
   * Get node by data index
   */ Graph.prototype.getNodeByIndex = function(dataIndex) {
        var rawIdx = this.data.getRawIndex(dataIndex);
        return this.nodes[rawIdx];
    };
    /**
   * Get node by id
   */ Graph.prototype.getNodeById = function(id) {
        return this._nodesMap[$7e67f74238c90217$var$generateNodeKey(id)];
    };
    /**
   * Add a new edge
   */ Graph.prototype.addEdge = function(n1, n2, dataIndex) {
        var nodesMap = this._nodesMap;
        var edgesMap = this._edgesMap;
        // PENDING
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(n1)) n1 = this.nodes[n1];
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(n2)) n2 = this.nodes[n2];
        if (!(n1 instanceof $7e67f74238c90217$export$32866653dfc29d0d)) n1 = nodesMap[$7e67f74238c90217$var$generateNodeKey(n1)];
        if (!(n2 instanceof $7e67f74238c90217$export$32866653dfc29d0d)) n2 = nodesMap[$7e67f74238c90217$var$generateNodeKey(n2)];
        if (!n1 || !n2) return;
        var key = n1.id + "-" + n2.id;
        var edge = new $7e67f74238c90217$export$87f150720cc8d165(n1, n2, dataIndex);
        edge.hostGraph = this;
        if (this._directed) {
            n1.outEdges.push(edge);
            n2.inEdges.push(edge);
        }
        n1.edges.push(edge);
        if (n1 !== n2) n2.edges.push(edge);
        this.edges.push(edge);
        edgesMap[key] = edge;
        return edge;
    };
    /**
   * Get edge by data index
   */ Graph.prototype.getEdgeByIndex = function(dataIndex) {
        var rawIdx = this.edgeData.getRawIndex(dataIndex);
        return this.edges[rawIdx];
    };
    /**
   * Get edge by two linked nodes
   */ Graph.prototype.getEdge = function(n1, n2) {
        if (n1 instanceof $7e67f74238c90217$export$32866653dfc29d0d) n1 = n1.id;
        if (n2 instanceof $7e67f74238c90217$export$32866653dfc29d0d) n2 = n2.id;
        var edgesMap = this._edgesMap;
        if (this._directed) return edgesMap[n1 + "-" + n2];
        else return edgesMap[n1 + "-" + n2] || edgesMap[n2 + "-" + n1];
    };
    /**
   * Iterate all nodes
   */ Graph.prototype.eachNode = function(cb, context) {
        var nodes = this.nodes;
        var len = nodes.length;
        for(var i = 0; i < len; i++)if (nodes[i].dataIndex >= 0) cb.call(context, nodes[i], i);
    };
    /**
   * Iterate all edges
   */ Graph.prototype.eachEdge = function(cb, context) {
        var edges = this.edges;
        var len = edges.length;
        for(var i = 0; i < len; i++)if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) cb.call(context, edges[i], i);
    };
    /**
   * Breadth first traverse
   * Return true to stop traversing
   */ Graph.prototype.breadthFirstTraverse = function(cb, startNode, direction, context) {
        if (!(startNode instanceof $7e67f74238c90217$export$32866653dfc29d0d)) startNode = this._nodesMap[$7e67f74238c90217$var$generateNodeKey(startNode)];
        if (!startNode) return;
        var edgeType = direction === "out" ? "outEdges" : direction === "in" ? "inEdges" : "edges";
        for(var i = 0; i < this.nodes.length; i++)this.nodes[i].__visited = false;
        if (cb.call(context, startNode, null)) return;
        var queue = [
            startNode
        ];
        while(queue.length){
            var currentNode = queue.shift();
            var edges = currentNode[edgeType];
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
                if (!otherNode.__visited) {
                    if (cb.call(context, otherNode, currentNode)) // Stop traversing
                    return;
                    queue.push(otherNode);
                    otherNode.__visited = true;
                }
            }
        }
    };
    // TODO
    // depthFirstTraverse(
    //     cb, startNode, direction, context
    // ) {
    // };
    // Filter update
    Graph.prototype.update = function() {
        var data = this.data;
        var edgeData = this.edgeData;
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
        edgeData.filterSelf(function(idx) {
            var edge = edges[edgeData.getRawIndex(idx)];
            return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
        });
        // Update edge
        for(var i = 0, len = edges.length; i < len; i++)edges[i].dataIndex = -1;
        for(var i = 0, len = edgeData.count(); i < len; i++)edges[edgeData.getRawIndex(i)].dataIndex = i;
    };
    /**
   * @return {module:echarts/data/Graph}
   */ Graph.prototype.clone = function() {
        var graph = new Graph(this._directed);
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0; i < nodes.length; i++)graph.addNode(nodes[i].id, nodes[i].dataIndex);
        for(var i = 0; i < edges.length; i++){
            var e = edges[i];
            graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
        }
        return graph;
    };
    return Graph;
}();
var $7e67f74238c90217$export$32866653dfc29d0d = /** @class */ function() {
    function GraphNode(id, dataIndex) {
        this.inEdges = [];
        this.outEdges = [];
        this.edges = [];
        this.dataIndex = -1;
        this.id = id == null ? "" : id;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    /**
   * @return {number}
   */ GraphNode.prototype.degree = function() {
        return this.edges.length;
    };
    /**
   * @return {number}
   */ GraphNode.prototype.inDegree = function() {
        return this.inEdges.length;
    };
    /**
  * @return {number}
  */ GraphNode.prototype.outDegree = function() {
        return this.outEdges.length;
    };
    GraphNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphNode.prototype.getAdjacentDataIndices = function() {
        var dataIndices = {
            edge: [],
            node: []
        };
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            dataIndices.edge.push(adjacentEdge.dataIndex);
            dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
        }
        return dataIndices;
    };
    GraphNode.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            connectedEdgesMap.set(adjacentEdge.dataIndex, true);
            var sourceNodesQueue = [
                adjacentEdge.node1
            ];
            var targetNodesQueue = [
                adjacentEdge.node2
            ];
            var nodeIteratorIndex = 0;
            while(nodeIteratorIndex < sourceNodesQueue.length){
                var sourceNode = sourceNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(sourceNode.dataIndex, true);
                for(var j = 0; j < sourceNode.inEdges.length; j++){
                    connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
                    sourceNodesQueue.push(sourceNode.inEdges[j].node1);
                }
            }
            nodeIteratorIndex = 0;
            while(nodeIteratorIndex < targetNodesQueue.length){
                var targetNode = targetNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(targetNode.dataIndex, true);
                for(var j = 0; j < targetNode.outEdges.length; j++){
                    connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
                    targetNodesQueue.push(targetNode.outEdges[j].node2);
                }
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphNode;
}();
var $7e67f74238c90217$export$87f150720cc8d165 = /** @class */ function() {
    function GraphEdge(n1, n2, dataIndex) {
        this.dataIndex = -1;
        this.node1 = n1;
        this.node2 = n2;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    GraphEdge.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.edgeData.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphEdge.prototype.getAdjacentDataIndices = function() {
        return {
            edge: [
                this.dataIndex
            ],
            node: [
                this.node1.dataIndex,
                this.node2.dataIndex
            ]
        };
    };
    GraphEdge.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        connectedEdgesMap.set(this.dataIndex, true);
        var sourceNodes = [
            this.node1
        ];
        var targetNodes = [
            this.node2
        ];
        var nodeIteratorIndex = 0;
        while(nodeIteratorIndex < sourceNodes.length){
            var sourceNode = sourceNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(sourceNode.dataIndex, true);
            for(var j = 0; j < sourceNode.inEdges.length; j++){
                connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
                sourceNodes.push(sourceNode.inEdges[j].node1);
            }
        }
        nodeIteratorIndex = 0;
        while(nodeIteratorIndex < targetNodes.length){
            var targetNode = targetNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(targetNode.dataIndex, true);
            for(var j = 0; j < targetNode.outEdges.length; j++){
                connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
                targetNodes.push(targetNode.outEdges[j].node2);
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphEdge;
}();
function $7e67f74238c90217$var$createGraphDataProxyMixin(hostName, dataName) {
    return {
        /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */ getValue: function(dimension) {
            var data = this[hostName][dataName];
            return data.getStore().get(data.getDimensionIndex(dimension || "value"), this.dataIndex);
        },
        // TODO: TYPE stricter type.
        setVisual: function(key, value) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
        },
        getVisual: function(key) {
            return this[hostName][dataName].getItemVisual(this.dataIndex, key);
        },
        setLayout: function(layout, merge) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
        },
        getLayout: function() {
            return this[hostName][dataName].getItemLayout(this.dataIndex);
        },
        getGraphicEl: function() {
            return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
        },
        getRawIndex: function() {
            return this[hostName][dataName].getRawIndex(this.dataIndex);
        }
    };
}
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7e67f74238c90217$export$32866653dfc29d0d, $7e67f74238c90217$var$createGraphDataProxyMixin("hostGraph", "data"));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7e67f74238c90217$export$87f150720cc8d165, $7e67f74238c90217$var$createGraphDataProxyMixin("hostGraph", "edgeData"));
var $7e67f74238c90217$export$2e2bcd8739ae039 = $7e67f74238c90217$var$Graph;







function $09eb5d193a1ecbce$export$2e2bcd8739ae039(nodes, edges, seriesModel, directed, beforeLink) {
    // ??? TODO
    // support dataset?
    var graph = new (0, $7e67f74238c90217$export$2e2bcd8739ae039)(directed);
    for(var i = 0; i < nodes.length; i++)graph.addNode($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(// Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
    var linkNameList = [];
    var validEdges = [];
    var linkCount = 0;
    for(var i = 0; i < edges.length; i++){
        var link = edges[i];
        var source = link.source;
        var target = link.target;
        // addEdge may fail when source or target not exists
        if (graph.addEdge(source, target, linkCount)) {
            validEdges.push(link);
            linkNameList.push($7a1bd9c2710fea0d$export$8a4d17b6e8486e66((0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(link.id, null), source + " > " + target));
            linkCount++;
        }
    }
    var coordSys = seriesModel.get("coordinateSystem");
    var nodeData;
    if (coordSys === "cartesian2d" || coordSys === "polar") nodeData = (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(nodes, seriesModel);
    else {
        var coordSysCtor = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(coordSys);
        var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : [];
        // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
        // `value` dimension, but graph need `value` dimension. It's better to
        // uniform this behavior.
        if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(coordDimensions, "value") < 0) coordDimensions.concat([
            "value"
        ]);
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(nodes, {
            coordDimensions: coordDimensions,
            encodeDefine: seriesModel.getEncode()
        }).dimensions;
        nodeData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, seriesModel);
        nodeData.initData(nodes);
    }
    var edgeData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
        "value"
    ], seriesModel);
    edgeData.initData(validEdges, linkNameList);
    beforeLink && beforeLink(nodeData, edgeData);
    (0, $4a8451eb7786c849$export$2e2bcd8739ae039)({
        mainData: nodeData,
        struct: graph,
        structAttr: "graph",
        datas: {
            node: nodeData,
            edge: edgeData
        },
        datasAttr: {
            node: "data",
            edge: "edgeData"
        }
    });
    // Update dataIndex of nodes and edges because invalid edge may be removed
    graph.update();
    return graph;
}







var $6c5e3b756b0e9560$var$GraphSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GraphSeriesModel, _super);
    function GraphSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    GraphSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        var self = this;
        function getCategoriesData() {
            return self._categoriesData;
        }
        // Provide data for legend select
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)(getCategoriesData, getCategoriesData);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeDefaultAndTheme = function(option) {
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        (0, $76d619f648247e6d$export$abdcc6a26372f94b)(option, "edgeLabel", [
            "show"
        ]);
    };
    GraphSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var self = this;
        if (nodes && edges) {
            // auto curveness
            (0, $0425a00d02ade69a$export$4f05389c1f2934b8)(this);
            var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, edges, this, true, beforeLink);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(graph.edges, function(edge) {
                (0, $0425a00d02ade69a$export$c47b549eed9a7311)(edge.node1, edge.node2, this, edge.dataIndex);
            }, this);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // Overwrite nodeData.getItemModel to
            nodeData.wrapMethod("getItemModel", function(model) {
                var categoriesModels = self._categoriesModels;
                var categoryIdx = model.getShallow("category");
                var categoryModel = categoriesModels[categoryIdx];
                if (categoryModel) {
                    categoryModel.parentModel = model.parentModel;
                    model.parentModel = categoryModel;
                }
                return model;
            });
            // TODO Inherit resolveParentPath by default in Model#getModel?
            var oldGetModel = (0, $6818646a97528290$export$2e2bcd8739ae039).prototype.getModel;
            function newGetModel(path, parentModel) {
                var model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod("getItemModel", function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === "label" || pathArr[1] === "label")) {
                    var newPathArr = pathArr.slice();
                    if (pathArr[0] === "label") newPathArr[0] = "edgeLabel";
                    else if (pathArr[1] === "label") newPathArr[1] = "edgeLabel";
                    return newPathArr;
                }
                return pathArr;
            }
        }
    };
    GraphSeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    GraphSeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    GraphSeriesModel.prototype.getCategoriesData = function() {
        return this._categoriesData;
    };
    GraphSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        if (dataType === "edge") {
            var nodeData = this.getData();
            var params = this.getDataParams(dataIndex, dataType);
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var nameArr = [];
            sourceName != null && nameArr.push(sourceName);
            targetName != null && nameArr.push(targetName);
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: nameArr.join(" > "),
                value: params.value,
                noValue: params.value == null
            });
        }
        // dataType === 'node' or empty
        var nodeMarkup = (0, $b0d4c63a14430ca1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
        return nodeMarkup;
    };
    GraphSeriesModel.prototype._updateCategoriesData = function() {
        var categories = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this.option.categories || [], function(category) {
            // Data must has value
            return category.value != null ? category : $7a1bd9c2710fea0d$export$8b58be045bf06082({
                value: 0
            }, category);
        });
        var categoriesData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            "value"
        ], this);
        categoriesData.initData(categories);
        this._categoriesData = categoriesData;
        this._categoriesModels = categoriesData.mapArray(function(idx) {
            return categoriesData.getItemModel(idx);
        });
    };
    GraphSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GraphSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    GraphSeriesModel.prototype.isAnimationEnabled = function() {
        return _super.prototype.isAnimationEnabled.call(this) && !(this.get("layout") === "force" && this.get([
            "force",
            "layoutAnimation"
        ]));
    };
    GraphSeriesModel.type = "series.graph";
    GraphSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ];
    GraphSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        // Default option for all coordinate systems
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // polarIndex: 0,
        // geoIndex: 0,
        legendHoverLink: true,
        layout: null,
        // Configuration of circular layout
        circular: {
            rotateLabel: false
        },
        // Configuration of force directed layout
        force: {
            initLayout: null,
            // Node repulsion. Can be an array to represent range.
            repulsion: [
                0,
                50
            ],
            gravity: 0.1,
            // Initial friction
            friction: 0.6,
            // Edge length. Can be an array to represent range.
            edgeLength: 30,
            layoutAnimation: true
        },
        left: "center",
        top: "center",
        // right: null,
        // bottom: null,
        // width: '80%',
        // height: '80%',
        symbol: "circle",
        symbolSize: 10,
        edgeSymbol: [
            "none",
            "none"
        ],
        edgeSymbolSize: 10,
        edgeLabel: {
            position: "middle",
            distance: 5
        },
        draggable: false,
        roam: false,
        // Default on center of graph
        center: null,
        zoom: 1,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.6,
        // cursor: null,
        // categories: [],
        // data: []
        // Or
        // nodes: []
        //
        // links: []
        // Or
        // edges: []
        label: {
            show: false,
            formatter: "{b}"
        },
        itemStyle: {},
        lineStyle: {
            color: "#aaa",
            width: 1,
            opacity: 0.5
        },
        emphasis: {
            scale: true,
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        }
    };
    return GraphSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $6c5e3b756b0e9560$export$2e2bcd8739ae039 = $6c5e3b756b0e9560$var$GraphSeriesModel;




var $b48bd73bf5d69641$var$actionInfo = {
    type: "graphRoam",
    event: "graphRoam",
    update: "none"
};
function $b48bd73bf5d69641$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $65490d05ca8b2521$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $6c5e3b756b0e9560$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $23b43ea6be789dc3$export$2e2bcd8739ae039));
    registers.registerVisual((0, $2c7d64c9b3613d6b$export$2e2bcd8739ae039));
    registers.registerVisual((0, $11ee0a103a25747c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $35717df2daa24f5d$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $3c017b875f1b19fb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $cd6209901c0041df$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("graphView", {
        dimensions: (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039).dimensions,
        create: (0, $8491beaca48712b9$export$2e2bcd8739ae039)
    });
    // Register legacy focus actions
    registers.registerAction({
        type: "focusNodeAdjacency",
        event: "focusNodeAdjacency",
        update: "series:focusNodeAdjacency"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "unfocusNodeAdjacency",
        event: "unfocusNodeAdjacency",
        update: "series:unfocusNodeAdjacency"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    // Register roam action.
    registers.registerAction($b48bd73bf5d69641$var$actionInfo, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: "series",
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(coordSys, payload, undefined, api);
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ea4af8acc4ea1022$var$PointerShape = /** @class */ function() {
    function PointerShape() {
        this.angle = 0;
        this.width = 10;
        this.r = 10;
        this.x = 0;
        this.y = 0;
    }
    return PointerShape;
}();
var $ea4af8acc4ea1022$var$PointerPath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PointerPath, _super);
    function PointerPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "pointer";
        return _this;
    }
    PointerPath.prototype.getDefaultShape = function() {
        return new $ea4af8acc4ea1022$var$PointerShape();
    };
    PointerPath.prototype.buildPath = function(ctx, shape) {
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        var r = shape.r;
        var width = shape.width;
        var angle = shape.angle;
        var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
        var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
        angle = shape.angle - Math.PI / 2;
        ctx.moveTo(x, y);
        ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
        ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
        ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
        ctx.lineTo(x, y);
    };
    return PointerPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $ea4af8acc4ea1022$export$2e2bcd8739ae039 = $ea4af8acc4ea1022$var$PointerPath;













function $f677de6b1db15bcf$var$parsePosition(seriesModel, api) {
    var center = seriesModel.get("center");
    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], api.getWidth());
    var cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], api.getHeight());
    var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("radius"), size / 2);
    return {
        cx: cx,
        cy: cy,
        r: r
    };
}
function $f677de6b1db15bcf$var$formatLabel(value, labelFormatter) {
    var label = value == null ? "" : value + "";
    if (labelFormatter) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelFormatter)) label = labelFormatter.replace("{value}", label);
        else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelFormatter)) label = labelFormatter(value);
    }
    return label;
}
var $f677de6b1db15bcf$var$GaugeView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GaugeView, _super);
    function GaugeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeView.type;
        return _this;
    }
    GaugeView.prototype.render = function(seriesModel, ecModel, api) {
        this.group.removeAll();
        var colorList = seriesModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ]);
        var posInfo = $f677de6b1db15bcf$var$parsePosition(seriesModel, api);
        this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
        this._data = seriesModel.getData();
    };
    GaugeView.prototype.dispose = function() {};
    GaugeView.prototype._renderMain = function(seriesModel, ecModel, api, colorList, posInfo) {
        var group = this.group;
        var clockwise = seriesModel.get("clockwise");
        var startAngle = -seriesModel.get("startAngle") / 180 * Math.PI;
        var endAngle = -seriesModel.get("endAngle") / 180 * Math.PI;
        var axisLineModel = seriesModel.getModel("axisLine");
        var roundCap = axisLineModel.get("roundCap");
        var MainPath = roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : $a3e1dec0a3875b49$export$2e2bcd8739ae039;
        var showAxis = axisLineModel.get("show");
        var lineStyleModel = axisLineModel.getModel("lineStyle");
        var axisLineWidth = lineStyleModel.get("width");
        var angles = [
            startAngle,
            endAngle
        ];
        (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0];
        endAngle = angles[1];
        var angleRangeSpan = endAngle - startAngle;
        var prevEndAngle = startAngle;
        var sectors = [];
        for(var i = 0; showAxis && i < colorList.length; i++){
            // Clamp
            var percent = Math.min(Math.max(colorList[i][0], 0), 1);
            endAngle = startAngle + angleRangeSpan * percent;
            var sector = new MainPath({
                shape: {
                    startAngle: prevEndAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: posInfo.r - axisLineWidth,
                    r: posInfo.r
                },
                silent: true
            });
            sector.setStyle({
                fill: colorList[i][1]
            });
            sector.setStyle(lineStyleModel.getLineStyle(// Because we use sector to simulate arc
            // so the properties for stroking are useless
            [
                "color",
                "width"
            ]));
            sectors.push(sector);
            prevEndAngle = endAngle;
        }
        sectors.reverse();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sectors, function(sector) {
            return group.add(sector);
        });
        var getColor = function(percent) {
            // Less than 0
            if (percent <= 0) return colorList[0][1];
            var i;
            for(i = 0; i < colorList.length; i++){
                if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) return colorList[i][1];
            }
            // More than 1
            return colorList[i - 1][1];
        };
        this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
        this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);
        this._renderAnchor(seriesModel, posInfo);
        this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
    };
    GaugeView.prototype._renderTicks = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var cx = posInfo.cx;
        var cy = posInfo.cy;
        var r = posInfo.r;
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var splitLineModel = seriesModel.getModel("splitLine");
        var tickModel = seriesModel.getModel("axisTick");
        var labelModel = seriesModel.getModel("axisLabel");
        var splitNumber = seriesModel.get("splitNumber");
        var subSplitNumber = tickModel.get("splitNumber");
        var splitLineLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(splitLineModel.get("length"), r);
        var tickLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(tickModel.get("length"), r);
        var angle = startAngle;
        var step = (endAngle - startAngle) / splitNumber;
        var subStep = step / subSplitNumber;
        var splitLineStyle = splitLineModel.getModel("lineStyle").getLineStyle();
        var tickLineStyle = tickModel.getModel("lineStyle").getLineStyle();
        var splitLineDistance = splitLineModel.get("distance");
        var unitX;
        var unitY;
        for(var i = 0; i <= splitNumber; i++){
            unitX = Math.cos(angle);
            unitY = Math.sin(angle);
            // Split line
            if (splitLineModel.get("show")) {
                var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
                var splitLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                    shape: {
                        x1: unitX * (r - distance) + cx,
                        y1: unitY * (r - distance) + cy,
                        x2: unitX * (r - splitLineLen - distance) + cx,
                        y2: unitY * (r - splitLineLen - distance) + cy
                    },
                    style: splitLineStyle,
                    silent: true
                });
                if (splitLineStyle.stroke === "auto") splitLine.setStyle({
                    stroke: getColor(i / splitNumber)
                });
                group.add(splitLine);
            }
            // Label
            if (labelModel.get("show")) {
                var distance = labelModel.get("distance") + splitLineDistance;
                var label = $f677de6b1db15bcf$var$formatLabel((0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get("formatter"));
                var autoColor = getColor(i / splitNumber);
                var textStyleX = unitX * (r - splitLineLen - distance) + cx;
                var textStyleY = unitY * (r - splitLineLen - distance) + cy;
                var rotateType = labelModel.get("rotate");
                var rotate = 0;
                if (rotateType === "radial") {
                    rotate = -angle + 2 * Math.PI;
                    if (rotate > Math.PI / 2) rotate += Math.PI;
                } else if (rotateType === "tangential") rotate = -angle - Math.PI / 2;
                else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotateType)) rotate = rotateType * Math.PI / 180;
                if (rotate === 0) group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: unitY < -0.8 ? "top" : unitY > 0.8 ? "bottom" : "middle",
                        align: unitX < -0.4 ? "left" : unitX > 0.4 ? "right" : "center"
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true
                }));
                else group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: "middle",
                        align: "center"
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true,
                    originX: textStyleX,
                    originY: textStyleY,
                    rotation: rotate
                }));
            }
            // Axis tick
            if (tickModel.get("show") && i !== splitNumber) {
                var distance = tickModel.get("distance");
                distance = distance ? distance + axisLineWidth : axisLineWidth;
                for(var j = 0; j <= subSplitNumber; j++){
                    unitX = Math.cos(angle);
                    unitY = Math.sin(angle);
                    var tickLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                        shape: {
                            x1: unitX * (r - distance) + cx,
                            y1: unitY * (r - distance) + cy,
                            x2: unitX * (r - tickLen - distance) + cx,
                            y2: unitY * (r - tickLen - distance) + cy
                        },
                        silent: true,
                        style: tickLineStyle
                    });
                    if (tickLineStyle.stroke === "auto") tickLine.setStyle({
                        stroke: getColor((i + j / subSplitNumber) / splitNumber)
                    });
                    group.add(tickLine);
                    angle += subStep;
                }
                angle -= subStep;
            } else angle += step;
        }
    };
    GaugeView.prototype._renderPointer = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var oldData = this._data;
        var oldProgressData = this._progressEls;
        var progressList = [];
        var showPointer = seriesModel.get([
            "pointer",
            "show"
        ]);
        var progressModel = seriesModel.getModel("progress");
        var showProgress = progressModel.get("show");
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var valueExtent = [
            minVal,
            maxVal
        ];
        var angleExtent = [
            startAngle,
            endAngle
        ];
        function createPointer(idx, angle) {
            var itemModel = data.getItemModel(idx);
            var pointerModel = itemModel.getModel("pointer");
            var pointerWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerModel.get("width"), posInfo.r);
            var pointerLength = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerModel.get("length"), posInfo.r);
            var pointerStr = seriesModel.get([
                "pointer",
                "icon"
            ]);
            var pointerOffset = pointerModel.get("offsetCenter");
            var pointerOffsetX = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerOffset[0], posInfo.r);
            var pointerOffsetY = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerOffset[1], posInfo.r);
            var pointerKeepAspect = pointerModel.get("keepAspect");
            var pointer;
            // not exist icon type will be set 'rect'
            if (pointerStr) pointer = (0, $5370466dadc978d7$export$af050e04da3a02e8)(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
            else pointer = new (0, $ea4af8acc4ea1022$export$2e2bcd8739ae039)({
                shape: {
                    angle: -Math.PI / 2,
                    width: pointerWidth,
                    r: pointerLength,
                    x: pointerOffsetX,
                    y: pointerOffsetY
                }
            });
            pointer.rotation = -(angle + Math.PI / 2);
            pointer.x = posInfo.cx;
            pointer.y = posInfo.cy;
            return pointer;
        }
        function createProgress(idx, endAngle) {
            var roundCap = progressModel.get("roundCap");
            var ProgressPath = roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : $a3e1dec0a3875b49$export$2e2bcd8739ae039;
            var isOverlap = progressModel.get("overlap");
            var progressWidth = isOverlap ? progressModel.get("width") : axisLineWidth / data.count();
            var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
            var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
            var progress = new ProgressPath({
                shape: {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: r0,
                    r: r
                }
            });
            isOverlap && (progress.z2 = maxVal - data.get(valueDim, idx) % maxVal);
            return progress;
        }
        if (showProgress || showPointer) {
            data.diff(oldData).add(function(idx) {
                var val = data.get(valueDim, idx);
                if (showPointer) {
                    var pointer = createPointer(idx, startAngle);
                    // TODO hide pointer on NaN value?
                    $8b353638fbedfefa$export$a121566aadcfe021(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(idx, pointer);
                }
                if (showProgress) {
                    var progress = createProgress(idx, startAngle);
                    var isClip = progressModel.get("clip");
                    $8b353638fbedfefa$export$a121566aadcfe021(progress, {
                        shape: {
                            endAngle: (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, idx, progress);
                    progressList[idx] = progress;
                }
            }).update(function(newIdx, oldIdx) {
                var val = data.get(valueDim, newIdx);
                if (showPointer) {
                    var previousPointer = oldData.getItemGraphicEl(oldIdx);
                    var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
                    var pointer = createPointer(newIdx, previousRotate);
                    pointer.rotation = previousRotate;
                    $8b353638fbedfefa$export$c8dce3c08436e91e(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(newIdx, pointer);
                }
                if (showProgress) {
                    var previousProgress = oldProgressData[oldIdx];
                    var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
                    var progress = createProgress(newIdx, previousEndAngle);
                    var isClip = progressModel.get("clip");
                    $8b353638fbedfefa$export$c8dce3c08436e91e(progress, {
                        shape: {
                            endAngle: (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, newIdx, progress);
                    progressList[newIdx] = progress;
                }
            }).execute();
            data.each(function(idx) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel = itemModel.getModel("emphasis");
                var focus = emphasisModel.get("focus");
                var blurScope = emphasisModel.get("blurScope");
                var emphasisDisabled = emphasisModel.get("disabled");
                if (showPointer) {
                    var pointer = data.getItemGraphicEl(idx);
                    var symbolStyle = data.getItemVisual(idx, "style");
                    var visualColor = symbolStyle.fill;
                    if (pointer instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
                        var pathStyle = pointer.style;
                        pointer.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            image: pathStyle.image,
                            x: pathStyle.x,
                            y: pathStyle.y,
                            width: pathStyle.width,
                            height: pathStyle.height
                        }, symbolStyle));
                    } else {
                        pointer.useStyle(symbolStyle);
                        pointer.type !== "pointer" && pointer.setColor(visualColor);
                    }
                    pointer.setStyle(itemModel.getModel([
                        "pointer",
                        "itemStyle"
                    ]).getItemStyle());
                    if (pointer.style.fill === "auto") pointer.setStyle("fill", getColor((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data.get(valueDim, idx), valueExtent, [
                        0,
                        1
                    ], true)));
                    pointer.z2EmphasisLift = 0;
                    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(pointer, itemModel);
                    (0, $2bf82c0980125b62$export$e51187539ff11209)(pointer, focus, blurScope, emphasisDisabled);
                }
                if (showProgress) {
                    var progress = progressList[idx];
                    progress.useStyle(data.getItemVisual(idx, "style"));
                    progress.setStyle(itemModel.getModel([
                        "progress",
                        "itemStyle"
                    ]).getItemStyle());
                    progress.z2EmphasisLift = 0;
                    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(progress, itemModel);
                    (0, $2bf82c0980125b62$export$e51187539ff11209)(progress, focus, blurScope, emphasisDisabled);
                }
            });
            this._progressEls = progressList;
        }
    };
    GaugeView.prototype._renderAnchor = function(seriesModel, posInfo) {
        var anchorModel = seriesModel.getModel("anchor");
        var showAnchor = anchorModel.get("show");
        if (showAnchor) {
            var anchorSize = anchorModel.get("size");
            var anchorType = anchorModel.get("icon");
            var offsetCenter = anchorModel.get("offsetCenter");
            var anchorKeepAspect = anchorModel.get("keepAspect");
            var anchor = (0, $5370466dadc978d7$export$af050e04da3a02e8)(anchorType, posInfo.cx - anchorSize / 2 + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
            anchor.z2 = anchorModel.get("showAbove") ? 1 : 0;
            anchor.setStyle(anchorModel.getModel("itemStyle").getItemStyle());
            this.group.add(anchor);
        }
    };
    GaugeView.prototype._renderTitleAndDetail = function(seriesModel, ecModel, api, getColor, posInfo) {
        var _this = this;
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var contentGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var newTitleEls = [];
        var newDetailEls = [];
        var hasAnimation = seriesModel.isAnimationEnabled();
        var showPointerAbove = seriesModel.get([
            "pointer",
            "showAbove"
        ]);
        data.diff(this._data).add(function(idx) {
            newTitleEls[idx] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true
            });
            newDetailEls[idx] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true
            });
        }).update(function(idx, oldIdx) {
            newTitleEls[idx] = _this._titleEls[oldIdx];
            newDetailEls[idx] = _this._detailEls[oldIdx];
        }).execute();
        data.each(function(idx) {
            var itemModel = data.getItemModel(idx);
            var value = data.get(valueDim, idx);
            var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            var autoColor = getColor((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, [
                minVal,
                maxVal
            ], [
                0,
                1
            ], true));
            var itemTitleModel = itemModel.getModel("title");
            if (itemTitleModel.get("show")) {
                var titleOffsetCenter = itemTitleModel.get("offsetCenter");
                var titleX = posInfo.cx + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(titleOffsetCenter[0], posInfo.r);
                var titleY = posInfo.cy + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(titleOffsetCenter[1], posInfo.r);
                var labelEl = newTitleEls[idx];
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemTitleModel, {
                        x: titleX,
                        y: titleY,
                        text: data.getName(idx),
                        align: "center",
                        verticalAlign: "middle"
                    }, {
                        inheritColor: autoColor
                    })
                });
                itemGroup.add(labelEl);
            }
            var itemDetailModel = itemModel.getModel("detail");
            if (itemDetailModel.get("show")) {
                var detailOffsetCenter = itemDetailModel.get("offsetCenter");
                var detailX = posInfo.cx + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(detailOffsetCenter[0], posInfo.r);
                var detailY = posInfo.cy + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(detailOffsetCenter[1], posInfo.r);
                var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(itemDetailModel.get("width"), posInfo.r);
                var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(itemDetailModel.get("height"), posInfo.r);
                var detailColor = seriesModel.get([
                    "progress",
                    "show"
                ]) ? data.getItemVisual(idx, "style").fill : autoColor;
                var labelEl = newDetailEls[idx];
                var formatter_1 = itemDetailModel.get("formatter");
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemDetailModel, {
                        x: detailX,
                        y: detailY,
                        text: $f677de6b1db15bcf$var$formatLabel(value, formatter_1),
                        width: isNaN(width) ? null : width,
                        height: isNaN(height) ? null : height,
                        align: "center",
                        verticalAlign: "middle"
                    }, {
                        inheritColor: detailColor
                    })
                });
                (0, $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2)(labelEl, {
                    normal: itemDetailModel
                }, value, function(value) {
                    return $f677de6b1db15bcf$var$formatLabel(value, formatter_1);
                });
                hasAnimation && (0, $6800dfcb6e1e2a44$export$dd6101605f5c186)(labelEl, idx, data, seriesModel, {
                    getFormattedLabel: function(labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
                        return $f677de6b1db15bcf$var$formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
                    }
                });
                itemGroup.add(labelEl);
            }
            contentGroup.add(itemGroup);
        });
        this.group.add(contentGroup);
        this._titleEls = newTitleEls;
        this._detailEls = newDetailEls;
    };
    GaugeView.type = "gauge";
    return GaugeView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $f677de6b1db15bcf$export$2e2bcd8739ae039 = $f677de6b1db15bcf$var$GaugeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $059503c83684127e$var$GaugeSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GaugeSeriesModel, _super);
    function GaugeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeSeriesModel.type;
        _this.visualStyleAccessPath = "itemStyle";
        return _this;
    }
    GaugeSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, [
            "value"
        ]);
    };
    GaugeSeriesModel.type = "series.gauge";
    GaugeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        legendHoverLink: true,
        radius: "75%",
        startAngle: 225,
        endAngle: -45,
        clockwise: true,
        // 最小值
        min: 0,
        // 最大值
        max: 100,
        // 分割段数，默认为10
        splitNumber: 10,
        // 坐标轴线
        axisLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            roundCap: false,
            lineStyle: {
                color: [
                    [
                        1,
                        "#E6EBF8"
                    ]
                ],
                width: 10
            }
        },
        // 坐标轴线
        progress: {
            // 默认显示，属性show控制显示与否
            show: false,
            overlap: true,
            width: 10,
            roundCap: false,
            clip: true
        },
        // 分隔线
        splitLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            // 属性length控制线长
            length: 10,
            distance: 10,
            // 属性lineStyle（详见lineStyle）控制线条样式
            lineStyle: {
                color: "#63677A",
                width: 3,
                type: "solid"
            }
        },
        // 坐标轴小标记
        axisTick: {
            // 属性show控制显示与否，默认不显示
            show: true,
            // 每份split细分多少段
            splitNumber: 5,
            // 属性length控制线长
            length: 6,
            distance: 10,
            // 属性lineStyle控制线条样式
            lineStyle: {
                color: "#63677A",
                width: 1,
                type: "solid"
            }
        },
        axisLabel: {
            show: true,
            distance: 15,
            // formatter: null,
            color: "#464646",
            fontSize: 12,
            rotate: 0
        },
        pointer: {
            icon: null,
            offsetCenter: [
                0,
                0
            ],
            show: true,
            showAbove: true,
            length: "60%",
            width: 6,
            keepAspect: false
        },
        anchor: {
            show: false,
            showAbove: false,
            size: 6,
            icon: "circle",
            offsetCenter: [
                0,
                0
            ],
            keepAspect: false,
            itemStyle: {
                color: "#fff",
                borderWidth: 0,
                borderColor: "#5470c6"
            }
        },
        title: {
            show: true,
            // x, y，单位px
            offsetCenter: [
                0,
                "20%"
            ],
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "#464646",
            fontSize: 16,
            valueAnimation: false
        },
        detail: {
            show: true,
            backgroundColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            borderColor: "#ccc",
            width: 100,
            height: null,
            padding: [
                5,
                10
            ],
            // x, y，单位px
            offsetCenter: [
                0,
                "40%"
            ],
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "#464646",
            fontSize: 30,
            fontWeight: "bold",
            lineHeight: 30,
            valueAnimation: false
        }
    };
    return GaugeSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $059503c83684127e$export$2e2bcd8739ae039 = $059503c83684127e$var$GaugeSeriesModel;


function $bf7cb565bb1d2308$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $f677de6b1db15bcf$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $059503c83684127e$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $a34a81cc5e14c818$var$opacityAccessPath = [
    "itemStyle",
    "opacity"
];
/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $a34a81cc5e14c818$var$FunnelPiece = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(FunnelPiece, _super);
    function FunnelPiece(data, idx) {
        var _this = _super.call(this) || this;
        var polygon = _this;
        var labelLine = new $d28119f30e6bb670$export$2e2bcd8739ae039();
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        polygon.setTextContent(text);
        _this.setTextGuideLine(labelLine);
        _this.updateData(data, idx, true);
        return _this;
    }
    FunnelPiece.prototype.updateData = function(data, idx, firstCreate) {
        var polygon = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var emphasisModel = itemModel.getModel("emphasis");
        var opacity = itemModel.get($a34a81cc5e14c818$var$opacityAccessPath);
        opacity = opacity == null ? 1 : opacity;
        if (!firstCreate) (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
        // Update common style
        polygon.useStyle(data.getItemVisual(idx, "style"));
        polygon.style.lineJoin = "round";
        if (firstCreate) {
            polygon.setShape({
                points: layout.points
            });
            polygon.style.opacity = 0;
            $8b353638fbedfefa$export$a121566aadcfe021(polygon, {
                style: {
                    opacity: opacity
                }
            }, seriesModel, idx);
        } else $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
            style: {
                opacity: opacity
            },
            shape: {
                points: layout.points
            }
        }, seriesModel, idx);
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel);
        this._updateLabel(data, idx);
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    FunnelPiece.prototype._updateLabel = function(data, idx) {
        var polygon = this;
        var labelLine = this.getTextGuideLine();
        var labelText = polygon.getTextContent();
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var labelLayout = layout.label;
        var style = data.getItemVisual(idx, "style");
        var visualColor = style.fill;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(// position will not be used in setLabelStyle
        labelText, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            defaultOpacity: style.opacity,
            defaultText: data.getName(idx)
        }, {
            normal: {
                align: labelLayout.textAlign,
                verticalAlign: labelLayout.verticalAlign
            }
        });
        polygon.setTextConfig({
            local: true,
            inside: !!labelLayout.inside,
            insideStroke: visualColor,
            // insideFill: 'auto',
            outsideFill: visualColor
        });
        var linePoints = labelLayout.linePoints;
        labelLine.setShape({
            points: linePoints
        });
        polygon.textGuideLineConfig = {
            anchor: linePoints ? new $b887f038f104fe7e$export$2e2bcd8739ae039(linePoints[0][0], linePoints[0][1]) : null
        };
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        $8b353638fbedfefa$export$c8dce3c08436e91e(labelText, {
            style: {
                x: labelLayout.x,
                y: labelLayout.y
            }
        }, seriesModel, idx);
        labelText.attr({
            rotation: labelLayout.rotation,
            originX: labelLayout.x,
            originY: labelLayout.y,
            z2: 10
        });
        (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(polygon, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), {
            // Default use item visual color
            stroke: visualColor
        });
    };
    return FunnelPiece;
}($51acf033123e1a30$export$2e2bcd8739ae039);
var $a34a81cc5e14c818$var$FunnelView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(FunnelView, _super);
    function FunnelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelView.type;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    FunnelView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        data.diff(oldData).add(function(idx) {
            var funnelPiece = new $a34a81cc5e14c818$var$FunnelPiece(data, idx);
            data.setItemGraphicEl(idx, funnelPiece);
            group.add(funnelPiece);
        }).update(function(newIdx, oldIdx) {
            var piece = oldData.getItemGraphicEl(oldIdx);
            piece.updateData(data, newIdx);
            group.add(piece);
            data.setItemGraphicEl(newIdx, piece);
        }).remove(function(idx) {
            var piece = oldData.getItemGraphicEl(idx);
            $8b353638fbedfefa$export$6d0fd725cb4aee8a(piece, seriesModel, idx);
        }).execute();
        this._data = data;
    };
    FunnelView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    FunnelView.prototype.dispose = function() {};
    FunnelView.type = "funnel";
    return FunnelView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $a34a81cc5e14c818$export$2e2bcd8739ae039 = $a34a81cc5e14c818$var$FunnelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $3ac6efc4b95638aa$var$FunnelSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(FunnelSeriesModel, _super);
    function FunnelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelSeriesModel.type;
        return _this;
    }
    FunnelSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
        // Extend labelLine emphasis
        this._defaultLabelLine(option);
    };
    FunnelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
    };
    FunnelSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        (0, $76d619f648247e6d$export$abdcc6a26372f94b)(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    // Overwrite
    FunnelSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        var valueDim = data.mapDimension("value");
        var sum = data.getSum(valueDim);
        // Percent is 0 if sum is 0
        params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
        params.$vars.push("percent");
        return params;
    };
    FunnelSeriesModel.type = "series.funnel";
    FunnelSeriesModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 2,
        legendHoverLink: true,
        colorBy: "data",
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        // 默认取数据最小最大值
        // min: 0,
        // max: 100,
        minSize: "0%",
        maxSize: "100%",
        sort: "descending",
        orient: "vertical",
        gap: 0,
        funnelAlign: "center",
        label: {
            show: true,
            position: "outer"
        },
        labelLine: {
            show: true,
            length: 20,
            lineStyle: {
                // color: 各异,
                width: 1
            }
        },
        itemStyle: {
            // color: 各异,
            borderColor: "#fff",
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        }
    };
    return FunnelSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $3ac6efc4b95638aa$export$2e2bcd8739ae039 = $3ac6efc4b95638aa$var$FunnelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $4e9f9ac9332ed124$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $4e9f9ac9332ed124$var$getSortedIndices(data, sort) {
    var valueDim = data.mapDimension("value");
    var valueArr = data.mapArray(valueDim, function(val) {
        return val;
    });
    var indices = [];
    var isAscending = sort === "ascending";
    for(var i = 0, len = data.count(); i < len; i++)indices[i] = i;
    // Add custom sortable function & none sortable opetion by "options.sort"
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(sort)) indices.sort(sort);
    else if (sort !== "none") indices.sort(function(a, b) {
        return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
    return indices;
}
function $4e9f9ac9332ed124$var$labelLayout(data) {
    var seriesModel = data.hostModel;
    var orient = seriesModel.get("orient");
    data.each(function(idx) {
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label");
        var labelPosition = labelModel.get("position");
        var labelLineModel = itemModel.getModel("labelLine");
        var layout = data.getItemLayout(idx);
        var points = layout.points;
        var isLabelInside = labelPosition === "inner" || labelPosition === "inside" || labelPosition === "center" || labelPosition === "insideLeft" || labelPosition === "insideRight";
        var textAlign;
        var textX;
        var textY;
        var linePoints;
        if (isLabelInside) {
            if (labelPosition === "insideLeft") {
                textX = (points[0][0] + points[3][0]) / 2 + 5;
                textY = (points[0][1] + points[3][1]) / 2;
                textAlign = "left";
            } else if (labelPosition === "insideRight") {
                textX = (points[1][0] + points[2][0]) / 2 - 5;
                textY = (points[1][1] + points[2][1]) / 2;
                textAlign = "right";
            } else {
                textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
                textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
                textAlign = "center";
            }
            linePoints = [
                [
                    textX,
                    textY
                ],
                [
                    textX,
                    textY
                ]
            ];
        } else {
            var x1 = void 0;
            var y1 = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var labelLineLen = labelLineModel.get("length");
            if (labelPosition === "left") {
                // Left side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                x2 = x1 - labelLineLen;
                textX = x2 - 5;
                textAlign = "right";
            } else if (labelPosition === "right") {
                // Right side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                x2 = x1 + labelLineLen;
                textX = x2 + 5;
                textAlign = "left";
            } else if (labelPosition === "top") {
                // Top side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                y2 = y1 - labelLineLen;
                textY = y2 - 5;
                textAlign = "center";
            } else if (labelPosition === "bottom") {
                // Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                y2 = y1 + labelLineLen;
                textY = y2 + 5;
                textAlign = "center";
            } else if (labelPosition === "rightTop") {
                // RightTop side
                x1 = orient === "horizontal" ? points[3][0] : points[1][0];
                y1 = orient === "horizontal" ? points[3][1] : points[1][1];
                if (orient === "horizontal") {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "top";
                }
            } else if (labelPosition === "rightBottom") {
                // RightBottom side
                x1 = points[2][0];
                y1 = points[2][1];
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "bottom";
                }
            } else if (labelPosition === "leftTop") {
                // LeftTop side
                x1 = points[0][0];
                y1 = orient === "horizontal" ? points[0][1] : points[1][1];
                if (orient === "horizontal") {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = "center";
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = "right";
                }
            } else if (labelPosition === "leftBottom") {
                // LeftBottom side
                x1 = orient === "horizontal" ? points[1][0] : points[3][0];
                y1 = orient === "horizontal" ? points[1][1] : points[2][1];
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = "right";
                }
            } else {
                // Right side or Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "left";
                }
            }
            if (orient === "horizontal") {
                x2 = x1;
                textX = x2;
            } else {
                y2 = y1;
                textY = y2;
            }
            linePoints = [
                [
                    x1,
                    y1
                ],
                [
                    x2,
                    y2
                ]
            ];
        }
        layout.label = {
            linePoints: linePoints,
            x: textX,
            y: textY,
            verticalAlign: "middle",
            textAlign: textAlign,
            inside: isLabelInside
        };
    });
}
function $4e9f9ac9332ed124$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("funnel", function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var sort = seriesModel.get("sort");
        var viewRect = $4e9f9ac9332ed124$var$getViewRect(seriesModel, api);
        var orient = seriesModel.get("orient");
        var viewWidth = viewRect.width;
        var viewHeight = viewRect.height;
        var indices = $4e9f9ac9332ed124$var$getSortedIndices(data, sort);
        var x = viewRect.x;
        var y = viewRect.y;
        var sizeExtent = orient === "horizontal" ? [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("minSize"), viewHeight),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("maxSize"), viewHeight)
        ] : [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("minSize"), viewWidth),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("maxSize"), viewWidth)
        ];
        var dataExtent = data.getDataExtent(valueDim);
        var min = seriesModel.get("min");
        var max = seriesModel.get("max");
        if (min == null) min = Math.min(dataExtent[0], 0);
        if (max == null) max = dataExtent[1];
        var funnelAlign = seriesModel.get("funnelAlign");
        var gap = seriesModel.get("gap");
        var viewSize = orient === "horizontal" ? viewWidth : viewHeight;
        var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
        var getLinePoints = function(idx, offset) {
            // End point index is data.count() and we assign it 0
            if (orient === "horizontal") {
                var val_1 = data.get(valueDim, idx) || 0;
                var itemHeight = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val_1, [
                    min,
                    max
                ], sizeExtent, true);
                var y0 = void 0;
                switch(funnelAlign){
                    case "top":
                        y0 = y;
                        break;
                    case "center":
                        y0 = y + (viewHeight - itemHeight) / 2;
                        break;
                    case "bottom":
                        y0 = y + (viewHeight - itemHeight);
                        break;
                }
                return [
                    [
                        offset,
                        y0
                    ],
                    [
                        offset,
                        y0 + itemHeight
                    ]
                ];
            }
            var val = data.get(valueDim, idx) || 0;
            var itemWidth = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, [
                min,
                max
            ], sizeExtent, true);
            var x0;
            switch(funnelAlign){
                case "left":
                    x0 = x;
                    break;
                case "center":
                    x0 = x + (viewWidth - itemWidth) / 2;
                    break;
                case "right":
                    x0 = x + viewWidth - itemWidth;
                    break;
            }
            return [
                [
                    x0,
                    offset
                ],
                [
                    x0 + itemWidth,
                    offset
                ]
            ];
        };
        if (sort === "ascending") {
            // From bottom to top
            itemSize = -itemSize;
            gap = -gap;
            if (orient === "horizontal") x += viewWidth;
            else y += viewHeight;
            indices = indices.reverse();
        }
        for(var i = 0; i < indices.length; i++){
            var idx = indices[i];
            var nextIdx = indices[i + 1];
            var itemModel = data.getItemModel(idx);
            if (orient === "horizontal") {
                var width = itemModel.get([
                    "itemStyle",
                    "width"
                ]);
                if (width == null) width = itemSize;
                else {
                    width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(width, viewWidth);
                    if (sort === "ascending") width = -width;
                }
                var start = getLinePoints(idx, x);
                var end = getLinePoints(nextIdx, x + width);
                x += width + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            } else {
                var height = itemModel.get([
                    "itemStyle",
                    "height"
                ]);
                if (height == null) height = itemSize;
                else {
                    height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(height, viewHeight);
                    if (sort === "ascending") height = -height;
                }
                var start = getLinePoints(idx, y);
                var end = getLinePoints(nextIdx, y + height);
                y += height + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            }
        }
        $4e9f9ac9332ed124$var$labelLayout(data);
    });
}



function $2bdc3734cdc2f6c8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $a34a81cc5e14c818$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3ac6efc4b95638aa$export$2e2bcd8739ae039));
    registers.registerLayout((0, $4e9f9ac9332ed124$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("funnel"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $9e57680b9c04f083$var$DEFAULT_SMOOTH = 0.3;
var $9e57680b9c04f083$var$ParallelView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        _this._dataGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._initialized = false;
        return _this;
    }
    ParallelView.prototype.init = function() {
        this.group.add(this._dataGroup);
    };
    /**
   * @override
   */ ParallelView.prototype.render = function(seriesModel, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var dataGroup = this._dataGroup;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $9e57680b9c04f083$var$makeSeriesScope(seriesModel);
        data.diff(oldData).add(add).update(update).remove(remove).execute();
        function add(newDataIndex) {
            var line = $9e57680b9c04f083$var$addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
            $9e57680b9c04f083$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function update(newDataIndex, oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            var points = $9e57680b9c04f083$var$createLinePoints(data, newDataIndex, dimensions, coordSys);
            data.setItemGraphicEl(newDataIndex, line);
            $8b353638fbedfefa$export$c8dce3c08436e91e(line, {
                shape: {
                    points: points
                }
            }, seriesModel, newDataIndex);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(line);
            $9e57680b9c04f083$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function remove(oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            dataGroup.remove(line);
        }
        // First create
        if (!this._initialized) {
            this._initialized = true;
            var clipPath = $9e57680b9c04f083$var$createGridClipShape(coordSys, seriesModel, function() {
                // Callback will be invoked immediately if there is no animation
                setTimeout(function() {
                    dataGroup.removeClipPath();
                });
            });
            dataGroup.setClipPath(clipPath);
        }
        this._data = data;
    };
    ParallelView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._initialized = true;
        this._data = null;
        this._dataGroup.removeAll();
    };
    ParallelView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $9e57680b9c04f083$var$makeSeriesScope(seriesModel);
        var progressiveEls = this._progressiveEls = [];
        for(var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++){
            var line = $9e57680b9c04f083$var$addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
            line.incremental = true;
            $9e57680b9c04f083$var$updateElCommon(line, data, dataIndex, seriesScope);
            progressiveEls.push(line);
        }
    };
    ParallelView.prototype.remove = function() {
        this._dataGroup && this._dataGroup.removeAll();
        this._data = null;
    };
    ParallelView.type = "parallel";
    return ParallelView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $9e57680b9c04f083$var$createGridClipShape(coordSys, seriesModel, cb) {
    var parallelModel = coordSys.model;
    var rect = coordSys.getRect();
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        }
    });
    var dim = parallelModel.get("layout") === "horizontal" ? "width" : "height";
    rectEl.setShape(dim, 0);
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width,
            height: rect.height
        }
    }, seriesModel, cb);
    return rectEl;
}
function $9e57680b9c04f083$var$createLinePoints(data, dataIndex, dimensions, coordSys) {
    var points = [];
    for(var i = 0; i < dimensions.length; i++){
        var dimName = dimensions[i];
        var value = data.get(data.mapDimension(dimName), dataIndex);
        if (!$9e57680b9c04f083$var$isEmptyValue(value, coordSys.getAxis(dimName).type)) points.push(coordSys.dataToPoint(value, dimName));
    }
    return points;
}
function $9e57680b9c04f083$var$addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
    var points = $9e57680b9c04f083$var$createLinePoints(data, dataIndex, dimensions, coordSys);
    var line = new $d28119f30e6bb670$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        // silent: true,
        z2: 10
    });
    dataGroup.add(line);
    data.setItemGraphicEl(dataIndex, line);
    return line;
}
function $9e57680b9c04f083$var$makeSeriesScope(seriesModel) {
    var smooth = seriesModel.get("smooth", true);
    smooth === true && (smooth = $9e57680b9c04f083$var$DEFAULT_SMOOTH);
    smooth = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(smooth);
    (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(smooth) && (smooth = 0);
    return {
        smooth: smooth
    };
}
function $9e57680b9c04f083$var$updateElCommon(el, data, dataIndex, seriesScope) {
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.fill = null;
    el.setShape("smooth", seriesScope.smooth);
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel("emphasis");
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel, "lineStyle");
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
}
// function simpleDiff(oldData, newData, dimensions) {
//     let oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     let dimLen = dimensions.length;
//     for (let i = 0; i < oldLen; i++) {
//         for (let j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME put in common util?
function $9e57680b9c04f083$var$isEmptyValue(val, axisType) {
    return axisType === "category" ? val == null : val == null || isNaN(val); // axisType === 'value'
}
var $9e57680b9c04f083$export$2e2bcd8739ae039 = $9e57680b9c04f083$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5d63691998e05817$var$ParallelSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ParallelSeriesModel, _super);
    function ParallelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelSeriesModel.type;
        _this.visualStyleAccessPath = "lineStyle";
        _this.visualDrawType = "stroke";
        return _this;
    }
    ParallelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($5d63691998e05817$var$makeDefaultEncode, null, this)
        });
    };
    /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @return Raw indices
   */ ParallelSeriesModel.prototype.getRawIndicesByActiveState = function(activeState) {
        var coordSys = this.coordinateSystem;
        var data = this.getData();
        var indices = [];
        coordSys.eachActiveState(data, function(theActiveState, dataIndex) {
            if (activeState === theActiveState) indices.push(data.getRawIndex(dataIndex));
        });
        return indices;
    };
    ParallelSeriesModel.type = "series.parallel";
    ParallelSeriesModel.dependencies = [
        "parallel"
    ];
    ParallelSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "parallel",
        parallelIndex: 0,
        label: {
            show: false
        },
        inactiveOpacity: 0.05,
        activeOpacity: 1,
        lineStyle: {
            width: 1,
            opacity: 0.45,
            type: "solid"
        },
        emphasis: {
            label: {
                show: false
            }
        },
        progressive: 500,
        smooth: false,
        animationEasing: "linear"
    };
    return ParallelSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
function $5d63691998e05817$var$makeDefaultEncode(seriesModel) {
    // The mapping of parallelAxis dimension to data dimension can
    // be specified in parallelAxis.option.dim. For example, if
    // parallelAxis.option.dim is 'dim3', it mapping to the third
    // dimension of data. But `data.encode` has higher priority.
    // Moreover, parallelModel.dimension should not be regarded as data
    // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
    var parallelModel = seriesModel.ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
    if (!parallelModel) return;
    var encodeDefine = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parallelModel.dimensions, function(axisDim) {
        var dataDimIndex = $5d63691998e05817$var$convertDimNameToNumber(axisDim);
        encodeDefine[axisDim] = dataDimIndex;
    });
    return encodeDefine;
}
function $5d63691998e05817$var$convertDimNameToNumber(dimName) {
    return +dimName.replace("dim", "");
}
var $5d63691998e05817$export$2e2bcd8739ae039 = $5d63691998e05817$var$ParallelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8148e21d655f67c8$var$opacityAccessPath = [
    "lineStyle",
    "opacity"
];
var $8148e21d655f67c8$var$parallelVisual = {
    seriesType: "parallel",
    reset: function(seriesModel, ecModel) {
        var coordSys = seriesModel.coordinateSystem;
        var opacityMap = {
            normal: seriesModel.get([
                "lineStyle",
                "opacity"
            ]),
            active: seriesModel.get("activeOpacity"),
            inactive: seriesModel.get("inactiveOpacity")
        };
        return {
            progress: function(params, data) {
                coordSys.eachActiveState(data, function(activeState, dataIndex) {
                    var opacity = opacityMap[activeState];
                    if (activeState === "normal" && data.hasItemOption) {
                        var itemOpacity = data.getItemModel(dataIndex).get($8148e21d655f67c8$var$opacityAccessPath, true);
                        itemOpacity != null && (opacity = itemOpacity);
                    }
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, "style");
                    existsStyle.opacity = opacity;
                }, params.start, params.end);
            }
        };
    }
};
var $8148e21d655f67c8$export$2e2bcd8739ae039 = $8148e21d655f67c8$var$parallelVisual;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $30173db3404062fa$export$2e2bcd8739ae039(option) {
    $30173db3404062fa$var$createParallelIfNeeded(option);
    $30173db3404062fa$var$mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */ function $30173db3404062fa$var$createParallelIfNeeded(option) {
    if (option.parallel) return;
    var hasParallelSeries = false;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "parallel") hasParallelSeries = true;
    });
    if (hasParallelSeries) option.parallel = [
        {}
    ];
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */ function $30173db3404062fa$var$mergeAxisOptionFromParallel(option) {
    var axes = $76d619f648247e6d$export$4f07b212a02c8051(option.parallelAxis);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(axes, function(axisOption) {
        if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(axisOption)) return;
        var parallelIndex = axisOption.parallelIndex || 0;
        var parallelOption = $76d619f648247e6d$export$4f07b212a02c8051(option.parallel)[parallelIndex];
        if (parallelOption && parallelOption.parallelAxisDefault) $7a1bd9c2710fea0d$export$4950aa0f605343fb(axisOption, parallelOption.parallelAxisDefault, false);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $ccce4513d4baec6a$var$CLICK_THRESHOLD = 5; // > 4
var $ccce4513d4baec6a$var$ParallelView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        return _this;
    }
    ParallelView.prototype.render = function(parallelModel, ecModel, api) {
        this._model = parallelModel;
        this._api = api;
        if (!this._handlers) {
            this._handlers = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($ccce4513d4baec6a$var$handlers, function(handler, eventName) {
                api.getZr().on(eventName, this._handlers[eventName] = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(handler, this));
            }, this);
        }
        (0, $c98659a9437a3d2e$export$958e3e1a02eac4b6)(this, "_throttledDispatchExpand", parallelModel.get("axisExpandRate"), "fixRate");
    };
    ParallelView.prototype.dispose = function(ecModel, api) {
        (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_throttledDispatchExpand");
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            api.getZr().off(eventName, handler);
        });
        this._handlers = null;
    };
    /**
   * @internal
   * @param {Object} [opt] If null, cancel the last action triggering for debounce.
   */ ParallelView.prototype._throttledDispatchExpand = function(opt) {
        this._dispatchExpand(opt);
    };
    /**
   * @internal
   */ ParallelView.prototype._dispatchExpand = function(opt) {
        opt && this._api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            type: "parallelAxisExpand"
        }, opt));
    };
    ParallelView.type = "parallel";
    return ParallelView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $ccce4513d4baec6a$var$handlers = {
    mousedown: function(e) {
        if ($ccce4513d4baec6a$var$checkTrigger(this, "click")) this._mouseDownPoint = [
            e.offsetX,
            e.offsetY
        ];
    },
    mouseup: function(e) {
        var mouseDownPoint = this._mouseDownPoint;
        if ($ccce4513d4baec6a$var$checkTrigger(this, "click") && mouseDownPoint) {
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
            if (dist > $ccce4513d4baec6a$var$CLICK_THRESHOLD) return;
            var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([
                e.offsetX,
                e.offsetY
            ]);
            result.behavior !== "none" && this._dispatchExpand({
                axisExpandWindow: result.axisExpandWindow
            });
        }
        this._mouseDownPoint = null;
    },
    mousemove: function(e) {
        // Should do nothing when brushing.
        if (this._mouseDownPoint || !$ccce4513d4baec6a$var$checkTrigger(this, "mousemove")) return;
        var model = this._model;
        var result = model.coordinateSystem.getSlidedAxisExpandWindow([
            e.offsetX,
            e.offsetY
        ]);
        var behavior = result.behavior;
        behavior === "jump" && this._throttledDispatchExpand.debounceNextCall(model.get("axisExpandDebounce"));
        this._throttledDispatchExpand(behavior === "none" ? null // Cancel the last trigger, in case that mouse slide out of the area quickly.
         : {
            axisExpandWindow: result.axisExpandWindow,
            // Jumping uses animation, and sliding suppresses animation.
            animation: behavior === "jump" ? null : {
                duration: 0 // Disable animation.
            }
        });
    }
};
function $ccce4513d4baec6a$var$checkTrigger(view, triggerOn) {
    var model = view._model;
    return model.get("axisExpandable") && model.get("axisExpandTriggerOn") === triggerOn;
}
var $ccce4513d4baec6a$export$2e2bcd8739ae039 = $ccce4513d4baec6a$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a14d8e1511adaa1e$var$ParallelModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ParallelModel, _super);
    function ParallelModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelModel.type;
        return _this;
    }
    ParallelModel.prototype.init = function() {
        _super.prototype.init.apply(this, arguments);
        this.mergeOption({});
    };
    ParallelModel.prototype.mergeOption = function(newOption) {
        var thisOption = this.option;
        newOption && $7a1bd9c2710fea0d$export$4950aa0f605343fb(thisOption, newOption, true);
        this._initDimensions();
    };
    /**
   * Whether series or axis is in this coordinate system.
   */ ParallelModel.prototype.contains = function(model, ecModel) {
        var parallelIndex = model.get("parallelIndex");
        return parallelIndex != null && ecModel.getComponent("parallel", parallelIndex) === this;
    };
    ParallelModel.prototype.setAxisExpand = function(opt) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "axisExpandable",
            "axisExpandCenter",
            "axisExpandCount",
            "axisExpandWidth",
            "axisExpandWindow"
        ], function(name) {
            if (opt.hasOwnProperty(name)) // @ts-ignore FIXME: why "never" inferred in this.option[name]?
            this.option[name] = opt[name];
        }, this);
    };
    ParallelModel.prototype._initDimensions = function() {
        var dimensions = this.dimensions = [];
        var parallelAxisIndex = this.parallelAxisIndex = [];
        var axisModels = $7a1bd9c2710fea0d$export$3dea766d36a8935f(this.ecModel.queryComponents({
            mainType: "parallelAxis"
        }), function(axisModel) {
            // Can not use this.contains here, because
            // initialization has not been completed yet.
            return (axisModel.get("parallelIndex") || 0) === this.componentIndex;
        }, this);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisModels, function(axisModel) {
            dimensions.push("dim" + axisModel.get("dim"));
            parallelAxisIndex.push(axisModel.componentIndex);
        });
    };
    ParallelModel.type = "parallel";
    ParallelModel.dependencies = [
        "parallelAxis"
    ];
    ParallelModel.layoutMode = "box";
    ParallelModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        layout: "horizontal",
        // FIXME
        // naming?
        axisExpandable: false,
        axisExpandCenter: null,
        axisExpandCount: 0,
        axisExpandWidth: 50,
        axisExpandRate: 17,
        axisExpandDebounce: 50,
        // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
        // Do not doc to user until necessary.
        axisExpandSlideTriggerArea: [
            -0.15,
            0.05,
            0.4
        ],
        axisExpandTriggerOn: "click",
        parallelAxisDefault: null
    };
    return ParallelModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $a14d8e1511adaa1e$export$2e2bcd8739ae039 = $a14d8e1511adaa1e$var$ParallelModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel coordinate system creater.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ec1c8727611588c2$var$ParallelAxis = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ParallelAxis, _super);
    function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        _this.axisIndex = axisIndex;
        return _this;
    }
    ParallelAxis.prototype.isHorizontal = function() {
        return this.coordinateSystem.getModel().get("layout") !== "horizontal";
    };
    return ParallelAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $ec1c8727611588c2$export$2e2bcd8739ae039 = $ec1c8727611588c2$var$ParallelAxis;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param delta Move length.
 * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param handleIndex Can be 'all', means that both move the two handleEnds.
 * @param minSpan The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param maxSpan The range of dataZoom can not be larger than that.
 * @return The input handleEnds.
 */ function $00a8003b34293330$export$2e2bcd8739ae039(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
    delta = delta || 0;
    var extentSpan = extent[1] - extent[0];
    // Notice maxSpan and minSpan can be null/undefined.
    if (minSpan != null) minSpan = $00a8003b34293330$var$restrict(minSpan, [
        0,
        extentSpan
    ]);
    if (maxSpan != null) maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
    if (handleIndex === "all") {
        var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
        handleSpan = $00a8003b34293330$var$restrict(handleSpan, [
            0,
            extentSpan
        ]);
        minSpan = maxSpan = $00a8003b34293330$var$restrict(handleSpan, [
            minSpan,
            maxSpan
        ]);
        handleIndex = 0;
    }
    handleEnds[0] = $00a8003b34293330$var$restrict(handleEnds[0], extent);
    handleEnds[1] = $00a8003b34293330$var$restrict(handleEnds[1], extent);
    var originalDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    handleEnds[handleIndex] += delta;
    // Restrict in extent.
    var extentMinSpan = minSpan || 0;
    var realExtent = extent.slice();
    originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
    handleEnds[handleIndex] = $00a8003b34293330$var$restrict(handleEnds[handleIndex], realExtent);
    // Expand span.
    var currDistSign;
    currDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
    // Shrink span.
    currDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    if (maxSpan != null && currDistSign.span > maxSpan) handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
    return handleEnds;
}
function $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex) {
    var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex];
    // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
    // is at left of handleEnds[1] for non-cross case.
    return {
        span: Math.abs(dist),
        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
    };
}
function $00a8003b34293330$var$restrict(value, extend) {
    return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}


var $a26a2212b9c3ac89$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $a26a2212b9c3ac89$var$mathMin = Math.min;
var $a26a2212b9c3ac89$var$mathMax = Math.max;
var $a26a2212b9c3ac89$var$mathFloor = Math.floor;
var $a26a2212b9c3ac89$var$mathCeil = Math.ceil;
var $a26a2212b9c3ac89$var$round = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $a26a2212b9c3ac89$var$PI = Math.PI;
var $a26a2212b9c3ac89$var$Parallel = /** @class */ function() {
    function Parallel(parallelModel, ecModel, api) {
        this.type = "parallel";
        /**
     * key: dimension
     */ this._axesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        /**
     * key: dimension
     * value: {position: [], rotation, }
     */ this._axesLayout = {};
        this.dimensions = parallelModel.dimensions;
        this._model = parallelModel;
        this._init(parallelModel, ecModel, api);
    }
    Parallel.prototype._init = function(parallelModel, ecModel, api) {
        var dimensions = parallelModel.dimensions;
        var parallelAxisIndex = parallelModel.parallelAxisIndex;
        $a26a2212b9c3ac89$var$each(dimensions, function(dim, idx) {
            var axisIndex = parallelAxisIndex[idx];
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axis = this._axesMap.set(dim, new (0, $ec1c8727611588c2$export$2e2bcd8739ae039)(dim, $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel), [
                0,
                0
            ], axisModel.get("type"), axisIndex));
            var isCategory = axis.type === "category";
            axis.onBand = isCategory && axisModel.get("boundaryGap");
            axis.inverse = axisModel.get("inverse");
            // Injection
            axisModel.axis = axis;
            axis.model = axisModel;
            axis.coordinateSystem = axisModel.coordinateSystem = this;
        }, this);
    };
    /**
   * Update axis scale after data processed
   */ Parallel.prototype.update = function(ecModel, api) {
        this._updateAxesFromSeries(this._model, ecModel);
    };
    Parallel.prototype.containPoint = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var axisBase = layoutInfo.axisBase;
        var layoutBase = layoutInfo.layoutBase;
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var pAxis = point[1 - pixelDimIndex];
        var pLayout = point[pixelDimIndex];
        return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
    };
    Parallel.prototype.getModel = function() {
        return this._model;
    };
    /**
   * Update properties from series
   */ Parallel.prototype._updateAxesFromSeries = function(parallelModel, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            if (!parallelModel.contains(seriesModel, ecModel)) return;
            var data = seriesModel.getData();
            $a26a2212b9c3ac89$var$each(this.dimensions, function(dim) {
                var axis = this._axesMap.get(dim);
                axis.scale.unionExtentFromData(data, data.mapDimension(dim));
                $2d646e51cc34f840$export$51f3e70a54405d5a(axis.scale, axis.model);
            }, this);
        }, this);
    };
    /**
   * Resize the parallel coordinate system.
   */ Parallel.prototype.resize = function(parallelModel, api) {
        this._rect = $93b9bc7f22ac7369$export$4517a5ca639a7293(parallelModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._layoutAxes();
    };
    Parallel.prototype.getRect = function() {
        return this._rect;
    };
    Parallel.prototype._makeLayoutInfo = function() {
        var parallelModel = this._model;
        var rect = this._rect;
        var xy = [
            "x",
            "y"
        ];
        var wh = [
            "width",
            "height"
        ];
        var layout = parallelModel.get("layout");
        var pixelDimIndex = layout === "horizontal" ? 0 : 1;
        var layoutLength = rect[wh[pixelDimIndex]];
        var layoutExtent = [
            0,
            layoutLength
        ];
        var axisCount = this.dimensions.length;
        var axisExpandWidth = $a26a2212b9c3ac89$var$restrict(parallelModel.get("axisExpandWidth"), layoutExtent);
        var axisExpandCount = $a26a2212b9c3ac89$var$restrict(parallelModel.get("axisExpandCount") || 0, [
            0,
            axisCount
        ]);
        var axisExpandable = parallelModel.get("axisExpandable") && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0;
        // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
        // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
        // where collapsed axes should be overlapped.
        var axisExpandWindow = parallelModel.get("axisExpandWindow");
        var winSize;
        if (!axisExpandWindow) {
            winSize = $a26a2212b9c3ac89$var$restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
            var axisExpandCenter = parallelModel.get("axisExpandCenter") || $a26a2212b9c3ac89$var$mathFloor(axisCount / 2);
            axisExpandWindow = [
                axisExpandWidth * axisExpandCenter - winSize / 2
            ];
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        } else {
            winSize = $a26a2212b9c3ac89$var$restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        }
        var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount);
        // Avoid axisCollapseWidth is too small.
        axisCollapseWidth < 3 && (axisCollapseWidth = 0);
        // Find the first and last indices > ewin[0] and < ewin[1].
        var winInnerIndices = [
            $a26a2212b9c3ac89$var$mathFloor($a26a2212b9c3ac89$var$round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1,
            $a26a2212b9c3ac89$var$mathCeil($a26a2212b9c3ac89$var$round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1
        ];
        // Pos in ec coordinates.
        var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
        return {
            layout: layout,
            pixelDimIndex: pixelDimIndex,
            layoutBase: rect[xy[pixelDimIndex]],
            layoutLength: layoutLength,
            axisBase: rect[xy[1 - pixelDimIndex]],
            axisLength: rect[wh[1 - pixelDimIndex]],
            axisExpandable: axisExpandable,
            axisExpandWidth: axisExpandWidth,
            axisCollapseWidth: axisCollapseWidth,
            axisExpandWindow: axisExpandWindow,
            axisCount: axisCount,
            winInnerIndices: winInnerIndices,
            axisExpandWindow0Pos: axisExpandWindow0Pos
        };
    };
    Parallel.prototype._layoutAxes = function() {
        var rect = this._rect;
        var axes = this._axesMap;
        var dimensions = this.dimensions;
        var layoutInfo = this._makeLayoutInfo();
        var layout = layoutInfo.layout;
        axes.each(function(axis) {
            var axisExtent = [
                0,
                layoutInfo.axisLength
            ];
            var idx = axis.inverse ? 1 : 0;
            axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
        });
        $a26a2212b9c3ac89$var$each(dimensions, function(dim, idx) {
            var posInfo = (layoutInfo.axisExpandable ? $a26a2212b9c3ac89$var$layoutAxisWithExpand : $a26a2212b9c3ac89$var$layoutAxisWithoutExpand)(idx, layoutInfo);
            var positionTable = {
                horizontal: {
                    x: posInfo.position,
                    y: layoutInfo.axisLength
                },
                vertical: {
                    x: 0,
                    y: posInfo.position
                }
            };
            var rotationTable = {
                horizontal: $a26a2212b9c3ac89$var$PI / 2,
                vertical: 0
            };
            var position = [
                positionTable[layout].x + rect.x,
                positionTable[layout].y + rect.y
            ];
            var rotation = rotationTable[layout];
            var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, rotation);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, position);
            // TODO
            // tick layout info
            // TODO
            // update dimensions info based on axis order.
            this._axesLayout[dim] = {
                position: position,
                rotation: rotation,
                transform: transform,
                axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
                axisLabelShow: posInfo.axisLabelShow,
                nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
                tickDirection: 1,
                labelDirection: 1
            };
        }, this);
    };
    /**
   * Get axis by dim.
   */ Parallel.prototype.getAxis = function(dim) {
        return this._axesMap.get(dim);
    };
    /**
   * Convert a dim value of a single item of series data to Point.
   */ Parallel.prototype.dataToPoint = function(value, dim) {
        return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
    };
    /**
   * Travel data for one time, get activeState of each data item.
   * @param start the start dataIndex that travel from.
   * @param end the next dataIndex of the last dataIndex will be travel.
   */ Parallel.prototype.eachActiveState = function(data, callback, start, end) {
        start == null && (start = 0);
        end == null && (end = data.count());
        var axesMap = this._axesMap;
        var dimensions = this.dimensions;
        var dataDimensions = [];
        var axisModels = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimensions, function(axisDim) {
            dataDimensions.push(data.mapDimension(axisDim));
            axisModels.push(axesMap.get(axisDim).model);
        });
        var hasActiveSet = this.hasAxisBrushed();
        for(var dataIndex = start; dataIndex < end; dataIndex++){
            var activeState = void 0;
            if (!hasActiveSet) activeState = "normal";
            else {
                activeState = "active";
                var values = data.getValues(dataDimensions, dataIndex);
                for(var j = 0, lenj = dimensions.length; j < lenj; j++){
                    var state = axisModels[j].getActiveState(values[j]);
                    if (state === "inactive") {
                        activeState = "inactive";
                        break;
                    }
                }
            }
            callback(activeState, dataIndex);
        }
    };
    /**
   * Whether has any activeSet.
   */ Parallel.prototype.hasAxisBrushed = function() {
        var dimensions = this.dimensions;
        var axesMap = this._axesMap;
        var hasActiveSet = false;
        for(var j = 0, lenj = dimensions.length; j < lenj; j++)if (axesMap.get(dimensions[j]).model.getActiveState() !== "normal") hasActiveSet = true;
        return hasActiveSet;
    };
    /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   */ Parallel.prototype.axisCoordToPoint = function(coord, dim) {
        var axisLayout = this._axesLayout[dim];
        return $5b455ae6f843ac47$export$9f9dcb98c894b623([
            coord,
            0
        ], axisLayout.transform);
    };
    /**
   * Get axis layout.
   */ Parallel.prototype.getAxisLayout = function(dim) {
        return $7a1bd9c2710fea0d$export$9cd59f9826255e47(this._axesLayout[dim]);
    };
    /**
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */ Parallel.prototype.getSlidedAxisExpandWindow = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var extent = [
            0,
            layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)
        ];
        // Out of the area of coordinate system.
        if (!this.containPoint(point)) return {
            behavior: "none",
            axisExpandWindow: axisExpandWindow
        };
        // Convert the point from global to expand coordinates.
        var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos;
        // For dragging operation convenience, the window should not be
        // slided when mouse is the center area of the window.
        var delta;
        var behavior = "slide";
        var axisCollapseWidth = layoutInfo.axisCollapseWidth;
        var triggerArea = this._model.get("axisExpandSlideTriggerArea");
        // But consider touch device, jump is necessary.
        var useJump = triggerArea[0] != null;
        if (axisCollapseWidth) {
            if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
                behavior = "jump";
                delta = pointCoord - winSize * triggerArea[2];
            } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
                behavior = "jump";
                delta = pointCoord - winSize * (1 - triggerArea[2]);
            } else (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
            delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
            delta ? (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, axisExpandWindow, extent, "all") : behavior = "none";
        } else {
            var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
            var pos = extent[1] * pointCoord / winSize2;
            axisExpandWindow = [
                $a26a2212b9c3ac89$var$mathMax(0, pos - winSize2 / 2)
            ];
            axisExpandWindow[1] = $a26a2212b9c3ac89$var$mathMin(extent[1], axisExpandWindow[0] + winSize2);
            axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
        }
        return {
            axisExpandWindow: axisExpandWindow,
            behavior: behavior
        };
    };
    return Parallel;
}();
function $a26a2212b9c3ac89$var$restrict(len, extent) {
    return $a26a2212b9c3ac89$var$mathMin($a26a2212b9c3ac89$var$mathMax(len, extent[0]), extent[1]);
}
function $a26a2212b9c3ac89$var$layoutAxisWithoutExpand(axisIndex, layoutInfo) {
    var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
    return {
        position: step * axisIndex,
        axisNameAvailableWidth: step,
        axisLabelShow: true
    };
}
function $a26a2212b9c3ac89$var$layoutAxisWithExpand(axisIndex, layoutInfo) {
    var layoutLength = layoutInfo.layoutLength;
    var axisExpandWidth = layoutInfo.axisExpandWidth;
    var axisCount = layoutInfo.axisCount;
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
    var winInnerIndices = layoutInfo.winInnerIndices;
    var position;
    var axisNameAvailableWidth = axisCollapseWidth;
    var axisLabelShow = false;
    var nameTruncateMaxWidth;
    if (axisIndex < winInnerIndices[0]) {
        position = axisIndex * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    } else if (axisIndex <= winInnerIndices[1]) {
        position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
        axisNameAvailableWidth = axisExpandWidth;
        axisLabelShow = true;
    } else {
        position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    }
    return {
        position: position,
        axisNameAvailableWidth: axisNameAvailableWidth,
        axisLabelShow: axisLabelShow,
        nameTruncateMaxWidth: nameTruncateMaxWidth
    };
}
var $a26a2212b9c3ac89$export$2e2bcd8739ae039 = $a26a2212b9c3ac89$var$Parallel;



function $88531590cdbcfc26$var$createParallelCoordSys(ecModel, api) {
    var coordSysList = [];
    ecModel.eachComponent("parallel", function(parallelModel, idx) {
        var coordSys = new (0, $a26a2212b9c3ac89$export$2e2bcd8739ae039)(parallelModel, ecModel, api);
        coordSys.name = "parallel_" + idx;
        coordSys.resize(parallelModel, api);
        parallelModel.coordinateSystem = coordSys;
        coordSys.model = parallelModel;
        coordSysList.push(coordSys);
    });
    // Inject the coordinateSystems into seriesModel
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get("coordinateSystem") === "parallel") {
            var parallelModel = seriesModel.getReferringComponents("parallel", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = parallelModel.coordinateSystem;
        }
    });
    return coordSysList;
}
var $88531590cdbcfc26$var$parallelCoordSysCreator = {
    create: $88531590cdbcfc26$var$createParallelCoordSys
};
var $88531590cdbcfc26$export$2e2bcd8739ae039 = $88531590cdbcfc26$var$parallelCoordSysCreator;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $839a50fcb1c6f44b$var$ParallelAxisModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ParallelAxisModel, _super);
    function ParallelAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisModel.type;
        /**
     * @readOnly
     */ _this.activeIntervals = [];
        return _this;
    }
    ParallelAxisModel.prototype.getAreaSelectStyle = function() {
        return (0, $06542048a26d4d91$export$2e2bcd8739ae039)([
            [
                "fill",
                "color"
            ],
            [
                "lineWidth",
                "borderWidth"
            ],
            [
                "stroke",
                "borderColor"
            ],
            [
                "width",
                "width"
            ],
            [
                "opacity",
                "opacity"
            ]
        ])(this.getModel("areaSelectStyle"));
    };
    /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param intervals `interval.length === 0` means set all active.
   */ ParallelAxisModel.prototype.setActiveIntervals = function(intervals) {
        var activeIntervals = this.activeIntervals = $7a1bd9c2710fea0d$export$9cd59f9826255e47(intervals);
        // Normalize
        if (activeIntervals) for(var i = activeIntervals.length - 1; i >= 0; i--)$cfc1f3b422a3185f$export$debe6e778e0a6d32(activeIntervals[i]);
    };
    /**
   * @param value When only attempting detect whether 'no activeIntervals set',
   *        `value` is not needed to be input.
   */ ParallelAxisModel.prototype.getActiveState = function(value) {
        var activeIntervals = this.activeIntervals;
        if (!activeIntervals.length) return "normal";
        if (value == null || isNaN(+value)) return "inactive";
        // Simple optimization
        if (activeIntervals.length === 1) {
            var interval = activeIntervals[0];
            if (interval[0] <= value && value <= interval[1]) return "active";
        } else for(var i = 0, len = activeIntervals.length; i < len; i++){
            if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) return "active";
        }
        return "inactive";
    };
    return ParallelAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($839a50fcb1c6f44b$var$ParallelAxisModel, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $839a50fcb1c6f44b$export$2e2bcd8739ae039 = $839a50fcb1c6f44b$var$ParallelAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL = true;
var $91342d1cfa622c5a$var$mathMin = Math.min;
var $91342d1cfa622c5a$var$mathMax = Math.max;
var $91342d1cfa622c5a$var$mathPow = Math.pow;
var $91342d1cfa622c5a$var$COVER_Z = 10000;
var $91342d1cfa622c5a$var$UNSELECT_THRESHOLD = 6;
var $91342d1cfa622c5a$var$MIN_RESIZE_LINE_WIDTH = 6;
var $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY = "globalPan";
var $91342d1cfa622c5a$var$DIRECTION_MAP = {
    w: [
        0,
        0
    ],
    e: [
        0,
        1
    ],
    n: [
        1,
        0
    ],
    s: [
        1,
        1
    ]
};
var $91342d1cfa622c5a$var$CURSOR_MAP = {
    w: "ew",
    e: "ew",
    n: "ns",
    s: "ns",
    ne: "nesw",
    sw: "nesw",
    nw: "nwse",
    se: "nwse"
};
var $91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT = {
    brushStyle: {
        lineWidth: 2,
        stroke: "rgba(210,219,238,0.3)",
        fill: "#D2DBEE"
    },
    transformable: true,
    brushMode: "single",
    removeOnClick: false
};
var $91342d1cfa622c5a$var$baseUID = 0;
/**
 * params:
 *     areas: Array.<Array>, coord relates to container group,
 *                             If no container specified, to global.
 *     opt {
 *         isEnd: boolean,
 *         removeOnClick: boolean
 *     }
 */ var $91342d1cfa622c5a$var$BrushController = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BrushController, _super);
    function BrushController(zr) {
        var _this = _super.call(this) || this;
        /**
     * @internal
     */ _this._track = [];
        /**
     * @internal
     */ _this._covers = [];
        _this._handlers = {};
        _this._zr = zr;
        _this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._uid = "brushController_" + $91342d1cfa622c5a$var$baseUID++;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($91342d1cfa622c5a$var$pointerHandlers, function(handler, eventName) {
            this._handlers[eventName] = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(handler, this);
        }, _this);
        return _this;
    }
    /**
   * If set to `false`, select disabled.
   */ BrushController.prototype.enableBrush = function(brushOption) {
        this._brushType && this._doDisableBrush();
        brushOption.brushType && this._doEnableBrush(brushOption);
        return this;
    };
    BrushController.prototype._doEnableBrush = function(brushOption) {
        var zr = this._zr;
        // Consider roam, which takes globalPan too.
        if (!this._enableGlobalPan) $befd6a34b30d3f54$export$b7df5d561049483a(zr, $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.on(eventName, handler);
        });
        this._brushType = brushOption.brushType;
        this._brushOption = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT), brushOption, true);
    };
    BrushController.prototype._doDisableBrush = function() {
        var zr = this._zr;
        $befd6a34b30d3f54$export$23d3fad09dc44362(zr, $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.off(eventName, handler);
        });
        this._brushType = this._brushOption = null;
    };
    /**
   * @param panelOpts If not pass, it is global brush.
   */ BrushController.prototype.setPanels = function(panelOpts) {
        if (panelOpts && panelOpts.length) {
            var panels_1 = this._panels = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(panelOpts, function(panelOpts) {
                panels_1[panelOpts.panelId] = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(panelOpts);
            });
        } else this._panels = null;
        return this;
    };
    BrushController.prototype.mount = function(opt) {
        opt = opt || {};
        this._enableGlobalPan = opt.enableGlobalPan;
        var thisGroup = this.group;
        this._zr.add(thisGroup);
        thisGroup.attr({
            x: opt.x || 0,
            y: opt.y || 0,
            rotation: opt.rotation || 0,
            scaleX: opt.scaleX || 1,
            scaleY: opt.scaleY || 1
        });
        this._transform = thisGroup.getLocalTransform();
        return this;
    };
    // eachCover(cb, context): void {
    //     each(this._covers, cb, context);
    // }
    /**
   * Update covers.
   * @param coverConfigList
   *        If coverConfigList is null/undefined, all covers removed.
   */ BrushController.prototype.updateCovers = function(coverConfigList) {
        coverConfigList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coverConfigList, function(coverConfig) {
            return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT), coverConfig, true);
        });
        var tmpIdPrefix = "\x00-brush-index-";
        var oldCovers = this._covers;
        var newCovers = this._covers = [];
        var controller = this;
        var creatingCover = this._creatingCover;
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
        return this;
        function getKey(brushOption, index) {
            return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + "-" + brushOption.brushType;
        }
        function oldGetKey(cover, index) {
            return getKey(cover.__brushOption, index);
        }
        function addOrUpdate(newIndex, oldIndex) {
            var newBrushInternal = coverConfigList[newIndex];
            // Consider setOption in event listener of brushSelect,
            // where updating cover when creating should be forbidden.
            if (oldIndex != null && oldCovers[oldIndex] === creatingCover) newCovers[newIndex] = oldCovers[oldIndex];
            else {
                var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : $91342d1cfa622c5a$var$endCreating(controller, $91342d1cfa622c5a$var$createCover(controller, newBrushInternal));
                $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
            }
        }
        function remove(oldIndex) {
            if (oldCovers[oldIndex] !== creatingCover) controller.group.remove(oldCovers[oldIndex]);
        }
    };
    BrushController.prototype.unmount = function() {
        this.enableBrush(false);
        // container may 'removeAll' outside.
        $91342d1cfa622c5a$var$clearCovers(this);
        this._zr.remove(this.group);
        return this;
    };
    BrushController.prototype.dispose = function() {
        this.unmount();
        this.off();
    };
    return BrushController;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
function $91342d1cfa622c5a$var$createCover(controller, brushOption) {
    var cover = $91342d1cfa622c5a$var$coverRenderers[brushOption.brushType].createCover(controller, brushOption);
    cover.__brushOption = brushOption;
    $91342d1cfa622c5a$var$updateZ(cover, brushOption);
    controller.group.add(cover);
    return cover;
}
function $91342d1cfa622c5a$var$endCreating(controller, creatingCover) {
    var coverRenderer = $91342d1cfa622c5a$var$getCoverRenderer(creatingCover);
    if (coverRenderer.endCreating) {
        coverRenderer.endCreating(controller, creatingCover);
        $91342d1cfa622c5a$var$updateZ(creatingCover, creatingCover.__brushOption);
    }
    return creatingCover;
}
function $91342d1cfa622c5a$var$updateCoverShape(controller, cover) {
    var brushOption = cover.__brushOption;
    $91342d1cfa622c5a$var$getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}
function $91342d1cfa622c5a$var$updateZ(cover, brushOption) {
    var z = brushOption.z;
    z == null && (z = $91342d1cfa622c5a$var$COVER_Z);
    cover.traverse(function(el) {
        el.z = z;
        el.z2 = z; // Consider in given container.
    });
}
function $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover) {
    $91342d1cfa622c5a$var$getCoverRenderer(cover).updateCommon(controller, cover);
    $91342d1cfa622c5a$var$updateCoverShape(controller, cover);
}
function $91342d1cfa622c5a$var$getCoverRenderer(cover) {
    return $91342d1cfa622c5a$var$coverRenderers[cover.__brushOption.brushType];
}
// return target panel or `true` (means global panel)
function $91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint) {
    var panels = controller._panels;
    if (!panels) return $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panel;
    var transform = controller._transform;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(panels, function(pn) {
        pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
    });
    return panel;
}
// Return a panel or true
function $91342d1cfa622c5a$var$getPanelByCover(controller, cover) {
    var panels = controller._panels;
    if (!panels) return $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panelId = cover.__brushOption.panelId;
    // User may give cover without coord sys info,
    // which is then treated as global panel.
    return panelId != null ? panels[panelId] : $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL;
}
function $91342d1cfa622c5a$var$clearCovers(controller) {
    var covers = controller._covers;
    var originalLength = covers.length;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(covers, function(cover) {
        controller.group.remove(cover);
    }, controller);
    covers.length = 0;
    return !!originalLength;
}
function $91342d1cfa622c5a$var$trigger(controller, opt) {
    var areas = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(controller._covers, function(cover) {
        var brushOption = cover.__brushOption;
        var range = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(brushOption.range);
        return {
            brushType: brushOption.brushType,
            panelId: brushOption.panelId,
            range: range
        };
    });
    controller.trigger("brush", {
        areas: areas,
        isEnd: !!opt.isEnd,
        removeOnClick: !!opt.removeOnClick
    });
}
function $91342d1cfa622c5a$var$shouldShowCover(controller) {
    var track = controller._track;
    if (!track.length) return false;
    var p2 = track[track.length - 1];
    var p1 = track[0];
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var dist = $91342d1cfa622c5a$var$mathPow(dx * dx + dy * dy, 0.5);
    return dist > $91342d1cfa622c5a$var$UNSELECT_THRESHOLD;
}
function $91342d1cfa622c5a$var$getTrackEnds(track) {
    var tail = track.length - 1;
    tail < 0 && (tail = 0);
    return [
        track[0],
        track[tail]
    ];
}
function $91342d1cfa622c5a$var$createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
    var cover = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    cover.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
        name: "main",
        style: $91342d1cfa622c5a$var$makeStyle(brushOption),
        silent: true,
        draggable: true,
        cursor: "move",
        drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftRect, rectRangeConverter, controller, cover, [
            "n",
            "s",
            "w",
            "e"
        ]),
        ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
            isEnd: true
        })
    }));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(edgeNameSequences, function(nameSequence) {
        cover.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            name: nameSequence.join(""),
            style: {
                opacity: 0
            },
            draggable: true,
            silent: true,
            invisible: true,
            drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftRect, rectRangeConverter, controller, cover, nameSequence),
            ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
                isEnd: true
            })
        }));
    });
    return cover;
}
function $91342d1cfa622c5a$var$updateBaseRect(controller, cover, localRange, brushOption) {
    var lineWidth = brushOption.brushStyle.lineWidth || 0;
    var handleSize = $91342d1cfa622c5a$var$mathMax(lineWidth, $91342d1cfa622c5a$var$MIN_RESIZE_LINE_WIDTH);
    var x = localRange[0][0];
    var y = localRange[1][0];
    var xa = x - lineWidth / 2;
    var ya = y - lineWidth / 2;
    var x2 = localRange[0][1];
    var y2 = localRange[1][1];
    var x2a = x2 - handleSize + lineWidth / 2;
    var y2a = y2 - handleSize + lineWidth / 2;
    var width = x2 - x;
    var height = y2 - y;
    var widtha = width + lineWidth;
    var heighta = height + lineWidth;
    $91342d1cfa622c5a$var$updateRectShape(controller, cover, "main", x, y, width, height);
    if (brushOption.transformable) {
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "w", xa, ya, handleSize, heighta);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "e", x2a, ya, handleSize, heighta);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "n", xa, ya, widtha, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "s", xa, y2a, widtha, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "nw", xa, ya, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "ne", x2a, ya, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "sw", xa, y2a, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "se", x2a, y2a, handleSize, handleSize);
    }
}
function $91342d1cfa622c5a$var$updateCommon(controller, cover) {
    var brushOption = cover.__brushOption;
    var transformable = brushOption.transformable;
    var mainEl = cover.childAt(0);
    mainEl.useStyle($91342d1cfa622c5a$var$makeStyle(brushOption));
    mainEl.attr({
        silent: !transformable,
        cursor: transformable ? "move" : "default"
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        [
            "w"
        ],
        [
            "e"
        ],
        [
            "n"
        ],
        [
            "s"
        ],
        [
            "s",
            "e"
        ],
        [
            "s",
            "w"
        ],
        [
            "n",
            "e"
        ],
        [
            "n",
            "w"
        ]
    ], function(nameSequence) {
        var el = cover.childOfName(nameSequence.join(""));
        var globalDir = nameSequence.length === 1 ? $91342d1cfa622c5a$var$getGlobalDirection1(controller, nameSequence[0]) : $91342d1cfa622c5a$var$getGlobalDirection2(controller, nameSequence);
        el && el.attr({
            silent: !transformable,
            invisible: !transformable,
            cursor: transformable ? $91342d1cfa622c5a$var$CURSOR_MAP[globalDir] + "-resize" : null
        });
    });
}
function $91342d1cfa622c5a$var$updateRectShape(controller, cover, name, x, y, w, h) {
    var el = cover.childOfName(name);
    el && el.setShape($91342d1cfa622c5a$var$pointsToRect($91342d1cfa622c5a$var$clipByPanel(controller, cover, [
        [
            x,
            y
        ],
        [
            x + w,
            y + h
        ]
    ])));
}
function $91342d1cfa622c5a$var$makeStyle(brushOption) {
    return (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        strokeNoScale: true
    }, brushOption.brushStyle);
}
function $91342d1cfa622c5a$var$formatRectRange(x, y, x2, y2) {
    var min = [
        $91342d1cfa622c5a$var$mathMin(x, x2),
        $91342d1cfa622c5a$var$mathMin(y, y2)
    ];
    var max = [
        $91342d1cfa622c5a$var$mathMax(x, x2),
        $91342d1cfa622c5a$var$mathMax(y, y2)
    ];
    return [
        [
            min[0],
            max[0]
        ],
        [
            min[1],
            max[1]
        ] // y range
    ];
}
function $91342d1cfa622c5a$var$getTransform(controller) {
    return $5b455ae6f843ac47$export$fce0c6cfca85ed96(controller.group);
}
function $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirName) {
    var map = {
        w: "left",
        e: "right",
        n: "top",
        s: "bottom"
    };
    var inverseMap = {
        left: "w",
        right: "e",
        top: "n",
        bottom: "s"
    };
    var dir = $5b455ae6f843ac47$export$fff94e9792354cfa(map[localDirName], $91342d1cfa622c5a$var$getTransform(controller));
    return inverseMap[dir];
}
function $91342d1cfa622c5a$var$getGlobalDirection2(controller, localDirNameSeq) {
    var globalDir = [
        $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirNameSeq[0]),
        $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirNameSeq[1])
    ];
    (globalDir[0] === "e" || globalDir[0] === "w") && globalDir.reverse();
    return globalDir.join("");
}
function $91342d1cfa622c5a$var$driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
    var brushOption = cover.__brushOption;
    var rectRange = rectRangeConverter.toRectRange(brushOption.range);
    var localDelta = $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dirNameSequence, function(dirName) {
        var ind = $91342d1cfa622c5a$var$DIRECTION_MAP[dirName];
        rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
    });
    brushOption.range = rectRangeConverter.fromRectRange($91342d1cfa622c5a$var$formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
    $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
    $91342d1cfa622c5a$var$trigger(controller, {
        isEnd: false
    });
}
function $91342d1cfa622c5a$var$driftPolygon(controller, cover, dx, dy) {
    var range = cover.__brushOption.range;
    var localDelta = $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(range, function(point) {
        point[0] += localDelta[0];
        point[1] += localDelta[1];
    });
    $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
    $91342d1cfa622c5a$var$trigger(controller, {
        isEnd: false
    });
}
function $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy) {
    var thisGroup = controller.group;
    var localD = thisGroup.transformCoordToLocal(dx, dy);
    var localZero = thisGroup.transformCoordToLocal(0, 0);
    return [
        localD[0] - localZero[0],
        localD[1] - localZero[1]
    ];
}
function $91342d1cfa622c5a$var$clipByPanel(controller, cover, data) {
    var panel = $91342d1cfa622c5a$var$getPanelByCover(controller, cover);
    return panel && panel !== $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(data);
}
function $91342d1cfa622c5a$var$pointsToRect(points) {
    var xmin = $91342d1cfa622c5a$var$mathMin(points[0][0], points[1][0]);
    var ymin = $91342d1cfa622c5a$var$mathMin(points[0][1], points[1][1]);
    var xmax = $91342d1cfa622c5a$var$mathMax(points[0][0], points[1][0]);
    var ymax = $91342d1cfa622c5a$var$mathMax(points[0][1], points[1][1]);
    return {
        x: xmin,
        y: ymin,
        width: xmax - xmin,
        height: ymax - ymin
    };
}
function $91342d1cfa622c5a$var$resetCursor(controller, e, localCursorPoint) {
    if (// Check active
    !controller._brushType || $91342d1cfa622c5a$var$isOutsideZrArea(controller, e.offsetX, e.offsetY)) return;
    var zr = controller._zr;
    var covers = controller._covers;
    var currPanel = $91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint);
    // Check whether in covers.
    if (!controller._dragging) for(var i = 0; i < covers.length; i++){
        var brushOption = covers[i].__brushOption;
        if (currPanel && (currPanel === $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && $91342d1cfa622c5a$var$coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) // Use cursor style set on cover.
        return;
    }
    currPanel && zr.setCursorStyle("crosshair");
}
function $91342d1cfa622c5a$var$preventDefault(e) {
    var rawE = e.event;
    rawE.preventDefault && rawE.preventDefault();
}
function $91342d1cfa622c5a$var$mainShapeContain(cover, x, y) {
    return cover.childOfName("main").contain(x, y);
}
function $91342d1cfa622c5a$var$updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
    var creatingCover = controller._creatingCover;
    var panel = controller._creatingPanel;
    var thisBrushOption = controller._brushOption;
    var eventParams;
    controller._track.push(localCursorPoint.slice());
    if ($91342d1cfa622c5a$var$shouldShowCover(controller) || creatingCover) {
        if (panel && !creatingCover) {
            thisBrushOption.brushMode === "single" && $91342d1cfa622c5a$var$clearCovers(controller);
            var brushOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(thisBrushOption);
            brushOption.brushType = $91342d1cfa622c5a$var$determineBrushType(brushOption.brushType, panel);
            brushOption.panelId = panel === $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL ? null : panel.panelId;
            creatingCover = controller._creatingCover = $91342d1cfa622c5a$var$createCover(controller, brushOption);
            controller._covers.push(creatingCover);
        }
        if (creatingCover) {
            var coverRenderer = $91342d1cfa622c5a$var$coverRenderers[$91342d1cfa622c5a$var$determineBrushType(controller._brushType, panel)];
            var coverBrushOption = creatingCover.__brushOption;
            coverBrushOption.range = coverRenderer.getCreatingRange($91342d1cfa622c5a$var$clipByPanel(controller, creatingCover, controller._track));
            if (isEnd) {
                $91342d1cfa622c5a$var$endCreating(controller, creatingCover);
                coverRenderer.updateCommon(controller, creatingCover);
            }
            $91342d1cfa622c5a$var$updateCoverShape(controller, creatingCover);
            eventParams = {
                isEnd: isEnd
            };
        }
    } else if (isEnd && thisBrushOption.brushMode === "single" && thisBrushOption.removeOnClick) // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    {
        if ($91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint) && $91342d1cfa622c5a$var$clearCovers(controller)) eventParams = {
            isEnd: isEnd,
            removeOnClick: true
        };
    }
    return eventParams;
}
function $91342d1cfa622c5a$var$determineBrushType(brushType, panel) {
    if (brushType === "auto") return panel.defaultBrushType;
    return brushType;
}
var $91342d1cfa622c5a$var$pointerHandlers = {
    mousedown: function(e) {
        if (this._dragging) // In case some browser do not support globalOut,
        // and release mouse out side the browser.
        $91342d1cfa622c5a$var$handleDragEnd(this, e);
        else if (!e.target || !e.target.draggable) {
            $91342d1cfa622c5a$var$preventDefault(e);
            var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
            this._creatingCover = null;
            var panel = this._creatingPanel = $91342d1cfa622c5a$var$getPanelByPoint(this, e, localCursorPoint);
            if (panel) {
                this._dragging = true;
                this._track = [
                    localCursorPoint.slice()
                ];
            }
        }
    },
    mousemove: function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = this.group.transformCoordToLocal(x, y);
        $91342d1cfa622c5a$var$resetCursor(this, e, localCursorPoint);
        if (this._dragging) {
            $91342d1cfa622c5a$var$preventDefault(e);
            var eventParams = $91342d1cfa622c5a$var$updateCoverByMouse(this, e, localCursorPoint, false);
            eventParams && $91342d1cfa622c5a$var$trigger(this, eventParams);
        }
    },
    mouseup: function(e) {
        $91342d1cfa622c5a$var$handleDragEnd(this, e);
    }
};
function $91342d1cfa622c5a$var$handleDragEnd(controller, e) {
    if (controller._dragging) {
        $91342d1cfa622c5a$var$preventDefault(e);
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = controller.group.transformCoordToLocal(x, y);
        var eventParams = $91342d1cfa622c5a$var$updateCoverByMouse(controller, e, localCursorPoint, true);
        controller._dragging = false;
        controller._track = [];
        controller._creatingCover = null;
        // trigger event should be at final, after procedure will be nested.
        eventParams && $91342d1cfa622c5a$var$trigger(controller, eventParams);
    }
}
function $91342d1cfa622c5a$var$isOutsideZrArea(controller, x, y) {
    var zr = controller._zr;
    return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 */ var $91342d1cfa622c5a$var$coverRenderers = {
    lineX: $91342d1cfa622c5a$var$getLineRenderer(0),
    lineY: $91342d1cfa622c5a$var$getLineRenderer(1),
    rect: {
        createCover: function(controller, brushOption) {
            function returnInput(range) {
                return range;
            }
            return $91342d1cfa622c5a$var$createBaseRectCover({
                toRectRange: returnInput,
                fromRectRange: returnInput
            }, controller, brushOption, [
                [
                    "w"
                ],
                [
                    "e"
                ],
                [
                    "n"
                ],
                [
                    "s"
                ],
                [
                    "s",
                    "e"
                ],
                [
                    "s",
                    "w"
                ],
                [
                    "n",
                    "e"
                ],
                [
                    "n",
                    "w"
                ]
            ]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $91342d1cfa622c5a$var$getTrackEnds(localTrack);
            return $91342d1cfa622c5a$var$formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            $91342d1cfa622c5a$var$updateBaseRect(controller, cover, localRange, brushOption);
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    },
    polygon: {
        createCover: function(controller, brushOption) {
            var cover = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            // Do not use graphic.Polygon because graphic.Polyline do not close the
            // border of the shape when drawing, which is a better experience for user.
            cover.add(new $d28119f30e6bb670$export$2e2bcd8739ae039({
                name: "main",
                style: $91342d1cfa622c5a$var$makeStyle(brushOption),
                silent: true
            }));
            return cover;
        },
        getCreatingRange: function(localTrack) {
            return localTrack;
        },
        endCreating: function(controller, cover) {
            cover.remove(cover.childAt(0));
            // Use graphic.Polygon close the shape.
            cover.add(new $51acf033123e1a30$export$2e2bcd8739ae039({
                name: "main",
                draggable: true,
                drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftPolygon, controller, cover),
                ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
                    isEnd: true
                })
            }));
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            cover.childAt(0).setShape({
                points: $91342d1cfa622c5a$var$clipByPanel(controller, cover, localRange)
            });
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    }
};
function $91342d1cfa622c5a$var$getLineRenderer(xyIndex) {
    return {
        createCover: function(controller, brushOption) {
            return $91342d1cfa622c5a$var$createBaseRectCover({
                toRectRange: function(range) {
                    var rectRange = [
                        range,
                        [
                            0,
                            100
                        ]
                    ];
                    xyIndex && rectRange.reverse();
                    return rectRange;
                },
                fromRectRange: function(rectRange) {
                    return rectRange[xyIndex];
                }
            }, controller, brushOption, [
                [
                    [
                        "w"
                    ],
                    [
                        "e"
                    ]
                ],
                [
                    [
                        "n"
                    ],
                    [
                        "s"
                    ]
                ]
            ][xyIndex]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $91342d1cfa622c5a$var$getTrackEnds(localTrack);
            var min = $91342d1cfa622c5a$var$mathMin(ends[0][xyIndex], ends[1][xyIndex]);
            var max = $91342d1cfa622c5a$var$mathMax(ends[0][xyIndex], ends[1][xyIndex]);
            return [
                min,
                max
            ];
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            var otherExtent;
            // If brushWidth not specified, fit the panel.
            var panel = $91342d1cfa622c5a$var$getPanelByCover(controller, cover);
            if (panel !== $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
            else {
                var zr = controller._zr;
                otherExtent = [
                    0,
                    [
                        zr.getWidth(),
                        zr.getHeight()
                    ][1 - xyIndex]
                ];
            }
            var rectRange = [
                localRange,
                otherExtent
            ];
            xyIndex && rectRange.reverse();
            $91342d1cfa622c5a$var$updateBaseRect(controller, cover, rectRange, brushOption);
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    };
}
var $91342d1cfa622c5a$export$2e2bcd8739ae039 = $91342d1cfa622c5a$var$BrushController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect) {
    rect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(localPoints) {
        return $5b455ae6f843ac47$export$e2f409471bbbc1dc(localPoints, rect);
    };
}
function $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect, specifiedXYIndex) {
    rect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(xyIndex) {
        var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
        var brushWidth = idx ? rect.width : rect.height;
        var base = idx ? rect.x : rect.y;
        return [
            base,
            base + (brushWidth || 0)
        ];
    };
}
function $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, targetModel) {
    var boundingRect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(e, localCursorPoint) {
        return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, targetModel);
    };
}
// Consider width/height is negative.
function $d9c171f7dfe1f12f$var$normalizeRect(rect) {
    return (0, $1bebe7106c895823$export$2e2bcd8739ae039).create(rect);
}




var $90a4a8a0234865c7$var$elementList = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $90a4a8a0234865c7$var$ParallelAxisView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ParallelAxisView, _super);
    function ParallelAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisView.type;
        return _this;
    }
    ParallelAxisView.prototype.init = function(ecModel, api) {
        _super.prototype.init.apply(this, arguments);
        (this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr())).on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this));
    };
    ParallelAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        if ($90a4a8a0234865c7$var$fromAxisAreaSelect(axisModel, ecModel, payload)) return;
        this.axisModel = axisModel;
        this.api = api;
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get("show")) return;
        var coordSysModel = $90a4a8a0234865c7$var$getCoordSysModel(axisModel, ecModel);
        var coordSys = coordSysModel.coordinateSystem;
        var areaSelectStyle = axisModel.getAreaSelectStyle();
        var areaWidth = areaSelectStyle.width;
        var dim = axisModel.axis.dim;
        var axisLayout = coordSys.getAxisLayout(dim);
        var builderOpt = $7a1bd9c2710fea0d$export$8b58be045bf06082({
            strokeContainThreshold: areaWidth
        }, axisLayout);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, builderOpt);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($90a4a8a0234865c7$var$elementList, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
        $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
    };
    // /**
    //  * @override
    //  */
    // updateVisual(axisModel, ecModel, api, payload) {
    //     this._brushController && this._brushController
    //         .updateCovers(getCoverInfoList(axisModel));
    // }
    ParallelAxisView.prototype._refreshBrushController = function(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
        // After filtering, axis may change, select area needs to be update.
        var extent = axisModel.axis.getExtent();
        var extentLen = extent[1] - extent[0];
        var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
        // width/height might be negative, which will be
        // normalized in BoundingRect.
        var rect = $1bebe7106c895823$export$2e2bcd8739ae039.create({
            x: extent[0],
            y: -areaWidth / 2,
            width: extentLen,
            height: areaWidth
        });
        rect.x -= extra;
        rect.width += 2 * extra;
        this._brushController.mount({
            enableGlobalPan: true,
            rotation: builderOpt.rotation,
            x: builderOpt.position[0],
            y: builderOpt.position[1]
        }).setPanels([
            {
                panelId: "pl",
                clipPath: $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect),
                isTargetByCursor: $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, coordSysModel),
                getLinearBrushOtherExtent: $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect, 0)
            }
        ]).enableBrush({
            brushType: "lineX",
            brushStyle: areaSelectStyle,
            removeOnClick: true
        }).updateCovers($90a4a8a0234865c7$var$getCoverInfoList(axisModel));
    };
    ParallelAxisView.prototype._onBrush = function(eventParam) {
        var coverInfoList = eventParam.areas;
        // Do not cache these object, because the mey be changed.
        var axisModel = this.axisModel;
        var axis = axisModel.axis;
        var intervals = $7a1bd9c2710fea0d$export$871de8747c9eaa88(coverInfoList, function(coverInfo) {
            return [
                axis.coordToData(coverInfo.range[0], true),
                axis.coordToData(coverInfo.range[1], true)
            ];
        });
        // If realtime is true, action is not dispatched on drag end, because
        // the drag end emits the same params with the last drag move event,
        // and may have some delay when using touch pad.
        if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) // jshint ignore:line
        this.api.dispatchAction({
            type: "axisAreaSelect",
            parallelAxisId: axisModel.id,
            intervals: intervals
        });
    };
    ParallelAxisView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    ParallelAxisView.type = "parallelAxis";
    return ParallelAxisView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $90a4a8a0234865c7$var$fromAxisAreaSelect(axisModel, ecModel, payload) {
    return payload && payload.type === "axisAreaSelect" && ecModel.findComponents({
        mainType: "parallelAxis",
        query: payload
    })[0] === axisModel;
}
function $90a4a8a0234865c7$var$getCoverInfoList(axisModel) {
    var axis = axisModel.axis;
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(axisModel.activeIntervals, function(interval) {
        return {
            brushType: "lineX",
            panelId: "pl",
            range: [
                axis.dataToCoord(interval[0], true),
                axis.dataToCoord(interval[1], true)
            ]
        };
    });
}
function $90a4a8a0234865c7$var$getCoordSysModel(axisModel, ecModel) {
    return ecModel.getComponent("parallel", axisModel.get("parallelIndex"));
}
var $90a4a8a0234865c7$export$2e2bcd8739ae039 = $90a4a8a0234865c7$var$ParallelAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1c10e648a7cc8028$var$actionInfo = {
    type: "axisAreaSelect",
    event: "axisAreaSelected"
};
function $1c10e648a7cc8028$export$a97c1e0aa84f4f71(registers) {
    registers.registerAction($1c10e648a7cc8028$var$actionInfo, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "parallelAxis",
            query: payload
        }, function(parallelAxisModel) {
            parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
        });
    });
    /**
   * @payload
   */ registers.registerAction("parallelAxisExpand", function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "parallel",
            query: payload
        }, function(parallelModel) {
            parallelModel.setAxisExpand(payload);
        });
    });
}


var $462857bad733a944$var$defaultAxisOption = {
    type: "value",
    areaSelectStyle: {
        width: 20,
        borderWidth: 1,
        borderColor: "rgba(160,197,232)",
        color: "rgba(160,197,232)",
        opacity: 0.3
    },
    realtime: true,
    z: 10
};
function $462857bad733a944$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $ccce4513d4baec6a$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $a14d8e1511adaa1e$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("parallel", (0, $88531590cdbcfc26$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $30173db3404062fa$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $839a50fcb1c6f44b$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $90a4a8a0234865c7$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "parallel", (0, $839a50fcb1c6f44b$export$2e2bcd8739ae039), $462857bad733a944$var$defaultAxisOption);
    (0, $1c10e648a7cc8028$export$a97c1e0aa84f4f71)(registers);
}


function $4d1dc874f9d8653d$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $462857bad733a944$export$4b3e715f166fdd78));
    registers.registerChartView((0, $9e57680b9c04f083$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5d63691998e05817$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $8148e21d655f67c8$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $58364a2c82b0ec77$var$SankeyPathShape = /** @class */ function() {
    function SankeyPathShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.cpx2 = 0;
        this.cpy2 = 0;
        this.extent = 0;
    }
    return SankeyPathShape;
}();
var $58364a2c82b0ec77$var$SankeyPath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SankeyPath, _super);
    function SankeyPath(opts) {
        return _super.call(this, opts) || this;
    }
    SankeyPath.prototype.getDefaultShape = function() {
        return new $58364a2c82b0ec77$var$SankeyPathShape();
    };
    SankeyPath.prototype.buildPath = function(ctx, shape) {
        var extent = shape.extent;
        ctx.moveTo(shape.x1, shape.y1);
        ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
        if (shape.orient === "vertical") {
            ctx.lineTo(shape.x2 + extent, shape.y2);
            ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
        } else {
            ctx.lineTo(shape.x2, shape.y2 + extent);
            ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
        }
        ctx.closePath();
    };
    SankeyPath.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    SankeyPath.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    return SankeyPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $58364a2c82b0ec77$var$SankeyView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SankeyView, _super);
    function SankeyView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeyView.type;
        _this._focusAdjacencyDisabled = false;
        return _this;
    }
    SankeyView.prototype.render = function(seriesModel, ecModel, api) {
        var sankeyView = this;
        var graph = seriesModel.getGraph();
        var group = this.group;
        var layoutInfo = seriesModel.layoutInfo;
        // view width
        var width = layoutInfo.width;
        // view height
        var height = layoutInfo.height;
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getData("edge");
        var orient = seriesModel.get("orient");
        this._model = seriesModel;
        group.removeAll();
        group.x = layoutInfo.x;
        group.y = layoutInfo.y;
        // generate a bezire Curve for each edge
        graph.eachEdge(function(edge) {
            var curve = new $58364a2c82b0ec77$var$SankeyPath();
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(curve);
            ecData.dataIndex = edge.dataIndex;
            ecData.seriesIndex = seriesModel.seriesIndex;
            ecData.dataType = "edge";
            var edgeModel = edge.getModel();
            var lineStyleModel = edgeModel.getModel("lineStyle");
            var curvature = lineStyleModel.get("curveness");
            var n1Layout = edge.node1.getLayout();
            var node1Model = edge.node1.getModel();
            var dragX1 = node1Model.get("localX");
            var dragY1 = node1Model.get("localY");
            var n2Layout = edge.node2.getLayout();
            var node2Model = edge.node2.getModel();
            var dragX2 = node2Model.get("localX");
            var dragY2 = node2Model.get("localY");
            var edgeLayout = edge.getLayout();
            var x1;
            var y1;
            var x2;
            var y2;
            var cpx1;
            var cpy1;
            var cpx2;
            var cpy2;
            curve.shape.extent = Math.max(1, edgeLayout.dy);
            curve.shape.orient = orient;
            if (orient === "vertical") {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
                x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
                y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
                cpx1 = x1;
                cpy1 = y1 * (1 - curvature) + y2 * curvature;
                cpx2 = x2;
                cpy2 = y1 * curvature + y2 * (1 - curvature);
            } else {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
                x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
                y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
                cpx1 = x1 * (1 - curvature) + x2 * curvature;
                cpy1 = y1;
                cpx2 = x1 * curvature + x2 * (1 - curvature);
                cpy2 = y2;
            }
            curve.setShape({
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                cpx1: cpx1,
                cpy1: cpy1,
                cpx2: cpx2,
                cpy2: cpy2
            });
            curve.useStyle(lineStyleModel.getItemStyle());
            // Special color, use source node color or target node color
            $58364a2c82b0ec77$var$applyCurveStyle(curve.style, orient, edge);
            var defaultEdgeLabelText = "" + edgeModel.get("value");
            var edgeLabelStateModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(edgeModel, "edgeLabel");
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(curve, edgeLabelStateModels, {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, "edge", labelDimIndex, // ensure edgeLabel formatter is provided
                        // to prevent the inheritance from `label.formatter` of the series
                        (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(formatter, edgeLabelStateModels.normal && edgeLabelStateModels.normal.get("formatter"), defaultEdgeLabelText), extendParams);
                    }
                },
                labelDataIndex: edge.dataIndex,
                defaultText: defaultEdgeLabelText
            });
            curve.setTextConfig({
                position: "inside"
            });
            var emphasisModel = edgeModel.getModel("emphasis");
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(curve, edgeModel, "lineStyle", function(model) {
                var style = model.getItemStyle();
                $58364a2c82b0ec77$var$applyCurveStyle(style, orient, edge);
                return style;
            });
            group.add(curve);
            edgeData.setItemGraphicEl(edge.dataIndex, curve);
            var focus = emphasisModel.get("focus");
            (0, $2bf82c0980125b62$export$e51187539ff11209)(curve, focus === "adjacency" ? edge.getAdjacentDataIndices() : focus === "trajectory" ? edge.getTrajectoryDataIndices() : focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        // Generate a rect for each node
        graph.eachNode(function(node) {
            var layout = node.getLayout();
            var itemModel = node.getModel();
            var dragX = itemModel.get("localX");
            var dragY = itemModel.get("localY");
            var emphasisModel = itemModel.getModel("emphasis");
            var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: {
                    x: dragX != null ? dragX * width : layout.x,
                    y: dragY != null ? dragY * height : layout.y,
                    width: layout.dx,
                    height: layout.dy
                },
                style: itemModel.getModel("itemStyle").getItemStyle(),
                z2: 10
            });
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rect, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, "node");
                    }
                },
                labelDataIndex: node.dataIndex,
                defaultText: node.id
            });
            rect.disableLabelAnimation = true;
            rect.setStyle("fill", node.getVisual("color"));
            rect.setStyle("decal", node.getVisual("style").decal);
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(rect, itemModel);
            group.add(rect);
            nodeData.setItemGraphicEl(node.dataIndex, rect);
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(rect).dataType = "node";
            var focus = emphasisModel.get("focus");
            (0, $2bf82c0980125b62$export$e51187539ff11209)(rect, focus === "adjacency" ? node.getAdjacentDataIndices() : focus === "trajectory" ? node.getTrajectoryDataIndices() : focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        nodeData.eachItemGraphicEl(function(el, dataIndex) {
            var itemModel = nodeData.getItemModel(dataIndex);
            if (itemModel.get("draggable")) {
                el.drift = function(dx, dy) {
                    sankeyView._focusAdjacencyDisabled = true;
                    this.shape.x += dx;
                    this.shape.y += dy;
                    this.dirty();
                    api.dispatchAction({
                        type: "dragNode",
                        seriesId: seriesModel.id,
                        dataIndex: nodeData.getRawIndex(dataIndex),
                        localX: this.shape.x / width,
                        localY: this.shape.y / height
                    });
                };
                el.ondragend = function() {
                    sankeyView._focusAdjacencyDisabled = false;
                };
                el.draggable = true;
                el.cursor = "move";
            }
        });
        if (!this._data && seriesModel.isAnimationEnabled()) group.setClipPath($58364a2c82b0ec77$var$createGridClipShape(group.getBoundingRect(), seriesModel, function() {
            group.removeClipPath();
        }));
        this._data = seriesModel.getData();
    };
    SankeyView.prototype.dispose = function() {};
    SankeyView.type = "sankey";
    return SankeyView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
/**
 * Special color, use source node color or target node color
 * @param curveProps curve's style to parse
 * @param orient direction
 * @param edge current curve data
 */ function $58364a2c82b0ec77$var$applyCurveStyle(curveProps, orient, edge) {
    switch(curveProps.fill){
        case "source":
            curveProps.fill = edge.node1.getVisual("color");
            curveProps.decal = edge.node1.getVisual("style").decal;
            break;
        case "target":
            curveProps.fill = edge.node2.getVisual("color");
            curveProps.decal = edge.node2.getVisual("style").decal;
            break;
        case "gradient":
            var sourceColor = edge.node1.getVisual("color");
            var targetColor = edge.node2.getVisual("color");
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sourceColor) && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetColor)) curveProps.fill = new $cf44c01491b58e53$export$2e2bcd8739ae039(0, 0, +(orient === "horizontal"), +(orient === "vertical"), [
                {
                    color: sourceColor,
                    offset: 0
                },
                {
                    color: targetColor,
                    offset: 1
                }
            ]);
    }
}
// Add animation to the view
function $58364a2c82b0ec77$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $58364a2c82b0ec77$export$2e2bcd8739ae039 = $58364a2c82b0ec77$var$SankeyView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $f213d63e219306d2$var$SankeySeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SankeySeriesModel, _super);
    function SankeySeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeySeriesModel.type;
        return _this;
    }
    /**
   * Init a graph data structure from data in option series
   */ SankeySeriesModel.prototype.getInitialData = function(option, ecModel) {
        var links = option.edges || option.links;
        var nodes = option.data || option.nodes;
        var levels = option.levels;
        this.levelModels = [];
        var levelModels = this.levelModels;
        for(var i = 0; i < levels.length; i++)if (levels[i].depth != null && levels[i].depth >= 0) levelModels[levels[i].depth] = new (0, $6818646a97528290$export$2e2bcd8739ae039)(levels[i], this, ecModel);
        if (nodes && links) {
            var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, links, this, true, beforeLink);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var seriesModel = model.parentModel;
                var layout = seriesModel.getData().getItemLayout(idx);
                if (layout) {
                    var nodeDepth = layout.depth;
                    var levelModel = seriesModel.levelModels[nodeDepth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
            edgeData.wrapMethod("getItemModel", function(model, idx) {
                var seriesModel = model.parentModel;
                var edge = seriesModel.getGraph().getEdgeByIndex(idx);
                var layout = edge.node1.getLayout();
                if (layout) {
                    var depth = layout.depth;
                    var levelModel = seriesModel.levelModels[depth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
        }
    };
    SankeySeriesModel.prototype.setNodePosition = function(dataIndex, localPosition) {
        var nodes = this.option.data || this.option.nodes;
        var dataItem = nodes[dataIndex];
        dataItem.localX = localPosition[0];
        dataItem.localY = localPosition[1];
    };
    /**
   * Return the graphic data structure
   *
   * @return graphic data structure
   */ SankeySeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    /**
   * Get edge data of graphic data structure
   *
   * @return data structure of list
   */ SankeySeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    SankeySeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        function noValue(val) {
            return isNaN(val) || val == null;
        }
        // dataType === 'node' or empty do not show tooltip by default
        if (dataType === "edge") {
            var params = this.getDataParams(dataIndex, dataType);
            var rawDataOpt = params.data;
            var edgeValue = params.value;
            var edgeName = rawDataOpt.source + " -- " + rawDataOpt.target;
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: edgeName,
                value: edgeValue,
                noValue: noValue(edgeValue)
            });
        } else {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var value = node.getLayout().value;
            var name_1 = this.getDataParams(dataIndex, dataType).data.name;
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: name_1 != null ? name_1 + "" : null,
                value: value,
                noValue: noValue(value)
            });
        }
    };
    SankeySeriesModel.prototype.optionUpdated = function() {};
    // Override Series.getDataParams()
    SankeySeriesModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        if (params.value == null && dataType === "node") {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var nodeValue = node.getLayout().value;
            params.value = nodeValue;
        }
        return params;
    };
    SankeySeriesModel.type = "series.sankey";
    SankeySeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        left: "5%",
        top: "5%",
        right: "20%",
        bottom: "5%",
        orient: "horizontal",
        nodeWidth: 20,
        nodeGap: 8,
        draggable: true,
        layoutIterations: 32,
        label: {
            show: true,
            position: "right",
            fontSize: 12
        },
        edgeLabel: {
            show: false,
            fontSize: 12
        },
        levels: [],
        nodeAlign: "justify",
        lineStyle: {
            color: "#314656",
            opacity: 0.2,
            curveness: 0.5
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                opacity: 0.5
            }
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        },
        animationEasing: "linear",
        animationDuration: 1000
    };
    return SankeySeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $f213d63e219306d2$export$2e2bcd8739ae039 = $f213d63e219306d2$var$SankeySeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $b2e36df99c285454$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("sankey", function(seriesModel) {
        var nodeWidth = seriesModel.get("nodeWidth");
        var nodeGap = seriesModel.get("nodeGap");
        var layoutInfo = $b2e36df99c285454$var$getViewRect(seriesModel, api);
        seriesModel.layoutInfo = layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        $b2e36df99c285454$var$computeNodeValues(nodes);
        var filteredNodes = $7a1bd9c2710fea0d$export$3dea766d36a8935f(nodes, function(node) {
            return node.getLayout().value === 0;
        });
        var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get("layoutIterations");
        var orient = seriesModel.get("orient");
        var nodeAlign = seriesModel.get("nodeAlign");
        $b2e36df99c285454$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
    });
}
/**
 * Get the layout position of the whole view
 */ function $b2e36df99c285454$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $b2e36df99c285454$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
    $b2e36df99c285454$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
    $b2e36df99c285454$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
    $b2e36df99c285454$var$computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 */ function $b2e36df99c285454$var$computeNodeValues(nodes) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var value1 = $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$getEdgeValue);
        var value2 = $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$getEdgeValue);
        var nodeRawValue = node.getValue() || 0;
        var value = Math.max(value1, value2, nodeRawValue);
        node.setLayout({
            value: value
        }, true);
    });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 */ function $b2e36df99c285454$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
    // Used to mark whether the edge is deleted. if it is deleted,
    // the value is 0, otherwise it is 1.
    var remainEdges = [];
    // Storage each node's indegree.
    var indegreeArr = [];
    // Used to storage the node with indegree is equal to 0.
    var zeroIndegrees = [];
    var nextTargetNode = [];
    var x = 0;
    // let kx = 0;
    for(var i = 0; i < edges.length; i++)remainEdges[i] = 1;
    for(var i = 0; i < nodes.length; i++){
        indegreeArr[i] = nodes[i].inEdges.length;
        if (indegreeArr[i] === 0) zeroIndegrees.push(nodes[i]);
    }
    var maxNodeDepth = -1;
    // Traversing nodes using topological sorting to calculate the
    // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
    // position of the nodes.
    while(zeroIndegrees.length){
        for(var idx = 0; idx < zeroIndegrees.length; idx++){
            var node = zeroIndegrees[idx];
            var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
            var isItemDepth = item.depth != null && item.depth >= 0;
            if (isItemDepth && item.depth > maxNodeDepth) maxNodeDepth = item.depth;
            node.setLayout({
                depth: isItemDepth ? item.depth : x
            }, true);
            orient === "vertical" ? node.setLayout({
                dy: nodeWidth
            }, true) : node.setLayout({
                dx: nodeWidth
            }, true);
            for(var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++){
                var edge = node.outEdges[edgeIdx];
                var indexEdge = edges.indexOf(edge);
                remainEdges[indexEdge] = 0;
                var targetNode = edge.node2;
                var nodeIndex = nodes.indexOf(targetNode);
                if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) nextTargetNode.push(targetNode);
            }
        }
        ++x;
        zeroIndegrees = nextTargetNode;
        nextTargetNode = [];
    }
    for(var i = 0; i < remainEdges.length; i++){
        if (remainEdges[i] === 1) throw new Error("Sankey is a DAG, the original data has cycle!");
    }
    var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
    if (nodeAlign && nodeAlign !== "left") $b2e36df99c285454$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
    var kx = orient === "vertical" ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
    $b2e36df99c285454$var$scaleNodeBreadths(nodes, kx, orient);
}
function $b2e36df99c285454$var$isNodeDepth(node) {
    var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
    return item.depth != null && item.depth >= 0;
}
function $b2e36df99c285454$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
    if (nodeAlign === "right") {
        var nextSourceNode = [];
        var remainNodes = nodes;
        var nodeHeight = 0;
        while(remainNodes.length){
            for(var i = 0; i < remainNodes.length; i++){
                var node = remainNodes[i];
                node.setLayout({
                    skNodeHeight: nodeHeight
                }, true);
                for(var j = 0; j < node.inEdges.length; j++){
                    var edge = node.inEdges[j];
                    if (nextSourceNode.indexOf(edge.node1) < 0) nextSourceNode.push(edge.node1);
                }
            }
            remainNodes = nextSourceNode;
            nextSourceNode = [];
            ++nodeHeight;
        }
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (!$b2e36df99c285454$var$isNodeDepth(node)) node.setLayout({
                depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
            }, true);
        });
    } else if (nodeAlign === "justify") $b2e36df99c285454$var$moveSinksRight(nodes, maxDepth);
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param nodes.  node of sankey view.
 * @param maxDepth.  use to assign to node without outEdges as x-position.
 */ function $b2e36df99c285454$var$moveSinksRight(nodes, maxDepth) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        if (!$b2e36df99c285454$var$isNodeDepth(node) && !node.outEdges.length) node.setLayout({
            depth: maxDepth
        }, true);
    });
}
/**
 * Scale node x-position to the width
 *
 * @param nodes  node of sankey view
 * @param kx   multiple used to scale nodes
 */ function $b2e36df99c285454$var$scaleNodeBreadths(nodes, kx, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var nodeDepth = node.getLayout().depth * kx;
        orient === "vertical" ? node.setLayout({
            y: nodeDepth
        }, true) : node.setLayout({
            x: nodeDepth
        }, true);
    });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param nodes  node of sankey view
 * @param edges  edge of sankey view
 * @param height  the whole height of the area to draw the view
 * @param nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param iterations  the number of iterations for the algorithm
 */ function $b2e36df99c285454$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
    var nodesByBreadth = $b2e36df99c285454$var$prepareNodesByBreadth(nodes, orient);
    $b2e36df99c285454$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
    $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    for(var alpha = 1; iterations > 0; iterations--){
        // 0.99 is a experience parameter, ensure that each iterations of
        // changes as small as possible.
        alpha *= 0.99;
        $b2e36df99c285454$var$relaxRightToLeft(nodesByBreadth, alpha, orient);
        $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
        $b2e36df99c285454$var$relaxLeftToRight(nodesByBreadth, alpha, orient);
        $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    }
}
function $b2e36df99c285454$var$prepareNodesByBreadth(nodes, orient) {
    var nodesByBreadth = [];
    var keyAttr = orient === "vertical" ? "y" : "x";
    var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(nodes, function(node) {
        return node.getLayout()[keyAttr];
    });
    groupResult.keys.sort(function(a, b) {
        return a - b;
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(groupResult.keys, function(key) {
        nodesByBreadth.push(groupResult.buckets.get(key));
    });
    return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 */ function $b2e36df99c285454$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
    var minKy = Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        var n = nodes.length;
        var sum = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            sum += node.getLayout().value;
        });
        var ky = orient === "vertical" ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
        if (ky < minKy) minKy = ky;
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node, i) {
            var nodeDy = node.getLayout().value * minKy;
            if (orient === "vertical") {
                node.setLayout({
                    x: i
                }, true);
                node.setLayout({
                    dx: nodeDy
                }, true);
            } else {
                node.setLayout({
                    y: i
                }, true);
                node.setLayout({
                    dy: nodeDy
                }, true);
            }
        });
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(edges, function(edge) {
        var edgeDy = +edge.getValue() * minKy;
        edge.setLayout({
            dy: edgeDy
        }, true);
    });
}
/**
 * Resolve the collision of initialized depth (y-position)
 */ function $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
    var keyAttr = orient === "vertical" ? "x" : "y";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        nodes.sort(function(a, b) {
            return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
        });
        var nodeX;
        var node;
        var dy;
        var y0 = 0;
        var n = nodes.length;
        var nodeDyAttr = orient === "vertical" ? "dx" : "dy";
        for(var i = 0; i < n; i++){
            node = nodes[i];
            dy = y0 - node.getLayout()[keyAttr];
            if (dy > 0) {
                nodeX = node.getLayout()[keyAttr] + dy;
                orient === "vertical" ? node.setLayout({
                    x: nodeX
                }, true) : node.setLayout({
                    y: nodeX
                }, true);
            }
            y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
        }
        var viewWidth = orient === "vertical" ? width : height;
        // If the bottommost node goes outside the bounds, push it back up
        dy = y0 - nodeGap - viewWidth;
        if (dy > 0) {
            nodeX = node.getLayout()[keyAttr] - dy;
            orient === "vertical" ? node.setLayout({
                x: nodeX
            }, true) : node.setLayout({
                y: nodeX
            }, true);
            y0 = nodeX;
            for(var i = n - 2; i >= 0; --i){
                node = nodes[i];
                dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
                if (dy > 0) {
                    nodeX = node.getLayout()[keyAttr] - dy;
                    orient === "vertical" ? node.setLayout({
                        x: nodeX
                    }, true) : node.setLayout({
                        y: nodeX
                    }, true);
                }
                y0 = node.getLayout()[keyAttr];
            }
        }
    });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 * @param nodesByBreadth
 * @param alpha  parameter used to adjust the nodes y-position
 */ function $b2e36df99c285454$var$relaxRightToLeft(nodesByBreadth, alpha, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth.slice().reverse(), function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (node.outEdges.length) {
                var y = $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$weightedTarget, orient) / $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.outEdges.length;
                    y = len ? $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$centerTarget, orient) / len : 0;
                }
                if (orient === "vertical") {
                    var nodeX = node.getLayout().x + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
function $b2e36df99c285454$var$weightedTarget(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node2, orient) * edge.getValue();
}
function $b2e36df99c285454$var$centerTarget(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node2, orient);
}
function $b2e36df99c285454$var$weightedSource(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node1, orient) * edge.getValue();
}
function $b2e36df99c285454$var$centerSource(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node1, orient);
}
function $b2e36df99c285454$var$center(node, orient) {
    return orient === "vertical" ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}
function $b2e36df99c285454$var$getEdgeValue(edge) {
    return edge.getValue();
}
function $b2e36df99c285454$var$sum(array, cb, orient) {
    var sum = 0;
    var len = array.length;
    var i = -1;
    while(++i < len){
        var value = +cb(array[i], orient);
        if (!isNaN(value)) sum += value;
    }
    return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 */ function $b2e36df99c285454$var$relaxLeftToRight(nodesByBreadth, alpha, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (node.inEdges.length) {
                var y = $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$weightedSource, orient) / $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.inEdges.length;
                    y = len ? $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$centerSource, orient) / len : 0;
                }
                if (orient === "vertical") {
                    var nodeX = node.getLayout().x + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
/**
 * Compute the depth(y-position) of each edge
 */ function $b2e36df99c285454$var$computeEdgeDepths(nodes, orient) {
    var keyAttr = orient === "vertical" ? "x" : "y";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        node.outEdges.sort(function(a, b) {
            return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
        });
        node.inEdges.sort(function(a, b) {
            return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
        });
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var sy = 0;
        var ty = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.outEdges, function(edge) {
            edge.setLayout({
                sy: sy
            }, true);
            sy += edge.getLayout().dy;
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.inEdges, function(edge) {
            edge.setLayout({
                ty: ty
            }, true);
            ty += edge.getLayout().dy;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $5379d5704c92d7dd$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("sankey", function(seriesModel) {
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        if (nodes.length) {
            var minValue_1 = Infinity;
            var maxValue_1 = -Infinity;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
                var nodeValue = node.getLayout().value;
                if (nodeValue < minValue_1) minValue_1 = nodeValue;
                if (nodeValue > maxValue_1) maxValue_1 = nodeValue;
            });
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
                var mapping = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)({
                    type: "color",
                    mappingMethod: "linear",
                    dataExtent: [
                        minValue_1,
                        maxValue_1
                    ],
                    visual: seriesModel.get("color")
                });
                var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
                var customColor = node.getModel().get([
                    "itemStyle",
                    "color"
                ]);
                if (customColor != null) {
                    node.setVisual("color", customColor);
                    node.setVisual("style", {
                        fill: customColor
                    });
                } else {
                    node.setVisual("color", mapValueToColor);
                    node.setVisual("style", {
                        fill: mapValueToColor
                    });
                }
            });
        }
        if (edges.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(edges, function(edge) {
            var edgeStyle = edge.getModel().get("lineStyle");
            edge.setVisual("style", edgeStyle);
        });
    });
}


function $2439b31c49c21b38$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $58364a2c82b0ec77$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f213d63e219306d2$export$2e2bcd8739ae039));
    registers.registerLayout((0, $b2e36df99c285454$export$2e2bcd8739ae039));
    registers.registerVisual((0, $5379d5704c92d7dd$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "dragNode",
        event: "dragnode",
        // here can only use 'update' now, other value is not support in echarts.
        update: "update"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "sankey",
            query: payload
        }, function(seriesModel) {
            seriesModel.setNodePosition(payload.dataIndex, [
                payload.localX,
                payload.localY
            ]);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $29bc1fc21a5243a6$export$ccfed902f8630510 = /** @class */ function() {
    function WhiskerBoxCommonMixin() {}
    /**
   * @override
   */ WhiskerBoxCommonMixin.prototype.getInitialData = function(option, ecModel) {
        // When both types of xAxis and yAxis are 'value', layout is
        // needed to be specified by user. Otherwise, layout can be
        // judged by which axis is category.
        var ordinalMeta;
        var xAxisModel = ecModel.getComponent("xAxis", this.get("xAxisIndex"));
        var yAxisModel = ecModel.getComponent("yAxis", this.get("yAxisIndex"));
        var xAxisType = xAxisModel.get("type");
        var yAxisType = yAxisModel.get("type");
        var addOrdinal;
        // FIXME
        // Consider time axis.
        if (xAxisType === "category") {
            option.layout = "horizontal";
            ordinalMeta = xAxisModel.getOrdinalMeta();
            addOrdinal = true;
        } else if (yAxisType === "category") {
            option.layout = "vertical";
            ordinalMeta = yAxisModel.getOrdinalMeta();
            addOrdinal = true;
        } else option.layout = option.layout || "horizontal";
        var coordDims = [
            "x",
            "y"
        ];
        var baseAxisDimIndex = option.layout === "horizontal" ? 0 : 1;
        var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
        var otherAxisDim = coordDims[1 - baseAxisDimIndex];
        var axisModels = [
            xAxisModel,
            yAxisModel
        ];
        var baseAxisType = axisModels[baseAxisDimIndex].get("type");
        var otherAxisType = axisModels[1 - baseAxisDimIndex].get("type");
        var data = option.data;
        // Clone a new data for next setOption({}) usage.
        // Avoid modifying current data will affect further update.
        if (data && addOrdinal) {
            var newOptionData_1 = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(item, index) {
                var newItem;
                if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(item)) {
                    newItem = item.slice();
                    // Modify current using data.
                    item.unshift(index);
                } else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(item.value)) {
                    newItem = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, item);
                    newItem.value = newItem.value.slice();
                    // Modify current using data.
                    item.value.unshift(index);
                } else newItem = item;
                newOptionData_1.push(newItem);
            });
            option.data = newOptionData_1;
        }
        var defaultValueDimensions = this.defaultValueDimensions;
        var coordDimensions = [
            {
                name: baseAxisDim,
                type: (0, $18085de91ae59d03$export$af1622903e71278e)(baseAxisType),
                ordinalMeta: ordinalMeta,
                otherDims: {
                    tooltip: false,
                    itemName: 0
                },
                dimsDef: [
                    "base"
                ]
            },
            {
                name: otherAxisDim,
                type: (0, $18085de91ae59d03$export$af1622903e71278e)(otherAxisType),
                dimsDef: defaultValueDimensions.slice()
            }
        ];
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: coordDimensions,
            dimensionsCount: defaultValueDimensions.length + 1,
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$37682b8fdd2e83d), coordDimensions, this)
        });
    };
    /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */ WhiskerBoxCommonMixin.prototype.getBaseAxis = function() {
        var dim = this._baseAxisDim;
        return this.ecModel.getComponent(dim + "Axis", this.get(dim + "AxisIndex")).axis;
    };
    return WhiskerBoxCommonMixin;
}();



var $de6da9192b0ee4cb$var$BoxplotSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BoxplotSeriesModel, _super);
    function BoxplotSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotSeriesModel.type;
        // TODO
        // box width represents group size, so dimension should have 'size'.
        /**
     * @see <https://en.wikipedia.org/wiki/Box_plot>
     * The meanings of 'min' and 'max' depend on user,
     * and echarts do not need to know it.
     * @readOnly
     */ _this.defaultValueDimensions = [
            {
                name: "min",
                defaultTooltip: true
            },
            {
                name: "Q1",
                defaultTooltip: true
            },
            {
                name: "median",
                defaultTooltip: true
            },
            {
                name: "Q3",
                defaultTooltip: true
            },
            {
                name: "max",
                defaultTooltip: true
            }
        ];
        _this.visualDrawType = "stroke";
        return _this;
    }
    BoxplotSeriesModel.type = "series.boxplot";
    BoxplotSeriesModel.dependencies = [
        "xAxis",
        "yAxis",
        "grid"
    ];
    BoxplotSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        layout: null,
        boxWidth: [
            7,
            50
        ],
        itemStyle: {
            color: "#fff",
            borderWidth: 1
        },
        emphasis: {
            scale: true,
            itemStyle: {
                borderWidth: 2,
                shadowBlur: 5,
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowColor: "rgba(0,0,0,0.2)"
            }
        },
        animationDuration: 800
    };
    return BoxplotSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($de6da9192b0ee4cb$var$BoxplotSeriesModel, (0, $29bc1fc21a5243a6$export$ccfed902f8630510), true);
var $de6da9192b0ee4cb$export$2e2bcd8739ae039 = $de6da9192b0ee4cb$var$BoxplotSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $4f6c4593265afb0c$var$BoxplotView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BoxplotView, _super);
    function BoxplotView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotView.type;
        return _this;
    }
    BoxplotView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var group = this.group;
        var oldData = this._data;
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        var constDim = seriesModel.get("layout") === "horizontal" ? 1 : 0;
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                var symbolEl = $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, newIdx, constDim, true);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(symbolEl);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (!symbolEl) symbolEl = $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, newIdx, constDim);
            else {
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(symbolEl);
                $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
            }
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    BoxplotView.prototype.remove = function(ecModel) {
        var group = this.group;
        var data = this._data;
        this._data = null;
        data && data.eachItemGraphicEl(function(el) {
            el && group.remove(el);
        });
    };
    BoxplotView.type = "boxplot";
    return BoxplotView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $4f6c4593265afb0c$var$BoxPathShape = /** @class */ function() {
    function BoxPathShape() {}
    return BoxPathShape;
}();
var $4f6c4593265afb0c$var$BoxPath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BoxPath, _super);
    function BoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "boxplotBoxPath";
        return _this;
    }
    BoxPath.prototype.getDefaultShape = function() {
        return new $4f6c4593265afb0c$var$BoxPathShape();
    };
    BoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        var i = 0;
        ctx.moveTo(ends[i][0], ends[i][1]);
        i++;
        for(; i < 4; i++)ctx.lineTo(ends[i][0], ends[i][1]);
        ctx.closePath();
        for(; i < ends.length; i++){
            ctx.moveTo(ends[i][0], ends[i][1]);
            i++;
            ctx.lineTo(ends[i][0], ends[i][1]);
        }
    };
    return BoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
    var ends = itemLayout.ends;
    var el = new $4f6c4593265afb0c$var$BoxPath({
        shape: {
            points: isInit ? $4f6c4593265afb0c$var$transInit(ends, constDim, itemLayout) : ends
        }
    });
    $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
    return el;
}
function $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
    var seriesModel = data.hostModel;
    var updateMethod = $5b455ae6f843ac47$exports[isInit ? "initProps" : "updateProps"];
    updateMethod(el, {
        shape: {
            points: itemLayout.ends
        }
    }, seriesModel, dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.strokeNoScale = true;
    el.z2 = 100;
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel("emphasis");
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
}
function $4f6c4593265afb0c$var$transInit(points, dim, itemLayout) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[dim] = itemLayout.initBaseline;
        return point;
    });
}
var $4f6c4593265afb0c$export$2e2bcd8739ae039 = $4f6c4593265afb0c$var$BoxplotView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $aa15a3e67343392c$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $aa15a3e67343392c$export$2e2bcd8739ae039(ecModel) {
    var groupResult = $aa15a3e67343392c$var$groupSeriesByAxis(ecModel);
    $aa15a3e67343392c$var$each(groupResult, function(groupItem) {
        var seriesModels = groupItem.seriesModels;
        if (!seriesModels.length) return;
        $aa15a3e67343392c$var$calculateBase(groupItem);
        $aa15a3e67343392c$var$each(seriesModels, function(seriesModel, idx) {
            $aa15a3e67343392c$var$layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
        });
    });
}
/**
 * Group series by axis.
 */ function $aa15a3e67343392c$var$groupSeriesByAxis(ecModel) {
    var result = [];
    var axisList = [];
    ecModel.eachSeriesByType("boxplot", function(seriesModel) {
        var baseAxis = seriesModel.getBaseAxis();
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(axisList, baseAxis);
        if (idx < 0) {
            idx = axisList.length;
            axisList[idx] = baseAxis;
            result[idx] = {
                axis: baseAxis,
                seriesModels: []
            };
        }
        result[idx].seriesModels.push(seriesModel);
    });
    return result;
}
/**
 * Calculate offset and box width for each series.
 */ function $aa15a3e67343392c$var$calculateBase(groupItem) {
    var baseAxis = groupItem.axis;
    var seriesModels = groupItem.seriesModels;
    var seriesCount = seriesModels.length;
    var boxWidthList = groupItem.boxWidthList = [];
    var boxOffsetList = groupItem.boxOffsetList = [];
    var boundList = [];
    var bandWidth;
    if (baseAxis.type === "category") bandWidth = baseAxis.getBandWidth();
    else {
        var maxDataCount_1 = 0;
        $aa15a3e67343392c$var$each(seriesModels, function(seriesModel) {
            maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
        });
        var extent = baseAxis.getExtent();
        bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
    }
    $aa15a3e67343392c$var$each(seriesModels, function(seriesModel) {
        var boxWidthBound = seriesModel.get("boxWidth");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(boxWidthBound)) boxWidthBound = [
            boxWidthBound,
            boxWidthBound
        ];
        boundList.push([
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(boxWidthBound[0], bandWidth) || 0,
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(boxWidthBound[1], bandWidth) || 0
        ]);
    });
    var availableWidth = bandWidth * 0.8 - 2;
    var boxGap = availableWidth / seriesCount * 0.3;
    var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
    var base = boxWidth / 2 - availableWidth / 2;
    $aa15a3e67343392c$var$each(seriesModels, function(seriesModel, idx) {
        boxOffsetList.push(base);
        base += boxGap + boxWidth;
        boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
    });
}
/**
 * Calculate points location for each series.
 */ function $aa15a3e67343392c$var$layoutSingleSeries(seriesModel, offset, boxWidth) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var halfWidth = boxWidth / 2;
    var cDimIdx = seriesModel.get("layout") === "horizontal" ? 0 : 1;
    var vDimIdx = 1 - cDimIdx;
    var coordDims = [
        "x",
        "y"
    ];
    var cDim = data.mapDimension(coordDims[cDimIdx]);
    var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);
    if (cDim == null || vDims.length < 5) return;
    for(var dataIndex = 0; dataIndex < data.count(); dataIndex++){
        var axisDimVal = data.get(cDim, dataIndex);
        var median = getPoint(axisDimVal, vDims[2], dataIndex);
        var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
        var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
        var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
        var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
        var ends = [];
        addBodyEnd(ends, end2, false);
        addBodyEnd(ends, end4, true);
        ends.push(end1, end2, end5, end4);
        layEndLine(ends, end1);
        layEndLine(ends, end5);
        layEndLine(ends, median);
        data.setItemLayout(dataIndex, {
            initBaseline: median[vDimIdx],
            ends: ends
        });
    }
    function getPoint(axisDimVal, dim, dataIndex) {
        var val = data.get(dim, dataIndex);
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        var point;
        if (isNaN(axisDimVal) || isNaN(val)) point = [
            NaN,
            NaN
        ];
        else {
            point = coordSys.dataToPoint(p);
            point[cDimIdx] += offset;
        }
        return point;
    }
    function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] += halfWidth;
        point2[cDimIdx] -= halfWidth;
        start ? ends.push(point1, point2) : ends.push(point2, point1);
    }
    function layEndLine(ends, endCenter) {
        var from = endCenter.slice();
        var to = endCenter.slice();
        from[cDimIdx] -= halfWidth;
        to[cDimIdx] += halfWidth;
        ends.push(from, to);
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a9247e275753b379$export$2e2bcd8739ae039(rawData, opt) {
    opt = opt || {};
    var boxData = [];
    var outliers = [];
    var boundIQR = opt.boundIQR;
    var useExtreme = boundIQR === "none" || boundIQR === 0;
    for(var i = 0; i < rawData.length; i++){
        var ascList = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(rawData[i].slice());
        var Q1 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.25);
        var Q2 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.5);
        var Q3 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.75);
        var min = ascList[0];
        var max = ascList[ascList.length - 1];
        var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
        var low = useExtreme ? min : Math.max(min, Q1 - bound);
        var high = useExtreme ? max : Math.min(max, Q3 + bound);
        var itemNameFormatter = opt.itemNameFormatter;
        var itemName = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(itemNameFormatter) ? itemNameFormatter({
            value: i
        }) : (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(itemNameFormatter) ? itemNameFormatter.replace("{value}", i + "") : i + "";
        boxData.push([
            itemName,
            low,
            Q1,
            Q2,
            Q3,
            high
        ]);
        for(var j = 0; j < ascList.length; j++){
            var dataItem = ascList[j];
            if (dataItem < low || dataItem > high) {
                var outlier = [
                    itemName,
                    dataItem
                ];
                outliers.push(outlier);
            }
        }
    }
    return {
        boxData: boxData,
        outliers: outliers
    };
}




var $9203fc6e2b112614$export$e0915fae26dedefc = {
    type: "echarts:boxplot",
    transform: function transform(params) {
        var upstream = params.upstream;
        if (upstream.sourceFormat !== (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        var result = (0, $a9247e275753b379$export$2e2bcd8739ae039)(upstream.getRawData(), params.config);
        return [
            {
                dimensions: [
                    "ItemName",
                    "Low",
                    "Q1",
                    "Q2",
                    "Q3",
                    "High"
                ],
                data: result.boxData
            },
            {
                data: result.outliers
            }
        ];
    }
};


function $0fd6296850ce3099$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $de6da9192b0ee4cb$export$2e2bcd8739ae039));
    registers.registerChartView((0, $4f6c4593265afb0c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $aa15a3e67343392c$export$2e2bcd8739ae039));
    registers.registerTransform((0, $9203fc6e2b112614$export$e0915fae26dedefc));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $74dcd5b9be05016d$var$SKIP_PROPS = [
    "color",
    "borderColor"
];
var $74dcd5b9be05016d$var$CandlestickView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CandlestickView, _super);
    function CandlestickView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickView.type;
        return _this;
    }
    CandlestickView.prototype.render = function(seriesModel, ecModel, api) {
        // If there is clipPath created in large mode. Remove it.
        this.group.removeClipPath();
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this._updateDrawMode(seriesModel);
        this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
    };
    CandlestickView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._clear();
        this._updateDrawMode(seriesModel);
    };
    CandlestickView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        this._progressiveEls = [];
        this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
    };
    CandlestickView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CandlestickView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    CandlestickView.prototype._renderNormal = function(seriesModel) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var isSimpleBox = data.getLayout("isSimpleBox");
        var needsClip = seriesModel.get("clip", true);
        var coord = seriesModel.coordinateSystem;
        var clipArea = coord.getArea && coord.getArea();
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                if (needsClip && $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout)) return;
                var el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, newIdx, true);
                $8b353638fbedfefa$export$a121566aadcfe021(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                $74dcd5b9be05016d$var$setBoxCommon(el, data, newIdx, isSimpleBox);
                group.add(el);
                data.setItemGraphicEl(newIdx, el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(el);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (needsClip && $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout)) {
                group.remove(el);
                return;
            }
            if (!el) el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, newIdx);
            else {
                $8b353638fbedfefa$export$c8dce3c08436e91e(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            }
            $74dcd5b9be05016d$var$setBoxCommon(el, data, newIdx, isSimpleBox);
            group.add(el);
            data.setItemGraphicEl(newIdx, el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    CandlestickView.prototype._renderLarge = function(seriesModel) {
        this._clear();
        $74dcd5b9be05016d$var$createLarge(seriesModel, this.group);
        var clipPath = seriesModel.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    };
    CandlestickView.prototype._incrementalRenderNormal = function(params, seriesModel) {
        var data = seriesModel.getData();
        var isSimpleBox = data.getLayout("isSimpleBox");
        var dataIndex;
        while((dataIndex = params.next()) != null){
            var itemLayout = data.getItemLayout(dataIndex);
            var el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, dataIndex);
            $74dcd5b9be05016d$var$setBoxCommon(el, data, dataIndex, isSimpleBox);
            el.incremental = true;
            this.group.add(el);
            this._progressiveEls.push(el);
        }
    };
    CandlestickView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        $74dcd5b9be05016d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    CandlestickView.prototype.remove = function(ecModel) {
        this._clear();
    };
    CandlestickView.prototype._clear = function() {
        this.group.removeAll();
        this._data = null;
    };
    CandlestickView.type = "candlestick";
    return CandlestickView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $74dcd5b9be05016d$var$NormalBoxPathShape = /** @class */ function() {
    function NormalBoxPathShape() {}
    return NormalBoxPathShape;
}();
var $74dcd5b9be05016d$var$NormalBoxPath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(NormalBoxPath, _super);
    function NormalBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "normalCandlestickBox";
        return _this;
    }
    NormalBoxPath.prototype.getDefaultShape = function() {
        return new $74dcd5b9be05016d$var$NormalBoxPathShape();
    };
    NormalBoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        if (this.__simpleBox) {
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[6][0], ends[6][1]);
        } else {
            ctx.moveTo(ends[0][0], ends[0][1]);
            ctx.lineTo(ends[1][0], ends[1][1]);
            ctx.lineTo(ends[2][0], ends[2][1]);
            ctx.lineTo(ends[3][0], ends[3][1]);
            ctx.closePath();
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[5][0], ends[5][1]);
            ctx.moveTo(ends[6][0], ends[6][1]);
            ctx.lineTo(ends[7][0], ends[7][1]);
        }
    };
    return NormalBoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $74dcd5b9be05016d$var$createNormalBox(itemLayout, dataIndex, isInit) {
    var ends = itemLayout.ends;
    return new $74dcd5b9be05016d$var$NormalBoxPath({
        shape: {
            points: isInit ? $74dcd5b9be05016d$var$transInit(ends, itemLayout) : ends
        },
        z2: 100
    });
}
function $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout) {
    var clipped = true;
    for(var i = 0; i < itemLayout.ends.length; i++)// If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
        clipped = false;
        break;
    }
    return clipped;
}
function $74dcd5b9be05016d$var$setBoxCommon(el, data, dataIndex, isSimpleBox) {
    var itemModel = data.getItemModel(dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.strokeNoScale = true;
    el.__simpleBox = isSimpleBox;
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
}
function $74dcd5b9be05016d$var$transInit(points, itemLayout) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[1] = itemLayout.initBaseline;
        return point;
    });
}
var $74dcd5b9be05016d$var$LargeBoxPathShape = /** @class */ function() {
    function LargeBoxPathShape() {}
    return LargeBoxPathShape;
}();
var $74dcd5b9be05016d$var$LargeBoxPath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LargeBoxPath, _super);
    function LargeBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "largeCandlestickBox";
        return _this;
    }
    LargeBoxPath.prototype.getDefaultShape = function() {
        return new $74dcd5b9be05016d$var$LargeBoxPathShape();
    };
    LargeBoxPath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        for(var i = 0; i < points.length;)if (this.__sign === points[i++]) {
            var x = points[i++];
            ctx.moveTo(x, points[i++]);
            ctx.lineTo(x, points[i++]);
        } else i += 3;
    };
    return LargeBoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $74dcd5b9be05016d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    var data = seriesModel.getData();
    var largePoints = data.getLayout("largePoints");
    var elP = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 1,
        ignoreCoarsePointer: true
    });
    group.add(elP);
    var elN = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: -1,
        ignoreCoarsePointer: true
    });
    group.add(elN);
    var elDoji = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 0,
        ignoreCoarsePointer: true
    });
    group.add(elDoji);
    $74dcd5b9be05016d$var$setLargeStyle(1, elP, seriesModel, data);
    $74dcd5b9be05016d$var$setLargeStyle(-1, elN, seriesModel, data);
    $74dcd5b9be05016d$var$setLargeStyle(0, elDoji, seriesModel, data);
    if (incremental) {
        elP.incremental = true;
        elN.incremental = true;
    }
    if (progressiveEls) progressiveEls.push(elP, elN);
}
function $74dcd5b9be05016d$var$setLargeStyle(sign, el, seriesModel, data) {
    // TODO put in visual?
    var borderColor = seriesModel.get([
        "itemStyle",
        sign > 0 ? "borderColor" : "borderColor0"
    ]) || seriesModel.get([
        "itemStyle",
        sign > 0 ? "color" : "color0"
    ]);
    if (sign === 0) borderColor = seriesModel.get([
        "itemStyle",
        "borderColorDoji"
    ]);
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var itemStyle = seriesModel.getModel("itemStyle").getItemStyle($74dcd5b9be05016d$var$SKIP_PROPS);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
}
var $74dcd5b9be05016d$export$2e2bcd8739ae039 = $74dcd5b9be05016d$var$CandlestickView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b79b80243e209954$var$CandlestickSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CandlestickSeriesModel, _super);
    function CandlestickSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickSeriesModel.type;
        _this.defaultValueDimensions = [
            {
                name: "open",
                defaultTooltip: true
            },
            {
                name: "close",
                defaultTooltip: true
            },
            {
                name: "lowest",
                defaultTooltip: true
            },
            {
                name: "highest",
                defaultTooltip: true
            }
        ];
        return _this;
    }
    /**
   * Get dimension for shadow in dataZoom
   * @return dimension name
   */ CandlestickSeriesModel.prototype.getShadowDim = function() {
        return "open";
    };
    CandlestickSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        var itemLayout = data.getItemLayout(dataIndex);
        return itemLayout && selectors.rect(itemLayout.brushRect);
    };
    CandlestickSeriesModel.type = "series.candlestick";
    CandlestickSeriesModel.dependencies = [
        "xAxis",
        "yAxis",
        "grid"
    ];
    CandlestickSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        layout: null,
        clip: true,
        itemStyle: {
            color: "#eb5454",
            color0: "#47b262",
            borderColor: "#eb5454",
            borderColor0: "#47b262",
            borderColorDoji: null,
            // borderColor: '#d24040',
            // borderColor0: '#398f4f',
            borderWidth: 1
        },
        emphasis: {
            scale: true,
            itemStyle: {
                borderWidth: 2
            }
        },
        barMaxWidth: null,
        barMinWidth: null,
        barWidth: null,
        large: true,
        largeThreshold: 600,
        progressive: 3e3,
        progressiveThreshold: 1e4,
        progressiveChunkMode: "mod",
        animationEasing: "linear",
        animationDuration: 300
    };
    return CandlestickSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($b79b80243e209954$var$CandlestickSeriesModel, (0, $29bc1fc21a5243a6$export$ccfed902f8630510), true);
var $b79b80243e209954$export$2e2bcd8739ae039 = $b79b80243e209954$var$CandlestickSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $55263b38adc138a7$export$2e2bcd8739ae039(option) {
    if (!option || !$7a1bd9c2710fea0d$export$43bee75e5e14138e(option.series)) return;
    // Translate 'k' to 'candlestick'.
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesItem) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(seriesItem) && seriesItem.type === "k") seriesItem.type = "candlestick";
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f31d4ab399bcabcc$var$positiveBorderColorQuery = [
    "itemStyle",
    "borderColor"
];
var $f31d4ab399bcabcc$var$negativeBorderColorQuery = [
    "itemStyle",
    "borderColor0"
];
var $f31d4ab399bcabcc$var$dojiBorderColorQuery = [
    "itemStyle",
    "borderColorDoji"
];
var $f31d4ab399bcabcc$var$positiveColorQuery = [
    "itemStyle",
    "color"
];
var $f31d4ab399bcabcc$var$negativeColorQuery = [
    "itemStyle",
    "color0"
];
var $f31d4ab399bcabcc$var$candlestickVisual = {
    seriesType: "candlestick",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        function getColor(sign, model) {
            return model.get(sign > 0 ? $f31d4ab399bcabcc$var$positiveColorQuery : $f31d4ab399bcabcc$var$negativeColorQuery);
        }
        function getBorderColor(sign, model) {
            return model.get(sign === 0 ? $f31d4ab399bcabcc$var$dojiBorderColorQuery : sign > 0 ? $f31d4ab399bcabcc$var$positiveBorderColorQuery : $f31d4ab399bcabcc$var$negativeBorderColorQuery);
        }
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var isLargeRender = seriesModel.pipelineContext.large;
        return !isLargeRender && {
            progress: function(params, data) {
                var dataIndex;
                while((dataIndex = params.next()) != null){
                    var itemModel = data.getItemModel(dataIndex);
                    var sign = data.getItemLayout(dataIndex).sign;
                    var style = itemModel.getItemStyle();
                    style.fill = getColor(sign, itemModel);
                    style.stroke = getBorderColor(sign, itemModel) || style.fill;
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, "style");
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
                }
            }
        };
    }
};
var $f31d4ab399bcabcc$export$2e2bcd8739ae039 = $f31d4ab399bcabcc$var$candlestickVisual;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $a4e49046f9f1fd8b$var$candlestickLayout = {
    seriesType: "candlestick",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        var candleWidth = $a4e49046f9f1fd8b$var$calculateCandleWidth(seriesModel, data);
        var cDimIdx = 0;
        var vDimIdx = 1;
        var coordDims = [
            "x",
            "y"
        ];
        var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
        var vDimsI = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
        var openDimI = vDimsI[0];
        var closeDimI = vDimsI[1];
        var lowestDimI = vDimsI[2];
        var highestDimI = vDimsI[3];
        data.setLayout({
            candleWidth: candleWidth,
            // The value is experimented visually.
            isSimpleBox: candleWidth <= 1.3
        });
        if (cDimI < 0 || vDimsI.length < 4) return;
        return {
            progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
        };
        function normalProgress(params, data) {
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                var ocLow = Math.min(openVal, closeVal);
                var ocHigh = Math.max(openVal, closeVal);
                var ocLowPoint = getPoint(ocLow, axisDimVal);
                var ocHighPoint = getPoint(ocHigh, axisDimVal);
                var lowestPoint = getPoint(lowestVal, axisDimVal);
                var highestPoint = getPoint(highestVal, axisDimVal);
                var ends = [];
                addBodyEnd(ends, ocHighPoint, 0);
                addBodyEnd(ends, ocLowPoint, 1);
                ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
                var itemModel = data.getItemModel(dataIndex);
                var hasDojiColor = !!itemModel.get([
                    "itemStyle",
                    "borderColorDoji"
                ]);
                data.setItemLayout(dataIndex, {
                    sign: $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor),
                    initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
                    ends: ends,
                    brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
                });
            }
            function getPoint(val, axisDimVal) {
                var p = [];
                p[cDimIdx] = axisDimVal;
                p[vDimIdx] = val;
                return isNaN(axisDimVal) || isNaN(val) ? [
                    NaN,
                    NaN
                ] : coordSys.dataToPoint(p);
            }
            function addBodyEnd(ends, point, start) {
                var point1 = point.slice();
                var point2 = point.slice();
                point1[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point1[cDimIdx] + candleWidth / 2, 1, false);
                point2[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point2[cDimIdx] - candleWidth / 2, 1, true);
                start ? ends.push(point1, point2) : ends.push(point2, point1);
            }
            function makeBrushRect(lowestVal, highestVal, axisDimVal) {
                var pmin = getPoint(lowestVal, axisDimVal);
                var pmax = getPoint(highestVal, axisDimVal);
                pmin[cDimIdx] -= candleWidth / 2;
                pmax[cDimIdx] -= candleWidth / 2;
                return {
                    x: pmin[0],
                    y: pmin[1],
                    width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
                    height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
                };
            }
            function subPixelOptimizePoint(point) {
                point[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point[cDimIdx], 1);
                return point;
            }
        }
        function largeProgress(params, data) {
            // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
            var points = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(params.count * 4);
            var offset = 0;
            var point;
            var tmpIn = [];
            var tmpOut = [];
            var dataIndex;
            var store = data.getStore();
            var hasDojiColor = !!seriesModel.get([
                "itemStyle",
                "borderColorDoji"
            ]);
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
                    points[offset++] = NaN;
                    offset += 3;
                    continue;
                }
                points[offset++] = $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor);
                tmpIn[cDimIdx] = axisDimVal;
                tmpIn[vDimIdx] = lowestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[0] : NaN;
                points[offset++] = point ? point[1] : NaN;
                tmpIn[vDimIdx] = highestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[1] : NaN;
            }
            data.setLayout("largePoints", points);
        }
    }
};
/**
 * Get the sign of a single data.
 *
 * @returns 0 for doji with hasDojiColor: true,
 *          1 for positive,
 *          -1 for negative.
 */ function $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor) {
    var sign;
    if (openVal > closeVal) sign = -1;
    else if (openVal < closeVal) sign = 1;
    else sign = hasDojiColor ? 0 : dataIndex > 0 ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : 1;
    return sign;
}
function $a4e49046f9f1fd8b$var$calculateCandleWidth(seriesModel, data) {
    var baseAxis = seriesModel.getBaseAxis();
    var extent;
    var bandWidth = baseAxis.type === "category" ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
    var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(seriesModel.get("barMaxWidth"), bandWidth), bandWidth);
    var barMinWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(seriesModel.get("barMinWidth"), 1), bandWidth);
    var barWidth = seriesModel.get("barWidth");
    return barWidth != null ? (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(barWidth, bandWidth) : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}
var $a4e49046f9f1fd8b$export$2e2bcd8739ae039 = $a4e49046f9f1fd8b$var$candlestickLayout;


function $21999577dfdc5807$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $74dcd5b9be05016d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $b79b80243e209954$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $55263b38adc138a7$export$2e2bcd8739ae039));
    registers.registerVisual((0, $f31d4ab399bcabcc$export$2e2bcd8739ae039));
    registers.registerLayout((0, $a4e49046f9f1fd8b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg) {
    var color = effectCfg.rippleEffectColor || effectCfg.color;
    rippleGroup.eachChild(function(ripplePath) {
        ripplePath.attr({
            z: effectCfg.z,
            zlevel: effectCfg.zlevel,
            style: {
                stroke: effectCfg.brushType === "stroke" ? color : null,
                fill: effectCfg.brushType === "fill" ? color : null
            }
        });
    });
}
var $fa583301cd9a2f5a$var$EffectSymbol = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(EffectSymbol, _super);
    function EffectSymbol(data, idx) {
        var _this = _super.call(this) || this;
        var symbol = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, idx);
        var rippleGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        _this.add(symbol);
        _this.add(rippleGroup);
        _this.updateData(data, idx);
        return _this;
    }
    EffectSymbol.prototype.stopEffectAnimation = function() {
        this.childAt(1).removeAll();
    };
    EffectSymbol.prototype.startEffectAnimation = function(effectCfg) {
        var symbolType = effectCfg.symbolType;
        var color = effectCfg.color;
        var rippleNumber = effectCfg.rippleNumber;
        var rippleGroup = this.childAt(1);
        for(var i = 0; i < rippleNumber; i++){
            // If width/height are set too small (e.g., set to 1) on ios10
            // and macOS Sierra, a circle stroke become a rect, no matter what
            // the scale is set. So we set width/height as 2. See #4136.
            var ripplePath = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
            ripplePath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 99,
                silent: true,
                scaleX: 0.5,
                scaleY: 0.5
            });
            var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
            ripplePath.animate("", true).when(effectCfg.period, {
                scaleX: effectCfg.rippleScale / 2,
                scaleY: effectCfg.rippleScale / 2
            }).delay(delay).start();
            ripplePath.animateStyle(true).when(effectCfg.period, {
                opacity: 0
            }).delay(delay).start();
            rippleGroup.add(ripplePath);
        }
        $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Update effect symbol
   */ EffectSymbol.prototype.updateEffectAnimation = function(effectCfg) {
        var oldEffectCfg = this._effectCfg;
        var rippleGroup = this.childAt(1);
        // Must reinitialize effect if following configuration changed
        var DIFFICULT_PROPS = [
            "symbolType",
            "period",
            "rippleScale",
            "rippleNumber"
        ];
        for(var i = 0; i < DIFFICULT_PROPS.length; i++){
            var propName = DIFFICULT_PROPS[i];
            if (oldEffectCfg[propName] !== effectCfg[propName]) {
                this.stopEffectAnimation();
                this.startEffectAnimation(effectCfg);
                return;
            }
        }
        $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Highlight symbol
   */ EffectSymbol.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    /**
   * Downplay symbol
   */ EffectSymbol.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    EffectSymbol.prototype.getSymbolType = function() {
        var symbol = this.childAt(0);
        return symbol && symbol.getSymbolType();
    };
    /**
   * Update symbol properties
   */ EffectSymbol.prototype.updateData = function(data, idx) {
        var _this = this;
        var seriesModel = data.hostModel;
        this.childAt(0).updateData(data, idx);
        var rippleGroup = this.childAt(1);
        var itemModel = data.getItemModel(idx);
        var symbolType = data.getItemVisual(idx, "symbol");
        var symbolSize = (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(data.getItemVisual(idx, "symbolSize"));
        var symbolStyle = data.getItemVisual(idx, "style");
        var color = symbolStyle && symbolStyle.fill;
        var emphasisModel = itemModel.getModel("emphasis");
        rippleGroup.setScale(symbolSize);
        rippleGroup.traverse(function(ripplePath) {
            ripplePath.setStyle("fill", color);
        });
        var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(data.getItemVisual(idx, "symbolOffset"), symbolSize);
        if (symbolOffset) {
            rippleGroup.x = symbolOffset[0];
            rippleGroup.y = symbolOffset[1];
        }
        var symbolRotate = data.getItemVisual(idx, "symbolRotate");
        rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
        var effectCfg = {};
        effectCfg.showEffectOn = seriesModel.get("showEffectOn");
        effectCfg.rippleScale = itemModel.get([
            "rippleEffect",
            "scale"
        ]);
        effectCfg.brushType = itemModel.get([
            "rippleEffect",
            "brushType"
        ]);
        effectCfg.period = itemModel.get([
            "rippleEffect",
            "period"
        ]) * 1000;
        effectCfg.effectOffset = idx / data.count();
        effectCfg.z = seriesModel.getShallow("z") || 0;
        effectCfg.zlevel = seriesModel.getShallow("zlevel") || 0;
        effectCfg.symbolType = symbolType;
        effectCfg.color = color;
        effectCfg.rippleEffectColor = itemModel.get([
            "rippleEffect",
            "color"
        ]);
        effectCfg.rippleNumber = itemModel.get([
            "rippleEffect",
            "number"
        ]);
        if (effectCfg.showEffectOn === "render") {
            this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
            this._effectCfg = effectCfg;
        } else {
            // Not keep old effect config
            this._effectCfg = null;
            this.stopEffectAnimation();
            this.onHoverStateChange = function(toState) {
                if (toState === "emphasis") {
                    if (effectCfg.showEffectOn !== "render") _this.startEffectAnimation(effectCfg);
                } else if (toState === "normal") {
                    if (effectCfg.showEffectOn !== "render") _this.stopEffectAnimation();
                }
            };
        }
        this._effectCfg = effectCfg;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    EffectSymbol.prototype.fadeOut = function(cb) {
        cb && cb();
    };
    return EffectSymbol;
}((0, $7ef7583d8302ffce$export$2e2bcd8739ae039));
var $fa583301cd9a2f5a$export$2e2bcd8739ae039 = $fa583301cd9a2f5a$var$EffectSymbol;





var $41934e1dad128ad0$var$EffectScatterView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(EffectScatterView, _super);
    function EffectScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterView.type;
        return _this;
    }
    EffectScatterView.prototype.init = function() {
        this._symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)((0, $fa583301cd9a2f5a$export$2e2bcd8739ae039));
    };
    EffectScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var effectSymbolDraw = this._symbolDraw;
        effectSymbolDraw.updateData(data, {
            clipShape: this._getClipShape(seriesModel)
        });
        this.group.add(effectSymbolDraw.group);
    };
    EffectScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get("clip", true) ? clipArea : null;
    };
    EffectScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        this.group.dirty();
        var res = (0, $73b014aa594ea652$export$2e2bcd8739ae039)("").reset(seriesModel, ecModel, api);
        if (res.progress) res.progress({
            start: 0,
            end: data.count(),
            count: data.count()
        }, data);
        this._symbolDraw.updateLayout();
    };
    EffectScatterView.prototype._updateGroupTransform = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.getRoamTransform) {
            this.group.transform = $f41ebb9dd60b55b4$export$9cd59f9826255e47(coordSys.getRoamTransform());
            this.group.decomposeTransform();
        }
    };
    EffectScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
    };
    EffectScatterView.type = "effectScatter";
    return EffectScatterView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $41934e1dad128ad0$export$2e2bcd8739ae039 = $41934e1dad128ad0$var$EffectScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $719c2a408bc8b7bb$var$EffectScatterSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(EffectScatterSeriesModel, _super);
    function EffectScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    EffectScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    EffectScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    EffectScatterSeriesModel.type = "series.effectScatter";
    EffectScatterSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    EffectScatterSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        effectType: "ripple",
        progressive: 0,
        // When to show the effect, option: 'render'|'emphasis'
        showEffectOn: "render",
        clip: true,
        // Ripple effect config
        rippleEffect: {
            period: 4,
            // Scale of ripple
            scale: 2.5,
            // Brush type can be fill or stroke
            brushType: "fill",
            // Ripple number
            number: 3
        },
        universalTransition: {
            divideShape: "clone"
        },
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    };
    return EffectScatterSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $719c2a408bc8b7bb$export$2e2bcd8739ae039 = $719c2a408bc8b7bb$var$EffectScatterSeriesModel;



function $a0fd335cdafe9e6e$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $41934e1dad128ad0$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $719c2a408bc8b7bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("effectScatter"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $ac4f44aacfb7dba9$var$EffectLine = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(EffectLine, _super);
    function EffectLine(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this.add(_this.createLine(lineData, idx, seriesScope));
        _this._updateEffectSymbol(lineData, idx);
        return _this;
    }
    EffectLine.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    EffectLine.prototype._updateEffectSymbol = function(lineData, idx) {
        var itemModel = lineData.getItemModel(idx);
        var effectModel = itemModel.getModel("effect");
        var size = effectModel.get("symbolSize");
        var symbolType = effectModel.get("symbol");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(size)) size = [
            size,
            size
        ];
        var lineStyle = lineData.getItemVisual(idx, "style");
        var color = effectModel.get("color") || lineStyle && lineStyle.stroke;
        var symbol = this.childAt(1);
        if (this._symbolType !== symbolType) {
            // Remove previous
            this.remove(symbol);
            symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -0.5, -0.5, 1, 1, color);
            symbol.z2 = 100;
            symbol.culling = true;
            this.add(symbol);
        }
        // Symbol may be removed if loop is false
        if (!symbol) return;
        // Shadow color is same with color in default
        symbol.setStyle("shadowColor", color);
        symbol.setStyle(effectModel.getItemStyle([
            "color"
        ]));
        symbol.scaleX = size[0];
        symbol.scaleY = size[1];
        symbol.setColor(color);
        this._symbolType = symbolType;
        this._symbolScale = size;
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    EffectLine.prototype._updateEffectAnimation = function(lineData, effectModel, idx) {
        var symbol = this.childAt(1);
        if (!symbol) return;
        var points = lineData.getItemLayout(idx);
        var period = effectModel.get("period") * 1000;
        var loop = effectModel.get("loop");
        var roundTrip = effectModel.get("roundTrip");
        var constantSpeed = effectModel.get("constantSpeed");
        var delayExpr = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(effectModel.get("delay"), function(idx) {
            return idx / lineData.count() * period / 3;
        });
        // Ignore when updating
        symbol.ignore = true;
        this._updateAnimationPoints(symbol, points);
        if (constantSpeed > 0) period = this._getLineLength(symbol) / constantSpeed * 1000;
        if (period !== this._period || loop !== this._loop || roundTrip !== this._roundTrip) {
            symbol.stopAnimation();
            var delayNum = void 0;
            if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(delayExpr)) delayNum = delayExpr(idx);
            else delayNum = delayExpr;
            if (symbol.__t > 0) delayNum = -period * symbol.__t;
            this._animateSymbol(symbol, period, delayNum, loop, roundTrip);
        }
        this._period = period;
        this._loop = loop;
        this._roundTrip = roundTrip;
    };
    EffectLine.prototype._animateSymbol = function(symbol, period, delayNum, loop, roundTrip) {
        if (period > 0) {
            symbol.__t = 0;
            var self_1 = this;
            var animator = symbol.animate("", loop).when(roundTrip ? period * 2 : period, {
                __t: roundTrip ? 2 : 1
            }).delay(delayNum).during(function() {
                self_1._updateSymbolPosition(symbol);
            });
            if (!loop) animator.done(function() {
                self_1.remove(symbol);
            });
            animator.start();
        }
    };
    EffectLine.prototype._getLineLength = function(symbol) {
        // Not so accurate
        return $6de594cf8ac295ff$export$6c4a311cc157c764(symbol.__p1, symbol.__cp1) + $6de594cf8ac295ff$export$6c4a311cc157c764(symbol.__cp1, symbol.__p2);
    };
    EffectLine.prototype._updateAnimationPoints = function(symbol, points) {
        symbol.__p1 = points[0];
        symbol.__p2 = points[1];
        symbol.__cp1 = points[2] || [
            (points[0][0] + points[1][0]) / 2,
            (points[0][1] + points[1][1]) / 2
        ];
    };
    EffectLine.prototype.updateData = function(lineData, idx, seriesScope) {
        this.childAt(0).updateData(lineData, idx, seriesScope);
        this._updateEffectSymbol(lineData, idx);
    };
    EffectLine.prototype._updateSymbolPosition = function(symbol) {
        var p1 = symbol.__p1;
        var p2 = symbol.__p2;
        var cp1 = symbol.__cp1;
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var pos = [
            symbol.x,
            symbol.y
        ];
        var lastPos = pos.slice();
        var quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
        var quadraticDerivativeAt = $747cfc5611b57cea$export$7e161e77e6fff8cb;
        pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
        pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t);
        // Tangent
        var tx = symbol.__t < 1 ? quadraticDerivativeAt(p1[0], cp1[0], p2[0], t) : quadraticDerivativeAt(p2[0], cp1[0], p1[0], 1 - t);
        var ty = symbol.__t < 1 ? quadraticDerivativeAt(p1[1], cp1[1], p2[1], t) : quadraticDerivativeAt(p2[1], cp1[1], p1[1], 1 - t);
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
        if (this._symbolType === "line" || this._symbolType === "rect" || this._symbolType === "roundRect") {
            if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
                symbol.scaleY = $6de594cf8ac295ff$export$6c4a311cc157c764(lastPos, pos) * 1.05;
                // make sure the last segment render within endPoint
                if (t === 1) {
                    pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
                    pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
                }
            } else if (symbol.__lastT === 1) // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
            symbol.scaleY = 2 * $6de594cf8ac295ff$export$6c4a311cc157c764(p1, pos);
            else symbol.scaleY = this._symbolScale[1];
        }
        symbol.__lastT = symbol.__t;
        symbol.ignore = false;
        symbol.x = pos[0];
        symbol.y = pos[1];
    };
    EffectLine.prototype.updateLayout = function(lineData, idx) {
        this.childAt(0).updateLayout(lineData, idx);
        var effectModel = lineData.getItemModel(idx).getModel("effect");
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    return EffectLine;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $ac4f44aacfb7dba9$export$2e2bcd8739ae039 = $ac4f44aacfb7dba9$var$EffectLine;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bdfe7b18bcde1955$var$Polyline = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createPolyline(lineData, idx, seriesScope);
        return _this;
    }
    Polyline.prototype._createPolyline = function(lineData, idx, seriesScope) {
        // let seriesModel = lineData.hostModel;
        var points = lineData.getItemLayout(idx);
        var line = new $d28119f30e6bb670$export$2e2bcd8739ae039({
            shape: {
                points: points
            }
        });
        this.add(line);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childAt(0);
        var target = {
            shape: {
                points: lineData.getItemLayout(idx)
            }
        };
        $8b353638fbedfefa$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var line = this.childAt(0);
        var itemModel = lineData.getItemModel(idx);
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        if (!seriesScope || lineData.hasItemOption) {
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisLineStyle = emphasisModel.getModel("lineStyle").getLineStyle();
            emphasisDisabled = emphasisModel.get("disabled");
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
        }
        line.useStyle(lineData.getItemVisual(idx, "style"));
        line.style.fill = null;
        line.style.strokeNoScale = true;
        var lineEmphasisState = line.ensureState("emphasis");
        lineEmphasisState.style = emphasisLineStyle;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Polyline.prototype.updateLayout = function(lineData, idx) {
        var polyline = this.childAt(0);
        polyline.setShape("points", lineData.getItemLayout(idx));
    };
    return Polyline;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $bdfe7b18bcde1955$export$2e2bcd8739ae039 = $bdfe7b18bcde1955$var$Polyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a16373b7bc6b0508$var$EffectPolyline = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(EffectPolyline, _super);
    function EffectPolyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._lastFrame = 0;
        _this._lastFramePercent = 0;
        return _this;
    }
    // Override
    EffectPolyline.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $bdfe7b18bcde1955$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    // Override
    EffectPolyline.prototype._updateAnimationPoints = function(symbol, points) {
        this._points = points;
        var accLenArr = [
            0
        ];
        var len = 0;
        for(var i = 1; i < points.length; i++){
            var p1 = points[i - 1];
            var p2 = points[i];
            len += $6de594cf8ac295ff$export$6c4a311cc157c764(p1, p2);
            accLenArr.push(len);
        }
        if (len === 0) {
            this._length = 0;
            return;
        }
        for(var i = 0; i < accLenArr.length; i++)accLenArr[i] /= len;
        this._offsets = accLenArr;
        this._length = len;
    };
    // Override
    EffectPolyline.prototype._getLineLength = function() {
        return this._length;
    };
    // Override
    EffectPolyline.prototype._updateSymbolPosition = function(symbol) {
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var points = this._points;
        var offsets = this._offsets;
        var len = points.length;
        if (!offsets) // Has length 0
        return;
        var lastFrame = this._lastFrame;
        var frame;
        if (t < this._lastFramePercent) {
            // Start from the next frame
            // PENDING start from lastFrame ?
            var start = Math.min(lastFrame + 1, len - 1);
            for(frame = start; frame >= 0; frame--){
                if (offsets[frame] <= t) break;
            }
            // PENDING really need to do this ?
            frame = Math.min(frame, len - 2);
        } else {
            for(frame = lastFrame; frame < len; frame++){
                if (offsets[frame] > t) break;
            }
            frame = Math.min(frame - 1, len - 2);
        }
        var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
        var p0 = points[frame];
        var p1 = points[frame + 1];
        symbol.x = p0[0] * (1 - p) + p * p1[0];
        symbol.y = p0[1] * (1 - p) + p * p1[1];
        var tx = symbol.__t < 1 ? p1[0] - p0[0] : p0[0] - p1[0];
        var ty = symbol.__t < 1 ? p1[1] - p0[1] : p0[1] - p1[1];
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        this._lastFrame = frame;
        this._lastFramePercent = t;
        symbol.ignore = false;
    };
    return EffectPolyline;
}((0, $ac4f44aacfb7dba9$export$2e2bcd8739ae039));
var $a16373b7bc6b0508$export$2e2bcd8739ae039 = $a16373b7bc6b0508$var$EffectPolyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $2f5f63360e8576db$var$LargeLinesPathShape = /** @class */ function() {
    function LargeLinesPathShape() {
        this.polyline = false;
        this.curveness = 0;
        this.segs = [];
    }
    return LargeLinesPathShape;
}();
var $2f5f63360e8576db$var$LargeLinesPath = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LargeLinesPath, _super);
    function LargeLinesPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeLinesPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeLinesPath.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    LargeLinesPath.prototype.getDefaultShape = function() {
        return new $2f5f63360e8576db$var$LargeLinesPathShape();
    };
    LargeLinesPath.prototype.buildPath = function(ctx, shape) {
        var segs = shape.segs;
        var curveness = shape.curveness;
        var i;
        if (shape.polyline) for(i = this._off; i < segs.length;){
            var count = segs[i++];
            if (count > 0) {
                ctx.moveTo(segs[i++], segs[i++]);
                for(var k = 1; k < count; k++)ctx.lineTo(segs[i++], segs[i++]);
            }
        }
        else for(i = this._off; i < segs.length;){
            var x0 = segs[i++];
            var y0 = segs[i++];
            var x1 = segs[i++];
            var y1 = segs[i++];
            ctx.moveTo(x0, y0);
            if (curveness > 0) {
                var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                ctx.quadraticCurveTo(x2, y2, x1, y1);
            } else ctx.lineTo(x1, y1);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeLinesPath.prototype.findDataIndex = function(x, y) {
        var shape = this.shape;
        var segs = shape.segs;
        var curveness = shape.curveness;
        var lineWidth = this.style.lineWidth;
        if (shape.polyline) {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var count = segs[i++];
                if (count > 0) {
                    var x0 = segs[i++];
                    var y0 = segs[i++];
                    for(var k = 1; k < count; k++){
                        var x1 = segs[i++];
                        var y1 = segs[i++];
                        if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                    }
                }
                dataIndex++;
            }
        } else {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var x0 = segs[i++];
                var y0 = segs[i++];
                var x1 = segs[i++];
                var y1 = segs[i++];
                if (curveness > 0) {
                    var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                    var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                    if ($a1d80a5bf05b597b$export$8d36b1b5d19157c5(x0, y0, x2, y2, x1, y1, lineWidth, x, y)) return dataIndex;
                } else {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                }
                dataIndex++;
            }
        }
        return -1;
    };
    LargeLinesPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeLinesPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.segs;
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $1bebe7106c895823$export$2e2bcd8739ae039(minX, minY, maxX, maxY);
        }
        return rect;
    };
    return LargeLinesPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $2f5f63360e8576db$var$LargeLineDraw = /** @class */ function() {
    function LargeLineDraw() {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeLineDraw.prototype.updateData = function(data) {
        this._clear();
        var lineEl = this._create();
        lineEl.setShape({
            segs: data.getLayout("linesPoints")
        });
        this._setCommon(lineEl, data);
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalPrepareUpdate = function(data) {
        this.group.removeAll();
        this._clear();
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalUpdate = function(taskParams, data) {
        var lastAdded = this._newAdded[0];
        var linePoints = data.getLayout("linesPoints");
        var oldSegs = lastAdded && lastAdded.shape.segs;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldSegs && oldSegs.length < 2e4) {
            var oldLen = oldSegs.length;
            var newSegs = new Float32Array(oldLen + linePoints.length);
            // Concat two array
            newSegs.set(oldSegs);
            newSegs.set(linePoints, oldLen);
            lastAdded.setShape({
                segs: newSegs
            });
        } else {
            // Clear
            this._newAdded = [];
            var lineEl = this._create();
            lineEl.incremental = true;
            lineEl.setShape({
                segs: linePoints
            });
            this._setCommon(lineEl, data);
            lineEl.__startIndex = taskParams.start;
        }
    };
    /**
   * @override
   */ LargeLineDraw.prototype.remove = function() {
        this._clear();
    };
    LargeLineDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeLineDraw.prototype._create = function() {
        var lineEl = new $2f5f63360e8576db$var$LargeLinesPath({
            cursor: "default",
            ignoreCoarsePointer: true
        });
        this._newAdded.push(lineEl);
        this.group.add(lineEl);
        return lineEl;
    };
    LargeLineDraw.prototype._setCommon = function(lineEl, data, isIncremental) {
        var hostModel = data.hostModel;
        lineEl.setShape({
            polyline: hostModel.get("polyline"),
            curveness: hostModel.get([
                "lineStyle",
                "curveness"
            ])
        });
        lineEl.useStyle(hostModel.getModel("lineStyle").getLineStyle());
        lineEl.style.strokeNoScale = true;
        var style = data.getVisual("style");
        if (style && style.stroke) lineEl.setStyle("stroke", style.stroke);
        lineEl.setStyle("fill", null);
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(lineEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        lineEl.on("mousemove", function(e) {
            ecData.dataIndex = null;
            var dataIndex = lineEl.hoverDataIdx;
            if (dataIndex > 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + lineEl.__startIndex;
        });
    };
    LargeLineDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeLineDraw;
}();
var $2f5f63360e8576db$export$2e2bcd8739ae039 = $2f5f63360e8576db$var$LargeLineDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 

var $e702d3171e9448b0$var$linesLayout = {
    seriesType: "lines",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var isPolyline = seriesModel.get("polyline");
        var isLarge = seriesModel.pipelineContext.large;
        return {
            progress: function(params, lineData) {
                var lineCoords = [];
                if (isLarge) {
                    var points = void 0;
                    var segCount = params.end - params.start;
                    if (isPolyline) {
                        var totalCoordsCount = 0;
                        for(var i = params.start; i < params.end; i++)totalCoordsCount += seriesModel.getLineCoordsCount(i);
                        points = new Float32Array(segCount + totalCoordsCount * 2);
                    } else points = new Float32Array(segCount * 4);
                    var offset = 0;
                    var pt = [];
                    for(var i = params.start; i < params.end; i++){
                        var len = seriesModel.getLineCoords(i, lineCoords);
                        if (isPolyline) points[offset++] = len;
                        for(var k = 0; k < len; k++){
                            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
                            points[offset++] = pt[0];
                            points[offset++] = pt[1];
                        }
                    }
                    lineData.setLayout("linesPoints", points);
                } else for(var i = params.start; i < params.end; i++){
                    var itemModel = lineData.getItemModel(i);
                    var len = seriesModel.getLineCoords(i, lineCoords);
                    var pts = [];
                    if (isPolyline) for(var j = 0; j < len; j++)pts.push(coordSys.dataToPoint(lineCoords[j]));
                    else {
                        pts[0] = coordSys.dataToPoint(lineCoords[0]);
                        pts[1] = coordSys.dataToPoint(lineCoords[1]);
                        var curveness = itemModel.get([
                            "lineStyle",
                            "curveness"
                        ]);
                        if (+curveness) pts[2] = [
                            (pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness,
                            (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness
                        ];
                    }
                    lineData.setItemLayout(i, pts);
                }
            }
        };
    }
};
var $e702d3171e9448b0$export$2e2bcd8739ae039 = $e702d3171e9448b0$var$linesLayout;




var $cefff1aea7415b28$var$LinesView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LinesView, _super);
    function LinesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesView.type;
        return _this;
    }
    LinesView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        var zlevel = seriesModel.get("zlevel");
        var trailLength = seriesModel.get([
            "effect",
            "trailLength"
        ]);
        var zr = api.getZr();
        // Avoid the drag cause ghost shadow
        // FIXME Better way ?
        // SVG doesn't support
        var isSvg = zr.painter.getType() === "svg";
        if (!isSvg) zr.painter.getLayer(zlevel).clear(true);
        // Config layer with motion blur
        if (this._lastZlevel != null && !isSvg) zr.configLayer(this._lastZlevel, {
            motionBlur: false
        });
        if (this._showEffect(seriesModel) && trailLength > 0) {
            if (!isSvg) zr.configLayer(zlevel, {
                motionBlur: true,
                lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
            });
        }
        lineDraw.updateData(data);
        var clipPath = seriesModel.get("clip", true) && (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
        this._lastZlevel = zlevel;
        this._finished = true;
    };
    LinesView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        lineDraw.incrementalPrepareUpdate(data);
        this._clearLayer(api);
        this._finished = false;
    };
    LinesView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    LinesView.prototype.eachRendered = function(cb) {
        this._lineDraw && this._lineDraw.eachRendered(cb);
    };
    LinesView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var pipelineContext = seriesModel.pipelineContext;
        if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) // TODO Don't have to do update in large mode. Only do it when there are millions of data.
        return {
            update: true
        };
        else {
            // TODO Use same logic with ScatterView.
            // Manually update layout
            var res = (0, $e702d3171e9448b0$export$2e2bcd8739ae039).reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            // Not in large mode
            this._lineDraw.updateLayout();
            this._clearLayer(api);
        }
    };
    LinesView.prototype._updateLineDraw = function(data, seriesModel) {
        var lineDraw = this._lineDraw;
        var hasEffect = this._showEffect(seriesModel);
        var isPolyline = !!seriesModel.get("polyline");
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
            if (lineDraw) lineDraw.remove();
            lineDraw = this._lineDraw = isLargeDraw ? new (0, $2f5f63360e8576db$export$2e2bcd8739ae039)() : new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)(isPolyline ? hasEffect ? (0, $a16373b7bc6b0508$export$2e2bcd8739ae039) : (0, $bdfe7b18bcde1955$export$2e2bcd8739ae039) : hasEffect ? (0, $ac4f44aacfb7dba9$export$2e2bcd8739ae039) : (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039));
            this._hasEffet = hasEffect;
            this._isPolyline = isPolyline;
            this._isLargeDraw = isLargeDraw;
        }
        this.group.add(lineDraw.group);
        return lineDraw;
    };
    LinesView.prototype._showEffect = function(seriesModel) {
        return !!seriesModel.get([
            "effect",
            "show"
        ]);
    };
    LinesView.prototype._clearLayer = function(api) {
        // Not use motion when dragging or zooming
        var zr = api.getZr();
        var isSvg = zr.painter.getType() === "svg";
        if (!isSvg && this._lastZlevel != null) zr.painter.getLayer(this._lastZlevel).clear(true);
    };
    LinesView.prototype.remove = function(ecModel, api) {
        this._lineDraw && this._lineDraw.remove();
        this._lineDraw = null;
        // Clear motion when lineDraw is removed
        this._clearLayer(api);
    };
    LinesView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    LinesView.type = "lines";
    return LinesView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $cefff1aea7415b28$export$2e2bcd8739ae039 = $cefff1aea7415b28$var$LinesView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $7abeccdc5e740e42$var$Uint32Arr = typeof Uint32Array === "undefined" ? Array : Uint32Array;
var $7abeccdc5e740e42$var$Float64Arr = typeof Float64Array === "undefined" ? Array : Float64Array;
function $7abeccdc5e740e42$var$compatEc2(seriesOpt) {
    var data = seriesOpt.data;
    if (data && data[0] && data[0][0] && data[0][0].coord) seriesOpt.data = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data, function(itemOpt) {
        var coords = [
            itemOpt[0].coord,
            itemOpt[1].coord
        ];
        var target = {
            coords: coords
        };
        if (itemOpt[0].name) target.fromName = itemOpt[0].name;
        if (itemOpt[1].name) target.toName = itemOpt[1].name;
        return (0, $7a1bd9c2710fea0d$export$18aef43295bbe906)([
            target,
            itemOpt[0],
            itemOpt[1]
        ]);
    });
}
var $7abeccdc5e740e42$var$LinesSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LinesSeriesModel, _super);
    function LinesSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesSeriesModel.type;
        _this.visualStyleAccessPath = "lineStyle";
        _this.visualDrawType = "stroke";
        return _this;
    }
    LinesSeriesModel.prototype.init = function(option) {
        // The input data may be null/undefined.
        option.data = option.data || [];
        // Not using preprocessor because mergeOption may not have series.type
        $7abeccdc5e740e42$var$compatEc2(option);
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        _super.prototype.init.apply(this, arguments);
    };
    LinesSeriesModel.prototype.mergeOption = function(option) {
        $7abeccdc5e740e42$var$compatEc2(option);
        if (option.data) {
            // Only update when have option data to merge.
            var result = this._processFlatCoordsArray(option.data);
            this._flatCoords = result.flatCoords;
            this._flatCoordsOffset = result.flatCoordsOffset;
            if (result.flatCoords) option.data = new Float32Array(result.count);
        }
        _super.prototype.mergeOption.apply(this, arguments);
    };
    LinesSeriesModel.prototype.appendData = function(params) {
        var result = this._processFlatCoordsArray(params.data);
        if (result.flatCoords) {
            if (!this._flatCoords) {
                this._flatCoords = result.flatCoords;
                this._flatCoordsOffset = result.flatCoordsOffset;
            } else {
                this._flatCoords = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoords, result.flatCoords);
                this._flatCoordsOffset = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoordsOffset, result.flatCoordsOffset);
            }
            params.data = new Float32Array(result.count);
        }
        this.getRawData().appendData(params.data);
    };
    LinesSeriesModel.prototype._getCoordsFromItemModel = function(idx) {
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow("coords");
        return coords;
    };
    LinesSeriesModel.prototype.getLineCoordsCount = function(idx) {
        if (this._flatCoordsOffset) return this._flatCoordsOffset[idx * 2 + 1];
        else return this._getCoordsFromItemModel(idx).length;
    };
    LinesSeriesModel.prototype.getLineCoords = function(idx, out) {
        if (this._flatCoordsOffset) {
            var offset = this._flatCoordsOffset[idx * 2];
            var len = this._flatCoordsOffset[idx * 2 + 1];
            for(var i = 0; i < len; i++){
                out[i] = out[i] || [];
                out[i][0] = this._flatCoords[offset + i * 2];
                out[i][1] = this._flatCoords[offset + i * 2 + 1];
            }
            return len;
        } else {
            var coords = this._getCoordsFromItemModel(idx);
            for(var i = 0; i < coords.length; i++){
                out[i] = out[i] || [];
                out[i][0] = coords[i][0];
                out[i][1] = coords[i][1];
            }
            return coords.length;
        }
    };
    LinesSeriesModel.prototype._processFlatCoordsArray = function(data) {
        var startOffset = 0;
        if (this._flatCoords) startOffset = this._flatCoords.length;
        // Stored as a typed array. In format
        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
        if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(data[0])) {
            var len = data.length;
            // Store offset and len of each segment
            var coordsOffsetAndLenStorage = new $7abeccdc5e740e42$var$Uint32Arr(len);
            var coordsStorage = new $7abeccdc5e740e42$var$Float64Arr(len);
            var coordsCursor = 0;
            var offsetCursor = 0;
            var dataCount = 0;
            for(var i = 0; i < len;){
                dataCount++;
                var count = data[i++];
                // Offset
                coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset;
                // Len
                coordsOffsetAndLenStorage[offsetCursor++] = count;
                for(var k = 0; k < count; k++){
                    var x = data[i++];
                    var y = data[i++];
                    coordsStorage[coordsCursor++] = x;
                    coordsStorage[coordsCursor++] = y;
                }
            }
            return {
                flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
                flatCoords: coordsStorage,
                count: dataCount
            };
        }
        return {
            flatCoordsOffset: null,
            flatCoords: null,
            count: data.length
        };
    };
    LinesSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var CoordSys;
        var lineData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            "value"
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    };
    LinesSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var itemModel = data.getItemModel(dataIndex);
        var name = itemModel.get("name");
        if (name) return name;
        var fromName = itemModel.get("fromName");
        var toName = itemModel.get("toName");
        var nameArr = [];
        fromName != null && nameArr.push(fromName);
        toName != null && nameArr.push(toName);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: nameArr.join(" > ")
        });
    };
    LinesSeriesModel.prototype.preventIncremental = function() {
        return !!this.get([
            "effect",
            "show"
        ]);
    };
    LinesSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) return this.option.large ? 1e4 : this.get("progressive");
        return progressive;
    };
    LinesSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) return this.option.large ? 2e4 : this.get("progressiveThreshold");
        return progressiveThreshold;
    };
    LinesSeriesModel.prototype.getZLevelKey = function() {
        var effectModel = this.getModel("effect");
        var trailLength = effectModel.get("trailLength");
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : effectModel.get("show") && trailLength > 0 ? trailLength + "" : "";
    };
    LinesSeriesModel.type = "series.lines";
    LinesSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "calendar"
    ];
    LinesSeriesModel.defaultOption = {
        coordinateSystem: "geo",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Cartesian coordinate system
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            10
        ],
        // Geo coordinate system
        geoIndex: 0,
        effect: {
            show: false,
            period: 4,
            constantSpeed: 0,
            symbol: "circle",
            symbolSize: 3,
            loop: true,
            trailLength: 0.2
        },
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        polyline: false,
        clip: true,
        label: {
            show: false,
            position: "end"
        },
        lineStyle: {
            opacity: 0.5
        }
    };
    return LinesSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $7abeccdc5e740e42$export$2e2bcd8739ae039 = $7abeccdc5e740e42$var$LinesSeriesModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $111ea02a392b95a6$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
var $111ea02a392b95a6$var$linesVisual = {
    seriesType: "lines",
    reset: function(seriesModel) {
        var symbolType = $111ea02a392b95a6$var$normalize(seriesModel.get("symbol"));
        var symbolSize = $111ea02a392b95a6$var$normalize(seriesModel.get("symbolSize"));
        var data = seriesModel.getData();
        data.setVisual("fromSymbol", symbolType && symbolType[0]);
        data.setVisual("toSymbol", symbolType && symbolType[1]);
        data.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
        data.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var symbolType = $111ea02a392b95a6$var$normalize(itemModel.getShallow("symbol", true));
            var symbolSize = $111ea02a392b95a6$var$normalize(itemModel.getShallow("symbolSize", true));
            symbolType[0] && data.setItemVisual(idx, "fromSymbol", symbolType[0]);
            symbolType[1] && data.setItemVisual(idx, "toSymbol", symbolType[1]);
            symbolSize[0] && data.setItemVisual(idx, "fromSymbolSize", symbolSize[0]);
            symbolSize[1] && data.setItemVisual(idx, "toSymbolSize", symbolSize[1]);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};
var $111ea02a392b95a6$export$2e2bcd8739ae039 = $111ea02a392b95a6$var$linesVisual;


function $52dd2448928cc7d8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $cefff1aea7415b28$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $7abeccdc5e740e42$export$2e2bcd8739ae039));
    registers.registerLayout((0, $e702d3171e9448b0$export$2e2bcd8739ae039));
    registers.registerVisual((0, $111ea02a392b95a6$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8ClampedArray */ 
var $e72df59f80933534$var$GRADIENT_LEVELS = 256;
var $e72df59f80933534$var$HeatmapLayer = /** @class */ function() {
    function HeatmapLayer() {
        this.blurSize = 30;
        this.pointSize = 20;
        this.maxOpacity = 1;
        this.minOpacity = 0;
        this._gradientPixels = {
            inRange: null,
            outOfRange: null
        };
        var canvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
        this.canvas = canvas;
    }
    /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */ HeatmapLayer.prototype.update = function(data, width, height, normalize, colorFunc, isInRange) {
        var brush = this._getBrush();
        var gradientInRange = this._getGradient(colorFunc, "inRange");
        var gradientOutOfRange = this._getGradient(colorFunc, "outOfRange");
        var r = this.pointSize + this.blurSize;
        var canvas = this.canvas;
        var ctx = canvas.getContext("2d");
        var len = data.length;
        canvas.width = width;
        canvas.height = height;
        for(var i = 0; i < len; ++i){
            var p = data[i];
            var x = p[0];
            var y = p[1];
            var value = p[2];
            // calculate alpha using value
            var alpha = normalize(value);
            // draw with the circle brush with alpha
            ctx.globalAlpha = alpha;
            ctx.drawImage(brush, x - r, y - r);
        }
        if (!canvas.width || !canvas.height) // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
        // 'CanvasRenderingContext2D': The source height is 0."
        return canvas;
        // colorize the canvas using alpha value and set with gradient
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var offset = 0;
        var pixelLen = pixels.length;
        var minOpacity = this.minOpacity;
        var maxOpacity = this.maxOpacity;
        var diffOpacity = maxOpacity - minOpacity;
        while(offset < pixelLen){
            var alpha = pixels[offset + 3] / 256;
            var gradientOffset = Math.floor(alpha * ($e72df59f80933534$var$GRADIENT_LEVELS - 1)) * 4;
            // Simple optimize to ignore the empty data
            if (alpha > 0) {
                var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange;
                // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
                alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
                pixels[offset++] = gradient[gradientOffset];
                pixels[offset++] = gradient[gradientOffset + 1];
                pixels[offset++] = gradient[gradientOffset + 2];
                pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
            } else offset += 4;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    /**
   * get canvas of a black circle brush used for canvas to draw later
   */ HeatmapLayer.prototype._getBrush = function() {
        var brushCanvas = this._brushCanvas || (this._brushCanvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas());
        // set brush size
        var r = this.pointSize + this.blurSize;
        var d = r * 2;
        brushCanvas.width = d;
        brushCanvas.height = d;
        var ctx = brushCanvas.getContext("2d");
        ctx.clearRect(0, 0, d, d);
        // in order to render shadow without the distinct circle,
        // draw the distinct circle in an invisible place,
        // and use shadowOffset to draw shadow in the center of the canvas
        ctx.shadowOffsetX = d;
        ctx.shadowBlur = this.blurSize;
        // draw the shadow in black, and use alpha and shadow blur to generate
        // color in color map
        ctx.shadowColor = "#000";
        // draw circle in the left to the canvas
        ctx.beginPath();
        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return brushCanvas;
    };
    /**
   * get gradient color map
   * @private
   */ HeatmapLayer.prototype._getGradient = function(colorFunc, state) {
        var gradientPixels = this._gradientPixels;
        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(1024));
        var color = [
            0,
            0,
            0,
            0
        ];
        var off = 0;
        for(var i = 0; i < 256; i++){
            colorFunc[state](i / 255, true, color);
            pixelsSingleState[off++] = color[0];
            pixelsSingleState[off++] = color[1];
            pixelsSingleState[off++] = color[2];
            pixelsSingleState[off++] = color[3];
        }
        return pixelsSingleState;
    };
    return HeatmapLayer;
}();
var $e72df59f80933534$export$2e2bcd8739ae039 = $e72df59f80933534$var$HeatmapLayer;






function $62f45dd0b06f949c$var$getIsInPiecewiseRange(dataExtent, pieceList, selected) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    pieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(pieceList, function(piece) {
        return {
            interval: [
                (piece.interval[0] - dataExtent[0]) / dataSpan,
                (piece.interval[1] - dataExtent[0]) / dataSpan
            ]
        };
    });
    var len = pieceList.length;
    var lastIndex = 0;
    return function(val) {
        var i;
        // Try to find in the location of the last found
        for(i = lastIndex; i < len; i++){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        if (i === len) // Not found, back interation
        for(i = lastIndex - 1; i >= 0; i--){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        return i >= 0 && i < len && selected[i];
    };
}
function $62f45dd0b06f949c$var$getIsInContinuousRange(dataExtent, range) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    range = [
        (range[0] - dataExtent[0]) / dataSpan,
        (range[1] - dataExtent[0]) / dataSpan
    ];
    return function(val) {
        return val >= range[0] && val <= range[1];
    };
}
function $62f45dd0b06f949c$var$isGeoCoordSys(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === "lng" && dimensions[1] === "lat";
}
var $62f45dd0b06f949c$var$HeatmapView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(HeatmapView, _super);
    function HeatmapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapView.type;
        return _this;
    }
    HeatmapView.prototype.render = function(seriesModel, ecModel, api) {
        var visualMapOfThisSeries;
        ecModel.eachComponent("visualMap", function(visualMap) {
            visualMap.eachTargetSeries(function(targetSeries) {
                if (targetSeries === seriesModel) visualMapOfThisSeries = visualMap;
            });
        });
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this.group.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === "cartesian2d" || coordSys.type === "calendar") this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
        else if ($62f45dd0b06f949c$var$isGeoCoordSys(coordSys)) this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    };
    HeatmapView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this.group.removeAll();
    };
    HeatmapView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys) {
            // geo does not support incremental rendering?
            if ($62f45dd0b06f949c$var$isGeoCoordSys(coordSys)) this.render(seriesModel, ecModel, api);
            else {
                this._progressiveEls = [];
                this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
            }
        }
    };
    HeatmapView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    HeatmapView.prototype._renderOnCartesianAndCalendar = function(seriesModel, api, start, end, incremental) {
        var coordSys = seriesModel.coordinateSystem;
        var isCartesian2d = (0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d");
        var width;
        var height;
        var xAxisExtent;
        var yAxisExtent;
        if (isCartesian2d) {
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            // add 0.5px to avoid the gaps
            width = xAxis.getBandWidth() + .5;
            height = yAxis.getBandWidth() + .5;
            xAxisExtent = xAxis.scale.getExtent();
            yAxisExtent = yAxis.scale.getExtent();
        }
        var group = this.group;
        var data = seriesModel.getData();
        var emphasisStyle = seriesModel.getModel([
            "emphasis",
            "itemStyle"
        ]).getItemStyle();
        var blurStyle = seriesModel.getModel([
            "blur",
            "itemStyle"
        ]).getItemStyle();
        var selectStyle = seriesModel.getModel([
            "select",
            "itemStyle"
        ]).getItemStyle();
        var borderRadius = seriesModel.get([
            "itemStyle",
            "borderRadius"
        ]);
        var labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel);
        var emphasisModel = seriesModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var blurScope = emphasisModel.get("blurScope");
        var emphasisDisabled = emphasisModel.get("disabled");
        var dataDims = isCartesian2d ? [
            data.mapDimension("x"),
            data.mapDimension("y"),
            data.mapDimension("value")
        ] : [
            data.mapDimension("time"),
            data.mapDimension("value")
        ];
        for(var idx = start; idx < end; idx++){
            var rect = void 0;
            var style = data.getItemVisual(idx, "style");
            if (isCartesian2d) {
                var dataDimX = data.get(dataDims[0], idx);
                var dataDimY = data.get(dataDims[1], idx);
                // Ignore empty data and out of extent data
                if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) continue;
                var point = coordSys.dataToPoint([
                    dataDimX,
                    dataDimY
                ]);
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    shape: {
                        x: point[0] - width / 2,
                        y: point[1] - height / 2,
                        width: width,
                        height: height
                    },
                    style: style
                });
            } else {
                // Ignore empty data
                if (isNaN(data.get(dataDims[1], idx))) continue;
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    z2: 1,
                    shape: coordSys.dataToRect([
                        data.get(dataDims[0], idx)
                    ]).contentShape,
                    style: style
                });
            }
            // Optimization for large dataset
            if (data.hasItemOption) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel_1 = itemModel.getModel("emphasis");
                emphasisStyle = emphasisModel_1.getModel("itemStyle").getItemStyle();
                blurStyle = itemModel.getModel([
                    "blur",
                    "itemStyle"
                ]).getItemStyle();
                selectStyle = itemModel.getModel([
                    "select",
                    "itemStyle"
                ]).getItemStyle();
                // Each item value struct in the data would be firstly
                // {
                //     itemStyle: { borderRadius: [30, 30] },
                //     value: [2022, 02, 22]
                // }
                borderRadius = itemModel.get([
                    "itemStyle",
                    "borderRadius"
                ]);
                focus = emphasisModel_1.get("focus");
                blurScope = emphasisModel_1.get("blurScope");
                emphasisDisabled = emphasisModel_1.get("disabled");
                labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
            }
            rect.shape.r = borderRadius;
            var rawValue = seriesModel.getRawValue(idx);
            var defaultText = "-";
            if (rawValue && rawValue[2] != null) defaultText = rawValue[2] + "";
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rect, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultOpacity: style.opacity,
                defaultText: defaultText
            });
            rect.ensureState("emphasis").style = emphasisStyle;
            rect.ensureState("blur").style = blurStyle;
            rect.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(rect, focus, blurScope, emphasisDisabled);
            rect.incremental = incremental;
            // PENDING
            if (incremental) // Rect must use hover layer if it's incremental.
            rect.states.emphasis.hoverLayer = true;
            group.add(rect);
            data.setItemGraphicEl(idx, rect);
            if (this._progressiveEls) this._progressiveEls.push(rect);
        }
    };
    HeatmapView.prototype._renderOnGeo = function(geo, seriesModel, visualMapModel, api) {
        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange;
        // if (!visualMapping) {
        //     throw new Error('Data range must have color visuals');
        // }
        var data = seriesModel.getData();
        var hmLayer = this._hmLayer || this._hmLayer || new (0, $e72df59f80933534$export$2e2bcd8739ae039)();
        hmLayer.blurSize = seriesModel.get("blurSize");
        hmLayer.pointSize = seriesModel.get("pointSize");
        hmLayer.minOpacity = seriesModel.get("minOpacity");
        hmLayer.maxOpacity = seriesModel.get("maxOpacity");
        var rect = geo.getViewRect().clone();
        var roamTransform = geo.getRoamTransform();
        rect.applyTransform(roamTransform);
        // Clamp on viewport
        var x = Math.max(rect.x, 0);
        var y = Math.max(rect.y, 0);
        var x2 = Math.min(rect.width + rect.x, api.getWidth());
        var y2 = Math.min(rect.height + rect.y, api.getHeight());
        var width = x2 - x;
        var height = y2 - y;
        var dims = [
            data.mapDimension("lng"),
            data.mapDimension("lat"),
            data.mapDimension("value")
        ];
        var points = data.mapArray(dims, function(lng, lat, value) {
            var pt = geo.dataToPoint([
                lng,
                lat
            ]);
            pt[0] -= x;
            pt[1] -= y;
            pt.push(value);
            return pt;
        });
        var dataExtent = visualMapModel.getExtent();
        var isInRange = visualMapModel.type === "visualMap.continuous" ? $62f45dd0b06f949c$var$getIsInContinuousRange(dataExtent, visualMapModel.option.range) : $62f45dd0b06f949c$var$getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
            inRange: inRangeVisuals.color.getColorMapper(),
            outOfRange: outOfRangeVisuals.color.getColorMapper()
        }, isInRange);
        var img = new $86adec94217b86c6$export$2e2bcd8739ae039({
            style: {
                width: width,
                height: height,
                x: x,
                y: y,
                image: hmLayer.canvas
            },
            silent: true
        });
        this.group.add(img);
    };
    HeatmapView.type = "heatmap";
    return HeatmapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $62f45dd0b06f949c$export$2e2bcd8739ae039 = $62f45dd0b06f949c$var$HeatmapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4b84759fb7a8174c$var$HeatmapSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(HeatmapSeriesModel, _super);
    function HeatmapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapSeriesModel.type;
        return _this;
    }
    HeatmapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            generateCoord: "value"
        });
    };
    HeatmapSeriesModel.prototype.preventIncremental = function() {
        var coordSysCreator = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(this.get("coordinateSystem"));
        if (coordSysCreator && coordSysCreator.dimensions) return coordSysCreator.dimensions[0] === "lng" && coordSysCreator.dimensions[1] === "lat";
    };
    HeatmapSeriesModel.type = "series.heatmap";
    HeatmapSeriesModel.dependencies = [
        "grid",
        "geo",
        "calendar"
    ];
    HeatmapSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0,
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        }
    };
    return HeatmapSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $4b84759fb7a8174c$export$2e2bcd8739ae039 = $4b84759fb7a8174c$var$HeatmapSeriesModel;


function $c53e84d38e53ec61$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $62f45dd0b06f949c$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $4b84759fb7a8174c$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











var $55a0f29f32f7b1c4$var$BAR_BORDER_WIDTH_QUERY = [
    "itemStyle",
    "borderWidth"
];
// index: +isHorizontal
var $55a0f29f32f7b1c4$var$LAYOUT_ATTRS = [
    {
        xy: "x",
        wh: "width",
        index: 0,
        posDesc: [
            "left",
            "right"
        ]
    },
    {
        xy: "y",
        wh: "height",
        index: 1,
        posDesc: [
            "top",
            "bottom"
        ]
    }
];
var $55a0f29f32f7b1c4$var$pathForLineWidth = new $5b455ae6f843ac47$exports.Circle();
var $55a0f29f32f7b1c4$var$PictorialBarView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PictorialBarView, _super);
    function PictorialBarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarView.type;
        return _this;
    }
    PictorialBarView.prototype.render = function(seriesModel, ecModel, api) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var coordSysRect = cartesian.master.getRect();
        var opt = {
            ecSize: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            seriesModel: seriesModel,
            coordSys: cartesian,
            coordSysExtent: [
                [
                    coordSysRect.x,
                    coordSysRect.x + coordSysRect.width
                ],
                [
                    coordSysRect.y,
                    coordSysRect.y + coordSysRect.height
                ]
            ],
            isHorizontal: isHorizontal,
            valueDim: $55a0f29f32f7b1c4$var$LAYOUT_ATTRS[+isHorizontal],
            categoryDim: $55a0f29f32f7b1c4$var$LAYOUT_ATTRS[1 - +isHorizontal]
        };
        data.diff(oldData).add(function(dataIndex) {
            if (!data.hasValue(dataIndex)) return;
            var itemModel = $55a0f29f32f7b1c4$var$getItemModel(data, dataIndex);
            var symbolMeta = $55a0f29f32f7b1c4$var$getSymbolMeta(data, dataIndex, itemModel, opt);
            var bar = $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta);
            data.setItemGraphicEl(dataIndex, bar);
            group.add(bar);
            $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta);
        }).update(function(newIndex, oldIndex) {
            var bar = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex)) {
                group.remove(bar);
                return;
            }
            var itemModel = $55a0f29f32f7b1c4$var$getItemModel(data, newIndex);
            var symbolMeta = $55a0f29f32f7b1c4$var$getSymbolMeta(data, newIndex, itemModel, opt);
            var pictorialShapeStr = $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta);
            if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
                group.remove(bar);
                data.setItemGraphicEl(newIndex, null);
                bar = null;
            }
            if (bar) $55a0f29f32f7b1c4$var$updateBar(bar, opt, symbolMeta);
            else bar = $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta, true);
            data.setItemGraphicEl(newIndex, bar);
            bar.__pictorialSymbolMeta = symbolMeta;
            // Add back
            group.add(bar);
            $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta);
        }).remove(function(dataIndex) {
            var bar = oldData.getItemGraphicEl(dataIndex);
            bar && $55a0f29f32f7b1c4$var$removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
        }).execute();
        // Do clipping
        var clipPath = seriesModel.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
        return this.group;
    };
    PictorialBarView.prototype.remove = function(ecModel, api) {
        var group = this.group;
        var data = this._data;
        if (ecModel.get("animation")) {
            if (data) data.eachItemGraphicEl(function(bar) {
                $55a0f29f32f7b1c4$var$removeBar(data, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(bar).dataIndex, ecModel, bar);
            });
        } else group.removeAll();
    };
    PictorialBarView.type = "pictorialBar";
    return PictorialBarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
// Set or calculate default value about symbol, and calculate layout info.
function $55a0f29f32f7b1c4$var$getSymbolMeta(data, dataIndex, itemModel, opt) {
    var layout = data.getItemLayout(dataIndex);
    var symbolRepeat = itemModel.get("symbolRepeat");
    var symbolClip = itemModel.get("symbolClip");
    var symbolPosition = itemModel.get("symbolPosition") || "start";
    var symbolRotate = itemModel.get("symbolRotate");
    var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var symbolPatternSize = itemModel.get("symbolPatternSize") || 2;
    var isAnimationEnabled = itemModel.isAnimationEnabled();
    var symbolMeta = {
        dataIndex: dataIndex,
        layout: layout,
        itemModel: itemModel,
        symbolType: data.getItemVisual(dataIndex, "symbol") || "circle",
        style: data.getItemVisual(dataIndex, "style"),
        symbolClip: symbolClip,
        symbolRepeat: symbolRepeat,
        symbolRepeatDirection: itemModel.get("symbolRepeatDirection"),
        symbolPatternSize: symbolPatternSize,
        rotation: rotation,
        animationModel: isAnimationEnabled ? itemModel : null,
        hoverScale: isAnimationEnabled && itemModel.get([
            "emphasis",
            "scale"
        ]),
        z2: itemModel.getShallow("z", true) || 0
    };
    $55a0f29f32f7b1c4$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
    var symbolSize = symbolMeta.symbolSize;
    var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(itemModel.get("symbolOffset"), symbolSize);
    $55a0f29f32f7b1c4$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
    return symbolMeta;
}
// bar length can be negative.
function $55a0f29f32f7b1c4$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var symbolBoundingData = itemModel.get("symbolBoundingData");
    var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
    var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
    var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
    var boundingLength;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(symbolBoundingData)) {
        var symbolBoundingExtent = [
            $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx,
            $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx
        ];
        symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
        boundingLength = symbolBoundingExtent[pxSignIdx];
    } else if (symbolBoundingData != null) boundingLength = $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
    else if (symbolRepeat) boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
    else boundingLength = layout[valueDim.wh];
    outputSymbolMeta.boundingLength = boundingLength;
    if (symbolRepeat) outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
    // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
    // and when borderWidth be settled, the actual linewidth will be NaN
    outputSymbolMeta.pxSign = boundingLength > 0 ? 1 : -1;
}
function $55a0f29f32f7b1c4$var$convertToCoordOnAxis(axis, value) {
    return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
}
// Support ['100%', '100%']
function $55a0f29f32f7b1c4$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var categoryDim = opt.categoryDim;
    var categorySize = Math.abs(layout[categoryDim.wh]);
    var symbolSize = data.getItemVisual(dataIndex, "symbolSize");
    var parsedSymbolSize;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(symbolSize)) parsedSymbolSize = symbolSize.slice();
    else if (symbolSize == null) // will parse to number below
    parsedSymbolSize = [
        "100%",
        "100%"
    ];
    else parsedSymbolSize = [
        symbolSize,
        symbolSize
    ];
    // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
    // to complicated to calculate real percent value if considering scaled lineWidth.
    // So the actual size will bigger than layout size if lineWidth is bigger than zero,
    // which can be tolerated in pictorial chart.
    parsedSymbolSize[categoryDim.index] = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(parsedSymbolSize[categoryDim.index], categorySize);
    parsedSymbolSize[valueDim.index] = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
    outputSymbolMeta.symbolSize = parsedSymbolSize;
    // If x or y is less than zero, show reversed shape.
    var symbolScale = outputSymbolMeta.symbolScale = [
        parsedSymbolSize[0] / symbolPatternSize,
        parsedSymbolSize[1] / symbolPatternSize
    ];
    // Follow convention, 'right' and 'top' is the normal scale.
    symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}
function $55a0f29f32f7b1c4$var$prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
    // In symbols are drawn with scale, so do not need to care about the case that width
    // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
    // be calculated.
    var valueLineWidth = itemModel.get($55a0f29f32f7b1c4$var$BAR_BORDER_WIDTH_QUERY) || 0;
    if (valueLineWidth) {
        $55a0f29f32f7b1c4$var$pathForLineWidth.attr({
            scaleX: symbolScale[0],
            scaleY: symbolScale[1],
            rotation: rotation
        });
        $55a0f29f32f7b1c4$var$pathForLineWidth.updateTransform();
        valueLineWidth /= $55a0f29f32f7b1c4$var$pathForLineWidth.getLineScale();
        valueLineWidth *= symbolScale[opt.valueDim.index];
    }
    outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
}
function $55a0f29f32f7b1c4$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
    var categoryDim = opt.categoryDim;
    var valueDim = opt.valueDim;
    var pxSign = outputSymbolMeta.pxSign;
    var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
    var pathLen = unitLength;
    // Note: rotation will not effect the layout of symbols, because user may
    // want symbols to rotate on its center, which should not be translated
    // when rotating.
    if (symbolRepeat) {
        var absBoundingLength = Math.abs(boundingLength);
        var symbolMargin = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(itemModel.get("symbolMargin"), "15%") + "";
        var hasEndGap = false;
        if (symbolMargin.lastIndexOf("!") === symbolMargin.length - 1) {
            hasEndGap = true;
            symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
        }
        var symbolMarginNumeric = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(symbolMargin, symbolSize[valueDim.index]);
        var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0);
        // When symbol margin is less than 0, margin at both ends will be subtracted
        // to ensure that all of the symbols will not be overflow the given area.
        var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Both final repeatTimes and final symbolMarginNumeric area calculated based on
        // boundingLength.
        var repeatSpecified = (0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(symbolRepeat);
        var repeatTimes = repeatSpecified ? symbolRepeat : $55a0f29f32f7b1c4$var$toIntTimes((absBoundingLength + endFix) / uLenWithMargin);
        // Adjust calculate margin, to ensure each symbol is displayed
        // entirely in the given layout area.
        var mDiff = absBoundingLength - repeatTimes * unitLength;
        symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
        uLenWithMargin = unitLength + symbolMarginNumeric * 2;
        endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Update repeatTimes when not all symbol will be shown.
        if (!repeatSpecified && symbolRepeat !== "fixed") repeatTimes = repeatCutLength ? $55a0f29f32f7b1c4$var$toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
        pathLen = repeatTimes * uLenWithMargin - endFix;
        outputSymbolMeta.repeatTimes = repeatTimes;
        outputSymbolMeta.symbolMargin = symbolMarginNumeric;
    }
    var sizeFix = pxSign * (pathLen / 2);
    var pathPosition = outputSymbolMeta.pathPosition = [];
    pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
    pathPosition[valueDim.index] = symbolPosition === "start" ? sizeFix : symbolPosition === "end" ? boundingLength - sizeFix : boundingLength / 2; // 'center'
    if (symbolOffset) {
        pathPosition[0] += symbolOffset[0];
        pathPosition[1] += symbolOffset[1];
    }
    var bundlePosition = outputSymbolMeta.bundlePosition = [];
    bundlePosition[categoryDim.index] = layout[categoryDim.xy];
    bundlePosition[valueDim.index] = layout[valueDim.xy];
    var barRectShape = outputSymbolMeta.barRectShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, layout);
    barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
    barRectShape[categoryDim.wh] = layout[categoryDim.wh];
    var clipShape = outputSymbolMeta.clipShape = {};
    // Consider that symbol may be overflow layout rect.
    clipShape[categoryDim.xy] = -layout[categoryDim.xy];
    clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
    clipShape[valueDim.xy] = 0;
    clipShape[valueDim.wh] = layout[valueDim.wh];
}
function $55a0f29f32f7b1c4$var$createPath(symbolMeta) {
    var symbolPatternSize = symbolMeta.symbolPatternSize;
    var path = (0, $5370466dadc978d7$export$af050e04da3a02e8)(// Consider texture img, make a big size.
    symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
    path.attr({
        culling: true
    });
    path.type !== "image" && path.setStyle({
        strokeNoScale: true
    });
    return path;
}
function $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var symbolSize = symbolMeta.symbolSize;
    var valueLineWidth = symbolMeta.valueLineWidth;
    var pathPosition = symbolMeta.pathPosition;
    var valueDim = opt.valueDim;
    var repeatTimes = symbolMeta.repeatTimes || 0;
    var index = 0;
    var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        if (index < repeatTimes) $55a0f29f32f7b1c4$var$updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
        else $55a0f29f32f7b1c4$var$updateAttr(path, null, {
            scaleX: 0,
            scaleY: 0
        }, symbolMeta, isUpdate, function() {
            bundle.remove(path);
        });
        // updateHoverAnimation(path, symbolMeta);
        index++;
    });
    for(; index < repeatTimes; index++){
        var path = $55a0f29f32f7b1c4$var$createPath(symbolMeta);
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        bundle.add(path);
        var target = makeTarget(index);
        $55a0f29f32f7b1c4$var$updateAttr(path, {
            x: target.x,
            y: target.y,
            scaleX: 0,
            scaleY: 0
        }, {
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            rotation: target.rotation
        }, symbolMeta, isUpdate);
    }
    function makeTarget(index) {
        var position = pathPosition.slice();
        // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
        // Otherwise: i = index;
        var pxSign = symbolMeta.pxSign;
        var i = index;
        if (symbolMeta.symbolRepeatDirection === "start" ? pxSign > 0 : pxSign < 0) i = repeatTimes - 1 - index;
        position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
        return {
            x: position[0],
            y: position[1],
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1],
            rotation: symbolMeta.rotation
        };
    }
}
function $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var mainPath = bar.__pictorialMainPath;
    if (!mainPath) {
        mainPath = bar.__pictorialMainPath = $55a0f29f32f7b1c4$var$createPath(symbolMeta);
        bundle.add(mainPath);
        $55a0f29f32f7b1c4$var$updateAttr(mainPath, {
            x: symbolMeta.pathPosition[0],
            y: symbolMeta.pathPosition[1],
            scaleX: 0,
            scaleY: 0,
            rotation: symbolMeta.rotation
        }, {
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1]
        }, symbolMeta, isUpdate);
    } else $55a0f29f32f7b1c4$var$updateAttr(mainPath, null, {
        x: symbolMeta.pathPosition[0],
        y: symbolMeta.pathPosition[1],
        scaleX: symbolMeta.symbolScale[0],
        scaleY: symbolMeta.symbolScale[1],
        rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
}
// bar rect is used for label.
function $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
    var rectShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, symbolMeta.barRectShape);
    var barRect = bar.__pictorialBarRect;
    if (!barRect) {
        barRect = bar.__pictorialBarRect = new $5b455ae6f843ac47$exports.Rect({
            z2: 2,
            shape: rectShape,
            silent: true,
            style: {
                stroke: "transparent",
                fill: "transparent",
                lineWidth: 0
            }
        });
        barRect.disableMorphing = true;
        bar.add(barRect);
    } else $55a0f29f32f7b1c4$var$updateAttr(barRect, null, {
        shape: rectShape
    }, symbolMeta, isUpdate);
}
function $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
    // If not clip, symbol will be remove and rebuilt.
    if (symbolMeta.symbolClip) {
        var clipPath = bar.__pictorialClipPath;
        var clipShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, symbolMeta.clipShape);
        var valueDim = opt.valueDim;
        var animationModel = symbolMeta.animationModel;
        var dataIndex = symbolMeta.dataIndex;
        if (clipPath) $5b455ae6f843ac47$exports.updateProps(clipPath, {
            shape: clipShape
        }, animationModel, dataIndex);
        else {
            clipShape[valueDim.wh] = 0;
            clipPath = new $5b455ae6f843ac47$exports.Rect({
                shape: clipShape
            });
            bar.__pictorialBundle.setClipPath(clipPath);
            bar.__pictorialClipPath = clipPath;
            var target = {};
            target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
            $5b455ae6f843ac47$exports[isUpdate ? "updateProps" : "initProps"](clipPath, {
                shape: target
            }, animationModel, dataIndex);
        }
    }
}
function $55a0f29f32f7b1c4$var$getItemModel(data, dataIndex) {
    var itemModel = data.getItemModel(dataIndex);
    itemModel.getAnimationDelayParams = $55a0f29f32f7b1c4$var$getAnimationDelayParams;
    itemModel.isAnimationEnabled = $55a0f29f32f7b1c4$var$isAnimationEnabled;
    return itemModel;
}
function $55a0f29f32f7b1c4$var$getAnimationDelayParams(path) {
    // The order is the same as the z-order, see `symbolRepeatDiretion`.
    return {
        index: path.__pictorialAnimationIndex,
        count: path.__pictorialRepeatTimes
    };
}
function $55a0f29f32f7b1c4$var$isAnimationEnabled() {
    // `animation` prop can be set on itemModel in pictorial bar chart.
    return this.parentModel.isAnimationEnabled() && !!this.getShallow("animation");
}
function $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta, isUpdate) {
    // bar is the main element for each data.
    var bar = new $5b455ae6f843ac47$exports.Group();
    // bundle is used for location and clip.
    var bundle = new $5b455ae6f843ac47$exports.Group();
    bar.add(bundle);
    bar.__pictorialBundle = bundle;
    bundle.x = symbolMeta.bundlePosition[0];
    bundle.y = symbolMeta.bundlePosition[1];
    if (symbolMeta.symbolRepeat) $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
    else $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate);
    $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
    bar.__pictorialShapeStr = $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta);
    bar.__pictorialSymbolMeta = symbolMeta;
    return bar;
}
function $55a0f29f32f7b1c4$var$updateBar(bar, opt, symbolMeta) {
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;
    var bundle = bar.__pictorialBundle;
    $5b455ae6f843ac47$exports.updateProps(bundle, {
        x: symbolMeta.bundlePosition[0],
        y: symbolMeta.bundlePosition[1]
    }, animationModel, dataIndex);
    if (symbolMeta.symbolRepeat) $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
    else $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
    $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, true);
    $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, true);
}
function $55a0f29f32f7b1c4$var$removeBar(data, dataIndex, animationModel, bar) {
    // Not show text when animating
    var labelRect = bar.__pictorialBarRect;
    labelRect && labelRect.removeTextContent();
    var paths = [];
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        paths.push(path);
    });
    bar.__pictorialMainPath && paths.push(bar.__pictorialMainPath);
    // I do not find proper remove animation for clip yet.
    bar.__pictorialClipPath && (animationModel = null);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(paths, function(path) {
        $5b455ae6f843ac47$exports.removeElement(path, {
            scaleX: 0,
            scaleY: 0
        }, animationModel, dataIndex, function() {
            bar.parent && bar.parent.remove(bar);
        });
    });
    data.setItemGraphicEl(dataIndex, null);
}
function $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta) {
    return [
        data.getItemVisual(symbolMeta.dataIndex, "symbol") || "none",
        !!symbolMeta.symbolRepeat,
        !!symbolMeta.symbolClip
    ].join(":");
}
function $55a0f29f32f7b1c4$var$eachPath(bar, cb, context) {
    // Do not use Group#eachChild, because it do not support remove.
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(bar.__pictorialBundle.children(), function(el) {
        el !== bar.__pictorialBarRect && cb.call(context, el);
    });
}
function $55a0f29f32f7b1c4$var$updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
    immediateAttrs && el.attr(immediateAttrs);
    // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
    if (symbolMeta.symbolClip && !isUpdate) animationAttrs && el.attr(animationAttrs);
    else animationAttrs && $5b455ae6f843ac47$exports[isUpdate ? "updateProps" : "initProps"](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
}
function $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta) {
    var dataIndex = symbolMeta.dataIndex;
    var itemModel = symbolMeta.itemModel;
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var emphasisModel = itemModel.getModel("emphasis");
    var emphasisStyle = emphasisModel.getModel("itemStyle").getItemStyle();
    var blurStyle = itemModel.getModel([
        "blur",
        "itemStyle"
    ]).getItemStyle();
    var selectStyle = itemModel.getModel([
        "select",
        "itemStyle"
    ]).getItemStyle();
    var cursorStyle = itemModel.getShallow("cursor");
    var focus = emphasisModel.get("focus");
    var blurScope = emphasisModel.get("blurScope");
    var hoverScale = emphasisModel.get("scale");
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        if (path instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = path.style;
            path.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                // TODO other properties like dx, dy ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolMeta.style));
        } else path.useStyle(symbolMeta.style);
        var emphasisState = path.ensureState("emphasis");
        emphasisState.style = emphasisStyle;
        if (hoverScale) {
            // NOTE: Must after scale is set after updateAttr
            emphasisState.scaleX = path.scaleX * 1.1;
            emphasisState.scaleY = path.scaleY * 1.1;
        }
        path.ensureState("blur").style = blurStyle;
        path.ensureState("select").style = selectStyle;
        cursorStyle && (path.cursor = cursorStyle);
        path.z2 = symbolMeta.z2;
    });
    var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
    var barRect = bar.__pictorialBarRect;
    barRect.ignoreClip = true;
    (0, $6800dfcb6e1e2a44$export$9a13992917966657)(barRect, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
        labelFetcher: opt.seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(opt.seriesModel.getData(), dataIndex),
        inheritColor: symbolMeta.style.fill,
        defaultOpacity: symbolMeta.style.opacity,
        defaultOutsidePosition: barPositionOutside
    });
    (0, $2bf82c0980125b62$export$e51187539ff11209)(bar, focus, blurScope, emphasisModel.get("disabled"));
}
function $55a0f29f32f7b1c4$var$toIntTimes(times) {
    var roundedTimes = Math.round(times);
    // Escapse accurate error
    return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}
var $55a0f29f32f7b1c4$export$2e2bcd8739ae039 = $55a0f29f32f7b1c4$var$PictorialBarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $eb46f662d47de4a6$var$PictorialBarSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PictorialBarSeriesModel, _super);
    function PictorialBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarSeriesModel.type;
        _this.hasSymbolVisual = true;
        _this.defaultSymbol = "roundRect";
        return _this;
    }
    PictorialBarSeriesModel.prototype.getInitialData = function(option) {
        // Disable stack.
        option.stack = null;
        return _super.prototype.getInitialData.apply(this, arguments);
    };
    PictorialBarSeriesModel.type = "series.pictorialBar";
    PictorialBarSeriesModel.dependencies = [
        "grid"
    ];
    PictorialBarSeriesModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $b508252f98157abf$export$2e2bcd8739ae039).defaultOption, {
        symbol: "circle",
        symbolSize: null,
        symbolRotate: null,
        symbolPosition: null,
        symbolOffset: null,
        symbolMargin: null,
        symbolRepeat: false,
        symbolRepeatDirection: "end",
        symbolClip: false,
        symbolBoundingData: null,
        symbolPatternSize: 400,
        barGap: "-100%",
        // Pictorial bar do not clip by default because in many cases
        // xAxis and yAxis are not displayed and it's expected not to clip
        clip: false,
        // z can be set in data item, which is z2 actually.
        // Disable progressive
        progressive: 0,
        emphasis: {
            // By default pictorialBar do not hover scale. Hover scale is not suitable
            // for the case that both has foreground and background.
            scale: false
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        }
    });
    return PictorialBarSeriesModel;
}((0, $b508252f98157abf$export$2e2bcd8739ae039));
var $eb46f662d47de4a6$export$2e2bcd8739ae039 = $eb46f662d47de4a6$var$PictorialBarSeriesModel;




function $7e25595b74be81a3$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $55a0f29f32f7b1c4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $eb46f662d47de4a6$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $361c48dd900de28f$export$b3219800bda33a1f), "pictorialBar"));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $361c48dd900de28f$export$16e8685758531cb6)("pictorialBar"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $91b53b7eca57e10b$var$ThemeRiverView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ThemeRiverView, _super);
    function ThemeRiverView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverView.type;
        _this._layers = [];
        return _this;
    }
    ThemeRiverView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var self = this;
        var group = this.group;
        var layersSeries = seriesModel.getLayerSeries();
        var layoutInfo = data.getLayout("layoutInfo");
        var rect = layoutInfo.rect;
        var boundaryGap = layoutInfo.boundaryGap;
        group.x = 0;
        group.y = rect.y + boundaryGap[0];
        function keyGetter(item) {
            return item.name;
        }
        var dataDiffer = new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(this._layersSeries || [], layersSeries, keyGetter, keyGetter);
        var newLayersGroups = [];
        dataDiffer.add((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "add")).update((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "update")).remove((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "remove")).execute();
        function process(status, idx, oldIdx) {
            var oldLayersGroups = self._layers;
            if (status === "remove") {
                group.remove(oldLayersGroups[idx]);
                return;
            }
            var points0 = [];
            var points1 = [];
            var style;
            var indices = layersSeries[idx].indices;
            var j = 0;
            for(; j < indices.length; j++){
                var layout = data.getItemLayout(indices[j]);
                var x = layout.x;
                var y0 = layout.y0;
                var y = layout.y;
                points0.push(x, y0);
                points1.push(x, y0 + y);
                style = data.getItemVisual(indices[j], "style");
            }
            var polygon;
            var textLayout = data.getItemLayout(indices[0]);
            var labelModel = seriesModel.getModel("label");
            var margin = labelModel.get("margin");
            var emphasisModel = seriesModel.getModel("emphasis");
            if (status === "add") {
                var layerGroup = newLayersGroups[idx] = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
                polygon = new (0, $5c417e1ed90142c5$export$6042a400d113f2bd)({
                    shape: {
                        points: points0,
                        stackedOnPoints: points1,
                        smooth: 0.4,
                        stackedOnSmooth: 0.4,
                        smoothConstraint: false
                    },
                    z2: 0
                });
                layerGroup.add(polygon);
                group.add(layerGroup);
                if (seriesModel.isAnimationEnabled()) polygon.setClipPath($91b53b7eca57e10b$var$createGridClipShape(polygon.getBoundingRect(), seriesModel, function() {
                    polygon.removeClipPath();
                }));
            } else {
                var layerGroup = oldLayersGroups[oldIdx];
                polygon = layerGroup.childAt(0);
                group.add(layerGroup);
                newLayersGroups[idx] = layerGroup;
                $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: points0,
                        stackedOnPoints: points1
                    }
                }, seriesModel);
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
            }
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polygon, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel), {
                labelDataIndex: indices[j - 1],
                defaultText: data.getName(indices[j - 1]),
                inheritColor: style.fill
            }, {
                normal: {
                    verticalAlign: "middle"
                }
            });
            polygon.setTextConfig({
                position: null,
                local: true
            });
            var labelEl = polygon.getTextContent();
            // TODO More label position options.
            if (labelEl) {
                labelEl.x = textLayout.x - margin;
                labelEl.y = textLayout.y0 + textLayout.y / 2;
            }
            polygon.useStyle(style);
            data.setItemGraphicEl(idx, polygon);
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, seriesModel);
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        }
        this._layersSeries = layersSeries;
        this._layers = newLayersGroups;
    };
    ThemeRiverView.type = "themeRiver";
    return ThemeRiverView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
// add animation to the view
function $91b53b7eca57e10b$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            x: rect.x - 50,
            width: rect.width + 100,
            height: rect.height + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $91b53b7eca57e10b$export$2e2bcd8739ae039 = $91b53b7eca57e10b$var$ThemeRiverView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $5814c4cad54e1e96$var$DATA_NAME_INDEX = 2;
var $5814c4cad54e1e96$var$ThemeRiverSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ThemeRiverSeriesModel, _super);
    function ThemeRiverSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverSeriesModel.type;
        return _this;
    }
    /**
   * @override
   */ ThemeRiverSeriesModel.prototype.init = function(option) {
        // eslint-disable-next-line
        _super.prototype.init.apply(this, arguments);
        // Put this function here is for the sake of consistency of code style.
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */ ThemeRiverSeriesModel.prototype.fixData = function(data) {
        var rawDataLength = data.length;
        /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */ var timeValueKeys = {};
        // grouped data by name
        var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(data, function(item) {
            if (!timeValueKeys.hasOwnProperty(item[0] + "")) timeValueKeys[item[0] + ""] = -1;
            return item[2];
        });
        var layerData = [];
        groupResult.buckets.each(function(items, key) {
            layerData.push({
                name: key,
                dataList: items
            });
        });
        var layerNum = layerData.length;
        for(var k = 0; k < layerNum; ++k){
            var name_1 = layerData[k].name;
            for(var j = 0; j < layerData[k].dataList.length; ++j){
                var timeValue = layerData[k].dataList[j][0] + "";
                timeValueKeys[timeValue] = k;
            }
            for(var timeValue in timeValueKeys)if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
                timeValueKeys[timeValue] = k;
                data[rawDataLength] = [
                    timeValue,
                    0,
                    name_1
                ];
                rawDataLength++;
            }
        }
        return data;
    };
    /**
   * @override
   * @param  option  the initial option that user gave
   * @param  ecModel  the model object for themeRiver option
   */ ThemeRiverSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var singleAxisModel = this.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var axisType = singleAxisModel.get("type");
        // filter the data item with the value of label is undefined
        var filterData = $7a1bd9c2710fea0d$export$3dea766d36a8935f(option.data, function(dataItem) {
            return dataItem[2] !== undefined;
        });
        // ??? TODO design a stage to transfer data for themeRiver and lines?
        var data = this.fixData(filterData || []);
        var nameList = [];
        var nameMap = this.nameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var count = 0;
        for(var i = 0; i < data.length; ++i){
            nameList.push(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX]);
            if (!nameMap.get(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX])) {
                nameMap.set(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX], count);
                count++;
            }
        }
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(data, {
            coordDimensions: [
                "single"
            ],
            dimensionsDefine: [
                {
                    name: "time",
                    type: (0, $18085de91ae59d03$export$af1622903e71278e)(axisType)
                },
                {
                    name: "value",
                    type: "float"
                },
                {
                    name: "name",
                    type: "ordinal"
                }
            ],
            encodeDefine: {
                single: 0,
                value: 1,
                itemName: 2
            }
        }).dimensions;
        var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, this);
        list.initData(data);
        return list;
    };
    /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   */ ThemeRiverSeriesModel.prototype.getLayerSeries = function() {
        var data = this.getData();
        var lenCount = data.count();
        var indexArr = [];
        for(var i = 0; i < lenCount; ++i)indexArr[i] = i;
        var timeDim = data.mapDimension("single");
        // data group by name
        var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(indexArr, function(index) {
            return data.get("name", index);
        });
        var layerSeries = [];
        groupResult.buckets.each(function(items, key) {
            items.sort(function(index1, index2) {
                return data.get(timeDim, index1) - data.get(timeDim, index2);
            });
            layerSeries.push({
                name: key,
                indices: items
            });
        });
        return layerSeries;
    };
    /**
   * Get data indices for show tooltip content
   */ ThemeRiverSeriesModel.prototype.getAxisTooltipData = function(dim, value, baseAxis) {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(dim)) dim = dim ? [
            dim
        ] : [];
        var data = this.getData();
        var layerSeries = this.getLayerSeries();
        var indices = [];
        var layerNum = layerSeries.length;
        var nestestValue;
        for(var i = 0; i < layerNum; ++i){
            var minDist = Number.MAX_VALUE;
            var nearestIdx = -1;
            var pointNum = layerSeries[i].indices.length;
            for(var j = 0; j < pointNum; ++j){
                var theValue = data.get(dim[0], layerSeries[i].indices[j]);
                var dist = Math.abs(theValue - value);
                if (dist <= minDist) {
                    nestestValue = theValue;
                    minDist = dist;
                    nearestIdx = layerSeries[i].indices[j];
                }
            }
            indices.push(nearestIdx);
        }
        return {
            dataIndices: indices,
            nestestValue: nestestValue
        };
    };
    ThemeRiverSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var name = data.getName(dataIndex);
        var value = data.get(data.mapDimension("value"), dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value
        });
    };
    ThemeRiverSeriesModel.type = "series.themeRiver";
    ThemeRiverSeriesModel.dependencies = [
        "singleAxis"
    ];
    ThemeRiverSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        coordinateSystem: "singleAxis",
        // gap in axis's orthogonal orientation
        boundaryGap: [
            "10%",
            "10%"
        ],
        // legendHoverLink: true,
        singleAxisIndex: 0,
        animationEasing: "linear",
        label: {
            margin: 4,
            show: true,
            position: "left",
            fontSize: 11
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return ThemeRiverSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $5814c4cad54e1e96$export$2e2bcd8739ae039 = $5814c4cad54e1e96$var$ThemeRiverSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $7dda345d99fef8ed$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("themeRiver", function(seriesModel) {
        var data = seriesModel.getData();
        var single = seriesModel.coordinateSystem;
        var layoutInfo = {};
        // use the axis boundingRect for view
        var rect = single.getRect();
        layoutInfo.rect = rect;
        var boundaryGap = seriesModel.get("boundaryGap");
        var axis = single.getAxis();
        layoutInfo.boundaryGap = boundaryGap;
        if (axis.orient === "horizontal") {
            boundaryGap[0] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[0], rect.height);
            boundaryGap[1] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[1], rect.height);
            var height = rect.height - boundaryGap[0] - boundaryGap[1];
            $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, height);
        } else {
            boundaryGap[0] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[0], rect.width);
            boundaryGap[1] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[1], rect.width);
            var width = rect.width - boundaryGap[0] - boundaryGap[1];
            $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, width);
        }
        data.setLayout("layoutInfo", layoutInfo);
    });
}
/**
 * The layout information about themeriver
 *
 * @param data  data in the series
 * @param seriesModel  the model object of themeRiver series
 * @param height  value used to compute every series height
 */ function $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, height) {
    if (!data.count()) return;
    var coordSys = seriesModel.coordinateSystem;
    // the data in each layer are organized into a series.
    var layerSeries = seriesModel.getLayerSeries();
    // the points in each layer.
    var timeDim = data.mapDimension("single");
    var valueDim = data.mapDimension("value");
    var layerPoints = $7a1bd9c2710fea0d$export$871de8747c9eaa88(layerSeries, function(singleLayer) {
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(singleLayer.indices, function(idx) {
            var pt = coordSys.dataToPoint(data.get(timeDim, idx));
            pt[1] = data.get(valueDim, idx);
            return pt;
        });
    });
    var base = $7dda345d99fef8ed$var$computeBaseline(layerPoints);
    var baseLine = base.y0;
    var ky = height / base.max;
    // set layout information for each item.
    var n = layerSeries.length;
    var m = layerSeries[0].indices.length;
    var baseY0;
    for(var j = 0; j < m; ++j){
        baseY0 = baseLine[j] * ky;
        data.setItemLayout(layerSeries[0].indices[j], {
            layerIndex: 0,
            x: layerPoints[0][j][0],
            y0: baseY0,
            y: layerPoints[0][j][1] * ky
        });
        for(var i = 1; i < n; ++i){
            baseY0 += layerPoints[i - 1][j][1] * ky;
            data.setItemLayout(layerSeries[i].indices[j], {
                layerIndex: i,
                x: layerPoints[i][j][0],
                y0: baseY0,
                y: layerPoints[i][j][1] * ky
            });
        }
    }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  data  the points in each layer
 */ function $7dda345d99fef8ed$var$computeBaseline(data) {
    var layerNum = data.length;
    var pointNum = data[0].length;
    var sums = [];
    var y0 = [];
    var max = 0;
    for(var i = 0; i < pointNum; ++i){
        var temp = 0;
        for(var j = 0; j < layerNum; ++j)temp += data[j][i][1];
        if (temp > max) max = temp;
        sums.push(temp);
    }
    for(var k = 0; k < pointNum; ++k)y0[k] = (max - sums[k]) / 2;
    max = 0;
    for(var l = 0; l < pointNum; ++l){
        var sum = sums[l] + y0[l];
        if (sum > max) max = sum;
    }
    return {
        y0: y0,
        max: max
    };
}



function $e883cd02390b2e6d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $91b53b7eca57e10b$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5814c4cad54e1e96$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7dda345d99fef8ed$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("themeRiver"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $9b5b8a865cafa8ae$var$DEFAULT_SECTOR_Z = 2;
var $9b5b8a865cafa8ae$var$DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 */ var $9b5b8a865cafa8ae$var$SunburstPiece = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SunburstPiece, _super);
    function SunburstPiece(node, seriesModel, ecModel, api) {
        var _this = _super.call(this) || this;
        _this.z2 = $9b5b8a865cafa8ae$var$DEFAULT_SECTOR_Z;
        _this.textConfig = {
            inside: true
        };
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(_this).seriesIndex = seriesModel.seriesIndex;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039({
            z2: $9b5b8a865cafa8ae$var$DEFAULT_TEXT_Z,
            silent: node.getModel().get([
                "label",
                "silent"
            ])
        });
        _this.setTextContent(text);
        _this.updateData(true, node, seriesModel, ecModel, api);
        return _this;
    }
    SunburstPiece.prototype.updateData = function(firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
    seriesModel, ecModel, api) {
        this.node = node;
        node.piece = this;
        seriesModel = seriesModel || this._seriesModel;
        ecModel = ecModel || this._ecModel;
        var sector = this;
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(sector).dataIndex = node.dataIndex;
        var itemModel = node.getModel();
        var emphasisModel = itemModel.getModel("emphasis");
        var layout = node.getLayout();
        var sectorShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, layout);
        sectorShape.label = null;
        var normalStyle = node.getVisual("style");
        normalStyle.lineJoin = "bevel";
        var decal = node.getVisual("decal");
        if (decal) normalStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
        var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), sectorShape, true);
        $7a1bd9c2710fea0d$export$8b58be045bf06082(sectorShape, cornerRadius);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2bf82c0980125b62$export$151308dceb52d5b), function(stateName) {
            var state = sector.ensureState(stateName);
            var itemStyleModel = itemModel.getModel([
                stateName,
                "itemStyle"
            ]);
            state.style = itemStyleModel.getItemStyle();
            // border radius
            var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemStyleModel, sectorShape);
            if (cornerRadius) state.shape = cornerRadius;
        });
        if (firstCreate) {
            sector.setShape(sectorShape);
            sector.shape.r = layout.r0;
            $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                shape: {
                    r: layout.r
                }
            }, seriesModel, node.dataIndex);
        } else {
            // Disable animation for gradient since no interpolation method
            // is supported for gradient
            $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(sector);
        }
        sector.useStyle(normalStyle);
        this._updateLabel(seriesModel);
        var cursorStyle = itemModel.getShallow("cursor");
        cursorStyle && sector.attr("cursor", cursorStyle);
        this._seriesModel = seriesModel || this._seriesModel;
        this._ecModel = ecModel || this._ecModel;
        var focus = emphasisModel.get("focus");
        var focusOrIndices = focus === "ancestor" ? node.getAncestorsIndices() : focus === "descendant" ? node.getDescendantIndices() : focus;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focusOrIndices, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    SunburstPiece.prototype._updateLabel = function(seriesModel) {
        var _this = this;
        var itemModel = this.node.getModel();
        var normalLabelModel = itemModel.getModel("label");
        var layout = this.node.getLayout();
        var angle = layout.endAngle - layout.startAngle;
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var sector = this;
        var label = sector.getTextContent();
        var dataIndex = this.node.dataIndex;
        var labelMinAngle = normalLabelModel.get("minAngle") / 180 * Math.PI;
        var isNormalShown = normalLabelModel.get("show") && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
        label.ignore = !isNormalShown;
        // TODO use setLabelStyle
        $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2bf82c0980125b62$export$57ee5306b85ad7d5), function(stateName) {
            var labelStateModel = stateName === "normal" ? itemModel.getModel("label") : itemModel.getModel([
                stateName,
                "label"
            ]);
            var isNormal = stateName === "normal";
            var state = isNormal ? label : label.ensureState(stateName);
            var text = seriesModel.getFormattedLabel(dataIndex, stateName);
            if (isNormal) text = text || _this.node.name;
            state.style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelStateModel, {}, null, stateName !== "normal", true);
            if (text) state.style.text = text;
            // Not displaying text when angle is too small
            var isShown = labelStateModel.get("show");
            if (isShown != null && !isNormal) state.ignore = !isShown;
            var labelPosition = getLabelAttr(labelStateModel, "position");
            var sectorState = isNormal ? sector : sector.states[stateName];
            var labelColor = sectorState.style.fill;
            sectorState.textConfig = {
                outsideFill: labelStateModel.get("color") === "inherit" ? labelColor : null,
                inside: labelPosition !== "outside"
            };
            var r;
            var labelPadding = getLabelAttr(labelStateModel, "distance") || 0;
            var textAlign = getLabelAttr(labelStateModel, "align");
            var rotateType = getLabelAttr(labelStateModel, "rotate");
            var flipStartAngle = Math.PI * 0.5;
            var flipEndAngle = Math.PI * 1.5;
            var midAngleNormal = (0, $b44a8536c7214e4f$export$d44861331f213635)(rotateType === "tangential" ? Math.PI / 2 - midAngle : midAngle);
            // For text that is up-side down, rotate 180 degrees to make sure
            // it's readable
            var needsFlip = midAngleNormal > flipStartAngle && !(0, $cfc1f3b422a3185f$export$d1df570aea2868f)(midAngleNormal - flipStartAngle) && midAngleNormal < flipEndAngle;
            if (labelPosition === "outside") {
                r = layout.r + labelPadding;
                textAlign = needsFlip ? "right" : "left";
            } else {
                if (!textAlign || textAlign === "center") {
                    // Put label in the center if it's a circle
                    if (angle === 2 * Math.PI && layout.r0 === 0) r = 0;
                    else r = (layout.r + layout.r0) / 2;
                    textAlign = "center";
                } else if (textAlign === "left") {
                    r = layout.r0 + labelPadding;
                    textAlign = needsFlip ? "right" : "left";
                } else if (textAlign === "right") {
                    r = layout.r - labelPadding;
                    textAlign = needsFlip ? "left" : "right";
                }
            }
            state.style.align = textAlign;
            state.style.verticalAlign = getLabelAttr(labelStateModel, "verticalAlign") || "middle";
            state.x = r * dx + layout.cx;
            state.y = r * dy + layout.cy;
            var rotate = 0;
            if (rotateType === "radial") rotate = (0, $b44a8536c7214e4f$export$d44861331f213635)(-midAngle) + (needsFlip ? Math.PI : 0);
            else if (rotateType === "tangential") rotate = (0, $b44a8536c7214e4f$export$d44861331f213635)(Math.PI / 2 - midAngle) + (needsFlip ? Math.PI : 0);
            else if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(rotateType)) rotate = rotateType * Math.PI / 180;
            state.rotation = (0, $b44a8536c7214e4f$export$d44861331f213635)(rotate);
        });
        function getLabelAttr(model, name) {
            var stateAttr = model.get(name);
            if (stateAttr == null) return normalLabelModel.get(name);
            return stateAttr;
        }
        label.dirtyStyle();
    };
    return SunburstPiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
var $9b5b8a865cafa8ae$export$2e2bcd8739ae039 = $9b5b8a865cafa8ae$var$SunburstPiece;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $aae4889dfc91fba0$export$b06afbbb40399c8b = "sunburstRootToNode";
var $aae4889dfc91fba0$var$HIGHLIGHT_ACTION = "sunburstHighlight";
var $aae4889dfc91fba0$var$UNHIGHLIGHT_ACTION = "sunburstUnhighlight";
function $aae4889dfc91fba0$export$d2def111ea616eb3(registers) {
    registers.registerAction({
        type: $aae4889dfc91fba0$export$b06afbbb40399c8b,
        update: "updateView"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "sunburst",
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var targetInfo = (0, $6341f66602946a06$export$c5445fa59c15dec4)(payload, [
                $aae4889dfc91fba0$export$b06afbbb40399c8b
            ], model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = (0, $6341f66602946a06$export$df59de26c77b5bea)(originViewRoot, targetInfo.node) ? "rollUp" : "drillDown";
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
    registers.registerAction({
        type: $aae4889dfc91fba0$var$HIGHLIGHT_ACTION,
        update: "none"
    }, function(payload, ecModel, api) {
        // Clone
        payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
        ecModel.eachComponent({
            mainType: "series",
            subType: "sunburst",
            query: payload
        }, handleHighlight);
        function handleHighlight(model) {
            var targetInfo = (0, $6341f66602946a06$export$c5445fa59c15dec4)(payload, [
                $aae4889dfc91fba0$var$HIGHLIGHT_ACTION
            ], model);
            if (targetInfo) payload.dataIndex = targetInfo.node.dataIndex;
        }
        // Fast forward action
        api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
            type: "highlight"
        }));
    });
    registers.registerAction({
        type: $aae4889dfc91fba0$var$UNHIGHLIGHT_ACTION,
        update: "updateView"
    }, function(payload, ecModel, api) {
        payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
        api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
            type: "downplay"
        }));
    });
}



var $270cb27be00846ce$var$SunburstView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SunburstView, _super);
    function SunburstView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstView.type;
        return _this;
    }
    SunburstView.prototype.render = function(seriesModel, ecModel, api, // @ts-ignore
    payload) {
        var self = this;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var data = seriesModel.getData();
        var virtualRoot = data.tree.root;
        var newRoot = seriesModel.getViewRoot();
        var group = this.group;
        var renderLabelForZeroData = seriesModel.get("renderLabelForZeroData");
        var newChildren = [];
        newRoot.eachNode(function(node) {
            newChildren.push(node);
        });
        var oldChildren = this._oldChildren || [];
        dualTravel(newChildren, oldChildren);
        renderRollUp(virtualRoot, newRoot);
        this._initEvents();
        this._oldChildren = newChildren;
        function dualTravel(newChildren, oldChildren) {
            if (newChildren.length === 0 && oldChildren.length === 0) return;
            new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove($7a1bd9c2710fea0d$export$c3095a23b368d1f2(processNode, null)).execute();
            function getKey(node) {
                return node.getId();
            }
            function processNode(newIdx, oldIdx) {
                var newNode = newIdx == null ? null : newChildren[newIdx];
                var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
                doRenderNode(newNode, oldNode);
            }
        }
        function doRenderNode(newNode, oldNode) {
            if (!renderLabelForZeroData && newNode && !newNode.getValue()) // Not render data with value 0
            newNode = null;
            if (newNode !== virtualRoot && oldNode !== virtualRoot) {
                if (oldNode && oldNode.piece) {
                    if (newNode) {
                        // Update
                        oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api);
                        // For tooltip
                        data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
                    } else // Remove
                    removeNode(oldNode);
                } else if (newNode) {
                    // Add
                    var piece = new (0, $9b5b8a865cafa8ae$export$2e2bcd8739ae039)(newNode, seriesModel, ecModel, api);
                    group.add(piece);
                    // For tooltip
                    data.setItemGraphicEl(newNode.dataIndex, piece);
                }
            }
        }
        function removeNode(node) {
            if (!node) return;
            if (node.piece) {
                group.remove(node.piece);
                node.piece = null;
            }
        }
        function renderRollUp(virtualRoot, viewRoot) {
            if (viewRoot.depth > 0) {
                // Render
                if (self.virtualPiece) // Update
                self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
                else {
                    // Add
                    self.virtualPiece = new (0, $9b5b8a865cafa8ae$export$2e2bcd8739ae039)(virtualRoot, seriesModel, ecModel, api);
                    group.add(self.virtualPiece);
                }
                // TODO event scope
                viewRoot.piece.off("click");
                self.virtualPiece.on("click", function(e) {
                    self._rootToNode(viewRoot.parentNode);
                });
            } else if (self.virtualPiece) {
                // Remove
                group.remove(self.virtualPiece);
                self.virtualPiece = null;
            }
        }
    };
    /**
   * @private
   */ SunburstView.prototype._initEvents = function() {
        var _this = this;
        this.group.off("click");
        this.group.on("click", function(e) {
            var targetFound = false;
            var viewRoot = _this.seriesModel.getViewRoot();
            viewRoot.eachNode(function(node) {
                if (!targetFound && node.piece && node.piece === e.target) {
                    var nodeClick = node.getModel().get("nodeClick");
                    if (nodeClick === "rootToNode") _this._rootToNode(node);
                    else if (nodeClick === "link") {
                        var itemModel = node.getModel();
                        var link = itemModel.get("link");
                        if (link) {
                            var linkTarget = itemModel.get("target", true) || "_blank";
                            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, linkTarget);
                        }
                    }
                    targetFound = true;
                }
            });
        });
    };
    /**
   * @private
   */ SunburstView.prototype._rootToNode = function(node) {
        if (node !== this.seriesModel.getViewRoot()) this.api.dispatchAction({
            type: (0, $aae4889dfc91fba0$export$b06afbbb40399c8b),
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: node
        });
    };
    /**
   * @implement
   */ SunburstView.prototype.containPoint = function(point, seriesModel) {
        var treeRoot = seriesModel.getData();
        var itemLayout = treeRoot.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    SunburstView.type = "sunburst";
    return SunburstView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $270cb27be00846ce$export$2e2bcd8739ae039 = $270cb27be00846ce$var$SunburstView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $5204df39d5781117$var$SunburstSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SunburstSeriesModel, _super);
    function SunburstSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstSeriesModel.type;
        _this.ignoreStyleOnData = true;
        return _this;
    }
    SunburstSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $5204df39d5781117$var$completeTreeValue(root);
        var levelModels = this._levelModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(option.levels || [], function(levelDefine) {
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine, this, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = levelModels[node.depth];
                levelModel && (model.parentModel = levelModel);
                return model;
            });
        }
        return tree.data;
    };
    SunburstSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /*
   * @override
   */ SunburstSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treePathInfo = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        return params;
    };
    SunburstSeriesModel.prototype.getLevelModel = function(node) {
        return this._levelModels && this._levelModels[node.depth];
    };
    SunburstSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    SunburstSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    SunburstSeriesModel.prototype.enableAriaDecal = function() {
        (0, $a116b59e46d9072c$export$2e2bcd8739ae039)(this);
    };
    SunburstSeriesModel.type = "series.sunburst";
    SunburstSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "75%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // 'rootToNode', 'link', or false
        nodeClick: "rootToNode",
        renderLabelForZeroData: false,
        label: {
            // could be: 'radial', 'tangential', or 'none'
            rotate: "radial",
            show: true,
            opacity: 1,
            // 'left' is for inner side of inside, and 'right' is for outer
            // side for inside
            align: "center",
            position: "inside",
            distance: 5,
            silent: true
        },
        itemStyle: {
            borderWidth: 1,
            borderColor: "white",
            borderType: "solid",
            shadowBlur: 0,
            shadowColor: "rgba(0, 0, 0, 0.2)",
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        emphasis: {
            focus: "descendant"
        },
        blur: {
            itemStyle: {
                opacity: 0.2
            },
            label: {
                opacity: 0.1
            }
        },
        // Animation type can be expansion, scale.
        animationType: "expansion",
        animationDuration: 1000,
        animationDurationUpdate: 500,
        data: [],
        /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */ sort: "desc"
    };
    return SunburstSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
function $5204df39d5781117$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataNode.children, function(child) {
        $5204df39d5781117$var$completeTreeValue(child);
        var childValue = child.value;
        // TODO First value of array must be a number
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
var $5204df39d5781117$export$2e2bcd8739ae039 = $5204df39d5781117$var$SunburstSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

// let PI2 = Math.PI * 2;
var $2ac615e1f67ae37a$var$RADIAN = Math.PI / 180;
function $2ac615e1f67ae37a$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var center = seriesModel.get("center");
        var radius = seriesModel.get("radius");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) radius = [
            0,
            radius
        ];
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        var width = api.getWidth();
        var height = api.getHeight();
        var size = Math.min(width, height);
        var cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width);
        var cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height);
        var r0 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
        var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
        var startAngle = -seriesModel.get("startAngle") * $2ac615e1f67ae37a$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $2ac615e1f67ae37a$var$RADIAN;
        var virtualRoot = seriesModel.getData().tree.root;
        var treeRoot = seriesModel.getViewRoot();
        var rootDepth = treeRoot.depth;
        var sort = seriesModel.get("sort");
        if (sort != null) $2ac615e1f67ae37a$var$initChildren(treeRoot, sort);
        var validDataCount = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(treeRoot.children, function(child) {
            !isNaN(child.getValue()) && validDataCount++;
        });
        var sum = treeRoot.getValue();
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var renderRollupNode = treeRoot.depth > 0;
        var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
        var rPerLevel = (r - r0) / (levels || 1);
        var clockwise = seriesModel.get("clockwise");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum");
        // In the case some sector angle is smaller than minAngle
        // let restAngle = PI2;
        // let valueSumLargerThanMinAngle = 0;
        var dir = clockwise ? 1 : -1;
        /**
     * Render a tree
     * @return increased angle
     */ var renderNode = function(node, startAngle) {
            if (!node) return;
            var endAngle = startAngle;
            // Render self
            if (node !== virtualRoot) {
                // Tree node is virtual, so it doesn't need to be drawn
                var value = node.getValue();
                var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
                if (angle < minAngle) angle = minAngle;
                // else {
                //     valueSumLargerThanMinAngle += value;
                // }
                endAngle = startAngle + dir * angle;
                var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
                var rStart = r0 + rPerLevel * depth;
                var rEnd = r0 + rPerLevel * (depth + 1);
                var levelModel = seriesModel.getLevelModel(node);
                if (levelModel) {
                    var r0_1 = levelModel.get("r0", true);
                    var r_1 = levelModel.get("r", true);
                    var radius_1 = levelModel.get("radius", true);
                    if (radius_1 != null) {
                        r0_1 = radius_1[0];
                        r_1 = radius_1[1];
                    }
                    r0_1 != null && (rStart = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(r0_1, size / 2));
                    r_1 != null && (rEnd = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(r_1, size / 2));
                }
                node.setLayout({
                    angle: angle,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: rStart,
                    r: rEnd
                });
            }
            // Render children
            if (node.children && node.children.length) {
                // currentAngle = startAngle;
                var siblingAngle_1 = 0;
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.children, function(node) {
                    siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
                });
            }
            return endAngle - startAngle;
        };
        // Virtual root node for roll up
        if (renderRollupNode) {
            var rStart = r0;
            var rEnd = r0 + rPerLevel;
            var angle = Math.PI * 2;
            virtualRoot.setLayout({
                angle: angle,
                startAngle: startAngle,
                endAngle: startAngle + angle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: rStart,
                r: rEnd
            });
        }
        renderNode(treeRoot, startAngle);
    });
}
/**
 * Init node children by order and update visual
 */ function $2ac615e1f67ae37a$var$initChildren(node, sortOrder) {
    var children = node.children || [];
    node.children = $2ac615e1f67ae37a$var$sort(children, sortOrder);
    // Init children recursively
    if (children.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.children, function(child) {
        $2ac615e1f67ae37a$var$initChildren(child, sortOrder);
    });
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */ function $2ac615e1f67ae37a$var$sort(children, sortOrder) {
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(sortOrder)) {
        var sortTargets = $7a1bd9c2710fea0d$export$871de8747c9eaa88(children, function(child, idx) {
            var value = child.getValue();
            return {
                params: {
                    depth: child.depth,
                    height: child.height,
                    dataIndex: child.dataIndex,
                    getValue: function() {
                        return value;
                    }
                },
                index: idx
            };
        });
        sortTargets.sort(function(a, b) {
            return sortOrder(a.params, b.params);
        });
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(sortTargets, function(target) {
            return children[target.index];
        });
    } else {
        var isAsc_1 = sortOrder === "asc";
        return children.sort(function(a, b) {
            var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
            return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
        });
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a3ad73d5b7f783f0$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    // Default color strategy
    function pickColor(node, seriesModel, treeHeight) {
        // Choose color from palette based on the first level.
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + "", paletteScope);
        if (node.depth > 1 && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(color)) // Lighter on the deeper level.
        color = (0, $2c037f5bda6341ca$export$590e8b2c435046d9)(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
        return color;
    }
    ecModel.eachSeriesByType("sunburst", function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            var style = model.getModel("itemStyle").getItemStyle();
            if (!style.fill) style.fill = pickColor(node, seriesModel, tree.root.height);
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}





function $b7341ef122ec790d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $270cb27be00846ce$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5204df39d5781117$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $2ac615e1f67ae37a$export$2e2bcd8739ae039), "sunburst"));
    registers.registerProcessor((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $e11a533bf70b759c$export$2e2bcd8739ae039), "sunburst"));
    registers.registerVisual((0, $a3ad73d5b7f783f0$export$2e2bcd8739ae039));
    (0, $aae4889dfc91fba0$export$d2def111ea616eb3)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $fef28dd8967d3f1b$export$84369c8e2229fa7f = {
    color: "fill",
    borderColor: "stroke"
};
var $fef28dd8967d3f1b$export$734d775a14929701 = {
    symbol: 1,
    symbolSize: 1,
    symbolKeepAspect: 1,
    legendIcon: 1,
    visualMeta: 1,
    liftZ: 1,
    decal: 1
};
var $fef28dd8967d3f1b$export$dd5c3cc86073562f = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $fef28dd8967d3f1b$var$CustomSeriesModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CustomSeriesModel, _super);
    function CustomSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomSeriesModel.type;
        return _this;
    }
    CustomSeriesModel.prototype.optionUpdated = function() {
        this.currentZLevel = this.get("zlevel", true);
        this.currentZ = this.get("z", true);
    };
    CustomSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this);
    };
    CustomSeriesModel.prototype.getDataParams = function(dataIndex, dataType, el) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        el && (params.info = $fef28dd8967d3f1b$export$dd5c3cc86073562f(el).info);
        return params;
    };
    CustomSeriesModel.type = "series.custom";
    CustomSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ];
    CustomSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Custom series will not clip by default.
        // Some case will use custom series to draw label
        // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
        clip: false
    };
    return CustomSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $fef28dd8967d3f1b$export$2e2bcd8739ae039 = $fef28dd8967d3f1b$var$CustomSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb5b87553d7c5e15$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        "x",
        "y"
    ], function(dim, dimIdx) {
        var axis = this.getAxis(dim);
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        return axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
    }, this);
}
function $eb5b87553d7c5e15$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.master.getRect();
    return {
        coordSys: {
            // The name exposed to user is always 'cartesian2d' but not 'grid'.
            type: "cartesian2d",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data) {
                // do not provide "out" param
                return coordSys.dataToPoint(data);
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($eb5b87553d7c5e15$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $db94904ae7a63a7b$var$dataToCoordSize(dataSize, dataItem) {
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        0,
        1
    ], function(dimIdx) {
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var p1 = [];
        var p2 = [];
        p1[dimIdx] = val - halfSize;
        p2[dimIdx] = val + halfSize;
        p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
        return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
    }, this);
}
function $db94904ae7a63a7b$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getBoundingRect();
    return {
        coordSys: {
            type: "geo",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            zoom: coordSys.getZoom()
        },
        api: {
            coord: function(data) {
                // do not provide "out" and noRoam param,
                // Compatible with this usage:
                // echarts.util.map(item.points, api.coord)
                return coordSys.dataToPoint(data);
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($db94904ae7a63a7b$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4af7f8b40c63338e$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    var axis = this.getAxis();
    var val = dataItem instanceof Array ? dataItem[0] : dataItem;
    var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
    return axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}
function $4af7f8b40c63338e$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: "singleAxis",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(val) {
                // do not provide "out" param
                return coordSys.dataToPoint(val);
            },
            size: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($4af7f8b40c63338e$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// import AngleAxis from './AngleAxis.js';
function $5542da7477183ee1$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        "Radius",
        "Angle"
    ], function(dim, dimIdx) {
        var getterName = "get" + dim + "Axis";
        // TODO: TYPE Check Angle Axis
        var axis = this[getterName]();
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var result = axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
        if (dim === "Angle") result = result * Math.PI / 180;
        return result;
    }, this);
}
function $5542da7477183ee1$export$2e2bcd8739ae039(coordSys) {
    var radiusAxis = coordSys.getRadiusAxis();
    var angleAxis = coordSys.getAngleAxis();
    var radius = radiusAxis.getExtent();
    radius[0] > radius[1] && radius.reverse();
    return {
        coordSys: {
            type: "polar",
            cx: coordSys.cx,
            cy: coordSys.cy,
            r: radius[1],
            r0: radius[0]
        },
        api: {
            coord: function(data) {
                var radius = radiusAxis.dataToRadius(data[0]);
                var angle = angleAxis.dataToAngle(data[1]);
                var coord = coordSys.coordToPoint([
                    radius,
                    angle
                ]);
                coord.push(radius, angle * Math.PI / 180);
                return coord;
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($5542da7477183ee1$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $07a38220d20058fb$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    var rangeInfo = coordSys.getRangeInfo();
    return {
        coordSys: {
            type: "calendar",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            cellWidth: coordSys.getCellWidth(),
            cellHeight: coordSys.getCellHeight(),
            rangeInfo: {
                start: rangeInfo.start,
                end: rangeInfo.end,
                weeks: rangeInfo.weeks,
                dayCount: rangeInfo.allDay
            }
        },
        api: {
            coord: function(data, clamp) {
                return coordSys.dataToPoint(data, clamp);
            }
        }
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $daa53642c3afcc30$var$deprecatedLogs = {};
function $daa53642c3afcc30$export$3b868abde5eae7d1(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
    // Since echarts5, `RectText` is separated from its host element and style.text
    // does not exist any more. The compat work brings some extra burden on performance.
    // So we provide:
    // `legacy: true` force make compat.
    // `legacy: false`, force do not compat.
    // `legacy` not set: auto detect whether legacy.
    //     But in this case we do not compat (difficult to detect and rare case):
    //     Becuse custom series and graphic component support "merge", users may firstly
    //     only set `textStrokeWidth` style or secondly only set `text`.
    return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== "tspan" && (elType === "text" || (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(style, "text")));
}
function $daa53642c3afcc30$export$7748133eaaa8aecc(hostStyle, elType, isNormal) {
    var srcStyle = hostStyle;
    var textConfig;
    var textContent;
    var textContentStyle;
    if (elType === "text") textContentStyle = srcStyle;
    else {
        textContentStyle = {};
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "text") && (textContentStyle.text = srcStyle.text);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "rich") && (textContentStyle.rich = srcStyle.rich);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textFill") && (textContentStyle.fill = srcStyle.textFill);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textStroke") && (textContentStyle.stroke = srcStyle.textStroke);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontFamily") && (textContentStyle.fontFamily = srcStyle.fontFamily);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontSize") && (textContentStyle.fontSize = srcStyle.fontSize);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontStyle") && (textContentStyle.fontStyle = srcStyle.fontStyle);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontWeight") && (textContentStyle.fontWeight = srcStyle.fontWeight);
        textContent = {
            type: "text",
            style: textContentStyle,
            // ec4 does not support rectText trigger.
            // And when text position is different in normal and emphasis
            // => hover text trigger emphasis;
            // => text position changed, leave mouse pointer immediately;
            // That might cause incorrect state.
            silent: true
        };
        textConfig = {};
        var hasOwnPos = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textPosition");
        if (isNormal) textConfig.position = hasOwnPos ? srcStyle.textPosition : "inside";
        else hasOwnPos && (textConfig.position = srcStyle.textPosition);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textPosition") && (textConfig.position = srcStyle.textPosition);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textOffset") && (textConfig.offset = srcStyle.textOffset);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textRotation") && (textConfig.rotation = srcStyle.textRotation);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textDistance") && (textConfig.distance = srcStyle.textDistance);
    }
    $daa53642c3afcc30$var$convertEC4CompatibleRichItem(textContentStyle, hostStyle);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(textContentStyle.rich, function(richItem) {
        $daa53642c3afcc30$var$convertEC4CompatibleRichItem(richItem, richItem);
    });
    return {
        textConfig: textConfig,
        textContent: textContent
    };
}
/**
 * The result will be set to `out`.
 */ function $daa53642c3afcc30$var$convertEC4CompatibleRichItem(out, richItem) {
    if (!richItem) return;
    // (1) For simplicity, make textXXX properties (deprecated since ec5) has
    // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
    // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
    // richText in ec5.
    // (2) `out === richItem` if and only if `out` is text el or rich item.
    // So we can overwrite existing props in `out` since textXXX has higher priority.
    richItem.font = richItem.textFont || richItem.font;
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textStrokeWidth") && (out.lineWidth = richItem.textStrokeWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textAlign") && (out.align = richItem.textAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textVerticalAlign") && (out.verticalAlign = richItem.textVerticalAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textLineHeight") && (out.lineHeight = richItem.textLineHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textWidth") && (out.width = richItem.textWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textHeight") && (out.height = richItem.textHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBackgroundColor") && (out.backgroundColor = richItem.textBackgroundColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textPadding") && (out.padding = richItem.textPadding);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderColor") && (out.borderColor = richItem.textBorderColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderWidth") && (out.borderWidth = richItem.textBorderWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderRadius") && (out.borderRadius = richItem.textBorderRadius);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowColor") && (out.shadowColor = richItem.textBoxShadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowBlur") && (out.shadowBlur = richItem.textBoxShadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowOffsetX") && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowOffsetY") && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
}
function $daa53642c3afcc30$export$b8ddb75bd1b9b791(itemStl, txStl, txCfg) {
    var out = itemStl;
    // See `custom.ts`, a trick to set extra `textPosition` firstly.
    out.textPosition = out.textPosition || txCfg.position || "inside";
    txCfg.offset != null && (out.textOffset = txCfg.offset);
    txCfg.rotation != null && (out.textRotation = txCfg.rotation);
    txCfg.distance != null && (out.textDistance = txCfg.distance);
    var isInside = out.textPosition.indexOf("inside") >= 0;
    var hostFill = itemStl.fill || "#000";
    $daa53642c3afcc30$var$convertToEC4RichItem(out, txStl);
    var textFillNotSet = out.textFill == null;
    if (isInside) {
        if (textFillNotSet) {
            out.textFill = txCfg.insideFill || "#fff";
            !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
            !out.textStroke && (out.textStroke = hostFill);
            out.textStrokeWidth == null && (out.textStrokeWidth = 2);
        }
    } else {
        if (textFillNotSet) out.textFill = itemStl.fill || txCfg.outsideFill || "#000";
        !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
    }
    out.text = txStl.text;
    out.rich = txStl.rich;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(txStl.rich, function(richItem) {
        $daa53642c3afcc30$var$convertToEC4RichItem(richItem, richItem);
    });
    return out;
}
function $daa53642c3afcc30$var$convertToEC4RichItem(out, richItem) {
    if (!richItem) return;
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fill") && (out.textFill = richItem.fill);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "stroke") && (out.textStroke = richItem.fill);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "lineWidth") && (out.textStrokeWidth = richItem.lineWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "font") && (out.font = richItem.font);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontStyle") && (out.fontStyle = richItem.fontStyle);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontWeight") && (out.fontWeight = richItem.fontWeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontSize") && (out.fontSize = richItem.fontSize);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontFamily") && (out.fontFamily = richItem.fontFamily);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "align") && (out.textAlign = richItem.align);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "verticalAlign") && (out.textVerticalAlign = richItem.verticalAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "lineHeight") && (out.textLineHeight = richItem.lineHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "width") && (out.textWidth = richItem.width);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "height") && (out.textHeight = richItem.height);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "backgroundColor") && (out.textBackgroundColor = richItem.backgroundColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "padding") && (out.textPadding = richItem.padding);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderColor") && (out.textBorderColor = richItem.borderColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderWidth") && (out.textBorderWidth = richItem.borderWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderRadius") && (out.textBorderRadius = richItem.borderRadius);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowColor") && (out.textBoxShadowColor = richItem.shadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowBlur") && (out.textBoxShadowBlur = richItem.shadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowOffsetX") && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowOffsetY") && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowColor") && (out.textShadowColor = richItem.textShadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowBlur") && (out.textShadowBlur = richItem.textShadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowOffsetX") && (out.textShadowOffsetX = richItem.textShadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowOffsetY") && (out.textShadowOffsetY = richItem.textShadowOffsetY);
}
function $daa53642c3afcc30$export$606a5c06d13e04b6(deprecated, insteadApproach) {
    var key;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP = {
    position: [
        "x",
        "y"
    ],
    scale: [
        "scaleX",
        "scaleY"
    ],
    origin: [
        "originX",
        "originY"
    ]
};
var $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP);
var $7c104376a000308e$var$TRANSFORM_PROPS_MAP = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)((0, $becf2d727f9cf450$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = 1;
    return obj;
}, {});
var $7c104376a000308e$var$transformPropNamesStr = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).join(", ");
var $7c104376a000308e$export$9a911ad86e905b13 = [
    "",
    "style",
    "shape",
    "extra"
];
var $7c104376a000308e$var$transitionInnerStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $7c104376a000308e$var$getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
    var animationProp = animationType + "Animation";
    var config = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)(animationType, parentModel, dataIndex) || {};
    var userDuring = $7c104376a000308e$var$transitionInnerStore(el).userDuring;
    // Only set when duration is > 0 and it's need to be animated.
    if (config.duration > 0) {
        // For simplicity, if during not specified, the previous during will not work any more.
        config.during = userDuring ? (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($7c104376a000308e$var$duringCall, {
            el: el,
            userDuring: userDuring
        }) : null;
        config.setToFinal = true;
        config.scope = animationType;
    }
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(config, elOption[animationProp]);
    return config;
}
function $7c104376a000308e$export$4342b281b9b5d77e(el, elOption, animatableModel, opts) {
    opts = opts || {};
    var dataIndex = opts.dataIndex, isInit = opts.isInit, clearStyle = opts.clearStyle;
    var hasAnimation = animatableModel.isAnimationEnabled();
    // Save the meta info for further morphing. Like apply on the sub morphing elements.
    var store = $7c104376a000308e$var$transitionInnerStore(el);
    var styleOpt = elOption.style;
    store.userDuring = elOption.during;
    var transFromProps = {};
    var propsToSet = {};
    $7c104376a000308e$var$prepareTransformAllPropsFinal(el, elOption, propsToSet);
    $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal("shape", elOption, propsToSet);
    $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal("extra", elOption, propsToSet);
    if (!isInit && hasAnimation) {
        $7c104376a000308e$var$prepareTransformTransitionFrom(el, elOption, transFromProps);
        $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom("shape", el, elOption, transFromProps);
        $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom("extra", el, elOption, transFromProps);
        $7c104376a000308e$var$prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
    }
    propsToSet.style = styleOpt;
    $7c104376a000308e$var$applyPropsDirectly(el, propsToSet, clearStyle);
    $7c104376a000308e$var$applyMiscProps(el, elOption);
    if (hasAnimation) {
        if (isInit) {
            var enterFromProps_1 = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($7c104376a000308e$export$9a911ad86e905b13, function(propName) {
                var prop = propName ? elOption[propName] : elOption;
                if (prop && prop.enterFrom) {
                    if (propName) enterFromProps_1[propName] = enterFromProps_1[propName] || {};
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
                }
            });
            var config = $7c104376a000308e$var$getElementAnimationConfig("enter", el, elOption, animatableModel, dataIndex);
            if (config.duration > 0) el.animateFrom(enterFromProps_1, config);
        } else $7c104376a000308e$var$applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
    }
    // Store leave to be used in leave transition.
    $7c104376a000308e$export$a6f11bb1cb100e2a(el, elOption);
    styleOpt ? el.dirty() : el.markRedraw();
}
function $7c104376a000308e$export$a6f11bb1cb100e2a(el, elOption) {
    // Try merge to previous set leaveTo
    var leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps;
    for(var i = 0; i < $7c104376a000308e$export$9a911ad86e905b13.length; i++){
        var propName = $7c104376a000308e$export$9a911ad86e905b13[i];
        var prop = propName ? elOption[propName] : elOption;
        if (prop && prop.leaveTo) {
            if (!leaveToProps) leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps = {};
            if (propName) leaveToProps[propName] = leaveToProps[propName] || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
        }
    }
}
function $7c104376a000308e$export$15575b6d82d35bb3(el, elOption, animatableModel, onRemove) {
    if (el) {
        var parent_1 = el.parent;
        var leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps;
        if (leaveToProps) {
            // TODO TODO use leave after leaveAnimation in series is introduced
            // TODO Data index?
            var config = $7c104376a000308e$var$getElementAnimationConfig("update", el, elOption, animatableModel, 0);
            config.done = function() {
                parent_1.remove(el);
                onRemove && onRemove();
            };
            el.animateTo(leaveToProps, config);
        } else {
            parent_1.remove(el);
            onRemove && onRemove();
        }
    }
}
function $7c104376a000308e$export$6f3361b4b8d7a8ba(transition) {
    return transition === "all";
}
function $7c104376a000308e$var$applyPropsDirectly(el, // Can be null/undefined
allPropsFinal, clearStyle) {
    var styleOpt = allPropsFinal.style;
    if (!el.isGroup && styleOpt) {
        if (clearStyle) {
            el.useStyle({});
            // When style object changed, how to trade the existing animation?
            // It is probably complicated and not needed to cover all the cases.
            // But still need consider the case:
            // (1) When using init animation on `style.opacity`, and before the animation
            //     ended users triggers an update by mousewhel. At that time the init
            //     animation should better be continued rather than terminated.
            //     So after `useStyle` called, we should change the animation target manually
            //     to continue the effect of the init animation.
            // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
            //     to update the value to `val2` and no animation declared, should be terminate
            //     the previous animation or just modify the target of the animation?
            //     Therotically That will happen not only on `style` but also on `shape` and
            //     `transfrom` props. But we haven't handle this case at present yet.
            // (3) PENDING: Is it proper to visit `animators` and `targetName`?
            var animators = el.animators;
            for(var i = 0; i < animators.length; i++){
                var animator = animators[i];
                // targetName is the "topKey".
                if (animator.targetName === "style") animator.changeTarget(el.style);
            }
        }
        el.setStyle(styleOpt);
    }
    if (allPropsFinal) {
        // Not set style here.
        allPropsFinal.style = null;
        // Set el to the final state firstly.
        allPropsFinal && el.attr(allPropsFinal);
        allPropsFinal.style = styleOpt;
    }
}
function $7c104376a000308e$var$applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
transFromProps) {
    if (transFromProps) {
        var config = $7c104376a000308e$var$getElementAnimationConfig("update", el, elOption, model, dataIndex);
        if (config.duration > 0) el.animateFrom(transFromProps, config);
    }
}
function $7c104376a000308e$var$applyMiscProps(el, elOption) {
    // Merge by default.
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "silent") && (el.silent = elOption.silent);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "ignore") && (el.ignore = elOption.ignore);
    if (el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "invisible") && (el.invisible = elOption.invisible);
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "autoBatch") && (el.autoBatch = elOption.autoBatch);
}
// Use it to avoid it be exposed to user.
var $7c104376a000308e$var$tmpDuringScope = {};
var $7c104376a000308e$var$transitionDuringAPI = {
    // Usually other props do not need to be changed in animation during.
    setTransform: function(key, val) {
        $7c104376a000308e$var$tmpDuringScope.el[key] = val;
        return this;
    },
    getTransform: function(key) {
        return $7c104376a000308e$var$tmpDuringScope.el[key];
    },
    setShape: function(key, val) {
        var el = $7c104376a000308e$var$tmpDuringScope.el;
        var shape = el.shape || (el.shape = {});
        shape[key] = val;
        el.dirtyShape && el.dirtyShape();
        return this;
    },
    getShape: function(key) {
        var shape = $7c104376a000308e$var$tmpDuringScope.el.shape;
        if (shape) return shape[key];
    },
    setStyle: function(key, val) {
        var el = $7c104376a000308e$var$tmpDuringScope.el;
        var style = el.style;
        if (style) {
            style[key] = val;
            el.dirtyStyle && el.dirtyStyle();
        }
        return this;
    },
    getStyle: function(key) {
        var style = $7c104376a000308e$var$tmpDuringScope.el.style;
        if (style) return style[key];
    },
    setExtra: function(key, val) {
        var extra = $7c104376a000308e$var$tmpDuringScope.el.extra || ($7c104376a000308e$var$tmpDuringScope.el.extra = {});
        extra[key] = val;
        return this;
    },
    getExtra: function(key) {
        var extra = $7c104376a000308e$var$tmpDuringScope.el.extra;
        if (extra) return extra[key];
    }
};
function $7c104376a000308e$var$assertNotReserved(key) {}
function $7c104376a000308e$var$duringCall() {
    // Do not provide "percent" until some requirements come.
    // Because consider thies case:
    // enterFrom: {x: 100, y: 30}, transition: 'x'.
    // And enter duration is different from update duration.
    // Thus it might be confused about the meaning of "percent" in during callback.
    var scope = this;
    var el = scope.el;
    if (!el) return;
    // If el is remove from zr by reason like legend, during still need to called,
    // because el will be added back to zr and the prop value should not be incorrect.
    var latestUserDuring = $7c104376a000308e$var$transitionInnerStore(el).userDuring;
    var scopeUserDuring = scope.userDuring;
    // Ensured a during is only called once in each animation frame.
    // If a during is called multiple times in one frame, maybe some users' calculation logic
    // might be wrong (not sure whether this usage exists).
    // The case of a during might be called twice can be: by default there is a animator for
    // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
    // another animators for 'style'/'shape'/'extra'.
    if (latestUserDuring !== scopeUserDuring) {
        // release
        scope.el = scope.userDuring = null;
        return;
    }
    $7c104376a000308e$var$tmpDuringScope.el = el;
    // Give no `this` to user in "during" calling.
    scopeUserDuring($7c104376a000308e$var$transitionDuringAPI);
// FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
// consider the issue that the prop might be incorrect when return to "normal" state.
}
function $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var elPropsInAttr = fromEl[mainAttr];
    var transFromPropsInAttr;
    if (elPropsInAttr) {
        var transition = elOption.transition;
        var attrTransition = attrOpt.transition;
        if (attrTransition) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            if ($7c104376a000308e$export$6f3361b4b8d7a8ba(attrTransition)) (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(transFromPropsInAttr, elPropsInAttr);
            else {
                var transitionKeys = (0, $76d619f648247e6d$export$4f07b212a02c8051)(attrTransition);
                for(var i = 0; i < transitionKeys.length; i++){
                    var key = transitionKeys[i];
                    var elVal = elPropsInAttr[key];
                    transFromPropsInAttr[key] = elVal;
                }
            }
        } else if ($7c104376a000308e$export$6f3361b4b8d7a8ba(transition) || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(transition, mainAttr) >= 0) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            var elPropsInAttrKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(elPropsInAttr);
            for(var i = 0; i < elPropsInAttrKeys.length; i++){
                var key = elPropsInAttrKeys[i];
                var elVal = elPropsInAttr[key];
                if ($7c104376a000308e$var$isNonStyleTransitionEnabled(attrOpt[key], elVal)) transFromPropsInAttr[key] = elVal;
            }
        }
    }
}
function $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var allPropsInAttr = allProps[mainAttr] = {};
    var keysInAttr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(attrOpt);
    for(var i = 0; i < keysInAttr.length; i++){
        var key = keysInAttr[i];
        // To avoid share one object with different element, and
        // to avoid user modify the object inexpectedly, have to clone.
        allPropsInAttr[key] = (0, $76d8a142a20276fc$export$c5e92b7f105af84e)(attrOpt[key]);
    }
}
function $7c104376a000308e$var$prepareTransformTransitionFrom(el, elOption, transFromProps) {
    var transition = elOption.transition;
    var transitionKeys = $7c104376a000308e$export$6f3361b4b8d7a8ba(transition) ? (0, $becf2d727f9cf450$export$98ab6203ec3396e2) : (0, $76d619f648247e6d$export$4f07b212a02c8051)(transition || []);
    for(var i = 0; i < transitionKeys.length; i++){
        var key = transitionKeys[i];
        if (key === "style" || key === "shape" || key === "extra") continue;
        var elVal = el[key];
        // Do not clone, animator will perform that clone.
        transFromProps[key] = elVal;
    }
}
function $7c104376a000308e$var$prepareTransformAllPropsFinal(el, elOption, allProps) {
    for(var i = 0; i < $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS.length; i++){
        var legacyName = $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS[i];
        var xyName = $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP[legacyName];
        var legacyArr = elOption[legacyName];
        if (legacyArr) {
            allProps[xyName[0]] = legacyArr[0];
            allProps[xyName[1]] = legacyArr[1];
        }
    }
    for(var i = 0; i < (0, $becf2d727f9cf450$export$98ab6203ec3396e2).length; i++){
        var key = (0, $becf2d727f9cf450$export$98ab6203ec3396e2)[i];
        if (elOption[key] != null) allProps[key] = elOption[key];
    }
}
function $7c104376a000308e$var$prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
    if (!styleOpt) return;
    var fromElStyle = fromEl.style;
    var transFromStyleProps;
    if (fromElStyle) {
        var styleTransition = styleOpt.transition;
        var elTransition = elOption.transition;
        if (styleTransition && !$7c104376a000308e$export$6f3361b4b8d7a8ba(styleTransition)) {
            var transitionKeys = (0, $76d619f648247e6d$export$4f07b212a02c8051)(styleTransition);
            !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
            for(var i = 0; i < transitionKeys.length; i++){
                var key = transitionKeys[i];
                var elVal = fromElStyle[key];
                // Do not clone, see `checkNonStyleTansitionRefer`.
                transFromStyleProps[key] = elVal;
            }
        } else if (fromEl.getAnimationStyleProps && ($7c104376a000308e$export$6f3361b4b8d7a8ba(elTransition) || $7c104376a000308e$export$6f3361b4b8d7a8ba(styleTransition) || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(elTransition, "style") >= 0)) {
            var animationProps = fromEl.getAnimationStyleProps();
            var animationStyleProps = animationProps ? animationProps.style : null;
            if (animationStyleProps) {
                !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
                var styleKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(styleOpt);
                for(var i = 0; i < styleKeys.length; i++){
                    var key = styleKeys[i];
                    if (animationStyleProps[key]) {
                        var elVal = fromElStyle[key];
                        transFromStyleProps[key] = elVal;
                    }
                }
            }
        }
    }
}
function $7c104376a000308e$var$isNonStyleTransitionEnabled(optVal, elVal) {
    // The same as `checkNonStyleTansitionRefer`.
    return !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
}
var $7c104376a000308e$var$checkTransformPropRefer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $ab8d73690f09fb6d$var$getStateToRestore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ab8d73690f09fb6d$var$KEYFRAME_EXCLUDE_KEYS = [
    "percent",
    "easing",
    "shape",
    "style",
    "extra"
];
function $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4(el) {
    // Stop previous keyframe animation.
    el.stopAnimation("keyframe");
    // Restore
    el.attr($ab8d73690f09fb6d$var$getStateToRestore(el));
}
function $ab8d73690f09fb6d$export$b0aa6a5f01693fa4(el, animationOpts, animatableModel) {
    if (!animatableModel.isAnimationEnabled() || !animationOpts) return;
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(animationOpts)) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(animationOpts, function(singleAnimationOpts) {
            $ab8d73690f09fb6d$export$b0aa6a5f01693fa4(el, singleAnimationOpts, animatableModel);
        });
        return;
    }
    var keyframes = animationOpts.keyframes;
    var duration = animationOpts.duration;
    if (animatableModel && duration == null) {
        // Default to use duration of config.
        // NOTE: animation config from payload will be ignored because they are mainly for transitions.
        var config = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("enter", animatableModel, 0);
        duration = config && config.duration;
    }
    if (!keyframes || !duration) return;
    var stateToRestore = $ab8d73690f09fb6d$var$getStateToRestore(el);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $7c104376a000308e$export$9a911ad86e905b13), function(targetPropName) {
        if (targetPropName && !el[targetPropName]) return;
        var animator;
        var endFrameIsSet = false;
        // Sort keyframes by percent.
        keyframes.sort(function(a, b) {
            return a.percent - b.percent;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(keyframes, function(kf) {
            // Stop current animation.
            var animators = el.animators;
            var kfValues = targetPropName ? kf[targetPropName] : kf;
            if (!kfValues) return;
            var propKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(kfValues);
            if (!targetPropName) // PENDING performance?
            propKeys = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(propKeys, function(key) {
                return (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($ab8d73690f09fb6d$var$KEYFRAME_EXCLUDE_KEYS, key) < 0;
            });
            if (!propKeys.length) return;
            if (!animator) {
                animator = el.animate(targetPropName, animationOpts.loop, true);
                animator.scope = "keyframe";
            }
            for(var i = 0; i < animators.length; i++)// Stop all other animation that is not keyframe.
            if (animators[i] !== animator && animators[i].targetName === animator.targetName) animators[i].stopTracks(propKeys);
            targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
            var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(propKeys, function(key) {
                // Save original value.
                savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
            });
            animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
        });
        if (!animator) return;
        animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
    });
}


var $590d5f44e94a6803$var$EMPHASIS = "emphasis";
var $590d5f44e94a6803$var$NORMAL = "normal";
var $590d5f44e94a6803$var$BLUR = "blur";
var $590d5f44e94a6803$var$SELECT = "select";
var $590d5f44e94a6803$var$STATES = [
    $590d5f44e94a6803$var$NORMAL,
    $590d5f44e94a6803$var$EMPHASIS,
    $590d5f44e94a6803$var$BLUR,
    $590d5f44e94a6803$var$SELECT
];
var $590d5f44e94a6803$var$PATH_ITEM_STYLE = {
    normal: [
        "itemStyle"
    ],
    emphasis: [
        $590d5f44e94a6803$var$EMPHASIS,
        "itemStyle"
    ],
    blur: [
        $590d5f44e94a6803$var$BLUR,
        "itemStyle"
    ],
    select: [
        $590d5f44e94a6803$var$SELECT,
        "itemStyle"
    ]
};
var $590d5f44e94a6803$var$PATH_LABEL = {
    normal: [
        "label"
    ],
    emphasis: [
        $590d5f44e94a6803$var$EMPHASIS,
        "label"
    ],
    blur: [
        $590d5f44e94a6803$var$BLUR,
        "label"
    ],
    select: [
        $590d5f44e94a6803$var$SELECT,
        "label"
    ]
};
var $590d5f44e94a6803$var$DEFAULT_TRANSITION = [
    "x",
    "y"
];
// Use prefix to avoid index to be the same as el.name,
// which will cause weird update animation.
var $590d5f44e94a6803$var$GROUP_DIFF_PREFIX = "e\x00\x00";
var $590d5f44e94a6803$var$attachedTxInfoTmp = {
    normal: {},
    emphasis: {},
    blur: {},
    select: {}
};
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */ var $590d5f44e94a6803$var$prepareCustoms = {
    cartesian2d: (0, $eb5b87553d7c5e15$export$2e2bcd8739ae039),
    geo: (0, $db94904ae7a63a7b$export$2e2bcd8739ae039),
    single: (0, $4af7f8b40c63338e$export$2e2bcd8739ae039),
    polar: (0, $5542da7477183ee1$export$2e2bcd8739ae039),
    calendar: (0, $07a38220d20058fb$export$2e2bcd8739ae039)
};
function $590d5f44e94a6803$var$isPath(el) {
    return el instanceof $b02ffe7acd508c08$export$2e2bcd8739ae039;
}
function $590d5f44e94a6803$var$isDisplayable(el) {
    return el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039);
}
function $590d5f44e94a6803$var$copyElement(sourceEl, targetEl) {
    targetEl.copyTransform(sourceEl);
    if ($590d5f44e94a6803$var$isDisplayable(targetEl) && $590d5f44e94a6803$var$isDisplayable(sourceEl)) {
        targetEl.setStyle(sourceEl.style);
        targetEl.z = sourceEl.z;
        targetEl.z2 = sourceEl.z2;
        targetEl.zlevel = sourceEl.zlevel;
        targetEl.invisible = sourceEl.invisible;
        targetEl.ignore = sourceEl.ignore;
        if ($590d5f44e94a6803$var$isPath(targetEl) && $590d5f44e94a6803$var$isPath(sourceEl)) targetEl.setShape(sourceEl.shape);
    }
}
var $590d5f44e94a6803$var$CustomChartView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CustomChartView, _super);
    function CustomChartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomChartView.type;
        return _this;
    }
    CustomChartView.prototype.render = function(customSeries, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var oldData = this._data;
        var data = customSeries.getData();
        var group = this.group;
        var renderItem = $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api);
        if (!oldData) // Previous render is incremental render or first render.
        // Needs remove the incremental rendered elements.
        group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            $590d5f44e94a6803$var$createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && (0, $7c104376a000308e$export$15575b6d82d35bb3)(el, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).option, customSeries);
        }).update(function(newIdx, oldIdx) {
            var oldEl = oldData.getItemGraphicEl(oldIdx);
            $590d5f44e94a6803$var$createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).execute();
        // Do clipping
        var clipPath = customSeries.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(customSeries.coordinateSystem, false, customSeries) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
    };
    CustomChartView.prototype.incrementalPrepareRender = function(customSeries, ecModel, api) {
        this.group.removeAll();
        this._data = null;
    };
    CustomChartView.prototype.incrementalRender = function(params, customSeries, ecModel, api, payload) {
        var data = customSeries.getData();
        var renderItem = $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api);
        var progressiveEls = this._progressiveEls = [];
        function setIncrementalAndHoverLayer(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = params.start; idx < params.end; idx++){
            var el = $590d5f44e94a6803$var$createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);
            if (el) {
                el.traverse(setIncrementalAndHoverLayer);
                progressiveEls.push(el);
            }
        }
    };
    CustomChartView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CustomChartView.prototype.filterForExposedEvent = function(eventType, query, targetEl, packedEvent) {
        var elementName = query.element;
        if (elementName == null || targetEl.name === elementName) return true;
        // Enable to give a name on a group made by `renderItem`, and listen
        // events that are triggered by its descendents.
        while((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group){
            if (targetEl.name === elementName) return true;
        }
        return false;
    };
    CustomChartView.type = "custom";
    return CustomChartView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $590d5f44e94a6803$export$2e2bcd8739ae039 = $590d5f44e94a6803$var$CustomChartView;
function $590d5f44e94a6803$var$createEl(elOption) {
    var graphicType = elOption.type;
    var el;
    // Those graphic elements are not shapes. They should not be
    // overwritten by users, so do them first.
    if (graphicType === "path") {
        var shape = elOption.shape;
        // Using pathRect brings convenience to users sacle svg path.
        var pathRect = shape.width != null && shape.height != null ? {
            x: shape.x || 0,
            y: shape.y || 0,
            width: shape.width,
            height: shape.height
        } : null;
        var pathData = $590d5f44e94a6803$var$getPathData(shape);
        // Path is also used for icon, so layout 'center' by default.
        el = $5b455ae6f843ac47$export$aa9bab72412f5613(pathData, null, pathRect, shape.layout || "center");
        (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customPathData = pathData;
    } else if (graphicType === "image") {
        el = new $86adec94217b86c6$export$2e2bcd8739ae039({});
        (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customImagePath = elOption.style.image;
    } else if (graphicType === "text") el = new $fe885cc21795562b$export$2e2bcd8739ae039({});
    else if (graphicType === "group") el = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    else if (graphicType === "compoundPath") throw new Error('"compoundPath" is not supported yet.');
    else {
        var Clz = $5b455ae6f843ac47$export$51df4b5565a58189(graphicType);
        if (!Clz) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        el = new Clz();
    }
    (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customGraphicType = graphicType;
    el.name = elOption.name;
    // Compat ec4: the default z2 lift is 1. If changing the number,
    // some cases probably be broken: hierarchy layout along z, like circle packing,
    // where emphasis only intending to modify color/border rather than lift z2.
    el.z2EmphasisLift = 1;
    el.z2SelectLift = 1;
    return el;
}
function $590d5f44e94a6803$var$updateElNormal(// Can be null/undefined
api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
    // Stop and restore before update any other attributes.
    (0, $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4)(el);
    var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;
    if (txCfgOpt) // PENDING: whether use user object directly rather than clone?
    // TODO:5.0 textConfig transition animation?
    el.setTextConfig(txCfgOpt);
    // Default transition ['x', 'y']
    if (elOption && elOption.transition == null) elOption.transition = $590d5f44e94a6803$var$DEFAULT_TRANSITION;
    // Do some normalization on style.
    var styleOpt = elOption && elOption.style;
    if (styleOpt) {
        if (el.type === "text") {
            var textOptionStyle = styleOpt;
            // Compatible with ec4: if `textFill` or `textStroke` exists use them.
            (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(textOptionStyle, "textFill") && (textOptionStyle.fill = textOptionStyle.textFill);
            (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(textOptionStyle, "textStroke") && (textOptionStyle.stroke = textOptionStyle.textStroke);
        }
        var decalPattern = void 0;
        var decalObj = $590d5f44e94a6803$var$isPath(el) ? styleOpt.decal : null;
        if (api && decalObj) {
            decalObj.dirty = true;
            decalPattern = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decalObj, api);
        }
        // Always overwrite in case user specify this prop.
        styleOpt.__decalPattern = decalPattern;
    }
    if ($590d5f44e94a6803$var$isDisplayable(el)) {
        if (styleOpt) {
            var decalPattern = styleOpt.__decalPattern;
            if (decalPattern) styleOpt.decal = decalPattern;
        }
    }
    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el, elOption, seriesModel, {
        dataIndex: dataIndex,
        isInit: isInit,
        clearStyle: true
    });
    (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, seriesModel);
}
function $590d5f44e94a6803$var$updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
    var elDisplayable = el.isGroup ? null : el;
    var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg;
    // PENDING:5.0 support customize scale change and transition animation?
    if (elDisplayable) {
        // By default support auto lift color when hover whether `emphasis` specified.
        var stateObj = elDisplayable.ensureState(state);
        if (styleOpt === false) {
            var existingEmphasisState = elDisplayable.getState(state);
            if (existingEmphasisState) existingEmphasisState.style = null;
        } else // style is needed to enable default emphasis.
        stateObj.style = styleOpt || null;
        // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
        // remove hover style.
        // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
        // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.
        if (txCfgOpt) stateObj.textConfig = txCfgOpt;
        (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(elDisplayable);
    }
}
function $590d5f44e94a6803$var$updateZ(el, elOption, seriesModel) {
    // Group not support textContent and not support z yet.
    if (el.isGroup) return;
    var elDisplayable = el;
    var currentZ = seriesModel.currentZ;
    var currentZLevel = seriesModel.currentZLevel;
    // Always erase.
    elDisplayable.z = currentZ;
    elDisplayable.zlevel = currentZLevel;
    // z2 must not be null/undefined, otherwise sort error may occur.
    var optZ2 = elOption.z2;
    optZ2 != null && (elDisplayable.z2 = optZ2 || 0);
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++)$590d5f44e94a6803$var$updateZForEachState(elDisplayable, elOption, $590d5f44e94a6803$var$STATES[i]);
}
function $590d5f44e94a6803$var$updateZForEachState(elDisplayable, elOption, state) {
    var isNormal = state === $590d5f44e94a6803$var$NORMAL;
    var elStateOpt = isNormal ? elOption : $590d5f44e94a6803$var$retrieveStateOption(elOption, state);
    var optZ2 = elStateOpt ? elStateOpt.z2 : null;
    var stateObj;
    if (optZ2 != null) {
        // Do not `ensureState` until required.
        stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
        stateObj.z2 = optZ2 || 0;
    }
}
function $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api) {
    var renderItem = customSeries.get("renderItem");
    var coordSys = customSeries.coordinateSystem;
    var prepareResult = {};
    if (coordSys) // `coordSys.prepareCustoms` is used for external coord sys like bmap.
    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : $590d5f44e94a6803$var$prepareCustoms[coordSys.type](coordSys);
    var userAPI = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        getWidth: api.getWidth,
        getHeight: api.getHeight,
        getZr: api.getZr,
        getDevicePixelRatio: api.getDevicePixelRatio,
        value: value,
        style: style,
        ordinalRawValue: ordinalRawValue,
        styleEmphasis: styleEmphasis,
        visual: visual,
        barLayout: barLayout,
        currentSeriesIndices: currentSeriesIndices,
        font: font
    }, prepareResult.api || {});
    var userParams = {
        // The life cycle of context: current round of rendering.
        // The global life cycle is probably not necessary, because
        // user can store global status by themselves.
        context: {},
        seriesId: customSeries.id,
        seriesName: customSeries.name,
        seriesIndex: customSeries.seriesIndex,
        coordSys: prepareResult.coordSys,
        dataInsideLength: data.count(),
        encode: $590d5f44e94a6803$var$wrapEncodeDef(customSeries.getData())
    };
    // If someday intending to refactor them to a class, should consider do not
    // break change: currently these attribute member are encapsulated in a closure
    // so that do not need to force user to call these method with a scope.
    // Do not support call `api` asynchronously without dataIndexInside input.
    var currDataIndexInside;
    var currItemModel;
    var currItemStyleModels = {};
    var currLabelModels = {};
    var seriesItemStyleModels = {};
    var seriesLabelModels = {};
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
        var stateName = $590d5f44e94a6803$var$STATES[i];
        seriesItemStyleModels[stateName] = customSeries.getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[stateName]);
        seriesLabelModels[stateName] = customSeries.getModel($590d5f44e94a6803$var$PATH_LABEL[stateName]);
    }
    function getItemModel(dataIndexInside) {
        return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
    }
    function getItemStyleModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[state]);
    }
    function getLabelModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_LABEL[state]);
    }
    return function(dataIndexInside, payload) {
        currDataIndexInside = dataIndexInside;
        currItemModel = null;
        currItemStyleModels = {};
        currLabelModels = {};
        return renderItem && renderItem((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            dataIndexInside: dataIndexInside,
            dataIndex: data.getRawIndex(dataIndexInside),
            // Can be used for optimization when zoom or roam.
            actionType: payload ? payload.type : null
        }, userParams), userAPI);
    };
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function value(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
    }
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function ordinalRawValue(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        dim = dim || 0;
        var dimInfo = data.getDimensionInfo(dim);
        if (!dimInfo) {
            var dimIndex = data.getDimensionIndex(dim);
            return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
        }
        var val = data.get(dimInfo.name, dataIndexInside);
        var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
        return ordinalMeta ? ordinalMeta.categories[val] : val;
    }
    /**
   * @deprecated The original intention of `api.style` is enable to set itemStyle
   * like other series. But it is not necessary and not easy to give a strict definition
   * of what it returns. And since echarts5 it needs to be make compat work. So
   * deprecates it since echarts5.
   *
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   *
   * [Compat]: since ec5, RectText has been separated from its hosts el.
   * so `api.style()` will only return the style from `itemStyle` but not handle `label`
   * any more. But `series.label` config is never published in doc.
   * We still compat it in `api.style()`. But not encourage to use it and will still not
   * to pulish it to doc.
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function style(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var style = data.getItemVisual(dataIndexInside, "style");
        var visualColor = style && style.fill;
        var opacity = style && style.opacity;
        var itemStyle = getItemStyleModel(dataIndexInside, $590d5f44e94a6803$var$NORMAL).getItemStyle();
        visualColor != null && (itemStyle.fill = visualColor);
        opacity != null && (itemStyle.opacity = opacity);
        var opt = {
            inheritColor: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(visualColor) ? visualColor : "#000"
        };
        var labelModel = getLabelModel(dataIndexInside, $590d5f44e94a6803$var$NORMAL);
        // Now that the feature of "auto adjust text fill/stroke" has been migrated to zrender
        // since ec5, we should set `isAttached` as `false` here and make compat in
        // `convertToEC4StyleForCustomSerise`.
        var textStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(labelModel, null, opt, false, true);
        textStyle.text = labelModel.getShallow("show") ? (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$NORMAL), (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(labelModel, opt, false);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $daa53642c3afcc30$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    /**
   * @deprecated The reason see `api.style()`
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function styleEmphasis(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var itemStyle = getItemStyleModel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS).getItemStyle();
        var labelModel = getLabelModel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS);
        var textStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(labelModel, null, null, true, true);
        textStyle.text = labelModel.getShallow("show") ? (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$NORMAL), (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(labelModel, null, true);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $daa53642c3afcc30$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    function applyUserPropsAfter(itemStyle, extra) {
        for(var key in extra)if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(extra, key)) itemStyle[key] = extra[key];
    }
    function preFetchFromExtra(extra, itemStyle) {
        // A trick to retrieve those props firstly, which are used to
        // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
        // (It's not reasonable but only for a degree of compat)
        if (extra) {
            extra.textFill && (itemStyle.textFill = extra.textFill);
            extra.textPosition && (itemStyle.textPosition = extra.textPosition);
        }
    }
    /**
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function visual(visualType, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)((0, $fef28dd8967d3f1b$export$84369c8e2229fa7f), visualType)) {
            var style_1 = data.getItemVisual(dataIndexInside, "style");
            return style_1 ? style_1[(0, $fef28dd8967d3f1b$export$84369c8e2229fa7f)[visualType]] : null;
        }
        // Only support these visuals. Other visual might be inner tricky
        // for performance (like `style`), do not expose to users.
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)((0, $fef28dd8967d3f1b$export$734d775a14929701), visualType)) return data.getItemVisual(dataIndexInside, visualType);
    }
    /**
   * @public
   * @return If not support, return undefined.
   */ function barLayout(opt) {
        if (coordSys.type === "cartesian2d") {
            var baseAxis = coordSys.getBaseAxis();
            return (0, $361c48dd900de28f$export$658df087977b9e84)((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                axis: baseAxis
            }, opt));
        }
    }
    /**
   * @public
   */ function currentSeriesIndices() {
        return ecModel.getCurrentSeriesIndices();
    }
    /**
   * @public
   * @return font string
   */ function font(opt) {
        return $6800dfcb6e1e2a44$export$155316a870a9d61e(opt, ecModel);
    }
}
function $590d5f44e94a6803$var$wrapEncodeDef(data) {
    var encodeDef = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimInfo = data.getDimensionInfo(dimName);
        if (!dimInfo.isExtraCoord) {
            var coordDim = dimInfo.coordDim;
            var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
            dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
        }
    });
    return encodeDef;
}
function $590d5f44e94a6803$var$createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
    // [Rule]
    // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
    //     (It seems that violate the "merge" principle, but most of users probably intuitively
    //     regard "return;" as "show nothing element whatever", so make a exception to meet the
    //     most cases.)
    // The rule or "merge" see [STRATEGY_MERGE].
    // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
    if (!elOption) {
        group.remove(existsEl);
        return;
    }
    var el = $590d5f44e94a6803$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
    el && data.setItemGraphicEl(dataIndex, el);
    el && (0, $2bf82c0980125b62$export$e51187539ff11209)(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
    return el;
}
function $590d5f44e94a6803$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
    var toBeReplacedIdx = -1;
    var oldEl = existsEl;
    if (existsEl && $590d5f44e94a6803$var$doesElNeedRecreate(existsEl, elOption, seriesModel)) {
        // Should keep at the original index, otherwise "merge by index" will be incorrect.
        toBeReplacedIdx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(group.childrenRef(), existsEl);
        existsEl = null;
    }
    var isInit = !existsEl;
    var el = existsEl;
    if (!el) {
        el = $590d5f44e94a6803$var$createEl(elOption);
        if (oldEl) $590d5f44e94a6803$var$copyElement(oldEl, el);
    } else // FIMXE:NEXT unified clearState?
    // If in some case the performance issue arised, consider
    // do not clearState but update cached normal state directly.
    el.clearStates();
    // Need to set morph: false explictly to disable automatically morphing.
    if (elOption.morph === false) el.disableMorphing = true;
    else if (el.disableMorphing) el.disableMorphing = false;
    $590d5f44e94a6803$var$attachedTxInfoTmp.normal.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.normal.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.emphasis.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.emphasis.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.blur.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.blur.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.select.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.select.conOpt = null;
    $590d5f44e94a6803$var$attachedTxInfoTmp.isLegacy = false;
    $590d5f44e94a6803$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, $590d5f44e94a6803$var$attachedTxInfoTmp);
    $590d5f44e94a6803$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
    $590d5f44e94a6803$var$updateElNormal(api, el, dataIndex, elOption, $590d5f44e94a6803$var$attachedTxInfoTmp, seriesModel, isInit);
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    // Update them only when user specified, otherwise, remain.
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "info") && ((0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).info = elOption.info);
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
        var stateName = $590d5f44e94a6803$var$STATES[i];
        if (stateName !== $590d5f44e94a6803$var$NORMAL) {
            var otherStateOpt = $590d5f44e94a6803$var$retrieveStateOption(elOption, stateName);
            var otherStyleOpt = $590d5f44e94a6803$var$retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
            $590d5f44e94a6803$var$updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, $590d5f44e94a6803$var$attachedTxInfoTmp);
        }
    }
    $590d5f44e94a6803$var$updateZ(el, elOption, seriesModel);
    if (elOption.type === "group") $590d5f44e94a6803$var$mergeChildren(api, el, dataIndex, elOption, seriesModel);
    if (toBeReplacedIdx >= 0) group.replaceAt(el, toBeReplacedIdx);
    else group.add(el);
    return el;
}
// `el` must not be null/undefined.
function $590d5f44e94a6803$var$doesElNeedRecreate(el, elOption, seriesModel) {
    var elInner = (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el);
    var elOptionType = elOption.type;
    var elOptionShape = elOption.shape;
    var elOptionStyle = elOption.style;
    return(// Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    seriesModel.isUniversalTransitionEnabled() || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === "path" && $590d5f44e94a6803$var$hasOwnPathData(elOptionShape) && $590d5f44e94a6803$var$getPathData(elOptionShape) !== elInner.customPathData || elOptionType === "image" && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOptionStyle, "image") && elOptionStyle.image !== elInner.customImagePath);
}
function $590d5f44e94a6803$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
    // Based on the "merge" principle, if no clipPath provided,
    // do nothing. The exists clip will be totally removed only if
    // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
    var clipPathOpt = elOption.clipPath;
    if (clipPathOpt === false) {
        if (el && el.getClipPath()) el.removeClipPath();
    } else if (clipPathOpt) {
        var clipPath = el.getClipPath();
        if (clipPath && $590d5f44e94a6803$var$doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) clipPath = null;
        if (!clipPath) {
            clipPath = $590d5f44e94a6803$var$createEl(clipPathOpt);
            el.setClipPath(clipPath);
        }
        $590d5f44e94a6803$var$updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
    }
// If not define `clipPath` in option, do nothing unnecessary.
}
function $590d5f44e94a6803$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
    // Group does not support textContent temporarily until necessary.
    if (el.isGroup) return;
    // Normal must be called before emphasis, for `isLegacy` detection.
    $590d5f44e94a6803$var$processTxInfo(elOption, null, attachedTxInfo);
    $590d5f44e94a6803$var$processTxInfo(elOption, $590d5f44e94a6803$var$EMPHASIS, attachedTxInfo);
    // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sense.
    // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
    // trade them as set to null to el.
    // Especially:
    // `elOption.textContent: false` means remove textContent.
    // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.
    var txConOptNormal = attachedTxInfo.normal.conOpt;
    var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
    var txConOptBlur = attachedTxInfo.blur.conOpt;
    var txConOptSelect = attachedTxInfo.select.conOpt;
    if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
        var textContent = el.getTextContent();
        if (txConOptNormal === false) textContent && el.removeTextContent();
        else {
            txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
                type: "text"
            };
            if (!textContent) {
                textContent = $590d5f44e94a6803$var$createEl(txConOptNormal);
                el.setTextContent(textContent);
            } else // If in some case the performance issue arised, consider
            // do not clearState but update cached normal state directly.
            textContent.clearStates();
            $590d5f44e94a6803$var$updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
            var txConStlOptNormal = txConOptNormal && txConOptNormal.style;
            for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
                var stateName = $590d5f44e94a6803$var$STATES[i];
                if (stateName !== $590d5f44e94a6803$var$NORMAL) {
                    var txConOptOtherState = attachedTxInfo[stateName].conOpt;
                    $590d5f44e94a6803$var$updateElOnState(stateName, textContent, txConOptOtherState, $590d5f44e94a6803$var$retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
                }
            }
            txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
        }
    }
}
function $590d5f44e94a6803$var$processTxInfo(elOption, state, attachedTxInfo) {
    var stateOpt = !state ? elOption : $590d5f44e94a6803$var$retrieveStateOption(elOption, state);
    var styleOpt = !state ? elOption.style : $590d5f44e94a6803$var$retrieveStyleOptionOnState(elOption, stateOpt, $590d5f44e94a6803$var$EMPHASIS);
    var elType = elOption.type;
    var txCfg = stateOpt ? stateOpt.textConfig : null;
    var txConOptNormal = elOption.textContent;
    var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : $590d5f44e94a6803$var$retrieveStateOption(txConOptNormal, state);
    if (styleOpt && // Because emphasis style has little info to detect legacy,
    // if normal is legacy, emphasis is trade as legacy.
    (attachedTxInfo.isLegacy || (0, $daa53642c3afcc30$export$3b868abde5eae7d1)(styleOpt, elType, !!txCfg, !!txConOpt))) {
        attachedTxInfo.isLegacy = true;
        var convertResult = (0, $daa53642c3afcc30$export$7748133eaaa8aecc)(styleOpt, elType, !state);
        // Explicitly specified `textConfig` and `textContent` has higher priority than
        // the ones generated by legacy style. Otherwise if users use them and `api.style`
        // at the same time, they not both work and hardly to known why.
        if (!txCfg && convertResult.textConfig) txCfg = convertResult.textConfig;
        if (!txConOpt && convertResult.textContent) txConOpt = convertResult.textContent;
    }
    if (!state && txConOpt) {
        var txConOptNormal_1 = txConOpt;
        // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.
        !txConOptNormal_1.type && (txConOptNormal_1.type = "text");
    }
    var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
    info.cfg = txCfg;
    info.conOpt = txConOpt;
}
function $590d5f44e94a6803$var$retrieveStateOption(elOption, state) {
    return !state ? elOption : elOption ? elOption[state] : null;
}
function $590d5f44e94a6803$var$retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
    var style = stateOption && stateOption.style;
    if (style == null && state === $590d5f44e94a6803$var$EMPHASIS && stateOptionNormal) style = stateOptionNormal.styleEmphasis;
    return style;
}
// Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates
//     that the existing children will not be removed, and enables the feature
//     that update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will
//     happen.
// (5) If `elOption.$mergeChildren` is not `false` neither `'byName'` and the
//     `el` is a group, and if any of the new child is null, it means to remove
//     the element at the same index, if exists. On the other hand, if the new
//     child is and empty object `{}`, it means to keep the element not changed.
//
// For implementation simpleness, do not provide a direct way to remove single
// child (otherwise the total indices of the children array have to be modified).
// User can remove a single child by setting its `ignore` to `true`.
function $590d5f44e94a6803$var$mergeChildren(api, el, dataIndex, elOption, seriesModel) {
    var newChildren = elOption.children;
    var newLen = newChildren ? newChildren.length : 0;
    var mergeChildren = elOption.$mergeChildren;
    // `diffChildrenByName` has been deprecated.
    var byName = mergeChildren === "byName" || elOption.diffChildrenByName;
    var notMerge = mergeChildren === false;
    // For better performance on roam update, only enter if necessary.
    if (!newLen && !byName && !notMerge) return;
    if (byName) {
        $590d5f44e94a6803$var$diffGroupChildren({
            api: api,
            oldChildren: el.children() || [],
            newChildren: newChildren || [],
            dataIndex: dataIndex,
            seriesModel: seriesModel,
            group: el
        });
        return;
    }
    notMerge && el.removeAll();
    // Mapping children of a group simply by index, which
    // might be better performance.
    var index = 0;
    for(; index < newLen; index++){
        var newChild = newChildren[index];
        var oldChild = el.childAt(index);
        if (newChild) {
            if (newChild.ignore == null) // The old child is set to be ignored if null (see comments
            // below). So we need to set ignore to be false back.
            newChild.ignore = false;
            $590d5f44e94a6803$var$doCreateOrUpdateEl(api, oldChild, dataIndex, newChild, seriesModel, el);
        } else // If the new element option is null, it means to remove the old
        // element. But we cannot really remove the element from the group
        // directly, because the element order may not be stable when this
        // element is added back. So we set the element to be ignored.
        oldChild.ignore = true;
    }
    for(var i = el.childCount() - 1; i >= index; i--){
        var child = el.childAt(i);
        $590d5f44e94a6803$var$removeChildFromGroup(el, child, seriesModel);
    }
}
function $590d5f44e94a6803$var$removeChildFromGroup(group, child, seriesModel) {
    // Do not support leave elements that are not mentioned in the latest
    // `renderItem` return. Otherwise users may not have a clear and simple
    // concept that how to control all of the elements.
    child && (0, $7c104376a000308e$export$15575b6d82d35bb3)(child, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(group).option, seriesModel);
}
function $590d5f44e94a6803$var$diffGroupChildren(context) {
    new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(context.oldChildren, context.newChildren, $590d5f44e94a6803$var$getKey, $590d5f44e94a6803$var$getKey, context).add($590d5f44e94a6803$var$processAddUpdate).update($590d5f44e94a6803$var$processAddUpdate).remove($590d5f44e94a6803$var$processRemove).execute();
}
function $590d5f44e94a6803$var$getKey(item, idx) {
    var name = item && item.name;
    return name != null ? name : $590d5f44e94a6803$var$GROUP_DIFF_PREFIX + idx;
}
function $590d5f44e94a6803$var$processAddUpdate(newIndex, oldIndex) {
    var context = this.context;
    var childOption = newIndex != null ? context.newChildren[newIndex] : null;
    var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
    $590d5f44e94a6803$var$doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
}
function $590d5f44e94a6803$var$processRemove(oldIndex) {
    var context = this.context;
    var child = context.oldChildren[oldIndex];
    child && (0, $7c104376a000308e$export$15575b6d82d35bb3)(child, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(child).option, context.seriesModel);
}
/**
 * @return SVG Path data.
 */ function $590d5f44e94a6803$var$getPathData(shape) {
    // "d" follows the SVG convention.
    return shape && (shape.pathData || shape.d);
}
function $590d5f44e94a6803$var$hasOwnPathData(shape) {
    return shape && ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(shape, "pathData") || (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(shape, "d"));
}


function $3fd02cf8c6a1578a$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $590d5f44e94a6803$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $fef28dd8967d3f1b$export$2e2bcd8739ae039));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a331d7a6c631e6d9$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $a331d7a6c631e6d9$var$clone = $7a1bd9c2710fea0d$export$9cd59f9826255e47;
var $a331d7a6c631e6d9$var$bind = $7a1bd9c2710fea0d$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $a331d7a6c631e6d9$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get("value");
        var status = axisPointerModel.get("status");
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === "hide") {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $5b455ae6f843ac47$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($a331d7a6c631e6d9$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $a331d7a6c631e6d9$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get("animation");
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === "category";
        var useSnap = axisPointerModel.get("snap");
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === "auto" || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemenented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $a331d7a6c631e6d9$var$inner(group).pointerEl = new $5b455ae6f843ac47$exports[pointerOption.type]($a331d7a6c631e6d9$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $a331d7a6c631e6d9$var$inner(group).labelEl = new $5b455ae6f843ac47$exports.Text($a331d7a6c631e6d9$var$clone(elOption.label));
            group.add(labelEl);
            $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $a331d7a6c631e6d9$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $a331d7a6c631e6d9$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel("handle");
        var status = axisPointerModel.get("status");
        if (!handleModel.get("show") || !status || status === "hide") {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $5b455ae6f843ac47$exports.createIcon(handleModel.get("icon"), {
                cursor: "move",
                draggable: true,
                onmousemove: function(e) {
                    // For mobile device, prevent screen slider on the button.
                    $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $a331d7a6c631e6d9$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $a331d7a6c631e6d9$var$bind(this._onHandleDragMove, this),
                ondragend: $a331d7a6c631e6d9$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $a331d7a6c631e6d9$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            "color",
            "borderColor",
            "borderWidth",
            "opacity",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ]));
        // update position
        var handleSize = handleModel.get("size");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $c98659a9437a3d2e$export$958e3e1a02eac4b6(this, "_doDispatchAxisPointer", handleModel.get("throttle") || 0, "fixRate");
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $a331d7a6c631e6d9$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $a331d7a6c631e6d9$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($a331d7a6c631e6d9$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($a331d7a6c631e6d9$var$getHandleTransProps(trans));
        $a331d7a6c631e6d9$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: "updateAxisPointer",
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get("value");
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: "hideTip"
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $c98659a9437a3d2e$export$42ffd38884aecdac(this, "_doDispatchAxisPointer");
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $a331d7a6c631e6d9$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$a331d7a6c631e6d9$var$propsEqual($a331d7a6c631e6d9$var$inner(el).lastProp, props)) {
        $a331d7a6c631e6d9$var$inner(el).lastProp = props;
        moveAnimation ? $5b455ae6f843ac47$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $a331d7a6c631e6d9$var$propsEqual(lastProps, newProps) {
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(lastProps) && $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $a331d7a6c631e6d9$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        "label",
        "show"
    ]) ? "show" : "hide"]();
}
function $a331d7a6c631e6d9$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $a331d7a6c631e6d9$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get("z");
    var zlevel = axisPointerModel.get("zlevel");
    group && group.traverse(function(el) {
        if (el.type !== "group") {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $a331d7a6c631e6d9$export$2e2bcd8739ae039 = $a331d7a6c631e6d9$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get("type");
    var styleModel = axisPointerModel.getModel(axisPointerType + "Style");
    var style;
    if (axisPointerType === "line") {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === "shadow") {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get("value");
    var text = $51dec70890757374$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get("seriesDataIndices"), {
        precision: axisPointerModel.get([
            "label",
            "precision"
        ]),
        formatter: axisPointerModel.get([
            "label",
            "formatter"
        ])
    });
    var labelModel = axisPointerModel.getModel("label");
    var paddings = $c84c9521536c601a$export$f3a38102c49f4268(labelModel.get("padding") || 0);
    var font = labelModel.getFont();
    var textRect = $6c308355c7107803$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === "right" && (position[0] -= width);
    align === "center" && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === "bottom" && (position[1] -= height);
    verticalAlign === "middle" && (position[1] -= height / 2);
    // Not overflow ec container
    $51dec70890757374$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get("backgroundColor");
    if (!bgColor || bgColor === "auto") bgColor = axisModel.get([
        "axisLine",
        "lineStyle",
        "color"
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $51dec70890757374$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $51dec70890757374$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $2d646e51cc34f840$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) text = formatter.replace("{value}", text);
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $51dec70890757374$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $5b455ae6f843ac47$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $51dec70890757374$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    // @ts-ignore
    var textLayout = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        "label",
        "margin"
    ]);
    $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $51dec70890757374$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $51dec70890757374$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $51dec70890757374$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}



var $044c80eefb03ac3d$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get("type");
        var otherExtent = $044c80eefb03ac3d$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $044c80eefb03ac3d$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $88c937c9bc0ca068$export$b3219800bda33a1f(grid.model, axisModel);
        $51dec70890757374$export$fd3eb3812211a173(// @ts-ignore
        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $88c937c9bc0ca068$export$b3219800bda33a1f(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        });
        // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            "handle",
            "margin"
        ]);
        var pos = $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $044c80eefb03ac3d$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === "x" ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: "middle"
            },
            {
                align: "center"
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
function $044c80eefb03ac3d$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + "AxisIndex"] = axis.index;
    return grid.getCartesian(opt);
}
var $044c80eefb03ac3d$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $51dec70890757374$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $044c80eefb03ac3d$var$getAxisDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: "Rect",
            shape: $51dec70890757374$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $044c80eefb03ac3d$var$getAxisDimIndex(axis))
        };
    }
};
function $044c80eefb03ac3d$var$getAxisDimIndex(axis) {
    return axis.dim === "x" ? 0 : 1;
}
var $044c80eefb03ac3d$export$2e2bcd8739ae039 = $044c80eefb03ac3d$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f55b7040bd1041c6$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = "axisPointer";
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: "auto",
        // zlevel: 0,
        z: 50,
        type: "line",
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: "#B9BEC9",
            width: 1,
            type: "dashed"
        },
        shadowStyle: {
            color: "rgba(210,219,238,0.2)"
        },
        label: {
            show: true,
            formatter: null,
            precision: "auto",
            margin: 3,
            color: "#fff",
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: "auto",
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: "#333",
            shadowBlur: 3,
            shadowColor: "#aaa",
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $f55b7040bd1041c6$export$2e2bcd8739ae039 = $f55b7040bd1041c6$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $84450f5aa7fbde00$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $84450f5aa7fbde00$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $84450f5aa7fbde00$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $84450f5aa7fbde00$var$inner(zr).records || ($84450f5aa7fbde00$var$inner(zr).records = {});
    $84450f5aa7fbde00$var$initGlobalListeners(zr, api);
    var record = $84450f5aa7fbde00$var$inner(zr).records[key] || ($84450f5aa7fbde00$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $84450f5aa7fbde00$var$initGlobalListeners(zr, api) {
    if ($84450f5aa7fbde00$var$inner(zr).initialized) return;
    $84450f5aa7fbde00$var$inner(zr).initialized = true;
    useHandler("click", $7a1bd9c2710fea0d$export$c3095a23b368d1f2($84450f5aa7fbde00$var$doEnter, "click"));
    useHandler("mousemove", $7a1bd9c2710fea0d$export$c3095a23b368d1f2($84450f5aa7fbde00$var$doEnter, "mousemove"));
    // useHandler('mouseout', onLeave);
    useHandler("globalout", $84450f5aa7fbde00$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $84450f5aa7fbde00$var$makeDispatchAction(api);
            $84450f5aa7fbde00$var$each($84450f5aa7fbde00$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $84450f5aa7fbde00$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $84450f5aa7fbde00$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $84450f5aa7fbde00$var$onLeave(record, e, dispatchAction) {
    record.handler("leave", null, dispatchAction);
}
function $84450f5aa7fbde00$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $84450f5aa7fbde00$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $84450f5aa7fbde00$export$d07f55d4c15c0440(key, api) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($84450f5aa7fbde00$var$inner(zr).records || {})[key];
    if (record) $84450f5aa7fbde00$var$inner(zr).records[key] = null;
}



var $615cfe2d5ef5fcce$var$AxisPointerView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent("tooltip");
        var triggerOn = globalAxisPointerModel.get("triggerOn") || globalTooltipModel && globalTooltipModel.get("triggerOn") || "mousemove|click";
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $84450f5aa7fbde00$export$6503ec6e8aabbaf("axisPointer", api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none" && (currTrigger === "leave" || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: "updateAxisPointer",
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $84450f5aa7fbde00$export$d07f55d4c15c0440("axisPointer", api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $84450f5aa7fbde00$export$d07f55d4c15c0440("axisPointer", api);
    };
    AxisPointerView.type = "axisPointer";
    return AxisPointerView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $615cfe2d5ef5fcce$export$2e2bcd8739ae039 = $615cfe2d5ef5fcce$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $4cab5d8b3532dad5$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo("stackResultDimension"), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}



var $1cb2191f8bc71b5b$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $1cb2191f8bc71b5b$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($1cb2191f8bc71b5b$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $4cab5d8b3532dad5$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $1cb2191f8bc71b5b$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === "leave" || $1cb2191f8bc71b5b$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($1cb2191f8bc71b5b$var$showPointer, showValueMap),
        showTooltip: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($1cb2191f8bc71b5b$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $1cb2191f8bc71b5b$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $1cb2191f8bc71b5b$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $1cb2191f8bc71b5b$var$makeMapperParam(srcAxisInfo), $1cb2191f8bc71b5b$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $1cb2191f8bc71b5b$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $1cb2191f8bc71b5b$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $1cb2191f8bc71b5b$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $1cb2191f8bc71b5b$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $1cb2191f8bc71b5b$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $1cb2191f8bc71b5b$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $1cb2191f8bc71b5b$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === "category" ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $1cb2191f8bc71b5b$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $1cb2191f8bc71b5b$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $84d826b9ba8bf009$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                "label",
                "precision"
            ]),
            formatter: axisPointerModel.get([
                "label",
                "formatter"
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $1cb2191f8bc71b5b$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = "show");
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = "hide");
        // If status is 'hide', should be no info in payload.
        option.status === "show" && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $1cb2191f8bc71b5b$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($1cb2191f8bc71b5b$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: "hideTip"
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: "showTip",
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $1cb2191f8bc71b5b$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = "axisPointerLastHighlights";
    var lastHighlights = $1cb2191f8bc71b5b$var$inner(zr)[highDownKey] || {};
    var newHighlights = $1cb2191f8bc71b5b$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === "show" && axisInfo.triggerEmphasis && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + " | " + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: "downplay",
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: "highlight",
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $1cb2191f8bc71b5b$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $1cb2191f8bc71b5b$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + "AxisIndex"] = axisModel.componentIndex;
    item.axisName = item[dim + "AxisName"] = axisModel.name;
    item.axisId = item[dim + "AxisId"] = axisModel.id;
    return item;
}
function $1cb2191f8bc71b5b$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $589507869c21caa1$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("CartesianAxisPointer", (0, $044c80eefb03ac3d$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $f55b7040bd1041c6$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $615cfe2d5ef5fcce$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent("axisPointer").coordSysAxesInfo = (0, $84d826b9ba8bf009$export$bb44f104e3c54dae)(ecModel, api);
    });
    // Broadcast to all views.
    registers.registerAction({
        type: "updateAxisPointer",
        event: "updateAxisPointer",
        update: ":updateAxisPointer"
    }, (0, $1cb2191f8bc71b5b$export$2e2bcd8739ae039));
}



function $30909b2e837c2175$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1021478d6a16b0aa$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $692a4df2164e3c50$var$PolarAxisPointer = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PolarAxisPointer, _super);
    function PolarAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ PolarAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        if (axis.dim === "angle") this.animationThreshold = Math.PI / 18;
        var polar = axis.polar;
        var otherAxis = polar.getOtherAxis(axis);
        var otherExtent = otherAxis.getExtent();
        var coordValue = axis.dataToCoord(value);
        var axisPointerType = axisPointerModel.get("type");
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $692a4df2164e3c50$var$pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var labelMargin = axisPointerModel.get([
            "label",
            "margin"
        ]);
        var labelPos = $692a4df2164e3c50$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
        $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos);
    };
    return PolarAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
function $692a4df2164e3c50$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
    var axis = axisModel.axis;
    var coord = axis.dataToCoord(value);
    var axisAngle = polar.getAngleAxis().getExtent()[0];
    axisAngle = axisAngle / 180 * Math.PI;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var position;
    var align;
    var verticalAlign;
    if (axis.dim === "radius") {
        var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, axisAngle);
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, [
            polar.cx,
            polar.cy
        ]);
        position = $5b455ae6f843ac47$export$9f9dcb98c894b623([
            coord,
            -labelMargin
        ], transform);
        var labelRotation = axisModel.getModel("axisLabel").get("rotate") || 0;
        // @ts-ignore
        var labelLayout = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
        align = labelLayout.textAlign;
        verticalAlign = labelLayout.textVerticalAlign;
    } else {
        // angle axis
        var r = radiusExtent[1];
        position = polar.coordToPoint([
            r + labelMargin,
            coord
        ]);
        var cx = polar.cx;
        var cy = polar.cy;
        align = Math.abs(position[0] - cx) / r < 0.3 ? "center" : position[0] > cx ? "left" : "right";
        verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? "middle" : position[1] > cy ? "top" : "bottom";
    }
    return {
        position: position,
        align: align,
        verticalAlign: verticalAlign
    };
}
var $692a4df2164e3c50$var$pointerShapeBuilder = {
    line: function(axis, polar, coordValue, otherExtent) {
        return axis.dim === "angle" ? {
            type: "Line",
            shape: $51dec70890757374$export$885fa0ad5a826207(polar.coordToPoint([
                otherExtent[0],
                coordValue
            ]), polar.coordToPoint([
                otherExtent[1],
                coordValue
            ]))
        } : {
            type: "Circle",
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: coordValue
            }
        };
    },
    shadow: function(axis, polar, coordValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var radian = Math.PI / 180;
        return axis.dim === "angle" ? {
            type: "Sector",
            shape: $51dec70890757374$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
            (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
        } : {
            type: "Sector",
            shape: $51dec70890757374$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
        };
    }
};
var $692a4df2164e3c50$export$2e2bcd8739ae039 = $692a4df2164e3c50$var$PolarAxisPointer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $657132d924424c20$var$PolarModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PolarModel, _super);
    function PolarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarModel.type;
        return _this;
    }
    PolarModel.prototype.findAxisModel = function(axisType) {
        var foundAxisModel;
        var ecModel = this.ecModel;
        ecModel.eachComponent(axisType, function(axisModel) {
            if (axisModel.getCoordSysModel() === this) foundAxisModel = axisModel;
        }, this);
        return foundAxisModel;
    };
    PolarModel.type = "polar";
    PolarModel.dependencies = [
        "radiusAxis",
        "angleAxis"
    ];
    PolarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            "50%",
            "50%"
        ],
        radius: "80%"
    };
    return PolarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $657132d924424c20$export$2e2bcd8739ae039 = $657132d924424c20$var$PolarModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $d885303d9d4b2eee$export$ae9b190f9f84c66f = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PolarAxisModel, _super);
    function PolarAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolarAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    };
    PolarAxisModel.type = "polarAxis";
    return PolarAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($d885303d9d4b2eee$export$ae9b190f9f84c66f, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $d885303d9d4b2eee$export$34735c2c701428ca = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AngleAxisModel, _super);
    function AngleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisModel.type;
        return _this;
    }
    AngleAxisModel.type = "angleAxis";
    return AngleAxisModel;
}($d885303d9d4b2eee$export$ae9b190f9f84c66f);
var $d885303d9d4b2eee$export$de202388c212a23b = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RadiusAxisModel, _super);
    function RadiusAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisModel.type;
        return _this;
    }
    RadiusAxisModel.type = "radiusAxis";
    return RadiusAxisModel;
}($d885303d9d4b2eee$export$ae9b190f9f84c66f);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Axis scale

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $bf08c49320f1faba$var$RadiusAxis = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RadiusAxis, _super);
    function RadiusAxis(scale, radiusExtent) {
        return _super.call(this, "radius", scale, radiusExtent) || this;
    }
    RadiusAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === "radius" ? 0 : 1];
    };
    return RadiusAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
$bf08c49320f1faba$var$RadiusAxis.prototype.dataToRadius = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.dataToCoord;
$bf08c49320f1faba$var$RadiusAxis.prototype.radiusToData = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.coordToData;
var $bf08c49320f1faba$export$2e2bcd8739ae039 = $bf08c49320f1faba$var$RadiusAxis;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4a9e505d5dd42027$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $4a9e505d5dd42027$var$AngleAxis = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AngleAxis, _super);
    function AngleAxis(scale, angleExtent) {
        return _super.call(this, "angle", scale, angleExtent || [
            0,
            360
        ]) || this;
    }
    AngleAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === "radius" ? 0 : 1];
    };
    /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */ AngleAxis.prototype.calculateCategoryInterval = function() {
        var axis = this;
        var labelModel = axis.getLabelModel();
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        // Providing this method is for optimization:
        // avoid generating a long array by `getTicks`
        // in large category data case.
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitH = Math.abs(unitSpan);
        // Not precise, just use height as text width
        // and each distance from axis line yet.
        var rect = $6c308355c7107803$export$c381147bfed79d9f(tickValue == null ? "" : tickValue + "", labelModel.getFont(), "center", "top");
        var maxH = Math.max(rect.height, 7);
        var dh = maxH / unitH;
        // 0/0 is NaN, 1/0 is Infinity.
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(dh));
        var cache = $4a9e505d5dd42027$var$inner(axis.model);
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        // Use cache to keep interval stable while moving zoom window,
        // otherwise the calculated interval might jitter when the zoom
        // window size is close to the interval-changing size.
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
        }
        return interval;
    };
    return AngleAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
$4a9e505d5dd42027$var$AngleAxis.prototype.dataToAngle = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.dataToCoord;
$4a9e505d5dd42027$var$AngleAxis.prototype.angleToData = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.coordToData;
var $4a9e505d5dd42027$export$2e2bcd8739ae039 = $4a9e505d5dd42027$var$AngleAxis;


var $bbec1db3de81c4bf$export$f6d9521c10640456 = [
    "radius",
    "angle"
];
var $bbec1db3de81c4bf$var$Polar = /** @class */ function() {
    function Polar(name) {
        this.dimensions = $bbec1db3de81c4bf$export$f6d9521c10640456;
        this.type = "polar";
        /**
     * x of polar center
     */ this.cx = 0;
        /**
     * y of polar center
     */ this.cy = 0;
        this._radiusAxis = new (0, $bf08c49320f1faba$export$2e2bcd8739ae039)();
        this._angleAxis = new (0, $4a9e505d5dd42027$export$2e2bcd8739ae039)();
        this.axisPointerEnabled = true;
        this.name = name || "";
        this._radiusAxis.polar = this._angleAxis.polar = this;
    }
    /**
   * If contain coord
   */ Polar.prototype.containPoint = function(point) {
        var coord = this.pointToCoord(point);
        return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
    };
    /**
   * If contain data
   */ Polar.prototype.containData = function(data) {
        return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
    };
    Polar.prototype.getAxis = function(dim) {
        var key = "_" + dim + "Axis";
        return this[key];
    };
    Polar.prototype.getAxes = function() {
        return [
            this._radiusAxis,
            this._angleAxis
        ];
    };
    /**
   * Get axes by type of scale
   */ Polar.prototype.getAxesByScale = function(scaleType) {
        var axes = [];
        var angleAxis = this._angleAxis;
        var radiusAxis = this._radiusAxis;
        angleAxis.scale.type === scaleType && axes.push(angleAxis);
        radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
        return axes;
    };
    Polar.prototype.getAngleAxis = function() {
        return this._angleAxis;
    };
    Polar.prototype.getRadiusAxis = function() {
        return this._radiusAxis;
    };
    Polar.prototype.getOtherAxis = function(axis) {
        var angleAxis = this._angleAxis;
        return axis === angleAxis ? this._radiusAxis : angleAxis;
    };
    /**
   * Base axis will be used on stacking.
   *
   */ Polar.prototype.getBaseAxis = function() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAngleAxis();
    };
    Polar.prototype.getTooltipAxes = function(dim) {
        var baseAxis = dim != null && dim !== "auto" ? this.getAxis(dim) : this.getBaseAxis();
        return {
            baseAxes: [
                baseAxis
            ],
            otherAxes: [
                this.getOtherAxis(baseAxis)
            ]
        };
    };
    /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   */ Polar.prototype.dataToPoint = function(data, clamp) {
        return this.coordToPoint([
            this._radiusAxis.dataToRadius(data[0], clamp),
            this._angleAxis.dataToAngle(data[1], clamp)
        ]);
    };
    /**
   * Convert a (x, y) point to data
   */ Polar.prototype.pointToData = function(point, clamp) {
        var coord = this.pointToCoord(point);
        return [
            this._radiusAxis.radiusToData(coord[0], clamp),
            this._angleAxis.angleToData(coord[1], clamp)
        ];
    };
    /**
   * Convert a (x, y) point to (radius, angle) coord
   */ Polar.prototype.pointToCoord = function(point) {
        var dx = point[0] - this.cx;
        var dy = point[1] - this.cy;
        var angleAxis = this.getAngleAxis();
        var extent = angleAxis.getExtent();
        var minAngle = Math.min(extent[0], extent[1]);
        var maxAngle = Math.max(extent[0], extent[1]);
        // Fix fixed extent in polarCreator
        // FIXME
        angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx) / Math.PI * 180;
        // move to angleExtent
        var dir = radian < minAngle ? 1 : -1;
        while(radian < minAngle || radian > maxAngle)radian += dir * 360;
        return [
            radius,
            radian
        ];
    };
    /**
   * Convert a (radius, angle) coord to (x, y) point
   */ Polar.prototype.coordToPoint = function(coord) {
        var radius = coord[0];
        var radian = coord[1] / 180 * Math.PI;
        var x = Math.cos(radian) * radius + this.cx;
        // Inverse the y
        var y = -Math.sin(radian) * radius + this.cy;
        return [
            x,
            y
        ];
    };
    /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Polar.prototype.getArea = function() {
        var angleAxis = this.getAngleAxis();
        var radiusAxis = this.getRadiusAxis();
        var radiusExtent = radiusAxis.getExtent().slice();
        radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
        var angleExtent = angleAxis.getExtent();
        var RADIAN = Math.PI / 180;
        return {
            cx: this.cx,
            cy: this.cy,
            r0: radiusExtent[0],
            r: radiusExtent[1],
            startAngle: -angleExtent[0] * RADIAN,
            endAngle: -angleExtent[1] * RADIAN,
            clockwise: angleAxis.inverse,
            contain: function(x, y) {
                // It's a ring shape.
                // Start angle and end angle don't matter
                var dx = x - this.cx;
                var dy = y - this.cy;
                // minus a tiny value 1e-4 to avoid being clipped unexpectedly
                var d2 = dx * dx + dy * dy - 1e-4;
                var r = this.r;
                var r0 = this.r0;
                return d2 <= r * r && d2 >= r0 * r0;
            }
        };
    };
    Polar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $bbec1db3de81c4bf$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Polar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $bbec1db3de81c4bf$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Polar;
}();
function $bbec1db3de81c4bf$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var polarModel = finder.polarModel;
    return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $bbec1db3de81c4bf$export$2e2bcd8739ae039 = $bbec1db3de81c4bf$var$Polar;





/**
 * Resize method bound to the polar
 */ function $45211ba328a63245$var$resizePolar(polar, polarModel, api) {
    var center = polarModel.get("center");
    var width = api.getWidth();
    var height = api.getHeight();
    polar.cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width);
    polar.cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height);
    var radiusAxis = polar.getRadiusAxis();
    var size = Math.min(width, height) / 2;
    var radius = polarModel.get("radius");
    if (radius == null) radius = [
        0,
        "100%"
    ];
    else if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) // r0 = 0
    radius = [
        0,
        radius
    ];
    var parsedRadius = [
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size),
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size)
    ];
    radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
}
/**
 * Update polar
 */ function $45211ba328a63245$var$updatePolarScale(ecModel, api) {
    var polar = this;
    var angleAxis = polar.getAngleAxis();
    var radiusAxis = polar.getRadiusAxis();
    // Reset scale
    angleAxis.scale.setExtent(Infinity, -Infinity);
    radiusAxis.scale.setExtent(Infinity, -Infinity);
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem === polar) {
            var data_1 = seriesModel.getData();
            $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data_1, "radius"), function(dim) {
                radiusAxis.scale.unionExtentFromData(data_1, dim);
            });
            $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data_1, "angle"), function(dim) {
                angleAxis.scale.unionExtentFromData(data_1, dim);
            });
        }
    });
    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(angleAxis.scale, angleAxis.model);
    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(radiusAxis.scale, radiusAxis.model);
    // Fix extent of category angle axis
    if (angleAxis.type === "category" && !angleAxis.onBand) {
        var extent = angleAxis.getExtent();
        var diff = 360 / angleAxis.scale.count();
        angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
        angleAxis.setExtent(extent[0], extent[1]);
    }
}
function $45211ba328a63245$var$isAngleAxisModel(axisModel) {
    return axisModel.mainType === "angleAxis";
}
/**
 * Set common axis properties
 */ function $45211ba328a63245$var$setAxis(axis, axisModel) {
    var _a;
    axis.type = axisModel.get("type");
    axis.scale = (0, $2d646e51cc34f840$export$8941c4cacdc8f5a5)(axisModel);
    axis.onBand = axisModel.get("boundaryGap") && axis.type === "category";
    axis.inverse = axisModel.get("inverse");
    if ($45211ba328a63245$var$isAngleAxisModel(axisModel)) {
        axis.inverse = axis.inverse !== axisModel.get("clockwise");
        var startAngle = axisModel.get("startAngle");
        var endAngle = (_a = axisModel.get("endAngle")) !== null && _a !== void 0 ? _a : startAngle + (axis.inverse ? -360 : 360);
        axis.setExtent(startAngle, endAngle);
    }
    // Inject axis instance
    axisModel.axis = axis;
    axis.model = axisModel;
}
var $45211ba328a63245$var$polarCreator = {
    dimensions: (0, $bbec1db3de81c4bf$export$f6d9521c10640456),
    create: function(ecModel, api) {
        var polarList = [];
        ecModel.eachComponent("polar", function(polarModel, idx) {
            var polar = new (0, $bbec1db3de81c4bf$export$2e2bcd8739ae039)(idx + "");
            // Inject resize and update method
            polar.update = $45211ba328a63245$var$updatePolarScale;
            var radiusAxis = polar.getRadiusAxis();
            var angleAxis = polar.getAngleAxis();
            var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
            var angleAxisModel = polarModel.findAxisModel("angleAxis");
            $45211ba328a63245$var$setAxis(radiusAxis, radiusAxisModel);
            $45211ba328a63245$var$setAxis(angleAxis, angleAxisModel);
            $45211ba328a63245$var$resizePolar(polar, polarModel, api);
            polarList.push(polar);
            polarModel.coordinateSystem = polar;
            polar.model = polarModel;
        });
        // Inject coordinateSystem to series
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get("coordinateSystem") === "polar") {
                var polarModel = seriesModel.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                seriesModel.coordinateSystem = polarModel.coordinateSystem;
            }
        });
        return polarList;
    }
};
var $45211ba328a63245$export$2e2bcd8739ae039 = $45211ba328a63245$var$polarCreator;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $6fbccfdf5ee55341$var$elementList = [
    "axisLine",
    "axisLabel",
    "axisTick",
    "minorTick",
    "splitLine",
    "minorSplitLine",
    "splitArea"
];
function $6fbccfdf5ee55341$var$getAxisLineShape(polar, rExtent, angle) {
    rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
    var start = polar.coordToPoint([
        rExtent[0],
        angle
    ]);
    var end = polar.coordToPoint([
        rExtent[1],
        angle
    ]);
    return {
        x1: start[0],
        y1: start[1],
        x2: end[0],
        y2: end[1]
    };
}
function $6fbccfdf5ee55341$var$getRadiusIdx(polar) {
    var radiusAxis = polar.getRadiusAxis();
    return radiusAxis.inverse ? 0 : 1;
}
// Remove the last tick which will overlap the first tick
function $6fbccfdf5ee55341$var$fixAngleOverlap(list) {
    var firstItem = list[0];
    var lastItem = list[list.length - 1];
    if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) list.pop();
}
var $6fbccfdf5ee55341$var$AngleAxisView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AngleAxisView, _super);
    function AngleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisView.type;
        _this.axisPointerClass = "PolarAxisPointer";
        return _this;
    }
    AngleAxisView.prototype.render = function(angleAxisModel, ecModel) {
        this.group.removeAll();
        if (!angleAxisModel.get("show")) return;
        var angleAxis = angleAxisModel.axis;
        var polar = angleAxis.polar;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var ticksAngles = angleAxis.getTicksCoords();
        var minorTickAngles = angleAxis.getMinorTicksCoords();
        var labels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(angleAxis.getViewLabels(), function(labelItem) {
            labelItem = $7a1bd9c2710fea0d$export$9cd59f9826255e47(labelItem);
            var scale = angleAxis.scale;
            var tickValue = scale.type === "ordinal" ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            labelItem.coord = angleAxis.dataToCoord(tickValue);
            return labelItem;
        });
        $6fbccfdf5ee55341$var$fixAngleOverlap(labels);
        $6fbccfdf5ee55341$var$fixAngleOverlap(ticksAngles);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($6fbccfdf5ee55341$var$elementList, function(name) {
            if (angleAxisModel.get([
                name,
                "show"
            ]) && (!angleAxis.scale.isBlank() || name === "axisLine")) $6fbccfdf5ee55341$var$angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
        }, this);
    };
    AngleAxisView.type = "angleAxis";
    return AngleAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $6fbccfdf5ee55341$var$angelAxisElementsBuilders = {
    axisLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var lineStyleModel = angleAxisModel.getModel([
            "axisLine",
            "lineStyle"
        ]);
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        // extent id of the axis radius (r0 and r)
        var rId = $6fbccfdf5ee55341$var$getRadiusIdx(polar);
        var r0Id = rId ? 0 : 1;
        var shape;
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? "Circle" : "Arc";
        if (radiusExtent[r0Id] === 0) shape = new $5b455ae6f843ac47$exports[shapeType]({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                startAngle: -angleExtent[0] * RADIAN,
                endAngle: -angleExtent[1] * RADIAN,
                clockwise: angleAxis.inverse
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        else shape = new $5b455ae6f843ac47$exports.Ring({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                r0: radiusExtent[r0Id]
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        shape.style.fill = null;
        group.add(shape);
    },
    axisTick: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var tickModel = angleAxisModel.getModel("axisTick");
        var tickLen = (tickModel.get("inside") ? -1 : 1) * tickModel.get("length");
        var radius = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
        var lines = $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticksAngles, function(tickAngleItem) {
            return new $5b455ae6f843ac47$exports.Line({
                shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, [
                    radius,
                    radius + tickLen
                ], tickAngleItem.coord)
            });
        });
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e(tickModel.getModel("lineStyle").getLineStyle(), {
                stroke: angleAxisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ])
            })
        }));
    },
    minorTick: function(group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var tickModel = angleAxisModel.getModel("axisTick");
        var minorTickModel = angleAxisModel.getModel("minorTick");
        var tickLen = (tickModel.get("inside") ? -1 : 1) * minorTickModel.get("length");
        var radius = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Line({
            shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, [
                radius,
                radius + tickLen
            ], minorTickAngles[i][k].coord)
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e(minorTickModel.getModel("lineStyle").getLineStyle(), $7a1bd9c2710fea0d$export$ebe90cb607ad99e(tickModel.getLineStyle(), {
                stroke: angleAxisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ])
            }))
        }));
    },
    axisLabel: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
        var rawCategoryData = angleAxisModel.getCategories(true);
        var commonLabelModel = angleAxisModel.getModel("axisLabel");
        var labelMargin = commonLabelModel.get("margin");
        var triggerEvent = angleAxisModel.get("triggerEvent");
        // Use length of ticksAngles because it may remove the last tick to avoid overlapping
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(labels, function(labelItem, idx) {
            var labelModel = commonLabelModel;
            var tickValue = labelItem.tickValue;
            var r = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
            var p = polar.coordToPoint([
                r + labelMargin,
                labelItem.coord
            ]);
            var cx = polar.cx;
            var cy = polar.cy;
            var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? "center" : p[0] > cx ? "left" : "right";
            var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? "middle" : p[1] > cy ? "top" : "bottom";
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(rawCategoryItem) && rawCategoryItem.textStyle) labelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
            }
            var textEl = new $5b455ae6f843ac47$exports.Text({
                silent: (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).isLabelSilent(angleAxisModel),
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                    x: p[0],
                    y: p[1],
                    fill: labelModel.getTextColor() || angleAxisModel.get([
                        "axisLine",
                        "lineStyle",
                        "color"
                    ]),
                    text: labelItem.formattedLabel,
                    align: labelTextAlign,
                    verticalAlign: labelTextVerticalAlign
                })
            });
            group.add(textEl);
            // Pack data for mouse event
            if (triggerEvent) {
                var eventData = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).makeAxisEventDataBase(angleAxisModel);
                eventData.targetType = "axisLabel";
                eventData.value = labelItem.rawLabel;
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            }
        }, this);
    },
    splitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var splitLineModel = angleAxisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var lineCount = 0;
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksAngles.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $5b455ae6f843ac47$exports.Line({
                shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyleModel.getLineStyle()),
            silent: true,
            z: angleAxisModel.get("z")
        }));
    },
    minorSplitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var minorSplitLineModel = angleAxisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Line({
            shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: lineStyleModel.getLineStyle(),
            silent: true,
            z: angleAxisModel.get("z")
        }));
    },
    splitArea: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!ticksAngles.length) return;
        var splitAreaModel = angleAxisModel.getModel("splitArea");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var areaColors = areaStyleModel.get("color");
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var RADIAN = Math.PI / 180;
        var prevAngle = -ticksAngles[0].coord * RADIAN;
        var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
        var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
        var clockwise = angleAxisModel.get("clockwise");
        for(var i = 1, len = ticksAngles.length; i <= len; i++){
            var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $5b455ae6f843ac47$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: r0,
                    r: r1,
                    startAngle: prevAngle,
                    endAngle: -coord * RADIAN,
                    clockwise: clockwise
                },
                silent: true
            }));
            prevAngle = -coord * RADIAN;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitAreas[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
var $6fbccfdf5ee55341$export$2e2bcd8739ae039 = $6fbccfdf5ee55341$var$AngleAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $e1f5ed5855e953f0$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $e1f5ed5855e953f0$var$selfBuilderAttrs = [
    "splitLine",
    "splitArea",
    "minorSplitLine"
];
var $e1f5ed5855e953f0$var$RadiusAxisView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RadiusAxisView, _super);
    function RadiusAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisView.type;
        _this.axisPointerClass = "PolarAxisPointer";
        return _this;
    }
    RadiusAxisView.prototype.render = function(radiusAxisModel, ecModel) {
        this.group.removeAll();
        if (!radiusAxisModel.get("show")) return;
        var oldAxisGroup = this._axisGroup;
        var newAxisGroup = this._axisGroup = new $5b455ae6f843ac47$exports.Group();
        this.group.add(newAxisGroup);
        var radiusAxis = radiusAxisModel.axis;
        var polar = radiusAxis.polar;
        var angleAxis = polar.getAngleAxis();
        var ticksCoords = radiusAxis.getTicksCoords();
        var minorTicksCoords = radiusAxis.getMinorTicksCoords();
        var axisAngle = angleAxis.getExtent()[0];
        var radiusExtent = radiusAxis.getExtent();
        var layout = $e1f5ed5855e953f0$var$layoutAxis(polar, radiusAxisModel, axisAngle);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(radiusAxisModel, layout);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e1f5ed5855e953f0$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        newAxisGroup.add(axisBuilder.getGroup());
        $5b455ae6f843ac47$exports.groupTransition(oldAxisGroup, newAxisGroup, radiusAxisModel);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e1f5ed5855e953f0$var$selfBuilderAttrs, function(name) {
            if (radiusAxisModel.get([
                name,
                "show"
            ]) && !radiusAxis.scale.isBlank()) $e1f5ed5855e953f0$var$axisElementBuilders[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
        }, this);
    };
    RadiusAxisView.type = "radiusAxis";
    return RadiusAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $e1f5ed5855e953f0$var$axisElementBuilders = {
    splitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        var splitLineModel = radiusAxisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var lineCount = 0;
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? "Circle" : "Arc";
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $5b455ae6f843ac47$exports[shapeType]({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    // ensure circle radius >= 0
                    r: Math.max(ticksCoords[i].coord, 0),
                    startAngle: -angleExtent[0] * RADIAN,
                    endAngle: -angleExtent[1] * RADIAN,
                    clockwise: angleAxis.inverse
                }
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length],
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    minorSplitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
        if (!minorTicksCoords.length) return;
        var minorSplitLineModel = radiusAxisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var lines = [];
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Circle({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: minorTicksCoords[i][k].coord
            }
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    splitArea: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        if (!ticksCoords.length) return;
        var splitAreaModel = radiusAxisModel.getModel("splitArea");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var areaColors = areaStyleModel.get("color");
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var prevRadius = ticksCoords[0].coord;
        for(var i = 1; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $5b455ae6f843ac47$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: prevRadius,
                    r: ticksCoords[i].coord,
                    startAngle: 0,
                    endAngle: Math.PI * 2
                },
                silent: true
            }));
            prevRadius = ticksCoords[i].coord;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitAreas[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
/**
 * @inner
 */ function $e1f5ed5855e953f0$var$layoutAxis(polar, radiusAxisModel, axisAngle) {
    return {
        position: [
            polar.cx,
            polar.cy
        ],
        rotation: axisAngle / 180 * Math.PI,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1,
        labelRotate: radiusAxisModel.getModel("axisLabel").get("rotate"),
        // Over splitLine and splitArea
        z2: 1
    };
}
var $e1f5ed5855e953f0$export$2e2bcd8739ae039 = $e1f5ed5855e953f0$var$RadiusAxisView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $ee4ff9541971b552$var$getSeriesStackId(seriesModel) {
    return seriesModel.get("stack") || "__ec_stack_" + seriesModel.seriesIndex;
}
function $ee4ff9541971b552$var$getAxisKey(polar, axis) {
    return axis.dim + polar.model.componentIndex;
}
function $ee4ff9541971b552$var$barLayoutPolar(seriesType, ecModel, api) {
    var lastStackCoords = {};
    var barWidthAndOffset = $ee4ff9541971b552$var$calRadialBar($7a1bd9c2710fea0d$export$3dea766d36a8935f(ecModel.getSeriesByType(seriesType), function(seriesModel) {
        return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "polar";
    }));
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for polar only
        if (seriesModel.coordinateSystem.type !== "polar") return;
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $ee4ff9541971b552$var$getAxisKey(polar, baseAxis);
        var stackId = $ee4ff9541971b552$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = polar.getOtherAxis(baseAxis);
        var cx = seriesModel.coordinateSystem.cx;
        var cy = seriesModel.coordinateSystem.cy;
        var barMinHeight = seriesModel.get("barMinHeight") || 0;
        var barMinAngle = seriesModel.get("barMinAngle") || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, valueDim /* , baseDim */ );
        var clampLayout = baseAxis.dim !== "radius" || !seriesModel.get("roundCap", true);
        var valueAxisStart = valueAxis.dataToCoord(0);
        for(var idx = 0, len = data.count(); idx < len; idx++){
            var value = data.get(valueDim, idx);
            var baseValue = data.get(baseDim, idx);
            var sign = value >= 0 ? "p" : "n";
            var baseCoord = valueAxisStart;
            // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            // Only ordinal axis can be stacked.
            if (stacked) {
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var r0 = void 0;
            var r = void 0;
            var startAngle = void 0;
            var endAngle = void 0;
            // radial sector
            if (valueAxis.dim === "radius") {
                var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
                var angle = baseAxis.dataToCoord(baseValue);
                if (Math.abs(radiusSpan) < barMinHeight) radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
                r0 = baseCoord;
                r = baseCoord + radiusSpan;
                startAngle = angle - columnOffset;
                endAngle = startAngle - columnWidth;
                stacked && (lastStackCoords[stackId][baseValue][sign] = r);
            } else {
                var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
                var radius = baseAxis.dataToCoord(baseValue);
                if (Math.abs(angleSpan) < barMinAngle) angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
                r0 = radius + columnOffset;
                r = r0 + columnWidth;
                startAngle = baseCoord;
                endAngle = baseCoord + angleSpan;
                // if the previous stack is at the end of the ring,
                // add a round to differentiate it from origin
                // let extent = angleAxis.getExtent();
                // let stackCoord = angle;
                // if (stackCoord === extent[0] && value > 0) {
                //     stackCoord = extent[1];
                // }
                // else if (stackCoord === extent[1] && value < 0) {
                //     stackCoord = extent[0];
                // }
                stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
            }
            data.setItemLayout(idx, {
                cx: cx,
                cy: cy,
                r0: r0,
                r: r,
                // Consider that positive angle is anti-clockwise,
                // while positive radian of sector is clockwise
                startAngle: -startAngle * Math.PI / 180,
                endAngle: -endAngle * Math.PI / 180,
                /**
         * Keep the same logic with bar in catesion: use end value to
         * control direction. Notice that if clockwise is true (by
         * default), the sector will always draw clockwisely, no matter
         * whether endAngle is greater or less than startAngle.
         */ clockwise: startAngle >= endAngle
            });
        }
    });
}
/**
 * Calculate bar width and offset for radial bar charts
 */ function $ee4ff9541971b552$var$calRadialBar(barSeries) {
    // Columns info on each category axis. Key is polar name
    var columnsMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barSeries, function(seriesModel, idx) {
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $ee4ff9541971b552$var$getAxisKey(polar, baseAxis);
        var axisExtent = baseAxis.getExtent();
        var bandWidth = baseAxis.type === "category" ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: "20%",
            gap: "30%",
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = $ee4ff9541971b552$var$getSeriesStackId(seriesModel);
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        var barWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barWidth"), bandWidth);
        var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barMaxWidth"), bandWidth);
        var barGap = seriesModel.get("barGap");
        var barCategoryGap = seriesModel.get("barCategoryGap");
        if (barWidth && !stacks[stackId].width) {
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            stacks[stackId].width = barWidth;
            columnsOnAxis.remainedWidth -= barWidth;
        }
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        barGap != null && (columnsOnAxis.gap = barGap);
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGap = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.categoryGap, bandWidth);
        var barGapPercent = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, stack) {
            var maxWidth = column.maxWidth;
            if (maxWidth && maxWidth < autoWidth) {
                maxWidth = Math.min(maxWidth, remainedWidth);
                if (column.width) maxWidth = Math.min(maxWidth, column.width);
                remainedWidth -= maxWidth;
                column.width = maxWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
var $ee4ff9541971b552$export$2e2bcd8739ae039 = $ee4ff9541971b552$var$barLayoutPolar;


var $0a6536a72e92ce0b$var$angleAxisExtraOption = {
    startAngle: 90,
    clockwise: true,
    splitNumber: 12,
    axisLabel: {
        rotate: 0
    }
};
var $0a6536a72e92ce0b$var$radiusAxisExtraOption = {
    splitNumber: 5
};
var $0a6536a72e92ce0b$var$PolarView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PolarView, _super);
    function PolarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarView.type;
        return _this;
    }
    PolarView.type = "polar";
    return PolarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $0a6536a72e92ce0b$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("PolarAxisPointer", (0, $692a4df2164e3c50$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("polar", (0, $45211ba328a63245$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $657132d924424c20$export$2e2bcd8739ae039));
    registers.registerComponentView($0a6536a72e92ce0b$var$PolarView);
    // Model and view for angleAxis and radiusAxis
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "angle", (0, $d885303d9d4b2eee$export$34735c2c701428ca), $0a6536a72e92ce0b$var$angleAxisExtraOption);
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "radius", (0, $d885303d9d4b2eee$export$de202388c212a23b), $0a6536a72e92ce0b$var$radiusAxisExtraOption);
    registers.registerComponentView((0, $6fbccfdf5ee55341$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e1f5ed5855e953f0$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $ee4ff9541971b552$export$2e2bcd8739ae039), "bar"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel, opt) {
    opt = opt || {};
    var single = axisModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var axisPosition = axis.position;
    var orient = axis.orient;
    var rect = single.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var positionMap = {
        horizontal: {
            top: rectBound[2],
            bottom: rectBound[3]
        },
        vertical: {
            left: rectBound[0],
            right: rectBound[1]
        }
    };
    layout.position = [
        orient === "vertical" ? positionMap.vertical[axisPosition] : rectBound[0],
        orient === "horizontal" ? positionMap.horizontal[axisPosition] : rectBound[3]
    ];
    var r = {
        horizontal: 0,
        vertical: 1
    };
    layout.rotation = Math.PI / 2 * r[orient];
    var directionMap = {
        top: -1,
        bottom: 1,
        right: 1,
        left: -1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
    if (axisModel.get([
        "axisTick",
        "inside"
    ])) layout.tickDirection = -layout.tickDirection;
    if ($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        "axisLabel",
        "inside"
    ]))) layout.labelDirection = -layout.labelDirection;
    var labelRotation = opt.rotate;
    labelRotation == null && (labelRotation = axisModel.get([
        "axisLabel",
        "rotate"
    ]));
    layout.labelRotation = axisPosition === "top" ? -labelRotation : labelRotation;
    layout.z2 = 1;
    return layout;
}




var $e0635e836f59c3c6$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $e0635e836f59c3c6$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine"
];
var $e0635e836f59c3c6$var$SingleAxisView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SingleAxisView, _super);
    function SingleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisView.type;
        _this.axisPointerClass = "SingleAxisPointer";
        return _this;
    }
    SingleAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var layout = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, layout);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e0635e836f59c3c6$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        group.add(this._axisGroup);
        group.add(axisBuilder.getGroup());
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e0635e836f59c3c6$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                "show"
            ])) $e0635e836f59c3c6$var$axisElementBuilders[name](this, this.group, this._axisGroup, axisModel);
        }, this);
        $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    SingleAxisView.prototype.remove = function() {
        (0, $ff3096b1f24c33b6$export$48ebf2d6ce8ad076)(this);
    };
    SingleAxisView.type = "singleAxis";
    return SingleAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $e0635e836f59c3c6$var$axisElementBuilders = {
    splitLine: function(axisView, group, axisGroup, axisModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var lineWidth = lineStyleModel.get("width");
        var gridRect = axisModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var splitLines = [];
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        for(var i = 0; i < ticksCoords.length; ++i){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineWidth);
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(line);
        }
        var lineStyle = lineStyleModel.getLineStyle([
            "color"
        ]);
        for(var i = 0; i < splitLines.length; ++i)group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyle),
            silent: true
        }));
    },
    splitArea: function(axisView, group, axisGroup, axisModel) {
        (0, $ff3096b1f24c33b6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, axisModel);
    }
};
var $e0635e836f59c3c6$export$2e2bcd8739ae039 = $e0635e836f59c3c6$var$SingleAxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $0b0fbc117344336a$var$SingleAxisModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SingleAxisModel, _super);
    function SingleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisModel.type;
        return _this;
    }
    SingleAxisModel.prototype.getCoordSysModel = function() {
        return this;
    };
    SingleAxisModel.type = "singleAxis";
    SingleAxisModel.layoutMode = "box";
    SingleAxisModel.defaultOption = {
        left: "5%",
        top: "5%",
        right: "5%",
        bottom: "5%",
        type: "value",
        position: "bottom",
        orient: "horizontal",
        axisLine: {
            show: true,
            lineStyle: {
                width: 1,
                type: "solid"
            }
        },
        // Single coordinate system and single axis is the,
        // which is used as the parent tooltip model.
        // same model, so we set default tooltip show as true.
        tooltip: {
            show: true
        },
        axisTick: {
            show: true,
            length: 6,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            interval: "auto"
        },
        splitLine: {
            show: true,
            lineStyle: {
                type: "dashed",
                opacity: 0.2
            }
        }
    };
    return SingleAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($0b0fbc117344336a$var$SingleAxisModel, (0, $3449fd4c0590d99e$export$5c54b224726edb5a).prototype);
var $0b0fbc117344336a$export$2e2bcd8739ae039 = $0b0fbc117344336a$var$SingleAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinate system creator.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinates system.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $75328fa4f01e808e$var$SingleAxis = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SingleAxis, _super);
    function SingleAxis(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        _this.position = position || "bottom";
        return _this;
    }
    /**
   * Judge the orient of the axis.
   */ SingleAxis.prototype.isHorizontal = function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    };
    SingleAxis.prototype.pointToData = function(point, clamp) {
        return this.coordinateSystem.pointToData(point)[0];
    };
    return SingleAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $75328fa4f01e808e$export$2e2bcd8739ae039 = $75328fa4f01e808e$var$SingleAxis;





var $2e4ce743775bada6$export$28486687f659fb1a = [
    "single"
];
/**
 * Create a single coordinates system.
 */ var $2e4ce743775bada6$var$Single = /** @class */ function() {
    function Single(axisModel, ecModel, api) {
        this.type = "single";
        this.dimension = "single";
        /**
     * Add it just for draw tooltip.
     */ this.dimensions = $2e4ce743775bada6$export$28486687f659fb1a;
        this.axisPointerEnabled = true;
        this.model = axisModel;
        this._init(axisModel, ecModel, api);
    }
    /**
   * Initialize single coordinate system.
   */ Single.prototype._init = function(axisModel, ecModel, api) {
        var dim = this.dimension;
        var axis = new (0, $75328fa4f01e808e$export$2e2bcd8739ae039)(dim, $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel), [
            0,
            0
        ], axisModel.get("type"), axisModel.get("position"));
        var isCategory = axis.type === "category";
        axis.onBand = isCategory && axisModel.get("boundaryGap");
        axis.inverse = axisModel.get("inverse");
        axis.orient = axisModel.get("orient");
        axisModel.axis = axis;
        axis.model = axisModel;
        axis.coordinateSystem = this;
        this._axis = axis;
    };
    /**
   * Update axis scale after data processed
   */ Single.prototype.update = function(ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.coordinateSystem === this) {
                var data_1 = seriesModel.getData();
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data_1.mapDimensionsAll(this.dimension), function(dim) {
                    this._axis.scale.unionExtentFromData(data_1, dim);
                }, this);
                $2d646e51cc34f840$export$51f3e70a54405d5a(this._axis.scale, this._axis.model);
            }
        }, this);
    };
    /**
   * Resize the single coordinate system.
   */ Single.prototype.resize = function(axisModel, api) {
        this._rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)({
            left: axisModel.get("left"),
            top: axisModel.get("top"),
            right: axisModel.get("right"),
            bottom: axisModel.get("bottom"),
            width: axisModel.get("width"),
            height: axisModel.get("height")
        }, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._adjustAxis();
    };
    Single.prototype.getRect = function() {
        return this._rect;
    };
    Single.prototype._adjustAxis = function() {
        var rect = this._rect;
        var axis = this._axis;
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [
            0,
            rect.width
        ] : [
            0,
            rect.height
        ];
        var idx = axis.inverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
    };
    Single.prototype._updateAxisTransform = function(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var extentSum = axisExtent[0] + axisExtent[1];
        var isHorizontal = axis.isHorizontal();
        axis.toGlobalCoord = isHorizontal ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
        axis.toLocalCoord = isHorizontal ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
    };
    /**
   * Get axis.
   */ Single.prototype.getAxis = function() {
        return this._axis;
    };
    /**
   * Get axis, add it just for draw tooltip.
   */ Single.prototype.getBaseAxis = function() {
        return this._axis;
    };
    Single.prototype.getAxes = function() {
        return [
            this._axis
        ];
    };
    Single.prototype.getTooltipAxes = function() {
        return {
            baseAxes: [
                this.getAxis()
            ],
            // Empty otherAxes
            otherAxes: []
        };
    };
    /**
   * If contain point.
   */ Single.prototype.containPoint = function(point) {
        var rect = this.getRect();
        var axis = this.getAxis();
        var orient = axis.orient;
        if (orient === "horizontal") return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
        else return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    };
    Single.prototype.pointToData = function(point) {
        var axis = this.getAxis();
        return [
            axis.coordToData(axis.toLocalCoord(point[axis.orient === "horizontal" ? 0 : 1]))
        ];
    };
    /**
   * Convert the series data to concrete point.
   * Can be [val] | val
   */ Single.prototype.dataToPoint = function(val) {
        var axis = this.getAxis();
        var rect = this.getRect();
        var pt = [];
        var idx = axis.orient === "horizontal" ? 0 : 1;
        if (val instanceof Array) val = val[0];
        pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
        pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
        return pt;
    };
    Single.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $2e4ce743775bada6$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Single.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $2e4ce743775bada6$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Single;
}();
function $2e4ce743775bada6$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var singleModel = finder.singleAxisModel;
    return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $2e4ce743775bada6$export$2e2bcd8739ae039 = $2e4ce743775bada6$var$Single;



/**
 * Create single coordinate system and inject it into seriesModel.
 */ function $65313efe3e93ec7e$var$create(ecModel, api) {
    var singles = [];
    ecModel.eachComponent("singleAxis", function(axisModel, idx) {
        var single = new (0, $2e4ce743775bada6$export$2e2bcd8739ae039)(axisModel, ecModel, api);
        single.name = "single_" + idx;
        single.resize(axisModel, api);
        axisModel.coordinateSystem = single;
        singles.push(single);
    });
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get("coordinateSystem") === "singleAxis") {
            var singleAxisModel = seriesModel.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
        }
    });
    return singles;
}
var $65313efe3e93ec7e$var$singleCreator = {
    create: $65313efe3e93ec7e$var$create,
    dimensions: (0, $2e4ce743775bada6$export$28486687f659fb1a)
};
var $65313efe3e93ec7e$export$2e2bcd8739ae039 = $65313efe3e93ec7e$var$singleCreator;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $26df41956a30cbbf$var$XY = [
    "x",
    "y"
];
var $26df41956a30cbbf$var$WH = [
    "width",
    "height"
];
var $26df41956a30cbbf$var$SingleAxisPointer = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SingleAxisPointer, _super);
    function SingleAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ SingleAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var otherExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, 1 - $26df41956a30cbbf$var$getPointDimIndex(axis));
        var pixelValue = coordSys.dataToPoint(value)[0];
        var axisPointerType = axisPointerModel.get("type");
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $26df41956a30cbbf$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel);
        $51dec70890757374$export$fd3eb3812211a173(// @ts-ignore
        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel, {
            labelInside: false
        });
        // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            "handle",
            "margin"
        ]);
        var position = $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: position[0],
            y: position[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var dimIndex = $26df41956a30cbbf$var$getPointDimIndex(axis);
        var axisExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, dimIndex);
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var otherExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, 1 - dimIndex);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: {
                verticalAlign: "middle"
            }
        };
    };
    return SingleAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
var $26df41956a30cbbf$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $51dec70890757374$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $26df41956a30cbbf$var$getPointDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = axis.getBandWidth();
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: "Rect",
            shape: $51dec70890757374$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $26df41956a30cbbf$var$getPointDimIndex(axis))
        };
    }
};
function $26df41956a30cbbf$var$getPointDimIndex(axis) {
    return axis.isHorizontal() ? 0 : 1;
}
function $26df41956a30cbbf$var$getGlobalExtent(coordSys, dimIndex) {
    var rect = coordSys.getRect();
    return [
        rect[$26df41956a30cbbf$var$XY[dimIndex]],
        rect[$26df41956a30cbbf$var$XY[dimIndex]] + rect[$26df41956a30cbbf$var$WH[dimIndex]]
    ];
}
var $26df41956a30cbbf$export$2e2bcd8739ae039 = $26df41956a30cbbf$var$SingleAxisPointer;


var $2e3198006a202a14$var$SingleView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SingleView, _super);
    function SingleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleView.type;
        return _this;
    }
    SingleView.type = "single";
    return SingleView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $2e3198006a202a14$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("SingleAxisPointer", (0, $26df41956a30cbbf$export$2e2bcd8739ae039));
    registers.registerComponentView($2e3198006a202a14$var$SingleView);
    // Axis
    registers.registerComponentView((0, $e0635e836f59c3c6$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $0b0fbc117344336a$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "single", (0, $0b0fbc117344336a$export$2e2bcd8739ae039), (0, $0b0fbc117344336a$export$2e2bcd8739ae039).defaultOption);
    registers.registerCoordinateSystem("single", (0, $65313efe3e93ec7e$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $795d2d92b1d02c70$var$CalendarModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CalendarModel, _super);
    function CalendarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarModel.type;
        return _this;
    }
    /**
   * @override
   */ CalendarModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option);
        _super.prototype.init.apply(this, arguments);
        $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(option, inputPositionParams);
    };
    /**
   * @override
   */ CalendarModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(this.option, option);
    };
    CalendarModel.prototype.getCellSize = function() {
        // Has been normalized
        return this.option.cellSize;
    };
    CalendarModel.type = "calendar";
    CalendarModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        // horizontal vertical
        orient: "horizontal",
        // month separate line style
        splitLine: {
            show: true,
            lineStyle: {
                color: "#000",
                width: 1,
                type: "solid"
            }
        },
        // rect style  temporarily unused emphasis
        itemStyle: {
            color: "#fff",
            borderWidth: 1,
            borderColor: "#ccc"
        },
        // week text style
        dayLabel: {
            show: true,
            firstDay: 0,
            // start end
            position: "start",
            margin: "50%",
            color: "#000"
        },
        // month text style
        monthLabel: {
            show: true,
            // start end
            position: "start",
            margin: 5,
            // center or left
            align: "center",
            formatter: null,
            color: "#000"
        },
        // year text style
        yearLabel: {
            show: true,
            // top bottom left right
            position: null,
            margin: 30,
            formatter: null,
            color: "#ccc",
            fontFamily: "sans-serif",
            fontWeight: "bolder",
            fontSize: 20
        }
    };
    return CalendarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
function $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(target, raw) {
    // Normalize cellSize
    var cellSize = target.cellSize;
    var cellSizeArr;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(cellSize)) cellSizeArr = target.cellSize = [
        cellSize,
        cellSize
    ];
    else cellSizeArr = cellSize;
    if (cellSizeArr.length === 1) cellSizeArr[1] = cellSizeArr[0];
    var ignoreSize = $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        0,
        1
    ], function(hvIdx) {
        // If user have set `width` or both `left` and `right`, cellSizeArr
        // will be automatically set to 'auto', otherwise the default
        // setting of cellSizeArr will make `width` setting not work.
        if ((0, $93b9bc7f22ac7369$export$7ede609e8ebc9650)(raw, hvIdx)) cellSizeArr[hvIdx] = "auto";
        return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== "auto";
    });
    (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(target, raw, {
        type: "box",
        ignoreSize: ignoreSize
    });
}
var $795d2d92b1d02c70$export$2e2bcd8739ae039 = $795d2d92b1d02c70$var$CalendarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $e6b2dc17a91ad4af$var$CalendarView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(CalendarView, _super);
    function CalendarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarView.type;
        return _this;
    }
    CalendarView.prototype.render = function(calendarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        var coordSys = calendarModel.coordinateSystem;
        // range info
        var rangeData = coordSys.getRangeInfo();
        var orient = coordSys.getOrient();
        // locale
        var localeModel = ecModel.getLocaleModel();
        this._renderDayRect(calendarModel, rangeData, group);
        // _renderLines must be called prior to following function
        this._renderLines(calendarModel, rangeData, orient, group);
        this._renderYearText(calendarModel, rangeData, orient, group);
        this._renderMonthText(calendarModel, localeModel, orient, group);
        this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
    };
    // render day rect
    CalendarView.prototype._renderDayRect = function(calendarModel, rangeData, group) {
        var coordSys = calendarModel.coordinateSystem;
        var itemRectStyleModel = calendarModel.getModel("itemStyle").getItemStyle();
        var sw = coordSys.getCellWidth();
        var sh = coordSys.getCellHeight();
        for(var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time){
            var point = coordSys.dataToRect([
                i
            ], false).tl;
            // every rect
            var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: {
                    x: point[0],
                    y: point[1],
                    width: sw,
                    height: sh
                },
                cursor: "default",
                style: itemRectStyleModel
            });
            group.add(rect);
        }
    };
    // render separate line
    CalendarView.prototype._renderLines = function(calendarModel, rangeData, orient, group) {
        var self = this;
        var coordSys = calendarModel.coordinateSystem;
        var lineStyleModel = calendarModel.getModel([
            "splitLine",
            "lineStyle"
        ]).getLineStyle();
        var show = calendarModel.get([
            "splitLine",
            "show"
        ]);
        var lineWidth = lineStyleModel.lineWidth;
        this._tlpoints = [];
        this._blpoints = [];
        this._firstDayOfMonth = [];
        this._firstDayPoints = [];
        var firstDay = rangeData.start;
        for(var i = 0; firstDay.time <= rangeData.end.time; i++){
            addPoints(firstDay.formatedDate);
            if (i === 0) firstDay = coordSys.getDateInfo(rangeData.start.y + "-" + rangeData.start.m);
            var date = firstDay.date;
            date.setMonth(date.getMonth() + 1);
            firstDay = coordSys.getDateInfo(date);
        }
        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
        function addPoints(date) {
            self._firstDayOfMonth.push(coordSys.getDateInfo(date));
            self._firstDayPoints.push(coordSys.dataToRect([
                date
            ], false).tl);
            var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
            self._tlpoints.push(points[0]);
            self._blpoints.push(points[points.length - 1]);
            show && self._drawSplitline(points, lineStyleModel, group);
        }
        // render top/left line
        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group);
        // render bottom/right line
        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
    };
    // get points at both ends
    CalendarView.prototype._getEdgesPoints = function(points, lineWidth, orient) {
        var rs = [
            points[0].slice(),
            points[points.length - 1].slice()
        ];
        var idx = orient === "horizontal" ? 0 : 1;
        // both ends of the line are extend half lineWidth
        rs[0][idx] = rs[0][idx] - lineWidth / 2;
        rs[1][idx] = rs[1][idx] + lineWidth / 2;
        return rs;
    };
    // render split line
    CalendarView.prototype._drawSplitline = function(points, lineStyle, group) {
        var poyline = new $d28119f30e6bb670$export$2e2bcd8739ae039({
            z2: 20,
            shape: {
                points: points
            },
            style: lineStyle
        });
        group.add(poyline);
    };
    // render month line of one week points
    CalendarView.prototype._getLinePointsOfOneWeek = function(calendarModel, date, orient) {
        var coordSys = calendarModel.coordinateSystem;
        var parsedDate = coordSys.getDateInfo(date);
        var points = [];
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(parsedDate.time, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false);
            points[2 * tmpD.day] = point.tl;
            points[2 * tmpD.day + 1] = point[orient === "horizontal" ? "bl" : "tr"];
        }
        return points;
    };
    CalendarView.prototype._formatterLabel = function(formatter, params) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(formatter) && formatter) return (0, $c84c9521536c601a$export$2fa08233ee42f8e1)(formatter, params);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(formatter)) return formatter(params);
        return params.nameMap;
    };
    CalendarView.prototype._yearTextPositionControl = function(textEl, point, orient, position, margin) {
        var x = point[0];
        var y = point[1];
        var aligns = [
            "center",
            "bottom"
        ];
        if (position === "bottom") {
            y += margin;
            aligns = [
                "center",
                "top"
            ];
        } else if (position === "left") x -= margin;
        else if (position === "right") {
            x += margin;
            aligns = [
                "center",
                "top"
            ];
        } else // top
        y -= margin;
        var rotate = 0;
        if (position === "left" || position === "right") rotate = Math.PI / 2;
        return {
            rotation: rotate,
            x: x,
            y: y,
            style: {
                align: aligns[0],
                verticalAlign: aligns[1]
            }
        };
    };
    // render year
    CalendarView.prototype._renderYearText = function(calendarModel, rangeData, orient, group) {
        var yearLabel = calendarModel.getModel("yearLabel");
        if (!yearLabel.get("show")) return;
        var margin = yearLabel.get("margin");
        var pos = yearLabel.get("position");
        if (!pos) pos = orient !== "horizontal" ? "top" : "left";
        var points = [
            this._tlpoints[this._tlpoints.length - 1],
            this._blpoints[0]
        ];
        var xc = (points[0][0] + points[1][0]) / 2;
        var yc = (points[0][1] + points[1][1]) / 2;
        var idx = orient === "horizontal" ? 0 : 1;
        var posPoints = {
            top: [
                xc,
                points[idx][1]
            ],
            bottom: [
                xc,
                points[1 - idx][1]
            ],
            left: [
                points[1 - idx][0],
                yc
            ],
            right: [
                points[idx][0],
                yc
            ]
        };
        var name = rangeData.start.y;
        if (+rangeData.end.y > +rangeData.start.y) name = name + "-" + rangeData.end.y;
        var formatter = yearLabel.get("formatter");
        var params = {
            start: rangeData.start.y,
            end: rangeData.end.y,
            nameMap: name
        };
        var content = this._formatterLabel(formatter, params);
        var yearText = new $fe885cc21795562b$export$2e2bcd8739ae039({
            z2: 30,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(yearLabel, {
                text: content
            })
        });
        yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
        group.add(yearText);
    };
    CalendarView.prototype._monthTextPositionControl = function(point, isCenter, orient, position, margin) {
        var align = "left";
        var vAlign = "top";
        var x = point[0];
        var y = point[1];
        if (orient === "horizontal") {
            y = y + margin;
            if (isCenter) align = "center";
            if (position === "start") vAlign = "bottom";
        } else {
            x = x + margin;
            if (isCenter) vAlign = "middle";
            if (position === "start") align = "right";
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render month and year text
    CalendarView.prototype._renderMonthText = function(calendarModel, localeModel, orient, group) {
        var monthLabel = calendarModel.getModel("monthLabel");
        if (!monthLabel.get("show")) return;
        var nameMap = monthLabel.get("nameMap");
        var margin = monthLabel.get("margin");
        var pos = monthLabel.get("position");
        var align = monthLabel.get("align");
        var termPoints = [
            this._tlpoints,
            this._blpoints
        ];
        if (!nameMap || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(nameMap) || localeModel;
            // PENDING
            // for ZH locale, original form is `一月` but current form is `1月`
            nameMap = localeModel.get([
                "time",
                "monthAbbr"
            ]) || [];
        }
        var idx = pos === "start" ? 0 : 1;
        var axis = orient === "horizontal" ? 0 : 1;
        margin = pos === "start" ? -margin : margin;
        var isCenter = align === "center";
        for(var i = 0; i < termPoints[idx].length - 1; i++){
            var tmp = termPoints[idx][i].slice();
            var firstDay = this._firstDayOfMonth[i];
            if (isCenter) {
                var firstDayPoints = this._firstDayPoints[i];
                tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
            }
            var formatter = monthLabel.get("formatter");
            var name_1 = nameMap[+firstDay.m - 1];
            var params = {
                yyyy: firstDay.y,
                yy: (firstDay.y + "").slice(2),
                MM: firstDay.m,
                M: +firstDay.m,
                nameMap: name_1
            };
            var content = this._formatterLabel(formatter, params);
            var monthText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(monthLabel, {
                    text: content
                }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin))
            });
            group.add(monthText);
        }
    };
    CalendarView.prototype._weekTextPositionControl = function(point, orient, position, margin, cellSize) {
        var align = "center";
        var vAlign = "middle";
        var x = point[0];
        var y = point[1];
        var isStart = position === "start";
        if (orient === "horizontal") {
            x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
            align = isStart ? "right" : "left";
        } else {
            y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
            vAlign = isStart ? "bottom" : "top";
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render weeks
    CalendarView.prototype._renderWeekText = function(calendarModel, localeModel, rangeData, orient, group) {
        var dayLabel = calendarModel.getModel("dayLabel");
        if (!dayLabel.get("show")) return;
        var coordSys = calendarModel.coordinateSystem;
        var pos = dayLabel.get("position");
        var nameMap = dayLabel.get("nameMap");
        var margin = dayLabel.get("margin");
        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
        if (!nameMap || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(nameMap) || localeModel;
            // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file
            var dayOfWeekShort = localeModel.get([
                "time",
                "dayOfWeekShort"
            ]);
            nameMap = dayOfWeekShort || (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(localeModel.get([
                "time",
                "dayOfWeekAbbr"
            ]), function(val) {
                return val[0];
            });
        }
        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
        var cellSize = [
            coordSys.getCellWidth(),
            coordSys.getCellHeight()
        ];
        margin = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(margin, Math.min(cellSize[1], cellSize[0]));
        if (pos === "start") {
            start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
            margin = -margin;
        }
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(start, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false).center;
            var day = i;
            day = Math.abs((i + firstDayOfWeek) % 7);
            var weekText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(dayLabel, {
                    text: nameMap[day]
                }), this._weekTextPositionControl(point, orient, pos, margin, cellSize))
            });
            group.add(weekText);
        }
    };
    CalendarView.type = "calendar";
    return CalendarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $e6b2dc17a91ad4af$export$2e2bcd8739ae039 = $e6b2dc17a91ad4af$var$CalendarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// (24*60*60*1000)
var $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY = 86400000;
var $be2279b8e0028cb2$var$Calendar = /** @class */ function() {
    function Calendar(calendarModel, ecModel, api) {
        this.type = "calendar";
        this.dimensions = Calendar.dimensions;
        // Required in createListFromData
        this.getDimensionsInfo = Calendar.getDimensionsInfo;
        this._model = calendarModel;
    }
    Calendar.getDimensionsInfo = function() {
        return [
            {
                name: "time",
                type: "time"
            },
            "value"
        ];
    };
    Calendar.prototype.getRangeInfo = function() {
        return this._rangeInfo;
    };
    Calendar.prototype.getModel = function() {
        return this._model;
    };
    Calendar.prototype.getRect = function() {
        return this._rect;
    };
    Calendar.prototype.getCellWidth = function() {
        return this._sw;
    };
    Calendar.prototype.getCellHeight = function() {
        return this._sh;
    };
    Calendar.prototype.getOrient = function() {
        return this._orient;
    };
    /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */ Calendar.prototype.getFirstDayOfWeek = function() {
        return this._firstDayOfWeek;
    };
    /**
   * get date info
   * }
   */ Calendar.prototype.getDateInfo = function(date) {
        date = $cfc1f3b422a3185f$export$6b862160d295c8e(date);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var mStr = m < 10 ? "0" + m : "" + m;
        var d = date.getDate();
        var dStr = d < 10 ? "0" + d : "" + d;
        var day = date.getDay();
        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
        return {
            y: y + "",
            m: mStr,
            d: dStr,
            day: day,
            time: date.getTime(),
            formatedDate: y + "-" + mStr + "-" + dStr,
            date: date
        };
    };
    Calendar.prototype.getNextNDay = function(date, n) {
        n = n || 0;
        if (n === 0) return this.getDateInfo(date);
        date = new Date(this.getDateInfo(date).time);
        date.setDate(date.getDate() + n);
        return this.getDateInfo(date);
    };
    Calendar.prototype.update = function(ecModel, api) {
        this._firstDayOfWeek = +this._model.getModel("dayLabel").get("firstDay");
        this._orient = this._model.get("orient");
        this._lineWidth = this._model.getModel("itemStyle").getItemStyle().lineWidth || 0;
        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
        var weeks = this._rangeInfo.weeks || 1;
        var whNames = [
            "width",
            "height"
        ];
        var cellSize = this._model.getCellSize().slice();
        var layoutParams = this._model.getBoxLayoutParams();
        var cellNumbers = this._orient === "horizontal" ? [
            weeks,
            7
        ] : [
            7,
            weeks
        ];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (cellSizeSpecified(cellSize, idx)) layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
        });
        var whGlobal = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var calendarRect = this._rect = $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutParams, whGlobal);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (!cellSizeSpecified(cellSize, idx)) cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
        });
        function cellSizeSpecified(cellSize, idx) {
            return cellSize[idx] != null && cellSize[idx] !== "auto";
        }
        // Has been calculated out number.
        this._sw = cellSize[0];
        this._sh = cellSize[1];
    };
    /**
   * Convert a time data(time, value) item to (x, y) point.
   */ // TODO Clamp of calendar is not same with cartesian coordinate systems.
    // It will return NaN if data exceeds.
    Calendar.prototype.dataToPoint = function(data, clamp) {
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(data) && (data = data[0]);
        clamp == null && (clamp = true);
        var dayInfo = this.getDateInfo(data);
        var range = this._rangeInfo;
        var date = dayInfo.formatedDate;
        // if not in range return [NaN, NaN]
        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY)) return [
            NaN,
            NaN
        ];
        var week = dayInfo.day;
        var nthWeek = this._getRangeInfo([
            range.start.time,
            date
        ]).nthWeek;
        if (this._orient === "vertical") return [
            this._rect.x + week * this._sw + this._sw / 2,
            this._rect.y + nthWeek * this._sh + this._sh / 2
        ];
        return [
            this._rect.x + nthWeek * this._sw + this._sw / 2,
            this._rect.y + week * this._sh + this._sh / 2
        ];
    };
    /**
   * Convert a (x, y) point to time data
   */ Calendar.prototype.pointToData = function(point) {
        var date = this.pointToDate(point);
        return date && date.time;
    };
    /**
   * Convert a time date item to (x, y) four point.
   */ Calendar.prototype.dataToRect = function(data, clamp) {
        var point = this.dataToPoint(data, clamp);
        return {
            contentShape: {
                x: point[0] - (this._sw - this._lineWidth) / 2,
                y: point[1] - (this._sh - this._lineWidth) / 2,
                width: this._sw - this._lineWidth,
                height: this._sh - this._lineWidth
            },
            center: point,
            tl: [
                point[0] - this._sw / 2,
                point[1] - this._sh / 2
            ],
            tr: [
                point[0] + this._sw / 2,
                point[1] - this._sh / 2
            ],
            br: [
                point[0] + this._sw / 2,
                point[1] + this._sh / 2
            ],
            bl: [
                point[0] - this._sw / 2,
                point[1] + this._sh / 2
            ]
        };
    };
    /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */ Calendar.prototype.pointToDate = function(point) {
        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
        var range = this._rangeInfo.range;
        if (this._orient === "vertical") return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
    };
    Calendar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Calendar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    Calendar.prototype.containPoint = function(point) {
        console.warn("Not implemented.");
        return false;
    };
    /**
   * initRange
   * Normalize to an [start, end] array
   */ Calendar.prototype._initRangeOption = function() {
        var range = this._model.get("range");
        var normalizedRange;
        // Convert [1990] to 1990
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(range) && range.length === 1) range = range[0];
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(range)) {
            var rangeStr = range.toString();
            // One year.
            if (/^\d{4}$/.test(rangeStr)) normalizedRange = [
                rangeStr + "-01-01",
                rangeStr + "-12-31"
            ];
            // One month
            if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
                var start = this.getDateInfo(rangeStr);
                var firstDay = start.date;
                firstDay.setMonth(firstDay.getMonth() + 1);
                var end = this.getNextNDay(firstDay, -1);
                normalizedRange = [
                    start.formatedDate,
                    end.formatedDate
                ];
            }
            // One day
            if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) normalizedRange = [
                rangeStr,
                rangeStr
            ];
        } else normalizedRange = range;
        if (!normalizedRange) // Not handling it.
        return range;
        var tmp = this._getRangeInfo(normalizedRange);
        if (tmp.start.time > tmp.end.time) normalizedRange.reverse();
        return normalizedRange;
    };
    /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */ Calendar.prototype._getRangeInfo = function(range) {
        var parsedRange = [
            this.getDateInfo(range[0]),
            this.getDateInfo(range[1])
        ];
        var reversed;
        if (parsedRange[0].time > parsedRange[1].time) {
            reversed = true;
            parsedRange.reverse();
        }
        var allDay = Math.floor(parsedRange[1].time / $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY) + 1;
        // Consider case1 (#11677 #10430):
        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
        // Consider case2:
        // Firstly set system timezone as "Time Zone: America/Toronto",
        // ```
        // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
        // let second = new Date(1478412000000);
        // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
        // ```
        // will get wrong result because of DST. So we should fix it.
        var date = new Date(parsedRange[0].time);
        var startDateNum = date.getDate();
        var endDateNum = parsedRange[1].date.getDate();
        date.setDate(startDateNum + allDay - 1);
        // The bias can not over a month, so just compare date.
        var dateNum = date.getDate();
        if (dateNum !== endDateNum) {
            var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;
            while((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0){
                allDay -= sign;
                date.setDate(dateNum - sign);
            }
        }
        var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
        reversed && parsedRange.reverse();
        return {
            range: [
                parsedRange[0].formatedDate,
                parsedRange[1].formatedDate
            ],
            start: parsedRange[0],
            end: parsedRange[1],
            allDay: allDay,
            weeks: weeks,
            // From 0.
            nthWeek: nthWeek,
            fweek: parsedRange[0].day,
            lweek: parsedRange[1].day
        };
    };
    /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */ Calendar.prototype._getDateByWeeksAndDay = function(nthWeek, day, range) {
        var rangeInfo = this._getRangeInfo(range);
        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) return null;
        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
        var date = new Date(rangeInfo.start.time);
        date.setDate(+rangeInfo.start.d + nthDay);
        return this.getDateInfo(date);
    };
    Calendar.create = function(ecModel, api) {
        var calendarList = [];
        ecModel.eachComponent("calendar", function(calendarModel) {
            var calendar = new Calendar(calendarModel, ecModel, api);
            calendarList.push(calendar);
            calendarModel.coordinateSystem = calendar;
        });
        ecModel.eachSeries(function(calendarSeries) {
            if (calendarSeries.get("coordinateSystem") === "calendar") // Inject coordinate system
            calendarSeries.coordinateSystem = calendarList[calendarSeries.get("calendarIndex") || 0];
        });
        return calendarList;
    };
    Calendar.dimensions = [
        "time",
        "value"
    ];
    return Calendar;
}();
function $be2279b8e0028cb2$var$getCoordSys(finder) {
    var calendarModel = finder.calendarModel;
    var seriesModel = finder.seriesModel;
    var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $be2279b8e0028cb2$export$2e2bcd8739ae039 = $be2279b8e0028cb2$var$Calendar;


function $c1c3b68ff9dcc3e7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $795d2d92b1d02c70$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e6b2dc17a91ad4af$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("calendar", (0, $be2279b8e0028cb2$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $21e1121941dbd8a9$export$f6339b3d96c5d3d7(resultItem, newElOption) {
    var existElOption = resultItem.existing;
    // Set id and type after id assigned.
    newElOption.id = resultItem.keyInfo.id;
    !newElOption.type && existElOption && (newElOption.type = existElOption.type);
    // Set parent id if not specified
    if (newElOption.parentId == null) {
        var newElParentOption = newElOption.parentOption;
        if (newElParentOption) newElOption.parentId = newElParentOption.id;
        else if (existElOption) newElOption.parentId = existElOption.parentId;
    }
    // Clear
    newElOption.parentOption = null;
}
function $21e1121941dbd8a9$var$isSetLoc(obj, props) {
    var isSet;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(props, function(prop) {
        obj[prop] != null && obj[prop] !== "auto" && (isSet = true);
    });
    return isSet;
}
function $21e1121941dbd8a9$var$mergeNewElOptionToExist(existList, index, newElOption) {
    // Update existing options, for `getOption` feature.
    var newElOptCopy = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, newElOption);
    var existElOption = existList[index];
    var $action = newElOption.$action || "merge";
    if ($action === "merge") {
        if (existElOption) {
            var newType;
            // We can ensure that newElOptCopy and existElOption are not
            // the same object, so `merge` will not change newElOptCopy.
            $7a1bd9c2710fea0d$export$4950aa0f605343fb(existElOption, newElOptCopy, true);
            // Rigid body, use ignoreSize.
            (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(existElOption, newElOptCopy, {
                ignoreSize: true
            });
            // Will be used in render.
            (0, $93b9bc7f22ac7369$export$7438999faea9b6cc)(newElOption, existElOption);
            // Copy transition info to new option so it can be used in the transition.
            // DO IT AFTER merge
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption);
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "shape");
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "style");
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "extra");
            // Copy clipPath
            newElOption.clipPath = existElOption.clipPath;
        } else existList[index] = newElOptCopy;
    } else if ($action === "replace") existList[index] = newElOptCopy;
    else if ($action === "remove") // null will be cleaned later.
    existElOption && (existList[index] = null);
}
var $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY = [
    "transition",
    "enterFrom",
    "leaveTo"
];
var $21e1121941dbd8a9$var$ROOT_TRANSITION_PROPS_TO_COPY = $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY.concat([
    "enterAnimation",
    "updateAnimation",
    "leaveAnimation"
]);
function $21e1121941dbd8a9$var$copyTransitionInfo(target, source, targetProp) {
    if (targetProp) {
        if (!target[targetProp] && source[targetProp]) // TODO avoid creating this empty object when there is no transition configuration.
        target[targetProp] = {};
        target = target[targetProp];
        source = source[targetProp];
    }
    if (!target || !source) return;
    var props = targetProp ? $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY : $21e1121941dbd8a9$var$ROOT_TRANSITION_PROPS_TO_COPY;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (target[prop] == null && source[prop] != null) target[prop] = source[prop];
    }
}
function $21e1121941dbd8a9$var$setLayoutInfoToExist(existItem, newElOption) {
    if (!existItem) return;
    existItem.hv = newElOption.hv = [
        // Rigid body, don't care about `width`.
        $21e1121941dbd8a9$var$isSetLoc(newElOption, [
            "left",
            "right"
        ]),
        // Rigid body, don't care about `height`.
        $21e1121941dbd8a9$var$isSetLoc(newElOption, [
            "top",
            "bottom"
        ])
    ];
    // Give default group size. Otherwise layout error may occur.
    if (existItem.type === "group") {
        var existingGroupOpt = existItem;
        var newGroupOpt = newElOption;
        existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
        existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
    }
}
var $21e1121941dbd8a9$export$6d85925da4d2cf23 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GraphicComponentModel, _super);
    function GraphicComponentModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentModel.type;
        _this.preventAutoZ = true;
        return _this;
    }
    GraphicComponentModel.prototype.mergeOption = function(option, ecModel) {
        // Prevent default merge to elements
        var elements = this.option.elements;
        this.option.elements = null;
        _super.prototype.mergeOption.call(this, option, ecModel);
        this.option.elements = elements;
    };
    GraphicComponentModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        var newList = (isInit ? thisOption : newOption).elements;
        var existList = thisOption.elements = isInit ? [] : thisOption.elements;
        var flattenedList = [];
        this._flatten(newList, flattenedList, null);
        var mappingResult = $76d619f648247e6d$export$574f818966e4da87(existList, flattenedList, "normalMerge");
        // Clear elOptionsToUpdate
        var elOptionsToUpdate = this._elOptionsToUpdate = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mappingResult, function(resultItem, index) {
            var newElOption = resultItem.newOption;
            if (!newElOption) return;
            elOptionsToUpdate.push(newElOption);
            $21e1121941dbd8a9$export$f6339b3d96c5d3d7(resultItem, newElOption);
            $21e1121941dbd8a9$var$mergeNewElOptionToExist(existList, index, newElOption);
            $21e1121941dbd8a9$var$setLayoutInfoToExist(existList[index], newElOption);
        }, this);
        // Clean
        thisOption.elements = $7a1bd9c2710fea0d$export$3dea766d36a8935f(existList, function(item) {
            // $action should be volatile, otherwise option gotten from
            // `getOption` will contain unexpected $action.
            item && delete item.$action;
            return item != null;
        });
    };
    /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   */ GraphicComponentModel.prototype._flatten = function(optionList, result, parentOption) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(optionList, function(option) {
            if (!option) return;
            if (parentOption) option.parentOption = parentOption;
            result.push(option);
            var children = option.children;
            // here we don't judge if option.type is `group`
            // when new option doesn't provide `type`, it will cause that the children can't be updated.
            if (children && children.length) this._flatten(children, result, option);
            // Deleting for JSON output, and for not affecting group creation.
            delete option.children;
        }, this);
    };
    // FIXME
    // Pass to view using payload? setOption has a payload?
    GraphicComponentModel.prototype.useElOptionsToUpdate = function() {
        var els = this._elOptionsToUpdate;
        // Clear to avoid render duplicately when zooming.
        this._elOptionsToUpdate = null;
        return els;
    };
    GraphicComponentModel.type = "graphic";
    GraphicComponentModel.defaultOption = {
        elements: []
    };
    return GraphicComponentModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $2b680c3ccdb25c77$var$nonShapeGraphicElements = {
    // Reserved but not supported in graphic component.
    path: null,
    compoundPath: null,
    // Supported in graphic component.
    group: $7ef7583d8302ffce$export$2e2bcd8739ae039,
    image: $86adec94217b86c6$export$2e2bcd8739ae039,
    text: $fe885cc21795562b$export$2e2bcd8739ae039
};
var $2b680c3ccdb25c77$export$4ae363f1d88fb658 = $76d619f648247e6d$export$64df9f8d92ae083f();
// ------------------------
// View
// ------------------------
var $2b680c3ccdb25c77$export$1132c9ab9ad80748 = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(GraphicComponentView, _super);
    function GraphicComponentView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentView.type;
        return _this;
    }
    GraphicComponentView.prototype.init = function() {
        this._elMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.render = function(graphicModel, ecModel, api) {
        // Having leveraged between use cases and algorithm complexity, a very
        // simple layout mechanism is used:
        // The size(width/height) can be determined by itself or its parent (not
        // implemented yet), but can not by its children. (Top-down travel)
        // The location(x/y) can be determined by the bounding rect of itself
        // (can including its descendants or not) and the size of its parent.
        // (Bottom-up travel)
        // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
        // view will be reused.
        if (graphicModel !== this._lastGraphicModel) this._clear();
        this._lastGraphicModel = graphicModel;
        this._updateElements(graphicModel);
        this._relocate(graphicModel, api);
    };
    /**
   * Update graphic elements.
   */ GraphicComponentView.prototype._updateElements = function(graphicModel) {
        var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
        if (!elOptionsToUpdate) return;
        var elMap = this._elMap;
        var rootGroup = this.group;
        var globalZ = graphicModel.get("z");
        var globalZLevel = graphicModel.get("zlevel");
        // Top-down tranverse to assign graphic settings to each elements.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(elOptionsToUpdate, function(elOption) {
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var elExisting = id != null ? elMap.get(id) : null;
            var parentId = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.parentId, null);
            var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
            var elType = elOption.type;
            var elOptionStyle = elOption.style;
            if (elType === "text" && elOptionStyle) // In top/bottom mode, textVerticalAlign should not be used, which cause
            // inaccurately locating.
            {
                if (elOption.hv && elOption.hv[1]) elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
            }
            var textContentOption = elOption.textContent;
            var textConfig = elOption.textConfig;
            if (elOptionStyle && (0, $daa53642c3afcc30$export$3b868abde5eae7d1)(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
                var convertResult = (0, $daa53642c3afcc30$export$7748133eaaa8aecc)(elOptionStyle, elType, true);
                if (!textConfig && convertResult.textConfig) textConfig = elOption.textConfig = convertResult.textConfig;
                if (!textContentOption && convertResult.textContent) textContentOption = convertResult.textContent;
            }
            // Remove unnecessary props to avoid potential problems.
            var elOptionCleaned = $2b680c3ccdb25c77$var$getCleanedElOption(elOption);
            var $action = elOption.$action || "merge";
            var isMerge = $action === "merge";
            var isReplace = $action === "replace";
            if (isMerge) {
                var isInit = !elExisting;
                var el_1 = elExisting;
                if (isInit) el_1 = $2b680c3ccdb25c77$var$createEl(id, targetElParent, elOption.type, elMap);
                else {
                    el_1 && ($2b680c3ccdb25c77$export$4ae363f1d88fb658(el_1).isNew = false);
                    // Stop and restore before update any other attributes.
                    (0, $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4)(el_1);
                }
                if (el_1) {
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el_1, elOptionCleaned, graphicModel, {
                        isInit: isInit
                    });
                    $2b680c3ccdb25c77$var$updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
                }
            } else if (isReplace) {
                $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel);
                var el_2 = $2b680c3ccdb25c77$var$createEl(id, targetElParent, elOption.type, elMap);
                if (el_2) {
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el_2, elOptionCleaned, graphicModel, {
                        isInit: true
                    });
                    $2b680c3ccdb25c77$var$updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
                }
            } else if ($action === "remove") {
                (0, $7c104376a000308e$export$a6f11bb1cb100e2a)(elExisting, elOption);
                $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel);
            }
            var el = elMap.get(id);
            if (el && textContentOption) {
                if (isMerge) {
                    var textContentExisting = el.getTextContent();
                    textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new $fe885cc21795562b$export$2e2bcd8739ae039(textContentOption));
                } else if (isReplace) el.setTextContent(new $fe885cc21795562b$export$2e2bcd8739ae039(textContentOption));
            }
            if (el) {
                var clipPathOption = elOption.clipPath;
                if (clipPathOption) {
                    var clipPathType = clipPathOption.type;
                    var clipPath = void 0;
                    var isInit = false;
                    if (isMerge) {
                        var oldClipPath = el.getClipPath();
                        isInit = !oldClipPath || $2b680c3ccdb25c77$export$4ae363f1d88fb658(oldClipPath).type !== clipPathType;
                        clipPath = isInit ? $2b680c3ccdb25c77$var$newEl(clipPathType) : oldClipPath;
                    } else if (isReplace) {
                        isInit = true;
                        clipPath = $2b680c3ccdb25c77$var$newEl(clipPathType);
                    }
                    el.setClipPath(clipPath);
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(clipPath, clipPathOption, graphicModel, {
                        isInit: isInit
                    });
                    (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(clipPath, clipPathOption.keyframeAnimation, graphicModel);
                }
                var elInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(el);
                el.setTextConfig(textConfig);
                elInner.option = elOption;
                $2b680c3ccdb25c77$var$setEventData(el, graphicModel, elOption);
                $5b455ae6f843ac47$export$fc6410d97fab306c({
                    el: el,
                    componentModel: graphicModel,
                    itemName: el.name,
                    itemTooltipOption: elOption.tooltip
                });
                (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, graphicModel);
            }
        });
    };
    /**
   * Locate graphic elements.
   */ GraphicComponentView.prototype._relocate = function(graphicModel, api) {
        var elOptions = graphicModel.option.elements;
        var rootGroup = this.group;
        var elMap = this._elMap;
        var apiWidth = api.getWidth();
        var apiHeight = api.getHeight();
        var xy = [
            "x",
            "y"
        ];
        // Top-down to calculate percentage width/height of group
        for(var i = 0; i < elOptions.length; i++){
            var elOption = elOptions[i];
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el || !el.isGroup) continue;
            var parentEl = el.parent;
            var isParentRoot = parentEl === rootGroup;
            // Like 'position:absolut' in css, default 0.
            var elInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(el);
            var parentElInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(parentEl);
            elInner.width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
            elInner.height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
        }
        // Bottom-up tranvese all elements (consider ec resize) to locate elements.
        for(var i = elOptions.length - 1; i >= 0; i--){
            var elOption = elOptions[i];
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el) continue;
            var parentEl = el.parent;
            var parentElInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(parentEl);
            var containerInfo = parentEl === rootGroup ? {
                width: apiWidth,
                height: apiHeight
            } : {
                width: parentElInner.width,
                height: parentElInner.height
            };
            // PENDING
            // Currently, when `bounding: 'all'`, the union bounding rect of the group
            // does not include the rect of [0, 0, group.width, group.height], which
            // is probably weird for users. Should we make a break change for it?
            var layoutPos = {};
            var layouted = $93b9bc7f22ac7369$export$74054bd96b5eeef1(el, elOption, containerInfo, null, {
                hv: elOption.hv,
                boundingMode: elOption.bounding
            }, layoutPos);
            if (!$2b680c3ccdb25c77$export$4ae363f1d88fb658(el).isNew && layouted) {
                var transition = elOption.transition;
                var animatePos = {};
                for(var k = 0; k < xy.length; k++){
                    var key = xy[k];
                    var val = layoutPos[key];
                    if (transition && ((0, $7c104376a000308e$export$6f3361b4b8d7a8ba)(transition) || $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(transition, key) >= 0)) animatePos[key] = val;
                    else el[key] = val;
                }
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, animatePos, graphicModel, 0);
            } else el.attr(layoutPos);
        }
    };
    /**
   * Clear all elements.
   */ GraphicComponentView.prototype._clear = function() {
        var _this = this;
        var elMap = this._elMap;
        elMap.each(function(el) {
            $2b680c3ccdb25c77$var$removeEl(el, $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).option, elMap, _this._lastGraphicModel);
        });
        this._elMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.dispose = function() {
        this._clear();
    };
    GraphicComponentView.type = "graphic";
    return GraphicComponentView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $2b680c3ccdb25c77$var$newEl(graphicType) {
    var Clz = $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3($2b680c3ccdb25c77$var$nonShapeGraphicElements, graphicType) ? $2b680c3ccdb25c77$var$nonShapeGraphicElements[graphicType] : $5b455ae6f843ac47$export$51df4b5565a58189(graphicType);
    var el = new Clz({});
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).type = graphicType;
    return el;
}
function $2b680c3ccdb25c77$var$createEl(id, targetElParent, graphicType, elMap) {
    var el = $2b680c3ccdb25c77$var$newEl(graphicType);
    targetElParent.add(el);
    elMap.set(id, el);
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).id = id;
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).isNew = true;
    return el;
}
function $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel) {
    var existElParent = elExisting && elExisting.parent;
    if (existElParent) {
        elExisting.type === "group" && elExisting.traverse(function(el) {
            $2b680c3ccdb25c77$var$removeEl(el, elOption, elMap, graphicModel);
        });
        (0, $7c104376a000308e$export$15575b6d82d35bb3)(elExisting, elOption, graphicModel);
        elMap.removeKey($2b680c3ccdb25c77$export$4ae363f1d88fb658(elExisting).id);
    }
}
function $2b680c3ccdb25c77$var$updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
    if (!el.isGroup) $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        [
            "cursor",
            (0, $56206a6cb4666931$export$2e2bcd8739ae039).prototype.cursor
        ],
        // We should not support configure z and zlevel in the element level.
        // But seems we didn't limit it previously. So here still use it to avoid breaking.
        [
            "zlevel",
            defaultZlevel || 0
        ],
        [
            "z",
            defaultZ || 0
        ],
        // z2 must not be null/undefined, otherwise sort error may occur.
        [
            "z2",
            0
        ]
    ], function(item) {
        var prop = item[0];
        if ($7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(elOption, prop)) el[prop] = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(elOption[prop], item[1]);
        else if (el[prop] == null) el[prop] = item[1];
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($7a1bd9c2710fea0d$export$ed97f33186d4b816(elOption), function(key) {
        // Assign event handlers.
        // PENDING: should enumerate all event names or use pattern matching?
        if (key.indexOf("on") === 0) {
            var val = elOption[key];
            el[key] = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(val) ? val : null;
        }
    });
    if ($7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(elOption, "draggable")) el.draggable = elOption.draggable;
    // Other attributes
    elOption.name != null && (el.name = elOption.name);
    elOption.id != null && (el.id = elOption.id);
}
// Remove unnecessary props to avoid potential problems.
function $2b680c3ccdb25c77$var$getCleanedElOption(elOption) {
    elOption = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, elOption);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        "id",
        "parentId",
        "$action",
        "hv",
        "bounding",
        "textContent",
        "clipPath"
    ].concat($93b9bc7f22ac7369$export$a9aa2cc018afbed), function(name) {
        delete elOption[name];
    });
    return elOption;
}
function $2b680c3ccdb25c77$var$setEventData(el, graphicModel, elOption) {
    var eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData;
    // Simple optimize for large amount of elements that no need event.
    if (!el.silent && !el.ignore && !eventData) eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: "graphic",
        componentIndex: graphicModel.componentIndex,
        name: el.name
    };
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    if (eventData) eventData.info = elOption.info;
}


function $48174658d54922b7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $21e1121941dbd8a9$export$6d85925da4d2cf23));
    registers.registerComponentView((0, $2b680c3ccdb25c77$export$1132c9ab9ad80748));
    registers.registerPreprocessor(function(option) {
        var graphicOption = option.graphic;
        // Convert
        // {graphic: [{left: 10, type: 'circle'}, ...]}
        // or
        // {graphic: {left: 10, type: 'circle'}}
        // to
        // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(graphicOption)) {
            if (!graphicOption[0] || !graphicOption[0].elements) option.graphic = [
                {
                    elements: graphicOption
                }
            ];
            else // Only one graphic instance can be instantiated. (We don't
            // want that too many views are created in echarts._viewMap.)
            option.graphic = [
                option.graphic[0]
            ];
        } else if (graphicOption && !graphicOption.elements) option.graphic = [
            {
                elements: [
                    graphicOption
                ]
            }
        ];
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $554cb472ba0e05d3$export$f25521e726513e83 = [
    "x",
    "y",
    "radius",
    "angle",
    "single"
];
// Supported coords.
// FIXME: polar has been broken (but rarely used).
var $554cb472ba0e05d3$var$SERIES_COORDS = [
    "cartesian2d",
    "polar",
    "singleAxis"
];
function $554cb472ba0e05d3$export$2d449d4adc0d2cfc(seriesModel) {
    var coordType = seriesModel.get("coordinateSystem");
    return (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($554cb472ba0e05d3$var$SERIES_COORDS, coordType) >= 0;
}
function $554cb472ba0e05d3$export$90855f7219399082(axisDim) {
    return axisDim + "Axis";
}
function $554cb472ba0e05d3$export$f9c16e110bf1e902(axisDim) {
    return axisDim + "AxisIndex";
}
function $554cb472ba0e05d3$export$fa8714b2310ddff9(axisDim) {
    return axisDim + "AxisId";
}
function $554cb472ba0e05d3$export$9e00b6c2b8b2e9a7(ecModel, payload) {
    // Key: `DataZoomAxisDimension`
    var axisRecords = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var effectedModels = [];
    // Key: uid of dataZoomModel
    var effectedModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Find the dataZooms specified by payload.
    ecModel.eachComponent({
        mainType: "dataZoom",
        query: payload
    }, function(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid)) addToEffected(dataZoomModel);
    });
    // Start from the given dataZoomModels, travel the graph to find
    // all of the linked dataZoom models.
    var foundNewLink;
    do {
        foundNewLink = false;
        ecModel.eachComponent("dataZoom", processSingle);
    }while (foundNewLink);
    function processSingle(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
            addToEffected(dataZoomModel);
            foundNewLink = true;
        }
    }
    function addToEffected(dataZoom) {
        effectedModelMap.set(dataZoom.uid, true);
        effectedModels.push(dataZoom);
        markAxisControlled(dataZoom);
    }
    function isLinked(dataZoomModel) {
        var isLink = false;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var axisIdxArr = axisRecords.get(axisDim);
            if (axisIdxArr && axisIdxArr[axisIndex]) isLink = true;
        });
        return isLink;
    }
    function markAxisControlled(dataZoomModel) {
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
        });
    }
    return effectedModels;
}
function $554cb472ba0e05d3$export$b41173dee9da195b(dataZoomModel) {
    var ecModel = dataZoomModel.ecModel;
    var coordSysInfoWrap = {
        infoList: [],
        infoMap: (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)()
    };
    dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
        var axisModel = ecModel.getComponent($554cb472ba0e05d3$export$90855f7219399082(axisDim), axisIndex);
        if (!axisModel) return;
        var coordSysModel = axisModel.getCoordSysModel();
        if (!coordSysModel) return;
        var coordSysUid = coordSysModel.uid;
        var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);
        if (!coordSysInfo) {
            coordSysInfo = {
                model: coordSysModel,
                axisModels: []
            };
            coordSysInfoWrap.infoList.push(coordSysInfo);
            coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
        }
        coordSysInfo.axisModels.push(axisModel);
    });
    return coordSysInfoWrap;
}



var $41d57478d16bff21$var$DataZoomAxisInfo = /** @class */ function() {
    function DataZoomAxisInfo() {
        this.indexList = [];
        this.indexMap = [];
    }
    DataZoomAxisInfo.prototype.add = function(axisCmptIdx) {
        // Remove duplication.
        if (!this.indexMap[axisCmptIdx]) {
            this.indexList.push(axisCmptIdx);
            this.indexMap[axisCmptIdx] = true;
        }
    };
    return DataZoomAxisInfo;
}();
var $41d57478d16bff21$var$DataZoomModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DataZoomModel, _super);
    function DataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomModel.type;
        _this._autoThrottle = true;
        _this._noTarget = true;
        /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     */ _this._rangePropMode = [
            "percent",
            "percent"
        ];
        return _this;
    }
    DataZoomModel.prototype.init = function(option, parentModel, ecModel) {
        var inputRawOption = $41d57478d16bff21$var$retrieveRawOption(option);
        /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     */ this.settledOption = inputRawOption;
        this.mergeDefaultAndTheme(option, ecModel);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype.mergeOption = function(newOption) {
        var inputRawOption = $41d57478d16bff21$var$retrieveRawOption(newOption);
        // FIX #2591
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.option, newOption, true);
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.settledOption, inputRawOption, true);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype._doInit = function(inputRawOption) {
        var thisOption = this.option;
        this._setDefaultThrottle(inputRawOption);
        this._updateRangeUse(inputRawOption);
        var settledOption = this.settledOption;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names, index) {
            // start/end has higher priority over startValue/endValue if they
            // both set, but we should make chart.setOption({endValue: 1000})
            // effective, rather than chart.setOption({endValue: 1000, end: null}).
            if (this._rangePropMode[index] === "value") thisOption[names[0]] = settledOption[names[0]] = null;
        // Otherwise do nothing and use the merge result.
        }, this);
        this._resetTarget();
    };
    DataZoomModel.prototype._resetTarget = function() {
        var optionOrient = this.get("orient", true);
        var targetAxisIndexMap = this._targetAxisInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);
        if (hasAxisSpecified) this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
        else {
            this._orient = optionOrient || "horizontal";
            this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
        }
        this._noTarget = true;
        targetAxisIndexMap.each(function(axisInfo) {
            if (axisInfo.indexList.length) this._noTarget = false;
        }, this);
    };
    DataZoomModel.prototype._fillSpecifiedTargetAxis = function(targetAxisIndexMap) {
        var hasAxisSpecified = false;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $554cb472ba0e05d3$export$f25521e726513e83), function(axisDim) {
            var refering = this.getReferringComponents((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), (0, $76d619f648247e6d$export$48d598924ce4892c));
            // When user set axisIndex as a empty array, we think that user specify axisIndex
            // but do not want use auto mode. Because empty array may be encountered when
            // some error occurred.
            if (!refering.specified) return;
            hasAxisSpecified = true;
            var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(refering.models, function(axisModel) {
                axisInfo.add(axisModel.componentIndex);
            });
            targetAxisIndexMap.set(axisDim, axisInfo);
        }, this);
        return hasAxisSpecified;
    };
    DataZoomModel.prototype._fillAutoTargetAxisByOrient = function(targetAxisIndexMap, orient) {
        var ecModel = this.ecModel;
        var needAuto = true;
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisDim = orient === "vertical" ? "y" : "x";
            var axisModels = ecModel.findComponents({
                mainType: axisDim + "Axis"
            });
            setParallelAxis(axisModels, axisDim);
        }
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisModels = ecModel.findComponents({
                mainType: "singleAxis",
                filter: function(axisModel) {
                    return axisModel.get("orient", true) === orient;
                }
            });
            setParallelAxis(axisModels, "single");
        }
        function setParallelAxis(axisModels, axisDim) {
            // At least use the first parallel axis as the target axis.
            var axisModel = axisModels[0];
            if (!axisModel) return;
            var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
            axisInfo.add(axisModel.componentIndex);
            targetAxisIndexMap.set(axisDim, axisInfo);
            needAuto = false;
            // Find parallel axes in the same grid.
            if (axisDim === "x" || axisDim === "y") {
                var gridModel_1 = axisModel.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                gridModel_1 && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisModels, function(axModel) {
                    if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0]) axisInfo.add(axModel.componentIndex);
                });
            }
        }
        if (needAuto) // If no parallel axis, find the first category axis as default. (Also consider polar).
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $554cb472ba0e05d3$export$f25521e726513e83), function(axisDim) {
            if (!needAuto) return;
            var axisModels = ecModel.findComponents({
                mainType: (0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim),
                filter: function(axisModel) {
                    return axisModel.get("type", true) === "category";
                }
            });
            if (axisModels[0]) {
                var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
                axisInfo.add(axisModels[0].componentIndex);
                targetAxisIndexMap.set(axisDim, axisInfo);
                needAuto = false;
            }
        }, this);
    };
    DataZoomModel.prototype._makeAutoOrientByTargetAxis = function() {
        var dim;
        // Find the first axis
        this.eachTargetAxis(function(axisDim) {
            !dim && (dim = axisDim);
        }, this);
        return dim === "y" ? "vertical" : "horizontal";
    };
    DataZoomModel.prototype._setDefaultThrottle = function(inputRawOption) {
        // When first time user set throttle, auto throttle ends.
        if (inputRawOption.hasOwnProperty("throttle")) this._autoThrottle = false;
        if (this._autoThrottle) {
            var globalOption = this.ecModel.option;
            this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
        }
    };
    DataZoomModel.prototype._updateRangeUse = function(inputRawOption) {
        var rangePropMode = this._rangePropMode;
        var rangeModeInOption = this.get("rangeMode");
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names, index) {
            var percentSpecified = inputRawOption[names[0]] != null;
            var valueSpecified = inputRawOption[names[1]] != null;
            if (percentSpecified && !valueSpecified) rangePropMode[index] = "percent";
            else if (!percentSpecified && valueSpecified) rangePropMode[index] = "value";
            else if (rangeModeInOption) rangePropMode[index] = rangeModeInOption[index];
            else if (percentSpecified) // percentSpecified && valueSpecified
            rangePropMode[index] = "percent";
        // else remain its original setting.
        });
    };
    DataZoomModel.prototype.noTarget = function() {
        return this._noTarget;
    };
    DataZoomModel.prototype.getFirstTargetAxisModel = function() {
        var firstAxisModel;
        this.eachTargetAxis(function(axisDim, axisIndex) {
            if (firstAxisModel == null) firstAxisModel = this.ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
        }, this);
        return firstAxisModel;
    };
    /**
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */ DataZoomModel.prototype.eachTargetAxis = function(callback, context) {
        this._targetAxisInfoMap.each(function(axisInfo, axisDim) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisInfo.indexList, function(axisIndex) {
                callback.call(context, axisDim, axisIndex);
            });
        });
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisProxy = function(axisDim, axisIndex) {
        var axisModel = this.getAxisModel(axisDim, axisIndex);
        if (axisModel) return axisModel.__dzAxisProxy;
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisModel = function(axisDim, axisIndex) {
        var axisInfo = this._targetAxisInfoMap.get(axisDim);
        if (axisInfo && axisInfo.indexMap[axisIndex]) return this.ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
    };
    /**
   * If not specified, set to undefined.
   */ DataZoomModel.prototype.setRawRange = function(opt) {
        var thisOption = this.option;
        var settledOption = this.settledOption;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names) {
            // Consider the pair <start, startValue>:
            // If one has value and the other one is `null/undefined`, we both set them
            // to `settledOption`. This strategy enables the feature to clear the original
            // value in `settledOption` to `null/undefined`.
            // But if both of them are `null/undefined`, we do not set them to `settledOption`
            // and keep `settledOption` with the original value. This strategy enables users to
            // only set <end or endValue> but not set <start or startValue> when calling
            // `dispatchAction`.
            // The pair <end, endValue> is treated in the same way.
            if (opt[names[0]] != null || opt[names[1]] != null) {
                thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
                thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
            }
        }, this);
        this._updateRangeUse(opt);
    };
    DataZoomModel.prototype.setCalculatedRange = function(opt) {
        var option = this.option;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "start",
            "startValue",
            "end",
            "endValue"
        ], function(name) {
            option[name] = opt[name];
        });
    };
    DataZoomModel.prototype.getPercentRange = function() {
        var axisProxy = this.findRepresentativeAxisProxy();
        if (axisProxy) return axisProxy.getDataPercentWindow();
    };
    /**
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @return [startValue, endValue] value can only be '-' or finite number.
   */ DataZoomModel.prototype.getValueRange = function(axisDim, axisIndex) {
        if (axisDim == null && axisIndex == null) {
            var axisProxy = this.findRepresentativeAxisProxy();
            if (axisProxy) return axisProxy.getDataValueWindow();
        } else return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
    };
    /**
   * @param axisModel If axisModel given, find axisProxy
   *      corresponding to the axisModel
   */ DataZoomModel.prototype.findRepresentativeAxisProxy = function(axisModel) {
        if (axisModel) return axisModel.__dzAxisProxy;
        // Find the first hosted axisProxy
        var firstProxy;
        var axisDimList = this._targetAxisInfoMap.keys();
        for(var i = 0; i < axisDimList.length; i++){
            var axisDim = axisDimList[i];
            var axisInfo = this._targetAxisInfoMap.get(axisDim);
            for(var j = 0; j < axisInfo.indexList.length; j++){
                var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);
                if (proxy.hostedBy(this)) return proxy;
                if (!firstProxy) firstProxy = proxy;
            }
        }
        // If no hosted proxy found, still need to return a proxy.
        // This case always happens in toolbox dataZoom, where axes are all hosted by
        // other dataZooms.
        return firstProxy;
    };
    DataZoomModel.prototype.getRangePropMode = function() {
        return this._rangePropMode.slice();
    };
    DataZoomModel.prototype.getOrient = function() {
        return this._orient;
    };
    DataZoomModel.type = "dataZoom";
    DataZoomModel.dependencies = [
        "xAxis",
        "yAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "series",
        "toolbox"
    ];
    DataZoomModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        filterMode: "filter",
        start: 0,
        end: 100
    };
    return DataZoomModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
/**
 * Retrieve those raw params from option, which will be cached separately,
 * because they will be overwritten by normalized/calculated values in the main
 * process.
 */ function $41d57478d16bff21$var$retrieveRawOption(option) {
    var ret = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "start",
        "end",
        "startValue",
        "endValue",
        "throttle"
    ], function(name) {
        option.hasOwnProperty(name) && (ret[name] = option[name]);
    });
    return ret;
}
var $41d57478d16bff21$export$2e2bcd8739ae039 = $41d57478d16bff21$var$DataZoomModel;


var $4f28f1fbb9446d57$var$SelectDataZoomModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SelectDataZoomModel, _super);
    function SelectDataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomModel.type;
        return _this;
    }
    SelectDataZoomModel.type = "dataZoom.select";
    return SelectDataZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $4f28f1fbb9446d57$export$2e2bcd8739ae039 = $4f28f1fbb9446d57$var$SelectDataZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $80d6a03162f25654$var$DataZoomView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DataZoomView, _super);
    function DataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomView.type;
        return _this;
    }
    DataZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        this.dataZoomModel = dataZoomModel;
        this.ecModel = ecModel;
        this.api = api;
    };
    DataZoomView.type = "dataZoom";
    return DataZoomView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $80d6a03162f25654$export$2e2bcd8739ae039 = $80d6a03162f25654$var$DataZoomView;


var $ee4d1f83b7568801$var$SelectDataZoomView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SelectDataZoomView, _super);
    function SelectDataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomView.type;
        return _this;
    }
    SelectDataZoomView.type = "dataZoom.select";
    return SelectDataZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
var $ee4d1f83b7568801$export$2e2bcd8739ae039 = $ee4d1f83b7568801$var$SelectDataZoomView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $06639d6035d20694$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $06639d6035d20694$var$asc = $cfc1f3b422a3185f$export$debe6e778e0a6d32;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 */ var $06639d6035d20694$var$AxisProxy = /** @class */ function() {
    function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
        this._dimName = dimName;
        this._axisIndex = axisIndex;
        this.ecModel = ecModel;
        this._dataZoomModel = dataZoomModel;
    // /**
    //  * @readOnly
    //  * @private
    //  */
    // this.hasSeriesStacked;
    }
    /**
   * Whether the axisProxy is hosted by dataZoomModel.
   */ AxisProxy.prototype.hostedBy = function(dataZoomModel) {
        return this._dataZoomModel === dataZoomModel;
    };
    /**
   * @return Value can only be NaN or finite value.
   */ AxisProxy.prototype.getDataValueWindow = function() {
        return this._valueWindow.slice();
    };
    /**
   * @return {Array.<number>}
   */ AxisProxy.prototype.getDataPercentWindow = function() {
        return this._percentWindow.slice();
    };
    AxisProxy.prototype.getTargetSeriesModels = function() {
        var seriesModels = [];
        this.ecModel.eachSeries(function(seriesModel) {
            if ((0, $554cb472ba0e05d3$export$2d449d4adc0d2cfc)(seriesModel)) {
                var axisMainType = (0, $554cb472ba0e05d3$export$90855f7219399082)(this._dimName);
                var axisModel = seriesModel.getReferringComponents(axisMainType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                if (axisModel && this._axisIndex === axisModel.componentIndex) seriesModels.push(seriesModel);
            }
        }, this);
        return seriesModels;
    };
    AxisProxy.prototype.getAxisModel = function() {
        return this.ecModel.getComponent(this._dimName + "Axis", this._axisIndex);
    };
    AxisProxy.prototype.getMinMaxSpan = function() {
        return $7a1bd9c2710fea0d$export$9cd59f9826255e47(this._minMaxSpan);
    };
    /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   */ AxisProxy.prototype.calculateDataWindow = function(opt) {
        var dataExtent = this._dataExtent;
        var axisModel = this.getAxisModel();
        var scale = axisModel.axis.scale;
        var rangePropMode = this._dataZoomModel.getRangePropMode();
        var percentExtent = [
            0,
            100
        ];
        var percentWindow = [];
        var valueWindow = [];
        var hasPropModeValue;
        $06639d6035d20694$var$each([
            "start",
            "end"
        ], function(prop, idx) {
            var boundPercent = opt[prop];
            var boundValue = opt[prop + "Value"];
            // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
            // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
            // but not min/max of axis, which will be calculated by data window then).
            // The former one is suitable for cases that a dataZoom component controls multiple
            // axes with different unit or extent, and the latter one is suitable for accurate
            // zoom by pixel (e.g., in dataZoomSelect).
            // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
            // only when setOption or dispatchAction, otherwise it remains its original value.
            // (Why not only record `percentProp` and always map to `valueProp`? Because
            // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
            // `valueProp`. consider two axes constrolled by one dataZoom. They have different
            // data extent. All of values that are overflow the `dataExtent` will be calculated
            // to percent '100%').
            if (rangePropMode[idx] === "percent") {
                boundPercent == null && (boundPercent = percentExtent[idx]);
                // Use scale.parse to math round for category or time axis.
                boundValue = scale.parse($cfc1f3b422a3185f$export$d3f68fbaa670562(boundPercent, percentExtent, dataExtent));
            } else {
                hasPropModeValue = true;
                boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue);
                // Calculating `percent` from `value` may be not accurate, because
                // This calculation can not be inversed, because all of values that
                // are overflow the `dataExtent` will be calculated to percent '100%'
                boundPercent = $cfc1f3b422a3185f$export$d3f68fbaa670562(boundValue, dataExtent, percentExtent);
            }
            // valueWindow[idx] = round(boundValue);
            // percentWindow[idx] = round(boundPercent);
            // fallback to extent start/end when parsed value or percent is invalid
            valueWindow[idx] = boundValue == null || isNaN(boundValue) ? dataExtent[idx] : boundValue;
            percentWindow[idx] = boundPercent == null || isNaN(boundPercent) ? percentExtent[idx] : boundPercent;
        });
        $06639d6035d20694$var$asc(valueWindow);
        $06639d6035d20694$var$asc(percentWindow);
        // The windows from user calling of `dispatchAction` might be out of the extent,
        // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we don't restrict window
        // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
        // where API is able to initialize/modify the window size even though `zoomLock`
        // specified.
        var spans = this._minMaxSpan;
        hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
        function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
            var suffix = toValue ? "Span" : "ValueSpan";
            (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, fromWindow, fromExtent, "all", spans["min" + suffix], spans["max" + suffix]);
            for(var i = 0; i < 2; i++){
                toWindow[i] = $cfc1f3b422a3185f$export$d3f68fbaa670562(fromWindow[i], fromExtent, toExtent, true);
                toValue && (toWindow[i] = scale.parse(toWindow[i]));
            }
        }
        return {
            valueWindow: valueWindow,
            percentWindow: percentWindow
        };
    };
    /**
   * Notice: reset should not be called before series.restoreData() is called,
   * so it is recommended to be called in "process stage" but not "model init
   * stage".
   */ AxisProxy.prototype.reset = function(dataZoomModel) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var targetSeries = this.getTargetSeriesModels();
        // Culculate data window and data extent, and record them.
        this._dataExtent = $06639d6035d20694$var$calculateDataExtent(this, this._dimName, targetSeries);
        // `calculateDataWindow` uses min/maxSpan.
        this._updateMinMaxSpan();
        var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
        this._valueWindow = dataWindow.valueWindow;
        this._percentWindow = dataWindow.percentWindow;
        // Update axis setting then.
        this._setAxisModel();
    };
    AxisProxy.prototype.filterData = function(dataZoomModel, api) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var axisDim = this._dimName;
        var seriesModels = this.getTargetSeriesModels();
        var filterMode = dataZoomModel.get("filterMode");
        var valueWindow = this._valueWindow;
        if (filterMode === "none") return;
        // FIXME
        // Toolbox may has dataZoom injected. And if there are stacked bar chart
        // with NaN data, NaN will be filtered and stack will be wrong.
        // So we need to force the mode to be set empty.
        // In fect, it is not a big deal that do not support filterMode-'filter'
        // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
        // selection" some day, which might need "adapt to data extent on the
        // otherAxis", which is disabled by filterMode-'empty'.
        // But currently, stack has been fixed to based on value but not index,
        // so this is not an issue any more.
        // let otherAxisModel = this.getOtherAxisModel();
        // if (dataZoomModel.get('$fromToolbox')
        //     && otherAxisModel
        //     && otherAxisModel.hasSeriesStacked
        // ) {
        //     filterMode = 'empty';
        // }
        // TODO
        // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
        $06639d6035d20694$var$each(seriesModels, function(seriesModel) {
            var seriesData = seriesModel.getData();
            var dataDims = seriesData.mapDimensionsAll(axisDim);
            if (!dataDims.length) return;
            if (filterMode === "weakFilter") {
                var store_1 = seriesData.getStore();
                var dataDimIndices_1 = $7a1bd9c2710fea0d$export$871de8747c9eaa88(dataDims, function(dim) {
                    return seriesData.getDimensionIndex(dim);
                }, seriesData);
                seriesData.filterSelf(function(dataIndex) {
                    var leftOut;
                    var rightOut;
                    var hasValue;
                    for(var i = 0; i < dataDims.length; i++){
                        var value = store_1.get(dataDimIndices_1[i], dataIndex);
                        var thisHasValue = !isNaN(value);
                        var thisLeftOut = value < valueWindow[0];
                        var thisRightOut = value > valueWindow[1];
                        if (thisHasValue && !thisLeftOut && !thisRightOut) return true;
                        thisHasValue && (hasValue = true);
                        thisLeftOut && (leftOut = true);
                        thisRightOut && (rightOut = true);
                    }
                    // If both left out and right out, do not filter.
                    return hasValue && leftOut && rightOut;
                });
            } else $06639d6035d20694$var$each(dataDims, function(dim) {
                if (filterMode === "empty") seriesModel.setData(seriesData = seriesData.map(dim, function(value) {
                    return !isInWindow(value) ? NaN : value;
                }));
                else {
                    var range = {};
                    range[dim] = valueWindow;
                    // console.time('select');
                    seriesData.selectRange(range);
                // console.timeEnd('select');
                }
            });
            $06639d6035d20694$var$each(dataDims, function(dim) {
                seriesData.setApproximateExtent(valueWindow, dim);
            });
        });
        function isInWindow(value) {
            return value >= valueWindow[0] && value <= valueWindow[1];
        }
    };
    AxisProxy.prototype._updateMinMaxSpan = function() {
        var minMaxSpan = this._minMaxSpan = {};
        var dataZoomModel = this._dataZoomModel;
        var dataExtent = this._dataExtent;
        $06639d6035d20694$var$each([
            "min",
            "max"
        ], function(minMax) {
            var percentSpan = dataZoomModel.get(minMax + "Span");
            var valueSpan = dataZoomModel.get(minMax + "ValueSpan");
            valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan));
            // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
            if (valueSpan != null) percentSpan = $cfc1f3b422a3185f$export$d3f68fbaa670562(dataExtent[0] + valueSpan, dataExtent, [
                0,
                100
            ], true);
            else if (percentSpan != null) valueSpan = $cfc1f3b422a3185f$export$d3f68fbaa670562(percentSpan, [
                0,
                100
            ], dataExtent, true) - dataExtent[0];
            minMaxSpan[minMax + "Span"] = percentSpan;
            minMaxSpan[minMax + "ValueSpan"] = valueSpan;
        }, this);
    };
    AxisProxy.prototype._setAxisModel = function() {
        var axisModel = this.getAxisModel();
        var percentWindow = this._percentWindow;
        var valueWindow = this._valueWindow;
        if (!percentWindow) return;
        // [0, 500]: arbitrary value, guess axis extent.
        var precision = $cfc1f3b422a3185f$export$666260d9a2dda8a7(valueWindow, [
            0,
            500
        ]);
        precision = Math.min(precision, 20);
        // For value axis, if min/max/scale are not set, we just use the extent obtained
        // by series data, which may be a little different from the extent calculated by
        // `axisHelper.getScaleExtent`. But the different just affects the experience a
        // little when zooming. So it will not be fixed until some users require it strongly.
        var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;
        if (percentWindow[0] !== 0) rawExtentInfo.setDeterminedMinMax("min", +valueWindow[0].toFixed(precision));
        if (percentWindow[1] !== 100) rawExtentInfo.setDeterminedMinMax("max", +valueWindow[1].toFixed(precision));
        rawExtentInfo.freeze();
    };
    return AxisProxy;
}();
function $06639d6035d20694$var$calculateDataExtent(axisProxy, axisDim, seriesModels) {
    var dataExtent = [
        Infinity,
        -Infinity
    ];
    $06639d6035d20694$var$each(seriesModels, function(seriesModel) {
        (0, $2d646e51cc34f840$export$635fe7f20d0f4c70)(dataExtent, seriesModel.getData(), axisDim);
    });
    // It is important to get "consistent" extent when more then one axes is
    // controlled by a `dataZoom`, otherwise those axes will not be synchronized
    // when zooming. But it is difficult to know what is "consistent", considering
    // axes have different type or even different meanings (For example, two
    // time axes are used to compare data of the same date in different years).
    // So basically dataZoom just obtains extent by series.data (in category axis
    // extent can be obtained from axis.data).
    // Nevertheless, user can set min/max/scale on axes to make extent of axes
    // consistent.
    var axisModel = axisProxy.getAxisModel();
    var rawExtentResult = (0, $483be9695e74220c$export$5c3dbcbeb9ce7f5a)(axisModel.axis.scale, axisModel, dataExtent).calculate();
    return [
        rawExtentResult.min,
        rawExtentResult.max
    ];
}
var $06639d6035d20694$export$2e2bcd8739ae039 = $06639d6035d20694$var$AxisProxy;


var $e1090934575f11ee$var$dataZoomProcessor = {
    // `dataZoomProcessor` will only be performed in needed series. Consider if
    // there is a line series and a pie series, it is better not to update the
    // line series if only pie series is needed to be updated.
    getTargetSeries: function(ecModel) {
        function eachAxisModel(cb) {
            ecModel.eachComponent("dataZoom", function(dataZoomModel) {
                dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                    var axisModel = ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
                    cb(axisDim, axisIndex, axisModel, dataZoomModel);
                });
            });
        }
        // FIXME: it brings side-effect to `getTargetSeries`.
        // Prepare axis proxies.
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // dispose all last axis proxy, in case that some axis are deleted.
            axisModel.__dzAxisProxy = null;
        });
        var proxyList = [];
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // Different dataZooms may constrol the same axis. In that case,
            // an axisProxy serves both of them.
            if (!axisModel.__dzAxisProxy) {
                // Use the first dataZoomModel as the main model of axisProxy.
                axisModel.__dzAxisProxy = new (0, $06639d6035d20694$export$2e2bcd8739ae039)(axisDim, axisIndex, dataZoomModel, ecModel);
                proxyList.push(axisModel.__dzAxisProxy);
            }
        });
        var seriesModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(proxyList, function(axisProxy) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisProxy.getTargetSeriesModels(), function(seriesModel) {
                seriesModelMap.set(seriesModel.uid, seriesModel);
            });
        });
        return seriesModelMap;
    },
    // Consider appendData, where filter should be performed. Because data process is
    // in block mode currently, it is not need to worry about that the overallProgress
    // execute every frame.
    overallReset: function(ecModel, api) {
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            // We calculate window and reset axis here but not in model
            // init stage and not after action dispatch handler, because
            // reset should be called after seriesData.restoreData.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
            });
            // Caution: data zoom filtering is order sensitive when using
            // percent range and no min/max/scale set on axis.
            // For example, we have dataZoom definition:
            // [
            //      {xAxisIndex: 0, start: 30, end: 70},
            //      {yAxisIndex: 0, start: 20, end: 80}
            // ]
            // In this case, [20, 80] of y-dataZoom should be based on data
            // that have filtered by x-dataZoom using range of [30, 70],
            // but should not be based on full raw data. Thus sliding
            // x-dataZoom will change both ranges of xAxis and yAxis,
            // while sliding y-dataZoom will only change the range of yAxis.
            // So we should filter x-axis after reset x-axis immediately,
            // and then reset y-axis and filter y-axis.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
            });
        });
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            // Fullfill all of the range props so that user
            // is able to get them from chart.getOption().
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var percentRange = axisProxy.getDataPercentWindow();
                var valueRange = axisProxy.getDataValueWindow();
                dataZoomModel.setCalculatedRange({
                    start: percentRange[0],
                    end: percentRange[1],
                    startValue: valueRange[0],
                    endValue: valueRange[1]
                });
            }
        });
    }
};
var $e1090934575f11ee$export$2e2bcd8739ae039 = $e1090934575f11ee$var$dataZoomProcessor;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $de61ff13130c6dae$export$2e2bcd8739ae039(registers) {
    registers.registerAction("dataZoom", function(payload, ecModel) {
        var effectedModels = (0, $554cb472ba0e05d3$export$9e00b6c2b8b2e9a7)(ecModel, payload);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(effectedModels, function(dataZoomModel) {
            dataZoomModel.setRawRange({
                start: payload.start,
                end: payload.end,
                startValue: payload.startValue,
                endValue: payload.endValue
            });
        });
    });
}


var $8904ef10f452e35c$var$installed = false;
function $8904ef10f452e35c$export$2e2bcd8739ae039(registers) {
    if ($8904ef10f452e35c$var$installed) return;
    $8904ef10f452e35c$var$installed = true;
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, (0, $e1090934575f11ee$export$2e2bcd8739ae039));
    (0, $de61ff13130c6dae$export$2e2bcd8739ae039)(registers);
    registers.registerSubTypeDefaulter("dataZoom", function() {
        // Default 'slider' when no type specified.
        return "slider";
    });
}


function $738a563bbc36032b$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $4f28f1fbb9446d57$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ee4d1f83b7568801$export$2e2bcd8739ae039));
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ var $974ee7656e10f2d0$export$1426bfb1b0bcf539 = /** @class */ function() {
    function ToolboxFeature() {}
    return ToolboxFeature;
}();
var $974ee7656e10f2d0$var$features = {};
function $974ee7656e10f2d0$export$c6213a6f247cf906(name, ctor) {
    $974ee7656e10f2d0$var$features[name] = ctor;
}
function $974ee7656e10f2d0$export$bba2e7bbd72e62e1(name) {
    return $974ee7656e10f2d0$var$features[name];
}



var $f3a05ea4ae929f91$var$ToolboxModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ToolboxModel, _super);
    function ToolboxModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ToolboxModel.type;
        return _this;
    }
    ToolboxModel.prototype.optionUpdated = function() {
        _super.prototype.optionUpdated.apply(this, arguments);
        var ecModel = this.ecModel;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.option.feature, function(featureOpt, featureName) {
            var Feature = $974ee7656e10f2d0$export$bba2e7bbd72e62e1(featureName);
            if (Feature) {
                if (Feature.getDefaultOption) Feature.defaultOption = Feature.getDefaultOption(ecModel);
                $7a1bd9c2710fea0d$export$4950aa0f605343fb(featureOpt, Feature.defaultOption);
            }
        });
    };
    ToolboxModel.type = "toolbox";
    ToolboxModel.layoutMode = {
        type: "box",
        ignoreSize: true
    };
    ToolboxModel.defaultOption = {
        show: true,
        z: 6,
        // zlevel: 0,
        orient: "horizontal",
        left: "right",
        top: "top",
        // right
        // bottom
        backgroundColor: "transparent",
        borderColor: "#ccc",
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemSize: 15,
        itemGap: 8,
        showTitle: true,
        iconStyle: {
            borderColor: "#666",
            color: "none"
        },
        emphasis: {
            iconStyle: {
                borderColor: "#3E98C5"
            }
        },
        // textStyle: {},
        // feature
        tooltip: {
            show: false,
            position: "bottom"
        }
    };
    return ToolboxModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $f3a05ea4ae929f91$export$2e2bcd8739ae039 = $f3a05ea4ae929f91$var$ToolboxModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck



function $40fca678c85406ff$export$b3219800bda33a1f(group, componentModel, api) {
    var boxLayoutParams = componentModel.getBoxLayoutParams();
    var padding = componentModel.get("padding");
    var viewportSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutParams, viewportSize, padding);
    (0, $93b9bc7f22ac7369$export$827f4ee28efc37)(componentModel.get("orient"), group, componentModel.get("itemGap"), rect.width, rect.height);
    (0, $93b9bc7f22ac7369$export$74054bd96b5eeef1)(group, boxLayoutParams, viewportSize, padding);
}
function $40fca678c85406ff$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $c84c9521536c601a$export$f3a38102c49f4268(componentModel.get("padding"));
    var style = componentModel.getItemStyle([
        "color",
        "opacity"
    ]);
    style.fill = componentModel.get("backgroundColor");
    rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get("borderRadius")
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return rect;
}







var $e0876f124cc8d5c9$var$ToolboxView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ToolboxView, _super);
    function ToolboxView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolboxView.prototype.render = function(toolboxModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        if (!toolboxModel.get("show")) return;
        var itemSize = +toolboxModel.get("itemSize");
        var isVertical = toolboxModel.get("orient") === "vertical";
        var featureOpts = toolboxModel.get("feature") || {};
        var features = this._features || (this._features = {});
        var featureNames = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(featureOpts, function(opt, name) {
            featureNames.push(name);
        });
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove($7a1bd9c2710fea0d$export$c3095a23b368d1f2(processFeature, null)).execute();
        // Keep for diff.
        this._featureNames = featureNames;
        function processFeature(newIndex, oldIndex) {
            var featureName = featureNames[newIndex];
            var oldName = featureNames[oldIndex];
            var featureOpt = featureOpts[featureName];
            var featureModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(featureOpt, toolboxModel, toolboxModel.ecModel);
            var feature;
            // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
            if (payload && payload.newTitle != null && payload.featureName === featureName) featureOpt.title = payload.newTitle;
            if (featureName && !oldName) {
                // Create
                if ($e0876f124cc8d5c9$var$isUserFeatureName(featureName)) feature = {
                    onclick: featureModel.option.onclick,
                    featureName: featureName
                };
                else {
                    var Feature = (0, $974ee7656e10f2d0$export$bba2e7bbd72e62e1)(featureName);
                    if (!Feature) return;
                    feature = new Feature();
                }
                features[featureName] = feature;
            } else {
                feature = features[oldName];
                // If feature does not exist.
                if (!feature) return;
            }
            feature.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("toolbox-feature");
            feature.model = featureModel;
            feature.ecModel = ecModel;
            feature.api = api;
            var isToolboxFeature = feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539);
            if (!featureName && oldName) {
                isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
                return;
            }
            if (!featureModel.get("show") || isToolboxFeature && feature.unusable) {
                isToolboxFeature && feature.remove && feature.remove(ecModel, api);
                return;
            }
            createIconPaths(featureModel, feature, featureName);
            featureModel.setIconStatus = function(iconName, status) {
                var option = this.option;
                var iconPaths = this.iconPaths;
                option.iconStatus = option.iconStatus || {};
                option.iconStatus[iconName] = status;
                if (iconPaths[iconName]) (status === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(iconPaths[iconName]);
            };
            if (feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539)) {
                if (feature.render) feature.render(featureModel, ecModel, api, payload);
            }
        }
        function createIconPaths(featureModel, feature, featureName) {
            var iconStyleModel = featureModel.getModel("iconStyle");
            var iconStyleEmphasisModel = featureModel.getModel([
                "emphasis",
                "iconStyle"
            ]);
            // If one feature has multiple icons, they are organized as
            // {
            //     icon: {
            //         foo: '',
            //         bar: ''
            //     },
            //     title: {
            //         foo: '',
            //         bar: ''
            //     }
            // }
            var icons = feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.getIcons ? feature.getIcons() : featureModel.get("icon");
            var titles = featureModel.get("title") || {};
            var iconsMap;
            var titlesMap;
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(icons)) {
                iconsMap = {};
                iconsMap[featureName] = icons;
            } else iconsMap = icons;
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(titles)) {
                titlesMap = {};
                titlesMap[featureName] = titles;
            } else titlesMap = titles;
            var iconPaths = featureModel.iconPaths = {};
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(iconsMap, function(iconStr, iconName) {
                var path = $5b455ae6f843ac47$export$274edc73af1ae9c8(iconStr, {}, {
                    x: -itemSize / 2,
                    y: -itemSize / 2,
                    width: itemSize,
                    height: itemSize
                }); // TODO handling image
                path.setStyle(iconStyleModel.getItemStyle());
                var pathEmphasisState = path.ensureState("emphasis");
                pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle();
                // Text position calculation
                // TODO: extract `textStyle` from `iconStyle` and use `createTextStyle`
                var textContent = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
                    style: {
                        text: titlesMap[iconName],
                        align: iconStyleEmphasisModel.get("textAlign"),
                        borderRadius: iconStyleEmphasisModel.get("textBorderRadius"),
                        padding: iconStyleEmphasisModel.get("textPadding"),
                        fill: null,
                        font: (0, $6800dfcb6e1e2a44$export$155316a870a9d61e)({
                            fontStyle: iconStyleEmphasisModel.get("textFontStyle"),
                            fontFamily: iconStyleEmphasisModel.get("textFontFamily"),
                            fontSize: iconStyleEmphasisModel.get("textFontSize"),
                            fontWeight: iconStyleEmphasisModel.get("textFontWeight")
                        }, ecModel)
                    },
                    ignore: true
                });
                path.setTextContent(textContent);
                $5b455ae6f843ac47$export$fc6410d97fab306c({
                    el: path,
                    componentModel: toolboxModel,
                    itemName: iconName,
                    formatterParamsExtra: {
                        title: titlesMap[iconName]
                    }
                });
                path.__title = titlesMap[iconName];
                path.on("mouseover", function() {
                    // Should not reuse above hoverStyle, which might be modified.
                    var hoverStyle = iconStyleEmphasisModel.getItemStyle();
                    var defaultTextPosition = isVertical ? toolboxModel.get("right") == null && toolboxModel.get("left") !== "right" ? "right" : "left" : toolboxModel.get("bottom") == null && toolboxModel.get("top") !== "bottom" ? "bottom" : "top";
                    textContent.setStyle({
                        fill: iconStyleEmphasisModel.get("textFill") || hoverStyle.fill || hoverStyle.stroke || "#000",
                        backgroundColor: iconStyleEmphasisModel.get("textBackgroundColor")
                    });
                    path.setTextConfig({
                        position: iconStyleEmphasisModel.get("textPosition") || defaultTextPosition
                    });
                    textContent.ignore = !toolboxModel.get("showTitle");
                    // Use enterEmphasis and leaveEmphasis provide by ec.
                    // There are flags managed by the echarts.
                    api.enterEmphasis(this);
                }).on("mouseout", function() {
                    if (featureModel.get([
                        "iconStatus",
                        iconName
                    ]) !== "emphasis") api.leaveEmphasis(this);
                    textContent.hide();
                });
                (featureModel.get([
                    "iconStatus",
                    iconName
                ]) === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(path);
                group.add(path);
                path.on("click", $7a1bd9c2710fea0d$export$2385a24977818dd0(feature.onclick, feature, ecModel, api, iconName));
                iconPaths[iconName] = path;
            });
        }
        $40fca678c85406ff$export$b3219800bda33a1f(group, toolboxModel, api);
        // Render background after group is layout
        // FIXME
        group.add($40fca678c85406ff$export$fae23936eedfad4f(group.getBoundingRect(), toolboxModel));
        // Adjust icon title positions to avoid them out of screen
        isVertical || group.eachChild(function(icon) {
            var titleText = icon.__title;
            // const hoverStyle = icon.hoverStyle;
            // TODO simplify code?
            var emphasisState = icon.ensureState("emphasis");
            var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
            var textContent = icon.getTextContent();
            var emphasisTextState = textContent && textContent.ensureState("emphasis");
            // May be background element
            if (emphasisTextState && !$7a1bd9c2710fea0d$export$f6e2535fb5126e54(emphasisTextState) && titleText) {
                var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
                var rect = $6c308355c7107803$export$c381147bfed79d9f(titleText, (0, $fe885cc21795562b$export$2e2bcd8739ae039).makeFont(emphasisTextStyle));
                var offsetX = icon.x + group.x;
                var offsetY = icon.y + group.y + itemSize;
                var needPutOnTop = false;
                if (offsetY + rect.height > api.getHeight()) {
                    emphasisTextConfig.position = "top";
                    needPutOnTop = true;
                }
                var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;
                if (offsetX + rect.width / 2 > api.getWidth()) {
                    emphasisTextConfig.position = [
                        "100%",
                        topOffset
                    ];
                    emphasisTextStyle.align = "right";
                } else if (offsetX - rect.width / 2 < 0) {
                    emphasisTextConfig.position = [
                        0,
                        topOffset
                    ];
                    emphasisTextStyle.align = "left";
                }
            }
        });
    };
    ToolboxView.prototype.updateView = function(toolboxModel, ecModel, api, payload) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
        });
    };
    // updateLayout(toolboxModel, ecModel, api, payload) {
    //     zrUtil.each(this._features, function (feature) {
    //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
    //     });
    // },
    ToolboxView.prototype.remove = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.remove && feature.remove(ecModel, api);
        });
        this.group.removeAll();
    };
    ToolboxView.prototype.dispose = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.dispose && feature.dispose(ecModel, api);
        });
    };
    ToolboxView.type = "toolbox";
    return ToolboxView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $e0876f124cc8d5c9$var$isUserFeatureName(featureName) {
    return featureName.indexOf("my") === 0;
}
var $e0876f124cc8d5c9$export$2e2bcd8739ae039 = $e0876f124cc8d5c9$var$ToolboxView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/* global window, document */ var $1abd70fc7852729e$var$SaveAsImage = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SaveAsImage, _super);
    function SaveAsImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaveAsImage.prototype.onclick = function(ecModel, api) {
        var model = this.model;
        var title = model.get("name") || ecModel.get("title.0.text") || "echarts";
        var isSvg = api.getZr().painter.getType() === "svg";
        var type = isSvg ? "svg" : model.get("type", true) || "png";
        var url = api.getConnectedDataURL({
            type: type,
            backgroundColor: model.get("backgroundColor", true) || ecModel.get("backgroundColor") || "#fff",
            connectedBackgroundColor: model.get("connectedBackgroundColor"),
            excludeComponents: model.get("excludeComponents"),
            pixelRatio: model.get("pixelRatio")
        });
        var browser = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser;
        // Chrome, Firefox, New Edge
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(MouseEvent) && (browser.newEdge || !browser.ie && !browser.edge)) {
            var $a = document.createElement("a");
            $a.download = title + "." + type;
            $a.target = "_blank";
            $a.href = url;
            var evt = new MouseEvent("click", {
                // some micro front-end framework， window maybe is a Proxy
                view: document.defaultView,
                bubbles: true,
                cancelable: false
            });
            $a.dispatchEvent(evt);
        } else // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob || isSvg) {
            var parts = url.split(",");
            // data:[<mime type>][;charset=<charset>][;base64],<encoded data>
            var base64Encoded = parts[0].indexOf("base64") > -1;
            var bstr = isSvg ? decodeURIComponent(parts[1]) : parts[1];
            // only `atob` when the data uri is encoded with base64
            // otherwise, like `svg` data uri exported by zrender,
            // there will be an error, for it's not encoded with base64.
            // (just a url-encoded string through `encodeURIComponent`)
            base64Encoded && (bstr = window.atob(bstr));
            var filename = title + "." + type;
            // @ts-ignore
            if (window.navigator.msSaveOrOpenBlob) {
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while(n--)u8arr[n] = bstr.charCodeAt(n);
                var blob = new Blob([
                    u8arr
                ]); // @ts-ignore
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var frame = document.createElement("iframe");
                document.body.appendChild(frame);
                var cw = frame.contentWindow;
                var doc = cw.document;
                doc.open("image/svg+xml", "replace");
                doc.write(bstr);
                doc.close();
                cw.focus();
                doc.execCommand("SaveAs", true, filename);
                document.body.removeChild(frame);
            }
        } else {
            var lang = model.get("lang");
            var html = '<body style="margin:0;"><img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || "") + '" />' + "</body>";
            var tab = window.open();
            tab.document.write(html);
            tab.document.title = title;
        }
    };
    SaveAsImage.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            icon: "M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "saveAsImage",
                "title"
            ]),
            type: "png",
            // Default use option.backgroundColor
            // backgroundColor: '#fff',
            connectedBackgroundColor: "#fff",
            name: "",
            excludeComponents: [
                "toolbox"
            ],
            // use current pixel ratio of device by default
            // pixelRatio: 1,
            lang: ecModel.getLocaleModel().get([
                "toolbox",
                "saveAsImage",
                "lang"
            ])
        };
        return defaultOption;
    };
    return SaveAsImage;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $1abd70fc7852729e$export$2e2bcd8739ae039 = $1abd70fc7852729e$var$SaveAsImage;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $1a3c941566c70505$var$INNER_STACK_KEYWORD = "__ec_magicType_stack__";
var $1a3c941566c70505$var$ICON_TYPES = [
    "line",
    "bar",
    "stack"
];
// stack and tiled appears in pair for the title
var $1a3c941566c70505$var$TITLE_TYPES = [
    "line",
    "bar",
    "stack",
    "tiled"
];
var $1a3c941566c70505$var$radioTypes = [
    [
        "line",
        "bar"
    ],
    [
        "stack"
    ]
];
var $1a3c941566c70505$var$MagicType = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MagicType, _super);
    function MagicType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MagicType.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get("icon");
        var icons = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("type"), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    MagicType.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: [],
            // Icon group
            icon: {
                line: "M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4",
                bar: "M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7",
                // eslint-disable-next-line
                stack: "M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z" // jshint ignore:line
            },
            // `line`, `bar`, `stack`, `tiled`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "magicType",
                "title"
            ]),
            option: {},
            seriesIndex: {}
        };
        return defaultOption;
    };
    MagicType.prototype.onclick = function(ecModel, api, type) {
        var model = this.model;
        var seriesIndex = model.get([
            "seriesIndex",
            type
        ]);
        // Not supported magicType
        if (!$1a3c941566c70505$var$seriesOptGenreator[type]) return;
        var newOption = {
            series: []
        };
        var generateNewSeriesTypes = function(seriesModel) {
            var seriesType = seriesModel.subType;
            var seriesId = seriesModel.id;
            var newSeriesOpt = $1a3c941566c70505$var$seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
            if (newSeriesOpt) {
                // PENDING If merge original option?
                $7a1bd9c2710fea0d$export$ebe90cb607ad99e(newSeriesOpt, seriesModel.option);
                newOption.series.push(newSeriesOpt);
            }
            // Modify boundaryGap
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.type === "cartesian2d" && (type === "line" || type === "bar")) {
                var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
                if (categoryAxis) {
                    var axisDim = categoryAxis.dim;
                    var axisType = axisDim + "Axis";
                    var axisModel = seriesModel.getReferringComponents(axisType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                    var axisIndex = axisModel.componentIndex;
                    newOption[axisType] = newOption[axisType] || [];
                    for(var i = 0; i <= axisIndex; i++)newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
                    newOption[axisType][axisIndex].boundaryGap = type === "bar";
                }
            }
        };
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($1a3c941566c70505$var$radioTypes, function(radio) {
            if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(radio, type) >= 0) $7a1bd9c2710fea0d$export$79b2f7037acddd43(radio, function(item) {
                model.setIconStatus(item, "normal");
            });
        });
        model.setIconStatus(type, "emphasis");
        ecModel.eachComponent({
            mainType: "series",
            query: seriesIndex == null ? null : {
                seriesIndex: seriesIndex
            }
        }, generateNewSeriesTypes);
        var newTitle;
        var currentType = type;
        // Change title of stack
        if (type === "stack") {
            // use titles in model instead of ecModel
            // as stack and tiled appears in pair, just flip them
            // no need of checking stack state
            newTitle = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
                stack: model.option.title.tiled,
                tiled: model.option.title.stack
            }, model.option.title);
            if (model.get([
                "iconStatus",
                type
            ]) !== "emphasis") currentType = "tiled";
        }
        api.dispatchAction({
            type: "changeMagicType",
            currentType: currentType,
            newOption: newOption,
            newTitle: newTitle,
            featureName: "magicType"
        });
    };
    return MagicType;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $1a3c941566c70505$var$seriesOptGenreator = {
    "line": function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === "bar") return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            id: seriesId,
            type: "line",
            // Preserve data related option
            data: seriesModel.get("data"),
            stack: seriesModel.get("stack"),
            markPoint: seriesModel.get("markPoint"),
            markLine: seriesModel.get("markLine")
        }, model.get([
            "option",
            "line"
        ]) || {}, true);
    },
    "bar": function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === "line") return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            id: seriesId,
            type: "bar",
            // Preserve data related option
            data: seriesModel.get("data"),
            stack: seriesModel.get("stack"),
            markPoint: seriesModel.get("markPoint"),
            markLine: seriesModel.get("markLine")
        }, model.get([
            "option",
            "bar"
        ]) || {}, true);
    },
    "stack": function(seriesType, seriesId, seriesModel, model) {
        var isStack = seriesModel.get("stack") === $1a3c941566c70505$var$INNER_STACK_KEYWORD;
        if (seriesType === "line" || seriesType === "bar") {
            model.setIconStatus("stack", isStack ? "normal" : "emphasis");
            return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
                id: seriesId,
                stack: isStack ? "" : $1a3c941566c70505$var$INNER_STACK_KEYWORD
            }, model.get([
                "option",
                "stack"
            ]) || {}, true);
        }
    }
};
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "changeMagicType",
    event: "magicTypeChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    ecModel.mergeOption(payload.newOption);
});
var $1a3c941566c70505$export$2e2bcd8739ae039 = $1a3c941566c70505$var$MagicType;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/* global document */ var $c28a86c6c47fb2f6$var$BLOCK_SPLITER = new Array(60).join("-");
var $c28a86c6c47fb2f6$var$ITEM_SPLITER = "	";
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 */ function $c28a86c6c47fb2f6$var$groupSeries(ecModel) {
    var seriesGroupByCategoryAxis = {};
    var otherSeries = [];
    var meta = [];
    ecModel.eachRawSeries(function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === "cartesian2d" || coordSys.type === "polar")) {
            // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
            var baseAxis = coordSys.getBaseAxis();
            if (baseAxis.type === "category") {
                var key = baseAxis.dim + "_" + baseAxis.index;
                if (!seriesGroupByCategoryAxis[key]) {
                    seriesGroupByCategoryAxis[key] = {
                        categoryAxis: baseAxis,
                        valueAxis: coordSys.getOtherAxis(baseAxis),
                        series: []
                    };
                    meta.push({
                        axisDim: baseAxis.dim,
                        axisIndex: baseAxis.index
                    });
                }
                seriesGroupByCategoryAxis[key].series.push(seriesModel);
            } else otherSeries.push(seriesModel);
        } else otherSeries.push(seriesModel);
    });
    return {
        seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
        other: otherSeries,
        meta: meta
    };
}
/**
 * Assemble content of series on cateogory axis
 * @inner
 */ function $c28a86c6c47fb2f6$var$assembleSeriesWithCategoryAxis(groups) {
    var tables = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(groups, function(group, key) {
        var categoryAxis = group.categoryAxis;
        var valueAxis = group.valueAxis;
        var valueAxisDim = valueAxis.dim;
        var headers = [
            " "
        ].concat($7a1bd9c2710fea0d$export$871de8747c9eaa88(group.series, function(series) {
            return series.name;
        }));
        // @ts-ignore TODO Polar
        var columns = [
            categoryAxis.model.getCategories()
        ];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(group.series, function(series) {
            var rawData = series.getRawData();
            columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function(val) {
                return val;
            }));
        });
        // Assemble table content
        var lines = [
            headers.join($c28a86c6c47fb2f6$var$ITEM_SPLITER)
        ];
        for(var i = 0; i < columns[0].length; i++){
            var items = [];
            for(var j = 0; j < columns.length; j++)items.push(columns[j][i]);
            lines.push(items.join($c28a86c6c47fb2f6$var$ITEM_SPLITER));
        }
        tables.push(lines.join("\n"));
    });
    return tables.join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n");
}
/**
 * Assemble content of other series
 */ function $c28a86c6c47fb2f6$var$assembleOtherSeries(series) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(series, function(series) {
        var data = series.getRawData();
        var lines = [
            series.name
        ];
        var vals = [];
        data.each(data.dimensions, function() {
            var argLen = arguments.length;
            var dataIndex = arguments[argLen - 1];
            var name = data.getName(dataIndex);
            for(var i = 0; i < argLen - 1; i++)vals[i] = arguments[i];
            lines.push((name ? name + $c28a86c6c47fb2f6$var$ITEM_SPLITER : "") + vals.join($c28a86c6c47fb2f6$var$ITEM_SPLITER));
        });
        return lines.join("\n");
    }).join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n");
}
function $c28a86c6c47fb2f6$var$getContentFromModel(ecModel) {
    var result = $c28a86c6c47fb2f6$var$groupSeries(ecModel);
    return {
        value: $7a1bd9c2710fea0d$export$3dea766d36a8935f([
            $c28a86c6c47fb2f6$var$assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis),
            $c28a86c6c47fb2f6$var$assembleOtherSeries(result.other)
        ], function(str) {
            return !!str.replace(/[\n\t\s]/g, "");
        }).join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n"),
        meta: result.meta
    };
}
function $c28a86c6c47fb2f6$var$trim(str) {
    return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
/**
 * If a block is tsv format
 */ function $c28a86c6c47fb2f6$var$isTSVFormat(block) {
    // Simple method to find out if a block is tsv format
    var firstLine = block.slice(0, block.indexOf("\n"));
    if (firstLine.indexOf($c28a86c6c47fb2f6$var$ITEM_SPLITER) >= 0) return true;
}
var $c28a86c6c47fb2f6$var$itemSplitRegex = new RegExp("[" + $c28a86c6c47fb2f6$var$ITEM_SPLITER + "]+", "g");
/**
 * @param {string} tsv
 * @return {Object}
 */ function $c28a86c6c47fb2f6$var$parseTSVContents(tsv) {
    var tsvLines = tsv.split(/\n+/g);
    var headers = $c28a86c6c47fb2f6$var$trim(tsvLines.shift()).split($c28a86c6c47fb2f6$var$itemSplitRegex);
    var categories = [];
    var series = $7a1bd9c2710fea0d$export$871de8747c9eaa88(headers, function(header) {
        return {
            name: header,
            data: []
        };
    });
    for(var i = 0; i < tsvLines.length; i++){
        var items = $c28a86c6c47fb2f6$var$trim(tsvLines[i]).split($c28a86c6c47fb2f6$var$itemSplitRegex);
        categories.push(items.shift());
        for(var j = 0; j < items.length; j++)series[j] && (series[j].data[i] = items[j]);
    }
    return {
        series: series,
        categories: categories
    };
}
function $c28a86c6c47fb2f6$var$parseListContents(str) {
    var lines = str.split(/\n+/g);
    var seriesName = $c28a86c6c47fb2f6$var$trim(lines.shift());
    var data = [];
    for(var i = 0; i < lines.length; i++){
        // if line is empty, ignore it.
        // there is a case that a user forgot to delete `\n`.
        var line = $c28a86c6c47fb2f6$var$trim(lines[i]);
        if (!line) continue;
        var items = line.split($c28a86c6c47fb2f6$var$itemSplitRegex);
        var name_1 = "";
        var value = void 0;
        var hasName = false;
        if (isNaN(items[0])) {
            // First item is name
            hasName = true;
            name_1 = items[0];
            items = items.slice(1);
            data[i] = {
                name: name_1,
                value: []
            };
            value = data[i].value;
        } else value = data[i] = [];
        for(var j = 0; j < items.length; j++)value.push(+items[j]);
        if (value.length === 1) hasName ? data[i].value = value[0] : data[i] = value[0];
    }
    return {
        name: seriesName,
        data: data
    };
}
function $c28a86c6c47fb2f6$var$parseContents(str, blockMetaList) {
    var blocks = str.split(new RegExp("\n*" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n*", "g"));
    var newOption = {
        series: []
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(blocks, function(block, idx) {
        if ($c28a86c6c47fb2f6$var$isTSVFormat(block)) {
            var result = $c28a86c6c47fb2f6$var$parseTSVContents(block);
            var blockMeta = blockMetaList[idx];
            var axisKey = blockMeta.axisDim + "Axis";
            if (blockMeta) {
                newOption[axisKey] = newOption[axisKey] || [];
                newOption[axisKey][blockMeta.axisIndex] = {
                    data: result.categories
                };
                newOption.series = newOption.series.concat(result.series);
            }
        } else {
            var result = $c28a86c6c47fb2f6$var$parseListContents(block);
            newOption.series.push(result);
        }
    });
    return newOption;
}
var $c28a86c6c47fb2f6$var$DataView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DataView, _super);
    function DataView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataView.prototype.onclick = function(ecModel, api) {
        // FIXME: better way?
        setTimeout(function() {
            api.dispatchAction({
                type: "hideTip"
            });
        });
        var container = api.getDom();
        var model = this.model;
        if (this._dom) container.removeChild(this._dom);
        var root = document.createElement("div");
        // use padding to avoid 5px whitespace
        root.style.cssText = "position:absolute;top:0;bottom:0;left:0;right:0;padding:5px";
        root.style.backgroundColor = model.get("backgroundColor") || "#fff";
        // Create elements
        var header = document.createElement("h4");
        var lang = model.get("lang") || [];
        header.innerHTML = lang[0] || model.get("title");
        header.style.cssText = "margin:10px 20px";
        header.style.color = model.get("textColor");
        var viewMain = document.createElement("div");
        var textarea = document.createElement("textarea");
        viewMain.style.cssText = "overflow:auto";
        var optionToContent = model.get("optionToContent");
        var contentToOption = model.get("contentToOption");
        var result = $c28a86c6c47fb2f6$var$getContentFromModel(ecModel);
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionToContent)) {
            var htmlOrDom = optionToContent(api.getOption());
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(htmlOrDom)) viewMain.innerHTML = htmlOrDom;
            else if ($7a1bd9c2710fea0d$export$9f57505b7bd8dae(htmlOrDom)) viewMain.appendChild(htmlOrDom);
        } else {
            // Use default textarea
            textarea.readOnly = model.get("readOnly");
            var style = textarea.style;
            // eslint-disable-next-line max-len
            style.cssText = "display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none";
            style.color = model.get("textColor");
            style.borderColor = model.get("textareaBorderColor");
            style.backgroundColor = model.get("textareaColor");
            textarea.value = result.value;
            viewMain.appendChild(textarea);
        }
        var blockMetaList = result.meta;
        var buttonContainer = document.createElement("div");
        buttonContainer.style.cssText = "position:absolute;bottom:5px;left:0;right:0";
        // eslint-disable-next-line max-len
        var buttonStyle = "float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px";
        var closeButton = document.createElement("div");
        var refreshButton = document.createElement("div");
        buttonStyle += ";background-color:" + model.get("buttonColor");
        buttonStyle += ";color:" + model.get("buttonTextColor");
        var self = this;
        function close() {
            container.removeChild(root);
            self._dom = null;
        }
        (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(closeButton, "click", close);
        (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(refreshButton, "click", function() {
            if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
                close();
                return;
            }
            var newOption;
            try {
                if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(contentToOption)) newOption = contentToOption(viewMain, api.getOption());
                else newOption = $c28a86c6c47fb2f6$var$parseContents(textarea.value, blockMetaList);
            } catch (e) {
                close();
                throw new Error("Data view format error " + e);
            }
            if (newOption) api.dispatchAction({
                type: "changeDataView",
                newOption: newOption
            });
            close();
        });
        closeButton.innerHTML = lang[1];
        refreshButton.innerHTML = lang[2];
        refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
        !model.get("readOnly") && buttonContainer.appendChild(refreshButton);
        buttonContainer.appendChild(closeButton);
        root.appendChild(header);
        root.appendChild(viewMain);
        root.appendChild(buttonContainer);
        viewMain.style.height = container.clientHeight - 80 + "px";
        container.appendChild(root);
        this._dom = root;
    };
    DataView.prototype.remove = function(ecModel, api) {
        this._dom && api.getDom().removeChild(this._dom);
    };
    DataView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    DataView.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            readOnly: false,
            optionToContent: null,
            contentToOption: null,
            // eslint-disable-next-line
            icon: "M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "dataView",
                "title"
            ]),
            lang: ecModel.getLocaleModel().get([
                "toolbox",
                "dataView",
                "lang"
            ]),
            backgroundColor: "#fff",
            textColor: "#000",
            textareaColor: "#fff",
            textareaBorderColor: "#333",
            buttonColor: "#c23531",
            buttonTextColor: "#fff"
        };
        return defaultOption;
    };
    return DataView;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
/**
 * @inner
 */ function $c28a86c6c47fb2f6$var$tryMergeDataOption(newData, originalData) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(newData, function(newVal, idx) {
        var original = originalData && originalData[idx];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(original) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(original)) {
            var newValIsObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(newVal) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(newVal);
            if (!newValIsObject) newVal = {
                value: newVal
            };
            // original data has name but new data has no name
            var shouldDeleteName = original.name != null && newVal.name == null;
            // Original data has option
            newVal = $7a1bd9c2710fea0d$export$ebe90cb607ad99e(newVal, original);
            shouldDeleteName && delete newVal.name;
            return newVal;
        } else return newVal;
    });
}
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "changeDataView",
    event: "dataViewChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    var newSeriesOptList = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(payload.newOption.series, function(seriesOpt) {
        var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
        if (!seriesModel) // New created series
        // Geuss the series type
        newSeriesOptList.push($7a1bd9c2710fea0d$export$8b58be045bf06082({
            // Default is scatter
            type: "scatter"
        }, seriesOpt));
        else {
            var originalData = seriesModel.get("data");
            newSeriesOptList.push({
                name: seriesOpt.name,
                data: $c28a86c6c47fb2f6$var$tryMergeDataOption(seriesOpt.data, originalData)
            });
        }
    });
    ecModel.mergeOption($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        series: newSeriesOptList
    }, payload.newOption));
});
var $c28a86c6c47fb2f6$export$2e2bcd8739ae039 = $c28a86c6c47fb2f6$var$DataView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $61ea33782638ccd3$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $61ea33782638ccd3$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $61ea33782638ccd3$export$4cbf152802aa238(ecModel, newSnapshot) {
    var storedSnapshots = $61ea33782638ccd3$var$getStoreSnapshots(ecModel);
    // If previous dataZoom can not be found,
    // complete an range with current range.
    $61ea33782638ccd3$var$each(newSnapshot, function(batchItem, dataZoomId) {
        var i = storedSnapshots.length - 1;
        for(; i >= 0; i--){
            var snapshot = storedSnapshots[i];
            if (snapshot[dataZoomId]) break;
        }
        if (i < 0) {
            // No origin range set, create one by current range.
            var dataZoomModel = ecModel.queryComponents({
                mainType: "dataZoom",
                subType: "select",
                id: dataZoomId
            })[0];
            if (dataZoomModel) {
                var percentRange = dataZoomModel.getPercentRange();
                storedSnapshots[0][dataZoomId] = {
                    dataZoomId: dataZoomId,
                    start: percentRange[0],
                    end: percentRange[1]
                };
            }
        }
    });
    storedSnapshots.push(newSnapshot);
}
function $61ea33782638ccd3$export$3e41007ebfff0e64(ecModel) {
    var storedSnapshots = $61ea33782638ccd3$var$getStoreSnapshots(ecModel);
    var head = storedSnapshots[storedSnapshots.length - 1];
    storedSnapshots.length > 1 && storedSnapshots.pop();
    // Find top for all dataZoom.
    var snapshot = {};
    $61ea33782638ccd3$var$each(head, function(batchItem, dataZoomId) {
        for(var i = storedSnapshots.length - 1; i >= 0; i--){
            batchItem = storedSnapshots[i][dataZoomId];
            if (batchItem) {
                snapshot[dataZoomId] = batchItem;
                break;
            }
        }
    });
    return snapshot;
}
function $61ea33782638ccd3$export$42ffd38884aecdac(ecModel) {
    $61ea33782638ccd3$var$inner(ecModel).snapshots = null;
}
function $61ea33782638ccd3$export$85b9a36db797e02b(ecModel) {
    return $61ea33782638ccd3$var$getStoreSnapshots(ecModel).length;
}
/**
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 */ function $61ea33782638ccd3$var$getStoreSnapshots(ecModel) {
    var store = $61ea33782638ccd3$var$inner(ecModel);
    if (!store.snapshots) store.snapshots = [
        {}
    ];
    return store.snapshots;
}



var $5719d35bf0243166$var$RestoreOption = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(RestoreOption, _super);
    function RestoreOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestoreOption.prototype.onclick = function(ecModel, api) {
        $61ea33782638ccd3$export$42ffd38884aecdac(ecModel);
        api.dispatchAction({
            type: "restore",
            from: this.uid
        });
    };
    RestoreOption.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            // eslint-disable-next-line
            icon: "M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "restore",
                "title"
            ])
        };
        return defaultOption;
    };
    return RestoreOption;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "restore",
    event: "restore",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    ecModel.resetOption("recreate");
});
var $5719d35bf0243166$export$2e2bcd8739ae039 = $5719d35bf0243166$var$RestoreOption;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// FIXME
// how to genarialize to more coordinate systems.
var $6213fed8aa63fab1$var$INCLUDE_FINDER_MAIN_TYPES = [
    "grid",
    "xAxis",
    "yAxis",
    "geo",
    "graph",
    "polar",
    "radiusAxis",
    "angleAxis",
    "bmap"
];
var $6213fed8aa63fab1$var$BrushTargetManager = /** @class */ function() {
    /**
   * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
   *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
   * @param opt.include include coordinate system types.
   */ function BrushTargetManager(finder, ecModel, opt) {
        var _this = this;
        this._targetInfoList = [];
        var foundCpts = $6213fed8aa63fab1$var$parseFinder(ecModel, finder);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($6213fed8aa63fab1$var$targetInfoBuilders, function(builder, type) {
            if (!opt || !opt.include || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(opt.include, type) >= 0) builder(foundCpts, _this._targetInfoList);
        });
    }
    BrushTargetManager.prototype.setOutputRanges = function(areas, ecModel) {
        this.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            (area.coordRanges || (area.coordRanges = [])).push(coordRange);
            // area.coordRange is the first of area.coordRanges
            if (!area.coordRange) {
                area.coordRange = coordRange;
                // In 'category' axis, coord to pixel is not reversible, so we can not
                // rebuild range by coordRange accrately, which may bring trouble when
                // brushing only one item. So we use __rangeOffset to rebuilding range
                // by coordRange. And this it only used in brush component so it is no
                // need to be adapted to coordRanges.
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](0, coordSys, coordRange);
                area.__rangeOffset = {
                    offset: $6213fed8aa63fab1$var$diffProcessor[area.brushType](result.values, area.range, [
                        1,
                        1
                    ]),
                    xyMinMax: result.xyMinMax
                };
            }
        });
        return areas;
    };
    BrushTargetManager.prototype.matchOutputRanges = function(areas, ecModel, cb) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            if (targetInfo && targetInfo !== true) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(targetInfo.coordSyses, function(coordSys) {
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](1, coordSys, area.range, true);
                cb(area, result.values, coordSys, ecModel);
            });
        }, this);
    };
    /**
   * the `areas` is `BrushModel.areas`.
   * Called in layout stage.
   * convert `area.coordRange` to global range and set panelId to `area.range`.
   */ BrushTargetManager.prototype.setInputRanges = function(areas, ecModel) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            area.range = area.range || [];
            // convert coordRange to global range and set panelId.
            if (targetInfo && targetInfo !== true) {
                area.panelId = targetInfo.panelId;
                // (1) area.range should always be calculate from coordRange but does
                // not keep its original value, for the sake of the dataZoom scenario,
                // where area.coordRange remains unchanged but area.range may be changed.
                // (2) Only support converting one coordRange to pixel range in brush
                // component. So do not consider `coordRanges`.
                // (3) About __rangeOffset, see comment above.
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
                var rangeOffset = area.__rangeOffset;
                area.range = rangeOffset ? $6213fed8aa63fab1$var$diffProcessor[area.brushType](result.values, rangeOffset.offset, $6213fed8aa63fab1$var$getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
            }
        }, this);
    };
    BrushTargetManager.prototype.makePanelOpts = function(api, getDefaultBrushType) {
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(this._targetInfoList, function(targetInfo) {
            var rect = targetInfo.getPanelRect();
            return {
                panelId: targetInfo.panelId,
                defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
                clipPath: $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect),
                isTargetByCursor: $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, targetInfo.coordSysModel),
                getLinearBrushOtherExtent: $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect)
            };
        });
    };
    BrushTargetManager.prototype.controlSeries = function(area, seriesModel, ecModel) {
        // Check whether area is bound in coord, and series do not belong to that coord.
        // If do not do this check, some brush (like lineX) will controll all axes.
        var targetInfo = this.findTargetInfo(area, ecModel);
        return targetInfo === true || targetInfo && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
    };
    /**
   * If return Object, a coord found.
   * If return true, global found.
   * Otherwise nothing found.
   */ BrushTargetManager.prototype.findTargetInfo = function(area, ecModel) {
        var targetInfoList = this._targetInfoList;
        var foundCpts = $6213fed8aa63fab1$var$parseFinder(ecModel, area);
        for(var i = 0; i < targetInfoList.length; i++){
            var targetInfo = targetInfoList[i];
            var areaPanelId = area.panelId;
            if (areaPanelId) {
                if (targetInfo.panelId === areaPanelId) return targetInfo;
            } else for(var j = 0; j < $6213fed8aa63fab1$var$targetInfoMatchers.length; j++){
                if ($6213fed8aa63fab1$var$targetInfoMatchers[j](foundCpts, targetInfo)) return targetInfo;
            }
        }
        return true;
    };
    return BrushTargetManager;
}();
function $6213fed8aa63fab1$var$formatMinMax(minMax) {
    minMax[0] > minMax[1] && minMax.reverse();
    return minMax;
}
function $6213fed8aa63fab1$var$parseFinder(ecModel, finder) {
    return (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, finder, {
        includeMainTypes: $6213fed8aa63fab1$var$INCLUDE_FINDER_MAIN_TYPES
    });
}
var $6213fed8aa63fab1$var$targetInfoBuilders = {
    grid: function(foundCpts, targetInfoList) {
        var xAxisModels = foundCpts.xAxisModels;
        var yAxisModels = foundCpts.yAxisModels;
        var gridModels = foundCpts.gridModels;
        // Remove duplicated.
        var gridModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var xAxesHas = {};
        var yAxesHas = {};
        if (!xAxisModels && !yAxisModels && !gridModels) return;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(xAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(yAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            yAxesHas[gridModel.id] = true;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(gridModels, function(gridModel) {
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
            yAxesHas[gridModel.id] = true;
        });
        gridModelMap.each(function(gridModel) {
            var grid = gridModel.coordinateSystem;
            var cartesians = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(grid.getCartesians(), function(cartesian, index) {
                if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(xAxisModels, cartesian.getAxis("x").model) >= 0 || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(yAxisModels, cartesian.getAxis("y").model) >= 0) cartesians.push(cartesian);
            });
            targetInfoList.push({
                panelId: "grid--" + gridModel.id,
                gridModel: gridModel,
                coordSysModel: gridModel,
                // Use the first one as the representitive coordSys.
                coordSys: cartesians[0],
                coordSyses: cartesians,
                getPanelRect: $6213fed8aa63fab1$var$panelRectBuilders.grid,
                xAxisDeclared: xAxesHas[gridModel.id],
                yAxisDeclared: yAxesHas[gridModel.id]
            });
        });
    },
    geo: function(foundCpts, targetInfoList) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(foundCpts.geoModels, function(geoModel) {
            var coordSys = geoModel.coordinateSystem;
            targetInfoList.push({
                panelId: "geo--" + geoModel.id,
                geoModel: geoModel,
                coordSysModel: geoModel,
                coordSys: coordSys,
                coordSyses: [
                    coordSys
                ],
                getPanelRect: $6213fed8aa63fab1$var$panelRectBuilders.geo
            });
        });
    }
};
var $6213fed8aa63fab1$var$targetInfoMatchers = [
    // grid
    function(foundCpts, targetInfo) {
        var xAxisModel = foundCpts.xAxisModel;
        var yAxisModel = foundCpts.yAxisModel;
        var gridModel = foundCpts.gridModel;
        !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
        !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
        return gridModel && gridModel === targetInfo.gridModel;
    },
    // geo
    function(foundCpts, targetInfo) {
        var geoModel = foundCpts.geoModel;
        return geoModel && geoModel === targetInfo.geoModel;
    }
];
var $6213fed8aa63fab1$var$panelRectBuilders = {
    grid: function() {
        // grid is not Transformable.
        return this.coordSys.master.getRect().clone();
    },
    geo: function() {
        var coordSys = this.coordSys;
        var rect = coordSys.getBoundingRect().clone();
        // geo roam and zoom transform
        rect.applyTransform($5b455ae6f843ac47$export$fce0c6cfca85ed96(coordSys));
        return rect;
    }
};
var $6213fed8aa63fab1$var$coordConvert = {
    lineX: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisConvert, 0),
    lineY: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisConvert, 1),
    rect: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xminymin = to ? coordSys.pointToData([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp);
        var xmaxymax = to ? coordSys.pointToData([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp);
        var values = [
            $6213fed8aa63fab1$var$formatMinMax([
                xminymin[0],
                xmaxymax[0]
            ]),
            $6213fed8aa63fab1$var$formatMinMax([
                xminymin[1],
                xmaxymax[1]
            ])
        ];
        return {
            values: values,
            xyMinMax: values
        };
    },
    polygon: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xyMinMax = [
            [
                Infinity,
                -Infinity
            ],
            [
                Infinity,
                -Infinity
            ]
        ];
        var values = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(rangeOrCoordRange, function(item) {
            var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
            xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
            xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
            xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
            xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
            return p;
        });
        return {
            values: values,
            xyMinMax: xyMinMax
        };
    }
};
function $6213fed8aa63fab1$var$axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
    var axis = coordSys.getAxis([
        "x",
        "y"
    ][axisNameIndex]);
    var values = $6213fed8aa63fab1$var$formatMinMax((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)([
        0,
        1
    ], function(i) {
        return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
    }));
    var xyMinMax = [];
    xyMinMax[axisNameIndex] = values;
    xyMinMax[1 - axisNameIndex] = [
        NaN,
        NaN
    ];
    return {
        values: values,
        xyMinMax: xyMinMax
    };
}
var $6213fed8aa63fab1$var$diffProcessor = {
    lineX: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisDiffProcessor, 0),
    lineY: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisDiffProcessor, 1),
    rect: function(values, refer, scales) {
        return [
            [
                values[0][0] - scales[0] * refer[0][0],
                values[0][1] - scales[0] * refer[0][1]
            ],
            [
                values[1][0] - scales[1] * refer[1][0],
                values[1][1] - scales[1] * refer[1][1]
            ]
        ];
    },
    polygon: function(values, refer, scales) {
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(values, function(item, idx) {
            return [
                item[0] - scales[0] * refer[idx][0],
                item[1] - scales[1] * refer[idx][1]
            ];
        });
    }
};
function $6213fed8aa63fab1$var$axisDiffProcessor(axisNameIndex, values, refer, scales) {
    return [
        values[0] - scales[axisNameIndex] * refer[0],
        values[1] - scales[axisNameIndex] * refer[1]
    ];
}
// We have to process scale caused by dataZoom manually,
// although it might be not accurate.
// Return [0~1, 0~1]
function $6213fed8aa63fab1$var$getScales(xyMinMaxCurr, xyMinMaxOrigin) {
    var sizeCurr = $6213fed8aa63fab1$var$getSize(xyMinMaxCurr);
    var sizeOrigin = $6213fed8aa63fab1$var$getSize(xyMinMaxOrigin);
    var scales = [
        sizeCurr[0] / sizeOrigin[0],
        sizeCurr[1] / sizeOrigin[1]
    ];
    isNaN(scales[0]) && (scales[0] = 1);
    isNaN(scales[1]) && (scales[1] = 1);
    return scales;
}
function $6213fed8aa63fab1$var$getSize(xyMinMax) {
    return xyMinMax ? [
        xyMinMax[0][1] - xyMinMax[0][0],
        xyMinMax[1][1] - xyMinMax[1][0]
    ] : [
        NaN,
        NaN
    ];
}
var $6213fed8aa63fab1$export$2e2bcd8739ae039 = $6213fed8aa63fab1$var$BrushTargetManager;







var $d48e21e24ee5fc18$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $d48e21e24ee5fc18$var$DATA_ZOOM_ID_BASE = (0, $76d619f648247e6d$export$1753133c42e665e8)("toolbox-dataZoom_");
var $d48e21e24ee5fc18$var$ICON_TYPES = [
    "zoom",
    "back"
];
var $d48e21e24ee5fc18$var$DataZoomFeature = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DataZoomFeature, _super);
    function DataZoomFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataZoomFeature.prototype.render = function(featureModel, ecModel, api, payload) {
        if (!this._brushController) {
            this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr());
            this._brushController.on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this)).mount();
        }
        $d48e21e24ee5fc18$var$updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
        $d48e21e24ee5fc18$var$updateBackBtnStatus(featureModel, ecModel);
    };
    DataZoomFeature.prototype.onclick = function(ecModel, api, type) {
        $d48e21e24ee5fc18$var$handlers[type].call(this);
    };
    DataZoomFeature.prototype.remove = function(ecModel, api) {
        this._brushController && this._brushController.unmount();
    };
    DataZoomFeature.prototype.dispose = function(ecModel, api) {
        this._brushController && this._brushController.dispose();
    };
    DataZoomFeature.prototype._onBrush = function(eventParam) {
        var areas = eventParam.areas;
        if (!eventParam.isEnd || !areas.length) return;
        var snapshot = {};
        var ecModel = this.ecModel;
        this._brushController.updateCovers([]); // remove cover
        var brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)($d48e21e24ee5fc18$var$makeAxisFinder(this.model), ecModel, {
            include: [
                "grid"
            ]
        });
        brushTargetManager.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            if (coordSys.type !== "cartesian2d") return;
            var brushType = area.brushType;
            if (brushType === "rect") {
                setBatch("x", coordSys, coordRange[0]);
                setBatch("y", coordSys, coordRange[1]);
            } else setBatch({
                lineX: "x",
                lineY: "y"
            }[brushType], coordSys, coordRange);
        });
        $61ea33782638ccd3$export$4cbf152802aa238(ecModel, snapshot);
        this._dispatchZoomAction(snapshot);
        function setBatch(dimName, coordSys, minMax) {
            var axis = coordSys.getAxis(dimName);
            var axisModel = axis.model;
            var dataZoomModel = findDataZoom(dimName, axisModel, ecModel);
            // Restrict range.
            var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
            if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) minMax = (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
            dataZoomModel && (snapshot[dataZoomModel.id] = {
                dataZoomId: dataZoomModel.id,
                startValue: minMax[0],
                endValue: minMax[1]
            });
        }
        function findDataZoom(dimName, axisModel, ecModel) {
            var found;
            ecModel.eachComponent({
                mainType: "dataZoom",
                subType: "select"
            }, function(dzModel) {
                var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
                has && (found = dzModel);
            });
            return found;
        }
    };
    DataZoomFeature.prototype._dispatchZoomAction = function(snapshot) {
        var batch = [];
        // Convert from hash map to array.
        $d48e21e24ee5fc18$var$each(snapshot, function(batchItem, dataZoomId) {
            batch.push($7a1bd9c2710fea0d$export$9cd59f9826255e47(batchItem));
        });
        batch.length && this.api.dispatchAction({
            type: "dataZoom",
            from: this.uid,
            batch: batch
        });
    };
    DataZoomFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            filterMode: "filter",
            // Icon group
            icon: {
                zoom: "M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1",
                back: "M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26"
            },
            // `zoom`, `back`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "dataZoom",
                "title"
            ]),
            brushStyle: {
                borderWidth: 0,
                color: "rgba(210,219,238,0.2)"
            }
        };
        return defaultOption;
    };
    return DataZoomFeature;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $d48e21e24ee5fc18$var$handlers = {
    zoom: function() {
        var nextActive = !this._isZoomActive;
        this.api.dispatchAction({
            type: "takeGlobalCursor",
            key: "dataZoomSelect",
            dataZoomSelectActive: nextActive
        });
    },
    back: function() {
        this._dispatchZoomAction($61ea33782638ccd3$export$3e41007ebfff0e64(this.ecModel));
    }
};
function $d48e21e24ee5fc18$var$makeAxisFinder(dzFeatureModel) {
    var setting = {
        xAxisIndex: dzFeatureModel.get("xAxisIndex", true),
        yAxisIndex: dzFeatureModel.get("yAxisIndex", true),
        xAxisId: dzFeatureModel.get("xAxisId", true),
        yAxisId: dzFeatureModel.get("yAxisId", true)
    };
    // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
    // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
    // Some old cases set like this below to close yAxis control but leave xAxis control:
    // `{ feature: { dataZoom: { yAxisIndex: false } }`.
    if (setting.xAxisIndex == null && setting.xAxisId == null) setting.xAxisIndex = "all";
    if (setting.yAxisIndex == null && setting.yAxisId == null) setting.yAxisIndex = "all";
    return setting;
}
function $d48e21e24ee5fc18$var$updateBackBtnStatus(featureModel, ecModel) {
    featureModel.setIconStatus("back", $61ea33782638ccd3$export$85b9a36db797e02b(ecModel) > 1 ? "emphasis" : "normal");
}
function $d48e21e24ee5fc18$var$updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
    var zoomActive = view._isZoomActive;
    if (payload && payload.type === "takeGlobalCursor") zoomActive = payload.key === "dataZoomSelect" ? payload.dataZoomSelectActive : false;
    view._isZoomActive = zoomActive;
    featureModel.setIconStatus("zoom", zoomActive ? "emphasis" : "normal");
    var brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)($d48e21e24ee5fc18$var$makeAxisFinder(featureModel), ecModel, {
        include: [
            "grid"
        ]
    });
    var panels = brushTargetManager.makePanelOpts(api, function(targetInfo) {
        return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? "lineX" : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? "lineY" : "rect";
    });
    view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
        brushType: "auto",
        brushStyle: featureModel.getModel("brushStyle").getItemStyle()
    } : false);
}
(0, $a625fe571efb4064$export$5a90be4668898d38)("dataZoom", function(ecModel) {
    var toolboxModel = ecModel.getComponent("toolbox", 0);
    var featureDataZoomPath = [
        "feature",
        "dataZoom"
    ];
    if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) return;
    var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
    var dzOptions = [];
    var finder = $d48e21e24ee5fc18$var$makeAxisFinder(dzFeatureModel);
    var finderResult = (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, finder);
    $d48e21e24ee5fc18$var$each(finderResult.xAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, "xAxis", "xAxisIndex");
    });
    $d48e21e24ee5fc18$var$each(finderResult.yAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, "yAxis", "yAxisIndex");
    });
    function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
        var axisIndex = axisModel.componentIndex;
        var newOpt = {
            type: "select",
            $fromToolbox: true,
            // Default to be filter
            filterMode: dzFeatureModel.get("filterMode", true) || "filter",
            // Id for merge mapping.
            id: $d48e21e24ee5fc18$var$DATA_ZOOM_ID_BASE + axisMainType + axisIndex
        };
        newOpt[axisIndexPropName] = axisIndex;
        dzOptions.push(newOpt);
    }
    return dzOptions;
});
var $d48e21e24ee5fc18$export$2e2bcd8739ae039 = $d48e21e24ee5fc18$var$DataZoomFeature;


function $db487da8ce0e4ca6$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $f3a05ea4ae929f91$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e0876f124cc8d5c9$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("saveAsImage", (0, $1abd70fc7852729e$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("magicType", (0, $1a3c941566c70505$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("dataView", (0, $c28a86c6c47fb2f6$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("dataZoom", (0, $d48e21e24ee5fc18$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("restore", (0, $5719d35bf0243166$export$2e2bcd8739ae039));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $738a563bbc36032b$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $310c8e7a9655a722$var$TooltipModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = "tooltip";
    TooltipModel.dependencies = [
        "axisPointer"
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: "item",
        // 'click' | 'mousemove' | 'none'
        triggerOn: "mousemove|click",
        alwaysShowContent: false,
        displayMode: "single",
        renderMode: "auto",
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaut false (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        enterable: false,
        backgroundColor: "#fff",
        // box shadow
        shadowBlur: 10,
        shadowColor: "rgba(0, 0, 0, .2)",
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: "",
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: "line",
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: "auto",
            animation: "auto",
            animationDurationUpdate: 200,
            animationEasingUpdate: "exponentialOut",
            crossStyle: {
                color: "#999",
                width: 1,
                type: "dashed",
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: "#666",
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $310c8e7a9655a722$export$2e2bcd8739ae039 = $310c8e7a9655a722$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $c6d80cf697426e46$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get("confine");
    return confineOption != null ? !!confineOption : tooltipModel.get("renderMode") === "richText";
}
function $c6d80cf697426e46$var$testStyle(styleProps) {
    if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $c6d80cf697426e46$export$7b4286b1e4a23439 = $c6d80cf697426e46$var$testStyle([
    "transform",
    "webkitTransform",
    "OTransform",
    "MozTransform",
    "msTransform"
]);
var $c6d80cf697426e46$export$70a631ae991b5e76 = $c6d80cf697426e46$var$testStyle([
    "webkitTransition",
    "transition",
    "OTransition",
    "MozTransition",
    "msTransition"
]);
function $c6d80cf697426e46$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $c84c9521536c601a$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $c6d80cf697426e46$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $501187a7e974c4e1$var$CSS_TRANSITION_VENDOR = (0, $c6d80cf697426e46$export$5886acafe29a08d1)((0, $c6d80cf697426e46$export$70a631ae991b5e76), "transition");
var $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR = (0, $c6d80cf697426e46$export$5886acafe29a08d1)((0, $c6d80cf697426e46$export$7b4286b1e4a23439), "transform");
// eslint-disable-next-line
var $501187a7e974c4e1$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported ? "will-change:transform;" : "");
function $501187a7e974c4e1$var$mirrorPos(pos) {
    pos = pos === "left" ? "right" : pos === "right" ? "left" : pos === "top" ? "bottom" : "top";
    return pos;
}
function $501187a7e974c4e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowPosition) || arrowPosition === "inside") return "";
    var backgroundColor = tooltipModel.get("backgroundColor");
    var borderWidth = tooltipModel.get("borderWidth");
    borderColor = (0, $c84c9521536c601a$export$cda04d03233e5555)(borderColor);
    var arrowPos = $501187a7e974c4e1$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = "";
    var transformStyle = $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + ":";
    var rotateDeg;
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)([
        "left",
        "right"
    ], arrowPos) > -1) {
        positionStyle += "top:50%";
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === "left" ? -225 : -45) + "deg)";
    } else {
        positionStyle += "left:50%";
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === "top" ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return '<div style="' + styleCss.join("") + '"></div>';
}
function $501187a7e974c4e1$var$assembleTransition(duration, onlyFade) {
    var transitionCurve = "cubic-bezier(0.23,1,0.32,1)";
    var transitionOption = " " + duration / 2 + "s " + transitionCurve;
    var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    if (!onlyFade) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transformSupported ? "," + $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
    }
    return $501187a7e974c4e1$var$CSS_TRANSITION_VENDOR + ":" + transitionText;
}
function $501187a7e974c4e1$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + "px";
    var y0 = y.toFixed(0) + "px";
    // not support transform, use `left` and `top` instead.
    if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            "top",
            y0
        ],
        [
            "left",
            x0
        ]
    ];
    // support transform
    var is3d = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? "3d" : "") + "(" + x0 + "," + y0 + (is3d ? ",0" : "") + ")";
    return toString ? "top:0;left:0;" + $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + ":" + translate + ";" : [
        [
            "top",
            0
        ],
        [
            "left",
            0
        ],
        [
            (0, $c6d80cf697426e46$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $501187a7e974c4e1$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get("fontSize");
    var color = textStyleModel.getTextColor();
    color && cssText.push("color:" + color);
    cssText.push("font:" + textStyleModel.getFont());
    fontSize && cssText.push("line-height:" + Math.round(fontSize * 3 / 2) + "px");
    var shadowColor = textStyleModel.get("textShadowColor");
    var shadowBlur = textStyleModel.get("textShadowBlur") || 0;
    var shadowOffsetX = textStyleModel.get("textShadowOffsetX") || 0;
    var shadowOffsetY = textStyleModel.get("textShadowOffsetY") || 0;
    shadowColor && shadowBlur && cssText.push("text-shadow:" + shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "decoration",
        "align"
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push("text-" + name + ":" + val);
    });
    return cssText.join(";");
}
function $501187a7e974c4e1$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
    var cssText = [];
    var transitionDuration = tooltipModel.get("transitionDuration");
    var backgroundColor = tooltipModel.get("backgroundColor");
    var shadowBlur = tooltipModel.get("shadowBlur");
    var shadowColor = tooltipModel.get("shadowColor");
    var shadowOffsetX = tooltipModel.get("shadowOffsetX");
    var shadowOffsetY = tooltipModel.get("shadowOffsetY");
    var textStyleModel = tooltipModel.getModel("textStyle");
    var padding = (0, $d5ab84c08d6657ec$export$3048212c802df496)(tooltipModel, "html");
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push("box-shadow:" + boxShadow);
    // Animation transition. Do not animate when transitionDuration is 0.
    enableTransition && transitionDuration && cssText.push($501187a7e974c4e1$var$assembleTransition(transitionDuration, onlyFade));
    if (backgroundColor) cssText.push("background-color:" + backgroundColor);
    // Border style
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "width",
        "color",
        "radius"
    ], function(name) {
        var borderName = "border-" + name;
        var camelCase = (0, $c84c9521536c601a$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ":" + val + (name === "color" ? "" : "px"));
    });
    // Text style
    cssText.push($501187a7e974c4e1$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push("padding:" + (0, $c84c9521536c601a$export$f3a38102c49f4268)(padding).join("px ") + "px");
    return cssText.join(";") + ";";
}
// If not able to make, do not modify the input `out`.
function $501187a7e974c4e1$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $664e052f390bd76e$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $501187a7e974c4e1$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement("div");
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $7a1bd9c2710fea0d$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $501187a7e974c4e1$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $b3864a78637ff9ed$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch("mousemove", e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $c6d80cf697426e46$export$3735103072e4a80)(container, "position");
            var domStyle = container.style;
            if (domStyle.position !== "absolute" && position !== "absolute") domStyle.position = "relative";
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        // update className
        this.el.className = tooltipModel.get("className") || "";
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = "none";
        else style.cssText = $501187a7e974c4e1$var$gCssText + $501187a7e974c4e1$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) + $501187a7e974c4e1$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $c84c9521536c601a$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get("extraCssText") || "") + (";pointer-events:" + (this._enterable ? "auto" : "none"));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = "";
            return;
        }
        var arrow = "";
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get("trigger") === "item" && !(0, $c6d80cf697426e46$export$a309528050824ba4)(tooltipModel)) arrow = $501187a7e974c4e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = "";
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $7a1bd9c2710fea0d$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement("div");
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return [
            el.offsetWidth,
            el.offsetHeight
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        var styleCoord = this._styleCoord;
        $501187a7e974c4e1$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $501187a7e974c4e1$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        style.visibility = "hidden";
        style.opacity = "0";
        (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = "");
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var parentNode = this.el.parentNode;
        parentNode && parentNode.removeChild(this.el);
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $501187a7e974c4e1$export$2e2bcd8739ae039 = $501187a7e974c4e1$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $62f65ba5b769b0ae$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $62f65ba5b769b0ae$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(content)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)("");
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel("textStyle");
        this.el = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get("textShadowColor"),
                fill: tooltipModel.get([
                    "textStyle",
                    "color"
                ]),
                padding: (0, $d5ab84c08d6657ec$export$3048212c802df496)(tooltipModel, "richText"),
                verticalAlign: "top",
                align: "left"
            },
            z: tooltipModel.get("z")
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "backgroundColor",
            "borderRadius",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "textShadowBlur",
            "textShadowOffsetX",
            "textShadowOffsetY"
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on("mouseover", function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on("mouseout", function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $62f65ba5b769b0ae$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $62f65ba5b769b0ae$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $62f65ba5b769b0ae$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $62f65ba5b769b0ae$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($7a1bd9c2710fea0d$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $62f65ba5b769b0ae$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $62f65ba5b769b0ae$var$calcShadowOuterSize(style) {
    var shadowBlur = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $62f65ba5b769b0ae$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $62f65ba5b769b0ae$export$2e2bcd8739ae039 = $62f65ba5b769b0ae$var$TooltipRichContent;




















var $1b2ffe835052ab23$var$proxyRect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $1b2ffe835052ab23$var$TooltipView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent("tooltip");
        var renderMode = this._renderMode = (0, $76d619f648247e6d$export$cc0a17a5d27b4e17)(tooltipModel.get("renderMode"));
        this._tooltipContent = renderMode === "richText" ? new (0, $62f65ba5b769b0ae$export$2e2bcd8739ae039)(api) : new (0, $501187a7e974c4e1$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get("appendToBody", true) ? "body" : tooltipModel.get("appendTo", true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== "richText" && tooltipModel.get("transitionDuration")) (0, $c98659a9437a3d2e$export$958e3e1a02eac4b6)(this, "_updatePosition", 50, "fixRate");
        else (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_updatePosition");
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get("triggerOn");
        $84450f5aa7fbde00$export$6503ec6e8aabbaf("itemTooltip", this._api, (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none") {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === "leave") this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get("triggerOn");
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== "none" && triggerOn !== "click") {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $1b2ffe835052ab23$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = "";
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $1b2ffe835052ab23$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: "bottom"
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $1b2ffe835052ab23$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $4cab5d8b3532dad5$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: "bottom"
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: "updateAxisPointer",
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get("hideDelay"));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($1b2ffe835052ab23$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $1b2ffe835052ab23$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get("trigger") !== "axis") return;
        api.dispatchAction({
            type: "updateAxisPointer",
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === "legend") // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(target) {
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).dataIndex != null) {
                    seriesDispatcher_1 = target;
                    return true;
                }
                // Tooltip provided directly. Like legend.
                if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) {
                    cmptDispatcher_1 = target;
                    return true;
                }
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get("showDelay");
        cb = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $1b2ffe835052ab23$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + "Axis", axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                var axisValueLabel = $51dec70890757374$export$7cffee0f9aed39d0(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
                    header: axisValueLabel,
                    noHeader: !(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $2d646e51cc34f840$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker("item", (0, $c84c9521536c601a$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $655dd6075cc63601$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $1b2ffe835052ab23$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get("valueFormatter");
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get("order");
        var builtMarkupText = (0, $d5ab84c08d6657ec$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get("useUTC"), singleTooltipModel.get("textStyle"));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === "richText" ? "\n\n" : "<br/>";
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + "", point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $1b2ffe835052ab23$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get("trigger");
        if (tooltipTrigger != null && tooltipTrigger !== "item") return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker("item", (0, $c84c9521536c601a$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $655dd6075cc63601$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get("order");
        var valueFormatter = tooltipModel.get("valueFormatter");
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $d5ab84c08d6657ec$export$6969ffb02c1cb49a)(valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get("useUTC"), tooltipModel.get("textStyle")) : seriesTooltipResult.text;
        var asyncTicket = "item_" + dataModel.name + "_" + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: "showTip",
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $1b2ffe835052ab23$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get("content");
        var asyncTicket = Math.random() + "";
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(subTooltipModel.get("formatterParams") || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: "showTip",
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = "";
        if (!tooltipModel.get("showContent") || !tooltipModel.get("show")) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        var formatter = tooltipModel.get("formatter");
        positionExpr = positionExpr || tooltipModel.get("position");
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get("trigger"), tooltipModel.get("borderColor"));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get("useUTC");
                var params0 = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf("time") >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $0ae0381fb3fd176f$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $c84c9521536c601a$export$2028496a35766e41)(html, params, true);
            } else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
        if (trigger === "axis" || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || (this._renderMode === "html" ? "#fff" : "none")
        };
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get("position");
        var contentSize = content.getSize();
        var align = tooltipModel.get("align");
        var vAlign = tooltipModel.get("verticalAlign");
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $1b2ffe835052ab23$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get("borderWidth"));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $1b2ffe835052ab23$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $1b2ffe835052ab23$var$isCenterAlign(align) ? contentSize[0] / 2 : align === "right" ? contentSize[0] : 0);
        vAlign && (y -= $1b2ffe835052ab23$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === "bottom" ? contentSize[1] : 0);
        if ((0, $c6d80cf697426e46$export$a309528050824ba4)(tooltipModel)) {
            var pos = $1b2ffe835052ab23$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: "hideTip",
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_updatePosition");
        this._tooltipContent.dispose();
        $84450f5aa7fbde00$export$d07f55d4c15c0440("itemTooltip", api);
    };
    TooltipView.type = "tooltip";
    return TooltipView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $1b2ffe835052ab23$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $6818646a97528290$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get("tooltip", true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $1b2ffe835052ab23$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $1b2ffe835052ab23$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case "inside":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "top":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case "bottom":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case "left":
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "right":
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$isCenterAlign(align) {
    return align === "center" || align === "middle";
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $1b2ffe835052ab23$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $76d619f648247e6d$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === "series") return;
    var queryResult = (0, $76d619f648247e6d$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $1b2ffe835052ab23$export$2e2bcd8739ae039 = $1b2ffe835052ab23$var$TooltipView;



function $46e639bec576c55c$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $310c8e7a9655a722$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $1b2ffe835052ab23$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: "showTip",
        event: "showTip",
        update: "tooltip:manuallyShowTip"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "hideTip",
        event: "hideTip",
        update: "tooltip:manuallyHideTip"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $860dd9ca08385e85$var$DEFAULT_TOOLBOX_BTNS = [
    "rect",
    "polygon",
    "keep",
    "clear"
];
function $860dd9ca08385e85$export$2e2bcd8739ae039(option, isNew) {
    var brushComponents = (0, $76d619f648247e6d$export$4f07b212a02c8051)(option ? option.brush : []);
    if (!brushComponents.length) return;
    var brushComponentSpecifiedBtns = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(brushComponents, function(brushOpt) {
        var tbs = brushOpt.hasOwnProperty("toolbox") ? brushOpt.toolbox : [];
        if (tbs instanceof Array) brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    });
    var toolbox = option && option.toolbox;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(toolbox)) toolbox = toolbox[0];
    if (!toolbox) {
        toolbox = {
            feature: {}
        };
        option.toolbox = [
            toolbox
        ];
    }
    var toolboxFeature = toolbox.feature || (toolbox.feature = {});
    var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
    var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
    brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
    $860dd9ca08385e85$var$removeDuplicate(brushTypes);
    if (isNew && !brushTypes.length) brushTypes.push.apply(brushTypes, $860dd9ca08385e85$var$DEFAULT_TOOLBOX_BTNS);
}
function $860dd9ca08385e85$var$removeDuplicate(arr) {
    var map = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(arr, function(val) {
        map[val] = 1;
    });
    arr.length = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(map, function(flag, val) {
        arr.push(val);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual solution, for consistent option specification.
 */ 


var $87ea23222d1c134e$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $87ea23222d1c134e$var$hasKeys(obj) {
    if (obj) for(var name_1 in obj){
        if (obj.hasOwnProperty(name_1)) return true;
    }
}
function $87ea23222d1c134e$export$89974527642f24a0(option, stateList, supplementVisualOption) {
    var visualMappings = {};
    $87ea23222d1c134e$var$each(stateList, function(state) {
        var mappings = visualMappings[state] = createMappings();
        $87ea23222d1c134e$var$each(option[state], function(visualData, visualType) {
            if (!(0, $7b50f502cfd189d5$export$2e2bcd8739ae039).isValidType(visualType)) return;
            var mappingOption = {
                type: visualType,
                visual: visualData
            };
            supplementVisualOption && supplementVisualOption(mappingOption, state);
            mappings[visualType] = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(mappingOption);
            // Prepare a alpha for opacity, for some case that opacity
            // is not supported, such as rendering using gradient color.
            if (visualType === "opacity") {
                mappingOption = $7a1bd9c2710fea0d$export$9cd59f9826255e47(mappingOption);
                mappingOption.type = "colorAlpha";
                mappings.__hidden.__alphaForOpacity = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(mappingOption);
            }
        });
    });
    return visualMappings;
    function createMappings() {
        var Creater = function() {};
        // Make sure hidden fields will not be visited by
        // object iteration (with hasOwnProperty checking).
        Creater.prototype.__hidden = Creater.prototype;
        var obj = new Creater();
        return obj;
    }
}
function $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, keys) {
    // Visual attributes merge is not supported, otherwise it
    // brings overcomplicated merge logic. See #2853. So if
    // newOption has anyone of these keys, all of these keys
    // will be reset. Otherwise, all keys remain.
    var has;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $87ea23222d1c134e$var$hasKeys(newOption[key])) has = true;
    });
    has && $7a1bd9c2710fea0d$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $87ea23222d1c134e$var$hasKeys(newOption[key])) thisOption[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(newOption[key]);
        else delete thisOption[key];
    });
}
function $87ea23222d1c134e$export$bb1ef43951d58629(stateList, visualMappings, data, getValueState, scope, dimension) {
    var visualTypesMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    var dataIndex;
    function getVisual(key) {
        return (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndex, key);
    }
    function setVisual(key, value) {
        (0, $ea13f1ab2169d82d$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
    }
    if (dimension == null) data.each(eachItem);
    else data.each([
        dimension
    ], eachItem);
    function eachItem(valueOrIndex, index) {
        dataIndex = dimension == null ? valueOrIndex // First argument is index
         : index;
        var rawDataItem = data.getRawDataItem(dataIndex);
        // Consider performance
        // @ts-ignore
        if (rawDataItem && rawDataItem.visualMap === false) return;
        var valueState = getValueState.call(scope, valueOrIndex);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];
        for(var i = 0, len = visualTypes.length; i < len; i++){
            var type = visualTypes[i];
            mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
        }
    }
}
function $87ea23222d1c134e$export$fc0ef8703cccf128(stateList, visualMappings, getValueState, dim) {
    var visualTypesMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    return {
        progress: function progress(params, data) {
            var dimIndex;
            if (dim != null) dimIndex = data.getDimensionIndex(dim);
            function getVisual(key) {
                return (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndex, key);
            }
            function setVisual(key, value) {
                (0, $ea13f1ab2169d82d$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
            }
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var rawDataItem = data.getRawDataItem(dataIndex);
                // Consider performance
                // @ts-ignore
                if (rawDataItem && rawDataItem.visualMap === false) continue;
                var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
                var valueState = getValueState(value);
                var mappings = visualMappings[valueState];
                var visualTypes = visualTypesMap[valueState];
                for(var i = 0, len = visualTypes.length; i < len; i++){
                    var type = visualTypes[i];
                    mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $431fae42b264171b$export$2225cfa0a999c142(area) {
    var brushType = area.brushType;
    // Do not use function binding or curry for performance.
    var selectors = {
        point: function(itemLayout) {
            return $431fae42b264171b$var$selector[brushType].point(itemLayout, selectors, area);
        },
        rect: function(itemLayout) {
            return $431fae42b264171b$var$selector[brushType].rect(itemLayout, selectors, area);
        }
    };
    return selectors;
}
var $431fae42b264171b$var$selector = {
    lineX: $431fae42b264171b$var$getLineSelectors(0),
    lineY: $431fae42b264171b$var$getLineSelectors(1),
    rect: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.intersect(itemLayout);
        }
    },
    polygon: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && $b4726ec5f917394d$export$8893e2b90ba10d92(area.range, itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            var points = area.range;
            if (!itemLayout || points.length <= 1) return false;
            var x = itemLayout.x;
            var y = itemLayout.y;
            var width = itemLayout.width;
            var height = itemLayout.height;
            var p = points[0];
            if ($b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x + width, y) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y + height) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x + width, y + height) || (0, $1bebe7106c895823$export$2e2bcd8739ae039).create(itemLayout).contain(p[0], p[1]) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y, x + width, y, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y, x, y + height, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x + width, y, x + width, y + height, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y + height, x + width, y + height, points)) return true;
        }
    }
};
function $431fae42b264171b$var$getLineSelectors(xyIndex) {
    var xy = [
        "x",
        "y"
    ];
    var wh = [
        "width",
        "height"
    ];
    return {
        point: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var p = itemLayout[xyIndex];
                return $431fae42b264171b$var$inLineRange(p, range);
            }
        },
        rect: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var layoutRange = [
                    itemLayout[xy[xyIndex]],
                    itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]
                ];
                layoutRange[1] < layoutRange[0] && layoutRange.reverse();
                return $431fae42b264171b$var$inLineRange(layoutRange[0], range) || $431fae42b264171b$var$inLineRange(layoutRange[1], range) || $431fae42b264171b$var$inLineRange(range[0], layoutRange) || $431fae42b264171b$var$inLineRange(range[1], layoutRange);
            }
        }
    };
}
function $431fae42b264171b$var$inLineRange(p, range) {
    return range[0] <= p && p <= range[1];
}
var $431fae42b264171b$export$2e2bcd8739ae039 = $431fae42b264171b$var$selector;




var $8c565e07fd43a6ee$var$STATE_LIST = [
    "inBrush",
    "outOfBrush"
];
var $8c565e07fd43a6ee$var$DISPATCH_METHOD = "__ecBrushSelect";
var $8c565e07fd43a6ee$var$DISPATCH_FLAG = "__ecInBrushSelectEvent";
function $8c565e07fd43a6ee$export$ead1205d8c0d8375(ecModel) {
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        var brushTargetManager = brushModel.brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)(brushModel.option, ecModel);
        brushTargetManager.setInputRanges(brushModel.areas, ecModel);
    });
}
function $8c565e07fd43a6ee$export$2e2bcd8739ae039(ecModel, api, payload) {
    var brushSelected = [];
    var throttleType;
    var throttleDelay;
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        payload && payload.type === "takeGlobalCursor" && brushModel.setBrushOption(payload.key === "brush" ? payload.brushOption : {
            brushType: false
        });
    });
    $8c565e07fd43a6ee$export$ead1205d8c0d8375(ecModel);
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel, brushIndex) {
        var thisBrushSelected = {
            brushId: brushModel.id,
            brushIndex: brushIndex,
            brushName: brushModel.name,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(brushModel.areas),
            selected: []
        };
        // Every brush component exists in event params, convenient
        // for user to find by index.
        brushSelected.push(thisBrushSelected);
        var brushOption = brushModel.option;
        var brushLink = brushOption.brushLink;
        var linkedSeriesMap = [];
        var selectedDataIndexForLink = [];
        var rangeInfoBySeries = [];
        var hasBrushExists = false;
        if (!brushIndex) {
            // Only the first throttle setting works.
            throttleType = brushOption.throttleType;
            throttleDelay = brushOption.throttleDelay;
        }
        // Add boundingRect and selectors to range.
        var areas = $7a1bd9c2710fea0d$export$871de8747c9eaa88(brushModel.areas, function(area) {
            var builder = $8c565e07fd43a6ee$var$boundingRectBuilders[area.brushType];
            var selectableArea = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                boundingRect: builder ? builder(area) : void 0
            }, area);
            selectableArea.selectors = (0, $431fae42b264171b$export$2225cfa0a999c142)(selectableArea);
            return selectableArea;
        });
        var visualMappings = $87ea23222d1c134e$export$89974527642f24a0(brushModel.option, $8c565e07fd43a6ee$var$STATE_LIST, function(mappingOption) {
            mappingOption.mappingMethod = "fixed";
        });
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(brushLink) && $7a1bd9c2710fea0d$export$79b2f7037acddd43(brushLink, function(seriesIndex) {
            linkedSeriesMap[seriesIndex] = 1;
        });
        function linkOthers(seriesIndex) {
            return brushLink === "all" || !!linkedSeriesMap[seriesIndex];
        }
        // If no supported brush or no brush on the series,
        // all visuals should be in original state.
        function brushed(rangeInfoList) {
            return !!rangeInfoList.length;
        }
        /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */ // Step A
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
            seriesModel.subType === "parallel" ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
        });
        function stepAParallel(seriesModel, seriesIndex) {
            var coordSys = seriesModel.coordinateSystem;
            hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
            linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function(activeState, dataIndex) {
                activeState === "active" && (selectedDataIndexForLink[dataIndex] = 1);
            });
        }
        function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
            if (!seriesModel.brushSelector || $8c565e07fd43a6ee$var$brushModelNotControll(brushModel, seriesIndex)) return;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(areas, function(area) {
                if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) rangeInfoList.push(area);
                hasBrushExists = hasBrushExists || brushed(rangeInfoList);
            });
            if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
                var data_1 = seriesModel.getData();
                data_1.each(function(dataIndex) {
                    if ($8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) selectedDataIndexForLink[dataIndex] = 1;
                });
            }
        }
        // Step B
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var seriesBrushSelected = {
                seriesId: seriesModel.id,
                seriesIndex: seriesIndex,
                seriesName: seriesModel.name,
                dataIndex: []
            };
            // Every series exists in event params, convenient
            // for user to find series by seriesIndex.
            thisBrushSelected.selected.push(seriesBrushSelected);
            var rangeInfoList = rangeInfoBySeries[seriesIndex];
            var data = seriesModel.getData();
            var getValueState = linkOthers(seriesIndex) ? function(dataIndex) {
                return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), "inBrush") : "outOfBrush";
            } : function(dataIndex) {
                return $8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), "inBrush") : "outOfBrush";
            };
            // If no supported brush or no brush, all visuals are in original state.
            (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && $87ea23222d1c134e$export$bb1ef43951d58629($8c565e07fd43a6ee$var$STATE_LIST, visualMappings, data, getValueState);
        });
    });
    $8c565e07fd43a6ee$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
}
function $8c565e07fd43a6ee$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
    // This event will not be triggered when `setOpion`, otherwise dead lock may
    // triggered when do `setOption` in event listener, which we do not find
    // satisfactory way to solve yet. Some considered resolutions:
    // (a) Diff with prevoius selected data ant only trigger event when changed.
    // But store previous data and diff precisely (i.e., not only by dataIndex, but
    // also detect value changes in selected data) might bring complexity or fragility.
    // (b) Use spectial param like `silent` to suppress event triggering.
    // But such kind of volatile param may be weird in `setOption`.
    if (!payload) return;
    var zr = api.getZr();
    if (zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG]) return;
    if (!zr[$8c565e07fd43a6ee$var$DISPATCH_METHOD]) zr[$8c565e07fd43a6ee$var$DISPATCH_METHOD] = $8c565e07fd43a6ee$var$doDispatch;
    var fn = $c98659a9437a3d2e$export$958e3e1a02eac4b6(zr, $8c565e07fd43a6ee$var$DISPATCH_METHOD, throttleDelay, throttleType);
    fn(api, brushSelected);
}
function $8c565e07fd43a6ee$var$doDispatch(api, brushSelected) {
    if (!api.isDisposed()) {
        var zr = api.getZr();
        zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG] = true;
        api.dispatchAction({
            type: "brushSelect",
            batch: brushSelected
        });
        zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG] = false;
    }
}
function $8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
    for(var i = 0, len = rangeInfoList.length; i < len; i++){
        var area = rangeInfoList[i];
        if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) return true;
    }
}
function $8c565e07fd43a6ee$var$brushModelNotControll(brushModel, seriesIndex) {
    var seriesIndices = brushModel.option.seriesIndex;
    return seriesIndices != null && seriesIndices !== "all" && ($7a1bd9c2710fea0d$export$43bee75e5e14138e(seriesIndices) ? $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}
var $8c565e07fd43a6ee$var$boundingRectBuilders = {
    rect: function(area) {
        return $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(area.range);
    },
    polygon: function(area) {
        var minMax;
        var range = area.range;
        for(var i = 0, len = range.length; i < len; i++){
            minMax = minMax || [
                [
                    Infinity,
                    -Infinity
                ],
                [
                    Infinity,
                    -Infinity
                ]
            ];
            var rg = range[i];
            rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
            rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
            rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
            rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
        }
        return minMax && $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(minMax);
    }
};
function $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(minMax) {
    return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}



var $b3094615d1ff0264$var$BrushView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BrushView, _super);
    function BrushView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushView.type;
        return _this;
    }
    BrushView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
        this.model;
        (this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr())).on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this)).mount();
    };
    BrushView.prototype.render = function(brushModel, ecModel, api, payload) {
        this.model = brushModel;
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateTransform = function(brushModel, ecModel, api, payload) {
        // PENDING: `updateTransform` is a little tricky, whose layout need
        // to be calculate mandatorily and other stages will not be performed.
        // Take care the correctness of the logic. See #11754 .
        (0, $8c565e07fd43a6ee$export$ead1205d8c0d8375)(ecModel);
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateVisual = function(brushModel, ecModel, api, payload) {
        this.updateTransform(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateView = function(brushModel, ecModel, api, payload) {
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype._updateController = function(brushModel, ecModel, api, payload) {
        // Do not update controller when drawing.
        (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
    };
    // updateLayout: updateController,
    // updateVisual: updateController,
    BrushView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    BrushView.prototype._onBrush = function(eventParam) {
        var modelId = this.model.id;
        var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel);
        // Action is not dispatched on drag end, because the drag end
        // emits the same params with the last drag move event, and
        // may have some delay when using touch pad, which makes
        // animation not smooth (when using debounce).
        (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
            type: "brush",
            brushId: modelId,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(areas),
            $from: modelId
        });
        eventParam.isEnd && this.api.dispatchAction({
            type: "brushEnd",
            brushId: modelId,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(areas),
            $from: modelId
        });
    };
    BrushView.type = "brush";
    return BrushView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $b3094615d1ff0264$export$2e2bcd8739ae039 = $b3094615d1ff0264$var$BrushView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $c309289727ee7770$var$DEFAULT_OUT_OF_BRUSH_COLOR = "#ddd";
var $c309289727ee7770$var$BrushModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BrushModel, _super);
    function BrushModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushModel.type;
        /**
     * @readOnly
     */ _this.areas = [];
        /**
     * Current brush painting area settings.
     * @readOnly
     */ _this.brushOption = {};
        return _this;
    }
    BrushModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, [
            "inBrush",
            "outOfBrush"
        ]);
        var inBrush = thisOption.inBrush = thisOption.inBrush || {};
        // Always give default visual, consider setOption at the second time.
        thisOption.outOfBrush = thisOption.outOfBrush || {
            color: $c309289727ee7770$var$DEFAULT_OUT_OF_BRUSH_COLOR
        };
        if (!inBrush.hasOwnProperty("liftZ")) // Bigger than the highlight z lift, otherwise it will
        // be effected by the highlight z when brush.
        inBrush.liftZ = 5;
    };
    /**
   * If `areas` is null/undefined, range state remain.
   */ BrushModel.prototype.setAreas = function(areas) {
        // If areas is null/undefined, range state remain.
        // This helps user to dispatchAction({type: 'brush'}) with no areas
        // set but just want to get the current brush select info from a `brush` event.
        if (!areas) return;
        this.areas = $7a1bd9c2710fea0d$export$871de8747c9eaa88(areas, function(area) {
            return $c309289727ee7770$var$generateBrushOption(this.option, area);
        }, this);
    };
    /**
   * Set the current painting brush option.
   */ BrushModel.prototype.setBrushOption = function(brushOption) {
        this.brushOption = $c309289727ee7770$var$generateBrushOption(this.option, brushOption);
        this.brushType = this.brushOption.brushType;
    };
    BrushModel.type = "brush";
    BrushModel.dependencies = [
        "geo",
        "grid",
        "xAxis",
        "yAxis",
        "parallel",
        "series"
    ];
    BrushModel.defaultOption = {
        seriesIndex: "all",
        brushType: "rect",
        brushMode: "single",
        transformable: true,
        brushStyle: {
            borderWidth: 1,
            color: "rgba(210,219,238,0.3)",
            borderColor: "#D2DBEE"
        },
        throttleType: "fixRate",
        throttleDelay: 0,
        removeOnClick: true,
        z: 10000
    };
    return BrushModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
function $c309289727ee7770$var$generateBrushOption(option, brushOption) {
    return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
        brushType: option.brushType,
        brushMode: option.brushMode,
        transformable: option.transformable,
        brushStyle: new (0, $6818646a97528290$export$2e2bcd8739ae039)(option.brushStyle).getItemStyle(),
        removeOnClick: option.removeOnClick,
        z: option.z
    }, brushOption, true);
}
var $c309289727ee7770$export$2e2bcd8739ae039 = $c309289727ee7770$var$BrushModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $0ea8e48a326f7b6d$var$ICON_TYPES = [
    "rect",
    "polygon",
    "lineX",
    "lineY",
    "keep",
    "clear"
];
var $0ea8e48a326f7b6d$var$BrushFeature = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BrushFeature, _super);
    function BrushFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrushFeature.prototype.render = function(featureModel, ecModel, api) {
        var brushType;
        var brushMode;
        var isBrushed;
        ecModel.eachComponent({
            mainType: "brush"
        }, function(brushModel) {
            brushType = brushModel.brushType;
            brushMode = brushModel.brushOption.brushMode || "single";
            isBrushed = isBrushed || !!brushModel.areas.length;
        });
        this._brushType = brushType;
        this._brushMode = brushMode;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(featureModel.get("type", true), function(type) {
            featureModel.setIconStatus(type, (type === "keep" ? brushMode === "multiple" : type === "clear" ? isBrushed : type === brushType) ? "emphasis" : "normal");
        });
    };
    BrushFeature.prototype.updateView = function(featureModel, ecModel, api) {
        this.render(featureModel, ecModel, api);
    };
    BrushFeature.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get("icon", true);
        var icons = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("type", true), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    BrushFeature.prototype.onclick = function(ecModel, api, type) {
        var brushType = this._brushType;
        var brushMode = this._brushMode;
        if (type === "clear") {
            // Trigger parallel action firstly
            api.dispatchAction({
                type: "axisAreaSelect",
                intervals: []
            });
            api.dispatchAction({
                type: "brush",
                command: "clear",
                // Clear all areas of all brush components.
                areas: []
            });
        } else api.dispatchAction({
            type: "takeGlobalCursor",
            key: "brush",
            brushOption: {
                brushType: type === "keep" ? brushType : brushType === type ? false : type,
                brushMode: type === "keep" ? brushMode === "multiple" ? "single" : "multiple" : brushMode
            }
        });
    };
    BrushFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: $0ea8e48a326f7b6d$var$ICON_TYPES.slice(),
            icon: {
                /* eslint-disable */ rect: "M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13",
                polygon: "M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2",
                lineX: "M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4",
                lineY: "M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4",
                keep: "M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z",
                clear: "M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2" // jshint ignore:line
            },
            // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "brush",
                "title"
            ])
        };
        return defaultOption;
    };
    return BrushFeature;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $0ea8e48a326f7b6d$export$2e2bcd8739ae039 = $0ea8e48a326f7b6d$var$BrushFeature;




function $e97a928e0b93a54f$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $b3094615d1ff0264$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $c309289727ee7770$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $860dd9ca08385e85$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $8c565e07fd43a6ee$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "brush",
        event: "brush",
        update: "updateVisual"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "brush",
            query: payload
        }, function(brushModel) {
            brushModel.setAreas(payload.areas);
        });
    });
    /**
   * payload: {
   *      brushComponents: [
   *          {
   *              brushId,
   *              brushIndex,
   *              brushName,
   *              series: [
   *                  {
   *                      seriesId,
   *                      seriesIndex,
   *                      seriesName,
   *                      rawIndices: [21, 34, ...]
   *                  },
   *                  ...
   *              ]
   *          },
   *          ...
   *      ]
   * }
   */ registers.registerAction({
        type: "brushSelect",
        event: "brushSelected",
        update: "none"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "brushEnd",
        event: "brushEnd",
        update: "none"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("brush", (0, $0ea8e48a326f7b6d$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $66707465bee49836$var$TitleModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: "box",
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = "title";
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: "",
        target: "blank",
        subtext: "",
        subtarget: "blank",
        left: 0,
        top: 0,
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: "bold",
            color: "#464646"
        },
        subtextStyle: {
            fontSize: 12,
            color: "#6E7079"
        }
    };
    return TitleModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
// View
var $66707465bee49836$var$TitleView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get("show")) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel("textStyle");
        var subtextStyleModel = titleModel.getModel("subtextStyle");
        var textAlign = titleModel.get("textAlign");
        var textVerticalAlign = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(titleModel.get("textBaseline"), titleModel.get("textVerticalAlign"));
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: titleModel.get("text"),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get("subtext");
        var subTextEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get("itemGap"),
                verticalAlign: "top"
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get("link");
        var sublink = titleModel.get("sublink");
        var triggerEvent = titleModel.get("triggerEvent", true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on("click", function() {
            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, "_" + titleModel.get("target"));
        });
        if (sublink) subTextEl.on("click", function() {
            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(sublink, "_" + titleModel.get("subtarget"));
        });
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(subTextEl).eventData = triggerEvent ? {
            componentType: "title",
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(layoutOption, {
            width: api.getWidth(),
            height: api.getHeight()
        }, titleModel.get("padding"));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get("left") || titleModel.get("right");
            // @ts-ignore
            if (textAlign === "middle") textAlign = "center";
            // Adjust layout by text align
            if (textAlign === "right") layoutRect.x += layoutRect.width;
            else if (textAlign === "center") layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get("top") || titleModel.get("bottom");
            // @ts-ignore
            if (textVerticalAlign === "center") textVerticalAlign = "middle";
            if (textVerticalAlign === "bottom") layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === "middle") layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || "top";
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            "color",
            "opacity"
        ]);
        style.fill = titleModel.get("backgroundColor");
        var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get("borderRadius")
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = "title";
    return TitleView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $66707465bee49836$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($66707465bee49836$var$TitleModel);
    registers.registerComponentView($66707465bee49836$var$TitleView);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0a5c39a9e7129dc4$var$TimelineModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TimelineModel, _super);
    function TimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineModel.type;
        _this.layoutMode = "box";
        return _this;
    }
    /**
   * @override
   */ TimelineModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._initData();
    };
    /**
   * @override
   */ TimelineModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this._initData();
    };
    TimelineModel.prototype.setCurrentIndex = function(currentIndex) {
        if (currentIndex == null) currentIndex = this.option.currentIndex;
        var count = this._data.count();
        if (this.option.loop) currentIndex = (currentIndex % count + count) % count;
        else {
            currentIndex >= count && (currentIndex = count - 1);
            currentIndex < 0 && (currentIndex = 0);
        }
        this.option.currentIndex = currentIndex;
    };
    /**
   * @return {number} currentIndex
   */ TimelineModel.prototype.getCurrentIndex = function() {
        return this.option.currentIndex;
    };
    /**
   * @return {boolean}
   */ TimelineModel.prototype.isIndexMax = function() {
        return this.getCurrentIndex() >= this._data.count() - 1;
    };
    /**
   * @param {boolean} state true: play, false: stop
   */ TimelineModel.prototype.setPlayState = function(state) {
        this.option.autoPlay = !!state;
    };
    /**
   * @return {boolean} true: play, false: stop
   */ TimelineModel.prototype.getPlayState = function() {
        return !!this.option.autoPlay;
    };
    /**
   * @private
   */ TimelineModel.prototype._initData = function() {
        var thisOption = this.option;
        var dataArr = thisOption.data || [];
        var axisType = thisOption.axisType;
        var names = this._names = [];
        var processedDataArr;
        if (axisType === "category") {
            processedDataArr = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataArr, function(item, index) {
                var value = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)((0, $76d619f648247e6d$export$2c944e12edb48d4b)(item), "");
                var newItem;
                if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item)) {
                    newItem = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
                    newItem.value = index;
                } else newItem = index;
                processedDataArr.push(newItem);
                names.push(value);
            });
        } else processedDataArr = dataArr;
        var dimType = {
            category: "ordinal",
            time: "time",
            value: "number"
        }[axisType] || "number";
        var data = this._data = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            {
                name: "value",
                type: dimType
            }
        ], this);
        data.initData(processedDataArr, names);
    };
    TimelineModel.prototype.getData = function() {
        return this._data;
    };
    /**
   * @public
   * @return {Array.<string>} categoreis
   */ TimelineModel.prototype.getCategories = function() {
        if (this.get("axisType") === "category") return this._names.slice();
    };
    TimelineModel.type = "timeline";
    /**
   * @protected
   */ TimelineModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 4,
        show: true,
        axisType: "time",
        realtime: true,
        left: "20%",
        top: null,
        right: "20%",
        bottom: 0,
        width: null,
        height: 40,
        padding: 5,
        controlPosition: "left",
        autoPlay: false,
        rewind: false,
        loop: true,
        playInterval: 2000,
        currentIndex: 0,
        itemStyle: {},
        label: {
            color: "#000"
        },
        data: []
    };
    return TimelineModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $0a5c39a9e7129dc4$export$2e2bcd8739ae039 = $0a5c39a9e7129dc4$var$TimelineModel;





var $22b93c2a0cce341f$var$SliderTimelineModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SliderTimelineModel, _super);
    function SliderTimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineModel.type;
        return _this;
    }
    SliderTimelineModel.type = "timeline.slider";
    /**
   * @protected
   */ SliderTimelineModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $0a5c39a9e7129dc4$export$2e2bcd8739ae039).defaultOption, {
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderWidth: 0,
        orient: "horizontal",
        inverse: false,
        tooltip: {
            trigger: "item" // data item may also have tootip attr.
        },
        symbol: "circle",
        symbolSize: 12,
        lineStyle: {
            show: true,
            width: 2,
            color: "#DAE1F5"
        },
        label: {
            position: "auto",
            // When using number, label position is not
            // restricted by viewRect.
            // positive: right/bottom, negative: left/top
            show: true,
            interval: "auto",
            rotate: 0,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "#A4B1D7"
        },
        itemStyle: {
            color: "#A4B1D7",
            borderWidth: 1
        },
        checkpointStyle: {
            symbol: "circle",
            symbolSize: 15,
            color: "#316bf3",
            borderColor: "#fff",
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: "rgba(0, 0, 0, 0.3)",
            // borderColor: 'rgba(194,53,49, 0.5)',
            animation: true,
            animationDuration: 300,
            animationEasing: "quinticInOut"
        },
        controlStyle: {
            show: true,
            showPlayBtn: true,
            showPrevBtn: true,
            showNextBtn: true,
            itemSize: 24,
            itemGap: 12,
            position: "left",
            playIcon: "path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z",
            stopIcon: "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z",
            // eslint-disable-next-line max-len
            nextIcon: "M2,18.5A1.52,1.52,0,0,1,.92,18a1.49,1.49,0,0,1,0-2.12L7.81,9.36,1,3.11A1.5,1.5,0,1,1,3,.89l8,7.34a1.48,1.48,0,0,1,.49,1.09,1.51,1.51,0,0,1-.46,1.1L3,18.08A1.5,1.5,0,0,1,2,18.5Z",
            // eslint-disable-next-line max-len
            prevIcon: "M10,.5A1.52,1.52,0,0,1,11.08,1a1.49,1.49,0,0,1,0,2.12L4.19,9.64,11,15.89a1.5,1.5,0,1,1-2,2.22L1,10.77A1.48,1.48,0,0,1,.5,9.68,1.51,1.51,0,0,1,1,8.58L9,.92A1.5,1.5,0,0,1,10,.5Z",
            prevBtnSize: 18,
            nextBtnSize: 18,
            color: "#A4B1D7",
            borderColor: "#A4B1D7",
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true,
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: "#6f778d"
            },
            itemStyle: {
                color: "#316BF3"
            },
            controlStyle: {
                color: "#316BF3",
                borderColor: "#316BF3",
                borderWidth: 2
            }
        },
        progress: {
            lineStyle: {
                color: "#316BF3"
            },
            itemStyle: {
                color: "#316BF3"
            },
            label: {
                color: "#6f778d"
            }
        },
        data: []
    });
    return SliderTimelineModel;
}((0, $0a5c39a9e7129dc4$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($22b93c2a0cce341f$var$SliderTimelineModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype);
var $22b93c2a0cce341f$export$2e2bcd8739ae039 = $22b93c2a0cce341f$var$SliderTimelineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $79b71ced407c5926$var$TimelineView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TimelineView, _super);
    function TimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineView.type;
        return _this;
    }
    TimelineView.type = "timeline";
    return TimelineView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $79b71ced407c5926$export$2e2bcd8739ae039 = $79b71ced407c5926$var$TimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Extend axis 2d
 */ var $d38633a847120ec8$var$TimelineAxis = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(TimelineAxis, _super);
    function TimelineAxis(dim, scale, coordExtent, axisType) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        return _this;
    }
    /**
   * @override
   */ TimelineAxis.prototype.getLabelModel = function() {
        // Force override
        return this.model.getModel("label");
    };
    /**
   * @override
   */ TimelineAxis.prototype.isHorizontal = function() {
        return this.model.get("orient") === "horizontal";
    };
    return TimelineAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $d38633a847120ec8$export$2e2bcd8739ae039 = $d38633a847120ec8$var$TimelineAxis;













var $aba52479ef639cd6$var$PI = Math.PI;
var $aba52479ef639cd6$var$labelDataIndexStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $aba52479ef639cd6$var$SliderTimelineView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SliderTimelineView, _super);
    function SliderTimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineView.type;
        return _this;
    }
    SliderTimelineView.prototype.init = function(ecModel, api) {
        this.api = api;
    };
    /**
   * @override
   */ SliderTimelineView.prototype.render = function(timelineModel, ecModel, api) {
        this.model = timelineModel;
        this.api = api;
        this.ecModel = ecModel;
        this.group.removeAll();
        if (timelineModel.get("show", true)) {
            var layoutInfo_1 = this._layout(timelineModel, api);
            var mainGroup_1 = this._createGroup("_mainGroup");
            var labelGroup = this._createGroup("_labelGroup");
            var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);
            timelineModel.formatTooltip = function(dataIndex) {
                var name = axis_1.scale.getLabel({
                    value: dataIndex
                });
                return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    noName: true,
                    value: name
                });
            };
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
                "AxisLine",
                "AxisTick",
                "Control",
                "CurrentPointer"
            ], function(name) {
                this["_render" + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
            }, this);
            this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);
            this._position(layoutInfo_1, timelineModel);
        }
        this._doPlayStop();
        this._updateTicksStatus();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.remove = function() {
        this._clearTimer();
        this.group.removeAll();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.dispose = function() {
        this._clearTimer();
    };
    SliderTimelineView.prototype._layout = function(timelineModel, api) {
        var labelPosOpt = timelineModel.get([
            "label",
            "position"
        ]);
        var orient = timelineModel.get("orient");
        var viewRect = $aba52479ef639cd6$var$getViewRect(timelineModel, api);
        var parsedLabelPos;
        // Auto label offset.
        if (labelPosOpt == null || labelPosOpt === "auto") parsedLabelPos = orient === "horizontal" ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? "-" : "+" : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? "+" : "-";
        else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelPosOpt)) parsedLabelPos = ({
            horizontal: {
                top: "-",
                bottom: "+"
            },
            vertical: {
                left: "-",
                right: "+"
            }
        })[orient][labelPosOpt];
        else // is number
        parsedLabelPos = labelPosOpt;
        var labelAlignMap = {
            horizontal: "center",
            vertical: parsedLabelPos >= 0 || parsedLabelPos === "+" ? "left" : "right"
        };
        var labelBaselineMap = {
            horizontal: parsedLabelPos >= 0 || parsedLabelPos === "+" ? "top" : "bottom",
            vertical: "middle"
        };
        var rotationMap = {
            horizontal: 0,
            vertical: $aba52479ef639cd6$var$PI / 2
        };
        // Position
        var mainLength = orient === "vertical" ? viewRect.height : viewRect.width;
        var controlModel = timelineModel.getModel("controlStyle");
        var showControl = controlModel.get("show", true);
        var controlSize = showControl ? controlModel.get("itemSize") : 0;
        var controlGap = showControl ? controlModel.get("itemGap") : 0;
        var sizePlusGap = controlSize + controlGap;
        // Special label rotate.
        var labelRotation = timelineModel.get([
            "label",
            "rotate"
        ]) || 0;
        labelRotation = labelRotation * $aba52479ef639cd6$var$PI / 180; // To radian.
        var playPosition;
        var prevBtnPosition;
        var nextBtnPosition;
        var controlPosition = controlModel.get("position", true);
        var showPlayBtn = showControl && controlModel.get("showPlayBtn", true);
        var showPrevBtn = showControl && controlModel.get("showPrevBtn", true);
        var showNextBtn = showControl && controlModel.get("showNextBtn", true);
        var xLeft = 0;
        var xRight = mainLength;
        // position[0] means left, position[1] means middle.
        if (controlPosition === "left" || controlPosition === "bottom") {
            showPlayBtn && (playPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                xLeft,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        } else {
            // 'top' 'right'
            showPlayBtn && (playPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        }
        var axisExtent = [
            xLeft,
            xRight
        ];
        if (timelineModel.get("inverse")) axisExtent.reverse();
        return {
            viewRect: viewRect,
            mainLength: mainLength,
            orient: orient,
            rotation: rotationMap[orient],
            labelRotation: labelRotation,
            labelPosOpt: parsedLabelPos,
            labelAlign: timelineModel.get([
                "label",
                "align"
            ]) || labelAlignMap[orient],
            labelBaseline: timelineModel.get([
                "label",
                "verticalAlign"
            ]) || timelineModel.get([
                "label",
                "baseline"
            ]) || labelBaselineMap[orient],
            // Based on mainGroup.
            playPosition: playPosition,
            prevBtnPosition: prevBtnPosition,
            nextBtnPosition: nextBtnPosition,
            axisExtent: axisExtent,
            controlSize: controlSize,
            controlGap: controlGap
        };
    };
    SliderTimelineView.prototype._position = function(layoutInfo, timelineModel) {
        // Position is be called finally, because bounding rect is needed for
        // adapt content to fill viewRect (auto adapt offset).
        // Timeline may be not all in the viewRect when 'offset' is specified
        // as a number, because it is more appropriate that label aligns at
        // 'offset' but not the other edge defined by viewRect.
        var mainGroup = this._mainGroup;
        var labelGroup = this._labelGroup;
        var viewRect = layoutInfo.viewRect;
        if (layoutInfo.orient === "vertical") {
            // transform to horizontal, inverse rotate by left-top point.
            var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            var rotateOriginX = viewRect.x;
            var rotateOriginY = viewRect.y + viewRect.height;
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                -rotateOriginX,
                -rotateOriginY
            ]);
            $f41ebb9dd60b55b4$export$bb628a54ab399bc9(m, m, -$aba52479ef639cd6$var$PI / 2);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                rotateOriginX,
                rotateOriginY
            ]);
            viewRect = viewRect.clone();
            viewRect.applyTransform(m);
        }
        var viewBound = getBound(viewRect);
        var mainBound = getBound(mainGroup.getBoundingRect());
        var labelBound = getBound(labelGroup.getBoundingRect());
        var mainPosition = [
            mainGroup.x,
            mainGroup.y
        ];
        var labelsPosition = [
            labelGroup.x,
            labelGroup.y
        ];
        labelsPosition[0] = mainPosition[0] = viewBound[0][0];
        var labelPosOpt = layoutInfo.labelPosOpt;
        if (labelPosOpt == null || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelPosOpt)) {
            // '+' or '-'
            var mainBoundIdx = labelPosOpt === "+" ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
        } else {
            var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            labelsPosition[1] = mainPosition[1] + labelPosOpt;
        }
        mainGroup.setPosition(mainPosition);
        labelGroup.setPosition(labelsPosition);
        mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
        setOrigin(mainGroup);
        setOrigin(labelGroup);
        function setOrigin(targetGroup) {
            targetGroup.originX = viewBound[0][0] - targetGroup.x;
            targetGroup.originY = viewBound[1][0] - targetGroup.y;
        }
        function getBound(rect) {
            // [[xmin, xmax], [ymin, ymax]]
            return [
                [
                    rect.x,
                    rect.x + rect.width
                ],
                [
                    rect.y,
                    rect.y + rect.height
                ]
            ];
        }
        function toBound(fromPos, from, to, dimIdx, boundIdx) {
            fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
        }
    };
    SliderTimelineView.prototype._createAxis = function(layoutInfo, timelineModel) {
        var data = timelineModel.getData();
        var axisType = timelineModel.get("axisType");
        var scale = $aba52479ef639cd6$var$createScaleByModel(timelineModel, axisType);
        // Customize scale. The `tickValue` is `dataIndex`.
        scale.getTicks = function() {
            return data.mapArray([
                "value"
            ], function(value) {
                return {
                    value: value
                };
            });
        };
        var dataExtent = data.getDataExtent("value");
        scale.setExtent(dataExtent[0], dataExtent[1]);
        scale.calcNiceTicks();
        var axis = new (0, $d38633a847120ec8$export$2e2bcd8739ae039)("value", scale, layoutInfo.axisExtent, axisType);
        axis.model = timelineModel;
        return axis;
    };
    SliderTimelineView.prototype._createGroup = function(key) {
        var newGroup = this[key] = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(newGroup);
        return newGroup;
    };
    SliderTimelineView.prototype._renderAxisLine = function(layoutInfo, group, axis, timelineModel) {
        var axisExtent = axis.getExtent();
        if (!timelineModel.get([
            "lineStyle",
            "show"
        ])) return;
        var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                y1: 0,
                x2: axisExtent[1],
                y2: 0
            },
            style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                lineCap: "round"
            }, timelineModel.getModel("lineStyle").getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(line);
        var progressLine = this._progressLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
                y1: 0,
                y2: 0
            },
            style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                lineCap: "round",
                lineWidth: line.style.lineWidth
            }, timelineModel.getModel([
                "progress",
                "lineStyle"
            ]).getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(progressLine);
    };
    SliderTimelineView.prototype._renderAxisTick = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var data = timelineModel.getData();
        // Show all ticks, despite ignoring strategy.
        var ticks = axis.scale.getTicks();
        this._tickSymbols = [];
        // The value is dataIndex, see the customized scale.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticks, function(tick) {
            var tickCoord = axis.dataToCoord(tick.value);
            var itemModel = data.getItemModel(tick.value);
            var itemStyleModel = itemModel.getModel("itemStyle");
            var hoverStyleModel = itemModel.getModel([
                "emphasis",
                "itemStyle"
            ]);
            var progressStyleModel = itemModel.getModel([
                "progress",
                "itemStyle"
            ]);
            var symbolOpt = {
                x: tickCoord,
                y: 0,
                onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._changeTimeline, _this, tick.value)
            };
            var el = $aba52479ef639cd6$var$giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
            el.ensureState("emphasis").style = hoverStyleModel.getItemStyle();
            el.ensureState("progress").style = progressStyleModel.getItemStyle();
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(el);
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            if (itemModel.get("tooltip")) {
                ecData.dataIndex = tick.value;
                ecData.dataModel = timelineModel;
            } else ecData.dataIndex = ecData.dataModel = null;
            _this._tickSymbols.push(el);
        });
    };
    SliderTimelineView.prototype._renderAxisLabel = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var labelModel = axis.getLabelModel();
        if (!labelModel.get("show")) return;
        var data = timelineModel.getData();
        var labels = axis.getViewLabels();
        this._tickLabels = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labels, function(labelItem) {
            // The tickValue is dataIndex, see the customized scale.
            var dataIndex = labelItem.tickValue;
            var itemModel = data.getItemModel(dataIndex);
            var normalLabelModel = itemModel.getModel("label");
            var hoverLabelModel = itemModel.getModel([
                "emphasis",
                "label"
            ]);
            var progressLabelModel = itemModel.getModel([
                "progress",
                "label"
            ]);
            var tickCoord = axis.dataToCoord(labelItem.tickValue);
            var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
                x: tickCoord,
                y: 0,
                rotation: layoutInfo.labelRotation - layoutInfo.rotation,
                onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._changeTimeline, _this, dataIndex),
                silent: false,
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(normalLabelModel, {
                    text: labelItem.formattedLabel,
                    align: layoutInfo.labelAlign,
                    verticalAlign: layoutInfo.labelBaseline
                })
            });
            textEl.ensureState("emphasis").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(hoverLabelModel);
            textEl.ensureState("progress").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(progressLabelModel);
            group.add(textEl);
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(textEl);
            $aba52479ef639cd6$var$labelDataIndexStore(textEl).dataIndex = dataIndex;
            _this._tickLabels.push(textEl);
        });
    };
    SliderTimelineView.prototype._renderControl = function(layoutInfo, group, axis, timelineModel) {
        var controlSize = layoutInfo.controlSize;
        var rotation = layoutInfo.rotation;
        var itemStyle = timelineModel.getModel("controlStyle").getItemStyle();
        var hoverStyle = timelineModel.getModel([
            "emphasis",
            "controlStyle"
        ]).getItemStyle();
        var playState = timelineModel.getPlayState();
        var inverse = timelineModel.get("inverse", true);
        makeBtn(layoutInfo.nextBtnPosition, "next", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? "-" : "+"));
        makeBtn(layoutInfo.prevBtnPosition, "prev", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? "+" : "-"));
        makeBtn(layoutInfo.playPosition, playState ? "stop" : "play", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._handlePlayClick, this, !playState), true);
        function makeBtn(position, iconName, onclick, willRotate) {
            if (!position) return;
            var iconSize = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(timelineModel.get([
                "controlStyle",
                iconName + "BtnSize"
            ]), controlSize), controlSize);
            var rect = [
                0,
                -iconSize / 2,
                iconSize,
                iconSize
            ];
            var btn = $aba52479ef639cd6$var$makeControlIcon(timelineModel, iconName + "Icon", rect, {
                x: position[0],
                y: position[1],
                originX: controlSize / 2,
                originY: 0,
                rotation: willRotate ? -rotation : 0,
                rectHover: true,
                style: itemStyle,
                onclick: onclick
            });
            btn.ensureState("emphasis").style = hoverStyle;
            group.add(btn);
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(btn);
        }
    };
    SliderTimelineView.prototype._renderCurrentPointer = function(layoutInfo, group, axis, timelineModel) {
        var data = timelineModel.getData();
        var currentIndex = timelineModel.getCurrentIndex();
        var pointerModel = data.getItemModel(currentIndex).getModel("checkpointStyle");
        var me = this;
        var callback = {
            onCreate: function(pointer) {
                pointer.draggable = true;
                pointer.drift = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(me._handlePointerDrag, me);
                pointer.ondragend = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(me._handlePointerDragend, me);
                $aba52479ef639cd6$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
            },
            onUpdate: function(pointer) {
                $aba52479ef639cd6$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
            }
        };
        // Reuse when exists, for animation and drag.
        this._currentPointer = $aba52479ef639cd6$var$giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
    };
    SliderTimelineView.prototype._handlePlayClick = function(nextState) {
        this._clearTimer();
        this.api.dispatchAction({
            type: "timelinePlayChange",
            playState: nextState,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._handlePointerDrag = function(dx, dy, e) {
        this._clearTimer();
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ]);
    };
    SliderTimelineView.prototype._handlePointerDragend = function(e) {
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ], true);
    };
    SliderTimelineView.prototype._pointerChangeTimeline = function(mousePos, trigger) {
        var toCoord = this._toAxisCoord(mousePos)[0];
        var axis = this._axis;
        var axisExtent = $cfc1f3b422a3185f$export$debe6e778e0a6d32(axis.getExtent().slice());
        toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
        toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
        this._currentPointer.x = toCoord;
        this._currentPointer.markRedraw();
        var progressLine = this._progressLine;
        if (progressLine) {
            progressLine.shape.x2 = toCoord;
            progressLine.dirty();
        }
        var targetDataIndex = this._findNearestTick(toCoord);
        var timelineModel = this.model;
        if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get("realtime")) this._changeTimeline(targetDataIndex);
    };
    SliderTimelineView.prototype._doPlayStop = function() {
        var _this = this;
        this._clearTimer();
        if (this.model.getPlayState()) this._timer = setTimeout(function() {
            // Do not cache
            var timelineModel = _this.model;
            _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get("rewind", true) ? -1 : 1));
        }, this.model.get("playInterval"));
    };
    SliderTimelineView.prototype._toAxisCoord = function(vertex) {
        var trans = this._mainGroup.getLocalTransform();
        return $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, trans, true);
    };
    SliderTimelineView.prototype._findNearestTick = function(axisCoord) {
        var data = this.model.getData();
        var dist = Infinity;
        var targetDataIndex;
        var axis = this._axis;
        data.each([
            "value"
        ], function(value, dataIndex) {
            var coord = axis.dataToCoord(value);
            var d = Math.abs(coord - axisCoord);
            if (d < dist) {
                dist = d;
                targetDataIndex = dataIndex;
            }
        });
        return targetDataIndex;
    };
    SliderTimelineView.prototype._clearTimer = function() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    };
    SliderTimelineView.prototype._changeTimeline = function(nextIndex) {
        var currentIndex = this.model.getCurrentIndex();
        if (nextIndex === "+") nextIndex = currentIndex + 1;
        else if (nextIndex === "-") nextIndex = currentIndex - 1;
        this.api.dispatchAction({
            type: "timelineChange",
            currentIndex: nextIndex,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._updateTicksStatus = function() {
        var currentIndex = this.model.getCurrentIndex();
        var tickSymbols = this._tickSymbols;
        var tickLabels = this._tickLabels;
        if (tickSymbols) for(var i = 0; i < tickSymbols.length; i++)tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState("progress", i < currentIndex);
        if (tickLabels) for(var i = 0; i < tickLabels.length; i++)tickLabels && tickLabels[i] && tickLabels[i].toggleState("progress", $aba52479ef639cd6$var$labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
    };
    SliderTimelineView.type = "timeline.slider";
    return SliderTimelineView;
}((0, $79b71ced407c5926$export$2e2bcd8739ae039));
function $aba52479ef639cd6$var$createScaleByModel(model, axisType) {
    axisType = axisType || model.get("type");
    if (axisType) switch(axisType){
        // Buildin scale
        case "category":
            return new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case "time":
            return new (0, $7729d7ac367e621c$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get("useUTC")
            });
        default:
            // default to be value
            return new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
    }
}
function $aba52479ef639cd6$var$getViewRect(model, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(model.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    }, model.get("padding"));
}
function $aba52479ef639cd6$var$makeControlIcon(timelineModel, objPath, rect, opts) {
    var style = opts.style;
    var icon = $5b455ae6f843ac47$export$274edc73af1ae9c8(timelineModel.get([
        "controlStyle",
        objPath
    ]), opts || {}, new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(rect[0], rect[1], rect[2], rect[3]));
    // TODO createIcon won't use style in opt.
    if (style) icon.setStyle(style);
    return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */ function $aba52479ef639cd6$var$giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
    var color = itemStyleModel.get("color");
    if (!symbol) {
        var symbolType = hostModel.get("symbol");
        symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
        symbol.setStyle("strokeNoScale", true);
        group.add(symbol);
        callback && callback.onCreate(symbol);
    } else {
        symbol.setColor(color);
        group.add(symbol); // Group may be new, also need to add.
        callback && callback.onUpdate(symbol);
    }
    // Style
    var itemStyle = itemStyleModel.getItemStyle([
        "color"
    ]);
    symbol.setStyle(itemStyle);
    // Transform and events.
    opt = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)({
        rectHover: true,
        z2: 100
    }, opt, true);
    var symbolSize = (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(hostModel.get("symbolSize"));
    opt.scaleX = symbolSize[0] / 2;
    opt.scaleY = symbolSize[1] / 2;
    var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(hostModel.get("symbolOffset"), symbolSize);
    if (symbolOffset) {
        opt.x = (opt.x || 0) + symbolOffset[0];
        opt.y = (opt.y || 0) + symbolOffset[1];
    }
    var symbolRotate = hostModel.get("symbolRotate");
    opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    symbol.attr(opt);
    // FIXME
    // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
    // getBoundingRect will return wrong result.
    // (This is supposed to be resolved in zrender, but it is a little difficult to
    // leverage performance and auto updateTransform)
    // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
    symbol.updateTransform();
    return symbol;
}
function $aba52479ef639cd6$var$pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
    if (pointer.dragging) return;
    var pointerModel = timelineModel.getModel("checkpointStyle");
    var toCoord = axis.dataToCoord(timelineModel.getData().get("value", dataIndex));
    if (noAnimation || !pointerModel.get("animation", true)) {
        pointer.attr({
            x: toCoord,
            y: 0
        });
        progressLine && progressLine.attr({
            shape: {
                x2: toCoord
            }
        });
    } else {
        var animationCfg = {
            duration: pointerModel.get("animationDuration", true),
            easing: pointerModel.get("animationEasing", true)
        };
        pointer.stopAnimation(null, true);
        pointer.animateTo({
            x: toCoord,
            y: 0
        }, animationCfg);
        progressLine && progressLine.animateTo({
            shape: {
                x2: toCoord
            }
        }, animationCfg);
    }
}
var $aba52479ef639cd6$export$2e2bcd8739ae039 = $aba52479ef639cd6$var$SliderTimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $001a2b3d09da4e02$export$780c34b7cfe44e86(registers) {
    registers.registerAction({
        type: "timelineChange",
        event: "timelineChanged",
        update: "prepareAndUpdate"
    }, function(payload, ecModel, api) {
        var timelineModel = ecModel.getComponent("timeline");
        if (timelineModel && payload.currentIndex != null) {
            timelineModel.setCurrentIndex(payload.currentIndex);
            if (!timelineModel.get("loop", true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
                timelineModel.setPlayState(false);
                // The timeline has played to the end, trigger event
                api.dispatchAction({
                    type: "timelinePlayChange",
                    playState: false,
                    from: payload.from
                });
            }
        }
        // Set normalized currentIndex to payload.
        ecModel.resetOption("timeline", {
            replaceMerge: timelineModel.get("replaceMerge", true)
        });
        return (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            currentIndex: timelineModel.option.currentIndex
        }, payload);
    });
    registers.registerAction({
        type: "timelinePlayChange",
        event: "timelinePlayChanged",
        update: "update"
    }, function(payload, ecModel) {
        var timelineModel = ecModel.getComponent("timeline");
        if (timelineModel && payload.playState != null) timelineModel.setPlayState(payload.playState);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

function $a77b6788fc89e6e1$export$2e2bcd8739ae039(option) {
    var timelineOpt = option && option.timeline;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(timelineOpt)) timelineOpt = timelineOpt ? [
        timelineOpt
    ] : [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(timelineOpt, function(opt) {
        if (!opt) return;
        $a77b6788fc89e6e1$var$compatibleEC2(opt);
    });
}
function $a77b6788fc89e6e1$var$compatibleEC2(opt) {
    var type = opt.type;
    var ec2Types = {
        "number": "value",
        "time": "time"
    };
    // Compatible with ec2
    if (ec2Types[type]) {
        opt.axisType = ec2Types[type];
        delete opt.type;
    }
    $a77b6788fc89e6e1$var$transferItem(opt);
    if ($a77b6788fc89e6e1$var$has(opt, "controlPosition")) {
        var controlStyle = opt.controlStyle || (opt.controlStyle = {});
        if (!$a77b6788fc89e6e1$var$has(controlStyle, "position")) controlStyle.position = opt.controlPosition;
        if (controlStyle.position === "none" && !$a77b6788fc89e6e1$var$has(controlStyle, "show")) {
            controlStyle.show = false;
            delete controlStyle.position;
        }
        delete opt.controlPosition;
    }
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(opt.data || [], function(dataItem) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(dataItem) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(dataItem)) {
            if (!$a77b6788fc89e6e1$var$has(dataItem, "value") && $a77b6788fc89e6e1$var$has(dataItem, "name")) // In ec2, using name as value.
            dataItem.value = dataItem.name;
            $a77b6788fc89e6e1$var$transferItem(dataItem);
        }
    });
}
function $a77b6788fc89e6e1$var$transferItem(opt) {
    var itemStyle = opt.itemStyle || (opt.itemStyle = {});
    var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {});
    // Transfer label out
    var label = opt.label || opt.label || {};
    var labelNormal = label.normal || (label.normal = {});
    var excludeLabelAttr = {
        normal: 1,
        emphasis: 1
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(label, function(value, name) {
        if (!excludeLabelAttr[name] && !$a77b6788fc89e6e1$var$has(labelNormal, name)) labelNormal[name] = value;
    });
    if (itemStyleEmphasis.label && !$a77b6788fc89e6e1$var$has(label, "emphasis")) {
        label.emphasis = itemStyleEmphasis.label;
        delete itemStyleEmphasis.label;
    }
}
function $a77b6788fc89e6e1$var$has(obj, attr) {
    return obj.hasOwnProperty(attr);
}


function $d41f79c5664eb934$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $22b93c2a0cce341f$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $aba52479ef639cd6$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter("timeline", function() {
        // Only slider now.
        return "slider";
    });
    (0, $001a2b3d09da4e02$export$780c34b7cfe44e86)(registers);
    registers.registerPreprocessor((0, $a77b6788fc89e6e1$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $bab2c9b6be98f0ce$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






function $1bab71219c0cd9a9$var$fillLabel(opt) {
    (0, $76d619f648247e6d$export$abdcc6a26372f94b)(opt, "label", [
        "show"
    ]);
}
// { [componentType]: MarkerModel }
var $1bab71219c0cd9a9$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $1bab71219c0cd9a9$var$MarkerModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow("animation") && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $1bab71219c0cd9a9$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $1bab71219c0cd9a9$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $1bab71219c0cd9a9$var$fillLabel(markerOpt);
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $1bab71219c0cd9a9$var$fillLabel(item[0]);
                        $1bab71219c0cd9a9$var$fillLabel(item[1]);
                    } else $1bab71219c0cd9a9$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel);
                // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $7a1bd9c2710fea0d$export$8b58be045bf06082(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $1bab71219c0cd9a9$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: this.name,
            blocks: [
                (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, // Support three types of markers. Strict check.
    componentType) {
        return $1bab71219c0cd9a9$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = "marker";
    MarkerModel.dependencies = [
        "series",
        "grid",
        "polar",
        "geo"
    ];
    return MarkerModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($1bab71219c0cd9a9$var$MarkerModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype);
var $1bab71219c0cd9a9$export$2e2bcd8739ae039 = $1bab71219c0cd9a9$var$MarkerModel;


var $2a559db54433a753$var$MarkPointModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MarkPointModel, _super);
    function MarkPointModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointModel.type;
        return _this;
    }
    MarkPointModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkPointModel.type = "markPoint";
    MarkPointModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: "pin",
        symbolSize: 50,
        // symbolRotate: 0,
        // symbolOffset: [0, 0]
        tooltip: {
            trigger: "item"
        },
        label: {
            show: true,
            position: "inside"
        },
        itemStyle: {
            borderWidth: 2
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return MarkPointModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $2a559db54433a753$export$2e2bcd8739ae039 = $2a559db54433a753$var$MarkPointModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $e4ec0ddef831b3b2$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $e4ec0ddef831b3b2$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, targetDataDim /* , otherDataDim */ );
    var calcDataDim = stacked ? data.getCalculationInfo("stackResultDimension") : targetDataDim;
    var value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex);
    // Make it simple, do not visit all stacked value to count precision.
    var precision = $cfc1f3b422a3185f$export$e0c74b50bbd10f68(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
}
// TODO Specified percent
var $e4ec0ddef831b3b2$var$markerTypeCalculator = {
    min: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "min"),
    max: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "max"),
    average: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "average"),
    median: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "median")
};
function $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item) {
    if (!item) return;
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dims = coordSys && coordSys.dimensions;
    // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (!$e4ec0ddef831b3b2$var$hasXAndY(item) && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item.coord) && (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dims)) {
        var axisInfo = $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel);
        // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
        if (item.type && $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0];
            // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else // FIXME Only has one of xAxis and yAxis.
        item.coord = [
            item.xAxis != null ? item.xAxis : item.radiusAxis,
            item.yAxis != null ? item.yAxis : item.angleAxis
        ];
    }
    // x y is provided
    if (item.coord == null || !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dims)) item.coord = [];
    else {
        // Each coord support max, min, average
        var coord = item.coord;
        for(var i = 0; i < 2; i++)if ($e4ec0ddef831b3b2$var$markerTypeCalculator[coord[i]]) coord[i] = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
    }
    return item;
}
function $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($e4ec0ddef831b3b2$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $e4ec0ddef831b3b2$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $e4ec0ddef831b3b2$export$179695f4a9040f73(// Currently only polar and cartesian has containData.
coordSys, item) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$e4ec0ddef831b3b2$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $e4ec0ddef831b3b2$export$c869311b63462da6(// Currently only polar and cartesian has containData.
coordSys, item1, item2) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containZone && item1.coord && item2.coord && !$e4ec0ddef831b3b2$var$hasXOrY(item1) && !$e4ec0ddef831b3b2$var$hasXOrY(item2) ? coordSys.containZone(item1.coord, item2.coord) : true;
}
function $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(item.value, dims[dimIndex]);
    };
}
function $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === "average") {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === "median") return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === "max" ? 1 : 0];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $ed6cf827ec8a4c83$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ed6cf827ec8a4c83$var$MarkerView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $ed6cf827ec8a4c83$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$ed6cf827ec8a4c83$var$inner(item).keep && _this.group.remove(item.group);
        });
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $ed6cf827ec8a4c83$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.toggleBlurSeries = function(seriesModelList, isBlur) {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) isBlur ? (0, $2bf82c0980125b62$export$207f9cb3e1099375)(el) : (0, $2bf82c0980125b62$export$fd4a9ec75456d3c1)(el);
                });
            }
        });
    };
    MarkerView.type = "marker";
    return MarkerView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $ed6cf827ec8a4c83$export$2e2bcd8739ae039 = $ed6cf827ec8a4c83$var$MarkerView;






function $80c0cdc6385c1c58$var$updateMarkerLayout(mpData, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    mpData.each(function(idx) {
        var itemModel = mpData.getItemModel(idx);
        var point;
        var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("x"), api.getWidth());
        var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("y"), api.getHeight());
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
        else if (coordSys) {
            var x = mpData.get(coordSys.dimensions[0], idx);
            var y = mpData.get(coordSys.dimensions[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
        mpData.setItemLayout(idx, point);
    });
}
var $80c0cdc6385c1c58$var$MarkPointView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MarkPointView, _super);
    function MarkPointView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointView.type;
        return _this;
    }
    MarkPointView.prototype.updateTransform = function(markPointModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mpModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markPoint");
            if (mpModel) {
                $80c0cdc6385c1c58$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkPointView.prototype.renderSeries = function(seriesModel, mpModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var symbolDrawMap = this.markerGroupMap;
        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)());
        var mpData = $80c0cdc6385c1c58$var$createData(coordSys, seriesModel, mpModel);
        // FIXME
        mpModel.setData(mpData);
        $80c0cdc6385c1c58$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var symbol = itemModel.getShallow("symbol");
            var symbolSize = itemModel.getShallow("symbolSize");
            var symbolRotate = itemModel.getShallow("symbolRotate");
            var symbolOffset = itemModel.getShallow("symbolOffset");
            var symbolKeepAspect = itemModel.getShallow("symbolKeepAspect");
            // TODO: refactor needed: single data item should not support callback function
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbol) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolSize) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolRotate) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolOffset)) {
                var rawIdx = mpModel.getRawValue(idx);
                var dataParams = mpModel.getDataParams(idx);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbol)) symbol = symbol(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolSize)) // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
                symbolSize = symbolSize(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolRotate)) symbolRotate = symbolRotate(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolOffset)) symbolOffset = symbolOffset(rawIdx, dataParams);
            }
            var style = itemModel.getModel("itemStyle").getItemStyle();
            var color = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            if (!style.fill) style.fill = color;
            mpData.setItemVisual(idx, {
                symbol: symbol,
                symbolSize: symbolSize,
                symbolRotate: symbolRotate,
                symbolOffset: symbolOffset,
                symbolKeepAspect: symbolKeepAspect,
                style: style
            });
        });
        // TODO Text are wrong
        symbolDraw.updateData(mpData);
        this.group.add(symbolDraw.group);
        // Set host model for tooltip
        // FIXME
        mpData.eachItemGraphicEl(function(el) {
            el.traverse(function(child) {
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child).dataModel = mpModel;
            });
        });
        this.markKeep(symbolDraw);
        symbolDraw.group.silent = mpModel.get("silent") || seriesModel.get("silent");
    };
    MarkPointView.type = "markPoint";
    return MarkPointView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $80c0cdc6385c1c58$var$createData(coordSys, seriesModel, mpModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: "value",
            type: "float"
        }
    ];
    var mpData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mpModel);
    var dataOpt = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(mpModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$export$3eebd2d54b98c04f, seriesModel));
    if (coordSys) dataOpt = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(dataOpt, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$export$179695f4a9040f73, coordSys));
    var dimValueGetter = $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    mpData.initData(dataOpt, null, dimValueGetter);
    return mpData;
}
var $80c0cdc6385c1c58$export$2e2bcd8739ae039 = $80c0cdc6385c1c58$var$MarkPointView;


function $4edaa7c972a7e0d1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2a559db54433a753$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $80c0cdc6385c1c58$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markPoint")) // Make sure markPoint component is enabled
        opt.markPoint = opt.markPoint || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ed1b4c8534a4bb68$var$MarkLineModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = "markLine";
    MarkLineModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: [
            "circle",
            "arrow"
        ],
        symbolSize: [
            8,
            16
        ],
        // symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: "item"
        },
        label: {
            show: true,
            position: "end",
            distance: 5
        },
        lineStyle: {
            type: "dashed"
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: "linear"
    };
    return MarkLineModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $ed1b4c8534a4bb68$export$2e2bcd8739ae039 = $ed1b4c8534a4bb68$var$MarkLineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $87a9be5fb3657486$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $87a9be5fb3657486$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === "min" || mlType === "max" || mlType === "average" || mlType === "median" || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? "y" : "x");
                value = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $efdd976e4917927c$export$909db2be4938fbdf)(data, axisInfo.valueDataDim);
                value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === "x" ? 0 : 1;
            var baseIndex = 1 - valueIndex;
            // Normized to 2d data with start and end point
            var mlFrom = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get("precision");
            if (precision >= 0 && (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value)) value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, itemArray[0]),
        $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, itemArray[1]),
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, itemArray[2])
    ];
    // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null;
    // Merge from option and to option into line option
    (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[0]);
    (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $87a9be5fb3657486$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markLine has one dim
function $87a9be5fb3657486$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $87a9be5fb3657486$var$isInfinity(fromCoord[otherDimIndex]) && $87a9be5fb3657486$var$isInfinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $87a9be5fb3657486$var$markLineFilter(coordSys, item) {
    if (coordSys.type === "cartesian2d") {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord;
        // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($87a9be5fb3657486$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $87a9be5fb3657486$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item[0]) && $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item[1]);
}
function $87a9be5fb3657486$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("x"), api.getWidth());
    var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("y"), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            var dims = coordSys.dimensions;
            if ($87a9be5fb3657486$var$isInfinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($87a9be5fb3657486$var$isInfinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $87a9be5fb3657486$var$MarkLineView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markLine");
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $87a9be5fb3657486$var$inner(mlModel).from;
                var toData_1 = $87a9be5fb3657486$var$inner(mlModel).to;
                // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $87a9be5fb3657486$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $87a9be5fb3657486$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                });
                // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)());
        this.group.add(lineDraw.group);
        var mlData = $87a9be5fb3657486$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $87a9be5fb3657486$var$inner(mlModel).from = fromData;
        $87a9be5fb3657486$var$inner(mlModel).to = toData;
        // Line data for tooltip and formatter
        mlModel.setData(lineData);
        // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get("symbol");
        var symbolSize = mlModel.get("symbolSize");
        var symbolRotate = mlModel.get("symbolRotate");
        var symbolOffset = mlModel.get("symbolOffset");
        // TODO: support callback function like markPoint
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        });
        // Update visual and layout of line
        lineData.each(function(idx) {
            var lineStyle = lineData.getItemModel(idx).getModel("lineStyle").getLineStyle();
            // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, "style").fill;
            lineData.setItemVisual(idx, {
                fromSymbolKeepAspect: fromData.getItemVisual(idx, "symbolKeepAspect"),
                fromSymbolOffset: fromData.getItemVisual(idx, "symbolOffset"),
                fromSymbolRotate: fromData.getItemVisual(idx, "symbolRotate"),
                fromSymbolSize: fromData.getItemVisual(idx, "symbolSize"),
                fromSymbol: fromData.getItemVisual(idx, "symbol"),
                toSymbolKeepAspect: toData.getItemVisual(idx, "symbolKeepAspect"),
                toSymbolOffset: toData.getItemVisual(idx, "symbolOffset"),
                toSymbolRotate: toData.getItemVisual(idx, "symbolRotate"),
                toSymbolSize: toData.getItemVisual(idx, "symbolSize"),
                toSymbol: toData.getItemVisual(idx, "symbol"),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData);
        // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el) {
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataModel = mlModel;
            el.traverse(function(child) {
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $87a9be5fb3657486$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel("itemStyle").getItemStyle();
            if (style.fill == null) style.fill = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get("symbolKeepAspect"),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolOffset", true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolRotate", true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolSize"), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbol", true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get("silent") || seriesModel.get("silent");
    };
    MarkLineView.type = "markLine";
    return MarkLineView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $87a9be5fb3657486$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: "value",
            type: "float"
        }
    ];
    var fromData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    var toData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    // No dimensions
    var lineData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([], mlModel);
    var optData = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(mlModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($87a9be5fb3657486$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(optData, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($87a9be5fb3657486$var$markLineFilter, coordSys));
    var dimValueGetter = $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    fromData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $87a9be5fb3657486$export$2e2bcd8739ae039 = $87a9be5fb3657486$var$MarkLineView;


function $0fc27d0a088604ed$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $ed1b4c8534a4bb68$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $87a9be5fb3657486$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markLine")) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $a4d9f6e367e83128$var$MarkAreaModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MarkAreaModel, _super);
    function MarkAreaModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaModel.type;
        return _this;
    }
    MarkAreaModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkAreaModel.type = "markArea";
    MarkAreaModel.defaultOption = {
        // zlevel: 0,
        // PENDING
        z: 1,
        tooltip: {
            trigger: "item"
        },
        // markArea should fixed on the coordinate system
        animation: false,
        label: {
            show: true,
            position: "top"
        },
        itemStyle: {
            // color and borderColor default to use color from series
            // color: 'auto'
            // borderColor: 'auto'
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                position: "top"
            }
        }
    };
    return MarkAreaModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $a4d9f6e367e83128$export$2e2bcd8739ae039 = $a4d9f6e367e83128$var$MarkAreaModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 















var $83ebccb52de64002$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $83ebccb52de64002$var$markAreaTransform = function(seriesModel, coordSys, maModel, item) {
    // item may be null
    var item0 = item[0];
    var item1 = item[1];
    if (!item0 || !item1) return;
    var lt = $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item0);
    var rb = $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item1);
    // FIXME make sure lt is less than rb
    var ltCoord = lt.coord;
    var rbCoord = rb.coord;
    ltCoord[0] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(ltCoord[0], -Infinity);
    ltCoord[1] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(ltCoord[1], -Infinity);
    rbCoord[0] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(rbCoord[0], Infinity);
    rbCoord[1] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(rbCoord[1], Infinity);
    // Merge option into one
    var result = (0, $7a1bd9c2710fea0d$export$18aef43295bbe906)([
        {},
        lt,
        rb
    ]);
    result.coord = [
        lt.coord,
        rb.coord
    ];
    result.x0 = lt.x;
    result.y0 = lt.y;
    result.x1 = rb.x;
    result.y1 = rb.y;
    return result;
};
function $83ebccb52de64002$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markArea has one dim
function $83ebccb52de64002$var$ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    return $83ebccb52de64002$var$isInfinity(fromCoord[otherDimIndex]) && $83ebccb52de64002$var$isInfinity(toCoord[otherDimIndex]);
}
function $83ebccb52de64002$var$markAreaFilter(coordSys, item) {
    var fromCoord = item.coord[0];
    var toCoord = item.coord[1];
    var item0 = {
        coord: fromCoord,
        x: item.x0,
        y: item.y0
    };
    var item1 = {
        coord: toCoord,
        x: item.x1,
        y: item.y1
    };
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
        // In case
        // {
        //  markArea: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($83ebccb52de64002$var$ifMarkAreaHasOnlyDim(1, fromCoord, toCoord, coordSys) || $83ebccb52de64002$var$ifMarkAreaHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
        // Directly returning true may also do the work,
        // because markArea will not be shown automatically
        // when it's not included in coordinate system.
        // But filtering ahead can avoid keeping rendering markArea
        // when there are too many of them.
        return $e4ec0ddef831b3b2$export$c869311b63462da6(coordSys, item0, item1);
    }
    return $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item0) || $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item1);
}
// dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
function $83ebccb52de64002$var$getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get(dims[0]), api.getWidth());
    var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get(dims[1]), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) {
            // Consider the case that user input the right-bottom point first
            // Pick the larger x and y as 'x1' and 'y1'
            var pointValue0 = data.getValues([
                "x0",
                "y0"
            ], idx);
            var pointValue1 = data.getValues([
                "x1",
                "y1"
            ], idx);
            var clampPointValue0 = coordSys.clampData(pointValue0);
            var clampPointValue1 = coordSys.clampData(pointValue1);
            var pointValue = [];
            if (dims[0] === "x0") pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue1[0] : pointValue0[0];
            else pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue0[0] : pointValue1[0];
            if (dims[1] === "y0") pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue1[1] : pointValue0[1];
            else pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue0[1] : pointValue1[1];
            // Use the getMarkerPosition
            point = seriesModel.getMarkerPosition(pointValue, dims, true);
        } else {
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            var pt = [
                x,
                y
            ];
            coordSys.clampData && coordSys.clampData(pt, pt);
            point = coordSys.dataToPoint(pt, true);
        }
        if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            if ($83ebccb52de64002$var$isInfinity(x)) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === "x0" ? 0 : 1]);
            else if ($83ebccb52de64002$var$isInfinity(y)) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === "y0" ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    return point;
}
var $83ebccb52de64002$export$fc5a505a325de211 = [
    [
        "x0",
        "y0"
    ],
    [
        "x1",
        "y0"
    ],
    [
        "x1",
        "y1"
    ],
    [
        "x0",
        "y1"
    ]
];
var $83ebccb52de64002$var$MarkAreaView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(MarkAreaView, _super);
    function MarkAreaView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaView.type;
        return _this;
    }
    MarkAreaView.prototype.updateTransform = function(markAreaModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var maModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markArea");
            if (maModel) {
                var areaData_1 = maModel.getData();
                areaData_1.each(function(idx) {
                    var points = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($83ebccb52de64002$export$fc5a505a325de211, function(dim) {
                        return $83ebccb52de64002$var$getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
                    });
                    // Layout
                    areaData_1.setItemLayout(idx, points);
                    var el = areaData_1.getItemGraphicEl(idx);
                    el.setShape("points", points);
                });
            }
        }, this);
    };
    MarkAreaView.prototype.renderSeries = function(seriesModel, maModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var areaGroupMap = this.markerGroupMap;
        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
            group: new $7ef7583d8302ffce$export$2e2bcd8739ae039()
        });
        this.group.add(polygonGroup.group);
        this.markKeep(polygonGroup);
        var areaData = $83ebccb52de64002$var$createList(coordSys, seriesModel, maModel);
        // Line data for tooltip and formatter
        maModel.setData(areaData);
        // Update visual and layout of line
        areaData.each(function(idx) {
            // Layout
            var points = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($83ebccb52de64002$export$fc5a505a325de211, function(dim) {
                return $83ebccb52de64002$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
            });
            var xAxisScale = coordSys.getAxis("x").scale;
            var yAxisScale = coordSys.getAxis("y").scale;
            var xAxisExtent = xAxisScale.getExtent();
            var yAxisExtent = yAxisScale.getExtent();
            var xPointExtent = [
                xAxisScale.parse(areaData.get("x0", idx)),
                xAxisScale.parse(areaData.get("x1", idx))
            ];
            var yPointExtent = [
                yAxisScale.parse(areaData.get("y0", idx)),
                yAxisScale.parse(areaData.get("y1", idx))
            ];
            $cfc1f3b422a3185f$export$debe6e778e0a6d32(xPointExtent);
            $cfc1f3b422a3185f$export$debe6e778e0a6d32(yPointExtent);
            var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]);
            // If none of the area is inside coordSys, allClipped is set to be true
            // in layout so that label will not be displayed. See #12591
            var allClipped = !overlapped;
            areaData.setItemLayout(idx, {
                points: points,
                allClipped: allClipped
            });
            var style = areaData.getItemModel(idx).getModel("itemStyle").getItemStyle();
            var color = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            if (!style.fill) {
                style.fill = color;
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(style.fill)) style.fill = $2c037f5bda6341ca$export$ab4754bf42583a26(style.fill, 0.4);
            }
            if (!style.stroke) style.stroke = color;
            // Visual
            areaData.setItemVisual(idx, "style", style);
        });
        areaData.diff($83ebccb52de64002$var$inner(polygonGroup).data).add(function(idx) {
            var layout = areaData.getItemLayout(idx);
            if (!layout.allClipped) {
                var polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(idx, polygon);
                polygonGroup.group.add(polygon);
            }
        }).update(function(newIdx, oldIdx) {
            var polygon = $83ebccb52de64002$var$inner(polygonGroup).data.getItemGraphicEl(oldIdx);
            var layout = areaData.getItemLayout(newIdx);
            if (!layout.allClipped) {
                if (polygon) $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: layout.points
                    }
                }, maModel, newIdx);
                else polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(newIdx, polygon);
                polygonGroup.group.add(polygon);
            } else if (polygon) polygonGroup.group.remove(polygon);
        }).remove(function(idx) {
            var polygon = $83ebccb52de64002$var$inner(polygonGroup).data.getItemGraphicEl(idx);
            polygonGroup.group.remove(polygon);
        }).execute();
        areaData.eachItemGraphicEl(function(polygon, idx) {
            var itemModel = areaData.getItemModel(idx);
            var style = areaData.getItemVisual(idx, "style");
            polygon.useStyle(areaData.getItemVisual(idx, "style"));
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polygon, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                labelFetcher: maModel,
                labelDataIndex: idx,
                defaultText: areaData.getName(idx) || "",
                inheritColor: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(style.fill) ? $2c037f5bda6341ca$export$ab4754bf42583a26(style.fill, 1) : "#000"
            });
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel);
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, null, null, itemModel.get([
                "emphasis",
                "disabled"
            ]));
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polygon).dataModel = maModel;
        });
        $83ebccb52de64002$var$inner(polygonGroup).data = areaData;
        polygonGroup.group.silent = maModel.get("silent") || seriesModel.get("silent");
    };
    MarkAreaView.type = "markArea";
    return MarkAreaView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $83ebccb52de64002$var$createList(coordSys, seriesModel, maModel) {
    var areaData;
    var dataDims;
    var dims = [
        "x0",
        "y0",
        "x1",
        "y1"
    ];
    if (coordSys) {
        var coordDimsInfos_1 = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
            var data = seriesModel.getData();
            var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {};
            // In map series data don't have lng and lat dimension. Fallback to same with coordSys
            return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
                name: coordDim,
                // DON'T use ordinalMeta to parse and collect ordinal.
                ordinalMeta: null
            });
        });
        dataDims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dims, function(dim, idx) {
            return {
                name: dim,
                type: coordDimsInfos_1[idx % 2].type
            };
        });
        areaData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dataDims, maModel);
    } else {
        dataDims = [
            {
                name: "value",
                type: "float"
            }
        ];
        areaData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dataDims, maModel);
    }
    var optData = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(maModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($83ebccb52de64002$var$markAreaTransform, seriesModel, coordSys, maModel));
    if (coordSys) optData = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(optData, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($83ebccb52de64002$var$markAreaFilter, coordSys));
    var dimValueGetter = coordSys ? function(item, dimName, dataIndex, dimIndex) {
        // TODO should convert to ParsedValue?
        var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dataDims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(item.value, dataDims[dimIndex]);
    };
    areaData.initData(optData, null, dimValueGetter);
    areaData.hasItemOption = true;
    return areaData;
}
var $83ebccb52de64002$export$2e2bcd8739ae039 = $83ebccb52de64002$var$MarkAreaView;


function $8a8e80722bf1c081$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $a4d9f6e367e83128$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $83ebccb52de64002$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markArea")) // Make sure markArea component is enabled
        opt.markArea = opt.markArea || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0fbb1ae1b8df4cab$var$getDefaultSelectorOptions = function(ecModel, type) {
    if (type === "all") return {
        type: "all",
        title: ecModel.getLocaleModel().get([
            "legend",
            "selector",
            "all"
        ])
    };
    else if (type === "inverse") return {
        type: "inverse",
        title: ecModel.getLocaleModel().get([
            "legend",
            "selector",
            "inverse"
        ])
    };
};
var $0fbb1ae1b8df4cab$var$LegendModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: "box",
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            "all",
            "inverse"
        ];
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(selector)) $7a1bd9c2710fea0d$export$79b2f7037acddd43(selector, function(item, index) {
            $7a1bd9c2710fea0d$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $7a1bd9c2710fea0d$export$4950aa0f605343fb(item, $0fbb1ae1b8df4cab$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get("selectedMode") === "single") {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get("name");
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get("name"));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $76d619f648247e6d$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get("data") || potentialData;
        var legendNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var legendData = $7a1bd9c2710fea0d$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(dataItem) || $7a1bd9c2710fea0d$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $7a1bd9c2710fea0d$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get("selectedMode");
        if (selectedMode === "single") {
            var data = this._data;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get("name")] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get("selectedMode") !== "single") this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? "unSelect" : "select"](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get("name", true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get("name", true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get("orient") === "vertical" ? {
            index: 1,
            name: "vertical"
        } : {
            index: 0,
            name: "horizontal"
        };
    };
    LegendModel.type = "legend.plain";
    LegendModel.dependencies = [
        "series"
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: "horizontal",
        left: "center",
        // right: 'center',
        top: 0,
        // bottom: null,
        align: "auto",
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: "inherit",
        symbolKeepAspect: true,
        inactiveColor: "#ccc",
        inactiveBorderColor: "#ccc",
        inactiveBorderWidth: "auto",
        itemStyle: {
            color: "inherit",
            opacity: "inherit",
            borderColor: "inherit",
            borderWidth: "auto",
            borderCap: "inherit",
            borderJoin: "inherit",
            borderDashOffset: "inherit",
            borderMiterLimit: "inherit"
        },
        lineStyle: {
            width: "auto",
            color: "inherit",
            inactiveColor: "#ccc",
            inactiveWidth: 2,
            opacity: "inherit",
            type: "inherit",
            cap: "inherit",
            join: "inherit",
            dashOffset: "inherit",
            miterLimit: "inherit"
        },
        textStyle: {
            color: "#333"
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: "sans-serif",
            color: "#666",
            borderWidth: 1,
            borderColor: "#666"
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: "#eee",
                backgroundColor: "#666"
            }
        },
        selectorPosition: "auto",
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        }
    };
    return LegendModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $0fbb1ae1b8df4cab$export$2e2bcd8739ae039 = $0fbb1ae1b8df4cab$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











var $c2e212625ccc38b4$var$curry = $7a1bd9c2710fea0d$export$c3095a23b368d1f2;
var $c2e212625ccc38b4$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $c2e212625ccc38b4$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $c2e212625ccc38b4$var$LegendView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $c2e212625ccc38b4$var$Group());
        this.group.add(this._selectorGroup = new $c2e212625ccc38b4$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get("show", true)) return;
        var itemAlign = legendModel.get("align");
        var orient = legendModel.get("orient");
        if (!itemAlign || itemAlign === "auto") itemAlign = legendModel.get("left") === "right" && orient === "vertical" ? "right" : "left";
        // selector has been normalized to an array in model
        var selector = legendModel.get("selector", true);
        var selectorPosition = legendModel.get("selectorPosition", true);
        if (selector && (!selectorPosition || selectorPosition === "auto")) selectorPosition = orient === "horizontal" ? "end" : "start";
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var positionInfo = legendModel.getBoxLayoutParams();
        var viewportSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var padding = legendModel.get("padding");
        var maxSize = $93b9bc7f22ac7369$export$4517a5ca639a7293(positionInfo, viewportSize, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), viewportSize, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $40fca678c85406ff$export$fae23936eedfad4f)(mainRect, legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get("selectedMode");
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get("legendHoverLink") && excludeSeriesId.push(seriesModel.id);
        });
        $c2e212625ccc38b4$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var name = legendItemModel.get("name");
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === "" || name === "\n")) {
                var g = new $c2e212625ccc38b4$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual("legendLineStyle") || {};
                var legendIcon = data.getVisual("legendIcon");
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual("style");
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on("click", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on("mouseover", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on("mouseout", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = "legend";
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, "style");
                    var legendIcon = provider.getItemVisual(idx, "legendIcon");
                    var colorArr = (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $7a1bd9c2710fea0d$export$8b58be045bf06082($7a1bd9c2710fea0d$export$8b58be045bf06082({}, style), {
                            fill: (0, $2c037f5bda6341ca$export$fac44ee5b035f737)(colorArr, "rgba")
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on("click", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on("mouseover", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on("mouseout", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = "legend";
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $c2e212625ccc38b4$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: "center",
                    verticalAlign: "middle"
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === "all" ? "legendAllSelect" : "legendInverseSelect"
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel("selectorLabel");
            var emphasisLabelModel = legendModel.getModel([
                "emphasis",
                "selectorLabel"
            ]);
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get("itemWidth");
        var itemHeight = legendModel.get("itemHeight");
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get("symbolRotate");
        var symbolKeepAspect = legendItemModel.get("symbolKeepAspect");
        var legendIconType = legendItemModel.get("icon");
        legendIcon = legendIconType || legendIcon || "roundRect";
        var style = $c2e212625ccc38b4$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $c2e212625ccc38b4$var$Group();
        var textStyleModel = legendItemModel.getModel("textStyle");
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === "inherit")) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === "inherit" && seriesModel.getData().getVisual("symbol") ? iconRotate === "inherit" ? seriesModel.getData().getVisual("symbolRotate") : iconRotate : 0; // No rotation for no icon
            itemGroup.add($c2e212625ccc38b4$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === "left" ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get("formatter");
        var content = name;
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace("{name}", name != null ? name : "");
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get("inactiveColor");
        itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: "middle"
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: "transparent"
            }
        });
        var tooltipModel = legendItemModel.getModel("tooltip");
        if (tooltipModel.get("show")) $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $93b9bc7f22ac7369$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            "horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get("selectorButtonGap", true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? "width" : "height";
            var hw = orientIdx === 0 ? "height" : "width";
            var yx = orientIdx === 0 ? "y" : "x";
            if (selectorPosition === "end") selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = "legend.plain";
    return LegendView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $c2e212625ccc38b4$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === "auto") style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $c2e212625ccc38b4$var$each(style, function(propVal, propName) {
            style[propName] === "inherit" && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel("itemStyle");
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf("empty", 0) === 0 ? "fill" : "stroke";
    var decalStyle = itemStyleModel.getShallow("decal");
    itemStyle.decal = !decalStyle || decalStyle === "inherit" ? itemVisualStyle.decal : (0, $c6d646aacd243427$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === "inherit") /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === "inherit") /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === "inherit") /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === "fill" ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel("lineStyle");
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === "auto" && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === "auto" && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === "auto" && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get("inactiveBorderWidth");
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === "auto" ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get("inactiveColor");
        itemStyle.stroke = legendItemModel.get("inactiveBorderColor");
        lineStyle.stroke = legendLineModel.get("inactiveColor");
        lineStyle.lineWidth = legendLineModel.get("inactiveWidth");
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $c2e212625ccc38b4$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || "roundRect";
    var icon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf("empty") > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = "#fff";
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $c2e212625ccc38b4$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $c2e212625ccc38b4$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: "legendToggleSelect",
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $c2e212625ccc38b4$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $c2e212625ccc38b4$var$isUseHoverLayer(api) {
    var list = api.getZr().storage.getDisplayList();
    var emphasisState;
    var i = 0;
    var len = list.length;
    while(i < len && !(emphasisState = list[i].states.emphasis))i++;
    return emphasisState && emphasisState.hoverLayer;
}
function $c2e212625ccc38b4$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$c2e212625ccc38b4$var$isUseHoverLayer(api)) api.dispatchAction({
        type: "highlight",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $c2e212625ccc38b4$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$c2e212625ccc38b4$var$isUseHoverLayer(api)) api.dispatchAction({
        type: "downplay",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $c2e212625ccc38b4$export$2e2bcd8739ae039 = $c2e212625ccc38b4$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c618818715ebe216$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

function $19822663d90c963e$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var selectedMap = {};
    var isToggleSelect = methodName === "toggleSelected";
    var isSelected;
    // Update all legend components
    ecModel.eachComponent("legend", function(legendModel) {
        if (isToggleSelect && isSelected != null) // Force other legend has same selected status
        // Or the first is toggled to true and other are toggled to false
        // In the case one legend has some item unSelected in option. And if other legend
        // doesn't has the item, they will assume it is selected.
        legendModel[isSelected ? "select" : "unSelect"](payload.name);
        else if (methodName === "allSelect" || methodName === "inverseSelect") legendModel[methodName]();
        else {
            legendModel[methodName](payload.name);
            isSelected = legendModel.isSelected(payload.name);
        }
        var legendData = legendModel.getData();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(legendData, function(model) {
            var name = model.get("name");
            // Wrap element
            if (name === "\n" || name === "") return;
            var isItemSelected = legendModel.isSelected(name);
            if (selectedMap.hasOwnProperty(name)) // Unselected if any legend is unselected
            selectedMap[name] = selectedMap[name] && isItemSelected;
            else selectedMap[name] = isItemSelected;
        });
    });
    // Return the event explicitly
    return methodName === "allSelect" || methodName === "inverseSelect" ? {
        selected: selectedMap
    } : {
        name: payload.name,
        selected: selectedMap
    };
}
function $19822663d90c963e$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendToggleSelect", "legendselectchanged", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "toggleSelected"));
    registers.registerAction("legendAllSelect", "legendselectall", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "allSelect"));
    registers.registerAction("legendInverseSelect", "legendinverseselect", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "inverseSelect"));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendSelect", "legendselected", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "select"));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendUnSelect", "legendunselected", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "unSelect"));
}


function $407c7fdad108ade5$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $c2e212625ccc38b4$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $c618818715ebe216$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter("legend", function() {
        return "plain";
    });
    (0, $19822663d90c963e$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a19f9768bdff02b5$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = "legend.scroll";
    ScrollableLegendModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: "end",
        pageFormatter: "{current}/{total}",
        pageIcons: {
            horizontal: [
                "M0,0L12,-10L12,10z",
                "M0,0L-12,-10L-12,10z"
            ],
            vertical: [
                "M0,0L20,0L10,-20z",
                "M0,0L20,0L10,20z"
            ]
        },
        pageIconColor: "#2f4554",
        pageIconInactiveColor: "#aaa",
        pageIconSize: 15,
        pageTextStyle: {
            color: "#333"
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(target, raw, {
        type: "box",
        ignoreSize: !!ignoreSize
    });
}
var $a19f9768bdff02b5$export$2e2bcd8739ae039 = $a19f9768bdff02b5$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $47ff4587191e73cd$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $47ff4587191e73cd$var$WH = [
    "width",
    "height"
];
var $47ff4587191e73cd$var$XY = [
    "x",
    "y"
];
var $47ff4587191e73cd$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $47ff4587191e73cd$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $47ff4587191e73cd$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get("pageIconSize", true);
        var pageIconSizeArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton("pagePrev", 0);
        var pageTextStyleModel = legendModel.getModel("pageTextStyle");
        controllerGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            name: "pageText",
            style: {
                // Placeholder to calculate a proper layout.
                text: "xx/xx",
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: "middle",
                align: "center"
            },
            silent: true
        }));
        createPageButton("pageNext", 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + "DataIndex";
            var icon = $5b455ae6f843ac47$export$274edc73af1ae9c8(legendModel.get("pageIcons", true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $7a1bd9c2710fea0d$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $47ff4587191e73cd$var$WH[orientIdx];
        var xy = $47ff4587191e73cd$var$XY[orientIdx];
        var hw = $47ff4587191e73cd$var$WH[1 - orientIdx];
        var yx = $47ff4587191e73cd$var$XY[1 - orientIdx];
        selector && $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        "horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
        var selectorButtonGap = legendModel.get("selectorButtonGap", true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $7a1bd9c2710fea0d$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === "end") selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $93b9bc7f22ac7369$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        "horizontal", controllerGroup, legendModel.get("pageButtonItemGap", true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(legendModel.get("pageButtonGap", true), legendModel.get("itemGap", true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get("pageButtonPosition", true);
            // controller is on the right / bottom.
            if (pageButtonPosition === "end") controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $8b353638fbedfefa$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: "legendScroll",
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "pagePrev",
            "pageNext"
        ], function(name) {
            var key = name + "DataIndex";
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle("fill", canJump ? legendModel.get("pageIconColor", true) : legendModel.get("pageIconInactiveColor", true));
                icon.cursor = canJump ? "pointer" : "default";
            }
        });
        var pageText = controllerGroup.childOfName("pageText");
        var pageFormatter = legendModel.get("pageFormatter");
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle("text", $7a1bd9c2710fea0d$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace("{current}", current == null ? "" : current + "").replace("{total}", total == null ? "" : total + "") : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get("scrollDataIndex", true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $47ff4587191e73cd$var$WH[orientIdx];
        var xy = $47ff4587191e73cd$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = "legend.scroll";
    return ScrollableLegendView;
}((0, $c2e212625ccc38b4$export$2e2bcd8739ae039));
var $47ff4587191e73cd$export$2e2bcd8739ae039 = $47ff4587191e73cd$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8ff9a37bcf939bdd$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction("legendScroll", "legendscroll", function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: "legend",
            subType: "scroll",
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $2861842f2dfd6682$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $407c7fdad108ade5$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $a19f9768bdff02b5$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $47ff4587191e73cd$export$2e2bcd8739ae039));
    (0, $8ff9a37bcf939bdd$export$2e2bcd8739ae039)(registers);
}


function $1a0761510a437d9f$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $407c7fdad108ade5$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2861842f2dfd6682$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $6cccca1a1040a7a1$var$InsideZoomModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InsideZoomModel, _super);
    function InsideZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = InsideZoomModel.type;
        return _this;
    }
    InsideZoomModel.type = "dataZoom.inside";
    InsideZoomModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $41d57478d16bff21$export$2e2bcd8739ae039).defaultOption, {
        disabled: false,
        zoomLock: false,
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        moveOnMouseWheel: false,
        preventDefaultMouseMove: true
    });
    return InsideZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $6cccca1a1040a7a1$export$2e2bcd8739ae039 = $6cccca1a1040a7a1$var$InsideZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.





var $6379ab7b9c3fbfb6$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6379ab7b9c3fbfb6$export$c499fdc26107c565(api, dataZoomModel, getRange) {
    $6379ab7b9c3fbfb6$var$inner(api).coordSysRecordMap.each(function(coordSysRecord) {
        var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);
        if (dzInfo) dzInfo.getRange = getRange;
    });
}
function $6379ab7b9c3fbfb6$export$d074fdbbb2bf218c(api, dataZoomModel) {
    var coordSysRecordMap = $6379ab7b9c3fbfb6$var$inner(api).coordSysRecordMap;
    var coordSysKeyArr = coordSysRecordMap.keys();
    for(var i = 0; i < coordSysKeyArr.length; i++){
        var coordSysKey = coordSysKeyArr[i];
        var coordSysRecord = coordSysRecordMap.get(coordSysKey);
        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
        if (dataZoomInfoMap) {
            var dzUid = dataZoomModel.uid;
            var dzInfo = dataZoomInfoMap.get(dzUid);
            if (dzInfo) {
                dataZoomInfoMap.removeKey(dzUid);
                if (!dataZoomInfoMap.keys().length) $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
            }
        }
    }
}
function $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
    if (coordSysRecord) {
        coordSysRecordMap.removeKey(coordSysRecord.model.uid);
        var controller = coordSysRecord.controller;
        controller && controller.dispose();
    }
}
function $6379ab7b9c3fbfb6$var$createCoordSysRecord(api, coordSysModel) {
    // These init props will never change after record created.
    var coordSysRecord = {
        model: coordSysModel,
        containsPoint: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6379ab7b9c3fbfb6$var$containsPoint, coordSysModel),
        dispatchAction: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6379ab7b9c3fbfb6$var$dispatchAction, api),
        dataZoomInfoMap: null,
        controller: null
    };
    // Must not do anything depends on coordSysRecord outside the event handler here,
    // because coordSysRecord not completed yet.
    var controller = coordSysRecord.controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "pan",
        "zoom",
        "scrollMove"
    ], function(eventName) {
        controller.on(eventName, function(event) {
            var batch = [];
            coordSysRecord.dataZoomInfoMap.each(function(dzInfo) {
                // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
                // moveOnMouseWheel, ...) enabled.
                if (!event.isAvailableBehavior(dzInfo.model.option)) return;
                var method = (dzInfo.getRange || {})[eventName];
                var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
                !dzInfo.model.get("disabled", true) && range && batch.push({
                    dataZoomId: dzInfo.model.id,
                    start: range[0],
                    end: range[1]
                });
            });
            batch.length && coordSysRecord.dispatchAction(batch);
        });
    });
    return coordSysRecord;
}
/**
 * This action will be throttled.
 */ function $6379ab7b9c3fbfb6$var$dispatchAction(api, batch) {
    if (!api.isDisposed()) api.dispatchAction({
        type: "dataZoom",
        animation: {
            easing: "cubicOut",
            duration: 100
        },
        batch: batch
    });
}
function $6379ab7b9c3fbfb6$var$containsPoint(coordSysModel, e, x, y) {
    return coordSysModel.coordinateSystem.containPoint([
        x,
        y
    ]);
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */ function $6379ab7b9c3fbfb6$var$mergeControllerParams(dataZoomInfoMap) {
    var controlType;
    // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
    // as string, it is probably revert to reserved word by compress tool. See #7411.
    var prefix = "type_";
    var typePriority = {
        "type_true": 2,
        "type_move": 1,
        "type_false": 0,
        "type_undefined": -1
    };
    var preventDefaultMouseMove = true;
    dataZoomInfoMap.each(function(dataZoomInfo) {
        var dataZoomModel = dataZoomInfo.model;
        var oneType = dataZoomModel.get("disabled", true) ? false : dataZoomModel.get("zoomLock", true) ? "move" : true;
        if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) controlType = oneType;
        // Prevent default move event by default. If one false, do not prevent. Otherwise
        // users may be confused why it does not work when multiple insideZooms exist.
        preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get("preventDefaultMouseMove", true);
    });
    return {
        controlType: controlType,
        opt: {
            // RoamController will enable all of these functionalities,
            // and the final behavior is determined by its event listener
            // provided by each inside zoom.
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
            preventDefaultMouseMove: !!preventDefaultMouseMove
        }
    };
}
function $6379ab7b9c3fbfb6$export$f3632ddafc9ea51e(registers) {
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function(ecModel, api) {
        var apiInner = $6379ab7b9c3fbfb6$var$inner(api);
        var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)());
        coordSysRecordMap.each(function(coordSysRecord) {
            // `coordSysRecordMap` always exists (because it holds the `roam controller`, which should
            // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
            coordSysRecord.dataZoomInfoMap = null;
        });
        ecModel.eachComponent({
            mainType: "dataZoom",
            subType: "inside"
        }, function(dataZoomModel) {
            var dzReferCoordSysWrap = (0, $554cb472ba0e05d3$export$b41173dee9da195b)(dataZoomModel);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dzReferCoordSysWrap.infoList, function(dzCoordSysInfo) {
                var coordSysUid = dzCoordSysInfo.model.uid;
                var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, $6379ab7b9c3fbfb6$var$createCoordSysRecord(api, dzCoordSysInfo.model));
                var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)());
                // Notice these props might be changed each time for a single dataZoomModel.
                dataZoomInfoMap.set(dataZoomModel.uid, {
                    dzReferCoordSysInfo: dzCoordSysInfo,
                    model: dataZoomModel,
                    getRange: null
                });
            });
        });
        // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
        // (2) Clear coord sys if not refered by any dataZoom.
        coordSysRecordMap.each(function(coordSysRecord) {
            var controller = coordSysRecord.controller;
            var firstDzInfo;
            var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
            if (dataZoomInfoMap) {
                var firstDzKey = dataZoomInfoMap.keys()[0];
                if (firstDzKey != null) firstDzInfo = dataZoomInfoMap.get(firstDzKey);
            }
            if (!firstDzInfo) {
                $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
                return;
            }
            var controllerParams = $6379ab7b9c3fbfb6$var$mergeControllerParams(dataZoomInfoMap);
            controller.enable(controllerParams.controlType, controllerParams.opt);
            controller.setPointerChecker(coordSysRecord.containsPoint);
            $c98659a9437a3d2e$export$958e3e1a02eac4b6(coordSysRecord, "dispatchAction", firstDzInfo.model.get("throttle", true), "fixRate");
        });
    });
}



var $ad4d16a462c12aaf$var$InsideZoomView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(InsideZoomView, _super);
    function InsideZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataZoom.inside";
        return _this;
    }
    InsideZoomView.prototype.render = function(dataZoomModel, ecModel, api) {
        _super.prototype.render.apply(this, arguments);
        if (dataZoomModel.noTarget()) {
            this._clear();
            return;
        }
        // Hence the `throttle` util ensures to preserve command order,
        // here simply updating range all the time will not cause missing
        // any of the the roam change.
        this.range = dataZoomModel.getPercentRange();
        // Reset controllers.
        $6379ab7b9c3fbfb6$export$c499fdc26107c565(api, dataZoomModel, {
            pan: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.pan, this),
            zoom: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.zoom, this),
            scrollMove: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.scrollMove, this)
        });
    };
    InsideZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    InsideZoomView.prototype._clear = function() {
        $6379ab7b9c3fbfb6$export$d074fdbbb2bf218c(this.api, this.dataZoomModel);
        this.range = null;
    };
    InsideZoomView.type = "dataZoom.inside";
    return InsideZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
var $ad4d16a462c12aaf$var$getRangeHandlers = {
    zoom: function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType](null, [
            e.originX,
            e.originY
        ], axisModel, controller, coordSysInfo);
        var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
        var scale = Math.max(1 / e.scale, 0);
        range[0] = (range[0] - percentPoint) * scale + percentPoint;
        range[1] = (range[1] - percentPoint) * scale + percentPoint;
        // Restrict range.
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, range, [
            0,
            100
        ], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    },
    pan: $ad4d16a462c12aaf$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType]([
            e.oldX,
            e.oldY
        ], [
            e.newX,
            e.newY
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
    }),
    scrollMove: $ad4d16a462c12aaf$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType]([
            0,
            0
        ], [
            e.scrollDelta,
            e.scrollDelta
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
    })
};
function $ad4d16a462c12aaf$var$makeMover(getPercentDelta) {
    return function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(percentDelta, range, [
            0,
            100
        ], "all");
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    };
}
var $ad4d16a462c12aaf$var$getDirectionInfo = {
    grid: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.dim === "x") {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // axis.dim === 'y'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    polar: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var polar = coordSysInfo.model.coordinateSystem;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var angleExtent = polar.getAngleAxis().getExtent();
        oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [
            0,
            0
        ];
        newPoint = polar.pointToCoord(newPoint);
        if (axisModel.mainType === "radiusAxis") {
            ret.pixel = newPoint[0] - oldPoint[0];
            // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
            // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
            ret.pixelLength = radiusExtent[1] - radiusExtent[0];
            ret.pixelStart = radiusExtent[0];
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'angleAxis'
            ret.pixel = newPoint[1] - oldPoint[1];
            // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
            // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
            ret.pixelLength = angleExtent[1] - angleExtent[0];
            ret.pixelStart = angleExtent[0];
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    singleAxis: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        var ret = {};
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.orient === "horizontal") {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'vertical'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    }
};
var $ad4d16a462c12aaf$export$2e2bcd8739ae039 = $ad4d16a462c12aaf$var$InsideZoomView;




function $b5ee445cd897e37a$export$4b3e715f166fdd78(registers) {
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
    registers.registerComponentModel((0, $6cccca1a1040a7a1$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ad4d16a462c12aaf$export$2e2bcd8739ae039));
    (0, $6379ab7b9c3fbfb6$export$f3632ddafc9ea51e)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8fa9b5e71c234965$var$SliderZoomModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SliderZoomModel, _super);
    function SliderZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomModel.type;
        return _this;
    }
    SliderZoomModel.type = "dataZoom.slider";
    SliderZoomModel.layoutMode = "box";
    SliderZoomModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $41d57478d16bff21$export$2e2bcd8739ae039).defaultOption, {
        show: true,
        // deault value can only be drived in view stage.
        right: "ph",
        top: "ph",
        width: "ph",
        height: "ph",
        left: null,
        bottom: null,
        borderColor: "#d2dbee",
        borderRadius: 3,
        backgroundColor: "rgba(47,69,84,0)",
        // dataBackgroundColor: '#ddd',
        dataBackground: {
            lineStyle: {
                color: "#d2dbee",
                width: 0.5
            },
            areaStyle: {
                color: "#d2dbee",
                opacity: 0.2
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: "#8fb0f7",
                width: 0.5
            },
            areaStyle: {
                color: "#8fb0f7",
                opacity: 0.2
            }
        },
        // Color of selected window.
        fillerColor: "rgba(135,175,274,0.2)",
        handleIcon: "path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z",
        // Percent of the slider height
        handleSize: "100%",
        handleStyle: {
            color: "#fff",
            borderColor: "#ACB8D1"
        },
        moveHandleSize: 7,
        moveHandleIcon: "path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z",
        moveHandleStyle: {
            color: "#D2DBEE",
            opacity: 0.7
        },
        showDetail: true,
        showDataShadow: "auto",
        realtime: true,
        zoomLock: false,
        textStyle: {
            color: "#6E7079"
        },
        brushSelect: true,
        brushStyle: {
            color: "rgba(135,175,274,0.15)"
        },
        emphasis: {
            handleStyle: {
                borderColor: "#8FB0F7"
            },
            moveHandleStyle: {
                color: "#8FB0F7"
            }
        }
    });
    return SliderZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $8fa9b5e71c234965$export$2e2bcd8739ae039 = $8fa9b5e71c234965$var$SliderZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 













var $eee50458c1b708ef$var$Rect = $419e5ff2f303755e$export$2e2bcd8739ae039;
// Constants
var $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP = 7;
var $eee50458c1b708ef$var$DEFAULT_FRAME_BORDER_WIDTH = 1;
var $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE = 30;
var $eee50458c1b708ef$var$DEFAULT_MOVE_HANDLE_SIZE = 7;
var $eee50458c1b708ef$var$HORIZONTAL = "horizontal";
var $eee50458c1b708ef$var$VERTICAL = "vertical";
var $eee50458c1b708ef$var$LABEL_GAP = 5;
var $eee50458c1b708ef$var$SHOW_DATA_SHADOW_SERIES_TYPE = [
    "line",
    "bar",
    "candlestick",
    "scatter"
];
var $eee50458c1b708ef$var$REALTIME_ANIMATION_CONFIG = {
    easing: "cubicOut",
    duration: 100,
    delay: 0
};
var $eee50458c1b708ef$var$SliderZoomView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SliderZoomView, _super);
    function SliderZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomView.type;
        _this._displayables = {};
        return _this;
    }
    SliderZoomView.prototype.init = function(ecModel, api) {
        this.api = api;
        // A unique handler for each dataZoom component
        this._onBrush = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onBrush, this);
        this._onBrushEnd = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onBrushEnd, this);
    };
    SliderZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        _super.prototype.render.apply(this, arguments);
        $c98659a9437a3d2e$export$958e3e1a02eac4b6(this, "_dispatchZoomAction", dataZoomModel.get("throttle"), "fixRate");
        this._orient = dataZoomModel.getOrient();
        if (dataZoomModel.get("show") === false) {
            this.group.removeAll();
            return;
        }
        if (dataZoomModel.noTarget()) {
            this._clear();
            this.group.removeAll();
            return;
        }
        // Notice: this._resetInterval() should not be executed when payload.type
        // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
        // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
        if (!payload || payload.type !== "dataZoom" || payload.from !== this.uid) this._buildView();
        this._updateView();
    };
    SliderZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    SliderZoomView.prototype._clear = function() {
        $c98659a9437a3d2e$export$42ffd38884aecdac(this, "_dispatchZoomAction");
        var zr = this.api.getZr();
        zr.off("mousemove", this._onBrush);
        zr.off("mouseup", this._onBrushEnd);
    };
    SliderZoomView.prototype._buildView = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        this._brushing = false;
        this._displayables.brushRect = null;
        this._resetLocation();
        this._resetInterval();
        var barGroup = this._displayables.sliderGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._renderBackground();
        this._renderHandle();
        this._renderDataShadow();
        thisGroup.add(barGroup);
        this._positionGroup();
    };
    SliderZoomView.prototype._resetLocation = function() {
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var showMoveHandle = dataZoomModel.get("brushSelect");
        var moveHandleSize = showMoveHandle ? $eee50458c1b708ef$var$DEFAULT_MOVE_HANDLE_SIZE : 0;
        // If some of x/y/width/height are not specified,
        // auto-adapt according to target grid.
        var coordRect = this._findCoordRect();
        var ecSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        // Default align by coordinate system rect.
        var positionInfo = this._orient === $eee50458c1b708ef$var$HORIZONTAL ? {
            // Why using 'right', because right should be used in vertical,
            // and it is better to be consistent for dealing with position param merge.
            right: ecSize.width - coordRect.x - coordRect.width,
            top: ecSize.height - $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE - $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP - moveHandleSize,
            width: coordRect.width,
            height: $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE
        } : {
            right: $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP,
            top: coordRect.y,
            width: $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE,
            height: coordRect.height
        };
        // Do not write back to option and replace value 'ph', because
        // the 'ph' value should be recalculated when resize.
        var layoutParams = $93b9bc7f22ac7369$export$4b0d20af19c9875e(dataZoomModel.option);
        // Replace the placeholder value.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "right",
            "top",
            "width",
            "height"
        ], function(name) {
            if (layoutParams[name] === "ph") layoutParams[name] = positionInfo[name];
        });
        var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutParams, ecSize);
        this._location = {
            x: layoutRect.x,
            y: layoutRect.y
        };
        this._size = [
            layoutRect.width,
            layoutRect.height
        ];
        this._orient === $eee50458c1b708ef$var$VERTICAL && this._size.reverse();
    };
    SliderZoomView.prototype._positionGroup = function() {
        var thisGroup = this.group;
        var location = this._location;
        var orient = this._orient;
        // Just use the first axis to determine mapping.
        var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
        var inverse = targetAxisModel && targetAxisModel.get("inverse");
        var sliderGroup = this._displayables.sliderGroup;
        var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse;
        // Transform barGroup.
        sliderGroup.attr(orient === $eee50458c1b708ef$var$HORIZONTAL && !inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: 1
        } : orient === $eee50458c1b708ef$var$HORIZONTAL && inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: -1
        } : orient === $eee50458c1b708ef$var$VERTICAL && !inverse ? {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: 1,
            rotation: Math.PI / 2
        } : {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: -1,
            rotation: Math.PI / 2
        });
        // Position barGroup
        var rect = thisGroup.getBoundingRect([
            sliderGroup
        ]);
        thisGroup.x = location.x - rect.x;
        thisGroup.y = location.y - rect.y;
        thisGroup.markRedraw();
    };
    SliderZoomView.prototype._getViewExtent = function() {
        return [
            0,
            this._size[0]
        ];
    };
    SliderZoomView.prototype._renderBackground = function() {
        var dataZoomModel = this.dataZoomModel;
        var size = this._size;
        var barGroup = this._displayables.sliderGroup;
        var brushSelect = dataZoomModel.get("brushSelect");
        barGroup.add(new $eee50458c1b708ef$var$Rect({
            silent: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: dataZoomModel.get("backgroundColor")
            },
            z2: -40
        }));
        // Click panel, over shadow, below handles.
        var clickPanel = new $eee50458c1b708ef$var$Rect({
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: "transparent"
            },
            z2: 0,
            onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onClickPanel, this)
        });
        var zr = this.api.getZr();
        if (brushSelect) {
            clickPanel.on("mousedown", this._onBrushStart, this);
            clickPanel.cursor = "crosshair";
            zr.on("mousemove", this._onBrush);
            zr.on("mouseup", this._onBrushEnd);
        } else {
            zr.off("mousemove", this._onBrush);
            zr.off("mouseup", this._onBrushEnd);
        }
        barGroup.add(clickPanel);
    };
    SliderZoomView.prototype._renderDataShadow = function() {
        var info = this._dataShadowInfo = this._prepareDataShadowInfo();
        this._displayables.dataShadowSegs = [];
        if (!info) return;
        var size = this._size;
        var oldSize = this._shadowSize || [];
        var seriesModel = info.series;
        var data = seriesModel.getRawData();
        var candlestickDim = seriesModel.getShadowDim && seriesModel.getShadowDim();
        var otherDim = candlestickDim && data.getDimensionInfo(candlestickDim) ? seriesModel.getShadowDim() // @see candlestick
         : info.otherDim;
        if (otherDim == null) return;
        var polygonPts = this._shadowPolygonPts;
        var polylinePts = this._shadowPolylinePts;
        // Not re-render if data doesn't change.
        if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            var otherDataExtent_1 = data.getDataExtent(otherDim);
            // Nice extent.
            var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
            otherDataExtent_1 = [
                otherDataExtent_1[0] - otherOffset,
                otherDataExtent_1[1] + otherOffset
            ];
            var otherShadowExtent_1 = [
                0,
                size[1]
            ];
            var thisShadowExtent = [
                0,
                size[0]
            ];
            var areaPoints_1 = [
                [
                    size[0],
                    0
                ],
                [
                    0,
                    0
                ]
            ];
            var linePoints_1 = [];
            var step_1 = thisShadowExtent[1] / (data.count() - 1);
            var thisCoord_1 = 0;
            // Optimize for large data shadow
            var stride_1 = Math.round(data.count() / size[0]);
            var lastIsEmpty_1;
            data.each([
                otherDim
            ], function(value, index) {
                if (stride_1 > 0 && index % stride_1) {
                    thisCoord_1 += step_1;
                    return;
                }
                // FIXME
                // Should consider axis.min/axis.max when drawing dataShadow.
                // FIXME
                // 应该使用统一的空判断？还是在list里进行空判断？
                var isEmpty = value == null || isNaN(value) || value === "";
                // See #4235.
                var otherCoord = isEmpty ? 0 : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, otherDataExtent_1, otherShadowExtent_1, true);
                // Attempt to draw data shadow precisely when there are empty value.
                if (isEmpty && !lastIsEmpty_1 && index) {
                    areaPoints_1.push([
                        areaPoints_1[areaPoints_1.length - 1][0],
                        0
                    ]);
                    linePoints_1.push([
                        linePoints_1[linePoints_1.length - 1][0],
                        0
                    ]);
                } else if (!isEmpty && lastIsEmpty_1) {
                    areaPoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                    linePoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                }
                areaPoints_1.push([
                    thisCoord_1,
                    otherCoord
                ]);
                linePoints_1.push([
                    thisCoord_1,
                    otherCoord
                ]);
                thisCoord_1 += step_1;
                lastIsEmpty_1 = isEmpty;
            });
            polygonPts = this._shadowPolygonPts = areaPoints_1;
            polylinePts = this._shadowPolylinePts = linePoints_1;
        }
        this._shadowData = data;
        this._shadowDim = otherDim;
        this._shadowSize = [
            size[0],
            size[1]
        ];
        var dataZoomModel = this.dataZoomModel;
        function createDataShadowGroup(isSelectedArea) {
            var model = dataZoomModel.getModel(isSelectedArea ? "selectedDataBackground" : "dataBackground");
            var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            var polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                shape: {
                    points: polygonPts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel("areaStyle").getAreaStyle(),
                silent: true,
                z2: -20
            });
            var polyline = new $d28119f30e6bb670$export$2e2bcd8739ae039({
                shape: {
                    points: polylinePts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel("lineStyle").getLineStyle(),
                silent: true,
                z2: -19
            });
            group.add(polygon);
            group.add(polyline);
            return group;
        }
        // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');
        for(var i = 0; i < 3; i++){
            var group = createDataShadowGroup(i === 1);
            this._displayables.sliderGroup.add(group);
            this._displayables.dataShadowSegs.push(group);
        }
    };
    SliderZoomView.prototype._prepareDataShadowInfo = function() {
        var dataZoomModel = this.dataZoomModel;
        var showDataShadow = dataZoomModel.get("showDataShadow");
        if (showDataShadow === false) return;
        // Find a representative series.
        var result;
        var ecModel = this.ecModel;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
                if (result) return;
                if (showDataShadow !== true && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($eee50458c1b708ef$var$SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get("type")) < 0) return;
                var thisAxis = ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex).axis;
                var otherDim = $eee50458c1b708ef$var$getOtherDim(axisDim);
                var otherAxisInverse;
                var coordSys = seriesModel.coordinateSystem;
                if (otherDim != null && coordSys.getOtherAxis) otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
                otherDim = seriesModel.getData().mapDimension(otherDim);
                result = {
                    thisAxis: thisAxis,
                    series: seriesModel,
                    thisDim: axisDim,
                    otherDim: otherDim,
                    otherAxisInverse: otherAxisInverse
                };
            }, this);
        }, this);
        return result;
    };
    SliderZoomView.prototype._renderHandle = function() {
        var thisGroup = this.group;
        var displayables = this._displayables;
        var handles = displayables.handles = [
            null,
            null
        ];
        var handleLabels = displayables.handleLabels = [
            null,
            null
        ];
        var sliderGroup = this._displayables.sliderGroup;
        var size = this._size;
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var borderRadius = dataZoomModel.get("borderRadius") || 0;
        var brushSelect = dataZoomModel.get("brushSelect");
        var filler = displayables.filler = new $eee50458c1b708ef$var$Rect({
            silent: brushSelect,
            style: {
                fill: dataZoomModel.get("fillerColor")
            },
            textConfig: {
                position: "inside"
            }
        });
        sliderGroup.add(filler);
        // Frame border.
        sliderGroup.add(new $eee50458c1b708ef$var$Rect({
            silent: true,
            subPixelOptimize: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1],
                r: borderRadius
            },
            style: {
                // deprecated option
                stroke: dataZoomModel.get("dataBackgroundColor") || dataZoomModel.get("borderColor"),
                lineWidth: $eee50458c1b708ef$var$DEFAULT_FRAME_BORDER_WIDTH,
                fill: "rgba(0,0,0,0)"
            }
        }));
        // Left and right handle to resize
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            var iconStr = dataZoomModel.get("handleIcon");
            if (!(0, $5370466dadc978d7$export$33fc3b478d332725)[iconStr] && iconStr.indexOf("path://") < 0 && iconStr.indexOf("image://") < 0) // Compatitable with the old icon parsers. Which can use a path string without path://
            iconStr = "path://" + iconStr;
            var path = (0, $5370466dadc978d7$export$af050e04da3a02e8)(iconStr, -1, 0, 2, 2, null, true);
            path.attr({
                cursor: $eee50458c1b708ef$var$getCursor(this._orient),
                draggable: true,
                drift: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragMove, this, handleIndex),
                ondragend: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragEnd, this),
                onmouseover: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
                onmouseout: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, false),
                z2: 5
            });
            var bRect = path.getBoundingRect();
            var handleSize = dataZoomModel.get("handleSize");
            this._handleHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(handleSize, this._size[1]);
            this._handleWidth = bRect.width / bRect.height * this._handleHeight;
            path.setStyle(dataZoomModel.getModel("handleStyle").getItemStyle());
            path.style.strokeNoScale = true;
            path.rectHover = true;
            path.ensureState("emphasis").style = dataZoomModel.getModel([
                "emphasis",
                "handleStyle"
            ]).getItemStyle();
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(path);
            var handleColor = dataZoomModel.get("handleColor"); // deprecated option
            // Compatitable with previous version
            if (handleColor != null) path.style.fill = handleColor;
            sliderGroup.add(handles[handleIndex] = path);
            var textStyleModel = dataZoomModel.getModel("textStyle");
            thisGroup.add(handleLabels[handleIndex] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true,
                invisible: true,
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                    x: 0,
                    y: 0,
                    text: "",
                    verticalAlign: "middle",
                    align: "center",
                    fill: textStyleModel.getTextColor(),
                    font: textStyleModel.getFont()
                }),
                z2: 10
            }));
        }, this);
        // Handle to move. Only visible when brushSelect is set true.
        var actualMoveZone = filler;
        if (brushSelect) {
            var moveHandleHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(dataZoomModel.get("moveHandleSize"), size[1]);
            var moveHandle_1 = displayables.moveHandle = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                style: dataZoomModel.getModel("moveHandleStyle").getItemStyle(),
                silent: true,
                shape: {
                    r: [
                        0,
                        0,
                        2,
                        2
                    ],
                    y: size[1] - 0.5,
                    height: moveHandleHeight
                }
            });
            var iconSize = moveHandleHeight * 0.8;
            var moveHandleIcon = displayables.moveHandleIcon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(dataZoomModel.get("moveHandleIcon"), -iconSize / 2, -iconSize / 2, iconSize, iconSize, "#fff", true);
            moveHandleIcon.silent = true;
            moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
            moveHandle_1.ensureState("emphasis").style = dataZoomModel.getModel([
                "emphasis",
                "moveHandleStyle"
            ]).getItemStyle();
            var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
            actualMoveZone = displayables.moveZone = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                invisible: true,
                shape: {
                    y: size[1] - moveZoneExpandSize,
                    height: moveHandleHeight + moveZoneExpandSize
                }
            });
            actualMoveZone.on("mouseover", function() {
                api.enterEmphasis(moveHandle_1);
            }).on("mouseout", function() {
                api.leaveEmphasis(moveHandle_1);
            });
            sliderGroup.add(moveHandle_1);
            sliderGroup.add(moveHandleIcon);
            sliderGroup.add(actualMoveZone);
        }
        actualMoveZone.attr({
            draggable: true,
            cursor: $eee50458c1b708ef$var$getCursor(this._orient),
            drift: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragMove, this, "all"),
            ondragstart: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
            ondragend: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragEnd, this),
            onmouseover: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
            onmouseout: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, false)
        });
    };
    SliderZoomView.prototype._resetInterval = function() {
        var range = this._range = this.dataZoomModel.getPercentRange();
        var viewExtent = this._getViewExtent();
        this._handleEnds = [
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(range[0], [
                0,
                100
            ], viewExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(range[1], [
                0,
                100
            ], viewExtent, true)
        ];
    };
    SliderZoomView.prototype._updateInterval = function(handleIndex, delta) {
        var dataZoomModel = this.dataZoomModel;
        var handleEnds = this._handleEnds;
        var viewExtend = this._getViewExtent();
        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        var percentExtent = [
            0,
            100
        ];
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, handleEnds, viewExtend, dataZoomModel.get("zoomLock") ? "all" : handleIndex, minMaxSpan.minSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        var lastRange = this._range;
        var range = this._range = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)([
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[0], viewExtend, percentExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
    };
    SliderZoomView.prototype._updateView = function(nonRealtime) {
        var displaybles = this._displayables;
        var handleEnds = this._handleEnds;
        var handleInterval = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(handleEnds.slice());
        var size = this._size;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            // Handles
            var handle = displaybles.handles[handleIndex];
            var handleHeight = this._handleHeight;
            handle.attr({
                scaleX: handleHeight / 2,
                scaleY: handleHeight / 2,
                // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
                // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
                x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
                y: size[1] / 2 - handleHeight / 2
            });
        }, this);
        // Filler
        displaybles.filler.setShape({
            x: handleInterval[0],
            y: 0,
            width: handleInterval[1] - handleInterval[0],
            height: size[1]
        });
        var viewExtent = {
            x: handleInterval[0],
            width: handleInterval[1] - handleInterval[0]
        };
        // Move handle
        if (displaybles.moveHandle) {
            displaybles.moveHandle.setShape(viewExtent);
            displaybles.moveZone.setShape(viewExtent);
            // Force update path on the invisible object
            displaybles.moveZone.getBoundingRect();
            displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr("x", viewExtent.x + viewExtent.width / 2);
        }
        // update clip path of shadow.
        var dataShadowSegs = displaybles.dataShadowSegs;
        var segIntervals = [
            0,
            handleInterval[0],
            handleInterval[1],
            size[0]
        ];
        for(var i = 0; i < dataShadowSegs.length; i++){
            var segGroup = dataShadowSegs[i];
            var clipPath = segGroup.getClipPath();
            if (!clipPath) {
                clipPath = new $419e5ff2f303755e$export$2e2bcd8739ae039();
                segGroup.setClipPath(clipPath);
            }
            clipPath.setShape({
                x: segIntervals[i],
                y: 0,
                width: segIntervals[i + 1] - segIntervals[i],
                height: size[1]
            });
        }
        this._updateDataInfo(nonRealtime);
    };
    SliderZoomView.prototype._updateDataInfo = function(nonRealtime) {
        var dataZoomModel = this.dataZoomModel;
        var displaybles = this._displayables;
        var handleLabels = displaybles.handleLabels;
        var orient = this._orient;
        var labelTexts = [
            "",
            ""
        ];
        // FIXME
        // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
        if (dataZoomModel.get("showDetail")) {
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var axis = axisProxy.getAxisModel().axis;
                var range = this._range;
                var dataInterval = nonRealtime ? axisProxy.calculateDataWindow({
                    start: range[0],
                    end: range[1]
                }).valueWindow : axisProxy.getDataValueWindow();
                labelTexts = [
                    this._formatLabel(dataInterval[0], axis),
                    this._formatLabel(dataInterval[1], axis)
                ];
            }
        }
        var orderedHandleEnds = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(this._handleEnds.slice());
        setLabel.call(this, 0);
        setLabel.call(this, 1);
        function setLabel(handleIndex) {
            // Label
            // Text should not transform by barGroup.
            // Ignore handlers transform
            var barTransform = $5b455ae6f843ac47$export$fce0c6cfca85ed96(displaybles.handles[handleIndex].parent, this.group);
            var direction = $5b455ae6f843ac47$export$fff94e9792354cfa(handleIndex === 0 ? "right" : "left", barTransform);
            var offset = this._handleWidth / 2 + $eee50458c1b708ef$var$LABEL_GAP;
            var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623([
                orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset),
                this._size[1] / 2
            ], barTransform);
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                verticalAlign: orient === $eee50458c1b708ef$var$HORIZONTAL ? "middle" : direction,
                align: orient === $eee50458c1b708ef$var$HORIZONTAL ? direction : "center",
                text: labelTexts[handleIndex]
            });
        }
    };
    SliderZoomView.prototype._formatLabel = function(value, axis) {
        var dataZoomModel = this.dataZoomModel;
        var labelFormatter = dataZoomModel.get("labelFormatter");
        var labelPrecision = dataZoomModel.get("labelPrecision");
        if (labelPrecision == null || labelPrecision === "auto") labelPrecision = axis.getPixelPrecision();
        var valueStr = value == null || isNaN(value) ? "" : axis.type === "category" || axis.type === "time" ? axis.scale.getLabel({
            value: Math.round(value)
        }) : value.toFixed(Math.min(labelPrecision, 20));
        return (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelFormatter) ? labelFormatter(value, valueStr) : (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelFormatter) ? labelFormatter.replace("{value}", valueStr) : valueStr;
    };
    /**
   * @param showOrHide true: show, false: hide
   */ SliderZoomView.prototype._showDataInfo = function(showOrHide) {
        // Always show when drgging.
        showOrHide = this._dragging || showOrHide;
        var displayables = this._displayables;
        var handleLabels = displayables.handleLabels;
        handleLabels[0].attr("invisible", !showOrHide);
        handleLabels[1].attr("invisible", !showOrHide);
        // Highlight move handle
        displayables.moveHandle && this.api[showOrHide ? "enterEmphasis" : "leaveEmphasis"](displayables.moveHandle, 1);
    };
    SliderZoomView.prototype._onDragMove = function(handleIndex, dx, dy, event) {
        this._dragging = true;
        // For mobile device, prevent screen slider on the button.
        $b3864a78637ff9ed$export$fa6813432f753b0d(event.event);
        // Transform dx, dy to bar coordination.
        var barTransform = this._displayables.sliderGroup.getLocalTransform();
        var vertex = $5b455ae6f843ac47$export$9f9dcb98c894b623([
            dx,
            dy
        ], barTransform, true);
        var changed = this._updateInterval(handleIndex, vertex[0]);
        var realtime = this.dataZoomModel.get("realtime");
        this._updateView(!realtime);
        // Avoid dispatch dataZoom repeatly but range not changed,
        // which cause bad visual effect when progressive enabled.
        changed && realtime && this._dispatchZoomAction(true);
    };
    SliderZoomView.prototype._onDragEnd = function() {
        this._dragging = false;
        this._showDataInfo(false);
        // While in realtime mode and stream mode, dispatch action when
        // drag end will cause the whole view rerender, which is unnecessary.
        var realtime = this.dataZoomModel.get("realtime");
        !realtime && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onClickPanel = function(e) {
        var size = this._size;
        var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);
        if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) return;
        var handleEnds = this._handleEnds;
        var center = (handleEnds[0] + handleEnds[1]) / 2;
        var changed = this._updateInterval("all", localPoint[0] - center);
        this._updateView();
        changed && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrushStart = function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        this._brushStart = new $b887f038f104fe7e$export$2e2bcd8739ae039(x, y);
        this._brushing = true;
        this._brushStartTime = +new Date();
    // this._updateBrushRect(x, y);
    };
    SliderZoomView.prototype._onBrushEnd = function(e) {
        if (!this._brushing) return;
        var brushRect = this._displayables.brushRect;
        this._brushing = false;
        if (!brushRect) return;
        brushRect.attr("ignore", true);
        var brushShape = brushRect.shape;
        var brushEndTime = +new Date();
        // console.log(brushEndTime - this._brushStartTime);
        if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) // Will treat it as a click
        return;
        var viewExtend = this._getViewExtent();
        var percentExtent = [
            0,
            100
        ];
        this._range = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)([
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(brushShape.x, viewExtend, percentExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(brushShape.x + brushShape.width, viewExtend, percentExtent, true)
        ]);
        this._handleEnds = [
            brushShape.x,
            brushShape.x + brushShape.width
        ];
        this._updateView();
        this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrush = function(e) {
        if (this._brushing) {
            // For mobile device, prevent screen slider on the button.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            this._updateBrushRect(e.offsetX, e.offsetY);
        }
    };
    SliderZoomView.prototype._updateBrushRect = function(mouseX, mouseY) {
        var displayables = this._displayables;
        var dataZoomModel = this.dataZoomModel;
        var brushRect = displayables.brushRect;
        if (!brushRect) {
            brushRect = displayables.brushRect = new $eee50458c1b708ef$var$Rect({
                silent: true,
                style: dataZoomModel.getModel("brushStyle").getItemStyle()
            });
            displayables.sliderGroup.add(brushRect);
        }
        brushRect.attr("ignore", false);
        var brushStart = this._brushStart;
        var sliderGroup = this._displayables.sliderGroup;
        var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
        var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
        var size = this._size;
        endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
        brushRect.setShape({
            x: startPoint[0],
            y: 0,
            width: endPoint[0] - startPoint[0],
            height: size[1]
        });
    };
    /**
   * This action will be throttled.
   */ SliderZoomView.prototype._dispatchZoomAction = function(realtime) {
        var range = this._range;
        this.api.dispatchAction({
            type: "dataZoom",
            from: this.uid,
            dataZoomId: this.dataZoomModel.id,
            animation: realtime ? $eee50458c1b708ef$var$REALTIME_ANIMATION_CONFIG : null,
            start: range[0],
            end: range[1]
        });
    };
    SliderZoomView.prototype._findCoordRect = function() {
        // Find the grid corresponding to the first axis referred by dataZoom.
        var rect;
        var coordSysInfoList = (0, $554cb472ba0e05d3$export$b41173dee9da195b)(this.dataZoomModel).infoList;
        if (!rect && coordSysInfoList.length) {
            var coordSys = coordSysInfoList[0].model.coordinateSystem;
            rect = coordSys.getRect && coordSys.getRect();
        }
        if (!rect) {
            var width = this.api.getWidth();
            var height = this.api.getHeight();
            rect = {
                x: width * 0.2,
                y: height * 0.2,
                width: width * 0.6,
                height: height * 0.6
            };
        }
        return rect;
    };
    SliderZoomView.type = "dataZoom.slider";
    return SliderZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
function $eee50458c1b708ef$var$getOtherDim(thisDim) {
    // FIXME
    // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
    var map = {
        x: "y",
        y: "x",
        radius: "angle",
        angle: "radius"
    };
    return map[thisDim];
}
function $eee50458c1b708ef$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $eee50458c1b708ef$export$2e2bcd8739ae039 = $eee50458c1b708ef$var$SliderZoomView;



function $794c23331e97718e$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $8fa9b5e71c234965$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $eee50458c1b708ef$export$2e2bcd8739ae039));
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
}


function $aa2dc70f9fa9453b$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b5ee445cd897e37a$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $794c23331e97718e$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual mapping.
 */ 
var $ef3bd976f9d1f7a2$var$visualDefault = {
    /**
   * @public
   */ get: function(visualType, key, isCategory) {
        var value = $7a1bd9c2710fea0d$export$9cd59f9826255e47(($ef3bd976f9d1f7a2$var$defaultOption[visualType] || {})[key]);
        return isCategory ? $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) ? value[value.length - 1] : value : value;
    }
};
var $ef3bd976f9d1f7a2$var$defaultOption = {
    color: {
        active: [
            "#006edd",
            "#e0ffff"
        ],
        inactive: [
            "rgba(0,0,0,0)"
        ]
    },
    colorHue: {
        active: [
            0,
            360
        ],
        inactive: [
            0,
            0
        ]
    },
    colorSaturation: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    colorLightness: {
        active: [
            0.9,
            0.5
        ],
        inactive: [
            0,
            0
        ]
    },
    colorAlpha: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    opacity: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    symbol: {
        active: [
            "circle",
            "roundRect",
            "diamond"
        ],
        inactive: [
            "none"
        ]
    },
    symbolSize: {
        active: [
            10,
            50
        ],
        inactive: [
            0,
            0
        ]
    }
};
var $ef3bd976f9d1f7a2$export$2e2bcd8739ae039 = $ef3bd976f9d1f7a2$var$visualDefault;







var $fca0c970f405ff38$var$mapVisual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).mapVisual;
var $fca0c970f405ff38$var$eachVisual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).eachVisual;
var $fca0c970f405ff38$var$isArray = $7a1bd9c2710fea0d$export$43bee75e5e14138e;
var $fca0c970f405ff38$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $fca0c970f405ff38$var$asc = $cfc1f3b422a3185f$export$debe6e778e0a6d32;
var $fca0c970f405ff38$var$linearMap = $cfc1f3b422a3185f$export$d3f68fbaa670562;
var $fca0c970f405ff38$var$VisualMapModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(VisualMapModel, _super);
    function VisualMapModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapModel.type;
        _this.stateList = [
            "inRange",
            "outOfRange"
        ];
        _this.replacableOptionKeys = [
            "inRange",
            "outOfRange",
            "target",
            "controller",
            "color"
        ];
        _this.layoutMode = {
            type: "box",
            ignoreSize: true
        };
        /**
     * [lowerBound, upperBound]
     */ _this.dataBound = [
            -Infinity,
            Infinity
        ];
        _this.targetVisuals = {};
        _this.controllerVisuals = {};
        return _this;
    }
    VisualMapModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    /**
   * @protected
   */ VisualMapModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, this.replacableOptionKeys);
        this.textStyleModel = this.getModel("textStyle");
        this.resetItemSize();
        this.completeVisualOption();
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetVisual = function(supplementVisualOption) {
        var stateList = this.stateList;
        supplementVisualOption = $7a1bd9c2710fea0d$export$2385a24977818dd0(supplementVisualOption, this);
        this.controllerVisuals = $87ea23222d1c134e$export$89974527642f24a0(this.option.controller, stateList, supplementVisualOption);
        this.targetVisuals = $87ea23222d1c134e$export$89974527642f24a0(this.option.target, stateList, supplementVisualOption);
    };
    /**
   * @public
   */ VisualMapModel.prototype.getItemSymbol = function() {
        return null;
    };
    /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */ VisualMapModel.prototype.getTargetSeriesIndices = function() {
        var optionSeriesIndex = this.option.seriesIndex;
        var seriesIndices = [];
        if (optionSeriesIndex == null || optionSeriesIndex === "all") this.ecModel.eachSeries(function(seriesModel, index) {
            seriesIndices.push(index);
        });
        else seriesIndices = $76d619f648247e6d$export$4f07b212a02c8051(optionSeriesIndex);
        return seriesIndices;
    };
    /**
   * @public
   */ VisualMapModel.prototype.eachTargetSeries = function(callback, context) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.getTargetSeriesIndices(), function(seriesIndex) {
            var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);
            if (seriesModel) callback.call(context, seriesModel);
        }, this);
    };
    /**
   * @pubilc
   */ VisualMapModel.prototype.isTargetSeries = function(seriesModel) {
        var is = false;
        this.eachTargetSeries(function(model) {
            model === seriesModel && (is = true);
        });
        return is;
    };
    /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */ VisualMapModel.prototype.formatValueText = function(value, isCategory, edgeSymbols) {
        var option = this.option;
        var precision = option.precision;
        var dataBound = this.dataBound;
        var formatter = option.formatter;
        var isMinMax;
        edgeSymbols = edgeSymbols || [
            "<",
            ">"
        ];
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(value)) {
            value = value.slice();
            isMinMax = true;
        }
        var textValue = isCategory ? value // Value is string when isCategory
         : isMinMax ? [
            toFixed(value[0]),
            toFixed(value[1])
        ] : toFixed(value);
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) return formatter.replace("{value}", isMinMax ? textValue[0] : textValue).replace("{value2}", isMinMax ? textValue[1] : textValue);
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) return isMinMax ? formatter(value[0], value[1]) : formatter(value);
        if (isMinMax) {
            if (value[0] === dataBound[0]) return edgeSymbols[0] + " " + textValue[1];
            else if (value[1] === dataBound[1]) return edgeSymbols[1] + " " + textValue[0];
            else return textValue[0] + " - " + textValue[1];
        } else // Format single value (includes category case).
        return textValue;
        function toFixed(val) {
            return val === dataBound[0] ? "min" : val === dataBound[1] ? "max" : (+val).toFixed(Math.min(precision, 20));
        }
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetExtent = function() {
        var thisOption = this.option;
        // Can not calculate data extent by data here.
        // Because series and data may be modified in processing stage.
        // So we do not support the feature "auto min/max".
        var extent = $fca0c970f405ff38$var$asc([
            thisOption.min,
            thisOption.max
        ]);
        this._dataExtent = extent;
    };
    /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimension. If null/undefined is returned, no dimension is used.
   */ // getDataDimension(data: SeriesData) {
    //     const optDim = this.option.dimension;
    //     if (optDim != null) {
    //         return data.getDimension(optDim);
    //     }
    //     const dimNames = data.dimensions;
    //     for (let i = dimNames.length - 1; i >= 0; i--) {
    //         const dimName = dimNames[i];
    //         const dimInfo = data.getDimensionInfo(dimName);
    //         if (!dimInfo.isCalculationCoord) {
    //             return dimName;
    //         }
    //     }
    // }
    VisualMapModel.prototype.getDataDimensionIndex = function(data) {
        var optDim = this.option.dimension;
        if (optDim != null) return data.getDimensionIndex(optDim);
        var dimNames = data.dimensions;
        for(var i = dimNames.length - 1; i >= 0; i--){
            var dimName = dimNames[i];
            var dimInfo = data.getDimensionInfo(dimName);
            if (!dimInfo.isCalculationCoord) return dimInfo.storeDimIndex;
        }
    };
    VisualMapModel.prototype.getExtent = function() {
        return this._dataExtent.slice();
    };
    VisualMapModel.prototype.completeVisualOption = function() {
        var ecModel = this.ecModel;
        var thisOption = this.option;
        var base = {
            inRange: thisOption.inRange,
            outOfRange: thisOption.outOfRange
        };
        var target = thisOption.target || (thisOption.target = {});
        var controller = thisOption.controller || (thisOption.controller = {});
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(target, base); // Do not override
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(controller, base); // Do not override
        var isCategory = this.isCategory();
        completeSingle.call(this, target);
        completeSingle.call(this, controller);
        completeInactive.call(this, target, "inRange", "outOfRange");
        // completeInactive.call(this, target, 'outOfRange', 'inRange');
        completeController.call(this, controller);
        function completeSingle(base) {
            // Compatible with ec2 dataRange.color.
            // The mapping order of dataRange.color is: [high value, ..., low value]
            // whereas inRange.color and outOfRange.color is [low value, ..., high value]
            // Notice: ec2 has no inverse.
            if ($fca0c970f405ff38$var$isArray(thisOption.color) && !base.inRange) base.inRange = {
                color: thisOption.color.slice().reverse()
            };
            // Compatible with previous logic, always give a default color, otherwise
            // simple config with no inRange and outOfRange will not work.
            // Originally we use visualMap.color as the default color, but setOption at
            // the second time the default color will be erased. So we change to use
            // constant DEFAULT_COLOR.
            // If user do not want the default color, set inRange: {color: null}.
            base.inRange = base.inRange || {
                color: ecModel.get("gradientColor")
            };
        }
        function completeInactive(base, stateExist, stateAbsent) {
            var optExist = base[stateExist];
            var optAbsent = base[stateAbsent];
            if (optExist && !optAbsent) {
                optAbsent = base[stateAbsent] = {};
                $fca0c970f405ff38$var$each(optExist, function(visualData, visualType) {
                    if (!(0, $7b50f502cfd189d5$export$2e2bcd8739ae039).isValidType(visualType)) return;
                    var defa = (0, $ef3bd976f9d1f7a2$export$2e2bcd8739ae039).get(visualType, "inactive", isCategory);
                    if (defa != null) {
                        optAbsent[visualType] = defa;
                        // Compatibable with ec2:
                        // Only inactive color to rgba(0,0,0,0) can not
                        // make label transparent, so use opacity also.
                        if (visualType === "color" && !optAbsent.hasOwnProperty("opacity") && !optAbsent.hasOwnProperty("colorAlpha")) optAbsent.opacity = [
                            0,
                            0
                        ];
                    }
                });
            }
        }
        function completeController(controller) {
            var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
            var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
            var inactiveColor = this.get("inactiveColor");
            var itemSymbol = this.getItemSymbol();
            var defaultSymbol = itemSymbol || "roundRect";
            $fca0c970f405ff38$var$each(this.stateList, function(state) {
                var itemSize = this.itemSize;
                var visuals = controller[state];
                // Set inactive color for controller if no other color
                // attr (like colorAlpha) specified.
                if (!visuals) visuals = controller[state] = {
                    color: isCategory ? inactiveColor : [
                        inactiveColor
                    ]
                };
                // Consistent symbol and symbolSize if not specified.
                if (visuals.symbol == null) visuals.symbol = symbolExists && $7a1bd9c2710fea0d$export$9cd59f9826255e47(symbolExists) || (isCategory ? defaultSymbol : [
                    defaultSymbol
                ]);
                if (visuals.symbolSize == null) visuals.symbolSize = symbolSizeExists && $7a1bd9c2710fea0d$export$9cd59f9826255e47(symbolSizeExists) || (isCategory ? itemSize[0] : [
                    itemSize[0],
                    itemSize[0]
                ]);
                // Filter none
                visuals.symbol = $fca0c970f405ff38$var$mapVisual(visuals.symbol, function(symbol) {
                    return symbol === "none" ? defaultSymbol : symbol;
                });
                // Normalize symbolSize
                var symbolSize = visuals.symbolSize;
                if (symbolSize != null) {
                    var max_1 = -Infinity;
                    // symbolSize can be object when categories defined.
                    $fca0c970f405ff38$var$eachVisual(symbolSize, function(value) {
                        value > max_1 && (max_1 = value);
                    });
                    visuals.symbolSize = $fca0c970f405ff38$var$mapVisual(symbolSize, function(value) {
                        return $fca0c970f405ff38$var$linearMap(value, [
                            0,
                            max_1
                        ], [
                            0,
                            itemSize[0]
                        ], true);
                    });
                }
            }, this);
        }
    };
    VisualMapModel.prototype.resetItemSize = function() {
        this.itemSize = [
            parseFloat(this.get("itemWidth")),
            parseFloat(this.get("itemHeight"))
        ];
    };
    VisualMapModel.prototype.isCategory = function() {
        return !!this.option.categories;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.setSelected = function(selected) {};
    VisualMapModel.prototype.getSelected = function() {
        return null;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.getValueState = function(value) {
        return null;
    };
    /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */ VisualMapModel.prototype.getVisualMeta = function(getColorVisual) {
        return null;
    };
    VisualMapModel.type = "visualMap";
    VisualMapModel.dependencies = [
        "series"
    ];
    VisualMapModel.defaultOption = {
        show: true,
        // zlevel: 0,
        z: 4,
        seriesIndex: "all",
        min: 0,
        max: 200,
        left: 0,
        right: null,
        top: null,
        bottom: 0,
        itemWidth: null,
        itemHeight: null,
        inverse: false,
        orient: "vertical",
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        contentColor: "#5793f3",
        inactiveColor: "#aaa",
        borderWidth: 0,
        padding: 5,
        // 接受数组分别设定上右下左边距，同css
        textGap: 10,
        precision: 0,
        textStyle: {
            color: "#333" // 值域文字颜色
        }
    };
    return VisualMapModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $fca0c970f405ff38$export$2e2bcd8739ae039 = $fca0c970f405ff38$var$VisualMapModel;




// Constant
var $91b3756da4f00019$var$DEFAULT_BAR_BOUND = [
    20,
    140
];
var $91b3756da4f00019$var$ContinuousModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContinuousModel, _super);
    function ContinuousModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousModel.type;
        return _this;
    }
    /**
   * @override
   */ ContinuousModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        this.resetVisual(function(mappingOption) {
            mappingOption.mappingMethod = "linear";
            mappingOption.dataExtent = this.getExtent();
        });
        this._resetRange();
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.resetItemSize = function() {
        _super.prototype.resetItemSize.apply(this, arguments);
        var itemSize = this.itemSize;
        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = $91b3756da4f00019$var$DEFAULT_BAR_BOUND[0]);
        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = $91b3756da4f00019$var$DEFAULT_BAR_BOUND[1]);
    };
    /**
   * @private
   */ ContinuousModel.prototype._resetRange = function() {
        var dataExtent = this.getExtent();
        var range = this.option.range;
        if (!range || range.auto) {
            // `range` should always be array (so we don't use other
            // value like 'auto') for user-friend. (consider getOption).
            dataExtent.auto = 1;
            this.option.range = dataExtent;
        } else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(range)) {
            if (range[0] > range[1]) range.reverse();
            range[0] = Math.max(range[0], dataExtent[0]);
            range[1] = Math.min(range[1], dataExtent[1]);
        }
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.completeVisualOption = function() {
        _super.prototype.completeVisualOption.apply(this, arguments);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
            var symbolSize = this.option.controller[state].symbolSize;
            if (symbolSize && symbolSize[0] !== symbolSize[1]) symbolSize[0] = symbolSize[1] / 3; // For good looking.
        }, this);
    };
    /**
   * @override
   */ ContinuousModel.prototype.setSelected = function(selected) {
        this.option.range = selected.slice();
        this._resetRange();
    };
    /**
   * @public
   */ ContinuousModel.prototype.getSelected = function() {
        var dataExtent = this.getExtent();
        var dataInterval = $cfc1f3b422a3185f$export$debe6e778e0a6d32((this.get("range") || []).slice());
        // Clamp
        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
        return dataInterval;
    };
    /**
   * @override
   */ ContinuousModel.prototype.getValueState = function(value) {
        var range = this.option.range;
        var dataExtent = this.getExtent();
        // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
        // range[1] is processed likewise.
        return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? "inRange" : "outOfRange";
    };
    ContinuousModel.prototype.findTargetDataIndices = function(range) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @implement
   */ ContinuousModel.prototype.getVisualMeta = function(getColorVisual) {
        var oVals = $91b3756da4f00019$var$getColorStopValues(this, "outOfRange", this.getExtent());
        var iVals = $91b3756da4f00019$var$getColorStopValues(this, "inRange", this.option.range.slice());
        var stops = [];
        function setStop(value, valueState) {
            stops.push({
                value: value,
                color: getColorVisual(value, valueState)
            });
        }
        // Format to: outOfRange -- inRange -- outOfRange.
        var iIdx = 0;
        var oIdx = 0;
        var iLen = iVals.length;
        var oLen = oVals.length;
        for(; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++)// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
        if (oVals[oIdx] < iVals[iIdx]) setStop(oVals[oIdx], "outOfRange");
        for(var first = 1; iIdx < iLen; iIdx++, first = 0){
            // If range is full, value beyond min, max will be clamped.
            // make a singularity
            first && stops.length && setStop(iVals[iIdx], "outOfRange");
            setStop(iVals[iIdx], "inRange");
        }
        for(var first = 1; oIdx < oLen; oIdx++)if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
            // make a singularity
            if (first) {
                stops.length && setStop(stops[stops.length - 1].value, "outOfRange");
                first = 0;
            }
            setStop(oVals[oIdx], "outOfRange");
        }
        var stopsLen = stops.length;
        return {
            stops: stops,
            outerColors: [
                stopsLen ? stops[0].color : "transparent",
                stopsLen ? stops[stopsLen - 1].color : "transparent"
            ]
        };
    };
    ContinuousModel.type = "visualMap.continuous";
    ContinuousModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $fca0c970f405ff38$export$2e2bcd8739ae039).defaultOption, {
        align: "auto",
        calculable: false,
        hoverLink: true,
        realtime: true,
        handleIcon: "path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z",
        handleSize: "120%",
        handleStyle: {
            borderColor: "#fff",
            borderWidth: 1
        },
        indicatorIcon: "circle",
        indicatorSize: "50%",
        indicatorStyle: {
            borderColor: "#fff",
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: "rgba(0,0,0,0.2)"
        }
    });
    return ContinuousModel;
}((0, $fca0c970f405ff38$export$2e2bcd8739ae039));
function $91b3756da4f00019$var$getColorStopValues(visualMapModel, valueState, dataExtent) {
    if (dataExtent[0] === dataExtent[1]) return dataExtent.slice();
    // When using colorHue mapping, it is not linear color any more.
    // Moreover, canvas gradient seems not to be accurate linear.
    // FIXME
    // Should be arbitrary value 100? or based on pixel size?
    var count = 200;
    var step = (dataExtent[1] - dataExtent[0]) / count;
    var value = dataExtent[0];
    var stopValues = [];
    for(var i = 0; i <= count && value < dataExtent[1]; i++){
        stopValues.push(value);
        value += step;
    }
    stopValues.push(dataExtent[1]);
    return stopValues;
}
var $91b3756da4f00019$export$2e2bcd8739ae039 = $91b3756da4f00019$var$ContinuousModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $0eb56f276c16b145$var$VisualMapView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(VisualMapView, _super);
    function VisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapView.type;
        _this.autoPositionValues = {
            left: 1,
            right: 1,
            top: 1,
            bottom: 1
        };
        return _this;
    }
    VisualMapView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
    };
    /**
   * @protected
   */ VisualMapView.prototype.render = function(visualMapModel, ecModel, api, payload // TODO: TYPE
    ) {
        this.visualMapModel = visualMapModel;
        if (visualMapModel.get("show") === false) {
            this.group.removeAll();
            return;
        }
        this.doRender(visualMapModel, ecModel, api, payload);
    };
    /**
   * @protected
   */ VisualMapView.prototype.renderBackground = function(group) {
        var visualMapModel = this.visualMapModel;
        var padding = $c84c9521536c601a$export$f3a38102c49f4268(visualMapModel.get("padding") || 0);
        var rect = group.getBoundingRect();
        group.add(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            z2: -1,
            silent: true,
            shape: {
                x: rect.x - padding[3],
                y: rect.y - padding[0],
                width: rect.width + padding[3] + padding[1],
                height: rect.height + padding[0] + padding[2]
            },
            style: {
                fill: visualMapModel.get("backgroundColor"),
                stroke: visualMapModel.get("borderColor"),
                lineWidth: visualMapModel.get("borderWidth")
            }
        }));
    };
    /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */ VisualMapView.prototype.getControllerVisual = function(targetValue, visualCluster, opts) {
        opts = opts || {};
        var forceState = opts.forceState;
        var visualMapModel = this.visualMapModel;
        var visualObj = {};
        // Default values.
        if (visualCluster === "color") {
            var defaultColor = visualMapModel.get("contentColor");
            visualObj.color = defaultColor;
        }
        function getter(key) {
            return visualObj[key];
        }
        function setter(key, value) {
            visualObj[key] = value;
        }
        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypes, function(type) {
            var visualMapping = mappings[type];
            if (opts.convertOpacityToAlpha && type === "opacity") {
                type = "colorAlpha";
                visualMapping = mappings.__alphaForOpacity;
            }
            if ((0, $7b50f502cfd189d5$export$2e2bcd8739ae039).dependsOn(type, visualCluster)) visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
        });
        return visualObj[visualCluster];
    };
    VisualMapView.prototype.positionGroup = function(group) {
        var model = this.visualMapModel;
        var api = this.api;
        $93b9bc7f22ac7369$export$74054bd96b5eeef1(group, model.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    VisualMapView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {};
    VisualMapView.type = "visualMap";
    return VisualMapView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $0eb56f276c16b145$export$2e2bcd8739ae039 = $0eb56f276c16b145$var$VisualMapView;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $1a17eb3ffb707117$var$paramsSet = [
    [
        "left",
        "right",
        "width"
    ],
    [
        "top",
        "bottom",
        "height"
    ]
];
function $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, api, itemSize) {
    var modelOption = visualMapModel.option;
    var itemAlign = modelOption.align;
    if (itemAlign != null && itemAlign !== "auto") return itemAlign;
    // Auto decision align.
    var ecSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var realIndex = modelOption.orient === "horizontal" ? 1 : 0;
    var reals = $1a17eb3ffb707117$var$paramsSet[realIndex];
    var fakeValue = [
        0,
        null,
        10
    ];
    var layoutInput = {};
    for(var i = 0; i < 3; i++){
        layoutInput[$1a17eb3ffb707117$var$paramsSet[1 - realIndex][i]] = fakeValue[i];
        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
    }
    var rParam = [
        [
            "x",
            "width",
            3
        ],
        [
            "y",
            "height",
            0
        ]
    ][realIndex];
    var rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(layoutInput, ecSize, modelOption.padding);
    return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
function $1a17eb3ffb707117$export$5381a9dc5427ba18(batch, visualMapModel) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(batch || [], function(batchItem) {
        if (batchItem.dataIndex != null) {
            batchItem.dataIndexInside = batchItem.dataIndex;
            batchItem.dataIndex = null;
        }
        batchItem.highlightKey = "visualMap" + (visualMapModel ? visualMapModel.componentIndex : "");
    });
    return batch;
}










var $46b89608ba6c0e8b$var$linearMap = $cfc1f3b422a3185f$export$d3f68fbaa670562;
var $46b89608ba6c0e8b$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $46b89608ba6c0e8b$var$mathMin = Math.min;
var $46b89608ba6c0e8b$var$mathMax = Math.max;
// Arbitrary value
var $46b89608ba6c0e8b$var$HOVER_LINK_SIZE = 12;
var $46b89608ba6c0e8b$var$HOVER_LINK_OUT = 6;
// Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var $46b89608ba6c0e8b$var$ContinuousView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ContinuousView, _super);
    function ContinuousView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousView.type;
        _this._shapes = {};
        _this._dataInterval = [];
        _this._handleEnds = [];
        _this._hoverLinkDataIndices = [];
        return _this;
    }
    ContinuousView.prototype.init = function(ecModel, api) {
        _super.prototype.init.call(this, ecModel, api);
        this._hoverLinkFromSeriesMouseOver = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._hoverLinkFromSeriesMouseOver, this);
        this._hideIndicator = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._hideIndicator, this);
    };
    ContinuousView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {
        if (!payload || payload.type !== "selectDataRange" || payload.from !== this.uid) this._buildView();
    };
    ContinuousView.prototype._buildView = function() {
        this.group.removeAll();
        var visualMapModel = this.visualMapModel;
        var thisGroup = this.group;
        this._orient = visualMapModel.get("orient");
        this._useHandle = visualMapModel.get("calculable");
        this._resetInterval();
        this._renderBar(thisGroup);
        var dataRangeText = visualMapModel.get("text");
        this._renderEndsText(thisGroup, dataRangeText, 0);
        this._renderEndsText(thisGroup, dataRangeText, 1);
        // Do this for background size calculation.
        this._updateView(true);
        // After updating view, inner shapes is built completely,
        // and then background can be rendered.
        this.renderBackground(thisGroup);
        // Real update view
        this._updateView();
        this._enableHoverLinkToSeries();
        this._enableHoverLinkFromSeries();
        this.positionGroup(thisGroup);
    };
    ContinuousView.prototype._renderEndsText = function(group, dataRangeText, endsIndex) {
        if (!dataRangeText) return;
        // Compatible with ec2, text[0] map to high value, text[1] map low value.
        var text = dataRangeText[1 - endsIndex];
        text = text != null ? text + "" : "";
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var itemSize = visualMapModel.itemSize;
        var barGroup = this._shapes.mainGroup;
        var position = this._applyTransform([
            itemSize[0] / 2,
            endsIndex === 0 ? -textGap : itemSize[1] + textGap
        ], barGroup);
        var align = this._applyTransform(endsIndex === 0 ? "bottom" : "top", barGroup);
        var orient = this._orient;
        var textStyleModel = this.visualMapModel.textStyleModel;
        this.group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: position[0],
                y: position[1],
                verticalAlign: orient === "horizontal" ? "middle" : align,
                align: orient === "horizontal" ? align : "center",
                text: text
            })
        }));
    };
    ContinuousView.prototype._renderBar = function(targetGroup) {
        var visualMapModel = this.visualMapModel;
        var shapes = this._shapes;
        var itemSize = visualMapModel.itemSize;
        var orient = this._orient;
        var useHandle = this._useHandle;
        var itemAlign = $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, this.api, itemSize);
        var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);
        var gradientBarGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        mainGroup.add(gradientBarGroup);
        // Bar
        gradientBarGroup.add(shapes.outOfRange = $46b89608ba6c0e8b$var$createPolygon());
        gradientBarGroup.add(shapes.inRange = $46b89608ba6c0e8b$var$createPolygon(null, useHandle ? $46b89608ba6c0e8b$var$getCursor(this._orient) : null, $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, "all", false), $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, "all", true)));
        // A border radius clip.
        gradientBarGroup.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: {
                x: 0,
                y: 0,
                width: itemSize[0],
                height: itemSize[1],
                r: 3
            }
        }));
        var textRect = visualMapModel.textStyleModel.getTextRect("\u56FD");
        var textSize = $46b89608ba6c0e8b$var$mathMax(textRect.width, textRect.height);
        // Handle
        if (useHandle) {
            shapes.handleThumbs = [];
            shapes.handleLabels = [];
            shapes.handleLabelPoints = [];
            this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);
            this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
        }
        this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);
        targetGroup.add(mainGroup);
    };
    ContinuousView.prototype._createHandle = function(visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
        var onDrift = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, handleIndex, false);
        var onDragEnd = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, handleIndex, true);
        var handleSize = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(visualMapModel.get("handleSize"), itemSize[0]);
        var handleThumb = (0, $5370466dadc978d7$export$af050e04da3a02e8)(visualMapModel.get("handleIcon"), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
        var cursor = $46b89608ba6c0e8b$var$getCursor(this._orient);
        handleThumb.attr({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            ondragend: onDragEnd,
            onmousemove: function(e) {
                $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            }
        });
        handleThumb.x = itemSize[0] / 2;
        handleThumb.useStyle(visualMapModel.getModel("handleStyle").getItemStyle());
        handleThumb.setStyle({
            strokeNoScale: true,
            strokeFirst: true
        });
        handleThumb.style.lineWidth *= 2;
        handleThumb.ensureState("emphasis").style = visualMapModel.getModel([
            "emphasis",
            "handleStyle"
        ]).getItemStyle();
        (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(handleThumb, true);
        mainGroup.add(handleThumb);
        // Text is always horizontal layout but should not be effected by
        // transform (orient/inverse). So label is built separately but not
        // use zrender/graphic/helper/RectText, and is located based on view
        // group (according to handleLabelPoint) but not barGroup.
        var textStyleModel = this.visualMapModel.textStyleModel;
        var handleLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            onmousemove: function(e) {
                // For mobile device, prevent screen slider on the button.
                $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            },
            ondragend: onDragEnd,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ""
            })
        });
        handleLabel.ensureState("blur").style = {
            opacity: 0.1
        };
        handleLabel.stateTransition = {
            duration: 200
        };
        this.group.add(handleLabel);
        var handleLabelPoint = [
            handleSize,
            0
        ];
        var shapes = this._shapes;
        shapes.handleThumbs[handleIndex] = handleThumb;
        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
        shapes.handleLabels[handleIndex] = handleLabel;
    };
    ContinuousView.prototype._createIndicator = function(visualMapModel, mainGroup, itemSize, textSize, orient) {
        var scale = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(visualMapModel.get("indicatorSize"), itemSize[0]);
        var indicator = (0, $5370466dadc978d7$export$af050e04da3a02e8)(visualMapModel.get("indicatorIcon"), -scale / 2, -scale / 2, scale, scale, null, true);
        indicator.attr({
            cursor: "move",
            invisible: true,
            silent: true,
            x: itemSize[0] / 2
        });
        var indicatorStyle = visualMapModel.getModel("indicatorStyle").getItemStyle();
        if (indicator instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = indicator.style;
            indicator.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, indicatorStyle));
        } else indicator.useStyle(indicatorStyle);
        mainGroup.add(indicator);
        var textStyleModel = this.visualMapModel.textStyleModel;
        var indicatorLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
            silent: true,
            invisible: true,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ""
            })
        });
        this.group.add(indicatorLabel);
        var indicatorLabelPoint = [
            (orient === "horizontal" ? textSize / 2 : $46b89608ba6c0e8b$var$HOVER_LINK_OUT) + itemSize[0] / 2,
            0
        ];
        var shapes = this._shapes;
        shapes.indicator = indicator;
        shapes.indicatorLabel = indicatorLabel;
        shapes.indicatorLabelPoint = indicatorLabelPoint;
        this._firstShowIndicator = true;
    };
    ContinuousView.prototype._dragHandle = function(handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
    dx, dy) {
        if (!this._useHandle) return;
        this._dragging = !isEnd;
        if (!isEnd) {
            // Transform dx, dy to bar coordination.
            var vertex = this._applyTransform([
                dx,
                dy
            ], this._shapes.mainGroup, true);
            this._updateInterval(handleIndex, vertex[1]);
            this._hideIndicator();
            // Considering realtime, update view should be executed
            // before dispatch action.
            this._updateView();
        }
        // dragEnd do not dispatch action when realtime.
        if (isEnd === !this.visualMapModel.get("realtime")) // jshint ignore:line
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
        });
        if (isEnd) !this._hovering && this._clearHoverLinkToSeries();
        else if ($46b89608ba6c0e8b$var$useHoverLinkOnHandle(this.visualMapModel)) this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    };
    ContinuousView.prototype._resetInterval = function() {
        var visualMapModel = this.visualMapModel;
        var dataInterval = this._dataInterval = visualMapModel.getSelected();
        var dataExtent = visualMapModel.getExtent();
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        this._handleEnds = [
            $46b89608ba6c0e8b$var$linearMap(dataInterval[0], dataExtent, sizeExtent, true),
            $46b89608ba6c0e8b$var$linearMap(dataInterval[1], dataExtent, sizeExtent, true)
        ];
    };
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */ ContinuousView.prototype._updateInterval = function(handleIndex, delta) {
        delta = delta || 0;
        var visualMapModel = this.visualMapModel;
        var handleEnds = this._handleEnds;
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, handleEnds, sizeExtent, handleIndex, // cross is forbidden
        0);
        var dataExtent = visualMapModel.getExtent();
        // Update data interval.
        this._dataInterval = [
            $46b89608ba6c0e8b$var$linearMap(handleEnds[0], sizeExtent, dataExtent, true),
            $46b89608ba6c0e8b$var$linearMap(handleEnds[1], sizeExtent, dataExtent, true)
        ];
    };
    ContinuousView.prototype._updateView = function(forSketch) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var shapes = this._shapes;
        var outOfRangeHandleEnds = [
            0,
            visualMapModel.itemSize[1]
        ];
        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, "inRange");
        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, "outOfRange");
        shapes.inRange.setStyle({
            fill: visualInRange.barColor
        }).setShape("points", visualInRange.barPoints);
        shapes.outOfRange.setStyle({
            fill: visualOutOfRange.barColor
        }).setShape("points", visualOutOfRange.barPoints);
        this._updateHandle(inRangeHandleEnds, visualInRange);
    };
    ContinuousView.prototype._createBarVisual = function(dataInterval, dataExtent, handleEnds, forceState) {
        var opts = {
            forceState: forceState,
            convertOpacityToAlpha: true
        };
        var colorStops = this._makeColorGradient(dataInterval, opts);
        var symbolSizes = [
            this.getControllerVisual(dataInterval[0], "symbolSize", opts),
            this.getControllerVisual(dataInterval[1], "symbolSize", opts)
        ];
        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
        return {
            barColor: new (0, $cf44c01491b58e53$export$2e2bcd8739ae039)(0, 0, 0, 1, colorStops),
            barPoints: barPoints,
            handlesColor: [
                colorStops[0].color,
                colorStops[colorStops.length - 1].color
            ]
        };
    };
    ContinuousView.prototype._makeColorGradient = function(dataInterval, opts) {
        // Considering colorHue, which is not linear, so we have to sample
        // to calculate gradient color stops, but not only calculate head
        // and tail.
        var sampleNumber = 100; // Arbitrary value.
        var colorStops = [];
        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
        colorStops.push({
            color: this.getControllerVisual(dataInterval[0], "color", opts),
            offset: 0
        });
        for(var i = 1; i < sampleNumber; i++){
            var currValue = dataInterval[0] + step * i;
            if (currValue > dataInterval[1]) break;
            colorStops.push({
                color: this.getControllerVisual(currValue, "color", opts),
                offset: i / sampleNumber
            });
        }
        colorStops.push({
            color: this.getControllerVisual(dataInterval[1], "color", opts),
            offset: 1
        });
        return colorStops;
    };
    ContinuousView.prototype._createBarPoints = function(handleEnds, symbolSizes) {
        var itemSize = this.visualMapModel.itemSize;
        return [
            [
                itemSize[0] - symbolSizes[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[1]
            ],
            [
                itemSize[0] - symbolSizes[1],
                handleEnds[1]
            ]
        ];
    };
    ContinuousView.prototype._createBarGroup = function(itemAlign) {
        var orient = this._orient;
        var inverse = this.visualMapModel.get("inverse");
        return new $7ef7583d8302ffce$export$2e2bcd8739ae039(orient === "horizontal" && !inverse ? {
            scaleX: itemAlign === "bottom" ? 1 : -1,
            rotation: Math.PI / 2
        } : orient === "horizontal" && inverse ? {
            scaleX: itemAlign === "bottom" ? -1 : 1,
            rotation: -Math.PI / 2
        } : orient === "vertical" && !inverse ? {
            scaleX: itemAlign === "left" ? 1 : -1,
            scaleY: -1
        } : {
            scaleX: itemAlign === "left" ? 1 : -1
        });
    };
    ContinuousView.prototype._updateHandle = function(handleEnds, visualInRange) {
        if (!this._useHandle) return;
        var shapes = this._shapes;
        var visualMapModel = this.visualMapModel;
        var handleThumbs = shapes.handleThumbs;
        var handleLabels = shapes.handleLabels;
        var itemSize = visualMapModel.itemSize;
        var dataExtent = visualMapModel.getExtent();
        $46b89608ba6c0e8b$var$each([
            0,
            1
        ], function(handleIndex) {
            var handleThumb = handleThumbs[handleIndex];
            handleThumb.setStyle("fill", visualInRange.handlesColor[handleIndex]);
            handleThumb.y = handleEnds[handleIndex];
            var val = $46b89608ba6c0e8b$var$linearMap(handleEnds[handleIndex], [
                0,
                itemSize[1]
            ], dataExtent, true);
            var symbolSize = this.getControllerVisual(val, "symbolSize");
            handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
            handleThumb.x = itemSize[0] - symbolSize / 2;
            // Update handle label position.
            var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623(shapes.handleLabelPoints[handleIndex], $5b455ae6f843ac47$export$fce0c6cfca85ed96(handleThumb, this.group));
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
                verticalAlign: "middle",
                align: this._orient === "vertical" ? this._applyTransform("left", shapes.mainGroup) : "center"
            });
        }, this);
    };
    ContinuousView.prototype._showIndicator = function(cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var itemSize = visualMapModel.itemSize;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var shapes = this._shapes;
        var indicator = shapes.indicator;
        if (!indicator) return;
        indicator.attr("invisible", false);
        var opts = {
            convertOpacityToAlpha: true
        };
        var color = this.getControllerVisual(cursorValue, "color", opts);
        var symbolSize = this.getControllerVisual(cursorValue, "symbolSize");
        var y = $46b89608ba6c0e8b$var$linearMap(cursorValue, dataExtent, sizeExtent, true);
        var x = itemSize[0] - symbolSize / 2;
        var oldIndicatorPos = {
            x: indicator.x,
            y: indicator.y
        };
        // Update handle label position.
        indicator.y = y;
        indicator.x = x;
        var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623(shapes.indicatorLabelPoint, $5b455ae6f843ac47$export$fce0c6cfca85ed96(indicator, this.group));
        var indicatorLabel = shapes.indicatorLabel;
        indicatorLabel.attr("invisible", false);
        var align = this._applyTransform("left", shapes.mainGroup);
        var orient = this._orient;
        var isHorizontal = orient === "horizontal";
        indicatorLabel.setStyle({
            text: (rangeSymbol ? rangeSymbol : "") + visualMapModel.formatValueText(textValue),
            verticalAlign: isHorizontal ? align : "middle",
            align: isHorizontal ? "center" : align
        });
        var indicatorNewProps = {
            x: x,
            y: y,
            style: {
                fill: color
            }
        };
        var labelNewProps = {
            style: {
                x: textPoint[0],
                y: textPoint[1]
            }
        };
        if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
            var animationCfg = {
                duration: 100,
                easing: "cubicInOut",
                additive: true
            };
            indicator.x = oldIndicatorPos.x;
            indicator.y = oldIndicatorPos.y;
            indicator.animateTo(indicatorNewProps, animationCfg);
            indicatorLabel.animateTo(labelNewProps, animationCfg);
        } else {
            indicator.attr(indicatorNewProps);
            indicatorLabel.attr(labelNewProps);
        }
        this._firstShowIndicator = false;
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.enterBlur(handleLabels[i]);
    };
    ContinuousView.prototype._enableHoverLinkToSeries = function() {
        var self = this;
        this._shapes.mainGroup.on("mousemove", function(e) {
            self._hovering = true;
            if (!self._dragging) {
                var itemSize = self.visualMapModel.itemSize;
                var pos = self._applyTransform([
                    e.offsetX,
                    e.offsetY
                ], self._shapes.mainGroup, true, true);
                // For hover link show when hover handle, which might be
                // below or upper than sizeExtent.
                pos[1] = $46b89608ba6c0e8b$var$mathMin($46b89608ba6c0e8b$var$mathMax(0, pos[1]), itemSize[1]);
                self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
            }
        }).on("mouseout", function() {
            // When mouse is out of handle, hoverLink still need
            // to be displayed when realtime is set as false.
            self._hovering = false;
            !self._dragging && self._clearHoverLinkToSeries();
        });
    };
    ContinuousView.prototype._enableHoverLinkFromSeries = function() {
        var zr = this.api.getZr();
        if (this.visualMapModel.option.hoverLink) {
            zr.on("mouseover", this._hoverLinkFromSeriesMouseOver, this);
            zr.on("mouseout", this._hideIndicator, this);
        } else this._clearHoverLinkFromSeries();
    };
    ContinuousView.prototype._doHoverLinkToSeries = function(cursorPos, hoverOnBar) {
        var visualMapModel = this.visualMapModel;
        var itemSize = visualMapModel.itemSize;
        if (!visualMapModel.option.hoverLink) return;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var dataExtent = visualMapModel.getExtent();
        // For hover link show when hover handle, which might be below or upper than sizeExtent.
        cursorPos = $46b89608ba6c0e8b$var$mathMin($46b89608ba6c0e8b$var$mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
        var halfHoverLinkSize = $46b89608ba6c0e8b$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
        var hoverRange = [
            cursorPos - halfHoverLinkSize,
            cursorPos + halfHoverLinkSize
        ];
        var cursorValue = $46b89608ba6c0e8b$var$linearMap(cursorPos, sizeExtent, dataExtent, true);
        var valueRange = [
            $46b89608ba6c0e8b$var$linearMap(hoverRange[0], sizeExtent, dataExtent, true),
            $46b89608ba6c0e8b$var$linearMap(hoverRange[1], sizeExtent, dataExtent, true)
        ];
        // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
        // where china and india has very large population.
        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity);
        // Do not show indicator when mouse is over handle,
        // otherwise labels overlap, especially when dragging.
        if (hoverOnBar) {
            if (valueRange[0] === -Infinity) this._showIndicator(cursorValue, valueRange[1], "< ", halfHoverLinkSize);
            else if (valueRange[1] === Infinity) this._showIndicator(cursorValue, valueRange[0], "> ", halfHoverLinkSize);
            else this._showIndicator(cursorValue, cursorValue, "\u2248 ", halfHoverLinkSize);
        }
        // When realtime is set as false, handles, which are in barGroup,
        // also trigger hoverLink, which help user to realize where they
        // focus on when dragging. (see test/heatmap-large.html)
        // When realtime is set as true, highlight will not show when hover
        // handle, because the label on handle, which displays a exact value
        // but not range, might mislead users.
        var oldBatch = this._hoverLinkDataIndices;
        var newBatch = [];
        if (hoverOnBar || $46b89608ba6c0e8b$var$useHoverLinkOnHandle(visualMapModel)) newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
        var resultBatches = $76d619f648247e6d$export$6d12cabb0c9bf8e3(oldBatch, newBatch);
        this._dispatchHighDown("downplay", $1a17eb3ffb707117$export$5381a9dc5427ba18(resultBatches[0], visualMapModel));
        this._dispatchHighDown("highlight", $1a17eb3ffb707117$export$5381a9dc5427ba18(resultBatches[1], visualMapModel));
    };
    ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function(e) {
        var ecData;
        (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(e.target, function(target) {
            var currECData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target);
            if (currECData.dataIndex != null) {
                ecData = currECData;
                return true;
            }
        }, true);
        if (!ecData) return;
        var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
        var visualMapModel = this.visualMapModel;
        if (!visualMapModel.isTargetSeries(dataModel)) return;
        var data = dataModel.getData(ecData.dataType);
        var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);
        if (!isNaN(value)) this._showIndicator(value, value);
    };
    ContinuousView.prototype._hideIndicator = function() {
        var shapes = this._shapes;
        shapes.indicator && shapes.indicator.attr("invisible", true);
        shapes.indicatorLabel && shapes.indicatorLabel.attr("invisible", true);
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.leaveBlur(handleLabels[i]);
    };
    ContinuousView.prototype._clearHoverLinkToSeries = function() {
        this._hideIndicator();
        var indices = this._hoverLinkDataIndices;
        this._dispatchHighDown("downplay", $1a17eb3ffb707117$export$5381a9dc5427ba18(indices, this.visualMapModel));
        indices.length = 0;
    };
    ContinuousView.prototype._clearHoverLinkFromSeries = function() {
        this._hideIndicator();
        var zr = this.api.getZr();
        zr.off("mouseover", this._hoverLinkFromSeriesMouseOver);
        zr.off("mouseout", this._hideIndicator);
    };
    ContinuousView.prototype._applyTransform = function(vertex, element, inverse, global) {
        var transform = $5b455ae6f843ac47$export$fce0c6cfca85ed96(element, global ? null : this.group);
        return $7a1bd9c2710fea0d$export$43bee75e5e14138e(vertex) ? $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, transform, inverse) : $5b455ae6f843ac47$export$fff94e9792354cfa(vertex, transform, inverse);
    };
    // TODO: TYPE more specified payload types.
    ContinuousView.prototype._dispatchHighDown = function(type, batch) {
        batch && batch.length && this.api.dispatchAction({
            type: type,
            batch: batch
        });
    };
    /**
   * @override
   */ ContinuousView.prototype.dispose = function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    };
    ContinuousView.type = "visualMap.continuous";
    return ContinuousView;
}((0, $0eb56f276c16b145$export$2e2bcd8739ae039));
function $46b89608ba6c0e8b$var$createPolygon(points, cursor, onDrift, onDragEnd) {
    return new $51acf033123e1a30$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        draggable: !!onDrift,
        cursor: cursor,
        drift: onDrift,
        onmousemove: function(e) {
            // For mobile device, prevent screen slider on the button.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        },
        ondragend: onDragEnd
    });
}
function $46b89608ba6c0e8b$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
    var halfHoverLinkSize = $46b89608ba6c0e8b$var$HOVER_LINK_SIZE / 2;
    var hoverLinkDataSize = visualMapModel.get("hoverLinkDataSize");
    if (hoverLinkDataSize) halfHoverLinkSize = $46b89608ba6c0e8b$var$linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
    return halfHoverLinkSize;
}
function $46b89608ba6c0e8b$var$useHoverLinkOnHandle(visualMapModel) {
    var hoverLinkOnHandle = visualMapModel.get("hoverLinkOnHandle");
    return !!(hoverLinkOnHandle == null ? visualMapModel.get("realtime") : hoverLinkOnHandle);
}
function $46b89608ba6c0e8b$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $46b89608ba6c0e8b$export$2e2bcd8739ae039 = $46b89608ba6c0e8b$var$ContinuousView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $395ebe650d46f583$export$c5097295b52f5ecd = {
    type: "selectDataRange",
    event: "dataRangeSelected",
    // FIXME use updateView appears wrong
    update: "update"
};
var $395ebe650d46f583$export$8655c04a6fcbaa76 = function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "visualMap",
        query: payload
    }, function(model) {
        model.setSelected(payload.selected);
    });
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $561e4a618ab15558$export$5933e7c74ab358d1 = [
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var resetDefines = [];
            ecModel.eachComponent("visualMap", function(visualMapModel) {
                var pipelineContext = seriesModel.pipelineContext;
                if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) return;
                resetDefines.push($87ea23222d1c134e$export$fc0ef8703cccf128(visualMapModel.stateList, visualMapModel.targetVisuals, $7a1bd9c2710fea0d$export$2385a24977818dd0(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
            });
            return resetDefines;
        }
    },
    // Only support color.
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var visualMetaList = [];
            ecModel.eachComponent("visualMap", function(visualMapModel) {
                if (visualMapModel.isTargetSeries(seriesModel)) {
                    var visualMeta = visualMapModel.getVisualMeta($7a1bd9c2710fea0d$export$2385a24977818dd0($561e4a618ab15558$var$getColorVisual, null, seriesModel, visualMapModel)) || {
                        stops: [],
                        outerColors: []
                    };
                    var dimIdx = visualMapModel.getDataDimensionIndex(data);
                    if (dimIdx >= 0) {
                        // visualMeta.dimension should be dimension index, but not concrete dimension.
                        visualMeta.dimension = dimIdx;
                        visualMetaList.push(visualMeta);
                    }
                }
            });
            // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
            seriesModel.getData().setVisual("visualMeta", visualMetaList);
        }
    }
];
// FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function $561e4a618ab15558$var$getColorVisual(seriesModel, visualMapModel, value, valueState) {
    var mappings = visualMapModel.targetVisuals[valueState];
    var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
    var resultVisual = {
        color: (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesModel.getData(), "color") // default color.
    };
    for(var i = 0, len = visualTypes.length; i < len; i++){
        var type = visualTypes[i];
        var mapping = mappings[type === "opacity" ? "__alphaForOpacity" : type];
        mapping && mapping.applyVisual(value, getVisual, setVisual);
    }
    return resultVisual.color;
    function getVisual(key) {
        return resultVisual[key];
    }
    function setVisual(key, value) {
        resultVisual[key] = value;
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $92519f6317138812$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $92519f6317138812$export$2e2bcd8739ae039(option) {
    var visualMap = option && option.visualMap;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(visualMap)) visualMap = visualMap ? [
        visualMap
    ] : [];
    $92519f6317138812$var$each(visualMap, function(opt) {
        if (!opt) return;
        // rename splitList to pieces
        if ($92519f6317138812$var$has(opt, "splitList") && !$92519f6317138812$var$has(opt, "pieces")) {
            opt.pieces = opt.splitList;
            delete opt.splitList;
        }
        var pieces = opt.pieces;
        if (pieces && $7a1bd9c2710fea0d$export$43bee75e5e14138e(pieces)) $92519f6317138812$var$each(pieces, function(piece) {
            if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(piece)) {
                if ($92519f6317138812$var$has(piece, "start") && !$92519f6317138812$var$has(piece, "min")) piece.min = piece.start;
                if ($92519f6317138812$var$has(piece, "end") && !$92519f6317138812$var$has(piece, "max")) piece.max = piece.end;
            }
        });
    });
}
function $92519f6317138812$var$has(obj, name) {
    return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}


var $769f929efa66b3be$var$installed = false;
function $769f929efa66b3be$export$2e2bcd8739ae039(registers) {
    if ($769f929efa66b3be$var$installed) return;
    $769f929efa66b3be$var$installed = true;
    registers.registerSubTypeDefaulter("visualMap", function(option) {
        // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
        return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? "continuous" : "piecewise";
    });
    registers.registerAction((0, $395ebe650d46f583$export$c5097295b52f5ecd), (0, $395ebe650d46f583$export$8655c04a6fcbaa76));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $561e4a618ab15558$export$5933e7c74ab358d1), function(handler) {
        registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
    });
    registers.registerPreprocessor((0, $92519f6317138812$export$2e2bcd8739ae039));
}


function $a0f8a196dd8b4cba$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $91b3756da4f00019$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $46b89608ba6c0e8b$export$2e2bcd8739ae039));
    (0, $769f929efa66b3be$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $800f031000e0c641$var$PiecewiseModel = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PiecewiseModel, _super);
    function PiecewiseModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseModel.type;
        /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */ _this._pieceList = [];
        return _this;
    }
    PiecewiseModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        var mode = this._mode = this._determineMode();
        this._pieceList = [];
        $800f031000e0c641$var$resetMethods[this._mode].call(this, this._pieceList);
        this._resetSelected(newOption, isInit);
        var categories = this.option.categories;
        this.resetVisual(function(mappingOption, state) {
            if (mode === "categories") {
                mappingOption.mappingMethod = "category";
                mappingOption.categories = $7a1bd9c2710fea0d$export$9cd59f9826255e47(categories);
            } else {
                mappingOption.dataExtent = this.getExtent();
                mappingOption.mappingMethod = "piecewise";
                mappingOption.pieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this._pieceList, function(piece) {
                    piece = $7a1bd9c2710fea0d$export$9cd59f9826255e47(piece);
                    if (state !== "inRange") // FIXME
                    // outOfRange do not support special visual in pieces.
                    piece.visual = null;
                    return piece;
                });
            }
        });
    };
    /**
   * @protected
   * @override
   */ PiecewiseModel.prototype.completeVisualOption = function() {
        // Consider this case:
        // visualMap: {
        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
        // }
        // where no inRange/outOfRange set but only pieces. So we should make
        // default inRange/outOfRange for this case, otherwise visuals that only
        // appear in `pieces` will not be taken into account in visual encoding.
        var option = this.option;
        var visualTypesInPieces = {};
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).listVisualTypes();
        var isCategory = this.isCategory();
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.pieces, function(piece) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypes, function(visualType) {
                if (piece.hasOwnProperty(visualType)) visualTypesInPieces[visualType] = 1;
            });
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypesInPieces, function(v, visualType) {
            var exists = false;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
                exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
            }, this);
            !exists && $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
                (option[state] || (option[state] = {}))[visualType] = (0, $ef3bd976f9d1f7a2$export$2e2bcd8739ae039).get(visualType, state === "inRange" ? "active" : "inactive", isCategory);
            });
        }, this);
        function has(obj, state, visualType) {
            return obj && obj[state] && obj[state].hasOwnProperty(visualType);
        }
        _super.prototype.completeVisualOption.apply(this, arguments);
    };
    PiecewiseModel.prototype._resetSelected = function(newOption, isInit) {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        // Selected do not merge but all override.
        var selected = (isInit ? thisOption : newOption).selected || {};
        thisOption.selected = selected;
        // Consider 'not specified' means true.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
            var key = this.getSelectedMapKey(piece);
            if (!selected.hasOwnProperty(key)) selected[key] = true;
        }, this);
        if (thisOption.selectedMode === "single") {
            // Ensure there is only one selected.
            var hasSel_1 = false;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
                var key = this.getSelectedMapKey(piece);
                if (selected[key]) hasSel_1 ? selected[key] = false : hasSel_1 = true;
            }, this);
        }
    // thisOption.selectedMode === 'multiple', default: all selected.
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getItemSymbol = function() {
        return this.get("itemSymbol");
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getSelectedMapKey = function(piece) {
        return this._mode === "categories" ? piece.value + "" : piece.index + "";
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getPieceList = function() {
        return this._pieceList;
    };
    /**
   * @return {string}
   */ PiecewiseModel.prototype._determineMode = function() {
        var option = this.option;
        return option.pieces && option.pieces.length > 0 ? "pieces" : this.option.categories ? "categories" : "splitNumber";
    };
    /**
   * @override
   */ PiecewiseModel.prototype.setSelected = function(selected) {
        this.option.selected = $7a1bd9c2710fea0d$export$9cd59f9826255e47(selected);
    };
    /**
   * @override
   */ PiecewiseModel.prototype.getValueState = function(value) {
        var index = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).findPieceIndex(value, this._pieceList);
        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? "inRange" : "outOfRange" : "outOfRange";
    };
    /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */ PiecewiseModel.prototype.findTargetDataIndices = function(pieceIndex) {
        var result = [];
        var pieceList = this._pieceList;
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                // Should always base on model pieceList, because it is order sensitive.
                var pIdx = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).findPieceIndex(value, pieceList);
                pIdx === pieceIndex && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */ PiecewiseModel.prototype.getRepresentValue = function(piece) {
        var representValue;
        if (this.isCategory()) representValue = piece.value;
        else if (piece.value != null) representValue = piece.value;
        else {
            var pieceInterval = piece.interval || [];
            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
        }
        return representValue;
    };
    PiecewiseModel.prototype.getVisualMeta = function(getColorVisual) {
        // Do not support category. (category axis is ordinal, numerical)
        if (this.isCategory()) return;
        var stops = [];
        var outerColors = [
            "",
            ""
        ];
        var visualMapModel = this;
        function setStop(interval, valueState) {
            var representValue = visualMapModel.getRepresentValue({
                interval: interval
            }); // Not category
            if (!valueState) valueState = visualMapModel.getValueState(representValue);
            var color = getColorVisual(representValue, valueState);
            if (interval[0] === -Infinity) outerColors[0] = color;
            else if (interval[1] === Infinity) outerColors[1] = color;
            else stops.push({
                value: interval[0],
                color: color
            }, {
                value: interval[1],
                color: color
            });
        }
        // Suplement
        var pieceList = this._pieceList.slice();
        if (!pieceList.length) pieceList.push({
            interval: [
                -Infinity,
                Infinity
            ]
        });
        else {
            var edge = pieceList[0].interval[0];
            edge !== -Infinity && pieceList.unshift({
                interval: [
                    -Infinity,
                    edge
                ]
            });
            edge = pieceList[pieceList.length - 1].interval[1];
            edge !== Infinity && pieceList.push({
                interval: [
                    edge,
                    Infinity
                ]
            });
        }
        var curr = -Infinity;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece) {
            var interval = piece.interval;
            if (interval) {
                // Fulfill gap.
                interval[0] > curr && setStop([
                    curr,
                    interval[0]
                ], "outOfRange");
                setStop(interval.slice());
                curr = interval[1];
            }
        }, this);
        return {
            stops: stops,
            outerColors: outerColors
        };
    };
    PiecewiseModel.type = "visualMap.piecewise";
    PiecewiseModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $fca0c970f405ff38$export$2e2bcd8739ae039).defaultOption, {
        selected: null,
        minOpen: false,
        maxOpen: false,
        align: "auto",
        itemWidth: 20,
        itemHeight: 14,
        itemSymbol: "roundRect",
        pieces: null,
        categories: null,
        splitNumber: 5,
        selectedMode: "multiple",
        itemGap: 10,
        hoverLink: true // Enable hover highlight.
    });
    return PiecewiseModel;
}((0, $fca0c970f405ff38$export$2e2bcd8739ae039));
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */ var $800f031000e0c641$var$resetMethods = {
    splitNumber: function(outPieceList) {
        var thisOption = this.option;
        var precision = Math.min(thisOption.precision, 20);
        var dataExtent = this.getExtent();
        var splitNumber = thisOption.splitNumber;
        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
        thisOption.splitNumber = splitNumber;
        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber;
        // Precision auto-adaption
        while(+splitStep.toFixed(precision) !== splitStep && precision < 5)precision++;
        thisOption.precision = precision;
        splitStep = +splitStep.toFixed(precision);
        if (thisOption.minOpen) outPieceList.push({
            interval: [
                -Infinity,
                dataExtent[0]
            ],
            close: [
                0,
                0
            ]
        });
        for(var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++){
            var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
            outPieceList.push({
                interval: [
                    curr,
                    max
                ],
                close: [
                    1,
                    1
                ]
            });
        }
        if (thisOption.maxOpen) outPieceList.push({
            interval: [
                dataExtent[1],
                Infinity
            ],
            close: [
                0,
                0
            ]
        });
        (0, $cfc1f3b422a3185f$export$12f7386070bc380a)(outPieceList);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(outPieceList, function(piece, index) {
            piece.index = index;
            piece.text = this.formatValueText(piece.interval);
        }, this);
    },
    categories: function(outPieceList) {
        var thisOption = this.option;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(thisOption.categories, function(cate) {
            // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
            // 是否改一致。
            outPieceList.push({
                text: this.formatValueText(cate, true),
                value: cate
            });
        }, this);
        // See "Order Rule".
        $800f031000e0c641$var$normalizeReverse(thisOption, outPieceList);
    },
    pieces: function(outPieceList) {
        var thisOption = this.option;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(thisOption.pieces, function(pieceListItem, index) {
            if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(pieceListItem)) pieceListItem = {
                value: pieceListItem
            };
            var item = {
                text: "",
                index: index
            };
            if (pieceListItem.label != null) item.text = pieceListItem.label;
            if (pieceListItem.hasOwnProperty("value")) {
                var value = item.value = pieceListItem.value;
                item.interval = [
                    value,
                    value
                ];
                item.close = [
                    1,
                    1
                ];
            } else {
                // `min` `max` is legacy option.
                // `lt` `gt` `lte` `gte` is recommended.
                var interval = item.interval = [];
                var close_1 = item.close = [
                    0,
                    0
                ];
                var closeList = [
                    1,
                    0,
                    1
                ];
                var infinityList = [
                    -Infinity,
                    Infinity
                ];
                var useMinMax = [];
                for(var lg = 0; lg < 2; lg++){
                    var names = [
                        [
                            "gte",
                            "gt",
                            "min"
                        ],
                        [
                            "lte",
                            "lt",
                            "max"
                        ]
                    ][lg];
                    for(var i = 0; i < 3 && interval[lg] == null; i++){
                        interval[lg] = pieceListItem[names[i]];
                        close_1[lg] = closeList[i];
                        useMinMax[lg] = i === 2;
                    }
                    interval[lg] == null && (interval[lg] = infinityList[lg]);
                }
                useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
                useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);
                if (interval[0] === interval[1] && close_1[0] && close_1[1]) // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
                // we use value to lift the priority when min === max
                item.value = interval[0];
            }
            item.visual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).retrieveVisuals(pieceListItem);
            outPieceList.push(item);
        }, this);
        // See "Order Rule".
        $800f031000e0c641$var$normalizeReverse(thisOption, outPieceList);
        // Only pieces
        (0, $cfc1f3b422a3185f$export$12f7386070bc380a)(outPieceList);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(outPieceList, function(piece) {
            var close = piece.close;
            var edgeSymbols = [
                [
                    "<",
                    "\u2264"
                ][close[1]],
                [
                    ">",
                    "\u2265"
                ][close[0]]
            ];
            piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
        }, this);
    }
};
function $800f031000e0c641$var$normalizeReverse(thisOption, pieceList) {
    var inverse = thisOption.inverse;
    if (thisOption.orient === "vertical" ? !inverse : inverse) pieceList.reverse();
}
var $800f031000e0c641$export$2e2bcd8739ae039 = $800f031000e0c641$var$PiecewiseModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $54f263ebb7934a99$var$PiecewiseVisualMapView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(PiecewiseVisualMapView, _super);
    function PiecewiseVisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseVisualMapView.type;
        return _this;
    }
    PiecewiseVisualMapView.prototype.doRender = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var textStyleModel = visualMapModel.textStyleModel;
        var textFont = textStyleModel.getFont();
        var textFill = textStyleModel.getTextColor();
        var itemAlign = this._getItemAlign();
        var itemSize = visualMapModel.itemSize;
        var viewData = this._getViewData();
        var endsText = viewData.endsText;
        var showLabel = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(visualMapModel.get("showLabel", true), !endsText);
        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(viewData.viewPieceList, function(item) {
            var piece = item.piece;
            var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            itemGroup.onclick = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onItemClick, this, piece);
            this._enableHoverLink(itemGroup, item.indexInModelPieceList);
            // TODO Category
            var representValue = visualMapModel.getRepresentValue(piece);
            this._createItemSymbol(itemGroup, representValue, [
                0,
                0,
                itemSize[0],
                itemSize[1]
            ]);
            if (showLabel) {
                var visualState = this.visualMapModel.getValueState(representValue);
                itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: {
                        x: itemAlign === "right" ? -textGap : itemSize[0] + textGap,
                        y: itemSize[1] / 2,
                        text: piece.text,
                        verticalAlign: "middle",
                        align: itemAlign,
                        font: textFont,
                        fill: textFill,
                        opacity: visualState === "outOfRange" ? 0.5 : 1
                    }
                }));
            }
            thisGroup.add(itemGroup);
        }, this);
        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
        $93b9bc7f22ac7369$export$827f4ee28efc37(visualMapModel.get("orient"), thisGroup, visualMapModel.get("itemGap"));
        this.renderBackground(thisGroup);
        this.positionGroup(thisGroup);
    };
    PiecewiseVisualMapView.prototype._enableHoverLink = function(itemGroup, pieceIndex) {
        var _this = this;
        itemGroup.on("mouseover", function() {
            return onHoverLink("highlight");
        }).on("mouseout", function() {
            return onHoverLink("downplay");
        });
        var onHoverLink = function(method) {
            var visualMapModel = _this.visualMapModel;
            // TODO: TYPE More detailed action types
            visualMapModel.option.hoverLink && _this.api.dispatchAction({
                type: method,
                batch: $1a17eb3ffb707117$export$5381a9dc5427ba18(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
            });
        };
    };
    PiecewiseVisualMapView.prototype._getItemAlign = function() {
        var visualMapModel = this.visualMapModel;
        var modelOption = visualMapModel.option;
        if (modelOption.orient === "vertical") return $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, this.api, visualMapModel.itemSize);
        else {
            // horizontal, most case left unless specifying right.
            var align = modelOption.align;
            if (!align || align === "auto") align = "left";
            return align;
        }
    };
    PiecewiseVisualMapView.prototype._renderEndsText = function(group, text, itemSize, showLabel, itemAlign) {
        if (!text) return;
        var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var textStyleModel = this.visualMapModel.textStyleModel;
        itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: showLabel ? itemAlign === "right" ? itemSize[0] : 0 : itemSize[0] / 2,
                y: itemSize[1] / 2,
                verticalAlign: "middle",
                align: showLabel ? itemAlign : "center",
                text: text
            })
        }));
        group.add(itemGroup);
    };
    /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */ PiecewiseVisualMapView.prototype._getViewData = function() {
        var visualMapModel = this.visualMapModel;
        var viewPieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualMapModel.getPieceList(), function(piece, index) {
            return {
                piece: piece,
                indexInModelPieceList: index
            };
        });
        var endsText = visualMapModel.get("text");
        // Consider orient and inverse.
        var orient = visualMapModel.get("orient");
        var inverse = visualMapModel.get("inverse");
        // Order of model pieceList is always [low, ..., high]
        if (orient === "horizontal" ? inverse : !inverse) viewPieceList.reverse();
        else if (endsText) endsText = endsText.slice().reverse();
        return {
            viewPieceList: viewPieceList,
            endsText: endsText
        };
    };
    PiecewiseVisualMapView.prototype._createItemSymbol = function(group, representValue, shapeParam) {
        group.add((0, $5370466dadc978d7$export$af050e04da3a02e8)(// symbol will be string
        this.getControllerVisual(representValue, "symbol"), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
        this.getControllerVisual(representValue, "color")));
    };
    PiecewiseVisualMapView.prototype._onItemClick = function(piece) {
        var visualMapModel = this.visualMapModel;
        var option = visualMapModel.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        var selected = $7a1bd9c2710fea0d$export$9cd59f9826255e47(option.selected);
        var newKey = visualMapModel.getSelectedMapKey(piece);
        if (selectedMode === "single" || selectedMode === true) {
            selected[newKey] = true;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(selected, function(o, key) {
                selected[key] = key === newKey;
            });
        } else selected[newKey] = !selected[newKey];
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: selected
        });
    };
    PiecewiseVisualMapView.type = "visualMap.piecewise";
    return PiecewiseVisualMapView;
}((0, $0eb56f276c16b145$export$2e2bcd8739ae039));
var $54f263ebb7934a99$export$2e2bcd8739ae039 = $54f263ebb7934a99$var$PiecewiseVisualMapView;



function $312d2d640a7c60e1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $800f031000e0c641$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $54f263ebb7934a99$export$2e2bcd8739ae039));
    (0, $769f929efa66b3be$export$2e2bcd8739ae039)(registers);
}


function $1df0d53aa7db8747$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $a0f8a196dd8b4cba$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $312d2d640a7c60e1$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $98990baee36aa4ed$var$DEFAULT_OPTION = {
    label: {
        enabled: true
    },
    decal: {
        show: false
    }
};
var $98990baee36aa4ed$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $98990baee36aa4ed$var$decalPaletteScope = {};
function $98990baee36aa4ed$export$2e2bcd8739ae039(ecModel, api) {
    var ariaModel = ecModel.getModel("aria");
    // See "area enabled" detection code in `GlobalModel.ts`.
    if (!ariaModel.get("enabled")) return;
    var defaultOption = $7a1bd9c2710fea0d$export$9cd59f9826255e47($98990baee36aa4ed$var$DEFAULT_OPTION);
    $7a1bd9c2710fea0d$export$4950aa0f605343fb(defaultOption.label, ecModel.getLocaleModel().get("aria"), false);
    $7a1bd9c2710fea0d$export$4950aa0f605343fb(ariaModel.option, defaultOption, false);
    setDecal();
    setLabel();
    function setDecal() {
        var decalModel = ariaModel.getModel("decal");
        var useDecal = decalModel.get("show");
        if (useDecal) {
            // Each type of series use one scope.
            // Pie and funnel are using different scopes.
            var paletteScopeGroupByType_1 = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries()) return;
                var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);
                if (!decalScope) {
                    decalScope = {};
                    paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
                }
                $98990baee36aa4ed$var$inner(seriesModel).scope = decalScope;
            });
            ecModel.eachRawSeries(function(seriesModel) {
                if (ecModel.isSeriesFiltered(seriesModel)) return;
                if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesModel.enableAriaDecal)) {
                    // Let series define how to use decal palette on data
                    seriesModel.enableAriaDecal();
                    return;
                }
                var data = seriesModel.getData();
                if (!seriesModel.isColorBySeries()) {
                    var dataAll_1 = seriesModel.getRawData();
                    var idxMap_1 = {};
                    var decalScope_1 = $98990baee36aa4ed$var$inner(seriesModel).scope;
                    data.each(function(idx) {
                        var rawIdx = data.getRawIndex(idx);
                        idxMap_1[rawIdx] = idx;
                    });
                    var dataCount_1 = dataAll_1.count();
                    dataAll_1.each(function(rawIdx) {
                        var idx = idxMap_1[rawIdx];
                        var name = dataAll_1.getName(rawIdx) || rawIdx + "";
                        var paletteDecal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, name, decalScope_1, dataCount_1);
                        var specifiedDecal = data.getItemVisual(idx, "decal");
                        data.setItemVisual(idx, "decal", mergeDecal(specifiedDecal, paletteDecal));
                    });
                } else {
                    var paletteDecal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, seriesModel.name, $98990baee36aa4ed$var$decalPaletteScope, ecModel.getSeriesCount());
                    var specifiedDecal = data.getVisual("decal");
                    data.setVisual("decal", mergeDecal(specifiedDecal, paletteDecal));
                }
                function mergeDecal(specifiedDecal, paletteDecal) {
                    // Merge decal from palette to decal from itemStyle.
                    // User do not need to specify all of the decal props.
                    var resultDecal = specifiedDecal ? $7a1bd9c2710fea0d$export$8b58be045bf06082($7a1bd9c2710fea0d$export$8b58be045bf06082({}, paletteDecal), specifiedDecal) : paletteDecal;
                    resultDecal.dirty = true;
                    return resultDecal;
                }
            });
        }
    }
    function setLabel() {
        var labelLocale = ecModel.getLocaleModel().get("aria");
        var labelModel = ariaModel.getModel("label");
        labelModel.option = $7a1bd9c2710fea0d$export$ebe90cb607ad99e(labelModel.option, labelLocale);
        if (!labelModel.get("enabled")) return;
        var dom = api.getZr().dom;
        if (labelModel.get("description")) {
            dom.setAttribute("aria-label", labelModel.get("description"));
            return;
        }
        var seriesCnt = ecModel.getSeriesCount();
        var maxDataCnt = labelModel.get([
            "data",
            "maxCount"
        ]) || 10;
        var maxSeriesCnt = labelModel.get([
            "series",
            "maxCount"
        ]) || 10;
        var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
        var ariaLabel;
        if (seriesCnt < 1) // No series, no aria label
        return;
        else {
            var title = getTitle();
            if (title) {
                var withTitle = labelModel.get([
                    "general",
                    "withTitle"
                ]);
                ariaLabel = replace(withTitle, {
                    title: title
                });
            } else ariaLabel = labelModel.get([
                "general",
                "withoutTitle"
            ]);
            var seriesLabels_1 = [];
            var prefix = seriesCnt > 1 ? labelModel.get([
                "series",
                "multiple",
                "prefix"
            ]) : labelModel.get([
                "series",
                "single",
                "prefix"
            ]);
            ariaLabel += replace(prefix, {
                seriesCount: seriesCnt
            });
            ecModel.eachSeries(function(seriesModel, idx) {
                if (idx < displaySeriesCnt) {
                    var seriesLabel = void 0;
                    var seriesName = seriesModel.get("name");
                    var withName = seriesName ? "withName" : "withoutName";
                    seriesLabel = seriesCnt > 1 ? labelModel.get([
                        "series",
                        "multiple",
                        withName
                    ]) : labelModel.get([
                        "series",
                        "single",
                        withName
                    ]);
                    seriesLabel = replace(seriesLabel, {
                        seriesId: seriesModel.seriesIndex,
                        seriesName: seriesModel.get("name"),
                        seriesType: getSeriesTypeName(seriesModel.subType)
                    });
                    var data = seriesModel.getData();
                    if (data.count() > maxDataCnt) {
                        // Show part of data
                        var partialLabel = labelModel.get([
                            "data",
                            "partialData"
                        ]);
                        seriesLabel += replace(partialLabel, {
                            displayCnt: maxDataCnt
                        });
                    } else seriesLabel += labelModel.get([
                        "data",
                        "allData"
                    ]);
                    var middleSeparator_1 = labelModel.get([
                        "data",
                        "separator",
                        "middle"
                    ]);
                    var endSeparator_1 = labelModel.get([
                        "data",
                        "separator",
                        "end"
                    ]);
                    var dataLabels = [];
                    for(var i = 0; i < data.count(); i++)if (i < maxDataCnt) {
                        var name_1 = data.getName(i);
                        var value = data.getValues(i);
                        var dataLabel = labelModel.get([
                            "data",
                            name_1 ? "withName" : "withoutName"
                        ]);
                        dataLabels.push(replace(dataLabel, {
                            name: name_1,
                            value: value.join(middleSeparator_1)
                        }));
                    }
                    seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
                    seriesLabels_1.push(seriesLabel);
                }
            });
            var separatorModel = labelModel.getModel([
                "series",
                "multiple",
                "separator"
            ]);
            var middleSeparator = separatorModel.get("middle");
            var endSeparator = separatorModel.get("end");
            ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
            dom.setAttribute("aria-label", ariaLabel);
        }
    }
    function replace(str, keyValues) {
        if (!$7a1bd9c2710fea0d$export$844ec244b1367d54(str)) return str;
        var result = str;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(keyValues, function(value, key) {
            result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), value);
        });
        return result;
    }
    function getTitle() {
        var title = ecModel.get("title");
        if (title && title.length) title = title[0];
        return title && title.text;
    }
    function getSeriesTypeName(type) {
        var typeNames = ecModel.getLocaleModel().get([
            "series",
            "typeNames"
        ]);
        return typeNames[type] || typeNames.chart;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $6f6d6469de000c68$export$2e2bcd8739ae039(option) {
    if (!option || !option.aria) return;
    var aria = option.aria;
    // aria.show is deprecated and should use aria.enabled instead
    if (aria.show != null) aria.enabled = aria.show;
    aria.label = aria.label || {};
    // move description, general, series, data to be under aria.label
    $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        "description",
        "general",
        "series",
        "data"
    ], function(name) {
        if (aria[name] != null) aria.label[name] = aria[name];
    });
}


function $772c09ed30d27c33$export$4b3e715f166fdd78(registers) {
    registers.registerPreprocessor((0, $6f6d6469de000c68$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, (0, $98990baee36aa4ed$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
    value: "eq",
    // PENDING: not good for literal semantic?
    "<": "lt",
    "<=": "lte",
    ">": "gt",
    ">=": "gte",
    "=": "eq",
    "!=": "ne",
    "<>": "ne"
};
// type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;
var $9c7e3d8a1f578014$var$RegExpEvaluator = /** @class */ function() {
    function RegExpEvaluator(rVal) {
        // Support condVal: RegExp | string
        var condValue = this._condVal = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rVal) ? new RegExp(rVal) : (0, $7a1bd9c2710fea0d$export$49841c62b9eff15)(rVal) ? rVal : null;
        if (condValue == null) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
    }
    RegExpEvaluator.prototype.evaluate = function(lVal) {
        var type = typeof lVal;
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(type) ? this._condVal.test(lVal) : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(type) ? this._condVal.test(lVal + "") : false;
    };
    return RegExpEvaluator;
}();
var $9c7e3d8a1f578014$var$ConstConditionInternal = /** @class */ function() {
    function ConstConditionInternal() {}
    ConstConditionInternal.prototype.evaluate = function() {
        return this.value;
    };
    return ConstConditionInternal;
}();
var $9c7e3d8a1f578014$var$AndConditionInternal = /** @class */ function() {
    function AndConditionInternal() {}
    AndConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (!children[i].evaluate()) return false;
        }
        return true;
    };
    return AndConditionInternal;
}();
var $9c7e3d8a1f578014$var$OrConditionInternal = /** @class */ function() {
    function OrConditionInternal() {}
    OrConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (children[i].evaluate()) return true;
        }
        return false;
    };
    return OrConditionInternal;
}();
var $9c7e3d8a1f578014$var$NotConditionInternal = /** @class */ function() {
    function NotConditionInternal() {}
    NotConditionInternal.prototype.evaluate = function() {
        return !this.child.evaluate();
    };
    return NotConditionInternal;
}();
var $9c7e3d8a1f578014$var$RelationalConditionInternal = /** @class */ function() {
    function RelationalConditionInternal() {}
    RelationalConditionInternal.prototype.evaluate = function() {
        var needParse = !!this.valueParser;
        // Call getValue with no `this`.
        var getValue = this.getValue;
        var tarValRaw = getValue(this.valueGetterParam);
        var tarValParsed = needParse ? this.valueParser(tarValRaw) : null;
        // Relational cond follow "and" logic internally.
        for(var i = 0; i < this.subCondList.length; i++){
            if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) return false;
        }
        return true;
    };
    return RelationalConditionInternal;
}();
function $9c7e3d8a1f578014$var$parseOption(exprOption, getters) {
    if (exprOption === true || exprOption === false) {
        var cond = new $9c7e3d8a1f578014$var$ConstConditionInternal();
        cond.value = exprOption;
        return cond;
    }
    var errMsg = "";
    if (!$9c7e3d8a1f578014$var$isObjectNotArray(exprOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (exprOption.and) return $9c7e3d8a1f578014$var$parseAndOrOption("and", exprOption, getters);
    else if (exprOption.or) return $9c7e3d8a1f578014$var$parseAndOrOption("or", exprOption, getters);
    else if (exprOption.not) return $9c7e3d8a1f578014$var$parseNotOption(exprOption, getters);
    return $9c7e3d8a1f578014$var$parseRelationalOption(exprOption, getters);
}
function $9c7e3d8a1f578014$var$parseAndOrOption(op, exprOption, getters) {
    var subOptionArr = exprOption[op];
    var errMsg = "";
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(subOptionArr)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (!subOptionArr.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = op === "and" ? new $9c7e3d8a1f578014$var$AndConditionInternal() : new $9c7e3d8a1f578014$var$OrConditionInternal();
    cond.children = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(subOptionArr, function(subOption) {
        return $9c7e3d8a1f578014$var$parseOption(subOption, getters);
    });
    if (!cond.children.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $9c7e3d8a1f578014$var$parseNotOption(exprOption, getters) {
    var subOption = exprOption.not;
    var errMsg = "";
    if (!$9c7e3d8a1f578014$var$isObjectNotArray(subOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $9c7e3d8a1f578014$var$NotConditionInternal();
    cond.child = $9c7e3d8a1f578014$var$parseOption(subOption, getters);
    if (!cond.child) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $9c7e3d8a1f578014$var$parseRelationalOption(exprOption, getters) {
    var errMsg = "";
    var valueGetterParam = getters.prepareGetValue(exprOption);
    var subCondList = [];
    var exprKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(exprOption);
    var parserName = exprOption.parser;
    var valueParser = parserName ? (0, $40ab59f44b7d2db6$export$c88237b7c265b36b)(parserName) : null;
    for(var i = 0; i < exprKeys.length; i++){
        var keyRaw = exprKeys[i];
        if (keyRaw === "parser" || getters.valueGetterAttrMap.get(keyRaw)) continue;
        var op = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? $9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
        var condValueRaw = exprOption[keyRaw];
        var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
        var evaluator = (0, $40ab59f44b7d2db6$export$f2644c3485f94c4e)(op, condValueParsed) || op === "reg" && new $9c7e3d8a1f578014$var$RegExpEvaluator(condValueParsed);
        if (!evaluator) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        subCondList.push(evaluator);
    }
    if (!subCondList.length) // No relational operator always disabled in case of dangers result.
    (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $9c7e3d8a1f578014$var$RelationalConditionInternal();
    cond.valueGetterParam = valueGetterParam;
    cond.valueParser = valueParser;
    cond.getValue = getters.getValue;
    cond.subCondList = subCondList;
    return cond;
}
function $9c7e3d8a1f578014$var$isObjectNotArray(val) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(val) && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val);
}
var $9c7e3d8a1f578014$var$ConditionalExpressionParsed = /** @class */ function() {
    function ConditionalExpressionParsed(exprOption, getters) {
        this._cond = $9c7e3d8a1f578014$var$parseOption(exprOption, getters);
    }
    ConditionalExpressionParsed.prototype.evaluate = function() {
        return this._cond.evaluate();
    };
    return ConditionalExpressionParsed;
}();
function $9c7e3d8a1f578014$export$cd61647d82cec762(exprOption, getters) {
    return new $9c7e3d8a1f578014$var$ConditionalExpressionParsed(exprOption, getters);
}




var $0e1e10ffafe52e71$export$dc15474d94cdc2b3 = {
    type: "echarts:filter",
    // PENDING: enhance to filter by index rather than create new data
    transform: function(params) {
        // [Caveat] Fail-Fast:
        // Do not return the whole dataset unless user config indicates it explicitly.
        // For example, if no condition is specified by mistake, returning an empty result
        // is better than returning the entire raw source for the user to find the mistake.
        var upstream = params.upstream;
        var rawItem;
        var condition = (0, $9c7e3d8a1f578014$export$cd61647d82cec762)(params.config, {
            valueGetterAttrMap: (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
                dimension: true
            }),
            prepareGetValue: function(exprOption) {
                var errMsg = "";
                var dimLoose = exprOption.dimension;
                if (!(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(exprOption, "dimension")) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
                var dimInfo = upstream.getDimensionInfo(dimLoose);
                if (!dimInfo) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
                return {
                    dimIdx: dimInfo.index
                };
            },
            getValue: function(param) {
                return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
            }
        });
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++){
            rawItem = upstream.getRawDataItem(i);
            if (condition.evaluate()) resultData.push(rawItem);
        }
        return {
            data: resultData
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $7781c153e964c2e9$var$sampleLog = "";
var $7781c153e964c2e9$export$505f1bb66427eaee = {
    type: "echarts:sort",
    transform: function(params) {
        var upstream = params.upstream;
        var config = params.config;
        var errMsg = "";
        // Normalize
        // const orderExprList: OrderExpression[] = isArray(config[0])
        //     ? config as OrderExpression[]
        //     : [config as OrderExpression];
        var orderExprList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(config);
        if (!orderExprList.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var orderDefList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(orderExprList, function(orderExpr) {
            var dimLoose = orderExpr.dimension;
            var order = orderExpr.order;
            var parserName = orderExpr.parser;
            var incomparable = orderExpr.incomparable;
            if (dimLoose == null) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            if (order !== "asc" && order !== "desc") (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            if (incomparable && incomparable !== "min" && incomparable !== "max") {
                var errMsg_1 = "";
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_1);
            }
            if (order !== "asc" && order !== "desc") {
                var errMsg_2 = "";
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_2);
            }
            var dimInfo = upstream.getDimensionInfo(dimLoose);
            if (!dimInfo) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            var parser = parserName ? (0, $40ab59f44b7d2db6$export$c88237b7c265b36b)(parserName) : null;
            if (parserName && !parser) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            orderDefList.push({
                dimIdx: dimInfo.index,
                parser: parser,
                comparator: new (0, $40ab59f44b7d2db6$export$ed75a5d7b0144167)(order, incomparable)
            });
        });
        // TODO: support it?
        var sourceFormat = upstream.sourceFormat;
        if (sourceFormat !== (0, $cab29724515ce2b8$export$fcd62ebf51387903) && sourceFormat !== (0, $cab29724515ce2b8$export$703ae8a2d83f441)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        // Other upstream format are all array.
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++)resultData.push(upstream.getRawDataItem(i));
        resultData.sort(function(item0, item1) {
            for(var i = 0; i < orderDefList.length; i++){
                var orderDef = orderDefList[i];
                var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
                var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);
                if (orderDef.parser) {
                    val0 = orderDef.parser(val0);
                    val1 = orderDef.parser(val1);
                }
                var result = orderDef.comparator.evaluate(val0, val1);
                if (result !== 0) return result;
            }
            return 0;
        });
        return {
            data: resultData
        };
    }
};


function $d6bad095dfa9594d$export$4b3e715f166fdd78(registers) {
    registers.registerTransform((0, $0e1e10ffafe52e71$export$dc15474d94cdc2b3));
    registers.registerTransform((0, $7781c153e964c2e9$export$505f1bb66427eaee));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $afb70cea6fec4fe0$export$83e718f1c3c9edae = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DatasetModel, _super);
    function DatasetModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataset";
        return _this;
    }
    DatasetModel.prototype.init = function(option, parentModel, ecModel) {
        _super.prototype.init.call(this, option, parentModel, ecModel);
        this._sourceManager = new (0, $1c87d176de397e7e$export$af4db9ec7e200ea2)(this);
        (0, $1c87d176de397e7e$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.call(this, newOption, ecModel);
        (0, $1c87d176de397e7e$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.optionUpdated = function() {
        this._sourceManager.dirty();
    };
    DatasetModel.prototype.getSourceManager = function() {
        return this._sourceManager;
    };
    DatasetModel.type = "dataset";
    DatasetModel.defaultOption = {
        seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)
    };
    return DatasetModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $afb70cea6fec4fe0$var$DatasetView = /** @class */ function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(DatasetView, _super);
    function DatasetView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataset";
        return _this;
    }
    DatasetView.type = "dataset";
    return DatasetView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $afb70cea6fec4fe0$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($afb70cea6fec4fe0$export$83e718f1c3c9edae);
    registers.registerComponentView($afb70cea6fec4fe0$var$DatasetView);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Universal transitions that can animate between any shapes(series) and any properties in any amounts.


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














var $2a60c506580ea7a9$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
function $2a60c506580ea7a9$var$aroundEqual(a, b) {
    return Math.abs(a - b) < 1e-5;
}
function $2a60c506580ea7a9$export$fbc91cffd4bdf629(path) {
    var data = path.data;
    var len = path.len();
    var bezierArrayGroups = [];
    var currentSubpath;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    function createNewSubpath(x, y) {
        if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
        currentSubpath = [
            x,
            y
        ];
    }
    function addLine(x0, y0, x1, y1) {
        if (!($2a60c506580ea7a9$var$aroundEqual(x0, x1) && $2a60c506580ea7a9$var$aroundEqual(y0, y1))) currentSubpath.push(x0, y0, x1, y1, x1, y1);
    }
    function addArc(startAngle, endAngle, cx, cy, rx, ry) {
        var delta = Math.abs(endAngle - startAngle);
        var len = Math.tan(delta / 4) * 4 / 3;
        var dir = endAngle < startAngle ? -1 : 1;
        var c1 = Math.cos(startAngle);
        var s1 = Math.sin(startAngle);
        var c2 = Math.cos(endAngle);
        var s2 = Math.sin(endAngle);
        var x1 = c1 * rx + cx;
        var y1 = s1 * ry + cy;
        var x4 = c2 * rx + cx;
        var y4 = s2 * ry + cy;
        var hx = rx * len * dir;
        var hy = ry * len * dir;
        currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
    }
    var x1;
    var y1;
    var x2;
    var y2;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
            if (cmd === $2a60c506580ea7a9$var$CMD.L || cmd === $2a60c506580ea7a9$var$CMD.C || cmd === $2a60c506580ea7a9$var$CMD.Q) currentSubpath = [
                x0,
                y0
            ];
        }
        switch(cmd){
            case $2a60c506580ea7a9$var$CMD.M:
                xi = x0 = data[i++];
                yi = y0 = data[i++];
                createNewSubpath(x0, y0);
                break;
            case $2a60c506580ea7a9$var$CMD.L:
                x1 = data[i++];
                y1 = data[i++];
                addLine(xi, yi, x1, y1);
                xi = x1;
                yi = y1;
                break;
            case $2a60c506580ea7a9$var$CMD.C:
                currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
                break;
            case $2a60c506580ea7a9$var$CMD.Q:
                x1 = data[i++];
                y1 = data[i++];
                x2 = data[i++];
                y2 = data[i++];
                currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
                xi = x2;
                yi = y2;
                break;
            case $2a60c506580ea7a9$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var startAngle = data[i++];
                var endAngle = data[i++] + startAngle;
                i += 1;
                var anticlockwise = !data[i++];
                x1 = Math.cos(startAngle) * rx + cx;
                y1 = Math.sin(startAngle) * ry + cy;
                if (isFirst) {
                    x0 = x1;
                    y0 = y1;
                    createNewSubpath(x0, y0);
                } else addLine(xi, yi, x1, y1);
                xi = Math.cos(endAngle) * rx + cx;
                yi = Math.sin(endAngle) * ry + cy;
                var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
                for(var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step){
                    var nextAngle = anticlockwise ? Math.max(angle + step, endAngle) : Math.min(angle + step, endAngle);
                    addArc(angle, nextAngle, cx, cy, rx, ry);
                }
                break;
            case $2a60c506580ea7a9$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                x1 = x0 + data[i++];
                y1 = y0 + data[i++];
                createNewSubpath(x1, y0);
                addLine(x1, y0, x1, y1);
                addLine(x1, y1, x0, y1);
                addLine(x0, y1, x0, y0);
                addLine(x0, y0, x1, y0);
                break;
            case $2a60c506580ea7a9$var$CMD.Z:
                currentSubpath && addLine(xi, yi, x0, y0);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
    return bezierArrayGroups;
}
function $2a60c506580ea7a9$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
    if ($2a60c506580ea7a9$var$aroundEqual(x0, x1) && $2a60c506580ea7a9$var$aroundEqual(y0, y1) && $2a60c506580ea7a9$var$aroundEqual(x2, x3) && $2a60c506580ea7a9$var$aroundEqual(y2, y3)) {
        out.push(x3, y3);
        return;
    }
    var PIXEL_DISTANCE = 2 / scale;
    var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
    var dx = x3 - x0;
    var dy = y3 - y0;
    var d = Math.sqrt(dx * dx + dy * dy);
    dx /= d;
    dy /= d;
    var dx1 = x1 - x0;
    var dy1 = y1 - y0;
    var dx2 = x2 - x3;
    var dy2 = y2 - y3;
    var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
    var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
    if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
        out.push(x3, y3);
        return;
    }
    var projLen1 = dx * dx1 + dy * dy1;
    var projLen2 = -dx * dx2 - dy * dy2;
    var d1Sqr = cp1LenSqr - projLen1 * projLen1;
    var d2Sqr = cp2LenSqr - projLen2 * projLen2;
    if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0 && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
        out.push(x3, y3);
        return;
    }
    var tmpSegX = [];
    var tmpSegY = [];
    (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x0, x1, x2, x3, 0.5, tmpSegX);
    (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y0, y1, y2, y3, 0.5, tmpSegY);
    $2a60c506580ea7a9$var$adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
    $2a60c506580ea7a9$var$adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
}
function $2a60c506580ea7a9$export$163f4950160f2337(path, scale) {
    var bezierArrayGroups = $2a60c506580ea7a9$export$fbc91cffd4bdf629(path);
    var polygons = [];
    scale = scale || 1;
    for(var i = 0; i < bezierArrayGroups.length; i++){
        var beziers = bezierArrayGroups[i];
        var polygon = [];
        var x0 = beziers[0];
        var y0 = beziers[1];
        polygon.push(x0, y0);
        for(var k = 2; k < beziers.length;){
            var x1 = beziers[k++];
            var y1 = beziers[k++];
            var x2 = beziers[k++];
            var y2 = beziers[k++];
            var x3 = beziers[k++];
            var y3 = beziers[k++];
            $2a60c506580ea7a9$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
            x0 = x3;
            y0 = y3;
        }
        polygons.push(polygon);
    }
    return polygons;
}



function $640f8b532a910a4f$var$getDividingGrids(dimSize, rowDim, count) {
    var rowSize = dimSize[rowDim];
    var columnSize = dimSize[1 - rowDim];
    var ratio = Math.abs(rowSize / columnSize);
    var rowCount = Math.ceil(Math.sqrt(ratio * count));
    var columnCount = Math.floor(count / rowCount);
    if (columnCount === 0) {
        columnCount = 1;
        rowCount = count;
    }
    var grids = [];
    for(var i = 0; i < rowCount; i++)grids.push(columnCount);
    var currentCount = rowCount * columnCount;
    var remained = count - currentCount;
    if (remained > 0) for(var i = 0; i < remained; i++)grids[i % rowCount] += 1;
    return grids;
}
function $640f8b532a910a4f$var$divideSector(sectorShape, count, outShapes) {
    var r0 = sectorShape.r0;
    var r = sectorShape.r;
    var startAngle = sectorShape.startAngle;
    var endAngle = sectorShape.endAngle;
    var angle = Math.abs(endAngle - startAngle);
    var arcLen = angle * r;
    var deltaR = r - r0;
    var isAngleRow = arcLen > Math.abs(deltaR);
    var grids = $640f8b532a910a4f$var$getDividingGrids([
        arcLen,
        deltaR
    ], isAngleRow ? 0 : 1, count);
    var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            if (isAngleRow) {
                newShape.startAngle = startAngle + rowSize * row;
                newShape.endAngle = startAngle + rowSize * (row + 1);
                newShape.r0 = r0 + columnSize * column;
                newShape.r = r0 + columnSize * (column + 1);
            } else {
                newShape.startAngle = startAngle + columnSize * column;
                newShape.endAngle = startAngle + columnSize * (column + 1);
                newShape.r0 = r0 + rowSize * row;
                newShape.r = r0 + rowSize * (row + 1);
            }
            newShape.clockwise = sectorShape.clockwise;
            newShape.cx = sectorShape.cx;
            newShape.cy = sectorShape.cy;
            outShapes.push(newShape);
        }
    }
}
function $640f8b532a910a4f$var$divideRect(rectShape, count, outShapes) {
    var width = rectShape.width;
    var height = rectShape.height;
    var isHorizontalRow = width > height;
    var grids = $640f8b532a910a4f$var$getDividingGrids([
        width,
        height
    ], isHorizontalRow ? 0 : 1, count);
    var rowSizeDim = isHorizontalRow ? "width" : "height";
    var columnSizeDim = isHorizontalRow ? "height" : "width";
    var rowDim = isHorizontalRow ? "x" : "y";
    var columnDim = isHorizontalRow ? "y" : "x";
    var rowSize = rectShape[rowSizeDim] / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = rectShape[columnSizeDim] / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            newShape[rowDim] = row * rowSize;
            newShape[columnDim] = column * columnSize;
            newShape[rowSizeDim] = rowSize;
            newShape[columnSizeDim] = columnSize;
            newShape.x += rectShape.x;
            newShape.y += rectShape.y;
            outShapes.push(newShape);
        }
    }
}
function $640f8b532a910a4f$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $640f8b532a910a4f$var$lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    var nmCrossProduct = $640f8b532a910a4f$var$crossProduct2d(nx, ny, mx, my);
    if (Math.abs(nmCrossProduct) < 1e-6) return null;
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var p = $640f8b532a910a4f$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return null;
    return new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(p * mx + a1x, p * my + a1y);
}
function $640f8b532a910a4f$var$projPtOnLine(pt, lineA, lineB) {
    var dir = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(dir, lineB, lineA);
    dir.normalize();
    var dir2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(dir2, pt, lineA);
    var len = dir2.dot(dir);
    return len;
}
function $640f8b532a910a4f$var$addToPoly(poly, pt) {
    var last = poly[poly.length - 1];
    if (last && last[0] === pt[0] && last[1] === pt[1]) return;
    poly.push(pt);
}
function $640f8b532a910a4f$var$splitPolygonByLine(points, lineA, lineB) {
    var len = points.length;
    var intersections = [];
    for(var i = 0; i < len; i++){
        var p0 = points[i];
        var p1 = points[(i + 1) % len];
        var intersectionPt = $640f8b532a910a4f$var$lineLineIntersect(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
        if (intersectionPt) intersections.push({
            projPt: $640f8b532a910a4f$var$projPtOnLine(intersectionPt, lineA, lineB),
            pt: intersectionPt,
            idx: i
        });
    }
    if (intersections.length < 2) return [
        {
            points: points
        },
        {
            points: points
        }
    ];
    intersections.sort(function(a, b) {
        return a.projPt - b.projPt;
    });
    var splitPt0 = intersections[0];
    var splitPt1 = intersections[intersections.length - 1];
    if (splitPt1.idx < splitPt0.idx) {
        var tmp = splitPt0;
        splitPt0 = splitPt1;
        splitPt1 = tmp;
    }
    var splitPt0Arr = [
        splitPt0.pt.x,
        splitPt0.pt.y
    ];
    var splitPt1Arr = [
        splitPt1.pt.x,
        splitPt1.pt.y
    ];
    var newPolyA = [
        splitPt0Arr
    ];
    var newPolyB = [
        splitPt1Arr
    ];
    for(var i = splitPt0.idx + 1; i <= splitPt1.idx; i++)$640f8b532a910a4f$var$addToPoly(newPolyA, points[i].slice());
    $640f8b532a910a4f$var$addToPoly(newPolyA, splitPt1Arr);
    $640f8b532a910a4f$var$addToPoly(newPolyA, splitPt0Arr);
    for(var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++)$640f8b532a910a4f$var$addToPoly(newPolyB, points[i % len].slice());
    $640f8b532a910a4f$var$addToPoly(newPolyB, splitPt0Arr);
    $640f8b532a910a4f$var$addToPoly(newPolyB, splitPt1Arr);
    return [
        {
            points: newPolyA
        },
        {
            points: newPolyB
        }
    ];
}
function $640f8b532a910a4f$var$binaryDividePolygon(polygonShape) {
    var points = polygonShape.points;
    var min = [];
    var max = [];
    (0, $af3aab2435198f82$export$188c3cd07b4129dd)(points, min, max);
    var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    var width = boundingRect.width;
    var height = boundingRect.height;
    var x = boundingRect.x;
    var y = boundingRect.y;
    var pt0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    var pt1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    if (width > height) {
        pt0.x = pt1.x = x + width / 2;
        pt0.y = y;
        pt1.y = y + height;
    } else {
        pt0.y = pt1.y = y + height / 2;
        pt0.x = x;
        pt1.x = x + width;
    }
    return $640f8b532a910a4f$var$splitPolygonByLine(points, pt0, pt1);
}
function $640f8b532a910a4f$var$binaryDivideRecursive(divider, shape, count, out) {
    if (count === 1) out.push(shape);
    else {
        var mid = Math.floor(count / 2);
        var sub = divider(shape);
        $640f8b532a910a4f$var$binaryDivideRecursive(divider, sub[0], mid, out);
        $640f8b532a910a4f$var$binaryDivideRecursive(divider, sub[1], count - mid, out);
    }
    return out;
}
function $640f8b532a910a4f$export$9cd59f9826255e47(path, count) {
    var paths = [];
    for(var i = 0; i < count; i++)paths.push((0, $15b38920672b9006$export$18711d956bf1c3eb)(path));
    return paths;
}
function $640f8b532a910a4f$var$copyPathProps(source, target) {
    target.setStyle(source.style);
    target.z = source.z;
    target.z2 = source.z2;
    target.zlevel = source.zlevel;
}
function $640f8b532a910a4f$var$polygonConvert(points) {
    var out = [];
    for(var i = 0; i < points.length;)out.push([
        points[i++],
        points[i++]
    ]);
    return out;
}
function $640f8b532a910a4f$export$65980d18b75784e2(path, count) {
    var outShapes = [];
    var shape = path.shape;
    var OutShapeCtor;
    switch(path.type){
        case "rect":
            $640f8b532a910a4f$var$divideRect(shape, count, outShapes);
            OutShapeCtor = (0, $419e5ff2f303755e$export$2e2bcd8739ae039);
            break;
        case "sector":
            $640f8b532a910a4f$var$divideSector(shape, count, outShapes);
            OutShapeCtor = (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
            break;
        case "circle":
            $640f8b532a910a4f$var$divideSector({
                r0: 0,
                r: shape.r,
                startAngle: 0,
                endAngle: Math.PI * 2,
                cx: shape.cx,
                cy: shape.cy
            }, count, outShapes);
            OutShapeCtor = (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
            break;
        default:
            var m = path.getComputedTransform();
            var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
            var polygons = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $2a60c506580ea7a9$export$163f4950160f2337)(path.getUpdatedPathProxy(), scale), function(poly) {
                return $640f8b532a910a4f$var$polygonConvert(poly);
            });
            var polygonCount = polygons.length;
            if (polygonCount === 0) $640f8b532a910a4f$var$binaryDivideRecursive($640f8b532a910a4f$var$binaryDividePolygon, {
                points: polygons[0]
            }, count, outShapes);
            else if (polygonCount === count) for(var i = 0; i < polygonCount; i++)outShapes.push({
                points: polygons[i]
            });
            else {
                var totalArea_1 = 0;
                var items = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(polygons, function(poly) {
                    var min = [];
                    var max = [];
                    (0, $af3aab2435198f82$export$188c3cd07b4129dd)(poly, min, max);
                    var area = (max[1] - min[1]) * (max[0] - min[0]);
                    totalArea_1 += area;
                    return {
                        poly: poly,
                        area: area
                    };
                });
                items.sort(function(a, b) {
                    return b.area - a.area;
                });
                var left = count;
                for(var i = 0; i < polygonCount; i++){
                    var item = items[i];
                    if (left <= 0) break;
                    var selfCount = i === polygonCount - 1 ? left : Math.ceil(item.area / totalArea_1 * count);
                    if (selfCount < 0) continue;
                    $640f8b532a910a4f$var$binaryDivideRecursive($640f8b532a910a4f$var$binaryDividePolygon, {
                        points: item.poly
                    }, selfCount, outShapes);
                    left -= selfCount;
                }
            }
            OutShapeCtor = (0, $51acf033123e1a30$export$2e2bcd8739ae039);
            break;
    }
    if (!OutShapeCtor) return $640f8b532a910a4f$export$9cd59f9826255e47(path, count);
    var out = [];
    for(var i = 0; i < outShapes.length; i++){
        var subPath = new OutShapeCtor();
        subPath.setShape(outShapes[i]);
        $640f8b532a910a4f$var$copyPathProps(path, subPath);
        out.push(subPath);
    }
    return out;
}



function $2ef03ef3a2bb366a$var$alignSubpath(subpath1, subpath2) {
    var len1 = subpath1.length;
    var len2 = subpath2.length;
    if (len1 === len2) return [
        subpath1,
        subpath2
    ];
    var tmpSegX = [];
    var tmpSegY = [];
    var shorterPath = len1 < len2 ? subpath1 : subpath2;
    var shorterLen = Math.min(len1, len2);
    var diff = Math.abs(len2 - len1) / 6;
    var shorterBezierCount = (shorterLen - 2) / 6;
    var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
    var newSubpath = [
        shorterPath[0],
        shorterPath[1]
    ];
    var remained = diff;
    for(var i = 2; i < shorterLen;){
        var x0 = shorterPath[i - 2];
        var y0 = shorterPath[i - 1];
        var x1 = shorterPath[i++];
        var y1 = shorterPath[i++];
        var x2 = shorterPath[i++];
        var y2 = shorterPath[i++];
        var x3 = shorterPath[i++];
        var y3 = shorterPath[i++];
        if (remained <= 0) {
            newSubpath.push(x1, y1, x2, y2, x3, y3);
            continue;
        }
        var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
        for(var k = 1; k <= actualSubDivCount; k++){
            var p = k / actualSubDivCount;
            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x0, x1, x2, x3, p, tmpSegX);
            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y0, y1, y2, y3, p, tmpSegY);
            x0 = tmpSegX[3];
            y0 = tmpSegY[3];
            newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
            x1 = tmpSegX[5];
            y1 = tmpSegY[5];
            x2 = tmpSegX[6];
            y2 = tmpSegY[6];
        }
        remained -= actualSubDivCount - 1;
    }
    return shorterPath === subpath1 ? [
        newSubpath,
        subpath2
    ] : [
        subpath1,
        newSubpath
    ];
}
function $2ef03ef3a2bb366a$var$createSubpath(lastSubpathSubpath, otherSubpath) {
    var len = lastSubpathSubpath.length;
    var lastX = lastSubpathSubpath[len - 2];
    var lastY = lastSubpathSubpath[len - 1];
    var newSubpath = [];
    for(var i = 0; i < otherSubpath.length;){
        newSubpath[i++] = lastX;
        newSubpath[i++] = lastY;
    }
    return newSubpath;
}
function $2ef03ef3a2bb366a$export$d7b853a0ab412a07(array1, array2) {
    var _a;
    var lastSubpath1;
    var lastSubpath2;
    var newArray1 = [];
    var newArray2 = [];
    for(var i = 0; i < Math.max(array1.length, array2.length); i++){
        var subpath1 = array1[i];
        var subpath2 = array2[i];
        var newSubpath1 = void 0;
        var newSubpath2 = void 0;
        if (!subpath1) {
            newSubpath1 = $2ef03ef3a2bb366a$var$createSubpath(lastSubpath1 || subpath2, subpath2);
            newSubpath2 = subpath2;
        } else if (!subpath2) {
            newSubpath2 = $2ef03ef3a2bb366a$var$createSubpath(lastSubpath2 || subpath1, subpath1);
            newSubpath1 = subpath1;
        } else {
            _a = $2ef03ef3a2bb366a$var$alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
            lastSubpath1 = newSubpath1;
            lastSubpath2 = newSubpath2;
        }
        newArray1.push(newSubpath1);
        newArray2.push(newSubpath2);
    }
    return [
        newArray1,
        newArray2
    ];
}
function $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(array) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = array.length;
    for(var i = 0, j = len - 2; i < len; j = i, i += 2){
        var x0 = array[j];
        var y0 = array[j + 1];
        var x1 = array[i];
        var y1 = array[i + 1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
    }
    if (signedArea === 0) return [
        array[0] || 0,
        array[1] || 0
    ];
    return [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ];
}
function $2ef03ef3a2bb366a$var$findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
    var bezierCount = (fromSubBeziers.length - 2) / 6;
    var bestScore = Infinity;
    var bestOffset = 0;
    var len = fromSubBeziers.length;
    var len2 = len - 2;
    for(var offset = 0; offset < bezierCount; offset++){
        var cursorOffset = offset * 6;
        var score = 0;
        for(var k = 0; k < len; k += 2){
            var idx = k === 0 ? cursorOffset : (cursorOffset + k - 2) % len2 + 2;
            var x0 = fromSubBeziers[idx] - fromCp[0];
            var y0 = fromSubBeziers[idx + 1] - fromCp[1];
            var x1 = toSubBeziers[k] - toCp[0];
            var y1 = toSubBeziers[k + 1] - toCp[1];
            var dx = x1 - x0;
            var dy = y1 - y0;
            score += dx * dx + dy * dy;
        }
        if (score < bestScore) {
            bestScore = score;
            bestOffset = offset;
        }
    }
    return bestOffset;
}
function $2ef03ef3a2bb366a$var$reverse(array) {
    var newArr = [];
    var len = array.length;
    for(var i = 0; i < len; i += 2){
        newArr[i] = array[len - i - 2];
        newArr[i + 1] = array[len - i - 1];
    }
    return newArr;
}
function $2ef03ef3a2bb366a$var$findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
    var result = [];
    var fromNeedsReverse;
    for(var i = 0; i < fromArr.length; i++){
        var fromSubpathBezier = fromArr[i];
        var toSubpathBezier = toArr[i];
        var fromCp = $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(fromSubpathBezier);
        var toCp = $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(toSubpathBezier);
        if (fromNeedsReverse == null) fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
        var newFromSubpathBezier = [];
        var newToSubpathBezier = [];
        var bestAngle = 0;
        var bestScore = Infinity;
        var tmpArr = [];
        var len = fromSubpathBezier.length;
        if (fromNeedsReverse) fromSubpathBezier = $2ef03ef3a2bb366a$var$reverse(fromSubpathBezier);
        var offset = $2ef03ef3a2bb366a$var$findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
        var len2 = len - 2;
        for(var k = 0; k < len2; k += 2){
            var idx = (offset + k) % len2 + 2;
            newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
            newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
        }
        newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
        newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
        if (searchAngleIteration > 0) {
            var step = searchAngleRange / searchAngleIteration;
            for(var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step){
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                var score = 0;
                for(var k = 0; k < fromSubpathBezier.length; k += 2){
                    var x0 = newFromSubpathBezier[k];
                    var y0 = newFromSubpathBezier[k + 1];
                    var x1 = toSubpathBezier[k] - toCp[0];
                    var y1 = toSubpathBezier[k + 1] - toCp[1];
                    var newX1 = x1 * ca - y1 * sa;
                    var newY1 = x1 * sa + y1 * ca;
                    tmpArr[k] = newX1;
                    tmpArr[k + 1] = newY1;
                    var dx = newX1 - x0;
                    var dy = newY1 - y0;
                    score += dx * dx + dy * dy;
                }
                if (score < bestScore) {
                    bestScore = score;
                    bestAngle = angle;
                    for(var m = 0; m < tmpArr.length; m++)newToSubpathBezier[m] = tmpArr[m];
                }
            }
        } else for(var i_1 = 0; i_1 < len; i_1 += 2){
            newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
            newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
        }
        result.push({
            from: newFromSubpathBezier,
            to: newToSubpathBezier,
            fromCp: fromCp,
            toCp: toCp,
            rotation: -bestAngle
        });
    }
    return result;
}
function $2ef03ef3a2bb366a$export$f9f720a01590a46f(path) {
    return path.__isCombineMorphing;
}
function $2ef03ef3a2bb366a$export$ddee3124b756354f(el) {
    return el.__morphT >= 0;
}
var $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX = "__mOriginal_";
function $2ef03ef3a2bb366a$var$saveAndModifyMethod(obj, methodName, modifiers) {
    var savedMethodName = $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX + methodName;
    var originalMethod = obj[savedMethodName] || obj[methodName];
    if (!obj[savedMethodName]) obj[savedMethodName] = obj[methodName];
    var replace = modifiers.replace;
    var after = modifiers.after;
    var before = modifiers.before;
    obj[methodName] = function() {
        var args = arguments;
        var res;
        before && before.apply(this, args);
        if (replace) res = replace.apply(this, args);
        else res = originalMethod.apply(this, args);
        after && after.apply(this, args);
        return res;
    };
}
function $2ef03ef3a2bb366a$var$restoreMethod(obj, methodName) {
    var savedMethodName = $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX + methodName;
    if (obj[savedMethodName]) {
        obj[methodName] = obj[savedMethodName];
        obj[savedMethodName] = null;
    }
}
function $2ef03ef3a2bb366a$var$applyTransformOnBeziers(bezierCurves, mm) {
    for(var i = 0; i < bezierCurves.length; i++){
        var subBeziers = bezierCurves[i];
        for(var k = 0; k < subBeziers.length;){
            var x = subBeziers[k];
            var y = subBeziers[k + 1];
            subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
            subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
        }
    }
}
function $2ef03ef3a2bb366a$var$prepareMorphPath(fromPath, toPath) {
    var fromPathProxy = fromPath.getUpdatedPathProxy();
    var toPathProxy = toPath.getUpdatedPathProxy();
    var _a = $2ef03ef3a2bb366a$export$d7b853a0ab412a07((0, $2a60c506580ea7a9$export$fbc91cffd4bdf629)(fromPathProxy), (0, $2a60c506580ea7a9$export$fbc91cffd4bdf629)(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
    var fromPathTransform = fromPath.getComputedTransform();
    var toPathTransform = toPath.getComputedTransform();
    function updateIdentityTransform() {
        this.transform = null;
    }
    fromPathTransform && $2ef03ef3a2bb366a$var$applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
    toPathTransform && $2ef03ef3a2bb366a$var$applyTransformOnBeziers(toBezierCurves, toPathTransform);
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "updateTransform", {
        replace: updateIdentityTransform
    });
    toPath.transform = null;
    var morphingData = $2ef03ef3a2bb366a$var$findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
    var tmpArr = [];
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "buildPath", {
        replace: function(path) {
            var t = toPath.__morphT;
            var onet = 1 - t;
            var newCp = [];
            for(var i = 0; i < morphingData.length; i++){
                var item = morphingData[i];
                var from = item.from;
                var to = item.to;
                var angle = item.rotation * t;
                var fromCp = item.fromCp;
                var toCp = item.toCp;
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                (0, $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f)(newCp, fromCp, toCp, t);
                for(var m = 0; m < from.length; m += 2){
                    var x0_1 = from[m];
                    var y0_1 = from[m + 1];
                    var x1 = to[m];
                    var y1 = to[m + 1];
                    var x = x0_1 * onet + x1 * t;
                    var y = y0_1 * onet + y1 * t;
                    tmpArr[m] = x * ca - y * sa + newCp[0];
                    tmpArr[m + 1] = x * sa + y * ca + newCp[1];
                }
                var x0 = tmpArr[0];
                var y0 = tmpArr[1];
                path.moveTo(x0, y0);
                for(var m = 2; m < from.length;){
                    var x1 = tmpArr[m++];
                    var y1 = tmpArr[m++];
                    var x2 = tmpArr[m++];
                    var y2 = tmpArr[m++];
                    var x3 = tmpArr[m++];
                    var y3 = tmpArr[m++];
                    if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) path.lineTo(x3, y3);
                    else path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    x0 = x3;
                    y0 = y3;
                }
            }
        }
    });
}
function $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPath, toPath, animationOpts) {
    if (!fromPath || !toPath) return toPath;
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    $2ef03ef3a2bb366a$var$prepareMorphPath(fromPath, toPath);
    toPath.__morphT = 0;
    function restoreToPath() {
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "buildPath");
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "updateTransform");
        toPath.__morphT = -1;
        toPath.createPathProxy();
        toPath.dirtyShape();
    }
    toPath.animateTo({
        __morphT: 1
    }, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        during: function(p) {
            toPath.dirtyShape();
            oldDuring && oldDuring(p);
        },
        done: function() {
            restoreToPath();
            oldDone && oldDone();
        }
    }, animationOpts));
    return toPath;
}
function $2ef03ef3a2bb366a$var$hilbert(x, y, minX, minY, maxX, maxY) {
    var bits = 16;
    x = maxX === minX ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
    y = maxY === minY ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
    var d = 0;
    var tmp;
    for(var s = (1 << bits) / 2; s > 0; s /= 2){
        var rx = 0;
        var ry = 0;
        if ((x & s) > 0) rx = 1;
        if ((y & s) > 0) ry = 1;
        d += s * s * (3 * rx ^ ry);
        if (ry === 0) {
            if (rx === 1) {
                x = s - 1 - x;
                y = s - 1 - y;
            }
            tmp = x;
            x = y;
            y = tmp;
        }
    }
    return d;
}
function $2ef03ef3a2bb366a$var$sortPaths(pathList) {
    var xMin = Infinity;
    var yMin = Infinity;
    var xMax = -Infinity;
    var yMax = -Infinity;
    var cps = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(pathList, function(path) {
        var rect = path.getBoundingRect();
        var m = path.getComputedTransform();
        var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
        var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
        xMin = Math.min(x, xMin);
        yMin = Math.min(y, yMin);
        xMax = Math.max(x, xMax);
        yMax = Math.max(y, yMax);
        return [
            x,
            y
        ];
    });
    var items = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(cps, function(cp, idx) {
        return {
            cp: cp,
            z: $2ef03ef3a2bb366a$var$hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
            path: pathList[idx]
        };
    });
    return items.sort(function(a, b) {
        return a.z - b.z;
    }).map(function(item) {
        return item.path;
    });
}
function $2ef03ef3a2bb366a$var$defaultDividePath(param) {
    return (0, $640f8b532a910a4f$export$65980d18b75784e2)(param.path, param.count);
}
function $2ef03ef3a2bb366a$var$createEmptyReturn() {
    return {
        fromIndividuals: [],
        toIndividuals: [],
        count: 0
    };
}
function $2ef03ef3a2bb366a$export$57d3bac3565fd555(fromList, toPath, animationOpts) {
    var fromPathList = [];
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    addFromPath(fromList);
    var separateCount = fromPathList.length;
    if (!separateCount) return $2ef03ef3a2bb366a$var$createEmptyReturn();
    var dividePath = animationOpts.dividePath || $2ef03ef3a2bb366a$var$defaultDividePath;
    var toSubPathList = dividePath({
        path: toPath,
        count: separateCount
    });
    if (toSubPathList.length !== separateCount) {
        console.error("Invalid morphing: unmatched splitted path");
        return $2ef03ef3a2bb366a$var$createEmptyReturn();
    }
    fromPathList = $2ef03ef3a2bb366a$var$sortPaths(fromPathList);
    toSubPathList = $2ef03ef3a2bb366a$var$sortPaths(toSubPathList);
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    var individualDelay = animationOpts.individualDelay;
    var identityTransform = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
    for(var i = 0; i < separateCount; i++){
        var from = fromPathList[i];
        var to = toSubPathList[i];
        to.parent = toPath;
        to.copyTransform(identityTransform);
        if (!individualDelay) $2ef03ef3a2bb366a$var$prepareMorphPath(from, to);
    }
    toPath.__isCombineMorphing = true;
    toPath.childrenRef = function() {
        return toSubPathList;
    };
    function addToSubPathListToZr(zr) {
        for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].addSelfToZr(zr);
    }
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "addSelfToZr", {
        after: function(zr) {
            addToSubPathListToZr(zr);
        }
    });
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "removeSelfFromZr", {
        after: function(zr) {
            for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].removeSelfFromZr(zr);
        }
    });
    function restoreToPath() {
        toPath.__isCombineMorphing = false;
        toPath.__morphT = -1;
        toPath.childrenRef = null;
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "addSelfToZr");
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "removeSelfFromZr");
    }
    var toLen = toSubPathList.length;
    if (individualDelay) {
        var animating_1 = toLen;
        var eachDone = function() {
            animating_1--;
            if (animating_1 === 0) {
                restoreToPath();
                oldDone && oldDone();
            }
        };
        for(var i = 0; i < toLen; i++){
            var indivdualAnimationOpts = individualDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
                done: eachDone
            }, animationOpts) : animationOpts;
            $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
        }
    } else {
        toPath.__morphT = 0;
        toPath.animateTo({
            __morphT: 1
        }, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            during: function(p) {
                for(var i = 0; i < toLen; i++){
                    var child = toSubPathList[i];
                    child.__morphT = toPath.__morphT;
                    child.dirtyShape();
                }
                oldDuring && oldDuring(p);
            },
            done: function() {
                restoreToPath();
                for(var i = 0; i < fromList.length; i++)$2ef03ef3a2bb366a$var$restoreMethod(fromList[i], "updateTransform");
                oldDone && oldDone();
            }
        }, animationOpts));
    }
    if (toPath.__zr) addToSubPathListToZr(toPath.__zr);
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toSubPathList,
        count: toLen
    };
}
function $2ef03ef3a2bb366a$export$b6ed198024fe6db8(fromPath, toPathList, animationOpts) {
    var toLen = toPathList.length;
    var fromPathList = [];
    var dividePath = animationOpts.dividePath || $2ef03ef3a2bb366a$var$defaultDividePath;
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(fromPath)) {
        addFromPath(fromPath.childrenRef());
        var fromLen = fromPathList.length;
        if (fromLen < toLen) {
            var k = 0;
            for(var i = fromLen; i < toLen; i++)fromPathList.push((0, $15b38920672b9006$export$18711d956bf1c3eb)(fromPathList[k++ % fromLen]));
        }
        fromPathList.length = toLen;
    } else {
        fromPathList = dividePath({
            path: fromPath,
            count: toLen
        });
        var fromPathTransform = fromPath.getComputedTransform();
        for(var i = 0; i < fromPathList.length; i++)fromPathList[i].setLocalTransform(fromPathTransform);
        if (fromPathList.length !== toLen) {
            console.error("Invalid morphing: unmatched splitted path");
            return $2ef03ef3a2bb366a$var$createEmptyReturn();
        }
    }
    fromPathList = $2ef03ef3a2bb366a$var$sortPaths(fromPathList);
    toPathList = $2ef03ef3a2bb366a$var$sortPaths(toPathList);
    var individualDelay = animationOpts.individualDelay;
    for(var i = 0; i < toLen; i++){
        var indivdualAnimationOpts = individualDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
        }, animationOpts) : animationOpts;
        $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPathList[i], toPathList[i], indivdualAnimationOpts);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toPathList,
        count: toPathList.length
    };
}






function $2a0c51260032b767$var$isMultiple(elements) {
    return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(elements[0]);
}
function $2a0c51260032b767$var$prepareMorphBatches(one, many) {
    var batches = [];
    var batchCount = one.length;
    for(var i = 0; i < batchCount; i++)batches.push({
        one: one[i],
        many: []
    });
    for(var i = 0; i < many.length; i++){
        var len = many[i].length;
        var k = void 0;
        for(k = 0; k < len; k++)batches[k % batchCount].many.push(many[i][k]);
    }
    var off = 0;
    // If one has more paths than each one of many. average them.
    for(var i = batchCount - 1; i >= 0; i--)if (!batches[i].many.length) {
        var moveFrom = batches[off].many;
        if (moveFrom.length <= 1) {
            // Not enough
            // Start from the first one.
            if (off) off = 0;
            else return batches;
        }
        var len = moveFrom.length;
        var mid = Math.ceil(len / 2);
        batches[i].many = moveFrom.slice(mid, len);
        batches[off].many = moveFrom.slice(0, mid);
        off++;
    }
    return batches;
}
var $2a0c51260032b767$var$pathDividers = {
    clone: function(params) {
        var ret = [];
        // Fitting the alpha
        var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);
        for(var i = 0; i < params.count; i++){
            var cloned = (0, $15b38920672b9006$export$18711d956bf1c3eb)(params.path);
            cloned.setStyle("opacity", approxOpacity);
            ret.push(cloned);
        }
        return ret;
    },
    // Use the default divider
    split: null
};
function $2a0c51260032b767$export$c6ab3ab2bfe1ec39(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
    if (!from.length || !to.length) return;
    var updateAnimationCfg = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, dataIndex);
    if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) return;
    var animationDelay = seriesModel.getModel("universalTransition").get("delay");
    var animationCfg = Object.assign({
        // Need to setToFinal so the further calculation based on the style can be correct.
        // Like emphasis color.
        setToFinal: true
    }, updateAnimationCfg);
    var many;
    var one;
    if ($2a0c51260032b767$var$isMultiple(from)) {
        // manyToOne
        many = from;
        one = to;
    }
    if ($2a0c51260032b767$var$isMultiple(to)) {
        // oneToMany
        many = to;
        one = from;
    }
    function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
        var batchMany = batch.many;
        var batchOne = batch.one;
        if (batchMany.length === 1 && !forceManyOne) {
            // Is one to one
            var batchFrom = fromIsMany ? batchMany[0] : batchOne;
            var batchTo = fromIsMany ? batchOne : batchMany[0];
            if ((0, $2ef03ef3a2bb366a$export$f9f720a01590a46f)(batchFrom)) // Keep doing combine animation.
            morphOneBatch({
                many: [
                    batchFrom
                ],
                one: batchTo
            }, true, animateIndex, animateCount, true);
            else {
                var individualAnimationCfg = animationDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    delay: animationDelay(animateIndex, animateCount)
                }, animationCfg) : animationCfg;
                (0, $2ef03ef3a2bb366a$export$7174e282c1c7df1c)(batchFrom, batchTo, individualAnimationCfg);
                animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
            }
        } else {
            var separateAnimationCfg = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                dividePath: $2a0c51260032b767$var$pathDividers[divideShape],
                individualDelay: animationDelay && function(idx, count, fromPath, toPath) {
                    return animationDelay(idx + animateIndex, animateCount);
                }
            }, animationCfg);
            var _a = fromIsMany ? (0, $2ef03ef3a2bb366a$export$57d3bac3565fd555)(batchMany, batchOne, separateAnimationCfg) : (0, $2ef03ef3a2bb366a$export$b6ed198024fe6db8)(batchOne, batchMany, separateAnimationCfg), fromIndividuals = _a.fromIndividuals, toIndividuals = _a.toIndividuals;
            var count = fromIndividuals.length;
            for(var k = 0; k < count; k++){
                var individualAnimationCfg = animationDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    delay: animationDelay(k, count)
                }, animationCfg) : animationCfg;
                animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
            }
        }
    }
    var fromIsMany = many ? many === from : from.length > to.length;
    var morphBatches = many ? $2a0c51260032b767$var$prepareMorphBatches(one, many) : $2a0c51260032b767$var$prepareMorphBatches(fromIsMany ? to : from, [
        fromIsMany ? from : to
    ]);
    var animateCount = 0;
    for(var i = 0; i < morphBatches.length; i++)animateCount += morphBatches[i].many.length;
    var animateIndex = 0;
    for(var i = 0; i < morphBatches.length; i++){
        morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
        animateIndex += morphBatches[i].many.length;
    }
}
function $2a0c51260032b767$export$ad61593d7c3fa814(elements) {
    if (!elements) return [];
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(elements)) {
        var pathList_1 = [];
        for(var i = 0; i < elements.length; i++)pathList_1.push($2a0c51260032b767$export$ad61593d7c3fa814(elements[i]));
        return pathList_1;
    }
    var pathList = [];
    elements.traverse(function(el) {
        if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && !el.disableMorphing && !el.invisible && !el.ignore) pathList.push(el);
    });
    return pathList;
}









var $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD = 1e4;
var $2915cc4a2282c523$var$TRANSITION_NONE = 0;
var $2915cc4a2282c523$var$TRANSITION_P2C = 1;
var $2915cc4a2282c523$var$TRANSITION_C2P = 2;
var $2915cc4a2282c523$var$getUniversalTransitionGlobalStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $2915cc4a2282c523$var$getDimension(data, visualDimension) {
    var dimensions = data.dimensions;
    for(var i = 0; i < dimensions.length; i++){
        var dimInfo = data.getDimensionInfo(dimensions[i]);
        if (dimInfo && dimInfo.otherDims[visualDimension] === 0) return dimensions[i];
    }
}
// get value by dimension. (only get value of itemGroupId or childGroupId, so convert it to string)
function $2915cc4a2282c523$var$getValueByDimension(data, dataIndex, dimension) {
    var dimInfo = data.getDimensionInfo(dimension);
    var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;
    if (dimInfo) {
        var value = data.get(dimInfo.name, dataIndex);
        if (dimOrdinalMeta) return dimOrdinalMeta.categories[value] || value + "";
        return value + "";
    }
}
function $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, isChild) {
    // try to get groupId from encode
    var visualDimension = isChild ? "itemChildGroupId" : "itemGroupId";
    var groupIdDim = $2915cc4a2282c523$var$getDimension(data, visualDimension);
    if (groupIdDim) {
        var groupId = $2915cc4a2282c523$var$getValueByDimension(data, dataIndex, groupIdDim);
        return groupId;
    }
    // try to get groupId from raw data item
    var rawDataItem = data.getRawDataItem(dataIndex);
    var property = isChild ? "childGroupId" : "groupId";
    if (rawDataItem && rawDataItem[property]) return rawDataItem[property] + "";
    // fallback
    if (isChild) return;
    // try to use series.dataGroupId as groupId, otherwise use dataItem's id as groupId
    return dataGroupId || data.getId(dataIndex);
}
// flatten all data items from different serieses into one arrary
function $2915cc4a2282c523$var$flattenDataDiffItems(list) {
    var items = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(list, function(seriesInfo) {
        var data = seriesInfo.data;
        var dataGroupId = seriesInfo.dataGroupId;
        if (data.count() > $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD) return;
        var indices = data.getIndices();
        for(var dataIndex = 0; dataIndex < indices.length; dataIndex++)items.push({
            data: data,
            groupId: $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, false),
            childGroupId: $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, true),
            divide: seriesInfo.divide,
            dataIndex: dataIndex
        });
    });
    return items;
}
function $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newIndex) {
    newEl.traverse(function(el) {
        if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) // TODO use fade in animation for target element.
        (0, $8b353638fbedfefa$export$a121566aadcfe021)(el, {
            style: {
                opacity: 0
            }
        }, newSeries, {
            dataIndex: newIndex,
            isFrom: true
        });
    });
}
function $2915cc4a2282c523$var$removeEl(el) {
    if (el.parent) {
        // Bake parent transform to element.
        // So it can still have proper transform to transition after it's removed.
        var computedTransform = el.getComputedTransform();
        el.setLocalTransform(computedTransform);
        el.parent.remove(el);
    }
}
function $2915cc4a2282c523$var$stopAnimation(el) {
    el.stopAnimation();
    if (el.isGroup) el.traverse(function(child) {
        child.stopAnimation();
    });
}
function $2915cc4a2282c523$var$animateElementStyles(el, dataIndex, seriesModel) {
    var animationConfig = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, dataIndex);
    animationConfig && el.traverse(function(child) {
        if (child instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) {
            var oldStyle = (0, $8b353638fbedfefa$export$ccb1f1e4d2fa86ac)(child);
            if (oldStyle) child.animateFrom({
                style: oldStyle
            }, animationConfig);
        }
    });
}
function $2915cc4a2282c523$var$isAllIdSame(oldDiffItems, newDiffItems) {
    var len = oldDiffItems.length;
    if (len !== newDiffItems.length) return false;
    for(var i = 0; i < len; i++){
        var oldItem = oldDiffItems[i];
        var newItem = newDiffItems[i];
        if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) return false;
    }
    return true;
}
function $2915cc4a2282c523$var$transitionBetween(oldList, newList, api) {
    var oldDiffItems = $2915cc4a2282c523$var$flattenDataDiffItems(oldList);
    var newDiffItems = $2915cc4a2282c523$var$flattenDataDiffItems(newList);
    function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
        if (rawFrom || from) to.animateFrom({
            style: rawFrom && rawFrom !== from ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, rawFrom.style), from.style) : from.style
        }, animationCfg);
    }
    var hasMorphAnimation = false;
    /**
   * With groupId and childGroupId, we can build parent-child relationships between dataItems.
   * However, we should mind the parent-child "direction" between old and new options.
   *
   * For example, suppose we have two dataItems from two series.data:
   *
   * dataA: [                          dataB: [
   *   {                                 {
   *     value: 5,                         value: 3,
   *     groupId: 'creatures',             groupId: 'animals',
   *     childGroupId: 'animals'           childGroupId: 'dogs'
   *   },                                },
   *   ...                               ...
   * ]                                 ]
   *
   * where dataA is belong to optionA and dataB is belong to optionB.
   *
   * When we `setOption(optionB)` from optionA, we choose childGroupId of dataItemA and groupId of
   * dataItemB as keys so the two keys are matched (both are 'animals'), then universalTransition
   * will work. This derection is "parent -> child".
   *
   * If we `setOption(optionA)` from optionB, we also choose groupId of dataItemB and childGroupId
   * of dataItemA as keys and universalTransition will work. This derection is "child -> parent".
   *
   * If there is no childGroupId specified, which means no multiLevelDrillDown/Up is needed and no
   * parent-child relationship exists. This direction is "none".
   *
   * So we need to know whether to use groupId or childGroupId as the key when we call the keyGetter
   * functions. Thus, we need to decide the direction first.
   *
   * The rule is:
   *
   * if (all childGroupIds in oldDiffItems and all groupIds in newDiffItems have common value) {
   *   direction = 'parent -> child';
   * } else if (all groupIds in oldDiffItems and all childGroupIds in newDiffItems have common value) {
   *   direction = 'child -> parent';
   * } else {
   *   direction = 'none';
   * }
   */ var direction = $2915cc4a2282c523$var$TRANSITION_NONE;
    // find all groupIds and childGroupIds from oldDiffItems
    var oldGroupIds = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var oldChildGroupIds = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    oldDiffItems.forEach(function(item) {
        item.groupId && oldGroupIds.set(item.groupId, true);
        item.childGroupId && oldChildGroupIds.set(item.childGroupId, true);
    });
    // traverse newDiffItems and decide the direction according to the rule
    for(var i = 0; i < newDiffItems.length; i++){
        var newGroupId = newDiffItems[i].groupId;
        if (oldChildGroupIds.get(newGroupId)) {
            direction = $2915cc4a2282c523$var$TRANSITION_P2C;
            break;
        }
        var newChildGroupId = newDiffItems[i].childGroupId;
        if (newChildGroupId && oldGroupIds.get(newChildGroupId)) {
            direction = $2915cc4a2282c523$var$TRANSITION_C2P;
            break;
        }
    }
    function createKeyGetter(isOld, onlyGetId) {
        return function(diffItem) {
            var data = diffItem.data;
            var dataIndex = diffItem.dataIndex;
            // TODO if specified dim
            if (onlyGetId) return data.getId(dataIndex);
            if (isOld) return direction === $2915cc4a2282c523$var$TRANSITION_P2C ? diffItem.childGroupId : diffItem.groupId;
            else return direction === $2915cc4a2282c523$var$TRANSITION_C2P ? diffItem.childGroupId : diffItem.groupId;
        };
    }
    // Use id if it's very likely to be an one to one animation
    // It's more robust than groupId
    // TODO Check if key dimension is specified.
    var useId = $2915cc4a2282c523$var$isAllIdSame(oldDiffItems, newDiffItems);
    var isElementStillInChart = {};
    if (!useId) // We may have different diff strategy with basicTransition if we use other dimension as key.
    // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
    // We can't use the elements that already being morphed. Let it keep it's original basic transition.
    for(var i = 0; i < newDiffItems.length; i++){
        var newItem = newDiffItems[i];
        var el = newItem.data.getItemGraphicEl(newItem.dataIndex);
        if (el) isElementStillInChart[el.id] = true;
    }
    function updateOneToOne(newIndex, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var newItem = newDiffItems[newIndex];
        var newSeries = newItem.data.hostModel;
        // TODO Mark this elements is morphed and don't morph them anymore
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex);
        // Can't handle same elements.
        if (oldEl === newEl) {
            newEl && $2915cc4a2282c523$var$animateElementStyles(newEl, newItem.dataIndex, newSeries);
            return;
        }
        if (// We can't use the elements that already being morphed
        oldEl && isElementStillInChart[oldEl.id]) return;
        if (newEl) {
            // TODO: If keep animating the group in case
            // some of the elements don't want to be morphed.
            // TODO Label?
            $2915cc4a2282c523$var$stopAnimation(newEl);
            if (oldEl) {
                $2915cc4a2282c523$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $2915cc4a2282c523$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldEl), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newIndex);
        }
    // else keep oldEl leaving animation.
    }
    new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, "multiple").update(updateOneToOne).updateManyToOne(function(newIndex, oldIndices) {
        var newItem = newDiffItems[newIndex];
        var newData = newItem.data;
        var newSeries = newData.hostModel;
        var newEl = newData.getItemGraphicEl(newItem.dataIndex);
        var oldElsList = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(oldIndices, function(idx) {
            return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
        }), function(oldEl) {
            return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
        });
        if (newEl) {
            $2915cc4a2282c523$var$stopAnimation(newEl);
            if (oldElsList.length) {
                // If old element is doing leaving animation. stop it and remove it immediately.
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(oldElsList, function(oldEl) {
                    $2915cc4a2282c523$var$stopAnimation(oldEl);
                    $2915cc4a2282c523$var$removeEl(oldEl);
                });
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldElsList), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newItem.dataIndex);
        }
    // else keep oldEl leaving animation.
    }).updateOneToMany(function(newIndices, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        // We can't use the elements that already being morphed
        if (oldEl && isElementStillInChart[oldEl.id]) return;
        var newElsList = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(newIndices, function(idx) {
            return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
        }), function(el) {
            return el && el !== oldEl;
        });
        var newSeris = newDiffItems[newIndices[0]].data.hostModel;
        if (newElsList.length) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $2915cc4a2282c523$var$stopAnimation(newEl);
            });
            if (oldEl) {
                $2915cc4a2282c523$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $2915cc4a2282c523$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldEl), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newElsList), oldItem.divide, // Use divide on old.
                newSeris, newIndices[0], updateMorphingPathProps);
            } else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $2915cc4a2282c523$var$fadeInElement(newEl, newSeris, newIndices[0]);
            });
        }
    // else keep oldEl leaving animation.
    }).updateManyToMany(function(newIndices, oldIndices) {
        // If two data are same and both have groupId.
        // Normally they should be diff by id.
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldIndices, newIndices, function(rawIdx) {
            return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
        }, function(rawIdx) {
            return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
        }).update(function(newIndex, oldIndex) {
            // Use the original index
            updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
        }).execute();
    }).execute();
    if (hasMorphAnimation) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newList, function(_a) {
        var data = _a.data;
        var seriesModel = data.hostModel;
        var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
        var animationCfg = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, 0); // use 0 index.
        if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) view.group.traverse(function(el) {
            if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && !el.animators.length) // We can't accept there still exists element that has no animation
            // if universalTransition is enabled
            el.animateFrom({
                style: {
                    opacity: 0
                }
            }, animationCfg);
        });
    });
}
function $2915cc4a2282c523$var$getSeriesTransitionKey(series) {
    var seriesKey = series.getModel("universalTransition").get("seriesKey");
    if (!seriesKey) // Use series id by default.
    return series.id;
    return seriesKey;
}
function $2915cc4a2282c523$var$convertArraySeriesKeyToString(seriesKey) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(seriesKey)) // Order independent.
    return seriesKey.sort().join(",");
    return seriesKey;
}
function $2915cc4a2282c523$var$getDivideShapeFromData(data) {
    if (data.hostModel) return data.hostModel.getModel("universalTransition").get("divideShape");
}
function $2915cc4a2282c523$var$findTransitionSeriesBatches(globalStore, params) {
    var updateBatches = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var oldDataMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Map that only store key in array seriesKey.
    // Which is used to query the old data when transition from one to multiple series.
    var oldDataMapForSplit = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(globalStore.oldSeries, function(series, idx) {
        var oldDataGroupId = globalStore.oldDataGroupIds[idx];
        var oldData = globalStore.oldData[idx];
        var transitionKey = $2915cc4a2282c523$var$getSeriesTransitionKey(series);
        var transitionKeyStr = $2915cc4a2282c523$var$convertArraySeriesKeyToString(transitionKey);
        oldDataMap.set(transitionKeyStr, {
            dataGroupId: oldDataGroupId,
            data: oldData
        });
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(transitionKey)) // Same key can't in different array seriesKey.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transitionKey, function(key) {
            oldDataMapForSplit.set(key, {
                key: transitionKeyStr,
                dataGroupId: oldDataGroupId,
                data: oldData
            });
        });
    });
    function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
        if (updateBatches.get(transitionKeyStr)) (0, $84bc7667c27ccedc$export$c106dd0671a0fc2d)("Duplicated seriesKey in universalTransition " + transitionKeyStr);
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
        if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
            var newDataGroupId = series.get("dataGroupId");
            var newData = series.getData();
            var transitionKey = $2915cc4a2282c523$var$getSeriesTransitionKey(series);
            var transitionKeyStr = $2915cc4a2282c523$var$convertArraySeriesKeyToString(transitionKey);
            // Only transition between series with same id.
            var oldData = oldDataMap.get(transitionKeyStr);
            // string transition key is the best match.
            if (oldData) // TODO check if data is same?
            updateBatches.set(transitionKeyStr, {
                oldSeries: [
                    {
                        dataGroupId: oldData.dataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    }
                ],
                newSeries: [
                    {
                        dataGroupId: newDataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData),
                        data: newData
                    }
                ]
            });
            else // Transition from multiple series.
            // e.g. 'female', 'male' -> ['female', 'male']
            if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(transitionKey)) {
                var oldSeries_1 = [];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transitionKey, function(key) {
                    var oldData = oldDataMap.get(key);
                    if (oldData.data) oldSeries_1.push({
                        dataGroupId: oldData.dataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    });
                });
                if (oldSeries_1.length) updateBatches.set(transitionKeyStr, {
                    oldSeries: oldSeries_1,
                    newSeries: [
                        {
                            dataGroupId: newDataGroupId,
                            data: newData,
                            divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData)
                        }
                    ]
                });
            } else {
                // Try transition to multiple series.
                // e.g. ['female', 'male'] -> 'female', 'male'
                var oldData_1 = oldDataMapForSplit.get(transitionKey);
                if (oldData_1) {
                    var batch = updateBatches.get(oldData_1.key);
                    if (!batch) {
                        batch = {
                            oldSeries: [
                                {
                                    dataGroupId: oldData_1.dataGroupId,
                                    data: oldData_1.data,
                                    divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData_1.data)
                                }
                            ],
                            newSeries: []
                        };
                        updateBatches.set(oldData_1.key, batch);
                    }
                    batch.newSeries.push({
                        dataGroupId: newDataGroupId,
                        data: newData,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData)
                    });
                }
            }
        }
    });
    return updateBatches;
}
function $2915cc4a2282c523$var$querySeries(series, finder) {
    for(var i = 0; i < series.length; i++){
        var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;
        if (found) return i;
    }
}
function $2915cc4a2282c523$var$transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
    var from = [];
    var to = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt.from), function(finder) {
        var idx = $2915cc4a2282c523$var$querySeries(globalStore.oldSeries, finder);
        if (idx >= 0) from.push({
            dataGroupId: globalStore.oldDataGroupIds[idx],
            data: globalStore.oldData[idx],
            // TODO can specify divideShape in transition.
            divide: $2915cc4a2282c523$var$getDivideShapeFromData(globalStore.oldData[idx]),
            groupIdDim: finder.dimension
        });
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt.to), function(finder) {
        var idx = $2915cc4a2282c523$var$querySeries(params.updatedSeries, finder);
        if (idx >= 0) {
            var data = params.updatedSeries[idx].getData();
            to.push({
                dataGroupId: globalStore.oldDataGroupIds[idx],
                data: data,
                divide: $2915cc4a2282c523$var$getDivideShapeFromData(data),
                groupIdDim: finder.dimension
            });
        }
    });
    if (from.length > 0 && to.length > 0) $2915cc4a2282c523$var$transitionBetween(from, to, api);
}
function $2915cc4a2282c523$export$efd07f28fd73e88c(registers) {
    registers.registerUpdateLifecycle("series:beforeupdate", function(ecMOdel, api, params) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(params.seriesTransition), function(transOpt) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transOpt.to), function(finder) {
                var series = params.updatedSeries;
                for(var i = 0; i < series.length; i++)if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) series[i][0, $7c10febb2cdef0d8$export$e960441116ae2799] = true;
            });
        });
    });
    registers.registerUpdateLifecycle("series:transition", function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var globalStore = $2915cc4a2282c523$var$getUniversalTransitionGlobalStore(api);
        // TODO multiple to multiple series.
        if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
            // TODO transitionOpt was used in an old implementation and can be removed now
            // Use give transition config if its' give;
            var transitionOpt = params.seriesTransition;
            if (transitionOpt) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt), function(opt) {
                $2915cc4a2282c523$var$transitionSeriesFromOpt(opt, globalStore, params, api);
            });
            else {
                // Else guess from series based on transition series key.
                var updateBatches_1 = $2915cc4a2282c523$var$findTransitionSeriesBatches(globalStore, params);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(updateBatches_1.keys(), function(key) {
                    var batch = updateBatches_1.get(key);
                    $2915cc4a2282c523$var$transitionBetween(batch.oldSeries, batch.newSeries, api);
                });
            }
            // Reset
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
                // Reset;
                if (series[0, $7c10febb2cdef0d8$export$e960441116ae2799]) series[0, $7c10febb2cdef0d8$export$e960441116ae2799] = false;
            });
        }
        // Save all series of current update. Not only the updated one.
        var allSeries = ecModel.getSeries();
        var savedSeries = globalStore.oldSeries = [];
        var savedDataGroupIds = globalStore.oldDataGroupIds = [];
        var savedData = globalStore.oldData = [];
        for(var i = 0; i < allSeries.length; i++){
            var data = allSeries[i].getData();
            // Only save the data that can have transition.
            // Avoid large data costing too much extra memory
            if (data.count() < $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD) {
                savedSeries.push(allSeries[i]);
                savedDataGroupIds.push(allSeries[i].get("dataGroupId"));
                savedData.push(data);
            }
        }
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.










function $e10cf2049e185956$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $e10cf2049e185956$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $e10cf2049e185956$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS = [
    "align",
    "verticalAlign",
    "width",
    "height",
    "fontSize"
];
var $e10cf2049e185956$var$dummyTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
var $e10cf2049e185956$var$labelLayoutInnerStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e10cf2049e185956$var$labelLineAnimationStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $e10cf2049e185956$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $e10cf2049e185956$var$LABEL_LAYOUT_PROPS = [
    "x",
    "y",
    "rotation"
];
var $e10cf2049e185956$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {};
        // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $e10cf2049e185956$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $e10cf2049e185956$var$dummyTransformable.x = $e10cf2049e185956$var$dummyTransformable.y = $e10cf2049e185956$var$dummyTransformable.rotation = $e10cf2049e185956$var$dummyTransformable.originX = $e10cf2049e185956$var$dummyTransformable.originY = 0;
            $e10cf2049e185956$var$dummyTransformable.scaleX = $e10cf2049e185956$var$dummyTransformable.scaleY = 1;
        }
        $e10cf2049e185956$var$dummyTransformable.rotation = (0, $b44a8536c7214e4f$export$d44861331f213635)($e10cf2049e185956$var$dummyTransformable.rotation);
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOption: layoutOption,
            computedLayoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $e10cf2049e185956$var$dummyTransformable.x,
                y: $e10cf2049e185956$var$dummyTransformable.y,
                scaleX: $e10cf2049e185956$var$dummyTransformable.scaleX,
                scaleY: $e10cf2049e185956$var$dummyTransformable.scaleY,
                rotation: $e10cf2049e185956$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get("labelLayout");
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(layoutOption) || (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
            // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
            // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $f4eb87a228be297f$export$cc93ba643cd97d83)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0;
            // TODO A global layout option?
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelItem.layoutOption)) layoutOption = labelItem.layoutOption($e10cf2049e185956$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOption;
            layoutOption = layoutOption || {};
            labelItem.computedLayoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180;
            // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(layoutOption.x, width);
                label.setStyle("x", 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle("x", defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(layoutOption.y, height);
                label.setStyle("y", 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle("y", defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    });
                    // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $e10cf2049e185956$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = "move";
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on("drag", createDragHandler(hostEl, hostModel.getModel("labelLine")));
                }
            } else {
                // TODO Other drag functions?
                label.off("drag");
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = (0, $11dac7a73f36cc2c$export$6c403cad1ae3e239)(this._labelList);
        var labelsNeedsAdjustOnX = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === "shiftX";
        });
        var labelsNeedsAdjustOnY = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === "shiftY";
        });
        (0, $11dac7a73f36cc2c$export$b6b2b07f8ed32bd6)(labelsNeedsAdjustOnX, 0, width);
        (0, $11dac7a73f36cc2c$export$118c25e0932528e4)(labelsNeedsAdjustOnY, 0, height);
        var labelsNeedsHideOverlap = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $11dac7a73f36cc2c$export$8ce774e164a49410)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore && !child.forceLabelAnimation) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $e10cf2049e185956$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent();
        // Update label line style.
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        var dataIndex = ecData.dataIndex;
        // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, "style");
            if (visualStyle) {
                var visualType = data.getVisual("drawType");
                // Default to be same with main color
                defaultStyle.stroke = visualStyle[visualType];
            }
            var labelLineModel = itemModel.getModel("labelLine");
            (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(el, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), defaultStyle);
            (0, $f4eb87a228be297f$export$cc93ba643cd97d83)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine();
        // Animate
        if (textEl && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $8b353638fbedfefa$export$5b89d4b643713034)(el))) {
            var layoutStore = $e10cf2049e185956$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps);
                // Disable fade in animation if value animation is enabled.
                if (!(0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(textEl).valueAnimation) {
                    var oldOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textEl.style.opacity, 1);
                    // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $8b353638fbedfefa$export$a121566aadcfe021)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout);
                // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(prevStates, "select") >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(prevStates, "emphasis") >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $e10cf2049e185956$var$extendWithKeys(layoutSelect, newProps, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
                $e10cf2049e185956$var$extendWithKeys(layoutSelect, textEl.states.select, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $e10cf2049e185956$var$extendWithKeys(layoutEmphasis, newProps, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
                $e10cf2049e185956$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
            }
            (0, $6800dfcb6e1e2a44$export$dd6101605f5c186)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $e10cf2049e185956$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $8b353638fbedfefa$export$a121566aadcfe021)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $e10cf2049e185956$export$2e2bcd8739ae039 = $e10cf2049e185956$var$LabelManager;


var $de19ea5da3bb8f56$var$getLabelManager = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $de19ea5da3bb8f56$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle("series:beforeupdate", function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager = new (0, $e10cf2049e185956$export$2e2bcd8739ae039)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle("series:layoutlabels", function(ecModel, api, params) {
        var labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}


// -----------------
// Render engines
// -----------------
// Render via Canvas.
// echarts.init(dom, null, { renderer: 'canvas' })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $e792bf2f67d76098$export$4b3e715f166fdd78)
]);
// Render via SVG.
// echarts.init(dom, null, { renderer: 'svg' })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $8d8c6eb926bbdd0e$export$4b3e715f166fdd78)
]);
// ----------------
// Charts (series)
// ----------------
// All of the series types, for example:
// chart.setOption({
//     series: [{
//         type: 'line' // or 'bar', 'pie', ...
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $9c1bfdc9a4f78f2d$export$4b3e715f166fdd78),
    (0, $4bb56d1f08552ff4$export$4b3e715f166fdd78),
    (0, $6b7ead9b40180cba$export$4b3e715f166fdd78),
    (0, $1214e5d7a4a6f990$export$4b3e715f166fdd78),
    (0, $a8120efef8bcaaa0$export$4b3e715f166fdd78),
    (0, $6c94070aa7d5e098$export$4b3e715f166fdd78),
    (0, $44a5d4d260c7de78$export$4b3e715f166fdd78),
    (0, $330b7dc841112eff$export$4b3e715f166fdd78),
    (0, $b48bd73bf5d69641$export$4b3e715f166fdd78),
    (0, $bf7cb565bb1d2308$export$4b3e715f166fdd78),
    (0, $2bdc3734cdc2f6c8$export$4b3e715f166fdd78),
    (0, $4d1dc874f9d8653d$export$4b3e715f166fdd78),
    (0, $2439b31c49c21b38$export$4b3e715f166fdd78),
    (0, $0fd6296850ce3099$export$4b3e715f166fdd78),
    (0, $21999577dfdc5807$export$4b3e715f166fdd78),
    (0, $a0fd335cdafe9e6e$export$4b3e715f166fdd78),
    (0, $52dd2448928cc7d8$export$4b3e715f166fdd78),
    (0, $c53e84d38e53ec61$export$4b3e715f166fdd78),
    (0, $7e25595b74be81a3$export$4b3e715f166fdd78),
    (0, $e883cd02390b2e6d$export$4b3e715f166fdd78),
    (0, $b7341ef122ec790d$export$4b3e715f166fdd78),
    (0, $3fd02cf8c6a1578a$export$4b3e715f166fdd78)
]);
// -------------------
// Coordinate systems
// -------------------
// All of the axis modules have been included in the
// coordinate system module below, do not need to
// make extra import.
// `cartesian` coordinate system. For some historical
// reasons, it is named as grid, for example:
// chart.setOption({
//     grid: {...},
//     xAxis: {...},
//     yAxis: {...},
//     series: [{...}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $30909b2e837c2175$export$4b3e715f166fdd78));
// `polar` coordinate system, for example:
// chart.setOption({
//     polar: {...},
//     radiusAxis: {...},
//     angleAxis: {...},
//     series: [{
//         coordinateSystem: 'polar'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0a6536a72e92ce0b$export$4b3e715f166fdd78));
// `geo` coordinate system, for example:
// chart.setOption({
//     geo: {...},
//     series: [{
//         coordinateSystem: 'geo'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8082b8b129488d44$export$4b3e715f166fdd78));
// `singleAxis` coordinate system (notice, it is a coordinate system
// with only one axis, work for chart like theme river), for example:
// chart.setOption({
//     singleAxis: {...}
//     series: [{type: 'themeRiver', ...}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2e3198006a202a14$export$4b3e715f166fdd78));
// `parallel` coordinate system, only work for parallel series, for example:
// chart.setOption({
//     parallel: {...},
//     parallelAxis: [{...}, ...],
//     series: [{
//         type: 'parallel'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $462857bad733a944$export$4b3e715f166fdd78));
// `calendar` coordinate system. for example,
// chart.setOption({
//     calendar: {...},
//     series: [{
//         coordinateSystem: 'calendar'
//     }]
// );
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $c1c3b68ff9dcc3e7$export$4b3e715f166fdd78));
// ------------------
// Other components
// ------------------
// `graphic` component, for example:
// chart.setOption({
//     graphic: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $48174658d54922b7$export$4b3e715f166fdd78));
// `toolbox` component, for example:
// chart.setOption({
//     toolbox: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $db487da8ce0e4ca6$export$4b3e715f166fdd78));
// `tooltip` component, for example:
// chart.setOption({
//     tooltip: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $46e639bec576c55c$export$4b3e715f166fdd78));
// `axisPointer` component, for example:
// chart.setOption({
//     tooltip: {axisPointer: {...}, ...}
// });
// Or
// chart.setOption({
//     axisPointer: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
// `brush` component, for example:
// chart.setOption({
//     brush: {...}
// });
// Or
// chart.setOption({
//     tooltip: {feature: {brush: {...}}
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $e97a928e0b93a54f$export$4b3e715f166fdd78));
// `title` component, for example:
// chart.setOption({
//     title: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $66707465bee49836$export$4b3e715f166fdd78));
// `timeline` component, for example:
// chart.setOption({
//     timeline: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d41f79c5664eb934$export$4b3e715f166fdd78));
// `markPoint` component, for example:
// chart.setOption({
//     series: [{markPoint: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $4edaa7c972a7e0d1$export$4b3e715f166fdd78));
// `markLine` component, for example:
// chart.setOption({
//     series: [{markLine: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0fc27d0a088604ed$export$4b3e715f166fdd78));
// `markArea` component, for example:
// chart.setOption({
//     series: [{markArea: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8a8e80722bf1c081$export$4b3e715f166fdd78));
// `legend` component not scrollable. for example:
// chart.setOption({
//     legend: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1a0761510a437d9f$export$4b3e715f166fdd78));
// `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $aa2dc70f9fa9453b$export$4b3e715f166fdd78));
// `dataZoom` component providing drag, pinch, wheel behaviors
// inside coordinate system, for example:
// chart.setOption({
//     dataZoom: {type: 'inside'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b5ee445cd897e37a$export$4b3e715f166fdd78));
// `dataZoom` component providing a slider bar, for example:
// chart.setOption({
//     dataZoom: {type: 'slider'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $794c23331e97718e$export$4b3e715f166fdd78));
// `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1df0d53aa7db8747$export$4b3e715f166fdd78));
// `visualMap` component providing continuous bar, for example:
// chart.setOption({
//     visualMap: {type: 'continuous'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $a0f8a196dd8b4cba$export$4b3e715f166fdd78));
// `visualMap` component providing pieces bar, for example:
// chart.setOption({
//     visualMap: {type: 'piecewise'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $312d2d640a7c60e1$export$4b3e715f166fdd78));
// `aria` component providing aria, for example:
// chart.setOption({
//     aria: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $772c09ed30d27c33$export$4b3e715f166fdd78));
// dataset transform
// chart.setOption({
//     dataset: {
//          transform: []
//     }
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d6bad095dfa9594d$export$4b3e715f166fdd78));
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $afb70cea6fec4fe0$export$4b3e715f166fdd78));
// universal transition
// chart.setOption({
//     series: {
//         universalTransition: { enabled: true }
//     }
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2915cc4a2282c523$export$efd07f28fd73e88c));
// label layout
// chart.setOption({
//     series: {
//         labelLayout: { hideOverlap: true }
//     }
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $de19ea5da3bb8f56$export$5320d1b3745c02a5));


let $b324e0f8855d37bf$export$ceb8328249fa3d26;
class $b324e0f8855d37bf$export$7a7fa4424cb20976 {
    constructor(){
        if ($b324e0f8855d37bf$export$ceb8328249fa3d26) throw new Error("Control already instanced");
        $b324e0f8855d37bf$export$ceb8328249fa3d26 = this;
        var navCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#navCol");
        this.store = $5605c1058d66d37f$export$f51a9068ac82ea43();
        this.contentDisplay = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#displayTextArea");
        this.categoryViews = [];
        this.metadataCategoryViewMap = new Map();
        this.forceHTTPSFlag = true;
        var forceHTTPSFlagValue = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#forceHTTPSFlagCheckbox").prop("checked");
        this.forceHTTPSFlag = forceHTTPSFlagValue;
        this.shareEndpointURL = true;
        var shareEndpointURLCheckboxValue = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#shareEndpointURLCheckbox").prop("checked");
        this.shareEndpointURL = shareEndpointURLCheckboxValue;
        this.sessionId = (0, $3fa3ae484854b431$export$2e2bcd8739ae039)();
        // window.onload = (event) => {
        this.initCategoryViews();
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#downloadButton").on("click", ()=>{
            $5605c1058d66d37f$export$147c92fc1e54141d(this.store).then((fileContent)=>{
                (0, $90f256c567e4c320$exports.saveAs)(new Blob([
                    fileContent
                ], {
                    "type": "text/turtle"
                }), "description.ttl");
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#saturationButton").on("click", ()=>{
            this.generateEquivalenceTriples().then((equivalences)=>{
                this.store.addAll(equivalences);
                this.refreshStore();
                return;
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#forceHTTPScheckbox").on("change", ()=>{
            var checkboxValue = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#forceHTTPScheckbox").prop("checked");
            this.forceHTTPSFlag = checkboxValue;
        });
        // $('#shareEndpointURLCheckbox').on("change", () => {
        //     var checkboxValue = $('#shareEndpointURLCheckbox').prop("checked");
        //     this.shareEndpointURL = checkboxValue;
        // })
        let loadModelInput = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#loadTextarea");
        const loadModal = new $e9dd36436aec3b21$export$2b77a92f1a5ad772("#loadModalDiv", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#loadButton").on("click", ()=>{
            loadModal.show();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#clearButton").on("click", ()=>{
            this.clearAll();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").attr("title", "DESCRIBE <http://dbpedia.org/void/Dataset>");
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").on("click", ()=>{
            this.clearAll();
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-dark");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-success");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-danger");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").addClass("btn-warning");
            this.fetchExample("https://dbpedia.org/sparql", "http://dbpedia.org/void/Dataset").then((exampleDescription)=>{
                return this.importData(exampleDescription).then(()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-dark");
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-warning");
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-danger");
                    (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").addClass("btn-success");
                });
            }).catch((error)=>{
                console.error(error);
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-dark");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-warning");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").removeClass("btn-success");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#exampleDBpediaButton").addClass("btn-danger");
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#clearLoadButton").on("click", ()=>{
            loadModelInput.val("");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#closeLoadButton").on("click", ()=>{
            loadModal.hide();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#saveLoadButton").on("click", ()=>{
            try {
                this.importData(loadModelInput.val().toLocaleString(), (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#loadFileFormatSelect").val().toLocaleString()).then(()=>{
                    loadModal.hide();
                });
            } catch (e) {
                console.error(e);
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#loadErrorDiv").text(e.message);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairButton").on("click", ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairButton").removeClass("btn-dark");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairButton").removeClass("btn-success");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairButton").addClass("btn-warning");
            this.setFAIRRadar().then(()=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairButton").removeClass("btn-dark");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairButton").removeClass("btn-warning");
                (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairButton").addClass("btn-success");
                return;
            });
        });
        // Dirty hack to fix echarts width and height bug
        const baseWidth = window.innerWidth - 270;
        const baseHeight = window.innerHeight * 0.45;
        let radarDOM = document.getElementById("fairRadar");
        this.radarChart = $4d59907f44a2d0ad$export$2cd8252107eb640b(radarDOM);
        // };
        // Import a turtle description present in the URL as value of the "description" parameter
        let currentUrl = new URL(window.location.href);
        let zippedDescription = currentUrl.searchParams.get("description");
        if (zippedDescription != null) {
            let description = (0, $ce9a2afe0584bbc0$export$85af90b470928c35)(zippedDescription);
            if (description != null) {
                let decodedDescription = decodeURIComponent(description);
                let parsedStore = $5605c1058d66d37f$export$f51a9068ac82ea43();
                $5605c1058d66d37f$export$968deea481412d5d(decodedDescription, parsedStore).then((store)=>{
                    if (parsedStore.length > 0) return this.importData(decodedDescription);
                }).catch((error)=>{
                    console.error(error);
                });
            }
        }
        this.addStatement($6f0137736d5eb798$export$8692ddd9f3fb5f5d($5605c1058d66d37f$export$19285ac0211cbcbc, $5605c1058d66d37f$export$fd985e82eeb3038("type"), $5605c1058d66d37f$export$7be7716cc4115fc5("Dataset")));
    }
    fetchExample(endpointUrl, resourceURL) {
        let query = `DESCRIBE <${resourceURL}>`;
        return $35459c07cd7570af$export$d37bf5547347f960(endpointUrl, query).then((storeResult)=>{
            return $5605c1058d66d37f$export$147c92fc1e54141d(storeResult);
        }).catch((error)=>{
            console.error(endpointUrl, query, error);
            throw error;
        });
    }
    setFAIRRadar() {
        const mainContentColWidth = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#mainContentCol").width();
        $b324e0f8855d37bf$export$ceb8328249fa3d26.radarChart.resize({
            width: mainContentColWidth,
            height: 500
        });
        function setFAIRError(message) {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairError").text(message);
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairError").addClass("alert-danger");
        }
        function resetFAIRError() {
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairError").text("");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairError").removeClass("alert-danger");
        }
        return $35459c07cd7570af$export$230442c21b56ff1e("https://fair-checker.france-bioinformatique.fr/api/check/metrics_all?url=" + encodeURIComponent(document.location.href)).then((result)=>{
            resetFAIRError();
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairchecker").removeClass("collapse");
            if (Array.isArray(result) && result.length > 0) {
                let F1AScore = result.find((metric)=>metric.metric === "F1A")?.score;
                let F1BScore = result.find((metric)=>metric.metric === "F1B")?.score;
                let F2AScore = result.find((metric)=>metric.metric === "F2A")?.score;
                let F2BScore = result.find((metric)=>metric.metric === "F2B")?.score;
                let A11Score = result.find((metric)=>metric.metric === "A1.1")?.score;
                let A12Score = result.find((metric)=>metric.metric === "A1.2")?.score;
                let I1Score = result.find((metric)=>metric.metric === "I1")?.score;
                let I2Score = result.find((metric)=>metric.metric === "I2")?.score;
                let I3Score = result.find((metric)=>metric.metric === "I3")?.score;
                let R11Score = result.find((metric)=>metric.metric === "R1.1")?.score;
                let R12Score = result.find((metric)=>metric.metric === "R1.2")?.score;
                let R13Score = result.find((metric)=>metric.metric === "R1.3")?.score;
                if ([
                    F1AScore,
                    F1BScore,
                    F2AScore,
                    F2BScore,
                    A11Score,
                    A12Score,
                    I1Score,
                    I2Score,
                    I3Score,
                    R11Score,
                    R12Score,
                    R13Score
                ].some((score)=>score == undefined)) setFAIRError("One of the metrics could not be retrieved from FAIR-checker " + JSON.stringify(result, null, 2));
                else {
                    F1AScore = Number.parseInt(F1AScore);
                    F1BScore = 0; // Number.parseInt(F1BScore); // Stuck at 0 because we are generating URIs for the dataset and identifiers are a bioinformatics oriented metric
                    F2AScore = Number.parseInt(F2AScore);
                    F2BScore = Number.parseInt(F2BScore);
                    A11Score = Number.parseInt(A11Score);
                    A12Score = Number.parseInt(A12Score);
                    I1Score = Number.parseInt(I1Score);
                    I2Score = Number.parseInt(I2Score);
                    I3Score = Number.parseInt(I3Score);
                    R11Score = Number.parseInt(R11Score);
                    R12Score = Number.parseInt(R12Score);
                    R13Score = Number.parseInt(R13Score);
                    let option = {
                        title: {
                            text: "FAIR-Checker evaluation",
                            left: "center"
                        },
                        legend: {
                            show: false
                        },
                        radar: [
                            {
                                axisName: {
                                    show: true
                                },
                                indicator: [
                                    {
                                        name: "Findable",
                                        max: 8
                                    },
                                    {
                                        name: "Accessible",
                                        max: 4
                                    },
                                    {
                                        name: "Interoperable",
                                        max: 6
                                    },
                                    {
                                        name: "Reusable",
                                        max: 6
                                    }
                                ],
                                center: [
                                    "25%",
                                    "50%"
                                ],
                                radius: "50%"
                            },
                            {
                                axisName: {
                                    show: true
                                },
                                indicator: [
                                    {
                                        name: "F1A",
                                        max: 2
                                    },
                                    {
                                        name: "F1B",
                                        max: 2
                                    },
                                    {
                                        name: "F2A",
                                        max: 2
                                    },
                                    {
                                        name: "F2B",
                                        max: 2
                                    }
                                ],
                                center: [
                                    "62%",
                                    "25%"
                                ],
                                radius: "20%"
                            },
                            {
                                axisName: {
                                    show: true
                                },
                                indicator: [
                                    {
                                        name: "A1.1",
                                        max: 2
                                    },
                                    {
                                        name: "",
                                        max: 2
                                    },
                                    {
                                        name: "A1.2",
                                        max: 2
                                    },
                                    {
                                        name: "",
                                        max: 2
                                    }
                                ],
                                center: [
                                    "87%",
                                    "25%"
                                ],
                                radius: "20%"
                            },
                            {
                                axisName: {
                                    show: true
                                },
                                indicator: [
                                    {
                                        name: "I1",
                                        max: 2
                                    },
                                    {
                                        name: "I2",
                                        max: 2
                                    },
                                    {
                                        name: "I3",
                                        max: 2
                                    }
                                ],
                                center: [
                                    "62%",
                                    "75%"
                                ],
                                radius: "20%"
                            },
                            {
                                axisName: {
                                    show: true
                                },
                                indicator: [
                                    {
                                        name: "R1.1",
                                        max: 2
                                    },
                                    {
                                        name: "R1.2",
                                        max: 2
                                    },
                                    {
                                        name: "R1.3",
                                        max: 2
                                    }
                                ],
                                center: [
                                    "87%",
                                    "75%"
                                ],
                                radius: "20%"
                            }
                        ],
                        series: [
                            {
                                name: "FAIRness evaluation",
                                radarIndex: 0,
                                type: "radar",
                                data: [
                                    {
                                        value: [
                                            F1AScore + F1BScore + F2AScore + F2BScore,
                                            A11Score + A12Score,
                                            I1Score + I2Score + I3Score,
                                            R11Score + R12Score + R13Score
                                        ],
                                        name: "Dataset"
                                    }
                                ]
                            },
                            {
                                name: "Findability",
                                radarIndex: 1,
                                type: "radar",
                                data: [
                                    {
                                        value: [
                                            F1AScore,
                                            F1BScore,
                                            F2AScore,
                                            F2BScore
                                        ],
                                        name: "Dataset"
                                    }
                                ]
                            },
                            {
                                name: "Accessibility",
                                radarIndex: 2,
                                type: "radar",
                                data: [
                                    {
                                        value: [
                                            A11Score,
                                            0,
                                            A12Score,
                                            0
                                        ],
                                        name: "Dataset"
                                    }
                                ]
                            },
                            {
                                name: "Interoperability",
                                radarIndex: 3,
                                type: "radar",
                                data: [
                                    {
                                        value: [
                                            I1Score,
                                            I2Score,
                                            I3Score
                                        ],
                                        name: "Dataset"
                                    }
                                ]
                            },
                            {
                                name: "Reusability",
                                radarIndex: 4,
                                type: "radar",
                                data: [
                                    {
                                        value: [
                                            R11Score,
                                            R12Score,
                                            R13Score
                                        ],
                                        name: "Dataset"
                                    }
                                ]
                            }
                        ]
                    };
                    option && $b324e0f8855d37bf$export$ceb8328249fa3d26.radarChart.setOption(option);
                }
            } else setFAIRError("No result returned by FAIR-checker");
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairresult").text(JSON.stringify(result, null, 2));
        }).catch((error)=>{
            setFAIRError("Error while checking the FAIRness of the dataset: " + error);
        });
    }
    changeUrlDescriptionParameter() {
        let currentUrl = new URL(window.location.href);
        $5605c1058d66d37f$export$147c92fc1e54141d(this.store).then((fileContent)=>{
            let description = (0, $ce9a2afe0584bbc0$export$92147089af557b01)(encodeURIComponent(fileContent));
            currentUrl.searchParams.set("description", description);
            window.history.pushState({}, "", currentUrl.href);
        });
    }
    changeProgressBar() {
        let emptyRecommendedCategoryNames = [];
        let totalLines = 0;
        let totalValidLines = 0;
        this.categoryViews.forEach((catView)=>{
            if (catView.coreElement.recommended) {
                totalLines++;
                if (catView.hasValidLines()) totalValidLines++;
                else emptyRecommendedCategoryNames.push(catView.coreElement.categoryTitle);
            }
        });
        let progressBar = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#recommendedProgressBar");
        let progress = totalValidLines / totalLines * 100;
        progressBar.css("width", progress + "%");
        progressBar.attr("aria-valuenow", progress);
        progressBar.text(Math.round(progress) + "%");
        let remark = "";
        if (emptyRecommendedCategoryNames.length > 0) remark = "It is recommended to fill at least the following features: " + emptyRecommendedCategoryNames.join(", ");
        else if (progress == 100) remark = `The recommended features are all filled.<br/> Do not hesitate to evaluate the FAIRness of your dataset using one of the tools listed at <a target="_blank" rel="noopener noreferrer" href='https://fairassist.org/#!/'>FAIRassist</a>.`;
        (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#recommendedRemark").html(remark);
    }
    importData(data, dataFormat) {
        let parsingfunction = undefined;
        switch(dataFormat){
            case "jsonld":
                parsingfunction = $5605c1058d66d37f$export$6725074973fc00d;
                break;
            case "nquads":
                parsingfunction = $5605c1058d66d37f$export$1843c9c1bbbb33a;
                break;
            case "rdf":
                parsingfunction = $5605c1058d66d37f$export$4e369e5d821beb3f;
                break;
            case "ntriples":
                parsingfunction = $5605c1058d66d37f$export$3f751611e1c07e11;
                break;
            case "n3":
                parsingfunction = $5605c1058d66d37f$export$c5a866906ae935ba;
                break;
            case "turtle":
            default:
                parsingfunction = $5605c1058d66d37f$export$968deea481412d5d;
                break;
        }
        if (data !== undefined && data !== null && data !== "") {
            let parsedStore = $5605c1058d66d37f$export$f51a9068ac82ea43();
            return parsingfunction(data, parsedStore).then((store)=>{
                return $0f8b792ecec97e77$export$f7fc8ccdbb5a3a2c("https://raw.githubusercontent.com/Wimmics/voidmatic/master/data/equivalences.ttl").then((equivalences)=>{
                    return $0f8b792ecec97e77$export$51716a511b9a85d1(equivalences, store);
                }).then((equivalences)=>{
                    store.addAll(equivalences);
                    return store;
                });
            }).then((store)=>{
                function loadCategroyViewValues(catView, store) {
                    let newLinesValues = [];
                    catView.coreElement.fields.forEach((line)=>{
                        newLinesValues = newLinesValues.concat(line.dataLoadFunction(store));
                    });
                    newLinesValues.forEach((newValue)=>{
                        catView.addLine(newValue);
                    });
                    catView.subCategoryViews.forEach((subCatView)=>{
                        loadCategroyViewValues(subCatView, store);
                    });
                }
                function cleanCategory(catView) {
                    let lineToBeRemoved = [];
                    catView.lines.forEach((line, lineId)=>{
                        if (!(0, $1dd5f29d6665a182$export$f91d67ddd1e8123a).isValid(line.validationState)) lineToBeRemoved.push(lineId);
                    });
                    lineToBeRemoved.forEach((lineId)=>{
                        catView.removeLine(lineId);
                    });
                    catView.subCategoryViews.forEach((subCatView)=>{
                        cleanCategory(subCatView);
                    });
                }
                this.categoryViews.forEach((catView)=>{
                    cleanCategory(catView);
                    loadCategroyViewValues(catView, store);
                });
            });
        } else return Promise.resolve();
    }
    standardizeEndpointURL(endpointURL) {
        if (this.forceHTTPSFlag) return endpointURL.replace("http://", "https://");
        else return endpointURL;
    }
    generateEquivalenceTriples() {
        return this.generateEquivalenceTriplesFromStore(this.store);
    }
    /**
     * Generates triples in known vocabularies according to IndeGx equivalences.
     * TODO: Make it using SPARQL or defined in each field.
     */ generateEquivalenceTriplesFromStore(store) {
        return $0f8b792ecec97e77$export$f7fc8ccdbb5a3a2c("https://raw.githubusercontent.com/Wimmics/voidmatic/master/data/equivalences.ttl").then((equivalences)=>{
            return $0f8b792ecec97e77$export$51716a511b9a85d1(equivalences, store);
        });
    }
    listNodesStore(s, p, o) {
        return this.store.each(s, p, o);
    }
    addStatement(statement) {
        this.addAllStatements([
            statement
        ]);
    }
    addAllStatements(statements) {
        this.store.add(statements);
        this.refreshStore();
    }
    removeStatement(statement) {
        if (this.store.holdsStatement(statement)) {
            this.store.remove(statement);
            this.refreshStore();
        }
    }
    removeAllStatements(statements) {
        statements.forEach((statement)=>{
            if (this.store.holdsStatement(statement)) this.store.remove(statement);
            this.refreshStore();
        });
    }
    setDisplay(str) {
        this.contentDisplay.text(str);
    }
    containsStatement(statement) {
        return this.store.holdsStatement(statement);
    }
    /**
     * Add the category views to the page and add the listeners
     */ initCategoryViews() {
        var dataCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#dataCol");
        var navCol = (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#navCol");
        (0, $1aafcae990228224$export$4cacfc59564927f2).forEach((catMetadata)=>{
            var catMetadataView = new (0, $0fad04dc9d895ec5$export$47ada3610a077e)({
                category: catMetadata
            });
            this.categoryViews.push(catMetadataView);
            const categoryJquery = catMetadataView.render();
            dataCol.append(categoryJquery);
            navCol.append(catMetadataView.navItem);
            this.metadataCategoryViewMap.set(catMetadata.idPrefix, catMetadataView);
            catMetadataView.on("add", (statements, source)=>{
                this.addAllStatements(statements);
                if (catMetadataView.coreElement.idPrefix === "endpoint") this.sendMetadatatoServer();
            });
            catMetadataView.on("remove", (statements, source)=>{
                this.removeAllStatements(statements);
            });
            catMetadataView.on("error", (message, source)=>{
                console.error(message);
            });
            catMetadataView.on("change", (source)=>{
                dataCol.empty();
                navCol.empty();
                catMetadataView.refresh();
            });
        });
        navCol.append((0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(`<div class="navbar-item"><a class="navbar-link btn" href="#displayTextArea">Description of the dataset</a></div>`));
    }
    refreshCategories() {
        this.categoryViews.forEach((categoryView)=>{
            categoryView.refresh();
        });
    }
    refreshStore() {
        this.changeProgressBar();
        $5605c1058d66d37f$export$147c92fc1e54141d(this.store).then((str)=>{
            $b324e0f8855d37bf$export$ceb8328249fa3d26.setDisplay(str);
            this.changeUrlDescriptionParameter();
        });
        $5605c1058d66d37f$export$93c0abeba0b5b50d(this.store).then((str)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))("#fairJson").html(str);
        });
    }
    clearAll() {
        console.log("Clearing all");
        this.removeAllStatements(this.store.statementsMatching(null, null, null));
        this.categoryViews.forEach((categoryView)=>{
            categoryView.clear();
        });
        this.refreshStore();
    }
    sendMetadatatoServer() {
    // console.log("shareEndpointURL: ", this.shareEndpointURL);
    // if (this.store.holds(null, RDFUtils.VOID("sparqlEndpoint"), null) && this.shareEndpointURL) {
    //     console.log("Sending metadata to server");
    //     let str = "";
    //     this.store.statementsMatching(null, RDFUtils.VOID("sparqlEndpoint"), null).forEach(statement => {
    //         str += statement.toNT() + " ";
    //     })
    //     const finalUrl = "https://prod-dekalog.inria.fr/description?uuid=" + this.sessionId + "&description=" + encodeURIComponent(str.replaceAll("\n", " "));
    //     return Query.fetchJSONPromise(finalUrl).catch(error => { })
    // }
    }
}


(0, (/*@__PURE__*/$parcel$interopDefault($4eae0a726ab50395$exports)))(()=>{
    new (0, $b324e0f8855d37bf$export$7a7fa4424cb20976)();
});


//# sourceMappingURL=index.f28799d5.js.map
